
      var $parcel$global = globalThis;
    
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire141c"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire141c"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("f1q41", function(module, exports) {
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = '4.17.21';
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.', FUNC_ERROR_TEXT = 'Expected a function', INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = '__lodash_placeholder__';
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = '...';
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            'ary',
            WRAP_ARY_FLAG
        ],
        [
            'bind',
            WRAP_BIND_FLAG
        ],
        [
            'bindKey',
            WRAP_BIND_KEY_FLAG
        ],
        [
            'curry',
            WRAP_CURRY_FLAG
        ],
        [
            'curryRight',
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            'flip',
            WRAP_FLIP_FLAG
        ],
        [
            'partial',
            WRAP_PARTIAL_FLAG
        ],
        [
            'partialRight',
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            'rearg',
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', domExcTag = '[object DOMException]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]', weakSetTag = '[object WeakSet]';
    var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = '\\u2700-\\u27bf', rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', rsPunctuationRange = '\\u2000-\\u206f', rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', rsVarRange = '\\ufe0e\\ufe0f', rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = '[' + rsAstralRange + ']', rsBreak = '[' + rsBreakRange + ']', rsCombo = '[' + rsComboRange + ']', rsDigits = '\\d+', rsDingbat = '[' + rsDingbatRange + ']', rsLower = '[' + rsLowerRange + ']', rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']', rsFitz = '\\ud83c[\\udffb-\\udfff]', rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')', rsNonAstral = '[^' + rsAstralRange + ']', rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsUpper = '[' + rsUpperRange + ']', rsZWJ = '\\u200d';
    /** Used to compose unicode regexes. */ var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')', rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')', rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?', rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?', reOptMod = rsModifier + '?', rsOptVar = '[' + rsVarRange + ']?', rsOptJoin = '(?:' + rsZWJ + '(?:' + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsOptVar + reOptMod + ')*', rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = '(?:' + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsSeq, rsSymbol = '(?:' + [
        rsNonAstral + rsCombo + '?',
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join('|') + ')';
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, 'g');
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, 'g');
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [
            rsBreak,
            rsUpper,
            '$'
        ].join('|') + ')',
        rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [
            rsBreak,
            rsUpper + rsMiscLower,
            '$'
        ].join('|') + ')',
        rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
        rsUpper + '+' + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join('|'), 'g');
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        'Array',
        'Buffer',
        'DataView',
        'Date',
        'Error',
        'Float32Array',
        'Float64Array',
        'Function',
        'Int8Array',
        'Int16Array',
        'Int32Array',
        'Map',
        'Math',
        'Object',
        'Promise',
        'RegExp',
        'Set',
        'String',
        'Symbol',
        'TypeError',
        'Uint8Array',
        'Uint8ClampedArray',
        'Uint16Array',
        'Uint32Array',
        'WeakMap',
        '_',
        'clearTimeout',
        'isFinite',
        'parseInt',
        'setTimeout'
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        '\xc0': 'A',
        '\xc1': 'A',
        '\xc2': 'A',
        '\xc3': 'A',
        '\xc4': 'A',
        '\xc5': 'A',
        '\xe0': 'a',
        '\xe1': 'a',
        '\xe2': 'a',
        '\xe3': 'a',
        '\xe4': 'a',
        '\xe5': 'a',
        '\xc7': 'C',
        '\xe7': 'c',
        '\xd0': 'D',
        '\xf0': 'd',
        '\xc8': 'E',
        '\xc9': 'E',
        '\xca': 'E',
        '\xcb': 'E',
        '\xe8': 'e',
        '\xe9': 'e',
        '\xea': 'e',
        '\xeb': 'e',
        '\xcc': 'I',
        '\xcd': 'I',
        '\xce': 'I',
        '\xcf': 'I',
        '\xec': 'i',
        '\xed': 'i',
        '\xee': 'i',
        '\xef': 'i',
        '\xd1': 'N',
        '\xf1': 'n',
        '\xd2': 'O',
        '\xd3': 'O',
        '\xd4': 'O',
        '\xd5': 'O',
        '\xd6': 'O',
        '\xd8': 'O',
        '\xf2': 'o',
        '\xf3': 'o',
        '\xf4': 'o',
        '\xf5': 'o',
        '\xf6': 'o',
        '\xf8': 'o',
        '\xd9': 'U',
        '\xda': 'U',
        '\xdb': 'U',
        '\xdc': 'U',
        '\xf9': 'u',
        '\xfa': 'u',
        '\xfb': 'u',
        '\xfc': 'u',
        '\xdd': 'Y',
        '\xfd': 'y',
        '\xff': 'y',
        '\xc6': 'Ae',
        '\xe6': 'ae',
        '\xde': 'Th',
        '\xfe': 'th',
        '\xdf': 'ss',
        // Latin Extended-A block.
        '\u0100': 'A',
        '\u0102': 'A',
        '\u0104': 'A',
        '\u0101': 'a',
        '\u0103': 'a',
        '\u0105': 'a',
        '\u0106': 'C',
        '\u0108': 'C',
        '\u010a': 'C',
        '\u010c': 'C',
        '\u0107': 'c',
        '\u0109': 'c',
        '\u010b': 'c',
        '\u010d': 'c',
        '\u010e': 'D',
        '\u0110': 'D',
        '\u010f': 'd',
        '\u0111': 'd',
        '\u0112': 'E',
        '\u0114': 'E',
        '\u0116': 'E',
        '\u0118': 'E',
        '\u011a': 'E',
        '\u0113': 'e',
        '\u0115': 'e',
        '\u0117': 'e',
        '\u0119': 'e',
        '\u011b': 'e',
        '\u011c': 'G',
        '\u011e': 'G',
        '\u0120': 'G',
        '\u0122': 'G',
        '\u011d': 'g',
        '\u011f': 'g',
        '\u0121': 'g',
        '\u0123': 'g',
        '\u0124': 'H',
        '\u0126': 'H',
        '\u0125': 'h',
        '\u0127': 'h',
        '\u0128': 'I',
        '\u012a': 'I',
        '\u012c': 'I',
        '\u012e': 'I',
        '\u0130': 'I',
        '\u0129': 'i',
        '\u012b': 'i',
        '\u012d': 'i',
        '\u012f': 'i',
        '\u0131': 'i',
        '\u0134': 'J',
        '\u0135': 'j',
        '\u0136': 'K',
        '\u0137': 'k',
        '\u0138': 'k',
        '\u0139': 'L',
        '\u013b': 'L',
        '\u013d': 'L',
        '\u013f': 'L',
        '\u0141': 'L',
        '\u013a': 'l',
        '\u013c': 'l',
        '\u013e': 'l',
        '\u0140': 'l',
        '\u0142': 'l',
        '\u0143': 'N',
        '\u0145': 'N',
        '\u0147': 'N',
        '\u014a': 'N',
        '\u0144': 'n',
        '\u0146': 'n',
        '\u0148': 'n',
        '\u014b': 'n',
        '\u014c': 'O',
        '\u014e': 'O',
        '\u0150': 'O',
        '\u014d': 'o',
        '\u014f': 'o',
        '\u0151': 'o',
        '\u0154': 'R',
        '\u0156': 'R',
        '\u0158': 'R',
        '\u0155': 'r',
        '\u0157': 'r',
        '\u0159': 'r',
        '\u015a': 'S',
        '\u015c': 'S',
        '\u015e': 'S',
        '\u0160': 'S',
        '\u015b': 's',
        '\u015d': 's',
        '\u015f': 's',
        '\u0161': 's',
        '\u0162': 'T',
        '\u0164': 'T',
        '\u0166': 'T',
        '\u0163': 't',
        '\u0165': 't',
        '\u0167': 't',
        '\u0168': 'U',
        '\u016a': 'U',
        '\u016c': 'U',
        '\u016e': 'U',
        '\u0170': 'U',
        '\u0172': 'U',
        '\u0169': 'u',
        '\u016b': 'u',
        '\u016d': 'u',
        '\u016f': 'u',
        '\u0171': 'u',
        '\u0173': 'u',
        '\u0174': 'W',
        '\u0175': 'w',
        '\u0176': 'Y',
        '\u0177': 'y',
        '\u0178': 'Y',
        '\u0179': 'Z',
        '\u017b': 'Z',
        '\u017d': 'Z',
        '\u017a': 'z',
        '\u017c': 'z',
        '\u017e': 'z',
        '\u0132': 'IJ',
        '\u0133': 'ij',
        '\u0152': 'Oe',
        '\u0153': 'oe',
        '\u0149': "'n",
        '\u017f': 's'
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#39;': "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        '\\': '\\',
        "'": "'",
        '\n': 'n',
        '\r': 'r',
        '\u2028': 'u2028',
        '\u2029': 'u2029'
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require('util').types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding('util');
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty('length');
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split('');
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return '\\' + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context['__core-js_shared__'];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
            return uid ? 'Symbol(src)_1.' + uid : '';
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, 'defineProperty');
                func({}, '', {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, 'DataView'), Map = getNative(context, 'Map'), Promise = getNative(context, 'Promise'), Set = getNative(context, 'Set'), WeakMap = getNative(context, 'WeakMap'), nativeCreate = getNative(Object1, 'create');
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, '__wrapped__')) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'escape': reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'evaluate': reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'interpolate': reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ 'variable': '',
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ 'imports': {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ '_': lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype['delete'] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype['delete'] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                'hash': new Hash,
                'map': new (Map || ListCache),
                'string': new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)['delete'](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype['delete'] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data['delete'](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype['delete'] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == '__proto__' && defineProperty) defineProperty(object, key, {
                'configurable': true,
                'enumerable': true,
                'value': value,
                'writable': true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == 'function') return value;
            if (value == null) return identity;
            if (typeof value == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack['delete'](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    'criteria': criteria,
                    'index': ++index,
                    'value': value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = '';
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + '');
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, 'toString', {
                'configurable': true,
                'enumerable': false,
                'value': constant(string),
                'writable': true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == 'string') return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + '';
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == 'function' ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == 'desc' ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == 'wrapper') var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == 'wrapper' ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == 'string' || typeof other == 'string') {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? ' ' : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join('') : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != 'number' && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == 'string' && typeof other == 'string')) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + 'e').split('e'), value = func(pair[0] + 'e' + (+pair[1] + precision));
                    pair = (toString(value) + 'e').split('e');
                    return +(pair[0] + 'e' + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack['delete'](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack['delete'](array);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + '';
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack['delete'](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == 'constructor');
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
            }
            stack['delete'](object);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + '');
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + '', array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case 'drop':
                        start += size;
                        break;
                    case 'dropRight':
                        end -= size;
                        break;
                    case 'take':
                        end = nativeMin(end, start + size);
                        break;
                    case 'takeRight':
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                'start': start,
                'end': end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
            details = details.join(length > 2 ? ', ' : ' ');
            return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === 'constructor' && typeof object[key] === 'function') return;
            if (key == '__proto__') return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + '';
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == 'string' || isSymbol(value)) return value;
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + '';
                } catch (e) {}
            }
            return '';
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = '_.' + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? '' : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                'func': thru,
                'args': [
                    interceptor
                ],
                'thisArg': undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                'done': done,
                'value': value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    'func': thru,
                    'args': [
                        reverse
                    ],
                    'thisArg': undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == 'function', result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = 'maxWait' in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = 'leading' in options ? !!options.leading : leading;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                'leading': leading,
                'maxWait': wait,
                'trailing': trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == 'number' && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == 'number' && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == 'object' || type == 'function');
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == 'object';
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
            return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
                value = isObject(other) ? other + '' : other;
            }
            if (typeof value != 'string') return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? '' : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == 'boolean') {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == 'boolean') {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? '-' : '') + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst('toLowerCase');
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? '_' : '') + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == 'string' || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = '//# sourceURL=' + (hasOwnProperty.call(options, 'sourceURL') ? (options.sourceURL + '').replace(/\s/g, ' ') : 'lodash.templateSources[' + ++templateCounter + ']') + '\n';
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, 'variable') && options.variable;
            if (!variable) source = 'with (obj) {\n' + source + '\n}\n';
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');
            // Frame code as the function body.
            source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join('');
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join('');
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, '');
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join('');
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = 'separator' in options ? options.separator : separator;
                length = 'length' in options ? toInteger(options.length) : length;
                omission = 'omission' in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join('') : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + 'g');
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst('toUpperCase');
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && 'chain' in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            'func': func,
                            'args': arguments,
                            'thisArg': object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return '';
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound('ceil');
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound('floor');
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound('round');
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            'chain': false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            'bind',
            'bindKey',
            'curry',
            'curryRight',
            'partial',
            'partialRight'
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            'drop',
            'take'
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    'size': nativeMin(n, MAX_ARRAY_LENGTH),
                    'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
                });
                return result;
            };
            LazyWrapper.prototype[methodName + 'Right'] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            'filter',
            'map',
            'takeWhile'
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    'iteratee': getIteratee(iteratee, 3),
                    'type': type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            'head',
            'last'
        ], function(methodName, index) {
            var takeName = 'take' + (index ? 'Right' : '');
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            'initial',
            'tail'
        ], function(methodName, index) {
            var dropName = 'drop' + (index ? '' : 'Right');
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == 'function') return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? 'take' + (methodName == 'last' ? 'Right' : '') : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        'func': thru,
                        'args': [
                            interceptor
                        ],
                        'thisArg': undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            'pop',
            'push',
            'shift',
            'sort',
            'splice',
            'unshift'
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru', retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + '';
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    'name': methodName,
                    'func': lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                'name': 'wrapper',
                'func': undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRegister("45fvw", function(module, exports) {
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    'use strict';
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, 'toString')) a.toString = b.toString;
        if (hasOwnProp(b, 'valueOf')) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        var flags = null, parsedParts = false, isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            });
            isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
        else return isNowValid;
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) console.warn('Deprecation warning: ' + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ': ' + arguments[0][key] + ', ';
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== 'undefined' && input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this['_' + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + '|' + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L'
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? '+' : '' : '-') + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, '');
        return input.replace(/\\/g, '');
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = '', i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A'
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === 'MMMM' || tok === 'MM' || tok === 'DD' || tok === 'dddd') return tok.slice(1);
            return tok;
        }).join('');
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = 'Invalid date';
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = '%d', defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }
    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years'
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {
        D: 'date',
        dates: 'date',
        date: 'date',
        d: 'day',
        days: 'day',
        day: 'day',
        e: 'weekday',
        weekdays: 'weekday',
        weekday: 'weekday',
        E: 'isoWeekday',
        isoweekdays: 'isoWeekday',
        isoweekday: 'isoWeekday',
        DDD: 'dayOfYear',
        dayofyears: 'dayOfYear',
        dayofyear: 'dayOfYear',
        h: 'hour',
        hours: 'hour',
        hour: 'hour',
        ms: 'millisecond',
        milliseconds: 'millisecond',
        millisecond: 'millisecond',
        m: 'minute',
        minutes: 'minute',
        minute: 'minute',
        M: 'month',
        months: 'month',
        month: 'month',
        Q: 'quarter',
        quarters: 'quarter',
        quarter: 'quarter',
        s: 'second',
        seconds: 'second',
        second: 'second',
        gg: 'weekYear',
        weekyears: 'weekYear',
        weekyear: 'weekYear',
        GG: 'isoWeekYear',
        isoweekyears: 'isoWeekYear',
        isoweekyear: 'isoWeekYear',
        w: 'week',
        weeks: 'week',
        week: 'week',
        W: 'isoWeek',
        isoweeks: 'isoWeek',
        isoweek: 'isoWeek',
        y: 'year',
        years: 'year',
        year: 'year'
    };
    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1
    };
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === 'string') token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    // FORMATTING
    addFormatToken('Y', 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });
    addFormatToken(0, [
        'YY',
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        'YYYY',
        4
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYY',
        5
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYYY',
        6,
        true
    ], 0, 'year');
    // PARSING
    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);
    addParseToken([
        'YYYYY',
        'YYYYYY'
    ], YEAR);
    addParseToken('YYYY', function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet('FullYear', true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        if (!mom.isValid()) return NaN;
        var d = mom._d, isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case 'Seconds':
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case 'Minutes':
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case 'Hours':
                return isUTC ? d.getUTCHours() : d.getHours();
            case 'Date':
                return isUTC ? d.getUTCDate() : d.getDate();
            case 'Day':
                return isUTC ? d.getUTCDay() : d.getDay();
            case 'Month':
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case 'FullYear':
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }
    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;
        if (!mom.isValid() || isNaN(value)) return;
        d = mom._d;
        isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return void (isUTC ? d.setUTCMilliseconds(value) : d.setMilliseconds(value));
            case 'Seconds':
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case 'Minutes':
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case 'Hours':
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case 'Date':
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case 'FullYear':
                break; // See below ...
            default:
                return; // Just in case
        }
        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        isUTC ? d.setUTCFullYear(year, month, date) : d.setFullYear(year, month, date);
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken('M', [
        'MM',
        2
    ], 'Mo', function() {
        return this.month() + 1;
    });
    addFormatToken('MMM', 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken('MMMM', 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // PARSING
    addRegexToken('M', match1to2, match1to2NoLeadingZero);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        'M',
        'MM'
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        'MMM',
        'MMMM'
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'), defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months['standalone'];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort['standalone'];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        var month = value, date = mom.date();
        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, 'Month');
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom, shortP, longP;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortP = regexEscape(this.monthsShort(mom, ''));
            longP = regexEscape(this.months(mom, ''));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken('w', [
        'ww',
        2
    ], 'wo', 'week');
    addFormatToken('W', [
        'WW',
        2
    ], 'Wo', 'isoWeek');
    // PARSING
    addRegexToken('w', match1to2, match1to2NoLeadingZero);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2, match1to2NoLeadingZero);
    addRegexToken('WW', match1to2, match2);
    addWeekParseToken([
        'w',
        'ww',
        'W',
        'WW'
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    // FORMATTING
    addFormatToken('d', 0, 'do', 'day');
    addFormatToken('dd', 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken('ddd', 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken('dddd', 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');
    // PARSING
    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        'dd',
        'ddd',
        'dddd'
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        'd',
        'e',
        'E'
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== 'string') return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === 'number') return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'), defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'), defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? 'format' : 'standalone'];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = get(this, 'Day');
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken('H', [
        'HH',
        2
    ], 0, 'hour');
    addFormatToken('h', [
        'hh',
        2
    ], 0, hFormat);
    addFormatToken('k', [
        'kk',
        2
    ], 0, kFormat);
    addFormatToken('hmm', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken('hmmss', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken('Hmm', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken('Hmmss', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem('a', true);
    meridiem('A', false);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2, match1to2HasZero);
    addRegexToken('h', match1to2, match1to2NoLeadingZero);
    addRegexToken('k', match1to2, match1to2NoLeadingZero);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);
    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);
    addParseToken([
        'H',
        'HH'
    ], HOUR);
    addParseToken([
        'k',
        'kk'
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        'a',
        'A'
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        'h',
        'hh'
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet('Hours', true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? 'pm' : 'PM';
        else return isLower ? 'am' : 'AM';
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match('^[^/\\\\]*$'));
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire('./locale/' + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== 'undefined' && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn('Locale ' + key + ' not found. Did you forget to load it?');
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride', "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            'YYYYYY-MM-DD',
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            'YYYY-MM-DD',
            /\d{4}-\d\d-\d\d/
        ],
        [
            'GGGG-[W]WW-E',
            /\d{4}-W\d\d-\d/
        ],
        [
            'GGGG-[W]WW',
            /\d{4}-W\d\d/,
            false
        ],
        [
            'YYYY-DDD',
            /\d{4}-\d{3}/
        ],
        [
            'YYYY-MM',
            /\d{4}-\d\d/,
            false
        ],
        [
            'YYYYYYMMDD',
            /[+-]\d{10}/
        ],
        [
            'YYYYMMDD',
            /\d{8}/
        ],
        [
            'GGGG[W]WWE',
            /\d{4}W\d{3}/
        ],
        [
            'GGGG[W]WW',
            /\d{4}W\d{2}/,
            false
        ],
        [
            'YYYYDDD',
            /\d{7}/
        ],
        [
            'YYYYMM',
            /\d{6}/,
            false
        ],
        [
            'YYYY',
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            'HH:mm:ss.SSSS',
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            'HH:mm:ss,SSSS',
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            'HH:mm:ss',
            /\d\d:\d\d:\d\d/
        ],
        [
            'HH:mm',
            /\d\d:\d\d/
        ],
        [
            'HHmmss.SSSS',
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            'HHmmss,SSSS',
            /\d\d\d\d\d\d,\d+/
        ],
        [
            'HHmmss',
            /\d\d\d\d\d\d/
        ],
        [
            'HHmm',
            /\d\d\d\d/
        ],
        [
            'HH',
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = 'Z';
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === '') return createInvalid({
            nullInput: true
        });
        if (typeof input === 'string') config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === 'string') configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate('moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate('moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isBefore', args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isAfter', args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond'
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset('Z', ':');
    offset('ZZ', '');
    // PARSING
    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken([
        'Z',
        'ZZ'
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || [
            '-',
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, 'm');
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), 'm');
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, '_locale')) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, '_isValid')) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, 'M');
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' + 'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, 'Month') + months * isAdding);
        if (days) set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, 'add'), subtract = createAdder(-1, 'subtract');
    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'years',
            'year',
            'y',
            'months',
            'month',
            'M',
            'days',
            'day',
            'd',
            'dates',
            'date',
            'D',
            'hours',
            'hour',
            'h',
            'minutes',
            'minute',
            'm',
            'seconds',
            'second',
            's',
            'milliseconds',
            'millisecond',
            'ms'
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'sameDay',
            'nextDay',
            'lastDay',
            'nextWeek',
            'lastWeek',
            'sameElse'
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' : diff < -1 ? 'lastWeek' : diff < 0 ? 'lastDay' : diff < 1 ? 'sameDay' : diff < 2 ? 'nextDay' : diff < 7 ? 'nextWeek' : 'sameElse';
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf('day'), format = hooks.calendarFormat(this, sod) || 'sameElse', output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace('Z', formatMoment(m, 'Z'));
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return 'moment.invalid(/* ' + this._i + ' */)';
        var func = 'moment', zone = '', prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
    addFormatToken('y', [
        'y',
        1
    ], 'yo', 'eraYear');
    addFormatToken('y', [
        'yy',
        2
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyy',
        3
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyyy',
        4
    ], 0, 'eraYear');
    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);
    addParseToken([
        'N',
        'NN',
        'NNN',
        'NNNN',
        'NNNNN'
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);
    addParseToken([
        'y',
        'yy',
        'yyy',
        'yyyy'
    ], YEAR);
    addParseToken([
        'yo'
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale('en')._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case 'undefined':
                    eras[i].until = Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case 'N':
                case 'NN':
                case 'NNN':
                    if (abbr === eraName) return eras[i];
                    break;
                case 'NNNN':
                    if (name === eraName) return eras[i];
                    break;
                case 'NNNNN':
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return '';
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return '';
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return '';
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, erasName, erasAbbr, erasNarrow, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);
            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }
        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp('^(' + narrowPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    addFormatToken(0, [
        'gg',
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        'GG',
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
    // ALIASES
    // PARSING
    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);
    addWeekParseToken([
        'gggg',
        'ggggg',
        'GGGG',
        'GGGGG'
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        'gg',
        'GG'
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday() + this.localeData()._week.dow, this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken('Q', 0, 'Qo', 'quarter');
    // PARSING
    addRegexToken('Q', match1);
    addParseToken('Q', function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken('D', [
        'DD',
        2
    ], 'Do', 'date');
    // PARSING
    addRegexToken('D', match1to2, match1to2NoLeadingZero);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        'D',
        'DD'
    ], DATE);
    addParseToken('Do', function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet('Date', true);
    // FORMATTING
    addFormatToken('DDD', [
        'DDDD',
        3
    ], 'DDDo', 'dayOfYear');
    // PARSING
    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken([
        'DDD',
        'DDDD'
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }
    // FORMATTING
    addFormatToken('m', [
        'mm',
        2
    ], 0, 'minute');
    // PARSING
    addRegexToken('m', match1to2, match1to2HasZero);
    addRegexToken('mm', match1to2, match2);
    addParseToken([
        'm',
        'mm'
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet('Minutes', false);
    // FORMATTING
    addFormatToken('s', [
        'ss',
        2
    ], 0, 'second');
    // PARSING
    addRegexToken('s', match1to2, match1to2HasZero);
    addRegexToken('ss', match1to2, match2);
    addParseToken([
        's',
        'ss'
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet('Seconds', false);
    // FORMATTING
    addFormatToken('S', 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        'SS',
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        'SSS',
        3
    ], 0, 'millisecond');
    addFormatToken(0, [
        'SSSS',
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        'SSSSS',
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        'SSSSSS',
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        'SSSSSSS',
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        'SSSSSSSS',
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        'SSSSSSSSS',
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // PARSING
    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);
    var token, getSetMillisecond;
    for(token = 'SSSS'; token.length <= 9; token += 'S')addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }
    for(token = 'S'; token.length <= 9; token += 'S')addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet('Milliseconds', false);
    // FORMATTING
    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }
    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) proto[Symbol.for('nodejs.util.inspect.custom')] = function() {
        return 'Moment<' + this.format() + '>';
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || '';
        if (index != null) return get$1(format, index, field, 'month');
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, 'month');
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, 'day');
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, 'day');
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }
    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD'
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC'
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs('ms'), asSeconds = makeAs('s'), asMinutes = makeAs('m'), asHours = makeAs('h'), asDays = makeAs('d'), asWeeks = makeAs('w'), asMonths = makeAs('M'), asQuarters = makeAs('Q'), asYears = makeAs('y'), valueOf$1 = asMilliseconds;
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter('milliseconds'), seconds = makeGetter('seconds'), minutes = makeGetter('minutes'), hours = makeGetter('hours'), days = makeGetter('days'), months = makeGetter('months'), years = makeGetter('years');
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as('s')), minutes = round(duration.as('m')), hours = round(duration.as('h')), days = round(duration.as('d')), months = round(duration.as('M')), weeks = round(duration.as('w')), years = round(duration.as('y')), a = seconds <= thresholds.ss && [
            's',
            seconds
        ] || seconds < thresholds.s && [
            'ss',
            seconds
        ] || minutes <= 1 && [
            'm'
        ] || minutes < thresholds.m && [
            'mm',
            minutes
        ] || hours <= 1 && [
            'h'
        ] || hours < thresholds.h && [
            'hh',
            hours
        ] || days <= 1 && [
            'd'
        ] || days < thresholds.d && [
            'dd',
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            'w'
        ] || weeks < thresholds.w && [
            'ww',
            weeks
        ];
        a = a || months <= 1 && [
            'M'
        ] || months < thresholds.M && [
            'MM',
            months
        ] || years <= 1 && [
            'y'
        ] || [
            'yy',
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === 's') thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') withSuffix = argWithSuffix;
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
        return totalSign + 'P' + (years ? ymSign + years + 'Y' : '') + (months ? ymSign + months + 'M' : '') + (days ? daysSign + days + 'D' : '') + (hours || minutes || seconds ? 'T' : '') + (hours ? hmsSign + hours + 'H' : '') + (minutes ? hmsSign + minutes + 'M' : '') + (seconds ? hmsSign + s + 'S' : '');
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');
    // PARSING
    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = '2.30.1';
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',
        DATE: 'YYYY-MM-DD',
        TIME: 'HH:mm',
        TIME_SECONDS: 'HH:mm:ss',
        TIME_MS: 'HH:mm:ss.SSS',
        WEEK: 'GGGG-[W]WW',
        MONTH: 'YYYY-MM'
    };
    return hooks;
});

});

parcelRegister("9zr9G", function(module, exports) {

$parcel$export(module.exports, "init", () => init);
$parcel$export(module.exports, "forward", () => forward);
$parcel$export(module.exports, "inverse", () => inverse);
$parcel$export(module.exports, "names", () => names);
$parcel$export(module.exports, "default", () => $6f7c72613b8aa92a$export$2e2bcd8739ae039);
// Heavily based on this etmerc projection implementation
// https://github.com/mbloch/mapshaper-proj/blob/master/src/projections/etmerc.js

var $9t3dO = parcelRequire("9t3dO");

var $zBlxr = parcelRequire("zBlxr");

var $jU5gu = parcelRequire("jU5gu");

var $cVtoA = parcelRequire("cVtoA");

var $klaWo = parcelRequire("klaWo");

var $k0stT = parcelRequire("k0stT");

var $iKZ74 = parcelRequire("iKZ74");

var $a9oRf = parcelRequire("a9oRf");
function init() {
    if (!this.approx && (isNaN(this.es) || this.es <= 0)) throw new Error('Incorrect elliptical usage. Try using the +approx option in the proj string, or PROJECTION["Fast_Transverse_Mercator"] in the WKT.');
    if (this.approx) {
        // When '+approx' is set, use tmerc instead
        (0, $9t3dO.default).init.apply(this);
        this.forward = (0, $9t3dO.default).forward;
        this.inverse = (0, $9t3dO.default).inverse;
    }
    this.x0 = this.x0 !== undefined ? this.x0 : 0;
    this.y0 = this.y0 !== undefined ? this.y0 : 0;
    this.long0 = this.long0 !== undefined ? this.long0 : 0;
    this.lat0 = this.lat0 !== undefined ? this.lat0 : 0;
    this.cgb = [];
    this.cbg = [];
    this.utg = [];
    this.gtu = [];
    var f = this.es / (1 + Math.sqrt(1 - this.es));
    var n = f / (2 - f);
    var np = n;
    this.cgb[0] = n * (2 + n * (-2 / 3 + n * (-2 + n * (116 / 45 + n * (26 / 45 + n * (-2854 / 675))))));
    this.cbg[0] = n * (-2 + n * (2 / 3 + n * (4 / 3 + n * (-82 / 45 + n * (32 / 45 + n * (4642 / 4725))))));
    np = np * n;
    this.cgb[1] = np * (7 / 3 + n * (-1.6 + n * (-227 / 45 + n * (2704 / 315 + n * (2323 / 945)))));
    this.cbg[1] = np * (5 / 3 + n * (-16 / 15 + n * (-13 / 9 + n * (904 / 315 + n * (-1522 / 945)))));
    np = np * n;
    this.cgb[2] = np * (56 / 15 + n * (-136 / 35 + n * (-1262 / 105 + n * (73814 / 2835))));
    this.cbg[2] = np * (-26 / 15 + n * (34 / 21 + n * (1.6 + n * (-12686 / 2835))));
    np = np * n;
    this.cgb[3] = np * (4279 / 630 + n * (-332 / 35 + n * (-399572 / 14175)));
    this.cbg[3] = np * (1237 / 630 + n * (-2.4 + n * (-24832 / 14175)));
    np = np * n;
    this.cgb[4] = np * (4174 / 315 + n * (-144838 / 6237));
    this.cbg[4] = np * (-734 / 315 + n * (109598 / 31185));
    np = np * n;
    this.cgb[5] = np * (601676 / 22275);
    this.cbg[5] = np * (444337 / 155925);
    np = Math.pow(n, 2);
    this.Qn = this.k0 / (1 + n) * (1 + np * (1 / 4 + np * (1 / 64 + np / 256)));
    this.utg[0] = n * (-0.5 + n * (2 / 3 + n * (-37 / 96 + n * (1 / 360 + n * (81 / 512 + n * (-96199 / 604800))))));
    this.gtu[0] = n * (0.5 + n * (-2 / 3 + n * (5 / 16 + n * (41 / 180 + n * (-127 / 288 + n * (7891 / 37800))))));
    this.utg[1] = np * (-1 / 48 + n * (-1 / 15 + n * (437 / 1440 + n * (-46 / 105 + n * (1118711 / 3870720)))));
    this.gtu[1] = np * (13 / 48 + n * (-0.6 + n * (557 / 1440 + n * (281 / 630 + n * (-1983433 / 1935360)))));
    np = np * n;
    this.utg[2] = np * (-17 / 480 + n * (37 / 840 + n * (209 / 4480 + n * (-5569 / 90720))));
    this.gtu[2] = np * (61 / 240 + n * (-103 / 140 + n * (15061 / 26880 + n * (167603 / 181440))));
    np = np * n;
    this.utg[3] = np * (-4397 / 161280 + n * (11 / 504 + n * (830251 / 7257600)));
    this.gtu[3] = np * (49561 / 161280 + n * (-179 / 168 + n * (6601661 / 7257600)));
    np = np * n;
    this.utg[4] = np * (-4583 / 161280 + n * (108847 / 3991680));
    this.gtu[4] = np * (34729 / 80640 + n * (-3418889 / 1995840));
    np = np * n;
    this.utg[5] = np * (-20648693 / 638668800);
    this.gtu[5] = np * 0.6650675310896665;
    var Z = (0, $klaWo.default)(this.cbg, this.lat0);
    this.Zb = -this.Qn * (Z + (0, $k0stT.default)(this.gtu, 2 * Z));
}
function forward(p) {
    var Ce = (0, $a9oRf.default)(p.x - this.long0);
    var Cn = p.y;
    Cn = (0, $klaWo.default)(this.cbg, Cn);
    var sin_Cn = Math.sin(Cn);
    var cos_Cn = Math.cos(Cn);
    var sin_Ce = Math.sin(Ce);
    var cos_Ce = Math.cos(Ce);
    Cn = Math.atan2(sin_Cn, cos_Ce * cos_Cn);
    Ce = Math.atan2(sin_Ce * cos_Cn, (0, $jU5gu.default)(sin_Cn, cos_Cn * cos_Ce));
    Ce = (0, $cVtoA.default)(Math.tan(Ce));
    var tmp = (0, $iKZ74.default)(this.gtu, 2 * Cn, 2 * Ce);
    Cn = Cn + tmp[0];
    Ce = Ce + tmp[1];
    var x;
    var y;
    if (Math.abs(Ce) <= 2.623395162778) {
        x = this.a * (this.Qn * Ce) + this.x0;
        y = this.a * (this.Qn * Cn + this.Zb) + this.y0;
    } else {
        x = Infinity;
        y = Infinity;
    }
    p.x = x;
    p.y = y;
    return p;
}
function inverse(p) {
    var Ce = (p.x - this.x0) * (1 / this.a);
    var Cn = (p.y - this.y0) * (1 / this.a);
    Cn = (Cn - this.Zb) / this.Qn;
    Ce = Ce / this.Qn;
    var lon;
    var lat;
    if (Math.abs(Ce) <= 2.623395162778) {
        var tmp = (0, $iKZ74.default)(this.utg, 2 * Cn, 2 * Ce);
        Cn = Cn + tmp[0];
        Ce = Ce + tmp[1];
        Ce = Math.atan((0, $zBlxr.default)(Ce));
        var sin_Cn = Math.sin(Cn);
        var cos_Cn = Math.cos(Cn);
        var sin_Ce = Math.sin(Ce);
        var cos_Ce = Math.cos(Ce);
        Cn = Math.atan2(sin_Cn * cos_Ce, (0, $jU5gu.default)(sin_Ce, cos_Ce * cos_Cn));
        Ce = Math.atan2(sin_Ce, cos_Ce * cos_Cn);
        lon = (0, $a9oRf.default)(Ce + this.long0);
        lat = (0, $klaWo.default)(this.cgb, Cn);
    } else {
        lon = Infinity;
        lat = Infinity;
    }
    p.x = lon;
    p.y = lat;
    return p;
}
var names = [
    "Extended_Transverse_Mercator",
    "Extended Transverse Mercator",
    "etmerc",
    "Transverse_Mercator",
    "Transverse Mercator",
    "Gauss Kruger",
    "Gauss_Kruger",
    "tmerc"
];
var $6f7c72613b8aa92a$export$2e2bcd8739ae039 = {
    init: init,
    forward: forward,
    inverse: inverse,
    names: names
};

});
parcelRegister("9t3dO", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e495242beb4668f$export$2e2bcd8739ae039);
// Heavily based on this tmerc projection implementation
// https://github.com/mbloch/mapshaper-proj/blob/master/src/projections/tmerc.js

var $gqKpL = parcelRequire("gqKpL");

var $hpUQm = parcelRequire("hpUQm");

var $jQUK6 = parcelRequire("jQUK6");

var $a9oRf = parcelRequire("a9oRf");

var $gyVUi = parcelRequire("gyVUi");

var $boTd3 = parcelRequire("boTd3");
function $6e495242beb4668f$export$2cd8252107eb640b() {
    this.x0 = this.x0 !== undefined ? this.x0 : 0;
    this.y0 = this.y0 !== undefined ? this.y0 : 0;
    this.long0 = this.long0 !== undefined ? this.long0 : 0;
    this.lat0 = this.lat0 !== undefined ? this.lat0 : 0;
    if (this.es) {
        this.en = (0, $gqKpL.default)(this.es);
        this.ml0 = (0, $hpUQm.default)(this.lat0, Math.sin(this.lat0), Math.cos(this.lat0), this.en);
    }
}
function $6e495242beb4668f$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    var delta_lon = (0, $a9oRf.default)(lon - this.long0);
    var con;
    var x, y;
    var sin_phi = Math.sin(lat);
    var cos_phi = Math.cos(lat);
    if (!this.es) {
        var b = cos_phi * Math.sin(delta_lon);
        if (Math.abs(Math.abs(b) - 1) < (0, $gyVUi.EPSLN)) return 93;
        else {
            x = 0.5 * this.a * this.k0 * Math.log((1 + b) / (1 - b)) + this.x0;
            y = cos_phi * Math.cos(delta_lon) / Math.sqrt(1 - Math.pow(b, 2));
            b = Math.abs(y);
            if (b >= 1) {
                if (b - 1 > (0, $gyVUi.EPSLN)) return 93;
                else y = 0;
            } else y = Math.acos(y);
            if (lat < 0) y = -y;
            y = this.a * this.k0 * (y - this.lat0) + this.y0;
        }
    } else {
        var al = cos_phi * delta_lon;
        var als = Math.pow(al, 2);
        var c = this.ep2 * Math.pow(cos_phi, 2);
        var cs = Math.pow(c, 2);
        var tq = Math.abs(cos_phi) > (0, $gyVUi.EPSLN) ? Math.tan(lat) : 0;
        var t = Math.pow(tq, 2);
        var ts = Math.pow(t, 2);
        con = 1 - this.es * Math.pow(sin_phi, 2);
        al = al / Math.sqrt(con);
        var ml = (0, $hpUQm.default)(lat, sin_phi, cos_phi, this.en);
        x = this.a * (this.k0 * al * (1 + als / 6 * (1 - t + c + als / 20 * (5 - 18 * t + ts + 14 * c - 58 * t * c + als / 42 * (61 + 179 * ts - ts * t - 479 * t))))) + this.x0;
        y = this.a * (this.k0 * (ml - this.ml0 + sin_phi * delta_lon * al / 2 * (1 + als / 12 * (5 - t + 9 * c + 4 * cs + als / 30 * (61 + ts - 58 * t + 270 * c - 330 * t * c + als / 56 * (1385 + 543 * ts - ts * t - 3111 * t)))))) + this.y0;
    }
    p.x = x;
    p.y = y;
    return p;
}
function $6e495242beb4668f$export$70ae2c07e401031b(p) {
    var con, phi;
    var lat, lon;
    var x = (p.x - this.x0) * (1 / this.a);
    var y = (p.y - this.y0) * (1 / this.a);
    if (!this.es) {
        var f = Math.exp(x / this.k0);
        var g = 0.5 * (f - 1 / f);
        var temp = this.lat0 + y / this.k0;
        var h = Math.cos(temp);
        con = Math.sqrt((1 - Math.pow(h, 2)) / (1 + Math.pow(g, 2)));
        lat = Math.asin(con);
        if (y < 0) lat = -lat;
        if (g === 0 && h === 0) lon = 0;
        else lon = (0, $a9oRf.default)(Math.atan2(g, h) + this.long0);
    } else {
        con = this.ml0 + y / this.k0;
        phi = (0, $jQUK6.default)(con, this.es, this.en);
        if (Math.abs(phi) < (0, $gyVUi.HALF_PI)) {
            var sin_phi = Math.sin(phi);
            var cos_phi = Math.cos(phi);
            var tan_phi = Math.abs(cos_phi) > (0, $gyVUi.EPSLN) ? Math.tan(phi) : 0;
            var c = this.ep2 * Math.pow(cos_phi, 2);
            var cs = Math.pow(c, 2);
            var t = Math.pow(tan_phi, 2);
            var ts = Math.pow(t, 2);
            con = 1 - this.es * Math.pow(sin_phi, 2);
            var d = x * Math.sqrt(con) / this.k0;
            var ds = Math.pow(d, 2);
            con = con * tan_phi;
            lat = phi - con * ds / (1 - this.es) * 0.5 * (1 - ds / 12 * (5 + 3 * t - 9 * c * t + c - 4 * cs - ds / 30 * (61 + 90 * t - 252 * c * t + 45 * ts + 46 * c - ds / 56 * (1385 + 3633 * t + 4095 * ts + 1574 * ts * t))));
            lon = (0, $a9oRf.default)(this.long0 + d * (1 - ds / 6 * (1 + 2 * t + c - ds / 20 * (5 + 28 * t + 24 * ts + 8 * c * t + 6 * c - ds / 42 * (61 + 662 * t + 1320 * ts + 720 * ts * t)))) / cos_phi);
        } else {
            lat = (0, $gyVUi.HALF_PI) * (0, $boTd3.default)(y);
            lon = 0;
        }
    }
    p.x = lon;
    p.y = lat;
    return p;
}
var $6e495242beb4668f$export$e4b2ac9215619f8d = [
    "Fast_Transverse_Mercator",
    "Fast Transverse Mercator"
];
var $6e495242beb4668f$export$2e2bcd8739ae039 = {
    init: $6e495242beb4668f$export$2cd8252107eb640b,
    forward: $6e495242beb4668f$export$174bb771924e7eb1,
    inverse: $6e495242beb4668f$export$70ae2c07e401031b,
    names: $6e495242beb4668f$export$e4b2ac9215619f8d
};

});
parcelRegister("gqKpL", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf6313ff986be9ac$export$2e2bcd8739ae039);
var $bf6313ff986be9ac$var$C00 = 1;
var $bf6313ff986be9ac$var$C02 = 0.25;
var $bf6313ff986be9ac$var$C04 = 0.046875;
var $bf6313ff986be9ac$var$C06 = 0.01953125;
var $bf6313ff986be9ac$var$C08 = 0.01068115234375;
var $bf6313ff986be9ac$var$C22 = 0.75;
var $bf6313ff986be9ac$var$C44 = 0.46875;
var $bf6313ff986be9ac$var$C46 = 0.01302083333333333333;
var $bf6313ff986be9ac$var$C48 = 0.00712076822916666666;
var $bf6313ff986be9ac$var$C66 = 0.36458333333333333333;
var $bf6313ff986be9ac$var$C68 = 0.00569661458333333333;
var $bf6313ff986be9ac$var$C88 = 0.3076171875;
function $bf6313ff986be9ac$export$2e2bcd8739ae039(es) {
    var en = [];
    en[0] = $bf6313ff986be9ac$var$C00 - es * ($bf6313ff986be9ac$var$C02 + es * ($bf6313ff986be9ac$var$C04 + es * ($bf6313ff986be9ac$var$C06 + es * $bf6313ff986be9ac$var$C08)));
    en[1] = es * ($bf6313ff986be9ac$var$C22 - es * ($bf6313ff986be9ac$var$C04 + es * ($bf6313ff986be9ac$var$C06 + es * $bf6313ff986be9ac$var$C08)));
    var t = es * es;
    en[2] = t * ($bf6313ff986be9ac$var$C44 - es * ($bf6313ff986be9ac$var$C46 + es * $bf6313ff986be9ac$var$C48));
    t *= es;
    en[3] = t * ($bf6313ff986be9ac$var$C66 - es * $bf6313ff986be9ac$var$C68);
    en[4] = t * es * $bf6313ff986be9ac$var$C88;
    return en;
}

});

parcelRegister("hpUQm", function(module, exports) {

$parcel$export(module.exports, "default", () => $cae0dd692f473684$export$2e2bcd8739ae039);
function $cae0dd692f473684$export$2e2bcd8739ae039(phi, sphi, cphi, en) {
    cphi *= sphi;
    sphi *= sphi;
    return en[0] * phi - cphi * (en[1] + sphi * (en[2] + sphi * (en[3] + sphi * en[4])));
}

});

parcelRegister("jQUK6", function(module, exports) {

$parcel$export(module.exports, "default", () => $e73ee39023f9c198$export$2e2bcd8739ae039);

var $hpUQm = parcelRequire("hpUQm");

var $gyVUi = parcelRequire("gyVUi");
var $e73ee39023f9c198$var$MAX_ITER = 20;
function $e73ee39023f9c198$export$2e2bcd8739ae039(arg, es, en) {
    var k = 1 / (1 - es);
    var phi = arg;
    for(var i = $e73ee39023f9c198$var$MAX_ITER; i; --i){
        var s = Math.sin(phi);
        var t = 1 - es * s * s;
        //t = this.pj_mlfn(phi, s, Math.cos(phi), en) - arg;
        //phi -= t * (t * Math.sqrt(t)) * k;
        t = ((0, $hpUQm.default)(phi, s, Math.cos(phi), en) - arg) * (t * Math.sqrt(t)) * k;
        phi -= t;
        if (Math.abs(t) < (0, $gyVUi.EPSLN)) return phi;
    }
    //..reportError("cass:pj_inv_mlfn: Convergence error");
    return phi;
}

});
parcelRegister("gyVUi", function(module, exports) {

$parcel$export(module.exports, "PJD_3PARAM", () => $c0ecbd71ed29ee86$export$3a3ed3e590e8ec27);
$parcel$export(module.exports, "PJD_7PARAM", () => $c0ecbd71ed29ee86$export$8cab19b7f383a7a7);
$parcel$export(module.exports, "PJD_GRIDSHIFT", () => $c0ecbd71ed29ee86$export$83d26ae02793dd10);
$parcel$export(module.exports, "PJD_WGS84", () => $c0ecbd71ed29ee86$export$ab5bf8c731b6bbbb);
$parcel$export(module.exports, "PJD_NODATUM", () => $c0ecbd71ed29ee86$export$8df4c7729d8ed58d);
$parcel$export(module.exports, "SRS_WGS84_SEMIMAJOR", () => $c0ecbd71ed29ee86$export$d612c03b7390d945);
$parcel$export(module.exports, "SRS_WGS84_SEMIMINOR", () => $c0ecbd71ed29ee86$export$59af086d7527ec46);
$parcel$export(module.exports, "SRS_WGS84_ESQUARED", () => $c0ecbd71ed29ee86$export$9b798f9d78b99fc0);
$parcel$export(module.exports, "SEC_TO_RAD", () => $c0ecbd71ed29ee86$export$e0b9011552f3b2f7);
$parcel$export(module.exports, "HALF_PI", () => $c0ecbd71ed29ee86$export$f504979d7e0a75c7);
$parcel$export(module.exports, "SIXTH", () => $c0ecbd71ed29ee86$export$d7977f56a0faa834);
$parcel$export(module.exports, "RA4", () => $c0ecbd71ed29ee86$export$9e703428410a9c7b);
$parcel$export(module.exports, "RA6", () => $c0ecbd71ed29ee86$export$bb54dde5565ed6e3);
$parcel$export(module.exports, "EPSLN", () => $c0ecbd71ed29ee86$export$2aa89dbfb8b504bb);
$parcel$export(module.exports, "D2R", () => $c0ecbd71ed29ee86$export$ed6012a68c0f4a70);
$parcel$export(module.exports, "R2D", () => $c0ecbd71ed29ee86$export$456934b8be7498c3);
$parcel$export(module.exports, "FORTPI", () => $c0ecbd71ed29ee86$export$10cb69dd603c11b0);
$parcel$export(module.exports, "TWO_PI", () => $c0ecbd71ed29ee86$export$6eec49b1a6289c4e);
$parcel$export(module.exports, "SPI", () => $c0ecbd71ed29ee86$export$703a92fc6506ffb9);
var $c0ecbd71ed29ee86$export$3a3ed3e590e8ec27 = 1;
var $c0ecbd71ed29ee86$export$8cab19b7f383a7a7 = 2;
var $c0ecbd71ed29ee86$export$83d26ae02793dd10 = 3;
var $c0ecbd71ed29ee86$export$ab5bf8c731b6bbbb = 4; // WGS84 or equivalent
var $c0ecbd71ed29ee86$export$8df4c7729d8ed58d = 5; // WGS84 or equivalent
var $c0ecbd71ed29ee86$export$d612c03b7390d945 = 6378137.0; // only used in grid shift transforms
var $c0ecbd71ed29ee86$export$59af086d7527ec46 = 6356752.314; // only used in grid shift transforms
var $c0ecbd71ed29ee86$export$9b798f9d78b99fc0 = 0.0066943799901413165; // only used in grid shift transforms
var $c0ecbd71ed29ee86$export$e0b9011552f3b2f7 = 4.84813681109535993589914102357e-6;
var $c0ecbd71ed29ee86$export$f504979d7e0a75c7 = Math.PI / 2;
var $c0ecbd71ed29ee86$export$d7977f56a0faa834 = 0.1666666666666666667;
var $c0ecbd71ed29ee86$export$9e703428410a9c7b = 0.04722222222222222222;
var $c0ecbd71ed29ee86$export$bb54dde5565ed6e3 = 0.02215608465608465608;
var $c0ecbd71ed29ee86$export$2aa89dbfb8b504bb = 1.0e-10;
var $c0ecbd71ed29ee86$export$ed6012a68c0f4a70 = 0.01745329251994329577;
var $c0ecbd71ed29ee86$export$456934b8be7498c3 = 57.29577951308232088;
var $c0ecbd71ed29ee86$export$10cb69dd603c11b0 = Math.PI / 4;
var $c0ecbd71ed29ee86$export$6eec49b1a6289c4e = Math.PI * 2;
var $c0ecbd71ed29ee86$export$703a92fc6506ffb9 = 3.14159265359;

});


parcelRegister("a9oRf", function(module, exports) {

$parcel$export(module.exports, "default", () => $763e06e438986b6c$export$2e2bcd8739ae039);

var $gyVUi = parcelRequire("gyVUi");

var $boTd3 = parcelRequire("boTd3");
function $763e06e438986b6c$export$2e2bcd8739ae039(x) {
    return Math.abs(x) <= (0, $gyVUi.SPI) ? x : x - (0, $boTd3.default)(x) * (0, $gyVUi.TWO_PI);
}

});
parcelRegister("boTd3", function(module, exports) {

$parcel$export(module.exports, "default", () => $84ccc316da8510bf$export$2e2bcd8739ae039);
function $84ccc316da8510bf$export$2e2bcd8739ae039(x) {
    return x < 0 ? -1 : 1;
}

});



parcelRegister("zBlxr", function(module, exports) {

$parcel$export(module.exports, "default", () => $06b03d370063c40e$export$2e2bcd8739ae039);
function $06b03d370063c40e$export$2e2bcd8739ae039(x) {
    var r = Math.exp(x);
    r = (r - 1 / r) / 2;
    return r;
}

});

parcelRegister("jU5gu", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7d754d244264a37$export$2e2bcd8739ae039);
function $e7d754d244264a37$export$2e2bcd8739ae039(x, y) {
    x = Math.abs(x);
    y = Math.abs(y);
    var a = Math.max(x, y);
    var b = Math.min(x, y) / (a ? a : 1);
    return a * Math.sqrt(1 + Math.pow(b, 2));
}

});

parcelRegister("cVtoA", function(module, exports) {

$parcel$export(module.exports, "default", () => $96919c3c2b0cfee9$export$2e2bcd8739ae039);

var $jU5gu = parcelRequire("jU5gu");

var $g1hBf = parcelRequire("g1hBf");
function $96919c3c2b0cfee9$export$2e2bcd8739ae039(x) {
    var y = Math.abs(x);
    y = (0, $g1hBf.default)(y * (1 + y / ((0, $jU5gu.default)(1, y) + 1)));
    return x < 0 ? -y : y;
}

});
parcelRegister("g1hBf", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba9a64430787103e$export$2e2bcd8739ae039);
function $ba9a64430787103e$export$2e2bcd8739ae039(x) {
    var y = 1 + x;
    var z = y - 1;
    return z === 0 ? x : x * Math.log(y) / z;
}

});


parcelRegister("klaWo", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecee41736c9c0e4b$export$2e2bcd8739ae039);
function $ecee41736c9c0e4b$export$2e2bcd8739ae039(pp, B) {
    var cos_2B = 2 * Math.cos(2 * B);
    var i = pp.length - 1;
    var h1 = pp[i];
    var h2 = 0;
    var h;
    while(--i >= 0){
        h = -h2 + cos_2B * h1 + pp[i];
        h2 = h1;
        h1 = h;
    }
    return B + h * Math.sin(2 * B);
}

});

parcelRegister("k0stT", function(module, exports) {

$parcel$export(module.exports, "default", () => $e909e682fc23c405$export$2e2bcd8739ae039);
function $e909e682fc23c405$export$2e2bcd8739ae039(pp, arg_r) {
    var r = 2 * Math.cos(arg_r);
    var i = pp.length - 1;
    var hr1 = pp[i];
    var hr2 = 0;
    var hr;
    while(--i >= 0){
        hr = -hr2 + r * hr1 + pp[i];
        hr2 = hr1;
        hr1 = hr;
    }
    return Math.sin(arg_r) * hr;
}

});

parcelRegister("iKZ74", function(module, exports) {

$parcel$export(module.exports, "default", () => $da7beda932685c15$export$2e2bcd8739ae039);

var $zBlxr = parcelRequire("zBlxr");

var $cz4ED = parcelRequire("cz4ED");
function $da7beda932685c15$export$2e2bcd8739ae039(pp, arg_r, arg_i) {
    var sin_arg_r = Math.sin(arg_r);
    var cos_arg_r = Math.cos(arg_r);
    var sinh_arg_i = (0, $zBlxr.default)(arg_i);
    var cosh_arg_i = (0, $cz4ED.default)(arg_i);
    var r = 2 * cos_arg_r * cosh_arg_i;
    var i = -2 * sin_arg_r * sinh_arg_i;
    var j = pp.length - 1;
    var hr = pp[j];
    var hi1 = 0;
    var hr1 = 0;
    var hi = 0;
    var hr2;
    var hi2;
    while(--j >= 0){
        hr2 = hr1;
        hi2 = hi1;
        hr1 = hr;
        hi1 = hi;
        hr = -hr2 + r * hr1 - i * hi1 + pp[j];
        hi = -hi2 + i * hr1 + r * hi1;
    }
    r = sin_arg_r * cosh_arg_i;
    i = cos_arg_r * sinh_arg_i;
    return [
        r * hr - i * hi,
        r * hi + i * hr
    ];
}

});
parcelRegister("cz4ED", function(module, exports) {

$parcel$export(module.exports, "default", () => $925c5d35b4e59088$export$2e2bcd8739ae039);
function $925c5d35b4e59088$export$2e2bcd8739ae039(x) {
    var r = Math.exp(x);
    r = (r + 1 / r) / 2;
    return r;
}

});



parcelRegister("llHto", function(module, exports) {

$parcel$export(module.exports, "ssfn_", () => ssfn_);
$parcel$export(module.exports, "init", () => init);
$parcel$export(module.exports, "forward", () => forward);
$parcel$export(module.exports, "inverse", () => inverse);
$parcel$export(module.exports, "names", () => names);
$parcel$export(module.exports, "default", () => $f8ad4802022ce868$export$2e2bcd8739ae039);

var $gyVUi = parcelRequire("gyVUi");

var $boTd3 = parcelRequire("boTd3");

var $bi5ZC = parcelRequire("bi5ZC");

var $3xC66 = parcelRequire("3xC66");

var $2AZR8 = parcelRequire("2AZR8");

var $a9oRf = parcelRequire("a9oRf");
function ssfn_(phit, sinphi, eccen) {
    sinphi *= eccen;
    return Math.tan(0.5 * ((0, $gyVUi.HALF_PI) + phit)) * Math.pow((1 - sinphi) / (1 + sinphi), 0.5 * eccen);
}
function init() {
    // setting default parameters
    this.x0 = this.x0 || 0;
    this.y0 = this.y0 || 0;
    this.lat0 = this.lat0 || 0;
    this.long0 = this.long0 || 0;
    this.coslat0 = Math.cos(this.lat0);
    this.sinlat0 = Math.sin(this.lat0);
    if (this.sphere) {
        if (this.k0 === 1 && !isNaN(this.lat_ts) && Math.abs(this.coslat0) <= (0, $gyVUi.EPSLN)) this.k0 = 0.5 * (1 + (0, $boTd3.default)(this.lat0) * Math.sin(this.lat_ts));
    } else {
        if (Math.abs(this.coslat0) <= (0, $gyVUi.EPSLN)) {
            if (this.lat0 > 0) //North pole
            //trace('stere:north pole');
            this.con = 1;
            else //South pole
            //trace('stere:south pole');
            this.con = -1;
        }
        this.cons = Math.sqrt(Math.pow(1 + this.e, 1 + this.e) * Math.pow(1 - this.e, 1 - this.e));
        if (this.k0 === 1 && !isNaN(this.lat_ts) && Math.abs(this.coslat0) <= (0, $gyVUi.EPSLN) && Math.abs(Math.cos(this.lat_ts)) > (0, $gyVUi.EPSLN)) // When k0 is 1 (default value) and lat_ts is a vaild number and lat0 is at a pole and lat_ts is not at a pole
        // Recalculate k0 using formula 21-35 from p161 of Snyder, 1987
        this.k0 = 0.5 * this.cons * (0, $bi5ZC.default)(this.e, Math.sin(this.lat_ts), Math.cos(this.lat_ts)) / (0, $3xC66.default)(this.e, this.con * this.lat_ts, this.con * Math.sin(this.lat_ts));
        this.ms1 = (0, $bi5ZC.default)(this.e, this.sinlat0, this.coslat0);
        this.X0 = 2 * Math.atan(this.ssfn_(this.lat0, this.sinlat0, this.e)) - (0, $gyVUi.HALF_PI);
        this.cosX0 = Math.cos(this.X0);
        this.sinX0 = Math.sin(this.X0);
    }
}
function forward(p) {
    var lon = p.x;
    var lat = p.y;
    var sinlat = Math.sin(lat);
    var coslat = Math.cos(lat);
    var A, X, sinX, cosX, ts, rh;
    var dlon = (0, $a9oRf.default)(lon - this.long0);
    if (Math.abs(Math.abs(lon - this.long0) - Math.PI) <= (0, $gyVUi.EPSLN) && Math.abs(lat + this.lat0) <= (0, $gyVUi.EPSLN)) {
        //case of the origine point
        //trace('stere:this is the origin point');
        p.x = NaN;
        p.y = NaN;
        return p;
    }
    if (this.sphere) {
        //trace('stere:sphere case');
        A = 2 * this.k0 / (1 + this.sinlat0 * sinlat + this.coslat0 * coslat * Math.cos(dlon));
        p.x = this.a * A * coslat * Math.sin(dlon) + this.x0;
        p.y = this.a * A * (this.coslat0 * sinlat - this.sinlat0 * coslat * Math.cos(dlon)) + this.y0;
        return p;
    } else {
        X = 2 * Math.atan(this.ssfn_(lat, sinlat, this.e)) - (0, $gyVUi.HALF_PI);
        cosX = Math.cos(X);
        sinX = Math.sin(X);
        if (Math.abs(this.coslat0) <= (0, $gyVUi.EPSLN)) {
            ts = (0, $3xC66.default)(this.e, lat * this.con, this.con * sinlat);
            rh = 2 * this.a * this.k0 * ts / this.cons;
            p.x = this.x0 + rh * Math.sin(lon - this.long0);
            p.y = this.y0 - this.con * rh * Math.cos(lon - this.long0);
            //trace(p.toString());
            return p;
        } else if (Math.abs(this.sinlat0) < (0, $gyVUi.EPSLN)) {
            //Eq
            //trace('stere:equateur');
            A = 2 * this.a * this.k0 / (1 + cosX * Math.cos(dlon));
            p.y = A * sinX;
        } else {
            //other case
            //trace('stere:normal case');
            A = 2 * this.a * this.k0 * this.ms1 / (this.cosX0 * (1 + this.sinX0 * sinX + this.cosX0 * cosX * Math.cos(dlon)));
            p.y = A * (this.cosX0 * sinX - this.sinX0 * cosX * Math.cos(dlon)) + this.y0;
        }
        p.x = A * cosX * Math.sin(dlon) + this.x0;
    }
    //trace(p.toString());
    return p;
}
function inverse(p) {
    p.x -= this.x0;
    p.y -= this.y0;
    var lon, lat, ts, ce, Chi;
    var rh = Math.sqrt(p.x * p.x + p.y * p.y);
    if (this.sphere) {
        var c = 2 * Math.atan(rh / (2 * this.a * this.k0));
        lon = this.long0;
        lat = this.lat0;
        if (rh <= (0, $gyVUi.EPSLN)) {
            p.x = lon;
            p.y = lat;
            return p;
        }
        lat = Math.asin(Math.cos(c) * this.sinlat0 + p.y * Math.sin(c) * this.coslat0 / rh);
        if (Math.abs(this.coslat0) < (0, $gyVUi.EPSLN)) {
            if (this.lat0 > 0) lon = (0, $a9oRf.default)(this.long0 + Math.atan2(p.x, -1 * p.y));
            else lon = (0, $a9oRf.default)(this.long0 + Math.atan2(p.x, p.y));
        } else lon = (0, $a9oRf.default)(this.long0 + Math.atan2(p.x * Math.sin(c), rh * this.coslat0 * Math.cos(c) - p.y * this.sinlat0 * Math.sin(c)));
        p.x = lon;
        p.y = lat;
        return p;
    } else if (Math.abs(this.coslat0) <= (0, $gyVUi.EPSLN)) {
        if (rh <= (0, $gyVUi.EPSLN)) {
            lat = this.lat0;
            lon = this.long0;
            p.x = lon;
            p.y = lat;
            //trace(p.toString());
            return p;
        }
        p.x *= this.con;
        p.y *= this.con;
        ts = rh * this.cons / (2 * this.a * this.k0);
        lat = this.con * (0, $2AZR8.default)(this.e, ts);
        lon = this.con * (0, $a9oRf.default)(this.con * this.long0 + Math.atan2(p.x, -1 * p.y));
    } else {
        ce = 2 * Math.atan(rh * this.cosX0 / (2 * this.a * this.k0 * this.ms1));
        lon = this.long0;
        if (rh <= (0, $gyVUi.EPSLN)) Chi = this.X0;
        else {
            Chi = Math.asin(Math.cos(ce) * this.sinX0 + p.y * Math.sin(ce) * this.cosX0 / rh);
            lon = (0, $a9oRf.default)(this.long0 + Math.atan2(p.x * Math.sin(ce), rh * this.cosX0 * Math.cos(ce) - p.y * this.sinX0 * Math.sin(ce)));
        }
        lat = -1 * (0, $2AZR8.default)(this.e, Math.tan(0.5 * ((0, $gyVUi.HALF_PI) + Chi)));
    }
    p.x = lon;
    p.y = lat;
    //trace(p.toString());
    return p;
}
var names = [
    "stere",
    "Stereographic_South_Pole",
    "Polar Stereographic (variant B)",
    "Polar_Stereographic"
];
var $f8ad4802022ce868$export$2e2bcd8739ae039 = {
    init: init,
    forward: forward,
    inverse: inverse,
    names: names,
    ssfn_: ssfn_
};

});
parcelRegister("bi5ZC", function(module, exports) {

$parcel$export(module.exports, "default", () => $8386063044328ea8$export$2e2bcd8739ae039);
function $8386063044328ea8$export$2e2bcd8739ae039(eccent, sinphi, cosphi) {
    var con = eccent * sinphi;
    return cosphi / Math.sqrt(1 - con * con);
}

});

parcelRegister("3xC66", function(module, exports) {

$parcel$export(module.exports, "default", () => $2942018063c2eff1$export$2e2bcd8739ae039);

var $gyVUi = parcelRequire("gyVUi");
function $2942018063c2eff1$export$2e2bcd8739ae039(eccent, phi, sinphi) {
    var con = eccent * sinphi;
    var com = 0.5 * eccent;
    con = Math.pow((1 - con) / (1 + con), com);
    return Math.tan(0.5 * ((0, $gyVUi.HALF_PI) - phi)) / con;
}

});

parcelRegister("2AZR8", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e3eece278ef2a71$export$2e2bcd8739ae039);

var $gyVUi = parcelRequire("gyVUi");
function $1e3eece278ef2a71$export$2e2bcd8739ae039(eccent, ts) {
    var eccnth = 0.5 * eccent;
    var con, dphi;
    var phi = (0, $gyVUi.HALF_PI) - 2 * Math.atan(ts);
    for(var i = 0; i <= 15; i++){
        con = eccent * Math.sin(phi);
        dphi = (0, $gyVUi.HALF_PI) - 2 * Math.atan(ts * Math.pow((1 - con) / (1 + con), eccnth)) - phi;
        phi += dphi;
        if (Math.abs(dphi) <= 0.0000000001) return phi;
    }
    //console.log("phi2z has NoConvergence");
    return -9999;
}

});


parcelRegister("deudM", function(module, exports) {

$parcel$export(module.exports, "S_POLE", () => S_POLE);
$parcel$export(module.exports, "N_POLE", () => N_POLE);
$parcel$export(module.exports, "EQUIT", () => EQUIT);
$parcel$export(module.exports, "OBLIQ", () => OBLIQ);
$parcel$export(module.exports, "init", () => init);
$parcel$export(module.exports, "forward", () => forward);
$parcel$export(module.exports, "inverse", () => inverse);
$parcel$export(module.exports, "names", () => names);
$parcel$export(module.exports, "default", () => $9a24067d8ab69621$export$2e2bcd8739ae039);

var $gyVUi = parcelRequire("gyVUi");

var $874JP = parcelRequire("874JP");

var $a9oRf = parcelRequire("a9oRf");
var S_POLE = 1;
var N_POLE = 2;
var EQUIT = 3;
var OBLIQ = 4;
function init() {
    var t = Math.abs(this.lat0);
    if (Math.abs(t - (0, $gyVUi.HALF_PI)) < (0, $gyVUi.EPSLN)) this.mode = this.lat0 < 0 ? this.S_POLE : this.N_POLE;
    else if (Math.abs(t) < (0, $gyVUi.EPSLN)) this.mode = this.EQUIT;
    else this.mode = this.OBLIQ;
    if (this.es > 0) {
        var sinphi;
        this.qp = (0, $874JP.default)(this.e, 1);
        this.mmf = 0.5 / (1 - this.es);
        this.apa = authset(this.es);
        switch(this.mode){
            case this.N_POLE:
                this.dd = 1;
                break;
            case this.S_POLE:
                this.dd = 1;
                break;
            case this.EQUIT:
                this.rq = Math.sqrt(0.5 * this.qp);
                this.dd = 1 / this.rq;
                this.xmf = 1;
                this.ymf = 0.5 * this.qp;
                break;
            case this.OBLIQ:
                this.rq = Math.sqrt(0.5 * this.qp);
                sinphi = Math.sin(this.lat0);
                this.sinb1 = (0, $874JP.default)(this.e, sinphi) / this.qp;
                this.cosb1 = Math.sqrt(1 - this.sinb1 * this.sinb1);
                this.dd = Math.cos(this.lat0) / (Math.sqrt(1 - this.es * sinphi * sinphi) * this.rq * this.cosb1);
                this.ymf = (this.xmf = this.rq) / this.dd;
                this.xmf *= this.dd;
                break;
        }
    } else if (this.mode === this.OBLIQ) {
        this.sinph0 = Math.sin(this.lat0);
        this.cosph0 = Math.cos(this.lat0);
    }
}
function forward(p) {
    /* Forward equations
      -----------------*/ var x, y, coslam, sinlam, sinphi, q, sinb, cosb, b, cosphi;
    var lam = p.x;
    var phi = p.y;
    lam = (0, $a9oRf.default)(lam - this.long0);
    if (this.sphere) {
        sinphi = Math.sin(phi);
        cosphi = Math.cos(phi);
        coslam = Math.cos(lam);
        if (this.mode === this.OBLIQ || this.mode === this.EQUIT) {
            y = this.mode === this.EQUIT ? 1 + cosphi * coslam : 1 + this.sinph0 * sinphi + this.cosph0 * cosphi * coslam;
            if (y <= (0, $gyVUi.EPSLN)) return null;
            y = Math.sqrt(2 / y);
            x = y * cosphi * Math.sin(lam);
            y *= this.mode === this.EQUIT ? sinphi : this.cosph0 * sinphi - this.sinph0 * cosphi * coslam;
        } else if (this.mode === this.N_POLE || this.mode === this.S_POLE) {
            if (this.mode === this.N_POLE) coslam = -coslam;
            if (Math.abs(phi + this.lat0) < (0, $gyVUi.EPSLN)) return null;
            y = (0, $gyVUi.FORTPI) - phi * 0.5;
            y = 2 * (this.mode === this.S_POLE ? Math.cos(y) : Math.sin(y));
            x = y * Math.sin(lam);
            y *= coslam;
        }
    } else {
        sinb = 0;
        cosb = 0;
        b = 0;
        coslam = Math.cos(lam);
        sinlam = Math.sin(lam);
        sinphi = Math.sin(phi);
        q = (0, $874JP.default)(this.e, sinphi);
        if (this.mode === this.OBLIQ || this.mode === this.EQUIT) {
            sinb = q / this.qp;
            cosb = Math.sqrt(1 - sinb * sinb);
        }
        switch(this.mode){
            case this.OBLIQ:
                b = 1 + this.sinb1 * sinb + this.cosb1 * cosb * coslam;
                break;
            case this.EQUIT:
                b = 1 + cosb * coslam;
                break;
            case this.N_POLE:
                b = (0, $gyVUi.HALF_PI) + phi;
                q = this.qp - q;
                break;
            case this.S_POLE:
                b = phi - (0, $gyVUi.HALF_PI);
                q = this.qp + q;
                break;
        }
        if (Math.abs(b) < (0, $gyVUi.EPSLN)) return null;
        switch(this.mode){
            case this.OBLIQ:
            case this.EQUIT:
                b = Math.sqrt(2 / b);
                if (this.mode === this.OBLIQ) y = this.ymf * b * (this.cosb1 * sinb - this.sinb1 * cosb * coslam);
                else y = (b = Math.sqrt(2 / (1 + cosb * coslam))) * sinb * this.ymf;
                x = this.xmf * b * cosb * sinlam;
                break;
            case this.N_POLE:
            case this.S_POLE:
                if (q >= 0) {
                    x = (b = Math.sqrt(q)) * sinlam;
                    y = coslam * (this.mode === this.S_POLE ? b : -b);
                } else x = y = 0;
                break;
        }
    }
    p.x = this.a * x + this.x0;
    p.y = this.a * y + this.y0;
    return p;
}
function inverse(p) {
    p.x -= this.x0;
    p.y -= this.y0;
    var x = p.x / this.a;
    var y = p.y / this.a;
    var lam, phi, cCe, sCe, q, rho, ab;
    if (this.sphere) {
        var cosz = 0, rh, sinz = 0;
        rh = Math.sqrt(x * x + y * y);
        phi = rh * 0.5;
        if (phi > 1) return null;
        phi = 2 * Math.asin(phi);
        if (this.mode === this.OBLIQ || this.mode === this.EQUIT) {
            sinz = Math.sin(phi);
            cosz = Math.cos(phi);
        }
        switch(this.mode){
            case this.EQUIT:
                phi = Math.abs(rh) <= (0, $gyVUi.EPSLN) ? 0 : Math.asin(y * sinz / rh);
                x *= sinz;
                y = cosz * rh;
                break;
            case this.OBLIQ:
                phi = Math.abs(rh) <= (0, $gyVUi.EPSLN) ? this.lat0 : Math.asin(cosz * this.sinph0 + y * sinz * this.cosph0 / rh);
                x *= sinz * this.cosph0;
                y = (cosz - Math.sin(phi) * this.sinph0) * rh;
                break;
            case this.N_POLE:
                y = -y;
                phi = (0, $gyVUi.HALF_PI) - phi;
                break;
            case this.S_POLE:
                phi -= (0, $gyVUi.HALF_PI);
                break;
        }
        lam = y === 0 && (this.mode === this.EQUIT || this.mode === this.OBLIQ) ? 0 : Math.atan2(x, y);
    } else {
        ab = 0;
        if (this.mode === this.OBLIQ || this.mode === this.EQUIT) {
            x /= this.dd;
            y *= this.dd;
            rho = Math.sqrt(x * x + y * y);
            if (rho < (0, $gyVUi.EPSLN)) {
                p.x = this.long0;
                p.y = this.lat0;
                return p;
            }
            sCe = 2 * Math.asin(0.5 * rho / this.rq);
            cCe = Math.cos(sCe);
            x *= sCe = Math.sin(sCe);
            if (this.mode === this.OBLIQ) {
                ab = cCe * this.sinb1 + y * sCe * this.cosb1 / rho;
                q = this.qp * ab;
                y = rho * this.cosb1 * cCe - y * this.sinb1 * sCe;
            } else {
                ab = y * sCe / rho;
                q = this.qp * ab;
                y = rho * cCe;
            }
        } else if (this.mode === this.N_POLE || this.mode === this.S_POLE) {
            if (this.mode === this.N_POLE) y = -y;
            q = x * x + y * y;
            if (!q) {
                p.x = this.long0;
                p.y = this.lat0;
                return p;
            }
            ab = 1 - q / this.qp;
            if (this.mode === this.S_POLE) ab = -ab;
        }
        lam = Math.atan2(x, y);
        phi = authlat(Math.asin(ab), this.apa);
    }
    p.x = (0, $a9oRf.default)(this.long0 + lam);
    p.y = phi;
    return p;
}
/* determine latitude from authalic latitude */ var P00 = 0.33333333333333333333;
var P01 = 0.17222222222222222222;
var P02 = 0.10257936507936507936;
var P10 = 0.06388888888888888888;
var P11 = 0.06640211640211640211;
var P20 = 0.01641501294219154443;
function authset(es) {
    var t;
    var APA = [];
    APA[0] = es * P00;
    t = es * es;
    APA[0] += t * P01;
    APA[1] = t * P10;
    t *= es;
    APA[0] += t * P02;
    APA[1] += t * P11;
    APA[2] = t * P20;
    return APA;
}
function authlat(beta, APA) {
    var t = beta + beta;
    return beta + APA[0] * Math.sin(t) + APA[1] * Math.sin(t + t) + APA[2] * Math.sin(t + t + t);
}
var names = [
    "Lambert Azimuthal Equal Area",
    "Lambert_Azimuthal_Equal_Area",
    "laea"
];
var $9a24067d8ab69621$export$2e2bcd8739ae039 = {
    init: init,
    forward: forward,
    inverse: inverse,
    names: names,
    S_POLE: S_POLE,
    N_POLE: N_POLE,
    EQUIT: EQUIT,
    OBLIQ: OBLIQ
};

});
parcelRegister("874JP", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e82a7153665d151$export$2e2bcd8739ae039);
function $5e82a7153665d151$export$2e2bcd8739ae039(eccent, sinphi) {
    var con;
    if (eccent > 1.0e-7) {
        con = eccent * sinphi;
        return (1 - eccent * eccent) * (sinphi / (1 - con * con) - 0.5 / eccent * Math.log((1 - con) / (1 + con)));
    } else return 2 * sinphi;
}

});


parcelRegister("8mhgZ", function(module, exports) {

$parcel$export(module.exports, "init", () => init);
$parcel$export(module.exports, "forward", () => forward);
$parcel$export(module.exports, "inverse", () => inverse);
$parcel$export(module.exports, "phi1z", () => phi1z);
$parcel$export(module.exports, "names", () => names);
$parcel$export(module.exports, "default", () => $615dc6dbd83ac6d5$export$2e2bcd8739ae039);

var $bi5ZC = parcelRequire("bi5ZC");

var $874JP = parcelRequire("874JP");

var $a9oRf = parcelRequire("a9oRf");

var $ljPJJ = parcelRequire("ljPJJ");

var $gyVUi = parcelRequire("gyVUi");
function init() {
    if (Math.abs(this.lat1 + this.lat2) < (0, $gyVUi.EPSLN)) return;
    this.temp = this.b / this.a;
    this.es = 1 - Math.pow(this.temp, 2);
    this.e3 = Math.sqrt(this.es);
    this.sin_po = Math.sin(this.lat1);
    this.cos_po = Math.cos(this.lat1);
    this.t1 = this.sin_po;
    this.con = this.sin_po;
    this.ms1 = (0, $bi5ZC.default)(this.e3, this.sin_po, this.cos_po);
    this.qs1 = (0, $874JP.default)(this.e3, this.sin_po);
    this.sin_po = Math.sin(this.lat2);
    this.cos_po = Math.cos(this.lat2);
    this.t2 = this.sin_po;
    this.ms2 = (0, $bi5ZC.default)(this.e3, this.sin_po, this.cos_po);
    this.qs2 = (0, $874JP.default)(this.e3, this.sin_po);
    this.sin_po = Math.sin(this.lat0);
    this.cos_po = Math.cos(this.lat0);
    this.t3 = this.sin_po;
    this.qs0 = (0, $874JP.default)(this.e3, this.sin_po);
    if (Math.abs(this.lat1 - this.lat2) > (0, $gyVUi.EPSLN)) this.ns0 = (this.ms1 * this.ms1 - this.ms2 * this.ms2) / (this.qs2 - this.qs1);
    else this.ns0 = this.con;
    this.c = this.ms1 * this.ms1 + this.ns0 * this.qs1;
    this.rh = this.a * Math.sqrt(this.c - this.ns0 * this.qs0) / this.ns0;
}
function forward(p) {
    var lon = p.x;
    var lat = p.y;
    this.sin_phi = Math.sin(lat);
    this.cos_phi = Math.cos(lat);
    var qs = (0, $874JP.default)(this.e3, this.sin_phi);
    var rh1 = this.a * Math.sqrt(this.c - this.ns0 * qs) / this.ns0;
    var theta = this.ns0 * (0, $a9oRf.default)(lon - this.long0);
    var x = rh1 * Math.sin(theta) + this.x0;
    var y = this.rh - rh1 * Math.cos(theta) + this.y0;
    p.x = x;
    p.y = y;
    return p;
}
function inverse(p) {
    var rh1, qs, con, theta, lon, lat;
    p.x -= this.x0;
    p.y = this.rh - p.y + this.y0;
    if (this.ns0 >= 0) {
        rh1 = Math.sqrt(p.x * p.x + p.y * p.y);
        con = 1;
    } else {
        rh1 = -Math.sqrt(p.x * p.x + p.y * p.y);
        con = -1;
    }
    theta = 0;
    if (rh1 !== 0) theta = Math.atan2(con * p.x, con * p.y);
    con = rh1 * this.ns0 / this.a;
    if (this.sphere) lat = Math.asin((this.c - con * con) / (2 * this.ns0));
    else {
        qs = (this.c - con * con) / this.ns0;
        lat = this.phi1z(this.e3, qs);
    }
    lon = (0, $a9oRf.default)(theta / this.ns0 + this.long0);
    p.x = lon;
    p.y = lat;
    return p;
}
function phi1z(eccent, qs) {
    var sinphi, cosphi, con, com, dphi;
    var phi = (0, $ljPJJ.default)(0.5 * qs);
    if (eccent < (0, $gyVUi.EPSLN)) return phi;
    var eccnts = eccent * eccent;
    for(var i = 1; i <= 25; i++){
        sinphi = Math.sin(phi);
        cosphi = Math.cos(phi);
        con = eccent * sinphi;
        com = 1 - con * con;
        dphi = 0.5 * com * com / cosphi * (qs / (1 - eccnts) - sinphi / com + 0.5 / eccent * Math.log((1 - con) / (1 + con)));
        phi = phi + dphi;
        if (Math.abs(dphi) <= 1e-7) return phi;
    }
    return null;
}
var names = [
    "Albers_Conic_Equal_Area",
    "Albers",
    "aea"
];
var $615dc6dbd83ac6d5$export$2e2bcd8739ae039 = {
    init: init,
    forward: forward,
    inverse: inverse,
    names: names,
    phi1z: phi1z
};

});
parcelRegister("ljPJJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8538120e633ea57$export$2e2bcd8739ae039);
function $f8538120e633ea57$export$2e2bcd8739ae039(x) {
    if (Math.abs(x) > 1) x = x > 1 ? 1 : -1;
    return Math.asin(x);
}

});


parcelRegister("6Eu1X", function(module, exports) {

$parcel$export(module.exports, "iterations", () => iterations);
$parcel$export(module.exports, "init", () => init);
$parcel$export(module.exports, "forward", () => forward);
$parcel$export(module.exports, "inverse", () => inverse);
$parcel$export(module.exports, "names", () => names);
$parcel$export(module.exports, "default", () => $4d7dc5ed367b221e$export$2e2bcd8739ae039);

var $gyVUi = parcelRequire("gyVUi");
var iterations = 1;
function init() {
    this.A = [];
    this.A[1] = 0.6399175073;
    this.A[2] = -0.1358797613;
    this.A[3] = 0.063294409;
    this.A[4] = -0.02526853;
    this.A[5] = 0.0117879;
    this.A[6] = -0.0055161;
    this.A[7] = 0.0026906;
    this.A[8] = -0.001333;
    this.A[9] = 0.00067;
    this.A[10] = -0.00034;
    this.B_re = [];
    this.B_im = [];
    this.B_re[1] = 0.7557853228;
    this.B_im[1] = 0;
    this.B_re[2] = 0.249204646;
    this.B_im[2] = 0.003371507;
    this.B_re[3] = -0.001541739;
    this.B_im[3] = 0.041058560;
    this.B_re[4] = -0.10162907;
    this.B_im[4] = 0.01727609;
    this.B_re[5] = -0.26623489;
    this.B_im[5] = -0.36249218;
    this.B_re[6] = -0.6870983;
    this.B_im[6] = -1.1651967;
    this.C_re = [];
    this.C_im = [];
    this.C_re[1] = 1.3231270439;
    this.C_im[1] = 0;
    this.C_re[2] = -0.577245789;
    this.C_im[2] = -0.007809598;
    this.C_re[3] = 0.508307513;
    this.C_im[3] = -0.112208952;
    this.C_re[4] = -0.15094762;
    this.C_im[4] = 0.18200602;
    this.C_re[5] = 1.01418179;
    this.C_im[5] = 1.64497696;
    this.C_re[6] = 1.9660549;
    this.C_im[6] = 2.5127645;
    this.D = [];
    this.D[1] = 1.5627014243;
    this.D[2] = 0.5185406398;
    this.D[3] = -0.03333098;
    this.D[4] = -0.1052906;
    this.D[5] = -0.0368594;
    this.D[6] = 0.007317;
    this.D[7] = 0.01220;
    this.D[8] = 0.00394;
    this.D[9] = -0.0013;
}
function forward(p) {
    var n;
    var lon = p.x;
    var lat = p.y;
    var delta_lat = lat - this.lat0;
    var delta_lon = lon - this.long0;
    // 1. Calculate d_phi and d_psi    ...                          // and d_lambda
    // For this algorithm, delta_latitude is in seconds of arc x 10-5, so we need to scale to those units. Longitude is radians.
    var d_phi = delta_lat / (0, $gyVUi.SEC_TO_RAD) * 1E-5;
    var d_lambda = delta_lon;
    var d_phi_n = 1; // d_phi^0
    var d_psi = 0;
    for(n = 1; n <= 10; n++){
        d_phi_n = d_phi_n * d_phi;
        d_psi = d_psi + this.A[n] * d_phi_n;
    }
    // 2. Calculate theta
    var th_re = d_psi;
    var th_im = d_lambda;
    // 3. Calculate z
    var th_n_re = 1;
    var th_n_im = 0; // theta^0
    var th_n_re1;
    var th_n_im1;
    var z_re = 0;
    var z_im = 0;
    for(n = 1; n <= 6; n++){
        th_n_re1 = th_n_re * th_re - th_n_im * th_im;
        th_n_im1 = th_n_im * th_re + th_n_re * th_im;
        th_n_re = th_n_re1;
        th_n_im = th_n_im1;
        z_re = z_re + this.B_re[n] * th_n_re - this.B_im[n] * th_n_im;
        z_im = z_im + this.B_im[n] * th_n_re + this.B_re[n] * th_n_im;
    }
    // 4. Calculate easting and northing
    p.x = z_im * this.a + this.x0;
    p.y = z_re * this.a + this.y0;
    return p;
}
function inverse(p) {
    var n;
    var x = p.x;
    var y = p.y;
    var delta_x = x - this.x0;
    var delta_y = y - this.y0;
    // 1. Calculate z
    var z_re = delta_y / this.a;
    var z_im = delta_x / this.a;
    // 2a. Calculate theta - first approximation gives km accuracy
    var z_n_re = 1;
    var z_n_im = 0; // z^0
    var z_n_re1;
    var z_n_im1;
    var th_re = 0;
    var th_im = 0;
    for(n = 1; n <= 6; n++){
        z_n_re1 = z_n_re * z_re - z_n_im * z_im;
        z_n_im1 = z_n_im * z_re + z_n_re * z_im;
        z_n_re = z_n_re1;
        z_n_im = z_n_im1;
        th_re = th_re + this.C_re[n] * z_n_re - this.C_im[n] * z_n_im;
        th_im = th_im + this.C_im[n] * z_n_re + this.C_re[n] * z_n_im;
    }
    // 2b. Iterate to refine the accuracy of the calculation
    //        0 iterations gives km accuracy
    //        1 iteration gives m accuracy -- good enough for most mapping applications
    //        2 iterations bives mm accuracy
    for(var i = 0; i < this.iterations; i++){
        var th_n_re = th_re;
        var th_n_im = th_im;
        var th_n_re1;
        var th_n_im1;
        var num_re = z_re;
        var num_im = z_im;
        for(n = 2; n <= 6; n++){
            th_n_re1 = th_n_re * th_re - th_n_im * th_im;
            th_n_im1 = th_n_im * th_re + th_n_re * th_im;
            th_n_re = th_n_re1;
            th_n_im = th_n_im1;
            num_re = num_re + (n - 1) * (this.B_re[n] * th_n_re - this.B_im[n] * th_n_im);
            num_im = num_im + (n - 1) * (this.B_im[n] * th_n_re + this.B_re[n] * th_n_im);
        }
        th_n_re = 1;
        th_n_im = 0;
        var den_re = this.B_re[1];
        var den_im = this.B_im[1];
        for(n = 2; n <= 6; n++){
            th_n_re1 = th_n_re * th_re - th_n_im * th_im;
            th_n_im1 = th_n_im * th_re + th_n_re * th_im;
            th_n_re = th_n_re1;
            th_n_im = th_n_im1;
            den_re = den_re + n * (this.B_re[n] * th_n_re - this.B_im[n] * th_n_im);
            den_im = den_im + n * (this.B_im[n] * th_n_re + this.B_re[n] * th_n_im);
        }
        // Complex division
        var den2 = den_re * den_re + den_im * den_im;
        th_re = (num_re * den_re + num_im * den_im) / den2;
        th_im = (num_im * den_re - num_re * den_im) / den2;
    }
    // 3. Calculate d_phi              ...                                    // and d_lambda
    var d_psi = th_re;
    var d_lambda = th_im;
    var d_psi_n = 1; // d_psi^0
    var d_phi = 0;
    for(n = 1; n <= 9; n++){
        d_psi_n = d_psi_n * d_psi;
        d_phi = d_phi + this.D[n] * d_psi_n;
    }
    // 4. Calculate latitude and longitude
    // d_phi is calcuated in second of arc * 10^-5, so we need to scale back to radians. d_lambda is in radians.
    var lat = this.lat0 + d_phi * (0, $gyVUi.SEC_TO_RAD) * 1E5;
    var lon = this.long0 + d_lambda;
    p.x = lon;
    p.y = lat;
    return p;
}
var names = [
    "New_Zealand_Map_Grid",
    "nzmg"
];
var $4d7dc5ed367b221e$export$2e2bcd8739ae039 = {
    init: init,
    forward: forward,
    inverse: inverse,
    names: names
};

});

// Core OpenLayers

/**
 * @module ol/Map
 */ /**
 * @module ol/Collection
 */ /**
 * @module ol/CollectionEventType
 */ /**
 * @enum {string}
 */ var $161dd067fe2d672c$export$2e2bcd8739ae039 = {
    /**
   * Triggered when an item is added to the collection.
   * @event module:ol/Collection.CollectionEvent#add
   * @api
   */ ADD: 'add',
    /**
   * Triggered when an item is removed from the collection.
   * @event module:ol/Collection.CollectionEvent#remove
   * @api
   */ REMOVE: 'remove'
};


/**
 * @module ol/Object
 */ /**
 * @module ol/ObjectEventType
 */ /**
 * @enum {string}
 */ var $e881b5dca21eb5d4$export$2e2bcd8739ae039 /**
 * @typedef {'propertychange'} Types
 */  = {
    /**
   * Triggered when a property is changed.
   * @event module:ol/Object.ObjectEvent#propertychange
   * @api
   */ PROPERTYCHANGE: 'propertychange'
};


/**
 * @module ol/Observable
 */ /**
 * @module ol/events/EventType
 */ /**
 * @enum {string}
 * @const
 */ var $294047c5e65f31a3$export$2e2bcd8739ae039 = {
    /**
   * Generic change event. Triggered when the revision counter is increased.
   * @event module:ol/events/Event~BaseEvent#change
   * @api
   */ CHANGE: 'change',
    /**
   * Generic error event. Triggered when an error occurs.
   * @event module:ol/events/Event~BaseEvent#error
   * @api
   */ ERROR: 'error',
    BLUR: 'blur',
    CLEAR: 'clear',
    CONTEXTMENU: 'contextmenu',
    CLICK: 'click',
    DBLCLICK: 'dblclick',
    DRAGENTER: 'dragenter',
    DRAGOVER: 'dragover',
    DROP: 'drop',
    FOCUS: 'focus',
    KEYDOWN: 'keydown',
    KEYPRESS: 'keypress',
    LOAD: 'load',
    RESIZE: 'resize',
    TOUCHMOVE: 'touchmove',
    WHEEL: 'wheel'
};


/**
 * @module ol/events/Target
 */ /**
 * @module ol/Disposable
 */ /**
 * @classdesc
 * Objects that need to clean up after themselves.
 */ class $3273ed08087da3da$var$Disposable {
    constructor(){
        /**
     * The object has already been disposed.
     * @type {boolean}
     * @protected
     */ this.disposed = false;
    }
    /**
   * Clean up.
   */ dispose() {
        if (!this.disposed) {
            this.disposed = true;
            this.disposeInternal();
        }
    }
    /**
   * Extension point for disposable objects.
   * @protected
   */ disposeInternal() {}
}
var $3273ed08087da3da$export$2e2bcd8739ae039 = $3273ed08087da3da$var$Disposable;


/**
 * @module ol/functions
 */ /**
 * @module ol/array
 */ /**
 * Performs a binary search on the provided sorted list and returns the index of the item if found. If it can't be found it'll return -1.
 * https://github.com/darkskyapp/binary-search
 *
 * @param {Array<*>} haystack Items to search through.
 * @param {*} needle The item to look for.
 * @param {Function} [comparator] Comparator function.
 * @return {number} The index of the item if found, -1 if not.
 */ function $b998d41b678ed5d1$export$2e0ae67339d5f1ac(haystack, needle, comparator) {
    let mid, cmp;
    comparator = comparator || $b998d41b678ed5d1$export$fcb633242ef15540;
    let low = 0;
    let high = haystack.length;
    let found = false;
    while(low < high){
        /* Note that "(low + high) >>> 1" may overflow, and results in a typecast
     * to double (which gives the wrong results). */ mid = low + (high - low >> 1);
        cmp = +comparator(haystack[mid], needle);
        if (cmp < 0.0) /* Too low. */ low = mid + 1;
        else {
            /* Key found or too high */ high = mid;
            found = !cmp;
        }
    }
    /* Key not found. */ return found ? low : ~low;
}
function $b998d41b678ed5d1$export$fcb633242ef15540(a, b) {
    return a > b ? 1 : a < b ? -1 : 0;
}
function $b998d41b678ed5d1$export$4fa3190a997c3d8f(a, b) {
    return a < b ? 1 : a > b ? -1 : 0;
}
function $b998d41b678ed5d1$export$8a3786cc03fdb777(arr, target, direction) {
    if (arr[0] <= target) return 0;
    const n = arr.length;
    if (target <= arr[n - 1]) return n - 1;
    if (typeof direction === 'function') {
        for(let i = 1; i < n; ++i){
            const candidate = arr[i];
            if (candidate === target) return i;
            if (candidate < target) {
                if (direction(target, arr[i - 1], candidate) > 0) return i - 1;
                return i;
            }
        }
        return n - 1;
    }
    if (direction > 0) {
        for(let i = 1; i < n; ++i){
            if (arr[i] < target) return i - 1;
        }
        return n - 1;
    }
    if (direction < 0) {
        for(let i = 1; i < n; ++i){
            if (arr[i] <= target) return i;
        }
        return n - 1;
    }
    for(let i = 1; i < n; ++i){
        if (arr[i] == target) return i;
        if (arr[i] < target) {
            if (arr[i - 1] - target < target - arr[i]) return i - 1;
            return i;
        }
    }
    return n - 1;
}
function $b998d41b678ed5d1$export$292cfa960964f0e0(arr, begin, end) {
    while(begin < end){
        const tmp = arr[begin];
        arr[begin] = arr[end];
        arr[end] = tmp;
        ++begin;
        --end;
    }
}
function $b998d41b678ed5d1$export$8b58be045bf06082(arr, data) {
    const extension = Array.isArray(data) ? data : [
        data
    ];
    const length = extension.length;
    for(let i = 0; i < length; i++)arr[arr.length] = extension[i];
}
function $b998d41b678ed5d1$export$cd7f480d6b8286c3(arr, obj) {
    const i = arr.indexOf(obj);
    const found = i > -1;
    if (found) arr.splice(i, 1);
    return found;
}
function $b998d41b678ed5d1$export$e9bab7fafb253603(arr1, arr2) {
    const len1 = arr1.length;
    if (len1 !== arr2.length) return false;
    for(let i = 0; i < len1; i++){
        if (arr1[i] !== arr2[i]) return false;
    }
    return true;
}
function $b998d41b678ed5d1$export$c7d3d1f96a700512(arr, compareFnc) {
    const length = arr.length;
    const tmp = Array(arr.length);
    let i;
    for(i = 0; i < length; i++)tmp[i] = {
        index: i,
        value: arr[i]
    };
    tmp.sort(function(a, b) {
        return compareFnc(a.value, b.value) || a.index - b.index;
    });
    for(i = 0; i < arr.length; i++)arr[i] = tmp[i].value;
}
function $b998d41b678ed5d1$export$efa610630f9e181(arr, func, strict) {
    const compare = func || $b998d41b678ed5d1$export$fcb633242ef15540;
    return arr.every(function(currentVal, index) {
        if (index === 0) return true;
        const res = compare(arr[index - 1], currentVal);
        return !(res > 0 || strict && res === 0);
    });
}


function $013a1733c226ec50$export$22e23a2304399231() {
    return true;
}
function $013a1733c226ec50$export$8f11cee4bdc7e668() {
    return false;
}
function $013a1733c226ec50$export$1cd1943b3a73bbe8() {}
function $013a1733c226ec50$export$ff83df6f9971435f(fn) {
    /** @type {ReturnType} */ let lastResult;
    /** @type {Array<any>|undefined} */ let lastArgs;
    let lastThis;
    /**
   * @this {*} Only need to know if `this` changed, don't care what type
   * @return {ReturnType} Memoized value
   */ return function() {
        const nextArgs = Array.prototype.slice.call(arguments);
        if (!lastArgs || this !== lastThis || !(0, $b998d41b678ed5d1$export$e9bab7fafb253603)(nextArgs, lastArgs)) {
            lastThis = this;
            lastArgs = nextArgs;
            lastResult = fn.apply(this, arguments);
        }
        return lastResult;
    };
}
function $013a1733c226ec50$export$4dbaaf6c79705e6c(getter) {
    function promiseGetter() {
        let value;
        try {
            value = getter();
        } catch (err) {
            return Promise.reject(err);
        }
        if (value instanceof Promise) return value;
        return Promise.resolve(value);
    }
    return promiseGetter();
}


/**
 * @module ol/obj
 */ /**
 * Removes all properties from an object.
 * @param {Object<string, unknown>} object The object to clear.
 */ function $beaefe87199bb537$export$42ffd38884aecdac(object) {
    for(const property in object)delete object[property];
}
function $beaefe87199bb537$export$dd1bc94b04021eeb(object) {
    let property;
    for(property in object)return false;
    return !property;
}


/**
 * @module ol/events/Event
 */ /**
 * @classdesc
 * Stripped down implementation of the W3C DOM Level 2 Event interface.
 * See https://www.w3.org/TR/DOM-Level-2-Events/events.html#Events-interface.
 *
 * This implementation only provides `type` and `target` properties, and
 * `stopPropagation` and `preventDefault` methods. It is meant as base class
 * for higher level events defined in the library, and works with
 * {@link module:ol/events/Target~Target}.
 */ class $aeedce20e9577100$var$BaseEvent {
    /**
   * @param {string} type Type.
   */ constructor(type){
        /**
     * @type {boolean}
     */ this.propagationStopped;
        /**
     * @type {boolean}
     */ this.defaultPrevented;
        /**
     * The event type.
     * @type {string}
     * @api
     */ this.type = type;
        /**
     * The event target.
     * @type {Object}
     * @api
     */ this.target = null;
    }
    /**
   * Prevent default. This means that no emulated `click`, `singleclick` or `doubleclick` events
   * will be fired.
   * @api
   */ preventDefault() {
        this.defaultPrevented = true;
    }
    /**
   * Stop event propagation.
   * @api
   */ stopPropagation() {
        this.propagationStopped = true;
    }
}
function $aeedce20e9577100$export$51134cce184326b9(evt) {
    evt.stopPropagation();
}
function $aeedce20e9577100$export$fa3b29edae795ef4(evt) {
    evt.preventDefault();
}
var $aeedce20e9577100$export$2e2bcd8739ae039 = $aeedce20e9577100$var$BaseEvent;


/**
 * @typedef {EventTarget|Target} EventTargetLike
 */ /**
 * @classdesc
 * A simplified implementation of the W3C DOM Level 2 EventTarget interface.
 * See https://www.w3.org/TR/2000/REC-DOM-Level-2-Events-20001113/events.html#Events-EventTarget.
 *
 * There are two important simplifications compared to the specification:
 *
 * 1. The handling of `useCapture` in `addEventListener` and
 *    `removeEventListener`. There is no real capture model.
 * 2. The handling of `stopPropagation` and `preventDefault` on `dispatchEvent`.
 *    There is no event target hierarchy. When a listener calls
 *    `stopPropagation` or `preventDefault` on an event object, it means that no
 *    more listeners after this one will be called. Same as when the listener
 *    returns false.
 */ class $08c28d22c0cb5a39$var$Target extends (0, $3273ed08087da3da$export$2e2bcd8739ae039) {
    /**
   * @param {*} [target] Default event target for dispatched events.
   */ constructor(target){
        super();
        /**
     * @private
     * @type {*}
     */ this.eventTarget_ = target;
        /**
     * @private
     * @type {Object<string, number>|null}
     */ this.pendingRemovals_ = null;
        /**
     * @private
     * @type {Object<string, number>|null}
     */ this.dispatching_ = null;
        /**
     * @private
     * @type {Object<string, Array<import("../events.js").Listener>>|null}
     */ this.listeners_ = null;
    }
    /**
   * @param {string} type Type.
   * @param {import("../events.js").Listener} listener Listener.
   */ addEventListener(type, listener) {
        if (!type || !listener) return;
        const listeners = this.listeners_ || (this.listeners_ = {});
        const listenersForType = listeners[type] || (listeners[type] = []);
        if (!listenersForType.includes(listener)) listenersForType.push(listener);
    }
    /**
   * Dispatches an event and calls all listeners listening for events
   * of this type. The event parameter can either be a string or an
   * Object with a `type` property.
   *
   * @param {import("./Event.js").default|string} event Event object.
   * @return {boolean|undefined} `false` if anyone called preventDefault on the
   *     event object or if any of the listeners returned false.
   * @api
   */ dispatchEvent(event) {
        const isString = typeof event === 'string';
        const type = isString ? event : event.type;
        const listeners = this.listeners_ && this.listeners_[type];
        if (!listeners) return;
        const evt = isString ? new (0, $aeedce20e9577100$export$2e2bcd8739ae039)(event) : /** @type {Event} */ event;
        if (!evt.target) evt.target = this.eventTarget_ || this;
        const dispatching = this.dispatching_ || (this.dispatching_ = {});
        const pendingRemovals = this.pendingRemovals_ || (this.pendingRemovals_ = {});
        if (!(type in dispatching)) {
            dispatching[type] = 0;
            pendingRemovals[type] = 0;
        }
        ++dispatching[type];
        let propagate;
        for(let i = 0, ii = listeners.length; i < ii; ++i){
            if ('handleEvent' in listeners[i]) propagate = /** @type {import("../events.js").ListenerObject} */ listeners[i].handleEvent(evt);
            else propagate = /** @type {import("../events.js").ListenerFunction} */ listeners[i].call(this, evt);
            if (propagate === false || evt.propagationStopped) {
                propagate = false;
                break;
            }
        }
        if (--dispatching[type] === 0) {
            let pr = pendingRemovals[type];
            delete pendingRemovals[type];
            while(pr--)this.removeEventListener(type, (0, $013a1733c226ec50$export$1cd1943b3a73bbe8));
            delete dispatching[type];
        }
        return propagate;
    }
    /**
   * Clean up.
   * @override
   */ disposeInternal() {
        this.listeners_ && (0, $beaefe87199bb537$export$42ffd38884aecdac)(this.listeners_);
    }
    /**
   * Get the listeners for a specified event type. Listeners are returned in the
   * order that they will be called in.
   *
   * @param {string} type Type.
   * @return {Array<import("../events.js").Listener>|undefined} Listeners.
   */ getListeners(type) {
        return this.listeners_ && this.listeners_[type] || undefined;
    }
    /**
   * @param {string} [type] Type. If not provided,
   *     `true` will be returned if this event target has any listeners.
   * @return {boolean} Has listeners.
   */ hasListener(type) {
        if (!this.listeners_) return false;
        return type ? type in this.listeners_ : Object.keys(this.listeners_).length > 0;
    }
    /**
   * @param {string} type Type.
   * @param {import("../events.js").Listener} listener Listener.
   */ removeEventListener(type, listener) {
        if (!this.listeners_) return;
        const listeners = this.listeners_[type];
        if (!listeners) return;
        const index = listeners.indexOf(listener);
        if (index !== -1) {
            if (this.pendingRemovals_ && type in this.pendingRemovals_) {
                // make listener a no-op, and remove later in #dispatchEvent()
                listeners[index] = (0, $013a1733c226ec50$export$1cd1943b3a73bbe8);
                ++this.pendingRemovals_[type];
            } else {
                listeners.splice(index, 1);
                if (listeners.length === 0) delete this.listeners_[type];
            }
        }
    }
}
var $08c28d22c0cb5a39$export$2e2bcd8739ae039 = $08c28d22c0cb5a39$var$Target;


/**
 * @module ol/events
 */ 
function $d5bf8abd656a3cdc$export$63174c828edd6ff8(target, type, listener, thisArg, once) {
    if (once) {
        const originalListener = listener;
        /**
     * @param {Event|import('./events/Event.js').default} event The event
     * @return {void|boolean} When the function returns `false`, event propagation will stop.
     * @this {typeof target}
     */ listener = function(event) {
            target.removeEventListener(type, listener);
            return originalListener.call(thisArg ?? this, event);
        };
    } else if (thisArg && thisArg !== target) listener = listener.bind(thisArg);
    const eventsKey = {
        target: target,
        type: type,
        listener: listener
    };
    target.addEventListener(type, listener);
    return eventsKey;
}
function $d5bf8abd656a3cdc$export$8d2a95bc11b44725(target, type, listener, thisArg) {
    return $d5bf8abd656a3cdc$export$63174c828edd6ff8(target, type, listener, thisArg, true);
}
function $d5bf8abd656a3cdc$export$b0a21c8b3c1c921(key) {
    if (key && key.target) {
        key.target.removeEventListener(key.type, key.listener);
        (0, $beaefe87199bb537$export$42ffd38884aecdac)(key);
    }
}


/***
 * @template {string} Type
 * @template {Event|import("./events/Event.js").default} EventClass
 * @template Return
 * @typedef {(type: Type, listener: (event: EventClass) => ?) => Return} OnSignature
 */ /***
 * @template {string} Type
 * @template Return
 * @typedef {(type: Type[], listener: (event: Event|import("./events/Event").default) => ?) => Return extends void ? void : Return[]} CombinedOnSignature
 */ /**
 * @typedef {'change'|'error'} EventTypes
 */ /***
 * @template Return
 * @typedef {OnSignature<EventTypes, import("./events/Event.js").default, Return> & CombinedOnSignature<EventTypes, Return>} ObservableOnSignature
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * An event target providing convenient methods for listener registration
 * and unregistration. A generic `change` event is always available through
 * {@link module:ol/Observable~Observable#changed}.
 *
 * @fires import("./events/Event.js").default
 * @api
 */ class $1f093ab5083c8a1f$var$Observable extends (0, $08c28d22c0cb5a39$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.on = /** @type {ObservableOnSignature<import("./events").EventsKey>} */ this.onInternal;
        this.once = /** @type {ObservableOnSignature<import("./events").EventsKey>} */ this.onceInternal;
        this.un = /** @type {ObservableOnSignature<void>} */ this.unInternal;
        /**
     * @private
     * @type {number}
     */ this.revision_ = 0;
    }
    /**
   * Increases the revision counter and dispatches a 'change' event.
   * @api
   */ changed() {
        ++this.revision_;
        this.dispatchEvent((0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE);
    }
    /**
   * Get the version number for this object.  Each time the object is modified,
   * its version number will be incremented.
   * @return {number} Revision.
   * @api
   */ getRevision() {
        return this.revision_;
    }
    /**
   * @param {string|Array<string>} type Type.
   * @param {function((Event|import("./events/Event").default)): ?} listener Listener.
   * @return {import("./events.js").EventsKey|Array<import("./events.js").EventsKey>} Event key.
   * @protected
   */ onInternal(type, listener) {
        if (Array.isArray(type)) {
            const len = type.length;
            const keys = new Array(len);
            for(let i = 0; i < len; ++i)keys[i] = (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(this, type[i], listener);
            return keys;
        }
        return (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(this, /** @type {string} */ type, listener);
    }
    /**
   * @param {string|Array<string>} type Type.
   * @param {function((Event|import("./events/Event").default)): ?} listener Listener.
   * @return {import("./events.js").EventsKey|Array<import("./events.js").EventsKey>} Event key.
   * @protected
   */ onceInternal(type, listener) {
        let key;
        if (Array.isArray(type)) {
            const len = type.length;
            key = new Array(len);
            for(let i = 0; i < len; ++i)key[i] = (0, $d5bf8abd656a3cdc$export$8d2a95bc11b44725)(this, type[i], listener);
        } else key = (0, $d5bf8abd656a3cdc$export$8d2a95bc11b44725)(this, /** @type {string} */ type, listener);
        /** @type {Object} */ listener.ol_key = key;
        return key;
    }
    /**
   * Unlisten for a certain type of event.
   * @param {string|Array<string>} type Type.
   * @param {function((Event|import("./events/Event").default)): ?} listener Listener.
   * @protected
   */ unInternal(type, listener) {
        const key = /** @type {Object} */ listener.ol_key;
        if (key) $1f093ab5083c8a1f$export$b7ef3f8527533384(key);
        else if (Array.isArray(type)) for(let i = 0, ii = type.length; i < ii; ++i)this.removeEventListener(type[i], listener);
        else this.removeEventListener(type, listener);
    }
}
/**
 * Listen for a certain type of event.
 * @function
 * @param {string|Array<string>} type The event type or array of event types.
 * @param {function((Event|import("./events/Event").default)): ?} listener The listener function.
 * @return {import("./events.js").EventsKey|Array<import("./events.js").EventsKey>} Unique key for the listener. If
 *     called with an array of event types as the first argument, the return
 *     will be an array of keys.
 * @api
 */ $1f093ab5083c8a1f$var$Observable.prototype.on;
/**
 * Listen once for a certain type of event.
 * @function
 * @param {string|Array<string>} type The event type or array of event types.
 * @param {function((Event|import("./events/Event").default)): ?} listener The listener function.
 * @return {import("./events.js").EventsKey|Array<import("./events.js").EventsKey>} Unique key for the listener. If
 *     called with an array of event types as the first argument, the return
 *     will be an array of keys.
 * @api
 */ $1f093ab5083c8a1f$var$Observable.prototype.once;
/**
 * Unlisten for a certain type of event.
 * @function
 * @param {string|Array<string>} type The event type or array of event types.
 * @param {function((Event|import("./events/Event").default)): ?} listener The listener function.
 * @api
 */ $1f093ab5083c8a1f$var$Observable.prototype.un;
function $1f093ab5083c8a1f$export$b7ef3f8527533384(key) {
    if (Array.isArray(key)) for(let i = 0, ii = key.length; i < ii; ++i)(0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921)(key[i]);
    else (0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921)(/** @type {import("./events.js").EventsKey} */ key);
}
var $1f093ab5083c8a1f$export$2e2bcd8739ae039 = $1f093ab5083c8a1f$var$Observable;




/**
 * @module ol/util
 */ /**
 * @return {never} Any return.
 */ function $6c5e11070e371322$export$817eb92a8194bab0() {
    throw new Error('Unimplemented abstract method.');
}
/**
 * Counter for getUid.
 * @type {number}
 * @private
 */ let $6c5e11070e371322$var$uidCounter_ = 0;
function $6c5e11070e371322$export$5e82334337e0f204(obj) {
    return obj.ol_uid || (obj.ol_uid = String(++$6c5e11070e371322$var$uidCounter_));
}
const $6c5e11070e371322$export$a4ad2735b021c132 = '10.6.1';


class $b68b3d6e32e3074a$export$cf395d7c4a2d5a17 extends (0, $aeedce20e9577100$export$2e2bcd8739ae039) {
    /**
   * @param {string} type The event type.
   * @param {string} key The property name.
   * @param {*} oldValue The old value for `key`.
   */ constructor(type, key, oldValue){
        super(type);
        /**
     * The name of the property whose value is changing.
     * @type {string}
     * @api
     */ this.key = key;
        /**
     * The old value. To get the new value use `e.target.get(e.key)` where
     * `e` is the event object.
     * @type {*}
     * @api
     */ this.oldValue = oldValue;
    }
}
/***
 * @template Return
 * @typedef {import("./Observable").OnSignature<import("./Observable").EventTypes, import("./events/Event.js").default, Return> &
 *    import("./Observable").OnSignature<import("./ObjectEventType").Types, ObjectEvent, Return> &
 *    import("./Observable").CombinedOnSignature<import("./Observable").EventTypes|import("./ObjectEventType").Types, Return>} ObjectOnSignature
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Most non-trivial classes inherit from this.
 *
 * This extends {@link module:ol/Observable~Observable} with observable
 * properties, where each property is observable as well as the object as a
 * whole.
 *
 * Classes that inherit from this have pre-defined properties, to which you can
 * add your owns. The pre-defined properties are listed in this documentation as
 * 'Observable Properties', and have their own accessors; for example,
 * {@link module:ol/Map~Map} has a `target` property, accessed with
 * `getTarget()` and changed with `setTarget()`. Not all properties are however
 * settable. There are also general-purpose accessors `get()` and `set()`. For
 * example, `get('target')` is equivalent to `getTarget()`.
 *
 * The `set` accessors trigger a change event, and you can monitor this by
 * registering a listener. For example, {@link module:ol/View~View} has a
 * `center` property, so `view.on('change:center', function(evt) {...});` would
 * call the function whenever the value of the center property changes. Within
 * the function, `evt.target` would be the view, so `evt.target.getCenter()`
 * would return the new center.
 *
 * You can add your own observable properties with
 * `object.set('prop', 'value')`, and retrieve that with `object.get('prop')`.
 * You can listen for changes on that property value with
 * `object.on('change:prop', listener)`. You can get a list of all
 * properties with {@link module:ol/Object~BaseObject#getProperties}.
 *
 * Note that the observable properties are separate from standard JS properties.
 * You can, for example, give your map object a title with
 * `map.title='New title'` and with `map.set('title', 'Another title')`. The
 * first will be a `hasOwnProperty`; the second will appear in
 * `getProperties()`. Only the second is observable.
 *
 * Properties can be deleted by using the unset method. E.g.
 * object.unset('foo').
 *
 * @fires ObjectEvent
 * @api
 */ class $b68b3d6e32e3074a$var$BaseObject extends (0, $1f093ab5083c8a1f$export$2e2bcd8739ae039) {
    /**
   * @param {Object<string, *>} [values] An object with key-value pairs.
   */ constructor(values){
        super();
        /***
     * @type {ObjectOnSignature<import("./events").EventsKey>}
     */ this.on;
        /***
     * @type {ObjectOnSignature<import("./events").EventsKey>}
     */ this.once;
        /***
     * @type {ObjectOnSignature<void>}
     */ this.un;
        // Call {@link module:ol/util.getUid} to ensure that the order of objects' ids is
        // the same as the order in which they were created.  This also helps to
        // ensure that object properties are always added in the same order, which
        // helps many JavaScript engines generate faster code.
        (0, $6c5e11070e371322$export$5e82334337e0f204)(this);
        /**
     * @private
     * @type {Object<string, *>|null}
     */ this.values_ = null;
        if (values !== undefined) this.setProperties(values);
    }
    /**
   * Gets a value.
   * @param {string} key Key name.
   * @return {*} Value.
   * @api
   */ get(key) {
        let value;
        if (this.values_ && this.values_.hasOwnProperty(key)) value = this.values_[key];
        return value;
    }
    /**
   * Get a list of object property names.
   * @return {Array<string>} List of property names.
   * @api
   */ getKeys() {
        return this.values_ && Object.keys(this.values_) || [];
    }
    /**
   * Get an object of all property names and values.
   * @return {Object<string, *>} Object.
   * @api
   */ getProperties() {
        return this.values_ && Object.assign({}, this.values_) || {};
    }
    /**
   * Get an object of all property names and values.
   * @return {Object<string, *>?} Object.
   */ getPropertiesInternal() {
        return this.values_;
    }
    /**
   * @return {boolean} The object has properties.
   */ hasProperties() {
        return !!this.values_;
    }
    /**
   * @param {string} key Key name.
   * @param {*} oldValue Old value.
   */ notify(key, oldValue) {
        let eventType;
        eventType = `change:${key}`;
        if (this.hasListener(eventType)) this.dispatchEvent(new $b68b3d6e32e3074a$export$cf395d7c4a2d5a17(eventType, key, oldValue));
        eventType = (0, $e881b5dca21eb5d4$export$2e2bcd8739ae039).PROPERTYCHANGE;
        if (this.hasListener(eventType)) this.dispatchEvent(new $b68b3d6e32e3074a$export$cf395d7c4a2d5a17(eventType, key, oldValue));
    }
    /**
   * @param {string} key Key name.
   * @param {import("./events.js").Listener} listener Listener.
   */ addChangeListener(key, listener) {
        this.addEventListener(`change:${key}`, listener);
    }
    /**
   * @param {string} key Key name.
   * @param {import("./events.js").Listener} listener Listener.
   */ removeChangeListener(key, listener) {
        this.removeEventListener(`change:${key}`, listener);
    }
    /**
   * Sets a value.
   * @param {string} key Key name.
   * @param {*} value Value.
   * @param {boolean} [silent] Update without triggering an event.
   * @api
   */ set(key, value, silent) {
        const values = this.values_ || (this.values_ = {});
        if (silent) values[key] = value;
        else {
            const oldValue = values[key];
            values[key] = value;
            if (oldValue !== value) this.notify(key, oldValue);
        }
    }
    /**
   * Sets a collection of key-value pairs.  Note that this changes any existing
   * properties and adds new ones (it does not remove any existing properties).
   * @param {Object<string, *>} values Values.
   * @param {boolean} [silent] Update without triggering an event.
   * @api
   */ setProperties(values, silent) {
        for(const key in values)this.set(key, values[key], silent);
    }
    /**
   * Apply any properties from another object without triggering events.
   * @param {BaseObject} source The source object.
   * @protected
   */ applyProperties(source) {
        if (!source.values_) return;
        Object.assign(this.values_ || (this.values_ = {}), source.values_);
    }
    /**
   * Unsets a property.
   * @param {string} key Key name.
   * @param {boolean} [silent] Unset without triggering an event.
   * @api
   */ unset(key, silent) {
        if (this.values_ && key in this.values_) {
            const oldValue = this.values_[key];
            delete this.values_[key];
            if ((0, $beaefe87199bb537$export$dd1bc94b04021eeb)(this.values_)) this.values_ = null;
            if (!silent) this.notify(key, oldValue);
        }
    }
}
var $b68b3d6e32e3074a$export$2e2bcd8739ae039 = $b68b3d6e32e3074a$var$BaseObject;



/**
 * @enum {string}
 * @private
 */ const $931ffc4e747c14db$var$Property = {
    LENGTH: 'length'
};
class $931ffc4e747c14db$export$a87ae6eb2761ec6d extends (0, $aeedce20e9577100$export$2e2bcd8739ae039) {
    /**
   * @param {import("./CollectionEventType.js").default} type Type.
   * @param {T} element Element.
   * @param {number} index The index of the added or removed element.
   */ constructor(type, element, index){
        super(type);
        /**
     * The element that is added to or removed from the collection.
     * @type {T}
     * @api
     */ this.element = element;
        /**
     * The index of the added or removed element.
     * @type {number}
     * @api
     */ this.index = index;
    }
}
/***
 * @template T
 * @template Return
 * @typedef {import("./Observable").OnSignature<import("./Observable").EventTypes, import("./events/Event.js").default, Return> &
 *   import("./Observable").OnSignature<import("./ObjectEventType").Types|'change:length', import("./Object").ObjectEvent, Return> &
 *   import("./Observable").OnSignature<'add'|'remove', CollectionEvent<T>, Return> &
 *   import("./Observable").CombinedOnSignature<import("./Observable").EventTypes|import("./ObjectEventType").Types|
 *     'change:length'|'add'|'remove',Return>} CollectionOnSignature
 */ /**
 * @typedef {Object} Options
 * @property {boolean} [unique=false] Disallow the same item from being added to
 * the collection twice.
 */ /**
 * @classdesc
 * An expanded version of standard JS Array, adding convenience methods for
 * manipulation. Add and remove changes to the Collection trigger a Collection
 * event. Note that this does not cover changes to the objects _within_ the
 * Collection; they trigger events on the appropriate object, not on the
 * Collection as a whole.
 *
 * @fires CollectionEvent
 *
 * @template T
 * @api
 */ class $931ffc4e747c14db$var$Collection extends (0, $b68b3d6e32e3074a$export$2e2bcd8739ae039) {
    /**
   * @param {Array<T>} [array] Array.
   * @param {Options} [options] Collection options.
   */ constructor(array, options){
        super();
        /***
     * @type {CollectionOnSignature<T, import("./events").EventsKey>}
     */ this.on;
        /***
     * @type {CollectionOnSignature<T, import("./events").EventsKey>}
     */ this.once;
        /***
     * @type {CollectionOnSignature<T, void>}
     */ this.un;
        options = options || {};
        /**
     * @private
     * @type {boolean}
     */ this.unique_ = !!options.unique;
        /**
     * @private
     * @type {!Array<T>}
     */ this.array_ = array ? array : [];
        if (this.unique_) for(let i = 0, ii = this.array_.length; i < ii; ++i)this.assertUnique_(this.array_[i], i);
        this.updateLength_();
    }
    /**
   * Remove all elements from the collection.
   * @api
   */ clear() {
        while(this.getLength() > 0)this.pop();
    }
    /**
   * Add elements to the collection.  This pushes each item in the provided array
   * to the end of the collection.
   * @param {!Array<T>} arr Array.
   * @return {Collection<T>} This collection.
   * @api
   */ extend(arr) {
        for(let i = 0, ii = arr.length; i < ii; ++i)this.push(arr[i]);
        return this;
    }
    /**
   * Iterate over each element, calling the provided callback.
   * @param {function(T, number, Array<T>): *} f The function to call
   *     for every element. This function takes 3 arguments (the element, the
   *     index and the array). The return value is ignored.
   * @api
   */ forEach(f) {
        const array = this.array_;
        for(let i = 0, ii = array.length; i < ii; ++i)f(array[i], i, array);
    }
    /**
   * Get a reference to the underlying Array object. Warning: if the array
   * is mutated, no events will be dispatched by the collection, and the
   * collection's "length" property won't be in sync with the actual length
   * of the array.
   * @return {!Array<T>} Array.
   * @api
   */ getArray() {
        return this.array_;
    }
    /**
   * Get the element at the provided index.
   * @param {number} index Index.
   * @return {T} Element.
   * @api
   */ item(index) {
        return this.array_[index];
    }
    /**
   * Get the length of this collection.
   * @return {number} The length of the array.
   * @observable
   * @api
   */ getLength() {
        return this.get($931ffc4e747c14db$var$Property.LENGTH);
    }
    /**
   * Insert an element at the provided index.
   * @param {number} index Index.
   * @param {T} elem Element.
   * @api
   */ insertAt(index, elem) {
        if (index < 0 || index > this.getLength()) throw new Error('Index out of bounds: ' + index);
        if (this.unique_) this.assertUnique_(elem);
        this.array_.splice(index, 0, elem);
        this.updateLength_();
        this.dispatchEvent(new $931ffc4e747c14db$export$a87ae6eb2761ec6d((0, $161dd067fe2d672c$export$2e2bcd8739ae039).ADD, elem, index));
    }
    /**
   * Remove the last element of the collection and return it.
   * Return `undefined` if the collection is empty.
   * @return {T|undefined} Element.
   * @api
   */ pop() {
        return this.removeAt(this.getLength() - 1);
    }
    /**
   * Insert the provided element at the end of the collection.
   * @param {T} elem Element.
   * @return {number} New length of the collection.
   * @api
   */ push(elem) {
        if (this.unique_) this.assertUnique_(elem);
        const n = this.getLength();
        this.insertAt(n, elem);
        return this.getLength();
    }
    /**
   * Remove the first occurrence of an element from the collection.
   * @param {T} elem Element.
   * @return {T|undefined} The removed element or undefined if none found.
   * @api
   */ remove(elem) {
        const arr = this.array_;
        for(let i = 0, ii = arr.length; i < ii; ++i){
            if (arr[i] === elem) return this.removeAt(i);
        }
        return undefined;
    }
    /**
   * Remove the element at the provided index and return it.
   * Return `undefined` if the collection does not contain this index.
   * @param {number} index Index.
   * @return {T|undefined} Value.
   * @api
   */ removeAt(index) {
        if (index < 0 || index >= this.getLength()) return undefined;
        const prev = this.array_[index];
        this.array_.splice(index, 1);
        this.updateLength_();
        this.dispatchEvent(/** @type {CollectionEvent<T>} */ new $931ffc4e747c14db$export$a87ae6eb2761ec6d((0, $161dd067fe2d672c$export$2e2bcd8739ae039).REMOVE, prev, index));
        return prev;
    }
    /**
   * Set the element at the provided index.
   * @param {number} index Index.
   * @param {T} elem Element.
   * @api
   */ setAt(index, elem) {
        const n = this.getLength();
        if (index >= n) {
            this.insertAt(index, elem);
            return;
        }
        if (index < 0) throw new Error('Index out of bounds: ' + index);
        if (this.unique_) this.assertUnique_(elem, index);
        const prev = this.array_[index];
        this.array_[index] = elem;
        this.dispatchEvent(/** @type {CollectionEvent<T>} */ new $931ffc4e747c14db$export$a87ae6eb2761ec6d((0, $161dd067fe2d672c$export$2e2bcd8739ae039).REMOVE, prev, index));
        this.dispatchEvent(/** @type {CollectionEvent<T>} */ new $931ffc4e747c14db$export$a87ae6eb2761ec6d((0, $161dd067fe2d672c$export$2e2bcd8739ae039).ADD, elem, index));
    }
    /**
   * @private
   */ updateLength_() {
        this.set($931ffc4e747c14db$var$Property.LENGTH, this.array_.length);
    }
    /**
   * @private
   * @param {T} elem Element.
   * @param {number} [except] Optional index to ignore.
   */ assertUnique_(elem, except) {
        for(let i = 0, ii = this.array_.length; i < ii; ++i){
            if (this.array_[i] === elem && i !== except) throw new Error('Duplicate item added to a unique collection');
        }
    }
}
var $931ffc4e747c14db$export$2e2bcd8739ae039 = $931ffc4e747c14db$var$Collection;



/**
 * @module ol/MapBrowserEvent
 */ /**
 * @module ol/MapEvent
 */ 
/**
 * @classdesc
 * Events emitted as map events are instances of this type.
 * See {@link module:ol/Map~Map} for which events trigger a map event.
 */ class $3a171922c3a0c5ed$var$MapEvent extends (0, $aeedce20e9577100$export$2e2bcd8739ae039) {
    /**
   * @param {string} type Event type.
   * @param {import("./Map.js").default} map Map.
   * @param {?import("./Map.js").FrameState} [frameState] Frame state.
   */ constructor(type, map, frameState){
        super(type);
        /**
     * The map where the event occurred.
     * @type {import("./Map.js").default}
     * @api
     */ this.map = map;
        /**
     * The frame state at the time of the event.
     * @type {?import("./Map.js").FrameState}
     * @api
     */ this.frameState = frameState !== undefined ? frameState : null;
    }
}
var $3a171922c3a0c5ed$export$2e2bcd8739ae039 = $3a171922c3a0c5ed$var$MapEvent;


/**
 * @classdesc
 * Events emitted as map browser events are instances of this type.
 * See {@link module:ol/Map~Map} for which events trigger a map browser event.
 * @template {PointerEvent|KeyboardEvent|WheelEvent} [EVENT=PointerEvent|KeyboardEvent|WheelEvent]
 */ class $a1b91f073c6a6c43$var$MapBrowserEvent extends (0, $3a171922c3a0c5ed$export$2e2bcd8739ae039) {
    /**
   * @param {string} type Event type.
   * @param {import("./Map.js").default} map Map.
   * @param {EVENT} originalEvent Original event.
   * @param {boolean} [dragging] Is the map currently being dragged?
   * @param {import("./Map.js").FrameState} [frameState] Frame state.
   * @param {Array<PointerEvent>} [activePointers] Active pointers.
   */ constructor(type, map, originalEvent, dragging, frameState, activePointers){
        super(type, map, frameState);
        /**
     * The original browser event.
     * @const
     * @type {EVENT}
     * @api
     */ this.originalEvent = originalEvent;
        /**
     * The map pixel relative to the viewport corresponding to the original browser event.
     * @type {?import("./pixel.js").Pixel}
     * @private
     */ this.pixel_ = null;
        /**
     * The coordinate in the user projection corresponding to the original browser event.
     * @type {?import("./coordinate.js").Coordinate}
     * @private
     */ this.coordinate_ = null;
        /**
     * Indicates if the map is currently being dragged. Only set for
     * `POINTERDRAG` and `POINTERMOVE` events. Default is `false`.
     *
     * @type {boolean}
     * @api
     */ this.dragging = dragging !== undefined ? dragging : false;
        /**
     * @type {Array<PointerEvent>|undefined}
     */ this.activePointers = activePointers;
    }
    /**
   * The map pixel relative to the viewport corresponding to the original event.
   * @type {import("./pixel.js").Pixel}
   * @api
   */ get pixel() {
        if (!this.pixel_) this.pixel_ = this.map.getEventPixel(this.originalEvent);
        return this.pixel_;
    }
    set pixel(pixel) {
        this.pixel_ = pixel;
    }
    /**
   * The coordinate corresponding to the original browser event.  This will be in the user
   * projection if one is set.  Otherwise it will be in the view projection.
   * @type {import("./coordinate.js").Coordinate}
   * @api
   */ get coordinate() {
        if (!this.coordinate_) this.coordinate_ = this.map.getCoordinateFromPixel(this.pixel);
        return this.coordinate_;
    }
    set coordinate(coordinate) {
        this.coordinate_ = coordinate;
    }
    /**
   * Prevents the default browser action.
   * See https://developer.mozilla.org/en-US/docs/Web/API/event.preventDefault.
   * @api
   * @override
   */ preventDefault() {
        super.preventDefault();
        if ('preventDefault' in this.originalEvent) /** @type {UIEvent} */ this.originalEvent.preventDefault();
    }
    /**
   * Prevents further propagation of the current event.
   * See https://developer.mozilla.org/en-US/docs/Web/API/event.stopPropagation.
   * @api
   * @override
   */ stopPropagation() {
        super.stopPropagation();
        if ('stopPropagation' in this.originalEvent) /** @type {UIEvent} */ this.originalEvent.stopPropagation();
    }
}
var $a1b91f073c6a6c43$export$2e2bcd8739ae039 = $a1b91f073c6a6c43$var$MapBrowserEvent;


/**
 * @module ol/MapBrowserEventHandler
 */ 
/**
 * @module ol/MapBrowserEventType
 */ 
var /**
 * Constants for event names.
 * @enum {string}
 */ $150f412a4a7fa263$export$2e2bcd8739ae039 /***
 * @typedef {'singleclick'|'click'|'dblclick'|'pointerdrag'|'pointermove'} Types
 */  = {
    /**
   * A true single click with no dragging and no double click. Note that this
   * event is delayed by 250 ms to ensure that it is not a double click.
   * @event module:ol/MapBrowserEvent~MapBrowserEvent#singleclick
   * @api
   */ SINGLECLICK: 'singleclick',
    /**
   * A click with no dragging. A double click will fire two of this.
   * @event module:ol/MapBrowserEvent~MapBrowserEvent#click
   * @api
   */ CLICK: (0, $294047c5e65f31a3$export$2e2bcd8739ae039).CLICK,
    /**
   * A true double click, with no dragging.
   * @event module:ol/MapBrowserEvent~MapBrowserEvent#dblclick
   * @api
   */ DBLCLICK: (0, $294047c5e65f31a3$export$2e2bcd8739ae039).DBLCLICK,
    /**
   * Triggered when a pointer is dragged.
   * @event module:ol/MapBrowserEvent~MapBrowserEvent#pointerdrag
   * @api
   */ POINTERDRAG: 'pointerdrag',
    /**
   * Triggered when a pointer is moved. Note that on touch devices this is
   * triggered when the map is panned, so is not the same as mousemove.
   * @event module:ol/MapBrowserEvent~MapBrowserEvent#pointermove
   * @api
   */ POINTERMOVE: 'pointermove',
    POINTERDOWN: 'pointerdown',
    POINTERUP: 'pointerup',
    POINTEROVER: 'pointerover',
    POINTEROUT: 'pointerout',
    POINTERENTER: 'pointerenter',
    POINTERLEAVE: 'pointerleave',
    POINTERCANCEL: 'pointercancel'
};





/**
 * @module ol/has
 */ const $67c66761d21428d0$var$ua = typeof navigator !== 'undefined' && typeof navigator.userAgent !== 'undefined' ? navigator.userAgent.toLowerCase() : '';
const $67c66761d21428d0$export$3227bfbdaa9275de = $67c66761d21428d0$var$ua.includes('safari') && !$67c66761d21428d0$var$ua.includes('chrom');
const $67c66761d21428d0$export$b23eed0e325a206a = $67c66761d21428d0$export$3227bfbdaa9275de && ($67c66761d21428d0$var$ua.includes('version/15.4') || /cpu (os|iphone os) 15_4 like mac os x/.test($67c66761d21428d0$var$ua));
const $67c66761d21428d0$export$39dfd62a25e0fe93 = $67c66761d21428d0$var$ua.includes('webkit') && !$67c66761d21428d0$var$ua.includes('edge');
const $67c66761d21428d0$export$76c0a3b101d93136 = $67c66761d21428d0$var$ua.includes('macintosh');
const $67c66761d21428d0$export$6b83a0446fc26f94 = typeof devicePixelRatio !== 'undefined' ? devicePixelRatio : 1;
const $67c66761d21428d0$export$98fcef3dc9973292 = typeof WorkerGlobalScope !== 'undefined' && typeof OffscreenCanvas !== 'undefined' && self instanceof WorkerGlobalScope; //eslint-disable-line
const $67c66761d21428d0$export$716f8695eedb9bad = typeof Image !== 'undefined' && Image.prototype.decode;
const $67c66761d21428d0$export$7478563940788376 = typeof createImageBitmap === 'function';
const $67c66761d21428d0$export$f751ce96c6c4e4fc = function() {
    let passive = false;
    try {
        const options = Object.defineProperty({}, 'passive', {
            get: function() {
                passive = true;
            }
        });
        // @ts-ignore Ignore invalid event type '_'
        window.addEventListener('_', null, options);
        // @ts-ignore Ignore invalid event type '_'
        window.removeEventListener('_', null, options);
    } catch  {
    // passive not supported
    }
    return passive;
}();


/**
 * @module ol/pointer/EventType
 */ /**
 * Constants for event names.
 * @enum {string}
 */ var $d564567e31203d44$export$2e2bcd8739ae039 = {
    POINTERMOVE: 'pointermove',
    POINTERDOWN: 'pointerdown',
    POINTERUP: 'pointerup',
    POINTEROVER: 'pointerover',
    POINTEROUT: 'pointerout',
    POINTERENTER: 'pointerenter',
    POINTERLEAVE: 'pointerleave',
    POINTERCANCEL: 'pointercancel'
};


class $6085d006f9d0efe2$var$MapBrowserEventHandler extends (0, $08c28d22c0cb5a39$export$2e2bcd8739ae039) {
    /**
   * @param {import("./Map.js").default} map The map with the viewport to listen to events on.
   * @param {number} [moveTolerance] The minimal distance the pointer must travel to trigger a move.
   */ constructor(map, moveTolerance){
        super(map);
        /**
     * This is the element that we will listen to the real events on.
     * @type {import("./Map.js").default}
     * @private
     */ this.map_ = map;
        /**
     * @type {ReturnType<typeof setTimeout>}
     * @private
     */ this.clickTimeoutId_;
        /**
     * Emulate dblclick and singleclick. Will be true when only one pointer is active.
     * @type {boolean}
     */ this.emulateClicks_ = false;
        /**
     * @type {boolean}
     * @private
     */ this.dragging_ = false;
        /**
     * @type {!Array<import("./events.js").EventsKey>}
     * @private
     */ this.dragListenerKeys_ = [];
        /**
     * @type {number}
     * @private
     */ this.moveTolerance_ = moveTolerance === undefined ? 1 : moveTolerance;
        /**
     * The most recent "down" type event (or null if none have occurred).
     * Set on pointerdown.
     * @type {PointerEvent|null}
     * @private
     */ this.down_ = null;
        const element = this.map_.getViewport();
        /**
     * @type {Array<PointerEvent>}
     * @private
     */ this.activePointers_ = [];
        /**
     * @type {!Object<number, Event>}
     * @private
     */ this.trackedTouches_ = {};
        /**
     * @private
     */ this.element_ = element;
        /**
     * @type {?import("./events.js").EventsKey}
     * @private
     */ this.pointerdownListenerKey_ = (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(element, (0, $d564567e31203d44$export$2e2bcd8739ae039).POINTERDOWN, this.handlePointerDown_, this);
        /**
     * @type {PointerEvent}
     * @private
     */ this.originalPointerMoveEvent_;
        /**
     * @type {?import("./events.js").EventsKey}
     * @private
     */ this.relayedListenerKey_ = (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(element, (0, $d564567e31203d44$export$2e2bcd8739ae039).POINTERMOVE, this.relayMoveEvent_, this);
        /**
     * @private
     */ this.boundHandleTouchMove_ = this.handleTouchMove_.bind(this);
        this.element_.addEventListener((0, $294047c5e65f31a3$export$2e2bcd8739ae039).TOUCHMOVE, this.boundHandleTouchMove_, (0, $67c66761d21428d0$export$f751ce96c6c4e4fc) ? {
            passive: false
        } : false);
    }
    /**
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @private
   */ emulateClick_(pointerEvent) {
        let newEvent = new (0, $a1b91f073c6a6c43$export$2e2bcd8739ae039)((0, $150f412a4a7fa263$export$2e2bcd8739ae039).CLICK, this.map_, pointerEvent);
        this.dispatchEvent(newEvent);
        if (this.clickTimeoutId_ !== undefined) {
            // double-click
            clearTimeout(this.clickTimeoutId_);
            this.clickTimeoutId_ = undefined;
            newEvent = new (0, $a1b91f073c6a6c43$export$2e2bcd8739ae039)((0, $150f412a4a7fa263$export$2e2bcd8739ae039).DBLCLICK, this.map_, pointerEvent);
            this.dispatchEvent(newEvent);
        } else // click
        this.clickTimeoutId_ = setTimeout(()=>{
            this.clickTimeoutId_ = undefined;
            const newEvent = new (0, $a1b91f073c6a6c43$export$2e2bcd8739ae039)((0, $150f412a4a7fa263$export$2e2bcd8739ae039).SINGLECLICK, this.map_, pointerEvent);
            this.dispatchEvent(newEvent);
        }, 250);
    }
    /**
   * Keeps track on how many pointers are currently active.
   *
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @private
   */ updateActivePointers_(pointerEvent) {
        const event = pointerEvent;
        const id = event.pointerId;
        if (event.type == (0, $150f412a4a7fa263$export$2e2bcd8739ae039).POINTERUP || event.type == (0, $150f412a4a7fa263$export$2e2bcd8739ae039).POINTERCANCEL) {
            delete this.trackedTouches_[id];
            for(const pointerId in this.trackedTouches_)if (this.trackedTouches_[pointerId].target !== event.target) {
                // Some platforms assign a new pointerId when the target changes.
                // If this happens, delete one tracked pointer. If there is more
                // than one tracked pointer for the old target, it will be cleared
                // by subsequent POINTERUP events from other pointers.
                delete this.trackedTouches_[pointerId];
                break;
            }
        } else if (event.type == (0, $150f412a4a7fa263$export$2e2bcd8739ae039).POINTERDOWN || event.type == (0, $150f412a4a7fa263$export$2e2bcd8739ae039).POINTERMOVE) this.trackedTouches_[id] = event;
        this.activePointers_ = Object.values(this.trackedTouches_);
    }
    /**
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @private
   */ handlePointerUp_(pointerEvent) {
        this.updateActivePointers_(pointerEvent);
        const newEvent = new (0, $a1b91f073c6a6c43$export$2e2bcd8739ae039)((0, $150f412a4a7fa263$export$2e2bcd8739ae039).POINTERUP, this.map_, pointerEvent, undefined, undefined, this.activePointers_);
        this.dispatchEvent(newEvent);
        // We emulate click events on left mouse button click, touch contact, and pen
        // contact. isMouseActionButton returns true in these cases (evt.button is set
        // to 0).
        // See http://www.w3.org/TR/pointerevents/#button-states
        // We only fire click, singleclick, and doubleclick if nobody has called
        // event.preventDefault().
        if (this.emulateClicks_ && !newEvent.defaultPrevented && !this.dragging_ && this.isMouseActionButton_(pointerEvent)) this.emulateClick_(this.down_);
        if (this.activePointers_.length === 0) {
            this.dragListenerKeys_.forEach((0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921));
            this.dragListenerKeys_.length = 0;
            this.dragging_ = false;
            this.down_ = null;
        }
    }
    /**
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @return {boolean} If the left mouse button was pressed.
   * @private
   */ isMouseActionButton_(pointerEvent) {
        return pointerEvent.button === 0;
    }
    /**
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @private
   */ handlePointerDown_(pointerEvent) {
        this.emulateClicks_ = this.activePointers_.length === 0;
        this.updateActivePointers_(pointerEvent);
        const newEvent = new (0, $a1b91f073c6a6c43$export$2e2bcd8739ae039)((0, $150f412a4a7fa263$export$2e2bcd8739ae039).POINTERDOWN, this.map_, pointerEvent, undefined, undefined, this.activePointers_);
        this.dispatchEvent(newEvent);
        this.down_ = new PointerEvent(pointerEvent.type, pointerEvent);
        Object.defineProperty(this.down_, 'target', {
            writable: false,
            value: pointerEvent.target
        });
        if (this.dragListenerKeys_.length === 0) {
            const doc = this.map_.getOwnerDocument();
            this.dragListenerKeys_.push((0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(doc, (0, $150f412a4a7fa263$export$2e2bcd8739ae039).POINTERMOVE, this.handlePointerMove_, this), (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(doc, (0, $150f412a4a7fa263$export$2e2bcd8739ae039).POINTERUP, this.handlePointerUp_, this), /* Note that the listener for `pointercancel is set up on
         * `pointerEventHandler_` and not `documentPointerEventHandler_` like
         * the `pointerup` and `pointermove` listeners.
         *
         * The reason for this is the following: `TouchSource.vacuumTouches_()`
         * issues `pointercancel` events, when there was no `touchend` for a
         * `touchstart`. Now, let's say a first `touchstart` is registered on
         * `pointerEventHandler_`. The `documentPointerEventHandler_` is set up.
         * But `documentPointerEventHandler_` doesn't know about the first
         * `touchstart`. If there is no `touchend` for the `touchstart`, we can
         * only receive a `touchcancel` from `pointerEventHandler_`, because it is
         * only registered there.
         */ (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(this.element_, (0, $150f412a4a7fa263$export$2e2bcd8739ae039).POINTERCANCEL, this.handlePointerUp_, this));
            if (this.element_.getRootNode && this.element_.getRootNode() !== doc) this.dragListenerKeys_.push((0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(this.element_.getRootNode(), (0, $150f412a4a7fa263$export$2e2bcd8739ae039).POINTERUP, this.handlePointerUp_, this));
        }
    }
    /**
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @private
   */ handlePointerMove_(pointerEvent) {
        // Between pointerdown and pointerup, pointermove events are triggered.
        // To avoid a 'false' touchmove event to be dispatched, we test if the pointer
        // moved a significant distance.
        if (this.isMoving_(pointerEvent)) {
            this.updateActivePointers_(pointerEvent);
            this.dragging_ = true;
            const newEvent = new (0, $a1b91f073c6a6c43$export$2e2bcd8739ae039)((0, $150f412a4a7fa263$export$2e2bcd8739ae039).POINTERDRAG, this.map_, pointerEvent, this.dragging_, undefined, this.activePointers_);
            this.dispatchEvent(newEvent);
        }
    }
    /**
   * Wrap and relay a pointermove event.
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @private
   */ relayMoveEvent_(pointerEvent) {
        this.originalPointerMoveEvent_ = pointerEvent;
        const dragging = !!(this.down_ && this.isMoving_(pointerEvent));
        this.dispatchEvent(new (0, $a1b91f073c6a6c43$export$2e2bcd8739ae039)((0, $150f412a4a7fa263$export$2e2bcd8739ae039).POINTERMOVE, this.map_, pointerEvent, dragging));
    }
    /**
   * Flexible handling of a `touch-action: none` css equivalent: because calling
   * `preventDefault()` on a `pointermove` event does not stop native page scrolling
   * and zooming, we also listen for `touchmove` and call `preventDefault()` on it
   * when an interaction (currently `DragPan` handles the event.
   * @param {TouchEvent} event Event.
   * @private
   */ handleTouchMove_(event) {
        // Due to https://github.com/mpizenberg/elm-pep/issues/2, `this.originalPointerMoveEvent_`
        // may not be initialized yet when we get here on a platform without native pointer events,
        // when elm-pep is used as pointer events polyfill.
        const originalEvent = this.originalPointerMoveEvent_;
        if ((!originalEvent || originalEvent.defaultPrevented) && (typeof event.cancelable !== 'boolean' || event.cancelable === true)) event.preventDefault();
    }
    /**
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @return {boolean} Is moving.
   * @private
   */ isMoving_(pointerEvent) {
        return this.dragging_ || Math.abs(pointerEvent.clientX - this.down_.clientX) > this.moveTolerance_ || Math.abs(pointerEvent.clientY - this.down_.clientY) > this.moveTolerance_;
    }
    /**
   * Clean up.
   * @override
   */ disposeInternal() {
        if (this.relayedListenerKey_) {
            (0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921)(this.relayedListenerKey_);
            this.relayedListenerKey_ = null;
        }
        this.element_.removeEventListener((0, $294047c5e65f31a3$export$2e2bcd8739ae039).TOUCHMOVE, this.boundHandleTouchMove_);
        if (this.pointerdownListenerKey_) {
            (0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921)(this.pointerdownListenerKey_);
            this.pointerdownListenerKey_ = null;
        }
        this.dragListenerKeys_.forEach((0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921));
        this.dragListenerKeys_.length = 0;
        this.element_ = null;
        super.disposeInternal();
    }
}
var $6085d006f9d0efe2$export$2e2bcd8739ae039 = $6085d006f9d0efe2$var$MapBrowserEventHandler;




/**
 * @module ol/MapEventType
 */ /**
 * @enum {string}
 */ var $e4ad75f913b6f7ff$export$2e2bcd8739ae039 /***
 * @typedef {'postrender'|'movestart'|'moveend'|'loadstart'|'loadend'} Types
 */  = {
    /**
   * Triggered after a map frame is rendered.
   * @event module:ol/MapEvent~MapEvent#postrender
   * @api
   */ POSTRENDER: 'postrender',
    /**
   * Triggered when the map starts moving.
   * @event module:ol/MapEvent~MapEvent#movestart
   * @api
   */ MOVESTART: 'movestart',
    /**
   * Triggered after the map is moved.
   * @event module:ol/MapEvent~MapEvent#moveend
   * @api
   */ MOVEEND: 'moveend',
    /**
   * Triggered when loading of additional map data (tiles, images, features) starts.
   * @event module:ol/MapEvent~MapEvent#loadstart
   * @api
   */ LOADSTART: 'loadstart',
    /**
   * Triggered when loading of additional map data has completed.
   * @event module:ol/MapEvent~MapEvent#loadend
   * @api
   */ LOADEND: 'loadend'
};


/**
 * @module ol/MapProperty
 */ /**
 * @enum {string}
 */ var $07fa325567004bb7$export$2e2bcd8739ae039 = {
    LAYERGROUP: 'layergroup',
    SIZE: 'size',
    TARGET: 'target',
    VIEW: 'view'
};




/**
 * @module ol/TileQueue
 */ /**
 * @module ol/TileState
 */ /**
 * @enum {number}
 */ var $b8291d9739c3c64e$export$2e2bcd8739ae039 = {
    IDLE: 0,
    LOADING: 1,
    LOADED: 2,
    /**
   * Indicates that tile loading failed
   * @type {number}
   */ ERROR: 3,
    EMPTY: 4
};



/**
 * @module ol/structs/PriorityQueue
 */ /**
 * @module ol/asserts
 */ /**
 * @param {*} assertion Assertion we expected to be truthy.
 * @param {string} errorMessage Error message.
 */ function $35d5ec884318008e$export$a7a9523472993e97(assertion, errorMessage) {
    if (!assertion) throw new Error(errorMessage);
}



const $716c6804ea170b71$export$b4af72c40fd57063 = Infinity;
/**
 * @classdesc
 * Priority queue.
 *
 * The implementation is inspired from the Closure Library's Heap class and
 * Python's heapq module.
 *
 * See https://github.com/google/closure-library/blob/master/closure/goog/structs/heap.js
 * and https://hg.python.org/cpython/file/2.7/Lib/heapq.py.
 *
 * @template T
 */ class $716c6804ea170b71$var$PriorityQueue {
    /**
   * @param {function(T): number} priorityFunction Priority function.
   * @param {function(T): string} keyFunction Key function.
   */ constructor(priorityFunction, keyFunction){
        /**
     * @type {function(T): number}
     * @private
     */ this.priorityFunction_ = priorityFunction;
        /**
     * @type {function(T): string}
     * @private
     */ this.keyFunction_ = keyFunction;
        /**
     * @type {Array<T>}
     * @private
     */ this.elements_ = [];
        /**
     * @type {Array<number>}
     * @private
     */ this.priorities_ = [];
        /**
     * @type {!Object<string, boolean>}
     * @private
     */ this.queuedElements_ = {};
    }
    /**
   * FIXME empty description for jsdoc
   */ clear() {
        this.elements_.length = 0;
        this.priorities_.length = 0;
        (0, $beaefe87199bb537$export$42ffd38884aecdac)(this.queuedElements_);
    }
    /**
   * Remove and return the highest-priority element. O(log N).
   * @return {T} Element.
   */ dequeue() {
        const elements = this.elements_;
        const priorities = this.priorities_;
        const element = elements[0];
        if (elements.length == 1) {
            elements.length = 0;
            priorities.length = 0;
        } else {
            elements[0] = /** @type {T} */ elements.pop();
            priorities[0] = /** @type {number} */ priorities.pop();
            this.siftUp_(0);
        }
        const elementKey = this.keyFunction_(element);
        delete this.queuedElements_[elementKey];
        return element;
    }
    /**
   * Enqueue an element. O(log N).
   * @param {T} element Element.
   * @return {boolean} The element was added to the queue.
   */ enqueue(element) {
        (0, $35d5ec884318008e$export$a7a9523472993e97)(!(this.keyFunction_(element) in this.queuedElements_), 'Tried to enqueue an `element` that was already added to the queue');
        const priority = this.priorityFunction_(element);
        if (priority != $716c6804ea170b71$export$b4af72c40fd57063) {
            this.elements_.push(element);
            this.priorities_.push(priority);
            this.queuedElements_[this.keyFunction_(element)] = true;
            this.siftDown_(0, this.elements_.length - 1);
            return true;
        }
        return false;
    }
    /**
   * @return {number} Count.
   */ getCount() {
        return this.elements_.length;
    }
    /**
   * Gets the index of the left child of the node at the given index.
   * @param {number} index The index of the node to get the left child for.
   * @return {number} The index of the left child.
   * @private
   */ getLeftChildIndex_(index) {
        return index * 2 + 1;
    }
    /**
   * Gets the index of the right child of the node at the given index.
   * @param {number} index The index of the node to get the right child for.
   * @return {number} The index of the right child.
   * @private
   */ getRightChildIndex_(index) {
        return index * 2 + 2;
    }
    /**
   * Gets the index of the parent of the node at the given index.
   * @param {number} index The index of the node to get the parent for.
   * @return {number} The index of the parent.
   * @private
   */ getParentIndex_(index) {
        return index - 1 >> 1;
    }
    /**
   * Make this a heap. O(N).
   * @private
   */ heapify_() {
        let i;
        for(i = (this.elements_.length >> 1) - 1; i >= 0; i--)this.siftUp_(i);
    }
    /**
   * @return {boolean} Is empty.
   */ isEmpty() {
        return this.elements_.length === 0;
    }
    /**
   * @param {string} key Key.
   * @return {boolean} Is key queued.
   */ isKeyQueued(key) {
        return key in this.queuedElements_;
    }
    /**
   * @param {T} element Element.
   * @return {boolean} Is queued.
   */ isQueued(element) {
        return this.isKeyQueued(this.keyFunction_(element));
    }
    /**
   * @param {number} index The index of the node to move down.
   * @private
   */ siftUp_(index) {
        const elements = this.elements_;
        const priorities = this.priorities_;
        const count = elements.length;
        const element = elements[index];
        const priority = priorities[index];
        const startIndex = index;
        while(index < count >> 1){
            const lIndex = this.getLeftChildIndex_(index);
            const rIndex = this.getRightChildIndex_(index);
            const smallerChildIndex = rIndex < count && priorities[rIndex] < priorities[lIndex] ? rIndex : lIndex;
            elements[index] = elements[smallerChildIndex];
            priorities[index] = priorities[smallerChildIndex];
            index = smallerChildIndex;
        }
        elements[index] = element;
        priorities[index] = priority;
        this.siftDown_(startIndex, index);
    }
    /**
   * @param {number} startIndex The index of the root.
   * @param {number} index The index of the node to move up.
   * @private
   */ siftDown_(startIndex, index) {
        const elements = this.elements_;
        const priorities = this.priorities_;
        const element = elements[index];
        const priority = priorities[index];
        while(index > startIndex){
            const parentIndex = this.getParentIndex_(index);
            if (priorities[parentIndex] > priority) {
                elements[index] = elements[parentIndex];
                priorities[index] = priorities[parentIndex];
                index = parentIndex;
            } else break;
        }
        elements[index] = element;
        priorities[index] = priority;
    }
    /**
   * FIXME empty description for jsdoc
   */ reprioritize() {
        const priorityFunction = this.priorityFunction_;
        const elements = this.elements_;
        const priorities = this.priorities_;
        let index = 0;
        const n = elements.length;
        let element, i, priority;
        for(i = 0; i < n; ++i){
            element = elements[i];
            priority = priorityFunction(element);
            if (priority == $716c6804ea170b71$export$b4af72c40fd57063) delete this.queuedElements_[this.keyFunction_(element)];
            else {
                priorities[index] = priority;
                elements[index++] = element;
            }
        }
        elements.length = index;
        priorities.length = index;
        this.heapify_();
    }
}
var $716c6804ea170b71$export$2e2bcd8739ae039 = $716c6804ea170b71$var$PriorityQueue;


/**
 * @typedef {function(import("./Tile.js").default, string, import('./tilecoord.js').TileCoord, number): number} PriorityFunction
 */ /**
 * @typedef {[import('./Tile.js').default, string, import('./tilecoord.js').TileCoord, number]} TileQueueElement
 */ /**
 * @extends PriorityQueue<TileQueueElement>}
 */ class $4c51fd53052a6bbc$var$TileQueue extends (0, $716c6804ea170b71$export$2e2bcd8739ae039) {
    /**
   * @param {PriorityFunction} tilePriorityFunction Tile priority function.
   * @param {function(): ?} tileChangeCallback Function called on each tile change event.
   */ constructor(tilePriorityFunction, tileChangeCallback){
        super((element)=>tilePriorityFunction.apply(null, element), (element)=>element[0].getKey());
        /** @private */ this.boundHandleTileChange_ = this.handleTileChange.bind(this);
        /**
     * @private
     * @type {function(): ?}
     */ this.tileChangeCallback_ = tileChangeCallback;
        /**
     * @private
     * @type {number}
     */ this.tilesLoading_ = 0;
        /**
     * @private
     * @type {!Object<string,boolean>}
     */ this.tilesLoadingKeys_ = {};
    }
    /**
   * @param {TileQueueElement} element Element.
   * @return {boolean} The element was added to the queue.
   * @override
   */ enqueue(element) {
        const added = super.enqueue(element);
        if (added) {
            const tile = element[0];
            tile.addEventListener((0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE, this.boundHandleTileChange_);
        }
        return added;
    }
    /**
   * @return {number} Number of tiles loading.
   */ getTilesLoading() {
        return this.tilesLoading_;
    }
    /**
   * @param {import("./events/Event.js").default} event Event.
   * @protected
   */ handleTileChange(event) {
        const tile = /** @type {import("./Tile.js").default} */ event.target;
        const state = tile.getState();
        if (state === (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).LOADED || state === (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).ERROR || state === (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).EMPTY) {
            if (state !== (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).ERROR) tile.removeEventListener((0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE, this.boundHandleTileChange_);
            const tileKey = tile.getKey();
            if (tileKey in this.tilesLoadingKeys_) {
                delete this.tilesLoadingKeys_[tileKey];
                --this.tilesLoading_;
            }
            this.tileChangeCallback_();
        }
    }
    /**
   * @param {number} maxTotalLoading Maximum number tiles to load simultaneously.
   * @param {number} maxNewLoads Maximum number of new tiles to load.
   */ loadMoreTiles(maxTotalLoading, maxNewLoads) {
        let newLoads = 0;
        while(this.tilesLoading_ < maxTotalLoading && newLoads < maxNewLoads && this.getCount() > 0){
            const tile = this.dequeue()[0];
            const tileKey = tile.getKey();
            const state = tile.getState();
            if (state === (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).IDLE && !(tileKey in this.tilesLoadingKeys_)) {
                this.tilesLoadingKeys_[tileKey] = true;
                ++this.tilesLoading_;
                ++newLoads;
                tile.load();
            }
        }
    }
}
var $4c51fd53052a6bbc$export$2e2bcd8739ae039 = $4c51fd53052a6bbc$var$TileQueue;
function $4c51fd53052a6bbc$export$f08ad5eceeff5d45(frameState, tile, tileSourceKey, tileCenter, tileResolution) {
    // Filter out tiles at higher zoom levels than the current zoom level, or that
    // are outside the visible extent.
    if (!frameState || !(tileSourceKey in frameState.wantedTiles)) return 0, $716c6804ea170b71$export$b4af72c40fd57063;
    if (!frameState.wantedTiles[tileSourceKey][tile.getKey()]) return 0, $716c6804ea170b71$export$b4af72c40fd57063;
    // Prioritize the highest zoom level tiles closest to the focus.
    // Tiles at higher zoom levels are prioritized using Math.log(tileResolution).
    // Within a zoom level, tiles are prioritized by the distance in pixels between
    // the center of the tile and the center of the viewport.  The factor of 65536
    // means that the prioritization should behave as desired for tiles up to
    // 65536 * Math.log(2) = 45426 pixels from the focus.
    const center = frameState.viewState.center;
    const deltaX = tileCenter[0] - center[0];
    const deltaY = tileCenter[1] - center[1];
    return 65536 * Math.log(tileResolution) + Math.sqrt(deltaX * deltaX + deltaY * deltaY) / tileResolution;
}


/**
 * @module ol/View
 */ 
/**
 * @module ol/ViewHint
 */ /**
 * @enum {number}
 */ var $7d362782b4ccb93d$export$2e2bcd8739ae039 = {
    ANIMATING: 0,
    INTERACTING: 1
};


/**
 * @module ol/ViewProperty
 */ /**
 * @enum {string}
 */ var $d35baefbe89be4c5$export$2e2bcd8739ae039 = {
    CENTER: 'center',
    RESOLUTION: 'resolution',
    ROTATION: 'rotation'
};




/**
 * @module ol/centerconstraint
 */ /**
 * @module ol/math
 */ /**
 * Takes a number and clamps it to within the provided bounds.
 * @param {number} value The input number.
 * @param {number} min The minimum value to return.
 * @param {number} max The maximum value to return.
 * @return {number} The input number if it is within bounds, or the nearest
 *     number within the bounds.
 */ function $6b000a049d919fe5$export$7d15b64cf5a3a4c4(value, min, max) {
    return Math.min(Math.max(value, min), max);
}
function $6b000a049d919fe5$export$251bb0a9cef172e6(x, y, x1, y1, x2, y2) {
    const dx = x2 - x1;
    const dy = y2 - y1;
    if (dx !== 0 || dy !== 0) {
        const t = ((x - x1) * dx + (y - y1) * dy) / (dx * dx + dy * dy);
        if (t > 1) {
            x1 = x2;
            y1 = y2;
        } else if (t > 0) {
            x1 += dx * t;
            y1 += dy * t;
        }
    }
    return $6b000a049d919fe5$export$88e6ebb4fe54f538(x, y, x1, y1);
}
function $6b000a049d919fe5$export$88e6ebb4fe54f538(x1, y1, x2, y2) {
    const dx = x2 - x1;
    const dy = y2 - y1;
    return dx * dx + dy * dy;
}
function $6b000a049d919fe5$export$8240f01c446270e6(mat) {
    const n = mat.length;
    for(let i = 0; i < n; i++){
        // Find max in the i-th column (ignoring i - 1 first rows)
        let maxRow = i;
        let maxEl = Math.abs(mat[i][i]);
        for(let r = i + 1; r < n; r++){
            const absValue = Math.abs(mat[r][i]);
            if (absValue > maxEl) {
                maxEl = absValue;
                maxRow = r;
            }
        }
        if (maxEl === 0) return null; // matrix is singular
        // Swap max row with i-th (current) row
        const tmp = mat[maxRow];
        mat[maxRow] = mat[i];
        mat[i] = tmp;
        // Subtract the i-th row to make all the remaining rows 0 in the i-th column
        for(let j = i + 1; j < n; j++){
            const coef = -mat[j][i] / mat[i][i];
            for(let k = i; k < n + 1; k++)if (i == k) mat[j][k] = 0;
            else mat[j][k] += coef * mat[i][k];
        }
    }
    // Solve Ax=b for upper triangular matrix A (mat)
    const x = new Array(n);
    for(let l = n - 1; l >= 0; l--){
        x[l] = mat[l][n] / mat[l][l];
        for(let m = l - 1; m >= 0; m--)mat[m][n] -= mat[m][l] * x[l];
    }
    return x;
}
function $6b000a049d919fe5$export$56cb859c01fa134d(angleInRadians) {
    return angleInRadians * 180 / Math.PI;
}
function $6b000a049d919fe5$export$cba01ba138429a1d(angleInDegrees) {
    return angleInDegrees * Math.PI / 180;
}
function $6b000a049d919fe5$export$ba467bec01d66def(a, b) {
    const r = a % b;
    return r * b < 0 ? r + b : r;
}
function $6b000a049d919fe5$export$3a89f8d6f6bf6c9f(a, b, x) {
    return a + x * (b - a);
}
function $6b000a049d919fe5$export$a81f732198733497(n, decimals) {
    const factor = Math.pow(10, decimals);
    return Math.round(n * factor) / factor;
}
function $6b000a049d919fe5$export$2077e0241d6afd3c(n, decimals) {
    return Math.round($6b000a049d919fe5$export$a81f732198733497(n, decimals));
}
function $6b000a049d919fe5$export$a3fe094919f356fd(n, decimals) {
    return Math.floor($6b000a049d919fe5$export$a81f732198733497(n, decimals));
}
function $6b000a049d919fe5$export$803ce6b71a0a94b2(n, decimals) {
    return Math.ceil($6b000a049d919fe5$export$a81f732198733497(n, decimals));
}
function $6b000a049d919fe5$export$4997ffc0176396a6(n, min, max) {
    if (n >= min && n < max) return n;
    const range = max - min;
    return ((n - min) % range + range) % range + min;
}


function $b21a6e049949bb31$export$c2f0af2c946f6897(extent, onlyCenter, smooth) {
    return(/**
     * @param {import("./coordinate.js").Coordinate|undefined} center Center.
     * @param {number|undefined} resolution Resolution.
     * @param {import("./size.js").Size} size Viewport size; unused if `onlyCenter` was specified.
     * @param {boolean} [isMoving] True if an interaction or animation is in progress.
     * @param {Array<number>} [centerShift] Shift between map center and viewport center.
     * @return {import("./coordinate.js").Coordinate|undefined} Center.
     */ function(center, resolution, size, isMoving, centerShift) {
        if (!center) return undefined;
        if (!resolution && !onlyCenter) return center;
        const viewWidth = onlyCenter ? 0 : size[0] * resolution;
        const viewHeight = onlyCenter ? 0 : size[1] * resolution;
        const shiftX = centerShift ? centerShift[0] : 0;
        const shiftY = centerShift ? centerShift[1] : 0;
        let minX = extent[0] + viewWidth / 2 + shiftX;
        let maxX = extent[2] - viewWidth / 2 + shiftX;
        let minY = extent[1] + viewHeight / 2 + shiftY;
        let maxY = extent[3] - viewHeight / 2 + shiftY;
        // note: when zooming out of bounds, min and max values for x and y may
        // end up inverted (min > max); this has to be accounted for
        if (minX > maxX) {
            minX = (maxX + minX) / 2;
            maxX = minX;
        }
        if (minY > maxY) {
            minY = (maxY + minY) / 2;
            maxY = minY;
        }
        let x = (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(center[0], minX, maxX);
        let y = (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(center[1], minY, maxY);
        // during an interaction, allow some overscroll
        if (isMoving && smooth && resolution) {
            const ratio = 30 * resolution;
            x += -ratio * Math.log(1 + Math.max(0, minX - center[0]) / ratio) + ratio * Math.log(1 + Math.max(0, center[0] - maxX) / ratio);
            y += -ratio * Math.log(1 + Math.max(0, minY - center[1]) / ratio) + ratio * Math.log(1 + Math.max(0, center[1] - maxY) / ratio);
        }
        return [
            x,
            y
        ];
    });
}
function $b21a6e049949bb31$export$f883a24d5edde77c(center) {
    return center;
}


/**
 * @module ol/coordinate
 */ /**
 * @module ol/extent
 */ /**
 * @module ol/extent/Relationship
 */ /**
 * Relationship to an extent.
 * @enum {number}
 */ var $dab4245bc22b806c$export$2e2bcd8739ae039 = {
    UNKNOWN: 0,
    INTERSECTING: 1,
    ABOVE: 2,
    RIGHT: 4,
    BELOW: 8,
    LEFT: 16
};


function $6da4c8ed3074c92b$export$8aceca7c77505534(coordinates) {
    const extent = $6da4c8ed3074c92b$export$fe201bb3bbe031e9();
    for(let i = 0, ii = coordinates.length; i < ii; ++i)$6da4c8ed3074c92b$export$1f820e3920fa5715(extent, coordinates[i]);
    return extent;
}
/**
 * @param {Array<number>} xs Xs.
 * @param {Array<number>} ys Ys.
 * @param {Extent} [dest] Destination extent.
 * @private
 * @return {Extent} Extent.
 */ function $6da4c8ed3074c92b$var$_boundingExtentXYs(xs, ys, dest) {
    const minX = Math.min.apply(null, xs);
    const minY = Math.min.apply(null, ys);
    const maxX = Math.max.apply(null, xs);
    const maxY = Math.max.apply(null, ys);
    return $6da4c8ed3074c92b$export$958e3e1a02eac4b6(minX, minY, maxX, maxY, dest);
}
function $6da4c8ed3074c92b$export$ab1029bcae9ddb4a(extent, value, dest) {
    if (dest) {
        dest[0] = extent[0] - value;
        dest[1] = extent[1] - value;
        dest[2] = extent[2] + value;
        dest[3] = extent[3] + value;
        return dest;
    }
    return [
        extent[0] - value,
        extent[1] - value,
        extent[2] + value,
        extent[3] + value
    ];
}
function $6da4c8ed3074c92b$export$9cd59f9826255e47(extent, dest) {
    if (dest) {
        dest[0] = extent[0];
        dest[1] = extent[1];
        dest[2] = extent[2];
        dest[3] = extent[3];
        return dest;
    }
    return extent.slice();
}
function $6da4c8ed3074c92b$export$cbe64c389534206f(extent, x, y) {
    let dx, dy;
    if (x < extent[0]) dx = extent[0] - x;
    else if (extent[2] < x) dx = x - extent[2];
    else dx = 0;
    if (y < extent[1]) dy = extent[1] - y;
    else if (extent[3] < y) dy = y - extent[3];
    else dy = 0;
    return dx * dx + dy * dy;
}
function $6da4c8ed3074c92b$export$ac68c24d37ca240f(extent, coordinate) {
    return $6da4c8ed3074c92b$export$805bdfd6d6690e97(extent, coordinate[0], coordinate[1]);
}
function $6da4c8ed3074c92b$export$be866b1e0809b17e(extent1, extent2) {
    return extent1[0] <= extent2[0] && extent2[2] <= extent1[2] && extent1[1] <= extent2[1] && extent2[3] <= extent1[3];
}
function $6da4c8ed3074c92b$export$805bdfd6d6690e97(extent, x, y) {
    return extent[0] <= x && x <= extent[2] && extent[1] <= y && y <= extent[3];
}
function $6da4c8ed3074c92b$export$f97905ead28c61a8(extent, coordinate) {
    const minX = extent[0];
    const minY = extent[1];
    const maxX = extent[2];
    const maxY = extent[3];
    const x = coordinate[0];
    const y = coordinate[1];
    let relationship = (0, $dab4245bc22b806c$export$2e2bcd8739ae039).UNKNOWN;
    if (x < minX) relationship = relationship | (0, $dab4245bc22b806c$export$2e2bcd8739ae039).LEFT;
    else if (x > maxX) relationship = relationship | (0, $dab4245bc22b806c$export$2e2bcd8739ae039).RIGHT;
    if (y < minY) relationship = relationship | (0, $dab4245bc22b806c$export$2e2bcd8739ae039).BELOW;
    else if (y > maxY) relationship = relationship | (0, $dab4245bc22b806c$export$2e2bcd8739ae039).ABOVE;
    if (relationship === (0, $dab4245bc22b806c$export$2e2bcd8739ae039).UNKNOWN) relationship = (0, $dab4245bc22b806c$export$2e2bcd8739ae039).INTERSECTING;
    return relationship;
}
function $6da4c8ed3074c92b$export$fe201bb3bbe031e9() {
    return [
        Infinity,
        Infinity,
        -Infinity,
        -Infinity
    ];
}
function $6da4c8ed3074c92b$export$958e3e1a02eac4b6(minX, minY, maxX, maxY, dest) {
    if (dest) {
        dest[0] = minX;
        dest[1] = minY;
        dest[2] = maxX;
        dest[3] = maxY;
        return dest;
    }
    return [
        minX,
        minY,
        maxX,
        maxY
    ];
}
function $6da4c8ed3074c92b$export$3e2152b047719fa1(dest) {
    return $6da4c8ed3074c92b$export$958e3e1a02eac4b6(Infinity, Infinity, -Infinity, -Infinity, dest);
}
function $6da4c8ed3074c92b$export$4838bf78d04a9440(coordinate, dest) {
    const x = coordinate[0];
    const y = coordinate[1];
    return $6da4c8ed3074c92b$export$958e3e1a02eac4b6(x, y, x, y, dest);
}
function $6da4c8ed3074c92b$export$29e3ad4dbd0cb863(coordinates, dest) {
    const extent = $6da4c8ed3074c92b$export$3e2152b047719fa1(dest);
    return $6da4c8ed3074c92b$export$795cd48be4d5f252(extent, coordinates);
}
function $6da4c8ed3074c92b$export$be0ab0bf96ca59ca(flatCoordinates, offset, end, stride, dest) {
    const extent = $6da4c8ed3074c92b$export$3e2152b047719fa1(dest);
    return $6da4c8ed3074c92b$export$30570204156ffd18(extent, flatCoordinates, offset, end, stride);
}
function $6da4c8ed3074c92b$export$73b4897e93bc5c83(rings, dest) {
    const extent = $6da4c8ed3074c92b$export$3e2152b047719fa1(dest);
    return $6da4c8ed3074c92b$export$9b319549574402d7(extent, rings);
}
function $6da4c8ed3074c92b$export$e9bab7fafb253603(extent1, extent2) {
    return extent1[0] == extent2[0] && extent1[2] == extent2[2] && extent1[1] == extent2[1] && extent1[3] == extent2[3];
}
function $6da4c8ed3074c92b$export$998afeab28643bd6(extent1, extent2, tolerance) {
    return Math.abs(extent1[0] - extent2[0]) < tolerance && Math.abs(extent1[2] - extent2[2]) < tolerance && Math.abs(extent1[1] - extent2[1]) < tolerance && Math.abs(extent1[3] - extent2[3]) < tolerance;
}
function $6da4c8ed3074c92b$export$8b58be045bf06082(extent1, extent2) {
    if (extent2[0] < extent1[0]) extent1[0] = extent2[0];
    if (extent2[2] > extent1[2]) extent1[2] = extent2[2];
    if (extent2[1] < extent1[1]) extent1[1] = extent2[1];
    if (extent2[3] > extent1[3]) extent1[3] = extent2[3];
    return extent1;
}
function $6da4c8ed3074c92b$export$1f820e3920fa5715(extent, coordinate) {
    if (coordinate[0] < extent[0]) extent[0] = coordinate[0];
    if (coordinate[0] > extent[2]) extent[2] = coordinate[0];
    if (coordinate[1] < extent[1]) extent[1] = coordinate[1];
    if (coordinate[1] > extent[3]) extent[3] = coordinate[1];
}
function $6da4c8ed3074c92b$export$795cd48be4d5f252(extent, coordinates) {
    for(let i = 0, ii = coordinates.length; i < ii; ++i)$6da4c8ed3074c92b$export$1f820e3920fa5715(extent, coordinates[i]);
    return extent;
}
function $6da4c8ed3074c92b$export$30570204156ffd18(extent, flatCoordinates, offset, end, stride) {
    for(; offset < end; offset += stride)$6da4c8ed3074c92b$export$f1dab130b92b85a9(extent, flatCoordinates[offset], flatCoordinates[offset + 1]);
    return extent;
}
function $6da4c8ed3074c92b$export$9b319549574402d7(extent, rings) {
    for(let i = 0, ii = rings.length; i < ii; ++i)$6da4c8ed3074c92b$export$795cd48be4d5f252(extent, rings[i]);
    return extent;
}
function $6da4c8ed3074c92b$export$f1dab130b92b85a9(extent, x, y) {
    extent[0] = Math.min(extent[0], x);
    extent[1] = Math.min(extent[1], y);
    extent[2] = Math.max(extent[2], x);
    extent[3] = Math.max(extent[3], y);
}
function $6da4c8ed3074c92b$export$f9ed8a3d123a08e2(extent, callback) {
    let val;
    val = callback($6da4c8ed3074c92b$export$8d09f5e2e1bf560d(extent));
    if (val) return val;
    val = callback($6da4c8ed3074c92b$export$e77c1cf70445e168(extent));
    if (val) return val;
    val = callback($6da4c8ed3074c92b$export$b84fa077c8b05295(extent));
    if (val) return val;
    val = callback($6da4c8ed3074c92b$export$cb1538b07e6964ff(extent));
    if (val) return val;
    return false;
}
function $6da4c8ed3074c92b$export$520c40045967cb15(extent) {
    let area = 0;
    if (!$6da4c8ed3074c92b$export$dd1bc94b04021eeb(extent)) area = $6da4c8ed3074c92b$export$3c49c185de0c2bfc(extent) * $6da4c8ed3074c92b$export$c08559766941f856(extent);
    return area;
}
function $6da4c8ed3074c92b$export$8d09f5e2e1bf560d(extent) {
    return [
        extent[0],
        extent[1]
    ];
}
function $6da4c8ed3074c92b$export$e77c1cf70445e168(extent) {
    return [
        extent[2],
        extent[1]
    ];
}
function $6da4c8ed3074c92b$export$c91255cadecfe081(extent) {
    return [
        (extent[0] + extent[2]) / 2,
        (extent[1] + extent[3]) / 2
    ];
}
function $6da4c8ed3074c92b$export$a1cfd206661d0801(extent, corner) {
    let coordinate;
    if (corner === 'bottom-left') coordinate = $6da4c8ed3074c92b$export$8d09f5e2e1bf560d(extent);
    else if (corner === 'bottom-right') coordinate = $6da4c8ed3074c92b$export$e77c1cf70445e168(extent);
    else if (corner === 'top-left') coordinate = $6da4c8ed3074c92b$export$cb1538b07e6964ff(extent);
    else if (corner === 'top-right') coordinate = $6da4c8ed3074c92b$export$b84fa077c8b05295(extent);
    else throw new Error('Invalid corner');
    return coordinate;
}
function $6da4c8ed3074c92b$export$7d6fa884b32a3751(extent1, extent2) {
    const minX = Math.min(extent1[0], extent2[0]);
    const minY = Math.min(extent1[1], extent2[1]);
    const maxX = Math.max(extent1[2], extent2[2]);
    const maxY = Math.max(extent1[3], extent2[3]);
    return (maxX - minX) * (maxY - minY);
}
function $6da4c8ed3074c92b$export$13ba650faf8308(center, resolution, rotation, size, dest) {
    const [x0, y0, x1, y1, x2, y2, x3, y3] = $6da4c8ed3074c92b$export$4b7a6fb4002cd6ac(center, resolution, rotation, size);
    return $6da4c8ed3074c92b$export$958e3e1a02eac4b6(Math.min(x0, x1, x2, x3), Math.min(y0, y1, y2, y3), Math.max(x0, x1, x2, x3), Math.max(y0, y1, y2, y3), dest);
}
function $6da4c8ed3074c92b$export$4b7a6fb4002cd6ac(center, resolution, rotation, size) {
    const dx = resolution * size[0] / 2;
    const dy = resolution * size[1] / 2;
    const cosRotation = Math.cos(rotation);
    const sinRotation = Math.sin(rotation);
    const xCos = dx * cosRotation;
    const xSin = dx * sinRotation;
    const yCos = dy * cosRotation;
    const ySin = dy * sinRotation;
    const x = center[0];
    const y = center[1];
    return [
        x - xCos + ySin,
        y - xSin - yCos,
        x - xCos - ySin,
        y - xSin + yCos,
        x + xCos - ySin,
        y + xSin + yCos,
        x + xCos + ySin,
        y + xSin - yCos,
        x - xCos + ySin,
        y - xSin - yCos
    ];
}
function $6da4c8ed3074c92b$export$c08559766941f856(extent) {
    return extent[3] - extent[1];
}
function $6da4c8ed3074c92b$export$f3fe0e9a60cde324(extent1, extent2) {
    const intersection = $6da4c8ed3074c92b$export$72209efa88586d42(extent1, extent2);
    return $6da4c8ed3074c92b$export$520c40045967cb15(intersection);
}
function $6da4c8ed3074c92b$export$72209efa88586d42(extent1, extent2, dest) {
    const intersection = dest ? dest : $6da4c8ed3074c92b$export$fe201bb3bbe031e9();
    if ($6da4c8ed3074c92b$export$7b0a31e10bbff018(extent1, extent2)) {
        if (extent1[0] > extent2[0]) intersection[0] = extent1[0];
        else intersection[0] = extent2[0];
        if (extent1[1] > extent2[1]) intersection[1] = extent1[1];
        else intersection[1] = extent2[1];
        if (extent1[2] < extent2[2]) intersection[2] = extent1[2];
        else intersection[2] = extent2[2];
        if (extent1[3] < extent2[3]) intersection[3] = extent1[3];
        else intersection[3] = extent2[3];
    } else $6da4c8ed3074c92b$export$3e2152b047719fa1(intersection);
    return intersection;
}
function $6da4c8ed3074c92b$export$1bc603050bd777b1(extent) {
    return $6da4c8ed3074c92b$export$3c49c185de0c2bfc(extent) + $6da4c8ed3074c92b$export$c08559766941f856(extent);
}
function $6da4c8ed3074c92b$export$31b21d0167753bb4(extent) {
    return [
        extent[2] - extent[0],
        extent[3] - extent[1]
    ];
}
function $6da4c8ed3074c92b$export$cb1538b07e6964ff(extent) {
    return [
        extent[0],
        extent[3]
    ];
}
function $6da4c8ed3074c92b$export$b84fa077c8b05295(extent) {
    return [
        extent[2],
        extent[3]
    ];
}
function $6da4c8ed3074c92b$export$3c49c185de0c2bfc(extent) {
    return extent[2] - extent[0];
}
function $6da4c8ed3074c92b$export$7b0a31e10bbff018(extent1, extent2) {
    return extent1[0] <= extent2[2] && extent1[2] >= extent2[0] && extent1[1] <= extent2[3] && extent1[3] >= extent2[1];
}
function $6da4c8ed3074c92b$export$dd1bc94b04021eeb(extent) {
    return extent[2] < extent[0] || extent[3] < extent[1];
}
function $6da4c8ed3074c92b$export$6a4fe494c558c238(extent, dest) {
    if (dest) {
        dest[0] = extent[0];
        dest[1] = extent[1];
        dest[2] = extent[2];
        dest[3] = extent[3];
        return dest;
    }
    return extent;
}
function $6da4c8ed3074c92b$export$80cbab86674143b6(extent, value) {
    const deltaX = (extent[2] - extent[0]) / 2 * (value - 1);
    const deltaY = (extent[3] - extent[1]) / 2 * (value - 1);
    extent[0] -= deltaX;
    extent[2] += deltaX;
    extent[1] -= deltaY;
    extent[3] += deltaY;
}
function $6da4c8ed3074c92b$export$a6a5a7a461419425(extent, start, end) {
    let intersects = false;
    const startRel = $6da4c8ed3074c92b$export$f97905ead28c61a8(extent, start);
    const endRel = $6da4c8ed3074c92b$export$f97905ead28c61a8(extent, end);
    if (startRel === (0, $dab4245bc22b806c$export$2e2bcd8739ae039).INTERSECTING || endRel === (0, $dab4245bc22b806c$export$2e2bcd8739ae039).INTERSECTING) intersects = true;
    else {
        const minX = extent[0];
        const minY = extent[1];
        const maxX = extent[2];
        const maxY = extent[3];
        const startX = start[0];
        const startY = start[1];
        const endX = end[0];
        const endY = end[1];
        const slope = (endY - startY) / (endX - startX);
        let x, y;
        if (!!(endRel & (0, $dab4245bc22b806c$export$2e2bcd8739ae039).ABOVE) && !(startRel & (0, $dab4245bc22b806c$export$2e2bcd8739ae039).ABOVE)) {
            // potentially intersects top
            x = endX - (endY - maxY) / slope;
            intersects = x >= minX && x <= maxX;
        }
        if (!intersects && !!(endRel & (0, $dab4245bc22b806c$export$2e2bcd8739ae039).RIGHT) && !(startRel & (0, $dab4245bc22b806c$export$2e2bcd8739ae039).RIGHT)) {
            // potentially intersects right
            y = endY - (endX - maxX) * slope;
            intersects = y >= minY && y <= maxY;
        }
        if (!intersects && !!(endRel & (0, $dab4245bc22b806c$export$2e2bcd8739ae039).BELOW) && !(startRel & (0, $dab4245bc22b806c$export$2e2bcd8739ae039).BELOW)) {
            // potentially intersects bottom
            x = endX - (endY - minY) / slope;
            intersects = x >= minX && x <= maxX;
        }
        if (!intersects && !!(endRel & (0, $dab4245bc22b806c$export$2e2bcd8739ae039).LEFT) && !(startRel & (0, $dab4245bc22b806c$export$2e2bcd8739ae039).LEFT)) {
            // potentially intersects left
            y = endY - (endX - minX) * slope;
            intersects = y >= minY && y <= maxY;
        }
    }
    return intersects;
}
function $6da4c8ed3074c92b$export$9f9dcb98c894b623(extent, transformFn, dest, stops) {
    if ($6da4c8ed3074c92b$export$dd1bc94b04021eeb(extent)) return $6da4c8ed3074c92b$export$3e2152b047719fa1(dest);
    let coordinates = [];
    if (stops > 1) {
        const width = extent[2] - extent[0];
        const height = extent[3] - extent[1];
        for(let i = 0; i < stops; ++i)coordinates.push(extent[0] + width * i / stops, extent[1], extent[2], extent[1] + height * i / stops, extent[2] - width * i / stops, extent[3], extent[0], extent[3] - height * i / stops);
    } else coordinates = [
        extent[0],
        extent[1],
        extent[2],
        extent[1],
        extent[2],
        extent[3],
        extent[0],
        extent[3]
    ];
    transformFn(coordinates, coordinates, 2);
    const xs = [];
    const ys = [];
    for(let i = 0, l = coordinates.length; i < l; i += 2){
        xs.push(coordinates[i]);
        ys.push(coordinates[i + 1]);
    }
    return $6da4c8ed3074c92b$var$_boundingExtentXYs(xs, ys, dest);
}
function $6da4c8ed3074c92b$export$39a9ce3624977b84(extent, projection) {
    const projectionExtent = projection.getExtent();
    const center = $6da4c8ed3074c92b$export$c91255cadecfe081(extent);
    if (projection.canWrapX() && (center[0] < projectionExtent[0] || center[0] >= projectionExtent[2])) {
        const worldWidth = $6da4c8ed3074c92b$export$3c49c185de0c2bfc(projectionExtent);
        const worldsAway = Math.floor((center[0] - projectionExtent[0]) / worldWidth);
        const offset = worldsAway * worldWidth;
        extent[0] -= offset;
        extent[2] -= offset;
    }
    return extent;
}
function $6da4c8ed3074c92b$export$9031237f01de0947(extent, projection, multiWorld) {
    if (projection.canWrapX()) {
        const projectionExtent = projection.getExtent();
        if (!isFinite(extent[0]) || !isFinite(extent[2])) return [
            [
                projectionExtent[0],
                extent[1],
                projectionExtent[2],
                extent[3]
            ]
        ];
        $6da4c8ed3074c92b$export$39a9ce3624977b84(extent, projection);
        const worldWidth = $6da4c8ed3074c92b$export$3c49c185de0c2bfc(projectionExtent);
        if ($6da4c8ed3074c92b$export$3c49c185de0c2bfc(extent) > worldWidth && !multiWorld) // the extent wraps around on itself
        return [
            [
                projectionExtent[0],
                extent[1],
                projectionExtent[2],
                extent[3]
            ]
        ];
        if (extent[0] < projectionExtent[0]) // the extent crosses the anti meridian, so it needs to be sliced
        return [
            [
                extent[0] + worldWidth,
                extent[1],
                projectionExtent[2],
                extent[3]
            ],
            [
                projectionExtent[0],
                extent[1],
                extent[2],
                extent[3]
            ]
        ];
        if (extent[2] > projectionExtent[2]) // the extent crosses the anti meridian, so it needs to be sliced
        return [
            [
                extent[0],
                extent[1],
                projectionExtent[2],
                extent[3]
            ],
            [
                projectionExtent[0],
                extent[1],
                extent[2] - worldWidth,
                extent[3]
            ]
        ];
    }
    return [
        extent
    ];
}



/**
 * @module ol/string
 */ /**
 * @param {number} number Number to be formatted
 * @param {number} width The desired width
 * @param {number} [precision] Precision of the output string (i.e. number of decimal places)
 * @return {string} Formatted string
 */ function $ff7180bdd45ebb19$export$24be126cb0a7bbeb(number, width, precision) {
    const numberString = precision !== undefined ? number.toFixed(precision) : '' + number;
    let decimal = numberString.indexOf('.');
    decimal = decimal === -1 ? numberString.length : decimal;
    return decimal > width ? numberString : new Array(1 + width - decimal).join('0') + numberString;
}
function $ff7180bdd45ebb19$export$66e1c0999abad646(v1, v2) {
    const s1 = ('' + v1).split('.');
    const s2 = ('' + v2).split('.');
    for(let i = 0; i < Math.max(s1.length, s2.length); i++){
        const n1 = parseInt(s1[i] || '0', 10);
        const n2 = parseInt(s2[i] || '0', 10);
        if (n1 > n2) return 1;
        if (n2 > n1) return -1;
    }
    return 0;
}


function $1bd0a226f9a16141$export$e16d8520af44a096(coordinate, delta) {
    coordinate[0] += +delta[0];
    coordinate[1] += +delta[1];
    return coordinate;
}
function $1bd0a226f9a16141$export$cbe80a3fcd2b99b7(coordinate, circle) {
    const r = circle.getRadius();
    const center = circle.getCenter();
    const x0 = center[0];
    const y0 = center[1];
    const x1 = coordinate[0];
    const y1 = coordinate[1];
    let dx = x1 - x0;
    const dy = y1 - y0;
    if (dx === 0 && dy === 0) dx = 1;
    const d = Math.sqrt(dx * dx + dy * dy);
    const x = x0 + r * dx / d;
    const y = y0 + r * dy / d;
    return [
        x,
        y
    ];
}
function $1bd0a226f9a16141$export$18cdd31d17f97131(coordinate, segment) {
    const x0 = coordinate[0];
    const y0 = coordinate[1];
    const start = segment[0];
    const end = segment[1];
    const x1 = start[0];
    const y1 = start[1];
    const x2 = end[0];
    const y2 = end[1];
    const dx = x2 - x1;
    const dy = y2 - y1;
    const along = dx === 0 && dy === 0 ? 0 : (dx * (x0 - x1) + dy * (y0 - y1)) / (dx * dx + dy * dy || 0);
    let x, y;
    if (along <= 0) {
        x = x1;
        y = y1;
    } else if (along >= 1) {
        x = x2;
        y = y2;
    } else {
        x = x1 + along * dx;
        y = y1 + along * dy;
    }
    return [
        x,
        y
    ];
}
function $1bd0a226f9a16141$export$35ad6765fe262b6(fractionDigits) {
    return(/**
     * @param {Coordinate} coordinate Coordinate.
     * @return {string} String XY.
     */ function(coordinate) {
        return $1bd0a226f9a16141$export$9ff8f16060979e0a(coordinate, fractionDigits);
    });
}
function $1bd0a226f9a16141$export$6eb0ac5f024d8590(hemispheres, degrees, fractionDigits) {
    const normalizedDegrees = (0, $6b000a049d919fe5$export$ba467bec01d66def)(degrees + 180, 360) - 180;
    const x = Math.abs(3600 * normalizedDegrees);
    const decimals = fractionDigits || 0;
    let deg = Math.floor(x / 3600);
    let min = Math.floor((x - deg * 3600) / 60);
    let sec = (0, $6b000a049d919fe5$export$a81f732198733497)(x - deg * 3600 - min * 60, decimals);
    if (sec >= 60) {
        sec = 0;
        min += 1;
    }
    if (min >= 60) {
        min = 0;
        deg += 1;
    }
    let hdms = deg + '\u00b0';
    if (min !== 0 || sec !== 0) hdms += ' ' + (0, $ff7180bdd45ebb19$export$24be126cb0a7bbeb)(min, 2) + '\u2032';
    if (sec !== 0) hdms += ' ' + (0, $ff7180bdd45ebb19$export$24be126cb0a7bbeb)(sec, 2, decimals) + '\u2033';
    if (normalizedDegrees !== 0) hdms += ' ' + hemispheres.charAt(normalizedDegrees < 0 ? 1 : 0);
    return hdms;
}
function $1bd0a226f9a16141$export$d9468344d3651243(coordinate, template, fractionDigits) {
    if (coordinate) return template.replace('{x}', coordinate[0].toFixed(fractionDigits)).replace('{y}', coordinate[1].toFixed(fractionDigits));
    return '';
}
function $1bd0a226f9a16141$export$e9bab7fafb253603(coordinate1, coordinate2) {
    let equals = true;
    for(let i = coordinate1.length - 1; i >= 0; --i)if (coordinate1[i] != coordinate2[i]) {
        equals = false;
        break;
    }
    return equals;
}
function $1bd0a226f9a16141$export$bb628a54ab399bc9(coordinate, angle) {
    const cosAngle = Math.cos(angle);
    const sinAngle = Math.sin(angle);
    const x = coordinate[0] * cosAngle - coordinate[1] * sinAngle;
    const y = coordinate[1] * cosAngle + coordinate[0] * sinAngle;
    coordinate[0] = x;
    coordinate[1] = y;
    return coordinate;
}
function $1bd0a226f9a16141$export$dcdf75081b88279d(coordinate, scale) {
    coordinate[0] *= scale;
    coordinate[1] *= scale;
    return coordinate;
}
function $1bd0a226f9a16141$export$88e6ebb4fe54f538(coord1, coord2) {
    const dx = coord1[0] - coord2[0];
    const dy = coord1[1] - coord2[1];
    return dx * dx + dy * dy;
}
function $1bd0a226f9a16141$export$9f17032d917177de(coord1, coord2) {
    return Math.sqrt($1bd0a226f9a16141$export$88e6ebb4fe54f538(coord1, coord2));
}
function $1bd0a226f9a16141$export$6985570514055196(coordinate, segment) {
    return $1bd0a226f9a16141$export$88e6ebb4fe54f538(coordinate, $1bd0a226f9a16141$export$18cdd31d17f97131(coordinate, segment));
}
function $1bd0a226f9a16141$export$c883fd238161f841(coordinate, fractionDigits) {
    if (coordinate) return $1bd0a226f9a16141$export$6eb0ac5f024d8590('NS', coordinate[1], fractionDigits) + ' ' + $1bd0a226f9a16141$export$6eb0ac5f024d8590('EW', coordinate[0], fractionDigits);
    return '';
}
function $1bd0a226f9a16141$export$9ff8f16060979e0a(coordinate, fractionDigits) {
    return $1bd0a226f9a16141$export$d9468344d3651243(coordinate, '{x}, {y}', fractionDigits);
}
function $1bd0a226f9a16141$export$39a9ce3624977b84(coordinate, projection) {
    if (projection.canWrapX()) {
        const worldWidth = (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(projection.getExtent());
        const worldsAway = $1bd0a226f9a16141$export$24e2b27d1ff0c1d5(coordinate, projection, worldWidth);
        if (worldsAway) coordinate[0] -= worldsAway * worldWidth;
    }
    return coordinate;
}
function $1bd0a226f9a16141$export$24e2b27d1ff0c1d5(coordinate, projection, sourceExtentWidth) {
    const projectionExtent = projection.getExtent();
    let worldsAway = 0;
    if (projection.canWrapX() && (coordinate[0] < projectionExtent[0] || coordinate[0] > projectionExtent[2])) {
        sourceExtentWidth = sourceExtentWidth || (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(projectionExtent);
        worldsAway = Math.floor((coordinate[0] - projectionExtent[0]) / sourceExtentWidth);
    }
    return worldsAway;
}


/**
 * @module ol/easing
 */ /**
 * Start slow and speed up.
 * @param {number} t Input between 0 and 1.
 * @return {number} Output between 0 and 1.
 * @api
 */ function $c7ccf7e681a9b333$export$929e5a82286172a6(t) {
    return Math.pow(t, 3);
}
function $c7ccf7e681a9b333$export$57636bb43b1ccbb0(t) {
    return 1 - $c7ccf7e681a9b333$export$929e5a82286172a6(1 - t);
}
function $c7ccf7e681a9b333$export$9b47139b511b56e4(t) {
    return 3 * t * t - 2 * t * t * t;
}
function $c7ccf7e681a9b333$export$45db2fc2f15997e7(t) {
    return t;
}
function $c7ccf7e681a9b333$export$7f4472f6708afaf3(t) {
    if (t < 0.5) return $c7ccf7e681a9b333$export$9b47139b511b56e4(2 * t);
    return 1 - $c7ccf7e681a9b333$export$9b47139b511b56e4(2 * (t - 0.5));
}




/**
 * @module ol/geom/Polygon
 */ 


/**
 * @module ol/sphere
 */ 
const $fb75384508533d8f$export$63f2df7bd7371262 = 6371008.8;
function $fb75384508533d8f$export$79376507b09a66f(c1, c2, radius) {
    radius = radius || $fb75384508533d8f$export$63f2df7bd7371262;
    const lat1 = (0, $6b000a049d919fe5$export$cba01ba138429a1d)(c1[1]);
    const lat2 = (0, $6b000a049d919fe5$export$cba01ba138429a1d)(c2[1]);
    const deltaLatBy2 = (lat2 - lat1) / 2;
    const deltaLonBy2 = (0, $6b000a049d919fe5$export$cba01ba138429a1d)(c2[0] - c1[0]) / 2;
    const a = Math.sin(deltaLatBy2) * Math.sin(deltaLatBy2) + Math.sin(deltaLonBy2) * Math.sin(deltaLonBy2) * Math.cos(lat1) * Math.cos(lat2);
    return 2 * radius * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}
/**
 * Get the cumulative great circle length of linestring coordinates (geographic).
 * @param {Array} coordinates Linestring coordinates.
 * @param {number} radius The sphere radius to use.
 * @return {number} The length (in meters).
 */ function $fb75384508533d8f$var$getLengthInternal(coordinates, radius) {
    let length = 0;
    for(let i = 0, ii = coordinates.length; i < ii - 1; ++i)length += $fb75384508533d8f$export$79376507b09a66f(coordinates[i], coordinates[i + 1], radius);
    return length;
}
function $fb75384508533d8f$export$f0d11c074a923179(geometry, options) {
    options = options || {};
    const radius = options.radius || $fb75384508533d8f$export$63f2df7bd7371262;
    const projection = options.projection || 'EPSG:3857';
    const type = geometry.getType();
    if (type !== 'GeometryCollection') geometry = geometry.clone().transform(projection, 'EPSG:4326');
    let length = 0;
    let coordinates, coords, i, ii, j, jj;
    switch(type){
        case 'Point':
        case 'MultiPoint':
            break;
        case 'LineString':
        case 'LinearRing':
            coordinates = /** @type {import("./geom/SimpleGeometry.js").default} */ geometry.getCoordinates();
            length = $fb75384508533d8f$var$getLengthInternal(coordinates, radius);
            break;
        case 'MultiLineString':
        case 'Polygon':
            coordinates = /** @type {import("./geom/SimpleGeometry.js").default} */ geometry.getCoordinates();
            for(i = 0, ii = coordinates.length; i < ii; ++i)length += $fb75384508533d8f$var$getLengthInternal(coordinates[i], radius);
            break;
        case 'MultiPolygon':
            coordinates = /** @type {import("./geom/SimpleGeometry.js").default} */ geometry.getCoordinates();
            for(i = 0, ii = coordinates.length; i < ii; ++i){
                coords = coordinates[i];
                for(j = 0, jj = coords.length; j < jj; ++j)length += $fb75384508533d8f$var$getLengthInternal(coords[j], radius);
            }
            break;
        case 'GeometryCollection':
            {
                const geometries = /** @type {import("./geom/GeometryCollection.js").default} */ geometry.getGeometries();
                for(i = 0, ii = geometries.length; i < ii; ++i)length += $fb75384508533d8f$export$f0d11c074a923179(geometries[i], options);
                break;
            }
        default:
            throw new Error('Unsupported geometry type: ' + type);
    }
    return length;
}
/**
 * Returns the spherical area for a list of coordinates.
 *
 * [Reference](https://trs.jpl.nasa.gov/handle/2014/40409)
 * Robert. G. Chamberlain and William H. Duquette, "Some Algorithms for
 * Polygons on a Sphere", JPL Publication 07-03, Jet Propulsion
 * Laboratory, Pasadena, CA, June 2007
 *
 * @param {Array<import("./coordinate.js").Coordinate>} coordinates List of coordinates of a linear
 * ring. If the ring is oriented clockwise, the area will be positive,
 * otherwise it will be negative.
 * @param {number} radius The sphere radius.
 * @return {number} Area (in square meters).
 */ function $fb75384508533d8f$var$getAreaInternal(coordinates, radius) {
    let area = 0;
    const len = coordinates.length;
    let x1 = coordinates[len - 1][0];
    let y1 = coordinates[len - 1][1];
    for(let i = 0; i < len; i++){
        const x2 = coordinates[i][0];
        const y2 = coordinates[i][1];
        area += (0, $6b000a049d919fe5$export$cba01ba138429a1d)(x2 - x1) * (2 + Math.sin((0, $6b000a049d919fe5$export$cba01ba138429a1d)(y1)) + Math.sin((0, $6b000a049d919fe5$export$cba01ba138429a1d)(y2)));
        x1 = x2;
        y1 = y2;
    }
    return area * radius * radius / 2.0;
}
function $fb75384508533d8f$export$520c40045967cb15(geometry, options) {
    options = options || {};
    const radius = options.radius || $fb75384508533d8f$export$63f2df7bd7371262;
    const projection = options.projection || 'EPSG:3857';
    const type = geometry.getType();
    if (type !== 'GeometryCollection') geometry = geometry.clone().transform(projection, 'EPSG:4326');
    let area = 0;
    let coordinates, coords, i, ii, j, jj;
    switch(type){
        case 'Point':
        case 'MultiPoint':
        case 'LineString':
        case 'MultiLineString':
        case 'LinearRing':
            break;
        case 'Polygon':
            coordinates = /** @type {import("./geom/Polygon.js").default} */ geometry.getCoordinates();
            area = Math.abs($fb75384508533d8f$var$getAreaInternal(coordinates[0], radius));
            for(i = 1, ii = coordinates.length; i < ii; ++i)area -= Math.abs($fb75384508533d8f$var$getAreaInternal(coordinates[i], radius));
            break;
        case 'MultiPolygon':
            coordinates = /** @type {import("./geom/SimpleGeometry.js").default} */ geometry.getCoordinates();
            for(i = 0, ii = coordinates.length; i < ii; ++i){
                coords = coordinates[i];
                area += Math.abs($fb75384508533d8f$var$getAreaInternal(coords[0], radius));
                for(j = 1, jj = coords.length; j < jj; ++j)area -= Math.abs($fb75384508533d8f$var$getAreaInternal(coords[j], radius));
            }
            break;
        case 'GeometryCollection':
            {
                const geometries = /** @type {import("./geom/GeometryCollection.js").default} */ geometry.getGeometries();
                for(i = 0, ii = geometries.length; i < ii; ++i)area += $fb75384508533d8f$export$520c40045967cb15(geometries[i], options);
                break;
            }
        default:
            throw new Error('Unsupported geometry type: ' + type);
    }
    return area;
}
function $fb75384508533d8f$export$cc800923e997bb8(c1, distance, bearing, radius) {
    radius = radius || $fb75384508533d8f$export$63f2df7bd7371262;
    const lat1 = (0, $6b000a049d919fe5$export$cba01ba138429a1d)(c1[1]);
    const lon1 = (0, $6b000a049d919fe5$export$cba01ba138429a1d)(c1[0]);
    const dByR = distance / radius;
    const lat = Math.asin(Math.sin(lat1) * Math.cos(dByR) + Math.cos(lat1) * Math.sin(dByR) * Math.cos(bearing));
    const lon = lon1 + Math.atan2(Math.sin(bearing) * Math.sin(dByR) * Math.cos(lat1), Math.cos(dByR) - Math.sin(lat1) * Math.sin(lat));
    return [
        (0, $6b000a049d919fe5$export$56cb859c01fa134d)(lon),
        (0, $6b000a049d919fe5$export$56cb859c01fa134d)(lat)
    ];
}


/**
 * @module ol/geom/LinearRing
 */ 
/**
 * @module ol/geom/SimpleGeometry
 */ 

/**
 * @module ol/geom/Geometry
 */ 


/**
 * @module ol/proj
 */ /**
 * The ol/proj module stores:
 * a list of {@link module:ol/proj/Projection~Projection}
 * objects, one for each projection supported by the application
 * a list of transform functions needed to convert coordinates in one projection
 * into another.
 *
 * The static functions are the methods used to maintain these.
 * Each transform function can handle not only simple coordinate pairs, but also
 * large arrays of coordinates such as vector geometries.
 *
 * When loaded, the library adds projection objects for EPSG:4326 (WGS84
 * geographic coordinates) and EPSG:3857 (Web or Spherical Mercator, as used
 * for example by Bing Maps or OpenStreetMap), together with the relevant
 * transform functions.
 *
 * Additional transforms may be added by using the http://proj4js.org/
 * library (version 2.2 or later). You can use the full build supplied by
 * Proj4js, or create a custom build to support those projections you need; see
 * the Proj4js website for how to do this. You also need the Proj4js definitions
 * for the required projections. These definitions can be obtained from
 * https://epsg.io/, and are a JS function, so can be loaded in a script
 * tag (as in the examples) or pasted into your application.
 *
 * After all required projection definitions are added to proj4's registry (by
 * using `proj4.defs()`), simply call `register(proj4)` from the `ol/proj/proj4`
 * package. Existing transforms are not changed by this function. See
 * examples/wms-image-custom-proj for an example of this.
 *
 * Additional projection definitions can be registered with `proj4.defs()` any
 * time. Just make sure to call `register(proj4)` again; for example, with user-supplied data where you don't
 * know in advance what projections are needed, you can initially load minimal
 * support and then load whichever are requested.
 *
 * Note that Proj4js does not support projection extents. If you want to add
 * one for creating default tile grids, you can add it after the Projection
 * object has been created with `setExtent`, for example,
 * `get('EPSG:1234').setExtent(extent)`.
 *
 * In addition to Proj4js support, any transform functions can be added with
 * {@link module:ol/proj.addCoordinateTransforms}. To use this, you must first create
 * a {@link module:ol/proj/Projection~Projection} object for the new projection and add it with
 * {@link module:ol/proj.addProjection}. You can then add the forward and inverse
 * functions with {@link module:ol/proj.addCoordinateTransforms}. See
 * examples/wms-custom-proj for an example of this.
 *
 * Note that if no transforms are needed and you only need to define the
 * projection, just add a {@link module:ol/proj/Projection~Projection} with
 * {@link module:ol/proj.addProjection}. See examples/wms-no-proj for an example of
 * this.
 */ /**
 * @module ol/console
 */ /**
 * @typedef {'info'|'warn'|'error'|'none'} Level
 */ /**
 * @type {Object<Level, number>}
 */ const $8c65b0699f3f3f8e$var$levels = {
    info: 1,
    warn: 2,
    error: 3,
    none: 4
};
/**
 * @type {number}
 */ let $8c65b0699f3f3f8e$var$level = $8c65b0699f3f3f8e$var$levels.info;
function $8c65b0699f3f3f8e$export$2c97a59140dbf245(l) {
    $8c65b0699f3f3f8e$var$level = $8c65b0699f3f3f8e$var$levels[l];
}
function $8c65b0699f3f3f8e$export$bef1f36f5486a6a3(...args) {
    if ($8c65b0699f3f3f8e$var$level > $8c65b0699f3f3f8e$var$levels.info) return;
    console.log(...args); // eslint-disable-line no-console
}
function $8c65b0699f3f3f8e$export$c106dd0671a0fc2d(...args) {
    if ($8c65b0699f3f3f8e$var$level > $8c65b0699f3f3f8e$var$levels.warn) return;
    console.warn(...args); // eslint-disable-line no-console
}
function $8c65b0699f3f3f8e$export$a3bc9b8ed74fc(...args) {
    if ($8c65b0699f3f3f8e$var$level > $8c65b0699f3f3f8e$var$levels.error) return;
    console.error(...args); // eslint-disable-line no-console
}






/**
 * @module ol/proj/Units
 */ /**
 * @typedef {'radians' | 'degrees' | 'ft' | 'm' | 'pixels' | 'tile-pixels' | 'us-ft'} Units
 * Projection units.
 */ /**
 * See http://duff.ess.washington.edu/data/raster/drg/docs/geotiff.txt
 * @type {Object<number, Units>}
 */ const $03edbd434a9e6608$var$unitByCode = {
    '9001': 'm',
    '9002': 'ft',
    '9003': 'us-ft',
    '9101': 'radians',
    '9102': 'degrees'
};
function $03edbd434a9e6608$export$7f58726df3255edc(code) {
    return $03edbd434a9e6608$var$unitByCode[code];
}
const $03edbd434a9e6608$export$1482081eec883108 = {
    // use the radius of the Normal sphere
    'radians': 6370997 / (2 * Math.PI),
    'degrees': 2 * Math.PI * 6370997 / 360,
    'ft': 0.3048,
    'm': 1,
    'us-ft': 1200 / 3937
};


/**
 * @module ol/proj/epsg3857
 */ /**
 * @module ol/proj/Projection
 */ 
/**
 * The function is called with a `number` view resolution and a
 * {@link module:ol/coordinate~Coordinate} as arguments, and returns the `number` resolution
 * in projection units at the passed coordinate.
 * @typedef {function(number, import("../coordinate.js").Coordinate):number} GetPointResolution
 * @api
 */ /**
 * @typedef {Object} Options
 * @property {string} code The SRS identifier code, e.g. `EPSG:4326`.
 * @property {import("./Units.js").Units} [units] Units. Required unless a
 * proj4 projection is defined for `code`.
 * @property {import("../extent.js").Extent} [extent] The validity extent for the SRS.
 * @property {string} [axisOrientation='enu'] The axis orientation as specified in Proj4.
 * @property {boolean} [global=false] Whether the projection is valid for the whole globe.
 * @property {number} [metersPerUnit] The meters per unit for the SRS.
 * If not provided, the `units` are used to get the meters per unit from the {@link METERS_PER_UNIT}
 * lookup table.
 * @property {import("../extent.js").Extent} [worldExtent] The world extent for the SRS.
 * @property {GetPointResolution} [getPointResolution]
 * Function to determine resolution at a point. The function is called with a
 * `number` view resolution and a {@link module:ol/coordinate~Coordinate} as arguments, and returns
 * the `number` resolution in projection units at the passed coordinate. If this is `undefined`,
 * the default {@link module:ol/proj.getPointResolution} function will be used.
 */ /**
 * @classdesc
 * In most cases, you should not need to create instances of this class.
 * Instead, where projection information is required, you can use a string
 * projection code or identifier (e.g. `EPSG:4326`) instead of a projection
 * instance.
 *
 * The library includes support for transforming coordinates between the following
 * projections:
 *
 *  WGS 84 / Geographic - Using codes `EPSG:4326`, `CRS:84`, `urn:ogc:def:crs:EPSG:6.6:4326`,
 *    `urn:ogc:def:crs:OGC:1.3:CRS84`, `urn:ogc:def:crs:OGC:2:84`, `http://www.opengis.net/gml/srs/epsg.xml#4326`,
 *    or `urn:x-ogc:def:crs:EPSG:4326`
 *  WGS 84 / Spherical Mercator - Using codes `EPSG:3857`, `EPSG:102100`, `EPSG:102113`, `EPSG:900913`,
 *    `urn:ogc:def:crs:EPSG:6.18:3:3857`, or `http://www.opengis.net/gml/srs/epsg.xml#3857`
 *  WGS 84 / UTM zones - Using codes `EPSG:32601` through `EPSG:32660` for northern zones
 *    and `EPSG:32701` through `EPSG:32760` for southern zones. Note that the built-in UTM transforms
 *    are lower accuracy (with errors on the order of 0.1 m) than those that you might get in a
 *    library like [proj4js](https://github.com/proj4js/proj4js).
 *
 * For additional projection support, or to use higher accuracy transforms than the built-in ones, you can use
 * the [proj4js](https://github.com/proj4js/proj4js) library. With `proj4js`, after adding any new projection
 * definitions, call the {@link module:ol/proj/proj4.register} function.
 *
 * You can use the {@link module:ol/proj.get} function to retrieve a projection instance
 * for one of the registered projections.
 *
 * @api
 */ class $6dc418afeec7068a$var$Projection {
    /**
   * @param {Options} options Projection options.
   */ constructor(options){
        /**
     * @private
     * @type {string}
     */ this.code_ = options.code;
        /**
     * Units of projected coordinates. When set to `TILE_PIXELS`, a
     * `this.extent_` and `this.worldExtent_` must be configured properly for each
     * tile.
     * @private
     * @type {import("./Units.js").Units}
     */ this.units_ = /** @type {import("./Units.js").Units} */ options.units;
        /**
     * Validity extent of the projection in projected coordinates. For projections
     * with `TILE_PIXELS` units, this is the extent of the tile in
     * tile pixel space.
     * @private
     * @type {import("../extent.js").Extent}
     */ this.extent_ = options.extent !== undefined ? options.extent : null;
        /**
     * Extent of the world in EPSG:4326. For projections with
     * `TILE_PIXELS` units, this is the extent of the tile in
     * projected coordinate space.
     * @private
     * @type {import("../extent.js").Extent}
     */ this.worldExtent_ = options.worldExtent !== undefined ? options.worldExtent : null;
        /**
     * @private
     * @type {string}
     */ this.axisOrientation_ = options.axisOrientation !== undefined ? options.axisOrientation : 'enu';
        /**
     * @private
     * @type {boolean}
     */ this.global_ = options.global !== undefined ? options.global : false;
        /**
     * @private
     * @type {boolean}
     */ this.canWrapX_ = !!(this.global_ && this.extent_);
        /**
     * @private
     * @type {GetPointResolution|undefined}
     */ this.getPointResolutionFunc_ = options.getPointResolution;
        /**
     * @private
     * @type {import("../tilegrid/TileGrid.js").default}
     */ this.defaultTileGrid_ = null;
        /**
     * @private
     * @type {number|undefined}
     */ this.metersPerUnit_ = options.metersPerUnit;
    }
    /**
   * @return {boolean} The projection is suitable for wrapping the x-axis
   */ canWrapX() {
        return this.canWrapX_;
    }
    /**
   * Get the code for this projection, e.g. 'EPSG:4326'.
   * @return {string} Code.
   * @api
   */ getCode() {
        return this.code_;
    }
    /**
   * Get the validity extent for this projection.
   * @return {import("../extent.js").Extent} Extent.
   * @api
   */ getExtent() {
        return this.extent_;
    }
    /**
   * Get the units of this projection.
   * @return {import("./Units.js").Units} Units.
   * @api
   */ getUnits() {
        return this.units_;
    }
    /**
   * Get the amount of meters per unit of this projection.  If the projection is
   * not configured with `metersPerUnit` or a units identifier, the return is
   * `undefined`.
   * @return {number|undefined} Meters.
   * @api
   */ getMetersPerUnit() {
        return this.metersPerUnit_ || (0, $03edbd434a9e6608$export$1482081eec883108)[this.units_];
    }
    /**
   * Get the world extent for this projection.
   * @return {import("../extent.js").Extent} Extent.
   * @api
   */ getWorldExtent() {
        return this.worldExtent_;
    }
    /**
   * Get the axis orientation of this projection.
   * Example values are:
   * enu - the default easting, northing, elevation.
   * neu - northing, easting, up - useful for "lat/long" geographic coordinates,
   *     or south orientated transverse mercator.
   * wnu - westing, northing, up - some planetary coordinate systems have
   *     "west positive" coordinate systems
   * @return {string} Axis orientation.
   * @api
   */ getAxisOrientation() {
        return this.axisOrientation_;
    }
    /**
   * Is this projection a global projection which spans the whole world?
   * @return {boolean} Whether the projection is global.
   * @api
   */ isGlobal() {
        return this.global_;
    }
    /**
   * Set if the projection is a global projection which spans the whole world
   * @param {boolean} global Whether the projection is global.
   * @api
   */ setGlobal(global) {
        this.global_ = global;
        this.canWrapX_ = !!(global && this.extent_);
    }
    /**
   * @return {import("../tilegrid/TileGrid.js").default} The default tile grid.
   */ getDefaultTileGrid() {
        return this.defaultTileGrid_;
    }
    /**
   * @param {import("../tilegrid/TileGrid.js").default} tileGrid The default tile grid.
   */ setDefaultTileGrid(tileGrid) {
        this.defaultTileGrid_ = tileGrid;
    }
    /**
   * Set the validity extent for this projection.
   * @param {import("../extent.js").Extent} extent Extent.
   * @api
   */ setExtent(extent) {
        this.extent_ = extent;
        this.canWrapX_ = !!(this.global_ && extent);
    }
    /**
   * Set the world extent for this projection.
   * @param {import("../extent.js").Extent} worldExtent World extent
   *     [minlon, minlat, maxlon, maxlat].
   * @api
   */ setWorldExtent(worldExtent) {
        this.worldExtent_ = worldExtent;
    }
    /**
   * Set the getPointResolution function (see {@link module:ol/proj.getPointResolution}
   * for this projection.
   * @param {function(number, import("../coordinate.js").Coordinate):number} func Function
   * @api
   */ setGetPointResolution(func) {
        this.getPointResolutionFunc_ = func;
    }
    /**
   * Get the custom point resolution function for this projection (if set).
   * @return {GetPointResolution|undefined} The custom point
   * resolution function (if set).
   */ getPointResolutionFunc() {
        return this.getPointResolutionFunc_;
    }
}
var $6dc418afeec7068a$export$2e2bcd8739ae039 = $6dc418afeec7068a$var$Projection;


const $84ad988f04807ab1$export$2d2c9be8b5b863f = 6378137;
const $84ad988f04807ab1$export$f3928063e5e96d35 = Math.PI * $84ad988f04807ab1$export$2d2c9be8b5b863f;
const $84ad988f04807ab1$export$21e6da8a7375dfe8 = [
    -$84ad988f04807ab1$export$f3928063e5e96d35,
    -$84ad988f04807ab1$export$f3928063e5e96d35,
    $84ad988f04807ab1$export$f3928063e5e96d35,
    $84ad988f04807ab1$export$f3928063e5e96d35
];
const $84ad988f04807ab1$export$ae9d6ed80df710e5 = [
    -180,
    -85,
    180,
    85
];
const $84ad988f04807ab1$export$d26945d1ad52feeb = $84ad988f04807ab1$export$2d2c9be8b5b863f * Math.log(Math.tan(Math.PI / 2));
/**
 * @classdesc
 * Projection object for web/spherical Mercator (EPSG:3857).
 */ class $84ad988f04807ab1$var$EPSG3857Projection extends (0, $6dc418afeec7068a$export$2e2bcd8739ae039) {
    /**
   * @param {string} code Code.
   */ constructor(code){
        super({
            code: code,
            units: 'm',
            extent: $84ad988f04807ab1$export$21e6da8a7375dfe8,
            global: true,
            worldExtent: $84ad988f04807ab1$export$ae9d6ed80df710e5,
            getPointResolution: function(resolution, point) {
                return resolution / Math.cosh(point[1] / $84ad988f04807ab1$export$2d2c9be8b5b863f);
            }
        });
    }
}
const $84ad988f04807ab1$export$b508d7ad9a891c1b = [
    new $84ad988f04807ab1$var$EPSG3857Projection('EPSG:3857'),
    new $84ad988f04807ab1$var$EPSG3857Projection('EPSG:102100'),
    new $84ad988f04807ab1$var$EPSG3857Projection('EPSG:102113'),
    new $84ad988f04807ab1$var$EPSG3857Projection('EPSG:900913'),
    new $84ad988f04807ab1$var$EPSG3857Projection('http://www.opengis.net/def/crs/EPSG/0/3857'),
    new $84ad988f04807ab1$var$EPSG3857Projection('http://www.opengis.net/gml/srs/epsg.xml#3857')
];
function $84ad988f04807ab1$export$1ff8bb36c0983070(input, output, dimension, stride) {
    const length = input.length;
    dimension = dimension > 1 ? dimension : 2;
    stride = stride ?? dimension;
    if (output === undefined) {
        if (dimension > 2) // preserve values beyond second dimension
        output = input.slice();
        else output = new Array(length);
    }
    for(let i = 0; i < length; i += stride){
        output[i] = $84ad988f04807ab1$export$f3928063e5e96d35 * input[i] / 180;
        let y = $84ad988f04807ab1$export$2d2c9be8b5b863f * Math.log(Math.tan(Math.PI * (+input[i + 1] + 90) / 360));
        if (y > $84ad988f04807ab1$export$d26945d1ad52feeb) y = $84ad988f04807ab1$export$d26945d1ad52feeb;
        else if (y < -$84ad988f04807ab1$export$d26945d1ad52feeb) y = -$84ad988f04807ab1$export$d26945d1ad52feeb;
        output[i + 1] = y;
    }
    return output;
}
function $84ad988f04807ab1$export$8c71322ec28ed6b4(input, output, dimension, stride) {
    const length = input.length;
    dimension = dimension > 1 ? dimension : 2;
    stride = stride ?? dimension;
    if (output === undefined) {
        if (dimension > 2) // preserve values beyond second dimension
        output = input.slice();
        else output = new Array(length);
    }
    for(let i = 0; i < length; i += stride){
        output[i] = 180 * input[i] / $84ad988f04807ab1$export$f3928063e5e96d35;
        output[i + 1] = 360 * Math.atan(Math.exp(input[i + 1] / $84ad988f04807ab1$export$2d2c9be8b5b863f)) / Math.PI - 90;
    }
    return output;
}


/**
 * @module ol/proj/epsg4326
 */ 
const $b58ae362632b32c5$export$2d2c9be8b5b863f = 6378137;
const $b58ae362632b32c5$export$21e6da8a7375dfe8 = [
    -180,
    -90,
    180,
    90
];
const $b58ae362632b32c5$export$1482081eec883108 = Math.PI * $b58ae362632b32c5$export$2d2c9be8b5b863f / 180;
/**
 * @classdesc
 * Projection object for WGS84 geographic coordinates (EPSG:4326).
 *
 * Note that OpenLayers does not strictly comply with the EPSG definition.
 * The EPSG registry defines 4326 as a CRS for Latitude,Longitude (y,x).
 * OpenLayers treats EPSG:4326 as a pseudo-projection, with x,y coordinates.
 */ class $b58ae362632b32c5$var$EPSG4326Projection extends (0, $6dc418afeec7068a$export$2e2bcd8739ae039) {
    /**
   * @param {string} code Code.
   * @param {string} [axisOrientation] Axis orientation.
   */ constructor(code, axisOrientation){
        super({
            code: code,
            units: 'degrees',
            extent: $b58ae362632b32c5$export$21e6da8a7375dfe8,
            axisOrientation: axisOrientation,
            global: true,
            metersPerUnit: $b58ae362632b32c5$export$1482081eec883108,
            worldExtent: $b58ae362632b32c5$export$21e6da8a7375dfe8
        });
    }
}
const $b58ae362632b32c5$export$b508d7ad9a891c1b = [
    new $b58ae362632b32c5$var$EPSG4326Projection('CRS:84'),
    new $b58ae362632b32c5$var$EPSG4326Projection('EPSG:4326', 'neu'),
    new $b58ae362632b32c5$var$EPSG4326Projection('urn:ogc:def:crs:OGC:1.3:CRS84'),
    new $b58ae362632b32c5$var$EPSG4326Projection('urn:ogc:def:crs:OGC:2:84'),
    new $b58ae362632b32c5$var$EPSG4326Projection('http://www.opengis.net/def/crs/OGC/1.3/CRS84'),
    new $b58ae362632b32c5$var$EPSG4326Projection('http://www.opengis.net/gml/srs/epsg.xml#4326', 'neu'),
    new $b58ae362632b32c5$var$EPSG4326Projection('http://www.opengis.net/def/crs/EPSG/0/4326', 'neu')
];


/**
 * @module ol/proj/projections
 */ /**
 * @type {Object<string, import("./Projection.js").default>}
 */ let $f5ec5c943d804ecb$var$cache = {};
function $f5ec5c943d804ecb$export$42ffd38884aecdac() {
    $f5ec5c943d804ecb$var$cache = {};
}
function $f5ec5c943d804ecb$export$3988ae62b71be9a3(code) {
    return $f5ec5c943d804ecb$var$cache[code] || $f5ec5c943d804ecb$var$cache[code.replace(/urn:(x-)?ogc:def:crs:EPSG:(.*:)?(\w+)$/, 'EPSG:$3')] || null;
}
function $f5ec5c943d804ecb$export$e16d8520af44a096(code, projection) {
    $f5ec5c943d804ecb$var$cache[code] = projection;
}


/**
 * @module ol/proj/transforms
 */ 
/**
 * @private
 * @type {!Object<string, Object<string, import("../proj.js").TransformFunction>>}
 */ let $11b5dd198626e1de$var$transforms = {};
function $11b5dd198626e1de$export$42ffd38884aecdac() {
    $11b5dd198626e1de$var$transforms = {};
}
function $11b5dd198626e1de$export$e16d8520af44a096(source, destination, transformFn) {
    const sourceCode = source.getCode();
    const destinationCode = destination.getCode();
    if (!(sourceCode in $11b5dd198626e1de$var$transforms)) $11b5dd198626e1de$var$transforms[sourceCode] = {};
    $11b5dd198626e1de$var$transforms[sourceCode][destinationCode] = transformFn;
}
function $11b5dd198626e1de$export$cd7f480d6b8286c3(source, destination) {
    const sourceCode = source.getCode();
    const destinationCode = destination.getCode();
    const transform = $11b5dd198626e1de$var$transforms[sourceCode][destinationCode];
    delete $11b5dd198626e1de$var$transforms[sourceCode][destinationCode];
    if ((0, $beaefe87199bb537$export$dd1bc94b04021eeb)($11b5dd198626e1de$var$transforms[sourceCode])) delete $11b5dd198626e1de$var$transforms[sourceCode];
    return transform;
}
function $11b5dd198626e1de$export$3988ae62b71be9a3(sourceCode, destinationCode) {
    if (sourceCode in $11b5dd198626e1de$var$transforms && destinationCode in $11b5dd198626e1de$var$transforms[sourceCode]) return $11b5dd198626e1de$var$transforms[sourceCode][destinationCode];
    return null;
}


/**
 * @module ol/proj/utm
 */ /**
 * Adapted from https://github.com/Turbo87/utm
 * Copyright (c) 2012-2017 Tobias Bieniek
 *
 * The functions here provide approximate transforms to and from UTM.
 * They are not appropriate for use beyond the validity extend of a UTM
 * zone, and the accuracy of the transform decreases toward the zone
 * edges.
 */ 

/**
 * @typedef {Object} UTMZone
 * @property {number} number The zone number (1 - 60).
 * @property {boolean} north The northern hemisphere.
 */ const $5f19451ebc03a1eb$var$K0 = 0.9996;
const $5f19451ebc03a1eb$var$E = 0.00669438;
const $5f19451ebc03a1eb$var$E2 = $5f19451ebc03a1eb$var$E * $5f19451ebc03a1eb$var$E;
const $5f19451ebc03a1eb$var$E3 = $5f19451ebc03a1eb$var$E2 * $5f19451ebc03a1eb$var$E;
const $5f19451ebc03a1eb$var$E_P2 = $5f19451ebc03a1eb$var$E / (1 - $5f19451ebc03a1eb$var$E);
const $5f19451ebc03a1eb$var$SQRT_E = Math.sqrt(1 - $5f19451ebc03a1eb$var$E);
const $5f19451ebc03a1eb$var$_E = (1 - $5f19451ebc03a1eb$var$SQRT_E) / (1 + $5f19451ebc03a1eb$var$SQRT_E);
const $5f19451ebc03a1eb$var$_E2 = $5f19451ebc03a1eb$var$_E * $5f19451ebc03a1eb$var$_E;
const $5f19451ebc03a1eb$var$_E3 = $5f19451ebc03a1eb$var$_E2 * $5f19451ebc03a1eb$var$_E;
const $5f19451ebc03a1eb$var$_E4 = $5f19451ebc03a1eb$var$_E3 * $5f19451ebc03a1eb$var$_E;
const $5f19451ebc03a1eb$var$_E5 = $5f19451ebc03a1eb$var$_E4 * $5f19451ebc03a1eb$var$_E;
const $5f19451ebc03a1eb$var$M1 = 1 - $5f19451ebc03a1eb$var$E / 4 - 3 * $5f19451ebc03a1eb$var$E2 / 64 - 5 * $5f19451ebc03a1eb$var$E3 / 256;
const $5f19451ebc03a1eb$var$M2 = 3 * $5f19451ebc03a1eb$var$E / 8 + 3 * $5f19451ebc03a1eb$var$E2 / 32 + 45 * $5f19451ebc03a1eb$var$E3 / 1024;
const $5f19451ebc03a1eb$var$M3 = 15 * $5f19451ebc03a1eb$var$E2 / 256 + 45 * $5f19451ebc03a1eb$var$E3 / 1024;
const $5f19451ebc03a1eb$var$M4 = 35 * $5f19451ebc03a1eb$var$E3 / 3072;
const $5f19451ebc03a1eb$var$P2 = 1.5 * $5f19451ebc03a1eb$var$_E - 27 / 32 * $5f19451ebc03a1eb$var$_E3 + 269 / 512 * $5f19451ebc03a1eb$var$_E5;
const $5f19451ebc03a1eb$var$P3 = 21 / 16 * $5f19451ebc03a1eb$var$_E2 - 55 / 32 * $5f19451ebc03a1eb$var$_E4;
const $5f19451ebc03a1eb$var$P4 = 151 / 96 * $5f19451ebc03a1eb$var$_E3 - 417 / 128 * $5f19451ebc03a1eb$var$_E5;
const $5f19451ebc03a1eb$var$P5 = 1097 / 512 * $5f19451ebc03a1eb$var$_E4;
const $5f19451ebc03a1eb$var$R = 6378137;
/**
 * @param {number} easting Easting value of coordinate.
 * @param {number} northing Northing value of coordinate.
 * @param {UTMZone} zone The UTM zone.
 * @return {import("../coordinate.js").Coordinate} The transformed coordinate.
 */ function $5f19451ebc03a1eb$var$toLonLat(easting, northing, zone) {
    const x = easting - 500000;
    const y = zone.north ? northing : northing - 10000000;
    const m = y / $5f19451ebc03a1eb$var$K0;
    const mu = m / ($5f19451ebc03a1eb$var$R * $5f19451ebc03a1eb$var$M1);
    const pRad = mu + $5f19451ebc03a1eb$var$P2 * Math.sin(2 * mu) + $5f19451ebc03a1eb$var$P3 * Math.sin(4 * mu) + $5f19451ebc03a1eb$var$P4 * Math.sin(6 * mu) + $5f19451ebc03a1eb$var$P5 * Math.sin(8 * mu);
    const pSin = Math.sin(pRad);
    const pSin2 = pSin * pSin;
    const pCos = Math.cos(pRad);
    const pTan = pSin / pCos;
    const pTan2 = pTan * pTan;
    const pTan4 = pTan2 * pTan2;
    const epSin = 1 - $5f19451ebc03a1eb$var$E * pSin2;
    const epSinSqrt = Math.sqrt(1 - $5f19451ebc03a1eb$var$E * pSin2);
    const n = $5f19451ebc03a1eb$var$R / epSinSqrt;
    const r = (1 - $5f19451ebc03a1eb$var$E) / epSin;
    const c = $5f19451ebc03a1eb$var$E_P2 * pCos ** 2;
    const c2 = c * c;
    const d = x / (n * $5f19451ebc03a1eb$var$K0);
    const d2 = d * d;
    const d3 = d2 * d;
    const d4 = d3 * d;
    const d5 = d4 * d;
    const d6 = d5 * d;
    const latitude = pRad - pTan / r * (d2 / 2 - d4 / 24 * (5 + 3 * pTan2 + 10 * c - 4 * c2 - 9 * $5f19451ebc03a1eb$var$E_P2)) + d6 / 720 * (61 + 90 * pTan2 + 298 * c + 45 * pTan4 - 252 * $5f19451ebc03a1eb$var$E_P2 - 3 * c2);
    let longitude = (d - d3 / 6 * (1 + 2 * pTan2 + c) + d5 / 120 * (5 - 2 * c + 28 * pTan2 - 3 * c2 + 8 * $5f19451ebc03a1eb$var$E_P2 + 24 * pTan4)) / pCos;
    longitude = (0, $6b000a049d919fe5$export$4997ffc0176396a6)(longitude + (0, $6b000a049d919fe5$export$cba01ba138429a1d)($5f19451ebc03a1eb$var$zoneToCentralLongitude(zone.number)), -Math.PI, Math.PI);
    return [
        (0, $6b000a049d919fe5$export$56cb859c01fa134d)(longitude),
        (0, $6b000a049d919fe5$export$56cb859c01fa134d)(latitude)
    ];
}
const $5f19451ebc03a1eb$var$MIN_LATITUDE = -80;
const $5f19451ebc03a1eb$var$MAX_LATITUDE = 84;
const $5f19451ebc03a1eb$var$MIN_LONGITUDE = -180;
const $5f19451ebc03a1eb$var$MAX_LONGITUDE = 180;
/**
 * @param {number} longitude The longitude.
 * @param {number} latitude The latitude.
 * @param {UTMZone} zone The UTM zone.
 * @return {import('../coordinate.js').Coordinate} The UTM coordinate.
 */ function $5f19451ebc03a1eb$var$fromLonLat(longitude, latitude, zone) {
    longitude = (0, $6b000a049d919fe5$export$4997ffc0176396a6)(longitude, $5f19451ebc03a1eb$var$MIN_LONGITUDE, $5f19451ebc03a1eb$var$MAX_LONGITUDE);
    if (latitude < $5f19451ebc03a1eb$var$MIN_LATITUDE) latitude = $5f19451ebc03a1eb$var$MIN_LATITUDE;
    else if (latitude > $5f19451ebc03a1eb$var$MAX_LATITUDE) latitude = $5f19451ebc03a1eb$var$MAX_LATITUDE;
    const latRad = (0, $6b000a049d919fe5$export$cba01ba138429a1d)(latitude);
    const latSin = Math.sin(latRad);
    const latCos = Math.cos(latRad);
    const latTan = latSin / latCos;
    const latTan2 = latTan * latTan;
    const latTan4 = latTan2 * latTan2;
    const lonRad = (0, $6b000a049d919fe5$export$cba01ba138429a1d)(longitude);
    const centralLon = $5f19451ebc03a1eb$var$zoneToCentralLongitude(zone.number);
    const centralLonRad = (0, $6b000a049d919fe5$export$cba01ba138429a1d)(centralLon);
    const n = $5f19451ebc03a1eb$var$R / Math.sqrt(1 - $5f19451ebc03a1eb$var$E * latSin ** 2);
    const c = $5f19451ebc03a1eb$var$E_P2 * latCos ** 2;
    const a = latCos * (0, $6b000a049d919fe5$export$4997ffc0176396a6)(lonRad - centralLonRad, -Math.PI, Math.PI);
    const a2 = a * a;
    const a3 = a2 * a;
    const a4 = a3 * a;
    const a5 = a4 * a;
    const a6 = a5 * a;
    const m = $5f19451ebc03a1eb$var$R * ($5f19451ebc03a1eb$var$M1 * latRad - $5f19451ebc03a1eb$var$M2 * Math.sin(2 * latRad) + $5f19451ebc03a1eb$var$M3 * Math.sin(4 * latRad) - $5f19451ebc03a1eb$var$M4 * Math.sin(6 * latRad));
    const easting = $5f19451ebc03a1eb$var$K0 * n * (a + a3 / 6 * (1 - latTan2 + c) + a5 / 120 * (5 - 18 * latTan2 + latTan4 + 72 * c - 58 * $5f19451ebc03a1eb$var$E_P2)) + 500000;
    let northing = $5f19451ebc03a1eb$var$K0 * (m + n * latTan * (a2 / 2 + a4 / 24 * (5 - latTan2 + 9 * c + 4 * c ** 2) + a6 / 720 * (61 - 58 * latTan2 + latTan4 + 600 * c - 330 * $5f19451ebc03a1eb$var$E_P2)));
    if (!zone.north) northing += 10000000;
    return [
        easting,
        northing
    ];
}
/**
 * @param {number} zone The zone number.
 * @return {number} The central longitude in degrees.
 */ function $5f19451ebc03a1eb$var$zoneToCentralLongitude(zone) {
    return (zone - 1) * 6 - 180 + 3;
}
/**
 * @type {Array<RegExp>}
 */ const $5f19451ebc03a1eb$var$epsgRegExes = [
    /^EPSG:(\d+)$/,
    /^urn:ogc:def:crs:EPSG::(\d+)$/,
    /^http:\/\/www\.opengis\.net\/def\/crs\/EPSG\/0\/(\d+)$/
];
function $5f19451ebc03a1eb$export$bb54dc52a08ed170(code) {
    let epsgId = 0;
    for (const re of $5f19451ebc03a1eb$var$epsgRegExes){
        const match = code.match(re);
        if (match) {
            epsgId = parseInt(match[1]);
            break;
        }
    }
    if (!epsgId) return null;
    let number = 0;
    let north = false;
    if (epsgId > 32700 && epsgId < 32761) number = epsgId - 32700;
    else if (epsgId > 32600 && epsgId < 32661) {
        north = true;
        number = epsgId - 32600;
    }
    if (!number) return null;
    return {
        number: number,
        north: north
    };
}
/**
 * @param {function(number, number, UTMZone): import('../coordinate.js').Coordinate} transformer The transformer.
 * @param {UTMZone} zone The UTM zone.
 * @return {import('../proj.js').TransformFunction} The transform function.
 */ function $5f19451ebc03a1eb$var$makeTransformFunction(transformer, zone) {
    return function(input, output, dimension, stride) {
        const length = input.length;
        dimension = dimension > 1 ? dimension : 2;
        stride = stride ?? dimension;
        if (!output) {
            if (dimension > 2) output = input.slice();
            else output = new Array(length);
        }
        for(let i = 0; i < length; i += stride){
            const x = input[i];
            const y = input[i + 1];
            const coord = transformer(x, y, zone);
            output[i] = coord[0];
            output[i + 1] = coord[1];
        }
        return output;
    };
}
function $5f19451ebc03a1eb$export$3277980d225b59be(code) {
    const zone = $5f19451ebc03a1eb$export$bb54dc52a08ed170(code);
    if (!zone) return null;
    return new (0, $6dc418afeec7068a$export$2e2bcd8739ae039)({
        code: code,
        units: 'm'
    });
}
function $5f19451ebc03a1eb$export$f94509e55523febf(projection) {
    const zone = $5f19451ebc03a1eb$export$bb54dc52a08ed170(projection.getCode());
    if (!zone) return null;
    return {
        forward: $5f19451ebc03a1eb$var$makeTransformFunction($5f19451ebc03a1eb$var$fromLonLat, zone),
        inverse: $5f19451ebc03a1eb$var$makeTransformFunction($5f19451ebc03a1eb$var$toLonLat, zone)
    };
}



/**
 * A projection as {@link module:ol/proj/Projection~Projection}, SRS identifier
 * string or undefined.
 * @typedef {Projection|string|undefined} ProjectionLike
 * @api
 */ /**
 * @typedef {Object} Transforms
 * @property {TransformFunction} forward The forward transform (from geographic).
 * @property {TransformFunction} inverse The inverse transform (to geographic).
 */ /**
 * @type {Array<function(Projection): Transforms|null>}
 */ const $9c4744460e43e41b$var$transformFactories = [
    (0, $5f19451ebc03a1eb$export$f94509e55523febf)
];
/**
 * @type {Array<function(string): Projection|null>}
 */ const $9c4744460e43e41b$var$projectionFactories = [
    (0, $5f19451ebc03a1eb$export$3277980d225b59be)
];
let $9c4744460e43e41b$var$showCoordinateWarning = true;
function $9c4744460e43e41b$export$ed949affbc7c4223(disable) {
    const hide = disable === undefined ? true : disable;
    $9c4744460e43e41b$var$showCoordinateWarning = !hide;
}
function $9c4744460e43e41b$export$dd516654c5f598fb(input, output) {
    if (output !== undefined) {
        for(let i = 0, ii = input.length; i < ii; ++i)output[i] = input[i];
        output;
    } else output = input.slice();
    return output;
}
function $9c4744460e43e41b$export$83e8ab53904f8022(input, output) {
    if (output !== undefined && input !== output) {
        for(let i = 0, ii = input.length; i < ii; ++i)output[i] = input[i];
        input = output;
    }
    return input;
}
function $9c4744460e43e41b$export$59ae956cd3e343f7(projection) {
    (0, $f5ec5c943d804ecb$export$e16d8520af44a096)(projection.getCode(), projection);
    (0, $11b5dd198626e1de$export$e16d8520af44a096)(projection, projection, $9c4744460e43e41b$export$dd516654c5f598fb);
}
function $9c4744460e43e41b$export$638ad73f7aafb913(projections) {
    projections.forEach($9c4744460e43e41b$export$59ae956cd3e343f7);
}
function $9c4744460e43e41b$export$3988ae62b71be9a3(projectionLike) {
    if (!(typeof projectionLike === 'string')) return projectionLike;
    const projection = (0, $f5ec5c943d804ecb$export$3988ae62b71be9a3)(projectionLike);
    if (projection) return projection;
    for (const makeProjection of $9c4744460e43e41b$var$projectionFactories){
        const projection = makeProjection(projectionLike);
        if (projection) return projection;
    }
    return null;
}
function $9c4744460e43e41b$export$2d8f7b4eec383d44(projection, resolution, point, units) {
    projection = $9c4744460e43e41b$export$3988ae62b71be9a3(projection);
    let pointResolution;
    const getter = projection.getPointResolutionFunc();
    if (getter) {
        pointResolution = getter(resolution, point);
        if (units && units !== projection.getUnits()) {
            const metersPerUnit = projection.getMetersPerUnit();
            if (metersPerUnit) pointResolution = pointResolution * metersPerUnit / (0, $03edbd434a9e6608$export$1482081eec883108)[units];
        }
    } else {
        const projUnits = projection.getUnits();
        if (projUnits == 'degrees' && !units || units == 'degrees') pointResolution = resolution;
        else {
            // Estimate point resolution by transforming the center pixel to EPSG:4326,
            // measuring its width and height on the normal sphere, and taking the
            // average of the width and height.
            const toEPSG4326 = $9c4744460e43e41b$export$e3c4995a701c26a3(projection, $9c4744460e43e41b$export$3988ae62b71be9a3('EPSG:4326'));
            if (!toEPSG4326 && projUnits !== 'degrees') // no transform is available
            pointResolution = resolution * projection.getMetersPerUnit();
            else {
                let vertices = [
                    point[0] - resolution / 2,
                    point[1],
                    point[0] + resolution / 2,
                    point[1],
                    point[0],
                    point[1] - resolution / 2,
                    point[0],
                    point[1] + resolution / 2
                ];
                vertices = toEPSG4326(vertices, vertices, 2);
                const width = (0, $fb75384508533d8f$export$79376507b09a66f)(vertices.slice(0, 2), vertices.slice(2, 4));
                const height = (0, $fb75384508533d8f$export$79376507b09a66f)(vertices.slice(4, 6), vertices.slice(6, 8));
                pointResolution = (width + height) / 2;
            }
            const metersPerUnit = units ? (0, $03edbd434a9e6608$export$1482081eec883108)[units] : projection.getMetersPerUnit();
            if (metersPerUnit !== undefined) pointResolution /= metersPerUnit;
        }
    }
    return pointResolution;
}
function $9c4744460e43e41b$export$eeb8392580a05a37(projections) {
    $9c4744460e43e41b$export$638ad73f7aafb913(projections);
    projections.forEach(function(source) {
        projections.forEach(function(destination) {
            if (source !== destination) (0, $11b5dd198626e1de$export$e16d8520af44a096)(source, destination, $9c4744460e43e41b$export$dd516654c5f598fb);
        });
    });
}
function $9c4744460e43e41b$export$4856f21c2f184f24(projections1, projections2, forwardTransform, inverseTransform) {
    projections1.forEach(function(projection1) {
        projections2.forEach(function(projection2) {
            (0, $11b5dd198626e1de$export$e16d8520af44a096)(projection1, projection2, forwardTransform);
            (0, $11b5dd198626e1de$export$e16d8520af44a096)(projection2, projection1, inverseTransform);
        });
    });
}
function $9c4744460e43e41b$export$4860237d10380594() {
    (0, $f5ec5c943d804ecb$export$42ffd38884aecdac)();
    (0, $11b5dd198626e1de$export$42ffd38884aecdac)();
}
function $9c4744460e43e41b$export$549167224996a0fb(projection, defaultCode) {
    if (!projection) return $9c4744460e43e41b$export$3988ae62b71be9a3(defaultCode);
    if (typeof projection === 'string') return $9c4744460e43e41b$export$3988ae62b71be9a3(projection);
    return /** @type {Projection} */ projection;
}
function $9c4744460e43e41b$export$6b4aafd331159e0d(coordTransform) {
    return(/**
     * @param {Array<number>} input Input.
     * @param {Array<number>} [output] Output.
     * @param {number} [dimension] Dimensions that should be transformed.
     * @param {number} [stride] Stride.
     * @return {Array<number>} Output.
     */ function(input, output, dimension, stride) {
        const length = input.length;
        dimension = dimension !== undefined ? dimension : 2;
        stride = stride ?? dimension;
        output = output !== undefined ? output : new Array(length);
        for(let i = 0; i < length; i += stride){
            const point = coordTransform(input.slice(i, i + dimension));
            const pointLength = point.length;
            for(let j = 0, jj = stride; j < jj; ++j)output[i + j] = j >= pointLength ? input[i + j] : point[j];
        }
        return output;
    });
}
function $9c4744460e43e41b$export$6b1c2e6623f4f49d(source, destination, forward, inverse) {
    const sourceProj = $9c4744460e43e41b$export$3988ae62b71be9a3(source);
    const destProj = $9c4744460e43e41b$export$3988ae62b71be9a3(destination);
    (0, $11b5dd198626e1de$export$e16d8520af44a096)(sourceProj, destProj, $9c4744460e43e41b$export$6b4aafd331159e0d(forward));
    (0, $11b5dd198626e1de$export$e16d8520af44a096)(destProj, sourceProj, $9c4744460e43e41b$export$6b4aafd331159e0d(inverse));
}
function $9c4744460e43e41b$export$b15d9668511529b9(coordinate, projection) {
    $9c4744460e43e41b$export$ed949affbc7c4223();
    return $9c4744460e43e41b$export$51186ad6e864892a(coordinate, 'EPSG:4326', projection !== undefined ? projection : 'EPSG:3857');
}
function $9c4744460e43e41b$export$3fb495868742d370(coordinate, projection) {
    const lonLat = $9c4744460e43e41b$export$51186ad6e864892a(coordinate, projection !== undefined ? projection : 'EPSG:3857', 'EPSG:4326');
    const lon = lonLat[0];
    if (lon < -180 || lon > 180) lonLat[0] = (0, $6b000a049d919fe5$export$ba467bec01d66def)(lon + 180, 360) - 180;
    return lonLat;
}
function $9c4744460e43e41b$export$fe091d73a555748b(projection1, projection2) {
    if (projection1 === projection2) return true;
    const equalUnits = projection1.getUnits() === projection2.getUnits();
    if (projection1.getCode() === projection2.getCode()) return equalUnits;
    const transformFunc = $9c4744460e43e41b$export$e3c4995a701c26a3(projection1, projection2);
    return transformFunc === $9c4744460e43e41b$export$dd516654c5f598fb && equalUnits;
}
function $9c4744460e43e41b$export$e3c4995a701c26a3(source, destination) {
    const sourceCode = source.getCode();
    const destinationCode = destination.getCode();
    let transformFunc = (0, $11b5dd198626e1de$export$3988ae62b71be9a3)(sourceCode, destinationCode);
    if (transformFunc) return transformFunc;
    /**
   * @type {Transforms|null}
   */ let sourceTransforms = null;
    /**
   * @type {Transforms|null}
   */ let destinationTransforms = null;
    // lazily add projections if we have supported transforms
    for (const makeTransforms of $9c4744460e43e41b$var$transformFactories){
        if (!sourceTransforms) sourceTransforms = makeTransforms(source);
        if (!destinationTransforms) destinationTransforms = makeTransforms(destination);
    }
    if (!sourceTransforms && !destinationTransforms) return null;
    const intermediateCode = 'EPSG:4326';
    if (!destinationTransforms) {
        const toDestination = (0, $11b5dd198626e1de$export$3988ae62b71be9a3)(intermediateCode, destinationCode);
        if (toDestination) transformFunc = $9c4744460e43e41b$var$composeTransformFuncs(sourceTransforms.inverse, toDestination);
    } else if (!sourceTransforms) {
        const fromSource = (0, $11b5dd198626e1de$export$3988ae62b71be9a3)(sourceCode, intermediateCode);
        if (fromSource) transformFunc = $9c4744460e43e41b$var$composeTransformFuncs(fromSource, destinationTransforms.forward);
    } else transformFunc = $9c4744460e43e41b$var$composeTransformFuncs(sourceTransforms.inverse, destinationTransforms.forward);
    if (transformFunc) {
        $9c4744460e43e41b$export$59ae956cd3e343f7(source);
        $9c4744460e43e41b$export$59ae956cd3e343f7(destination);
        (0, $11b5dd198626e1de$export$e16d8520af44a096)(source, destination, transformFunc);
    }
    return transformFunc;
}
/**
 * @param {TransformFunction} t1 The first transform function.
 * @param {TransformFunction} t2 The second transform function.
 * @return {TransformFunction} The composed transform function.
 */ function $9c4744460e43e41b$var$composeTransformFuncs(t1, t2) {
    return function(input, output, dimensions, stride) {
        output = t1(input, output, dimensions, stride);
        return t2(output, output, dimensions, stride);
    };
}
function $9c4744460e43e41b$export$fce0c6cfca85ed96(source, destination) {
    const sourceProjection = $9c4744460e43e41b$export$3988ae62b71be9a3(source);
    const destinationProjection = $9c4744460e43e41b$export$3988ae62b71be9a3(destination);
    return $9c4744460e43e41b$export$e3c4995a701c26a3(sourceProjection, destinationProjection);
}
function $9c4744460e43e41b$export$51186ad6e864892a(coordinate, source, destination) {
    const transformFunc = $9c4744460e43e41b$export$fce0c6cfca85ed96(source, destination);
    if (!transformFunc) {
        const sourceCode = $9c4744460e43e41b$export$3988ae62b71be9a3(source).getCode();
        const destinationCode = $9c4744460e43e41b$export$3988ae62b71be9a3(destination).getCode();
        throw new Error(`No transform available between ${sourceCode} and ${destinationCode}`);
    }
    return transformFunc(coordinate, undefined, coordinate.length);
}
function $9c4744460e43e41b$export$751c68e0e0efff79(extent, source, destination, stops) {
    const transformFunc = $9c4744460e43e41b$export$fce0c6cfca85ed96(source, destination);
    return (0, $6da4c8ed3074c92b$export$9f9dcb98c894b623)(extent, transformFunc, undefined, stops);
}
function $9c4744460e43e41b$export$affbde93b1db73f8(point, sourceProjection, destinationProjection) {
    const transformFunc = $9c4744460e43e41b$export$e3c4995a701c26a3(sourceProjection, destinationProjection);
    return transformFunc(point);
}
/**
 * @type {Projection|null}
 */ let $9c4744460e43e41b$var$userProjection = null;
function $9c4744460e43e41b$export$d0aeadbeac54116e(projection) {
    $9c4744460e43e41b$var$userProjection = $9c4744460e43e41b$export$3988ae62b71be9a3(projection);
}
function $9c4744460e43e41b$export$1ae11279759d4e8f() {
    $9c4744460e43e41b$var$userProjection = null;
}
function $9c4744460e43e41b$export$3973b77d5f6f2790() {
    return $9c4744460e43e41b$var$userProjection;
}
function $9c4744460e43e41b$export$aa7494edfbe36197() {
    $9c4744460e43e41b$export$d0aeadbeac54116e('EPSG:4326');
}
function $9c4744460e43e41b$export$698f563af1ba02a5(coordinate, sourceProjection) {
    if (!$9c4744460e43e41b$var$userProjection) return coordinate;
    return $9c4744460e43e41b$export$51186ad6e864892a(coordinate, sourceProjection, $9c4744460e43e41b$var$userProjection);
}
function $9c4744460e43e41b$export$d4b8ec0b96db1ee2(coordinate, destProjection) {
    if (!$9c4744460e43e41b$var$userProjection) {
        if ($9c4744460e43e41b$var$showCoordinateWarning && !(0, $1bd0a226f9a16141$export$e9bab7fafb253603)(coordinate, [
            0,
            0
        ]) && coordinate[0] >= -180 && coordinate[0] <= 180 && coordinate[1] >= -90 && coordinate[1] <= 90) {
            $9c4744460e43e41b$var$showCoordinateWarning = false;
            (0, $8c65b0699f3f3f8e$export$c106dd0671a0fc2d)('Call useGeographic() from ol/proj once to work with [longitude, latitude] coordinates.');
        }
        return coordinate;
    }
    return $9c4744460e43e41b$export$51186ad6e864892a(coordinate, $9c4744460e43e41b$var$userProjection, destProjection);
}
function $9c4744460e43e41b$export$96bfd09e2cffb006(extent, sourceProjection) {
    if (!$9c4744460e43e41b$var$userProjection) return extent;
    return $9c4744460e43e41b$export$751c68e0e0efff79(extent, sourceProjection, $9c4744460e43e41b$var$userProjection);
}
function $9c4744460e43e41b$export$494be3a3a25689ca(extent, destProjection) {
    if (!$9c4744460e43e41b$var$userProjection) return extent;
    return $9c4744460e43e41b$export$751c68e0e0efff79(extent, $9c4744460e43e41b$var$userProjection, destProjection);
}
function $9c4744460e43e41b$export$b56bb8ad8b3a00e9(resolution, sourceProjection) {
    if (!$9c4744460e43e41b$var$userProjection) return resolution;
    const sourceMetersPerUnit = $9c4744460e43e41b$export$3988ae62b71be9a3(sourceProjection).getMetersPerUnit();
    const userMetersPerUnit = $9c4744460e43e41b$var$userProjection.getMetersPerUnit();
    return sourceMetersPerUnit && userMetersPerUnit ? resolution * sourceMetersPerUnit / userMetersPerUnit : resolution;
}
function $9c4744460e43e41b$export$bd1cd3b88140b906(resolution, destProjection) {
    if (!$9c4744460e43e41b$var$userProjection) return resolution;
    const destMetersPerUnit = $9c4744460e43e41b$export$3988ae62b71be9a3(destProjection).getMetersPerUnit();
    const userMetersPerUnit = $9c4744460e43e41b$var$userProjection.getMetersPerUnit();
    return destMetersPerUnit && userMetersPerUnit ? resolution * userMetersPerUnit / destMetersPerUnit : resolution;
}
function $9c4744460e43e41b$export$1873f9cfeb8bd1d6(sourceProj, destProj, transform) {
    return function(coord) {
        let transformed, worldsAway;
        if (sourceProj.canWrapX()) {
            const sourceExtent = sourceProj.getExtent();
            const sourceExtentWidth = (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(sourceExtent);
            coord = coord.slice(0);
            worldsAway = (0, $1bd0a226f9a16141$export$24e2b27d1ff0c1d5)(coord, sourceProj, sourceExtentWidth);
            if (worldsAway) // Move x to the real world
            coord[0] = coord[0] - worldsAway * sourceExtentWidth;
            coord[0] = (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(coord[0], sourceExtent[0], sourceExtent[2]);
            coord[1] = (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(coord[1], sourceExtent[1], sourceExtent[3]);
            transformed = transform(coord);
        } else transformed = transform(coord);
        if (worldsAway && destProj.canWrapX()) // Move transformed coordinate back to the offset world
        transformed[0] += worldsAway * (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(destProj.getExtent());
        return transformed;
    };
}
function $9c4744460e43e41b$export$86eed449eb2dcac4() {
    // Add transformations that don't alter coordinates to convert within set of
    // projections with equal meaning.
    $9c4744460e43e41b$export$eeb8392580a05a37((0, $84ad988f04807ab1$export$b508d7ad9a891c1b));
    $9c4744460e43e41b$export$eeb8392580a05a37((0, $b58ae362632b32c5$export$b508d7ad9a891c1b));
    // Add transformations to convert EPSG:4326 like coordinates to EPSG:3857 like
    // coordinates and back.
    $9c4744460e43e41b$export$4856f21c2f184f24((0, $b58ae362632b32c5$export$b508d7ad9a891c1b), (0, $84ad988f04807ab1$export$b508d7ad9a891c1b), (0, $84ad988f04807ab1$export$1ff8bb36c0983070), (0, $84ad988f04807ab1$export$8c71322ec28ed6b4));
}
$9c4744460e43e41b$export$86eed449eb2dcac4();


/**
 * @module ol/transform
 */ 
/**
 * An array representing an affine 2d transformation for use with
 * {@link module:ol/transform} functions. The array has 6 elements.
 * @typedef {!Array<number>} Transform
 * @api
 */ /**
 * Collection of affine 2d transformation functions. The functions work on an
 * array of 6 elements. The element order is compatible with the [SVGMatrix
 * interface](https://developer.mozilla.org/en-US/docs/Web/API/SVGMatrix) and is
 * a subset (elements a to f) of a 3×3 matrix:
 * ```
 * [ a c e ]
 * [ b d f ]
 * [ 0 0 1 ]
 * ```
 */ /**
 * @private
 * @type {Transform}
 */ const $e22e7611e69f42a9$var$tmp_ = new Array(6);
function $e22e7611e69f42a9$export$185802fd694ee1f5() {
    return [
        1,
        0,
        0,
        1,
        0,
        0
    ];
}
function $e22e7611e69f42a9$export$aad8462122ac592b(transform) {
    return $e22e7611e69f42a9$export$adaa4cf7ef1b65be(transform, 1, 0, 0, 1, 0, 0);
}
function $e22e7611e69f42a9$export$2060d2db72cce88f(transform1, transform2) {
    const a1 = transform1[0];
    const b1 = transform1[1];
    const c1 = transform1[2];
    const d1 = transform1[3];
    const e1 = transform1[4];
    const f1 = transform1[5];
    const a2 = transform2[0];
    const b2 = transform2[1];
    const c2 = transform2[2];
    const d2 = transform2[3];
    const e2 = transform2[4];
    const f2 = transform2[5];
    transform1[0] = a1 * a2 + c1 * b2;
    transform1[1] = b1 * a2 + d1 * b2;
    transform1[2] = a1 * c2 + c1 * d2;
    transform1[3] = b1 * c2 + d1 * d2;
    transform1[4] = a1 * e2 + c1 * f2 + e1;
    transform1[5] = b1 * e2 + d1 * f2 + f1;
    return transform1;
}
function $e22e7611e69f42a9$export$adaa4cf7ef1b65be(transform, a, b, c, d, e, f) {
    transform[0] = a;
    transform[1] = b;
    transform[2] = c;
    transform[3] = d;
    transform[4] = e;
    transform[5] = f;
    return transform;
}
function $e22e7611e69f42a9$export$42b4187a82d80ed0(transform1, transform2) {
    transform1[0] = transform2[0];
    transform1[1] = transform2[1];
    transform1[2] = transform2[2];
    transform1[3] = transform2[3];
    transform1[4] = transform2[4];
    transform1[5] = transform2[5];
    return transform1;
}
function $e22e7611e69f42a9$export$5635d7ef4b8fee1c(transform, coordinate) {
    const x = coordinate[0];
    const y = coordinate[1];
    coordinate[0] = transform[0] * x + transform[2] * y + transform[4];
    coordinate[1] = transform[1] * x + transform[3] * y + transform[5];
    return coordinate;
}
function $e22e7611e69f42a9$export$bb628a54ab399bc9(transform, angle) {
    const cos = Math.cos(angle);
    const sin = Math.sin(angle);
    return $e22e7611e69f42a9$export$2060d2db72cce88f(transform, $e22e7611e69f42a9$export$adaa4cf7ef1b65be($e22e7611e69f42a9$var$tmp_, cos, sin, -sin, cos, 0, 0));
}
function $e22e7611e69f42a9$export$dcdf75081b88279d(transform, x, y) {
    return $e22e7611e69f42a9$export$2060d2db72cce88f(transform, $e22e7611e69f42a9$export$adaa4cf7ef1b65be($e22e7611e69f42a9$var$tmp_, x, 0, 0, y, 0, 0));
}
function $e22e7611e69f42a9$export$3e4e33ea14aeb531(target, x, y) {
    return $e22e7611e69f42a9$export$adaa4cf7ef1b65be(target, x, 0, 0, y, 0, 0);
}
function $e22e7611e69f42a9$export$d73ee8ef04f5226a(transform, dx, dy) {
    return $e22e7611e69f42a9$export$2060d2db72cce88f(transform, $e22e7611e69f42a9$export$adaa4cf7ef1b65be($e22e7611e69f42a9$var$tmp_, 1, 0, 0, 1, dx, dy));
}
function $e22e7611e69f42a9$export$f672e0b6f7222cd7(transform, dx1, dy1, sx, sy, angle, dx2, dy2) {
    const sin = Math.sin(angle);
    const cos = Math.cos(angle);
    transform[0] = sx * cos;
    transform[1] = sy * sin;
    transform[2] = -sx * sin;
    transform[3] = sy * cos;
    transform[4] = dx2 * sx * cos - dy2 * sx * sin + dx1;
    transform[5] = dx2 * sy * sin + dy2 * sy * cos + dy1;
    return transform;
}
function $e22e7611e69f42a9$export$12a96a1aaf5558e3(dx1, dy1, sx, sy, angle, dx2, dy2) {
    return $e22e7611e69f42a9$export$f84e8e69fd4488a5($e22e7611e69f42a9$export$f672e0b6f7222cd7($e22e7611e69f42a9$export$185802fd694ee1f5(), dx1, dy1, sx, sy, angle, dx2, dy2));
}
function $e22e7611e69f42a9$export$6897c284b6f9f4dc(source) {
    return $e22e7611e69f42a9$export$bd70ea2a93c0fa4(source, source);
}
function $e22e7611e69f42a9$export$bd70ea2a93c0fa4(target, source) {
    const det = $e22e7611e69f42a9$export$a04698f914c55ed9(source);
    (0, $35d5ec884318008e$export$a7a9523472993e97)(det !== 0, 'Transformation matrix cannot be inverted');
    const a = source[0];
    const b = source[1];
    const c = source[2];
    const d = source[3];
    const e = source[4];
    const f = source[5];
    target[0] = d / det;
    target[1] = -b / det;
    target[2] = -c / det;
    target[3] = a / det;
    target[4] = (c * f - d * e) / det;
    target[5] = -(a * f - b * e) / det;
    return target;
}
function $e22e7611e69f42a9$export$a04698f914c55ed9(mat) {
    return mat[0] * mat[3] - mat[1] * mat[2];
}
/**
 * @type {Array}
 */ const $e22e7611e69f42a9$var$matrixPrecision = [
    1e5,
    1e5,
    1e5,
    1e5,
    2,
    2
];
function $e22e7611e69f42a9$export$f84e8e69fd4488a5(mat) {
    const transformString = 'matrix(' + mat.join(', ') + ')';
    return transformString;
}
/**
 * Create a transform from a CSS transform matrix string.
 * @param {string} cssTransform The CSS string to parse.
 * @return {!Transform} The transform.
 */ function $e22e7611e69f42a9$var$fromString(cssTransform) {
    const values = cssTransform.substring(7, cssTransform.length - 1).split(',');
    return values.map(parseFloat);
}
function $e22e7611e69f42a9$export$fe091d73a555748b(cssTransform1, cssTransform2) {
    const mat1 = $e22e7611e69f42a9$var$fromString(cssTransform1);
    const mat2 = $e22e7611e69f42a9$var$fromString(cssTransform2);
    for(let i = 0; i < 6; ++i){
        if (Math.round((mat1[i] - mat2[i]) * $e22e7611e69f42a9$var$matrixPrecision[i]) !== 0) return false;
    }
    return true;
}



/**
 * @module ol/geom/flat/transform
 */ /**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {import("../../transform.js").Transform} transform Transform.
 * @param {Array<number>} [dest] Destination.
 * @param {number} [destinationStride] Stride of destination coordinates; if unspecified, assumed to be 2.
 * @return {Array<number>} Transformed coordinates.
 */ function $14c6e714516e527b$export$b92b2dedcfff79de(flatCoordinates, offset, end, stride, transform, dest, destinationStride) {
    dest = dest ? dest : [];
    destinationStride = destinationStride ? destinationStride : 2;
    let i = 0;
    for(let j = offset; j < end; j += stride){
        const x = flatCoordinates[j];
        const y = flatCoordinates[j + 1];
        dest[i++] = transform[0] * x + transform[2] * y + transform[4];
        dest[i++] = transform[1] * x + transform[3] * y + transform[5];
        for(let k = 2; k < destinationStride; k++)dest[i++] = flatCoordinates[j + k];
    }
    if (dest && dest.length != i) dest.length = i;
    return dest;
}
function $14c6e714516e527b$export$bb628a54ab399bc9(flatCoordinates, offset, end, stride, angle, anchor, dest) {
    dest = dest ? dest : [];
    const cos = Math.cos(angle);
    const sin = Math.sin(angle);
    const anchorX = anchor[0];
    const anchorY = anchor[1];
    let i = 0;
    for(let j = offset; j < end; j += stride){
        const deltaX = flatCoordinates[j] - anchorX;
        const deltaY = flatCoordinates[j + 1] - anchorY;
        dest[i++] = anchorX + deltaX * cos - deltaY * sin;
        dest[i++] = anchorY + deltaX * sin + deltaY * cos;
        for(let k = j + 2; k < j + stride; ++k)dest[i++] = flatCoordinates[k];
    }
    if (dest && dest.length != i) dest.length = i;
    return dest;
}
function $14c6e714516e527b$export$dcdf75081b88279d(flatCoordinates, offset, end, stride, sx, sy, anchor, dest) {
    dest = dest ? dest : [];
    const anchorX = anchor[0];
    const anchorY = anchor[1];
    let i = 0;
    for(let j = offset; j < end; j += stride){
        const deltaX = flatCoordinates[j] - anchorX;
        const deltaY = flatCoordinates[j + 1] - anchorY;
        dest[i++] = anchorX + sx * deltaX;
        dest[i++] = anchorY + sy * deltaY;
        for(let k = j + 2; k < j + stride; ++k)dest[i++] = flatCoordinates[k];
    }
    if (dest && dest.length != i) dest.length = i;
    return dest;
}
function $14c6e714516e527b$export$d73ee8ef04f5226a(flatCoordinates, offset, end, stride, deltaX, deltaY, dest) {
    dest = dest ? dest : [];
    let i = 0;
    for(let j = offset; j < end; j += stride){
        dest[i++] = flatCoordinates[j] + deltaX;
        dest[i++] = flatCoordinates[j + 1] + deltaY;
        for(let k = j + 2; k < j + stride; ++k)dest[i++] = flatCoordinates[k];
    }
    if (dest && dest.length != i) dest.length = i;
    return dest;
}


/**
 * @typedef {'XY' | 'XYZ' | 'XYM' | 'XYZM'} GeometryLayout
 * The coordinate layout for geometries, indicating whether a 3rd or 4th z ('Z')
 * or measure ('M') coordinate is available.
 */ /**
 * @typedef {'Point' | 'LineString' | 'LinearRing' | 'Polygon' | 'MultiPoint' | 'MultiLineString' | 'MultiPolygon' | 'GeometryCollection' | 'Circle'} Type
 * The geometry type.  One of `'Point'`, `'LineString'`, `'LinearRing'`,
 * `'Polygon'`, `'MultiPoint'`, `'MultiLineString'`, `'MultiPolygon'`,
 * `'GeometryCollection'`, or `'Circle'`.
 */ /**
 * @type {import("../transform.js").Transform}
 */ const $50db89a00eb954f6$var$tmpTransform = (0, $e22e7611e69f42a9$export$185802fd694ee1f5)();
/** @type {import('../coordinate.js').Coordinate} */ const $50db89a00eb954f6$var$tmpPoint = [
    NaN,
    NaN
];
/**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Base class for vector geometries.
 *
 * To get notified of changes to the geometry, register a listener for the
 * generic `change` event on your geometry instance.
 *
 * @abstract
 * @api
 */ class $50db89a00eb954f6$var$Geometry extends (0, $b68b3d6e32e3074a$export$2e2bcd8739ae039) {
    constructor(){
        super();
        /**
     * @private
     * @type {import("../extent.js").Extent}
     */ this.extent_ = (0, $6da4c8ed3074c92b$export$fe201bb3bbe031e9)();
        /**
     * @private
     * @type {number}
     */ this.extentRevision_ = -1;
        /**
     * @protected
     * @type {number}
     */ this.simplifiedGeometryMaxMinSquaredTolerance = 0;
        /**
     * @protected
     * @type {number}
     */ this.simplifiedGeometryRevision = 0;
        /**
     * Get a transformed and simplified version of the geometry.
     * @abstract
     * @param {number} revision The geometry revision.
     * @param {number} squaredTolerance Squared tolerance.
     * @param {import("../proj.js").TransformFunction} [transform] Optional transform function.
     * @return {Geometry} Simplified geometry.
     */ this.simplifyTransformedInternal = (0, $013a1733c226ec50$export$ff83df6f9971435f)((revision, squaredTolerance, transform)=>{
            if (!transform) return this.getSimplifiedGeometry(squaredTolerance);
            const clone = this.clone();
            clone.applyTransform(transform);
            return clone.getSimplifiedGeometry(squaredTolerance);
        });
    }
    /**
   * Get a transformed and simplified version of the geometry.
   * @abstract
   * @param {number} squaredTolerance Squared tolerance.
   * @param {import("../proj.js").TransformFunction} [transform] Optional transform function.
   * @return {Geometry} Simplified geometry.
   */ simplifyTransformed(squaredTolerance, transform) {
        return this.simplifyTransformedInternal(this.getRevision(), squaredTolerance, transform);
    }
    /**
   * Make a complete copy of the geometry.
   * @abstract
   * @return {!Geometry} Clone.
   */ clone() {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * @abstract
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @return {boolean} Contains (x, y).
   */ containsXY(x, y) {
        return this.closestPointXY(x, y, $50db89a00eb954f6$var$tmpPoint, Number.MIN_VALUE) === 0;
    }
    /**
   * Return the closest point of the geometry to the passed point as
   * {@link module:ol/coordinate~Coordinate coordinate}.
   * @param {import("../coordinate.js").Coordinate} point Point.
   * @param {import("../coordinate.js").Coordinate} [closestPoint] Closest point.
   * @return {import("../coordinate.js").Coordinate} Closest point.
   * @api
   */ getClosestPoint(point, closestPoint) {
        closestPoint = closestPoint ? closestPoint : [
            NaN,
            NaN
        ];
        this.closestPointXY(point[0], point[1], closestPoint, Infinity);
        return closestPoint;
    }
    /**
   * Returns true if this geometry includes the specified coordinate. If the
   * coordinate is on the boundary of the geometry, returns false.
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @return {boolean} Contains coordinate.
   * @api
   */ intersectsCoordinate(coordinate) {
        return this.containsXY(coordinate[0], coordinate[1]);
    }
    /**
   * @abstract
   * @param {import("../extent.js").Extent} extent Extent.
   * @protected
   * @return {import("../extent.js").Extent} extent Extent.
   */ computeExtent(extent) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Get the extent of the geometry.
   * @param {import("../extent.js").Extent} [extent] Extent.
   * @return {import("../extent.js").Extent} extent Extent.
   * @api
   */ getExtent(extent) {
        if (this.extentRevision_ != this.getRevision()) {
            const extent = this.computeExtent(this.extent_);
            if (isNaN(extent[0]) || isNaN(extent[1])) (0, $6da4c8ed3074c92b$export$3e2152b047719fa1)(extent);
            this.extentRevision_ = this.getRevision();
        }
        return (0, $6da4c8ed3074c92b$export$6a4fe494c558c238)(this.extent_, extent);
    }
    /**
   * Rotate the geometry around a given coordinate. This modifies the geometry
   * coordinates in place.
   * @abstract
   * @param {number} angle Rotation angle in radians.
   * @param {import("../coordinate.js").Coordinate} anchor The rotation center.
   * @api
   */ rotate(angle, anchor) {
        (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Scale the geometry (with an optional origin).  This modifies the geometry
   * coordinates in place.
   * @abstract
   * @param {number} sx The scaling factor in the x-direction.
   * @param {number} [sy] The scaling factor in the y-direction (defaults to sx).
   * @param {import("../coordinate.js").Coordinate} [anchor] The scale origin (defaults to the center
   *     of the geometry extent).
   * @api
   */ scale(sx, sy, anchor) {
        (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Create a simplified version of this geometry.  For linestrings, this uses
   * the [Douglas Peucker](https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm)
   * algorithm.  For polygons, a quantization-based
   * simplification is used to preserve topology.
   * @param {number} tolerance The tolerance distance for simplification.
   * @return {Geometry} A new, simplified version of the original geometry.
   * @api
   */ simplify(tolerance) {
        return this.getSimplifiedGeometry(tolerance * tolerance);
    }
    /**
   * Create a simplified version of this geometry using the Douglas Peucker
   * algorithm.
   * See https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm.
   * @abstract
   * @param {number} squaredTolerance Squared tolerance.
   * @return {Geometry} Simplified geometry.
   */ getSimplifiedGeometry(squaredTolerance) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Get the type of this geometry.
   * @abstract
   * @return {Type} Geometry type.
   */ getType() {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Apply a transform function to the coordinates of the geometry.
   * The geometry is modified in place.
   * If you do not want the geometry modified in place, first `clone()` it and
   * then use this function on the clone.
   * @abstract
   * @param {import("../proj.js").TransformFunction} transformFn Transform function.
   * Called with a flat array of geometry coordinates.
   */ applyTransform(transformFn) {
        (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @abstract
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   */ intersectsExtent(extent) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Translate the geometry.  This modifies the geometry coordinates in place.  If
   * instead you want a new geometry, first `clone()` this geometry.
   * @abstract
   * @param {number} deltaX Delta X.
   * @param {number} deltaY Delta Y.
   * @api
   */ translate(deltaX, deltaY) {
        (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Transform each coordinate of the geometry from one coordinate reference
   * system to another. The geometry is modified in place.
   * For example, a line will be transformed to a line and a circle to a circle.
   * If you do not want the geometry modified in place, first `clone()` it and
   * then use this function on the clone.
   *
   * @param {import("../proj.js").ProjectionLike} source The current projection.  Can be a
   *     string identifier or a {@link module:ol/proj/Projection~Projection} object.
   * @param {import("../proj.js").ProjectionLike} destination The desired projection.  Can be a
   *     string identifier or a {@link module:ol/proj/Projection~Projection} object.
   * @return {this} This geometry.  Note that original geometry is
   *     modified in place.
   * @api
   */ transform(source, destination) {
        /** @type {import("../proj/Projection.js").default} */ const sourceProj = (0, $9c4744460e43e41b$export$3988ae62b71be9a3)(source);
        const transformFn = sourceProj.getUnits() == 'tile-pixels' ? function(inCoordinates, outCoordinates, stride) {
            const pixelExtent = sourceProj.getExtent();
            const projectedExtent = sourceProj.getWorldExtent();
            const scale = (0, $6da4c8ed3074c92b$export$c08559766941f856)(projectedExtent) / (0, $6da4c8ed3074c92b$export$c08559766941f856)(pixelExtent);
            (0, $e22e7611e69f42a9$export$f672e0b6f7222cd7)($50db89a00eb954f6$var$tmpTransform, projectedExtent[0], projectedExtent[3], scale, -scale, 0, 0, 0);
            const transformed = (0, $14c6e714516e527b$export$b92b2dedcfff79de)(inCoordinates, 0, inCoordinates.length, stride, $50db89a00eb954f6$var$tmpTransform, outCoordinates);
            const projTransform = (0, $9c4744460e43e41b$export$fce0c6cfca85ed96)(sourceProj, destination);
            if (projTransform) return projTransform(transformed, transformed, stride);
            return transformed;
        } : (0, $9c4744460e43e41b$export$fce0c6cfca85ed96)(sourceProj, destination);
        this.applyTransform(transformFn);
        return this;
    }
}
var $50db89a00eb954f6$export$2e2bcd8739ae039 = $50db89a00eb954f6$var$Geometry;



/**
 * @classdesc
 * Abstract base class; only used for creating subclasses; do not instantiate
 * in apps, as cannot be rendered.
 *
 * @abstract
 * @api
 */ class $c76e993e57efc8c4$var$SimpleGeometry extends (0, $50db89a00eb954f6$export$2e2bcd8739ae039) {
    constructor(){
        super();
        /**
     * @protected
     * @type {import("./Geometry.js").GeometryLayout}
     */ this.layout = 'XY';
        /**
     * @protected
     * @type {number}
     */ this.stride = 2;
        /**
     * @protected
     * @type {Array<number>}
     */ this.flatCoordinates;
    }
    /**
   * @param {import("../extent.js").Extent} extent Extent.
   * @protected
   * @return {import("../extent.js").Extent} extent Extent.
   * @override
   */ computeExtent(extent) {
        return (0, $6da4c8ed3074c92b$export$be0ab0bf96ca59ca)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, extent);
    }
    /**
   * @abstract
   * @return {Array<*> | null} Coordinates.
   */ getCoordinates() {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Return the first coordinate of the geometry.
   * @return {import("../coordinate.js").Coordinate} First coordinate.
   * @api
   */ getFirstCoordinate() {
        return this.flatCoordinates.slice(0, this.stride);
    }
    /**
   * @return {Array<number>} Flat coordinates.
   */ getFlatCoordinates() {
        return this.flatCoordinates;
    }
    /**
   * Return the last coordinate of the geometry.
   * @return {import("../coordinate.js").Coordinate} Last point.
   * @api
   */ getLastCoordinate() {
        return this.flatCoordinates.slice(this.flatCoordinates.length - this.stride);
    }
    /**
   * Return the {@link import("./Geometry.js").GeometryLayout layout} of the geometry.
   * @return {import("./Geometry.js").GeometryLayout} Layout.
   * @api
   */ getLayout() {
        return this.layout;
    }
    /**
   * Create a simplified version of this geometry using the Douglas Peucker algorithm.
   * @param {number} squaredTolerance Squared tolerance.
   * @return {SimpleGeometry} Simplified geometry.
   * @override
   */ getSimplifiedGeometry(squaredTolerance) {
        if (this.simplifiedGeometryRevision !== this.getRevision()) {
            this.simplifiedGeometryMaxMinSquaredTolerance = 0;
            this.simplifiedGeometryRevision = this.getRevision();
        }
        // If squaredTolerance is negative or if we know that simplification will not
        // have any effect then just return this.
        if (squaredTolerance < 0 || this.simplifiedGeometryMaxMinSquaredTolerance !== 0 && squaredTolerance <= this.simplifiedGeometryMaxMinSquaredTolerance) return this;
        const simplifiedGeometry = this.getSimplifiedGeometryInternal(squaredTolerance);
        const simplifiedFlatCoordinates = simplifiedGeometry.getFlatCoordinates();
        if (simplifiedFlatCoordinates.length < this.flatCoordinates.length) return simplifiedGeometry;
        // Simplification did not actually remove any coordinates.  We now know
        // that any calls to getSimplifiedGeometry with a squaredTolerance less
        // than or equal to the current squaredTolerance will also not have any
        // effect.  This allows us to short circuit simplification (saving CPU
        // cycles) and prevents the cache of simplified geometries from filling
        // up with useless identical copies of this geometry (saving memory).
        this.simplifiedGeometryMaxMinSquaredTolerance = squaredTolerance;
        return this;
    }
    /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {SimpleGeometry} Simplified geometry.
   * @protected
   */ getSimplifiedGeometryInternal(squaredTolerance) {
        return this;
    }
    /**
   * @return {number} Stride.
   */ getStride() {
        return this.stride;
    }
    /**
   * @param {import("./Geometry.js").GeometryLayout} layout Layout.
   * @param {Array<number>} flatCoordinates Flat coordinates.
   */ setFlatCoordinates(layout, flatCoordinates) {
        this.stride = $c76e993e57efc8c4$export$6af0c1b4a8549a43(layout);
        this.layout = layout;
        this.flatCoordinates = flatCoordinates;
    }
    /**
   * @abstract
   * @param {!Array<*>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   */ setCoordinates(coordinates, layout) {
        (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * @param {import("./Geometry.js").GeometryLayout|undefined} layout Layout.
   * @param {Array<*>} coordinates Coordinates.
   * @param {number} nesting Nesting.
   * @protected
   */ setLayout(layout, coordinates, nesting) {
        let stride;
        if (layout) stride = $c76e993e57efc8c4$export$6af0c1b4a8549a43(layout);
        else {
            for(let i = 0; i < nesting; ++i){
                if (coordinates.length === 0) {
                    this.layout = 'XY';
                    this.stride = 2;
                    return;
                }
                coordinates = /** @type {Array<unknown>} */ coordinates[0];
            }
            stride = coordinates.length;
            layout = $c76e993e57efc8c4$export$61bb6938093db2c8(stride);
        }
        this.layout = layout;
        this.stride = stride;
    }
    /**
   * Apply a transform function to the coordinates of the geometry.
   * The geometry is modified in place.
   * If you do not want the geometry modified in place, first `clone()` it and
   * then use this function on the clone.
   * @param {import("../proj.js").TransformFunction} transformFn Transform function.
   * Called with a flat array of geometry coordinates.
   * @api
   * @override
   */ applyTransform(transformFn) {
        if (this.flatCoordinates) {
            transformFn(this.flatCoordinates, this.flatCoordinates, this.layout.startsWith('XYZ') ? 3 : 2, this.stride);
            this.changed();
        }
    }
    /**
   * Rotate the geometry around a given coordinate. This modifies the geometry
   * coordinates in place.
   * @param {number} angle Rotation angle in counter-clockwise radians.
   * @param {import("../coordinate.js").Coordinate} anchor The rotation center.
   * @api
   * @override
   */ rotate(angle, anchor) {
        const flatCoordinates = this.getFlatCoordinates();
        if (flatCoordinates) {
            const stride = this.getStride();
            (0, $14c6e714516e527b$export$bb628a54ab399bc9)(flatCoordinates, 0, flatCoordinates.length, stride, angle, anchor, flatCoordinates);
            this.changed();
        }
    }
    /**
   * Scale the geometry (with an optional origin).  This modifies the geometry
   * coordinates in place.
   * @param {number} sx The scaling factor in the x-direction.
   * @param {number} [sy] The scaling factor in the y-direction (defaults to sx).
   * @param {import("../coordinate.js").Coordinate} [anchor] The scale origin (defaults to the center
   *     of the geometry extent).
   * @api
   * @override
   */ scale(sx, sy, anchor) {
        if (sy === undefined) sy = sx;
        if (!anchor) anchor = (0, $6da4c8ed3074c92b$export$c91255cadecfe081)(this.getExtent());
        const flatCoordinates = this.getFlatCoordinates();
        if (flatCoordinates) {
            const stride = this.getStride();
            (0, $14c6e714516e527b$export$dcdf75081b88279d)(flatCoordinates, 0, flatCoordinates.length, stride, sx, sy, anchor, flatCoordinates);
            this.changed();
        }
    }
    /**
   * Translate the geometry.  This modifies the geometry coordinates in place.  If
   * instead you want a new geometry, first `clone()` this geometry.
   * @param {number} deltaX Delta X.
   * @param {number} deltaY Delta Y.
   * @api
   * @override
   */ translate(deltaX, deltaY) {
        const flatCoordinates = this.getFlatCoordinates();
        if (flatCoordinates) {
            const stride = this.getStride();
            (0, $14c6e714516e527b$export$d73ee8ef04f5226a)(flatCoordinates, 0, flatCoordinates.length, stride, deltaX, deltaY, flatCoordinates);
            this.changed();
        }
    }
}
function $c76e993e57efc8c4$export$61bb6938093db2c8(stride) {
    let layout;
    if (stride == 2) layout = 'XY';
    else if (stride == 3) layout = 'XYZ';
    else if (stride == 4) layout = 'XYZM';
    return /** @type {import("./Geometry.js").GeometryLayout} */ layout;
}
function $c76e993e57efc8c4$export$6af0c1b4a8549a43(layout) {
    let stride;
    if (layout == 'XY') stride = 2;
    else if (layout == 'XYZ' || layout == 'XYM') stride = 3;
    else if (layout == 'XYZM') stride = 4;
    return /** @type {number} */ stride;
}
function $c76e993e57efc8c4$export$a3767472617c7861(simpleGeometry, transform, dest) {
    const flatCoordinates = simpleGeometry.getFlatCoordinates();
    if (!flatCoordinates) return null;
    const stride = simpleGeometry.getStride();
    return (0, $14c6e714516e527b$export$b92b2dedcfff79de)(flatCoordinates, 0, flatCoordinates.length, stride, transform, dest);
}
var $c76e993e57efc8c4$export$2e2bcd8739ae039 = $c76e993e57efc8c4$var$SimpleGeometry;


/**
 * @module ol/geom/flat/area
 */ /**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @return {number} Area.
 */ function $01ff26a2f986a1d0$export$3c5e1905f889266e(flatCoordinates, offset, end, stride) {
    let twiceArea = 0;
    const x0 = flatCoordinates[end - stride];
    const y0 = flatCoordinates[end - stride + 1];
    let dx1 = 0;
    let dy1 = 0;
    for(; offset < end; offset += stride){
        const dx2 = flatCoordinates[offset] - x0;
        const dy2 = flatCoordinates[offset + 1] - y0;
        twiceArea += dy1 * dx2 - dx1 * dy2;
        dx1 = dx2;
        dy1 = dy2;
    }
    return twiceArea / 2;
}
function $01ff26a2f986a1d0$export$7a8ee541dfdf2ed5(flatCoordinates, offset, ends, stride) {
    let area = 0;
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        area += $01ff26a2f986a1d0$export$3c5e1905f889266e(flatCoordinates, offset, end, stride);
        offset = end;
    }
    return area;
}
function $01ff26a2f986a1d0$export$78e139679ca7205(flatCoordinates, offset, endss, stride) {
    let area = 0;
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        area += $01ff26a2f986a1d0$export$7a8ee541dfdf2ed5(flatCoordinates, offset, ends, stride);
        offset = ends[ends.length - 1];
    }
    return area;
}


/**
 * @module ol/geom/flat/closest
 */ 
/**
 * Returns the point on the 2D line segment flatCoordinates[offset1] to
 * flatCoordinates[offset2] that is closest to the point (x, y).  Extra
 * dimensions are linearly interpolated.
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset1 Offset 1.
 * @param {number} offset2 Offset 2.
 * @param {number} stride Stride.
 * @param {number} x X.
 * @param {number} y Y.
 * @param {Array<number>} closestPoint Closest point.
 */ function $bf5604c1b8258b71$var$assignClosest(flatCoordinates, offset1, offset2, stride, x, y, closestPoint) {
    const x1 = flatCoordinates[offset1];
    const y1 = flatCoordinates[offset1 + 1];
    const dx = flatCoordinates[offset2] - x1;
    const dy = flatCoordinates[offset2 + 1] - y1;
    let offset;
    if (dx === 0 && dy === 0) offset = offset1;
    else {
        const t = ((x - x1) * dx + (y - y1) * dy) / (dx * dx + dy * dy);
        if (t > 1) offset = offset2;
        else if (t > 0) {
            for(let i = 0; i < stride; ++i)closestPoint[i] = (0, $6b000a049d919fe5$export$3a89f8d6f6bf6c9f)(flatCoordinates[offset1 + i], flatCoordinates[offset2 + i], t);
            closestPoint.length = stride;
            return;
        } else offset = offset1;
    }
    for(let i = 0; i < stride; ++i)closestPoint[i] = flatCoordinates[offset + i];
    closestPoint.length = stride;
}
function $bf5604c1b8258b71$export$bc2eb611ddf80103(flatCoordinates, offset, end, stride, max) {
    let x1 = flatCoordinates[offset];
    let y1 = flatCoordinates[offset + 1];
    for(offset += stride; offset < end; offset += stride){
        const x2 = flatCoordinates[offset];
        const y2 = flatCoordinates[offset + 1];
        const squaredDelta = (0, $6b000a049d919fe5$export$88e6ebb4fe54f538)(x1, y1, x2, y2);
        if (squaredDelta > max) max = squaredDelta;
        x1 = x2;
        y1 = y2;
    }
    return max;
}
function $bf5604c1b8258b71$export$fbf31c8f2668ed5a(flatCoordinates, offset, ends, stride, max) {
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        max = $bf5604c1b8258b71$export$bc2eb611ddf80103(flatCoordinates, offset, end, stride, max);
        offset = end;
    }
    return max;
}
function $bf5604c1b8258b71$export$37c18e6e7d50501a(flatCoordinates, offset, endss, stride, max) {
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        max = $bf5604c1b8258b71$export$fbf31c8f2668ed5a(flatCoordinates, offset, ends, stride, max);
        offset = ends[ends.length - 1];
    }
    return max;
}
function $bf5604c1b8258b71$export$4adc8e5135fb44c(flatCoordinates, offset, end, stride, maxDelta, isRing, x, y, closestPoint, minSquaredDistance, tmpPoint) {
    if (offset == end) return minSquaredDistance;
    let i, squaredDistance;
    if (maxDelta === 0) {
        // All points are identical, so just test the first point.
        squaredDistance = (0, $6b000a049d919fe5$export$88e6ebb4fe54f538)(x, y, flatCoordinates[offset], flatCoordinates[offset + 1]);
        if (squaredDistance < minSquaredDistance) {
            for(i = 0; i < stride; ++i)closestPoint[i] = flatCoordinates[offset + i];
            closestPoint.length = stride;
            return squaredDistance;
        }
        return minSquaredDistance;
    }
    tmpPoint = tmpPoint ? tmpPoint : [
        NaN,
        NaN
    ];
    let index = offset + stride;
    while(index < end){
        $bf5604c1b8258b71$var$assignClosest(flatCoordinates, index - stride, index, stride, x, y, tmpPoint);
        squaredDistance = (0, $6b000a049d919fe5$export$88e6ebb4fe54f538)(x, y, tmpPoint[0], tmpPoint[1]);
        if (squaredDistance < minSquaredDistance) {
            minSquaredDistance = squaredDistance;
            for(i = 0; i < stride; ++i)closestPoint[i] = tmpPoint[i];
            closestPoint.length = stride;
            index += stride;
        } else // Skip ahead multiple points, because we know that all the skipped
        // points cannot be any closer than the closest point we have found so
        // far.  We know this because we know how close the current point is, how
        // close the closest point we have found so far is, and the maximum
        // distance between consecutive points.  For example, if we're currently
        // at distance 10, the best we've found so far is 3, and that the maximum
        // distance between consecutive points is 2, then we'll need to skip at
        // least (10 - 3) / 2 == 3 (rounded down) points to have any chance of
        // finding a closer point.  We use Math.max(..., 1) to ensure that we
        // always advance at least one point, to avoid an infinite loop.
        index += stride * Math.max((Math.sqrt(squaredDistance) - Math.sqrt(minSquaredDistance)) / maxDelta | 0, 1);
    }
    if (isRing) {
        // Check the closing segment.
        $bf5604c1b8258b71$var$assignClosest(flatCoordinates, end - stride, offset, stride, x, y, tmpPoint);
        squaredDistance = (0, $6b000a049d919fe5$export$88e6ebb4fe54f538)(x, y, tmpPoint[0], tmpPoint[1]);
        if (squaredDistance < minSquaredDistance) {
            minSquaredDistance = squaredDistance;
            for(i = 0; i < stride; ++i)closestPoint[i] = tmpPoint[i];
            closestPoint.length = stride;
        }
    }
    return minSquaredDistance;
}
function $bf5604c1b8258b71$export$5a48a0eefcf14992(flatCoordinates, offset, ends, stride, maxDelta, isRing, x, y, closestPoint, minSquaredDistance, tmpPoint) {
    tmpPoint = tmpPoint ? tmpPoint : [
        NaN,
        NaN
    ];
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        minSquaredDistance = $bf5604c1b8258b71$export$4adc8e5135fb44c(flatCoordinates, offset, end, stride, maxDelta, isRing, x, y, closestPoint, minSquaredDistance, tmpPoint);
        offset = end;
    }
    return minSquaredDistance;
}
function $bf5604c1b8258b71$export$60e067685eb8f9c4(flatCoordinates, offset, endss, stride, maxDelta, isRing, x, y, closestPoint, minSquaredDistance, tmpPoint) {
    tmpPoint = tmpPoint ? tmpPoint : [
        NaN,
        NaN
    ];
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        minSquaredDistance = $bf5604c1b8258b71$export$5a48a0eefcf14992(flatCoordinates, offset, ends, stride, maxDelta, isRing, x, y, closestPoint, minSquaredDistance, tmpPoint);
        offset = ends[ends.length - 1];
    }
    return minSquaredDistance;
}


/**
 * @module ol/geom/flat/deflate
 */ /**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {import("../../coordinate.js").Coordinate} coordinate Coordinate.
 * @param {number} stride Stride.
 * @return {number} offset Offset.
 */ function $6b086aa46281540d$export$60815ead40ec79ab(flatCoordinates, offset, coordinate, stride) {
    for(let i = 0, ii = coordinate.length; i < ii; ++i)flatCoordinates[offset++] = coordinate[i];
    return offset;
}
function $6b086aa46281540d$export$5c4daf67e03c190f(flatCoordinates, offset, coordinates, stride) {
    for(let i = 0, ii = coordinates.length; i < ii; ++i){
        const coordinate = coordinates[i];
        for(let j = 0; j < stride; ++j)flatCoordinates[offset++] = coordinate[j];
    }
    return offset;
}
function $6b086aa46281540d$export$47c3746a74384d45(flatCoordinates, offset, coordinatess, stride, ends) {
    ends = ends ? ends : [];
    let i = 0;
    for(let j = 0, jj = coordinatess.length; j < jj; ++j){
        const end = $6b086aa46281540d$export$5c4daf67e03c190f(flatCoordinates, offset, coordinatess[j], stride);
        ends[i++] = end;
        offset = end;
    }
    ends.length = i;
    return ends;
}
function $6b086aa46281540d$export$f9f2bb59da4accd3(flatCoordinates, offset, coordinatesss, stride, endss) {
    endss = endss ? endss : [];
    let i = 0;
    for(let j = 0, jj = coordinatesss.length; j < jj; ++j){
        const ends = $6b086aa46281540d$export$47c3746a74384d45(flatCoordinates, offset, coordinatesss[j], stride, endss[i]);
        if (ends.length === 0) ends[0] = offset;
        endss[i++] = ends;
        offset = ends[ends.length - 1];
    }
    endss.length = i;
    return endss;
}


/**
 * @module ol/geom/flat/inflate
 */ /**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {Array<import("../../coordinate.js").Coordinate>} [coordinates] Coordinates.
 * @return {Array<import("../../coordinate.js").Coordinate>} Coordinates.
 */ function $5454470599558ddd$export$9c0934e4e9c3f61e(flatCoordinates, offset, end, stride, coordinates) {
    coordinates = coordinates !== undefined ? coordinates : [];
    let i = 0;
    for(let j = offset; j < end; j += stride)coordinates[i++] = flatCoordinates.slice(j, j + stride);
    coordinates.length = i;
    return coordinates;
}
function $5454470599558ddd$export$cbb9596fc0f40db2(flatCoordinates, offset, ends, stride, coordinatess) {
    coordinatess = coordinatess !== undefined ? coordinatess : [];
    let i = 0;
    for(let j = 0, jj = ends.length; j < jj; ++j){
        const end = ends[j];
        coordinatess[i++] = $5454470599558ddd$export$9c0934e4e9c3f61e(flatCoordinates, offset, end, stride, coordinatess[i]);
        offset = end;
    }
    coordinatess.length = i;
    return coordinatess;
}
function $5454470599558ddd$export$915c7058aeb4dfeb(flatCoordinates, offset, endss, stride, coordinatesss) {
    coordinatesss = coordinatesss !== undefined ? coordinatesss : [];
    let i = 0;
    for(let j = 0, jj = endss.length; j < jj; ++j){
        const ends = endss[j];
        coordinatesss[i++] = ends.length === 1 && ends[0] === offset ? [] : $5454470599558ddd$export$cbb9596fc0f40db2(flatCoordinates, offset, ends, stride, coordinatesss[i]);
        offset = ends[ends.length - 1];
    }
    coordinatesss.length = i;
    return coordinatesss;
}


/**
 * @module ol/geom/flat/simplify
 */ // Based on simplify-js https://github.com/mourner/simplify-js
// Copyright (c) 2012, Vladimir Agafonkin
// All rights reserved.
//
// Redistribution and use in source and binary forms, with or without
// modification, are permitted provided that the following conditions are met:
//
//    1. Redistributions of source code must retain the above copyright notice,
//       this list of conditions and the following disclaimer.
//
//    2. Redistributions in binary form must reproduce the above copyright
//       notice, this list of conditions and the following disclaimer in the
//       documentation and/or other materials provided with the distribution.
//
// THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
// AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
// IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
// ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE
// LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
// CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
// SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
// INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
// CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
// ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
// POSSIBILITY OF SUCH DAMAGE.

function $8780aae6970f5f65$export$2cbbcce9030b8734(flatCoordinates, offset, end, stride, squaredTolerance, highQuality, simplifiedFlatCoordinates) {
    simplifiedFlatCoordinates = simplifiedFlatCoordinates !== undefined ? simplifiedFlatCoordinates : [];
    if (!highQuality) {
        end = $8780aae6970f5f65$export$46dba205a0107e9e(flatCoordinates, offset, end, stride, squaredTolerance, simplifiedFlatCoordinates, 0);
        flatCoordinates = simplifiedFlatCoordinates;
        offset = 0;
        stride = 2;
    }
    simplifiedFlatCoordinates.length = $8780aae6970f5f65$export$ef693d1572e64fb8(flatCoordinates, offset, end, stride, squaredTolerance, simplifiedFlatCoordinates, 0);
    return simplifiedFlatCoordinates;
}
function $8780aae6970f5f65$export$ef693d1572e64fb8(flatCoordinates, offset, end, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset) {
    const n = (end - offset) / stride;
    if (n < 3) {
        for(; offset < end; offset += stride){
            simplifiedFlatCoordinates[simplifiedOffset++] = flatCoordinates[offset];
            simplifiedFlatCoordinates[simplifiedOffset++] = flatCoordinates[offset + 1];
        }
        return simplifiedOffset;
    }
    /** @type {Array<number>} */ const markers = new Array(n);
    markers[0] = 1;
    markers[n - 1] = 1;
    /** @type {Array<number>} */ const stack = [
        offset,
        end - stride
    ];
    let index = 0;
    while(stack.length > 0){
        const last = stack.pop();
        const first = stack.pop();
        let maxSquaredDistance = 0;
        const x1 = flatCoordinates[first];
        const y1 = flatCoordinates[first + 1];
        const x2 = flatCoordinates[last];
        const y2 = flatCoordinates[last + 1];
        for(let i = first + stride; i < last; i += stride){
            const x = flatCoordinates[i];
            const y = flatCoordinates[i + 1];
            const squaredDistance = (0, $6b000a049d919fe5$export$251bb0a9cef172e6)(x, y, x1, y1, x2, y2);
            if (squaredDistance > maxSquaredDistance) {
                index = i;
                maxSquaredDistance = squaredDistance;
            }
        }
        if (maxSquaredDistance > squaredTolerance) {
            markers[(index - offset) / stride] = 1;
            if (first + stride < index) stack.push(first, index);
            if (index + stride < last) stack.push(index, last);
        }
    }
    for(let i = 0; i < n; ++i)if (markers[i]) {
        simplifiedFlatCoordinates[simplifiedOffset++] = flatCoordinates[offset + i * stride];
        simplifiedFlatCoordinates[simplifiedOffset++] = flatCoordinates[offset + i * stride + 1];
    }
    return simplifiedOffset;
}
function $8780aae6970f5f65$export$cedb9900c0b225c2(flatCoordinates, offset, ends, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEnds) {
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        simplifiedOffset = $8780aae6970f5f65$export$ef693d1572e64fb8(flatCoordinates, offset, end, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset);
        simplifiedEnds.push(simplifiedOffset);
        offset = end;
    }
    return simplifiedOffset;
}
function $8780aae6970f5f65$export$5d74fb54bb752ea0(flatCoordinates, offset, endss, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEndss) {
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        /** @type {Array<number>} */ const simplifiedEnds = [];
        simplifiedOffset = $8780aae6970f5f65$export$cedb9900c0b225c2(flatCoordinates, offset, ends, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEnds);
        simplifiedEndss.push(simplifiedEnds);
        offset = ends[ends.length - 1];
    }
    return simplifiedOffset;
}
function $8780aae6970f5f65$export$46dba205a0107e9e(flatCoordinates, offset, end, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset) {
    if (end <= offset + stride) {
        // zero or one point, no simplification possible, so copy and return
        for(; offset < end; offset += stride){
            simplifiedFlatCoordinates[simplifiedOffset++] = flatCoordinates[offset];
            simplifiedFlatCoordinates[simplifiedOffset++] = flatCoordinates[offset + 1];
        }
        return simplifiedOffset;
    }
    let x1 = flatCoordinates[offset];
    let y1 = flatCoordinates[offset + 1];
    // copy first point
    simplifiedFlatCoordinates[simplifiedOffset++] = x1;
    simplifiedFlatCoordinates[simplifiedOffset++] = y1;
    let x2 = x1;
    let y2 = y1;
    for(offset += stride; offset < end; offset += stride){
        x2 = flatCoordinates[offset];
        y2 = flatCoordinates[offset + 1];
        if ((0, $6b000a049d919fe5$export$88e6ebb4fe54f538)(x1, y1, x2, y2) > squaredTolerance) {
            // copy point at offset
            simplifiedFlatCoordinates[simplifiedOffset++] = x2;
            simplifiedFlatCoordinates[simplifiedOffset++] = y2;
            x1 = x2;
            y1 = y2;
        }
    }
    if (x2 != x1 || y2 != y1) {
        // copy last point
        simplifiedFlatCoordinates[simplifiedOffset++] = x2;
        simplifiedFlatCoordinates[simplifiedOffset++] = y2;
    }
    return simplifiedOffset;
}
function $8780aae6970f5f65$export$51a0620f7a28532b(value, tolerance) {
    return tolerance * Math.round(value / tolerance);
}
function $8780aae6970f5f65$export$b84e8d2c4920a0c6(flatCoordinates, offset, end, stride, tolerance, simplifiedFlatCoordinates, simplifiedOffset) {
    // do nothing if the line is empty
    if (offset == end) return simplifiedOffset;
    // snap the first coordinate (P1)
    let x1 = $8780aae6970f5f65$export$51a0620f7a28532b(flatCoordinates[offset], tolerance);
    let y1 = $8780aae6970f5f65$export$51a0620f7a28532b(flatCoordinates[offset + 1], tolerance);
    offset += stride;
    // add the first coordinate to the output
    simplifiedFlatCoordinates[simplifiedOffset++] = x1;
    simplifiedFlatCoordinates[simplifiedOffset++] = y1;
    // find the next coordinate that does not snap to the same value as the first
    // coordinate (P2)
    let x2, y2;
    do {
        x2 = $8780aae6970f5f65$export$51a0620f7a28532b(flatCoordinates[offset], tolerance);
        y2 = $8780aae6970f5f65$export$51a0620f7a28532b(flatCoordinates[offset + 1], tolerance);
        offset += stride;
        if (offset == end) {
            // all coordinates snap to the same value, the line collapses to a point
            // push the last snapped value anyway to ensure that the output contains
            // at least two points
            // FIXME should we really return at least two points anyway?
            simplifiedFlatCoordinates[simplifiedOffset++] = x2;
            simplifiedFlatCoordinates[simplifiedOffset++] = y2;
            return simplifiedOffset;
        }
    }while (x2 == x1 && y2 == y1);
    while(offset < end){
        // snap the next coordinate (P3)
        const x3 = $8780aae6970f5f65$export$51a0620f7a28532b(flatCoordinates[offset], tolerance);
        const y3 = $8780aae6970f5f65$export$51a0620f7a28532b(flatCoordinates[offset + 1], tolerance);
        offset += stride;
        // skip P3 if it is equal to P2
        if (x3 == x2 && y3 == y2) continue;
        // calculate the delta between P1 and P2
        const dx1 = x2 - x1;
        const dy1 = y2 - y1;
        // calculate the delta between P3 and P1
        const dx2 = x3 - x1;
        const dy2 = y3 - y1;
        // if P1, P2, and P3 are colinear and P3 is further from P1 than P2 is from
        // P1 in the same direction then P2 is on the straight line between P1 and
        // P3
        if (dx1 * dy2 == dy1 * dx2 && (dx1 < 0 && dx2 < dx1 || dx1 == dx2 || dx1 > 0 && dx2 > dx1) && (dy1 < 0 && dy2 < dy1 || dy1 == dy2 || dy1 > 0 && dy2 > dy1)) {
            // discard P2 and set P2 = P3
            x2 = x3;
            y2 = y3;
            continue;
        }
        // either P1, P2, and P3 are not colinear, or they are colinear but P3 is
        // between P3 and P1 or on the opposite half of the line to P2.  add P2,
        // and continue with P1 = P2 and P2 = P3
        simplifiedFlatCoordinates[simplifiedOffset++] = x2;
        simplifiedFlatCoordinates[simplifiedOffset++] = y2;
        x1 = x2;
        y1 = y2;
        x2 = x3;
        y2 = y3;
    }
    // add the last point (P2)
    simplifiedFlatCoordinates[simplifiedOffset++] = x2;
    simplifiedFlatCoordinates[simplifiedOffset++] = y2;
    return simplifiedOffset;
}
function $8780aae6970f5f65$export$60a9904b67f8d51b(flatCoordinates, offset, ends, stride, tolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEnds) {
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        simplifiedOffset = $8780aae6970f5f65$export$b84e8d2c4920a0c6(flatCoordinates, offset, end, stride, tolerance, simplifiedFlatCoordinates, simplifiedOffset);
        simplifiedEnds.push(simplifiedOffset);
        offset = end;
    }
    return simplifiedOffset;
}
function $8780aae6970f5f65$export$b9acf67ef05cd17c(flatCoordinates, offset, endss, stride, tolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEndss) {
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        /** @type {Array<number>} */ const simplifiedEnds = [];
        simplifiedOffset = $8780aae6970f5f65$export$60a9904b67f8d51b(flatCoordinates, offset, ends, stride, tolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEnds);
        simplifiedEndss.push(simplifiedEnds);
        offset = ends[ends.length - 1];
    }
    return simplifiedOffset;
}


/**
 * @classdesc
 * Linear ring geometry. Only used as part of polygon; cannot be rendered
 * on its own.
 *
 * @api
 */ class $548636579b4087f2$var$LinearRing extends (0, $c76e993e57efc8c4$export$2e2bcd8739ae039) {
    /**
   * @param {Array<import("../coordinate.js").Coordinate>|Array<number>} coordinates Coordinates.
   *     For internal use, flat coordinates in combination with `layout` are also accepted.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   */ constructor(coordinates, layout){
        super();
        /**
     * @private
     * @type {number}
     */ this.maxDelta_ = -1;
        /**
     * @private
     * @type {number}
     */ this.maxDeltaRevision_ = -1;
        if (layout !== undefined && !Array.isArray(coordinates[0])) this.setFlatCoordinates(layout, /** @type {Array<number>} */ coordinates);
        else this.setCoordinates(/** @type {Array<import("../coordinate.js").Coordinate>} */ coordinates, layout);
    }
    /**
   * Make a complete copy of the geometry.
   * @return {!LinearRing} Clone.
   * @api
   * @override
   */ clone() {
        return new $548636579b4087f2$var$LinearRing(this.flatCoordinates.slice(), this.layout);
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   * @override
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < (0, $6da4c8ed3074c92b$export$cbe64c389534206f)(this.getExtent(), x, y)) return minSquaredDistance;
        if (this.maxDeltaRevision_ != this.getRevision()) {
            this.maxDelta_ = Math.sqrt((0, $bf5604c1b8258b71$export$bc2eb611ddf80103)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, 0));
            this.maxDeltaRevision_ = this.getRevision();
        }
        return (0, $bf5604c1b8258b71$export$4adc8e5135fb44c)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, this.maxDelta_, true, x, y, closestPoint, minSquaredDistance);
    }
    /**
   * Return the area of the linear ring on projected plane.
   * @return {number} Area (on projected plane).
   * @api
   */ getArea() {
        return (0, $01ff26a2f986a1d0$export$3c5e1905f889266e)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride);
    }
    /**
   * Return the coordinates of the linear ring.
   * @return {Array<import("../coordinate.js").Coordinate>} Coordinates.
   * @api
   * @override
   */ getCoordinates() {
        return (0, $5454470599558ddd$export$9c0934e4e9c3f61e)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride);
    }
    /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {LinearRing} Simplified LinearRing.
   * @protected
   * @override
   */ getSimplifiedGeometryInternal(squaredTolerance) {
        /** @type {Array<number>} */ const simplifiedFlatCoordinates = [];
        simplifiedFlatCoordinates.length = (0, $8780aae6970f5f65$export$ef693d1572e64fb8)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, squaredTolerance, simplifiedFlatCoordinates, 0);
        return new $548636579b4087f2$var$LinearRing(simplifiedFlatCoordinates, 'XY');
    }
    /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   * @override
   */ getType() {
        return 'LinearRing';
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   * @override
   */ intersectsExtent(extent) {
        return false;
    }
    /**
   * Set the coordinates of the linear ring.
   * @param {!Array<import("../coordinate.js").Coordinate>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   * @override
   */ setCoordinates(coordinates, layout) {
        this.setLayout(layout, coordinates, 1);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        this.flatCoordinates.length = (0, $6b086aa46281540d$export$5c4daf67e03c190f)(this.flatCoordinates, 0, coordinates, this.stride);
        this.changed();
    }
}
var $548636579b4087f2$export$2e2bcd8739ae039 = $548636579b4087f2$var$LinearRing;


/**
 * @module ol/geom/Point
 */ 



/**
 * @classdesc
 * Point geometry.
 *
 * @api
 */ class $6eced4c969949f6b$var$Point extends (0, $c76e993e57efc8c4$export$2e2bcd8739ae039) {
    /**
   * @param {import("../coordinate.js").Coordinate} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   */ constructor(coordinates, layout){
        super();
        this.setCoordinates(coordinates, layout);
    }
    /**
   * Make a complete copy of the geometry.
   * @return {!Point} Clone.
   * @api
   * @override
   */ clone() {
        const point = new $6eced4c969949f6b$var$Point(this.flatCoordinates.slice(), this.layout);
        point.applyProperties(this);
        return point;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   * @override
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        const flatCoordinates = this.flatCoordinates;
        const squaredDistance = (0, $6b000a049d919fe5$export$88e6ebb4fe54f538)(x, y, flatCoordinates[0], flatCoordinates[1]);
        if (squaredDistance < minSquaredDistance) {
            const stride = this.stride;
            for(let i = 0; i < stride; ++i)closestPoint[i] = flatCoordinates[i];
            closestPoint.length = stride;
            return squaredDistance;
        }
        return minSquaredDistance;
    }
    /**
   * Return the coordinate of the point.
   * @return {import("../coordinate.js").Coordinate} Coordinates.
   * @api
   * @override
   */ getCoordinates() {
        return this.flatCoordinates.slice();
    }
    /**
   * @param {import("../extent.js").Extent} extent Extent.
   * @protected
   * @return {import("../extent.js").Extent} extent Extent.
   * @override
   */ computeExtent(extent) {
        return (0, $6da4c8ed3074c92b$export$4838bf78d04a9440)(this.flatCoordinates, extent);
    }
    /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   * @override
   */ getType() {
        return 'Point';
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   * @override
   */ intersectsExtent(extent) {
        return (0, $6da4c8ed3074c92b$export$805bdfd6d6690e97)(extent, this.flatCoordinates[0], this.flatCoordinates[1]);
    }
    /**
   * @param {!Array<*>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   * @override
   */ setCoordinates(coordinates, layout) {
        this.setLayout(layout, coordinates, 0);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        this.flatCoordinates.length = (0, $6b086aa46281540d$export$60815ead40ec79ab)(this.flatCoordinates, 0, coordinates, this.stride);
        this.changed();
    }
}
var $6eced4c969949f6b$export$2e2bcd8739ae039 = $6eced4c969949f6b$var$Point;





/**
 * @module ol/geom/flat/contains
 */ 
function $239aa88e7a573859$export$cedabedc7ac0e138(flatCoordinates, offset, end, stride, extent) {
    const outside = (0, $6da4c8ed3074c92b$export$f9ed8a3d123a08e2)(extent, /**
     * @param {import("../../coordinate.js").Coordinate} coordinate Coordinate.
     * @return {boolean} Contains (x, y).
     */ function(coordinate) {
        return !$239aa88e7a573859$export$949a7a3a4b6f34fa(flatCoordinates, offset, end, stride, coordinate[0], coordinate[1]);
    });
    return !outside;
}
function $239aa88e7a573859$export$949a7a3a4b6f34fa(flatCoordinates, offset, end, stride, x, y) {
    // https://web.archive.org/web/20210504233957/http://geomalgorithms.com/a03-_inclusion.html
    // Copyright 2000 softSurfer, 2012 Dan Sunday
    // This code may be freely used and modified for any purpose
    // providing that this copyright notice is included with it.
    // SoftSurfer makes no warranty for this code, and cannot be held
    // liable for any real or imagined damage resulting from its use.
    // Users of this code must verify correctness for their application.
    let wn = 0;
    let x1 = flatCoordinates[end - stride];
    let y1 = flatCoordinates[end - stride + 1];
    for(; offset < end; offset += stride){
        const x2 = flatCoordinates[offset];
        const y2 = flatCoordinates[offset + 1];
        if (y1 <= y) {
            if (y2 > y && (x2 - x1) * (y - y1) - (x - x1) * (y2 - y1) > 0) wn++;
        } else if (y2 <= y && (x2 - x1) * (y - y1) - (x - x1) * (y2 - y1) < 0) wn--;
        x1 = x2;
        y1 = y2;
    }
    return wn !== 0;
}
function $239aa88e7a573859$export$ae868c0f6acc3355(flatCoordinates, offset, ends, stride, x, y) {
    if (ends.length === 0) return false;
    if (!$239aa88e7a573859$export$949a7a3a4b6f34fa(flatCoordinates, offset, ends[0], stride, x, y)) return false;
    for(let i = 1, ii = ends.length; i < ii; ++i){
        if ($239aa88e7a573859$export$949a7a3a4b6f34fa(flatCoordinates, ends[i - 1], ends[i], stride, x, y)) return false;
    }
    return true;
}
function $239aa88e7a573859$export$c760d9d16cf92043(flatCoordinates, offset, endss, stride, x, y) {
    if (endss.length === 0) return false;
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        if ($239aa88e7a573859$export$ae868c0f6acc3355(flatCoordinates, offset, ends, stride, x, y)) return true;
        offset = ends[ends.length - 1];
    }
    return false;
}




/**
 * @module ol/geom/flat/interiorpoint
 */ 

function $2166f19777f69377$export$50e3b25928a5e892(flatCoordinates, offset, ends, stride, flatCenters, flatCentersOffset, dest) {
    let i, ii, x, x1, x2, y1, y2;
    const y = flatCenters[flatCentersOffset + 1];
    /** @type {Array<number>} */ const intersections = [];
    // Calculate intersections with the horizontal line
    for(let r = 0, rr = ends.length; r < rr; ++r){
        const end = ends[r];
        x1 = flatCoordinates[end - stride];
        y1 = flatCoordinates[end - stride + 1];
        for(i = offset; i < end; i += stride){
            x2 = flatCoordinates[i];
            y2 = flatCoordinates[i + 1];
            if (y <= y1 && y2 <= y || y1 <= y && y <= y2) {
                x = (y - y1) / (y2 - y1) * (x2 - x1) + x1;
                intersections.push(x);
            }
            x1 = x2;
            y1 = y2;
        }
    }
    // Find the longest segment of the horizontal line that has its center point
    // inside the linear ring.
    let pointX = NaN;
    let maxSegmentLength = -Infinity;
    intersections.sort((0, $b998d41b678ed5d1$export$fcb633242ef15540));
    x1 = intersections[0];
    for(i = 1, ii = intersections.length; i < ii; ++i){
        x2 = intersections[i];
        const segmentLength = Math.abs(x2 - x1);
        if (segmentLength > maxSegmentLength) {
            x = (x1 + x2) / 2;
            if ((0, $239aa88e7a573859$export$ae868c0f6acc3355)(flatCoordinates, offset, ends, stride, x, y)) {
                pointX = x;
                maxSegmentLength = segmentLength;
            }
        }
        x1 = x2;
    }
    if (isNaN(pointX)) // There is no horizontal line that has its center point inside the linear
    // ring.  Use the center of the the linear ring's extent.
    pointX = flatCenters[flatCentersOffset];
    if (dest) {
        dest.push(pointX, y, maxSegmentLength);
        return dest;
    }
    return [
        pointX,
        y,
        maxSegmentLength
    ];
}
function $2166f19777f69377$export$11463803eda8a372(flatCoordinates, offset, endss, stride, flatCenters) {
    /** @type {Array<number>} */ let interiorPoints = [];
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        interiorPoints = $2166f19777f69377$export$50e3b25928a5e892(flatCoordinates, offset, ends, stride, flatCenters, 2 * i, interiorPoints);
        offset = ends[ends.length - 1];
    }
    return interiorPoints;
}


/**
 * @module ol/geom/flat/intersectsextent
 */ 

/**
 * @module ol/geom/flat/segments
 */ /**
 * This function calls `callback` for each segment of the flat coordinates
 * array. If the callback returns a truthy value the function returns that
 * value immediately. Otherwise the function returns `false`.
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {function(import("../../coordinate.js").Coordinate, import("../../coordinate.js").Coordinate): T} callback Function
 *     called for each segment.
 * @return {T|boolean} Value.
 * @template T
 */ function $3e64078bffae1cbd$export$4b80e395e36b5a56(flatCoordinates, offset, end, stride, callback) {
    let ret;
    offset += stride;
    for(; offset < end; offset += stride){
        ret = callback(flatCoordinates.slice(offset - stride, offset), flatCoordinates.slice(offset, offset + stride));
        if (ret) return ret;
    }
    return false;
}
function $3e64078bffae1cbd$export$3f024338373820dc(segment1, segment2) {
    const [a, b] = segment1;
    const [c, d] = segment2;
    const t = ((a[0] - c[0]) * (c[1] - d[1]) - (a[1] - c[1]) * (c[0] - d[0])) / ((a[0] - b[0]) * (c[1] - d[1]) - (a[1] - b[1]) * (c[0] - d[0]));
    const u = ((a[0] - c[0]) * (a[1] - b[1]) - (a[1] - c[1]) * (a[0] - b[0])) / ((a[0] - b[0]) * (c[1] - d[1]) - (a[1] - b[1]) * (c[0] - d[0]));
    // Check if lines actually intersect
    if (0 <= t && t <= 1 && 0 <= u && u <= 1) return [
        a[0] + t * (b[0] - a[0]),
        a[1] + t * (b[1] - a[1])
    ];
    return undefined;
}


function $acee589e5b390c5c$export$40d8d71841a3d779(flatCoordinates, offset, end, stride, extent, coordinatesExtent) {
    coordinatesExtent = coordinatesExtent ?? (0, $6da4c8ed3074c92b$export$30570204156ffd18)((0, $6da4c8ed3074c92b$export$fe201bb3bbe031e9)(), flatCoordinates, offset, end, stride);
    if (!(0, $6da4c8ed3074c92b$export$7b0a31e10bbff018)(extent, coordinatesExtent)) return false;
    if (coordinatesExtent[0] >= extent[0] && coordinatesExtent[2] <= extent[2] || coordinatesExtent[1] >= extent[1] && coordinatesExtent[3] <= extent[3]) return true;
    return (0, $3e64078bffae1cbd$export$4b80e395e36b5a56)(flatCoordinates, offset, end, stride, /**
     * @param {import("../../coordinate.js").Coordinate} point1 Start point.
     * @param {import("../../coordinate.js").Coordinate} point2 End point.
     * @return {boolean} `true` if the segment and the extent intersect,
     *     `false` otherwise.
     */ function(point1, point2) {
        return (0, $6da4c8ed3074c92b$export$a6a5a7a461419425)(extent, point1, point2);
    });
}
function $acee589e5b390c5c$export$fdb1d8e850bf7937(flatCoordinates, offset, ends, stride, extent) {
    for(let i = 0, ii = ends.length; i < ii; ++i){
        if ($acee589e5b390c5c$export$40d8d71841a3d779(flatCoordinates, offset, ends[i], stride, extent)) return true;
        offset = ends[i];
    }
    return false;
}
function $acee589e5b390c5c$export$830a0dafbb2ef1c5(flatCoordinates, offset, end, stride, extent) {
    if ($acee589e5b390c5c$export$40d8d71841a3d779(flatCoordinates, offset, end, stride, extent)) return true;
    if ((0, $239aa88e7a573859$export$949a7a3a4b6f34fa)(flatCoordinates, offset, end, stride, extent[0], extent[1])) return true;
    if ((0, $239aa88e7a573859$export$949a7a3a4b6f34fa)(flatCoordinates, offset, end, stride, extent[0], extent[3])) return true;
    if ((0, $239aa88e7a573859$export$949a7a3a4b6f34fa)(flatCoordinates, offset, end, stride, extent[2], extent[1])) return true;
    if ((0, $239aa88e7a573859$export$949a7a3a4b6f34fa)(flatCoordinates, offset, end, stride, extent[2], extent[3])) return true;
    return false;
}
function $acee589e5b390c5c$export$76dcd8f8f83b6ddb(flatCoordinates, offset, ends, stride, extent) {
    if (!$acee589e5b390c5c$export$830a0dafbb2ef1c5(flatCoordinates, offset, ends[0], stride, extent)) return false;
    if (ends.length === 1) return true;
    for(let i = 1, ii = ends.length; i < ii; ++i)if ((0, $239aa88e7a573859$export$cedabedc7ac0e138)(flatCoordinates, ends[i - 1], ends[i], stride, extent)) {
        if (!$acee589e5b390c5c$export$40d8d71841a3d779(flatCoordinates, ends[i - 1], ends[i], stride, extent)) return false;
    }
    return true;
}
function $acee589e5b390c5c$export$77b72fa3792f5bf0(flatCoordinates, offset, endss, stride, extent) {
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        if ($acee589e5b390c5c$export$76dcd8f8f83b6ddb(flatCoordinates, offset, ends, stride, extent)) return true;
        offset = ends[ends.length - 1];
    }
    return false;
}


/**
 * @module ol/geom/flat/orient
 */ /**
 * @module ol/geom/flat/reverse
 */ /**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 */ function $155dc783a4ec227e$export$741858880c96b18c(flatCoordinates, offset, end, stride) {
    while(offset < end - stride){
        for(let i = 0; i < stride; ++i){
            const tmp = flatCoordinates[offset + i];
            flatCoordinates[offset + i] = flatCoordinates[end - stride + i];
            flatCoordinates[end - stride + i] = tmp;
        }
        offset += stride;
        end -= stride;
    }
}


function $7892dc06ffd23218$export$318f2842ed17e094(flatCoordinates, offset, end, stride) {
    // https://stackoverflow.com/q/1165647/clockwise-method#1165943
    // https://github.com/OSGeo/gdal/blob/master/gdal/ogr/ogrlinearring.cpp
    let edge = 0;
    let x1 = flatCoordinates[end - stride];
    let y1 = flatCoordinates[end - stride + 1];
    for(; offset < end; offset += stride){
        const x2 = flatCoordinates[offset];
        const y2 = flatCoordinates[offset + 1];
        edge += (x2 - x1) * (y2 + y1);
        x1 = x2;
        y1 = y2;
    }
    return edge === 0 ? undefined : edge > 0;
}
function $7892dc06ffd23218$export$f27cd06e85f4ba28(flatCoordinates, offset, ends, stride, right) {
    right = right !== undefined ? right : false;
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        const isClockwise = $7892dc06ffd23218$export$318f2842ed17e094(flatCoordinates, offset, end, stride);
        if (i === 0) {
            if (right && isClockwise || !right && !isClockwise) return false;
        } else {
            if (right && !isClockwise || !right && isClockwise) return false;
        }
        offset = end;
    }
    return true;
}
function $7892dc06ffd23218$export$a1d138f4bd85f4b4(flatCoordinates, offset, endss, stride, right) {
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        if (!$7892dc06ffd23218$export$f27cd06e85f4ba28(flatCoordinates, offset, ends, stride, right)) return false;
        if (ends.length) offset = ends[ends.length - 1];
    }
    return true;
}
function $7892dc06ffd23218$export$b71b604ddfc778c7(flatCoordinates, offset, ends, stride, right) {
    right = right !== undefined ? right : false;
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        const isClockwise = $7892dc06ffd23218$export$318f2842ed17e094(flatCoordinates, offset, end, stride);
        const reverse = i === 0 ? right && isClockwise || !right && !isClockwise : right && !isClockwise || !right && isClockwise;
        if (reverse) (0, $155dc783a4ec227e$export$741858880c96b18c)(flatCoordinates, offset, end, stride);
        offset = end;
    }
    return offset;
}
function $7892dc06ffd23218$export$ea9ed55fc2a85010(flatCoordinates, offset, endss, stride, right) {
    for(let i = 0, ii = endss.length; i < ii; ++i)offset = $7892dc06ffd23218$export$b71b604ddfc778c7(flatCoordinates, offset, endss[i], stride, right);
    return offset;
}
function $7892dc06ffd23218$export$cb72ae403d6e78e6(flatCoordinates, ends) {
    const endss = [];
    let offset = 0;
    let prevEndIndex = 0;
    let startOrientation;
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        // classifies an array of rings into polygons with outer rings and holes
        const orientation = $7892dc06ffd23218$export$318f2842ed17e094(flatCoordinates, offset, end, 2);
        if (startOrientation === undefined) startOrientation = orientation;
        if (orientation === startOrientation) endss.push(ends.slice(prevEndIndex, i + 1));
        else {
            if (endss.length === 0) continue;
            endss[endss.length - 1].push(ends[prevEndIndex]);
        }
        prevEndIndex = i + 1;
        offset = end;
    }
    return endss;
}



/**
 * @classdesc
 * Polygon geometry.
 *
 * @api
 */ class $40aa8d43bbe572bf$var$Polygon extends (0, $c76e993e57efc8c4$export$2e2bcd8739ae039) {
    /**
   * @param {!Array<Array<import("../coordinate.js").Coordinate>>|!Array<number>} coordinates
   *     Array of linear rings that define the polygon. The first linear ring of the
   *     array defines the outer-boundary or surface of the polygon. Each subsequent
   *     linear ring defines a hole in the surface of the polygon. A linear ring is
   *     an array of vertices' coordinates where the first coordinate and the last are
   *     equivalent. (For internal use, flat coordinates in combination with
   *     `layout` and `ends` are also accepted.)
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @param {Array<number>} [ends] Ends (for internal use with flat coordinates).
   */ constructor(coordinates, layout, ends){
        super();
        /**
     * @type {Array<number>}
     * @private
     */ this.ends_ = [];
        /**
     * @private
     * @type {number}
     */ this.flatInteriorPointRevision_ = -1;
        /**
     * @private
     * @type {import("../coordinate.js").Coordinate|null}
     */ this.flatInteriorPoint_ = null;
        /**
     * @private
     * @type {number}
     */ this.maxDelta_ = -1;
        /**
     * @private
     * @type {number}
     */ this.maxDeltaRevision_ = -1;
        /**
     * @private
     * @type {number}
     */ this.orientedRevision_ = -1;
        /**
     * @private
     * @type {Array<number>|null}
     */ this.orientedFlatCoordinates_ = null;
        if (layout !== undefined && ends) {
            this.setFlatCoordinates(layout, /** @type {Array<number>} */ coordinates);
            this.ends_ = ends;
        } else this.setCoordinates(/** @type {Array<Array<import("../coordinate.js").Coordinate>>} */ coordinates, layout);
    }
    /**
   * Append the passed linear ring to this polygon.
   * @param {LinearRing} linearRing Linear ring.
   * @api
   */ appendLinearRing(linearRing) {
        if (!this.flatCoordinates) this.flatCoordinates = linearRing.getFlatCoordinates().slice();
        else (0, $b998d41b678ed5d1$export$8b58be045bf06082)(this.flatCoordinates, linearRing.getFlatCoordinates());
        this.ends_.push(this.flatCoordinates.length);
        this.changed();
    }
    /**
   * Make a complete copy of the geometry.
   * @return {!Polygon} Clone.
   * @api
   * @override
   */ clone() {
        const polygon = new $40aa8d43bbe572bf$var$Polygon(this.flatCoordinates.slice(), this.layout, this.ends_.slice());
        polygon.applyProperties(this);
        return polygon;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   * @override
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < (0, $6da4c8ed3074c92b$export$cbe64c389534206f)(this.getExtent(), x, y)) return minSquaredDistance;
        if (this.maxDeltaRevision_ != this.getRevision()) {
            this.maxDelta_ = Math.sqrt((0, $bf5604c1b8258b71$export$fbf31c8f2668ed5a)(this.flatCoordinates, 0, this.ends_, this.stride, 0));
            this.maxDeltaRevision_ = this.getRevision();
        }
        return (0, $bf5604c1b8258b71$export$5a48a0eefcf14992)(this.flatCoordinates, 0, this.ends_, this.stride, this.maxDelta_, true, x, y, closestPoint, minSquaredDistance);
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @return {boolean} Contains (x, y).
   * @override
   */ containsXY(x, y) {
        return (0, $239aa88e7a573859$export$ae868c0f6acc3355)(this.getOrientedFlatCoordinates(), 0, this.ends_, this.stride, x, y);
    }
    /**
   * Return the area of the polygon on projected plane.
   * @return {number} Area (on projected plane).
   * @api
   */ getArea() {
        return (0, $01ff26a2f986a1d0$export$7a8ee541dfdf2ed5)(this.getOrientedFlatCoordinates(), 0, this.ends_, this.stride);
    }
    /**
   * Get the coordinate array for this geometry.  This array has the structure
   * of a GeoJSON coordinate array for polygons.
   *
   * @param {boolean} [right] Orient coordinates according to the right-hand
   *     rule (counter-clockwise for exterior and clockwise for interior rings).
   *     If `false`, coordinates will be oriented according to the left-hand rule
   *     (clockwise for exterior and counter-clockwise for interior rings).
   *     By default, coordinate orientation will depend on how the geometry was
   *     constructed.
   * @return {Array<Array<import("../coordinate.js").Coordinate>>} Coordinates.
   * @api
   * @override
   */ getCoordinates(right) {
        let flatCoordinates;
        if (right !== undefined) {
            flatCoordinates = this.getOrientedFlatCoordinates().slice();
            (0, $7892dc06ffd23218$export$b71b604ddfc778c7)(flatCoordinates, 0, this.ends_, this.stride, right);
        } else flatCoordinates = this.flatCoordinates;
        return (0, $5454470599558ddd$export$cbb9596fc0f40db2)(flatCoordinates, 0, this.ends_, this.stride);
    }
    /**
   * @return {Array<number>} Ends.
   */ getEnds() {
        return this.ends_;
    }
    /**
   * @return {Array<number>} Interior point.
   */ getFlatInteriorPoint() {
        if (this.flatInteriorPointRevision_ != this.getRevision()) {
            const flatCenter = (0, $6da4c8ed3074c92b$export$c91255cadecfe081)(this.getExtent());
            this.flatInteriorPoint_ = (0, $2166f19777f69377$export$50e3b25928a5e892)(this.getOrientedFlatCoordinates(), 0, this.ends_, this.stride, flatCenter, 0);
            this.flatInteriorPointRevision_ = this.getRevision();
        }
        return /** @type {import("../coordinate.js").Coordinate} */ this.flatInteriorPoint_;
    }
    /**
   * Return an interior point of the polygon.
   * @return {Point} Interior point as XYM coordinate, where M is the
   * length of the horizontal intersection that the point belongs to.
   * @api
   */ getInteriorPoint() {
        return new (0, $6eced4c969949f6b$export$2e2bcd8739ae039)(this.getFlatInteriorPoint(), 'XYM');
    }
    /**
   * Return the number of rings of the polygon,  this includes the exterior
   * ring and any interior rings.
   *
   * @return {number} Number of rings.
   * @api
   */ getLinearRingCount() {
        return this.ends_.length;
    }
    /**
   * Return the Nth linear ring of the polygon geometry. Return `null` if the
   * given index is out of range.
   * The exterior linear ring is available at index `0` and the interior rings
   * at index `1` and beyond.
   *
   * @param {number} index Index.
   * @return {LinearRing|null} Linear ring.
   * @api
   */ getLinearRing(index) {
        if (index < 0 || this.ends_.length <= index) return null;
        return new (0, $548636579b4087f2$export$2e2bcd8739ae039)(this.flatCoordinates.slice(index === 0 ? 0 : this.ends_[index - 1], this.ends_[index]), this.layout);
    }
    /**
   * Return the linear rings of the polygon.
   * @return {Array<LinearRing>} Linear rings.
   * @api
   */ getLinearRings() {
        const layout = this.layout;
        const flatCoordinates = this.flatCoordinates;
        const ends = this.ends_;
        const linearRings = [];
        let offset = 0;
        for(let i = 0, ii = ends.length; i < ii; ++i){
            const end = ends[i];
            const linearRing = new (0, $548636579b4087f2$export$2e2bcd8739ae039)(flatCoordinates.slice(offset, end), layout);
            linearRings.push(linearRing);
            offset = end;
        }
        return linearRings;
    }
    /**
   * @return {Array<number>} Oriented flat coordinates.
   */ getOrientedFlatCoordinates() {
        if (this.orientedRevision_ != this.getRevision()) {
            const flatCoordinates = this.flatCoordinates;
            if ((0, $7892dc06ffd23218$export$f27cd06e85f4ba28)(flatCoordinates, 0, this.ends_, this.stride)) this.orientedFlatCoordinates_ = flatCoordinates;
            else {
                this.orientedFlatCoordinates_ = flatCoordinates.slice();
                this.orientedFlatCoordinates_.length = (0, $7892dc06ffd23218$export$b71b604ddfc778c7)(this.orientedFlatCoordinates_, 0, this.ends_, this.stride);
            }
            this.orientedRevision_ = this.getRevision();
        }
        return /** @type {Array<number>} */ this.orientedFlatCoordinates_;
    }
    /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {Polygon} Simplified Polygon.
   * @protected
   * @override
   */ getSimplifiedGeometryInternal(squaredTolerance) {
        /** @type {Array<number>} */ const simplifiedFlatCoordinates = [];
        /** @type {Array<number>} */ const simplifiedEnds = [];
        simplifiedFlatCoordinates.length = (0, $8780aae6970f5f65$export$60a9904b67f8d51b)(this.flatCoordinates, 0, this.ends_, this.stride, Math.sqrt(squaredTolerance), simplifiedFlatCoordinates, 0, simplifiedEnds);
        return new $40aa8d43bbe572bf$var$Polygon(simplifiedFlatCoordinates, 'XY', simplifiedEnds);
    }
    /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   * @override
   */ getType() {
        return 'Polygon';
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   * @override
   */ intersectsExtent(extent) {
        return (0, $acee589e5b390c5c$export$76dcd8f8f83b6ddb)(this.getOrientedFlatCoordinates(), 0, this.ends_, this.stride, extent);
    }
    /**
   * Set the coordinates of the polygon.
   * @param {!Array<Array<import("../coordinate.js").Coordinate>>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   * @override
   */ setCoordinates(coordinates, layout) {
        this.setLayout(layout, coordinates, 2);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        const ends = (0, $6b086aa46281540d$export$47c3746a74384d45)(this.flatCoordinates, 0, coordinates, this.stride, this.ends_);
        this.flatCoordinates.length = ends.length === 0 ? 0 : ends[ends.length - 1];
        this.changed();
    }
}
var $40aa8d43bbe572bf$export$2e2bcd8739ae039 = $40aa8d43bbe572bf$var$Polygon;
function $40aa8d43bbe572bf$export$f99d756c6d81ae3f(center, radius, n, sphereRadius) {
    n = n ? n : 32;
    /** @type {Array<number>} */ const flatCoordinates = [];
    for(let i = 0; i < n; ++i)(0, $b998d41b678ed5d1$export$8b58be045bf06082)(flatCoordinates, (0, $fb75384508533d8f$export$cc800923e997bb8)(center, radius, 2 * Math.PI * i / n, sphereRadius));
    flatCoordinates.push(flatCoordinates[0], flatCoordinates[1]);
    return new $40aa8d43bbe572bf$var$Polygon(flatCoordinates, 'XY', [
        flatCoordinates.length
    ]);
}
function $40aa8d43bbe572bf$export$c16b671815801c75(extent) {
    if ((0, $6da4c8ed3074c92b$export$dd1bc94b04021eeb)(extent)) throw new Error('Cannot create polygon from empty extent');
    const minX = extent[0];
    const minY = extent[1];
    const maxX = extent[2];
    const maxY = extent[3];
    const flatCoordinates = [
        minX,
        minY,
        minX,
        maxY,
        maxX,
        maxY,
        maxX,
        minY,
        minX,
        minY
    ];
    return new $40aa8d43bbe572bf$var$Polygon(flatCoordinates, 'XY', [
        flatCoordinates.length
    ]);
}
function $40aa8d43bbe572bf$export$2451009d645fb8c2(circle, sides, angle) {
    sides = sides ? sides : 32;
    const stride = circle.getStride();
    const layout = circle.getLayout();
    const center = circle.getCenter();
    const arrayLength = stride * (sides + 1);
    const flatCoordinates = new Array(arrayLength);
    for(let i = 0; i < arrayLength; i += stride){
        flatCoordinates[i] = 0;
        flatCoordinates[i + 1] = 0;
        for(let j = 2; j < stride; j++)flatCoordinates[i + j] = center[j];
    }
    const ends = [
        flatCoordinates.length
    ];
    const polygon = new $40aa8d43bbe572bf$var$Polygon(flatCoordinates, layout, ends);
    $40aa8d43bbe572bf$export$87d6a1539a56e47f(polygon, center, circle.getRadius(), angle);
    return polygon;
}
function $40aa8d43bbe572bf$export$87d6a1539a56e47f(polygon, center, radius, angle) {
    const flatCoordinates = polygon.getFlatCoordinates();
    const stride = polygon.getStride();
    const sides = flatCoordinates.length / stride - 1;
    const startAngle = angle ? angle : 0;
    for(let i = 0; i <= sides; ++i){
        const offset = i * stride;
        const angle = startAngle + (0, $6b000a049d919fe5$export$ba467bec01d66def)(i, sides) * 2 * Math.PI / sides;
        flatCoordinates[offset] = center[0] + radius * Math.cos(angle);
        flatCoordinates[offset + 1] = center[1] + radius * Math.sin(angle);
    }
    polygon.changed();
}




/**
 * @module ol/resolutionconstraint
 */ 


/**
 * @typedef {function((number|undefined), number, import("./size.js").Size, boolean=): (number|undefined)} Type
 */ /**
 * Returns a modified resolution taking into account the viewport size and maximum
 * allowed extent.
 * @param {number} resolution Resolution
 * @param {import("./extent.js").Extent} maxExtent Maximum allowed extent.
 * @param {import("./size.js").Size} viewportSize Viewport size.
 * @param {boolean} showFullExtent Whether to show the full extent.
 * @return {number} Capped resolution.
 */ function $bac43a1f4a628548$var$getViewportClampedResolution(resolution, maxExtent, viewportSize, showFullExtent) {
    const xResolution = (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(maxExtent) / viewportSize[0];
    const yResolution = (0, $6da4c8ed3074c92b$export$c08559766941f856)(maxExtent) / viewportSize[1];
    if (showFullExtent) return Math.min(resolution, Math.max(xResolution, yResolution));
    return Math.min(resolution, Math.min(xResolution, yResolution));
}
/**
 * Returns a modified resolution to be between maxResolution and minResolution while
 * still allowing the value to be slightly out of bounds.
 * Note: the computation is based on the logarithm function (ln):
 *  - at 1, ln(x) is 0
 *  - above 1, ln(x) keeps increasing but at a much slower pace than x
 * The final result is clamped to prevent getting too far away from bounds.
 * @param {number} resolution Resolution.
 * @param {number} maxResolution Max resolution.
 * @param {number} minResolution Min resolution.
 * @return {number} Smoothed resolution.
 */ function $bac43a1f4a628548$var$getSmoothClampedResolution(resolution, maxResolution, minResolution) {
    let result = Math.min(resolution, maxResolution);
    const ratio = 50;
    result *= Math.log(1 + ratio * Math.max(0, resolution / maxResolution - 1)) / ratio + 1;
    if (minResolution) {
        result = Math.max(result, minResolution);
        result /= Math.log(1 + ratio * Math.max(0, minResolution / resolution - 1)) / ratio + 1;
    }
    return (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(result, minResolution / 2, maxResolution * 2);
}
function $bac43a1f4a628548$export$d65a517690fc4385(resolutions, smooth, maxExtent, showFullExtent) {
    smooth = smooth !== undefined ? smooth : true;
    return(/**
     * @param {number|undefined} resolution Resolution.
     * @param {number} direction Direction.
     * @param {import("./size.js").Size} size Viewport size.
     * @param {boolean} [isMoving] True if an interaction or animation is in progress.
     * @return {number|undefined} Resolution.
     */ function(resolution, direction, size, isMoving) {
        if (resolution !== undefined) {
            const maxResolution = resolutions[0];
            const minResolution = resolutions[resolutions.length - 1];
            const cappedMaxRes = maxExtent ? $bac43a1f4a628548$var$getViewportClampedResolution(maxResolution, maxExtent, size, showFullExtent) : maxResolution;
            // during interacting or animating, allow intermediary values
            if (isMoving) {
                if (!smooth) return (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(resolution, minResolution, cappedMaxRes);
                return $bac43a1f4a628548$var$getSmoothClampedResolution(resolution, cappedMaxRes, minResolution);
            }
            const capped = Math.min(cappedMaxRes, resolution);
            const z = Math.floor((0, $b998d41b678ed5d1$export$8a3786cc03fdb777)(resolutions, capped, direction));
            if (resolutions[z] > cappedMaxRes && z < resolutions.length - 1) return resolutions[z + 1];
            return resolutions[z];
        }
        return undefined;
    });
}
function $bac43a1f4a628548$export$22ac0f6b219de91a(power, maxResolution, minResolution, smooth, maxExtent, showFullExtent) {
    smooth = smooth !== undefined ? smooth : true;
    minResolution = minResolution !== undefined ? minResolution : 0;
    return(/**
     * @param {number|undefined} resolution Resolution.
     * @param {number} direction Direction.
     * @param {import("./size.js").Size} size Viewport size.
     * @param {boolean} [isMoving] True if an interaction or animation is in progress.
     * @return {number|undefined} Resolution.
     */ function(resolution, direction, size, isMoving) {
        if (resolution !== undefined) {
            const cappedMaxRes = maxExtent ? $bac43a1f4a628548$var$getViewportClampedResolution(maxResolution, maxExtent, size, showFullExtent) : maxResolution;
            // during interacting or animating, allow intermediary values
            if (isMoving) {
                if (!smooth) return (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(resolution, minResolution, cappedMaxRes);
                return $bac43a1f4a628548$var$getSmoothClampedResolution(resolution, cappedMaxRes, minResolution);
            }
            const tolerance = 1e-9;
            const minZoomLevel = Math.ceil(Math.log(maxResolution / cappedMaxRes) / Math.log(power) - tolerance);
            const offset = -direction * (0.5 - tolerance) + 0.5;
            const capped = Math.min(cappedMaxRes, resolution);
            const cappedZoomLevel = Math.floor(Math.log(maxResolution / capped) / Math.log(power) + offset);
            const zoomLevel = Math.max(minZoomLevel, cappedZoomLevel);
            const newResolution = maxResolution / Math.pow(power, zoomLevel);
            return (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(newResolution, minResolution, cappedMaxRes);
        }
        return undefined;
    });
}
function $bac43a1f4a628548$export$1c4e6da9b4b066fe(maxResolution, minResolution, smooth, maxExtent, showFullExtent) {
    smooth = smooth !== undefined ? smooth : true;
    return(/**
     * @param {number|undefined} resolution Resolution.
     * @param {number} direction Direction.
     * @param {import("./size.js").Size} size Viewport size.
     * @param {boolean} [isMoving] True if an interaction or animation is in progress.
     * @return {number|undefined} Resolution.
     */ function(resolution, direction, size, isMoving) {
        if (resolution !== undefined) {
            const cappedMaxRes = maxExtent ? $bac43a1f4a628548$var$getViewportClampedResolution(maxResolution, maxExtent, size, showFullExtent) : maxResolution;
            if (!smooth || !isMoving) return (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(resolution, minResolution, cappedMaxRes);
            return $bac43a1f4a628548$var$getSmoothClampedResolution(resolution, cappedMaxRes, minResolution);
        }
        return undefined;
    });
}


/**
 * @module ol/rotationconstraint
 */ 
function $d65f0a322291d127$export$e20fbacbb41798b(rotation) {
    if (rotation !== undefined) return 0;
    return undefined;
}
function $d65f0a322291d127$export$f883a24d5edde77c(rotation) {
    if (rotation !== undefined) return rotation;
    return undefined;
}
function $d65f0a322291d127$export$9ba78806de831083(n) {
    const theta = 2 * Math.PI / n;
    return(/**
     * @param {number|undefined} rotation Rotation.
     * @param {boolean} [isMoving] True if an interaction or animation is in progress.
     * @return {number|undefined} Rotation.
     */ function(rotation, isMoving) {
        if (isMoving) return rotation;
        if (rotation !== undefined) {
            rotation = Math.floor(rotation / theta + 0.5) * theta;
            return rotation;
        }
        return undefined;
    });
}
function $d65f0a322291d127$export$17a6e6f3448b17e8(tolerance) {
    const t = tolerance === undefined ? (0, $6b000a049d919fe5$export$cba01ba138429a1d)(5) : tolerance;
    return(/**
     * @param {number|undefined} rotation Rotation.
     * @param {boolean} [isMoving] True if an interaction or animation is in progress.
     * @return {number|undefined} Rotation.
     */ function(rotation, isMoving) {
        if (isMoving || rotation === undefined) return rotation;
        if (Math.abs(rotation) <= t) return 0;
        return rotation;
    });
}


/**
 * @module ol/tilegrid/common
 */ /**
 * Default maximum zoom for default tile grids.
 * @type {number}
 */ const $57cd8651d88957a0$export$e98a216cdcc847dc = 42;
const $57cd8651d88957a0$export$6b8cb5cd370bd90c = 256;


/**
 * An animation configuration
 *
 * @typedef {Object} Animation
 * @property {import("./coordinate.js").Coordinate} [sourceCenter] Source center.
 * @property {import("./coordinate.js").Coordinate} [targetCenter] Target center.
 * @property {number} [sourceResolution] Source resolution.
 * @property {number} [targetResolution] Target resolution.
 * @property {number} [sourceRotation] Source rotation.
 * @property {number} [targetRotation] Target rotation.
 * @property {import("./coordinate.js").Coordinate} [anchor] Anchor.
 * @property {number} start Start.
 * @property {number} duration Duration.
 * @property {boolean} complete Complete.
 * @property {function(number):number} easing Easing.
 * @property {function(boolean):void} callback Callback.
 */ /**
 * @typedef {Object} Constraints
 * @property {import("./centerconstraint.js").Type} center Center.
 * @property {import("./resolutionconstraint.js").Type} resolution Resolution.
 * @property {import("./rotationconstraint.js").Type} rotation Rotation.
 */ /**
 * @typedef {Object} FitOptions
 * @property {import("./size.js").Size} [size] The size in pixels of the box to
 * fit the extent into. Defaults to the size of the map the view is associated with.
 * If no map or multiple maps are connected to the view, provide the desired box size
 * (e.g. `map.getSize()`).
 * @property {!Array<number>} [padding=[0, 0, 0, 0]] Padding (in pixels) to be
 * cleared inside the view. Values in the array are top, right, bottom and left
 * padding.
 * @property {boolean} [nearest=false] If the view `constrainResolution` option is `true`,
 * get the nearest extent instead of the closest that actually fits the view.
 * @property {number} [minResolution=0] Minimum resolution that we zoom to.
 * @property {number} [maxZoom] Maximum zoom level that we zoom to. If
 * `minResolution` is given, this property is ignored.
 * @property {number} [duration] The duration of the animation in milliseconds.
 * By default, there is no animation to the target extent.
 * @property {function(number):number} [easing] The easing function used during
 * the animation (defaults to {@link module:ol/easing.inAndOut}).
 * The function will be called for each frame with a number representing a
 * fraction of the animation's duration.  The function should return a number
 * between 0 and 1 representing the progress toward the destination state.
 * @property {function(boolean):void} [callback] Function called when the view is in
 * its final position. The callback will be called with `true` if the animation
 * series completed on its own or `false` if it was cancelled.
 */ /**
 * @typedef {Object} ViewOptions
 * @property {import("./coordinate.js").Coordinate} [center] The initial center for
 * the view. If a user projection is not set, the coordinate system for the center is
 * specified with the `projection` option. Layer sources will not be fetched if this
 * is not set, but the center can be set later with {@link #setCenter}.
 * @property {boolean|number} [constrainRotation=true] Rotation constraint.
 * `false` means no constraint. `true` means no constraint, but snap to zero
 * near zero. A number constrains the rotation to that number of values. For
 * example, `4` will constrain the rotation to 0, 90, 180, and 270 degrees.
 * @property {boolean} [enableRotation=true] Enable rotation.
 * If `false`, a rotation constraint that always sets the rotation to zero is
 * used. The `constrainRotation` option has no effect if `enableRotation` is
 * `false`.
 * @property {import("./extent.js").Extent} [extent] The extent that constrains the
 * view, in other words, nothing outside of this extent can be visible on the map.
 * @property {boolean} [constrainOnlyCenter=false] If true, the extent
 * constraint will only apply to the view center and not the whole extent.
 * @property {boolean} [smoothExtentConstraint=true] If true, the extent
 * constraint will be applied smoothly, i.e. allow the view to go slightly outside
 * of the given `extent`.
 * @property {number} [maxResolution] The maximum resolution used to determine
 * the resolution constraint. It is used together with `minResolution` (or
 * `maxZoom`) and `zoomFactor`. If unspecified it is calculated in such a way
 * that the projection's validity extent fits in a 256x256 px tile. If the
 * projection is Spherical Mercator (the default) then `maxResolution` defaults
 * to `40075016.68557849 / 256 = 156543.03392804097`.
 * @property {number} [minResolution] The minimum resolution used to determine
 * the resolution constraint.  It is used together with `maxResolution` (or
 * `minZoom`) and `zoomFactor`.  If unspecified it is calculated assuming 29
 * zoom levels (with a factor of 2). If the projection is Spherical Mercator
 * (the default) then `minResolution` defaults to
 * `40075016.68557849 / 256 / Math.pow(2, 28) = 0.0005831682455839253`.
 * @property {number} [maxZoom=28] The maximum zoom level used to determine the
 * resolution constraint. It is used together with `minZoom` (or
 * `maxResolution`) and `zoomFactor`.  Note that if `minResolution` is also
 * provided, it is given precedence over `maxZoom`.
 * @property {number} [minZoom=0] The minimum zoom level used to determine the
 * resolution constraint. It is used together with `maxZoom` (or
 * `minResolution`) and `zoomFactor`.  Note that if `maxResolution` is also
 * provided, it is given precedence over `minZoom`.
 * @property {boolean} [multiWorld=false] If `false` the view is constrained so
 * only one world is visible, and you cannot pan off the edge.  If `true` the map
 * may show multiple worlds at low zoom levels.  Only used if the `projection` is
 * global.  Note that if `extent` is also provided it is given precedence.
 * @property {boolean} [constrainResolution=false] If true, the view will always
 * animate to the closest zoom level after an interaction; false means
 * intermediary zoom levels are allowed.
 * @property {boolean} [smoothResolutionConstraint=true] If true, the resolution
 * min/max values will be applied smoothly, i. e. allow the view to exceed slightly
 * the given resolution or zoom bounds.
 * @property {boolean} [showFullExtent=false] Allow the view to be zoomed out to
 * show the full configured extent. By default, when a view is configured with an
 * extent, users will not be able to zoom out so the viewport exceeds the extent in
 * either dimension. This means the full extent may not be visible if the viewport
 * is taller or wider than the aspect ratio of the configured extent. If
 * showFullExtent is true, the user will be able to zoom out so that the viewport
 * exceeds the height or width of the configured extent, but not both, allowing the
 * full extent to be shown.
 * @property {import("./proj.js").ProjectionLike} [projection='EPSG:3857'] The
 * projection. The default is Spherical Mercator.
 * @property {number} [resolution] The initial resolution for the view. The
 * units are `projection` units per pixel (e.g. meters per pixel). An
 * alternative to setting this is to set `zoom`. Layer sources will not be
 * fetched if neither this nor `zoom` are defined, but they can be set later
 * with {@link #setZoom} or {@link #setResolution}.
 * @property {Array<number>} [resolutions] Resolutions that determine the
 * zoom levels if specified. The index in the array corresponds to the zoom level,
 * therefore the resolution values have to be in descending order. It also constrains
 * the resolution by the minimum and maximum value. If set the `maxResolution`,
 * `minResolution`, `minZoom`, `maxZoom`, and `zoomFactor` options are ignored.
 * @property {number} [rotation=0] The initial rotation for the view in radians
 * (positive rotation clockwise, 0 means North).
 * @property {number} [zoom] Only used if `resolution` is not defined. Zoom
 * level used to calculate the initial resolution for the view.
 * @property {number} [zoomFactor=2] The zoom factor used to compute the
 * corresponding resolution.
 * @property {!Array<number>} [padding=[0, 0, 0, 0]] Padding (in css pixels).
 * If the map viewport is partially covered with other content (overlays) along
 * its edges, this setting allows to shift the center of the viewport away from
 * that content. The order of the values is top, right, bottom, left.
 */ /**
 * @typedef {Object} AnimationOptions
 * @property {import("./coordinate.js").Coordinate} [center] The center of the view at the end of
 * the animation.
 * @property {number} [zoom] The zoom level of the view at the end of the
 * animation. This takes precedence over `resolution`.
 * @property {number} [resolution] The resolution of the view at the end
 * of the animation.  If `zoom` is also provided, this option will be ignored.
 * @property {number} [rotation] The rotation of the view at the end of
 * the animation.
 * @property {import("./coordinate.js").Coordinate} [anchor] Optional anchor to remain fixed
 * during a rotation or resolution animation.
 * @property {number} [duration=1000] The duration of the animation in milliseconds.
 * @property {function(number):number} [easing] The easing function used
 * during the animation (defaults to {@link module:ol/easing.inAndOut}).
 * The function will be called for each frame with a number representing a
 * fraction of the animation's duration.  The function should return a number
 * between 0 and 1 representing the progress toward the destination state.
 */ /**
 * @typedef {Object} State
 * @property {import("./coordinate.js").Coordinate} center Center (in view projection coordinates).
 * @property {import("./proj/Projection.js").default} projection Projection.
 * @property {number} resolution Resolution.
 * @property {import("./coordinate.js").Coordinate} [nextCenter] The next center during an animation series.
 * @property {number} [nextResolution] The next resolution during an animation series.
 * @property {number} [nextRotation] The next rotation during an animation series.
 * @property {number} rotation Rotation.
 * @property {number} zoom Zoom.
 */ /**
 * Like {@link import("./Map.js").FrameState}, but just `viewState` and `extent`.
 * @typedef {Object} ViewStateLayerStateExtent
 * @property {State} viewState View state.
 * @property {import("./extent.js").Extent} extent Extent (in user projection coordinates).
 * @property {Array<import("./layer/Layer.js").State>} [layerStatesArray] Layer states.
 */ /**
 * Default min zoom level for the map view.
 * @type {number}
 */ const $70364d0195659942$var$DEFAULT_MIN_ZOOM = 0;
/**
 * @typedef {import("./ObjectEventType").Types|'change:center'|'change:resolution'|'change:rotation'} ViewObjectEventTypes
 */ /***
 * @template Return
 * @typedef {import("./Observable").OnSignature<import("./Observable").EventTypes, import("./events/Event.js").default, Return> &
 *   import("./Observable").OnSignature<ViewObjectEventTypes, import("./Object").ObjectEvent, Return> &
 *   import("./Observable").CombinedOnSignature<import("./Observable").EventTypes|ViewObjectEventTypes, Return>} ViewOnSignature
 */ /**
 * @classdesc
 * A View object represents a simple 2D view of the map.
 *
 * This is the object to act upon to change the center, resolution,
 * and rotation of the map.
 *
 * A View has a `projection`. The projection determines the
 * coordinate system of the center, and its units determine the units of the
 * resolution (projection units per pixel). The default projection is
 * Web Mercator (EPSG:3857).
 *
 * ### The view states
 *
 * A View is determined by three states: `center`, `resolution`,
 * and `rotation`. Each state has a corresponding getter and setter, e.g.
 * `getCenter` and `setCenter` for the `center` state.
 *
 * The `zoom` state is actually not saved on the view: all computations
 * internally use the `resolution` state. Still, the `setZoom` and `getZoom`
 * methods are available, as well as `getResolutionForZoom` and
 * `getZoomForResolution` to switch from one system to the other.
 *
 * ### The constraints
 *
 * `setCenter`, `setResolution` and `setRotation` can be used to change the
 * states of the view, but any constraint defined in the constructor will
 * be applied along the way.
 *
 * A View object can have a *resolution constraint*, a *rotation constraint*
 * and a *center constraint*.
 *
 * The *resolution constraint* typically restricts min/max values and
 * snaps to specific resolutions. It is determined by the following
 * options: `resolutions`, `maxResolution`, `maxZoom` and `zoomFactor`.
 * If `resolutions` is set, the other three options are ignored. See
 * documentation for each option for more information. By default, the view
 * only has a min/max restriction and allow intermediary zoom levels when
 * pinch-zooming for example.
 *
 * The *rotation constraint* snaps to specific angles. It is determined
 * by the following options: `enableRotation` and `constrainRotation`.
 * By default rotation is allowed and its value is snapped to zero when approaching the
 * horizontal.
 *
 * The *center constraint* is determined by the `extent` option. By
 * default the view center is not constrained at all.
 *
 * ### Changing the view state
 *
 * It is important to note that `setZoom`, `setResolution`, `setCenter` and
 * `setRotation` are subject to the above mentioned constraints. As such, it
 * may sometimes not be possible to know in advance the resulting state of the
 * View. For example, calling `setResolution(10)` does not guarantee that
 * `getResolution()` will return `10`.
 *
 * A consequence of this is that, when applying a delta on the view state, one
 * should use `adjustCenter`, `adjustRotation`, `adjustZoom` and `adjustResolution`
 * rather than the corresponding setters. This will let view do its internal
 * computations. Besides, the `adjust*` methods also take an `anchor`
 * argument which allows specifying an origin for the transformation.
 *
 * ### Interacting with the view
 *
 * View constraints are usually only applied when the view is *at rest*, meaning that
 * no interaction or animation is ongoing. As such, if the user puts the view in a
 * state that is not equivalent to a constrained one (e.g. rotating the view when
 * the snap angle is 0), an animation will be triggered at the interaction end to
 * put back the view to a stable state;
 *
 * @api
 */ class $70364d0195659942$var$View extends (0, $b68b3d6e32e3074a$export$2e2bcd8739ae039) {
    /**
   * @param {ViewOptions} [options] View options.
   */ constructor(options){
        super();
        /***
     * @type {ViewOnSignature<import("./events").EventsKey>}
     */ this.on;
        /***
     * @type {ViewOnSignature<import("./events").EventsKey>}
     */ this.once;
        /***
     * @type {ViewOnSignature<void>}
     */ this.un;
        options = Object.assign({}, options);
        /**
     * @private
     * @type {Array<number>}
     */ this.hints_ = [
            0,
            0
        ];
        /**
     * @private
     * @type {Array<Array<Animation>>}
     */ this.animations_ = [];
        /**
     * @private
     * @type {number|undefined}
     */ this.updateAnimationKey_;
        /**
     * @private
     * @const
     * @type {import("./proj/Projection.js").default}
     */ this.projection_ = (0, $9c4744460e43e41b$export$549167224996a0fb)(options.projection, 'EPSG:3857');
        /**
     * @private
     * @type {import("./size.js").Size}
     */ this.viewportSize_ = [
            100,
            100
        ];
        /**
     * @private
     * @type {import("./coordinate.js").Coordinate|undefined}
     */ this.targetCenter_ = null;
        /**
     * @private
     * @type {number|undefined}
     */ this.targetResolution_;
        /**
     * @private
     * @type {number|undefined}
     */ this.targetRotation_;
        /**
     * @private
     * @type {import("./coordinate.js").Coordinate}
     */ this.nextCenter_ = null;
        /**
     * @private
     * @type {number}
     */ this.nextResolution_;
        /**
     * @private
     * @type {number}
     */ this.nextRotation_;
        /**
     * @private
     * @type {import("./coordinate.js").Coordinate|undefined}
     */ this.cancelAnchor_ = undefined;
        if (options.projection) (0, $9c4744460e43e41b$export$ed949affbc7c4223)();
        if (options.center) options.center = (0, $9c4744460e43e41b$export$d4b8ec0b96db1ee2)(options.center, this.projection_);
        if (options.extent) options.extent = (0, $9c4744460e43e41b$export$494be3a3a25689ca)(options.extent, this.projection_);
        this.applyOptions_(options);
    }
    /**
   * Set up the view with the given options.
   * @param {ViewOptions} options View options.
   */ applyOptions_(options) {
        const properties = Object.assign({}, options);
        for(const key in 0, $d35baefbe89be4c5$export$2e2bcd8739ae039)delete properties[key];
        this.setProperties(properties, true);
        const resolutionConstraintInfo = $70364d0195659942$export$c68d65f9148da196(options);
        /**
     * @private
     * @type {number}
     */ this.maxResolution_ = resolutionConstraintInfo.maxResolution;
        /**
     * @private
     * @type {number}
     */ this.minResolution_ = resolutionConstraintInfo.minResolution;
        /**
     * @private
     * @type {number}
     */ this.zoomFactor_ = resolutionConstraintInfo.zoomFactor;
        /**
     * @private
     * @type {Array<number>|undefined}
     */ this.resolutions_ = options.resolutions;
        /**
     * @type {Array<number>|undefined}
     * @private
     */ this.padding_ = options.padding;
        /**
     * @private
     * @type {number}
     */ this.minZoom_ = resolutionConstraintInfo.minZoom;
        const centerConstraint = $70364d0195659942$export$964345001ee9ac52(options);
        const resolutionConstraint = resolutionConstraintInfo.constraint;
        const rotationConstraint = $70364d0195659942$export$4eeaa08dd550e3c0(options);
        /**
     * @private
     * @type {Constraints}
     */ this.constraints_ = {
            center: centerConstraint,
            resolution: resolutionConstraint,
            rotation: rotationConstraint
        };
        this.setRotation(options.rotation !== undefined ? options.rotation : 0);
        this.setCenterInternal(options.center !== undefined ? options.center : null);
        if (options.resolution !== undefined) this.setResolution(options.resolution);
        else if (options.zoom !== undefined) this.setZoom(options.zoom);
    }
    /**
   * Padding (in css pixels).
   * If the map viewport is partially covered with other content (overlays) along
   * its edges, this setting allows to shift the center of the viewport away from that
   * content. The order of the values in the array is top, right, bottom, left.
   * The default is no padding, which is equivalent to `[0, 0, 0, 0]`.
   * @type {Array<number>|undefined}
   * @api
   */ get padding() {
        return this.padding_;
    }
    set padding(padding) {
        let oldPadding = this.padding_;
        this.padding_ = padding;
        const center = this.getCenterInternal();
        if (center) {
            const newPadding = padding || [
                0,
                0,
                0,
                0
            ];
            oldPadding = oldPadding || [
                0,
                0,
                0,
                0
            ];
            const resolution = this.getResolution();
            const offsetX = resolution / 2 * (newPadding[3] - oldPadding[3] + oldPadding[1] - newPadding[1]);
            const offsetY = resolution / 2 * (newPadding[0] - oldPadding[0] + oldPadding[2] - newPadding[2]);
            this.setCenterInternal([
                center[0] + offsetX,
                center[1] - offsetY
            ]);
        }
    }
    /**
   * Get an updated version of the view options used to construct the view.  The
   * current resolution (or zoom), center, and rotation are applied to any stored
   * options.  The provided options can be used to apply new min/max zoom or
   * resolution limits.
   * @param {ViewOptions} newOptions New options to be applied.
   * @return {ViewOptions} New options updated with the current view state.
   */ getUpdatedOptions_(newOptions) {
        const options = this.getProperties();
        // preserve resolution (or zoom)
        if (options.resolution !== undefined) options.resolution = this.getResolution();
        else options.zoom = this.getZoom();
        // preserve center
        options.center = this.getCenterInternal();
        // preserve rotation
        options.rotation = this.getRotation();
        return Object.assign({}, options, newOptions);
    }
    /**
   * Animate the view.  The view's center, zoom (or resolution), and rotation
   * can be animated for smooth transitions between view states.  For example,
   * to animate the view to a new zoom level:
   *
   *     view.animate({zoom: view.getZoom() + 1});
   *
   * By default, the animation lasts one second and uses in-and-out easing.  You
   * can customize this behavior by including `duration` (in milliseconds) and
   * `easing` options (see {@link module:ol/easing}).
   *
   * To chain together multiple animations, call the method with multiple
   * animation objects.  For example, to first zoom and then pan:
   *
   *     view.animate({zoom: 10}, {center: [0, 0]});
   *
   * If you provide a function as the last argument to the animate method, it
   * will get called at the end of an animation series.  The callback will be
   * called with `true` if the animation series completed on its own or `false`
   * if it was cancelled.
   *
   * Animations are cancelled by user interactions (e.g. dragging the map) or by
   * calling `view.setCenter()`, `view.setResolution()`, or `view.setRotation()`
   * (or another method that calls one of these).
   *
   * @param {...(AnimationOptions|function(boolean): void)} var_args Animation
   *     options.  Multiple animations can be run in series by passing multiple
   *     options objects.  To run multiple animations in parallel, call the method
   *     multiple times.  An optional callback can be provided as a final
   *     argument.  The callback will be called with a boolean indicating whether
   *     the animation completed without being cancelled.
   * @api
   */ animate(var_args) {
        if (this.isDef() && !this.getAnimating()) this.resolveConstraints(0);
        const args = new Array(arguments.length);
        for(let i = 0; i < args.length; ++i){
            let options = arguments[i];
            if (options.center) {
                options = Object.assign({}, options);
                options.center = (0, $9c4744460e43e41b$export$d4b8ec0b96db1ee2)(options.center, this.getProjection());
            }
            if (options.anchor) {
                options = Object.assign({}, options);
                options.anchor = (0, $9c4744460e43e41b$export$d4b8ec0b96db1ee2)(options.anchor, this.getProjection());
            }
            args[i] = options;
        }
        this.animateInternal.apply(this, args);
    }
    /**
   * @param {...(AnimationOptions|function(boolean): void)} var_args Animation options.
   */ animateInternal(var_args) {
        let animationCount = arguments.length;
        let callback;
        if (animationCount > 1 && typeof arguments[animationCount - 1] === 'function') {
            callback = arguments[animationCount - 1];
            --animationCount;
        }
        let i = 0;
        for(; i < animationCount && !this.isDef(); ++i){
            // if view properties are not yet set, shortcut to the final state
            const state = arguments[i];
            if (state.center) this.setCenterInternal(state.center);
            if (state.zoom !== undefined) this.setZoom(state.zoom);
            else if (state.resolution) this.setResolution(state.resolution);
            if (state.rotation !== undefined) this.setRotation(state.rotation);
        }
        if (i === animationCount) {
            if (callback) $70364d0195659942$var$animationCallback(callback, true);
            return;
        }
        let start = Date.now();
        let center = this.targetCenter_.slice();
        let resolution = this.targetResolution_;
        let rotation = this.targetRotation_;
        const series = [];
        for(; i < animationCount; ++i){
            const options = /** @type {AnimationOptions} */ arguments[i];
            const animation = {
                start: start,
                complete: false,
                anchor: options.anchor,
                duration: options.duration !== undefined ? options.duration : 1000,
                easing: options.easing || (0, $c7ccf7e681a9b333$export$9b47139b511b56e4),
                callback: callback
            };
            if (options.center) {
                animation.sourceCenter = center;
                animation.targetCenter = options.center.slice();
                center = animation.targetCenter;
            }
            if (options.zoom !== undefined) {
                animation.sourceResolution = resolution;
                animation.targetResolution = this.getResolutionForZoom(options.zoom);
                resolution = animation.targetResolution;
            } else if (options.resolution) {
                animation.sourceResolution = resolution;
                animation.targetResolution = options.resolution;
                resolution = animation.targetResolution;
            }
            if (options.rotation !== undefined) {
                animation.sourceRotation = rotation;
                const delta = (0, $6b000a049d919fe5$export$ba467bec01d66def)(options.rotation - rotation + Math.PI, 2 * Math.PI) - Math.PI;
                animation.targetRotation = rotation + delta;
                rotation = animation.targetRotation;
            }
            // check if animation is a no-op
            if ($70364d0195659942$export$ee75376562060184(animation)) animation.complete = true;
            else start += animation.duration;
            series.push(animation);
        }
        this.animations_.push(series);
        this.setHint((0, $7d362782b4ccb93d$export$2e2bcd8739ae039).ANIMATING, 1);
        this.updateAnimations_();
    }
    /**
   * Determine if the view is being animated.
   * @return {boolean} The view is being animated.
   * @api
   */ getAnimating() {
        return this.hints_[(0, $7d362782b4ccb93d$export$2e2bcd8739ae039).ANIMATING] > 0;
    }
    /**
   * Determine if the user is interacting with the view, such as panning or zooming.
   * @return {boolean} The view is being interacted with.
   * @api
   */ getInteracting() {
        return this.hints_[(0, $7d362782b4ccb93d$export$2e2bcd8739ae039).INTERACTING] > 0;
    }
    /**
   * Cancel any ongoing animations.
   * @api
   */ cancelAnimations() {
        this.setHint((0, $7d362782b4ccb93d$export$2e2bcd8739ae039).ANIMATING, -this.hints_[(0, $7d362782b4ccb93d$export$2e2bcd8739ae039).ANIMATING]);
        let anchor;
        for(let i = 0, ii = this.animations_.length; i < ii; ++i){
            const series = this.animations_[i];
            if (series[0].callback) $70364d0195659942$var$animationCallback(series[0].callback, false);
            if (!anchor) for(let j = 0, jj = series.length; j < jj; ++j){
                const animation = series[j];
                if (!animation.complete) {
                    anchor = animation.anchor;
                    break;
                }
            }
        }
        this.animations_.length = 0;
        this.cancelAnchor_ = anchor;
        this.nextCenter_ = null;
        this.nextResolution_ = NaN;
        this.nextRotation_ = NaN;
    }
    /**
   * Update all animations.
   */ updateAnimations_() {
        if (this.updateAnimationKey_ !== undefined) {
            cancelAnimationFrame(this.updateAnimationKey_);
            this.updateAnimationKey_ = undefined;
        }
        if (!this.getAnimating()) return;
        const now = Date.now();
        let more = false;
        for(let i = this.animations_.length - 1; i >= 0; --i){
            const series = this.animations_[i];
            let seriesComplete = true;
            for(let j = 0, jj = series.length; j < jj; ++j){
                const animation = series[j];
                if (animation.complete) continue;
                const elapsed = now - animation.start;
                let fraction = animation.duration > 0 ? elapsed / animation.duration : 1;
                if (fraction >= 1) {
                    animation.complete = true;
                    fraction = 1;
                } else seriesComplete = false;
                const progress = animation.easing(fraction);
                if (animation.sourceCenter) {
                    const x0 = animation.sourceCenter[0];
                    const y0 = animation.sourceCenter[1];
                    const x1 = animation.targetCenter[0];
                    const y1 = animation.targetCenter[1];
                    this.nextCenter_ = animation.targetCenter;
                    const x = x0 + progress * (x1 - x0);
                    const y = y0 + progress * (y1 - y0);
                    this.targetCenter_ = [
                        x,
                        y
                    ];
                }
                if (animation.sourceResolution && animation.targetResolution) {
                    const resolution = progress === 1 ? animation.targetResolution : animation.sourceResolution + progress * (animation.targetResolution - animation.sourceResolution);
                    if (animation.anchor) {
                        const size = this.getViewportSize_(this.getRotation());
                        const constrainedResolution = this.constraints_.resolution(resolution, 0, size, true);
                        this.targetCenter_ = this.calculateCenterZoom(constrainedResolution, animation.anchor);
                    }
                    this.nextResolution_ = animation.targetResolution;
                    this.targetResolution_ = resolution;
                    this.applyTargetState_(true);
                }
                if (animation.sourceRotation !== undefined && animation.targetRotation !== undefined) {
                    const rotation = progress === 1 ? (0, $6b000a049d919fe5$export$ba467bec01d66def)(animation.targetRotation + Math.PI, 2 * Math.PI) - Math.PI : animation.sourceRotation + progress * (animation.targetRotation - animation.sourceRotation);
                    if (animation.anchor) {
                        const constrainedRotation = this.constraints_.rotation(rotation, true);
                        this.targetCenter_ = this.calculateCenterRotate(constrainedRotation, animation.anchor);
                    }
                    this.nextRotation_ = animation.targetRotation;
                    this.targetRotation_ = rotation;
                }
                this.applyTargetState_(true);
                more = true;
                if (!animation.complete) break;
            }
            if (seriesComplete) {
                this.animations_[i] = null;
                this.setHint((0, $7d362782b4ccb93d$export$2e2bcd8739ae039).ANIMATING, -1);
                this.nextCenter_ = null;
                this.nextResolution_ = NaN;
                this.nextRotation_ = NaN;
                const callback = series[0].callback;
                if (callback) $70364d0195659942$var$animationCallback(callback, true);
            }
        }
        // prune completed series
        this.animations_ = this.animations_.filter(Boolean);
        if (more && this.updateAnimationKey_ === undefined) this.updateAnimationKey_ = requestAnimationFrame(this.updateAnimations_.bind(this));
    }
    /**
   * @param {number} rotation Target rotation.
   * @param {import("./coordinate.js").Coordinate} anchor Rotation anchor.
   * @return {import("./coordinate.js").Coordinate|undefined} Center for rotation and anchor.
   */ calculateCenterRotate(rotation, anchor) {
        let center;
        const currentCenter = this.getCenterInternal();
        if (currentCenter !== undefined) {
            center = [
                currentCenter[0] - anchor[0],
                currentCenter[1] - anchor[1]
            ];
            (0, $1bd0a226f9a16141$export$bb628a54ab399bc9)(center, rotation - this.getRotation());
            (0, $1bd0a226f9a16141$export$e16d8520af44a096)(center, anchor);
        }
        return center;
    }
    /**
   * @param {number} resolution Target resolution.
   * @param {import("./coordinate.js").Coordinate} anchor Zoom anchor.
   * @return {import("./coordinate.js").Coordinate|undefined} Center for resolution and anchor.
   */ calculateCenterZoom(resolution, anchor) {
        let center;
        const currentCenter = this.getCenterInternal();
        const currentResolution = this.getResolution();
        if (currentCenter !== undefined && currentResolution !== undefined) {
            const x = anchor[0] - resolution * (anchor[0] - currentCenter[0]) / currentResolution;
            const y = anchor[1] - resolution * (anchor[1] - currentCenter[1]) / currentResolution;
            center = [
                x,
                y
            ];
        }
        return center;
    }
    /**
   * Returns the current viewport size.
   * @private
   * @param {number} [rotation] Take into account the rotation of the viewport when giving the size
   * @return {import("./size.js").Size} Viewport size or `[100, 100]` when no viewport is found.
   */ getViewportSize_(rotation) {
        const size = this.viewportSize_;
        if (rotation) {
            const w = size[0];
            const h = size[1];
            return [
                Math.abs(w * Math.cos(rotation)) + Math.abs(h * Math.sin(rotation)),
                Math.abs(w * Math.sin(rotation)) + Math.abs(h * Math.cos(rotation))
            ];
        }
        return size;
    }
    /**
   * Stores the viewport size on the view. The viewport size is not read every time from the DOM
   * to avoid performance hit and layout reflow.
   * This should be done on map size change.
   * Note: the constraints are not resolved during an animation to avoid stopping it
   * @param {import("./size.js").Size} [size] Viewport size; if undefined, [100, 100] is assumed
   */ setViewportSize(size) {
        this.viewportSize_ = Array.isArray(size) ? size.slice() : [
            100,
            100
        ];
        if (!this.getAnimating()) this.resolveConstraints(0);
    }
    /**
   * Get the view center.
   * @return {import("./coordinate.js").Coordinate|undefined} The center of the view.
   * @observable
   * @api
   */ getCenter() {
        const center = this.getCenterInternal();
        if (!center) return center;
        return (0, $9c4744460e43e41b$export$698f563af1ba02a5)(center, this.getProjection());
    }
    /**
   * Get the view center without transforming to user projection.
   * @return {import("./coordinate.js").Coordinate|undefined} The center of the view.
   */ getCenterInternal() {
        return /** @type {import("./coordinate.js").Coordinate|undefined} */ this.get((0, $d35baefbe89be4c5$export$2e2bcd8739ae039).CENTER);
    }
    /**
   * @return {Constraints} Constraints.
   */ getConstraints() {
        return this.constraints_;
    }
    /**
   * @return {boolean} Resolution constraint is set
   */ getConstrainResolution() {
        return this.get('constrainResolution');
    }
    /**
   * @param {Array<number>} [hints] Destination array.
   * @return {Array<number>} Hint.
   */ getHints(hints) {
        if (hints !== undefined) {
            hints[0] = this.hints_[0];
            hints[1] = this.hints_[1];
            return hints;
        }
        return this.hints_.slice();
    }
    /**
   * Calculate the extent for the current view state and the passed box size.
   * @param {import("./size.js").Size} [size] The pixel dimensions of the box
   * into which the calculated extent should fit. Defaults to the size of the
   * map the view is associated with.
   * If no map or multiple maps are connected to the view, provide the desired
   * box size (e.g. `map.getSize()`).
   * @return {import("./extent.js").Extent} Extent.
   * @api
   */ calculateExtent(size) {
        const extent = this.calculateExtentInternal(size);
        return (0, $9c4744460e43e41b$export$96bfd09e2cffb006)(extent, this.getProjection());
    }
    /**
   * @param {import("./size.js").Size} [size] Box pixel size. If not provided,
   * the map's last known viewport size will be used.
   * @return {import("./extent.js").Extent} Extent.
   */ calculateExtentInternal(size) {
        size = size || this.getViewportSizeMinusPadding_();
        const center = /** @type {!import("./coordinate.js").Coordinate} */ this.getCenterInternal();
        (0, $35d5ec884318008e$export$a7a9523472993e97)(center, 'The view center is not defined');
        const resolution = /** @type {!number} */ this.getResolution();
        (0, $35d5ec884318008e$export$a7a9523472993e97)(resolution !== undefined, 'The view resolution is not defined');
        const rotation = /** @type {!number} */ this.getRotation();
        (0, $35d5ec884318008e$export$a7a9523472993e97)(rotation !== undefined, 'The view rotation is not defined');
        return (0, $6da4c8ed3074c92b$export$13ba650faf8308)(center, resolution, rotation, size);
    }
    /**
   * Get the maximum resolution of the view.
   * @return {number} The maximum resolution of the view.
   * @api
   */ getMaxResolution() {
        return this.maxResolution_;
    }
    /**
   * Get the minimum resolution of the view.
   * @return {number} The minimum resolution of the view.
   * @api
   */ getMinResolution() {
        return this.minResolution_;
    }
    /**
   * Get the maximum zoom level for the view.
   * @return {number} The maximum zoom level.
   * @api
   */ getMaxZoom() {
        return /** @type {number} */ this.getZoomForResolution(this.minResolution_);
    }
    /**
   * Set a new maximum zoom level for the view.
   * @param {number} zoom The maximum zoom level.
   * @api
   */ setMaxZoom(zoom) {
        this.applyOptions_(this.getUpdatedOptions_({
            maxZoom: zoom
        }));
    }
    /**
   * Get the minimum zoom level for the view.
   * @return {number} The minimum zoom level.
   * @api
   */ getMinZoom() {
        return /** @type {number} */ this.getZoomForResolution(this.maxResolution_);
    }
    /**
   * Set a new minimum zoom level for the view.
   * @param {number} zoom The minimum zoom level.
   * @api
   */ setMinZoom(zoom) {
        this.applyOptions_(this.getUpdatedOptions_({
            minZoom: zoom
        }));
    }
    /**
   * Set whether the view should allow intermediary zoom levels.
   * @param {boolean} enabled Whether the resolution is constrained.
   * @api
   */ setConstrainResolution(enabled) {
        this.applyOptions_(this.getUpdatedOptions_({
            constrainResolution: enabled
        }));
    }
    /**
   * Get the view projection.
   * @return {import("./proj/Projection.js").default} The projection of the view.
   * @api
   */ getProjection() {
        return this.projection_;
    }
    /**
   * Get the view resolution.
   * @return {number|undefined} The resolution of the view.
   * @observable
   * @api
   */ getResolution() {
        return /** @type {number|undefined} */ this.get((0, $d35baefbe89be4c5$export$2e2bcd8739ae039).RESOLUTION);
    }
    /**
   * Get the resolutions for the view. This returns the array of resolutions
   * passed to the constructor of the View, or undefined if none were given.
   * @return {Array<number>|undefined} The resolutions of the view.
   * @api
   */ getResolutions() {
        return this.resolutions_;
    }
    /**
   * Get the resolution for a provided extent (in map units) and size (in pixels).
   * @param {import("./extent.js").Extent} extent Extent.
   * @param {import("./size.js").Size} [size] Box pixel size.
   * @return {number} The resolution at which the provided extent will render at
   *     the given size.
   * @api
   */ getResolutionForExtent(extent, size) {
        return this.getResolutionForExtentInternal((0, $9c4744460e43e41b$export$494be3a3a25689ca)(extent, this.getProjection()), size);
    }
    /**
   * Get the resolution for a provided extent (in map units) and size (in pixels).
   * @param {import("./extent.js").Extent} extent Extent.
   * @param {import("./size.js").Size} [size] Box pixel size.
   * @return {number} The resolution at which the provided extent will render at
   *     the given size.
   */ getResolutionForExtentInternal(extent, size) {
        size = size || this.getViewportSizeMinusPadding_();
        const xResolution = (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(extent) / size[0];
        const yResolution = (0, $6da4c8ed3074c92b$export$c08559766941f856)(extent) / size[1];
        return Math.max(xResolution, yResolution);
    }
    /**
   * Return a function that returns a value between 0 and 1 for a
   * resolution. Exponential scaling is assumed.
   * @param {number} [power] Power.
   * @return {function(number): number} Resolution for value function.
   */ getResolutionForValueFunction(power) {
        power = power || 2;
        const maxResolution = this.getConstrainedResolution(this.maxResolution_);
        const minResolution = this.minResolution_;
        const max = Math.log(maxResolution / minResolution) / Math.log(power);
        return(/**
       * @param {number} value Value.
       * @return {number} Resolution.
       */ function(value) {
            const resolution = maxResolution / Math.pow(power, value * max);
            return resolution;
        });
    }
    /**
   * Get the view rotation.
   * @return {number} The rotation of the view in radians.
   * @observable
   * @api
   */ getRotation() {
        return /** @type {number} */ this.get((0, $d35baefbe89be4c5$export$2e2bcd8739ae039).ROTATION);
    }
    /**
   * Return a function that returns a resolution for a value between
   * 0 and 1. Exponential scaling is assumed.
   * @param {number} [power] Power.
   * @return {function(number): number} Value for resolution function.
   */ getValueForResolutionFunction(power) {
        const logPower = Math.log(power || 2);
        const maxResolution = this.getConstrainedResolution(this.maxResolution_);
        const minResolution = this.minResolution_;
        const max = Math.log(maxResolution / minResolution) / logPower;
        return(/**
       * @param {number} resolution Resolution.
       * @return {number} Value.
       */ function(resolution) {
            const value = Math.log(maxResolution / resolution) / logPower / max;
            return value;
        });
    }
    /**
   * Returns the size of the viewport minus padding.
   * @private
   * @param {number} [rotation] Take into account the rotation of the viewport when giving the size
   * @return {import("./size.js").Size} Viewport size reduced by the padding.
   */ getViewportSizeMinusPadding_(rotation) {
        let size = this.getViewportSize_(rotation);
        const padding = this.padding_;
        if (padding) size = [
            size[0] - padding[1] - padding[3],
            size[1] - padding[0] - padding[2]
        ];
        return size;
    }
    /**
   * @return {State} View state.
   */ getState() {
        const projection = this.getProjection();
        const resolution = this.getResolution();
        const rotation = this.getRotation();
        let center = /** @type {import("./coordinate.js").Coordinate} */ this.getCenterInternal();
        const padding = this.padding_;
        if (padding) {
            const reducedSize = this.getViewportSizeMinusPadding_();
            center = $70364d0195659942$var$calculateCenterOn(center, this.getViewportSize_(), [
                reducedSize[0] / 2 + padding[3],
                reducedSize[1] / 2 + padding[0]
            ], resolution, rotation);
        }
        return {
            center: center.slice(0),
            projection: projection !== undefined ? projection : null,
            resolution: resolution,
            nextCenter: this.nextCenter_,
            nextResolution: this.nextResolution_,
            nextRotation: this.nextRotation_,
            rotation: rotation,
            zoom: this.getZoom()
        };
    }
    /**
   * @return {ViewStateLayerStateExtent} Like `FrameState`, but just `viewState` and `extent`.
   */ getViewStateAndExtent() {
        return {
            viewState: this.getState(),
            extent: this.calculateExtent()
        };
    }
    /**
   * Get the current zoom level. This method may return non-integer zoom levels
   * if the view does not constrain the resolution, or if an interaction or
   * animation is underway.
   * @return {number|undefined} Zoom.
   * @api
   */ getZoom() {
        let zoom;
        const resolution = this.getResolution();
        if (resolution !== undefined) zoom = this.getZoomForResolution(resolution);
        return zoom;
    }
    /**
   * Get the zoom level for a resolution.
   * @param {number} resolution The resolution.
   * @return {number|undefined} The zoom level for the provided resolution.
   * @api
   */ getZoomForResolution(resolution) {
        let offset = this.minZoom_ || 0;
        let max, zoomFactor;
        if (this.resolutions_) {
            const nearest = (0, $b998d41b678ed5d1$export$8a3786cc03fdb777)(this.resolutions_, resolution, 1);
            offset = nearest;
            max = this.resolutions_[nearest];
            if (nearest == this.resolutions_.length - 1) zoomFactor = 2;
            else zoomFactor = max / this.resolutions_[nearest + 1];
        } else {
            max = this.maxResolution_;
            zoomFactor = this.zoomFactor_;
        }
        return offset + Math.log(max / resolution) / Math.log(zoomFactor);
    }
    /**
   * Get the resolution for a zoom level.
   * @param {number} zoom Zoom level.
   * @return {number} The view resolution for the provided zoom level.
   * @api
   */ getResolutionForZoom(zoom) {
        if (this.resolutions_?.length) {
            if (this.resolutions_.length === 1) return this.resolutions_[0];
            const baseLevel = (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(Math.floor(zoom), 0, this.resolutions_.length - 2);
            const zoomFactor = this.resolutions_[baseLevel] / this.resolutions_[baseLevel + 1];
            return this.resolutions_[baseLevel] / Math.pow(zoomFactor, (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(zoom - baseLevel, 0, 1));
        }
        return this.maxResolution_ / Math.pow(this.zoomFactor_, zoom - this.minZoom_);
    }
    /**
   * Fit the given geometry or extent based on the given map size and border.
   * The size is pixel dimensions of the box to fit the extent into.
   * In most cases you will want to use the map size, that is `map.getSize()`.
   * Takes care of the map angle.
   * @param {import("./geom/SimpleGeometry.js").default|import("./extent.js").Extent} geometryOrExtent The geometry or
   *     extent to fit the view to.
   * @param {FitOptions} [options] Options.
   * @api
   */ fit(geometryOrExtent, options) {
        /** @type {import("./geom/SimpleGeometry.js").default} */ let geometry;
        (0, $35d5ec884318008e$export$a7a9523472993e97)(Array.isArray(geometryOrExtent) || typeof /** @type {?} */ geometryOrExtent.getSimplifiedGeometry === 'function', 'Invalid extent or geometry provided as `geometry`');
        if (Array.isArray(geometryOrExtent)) {
            (0, $35d5ec884318008e$export$a7a9523472993e97)(!(0, $6da4c8ed3074c92b$export$dd1bc94b04021eeb)(geometryOrExtent), 'Cannot fit empty extent provided as `geometry`');
            const extent = (0, $9c4744460e43e41b$export$494be3a3a25689ca)(geometryOrExtent, this.getProjection());
            geometry = (0, $40aa8d43bbe572bf$export$c16b671815801c75)(extent);
        } else if (geometryOrExtent.getType() === 'Circle') {
            const extent = (0, $9c4744460e43e41b$export$494be3a3a25689ca)(geometryOrExtent.getExtent(), this.getProjection());
            geometry = (0, $40aa8d43bbe572bf$export$c16b671815801c75)(extent);
            geometry.rotate(this.getRotation(), (0, $6da4c8ed3074c92b$export$c91255cadecfe081)(extent));
        } else {
            const userProjection = (0, $9c4744460e43e41b$export$3973b77d5f6f2790)();
            if (userProjection) geometry = /** @type {import("./geom/SimpleGeometry.js").default} */ geometryOrExtent.clone().transform(userProjection, this.getProjection());
            else geometry = geometryOrExtent;
        }
        this.fitInternal(geometry, options);
    }
    /**
   * Calculate rotated extent
   * @param {import("./geom/SimpleGeometry.js").default} geometry The geometry.
   * @return {import("./extent").Extent} The rotated extent for the geometry.
   */ rotatedExtentForGeometry(geometry) {
        const rotation = this.getRotation();
        const cosAngle = Math.cos(rotation);
        const sinAngle = Math.sin(-rotation);
        const coords = geometry.getFlatCoordinates();
        const stride = geometry.getStride();
        let minRotX = Infinity;
        let minRotY = Infinity;
        let maxRotX = -Infinity;
        let maxRotY = -Infinity;
        for(let i = 0, ii = coords.length; i < ii; i += stride){
            const rotX = coords[i] * cosAngle - coords[i + 1] * sinAngle;
            const rotY = coords[i] * sinAngle + coords[i + 1] * cosAngle;
            minRotX = Math.min(minRotX, rotX);
            minRotY = Math.min(minRotY, rotY);
            maxRotX = Math.max(maxRotX, rotX);
            maxRotY = Math.max(maxRotY, rotY);
        }
        return [
            minRotX,
            minRotY,
            maxRotX,
            maxRotY
        ];
    }
    /**
   * @param {import("./geom/SimpleGeometry.js").default} geometry The geometry.
   * @param {FitOptions} [options] Options.
   */ fitInternal(geometry, options) {
        options = options || {};
        let size = options.size;
        if (!size) size = this.getViewportSizeMinusPadding_();
        const padding = options.padding !== undefined ? options.padding : [
            0,
            0,
            0,
            0
        ];
        const nearest = options.nearest !== undefined ? options.nearest : false;
        let minResolution;
        if (options.minResolution !== undefined) minResolution = options.minResolution;
        else if (options.maxZoom !== undefined) minResolution = this.getResolutionForZoom(options.maxZoom);
        else minResolution = 0;
        const rotatedExtent = this.rotatedExtentForGeometry(geometry);
        // calculate resolution
        let resolution = this.getResolutionForExtentInternal(rotatedExtent, [
            size[0] - padding[1] - padding[3],
            size[1] - padding[0] - padding[2]
        ]);
        resolution = isNaN(resolution) ? minResolution : Math.max(resolution, minResolution);
        resolution = this.getConstrainedResolution(resolution, nearest ? 0 : 1);
        // calculate center
        const rotation = this.getRotation();
        const sinAngle = Math.sin(rotation);
        const cosAngle = Math.cos(rotation);
        const centerRot = (0, $6da4c8ed3074c92b$export$c91255cadecfe081)(rotatedExtent);
        centerRot[0] += (padding[1] - padding[3]) / 2 * resolution;
        centerRot[1] += (padding[0] - padding[2]) / 2 * resolution;
        const centerX = centerRot[0] * cosAngle - centerRot[1] * sinAngle;
        const centerY = centerRot[1] * cosAngle + centerRot[0] * sinAngle;
        const center = this.getConstrainedCenter([
            centerX,
            centerY
        ], resolution);
        const callback = options.callback ? options.callback : (0, $013a1733c226ec50$export$1cd1943b3a73bbe8);
        if (options.duration !== undefined) this.animateInternal({
            resolution: resolution,
            center: center,
            duration: options.duration,
            easing: options.easing
        }, callback);
        else {
            this.targetResolution_ = resolution;
            this.targetCenter_ = center;
            this.applyTargetState_(false, true);
            $70364d0195659942$var$animationCallback(callback, true);
        }
    }
    /**
   * Center on coordinate and view position.
   * @param {import("./coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("./size.js").Size} size Box pixel size.
   * @param {import("./pixel.js").Pixel} position Position on the view to center on.
   * @api
   */ centerOn(coordinate, size, position) {
        this.centerOnInternal((0, $9c4744460e43e41b$export$d4b8ec0b96db1ee2)(coordinate, this.getProjection()), size, position);
    }
    /**
   * @param {import("./coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("./size.js").Size} size Box pixel size.
   * @param {import("./pixel.js").Pixel} position Position on the view to center on.
   */ centerOnInternal(coordinate, size, position) {
        this.setCenterInternal($70364d0195659942$var$calculateCenterOn(coordinate, size, position, this.getResolution(), this.getRotation()));
    }
    /**
   * Calculates the shift between map and viewport center.
   * @param {import("./coordinate.js").Coordinate} center Center.
   * @param {number} resolution Resolution.
   * @param {number} rotation Rotation.
   * @param {import("./size.js").Size} size Size.
   * @return {Array<number>|undefined} Center shift.
   */ calculateCenterShift(center, resolution, rotation, size) {
        let centerShift;
        const padding = this.padding_;
        if (padding && center) {
            const reducedSize = this.getViewportSizeMinusPadding_(-rotation);
            const shiftedCenter = $70364d0195659942$var$calculateCenterOn(center, size, [
                reducedSize[0] / 2 + padding[3],
                reducedSize[1] / 2 + padding[0]
            ], resolution, rotation);
            centerShift = [
                center[0] - shiftedCenter[0],
                center[1] - shiftedCenter[1]
            ];
        }
        return centerShift;
    }
    /**
   * @return {boolean} Is defined.
   */ isDef() {
        return !!this.getCenterInternal() && this.getResolution() !== undefined;
    }
    /**
   * Adds relative coordinates to the center of the view. Any extent constraint will apply.
   * @param {import("./coordinate.js").Coordinate} deltaCoordinates Relative value to add.
   * @api
   */ adjustCenter(deltaCoordinates) {
        const center = (0, $9c4744460e43e41b$export$698f563af1ba02a5)(this.targetCenter_, this.getProjection());
        this.setCenter([
            center[0] + deltaCoordinates[0],
            center[1] + deltaCoordinates[1]
        ]);
    }
    /**
   * Adds relative coordinates to the center of the view. Any extent constraint will apply.
   * @param {import("./coordinate.js").Coordinate} deltaCoordinates Relative value to add.
   */ adjustCenterInternal(deltaCoordinates) {
        const center = this.targetCenter_;
        this.setCenterInternal([
            center[0] + deltaCoordinates[0],
            center[1] + deltaCoordinates[1]
        ]);
    }
    /**
   * Multiply the view resolution by a ratio, optionally using an anchor. Any resolution
   * constraint will apply.
   * @param {number} ratio The ratio to apply on the view resolution.
   * @param {import("./coordinate.js").Coordinate} [anchor] The origin of the transformation.
   * @api
   */ adjustResolution(ratio, anchor) {
        anchor = anchor && (0, $9c4744460e43e41b$export$d4b8ec0b96db1ee2)(anchor, this.getProjection());
        this.adjustResolutionInternal(ratio, anchor);
    }
    /**
   * Multiply the view resolution by a ratio, optionally using an anchor. Any resolution
   * constraint will apply.
   * @param {number} ratio The ratio to apply on the view resolution.
   * @param {import("./coordinate.js").Coordinate} [anchor] The origin of the transformation.
   */ adjustResolutionInternal(ratio, anchor) {
        const isMoving = this.getAnimating() || this.getInteracting();
        const size = this.getViewportSize_(this.getRotation());
        const newResolution = this.constraints_.resolution(this.targetResolution_ * ratio, 0, size, isMoving);
        if (anchor) this.targetCenter_ = this.calculateCenterZoom(newResolution, anchor);
        this.targetResolution_ *= ratio;
        this.applyTargetState_();
    }
    /**
   * Adds a value to the view zoom level, optionally using an anchor. Any resolution
   * constraint will apply.
   * @param {number} delta Relative value to add to the zoom level.
   * @param {import("./coordinate.js").Coordinate} [anchor] The origin of the transformation.
   * @api
   */ adjustZoom(delta, anchor) {
        this.adjustResolution(Math.pow(this.zoomFactor_, -delta), anchor);
    }
    /**
   * Adds a value to the view rotation, optionally using an anchor. Any rotation
   * constraint will apply.
   * @param {number} delta Relative value to add to the zoom rotation, in radians.
   * @param {import("./coordinate.js").Coordinate} [anchor] The rotation center.
   * @api
   */ adjustRotation(delta, anchor) {
        if (anchor) anchor = (0, $9c4744460e43e41b$export$d4b8ec0b96db1ee2)(anchor, this.getProjection());
        this.adjustRotationInternal(delta, anchor);
    }
    /**
   * @param {number} delta Relative value to add to the zoom rotation, in radians.
   * @param {import("./coordinate.js").Coordinate} [anchor] The rotation center.
   */ adjustRotationInternal(delta, anchor) {
        const isMoving = this.getAnimating() || this.getInteracting();
        const newRotation = this.constraints_.rotation(this.targetRotation_ + delta, isMoving);
        if (anchor) this.targetCenter_ = this.calculateCenterRotate(newRotation, anchor);
        this.targetRotation_ += delta;
        this.applyTargetState_();
    }
    /**
   * Set the center of the current view. Any extent constraint will apply.
   * @param {import("./coordinate.js").Coordinate|undefined} center The center of the view.
   * @observable
   * @api
   */ setCenter(center) {
        this.setCenterInternal(center ? (0, $9c4744460e43e41b$export$d4b8ec0b96db1ee2)(center, this.getProjection()) : center);
    }
    /**
   * Set the center using the view projection (not the user projection).
   * @param {import("./coordinate.js").Coordinate|undefined} center The center of the view.
   */ setCenterInternal(center) {
        this.targetCenter_ = center;
        this.applyTargetState_();
    }
    /**
   * @param {import("./ViewHint.js").default} hint Hint.
   * @param {number} delta Delta.
   * @return {number} New value.
   */ setHint(hint, delta) {
        this.hints_[hint] += delta;
        this.changed();
        return this.hints_[hint];
    }
    /**
   * Set the resolution for this view. Any resolution constraint will apply.
   * @param {number|undefined} resolution The resolution of the view.
   * @observable
   * @api
   */ setResolution(resolution) {
        this.targetResolution_ = resolution;
        this.applyTargetState_();
    }
    /**
   * Set the rotation for this view. Any rotation constraint will apply.
   * @param {number} rotation The rotation of the view in radians.
   * @observable
   * @api
   */ setRotation(rotation) {
        this.targetRotation_ = rotation;
        this.applyTargetState_();
    }
    /**
   * Zoom to a specific zoom level. Any resolution constrain will apply.
   * @param {number} zoom Zoom level.
   * @api
   */ setZoom(zoom) {
        this.setResolution(this.getResolutionForZoom(zoom));
    }
    /**
   * Recompute rotation/resolution/center based on target values.
   * Note: we have to compute rotation first, then resolution and center considering that
   * parameters can influence one another in case a view extent constraint is present.
   * @param {boolean} [doNotCancelAnims] Do not cancel animations.
   * @param {boolean} [forceMoving] Apply constraints as if the view is moving.
   * @private
   */ applyTargetState_(doNotCancelAnims, forceMoving) {
        const isMoving = this.getAnimating() || this.getInteracting() || forceMoving;
        // compute rotation
        const newRotation = this.constraints_.rotation(this.targetRotation_, isMoving);
        const size = this.getViewportSize_(newRotation);
        const newResolution = this.constraints_.resolution(this.targetResolution_, 0, size, isMoving);
        const newCenter = this.constraints_.center(this.targetCenter_, newResolution, size, isMoving, this.calculateCenterShift(this.targetCenter_, newResolution, newRotation, size));
        if (this.get((0, $d35baefbe89be4c5$export$2e2bcd8739ae039).ROTATION) !== newRotation) this.set((0, $d35baefbe89be4c5$export$2e2bcd8739ae039).ROTATION, newRotation);
        if (this.get((0, $d35baefbe89be4c5$export$2e2bcd8739ae039).RESOLUTION) !== newResolution) {
            this.set((0, $d35baefbe89be4c5$export$2e2bcd8739ae039).RESOLUTION, newResolution);
            this.set('zoom', this.getZoom(), true);
        }
        if (!newCenter || !this.get((0, $d35baefbe89be4c5$export$2e2bcd8739ae039).CENTER) || !(0, $1bd0a226f9a16141$export$e9bab7fafb253603)(this.get((0, $d35baefbe89be4c5$export$2e2bcd8739ae039).CENTER), newCenter)) this.set((0, $d35baefbe89be4c5$export$2e2bcd8739ae039).CENTER, newCenter);
        if (this.getAnimating() && !doNotCancelAnims) this.cancelAnimations();
        this.cancelAnchor_ = undefined;
    }
    /**
   * If any constraints need to be applied, an animation will be triggered.
   * This is typically done on interaction end.
   * Note: calling this with a duration of 0 will apply the constrained values straight away,
   * without animation.
   * @param {number} [duration] The animation duration in ms.
   * @param {number} [resolutionDirection] Which direction to zoom.
   * @param {import("./coordinate.js").Coordinate} [anchor] The origin of the transformation.
   */ resolveConstraints(duration, resolutionDirection, anchor) {
        duration = duration !== undefined ? duration : 200;
        const direction = resolutionDirection || 0;
        const newRotation = this.constraints_.rotation(this.targetRotation_);
        const size = this.getViewportSize_(newRotation);
        const newResolution = this.constraints_.resolution(this.targetResolution_, direction, size);
        const newCenter = this.constraints_.center(this.targetCenter_, newResolution, size, false, this.calculateCenterShift(this.targetCenter_, newResolution, newRotation, size));
        if (duration === 0 && !this.cancelAnchor_) {
            this.targetResolution_ = newResolution;
            this.targetRotation_ = newRotation;
            this.targetCenter_ = newCenter;
            this.applyTargetState_();
            return;
        }
        anchor = anchor || (duration === 0 ? this.cancelAnchor_ : undefined);
        this.cancelAnchor_ = undefined;
        if (this.getResolution() !== newResolution || this.getRotation() !== newRotation || !this.getCenterInternal() || !(0, $1bd0a226f9a16141$export$e9bab7fafb253603)(this.getCenterInternal(), newCenter)) {
            if (this.getAnimating()) this.cancelAnimations();
            this.animateInternal({
                rotation: newRotation,
                center: newCenter,
                resolution: newResolution,
                duration: duration,
                easing: (0, $c7ccf7e681a9b333$export$57636bb43b1ccbb0),
                anchor: anchor
            });
        }
    }
    /**
   * Notify the View that an interaction has started.
   * The view state will be resolved to a stable one if needed
   * (depending on its constraints).
   * @api
   */ beginInteraction() {
        this.resolveConstraints(0);
        this.setHint((0, $7d362782b4ccb93d$export$2e2bcd8739ae039).INTERACTING, 1);
    }
    /**
   * Notify the View that an interaction has ended. The view state will be resolved
   * to a stable one if needed (depending on its constraints).
   * @param {number} [duration] Animation duration in ms.
   * @param {number} [resolutionDirection] Which direction to zoom.
   * @param {import("./coordinate.js").Coordinate} [anchor] The origin of the transformation.
   * @api
   */ endInteraction(duration, resolutionDirection, anchor) {
        anchor = anchor && (0, $9c4744460e43e41b$export$d4b8ec0b96db1ee2)(anchor, this.getProjection());
        this.endInteractionInternal(duration, resolutionDirection, anchor);
    }
    /**
   * Notify the View that an interaction has ended. The view state will be resolved
   * to a stable one if needed (depending on its constraints).
   * @param {number} [duration] Animation duration in ms.
   * @param {number} [resolutionDirection] Which direction to zoom.
   * @param {import("./coordinate.js").Coordinate} [anchor] The origin of the transformation.
   */ endInteractionInternal(duration, resolutionDirection, anchor) {
        if (!this.getInteracting()) return;
        this.setHint((0, $7d362782b4ccb93d$export$2e2bcd8739ae039).INTERACTING, -1);
        this.resolveConstraints(duration, resolutionDirection, anchor);
    }
    /**
   * Get a valid position for the view center according to the current constraints.
   * @param {import("./coordinate.js").Coordinate|undefined} targetCenter Target center position.
   * @param {number} [targetResolution] Target resolution. If not supplied, the current one will be used.
   * This is useful to guess a valid center position at a different zoom level.
   * @return {import("./coordinate.js").Coordinate|undefined} Valid center position.
   */ getConstrainedCenter(targetCenter, targetResolution) {
        const size = this.getViewportSize_(this.getRotation());
        return this.constraints_.center(targetCenter, targetResolution || this.getResolution(), size);
    }
    /**
   * Get a valid zoom level according to the current view constraints.
   * @param {number|undefined} targetZoom Target zoom.
   * @param {number} [direction] Indicate which resolution should be used
   * by a renderer if the view resolution does not match any resolution of the tile source.
   * If 0, the nearest resolution will be used. If 1, the nearest lower resolution
   * will be used. If -1, the nearest higher resolution will be used.
   * @return {number|undefined} Valid zoom level.
   */ getConstrainedZoom(targetZoom, direction) {
        const targetRes = this.getResolutionForZoom(targetZoom);
        return this.getZoomForResolution(this.getConstrainedResolution(targetRes, direction));
    }
    /**
   * Get a valid resolution according to the current view constraints.
   * @param {number|undefined} targetResolution Target resolution.
   * @param {number} [direction] Indicate which resolution should be used
   * by a renderer if the view resolution does not match any resolution of the tile source.
   * If 0, the nearest resolution will be used. If 1, the nearest lower resolution
   * will be used. If -1, the nearest higher resolution will be used.
   * @return {number|undefined} Valid resolution.
   */ getConstrainedResolution(targetResolution, direction) {
        direction = direction || 0;
        const size = this.getViewportSize_(this.getRotation());
        return this.constraints_.resolution(targetResolution, direction, size);
    }
}
/**
 * @param {Function} callback Callback.
 * @param {*} returnValue Return value.
 */ function $70364d0195659942$var$animationCallback(callback, returnValue) {
    setTimeout(function() {
        callback(returnValue);
    }, 0);
}
function $70364d0195659942$export$964345001ee9ac52(options) {
    if (options.extent !== undefined) {
        const smooth = options.smoothExtentConstraint !== undefined ? options.smoothExtentConstraint : true;
        return (0, $b21a6e049949bb31$export$c2f0af2c946f6897)(options.extent, options.constrainOnlyCenter, smooth);
    }
    const projection = (0, $9c4744460e43e41b$export$549167224996a0fb)(options.projection, 'EPSG:3857');
    if (options.multiWorld !== true && projection.isGlobal()) {
        const extent = projection.getExtent().slice();
        extent[0] = -Infinity;
        extent[2] = Infinity;
        return (0, $b21a6e049949bb31$export$c2f0af2c946f6897)(extent, false, false);
    }
    return 0, $b21a6e049949bb31$export$f883a24d5edde77c;
}
function $70364d0195659942$export$c68d65f9148da196(options) {
    let resolutionConstraint;
    let maxResolution;
    let minResolution;
    // TODO: move these to be ol constants
    // see https://github.com/openlayers/openlayers/issues/2076
    const defaultMaxZoom = 28;
    const defaultZoomFactor = 2;
    let minZoom = options.minZoom !== undefined ? options.minZoom : $70364d0195659942$var$DEFAULT_MIN_ZOOM;
    let maxZoom = options.maxZoom !== undefined ? options.maxZoom : defaultMaxZoom;
    const zoomFactor = options.zoomFactor !== undefined ? options.zoomFactor : defaultZoomFactor;
    const multiWorld = options.multiWorld !== undefined ? options.multiWorld : false;
    const smooth = options.smoothResolutionConstraint !== undefined ? options.smoothResolutionConstraint : true;
    const showFullExtent = options.showFullExtent !== undefined ? options.showFullExtent : false;
    const projection = (0, $9c4744460e43e41b$export$549167224996a0fb)(options.projection, 'EPSG:3857');
    const projExtent = projection.getExtent();
    let constrainOnlyCenter = options.constrainOnlyCenter;
    let extent = options.extent;
    if (!multiWorld && !extent && projection.isGlobal()) {
        constrainOnlyCenter = false;
        extent = projExtent;
    }
    if (options.resolutions !== undefined) {
        const resolutions = options.resolutions;
        maxResolution = resolutions[minZoom];
        minResolution = resolutions[maxZoom] !== undefined ? resolutions[maxZoom] : resolutions[resolutions.length - 1];
        if (options.constrainResolution) resolutionConstraint = (0, $bac43a1f4a628548$export$d65a517690fc4385)(resolutions, smooth, !constrainOnlyCenter && extent, showFullExtent);
        else resolutionConstraint = (0, $bac43a1f4a628548$export$1c4e6da9b4b066fe)(maxResolution, minResolution, smooth, !constrainOnlyCenter && extent, showFullExtent);
    } else {
        // calculate the default min and max resolution
        const size = !projExtent ? 360 * (0, $03edbd434a9e6608$export$1482081eec883108).degrees / projection.getMetersPerUnit() : Math.max((0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(projExtent), (0, $6da4c8ed3074c92b$export$c08559766941f856)(projExtent));
        const defaultMaxResolution = size / (0, $57cd8651d88957a0$export$6b8cb5cd370bd90c) / Math.pow(defaultZoomFactor, $70364d0195659942$var$DEFAULT_MIN_ZOOM);
        const defaultMinResolution = defaultMaxResolution / Math.pow(defaultZoomFactor, defaultMaxZoom - $70364d0195659942$var$DEFAULT_MIN_ZOOM);
        // user provided maxResolution takes precedence
        maxResolution = options.maxResolution;
        if (maxResolution !== undefined) minZoom = 0;
        else maxResolution = defaultMaxResolution / Math.pow(zoomFactor, minZoom);
        // user provided minResolution takes precedence
        minResolution = options.minResolution;
        if (minResolution === undefined) {
            if (options.maxZoom !== undefined) {
                if (options.maxResolution !== undefined) minResolution = maxResolution / Math.pow(zoomFactor, maxZoom);
                else minResolution = defaultMaxResolution / Math.pow(zoomFactor, maxZoom);
            } else minResolution = defaultMinResolution;
        }
        // given discrete zoom levels, minResolution may be different than provided
        maxZoom = minZoom + Math.floor(Math.log(maxResolution / minResolution) / Math.log(zoomFactor));
        minResolution = maxResolution / Math.pow(zoomFactor, maxZoom - minZoom);
        if (options.constrainResolution) resolutionConstraint = (0, $bac43a1f4a628548$export$22ac0f6b219de91a)(zoomFactor, maxResolution, minResolution, smooth, !constrainOnlyCenter && extent, showFullExtent);
        else resolutionConstraint = (0, $bac43a1f4a628548$export$1c4e6da9b4b066fe)(maxResolution, minResolution, smooth, !constrainOnlyCenter && extent, showFullExtent);
    }
    return {
        constraint: resolutionConstraint,
        maxResolution: maxResolution,
        minResolution: minResolution,
        minZoom: minZoom,
        zoomFactor: zoomFactor
    };
}
function $70364d0195659942$export$4eeaa08dd550e3c0(options) {
    const enableRotation = options.enableRotation !== undefined ? options.enableRotation : true;
    if (enableRotation) {
        const constrainRotation = options.constrainRotation;
        if (constrainRotation === undefined || constrainRotation === true) return (0, $d65f0a322291d127$export$17a6e6f3448b17e8)();
        if (constrainRotation === false) return 0, $d65f0a322291d127$export$f883a24d5edde77c;
        if (typeof constrainRotation === 'number') return (0, $d65f0a322291d127$export$9ba78806de831083)(constrainRotation);
        return 0, $d65f0a322291d127$export$f883a24d5edde77c;
    }
    return 0, $d65f0a322291d127$export$e20fbacbb41798b;
}
function $70364d0195659942$export$ee75376562060184(animation) {
    if (animation.sourceCenter && animation.targetCenter) {
        if (!(0, $1bd0a226f9a16141$export$e9bab7fafb253603)(animation.sourceCenter, animation.targetCenter)) return false;
    }
    if (animation.sourceResolution !== animation.targetResolution) return false;
    if (animation.sourceRotation !== animation.targetRotation) return false;
    return true;
}
/**
 * @param {import("./coordinate.js").Coordinate} coordinate Coordinate.
 * @param {import("./size.js").Size} size Box pixel size.
 * @param {import("./pixel.js").Pixel} position Position on the view to center on.
 * @param {number} resolution Resolution.
 * @param {number} rotation Rotation.
 * @return {import("./coordinate.js").Coordinate} Shifted center.
 */ function $70364d0195659942$var$calculateCenterOn(coordinate, size, position, resolution, rotation) {
    // calculate rotated position
    const cosAngle = Math.cos(-rotation);
    let sinAngle = Math.sin(-rotation);
    let rotX = coordinate[0] * cosAngle - coordinate[1] * sinAngle;
    let rotY = coordinate[1] * cosAngle + coordinate[0] * sinAngle;
    rotX += (size[0] / 2 - position[0]) * resolution;
    rotY += (position[1] - size[1] / 2) * resolution;
    // go back to original angle
    sinAngle = -sinAngle; // go back to original rotation
    const centerX = rotX * cosAngle - rotY * sinAngle;
    const centerY = rotY * cosAngle + rotX * sinAngle;
    return [
        centerX,
        centerY
    ];
}
var $70364d0195659942$export$2e2bcd8739ae039 = $70364d0195659942$var$View;






/**
 * @module ol/control/defaults
 */ 
/**
 * @module ol/control/Attribution
 */ 
/**
 * @module ol/css
 */ /**
 * @typedef {Object} FontParameters
 * @property {string} style Style.
 * @property {string} variant Variant.
 * @property {string} weight Weight.
 * @property {string} size Size.
 * @property {string} lineHeight LineHeight.
 * @property {string} family Family.
 * @property {Array<string>} families Families.
 */ /**
 * The CSS class for hidden feature.
 *
 * @const
 * @type {string}
 */ const $ce07df6d5d4656f1$export$981241db82723ce2 = 'ol-hidden';
const $ce07df6d5d4656f1$export$99b49471b0394319 = 'ol-selectable';
const $ce07df6d5d4656f1$export$1afde3d6e16a7b29 = 'ol-unselectable';
const $ce07df6d5d4656f1$export$68eede0dd8c6c1da = 'ol-unsupported';
const $ce07df6d5d4656f1$export$4d4f8be70b656192 = 'ol-control';
const $ce07df6d5d4656f1$export$e16017ac68d14492 = 'ol-collapsed';
/**
 * From https://stackoverflow.com/questions/10135697/regex-to-parse-any-css-font
 * @type {RegExp}
 */ const $ce07df6d5d4656f1$var$fontRegEx = new RegExp([
    '^\\s*(?=(?:(?:[-a-z]+\\s*){0,2}(italic|oblique))?)',
    '(?=(?:(?:[-a-z]+\\s*){0,2}(small-caps))?)',
    '(?=(?:(?:[-a-z]+\\s*){0,2}(bold(?:er)?|lighter|[1-9]00 ))?)',
    '(?:(?:normal|\\1|\\2|\\3)\\s*){0,3}((?:xx?-)?',
    '(?:small|large)|medium|smaller|larger|[\\.\\d]+(?:\\%|in|[cem]m|ex|p[ctx]))',
    '(?:\\s*\\/\\s*(normal|[\\.\\d]+(?:\\%|in|[cem]m|ex|p[ctx])?))',
    '?\\s*([-,\\"\\\'\\sa-z0-9]+?)\\s*$'
].join(''), 'i');
/** @type {Array<'style'|'variant'|'weight'|'size'|'lineHeight'|'family'>} */ const $ce07df6d5d4656f1$var$fontRegExMatchIndex = [
    'style',
    'variant',
    'weight',
    'size',
    'lineHeight',
    'family'
];
const $ce07df6d5d4656f1$export$59230918eb9bd861 = {
    normal: 400,
    bold: 700
};
const $ce07df6d5d4656f1$export$5abde8a6aec4a131 = function(fontSpec) {
    const match = fontSpec.match($ce07df6d5d4656f1$var$fontRegEx);
    if (!match) return null;
    const style = /** @type {FontParameters} */ {
        lineHeight: 'normal',
        size: '1.2em',
        style: 'normal',
        weight: '400',
        variant: 'normal'
    };
    for(let i = 0, ii = $ce07df6d5d4656f1$var$fontRegExMatchIndex.length; i < ii; ++i){
        const value = match[i + 1];
        if (value !== undefined) style[$ce07df6d5d4656f1$var$fontRegExMatchIndex[i]] = typeof value === 'string' ? value.trim() : value;
    }
    if (isNaN(Number(style.weight)) && style.weight in $ce07df6d5d4656f1$export$59230918eb9bd861) style.weight = $ce07df6d5d4656f1$export$59230918eb9bd861[style.weight];
    style.families = style.family.split(/,\s?/).map((f)=>f.trim().replace(/^['"]|['"]$/g, ''));
    return style;
};



function $075f937d7366f1a2$export$9e05d10eae75c464(width, height, canvasPool, settings) {
    /** @type {HTMLCanvasElement|OffscreenCanvas} */ let canvas;
    if (canvasPool && canvasPool.length) canvas = /** @type {HTMLCanvasElement} */ canvasPool.shift();
    else if (0, $67c66761d21428d0$export$98fcef3dc9973292) canvas = new OffscreenCanvas(width || 300, height || 300);
    else canvas = document.createElement('canvas');
    if (width) canvas.width = width;
    if (height) canvas.height = height;
    //FIXME Allow OffscreenCanvasRenderingContext2D as return type
    return /** @type {CanvasRenderingContext2D} */ canvas.getContext('2d', settings);
}
/** @type {CanvasRenderingContext2D} */ let $075f937d7366f1a2$var$sharedCanvasContext;
function $075f937d7366f1a2$export$fcb72ce088a6632c() {
    if (!$075f937d7366f1a2$var$sharedCanvasContext) $075f937d7366f1a2$var$sharedCanvasContext = $075f937d7366f1a2$export$9e05d10eae75c464(1, 1);
    return $075f937d7366f1a2$var$sharedCanvasContext;
}
function $075f937d7366f1a2$export$e918ac6a1026a12a(context) {
    const canvas = context.canvas;
    canvas.width = 1;
    canvas.height = 1;
    context.clearRect(0, 0, 1, 1);
}
function $075f937d7366f1a2$export$e823f88e4111159a(element) {
    let width = element.offsetWidth;
    const style = getComputedStyle(element);
    width += parseInt(style.marginLeft, 10) + parseInt(style.marginRight, 10);
    return width;
}
function $075f937d7366f1a2$export$fc5b8aac72846d1e(element) {
    let height = element.offsetHeight;
    const style = getComputedStyle(element);
    height += parseInt(style.marginTop, 10) + parseInt(style.marginBottom, 10);
    return height;
}
function $075f937d7366f1a2$export$5542201de9311ab2(newNode, oldNode) {
    const parent = oldNode.parentNode;
    if (parent) parent.replaceChild(newNode, oldNode);
}
function $075f937d7366f1a2$export$1e1c9bf5a4ffe0d1(node) {
    while(node.lastChild)node.lastChild.remove();
}
function $075f937d7366f1a2$export$caeacfe04f52533a(node, children) {
    const oldChildren = node.childNodes;
    for(let i = 0;; ++i){
        const oldChild = oldChildren[i];
        const newChild = children[i];
        // check if our work is done
        if (!oldChild && !newChild) break;
        // check if children match
        if (oldChild === newChild) continue;
        // check if a new child needs to be added
        if (!oldChild) {
            node.appendChild(newChild);
            continue;
        }
        // check if an old child needs to be removed
        if (!newChild) {
            node.removeChild(oldChild);
            --i;
            continue;
        }
        // reorder
        node.insertBefore(newChild, oldChild);
    }
}




/**
 * @module ol/control/Control
 */ 



/**
 * @typedef {Object} Options
 * @property {HTMLElement} [element] The element is the control's
 * container element. This only needs to be specified if you're developing
 * a custom control.
 * @property {function(import("../MapEvent.js").default):void} [render] Function called when
 * the control should be re-rendered. This is called in a `requestAnimationFrame`
 * callback.
 * @property {HTMLElement|string} [target] Specify a target if you want
 * the control to be rendered outside of the map's viewport.
 */ /**
 * @classdesc
 * A control is a visible widget with a DOM element in a fixed position on the
 * screen. They can involve user input (buttons), or be informational only;
 * the position is determined using CSS. By default these are placed in the
 * container with CSS class name `ol-overlaycontainer-stopevent`, but can use
 * any outside DOM element.
 *
 * This is the base class for controls. You can use it for simple custom
 * controls by creating the element with listeners, creating an instance:
 * ```js
 * const myControl = new Control({element: myElement});
 * ```
 * and then adding this to the map.
 *
 * The main advantage of having this as a control rather than a simple separate
 * DOM element is that preventing propagation is handled for you. Controls
 * will also be objects in a {@link module:ol/Collection~Collection}, so you can use their methods.
 *
 * You can also extend this base for your own control class. See
 * examples/custom-controls for an example of how to do this.
 *
 * @api
 */ class $b978dafe8f7d27ff$var$Control extends (0, $b68b3d6e32e3074a$export$2e2bcd8739ae039) {
    /**
   * @param {Options} options Control options.
   */ constructor(options){
        super();
        const element = options.element;
        if (element && !options.target && !element.style.pointerEvents) element.style.pointerEvents = 'auto';
        /**
     * @protected
     * @type {HTMLElement}
     */ this.element = element ? element : null;
        /**
     * @private
     * @type {HTMLElement}
     */ this.target_ = null;
        /**
     * @private
     * @type {import("../Map.js").default|null}
     */ this.map_ = null;
        /**
     * @protected
     * @type {!Array<import("../events.js").EventsKey>}
     */ this.listenerKeys = [];
        if (options.render) this.render = options.render;
        if (options.target) this.setTarget(options.target);
    }
    /**
   * Clean up.
   * @override
   */ disposeInternal() {
        this.element?.remove();
        super.disposeInternal();
    }
    /**
   * Get the map associated with this control.
   * @return {import("../Map.js").default|null} Map.
   * @api
   */ getMap() {
        return this.map_;
    }
    /**
   * Remove the control from its current map and attach it to the new map.
   * Pass `null` to just remove the control from the current map.
   * Subclasses may set up event handlers to get notified about changes to
   * the map here.
   * @param {import("../Map.js").default|null} map Map.
   * @api
   */ setMap(map) {
        if (this.map_) this.element?.remove();
        for(let i = 0, ii = this.listenerKeys.length; i < ii; ++i)(0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921)(this.listenerKeys[i]);
        this.listenerKeys.length = 0;
        this.map_ = map;
        if (map) {
            const target = this.target_ ?? map.getOverlayContainerStopEvent();
            if (this.element) target.appendChild(this.element);
            if (this.render !== (0, $013a1733c226ec50$export$1cd1943b3a73bbe8)) this.listenerKeys.push((0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(map, (0, $e4ad75f913b6f7ff$export$2e2bcd8739ae039).POSTRENDER, this.render, this));
            map.render();
        }
    }
    /**
   * Renders the control.
   * @param {import("../MapEvent.js").default} mapEvent Map event.
   * @api
   */ render(mapEvent) {}
    /**
   * This function is used to set a target element for the control. It has no
   * effect if it is called after the control has been added to the map (i.e.
   * after `setMap` is called on the control). If no `target` is set in the
   * options passed to the control constructor and if `setTarget` is not called
   * then the control is added to the map's overlay container.
   * @param {HTMLElement|string} target Target.
   * @api
   */ setTarget(target) {
        this.target_ = typeof target === 'string' ? document.getElementById(target) : target;
    }
}
var $b978dafe8f7d27ff$export$2e2bcd8739ae039 = $b978dafe8f7d27ff$var$Control;


/**
 * @typedef {Object} Options
 * @property {string} [className='ol-attribution'] CSS class name.
 * @property {HTMLElement|string} [target] Specify a target if you
 * want the control to be rendered outside of the map's
 * viewport.
 * @property {boolean} [collapsible] Specify if attributions can
 * be collapsed. If not specified, sources control this behavior with their
 * `attributionsCollapsible` setting.
 * @property {boolean} [collapsed=true] Specify if attributions should
 * be collapsed at startup.
 * @property {string} [tipLabel='Attributions'] Text label to use for the button tip.
 * @property {string|HTMLElement} [label='i'] Text label to use for the
 * collapsed attributions button.
 * Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string} [expandClassName=className + '-expand'] CSS class name for the
 * collapsed attributions button.
 * @property {string|HTMLElement} [collapseLabel='›'] Text label to use
 * for the expanded attributions button.
 * Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string} [collapseClassName=className + '-collapse'] CSS class name for the
 * expanded attributions button.
 * @property {function(import("../MapEvent.js").default):void} [render] Function called when
 * the control should be re-rendered. This is called in a `requestAnimationFrame`
 * callback.
 * @property {string|Array<string>|undefined} [attributions] Optional attribution(s) that will always be
 * displayed regardless of the layers rendered.
 * **Caution:** Attributions are rendered dynamically using `innerHTML`, which can lead to potential
 * [**XSS (Cross-Site Scripting)**](https://en.wikipedia.org/wiki/Cross-site_scripting) vulnerabilities.
 * Use this feature only for trusted content
 * or ensure that the content is properly sanitized before inserting it.
 */ /**
 * @classdesc
 * Control to show all the attributions associated with the layer sources
 * in the map. This control is one of the default controls included in maps.
 * By default it will show in the bottom right portion of the map, but this can
 * be changed by using a css selector for `.ol-attribution`.
 *
 * @api
 */ class $6a26ab11104d2c24$var$Attribution extends (0, $b978dafe8f7d27ff$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Attribution options.
   */ constructor(options){
        options = options ? options : {};
        super({
            element: document.createElement('div'),
            render: options.render,
            target: options.target
        });
        /**
     * @private
     * @type {HTMLElement}
     */ this.ulElement_ = document.createElement('ul');
        /**
     * @private
     * @type {boolean}
     */ this.collapsed_ = options.collapsed !== undefined ? options.collapsed : true;
        /**
     * @private
     * @type {boolean}
     */ this.userCollapsed_ = this.collapsed_;
        /**
     * @private
     * @type {boolean}
     */ this.overrideCollapsible_ = options.collapsible !== undefined;
        /**
     * @private
     * @type {boolean}
     */ this.collapsible_ = options.collapsible !== undefined ? options.collapsible : true;
        if (!this.collapsible_) this.collapsed_ = false;
        /**
     * @private
     * @type {string | Array<string> | undefined}
     */ this.attributions_ = options.attributions;
        const className = options.className !== undefined ? options.className : 'ol-attribution';
        const tipLabel = options.tipLabel !== undefined ? options.tipLabel : 'Attributions';
        const expandClassName = options.expandClassName !== undefined ? options.expandClassName : className + '-expand';
        const collapseLabel = options.collapseLabel !== undefined ? options.collapseLabel : '\u203A';
        const collapseClassName = options.collapseClassName !== undefined ? options.collapseClassName : className + '-collapse';
        if (typeof collapseLabel === 'string') {
            /**
       * @private
       * @type {HTMLElement}
       */ this.collapseLabel_ = document.createElement('span');
            this.collapseLabel_.textContent = collapseLabel;
            this.collapseLabel_.className = collapseClassName;
        } else this.collapseLabel_ = collapseLabel;
        const label = options.label !== undefined ? options.label : 'i';
        if (typeof label === 'string') {
            /**
       * @private
       * @type {HTMLElement}
       */ this.label_ = document.createElement('span');
            this.label_.textContent = label;
            this.label_.className = expandClassName;
        } else this.label_ = label;
        const activeLabel = this.collapsible_ && !this.collapsed_ ? this.collapseLabel_ : this.label_;
        /**
     * @private
     * @type {HTMLElement}
     */ this.toggleButton_ = document.createElement('button');
        this.toggleButton_.setAttribute('type', 'button');
        this.toggleButton_.setAttribute('aria-expanded', String(!this.collapsed_));
        this.toggleButton_.title = tipLabel;
        this.toggleButton_.appendChild(activeLabel);
        this.toggleButton_.addEventListener((0, $294047c5e65f31a3$export$2e2bcd8739ae039).CLICK, this.handleClick_.bind(this), false);
        const cssClasses = className + ' ' + (0, $ce07df6d5d4656f1$export$1afde3d6e16a7b29) + ' ' + (0, $ce07df6d5d4656f1$export$4d4f8be70b656192) + (this.collapsed_ && this.collapsible_ ? ' ' + (0, $ce07df6d5d4656f1$export$e16017ac68d14492) : '') + (this.collapsible_ ? '' : ' ol-uncollapsible');
        const element = this.element;
        element.className = cssClasses;
        element.appendChild(this.toggleButton_);
        element.appendChild(this.ulElement_);
        /**
     * A list of currently rendered resolutions.
     * @type {Array<string>}
     * @private
     */ this.renderedAttributions_ = [];
        /**
     * @private
     * @type {boolean}
     */ this.renderedVisible_ = true;
    }
    /**
   * Collect a list of visible attributions and set the collapsible state.
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @return {Array<string>} Attributions.
   * @private
   */ collectSourceAttributions_(frameState) {
        const layers = this.getMap().getAllLayers();
        const visibleAttributions = new Set(layers.flatMap((layer)=>layer.getAttributions(frameState)));
        if (this.attributions_ !== undefined) Array.isArray(this.attributions_) ? this.attributions_.forEach((item)=>visibleAttributions.add(item)) : visibleAttributions.add(this.attributions_);
        if (!this.overrideCollapsible_) {
            const collapsible = !layers.some((layer)=>layer.getSource()?.getAttributionsCollapsible() === false);
            this.setCollapsible(collapsible);
        }
        return Array.from(visibleAttributions);
    }
    /**
   * @private
   * @param {?import("../Map.js").FrameState} frameState Frame state.
   */ async updateElement_(frameState) {
        if (!frameState) {
            if (this.renderedVisible_) {
                this.element.style.display = 'none';
                this.renderedVisible_ = false;
            }
            return;
        }
        const attributions = await Promise.all(this.collectSourceAttributions_(frameState).map((attribution)=>(0, $013a1733c226ec50$export$4dbaaf6c79705e6c)(()=>attribution)));
        const visible = attributions.length > 0;
        if (this.renderedVisible_ != visible) {
            this.element.style.display = visible ? '' : 'none';
            this.renderedVisible_ = visible;
        }
        if ((0, $b998d41b678ed5d1$export$e9bab7fafb253603)(attributions, this.renderedAttributions_)) return;
        (0, $075f937d7366f1a2$export$1e1c9bf5a4ffe0d1)(this.ulElement_);
        // append the attributions
        for(let i = 0, ii = attributions.length; i < ii; ++i){
            const element = document.createElement('li');
            element.innerHTML = attributions[i];
            this.ulElement_.appendChild(element);
        }
        this.renderedAttributions_ = attributions;
    }
    /**
   * @param {MouseEvent} event The event to handle
   * @private
   */ handleClick_(event) {
        event.preventDefault();
        this.handleToggle_();
        this.userCollapsed_ = this.collapsed_;
    }
    /**
   * @private
   */ handleToggle_() {
        this.element.classList.toggle((0, $ce07df6d5d4656f1$export$e16017ac68d14492));
        if (this.collapsed_) (0, $075f937d7366f1a2$export$5542201de9311ab2)(this.collapseLabel_, this.label_);
        else (0, $075f937d7366f1a2$export$5542201de9311ab2)(this.label_, this.collapseLabel_);
        this.collapsed_ = !this.collapsed_;
        this.toggleButton_.setAttribute('aria-expanded', String(!this.collapsed_));
    }
    /**
   * Return `true` if the attribution is collapsible, `false` otherwise.
   * @return {boolean} True if the widget is collapsible.
   * @api
   */ getCollapsible() {
        return this.collapsible_;
    }
    /**
   * Set whether the attribution should be collapsible.
   * @param {boolean} collapsible True if the widget is collapsible.
   * @api
   */ setCollapsible(collapsible) {
        if (this.collapsible_ === collapsible) return;
        this.collapsible_ = collapsible;
        this.element.classList.toggle('ol-uncollapsible');
        if (this.userCollapsed_) this.handleToggle_();
    }
    /**
   * Collapse or expand the attribution according to the passed parameter. Will
   * not do anything if the attribution isn't collapsible or if the current
   * collapsed state is already the one requested.
   * @param {boolean} collapsed True if the widget is collapsed.
   * @api
   */ setCollapsed(collapsed) {
        this.userCollapsed_ = collapsed;
        if (!this.collapsible_ || this.collapsed_ === collapsed) return;
        this.handleToggle_();
    }
    /**
   * Return `true` when the attribution is currently collapsed or `false`
   * otherwise.
   * @return {boolean} True if the widget is collapsed.
   * @api
   */ getCollapsed() {
        return this.collapsed_;
    }
    /**
   * Update the attribution element.
   * @param {import("../MapEvent.js").default} mapEvent Map event.
   * @override
   */ render(mapEvent) {
        this.updateElement_(mapEvent.frameState);
    }
}
var $6a26ab11104d2c24$export$2e2bcd8739ae039 = $6a26ab11104d2c24$var$Attribution;


/**
 * @module ol/control/Rotate
 */ 



/**
 * @typedef {Object} Options
 * @property {string} [className='ol-rotate'] CSS class name.
 * @property {string|HTMLElement} [label='⇧'] Text label to use for the rotate button.
 * Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string} [tipLabel='Reset rotation'] Text label to use for the rotate tip.
 * @property {string} [compassClassName='ol-compass'] CSS class name for the compass.
 * @property {number} [duration=250] Animation duration in milliseconds.
 * @property {boolean} [autoHide=true] Hide the control when rotation is 0.
 * @property {function(import("../MapEvent.js").default):void} [render] Function called when the control should
 * be re-rendered. This is called in a `requestAnimationFrame` callback.
 * @property {function():void} [resetNorth] Function called when the control is clicked.
 * This will override the default `resetNorth`.
 * @property {HTMLElement|string} [target] Specify a target if you want the control to be
 * rendered outside of the map's viewport.
 */ /**
 * @classdesc
 * A button control to reset rotation to 0.
 * To style this control use css selector `.ol-rotate`. A `.ol-hidden` css
 * selector is added to the button when the rotation is 0.
 *
 * @api
 */ class $a305cff1f91b3b86$var$Rotate extends (0, $b978dafe8f7d27ff$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Rotate options.
   */ constructor(options){
        options = options ? options : {};
        super({
            element: document.createElement('div'),
            render: options.render,
            target: options.target
        });
        const className = options.className !== undefined ? options.className : 'ol-rotate';
        const label = options.label !== undefined ? options.label : '\u21E7';
        const compassClassName = options.compassClassName !== undefined ? options.compassClassName : 'ol-compass';
        /**
     * @type {HTMLElement}
     * @private
     */ this.label_ = null;
        if (typeof label === 'string') {
            this.label_ = document.createElement('span');
            this.label_.className = compassClassName;
            this.label_.textContent = label;
        } else {
            this.label_ = label;
            this.label_.classList.add(compassClassName);
        }
        const tipLabel = options.tipLabel ? options.tipLabel : 'Reset rotation';
        const button = document.createElement('button');
        button.className = className + '-reset';
        button.setAttribute('type', 'button');
        button.title = tipLabel;
        button.appendChild(this.label_);
        button.addEventListener((0, $294047c5e65f31a3$export$2e2bcd8739ae039).CLICK, this.handleClick_.bind(this), false);
        const cssClasses = className + ' ' + (0, $ce07df6d5d4656f1$export$1afde3d6e16a7b29) + ' ' + (0, $ce07df6d5d4656f1$export$4d4f8be70b656192);
        const element = this.element;
        element.className = cssClasses;
        element.appendChild(button);
        /**
     * @private
     */ this.callResetNorth_ = options.resetNorth ? options.resetNorth : undefined;
        /**
     * @type {number}
     * @private
     */ this.duration_ = options.duration !== undefined ? options.duration : 250;
        /**
     * @type {boolean}
     * @private
     */ this.autoHide_ = options.autoHide !== undefined ? options.autoHide : true;
        /**
     * @private
     * @type {number|undefined}
     */ this.rotation_ = undefined;
        if (this.autoHide_) this.element.classList.add((0, $ce07df6d5d4656f1$export$981241db82723ce2));
    }
    /**
   * @param {MouseEvent} event The event to handle
   * @private
   */ handleClick_(event) {
        event.preventDefault();
        if (this.callResetNorth_ !== undefined) this.callResetNorth_();
        else this.resetNorth_();
    }
    /**
   * @private
   */ resetNorth_() {
        const map = this.getMap();
        const view = map.getView();
        if (!view) // the map does not have a view, so we can't act
        // upon it
        return;
        const rotation = view.getRotation();
        if (rotation !== undefined) {
            if (this.duration_ > 0 && rotation % (2 * Math.PI) !== 0) view.animate({
                rotation: 0,
                duration: this.duration_,
                easing: (0, $c7ccf7e681a9b333$export$57636bb43b1ccbb0)
            });
            else view.setRotation(0);
        }
    }
    /**
   * Update the rotate control element.
   * @param {import("../MapEvent.js").default} mapEvent Map event.
   * @override
   */ render(mapEvent) {
        const frameState = mapEvent.frameState;
        if (!frameState) return;
        const rotation = frameState.viewState.rotation;
        if (rotation != this.rotation_) {
            const transform = 'rotate(' + rotation + 'rad)';
            if (this.autoHide_) {
                const contains = this.element.classList.contains((0, $ce07df6d5d4656f1$export$981241db82723ce2));
                if (!contains && rotation === 0) this.element.classList.add((0, $ce07df6d5d4656f1$export$981241db82723ce2));
                else if (contains && rotation !== 0) this.element.classList.remove((0, $ce07df6d5d4656f1$export$981241db82723ce2));
            }
            this.label_.style.transform = transform;
        }
        this.rotation_ = rotation;
    }
}
var $a305cff1f91b3b86$export$2e2bcd8739ae039 = $a305cff1f91b3b86$var$Rotate;


/**
 * @module ol/control/Zoom
 */ 



/**
 * @typedef {Object} Options
 * @property {number} [duration=250] Animation duration in milliseconds.
 * @property {string} [className='ol-zoom'] CSS class name.
 * @property {string} [zoomInClassName=className + '-in'] CSS class name for the zoom-in button.
 * @property {string} [zoomOutClassName=className + '-out'] CSS class name for the zoom-out button.
 * @property {string|HTMLElement} [zoomInLabel='+'] Text label to use for the zoom-in
 * button. Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string|HTMLElement} [zoomOutLabel='–'] Text label to use for the zoom-out button.
 * Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string} [zoomInTipLabel='Zoom in'] Text label to use for the button tip.
 * @property {string} [zoomOutTipLabel='Zoom out'] Text label to use for the button tip.
 * @property {number} [delta=1] The zoom delta applied on each click.
 * @property {HTMLElement|string} [target] Specify a target if you want the control to be
 * rendered outside of the map's viewport.
 */ /**
 * @classdesc
 * A control with 2 buttons, one for zoom in and one for zoom out.
 * This control is one of the default controls of a map. To style this control
 * use css selectors `.ol-zoom-in` and `.ol-zoom-out`.
 *
 * @api
 */ class $4901e3e27e30416a$var$Zoom extends (0, $b978dafe8f7d27ff$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Zoom options.
   */ constructor(options){
        options = options ? options : {};
        super({
            element: document.createElement('div'),
            target: options.target
        });
        const className = options.className !== undefined ? options.className : 'ol-zoom';
        const delta = options.delta !== undefined ? options.delta : 1;
        const zoomInClassName = options.zoomInClassName !== undefined ? options.zoomInClassName : className + '-in';
        const zoomOutClassName = options.zoomOutClassName !== undefined ? options.zoomOutClassName : className + '-out';
        const zoomInLabel = options.zoomInLabel !== undefined ? options.zoomInLabel : '+';
        const zoomOutLabel = options.zoomOutLabel !== undefined ? options.zoomOutLabel : '\u2013';
        const zoomInTipLabel = options.zoomInTipLabel !== undefined ? options.zoomInTipLabel : 'Zoom in';
        const zoomOutTipLabel = options.zoomOutTipLabel !== undefined ? options.zoomOutTipLabel : 'Zoom out';
        const inElement = document.createElement('button');
        inElement.className = zoomInClassName;
        inElement.setAttribute('type', 'button');
        inElement.title = zoomInTipLabel;
        inElement.appendChild(typeof zoomInLabel === 'string' ? document.createTextNode(zoomInLabel) : zoomInLabel);
        inElement.addEventListener((0, $294047c5e65f31a3$export$2e2bcd8739ae039).CLICK, this.handleClick_.bind(this, delta), false);
        const outElement = document.createElement('button');
        outElement.className = zoomOutClassName;
        outElement.setAttribute('type', 'button');
        outElement.title = zoomOutTipLabel;
        outElement.appendChild(typeof zoomOutLabel === 'string' ? document.createTextNode(zoomOutLabel) : zoomOutLabel);
        outElement.addEventListener((0, $294047c5e65f31a3$export$2e2bcd8739ae039).CLICK, this.handleClick_.bind(this, -delta), false);
        const cssClasses = className + ' ' + (0, $ce07df6d5d4656f1$export$1afde3d6e16a7b29) + ' ' + (0, $ce07df6d5d4656f1$export$4d4f8be70b656192);
        const element = this.element;
        element.className = cssClasses;
        element.appendChild(inElement);
        element.appendChild(outElement);
        /**
     * @type {number}
     * @private
     */ this.duration_ = options.duration !== undefined ? options.duration : 250;
    }
    /**
   * @param {number} delta Zoom delta.
   * @param {MouseEvent} event The event to handle
   * @private
   */ handleClick_(delta, event) {
        event.preventDefault();
        this.zoomByDelta_(delta);
    }
    /**
   * @param {number} delta Zoom delta.
   * @private
   */ zoomByDelta_(delta) {
        const map = this.getMap();
        const view = map.getView();
        if (!view) // the map does not have a view, so we can't act
        // upon it
        return;
        const currentZoom = view.getZoom();
        if (currentZoom !== undefined) {
            const newZoom = view.getConstrainedZoom(currentZoom + delta);
            if (this.duration_ > 0) {
                if (view.getAnimating()) view.cancelAnimations();
                view.animate({
                    zoom: newZoom,
                    duration: this.duration_,
                    easing: (0, $c7ccf7e681a9b333$export$57636bb43b1ccbb0)
                });
            } else view.setZoom(newZoom);
        }
    }
}
var $4901e3e27e30416a$export$2e2bcd8739ae039 = $4901e3e27e30416a$var$Zoom;


function $af7495b2f822d5e9$export$ebe90cb607ad99e(options) {
    options = options ? options : {};
    /** @type {Collection<import("./Control.js").default>} */ const controls = new (0, $931ffc4e747c14db$export$2e2bcd8739ae039)();
    const zoomControl = options.zoom !== undefined ? options.zoom : true;
    if (zoomControl) controls.push(new (0, $4901e3e27e30416a$export$2e2bcd8739ae039)(options.zoomOptions));
    const rotateControl = options.rotate !== undefined ? options.rotate : true;
    if (rotateControl) controls.push(new (0, $a305cff1f91b3b86$export$2e2bcd8739ae039)(options.rotateOptions));
    const attributionControl = options.attribution !== undefined ? options.attribution : true;
    if (attributionControl) controls.push(new (0, $6a26ab11104d2c24$export$2e2bcd8739ae039)(options.attributionOptions));
    return controls;
}







/**
 * @module ol/interaction/defaults
 */ 
/**
 * @module ol/Kinetic
 */ /**
 * @classdesc
 * Implementation of inertial deceleration for map movement.
 *
 * @api
 */ class $9a54ea8d5f7a49ee$var$Kinetic {
    /**
   * @param {number} decay Rate of decay (must be negative).
   * @param {number} minVelocity Minimum velocity (pixels/millisecond).
   * @param {number} delay Delay to consider to calculate the kinetic
   *     initial values (milliseconds).
   */ constructor(decay, minVelocity, delay){
        /**
     * @private
     * @type {number}
     */ this.decay_ = decay;
        /**
     * @private
     * @type {number}
     */ this.minVelocity_ = minVelocity;
        /**
     * @private
     * @type {number}
     */ this.delay_ = delay;
        /**
     * @private
     * @type {Array<number>}
     */ this.points_ = [];
        /**
     * @private
     * @type {number}
     */ this.angle_ = 0;
        /**
     * @private
     * @type {number}
     */ this.initialVelocity_ = 0;
    }
    /**
   * FIXME empty description for jsdoc
   */ begin() {
        this.points_.length = 0;
        this.angle_ = 0;
        this.initialVelocity_ = 0;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   */ update(x, y) {
        this.points_.push(x, y, Date.now());
    }
    /**
   * @return {boolean} Whether we should do kinetic animation.
   */ end() {
        if (this.points_.length < 6) // at least 2 points are required (i.e. there must be at least 6 elements
        // in the array)
        return false;
        const delay = Date.now() - this.delay_;
        const lastIndex = this.points_.length - 3;
        if (this.points_[lastIndex + 2] < delay) // the last tracked point is too old, which means that the user stopped
        // panning before releasing the map
        return false;
        // get the first point which still falls into the delay time
        let firstIndex = lastIndex - 3;
        while(firstIndex > 0 && this.points_[firstIndex + 2] > delay)firstIndex -= 3;
        const duration = this.points_[lastIndex + 2] - this.points_[firstIndex + 2];
        // we don't want a duration of 0 (divide by zero)
        // we also make sure the user panned for a duration of at least one frame
        // (1/60s) to compute sane displacement values
        if (duration < 1000 / 60) return false;
        const dx = this.points_[lastIndex] - this.points_[firstIndex];
        const dy = this.points_[lastIndex + 1] - this.points_[firstIndex + 1];
        this.angle_ = Math.atan2(dy, dx);
        this.initialVelocity_ = Math.sqrt(dx * dx + dy * dy) / duration;
        return this.initialVelocity_ > this.minVelocity_;
    }
    /**
   * @return {number} Total distance travelled (pixels).
   */ getDistance() {
        return (this.minVelocity_ - this.initialVelocity_) / this.decay_;
    }
    /**
   * @return {number} Angle of the kinetic panning animation (radians).
   */ getAngle() {
        return this.angle_;
    }
}
var $9a54ea8d5f7a49ee$export$2e2bcd8739ae039 = $9a54ea8d5f7a49ee$var$Kinetic;


/**
 * @module ol/interaction/DoubleClickZoom
 */ 
/**
 * @module ol/interaction/Interaction
 */ 

/**
 * @module ol/interaction/Property
 */ /**
 * @enum {string}
 */ var $2c9e42723ccf2bfb$export$2e2bcd8739ae039 = {
    ACTIVE: 'active'
};


/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types|
 *     'change:active', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types|
 *     'change:active', Return>} InteractionOnSignature
 */ /**
 * Object literal with config options for interactions.
 * @typedef {Object} InteractionOptions
 * @property {function(import("../MapBrowserEvent.js").default):boolean} [handleEvent]
 * Method called by the map to notify the interaction that a browser event was
 * dispatched to the map. If the function returns a falsy value, propagation of
 * the event to other interactions in the map's interactions chain will be
 * prevented (this includes functions with no explicit return). The interactions
 * are traversed in reverse order of the interactions collection of the map.
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * User actions that change the state of the map. Some are similar to controls,
 * but are not associated with a DOM element.
 * For example, {@link module:ol/interaction/KeyboardZoom~KeyboardZoom} is
 * functionally the same as {@link module:ol/control/Zoom~Zoom}, but triggered
 * by a keyboard event not a button element event.
 * Although interactions do not have a DOM element, some of them do render
 * vectors and so are visible on the screen.
 * @api
 */ class $39210df8527e63e5$var$Interaction extends (0, $b68b3d6e32e3074a$export$2e2bcd8739ae039) {
    /**
   * @param {InteractionOptions} [options] Options.
   */ constructor(options){
        super();
        /***
     * @type {InteractionOnSignature<import("../events").EventsKey>}
     */ this.on;
        /***
     * @type {InteractionOnSignature<import("../events").EventsKey>}
     */ this.once;
        /***
     * @type {InteractionOnSignature<void>}
     */ this.un;
        if (options && options.handleEvent) this.handleEvent = options.handleEvent;
        /**
     * @private
     * @type {import("../Map.js").default|null}
     */ this.map_ = null;
        this.setActive(true);
    }
    /**
   * Return whether the interaction is currently active.
   * @return {boolean} `true` if the interaction is active, `false` otherwise.
   * @observable
   * @api
   */ getActive() {
        return /** @type {boolean} */ this.get((0, $2c9e42723ccf2bfb$export$2e2bcd8739ae039).ACTIVE);
    }
    /**
   * Get the map associated with this interaction.
   * @return {import("../Map.js").default|null} Map.
   * @api
   */ getMap() {
        return this.map_;
    }
    /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event}.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   * @api
   */ handleEvent(mapBrowserEvent) {
        return true;
    }
    /**
   * Activate or deactivate the interaction.
   * @param {boolean} active Active.
   * @observable
   * @api
   */ setActive(active) {
        this.set((0, $2c9e42723ccf2bfb$export$2e2bcd8739ae039).ACTIVE, active);
    }
    /**
   * Remove the interaction from its current map and attach it to the new map.
   * Subclasses may set up event handlers to get notified about changes to
   * the map here.
   * @param {import("../Map.js").default|null} map Map.
   */ setMap(map) {
        this.map_ = map;
    }
}
function $39210df8527e63e5$export$4c486572e961a974(view, delta, duration) {
    const currentCenter = view.getCenterInternal();
    if (currentCenter) {
        const center = [
            currentCenter[0] + delta[0],
            currentCenter[1] + delta[1]
        ];
        view.animateInternal({
            duration: duration !== undefined ? duration : 250,
            easing: (0, $c7ccf7e681a9b333$export$45db2fc2f15997e7),
            center: view.getConstrainedCenter(center)
        });
    }
}
function $39210df8527e63e5$export$ace321ff2a8016ef(view, delta, anchor, duration) {
    const currentZoom = view.getZoom();
    if (currentZoom === undefined) return;
    const newZoom = view.getConstrainedZoom(currentZoom + delta);
    const newResolution = view.getResolutionForZoom(newZoom);
    if (view.getAnimating()) view.cancelAnimations();
    view.animate({
        resolution: newResolution,
        anchor: anchor,
        duration: duration !== undefined ? duration : 250,
        easing: (0, $c7ccf7e681a9b333$export$57636bb43b1ccbb0)
    });
}
var $39210df8527e63e5$export$2e2bcd8739ae039 = $39210df8527e63e5$var$Interaction;


/**
 * @typedef {Object} Options
 * @property {number} [duration=250] Animation duration in milliseconds.
 * @property {number} [delta=1] The zoom delta applied on each double click.
 */ /**
 * @classdesc
 * Allows the user to zoom by double-clicking on the map.
 * @api
 */ class $b50403621294a654$var$DoubleClickZoom extends (0, $39210df8527e63e5$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        super();
        options = options ? options : {};
        /**
     * @private
     * @type {number}
     */ this.delta_ = options.delta ? options.delta : 1;
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 250;
    }
    /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} (if it was a
   * doubleclick) and eventually zooms the map.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   * @override
   */ handleEvent(mapBrowserEvent) {
        let stopEvent = false;
        if (mapBrowserEvent.type == (0, $150f412a4a7fa263$export$2e2bcd8739ae039).DBLCLICK) {
            const browserEvent = /** @type {MouseEvent} */ mapBrowserEvent.originalEvent;
            const map = mapBrowserEvent.map;
            const anchor = mapBrowserEvent.coordinate;
            const delta = browserEvent.shiftKey ? -this.delta_ : this.delta_;
            const view = map.getView();
            (0, $39210df8527e63e5$export$ace321ff2a8016ef)(view, delta, anchor, this.duration_);
            browserEvent.preventDefault();
            stopEvent = true;
        }
        return !stopEvent;
    }
}
var $b50403621294a654$export$2e2bcd8739ae039 = $b50403621294a654$var$DoubleClickZoom;


/**
 * @module ol/interaction/DragPan
 */ 

/**
 * @module ol/events/condition
 */ 


function $edf87b50170125f7$export$84bf76cd7afc7469(var_args) {
    const conditions = arguments;
    /**
   * @param {import("../MapBrowserEvent.js").default} event Event.
   * @return {boolean} All conditions passed.
   */ return function(event) {
        let pass = true;
        for(let i = 0, ii = conditions.length; i < ii; ++i){
            pass = pass && conditions[i](event);
            if (!pass) break;
        }
        return pass;
    };
}
const $edf87b50170125f7$export$573409992e89967e = function(mapBrowserEvent) {
    const originalEvent = mapBrowserEvent.originalEvent;
    return originalEvent.altKey && !(originalEvent.metaKey || originalEvent.ctrlKey) && !originalEvent.shiftKey;
};
const $edf87b50170125f7$export$4e5f01653f9f1f82 = function(mapBrowserEvent) {
    const originalEvent = mapBrowserEvent.originalEvent;
    return originalEvent.altKey && !(originalEvent.metaKey || originalEvent.ctrlKey) && originalEvent.shiftKey;
};
const $edf87b50170125f7$export$d7ddd398f22d79ef = function(event) {
    const targetElement = event.map.getTargetElement();
    const rootNode = targetElement.getRootNode();
    const activeElement = event.map.getOwnerDocument().activeElement;
    return rootNode instanceof ShadowRoot ? rootNode.host.contains(activeElement) : targetElement.contains(activeElement);
};
const $edf87b50170125f7$export$ae2cdf064e3b0c55 = function(event) {
    const targetElement = event.map.getTargetElement();
    const rootNode = targetElement.getRootNode();
    const tabIndexCandidate = rootNode instanceof ShadowRoot ? rootNode.host : targetElement;
    return tabIndexCandidate.hasAttribute('tabindex') ? $edf87b50170125f7$export$d7ddd398f22d79ef(event) : true;
};
const $edf87b50170125f7$export$ba9e5d519bc326ca = (0, $013a1733c226ec50$export$22e23a2304399231);
const $edf87b50170125f7$export$64ef1bee2b9504c1 = function(mapBrowserEvent) {
    return mapBrowserEvent.type == (0, $150f412a4a7fa263$export$2e2bcd8739ae039).CLICK;
};
const $edf87b50170125f7$export$1238ad6b5e7fff70 = function(mapBrowserEvent) {
    const originalEvent = mapBrowserEvent.originalEvent;
    return 'pointerId' in originalEvent && originalEvent.button == 0 && !((0, $67c66761d21428d0$export$39dfd62a25e0fe93) && (0, $67c66761d21428d0$export$76c0a3b101d93136) && originalEvent.ctrlKey);
};
const $edf87b50170125f7$export$b3e22bcfd64c1022 = (0, $013a1733c226ec50$export$8f11cee4bdc7e668);
const $edf87b50170125f7$export$71eac0963f2c2f01 = function(mapBrowserEvent) {
    return mapBrowserEvent.type == 'pointermove';
};
const $edf87b50170125f7$export$194df8bad091b401 = function(mapBrowserEvent) {
    return mapBrowserEvent.type == (0, $150f412a4a7fa263$export$2e2bcd8739ae039).SINGLECLICK;
};
const $edf87b50170125f7$export$c59d944dd10b3dc7 = function(mapBrowserEvent) {
    return mapBrowserEvent.type == (0, $150f412a4a7fa263$export$2e2bcd8739ae039).DBLCLICK;
};
const $edf87b50170125f7$export$fdc892d0d8fe3bfb = function(mapBrowserEvent) {
    const originalEvent = /** @type {KeyboardEvent|MouseEvent|TouchEvent} */ mapBrowserEvent.originalEvent;
    return !originalEvent.altKey && !(originalEvent.metaKey || originalEvent.ctrlKey) && !originalEvent.shiftKey;
};
const $edf87b50170125f7$export$f3100d8d6292d638 = function(mapBrowserEvent) {
    const originalEvent = mapBrowserEvent.originalEvent;
    return !originalEvent.altKey && ((0, $67c66761d21428d0$export$76c0a3b101d93136) ? originalEvent.metaKey : originalEvent.ctrlKey) && !originalEvent.shiftKey;
};
const $edf87b50170125f7$export$32603ad571dd22b5 = function(mapBrowserEvent) {
    const originalEvent = mapBrowserEvent.originalEvent;
    return (0, $67c66761d21428d0$export$76c0a3b101d93136) ? originalEvent.metaKey : originalEvent.ctrlKey;
};
const $edf87b50170125f7$export$5d31fe68a477cfbb = function(mapBrowserEvent) {
    const originalEvent = mapBrowserEvent.originalEvent;
    return !originalEvent.altKey && !(originalEvent.metaKey || originalEvent.ctrlKey) && originalEvent.shiftKey;
};
const $edf87b50170125f7$export$e5570ca80cd8fd54 = function(mapBrowserEvent) {
    const originalEvent = mapBrowserEvent.originalEvent;
    const tagName = /** @type {Element} */ originalEvent.target.tagName;
    return tagName !== 'INPUT' && tagName !== 'SELECT' && tagName !== 'TEXTAREA' && // `isContentEditable` is only available on `HTMLElement`, but it may also be a
    // different type like `SVGElement`.
    // @ts-ignore
    !originalEvent.target.isContentEditable;
};
const $edf87b50170125f7$export$abb7acbfa76bf3c4 = function(mapBrowserEvent) {
    const pointerEvent = mapBrowserEvent.originalEvent;
    // see https://www.w3.org/TR/pointerevents/#widl-PointerEvent-pointerType
    return 'pointerId' in pointerEvent && pointerEvent.pointerType == 'mouse';
};
const $edf87b50170125f7$export$e74de664a571d084 = function(mapBrowserEvent) {
    const pointerEvt = mapBrowserEvent.originalEvent;
    // see https://www.w3.org/TR/pointerevents/#widl-PointerEvent-pointerType
    return 'pointerId' in pointerEvt && pointerEvt.pointerType === 'touch';
};
const $edf87b50170125f7$export$cd1707283a23f059 = function(mapBrowserEvent) {
    const pointerEvt = mapBrowserEvent.originalEvent;
    // see https://www.w3.org/TR/pointerevents/#widl-PointerEvent-pointerType
    return 'pointerId' in pointerEvt && pointerEvt.pointerType === 'pen';
};
const $edf87b50170125f7$export$189f0d593022b199 = function(mapBrowserEvent) {
    const pointerEvent = mapBrowserEvent.originalEvent;
    return 'pointerId' in pointerEvent && pointerEvent.isPrimary && pointerEvent.button === 0;
};



/**
 * @module ol/interaction/Pointer
 */ 

/**
 * @typedef {Object} Options
 * @property {function(import("../MapBrowserEvent.js").default):boolean} [handleDownEvent]
 * Function handling "down" events. If the function returns `true` then a drag
 * sequence is started.
 * @property {function(import("../MapBrowserEvent.js").default):void} [handleDragEvent]
 * Function handling "drag" events. This function is called on "move" events
 * during a drag sequence.
 * @property {function(import("../MapBrowserEvent.js").default):boolean} [handleEvent]
 * Method called by the map to notify the interaction that a browser event was
 * dispatched to the map. The function may return `false` to prevent the
 * propagation of the event to other interactions in the map's interactions
 * chain.
 * @property {function(import("../MapBrowserEvent.js").default):void} [handleMoveEvent]
 * Function handling "move" events. This function is called on "move" events.
 * This functions is also called during a drag sequence, so during a drag
 * sequence both the `handleDragEvent` function and this function are called.
 * If `handleDownEvent` is defined and it returns true this function will not
 * be called during a drag sequence.
 * @property {function(import("../MapBrowserEvent.js").default):boolean} [handleUpEvent]
 *  Function handling "up" events. If the function returns `false` then the
 * current drag sequence is stopped.
 * @property {function(boolean):boolean} [stopDown]
 * Should the down event be propagated to other interactions, or should be
 * stopped?
 */ /**
 * @classdesc
 * Base class that calls user-defined functions on `down`, `move` and `up`
 * events. This class also manages "drag sequences".
 *
 * When the `handleDownEvent` user function returns `true` a drag sequence is
 * started. During a drag sequence the `handleDragEvent` user function is
 * called on `move` events. The drag sequence ends when the `handleUpEvent`
 * user function is called and returns `false`.
 * @api
 */ class $cf1eb502962d87a8$var$PointerInteraction extends (0, $39210df8527e63e5$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        super(/** @type {import("./Interaction.js").InteractionOptions} */ options);
        if (options.handleDownEvent) this.handleDownEvent = options.handleDownEvent;
        if (options.handleDragEvent) this.handleDragEvent = options.handleDragEvent;
        if (options.handleMoveEvent) this.handleMoveEvent = options.handleMoveEvent;
        if (options.handleUpEvent) this.handleUpEvent = options.handleUpEvent;
        if (options.stopDown) this.stopDown = options.stopDown;
        /**
     * @type {boolean}
     * @protected
     */ this.handlingDownUpSequence = false;
        /**
     * @type {Array<PointerEvent>}
     * @protected
     */ this.targetPointers = [];
    }
    /**
   * Returns the current number of pointers involved in the interaction,
   * e.g. `2` when two fingers are used.
   * @return {number} The number of pointers.
   * @api
   */ getPointerCount() {
        return this.targetPointers.length;
    }
    /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @protected
   */ handleDownEvent(mapBrowserEvent) {
        return false;
    }
    /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @protected
   */ handleDragEvent(mapBrowserEvent) {}
    /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} and may call into
   * other functions, if event sequences like e.g. 'drag' or 'down-up' etc. are
   * detected.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   * @api
   * @override
   */ handleEvent(mapBrowserEvent) {
        if (!mapBrowserEvent.originalEvent) return true;
        let stopEvent = false;
        this.updateTrackedPointers_(mapBrowserEvent);
        if (this.handlingDownUpSequence) {
            if (mapBrowserEvent.type == (0, $150f412a4a7fa263$export$2e2bcd8739ae039).POINTERDRAG) {
                this.handleDragEvent(mapBrowserEvent);
                // prevent page scrolling during dragging
                mapBrowserEvent.originalEvent.preventDefault();
            } else if (mapBrowserEvent.type == (0, $150f412a4a7fa263$export$2e2bcd8739ae039).POINTERUP) {
                const handledUp = this.handleUpEvent(mapBrowserEvent);
                this.handlingDownUpSequence = handledUp && this.targetPointers.length > 0;
            }
        } else {
            if (mapBrowserEvent.type == (0, $150f412a4a7fa263$export$2e2bcd8739ae039).POINTERDOWN) {
                const handled = this.handleDownEvent(mapBrowserEvent);
                this.handlingDownUpSequence = handled;
                stopEvent = this.stopDown(handled);
            } else if (mapBrowserEvent.type == (0, $150f412a4a7fa263$export$2e2bcd8739ae039).POINTERMOVE) this.handleMoveEvent(mapBrowserEvent);
        }
        return !stopEvent;
    }
    /**
   * Handle pointer move events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @protected
   */ handleMoveEvent(mapBrowserEvent) {}
    /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @protected
   */ handleUpEvent(mapBrowserEvent) {
        return false;
    }
    /**
   * This function is used to determine if "down" events should be propagated
   * to other interactions or should be stopped.
   * @param {boolean} handled Was the event handled by the interaction?
   * @return {boolean} Should the `down` event be stopped?
   */ stopDown(handled) {
        return handled;
    }
    /**
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @private
   */ updateTrackedPointers_(mapBrowserEvent) {
        if (mapBrowserEvent.activePointers) this.targetPointers = mapBrowserEvent.activePointers;
    }
}
function $cf1eb502962d87a8$export$e2a20c553f6c85ce(pointerEvents) {
    const length = pointerEvents.length;
    let clientX = 0;
    let clientY = 0;
    for(let i = 0; i < length; i++){
        clientX += pointerEvents[i].clientX;
        clientY += pointerEvents[i].clientY;
    }
    return {
        clientX: clientX / length,
        clientY: clientY / length
    };
}
var $cf1eb502962d87a8$export$2e2bcd8739ae039 = $cf1eb502962d87a8$var$PointerInteraction;


/**
 * @typedef {Object} Options
 * @property {import("../events/condition.js").Condition} [condition] A function that takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a boolean
 * to indicate whether that event should be handled.
 * Default is {@link module:ol/events/condition.noModifierKeys} and {@link module:ol/events/condition.primaryAction}.
 * @property {boolean} [onFocusOnly=false] When the map's target has a `tabindex` attribute set,
 * the interaction will only handle events when the map has the focus.
 * @property {import("../Kinetic.js").default} [kinetic] Kinetic inertia to apply to the pan.
 */ /**
 * @classdesc
 * Allows the user to pan the map by dragging the map.
 * @api
 */ class $c11585da26a016db$var$DragPan extends (0, $cf1eb502962d87a8$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        super({
            stopDown: (0, $013a1733c226ec50$export$8f11cee4bdc7e668)
        });
        options = options ? options : {};
        /**
     * @private
     * @type {import("../Kinetic.js").default|undefined}
     */ this.kinetic_ = options.kinetic;
        /**
     * @type {import("../pixel.js").Pixel}
     */ this.lastCentroid = null;
        /**
     * @type {number}
     * @private
     */ this.lastPointersCount_;
        /**
     * @type {boolean}
     * @private
     */ this.panning_ = false;
        const condition = options.condition ? options.condition : (0, $edf87b50170125f7$export$84bf76cd7afc7469)((0, $edf87b50170125f7$export$fdc892d0d8fe3bfb), (0, $edf87b50170125f7$export$189f0d593022b199));
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.condition_ = options.onFocusOnly ? (0, $edf87b50170125f7$export$84bf76cd7afc7469)((0, $edf87b50170125f7$export$ae2cdf064e3b0c55), condition) : condition;
        /**
     * @private
     * @type {boolean}
     */ this.noKinetic_ = false;
    }
    /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @override
   */ handleDragEvent(mapBrowserEvent) {
        const map = mapBrowserEvent.map;
        if (!this.panning_) {
            this.panning_ = true;
            map.getView().beginInteraction();
        }
        const targetPointers = this.targetPointers;
        const centroid = map.getEventPixel((0, $cf1eb502962d87a8$export$e2a20c553f6c85ce)(targetPointers));
        if (targetPointers.length == this.lastPointersCount_) {
            if (this.kinetic_) this.kinetic_.update(centroid[0], centroid[1]);
            if (this.lastCentroid) {
                const delta = [
                    this.lastCentroid[0] - centroid[0],
                    centroid[1] - this.lastCentroid[1]
                ];
                const map = mapBrowserEvent.map;
                const view = map.getView();
                (0, $1bd0a226f9a16141$export$dcdf75081b88279d)(delta, view.getResolution());
                (0, $1bd0a226f9a16141$export$bb628a54ab399bc9)(delta, view.getRotation());
                view.adjustCenterInternal(delta);
            }
        } else if (this.kinetic_) // reset so we don't overestimate the kinetic energy after
        // after one finger down, tiny drag, second finger down
        this.kinetic_.begin();
        this.lastCentroid = centroid;
        this.lastPointersCount_ = targetPointers.length;
        mapBrowserEvent.originalEvent.preventDefault();
    }
    /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleUpEvent(mapBrowserEvent) {
        const map = mapBrowserEvent.map;
        const view = map.getView();
        if (this.targetPointers.length === 0) {
            if (!this.noKinetic_ && this.kinetic_ && this.kinetic_.end()) {
                const distance = this.kinetic_.getDistance();
                const angle = this.kinetic_.getAngle();
                const center = view.getCenterInternal();
                const centerpx = map.getPixelFromCoordinateInternal(center);
                const dest = map.getCoordinateFromPixelInternal([
                    centerpx[0] - distance * Math.cos(angle),
                    centerpx[1] - distance * Math.sin(angle)
                ]);
                view.animateInternal({
                    center: view.getConstrainedCenter(dest),
                    duration: 500,
                    easing: (0, $c7ccf7e681a9b333$export$57636bb43b1ccbb0)
                });
            }
            if (this.panning_) {
                this.panning_ = false;
                view.endInteraction();
            }
            return false;
        }
        if (this.kinetic_) // reset so we don't overestimate the kinetic energy after
        // after one finger up, tiny drag, second finger up
        this.kinetic_.begin();
        this.lastCentroid = null;
        return true;
    }
    /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleDownEvent(mapBrowserEvent) {
        if (this.targetPointers.length > 0 && this.condition_(mapBrowserEvent)) {
            const map = mapBrowserEvent.map;
            const view = map.getView();
            this.lastCentroid = null;
            // stop any current animation
            if (view.getAnimating()) view.cancelAnimations();
            if (this.kinetic_) this.kinetic_.begin();
            // No kinetic as soon as more than one pointer on the screen is
            // detected. This is to prevent nasty pans after pinch.
            this.noKinetic_ = this.targetPointers.length > 1;
            return true;
        }
        return false;
    }
}
var $c11585da26a016db$export$2e2bcd8739ae039 = $c11585da26a016db$var$DragPan;


/**
 * @module ol/interaction/DragRotate
 */ 



/**
 * @typedef {Object} Options
 * @property {import("../events/condition.js").Condition} [condition] A function that takes a
 * {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a boolean
 * to indicate whether that event should be handled.
 * Default is {@link module:ol/events/condition.altShiftKeysOnly}.
 * @property {number} [duration=250] Animation duration in milliseconds.
 */ /**
 * @classdesc
 * Allows the user to rotate the map by clicking and dragging on the map,
 * normally combined with a {@link module:ol/events/condition} that limits
 * it to when the alt and shift keys are held down.
 *
 * This interaction is only supported for mouse devices.
 * @api
 */ class $197c7092261b2aa0$var$DragRotate extends (0, $cf1eb502962d87a8$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        super({
            stopDown: (0, $013a1733c226ec50$export$8f11cee4bdc7e668)
        });
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.condition_ = options.condition ? options.condition : (0, $edf87b50170125f7$export$4e5f01653f9f1f82);
        /**
     * @private
     * @type {number|undefined}
     */ this.lastAngle_ = undefined;
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 250;
    }
    /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @override
   */ handleDragEvent(mapBrowserEvent) {
        if (!(0, $edf87b50170125f7$export$abb7acbfa76bf3c4)(mapBrowserEvent)) return;
        const map = mapBrowserEvent.map;
        const view = map.getView();
        if (view.getConstraints().rotation === (0, $d65f0a322291d127$export$e20fbacbb41798b)) return;
        const size = map.getSize();
        const offset = mapBrowserEvent.pixel;
        const theta = Math.atan2(size[1] / 2 - offset[1], offset[0] - size[0] / 2);
        if (this.lastAngle_ !== undefined) {
            const delta = theta - this.lastAngle_;
            view.adjustRotationInternal(-delta);
        }
        this.lastAngle_ = theta;
    }
    /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleUpEvent(mapBrowserEvent) {
        if (!(0, $edf87b50170125f7$export$abb7acbfa76bf3c4)(mapBrowserEvent)) return true;
        const map = mapBrowserEvent.map;
        const view = map.getView();
        view.endInteraction(this.duration_);
        return false;
    }
    /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleDownEvent(mapBrowserEvent) {
        if (!(0, $edf87b50170125f7$export$abb7acbfa76bf3c4)(mapBrowserEvent)) return false;
        if ((0, $edf87b50170125f7$export$1238ad6b5e7fff70)(mapBrowserEvent) && this.condition_(mapBrowserEvent)) {
            const map = mapBrowserEvent.map;
            map.getView().beginInteraction();
            this.lastAngle_ = undefined;
            return true;
        }
        return false;
    }
}
var $197c7092261b2aa0$export$2e2bcd8739ae039 = $197c7092261b2aa0$var$DragRotate;


/**
 * @module ol/interaction/DragZoom
 */ 

/**
 * @module ol/interaction/DragBox
 */ // FIXME draw drag box


/**
 * @module ol/render/Box
 */ 

class $c47adf75308683a6$var$RenderBox extends (0, $3273ed08087da3da$export$2e2bcd8739ae039) {
    /**
   * @param {string} className CSS class name.
   */ constructor(className){
        super();
        /**
     * @type {import("../geom/Polygon.js").default}
     * @private
     */ this.geometry_ = null;
        /**
     * @type {HTMLDivElement}
     * @private
     */ this.element_ = document.createElement('div');
        this.element_.style.position = 'absolute';
        this.element_.style.pointerEvents = 'auto';
        this.element_.className = 'ol-box ' + className;
        /**
     * @private
     * @type {import("../Map.js").default|null}
     */ this.map_ = null;
        /**
     * @private
     * @type {import("../pixel.js").Pixel}
     */ this.startPixel_ = null;
        /**
     * @private
     * @type {import("../pixel.js").Pixel}
     */ this.endPixel_ = null;
    }
    /**
   * Clean up.
   * @override
   */ disposeInternal() {
        this.setMap(null);
    }
    /**
   * @private
   */ render_() {
        const startPixel = this.startPixel_;
        const endPixel = this.endPixel_;
        const px = 'px';
        const style = this.element_.style;
        style.left = Math.min(startPixel[0], endPixel[0]) + px;
        style.top = Math.min(startPixel[1], endPixel[1]) + px;
        style.width = Math.abs(endPixel[0] - startPixel[0]) + px;
        style.height = Math.abs(endPixel[1] - startPixel[1]) + px;
    }
    /**
   * @param {import("../Map.js").default|null} map Map.
   */ setMap(map) {
        if (this.map_) {
            this.map_.getOverlayContainer().removeChild(this.element_);
            const style = this.element_.style;
            style.left = 'inherit';
            style.top = 'inherit';
            style.width = 'inherit';
            style.height = 'inherit';
        }
        this.map_ = map;
        if (this.map_) this.map_.getOverlayContainer().appendChild(this.element_);
    }
    /**
   * @param {import("../pixel.js").Pixel} startPixel Start pixel.
   * @param {import("../pixel.js").Pixel} endPixel End pixel.
   */ setPixels(startPixel, endPixel) {
        this.startPixel_ = startPixel;
        this.endPixel_ = endPixel;
        this.createOrUpdateGeometry();
        this.render_();
    }
    /**
   * Creates or updates the cached geometry.
   */ createOrUpdateGeometry() {
        if (!this.map_) return;
        const startPixel = this.startPixel_;
        const endPixel = this.endPixel_;
        const pixels = [
            startPixel,
            [
                startPixel[0],
                endPixel[1]
            ],
            endPixel,
            [
                endPixel[0],
                startPixel[1]
            ]
        ];
        const coordinates = pixels.map(this.map_.getCoordinateFromPixelInternal, this.map_);
        // close the polygon
        coordinates[4] = coordinates[0].slice();
        if (!this.geometry_) this.geometry_ = new (0, $40aa8d43bbe572bf$export$2e2bcd8739ae039)([
            coordinates
        ]);
        else this.geometry_.setCoordinates([
            coordinates
        ]);
    }
    /**
   * @return {import("../geom/Polygon.js").default} Geometry.
   */ getGeometry() {
        return this.geometry_;
    }
}
var $c47adf75308683a6$export$2e2bcd8739ae039 = $c47adf75308683a6$var$RenderBox;



/**
 * A function that takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and two
 * {@link module:ol/pixel~Pixel}s and returns a `{boolean}`. If the condition is met,
 * true should be returned.
 * @typedef {function(this: ?, import("../MapBrowserEvent.js").default, import("../pixel.js").Pixel, import("../pixel.js").Pixel):boolean} EndCondition
 */ /**
 * @typedef {Object} Options
 * @property {string} [className='ol-dragbox'] CSS class name for styling the box.
 * @property {import("../events/condition.js").Condition} [condition] A function that takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a boolean
 * to indicate whether that event should be handled.
 * Default is {@link ol/events/condition~mouseActionButton}.
 * @property {number} [minArea=64] The minimum area of the box in pixel, this value is used by the default
 * `boxEndCondition` function.
 * @property {EndCondition} [boxEndCondition] A function that takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and two
 * {@link module:ol/pixel~Pixel}s to indicate whether a `boxend` event should be fired.
 * Default is `true` if the area of the box is bigger than the `minArea` option.
 * @property {function(this:DragBox, import("../MapBrowserEvent.js").default):void} [onBoxEnd] Code to execute just
 * before `boxend` is fired.
 */ /**
 * @enum {string}
 */ const $e05f414bc3918235$var$DragBoxEventType = {
    /**
   * Triggered upon drag box start.
   * @event DragBoxEvent#boxstart
   * @api
   */ BOXSTART: 'boxstart',
    /**
   * Triggered on drag when box is active.
   * @event DragBoxEvent#boxdrag
   * @api
   */ BOXDRAG: 'boxdrag',
    /**
   * Triggered upon drag box end.
   * @event DragBoxEvent#boxend
   * @api
   */ BOXEND: 'boxend',
    /**
   * Triggered upon drag box canceled.
   * @event DragBoxEvent#boxcancel
   * @api
   */ BOXCANCEL: 'boxcancel'
};
class $e05f414bc3918235$export$7053c33c051365ea extends (0, $aeedce20e9577100$export$2e2bcd8739ae039) {
    /**
   * @param {string} type The event type.
   * @param {import("../coordinate.js").Coordinate} coordinate The event coordinate.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Originating event.
   */ constructor(type, coordinate, mapBrowserEvent){
        super(type);
        /**
     * The coordinate of the drag event.
     * @const
     * @type {import("../coordinate.js").Coordinate}
     * @api
     */ this.coordinate = coordinate;
        /**
     * @const
     * @type {import("../MapBrowserEvent.js").default}
     * @api
     */ this.mapBrowserEvent = mapBrowserEvent;
    }
}
/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types|
 *     'change:active', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<'boxcancel'|'boxdrag'|'boxend'|'boxstart', DragBoxEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types|
 *     'change:active'|'boxcancel'|'boxdrag'|'boxend', Return>} DragBoxOnSignature
 */ /**
 * @classdesc
 * Allows the user to draw a vector box by clicking and dragging on the map,
 * normally combined with a {@link module:ol/events/condition} that limits
 * it to when the shift or other key is held down. This is used, for example,
 * for zooming to a specific area of the map
 * (see {@link module:ol/interaction/DragZoom~DragZoom} and
 * {@link module:ol/interaction/DragRotateAndZoom~DragRotateAndZoom}).
 *
 * @fires DragBoxEvent
 * @api
 */ class $e05f414bc3918235$var$DragBox extends (0, $cf1eb502962d87a8$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        super();
        /***
     * @type {DragBoxOnSignature<import("../events").EventsKey>}
     */ this.on;
        /***
     * @type {DragBoxOnSignature<import("../events").EventsKey>}
     */ this.once;
        /***
     * @type {DragBoxOnSignature<void>}
     */ this.un;
        options = options ?? {};
        /**
     * @type {import("../render/Box.js").default}
     * @private
     */ this.box_ = new (0, $c47adf75308683a6$export$2e2bcd8739ae039)(options.className || 'ol-dragbox');
        /**
     * @type {number}
     * @private
     */ this.minArea_ = options.minArea ?? 64;
        if (options.onBoxEnd) this.onBoxEnd = options.onBoxEnd;
        /**
     * @type {import("../pixel.js").Pixel}
     * @private
     */ this.startPixel_ = null;
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.condition_ = options.condition ?? (0, $edf87b50170125f7$export$1238ad6b5e7fff70);
        /**
     * @private
     * @type {EndCondition}
     */ this.boxEndCondition_ = options.boxEndCondition ?? this.defaultBoxEndCondition;
    }
    /**
   * The default condition for determining whether the boxend event
   * should fire.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent The originating MapBrowserEvent
   *     leading to the box end.
   * @param {import("../pixel.js").Pixel} startPixel The starting pixel of the box.
   * @param {import("../pixel.js").Pixel} endPixel The end pixel of the box.
   * @return {boolean} Whether or not the boxend condition should be fired.
   */ defaultBoxEndCondition(mapBrowserEvent, startPixel, endPixel) {
        const width = endPixel[0] - startPixel[0];
        const height = endPixel[1] - startPixel[1];
        return width * width + height * height >= this.minArea_;
    }
    /**
   * Returns geometry of last drawn box.
   * @return {import("../geom/Polygon.js").default} Geometry.
   * @api
   */ getGeometry() {
        return this.box_.getGeometry();
    }
    /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @override
   */ handleDragEvent(mapBrowserEvent) {
        if (!this.startPixel_) return;
        this.box_.setPixels(this.startPixel_, mapBrowserEvent.pixel);
        this.dispatchEvent(new $e05f414bc3918235$export$7053c33c051365ea($e05f414bc3918235$var$DragBoxEventType.BOXDRAG, mapBrowserEvent.coordinate, mapBrowserEvent));
    }
    /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleUpEvent(mapBrowserEvent) {
        if (!this.startPixel_) return false;
        const completeBox = this.boxEndCondition_(mapBrowserEvent, this.startPixel_, mapBrowserEvent.pixel);
        if (completeBox) this.onBoxEnd(mapBrowserEvent);
        this.dispatchEvent(new $e05f414bc3918235$export$7053c33c051365ea(completeBox ? $e05f414bc3918235$var$DragBoxEventType.BOXEND : $e05f414bc3918235$var$DragBoxEventType.BOXCANCEL, mapBrowserEvent.coordinate, mapBrowserEvent));
        this.box_.setMap(null);
        this.startPixel_ = null;
        return false;
    }
    /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleDownEvent(mapBrowserEvent) {
        if (this.condition_(mapBrowserEvent)) {
            this.startPixel_ = mapBrowserEvent.pixel;
            this.box_.setMap(mapBrowserEvent.map);
            this.box_.setPixels(this.startPixel_, this.startPixel_);
            this.dispatchEvent(new $e05f414bc3918235$export$7053c33c051365ea($e05f414bc3918235$var$DragBoxEventType.BOXSTART, mapBrowserEvent.coordinate, mapBrowserEvent));
            return true;
        }
        return false;
    }
    /**
   * Function to execute just before `onboxend` is fired
   * @param {import("../MapBrowserEvent.js").default} event Event.
   */ onBoxEnd(event) {}
    /**
   * Activate or deactivate the interaction.
   * @param {boolean} active Active.
   * @observable
   * @api
   * @override
   */ setActive(active) {
        if (!active) {
            this.box_.setMap(null);
            if (this.startPixel_) {
                this.dispatchEvent(new $e05f414bc3918235$export$7053c33c051365ea($e05f414bc3918235$var$DragBoxEventType.BOXCANCEL, this.startPixel_, null));
                this.startPixel_ = null;
            }
        }
        super.setActive(active);
    }
    /**
   * @param {import("../Map.js").default|null} map Map.
   * @override
   */ setMap(map) {
        const oldMap = this.getMap();
        if (oldMap) {
            this.box_.setMap(null);
            if (this.startPixel_) {
                this.dispatchEvent(new $e05f414bc3918235$export$7053c33c051365ea($e05f414bc3918235$var$DragBoxEventType.BOXCANCEL, this.startPixel_, null));
                this.startPixel_ = null;
            }
        }
        super.setMap(map);
    }
}
var $e05f414bc3918235$export$2e2bcd8739ae039 = $e05f414bc3918235$var$DragBox;


/**
 * @typedef {Object} Options
 * @property {string} [className='ol-dragzoom'] CSS class name for styling the
 * box.
 * @property {import("../events/condition.js").Condition} [condition] A function that
 * takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled.
 * Default is {@link module:ol/events/condition.shiftKeyOnly}.
 * @property {number} [duration=200] Animation duration in milliseconds.
 * @property {boolean} [out=false] Use interaction for zooming out.
 * @property {number} [minArea=64] The minimum area of the box in pixel, this value is used by the parent default
 * `boxEndCondition` function.
 */ /**
 * @classdesc
 * Allows the user to zoom the map by clicking and dragging on the map,
 * normally combined with a {@link module:ol/events/condition} that limits
 * it to when a key, shift by default, is held down.
 *
 * To change the style of the box, use CSS and the `.ol-dragzoom` selector, or
 * your custom one configured with `className`.
 * @api
 */ class $afc7f51010a5b660$var$DragZoom extends (0, $e05f414bc3918235$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        const condition = options.condition ? options.condition : (0, $edf87b50170125f7$export$5d31fe68a477cfbb);
        super({
            condition: condition,
            className: options.className || 'ol-dragzoom',
            minArea: options.minArea
        });
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 200;
        /**
     * @private
     * @type {boolean}
     */ this.out_ = options.out !== undefined ? options.out : false;
    }
    /**
   * Function to execute just before `onboxend` is fired
   * @param {import("../MapBrowserEvent.js").default} event Event.
   * @override
   */ onBoxEnd(event) {
        const map = this.getMap();
        const view = /** @type {!import("../View.js").default} */ map.getView();
        let geometry = this.getGeometry();
        if (this.out_) {
            const rotatedExtent = view.rotatedExtentForGeometry(geometry);
            const resolution = view.getResolutionForExtentInternal(rotatedExtent);
            const factor = view.getResolution() / resolution;
            geometry = geometry.clone();
            geometry.scale(factor * factor);
        }
        view.fitInternal(geometry, {
            duration: this.duration_,
            easing: (0, $c7ccf7e681a9b333$export$57636bb43b1ccbb0)
        });
    }
}
var $afc7f51010a5b660$export$2e2bcd8739ae039 = $afc7f51010a5b660$var$DragZoom;


/**
 * @module ol/interaction/KeyboardPan
 */ 

/**
 * @module ol/events/Key
 */ /**
 * @enum {string}
 * @const
 */ var $368e06a3031941b5$export$2e2bcd8739ae039 = {
    LEFT: 'ArrowLeft',
    UP: 'ArrowUp',
    RIGHT: 'ArrowRight',
    DOWN: 'ArrowDown'
};




/**
 * @typedef {Object} Options
 * @property {import("../events/condition.js").Condition} [condition] A function that
 * takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled. Default is
 * {@link module:ol/events/condition.noModifierKeys} and
 * {@link module:ol/events/condition.targetNotEditable}.
 * @property {number} [duration=100] Animation duration in milliseconds.
 * @property {number} [pixelDelta=128] The amount of pixels to pan on each key
 * press.
 */ /**
 * @classdesc
 * Allows the user to pan the map using keyboard arrows.
 * Note that, although this interaction is by default included in maps,
 * the keys can only be used when browser focus is on the element to which
 * the keyboard events are attached. By default, this is the map div,
 * though you can change this with the `keyboardEventTarget` in
 * {@link module:ol/Map~Map}. `document` never loses focus but, for any other
 * element, focus will have to be on, and returned to, this element if the keys
 * are to function.
 * See also {@link module:ol/interaction/KeyboardZoom~KeyboardZoom}.
 * @api
 */ class $178bb1517d626802$var$KeyboardPan extends (0, $39210df8527e63e5$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        super();
        options = options || {};
        /**
     * @private
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Browser event.
     * @return {boolean} Combined condition result.
     */ this.defaultCondition_ = function(mapBrowserEvent) {
            return (0, $edf87b50170125f7$export$fdc892d0d8fe3bfb)(mapBrowserEvent) && (0, $edf87b50170125f7$export$e5570ca80cd8fd54)(mapBrowserEvent);
        };
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.condition_ = options.condition !== undefined ? options.condition : this.defaultCondition_;
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 100;
        /**
     * @private
     * @type {number}
     */ this.pixelDelta_ = options.pixelDelta !== undefined ? options.pixelDelta : 128;
    }
    /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} if it was a
   * `KeyEvent`, and decides the direction to pan to (if an arrow key was
   * pressed).
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   * @override
   */ handleEvent(mapBrowserEvent) {
        let stopEvent = false;
        if (mapBrowserEvent.type == (0, $294047c5e65f31a3$export$2e2bcd8739ae039).KEYDOWN) {
            const keyEvent = /** @type {KeyboardEvent} */ mapBrowserEvent.originalEvent;
            const key = keyEvent.key;
            if (this.condition_(mapBrowserEvent) && (key == (0, $368e06a3031941b5$export$2e2bcd8739ae039).DOWN || key == (0, $368e06a3031941b5$export$2e2bcd8739ae039).LEFT || key == (0, $368e06a3031941b5$export$2e2bcd8739ae039).RIGHT || key == (0, $368e06a3031941b5$export$2e2bcd8739ae039).UP)) {
                const map = mapBrowserEvent.map;
                const view = map.getView();
                const mapUnitsDelta = view.getResolution() * this.pixelDelta_;
                let deltaX = 0, deltaY = 0;
                if (key == (0, $368e06a3031941b5$export$2e2bcd8739ae039).DOWN) deltaY = -mapUnitsDelta;
                else if (key == (0, $368e06a3031941b5$export$2e2bcd8739ae039).LEFT) deltaX = -mapUnitsDelta;
                else if (key == (0, $368e06a3031941b5$export$2e2bcd8739ae039).RIGHT) deltaX = mapUnitsDelta;
                else deltaY = mapUnitsDelta;
                const delta = [
                    deltaX,
                    deltaY
                ];
                (0, $1bd0a226f9a16141$export$bb628a54ab399bc9)(delta, view.getRotation());
                (0, $39210df8527e63e5$export$4c486572e961a974)(view, delta, this.duration_);
                keyEvent.preventDefault();
                stopEvent = true;
            }
        }
        return !stopEvent;
    }
}
var $178bb1517d626802$export$2e2bcd8739ae039 = $178bb1517d626802$var$KeyboardPan;


/**
 * @module ol/interaction/KeyboardZoom
 */ 


/**
 * @typedef {Object} Options
 * @property {number} [duration=100] Animation duration in milliseconds.
 * @property {import("../events/condition.js").Condition} [condition] A function that
 * takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled. The default condition is
 * that {@link module:ol/events/condition.targetNotEditable} is fulfilled and that
 * the platform modifier key isn't pressed
 * (!{@link module:ol/events/condition.platformModifierKey}).
 * @property {number} [delta=1] The zoom level delta on each key press.
 */ /**
 * @classdesc
 * Allows the user to zoom the map using keyboard + and -.
 * Note that, although this interaction is by default included in maps,
 * the keys can only be used when browser focus is on the element to which
 * the keyboard events are attached. By default, this is the map div,
 * though you can change this with the `keyboardEventTarget` in
 * {@link module:ol/Map~Map}. `document` never loses focus but, for any other
 * element, focus will have to be on, and returned to, this element if the keys
 * are to function.
 * See also {@link module:ol/interaction/KeyboardPan~KeyboardPan}.
 * @api
 */ class $2237fabfa170eefc$var$KeyboardZoom extends (0, $39210df8527e63e5$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        super();
        options = options ? options : {};
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.condition_ = options.condition ? options.condition : function(mapBrowserEvent) {
            return !(0, $edf87b50170125f7$export$32603ad571dd22b5)(mapBrowserEvent) && (0, $edf87b50170125f7$export$e5570ca80cd8fd54)(mapBrowserEvent);
        };
        /**
     * @private
     * @type {number}
     */ this.delta_ = options.delta ? options.delta : 1;
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 100;
    }
    /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} if it was a
   * `KeyEvent`, and decides whether to zoom in or out (depending on whether the
   * key pressed was '+' or '-').
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   * @override
   */ handleEvent(mapBrowserEvent) {
        let stopEvent = false;
        if (mapBrowserEvent.type == (0, $294047c5e65f31a3$export$2e2bcd8739ae039).KEYDOWN || mapBrowserEvent.type == (0, $294047c5e65f31a3$export$2e2bcd8739ae039).KEYPRESS) {
            const keyEvent = /** @type {KeyboardEvent} */ mapBrowserEvent.originalEvent;
            const key = keyEvent.key;
            if (this.condition_(mapBrowserEvent) && (key === '+' || key === '-')) {
                const map = mapBrowserEvent.map;
                const delta = key === '+' ? this.delta_ : -this.delta_;
                const view = map.getView();
                (0, $39210df8527e63e5$export$ace321ff2a8016ef)(view, delta, undefined, this.duration_);
                keyEvent.preventDefault();
                stopEvent = true;
            }
        }
        return !stopEvent;
    }
}
var $2237fabfa170eefc$export$2e2bcd8739ae039 = $2237fabfa170eefc$var$KeyboardZoom;


/**
 * @module ol/interaction/MouseWheelZoom
 */ 



/**
 * @typedef {'trackpad' | 'wheel'} Mode
 */ /**
 * @typedef {Object} Options
 * @property {import("../events/condition.js").Condition} [condition] A function that
 * takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled. Default is
 * {@link module:ol/events/condition.always}.
 * @property {boolean} [onFocusOnly=false] When the map's target has a `tabindex` attribute set,
 * the interaction will only handle events when the map has the focus.
 * @property {number} [maxDelta=1] Maximum mouse wheel delta.
 * @property {number} [duration=250] Animation duration in milliseconds.
 * @property {number} [timeout=80] Mouse wheel timeout duration in milliseconds.
 * @property {boolean} [useAnchor=true] Enable zooming using the mouse's
 * location as the anchor. When set to `false`, zooming in and out will zoom to
 * the center of the screen instead of zooming on the mouse's location.
 * @property {boolean} [constrainResolution=false] If true, the mouse wheel zoom
 * event will always animate to the closest zoom level after an interaction;
 * false means intermediary zoom levels are allowed.
 */ /**
 * Mutliplier for the DOM_DELTA_LINE delta value.
 * @type {number}
 */ const $aaa378764710d71e$var$DELTA_LINE_MULTIPLIER = 40;
/**
 * Mutliplier for the DOM_DELTA_PAGE delta value.
 * @type {number}
 */ const $aaa378764710d71e$var$DELTA_PAGE_MULTIPLIER = 300;
/**
 * @classdesc
 * Allows the user to zoom the map by scrolling the mouse wheel.
 * @api
 */ class $aaa378764710d71e$var$MouseWheelZoom extends (0, $39210df8527e63e5$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        super(/** @type {import("./Interaction.js").InteractionOptions} */ options);
        /**
     * @private
     * @type {number}
     */ this.totalDelta_ = 0;
        /**
     * @private
     * @type {number}
     */ this.lastDelta_ = 0;
        /**
     * @private
     * @type {number}
     */ this.maxDelta_ = options.maxDelta !== undefined ? options.maxDelta : 1;
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 250;
        /**
     * @private
     * @type {number}
     */ this.timeout_ = options.timeout !== undefined ? options.timeout : 80;
        /**
     * @private
     * @type {boolean}
     */ this.useAnchor_ = options.useAnchor !== undefined ? options.useAnchor : true;
        /**
     * @private
     * @type {boolean}
     */ this.constrainResolution_ = options.constrainResolution !== undefined ? options.constrainResolution : false;
        const condition = options.condition ? options.condition : (0, $edf87b50170125f7$export$ba9e5d519bc326ca);
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.condition_ = options.onFocusOnly ? (0, $edf87b50170125f7$export$84bf76cd7afc7469)((0, $edf87b50170125f7$export$ae2cdf064e3b0c55), condition) : condition;
        /**
     * @private
     * @type {?import("../pixel.js").Pixel}
     */ this.lastAnchor_ = null;
        /**
     * @private
     * @type {number|undefined}
     */ this.startTime_ = undefined;
        /**
     * @private
     * @type {ReturnType<typeof setTimeout>}
     */ this.timeoutId_;
        /**
     * @private
     * @type {Mode|undefined}
     */ this.mode_ = undefined;
        /**
     * Trackpad events separated by this delay will be considered separate
     * interactions.
     * @private
     * @type {number}
     */ this.trackpadEventGap_ = 400;
        /**
     * @private
     * @type {ReturnType<typeof setTimeout>}
     */ this.trackpadTimeoutId_;
        /**
     * The number of delta values per zoom level
     * @private
     * @type {number}
     */ this.deltaPerZoom_ = 300;
    }
    /**
   * @private
   */ endInteraction_() {
        this.trackpadTimeoutId_ = undefined;
        const map = this.getMap();
        if (!map) return;
        const view = map.getView();
        view.endInteraction(undefined, this.lastDelta_ ? this.lastDelta_ > 0 ? 1 : -1 : 0, this.lastAnchor_ ? map.getCoordinateFromPixel(this.lastAnchor_) : null);
    }
    /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} (if it was a mousewheel-event) and eventually
   * zooms the map.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   * @override
   */ handleEvent(mapBrowserEvent) {
        if (!this.condition_(mapBrowserEvent)) return true;
        const type = mapBrowserEvent.type;
        if (type !== (0, $294047c5e65f31a3$export$2e2bcd8739ae039).WHEEL) return true;
        const map = mapBrowserEvent.map;
        const wheelEvent = /** @type {WheelEvent} */ mapBrowserEvent.originalEvent;
        wheelEvent.preventDefault();
        if (this.useAnchor_) this.lastAnchor_ = mapBrowserEvent.pixel;
        // Delta normalisation inspired by
        // https://github.com/mapbox/mapbox-gl-js/blob/001c7b9/js/ui/handler/scroll_zoom.js
        let delta = wheelEvent.deltaY;
        switch(wheelEvent.deltaMode){
            case WheelEvent.DOM_DELTA_LINE:
                delta *= $aaa378764710d71e$var$DELTA_LINE_MULTIPLIER;
                break;
            case WheelEvent.DOM_DELTA_PAGE:
                delta *= $aaa378764710d71e$var$DELTA_PAGE_MULTIPLIER;
                break;
            default:
        }
        if (delta === 0) return false;
        this.lastDelta_ = delta;
        const now = Date.now();
        if (this.startTime_ === undefined) this.startTime_ = now;
        if (!this.mode_ || now - this.startTime_ > this.trackpadEventGap_) this.mode_ = Math.abs(delta) < 4 ? 'trackpad' : 'wheel';
        const view = map.getView();
        if (this.mode_ === 'trackpad' && !(view.getConstrainResolution() || this.constrainResolution_)) {
            if (this.trackpadTimeoutId_) clearTimeout(this.trackpadTimeoutId_);
            else {
                if (view.getAnimating()) view.cancelAnimations();
                view.beginInteraction();
            }
            this.trackpadTimeoutId_ = setTimeout(this.endInteraction_.bind(this), this.timeout_);
            view.adjustZoom(-delta / this.deltaPerZoom_, this.lastAnchor_ ? map.getCoordinateFromPixel(this.lastAnchor_) : null);
            this.startTime_ = now;
            return false;
        }
        this.totalDelta_ += delta;
        const timeLeft = Math.max(this.timeout_ - (now - this.startTime_), 0);
        clearTimeout(this.timeoutId_);
        this.timeoutId_ = setTimeout(this.handleWheelZoom_.bind(this, map), timeLeft);
        return false;
    }
    /**
   * @private
   * @param {import("../Map.js").default} map Map.
   */ handleWheelZoom_(map) {
        const view = map.getView();
        if (view.getAnimating()) view.cancelAnimations();
        let delta = -(0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(this.totalDelta_, -this.maxDelta_ * this.deltaPerZoom_, this.maxDelta_ * this.deltaPerZoom_) / this.deltaPerZoom_;
        if (view.getConstrainResolution() || this.constrainResolution_) // view has a zoom constraint, zoom by 1
        delta = delta ? delta > 0 ? 1 : -1 : 0;
        (0, $39210df8527e63e5$export$ace321ff2a8016ef)(view, delta, this.lastAnchor_ ? map.getCoordinateFromPixel(this.lastAnchor_) : null, this.duration_);
        this.mode_ = undefined;
        this.totalDelta_ = 0;
        this.lastAnchor_ = null;
        this.startTime_ = undefined;
        this.timeoutId_ = undefined;
    }
    /**
   * Enable or disable using the mouse's location as an anchor when zooming
   * @param {boolean} useAnchor true to zoom to the mouse's location, false
   * to zoom to the center of the map
   * @api
   */ setMouseAnchor(useAnchor) {
        this.useAnchor_ = useAnchor;
        if (!useAnchor) this.lastAnchor_ = null;
    }
}
var $aaa378764710d71e$export$2e2bcd8739ae039 = $aaa378764710d71e$var$MouseWheelZoom;


/**
 * @module ol/interaction/PinchRotate
 */ 


/**
 * @typedef {Object} Options
 * @property {number} [duration=250] The duration of the animation in
 * milliseconds.
 * @property {number} [threshold=0.3] Minimal angle in radians to start a rotation.
 */ /**
 * @classdesc
 * Allows the user to rotate the map by twisting with two fingers
 * on a touch screen.
 * @api
 */ class $9727451f2459496c$var$PinchRotate extends (0, $cf1eb502962d87a8$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        const pointerOptions = /** @type {import("./Pointer.js").Options} */ options;
        if (!pointerOptions.stopDown) pointerOptions.stopDown = (0, $013a1733c226ec50$export$8f11cee4bdc7e668);
        super(pointerOptions);
        /**
     * @private
     * @type {import("../coordinate.js").Coordinate}
     */ this.anchor_ = null;
        /**
     * @private
     * @type {number|undefined}
     */ this.lastAngle_ = undefined;
        /**
     * @private
     * @type {boolean}
     */ this.rotating_ = false;
        /**
     * @private
     * @type {number}
     */ this.rotationDelta_ = 0.0;
        /**
     * @private
     * @type {number}
     */ this.threshold_ = options.threshold !== undefined ? options.threshold : 0.3;
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 250;
    }
    /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @override
   */ handleDragEvent(mapBrowserEvent) {
        let rotationDelta = 0.0;
        const touch0 = this.targetPointers[0];
        const touch1 = this.targetPointers[1];
        // angle between touches
        const angle = Math.atan2(touch1.clientY - touch0.clientY, touch1.clientX - touch0.clientX);
        if (this.lastAngle_ !== undefined) {
            const delta = angle - this.lastAngle_;
            this.rotationDelta_ += delta;
            if (!this.rotating_ && Math.abs(this.rotationDelta_) > this.threshold_) this.rotating_ = true;
            rotationDelta = delta;
        }
        this.lastAngle_ = angle;
        const map = mapBrowserEvent.map;
        const view = map.getView();
        if (view.getConstraints().rotation === (0, $d65f0a322291d127$export$e20fbacbb41798b)) return;
        // rotate anchor point.
        // FIXME: should be the intersection point between the lines:
        //     touch0,touch1 and previousTouch0,previousTouch1
        this.anchor_ = map.getCoordinateFromPixelInternal(map.getEventPixel((0, $cf1eb502962d87a8$export$e2a20c553f6c85ce)(this.targetPointers)));
        // rotate
        if (this.rotating_) {
            map.render();
            view.adjustRotationInternal(rotationDelta, this.anchor_);
        }
    }
    /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleUpEvent(mapBrowserEvent) {
        if (this.targetPointers.length < 2) {
            const map = mapBrowserEvent.map;
            const view = map.getView();
            view.endInteraction(this.duration_);
            return false;
        }
        return true;
    }
    /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleDownEvent(mapBrowserEvent) {
        if (this.targetPointers.length >= 2) {
            const map = mapBrowserEvent.map;
            this.anchor_ = null;
            this.lastAngle_ = undefined;
            this.rotating_ = false;
            this.rotationDelta_ = 0.0;
            if (!this.handlingDownUpSequence) map.getView().beginInteraction();
            return true;
        }
        return false;
    }
}
var $9727451f2459496c$export$2e2bcd8739ae039 = $9727451f2459496c$var$PinchRotate;


/**
 * @module ol/interaction/PinchZoom
 */ 

/**
 * @typedef {Object} Options
 * @property {number} [duration=400] Animation duration in milliseconds.
 */ /**
 * @classdesc
 * Allows the user to zoom the map by pinching with two fingers
 * on a touch screen.
 * @api
 */ class $79c946b60b88d4a6$var$PinchZoom extends (0, $cf1eb502962d87a8$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        const pointerOptions = /** @type {import("./Pointer.js").Options} */ options;
        if (!pointerOptions.stopDown) pointerOptions.stopDown = (0, $013a1733c226ec50$export$8f11cee4bdc7e668);
        super(pointerOptions);
        /**
     * @private
     * @type {import("../coordinate.js").Coordinate}
     */ this.anchor_ = null;
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 400;
        /**
     * @private
     * @type {number|undefined}
     */ this.lastDistance_ = undefined;
        /**
     * @private
     * @type {number}
     */ this.lastScaleDelta_ = 1;
    }
    /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @override
   */ handleDragEvent(mapBrowserEvent) {
        let scaleDelta = 1.0;
        const touch0 = this.targetPointers[0];
        const touch1 = this.targetPointers[1];
        const dx = touch0.clientX - touch1.clientX;
        const dy = touch0.clientY - touch1.clientY;
        // distance between touches
        const distance = Math.sqrt(dx * dx + dy * dy);
        if (this.lastDistance_ !== undefined) scaleDelta = this.lastDistance_ / distance;
        this.lastDistance_ = distance;
        const map = mapBrowserEvent.map;
        const view = map.getView();
        if (scaleDelta != 1.0) this.lastScaleDelta_ = scaleDelta;
        // scale anchor point.
        this.anchor_ = map.getCoordinateFromPixelInternal(map.getEventPixel((0, $cf1eb502962d87a8$export$e2a20c553f6c85ce)(this.targetPointers)));
        // scale, bypass the resolution constraint
        map.render();
        view.adjustResolutionInternal(scaleDelta, this.anchor_);
    }
    /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleUpEvent(mapBrowserEvent) {
        if (this.targetPointers.length < 2) {
            const map = mapBrowserEvent.map;
            const view = map.getView();
            const direction = this.lastScaleDelta_ > 1 ? 1 : -1;
            view.endInteraction(this.duration_, direction);
            return false;
        }
        return true;
    }
    /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleDownEvent(mapBrowserEvent) {
        if (this.targetPointers.length >= 2) {
            const map = mapBrowserEvent.map;
            this.anchor_ = null;
            this.lastDistance_ = undefined;
            this.lastScaleDelta_ = 1;
            if (!this.handlingDownUpSequence) map.getView().beginInteraction();
            return true;
        }
        return false;
    }
}
var $79c946b60b88d4a6$export$2e2bcd8739ae039 = $79c946b60b88d4a6$var$PinchZoom;


function $e3fbd36d629ecc04$export$ebe90cb607ad99e(options) {
    options = options ? options : {};
    /** @type {Collection<import("./Interaction.js").default>} */ const interactions = new (0, $931ffc4e747c14db$export$2e2bcd8739ae039)();
    const kinetic = new (0, $9a54ea8d5f7a49ee$export$2e2bcd8739ae039)(-0.005, 0.05, 100);
    const altShiftDragRotate = options.altShiftDragRotate !== undefined ? options.altShiftDragRotate : true;
    if (altShiftDragRotate) interactions.push(new (0, $197c7092261b2aa0$export$2e2bcd8739ae039)());
    const doubleClickZoom = options.doubleClickZoom !== undefined ? options.doubleClickZoom : true;
    if (doubleClickZoom) interactions.push(new (0, $b50403621294a654$export$2e2bcd8739ae039)({
        delta: options.zoomDelta,
        duration: options.zoomDuration
    }));
    const dragPan = options.dragPan !== undefined ? options.dragPan : true;
    if (dragPan) interactions.push(new (0, $c11585da26a016db$export$2e2bcd8739ae039)({
        onFocusOnly: options.onFocusOnly,
        kinetic: kinetic
    }));
    const pinchRotate = options.pinchRotate !== undefined ? options.pinchRotate : true;
    if (pinchRotate) interactions.push(new (0, $9727451f2459496c$export$2e2bcd8739ae039)());
    const pinchZoom = options.pinchZoom !== undefined ? options.pinchZoom : true;
    if (pinchZoom) interactions.push(new (0, $79c946b60b88d4a6$export$2e2bcd8739ae039)({
        duration: options.zoomDuration
    }));
    const keyboard = options.keyboard !== undefined ? options.keyboard : true;
    if (keyboard) {
        interactions.push(new (0, $178bb1517d626802$export$2e2bcd8739ae039)());
        interactions.push(new (0, $2237fabfa170eefc$export$2e2bcd8739ae039)({
            delta: options.zoomDelta,
            duration: options.zoomDuration
        }));
    }
    const mouseWheelZoom = options.mouseWheelZoom !== undefined ? options.mouseWheelZoom : true;
    if (mouseWheelZoom) interactions.push(new (0, $aaa378764710d71e$export$2e2bcd8739ae039)({
        onFocusOnly: options.onFocusOnly,
        duration: options.zoomDuration
    }));
    const shiftDragZoom = options.shiftDragZoom !== undefined ? options.shiftDragZoom : true;
    if (shiftDragZoom) interactions.push(new (0, $afc7f51010a5b660$export$2e2bcd8739ae039)({
        duration: options.zoomDuration
    }));
    return interactions;
}


/**
 * @module ol/layer/Group
 */ 









/**
 * @module ol/layer/Base
 */ 



/**
 * @module ol/layer/Property
 */ /**
 * @enum {string}
 */ var $f6d1853b3fcae320$export$2e2bcd8739ae039 = {
    OPACITY: 'opacity',
    VISIBLE: 'visible',
    EXTENT: 'extent',
    Z_INDEX: 'zIndex',
    MAX_RESOLUTION: 'maxResolution',
    MIN_RESOLUTION: 'minResolution',
    MAX_ZOOM: 'maxZoom',
    MIN_ZOOM: 'minZoom',
    SOURCE: 'source',
    MAP: 'map'
};


/**
 * A css color, or a function called with a view resolution returning a css color.
 *
 * @typedef {string|function(number):string} BackgroundColor
 * @api
 */ /**
 * @typedef {import("../ObjectEventType").Types|'change:extent'|'change:maxResolution'|'change:maxZoom'|
 *    'change:minResolution'|'change:minZoom'|'change:opacity'|'change:visible'|'change:zIndex'} BaseLayerObjectEventTypes
 */ /***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<BaseLayerObjectEventTypes, import("../Object").ObjectEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|BaseLayerObjectEventTypes, Return>} BaseLayerOnSignature
 */ /**
 * @typedef {Object} Options
 * @property {string} [className='ol-layer'] A CSS class name to set to the layer element.
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number | undefined} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {BackgroundColor} [background] Background color for the layer. If not specified, no background
 * will be rendered.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Note that with {@link module:ol/layer/Base~BaseLayer} and all its subclasses, any property set in
 * the options is set as a {@link module:ol/Object~BaseObject} property on the layer object, so
 * is observable, and has get/set accessors.
 *
 * @api
 */ class $57c5f0299cb9b82f$var$BaseLayer extends (0, $b68b3d6e32e3074a$export$2e2bcd8739ae039) {
    /**
   * @param {Options} options Layer options.
   */ constructor(options){
        super();
        /***
     * @type {BaseLayerOnSignature<import("../events").EventsKey>}
     */ this.on;
        /***
     * @type {BaseLayerOnSignature<import("../events").EventsKey>}
     */ this.once;
        /***
     * @type {BaseLayerOnSignature<void>}
     */ this.un;
        /**
     * @type {BackgroundColor|false}
     * @private
     */ this.background_ = options.background;
        /**
     * @type {Object<string, *>}
     */ const properties = Object.assign({}, options);
        if (typeof options.properties === 'object') {
            delete properties.properties;
            Object.assign(properties, options.properties);
        }
        properties[(0, $f6d1853b3fcae320$export$2e2bcd8739ae039).OPACITY] = options.opacity !== undefined ? options.opacity : 1;
        (0, $35d5ec884318008e$export$a7a9523472993e97)(typeof properties[(0, $f6d1853b3fcae320$export$2e2bcd8739ae039).OPACITY] === 'number', 'Layer opacity must be a number');
        properties[(0, $f6d1853b3fcae320$export$2e2bcd8739ae039).VISIBLE] = options.visible !== undefined ? options.visible : true;
        properties[(0, $f6d1853b3fcae320$export$2e2bcd8739ae039).Z_INDEX] = options.zIndex;
        properties[(0, $f6d1853b3fcae320$export$2e2bcd8739ae039).MAX_RESOLUTION] = options.maxResolution !== undefined ? options.maxResolution : Infinity;
        properties[(0, $f6d1853b3fcae320$export$2e2bcd8739ae039).MIN_RESOLUTION] = options.minResolution !== undefined ? options.minResolution : 0;
        properties[(0, $f6d1853b3fcae320$export$2e2bcd8739ae039).MIN_ZOOM] = options.minZoom !== undefined ? options.minZoom : -Infinity;
        properties[(0, $f6d1853b3fcae320$export$2e2bcd8739ae039).MAX_ZOOM] = options.maxZoom !== undefined ? options.maxZoom : Infinity;
        /**
     * @type {string}
     * @private
     */ this.className_ = properties.className !== undefined ? properties.className : 'ol-layer';
        delete properties.className;
        this.setProperties(properties);
        /**
     * @type {import("./Layer.js").State}
     * @private
     */ this.state_ = null;
    }
    /**
   * Get the background for this layer.
   * @return {BackgroundColor|false} Layer background.
   */ getBackground() {
        return this.background_;
    }
    /**
   * @return {string} CSS class name.
   */ getClassName() {
        return this.className_;
    }
    /**
   * This method is not meant to be called by layers or layer renderers because the state
   * is incorrect if the layer is included in a layer group.
   *
   * @param {boolean} [managed] Layer is managed.
   * @return {import("./Layer.js").State} Layer state.
   */ getLayerState(managed) {
        /** @type {import("./Layer.js").State} */ const state = this.state_ || /** @type {?} */ {
            layer: this,
            managed: managed === undefined ? true : managed
        };
        const zIndex = this.getZIndex();
        state.opacity = (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(Math.round(this.getOpacity() * 100) / 100, 0, 1);
        state.visible = this.getVisible();
        state.extent = this.getExtent();
        state.zIndex = zIndex === undefined && !state.managed ? Infinity : zIndex;
        state.maxResolution = this.getMaxResolution();
        state.minResolution = Math.max(this.getMinResolution(), 0);
        state.minZoom = this.getMinZoom();
        state.maxZoom = this.getMaxZoom();
        this.state_ = state;
        return state;
    }
    /**
   * @abstract
   * @param {Array<import("./Layer.js").default>} [array] Array of layers (to be
   *     modified in place).
   * @return {Array<import("./Layer.js").default>} Array of layers.
   */ getLayersArray(array) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * @abstract
   * @param {Array<import("./Layer.js").State>} [states] Optional list of layer
   *     states (to be modified in place).
   * @return {Array<import("./Layer.js").State>} List of layer states.
   */ getLayerStatesArray(states) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Return the {@link module:ol/extent~Extent extent} of the layer or `undefined` if it
   * will be visible regardless of extent.
   * @return {import("../extent.js").Extent|undefined} The layer extent.
   * @observable
   * @api
   */ getExtent() {
        return /** @type {import("../extent.js").Extent|undefined} */ this.get((0, $f6d1853b3fcae320$export$2e2bcd8739ae039).EXTENT);
    }
    /**
   * Return the maximum resolution of the layer. Returns Infinity if
   * the layer has no maximum resolution set.
   * @return {number} The maximum resolution of the layer.
   * @observable
   * @api
   */ getMaxResolution() {
        return /** @type {number} */ this.get((0, $f6d1853b3fcae320$export$2e2bcd8739ae039).MAX_RESOLUTION);
    }
    /**
   * Return the minimum resolution of the layer. Returns 0 if
   * the layer has no minimum resolution set.
   * @return {number} The minimum resolution of the layer.
   * @observable
   * @api
   */ getMinResolution() {
        return /** @type {number} */ this.get((0, $f6d1853b3fcae320$export$2e2bcd8739ae039).MIN_RESOLUTION);
    }
    /**
   * Return the minimum zoom level of the layer. Returns -Infinity if
   * the layer has no minimum zoom set.
   * @return {number} The minimum zoom level of the layer.
   * @observable
   * @api
   */ getMinZoom() {
        return /** @type {number} */ this.get((0, $f6d1853b3fcae320$export$2e2bcd8739ae039).MIN_ZOOM);
    }
    /**
   * Return the maximum zoom level of the layer. Returns Infinity if
   * the layer has no maximum zoom set.
   * @return {number} The maximum zoom level of the layer.
   * @observable
   * @api
   */ getMaxZoom() {
        return /** @type {number} */ this.get((0, $f6d1853b3fcae320$export$2e2bcd8739ae039).MAX_ZOOM);
    }
    /**
   * Return the opacity of the layer (between 0 and 1).
   * @return {number} The opacity of the layer.
   * @observable
   * @api
   */ getOpacity() {
        return /** @type {number} */ this.get((0, $f6d1853b3fcae320$export$2e2bcd8739ae039).OPACITY);
    }
    /**
   * @abstract
   * @return {import("../source/Source.js").State} Source state.
   */ getSourceState() {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Return the value of this layer's `visible` property. To find out whether the layer
   * is visible on a map, use `isVisible()` instead.
   * @return {boolean} The value of the `visible` property of the layer.
   * @observable
   * @api
   */ getVisible() {
        return /** @type {boolean} */ this.get((0, $f6d1853b3fcae320$export$2e2bcd8739ae039).VISIBLE);
    }
    /**
   * Return the Z-index of the layer, which is used to order layers before
   * rendering. Returns undefined if the layer is unmanaged.
   * @return {number|undefined} The Z-index of the layer.
   * @observable
   * @api
   */ getZIndex() {
        return /** @type {number|undefined} */ this.get((0, $f6d1853b3fcae320$export$2e2bcd8739ae039).Z_INDEX);
    }
    /**
   * Sets the background color.
   * @param {BackgroundColor} [background] Background color.
   */ setBackground(background) {
        this.background_ = background;
        this.changed();
    }
    /**
   * Set the extent at which the layer is visible.  If `undefined`, the layer
   * will be visible at all extents.
   * @param {import("../extent.js").Extent|undefined} extent The extent of the layer.
   * @observable
   * @api
   */ setExtent(extent) {
        this.set((0, $f6d1853b3fcae320$export$2e2bcd8739ae039).EXTENT, extent);
    }
    /**
   * Set the maximum resolution at which the layer is visible.
   * @param {number} maxResolution The maximum resolution of the layer.
   * @observable
   * @api
   */ setMaxResolution(maxResolution) {
        this.set((0, $f6d1853b3fcae320$export$2e2bcd8739ae039).MAX_RESOLUTION, maxResolution);
    }
    /**
   * Set the minimum resolution at which the layer is visible.
   * @param {number} minResolution The minimum resolution of the layer.
   * @observable
   * @api
   */ setMinResolution(minResolution) {
        this.set((0, $f6d1853b3fcae320$export$2e2bcd8739ae039).MIN_RESOLUTION, minResolution);
    }
    /**
   * Set the maximum zoom (exclusive) at which the layer is visible.
   * Note that the zoom levels for layer visibility are based on the
   * view zoom level, which may be different from a tile source zoom level.
   * @param {number} maxZoom The maximum zoom of the layer.
   * @observable
   * @api
   */ setMaxZoom(maxZoom) {
        this.set((0, $f6d1853b3fcae320$export$2e2bcd8739ae039).MAX_ZOOM, maxZoom);
    }
    /**
   * Set the minimum zoom (inclusive) at which the layer is visible.
   * Note that the zoom levels for layer visibility are based on the
   * view zoom level, which may be different from a tile source zoom level.
   * @param {number} minZoom The minimum zoom of the layer.
   * @observable
   * @api
   */ setMinZoom(minZoom) {
        this.set((0, $f6d1853b3fcae320$export$2e2bcd8739ae039).MIN_ZOOM, minZoom);
    }
    /**
   * Set the opacity of the layer, allowed values range from 0 to 1.
   * @param {number} opacity The opacity of the layer.
   * @observable
   * @api
   */ setOpacity(opacity) {
        (0, $35d5ec884318008e$export$a7a9523472993e97)(typeof opacity === 'number', 'Layer opacity must be a number');
        this.set((0, $f6d1853b3fcae320$export$2e2bcd8739ae039).OPACITY, opacity);
    }
    /**
   * Set the visibility of the layer (`true` or `false`).
   * @param {boolean} visible The visibility of the layer.
   * @observable
   * @api
   */ setVisible(visible) {
        this.set((0, $f6d1853b3fcae320$export$2e2bcd8739ae039).VISIBLE, visible);
    }
    /**
   * Set Z-index of the layer, which is used to order layers before rendering.
   * The default Z-index is 0.
   * @param {number} zindex The z-index of the layer.
   * @observable
   * @api
   */ setZIndex(zindex) {
        this.set((0, $f6d1853b3fcae320$export$2e2bcd8739ae039).Z_INDEX, zindex);
    }
    /**
   * Clean up.
   * @override
   */ disposeInternal() {
        if (this.state_) {
            this.state_.layer = null;
            this.state_ = null;
        }
        super.disposeInternal();
    }
}
var $57c5f0299cb9b82f$export$2e2bcd8739ae039 = $57c5f0299cb9b82f$var$BaseLayer;


class $0b703156bb914e6f$export$2f5ff21d758d25a7 extends (0, $aeedce20e9577100$export$2e2bcd8739ae039) {
    /**
   * @param {GroupEventType} type The event type.
   * @param {BaseLayer} layer The layer.
   */ constructor(type, layer){
        super(type);
        /**
     * The added or removed layer.
     * @type {BaseLayer}
     * @api
     */ this.layer = layer;
    }
}
/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("./Base").BaseLayerObjectEventTypes|
 *     'change:layers', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("./Base").BaseLayerObjectEventTypes|'change:layers', Return>} GroupOnSignature
 */ /**
 * @typedef {Object} Options
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {Array<import("./Base.js").default>|Collection<import("./Base.js").default>} [layers] Child layers.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 */ /**
 * @enum {string}
 * @private
 */ const $0b703156bb914e6f$var$Property = {
    LAYERS: 'layers'
};
/**
 * @classdesc
 * A {@link module:ol/Collection~Collection} of layers that are handled together.
 *
 * A generic `change` event is triggered when the group/Collection changes.
 *
 * @api
 */ class $0b703156bb914e6f$var$LayerGroup extends (0, $57c5f0299cb9b82f$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Layer options.
   */ constructor(options){
        options = options || {};
        const baseOptions = /** @type {Options} */ Object.assign({}, options);
        delete baseOptions.layers;
        let layers = options.layers;
        super(baseOptions);
        /***
     * @type {GroupOnSignature<import("../events").EventsKey>}
     */ this.on;
        /***
     * @type {GroupOnSignature<import("../events").EventsKey>}
     */ this.once;
        /***
     * @type {GroupOnSignature<void>}
     */ this.un;
        /**
     * @private
     * @type {Array<import("../events.js").EventsKey>}
     */ this.layersListenerKeys_ = [];
        /**
     * @private
     * @type {Object<string, Array<import("../events.js").EventsKey>>}
     */ this.listenerKeys_ = {};
        this.addChangeListener($0b703156bb914e6f$var$Property.LAYERS, this.handleLayersChanged_);
        if (layers) {
            if (Array.isArray(layers)) layers = new (0, $931ffc4e747c14db$export$2e2bcd8739ae039)(layers.slice(), {
                unique: true
            });
            else (0, $35d5ec884318008e$export$a7a9523472993e97)(typeof /** @type {?} */ layers.getArray === 'function', 'Expected `layers` to be an array or a `Collection`');
        } else layers = new (0, $931ffc4e747c14db$export$2e2bcd8739ae039)(undefined, {
            unique: true
        });
        this.setLayers(layers);
    }
    /**
   * @private
   */ handleLayerChange_() {
        this.changed();
    }
    /**
   * @private
   */ handleLayersChanged_() {
        this.layersListenerKeys_.forEach((0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921));
        this.layersListenerKeys_.length = 0;
        const layers = this.getLayers();
        this.layersListenerKeys_.push((0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(layers, (0, $161dd067fe2d672c$export$2e2bcd8739ae039).ADD, this.handleLayersAdd_, this), (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(layers, (0, $161dd067fe2d672c$export$2e2bcd8739ae039).REMOVE, this.handleLayersRemove_, this));
        for(const id in this.listenerKeys_)this.listenerKeys_[id].forEach((0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921));
        (0, $beaefe87199bb537$export$42ffd38884aecdac)(this.listenerKeys_);
        const layersArray = layers.getArray();
        for(let i = 0, ii = layersArray.length; i < ii; i++){
            const layer = layersArray[i];
            this.registerLayerListeners_(layer);
            this.dispatchEvent(new $0b703156bb914e6f$export$2f5ff21d758d25a7('addlayer', layer));
        }
        this.changed();
    }
    /**
   * @param {BaseLayer} layer The layer.
   */ registerLayerListeners_(layer) {
        const listenerKeys = [
            (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(layer, (0, $e881b5dca21eb5d4$export$2e2bcd8739ae039).PROPERTYCHANGE, this.handleLayerChange_, this),
            (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(layer, (0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE, this.handleLayerChange_, this)
        ];
        if (layer instanceof $0b703156bb914e6f$var$LayerGroup) listenerKeys.push((0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(layer, 'addlayer', this.handleLayerGroupAdd_, this), (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(layer, 'removelayer', this.handleLayerGroupRemove_, this));
        this.listenerKeys_[(0, $6c5e11070e371322$export$5e82334337e0f204)(layer)] = listenerKeys;
    }
    /**
   * @param {GroupEvent} event The layer group event.
   */ handleLayerGroupAdd_(event) {
        this.dispatchEvent(new $0b703156bb914e6f$export$2f5ff21d758d25a7('addlayer', event.layer));
    }
    /**
   * @param {GroupEvent} event The layer group event.
   */ handleLayerGroupRemove_(event) {
        this.dispatchEvent(new $0b703156bb914e6f$export$2f5ff21d758d25a7('removelayer', event.layer));
    }
    /**
   * @param {import("../Collection.js").CollectionEvent<import("./Base.js").default>} collectionEvent CollectionEvent.
   * @private
   */ handleLayersAdd_(collectionEvent) {
        const layer = collectionEvent.element;
        this.registerLayerListeners_(layer);
        this.dispatchEvent(new $0b703156bb914e6f$export$2f5ff21d758d25a7('addlayer', layer));
        this.changed();
    }
    /**
   * @param {import("../Collection.js").CollectionEvent<import("./Base.js").default>} collectionEvent CollectionEvent.
   * @private
   */ handleLayersRemove_(collectionEvent) {
        const layer = collectionEvent.element;
        const key = (0, $6c5e11070e371322$export$5e82334337e0f204)(layer);
        this.listenerKeys_[key].forEach((0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921));
        delete this.listenerKeys_[key];
        this.dispatchEvent(new $0b703156bb914e6f$export$2f5ff21d758d25a7('removelayer', layer));
        this.changed();
    }
    /**
   * Returns the {@link module:ol/Collection~Collection collection} of {@link module:ol/layer/Layer~Layer layers}
   * in this group.
   * @return {!Collection<import("./Base.js").default>} Collection of
   *   {@link module:ol/layer/Base~BaseLayer layers} that are part of this group.
   * @observable
   * @api
   */ getLayers() {
        return /** @type {!Collection<import("./Base.js").default>} */ this.get($0b703156bb914e6f$var$Property.LAYERS);
    }
    /**
   * Set the {@link module:ol/Collection~Collection collection} of {@link module:ol/layer/Layer~Layer layers}
   * in this group.
   * @param {!Collection<import("./Base.js").default>} layers Collection of
   *   {@link module:ol/layer/Base~BaseLayer layers} that are part of this group.
   * @observable
   * @api
   */ setLayers(layers) {
        const collection = this.getLayers();
        if (collection) {
            const currentLayers = collection.getArray();
            for(let i = 0, ii = currentLayers.length; i < ii; ++i)this.dispatchEvent(new $0b703156bb914e6f$export$2f5ff21d758d25a7('removelayer', currentLayers[i]));
        }
        this.set($0b703156bb914e6f$var$Property.LAYERS, layers);
    }
    /**
   * @param {Array<import("./Layer.js").default>} [array] Array of layers (to be modified in place).
   * @return {Array<import("./Layer.js").default>} Array of layers.
   * @override
   */ getLayersArray(array) {
        array = array !== undefined ? array : [];
        this.getLayers().forEach(function(layer) {
            layer.getLayersArray(array);
        });
        return array;
    }
    /**
   * Get the layer states list and use this groups z-index as the default
   * for all layers in this and nested groups, if it is unset at this point.
   * If dest is not provided and this group's z-index is undefined
   * 0 is used a the default z-index.
   * @param {Array<import("./Layer.js").State>} [dest] Optional list
   * of layer states (to be modified in place).
   * @return {Array<import("./Layer.js").State>} List of layer states.
   * @override
   */ getLayerStatesArray(dest) {
        const states = dest !== undefined ? dest : [];
        const pos = states.length;
        this.getLayers().forEach(function(layer) {
            layer.getLayerStatesArray(states);
        });
        const ownLayerState = this.getLayerState();
        let defaultZIndex = ownLayerState.zIndex;
        if (!dest && ownLayerState.zIndex === undefined) defaultZIndex = 0;
        for(let i = pos, ii = states.length; i < ii; i++){
            const layerState = states[i];
            layerState.opacity *= ownLayerState.opacity;
            layerState.visible = layerState.visible && ownLayerState.visible;
            layerState.maxResolution = Math.min(layerState.maxResolution, ownLayerState.maxResolution);
            layerState.minResolution = Math.max(layerState.minResolution, ownLayerState.minResolution);
            layerState.minZoom = Math.max(layerState.minZoom, ownLayerState.minZoom);
            layerState.maxZoom = Math.min(layerState.maxZoom, ownLayerState.maxZoom);
            if (ownLayerState.extent !== undefined) {
                if (layerState.extent !== undefined) layerState.extent = (0, $6da4c8ed3074c92b$export$72209efa88586d42)(layerState.extent, ownLayerState.extent);
                else layerState.extent = ownLayerState.extent;
            }
            if (layerState.zIndex === undefined) layerState.zIndex = defaultZIndex;
        }
        return states;
    }
    /**
   * @return {import("../source/Source.js").State} Source state.
   * @override
   */ getSourceState() {
        return 'ready';
    }
}
var $0b703156bb914e6f$export$2e2bcd8739ae039 = $0b703156bb914e6f$var$LayerGroup;


/**
 * @module ol/layer/Layer
 */ 




/**
 * @module ol/render/EventType
 */ /**
 * @enum {string}
 */ var $f5e92a4d985a2824$export$2e2bcd8739ae039 /**
 * @typedef {'postrender'|'precompose'|'postcompose'|'rendercomplete'} MapRenderEventTypes
 */  /**
 * @typedef {'postrender'|'prerender'} LayerRenderEventTypes
 */  = {
    /**
   * Triggered before a layer is rendered.
   * @event module:ol/render/Event~RenderEvent#prerender
   * @api
   */ PRERENDER: 'prerender',
    /**
   * Triggered after a layer is rendered.
   * @event module:ol/render/Event~RenderEvent#postrender
   * @api
   */ POSTRENDER: 'postrender',
    /**
   * Triggered before layers are composed.  When dispatched by the map, the event object will not have
   * a `context` set.  When dispatched by a layer, the event object will have a `context` set.  Only
   * WebGL layers currently dispatch this event.
   * @event module:ol/render/Event~RenderEvent#precompose
   * @api
   */ PRECOMPOSE: 'precompose',
    /**
   * Triggered after layers are composed.  When dispatched by the map, the event object will not have
   * a `context` set.  When dispatched by a layer, the event object will have a `context` set.  Only
   * WebGL layers currently dispatch this event.
   * @event module:ol/render/Event~RenderEvent#postcompose
   * @api
   */ POSTCOMPOSE: 'postcompose',
    /**
   * Triggered when rendering is complete, i.e. all sources and tiles have
   * finished loading for the current viewport, and all tiles are faded in.
   * The event object will not have a `context` set.
   * @event module:ol/render/Event~RenderEvent#rendercomplete
   * @api
   */ RENDERCOMPLETE: 'rendercomplete'
};




/**
 * @typedef {function(import("../Map.js").FrameState):HTMLElement} RenderFunction
 */ /**
 * @typedef {'sourceready'|'change:source'} LayerEventType
 */ /***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("./Base").BaseLayerObjectEventTypes|
 *     LayerEventType, import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<import("../render/EventType").LayerRenderEventTypes, import("../render/Event").default, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("./Base").BaseLayerObjectEventTypes|LayerEventType|
 *     import("../render/EventType").LayerRenderEventTypes, Return>} LayerOnSignature
 */ /**
 * @template {import("../source/Source.js").default} [SourceType=import("../source/Source.js").default]
 * @typedef {Object} Options
 * @property {string} [className='ol-layer'] A CSS class name to set to the layer element.
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {SourceType} [source] Source for this layer.  If not provided to the constructor,
 * the source can be set by calling {@link module:ol/layer/Layer~Layer#setSource layer.setSource(source)} after
 * construction.
 * @property {import("../Map.js").default|null} [map] Map.
 * @property {RenderFunction} [render] Render function. Takes the frame state as input and is expected to return an
 * HTML element. Will overwrite the default rendering for the layer.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 */ /**
 * @typedef {Object} State
 * @property {import("./Layer.js").default} layer Layer.
 * @property {number} opacity Opacity, the value is rounded to two digits to appear after the decimal point.
 * @property {boolean} visible Visible.
 * @property {boolean} managed Managed.
 * @property {import("../extent.js").Extent} [extent] Extent.
 * @property {number} zIndex ZIndex.
 * @property {number} maxResolution Maximum resolution.
 * @property {number} minResolution Minimum resolution.
 * @property {number} minZoom Minimum zoom.
 * @property {number} maxZoom Maximum zoom.
 */ /**
 * @classdesc
 * Base class from which all layer types are derived. This should only be instantiated
 * in the case where a custom layer is added to the map with a custom `render` function.
 * Such a function can be specified in the `options` object, and is expected to return an HTML element.
 *
 * A visual representation of raster or vector map data.
 * Layers group together those properties that pertain to how the data is to be
 * displayed, irrespective of the source of that data.
 *
 * Layers are usually added to a map with [map.addLayer()]{@link import("../Map.js").default#addLayer}.
 * Components like {@link module:ol/interaction/Draw~Draw} use unmanaged layers
 * internally. These unmanaged layers are associated with the map using
 * [layer.setMap()]{@link module:ol/layer/Layer~Layer#setMap} instead.
 *
 * A generic `change` event is fired when the state of the source changes.
 * A `sourceready` event is fired when the layer's source is ready.
 *
 * @fires import("../render/Event.js").RenderEvent#prerender
 * @fires import("../render/Event.js").RenderEvent#postrender
 * @fires import("../events/Event.js").BaseEvent#sourceready
 *
 * @template {import("../source/Source.js").default} [SourceType=import("../source/Source.js").default]
 * @template {import("../renderer/Layer.js").default} [RendererType=import("../renderer/Layer.js").default]
 * @api
 */ class $534f30fce11effcd$var$Layer extends (0, $57c5f0299cb9b82f$export$2e2bcd8739ae039) {
    /**
   * @param {Options<SourceType>} options Layer options.
   */ constructor(options){
        const baseOptions = Object.assign({}, options);
        delete baseOptions.source;
        super(baseOptions);
        /***
     * @type {LayerOnSignature<import("../events").EventsKey>}
     */ this.on;
        /***
     * @type {LayerOnSignature<import("../events").EventsKey>}
     */ this.once;
        /***
     * @type {LayerOnSignature<void>}
     */ this.un;
        /**
     * @private
     * @type {?import("../events.js").EventsKey}
     */ this.mapPrecomposeKey_ = null;
        /**
     * @private
     * @type {?import("../events.js").EventsKey}
     */ this.mapRenderKey_ = null;
        /**
     * @private
     * @type {?import("../events.js").EventsKey}
     */ this.sourceChangeKey_ = null;
        /**
     * @private
     * @type {RendererType}
     */ this.renderer_ = null;
        /**
     * @private
     * @type {boolean}
     */ this.sourceReady_ = false;
        /**
     * @protected
     * @type {boolean}
     */ this.rendered = false;
        // Overwrite default render method with a custom one
        if (options.render) this.render = options.render;
        if (options.map) this.setMap(options.map);
        this.addChangeListener((0, $f6d1853b3fcae320$export$2e2bcd8739ae039).SOURCE, this.handleSourcePropertyChange_);
        const source = options.source ? /** @type {SourceType} */ options.source : null;
        this.setSource(source);
    }
    /**
   * @param {Array<import("./Layer.js").default>} [array] Array of layers (to be modified in place).
   * @return {Array<import("./Layer.js").default>} Array of layers.
   * @override
   */ getLayersArray(array) {
        array = array ? array : [];
        array.push(this);
        return array;
    }
    /**
   * @param {Array<import("./Layer.js").State>} [states] Optional list of layer states (to be modified in place).
   * @return {Array<import("./Layer.js").State>} List of layer states.
   * @override
   */ getLayerStatesArray(states) {
        states = states ? states : [];
        states.push(this.getLayerState());
        return states;
    }
    /**
   * Get the layer source.
   * @return {SourceType|null} The layer source (or `null` if not yet set).
   * @observable
   * @api
   */ getSource() {
        return /** @type {SourceType} */ this.get((0, $f6d1853b3fcae320$export$2e2bcd8739ae039).SOURCE) || null;
    }
    /**
   * @return {SourceType|null} The source being rendered.
   */ getRenderSource() {
        return this.getSource();
    }
    /**
   * @return {import("../source/Source.js").State} Source state.
   * @override
   */ getSourceState() {
        const source = this.getSource();
        return !source ? 'undefined' : source.getState();
    }
    /**
   * @private
   */ handleSourceChange_() {
        this.changed();
        if (this.sourceReady_ || this.getSource().getState() !== 'ready') return;
        this.sourceReady_ = true;
        this.dispatchEvent('sourceready');
    }
    /**
   * @private
   */ handleSourcePropertyChange_() {
        if (this.sourceChangeKey_) {
            (0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921)(this.sourceChangeKey_);
            this.sourceChangeKey_ = null;
        }
        this.sourceReady_ = false;
        const source = this.getSource();
        if (source) {
            this.sourceChangeKey_ = (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(source, (0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE, this.handleSourceChange_, this);
            if (source.getState() === 'ready') {
                this.sourceReady_ = true;
                setTimeout(()=>{
                    this.dispatchEvent('sourceready');
                }, 0);
            }
        }
        this.changed();
    }
    /**
   * @param {import("../pixel").Pixel} pixel Pixel.
   * @return {Promise<Array<import("../Feature").FeatureLike>>} Promise that resolves with
   * an array of features.
   */ getFeatures(pixel) {
        if (!this.renderer_) return Promise.resolve([]);
        return this.renderer_.getFeatures(pixel);
    }
    /**
   * @param {import("../pixel").Pixel} pixel Pixel.
   * @return {Uint8ClampedArray|Uint8Array|Float32Array|DataView|null} Pixel data.
   */ getData(pixel) {
        if (!this.renderer_ || !this.rendered) return null;
        return this.renderer_.getData(pixel);
    }
    /**
   * The layer is visible on the map view, i.e. within its min/max resolution or zoom and
   * extent, not set to `visible: false`, and not inside a layer group that is set
   * to `visible: false`.
   * @param {View|import("../View.js").ViewStateLayerStateExtent} [view] View or {@link import("../Map.js").FrameState}.
   * Only required when the layer is not added to a map.
   * @return {boolean} The layer is visible in the map view.
   * @api
   */ isVisible(view) {
        let frameState;
        const map = this.getMapInternal();
        if (!view && map) view = map.getView();
        if (view instanceof (0, $70364d0195659942$export$2e2bcd8739ae039)) frameState = {
            viewState: view.getState(),
            extent: view.calculateExtent()
        };
        else frameState = view;
        if (!frameState.layerStatesArray && map) frameState.layerStatesArray = map.getLayerGroup().getLayerStatesArray();
        let layerState;
        if (frameState.layerStatesArray) {
            layerState = frameState.layerStatesArray.find((layerState)=>layerState.layer === this);
            if (!layerState) return false;
        } else layerState = this.getLayerState();
        const layerExtent = this.getExtent();
        return $534f30fce11effcd$export$acb1e9cb9ce4ca56(layerState, frameState.viewState) && (!layerExtent || (0, $6da4c8ed3074c92b$export$7b0a31e10bbff018)(layerExtent, frameState.extent));
    }
    /**
   * Get the attributions of the source of this layer for the given view.
   * @param {View|import("../View.js").ViewStateLayerStateExtent} [view] View or {@link import("../Map.js").FrameState}.
   * Only required when the layer is not added to a map.
   * @return {Array<string>} Attributions for this layer at the given view.
   * @api
   */ getAttributions(view) {
        if (!this.isVisible(view)) return [];
        const getAttributions = this.getSource()?.getAttributions();
        if (!getAttributions) return [];
        const frameState = view instanceof (0, $70364d0195659942$export$2e2bcd8739ae039) ? view.getViewStateAndExtent() : view;
        let attributions = getAttributions(frameState);
        if (!Array.isArray(attributions)) attributions = [
            attributions
        ];
        return attributions;
    }
    /**
   * In charge to manage the rendering of the layer. One layer type is
   * bounded with one layer renderer.
   * @param {?import("../Map.js").FrameState} frameState Frame state.
   * @param {HTMLElement} target Target which the renderer may (but need not) use
   * for rendering its content.
   * @return {HTMLElement|null} The rendered element.
   */ render(frameState, target) {
        const layerRenderer = this.getRenderer();
        if (layerRenderer.prepareFrame(frameState)) {
            this.rendered = true;
            return layerRenderer.renderFrame(frameState, target);
        }
        return null;
    }
    /**
   * Called when a layer is not visible during a map render.
   */ unrender() {
        this.rendered = false;
    }
    /** @return {string} Declutter */ getDeclutter() {
        return undefined;
    }
    /**
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @param {import("../layer/Layer.js").State} layerState Layer state.
   */ renderDeclutter(frameState, layerState) {}
    /**
   * When the renderer follows a layout -> render approach, do the final rendering here.
   * @param {import('../Map.js').FrameState} frameState Frame state
   */ renderDeferred(frameState) {
        const layerRenderer = this.getRenderer();
        if (!layerRenderer) return;
        layerRenderer.renderDeferred(frameState);
    }
    /**
   * For use inside the library only.
   * @param {import("../Map.js").default|null} map Map.
   */ setMapInternal(map) {
        if (!map) this.unrender();
        this.set((0, $f6d1853b3fcae320$export$2e2bcd8739ae039).MAP, map);
    }
    /**
   * For use inside the library only.
   * @return {import("../Map.js").default|null} Map.
   */ getMapInternal() {
        return this.get((0, $f6d1853b3fcae320$export$2e2bcd8739ae039).MAP);
    }
    /**
   * Sets the layer to be rendered on top of other layers on a map. The map will
   * not manage this layer in its layers collection. This
   * is useful for temporary layers. To remove an unmanaged layer from the map,
   * use `#setMap(null)`.
   *
   * To add the layer to a map and have it managed by the map, use
   * {@link module:ol/Map~Map#addLayer} instead.
   * @param {import("../Map.js").default|null} map Map.
   * @api
   */ setMap(map) {
        if (this.mapPrecomposeKey_) {
            (0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921)(this.mapPrecomposeKey_);
            this.mapPrecomposeKey_ = null;
        }
        if (!map) this.changed();
        if (this.mapRenderKey_) {
            (0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921)(this.mapRenderKey_);
            this.mapRenderKey_ = null;
        }
        if (map) {
            this.mapPrecomposeKey_ = (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(map, (0, $f5e92a4d985a2824$export$2e2bcd8739ae039).PRECOMPOSE, this.handlePrecompose_, this);
            this.mapRenderKey_ = (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(this, (0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE, map.render, map);
            this.changed();
        }
    }
    /**
   * @param {import("../events/Event.js").default} renderEvent Render event
   * @private
   */ handlePrecompose_(renderEvent) {
        const layerStatesArray = /** @type {import("../render/Event.js").default} */ renderEvent.frameState.layerStatesArray;
        const layerState = this.getLayerState(false);
        (0, $35d5ec884318008e$export$a7a9523472993e97)(!layerStatesArray.some((arrayLayerState)=>arrayLayerState.layer === layerState.layer), 'A layer can only be added to the map once. Use either `layer.setMap()` or `map.addLayer()`, not both.');
        layerStatesArray.push(layerState);
    }
    /**
   * Set the layer source.
   * @param {SourceType|null} source The layer source.
   * @observable
   * @api
   */ setSource(source) {
        this.set((0, $f6d1853b3fcae320$export$2e2bcd8739ae039).SOURCE, source);
    }
    /**
   * Get the renderer for this layer.
   * @return {RendererType|null} The layer renderer.
   */ getRenderer() {
        if (!this.renderer_) this.renderer_ = this.createRenderer();
        return this.renderer_;
    }
    /**
   * @return {boolean} The layer has a renderer.
   */ hasRenderer() {
        return !!this.renderer_;
    }
    /**
   * Create a renderer for this layer.
   * @return {RendererType} A layer renderer.
   * @protected
   */ createRenderer() {
        return null;
    }
    /**
   * This will clear the renderer so that a new one can be created next time it is needed
   */ clearRenderer() {
        if (this.renderer_) {
            this.renderer_.dispose();
            delete this.renderer_;
        }
    }
    /**
   * Clean up.
   * @override
   */ disposeInternal() {
        this.clearRenderer();
        this.setSource(null);
        super.disposeInternal();
    }
}
function $534f30fce11effcd$export$acb1e9cb9ce4ca56(layerState, viewState) {
    if (!layerState.visible) return false;
    const resolution = viewState.resolution;
    if (resolution < layerState.minResolution || resolution >= layerState.maxResolution) return false;
    const zoom = viewState.zoom;
    return zoom > layerState.minZoom && zoom <= layerState.maxZoom;
}
var $534f30fce11effcd$export$2e2bcd8739ae039 = $534f30fce11effcd$var$Layer;





/**
 * @module ol/renderer/Composite
 */ 



/**
 * @module ol/layer/BaseVector
 */ var $176ca75ee9f69668$exports = {};
!function(t, i) {
    $176ca75ee9f69668$exports = i();
}($176ca75ee9f69668$exports, function() {
    "use strict";
    function t(e, h, r = 0, s = e.length - 1, a = n) {
        for(; s > r;){
            if (s - r > 600) {
                const i = s - r + 1, n = h - r + 1, o = Math.log(i), l = .5 * Math.exp(2 * o / 3), c = .5 * Math.sqrt(o * l * (i - l) / i) * (n - i / 2 < 0 ? -1 : 1);
                t(e, h, Math.max(r, Math.floor(h - n * l / i + c)), Math.min(s, Math.floor(h + (i - n) * l / i + c)), a);
            }
            const n = e[h];
            let o = r, l = s;
            for(i(e, r, h), a(e[s], n) > 0 && i(e, r, s); o < l;){
                for(i(e, o, l), o++, l--; a(e[o], n) < 0;)o++;
                for(; a(e[l], n) > 0;)l--;
            }
            0 === a(e[r], n) ? i(e, r, l) : (l++, i(e, l, s)), l <= h && (r = l + 1), h <= l && (s = l - 1);
        }
    }
    function i(t, i, n) {
        const e = t[i];
        t[i] = t[n], t[n] = e;
    }
    function n(t, i) {
        return t < i ? -1 : t > i ? 1 : 0;
    }
    function e(t, i, n) {
        if (!n) return i.indexOf(t);
        for(let e = 0; e < i.length; e++)if (n(t, i[e])) return e;
        return -1;
    }
    function h(t, i) {
        r(t, 0, t.children.length, i, t);
    }
    function r(t, i, n, e, h) {
        h || (h = d(null)), h.minX = 1 / 0, h.minY = 1 / 0, h.maxX = -1 / 0, h.maxY = -1 / 0;
        for(let r = i; r < n; r++){
            const i = t.children[r];
            s(h, t.leaf ? e(i) : i);
        }
        return h;
    }
    function s(t, i) {
        return t.minX = Math.min(t.minX, i.minX), t.minY = Math.min(t.minY, i.minY), t.maxX = Math.max(t.maxX, i.maxX), t.maxY = Math.max(t.maxY, i.maxY), t;
    }
    function a(t, i) {
        return t.minX - i.minX;
    }
    function o(t, i) {
        return t.minY - i.minY;
    }
    function l(t) {
        return (t.maxX - t.minX) * (t.maxY - t.minY);
    }
    function c(t) {
        return t.maxX - t.minX + (t.maxY - t.minY);
    }
    function m(t, i) {
        const n = Math.max(t.minX, i.minX), e = Math.max(t.minY, i.minY), h = Math.min(t.maxX, i.maxX), r = Math.min(t.maxY, i.maxY);
        return Math.max(0, h - n) * Math.max(0, r - e);
    }
    function f(t, i) {
        return t.minX <= i.minX && t.minY <= i.minY && i.maxX <= t.maxX && i.maxY <= t.maxY;
    }
    function u(t, i) {
        return i.minX <= t.maxX && i.minY <= t.maxY && i.maxX >= t.minX && i.maxY >= t.minY;
    }
    function d(t) {
        return {
            children: t,
            height: 1,
            leaf: !0,
            minX: 1 / 0,
            minY: 1 / 0,
            maxX: -1 / 0,
            maxY: -1 / 0
        };
    }
    function x(i, n, e, h, r) {
        const s = [
            n,
            e
        ];
        for(; s.length;){
            if ((e = s.pop()) - (n = s.pop()) <= h) continue;
            const a = n + Math.ceil((e - n) / h / 2) * h;
            t(i, a, n, e, r), s.push(n, a, a, e);
        }
    }
    return class {
        constructor(t = 9){
            this._maxEntries = Math.max(4, t), this._minEntries = Math.max(2, Math.ceil(.4 * this._maxEntries)), this.clear();
        }
        all() {
            return this._all(this.data, []);
        }
        search(t) {
            let i = this.data;
            const n = [];
            if (!u(t, i)) return n;
            const e = this.toBBox, h = [];
            for(; i;){
                for(let r = 0; r < i.children.length; r++){
                    const s = i.children[r], a = i.leaf ? e(s) : s;
                    u(t, a) && (i.leaf ? n.push(s) : f(t, a) ? this._all(s, n) : h.push(s));
                }
                i = h.pop();
            }
            return n;
        }
        collides(t) {
            let i = this.data;
            if (!u(t, i)) return !1;
            const n = [];
            for(; i;){
                for(let e = 0; e < i.children.length; e++){
                    const h = i.children[e], r = i.leaf ? this.toBBox(h) : h;
                    if (u(t, r)) {
                        if (i.leaf || f(t, r)) return !0;
                        n.push(h);
                    }
                }
                i = n.pop();
            }
            return !1;
        }
        load(t) {
            if (!t || !t.length) return this;
            if (t.length < this._minEntries) {
                for(let i = 0; i < t.length; i++)this.insert(t[i]);
                return this;
            }
            let i = this._build(t.slice(), 0, t.length - 1, 0);
            if (this.data.children.length) {
                if (this.data.height === i.height) this._splitRoot(this.data, i);
                else {
                    if (this.data.height < i.height) {
                        const t = this.data;
                        this.data = i, i = t;
                    }
                    this._insert(i, this.data.height - i.height - 1, !0);
                }
            } else this.data = i;
            return this;
        }
        insert(t) {
            return t && this._insert(t, this.data.height - 1), this;
        }
        clear() {
            return this.data = d([]), this;
        }
        remove(t, i) {
            if (!t) return this;
            let n = this.data;
            const h = this.toBBox(t), r = [], s = [];
            let a, o, l;
            for(; n || r.length;){
                if (n || (n = r.pop(), o = r[r.length - 1], a = s.pop(), l = !0), n.leaf) {
                    const h = e(t, n.children, i);
                    if (-1 !== h) return n.children.splice(h, 1), r.push(n), this._condense(r), this;
                }
                l || n.leaf || !f(n, h) ? o ? (a++, n = o.children[a], l = !1) : n = null : (r.push(n), s.push(a), a = 0, o = n, n = n.children[0]);
            }
            return this;
        }
        toBBox(t) {
            return t;
        }
        compareMinX(t, i) {
            return t.minX - i.minX;
        }
        compareMinY(t, i) {
            return t.minY - i.minY;
        }
        toJSON() {
            return this.data;
        }
        fromJSON(t) {
            return this.data = t, this;
        }
        _all(t, i) {
            const n = [];
            for(; t;)t.leaf ? i.push(...t.children) : n.push(...t.children), t = n.pop();
            return i;
        }
        _build(t, i, n, e) {
            const r = n - i + 1;
            let s, a = this._maxEntries;
            if (r <= a) return s = d(t.slice(i, n + 1)), h(s, this.toBBox), s;
            e || (e = Math.ceil(Math.log(r) / Math.log(a)), a = Math.ceil(r / Math.pow(a, e - 1))), s = d([]), s.leaf = !1, s.height = e;
            const o = Math.ceil(r / a), l = o * Math.ceil(Math.sqrt(a));
            x(t, i, n, l, this.compareMinX);
            for(let h = i; h <= n; h += l){
                const i = Math.min(h + l - 1, n);
                x(t, h, i, o, this.compareMinY);
                for(let n = h; n <= i; n += o){
                    const h = Math.min(n + o - 1, i);
                    s.children.push(this._build(t, n, h, e - 1));
                }
            }
            return h(s, this.toBBox), s;
        }
        _chooseSubtree(t, i, n, e) {
            for(; e.push(i), !i.leaf && e.length - 1 !== n;){
                let n, e = 1 / 0, s = 1 / 0;
                for(let a = 0; a < i.children.length; a++){
                    const o = i.children[a], c = l(o), m = (h = t, r = o, (Math.max(r.maxX, h.maxX) - Math.min(r.minX, h.minX)) * (Math.max(r.maxY, h.maxY) - Math.min(r.minY, h.minY)) - c);
                    m < s ? (s = m, e = c < e ? c : e, n = o) : m === s && c < e && (e = c, n = o);
                }
                i = n || i.children[0];
            }
            var h, r;
            return i;
        }
        _insert(t, i, n) {
            const e = n ? t : this.toBBox(t), h = [], r = this._chooseSubtree(e, this.data, i, h);
            for(r.children.push(t), s(r, e); i >= 0 && h[i].children.length > this._maxEntries;)this._split(h, i), i--;
            this._adjustParentBBoxes(e, h, i);
        }
        _split(t, i) {
            const n = t[i], e = n.children.length, r = this._minEntries;
            this._chooseSplitAxis(n, r, e);
            const s = this._chooseSplitIndex(n, r, e), a = d(n.children.splice(s, n.children.length - s));
            a.height = n.height, a.leaf = n.leaf, h(n, this.toBBox), h(a, this.toBBox), i ? t[i - 1].children.push(a) : this._splitRoot(n, a);
        }
        _splitRoot(t, i) {
            this.data = d([
                t,
                i
            ]), this.data.height = t.height + 1, this.data.leaf = !1, h(this.data, this.toBBox);
        }
        _chooseSplitIndex(t, i, n) {
            let e, h = 1 / 0, s = 1 / 0;
            for(let a = i; a <= n - i; a++){
                const i = r(t, 0, a, this.toBBox), o = r(t, a, n, this.toBBox), c = m(i, o), f = l(i) + l(o);
                c < h ? (h = c, e = a, s = f < s ? f : s) : c === h && f < s && (s = f, e = a);
            }
            return e || n - i;
        }
        _chooseSplitAxis(t, i, n) {
            const e = t.leaf ? this.compareMinX : a, h = t.leaf ? this.compareMinY : o;
            this._allDistMargin(t, i, n, e) < this._allDistMargin(t, i, n, h) && t.children.sort(e);
        }
        _allDistMargin(t, i, n, e) {
            t.children.sort(e);
            const h = this.toBBox, a = r(t, 0, i, h), o = r(t, n - i, n, h);
            let l = c(a) + c(o);
            for(let e = i; e < n - i; e++){
                const i = t.children[e];
                s(a, t.leaf ? h(i) : i), l += c(a);
            }
            for(let e = n - i - 1; e >= i; e--){
                const i = t.children[e];
                s(o, t.leaf ? h(i) : i), l += c(o);
            }
            return l;
        }
        _adjustParentBBoxes(t, i, n) {
            for(let e = n; e >= 0; e--)s(i[e], t);
        }
        _condense(t) {
            for(let i, n = t.length - 1; n >= 0; n--)0 === t[n].children.length ? n > 0 ? (i = t[n - 1].children, i.splice(i.indexOf(t[n]), 1)) : this.clear() : h(t[n], this.toBBox);
        }
    };
});


/**
 * @module ol/render/canvas/style
 */ /**
 * @module ol/color
 */ 

const $322346e1ff7894ca$export$6c844c64a5efe1ee = [
    NaN,
    NaN,
    NaN,
    0
];
let $322346e1ff7894ca$var$colorParseContext;
/**
 * @return {CanvasRenderingContext2D} The color parse context
 */ function $322346e1ff7894ca$var$getColorParseContext() {
    if (!$322346e1ff7894ca$var$colorParseContext) $322346e1ff7894ca$var$colorParseContext = (0, $075f937d7366f1a2$export$9e05d10eae75c464)(1, 1, undefined, {
        willReadFrequently: true,
        desynchronized: true
    });
    return $322346e1ff7894ca$var$colorParseContext;
}
const $322346e1ff7894ca$var$rgbModernRegEx = /^rgba?\(\s*(\d+%?)\s+(\d+%?)\s+(\d+%?)(?:\s*\/\s*(\d+%|\d*\.\d+|[01]))?\s*\)$/i;
const $322346e1ff7894ca$var$rgbLegacyAbsoluteRegEx = /^rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)(?:\s*,\s*(\d+%|\d*\.\d+|[01]))?\s*\)$/i;
const $322346e1ff7894ca$var$rgbLegacyPercentageRegEx = /^rgba?\(\s*(\d+%)\s*,\s*(\d+%)\s*,\s*(\d+%)(?:\s*,\s*(\d+%|\d*\.\d+|[01]))?\s*\)$/i;
const $322346e1ff7894ca$var$hexRegEx = /^#([\da-f]{3,4}|[\da-f]{6}|[\da-f]{8})$/i;
/**
 * @param {string} s Color component as number or percentage.
 * @param {number} divider Divider for percentage.
 * @return {number} Color component.
 */ function $322346e1ff7894ca$var$toColorComponent(s, divider) {
    return s.endsWith('%') ? Number(s.substring(0, s.length - 1)) / divider : Number(s);
}
/**
 * @param {string} color Color string.
 */ function $322346e1ff7894ca$var$throwInvalidColor(color) {
    throw new Error('failed to parse "' + color + '" as color');
}
/**
 * @param {string} color Color string.
 * @return {Color} RGBa color array.
 */ function $322346e1ff7894ca$var$parseRgba(color) {
    // Fast lane for rgb(a) colors
    if (color.toLowerCase().startsWith('rgb')) {
        const rgb = color.match($322346e1ff7894ca$var$rgbLegacyAbsoluteRegEx) || color.match($322346e1ff7894ca$var$rgbModernRegEx) || color.match($322346e1ff7894ca$var$rgbLegacyPercentageRegEx);
        if (rgb) {
            const alpha = rgb[4];
            const rgbDivider = 100 / 255;
            return [
                (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)($322346e1ff7894ca$var$toColorComponent(rgb[1], rgbDivider) + 0.5 | 0, 0, 255),
                (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)($322346e1ff7894ca$var$toColorComponent(rgb[2], rgbDivider) + 0.5 | 0, 0, 255),
                (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)($322346e1ff7894ca$var$toColorComponent(rgb[3], rgbDivider) + 0.5 | 0, 0, 255),
                alpha !== undefined ? (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)($322346e1ff7894ca$var$toColorComponent(alpha, 100), 0, 1) : 1
            ];
        }
        $322346e1ff7894ca$var$throwInvalidColor(color);
    }
    // Fast lane for hex colors (also with alpha)
    if (color.startsWith('#')) {
        if ($322346e1ff7894ca$var$hexRegEx.test(color)) {
            const hex = color.substring(1);
            const step = hex.length <= 4 ? 1 : 2;
            const colorFromHex = [
                0,
                0,
                0,
                255
            ];
            for(let i = 0, ii = hex.length; i < ii; i += step){
                let colorComponent = parseInt(hex.substring(i, i + step), 16);
                if (step === 1) colorComponent += colorComponent << 4;
                colorFromHex[i / step] = colorComponent;
            }
            colorFromHex[3] = colorFromHex[3] / 255;
            return colorFromHex;
        }
        $322346e1ff7894ca$var$throwInvalidColor(color);
    }
    // Use canvas color serialization to parse the color into hex or rgba
    // See https://www.w3.org/TR/2021/SPSD-2dcontext-20210128/#serialization-of-a-color
    const context = $322346e1ff7894ca$var$getColorParseContext();
    context.fillStyle = '#abcdef';
    let invalidCheckFillStyle = context.fillStyle;
    context.fillStyle = color;
    if (context.fillStyle === invalidCheckFillStyle) {
        context.fillStyle = '#fedcba';
        invalidCheckFillStyle = context.fillStyle;
        context.fillStyle = color;
        if (context.fillStyle === invalidCheckFillStyle) $322346e1ff7894ca$var$throwInvalidColor(color);
    }
    const colorString = context.fillStyle;
    if (colorString.startsWith('#') || colorString.startsWith('rgba')) return $322346e1ff7894ca$var$parseRgba(colorString);
    context.clearRect(0, 0, 1, 1);
    context.fillRect(0, 0, 1, 1);
    const colorFromImage = Array.from(context.getImageData(0, 0, 1, 1).data);
    colorFromImage[3] = (0, $6b000a049d919fe5$export$a81f732198733497)(colorFromImage[3] / 255, 3);
    return colorFromImage;
}
function $322346e1ff7894ca$export$590567be997858b6(color) {
    if (typeof color === 'string') return color;
    return $322346e1ff7894ca$export$f84e8e69fd4488a5(color);
}
/**
 * @type {number}
 */ const $322346e1ff7894ca$var$MAX_CACHE_SIZE = 1024;
/**
 * We maintain a small cache of parsed strings.  Whenever the cache grows too large,
 * we delete an arbitrary set of the entries.
 *
 * @type {Object<string, Color>}
 */ const $322346e1ff7894ca$var$cache = {};
/**
 * @type {number}
 */ let $322346e1ff7894ca$var$cacheSize = 0;
function $322346e1ff7894ca$export$138c09bdd6bd797c(color) {
    if (color.length === 4) return color;
    const output = color.slice();
    output[3] = 1;
    return output;
}
// The functions b1, b2, a1, a2, rgbaToLcha and lchaToRgba below are adapted from
// https://stackoverflow.com/a/67219995/2389327
/**
 * @param {number} v Input value.
 * @return {number} Output value.
 */ function $322346e1ff7894ca$var$b1(v) {
    return v > 0.0031308 ? Math.pow(v, 1 / 2.4) * 269.025 - 14.025 : v * 3294.6;
}
/**
 * @param {number} v Input value.
 * @return {number} Output value.
 */ function $322346e1ff7894ca$var$b2(v) {
    return v > 0.2068965 ? Math.pow(v, 3) : (v - 4 / 29) * (108 / 841);
}
/**
 * @param {number} v Input value.
 * @return {number} Output value.
 */ function $322346e1ff7894ca$var$a1(v) {
    return v > 10.314724 ? Math.pow((v + 14.025) / 269.025, 2.4) : v / 3294.6;
}
/**
 * @param {number} v Input value.
 * @return {number} Output value.
 */ function $322346e1ff7894ca$var$a2(v) {
    return v > 0.0088564 ? Math.pow(v, 1 / 3) : v / (108 / 841) + 4 / 29;
}
function $322346e1ff7894ca$export$44fb54fa2e0c0d4(color) {
    const r = $322346e1ff7894ca$var$a1(color[0]);
    const g = $322346e1ff7894ca$var$a1(color[1]);
    const b = $322346e1ff7894ca$var$a1(color[2]);
    const y = $322346e1ff7894ca$var$a2(r * 0.222488403 + g * 0.716873169 + b * 0.06060791);
    const l = 500 * ($322346e1ff7894ca$var$a2(r * 0.452247074 + g * 0.399439023 + b * 0.148375274) - y);
    const q = 200 * (y - $322346e1ff7894ca$var$a2(r * 0.016863605 + g * 0.117638439 + b * 0.865350722));
    const h = Math.atan2(q, l) * (180 / Math.PI);
    return [
        116 * y - 16,
        Math.sqrt(l * l + q * q),
        h < 0 ? h + 360 : h,
        color[3]
    ];
}
function $322346e1ff7894ca$export$27cc94530c050f00(color) {
    const l = (color[0] + 16) / 116;
    const c = color[1];
    const h = color[2] * Math.PI / 180;
    const y = $322346e1ff7894ca$var$b2(l);
    const x = $322346e1ff7894ca$var$b2(l + c / 500 * Math.cos(h));
    const z = $322346e1ff7894ca$var$b2(l - c / 200 * Math.sin(h));
    const r = $322346e1ff7894ca$var$b1(x * 3.021973625 - y * 1.617392459 - z * 0.404875592);
    const g = $322346e1ff7894ca$var$b1(x * -0.943766287 + y * 1.916279586 + z * 0.027607165);
    const b = $322346e1ff7894ca$var$b1(x * 0.069407491 - y * 0.22898585 + z * 1.159737864);
    return [
        (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(r + 0.5 | 0, 0, 255),
        (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(g + 0.5 | 0, 0, 255),
        (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(b + 0.5 | 0, 0, 255),
        color[3]
    ];
}
function $322346e1ff7894ca$export$3004f64547af360e(s) {
    if (s === 'none') return $322346e1ff7894ca$export$6c844c64a5efe1ee;
    if ($322346e1ff7894ca$var$cache.hasOwnProperty(s)) return $322346e1ff7894ca$var$cache[s];
    if ($322346e1ff7894ca$var$cacheSize >= $322346e1ff7894ca$var$MAX_CACHE_SIZE) {
        let i = 0;
        for(const key in $322346e1ff7894ca$var$cache)if ((i++ & 3) === 0) {
            delete $322346e1ff7894ca$var$cache[key];
            --$322346e1ff7894ca$var$cacheSize;
        }
    }
    const color = $322346e1ff7894ca$var$parseRgba(s);
    if (color.length !== 4) $322346e1ff7894ca$var$throwInvalidColor(s);
    for (const c of color)if (isNaN(c)) $322346e1ff7894ca$var$throwInvalidColor(s);
    $322346e1ff7894ca$var$cache[s] = color;
    ++$322346e1ff7894ca$var$cacheSize;
    return color;
}
function $322346e1ff7894ca$export$75093a47a9fa838d(color) {
    if (Array.isArray(color)) return color;
    return $322346e1ff7894ca$export$3004f64547af360e(color);
}
function $322346e1ff7894ca$export$f84e8e69fd4488a5(color) {
    let r = color[0];
    if (r != (r | 0)) r = r + 0.5 | 0;
    let g = color[1];
    if (g != (g | 0)) g = g + 0.5 | 0;
    let b = color[2];
    if (b != (b | 0)) b = b + 0.5 | 0;
    const a = color[3] === undefined ? 1 : Math.round(color[3] * 1000) / 1000;
    return 'rgba(' + r + ',' + g + ',' + b + ',' + a + ')';
}
function $322346e1ff7894ca$export$40dd713d7775a0b1(s) {
    try {
        $322346e1ff7894ca$export$3004f64547af360e(s);
        return true;
    } catch  {
        return false;
    }
}


/**
 * @module ol/expr/cpu
 */ 
/**
 * @module ol/expr/expression
 */ 

/**
 * @module ol/size
 */ /**
 * An array of numbers representing a size: `[width, height]`.
 * @typedef {Array<number>} Size
 * @api
 */ /**
 * Returns a buffered size.
 * @param {Size} size Size.
 * @param {number} num The amount by which to buffer.
 * @param {Size} [dest] Optional reusable size array.
 * @return {Size} The buffered size.
 */ function $cc435a5409103773$export$ab1029bcae9ddb4a(size, num, dest) {
    if (dest === undefined) dest = [
        0,
        0
    ];
    dest[0] = size[0] + 2 * num;
    dest[1] = size[1] + 2 * num;
    return dest;
}
function $cc435a5409103773$export$622c471beb1693c7(size) {
    return size[0] > 0 && size[1] > 0;
}
function $cc435a5409103773$export$dcdf75081b88279d(size, ratio, dest) {
    if (dest === undefined) dest = [
        0,
        0
    ];
    dest[0] = size[0] * ratio + 0.5 | 0;
    dest[1] = size[1] * ratio + 0.5 | 0;
    return dest;
}
function $cc435a5409103773$export$a71a825ff42fb8e1(size, dest) {
    if (Array.isArray(size)) return size;
    if (dest === undefined) dest = [
        size,
        size
    ];
    else {
        dest[0] = size;
        dest[1] = size;
    }
    return dest;
}


/**
 * @fileoverview This module includes types and functions for parsing array encoded expressions.
 * The result of parsing an encoded expression is one of the specific expression classes.
 * During parsing, information is added to the parsing context about the data accessed by the
 * expression.
 */ /**
 * Base type used for literal style parameters; can be a number literal or the output of an operator,
 * which in turns takes {@link import("./expression.js").ExpressionValue} arguments.
 *
 * See below for details on the available operators (with notes for those that are WebGL or Canvas only).
 *
 * Reading operators:
 *   * `['band', bandIndex, xOffset, yOffset]` For tile layers only. Fetches pixel values from band
 *     `bandIndex` of the source's data. The first `bandIndex` of the source data is `1`. Fetched values
 *     are in the 0..1 range. {@link import("../source/TileImage.js").default} sources have 4 bands: red,
 *     green, blue and alpha. {@link import("../source/DataTile.js").default} sources can have any number
 *     of bands, depending on the underlying data source and
 *     {@link import("../source/GeoTIFF.js").Options configuration}. `xOffset` and `yOffset` are optional
 *     and allow specifying pixel offsets for x and y. This is used for sampling data from neighboring pixels (WebGL only).
 *   * `['get', attributeName]` fetches a feature property value, similar to `feature.get('attributeName')`.
 *   * `['get', attributeName, keyOrArrayIndex, ...]` (Canvas only) Access nested properties and array items of a
 *     feature property. The result is `undefined` when there is nothing at the specified key or index.
 *   * `['geometry-type']` returns a feature's geometry type as string, either: 'LineString', 'Point' or 'Polygon'
 *     `Multi*` values are returned as their singular equivalent
 *     `Circle` geometries are returned as 'Polygon'
 *     `GeometryCollection` geometries are returned as the type of the first geometry found in the collection (WebGL only).
 *   * `['resolution']` returns the current resolution
 *   * `['time']` The time in seconds since the creation of the layer (WebGL only).
 *   * `['var', 'varName']` fetches a value from the style variables; will throw an error if that variable is undefined
 *   * `['zoom']` The current zoom level (WebGL only).
 *   * `['line-metric']` returns the M component of the current point on a line (WebGL only); in case where the geometry layout of the line
 *      does not contain an M component (e.g. XY or XYZ), 0 is returned; 0 is also returned for geometries other than lines.
 *      Please note that the M component will be linearly interpolated between the two points composing a segment.
 *
 * Math operators:
 *   * `['*', value1, value2, ...]` multiplies the values (either numbers or colors)
 *   * `['/', value1, value2]` divides `value1` by `value2`
 *   * `['+', value1, value2, ...]` adds the values
 *   * `['-', value1, value2]` subtracts `value2` from `value1`
 *   * `['clamp', value, low, high]` clamps `value` between `low` and `high`
 *   * `['%', value1, value2]` returns the result of `value1 % value2` (modulo)
 *   * `['^', value1, value2]` returns the value of `value1` raised to the `value2` power
 *   * `['abs', value1]` returns the absolute value of `value1`
 *   * `['floor', value1]` returns the nearest integer less than or equal to `value1`
 *   * `['round', value1]` returns the nearest integer to `value1`
 *   * `['ceil', value1]` returns the nearest integer greater than or equal to `value1`
 *   * `['sin', value1]` returns the sine of `value1`
 *   * `['cos', value1]` returns the cosine of `value1`
 *   * `['atan', value1, value2]` returns `atan2(value1, value2)`. If `value2` is not provided, returns `atan(value1)`
 *   * `['sqrt', value1]` returns the square root of `value1`
 *
 * * Transform operators:
 *   * `['case', condition1, output1, ...conditionN, outputN, fallback]` selects the first output whose corresponding
 *     condition evaluates to `true`. If no match is found, returns the `fallback` value.
 *     All conditions should be `boolean`, output and fallback can be any kind.
 *   * `['match', input, match1, output1, ...matchN, outputN, fallback]` compares the `input` value against all
 *     provided `matchX` values, returning the output associated with the first valid match. If no match is found,
 *     returns the `fallback` value.
 *     `input` and `matchX` values must all be of the same type, and can be `number` or `string`. `outputX` and
 *     `fallback` values must be of the same type, and can be of any kind.
 *   * `['interpolate', interpolation, input, stop1, output1, ...stopN, outputN]` returns a value by interpolating between
 *     pairs of inputs and outputs; `interpolation` can either be `['linear']` or `['exponential', base]` where `base` is
 *     the rate of increase from stop A to stop B (i.e. power to which the interpolation ratio is raised); a value
 *     of 1 is equivalent to `['linear']`.
 *     `input` and `stopX` values must all be of type `number`. `outputX` values can be `number` or `color` values.
 *     Note: `input` will be clamped between `stop1` and `stopN`, meaning that all output values will be comprised
 *     between `output1` and `outputN`.
 *   * `['string', value1, value2, ...]` returns the first value in the list that evaluates to a string.
 *     An example would be to provide a default value for get: `['string', ['get', 'propertyname'], 'default value']]`
 *     (Canvas only).
 *   * `['number', value1, value2, ...]` returns the first value in the list that evaluates to a number.
 *     An example would be to provide a default value for get: `['string', ['get', 'propertyname'], 42]]`
 *     (Canvas only).
 *   * `['coalesce', value1, value2, ...]` returns the first value in the list which is not null or undefined.
 *     An example would be to provide a default value for get: `['coalesce', ['get','propertyname'], 'default value']]`
 *     (Canvas only).
 *
 * * Logical operators:
 *   * `['<', value1, value2]` returns `true` if `value1` is strictly lower than `value2`, or `false` otherwise.
 *   * `['<=', value1, value2]` returns `true` if `value1` is lower than or equals `value2`, or `false` otherwise.
 *   * `['>', value1, value2]` returns `true` if `value1` is strictly greater than `value2`, or `false` otherwise.
 *   * `['>=', value1, value2]` returns `true` if `value1` is greater than or equals `value2`, or `false` otherwise.
 *   * `['==', value1, value2]` returns `true` if `value1` equals `value2`, or `false` otherwise.
 *   * `['!=', value1, value2]` returns `true` if `value1` does not equal `value2`, or `false` otherwise.
 *   * `['!', value1]` returns `false` if `value1` is `true` or greater than `0`, or `true` otherwise.
 *   * `['all', value1, value2, ...]` returns `true` if all the inputs are `true`, `false` otherwise.
 *   * `['any', value1, value2, ...]` returns `true` if any of the inputs are `true`, `false` otherwise.
 *   * `['has', attributeName, keyOrArrayIndex, ...]` returns `true` if feature properties include the (nested) key `attributeName`,
 *     `false` otherwise.
 *     Note that for WebGL layers, the hardcoded value `-9999999` is used to distinguish when a property is not defined.
 *   * `['between', value1, value2, value3]` returns `true` if `value1` is contained between `value2` and `value3`
 *     (inclusively), or `false` otherwise.
 *   * `['in', needle, haystack]` returns `true` if `needle` is found in `haystack`, and
 *     `false` otherwise.
 *     This operator has the following limitations:
 *     * `haystack` has to be an array of numbers or strings (searching for a substring in a string is not supported yet)
 *     * Only literal arrays are supported as `haystack` for now; this means that `haystack` cannot be the result of an
 *     expression. If `haystack` is an array of strings, use the `literal` operator to disambiguate from an expression:
 *     `['literal', ['abc', 'def', 'ghi']]`
 *
 * * Conversion operators:
 *   * `['array', value1, ...valueN]` creates a numerical array from `number` values; please note that the amount of
 *     values can currently only be 2, 3 or 4 (WebGL only).
 *   * `['color', red, green, blue, alpha]` or `['color', shade, alpha]` creates a `color` value from `number` values;
 *     the `alpha` parameter is optional; if not specified, it will be set to 1 (WebGL only).
 *     Note: `red`, `green` and `blue` or `shade` components must be values between 0 and 255; `alpha` between 0 and 1.
 *   * `['palette', index, colors]` picks a `color` value from an array of colors using the given index; the `index`
 *     expression must evaluate to a number; the items in the `colors` array must be strings with hex colors
 *     (e.g. `'#86A136'`), colors using the rgba[a] functional notation (e.g. `'rgb(134, 161, 54)'` or `'rgba(134, 161, 54, 1)'`),
 *     named colors (e.g. `'red'`), or array literals with 3 ([r, g, b]) or 4 ([r, g, b, a]) values (with r, g, and b
 *     in the 0-255 range and a in the 0-1 range) (WebGL only).
 *   * `['to-string', value]` converts the input value to a string. If the input is a boolean, the result is "true" or "false".
 *     If the input is a number, it is converted to a string as specified by the "NumberToString" algorithm of the ECMAScript
 *     Language Specification. If the input is a color, it is converted to a string of the form "rgba(r,g,b,a)". (Canvas only)
 *
 * Values can either be literals or another operator, as they will be evaluated recursively.
 * Literal values can be of the following types:
 * * `boolean`
 * * `number`
 * * `number[]` (number arrays can only have a length of 2, 3 or 4)
 * * `string`
 * * {@link module:ol/color~Color}
 *
 * @typedef {Array<*>|import("../color.js").Color|string|number|boolean} ExpressionValue
 * @api
 */ let $778943ec39690f8e$var$numTypes = 0;
const $778943ec39690f8e$export$267d7ad6fa96ffaf = 0;
const $778943ec39690f8e$export$240f7fffab1b25a0 = 1 << $778943ec39690f8e$var$numTypes++;
const $778943ec39690f8e$export$86a7aca748b1e260 = 1 << $778943ec39690f8e$var$numTypes++;
const $778943ec39690f8e$export$2b93044cbf134323 = 1 << $778943ec39690f8e$var$numTypes++;
const $778943ec39690f8e$export$2cd82751acc0e609 = 1 << $778943ec39690f8e$var$numTypes++;
const $778943ec39690f8e$export$d701d0e49f4bcb39 = 1 << $778943ec39690f8e$var$numTypes++;
const $778943ec39690f8e$export$52725c8a6d4c61d1 = 1 << $778943ec39690f8e$var$numTypes++;
const $778943ec39690f8e$export$ec4c9a150bae86cd = Math.pow(2, $778943ec39690f8e$var$numTypes) - 1;
const $778943ec39690f8e$var$typeNames = {
    [$778943ec39690f8e$export$240f7fffab1b25a0]: 'boolean',
    [$778943ec39690f8e$export$86a7aca748b1e260]: 'number',
    [$778943ec39690f8e$export$2b93044cbf134323]: 'string',
    [$778943ec39690f8e$export$2cd82751acc0e609]: 'color',
    [$778943ec39690f8e$export$d701d0e49f4bcb39]: 'number[]',
    [$778943ec39690f8e$export$52725c8a6d4c61d1]: 'size'
};
const $778943ec39690f8e$var$namedTypes = Object.keys($778943ec39690f8e$var$typeNames).map(Number).sort((0, $b998d41b678ed5d1$export$fcb633242ef15540));
/**
 * @param {number} type The type.
 * @return {boolean} The type is one of the specific types (not any or a union type).
 */ function $778943ec39690f8e$var$isSpecific(type) {
    return type in $778943ec39690f8e$var$typeNames;
}
function $778943ec39690f8e$export$b2afc7c96b2b4a45(type) {
    const names = [];
    for (const namedType of $778943ec39690f8e$var$namedTypes)if ($778943ec39690f8e$export$9fdcb8b441c4f2b4(type, namedType)) names.push($778943ec39690f8e$var$typeNames[namedType]);
    if (names.length === 0) return 'untyped';
    if (names.length < 3) return names.join(' or ');
    return names.slice(0, -1).join(', ') + ', or ' + names[names.length - 1];
}
function $778943ec39690f8e$export$9fdcb8b441c4f2b4(broad, specific) {
    return (broad & specific) === specific;
}
function $778943ec39690f8e$export$3252d368d784c970(oneType, otherType) {
    return !!(oneType & otherType);
}
function $778943ec39690f8e$export$26b9f946b448f23e(type, expected) {
    return type === expected;
}
class $778943ec39690f8e$export$eb63e96e0913dda4 {
    /**
   * @param {number} type The value type.
   * @param {LiteralValue} value The literal value.
   */ constructor(type, value){
        if (!$778943ec39690f8e$var$isSpecific(type)) throw new Error(`literal expressions must have a specific type, got ${$778943ec39690f8e$export$b2afc7c96b2b4a45(type)}`);
        this.type = type;
        this.value = value;
    }
}
class $778943ec39690f8e$export$6f3d80189eb72cd4 {
    /**
   * @param {number} type The return type.
   * @param {string} operator The operator.
   * @param {...Expression} args The arguments.
   */ constructor(type, operator, ...args){
        this.type = type;
        this.operator = operator;
        this.args = args;
    }
}
function $778943ec39690f8e$export$1c8b4c1584800354() {
    return {
        variables: new Set(),
        properties: new Set(),
        featureId: false,
        geometryType: false,
        mapState: false
    };
}
function $778943ec39690f8e$export$98e6a39c04603d36(encoded, expectedType, context) {
    switch(typeof encoded){
        case 'boolean':
            if ($778943ec39690f8e$export$26b9f946b448f23e(expectedType, $778943ec39690f8e$export$2b93044cbf134323)) return new $778943ec39690f8e$export$eb63e96e0913dda4($778943ec39690f8e$export$2b93044cbf134323, encoded ? 'true' : 'false');
            if (!$778943ec39690f8e$export$9fdcb8b441c4f2b4(expectedType, $778943ec39690f8e$export$240f7fffab1b25a0)) throw new Error(`got a boolean, but expected ${$778943ec39690f8e$export$b2afc7c96b2b4a45(expectedType)}`);
            return new $778943ec39690f8e$export$eb63e96e0913dda4($778943ec39690f8e$export$240f7fffab1b25a0, encoded);
        case 'number':
            if ($778943ec39690f8e$export$26b9f946b448f23e(expectedType, $778943ec39690f8e$export$52725c8a6d4c61d1)) return new $778943ec39690f8e$export$eb63e96e0913dda4($778943ec39690f8e$export$52725c8a6d4c61d1, (0, $cc435a5409103773$export$a71a825ff42fb8e1)(encoded));
            if ($778943ec39690f8e$export$26b9f946b448f23e(expectedType, $778943ec39690f8e$export$240f7fffab1b25a0)) return new $778943ec39690f8e$export$eb63e96e0913dda4($778943ec39690f8e$export$240f7fffab1b25a0, !!encoded);
            if ($778943ec39690f8e$export$26b9f946b448f23e(expectedType, $778943ec39690f8e$export$2b93044cbf134323)) return new $778943ec39690f8e$export$eb63e96e0913dda4($778943ec39690f8e$export$2b93044cbf134323, encoded.toString());
            if (!$778943ec39690f8e$export$9fdcb8b441c4f2b4(expectedType, $778943ec39690f8e$export$86a7aca748b1e260)) throw new Error(`got a number, but expected ${$778943ec39690f8e$export$b2afc7c96b2b4a45(expectedType)}`);
            return new $778943ec39690f8e$export$eb63e96e0913dda4($778943ec39690f8e$export$86a7aca748b1e260, encoded);
        case 'string':
            if ($778943ec39690f8e$export$26b9f946b448f23e(expectedType, $778943ec39690f8e$export$2cd82751acc0e609)) return new $778943ec39690f8e$export$eb63e96e0913dda4($778943ec39690f8e$export$2cd82751acc0e609, (0, $322346e1ff7894ca$export$3004f64547af360e)(encoded));
            if ($778943ec39690f8e$export$26b9f946b448f23e(expectedType, $778943ec39690f8e$export$240f7fffab1b25a0)) return new $778943ec39690f8e$export$eb63e96e0913dda4($778943ec39690f8e$export$240f7fffab1b25a0, !!encoded);
            if (!$778943ec39690f8e$export$9fdcb8b441c4f2b4(expectedType, $778943ec39690f8e$export$2b93044cbf134323)) throw new Error(`got a string, but expected ${$778943ec39690f8e$export$b2afc7c96b2b4a45(expectedType)}`);
            return new $778943ec39690f8e$export$eb63e96e0913dda4($778943ec39690f8e$export$2b93044cbf134323, encoded);
        default:
    }
    if (!Array.isArray(encoded)) throw new Error('expression must be an array or a primitive value');
    if (encoded.length === 0) throw new Error('empty expression');
    if (typeof encoded[0] === 'string') return $778943ec39690f8e$var$parseCallExpression(encoded, expectedType, context);
    for (const item of encoded){
        if (typeof item !== 'number') throw new Error('expected an array of numbers');
    }
    if ($778943ec39690f8e$export$26b9f946b448f23e(expectedType, $778943ec39690f8e$export$52725c8a6d4c61d1)) {
        if (encoded.length !== 2) throw new Error(`expected an array of two values for a size, got ${encoded.length}`);
        return new $778943ec39690f8e$export$eb63e96e0913dda4($778943ec39690f8e$export$52725c8a6d4c61d1, encoded);
    }
    if ($778943ec39690f8e$export$26b9f946b448f23e(expectedType, $778943ec39690f8e$export$2cd82751acc0e609)) {
        if (encoded.length === 3) return new $778943ec39690f8e$export$eb63e96e0913dda4($778943ec39690f8e$export$2cd82751acc0e609, [
            ...encoded,
            1
        ]);
        if (encoded.length === 4) return new $778943ec39690f8e$export$eb63e96e0913dda4($778943ec39690f8e$export$2cd82751acc0e609, encoded);
        throw new Error(`expected an array of 3 or 4 values for a color, got ${encoded.length}`);
    }
    if (!$778943ec39690f8e$export$9fdcb8b441c4f2b4(expectedType, $778943ec39690f8e$export$d701d0e49f4bcb39)) throw new Error(`got an array of numbers, but expected ${$778943ec39690f8e$export$b2afc7c96b2b4a45(expectedType)}`);
    return new $778943ec39690f8e$export$eb63e96e0913dda4($778943ec39690f8e$export$d701d0e49f4bcb39, encoded);
}
const $778943ec39690f8e$export$2655e45458bc48f3 = {
    Get: 'get',
    Var: 'var',
    Concat: 'concat',
    GeometryType: 'geometry-type',
    LineMetric: 'line-metric',
    Any: 'any',
    All: 'all',
    Not: '!',
    Resolution: 'resolution',
    Zoom: 'zoom',
    Time: 'time',
    Equal: '==',
    NotEqual: '!=',
    GreaterThan: '>',
    GreaterThanOrEqualTo: '>=',
    LessThan: '<',
    LessThanOrEqualTo: '<=',
    Multiply: '*',
    Divide: '/',
    Add: '+',
    Subtract: '-',
    Clamp: 'clamp',
    Mod: '%',
    Pow: '^',
    Abs: 'abs',
    Floor: 'floor',
    Ceil: 'ceil',
    Round: 'round',
    Sin: 'sin',
    Cos: 'cos',
    Atan: 'atan',
    Sqrt: 'sqrt',
    Match: 'match',
    Between: 'between',
    Interpolate: 'interpolate',
    Coalesce: 'coalesce',
    Case: 'case',
    In: 'in',
    Number: 'number',
    String: 'string',
    Array: 'array',
    Color: 'color',
    Id: 'id',
    Band: 'band',
    Palette: 'palette',
    ToString: 'to-string',
    Has: 'has'
};
/**
 * @typedef {function(Array, number, ParsingContext):Expression} Parser
 *
 * Second argument is the expected type.
 */ /**
 * @type {Object<string, Parser>}
 */ const $778943ec39690f8e$var$parsers = {
    [$778943ec39690f8e$export$2655e45458bc48f3.Get]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(1, Infinity), $778943ec39690f8e$var$withGetArgs),
    [$778943ec39690f8e$export$2655e45458bc48f3.Var]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(1, 1), $778943ec39690f8e$var$withVarArgs),
    [$778943ec39690f8e$export$2655e45458bc48f3.Has]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(1, Infinity), $778943ec39690f8e$var$withGetArgs),
    [$778943ec39690f8e$export$2655e45458bc48f3.Id]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$usesFeatureId, $778943ec39690f8e$var$withNoArgs),
    [$778943ec39690f8e$export$2655e45458bc48f3.Concat]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(2, Infinity), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$2b93044cbf134323)),
    [$778943ec39690f8e$export$2655e45458bc48f3.GeometryType]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$usesGeometryType, $778943ec39690f8e$var$withNoArgs),
    [$778943ec39690f8e$export$2655e45458bc48f3.LineMetric]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$withNoArgs),
    [$778943ec39690f8e$export$2655e45458bc48f3.Resolution]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$usesMapState, $778943ec39690f8e$var$withNoArgs),
    [$778943ec39690f8e$export$2655e45458bc48f3.Zoom]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$usesMapState, $778943ec39690f8e$var$withNoArgs),
    [$778943ec39690f8e$export$2655e45458bc48f3.Time]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$usesMapState, $778943ec39690f8e$var$withNoArgs),
    [$778943ec39690f8e$export$2655e45458bc48f3.Any]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(2, Infinity), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$240f7fffab1b25a0)),
    [$778943ec39690f8e$export$2655e45458bc48f3.All]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(2, Infinity), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$240f7fffab1b25a0)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Not]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(1, 1), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$240f7fffab1b25a0)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Equal]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(2, 2), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$ec4c9a150bae86cd)),
    [$778943ec39690f8e$export$2655e45458bc48f3.NotEqual]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(2, 2), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$ec4c9a150bae86cd)),
    [$778943ec39690f8e$export$2655e45458bc48f3.GreaterThan]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(2, 2), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.GreaterThanOrEqualTo]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(2, 2), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.LessThan]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(2, 2), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.LessThanOrEqualTo]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(2, 2), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Multiply]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(2, Infinity), $778943ec39690f8e$var$withArgsOfReturnType),
    [$778943ec39690f8e$export$2655e45458bc48f3.Coalesce]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(2, Infinity), $778943ec39690f8e$var$withArgsOfReturnType),
    [$778943ec39690f8e$export$2655e45458bc48f3.Divide]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(2, 2), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Add]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(2, Infinity), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Subtract]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(2, 2), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Clamp]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(3, 3), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Mod]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(2, 2), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Pow]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(2, 2), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Abs]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(1, 1), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Floor]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(1, 1), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Ceil]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(1, 1), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Round]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(1, 1), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Sin]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(1, 1), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Cos]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(1, 1), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Atan]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(1, 2), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Sqrt]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(1, 1), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Match]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(4, Infinity), $778943ec39690f8e$var$hasEvenArgs, $778943ec39690f8e$var$withMatchArgs),
    [$778943ec39690f8e$export$2655e45458bc48f3.Between]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(3, 3), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Interpolate]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(6, Infinity), $778943ec39690f8e$var$hasEvenArgs, $778943ec39690f8e$var$withInterpolateArgs),
    [$778943ec39690f8e$export$2655e45458bc48f3.Case]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(3, Infinity), $778943ec39690f8e$var$hasOddArgs, $778943ec39690f8e$var$withCaseArgs),
    [$778943ec39690f8e$export$2655e45458bc48f3.In]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(2, 2), $778943ec39690f8e$var$withInArgs),
    [$778943ec39690f8e$export$2655e45458bc48f3.Number]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(1, Infinity), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$ec4c9a150bae86cd)),
    [$778943ec39690f8e$export$2655e45458bc48f3.String]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(1, Infinity), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$ec4c9a150bae86cd)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Array]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(1, Infinity), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Color]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(1, 4), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Band]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(1, 3), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Palette]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(2, 2), $778943ec39690f8e$var$withPaletteArgs),
    [$778943ec39690f8e$export$2655e45458bc48f3.ToString]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(1, 1), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$240f7fffab1b25a0 | $778943ec39690f8e$export$86a7aca748b1e260 | $778943ec39690f8e$export$2b93044cbf134323 | $778943ec39690f8e$export$2cd82751acc0e609))
};
/**
 * @typedef {function(Array<EncodedExpression>, number, ParsingContext):Array<Expression>|void} ArgValidator
 *
 * An argument validator applies various checks to an encoded expression arguments and
 * returns the parsed arguments if any.  The second argument is the return type of the call expression.
 */ /**
 * @type {ArgValidator}
 */ function $778943ec39690f8e$var$withGetArgs(encoded, returnType, context) {
    const argsCount = encoded.length - 1;
    const args = new Array(argsCount);
    for(let i = 0; i < argsCount; ++i){
        const key = encoded[i + 1];
        switch(typeof key){
            case 'number':
                args[i] = new $778943ec39690f8e$export$eb63e96e0913dda4($778943ec39690f8e$export$86a7aca748b1e260, key);
                break;
            case 'string':
                args[i] = new $778943ec39690f8e$export$eb63e96e0913dda4($778943ec39690f8e$export$2b93044cbf134323, key);
                break;
            default:
                throw new Error(`expected a string key or numeric array index for a get operation, got ${key}`);
        }
        if (i === 0) context.properties.add(String(key));
    }
    return args;
}
/**
 * @type {ArgValidator}
 */ function $778943ec39690f8e$var$withVarArgs(encoded, returnType, context) {
    const name = encoded[1];
    if (typeof name !== 'string') throw new Error('expected a string argument for var operation');
    context.variables.add(name);
    return [
        new $778943ec39690f8e$export$eb63e96e0913dda4($778943ec39690f8e$export$2b93044cbf134323, name)
    ];
}
/**
 * @type {ArgValidator}
 */ function $778943ec39690f8e$var$usesFeatureId(encoded, returnType, context) {
    context.featureId = true;
}
/**
 * @type {ArgValidator}
 */ function $778943ec39690f8e$var$usesGeometryType(encoded, returnType, context) {
    context.geometryType = true;
}
/**
 * @type {ArgValidator}
 */ function $778943ec39690f8e$var$usesMapState(encoded, returnType, context) {
    context.mapState = true;
}
/**
 * @type {ArgValidator}
 */ function $778943ec39690f8e$var$withNoArgs(encoded, returnType, context) {
    const operation = encoded[0];
    if (encoded.length !== 1) throw new Error(`expected no arguments for ${operation} operation`);
    return [];
}
/**
 * @param {number} minArgs The minimum number of arguments.
 * @param {number} maxArgs The maximum number of arguments.
 * @return {ArgValidator} The argument validator
 */ function $778943ec39690f8e$var$hasArgsCount(minArgs, maxArgs) {
    return function(encoded, returnType, context) {
        const operation = encoded[0];
        const argCount = encoded.length - 1;
        if (minArgs === maxArgs) {
            if (argCount !== minArgs) {
                const plural = minArgs === 1 ? '' : 's';
                throw new Error(`expected ${minArgs} argument${plural} for ${operation}, got ${argCount}`);
            }
        } else if (argCount < minArgs || argCount > maxArgs) {
            const range = maxArgs === Infinity ? `${minArgs} or more` : `${minArgs} to ${maxArgs}`;
            throw new Error(`expected ${range} arguments for ${operation}, got ${argCount}`);
        }
    };
}
/**
 * @type {ArgValidator}
 */ function $778943ec39690f8e$var$withArgsOfReturnType(encoded, returnType, context) {
    const argCount = encoded.length - 1;
    /**
   * @type {Array<Expression>}
   */ const args = new Array(argCount);
    for(let i = 0; i < argCount; ++i){
        const expression = $778943ec39690f8e$export$98e6a39c04603d36(encoded[i + 1], returnType, context);
        args[i] = expression;
    }
    return args;
}
/**
 * @param {number} argType The argument type.
 * @return {ArgValidator} The argument validator
 */ function $778943ec39690f8e$var$withArgsOfType(argType) {
    return function(encoded, returnType, context) {
        const argCount = encoded.length - 1;
        /**
     * @type {Array<Expression>}
     */ const args = new Array(argCount);
        for(let i = 0; i < argCount; ++i){
            const expression = $778943ec39690f8e$export$98e6a39c04603d36(encoded[i + 1], argType, context);
            args[i] = expression;
        }
        return args;
    };
}
/**
 * @type {ArgValidator}
 */ function $778943ec39690f8e$var$hasOddArgs(encoded, returnType, context) {
    const operation = encoded[0];
    const argCount = encoded.length - 1;
    if (argCount % 2 === 0) throw new Error(`expected an odd number of arguments for ${operation}, got ${argCount} instead`);
}
/**
 * @type {ArgValidator}
 */ function $778943ec39690f8e$var$hasEvenArgs(encoded, returnType, context) {
    const operation = encoded[0];
    const argCount = encoded.length - 1;
    if (argCount % 2 === 1) throw new Error(`expected an even number of arguments for operation ${operation}, got ${argCount} instead`);
}
/**
 * @type {ArgValidator}
 */ function $778943ec39690f8e$var$withMatchArgs(encoded, returnType, context) {
    const argsCount = encoded.length - 1;
    const inputType = $778943ec39690f8e$export$2b93044cbf134323 | $778943ec39690f8e$export$86a7aca748b1e260 | $778943ec39690f8e$export$240f7fffab1b25a0;
    const input = $778943ec39690f8e$export$98e6a39c04603d36(encoded[1], inputType, context);
    const fallback = $778943ec39690f8e$export$98e6a39c04603d36(encoded[encoded.length - 1], returnType, context);
    const args = new Array(argsCount - 2);
    for(let i = 0; i < argsCount - 2; i += 2){
        try {
            const match = $778943ec39690f8e$export$98e6a39c04603d36(encoded[i + 2], input.type, context);
            args[i] = match;
        } catch (err) {
            throw new Error(`failed to parse argument ${i + 1} of match expression: ${err.message}`);
        }
        try {
            const output = $778943ec39690f8e$export$98e6a39c04603d36(encoded[i + 3], fallback.type, context);
            args[i + 1] = output;
        } catch (err) {
            throw new Error(`failed to parse argument ${i + 2} of match expression: ${err.message}`);
        }
    }
    return [
        input,
        ...args,
        fallback
    ];
}
/**
 * @type {ArgValidator}
 */ function $778943ec39690f8e$var$withInterpolateArgs(encoded, returnType, context) {
    const interpolationType = encoded[1];
    /**
   * @type {number}
   */ let base;
    switch(interpolationType[0]){
        case 'linear':
            base = 1;
            break;
        case 'exponential':
            const b = interpolationType[1];
            if (typeof b !== 'number' || b <= 0) throw new Error(`expected a number base for exponential interpolation` + `, got ${JSON.stringify(b)} instead`);
            base = b;
            break;
        default:
            throw new Error(`invalid interpolation type: ${JSON.stringify(interpolationType)}`);
    }
    const interpolation = new $778943ec39690f8e$export$eb63e96e0913dda4($778943ec39690f8e$export$86a7aca748b1e260, base);
    let input;
    try {
        input = $778943ec39690f8e$export$98e6a39c04603d36(encoded[2], $778943ec39690f8e$export$86a7aca748b1e260, context);
    } catch (err) {
        throw new Error(`failed to parse argument 1 in interpolate expression: ${err.message}`);
    }
    const args = new Array(encoded.length - 3);
    for(let i = 0; i < args.length; i += 2){
        try {
            const stop = $778943ec39690f8e$export$98e6a39c04603d36(encoded[i + 3], $778943ec39690f8e$export$86a7aca748b1e260, context);
            args[i] = stop;
        } catch (err) {
            throw new Error(`failed to parse argument ${i + 2} for interpolate expression: ${err.message}`);
        }
        try {
            const output = $778943ec39690f8e$export$98e6a39c04603d36(encoded[i + 4], returnType, context);
            args[i + 1] = output;
        } catch (err) {
            throw new Error(`failed to parse argument ${i + 3} for interpolate expression: ${err.message}`);
        }
    }
    return [
        interpolation,
        input,
        ...args
    ];
}
/**
 * @type {ArgValidator}
 */ function $778943ec39690f8e$var$withCaseArgs(encoded, returnType, context) {
    const fallback = $778943ec39690f8e$export$98e6a39c04603d36(encoded[encoded.length - 1], returnType, context);
    const args = new Array(encoded.length - 1);
    for(let i = 0; i < args.length - 1; i += 2){
        try {
            const condition = $778943ec39690f8e$export$98e6a39c04603d36(encoded[i + 1], $778943ec39690f8e$export$240f7fffab1b25a0, context);
            args[i] = condition;
        } catch (err) {
            throw new Error(`failed to parse argument ${i} of case expression: ${err.message}`);
        }
        try {
            const output = $778943ec39690f8e$export$98e6a39c04603d36(encoded[i + 2], fallback.type, context);
            args[i + 1] = output;
        } catch (err) {
            throw new Error(`failed to parse argument ${i + 1} of case expression: ${err.message}`);
        }
    }
    args[args.length - 1] = fallback;
    return args;
}
/**
 * @type {ArgValidator}
 */ function $778943ec39690f8e$var$withInArgs(encoded, returnType, context) {
    let haystack = encoded[2];
    if (!Array.isArray(haystack)) throw new Error(`the second argument for the "in" operator must be an array`);
    /**
   * @type {number}
   */ let needleType;
    if (typeof haystack[0] === 'string') {
        if (haystack[0] !== 'literal') throw new Error(`for the "in" operator, a string array should be wrapped in a "literal" operator to disambiguate from expressions`);
        if (!Array.isArray(haystack[1])) throw new Error(`failed to parse "in" expression: the literal operator must be followed by an array`);
        haystack = haystack[1];
        needleType = $778943ec39690f8e$export$2b93044cbf134323;
    } else needleType = $778943ec39690f8e$export$86a7aca748b1e260;
    const args = new Array(haystack.length);
    for(let i = 0; i < args.length; i++)try {
        const arg = $778943ec39690f8e$export$98e6a39c04603d36(haystack[i], needleType, context);
        args[i] = arg;
    } catch (err) {
        throw new Error(`failed to parse haystack item ${i} for "in" expression: ${err.message}`);
    }
    const needle = $778943ec39690f8e$export$98e6a39c04603d36(encoded[1], needleType, context);
    return [
        needle,
        ...args
    ];
}
/**
 * @type {ArgValidator}
 */ function $778943ec39690f8e$var$withPaletteArgs(encoded, returnType, context) {
    let index;
    try {
        index = $778943ec39690f8e$export$98e6a39c04603d36(encoded[1], $778943ec39690f8e$export$86a7aca748b1e260, context);
    } catch (err) {
        throw new Error(`failed to parse first argument in palette expression: ${err.message}`);
    }
    const colors = encoded[2];
    if (!Array.isArray(colors)) throw new Error('the second argument of palette must be an array');
    const parsedColors = new Array(colors.length);
    for(let i = 0; i < parsedColors.length; i++){
        let color;
        try {
            color = $778943ec39690f8e$export$98e6a39c04603d36(colors[i], $778943ec39690f8e$export$2cd82751acc0e609, context);
        } catch (err) {
            throw new Error(`failed to parse color at index ${i} in palette expression: ${err.message}`);
        }
        if (!(color instanceof $778943ec39690f8e$export$eb63e96e0913dda4)) throw new Error(`the palette color at index ${i} must be a literal value`);
        parsedColors[i] = color;
    }
    return [
        index,
        ...parsedColors
    ];
}
/**
 * @param {Array<ArgValidator>} validators A chain of argument validators.  The last validator is expected
 * to return the parsed arguments.
 * @return {Parser} The parser.
 */ function $778943ec39690f8e$var$createCallExpressionParser(...validators) {
    return function(encoded, returnType, context) {
        const operator = encoded[0];
        /**
     * @type {Array<Expression>}
     */ let args;
        for(let i = 0; i < validators.length; i++){
            const parsed = validators[i](encoded, returnType, context);
            if (i == validators.length - 1) {
                if (!parsed) throw new Error('expected last argument validator to return the parsed args');
                args = parsed;
            }
        }
        return new $778943ec39690f8e$export$6f3d80189eb72cd4(returnType, operator, ...args);
    };
}
/**
 * @param {Array} encoded The encoded expression.
 * @param {number} returnType The expected return type of the call expression.
 * @param {ParsingContext} context The parsing context.
 * @return {Expression} The parsed expression.
 */ function $778943ec39690f8e$var$parseCallExpression(encoded, returnType, context) {
    const operator = encoded[0];
    const parser = $778943ec39690f8e$var$parsers[operator];
    if (!parser) throw new Error(`unknown operator: ${operator}`);
    return parser(encoded, returnType, context);
}
function $778943ec39690f8e$export$8da88d86d10c1295(geometry) {
    if (!geometry) return '';
    const type = geometry.getType();
    switch(type){
        case 'Point':
        case 'LineString':
        case 'Polygon':
            return type;
        case 'MultiPoint':
        case 'MultiLineString':
        case 'MultiPolygon':
            return /** @type {'Point'|'LineString'|'Polygon'} */ type.substring(5);
        case 'Circle':
            return 'Polygon';
        case 'GeometryCollection':
            return $778943ec39690f8e$export$8da88d86d10c1295(/** @type {import("../geom/GeometryCollection.js").default} */ geometry.getGeometries()[0]);
        default:
            return '';
    }
}


function $d597295b1f166e98$export$c18f39f0e136c26() {
    return {
        variables: {},
        properties: {},
        resolution: NaN,
        featureId: null,
        geometryType: ''
    };
}
function $d597295b1f166e98$export$b5f535122a9211f0(encoded, type, context) {
    const expression = (0, $778943ec39690f8e$export$98e6a39c04603d36)(encoded, type, context);
    return $d597295b1f166e98$var$compileExpression(expression, context);
}
/**
 * @param {import("./expression.js").Expression} expression The expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {ExpressionEvaluator} The evaluator function.
 */ function $d597295b1f166e98$var$compileExpression(expression, context) {
    if (expression instanceof (0, $778943ec39690f8e$export$eb63e96e0913dda4)) {
        // convert colors to array if possible
        if (expression.type === (0, $778943ec39690f8e$export$2cd82751acc0e609) && typeof expression.value === 'string') {
            const colorValue = (0, $322346e1ff7894ca$export$3004f64547af360e)(expression.value);
            return function() {
                return colorValue;
            };
        }
        return function() {
            return expression.value;
        };
    }
    const operator = expression.operator;
    switch(operator){
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Number:
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).String:
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Coalesce:
            return $d597295b1f166e98$var$compileAssertionExpression(expression, context);
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Get:
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Var:
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Has:
            return $d597295b1f166e98$var$compileAccessorExpression(expression, context);
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Id:
            return (context)=>context.featureId;
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).GeometryType:
            return (context)=>context.geometryType;
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Concat:
            {
                const args = expression.args.map((e)=>$d597295b1f166e98$var$compileExpression(e, context));
                return (context)=>''.concat(...args.map((arg)=>arg(context).toString()));
            }
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Resolution:
            return (context)=>context.resolution;
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Any:
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).All:
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Between:
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).In:
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Not:
            return $d597295b1f166e98$var$compileLogicalExpression(expression, context);
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Equal:
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).NotEqual:
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).LessThan:
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).LessThanOrEqualTo:
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).GreaterThan:
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).GreaterThanOrEqualTo:
            return $d597295b1f166e98$var$compileComparisonExpression(expression, context);
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Multiply:
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Divide:
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Add:
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Subtract:
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Clamp:
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Mod:
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Pow:
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Abs:
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Floor:
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Ceil:
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Round:
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Sin:
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Cos:
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Atan:
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Sqrt:
            return $d597295b1f166e98$var$compileNumericExpression(expression, context);
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Case:
            return $d597295b1f166e98$var$compileCaseExpression(expression, context);
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Match:
            return $d597295b1f166e98$var$compileMatchExpression(expression, context);
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Interpolate:
            return $d597295b1f166e98$var$compileInterpolateExpression(expression, context);
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).ToString:
            return $d597295b1f166e98$var$compileConvertExpression(expression, context);
        default:
            throw new Error(`Unsupported operator ${operator}`);
    }
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {ExpressionEvaluator} The evaluator function.
 */ function $d597295b1f166e98$var$compileAssertionExpression(expression, context) {
    const type = expression.operator;
    const length = expression.args.length;
    const args = new Array(length);
    for(let i = 0; i < length; ++i)args[i] = $d597295b1f166e98$var$compileExpression(expression.args[i], context);
    switch(type){
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Coalesce:
            return (context)=>{
                for(let i = 0; i < length; ++i){
                    const value = args[i](context);
                    if (typeof value !== 'undefined' && value !== null) return value;
                }
                throw new Error('Expected one of the values to be non-null');
            };
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Number:
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).String:
            return (context)=>{
                for(let i = 0; i < length; ++i){
                    const value = args[i](context);
                    if (typeof value === type) return value;
                }
                throw new Error(`Expected one of the values to be a ${type}`);
            };
        default:
            throw new Error(`Unsupported assertion operator ${type}`);
    }
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {ExpressionEvaluator} The evaluator function.
 */ function $d597295b1f166e98$var$compileAccessorExpression(expression, context) {
    const nameExpression = /** @type {LiteralExpression} */ expression.args[0];
    const name = /** @type {string} */ nameExpression.value;
    switch(expression.operator){
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Get:
            return (context)=>{
                const args = expression.args;
                let value = context.properties[name];
                for(let i = 1, ii = args.length; i < ii; ++i){
                    const keyExpression = /** @type {LiteralExpression} */ args[i];
                    const key = /** @type {string|number} */ keyExpression.value;
                    value = value[key];
                }
                return value;
            };
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Var:
            return (context)=>context.variables[name];
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Has:
            return (context)=>{
                const args = expression.args;
                if (!(name in context.properties)) return false;
                let value = context.properties[name];
                for(let i = 1, ii = args.length; i < ii; ++i){
                    const keyExpression = /** @type {LiteralExpression} */ args[i];
                    const key = /** @type {string|number} */ keyExpression.value;
                    if (!value || !Object.hasOwn(value, key)) return false;
                    value = value[key];
                }
                return true;
            };
        default:
            throw new Error(`Unsupported accessor operator ${expression.operator}`);
    }
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {BooleanEvaluator} The evaluator function.
 */ function $d597295b1f166e98$var$compileComparisonExpression(expression, context) {
    const op = expression.operator;
    const left = $d597295b1f166e98$var$compileExpression(expression.args[0], context);
    const right = $d597295b1f166e98$var$compileExpression(expression.args[1], context);
    switch(op){
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Equal:
            return (context)=>left(context) === right(context);
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).NotEqual:
            return (context)=>left(context) !== right(context);
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).LessThan:
            return (context)=>left(context) < right(context);
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).LessThanOrEqualTo:
            return (context)=>left(context) <= right(context);
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).GreaterThan:
            return (context)=>left(context) > right(context);
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).GreaterThanOrEqualTo:
            return (context)=>left(context) >= right(context);
        default:
            throw new Error(`Unsupported comparison operator ${op}`);
    }
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {BooleanEvaluator} The evaluator function.
 */ function $d597295b1f166e98$var$compileLogicalExpression(expression, context) {
    const op = expression.operator;
    const length = expression.args.length;
    const args = new Array(length);
    for(let i = 0; i < length; ++i)args[i] = $d597295b1f166e98$var$compileExpression(expression.args[i], context);
    switch(op){
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Any:
            return (context)=>{
                for(let i = 0; i < length; ++i){
                    if (args[i](context)) return true;
                }
                return false;
            };
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).All:
            return (context)=>{
                for(let i = 0; i < length; ++i){
                    if (!args[i](context)) return false;
                }
                return true;
            };
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Between:
            return (context)=>{
                const value = args[0](context);
                const min = args[1](context);
                const max = args[2](context);
                return value >= min && value <= max;
            };
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).In:
            return (context)=>{
                const value = args[0](context);
                for(let i = 1; i < length; ++i){
                    if (value === args[i](context)) return true;
                }
                return false;
            };
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Not:
            return (context)=>!args[0](context);
        default:
            throw new Error(`Unsupported logical operator ${op}`);
    }
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {NumberEvaluator} The evaluator function.
 */ function $d597295b1f166e98$var$compileNumericExpression(expression, context) {
    const op = expression.operator;
    const length = expression.args.length;
    const args = new Array(length);
    for(let i = 0; i < length; ++i)args[i] = $d597295b1f166e98$var$compileExpression(expression.args[i], context);
    switch(op){
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Multiply:
            return (context)=>{
                let value = 1;
                for(let i = 0; i < length; ++i)value *= args[i](context);
                return value;
            };
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Divide:
            return (context)=>args[0](context) / args[1](context);
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Add:
            return (context)=>{
                let value = 0;
                for(let i = 0; i < length; ++i)value += args[i](context);
                return value;
            };
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Subtract:
            return (context)=>args[0](context) - args[1](context);
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Clamp:
            return (context)=>{
                const value = args[0](context);
                const min = args[1](context);
                if (value < min) return min;
                const max = args[2](context);
                if (value > max) return max;
                return value;
            };
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Mod:
            return (context)=>args[0](context) % args[1](context);
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Pow:
            return (context)=>Math.pow(args[0](context), args[1](context));
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Abs:
            return (context)=>Math.abs(args[0](context));
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Floor:
            return (context)=>Math.floor(args[0](context));
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Ceil:
            return (context)=>Math.ceil(args[0](context));
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Round:
            return (context)=>Math.round(args[0](context));
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Sin:
            return (context)=>Math.sin(args[0](context));
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Cos:
            return (context)=>Math.cos(args[0](context));
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Atan:
            if (length === 2) return (context)=>Math.atan2(args[0](context), args[1](context));
            return (context)=>Math.atan(args[0](context));
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Sqrt:
            return (context)=>Math.sqrt(args[0](context));
        default:
            throw new Error(`Unsupported numeric operator ${op}`);
    }
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {ExpressionEvaluator} The evaluator function.
 */ function $d597295b1f166e98$var$compileCaseExpression(expression, context) {
    const length = expression.args.length;
    const args = new Array(length);
    for(let i = 0; i < length; ++i)args[i] = $d597295b1f166e98$var$compileExpression(expression.args[i], context);
    return (context)=>{
        for(let i = 0; i < length - 1; i += 2){
            const condition = args[i](context);
            if (condition) return args[i + 1](context);
        }
        return args[length - 1](context);
    };
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {ExpressionEvaluator} The evaluator function.
 */ function $d597295b1f166e98$var$compileMatchExpression(expression, context) {
    const length = expression.args.length;
    const args = new Array(length);
    for(let i = 0; i < length; ++i)args[i] = $d597295b1f166e98$var$compileExpression(expression.args[i], context);
    return (context)=>{
        const value = args[0](context);
        for(let i = 1; i < length - 1; i += 2){
            if (value === args[i](context)) return args[i + 1](context);
        }
        return args[length - 1](context);
    };
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {ExpressionEvaluator} The evaluator function.
 */ function $d597295b1f166e98$var$compileInterpolateExpression(expression, context) {
    const length = expression.args.length;
    const args = new Array(length);
    for(let i = 0; i < length; ++i)args[i] = $d597295b1f166e98$var$compileExpression(expression.args[i], context);
    return (context)=>{
        const base = args[0](context);
        const value = args[1](context);
        let previousInput;
        let previousOutput;
        for(let i = 2; i < length; i += 2){
            const input = args[i](context);
            let output = args[i + 1](context);
            const isColor = Array.isArray(output);
            if (isColor) output = (0, $322346e1ff7894ca$export$138c09bdd6bd797c)(output);
            if (input >= value) {
                if (i === 2) return output;
                if (isColor) return $d597295b1f166e98$var$interpolateColor(base, value, previousInput, previousOutput, input, output);
                return $d597295b1f166e98$var$interpolateNumber(base, value, previousInput, previousOutput, input, output);
            }
            previousInput = input;
            previousOutput = output;
        }
        return previousOutput;
    };
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {ExpressionEvaluator} The evaluator function.
 */ function $d597295b1f166e98$var$compileConvertExpression(expression, context) {
    const op = expression.operator;
    const length = expression.args.length;
    const args = new Array(length);
    for(let i = 0; i < length; ++i)args[i] = $d597295b1f166e98$var$compileExpression(expression.args[i], context);
    switch(op){
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).ToString:
            return (context)=>{
                const value = args[0](context);
                if (expression.args[0].type === (0, $778943ec39690f8e$export$2cd82751acc0e609)) return (0, $322346e1ff7894ca$export$f84e8e69fd4488a5)(value);
                return value.toString();
            };
        default:
            throw new Error(`Unsupported convert operator ${op}`);
    }
}
/**
 * @param {number} base The base.
 * @param {number} value The value.
 * @param {number} input1 The first input value.
 * @param {number} output1 The first output value.
 * @param {number} input2 The second input value.
 * @param {number} output2 The second output value.
 * @return {number} The interpolated value.
 */ function $d597295b1f166e98$var$interpolateNumber(base, value, input1, output1, input2, output2) {
    const delta = input2 - input1;
    if (delta === 0) return output1;
    const along = value - input1;
    const factor = base === 1 ? along / delta : (Math.pow(base, along) - 1) / (Math.pow(base, delta) - 1);
    return output1 + factor * (output2 - output1);
}
/**
 * @param {number} base The base.
 * @param {number} value The value.
 * @param {number} input1 The first input value.
 * @param {import('../color.js').Color} rgba1 The first output value.
 * @param {number} input2 The second input value.
 * @param {import('../color.js').Color} rgba2 The second output value.
 * @return {import('../color.js').Color} The interpolated color.
 */ function $d597295b1f166e98$var$interpolateColor(base, value, input1, rgba1, input2, rgba2) {
    const delta = input2 - input1;
    if (delta === 0) return rgba1;
    const lcha1 = (0, $322346e1ff7894ca$export$44fb54fa2e0c0d4)(rgba1);
    const lcha2 = (0, $322346e1ff7894ca$export$44fb54fa2e0c0d4)(rgba2);
    let deltaHue = lcha2[2] - lcha1[2];
    if (deltaHue > 180) deltaHue -= 360;
    else if (deltaHue < -180) deltaHue += 360;
    const lcha = [
        $d597295b1f166e98$var$interpolateNumber(base, value, input1, lcha1[0], input2, lcha2[0]),
        $d597295b1f166e98$var$interpolateNumber(base, value, input1, lcha1[1], input2, lcha2[1]),
        lcha1[2] + $d597295b1f166e98$var$interpolateNumber(base, value, input1, 0, input2, deltaHue),
        $d597295b1f166e98$var$interpolateNumber(base, value, input1, rgba1[3], input2, rgba2[3])
    ];
    return (0, $322346e1ff7894ca$export$27cc94530c050f00)(lcha);
}





/**
 * @module ol/style/Circle
 */ /**
 * @module ol/style/RegularShape
 */ /**
 * @module ol/ImageState
 */ /**
 * @enum {number}
 */ var $7eb75c96a6b6f2c6$export$2e2bcd8739ae039 = {
    IDLE: 0,
    LOADING: 1,
    LOADED: 2,
    ERROR: 3,
    EMPTY: 4
};



/**
 * @module ol/colorlike
 */ 


/**
 * @module ol/style/IconImage
 */ /**
 * @module ol/Image
 */ 





/**
 * A function that takes an {@link module:ol/Image~ImageWrapper} for the image and a
 * `{string}` for the src as arguments. It is supposed to make it so the
 * underlying image {@link module:ol/Image~ImageWrapper#getImage} is assigned the
 * content specified by the src. If not specified, the default is
 *
 *     function(image, src) {
 *       image.getImage().src = src;
 *     }
 *
 * Providing a custom `imageLoadFunction` can be useful to load images with
 * post requests or - in general - through XHR requests, where the src of the
 * image element would be set to a data URI when the content is loaded.
 *
 * @typedef {function(import("./Image.js").default, string): void} LoadFunction
 * @api
 */ /**
 * @typedef {Object} ImageObject
 * @property {import("./extent.js").Extent} [extent] Extent, if different from the requested one.
 * @property {import("./resolution.js").ResolutionLike} [resolution] Resolution, if different from the requested one.
 * When x and y resolution are different, use the array type (`[xResolution, yResolution]`).
 * @property {number} [pixelRatio] Pixel ratio, if different from the requested one.
 * @property {import('./DataTile.js').ImageLike} image Image.
 */ /**
 * Loader function used for image sources. Receives extent, resolution and pixel ratio as arguments.
 * For images that cover any extent and resolution (static images), the loader function should not accept
 * any arguments. The function returns an {@link import("./DataTile.js").ImageLike image}, an
 * {@link import("./Image.js").ImageObject image object}, or a promise for the same.
 * For loaders that generate images, the promise should not resolve until the image is loaded.
 * If the returned image does not match the extent, resolution or pixel ratio passed to the loader,
 * it has to return an {@link import("./Image.js").ImageObject image object} with the `image` and the
 * correct `extent`, `resolution` and `pixelRatio`.
 *
 * @typedef {function(import("./extent.js").Extent, number, number, (function(HTMLImageElement, string): void)=): import("./DataTile.js").ImageLike|ImageObject|Promise<import("./DataTile.js").ImageLike|ImageObject>} Loader
 * @api
 */ /**
 * Loader function used for image sources. Receives extent, resolution and pixel ratio as arguments.
 * The function returns a promise for an  {@link import("./Image.js").ImageObject image object}.
 *
 * @typedef {function(import("./extent.js").Extent, number, number, (function(HTMLImageElement, string): void)=): Promise<import("./DataTile.js").ImageLike|ImageObject>} ImageObjectPromiseLoader
 */ class $b54439be79d4619a$var$ImageWrapper extends (0, $08c28d22c0cb5a39$export$2e2bcd8739ae039) {
    /**
   * @param {import("./extent.js").Extent} extent Extent.
   * @param {number|Array<number>|undefined} resolution Resolution. If provided as array, x and y
   * resolution will be assumed.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("./ImageState.js").default|Loader} stateOrLoader State.
   */ constructor(extent, resolution, pixelRatio, stateOrLoader){
        super();
        /**
     * @protected
     * @type {import("./extent.js").Extent}
     */ this.extent = extent;
        /**
     * @private
     * @type {number}
     */ this.pixelRatio_ = pixelRatio;
        /**
     * @protected
     * @type {number|Array<number>|undefined}
     */ this.resolution = resolution;
        /**
     * @protected
     * @type {import("./ImageState.js").default}
     */ this.state = typeof stateOrLoader === 'function' ? (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).IDLE : stateOrLoader;
        /**
     * @private
     * @type {import('./DataTile.js').ImageLike|null}
     */ this.image_ = null;
        /**
     * @protected
     * @type {Loader|null}
     */ this.loader = typeof stateOrLoader === 'function' ? stateOrLoader : null;
    }
    /**
   * @protected
   */ changed() {
        this.dispatchEvent((0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE);
    }
    /**
   * @return {import("./extent.js").Extent} Extent.
   */ getExtent() {
        return this.extent;
    }
    /**
   * @return {import('./DataTile.js').ImageLike} Image.
   */ getImage() {
        return this.image_;
    }
    /**
   * @return {number} PixelRatio.
   */ getPixelRatio() {
        return this.pixelRatio_;
    }
    /**
   * @return {number|Array<number>} Resolution.
   */ getResolution() {
        return /** @type {number} */ this.resolution;
    }
    /**
   * @return {import("./ImageState.js").default} State.
   */ getState() {
        return this.state;
    }
    /**
   * Load not yet loaded URI.
   */ load() {
        if (this.state == (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).IDLE) {
            if (this.loader) {
                this.state = (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADING;
                this.changed();
                const resolution = this.getResolution();
                const requestResolution = Array.isArray(resolution) ? resolution[0] : resolution;
                (0, $013a1733c226ec50$export$4dbaaf6c79705e6c)(()=>this.loader(this.getExtent(), requestResolution, this.getPixelRatio())).then((image)=>{
                    if ('image' in image) this.image_ = image.image;
                    if ('extent' in image) this.extent = image.extent;
                    if ('resolution' in image) this.resolution = image.resolution;
                    if ('pixelRatio' in image) this.pixelRatio_ = image.pixelRatio;
                    if (image instanceof HTMLImageElement || (0, $67c66761d21428d0$export$7478563940788376) && image instanceof ImageBitmap || image instanceof HTMLCanvasElement || image instanceof HTMLVideoElement) this.image_ = image;
                    this.state = (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADED;
                }).catch((error)=>{
                    this.state = (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).ERROR;
                    console.error(error); // eslint-disable-line no-console
                }).finally(()=>this.changed());
            }
        }
    }
    /**
   * @param {import('./DataTile.js').ImageLike} image The image.
   */ setImage(image) {
        this.image_ = image;
    }
    /**
   * @param {number|Array<number>} resolution Resolution.
   */ setResolution(resolution) {
        this.resolution = resolution;
    }
}
function $b54439be79d4619a$export$bc96ecc7c2a50764(image, loadHandler, errorHandler) {
    const img = /** @type {HTMLImageElement} */ image;
    let listening = true;
    let decoding = false;
    let loaded = false;
    const listenerKeys = [
        (0, $d5bf8abd656a3cdc$export$8d2a95bc11b44725)(img, (0, $294047c5e65f31a3$export$2e2bcd8739ae039).LOAD, function() {
            loaded = true;
            if (!decoding) loadHandler();
        })
    ];
    if (img.src && (0, $67c66761d21428d0$export$716f8695eedb9bad)) {
        decoding = true;
        img.decode().then(function() {
            if (listening) loadHandler();
        }).catch(function(error) {
            if (listening) {
                if (loaded) loadHandler();
                else errorHandler();
            }
        });
    } else listenerKeys.push((0, $d5bf8abd656a3cdc$export$8d2a95bc11b44725)(img, (0, $294047c5e65f31a3$export$2e2bcd8739ae039).ERROR, errorHandler));
    return function unlisten() {
        listening = false;
        listenerKeys.forEach((0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921));
    };
}
function $b54439be79d4619a$export$11e63f7b0f3d9900(image, src) {
    return new Promise((resolve, reject)=>{
        function handleLoad() {
            unlisten();
            resolve(image);
        }
        function handleError() {
            unlisten();
            reject(new Error('Image load error'));
        }
        function unlisten() {
            image.removeEventListener('load', handleLoad);
            image.removeEventListener('error', handleError);
        }
        image.addEventListener('load', handleLoad);
        image.addEventListener('error', handleError);
        if (src) image.src = src;
    });
}
function $b54439be79d4619a$export$a9e5af241c1bd389(image, src) {
    if (src) image.src = src;
    return image.src && (0, $67c66761d21428d0$export$716f8695eedb9bad) ? new Promise((resolve, reject)=>image.decode().then(()=>resolve(image)).catch((e)=>image.complete && image.width ? resolve(image) : reject(e))) : $b54439be79d4619a$export$11e63f7b0f3d9900(image);
}
function $b54439be79d4619a$export$2f872c0f2117be69(image, src) {
    if (src) image.src = src;
    return image.src && (0, $67c66761d21428d0$export$716f8695eedb9bad) && (0, $67c66761d21428d0$export$7478563940788376) ? image.decode().then(()=>createImageBitmap(image)).catch((e)=>{
        if (image.complete && image.width) return image;
        throw e;
    }) : $b54439be79d4619a$export$a9e5af241c1bd389(image);
}
var $b54439be79d4619a$export$2e2bcd8739ae039 = $b54439be79d4619a$var$ImageWrapper;







/**
 * @module ol/style/IconImageCache
 */ 


/**
 * @classdesc
 * Singleton class. Available through {@link module:ol/style/IconImageCache.shared}.
 */ class $f351daabfe6e2d22$var$IconImageCache {
    constructor(){
        /**
     * @type {!Object<string, import("./IconImage.js").default>}
     * @private
     */ this.cache_ = {};
        /**
     * @type {!Object<string, CanvasPattern>}
     * @private
     */ this.patternCache_ = {};
        /**
     * @type {number}
     * @private
     */ this.cacheSize_ = 0;
        /**
     * @type {number}
     * @private
     */ this.maxCacheSize_ = 1024;
    }
    /**
   * FIXME empty description for jsdoc
   */ clear() {
        this.cache_ = {};
        this.patternCache_ = {};
        this.cacheSize_ = 0;
    }
    /**
   * @return {boolean} Can expire cache.
   */ canExpireCache() {
        return this.cacheSize_ > this.maxCacheSize_;
    }
    /**
   * FIXME empty description for jsdoc
   */ expire() {
        if (this.canExpireCache()) {
            let i = 0;
            for(const key in this.cache_){
                const iconImage = this.cache_[key];
                if ((i++ & 3) === 0 && !iconImage.hasListener()) {
                    delete this.cache_[key];
                    delete this.patternCache_[key];
                    --this.cacheSize_;
                }
            }
        }
    }
    /**
   * @param {string} src Src.
   * @param {?string} crossOrigin Cross origin.
   * @param {import("../color.js").Color|string|null} color Color.
   * @return {import("./IconImage.js").default} Icon image.
   */ get(src, crossOrigin, color) {
        const key = $f351daabfe6e2d22$export$611736262b635f8d(src, crossOrigin, color);
        return key in this.cache_ ? this.cache_[key] : null;
    }
    /**
   * @param {string} src Src.
   * @param {?string} crossOrigin Cross origin.
   * @param {import("../color.js").Color|string|null} color Color.
   * @return {CanvasPattern} Icon image.
   */ getPattern(src, crossOrigin, color) {
        const key = $f351daabfe6e2d22$export$611736262b635f8d(src, crossOrigin, color);
        return key in this.patternCache_ ? this.patternCache_[key] : null;
    }
    /**
   * @param {string} src Src.
   * @param {?string} crossOrigin Cross origin.
   * @param {import("../color.js").Color|string|null} color Color.
   * @param {import("./IconImage.js").default|null} iconImage Icon image.
   * @param {boolean} [pattern] Also cache a `'repeat'` pattern with this `iconImage`.
   */ set(src, crossOrigin, color, iconImage, pattern) {
        const key = $f351daabfe6e2d22$export$611736262b635f8d(src, crossOrigin, color);
        const update = key in this.cache_;
        this.cache_[key] = iconImage;
        if (pattern) {
            if (iconImage.getImageState() === (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).IDLE) iconImage.load();
            if (iconImage.getImageState() === (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADING) iconImage.ready().then(()=>{
                this.patternCache_[key] = (0, $075f937d7366f1a2$export$fcb72ce088a6632c)().createPattern(iconImage.getImage(1), 'repeat');
            });
            else this.patternCache_[key] = (0, $075f937d7366f1a2$export$fcb72ce088a6632c)().createPattern(iconImage.getImage(1), 'repeat');
        }
        if (!update) ++this.cacheSize_;
    }
    /**
   * Set the cache size of the icon cache. Default is `1024`. Change this value when
   * your map uses more than 1024 different icon images and you are not caching icon
   * styles on the application level.
   * @param {number} maxCacheSize Cache max size.
   * @api
   */ setSize(maxCacheSize) {
        this.maxCacheSize_ = maxCacheSize;
        this.expire();
    }
}
function $f351daabfe6e2d22$export$611736262b635f8d(src, crossOrigin, color) {
    const colorString = color ? (0, $322346e1ff7894ca$export$75093a47a9fa838d)(color) : 'null';
    return crossOrigin + ':' + src + ':' + colorString;
}
var $f351daabfe6e2d22$export$2e2bcd8739ae039 = $f351daabfe6e2d22$var$IconImageCache;
const $f351daabfe6e2d22$export$747ccdf771a87ab8 = new $f351daabfe6e2d22$var$IconImageCache();


/**
 * @type {CanvasRenderingContext2D}
 */ let $0e5ad1d3b638689e$var$taintedTestContext = null;
class $0e5ad1d3b638689e$var$IconImage extends (0, $08c28d22c0cb5a39$export$2e2bcd8739ae039) {
    /**
   * @param {HTMLImageElement|HTMLCanvasElement|ImageBitmap|null} image Image.
   * @param {string|undefined} src Src.
   * @param {?string} crossOrigin Cross origin.
   * @param {import("../ImageState.js").default|undefined} imageState Image state.
   * @param {import("../color.js").Color|string|null} color Color.
   */ constructor(image, src, crossOrigin, imageState, color){
        super();
        /**
     * @private
     * @type {HTMLImageElement|HTMLCanvasElement|ImageBitmap}
     */ this.hitDetectionImage_ = null;
        /**
     * @private
     * @type {HTMLImageElement|HTMLCanvasElement|ImageBitmap|null}
     */ this.image_ = image;
        /**
     * @private
     * @type {string|null}
     */ this.crossOrigin_ = crossOrigin;
        /**
     * @private
     * @type {Object<number, HTMLCanvasElement>}
     */ this.canvas_ = {};
        /**
     * @private
     * @type {import("../color.js").Color|string|null}
     */ this.color_ = color;
        /**
     * @private
     * @type {import("../ImageState.js").default}
     */ this.imageState_ = imageState === undefined ? (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).IDLE : imageState;
        /**
     * @private
     * @type {import("../size.js").Size|null}
     */ this.size_ = image && image.width && image.height ? [
            image.width,
            image.height
        ] : null;
        /**
     * @private
     * @type {string|undefined}
     */ this.src_ = src;
        /**
     * @private
     */ this.tainted_;
        /**
     * @private
     * @type {Promise<void>|null}
     */ this.ready_ = null;
    }
    /**
   * @private
   */ initializeImage_() {
        this.image_ = new Image();
        if (this.crossOrigin_ !== null) this.image_.crossOrigin = this.crossOrigin_;
    }
    /**
   * @private
   * @return {boolean} The image canvas is tainted.
   */ isTainted_() {
        if (this.tainted_ === undefined && this.imageState_ === (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADED) {
            if (!$0e5ad1d3b638689e$var$taintedTestContext) $0e5ad1d3b638689e$var$taintedTestContext = (0, $075f937d7366f1a2$export$9e05d10eae75c464)(1, 1, undefined, {
                willReadFrequently: true
            });
            $0e5ad1d3b638689e$var$taintedTestContext.drawImage(this.image_, 0, 0);
            try {
                $0e5ad1d3b638689e$var$taintedTestContext.getImageData(0, 0, 1, 1);
                this.tainted_ = false;
            } catch  {
                $0e5ad1d3b638689e$var$taintedTestContext = null;
                this.tainted_ = true;
            }
        }
        return this.tainted_ === true;
    }
    /**
   * @private
   */ dispatchChangeEvent_() {
        this.dispatchEvent((0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE);
    }
    /**
   * @private
   */ handleImageError_() {
        this.imageState_ = (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).ERROR;
        this.dispatchChangeEvent_();
    }
    /**
   * @private
   */ handleImageLoad_() {
        this.imageState_ = (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADED;
        this.size_ = [
            this.image_.width,
            this.image_.height
        ];
        this.dispatchChangeEvent_();
    }
    /**
   * @param {number} pixelRatio Pixel ratio.
   * @return {HTMLImageElement|HTMLCanvasElement|ImageBitmap} Image or Canvas element or image bitmap.
   */ getImage(pixelRatio) {
        if (!this.image_) this.initializeImage_();
        this.replaceColor_(pixelRatio);
        return this.canvas_[pixelRatio] ? this.canvas_[pixelRatio] : this.image_;
    }
    /**
   * @param {number} pixelRatio Pixel ratio.
   * @return {number} Image or Canvas element.
   */ getPixelRatio(pixelRatio) {
        this.replaceColor_(pixelRatio);
        return this.canvas_[pixelRatio] ? pixelRatio : 1;
    }
    /**
   * @return {import("../ImageState.js").default} Image state.
   */ getImageState() {
        return this.imageState_;
    }
    /**
   * @return {HTMLImageElement|HTMLCanvasElement|ImageBitmap} Image element.
   */ getHitDetectionImage() {
        if (!this.image_) this.initializeImage_();
        if (!this.hitDetectionImage_) {
            if (this.isTainted_()) {
                const width = this.size_[0];
                const height = this.size_[1];
                const context = (0, $075f937d7366f1a2$export$9e05d10eae75c464)(width, height);
                context.fillRect(0, 0, width, height);
                this.hitDetectionImage_ = context.canvas;
            } else this.hitDetectionImage_ = this.image_;
        }
        return this.hitDetectionImage_;
    }
    /**
   * Get the size of the icon (in pixels).
   * @return {import("../size.js").Size} Image size.
   */ getSize() {
        return this.size_;
    }
    /**
   * @return {string|undefined} Image src.
   */ getSrc() {
        return this.src_;
    }
    /**
   * Load not yet loaded URI.
   */ load() {
        if (this.imageState_ !== (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).IDLE) return;
        if (!this.image_) this.initializeImage_();
        this.imageState_ = (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADING;
        try {
            if (this.src_ !== undefined) /** @type {HTMLImageElement} */ this.image_.src = this.src_;
        } catch  {
            this.handleImageError_();
        }
        if (this.image_ instanceof HTMLImageElement) (0, $b54439be79d4619a$export$a9e5af241c1bd389)(this.image_, this.src_).then((image)=>{
            this.image_ = image;
            this.handleImageLoad_();
        }).catch(this.handleImageError_.bind(this));
    }
    /**
   * @param {number} pixelRatio Pixel ratio.
   * @private
   */ replaceColor_(pixelRatio) {
        if (!this.color_ || this.canvas_[pixelRatio] || this.imageState_ !== (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADED) return;
        const image = this.image_;
        const ctx = (0, $075f937d7366f1a2$export$9e05d10eae75c464)(Math.ceil(image.width * pixelRatio), Math.ceil(image.height * pixelRatio));
        const canvas = ctx.canvas;
        ctx.scale(pixelRatio, pixelRatio);
        ctx.drawImage(image, 0, 0);
        ctx.globalCompositeOperation = 'multiply';
        ctx.fillStyle = (0, $322346e1ff7894ca$export$590567be997858b6)(this.color_);
        ctx.fillRect(0, 0, canvas.width / pixelRatio, canvas.height / pixelRatio);
        ctx.globalCompositeOperation = 'destination-in';
        ctx.drawImage(image, 0, 0);
        this.canvas_[pixelRatio] = canvas;
    }
    /**
   * @return {Promise<void>} Promise that resolves when the image is loaded.
   */ ready() {
        if (!this.ready_) this.ready_ = new Promise((resolve)=>{
            if (this.imageState_ === (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADED || this.imageState_ === (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).ERROR) resolve();
            else {
                const onChange = ()=>{
                    if (this.imageState_ === (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADED || this.imageState_ === (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).ERROR) {
                        this.removeEventListener((0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE, onChange);
                        resolve();
                    }
                };
                this.addEventListener((0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE, onChange);
            }
        });
        return this.ready_;
    }
}
function $0e5ad1d3b638689e$export$3988ae62b71be9a3(image, cacheKey, crossOrigin, imageState, color, pattern) {
    let iconImage = cacheKey === undefined ? undefined : (0, $f351daabfe6e2d22$export$747ccdf771a87ab8).get(cacheKey, crossOrigin, color);
    if (!iconImage) {
        iconImage = new $0e5ad1d3b638689e$var$IconImage(image, image && 'src' in image ? image.src || undefined : cacheKey, crossOrigin, imageState, color);
        (0, $f351daabfe6e2d22$export$747ccdf771a87ab8).set(cacheKey, crossOrigin, color, iconImage, pattern);
    }
    if (pattern && iconImage && !(0, $f351daabfe6e2d22$export$747ccdf771a87ab8).getPattern(cacheKey, crossOrigin, color)) (0, $f351daabfe6e2d22$export$747ccdf771a87ab8).set(cacheKey, crossOrigin, color, iconImage, pattern);
    return iconImage;
}
var $0e5ad1d3b638689e$export$2e2bcd8739ae039 = $0e5ad1d3b638689e$var$IconImage;



function $e0807f400ec9a0a9$export$dc5b1400ac3a10a8(color) {
    if (!color) return null;
    if (Array.isArray(color)) return (0, $322346e1ff7894ca$export$f84e8e69fd4488a5)(color);
    if (typeof color === 'object' && 'src' in color) return $e0807f400ec9a0a9$var$asCanvasPattern(color);
    return color;
}
/**
 * @param {PatternDescriptor} pattern Pattern descriptor.
 * @return {CanvasPattern|null} Canvas pattern or null if the pattern referenced in the
 * PatternDescriptor was not found in the icon image cache.
 */ function $e0807f400ec9a0a9$var$asCanvasPattern(pattern) {
    if (!pattern.offset || !pattern.size) return (0, $f351daabfe6e2d22$export$747ccdf771a87ab8).getPattern(pattern.src, 'anonymous', pattern.color);
    const cacheKey = pattern.src + ':' + pattern.offset;
    const canvasPattern = (0, $f351daabfe6e2d22$export$747ccdf771a87ab8).getPattern(cacheKey, undefined, pattern.color);
    if (canvasPattern) return canvasPattern;
    const iconImage = (0, $f351daabfe6e2d22$export$747ccdf771a87ab8).get(pattern.src, 'anonymous', null);
    if (iconImage.getImageState() !== (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADED) return null;
    const patternCanvasContext = (0, $075f937d7366f1a2$export$9e05d10eae75c464)(pattern.size[0], pattern.size[1]);
    patternCanvasContext.drawImage(iconImage.getImage(1), pattern.offset[0], pattern.offset[1], pattern.size[0], pattern.size[1], 0, 0, pattern.size[0], pattern.size[1]);
    (0, $0e5ad1d3b638689e$export$3988ae62b71be9a3)(patternCanvasContext.canvas, cacheKey, undefined, (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADED, pattern.color, true);
    return (0, $f351daabfe6e2d22$export$747ccdf771a87ab8).getPattern(cacheKey, undefined, pattern.color);
}



/**
 * @module ol/render/canvas
 */ 




const $d4aabc5c971073f1$export$3847dfea4f8d4dfa = '10px sans-serif';
const $d4aabc5c971073f1$export$c495d52ee3fd74b2 = '#000';
const $d4aabc5c971073f1$export$17bd0c38d6ae694e = 'round';
const $d4aabc5c971073f1$export$e21b4112fdc612fc = [];
const $d4aabc5c971073f1$export$e06efc2409049f76 = 0;
const $d4aabc5c971073f1$export$365eb9648cf19bd0 = 'round';
const $d4aabc5c971073f1$export$80c1c01844597b7b = 10;
const $d4aabc5c971073f1$export$1eb2eaecacf2031e = '#000';
const $d4aabc5c971073f1$export$94d53b95641b5766 = 'center';
const $d4aabc5c971073f1$export$cf2279a1bff62eb = 'middle';
const $d4aabc5c971073f1$export$40a9eeef55665a40 = [
    0,
    0,
    0,
    0
];
const $d4aabc5c971073f1$export$79661f132c62010e = 1;
const $d4aabc5c971073f1$export$1d36981fcadac93b = new (0, $b68b3d6e32e3074a$export$2e2bcd8739ae039)();
/**
 * @type {CanvasRenderingContext2D}
 */ let $d4aabc5c971073f1$var$measureContext = null;
/**
 * @type {string}
 */ let $d4aabc5c971073f1$var$measureFont;
const $d4aabc5c971073f1$export$7fdcec604f0b1fa7 = {};
const $d4aabc5c971073f1$var$genericFontFamilies = new Set([
    'serif',
    'sans-serif',
    'monospace',
    'cursive',
    'fantasy',
    'system-ui',
    'ui-serif',
    'ui-sans-serif',
    'ui-monospace',
    'ui-rounded',
    'emoji',
    'math',
    'fangsong'
]);
/**
 * @param {string} style Css font-style
 * @param {string} weight Css font-weight
 * @param {string} family Css font-family
 * @return {string} Font key.
 */ function $d4aabc5c971073f1$var$getFontKey(style, weight, family) {
    return `${style} ${weight} 16px "${family}"`;
}
const $d4aabc5c971073f1$export$a534074a28fa87ff = function() {
    const retries = 100;
    let timeout, fontFaceSet;
    /**
   * @param {string} fontSpec Css font spec
   * @return {Promise<boolean>} Font with style and weight is available
   */ async function isAvailable(fontSpec) {
        await fontFaceSet.ready;
        const fontFaces = await fontFaceSet.load(fontSpec);
        if (fontFaces.length === 0) return false;
        const font = (0, $ce07df6d5d4656f1$export$5abde8a6aec4a131)(fontSpec);
        const checkFamily = font.families[0].toLowerCase();
        const checkWeight = font.weight;
        return fontFaces.some(/**
       * @param {import('../css.js').FontParameters} f Font.
       * @return {boolean} Font matches.
       */ (f)=>{
            const family = f.family.replace(/^['"]|['"]$/g, '').toLowerCase();
            const weight = (0, $ce07df6d5d4656f1$export$59230918eb9bd861)[f.weight] || f.weight;
            return family === checkFamily && f.style === font.style && weight == checkWeight;
        });
    }
    async function check() {
        await fontFaceSet.ready;
        let done = true;
        const checkedFontsProperties = $d4aabc5c971073f1$export$1d36981fcadac93b.getProperties();
        const fonts = Object.keys(checkedFontsProperties).filter((key)=>checkedFontsProperties[key] < retries);
        for(let i = fonts.length - 1; i >= 0; --i){
            const font = fonts[i];
            let currentRetries = checkedFontsProperties[font];
            if (currentRetries < retries) {
                if (await isAvailable(font)) {
                    (0, $beaefe87199bb537$export$42ffd38884aecdac)($d4aabc5c971073f1$export$7fdcec604f0b1fa7);
                    $d4aabc5c971073f1$export$1d36981fcadac93b.set(font, retries);
                } else {
                    currentRetries += 10;
                    $d4aabc5c971073f1$export$1d36981fcadac93b.set(font, currentRetries, true);
                    if (currentRetries < retries) done = false;
                }
            }
        }
        timeout = undefined;
        if (!done) timeout = setTimeout(check, 100);
    }
    return async function(fontSpec) {
        if (!fontFaceSet) fontFaceSet = (0, $67c66761d21428d0$export$98fcef3dc9973292) ? self.fonts : document.fonts;
        const font = (0, $ce07df6d5d4656f1$export$5abde8a6aec4a131)(fontSpec);
        if (!font) return;
        const families = font.families;
        let needCheck = false;
        for (const family of families){
            if ($d4aabc5c971073f1$var$genericFontFamilies.has(family)) continue;
            const key = $d4aabc5c971073f1$var$getFontKey(font.style, font.weight, family);
            if ($d4aabc5c971073f1$export$1d36981fcadac93b.get(key) !== undefined) continue;
            $d4aabc5c971073f1$export$1d36981fcadac93b.set(key, 0, true);
            needCheck = true;
        }
        if (needCheck) {
            clearTimeout(timeout);
            timeout = setTimeout(check, 100);
        }
    };
}();
const $d4aabc5c971073f1$export$4feaf6852ff92513 = function() {
    /**
   * @type {HTMLDivElement}
   */ let measureElement;
    return function(fontSpec) {
        let height = $d4aabc5c971073f1$export$7fdcec604f0b1fa7[fontSpec];
        if (height == undefined) {
            if (0, $67c66761d21428d0$export$98fcef3dc9973292) {
                const font = (0, $ce07df6d5d4656f1$export$5abde8a6aec4a131)(fontSpec);
                const metrics = $d4aabc5c971073f1$var$measureText(fontSpec, "\u017Dg");
                const lineHeight = isNaN(Number(font.lineHeight)) ? 1.2 : Number(font.lineHeight);
                height = lineHeight * (metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent);
            } else {
                if (!measureElement) {
                    measureElement = document.createElement('div');
                    measureElement.innerHTML = 'M';
                    measureElement.style.minHeight = '0';
                    measureElement.style.maxHeight = 'none';
                    measureElement.style.height = 'auto';
                    measureElement.style.padding = '0';
                    measureElement.style.border = 'none';
                    measureElement.style.position = 'absolute';
                    measureElement.style.display = 'block';
                    measureElement.style.left = '-99999px';
                }
                measureElement.style.font = fontSpec;
                document.body.appendChild(measureElement);
                height = measureElement.offsetHeight;
                document.body.removeChild(measureElement);
            }
            $d4aabc5c971073f1$export$7fdcec604f0b1fa7[fontSpec] = height;
        }
        return height;
    };
}();
/**
 * @param {string} font Font.
 * @param {string} text Text.
 * @return {TextMetrics} Text metrics.
 */ function $d4aabc5c971073f1$var$measureText(font, text) {
    if (!$d4aabc5c971073f1$var$measureContext) $d4aabc5c971073f1$var$measureContext = (0, $075f937d7366f1a2$export$9e05d10eae75c464)(1, 1);
    if (font != $d4aabc5c971073f1$var$measureFont) {
        $d4aabc5c971073f1$var$measureContext.font = font;
        $d4aabc5c971073f1$var$measureFont = $d4aabc5c971073f1$var$measureContext.font;
    }
    return $d4aabc5c971073f1$var$measureContext.measureText(text);
}
function $d4aabc5c971073f1$export$4ea92329b673abd1(font, text) {
    return $d4aabc5c971073f1$var$measureText(font, text).width;
}
function $d4aabc5c971073f1$export$915c7ba51467308f(font, text, cache) {
    if (text in cache) return cache[text];
    const width = text.split('\n').reduce((prev, curr)=>Math.max(prev, $d4aabc5c971073f1$export$4ea92329b673abd1(font, curr)), 0);
    cache[text] = width;
    return width;
}
function $d4aabc5c971073f1$export$7d7c13020df1e791(baseStyle, chunks) {
    const widths = [];
    const heights = [];
    const lineWidths = [];
    let width = 0;
    let lineWidth = 0;
    let height = 0;
    let lineHeight = 0;
    for(let i = 0, ii = chunks.length; i <= ii; i += 2){
        const text = chunks[i];
        if (text === '\n' || i === ii) {
            width = Math.max(width, lineWidth);
            lineWidths.push(lineWidth);
            lineWidth = 0;
            height += lineHeight;
            lineHeight = 0;
            continue;
        }
        const font = chunks[i + 1] || baseStyle.font;
        const currentWidth = $d4aabc5c971073f1$export$4ea92329b673abd1(font, text);
        widths.push(currentWidth);
        lineWidth += currentWidth;
        const currentHeight = $d4aabc5c971073f1$export$4feaf6852ff92513(font);
        heights.push(currentHeight);
        lineHeight = Math.max(lineHeight, currentHeight);
    }
    return {
        width: width,
        height: height,
        widths: widths,
        heights: heights,
        lineWidths: lineWidths
    };
}
function $d4aabc5c971073f1$export$8ac4d72be78047e6(context, rotation, offsetX, offsetY) {
    if (rotation !== 0) {
        context.translate(offsetX, offsetY);
        context.rotate(rotation);
        context.translate(-offsetX, -offsetY);
    }
}
function $d4aabc5c971073f1$export$3cb6f3a6e49cc0ee(context, transform, opacity, labelOrImage, originX, originY, w, h, x, y, scale) {
    context.save();
    if (opacity !== 1) {
        if (context.globalAlpha === undefined) context.globalAlpha = (context)=>context.globalAlpha *= opacity;
        else context.globalAlpha *= opacity;
    }
    if (transform) context.transform.apply(context, transform);
    if (/** @type {*} */ labelOrImage.contextInstructions) {
        // label
        context.translate(x, y);
        context.scale(scale[0], scale[1]);
        $d4aabc5c971073f1$var$executeLabelInstructions(/** @type {Label} */ labelOrImage, context);
    } else if (scale[0] < 0 || scale[1] < 0) {
        // flipped image
        context.translate(x, y);
        context.scale(scale[0], scale[1]);
        context.drawImage(/** @type {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} */ labelOrImage, originX, originY, w, h, 0, 0, w, h);
    } else // if image not flipped translate and scale can be avoided
    context.drawImage(/** @type {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} */ labelOrImage, originX, originY, w, h, x, y, w * scale[0], h * scale[1]);
    context.restore();
}
/**
 * @param {Label} label Label.
 * @param {CanvasRenderingContext2D} context Context.
 */ function $d4aabc5c971073f1$var$executeLabelInstructions(label, context) {
    const contextInstructions = label.contextInstructions;
    for(let i = 0, ii = contextInstructions.length; i < ii; i += 2)if (Array.isArray(contextInstructions[i + 1])) context[contextInstructions[i]].apply(context, contextInstructions[i + 1]);
    else context[contextInstructions[i]] = contextInstructions[i + 1];
}




/**
 * @module ol/style/Image
 */ 

/**
 * @typedef {Object} Options
 * @property {number} opacity Opacity.
 * @property {boolean} rotateWithView If the image should get rotated with the view.
 * @property {number} rotation Rotation.
 * @property {number|import("../size.js").Size} scale Scale.
 * @property {Array<number>} displacement Displacement.
 * @property {import('../style/Style.js').DeclutterMode} declutterMode Declutter mode: `declutter`, `obstacle`, `none`.
 */ /**
 * @classdesc
 * A base class used for creating subclasses and not instantiated in
 * apps. Base class for {@link module:ol/style/Icon~Icon}, {@link module:ol/style/Circle~CircleStyle} and
 * {@link module:ol/style/RegularShape~RegularShape}.
 * @abstract
 * @api
 */ class $e60011aea38e6239$var$ImageStyle {
    /**
   * @param {Options} options Options.
   */ constructor(options){
        /**
     * @private
     * @type {number}
     */ this.opacity_ = options.opacity;
        /**
     * @private
     * @type {boolean}
     */ this.rotateWithView_ = options.rotateWithView;
        /**
     * @private
     * @type {number}
     */ this.rotation_ = options.rotation;
        /**
     * @private
     * @type {number|import("../size.js").Size}
     */ this.scale_ = options.scale;
        /**
     * @private
     * @type {import("../size.js").Size}
     */ this.scaleArray_ = (0, $cc435a5409103773$export$a71a825ff42fb8e1)(options.scale);
        /**
     * @private
     * @type {Array<number>}
     */ this.displacement_ = options.displacement;
        /**
     * @private
     * @type {import('../style/Style.js').DeclutterMode}
     */ this.declutterMode_ = options.declutterMode;
    }
    /**
   * Clones the style.
   * @return {ImageStyle} The cloned style.
   * @api
   */ clone() {
        const scale = this.getScale();
        return new $e60011aea38e6239$var$ImageStyle({
            opacity: this.getOpacity(),
            scale: Array.isArray(scale) ? scale.slice() : scale,
            rotation: this.getRotation(),
            rotateWithView: this.getRotateWithView(),
            displacement: this.getDisplacement().slice(),
            declutterMode: this.getDeclutterMode()
        });
    }
    /**
   * Get the symbolizer opacity.
   * @return {number} Opacity.
   * @api
   */ getOpacity() {
        return this.opacity_;
    }
    /**
   * Determine whether the symbolizer rotates with the map.
   * @return {boolean} Rotate with map.
   * @api
   */ getRotateWithView() {
        return this.rotateWithView_;
    }
    /**
   * Get the symoblizer rotation.
   * @return {number} Rotation.
   * @api
   */ getRotation() {
        return this.rotation_;
    }
    /**
   * Get the symbolizer scale.
   * @return {number|import("../size.js").Size} Scale.
   * @api
   */ getScale() {
        return this.scale_;
    }
    /**
   * Get the symbolizer scale array.
   * @return {import("../size.js").Size} Scale array.
   */ getScaleArray() {
        return this.scaleArray_;
    }
    /**
   * Get the displacement of the shape
   * @return {Array<number>} Shape's center displacement
   * @api
   */ getDisplacement() {
        return this.displacement_;
    }
    /**
   * Get the declutter mode of the shape
   * @return {import("./Style.js").DeclutterMode} Shape's declutter mode
   * @api
   */ getDeclutterMode() {
        return this.declutterMode_;
    }
    /**
   * Get the anchor point in pixels. The anchor determines the center point for the
   * symbolizer.
   * @abstract
   * @return {Array<number>} Anchor.
   */ getAnchor() {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Get the image element for the symbolizer.
   * @abstract
   * @param {number} pixelRatio Pixel ratio.
   * @return {import('../DataTile.js').ImageLike} Image element.
   */ getImage(pixelRatio) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * @abstract
   * @return {import('../DataTile.js').ImageLike} Image element.
   */ getHitDetectionImage() {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Get the image pixel ratio.
   * @param {number} pixelRatio Pixel ratio.
   * @return {number} Pixel ratio.
   */ getPixelRatio(pixelRatio) {
        return 1;
    }
    /**
   * @abstract
   * @return {import("../ImageState.js").default} Image state.
   */ getImageState() {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * @abstract
   * @return {import("../size.js").Size} Image size.
   */ getImageSize() {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Get the origin of the symbolizer.
   * @abstract
   * @return {Array<number>} Origin.
   */ getOrigin() {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Get the size of the symbolizer (in pixels).
   * @abstract
   * @return {import("../size.js").Size} Size.
   */ getSize() {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Set the displacement.
   *
   * @param {Array<number>} displacement Displacement.
   * @api
   */ setDisplacement(displacement) {
        this.displacement_ = displacement;
    }
    /**
   * Set the opacity.
   *
   * @param {number} opacity Opacity.
   * @api
   */ setOpacity(opacity) {
        this.opacity_ = opacity;
    }
    /**
   * Set whether to rotate the style with the view.
   *
   * @param {boolean} rotateWithView Rotate with map.
   * @api
   */ setRotateWithView(rotateWithView) {
        this.rotateWithView_ = rotateWithView;
    }
    /**
   * Set the rotation.
   *
   * @param {number} rotation Rotation.
   * @api
   */ setRotation(rotation) {
        this.rotation_ = rotation;
    }
    /**
   * Set the scale.
   *
   * @param {number|import("../size.js").Size} scale Scale.
   * @api
   */ setScale(scale) {
        this.scale_ = scale;
        this.scaleArray_ = (0, $cc435a5409103773$export$a71a825ff42fb8e1)(scale);
    }
    /**
   * @abstract
   * @param {function(import("../events/Event.js").default): void} listener Listener function.
   */ listenImageChange(listener) {
        (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Load not yet loaded URI.
   * @abstract
   */ load() {
        (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * @abstract
   * @param {function(import("../events/Event.js").default): void} listener Listener function.
   */ unlistenImageChange(listener) {
        (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * @return {Promise<void>} `false` or Promise that resolves when the style is ready to use.
   */ ready() {
        return Promise.resolve();
    }
}
var $e60011aea38e6239$export$2e2bcd8739ae039 = $e60011aea38e6239$var$ImageStyle;


/**
 * Specify radius for regular polygons, or both radius and radius2 for stars.
 * @typedef {Object} Options
 * @property {import("./Fill.js").default} [fill] Fill style.
 * @property {number} points Number of points for stars and regular polygons. In case of a polygon, the number of points
 * is the number of sides.
 * @property {number} radius Radius of a regular polygon.
 * @property {number} [radius2] Second radius to make a star instead of a regular polygon.
 * @property {number} [angle=0] Shape's angle in radians. A value of 0 will have one of the shape's points facing up.
 * @property {Array<number>} [displacement=[0, 0]] Displacement of the shape in pixels.
 * Positive values will shift the shape right and up.
 * @property {import("./Stroke.js").default} [stroke] Stroke style.
 * @property {number} [rotation=0] Rotation in radians (positive rotation clockwise).
 * @property {boolean} [rotateWithView=false] Whether to rotate the shape with the view.
 * @property {number|import("../size.js").Size} [scale=1] Scale. Unless two dimensional scaling is required a better
 * result may be obtained with appropriate settings for `radius` and `radius2`.
 * @property {import('./Style.js').DeclutterMode} [declutterMode] Declutter mode.
 */ /**
 * @typedef {Object} RenderOptions
 * @property {import("../colorlike.js").ColorLike|undefined} strokeStyle StrokeStyle.
 * @property {number} strokeWidth StrokeWidth.
 * @property {number} size Size.
 * @property {CanvasLineCap} lineCap LineCap.
 * @property {Array<number>|null} lineDash LineDash.
 * @property {number} lineDashOffset LineDashOffset.
 * @property {CanvasLineJoin} lineJoin LineJoin.
 * @property {number} miterLimit MiterLimit.
 */ /**
 * @classdesc
 * Set regular shape style for vector features. The resulting shape will be
 * a regular polygon when `radius` is provided, or a star when both `radius` and
 * `radius2` are provided.
 * @api
 */ class $3e99c452138b2224$var$RegularShape extends (0, $e60011aea38e6239$export$2e2bcd8739ae039) {
    /**
   * @param {Options} options Options.
   */ constructor(options){
        super({
            opacity: 1,
            rotateWithView: options.rotateWithView !== undefined ? options.rotateWithView : false,
            rotation: options.rotation !== undefined ? options.rotation : 0,
            scale: options.scale !== undefined ? options.scale : 1,
            displacement: options.displacement !== undefined ? options.displacement : [
                0,
                0
            ],
            declutterMode: options.declutterMode
        });
        /**
     * @private
     * @type {HTMLCanvasElement|null}
     */ this.hitDetectionCanvas_ = null;
        /**
     * @private
     * @type {import("./Fill.js").default|null}
     */ this.fill_ = options.fill !== undefined ? options.fill : null;
        /**
     * @private
     * @type {Array<number>}
     */ this.origin_ = [
            0,
            0
        ];
        /**
     * @private
     * @type {number}
     */ this.points_ = options.points;
        /**
     * @protected
     * @type {number}
     */ this.radius = options.radius;
        /**
     * @private
     * @type {number|undefined}
     */ this.radius2_ = options.radius2;
        /**
     * @private
     * @type {number}
     */ this.angle_ = options.angle !== undefined ? options.angle : 0;
        /**
     * @private
     * @type {import("./Stroke.js").default|null}
     */ this.stroke_ = options.stroke !== undefined ? options.stroke : null;
        /**
     * @private
     * @type {import("../size.js").Size}
     */ this.size_;
        /**
     * @private
     * @type {RenderOptions}
     */ this.renderOptions_;
        /**
     * @private
     */ this.imageState_ = this.fill_ && this.fill_.loading() ? (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADING : (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADED;
        if (this.imageState_ === (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADING) this.ready().then(()=>this.imageState_ = (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADED);
        this.render();
    }
    /**
   * Clones the style.
   * @return {RegularShape} The cloned style.
   * @api
   * @override
   */ clone() {
        const scale = this.getScale();
        const style = new $3e99c452138b2224$var$RegularShape({
            fill: this.getFill() ? this.getFill().clone() : undefined,
            points: this.getPoints(),
            radius: this.getRadius(),
            radius2: this.getRadius2(),
            angle: this.getAngle(),
            stroke: this.getStroke() ? this.getStroke().clone() : undefined,
            rotation: this.getRotation(),
            rotateWithView: this.getRotateWithView(),
            scale: Array.isArray(scale) ? scale.slice() : scale,
            displacement: this.getDisplacement().slice(),
            declutterMode: this.getDeclutterMode()
        });
        style.setOpacity(this.getOpacity());
        return style;
    }
    /**
   * Get the anchor point in pixels. The anchor determines the center point for the
   * symbolizer.
   * @return {Array<number>} Anchor.
   * @api
   * @override
   */ getAnchor() {
        const size = this.size_;
        const displacement = this.getDisplacement();
        const scale = this.getScaleArray();
        // anchor is scaled by renderer but displacement should not be scaled
        // so divide by scale here
        return [
            size[0] / 2 - displacement[0] / scale[0],
            size[1] / 2 + displacement[1] / scale[1]
        ];
    }
    /**
   * Get the angle used in generating the shape.
   * @return {number} Shape's rotation in radians.
   * @api
   */ getAngle() {
        return this.angle_;
    }
    /**
   * Get the fill style for the shape.
   * @return {import("./Fill.js").default|null} Fill style.
   * @api
   */ getFill() {
        return this.fill_;
    }
    /**
   * Set the fill style.
   * @param {import("./Fill.js").default|null} fill Fill style.
   * @api
   */ setFill(fill) {
        this.fill_ = fill;
        this.render();
    }
    /**
   * @return {HTMLCanvasElement} Image element.
   * @override
   */ getHitDetectionImage() {
        if (!this.hitDetectionCanvas_) this.hitDetectionCanvas_ = this.createHitDetectionCanvas_(this.renderOptions_);
        return this.hitDetectionCanvas_;
    }
    /**
   * Get the image icon.
   * @param {number} pixelRatio Pixel ratio.
   * @return {HTMLCanvasElement} Image or Canvas element.
   * @api
   * @override
   */ getImage(pixelRatio) {
        const fillKey = this.fill_?.getKey();
        const cacheKey = `${pixelRatio},${this.angle_},${this.radius},${this.radius2_},${this.points_},${fillKey}` + Object.values(this.renderOptions_).join(',');
        let image = /** @type {HTMLCanvasElement} */ (0, $f351daabfe6e2d22$export$747ccdf771a87ab8).get(cacheKey, null, null)?.getImage(1);
        if (!image) {
            const renderOptions = this.renderOptions_;
            const size = Math.ceil(renderOptions.size * pixelRatio);
            const context = (0, $075f937d7366f1a2$export$9e05d10eae75c464)(size, size);
            this.draw_(renderOptions, context, pixelRatio);
            image = context.canvas;
            (0, $f351daabfe6e2d22$export$747ccdf771a87ab8).set(cacheKey, null, null, new (0, $0e5ad1d3b638689e$export$2e2bcd8739ae039)(image, undefined, null, (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADED, null));
        }
        return image;
    }
    /**
   * Get the image pixel ratio.
   * @param {number} pixelRatio Pixel ratio.
   * @return {number} Pixel ratio.
   * @override
   */ getPixelRatio(pixelRatio) {
        return pixelRatio;
    }
    /**
   * @return {import("../size.js").Size} Image size.
   * @override
   */ getImageSize() {
        return this.size_;
    }
    /**
   * @return {import("../ImageState.js").default} Image state.
   * @override
   */ getImageState() {
        return this.imageState_;
    }
    /**
   * Get the origin of the symbolizer.
   * @return {Array<number>} Origin.
   * @api
   * @override
   */ getOrigin() {
        return this.origin_;
    }
    /**
   * Get the number of points for generating the shape.
   * @return {number} Number of points for stars and regular polygons.
   * @api
   */ getPoints() {
        return this.points_;
    }
    /**
   * Get the (primary) radius for the shape.
   * @return {number} Radius.
   * @api
   */ getRadius() {
        return this.radius;
    }
    /**
   * Get the secondary radius for the shape.
   * @return {number|undefined} Radius2.
   * @api
   */ getRadius2() {
        return this.radius2_;
    }
    /**
   * Get the size of the symbolizer (in pixels).
   * @return {import("../size.js").Size} Size.
   * @api
   * @override
   */ getSize() {
        return this.size_;
    }
    /**
   * Get the stroke style for the shape.
   * @return {import("./Stroke.js").default|null} Stroke style.
   * @api
   */ getStroke() {
        return this.stroke_;
    }
    /**
   * Set the stroke style.
   * @param {import("./Stroke.js").default|null} stroke Stroke style.
   * @api
   */ setStroke(stroke) {
        this.stroke_ = stroke;
        this.render();
    }
    /**
   * @param {function(import("../events/Event.js").default): void} listener Listener function.
   * @override
   */ listenImageChange(listener) {}
    /**
   * Load not yet loaded URI.
   * @override
   */ load() {}
    /**
   * @param {function(import("../events/Event.js").default): void} listener Listener function.
   * @override
   */ unlistenImageChange(listener) {}
    /**
   * Calculate additional canvas size needed for the miter.
   * @param {string} lineJoin Line join
   * @param {number} strokeWidth Stroke width
   * @param {number} miterLimit Miter limit
   * @return {number} Additional canvas size needed
   * @private
   */ calculateLineJoinSize_(lineJoin, strokeWidth, miterLimit) {
        if (strokeWidth === 0 || this.points_ === Infinity || lineJoin !== 'bevel' && lineJoin !== 'miter') return strokeWidth;
        // m  | ^
        // i  | |\                  .
        // t >|  #\
        // e  | |\ \              .
        // r      \s\
        //      |  \t\          .                 .
        //          \r\                      .   .
        //      |    \o\      .          .  . . .
        //          e \k\            .  .    . .
        //      |      \e\  .    .  .       . .
        //       d      \ \  .  .          . .
        //      | _ _a_ _\#  .            . .
        //   r1          / `             . .
        //      |                       . .
        //       b     /               . .
        //      |                     . .
        //           / r2            . .
        //      |                        .   .
        //         /                           .   .
        //      |α                                   .   .
        //       /                                         .   .
        //      ° center
        let r1 = this.radius;
        let r2 = this.radius2_ === undefined ? r1 : this.radius2_;
        if (r1 < r2) {
            const tmp = r1;
            r1 = r2;
            r2 = tmp;
        }
        const points = this.radius2_ === undefined ? this.points_ : this.points_ * 2;
        const alpha = 2 * Math.PI / points;
        const a = r2 * Math.sin(alpha);
        const b = Math.sqrt(r2 * r2 - a * a);
        const d = r1 - b;
        const e = Math.sqrt(a * a + d * d);
        const miterRatio = e / a;
        if (lineJoin === 'miter' && miterRatio <= miterLimit) return miterRatio * strokeWidth;
        // Calculate the distance from center to the stroke corner where
        // it was cut short because of the miter limit.
        //              l
        //        ----+---- <= distance from center to here is maxr
        //       /####|k ##\
        //      /#####^#####\
        //     /#### /+\# s #\
        //    /### h/+++\# t #\
        //   /### t/+++++\# r #\
        //  /### a/+++++++\# o #\
        // /### p/++ fill +\# k #\
        ///#### /+++++^+++++\# e #\
        //#####/+++++/+\+++++\#####\
        const k = strokeWidth / 2 / miterRatio;
        const l = strokeWidth / 2 * (d / e);
        const maxr = Math.sqrt((r1 + k) * (r1 + k) + l * l);
        const bevelAdd = maxr - r1;
        if (this.radius2_ === undefined || lineJoin === 'bevel') return bevelAdd * 2;
        // If outer miter is over the miter limit the inner miter may reach through the
        // center and be longer than the bevel, same calculation as above but swap r1 / r2.
        const aa = r1 * Math.sin(alpha);
        const bb = Math.sqrt(r1 * r1 - aa * aa);
        const dd = r2 - bb;
        const ee = Math.sqrt(aa * aa + dd * dd);
        const innerMiterRatio = ee / aa;
        if (innerMiterRatio <= miterLimit) {
            const innerLength = innerMiterRatio * strokeWidth / 2 - r2 - r1;
            return 2 * Math.max(bevelAdd, innerLength);
        }
        return bevelAdd * 2;
    }
    /**
   * @return {RenderOptions}  The render options
   * @protected
   */ createRenderOptions() {
        let lineCap = (0, $d4aabc5c971073f1$export$17bd0c38d6ae694e);
        let lineJoin = (0, $d4aabc5c971073f1$export$365eb9648cf19bd0);
        let miterLimit = 0;
        let lineDash = null;
        let lineDashOffset = 0;
        let strokeStyle;
        let strokeWidth = 0;
        if (this.stroke_) {
            strokeStyle = (0, $e0807f400ec9a0a9$export$dc5b1400ac3a10a8)(this.stroke_.getColor() ?? (0, $d4aabc5c971073f1$export$1eb2eaecacf2031e));
            strokeWidth = this.stroke_.getWidth() ?? (0, $d4aabc5c971073f1$export$79661f132c62010e);
            lineDash = this.stroke_.getLineDash();
            lineDashOffset = this.stroke_.getLineDashOffset() ?? 0;
            lineJoin = this.stroke_.getLineJoin() ?? (0, $d4aabc5c971073f1$export$365eb9648cf19bd0);
            lineCap = this.stroke_.getLineCap() ?? (0, $d4aabc5c971073f1$export$17bd0c38d6ae694e);
            miterLimit = this.stroke_.getMiterLimit() ?? (0, $d4aabc5c971073f1$export$80c1c01844597b7b);
        }
        const add = this.calculateLineJoinSize_(lineJoin, strokeWidth, miterLimit);
        const maxRadius = Math.max(this.radius, this.radius2_ || 0);
        const size = Math.ceil(2 * maxRadius + add);
        return {
            strokeStyle: strokeStyle,
            strokeWidth: strokeWidth,
            size: size,
            lineCap: lineCap,
            lineDash: lineDash,
            lineDashOffset: lineDashOffset,
            lineJoin: lineJoin,
            miterLimit: miterLimit
        };
    }
    /**
   * @protected
   */ render() {
        this.renderOptions_ = this.createRenderOptions();
        const size = this.renderOptions_.size;
        this.hitDetectionCanvas_ = null;
        this.size_ = [
            size,
            size
        ];
    }
    /**
   * @private
   * @param {RenderOptions} renderOptions Render options.
   * @param {CanvasRenderingContext2D} context The rendering context.
   * @param {number} pixelRatio The pixel ratio.
   */ draw_(renderOptions, context, pixelRatio) {
        context.scale(pixelRatio, pixelRatio);
        // set origin to canvas center
        context.translate(renderOptions.size / 2, renderOptions.size / 2);
        this.createPath_(context);
        if (this.fill_) {
            let color = this.fill_.getColor();
            if (color === null) color = (0, $d4aabc5c971073f1$export$c495d52ee3fd74b2);
            context.fillStyle = (0, $e0807f400ec9a0a9$export$dc5b1400ac3a10a8)(color);
            context.fill();
        }
        if (renderOptions.strokeStyle) {
            context.strokeStyle = renderOptions.strokeStyle;
            context.lineWidth = renderOptions.strokeWidth;
            if (renderOptions.lineDash) {
                context.setLineDash(renderOptions.lineDash);
                context.lineDashOffset = renderOptions.lineDashOffset;
            }
            context.lineCap = renderOptions.lineCap;
            context.lineJoin = renderOptions.lineJoin;
            context.miterLimit = renderOptions.miterLimit;
            context.stroke();
        }
    }
    /**
   * @private
   * @param {RenderOptions} renderOptions Render options.
   * @return {HTMLCanvasElement} Canvas containing the icon
   */ createHitDetectionCanvas_(renderOptions) {
        let context;
        if (this.fill_) {
            let color = this.fill_.getColor();
            // determine if fill is transparent (or pattern or gradient)
            let opacity = 0;
            if (typeof color === 'string') color = (0, $322346e1ff7894ca$export$75093a47a9fa838d)(color);
            if (color === null) opacity = 1;
            else if (Array.isArray(color)) opacity = color.length === 4 ? color[3] : 1;
            if (opacity === 0) {
                // if a transparent fill style is set, create an extra hit-detection image
                // with a default fill style
                context = (0, $075f937d7366f1a2$export$9e05d10eae75c464)(renderOptions.size, renderOptions.size);
                this.drawHitDetectionCanvas_(renderOptions, context);
            }
        }
        return context ? context.canvas : this.getImage(1);
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} context The context to draw in.
   */ createPath_(context) {
        let points = this.points_;
        const radius = this.radius;
        if (points === Infinity) context.arc(0, 0, radius, 0, 2 * Math.PI);
        else {
            const radius2 = this.radius2_ === undefined ? radius : this.radius2_;
            if (this.radius2_ !== undefined) points *= 2;
            const startAngle = this.angle_ - Math.PI / 2;
            const step = 2 * Math.PI / points;
            for(let i = 0; i < points; i++){
                const angle0 = startAngle + i * step;
                const radiusC = i % 2 === 0 ? radius : radius2;
                context.lineTo(radiusC * Math.cos(angle0), radiusC * Math.sin(angle0));
            }
            context.closePath();
        }
    }
    /**
   * @private
   * @param {RenderOptions} renderOptions Render options.
   * @param {CanvasRenderingContext2D} context The context.
   */ drawHitDetectionCanvas_(renderOptions, context) {
        // set origin to canvas center
        context.translate(renderOptions.size / 2, renderOptions.size / 2);
        this.createPath_(context);
        context.fillStyle = (0, $d4aabc5c971073f1$export$c495d52ee3fd74b2);
        context.fill();
        if (renderOptions.strokeStyle) {
            context.strokeStyle = renderOptions.strokeStyle;
            context.lineWidth = renderOptions.strokeWidth;
            if (renderOptions.lineDash) {
                context.setLineDash(renderOptions.lineDash);
                context.lineDashOffset = renderOptions.lineDashOffset;
            }
            context.lineJoin = renderOptions.lineJoin;
            context.miterLimit = renderOptions.miterLimit;
            context.stroke();
        }
    }
    /**
   * @override
   */ ready() {
        return this.fill_ ? this.fill_.ready() : Promise.resolve();
    }
}
var $3e99c452138b2224$export$2e2bcd8739ae039 = $3e99c452138b2224$var$RegularShape;


/**
 * @typedef {Object} Options
 * @property {import("./Fill.js").default} [fill] Fill style.
 * @property {number} radius Circle radius.
 * @property {import("./Stroke.js").default} [stroke] Stroke style.
 * @property {Array<number>} [displacement=[0,0]] displacement
 * @property {number|import("../size.js").Size} [scale=1] Scale. A two dimensional scale will produce an ellipse.
 * Unless two dimensional scaling is required a better result may be obtained with an appropriate setting for `radius`.
 * @property {number} [rotation=0] Rotation in radians
 * (positive rotation clockwise, meaningful only when used in conjunction with a two dimensional scale).
 * @property {boolean} [rotateWithView=false] Whether to rotate the shape with the view
 * (meaningful only when used in conjunction with a two dimensional scale).
 * @property {import('./Style.js').DeclutterMode} [declutterMode] Declutter mode
 */ /**
 * @classdesc
 * Set circle style for vector features.
 * @api
 */ class $06150d8570b7481b$var$CircleStyle extends (0, $3e99c452138b2224$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options ? options : {
            radius: 5
        };
        super({
            points: Infinity,
            fill: options.fill,
            radius: options.radius,
            stroke: options.stroke,
            scale: options.scale !== undefined ? options.scale : 1,
            rotation: options.rotation !== undefined ? options.rotation : 0,
            rotateWithView: options.rotateWithView !== undefined ? options.rotateWithView : false,
            displacement: options.displacement !== undefined ? options.displacement : [
                0,
                0
            ],
            declutterMode: options.declutterMode
        });
    }
    /**
   * Clones the style.
   * @return {CircleStyle} The cloned style.
   * @api
   * @override
   */ clone() {
        const scale = this.getScale();
        const style = new $06150d8570b7481b$var$CircleStyle({
            fill: this.getFill() ? this.getFill().clone() : undefined,
            stroke: this.getStroke() ? this.getStroke().clone() : undefined,
            radius: this.getRadius(),
            scale: Array.isArray(scale) ? scale.slice() : scale,
            rotation: this.getRotation(),
            rotateWithView: this.getRotateWithView(),
            displacement: this.getDisplacement().slice(),
            declutterMode: this.getDeclutterMode()
        });
        style.setOpacity(this.getOpacity());
        return style;
    }
    /**
   * Set the circle radius.
   *
   * @param {number} radius Circle radius.
   * @api
   */ setRadius(radius) {
        this.radius = radius;
        this.render();
    }
}
var $06150d8570b7481b$export$2e2bcd8739ae039 = $06150d8570b7481b$var$CircleStyle;


/**
 * @module ol/style/Fill
 */ 



/**
 * @typedef {Object} Options
 * @property {import("../color.js").Color|import("../colorlike.js").ColorLike|import('../colorlike.js').PatternDescriptor|null} [color=null] A color,
 * gradient or pattern.
 * See {@link module:ol/color~Color} and {@link module:ol/colorlike~ColorLike} for possible formats. For polygon fills (not for {@link import("./RegularShape.js").default} fills),
 * a pattern can also be provided as {@link module:ol/colorlike~PatternDescriptor}.
 * Default null; if null, the Canvas/renderer default black will be used.
 */ /**
 * @classdesc
 * Set fill style for vector features.
 * @api
 */ class $d61d1dcaf3c44610$var$Fill {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options || {};
        /**
     * @private
     * @type {import("./IconImage.js").default|null}
     */ this.patternImage_ = null;
        /**
     * @private
     * @type {import("../color.js").Color|import("../colorlike.js").ColorLike|import('../colorlike.js').PatternDescriptor|null}
     */ this.color_ = null;
        if (options.color !== undefined) this.setColor(options.color);
    }
    /**
   * Clones the style. The color is not cloned if it is a {@link module:ol/colorlike~ColorLike}.
   * @return {Fill} The cloned style.
   * @api
   */ clone() {
        const color = this.getColor();
        return new $d61d1dcaf3c44610$var$Fill({
            color: Array.isArray(color) ? color.slice() : color || undefined
        });
    }
    /**
   * Get the fill color.
   * @return {import("../color.js").Color|import("../colorlike.js").ColorLike|import('../colorlike.js').PatternDescriptor|null} Color.
   * @api
   */ getColor() {
        return this.color_;
    }
    /**
   * Set the color.
   *
   * @param {import("../color.js").Color|import("../colorlike.js").ColorLike|import('../colorlike.js').PatternDescriptor|null} color Color.
   * @api
   */ setColor(color) {
        if (color !== null && typeof color === 'object' && 'src' in color) {
            const patternImage = (0, $0e5ad1d3b638689e$export$3988ae62b71be9a3)(null, color.src, 'anonymous', undefined, color.offset ? null : color.color ? color.color : null, !(color.offset && color.size));
            patternImage.ready().then(()=>{
                this.patternImage_ = null;
            });
            if (patternImage.getImageState() === (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).IDLE) patternImage.load();
            if (patternImage.getImageState() === (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADING) this.patternImage_ = patternImage;
        }
        this.color_ = color;
    }
    /**
   * @return {string} Key of the fill for cache lookup.
   */ getKey() {
        const fill = this.getColor();
        if (!fill) return '';
        return fill instanceof CanvasPattern || fill instanceof CanvasGradient ? (0, $6c5e11070e371322$export$5e82334337e0f204)(fill) : typeof fill === 'object' && 'src' in fill ? fill.src + ':' + fill.offset : (0, $322346e1ff7894ca$export$75093a47a9fa838d)(fill).toString();
    }
    /**
   * @return {boolean} The fill style is loading an image pattern.
   */ loading() {
        return !!this.patternImage_;
    }
    /**
   * @return {Promise<void>} `false` or a promise that resolves when the style is ready to use.
   */ ready() {
        return this.patternImage_ ? this.patternImage_.ready() : Promise.resolve();
    }
}
var $d61d1dcaf3c44610$export$2e2bcd8739ae039 = $d61d1dcaf3c44610$var$Fill;


/**
 * @module ol/style/Icon
 */ 






/**
 * @typedef {'fraction' | 'pixels'} IconAnchorUnits
 * Anchor unit can be either a fraction of the icon size or in pixels.
 */ /**
 * @typedef {'bottom-left' | 'bottom-right' | 'top-left' | 'top-right'} IconOrigin
 * Icon origin. One of 'bottom-left', 'bottom-right', 'top-left', 'top-right'.
 */ /**
 * @typedef {Object} Options
 * @property {Array<number>} [anchor=[0.5, 0.5]] Anchor. Default value is the icon center.
 * @property {IconOrigin} [anchorOrigin='top-left'] Origin of the anchor: `bottom-left`, `bottom-right`,
 * `top-left` or `top-right`.
 * @property {IconAnchorUnits} [anchorXUnits='fraction'] Units in which the anchor x value is
 * specified. A value of `'fraction'` indicates the x value is a fraction of the icon. A value of `'pixels'` indicates
 * the x value in pixels.
 * @property {IconAnchorUnits} [anchorYUnits='fraction'] Units in which the anchor y value is
 * specified. A value of `'fraction'` indicates the y value is a fraction of the icon. A value of `'pixels'` indicates
 * the y value in pixels.
 * @property {import("../color.js").Color|string} [color] Color to tint the icon. If not specified,
 * the icon will be left as is.
 * @property {null|string} [crossOrigin] The `crossOrigin` attribute for loaded images. Note that you must provide a
 * `crossOrigin` value if you want to access pixel data with the Canvas renderer.
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
 * @property {HTMLImageElement|HTMLCanvasElement|ImageBitmap} [img] Image object for the icon.
 * @property {Array<number>} [displacement=[0, 0]] Displacement of the icon in pixels.
 * Positive values will shift the icon right and up.
 * @property {number} [opacity=1] Opacity of the icon.
 * @property {number} [width] The width of the icon in pixels. This can't be used together with `scale`.
 * @property {number} [height] The height of the icon in pixels. This can't be used together with `scale`.
 * @property {number|import("../size.js").Size} [scale=1] Scale.
 * @property {boolean} [rotateWithView=false] Whether to rotate the icon with the view.
 * @property {number} [rotation=0] Rotation in radians (positive rotation clockwise).
 * @property {Array<number>} [offset=[0, 0]] Offset which, together with `size` and `offsetOrigin`, defines the
 * sub-rectangle to use from the original (sprite) image.
 * @property {IconOrigin} [offsetOrigin='top-left'] Origin of the offset: `bottom-left`, `bottom-right`,
 * `top-left` or `top-right`.
 * @property {import("../size.js").Size} [size] Icon size in pixels. Used together with `offset` to define the
 * sub-rectangle to use from the original (sprite) image.
 * @property {string} [src] Image source URI.
 * @property {import("./Style.js").DeclutterMode} [declutterMode] Declutter mode.
 */ /**
 * @param {number} width The width.
 * @param {number} height The height.
 * @param {number|undefined} wantedWidth The wanted width.
 * @param {number|undefined} wantedHeight The wanted height.
 * @return {number|Array<number>} The scale.
 */ function $8463d325b53eeb0c$var$calculateScale(width, height, wantedWidth, wantedHeight) {
    if (wantedWidth !== undefined && wantedHeight !== undefined) return [
        wantedWidth / width,
        wantedHeight / height
    ];
    if (wantedWidth !== undefined) return wantedWidth / width;
    if (wantedHeight !== undefined) return wantedHeight / height;
    return 1;
}
/**
 * @classdesc
 * Set icon style for vector features.
 * @api
 */ class $8463d325b53eeb0c$var$Icon extends (0, $e60011aea38e6239$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options || {};
        /**
     * @type {number}
     */ const opacity = options.opacity !== undefined ? options.opacity : 1;
        /**
     * @type {number}
     */ const rotation = options.rotation !== undefined ? options.rotation : 0;
        /**
     * @type {number|import("../size.js").Size}
     */ const scale = options.scale !== undefined ? options.scale : 1;
        /**
     * @type {boolean}
     */ const rotateWithView = options.rotateWithView !== undefined ? options.rotateWithView : false;
        super({
            opacity: opacity,
            rotation: rotation,
            scale: scale,
            displacement: options.displacement !== undefined ? options.displacement : [
                0,
                0
            ],
            rotateWithView: rotateWithView,
            declutterMode: options.declutterMode
        });
        /**
     * @private
     * @type {Array<number>}
     */ this.anchor_ = options.anchor !== undefined ? options.anchor : [
            0.5,
            0.5
        ];
        /**
     * @private
     * @type {Array<number>}
     */ this.normalizedAnchor_ = null;
        /**
     * @private
     * @type {IconOrigin}
     */ this.anchorOrigin_ = options.anchorOrigin !== undefined ? options.anchorOrigin : 'top-left';
        /**
     * @private
     * @type {IconAnchorUnits}
     */ this.anchorXUnits_ = options.anchorXUnits !== undefined ? options.anchorXUnits : 'fraction';
        /**
     * @private
     * @type {IconAnchorUnits}
     */ this.anchorYUnits_ = options.anchorYUnits !== undefined ? options.anchorYUnits : 'fraction';
        /**
     * @private
     * @type {?string}
     */ this.crossOrigin_ = options.crossOrigin !== undefined ? options.crossOrigin : null;
        const image = options.img !== undefined ? options.img : null;
        let cacheKey = options.src;
        (0, $35d5ec884318008e$export$a7a9523472993e97)(!(cacheKey !== undefined && image), '`image` and `src` cannot be provided at the same time');
        if ((cacheKey === undefined || cacheKey.length === 0) && image) cacheKey = /** @type {HTMLImageElement} */ image.src || (0, $6c5e11070e371322$export$5e82334337e0f204)(image);
        (0, $35d5ec884318008e$export$a7a9523472993e97)(cacheKey !== undefined && cacheKey.length > 0, 'A defined and non-empty `src` or `image` must be provided');
        (0, $35d5ec884318008e$export$a7a9523472993e97)(!((options.width !== undefined || options.height !== undefined) && options.scale !== undefined), '`width` or `height` cannot be provided together with `scale`');
        let imageState;
        if (options.src !== undefined) imageState = (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).IDLE;
        else if (image !== undefined) {
            if ('complete' in image) {
                if (image.complete) imageState = image.src ? (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADED : (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).IDLE;
                else imageState = (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADING;
            } else imageState = (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADED;
        }
        /**
     * @private
     * @type {import("../color.js").Color}
     */ this.color_ = options.color !== undefined ? (0, $322346e1ff7894ca$export$75093a47a9fa838d)(options.color) : null;
        /**
     * @private
     * @type {import("./IconImage.js").default}
     */ this.iconImage_ = (0, $0e5ad1d3b638689e$export$3988ae62b71be9a3)(image, /** @type {string} */ cacheKey, this.crossOrigin_, imageState, this.color_);
        /**
     * @private
     * @type {Array<number>}
     */ this.offset_ = options.offset !== undefined ? options.offset : [
            0,
            0
        ];
        /**
     * @private
     * @type {IconOrigin}
     */ this.offsetOrigin_ = options.offsetOrigin !== undefined ? options.offsetOrigin : 'top-left';
        /**
     * @private
     * @type {Array<number>}
     */ this.origin_ = null;
        /**
     * @private
     * @type {import("../size.js").Size}
     */ this.size_ = options.size !== undefined ? options.size : null;
        /**
     * @private
     */ this.initialOptions_;
        /**
     * Calculate the scale if width or height were given.
     */ if (options.width !== undefined || options.height !== undefined) {
            let width, height;
            if (options.size) [width, height] = options.size;
            else {
                const image = this.getImage(1);
                if (image.width && image.height) {
                    width = image.width;
                    height = image.height;
                } else if (image instanceof HTMLImageElement) {
                    this.initialOptions_ = options;
                    const onload = ()=>{
                        this.unlistenImageChange(onload);
                        if (!this.initialOptions_) return;
                        const imageSize = this.iconImage_.getSize();
                        this.setScale($8463d325b53eeb0c$var$calculateScale(imageSize[0], imageSize[1], options.width, options.height));
                    };
                    this.listenImageChange(onload);
                    return;
                }
            }
            if (width !== undefined) this.setScale($8463d325b53eeb0c$var$calculateScale(width, height, options.width, options.height));
        }
    }
    /**
   * Clones the style. The underlying Image/HTMLCanvasElement is not cloned.
   * @return {Icon} The cloned style.
   * @api
   * @override
   */ clone() {
        let scale, width, height;
        if (this.initialOptions_) {
            width = this.initialOptions_.width;
            height = this.initialOptions_.height;
        } else {
            scale = this.getScale();
            scale = Array.isArray(scale) ? scale.slice() : scale;
        }
        return new $8463d325b53eeb0c$var$Icon({
            anchor: this.anchor_.slice(),
            anchorOrigin: this.anchorOrigin_,
            anchorXUnits: this.anchorXUnits_,
            anchorYUnits: this.anchorYUnits_,
            color: this.color_ && this.color_.slice ? this.color_.slice() : this.color_ || undefined,
            crossOrigin: this.crossOrigin_,
            offset: this.offset_.slice(),
            offsetOrigin: this.offsetOrigin_,
            opacity: this.getOpacity(),
            rotateWithView: this.getRotateWithView(),
            rotation: this.getRotation(),
            scale: scale,
            width: width,
            height: height,
            size: this.size_ !== null ? this.size_.slice() : undefined,
            src: this.getSrc(),
            displacement: this.getDisplacement().slice(),
            declutterMode: this.getDeclutterMode()
        });
    }
    /**
   * Get the anchor point in pixels. The anchor determines the center point for the
   * symbolizer.
   * @return {Array<number>} Anchor.
   * @api
   * @override
   */ getAnchor() {
        let anchor = this.normalizedAnchor_;
        if (!anchor) {
            anchor = this.anchor_;
            const size = this.getSize();
            if (this.anchorXUnits_ == 'fraction' || this.anchorYUnits_ == 'fraction') {
                if (!size) return null;
                anchor = this.anchor_.slice();
                if (this.anchorXUnits_ == 'fraction') anchor[0] *= size[0];
                if (this.anchorYUnits_ == 'fraction') anchor[1] *= size[1];
            }
            if (this.anchorOrigin_ != 'top-left') {
                if (!size) return null;
                if (anchor === this.anchor_) anchor = this.anchor_.slice();
                if (this.anchorOrigin_ == 'top-right' || this.anchorOrigin_ == 'bottom-right') anchor[0] = -anchor[0] + size[0];
                if (this.anchorOrigin_ == 'bottom-left' || this.anchorOrigin_ == 'bottom-right') anchor[1] = -anchor[1] + size[1];
            }
            this.normalizedAnchor_ = anchor;
        }
        const displacement = this.getDisplacement();
        const scale = this.getScaleArray();
        // anchor is scaled by renderer but displacement should not be scaled
        // so divide by scale here
        return [
            anchor[0] - displacement[0] / scale[0],
            anchor[1] + displacement[1] / scale[1]
        ];
    }
    /**
   * Set the anchor point. The anchor determines the center point for the
   * symbolizer.
   *
   * @param {Array<number>} anchor Anchor.
   * @api
   */ setAnchor(anchor) {
        this.anchor_ = anchor;
        this.normalizedAnchor_ = null;
    }
    /**
   * Get the icon color.
   * @return {import("../color.js").Color} Color.
   * @api
   */ getColor() {
        return this.color_;
    }
    /**
   * Get the image icon.
   * @param {number} pixelRatio Pixel ratio.
   * @return {HTMLImageElement|HTMLCanvasElement|ImageBitmap} Image or Canvas element. If the Icon
   * style was configured with `src` or with a not let loaded `img`, an `ImageBitmap` will be returned.
   * @api
   * @override
   */ getImage(pixelRatio) {
        return this.iconImage_.getImage(pixelRatio);
    }
    /**
   * Get the pixel ratio.
   * @param {number} pixelRatio Pixel ratio.
   * @return {number} The pixel ratio of the image.
   * @api
   * @override
   */ getPixelRatio(pixelRatio) {
        return this.iconImage_.getPixelRatio(pixelRatio);
    }
    /**
   * @return {import("../size.js").Size} Image size.
   * @override
   */ getImageSize() {
        return this.iconImage_.getSize();
    }
    /**
   * @return {import("../ImageState.js").default} Image state.
   * @override
   */ getImageState() {
        return this.iconImage_.getImageState();
    }
    /**
   * @return {HTMLImageElement|HTMLCanvasElement|ImageBitmap} Image element.
   * @override
   */ getHitDetectionImage() {
        return this.iconImage_.getHitDetectionImage();
    }
    /**
   * Get the origin of the symbolizer.
   * @return {Array<number>} Origin.
   * @api
   * @override
   */ getOrigin() {
        if (this.origin_) return this.origin_;
        let offset = this.offset_;
        if (this.offsetOrigin_ != 'top-left') {
            const size = this.getSize();
            const iconImageSize = this.iconImage_.getSize();
            if (!size || !iconImageSize) return null;
            offset = offset.slice();
            if (this.offsetOrigin_ == 'top-right' || this.offsetOrigin_ == 'bottom-right') offset[0] = iconImageSize[0] - size[0] - offset[0];
            if (this.offsetOrigin_ == 'bottom-left' || this.offsetOrigin_ == 'bottom-right') offset[1] = iconImageSize[1] - size[1] - offset[1];
        }
        this.origin_ = offset;
        return this.origin_;
    }
    /**
   * Get the image URL.
   * @return {string|undefined} Image src.
   * @api
   */ getSrc() {
        return this.iconImage_.getSrc();
    }
    /**
   * Get the size of the icon (in pixels).
   * @return {import("../size.js").Size} Image size.
   * @api
   * @override
   */ getSize() {
        return !this.size_ ? this.iconImage_.getSize() : this.size_;
    }
    /**
   * Get the width of the icon (in pixels). Will return undefined when the icon image is not yet loaded.
   * @return {number} Icon width (in pixels).
   * @api
   */ getWidth() {
        const scale = this.getScaleArray();
        if (this.size_) return this.size_[0] * scale[0];
        if (this.iconImage_.getImageState() == (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADED) return this.iconImage_.getSize()[0] * scale[0];
        return undefined;
    }
    /**
   * Get the height of the icon (in pixels). Will return undefined when the icon image is not yet loaded.
   * @return {number} Icon height (in pixels).
   * @api
   */ getHeight() {
        const scale = this.getScaleArray();
        if (this.size_) return this.size_[1] * scale[1];
        if (this.iconImage_.getImageState() == (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADED) return this.iconImage_.getSize()[1] * scale[1];
        return undefined;
    }
    /**
   * Set the scale.
   *
   * @param {number|import("../size.js").Size} scale Scale.
   * @api
   * @override
   */ setScale(scale) {
        delete this.initialOptions_;
        super.setScale(scale);
    }
    /**
   * @param {function(import("../events/Event.js").default): void} listener Listener function.
   * @override
   */ listenImageChange(listener) {
        this.iconImage_.addEventListener((0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE, listener);
    }
    /**
   * Load not yet loaded URI.
   * When rendering a feature with an icon style, the vector renderer will
   * automatically call this method. However, you might want to call this
   * method yourself for preloading or other purposes.
   * @api
   * @override
   */ load() {
        this.iconImage_.load();
    }
    /**
   * @param {function(import("../events/Event.js").default): void} listener Listener function.
   * @override
   */ unlistenImageChange(listener) {
        this.iconImage_.removeEventListener((0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE, listener);
    }
    /**
   * @override
   */ ready() {
        return this.iconImage_.ready();
    }
}
var $8463d325b53eeb0c$export$2e2bcd8739ae039 = $8463d325b53eeb0c$var$Icon;



/**
 * @module ol/style/Stroke
 */ /**
 * @typedef {Object} Options
 * @property {import("../color.js").Color|import("../colorlike.js").ColorLike} [color] A color, gradient or pattern.
 * See {@link module:ol/color~Color} and {@link module:ol/colorlike~ColorLike} for possible formats.
 * Default null; if null, the Canvas/renderer default black will be used.
 * @property {CanvasLineCap} [lineCap='round'] Line cap style: `butt`, `round`, or `square`.
 * @property {CanvasLineJoin} [lineJoin='round'] Line join style: `bevel`, `round`, or `miter`.
 * @property {Array<number>} [lineDash] Line dash pattern. Default is `null` (no dash).
 * @property {number} [lineDashOffset=0] Line dash offset.
 * @property {number} [miterLimit=10] Miter limit.
 * @property {number} [width] Width.
 */ /**
 * @classdesc
 * Set stroke style for vector features.
 * Note that the defaults given are the Canvas defaults, which will be used if
 * option is not defined. The `get` functions return whatever was entered in
 * the options; they will not return the default.
 * @api
 */ class $f9d0329c5c745263$var$Stroke {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options || {};
        /**
     * @private
     * @type {import("../color.js").Color|import("../colorlike.js").ColorLike}
     */ this.color_ = options.color !== undefined ? options.color : null;
        /**
     * @private
     * @type {CanvasLineCap|undefined}
     */ this.lineCap_ = options.lineCap;
        /**
     * @private
     * @type {Array<number>|null}
     */ this.lineDash_ = options.lineDash !== undefined ? options.lineDash : null;
        /**
     * @private
     * @type {number|undefined}
     */ this.lineDashOffset_ = options.lineDashOffset;
        /**
     * @private
     * @type {CanvasLineJoin|undefined}
     */ this.lineJoin_ = options.lineJoin;
        /**
     * @private
     * @type {number|undefined}
     */ this.miterLimit_ = options.miterLimit;
        /**
     * @private
     * @type {number|undefined}
     */ this.width_ = options.width;
    }
    /**
   * Clones the style.
   * @return {Stroke} The cloned style.
   * @api
   */ clone() {
        const color = this.getColor();
        return new $f9d0329c5c745263$var$Stroke({
            color: Array.isArray(color) ? color.slice() : color || undefined,
            lineCap: this.getLineCap(),
            lineDash: this.getLineDash() ? this.getLineDash().slice() : undefined,
            lineDashOffset: this.getLineDashOffset(),
            lineJoin: this.getLineJoin(),
            miterLimit: this.getMiterLimit(),
            width: this.getWidth()
        });
    }
    /**
   * Get the stroke color.
   * @return {import("../color.js").Color|import("../colorlike.js").ColorLike} Color.
   * @api
   */ getColor() {
        return this.color_;
    }
    /**
   * Get the line cap type for the stroke.
   * @return {CanvasLineCap|undefined} Line cap.
   * @api
   */ getLineCap() {
        return this.lineCap_;
    }
    /**
   * Get the line dash style for the stroke.
   * @return {Array<number>|null} Line dash.
   * @api
   */ getLineDash() {
        return this.lineDash_;
    }
    /**
   * Get the line dash offset for the stroke.
   * @return {number|undefined} Line dash offset.
   * @api
   */ getLineDashOffset() {
        return this.lineDashOffset_;
    }
    /**
   * Get the line join type for the stroke.
   * @return {CanvasLineJoin|undefined} Line join.
   * @api
   */ getLineJoin() {
        return this.lineJoin_;
    }
    /**
   * Get the miter limit for the stroke.
   * @return {number|undefined} Miter limit.
   * @api
   */ getMiterLimit() {
        return this.miterLimit_;
    }
    /**
   * Get the stroke width.
   * @return {number|undefined} Width.
   * @api
   */ getWidth() {
        return this.width_;
    }
    /**
   * Set the color.
   *
   * @param {import("../color.js").Color|import("../colorlike.js").ColorLike} color Color.
   * @api
   */ setColor(color) {
        this.color_ = color;
    }
    /**
   * Set the line cap.
   *
   * @param {CanvasLineCap|undefined} lineCap Line cap.
   * @api
   */ setLineCap(lineCap) {
        this.lineCap_ = lineCap;
    }
    /**
   * Set the line dash.
   *
   * @param {Array<number>|null} lineDash Line dash.
   * @api
   */ setLineDash(lineDash) {
        this.lineDash_ = lineDash;
    }
    /**
   * Set the line dash offset.
   *
   * @param {number|undefined} lineDashOffset Line dash offset.
   * @api
   */ setLineDashOffset(lineDashOffset) {
        this.lineDashOffset_ = lineDashOffset;
    }
    /**
   * Set the line join.
   *
   * @param {CanvasLineJoin|undefined} lineJoin Line join.
   * @api
   */ setLineJoin(lineJoin) {
        this.lineJoin_ = lineJoin;
    }
    /**
   * Set the miter limit.
   *
   * @param {number|undefined} miterLimit Miter limit.
   * @api
   */ setMiterLimit(miterLimit) {
        this.miterLimit_ = miterLimit;
    }
    /**
   * Set the width.
   *
   * @param {number|undefined} width Width.
   * @api
   */ setWidth(width) {
        this.width_ = width;
    }
}
var $f9d0329c5c745263$export$2e2bcd8739ae039 = $f9d0329c5c745263$var$Stroke;


/**
 * @module ol/style/Style
 */ 



/**
 * Defines how symbols and text are decluttered on layers ith `declutter` set to `true`
 * **declutter**: Overlapping symbols and text are decluttered.
 * **obstacle**: Symbols and text are rendered, but serve as obstacle for subsequent attempts
 *   to place a symbol or text at the same location.
 * **none**: No decluttering is done.
 *
 * @typedef {"declutter"|"obstacle"|"none"} DeclutterMode
 */ /**
 * A function that takes a {@link module:ol/Feature~Feature} and a `{number}`
 * representing the view's resolution. The function should return a
 * {@link module:ol/style/Style~Style} or an array of them. This way e.g. a
 * vector layer can be styled. If the function returns `undefined`, the
 * feature will not be rendered.
 *
 * @typedef {function(import("../Feature.js").FeatureLike, number):(Style|Array<Style>|void)} StyleFunction
 */ /**
 * A {@link Style}, an array of {@link Style}, or a {@link StyleFunction}.
 * @typedef {Style|Array<Style>|StyleFunction} StyleLike
 */ /**
 * A function that takes a {@link module:ol/Feature~Feature} as argument and returns an
 * {@link module:ol/geom/Geometry~Geometry} that will be rendered and styled for the feature.
 *
 * @typedef {function(import("../Feature.js").FeatureLike):
 *     (import("../geom/Geometry.js").default|import("../render/Feature.js").default|undefined)} GeometryFunction
 */ /**
 * Custom renderer function. Takes two arguments:
 *
 * 1. The pixel coordinates of the geometry in GeoJSON notation.
 * 2. The {@link module:ol/render~State} of the layer renderer.
 *
 * @typedef {function((import("../coordinate.js").Coordinate|Array<import("../coordinate.js").Coordinate>|Array<Array<import("../coordinate.js").Coordinate>>|Array<Array<Array<import("../coordinate.js").Coordinate>>>),import("../render.js").State): void} RenderFunction
 */ /**
 * @typedef {Object} Options
 * @property {string|import("../geom/Geometry.js").default|GeometryFunction} [geometry] Feature property or geometry
 * or function returning a geometry to render for this style.
 * @property {import("./Fill.js").default} [fill] Fill style.
 * @property {import("./Image.js").default} [image] Image style.
 * @property {RenderFunction} [renderer] Custom renderer. When configured, `fill`, `stroke` and `image` will be
 * ignored, and the provided function will be called with each render frame for each geometry.
 * @property {RenderFunction} [hitDetectionRenderer] Custom renderer for hit detection. If provided will be used
 * in hit detection rendering.
 * @property {import("./Stroke.js").default} [stroke] Stroke style.
 * @property {import("./Text.js").default} [text] Text style.
 * @property {number} [zIndex] Z index.
 */ /**
 * @classdesc
 * Container for vector feature rendering styles. Any changes made to the style
 * or its children through `set*()` methods will not take effect until the
 * feature or layer that uses the style is re-rendered.
 *
 * ## Feature styles
 *
 * If no style is defined, the following default style is used:
 * ```js
 *  import {Circle, Fill, Stroke, Style} from 'ol/style.js';
 *
 *  const fill = new Fill({
 *    color: 'rgba(255,255,255,0.4)',
 *  });
 *  const stroke = new Stroke({
 *    color: '#3399CC',
 *    width: 1.25,
 *  });
 *  const styles = [
 *    new Style({
 *      image: new Circle({
 *        fill: fill,
 *        stroke: stroke,
 *        radius: 5,
 *      }),
 *      fill: fill,
 *      stroke: stroke,
 *    }),
 *  ];
 * ```
 *
 * A separate editing style has the following defaults:
 * ```js
 *  import {Circle, Fill, Stroke, Style} from 'ol/style.js';
 *
 *  const styles = {};
 *  const white = [255, 255, 255, 1];
 *  const blue = [0, 153, 255, 1];
 *  const width = 3;
 *  styles['Polygon'] = [
 *    new Style({
 *      fill: new Fill({
 *        color: [255, 255, 255, 0.5],
 *      }),
 *    }),
 *  ];
 *  styles['MultiPolygon'] =
 *      styles['Polygon'];
 *  styles['LineString'] = [
 *    new Style({
 *      stroke: new Stroke({
 *        color: white,
 *        width: width + 2,
 *      }),
 *    }),
 *    new Style({
 *      stroke: new Stroke({
 *        color: blue,
 *        width: width,
 *      }),
 *    }),
 *  ];
 *  styles['MultiLineString'] = styles['LineString'];
 *
 *  styles['Circle'] = styles['Polygon'].concat(
 *    styles['LineString']
 *  );
 *
 *  styles['Point'] = [
 *    new Style({
 *      image: new Circle({
 *        radius: width * 2,
 *        fill: new Fill({
 *          color: blue,
 *        }),
 *        stroke: new Stroke({
 *          color: white,
 *          width: width / 2,
 *        }),
 *      }),
 *      zIndex: Infinity,
 *    }),
 *  ];
 *  styles['MultiPoint'] =
 *      styles['Point'];
 *  styles['GeometryCollection'] =
 *      styles['Polygon'].concat(
 *          styles['LineString'],
 *          styles['Point']
 *      );
 * ```
 *
 * @api
 */ class $8c7f6dda98e8cb9c$var$Style {
    /**
   * @param {Options} [options] Style options.
   */ constructor(options){
        options = options || {};
        /**
     * @private
     * @type {string|import("../geom/Geometry.js").default|GeometryFunction|null}
     */ this.geometry_ = null;
        /**
     * @private
     * @type {!GeometryFunction}
     */ this.geometryFunction_ = $8c7f6dda98e8cb9c$var$defaultGeometryFunction;
        if (options.geometry !== undefined) this.setGeometry(options.geometry);
        /**
     * @private
     * @type {import("./Fill.js").default|null}
     */ this.fill_ = options.fill !== undefined ? options.fill : null;
        /**
     * @private
     * @type {import("./Image.js").default|null}
     */ this.image_ = options.image !== undefined ? options.image : null;
        /**
     * @private
     * @type {RenderFunction|null}
     */ this.renderer_ = options.renderer !== undefined ? options.renderer : null;
        /**
     * @private
     * @type {RenderFunction|null}
     */ this.hitDetectionRenderer_ = options.hitDetectionRenderer !== undefined ? options.hitDetectionRenderer : null;
        /**
     * @private
     * @type {import("./Stroke.js").default|null}
     */ this.stroke_ = options.stroke !== undefined ? options.stroke : null;
        /**
     * @private
     * @type {import("./Text.js").default|null}
     */ this.text_ = options.text !== undefined ? options.text : null;
        /**
     * @private
     * @type {number|undefined}
     */ this.zIndex_ = options.zIndex;
    }
    /**
   * Clones the style.
   * @return {Style} The cloned style.
   * @api
   */ clone() {
        let geometry = this.getGeometry();
        if (geometry && typeof geometry === 'object') geometry = /** @type {import("../geom/Geometry.js").default} */ geometry.clone();
        return new $8c7f6dda98e8cb9c$var$Style({
            geometry: geometry ?? undefined,
            fill: this.getFill() ? this.getFill().clone() : undefined,
            image: this.getImage() ? this.getImage().clone() : undefined,
            renderer: this.getRenderer() ?? undefined,
            stroke: this.getStroke() ? this.getStroke().clone() : undefined,
            text: this.getText() ? this.getText().clone() : undefined,
            zIndex: this.getZIndex()
        });
    }
    /**
   * Get the custom renderer function that was configured with
   * {@link #setRenderer} or the `renderer` constructor option.
   * @return {RenderFunction|null} Custom renderer function.
   * @api
   */ getRenderer() {
        return this.renderer_;
    }
    /**
   * Sets a custom renderer function for this style. When set, `fill`, `stroke`
   * and `image` options of the style will be ignored.
   * @param {RenderFunction|null} renderer Custom renderer function.
   * @api
   */ setRenderer(renderer) {
        this.renderer_ = renderer;
    }
    /**
   * Sets a custom renderer function for this style used
   * in hit detection.
   * @param {RenderFunction|null} renderer Custom renderer function.
   * @api
   */ setHitDetectionRenderer(renderer) {
        this.hitDetectionRenderer_ = renderer;
    }
    /**
   * Get the custom renderer function that was configured with
   * {@link #setHitDetectionRenderer} or the `hitDetectionRenderer` constructor option.
   * @return {RenderFunction|null} Custom renderer function.
   * @api
   */ getHitDetectionRenderer() {
        return this.hitDetectionRenderer_;
    }
    /**
   * Get the geometry to be rendered.
   * @return {string|import("../geom/Geometry.js").default|GeometryFunction|null}
   * Feature property or geometry or function that returns the geometry that will
   * be rendered with this style.
   * @api
   */ getGeometry() {
        return this.geometry_;
    }
    /**
   * Get the function used to generate a geometry for rendering.
   * @return {!GeometryFunction} Function that is called with a feature
   * and returns the geometry to render instead of the feature's geometry.
   * @api
   */ getGeometryFunction() {
        return this.geometryFunction_;
    }
    /**
   * Get the fill style.
   * @return {import("./Fill.js").default|null} Fill style.
   * @api
   */ getFill() {
        return this.fill_;
    }
    /**
   * Set the fill style.
   * @param {import("./Fill.js").default|null} fill Fill style.
   * @api
   */ setFill(fill) {
        this.fill_ = fill;
    }
    /**
   * Get the image style.
   * @return {import("./Image.js").default|null} Image style.
   * @api
   */ getImage() {
        return this.image_;
    }
    /**
   * Set the image style.
   * @param {import("./Image.js").default} image Image style.
   * @api
   */ setImage(image) {
        this.image_ = image;
    }
    /**
   * Get the stroke style.
   * @return {import("./Stroke.js").default|null} Stroke style.
   * @api
   */ getStroke() {
        return this.stroke_;
    }
    /**
   * Set the stroke style.
   * @param {import("./Stroke.js").default|null} stroke Stroke style.
   * @api
   */ setStroke(stroke) {
        this.stroke_ = stroke;
    }
    /**
   * Get the text style.
   * @return {import("./Text.js").default|null} Text style.
   * @api
   */ getText() {
        return this.text_;
    }
    /**
   * Set the text style.
   * @param {import("./Text.js").default} text Text style.
   * @api
   */ setText(text) {
        this.text_ = text;
    }
    /**
   * Get the z-index for the style.
   * @return {number|undefined} ZIndex.
   * @api
   */ getZIndex() {
        return this.zIndex_;
    }
    /**
   * Set a geometry that is rendered instead of the feature's geometry.
   *
   * @param {string|import("../geom/Geometry.js").default|GeometryFunction|null} geometry
   *     Feature property or geometry or function returning a geometry to render
   *     for this style.
   * @api
   */ setGeometry(geometry) {
        if (typeof geometry === 'function') this.geometryFunction_ = geometry;
        else if (typeof geometry === 'string') this.geometryFunction_ = function(feature) {
            return /** @type {import("../geom/Geometry.js").default} */ feature.get(geometry);
        };
        else if (!geometry) this.geometryFunction_ = $8c7f6dda98e8cb9c$var$defaultGeometryFunction;
        else if (geometry !== undefined) this.geometryFunction_ = function() {
            return /** @type {import("../geom/Geometry.js").default} */ geometry;
        };
        this.geometry_ = geometry;
    }
    /**
   * Set the z-index.
   *
   * @param {number|undefined} zIndex ZIndex.
   * @api
   */ setZIndex(zIndex) {
        this.zIndex_ = zIndex;
    }
}
function $8c7f6dda98e8cb9c$export$c314ea3f6b164147(obj) {
    let styleFunction;
    if (typeof obj === 'function') styleFunction = obj;
    else {
        /**
     * @type {Array<Style>}
     */ let styles;
        if (Array.isArray(obj)) styles = obj;
        else {
            (0, $35d5ec884318008e$export$a7a9523472993e97)(typeof /** @type {?} */ obj.getZIndex === 'function', 'Expected an `Style` or an array of `Style`');
            const style = /** @type {Style} */ obj;
            styles = [
                style
            ];
        }
        styleFunction = function() {
            return styles;
        };
    }
    return styleFunction;
}
/**
 * @type {Array<Style>|null}
 */ let $8c7f6dda98e8cb9c$var$defaultStyles = null;
function $8c7f6dda98e8cb9c$export$6865c5ac2f5ce8b6(feature, resolution) {
    // We don't use an immediately-invoked function
    // and a closure so we don't get an error at script evaluation time in
    // browsers that do not support Canvas. (import("./Circle.js").CircleStyle does
    // canvas.getContext('2d') at construction time, which will cause an.error
    // in such browsers.)
    if (!$8c7f6dda98e8cb9c$var$defaultStyles) {
        const fill = new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
            color: 'rgba(255,255,255,0.4)'
        });
        const stroke = new (0, $f9d0329c5c745263$export$2e2bcd8739ae039)({
            color: '#3399CC',
            width: 1.25
        });
        $8c7f6dda98e8cb9c$var$defaultStyles = [
            new $8c7f6dda98e8cb9c$var$Style({
                image: new (0, $06150d8570b7481b$export$2e2bcd8739ae039)({
                    fill: fill,
                    stroke: stroke,
                    radius: 5
                }),
                fill: fill,
                stroke: stroke
            })
        ];
    }
    return $8c7f6dda98e8cb9c$var$defaultStyles;
}
function $8c7f6dda98e8cb9c$export$ed1eaede5d0e77ac() {
    /** @type {Object<import("../geom/Geometry.js").Type, Array<Style>>} */ const styles = {};
    const white = [
        255,
        255,
        255,
        1
    ];
    const blue = [
        0,
        153,
        255,
        1
    ];
    const width = 3;
    styles['Polygon'] = [
        new $8c7f6dda98e8cb9c$var$Style({
            fill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
                color: [
                    255,
                    255,
                    255,
                    0.5
                ]
            })
        })
    ];
    styles['MultiPolygon'] = styles['Polygon'];
    styles['LineString'] = [
        new $8c7f6dda98e8cb9c$var$Style({
            stroke: new (0, $f9d0329c5c745263$export$2e2bcd8739ae039)({
                color: white,
                width: width + 2
            })
        }),
        new $8c7f6dda98e8cb9c$var$Style({
            stroke: new (0, $f9d0329c5c745263$export$2e2bcd8739ae039)({
                color: blue,
                width: width
            })
        })
    ];
    styles['MultiLineString'] = styles['LineString'];
    styles['Circle'] = styles['Polygon'].concat(styles['LineString']);
    styles['Point'] = [
        new $8c7f6dda98e8cb9c$var$Style({
            image: new (0, $06150d8570b7481b$export$2e2bcd8739ae039)({
                radius: width * 2,
                fill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
                    color: blue
                }),
                stroke: new (0, $f9d0329c5c745263$export$2e2bcd8739ae039)({
                    color: white,
                    width: width / 2
                })
            }),
            zIndex: Infinity
        })
    ];
    styles['MultiPoint'] = styles['Point'];
    styles['GeometryCollection'] = styles['Polygon'].concat(styles['LineString'], styles['Point']);
    return styles;
}
/**
 * Function that is called with a feature and returns its default geometry.
 * @param {import("../Feature.js").FeatureLike} feature Feature to get the geometry for.
 * @return {import("../geom/Geometry.js").default|import("../render/Feature.js").default|undefined} Geometry to render.
 */ function $8c7f6dda98e8cb9c$var$defaultGeometryFunction(feature) {
    return feature.getGeometry();
}
var $8c7f6dda98e8cb9c$export$2e2bcd8739ae039 = $8c7f6dda98e8cb9c$var$Style;


/**
 * @module ol/style/Text
 */ 

/**
 * @typedef {'point' | 'line'} TextPlacement
 * Default text placement is `'point'`. Note that
 * `'line'` requires the underlying geometry to be a {@link module:ol/geom/LineString~LineString},
 * {@link module:ol/geom/Polygon~Polygon}, {@link module:ol/geom/MultiLineString~MultiLineString} or
 * {@link module:ol/geom/MultiPolygon~MultiPolygon}.
 */ /**
 * @typedef {'left' | 'center' | 'right'} TextJustify
 */ /**
 * The default fill color to use if no fill was set at construction time; a
 * blackish `#333`.
 *
 * @const {string}
 */ const $944be50faeff5321$var$DEFAULT_FILL_COLOR = '#333';
/**
 * @typedef {Object} Options
 * @property {string} [font] Font style as CSS `font` value, see:
 * https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/font. Default is `'10px sans-serif'`
 * @property {number} [maxAngle=Math.PI/4] When `placement` is set to `'line'`, allow a maximum angle between adjacent characters.
 * The expected value is in radians, and the default is 45° (`Math.PI / 4`).
 * @property {number} [offsetX=0] Horizontal text offset in pixels. A positive will shift the text right.
 * @property {number} [offsetY=0] Vertical text offset in pixels. A positive will shift the text down.
 * @property {boolean} [overflow=false] For polygon labels or when `placement` is set to `'line'`, allow text to exceed
 * the width of the polygon at the label position or the length of the path that it follows.
 * @property {TextPlacement} [placement='point'] Text placement.
 * @property {number} [repeat] Repeat interval. When set, the text will be repeated at this interval, which specifies
 * the distance between two text anchors in pixels. Only available when `placement` is set to `'line'`. Overrides 'textAlign'.
 * @property {number|import("../size.js").Size} [scale] Scale.
 * @property {boolean} [rotateWithView=false] Whether to rotate the text with the view.
 * @property {boolean} [keepUpright=true] Whether the text can be rotated 180° to prevent being rendered upside down.
 * @property {number} [rotation=0] Rotation in radians (positive rotation clockwise).
 * @property {string|Array<string>} [text] Text content or rich text content. For plain text provide a string, which can
 * contain line breaks (`\n`). For rich text provide an array of text/font tuples. A tuple consists of the text to
 * render and the font to use (or `''` to use the text style's font). A line break has to be a separate tuple (i.e. `'\n', ''`).
 * **Example:** `['foo', 'bold 10px sans-serif', ' bar', 'italic 10px sans-serif', ' baz', '']` will yield "**foo** *bar* baz".
 * **Note:** Rich text is not supported for `placement: 'line'` or the immediate rendering API.
 * @property {CanvasTextAlign} [textAlign] Text alignment. Possible values: `'left'`, `'right'`, `'center'`, `'end'` or `'start'`.
 * Default is `'center'` for `placement: 'point'`. For `placement: 'line'`, the default is to let the renderer choose a
 * placement where `maxAngle` is not exceeded.
 * @property {TextJustify} [justify] Text justification within the text box.
 * If not set, text is justified towards the `textAlign` anchor.
 * Otherwise, use options `'left'`, `'center'`, or `'right'` to justify the text within the text box.
 * **Note:** `justify` is ignored for immediate rendering and also for `placement: 'line'`.
 * @property {CanvasTextBaseline} [textBaseline='middle'] Text base line. Possible values: `'bottom'`, `'top'`, `'middle'`, `'alphabetic'`,
 * `'hanging'`, `'ideographic'`.
 * @property {import("./Fill.js").default|null} [fill] Fill style. If none is provided, we'll use a dark fill-style (#333). Specify `null` for no fill.
 * @property {import("./Stroke.js").default} [stroke] Stroke style.
 * @property {import("./Fill.js").default} [backgroundFill] Fill style for the text background when `placement` is
 * `'point'`. Default is no fill.
 * @property {import("./Stroke.js").default} [backgroundStroke] Stroke style for the text background  when `placement`
 * is `'point'`. Default is no stroke.
 * @property {Array<number>} [padding=[0, 0, 0, 0]] Padding in pixels around the text for decluttering and background. The order of
 * values in the array is `[top, right, bottom, left]`.
 * @property {import('../style/Style.js').DeclutterMode} [declutterMode] Declutter mode: `declutter`, `obstacle`, `none`
 */ /**
 * @classdesc
 * Set text style for vector features.
 * @api
 */ class $944be50faeff5321$var$Text {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options || {};
        /**
     * @private
     * @type {string|undefined}
     */ this.font_ = options.font;
        /**
     * @private
     * @type {number|undefined}
     */ this.rotation_ = options.rotation;
        /**
     * @private
     * @type {boolean|undefined}
     */ this.rotateWithView_ = options.rotateWithView;
        /**
     * @private
     * @type {boolean|undefined}
     */ this.keepUpright_ = options.keepUpright;
        /**
     * @private
     * @type {number|import("../size.js").Size|undefined}
     */ this.scale_ = options.scale;
        /**
     * @private
     * @type {import("../size.js").Size}
     */ this.scaleArray_ = (0, $cc435a5409103773$export$a71a825ff42fb8e1)(options.scale !== undefined ? options.scale : 1);
        /**
     * @private
     * @type {string|Array<string>|undefined}
     */ this.text_ = options.text;
        /**
     * @private
     * @type {CanvasTextAlign|undefined}
     */ this.textAlign_ = options.textAlign;
        /**
     * @private
     * @type {TextJustify|undefined}
     */ this.justify_ = options.justify;
        /**
     * @private
     * @type {number|undefined}
     */ this.repeat_ = options.repeat;
        /**
     * @private
     * @type {CanvasTextBaseline|undefined}
     */ this.textBaseline_ = options.textBaseline;
        /**
     * @private
     * @type {import("./Fill.js").default|null}
     */ this.fill_ = options.fill !== undefined ? options.fill : new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
            color: $944be50faeff5321$var$DEFAULT_FILL_COLOR
        });
        /**
     * @private
     * @type {number}
     */ this.maxAngle_ = options.maxAngle !== undefined ? options.maxAngle : Math.PI / 4;
        /**
     * @private
     * @type {TextPlacement}
     */ this.placement_ = options.placement !== undefined ? options.placement : 'point';
        /**
     * @private
     * @type {boolean}
     */ this.overflow_ = !!options.overflow;
        /**
     * @private
     * @type {import("./Stroke.js").default|null}
     */ this.stroke_ = options.stroke !== undefined ? options.stroke : null;
        /**
     * @private
     * @type {number}
     */ this.offsetX_ = options.offsetX !== undefined ? options.offsetX : 0;
        /**
     * @private
     * @type {number}
     */ this.offsetY_ = options.offsetY !== undefined ? options.offsetY : 0;
        /**
     * @private
     * @type {import("./Fill.js").default|null}
     */ this.backgroundFill_ = options.backgroundFill ? options.backgroundFill : null;
        /**
     * @private
     * @type {import("./Stroke.js").default|null}
     */ this.backgroundStroke_ = options.backgroundStroke ? options.backgroundStroke : null;
        /**
     * @private
     * @type {Array<number>|null}
     */ this.padding_ = options.padding === undefined ? null : options.padding;
        /**
     * @private
     * @type {import('../style/Style.js').DeclutterMode}
     */ this.declutterMode_ = options.declutterMode;
    }
    /**
   * Clones the style.
   * @return {Text} The cloned style.
   * @api
   */ clone() {
        const scale = this.getScale();
        return new $944be50faeff5321$var$Text({
            font: this.getFont(),
            placement: this.getPlacement(),
            repeat: this.getRepeat(),
            maxAngle: this.getMaxAngle(),
            overflow: this.getOverflow(),
            rotation: this.getRotation(),
            rotateWithView: this.getRotateWithView(),
            keepUpright: this.getKeepUpright(),
            scale: Array.isArray(scale) ? scale.slice() : scale,
            text: this.getText(),
            textAlign: this.getTextAlign(),
            justify: this.getJustify(),
            textBaseline: this.getTextBaseline(),
            fill: this.getFill() ? this.getFill().clone() : undefined,
            stroke: this.getStroke() ? this.getStroke().clone() : undefined,
            offsetX: this.getOffsetX(),
            offsetY: this.getOffsetY(),
            backgroundFill: this.getBackgroundFill() ? this.getBackgroundFill().clone() : undefined,
            backgroundStroke: this.getBackgroundStroke() ? this.getBackgroundStroke().clone() : undefined,
            padding: this.getPadding() || undefined,
            declutterMode: this.getDeclutterMode()
        });
    }
    /**
   * Get the `overflow` configuration.
   * @return {boolean} Let text overflow the length of the path they follow.
   * @api
   */ getOverflow() {
        return this.overflow_;
    }
    /**
   * Get the font name.
   * @return {string|undefined} Font.
   * @api
   */ getFont() {
        return this.font_;
    }
    /**
   * Get the maximum angle between adjacent characters.
   * @return {number} Angle in radians.
   * @api
   */ getMaxAngle() {
        return this.maxAngle_;
    }
    /**
   * Get the label placement.
   * @return {TextPlacement} Text placement.
   * @api
   */ getPlacement() {
        return this.placement_;
    }
    /**
   * Get the repeat interval of the text.
   * @return {number|undefined} Repeat interval in pixels.
   * @api
   */ getRepeat() {
        return this.repeat_;
    }
    /**
   * Get the x-offset for the text.
   * @return {number} Horizontal text offset.
   * @api
   */ getOffsetX() {
        return this.offsetX_;
    }
    /**
   * Get the y-offset for the text.
   * @return {number} Vertical text offset.
   * @api
   */ getOffsetY() {
        return this.offsetY_;
    }
    /**
   * Get the fill style for the text.
   * @return {import("./Fill.js").default|null} Fill style.
   * @api
   */ getFill() {
        return this.fill_;
    }
    /**
   * Determine whether the text rotates with the map.
   * @return {boolean|undefined} Rotate with map.
   * @api
   */ getRotateWithView() {
        return this.rotateWithView_;
    }
    /**
   * Determine whether the text can be rendered upside down.
   * @return {boolean|undefined} Keep text upright.
   * @api
   */ getKeepUpright() {
        return this.keepUpright_;
    }
    /**
   * Get the text rotation.
   * @return {number|undefined} Rotation.
   * @api
   */ getRotation() {
        return this.rotation_;
    }
    /**
   * Get the text scale.
   * @return {number|import("../size.js").Size|undefined} Scale.
   * @api
   */ getScale() {
        return this.scale_;
    }
    /**
   * Get the symbolizer scale array.
   * @return {import("../size.js").Size} Scale array.
   */ getScaleArray() {
        return this.scaleArray_;
    }
    /**
   * Get the stroke style for the text.
   * @return {import("./Stroke.js").default|null} Stroke style.
   * @api
   */ getStroke() {
        return this.stroke_;
    }
    /**
   * Get the text to be rendered.
   * @return {string|Array<string>|undefined} Text.
   * @api
   */ getText() {
        return this.text_;
    }
    /**
   * Get the text alignment.
   * @return {CanvasTextAlign|undefined} Text align.
   * @api
   */ getTextAlign() {
        return this.textAlign_;
    }
    /**
   * Get the justification.
   * @return {TextJustify|undefined} Justification.
   * @api
   */ getJustify() {
        return this.justify_;
    }
    /**
   * Get the text baseline.
   * @return {CanvasTextBaseline|undefined} Text baseline.
   * @api
   */ getTextBaseline() {
        return this.textBaseline_;
    }
    /**
   * Get the background fill style for the text.
   * @return {import("./Fill.js").default|null} Fill style.
   * @api
   */ getBackgroundFill() {
        return this.backgroundFill_;
    }
    /**
   * Get the background stroke style for the text.
   * @return {import("./Stroke.js").default|null} Stroke style.
   * @api
   */ getBackgroundStroke() {
        return this.backgroundStroke_;
    }
    /**
   * Get the padding for the text.
   * @return {Array<number>|null} Padding.
   * @api
   */ getPadding() {
        return this.padding_;
    }
    /**
   * Get the declutter mode of the shape
   * @return {import("./Style.js").DeclutterMode} Shape's declutter mode
   * @api
   */ getDeclutterMode() {
        return this.declutterMode_;
    }
    /**
   * Set the `overflow` property.
   *
   * @param {boolean} overflow Let text overflow the path that it follows.
   * @api
   */ setOverflow(overflow) {
        this.overflow_ = overflow;
    }
    /**
   * Set the font.
   *
   * @param {string|undefined} font Font.
   * @api
   */ setFont(font) {
        this.font_ = font;
    }
    /**
   * Set the maximum angle between adjacent characters.
   *
   * @param {number} maxAngle Angle in radians.
   * @api
   */ setMaxAngle(maxAngle) {
        this.maxAngle_ = maxAngle;
    }
    /**
   * Set the x offset.
   *
   * @param {number} offsetX Horizontal text offset.
   * @api
   */ setOffsetX(offsetX) {
        this.offsetX_ = offsetX;
    }
    /**
   * Set the y offset.
   *
   * @param {number} offsetY Vertical text offset.
   * @api
   */ setOffsetY(offsetY) {
        this.offsetY_ = offsetY;
    }
    /**
   * Set the text placement.
   *
   * @param {TextPlacement} placement Placement.
   * @api
   */ setPlacement(placement) {
        this.placement_ = placement;
    }
    /**
   * Set the repeat interval of the text.
   * @param {number|undefined} [repeat] Repeat interval in pixels.
   * @api
   */ setRepeat(repeat) {
        this.repeat_ = repeat;
    }
    /**
   * Set whether to rotate the text with the view.
   *
   * @param {boolean} rotateWithView Rotate with map.
   * @api
   */ setRotateWithView(rotateWithView) {
        this.rotateWithView_ = rotateWithView;
    }
    /**
   * Set whether the text can be rendered upside down.
   *
   * @param {boolean} keepUpright Keep text upright.
   * @api
   */ setKeepUpright(keepUpright) {
        this.keepUpright_ = keepUpright;
    }
    /**
   * Set the fill.
   *
   * @param {import("./Fill.js").default|null} fill Fill style.
   * @api
   */ setFill(fill) {
        this.fill_ = fill;
    }
    /**
   * Set the rotation.
   *
   * @param {number|undefined} rotation Rotation.
   * @api
   */ setRotation(rotation) {
        this.rotation_ = rotation;
    }
    /**
   * Set the scale.
   *
   * @param {number|import("../size.js").Size|undefined} scale Scale.
   * @api
   */ setScale(scale) {
        this.scale_ = scale;
        this.scaleArray_ = (0, $cc435a5409103773$export$a71a825ff42fb8e1)(scale !== undefined ? scale : 1);
    }
    /**
   * Set the stroke.
   *
   * @param {import("./Stroke.js").default|null} stroke Stroke style.
   * @api
   */ setStroke(stroke) {
        this.stroke_ = stroke;
    }
    /**
   * Set the text.
   *
   * @param {string|Array<string>|undefined} text Text.
   * @api
   */ setText(text) {
        this.text_ = text;
    }
    /**
   * Set the text alignment.
   *
   * @param {CanvasTextAlign|undefined} textAlign Text align.
   * @api
   */ setTextAlign(textAlign) {
        this.textAlign_ = textAlign;
    }
    /**
   * Set the justification.
   *
   * @param {TextJustify|undefined} justify Justification.
   * @api
   */ setJustify(justify) {
        this.justify_ = justify;
    }
    /**
   * Set the text baseline.
   *
   * @param {CanvasTextBaseline|undefined} textBaseline Text baseline.
   * @api
   */ setTextBaseline(textBaseline) {
        this.textBaseline_ = textBaseline;
    }
    /**
   * Set the background fill.
   *
   * @param {import("./Fill.js").default|null} fill Fill style.
   * @api
   */ setBackgroundFill(fill) {
        this.backgroundFill_ = fill;
    }
    /**
   * Set the background stroke.
   *
   * @param {import("./Stroke.js").default|null} stroke Stroke style.
   * @api
   */ setBackgroundStroke(stroke) {
        this.backgroundStroke_ = stroke;
    }
    /**
   * Set the padding (`[top, right, bottom, left]`).
   *
   * @param {Array<number>|null} padding Padding.
   * @api
   */ setPadding(padding) {
        this.padding_ = padding;
    }
}
var $944be50faeff5321$export$2e2bcd8739ae039 = $944be50faeff5321$var$Text;


/**
 * @fileoverview This module includes functions to build styles for the canvas renderer.  Building
 * is composed of two steps: parsing and compiling.  The parsing step takes an encoded expression
 * and returns an instance of one of the expression classes.  The compiling step takes the
 * expression instance and returns a function that can be evaluated to return a literal value.  The
 * evaluator function should do as little allocation and work as possible.
 */ /**
 * @typedef {import("../../style/flat.js").FlatStyle} FlatStyle
 */ /**
 * @typedef {import("../../expr/expression.js").EncodedExpression} EncodedExpression
 */ /**
 * @typedef {import("../../expr/expression.js").ParsingContext} ParsingContext
 */ /**
 * @typedef {import("../../expr/expression.js").CallExpression} CallExpression
 */ /**
 * @typedef {import("../../expr/cpu.js").EvaluationContext} EvaluationContext
 */ /**
 * @typedef {import("../../expr/cpu.js").ExpressionEvaluator} ExpressionEvaluator
 */ /**
 * @param {EvaluationContext} context The evaluation context.
 * @return {boolean} Always true.
 */ function $6000539d86fde80c$var$always(context) {
    return true;
}
function $6000539d86fde80c$export$fc6a94152b1b05a8(rules) {
    const parsingContext = (0, $778943ec39690f8e$export$1c8b4c1584800354)();
    const evaluator = $6000539d86fde80c$export$d6ae6a4799989976(rules, parsingContext);
    const evaluationContext = (0, $d597295b1f166e98$export$c18f39f0e136c26)();
    return function(feature, resolution) {
        evaluationContext.properties = feature.getPropertiesInternal();
        evaluationContext.resolution = resolution;
        if (parsingContext.featureId) {
            const id = feature.getId();
            if (id !== undefined) evaluationContext.featureId = id;
            else evaluationContext.featureId = null;
        }
        if (parsingContext.geometryType) evaluationContext.geometryType = (0, $778943ec39690f8e$export$8da88d86d10c1295)(feature.getGeometry());
        return evaluator(evaluationContext);
    };
}
function $6000539d86fde80c$export$5a130bc4f0a0420b(flatStyles) {
    const parsingContext = (0, $778943ec39690f8e$export$1c8b4c1584800354)();
    const length = flatStyles.length;
    /**
   * @type {Array<StyleEvaluator>}
   */ const evaluators = new Array(length);
    for(let i = 0; i < length; ++i)evaluators[i] = $6000539d86fde80c$export$a6e5f510497b7388(flatStyles[i], parsingContext);
    const evaluationContext = (0, $d597295b1f166e98$export$c18f39f0e136c26)();
    /**
   * @type {Array<Style>}
   */ const styles = new Array(length);
    return function(feature, resolution) {
        evaluationContext.properties = feature.getPropertiesInternal();
        evaluationContext.resolution = resolution;
        if (parsingContext.featureId) {
            const id = feature.getId();
            if (id !== undefined) evaluationContext.featureId = id;
            else evaluationContext.featureId = null;
        }
        let nonNullCount = 0;
        for(let i = 0; i < length; ++i){
            const style = evaluators[i](evaluationContext);
            if (style) {
                styles[nonNullCount] = style;
                nonNullCount += 1;
            }
        }
        styles.length = nonNullCount;
        return styles;
    };
}
function $6000539d86fde80c$export$d6ae6a4799989976(rules, context) {
    const length = rules.length;
    /**
   * @type {Array<CompiledRule>}
   */ const compiledRules = new Array(length);
    for(let i = 0; i < length; ++i){
        const rule = rules[i];
        const filter = 'filter' in rule ? (0, $d597295b1f166e98$export$b5f535122a9211f0)(rule.filter, (0, $778943ec39690f8e$export$240f7fffab1b25a0), context) : $6000539d86fde80c$var$always;
        /**
     * @type {Array<StyleEvaluator>}
     */ let styles;
        if (Array.isArray(rule.style)) {
            const styleLength = rule.style.length;
            styles = new Array(styleLength);
            for(let j = 0; j < styleLength; ++j)styles[j] = $6000539d86fde80c$export$a6e5f510497b7388(rule.style[j], context);
        } else styles = [
            $6000539d86fde80c$export$a6e5f510497b7388(rule.style, context)
        ];
        compiledRules[i] = {
            filter: filter,
            styles: styles
        };
    }
    return function(context) {
        /**
     * @type {Array<Style>}
     */ const styles = [];
        let someMatched = false;
        for(let i = 0; i < length; ++i){
            const filterEvaluator = compiledRules[i].filter;
            if (!filterEvaluator(context)) continue;
            if (rules[i].else && someMatched) continue;
            someMatched = true;
            for (const styleEvaluator of compiledRules[i].styles){
                const style = styleEvaluator(context);
                if (!style) continue;
                styles.push(style);
            }
        }
        return styles;
    };
}
function $6000539d86fde80c$export$a6e5f510497b7388(flatStyle, context) {
    const evaluateFill = $6000539d86fde80c$var$buildFill(flatStyle, '', context);
    const evaluateStroke = $6000539d86fde80c$var$buildStroke(flatStyle, '', context);
    const evaluateText = $6000539d86fde80c$var$buildText(flatStyle, context);
    const evaluateImage = $6000539d86fde80c$var$buildImage(flatStyle, context);
    const evaluateZIndex = $6000539d86fde80c$var$numberEvaluator(flatStyle, 'z-index', context);
    if (!evaluateFill && !evaluateStroke && !evaluateText && !evaluateImage && !(0, $beaefe87199bb537$export$dd1bc94b04021eeb)(flatStyle)) // assume this is a user error
    // would be nice to check the properties and suggest "did you mean..."
    throw new Error('No fill, stroke, point, or text symbolizer properties in style: ' + JSON.stringify(flatStyle));
    const style = new (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)();
    return function(context) {
        let empty = true;
        if (evaluateFill) {
            const fill = evaluateFill(context);
            if (fill) empty = false;
            style.setFill(fill);
        }
        if (evaluateStroke) {
            const stroke = evaluateStroke(context);
            if (stroke) empty = false;
            style.setStroke(stroke);
        }
        if (evaluateText) {
            const text = evaluateText(context);
            if (text) empty = false;
            style.setText(text);
        }
        if (evaluateImage) {
            const image = evaluateImage(context);
            if (image) empty = false;
            style.setImage(image);
        }
        if (evaluateZIndex) style.setZIndex(evaluateZIndex(context));
        if (empty) return null;
        return style;
    };
}
/**
 * @typedef {function(EvaluationContext):Fill|null} FillEvaluator
 */ /**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} prefix The property prefix.
 * @param {ParsingContext} context The parsing context.
 * @return {FillEvaluator?} A function that evaluates to a fill.
 */ function $6000539d86fde80c$var$buildFill(flatStyle, prefix, context) {
    let evaluateColor;
    if (prefix + 'fill-pattern-src' in flatStyle) evaluateColor = $6000539d86fde80c$var$patternEvaluator(flatStyle, prefix + 'fill-', context);
    else {
        if (flatStyle[prefix + 'fill-color'] === 'none') // avoids hit detection
        return (context)=>null;
        evaluateColor = $6000539d86fde80c$var$colorLikeEvaluator(flatStyle, prefix + 'fill-color', context);
    }
    if (!evaluateColor) return null;
    const fill = new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)();
    return function(context) {
        const color = evaluateColor(context);
        if (color === (0, $322346e1ff7894ca$export$6c844c64a5efe1ee)) return null;
        fill.setColor(color);
        return fill;
    };
}
/**
 * @typedef {function(EvaluationContext):Stroke|null} StrokeEvaluator
 */ /**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} prefix The property prefix.
 * @param {ParsingContext} context The parsing context.
 * @return {StrokeEvaluator?} A function the evaluates to a stroke.
 */ function $6000539d86fde80c$var$buildStroke(flatStyle, prefix, context) {
    const evaluateWidth = $6000539d86fde80c$var$numberEvaluator(flatStyle, prefix + 'stroke-width', context);
    const evaluateColor = $6000539d86fde80c$var$colorLikeEvaluator(flatStyle, prefix + 'stroke-color', context);
    if (!evaluateWidth && !evaluateColor) return null;
    const evaluateLineCap = $6000539d86fde80c$var$stringEvaluator(flatStyle, prefix + 'stroke-line-cap', context);
    const evaluateLineJoin = $6000539d86fde80c$var$stringEvaluator(flatStyle, prefix + 'stroke-line-join', context);
    const evaluateLineDash = $6000539d86fde80c$var$numberArrayEvaluator(flatStyle, prefix + 'stroke-line-dash', context);
    const evaluateLineDashOffset = $6000539d86fde80c$var$numberEvaluator(flatStyle, prefix + 'stroke-line-dash-offset', context);
    const evaluateMiterLimit = $6000539d86fde80c$var$numberEvaluator(flatStyle, prefix + 'stroke-miter-limit', context);
    const stroke = new (0, $f9d0329c5c745263$export$2e2bcd8739ae039)();
    return function(context) {
        if (evaluateColor) {
            const color = evaluateColor(context);
            if (color === (0, $322346e1ff7894ca$export$6c844c64a5efe1ee)) return null;
            stroke.setColor(color);
        }
        if (evaluateWidth) stroke.setWidth(evaluateWidth(context));
        if (evaluateLineCap) {
            const lineCap = evaluateLineCap(context);
            if (lineCap !== 'butt' && lineCap !== 'round' && lineCap !== 'square') throw new Error('Expected butt, round, or square line cap');
            stroke.setLineCap(lineCap);
        }
        if (evaluateLineJoin) {
            const lineJoin = evaluateLineJoin(context);
            if (lineJoin !== 'bevel' && lineJoin !== 'round' && lineJoin !== 'miter') throw new Error('Expected bevel, round, or miter line join');
            stroke.setLineJoin(lineJoin);
        }
        if (evaluateLineDash) stroke.setLineDash(evaluateLineDash(context));
        if (evaluateLineDashOffset) stroke.setLineDashOffset(evaluateLineDashOffset(context));
        if (evaluateMiterLimit) stroke.setMiterLimit(evaluateMiterLimit(context));
        return stroke;
    };
}
/**
 * @typedef {function(EvaluationContext):Text} TextEvaluator
 */ /**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {ParsingContext} context The parsing context.
 * @return {TextEvaluator?} A function that evaluates to a text symbolizer.
 */ function $6000539d86fde80c$var$buildText(flatStyle, context) {
    const prefix = 'text-';
    // Currently, an Array<string> may be used for rich text support.  This doesn't
    // work with our expression syntax where arrays of strings are interpreted as
    // call expressions.  To support rich text, we could add a 'strings' operator
    // where all the following arguments would be string values.
    const evaluateValue = $6000539d86fde80c$var$stringEvaluator(flatStyle, prefix + 'value', context);
    if (!evaluateValue) return null;
    const evaluateFill = $6000539d86fde80c$var$buildFill(flatStyle, prefix, context);
    const evaluateBackgroundFill = $6000539d86fde80c$var$buildFill(flatStyle, prefix + 'background-', context);
    const evaluateStroke = $6000539d86fde80c$var$buildStroke(flatStyle, prefix, context);
    const evaluateBackgroundStroke = $6000539d86fde80c$var$buildStroke(flatStyle, prefix + 'background-', context);
    const evaluateFont = $6000539d86fde80c$var$stringEvaluator(flatStyle, prefix + 'font', context);
    const evaluateMaxAngle = $6000539d86fde80c$var$numberEvaluator(flatStyle, prefix + 'max-angle', context);
    const evaluateOffsetX = $6000539d86fde80c$var$numberEvaluator(flatStyle, prefix + 'offset-x', context);
    const evaluateOffsetY = $6000539d86fde80c$var$numberEvaluator(flatStyle, prefix + 'offset-y', context);
    const evaluateOverflow = $6000539d86fde80c$var$booleanEvaluator(flatStyle, prefix + 'overflow', context);
    const evaluatePlacement = $6000539d86fde80c$var$stringEvaluator(flatStyle, prefix + 'placement', context);
    const evaluateRepeat = $6000539d86fde80c$var$numberEvaluator(flatStyle, prefix + 'repeat', context);
    const evaluateScale = $6000539d86fde80c$var$sizeLikeEvaluator(flatStyle, prefix + 'scale', context);
    const evaluateRotateWithView = $6000539d86fde80c$var$booleanEvaluator(flatStyle, prefix + 'rotate-with-view', context);
    const evaluateRotation = $6000539d86fde80c$var$numberEvaluator(flatStyle, prefix + 'rotation', context);
    const evaluateAlign = $6000539d86fde80c$var$stringEvaluator(flatStyle, prefix + 'align', context);
    const evaluateJustify = $6000539d86fde80c$var$stringEvaluator(flatStyle, prefix + 'justify', context);
    const evaluateBaseline = $6000539d86fde80c$var$stringEvaluator(flatStyle, prefix + 'baseline', context);
    const evaluateKeepUpright = $6000539d86fde80c$var$booleanEvaluator(flatStyle, prefix + 'keep-upright', context);
    const evaluatePadding = $6000539d86fde80c$var$numberArrayEvaluator(flatStyle, prefix + 'padding', context);
    // The following properties are not currently settable
    const declutterMode = $6000539d86fde80c$var$optionalDeclutterMode(flatStyle, prefix + 'declutter-mode');
    const text = new (0, $944be50faeff5321$export$2e2bcd8739ae039)({
        declutterMode: declutterMode
    });
    return function(context) {
        text.setText(evaluateValue(context));
        if (evaluateFill) text.setFill(evaluateFill(context));
        if (evaluateBackgroundFill) text.setBackgroundFill(evaluateBackgroundFill(context));
        if (evaluateStroke) text.setStroke(evaluateStroke(context));
        if (evaluateBackgroundStroke) text.setBackgroundStroke(evaluateBackgroundStroke(context));
        if (evaluateFont) text.setFont(evaluateFont(context));
        if (evaluateMaxAngle) text.setMaxAngle(evaluateMaxAngle(context));
        if (evaluateOffsetX) text.setOffsetX(evaluateOffsetX(context));
        if (evaluateOffsetY) text.setOffsetY(evaluateOffsetY(context));
        if (evaluateOverflow) text.setOverflow(evaluateOverflow(context));
        if (evaluatePlacement) {
            const placement = evaluatePlacement(context);
            if (placement !== 'point' && placement !== 'line') throw new Error('Expected point or line for text-placement');
            text.setPlacement(placement);
        }
        if (evaluateRepeat) text.setRepeat(evaluateRepeat(context));
        if (evaluateScale) text.setScale(evaluateScale(context));
        if (evaluateRotateWithView) text.setRotateWithView(evaluateRotateWithView(context));
        if (evaluateRotation) text.setRotation(evaluateRotation(context));
        if (evaluateAlign) {
            const textAlign = evaluateAlign(context);
            if (textAlign !== 'left' && textAlign !== 'center' && textAlign !== 'right' && textAlign !== 'end' && textAlign !== 'start') throw new Error('Expected left, right, center, start, or end for text-align');
            text.setTextAlign(textAlign);
        }
        if (evaluateJustify) {
            const justify = evaluateJustify(context);
            if (justify !== 'left' && justify !== 'right' && justify !== 'center') throw new Error('Expected left, right, or center for text-justify');
            text.setJustify(justify);
        }
        if (evaluateBaseline) {
            const textBaseline = evaluateBaseline(context);
            if (textBaseline !== 'bottom' && textBaseline !== 'top' && textBaseline !== 'middle' && textBaseline !== 'alphabetic' && textBaseline !== 'hanging') throw new Error('Expected bottom, top, middle, alphabetic, or hanging for text-baseline');
            text.setTextBaseline(textBaseline);
        }
        if (evaluatePadding) text.setPadding(evaluatePadding(context));
        if (evaluateKeepUpright) text.setKeepUpright(evaluateKeepUpright(context));
        return text;
    };
}
/**
 * @typedef {function(EvaluationContext):import("../../style/Image.js").default} ImageEvaluator
 */ /**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {ParsingContext} context The parsing context.
 * @return {ImageEvaluator?} A function that evaluates to an image symbolizer.
 */ function $6000539d86fde80c$var$buildImage(flatStyle, context) {
    if ('icon-src' in flatStyle) return $6000539d86fde80c$var$buildIcon(flatStyle, context);
    if ('shape-points' in flatStyle) return $6000539d86fde80c$var$buildShape(flatStyle, context);
    if ('circle-radius' in flatStyle) return $6000539d86fde80c$var$buildCircle(flatStyle, context);
    return null;
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {ParsingContext} context The parsing context.
 * @return {ImageEvaluator} A function that evaluates to an image symbolizer.
 */ function $6000539d86fde80c$var$buildIcon(flatStyle, context) {
    const prefix = 'icon-';
    // required property
    const srcName = prefix + 'src';
    const src = $6000539d86fde80c$var$requireString(flatStyle[srcName], srcName);
    // settable properties
    const evaluateAnchor = $6000539d86fde80c$var$coordinateEvaluator(flatStyle, prefix + 'anchor', context);
    const evaluateScale = $6000539d86fde80c$var$sizeLikeEvaluator(flatStyle, prefix + 'scale', context);
    const evaluateOpacity = $6000539d86fde80c$var$numberEvaluator(flatStyle, prefix + 'opacity', context);
    const evaluateDisplacement = $6000539d86fde80c$var$coordinateEvaluator(flatStyle, prefix + 'displacement', context);
    const evaluateRotation = $6000539d86fde80c$var$numberEvaluator(flatStyle, prefix + 'rotation', context);
    const evaluateRotateWithView = $6000539d86fde80c$var$booleanEvaluator(flatStyle, prefix + 'rotate-with-view', context);
    // the remaining symbolizer properties are not currently settable
    const anchorOrigin = $6000539d86fde80c$var$optionalIconOrigin(flatStyle, prefix + 'anchor-origin');
    const anchorXUnits = $6000539d86fde80c$var$optionalIconAnchorUnits(flatStyle, prefix + 'anchor-x-units');
    const anchorYUnits = $6000539d86fde80c$var$optionalIconAnchorUnits(flatStyle, prefix + 'anchor-y-units');
    const color = $6000539d86fde80c$var$optionalColorLike(flatStyle, prefix + 'color');
    const crossOrigin = $6000539d86fde80c$var$optionalString(flatStyle, prefix + 'cross-origin');
    const offset = $6000539d86fde80c$var$optionalNumberArray(flatStyle, prefix + 'offset');
    const offsetOrigin = $6000539d86fde80c$var$optionalIconOrigin(flatStyle, prefix + 'offset-origin');
    const width = $6000539d86fde80c$var$optionalNumber(flatStyle, prefix + 'width');
    const height = $6000539d86fde80c$var$optionalNumber(flatStyle, prefix + 'height');
    const size = $6000539d86fde80c$var$optionalSize(flatStyle, prefix + 'size');
    const declutterMode = $6000539d86fde80c$var$optionalDeclutterMode(flatStyle, prefix + 'declutter-mode');
    const icon = new (0, $8463d325b53eeb0c$export$2e2bcd8739ae039)({
        src: src,
        anchorOrigin: anchorOrigin,
        anchorXUnits: anchorXUnits,
        anchorYUnits: anchorYUnits,
        color: color,
        crossOrigin: crossOrigin,
        offset: offset,
        offsetOrigin: offsetOrigin,
        height: height,
        width: width,
        size: size,
        declutterMode: declutterMode
    });
    return function(context) {
        if (evaluateOpacity) icon.setOpacity(evaluateOpacity(context));
        if (evaluateDisplacement) icon.setDisplacement(evaluateDisplacement(context));
        if (evaluateRotation) icon.setRotation(evaluateRotation(context));
        if (evaluateRotateWithView) icon.setRotateWithView(evaluateRotateWithView(context));
        if (evaluateScale) icon.setScale(evaluateScale(context));
        if (evaluateAnchor) icon.setAnchor(evaluateAnchor(context));
        return icon;
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {ParsingContext} context The parsing context.
 * @return {ImageEvaluator} A function that evaluates to an icon symbolizer.
 */ function $6000539d86fde80c$var$buildShape(flatStyle, context) {
    const prefix = 'shape-';
    // required property
    const pointsName = prefix + 'points';
    const radiusName = prefix + 'radius';
    const points = $6000539d86fde80c$var$requireNumber(flatStyle[pointsName], pointsName);
    const radius = $6000539d86fde80c$var$requireNumber(flatStyle[radiusName], radiusName);
    // settable properties
    const evaluateFill = $6000539d86fde80c$var$buildFill(flatStyle, prefix, context);
    const evaluateStroke = $6000539d86fde80c$var$buildStroke(flatStyle, prefix, context);
    const evaluateScale = $6000539d86fde80c$var$sizeLikeEvaluator(flatStyle, prefix + 'scale', context);
    const evaluateDisplacement = $6000539d86fde80c$var$coordinateEvaluator(flatStyle, prefix + 'displacement', context);
    const evaluateRotation = $6000539d86fde80c$var$numberEvaluator(flatStyle, prefix + 'rotation', context);
    const evaluateRotateWithView = $6000539d86fde80c$var$booleanEvaluator(flatStyle, prefix + 'rotate-with-view', context);
    // the remaining properties are not currently settable
    const radius2 = $6000539d86fde80c$var$optionalNumber(flatStyle, prefix + 'radius2');
    const angle = $6000539d86fde80c$var$optionalNumber(flatStyle, prefix + 'angle');
    const declutterMode = $6000539d86fde80c$var$optionalDeclutterMode(flatStyle, prefix + 'declutter-mode');
    const shape = new (0, $3e99c452138b2224$export$2e2bcd8739ae039)({
        points: points,
        radius: radius,
        radius2: radius2,
        angle: angle,
        declutterMode: declutterMode
    });
    return function(context) {
        if (evaluateFill) shape.setFill(evaluateFill(context));
        if (evaluateStroke) shape.setStroke(evaluateStroke(context));
        if (evaluateDisplacement) shape.setDisplacement(evaluateDisplacement(context));
        if (evaluateRotation) shape.setRotation(evaluateRotation(context));
        if (evaluateRotateWithView) shape.setRotateWithView(evaluateRotateWithView(context));
        if (evaluateScale) shape.setScale(evaluateScale(context));
        return shape;
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {ParsingContext} context The parsing context.
 * @return {ImageEvaluator} A function that evaluates to a circle symbolizer.
 */ function $6000539d86fde80c$var$buildCircle(flatStyle, context) {
    const prefix = 'circle-';
    // settable properties
    const evaluateFill = $6000539d86fde80c$var$buildFill(flatStyle, prefix, context);
    const evaluateStroke = $6000539d86fde80c$var$buildStroke(flatStyle, prefix, context);
    const evaluateRadius = $6000539d86fde80c$var$numberEvaluator(flatStyle, prefix + 'radius', context);
    const evaluateScale = $6000539d86fde80c$var$sizeLikeEvaluator(flatStyle, prefix + 'scale', context);
    const evaluateDisplacement = $6000539d86fde80c$var$coordinateEvaluator(flatStyle, prefix + 'displacement', context);
    const evaluateRotation = $6000539d86fde80c$var$numberEvaluator(flatStyle, prefix + 'rotation', context);
    const evaluateRotateWithView = $6000539d86fde80c$var$booleanEvaluator(flatStyle, prefix + 'rotate-with-view', context);
    // the remaining properties are not currently settable
    const declutterMode = $6000539d86fde80c$var$optionalDeclutterMode(flatStyle, prefix + 'declutter-mode');
    const circle = new (0, $06150d8570b7481b$export$2e2bcd8739ae039)({
        radius: 5,
        declutterMode: declutterMode
    });
    return function(context) {
        if (evaluateRadius) circle.setRadius(evaluateRadius(context));
        if (evaluateFill) circle.setFill(evaluateFill(context));
        if (evaluateStroke) circle.setStroke(evaluateStroke(context));
        if (evaluateDisplacement) circle.setDisplacement(evaluateDisplacement(context));
        if (evaluateRotation) circle.setRotation(evaluateRotation(context));
        if (evaluateRotateWithView) circle.setRotateWithView(evaluateRotateWithView(context));
        if (evaluateScale) circle.setScale(evaluateScale(context));
        return circle;
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @param {ParsingContext} context The parsing context.
 * @return {import('../../expr/cpu.js').NumberEvaluator|undefined} The expression evaluator or undefined.
 */ function $6000539d86fde80c$var$numberEvaluator(flatStyle, name, context) {
    if (!(name in flatStyle)) return undefined;
    const evaluator = (0, $d597295b1f166e98$export$b5f535122a9211f0)(flatStyle[name], (0, $778943ec39690f8e$export$86a7aca748b1e260), context);
    return function(context) {
        return $6000539d86fde80c$var$requireNumber(evaluator(context), name);
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @param {ParsingContext} context The parsing context.
 * @return {import('../../expr/cpu.js').StringEvaluator?} The expression evaluator.
 */ function $6000539d86fde80c$var$stringEvaluator(flatStyle, name, context) {
    if (!(name in flatStyle)) return null;
    const evaluator = (0, $d597295b1f166e98$export$b5f535122a9211f0)(flatStyle[name], (0, $778943ec39690f8e$export$2b93044cbf134323), context);
    return function(context) {
        return $6000539d86fde80c$var$requireString(evaluator(context), name);
    };
}
function $6000539d86fde80c$var$patternEvaluator(flatStyle, prefix, context) {
    const srcEvaluator = $6000539d86fde80c$var$stringEvaluator(flatStyle, prefix + 'pattern-src', context);
    const offsetEvaluator = $6000539d86fde80c$var$sizeEvaluator(flatStyle, prefix + 'pattern-offset', context);
    const patternSizeEvaluator = $6000539d86fde80c$var$sizeEvaluator(flatStyle, prefix + 'pattern-size', context);
    const colorEvaluator = $6000539d86fde80c$var$colorLikeEvaluator(flatStyle, prefix + 'color', context);
    return function(context) {
        return {
            src: srcEvaluator(context),
            offset: offsetEvaluator && offsetEvaluator(context),
            size: patternSizeEvaluator && patternSizeEvaluator(context),
            color: colorEvaluator && colorEvaluator(context)
        };
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @param {ParsingContext} context The parsing context.
 * @return {import('../../expr/cpu.js').BooleanEvaluator?} The expression evaluator.
 */ function $6000539d86fde80c$var$booleanEvaluator(flatStyle, name, context) {
    if (!(name in flatStyle)) return null;
    const evaluator = (0, $d597295b1f166e98$export$b5f535122a9211f0)(flatStyle[name], (0, $778943ec39690f8e$export$240f7fffab1b25a0), context);
    return function(context) {
        const value = evaluator(context);
        if (typeof value !== 'boolean') throw new Error(`Expected a boolean for ${name}`);
        return value;
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @param {ParsingContext} context The parsing context.
 * @return {import('../../expr/cpu.js').ColorLikeEvaluator?} The expression evaluator.
 */ function $6000539d86fde80c$var$colorLikeEvaluator(flatStyle, name, context) {
    if (!(name in flatStyle)) return null;
    const evaluator = (0, $d597295b1f166e98$export$b5f535122a9211f0)(flatStyle[name], (0, $778943ec39690f8e$export$2cd82751acc0e609), context);
    return function(context) {
        return $6000539d86fde80c$var$requireColorLike(evaluator(context), name);
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @param {ParsingContext} context The parsing context.
 * @return {import('../../expr/cpu.js').NumberArrayEvaluator?} The expression evaluator.
 */ function $6000539d86fde80c$var$numberArrayEvaluator(flatStyle, name, context) {
    if (!(name in flatStyle)) return null;
    const evaluator = (0, $d597295b1f166e98$export$b5f535122a9211f0)(flatStyle[name], (0, $778943ec39690f8e$export$d701d0e49f4bcb39), context);
    return function(context) {
        return $6000539d86fde80c$var$requireNumberArray(evaluator(context), name);
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @param {ParsingContext} context The parsing context.
 * @return {import('../../expr/cpu.js').CoordinateEvaluator?} The expression evaluator.
 */ function $6000539d86fde80c$var$coordinateEvaluator(flatStyle, name, context) {
    if (!(name in flatStyle)) return null;
    const evaluator = (0, $d597295b1f166e98$export$b5f535122a9211f0)(flatStyle[name], (0, $778943ec39690f8e$export$d701d0e49f4bcb39), context);
    return function(context) {
        const array = $6000539d86fde80c$var$requireNumberArray(evaluator(context), name);
        if (array.length !== 2) throw new Error(`Expected two numbers for ${name}`);
        return array;
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @param {ParsingContext} context The parsing context.
 * @return {import('../../expr/cpu.js').SizeEvaluator?} The expression evaluator.
 */ function $6000539d86fde80c$var$sizeEvaluator(flatStyle, name, context) {
    if (!(name in flatStyle)) return null;
    const evaluator = (0, $d597295b1f166e98$export$b5f535122a9211f0)(flatStyle[name], (0, $778943ec39690f8e$export$d701d0e49f4bcb39), context);
    return function(context) {
        return $6000539d86fde80c$var$requireSize(evaluator(context), name);
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @param {ParsingContext} context The parsing context.
 * @return {import('../../expr/cpu.js').SizeLikeEvaluator?} The expression evaluator.
 */ function $6000539d86fde80c$var$sizeLikeEvaluator(flatStyle, name, context) {
    if (!(name in flatStyle)) return null;
    const evaluator = (0, $d597295b1f166e98$export$b5f535122a9211f0)(flatStyle[name], (0, $778943ec39690f8e$export$d701d0e49f4bcb39) | (0, $778943ec39690f8e$export$86a7aca748b1e260), context);
    return function(context) {
        return $6000539d86fde80c$var$requireSizeLike(evaluator(context), name);
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} property The symbolizer property.
 * @return {number|undefined} A number or undefined.
 */ function $6000539d86fde80c$var$optionalNumber(flatStyle, property) {
    const value = flatStyle[property];
    if (value === undefined) return undefined;
    if (typeof value !== 'number') throw new Error(`Expected a number for ${property}`);
    return value;
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} property The symbolizer property.
 * @return {import("../../size.js").Size|undefined} A size or undefined.
 */ function $6000539d86fde80c$var$optionalSize(flatStyle, property) {
    const encoded = flatStyle[property];
    if (encoded === undefined) return undefined;
    if (typeof encoded === 'number') return (0, $cc435a5409103773$export$a71a825ff42fb8e1)(encoded);
    if (!Array.isArray(encoded)) throw new Error(`Expected a number or size array for ${property}`);
    if (encoded.length !== 2 || typeof encoded[0] !== 'number' || typeof encoded[1] !== 'number') throw new Error(`Expected a number or size array for ${property}`);
    return encoded;
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} property The symbolizer property.
 * @return {string|undefined} A string or undefined.
 */ function $6000539d86fde80c$var$optionalString(flatStyle, property) {
    const encoded = flatStyle[property];
    if (encoded === undefined) return undefined;
    if (typeof encoded !== 'string') throw new Error(`Expected a string for ${property}`);
    return encoded;
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} property The symbolizer property.
 * @return {import("../../style/Icon.js").IconOrigin|undefined} An icon origin or undefined.
 */ function $6000539d86fde80c$var$optionalIconOrigin(flatStyle, property) {
    const encoded = flatStyle[property];
    if (encoded === undefined) return undefined;
    if (encoded !== 'bottom-left' && encoded !== 'bottom-right' && encoded !== 'top-left' && encoded !== 'top-right') throw new Error(`Expected bottom-left, bottom-right, top-left, or top-right for ${property}`);
    return encoded;
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} property The symbolizer property.
 * @return {import("../../style/Icon.js").IconAnchorUnits|undefined} Icon anchor units or undefined.
 */ function $6000539d86fde80c$var$optionalIconAnchorUnits(flatStyle, property) {
    const encoded = flatStyle[property];
    if (encoded === undefined) return undefined;
    if (encoded !== 'pixels' && encoded !== 'fraction') throw new Error(`Expected pixels or fraction for ${property}`);
    return encoded;
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} property The symbolizer property.
 * @return {Array<number>|undefined} An array of numbers or undefined.
 */ function $6000539d86fde80c$var$optionalNumberArray(flatStyle, property) {
    const encoded = flatStyle[property];
    if (encoded === undefined) return undefined;
    return $6000539d86fde80c$var$requireNumberArray(encoded, property);
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} property The symbolizer property.
 * @return {import('../../style/Style.js').DeclutterMode} Icon declutter mode.
 */ function $6000539d86fde80c$var$optionalDeclutterMode(flatStyle, property) {
    const encoded = flatStyle[property];
    if (encoded === undefined) return undefined;
    if (typeof encoded !== 'string') throw new Error(`Expected a string for ${property}`);
    if (encoded !== 'declutter' && encoded !== 'obstacle' && encoded !== 'none') throw new Error(`Expected declutter, obstacle, or none for ${property}`);
    return encoded;
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} property The symbolizer property.
 * @return {string|Array<number>|undefined} A string or an array of color values or undefined.
 */ function $6000539d86fde80c$var$optionalColorLike(flatStyle, property) {
    const encoded = flatStyle[property];
    if (encoded === undefined) return undefined;
    return $6000539d86fde80c$var$requireColorLike(encoded, property);
}
/**
 * @param {any} value The value.
 * @param {string} property The property.
 * @return {Array<number>} An array of numbers.
 */ function $6000539d86fde80c$var$requireNumberArray(value, property) {
    if (!Array.isArray(value)) throw new Error(`Expected an array for ${property}`);
    const length = value.length;
    for(let i = 0; i < length; ++i){
        if (typeof value[i] !== 'number') throw new Error(`Expected an array of numbers for ${property}`);
    }
    return value;
}
/**
 * @param {any} value The value.
 * @param {string} property The property.
 * @return {string} A string.
 */ function $6000539d86fde80c$var$requireString(value, property) {
    if (typeof value !== 'string') throw new Error(`Expected a string for ${property}`);
    return value;
}
/**
 * @param {any} value The value.
 * @param {string} property The property.
 * @return {number} A number.
 */ function $6000539d86fde80c$var$requireNumber(value, property) {
    if (typeof value !== 'number') throw new Error(`Expected a number for ${property}`);
    return value;
}
/**
 * @param {any} value The value.
 * @param {string} property The property.
 * @return {Array<number>|string} A color.
 */ function $6000539d86fde80c$var$requireColorLike(value, property) {
    if (typeof value === 'string') return value;
    const array = $6000539d86fde80c$var$requireNumberArray(value, property);
    const length = array.length;
    if (length < 3 || length > 4) throw new Error(`Expected a color with 3 or 4 values for ${property}`);
    return array;
}
/**
 * @param {any} value The value.
 * @param {string} property The property.
 * @return {Array<number>} A number or an array of two numbers.
 */ function $6000539d86fde80c$var$requireSize(value, property) {
    const size = $6000539d86fde80c$var$requireNumberArray(value, property);
    if (size.length !== 2) throw new Error(`Expected an array of two numbers for ${property}`);
    return size;
}
/**
 * @param {any} value The value.
 * @param {string} property The property.
 * @return {number|Array<number>} A number or an array of two numbers.
 */ function $6000539d86fde80c$var$requireSizeLike(value, property) {
    if (typeof value === 'number') return value;
    return $6000539d86fde80c$var$requireSize(value, property);
}




/***
 * @template T
 * @typedef {T extends import("../source/Vector.js").default<infer U extends import("../Feature.js").FeatureLike> ? U : never} ExtractedFeatureType
 */ /**
 * @template {import('../Feature').FeatureLike} FeatureType
 * @template {import("../source/Vector.js").default<FeatureType>|import("../source/VectorTile.js").default<FeatureType>} VectorSourceType<FeatureType>
 * @typedef {Object} Options
 * @property {string} [className='ol-layer'] A CSS class name to set to the layer element.
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {import("../render.js").OrderFunction} [renderOrder] Render order. Function to be used when sorting
 * features before rendering. By default features are drawn in the order that they are created. Use
 * `null` to avoid the sort, but get an undefined draw order.
 * @property {number} [renderBuffer=100] The buffer in pixels around the viewport extent used by the
 * renderer when getting features from the vector source for the rendering or hit-detection.
 * Recommended value: the size of the largest symbol, line width or label.
 * @property {VectorSourceType} [source] Source.
 * @property {import("../Map.js").default} [map] Sets the layer as overlay on a map. The map will not manage
 * this layer in its layers collection, and the layer will be rendered on top. This is useful for
 * temporary layers. The standard way to add a layer to a map and have it managed by the map is to
 * use [map.addLayer()]{@link import("../Map.js").default#addLayer}.
 * @property {boolean|string|number} [declutter=false] Declutter images and text. Any truthy value will enable
 * decluttering. Within a layer, a feature rendered before another has higher priority. All layers with the
 * same `declutter` value will be decluttered together. The priority is determined by the drawing order of the
 * layers with the same `declutter` value. Higher in the layer stack means higher priority. To declutter distinct
 * layers or groups of layers separately, use different truthy values for `declutter`.
 * @property {import("../style/Style.js").StyleLike|import("../style/flat.js").FlatStyleLike|null} [style] Layer style. When set to `null`, only
 * features that have their own style will be rendered. See {@link module:ol/style/Style~Style} for the default style
 * which will be used if this is not set.
 * @property {import("./Base.js").BackgroundColor} [background] Background color for the layer. If not specified, no background
 * will be rendered.
 * @property {boolean} [updateWhileAnimating=false] When set to `true`, feature batches will
 * be recreated during animations. This means that no vectors will be shown clipped, but the
 * setting will have a performance impact for large amounts of vector data. When set to `false`,
 * batches will be recreated when no animation is active.
 * @property {boolean} [updateWhileInteracting=false] When set to `true`, feature batches will
 * be recreated during interactions. See also `updateWhileAnimating`.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 */ /**
 * @enum {string}
 * @private
 */ const $c8d6dc4c09ed9916$var$Property = {
    RENDER_ORDER: 'renderOrder'
};
/**
 * @classdesc
 * Vector data that is rendered client-side.
 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
 * property on the layer object; for example, setting `title: 'My Title'` in the
 * options means that `title` is observable, and has get/set accessors.
 *
 * @template {import('../Feature').FeatureLike} FeatureType
 * @template {import("../source/Vector.js").default<FeatureType>|import("../source/VectorTile.js").default<FeatureType>} VectorSourceType<FeatureType>
 * @extends {Layer<VectorSourceType, RendererType>}
 * @template {import("../renderer/canvas/VectorLayer.js").default|import("../renderer/canvas/VectorTileLayer.js").default|import("../renderer/canvas/VectorImageLayer.js").default|import("../renderer/webgl/VectorLayer.js").default|import("../renderer/webgl/PointsLayer.js").default} RendererType
 * @api
 */ class $c8d6dc4c09ed9916$var$BaseVectorLayer extends (0, $534f30fce11effcd$export$2e2bcd8739ae039) {
    /**
   * @param {Options<FeatureType, VectorSourceType>} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        const baseOptions = Object.assign({}, options);
        delete baseOptions.style;
        delete baseOptions.renderBuffer;
        delete baseOptions.updateWhileAnimating;
        delete baseOptions.updateWhileInteracting;
        super(baseOptions);
        /**
     * @private
     * @type {string}
     */ this.declutter_ = options.declutter ? String(options.declutter) : undefined;
        /**
     * @type {number}
     * @private
     */ this.renderBuffer_ = options.renderBuffer !== undefined ? options.renderBuffer : 100;
        /**
     * User provided style.
     * @type {import("../style/Style.js").StyleLike|import("../style/flat.js").FlatStyleLike}
     * @private
     */ this.style_ = null;
        /**
     * Style function for use within the library.
     * @type {import("../style/Style.js").StyleFunction|undefined}
     * @private
     */ this.styleFunction_ = undefined;
        this.setStyle(options.style);
        /**
     * @type {boolean}
     * @private
     */ this.updateWhileAnimating_ = options.updateWhileAnimating !== undefined ? options.updateWhileAnimating : false;
        /**
     * @type {boolean}
     * @private
     */ this.updateWhileInteracting_ = options.updateWhileInteracting !== undefined ? options.updateWhileInteracting : false;
    }
    /**
   * @return {string} Declutter group.
   * @override
   */ getDeclutter() {
        return this.declutter_;
    }
    /**
   * Get the topmost feature that intersects the given pixel on the viewport. Returns a promise
   * that resolves with an array of features. The array will either contain the topmost feature
   * when a hit was detected, or it will be empty.
   *
   * The hit detection algorithm used for this method is optimized for performance, but is less
   * accurate than the one used in [map.getFeaturesAtPixel()]{@link import("../Map.js").default#getFeaturesAtPixel}.
   * Text is not considered, and icons are only represented by their bounding box instead of the exact
   * image.
   *
   * @param {import("../pixel.js").Pixel} pixel Pixel.
   * @return {Promise<Array<import("../Feature").FeatureLike>>} Promise that resolves with an array of features.
   * @api
   * @override
   */ getFeatures(pixel) {
        return super.getFeatures(pixel);
    }
    /**
   * @return {number|undefined} Render buffer.
   */ getRenderBuffer() {
        return this.renderBuffer_;
    }
    /**
   * @return {import("../render.js").OrderFunction|null|undefined} Render order.
   */ getRenderOrder() {
        return /** @type {import("../render.js").OrderFunction|null|undefined} */ this.get($c8d6dc4c09ed9916$var$Property.RENDER_ORDER);
    }
    /**
   * Get the style for features.  This returns whatever was passed to the `style`
   * option at construction or to the `setStyle` method.
   * @return {import("../style/Style.js").StyleLike|import("../style/flat.js").FlatStyleLike|null|undefined} Layer style.
   * @api
   */ getStyle() {
        return this.style_;
    }
    /**
   * Get the style function.
   * @return {import("../style/Style.js").StyleFunction|undefined} Layer style function.
   * @api
   */ getStyleFunction() {
        return this.styleFunction_;
    }
    /**
   * @return {boolean} Whether the rendered layer should be updated while
   *     animating.
   */ getUpdateWhileAnimating() {
        return this.updateWhileAnimating_;
    }
    /**
   * @return {boolean} Whether the rendered layer should be updated while
   *     interacting.
   */ getUpdateWhileInteracting() {
        return this.updateWhileInteracting_;
    }
    /**
   * Render declutter items for this layer
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @param {import("../layer/Layer.js").State} layerState Layer state.
   * @override
   */ renderDeclutter(frameState, layerState) {
        const declutterGroup = this.getDeclutter();
        if (declutterGroup in frameState.declutter === false) frameState.declutter[declutterGroup] = new (0, (/*@__PURE__*/$parcel$interopDefault($176ca75ee9f69668$exports)))(9);
        this.getRenderer().renderDeclutter(frameState, layerState);
    }
    /**
   * @param {import("../render.js").OrderFunction|null|undefined} renderOrder
   *     Render order.
   */ setRenderOrder(renderOrder) {
        this.set($c8d6dc4c09ed9916$var$Property.RENDER_ORDER, renderOrder);
    }
    /**
   * Set the style for features.  This can be a single style object, an array
   * of styles, or a function that takes a feature and resolution and returns
   * an array of styles. If set to `null`, the layer has no style (a `null` style),
   * so only features that have their own styles will be rendered in the layer. Call
   * `setStyle()` without arguments to reset to the default style. See
   * [the ol/style/Style module]{@link module:ol/style/Style~Style} for information on the default style.
   *
   * If your layer has a static style, you can use [flat style]{@link module:ol/style/flat~FlatStyle} object
   * literals instead of using the `Style` and symbolizer constructors (`Fill`, `Stroke`, etc.):
   * ```js
   * vectorLayer.setStyle({
   *   "fill-color": "yellow",
   *   "stroke-color": "black",
   *   "stroke-width": 4
   * })
   * ```
   *
   * @param {import("../style/Style.js").StyleLike|import("../style/flat.js").FlatStyleLike|null} [style] Layer style.
   * @api
   */ setStyle(style) {
        this.style_ = style === undefined ? (0, $8c7f6dda98e8cb9c$export$6865c5ac2f5ce8b6) : style;
        const styleLike = $c8d6dc4c09ed9916$var$toStyleLike(style);
        this.styleFunction_ = style === null ? undefined : (0, $8c7f6dda98e8cb9c$export$c314ea3f6b164147)(styleLike);
        this.changed();
    }
    /**
   * @param {boolean|string|number} declutter Declutter images and text.
   * @api
   */ setDeclutter(declutter) {
        this.declutter_ = declutter ? String(declutter) : undefined;
        this.changed();
    }
}
/**
 * Coerce the allowed style types into a shorter list of types.  Flat styles, arrays of flat
 * styles, and arrays of rules are converted into style functions.
 *
 * @param {import("../style/Style.js").StyleLike|import("../style/flat.js").FlatStyleLike|null} [style] Layer style.
 * @return {import("../style/Style.js").StyleLike|null} The style.
 */ function $c8d6dc4c09ed9916$var$toStyleLike(style) {
    if (style === undefined) return 0, $8c7f6dda98e8cb9c$export$6865c5ac2f5ce8b6;
    if (!style) return null;
    if (typeof style === 'function') return style;
    if (style instanceof (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)) return style;
    if (!Array.isArray(style)) return (0, $6000539d86fde80c$export$5a130bc4f0a0420b)([
        style
    ]);
    if (style.length === 0) return [];
    const length = style.length;
    const first = style[0];
    if (first instanceof (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)) {
        /**
     * @type {Array<Style>}
     */ const styles = new Array(length);
        for(let i = 0; i < length; ++i){
            const candidate = style[i];
            if (!(candidate instanceof (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039))) throw new Error('Expected a list of style instances');
            styles[i] = candidate;
        }
        return styles;
    }
    if ('style' in first) {
        /**
     * @type {Array<import("../style/flat.js").Rule>}
     */ const rules = new Array(length);
        for(let i = 0; i < length; ++i){
            const candidate = style[i];
            if (!('style' in candidate)) throw new Error('Expected a list of rules with a style property');
            rules[i] = candidate;
        }
        return (0, $6000539d86fde80c$export$fc6a94152b1b05a8)(rules);
    }
    const flatStyles = /** @type {Array<import("../style/flat.js").FlatStyle>} */ style;
    return (0, $6000539d86fde80c$export$5a130bc4f0a0420b)(flatStyles);
}
var $c8d6dc4c09ed9916$export$2e2bcd8739ae039 = $c8d6dc4c09ed9916$var$BaseVectorLayer;



/**
 * @module ol/render/Event
 */ 
class $b80dddceb0c42ad4$var$RenderEvent extends (0, $aeedce20e9577100$export$2e2bcd8739ae039) {
    /**
   * @param {import("./EventType.js").default} type Type.
   * @param {import("../transform.js").Transform} [inversePixelTransform] Transform for
   *     CSS pixels to rendered pixels.
   * @param {import("../Map.js").FrameState} [frameState] Frame state.
   * @param {?(CanvasRenderingContext2D|WebGLRenderingContext)} [context] Context.
   */ constructor(type, inversePixelTransform, frameState, context){
        super(type);
        /**
     * Transform from CSS pixels (relative to the top-left corner of the map viewport)
     * to rendered pixels on this event's `context`. Only available when a Canvas renderer is used, null otherwise.
     * @type {import("../transform.js").Transform|undefined}
     * @api
     */ this.inversePixelTransform = inversePixelTransform;
        /**
     * An object representing the current render frame state.
     * @type {import("../Map.js").FrameState|undefined}
     * @api
     */ this.frameState = frameState;
        /**
     * Canvas context. Not available when the event is dispatched by the map. For Canvas 2D layers,
     * the context will be the 2D rendering context.  For WebGL layers, the context will be the WebGL
     * context.
     * @type {CanvasRenderingContext2D|WebGLRenderingContext|undefined}
     * @api
     */ this.context = context;
    }
}
var $b80dddceb0c42ad4$export$2e2bcd8739ae039 = $b80dddceb0c42ad4$var$RenderEvent;




/**
 * @module ol/renderer/Map
 */ 







/**
 * @template T
 * @typedef HitMatch
 * @property {import("../Feature.js").FeatureLike} feature Feature.
 * @property {import("../layer/Layer.js").default} layer Layer.
 * @property {import("../geom/SimpleGeometry.js").default} geometry Geometry.
 * @property {number} distanceSq Squared distance.
 * @property {import("./vector.js").FeatureCallback<T>} callback Callback.
 */ /**
 * @abstract
 */ class $b370ab32454a96fd$var$MapRenderer extends (0, $3273ed08087da3da$export$2e2bcd8739ae039) {
    /**
   * @param {import("../Map.js").default} map Map.
   */ constructor(map){
        super();
        /**
     * @private
     * @type {import("../Map.js").default}
     */ this.map_ = map;
    }
    /**
   * @abstract
   * @param {import("../render/EventType.js").default} type Event type.
   * @param {import("../Map.js").FrameState} frameState Frame state.
   */ dispatchRenderEvent(type, frameState) {
        (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * @param {import("../Map.js").FrameState} frameState FrameState.
   * @protected
   */ calculateMatrices2D(frameState) {
        const viewState = frameState.viewState;
        const coordinateToPixelTransform = frameState.coordinateToPixelTransform;
        const pixelToCoordinateTransform = frameState.pixelToCoordinateTransform;
        (0, $e22e7611e69f42a9$export$f672e0b6f7222cd7)(coordinateToPixelTransform, frameState.size[0] / 2, frameState.size[1] / 2, 1 / viewState.resolution, -1 / viewState.resolution, -viewState.rotation, -viewState.center[0], -viewState.center[1]);
        (0, $e22e7611e69f42a9$export$bd70ea2a93c0fa4)(pixelToCoordinateTransform, coordinateToPixelTransform);
    }
    /**
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("../Map.js").FrameState} frameState FrameState.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @param {boolean} checkWrapped Check for wrapped geometries.
   * @param {import("./vector.js").FeatureCallback<T>} callback Feature callback.
   * @param {S} thisArg Value to use as `this` when executing `callback`.
   * @param {function(this: U, import("../layer/Layer.js").default): boolean} layerFilter Layer filter
   *     function, only layers which are visible and for which this function
   *     returns `true` will be tested for features.  By default, all visible
   *     layers will be tested.
   * @param {U} thisArg2 Value to use as `this` when executing `layerFilter`.
   * @return {T|undefined} Callback result.
   * @template S,T,U
   */ forEachFeatureAtCoordinate(coordinate, frameState, hitTolerance, checkWrapped, callback, thisArg, layerFilter, thisArg2) {
        let result;
        const viewState = frameState.viewState;
        /**
     * @param {boolean} managed Managed layer.
     * @param {import("../Feature.js").FeatureLike} feature Feature.
     * @param {import("../layer/Layer.js").default} layer Layer.
     * @param {import("../geom/Geometry.js").default} geometry Geometry.
     * @return {T|undefined} Callback result.
     */ function forEachFeatureAtCoordinate(managed, feature, layer, geometry) {
            return callback.call(thisArg, feature, managed ? layer : null, geometry);
        }
        const projection = viewState.projection;
        const translatedCoordinate = (0, $1bd0a226f9a16141$export$39a9ce3624977b84)(coordinate.slice(), projection);
        const offsets = [
            [
                0,
                0
            ]
        ];
        if (projection.canWrapX() && checkWrapped) {
            const projectionExtent = projection.getExtent();
            const worldWidth = (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(projectionExtent);
            offsets.push([
                -worldWidth,
                0
            ], [
                worldWidth,
                0
            ]);
        }
        const layerStates = frameState.layerStatesArray;
        const numLayers = layerStates.length;
        const matches = /** @type {Array<HitMatch<T>>} */ [];
        const tmpCoord = [];
        for(let i = 0; i < offsets.length; i++)for(let j = numLayers - 1; j >= 0; --j){
            const layerState = layerStates[j];
            const layer = layerState.layer;
            if (layer.hasRenderer() && (0, $534f30fce11effcd$export$acb1e9cb9ce4ca56)(layerState, viewState) && layerFilter.call(thisArg2, layer)) {
                const layerRenderer = layer.getRenderer();
                const source = layer.getSource();
                if (layerRenderer && source) {
                    const coordinates = source.getWrapX() ? translatedCoordinate : coordinate;
                    const callback = forEachFeatureAtCoordinate.bind(null, layerState.managed);
                    tmpCoord[0] = coordinates[0] + offsets[i][0];
                    tmpCoord[1] = coordinates[1] + offsets[i][1];
                    result = layerRenderer.forEachFeatureAtCoordinate(tmpCoord, frameState, hitTolerance, callback, matches);
                }
                if (result) return result;
            }
        }
        if (matches.length === 0) return undefined;
        const order = 1 / matches.length;
        matches.forEach((m, i)=>m.distanceSq += i * order);
        matches.sort((a, b)=>a.distanceSq - b.distanceSq);
        matches.some((m)=>{
            return result = m.callback(m.feature, m.layer, m.geometry);
        });
        return result;
    }
    /**
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("../Map.js").FrameState} frameState FrameState.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @param {boolean} checkWrapped Check for wrapped geometries.
   * @param {function(this: U, import("../layer/Layer.js").default): boolean} layerFilter Layer filter
   *     function, only layers which are visible and for which this function
   *     returns `true` will be tested for features.  By default, all visible
   *     layers will be tested.
   * @param {U} thisArg Value to use as `this` when executing `layerFilter`.
   * @return {boolean} Is there a feature at the given coordinate?
   * @template U
   */ hasFeatureAtCoordinate(coordinate, frameState, hitTolerance, checkWrapped, layerFilter, thisArg) {
        const hasFeature = this.forEachFeatureAtCoordinate(coordinate, frameState, hitTolerance, checkWrapped, (0, $013a1733c226ec50$export$22e23a2304399231), this, layerFilter, thisArg);
        return hasFeature !== undefined;
    }
    /**
   * @return {import("../Map.js").default} Map.
   */ getMap() {
        return this.map_;
    }
    /**
   * Render.
   * @abstract
   * @param {?import("../Map.js").FrameState} frameState Frame state.
   */ renderFrame(frameState) {
        (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @protected
   */ scheduleExpireIconCache(frameState) {
        if ((0, $f351daabfe6e2d22$export$747ccdf771a87ab8).canExpireCache()) frameState.postRenderFunctions.push($b370ab32454a96fd$var$expireIconCache);
    }
}
/**
 * @param {import("../Map.js").default} map Map.
 * @param {import("../Map.js").FrameState} frameState Frame state.
 */ function $b370ab32454a96fd$var$expireIconCache(map, frameState) {
    (0, $f351daabfe6e2d22$export$747ccdf771a87ab8).expire();
}
var $b370ab32454a96fd$export$2e2bcd8739ae039 = $b370ab32454a96fd$var$MapRenderer;


/**
 * @classdesc
 * Canvas map renderer.
 * @api
 */ class $fa78c97693b12120$var$CompositeMapRenderer extends (0, $b370ab32454a96fd$export$2e2bcd8739ae039) {
    /**
   * @param {import("../Map.js").default} map Map.
   */ constructor(map){
        super(map);
        /**
     * @private
     * @type {import("../events.js").EventsKey}
     */ this.fontChangeListenerKey_ = (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)((0, $d4aabc5c971073f1$export$1d36981fcadac93b), (0, $e881b5dca21eb5d4$export$2e2bcd8739ae039).PROPERTYCHANGE, map.redrawText, map);
        /**
     * @private
     * @type {HTMLDivElement}
     */ this.element_ = document.createElement('div');
        const style = this.element_.style;
        style.position = 'absolute';
        style.width = '100%';
        style.height = '100%';
        style.zIndex = '0';
        this.element_.className = (0, $ce07df6d5d4656f1$export$1afde3d6e16a7b29) + ' ol-layers';
        const container = map.getViewport();
        container.insertBefore(this.element_, container.firstChild || null);
        /**
     * @private
     * @type {Array<HTMLElement>}
     */ this.children_ = [];
        /**
     * @private
     * @type {boolean}
     */ this.renderedVisible_ = true;
    }
    /**
   * @param {import("../render/EventType.js").default} type Event type.
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @override
   */ dispatchRenderEvent(type, frameState) {
        const map = this.getMap();
        if (map.hasListener(type)) {
            const event = new (0, $b80dddceb0c42ad4$export$2e2bcd8739ae039)(type, undefined, frameState);
            map.dispatchEvent(event);
        }
    }
    /**
   * @override
   */ disposeInternal() {
        (0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921)(this.fontChangeListenerKey_);
        this.element_.remove();
        super.disposeInternal();
    }
    /**
   * Render.
   * @param {?import("../Map.js").FrameState} frameState Frame state.
   * @override
   */ renderFrame(frameState) {
        if (!frameState) {
            if (this.renderedVisible_) {
                this.element_.style.display = 'none';
                this.renderedVisible_ = false;
            }
            return;
        }
        this.calculateMatrices2D(frameState);
        this.dispatchRenderEvent((0, $f5e92a4d985a2824$export$2e2bcd8739ae039).PRECOMPOSE, frameState);
        const layerStatesArray = frameState.layerStatesArray.sort((a, b)=>a.zIndex - b.zIndex);
        const declutter = layerStatesArray.some((layerState)=>layerState.layer instanceof (0, $c8d6dc4c09ed9916$export$2e2bcd8739ae039) && layerState.layer.getDeclutter());
        if (declutter) // Some layers need decluttering, turn on deferred rendering hint
        frameState.declutter = {};
        const viewState = frameState.viewState;
        this.children_.length = 0;
        const renderedLayerStates = [];
        let previousElement = null;
        for(let i = 0, ii = layerStatesArray.length; i < ii; ++i){
            const layerState = layerStatesArray[i];
            frameState.layerIndex = i;
            const layer = layerState.layer;
            const sourceState = layer.getSourceState();
            if (!(0, $534f30fce11effcd$export$acb1e9cb9ce4ca56)(layerState, viewState) || sourceState != 'ready' && sourceState != 'undefined') {
                layer.unrender();
                continue;
            }
            const element = layer.render(frameState, previousElement);
            if (!element) continue;
            if (element !== previousElement) {
                this.children_.push(element);
                previousElement = element;
            }
            renderedLayerStates.push(layerState);
        }
        this.declutter(frameState, renderedLayerStates);
        (0, $075f937d7366f1a2$export$caeacfe04f52533a)(this.element_, this.children_);
        this.dispatchRenderEvent((0, $f5e92a4d985a2824$export$2e2bcd8739ae039).POSTCOMPOSE, frameState);
        if (!this.renderedVisible_) {
            this.element_.style.display = '';
            this.renderedVisible_ = true;
        }
        this.scheduleExpireIconCache(frameState);
    }
    /**
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @param {Array<import('../layer/Layer.js').State>} layerStates Layers.
   */ declutter(frameState, layerStates) {
        if (!frameState.declutter) return;
        for(let i = layerStates.length - 1; i >= 0; --i){
            const layerState = layerStates[i];
            const layer = layerState.layer;
            if (layer.getDeclutter()) layer.renderDeclutter(frameState, layerState);
        }
        layerStates.forEach((layerState)=>layerState.layer.renderDeferred(frameState));
    }
}
var $fa78c97693b12120$export$2e2bcd8739ae039 = $fa78c97693b12120$var$CompositeMapRenderer;





/**
 * State of the current frame. Only `pixelRatio`, `time` and `viewState` should
 * be used in applications.
 * @typedef {Object} FrameState
 * @property {number} pixelRatio The pixel ratio of the frame.
 * @property {number} time The time when rendering of the frame was requested.
 * @property {import("./View.js").State} viewState The state of the current view.
 * @property {boolean} animate Animate.
 * @property {import("./transform.js").Transform} coordinateToPixelTransform CoordinateToPixelTransform.
 * @property {Object<string, import("rbush").default<import('./render/canvas/Executor.js').DeclutterEntry>>|null} declutter
 * Declutter trees by declutter group.
 * When null, no decluttering is needed because no layers have decluttering enabled.
 * @property {null|import("./extent.js").Extent} extent Extent (in view projection coordinates).
 * @property {import("./extent.js").Extent} [nextExtent] Next extent during an animation series.
 * @property {number} index Index.
 * @property {Array<import("./layer/Layer.js").State>} layerStatesArray LayerStatesArray.
 * @property {number} layerIndex LayerIndex.
 * @property {import("./transform.js").Transform} pixelToCoordinateTransform PixelToCoordinateTransform.
 * @property {Array<PostRenderFunction>} postRenderFunctions PostRenderFunctions.
 * @property {import("./size.js").Size} size Size.
 * @property {TileQueue} tileQueue TileQueue.
 * @property {!Object<string, Object<string, boolean>>} usedTiles UsedTiles.
 * @property {Array<number>} viewHints ViewHints.
 * @property {!Object<string, Object<string, boolean>>} wantedTiles WantedTiles.
 * @property {string} mapId The id of the map.
 * @property {Object<string, boolean>} renderTargets Identifiers of previously rendered elements.
 */ /**
 * @typedef {function(Map, FrameState): any} PostRenderFunction
 */ /**
 * @typedef {Object} AtPixelOptions
 * @property {undefined|function(import("./layer/Layer.js").default<import("./source/Source").default>): boolean} [layerFilter] Layer filter
 * function. The filter function will receive one argument, the
 * {@link module:ol/layer/Layer~Layer layer-candidate} and it should return a boolean value.
 * Only layers which are visible and for which this function returns `true`
 * will be tested for features. By default, all visible layers will be tested.
 * @property {number} [hitTolerance=0] Hit-detection tolerance in css pixels. Pixels
 * inside the radius around the given position will be checked for features.
 * @property {boolean} [checkWrapped=true] Check-Wrapped Will check for wrapped geometries inside the range of
 *   +/- 1 world width. Works only if a projection is used that can be wrapped.
 */ /**
 * @typedef {Object} MapOptionsInternal
 * @property {Collection<import("./control/Control.js").default>} [controls] Controls.
 * @property {Collection<import("./interaction/Interaction.js").default>} [interactions] Interactions.
 * @property {HTMLElement|Document} keyboardEventTarget KeyboardEventTarget.
 * @property {Collection<import("./Overlay.js").default>} overlays Overlays.
 * @property {Object<string, *>} values Values.
 */ /**
 * @typedef {import("./ObjectEventType").Types|'change:layergroup'|'change:size'|'change:target'|'change:view'} MapObjectEventTypes
 */ /***
 * @template Return
 * @typedef {import("./Observable").OnSignature<import("./Observable").EventTypes, import("./events/Event.js").default, Return> &
 *    import("./Observable").OnSignature<MapObjectEventTypes, import("./Object").ObjectEvent, Return> &
 *    import("./Observable").OnSignature<import("./MapBrowserEventType").Types, import("./MapBrowserEvent").default, Return> &
 *    import("./Observable").OnSignature<import("./MapEventType").Types, import("./MapEvent").default, Return> &
 *    import("./Observable").OnSignature<import("./render/EventType").MapRenderEventTypes, import("./render/Event").default, Return> &
 *    import("./Observable").CombinedOnSignature<import("./Observable").EventTypes|MapObjectEventTypes|
 *      import("./MapBrowserEventType").Types|import("./MapEventType").Types|
 *      import("./render/EventType").MapRenderEventTypes, Return>} MapEventHandler
 */ /**
 * Object literal with config options for the map.
 * @typedef {Object} MapOptions
 * @property {Collection<import("./control/Control.js").default>|Array<import("./control/Control.js").default>} [controls]
 * Controls initially added to the map. If not specified,
 * {@link module:ol/control/defaults.defaults} is used.
 * @property {number} [pixelRatio=window.devicePixelRatio] The ratio between
 * physical pixels and device-independent pixels (dips) on the device.
 * @property {Collection<import("./interaction/Interaction.js").default>|Array<import("./interaction/Interaction.js").default>} [interactions]
 * Interactions that are initially added to the map. If not specified,
 * {@link module:ol/interaction/defaults.defaults} is used.
 * @property {HTMLElement|Document|string} [keyboardEventTarget] The element to
 * listen to keyboard events on. This determines when the `KeyboardPan` and
 * `KeyboardZoom` interactions trigger. For example, if this option is set to
 * `document` the keyboard interactions will always trigger. If this option is
 * not specified, the element the library listens to keyboard events on is the
 * map target (i.e. the user-provided div for the map). If this is not
 * `document`, the target element needs to be focused for key events to be
 * emitted, requiring that the target element has a `tabindex` attribute.
 * @property {Array<import("./layer/Base.js").default>|Collection<import("./layer/Base.js").default>|LayerGroup} [layers]
 * Layers. If this is not defined, a map with no layers will be rendered. Note
 * that layers are rendered in the order supplied, so if you want, for example,
 * a vector layer to appear on top of a tile layer, it must come after the tile
 * layer.
 * @property {number} [maxTilesLoading=16] Maximum number tiles to load
 * simultaneously.
 * @property {number} [moveTolerance=1] The minimum distance in pixels the
 * cursor must move to be detected as a map move event instead of a click.
 * Increasing this value can make it easier to click on the map.
 * @property {Collection<import("./Overlay.js").default>|Array<import("./Overlay.js").default>} [overlays]
 * Overlays initially added to the map. By default, no overlays are added.
 * @property {HTMLElement|string} [target] The container for the map, either the
 * element itself or the `id` of the element. If not specified at construction
 * time, {@link module:ol/Map~Map#setTarget} must be called for the map to be
 * rendered. If passed by element, the container can be in a secondary document.
 * For accessibility (focus and keyboard events for map navigation), the `target` element must have a
 *  properly configured `tabindex` attribute. If the `target` element is inside a Shadow DOM, the
 *  `tabindex` atribute must be set on the custom element's host element.
 * **Note:** CSS `transform` support for the target element is limited to `scale`.
 * @property {View|Promise<import("./View.js").ViewOptions>} [view] The map's view.  No layer sources will be
 * fetched unless this is specified at construction time or through
 * {@link module:ol/Map~Map#setView}.
 */ /**
 * @param {import("./layer/Base.js").default} layer Layer.
 */ function $41aa29ae0c4b607a$var$removeLayerMapProperty(layer) {
    if (layer instanceof (0, $534f30fce11effcd$export$2e2bcd8739ae039)) {
        layer.setMapInternal(null);
        return;
    }
    if (layer instanceof (0, $0b703156bb914e6f$export$2e2bcd8739ae039)) layer.getLayers().forEach($41aa29ae0c4b607a$var$removeLayerMapProperty);
}
/**
 * @param {import("./layer/Base.js").default} layer Layer.
 * @param {Map} map Map.
 */ function $41aa29ae0c4b607a$var$setLayerMapProperty(layer, map) {
    if (layer instanceof (0, $534f30fce11effcd$export$2e2bcd8739ae039)) {
        layer.setMapInternal(map);
        return;
    }
    if (layer instanceof (0, $0b703156bb914e6f$export$2e2bcd8739ae039)) {
        const layers = layer.getLayers().getArray();
        for(let i = 0, ii = layers.length; i < ii; ++i)$41aa29ae0c4b607a$var$setLayerMapProperty(layers[i], map);
    }
}
/**
 * @classdesc
 * The map is the core component of OpenLayers. For a map to render, a view,
 * one or more layers, and a target container are needed:
 *
 *     import Map from 'ol/Map.js';
 *     import View from 'ol/View.js';
 *     import TileLayer from 'ol/layer/Tile.js';
 *     import OSM from 'ol/source/OSM.js';
 *
 *     const map = new Map({
 *       view: new View({
 *         center: [0, 0],
 *         zoom: 1,
 *       }),
 *       layers: [
 *         new TileLayer({
 *           source: new OSM(),
 *         }),
 *       ],
 *       target: 'map',
 *     });
 *
 * The above snippet creates a map using a {@link module:ol/layer/Tile~TileLayer} to
 * display {@link module:ol/source/OSM~OSM} OSM data and render it to a DOM
 * element with the id `map`.
 *
 * The constructor places a viewport container (with CSS class name
 * `ol-viewport`) in the target element (see `getViewport()`), and then two
 * further elements within the viewport: one with CSS class name
 * `ol-overlaycontainer-stopevent` for controls and some overlays, and one with
 * CSS class name `ol-overlaycontainer` for other overlays (see the `stopEvent`
 * option of {@link module:ol/Overlay~Overlay} for the difference). The map
 * itself is placed in a further element within the viewport.
 *
 * Layers are stored as a {@link module:ol/Collection~Collection} in
 * layerGroups. A top-level group is provided by the library. This is what is
 * accessed by `getLayerGroup` and `setLayerGroup`. Layers entered in the
 * options are added to this group, and `addLayer` and `removeLayer` change the
 * layer collection in the group. `getLayers` is a convenience function for
 * `getLayerGroup().getLayers()`. Note that {@link module:ol/layer/Group~LayerGroup}
 * is a subclass of {@link module:ol/layer/Base~BaseLayer}, so layers entered in the
 * options or added with `addLayer` can be groups, which can contain further
 * groups, and so on.
 *
 * @fires import("./MapBrowserEvent.js").MapBrowserEvent
 * @fires import("./MapEvent.js").MapEvent
 * @fires import("./render/Event.js").default#precompose
 * @fires import("./render/Event.js").default#postcompose
 * @fires import("./render/Event.js").default#rendercomplete
 * @api
 */ class $41aa29ae0c4b607a$var$Map extends (0, $b68b3d6e32e3074a$export$2e2bcd8739ae039) {
    /**
   * @param {MapOptions} [options] Map options.
   */ constructor(options){
        super();
        options = options || {};
        /***
     * @type {MapEventHandler<import("./events").EventsKey>}
     */ this.on;
        /***
     * @type {MapEventHandler<import("./events").EventsKey>}
     */ this.once;
        /***
     * @type {MapEventHandler<void>}
     */ this.un;
        const optionsInternal = $41aa29ae0c4b607a$var$createOptionsInternal(options);
        /**
     * @private
     * @type {boolean}
     */ this.renderComplete_ = false;
        /**
     * @private
     * @type {boolean}
     */ this.loaded_ = true;
        /** @private */ this.boundHandleBrowserEvent_ = this.handleBrowserEvent.bind(this);
        /**
     * @type {number}
     * @private
     */ this.maxTilesLoading_ = options.maxTilesLoading !== undefined ? options.maxTilesLoading : 16;
        /**
     * @private
     * @type {number}
     */ this.pixelRatio_ = options.pixelRatio !== undefined ? options.pixelRatio : (0, $67c66761d21428d0$export$6b83a0446fc26f94);
        /**
     * @private
     * @type {ReturnType<typeof setTimeout>}
     */ this.postRenderTimeoutHandle_;
        /**
     * @private
     * @type {number|undefined}
     */ this.animationDelayKey_;
        /**
     * @private
     */ this.animationDelay_ = this.animationDelay_.bind(this);
        /**
     * @private
     * @type {import("./transform.js").Transform}
     */ this.coordinateToPixelTransform_ = (0, $e22e7611e69f42a9$export$185802fd694ee1f5)();
        /**
     * @private
     * @type {import("./transform.js").Transform}
     */ this.pixelToCoordinateTransform_ = (0, $e22e7611e69f42a9$export$185802fd694ee1f5)();
        /**
     * @private
     * @type {number}
     */ this.frameIndex_ = 0;
        /**
     * @private
     * @type {?FrameState}
     */ this.frameState_ = null;
        /**
     * The extent at the previous 'moveend' event.
     * @private
     * @type {import("./extent.js").Extent}
     */ this.previousExtent_ = null;
        /**
     * @private
     * @type {?import("./events.js").EventsKey}
     */ this.viewPropertyListenerKey_ = null;
        /**
     * @private
     * @type {?import("./events.js").EventsKey}
     */ this.viewChangeListenerKey_ = null;
        /**
     * @private
     * @type {?Array<import("./events.js").EventsKey>}
     */ this.layerGroupPropertyListenerKeys_ = null;
        /**
     * @private
     * @type {!HTMLElement}
     */ this.viewport_ = document.createElement('div');
        this.viewport_.className = 'ol-viewport' + ('ontouchstart' in window ? ' ol-touch' : '');
        this.viewport_.style.position = 'relative';
        this.viewport_.style.overflow = 'hidden';
        this.viewport_.style.width = '100%';
        this.viewport_.style.height = '100%';
        /**
     * @private
     * @type {!HTMLElement}
     */ this.overlayContainer_ = document.createElement('div');
        this.overlayContainer_.style.position = 'absolute';
        this.overlayContainer_.style.zIndex = '0';
        this.overlayContainer_.style.width = '100%';
        this.overlayContainer_.style.height = '100%';
        this.overlayContainer_.style.pointerEvents = 'none';
        this.overlayContainer_.className = 'ol-overlaycontainer';
        this.viewport_.appendChild(this.overlayContainer_);
        /**
     * @private
     * @type {!HTMLElement}
     */ this.overlayContainerStopEvent_ = document.createElement('div');
        this.overlayContainerStopEvent_.style.position = 'absolute';
        this.overlayContainerStopEvent_.style.zIndex = '0';
        this.overlayContainerStopEvent_.style.width = '100%';
        this.overlayContainerStopEvent_.style.height = '100%';
        this.overlayContainerStopEvent_.style.pointerEvents = 'none';
        this.overlayContainerStopEvent_.className = 'ol-overlaycontainer-stopevent';
        this.viewport_.appendChild(this.overlayContainerStopEvent_);
        /**
     * @private
     * @type {MapBrowserEventHandler}
     */ this.mapBrowserEventHandler_ = null;
        /**
     * @private
     * @type {number}
     */ this.moveTolerance_ = options.moveTolerance;
        /**
     * @private
     * @type {HTMLElement|Document}
     */ this.keyboardEventTarget_ = optionsInternal.keyboardEventTarget;
        /**
     * @private
     * @type {?Array<import("./events.js").EventsKey>}
     */ this.targetChangeHandlerKeys_ = null;
        /**
     * @private
     * @type {HTMLElement|null}
     */ this.targetElement_ = null;
        /**
     * @private
     * @type {ResizeObserver}
     */ this.resizeObserver_ = new ResizeObserver(()=>this.updateSize());
        /**
     * @type {Collection<import("./control/Control.js").default>}
     * @protected
     */ this.controls = optionsInternal.controls || (0, $af7495b2f822d5e9$export$ebe90cb607ad99e)();
        /**
     * @type {Collection<import("./interaction/Interaction.js").default>}
     * @protected
     */ this.interactions = optionsInternal.interactions || (0, $e3fbd36d629ecc04$export$ebe90cb607ad99e)({
            onFocusOnly: true
        });
        /**
     * @type {Collection<import("./Overlay.js").default>}
     * @private
     */ this.overlays_ = optionsInternal.overlays;
        /**
     * A lookup of overlays by id.
     * @private
     * @type {Object<string, import("./Overlay.js").default>}
     */ this.overlayIdIndex_ = {};
        /**
     * @type {import("./renderer/Map.js").default|null}
     * @private
     */ this.renderer_ = null;
        /**
     * @private
     * @type {!Array<PostRenderFunction>}
     */ this.postRenderFunctions_ = [];
        /**
     * @private
     * @type {TileQueue}
     */ this.tileQueue_ = new (0, $4c51fd53052a6bbc$export$2e2bcd8739ae039)(this.getTilePriority.bind(this), this.handleTileChange_.bind(this));
        this.addChangeListener((0, $07fa325567004bb7$export$2e2bcd8739ae039).LAYERGROUP, this.handleLayerGroupChanged_);
        this.addChangeListener((0, $07fa325567004bb7$export$2e2bcd8739ae039).VIEW, this.handleViewChanged_);
        this.addChangeListener((0, $07fa325567004bb7$export$2e2bcd8739ae039).SIZE, this.handleSizeChanged_);
        this.addChangeListener((0, $07fa325567004bb7$export$2e2bcd8739ae039).TARGET, this.handleTargetChanged_);
        // setProperties will trigger the rendering of the map if the map
        // is "defined" already.
        this.setProperties(optionsInternal.values);
        const map = this;
        if (options.view && !(options.view instanceof (0, $70364d0195659942$export$2e2bcd8739ae039))) options.view.then(function(viewOptions) {
            map.setView(new (0, $70364d0195659942$export$2e2bcd8739ae039)(viewOptions));
        });
        this.controls.addEventListener((0, $161dd067fe2d672c$export$2e2bcd8739ae039).ADD, /**
       * @param {import("./Collection.js").CollectionEvent<import("./control/Control.js").default>} event CollectionEvent
       */ (event)=>{
            event.element.setMap(this);
        });
        this.controls.addEventListener((0, $161dd067fe2d672c$export$2e2bcd8739ae039).REMOVE, /**
       * @param {import("./Collection.js").CollectionEvent<import("./control/Control.js").default>} event CollectionEvent.
       */ (event)=>{
            event.element.setMap(null);
        });
        this.interactions.addEventListener((0, $161dd067fe2d672c$export$2e2bcd8739ae039).ADD, /**
       * @param {import("./Collection.js").CollectionEvent<import("./interaction/Interaction.js").default>} event CollectionEvent.
       */ (event)=>{
            event.element.setMap(this);
        });
        this.interactions.addEventListener((0, $161dd067fe2d672c$export$2e2bcd8739ae039).REMOVE, /**
       * @param {import("./Collection.js").CollectionEvent<import("./interaction/Interaction.js").default>} event CollectionEvent.
       */ (event)=>{
            event.element.setMap(null);
        });
        this.overlays_.addEventListener((0, $161dd067fe2d672c$export$2e2bcd8739ae039).ADD, /**
       * @param {import("./Collection.js").CollectionEvent<import("./Overlay.js").default>} event CollectionEvent.
       */ (event)=>{
            this.addOverlayInternal_(event.element);
        });
        this.overlays_.addEventListener((0, $161dd067fe2d672c$export$2e2bcd8739ae039).REMOVE, /**
       * @param {import("./Collection.js").CollectionEvent<import("./Overlay.js").default>} event CollectionEvent.
       */ (event)=>{
            const id = event.element.getId();
            if (id !== undefined) delete this.overlayIdIndex_[id.toString()];
            event.element.setMap(null);
        });
        this.controls.forEach(/**
       * @param {import("./control/Control.js").default} control Control.
       */ (control)=>{
            control.setMap(this);
        });
        this.interactions.forEach(/**
       * @param {import("./interaction/Interaction.js").default} interaction Interaction.
       */ (interaction)=>{
            interaction.setMap(this);
        });
        this.overlays_.forEach(this.addOverlayInternal_.bind(this));
    }
    /**
   * Add the given control to the map.
   * @param {import("./control/Control.js").default} control Control.
   * @api
   */ addControl(control) {
        this.getControls().push(control);
    }
    /**
   * Add the given interaction to the map. If you want to add an interaction
   * at another point of the collection use `getInteractions()` and the methods
   * available on {@link module:ol/Collection~Collection}. This can be used to
   * stop the event propagation from the handleEvent function. The interactions
   * get to handle the events in the reverse order of this collection.
   * @param {import("./interaction/Interaction.js").default} interaction Interaction to add.
   * @api
   */ addInteraction(interaction) {
        this.getInteractions().push(interaction);
    }
    /**
   * Adds the given layer to the top of this map. If you want to add a layer
   * elsewhere in the stack, use `getLayers()` and the methods available on
   * {@link module:ol/Collection~Collection}.
   * @param {import("./layer/Base.js").default} layer Layer.
   * @api
   */ addLayer(layer) {
        const layers = this.getLayerGroup().getLayers();
        layers.push(layer);
    }
    /**
   * @param {import("./layer/Group.js").GroupEvent} event The layer add event.
   * @private
   */ handleLayerAdd_(event) {
        $41aa29ae0c4b607a$var$setLayerMapProperty(event.layer, this);
    }
    /**
   * Add the given overlay to the map.
   * @param {import("./Overlay.js").default} overlay Overlay.
   * @api
   */ addOverlay(overlay) {
        this.getOverlays().push(overlay);
    }
    /**
   * This deals with map's overlay collection changes.
   * @param {import("./Overlay.js").default} overlay Overlay.
   * @private
   */ addOverlayInternal_(overlay) {
        const id = overlay.getId();
        if (id !== undefined) this.overlayIdIndex_[id.toString()] = overlay;
        overlay.setMap(this);
    }
    /**
   *
   * Clean up.
   * @override
   */ disposeInternal() {
        this.controls.clear();
        this.interactions.clear();
        this.overlays_.clear();
        this.resizeObserver_.disconnect();
        this.setTarget(null);
        super.disposeInternal();
    }
    /**
   * Detect features that intersect a pixel on the viewport, and execute a
   * callback with each intersecting feature. Layers included in the detection can
   * be configured through the `layerFilter` option in `options`.
   * For polygons without a fill, only the stroke will be used for hit detection.
   * Polygons must have a fill style applied to ensure that pixels inside a polygon are detected.
   * The fill can be transparent.
   * @param {import("./pixel.js").Pixel} pixel Pixel.
   * @param {function(import("./Feature.js").FeatureLike, import("./layer/Layer.js").default<import("./source/Source").default>, import("./geom/SimpleGeometry.js").default): T} callback Feature callback. The callback will be
   *     called with two arguments. The first argument is one
   *     {@link module:ol/Feature~Feature feature} or
   *     {@link module:ol/render/Feature~RenderFeature render feature} at the pixel, the second is
   *     the {@link module:ol/layer/Layer~Layer layer} of the feature and will be null for
   *     unmanaged layers. To stop detection, callback functions can return a
   *     truthy value.
   * @param {AtPixelOptions} [options] Optional options.
   * @return {T|undefined} Callback result, i.e. the return value of last
   * callback execution, or the first truthy callback return value.
   * @template T
   * @api
   */ forEachFeatureAtPixel(pixel, callback, options) {
        if (!this.frameState_ || !this.renderer_) return;
        const coordinate = this.getCoordinateFromPixelInternal(pixel);
        options = options !== undefined ? options : {};
        const hitTolerance = options.hitTolerance !== undefined ? options.hitTolerance : 0;
        const layerFilter = options.layerFilter !== undefined ? options.layerFilter : (0, $013a1733c226ec50$export$22e23a2304399231);
        const checkWrapped = options.checkWrapped !== false;
        return this.renderer_.forEachFeatureAtCoordinate(coordinate, this.frameState_, hitTolerance, checkWrapped, callback, null, layerFilter, null);
    }
    /**
   * Get all features that intersect a pixel on the viewport.
   * For polygons without a fill, only the stroke will be used for hit detection.
   * Polygons must have a fill style applied to ensure that pixels inside a polygon are detected.
   * The fill can be transparent.
   * @param {import("./pixel.js").Pixel} pixel Pixel.
   * @param {AtPixelOptions} [options] Optional options.
   * @return {Array<import("./Feature.js").FeatureLike>} The detected features or
   * an empty array if none were found.
   * @api
   */ getFeaturesAtPixel(pixel, options) {
        const features = [];
        this.forEachFeatureAtPixel(pixel, function(feature) {
            features.push(feature);
        }, options);
        return features;
    }
    /**
   * Get all layers from all layer groups.
   * @return {Array<import("./layer/Layer.js").default>} Layers.
   * @api
   */ getAllLayers() {
        const layers = [];
        function addLayersFrom(layerGroup) {
            layerGroup.forEach(function(layer) {
                if (layer instanceof (0, $0b703156bb914e6f$export$2e2bcd8739ae039)) addLayersFrom(layer.getLayers());
                else layers.push(layer);
            });
        }
        addLayersFrom(this.getLayers());
        return layers;
    }
    /**
   * Detect if features intersect a pixel on the viewport. Layers included in the
   * detection can be configured through the `layerFilter` option.
   * For polygons without a fill, only the stroke will be used for hit detection.
   * Polygons must have a fill style applied to ensure that pixels inside a polygon are detected.
   * The fill can be transparent.
   * @param {import("./pixel.js").Pixel} pixel Pixel.
   * @param {AtPixelOptions} [options] Optional options.
   * @return {boolean} Is there a feature at the given pixel?
   * @api
   */ hasFeatureAtPixel(pixel, options) {
        if (!this.frameState_ || !this.renderer_) return false;
        const coordinate = this.getCoordinateFromPixelInternal(pixel);
        options = options !== undefined ? options : {};
        const layerFilter = options.layerFilter !== undefined ? options.layerFilter : (0, $013a1733c226ec50$export$22e23a2304399231);
        const hitTolerance = options.hitTolerance !== undefined ? options.hitTolerance : 0;
        const checkWrapped = options.checkWrapped !== false;
        return this.renderer_.hasFeatureAtCoordinate(coordinate, this.frameState_, hitTolerance, checkWrapped, layerFilter, null);
    }
    /**
   * Returns the coordinate in user projection for a browser event.
   * @param {MouseEvent} event Event.
   * @return {import("./coordinate.js").Coordinate} Coordinate.
   * @api
   */ getEventCoordinate(event) {
        return this.getCoordinateFromPixel(this.getEventPixel(event));
    }
    /**
   * Returns the coordinate in view projection for a browser event.
   * @param {MouseEvent} event Event.
   * @return {import("./coordinate.js").Coordinate} Coordinate.
   */ getEventCoordinateInternal(event) {
        return this.getCoordinateFromPixelInternal(this.getEventPixel(event));
    }
    /**
   * Returns the map pixel position for a browser event relative to the viewport.
   * @param {UIEvent|{clientX: number, clientY: number}} event Event.
   * @return {import("./pixel.js").Pixel} Pixel.
   * @api
   */ getEventPixel(event) {
        const viewport = this.viewport_;
        const viewportPosition = viewport.getBoundingClientRect();
        const viewportSize = this.getSize();
        const scaleX = viewportPosition.width / viewportSize[0];
        const scaleY = viewportPosition.height / viewportSize[1];
        const eventPosition = //FIXME Are we really calling this with a TouchEvent anywhere?
        'changedTouches' in event ? /** @type {TouchEvent} */ event.changedTouches[0] : /** @type {MouseEvent} */ event;
        return [
            (eventPosition.clientX - viewportPosition.left) / scaleX,
            (eventPosition.clientY - viewportPosition.top) / scaleY
        ];
    }
    /**
   * Get the target in which this map is rendered.
   * Note that this returns what is entered as an option or in setTarget:
   * if that was an element, it returns an element; if a string, it returns that.
   * @return {HTMLElement|string|undefined} The Element or id of the Element that the
   *     map is rendered in.
   * @observable
   * @api
   */ getTarget() {
        return /** @type {HTMLElement|string|undefined} */ this.get((0, $07fa325567004bb7$export$2e2bcd8739ae039).TARGET);
    }
    /**
   * Get the DOM element into which this map is rendered. In contrast to
   * `getTarget` this method always return an `Element`, or `null` if the
   * map has no target.
   * @return {HTMLElement} The element that the map is rendered in.
   * @api
   */ getTargetElement() {
        return this.targetElement_;
    }
    /**
   * Get the coordinate for a given pixel.  This returns a coordinate in the
   * user projection.
   * @param {import("./pixel.js").Pixel} pixel Pixel position in the map viewport.
   * @return {import("./coordinate.js").Coordinate} The coordinate for the pixel position.
   * @api
   */ getCoordinateFromPixel(pixel) {
        return (0, $9c4744460e43e41b$export$698f563af1ba02a5)(this.getCoordinateFromPixelInternal(pixel), this.getView().getProjection());
    }
    /**
   * Get the coordinate for a given pixel.  This returns a coordinate in the
   * map view projection.
   * @param {import("./pixel.js").Pixel} pixel Pixel position in the map viewport.
   * @return {import("./coordinate.js").Coordinate} The coordinate for the pixel position.
   */ getCoordinateFromPixelInternal(pixel) {
        const frameState = this.frameState_;
        if (!frameState) return null;
        return (0, $e22e7611e69f42a9$export$5635d7ef4b8fee1c)(frameState.pixelToCoordinateTransform, pixel.slice());
    }
    /**
   * Get the map controls. Modifying this collection changes the controls
   * associated with the map.
   * @return {Collection<import("./control/Control.js").default>} Controls.
   * @api
   */ getControls() {
        return this.controls;
    }
    /**
   * Get the map overlays. Modifying this collection changes the overlays
   * associated with the map.
   * @return {Collection<import("./Overlay.js").default>} Overlays.
   * @api
   */ getOverlays() {
        return this.overlays_;
    }
    /**
   * Get an overlay by its identifier (the value returned by overlay.getId()).
   * Note that the index treats string and numeric identifiers as the same. So
   * `map.getOverlayById(2)` will return an overlay with id `'2'` or `2`.
   * @param {string|number} id Overlay identifier.
   * @return {import("./Overlay.js").default|null} Overlay.
   * @api
   */ getOverlayById(id) {
        const overlay = this.overlayIdIndex_[id.toString()];
        return overlay !== undefined ? overlay : null;
    }
    /**
   * Get the map interactions. Modifying this collection changes the interactions
   * associated with the map.
   *
   * Interactions are used for e.g. pan, zoom and rotate.
   * @return {Collection<import("./interaction/Interaction.js").default>} Interactions.
   * @api
   */ getInteractions() {
        return this.interactions;
    }
    /**
   * Get the layergroup associated with this map.
   * @return {LayerGroup} A layer group containing the layers in this map.
   * @observable
   * @api
   */ getLayerGroup() {
        return /** @type {LayerGroup} */ this.get((0, $07fa325567004bb7$export$2e2bcd8739ae039).LAYERGROUP);
    }
    /**
   * Clear any existing layers and add layers to the map.
   * @param {Array<import("./layer/Base.js").default>|Collection<import("./layer/Base.js").default>} layers The layers to be added to the map.
   * @api
   */ setLayers(layers) {
        const group = this.getLayerGroup();
        if (layers instanceof (0, $931ffc4e747c14db$export$2e2bcd8739ae039)) {
            group.setLayers(layers);
            return;
        }
        const collection = group.getLayers();
        collection.clear();
        collection.extend(layers);
    }
    /**
   * Get the collection of layers associated with this map.
   * @return {!Collection<import("./layer/Base.js").default>} Layers.
   * @api
   */ getLayers() {
        const layers = this.getLayerGroup().getLayers();
        return layers;
    }
    /**
   * @return {boolean} Layers have sources that are still loading.
   */ getLoadingOrNotReady() {
        const layerStatesArray = this.getLayerGroup().getLayerStatesArray();
        for(let i = 0, ii = layerStatesArray.length; i < ii; ++i){
            const state = layerStatesArray[i];
            if (!state.visible) continue;
            const renderer = state.layer.getRenderer();
            if (renderer && !renderer.ready) return true;
            const source = state.layer.getSource();
            if (source && source.loading) return true;
        }
        return false;
    }
    /**
   * Get the pixel for a coordinate.  This takes a coordinate in the user
   * projection and returns the corresponding pixel.
   * @param {import("./coordinate.js").Coordinate} coordinate A map coordinate.
   * @return {import("./pixel.js").Pixel} A pixel position in the map viewport.
   * @api
   */ getPixelFromCoordinate(coordinate) {
        const viewCoordinate = (0, $9c4744460e43e41b$export$d4b8ec0b96db1ee2)(coordinate, this.getView().getProjection());
        return this.getPixelFromCoordinateInternal(viewCoordinate);
    }
    /**
   * Get the pixel for a coordinate.  This takes a coordinate in the map view
   * projection and returns the corresponding pixel.
   * @param {import("./coordinate.js").Coordinate} coordinate A map coordinate.
   * @return {import("./pixel.js").Pixel} A pixel position in the map viewport.
   */ getPixelFromCoordinateInternal(coordinate) {
        const frameState = this.frameState_;
        if (!frameState) return null;
        return (0, $e22e7611e69f42a9$export$5635d7ef4b8fee1c)(frameState.coordinateToPixelTransform, coordinate.slice(0, 2));
    }
    /**
   * Get the map renderer.
   * @return {import("./renderer/Map.js").default|null} Renderer
   */ getRenderer() {
        return this.renderer_;
    }
    /**
   * Get the size of this map.
   * @return {import("./size.js").Size|undefined} The size in pixels of the map in the DOM.
   * @observable
   * @api
   */ getSize() {
        return /** @type {import("./size.js").Size|undefined} */ this.get((0, $07fa325567004bb7$export$2e2bcd8739ae039).SIZE);
    }
    /**
   * Get the view associated with this map. A view manages properties such as
   * center and resolution.
   * @return {View} The view that controls this map.
   * @observable
   * @api
   */ getView() {
        return /** @type {View} */ this.get((0, $07fa325567004bb7$export$2e2bcd8739ae039).VIEW);
    }
    /**
   * Get the element that serves as the map viewport.
   * @return {HTMLElement} Viewport.
   * @api
   */ getViewport() {
        return this.viewport_;
    }
    /**
   * Get the element that serves as the container for overlays.  Elements added to
   * this container will let mousedown and touchstart events through to the map,
   * so clicks and gestures on an overlay will trigger {@link module:ol/MapBrowserEvent~MapBrowserEvent}
   * events.
   * @return {!HTMLElement} The map's overlay container.
   */ getOverlayContainer() {
        return this.overlayContainer_;
    }
    /**
   * Get the element that serves as a container for overlays that don't allow
   * event propagation. Elements added to this container won't let mousedown and
   * touchstart events through to the map, so clicks and gestures on an overlay
   * don't trigger any {@link module:ol/MapBrowserEvent~MapBrowserEvent}.
   * @return {!HTMLElement} The map's overlay container that stops events.
   */ getOverlayContainerStopEvent() {
        return this.overlayContainerStopEvent_;
    }
    /**
   * @return {!Document} The document where the map is displayed.
   */ getOwnerDocument() {
        const targetElement = this.getTargetElement();
        return targetElement ? targetElement.ownerDocument : document;
    }
    /**
   * @param {import("./Tile.js").default} tile Tile.
   * @param {string} tileSourceKey Tile source key.
   * @param {import("./coordinate.js").Coordinate} tileCenter Tile center.
   * @param {number} tileResolution Tile resolution.
   * @return {number} Tile priority.
   */ getTilePriority(tile, tileSourceKey, tileCenter, tileResolution) {
        return (0, $4c51fd53052a6bbc$export$f08ad5eceeff5d45)(this.frameState_, tile, tileSourceKey, tileCenter, tileResolution);
    }
    /**
   * @param {PointerEvent|KeyboardEvent|WheelEvent} browserEvent Browser event.
   * @param {string} [type] Type.
   */ handleBrowserEvent(browserEvent, type) {
        type = type || browserEvent.type;
        const mapBrowserEvent = new (0, $a1b91f073c6a6c43$export$2e2bcd8739ae039)(type, this, browserEvent);
        this.handleMapBrowserEvent(mapBrowserEvent);
    }
    /**
   * @param {MapBrowserEvent} mapBrowserEvent The event to handle.
   */ handleMapBrowserEvent(mapBrowserEvent) {
        if (!this.frameState_) // With no view defined, we cannot translate pixels into geographical
        // coordinates so interactions cannot be used.
        return;
        const originalEvent = mapBrowserEvent.originalEvent;
        const eventType = originalEvent.type;
        if (eventType === (0, $d564567e31203d44$export$2e2bcd8739ae039).POINTERDOWN || eventType === (0, $294047c5e65f31a3$export$2e2bcd8739ae039).WHEEL || eventType === (0, $294047c5e65f31a3$export$2e2bcd8739ae039).KEYDOWN) {
            const doc = this.getOwnerDocument();
            const rootNode = this.viewport_.getRootNode ? this.viewport_.getRootNode() : doc;
            const target = /** @type {Node} */ originalEvent.target;
            const currentDoc = rootNode instanceof ShadowRoot ? rootNode.host === target ? rootNode.host.ownerDocument : rootNode : rootNode === doc ? doc.documentElement : rootNode;
            if (// Abort if the target is a child of the container for elements whose events are not meant
            // to be handled by map interactions.
            this.overlayContainerStopEvent_.contains(target) || // Abort if the event target is a child of the container that is no longer in the page.
            // It's possible for the target to no longer be in the page if it has been removed in an
            // event listener, this might happen in a Control that recreates it's content based on
            // user interaction either manually or via a render in something like https://reactjs.org/
            !currentDoc.contains(target)) return;
        }
        mapBrowserEvent.frameState = this.frameState_;
        if (this.dispatchEvent(mapBrowserEvent) !== false) {
            const interactionsArray = this.getInteractions().getArray().slice();
            for(let i = interactionsArray.length - 1; i >= 0; i--){
                const interaction = interactionsArray[i];
                if (interaction.getMap() !== this || !interaction.getActive() || !this.getTargetElement()) continue;
                const cont = interaction.handleEvent(mapBrowserEvent);
                if (!cont || mapBrowserEvent.propagationStopped) break;
            }
        }
    }
    /**
   * @protected
   */ handlePostRender() {
        const frameState = this.frameState_;
        // Manage the tile queue
        // Image loads are expensive and a limited resource, so try to use them
        // efficiently:
        // * When the view is static we allow a large number of parallel tile loads
        //   to complete the frame as quickly as possible.
        // * When animating or interacting, image loads can cause janks, so we reduce
        //   the maximum number of loads per frame and limit the number of parallel
        //   tile loads to remain reactive to view changes and to reduce the chance of
        //   loading tiles that will quickly disappear from view.
        const tileQueue = this.tileQueue_;
        if (!tileQueue.isEmpty()) {
            let maxTotalLoading = this.maxTilesLoading_;
            let maxNewLoads = maxTotalLoading;
            if (frameState) {
                const hints = frameState.viewHints;
                if (hints[(0, $7d362782b4ccb93d$export$2e2bcd8739ae039).ANIMATING] || hints[(0, $7d362782b4ccb93d$export$2e2bcd8739ae039).INTERACTING]) {
                    const lowOnFrameBudget = Date.now() - frameState.time > 8;
                    maxTotalLoading = lowOnFrameBudget ? 0 : 8;
                    maxNewLoads = lowOnFrameBudget ? 0 : 2;
                }
            }
            if (tileQueue.getTilesLoading() < maxTotalLoading) {
                tileQueue.reprioritize(); // FIXME only call if view has changed
                tileQueue.loadMoreTiles(maxTotalLoading, maxNewLoads);
            }
        }
        if (frameState && this.renderer_ && !frameState.animate) {
            if (this.renderComplete_) {
                if (this.hasListener((0, $f5e92a4d985a2824$export$2e2bcd8739ae039).RENDERCOMPLETE)) this.renderer_.dispatchRenderEvent((0, $f5e92a4d985a2824$export$2e2bcd8739ae039).RENDERCOMPLETE, frameState);
                if (this.loaded_ === false) {
                    this.loaded_ = true;
                    this.dispatchEvent(new (0, $3a171922c3a0c5ed$export$2e2bcd8739ae039)((0, $e4ad75f913b6f7ff$export$2e2bcd8739ae039).LOADEND, this, frameState));
                }
            } else if (this.loaded_ === true) {
                this.loaded_ = false;
                this.dispatchEvent(new (0, $3a171922c3a0c5ed$export$2e2bcd8739ae039)((0, $e4ad75f913b6f7ff$export$2e2bcd8739ae039).LOADSTART, this, frameState));
            }
        }
        const postRenderFunctions = this.postRenderFunctions_;
        if (frameState) for(let i = 0, ii = postRenderFunctions.length; i < ii; ++i)postRenderFunctions[i](this, frameState);
        postRenderFunctions.length = 0;
    }
    /**
   * @private
   */ handleSizeChanged_() {
        if (this.getView() && !this.getView().getAnimating()) this.getView().resolveConstraints(0);
        this.render();
    }
    /**
   * @private
   */ handleTargetChanged_() {
        if (this.mapBrowserEventHandler_) {
            for(let i = 0, ii = this.targetChangeHandlerKeys_.length; i < ii; ++i)(0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921)(this.targetChangeHandlerKeys_[i]);
            this.targetChangeHandlerKeys_ = null;
            this.viewport_.removeEventListener((0, $294047c5e65f31a3$export$2e2bcd8739ae039).CONTEXTMENU, this.boundHandleBrowserEvent_);
            this.viewport_.removeEventListener((0, $294047c5e65f31a3$export$2e2bcd8739ae039).WHEEL, this.boundHandleBrowserEvent_);
            this.mapBrowserEventHandler_.dispose();
            this.mapBrowserEventHandler_ = null;
            this.viewport_.remove();
        }
        if (this.targetElement_) {
            this.resizeObserver_.unobserve(this.targetElement_);
            const rootNode = this.targetElement_.getRootNode();
            if (rootNode instanceof ShadowRoot) this.resizeObserver_.unobserve(rootNode.host);
            this.setSize(undefined);
        }
        // target may be undefined, null, a string or an Element.
        // If it's a string we convert it to an Element before proceeding.
        // If it's not now an Element we remove the viewport from the DOM.
        // If it's an Element we append the viewport element to it.
        const target = this.getTarget();
        const targetElement = typeof target === 'string' ? document.getElementById(target) : target;
        this.targetElement_ = targetElement;
        if (!targetElement) {
            if (this.renderer_) {
                clearTimeout(this.postRenderTimeoutHandle_);
                this.postRenderTimeoutHandle_ = undefined;
                this.postRenderFunctions_.length = 0;
                this.renderer_.dispose();
                this.renderer_ = null;
            }
            if (this.animationDelayKey_) {
                cancelAnimationFrame(this.animationDelayKey_);
                this.animationDelayKey_ = undefined;
            }
        } else {
            targetElement.appendChild(this.viewport_);
            if (!this.renderer_) this.renderer_ = new (0, $fa78c97693b12120$export$2e2bcd8739ae039)(this);
            this.mapBrowserEventHandler_ = new (0, $6085d006f9d0efe2$export$2e2bcd8739ae039)(this, this.moveTolerance_);
            for(const key in 0, $150f412a4a7fa263$export$2e2bcd8739ae039)this.mapBrowserEventHandler_.addEventListener((0, $150f412a4a7fa263$export$2e2bcd8739ae039)[key], this.handleMapBrowserEvent.bind(this));
            this.viewport_.addEventListener((0, $294047c5e65f31a3$export$2e2bcd8739ae039).CONTEXTMENU, this.boundHandleBrowserEvent_, false);
            this.viewport_.addEventListener((0, $294047c5e65f31a3$export$2e2bcd8739ae039).WHEEL, this.boundHandleBrowserEvent_, (0, $67c66761d21428d0$export$f751ce96c6c4e4fc) ? {
                passive: false
            } : false);
            let keyboardEventTarget;
            if (!this.keyboardEventTarget_) {
                // check if map target is in shadowDOM, if yes use host element as target
                const targetRoot = targetElement.getRootNode();
                const targetCandidate = targetRoot instanceof ShadowRoot ? targetRoot.host : targetElement;
                keyboardEventTarget = targetCandidate;
            } else keyboardEventTarget = this.keyboardEventTarget_;
            this.targetChangeHandlerKeys_ = [
                (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(keyboardEventTarget, (0, $294047c5e65f31a3$export$2e2bcd8739ae039).KEYDOWN, this.handleBrowserEvent, this),
                (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(keyboardEventTarget, (0, $294047c5e65f31a3$export$2e2bcd8739ae039).KEYPRESS, this.handleBrowserEvent, this)
            ];
            const rootNode = targetElement.getRootNode();
            if (rootNode instanceof ShadowRoot) this.resizeObserver_.observe(rootNode.host);
            this.resizeObserver_.observe(targetElement);
        }
        this.updateSize();
    // updateSize calls setSize, so no need to call this.render
    // ourselves here.
    }
    /**
   * @private
   */ handleTileChange_() {
        this.render();
    }
    /**
   * @private
   */ handleViewPropertyChanged_() {
        this.render();
    }
    /**
   * @private
   */ handleViewChanged_() {
        if (this.viewPropertyListenerKey_) {
            (0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921)(this.viewPropertyListenerKey_);
            this.viewPropertyListenerKey_ = null;
        }
        if (this.viewChangeListenerKey_) {
            (0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921)(this.viewChangeListenerKey_);
            this.viewChangeListenerKey_ = null;
        }
        const view = this.getView();
        if (view) {
            this.updateViewportSize_(this.getSize());
            this.viewPropertyListenerKey_ = (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(view, (0, $e881b5dca21eb5d4$export$2e2bcd8739ae039).PROPERTYCHANGE, this.handleViewPropertyChanged_, this);
            this.viewChangeListenerKey_ = (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(view, (0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE, this.handleViewPropertyChanged_, this);
            view.resolveConstraints(0);
        }
        this.render();
    }
    /**
   * @private
   */ handleLayerGroupChanged_() {
        if (this.layerGroupPropertyListenerKeys_) {
            this.layerGroupPropertyListenerKeys_.forEach((0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921));
            this.layerGroupPropertyListenerKeys_ = null;
        }
        const layerGroup = this.getLayerGroup();
        if (layerGroup) {
            this.handleLayerAdd_(new (0, $0b703156bb914e6f$export$2f5ff21d758d25a7)('addlayer', layerGroup));
            this.layerGroupPropertyListenerKeys_ = [
                (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(layerGroup, (0, $e881b5dca21eb5d4$export$2e2bcd8739ae039).PROPERTYCHANGE, this.render, this),
                (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(layerGroup, (0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE, this.render, this),
                (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(layerGroup, 'addlayer', this.handleLayerAdd_, this),
                (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(layerGroup, 'removelayer', this.handleLayerRemove_, this)
            ];
        }
        this.render();
    }
    /**
   * @return {boolean} Is rendered.
   */ isRendered() {
        return !!this.frameState_;
    }
    /**
   * @private
   */ animationDelay_() {
        this.animationDelayKey_ = undefined;
        this.renderFrame_(Date.now());
    }
    /**
   * Requests an immediate render in a synchronous manner.
   * @api
   */ renderSync() {
        if (this.animationDelayKey_) cancelAnimationFrame(this.animationDelayKey_);
        this.animationDelay_();
    }
    /**
   * Redraws all text after new fonts have loaded
   */ redrawText() {
        if (!this.frameState_) return;
        const layerStates = this.frameState_.layerStatesArray;
        for(let i = 0, ii = layerStates.length; i < ii; ++i){
            const layer = layerStates[i].layer;
            if (layer.hasRenderer()) layer.getRenderer().handleFontsChanged();
        }
    }
    /**
   * Request a map rendering (at the next animation frame).
   * @api
   */ render() {
        if (this.renderer_ && this.animationDelayKey_ === undefined) this.animationDelayKey_ = requestAnimationFrame(this.animationDelay_);
    }
    /**
   * Remove the given control from the map.
   * @param {import("./control/Control.js").default} control Control.
   * @return {import("./control/Control.js").default|undefined} The removed control (or undefined
   *     if the control was not found).
   * @api
   */ removeControl(control) {
        return this.getControls().remove(control);
    }
    /**
   * Remove the given interaction from the map.
   * @param {import("./interaction/Interaction.js").default} interaction Interaction to remove.
   * @return {import("./interaction/Interaction.js").default|undefined} The removed interaction (or
   *     undefined if the interaction was not found).
   * @api
   */ removeInteraction(interaction) {
        return this.getInteractions().remove(interaction);
    }
    /**
   * Removes the given layer from the map.
   * @param {import("./layer/Base.js").default} layer Layer.
   * @return {import("./layer/Base.js").default|undefined} The removed layer (or undefined if the
   *     layer was not found).
   * @api
   */ removeLayer(layer) {
        const layers = this.getLayerGroup().getLayers();
        return layers.remove(layer);
    }
    /**
   * @param {import("./layer/Group.js").GroupEvent} event The layer remove event.
   * @private
   */ handleLayerRemove_(event) {
        $41aa29ae0c4b607a$var$removeLayerMapProperty(event.layer);
    }
    /**
   * Remove the given overlay from the map.
   * @param {import("./Overlay.js").default} overlay Overlay.
   * @return {import("./Overlay.js").default|undefined} The removed overlay (or undefined
   *     if the overlay was not found).
   * @api
   */ removeOverlay(overlay) {
        return this.getOverlays().remove(overlay);
    }
    /**
   * @param {number} time Time.
   * @private
   */ renderFrame_(time) {
        const size = this.getSize();
        const view = this.getView();
        const previousFrameState = this.frameState_;
        /** @type {?FrameState} */ let frameState = null;
        if (size !== undefined && (0, $cc435a5409103773$export$622c471beb1693c7)(size) && view && view.isDef()) {
            const viewHints = view.getHints(this.frameState_ ? this.frameState_.viewHints : undefined);
            const viewState = view.getState();
            frameState = {
                animate: false,
                coordinateToPixelTransform: this.coordinateToPixelTransform_,
                declutter: null,
                extent: (0, $6da4c8ed3074c92b$export$13ba650faf8308)(viewState.center, viewState.resolution, viewState.rotation, size),
                index: this.frameIndex_++,
                layerIndex: 0,
                layerStatesArray: this.getLayerGroup().getLayerStatesArray(),
                pixelRatio: this.pixelRatio_,
                pixelToCoordinateTransform: this.pixelToCoordinateTransform_,
                postRenderFunctions: [],
                size: size,
                tileQueue: this.tileQueue_,
                time: time,
                usedTiles: {},
                viewState: viewState,
                viewHints: viewHints,
                wantedTiles: {},
                mapId: (0, $6c5e11070e371322$export$5e82334337e0f204)(this),
                renderTargets: {}
            };
            if (viewState.nextCenter && viewState.nextResolution) {
                const rotation = isNaN(viewState.nextRotation) ? viewState.rotation : viewState.nextRotation;
                frameState.nextExtent = (0, $6da4c8ed3074c92b$export$13ba650faf8308)(viewState.nextCenter, viewState.nextResolution, rotation, size);
            }
        }
        this.frameState_ = frameState;
        this.renderer_.renderFrame(frameState);
        if (frameState) {
            if (frameState.animate) this.render();
            Array.prototype.push.apply(this.postRenderFunctions_, frameState.postRenderFunctions);
            if (previousFrameState) {
                const moveStart = !this.previousExtent_ || !(0, $6da4c8ed3074c92b$export$dd1bc94b04021eeb)(this.previousExtent_) && !(0, $6da4c8ed3074c92b$export$e9bab7fafb253603)(frameState.extent, this.previousExtent_);
                if (moveStart) {
                    this.dispatchEvent(new (0, $3a171922c3a0c5ed$export$2e2bcd8739ae039)((0, $e4ad75f913b6f7ff$export$2e2bcd8739ae039).MOVESTART, this, previousFrameState));
                    this.previousExtent_ = (0, $6da4c8ed3074c92b$export$3e2152b047719fa1)(this.previousExtent_);
                }
            }
            const idle = this.previousExtent_ && !frameState.viewHints[(0, $7d362782b4ccb93d$export$2e2bcd8739ae039).ANIMATING] && !frameState.viewHints[(0, $7d362782b4ccb93d$export$2e2bcd8739ae039).INTERACTING] && !(0, $6da4c8ed3074c92b$export$e9bab7fafb253603)(frameState.extent, this.previousExtent_);
            if (idle) {
                this.dispatchEvent(new (0, $3a171922c3a0c5ed$export$2e2bcd8739ae039)((0, $e4ad75f913b6f7ff$export$2e2bcd8739ae039).MOVEEND, this, frameState));
                (0, $6da4c8ed3074c92b$export$9cd59f9826255e47)(frameState.extent, this.previousExtent_);
            }
        }
        this.dispatchEvent(new (0, $3a171922c3a0c5ed$export$2e2bcd8739ae039)((0, $e4ad75f913b6f7ff$export$2e2bcd8739ae039).POSTRENDER, this, frameState));
        this.renderComplete_ = (this.hasListener((0, $e4ad75f913b6f7ff$export$2e2bcd8739ae039).LOADSTART) || this.hasListener((0, $e4ad75f913b6f7ff$export$2e2bcd8739ae039).LOADEND) || this.hasListener((0, $f5e92a4d985a2824$export$2e2bcd8739ae039).RENDERCOMPLETE)) && !this.tileQueue_.getTilesLoading() && !this.tileQueue_.getCount() && !this.getLoadingOrNotReady();
        if (!this.postRenderTimeoutHandle_) this.postRenderTimeoutHandle_ = setTimeout(()=>{
            this.postRenderTimeoutHandle_ = undefined;
            this.handlePostRender();
        }, 0);
    }
    /**
   * Sets the layergroup of this map.
   * @param {LayerGroup} layerGroup A layer group containing the layers in this map.
   * @observable
   * @api
   */ setLayerGroup(layerGroup) {
        const oldLayerGroup = this.getLayerGroup();
        if (oldLayerGroup) this.handleLayerRemove_(new (0, $0b703156bb914e6f$export$2f5ff21d758d25a7)('removelayer', oldLayerGroup));
        this.set((0, $07fa325567004bb7$export$2e2bcd8739ae039).LAYERGROUP, layerGroup);
    }
    /**
   * Set the size of this map.
   * @param {import("./size.js").Size|undefined} size The size in pixels of the map in the DOM.
   * @observable
   * @api
   */ setSize(size) {
        this.set((0, $07fa325567004bb7$export$2e2bcd8739ae039).SIZE, size);
    }
    /**
   * Set the target element to render this map into.
   * For accessibility (focus and keyboard events for map navigation), the `target` element must have a
   *  properly configured `tabindex` attribute. If the `target` element is inside a Shadow DOM, the
   *  `tabindex` atribute must be set on the custom element's host element.
   * @param {HTMLElement|string} [target] The Element or id of the Element
   *     that the map is rendered in.
   * @observable
   * @api
   */ setTarget(target) {
        this.set((0, $07fa325567004bb7$export$2e2bcd8739ae039).TARGET, target);
    }
    /**
   * Set the view for this map.
   * @param {View|Promise<import("./View.js").ViewOptions>|null} view The view that controls this map.
   * It is also possible to pass a promise that resolves to options for constructing a view.  This
   * alternative allows view properties to be resolved by sources or other components that load
   * view-related metadata.
   * @observable
   * @api
   */ setView(view) {
        if (!view || view instanceof (0, $70364d0195659942$export$2e2bcd8739ae039)) {
            this.set((0, $07fa325567004bb7$export$2e2bcd8739ae039).VIEW, view);
            return;
        }
        this.set((0, $07fa325567004bb7$export$2e2bcd8739ae039).VIEW, new (0, $70364d0195659942$export$2e2bcd8739ae039)());
        const map = this;
        view.then(function(viewOptions) {
            map.setView(new (0, $70364d0195659942$export$2e2bcd8739ae039)(viewOptions));
        });
    }
    /**
   * Force a recalculation of the map viewport size.  This should be called when
   * third-party code changes the size of the map viewport.
   * @api
   */ updateSize() {
        const targetElement = this.getTargetElement();
        let size = undefined;
        if (targetElement) {
            const computedStyle = getComputedStyle(targetElement);
            const width = targetElement.offsetWidth - parseFloat(computedStyle['borderLeftWidth']) - parseFloat(computedStyle['paddingLeft']) - parseFloat(computedStyle['paddingRight']) - parseFloat(computedStyle['borderRightWidth']);
            const height = targetElement.offsetHeight - parseFloat(computedStyle['borderTopWidth']) - parseFloat(computedStyle['paddingTop']) - parseFloat(computedStyle['paddingBottom']) - parseFloat(computedStyle['borderBottomWidth']);
            if (!isNaN(width) && !isNaN(height)) {
                size = [
                    Math.max(0, width),
                    Math.max(0, height)
                ];
                if (!(0, $cc435a5409103773$export$622c471beb1693c7)(size) && !!(targetElement.offsetWidth || targetElement.offsetHeight || targetElement.getClientRects().length)) (0, $8c65b0699f3f3f8e$export$c106dd0671a0fc2d)("No map visible because the map container's width or height are 0.");
            }
        }
        const oldSize = this.getSize();
        if (size && (!oldSize || !(0, $b998d41b678ed5d1$export$e9bab7fafb253603)(size, oldSize))) {
            this.setSize(size);
            this.updateViewportSize_(size);
        }
    }
    /**
   * Recomputes the viewport size and save it on the view object (if any)
   * @param {import("./size.js").Size|undefined} size The size.
   * @private
   */ updateViewportSize_(size) {
        const view = this.getView();
        if (view) view.setViewportSize(size);
    }
}
/**
 * @param {MapOptions} options Map options.
 * @return {MapOptionsInternal} Internal map options.
 */ function $41aa29ae0c4b607a$var$createOptionsInternal(options) {
    /**
   * @type {HTMLElement|Document}
   */ let keyboardEventTarget = null;
    if (options.keyboardEventTarget !== undefined) keyboardEventTarget = typeof options.keyboardEventTarget === 'string' ? document.getElementById(options.keyboardEventTarget) : options.keyboardEventTarget;
    /**
   * @type {Object<string, *>}
   */ const values = {};
    const layerGroup = options.layers && typeof /** @type {?} */ options.layers.getLayers === 'function' ? /** @type {LayerGroup} */ options.layers : new (0, $0b703156bb914e6f$export$2e2bcd8739ae039)({
        layers: /** @type {Collection<import("./layer/Base.js").default>|Array<import("./layer/Base.js").default>} */ options.layers
    });
    values[(0, $07fa325567004bb7$export$2e2bcd8739ae039).LAYERGROUP] = layerGroup;
    values[(0, $07fa325567004bb7$export$2e2bcd8739ae039).TARGET] = options.target;
    values[(0, $07fa325567004bb7$export$2e2bcd8739ae039).VIEW] = options.view instanceof (0, $70364d0195659942$export$2e2bcd8739ae039) ? options.view : new (0, $70364d0195659942$export$2e2bcd8739ae039)();
    /** @type {Collection<import("./control/Control.js").default>} */ let controls;
    if (options.controls !== undefined) {
        if (Array.isArray(options.controls)) controls = new (0, $931ffc4e747c14db$export$2e2bcd8739ae039)(options.controls.slice());
        else {
            (0, $35d5ec884318008e$export$a7a9523472993e97)(typeof /** @type {?} */ options.controls.getArray === 'function', 'Expected `controls` to be an array or an `ol/Collection.js`');
            controls = options.controls;
        }
    }
    /** @type {Collection<import("./interaction/Interaction").default>} */ let interactions;
    if (options.interactions !== undefined) {
        if (Array.isArray(options.interactions)) interactions = new (0, $931ffc4e747c14db$export$2e2bcd8739ae039)(options.interactions.slice());
        else {
            (0, $35d5ec884318008e$export$a7a9523472993e97)(typeof /** @type {?} */ options.interactions.getArray === 'function', 'Expected `interactions` to be an array or an `ol/Collection.js`');
            interactions = options.interactions;
        }
    }
    /** @type {Collection<import("./Overlay.js").default>} */ let overlays;
    if (options.overlays !== undefined) {
        if (Array.isArray(options.overlays)) overlays = new (0, $931ffc4e747c14db$export$2e2bcd8739ae039)(options.overlays.slice());
        else {
            (0, $35d5ec884318008e$export$a7a9523472993e97)(typeof /** @type {?} */ options.overlays.getArray === 'function', 'Expected `overlays` to be an array or an `ol/Collection.js`');
            overlays = options.overlays;
        }
    } else overlays = new (0, $931ffc4e747c14db$export$2e2bcd8739ae039)();
    return {
        controls: controls,
        interactions: interactions,
        keyboardEventTarget: keyboardEventTarget,
        overlays: overlays,
        values: values
    };
}
var $41aa29ae0c4b607a$export$2e2bcd8739ae039 = $41aa29ae0c4b607a$var$Map;






/**
 * @module ol/layer/Tile
 */ /**
 * @module ol/renderer/canvas/TileLayer
 */ /**
 * @module ol/DataTile
 */ /**
 * @module ol/Tile
 */ 




/**
 * A function that takes a {@link module:ol/Tile~Tile} for the tile and a
 * `{string}` for the url as arguments. The default is
 * ```js
 * source.setTileLoadFunction(function(tile, src) {
 *   tile.getImage().src = src;
 * });
 * ```
 * For more fine grained control, the load function can use fetch or XMLHttpRequest and involve
 * error handling:
 *
 * ```js
 * import TileState from 'ol/TileState.js';
 *
 * source.setTileLoadFunction(function(tile, src) {
 *   const xhr = new XMLHttpRequest();
 *   xhr.responseType = 'blob';
 *   xhr.addEventListener('loadend', function (evt) {
 *     const data = this.response;
 *     if (data !== undefined) {
 *       tile.getImage().src = URL.createObjectURL(data);
 *     } else {
 *       tile.setState(TileState.ERROR);
 *     }
 *   });
 *   xhr.addEventListener('error', function () {
 *     tile.setState(TileState.ERROR);
 *   });
 *   xhr.open('GET', src);
 *   xhr.send();
 * });
 * ```
 *
 * @typedef {function(Tile, string): void} LoadFunction
 * @api
 */ /**
 * {@link module:ol/source/Tile~TileSource} sources use a function of this type to get
 * the url that provides a tile for a given tile coordinate.
 *
 * This function takes a {@link module:ol/tilecoord~TileCoord} for the tile
 * coordinate, a `{number}` representing the pixel ratio and a
 * {@link module:ol/proj/Projection~Projection} for the projection  as arguments
 * and returns a `{string}` representing the tile URL, or undefined if no tile
 * should be requested for the passed tile coordinate.
 *
 * @typedef {function(import("./tilecoord.js").TileCoord, number,
 *           import("./proj/Projection.js").default): (string|undefined)} UrlFunction
 * @api
 */ /**
 * @typedef {Object} Options
 * @property {number} [transition=250] A duration for tile opacity
 * transitions in milliseconds. A duration of 0 disables the opacity transition.
 * @property {boolean} [interpolate=false] Use interpolated values when resampling.  By default,
 * the nearest neighbor is used when resampling.
 * @api
 */ /**
 * @classdesc
 * Base class for tiles.
 *
 * @abstract
 */ class $0f235d2d04095c6e$var$Tile extends (0, $08c28d22c0cb5a39$export$2e2bcd8739ae039) {
    /**
   * @param {import("./tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {import("./TileState.js").default} state State.
   * @param {Options} [options] Tile options.
   */ constructor(tileCoord, state, options){
        super();
        options = options ? options : {};
        /**
     * @type {import("./tilecoord.js").TileCoord}
     */ this.tileCoord = tileCoord;
        /**
     * @protected
     * @type {import("./TileState.js").default}
     */ this.state = state;
        /**
     * A key assigned to the tile. This is used in conjunction with a source key
     * to determine if a cached version of this tile may be used by the renderer.
     * @type {string}
     */ this.key = '';
        /**
     * The duration for the opacity transition.
     * @private
     * @type {number}
     */ this.transition_ = options.transition === undefined ? 250 : options.transition;
        /**
     * Lookup of start times for rendering transitions.  If the start time is
     * equal to -1, the transition is complete.
     * @private
     * @type {Object<string, number>}
     */ this.transitionStarts_ = {};
        /**
     * @type {boolean}
     */ this.interpolate = !!options.interpolate;
    }
    /**
   * @protected
   */ changed() {
        this.dispatchEvent((0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE);
    }
    /**
   * Called by the tile cache when the tile is removed from the cache due to expiry
   */ release() {
        // to remove the `change` listener on this tile in `ol/TileQueue#handleTileChange`
        this.setState((0, $b8291d9739c3c64e$export$2e2bcd8739ae039).EMPTY);
    }
    /**
   * @return {string} Key.
   */ getKey() {
        return this.key + '/' + this.tileCoord;
    }
    /**
   * Get the tile coordinate for this tile.
   * @return {import("./tilecoord.js").TileCoord} The tile coordinate.
   * @api
   */ getTileCoord() {
        return this.tileCoord;
    }
    /**
   * @return {import("./TileState.js").default} State.
   */ getState() {
        return this.state;
    }
    /**
   * Sets the state of this tile. If you write your own {@link module:ol/Tile~LoadFunction tileLoadFunction} ,
   * it is important to set the state correctly to {@link module:ol/TileState~ERROR}
   * when the tile cannot be loaded. Otherwise the tile cannot be removed from
   * the tile queue and will block other requests.
   * @param {import("./TileState.js").default} state State.
   * @api
   */ setState(state) {
        if (this.state === (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).EMPTY) // no more state changes
        return;
        if (this.state !== (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).ERROR && this.state > state) throw new Error('Tile load sequence violation');
        this.state = state;
        this.changed();
    }
    /**
   * Load the image or retry if loading previously failed.
   * Loading is taken care of by the tile queue, and calling this method is
   * only needed for preloading or for reloading in case of an error.
   * @abstract
   * @api
   */ load() {
        (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Get the alpha value for rendering.
   * @param {string} id An id for the renderer.
   * @param {number} time The render frame time.
   * @return {number} A number between 0 and 1.
   */ getAlpha(id, time) {
        if (!this.transition_) return 1;
        let start = this.transitionStarts_[id];
        if (!start) {
            start = time;
            this.transitionStarts_[id] = start;
        } else if (start === -1) return 1;
        const delta = time - start + 1000 / 60; // avoid rendering at 0
        if (delta >= this.transition_) return 1;
        return (0, $c7ccf7e681a9b333$export$929e5a82286172a6)(delta / this.transition_);
    }
    /**
   * Determine if a tile is in an alpha transition.  A tile is considered in
   * transition if tile.getAlpha() has not yet been called or has been called
   * and returned 1.
   * @param {string} id An id for the renderer.
   * @return {boolean} The tile is in transition.
   */ inTransition(id) {
        if (!this.transition_) return false;
        return this.transitionStarts_[id] !== -1;
    }
    /**
   * Mark a transition as complete.
   * @param {string} id An id for the renderer.
   */ endTransition(id) {
        if (this.transition_) this.transitionStarts_[id] = -1;
    }
    /**
   * @override
   */ disposeInternal() {
        this.release();
        super.disposeInternal();
    }
}
var $0f235d2d04095c6e$export$2e2bcd8739ae039 = $0f235d2d04095c6e$var$Tile;




function $fd518ba473015b27$export$3a7c913cb40dcb7d(data) {
    return data instanceof Image || data instanceof HTMLCanvasElement || data instanceof HTMLVideoElement || data instanceof ImageBitmap ? data : null;
}
function $fd518ba473015b27$export$7386cb0413f6b283(data) {
    return data instanceof Uint8Array || data instanceof Uint8ClampedArray || data instanceof Float32Array || data instanceof DataView ? data : null;
}
const $fd518ba473015b27$export$df4c617b86128e3e = new Error('disposed');
/**
 * @type {CanvasRenderingContext2D|null}
 */ let $fd518ba473015b27$var$sharedContext = null;
function $fd518ba473015b27$export$45b10814cc054894(image) {
    if (!$fd518ba473015b27$var$sharedContext) $fd518ba473015b27$var$sharedContext = (0, $075f937d7366f1a2$export$9e05d10eae75c464)(image.width, image.height, undefined, {
        willReadFrequently: true
    });
    const canvas = $fd518ba473015b27$var$sharedContext.canvas;
    const width = image.width;
    if (canvas.width !== width) canvas.width = width;
    const height = image.height;
    if (canvas.height !== height) canvas.height = height;
    $fd518ba473015b27$var$sharedContext.clearRect(0, 0, width, height);
    $fd518ba473015b27$var$sharedContext.drawImage(image, 0, 0);
    return $fd518ba473015b27$var$sharedContext.getImageData(0, 0, width, height).data;
}
/**
 * @type {import('./size.js').Size}
 */ const $fd518ba473015b27$var$defaultSize = [
    256,
    256
];
/**
 * @typedef {Object} Options
 * @property {import("./tilecoord.js").TileCoord} tileCoord Tile coordinate.
 * @property {function(): Promise<Data>} loader Data loader.  For loaders that generate images,
 * the promise should not resolve until the image is loaded.
 * @property {number} [transition=250] A duration for tile opacity
 * transitions in milliseconds. A duration of 0 disables the opacity transition.
 * @property {boolean} [interpolate=false] Use interpolated values when resampling.  By default,
 * the nearest neighbor is used when resampling.
 * @property {import('./size.js').Size} [size=[256, 256]] Tile size.
 * @property {AbortController} [controller] An abort controller.
 * @api
 */ class $fd518ba473015b27$var$DataTile extends (0, $0f235d2d04095c6e$export$2e2bcd8739ae039) {
    /**
   * @param {Options} options Tile options.
   */ constructor(options){
        const state = (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).IDLE;
        super(options.tileCoord, state, {
            transition: options.transition,
            interpolate: options.interpolate
        });
        /**
     * @type {function(): Promise<Data>}
     * @private
     */ this.loader_ = options.loader;
        /**
     * @type {Data}
     * @private
     */ this.data_ = null;
        /**
     * @type {Error}
     * @private
     */ this.error_ = null;
        /**
     * @type {import('./size.js').Size|null}
     * @private
     */ this.size_ = options.size || null;
        /**
     * @type {AbortController|null}
     * @private
     */ this.controller_ = options.controller || null;
    }
    /**
   * Get the tile size.
   * @return {import('./size.js').Size} Tile size.
   */ getSize() {
        if (this.size_) return this.size_;
        const imageData = $fd518ba473015b27$export$3a7c913cb40dcb7d(this.data_);
        if (imageData) return [
            imageData.width,
            imageData.height
        ];
        return $fd518ba473015b27$var$defaultSize;
    }
    /**
   * Get the data for the tile.
   * @return {Data} Tile data.
   * @api
   */ getData() {
        return this.data_;
    }
    /**
   * Get any loading error.
   * @return {Error} Loading error.
   * @api
   */ getError() {
        return this.error_;
    }
    /**
   * Load the tile data.
   * @api
   * @override
   */ load() {
        if (this.state !== (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).IDLE && this.state !== (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).ERROR) return;
        this.state = (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).LOADING;
        this.changed();
        const self = this;
        this.loader_().then(function(data) {
            self.data_ = data;
            self.state = (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).LOADED;
            self.changed();
        }).catch(function(error) {
            self.error_ = error;
            self.state = (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).ERROR;
            self.changed();
        });
    }
    /**
   * Clean up.
   * @override
   */ disposeInternal() {
        if (this.controller_) {
            this.controller_.abort($fd518ba473015b27$export$df4c617b86128e3e);
            this.controller_ = null;
        }
        super.disposeInternal();
    }
}
var $fd518ba473015b27$export$2e2bcd8739ae039 = $fd518ba473015b27$var$DataTile;


/**
 * @module ol/ImageTile
 */ 



class $cd3bc8d185522361$var$ImageTile extends (0, $0f235d2d04095c6e$export$2e2bcd8739ae039) {
    /**
   * @param {import("./tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {import("./TileState.js").default} state State.
   * @param {string} src Image source URI.
   * @param {?string} crossOrigin Cross origin.
   * @param {import("./Tile.js").LoadFunction} tileLoadFunction Tile load function.
   * @param {import("./Tile.js").Options} [options] Tile options.
   */ constructor(tileCoord, state, src, crossOrigin, tileLoadFunction, options){
        super(tileCoord, state, options);
        /**
     * @private
     * @type {?string}
     */ this.crossOrigin_ = crossOrigin;
        /**
     * Image URI
     *
     * @private
     * @type {string}
     */ this.src_ = src;
        this.key = src;
        /**
     * @private
     * @type {HTMLImageElement|HTMLCanvasElement}
     */ this.image_ = new Image();
        if (crossOrigin !== null) this.image_.crossOrigin = crossOrigin;
        /**
     * @private
     * @type {?function():void}
     */ this.unlisten_ = null;
        /**
     * @private
     * @type {import("./Tile.js").LoadFunction}
     */ this.tileLoadFunction_ = tileLoadFunction;
    }
    /**
   * Get the HTML image element for this tile (may be a Canvas, Image, or Video).
   * @return {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} Image.
   * @api
   */ getImage() {
        return this.image_;
    }
    /**
   * Sets an HTML image element for this tile (may be a Canvas or preloaded Image).
   * @param {HTMLCanvasElement|HTMLImageElement} element Element.
   */ setImage(element) {
        this.image_ = element;
        this.state = (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).LOADED;
        this.unlistenImage_();
        this.changed();
    }
    /**
   * Tracks loading or read errors.
   *
   * @private
   */ handleImageError_() {
        this.state = (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).ERROR;
        this.unlistenImage_();
        this.image_ = $cd3bc8d185522361$var$getBlankImage();
        this.changed();
    }
    /**
   * Tracks successful image load.
   *
   * @private
   */ handleImageLoad_() {
        const image = /** @type {HTMLImageElement} */ this.image_;
        if (image.naturalWidth && image.naturalHeight) this.state = (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).LOADED;
        else this.state = (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).EMPTY;
        this.unlistenImage_();
        this.changed();
    }
    /**
   * Load the image or retry if loading previously failed.
   * Loading is taken care of by the tile queue, and calling this method is
   * only needed for preloading or for reloading in case of an error.
   *
   * To retry loading tiles on failed requests, use a custom `tileLoadFunction`
   * that checks for error status codes and reloads only when the status code is
   * 408, 429, 500, 502, 503 and 504, and only when not too many retries have been
   * made already:
   *
   * ```js
   * const retryCodes = [408, 429, 500, 502, 503, 504];
   * const retries = {};
   * source.setTileLoadFunction((tile, src) => {
   *   const image = tile.getImage();
   *   fetch(src)
   *     .then((response) => {
   *       if (retryCodes.includes(response.status)) {
   *         retries[src] = (retries[src] || 0) + 1;
   *         if (retries[src] <= 3) {
   *           setTimeout(() => tile.load(), retries[src] * 1000);
   *         }
   *         return Promise.reject();
   *       }
   *       return response.blob();
   *     })
   *     .then((blob) => {
   *       const imageUrl = URL.createObjectURL(blob);
   *       image.src = imageUrl;
   *       setTimeout(() => URL.revokeObjectURL(imageUrl), 5000);
   *     })
   *     .catch(() => tile.setState(3)); // error
   * });
   * ```
   * @api
   * @override
   */ load() {
        if (this.state == (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).ERROR) {
            this.state = (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).IDLE;
            this.image_ = new Image();
            if (this.crossOrigin_ !== null) this.image_.crossOrigin = this.crossOrigin_;
        }
        if (this.state == (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).IDLE) {
            this.state = (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).LOADING;
            this.changed();
            this.tileLoadFunction_(this, this.src_);
            this.unlisten_ = (0, $b54439be79d4619a$export$bc96ecc7c2a50764)(this.image_, this.handleImageLoad_.bind(this), this.handleImageError_.bind(this));
        }
    }
    /**
   * Discards event handlers which listen for load completion or errors.
   *
   * @private
   */ unlistenImage_() {
        if (this.unlisten_) {
            this.unlisten_();
            this.unlisten_ = null;
        }
    }
    /**
   * @override
   */ disposeInternal() {
        this.unlistenImage_();
        this.image_ = null;
        super.disposeInternal();
    }
}
/**
 * Get a 1-pixel blank image.
 * @return {HTMLCanvasElement} Blank image.
 */ function $cd3bc8d185522361$var$getBlankImage() {
    const ctx = (0, $075f937d7366f1a2$export$9e05d10eae75c464)(1, 1);
    ctx.fillStyle = 'rgba(0,0,0,0)';
    ctx.fillRect(0, 0, 1, 1);
    return ctx.canvas;
}
var $cd3bc8d185522361$export$2e2bcd8739ae039 = $cd3bc8d185522361$var$ImageTile;


/**
 * @module ol/TileRange
 */ /**
 * A representation of a contiguous block of tiles.  A tile range is specified
 * by its min/max tile coordinates and is inclusive of coordinates.
 */ class $550e524b0d1b61d4$var$TileRange {
    /**
   * @param {number} minX Minimum X.
   * @param {number} maxX Maximum X.
   * @param {number} minY Minimum Y.
   * @param {number} maxY Maximum Y.
   */ constructor(minX, maxX, minY, maxY){
        /**
     * @type {number}
     */ this.minX = minX;
        /**
     * @type {number}
     */ this.maxX = maxX;
        /**
     * @type {number}
     */ this.minY = minY;
        /**
     * @type {number}
     */ this.maxY = maxY;
    }
    /**
   * @param {import("./tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @return {boolean} Contains tile coordinate.
   */ contains(tileCoord) {
        return this.containsXY(tileCoord[1], tileCoord[2]);
    }
    /**
   * @param {TileRange} tileRange Tile range.
   * @return {boolean} Contains.
   */ containsTileRange(tileRange) {
        return this.minX <= tileRange.minX && tileRange.maxX <= this.maxX && this.minY <= tileRange.minY && tileRange.maxY <= this.maxY;
    }
    /**
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @return {boolean} Contains coordinate.
   */ containsXY(x, y) {
        return this.minX <= x && x <= this.maxX && this.minY <= y && y <= this.maxY;
    }
    /**
   * @param {TileRange} tileRange Tile range.
   * @return {boolean} Equals.
   */ equals(tileRange) {
        return this.minX == tileRange.minX && this.minY == tileRange.minY && this.maxX == tileRange.maxX && this.maxY == tileRange.maxY;
    }
    /**
   * @param {TileRange} tileRange Tile range.
   */ extend(tileRange) {
        if (tileRange.minX < this.minX) this.minX = tileRange.minX;
        if (tileRange.maxX > this.maxX) this.maxX = tileRange.maxX;
        if (tileRange.minY < this.minY) this.minY = tileRange.minY;
        if (tileRange.maxY > this.maxY) this.maxY = tileRange.maxY;
    }
    /**
   * @return {number} Height.
   */ getHeight() {
        return this.maxY - this.minY + 1;
    }
    /**
   * @return {import("./size.js").Size} Size.
   */ getSize() {
        return [
            this.getWidth(),
            this.getHeight()
        ];
    }
    /**
   * @return {number} Width.
   */ getWidth() {
        return this.maxX - this.minX + 1;
    }
    /**
   * @param {TileRange} tileRange Tile range.
   * @return {boolean} Intersects.
   */ intersects(tileRange) {
        return this.minX <= tileRange.maxX && this.maxX >= tileRange.minX && this.minY <= tileRange.maxY && this.maxY >= tileRange.minY;
    }
}
function $550e524b0d1b61d4$export$958e3e1a02eac4b6(minX, maxX, minY, maxY, tileRange) {
    if (tileRange !== undefined) {
        tileRange.minX = minX;
        tileRange.maxX = maxX;
        tileRange.minY = minY;
        tileRange.maxY = maxY;
        return tileRange;
    }
    return new $550e524b0d1b61d4$var$TileRange(minX, maxX, minY, maxY);
}
var $550e524b0d1b61d4$export$2e2bcd8739ae039 = $550e524b0d1b61d4$var$TileRange;






/**
 * @module ol/reproj/Tile
 */ 






/**
 * @module ol/reproj
 */ 



let $2b0a118af78fb031$var$brokenDiagonalRendering_;
const $2b0a118af78fb031$export$a166f0857c555517 = [];
/**
 * This draws a small triangle into a canvas by setting the triangle as the clip region
 * and then drawing a (too large) rectangle
 *
 * @param {CanvasRenderingContext2D} ctx The context in which to draw the triangle
 * @param {number} u1 The x-coordinate of the second point. The first point is 0,0.
 * @param {number} v1 The y-coordinate of the second point.
 * @param {number} u2 The x-coordinate of the third point.
 * @param {number} v2 The y-coordinate of the third point.
 */ function $2b0a118af78fb031$var$drawTestTriangle(ctx, u1, v1, u2, v2) {
    ctx.beginPath();
    ctx.moveTo(0, 0);
    ctx.lineTo(u1, v1);
    ctx.lineTo(u2, v2);
    ctx.closePath();
    ctx.save();
    ctx.clip();
    ctx.fillRect(0, 0, Math.max(u1, u2) + 1, Math.max(v1, v2));
    ctx.restore();
}
/**
 * Given the data from getImageData, see if the right values appear at the provided offset.
 * Returns true if either the color or transparency is off
 *
 * @param {Uint8ClampedArray} data The data returned from getImageData
 * @param {number} offset The pixel offset from the start of data.
 * @return {boolean} true if the diagonal rendering is broken
 */ function $2b0a118af78fb031$var$verifyBrokenDiagonalRendering(data, offset) {
    // the values ought to be close to the rgba(210, 0, 0, 0.75)
    return Math.abs(data[offset * 4] - 210) > 2 || Math.abs(data[offset * 4 + 3] - 191.25) > 2;
}
/**
 * Determines if the current browser configuration can render triangular clip regions correctly.
 * This value is cached so the function is only expensive the first time called.
 * Firefox on Windows (as of now) does not if HWA is enabled. See https://bugzilla.mozilla.org/show_bug.cgi?id=1606976
 * Chrome works, and everything seems to work on OSX and Android. This function caches the
 * result. I suppose that it is conceivably possible that a browser might flip modes while the app is
 * running, but lets hope not.
 *
 * @return {boolean} true if the Diagonal Rendering is broken.
 */ function $2b0a118af78fb031$var$isBrokenDiagonalRendering() {
    if ($2b0a118af78fb031$var$brokenDiagonalRendering_ === undefined) {
        const ctx = (0, $075f937d7366f1a2$export$9e05d10eae75c464)(6, 6, $2b0a118af78fb031$export$a166f0857c555517);
        ctx.globalCompositeOperation = 'lighter';
        ctx.fillStyle = 'rgba(210, 0, 0, 0.75)';
        $2b0a118af78fb031$var$drawTestTriangle(ctx, 4, 5, 4, 0);
        $2b0a118af78fb031$var$drawTestTriangle(ctx, 4, 5, 0, 5);
        const data = ctx.getImageData(0, 0, 3, 3).data;
        $2b0a118af78fb031$var$brokenDiagonalRendering_ = $2b0a118af78fb031$var$verifyBrokenDiagonalRendering(data, 0) || $2b0a118af78fb031$var$verifyBrokenDiagonalRendering(data, 4) || $2b0a118af78fb031$var$verifyBrokenDiagonalRendering(data, 8);
        (0, $075f937d7366f1a2$export$e918ac6a1026a12a)(ctx);
        $2b0a118af78fb031$export$a166f0857c555517.push(ctx.canvas);
    }
    return $2b0a118af78fb031$var$brokenDiagonalRendering_;
}
function $2b0a118af78fb031$export$5fbb958059b7e71f(sourceProj, targetProj, targetCenter, targetResolution) {
    const sourceCenter = (0, $9c4744460e43e41b$export$51186ad6e864892a)(targetCenter, targetProj, sourceProj);
    // calculate the ideal resolution of the source data
    let sourceResolution = (0, $9c4744460e43e41b$export$2d8f7b4eec383d44)(targetProj, targetResolution, targetCenter);
    const targetMetersPerUnit = targetProj.getMetersPerUnit();
    if (targetMetersPerUnit !== undefined) sourceResolution *= targetMetersPerUnit;
    const sourceMetersPerUnit = sourceProj.getMetersPerUnit();
    if (sourceMetersPerUnit !== undefined) sourceResolution /= sourceMetersPerUnit;
    // Based on the projection properties, the point resolution at the specified
    // coordinates may be slightly different. We need to reverse-compensate this
    // in order to achieve optimal results.
    const sourceExtent = sourceProj.getExtent();
    if (!sourceExtent || (0, $6da4c8ed3074c92b$export$ac68c24d37ca240f)(sourceExtent, sourceCenter)) {
        const compensationFactor = (0, $9c4744460e43e41b$export$2d8f7b4eec383d44)(sourceProj, sourceResolution, sourceCenter) / sourceResolution;
        if (isFinite(compensationFactor) && compensationFactor > 0) sourceResolution /= compensationFactor;
    }
    return sourceResolution;
}
function $2b0a118af78fb031$export$16d356211d01f1cc(sourceProj, targetProj, targetExtent, targetResolution) {
    const targetCenter = (0, $6da4c8ed3074c92b$export$c91255cadecfe081)(targetExtent);
    let sourceResolution = $2b0a118af78fb031$export$5fbb958059b7e71f(sourceProj, targetProj, targetCenter, targetResolution);
    if (!isFinite(sourceResolution) || sourceResolution <= 0) (0, $6da4c8ed3074c92b$export$f9ed8a3d123a08e2)(targetExtent, function(corner) {
        sourceResolution = $2b0a118af78fb031$export$5fbb958059b7e71f(sourceProj, targetProj, corner, targetResolution);
        return isFinite(sourceResolution) && sourceResolution > 0;
    });
    return sourceResolution;
}
function $2b0a118af78fb031$export$b3890eb0ae9dca99(width, height, pixelRatio, sourceResolution, sourceExtent, targetResolution, targetExtent, triangulation, sources, gutter, renderEdges, interpolate, drawSingle, clipExtent) {
    const context = (0, $075f937d7366f1a2$export$9e05d10eae75c464)(Math.round(pixelRatio * width), Math.round(pixelRatio * height), $2b0a118af78fb031$export$a166f0857c555517);
    if (!interpolate) context.imageSmoothingEnabled = false;
    if (sources.length === 0) return context.canvas;
    context.scale(pixelRatio, pixelRatio);
    function pixelRound(value) {
        return Math.round(value * pixelRatio) / pixelRatio;
    }
    context.globalCompositeOperation = 'lighter';
    const sourceDataExtent = (0, $6da4c8ed3074c92b$export$fe201bb3bbe031e9)();
    sources.forEach(function(src, i, arr) {
        (0, $6da4c8ed3074c92b$export$8b58be045bf06082)(sourceDataExtent, src.extent);
    });
    let stitchContext;
    const stitchScale = pixelRatio / sourceResolution;
    // Round up Float32 scale values to prevent interpolation in Firefox.
    const inverseScale = (interpolate ? 1 : 1 + Math.pow(2, -24)) / stitchScale;
    if (!drawSingle || sources.length !== 1 || gutter !== 0) {
        stitchContext = (0, $075f937d7366f1a2$export$9e05d10eae75c464)(Math.round((0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(sourceDataExtent) * stitchScale), Math.round((0, $6da4c8ed3074c92b$export$c08559766941f856)(sourceDataExtent) * stitchScale), $2b0a118af78fb031$export$a166f0857c555517);
        if (!interpolate) stitchContext.imageSmoothingEnabled = false;
        if (sourceExtent && clipExtent) {
            const xPos = (sourceExtent[0] - sourceDataExtent[0]) * stitchScale;
            const yPos = -(sourceExtent[3] - sourceDataExtent[3]) * stitchScale;
            const width = (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(sourceExtent) * stitchScale;
            const height = (0, $6da4c8ed3074c92b$export$c08559766941f856)(sourceExtent) * stitchScale;
            stitchContext.rect(xPos, yPos, width, height);
            stitchContext.clip();
        }
        sources.forEach(function(src, i, arr) {
            // This test should never fail -- but it does. Need to find a fix the upstream condition
            if (src.image.width > 0 && src.image.height > 0) {
                if (src.clipExtent) {
                    stitchContext.save();
                    const xPos = (src.clipExtent[0] - sourceDataExtent[0]) * stitchScale;
                    const yPos = -(src.clipExtent[3] - sourceDataExtent[3]) * stitchScale;
                    const width = (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(src.clipExtent) * stitchScale;
                    const height = (0, $6da4c8ed3074c92b$export$c08559766941f856)(src.clipExtent) * stitchScale;
                    stitchContext.rect(interpolate ? xPos : Math.round(xPos), interpolate ? yPos : Math.round(yPos), interpolate ? width : Math.round(xPos + width) - Math.round(xPos), interpolate ? height : Math.round(yPos + height) - Math.round(yPos));
                    stitchContext.clip();
                }
                const xPos = (src.extent[0] - sourceDataExtent[0]) * stitchScale;
                const yPos = -(src.extent[3] - sourceDataExtent[3]) * stitchScale;
                const srcWidth = (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(src.extent) * stitchScale;
                const srcHeight = (0, $6da4c8ed3074c92b$export$c08559766941f856)(src.extent) * stitchScale;
                stitchContext.drawImage(src.image, gutter, gutter, src.image.width - 2 * gutter, src.image.height - 2 * gutter, interpolate ? xPos : Math.round(xPos), interpolate ? yPos : Math.round(yPos), interpolate ? srcWidth : Math.round(xPos + srcWidth) - Math.round(xPos), interpolate ? srcHeight : Math.round(yPos + srcHeight) - Math.round(yPos));
                if (src.clipExtent) stitchContext.restore();
            }
        });
    }
    const targetTopLeft = (0, $6da4c8ed3074c92b$export$cb1538b07e6964ff)(targetExtent);
    triangulation.getTriangles().forEach(function(triangle, i, arr) {
        /* Calculate affine transform (src -> dst)
     * Resulting matrix can be used to transform coordinate
     * from `sourceProjection` to destination pixels.
     *
     * To optimize number of context calls and increase numerical stability,
     * we also do the following operations:
     * trans(-topLeftExtentCorner), scale(1 / targetResolution), scale(1, -1)
     * here before solving the linear system so [ui, vi] are pixel coordinates.
     *
     * Src points: xi, yi
     * Dst points: ui, vi
     * Affine coefficients: aij
     *
     * | x0 y0 1  0  0 0 |   |a00|   |u0|
     * | x1 y1 1  0  0 0 |   |a01|   |u1|
     * | x2 y2 1  0  0 0 | x |a02| = |u2|
     * |  0  0 0 x0 y0 1 |   |a10|   |v0|
     * |  0  0 0 x1 y1 1 |   |a11|   |v1|
     * |  0  0 0 x2 y2 1 |   |a12|   |v2|
     */ const source = triangle.source;
        const target = triangle.target;
        let x0 = source[0][0], y0 = source[0][1];
        let x1 = source[1][0], y1 = source[1][1];
        let x2 = source[2][0], y2 = source[2][1];
        // Make sure that everything is on pixel boundaries
        const u0 = pixelRound((target[0][0] - targetTopLeft[0]) / targetResolution);
        const v0 = pixelRound(-(target[0][1] - targetTopLeft[1]) / targetResolution);
        const u1 = pixelRound((target[1][0] - targetTopLeft[0]) / targetResolution);
        const v1 = pixelRound(-(target[1][1] - targetTopLeft[1]) / targetResolution);
        const u2 = pixelRound((target[2][0] - targetTopLeft[0]) / targetResolution);
        const v2 = pixelRound(-(target[2][1] - targetTopLeft[1]) / targetResolution);
        // Shift all the source points to improve numerical stability
        // of all the subsequent calculations. The [x0, y0] is used here.
        // This is also used to simplify the linear system.
        const sourceNumericalShiftX = x0;
        const sourceNumericalShiftY = y0;
        x0 = 0;
        y0 = 0;
        x1 -= sourceNumericalShiftX;
        y1 -= sourceNumericalShiftY;
        x2 -= sourceNumericalShiftX;
        y2 -= sourceNumericalShiftY;
        const augmentedMatrix = [
            [
                x1,
                y1,
                0,
                0,
                u1 - u0
            ],
            [
                x2,
                y2,
                0,
                0,
                u2 - u0
            ],
            [
                0,
                0,
                x1,
                y1,
                v1 - v0
            ],
            [
                0,
                0,
                x2,
                y2,
                v2 - v0
            ]
        ];
        const affineCoefs = (0, $6b000a049d919fe5$export$8240f01c446270e6)(augmentedMatrix);
        if (!affineCoefs) return;
        context.save();
        context.beginPath();
        if ($2b0a118af78fb031$var$isBrokenDiagonalRendering() || !interpolate) {
            // Make sure that all lines are horizontal or vertical
            context.moveTo(u1, v1);
            // This is the diagonal line. Do it in 4 steps
            const steps = 4;
            const ud = u0 - u1;
            const vd = v0 - v1;
            for(let step = 0; step < steps; step++){
                // Go horizontally
                context.lineTo(u1 + pixelRound((step + 1) * ud / steps), v1 + pixelRound(step * vd / (steps - 1)));
                // Go vertically
                if (step != steps - 1) context.lineTo(u1 + pixelRound((step + 1) * ud / steps), v1 + pixelRound((step + 1) * vd / (steps - 1)));
            }
            // We are almost at u0r, v0r
            context.lineTo(u2, v2);
        } else {
            context.moveTo(u1, v1);
            context.lineTo(u0, v0);
            context.lineTo(u2, v2);
        }
        context.clip();
        context.transform(affineCoefs[0], affineCoefs[2], affineCoefs[1], affineCoefs[3], u0, v0);
        context.translate(sourceDataExtent[0] - sourceNumericalShiftX, sourceDataExtent[3] - sourceNumericalShiftY);
        let image;
        if (stitchContext) {
            image = stitchContext.canvas;
            context.scale(inverseScale, -inverseScale);
        } else {
            const source = sources[0];
            const extent = source.extent;
            image = source.image;
            context.scale((0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(extent) / image.width, -(0, $6da4c8ed3074c92b$export$c08559766941f856)(extent) / image.height);
        }
        context.drawImage(image, 0, 0);
        context.restore();
    });
    if (stitchContext) {
        (0, $075f937d7366f1a2$export$e918ac6a1026a12a)(stitchContext);
        $2b0a118af78fb031$export$a166f0857c555517.push(stitchContext.canvas);
    }
    if (renderEdges) {
        context.save();
        context.globalCompositeOperation = 'source-over';
        context.strokeStyle = 'black';
        context.lineWidth = 1;
        triangulation.getTriangles().forEach(function(triangle, i, arr) {
            const target = triangle.target;
            const u0 = (target[0][0] - targetTopLeft[0]) / targetResolution;
            const v0 = -(target[0][1] - targetTopLeft[1]) / targetResolution;
            const u1 = (target[1][0] - targetTopLeft[0]) / targetResolution;
            const v1 = -(target[1][1] - targetTopLeft[1]) / targetResolution;
            const u2 = (target[2][0] - targetTopLeft[0]) / targetResolution;
            const v2 = -(target[2][1] - targetTopLeft[1]) / targetResolution;
            context.beginPath();
            context.moveTo(u1, v1);
            context.lineTo(u0, v0);
            context.lineTo(u2, v2);
            context.closePath();
            context.stroke();
        });
        context.restore();
    }
    return context.canvas;
}


/**
 * @module ol/reproj/Triangulation
 */ 



/**
 * Single triangle; consists of 3 source points and 3 target points.
 * @typedef {Object} Triangle
 * @property {Array<import("../coordinate.js").Coordinate>} source Source.
 * @property {Array<import("../coordinate.js").Coordinate>} target Target.
 */ /**
 * Maximum number of subdivision steps during raster reprojection triangulation.
 * Prevents high memory usage and large number of proj4 calls (for certain
 * transformations and areas). At most `2*(2^this)` triangles are created for
 * each triangulated extent (tile/image).
 * @type {number}
 */ const $6be53f6edfbf1854$var$MAX_SUBDIVISION = 10;
/**
 * Maximum allowed size of triangle relative to world width. When transforming
 * corners of world extent between certain projections, the resulting
 * triangulation seems to have zero error and no subdivision is performed. If
 * the triangle width is more than this (relative to world width; 0-1),
 * subdivison is forced (up to `MAX_SUBDIVISION`). Default is `0.25`.
 * @type {number}
 */ const $6be53f6edfbf1854$var$MAX_TRIANGLE_WIDTH = 0.25;
/**
 * @classdesc
 * Class containing triangulation of the given target extent.
 * Used for determining source data and the reprojection itself.
 */ class $6be53f6edfbf1854$var$Triangulation {
    /**
   * @param {import("../proj/Projection.js").default} sourceProj Source projection.
   * @param {import("../proj/Projection.js").default} targetProj Target projection.
   * @param {import("../extent.js").Extent} targetExtent Target extent to triangulate.
   * @param {import("../extent.js").Extent} maxSourceExtent Maximal source extent that can be used.
   * @param {number} errorThreshold Acceptable error (in source units).
   * @param {?number} destinationResolution The (optional) resolution of the destination.
   * @param {import("../transform.js").Transform} [sourceMatrix] Source transform matrix.
   */ constructor(sourceProj, targetProj, targetExtent, maxSourceExtent, errorThreshold, destinationResolution, sourceMatrix){
        /**
     * @type {import("../proj/Projection.js").default}
     * @private
     */ this.sourceProj_ = sourceProj;
        /**
     * @type {import("../proj/Projection.js").default}
     * @private
     */ this.targetProj_ = targetProj;
        /** @type {!Object<string, import("../coordinate.js").Coordinate>} */ let transformInvCache = {};
        const transformInv = sourceMatrix ? (0, $9c4744460e43e41b$export$6b4aafd331159e0d)((input)=>(0, $e22e7611e69f42a9$export$5635d7ef4b8fee1c)(sourceMatrix, (0, $9c4744460e43e41b$export$51186ad6e864892a)(input, this.targetProj_, this.sourceProj_))) : (0, $9c4744460e43e41b$export$fce0c6cfca85ed96)(this.targetProj_, this.sourceProj_);
        /**
     * @param {import("../coordinate.js").Coordinate} c A coordinate.
     * @return {import("../coordinate.js").Coordinate} Transformed coordinate.
     * @private
     */ this.transformInv_ = function(c) {
            const key = c[0] + '/' + c[1];
            if (!transformInvCache[key]) transformInvCache[key] = transformInv(c);
            return transformInvCache[key];
        };
        /**
     * @type {import("../extent.js").Extent}
     * @private
     */ this.maxSourceExtent_ = maxSourceExtent;
        /**
     * @type {number}
     * @private
     */ this.errorThresholdSquared_ = errorThreshold * errorThreshold;
        /**
     * @type {Array<Triangle>}
     * @private
     */ this.triangles_ = [];
        /**
     * Indicates that the triangulation crosses edge of the source projection.
     * @type {boolean}
     * @private
     */ this.wrapsXInSource_ = false;
        /**
     * @type {boolean}
     * @private
     */ this.canWrapXInSource_ = this.sourceProj_.canWrapX() && !!maxSourceExtent && !!this.sourceProj_.getExtent() && (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(maxSourceExtent) >= (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(this.sourceProj_.getExtent());
        /**
     * @type {?number}
     * @private
     */ this.sourceWorldWidth_ = this.sourceProj_.getExtent() ? (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(this.sourceProj_.getExtent()) : null;
        /**
     * @type {?number}
     * @private
     */ this.targetWorldWidth_ = this.targetProj_.getExtent() ? (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(this.targetProj_.getExtent()) : null;
        const destinationTopLeft = (0, $6da4c8ed3074c92b$export$cb1538b07e6964ff)(targetExtent);
        const destinationTopRight = (0, $6da4c8ed3074c92b$export$b84fa077c8b05295)(targetExtent);
        const destinationBottomRight = (0, $6da4c8ed3074c92b$export$e77c1cf70445e168)(targetExtent);
        const destinationBottomLeft = (0, $6da4c8ed3074c92b$export$8d09f5e2e1bf560d)(targetExtent);
        const sourceTopLeft = this.transformInv_(destinationTopLeft);
        const sourceTopRight = this.transformInv_(destinationTopRight);
        const sourceBottomRight = this.transformInv_(destinationBottomRight);
        const sourceBottomLeft = this.transformInv_(destinationBottomLeft);
        /*
     * The maxSubdivision controls how many splittings of the target area can
     * be done. The idea here is to do a linear mapping of the target areas
     * but the actual overall reprojection (can be) extremely non-linear. The
     * default value of MAX_SUBDIVISION was chosen based on mapping a 256x256
     * tile size. However this function is also called to remap canvas rendered
     * layers which can be much larger. This calculation increases the maxSubdivision
     * value by the right factor so that each 256x256 pixel area has
     * MAX_SUBDIVISION divisions.
     */ const maxSubdivision = $6be53f6edfbf1854$var$MAX_SUBDIVISION + (destinationResolution ? Math.max(0, Math.ceil(Math.log2((0, $6da4c8ed3074c92b$export$520c40045967cb15)(targetExtent) / (destinationResolution * destinationResolution * 65536)))) : 0);
        this.addQuad_(destinationTopLeft, destinationTopRight, destinationBottomRight, destinationBottomLeft, sourceTopLeft, sourceTopRight, sourceBottomRight, sourceBottomLeft, maxSubdivision);
        if (this.wrapsXInSource_) {
            let leftBound = Infinity;
            this.triangles_.forEach(function(triangle, i, arr) {
                leftBound = Math.min(leftBound, triangle.source[0][0], triangle.source[1][0], triangle.source[2][0]);
            });
            // Shift triangles to be as close to `leftBound` as possible
            // (if the distance is more than `worldWidth / 2` it can be closer.
            this.triangles_.forEach((triangle)=>{
                if (Math.max(triangle.source[0][0], triangle.source[1][0], triangle.source[2][0]) - leftBound > this.sourceWorldWidth_ / 2) {
                    const newTriangle = [
                        [
                            triangle.source[0][0],
                            triangle.source[0][1]
                        ],
                        [
                            triangle.source[1][0],
                            triangle.source[1][1]
                        ],
                        [
                            triangle.source[2][0],
                            triangle.source[2][1]
                        ]
                    ];
                    if (newTriangle[0][0] - leftBound > this.sourceWorldWidth_ / 2) newTriangle[0][0] -= this.sourceWorldWidth_;
                    if (newTriangle[1][0] - leftBound > this.sourceWorldWidth_ / 2) newTriangle[1][0] -= this.sourceWorldWidth_;
                    if (newTriangle[2][0] - leftBound > this.sourceWorldWidth_ / 2) newTriangle[2][0] -= this.sourceWorldWidth_;
                    // Rarely (if the extent contains both the dateline and prime meridian)
                    // the shift can in turn break some triangles.
                    // Detect this here and don't shift in such cases.
                    const minX = Math.min(newTriangle[0][0], newTriangle[1][0], newTriangle[2][0]);
                    const maxX = Math.max(newTriangle[0][0], newTriangle[1][0], newTriangle[2][0]);
                    if (maxX - minX < this.sourceWorldWidth_ / 2) triangle.source = newTriangle;
                }
            });
        }
        transformInvCache = {};
    }
    /**
   * Adds triangle to the triangulation.
   * @param {import("../coordinate.js").Coordinate} a The target a coordinate.
   * @param {import("../coordinate.js").Coordinate} b The target b coordinate.
   * @param {import("../coordinate.js").Coordinate} c The target c coordinate.
   * @param {import("../coordinate.js").Coordinate} aSrc The source a coordinate.
   * @param {import("../coordinate.js").Coordinate} bSrc The source b coordinate.
   * @param {import("../coordinate.js").Coordinate} cSrc The source c coordinate.
   * @private
   */ addTriangle_(a, b, c, aSrc, bSrc, cSrc) {
        this.triangles_.push({
            source: [
                aSrc,
                bSrc,
                cSrc
            ],
            target: [
                a,
                b,
                c
            ]
        });
    }
    /**
   * Adds quad (points in clock-wise order) to the triangulation
   * (and reprojects the vertices) if valid.
   * Performs quad subdivision if needed to increase precision.
   *
   * @param {import("../coordinate.js").Coordinate} a The target a coordinate.
   * @param {import("../coordinate.js").Coordinate} b The target b coordinate.
   * @param {import("../coordinate.js").Coordinate} c The target c coordinate.
   * @param {import("../coordinate.js").Coordinate} d The target d coordinate.
   * @param {import("../coordinate.js").Coordinate} aSrc The source a coordinate.
   * @param {import("../coordinate.js").Coordinate} bSrc The source b coordinate.
   * @param {import("../coordinate.js").Coordinate} cSrc The source c coordinate.
   * @param {import("../coordinate.js").Coordinate} dSrc The source d coordinate.
   * @param {number} maxSubdivision Maximal allowed subdivision of the quad.
   * @private
   */ addQuad_(a, b, c, d, aSrc, bSrc, cSrc, dSrc, maxSubdivision) {
        const sourceQuadExtent = (0, $6da4c8ed3074c92b$export$8aceca7c77505534)([
            aSrc,
            bSrc,
            cSrc,
            dSrc
        ]);
        const sourceCoverageX = this.sourceWorldWidth_ ? (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(sourceQuadExtent) / this.sourceWorldWidth_ : null;
        const sourceWorldWidth = /** @type {number} */ this.sourceWorldWidth_;
        // when the quad is wrapped in the source projection
        // it covers most of the projection extent, but not fully
        const wrapsX = this.sourceProj_.canWrapX() && sourceCoverageX > 0.5 && sourceCoverageX < 1;
        let needsSubdivision = false;
        if (maxSubdivision > 0) {
            if (this.targetProj_.isGlobal() && this.targetWorldWidth_) {
                const targetQuadExtent = (0, $6da4c8ed3074c92b$export$8aceca7c77505534)([
                    a,
                    b,
                    c,
                    d
                ]);
                const targetCoverageX = (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(targetQuadExtent) / this.targetWorldWidth_;
                needsSubdivision = targetCoverageX > $6be53f6edfbf1854$var$MAX_TRIANGLE_WIDTH || needsSubdivision;
            }
            if (!wrapsX && this.sourceProj_.isGlobal() && sourceCoverageX) needsSubdivision = sourceCoverageX > $6be53f6edfbf1854$var$MAX_TRIANGLE_WIDTH || needsSubdivision;
        }
        if (!needsSubdivision && this.maxSourceExtent_) {
            if (isFinite(sourceQuadExtent[0]) && isFinite(sourceQuadExtent[1]) && isFinite(sourceQuadExtent[2]) && isFinite(sourceQuadExtent[3])) {
                if (!(0, $6da4c8ed3074c92b$export$7b0a31e10bbff018)(sourceQuadExtent, this.maxSourceExtent_)) // whole quad outside source projection extent -> ignore
                return;
            }
        }
        let isNotFinite = 0;
        if (!needsSubdivision) {
            if (!isFinite(aSrc[0]) || !isFinite(aSrc[1]) || !isFinite(bSrc[0]) || !isFinite(bSrc[1]) || !isFinite(cSrc[0]) || !isFinite(cSrc[1]) || !isFinite(dSrc[0]) || !isFinite(dSrc[1])) {
                if (maxSubdivision > 0) needsSubdivision = true;
                else {
                    // It might be the case that only 1 of the points is infinite. In this case
                    // we can draw a single triangle with the other three points
                    isNotFinite = (!isFinite(aSrc[0]) || !isFinite(aSrc[1]) ? 8 : 0) + (!isFinite(bSrc[0]) || !isFinite(bSrc[1]) ? 4 : 0) + (!isFinite(cSrc[0]) || !isFinite(cSrc[1]) ? 2 : 0) + (!isFinite(dSrc[0]) || !isFinite(dSrc[1]) ? 1 : 0);
                    if (isNotFinite != 1 && isNotFinite != 2 && isNotFinite != 4 && isNotFinite != 8) return;
                }
            }
        }
        if (maxSubdivision > 0) {
            if (!needsSubdivision) {
                const center = [
                    (a[0] + c[0]) / 2,
                    (a[1] + c[1]) / 2
                ];
                const centerSrc = this.transformInv_(center);
                let dx;
                if (wrapsX) {
                    const centerSrcEstimX = ((0, $6b000a049d919fe5$export$ba467bec01d66def)(aSrc[0], sourceWorldWidth) + (0, $6b000a049d919fe5$export$ba467bec01d66def)(cSrc[0], sourceWorldWidth)) / 2;
                    dx = centerSrcEstimX - (0, $6b000a049d919fe5$export$ba467bec01d66def)(centerSrc[0], sourceWorldWidth);
                } else dx = (aSrc[0] + cSrc[0]) / 2 - centerSrc[0];
                const dy = (aSrc[1] + cSrc[1]) / 2 - centerSrc[1];
                const centerSrcErrorSquared = dx * dx + dy * dy;
                needsSubdivision = centerSrcErrorSquared > this.errorThresholdSquared_;
            }
            if (needsSubdivision) {
                if (Math.abs(a[0] - c[0]) <= Math.abs(a[1] - c[1])) {
                    // split horizontally (top & bottom)
                    const bc = [
                        (b[0] + c[0]) / 2,
                        (b[1] + c[1]) / 2
                    ];
                    const bcSrc = this.transformInv_(bc);
                    const da = [
                        (d[0] + a[0]) / 2,
                        (d[1] + a[1]) / 2
                    ];
                    const daSrc = this.transformInv_(da);
                    this.addQuad_(a, b, bc, da, aSrc, bSrc, bcSrc, daSrc, maxSubdivision - 1);
                    this.addQuad_(da, bc, c, d, daSrc, bcSrc, cSrc, dSrc, maxSubdivision - 1);
                } else {
                    // split vertically (left & right)
                    const ab = [
                        (a[0] + b[0]) / 2,
                        (a[1] + b[1]) / 2
                    ];
                    const abSrc = this.transformInv_(ab);
                    const cd = [
                        (c[0] + d[0]) / 2,
                        (c[1] + d[1]) / 2
                    ];
                    const cdSrc = this.transformInv_(cd);
                    this.addQuad_(a, ab, cd, d, aSrc, abSrc, cdSrc, dSrc, maxSubdivision - 1);
                    this.addQuad_(ab, b, c, cd, abSrc, bSrc, cSrc, cdSrc, maxSubdivision - 1);
                }
                return;
            }
        }
        if (wrapsX) {
            if (!this.canWrapXInSource_) return;
            this.wrapsXInSource_ = true;
        }
        // Exactly zero or one of *Src is not finite
        // The triangles must have the diagonal line as the first side
        // This is to allow easy code in reproj.s to make it straight for broken
        // browsers that can't handle diagonal clipping
        if ((isNotFinite & 0xb) == 0) this.addTriangle_(a, c, d, aSrc, cSrc, dSrc);
        if ((isNotFinite & 0xe) == 0) this.addTriangle_(a, c, b, aSrc, cSrc, bSrc);
        if (isNotFinite) {
            // Try the other two triangles
            if ((isNotFinite & 0xd) == 0) this.addTriangle_(b, d, a, bSrc, dSrc, aSrc);
            if ((isNotFinite & 0x7) == 0) this.addTriangle_(b, d, c, bSrc, dSrc, cSrc);
        }
    }
    /**
   * Calculates extent of the `source` coordinates from all the triangles.
   *
   * @return {import("../extent.js").Extent} Calculated extent.
   */ calculateSourceExtent() {
        const extent = (0, $6da4c8ed3074c92b$export$fe201bb3bbe031e9)();
        this.triangles_.forEach(function(triangle, i, arr) {
            const src = triangle.source;
            (0, $6da4c8ed3074c92b$export$1f820e3920fa5715)(extent, src[0]);
            (0, $6da4c8ed3074c92b$export$1f820e3920fa5715)(extent, src[1]);
            (0, $6da4c8ed3074c92b$export$1f820e3920fa5715)(extent, src[2]);
        });
        return extent;
    }
    /**
   * @return {Array<Triangle>} Array of the calculated triangles.
   */ getTriangles() {
        return this.triangles_;
    }
}
var $6be53f6edfbf1854$export$2e2bcd8739ae039 = $6be53f6edfbf1854$var$Triangulation;


/**
 * @module ol/reproj/common
 */ /**
 * Default maximum allowed threshold  (in pixels) for reprojection
 * triangulation.
 * @type {number}
 */ const $8ea51dd7be3ba5e2$export$3ecb4bcfa5aae855 = 0.5;


/**
 * @typedef {function(number, number, number, number) : (import("../ImageTile.js").default)} FunctionType
 */ /**
 * @typedef {Object} TileOffset
 * @property {import("../ImageTile.js").default} tile Tile.
 * @property {number} offset Offset.
 */ /**
 * @classdesc
 * Class encapsulating single reprojected tile.
 * See {@link module:ol/source/TileImage~TileImage}.
 *
 */ class $398e350e33050c07$var$ReprojTile extends (0, $0f235d2d04095c6e$export$2e2bcd8739ae039) {
    /**
   * @param {import("../proj/Projection.js").default} sourceProj Source projection.
   * @param {import("../tilegrid/TileGrid.js").default} sourceTileGrid Source tile grid.
   * @param {import("../proj/Projection.js").default} targetProj Target projection.
   * @param {import("../tilegrid/TileGrid.js").default} targetTileGrid Target tile grid.
   * @param {import("../tilecoord.js").TileCoord} tileCoord Coordinate of the tile.
   * @param {import("../tilecoord.js").TileCoord} wrappedTileCoord Coordinate of the tile wrapped in X.
   * @param {number} pixelRatio Pixel ratio.
   * @param {number} gutter Gutter of the source tiles.
   * @param {FunctionType} getTileFunction
   *     Function returning source tiles (z, x, y, pixelRatio).
   * @param {number} [errorThreshold] Acceptable reprojection error (in px).
   * @param {boolean} [renderEdges] Render reprojection edges.
   * @param {import("../Tile.js").Options} [options] Tile options.
   */ constructor(sourceProj, sourceTileGrid, targetProj, targetTileGrid, tileCoord, wrappedTileCoord, pixelRatio, gutter, getTileFunction, errorThreshold, renderEdges, options){
        super(tileCoord, (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).IDLE, options);
        /**
     * @private
     * @type {boolean}
     */ this.renderEdges_ = renderEdges !== undefined ? renderEdges : false;
        /**
     * @private
     * @type {number}
     */ this.pixelRatio_ = pixelRatio;
        /**
     * @private
     * @type {number}
     */ this.gutter_ = gutter;
        /**
     * @private
     * @type {HTMLCanvasElement}
     */ this.canvas_ = null;
        /**
     * @private
     * @type {import("../tilegrid/TileGrid.js").default}
     */ this.sourceTileGrid_ = sourceTileGrid;
        /**
     * @private
     * @type {import("../tilegrid/TileGrid.js").default}
     */ this.targetTileGrid_ = targetTileGrid;
        /**
     * @private
     * @type {import("../tilecoord.js").TileCoord}
     */ this.wrappedTileCoord_ = wrappedTileCoord ? wrappedTileCoord : tileCoord;
        /**
     * @private
     * @type {!Array<TileOffset>}
     */ this.sourceTiles_ = [];
        /**
     * @private
     * @type {?Array<import("../events.js").EventsKey>}
     */ this.sourcesListenerKeys_ = null;
        /**
     * @private
     * @type {number}
     */ this.sourceZ_ = 0;
        /**
     * @private
     * @type {import("../extent.js").Extent}
     */ this.clipExtent_ = sourceProj.canWrapX() ? sourceProj.getExtent() : undefined;
        const targetExtent = targetTileGrid.getTileCoordExtent(this.wrappedTileCoord_);
        const maxTargetExtent = this.targetTileGrid_.getExtent();
        let maxSourceExtent = this.sourceTileGrid_.getExtent();
        const limitedTargetExtent = maxTargetExtent ? (0, $6da4c8ed3074c92b$export$72209efa88586d42)(targetExtent, maxTargetExtent) : targetExtent;
        if ((0, $6da4c8ed3074c92b$export$520c40045967cb15)(limitedTargetExtent) === 0) {
            // Tile is completely outside range -> EMPTY
            // TODO: is it actually correct that the source even creates the tile ?
            this.state = (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).EMPTY;
            return;
        }
        const sourceProjExtent = sourceProj.getExtent();
        if (sourceProjExtent) {
            if (!maxSourceExtent) maxSourceExtent = sourceProjExtent;
            else maxSourceExtent = (0, $6da4c8ed3074c92b$export$72209efa88586d42)(maxSourceExtent, sourceProjExtent);
        }
        const targetResolution = targetTileGrid.getResolution(this.wrappedTileCoord_[0]);
        const sourceResolution = (0, $2b0a118af78fb031$export$16d356211d01f1cc)(sourceProj, targetProj, limitedTargetExtent, targetResolution);
        if (!isFinite(sourceResolution) || sourceResolution <= 0) {
            // invalid sourceResolution -> EMPTY
            // probably edges of the projections when no extent is defined
            this.state = (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).EMPTY;
            return;
        }
        const errorThresholdInPixels = errorThreshold !== undefined ? errorThreshold : (0, $8ea51dd7be3ba5e2$export$3ecb4bcfa5aae855);
        /**
     * @private
     * @type {!import("./Triangulation.js").default}
     */ this.triangulation_ = new (0, $6be53f6edfbf1854$export$2e2bcd8739ae039)(sourceProj, targetProj, limitedTargetExtent, maxSourceExtent, sourceResolution * errorThresholdInPixels, targetResolution);
        if (this.triangulation_.getTriangles().length === 0) {
            // no valid triangles -> EMPTY
            this.state = (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).EMPTY;
            return;
        }
        this.sourceZ_ = sourceTileGrid.getZForResolution(sourceResolution);
        let sourceExtent = this.triangulation_.calculateSourceExtent();
        if (maxSourceExtent) {
            if (sourceProj.canWrapX()) {
                sourceExtent[1] = (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(sourceExtent[1], maxSourceExtent[1], maxSourceExtent[3]);
                sourceExtent[3] = (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(sourceExtent[3], maxSourceExtent[1], maxSourceExtent[3]);
            } else sourceExtent = (0, $6da4c8ed3074c92b$export$72209efa88586d42)(sourceExtent, maxSourceExtent);
        }
        if (!(0, $6da4c8ed3074c92b$export$520c40045967cb15)(sourceExtent)) this.state = (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).EMPTY;
        else {
            let worldWidth = 0;
            let worldsAway = 0;
            if (sourceProj.canWrapX()) {
                worldWidth = (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(sourceProjExtent);
                worldsAway = Math.floor((sourceExtent[0] - sourceProjExtent[0]) / worldWidth);
            }
            const sourceExtents = (0, $6da4c8ed3074c92b$export$9031237f01de0947)(sourceExtent.slice(), sourceProj, true);
            sourceExtents.forEach((extent)=>{
                const sourceRange = sourceTileGrid.getTileRangeForExtentAndZ(extent, this.sourceZ_);
                for(let srcX = sourceRange.minX; srcX <= sourceRange.maxX; srcX++)for(let srcY = sourceRange.minY; srcY <= sourceRange.maxY; srcY++){
                    const tile = getTileFunction(this.sourceZ_, srcX, srcY, pixelRatio);
                    if (tile) {
                        const offset = worldsAway * worldWidth;
                        this.sourceTiles_.push({
                            tile: tile,
                            offset: offset
                        });
                    }
                }
                ++worldsAway;
            });
            if (this.sourceTiles_.length === 0) this.state = (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).EMPTY;
        }
    }
    /**
   * Get the HTML Canvas element for this tile.
   * @return {HTMLCanvasElement} Canvas.
   */ getImage() {
        return this.canvas_;
    }
    /**
   * @private
   */ reproject_() {
        const sources = [];
        this.sourceTiles_.forEach((source)=>{
            const tile = source.tile;
            if (tile && tile.getState() == (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).LOADED) {
                const extent = this.sourceTileGrid_.getTileCoordExtent(tile.tileCoord);
                extent[0] += source.offset;
                extent[2] += source.offset;
                const clipExtent = this.clipExtent_?.slice();
                if (clipExtent) {
                    clipExtent[0] += source.offset;
                    clipExtent[2] += source.offset;
                }
                sources.push({
                    extent: extent,
                    clipExtent: clipExtent,
                    image: tile.getImage()
                });
            }
        });
        this.sourceTiles_.length = 0;
        if (sources.length === 0) this.state = (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).ERROR;
        else {
            const z = this.wrappedTileCoord_[0];
            const size = this.targetTileGrid_.getTileSize(z);
            const width = typeof size === 'number' ? size : size[0];
            const height = typeof size === 'number' ? size : size[1];
            const targetResolution = this.targetTileGrid_.getResolution(z);
            const sourceResolution = this.sourceTileGrid_.getResolution(this.sourceZ_);
            const targetExtent = this.targetTileGrid_.getTileCoordExtent(this.wrappedTileCoord_);
            this.canvas_ = (0, $2b0a118af78fb031$export$b3890eb0ae9dca99)(width, height, this.pixelRatio_, sourceResolution, this.sourceTileGrid_.getExtent(), targetResolution, targetExtent, this.triangulation_, sources, this.gutter_, this.renderEdges_, this.interpolate);
            this.state = (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).LOADED;
        }
        this.changed();
    }
    /**
   * Load not yet loaded URI.
   * @override
   */ load() {
        if (this.state == (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).IDLE) {
            this.state = (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).LOADING;
            this.changed();
            let leftToLoad = 0;
            this.sourcesListenerKeys_ = [];
            this.sourceTiles_.forEach(({ tile: tile })=>{
                const state = tile.getState();
                if (state == (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).IDLE || state == (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).LOADING) {
                    leftToLoad++;
                    const sourceListenKey = (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(tile, (0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE, (e)=>{
                        const state = tile.getState();
                        if (state == (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).LOADED || state == (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).ERROR || state == (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).EMPTY) {
                            (0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921)(sourceListenKey);
                            leftToLoad--;
                            if (leftToLoad === 0) {
                                this.unlistenSources_();
                                this.reproject_();
                            }
                        }
                    });
                    this.sourcesListenerKeys_.push(sourceListenKey);
                }
            });
            if (leftToLoad === 0) setTimeout(this.reproject_.bind(this), 0);
            else this.sourceTiles_.forEach(function({ tile: tile }, i, arr) {
                const state = tile.getState();
                if (state == (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).IDLE) tile.load();
            });
        }
    }
    /**
   * @private
   */ unlistenSources_() {
        this.sourcesListenerKeys_.forEach((0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921));
        this.sourcesListenerKeys_ = null;
    }
    /**
   * Remove from the cache due to expiry
   * @override
   */ release() {
        if (this.canvas_) {
            (0, $075f937d7366f1a2$export$e918ac6a1026a12a)(this.canvas_.getContext('2d'));
            (0, $2b0a118af78fb031$export$a166f0857c555517).push(this.canvas_);
            this.canvas_ = null;
        }
        super.release();
    }
}
var $398e350e33050c07$export$2e2bcd8739ae039 = $398e350e33050c07$var$ReprojTile;



/**
 * @module ol/structs/LRUCache
 */ 

/**
 * @typedef {Object} Entry
 * @property {string} key_ Key.
 * @property {Entry|null} newer Newer.
 * @property {Entry|null} older Older.
 * @property {*} value_ Value.
 */ /**
 * @classdesc
 * Implements a Least-Recently-Used cache where the keys do not conflict with
 * Object's properties (e.g. 'hasOwnProperty' is not allowed as a key). Expiring
 * items from the cache is the responsibility of the user.
 *
 * @fires import("../events/Event.js").default
 * @template T
 */ class $859b1614288c6316$var$LRUCache {
    /**
   * @param {number} [highWaterMark] High water mark.
   */ constructor(highWaterMark){
        /**
     * Desired max cache size after expireCache(). If set to 0, no cache entries
     * will be pruned at all.
     * @type {number}
     */ this.highWaterMark = highWaterMark !== undefined ? highWaterMark : 2048;
        /**
     * @private
     * @type {number}
     */ this.count_ = 0;
        /**
     * @private
     * @type {!Object<string, Entry>}
     */ this.entries_ = {};
        /**
     * @private
     * @type {?Entry}
     */ this.oldest_ = null;
        /**
     * @private
     * @type {?Entry}
     */ this.newest_ = null;
    }
    deleteOldest() {
        const entry = this.pop();
        if (entry instanceof (0, $3273ed08087da3da$export$2e2bcd8739ae039)) entry.dispose();
    }
    /**
   * @return {boolean} Can expire cache.
   */ canExpireCache() {
        return this.highWaterMark > 0 && this.getCount() > this.highWaterMark;
    }
    /**
   * Expire the cache. When the cache entry is a {@link module:ol/Disposable~Disposable},
   * the entry will be disposed.
   * @param {!Object<string, boolean>} [keep] Keys to keep. To be implemented by subclasses.
   */ expireCache(keep) {
        while(this.canExpireCache())this.deleteOldest();
    }
    /**
   * FIXME empty description for jsdoc
   */ clear() {
        while(this.oldest_)this.deleteOldest();
    }
    /**
   * @param {string} key Key.
   * @return {boolean} Contains key.
   */ containsKey(key) {
        return this.entries_.hasOwnProperty(key);
    }
    /**
   * @param {function(T, string, LRUCache<T>): ?} f The function
   *     to call for every entry from the oldest to the newer. This function takes
   *     3 arguments (the entry value, the entry key and the LRUCache object).
   *     The return value is ignored.
   */ forEach(f) {
        let entry = this.oldest_;
        while(entry){
            f(entry.value_, entry.key_, this);
            entry = entry.newer;
        }
    }
    /**
   * @param {string} key Key.
   * @param {*} [options] Options (reserved for subclasses).
   * @return {T} Value.
   */ get(key, options) {
        const entry = this.entries_[key];
        (0, $35d5ec884318008e$export$a7a9523472993e97)(entry !== undefined, 'Tried to get a value for a key that does not exist in the cache');
        if (entry === this.newest_) return entry.value_;
        if (entry === this.oldest_) {
            this.oldest_ = /** @type {Entry} */ this.oldest_.newer;
            this.oldest_.older = null;
        } else {
            entry.newer.older = entry.older;
            entry.older.newer = entry.newer;
        }
        entry.newer = null;
        entry.older = this.newest_;
        this.newest_.newer = entry;
        this.newest_ = entry;
        return entry.value_;
    }
    /**
   * Remove an entry from the cache.
   * @param {string} key The entry key.
   * @return {T} The removed entry.
   */ remove(key) {
        const entry = this.entries_[key];
        (0, $35d5ec884318008e$export$a7a9523472993e97)(entry !== undefined, 'Tried to get a value for a key that does not exist in the cache');
        if (entry === this.newest_) {
            this.newest_ = /** @type {Entry} */ entry.older;
            if (this.newest_) this.newest_.newer = null;
        } else if (entry === this.oldest_) {
            this.oldest_ = /** @type {Entry} */ entry.newer;
            if (this.oldest_) this.oldest_.older = null;
        } else {
            entry.newer.older = entry.older;
            entry.older.newer = entry.newer;
        }
        delete this.entries_[key];
        --this.count_;
        return entry.value_;
    }
    /**
   * @return {number} Count.
   */ getCount() {
        return this.count_;
    }
    /**
   * @return {Array<string>} Keys.
   */ getKeys() {
        const keys = new Array(this.count_);
        let i = 0;
        let entry;
        for(entry = this.newest_; entry; entry = entry.older)keys[i++] = entry.key_;
        return keys;
    }
    /**
   * @return {Array<T>} Values.
   */ getValues() {
        const values = new Array(this.count_);
        let i = 0;
        let entry;
        for(entry = this.newest_; entry; entry = entry.older)values[i++] = entry.value_;
        return values;
    }
    /**
   * @return {T} Last value.
   */ peekLast() {
        return this.oldest_.value_;
    }
    /**
   * @return {string} Last key.
   */ peekLastKey() {
        return this.oldest_.key_;
    }
    /**
   * Get the key of the newest item in the cache.  Throws if the cache is empty.
   * @return {string} The newest key.
   */ peekFirstKey() {
        return this.newest_.key_;
    }
    /**
   * Return an entry without updating least recently used time.
   * @param {string} key Key.
   * @return {T|undefined} Value.
   */ peek(key) {
        return this.entries_[key]?.value_;
    }
    /**
   * @return {T} value Value.
   */ pop() {
        const entry = this.oldest_;
        delete this.entries_[entry.key_];
        if (entry.newer) entry.newer.older = null;
        this.oldest_ = /** @type {Entry} */ entry.newer;
        if (!this.oldest_) this.newest_ = null;
        --this.count_;
        return entry.value_;
    }
    /**
   * @param {string} key Key.
   * @param {T} value Value.
   */ replace(key, value) {
        this.get(key); // update `newest_`
        this.entries_[key].value_ = value;
    }
    /**
   * @param {string} key Key.
   * @param {T} value Value.
   */ set(key, value) {
        (0, $35d5ec884318008e$export$a7a9523472993e97)(!(key in this.entries_), 'Tried to set a value for a key that is used already');
        const entry = {
            key_: key,
            newer: null,
            older: this.newest_,
            value_: value
        };
        if (!this.newest_) this.oldest_ = entry;
        else this.newest_.newer = entry;
        this.newest_ = entry;
        this.entries_[key] = entry;
        ++this.count_;
    }
    /**
   * Set a maximum number of entries for the cache.
   * @param {number} size Cache size.
   * @api
   */ setSize(size) {
        this.highWaterMark = size;
    }
}
var $859b1614288c6316$export$2e2bcd8739ae039 = $859b1614288c6316$var$LRUCache;


/**
 * @module ol/tilecoord
 */ /**
 * An array of three numbers representing the location of a tile in a tile
 * grid. The order is `z` (zoom level), `x` (column), and `y` (row).
 * @typedef {Array<number>} TileCoord
 * @api
 */ /**
 * @param {number} z Z.
 * @param {number} x X.
 * @param {number} y Y.
 * @param {TileCoord} [tileCoord] Tile coordinate.
 * @return {TileCoord} Tile coordinate.
 */ function $bf2a04496fadabc6$export$958e3e1a02eac4b6(z, x, y, tileCoord) {
    if (tileCoord !== undefined) {
        tileCoord[0] = z;
        tileCoord[1] = x;
        tileCoord[2] = y;
        return tileCoord;
    }
    return [
        z,
        x,
        y
    ];
}
function $bf2a04496fadabc6$export$92d0df0f1d25c63c(z, x, y) {
    return z + '/' + x + '/' + y;
}
function $bf2a04496fadabc6$export$a47fb462a08de82f(tileCoord) {
    return $bf2a04496fadabc6$export$92d0df0f1d25c63c(tileCoord[0], tileCoord[1], tileCoord[2]);
}
function $bf2a04496fadabc6$export$7f760414a8e3d2b5(tileKey) {
    const [z, x, y] = tileKey.substring(tileKey.lastIndexOf('/') + 1, tileKey.length).split(',').map(Number);
    return $bf2a04496fadabc6$export$92d0df0f1d25c63c(z, x, y);
}
function $bf2a04496fadabc6$export$a807b7874eb66454(key) {
    return key.split('/').map(Number);
}
function $bf2a04496fadabc6$export$d6af199866bfb566(tileCoord) {
    return $bf2a04496fadabc6$export$731f79419750ccf7(tileCoord[0], tileCoord[1], tileCoord[2]);
}
function $bf2a04496fadabc6$export$731f79419750ccf7(z, x, y) {
    return (x << z) + y;
}
function $bf2a04496fadabc6$export$60bedf8e3e3c3dbe(tileCoord, tileGrid) {
    const z = tileCoord[0];
    const x = tileCoord[1];
    const y = tileCoord[2];
    if (tileGrid.getMinZoom() > z || z > tileGrid.getMaxZoom()) return false;
    const tileRange = tileGrid.getFullTileRange(z);
    if (!tileRange) return true;
    return tileRange.containsXY(x, y);
}




/**
 * @module ol/renderer/canvas/Layer
 */ 





/**
 * @module ol/render/canvas/ZIndexContext
 */ 
/** @typedef {CanvasRenderingContext2D & {globalAlpha: any}} ZIndexContextProxy */ /**
 * @extends {CanvasRenderingContext2D}
 */ class $c1cb593c98d2cbd0$var$ZIndexContext {
    constructor(){
        /**
     * @private
     * @type {Array<Array<*>>}
     */ this.instructions_ = [];
        /**
     * @type {number}
     */ this.zIndex = 0;
        /**
     * @private
     * @type {number}
     */ this.offset_ = 0;
        /**
     * @private
     * @type {ZIndexContextProxy}
     */ this.context_ = /** @type {ZIndexContextProxy} */ new Proxy((0, $075f937d7366f1a2$export$fcb72ce088a6632c)(), {
            get: (target, property)=>{
                if (typeof /** @type {*} */ (0, $075f937d7366f1a2$export$fcb72ce088a6632c)()[property] !== 'function') // we only accept calling functions on the proxy, not accessing properties
                return undefined;
                this.push_(property);
                return this.pushMethodArgs_;
            },
            set: (target, property, value)=>{
                this.push_(property, value);
                return true;
            }
        });
    }
    /**
   * @param {...*} args Arguments to push to the instructions array.
   * @private
   */ push_(...args) {
        const instructions = this.instructions_;
        const index = this.zIndex + this.offset_;
        if (!instructions[index]) instructions[index] = [];
        instructions[index].push(...args);
    }
    /**
   * @private
   * @param {...*} args Args.
   * @return {ZIndexContext} This.
   */ pushMethodArgs_ = (...args)=>{
        this.push_(args);
        return this;
    };
    /**
   * Push a function that renders to the context directly.
   * @param {function(CanvasRenderingContext2D): void} render Function.
   */ pushFunction(render) {
        this.push_(render);
    }
    /**
   * Get a proxy for CanvasRenderingContext2D which does not support getting state
   * (e.g. `context.globalAlpha`, which will return `undefined`). To set state, if it relies on a
   * previous state (e.g. `context.globalAlpha = context.globalAlpha / 2`), set a function,
   * e.g. `context.globalAlpha = (context) => context.globalAlpha / 2`.
   * @return {ZIndexContextProxy} Context.
   */ getContext() {
        return this.context_;
    }
    /**
   * @param {CanvasRenderingContext2D} context Context.
   */ draw(context) {
        this.instructions_.forEach((instructionsAtIndex)=>{
            for(let i = 0, ii = instructionsAtIndex.length; i < ii; ++i){
                const property = instructionsAtIndex[i];
                if (typeof property === 'function') {
                    property(context);
                    continue;
                }
                const instructionAtIndex = instructionsAtIndex[++i];
                if (typeof /** @type {*} */ context[property] === 'function') /** @type {*} */ context[property](...instructionAtIndex);
                else {
                    if (typeof instructionAtIndex === 'function') {
                        /** @type {*} */ context[property] = instructionAtIndex(context);
                        continue;
                    }
                    /** @type {*} */ context[property] = instructionAtIndex;
                }
            }
        });
    }
    clear() {
        this.instructions_.length = 0;
        this.zIndex = 0;
        this.offset_ = 0;
    }
    /**
   * Offsets the zIndex by the highest current zIndex. Useful for rendering multiple worlds or tiles, to
   * avoid conflicting context.clip() or context.save()/restore() calls.
   */ offset() {
        this.offset_ = this.instructions_.length;
        this.zIndex = 0;
    }
}
var $c1cb593c98d2cbd0$export$2e2bcd8739ae039 = $c1cb593c98d2cbd0$var$ZIndexContext;



/**
 * @module ol/renderer/Layer
 */ 



const $cb18cdefd702a327$var$maxStaleKeys = 5;
/**
 * @template {import("../layer/Layer.js").default} LayerType
 */ class $cb18cdefd702a327$var$LayerRenderer extends (0, $1f093ab5083c8a1f$export$2e2bcd8739ae039) {
    /**
   * @param {LayerType} layer Layer.
   */ constructor(layer){
        super();
        /**
     * The renderer is initialized and ready to render.
     * @type {boolean}
     */ this.ready = true;
        /** @private */ this.boundHandleImageChange_ = this.handleImageChange_.bind(this);
        /**
     * @private
     * @type {LayerType}
     */ this.layer_ = layer;
        /**
     * @type {Array<string>}
     * @private
     */ this.staleKeys_ = new Array();
        /**
     * @type {number}
     * @protected
     */ this.maxStaleKeys = $cb18cdefd702a327$var$maxStaleKeys;
    }
    /**
   * @return {Array<string>} Get the list of stale keys.
   */ getStaleKeys() {
        return this.staleKeys_;
    }
    /**
   * @param {string} key The new stale key.
   */ prependStaleKey(key) {
        this.staleKeys_.unshift(key);
        if (this.staleKeys_.length > this.maxStaleKeys) this.staleKeys_.length = this.maxStaleKeys;
    }
    /**
   * Asynchronous layer level hit detection.
   * @param {import("../pixel.js").Pixel} pixel Pixel.
   * @return {Promise<Array<import("../Feature").FeatureLike>>} Promise that resolves with
   * an array of features.
   */ getFeatures(pixel) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * @param {import("../pixel.js").Pixel} pixel Pixel.
   * @return {Uint8ClampedArray|Uint8Array|Float32Array|DataView|null} Pixel data.
   */ getData(pixel) {
        return null;
    }
    /**
   * Determine whether render should be called.
   * @abstract
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @return {boolean} Layer is ready to be rendered.
   */ prepareFrame(frameState) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Render the layer.
   * @abstract
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @param {HTMLElement|null} target Target that may be used to render content to.
   * @return {HTMLElement} The rendered element.
   */ renderFrame(frameState, target) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * @abstract
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @param {import("./vector.js").FeatureCallback<T>} callback Feature callback.
   * @param {Array<import("./Map.js").HitMatch<T>>} matches The hit detected matches with tolerance.
   * @return {T|undefined} Callback result.
   * @template T
   */ forEachFeatureAtCoordinate(coordinate, frameState, hitTolerance, callback, matches) {
        return undefined;
    }
    /**
   * @return {LayerType} Layer.
   */ getLayer() {
        return this.layer_;
    }
    /**
   * Perform action necessary to get the layer rendered after new fonts have loaded
   * @abstract
   */ handleFontsChanged() {}
    /**
   * Handle changes in image state.
   * @param {import("../events/Event.js").default} event Image change event.
   * @private
   */ handleImageChange_(event) {
        const image = /** @type {import("../Image.js").default} */ event.target;
        if (image.getState() === (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADED || image.getState() === (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).ERROR) this.renderIfReadyAndVisible();
    }
    /**
   * Load the image if not already loaded, and register the image change
   * listener if needed.
   * @param {import("../Image.js").default} image Image.
   * @return {boolean} `true` if the image is already loaded, `false` otherwise.
   * @protected
   */ loadImage(image) {
        let imageState = image.getState();
        if (imageState != (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADED && imageState != (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).ERROR) image.addEventListener((0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE, this.boundHandleImageChange_);
        if (imageState == (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).IDLE) {
            image.load();
            imageState = image.getState();
        }
        return imageState == (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADED;
    }
    /**
   * @protected
   */ renderIfReadyAndVisible() {
        const layer = this.getLayer();
        if (layer && layer.getVisible() && layer.getSourceState() === 'ready') layer.changed();
    }
    /**
   * @param {import("../Map.js").FrameState} frameState Frame state.
   */ renderDeferred(frameState) {}
    /**
   * Clean up.
   * @override
   */ disposeInternal() {
        delete this.layer_;
        super.disposeInternal();
    }
}
var $cb18cdefd702a327$export$2e2bcd8739ae039 = $cb18cdefd702a327$var$LayerRenderer;


const $42152f52b26b6ca7$export$a166f0857c555517 = [];
/**
 * @type {CanvasRenderingContext2D}
 */ let $42152f52b26b6ca7$var$pixelContext = null;
function $42152f52b26b6ca7$var$createPixelContext() {
    $42152f52b26b6ca7$var$pixelContext = (0, $075f937d7366f1a2$export$9e05d10eae75c464)(1, 1, undefined, {
        willReadFrequently: true
    });
}
/**
 * @abstract
 * @template {import("../../layer/Layer.js").default} LayerType
 * @extends {LayerRenderer<LayerType>}
 */ class $42152f52b26b6ca7$var$CanvasLayerRenderer extends (0, $cb18cdefd702a327$export$2e2bcd8739ae039) {
    /**
   * @param {LayerType} layer Layer.
   */ constructor(layer){
        super(layer);
        /**
     * @protected
     * @type {HTMLElement}
     */ this.container = null;
        /**
     * @protected
     * @type {number}
     */ this.renderedResolution;
        /**
     * A temporary transform.  The values in this transform should only be used in a
     * function that sets the values.
     * @protected
     * @type {import("../../transform.js").Transform}
     */ this.tempTransform = (0, $e22e7611e69f42a9$export$185802fd694ee1f5)();
        /**
     * The transform for rendered pixels to viewport CSS pixels.  This transform must
     * be set when rendering a frame and may be used by other functions after rendering.
     * @protected
     * @type {import("../../transform.js").Transform}
     */ this.pixelTransform = (0, $e22e7611e69f42a9$export$185802fd694ee1f5)();
        /**
     * The transform for viewport CSS pixels to rendered pixels.  This transform must
     * be set when rendering a frame and may be used by other functions after rendering.
     * @protected
     * @type {import("../../transform.js").Transform}
     */ this.inversePixelTransform = (0, $e22e7611e69f42a9$export$185802fd694ee1f5)();
        /**
     * @type {CanvasRenderingContext2D}
     */ this.context = null;
        /**
     * @private
     * @type {ZIndexContext}
     */ this.deferredContext_ = null;
        /**
     * @type {boolean}
     */ this.containerReused = false;
        /**
     * @protected
     * @type {import("../../Map.js").FrameState|null}
     */ this.frameState = null;
    }
    /**
   * @param {import('../../DataTile.js').ImageLike} image Image.
   * @param {number} col The column index.
   * @param {number} row The row index.
   * @return {Uint8ClampedArray|null} The image data.
   */ getImageData(image, col, row) {
        if (!$42152f52b26b6ca7$var$pixelContext) $42152f52b26b6ca7$var$createPixelContext();
        $42152f52b26b6ca7$var$pixelContext.clearRect(0, 0, 1, 1);
        let data;
        try {
            $42152f52b26b6ca7$var$pixelContext.drawImage(image, col, row, 1, 1, 0, 0, 1, 1);
            data = $42152f52b26b6ca7$var$pixelContext.getImageData(0, 0, 1, 1).data;
        } catch  {
            $42152f52b26b6ca7$var$pixelContext = null;
            return null;
        }
        return data;
    }
    /**
   * @param {import('../../Map.js').FrameState} frameState Frame state.
   * @return {string} Background color.
   */ getBackground(frameState) {
        const layer = this.getLayer();
        let background = layer.getBackground();
        if (typeof background === 'function') background = background(frameState.viewState.resolution);
        return background || undefined;
    }
    /**
   * Get a rendering container from an existing target, if compatible.
   * @param {HTMLElement} target Potential render target.
   * @param {string} transform CSS transform matrix.
   * @param {string} [backgroundColor] Background color.
   */ useContainer(target, transform, backgroundColor) {
        const layerClassName = this.getLayer().getClassName();
        let container, context;
        if (target && target.className === layerClassName && (!backgroundColor || target && target.style.backgroundColor && (0, $b998d41b678ed5d1$export$e9bab7fafb253603)((0, $322346e1ff7894ca$export$75093a47a9fa838d)(target.style.backgroundColor), (0, $322346e1ff7894ca$export$75093a47a9fa838d)(backgroundColor)))) {
            const canvas = target.firstElementChild;
            if (canvas instanceof HTMLCanvasElement) context = canvas.getContext('2d');
        }
        if (context && (0, $e22e7611e69f42a9$export$fe091d73a555748b)(context.canvas.style.transform, transform)) {
            // Container of the previous layer renderer can be used.
            this.container = target;
            this.context = context;
            this.containerReused = true;
        } else if (this.containerReused) {
            // Previously reused container cannot be used any more.
            this.container = null;
            this.context = null;
            this.containerReused = false;
        } else if (this.container) this.container.style.backgroundColor = null;
        if (!this.container) {
            container = document.createElement('div');
            container.className = layerClassName;
            let style = container.style;
            style.position = 'absolute';
            style.width = '100%';
            style.height = '100%';
            context = (0, $075f937d7366f1a2$export$9e05d10eae75c464)();
            const canvas = context.canvas;
            container.appendChild(canvas);
            style = canvas.style;
            style.position = 'absolute';
            style.left = '0';
            style.transformOrigin = 'top left';
            this.container = container;
            this.context = context;
        }
        if (!this.containerReused && backgroundColor && !this.container.style.backgroundColor) this.container.style.backgroundColor = backgroundColor;
    }
    /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {import("../../extent.js").Extent} extent Clip extent.
   * @protected
   */ clipUnrotated(context, frameState, extent) {
        const topLeft = (0, $6da4c8ed3074c92b$export$cb1538b07e6964ff)(extent);
        const topRight = (0, $6da4c8ed3074c92b$export$b84fa077c8b05295)(extent);
        const bottomRight = (0, $6da4c8ed3074c92b$export$e77c1cf70445e168)(extent);
        const bottomLeft = (0, $6da4c8ed3074c92b$export$8d09f5e2e1bf560d)(extent);
        (0, $e22e7611e69f42a9$export$5635d7ef4b8fee1c)(frameState.coordinateToPixelTransform, topLeft);
        (0, $e22e7611e69f42a9$export$5635d7ef4b8fee1c)(frameState.coordinateToPixelTransform, topRight);
        (0, $e22e7611e69f42a9$export$5635d7ef4b8fee1c)(frameState.coordinateToPixelTransform, bottomRight);
        (0, $e22e7611e69f42a9$export$5635d7ef4b8fee1c)(frameState.coordinateToPixelTransform, bottomLeft);
        const inverted = this.inversePixelTransform;
        (0, $e22e7611e69f42a9$export$5635d7ef4b8fee1c)(inverted, topLeft);
        (0, $e22e7611e69f42a9$export$5635d7ef4b8fee1c)(inverted, topRight);
        (0, $e22e7611e69f42a9$export$5635d7ef4b8fee1c)(inverted, bottomRight);
        (0, $e22e7611e69f42a9$export$5635d7ef4b8fee1c)(inverted, bottomLeft);
        context.save();
        context.beginPath();
        context.moveTo(Math.round(topLeft[0]), Math.round(topLeft[1]));
        context.lineTo(Math.round(topRight[0]), Math.round(topRight[1]));
        context.lineTo(Math.round(bottomRight[0]), Math.round(bottomRight[1]));
        context.lineTo(Math.round(bottomLeft[0]), Math.round(bottomLeft[1]));
        context.clip();
    }
    /**
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {HTMLElement} target Target that may be used to render content to.
   * @protected
   */ prepareContainer(frameState, target) {
        const extent = frameState.extent;
        const resolution = frameState.viewState.resolution;
        const rotation = frameState.viewState.rotation;
        const pixelRatio = frameState.pixelRatio;
        const width = Math.round((0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(extent) / resolution * pixelRatio);
        const height = Math.round((0, $6da4c8ed3074c92b$export$c08559766941f856)(extent) / resolution * pixelRatio);
        // set forward and inverse pixel transforms
        (0, $e22e7611e69f42a9$export$f672e0b6f7222cd7)(this.pixelTransform, frameState.size[0] / 2, frameState.size[1] / 2, 1 / pixelRatio, 1 / pixelRatio, rotation, -width / 2, -height / 2);
        (0, $e22e7611e69f42a9$export$bd70ea2a93c0fa4)(this.inversePixelTransform, this.pixelTransform);
        const canvasTransform = (0, $e22e7611e69f42a9$export$f84e8e69fd4488a5)(this.pixelTransform);
        this.useContainer(target, canvasTransform, this.getBackground(frameState));
        if (!this.containerReused) {
            const canvas = this.context.canvas;
            if (canvas.width != width || canvas.height != height) {
                canvas.width = width;
                canvas.height = height;
            } else this.context.clearRect(0, 0, width, height);
            if (canvasTransform !== canvas.style.transform) canvas.style.transform = canvasTransform;
        }
    }
    /**
   * @param {import("../../render/EventType.js").default} type Event type.
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @private
   */ dispatchRenderEvent_(type, context, frameState) {
        const layer = this.getLayer();
        if (layer.hasListener(type)) {
            const event = new (0, $b80dddceb0c42ad4$export$2e2bcd8739ae039)(type, this.inversePixelTransform, frameState, context);
            layer.dispatchEvent(event);
        }
    }
    /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @protected
   */ preRender(context, frameState) {
        this.frameState = frameState;
        if (frameState.declutter) return;
        this.dispatchRenderEvent_((0, $f5e92a4d985a2824$export$2e2bcd8739ae039).PRERENDER, context, frameState);
    }
    /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @protected
   */ postRender(context, frameState) {
        if (frameState.declutter) return;
        this.dispatchRenderEvent_((0, $f5e92a4d985a2824$export$2e2bcd8739ae039).POSTRENDER, context, frameState);
    }
    /**
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   */ renderDeferredInternal(frameState) {}
    /**
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @return {import('../../render/canvas/ZIndexContext.js').ZIndexContextProxy} Context.
   */ getRenderContext(frameState) {
        if (frameState.declutter && !this.deferredContext_) this.deferredContext_ = new (0, $c1cb593c98d2cbd0$export$2e2bcd8739ae039)();
        return frameState.declutter ? this.deferredContext_.getContext() : this.context;
    }
    /**
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @override
   */ renderDeferred(frameState) {
        if (!frameState.declutter) return;
        this.dispatchRenderEvent_((0, $f5e92a4d985a2824$export$2e2bcd8739ae039).PRERENDER, this.context, frameState);
        if (frameState.declutter && this.deferredContext_) {
            this.deferredContext_.draw(this.context);
            this.deferredContext_.clear();
        }
        this.renderDeferredInternal(frameState);
        this.dispatchRenderEvent_((0, $f5e92a4d985a2824$export$2e2bcd8739ae039).POSTRENDER, this.context, frameState);
    }
    /**
   * Creates a transform for rendering to an element that will be rotated after rendering.
   * @param {import("../../coordinate.js").Coordinate} center Center.
   * @param {number} resolution Resolution.
   * @param {number} rotation Rotation.
   * @param {number} pixelRatio Pixel ratio.
   * @param {number} width Width of the rendered element (in pixels).
   * @param {number} height Height of the rendered element (in pixels).
   * @param {number} offsetX Offset on the x-axis in view coordinates.
   * @protected
   * @return {!import("../../transform.js").Transform} Transform.
   */ getRenderTransform(center, resolution, rotation, pixelRatio, width, height, offsetX) {
        const dx1 = width / 2;
        const dy1 = height / 2;
        const sx = pixelRatio / resolution;
        const sy = -sx;
        const dx2 = -center[0] + offsetX;
        const dy2 = -center[1];
        return (0, $e22e7611e69f42a9$export$f672e0b6f7222cd7)(this.tempTransform, dx1, dy1, sx, sy, -rotation, dx2, dy2);
    }
    /**
   * Clean up.
   * @override
   */ disposeInternal() {
        delete this.frameState;
        super.disposeInternal();
    }
}
var $42152f52b26b6ca7$export$2e2bcd8739ae039 = $42152f52b26b6ca7$var$CanvasLayerRenderer;


/**
 * @param {import("../../source/Tile.js").default} source The tile source.
 * @param {string} sourceKey The source key.
 * @param {number} z The tile z level.
 * @param {number} x The tile x level.
 * @param {number} y The tile y level.
 * @return {string} The cache key.
 */ function $02fffef185f4339b$var$getCacheKey(source, sourceKey, z, x, y) {
    return `${(0, $6c5e11070e371322$export$5e82334337e0f204)(source)},${sourceKey},${(0, $bf2a04496fadabc6$export$92d0df0f1d25c63c)(z, x, y)}`;
}
/**
 * @typedef {Object<number, Set<import("../../Tile.js").default>>} TileLookup
 */ /**
 * Add a tile to the lookup.
 * @param {TileLookup} tilesByZ Lookup of tiles by zoom level.
 * @param {import("../../Tile.js").default} tile A tile.
 * @param {number} z The zoom level.
 * @return {boolean} The tile was added to the lookup.
 */ function $02fffef185f4339b$var$addTileToLookup(tilesByZ, tile, z) {
    if (!(z in tilesByZ)) {
        tilesByZ[z] = new Set([
            tile
        ]);
        return true;
    }
    const set = tilesByZ[z];
    const existing = set.has(tile);
    if (!existing) set.add(tile);
    return !existing;
}
/**
 * Remove a tile from the lookup.
 * @param {TileLookup} tilesByZ Lookup of tiles by zoom level.
 * @param {import("../../Tile.js").default} tile A tile.
 * @param {number} z The zoom level.
 * @return {boolean} The tile was removed from the lookup.
 */ function $02fffef185f4339b$var$removeTileFromLookup(tilesByZ, tile, z) {
    const set = tilesByZ[z];
    if (set) return set.delete(tile);
    return false;
}
/**
 * @param {import("../../Map.js").FrameState} frameState Frame state.
 * @param {import("../../extent.js").Extent} extent The frame extent.
 * @return {import("../../extent.js").Extent} Frame extent intersected with layer extents.
 */ function $02fffef185f4339b$var$getRenderExtent(frameState, extent) {
    const layerState = frameState.layerStatesArray[frameState.layerIndex];
    if (layerState.extent) extent = (0, $6da4c8ed3074c92b$export$72209efa88586d42)(extent, (0, $9c4744460e43e41b$export$494be3a3a25689ca)(layerState.extent, frameState.viewState.projection));
    const source = /** @type {import("../../source/Tile.js").default} */ layerState.layer.getRenderSource();
    if (!source.getWrapX()) {
        const gridExtent = source.getTileGridForProjection(frameState.viewState.projection).getExtent();
        if (gridExtent) extent = (0, $6da4c8ed3074c92b$export$72209efa88586d42)(extent, gridExtent);
    }
    return extent;
}
/**
 * @typedef {Object} Options
 * @property {number} [cacheSize=512] The cache size.
 */ /**
 * @classdesc
 * Canvas renderer for tile layers.
 * @api
 * @template {import("../../layer/Tile.js").default|import("../../layer/VectorTile.js").default} [LayerType=import("../../layer/Tile.js").default<import("../../source/Tile.js").default>|import("../../layer/VectorTile.js").default]
 * @extends {CanvasLayerRenderer<LayerType>}
 */ class $02fffef185f4339b$var$CanvasTileLayerRenderer extends (0, $42152f52b26b6ca7$export$2e2bcd8739ae039) {
    /**
   * @param {LayerType} tileLayer Tile layer.
   * @param {Options} [options] Options.
   */ constructor(tileLayer, options){
        super(tileLayer);
        options = options || {};
        /**
     * Rendered extent has changed since the previous `renderFrame()` call
     * @type {boolean}
     */ this.extentChanged = true;
        /**
     * The last call to `renderFrame` was completed with all tiles loaded
     * @type {boolean}
     */ this.renderComplete = false;
        /**
     * @private
     * @type {?import("../../extent.js").Extent}
     */ this.renderedExtent_ = null;
        /**
     * @protected
     * @type {number}
     */ this.renderedPixelRatio;
        /**
     * @protected
     * @type {import("../../proj/Projection.js").default|null}
     */ this.renderedProjection = null;
        /**
     * @protected
     * @type {!Array<import("../../Tile.js").default>}
     */ this.renderedTiles = [];
        /**
     * @private
     * @type {string}
     */ this.renderedSourceKey_;
        /**
     * @private
     * @type {number}
     */ this.renderedSourceRevision_;
        /**
     * @protected
     * @type {import("../../extent.js").Extent}
     */ this.tempExtent = (0, $6da4c8ed3074c92b$export$fe201bb3bbe031e9)();
        /**
     * @private
     * @type {import("../../TileRange.js").default}
     */ this.tempTileRange_ = new (0, $550e524b0d1b61d4$export$2e2bcd8739ae039)(0, 0, 0, 0);
        /**
     * @type {import("../../tilecoord.js").TileCoord}
     * @private
     */ this.tempTileCoord_ = (0, $bf2a04496fadabc6$export$958e3e1a02eac4b6)(0, 0, 0);
        const cacheSize = options.cacheSize !== undefined ? options.cacheSize : 512;
        /**
     * @type {import("../../structs/LRUCache.js").default<import("../../Tile.js").default>}
     * @private
     */ this.tileCache_ = new (0, $859b1614288c6316$export$2e2bcd8739ae039)(cacheSize);
        this.maxStaleKeys = cacheSize * 0.5;
    }
    /**
   * @return {LRUCache} Tile cache.
   */ getTileCache() {
        return this.tileCache_;
    }
    /**
   * Get a tile from the cache or create one if needed.
   *
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @return {import("../../Tile.js").default|null} Tile (or null if outside source extent).
   * @protected
   */ getOrCreateTile(z, x, y, frameState) {
        const tileCache = this.tileCache_;
        const tileLayer = this.getLayer();
        const tileSource = tileLayer.getSource();
        const cacheKey = $02fffef185f4339b$var$getCacheKey(tileSource, tileSource.getKey(), z, x, y);
        /** @type {import("../../Tile.js").default} */ let tile;
        if (tileCache.containsKey(cacheKey)) tile = tileCache.get(cacheKey);
        else {
            tile = tileSource.getTile(z, x, y, frameState.pixelRatio, frameState.viewState.projection);
            if (!tile) return null;
            tileCache.set(cacheKey, tile);
        }
        return tile;
    }
    /**
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @return {import("../../Tile.js").default|null} Tile (or null if outside source extent).
   * @protected
   */ getTile(z, x, y, frameState) {
        const tile = this.getOrCreateTile(z, x, y, frameState);
        if (!tile) return null;
        return tile;
    }
    /**
   * @param {import("../../pixel.js").Pixel} pixel Pixel.
   * @return {Uint8ClampedArray} Data at the pixel location.
   * @override
   */ getData(pixel) {
        const frameState = this.frameState;
        if (!frameState) return null;
        const layer = this.getLayer();
        const coordinate = (0, $e22e7611e69f42a9$export$5635d7ef4b8fee1c)(frameState.pixelToCoordinateTransform, pixel.slice());
        const layerExtent = layer.getExtent();
        if (layerExtent) {
            if (!(0, $6da4c8ed3074c92b$export$ac68c24d37ca240f)(layerExtent, coordinate)) return null;
        }
        const viewState = frameState.viewState;
        const source = layer.getRenderSource();
        const tileGrid = source.getTileGridForProjection(viewState.projection);
        const tilePixelRatio = source.getTilePixelRatio(frameState.pixelRatio);
        for(let z = tileGrid.getZForResolution(viewState.resolution); z >= tileGrid.getMinZoom(); --z){
            const tileCoord = tileGrid.getTileCoordForCoordAndZ(coordinate, z);
            const tile = this.getTile(z, tileCoord[1], tileCoord[2], frameState);
            if (!tile || tile.getState() !== (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).LOADED) continue;
            const tileOrigin = tileGrid.getOrigin(z);
            const tileSize = (0, $cc435a5409103773$export$a71a825ff42fb8e1)(tileGrid.getTileSize(z));
            const tileResolution = tileGrid.getResolution(z);
            /**
       * @type {import('../../DataTile.js').ImageLike}
       */ let image;
            if (tile instanceof (0, $cd3bc8d185522361$export$2e2bcd8739ae039) || tile instanceof (0, $398e350e33050c07$export$2e2bcd8739ae039)) image = tile.getImage();
            else if (tile instanceof (0, $fd518ba473015b27$export$2e2bcd8739ae039)) {
                image = (0, $fd518ba473015b27$export$3a7c913cb40dcb7d)(tile.getData());
                if (!image) continue;
            } else continue;
            const col = Math.floor(tilePixelRatio * ((coordinate[0] - tileOrigin[0]) / tileResolution - tileCoord[1] * tileSize[0]));
            const row = Math.floor(tilePixelRatio * ((tileOrigin[1] - coordinate[1]) / tileResolution - tileCoord[2] * tileSize[1]));
            const gutter = Math.round(tilePixelRatio * source.getGutterForProjection(viewState.projection));
            return this.getImageData(image, col + gutter, row + gutter);
        }
        return null;
    }
    /**
   * Determine whether render should be called.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @return {boolean} Layer is ready to be rendered.
   * @override
   */ prepareFrame(frameState) {
        if (!this.renderedProjection) this.renderedProjection = frameState.viewState.projection;
        else if (frameState.viewState.projection !== this.renderedProjection) {
            this.tileCache_.clear();
            this.renderedProjection = frameState.viewState.projection;
        }
        const source = this.getLayer().getSource();
        if (!source) return false;
        const sourceRevision = source.getRevision();
        if (!this.renderedSourceRevision_) this.renderedSourceRevision_ = sourceRevision;
        else if (this.renderedSourceRevision_ !== sourceRevision) {
            this.renderedSourceRevision_ = sourceRevision;
            if (this.renderedSourceKey_ === source.getKey()) this.tileCache_.clear();
        }
        return true;
    }
    /**
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {import("../../extent.js").Extent} extent The extent to be rendered.
   * @param {number} initialZ The zoom level.
   * @param {TileLookup} tilesByZ Lookup of tiles by zoom level.
   * @param {number} preload Number of additional levels to load.
   */ enqueueTiles(frameState, extent, initialZ, tilesByZ, preload) {
        const viewState = frameState.viewState;
        const tileLayer = this.getLayer();
        const tileSource = tileLayer.getRenderSource();
        const tileGrid = tileSource.getTileGridForProjection(viewState.projection);
        const tileSourceKey = (0, $6c5e11070e371322$export$5e82334337e0f204)(tileSource);
        if (!(tileSourceKey in frameState.wantedTiles)) frameState.wantedTiles[tileSourceKey] = {};
        const wantedTiles = frameState.wantedTiles[tileSourceKey];
        const map = tileLayer.getMapInternal();
        const minZ = Math.max(initialZ - preload, tileGrid.getMinZoom(), tileGrid.getZForResolution(Math.min(tileLayer.getMaxResolution(), map ? map.getView().getResolutionForZoom(Math.max(tileLayer.getMinZoom(), 0)) : tileGrid.getResolution(0)), tileSource.zDirection));
        const rotation = viewState.rotation;
        const viewport = rotation ? (0, $6da4c8ed3074c92b$export$4b7a6fb4002cd6ac)(viewState.center, viewState.resolution, rotation, frameState.size) : undefined;
        for(let z = initialZ; z >= minZ; --z){
            const tileRange = tileGrid.getTileRangeForExtentAndZ(extent, z, this.tempTileRange_);
            const tileResolution = tileGrid.getResolution(z);
            for(let x = tileRange.minX; x <= tileRange.maxX; ++x)for(let y = tileRange.minY; y <= tileRange.maxY; ++y){
                if (rotation && !tileGrid.tileCoordIntersectsViewport([
                    z,
                    x,
                    y
                ], viewport)) continue;
                const tile = this.getTile(z, x, y, frameState);
                if (!tile) continue;
                const added = $02fffef185f4339b$var$addTileToLookup(tilesByZ, tile, z);
                if (!added) continue;
                const tileQueueKey = tile.getKey();
                wantedTiles[tileQueueKey] = true;
                if (tile.getState() === (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).IDLE) {
                    if (!frameState.tileQueue.isKeyQueued(tileQueueKey)) {
                        const tileCoord = (0, $bf2a04496fadabc6$export$958e3e1a02eac4b6)(z, x, y, this.tempTileCoord_);
                        frameState.tileQueue.enqueue([
                            tile,
                            tileSourceKey,
                            tileGrid.getTileCoordCenter(tileCoord),
                            tileResolution
                        ]);
                    }
                }
            }
        }
    }
    /**
   * Look for tiles covering the provided tile coordinate at an alternate
   * zoom level.  Loaded tiles will be added to the provided tile texture lookup.
   * @param {import("../../tilecoord.js").TileCoord} tileCoord The target tile coordinate.
   * @param {TileLookup} tilesByZ Lookup of tiles by zoom level.
   * @return {boolean} The tile coordinate is covered by loaded tiles at the alternate zoom level.
   * @private
   */ findStaleTile_(tileCoord, tilesByZ) {
        const tileCache = this.tileCache_;
        const z = tileCoord[0];
        const x = tileCoord[1];
        const y = tileCoord[2];
        const staleKeys = this.getStaleKeys();
        for(let i = 0; i < staleKeys.length; ++i){
            const cacheKey = $02fffef185f4339b$var$getCacheKey(this.getLayer().getSource(), staleKeys[i], z, x, y);
            if (tileCache.containsKey(cacheKey)) {
                const tile = tileCache.peek(cacheKey);
                if (tile.getState() === (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).LOADED) {
                    tile.endTransition((0, $6c5e11070e371322$export$5e82334337e0f204)(this));
                    $02fffef185f4339b$var$addTileToLookup(tilesByZ, tile, z);
                    return true;
                }
            }
        }
        return false;
    }
    /**
   * Look for tiles covering the provided tile coordinate at an alternate
   * zoom level.  Loaded tiles will be added to the provided tile texture lookup.
   * @param {import("../../tilegrid/TileGrid.js").default} tileGrid The tile grid.
   * @param {import("../../tilecoord.js").TileCoord} tileCoord The target tile coordinate.
   * @param {number} altZ The alternate zoom level.
   * @param {TileLookup} tilesByZ Lookup of tiles by zoom level.
   * @return {boolean} The tile coordinate is covered by loaded tiles at the alternate zoom level.
   * @private
   */ findAltTiles_(tileGrid, tileCoord, altZ, tilesByZ) {
        const tileRange = tileGrid.getTileRangeForTileCoordAndZ(tileCoord, altZ, this.tempTileRange_);
        if (!tileRange) return false;
        let covered = true;
        const tileCache = this.tileCache_;
        const source = this.getLayer().getRenderSource();
        const sourceKey = source.getKey();
        for(let x = tileRange.minX; x <= tileRange.maxX; ++x)for(let y = tileRange.minY; y <= tileRange.maxY; ++y){
            const cacheKey = $02fffef185f4339b$var$getCacheKey(source, sourceKey, altZ, x, y);
            let loaded = false;
            if (tileCache.containsKey(cacheKey)) {
                const tile = tileCache.peek(cacheKey);
                if (tile.getState() === (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).LOADED) {
                    $02fffef185f4339b$var$addTileToLookup(tilesByZ, tile, altZ);
                    loaded = true;
                }
            }
            if (!loaded) covered = false;
        }
        return covered;
    }
    /**
   * Render the layer.
   *
   * The frame rendering logic has three parts:
   *
   *  1. Enqueue tiles
   *  2. Find alt tiles for those that are not yet loaded
   *  3. Render loaded tiles
   *
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {HTMLElement} target Target that may be used to render content to.
   * @return {HTMLElement} The rendered element.
   * @override
   */ renderFrame(frameState, target) {
        this.renderComplete = true;
        /**
     * TODO:
     *  maybe skip transition when not fully opaque
     *  decide if this.renderComplete is useful
     */ const layerState = frameState.layerStatesArray[frameState.layerIndex];
        const viewState = frameState.viewState;
        const projection = viewState.projection;
        const viewResolution = viewState.resolution;
        const viewCenter = viewState.center;
        const pixelRatio = frameState.pixelRatio;
        const tileLayer = this.getLayer();
        const tileSource = tileLayer.getSource();
        const tileGrid = tileSource.getTileGridForProjection(projection);
        const z = tileGrid.getZForResolution(viewResolution, tileSource.zDirection);
        const tileResolution = tileGrid.getResolution(z);
        const sourceKey = tileSource.getKey();
        if (!this.renderedSourceKey_) this.renderedSourceKey_ = sourceKey;
        else if (this.renderedSourceKey_ !== sourceKey) {
            this.prependStaleKey(this.renderedSourceKey_);
            this.renderedSourceKey_ = sourceKey;
        }
        let frameExtent = frameState.extent;
        const tilePixelRatio = tileSource.getTilePixelRatio(pixelRatio);
        this.prepareContainer(frameState, target);
        // desired dimensions of the canvas in pixels
        const width = this.context.canvas.width;
        const height = this.context.canvas.height;
        const layerExtent = layerState.extent && (0, $9c4744460e43e41b$export$494be3a3a25689ca)(layerState.extent, projection);
        if (layerExtent) frameExtent = (0, $6da4c8ed3074c92b$export$72209efa88586d42)(frameExtent, (0, $9c4744460e43e41b$export$494be3a3a25689ca)(layerState.extent, projection));
        const dx = tileResolution * width / 2 / tilePixelRatio;
        const dy = tileResolution * height / 2 / tilePixelRatio;
        const canvasExtent = [
            viewCenter[0] - dx,
            viewCenter[1] - dy,
            viewCenter[0] + dx,
            viewCenter[1] + dy
        ];
        /**
     * @type {TileLookup}
     */ const tilesByZ = {};
        this.renderedTiles.length = 0;
        /**
     * Part 1: Enqueue tiles
     */ const preload = tileLayer.getPreload();
        if (frameState.nextExtent) {
            const targetZ = tileGrid.getZForResolution(viewState.nextResolution, tileSource.zDirection);
            const nextExtent = $02fffef185f4339b$var$getRenderExtent(frameState, frameState.nextExtent);
            this.enqueueTiles(frameState, nextExtent, targetZ, tilesByZ, preload);
        }
        const renderExtent = $02fffef185f4339b$var$getRenderExtent(frameState, frameExtent);
        this.enqueueTiles(frameState, renderExtent, z, tilesByZ, 0);
        if (preload > 0) setTimeout(()=>{
            this.enqueueTiles(frameState, renderExtent, z - 1, tilesByZ, preload - 1);
        }, 0);
        if (!(z in tilesByZ)) return this.container;
        /**
     * Part 2: Find alt tiles for those that are not yet loaded
     */ const uid = (0, $6c5e11070e371322$export$5e82334337e0f204)(this);
        const time = frameState.time;
        // look for cached tiles to use if a target tile is not ready
        for (const tile of tilesByZ[z]){
            const tileState = tile.getState();
            if (tileState === (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).EMPTY) continue;
            const tileCoord = tile.tileCoord;
            if (tileState === (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).LOADED) {
                const alpha = tile.getAlpha(uid, time);
                if (alpha === 1) {
                    // no need to look for alt tiles
                    tile.endTransition(uid);
                    continue;
                }
            }
            if (tileState !== (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).ERROR) this.renderComplete = false;
            const hasStaleTile = this.findStaleTile_(tileCoord, tilesByZ);
            if (hasStaleTile) {
                // use the stale tile before the new tile's transition has completed
                $02fffef185f4339b$var$removeTileFromLookup(tilesByZ, tile, z);
                frameState.animate = true;
                continue;
            }
            // first look for child tiles (at z + 1)
            const coveredByChildren = this.findAltTiles_(tileGrid, tileCoord, z + 1, tilesByZ);
            if (coveredByChildren) continue;
            // next look for parent tiles
            const minZoom = tileGrid.getMinZoom();
            for(let parentZ = z - 1; parentZ >= minZoom; --parentZ){
                const coveredByParent = this.findAltTiles_(tileGrid, tileCoord, parentZ, tilesByZ);
                if (coveredByParent) break;
            }
        }
        /**
     * Part 3: Render loaded tiles
     */ const canvasScale = tileResolution / viewResolution * pixelRatio / tilePixelRatio;
        const context = this.getRenderContext(frameState);
        // set scale transform for calculating tile positions on the canvas
        (0, $e22e7611e69f42a9$export$f672e0b6f7222cd7)(this.tempTransform, width / 2, height / 2, canvasScale, canvasScale, 0, -width / 2, -height / 2);
        if (layerState.extent) this.clipUnrotated(context, frameState, layerExtent);
        if (!tileSource.getInterpolate()) context.imageSmoothingEnabled = false;
        this.preRender(context, frameState);
        /** @type {Array<number>} */ const zs = Object.keys(tilesByZ).map(Number);
        zs.sort((0, $b998d41b678ed5d1$export$fcb633242ef15540));
        let currentClip;
        const clips = [];
        const clipZs = [];
        for(let i = zs.length - 1; i >= 0; --i){
            const currentZ = zs[i];
            const currentTilePixelSize = tileSource.getTilePixelSize(currentZ, pixelRatio, projection);
            const currentResolution = tileGrid.getResolution(currentZ);
            const currentScale = currentResolution / tileResolution;
            const dx = currentTilePixelSize[0] * currentScale * canvasScale;
            const dy = currentTilePixelSize[1] * currentScale * canvasScale;
            const originTileCoord = tileGrid.getTileCoordForCoordAndZ((0, $6da4c8ed3074c92b$export$cb1538b07e6964ff)(canvasExtent), currentZ);
            const originTileExtent = tileGrid.getTileCoordExtent(originTileCoord);
            const origin = (0, $e22e7611e69f42a9$export$5635d7ef4b8fee1c)(this.tempTransform, [
                tilePixelRatio * (originTileExtent[0] - canvasExtent[0]) / tileResolution,
                tilePixelRatio * (canvasExtent[3] - originTileExtent[3]) / tileResolution
            ]);
            const tileGutter = tilePixelRatio * tileSource.getGutterForProjection(projection);
            for (const tile of tilesByZ[currentZ]){
                if (tile.getState() !== (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).LOADED) continue;
                const tileCoord = tile.tileCoord;
                // Calculate integer positions and sizes so that tiles align
                const xIndex = originTileCoord[1] - tileCoord[1];
                const nextX = Math.round(origin[0] - (xIndex - 1) * dx);
                const yIndex = originTileCoord[2] - tileCoord[2];
                const nextY = Math.round(origin[1] - (yIndex - 1) * dy);
                const x = Math.round(origin[0] - xIndex * dx);
                const y = Math.round(origin[1] - yIndex * dy);
                const w = nextX - x;
                const h = nextY - y;
                const transition = zs.length === 1;
                let contextSaved = false;
                // Clip mask for regions in this tile that already filled by a higher z tile
                currentClip = [
                    x,
                    y,
                    x + w,
                    y,
                    x + w,
                    y + h,
                    x,
                    y + h
                ];
                for(let i = 0, ii = clips.length; i < ii; ++i)if (!transition && currentZ < clipZs[i]) {
                    const clip = clips[i];
                    if ((0, $6da4c8ed3074c92b$export$7b0a31e10bbff018)([
                        x,
                        y,
                        x + w,
                        y + h
                    ], [
                        clip[0],
                        clip[3],
                        clip[4],
                        clip[7]
                    ])) {
                        if (!contextSaved) {
                            context.save();
                            contextSaved = true;
                        }
                        context.beginPath();
                        // counter-clockwise (outer ring) for current tile
                        context.moveTo(currentClip[0], currentClip[1]);
                        context.lineTo(currentClip[2], currentClip[3]);
                        context.lineTo(currentClip[4], currentClip[5]);
                        context.lineTo(currentClip[6], currentClip[7]);
                        // clockwise (inner ring) for higher z tile
                        context.moveTo(clip[6], clip[7]);
                        context.lineTo(clip[4], clip[5]);
                        context.lineTo(clip[2], clip[3]);
                        context.lineTo(clip[0], clip[1]);
                        context.clip();
                    }
                }
                clips.push(currentClip);
                clipZs.push(currentZ);
                this.drawTile(tile, frameState, x, y, w, h, tileGutter, transition);
                if (contextSaved) context.restore();
                this.renderedTiles.unshift(tile);
                // TODO: decide if this is necessary
                this.updateUsedTiles(frameState.usedTiles, tileSource, tile);
            }
        }
        this.renderedResolution = tileResolution;
        this.extentChanged = !this.renderedExtent_ || !(0, $6da4c8ed3074c92b$export$e9bab7fafb253603)(this.renderedExtent_, canvasExtent);
        this.renderedExtent_ = canvasExtent;
        this.renderedPixelRatio = pixelRatio;
        this.postRender(this.context, frameState);
        if (layerState.extent) context.restore();
        context.imageSmoothingEnabled = true;
        if (this.renderComplete) {
            /**
       * @param {import("../../Map.js").default} map Map.
       * @param {import("../../Map.js").FrameState} frameState Frame state.
       */ const postRenderFunction = (map, frameState)=>{
                const tileSourceKey = (0, $6c5e11070e371322$export$5e82334337e0f204)(tileSource);
                const wantedTiles = frameState.wantedTiles[tileSourceKey];
                const tilesCount = wantedTiles ? Object.keys(wantedTiles).length : 0;
                this.updateCacheSize(tilesCount);
                this.tileCache_.expireCache();
            };
            frameState.postRenderFunctions.push(postRenderFunction);
        }
        return this.container;
    }
    /**
   * Increases the cache size if needed
   * @param {number} tileCount Minimum number of tiles needed.
   */ updateCacheSize(tileCount) {
        this.tileCache_.highWaterMark = Math.max(this.tileCache_.highWaterMark, tileCount * 2);
    }
    /**
   * @param {import("../../Tile.js").default} tile Tile.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {number} x Left of the tile.
   * @param {number} y Top of the tile.
   * @param {number} w Width of the tile.
   * @param {number} h Height of the tile.
   * @param {number} gutter Tile gutter.
   * @param {boolean} transition Apply an alpha transition.
   * @protected
   */ drawTile(tile, frameState, x, y, w, h, gutter, transition) {
        let image;
        if (tile instanceof (0, $fd518ba473015b27$export$2e2bcd8739ae039)) {
            image = (0, $fd518ba473015b27$export$3a7c913cb40dcb7d)(tile.getData());
            if (!image) throw new Error('Rendering array data is not yet supported');
        } else image = this.getTileImage(/** @type {import("../../ImageTile.js").default} */ tile);
        if (!image) return;
        const context = this.getRenderContext(frameState);
        const uid = (0, $6c5e11070e371322$export$5e82334337e0f204)(this);
        const layerState = frameState.layerStatesArray[frameState.layerIndex];
        const alpha = layerState.opacity * (transition ? tile.getAlpha(uid, frameState.time) : 1);
        const alphaChanged = alpha !== context.globalAlpha;
        if (alphaChanged) {
            context.save();
            context.globalAlpha = alpha;
        }
        context.drawImage(image, gutter, gutter, image.width - 2 * gutter, image.height - 2 * gutter, x, y, w, h);
        if (alphaChanged) context.restore();
        if (alpha !== layerState.opacity) frameState.animate = true;
        else if (transition) tile.endTransition(uid);
    }
    /**
   * @return {HTMLCanvasElement} Image
   */ getImage() {
        const context = this.context;
        return context ? context.canvas : null;
    }
    /**
   * Get the image from a tile.
   * @param {import("../../ImageTile.js").default} tile Tile.
   * @return {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} Image.
   * @protected
   */ getTileImage(tile) {
        return tile.getImage();
    }
    /**
   * @param {!Object<string, !Object<string, boolean>>} usedTiles Used tiles.
   * @param {import("../../source/Tile.js").default} tileSource Tile source.
   * @param {import('../../Tile.js').default} tile Tile.
   * @protected
   */ updateUsedTiles(usedTiles, tileSource, tile) {
        // FIXME should we use tilesToDrawByZ instead?
        const tileSourceKey = (0, $6c5e11070e371322$export$5e82334337e0f204)(tileSource);
        if (!(tileSourceKey in usedTiles)) usedTiles[tileSourceKey] = {};
        usedTiles[tileSourceKey][tile.getKey()] = true;
    }
}
var $02fffef185f4339b$export$2e2bcd8739ae039 = $02fffef185f4339b$var$CanvasTileLayerRenderer;


/**
 * @module ol/layer/BaseTile
 */ 
/**
 * @module ol/layer/TileProperty
 */ /**
 * @enum {string}
 */ var $e4c61536de922b84$export$2e2bcd8739ae039 = {
    PRELOAD: 'preload',
    USE_INTERIM_TILES_ON_ERROR: 'useInterimTilesOnError'
};


/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("./Base").BaseLayerObjectEventTypes|
 *     import("./Layer.js").LayerEventType|'change:preload'|'change:useInterimTilesOnError', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<import("../render/EventType").LayerRenderEventTypes, import("../render/Event").default, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("./Base").BaseLayerObjectEventTypes|
 *   import("./Layer.js").LayerEventType|'change:preload'|'change:useInterimTilesOnError'|import("../render/EventType").LayerRenderEventTypes, Return>} BaseTileLayerOnSignature
 */ /**
 * @template {import("../source/Tile.js").default} TileSourceType
 * @typedef {Object} Options
 * @property {string} [className='ol-layer'] A CSS class name to set to the layer element.
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {number} [preload=0] Preload. Load low-resolution tiles up to `preload` levels. `0`
 * means no preloading.
 * @property {TileSourceType} [source] Source for this layer.
 * @property {import("../Map.js").default} [map] Sets the layer as overlay on a map. The map will not manage
 * this layer in its layers collection, and the layer will be rendered on top. This is useful for
 * temporary layers. The standard way to add a layer to a map and have it managed by the map is to
 * use {@link import("../Map.js").default#addLayer map.addLayer()}.
 * @property {import("./Base.js").BackgroundColor} [background] Background color for the layer. If not specified, no background
 * will be rendered.
 * @property {boolean} [useInterimTilesOnError=true] Deprecated.  Use interim tiles on error.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 * @property {number} [cacheSize=512] The internal tile cache size.  This needs to be large enough to render
 * two zoom levels worth of tiles.
 */ /**
 * @classdesc
 * For layer sources that provide pre-rendered, tiled images in grids that are
 * organized by zoom levels for specific resolutions.
 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
 * property on the layer object; for example, setting `title: 'My Title'` in the
 * options means that `title` is observable, and has get/set accessors.
 *
 * @template {import("../source/Tile.js").default} TileSourceType
 * @template {import("../renderer/Layer.js").default} RendererType
 * @extends {Layer<TileSourceType, RendererType>}
 * @api
 */ class $93be2de6a052f587$var$BaseTileLayer extends (0, $534f30fce11effcd$export$2e2bcd8739ae039) {
    /**
   * @param {Options<TileSourceType>} [options] Tile layer options.
   */ constructor(options){
        options = options ? options : {};
        const baseOptions = Object.assign({}, options);
        const cacheSize = options.cacheSize;
        delete options.cacheSize;
        delete baseOptions.preload;
        delete baseOptions.useInterimTilesOnError;
        super(baseOptions);
        /***
     * @type {BaseTileLayerOnSignature<import("../events").EventsKey>}
     */ this.on;
        /***
     * @type {BaseTileLayerOnSignature<import("../events").EventsKey>}
     */ this.once;
        /***
     * @type {BaseTileLayerOnSignature<void>}
     */ this.un;
        /**
     * @type {number|undefined}
     * @private
     */ this.cacheSize_ = cacheSize;
        this.setPreload(options.preload !== undefined ? options.preload : 0);
        this.setUseInterimTilesOnError(options.useInterimTilesOnError !== undefined ? options.useInterimTilesOnError : true);
    }
    /**
   * @return {number|undefined} The suggested cache size
   * @protected
   */ getCacheSize() {
        return this.cacheSize_;
    }
    /**
   * Return the level as number to which we will preload tiles up to.
   * @return {number} The level to preload tiles up to.
   * @observable
   * @api
   */ getPreload() {
        return /** @type {number} */ this.get((0, $e4c61536de922b84$export$2e2bcd8739ae039).PRELOAD);
    }
    /**
   * Set the level as number to which we will preload tiles up to.
   * @param {number} preload The level to preload tiles up to.
   * @observable
   * @api
   */ setPreload(preload) {
        this.set((0, $e4c61536de922b84$export$2e2bcd8739ae039).PRELOAD, preload);
    }
    /**
   * Deprecated.  Whether we use interim tiles on error.
   * @return {boolean} Use interim tiles on error.
   * @observable
   * @api
   */ getUseInterimTilesOnError() {
        return /** @type {boolean} */ this.get((0, $e4c61536de922b84$export$2e2bcd8739ae039).USE_INTERIM_TILES_ON_ERROR);
    }
    /**
   * Deprecated.  Set whether we use interim tiles on error.
   * @param {boolean} useInterimTilesOnError Use interim tiles on error.
   * @observable
   * @api
   */ setUseInterimTilesOnError(useInterimTilesOnError) {
        this.set((0, $e4c61536de922b84$export$2e2bcd8739ae039).USE_INTERIM_TILES_ON_ERROR, useInterimTilesOnError);
    }
    /**
   * Get data for a pixel location.  The return type depends on the source data.  For image tiles,
   * a four element RGBA array will be returned.  For data tiles, the array length will match the
   * number of bands in the dataset.  For requests outside the layer extent, `null` will be returned.
   * Data for a image tiles can only be retrieved if the source's `crossOrigin` property is set.
   *
   * ```js
   * // display layer data on every pointer move
   * map.on('pointermove', (event) => {
   *   console.log(layer.getData(event.pixel));
   * });
   * ```
   * @param {import("../pixel").Pixel} pixel Pixel.
   * @return {Uint8ClampedArray|Uint8Array|Float32Array|DataView|null} Pixel data.
   * @api
   * @override
   */ getData(pixel) {
        return super.getData(pixel);
    }
}
var $93be2de6a052f587$export$2e2bcd8739ae039 = $93be2de6a052f587$var$BaseTileLayer;


/**
 * @classdesc
 * For layer sources that provide pre-rendered, tiled images in grids that are
 * organized by zoom levels for specific resolutions.
 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
 * property on the layer object; for example, setting `title: 'My Title'` in the
 * options means that `title` is observable, and has get/set accessors.
 *
 * @template {import("../source/Tile.js").default} [TileSourceType=import("../source/Tile.js").default]
 * @extends BaseTileLayer<TileSourceType, CanvasTileLayerRenderer>
 * @api
 */ class $32e67a4d3559554a$var$TileLayer extends (0, $93be2de6a052f587$export$2e2bcd8739ae039) {
    /**
   * @param {import("./BaseTile.js").Options<TileSourceType>} [options] Tile layer options.
   */ constructor(options){
        super(options);
    }
    /**
   * @override
   */ createRenderer() {
        return new (0, $02fffef185f4339b$export$2e2bcd8739ae039)(this, {
            cacheSize: this.getCacheSize()
        });
    }
}
var $32e67a4d3559554a$export$2e2bcd8739ae039 = $32e67a4d3559554a$var$TileLayer;


/**
 * @module ol/source/OSM
 */ /**
 * @module ol/source/XYZ
 */ /**
 * @module ol/tilegrid
 */ 


/**
 * @module ol/tilegrid/TileGrid
 */ 








/**
 * @private
 * @type {import("../tilecoord.js").TileCoord}
 */ const $bb602a307ef98bb5$var$tmpTileCoord = [
    0,
    0,
    0
];
/**
 * Number of decimal digits to consider in integer values when rounding.
 * @type {number}
 */ const $bb602a307ef98bb5$var$DECIMALS = 5;
/**
 * @typedef {Object} Options
 * @property {import("../extent.js").Extent} [extent] Extent for the tile grid. No tiles outside this
 * extent will be requested by {@link module:ol/source/Tile~TileSource} sources. When no `origin` or
 * `origins` are configured, the `origin` will be set to the top-left corner of the extent.
 * @property {number} [minZoom=0] Minimum zoom.
 * @property {import("../coordinate.js").Coordinate} [origin] The tile grid origin, i.e. where the `x`
 * and `y` axes meet (`[z, 0, 0]`). Tile coordinates increase left to right and downwards. If not
 * specified, `extent` or `origins` must be provided.
 * @property {Array<import("../coordinate.js").Coordinate>} [origins] Tile grid origins, i.e. where
 * the `x` and `y` axes meet (`[z, 0, 0]`), for each zoom level. If given, the array length
 * should match the length of the `resolutions` array, i.e. each resolution can have a different
 * origin. Tile coordinates increase left to right and downwards. If not specified, `extent` or
 * `origin` must be provided.
 * @property {!Array<number>} resolutions Resolutions. The array index of each resolution needs
 * to match the zoom level. This means that even if a `minZoom` is configured, the resolutions
 * array will have a length of `maxZoom + 1`.
 * @property {Array<import("../size.js").Size>} [sizes] Number of tile rows and columns
 * of the grid for each zoom level. If specified the values
 * define each zoom level's extent together with the `origin` or `origins`.
 * A grid `extent` can be configured in addition, and will further limit the extent
 * for which tile requests are made by sources. If the bottom-left corner of
 * an extent is used as `origin` or `origins`, then the `y` value must be
 * negative because OpenLayers tile coordinates use the top left as the origin.
 * @property {number|import("../size.js").Size} [tileSize] Tile size.
 * Default is `[256, 256]`.
 * @property {Array<number|import("../size.js").Size>} [tileSizes] Tile sizes. If given, the array length
 * should match the length of the `resolutions` array, i.e. each resolution can have a different
 * tile size.
 */ /**
 * @classdesc
 * Base class for setting the grid pattern for sources accessing tiled-image
 * servers.
 * @api
 */ class $bb602a307ef98bb5$var$TileGrid {
    /**
   * @param {Options} options Tile grid options.
   */ constructor(options){
        /**
     * @protected
     * @type {number}
     */ this.minZoom = options.minZoom !== undefined ? options.minZoom : 0;
        /**
     * @private
     * @type {!Array<number>}
     */ this.resolutions_ = options.resolutions;
        (0, $35d5ec884318008e$export$a7a9523472993e97)((0, $b998d41b678ed5d1$export$efa610630f9e181)(this.resolutions_, /**
         * @param {number} a First resolution
         * @param {number} b Second resolution
         * @return {number} Comparison result
         */ (a, b)=>b - a, true), '`resolutions` must be sorted in descending order');
        // check if we've got a consistent zoom factor and origin
        let zoomFactor;
        if (!options.origins) for(let i = 0, ii = this.resolutions_.length - 1; i < ii; ++i){
            if (!zoomFactor) zoomFactor = this.resolutions_[i] / this.resolutions_[i + 1];
            else if (this.resolutions_[i] / this.resolutions_[i + 1] !== zoomFactor) {
                zoomFactor = undefined;
                break;
            }
        }
        /**
     * @private
     * @type {number|undefined}
     */ this.zoomFactor_ = zoomFactor;
        /**
     * @protected
     * @type {number}
     */ this.maxZoom = this.resolutions_.length - 1;
        /**
     * @private
     * @type {import("../coordinate.js").Coordinate|null}
     */ this.origin_ = options.origin !== undefined ? options.origin : null;
        /**
     * @private
     * @type {Array<import("../coordinate.js").Coordinate>}
     */ this.origins_ = null;
        if (options.origins !== undefined) {
            this.origins_ = options.origins;
            (0, $35d5ec884318008e$export$a7a9523472993e97)(this.origins_.length == this.resolutions_.length, 'Number of `origins` and `resolutions` must be equal');
        }
        const extent = options.extent;
        if (extent !== undefined && !this.origin_ && !this.origins_) this.origin_ = (0, $6da4c8ed3074c92b$export$cb1538b07e6964ff)(extent);
        (0, $35d5ec884318008e$export$a7a9523472993e97)(!this.origin_ && this.origins_ || this.origin_ && !this.origins_, 'Either `origin` or `origins` must be configured, never both');
        /**
     * @private
     * @type {Array<number|import("../size.js").Size>}
     */ this.tileSizes_ = null;
        if (options.tileSizes !== undefined) {
            this.tileSizes_ = options.tileSizes;
            (0, $35d5ec884318008e$export$a7a9523472993e97)(this.tileSizes_.length == this.resolutions_.length, 'Number of `tileSizes` and `resolutions` must be equal');
        }
        /**
     * @private
     * @type {number|import("../size.js").Size}
     */ this.tileSize_ = options.tileSize !== undefined ? options.tileSize : !this.tileSizes_ ? (0, $57cd8651d88957a0$export$6b8cb5cd370bd90c) : null;
        (0, $35d5ec884318008e$export$a7a9523472993e97)(!this.tileSize_ && this.tileSizes_ || this.tileSize_ && !this.tileSizes_, 'Either `tileSize` or `tileSizes` must be configured, never both');
        /**
     * @private
     * @type {import("../extent.js").Extent}
     */ this.extent_ = extent !== undefined ? extent : null;
        /**
     * @private
     * @type {Array<import("../TileRange.js").default>}
     */ this.fullTileRanges_ = null;
        /**
     * @private
     * @type {import("../size.js").Size}
     */ this.tmpSize_ = [
            0,
            0
        ];
        /**
     * @private
     * @type {import("../extent.js").Extent}
     */ this.tmpExtent_ = [
            0,
            0,
            0,
            0
        ];
        if (options.sizes !== undefined) this.fullTileRanges_ = options.sizes.map((size, z)=>{
            const tileRange = new (0, $550e524b0d1b61d4$export$2e2bcd8739ae039)(Math.min(0, size[0]), Math.max(size[0] - 1, -1), Math.min(0, size[1]), Math.max(size[1] - 1, -1));
            if (extent) {
                const restrictedTileRange = this.getTileRangeForExtentAndZ(extent, z);
                tileRange.minX = Math.max(restrictedTileRange.minX, tileRange.minX);
                tileRange.maxX = Math.min(restrictedTileRange.maxX, tileRange.maxX);
                tileRange.minY = Math.max(restrictedTileRange.minY, tileRange.minY);
                tileRange.maxY = Math.min(restrictedTileRange.maxY, tileRange.maxY);
            }
            return tileRange;
        });
        else if (extent) this.calculateTileRanges_(extent);
    }
    /**
   * Call a function with each tile coordinate for a given extent and zoom level.
   *
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {number} zoom Integer zoom level.
   * @param {function(import("../tilecoord.js").TileCoord): void} callback Function called with each tile coordinate.
   * @api
   */ forEachTileCoord(extent, zoom, callback) {
        const tileRange = this.getTileRangeForExtentAndZ(extent, zoom);
        for(let i = tileRange.minX, ii = tileRange.maxX; i <= ii; ++i)for(let j = tileRange.minY, jj = tileRange.maxY; j <= jj; ++j)callback([
            zoom,
            i,
            j
        ]);
    }
    /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {function(number, import("../TileRange.js").default): boolean} callback Callback.
   * @param {import("../TileRange.js").default} [tempTileRange] Temporary import("../TileRange.js").default object.
   * @param {import("../extent.js").Extent} [tempExtent] Temporary import("../extent.js").Extent object.
   * @return {boolean} Callback succeeded.
   */ forEachTileCoordParentTileRange(tileCoord, callback, tempTileRange, tempExtent) {
        let tileRange, x, y;
        let tileCoordExtent = null;
        let z = tileCoord[0] - 1;
        if (this.zoomFactor_ === 2) {
            x = tileCoord[1];
            y = tileCoord[2];
        } else tileCoordExtent = this.getTileCoordExtent(tileCoord, tempExtent);
        while(z >= this.minZoom){
            if (x !== undefined && y !== undefined) {
                x = Math.floor(x / 2);
                y = Math.floor(y / 2);
                tileRange = (0, $550e524b0d1b61d4$export$958e3e1a02eac4b6)(x, x, y, y, tempTileRange);
            } else tileRange = this.getTileRangeForExtentAndZ(tileCoordExtent, z, tempTileRange);
            if (callback(z, tileRange)) return true;
            --z;
        }
        return false;
    }
    /**
   * Get the extent for this tile grid, if it was configured.
   * @return {import("../extent.js").Extent} Extent.
   * @api
   */ getExtent() {
        return this.extent_;
    }
    /**
   * Get the maximum zoom level for the grid.
   * @return {number} Max zoom.
   * @api
   */ getMaxZoom() {
        return this.maxZoom;
    }
    /**
   * Get the minimum zoom level for the grid.
   * @return {number} Min zoom.
   * @api
   */ getMinZoom() {
        return this.minZoom;
    }
    /**
   * Get the origin for the grid at the given zoom level.
   * @param {number} z Integer zoom level.
   * @return {import("../coordinate.js").Coordinate} Origin.
   * @api
   */ getOrigin(z) {
        if (this.origin_) return this.origin_;
        return this.origins_[z];
    }
    /**
   * Get the resolution for the given zoom level.
   * @param {number} z Integer zoom level.
   * @return {number} Resolution.
   * @api
   */ getResolution(z) {
        return this.resolutions_[z];
    }
    /**
   * Get the list of resolutions for the tile grid.
   * @return {Array<number>} Resolutions.
   * @api
   */ getResolutions() {
        return this.resolutions_;
    }
    /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {import("../TileRange.js").default} [tempTileRange] Temporary import("../TileRange.js").default object.
   * @param {import("../extent.js").Extent} [tempExtent] Temporary import("../extent.js").Extent object.
   * @return {import("../TileRange.js").default|null} Tile range.
   */ getTileCoordChildTileRange(tileCoord, tempTileRange, tempExtent) {
        if (tileCoord[0] < this.maxZoom) {
            if (this.zoomFactor_ === 2) {
                const minX = tileCoord[1] * 2;
                const minY = tileCoord[2] * 2;
                return (0, $550e524b0d1b61d4$export$958e3e1a02eac4b6)(minX, minX + 1, minY, minY + 1, tempTileRange);
            }
            const tileCoordExtent = this.getTileCoordExtent(tileCoord, tempExtent || this.tmpExtent_);
            return this.getTileRangeForExtentAndZ(tileCoordExtent, tileCoord[0] + 1, tempTileRange);
        }
        return null;
    }
    /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {number} z Integer zoom level.
   * @param {import("../TileRange.js").default} [tempTileRange] Temporary import("../TileRange.js").default object.
   * @return {import("../TileRange.js").default|null} Tile range.
   */ getTileRangeForTileCoordAndZ(tileCoord, z, tempTileRange) {
        if (z > this.maxZoom || z < this.minZoom) return null;
        const tileCoordZ = tileCoord[0];
        const tileCoordX = tileCoord[1];
        const tileCoordY = tileCoord[2];
        if (z === tileCoordZ) return (0, $550e524b0d1b61d4$export$958e3e1a02eac4b6)(tileCoordX, tileCoordY, tileCoordX, tileCoordY, tempTileRange);
        if (this.zoomFactor_) {
            const factor = Math.pow(this.zoomFactor_, z - tileCoordZ);
            const minX = Math.floor(tileCoordX * factor);
            const minY = Math.floor(tileCoordY * factor);
            if (z < tileCoordZ) return (0, $550e524b0d1b61d4$export$958e3e1a02eac4b6)(minX, minX, minY, minY, tempTileRange);
            const maxX = Math.floor(factor * (tileCoordX + 1)) - 1;
            const maxY = Math.floor(factor * (tileCoordY + 1)) - 1;
            return (0, $550e524b0d1b61d4$export$958e3e1a02eac4b6)(minX, maxX, minY, maxY, tempTileRange);
        }
        const tileCoordExtent = this.getTileCoordExtent(tileCoord, this.tmpExtent_);
        return this.getTileRangeForExtentAndZ(tileCoordExtent, z, tempTileRange);
    }
    /**
   * Get a tile range for the given extent and integer zoom level.
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {number} z Integer zoom level.
   * @param {import("../TileRange.js").default} [tempTileRange] Temporary tile range object.
   * @return {import("../TileRange.js").default} Tile range.
   */ getTileRangeForExtentAndZ(extent, z, tempTileRange) {
        this.getTileCoordForXYAndZ_(extent[0], extent[3], z, false, $bb602a307ef98bb5$var$tmpTileCoord);
        const minX = $bb602a307ef98bb5$var$tmpTileCoord[1];
        const minY = $bb602a307ef98bb5$var$tmpTileCoord[2];
        this.getTileCoordForXYAndZ_(extent[2], extent[1], z, true, $bb602a307ef98bb5$var$tmpTileCoord);
        const maxX = $bb602a307ef98bb5$var$tmpTileCoord[1];
        const maxY = $bb602a307ef98bb5$var$tmpTileCoord[2];
        return (0, $550e524b0d1b61d4$export$958e3e1a02eac4b6)(minX, maxX, minY, maxY, tempTileRange);
    }
    /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @return {import("../coordinate.js").Coordinate} Tile center.
   */ getTileCoordCenter(tileCoord) {
        const origin = this.getOrigin(tileCoord[0]);
        const resolution = this.getResolution(tileCoord[0]);
        const tileSize = (0, $cc435a5409103773$export$a71a825ff42fb8e1)(this.getTileSize(tileCoord[0]), this.tmpSize_);
        return [
            origin[0] + (tileCoord[1] + 0.5) * tileSize[0] * resolution,
            origin[1] - (tileCoord[2] + 0.5) * tileSize[1] * resolution
        ];
    }
    /**
   * Get the extent of a tile coordinate.
   *
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {import("../extent.js").Extent} [tempExtent] Temporary extent object.
   * @return {import("../extent.js").Extent} Extent.
   * @api
   */ getTileCoordExtent(tileCoord, tempExtent) {
        const origin = this.getOrigin(tileCoord[0]);
        const resolution = this.getResolution(tileCoord[0]);
        const tileSize = (0, $cc435a5409103773$export$a71a825ff42fb8e1)(this.getTileSize(tileCoord[0]), this.tmpSize_);
        const minX = origin[0] + tileCoord[1] * tileSize[0] * resolution;
        const minY = origin[1] - (tileCoord[2] + 1) * tileSize[1] * resolution;
        const maxX = minX + tileSize[0] * resolution;
        const maxY = minY + tileSize[1] * resolution;
        return (0, $6da4c8ed3074c92b$export$958e3e1a02eac4b6)(minX, minY, maxX, maxY, tempExtent);
    }
    /**
   * Get the tile coordinate for the given map coordinate and resolution.  This
   * method considers that coordinates that intersect tile boundaries should be
   * assigned the higher tile coordinate.
   *
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {number} resolution Resolution.
   * @param {import("../tilecoord.js").TileCoord} [opt_tileCoord] Destination import("../tilecoord.js").TileCoord object.
   * @return {import("../tilecoord.js").TileCoord} Tile coordinate.
   * @api
   */ getTileCoordForCoordAndResolution(coordinate, resolution, opt_tileCoord) {
        return this.getTileCoordForXYAndResolution_(coordinate[0], coordinate[1], resolution, false, opt_tileCoord);
    }
    /**
   * Note that this method should not be called for resolutions that correspond
   * to an integer zoom level.  Instead call the `getTileCoordForXYAndZ_` method.
   * @param {number} x X.
   * @param {number} y Y.
   * @param {number} resolution Resolution (for a non-integer zoom level).
   * @param {boolean} reverseIntersectionPolicy Instead of letting edge
   *     intersections go to the higher tile coordinate, let edge intersections
   *     go to the lower tile coordinate.
   * @param {import("../tilecoord.js").TileCoord} [opt_tileCoord] Temporary import("../tilecoord.js").TileCoord object.
   * @return {import("../tilecoord.js").TileCoord} Tile coordinate.
   * @private
   */ getTileCoordForXYAndResolution_(x, y, resolution, reverseIntersectionPolicy, opt_tileCoord) {
        const z = this.getZForResolution(resolution);
        const scale = resolution / this.getResolution(z);
        const origin = this.getOrigin(z);
        const tileSize = (0, $cc435a5409103773$export$a71a825ff42fb8e1)(this.getTileSize(z), this.tmpSize_);
        let tileCoordX = scale * (x - origin[0]) / resolution / tileSize[0];
        let tileCoordY = scale * (origin[1] - y) / resolution / tileSize[1];
        if (reverseIntersectionPolicy) {
            tileCoordX = (0, $6b000a049d919fe5$export$803ce6b71a0a94b2)(tileCoordX, $bb602a307ef98bb5$var$DECIMALS) - 1;
            tileCoordY = (0, $6b000a049d919fe5$export$803ce6b71a0a94b2)(tileCoordY, $bb602a307ef98bb5$var$DECIMALS) - 1;
        } else {
            tileCoordX = (0, $6b000a049d919fe5$export$a3fe094919f356fd)(tileCoordX, $bb602a307ef98bb5$var$DECIMALS);
            tileCoordY = (0, $6b000a049d919fe5$export$a3fe094919f356fd)(tileCoordY, $bb602a307ef98bb5$var$DECIMALS);
        }
        return (0, $bf2a04496fadabc6$export$958e3e1a02eac4b6)(z, tileCoordX, tileCoordY, opt_tileCoord);
    }
    /**
   * Although there is repetition between this method and `getTileCoordForXYAndResolution_`,
   * they should have separate implementations.  This method is for integer zoom
   * levels.  The other method should only be called for resolutions corresponding
   * to non-integer zoom levels.
   * @param {number} x Map x coordinate.
   * @param {number} y Map y coordinate.
   * @param {number} z Integer zoom level.
   * @param {boolean} reverseIntersectionPolicy Instead of letting edge
   *     intersections go to the higher tile coordinate, let edge intersections
   *     go to the lower tile coordinate.
   * @param {import("../tilecoord.js").TileCoord} [opt_tileCoord] Temporary import("../tilecoord.js").TileCoord object.
   * @return {import("../tilecoord.js").TileCoord} Tile coordinate.
   * @private
   */ getTileCoordForXYAndZ_(x, y, z, reverseIntersectionPolicy, opt_tileCoord) {
        const origin = this.getOrigin(z);
        const resolution = this.getResolution(z);
        const tileSize = (0, $cc435a5409103773$export$a71a825ff42fb8e1)(this.getTileSize(z), this.tmpSize_);
        let tileCoordX = (x - origin[0]) / resolution / tileSize[0];
        let tileCoordY = (origin[1] - y) / resolution / tileSize[1];
        if (reverseIntersectionPolicy) {
            tileCoordX = (0, $6b000a049d919fe5$export$803ce6b71a0a94b2)(tileCoordX, $bb602a307ef98bb5$var$DECIMALS) - 1;
            tileCoordY = (0, $6b000a049d919fe5$export$803ce6b71a0a94b2)(tileCoordY, $bb602a307ef98bb5$var$DECIMALS) - 1;
        } else {
            tileCoordX = (0, $6b000a049d919fe5$export$a3fe094919f356fd)(tileCoordX, $bb602a307ef98bb5$var$DECIMALS);
            tileCoordY = (0, $6b000a049d919fe5$export$a3fe094919f356fd)(tileCoordY, $bb602a307ef98bb5$var$DECIMALS);
        }
        return (0, $bf2a04496fadabc6$export$958e3e1a02eac4b6)(z, tileCoordX, tileCoordY, opt_tileCoord);
    }
    /**
   * Get a tile coordinate given a map coordinate and zoom level.
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {number} z Integer zoom level, e.g. the result of a `getZForResolution()` method call
   * @param {import("../tilecoord.js").TileCoord} [opt_tileCoord] Destination import("../tilecoord.js").TileCoord object.
   * @return {import("../tilecoord.js").TileCoord} Tile coordinate.
   * @api
   */ getTileCoordForCoordAndZ(coordinate, z, opt_tileCoord) {
        return this.getTileCoordForXYAndZ_(coordinate[0], coordinate[1], z, false, opt_tileCoord);
    }
    /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @return {number} Tile resolution.
   */ getTileCoordResolution(tileCoord) {
        return this.resolutions_[tileCoord[0]];
    }
    /**
   * Get the tile size for a zoom level. The type of the return value matches the
   * `tileSize` or `tileSizes` that the tile grid was configured with. To always
   * get an {@link import("../size.js").Size}, run the result through {@link module:ol/size.toSize}.
   * @param {number} z Z.
   * @return {number|import("../size.js").Size} Tile size.
   * @api
   */ getTileSize(z) {
        if (this.tileSize_) return this.tileSize_;
        return this.tileSizes_[z];
    }
    /**
   * @param {number} z Zoom level.
   * @return {import("../TileRange.js").default|null} Extent tile range for the specified zoom level.
   */ getFullTileRange(z) {
        if (!this.fullTileRanges_) return this.extent_ ? this.getTileRangeForExtentAndZ(this.extent_, z) : null;
        return this.fullTileRanges_[z];
    }
    /**
   * @param {number} resolution Resolution.
   * @param {number|import("../array.js").NearestDirectionFunction} [opt_direction]
   *     If 0, the nearest resolution will be used.
   *     If 1, the nearest higher resolution (lower Z) will be used. If -1, the
   *     nearest lower resolution (higher Z) will be used. Default is 0.
   *     Use a {@link module:ol/array~NearestDirectionFunction} for more precise control.
   *
   * For example to change tile Z at the midpoint of zoom levels
   * ```js
   * function(value, high, low) {
   *   return value - low * Math.sqrt(high / low);
   * }
   * ```
   * @return {number} Z.
   * @api
   */ getZForResolution(resolution, opt_direction) {
        const z = (0, $b998d41b678ed5d1$export$8a3786cc03fdb777)(this.resolutions_, resolution, opt_direction || 0);
        return (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(z, this.minZoom, this.maxZoom);
    }
    /**
   * The tile with the provided tile coordinate intersects the given viewport.
   * @param {import('../tilecoord.js').TileCoord} tileCoord Tile coordinate.
   * @param {Array<number>} viewport Viewport as returned from {@link module:ol/extent.getRotatedViewport}.
   * @return {boolean} The tile with the provided tile coordinate intersects the given viewport.
   */ tileCoordIntersectsViewport(tileCoord, viewport) {
        return (0, $acee589e5b390c5c$export$830a0dafbb2ef1c5)(viewport, 0, viewport.length, 2, this.getTileCoordExtent(tileCoord));
    }
    /**
   * @param {!import("../extent.js").Extent} extent Extent for this tile grid.
   * @private
   */ calculateTileRanges_(extent) {
        const length = this.resolutions_.length;
        const fullTileRanges = new Array(length);
        for(let z = this.minZoom; z < length; ++z)fullTileRanges[z] = this.getTileRangeForExtentAndZ(extent, z);
        this.fullTileRanges_ = fullTileRanges;
    }
}
var $bb602a307ef98bb5$export$2e2bcd8739ae039 = $bb602a307ef98bb5$var$TileGrid;




function $5779655d81caea04$export$1f4812384df8a9c5(projection) {
    let tileGrid = projection.getDefaultTileGrid();
    if (!tileGrid) {
        tileGrid = $5779655d81caea04$export$a251b12f5601c16f(projection);
        projection.setDefaultTileGrid(tileGrid);
    }
    return tileGrid;
}
function $5779655d81caea04$export$39a9ce3624977b84(tileGrid, tileCoord, projection) {
    const z = tileCoord[0];
    const center = tileGrid.getTileCoordCenter(tileCoord);
    const projectionExtent = $5779655d81caea04$export$7b5b6ef8fd55fac4(projection);
    if (!(0, $6da4c8ed3074c92b$export$ac68c24d37ca240f)(projectionExtent, center)) {
        const worldWidth = (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(projectionExtent);
        const worldsAway = Math.ceil((projectionExtent[0] - center[0]) / worldWidth);
        center[0] += worldWidth * worldsAway;
        return tileGrid.getTileCoordForCoordAndZ(center, z);
    }
    return tileCoord;
}
function $5779655d81caea04$export$ce88871416242df8(extent, maxZoom, tileSize, corner) {
    corner = corner !== undefined ? corner : 'top-left';
    const resolutions = $5779655d81caea04$var$resolutionsFromExtent(extent, maxZoom, tileSize);
    return new (0, $bb602a307ef98bb5$export$2e2bcd8739ae039)({
        extent: extent,
        origin: (0, $6da4c8ed3074c92b$export$a1cfd206661d0801)(extent, corner),
        resolutions: resolutions,
        tileSize: tileSize
    });
}
function $5779655d81caea04$export$38500bbeccc864ff(options) {
    const xyzOptions = options || {};
    const extent = xyzOptions.extent || (0, $9c4744460e43e41b$export$3988ae62b71be9a3)('EPSG:3857').getExtent();
    const gridOptions = {
        extent: extent,
        minZoom: xyzOptions.minZoom,
        tileSize: xyzOptions.tileSize,
        resolutions: $5779655d81caea04$var$resolutionsFromExtent(extent, xyzOptions.maxZoom, xyzOptions.tileSize, xyzOptions.maxResolution)
    };
    return new (0, $bb602a307ef98bb5$export$2e2bcd8739ae039)(gridOptions);
}
/**
 * Create a resolutions array from an extent.  A zoom factor of 2 is assumed.
 * @param {import("./extent.js").Extent} extent Extent.
 * @param {number} [maxZoom] Maximum zoom level (default is
 *     DEFAULT_MAX_ZOOM).
 * @param {number|import("./size.js").Size} [tileSize] Tile size (default uses
 *     DEFAULT_TILE_SIZE).
 * @param {number} [maxResolution] Resolution at level zero.
 * @return {!Array<number>} Resolutions array.
 */ function $5779655d81caea04$var$resolutionsFromExtent(extent, maxZoom, tileSize, maxResolution) {
    maxZoom = maxZoom !== undefined ? maxZoom : (0, $57cd8651d88957a0$export$e98a216cdcc847dc);
    tileSize = (0, $cc435a5409103773$export$a71a825ff42fb8e1)(tileSize !== undefined ? tileSize : (0, $57cd8651d88957a0$export$6b8cb5cd370bd90c));
    const height = (0, $6da4c8ed3074c92b$export$c08559766941f856)(extent);
    const width = (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(extent);
    maxResolution = maxResolution > 0 ? maxResolution : Math.max(width / tileSize[0], height / tileSize[1]);
    const length = maxZoom + 1;
    const resolutions = new Array(length);
    for(let z = 0; z < length; ++z)resolutions[z] = maxResolution / Math.pow(2, z);
    return resolutions;
}
function $5779655d81caea04$export$a251b12f5601c16f(projection, maxZoom, tileSize, corner) {
    const extent = $5779655d81caea04$export$7b5b6ef8fd55fac4(projection);
    return $5779655d81caea04$export$ce88871416242df8(extent, maxZoom, tileSize, corner);
}
function $5779655d81caea04$export$7b5b6ef8fd55fac4(projection) {
    projection = (0, $9c4744460e43e41b$export$3988ae62b71be9a3)(projection);
    let extent = projection.getExtent();
    if (!extent) {
        const half = 180 * (0, $03edbd434a9e6608$export$1482081eec883108).degrees / projection.getMetersPerUnit();
        extent = (0, $6da4c8ed3074c92b$export$958e3e1a02eac4b6)(-half, -half, half, half);
    }
    return extent;
}


/**
 * @module ol/source/TileImage
 */ 






/**
 * @module ol/source/UrlTile
 */ 
/**
 * @module ol/tileurlfunction
 */ 

/**
 * @module ol/uri
 */ 

function $60db182c0252e220$export$c202e3cb8db99a95(uri, params) {
    /** @type {Array<string>} */ const keyParams = [];
    // Skip any null or undefined parameter values
    Object.keys(params).forEach(function(k) {
        if (params[k] !== null && params[k] !== undefined) keyParams.push(k + '=' + encodeURIComponent(params[k]));
    });
    const qs = keyParams.join('&');
    // remove any trailing ? or &
    uri = uri.replace(/[?&]$/, '');
    // append ? or & depending on whether uri has existing parameters
    uri += uri.includes('?') ? '&' : '?';
    return uri + qs;
}
const $60db182c0252e220$var$zRegEx = /\{z\}/g;
const $60db182c0252e220$var$xRegEx = /\{x\}/g;
const $60db182c0252e220$var$yRegEx = /\{y\}/g;
const $60db182c0252e220$var$dashYRegEx = /\{-y\}/g;
function $60db182c0252e220$export$df1e52f1b5b1c86f(template, z, x, y, maxY) {
    return template.replace($60db182c0252e220$var$zRegEx, z.toString()).replace($60db182c0252e220$var$xRegEx, x.toString()).replace($60db182c0252e220$var$yRegEx, y.toString()).replace($60db182c0252e220$var$dashYRegEx, function() {
        if (maxY === undefined) throw new Error('If the URL template has a {-y} placeholder, the grid extent must be known');
        return (maxY - y).toString();
    });
}
function $60db182c0252e220$export$83e87e683240b2e8(urls, z, x, y) {
    const hash = (0, $bf2a04496fadabc6$export$731f79419750ccf7)(z, x, y);
    const index = (0, $6b000a049d919fe5$export$ba467bec01d66def)(hash, urls.length);
    return urls[index];
}
function $60db182c0252e220$export$2a1fa079bfd73dde(url) {
    const urls = [];
    let match = /\{([a-z])-([a-z])\}/.exec(url);
    if (match) {
        // char range
        const startCharCode = match[1].charCodeAt(0);
        const stopCharCode = match[2].charCodeAt(0);
        let charCode;
        for(charCode = startCharCode; charCode <= stopCharCode; ++charCode)urls.push(url.replace(match[0], String.fromCharCode(charCode)));
        return urls;
    }
    match = /\{(\d+)-(\d+)\}/.exec(url);
    if (match) {
        // number range
        const stop = parseInt(match[2], 10);
        for(let i = parseInt(match[1], 10); i <= stop; i++)urls.push(url.replace(match[0], i.toString()));
        return urls;
    }
    urls.push(url);
    return urls;
}


function $91dd08a0f5859882$export$f0ecb46e90798741(template, tileGrid) {
    return(/**
     * @param {import("./tilecoord.js").TileCoord} tileCoord Tile Coordinate.
     * @param {number} pixelRatio Pixel ratio.
     * @param {import("./proj/Projection.js").default} projection Projection.
     * @return {string|undefined} Tile URL.
     */ function(tileCoord, pixelRatio, projection) {
        if (!tileCoord) return undefined;
        let maxY;
        const z = tileCoord[0];
        if (tileGrid) {
            // The `{-y}` placeholder only works for sources that have a tile grid at construction
            const range = tileGrid.getFullTileRange(z);
            if (range) maxY = range.getHeight() - 1;
        }
        return (0, $60db182c0252e220$export$df1e52f1b5b1c86f)(template, z, tileCoord[1], tileCoord[2], maxY);
    });
}
function $91dd08a0f5859882$export$436f44dbcc31fea3(templates, tileGrid) {
    const len = templates.length;
    const tileUrlFunctions = new Array(len);
    for(let i = 0; i < len; ++i)tileUrlFunctions[i] = $91dd08a0f5859882$export$f0ecb46e90798741(templates[i], tileGrid);
    return $91dd08a0f5859882$export$4229b1d9af69b3be(tileUrlFunctions);
}
function $91dd08a0f5859882$export$4229b1d9af69b3be(tileUrlFunctions) {
    if (tileUrlFunctions.length === 1) return tileUrlFunctions[0];
    return(/**
     * @param {import("./tilecoord.js").TileCoord} tileCoord Tile Coordinate.
     * @param {number} pixelRatio Pixel ratio.
     * @param {import("./proj/Projection.js").default} projection Projection.
     * @return {string|undefined} Tile URL.
     */ function(tileCoord, pixelRatio, projection) {
        if (!tileCoord) return undefined;
        const h = (0, $bf2a04496fadabc6$export$d6af199866bfb566)(tileCoord);
        const index = (0, $6b000a049d919fe5$export$ba467bec01d66def)(h, tileUrlFunctions.length);
        return tileUrlFunctions[index](tileCoord, pixelRatio, projection);
    });
}
function $91dd08a0f5859882$export$fab585f002f634a1(tileCoord, pixelRatio, projection) {
    return undefined;
}




/**
 * @module ol/source/Tile
 */ 




/**
 * @module ol/source/Source
 */ 

/**
 * @typedef {'undefined' | 'loading' | 'ready' | 'error'} State
 * State of the source, one of 'undefined', 'loading', 'ready' or 'error'.
 */ /**
 * A function that takes a {@link import("../View.js").ViewStateLayerStateExtent} and returns a string or
 * an array of strings representing source attributions.
 *
 * @typedef {function(import("../View.js").ViewStateLayerStateExtent): (string|Array<string>)} Attribution
 */ /**
 * A type that can be used to provide attribution information for data sources.
 *
 * It represents either
 * a simple string (e.g. `'© Acme Inc.'`)
 * an array of simple strings (e.g. `['© Acme Inc.', '© Bacme Inc.']`)
 * a function that returns a string or array of strings ({@link module:ol/source/Source~Attribution})
 *
 * @typedef {string|Array<string>|Attribution} AttributionLike
 */ /**
 * @typedef {Object} Options
 * @property {AttributionLike} [attributions] Attributions.
 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
 * @property {import("../proj.js").ProjectionLike} [projection] Projection. Default is the view projection.
 * @property {import("./Source.js").State} [state='ready'] State.
 * @property {boolean} [wrapX=false] WrapX.
 * @property {boolean} [interpolate=false] Use interpolated values when resampling.  By default,
 * the nearest neighbor is used when resampling.
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Base class for {@link module:ol/layer/Layer~Layer} sources.
 *
 * A generic `change` event is triggered when the state of the source changes.
 * @abstract
 * @api
 */ class $ed6dc99f268f3882$var$Source extends (0, $b68b3d6e32e3074a$export$2e2bcd8739ae039) {
    /**
   * @param {Options} options Source options.
   */ constructor(options){
        super();
        /**
     * @protected
     * @type {import("../proj/Projection.js").default|null}
     */ this.projection = (0, $9c4744460e43e41b$export$3988ae62b71be9a3)(options.projection);
        /**
     * @private
     * @type {?Attribution}
     */ this.attributions_ = $ed6dc99f268f3882$var$adaptAttributions(options.attributions);
        /**
     * @private
     * @type {boolean}
     */ this.attributionsCollapsible_ = options.attributionsCollapsible ?? true;
        /**
     * This source is currently loading data. Sources that defer loading to the
     * map's tile queue never set this to `true`.
     * @type {boolean}
     */ this.loading = false;
        /**
     * @private
     * @type {import("./Source.js").State}
     */ this.state_ = options.state !== undefined ? options.state : 'ready';
        /**
     * @private
     * @type {boolean}
     */ this.wrapX_ = options.wrapX !== undefined ? options.wrapX : false;
        /**
     * @private
     * @type {boolean}
     */ this.interpolate_ = !!options.interpolate;
        /**
     * @protected
     * @type {function(import("../View.js").ViewOptions):void}
     */ this.viewResolver = null;
        /**
     * @protected
     * @type {function(Error):void}
     */ this.viewRejector = null;
        const self = this;
        /**
     * @private
     * @type {Promise<import("../View.js").ViewOptions>}
     */ this.viewPromise_ = new Promise(function(resolve, reject) {
            self.viewResolver = resolve;
            self.viewRejector = reject;
        });
    }
    /**
   * Get the attribution function for the source.
   * @return {?Attribution} Attribution function.
   * @api
   */ getAttributions() {
        return this.attributions_;
    }
    /**
   * @return {boolean} Attributions are collapsible.
   * @api
   */ getAttributionsCollapsible() {
        return this.attributionsCollapsible_;
    }
    /**
   * Get the projection of the source.
   * @return {import("../proj/Projection.js").default|null} Projection.
   * @api
   */ getProjection() {
        return this.projection;
    }
    /**
   * @param {import("../proj/Projection").default} [projection] Projection.
   * @return {Array<number>|null} Resolutions.
   */ getResolutions(projection) {
        return null;
    }
    /**
   * @return {Promise<import("../View.js").ViewOptions>} A promise for view-related properties.
   */ getView() {
        return this.viewPromise_;
    }
    /**
   * Get the state of the source, see {@link import("./Source.js").State} for possible states.
   * @return {import("./Source.js").State} State.
   * @api
   */ getState() {
        return this.state_;
    }
    /**
   * @return {boolean|undefined} Wrap X.
   */ getWrapX() {
        return this.wrapX_;
    }
    /**
   * @return {boolean} Use linear interpolation when resampling.
   */ getInterpolate() {
        return this.interpolate_;
    }
    /**
   * Refreshes the source. The source will be cleared, and data from the server will be reloaded.
   * @api
   */ refresh() {
        this.changed();
    }
    /**
   * Set the attributions of the source.
   * @param {AttributionLike|undefined} attributions Attributions.
   *     Can be passed as `string`, `Array<string>`, {@link module:ol/source/Source~Attribution},
   *     or `undefined`.
   * @api
   */ setAttributions(attributions) {
        this.attributions_ = $ed6dc99f268f3882$var$adaptAttributions(attributions);
        this.changed();
    }
    /**
   * Set the state of the source.
   * @param {import("./Source.js").State} state State.
   */ setState(state) {
        this.state_ = state;
        this.changed();
    }
}
/**
 * Turns the attributions option into an attributions function.
 * @param {AttributionLike|undefined} attributionLike The attribution option.
 * @return {Attribution|null} An attribution function (or null).
 */ function $ed6dc99f268f3882$var$adaptAttributions(attributionLike) {
    if (!attributionLike) return null;
    if (typeof attributionLike === 'function') return attributionLike;
    if (!Array.isArray(attributionLike)) attributionLike = [
        attributionLike
    ];
    return (frameState)=>attributionLike;
}
var $ed6dc99f268f3882$export$2e2bcd8739ae039 = $ed6dc99f268f3882$var$Source;


/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types, import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<import("./TileEventType").TileSourceEventTypes, TileSourceEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types|
 *     import("./TileEventType").TileSourceEventTypes, Return>} TileSourceOnSignature
 */ /**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
 * @property {number} [cacheSize] Deprecated.  Use the cacheSize option on the layer instead.
 * @property {number} [tilePixelRatio] TilePixelRatio.
 * @property {import("../proj.js").ProjectionLike} [projection] Projection.
 * @property {import("./Source.js").State} [state] State.
 * @property {import("../tilegrid/TileGrid.js").default} [tileGrid] TileGrid.
 * @property {boolean} [wrapX=false] WrapX.
 * @property {number} [transition] Transition.
 * @property {string} [key] Key.
 * @property {number|import("../array.js").NearestDirectionFunction} [zDirection=0] ZDirection.
 * @property {boolean} [interpolate=false] Use interpolated values when resampling.  By default,
 * the nearest neighbor is used when resampling.
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Base class for sources providing images divided into a tile grid.
 *
 * @template {import("../Tile.js").default} [TileType=import("../Tile.js").default]
 * @abstract
 * @api
 */ class $988a11d09320f6a8$var$TileSource extends (0, $ed6dc99f268f3882$export$2e2bcd8739ae039) {
    /**
   * @param {Options} options SourceTile source options.
   */ constructor(options){
        super({
            attributions: options.attributions,
            attributionsCollapsible: options.attributionsCollapsible,
            projection: options.projection,
            state: options.state,
            wrapX: options.wrapX,
            interpolate: options.interpolate
        });
        /***
     * @type {TileSourceOnSignature<import("../events").EventsKey>}
     */ this.on;
        /***
     * @type {TileSourceOnSignature<import("../events").EventsKey>}
     */ this.once;
        /***
     * @type {TileSourceOnSignature<void>}
     */ this.un;
        /**
     * @private
     * @type {number}
     */ this.tilePixelRatio_ = options.tilePixelRatio !== undefined ? options.tilePixelRatio : 1;
        /**
     * @type {import("../tilegrid/TileGrid.js").default|null}
     * @protected
     */ this.tileGrid = options.tileGrid !== undefined ? options.tileGrid : null;
        const tileSize = [
            256,
            256
        ];
        if (this.tileGrid) (0, $cc435a5409103773$export$a71a825ff42fb8e1)(this.tileGrid.getTileSize(this.tileGrid.getMinZoom()), tileSize);
        /**
     * @protected
     * @type {import("../size.js").Size}
     */ this.tmpSize = [
            0,
            0
        ];
        /**
     * @private
     * @type {string}
     */ this.key_ = options.key || (0, $6c5e11070e371322$export$5e82334337e0f204)(this);
        /**
     * @protected
     * @type {import("../Tile.js").Options}
     */ this.tileOptions = {
            transition: options.transition,
            interpolate: options.interpolate
        };
        /**
     * zDirection hint, read by the renderer. Indicates which resolution should be used
     * by a renderer if the views resolution does not match any resolution of the tile source.
     * If 0, the nearest resolution will be used. If 1, the nearest lower resolution
     * will be used. If -1, the nearest higher resolution will be used.
     * @type {number|import("../array.js").NearestDirectionFunction}
     */ this.zDirection = options.zDirection ? options.zDirection : 0;
    }
    /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {number} Gutter.
   */ getGutterForProjection(projection) {
        return 0;
    }
    /**
   * Return the key to be used for all tiles in the source.
   * @return {string} The key for all tiles.
   */ getKey() {
        return this.key_;
    }
    /**
   * Set the value to be used as the key for all tiles in the source.
   * @param {string} key The key for tiles.
   * @protected
   */ setKey(key) {
        if (this.key_ !== key) {
            this.key_ = key;
            this.changed();
        }
    }
    /**
   * @param {import("../proj/Projection").default} [projection] Projection.
   * @return {Array<number>|null} Resolutions.
   * @override
   */ getResolutions(projection) {
        const tileGrid = projection ? this.getTileGridForProjection(projection) : this.tileGrid;
        if (!tileGrid) return null;
        return tileGrid.getResolutions();
    }
    /**
   * @abstract
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {TileType|null} Tile.
   */ getTile(z, x, y, pixelRatio, projection) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Return the tile grid of the tile source.
   * @return {import("../tilegrid/TileGrid.js").default|null} Tile grid.
   * @api
   */ getTileGrid() {
        return this.tileGrid;
    }
    /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {!import("../tilegrid/TileGrid.js").default} Tile grid.
   */ getTileGridForProjection(projection) {
        if (!this.tileGrid) return (0, $5779655d81caea04$export$1f4812384df8a9c5)(projection);
        return this.tileGrid;
    }
    /**
   * Get the tile pixel ratio for this source. Subclasses may override this
   * method, which is meant to return a supported pixel ratio that matches the
   * provided `pixelRatio` as close as possible.
   * @param {number} pixelRatio Pixel ratio.
   * @return {number} Tile pixel ratio.
   */ getTilePixelRatio(pixelRatio) {
        return this.tilePixelRatio_;
    }
    /**
   * @param {number} z Z.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {import("../size.js").Size} Tile size.
   */ getTilePixelSize(z, pixelRatio, projection) {
        const tileGrid = this.getTileGridForProjection(projection);
        const tilePixelRatio = this.getTilePixelRatio(pixelRatio);
        const tileSize = (0, $cc435a5409103773$export$a71a825ff42fb8e1)(tileGrid.getTileSize(z), this.tmpSize);
        if (tilePixelRatio == 1) return tileSize;
        return (0, $cc435a5409103773$export$dcdf75081b88279d)(tileSize, tilePixelRatio, this.tmpSize);
    }
    /**
   * Returns a tile coordinate wrapped around the x-axis. When the tile coordinate
   * is outside the resolution and extent range of the tile grid, `null` will be
   * returned.
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {import("../proj/Projection.js").default} [projection] Projection.
   * @return {import("../tilecoord.js").TileCoord} Tile coordinate to be passed to the tileUrlFunction or
   *     null if no tile URL should be created for the passed `tileCoord`.
   */ getTileCoordForTileUrlFunction(tileCoord, projection) {
        const gridProjection = projection !== undefined ? projection : this.getProjection();
        const tileGrid = projection !== undefined ? this.getTileGridForProjection(gridProjection) : this.tileGrid || this.getTileGridForProjection(gridProjection);
        if (this.getWrapX() && gridProjection.isGlobal()) tileCoord = (0, $5779655d81caea04$export$39a9ce3624977b84)(tileGrid, tileCoord, gridProjection);
        return (0, $bf2a04496fadabc6$export$60bedf8e3e3c3dbe)(tileCoord, tileGrid) ? tileCoord : null;
    }
    /**
   * Remove all cached reprojected tiles from the source. The next render cycle will create new tiles.
   * @api
   */ clear() {}
    /**
   * @override
   */ refresh() {
        this.clear();
        super.refresh();
    }
}
class $988a11d09320f6a8$export$c571855c51e6c4b6 extends (0, $aeedce20e9577100$export$2e2bcd8739ae039) {
    /**
   * @param {string} type Type.
   * @param {import("../Tile.js").default} tile The tile.
   */ constructor(type, tile){
        super(type);
        /**
     * The tile related to the event.
     * @type {import("../Tile.js").default}
     * @api
     */ this.tile = tile;
    }
}
var $988a11d09320f6a8$export$2e2bcd8739ae039 = $988a11d09320f6a8$var$TileSource;


/**
 * @module ol/source/TileEventType
 */ /**
 * @enum {string}
 */ var $7e3d7a0f8b272861$export$2e2bcd8739ae039 /**
 * @typedef {'tileloadstart'|'tileloadend'|'tileloaderror'} TileSourceEventTypes
 */  = {
    /**
   * Triggered when a tile starts loading.
   * @event module:ol/source/Tile.TileSourceEvent#tileloadstart
   * @api
   */ TILELOADSTART: 'tileloadstart',
    /**
   * Triggered when a tile finishes loading, either when its data is loaded,
   * or when loading was aborted because the tile is no longer needed.
   * @event module:ol/source/Tile.TileSourceEvent#tileloadend
   * @api
   */ TILELOADEND: 'tileloadend',
    /**
   * Triggered if tile loading results in an error. Note that this is not the
   * right place to re-fetch tiles. See {@link module:ol/ImageTile~ImageTile#load}
   * for details.
   * @event module:ol/source/Tile.TileSourceEvent#tileloaderror
   * @api
   */ TILELOADERROR: 'tileloaderror'
};


/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
 * @property {number} [cacheSize] Deprecated.  Use the cacheSize option on the layer instead.
 * @property {import("../proj.js").ProjectionLike} [projection] Projection.
 * @property {import("./Source.js").State} [state] State.
 * @property {import("../tilegrid/TileGrid.js").default} [tileGrid] TileGrid.
 * @property {import("../Tile.js").LoadFunction} tileLoadFunction TileLoadFunction.
 * @property {number} [tilePixelRatio] TilePixelRatio.
 * @property {import("../Tile.js").UrlFunction} [tileUrlFunction] Deprecated.  Use an ImageTile source and provide a function
 * for the url option instead.
 * @property {string} [url] Url.
 * @property {Array<string>} [urls] Urls.
 * @property {boolean} [wrapX=true] WrapX.
 * @property {number} [transition] Transition.
 * @property {string} [key] Key.
 * @property {number|import("../array.js").NearestDirectionFunction} [zDirection=0] ZDirection.
 * @property {boolean} [interpolate=false] Use interpolated values when resampling.  By default,
 * the nearest neighbor is used when resampling.
 */ /**
 * @deprecated Use the ol/source/ImageTile.js instead.
 *
 * @fires import("./Tile.js").TileSourceEvent
 */ class $e6408236331c2614$var$UrlTile extends (0, $988a11d09320f6a8$export$2e2bcd8739ae039) {
    /**
   * @param {Options} options Image tile options.
   */ constructor(options){
        super({
            attributions: options.attributions,
            cacheSize: options.cacheSize,
            projection: options.projection,
            state: options.state,
            tileGrid: options.tileGrid,
            tilePixelRatio: options.tilePixelRatio,
            wrapX: options.wrapX,
            transition: options.transition,
            interpolate: options.interpolate,
            key: options.key,
            attributionsCollapsible: options.attributionsCollapsible,
            zDirection: options.zDirection
        });
        /**
     * @private
     * @type {boolean}
     */ this.generateTileUrlFunction_ = this.tileUrlFunction === $e6408236331c2614$var$UrlTile.prototype.tileUrlFunction;
        /**
     * @protected
     * @type {import("../Tile.js").LoadFunction}
     */ this.tileLoadFunction = options.tileLoadFunction;
        if (options.tileUrlFunction) this.tileUrlFunction = options.tileUrlFunction;
        /**
     * @protected
     * @type {!Array<string>|null}
     */ this.urls = null;
        if (options.urls) this.setUrls(options.urls);
        else if (options.url) this.setUrl(options.url);
        /**
     * @private
     * @type {!Object<string, boolean>}
     */ this.tileLoadingKeys_ = {};
    }
    /**
   * Deprecated.  Use an ImageTile source instead.
   * Return the tile load function of the source.
   * @return {import("../Tile.js").LoadFunction} TileLoadFunction
   * @api
   */ getTileLoadFunction() {
        return this.tileLoadFunction;
    }
    /**
   * Deprecated.  Use an ImageTile source instead.
   * Return the tile URL function of the source.
   * @return {import("../Tile.js").UrlFunction} TileUrlFunction
   * @api
   */ getTileUrlFunction() {
        return Object.getPrototypeOf(this).tileUrlFunction === this.tileUrlFunction ? this.tileUrlFunction.bind(this) : this.tileUrlFunction;
    }
    /**
   * Deprecated.  Use an ImageTile source instead.
   * Return the URLs used for this source.
   * When a tileUrlFunction is used instead of url or urls,
   * null will be returned.
   * @return {!Array<string>|null} URLs.
   * @api
   */ getUrls() {
        return this.urls;
    }
    /**
   * Handle tile change events.
   * @param {import("../events/Event.js").default} event Event.
   * @protected
   */ handleTileChange(event) {
        const tile = /** @type {import("../Tile.js").default} */ event.target;
        const uid = (0, $6c5e11070e371322$export$5e82334337e0f204)(tile);
        const tileState = tile.getState();
        let type;
        if (tileState == (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).LOADING) {
            this.tileLoadingKeys_[uid] = true;
            type = (0, $7e3d7a0f8b272861$export$2e2bcd8739ae039).TILELOADSTART;
        } else if (uid in this.tileLoadingKeys_) {
            delete this.tileLoadingKeys_[uid];
            type = tileState == (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).ERROR ? (0, $7e3d7a0f8b272861$export$2e2bcd8739ae039).TILELOADERROR : tileState == (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).LOADED ? (0, $7e3d7a0f8b272861$export$2e2bcd8739ae039).TILELOADEND : undefined;
        }
        if (type != undefined) this.dispatchEvent(new (0, $988a11d09320f6a8$export$c571855c51e6c4b6)(type, tile));
    }
    /**
   * Deprecated.  Use an ImageTile source instead.
   * Set the tile load function of the source.
   * @param {import("../Tile.js").LoadFunction} tileLoadFunction Tile load function.
   * @api
   */ setTileLoadFunction(tileLoadFunction) {
        this.tileLoadFunction = tileLoadFunction;
        this.changed();
    }
    /**
   * Deprecated.  Use an ImageTile source instead.
   * Set the tile URL function of the source.
   * @param {import("../Tile.js").UrlFunction} tileUrlFunction Tile URL function.
   * @param {string} [key] Optional new tile key for the source.
   * @api
   */ setTileUrlFunction(tileUrlFunction, key) {
        this.tileUrlFunction = tileUrlFunction;
        if (typeof key !== 'undefined') this.setKey(key);
        else this.changed();
    }
    /**
   * Set the URL to use for requests.
   * @param {string} url URL.
   * @api
   */ setUrl(url) {
        const urls = (0, $60db182c0252e220$export$2a1fa079bfd73dde)(url);
        this.urls = urls;
        this.setUrls(urls);
    }
    /**
   * Deprecated.  Use an ImageTile source instead.
   * Set the URLs to use for requests.
   * @param {Array<string>} urls URLs.
   * @api
   */ setUrls(urls) {
        this.urls = urls;
        const key = urls.join('\n');
        if (this.generateTileUrlFunction_) this.setTileUrlFunction((0, $91dd08a0f5859882$export$436f44dbcc31fea3)(urls, this.tileGrid), key);
        else this.setKey(key);
    }
    /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {string|undefined} Tile URL.
   */ tileUrlFunction(tileCoord, pixelRatio, projection) {
        return undefined;
    }
}
var $e6408236331c2614$export$2e2bcd8739ae039 = $e6408236331c2614$var$UrlTile;


/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
 * @property {number} [cacheSize] Deprecated.  Use the cacheSize option on the layer instead.
 * @property {null|string} [crossOrigin] The `crossOrigin` attribute for loaded images.  Note that
 * you must provide a `crossOrigin` value if you want to access pixel data with the Canvas renderer.
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
 * @property {boolean} [interpolate=true] Use interpolated values when resampling.  By default,
 * linear interpolation is used when resampling.  Set to false to use the nearest neighbor instead.
 * @property {import("../proj.js").ProjectionLike} [projection] Projection. Default is the view projection.
 * @property {number} [reprojectionErrorThreshold=0.5] Maximum allowed reprojection error (in pixels).
 * Higher values can increase reprojection performance, but decrease precision.
 * @property {import("./Source.js").State} [state] Source state.
 * @property {typeof import("../ImageTile.js").default} [tileClass] Class used to instantiate image tiles.
 * Default is {@link module:ol/ImageTile~ImageTile}.
 * @property {import("../tilegrid/TileGrid.js").default} [tileGrid] Tile grid.
 * @property {import("../Tile.js").LoadFunction} [tileLoadFunction] Optional function to load a tile given a URL. The default is
 * ```js
 * function(imageTile, src) {
 *   imageTile.getImage().src = src;
 * };
 * ```
 * @property {number} [tilePixelRatio=1] The pixel ratio used by the tile service. For example, if the tile
 * service advertizes 256px by 256px tiles but actually sends 512px
 * by 512px images (for retina/hidpi devices) then `tilePixelRatio`
 * should be set to `2`.
 * @property {import("../Tile.js").UrlFunction} [tileUrlFunction] Deprecated.  Use an ImageTile source and provide a function
 * for the url option instead.
 * @property {string} [url] URL template. Must include `{x}`, `{y}` or `{-y}`, and `{z}` placeholders.
 * A `{?-?}` template pattern, for example `subdomain{a-f}.domain.com`, may be
 * used instead of defining each one separately in the `urls` option.
 * @property {Array<string>} [urls] An array of URL templates.
 * @property {boolean} [wrapX] Whether to wrap the world horizontally. The default, is to
 * request out-of-bounds tiles from the server. When set to `false`, only one
 * world will be rendered. When set to `true`, tiles will be requested for one
 * world only, but they will be wrapped horizontally to render multiple worlds.
 * @property {number} [transition] Duration of the opacity transition for rendering.
 * To disable the opacity transition, pass `transition: 0`.
 * @property {string} [key] Optional tile key for proper cache fetching
 * @property {number|import("../array.js").NearestDirectionFunction} [zDirection=0]
 * Choose whether to use tiles with a higher or lower zoom level when between integer
 * zoom levels. See {@link module:ol/tilegrid/TileGrid~TileGrid#getZForResolution}.
 */ /**
 * @deprecated Use the ol/source/ImageTile.js instead.
 *
 * @fires import("./Tile.js").TileSourceEvent
 * @api
 */ class $51d055913ca55b5e$var$TileImage extends (0, $e6408236331c2614$export$2e2bcd8739ae039) {
    /**
   * @param {!Options} options Image tile options.
   */ constructor(options){
        super({
            attributions: options.attributions,
            cacheSize: options.cacheSize,
            projection: options.projection,
            state: options.state,
            tileGrid: options.tileGrid,
            tileLoadFunction: options.tileLoadFunction ? options.tileLoadFunction : $51d055913ca55b5e$var$defaultTileLoadFunction,
            tilePixelRatio: options.tilePixelRatio,
            tileUrlFunction: options.tileUrlFunction,
            url: options.url,
            urls: options.urls,
            wrapX: options.wrapX,
            transition: options.transition,
            interpolate: options.interpolate !== undefined ? options.interpolate : true,
            key: options.key,
            attributionsCollapsible: options.attributionsCollapsible,
            zDirection: options.zDirection
        });
        /**
     * @protected
     * @type {?string}
     */ this.crossOrigin = options.crossOrigin !== undefined ? options.crossOrigin : null;
        /**
     * @protected
     * @type {typeof ImageTile}
     */ this.tileClass = options.tileClass !== undefined ? options.tileClass : (0, $cd3bc8d185522361$export$2e2bcd8739ae039);
        /**
     * @protected
     * @type {!Object<string, import("../tilegrid/TileGrid.js").default>}
     */ this.tileGridForProjection = {};
        /**
     * @private
     * @type {number|undefined}
     */ this.reprojectionErrorThreshold_ = options.reprojectionErrorThreshold;
        /**
     * @private
     * @type {boolean}
     */ this.renderReprojectionEdges_ = false;
    }
    /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {number} Gutter.
   * @override
   */ getGutterForProjection(projection) {
        if (this.getProjection() && projection && !(0, $9c4744460e43e41b$export$fe091d73a555748b)(this.getProjection(), projection)) return 0;
        return this.getGutter();
    }
    /**
   * @return {number} Gutter.
   */ getGutter() {
        return 0;
    }
    /**
   * Return the key to be used for all tiles in the source.
   * @return {string} The key for all tiles.
   * @override
   */ getKey() {
        let key = super.getKey();
        if (!this.getInterpolate()) key += ':disable-interpolation';
        return key;
    }
    /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {!import("../tilegrid/TileGrid.js").default} Tile grid.
   * @override
   */ getTileGridForProjection(projection) {
        const thisProj = this.getProjection();
        if (this.tileGrid && (!thisProj || (0, $9c4744460e43e41b$export$fe091d73a555748b)(thisProj, projection))) return this.tileGrid;
        const projKey = (0, $6c5e11070e371322$export$5e82334337e0f204)(projection);
        if (!(projKey in this.tileGridForProjection)) this.tileGridForProjection[projKey] = (0, $5779655d81caea04$export$1f4812384df8a9c5)(projection);
        return this.tileGridForProjection[projKey];
    }
    /**
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @param {string} key The key set on the tile.
   * @return {!ImageTile} Tile.
   * @private
   */ createTile_(z, x, y, pixelRatio, projection, key) {
        const tileCoord = [
            z,
            x,
            y
        ];
        const urlTileCoord = this.getTileCoordForTileUrlFunction(tileCoord, projection);
        const tileUrl = urlTileCoord ? this.tileUrlFunction(urlTileCoord, pixelRatio, projection) : undefined;
        const tile = new this.tileClass(tileCoord, tileUrl !== undefined ? (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).IDLE : (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).EMPTY, tileUrl !== undefined ? tileUrl : '', this.crossOrigin, this.tileLoadFunction, this.tileOptions);
        tile.key = key;
        tile.addEventListener((0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE, this.handleTileChange.bind(this));
        return tile;
    }
    /**
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {!(ImageTile|ReprojTile)} Tile.
   * @override
   */ getTile(z, x, y, pixelRatio, projection) {
        const sourceProjection = this.getProjection();
        if (!sourceProjection || !projection || (0, $9c4744460e43e41b$export$fe091d73a555748b)(sourceProjection, projection)) return this.getTileInternal(z, x, y, pixelRatio, sourceProjection || projection);
        const tileCoord = [
            z,
            x,
            y
        ];
        const key = this.getKey();
        const sourceTileGrid = this.getTileGridForProjection(sourceProjection);
        const targetTileGrid = this.getTileGridForProjection(projection);
        const wrappedTileCoord = this.getTileCoordForTileUrlFunction(tileCoord, projection);
        const tile = new (0, $398e350e33050c07$export$2e2bcd8739ae039)(sourceProjection, sourceTileGrid, projection, targetTileGrid, tileCoord, wrappedTileCoord, this.getTilePixelRatio(pixelRatio), this.getGutter(), (z, x, y, pixelRatio)=>this.getTileInternal(z, x, y, pixelRatio, sourceProjection), this.reprojectionErrorThreshold_, this.renderReprojectionEdges_, this.tileOptions);
        tile.key = key;
        return tile;
    }
    /**
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {number} pixelRatio Pixel ratio.
   * @param {!import("../proj/Projection.js").default} projection Projection.
   * @return {!ImageTile} Tile.
   * @protected
   */ getTileInternal(z, x, y, pixelRatio, projection) {
        const key = this.getKey();
        return this.createTile_(z, x, y, pixelRatio, projection, key);
    }
    /**
   * Sets whether to render reprojection edges or not (usually for debugging).
   * @param {boolean} render Render the edges.
   * @api
   */ setRenderReprojectionEdges(render) {
        if (this.renderReprojectionEdges_ == render) return;
        this.renderReprojectionEdges_ = render;
        this.changed();
    }
    /**
   * Sets the tile grid to use when reprojecting the tiles to the given
   * projection instead of the default tile grid for the projection.
   *
   * This can be useful when the default tile grid cannot be created
   * (e.g. projection has no extent defined) or
   * for optimization reasons (custom tile size, resolutions, ...).
   *
   * @param {import("../proj.js").ProjectionLike} projection Projection.
   * @param {import("../tilegrid/TileGrid.js").default} tilegrid Tile grid to use for the projection.
   * @api
   */ setTileGridForProjection(projection, tilegrid) {
        const proj = (0, $9c4744460e43e41b$export$3988ae62b71be9a3)(projection);
        if (proj) {
            const projKey = (0, $6c5e11070e371322$export$5e82334337e0f204)(proj);
            if (!(projKey in this.tileGridForProjection)) this.tileGridForProjection[projKey] = tilegrid;
        }
    }
}
/**
 * @param {ImageTile} imageTile Image tile.
 * @param {string} src Source.
 */ function $51d055913ca55b5e$var$defaultTileLoadFunction(imageTile, src) {
    /** @type {HTMLImageElement|HTMLVideoElement} */ imageTile.getImage().src = src;
}
var $51d055913ca55b5e$export$2e2bcd8739ae039 = $51d055913ca55b5e$var$TileImage;


/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
 * @property {number} [cacheSize] Deprecated.  Use the cacheSize option on the layer instead.
 * @property {null|string} [crossOrigin] The `crossOrigin` attribute for loaded images.  Note that
 * you must provide a `crossOrigin` value if you want to access pixel data with the Canvas renderer.
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
 * @property {boolean} [interpolate=true] Use interpolated values when resampling.  By default,
 * linear interpolation is used when resampling.  Set to false to use the nearest neighbor instead.
 * @property {import("../proj.js").ProjectionLike} [projection='EPSG:3857'] Projection.
 * @property {number} [reprojectionErrorThreshold=0.5] Maximum allowed reprojection error (in pixels).
 * Higher values can increase reprojection performance, but decrease precision.
 * @property {number} [maxZoom=42] Optional max zoom level. Not used if `tileGrid` is provided.
 * @property {number} [minZoom=0] Optional min zoom level. Not used if `tileGrid` is provided.
 * @property {number} [maxResolution] Optional tile grid resolution at level zero. Not used if `tileGrid` is provided.
 * @property {import("../tilegrid/TileGrid.js").default} [tileGrid] Tile grid.
 * @property {import("../Tile.js").LoadFunction} [tileLoadFunction] Deprecated.  Use an ImageTile source with a loader
 * instead.  Optional function to load a tile given a URL. The default is
 * ```js
 * function(imageTile, src) {
 *   imageTile.getImage().src = src;
 * };
 * ```
 * @property {number} [tilePixelRatio=1] The pixel ratio used by the tile service.
 * For example, if the tile service advertizes 256px by 256px tiles but actually sends 512px
 * by 512px images (for retina/hidpi devices) then `tilePixelRatio`
 * should be set to `2`.
 * @property {number|import("../size.js").Size} [tileSize=[256, 256]] The tile size used by the tile service.
 * Not used if `tileGrid` is provided.
 * @property {number} [gutter=0] The size in pixels of the gutter around image tiles to ignore.
 * This allows artifacts of rendering at tile edges to be ignored.
 * Supported images should be wider and taller than the tile size by a value of `2 x gutter`.
 * @property {import("../Tile.js").UrlFunction} [tileUrlFunction] Deprecated.  Use an ImageTile source and provide a function
 * for the url option instead.
 * @property {string} [url] URL template. Must include `{x}`, `{y}` or `{-y}`,
 * and `{z}` placeholders. A `{?-?}` template pattern, for example `subdomain{a-f}.domain.com`,
 * may be used instead of defining each one separately in the `urls` option.
 * @property {Array<string>} [urls] Deprecated.  Use an ImageTile source and provide an array of URLs for the
 * url option instead.
 * @property {boolean} [wrapX=true] Whether to wrap the world horizontally.
 * @property {number} [transition=250] Duration of the opacity transition for rendering.
 * To disable the opacity transition, pass `transition: 0`.
 * @property {number|import("../array.js").NearestDirectionFunction} [zDirection=0]
 * Choose whether to use tiles with a higher or lower zoom level when between integer
 * zoom levels. See {@link module:ol/tilegrid/TileGrid~TileGrid#getZForResolution}.
 */ /**
 * @classdesc
 * Layer source for tile data with URLs in a set XYZ format that are
 * defined in a URL template. By default, this follows the widely-used
 * Google grid where `x` 0 and `y` 0 are in the top left. Grids like
 * TMS where `x` 0 and `y` 0 are in the bottom left can be used by
 * using the `{-y}` placeholder in the URL template, so long as the
 * source does not have a custom tile grid. In this case
 * a `tileUrlFunction` can be used, such as:
 * ```js
 *  tileUrlFunction: function(coordinate) {
 *    return 'http://mapserver.com/' + coordinate[0] + '/' +
 *      coordinate[1] + '/' + (-coordinate[2] - 1) + '.png';
 *  }
 * ```
 * @api
 */ class $963a7ef65488964c$var$XYZ extends (0, $51d055913ca55b5e$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] XYZ options.
   */ constructor(options){
        options = options || {};
        const projection = options.projection !== undefined ? options.projection : 'EPSG:3857';
        const tileGrid = options.tileGrid !== undefined ? options.tileGrid : (0, $5779655d81caea04$export$38500bbeccc864ff)({
            extent: (0, $5779655d81caea04$export$7b5b6ef8fd55fac4)(projection),
            maxResolution: options.maxResolution,
            maxZoom: options.maxZoom,
            minZoom: options.minZoom,
            tileSize: options.tileSize
        });
        super({
            attributions: options.attributions,
            cacheSize: options.cacheSize,
            crossOrigin: options.crossOrigin,
            interpolate: options.interpolate,
            projection: projection,
            reprojectionErrorThreshold: options.reprojectionErrorThreshold,
            tileGrid: tileGrid,
            tileLoadFunction: options.tileLoadFunction,
            tilePixelRatio: options.tilePixelRatio,
            tileUrlFunction: options.tileUrlFunction,
            url: options.url,
            urls: options.urls,
            wrapX: options.wrapX !== undefined ? options.wrapX : true,
            transition: options.transition,
            attributionsCollapsible: options.attributionsCollapsible,
            zDirection: options.zDirection
        });
        /**
     * @private
     * @type {number}
     */ this.gutter_ = options.gutter !== undefined ? options.gutter : 0;
    }
    /**
   * @return {number} Gutter.
   * @override
   */ getGutter() {
        return this.gutter_;
    }
}
var $963a7ef65488964c$export$2e2bcd8739ae039 = $963a7ef65488964c$var$XYZ;


const $6c8498cc816f2362$export$4de8a5e77eb994ad = '&#169; <a href="https://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a> contributors.';
/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {number} [cacheSize] Deprecated.  Use the cacheSize option on the layer instead.
 * @property {null|string} [crossOrigin='anonymous'] The `crossOrigin` attribute for loaded images.  Note that
 * you must provide a `crossOrigin` value if you want to access pixel data with the Canvas renderer.
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
 * @property {boolean} [interpolate=true] Use interpolated values when resampling.  By default,
 * linear interpolation is used when resampling.  Set to false to use the nearest neighbor instead.
 * @property {number} [maxZoom=19] Max zoom.
 * @property {number} [reprojectionErrorThreshold=0.5] Maximum allowed reprojection error (in pixels).
 * Higher values can increase reprojection performance, but decrease precision.
 * @property {import("../Tile.js").LoadFunction} [tileLoadFunction] Optional function to load a tile given a URL. The default is
 * ```js
 * function(imageTile, src) {
 *   imageTile.getImage().src = src;
 * };
 * ```
 * @property {number} [transition=250] Duration of the opacity transition for rendering.
 * To disable the opacity transition, pass `transition: 0`.
 * @property {string} [url='https://tile.openstreetmap.org/{z}/{x}/{y}.png'] URL template.
 * Must include `{x}`, `{y}` or `{-y}`, and `{z}` placeholders.
 * @property {boolean} [wrapX=true] Whether to wrap the world horizontally.
 * @property {number|import("../array.js").NearestDirectionFunction} [zDirection=0]
 * Choose whether to use tiles with a higher or lower zoom level when between integer
 * zoom levels. See {@link module:ol/tilegrid/TileGrid~TileGrid#getZForResolution}.
 */ /**
 * @classdesc
 * Layer source for the OpenStreetMap tile server.
 * @api
 */ class $6c8498cc816f2362$var$OSM extends (0, $963a7ef65488964c$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Open Street Map options.
   */ constructor(options){
        options = options || {};
        let attributions;
        if (options.attributions !== undefined) attributions = options.attributions;
        else attributions = [
            $6c8498cc816f2362$export$4de8a5e77eb994ad
        ];
        const crossOrigin = options.crossOrigin !== undefined ? options.crossOrigin : 'anonymous';
        const url = options.url !== undefined ? options.url : 'https://tile.openstreetmap.org/{z}/{x}/{y}.png';
        super({
            attributions: attributions,
            attributionsCollapsible: false,
            cacheSize: options.cacheSize,
            crossOrigin: crossOrigin,
            interpolate: options.interpolate,
            maxZoom: options.maxZoom !== undefined ? options.maxZoom : 19,
            reprojectionErrorThreshold: options.reprojectionErrorThreshold,
            tileLoadFunction: options.tileLoadFunction,
            transition: options.transition,
            url: url,
            wrapX: options.wrapX,
            zDirection: options.zDirection
        });
    }
}
var $6c8498cc816f2362$export$2e2bcd8739ae039 = $6c8498cc816f2362$var$OSM;



var $f1q41 = parcelRequire("f1q41");

var $f1q41 = parcelRequire("f1q41");

var $f1q41 = parcelRequire("f1q41");
'use strict';
function $e5cb5cefd6507f7e$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


'use strict';
// utils is a library of generic helper functions non-specific to axios
const { toString: $c319b2c832c2914a$var$toString } = Object.prototype;
const { getPrototypeOf: $c319b2c832c2914a$var$getPrototypeOf } = Object;
const $c319b2c832c2914a$var$kindOf = ((cache)=>(thing)=>{
        const str = $c319b2c832c2914a$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $c319b2c832c2914a$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$c319b2c832c2914a$var$kindOf(thing) === type;
};
const $c319b2c832c2914a$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $c319b2c832c2914a$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $c319b2c832c2914a$var$isUndefined = $c319b2c832c2914a$var$typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $c319b2c832c2914a$var$isBuffer(val) {
    return val !== null && !$c319b2c832c2914a$var$isUndefined(val) && val.constructor !== null && !$c319b2c832c2914a$var$isUndefined(val.constructor) && $c319b2c832c2914a$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $c319b2c832c2914a$var$isArrayBuffer = $c319b2c832c2914a$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $c319b2c832c2914a$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $c319b2c832c2914a$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $c319b2c832c2914a$var$isString = $c319b2c832c2914a$var$typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $c319b2c832c2914a$var$isFunction = $c319b2c832c2914a$var$typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $c319b2c832c2914a$var$isNumber = $c319b2c832c2914a$var$typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $c319b2c832c2914a$var$isObject = (thing)=>thing !== null && typeof thing === 'object';
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $c319b2c832c2914a$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $c319b2c832c2914a$var$isPlainObject = (val)=>{
    if ($c319b2c832c2914a$var$kindOf(val) !== 'object') return false;
    const prototype = $c319b2c832c2914a$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $c319b2c832c2914a$var$isDate = $c319b2c832c2914a$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $c319b2c832c2914a$var$isFile = $c319b2c832c2914a$var$kindOfTest('File');
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $c319b2c832c2914a$var$isBlob = $c319b2c832c2914a$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $c319b2c832c2914a$var$isFileList = $c319b2c832c2914a$var$kindOfTest('FileList');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $c319b2c832c2914a$var$isStream = (val)=>$c319b2c832c2914a$var$isObject(val) && $c319b2c832c2914a$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $c319b2c832c2914a$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === 'function' && thing instanceof FormData || $c319b2c832c2914a$var$isFunction(thing.append) && ((kind = $c319b2c832c2914a$var$kindOf(thing)) === 'formdata' || // detect form-data instance
    kind === 'object' && $c319b2c832c2914a$var$isFunction(thing.toString) && thing.toString() === '[object FormData]'));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $c319b2c832c2914a$var$isURLSearchParams = $c319b2c832c2914a$var$kindOfTest('URLSearchParams');
const [$c319b2c832c2914a$var$isReadableStream, $c319b2c832c2914a$var$isRequest, $c319b2c832c2914a$var$isResponse, $c319b2c832c2914a$var$isHeaders] = [
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map($c319b2c832c2914a$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $c319b2c832c2914a$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $c319b2c832c2914a$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($c319b2c832c2914a$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $c319b2c832c2914a$var$findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $c319b2c832c2914a$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== 'undefined' ? window : $parcel$global;
})();
const $c319b2c832c2914a$var$isContextDefined = (context)=>!$c319b2c832c2914a$var$isUndefined(context) && context !== $c319b2c832c2914a$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $c319b2c832c2914a$var$merge() {
    const { caseless: caseless } = $c319b2c832c2914a$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $c319b2c832c2914a$var$findKey(result, key) || key;
        if ($c319b2c832c2914a$var$isPlainObject(result[targetKey]) && $c319b2c832c2914a$var$isPlainObject(val)) result[targetKey] = $c319b2c832c2914a$var$merge(result[targetKey], val);
        else if ($c319b2c832c2914a$var$isPlainObject(val)) result[targetKey] = $c319b2c832c2914a$var$merge({}, val);
        else if ($c319b2c832c2914a$var$isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $c319b2c832c2914a$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $c319b2c832c2914a$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $c319b2c832c2914a$var$forEach(b, (val, key)=>{
        if (thisArg && $c319b2c832c2914a$var$isFunction(val)) a[key] = (0, $e5cb5cefd6507f7e$export$2e2bcd8739ae039)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $c319b2c832c2914a$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $c319b2c832c2914a$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, 'super', {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $c319b2c832c2914a$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $c319b2c832c2914a$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $c319b2c832c2914a$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $c319b2c832c2914a$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($c319b2c832c2914a$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$c319b2c832c2914a$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $c319b2c832c2914a$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== 'undefined' && $c319b2c832c2914a$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $c319b2c832c2914a$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[Symbol.iterator];
    const iterator = generator.call(obj);
    let result;
    while((result = iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $c319b2c832c2914a$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $c319b2c832c2914a$var$isHTMLForm = $c319b2c832c2914a$var$kindOfTest('HTMLFormElement');
const $c319b2c832c2914a$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $c319b2c832c2914a$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $c319b2c832c2914a$var$isRegExp = $c319b2c832c2914a$var$kindOfTest('RegExp');
const $c319b2c832c2914a$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $c319b2c832c2914a$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $c319b2c832c2914a$var$freezeMethods = (obj)=>{
    $c319b2c832c2914a$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($c319b2c832c2914a$var$isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$c319b2c832c2914a$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error('Can not rewrite read-only method \'' + name + '\'');
        };
    });
};
const $c319b2c832c2914a$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $c319b2c832c2914a$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $c319b2c832c2914a$var$noop = ()=>{};
const $c319b2c832c2914a$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $c319b2c832c2914a$var$isSpecCompliantForm(thing) {
    return !!(thing && $c319b2c832c2914a$var$isFunction(thing.append) && thing[Symbol.toStringTag] === 'FormData' && thing[Symbol.iterator]);
}
const $c319b2c832c2914a$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($c319b2c832c2914a$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!('toJSON' in source)) {
                stack[i] = source;
                const target = $c319b2c832c2914a$var$isArray(source) ? [] : {};
                $c319b2c832c2914a$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$c319b2c832c2914a$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $c319b2c832c2914a$var$isAsyncFn = $c319b2c832c2914a$var$kindOfTest('AsyncFunction');
const $c319b2c832c2914a$var$isThenable = (thing)=>thing && ($c319b2c832c2914a$var$isObject(thing) || $c319b2c832c2914a$var$isFunction(thing)) && $c319b2c832c2914a$var$isFunction(thing.then) && $c319b2c832c2914a$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
const $c319b2c832c2914a$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $c319b2c832c2914a$var$_global.addEventListener("message", ({ source: source, data: data })=>{
            if (source === $c319b2c832c2914a$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $c319b2c832c2914a$var$_global.postMessage(token, "*");
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === 'function', $c319b2c832c2914a$var$isFunction($c319b2c832c2914a$var$_global.postMessage));
const $c319b2c832c2914a$var$asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind($c319b2c832c2914a$var$_global) : $c319b2c832c2914a$var$_setImmediate;
var // *********************
$c319b2c832c2914a$export$2e2bcd8739ae039 = {
    isArray: $c319b2c832c2914a$var$isArray,
    isArrayBuffer: $c319b2c832c2914a$var$isArrayBuffer,
    isBuffer: $c319b2c832c2914a$var$isBuffer,
    isFormData: $c319b2c832c2914a$var$isFormData,
    isArrayBufferView: $c319b2c832c2914a$var$isArrayBufferView,
    isString: $c319b2c832c2914a$var$isString,
    isNumber: $c319b2c832c2914a$var$isNumber,
    isBoolean: $c319b2c832c2914a$var$isBoolean,
    isObject: $c319b2c832c2914a$var$isObject,
    isPlainObject: $c319b2c832c2914a$var$isPlainObject,
    isReadableStream: $c319b2c832c2914a$var$isReadableStream,
    isRequest: $c319b2c832c2914a$var$isRequest,
    isResponse: $c319b2c832c2914a$var$isResponse,
    isHeaders: $c319b2c832c2914a$var$isHeaders,
    isUndefined: $c319b2c832c2914a$var$isUndefined,
    isDate: $c319b2c832c2914a$var$isDate,
    isFile: $c319b2c832c2914a$var$isFile,
    isBlob: $c319b2c832c2914a$var$isBlob,
    isRegExp: $c319b2c832c2914a$var$isRegExp,
    isFunction: $c319b2c832c2914a$var$isFunction,
    isStream: $c319b2c832c2914a$var$isStream,
    isURLSearchParams: $c319b2c832c2914a$var$isURLSearchParams,
    isTypedArray: $c319b2c832c2914a$var$isTypedArray,
    isFileList: $c319b2c832c2914a$var$isFileList,
    forEach: $c319b2c832c2914a$var$forEach,
    merge: $c319b2c832c2914a$var$merge,
    extend: $c319b2c832c2914a$var$extend,
    trim: $c319b2c832c2914a$var$trim,
    stripBOM: $c319b2c832c2914a$var$stripBOM,
    inherits: $c319b2c832c2914a$var$inherits,
    toFlatObject: $c319b2c832c2914a$var$toFlatObject,
    kindOf: $c319b2c832c2914a$var$kindOf,
    kindOfTest: $c319b2c832c2914a$var$kindOfTest,
    endsWith: $c319b2c832c2914a$var$endsWith,
    toArray: $c319b2c832c2914a$var$toArray,
    forEachEntry: $c319b2c832c2914a$var$forEachEntry,
    matchAll: $c319b2c832c2914a$var$matchAll,
    isHTMLForm: $c319b2c832c2914a$var$isHTMLForm,
    hasOwnProperty: $c319b2c832c2914a$var$hasOwnProperty,
    hasOwnProp: $c319b2c832c2914a$var$hasOwnProperty,
    reduceDescriptors: $c319b2c832c2914a$var$reduceDescriptors,
    freezeMethods: $c319b2c832c2914a$var$freezeMethods,
    toObjectSet: $c319b2c832c2914a$var$toObjectSet,
    toCamelCase: $c319b2c832c2914a$var$toCamelCase,
    noop: $c319b2c832c2914a$var$noop,
    toFiniteNumber: $c319b2c832c2914a$var$toFiniteNumber,
    findKey: $c319b2c832c2914a$var$findKey,
    global: $c319b2c832c2914a$var$_global,
    isContextDefined: $c319b2c832c2914a$var$isContextDefined,
    isSpecCompliantForm: $c319b2c832c2914a$var$isSpecCompliantForm,
    toJSONObject: $c319b2c832c2914a$var$toJSONObject,
    isAsyncFn: $c319b2c832c2914a$var$isAsyncFn,
    isThenable: $c319b2c832c2914a$var$isThenable,
    setImmediate: $c319b2c832c2914a$var$_setImmediate,
    asap: $c319b2c832c2914a$var$asap
};







'use strict';
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $4e2395edb77acf3a$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = 'AxiosError';
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    if (response) {
        this.response = response;
        this.status = response.status ? response.status : null;
    }
}
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).inherits($4e2395edb77acf3a$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toJSONObject(this.config),
            code: this.code,
            status: this.status
        };
    }
});
const $4e2395edb77acf3a$var$prototype = $4e2395edb77acf3a$var$AxiosError.prototype;
const $4e2395edb77acf3a$var$descriptors = {};
[
    'ERR_BAD_OPTION_VALUE',
    'ERR_BAD_OPTION',
    'ECONNABORTED',
    'ETIMEDOUT',
    'ERR_NETWORK',
    'ERR_FR_TOO_MANY_REDIRECTS',
    'ERR_DEPRECATED',
    'ERR_BAD_RESPONSE',
    'ERR_BAD_REQUEST',
    'ERR_CANCELED',
    'ERR_NOT_SUPPORT',
    'ERR_INVALID_URL'
].forEach((code)=>{
    $4e2395edb77acf3a$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($4e2395edb77acf3a$var$AxiosError, $4e2395edb77acf3a$var$descriptors);
Object.defineProperty($4e2395edb77acf3a$var$prototype, 'isAxiosError', {
    value: true
});
// eslint-disable-next-line func-names
$4e2395edb77acf3a$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($4e2395edb77acf3a$var$prototype);
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== 'isAxiosError';
    });
    $4e2395edb77acf3a$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $4e2395edb77acf3a$export$2e2bcd8739ae039 = $4e2395edb77acf3a$var$AxiosError;


// eslint-disable-next-line strict
var $4023ac50ad132196$export$2e2bcd8739ae039 = null;


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
'use strict';
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
'use strict';
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup['-'.charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup['_'.charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case 'ascii':
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case 'base64':
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $eeb0961446aae8e3$export$6100ba28696e12de(buf);
    else return $eeb0961446aae8e3$export$6100ba28696e12de(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$51861dfc7ca9d588$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $eeb0961446aae8e3$export$d622b2ad8d90c771($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}


var $e6cbd383b18c9625$require$Buffer = $51861dfc7ca9d588$export$a143d493d941bafc;
'use strict';
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $e6cbd383b18c9625$var$isVisitable(thing) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $e6cbd383b18c9625$var$removeBrackets(key) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $e6cbd383b18c9625$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $e6cbd383b18c9625$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $e6cbd383b18c9625$var$isFlatArray(arr) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(arr) && !arr.some($e6cbd383b18c9625$var$isVisitable);
}
const $e6cbd383b18c9625$var$predicates = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFlatObject((0, $c319b2c832c2914a$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $e6cbd383b18c9625$var$toFormData(obj, formData, options) {
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $4023ac50ad132196$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
    const useBlob = _Blob && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if (!useBlob && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Blob is not supported. Use a Buffer instead.');
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === 'function' ? new Blob([
            value
        ]) : $e6cbd383b18c9625$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === 'object') {
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(value) && $e6cbd383b18c9625$var$isFlatArray(value) || ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFileList(value) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).endsWith(key, '[]')) && (arr = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $e6cbd383b18c9625$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $e6cbd383b18c9625$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($e6cbd383b18c9625$var$isVisitable(value)) return true;
        formData.append($e6cbd383b18c9625$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($e6cbd383b18c9625$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $e6cbd383b18c9625$var$isVisitable
    });
    function build(value, path) {
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
var $e6cbd383b18c9625$export$2e2bcd8739ae039 = $e6cbd383b18c9625$var$toFormData;


'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $f66f8c7b4f247caf$var$encode(str) {
    const charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+',
        '%00': '\x00'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $f66f8c7b4f247caf$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $e6cbd383b18c9625$export$2e2bcd8739ae039)(params, this, options);
}
const $f66f8c7b4f247caf$var$prototype = $f66f8c7b4f247caf$var$AxiosURLSearchParams.prototype;
$f66f8c7b4f247caf$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$f66f8c7b4f247caf$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $f66f8c7b4f247caf$var$encode);
    } : $f66f8c7b4f247caf$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
var $f66f8c7b4f247caf$export$2e2bcd8739ae039 = $f66f8c7b4f247caf$var$AxiosURLSearchParams;


'use strict';
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $8df8fedf1c1e4428$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}
function $8df8fedf1c1e4428$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $8df8fedf1c1e4428$var$encode;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(options)) options = {
        serialize: options
    };
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $f66f8c7b4f247caf$export$2e2bcd8739ae039)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}



'use strict';
class $5de878cd737ef277$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $5de878cd737ef277$export$2e2bcd8739ae039 = $5de878cd737ef277$var$InterceptorManager;





'use strict';
var $51466d41a76e5b4b$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};






'use strict';
var $6eeff4490c995137$export$2e2bcd8739ae039 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, $f66f8c7b4f247caf$export$2e2bcd8739ae039);


'use strict';
var $86d275a264afb13f$export$2e2bcd8739ae039 = typeof FormData !== 'undefined' ? FormData : null;


'use strict';
var $59c79e94740631e4$export$2e2bcd8739ae039 = typeof Blob !== 'undefined' ? Blob : null;


var $2f71637df772b183$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $6eeff4490c995137$export$2e2bcd8739ae039,
        FormData: $86d275a264afb13f$export$2e2bcd8739ae039,
        Blob: $59c79e94740631e4$export$2e2bcd8739ae039
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};


var $565e85ead8bde60a$exports = {};

$parcel$export($565e85ead8bde60a$exports, "hasBrowserEnv", () => $565e85ead8bde60a$export$c4996c4b7b93b0bf);
$parcel$export($565e85ead8bde60a$exports, "navigator", () => $565e85ead8bde60a$export$ec7c8efa7f5790ae);
$parcel$export($565e85ead8bde60a$exports, "hasStandardBrowserEnv", () => $565e85ead8bde60a$export$c0bcc9250309d66);
$parcel$export($565e85ead8bde60a$exports, "hasStandardBrowserWebWorkerEnv", () => $565e85ead8bde60a$export$c81692cf5af97dac);
$parcel$export($565e85ead8bde60a$exports, "origin", () => $565e85ead8bde60a$export$f710a83a91838a36);
const $565e85ead8bde60a$export$c4996c4b7b93b0bf = typeof window !== 'undefined' && typeof document !== 'undefined';
const $565e85ead8bde60a$export$ec7c8efa7f5790ae = typeof navigator === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $565e85ead8bde60a$export$c0bcc9250309d66 = $565e85ead8bde60a$export$c4996c4b7b93b0bf && (!$565e85ead8bde60a$export$ec7c8efa7f5790ae || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf($565e85ead8bde60a$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $565e85ead8bde60a$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const $565e85ead8bde60a$export$f710a83a91838a36 = $565e85ead8bde60a$export$c4996c4b7b93b0bf && window.location.href || 'http://localhost';


var $bb8180acb278e187$export$2e2bcd8739ae039 = {
    ...$565e85ead8bde60a$exports,
    ...(0, $2f71637df772b183$export$2e2bcd8739ae039)
};


'use strict';
function $f6f250f62cadb740$export$2e2bcd8739ae039(data, options) {
    return (0, $e6cbd383b18c9625$export$2e2bcd8739ae039)(data, new (0, $bb8180acb278e187$export$2e2bcd8739ae039).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, $bb8180acb278e187$export$2e2bcd8739ae039).isNode && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}




'use strict';
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $5f8142930b3b943f$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === '[]' ? '' : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $5f8142930b3b943f$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $5f8142930b3b943f$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === '__proto__') return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $5f8142930b3b943f$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(formData) && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($5f8142930b3b943f$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $5f8142930b3b943f$export$2e2bcd8739ae039 = $5f8142930b3b943f$var$formDataToJSON;


'use strict';
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $843bf0209bc94df8$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $843bf0209bc94df8$var$defaults = {
    transitional: (0, $51466d41a76e5b4b$export$2e2bcd8739ae039),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || '';
            const hasJSONContentType = contentType.indexOf('application/json') > -1;
            const isObjectPayload = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $5f8142930b3b943f$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBuffer(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isStream(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFile(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBlob(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, $f6f250f62cadb740$export$2e2bcd8739ae039)(data, this.formSerializer).toString();
                if ((isFileList = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $e6cbd383b18c9625$export$2e2bcd8739ae039)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return $843bf0209bc94df8$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $843bf0209bc94df8$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === 'json';
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isResponse(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if (data && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).from(e, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $bb8180acb278e187$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $bb8180acb278e187$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'post',
    'put',
    'patch'
], (method)=>{
    $843bf0209bc94df8$var$defaults.headers[method] = {};
});
var $843bf0209bc94df8$export$2e2bcd8739ae039 = $843bf0209bc94df8$var$defaults;




'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $fc026bbf9ee156f1$var$ignoreDuplicateOf = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $fc026bbf9ee156f1$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $fc026bbf9ee156f1$var$ignoreDuplicateOf[key]) return;
        if (key === 'set-cookie') {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};


'use strict';
const $866cce54f6bdfb0c$var$$internals = Symbol('internals');
function $866cce54f6bdfb0c$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $866cce54f6bdfb0c$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(value) ? value.map($866cce54f6bdfb0c$var$normalizeValue) : String(value);
}
function $866cce54f6bdfb0c$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $866cce54f6bdfb0c$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $866cce54f6bdfb0c$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $866cce54f6bdfb0c$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $866cce54f6bdfb0c$var$buildAccessors(obj, header) {
    const accessorName = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $866cce54f6bdfb0c$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (!lHeader) throw new Error('header name must be a non-empty string');
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $866cce54f6bdfb0c$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$866cce54f6bdfb0c$var$isValidHeaderName(header)) setHeaders((0, $fc026bbf9ee156f1$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isHeaders(header)) for (const [key, value] of header.entries())setHeader(value, key, rewrite);
        else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $866cce54f6bdfb0c$var$normalizeHeader(header);
        if (header) {
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $866cce54f6bdfb0c$var$parseTokens(value);
                if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    }
    has(header, matcher) {
        header = $866cce54f6bdfb0c$var$normalizeHeader(header);
        if (header) {
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $866cce54f6bdfb0c$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $866cce54f6bdfb0c$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $866cce54f6bdfb0c$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(value) ? value.join(', ') : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ': ' + value).join('\n');
    }
    get [Symbol.toStringTag]() {
        return 'AxiosHeaders';
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$866cce54f6bdfb0c$var$$internals] = this[$866cce54f6bdfb0c$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $866cce54f6bdfb0c$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$866cce54f6bdfb0c$var$AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).reduceDescriptors($866cce54f6bdfb0c$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).freezeMethods($866cce54f6bdfb0c$var$AxiosHeaders);
var $866cce54f6bdfb0c$export$2e2bcd8739ae039 = $866cce54f6bdfb0c$var$AxiosHeaders;


'use strict';
function $5cf10c777cce5f4f$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $843bf0209bc94df8$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


'use strict';
function $5a60afef8b0dd173$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}





'use strict';
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $9fd0919e266b4fda$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).call(this, message == null ? 'canceled' : message, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
    this.name = 'CanceledError';
}
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).inherits($9fd0919e266b4fda$var$CanceledError, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039), {
    __CANCEL__: true
});
var $9fd0919e266b4fda$export$2e2bcd8739ae039 = $9fd0919e266b4fda$var$CanceledError;







'use strict';
function $ecb62d5372993dcf$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Request failed with status code ' + response.status, [
        (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_REQUEST,
        (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}





'use strict';
function $23607f53e4fda918$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || '';
}




'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $4a9d49cd0e6b8acc$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $4a9d49cd0e6b8acc$export$2e2bcd8739ae039 = $4a9d49cd0e6b8acc$var$speedometer;


/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $9b3ced92bc7bdc99$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn.apply(null, args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $9b3ced92bc7bdc99$export$2e2bcd8739ae039 = $9b3ced92bc7bdc99$var$throttle;



const $1a6c80b567b74091$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $4a9d49cd0e6b8acc$export$2e2bcd8739ae039)(50, 250);
    return (0, $9b3ced92bc7bdc99$export$2e2bcd8739ae039)((e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? 'download' : 'upload']: true
        };
        listener(data);
    }, freq);
};
const $1a6c80b567b74091$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $1a6c80b567b74091$export$5d35863c355a22a9 = (fn)=>(...args)=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).asap(()=>fn(...args));





var $5eb63b558e1fb85a$export$2e2bcd8739ae039 = (0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $bb8180acb278e187$export$2e2bcd8739ae039).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $bb8180acb278e187$export$2e2bcd8739ae039).origin), (0, $bb8180acb278e187$export$2e2bcd8739ae039).navigator && /(msie|trident)/i.test((0, $bb8180acb278e187$export$2e2bcd8739ae039).navigator.userAgent)) : ()=>true;




var $65cc14c0704b5541$export$2e2bcd8739ae039 = (0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure) {
        const cookie = [
            name + '=' + encodeURIComponent(value)
        ];
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isNumber(expires) && cookie.push('expires=' + new Date(expires).toGMTString());
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(path) && cookie.push('path=' + path);
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(domain) && cookie.push('domain=' + domain);
        secure === true && cookie.push('secure');
        document.cookie = cookie.join('; ');
    },
    read (name) {
        const match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return match ? decodeURIComponent(match[3]) : null;
    },
    remove (name) {
        this.write(name, '', Date.now() - 86400000);
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};


'use strict';
function $8fa91c1a59edb5d9$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


'use strict';
function $b63e12c1e0b9e0be$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
}


'use strict';
function $598acbfafd2c63c5$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls) {
    let isRelativeUrl = !(0, $8fa91c1a59edb5d9$export$2e2bcd8739ae039)(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls == false)) return (0, $b63e12c1e0b9e0be$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}




'use strict';
const $f85fda54cd977b19$var$headersToObject = (thing)=>thing instanceof (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039) ? {
        ...thing
    } : thing;
function $f85fda54cd977b19$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(target) && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($f85fda54cd977b19$var$headersToObject(a), $f85fda54cd977b19$var$headersToObject(b), prop, true)
    };
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}




var $ab4625fac3104691$export$2e2bcd8739ae039 = (config)=>{
    const newConfig = (0, $f85fda54cd977b19$export$2e2bcd8739ae039)({}, config);
    let { data: data, withXSRFToken: withXSRFToken, xsrfHeaderName: xsrfHeaderName, xsrfCookieName: xsrfCookieName, headers: headers, auth: auth } = newConfig;
    newConfig.headers = headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(headers);
    newConfig.url = (0, $8df8fedf1c1e4428$export$2e2bcd8739ae039)((0, $598acbfafd2c63c5$export$2e2bcd8739ae039)(newConfig.baseURL, newConfig.url, newConfig.allowAbsoluteUrls), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set('Authorization', 'Basic ' + btoa((auth.username || '') + ':' + (auth.password ? unescape(encodeURIComponent(auth.password)) : '')));
    let contentType;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(data)) {
        if ((0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // Let the browser set it
        else if ((contentType = headers.getContentType()) !== false) {
            // fix semicolon duplication issue for ReactNative FormData implementation
            const [type, ...tokens] = contentType ? contentType.split(';').map((token)=>token.trim()).filter(Boolean) : [];
            headers.setContentType([
                type || 'multipart/form-data',
                ...tokens
            ].join('; '));
        }
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
        withXSRFToken && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
        if (withXSRFToken || withXSRFToken !== false && (0, $5eb63b558e1fb85a$export$2e2bcd8739ae039)(newConfig.url)) {
            // Add xsrf header
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $65cc14c0704b5541$export$2e2bcd8739ae039).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};


const $79f0a48d5eb7919b$var$isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
var $79f0a48d5eb7919b$export$2e2bcd8739ae039 = $79f0a48d5eb7919b$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $ab4625fac3104691$export$2e2bcd8739ae039)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $ecb62d5372993dcf$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Request aborted', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Network Error', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            const transitional = _config.transitional || (0, $51466d41a76e5b4b$export$2e2bcd8739ae039);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ETIMEDOUT : (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $1a6c80b567b74091$export$c1b28109d46c3592)(onDownloadProgress, true);
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $1a6c80b567b74091$export$c1b28109d46c3592)(onUploadProgress);
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        const protocol = (0, $23607f53e4fda918$export$2e2bcd8739ae039)(_config.url);
        if (protocol && (0, $bb8180acb278e187$export$2e2bcd8739ae039).protocols.indexOf(protocol) === -1) {
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Unsupported protocol ' + protocol + ':', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};








const $a052b9a6636aacdc$var$composeSignals = (signals, timeout)=>{
    const { length: length } = signals = signals ? signals.filter(Boolean) : [];
    if (timeout || length) {
        let controller = new AbortController();
        let aborted;
        const onabort = function(reason) {
            if (!aborted) {
                aborted = true;
                unsubscribe();
                const err = reason instanceof Error ? reason : this.reason;
                controller.abort(err instanceof (0, $4e2395edb77acf3a$export$2e2bcd8739ae039) ? err : new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(err instanceof Error ? err.message : err));
            }
        };
        let timer = timeout && setTimeout(()=>{
            timer = null;
            onabort(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`timeout ${timeout} of ms exceeded`, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ETIMEDOUT));
        }, timeout);
        const unsubscribe = ()=>{
            if (signals) {
                timer && clearTimeout(timer);
                timer = null;
                signals.forEach((signal)=>{
                    signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
                });
                signals = null;
            }
        };
        signals.forEach((signal)=>signal.addEventListener('abort', onabort));
        const { signal: signal } = controller;
        signal.unsubscribe = ()=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).asap(unsubscribe);
        return signal;
    }
};
var $a052b9a6636aacdc$export$2e2bcd8739ae039 = $a052b9a6636aacdc$var$composeSignals;


const $c9465135abb26626$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $c9465135abb26626$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $c9465135abb26626$var$readStream(iterable))yield* $c9465135abb26626$export$71b051935044bd5d(chunk, chunkSize);
};
const $c9465135abb26626$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $c9465135abb26626$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $c9465135abb26626$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};






const $e52be20a9fc15e96$var$isFetchSupported = typeof fetch === 'function' && typeof Request === 'function' && typeof Response === 'function';
const $e52be20a9fc15e96$var$isReadableStreamSupported = $e52be20a9fc15e96$var$isFetchSupported && typeof ReadableStream === 'function';
// used only inside the fetch adapter
const $e52be20a9fc15e96$var$encodeText = $e52be20a9fc15e96$var$isFetchSupported && (typeof TextEncoder === 'function' ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Response(str).arrayBuffer()));
const $e52be20a9fc15e96$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $e52be20a9fc15e96$var$supportsRequestStream = $e52be20a9fc15e96$var$isReadableStreamSupported && $e52be20a9fc15e96$var$test(()=>{
    let duplexAccessed = false;
    const hasContentType = new Request((0, $bb8180acb278e187$export$2e2bcd8739ae039).origin, {
        body: new ReadableStream(),
        method: 'POST',
        get duplex () {
            duplexAccessed = true;
            return 'half';
        }
    }).headers.has('Content-Type');
    return duplexAccessed && !hasContentType;
});
const $e52be20a9fc15e96$var$DEFAULT_CHUNK_SIZE = 65536;
const $e52be20a9fc15e96$var$supportsResponseStream = $e52be20a9fc15e96$var$isReadableStreamSupported && $e52be20a9fc15e96$var$test(()=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReadableStream(new Response('').body));
const $e52be20a9fc15e96$var$resolvers = {
    stream: $e52be20a9fc15e96$var$supportsResponseStream && ((res)=>res.body)
};
$e52be20a9fc15e96$var$isFetchSupported && ((res)=>{
    [
        'text',
        'arrayBuffer',
        'blob',
        'formData',
        'stream'
    ].forEach((type)=>{
        !$e52be20a9fc15e96$var$resolvers[type] && ($e52be20a9fc15e96$var$resolvers[type] = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(res[type]) ? (res)=>res[type]() : (_, config)=>{
            throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`Response type '${type}' is not supported`, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config);
        });
    });
})(new Response);
const $e52be20a9fc15e96$var$getBodyLength = async (body)=>{
    if (body == null) return 0;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBlob(body)) return body.size;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isSpecCompliantForm(body)) {
        const _request = new Request((0, $bb8180acb278e187$export$2e2bcd8739ae039).origin, {
            method: 'POST',
            body: body
        });
        return (await _request.arrayBuffer()).byteLength;
    }
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBufferView(body) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBuffer(body)) return body.byteLength;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isURLSearchParams(body)) body = body + '';
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(body)) return (await $e52be20a9fc15e96$var$encodeText(body)).byteLength;
};
const $e52be20a9fc15e96$var$resolveBodyLength = async (headers, body)=>{
    const length = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFiniteNumber(headers.getContentLength());
    return length == null ? $e52be20a9fc15e96$var$getBodyLength(body) : length;
};
var $e52be20a9fc15e96$export$2e2bcd8739ae039 = $e52be20a9fc15e96$var$isFetchSupported && (async (config)=>{
    let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = 'same-origin', fetchOptions: fetchOptions } = (0, $ab4625fac3104691$export$2e2bcd8739ae039)(config);
    responseType = responseType ? (responseType + '').toLowerCase() : 'text';
    let composedSignal = (0, $a052b9a6636aacdc$export$2e2bcd8739ae039)([
        signal,
        cancelToken && cancelToken.toAbortSignal()
    ], timeout);
    let request;
    const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
        composedSignal.unsubscribe();
    });
    let requestContentLength;
    try {
        if (onUploadProgress && $e52be20a9fc15e96$var$supportsRequestStream && method !== 'get' && method !== 'head' && (requestContentLength = await $e52be20a9fc15e96$var$resolveBodyLength(headers, data)) !== 0) {
            let _request = new Request(url, {
                method: 'POST',
                body: data,
                duplex: "half"
            });
            let contentTypeHeader;
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
            if (_request.body) {
                const [onProgress, flush] = (0, $1a6c80b567b74091$export$d9fadd12586c18d6)(requestContentLength, (0, $1a6c80b567b74091$export$c1b28109d46c3592)((0, $1a6c80b567b74091$export$5d35863c355a22a9)(onUploadProgress)));
                data = (0, $c9465135abb26626$export$b0119225647bd83)(_request.body, $e52be20a9fc15e96$var$DEFAULT_CHUNK_SIZE, onProgress, flush);
            }
        }
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
        // Cloudflare Workers throws when credentials are defined
        // see https://github.com/cloudflare/workerd/issues/902
        const isCredentialsSupported = "credentials" in Request.prototype;
        request = new Request(url, {
            ...fetchOptions,
            signal: composedSignal,
            method: method.toUpperCase(),
            headers: headers.normalize().toJSON(),
            body: data,
            duplex: "half",
            credentials: isCredentialsSupported ? withCredentials : undefined
        });
        let response = await fetch(request);
        const isStreamResponse = $e52be20a9fc15e96$var$supportsResponseStream && (responseType === 'stream' || responseType === 'response');
        if ($e52be20a9fc15e96$var$supportsResponseStream && (onDownloadProgress || isStreamResponse && unsubscribe)) {
            const options = {};
            [
                'status',
                'statusText',
                'headers'
            ].forEach((prop)=>{
                options[prop] = response[prop];
            });
            const responseContentLength = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFiniteNumber(response.headers.get('content-length'));
            const [onProgress, flush] = onDownloadProgress && (0, $1a6c80b567b74091$export$d9fadd12586c18d6)(responseContentLength, (0, $1a6c80b567b74091$export$c1b28109d46c3592)((0, $1a6c80b567b74091$export$5d35863c355a22a9)(onDownloadProgress), true)) || [];
            response = new Response((0, $c9465135abb26626$export$b0119225647bd83)(response.body, $e52be20a9fc15e96$var$DEFAULT_CHUNK_SIZE, onProgress, ()=>{
                flush && flush();
                unsubscribe && unsubscribe();
            }), options);
        }
        responseType = responseType || 'text';
        let responseData = await $e52be20a9fc15e96$var$resolvers[(0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey($e52be20a9fc15e96$var$resolvers, responseType) || 'text'](response, config);
        !isStreamResponse && unsubscribe && unsubscribe();
        return await new Promise((resolve, reject)=>{
            (0, $ecb62d5372993dcf$export$2e2bcd8739ae039)(resolve, reject, {
                data: responseData,
                headers: (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(response.headers),
                status: response.status,
                statusText: response.statusText,
                config: config,
                request: request
            });
        });
    } catch (err) {
        unsubscribe && unsubscribe();
        if (err && err.name === 'TypeError' && /fetch/i.test(err.message)) throw Object.assign(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Network Error', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_NETWORK, config, request), {
            cause: err.cause || err
        });
        throw (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).from(err, err && err.code, config, request);
    }
});



const $e8c8c7960873e9ee$var$knownAdapters = {
    http: (0, $4023ac50ad132196$export$2e2bcd8739ae039),
    xhr: (0, $79f0a48d5eb7919b$export$2e2bcd8739ae039),
    fetch: (0, $e52be20a9fc15e96$export$2e2bcd8739ae039)
};
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach($e8c8c7960873e9ee$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, 'name', {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            value: value
        });
    }
});
const $e8c8c7960873e9ee$var$renderReason = (reason)=>`- ${reason}`;
const $e8c8c7960873e9ee$var$isResolvedHandle = (adapter)=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
var $e8c8c7960873e9ee$export$2e2bcd8739ae039 = {
    getAdapter: (adapters)=>{
        adapters = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length: length } = adapters;
        let nameOrAdapter;
        let adapter;
        const rejectedReasons = {};
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            let id;
            adapter = nameOrAdapter;
            if (!$e8c8c7960873e9ee$var$isResolvedHandle(nameOrAdapter)) {
                adapter = $e8c8c7960873e9ee$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
            }
            if (adapter) break;
            rejectedReasons[id || '#' + i] = adapter;
        }
        if (!adapter) {
            const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
            let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map($e8c8c7960873e9ee$var$renderReason).join('\n') : ' ' + $e8c8c7960873e9ee$var$renderReason(reasons[0]) : 'as no adapter specified';
            throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, 'ERR_NOT_SUPPORT');
        }
        return adapter;
    },
    adapters: $e8c8c7960873e9ee$var$knownAdapters
};


'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $9b8d10189805ccc0$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(null, config);
}
function $9b8d10189805ccc0$export$2e2bcd8739ae039(config) {
    $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
    config.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $5cf10c777cce5f4f$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    const adapter = (0, $e8c8c7960873e9ee$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $843bf0209bc94df8$export$2e2bcd8739ae039).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $5cf10c777cce5f4f$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        response.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $5a60afef8b0dd173$export$2e2bcd8739ae039)(reason)) {
            $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $5cf10c777cce5f4f$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}




const $23ff3f1a5c7912d5$export$a4ad2735b021c132 = "1.8.4";



'use strict';
const $85f59389941e7907$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach((type, i)=>{
    $85f59389941e7907$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
const $85f59389941e7907$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $85f59389941e7907$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, $23ff3f1a5c7912d5$export$a4ad2735b021c132) + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$85f59389941e7907$var$deprecatedWarnings[opt]) {
            $85f59389941e7907$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$85f59389941e7907$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $85f59389941e7907$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object') throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('options must be an object', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('option ' + opt + ' must be ' + result, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Unknown option ' + opt, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $85f59389941e7907$export$2e2bcd8739ae039 = {
    assertOptions: $85f59389941e7907$var$assertOptions,
    validators: $85f59389941e7907$var$validators
};



'use strict';
const $a93486d2307f31c3$var$validators = (0, $85f59389941e7907$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $a93486d2307f31c3$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig;
        this.interceptors = {
            request: new (0, $5de878cd737ef277$export$2e2bcd8739ae039)(),
            response: new (0, $5de878cd737ef277$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, '') : '';
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ''))) err.stack += '\n' + stack;
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $f85fda54cd977b19$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $85f59389941e7907$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            forcedJSONParsing: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            clarifyTimeoutError: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $85f59389941e7907$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $a93486d2307f31c3$var$validators.function,
                serialize: $a93486d2307f31c3$var$validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, $85f59389941e7907$export$2e2bcd8739ae039).assertOptions(config, {
            baseUrl: $a93486d2307f31c3$var$validators.spelling('baseURL'),
            withXsrfToken: $a93486d2307f31c3$var$validators.spelling('withXSRFToken')
        }, true);
        // Set config.method
        config.method = (config.method || this.defaults.method || 'get').toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
            'delete',
            'get',
            'head',
            'post',
            'put',
            'patch',
            'common'
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $9b8d10189805ccc0$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $9b8d10189805ccc0$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $f85fda54cd977b19$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $598acbfafd2c63c5$export$2e2bcd8739ae039)(config.baseURL, config.url, config.allowAbsoluteUrls);
        return (0, $8df8fedf1c1e4428$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $a93486d2307f31c3$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $f85fda54cd977b19$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $f85fda54cd977b19$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $a93486d2307f31c3$var$Axios.prototype[method] = generateHTTPMethod();
    $a93486d2307f31c3$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
var $a93486d2307f31c3$export$2e2bcd8739ae039 = $a93486d2307f31c3$var$Axios;







'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $fb81495929d8a282$var$CancelToken {
    constructor(executor){
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $fb81495929d8a282$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $fb81495929d8a282$export$2e2bcd8739ae039 = $fb81495929d8a282$var$CancelToken;






'use strict';
function $089369673aa7c1c3$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



'use strict';
function $9db8da59db12cd94$export$2e2bcd8739ae039(payload) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $f919374d785e9fb8$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($f919374d785e9fb8$var$HttpStatusCode).forEach(([key, value])=>{
    $f919374d785e9fb8$var$HttpStatusCode[value] = key;
});
var $f919374d785e9fb8$export$2e2bcd8739ae039 = $f919374d785e9fb8$var$HttpStatusCode;


'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $57966c7e0affc4cb$var$createInstance(defaultConfig) {
    const context = new (0, $a93486d2307f31c3$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $e5cb5cefd6507f7e$export$2e2bcd8739ae039)((0, $a93486d2307f31c3$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).extend(instance, (0, $a93486d2307f31c3$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $57966c7e0affc4cb$var$createInstance((0, $f85fda54cd977b19$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $57966c7e0affc4cb$var$axios = $57966c7e0affc4cb$var$createInstance((0, $843bf0209bc94df8$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$57966c7e0affc4cb$var$axios.Axios = (0, $a93486d2307f31c3$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$57966c7e0affc4cb$var$axios.CanceledError = (0, $9fd0919e266b4fda$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.CancelToken = (0, $fb81495929d8a282$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.isCancel = (0, $5a60afef8b0dd173$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.VERSION = (0, $23ff3f1a5c7912d5$export$a4ad2735b021c132);
$57966c7e0affc4cb$var$axios.toFormData = (0, $e6cbd383b18c9625$export$2e2bcd8739ae039);
// Expose AxiosError class
$57966c7e0affc4cb$var$axios.AxiosError = (0, $4e2395edb77acf3a$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$57966c7e0affc4cb$var$axios.Cancel = $57966c7e0affc4cb$var$axios.CanceledError;
// Expose all/spread
$57966c7e0affc4cb$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$57966c7e0affc4cb$var$axios.spread = (0, $089369673aa7c1c3$export$2e2bcd8739ae039);
// Expose isAxiosError
$57966c7e0affc4cb$var$axios.isAxiosError = (0, $9db8da59db12cd94$export$2e2bcd8739ae039);
// Expose mergeConfig
$57966c7e0affc4cb$var$axios.mergeConfig = (0, $f85fda54cd977b19$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.AxiosHeaders = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.formToJSON = (thing)=>(0, $5f8142930b3b943f$export$2e2bcd8739ae039)((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$57966c7e0affc4cb$var$axios.getAdapter = (0, $e8c8c7960873e9ee$export$2e2bcd8739ae039).getAdapter;
$57966c7e0affc4cb$var$axios.HttpStatusCode = (0, $f919374d785e9fb8$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.default = $57966c7e0affc4cb$var$axios;
var // this module should only have a default export
$57966c7e0affc4cb$export$2e2bcd8739ae039 = $57966c7e0affc4cb$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $b302555736d21bd7$export$1c00760e9e5a4e95, AxiosError: $b302555736d21bd7$export$c1fbed17c2f6a328, CanceledError: $b302555736d21bd7$export$1ab0c6b20d94fa14, isCancel: $b302555736d21bd7$export$3b22524397b493c6, CancelToken: $b302555736d21bd7$export$fd08e3cb425f0d61, VERSION: $b302555736d21bd7$export$a4ad2735b021c132, all: $b302555736d21bd7$export$84bf76cd7afc7469, Cancel: $b302555736d21bd7$export$848c9b7ead0df967, isAxiosError: $b302555736d21bd7$export$fbafdbe06a5b5a9a, spread: $b302555736d21bd7$export$3ae0fd4797ed47c8, toFormData: $b302555736d21bd7$export$10ae0d317ea97f8b, AxiosHeaders: $b302555736d21bd7$export$4e7d6ff0f3e6520, HttpStatusCode: $b302555736d21bd7$export$a972f69c851492b3, formToJSON: $b302555736d21bd7$export$86d7c59254d6a2c9, getAdapter: $b302555736d21bd7$export$17ddc20a97d669e2, mergeConfig: $b302555736d21bd7$export$7ec1ebcfa9d8bd6a } = (0, $57966c7e0affc4cb$export$2e2bcd8739ae039);



var $45fvw = parcelRequire("45fvw");
/**
 * About:
 * BaseManager
 * 
 * Description:
 * Abstract base class that all other Managers extends.
 */ class $8a2666592e7029ee$export$84777416d052f822 {
    static async initAsync(options = {}) {
        throw new Error('Abstract base class');
    }
    static setMap(map) {
        throw new Error('Abstract base method');
    }
    static getName() {
        throw new Error('Abstract base method');
    }
}


const $b9b5c0363f244088$var$FILENAME = 'log-manager.js';
const $b9b5c0363f244088$var$Config = Object.freeze({
    logging: {
        logToConsole: false
    },
    timeFormat: Object.freeze({
        pretty: 'YYYY-MM-DD HH:mm:ss:SSS',
        gmt: 'YYYY-MM-DDTHH:mm:ssZ:SSS'
    })
});
/**
 * About:
 * LogManager
 * 
 * Description:
 * Manages all Debug-, Information-, Warning-, Error- and Fatal log messages. 
 * Can handle both simple string messages and complex JSON objects.
 * 
 * Note:
 * To avoid circular dependencies, the LogManager cannot fetch settings from the ConfigManager.
 * Unfortunately this also means that this local Config-object cannot be changed by the user.
 */ class $b9b5c0363f244088$export$49b118289be48034 extends (0, $8a2666592e7029ee$export$84777416d052f822) {
    static #log = [];
    static #levels = Object.freeze({
        debug: {
            value: 1,
            name: 'Debug',
            visible: false,
            color: '#00385B',
            backgroundColor: '#F0F6FF',
            borderColor: '#D7E3FA',
            method: window.console.debug
        },
        information: {
            value: 2,
            name: 'Information',
            visible: true,
            color: '#212529',
            backgroundColor: '#F3F4F5',
            borderColor: '#D3D9E6',
            method: window.console.info
        },
        warning: {
            value: 3,
            name: 'Warning',
            visible: true,
            color: '#493B10',
            backgroundColor: '#FFF8E1',
            borderColor: '#FAE59D',
            method: window.console.warn
        },
        error: {
            value: 4,
            name: 'Error',
            visible: true,
            color: '#8D2120',
            backgroundColor: '#FFE6E6',
            borderColor: '#FDB5B4',
            method: window.console.error
        },
        fatal: {
            value: 5,
            name: 'Fatal',
            visible: true,
            color: '#212529',
            backgroundColor: '#E8E6FF',
            borderColor: '#D0CAFF',
            method: window.console.error
        }
    });
    //--------------------------------------------------------------------
    // # Section: Base Overrides
    //--------------------------------------------------------------------
    static async initAsync(options = {}) {
        $b9b5c0363f244088$export$49b118289be48034.logDebug($b9b5c0363f244088$var$FILENAME, 'initAsync', 'Initialization started');
        return new Promise((resolve)=>{
            resolve({
                filename: $b9b5c0363f244088$var$FILENAME,
                result: true
            });
        });
    }
    static setMap(map) {}
    static getName() {
        return $b9b5c0363f244088$var$FILENAME;
    }
    //--------------------------------------------------------------------
    // # Section: Internal
    //--------------------------------------------------------------------
    static #logToConsole(level, origin, method, value, formattedTimestamp) {
        level.method(origin, method, value, formattedTimestamp);
    }
    static #logSink(level, origin, method, value) {
        const timeFormat = $b9b5c0363f244088$var$Config.timeFormat.pretty;
        const logToConsole = $b9b5c0363f244088$var$Config.logging.logToConsole;
        const timestamp = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))();
        const formattedTimestamp = timestamp.format(timeFormat);
        const entry = {
            timestamp: formattedTimestamp,
            level: level,
            origin: origin,
            method: method,
            value: value
        };
        this.#log.push(entry);
        if (logToConsole) this.#logToConsole(level, origin, method, value, formattedTimestamp);
        return entry;
    }
    //--------------------------------------------------------------------
    // # Section: Public API
    //--------------------------------------------------------------------
    static setLogToConsole(value) {
        $b9b5c0363f244088$var$Config.logging.logToConsole = value;
    }
    static getSize() {
        return this.#log.length || 0;
    }
    static getLog() {
        return this.#log;
    }
    static clearLog() {
        this.#log = [];
    }
    static getLogLevels() {
        return this.#levels;
    }
    static logDebug(origin, method, value) {
        return this.#logSink(this.#levels.debug, origin, method, value);
    }
    static logInformation(origin, method, value) {
        return this.#logSink(this.#levels.information, origin, method, value);
    }
    static logWarning(origin, method, value) {
        return this.#logSink(this.#levels.warning, origin, method, value);
    }
    static logError(origin, method, value) {
        return this.#logSink(this.#levels.error, origin, method, value);
    }
    static logFatal(origin, method, value) {
        return this.#logSink(this.#levels.fatal, origin, method, value);
    }
}




var $8f13b60c0ee5b277$exports = {};
$8f13b60c0ee5b277$exports = JSON.parse("{\"name\":\"oltb\",\"version\":\"3.5.0\",\"author\":\"Qulle\",\"license\":\"BSD-2-Clause license\",\"description\":\"OLTB is a portable mobile friendly GIS toolbar developed for OpenLayers 10.6.1\",\"keywords\":[\"gis\",\"map\",\"web-gis\",\"toolbar\",\"openlayers\"],\"repository\":{\"type\":\"git\",\"url\":\"git+https://github.com/qulle/oltb.git\"},\"homepage\":\"https://github.com/qulle/oltb#readme\",\"bugs\":{\"url\":\"https://github.com/qulle/oltb/issues\"},\"scripts\":{\"start\":\"parcel serve ./dev/index.html --open --dist-dir ./serve\",\"eslint:src\":\"eslint --config ./config/.eslintrc.mjs ./src/oltb/js/**/*.js\",\"eslint:src-fix\":\"eslint --fix --config ./config/.eslintrc.mjs ./src/oltb/js/**/*.js\",\"eslint:dev\":\"eslint --config ./config/.eslintrc.mjs ./dev/**/*.js\",\"eslint:dev-fix\":\"eslint --fix --config ./config/.eslintrc.mjs ./dev/**/*.js\",\"test\":\"cross-env NODE_OPTIONS=--experimental-vm-modules NODE_NO_WARNINGS=1 jest ./src --config ./config/jest.config.mjs\",\"test:watch\":\"cross-env NODE_OPTIONS=--experimental-vm-modules NODE_NO_WARNINGS=1 jest ./src --watch --config ./config/jest.config.mjs\",\"test:coverage\":\"cross-env NODE_OPTIONS=--experimental-vm-modules NODE_NO_WARNINGS=1 jest ./src --coverage --config ./config/jest.config.mjs\",\"test:clear\":\"jest --clearCache\",\"build\":\"npm run build:demo && npm run build:lib\",\"build:lib\":\"rollup --config ./config/rollup.config.mjs\",\"build:demo\":\"parcel build --public-url . ./dev/index.html --dist-dir ./demo\",\"example:cdn:1\":\"sh -c 'start firefox -url \\\"file://C:$(cut -c3- <<< $(readlink -m ./examples/cdn/example-1/index.html))\\\"'\",\"example:npm:1\":\"parcel serve ./examples/npm/example-1/index.html --open --dist-dir ./serve\",\"example:npm:2\":\"parcel serve ./examples/npm/example-2/index.html --open --dist-dir ./serve\",\"example:npm:3\":\"npm --prefix ./examples/npm/example-3-angular start\",\"example:npm:4\":\"npm --prefix ./examples/npm/example-4-react run dev\",\"clean\":\"rm -rf ./serve ./dist ./demo ./.parcel-cache\",\"install-husky\":\"npx husky install\",\"configure-husky\":\"npx husky install && npx husky add .husky/pre-commit \\\"npx lint-staged\\\"\"},\"lint-staged\":{\"./src/oltb/js/**/*.js\":[\"eslint --config ./config/.eslintrc.mjs\"],\"./dev/**/*.js\":[\"eslint --config ./config/.eslintrc.mjs\"]},\"files\":[\"dist\"],\"type\":\"module\",\"dependencies\":{\"a-color-picker\":\"^1.2.1\",\"axios\":\"^1.8.4\",\"browser-dtector\":\"^4.1.0\",\"html2canvas\":\"^1.4.1\",\"jsts\":\"^2.12.1\",\"lodash\":\"^4.17.21\",\"many-keys-map\":\"^2.0.1\",\"moment\":\"^2.30.1\",\"ol\":\"^10.6.1\",\"proj4\":\"^2.15.0\",\"screenfull\":\"^6.0.2\",\"sortablejs\":\"^1.15.6\",\"tippy.js\":\"^6.3.7\",\"uuid\":\"^11.1.0\"},\"devDependencies\":{\"@eslint/js\":\"^9.2.0\",\"@parcel/transformer-sass\":\"^2.14.4\",\"@rollup/plugin-commonjs\":\"^28.0.3\",\"@rollup/plugin-json\":\"^6.1.0\",\"@rollup/plugin-node-resolve\":\"^16.0.1\",\"@rollup/plugin-replace\":\"^6.0.2\",\"@rollup/plugin-terser\":\"^0.4.4\",\"buffer\":\"^6.0.3\",\"cross-env\":\"^7.0.3\",\"eslint\":\"^9.24.0\",\"husky\":\"^9.1.7\",\"identity-obj-proxy\":\"^3.0.0\",\"jest\":\"^29.7.0\",\"jest-environment-jsdom\":\"^29.7.0\",\"lint-staged\":\"^15.5.0\",\"parcel\":\"^2.14.4\",\"process\":\"^0.11.10\",\"rollup\":\"^4.39.0\",\"rollup-plugin-license\":\"^3.6.0\",\"rollup-plugin-scss\":\"^4.0.1\"}}");


// Note: 
// All config can be overridden by defining a custom config.json file. 
// That file is requested during the initAsync process by the ConfigManager.
const $0a57fad3299da03c$export$ac4f8128ea29c5 = Object.freeze({
    timeFormat: Object.freeze({
        pretty: 'YYYY-MM-DD HH:mm:ss:SSS',
        gmt: 'YYYY-MM-DDTHH:mm:ssZ:SSS'
    }),
    localization: Object.freeze({
        active: 'en-us',
        languages: Object.freeze([
            'en-us',
            'sv-se'
        ])
    }),
    location: Object.freeze({
        default: Object.freeze({
            lon: 18.1201,
            lat: 35.3518,
            zoom: 3,
            rotation: 0
        })
    }),
    className: Object.freeze({
        row: 'oltb-row',
        dark: 'oltb-dark'
    }),
    openLayers: Object.freeze({
        version: (0, $6c5e11070e371322$export$a4ad2735b021c132),
        id: 'map'
    }),
    toolbar: Object.freeze({
        version: $8f13b60c0ee5b277$exports.version,
        id: 'oltb'
    }),
    urlParameter: Object.freeze({
        debug: 'oltb-debug',
        marker: 'oltb-marker'
    }),
    marker: Object.freeze({
        focusZoom: 6,
        label: {
            shouldRender: true,
            visibleUnderResolution: 5000
        },
        pulseAnimation: {
            isEnabled: true,
            duration: 2000,
            shouldLoop: true,
            strokeWidth: 1,
            defaultStartSize: 0,
            defaultEndSize: 14,
            defaultColor: '#3B4352FF'
        }
    }),
    scroll: Object.freeze({
        distance: 100
    }),
    browser: Object.freeze({
        rem: 16
    }),
    sessionStorage: Object.freeze({
        key: 'oltb'
    }),
    localStorage: Object.freeze({
        key: 'oltb'
    }),
    projection: Object.freeze({
        default: 'EPSG:3857',
        wgs84: 'EPSG:4326'
    }),
    overlayOffset: Object.freeze({
        horizontal: 0,
        vertical: -8
    }),
    tippy: Object.freeze({
        delay: [
            600,
            100
        ]
    }),
    deviceWidth: Object.freeze({
        xs: '0',
        sm: '576',
        md: '768',
        lg: '992',
        xl: '1200',
        xxl: '1400'
    }),
    autoRemovalDuation: Object.freeze({
        slow: 6000,
        normal: 4000,
        fast: 2000
    }),
    animationDuration: Object.freeze({
        slow: 450,
        normal: 350,
        fast: 250,
        warp: 150
    }),
    aColorPicker: Object.freeze({
        showPaletteAsDefault: true,
        palette: Object.freeze([
            '#F0F6FF',
            '#D7E3FA',
            '#6397C2',
            '#0166A5',
            '#00385B',
            '#E7EFFF',
            '#C7D9F8',
            '#5B88D6',
            '#2357B1',
            '#103677',
            '#E8E6FF',
            '#D0CAFF',
            '#9085E4',
            '#52489B',
            '#2E2769',
            '#FEEDFF',
            '#FEE6FF',
            '#E8A2EA',
            '#914594',
            '#59275A',
            '#DDFEFF',
            '#BCF8FA',
            '#56BABD',
            '#00959A',
            '#005255',
            '#DFFFFC',
            '#BCFAF4',
            '#3CAEA3',
            '#007C70',
            '#004942',
            '#E0F4FF',
            '#CEEEFF',
            '#68B9E5',
            '#0080C5',
            '#004367',
            '#FFF8E1',
            '#FBEAB2',
            '#FBDD83',
            '#FBBD02',
            '#493B10',
            '#FFEDDB',
            '#FFDDBC',
            '#FCBE80',
            '#F08741',
            '#6B310A',
            '#FFE6E6',
            '#FDB5B4',
            '#E96B69',
            '#D64B49',
            '#8D2120',
            '#F3F4F5',
            '#D3D9E6',
            '#959DAD',
            '#3B4352',
            '#212529',
            '#000000',
            '#FFFFFF' // White
        ])
    })
});


const $1e8c0ef90ed82280$var$FILENAME = 'config-manager.js';
const $1e8c0ef90ed82280$var$DefaultOptions = Object.freeze({
    url: './assets/config/config.json'
});
/**
 * About:
 * ConfigManager
 * 
 * Description:
 * Manages loading of dynamic runtime JSON config that is merged with the DefaultConfig above.
 */ class $1e8c0ef90ed82280$export$a33e119b2316dcb7 extends (0, $8a2666592e7029ee$export$84777416d052f822) {
    static #config;
    static #options;
    //--------------------------------------------------------------------
    // # Section: Base Overrides
    //--------------------------------------------------------------------
    static async initAsync(options = {}) {
        this.#options = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep($1e8c0ef90ed82280$var$DefaultOptions), options);
        (0, $b9b5c0363f244088$export$49b118289be48034).logDebug($1e8c0ef90ed82280$var$FILENAME, 'initAsync', 'Initialization started');
        return this.#loadConfigFileAsync(this.#options.url);
    }
    static setMap(map) {}
    static getName() {
        return $1e8c0ef90ed82280$var$FILENAME;
    }
    static getConfig() {
        // Note: 
        // In some edge cases (LogManager as example)
        // The Config is required before it has loaded, return the DefaultConfig
        return this.#config || (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep((0, $0a57fad3299da03c$export$ac4f8128ea29c5));
    }
    static clearConfig() {
        this.#config = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep((0, $0a57fad3299da03c$export$ac4f8128ea29c5));
    }
    //--------------------------------------------------------------------
    // # Section: Internal
    //--------------------------------------------------------------------
    static async #loadConfigFileAsync(url) {
        const timestamp = Date.now().toString();
        return (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).get(url, {
            responseType: 'application/json',
            params: {
                cache: timestamp
            },
            headers: {
                'Cache-Control': 'no-cache',
                'Pragma': 'no-cache',
                'Expires': '0'
            }
        }).then((response)=>{
            if (response.status !== 200) throw new Error('Bad response from server', {
                cause: response
            });
            return JSON.parse(response.data);
        }).then((config)=>{
            // Note: 
            // Use _.mergeWith and not _.merge to have merging of empty arrays behave as 'expected'
            // If a empty array is given in the custom config.json it will now replace the array in the default-object
            this.#config = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).mergeWith((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep((0, $0a57fad3299da03c$export$ac4f8128ea29c5)), config, (a, b)=>{
                if ((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).isArray(b)) return b;
                return undefined;
            });
            // Note:
            // First log the loaded config (the part that the user is overriding)
            // Second log the total runtime config result (default + user-overrided)
            (0, $b9b5c0363f244088$export$49b118289be48034).logInformation($1e8c0ef90ed82280$var$FILENAME, 'loadConfigFileAsync', (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep(config));
            (0, $b9b5c0363f244088$export$49b118289be48034).logInformation($1e8c0ef90ed82280$var$FILENAME, 'loadConfigFileAsync', (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep(this.#config));
            return Promise.resolve({
                filename: $1e8c0ef90ed82280$var$FILENAME,
                result: true
            });
        }).catch((error)=>{
            (0, $b9b5c0363f244088$export$49b118289be48034).logWarning($1e8c0ef90ed82280$var$FILENAME, 'loadConfigFileAsync', {
                message: 'Failed to load configurations from /assets/config/config.json directory',
                error: error
            });
            return Promise.resolve({
                filename: $1e8c0ef90ed82280$var$FILENAME,
                result: false
            });
        });
    }
}


class $e1b36be5f031477b$export$cb0933279c36a66b {
    static createElement(options = {}) {
        const element = window.document.createElement(options.element);
        const commonAttributes = {
            id: 'id',
            class: 'className',
            value: 'value',
            text: 'innerText',
            html: 'innerHTML',
            style: 'style',
            title: 'title'
        };
        // Note:
        // Common element attributes
        for (const [key, value] of Object.entries(commonAttributes)){
            const attribute = options[key];
            if (attribute) {
                if (key === 'style') // Note:
                // Style is given as object, parse and convert to single string
                element[value] = Object.entries(attribute).map(([k, v])=>{
                    return `${k}:${v}`;
                }).join(';');
                else if (typeof attribute === 'string') // Note:
                // Trimming the attribute will help in removing "white-space-css-bugs"
                // The formatting of a template string, trailing enter etc, can cause problems otherwise
                element[value] = attribute.trim();
                else element[value] = attribute;
            }
        }
        // Note:
        // Attributes that needs to be set using setAttribute
        for(const attribute in options.attributes)element.setAttribute(attribute, options.attributes[attribute]);
        for(const prototype in options.prototypes)element[prototype] = options.prototypes[prototype];
        for(const listener in options.listeners){
            const callbacks = options.listeners[listener];
            if (Array.isArray(callbacks)) callbacks.forEach((callback)=>{
                element.addEventListener(listener, callback);
            });
            else element.addEventListener(listener, callbacks);
        }
        return element;
    }
    static removeElements(elements = []) {
        elements.forEach((element)=>{
            this.removeElement(element);
        });
    }
    static removeElement(element) {
        element.remove();
    }
    static clearElements(elements = []) {
        elements.forEach((element)=>{
            this.clearElement(element);
        });
    }
    static clearText(element) {
        element.innerText = '';
    }
    static clearElement(element) {
        element.innerHTML = '';
    }
    static prependChildren(element, children = []) {
        children.forEach((child)=>{
            element.prepend(child);
        });
    }
    static appendChildren(element, children = []) {
        children.forEach((child)=>{
            element.appendChild(child);
        });
    }
    static runAnimation(element, className) {
        if (!element) return;
        // Note:
        // Trigger re-render of DOM between class toggle
        element.classList.remove(className);
        element.offsetWidth;
        element.classList.add(className);
        // Note: 
        // Config.animationDuration.fast matches the time given in _animations.scss
        // With the animation-class the html2canvas fails to render the exported PNG correctly
        const duration = (0, $1e8c0ef90ed82280$export$a33e119b2316dcb7).getConfig().animationDuration.fast;
        window.setTimeout(()=>{
            element.classList.remove(className);
        }, duration);
    }
    static flashClass(element, className) {
        element.classList.add(className);
        const duration = (0, $1e8c0ef90ed82280$export$a33e119b2316dcb7).getConfig().animationDuration.slow;
        window.setTimeout(()=>{
            element.classList.remove(className);
        }, duration);
    }
}


const $a9807b370eed025c$export$ada873a34909da65 = Object.freeze({
    browser: Object.freeze({
        change: 'change',
        click: 'click',
        contentLoaded: 'DOMContentLoaded',
        contextMenu: 'contextmenu',
        error: 'error',
        fullScreenChange: 'fullscreenchange',
        input: 'input',
        keyDown: 'keydown',
        keyUp: 'keyup',
        load: 'load',
        mouseDown: 'mousedown',
        mouseMove: 'mousemove',
        mouseOut: 'mouseout',
        resize: 'resize',
        wheel: 'wheel'
    }),
    openLayers: Object.freeze({
        add: 'add',
        boxCancel: 'boxcancel',
        boxDrag: 'boxdrag',
        boxEnd: 'boxend',
        boxStart: 'boxstart',
        change: 'change',
        drawAbort: 'drawabort',
        drawEnd: 'drawend',
        drawStart: 'drawstart',
        error: 'error',
        modifyEnd: 'modifyend',
        modifyStart: 'modifystart',
        moveEnd: 'moveend',
        pointerMove: 'pointermove',
        postRender: 'postrender',
        preRender: 'prerender',
        propertyChange: 'propertychange',
        remove: 'remove',
        renderComplete: 'rendercomplete',
        singleClick: 'singleclick',
        snap: 'snap',
        unSnap: 'unsnap',
        translateEnd: 'translateend',
        translateStart: 'translatestart'
    }),
    custom: Object.freeze({
        activeFeatureLayerChange: 'oltb.active.feature.layer.change',
        browserStateCleared: 'oltb.browser.state.cleared',
        colorChange: 'oltb.color.change',
        featureEdited: 'oltb.feature.edited',
        featureLayerAdded: 'oltb.featureLayer.added',
        featureLayerRemoved: 'oltb.featureLayer.removed',
        featureRemoved: 'oltb.feature.removed',
        mapLayerAdded: 'oltb.mapLayer.added',
        mapLayerRemoved: 'oltb.mapLayer.removed',
        ready: 'oltb.is.ready',
        toolbarDirectionChange: 'oltb.toolbar.direction.change'
    })
});








var $f1q41 = parcelRequire("f1q41");


const $ceccb931a11a5f0d$export$a8a17deeffd2032 = Object.freeze([
    'marker',
    'tooltip',
    'onChangeListener'
]);



const $c40ede3e491a5acd$var$FILENAME = 'state-manager.js';
/**
 * About:
 * StateManager
 * 
 * Description:
 * Manages the state that is stored in LocalStorage.
 * The state contains information about active tools, user selections, Map position and zoom etc.
 */ class $c40ede3e491a5acd$export$4d5c8163a511d38a extends (0, $8a2666592e7029ee$export$84777416d052f822) {
    static #ignoredKeys;
    static #runtimeState;
    //--------------------------------------------------------------------
    // # Section: Base Overrides
    //--------------------------------------------------------------------
    static async initAsync(options = {}) {
        (0, $b9b5c0363f244088$export$49b118289be48034).logDebug($c40ede3e491a5acd$var$FILENAME, 'initAsync', 'Initialization started');
        this.#ignoredKeys = this.#mergeIgnoredKeys(options);
        this.#runtimeState = this.#getBrowserData();
        return new Promise((resolve)=>{
            resolve({
                filename: $c40ede3e491a5acd$var$FILENAME,
                result: true
            });
        });
    }
    static setMap(map) {}
    static getName() {
        return $c40ede3e491a5acd$var$FILENAME;
    }
    //--------------------------------------------------------------------
    // # Section: Internal
    //--------------------------------------------------------------------
    static #mergeIgnoredKeys(options) {
        const ignoredKeys = Object.freeze([
            ...(0, $ceccb931a11a5f0d$export$a8a17deeffd2032),
            ...options?.ignoredKeys || []
        ]);
        (0, $b9b5c0363f244088$export$49b118289be48034).logDebug($c40ede3e491a5acd$var$FILENAME, 'getIgnoredKeys', ignoredKeys);
        return ignoredKeys;
    }
    static #getBrowserData() {
        (0, $b9b5c0363f244088$export$49b118289be48034).logDebug($c40ede3e491a5acd$var$FILENAME, 'getBrowserData', 'Loading stored state from browser');
        let state = {};
        try {
            const key = (0, $1e8c0ef90ed82280$export$a33e119b2316dcb7).getConfig().localStorage.key;
            state = JSON.parse(localStorage.getItem(key)) || {};
        } catch (error) {
            (0, $b9b5c0363f244088$export$49b118289be48034).logError($c40ede3e491a5acd$var$FILENAME, 'getBrowserData', {
                message: 'Failed to load application state',
                error: error
            });
        }
        (0, $b9b5c0363f244088$export$49b118289be48034).logDebug($c40ede3e491a5acd$var$FILENAME, 'getBrowserData', (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep(state));
        return state;
    }
    static #saveState() {
        try {
            const serialized = JSON.stringify(this.#runtimeState, (key, value)=>{
                if (this.#ignoredKeys.includes(key)) return undefined;
                return value;
            });
            const key = (0, $1e8c0ef90ed82280$export$a33e119b2316dcb7).getConfig().localStorage.key;
            localStorage.setItem(key, serialized);
        } catch (error) {
            (0, $b9b5c0363f244088$export$49b118289be48034).logError($c40ede3e491a5acd$var$FILENAME, 'saveState', {
                message: 'Failed to save application state',
                error: error
            });
        }
    }
    //--------------------------------------------------------------------
    // # Section: Public API
    //--------------------------------------------------------------------
    static loadRuntimeState() {
        this.#runtimeState = this.#getBrowserData();
    }
    static getIgnoredKeys() {
        return this.#ignoredKeys;
    }
    static setStateObject(name, value) {
        this.#runtimeState[name] = value;
        this.#saveState();
    }
    static getStateObject(name) {
        if (name in this.#runtimeState) return this.#runtimeState[name];
        return {};
    }
    static getAndMergeStateObject(name, defaultObject) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep(defaultObject), this.getStateObject(name));
    }
    static clear() {
        (0, $b9b5c0363f244088$export$49b118289be48034).logDebug($c40ede3e491a5acd$var$FILENAME, 'clear', {
            info: 'Clearing stored state from browser',
            state: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep(this.#runtimeState)
        });
        this.#runtimeState = this.#getBrowserData();
    }
}



// Note: 
// These properties are placed inside the oltb object in localStorage
// So the don't need to be prefixed with oltb
const $52e25f2a10ab5b5c$export$ada36e8a1c3bc83a = Object.freeze({
    bookmarkTool: 'bookmarkTool',
    coordinatesTool: 'coordinatesTool',
    directionTool: 'directionTool',
    drawTool: 'drawTool',
    editTool: 'editTool',
    graticuleTool: 'graticuleTool',
    homeTool: 'homeTool',
    layerTool: 'layerTool',
    magnifyTool: 'magnifyTool',
    mapData: 'mapData',
    measureTool: 'measureTool',
    overviewTool: 'overviewTool',
    scaleLineTool: 'scalelineTool',
    scissorsTool: 'scissorsTool',
    settingsManager: 'settingsManager',
    splitViewTool: 'splitviewTool',
    themeTool: 'themeTool',
    toolboxTool: 'toolboxTool',
    translationManager: 'translationManager',
    zoomboxTool: 'zoomboxTool'
});


const $8f42450ebdd44f5e$var$FILENAME = 'element-manager.js';
const $8f42450ebdd44f5e$var$CLASS__TOOLBOX_CONTAINER = 'oltb-toolbox-container';
const $8f42450ebdd44f5e$var$CLASS__SMOOTH_INIT = 'init-visible';
const $8f42450ebdd44f5e$var$DELAY__SMOOTH_INIT = 600;
/**
 * About:
 * ElementManager
 * 
 * Description:
 * Manages the global UI references to the Map-, Toast-, Toolbar- and Toolbox elements.
 */ class $8f42450ebdd44f5e$export$8e7188a60a5bbe16 extends (0, $8a2666592e7029ee$export$84777416d052f822) {
    static #uiRefMapElement;
    static #uiRefToastElement;
    static #uiRefToolbarElement;
    static #uiRefToolboxElement;
    //--------------------------------------------------------------------
    // # Section: Base Overrides
    //--------------------------------------------------------------------
    static async initAsync(options = {}) {
        (0, $b9b5c0363f244088$export$49b118289be48034).logDebug($8f42450ebdd44f5e$var$FILENAME, 'initAsync', 'Initialization started');
        this.#uiRefMapElement = this.#createMapElement();
        this.#uiRefToastElement = this.#createToastElement();
        this.#uiRefToolbarElement = this.#createToolbarElement();
        this.#uiRefToolboxElement = this.#createToolboxElement();
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.load, this.#onInitSmoothInterface.bind(this));
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.resize, this.#onCollisionDetection.bind(this));
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.ready, this.#onCollisionDetection.bind(this));
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.toolbarDirectionChange, this.#onCollisionDetection.bind(this));
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.browserStateCleared, this.#onWindowBrowserStateCleared.bind(this));
        return new Promise((resolve)=>{
            resolve({
                filename: $8f42450ebdd44f5e$var$FILENAME,
                result: true
            });
        });
    }
    static setMap(map) {}
    static getName() {
        return $8f42450ebdd44f5e$var$FILENAME;
    }
    //--------------------------------------------------------------------
    // # Section: User Interface
    //--------------------------------------------------------------------
    static #createMapElement() {
        return window.document.getElementById((0, $1e8c0ef90ed82280$export$a33e119b2316dcb7).getConfig().openLayers.id);
    }
    static #createToastElement() {
        const element = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'div',
            class: 'oltb-toast-container',
            attributes: {
                'data-html2canvas-ignore': 'true'
            }
        });
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren($8f42450ebdd44f5e$export$8e7188a60a5bbe16.getMapElement(), [
            element
        ]);
        return element;
    }
    static #createToolbarElement() {
        const config = (0, $1e8c0ef90ed82280$export$a33e119b2316dcb7).getConfig();
        const element = window.document.getElementById(config.toolbar.id);
        element.setAttribute('data-html2canvas-ignore', 'true');
        element.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.wheel, this.#onMouseWheel.bind(element));
        const themeKey = (0, $52e25f2a10ab5b5c$export$ada36e8a1c3bc83a).themeTool;
        const directionKey = (0, $52e25f2a10ab5b5c$export$ada36e8a1c3bc83a).directionTool;
        // Check if the user has chosen dark theme
        const isDarkTheme = (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).getStateObject(themeKey).theme === 'dark';
        if (isDarkTheme) element.classList.add('dark');
        // Check if the user has chosen light theme 
        const isLightTheme = (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).getStateObject(themeKey).theme === 'light';
        if (isLightTheme) element.classList.remove('dark');
        // Check if the user has chosen horizontal layout 
        const isHorizontal = (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).getStateObject(directionKey).direction === 'row';
        if (isHorizontal) element.classList.add('row');
        // Check if the user has chosen vertical layout 
        const isVertical = (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).getStateObject(directionKey).direction === 'col';
        if (isVertical) element.classList.remove('row');
        // Add dark class to body, this will control the color for the entire project
        if (element.classList.contains('dark')) window.document.body.classList.add(config.className.dark);
        // For consistency also add the row class to the body
        if (element.classList.contains('row')) window.document.body.classList.add(config.className.row);
        return element;
    }
    static #createToolboxElement() {
        const element = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'div',
            class: $8f42450ebdd44f5e$var$CLASS__TOOLBOX_CONTAINER,
            attributes: {
                'data-html2canvas-ignore': 'true'
            }
        });
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren($8f42450ebdd44f5e$export$8e7188a60a5bbe16.getMapElement(), [
            element
        ]);
        return element;
    }
    //--------------------------------------------------------------------
    // # Section: Events
    //--------------------------------------------------------------------
    static #onWindowBrowserStateCleared(event) {
        if (window.innerWidth <= (0, $1e8c0ef90ed82280$export$a33e119b2316dcb7).getConfig().deviceWidth.sm) this.#uiRefToolboxElement.classList.add(`${$8f42450ebdd44f5e$var$CLASS__TOOLBOX_CONTAINER}--collision`);
        else this.#uiRefToolboxElement.classList.remove(`${$8f42450ebdd44f5e$var$CLASS__TOOLBOX_CONTAINER}--collision`);
    }
    static #onMouseWheel(event) {
        if (!event.ctrlKey) {
            const zeroAxis = 0;
            const distance = (0, $1e8c0ef90ed82280$export$a33e119b2316dcb7).getConfig().scroll.distance;
            this.scrollLeft += event.deltaY > zeroAxis ? distance : -distance;
        }
    }
    static #onInitSmoothInterface(event) {
        // TODO:
        // Add smooth init on the toolbox also, keep in mind to handle the "Toggle Toolbox" impact also
        window.setTimeout(()=>{
            this.#uiRefToolbarElement.classList.add($8f42450ebdd44f5e$var$CLASS__SMOOTH_INIT);
        }, $8f42450ebdd44f5e$var$DELAY__SMOOTH_INIT);
    }
    static #onCollisionDetection(event) {
        const collisionLimit = 0;
        const windowWidth = window.innerWidth;
        const toolbarWidth = this.#uiRefToolbarElement.offsetWidth;
        const toolboxWidth = this.#uiRefToolboxElement.offsetWidth;
        const rem = (0, $1e8c0ef90ed82280$export$a33e119b2316dcb7).getConfig().browser.rem;
        const delta = 3.5;
        if (windowWidth - (delta * rem + toolbarWidth + toolboxWidth) <= collisionLimit) this.#uiRefToolboxElement.classList.add(`${$8f42450ebdd44f5e$var$CLASS__TOOLBOX_CONTAINER}--collision`);
        else this.#uiRefToolboxElement.classList.remove(`${$8f42450ebdd44f5e$var$CLASS__TOOLBOX_CONTAINER}--collision`);
    }
    //--------------------------------------------------------------------
    // # Section: Public API
    //--------------------------------------------------------------------
    static getMapElement() {
        return this.#uiRefMapElement;
    }
    static getToastElement() {
        return this.#uiRefToastElement;
    }
    static getToolbarElement() {
        return this.#uiRefToolbarElement;
    }
    static getToolboxElement() {
        return this.#uiRefToolboxElement;
    }
}



var $f1q41 = parcelRequire("f1q41");





/**!
* tippy.js v6.3.7
* (c) 2017-2021 atomiks
* MIT License
*/ function $04a691b7a330df44$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}


function $6985093033570817$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $69730206aa270d41$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $6985093033570817$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $69730206aa270d41$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $6985093033570817$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $69730206aa270d41$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $6985093033570817$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


// and applies them to the HTMLElements such as popper and arrow
function $7deefb3680d4558f$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) || !(0, $04a691b7a330df44$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $7deefb3680d4558f$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) || !(0, $04a691b7a330df44$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $7deefb3680d4558f$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $7deefb3680d4558f$var$applyStyles,
    effect: $7deefb3680d4558f$var$effect,
    requires: [
        'computeStyles'
    ]
};


var $3711db8b00de96df$export$8960430cfd85939f = Math.max;
var $3711db8b00de96df$export$96ec731ed4dcb222 = Math.min;
var $3711db8b00de96df$export$2077e0241d6afd3c = Math.round;



function $6de7caa8ee90d63c$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}


function $bef5ff765617d084$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $6de7caa8ee90d63c$export$2e2bcd8739ae039)());
}


function $2ef6a598263dba8e$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $69730206aa270d41$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $3711db8b00de96df$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $3711db8b00de96df$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(element) ? (0, $6985093033570817$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $bef5ff765617d084$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}



function $39a9a96b6f99add9$export$2e2bcd8739ae039(node) {
    var win = (0, $6985093033570817$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}




function $d47756cb7a847081$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $ac7dd8aeabb81fe8$export$2e2bcd8739ae039(node) {
    if (node === (0, $6985093033570817$export$2e2bcd8739ae039)(node) || !(0, $69730206aa270d41$export$1b3bfaa9684536aa)(node)) return (0, $39a9a96b6f99add9$export$2e2bcd8739ae039)(node);
    else return (0, $d47756cb7a847081$export$2e2bcd8739ae039)(node);
}






function $0d1d9daad62fa952$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $69730206aa270d41$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $60124eceeef28a28$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)((0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element)).left + (0, $39a9a96b6f99add9$export$2e2bcd8739ae039)(element).scrollLeft;
}




function $cbd21d1454570861$export$2e2bcd8739ae039(element) {
    return (0, $6985093033570817$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}


function $12881c0013479a14$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $cbd21d1454570861$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}



function $bcb265ed9201975a$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $3711db8b00de96df$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $3711db8b00de96df$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $bcb265ed9201975a$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $69730206aa270d41$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $69730206aa270d41$export$1b3bfaa9684536aa)(offsetParent) && $bcb265ed9201975a$var$isElementScaled(offsetParent);
    var documentElement = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $04a691b7a330df44$export$2e2bcd8739ae039)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $12881c0013479a14$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $ac7dd8aeabb81fe8$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $69730206aa270d41$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $60124eceeef28a28$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}



function $9effe2b32f662e4a$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}





function $773048fc1d2aa7ee$export$2e2bcd8739ae039(element) {
    if ((0, $04a691b7a330df44$export$2e2bcd8739ae039)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $69730206aa270d41$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element) // fallback
    );
}





function $2cddda83e3357241$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $04a691b7a330df44$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $69730206aa270d41$export$1b3bfaa9684536aa)(node) && (0, $12881c0013479a14$export$2e2bcd8739ae039)(node)) return node;
    return $2cddda83e3357241$export$2e2bcd8739ae039((0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(node));
}





function $90b72ed15edfd54a$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $2cddda83e3357241$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $6985093033570817$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $12881c0013479a14$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($90b72ed15edfd54a$export$2e2bcd8739ae039((0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(target)));
}







function $fd46d779ec622be4$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $04a691b7a330df44$export$2e2bcd8739ae039)(element)) >= 0;
}




function $42fc94c94931c781$var$getTrueOffsetParent(element) {
    if (!(0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $cbd21d1454570861$export$2e2bcd8739ae039)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $42fc94c94931c781$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $6de7caa8ee90d63c$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $6de7caa8ee90d63c$export$2e2bcd8739ae039)());
    if (isIE && (0, $69730206aa270d41$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $cbd21d1454570861$export$2e2bcd8739ae039)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(element);
    if ((0, $69730206aa270d41$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $69730206aa270d41$export$1b3bfaa9684536aa)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $04a691b7a330df44$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $cbd21d1454570861$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $42fc94c94931c781$export$2e2bcd8739ae039(element) {
    var window = (0, $6985093033570817$export$2e2bcd8739ae039)(element);
    var offsetParent = $42fc94c94931c781$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $fd46d779ec622be4$export$2e2bcd8739ae039)(offsetParent) && (0, $cbd21d1454570861$export$2e2bcd8739ae039)(offsetParent).position === 'static')offsetParent = $42fc94c94931c781$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $04a691b7a330df44$export$2e2bcd8739ae039)(offsetParent) === 'html' || (0, $04a691b7a330df44$export$2e2bcd8739ae039)(offsetParent) === 'body' && (0, $cbd21d1454570861$export$2e2bcd8739ae039)(offsetParent).position === 'static')) return window;
    return offsetParent || $42fc94c94931c781$var$getContainingBlock(element) || window;
}


var $1472b89a65155de2$export$1e95b668f3b82d = 'top';
var $1472b89a65155de2$export$40e543e69a8b3fbb = 'bottom';
var $1472b89a65155de2$export$79ffe56a765070d2 = 'right';
var $1472b89a65155de2$export$eabcd2c8791e7bf4 = 'left';
var $1472b89a65155de2$export$dfb5619354ba860 = 'auto';
var $1472b89a65155de2$export$aec2ce47c367b8c3 = [
    $1472b89a65155de2$export$1e95b668f3b82d,
    $1472b89a65155de2$export$40e543e69a8b3fbb,
    $1472b89a65155de2$export$79ffe56a765070d2,
    $1472b89a65155de2$export$eabcd2c8791e7bf4
];
var $1472b89a65155de2$export$b3571188c770cc5a = 'start';
var $1472b89a65155de2$export$bd5df0f255a350f8 = 'end';
var $1472b89a65155de2$export$390fd549c5303b4d = 'clippingParents';
var $1472b89a65155de2$export$d7b7311ec04a3e8f = 'viewport';
var $1472b89a65155de2$export$ae5ab1c730825774 = 'popper';
var $1472b89a65155de2$export$ca50aac9f3ba507f = 'reference';
var $1472b89a65155de2$export$368f9a87e87fa4e1 = /*#__PURE__*/ $1472b89a65155de2$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $1472b89a65155de2$export$b3571188c770cc5a,
        placement + "-" + $1472b89a65155de2$export$bd5df0f255a350f8
    ]);
}, []);
var $1472b89a65155de2$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($1472b89a65155de2$export$aec2ce47c367b8c3, [
    $1472b89a65155de2$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $1472b89a65155de2$export$b3571188c770cc5a,
        placement + "-" + $1472b89a65155de2$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $1472b89a65155de2$export$421679a7c3d56e = 'beforeRead';
var $1472b89a65155de2$export$aafa59e2e03f2942 = 'read';
var $1472b89a65155de2$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $1472b89a65155de2$export$c65e99957a05207c = 'beforeMain';
var $1472b89a65155de2$export$f22da7240b7add18 = 'main';
var $1472b89a65155de2$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $1472b89a65155de2$export$8d4d2d70e7d46032 = 'beforeWrite';
var $1472b89a65155de2$export$68d8715fc104d294 = 'write';
var $1472b89a65155de2$export$70a6e5159acce2e6 = 'afterWrite';
var $1472b89a65155de2$export$d087d3878fdf71d5 = [
    $1472b89a65155de2$export$421679a7c3d56e,
    $1472b89a65155de2$export$aafa59e2e03f2942,
    $1472b89a65155de2$export$6964f6c886723980,
    $1472b89a65155de2$export$c65e99957a05207c,
    $1472b89a65155de2$export$f22da7240b7add18,
    $1472b89a65155de2$export$bab79516f2d662fe,
    $1472b89a65155de2$export$8d4d2d70e7d46032,
    $1472b89a65155de2$export$68d8715fc104d294,
    $1472b89a65155de2$export$70a6e5159acce2e6
];


function $77bc085de34276f2$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $77bc085de34276f2$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $77bc085de34276f2$var$order(modifiers); // order based on phase
    return (0, $1472b89a65155de2$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $9b685cb08303911c$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $f58f9fd4551b4b0f$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $60bdf67e43f5dfcb$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $60bdf67e43f5dfcb$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(reference) ? (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $77bc085de34276f2$export$2e2bcd8739ae039)((0, $f58f9fd4551b4b0f$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$60bdf67e43f5dfcb$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $bcb265ed9201975a$export$2e2bcd8739ae039)(reference, (0, $42fc94c94931c781$export$2e2bcd8739ae039)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $9effe2b32f662e4a$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $9b685cb08303911c$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$60bdf67e43f5dfcb$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $60bdf67e43f5dfcb$export$8f7491d57c8f97a9 = /*#__PURE__*/ $60bdf67e43f5dfcb$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules



var $e7d7845625089588$var$passive = {
    passive: true
};
function $e7d7845625089588$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $6985093033570817$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $e7d7845625089588$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $e7d7845625089588$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $e7d7845625089588$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $e7d7845625089588$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $e7d7845625089588$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $e7d7845625089588$var$effect,
    data: {}
};



function $c6075629d0814627$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}


function $5553ed9c2ee225e3$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}


function $ba9a98a4204389e3$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}



function $9a8b7e877fbba4f3$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $c6075629d0814627$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $1472b89a65155de2$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $1472b89a65155de2$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $1472b89a65155de2$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $1472b89a65155de2$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $ba9a98a4204389e3$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $1472b89a65155de2$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $1472b89a65155de2$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}


function $8e8ecd9a827a16d7$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $9a8b7e877fbba4f3$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $8e8ecd9a827a16d7$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $8e8ecd9a827a16d7$var$popperOffsets,
    data: {}
};










var $45d468ca92a1d24b$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $45d468ca92a1d24b$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $3711db8b00de96df$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $3711db8b00de96df$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $45d468ca92a1d24b$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
    var sideY = (0, $1472b89a65155de2$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $42fc94c94931c781$export$2e2bcd8739ae039)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $6985093033570817$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(popper);
            if ((0, $cbd21d1454570861$export$2e2bcd8739ae039)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $1472b89a65155de2$export$1e95b668f3b82d) || (placement === (0, $1472b89a65155de2$export$eabcd2c8791e7bf4) || placement === (0, $1472b89a65155de2$export$79ffe56a765070d2)) && variation === (0, $1472b89a65155de2$export$bd5df0f255a350f8)) {
            sideY = (0, $1472b89a65155de2$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $1472b89a65155de2$export$eabcd2c8791e7bf4) || (placement === (0, $1472b89a65155de2$export$1e95b668f3b82d) || placement === (0, $1472b89a65155de2$export$40e543e69a8b3fbb)) && variation === (0, $1472b89a65155de2$export$bd5df0f255a350f8)) {
            sideX = (0, $1472b89a65155de2$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $45d468ca92a1d24b$var$unsetSides);
    var _ref4 = roundOffsets === true ? $45d468ca92a1d24b$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $6985093033570817$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $45d468ca92a1d24b$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $c6075629d0814627$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $45d468ca92a1d24b$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $45d468ca92a1d24b$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $45d468ca92a1d24b$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $45d468ca92a1d24b$var$computeStyles,
    data: {}
};





function $ff9a9783c10adebd$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4),
        (0, $1472b89a65155de2$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4),
        (0, $1472b89a65155de2$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $ff9a9783c10adebd$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $1472b89a65155de2$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $ff9a9783c10adebd$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $ff9a9783c10adebd$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $ff9a9783c10adebd$var$offset
};


var $aaefa8315f14c8e2$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $aaefa8315f14c8e2$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $aaefa8315f14c8e2$var$hash[matched];
    });
}



var $37f85a49ff946cb6$var$hash = {
    start: 'end',
    end: 'start'
};
function $37f85a49ff946cb6$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $37f85a49ff946cb6$var$hash[matched];
    });
}







function $a35bf29d5fc5ab40$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $6985093033570817$export$2e2bcd8739ae039)(element);
    var html = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $bef5ff765617d084$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $60124eceeef28a28$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $a5e625ef2dd801ec$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $39a9a96b6f99add9$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $3711db8b00de96df$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $3711db8b00de96df$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $60124eceeef28a28$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $cbd21d1454570861$export$2e2bcd8739ae039)(body || html).direction === 'rtl') x += (0, $3711db8b00de96df$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}










function $8f3b5a3db2e59cbc$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $69730206aa270d41$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $d5700acdd3ba9a3c$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $449799046a13d100$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $449799046a13d100$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $1472b89a65155de2$export$d7b7311ec04a3e8f) ? (0, $d5700acdd3ba9a3c$export$2e2bcd8739ae039)((0, $a35bf29d5fc5ab40$export$2e2bcd8739ae039)(element, strategy)) : (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(clippingParent) ? $449799046a13d100$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $d5700acdd3ba9a3c$export$2e2bcd8739ae039)((0, $a5e625ef2dd801ec$export$2e2bcd8739ae039)((0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $449799046a13d100$var$getClippingParents(element) {
    var clippingParents = (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)((0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $cbd21d1454570861$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) ? (0, $42fc94c94931c781$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $69730206aa270d41$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(clippingParent) && (0, $8f3b5a3db2e59cbc$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $04a691b7a330df44$export$2e2bcd8739ae039)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $449799046a13d100$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $449799046a13d100$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $449799046a13d100$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $3711db8b00de96df$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $3711db8b00de96df$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $3711db8b00de96df$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $3711db8b00de96df$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $449799046a13d100$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $bcb51404109b5184$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $2c6bd604be4c867e$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $bcb51404109b5184$export$2e2bcd8739ae039)(), paddingObject);
}


function $c88039fe47959ef5$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


function $c24a1421ba2f823c$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $1472b89a65155de2$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $1472b89a65155de2$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $1472b89a65155de2$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $2c6bd604be4c867e$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $c88039fe47959ef5$export$2e2bcd8739ae039)(padding, (0, $1472b89a65155de2$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $1472b89a65155de2$export$ae5ab1c730825774) ? (0, $1472b89a65155de2$export$ca50aac9f3ba507f) : (0, $1472b89a65155de2$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $449799046a13d100$export$2e2bcd8739ae039)((0, $69730206aa270d41$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $9a8b7e877fbba4f3$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $d5700acdd3ba9a3c$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $1472b89a65155de2$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $1472b89a65155de2$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $1472b89a65155de2$export$79ffe56a765070d2),
                (0, $1472b89a65155de2$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $1472b89a65155de2$export$1e95b668f3b82d),
                (0, $1472b89a65155de2$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $dae0983d65fbfc0b$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $1472b89a65155de2$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $1472b89a65155de2$export$368f9a87e87fa4e1) : (0, $1472b89a65155de2$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $1472b89a65155de2$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $c6075629d0814627$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $cf1ba1dd94205465$var$getExpandedFallbackPlacements(placement) {
    if ((0, $c6075629d0814627$export$2e2bcd8739ae039)(placement) === (0, $1472b89a65155de2$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(placement);
    return [
        (0, $37f85a49ff946cb6$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $37f85a49ff946cb6$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $cf1ba1dd94205465$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $cf1ba1dd94205465$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $c6075629d0814627$export$2e2bcd8739ae039)(placement) === (0, $1472b89a65155de2$export$dfb5619354ba860) ? (0, $dae0983d65fbfc0b$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement) === (0, $1472b89a65155de2$export$b3571188c770cc5a);
        var isVertical = [
            (0, $1472b89a65155de2$export$1e95b668f3b82d),
            (0, $1472b89a65155de2$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $1472b89a65155de2$export$79ffe56a765070d2) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $cf1ba1dd94205465$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $cf1ba1dd94205465$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};





function $61f76a8076c296c7$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}



function $95428a5e75015184$export$f28d906d67a997f3(min, value, max) {
    return (0, $3711db8b00de96df$export$8960430cfd85939f)(min, (0, $3711db8b00de96df$export$96ec731ed4dcb222)(value, max));
}
function $95428a5e75015184$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $95428a5e75015184$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}








function $865d356b2ca960a5$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $ba9a98a4204389e3$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $61f76a8076c296c7$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $1472b89a65155de2$export$1e95b668f3b82d) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === 'y' ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$79ffe56a765070d2);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $1472b89a65155de2$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $1472b89a65155de2$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $9effe2b32f662e4a$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $bcb51404109b5184$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $95428a5e75015184$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $42fc94c94931c781$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $95428a5e75015184$export$f28d906d67a997f3)(tether ? (0, $3711db8b00de96df$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $3711db8b00de96df$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $1472b89a65155de2$export$1e95b668f3b82d) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === 'x' ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $1472b89a65155de2$export$1e95b668f3b82d),
            (0, $1472b89a65155de2$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $95428a5e75015184$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $95428a5e75015184$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $865d356b2ca960a5$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $865d356b2ca960a5$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};











var $f37d2f7eaf2ad10e$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $2c6bd604be4c867e$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $c88039fe47959ef5$export$2e2bcd8739ae039)(padding, (0, $1472b89a65155de2$export$aec2ce47c367b8c3)));
};
function $f37d2f7eaf2ad10e$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $ba9a98a4204389e3$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4),
        (0, $1472b89a65155de2$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $f37d2f7eaf2ad10e$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $9effe2b32f662e4a$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === 'y' ? (0, $1472b89a65155de2$export$1e95b668f3b82d) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
    var maxProp = axis === 'y' ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $42fc94c94931c781$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $95428a5e75015184$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $f37d2f7eaf2ad10e$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $8f3b5a3db2e59cbc$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $f37d2f7eaf2ad10e$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $f37d2f7eaf2ad10e$var$arrow,
    effect: $f37d2f7eaf2ad10e$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};




function $69d8d7bda7717b01$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $69d8d7bda7717b01$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $1472b89a65155de2$export$1e95b668f3b82d),
        (0, $1472b89a65155de2$export$79ffe56a765070d2),
        (0, $1472b89a65155de2$export$40e543e69a8b3fbb),
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $69d8d7bda7717b01$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $69d8d7bda7717b01$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $69d8d7bda7717b01$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $69d8d7bda7717b01$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $69d8d7bda7717b01$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $69d8d7bda7717b01$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $69d8d7bda7717b01$var$hide
};




var $288fbeb449f53487$export$d34966752335dd47 = [
    (0, $e7d7845625089588$export$2e2bcd8739ae039),
    (0, $8e8ecd9a827a16d7$export$2e2bcd8739ae039),
    (0, $45d468ca92a1d24b$export$2e2bcd8739ae039),
    (0, $7deefb3680d4558f$export$2e2bcd8739ae039),
    (0, $ff9a9783c10adebd$export$2e2bcd8739ae039),
    (0, $cf1ba1dd94205465$export$2e2bcd8739ae039),
    (0, $865d356b2ca960a5$export$2e2bcd8739ae039),
    (0, $f37d2f7eaf2ad10e$export$2e2bcd8739ae039),
    (0, $69d8d7bda7717b01$export$2e2bcd8739ae039)
];
var $288fbeb449f53487$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $60bdf67e43f5dfcb$export$ed5e13716264f202)({
    defaultModifiers: $288fbeb449f53487$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules


var $43bf50b0fa1441ac$export$c96c811c44a42da5 = '<svg width="16" height="6" xmlns="http://www.w3.org/2000/svg"><path d="M0 6s1.796-.013 4.67-3.615C5.851.9 6.93.006 8 0c1.07-.006 2.148.887 3.343 2.385C14.233 6.005 16 6 16 6H0z"></svg>';
var $43bf50b0fa1441ac$var$BOX_CLASS = "tippy-box";
var $43bf50b0fa1441ac$var$CONTENT_CLASS = "tippy-content";
var $43bf50b0fa1441ac$var$BACKDROP_CLASS = "tippy-backdrop";
var $43bf50b0fa1441ac$var$ARROW_CLASS = "tippy-arrow";
var $43bf50b0fa1441ac$var$SVG_ARROW_CLASS = "tippy-svg-arrow";
var $43bf50b0fa1441ac$var$TOUCH_OPTIONS = {
    passive: true,
    capture: true
};
var $43bf50b0fa1441ac$var$TIPPY_DEFAULT_APPEND_TO = function TIPPY_DEFAULT_APPEND_TO() {
    return document.body;
};
function $43bf50b0fa1441ac$var$hasOwnProperty(obj, key) {
    return ({}).hasOwnProperty.call(obj, key);
}
function $43bf50b0fa1441ac$var$getValueAtIndexOrReturn(value, index, defaultValue) {
    if (Array.isArray(value)) {
        var v = value[index];
        return v == null ? Array.isArray(defaultValue) ? defaultValue[index] : defaultValue : v;
    }
    return value;
}
function $43bf50b0fa1441ac$var$isType(value, type) {
    var str = ({}).toString.call(value);
    return str.indexOf('[object') === 0 && str.indexOf(type + "]") > -1;
}
function $43bf50b0fa1441ac$var$invokeWithArgsOrReturn(value, args) {
    return typeof value === 'function' ? value.apply(void 0, args) : value;
}
function $43bf50b0fa1441ac$var$debounce(fn, ms) {
    // Avoid wrapping in `setTimeout` if ms is 0 anyway
    if (ms === 0) return fn;
    var timeout;
    return function(arg) {
        clearTimeout(timeout);
        timeout = setTimeout(function() {
            fn(arg);
        }, ms);
    };
}
function $43bf50b0fa1441ac$var$removeProperties(obj, keys) {
    var clone = Object.assign({}, obj);
    keys.forEach(function(key) {
        delete clone[key];
    });
    return clone;
}
function $43bf50b0fa1441ac$var$splitBySpaces(value) {
    return value.split(/\s+/).filter(Boolean);
}
function $43bf50b0fa1441ac$var$normalizeToArray(value) {
    return [].concat(value);
}
function $43bf50b0fa1441ac$var$pushIfUnique(arr, value) {
    if (arr.indexOf(value) === -1) arr.push(value);
}
function $43bf50b0fa1441ac$var$unique(arr) {
    return arr.filter(function(item, index) {
        return arr.indexOf(item) === index;
    });
}
function $43bf50b0fa1441ac$var$getBasePlacement(placement) {
    return placement.split('-')[0];
}
function $43bf50b0fa1441ac$var$arrayFrom(value) {
    return [].slice.call(value);
}
function $43bf50b0fa1441ac$var$removeUndefinedProps(obj) {
    return Object.keys(obj).reduce(function(acc, key) {
        if (obj[key] !== undefined) acc[key] = obj[key];
        return acc;
    }, {});
}
function $43bf50b0fa1441ac$var$div() {
    return document.createElement('div');
}
function $43bf50b0fa1441ac$var$isElement(value) {
    return [
        'Element',
        'Fragment'
    ].some(function(type) {
        return $43bf50b0fa1441ac$var$isType(value, type);
    });
}
function $43bf50b0fa1441ac$var$isNodeList(value) {
    return $43bf50b0fa1441ac$var$isType(value, 'NodeList');
}
function $43bf50b0fa1441ac$var$isMouseEvent(value) {
    return $43bf50b0fa1441ac$var$isType(value, 'MouseEvent');
}
function $43bf50b0fa1441ac$var$isReferenceElement(value) {
    return !!(value && value._tippy && value._tippy.reference === value);
}
function $43bf50b0fa1441ac$var$getArrayOfElements(value) {
    if ($43bf50b0fa1441ac$var$isElement(value)) return [
        value
    ];
    if ($43bf50b0fa1441ac$var$isNodeList(value)) return $43bf50b0fa1441ac$var$arrayFrom(value);
    if (Array.isArray(value)) return value;
    return $43bf50b0fa1441ac$var$arrayFrom(document.querySelectorAll(value));
}
function $43bf50b0fa1441ac$var$setTransitionDuration(els, value) {
    els.forEach(function(el) {
        if (el) el.style.transitionDuration = value + "ms";
    });
}
function $43bf50b0fa1441ac$var$setVisibilityState(els, state) {
    els.forEach(function(el) {
        if (el) el.setAttribute('data-state', state);
    });
}
function $43bf50b0fa1441ac$var$getOwnerDocument(elementOrElements) {
    var _element$ownerDocumen;
    var _normalizeToArray = $43bf50b0fa1441ac$var$normalizeToArray(elementOrElements), element = _normalizeToArray[0]; // Elements created via a <template> have an ownerDocument with no reference to the body
    return element != null && (_element$ownerDocumen = element.ownerDocument) != null && _element$ownerDocumen.body ? element.ownerDocument : document;
}
function $43bf50b0fa1441ac$var$isCursorOutsideInteractiveBorder(popperTreeData, event) {
    var clientX = event.clientX, clientY = event.clientY;
    return popperTreeData.every(function(_ref) {
        var popperRect = _ref.popperRect, popperState = _ref.popperState, props = _ref.props;
        var interactiveBorder = props.interactiveBorder;
        var basePlacement = $43bf50b0fa1441ac$var$getBasePlacement(popperState.placement);
        var offsetData = popperState.modifiersData.offset;
        if (!offsetData) return true;
        var topDistance = basePlacement === 'bottom' ? offsetData.top.y : 0;
        var bottomDistance = basePlacement === 'top' ? offsetData.bottom.y : 0;
        var leftDistance = basePlacement === 'right' ? offsetData.left.x : 0;
        var rightDistance = basePlacement === 'left' ? offsetData.right.x : 0;
        var exceedsTop = popperRect.top - clientY + topDistance > interactiveBorder;
        var exceedsBottom = clientY - popperRect.bottom - bottomDistance > interactiveBorder;
        var exceedsLeft = popperRect.left - clientX + leftDistance > interactiveBorder;
        var exceedsRight = clientX - popperRect.right - rightDistance > interactiveBorder;
        return exceedsTop || exceedsBottom || exceedsLeft || exceedsRight;
    });
}
function $43bf50b0fa1441ac$var$updateTransitionEndListener(box, action, listener) {
    var method = action + "EventListener"; // some browsers apparently support `transition` (unprefixed) but only fire
    // `webkitTransitionEnd`...
    [
        'transitionend',
        'webkitTransitionEnd'
    ].forEach(function(event) {
        box[method](event, listener);
    });
}
/**
 * Compared to xxx.contains, this function works for dom structures with shadow
 * dom
 */ function $43bf50b0fa1441ac$var$actualContains(parent, child) {
    var target = child;
    while(target){
        var _target$getRootNode;
        if (parent.contains(target)) return true;
        target = target.getRootNode == null ? void 0 : (_target$getRootNode = target.getRootNode()) == null ? void 0 : _target$getRootNode.host;
    }
    return false;
}
var $43bf50b0fa1441ac$var$currentInput = {
    isTouch: false
};
var $43bf50b0fa1441ac$var$lastMouseMoveTime = 0;
/**
 * When a `touchstart` event is fired, it's assumed the user is using touch
 * input. We'll bind a `mousemove` event listener to listen for mouse input in
 * the future. This way, the `isTouch` property is fully dynamic and will handle
 * hybrid devices that use a mix of touch + mouse input.
 */ function $43bf50b0fa1441ac$var$onDocumentTouchStart() {
    if ($43bf50b0fa1441ac$var$currentInput.isTouch) return;
    $43bf50b0fa1441ac$var$currentInput.isTouch = true;
    if (window.performance) document.addEventListener('mousemove', $43bf50b0fa1441ac$var$onDocumentMouseMove);
}
/**
 * When two `mousemove` event are fired consecutively within 20ms, it's assumed
 * the user is using mouse input again. `mousemove` can fire on touch devices as
 * well, but very rarely that quickly.
 */ function $43bf50b0fa1441ac$var$onDocumentMouseMove() {
    var now = performance.now();
    if (now - $43bf50b0fa1441ac$var$lastMouseMoveTime < 20) {
        $43bf50b0fa1441ac$var$currentInput.isTouch = false;
        document.removeEventListener('mousemove', $43bf50b0fa1441ac$var$onDocumentMouseMove);
    }
    $43bf50b0fa1441ac$var$lastMouseMoveTime = now;
}
/**
 * When an element is in focus and has a tippy, leaving the tab/window and
 * returning causes it to show again. For mouse users this is unexpected, but
 * for keyboard use it makes sense.
 * TODO: find a better technique to solve this problem
 */ function $43bf50b0fa1441ac$var$onWindowBlur() {
    var activeElement = document.activeElement;
    if ($43bf50b0fa1441ac$var$isReferenceElement(activeElement)) {
        var instance = activeElement._tippy;
        if (activeElement.blur && !instance.state.isVisible) activeElement.blur();
    }
}
function $43bf50b0fa1441ac$var$bindGlobalEventListeners() {
    document.addEventListener('touchstart', $43bf50b0fa1441ac$var$onDocumentTouchStart, $43bf50b0fa1441ac$var$TOUCH_OPTIONS);
    window.addEventListener('blur', $43bf50b0fa1441ac$var$onWindowBlur);
}
var $43bf50b0fa1441ac$var$isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
var $43bf50b0fa1441ac$var$isIE11 = $43bf50b0fa1441ac$var$isBrowser ? !!window.msCrypto : false;
function $43bf50b0fa1441ac$var$createMemoryLeakWarning(method) {
    var txt = method === 'destroy' ? 'n already-' : ' ';
    return [
        method + "() was called on a" + txt + "destroyed instance. This is a no-op but",
        'indicates a potential memory leak.'
    ].join(' ');
}
function $43bf50b0fa1441ac$var$clean(value) {
    var spacesAndTabs = /[ \t]{2,}/g;
    var lineStartWithSpaces = /^[ \t]*/gm;
    return value.replace(spacesAndTabs, ' ').replace(lineStartWithSpaces, '').trim();
}
function $43bf50b0fa1441ac$var$getDevMessage(message) {
    return $43bf50b0fa1441ac$var$clean("\n  %ctippy.js\n\n  %c" + $43bf50b0fa1441ac$var$clean(message) + "\n\n  %c\uD83D\uDC77\u200D This is a development-only message. It will be removed in production.\n  ");
}
function $43bf50b0fa1441ac$var$getFormattedMessage(message) {
    return [
        $43bf50b0fa1441ac$var$getDevMessage(message),
        'color: #00C584; font-size: 1.3em; font-weight: bold;',
        'line-height: 1.5',
        'color: #a6a095;'
    ];
} // Assume warnings and errors never have the same message
var $43bf50b0fa1441ac$var$visitedMessages;
function $43bf50b0fa1441ac$var$resetVisitedMessages() {
    $43bf50b0fa1441ac$var$visitedMessages = new Set();
}
function $43bf50b0fa1441ac$var$warnWhen(condition, message) {
    if (condition && !$43bf50b0fa1441ac$var$visitedMessages.has(message)) {
        var _console;
        $43bf50b0fa1441ac$var$visitedMessages.add(message);
        (_console = console).warn.apply(_console, $43bf50b0fa1441ac$var$getFormattedMessage(message));
    }
}
function $43bf50b0fa1441ac$var$errorWhen(condition, message) {
    if (condition && !$43bf50b0fa1441ac$var$visitedMessages.has(message)) {
        var _console2;
        $43bf50b0fa1441ac$var$visitedMessages.add(message);
        (_console2 = console).error.apply(_console2, $43bf50b0fa1441ac$var$getFormattedMessage(message));
    }
}
function $43bf50b0fa1441ac$var$validateTargets(targets) {
    var didPassFalsyValue = !targets;
    var didPassPlainObject = Object.prototype.toString.call(targets) === '[object Object]' && !targets.addEventListener;
    $43bf50b0fa1441ac$var$errorWhen(didPassFalsyValue, [
        'tippy() was passed',
        '`' + String(targets) + '`',
        'as its targets (first) argument. Valid types are: String, Element,',
        'Element[], or NodeList.'
    ].join(' '));
    $43bf50b0fa1441ac$var$errorWhen(didPassPlainObject, [
        'tippy() was passed a plain object which is not supported as an argument',
        'for virtual positioning. Use props.getReferenceClientRect instead.'
    ].join(' '));
}
var $43bf50b0fa1441ac$var$pluginProps = {
    animateFill: false,
    followCursor: false,
    inlinePositioning: false,
    sticky: false
};
var $43bf50b0fa1441ac$var$renderProps = {
    allowHTML: false,
    animation: 'fade',
    arrow: true,
    content: '',
    inertia: false,
    maxWidth: 350,
    role: 'tooltip',
    theme: '',
    zIndex: 9999
};
var $43bf50b0fa1441ac$var$defaultProps = Object.assign({
    appendTo: $43bf50b0fa1441ac$var$TIPPY_DEFAULT_APPEND_TO,
    aria: {
        content: 'auto',
        expanded: 'auto'
    },
    delay: 0,
    duration: [
        300,
        250
    ],
    getReferenceClientRect: null,
    hideOnClick: true,
    ignoreAttributes: false,
    interactive: false,
    interactiveBorder: 2,
    interactiveDebounce: 0,
    moveTransition: '',
    offset: [
        0,
        10
    ],
    onAfterUpdate: function onAfterUpdate() {},
    onBeforeUpdate: function onBeforeUpdate() {},
    onCreate: function onCreate() {},
    onDestroy: function onDestroy() {},
    onHidden: function onHidden() {},
    onHide: function onHide() {},
    onMount: function onMount() {},
    onShow: function onShow() {},
    onShown: function onShown() {},
    onTrigger: function onTrigger() {},
    onUntrigger: function onUntrigger() {},
    onClickOutside: function onClickOutside() {},
    placement: 'top',
    plugins: [],
    popperOptions: {},
    render: null,
    showOnCreate: false,
    touch: true,
    trigger: 'mouseenter focus',
    triggerTarget: null
}, $43bf50b0fa1441ac$var$pluginProps, $43bf50b0fa1441ac$var$renderProps);
var $43bf50b0fa1441ac$var$defaultKeys = Object.keys($43bf50b0fa1441ac$var$defaultProps);
var $43bf50b0fa1441ac$var$setDefaultProps = function setDefaultProps(partialProps) {
    var keys = Object.keys(partialProps);
    keys.forEach(function(key) {
        $43bf50b0fa1441ac$var$defaultProps[key] = partialProps[key];
    });
};
function $43bf50b0fa1441ac$var$getExtendedPassedProps(passedProps) {
    var plugins = passedProps.plugins || [];
    var pluginProps = plugins.reduce(function(acc, plugin) {
        var name = plugin.name, defaultValue = plugin.defaultValue;
        if (name) {
            var _name;
            acc[name] = passedProps[name] !== undefined ? passedProps[name] : (_name = $43bf50b0fa1441ac$var$defaultProps[name]) != null ? _name : defaultValue;
        }
        return acc;
    }, {});
    return Object.assign({}, passedProps, pluginProps);
}
function $43bf50b0fa1441ac$var$getDataAttributeProps(reference, plugins) {
    var propKeys = plugins ? Object.keys($43bf50b0fa1441ac$var$getExtendedPassedProps(Object.assign({}, $43bf50b0fa1441ac$var$defaultProps, {
        plugins: plugins
    }))) : $43bf50b0fa1441ac$var$defaultKeys;
    var props = propKeys.reduce(function(acc, key) {
        var valueAsString = (reference.getAttribute("data-tippy-" + key) || '').trim();
        if (!valueAsString) return acc;
        if (key === 'content') acc[key] = valueAsString;
        else try {
            acc[key] = JSON.parse(valueAsString);
        } catch (e) {
            acc[key] = valueAsString;
        }
        return acc;
    }, {});
    return props;
}
function $43bf50b0fa1441ac$var$evaluateProps(reference, props) {
    var out = Object.assign({}, props, {
        content: $43bf50b0fa1441ac$var$invokeWithArgsOrReturn(props.content, [
            reference
        ])
    }, props.ignoreAttributes ? {} : $43bf50b0fa1441ac$var$getDataAttributeProps(reference, props.plugins));
    out.aria = Object.assign({}, $43bf50b0fa1441ac$var$defaultProps.aria, out.aria);
    out.aria = {
        expanded: out.aria.expanded === 'auto' ? props.interactive : out.aria.expanded,
        content: out.aria.content === 'auto' ? props.interactive ? null : 'describedby' : out.aria.content
    };
    return out;
}
function $43bf50b0fa1441ac$var$validateProps(partialProps, plugins) {
    if (partialProps === void 0) partialProps = {};
    if (plugins === void 0) plugins = [];
    var keys = Object.keys(partialProps);
    keys.forEach(function(prop) {
        var nonPluginProps = $43bf50b0fa1441ac$var$removeProperties($43bf50b0fa1441ac$var$defaultProps, Object.keys($43bf50b0fa1441ac$var$pluginProps));
        var didPassUnknownProp = !$43bf50b0fa1441ac$var$hasOwnProperty(nonPluginProps, prop); // Check if the prop exists in `plugins`
        if (didPassUnknownProp) didPassUnknownProp = plugins.filter(function(plugin) {
            return plugin.name === prop;
        }).length === 0;
        $43bf50b0fa1441ac$var$warnWhen(didPassUnknownProp, [
            "`" + prop + "`",
            "is not a valid prop. You may have spelled it incorrectly, or if it's",
            'a plugin, forgot to pass it in an array as props.plugins.',
            '\n\n',
            'All props: https://atomiks.github.io/tippyjs/v6/all-props/\n',
            'Plugins: https://atomiks.github.io/tippyjs/v6/plugins/'
        ].join(' '));
    });
}
var $43bf50b0fa1441ac$var$innerHTML = function innerHTML() {
    return 'innerHTML';
};
function $43bf50b0fa1441ac$var$dangerouslySetInnerHTML(element, html) {
    element[$43bf50b0fa1441ac$var$innerHTML()] = html;
}
function $43bf50b0fa1441ac$var$createArrowElement(value) {
    var arrow = $43bf50b0fa1441ac$var$div();
    if (value === true) arrow.className = $43bf50b0fa1441ac$var$ARROW_CLASS;
    else {
        arrow.className = $43bf50b0fa1441ac$var$SVG_ARROW_CLASS;
        if ($43bf50b0fa1441ac$var$isElement(value)) arrow.appendChild(value);
        else $43bf50b0fa1441ac$var$dangerouslySetInnerHTML(arrow, value);
    }
    return arrow;
}
function $43bf50b0fa1441ac$var$setContent(content, props) {
    if ($43bf50b0fa1441ac$var$isElement(props.content)) {
        $43bf50b0fa1441ac$var$dangerouslySetInnerHTML(content, '');
        content.appendChild(props.content);
    } else if (typeof props.content !== 'function') {
        if (props.allowHTML) $43bf50b0fa1441ac$var$dangerouslySetInnerHTML(content, props.content);
        else content.textContent = props.content;
    }
}
function $43bf50b0fa1441ac$var$getChildren(popper) {
    var box = popper.firstElementChild;
    var boxChildren = $43bf50b0fa1441ac$var$arrayFrom(box.children);
    return {
        box: box,
        content: boxChildren.find(function(node) {
            return node.classList.contains($43bf50b0fa1441ac$var$CONTENT_CLASS);
        }),
        arrow: boxChildren.find(function(node) {
            return node.classList.contains($43bf50b0fa1441ac$var$ARROW_CLASS) || node.classList.contains($43bf50b0fa1441ac$var$SVG_ARROW_CLASS);
        }),
        backdrop: boxChildren.find(function(node) {
            return node.classList.contains($43bf50b0fa1441ac$var$BACKDROP_CLASS);
        })
    };
}
function $43bf50b0fa1441ac$var$render(instance) {
    var popper = $43bf50b0fa1441ac$var$div();
    var box = $43bf50b0fa1441ac$var$div();
    box.className = $43bf50b0fa1441ac$var$BOX_CLASS;
    box.setAttribute('data-state', 'hidden');
    box.setAttribute('tabindex', '-1');
    var content = $43bf50b0fa1441ac$var$div();
    content.className = $43bf50b0fa1441ac$var$CONTENT_CLASS;
    content.setAttribute('data-state', 'hidden');
    $43bf50b0fa1441ac$var$setContent(content, instance.props);
    popper.appendChild(box);
    box.appendChild(content);
    onUpdate(instance.props, instance.props);
    function onUpdate(prevProps, nextProps) {
        var _getChildren = $43bf50b0fa1441ac$var$getChildren(popper), box = _getChildren.box, content = _getChildren.content, arrow = _getChildren.arrow;
        if (nextProps.theme) box.setAttribute('data-theme', nextProps.theme);
        else box.removeAttribute('data-theme');
        if (typeof nextProps.animation === 'string') box.setAttribute('data-animation', nextProps.animation);
        else box.removeAttribute('data-animation');
        if (nextProps.inertia) box.setAttribute('data-inertia', '');
        else box.removeAttribute('data-inertia');
        box.style.maxWidth = typeof nextProps.maxWidth === 'number' ? nextProps.maxWidth + "px" : nextProps.maxWidth;
        if (nextProps.role) box.setAttribute('role', nextProps.role);
        else box.removeAttribute('role');
        if (prevProps.content !== nextProps.content || prevProps.allowHTML !== nextProps.allowHTML) $43bf50b0fa1441ac$var$setContent(content, instance.props);
        if (nextProps.arrow) {
            if (!arrow) box.appendChild($43bf50b0fa1441ac$var$createArrowElement(nextProps.arrow));
            else if (prevProps.arrow !== nextProps.arrow) {
                box.removeChild(arrow);
                box.appendChild($43bf50b0fa1441ac$var$createArrowElement(nextProps.arrow));
            }
        } else if (arrow) box.removeChild(arrow);
    }
    return {
        popper: popper,
        onUpdate: onUpdate
    };
} // Runtime check to identify if the render function is the default one; this
// way we can apply default CSS transitions logic and it can be tree-shaken away
$43bf50b0fa1441ac$var$render.$$tippy = true;
var $43bf50b0fa1441ac$var$idCounter = 1;
var $43bf50b0fa1441ac$var$mouseMoveListeners = []; // Used by `hideAll()`
var $43bf50b0fa1441ac$var$mountedInstances = [];
function $43bf50b0fa1441ac$var$createTippy(reference, passedProps) {
    var props = $43bf50b0fa1441ac$var$evaluateProps(reference, Object.assign({}, $43bf50b0fa1441ac$var$defaultProps, $43bf50b0fa1441ac$var$getExtendedPassedProps($43bf50b0fa1441ac$var$removeUndefinedProps(passedProps)))); // ===========================================================================
    // 🔒 Private members
    // ===========================================================================
    var showTimeout;
    var hideTimeout;
    var scheduleHideAnimationFrame;
    var isVisibleFromClick = false;
    var didHideDueToDocumentMouseDown = false;
    var didTouchMove = false;
    var ignoreOnFirstUpdate = false;
    var lastTriggerEvent;
    var currentTransitionEndListener;
    var onFirstUpdate;
    var listeners = [];
    var debouncedOnMouseMove = $43bf50b0fa1441ac$var$debounce(onMouseMove, props.interactiveDebounce);
    var currentTarget; // ===========================================================================
    // 🔑 Public members
    // ===========================================================================
    var id = $43bf50b0fa1441ac$var$idCounter++;
    var popperInstance = null;
    var plugins = $43bf50b0fa1441ac$var$unique(props.plugins);
    var state = {
        // Is the instance currently enabled?
        isEnabled: true,
        // Is the tippy currently showing and not transitioning out?
        isVisible: false,
        // Has the instance been destroyed?
        isDestroyed: false,
        // Is the tippy currently mounted to the DOM?
        isMounted: false,
        // Has the tippy finished transitioning in?
        isShown: false
    };
    var instance = {
        // properties
        id: id,
        reference: reference,
        popper: $43bf50b0fa1441ac$var$div(),
        popperInstance: popperInstance,
        props: props,
        state: state,
        plugins: plugins,
        // methods
        clearDelayTimeouts: clearDelayTimeouts,
        setProps: setProps,
        setContent: setContent,
        show: show,
        hide: hide,
        hideWithInteractivity: hideWithInteractivity,
        enable: enable,
        disable: disable,
        unmount: unmount,
        destroy: destroy
    }; // TODO: Investigate why this early return causes a TDZ error in the tests —
    // it doesn't seem to happen in the browser
    /* istanbul ignore if */ if (!props.render) return instance;
     // ===========================================================================
    // Initial mutations
    // ===========================================================================
    var _props$render = props.render(instance), popper = _props$render.popper, onUpdate = _props$render.onUpdate;
    popper.setAttribute('data-tippy-root', '');
    popper.id = "tippy-" + instance.id;
    instance.popper = popper;
    reference._tippy = instance;
    popper._tippy = instance;
    var pluginsHooks = plugins.map(function(plugin) {
        return plugin.fn(instance);
    });
    var hasAriaExpanded = reference.hasAttribute('aria-expanded');
    addListeners();
    handleAriaExpandedAttribute();
    handleStyles();
    invokeHook('onCreate', [
        instance
    ]);
    if (props.showOnCreate) scheduleShow();
     // Prevent a tippy with a delay from hiding if the cursor left then returned
    // before it started hiding
    popper.addEventListener('mouseenter', function() {
        if (instance.props.interactive && instance.state.isVisible) instance.clearDelayTimeouts();
    });
    popper.addEventListener('mouseleave', function() {
        if (instance.props.interactive && instance.props.trigger.indexOf('mouseenter') >= 0) getDocument().addEventListener('mousemove', debouncedOnMouseMove);
    });
    return instance; // ===========================================================================
    // 🔒 Private methods
    // ===========================================================================
    function getNormalizedTouchSettings() {
        var touch = instance.props.touch;
        return Array.isArray(touch) ? touch : [
            touch,
            0
        ];
    }
    function getIsCustomTouchBehavior() {
        return getNormalizedTouchSettings()[0] === 'hold';
    }
    function getIsDefaultRenderFn() {
        var _instance$props$rende;
        // @ts-ignore
        return !!((_instance$props$rende = instance.props.render) != null && _instance$props$rende.$$tippy);
    }
    function getCurrentTarget() {
        return currentTarget || reference;
    }
    function getDocument() {
        var parent = getCurrentTarget().parentNode;
        return parent ? $43bf50b0fa1441ac$var$getOwnerDocument(parent) : document;
    }
    function getDefaultTemplateChildren() {
        return $43bf50b0fa1441ac$var$getChildren(popper);
    }
    function getDelay(isShow) {
        // For touch or keyboard input, force `0` delay for UX reasons
        // Also if the instance is mounted but not visible (transitioning out),
        // ignore delay
        if (instance.state.isMounted && !instance.state.isVisible || $43bf50b0fa1441ac$var$currentInput.isTouch || lastTriggerEvent && lastTriggerEvent.type === 'focus') return 0;
        return $43bf50b0fa1441ac$var$getValueAtIndexOrReturn(instance.props.delay, isShow ? 0 : 1, $43bf50b0fa1441ac$var$defaultProps.delay);
    }
    function handleStyles(fromHide) {
        if (fromHide === void 0) fromHide = false;
        popper.style.pointerEvents = instance.props.interactive && !fromHide ? '' : 'none';
        popper.style.zIndex = "" + instance.props.zIndex;
    }
    function invokeHook(hook, args, shouldInvokePropsHook) {
        if (shouldInvokePropsHook === void 0) shouldInvokePropsHook = true;
        pluginsHooks.forEach(function(pluginHooks) {
            if (pluginHooks[hook]) pluginHooks[hook].apply(pluginHooks, args);
        });
        if (shouldInvokePropsHook) {
            var _instance$props;
            (_instance$props = instance.props)[hook].apply(_instance$props, args);
        }
    }
    function handleAriaContentAttribute() {
        var aria = instance.props.aria;
        if (!aria.content) return;
        var attr = "aria-" + aria.content;
        var id = popper.id;
        var nodes = $43bf50b0fa1441ac$var$normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function(node) {
            var currentValue = node.getAttribute(attr);
            if (instance.state.isVisible) node.setAttribute(attr, currentValue ? currentValue + " " + id : id);
            else {
                var nextValue = currentValue && currentValue.replace(id, '').trim();
                if (nextValue) node.setAttribute(attr, nextValue);
                else node.removeAttribute(attr);
            }
        });
    }
    function handleAriaExpandedAttribute() {
        if (hasAriaExpanded || !instance.props.aria.expanded) return;
        var nodes = $43bf50b0fa1441ac$var$normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function(node) {
            if (instance.props.interactive) node.setAttribute('aria-expanded', instance.state.isVisible && node === getCurrentTarget() ? 'true' : 'false');
            else node.removeAttribute('aria-expanded');
        });
    }
    function cleanupInteractiveMouseListeners() {
        getDocument().removeEventListener('mousemove', debouncedOnMouseMove);
        $43bf50b0fa1441ac$var$mouseMoveListeners = $43bf50b0fa1441ac$var$mouseMoveListeners.filter(function(listener) {
            return listener !== debouncedOnMouseMove;
        });
    }
    function onDocumentPress(event) {
        // Moved finger to scroll instead of an intentional tap outside
        if ($43bf50b0fa1441ac$var$currentInput.isTouch) {
            if (didTouchMove || event.type === 'mousedown') return;
        }
        var actualTarget = event.composedPath && event.composedPath()[0] || event.target; // Clicked on interactive popper
        if (instance.props.interactive && $43bf50b0fa1441ac$var$actualContains(popper, actualTarget)) return;
         // Clicked on the event listeners target
        if ($43bf50b0fa1441ac$var$normalizeToArray(instance.props.triggerTarget || reference).some(function(el) {
            return $43bf50b0fa1441ac$var$actualContains(el, actualTarget);
        })) {
            if ($43bf50b0fa1441ac$var$currentInput.isTouch) return;
            if (instance.state.isVisible && instance.props.trigger.indexOf('click') >= 0) return;
        } else invokeHook('onClickOutside', [
            instance,
            event
        ]);
        if (instance.props.hideOnClick === true) {
            instance.clearDelayTimeouts();
            instance.hide(); // `mousedown` event is fired right before `focus` if pressing the
            // currentTarget. This lets a tippy with `focus` trigger know that it
            // should not show
            didHideDueToDocumentMouseDown = true;
            setTimeout(function() {
                didHideDueToDocumentMouseDown = false;
            }); // The listener gets added in `scheduleShow()`, but this may be hiding it
            // before it shows, and hide()'s early bail-out behavior can prevent it
            // from being cleaned up
            if (!instance.state.isMounted) removeDocumentPress();
        }
    }
    function onTouchMove() {
        didTouchMove = true;
    }
    function onTouchStart() {
        didTouchMove = false;
    }
    function addDocumentPress() {
        var doc = getDocument();
        doc.addEventListener('mousedown', onDocumentPress, true);
        doc.addEventListener('touchend', onDocumentPress, $43bf50b0fa1441ac$var$TOUCH_OPTIONS);
        doc.addEventListener('touchstart', onTouchStart, $43bf50b0fa1441ac$var$TOUCH_OPTIONS);
        doc.addEventListener('touchmove', onTouchMove, $43bf50b0fa1441ac$var$TOUCH_OPTIONS);
    }
    function removeDocumentPress() {
        var doc = getDocument();
        doc.removeEventListener('mousedown', onDocumentPress, true);
        doc.removeEventListener('touchend', onDocumentPress, $43bf50b0fa1441ac$var$TOUCH_OPTIONS);
        doc.removeEventListener('touchstart', onTouchStart, $43bf50b0fa1441ac$var$TOUCH_OPTIONS);
        doc.removeEventListener('touchmove', onTouchMove, $43bf50b0fa1441ac$var$TOUCH_OPTIONS);
    }
    function onTransitionedOut(duration, callback) {
        onTransitionEnd(duration, function() {
            if (!instance.state.isVisible && popper.parentNode && popper.parentNode.contains(popper)) callback();
        });
    }
    function onTransitionedIn(duration, callback) {
        onTransitionEnd(duration, callback);
    }
    function onTransitionEnd(duration, callback) {
        var box = getDefaultTemplateChildren().box;
        function listener(event) {
            if (event.target === box) {
                $43bf50b0fa1441ac$var$updateTransitionEndListener(box, 'remove', listener);
                callback();
            }
        } // Make callback synchronous if duration is 0
        // `transitionend` won't fire otherwise
        if (duration === 0) return callback();
        $43bf50b0fa1441ac$var$updateTransitionEndListener(box, 'remove', currentTransitionEndListener);
        $43bf50b0fa1441ac$var$updateTransitionEndListener(box, 'add', listener);
        currentTransitionEndListener = listener;
    }
    function on(eventType, handler, options) {
        if (options === void 0) options = false;
        var nodes = $43bf50b0fa1441ac$var$normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function(node) {
            node.addEventListener(eventType, handler, options);
            listeners.push({
                node: node,
                eventType: eventType,
                handler: handler,
                options: options
            });
        });
    }
    function addListeners() {
        if (getIsCustomTouchBehavior()) {
            on('touchstart', onTrigger, {
                passive: true
            });
            on('touchend', onMouseLeave, {
                passive: true
            });
        }
        $43bf50b0fa1441ac$var$splitBySpaces(instance.props.trigger).forEach(function(eventType) {
            if (eventType === 'manual') return;
            on(eventType, onTrigger);
            switch(eventType){
                case 'mouseenter':
                    on('mouseleave', onMouseLeave);
                    break;
                case 'focus':
                    on($43bf50b0fa1441ac$var$isIE11 ? 'focusout' : 'blur', onBlurOrFocusOut);
                    break;
                case 'focusin':
                    on('focusout', onBlurOrFocusOut);
                    break;
            }
        });
    }
    function removeListeners() {
        listeners.forEach(function(_ref) {
            var node = _ref.node, eventType = _ref.eventType, handler = _ref.handler, options = _ref.options;
            node.removeEventListener(eventType, handler, options);
        });
        listeners = [];
    }
    function onTrigger(event) {
        var _lastTriggerEvent;
        var shouldScheduleClickHide = false;
        if (!instance.state.isEnabled || isEventListenerStopped(event) || didHideDueToDocumentMouseDown) return;
        var wasFocused = ((_lastTriggerEvent = lastTriggerEvent) == null ? void 0 : _lastTriggerEvent.type) === 'focus';
        lastTriggerEvent = event;
        currentTarget = event.currentTarget;
        handleAriaExpandedAttribute();
        if (!instance.state.isVisible && $43bf50b0fa1441ac$var$isMouseEvent(event)) // If scrolling, `mouseenter` events can be fired if the cursor lands
        // over a new target, but `mousemove` events don't get fired. This
        // causes interactive tooltips to get stuck open until the cursor is
        // moved
        $43bf50b0fa1441ac$var$mouseMoveListeners.forEach(function(listener) {
            return listener(event);
        });
         // Toggle show/hide when clicking click-triggered tooltips
        if (event.type === 'click' && (instance.props.trigger.indexOf('mouseenter') < 0 || isVisibleFromClick) && instance.props.hideOnClick !== false && instance.state.isVisible) shouldScheduleClickHide = true;
        else scheduleShow(event);
        if (event.type === 'click') isVisibleFromClick = !shouldScheduleClickHide;
        if (shouldScheduleClickHide && !wasFocused) scheduleHide(event);
    }
    function onMouseMove(event) {
        var target = event.target;
        var isCursorOverReferenceOrPopper = getCurrentTarget().contains(target) || popper.contains(target);
        if (event.type === 'mousemove' && isCursorOverReferenceOrPopper) return;
        var popperTreeData = getNestedPopperTree().concat(popper).map(function(popper) {
            var _instance$popperInsta;
            var instance = popper._tippy;
            var state = (_instance$popperInsta = instance.popperInstance) == null ? void 0 : _instance$popperInsta.state;
            if (state) return {
                popperRect: popper.getBoundingClientRect(),
                popperState: state,
                props: props
            };
            return null;
        }).filter(Boolean);
        if ($43bf50b0fa1441ac$var$isCursorOutsideInteractiveBorder(popperTreeData, event)) {
            cleanupInteractiveMouseListeners();
            scheduleHide(event);
        }
    }
    function onMouseLeave(event) {
        var shouldBail = isEventListenerStopped(event) || instance.props.trigger.indexOf('click') >= 0 && isVisibleFromClick;
        if (shouldBail) return;
        if (instance.props.interactive) {
            instance.hideWithInteractivity(event);
            return;
        }
        scheduleHide(event);
    }
    function onBlurOrFocusOut(event) {
        if (instance.props.trigger.indexOf('focusin') < 0 && event.target !== getCurrentTarget()) return;
         // If focus was moved to within the popper
        if (instance.props.interactive && event.relatedTarget && popper.contains(event.relatedTarget)) return;
        scheduleHide(event);
    }
    function isEventListenerStopped(event) {
        return $43bf50b0fa1441ac$var$currentInput.isTouch ? getIsCustomTouchBehavior() !== event.type.indexOf('touch') >= 0 : false;
    }
    function createPopperInstance() {
        destroyPopperInstance();
        var _instance$props2 = instance.props, popperOptions = _instance$props2.popperOptions, placement = _instance$props2.placement, offset = _instance$props2.offset, getReferenceClientRect = _instance$props2.getReferenceClientRect, moveTransition = _instance$props2.moveTransition;
        var arrow = getIsDefaultRenderFn() ? $43bf50b0fa1441ac$var$getChildren(popper).arrow : null;
        var computedReference = getReferenceClientRect ? {
            getBoundingClientRect: getReferenceClientRect,
            contextElement: getReferenceClientRect.contextElement || getCurrentTarget()
        } : reference;
        var tippyModifier = {
            name: '$$tippy',
            enabled: true,
            phase: 'beforeWrite',
            requires: [
                'computeStyles'
            ],
            fn: function fn(_ref2) {
                var state = _ref2.state;
                if (getIsDefaultRenderFn()) {
                    var _getDefaultTemplateCh = getDefaultTemplateChildren(), box = _getDefaultTemplateCh.box;
                    [
                        'placement',
                        'reference-hidden',
                        'escaped'
                    ].forEach(function(attr) {
                        if (attr === 'placement') box.setAttribute('data-placement', state.placement);
                        else if (state.attributes.popper["data-popper-" + attr]) box.setAttribute("data-" + attr, '');
                        else box.removeAttribute("data-" + attr);
                    });
                    state.attributes.popper = {};
                }
            }
        };
        var modifiers = [
            {
                name: 'offset',
                options: {
                    offset: offset
                }
            },
            {
                name: 'preventOverflow',
                options: {
                    padding: {
                        top: 2,
                        bottom: 2,
                        left: 5,
                        right: 5
                    }
                }
            },
            {
                name: 'flip',
                options: {
                    padding: 5
                }
            },
            {
                name: 'computeStyles',
                options: {
                    adaptive: !moveTransition
                }
            },
            tippyModifier
        ];
        if (getIsDefaultRenderFn() && arrow) modifiers.push({
            name: 'arrow',
            options: {
                element: arrow,
                padding: 3
            }
        });
        modifiers.push.apply(modifiers, (popperOptions == null ? void 0 : popperOptions.modifiers) || []);
        instance.popperInstance = (0, $288fbeb449f53487$export$8f7491d57c8f97a9)(computedReference, popper, Object.assign({}, popperOptions, {
            placement: placement,
            onFirstUpdate: onFirstUpdate,
            modifiers: modifiers
        }));
    }
    function destroyPopperInstance() {
        if (instance.popperInstance) {
            instance.popperInstance.destroy();
            instance.popperInstance = null;
        }
    }
    function mount() {
        var appendTo = instance.props.appendTo;
        var parentNode; // By default, we'll append the popper to the triggerTargets's parentNode so
        // it's directly after the reference element so the elements inside the
        // tippy can be tabbed to
        // If there are clipping issues, the user can specify a different appendTo
        // and ensure focus management is handled correctly manually
        var node = getCurrentTarget();
        if (instance.props.interactive && appendTo === $43bf50b0fa1441ac$var$TIPPY_DEFAULT_APPEND_TO || appendTo === 'parent') parentNode = node.parentNode;
        else parentNode = $43bf50b0fa1441ac$var$invokeWithArgsOrReturn(appendTo, [
            node
        ]);
         // The popper element needs to exist on the DOM before its position can be
        // updated as Popper needs to read its dimensions
        if (!parentNode.contains(popper)) parentNode.appendChild(popper);
        instance.state.isMounted = true;
        createPopperInstance();
    }
    function getNestedPopperTree() {
        return $43bf50b0fa1441ac$var$arrayFrom(popper.querySelectorAll('[data-tippy-root]'));
    }
    function scheduleShow(event) {
        instance.clearDelayTimeouts();
        if (event) invokeHook('onTrigger', [
            instance,
            event
        ]);
        addDocumentPress();
        var delay = getDelay(true);
        var _getNormalizedTouchSe = getNormalizedTouchSettings(), touchValue = _getNormalizedTouchSe[0], touchDelay = _getNormalizedTouchSe[1];
        if ($43bf50b0fa1441ac$var$currentInput.isTouch && touchValue === 'hold' && touchDelay) delay = touchDelay;
        if (delay) showTimeout = setTimeout(function() {
            instance.show();
        }, delay);
        else instance.show();
    }
    function scheduleHide(event) {
        instance.clearDelayTimeouts();
        invokeHook('onUntrigger', [
            instance,
            event
        ]);
        if (!instance.state.isVisible) {
            removeDocumentPress();
            return;
        } // For interactive tippies, scheduleHide is added to a document.body handler
        // from onMouseLeave so must intercept scheduled hides from mousemove/leave
        // events when trigger contains mouseenter and click, and the tip is
        // currently shown as a result of a click.
        if (instance.props.trigger.indexOf('mouseenter') >= 0 && instance.props.trigger.indexOf('click') >= 0 && [
            'mouseleave',
            'mousemove'
        ].indexOf(event.type) >= 0 && isVisibleFromClick) return;
        var delay = getDelay(false);
        if (delay) hideTimeout = setTimeout(function() {
            if (instance.state.isVisible) instance.hide();
        }, delay);
        else // Fixes a `transitionend` problem when it fires 1 frame too
        // late sometimes, we don't want hide() to be called.
        scheduleHideAnimationFrame = requestAnimationFrame(function() {
            instance.hide();
        });
    } // ===========================================================================
    // 🔑 Public methods
    // ===========================================================================
    function enable() {
        instance.state.isEnabled = true;
    }
    function disable() {
        // Disabling the instance should also hide it
        // https://github.com/atomiks/tippy.js-react/issues/106
        instance.hide();
        instance.state.isEnabled = false;
    }
    function clearDelayTimeouts() {
        clearTimeout(showTimeout);
        clearTimeout(hideTimeout);
        cancelAnimationFrame(scheduleHideAnimationFrame);
    }
    function setProps(partialProps) {
        if (instance.state.isDestroyed) return;
        invokeHook('onBeforeUpdate', [
            instance,
            partialProps
        ]);
        removeListeners();
        var prevProps = instance.props;
        var nextProps = $43bf50b0fa1441ac$var$evaluateProps(reference, Object.assign({}, prevProps, $43bf50b0fa1441ac$var$removeUndefinedProps(partialProps), {
            ignoreAttributes: true
        }));
        instance.props = nextProps;
        addListeners();
        if (prevProps.interactiveDebounce !== nextProps.interactiveDebounce) {
            cleanupInteractiveMouseListeners();
            debouncedOnMouseMove = $43bf50b0fa1441ac$var$debounce(onMouseMove, nextProps.interactiveDebounce);
        } // Ensure stale aria-expanded attributes are removed
        if (prevProps.triggerTarget && !nextProps.triggerTarget) $43bf50b0fa1441ac$var$normalizeToArray(prevProps.triggerTarget).forEach(function(node) {
            node.removeAttribute('aria-expanded');
        });
        else if (nextProps.triggerTarget) reference.removeAttribute('aria-expanded');
        handleAriaExpandedAttribute();
        handleStyles();
        if (onUpdate) onUpdate(prevProps, nextProps);
        if (instance.popperInstance) {
            createPopperInstance(); // Fixes an issue with nested tippies if they are all getting re-rendered,
            // and the nested ones get re-rendered first.
            // https://github.com/atomiks/tippyjs-react/issues/177
            // TODO: find a cleaner / more efficient solution(!)
            getNestedPopperTree().forEach(function(nestedPopper) {
                // React (and other UI libs likely) requires a rAF wrapper as it flushes
                // its work in one
                requestAnimationFrame(nestedPopper._tippy.popperInstance.forceUpdate);
            });
        }
        invokeHook('onAfterUpdate', [
            instance,
            partialProps
        ]);
    }
    function setContent(content) {
        instance.setProps({
            content: content
        });
    }
    function show() {
        var isAlreadyVisible = instance.state.isVisible;
        var isDestroyed = instance.state.isDestroyed;
        var isDisabled = !instance.state.isEnabled;
        var isTouchAndTouchDisabled = $43bf50b0fa1441ac$var$currentInput.isTouch && !instance.props.touch;
        var duration = $43bf50b0fa1441ac$var$getValueAtIndexOrReturn(instance.props.duration, 0, $43bf50b0fa1441ac$var$defaultProps.duration);
        if (isAlreadyVisible || isDestroyed || isDisabled || isTouchAndTouchDisabled) return;
         // Normalize `disabled` behavior across browsers.
        // Firefox allows events on disabled elements, but Chrome doesn't.
        // Using a wrapper element (i.e. <span>) is recommended.
        if (getCurrentTarget().hasAttribute('disabled')) return;
        invokeHook('onShow', [
            instance
        ], false);
        if (instance.props.onShow(instance) === false) return;
        instance.state.isVisible = true;
        if (getIsDefaultRenderFn()) popper.style.visibility = 'visible';
        handleStyles();
        addDocumentPress();
        if (!instance.state.isMounted) popper.style.transition = 'none';
         // If flipping to the opposite side after hiding at least once, the
        // animation will use the wrong placement without resetting the duration
        if (getIsDefaultRenderFn()) {
            var _getDefaultTemplateCh2 = getDefaultTemplateChildren(), box = _getDefaultTemplateCh2.box, content = _getDefaultTemplateCh2.content;
            $43bf50b0fa1441ac$var$setTransitionDuration([
                box,
                content
            ], 0);
        }
        onFirstUpdate = function onFirstUpdate() {
            var _instance$popperInsta2;
            if (!instance.state.isVisible || ignoreOnFirstUpdate) return;
            ignoreOnFirstUpdate = true; // reflow
            popper.offsetHeight;
            popper.style.transition = instance.props.moveTransition;
            if (getIsDefaultRenderFn() && instance.props.animation) {
                var _getDefaultTemplateCh3 = getDefaultTemplateChildren(), _box = _getDefaultTemplateCh3.box, _content = _getDefaultTemplateCh3.content;
                $43bf50b0fa1441ac$var$setTransitionDuration([
                    _box,
                    _content
                ], duration);
                $43bf50b0fa1441ac$var$setVisibilityState([
                    _box,
                    _content
                ], 'visible');
            }
            handleAriaContentAttribute();
            handleAriaExpandedAttribute();
            $43bf50b0fa1441ac$var$pushIfUnique($43bf50b0fa1441ac$var$mountedInstances, instance); // certain modifiers (e.g. `maxSize`) require a second update after the
            // popper has been positioned for the first time
            (_instance$popperInsta2 = instance.popperInstance) == null || _instance$popperInsta2.forceUpdate();
            invokeHook('onMount', [
                instance
            ]);
            if (instance.props.animation && getIsDefaultRenderFn()) onTransitionedIn(duration, function() {
                instance.state.isShown = true;
                invokeHook('onShown', [
                    instance
                ]);
            });
        };
        mount();
    }
    function hide() {
        var isAlreadyHidden = !instance.state.isVisible;
        var isDestroyed = instance.state.isDestroyed;
        var isDisabled = !instance.state.isEnabled;
        var duration = $43bf50b0fa1441ac$var$getValueAtIndexOrReturn(instance.props.duration, 1, $43bf50b0fa1441ac$var$defaultProps.duration);
        if (isAlreadyHidden || isDestroyed || isDisabled) return;
        invokeHook('onHide', [
            instance
        ], false);
        if (instance.props.onHide(instance) === false) return;
        instance.state.isVisible = false;
        instance.state.isShown = false;
        ignoreOnFirstUpdate = false;
        isVisibleFromClick = false;
        if (getIsDefaultRenderFn()) popper.style.visibility = 'hidden';
        cleanupInteractiveMouseListeners();
        removeDocumentPress();
        handleStyles(true);
        if (getIsDefaultRenderFn()) {
            var _getDefaultTemplateCh4 = getDefaultTemplateChildren(), box = _getDefaultTemplateCh4.box, content = _getDefaultTemplateCh4.content;
            if (instance.props.animation) {
                $43bf50b0fa1441ac$var$setTransitionDuration([
                    box,
                    content
                ], duration);
                $43bf50b0fa1441ac$var$setVisibilityState([
                    box,
                    content
                ], 'hidden');
            }
        }
        handleAriaContentAttribute();
        handleAriaExpandedAttribute();
        if (instance.props.animation) {
            if (getIsDefaultRenderFn()) onTransitionedOut(duration, instance.unmount);
        } else instance.unmount();
    }
    function hideWithInteractivity(event) {
        getDocument().addEventListener('mousemove', debouncedOnMouseMove);
        $43bf50b0fa1441ac$var$pushIfUnique($43bf50b0fa1441ac$var$mouseMoveListeners, debouncedOnMouseMove);
        debouncedOnMouseMove(event);
    }
    function unmount() {
        if (instance.state.isVisible) instance.hide();
        if (!instance.state.isMounted) return;
        destroyPopperInstance(); // If a popper is not interactive, it will be appended outside the popper
        // tree by default. This seems mainly for interactive tippies, but we should
        // find a workaround if possible
        getNestedPopperTree().forEach(function(nestedPopper) {
            nestedPopper._tippy.unmount();
        });
        if (popper.parentNode) popper.parentNode.removeChild(popper);
        $43bf50b0fa1441ac$var$mountedInstances = $43bf50b0fa1441ac$var$mountedInstances.filter(function(i) {
            return i !== instance;
        });
        instance.state.isMounted = false;
        invokeHook('onHidden', [
            instance
        ]);
    }
    function destroy() {
        if (instance.state.isDestroyed) return;
        instance.clearDelayTimeouts();
        instance.unmount();
        removeListeners();
        delete reference._tippy;
        instance.state.isDestroyed = true;
        invokeHook('onDestroy', [
            instance
        ]);
    }
}
function $43bf50b0fa1441ac$var$tippy(targets, optionalProps) {
    if (optionalProps === void 0) optionalProps = {};
    var plugins = $43bf50b0fa1441ac$var$defaultProps.plugins.concat(optionalProps.plugins || []);
    $43bf50b0fa1441ac$var$bindGlobalEventListeners();
    var passedProps = Object.assign({}, optionalProps, {
        plugins: plugins
    });
    var elements = $43bf50b0fa1441ac$var$getArrayOfElements(targets);
    var isSingleContentElement, isMoreThanOneReferenceElement;
    var instances = elements.reduce(function(acc, reference) {
        var instance = reference && $43bf50b0fa1441ac$var$createTippy(reference, passedProps);
        if (instance) acc.push(instance);
        return acc;
    }, []);
    return $43bf50b0fa1441ac$var$isElement(targets) ? instances[0] : instances;
}
$43bf50b0fa1441ac$var$tippy.defaultProps = $43bf50b0fa1441ac$var$defaultProps;
$43bf50b0fa1441ac$var$tippy.setDefaultProps = $43bf50b0fa1441ac$var$setDefaultProps;
$43bf50b0fa1441ac$var$tippy.currentInput = $43bf50b0fa1441ac$var$currentInput;
var $43bf50b0fa1441ac$export$a9608aab345f7e75 = function hideAll(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, excludedReferenceOrInstance = _ref.exclude, duration = _ref.duration;
    $43bf50b0fa1441ac$var$mountedInstances.forEach(function(instance) {
        var isExcluded = false;
        if (excludedReferenceOrInstance) isExcluded = $43bf50b0fa1441ac$var$isReferenceElement(excludedReferenceOrInstance) ? instance.reference === excludedReferenceOrInstance : instance.popper === excludedReferenceOrInstance.popper;
        if (!isExcluded) {
            var originalDuration = instance.props.duration;
            instance.setProps({
                duration: duration
            });
            instance.hide();
            if (!instance.state.isDestroyed) instance.setProps({
                duration: originalDuration
            });
        }
    });
};
// every time the popper is destroyed (i.e. a new target), removing the styles
// and causing transitions to break for singletons when the console is open, but
// most notably for non-transform styles being used, `gpuAcceleration: false`.
var $43bf50b0fa1441ac$var$applyStylesModifier = Object.assign({}, (0, $7deefb3680d4558f$export$2e2bcd8739ae039), {
    effect: function effect(_ref) {
        var state = _ref.state;
        var initialStyles = {
            popper: {
                position: state.options.strategy,
                left: '0',
                top: '0',
                margin: '0'
            },
            arrow: {
                position: 'absolute'
            },
            reference: {}
        };
        Object.assign(state.elements.popper.style, initialStyles.popper);
        state.styles = initialStyles;
        if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
         // intentionally return no cleanup function
    // return () => { ... }
    }
});
var $43bf50b0fa1441ac$export$374c483667c1ea9b = function createSingleton(tippyInstances, optionalProps) {
    var _optionalProps$popper;
    if (optionalProps === void 0) optionalProps = {};
    var individualInstances = tippyInstances;
    var references = [];
    var triggerTargets = [];
    var currentTarget;
    var overrides = optionalProps.overrides;
    var interceptSetPropsCleanups = [];
    var shownOnCreate = false;
    function setTriggerTargets() {
        triggerTargets = individualInstances.map(function(instance) {
            return $43bf50b0fa1441ac$var$normalizeToArray(instance.props.triggerTarget || instance.reference);
        }).reduce(function(acc, item) {
            return acc.concat(item);
        }, []);
    }
    function setReferences() {
        references = individualInstances.map(function(instance) {
            return instance.reference;
        });
    }
    function enableInstances(isEnabled) {
        individualInstances.forEach(function(instance) {
            if (isEnabled) instance.enable();
            else instance.disable();
        });
    }
    function interceptSetProps(singleton) {
        return individualInstances.map(function(instance) {
            var originalSetProps = instance.setProps;
            instance.setProps = function(props) {
                originalSetProps(props);
                if (instance.reference === currentTarget) singleton.setProps(props);
            };
            return function() {
                instance.setProps = originalSetProps;
            };
        });
    } // have to pass singleton, as it maybe undefined on first call
    function prepareInstance(singleton, target) {
        var index = triggerTargets.indexOf(target); // bail-out
        if (target === currentTarget) return;
        currentTarget = target;
        var overrideProps = (overrides || []).concat('content').reduce(function(acc, prop) {
            acc[prop] = individualInstances[index].props[prop];
            return acc;
        }, {});
        singleton.setProps(Object.assign({}, overrideProps, {
            getReferenceClientRect: typeof overrideProps.getReferenceClientRect === 'function' ? overrideProps.getReferenceClientRect : function() {
                var _references$index;
                return (_references$index = references[index]) == null ? void 0 : _references$index.getBoundingClientRect();
            }
        }));
    }
    enableInstances(false);
    setReferences();
    setTriggerTargets();
    var plugin = {
        fn: function fn() {
            return {
                onDestroy: function onDestroy() {
                    enableInstances(true);
                },
                onHidden: function onHidden() {
                    currentTarget = null;
                },
                onClickOutside: function onClickOutside(instance) {
                    if (instance.props.showOnCreate && !shownOnCreate) {
                        shownOnCreate = true;
                        currentTarget = null;
                    }
                },
                onShow: function onShow(instance) {
                    if (instance.props.showOnCreate && !shownOnCreate) {
                        shownOnCreate = true;
                        prepareInstance(instance, references[0]);
                    }
                },
                onTrigger: function onTrigger(instance, event) {
                    prepareInstance(instance, event.currentTarget);
                }
            };
        }
    };
    var singleton = $43bf50b0fa1441ac$var$tippy($43bf50b0fa1441ac$var$div(), Object.assign({}, $43bf50b0fa1441ac$var$removeProperties(optionalProps, [
        'overrides'
    ]), {
        plugins: [
            plugin
        ].concat(optionalProps.plugins || []),
        triggerTarget: triggerTargets,
        popperOptions: Object.assign({}, optionalProps.popperOptions, {
            modifiers: [].concat(((_optionalProps$popper = optionalProps.popperOptions) == null ? void 0 : _optionalProps$popper.modifiers) || [], [
                $43bf50b0fa1441ac$var$applyStylesModifier
            ])
        })
    }));
    var originalShow = singleton.show;
    singleton.show = function(target) {
        originalShow(); // first time, showOnCreate or programmatic call with no params
        // default to showing first instance
        if (!currentTarget && target == null) return prepareInstance(singleton, references[0]);
         // triggered from event (do nothing as prepareInstance already called by onTrigger)
        // programmatic call with no params when already visible (do nothing again)
        if (currentTarget && target == null) return;
         // target is index of instance
        if (typeof target === 'number') return references[target] && prepareInstance(singleton, references[target]);
         // target is a child tippy instance
        if (individualInstances.indexOf(target) >= 0) {
            var ref = target.reference;
            return prepareInstance(singleton, ref);
        } // target is a ReferenceElement
        if (references.indexOf(target) >= 0) return prepareInstance(singleton, target);
    };
    singleton.showNext = function() {
        var first = references[0];
        if (!currentTarget) return singleton.show(0);
        var index = references.indexOf(currentTarget);
        singleton.show(references[index + 1] || first);
    };
    singleton.showPrevious = function() {
        var last = references[references.length - 1];
        if (!currentTarget) return singleton.show(last);
        var index = references.indexOf(currentTarget);
        var target = references[index - 1] || last;
        singleton.show(target);
    };
    var originalSetProps = singleton.setProps;
    singleton.setProps = function(props) {
        overrides = props.overrides || overrides;
        originalSetProps(props);
    };
    singleton.setInstances = function(nextInstances) {
        enableInstances(true);
        interceptSetPropsCleanups.forEach(function(fn) {
            return fn();
        });
        individualInstances = nextInstances;
        enableInstances(false);
        setReferences();
        setTriggerTargets();
        interceptSetPropsCleanups = interceptSetProps(singleton);
        singleton.setProps({
            triggerTarget: triggerTargets
        });
    };
    interceptSetPropsCleanups = interceptSetProps(singleton);
    return singleton;
};
var $43bf50b0fa1441ac$var$BUBBLING_EVENTS_MAP = {
    mouseover: 'mouseenter',
    focusin: 'focus',
    click: 'click'
};
/**
 * Creates a delegate instance that controls the creation of tippy instances
 * for child elements (`target` CSS selector).
 */ function $43bf50b0fa1441ac$export$10b1921597150314(targets, props) {
    var listeners = [];
    var childTippyInstances = [];
    var disabled = false;
    var target = props.target;
    var nativeProps = $43bf50b0fa1441ac$var$removeProperties(props, [
        'target'
    ]);
    var parentProps = Object.assign({}, nativeProps, {
        trigger: 'manual',
        touch: false
    });
    var childProps = Object.assign({
        touch: $43bf50b0fa1441ac$var$defaultProps.touch
    }, nativeProps, {
        showOnCreate: true
    });
    var returnValue = $43bf50b0fa1441ac$var$tippy(targets, parentProps);
    var normalizedReturnValue = $43bf50b0fa1441ac$var$normalizeToArray(returnValue);
    function onTrigger(event) {
        if (!event.target || disabled) return;
        var targetNode = event.target.closest(target);
        if (!targetNode) return;
         // Get relevant trigger with fallbacks:
        // 1. Check `data-tippy-trigger` attribute on target node
        // 2. Fallback to `trigger` passed to `delegate()`
        // 3. Fallback to `defaultProps.trigger`
        var trigger = targetNode.getAttribute('data-tippy-trigger') || props.trigger || $43bf50b0fa1441ac$var$defaultProps.trigger; // @ts-ignore
        if (targetNode._tippy) return;
        if (event.type === 'touchstart' && typeof childProps.touch === 'boolean') return;
        if (event.type !== 'touchstart' && trigger.indexOf($43bf50b0fa1441ac$var$BUBBLING_EVENTS_MAP[event.type]) < 0) return;
        var instance = $43bf50b0fa1441ac$var$tippy(targetNode, childProps);
        if (instance) childTippyInstances = childTippyInstances.concat(instance);
    }
    function on(node, eventType, handler, options) {
        if (options === void 0) options = false;
        node.addEventListener(eventType, handler, options);
        listeners.push({
            node: node,
            eventType: eventType,
            handler: handler,
            options: options
        });
    }
    function addEventListeners(instance) {
        var reference = instance.reference;
        on(reference, 'touchstart', onTrigger, $43bf50b0fa1441ac$var$TOUCH_OPTIONS);
        on(reference, 'mouseover', onTrigger);
        on(reference, 'focusin', onTrigger);
        on(reference, 'click', onTrigger);
    }
    function removeEventListeners() {
        listeners.forEach(function(_ref) {
            var node = _ref.node, eventType = _ref.eventType, handler = _ref.handler, options = _ref.options;
            node.removeEventListener(eventType, handler, options);
        });
        listeners = [];
    }
    function applyMutations(instance) {
        var originalDestroy = instance.destroy;
        var originalEnable = instance.enable;
        var originalDisable = instance.disable;
        instance.destroy = function(shouldDestroyChildInstances) {
            if (shouldDestroyChildInstances === void 0) shouldDestroyChildInstances = true;
            if (shouldDestroyChildInstances) childTippyInstances.forEach(function(instance) {
                instance.destroy();
            });
            childTippyInstances = [];
            removeEventListeners();
            originalDestroy();
        };
        instance.enable = function() {
            originalEnable();
            childTippyInstances.forEach(function(instance) {
                return instance.enable();
            });
            disabled = false;
        };
        instance.disable = function() {
            originalDisable();
            childTippyInstances.forEach(function(instance) {
                return instance.disable();
            });
            disabled = true;
        };
        addEventListeners(instance);
    }
    normalizedReturnValue.forEach(applyMutations);
    return returnValue;
}
var $43bf50b0fa1441ac$export$dd8ded329c01db79 = {
    name: 'animateFill',
    defaultValue: false,
    fn: function fn(instance) {
        var _instance$props$rende;
        // @ts-ignore
        if (!((_instance$props$rende = instance.props.render) != null && _instance$props$rende.$$tippy)) return {};
        var _getChildren = $43bf50b0fa1441ac$var$getChildren(instance.popper), box = _getChildren.box, content = _getChildren.content;
        var backdrop = instance.props.animateFill ? $43bf50b0fa1441ac$var$createBackdropElement() : null;
        return {
            onCreate: function onCreate() {
                if (backdrop) {
                    box.insertBefore(backdrop, box.firstElementChild);
                    box.setAttribute('data-animatefill', '');
                    box.style.overflow = 'hidden';
                    instance.setProps({
                        arrow: false,
                        animation: 'shift-away'
                    });
                }
            },
            onMount: function onMount() {
                if (backdrop) {
                    var transitionDuration = box.style.transitionDuration;
                    var duration = Number(transitionDuration.replace('ms', '')); // The content should fade in after the backdrop has mostly filled the
                    // tooltip element. `clip-path` is the other alternative but is not
                    // well-supported and is buggy on some devices.
                    content.style.transitionDelay = Math.round(duration / 10) + "ms";
                    backdrop.style.transitionDuration = transitionDuration;
                    $43bf50b0fa1441ac$var$setVisibilityState([
                        backdrop
                    ], 'visible');
                }
            },
            onShow: function onShow() {
                if (backdrop) backdrop.style.transitionDuration = '0ms';
            },
            onHide: function onHide() {
                if (backdrop) $43bf50b0fa1441ac$var$setVisibilityState([
                    backdrop
                ], 'hidden');
            }
        };
    }
};
function $43bf50b0fa1441ac$var$createBackdropElement() {
    var backdrop = $43bf50b0fa1441ac$var$div();
    backdrop.className = $43bf50b0fa1441ac$var$BACKDROP_CLASS;
    $43bf50b0fa1441ac$var$setVisibilityState([
        backdrop
    ], 'hidden');
    return backdrop;
}
var $43bf50b0fa1441ac$var$mouseCoords = {
    clientX: 0,
    clientY: 0
};
var $43bf50b0fa1441ac$var$activeInstances = [];
function $43bf50b0fa1441ac$var$storeMouseCoords(_ref) {
    var clientX = _ref.clientX, clientY = _ref.clientY;
    $43bf50b0fa1441ac$var$mouseCoords = {
        clientX: clientX,
        clientY: clientY
    };
}
function $43bf50b0fa1441ac$var$addMouseCoordsListener(doc) {
    doc.addEventListener('mousemove', $43bf50b0fa1441ac$var$storeMouseCoords);
}
function $43bf50b0fa1441ac$var$removeMouseCoordsListener(doc) {
    doc.removeEventListener('mousemove', $43bf50b0fa1441ac$var$storeMouseCoords);
}
var $43bf50b0fa1441ac$export$ac81526b64504ab6 = {
    name: 'followCursor',
    defaultValue: false,
    fn: function fn(instance) {
        var reference = instance.reference;
        var doc = $43bf50b0fa1441ac$var$getOwnerDocument(instance.props.triggerTarget || reference);
        var isInternalUpdate = false;
        var wasFocusEvent = false;
        var isUnmounted = true;
        var prevProps = instance.props;
        function getIsInitialBehavior() {
            return instance.props.followCursor === 'initial' && instance.state.isVisible;
        }
        function addListener() {
            doc.addEventListener('mousemove', onMouseMove);
        }
        function removeListener() {
            doc.removeEventListener('mousemove', onMouseMove);
        }
        function unsetGetReferenceClientRect() {
            isInternalUpdate = true;
            instance.setProps({
                getReferenceClientRect: null
            });
            isInternalUpdate = false;
        }
        function onMouseMove(event) {
            // If the instance is interactive, avoid updating the position unless it's
            // over the reference element
            var isCursorOverReference = event.target ? reference.contains(event.target) : true;
            var followCursor = instance.props.followCursor;
            var clientX = event.clientX, clientY = event.clientY;
            var rect = reference.getBoundingClientRect();
            var relativeX = clientX - rect.left;
            var relativeY = clientY - rect.top;
            if (isCursorOverReference || !instance.props.interactive) instance.setProps({
                // @ts-ignore - unneeded DOMRect properties
                getReferenceClientRect: function getReferenceClientRect() {
                    var rect = reference.getBoundingClientRect();
                    var x = clientX;
                    var y = clientY;
                    if (followCursor === 'initial') {
                        x = rect.left + relativeX;
                        y = rect.top + relativeY;
                    }
                    var top = followCursor === 'horizontal' ? rect.top : y;
                    var right = followCursor === 'vertical' ? rect.right : x;
                    var bottom = followCursor === 'horizontal' ? rect.bottom : y;
                    var left = followCursor === 'vertical' ? rect.left : x;
                    return {
                        width: right - left,
                        height: bottom - top,
                        top: top,
                        right: right,
                        bottom: bottom,
                        left: left
                    };
                }
            });
        }
        function create() {
            if (instance.props.followCursor) {
                $43bf50b0fa1441ac$var$activeInstances.push({
                    instance: instance,
                    doc: doc
                });
                $43bf50b0fa1441ac$var$addMouseCoordsListener(doc);
            }
        }
        function destroy() {
            $43bf50b0fa1441ac$var$activeInstances = $43bf50b0fa1441ac$var$activeInstances.filter(function(data) {
                return data.instance !== instance;
            });
            if ($43bf50b0fa1441ac$var$activeInstances.filter(function(data) {
                return data.doc === doc;
            }).length === 0) $43bf50b0fa1441ac$var$removeMouseCoordsListener(doc);
        }
        return {
            onCreate: create,
            onDestroy: destroy,
            onBeforeUpdate: function onBeforeUpdate() {
                prevProps = instance.props;
            },
            onAfterUpdate: function onAfterUpdate(_, _ref2) {
                var followCursor = _ref2.followCursor;
                if (isInternalUpdate) return;
                if (followCursor !== undefined && prevProps.followCursor !== followCursor) {
                    destroy();
                    if (followCursor) {
                        create();
                        if (instance.state.isMounted && !wasFocusEvent && !getIsInitialBehavior()) addListener();
                    } else {
                        removeListener();
                        unsetGetReferenceClientRect();
                    }
                }
            },
            onMount: function onMount() {
                if (instance.props.followCursor && !wasFocusEvent) {
                    if (isUnmounted) {
                        onMouseMove($43bf50b0fa1441ac$var$mouseCoords);
                        isUnmounted = false;
                    }
                    if (!getIsInitialBehavior()) addListener();
                }
            },
            onTrigger: function onTrigger(_, event) {
                if ($43bf50b0fa1441ac$var$isMouseEvent(event)) $43bf50b0fa1441ac$var$mouseCoords = {
                    clientX: event.clientX,
                    clientY: event.clientY
                };
                wasFocusEvent = event.type === 'focus';
            },
            onHidden: function onHidden() {
                if (instance.props.followCursor) {
                    unsetGetReferenceClientRect();
                    removeListener();
                    isUnmounted = true;
                }
            }
        };
    }
};
function $43bf50b0fa1441ac$var$getProps(props, modifier) {
    var _props$popperOptions;
    return {
        popperOptions: Object.assign({}, props.popperOptions, {
            modifiers: [].concat((((_props$popperOptions = props.popperOptions) == null ? void 0 : _props$popperOptions.modifiers) || []).filter(function(_ref) {
                var name = _ref.name;
                return name !== modifier.name;
            }), [
                modifier
            ])
        })
    };
}
var $43bf50b0fa1441ac$export$e2b668424a9c728 = {
    name: 'inlinePositioning',
    defaultValue: false,
    fn: function fn(instance) {
        var reference = instance.reference;
        function isEnabled() {
            return !!instance.props.inlinePositioning;
        }
        var placement;
        var cursorRectIndex = -1;
        var isInternalUpdate = false;
        var triedPlacements = [];
        var modifier = {
            name: 'tippyInlinePositioning',
            enabled: true,
            phase: 'afterWrite',
            fn: function fn(_ref2) {
                var state = _ref2.state;
                if (isEnabled()) {
                    if (triedPlacements.indexOf(state.placement) !== -1) triedPlacements = [];
                    if (placement !== state.placement && triedPlacements.indexOf(state.placement) === -1) {
                        triedPlacements.push(state.placement);
                        instance.setProps({
                            // @ts-ignore - unneeded DOMRect properties
                            getReferenceClientRect: function getReferenceClientRect() {
                                return _getReferenceClientRect(state.placement);
                            }
                        });
                    }
                    placement = state.placement;
                }
            }
        };
        function _getReferenceClientRect(placement) {
            return $43bf50b0fa1441ac$var$getInlineBoundingClientRect($43bf50b0fa1441ac$var$getBasePlacement(placement), reference.getBoundingClientRect(), $43bf50b0fa1441ac$var$arrayFrom(reference.getClientRects()), cursorRectIndex);
        }
        function setInternalProps(partialProps) {
            isInternalUpdate = true;
            instance.setProps(partialProps);
            isInternalUpdate = false;
        }
        function addModifier() {
            if (!isInternalUpdate) setInternalProps($43bf50b0fa1441ac$var$getProps(instance.props, modifier));
        }
        return {
            onCreate: addModifier,
            onAfterUpdate: addModifier,
            onTrigger: function onTrigger(_, event) {
                if ($43bf50b0fa1441ac$var$isMouseEvent(event)) {
                    var rects = $43bf50b0fa1441ac$var$arrayFrom(instance.reference.getClientRects());
                    var cursorRect = rects.find(function(rect) {
                        return rect.left - 2 <= event.clientX && rect.right + 2 >= event.clientX && rect.top - 2 <= event.clientY && rect.bottom + 2 >= event.clientY;
                    });
                    var index = rects.indexOf(cursorRect);
                    cursorRectIndex = index > -1 ? index : cursorRectIndex;
                }
            },
            onHidden: function onHidden() {
                cursorRectIndex = -1;
            }
        };
    }
};
function $43bf50b0fa1441ac$var$getInlineBoundingClientRect(currentBasePlacement, boundingRect, clientRects, cursorRectIndex) {
    // Not an inline element, or placement is not yet known
    if (clientRects.length < 2 || currentBasePlacement === null) return boundingRect;
     // There are two rects and they are disjoined
    if (clientRects.length === 2 && cursorRectIndex >= 0 && clientRects[0].left > clientRects[1].right) return clientRects[cursorRectIndex] || boundingRect;
    switch(currentBasePlacement){
        case 'top':
        case 'bottom':
            var firstRect = clientRects[0];
            var lastRect = clientRects[clientRects.length - 1];
            var isTop = currentBasePlacement === 'top';
            var top = firstRect.top;
            var bottom = lastRect.bottom;
            var left = isTop ? firstRect.left : lastRect.left;
            var right = isTop ? firstRect.right : lastRect.right;
            var width = right - left;
            var height = bottom - top;
            return {
                top: top,
                bottom: bottom,
                left: left,
                right: right,
                width: width,
                height: height
            };
        case 'left':
        case 'right':
            var minLeft = Math.min.apply(Math, clientRects.map(function(rects) {
                return rects.left;
            }));
            var maxRight = Math.max.apply(Math, clientRects.map(function(rects) {
                return rects.right;
            }));
            var measureRects = clientRects.filter(function(rect) {
                return currentBasePlacement === 'left' ? rect.left === minLeft : rect.right === maxRight;
            });
            var _top = measureRects[0].top;
            var _bottom = measureRects[measureRects.length - 1].bottom;
            var _left = minLeft;
            var _right = maxRight;
            var _width = _right - _left;
            var _height = _bottom - _top;
            return {
                top: _top,
                bottom: _bottom,
                left: _left,
                right: _right,
                width: _width,
                height: _height
            };
        default:
            return boundingRect;
    }
}
var $43bf50b0fa1441ac$export$4bd4b47501432316 = {
    name: 'sticky',
    defaultValue: false,
    fn: function fn(instance) {
        var reference = instance.reference, popper = instance.popper;
        function getReference() {
            return instance.popperInstance ? instance.popperInstance.state.elements.reference : reference;
        }
        function shouldCheck(value) {
            return instance.props.sticky === true || instance.props.sticky === value;
        }
        var prevRefRect = null;
        var prevPopRect = null;
        function updatePosition() {
            var currentRefRect = shouldCheck('reference') ? getReference().getBoundingClientRect() : null;
            var currentPopRect = shouldCheck('popper') ? popper.getBoundingClientRect() : null;
            if (currentRefRect && $43bf50b0fa1441ac$var$areRectsDifferent(prevRefRect, currentRefRect) || currentPopRect && $43bf50b0fa1441ac$var$areRectsDifferent(prevPopRect, currentPopRect)) {
                if (instance.popperInstance) instance.popperInstance.update();
            }
            prevRefRect = currentRefRect;
            prevPopRect = currentPopRect;
            if (instance.state.isMounted) requestAnimationFrame(updatePosition);
        }
        return {
            onMount: function onMount() {
                if (instance.props.sticky) updatePosition();
            }
        };
    }
};
function $43bf50b0fa1441ac$var$areRectsDifferent(rectA, rectB) {
    if (rectA && rectB) return rectA.top !== rectB.top || rectA.right !== rectB.right || rectA.bottom !== rectB.bottom || rectA.left !== rectB.left;
    return true;
}
$43bf50b0fa1441ac$var$tippy.setDefaultProps({
    render: $43bf50b0fa1441ac$var$render
});
var $43bf50b0fa1441ac$export$2e2bcd8739ae039 = $43bf50b0fa1441ac$var$tippy;






const $2d3c68c3d1a48cfe$export$2a62b49acb270576 = function() {
    return window.document.body.classList.contains((0, $1e8c0ef90ed82280$export$a33e119b2316dcb7).getConfig().className.row);
};




var $4fb5b3896f1b27ab$exports = {};
/*!
 * a-color-picker (https://github.com/narsenico/a-color-picker)
 * 
 * Copyright (c) 2017-2018, Gianfranco Caldi.
 * Released under the MIT License.
 */ !function(e1, t) {
    $4fb5b3896f1b27ab$exports = t();
}("undefined" != typeof self ? self : $4fb5b3896f1b27ab$exports, function() {
    return function(e1) {
        var t = {};
        function r(i) {
            if (t[i]) return t[i].exports;
            var o = t[i] = {
                i: i,
                l: !1,
                exports: {}
            };
            return e1[i].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
        }
        return r.m = e1, r.c = t, r.d = function(e1, t, i) {
            r.o(e1, t) || Object.defineProperty(e1, t, {
                enumerable: !0,
                get: i
            });
        }, r.r = function(e1) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e1, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e1, "__esModule", {
                value: !0
            });
        }, r.t = function(e1, t) {
            if (1 & t && (e1 = r(e1)), 8 & t) return e1;
            if (4 & t && "object" == typeof e1 && e1 && e1.__esModule) return e1;
            var i = Object.create(null);
            if (r.r(i), Object.defineProperty(i, "default", {
                enumerable: !0,
                value: e1
            }), 2 & t && "string" != typeof e1) for(var o in e1)r.d(i, o, (function(t) {
                return e1[t];
            }).bind(null, o));
            return i;
        }, r.n = function(e1) {
            var t = e1 && e1.__esModule ? function() {
                return e1.default;
            } : function() {
                return e1;
            };
            return r.d(t, "a", t), t;
        }, r.o = function(e1, t) {
            return Object.prototype.hasOwnProperty.call(e1, t);
        }, r.p = "", r(r.s = 1);
    }([
        function(e1, t, r) {
            "use strict";
            /*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */ var i = r(3);
            function o(e1) {
                return !0 === i(e1) && "[object Object]" === Object.prototype.toString.call(e1);
            }
            e1.exports = function(e1) {
                var t, r;
                return !1 !== o(e1) && "function" == typeof (t = e1.constructor) && !1 !== o(r = t.prototype) && !1 !== r.hasOwnProperty("isPrototypeOf");
            };
        },
        function(e1, t, r) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.VERSION = t.PALETTE_MATERIAL_CHROME = t.PALETTE_MATERIAL_500 = t.COLOR_NAMES = t.getLuminance = t.intToRgb = t.rgbToInt = t.rgbToHsv = t.rgbToHsl = t.hslToRgb = t.rgbToHex = t.parseColor = t.parseColorToHsla = t.parseColorToHsl = t.parseColorToRgba = t.parseColorToRgb = t.from = t.createPicker = void 0;
            var i = function() {
                function e1(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var i = t[r];
                        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e1, i.key, i);
                    }
                }
                return function(t, r, i) {
                    return r && e1(t.prototype, r), i && e1(t, i), t;
                };
            }(), o = function(e1, t) {
                if (Array.isArray(e1)) return e1;
                if (Symbol.iterator in Object(e1)) return function(e1, t) {
                    var r = [], i = !0, o = !1, n = void 0;
                    try {
                        for(var s, a = e1[Symbol.iterator](); !(i = (s = a.next()).done) && (r.push(s.value), !t || r.length !== t); i = !0);
                    } catch (e1) {
                        o = !0, n = e1;
                    } finally{
                        try {
                            !i && a.return && a.return();
                        } finally{
                            if (o) throw n;
                        }
                    }
                    return r;
                }(e1, t);
                throw new TypeError("Invalid attempt to destructure non-iterable instance");
            }, n = r(2), s = l(r(0)), a = l(r(4));
            function l(e1) {
                return e1 && e1.__esModule ? e1 : {
                    default: e1
                };
            }
            function c(e1, t) {
                if (!(e1 instanceof t)) throw new TypeError("Cannot call a class as a function");
            }
            function u(e1) {
                if (Array.isArray(e1)) {
                    for(var t = 0, r = Array(e1.length); t < e1.length; t++)r[t] = e1[t];
                    return r;
                }
                return Array.from(e1);
            }
            /*!
 * a-color-picker
 * https://github.com/narsenico/a-color-picker
 *
 * Copyright (c) 2017-2019, Gianfranco Caldi.
 * Released under the MIT License.
 */ var h = "undefined" != typeof window && window.navigator.userAgent.indexOf("Edge") > -1, p = "undefined" != typeof window && window.navigator.userAgent.indexOf("rv:") > -1, d = {
                id: null,
                attachTo: "body",
                showHSL: !0,
                showRGB: !0,
                showHEX: !0,
                showAlpha: !1,
                color: "#ff0000",
                palette: null,
                paletteEditable: !1,
                useAlphaInPalette: "auto",
                slBarSize: [
                    232,
                    150
                ],
                hueBarSize: [
                    150,
                    11
                ],
                alphaBarSize: [
                    150,
                    11
                ]
            }, f = "COLOR", g = "RGBA_USER", b = "HSLA_USER";
            function v(e1, t, r) {
                return e1 ? e1 instanceof HTMLElement ? e1 : e1 instanceof NodeList ? e1[0] : "string" == typeof e1 ? document.querySelector(e1) : e1.jquery ? e1.get(0) : r ? t : null : t;
            }
            function m(e1) {
                var t = e1.getContext("2d"), r = +e1.width, i = +e1.height, s = t.createLinearGradient(1, 1, 1, i - 1);
                return s.addColorStop(0, "white"), s.addColorStop(1, "black"), {
                    setHue: function(e1) {
                        var o = t.createLinearGradient(1, 0, r - 1, 0);
                        o.addColorStop(0, "hsla(" + e1 + ", 100%, 50%, 0)"), o.addColorStop(1, "hsla(" + e1 + ", 100%, 50%, 1)"), t.fillStyle = s, t.fillRect(0, 0, r, i), t.fillStyle = o, t.globalCompositeOperation = "multiply", t.fillRect(0, 0, r, i), t.globalCompositeOperation = "source-over";
                    },
                    grabColor: function(e1, r) {
                        return t.getImageData(e1, r, 1, 1).data;
                    },
                    findColor: function(e1, t, s) {
                        var a = (0, n.rgbToHsv)(e1, t, s), l = o(a, 3), c = l[1], u = l[2];
                        return [
                            c * r,
                            i - u * i
                        ];
                    }
                };
            }
            function A(e1, t, r) {
                return null === e1 ? t : /^\s*$/.test(e1) ? r : !!/true|yes|1/i.test(e1) || !/false|no|0/i.test(e1) && t;
            }
            function y(e1, t, r) {
                if (null === e1) return t;
                if (/^\s*$/.test(e1)) return r;
                var i = e1.split(",").map(Number);
                return 2 === i.length && i[0] && i[1] ? i : t;
            }
            var k = function() {
                function e1(t, r) {
                    if (c(this, e1), r ? (t = v(t), this.options = Object.assign({}, d, r)) : t && (0, s.default)(t) ? (this.options = Object.assign({}, d, t), t = v(this.options.attachTo)) : (this.options = Object.assign({}, d), t = v((0, n.nvl)(t, this.options.attachTo))), !t) throw new Error("Container not found: " + this.options.attachTo);
                    !function(e1, t) {
                        var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "acp-";
                        if (t.hasAttribute(r + "show-hsl") && (e1.showHSL = A(t.getAttribute(r + "show-hsl"), d.showHSL, !0)), t.hasAttribute(r + "show-rgb") && (e1.showRGB = A(t.getAttribute(r + "show-rgb"), d.showRGB, !0)), t.hasAttribute(r + "show-hex") && (e1.showHEX = A(t.getAttribute(r + "show-hex"), d.showHEX, !0)), t.hasAttribute(r + "show-alpha") && (e1.showAlpha = A(t.getAttribute(r + "show-alpha"), d.showAlpha, !0)), t.hasAttribute(r + "palette-editable") && (e1.paletteEditable = A(t.getAttribute(r + "palette-editable"), d.paletteEditable, !0)), t.hasAttribute(r + "sl-bar-size") && (e1.slBarSize = y(t.getAttribute(r + "sl-bar-size"), d.slBarSize, [
                            232,
                            150
                        ])), t.hasAttribute(r + "hue-bar-size") && (e1.hueBarSize = y(t.getAttribute(r + "hue-bar-size"), d.hueBarSize, [
                            150,
                            11
                        ]), e1.alphaBarSize = e1.hueBarSize), t.hasAttribute(r + "palette")) {
                            var i = t.getAttribute(r + "palette");
                            switch(i){
                                case "PALETTE_MATERIAL_500":
                                    e1.palette = n.PALETTE_MATERIAL_500;
                                    break;
                                case "PALETTE_MATERIAL_CHROME":
                                case "":
                                    e1.palette = n.PALETTE_MATERIAL_CHROME;
                                    break;
                                default:
                                    e1.palette = i.split(/[;|]/);
                            }
                        }
                        t.hasAttribute(r + "color") && (e1.color = t.getAttribute(r + "color"));
                    }(this.options, t), this.H = 0, this.S = 0, this.L = 0, this.R = 0, this.G = 0, this.B = 0, this.A = 1, this.palette = {}, this.element = document.createElement("div"), this.options.id && (this.element.id = this.options.id), this.element.className = "a-color-picker", this.element.innerHTML = a.default, t.appendChild(this.element);
                    var i = this.element.querySelector(".a-color-picker-h");
                    this.setupHueCanvas(i), this.hueBarHelper = m(i), this.huePointer = this.element.querySelector(".a-color-picker-h+.a-color-picker-dot");
                    var o = this.element.querySelector(".a-color-picker-sl");
                    this.setupSlCanvas(o), this.slBarHelper = m(o), this.slPointer = this.element.querySelector(".a-color-picker-sl+.a-color-picker-dot"), this.preview = this.element.querySelector(".a-color-picker-preview"), this.setupClipboard(this.preview.querySelector(".a-color-picker-clipbaord")), this.options.showHSL ? (this.setupInput(this.inputH = this.element.querySelector(".a-color-picker-hsl>input[nameref=H]")), this.setupInput(this.inputS = this.element.querySelector(".a-color-picker-hsl>input[nameref=S]")), this.setupInput(this.inputL = this.element.querySelector(".a-color-picker-hsl>input[nameref=L]"))) : this.element.querySelector(".a-color-picker-hsl").remove(), this.options.showRGB ? (this.setupInput(this.inputR = this.element.querySelector(".a-color-picker-rgb>input[nameref=R]")), this.setupInput(this.inputG = this.element.querySelector(".a-color-picker-rgb>input[nameref=G]")), this.setupInput(this.inputB = this.element.querySelector(".a-color-picker-rgb>input[nameref=B]"))) : this.element.querySelector(".a-color-picker-rgb").remove(), this.options.showHEX ? this.setupInput(this.inputRGBHEX = this.element.querySelector("input[nameref=RGBHEX]")) : this.element.querySelector(".a-color-picker-rgbhex").remove(), this.options.paletteEditable || this.options.palette && this.options.palette.length > 0 ? this.setPalette(this.paletteRow = this.element.querySelector(".a-color-picker-palette")) : (this.paletteRow = this.element.querySelector(".a-color-picker-palette"), this.paletteRow.remove()), this.options.showAlpha ? (this.setupAlphaCanvas(this.element.querySelector(".a-color-picker-a")), this.alphaPointer = this.element.querySelector(".a-color-picker-a+.a-color-picker-dot")) : this.element.querySelector(".a-color-picker-alpha").remove(), this.element.style.width = this.options.slBarSize[0] + "px", this.onValueChanged(f, this.options.color);
                }
                return i(e1, [
                    {
                        key: "setupHueCanvas",
                        value: function(e1) {
                            var t = this;
                            e1.width = this.options.hueBarSize[0], e1.height = this.options.hueBarSize[1];
                            for(var r = e1.getContext("2d"), i = r.createLinearGradient(0, 0, this.options.hueBarSize[0], 0), o = 0; o <= 1; o += 1 / 360)i.addColorStop(o, "hsl(" + 360 * o + ", 100%, 50%)");
                            r.fillStyle = i, r.fillRect(0, 0, this.options.hueBarSize[0], this.options.hueBarSize[1]);
                            var s = function(r) {
                                var i = (0, n.limit)(r.clientX - e1.getBoundingClientRect().left, 0, t.options.hueBarSize[0]), o = Math.round(360 * i / t.options.hueBarSize[0]);
                                t.huePointer.style.left = i - 7 + "px", t.onValueChanged("H", o);
                            }, a = function e1() {
                                document.removeEventListener("mousemove", s), document.removeEventListener("mouseup", e1);
                            };
                            e1.addEventListener("mousedown", function(e1) {
                                s(e1), document.addEventListener("mousemove", s), document.addEventListener("mouseup", a);
                            });
                        }
                    },
                    {
                        key: "setupSlCanvas",
                        value: function(e1) {
                            var t = this;
                            e1.width = this.options.slBarSize[0], e1.height = this.options.slBarSize[1];
                            var r = function(r) {
                                var i = (0, n.limit)(r.clientX - e1.getBoundingClientRect().left, 0, t.options.slBarSize[0] - 1), o = (0, n.limit)(r.clientY - e1.getBoundingClientRect().top, 0, t.options.slBarSize[1] - 1), s = t.slBarHelper.grabColor(i, o);
                                t.slPointer.style.left = i - 7 + "px", t.slPointer.style.top = o - 7 + "px", t.onValueChanged("RGB", s);
                            }, i = function e1() {
                                document.removeEventListener("mousemove", r), document.removeEventListener("mouseup", e1);
                            };
                            e1.addEventListener("mousedown", function(e1) {
                                r(e1), document.addEventListener("mousemove", r), document.addEventListener("mouseup", i);
                            });
                        }
                    },
                    {
                        key: "setupAlphaCanvas",
                        value: function(e1) {
                            var t = this;
                            e1.width = this.options.alphaBarSize[0], e1.height = this.options.alphaBarSize[1];
                            var r = e1.getContext("2d"), i = r.createLinearGradient(0, 0, e1.width - 1, 0);
                            i.addColorStop(0, "hsla(0, 0%, 50%, 0)"), i.addColorStop(1, "hsla(0, 0%, 50%, 1)"), r.fillStyle = i, r.fillRect(0, 0, this.options.alphaBarSize[0], this.options.alphaBarSize[1]);
                            var o = function(r) {
                                var i = (0, n.limit)(r.clientX - e1.getBoundingClientRect().left, 0, t.options.alphaBarSize[0]), o = +(i / t.options.alphaBarSize[0]).toFixed(2);
                                t.alphaPointer.style.left = i - 7 + "px", t.onValueChanged("ALPHA", o);
                            }, s = function e1() {
                                document.removeEventListener("mousemove", o), document.removeEventListener("mouseup", e1);
                            };
                            e1.addEventListener("mousedown", function(e1) {
                                o(e1), document.addEventListener("mousemove", o), document.addEventListener("mouseup", s);
                            });
                        }
                    },
                    {
                        key: "setupInput",
                        value: function(e1) {
                            var t = this, r = +e1.min, i = +e1.max, o = e1.getAttribute("nameref");
                            e1.hasAttribute("select-on-focus") && e1.addEventListener("focus", function() {
                                e1.select();
                            }), "text" === e1.type ? e1.addEventListener("change", function() {
                                t.onValueChanged(o, e1.value);
                            }) : ((h || p) && e1.addEventListener("keydown", function(s) {
                                "Up" === s.key ? (e1.value = (0, n.limit)(+e1.value + 1, r, i), t.onValueChanged(o, e1.value), s.returnValue = !1) : "Down" === s.key && (e1.value = (0, n.limit)(+e1.value - 1, r, i), t.onValueChanged(o, e1.value), s.returnValue = !1);
                            }), e1.addEventListener("change", function() {
                                var s = +e1.value;
                                t.onValueChanged(o, (0, n.limit)(s, r, i));
                            }));
                        }
                    },
                    {
                        key: "setupClipboard",
                        value: function(e1) {
                            var t = this;
                            e1.title = "click to copy", e1.addEventListener("click", function() {
                                e1.value = (0, n.parseColor)([
                                    t.R,
                                    t.G,
                                    t.B,
                                    t.A
                                ], "hexcss4"), e1.select(), document.execCommand("copy");
                            });
                        }
                    },
                    {
                        key: "setPalette",
                        value: function(e1) {
                            var t = this, r = "auto" === this.options.useAlphaInPalette ? this.options.showAlpha : this.options.useAlphaInPalette, i = null;
                            switch(this.options.palette){
                                case "PALETTE_MATERIAL_500":
                                    i = n.PALETTE_MATERIAL_500;
                                    break;
                                case "PALETTE_MATERIAL_CHROME":
                                    i = n.PALETTE_MATERIAL_CHROME;
                                    break;
                                default:
                                    i = (0, n.ensureArray)(this.options.palette);
                            }
                            if (this.options.paletteEditable || i.length > 0) {
                                var o = function(r, i, o) {
                                    var n = e1.querySelector('.a-color-picker-palette-color[data-color="' + r + '"]') || document.createElement("div");
                                    n.className = "a-color-picker-palette-color", n.style.backgroundColor = r, n.setAttribute("data-color", r), n.title = r, e1.insertBefore(n, i), t.palette[r] = !0, o && t.onPaletteColorAdd(r);
                                }, s = function(r, i) {
                                    r ? (e1.removeChild(r), t.palette[r.getAttribute("data-color")] = !1, i && t.onPaletteColorRemove(r.getAttribute("data-color"))) : (e1.querySelectorAll(".a-color-picker-palette-color[data-color]").forEach(function(t) {
                                        e1.removeChild(t);
                                    }), Object.keys(t.palette).forEach(function(e1) {
                                        t.palette[e1] = !1;
                                    }), i && t.onPaletteColorRemove());
                                };
                                if (i.map(function(e1) {
                                    return (0, n.parseColor)(e1, r ? "rgbcss4" : "hex");
                                }).filter(function(e1) {
                                    return !!e1;
                                }).forEach(function(e1) {
                                    return o(e1);
                                }), this.options.paletteEditable) {
                                    var a = document.createElement("div");
                                    a.className = "a-color-picker-palette-color a-color-picker-palette-add", a.innerHTML = "+", e1.appendChild(a), e1.addEventListener("click", function(e1) {
                                        /a-color-picker-palette-add/.test(e1.target.className) ? e1.shiftKey ? s(null, !0) : o(r ? (0, n.parseColor)([
                                            t.R,
                                            t.G,
                                            t.B,
                                            t.A
                                        ], "rgbcss4") : (0, n.rgbToHex)(t.R, t.G, t.B), e1.target, !0) : /a-color-picker-palette-color/.test(e1.target.className) && (e1.shiftKey ? s(e1.target, !0) : t.onValueChanged(f, e1.target.getAttribute("data-color")));
                                    });
                                } else e1.addEventListener("click", function(e1) {
                                    /a-color-picker-palette-color/.test(e1.target.className) && t.onValueChanged(f, e1.target.getAttribute("data-color"));
                                });
                            } else e1.style.display = "none";
                        }
                    },
                    {
                        key: "updatePalette",
                        value: function(e1) {
                            this.paletteRow.innerHTML = "", this.palette = {}, this.paletteRow.parentElement || this.element.appendChild(this.paletteRow), this.options.palette = e1, this.setPalette(this.paletteRow);
                        }
                    },
                    {
                        key: "onValueChanged",
                        value: function(e1, t) {
                            var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {
                                silent: !1
                            };
                            switch(e1){
                                case "H":
                                    this.H = t;
                                    var i = (0, n.hslToRgb)(this.H, this.S, this.L), s = o(i, 3);
                                    this.R = s[0], this.G = s[1], this.B = s[2], this.slBarHelper.setHue(t), this.updatePointerH(this.H), this.updateInputHSL(this.H, this.S, this.L), this.updateInputRGB(this.R, this.G, this.B), this.updateInputRGBHEX(this.R, this.G, this.B);
                                    break;
                                case "S":
                                    this.S = t;
                                    var a = (0, n.hslToRgb)(this.H, this.S, this.L), l = o(a, 3);
                                    this.R = l[0], this.G = l[1], this.B = l[2], this.updatePointerSL(this.H, this.S, this.L), this.updateInputHSL(this.H, this.S, this.L), this.updateInputRGB(this.R, this.G, this.B), this.updateInputRGBHEX(this.R, this.G, this.B);
                                    break;
                                case "L":
                                    this.L = t;
                                    var c = (0, n.hslToRgb)(this.H, this.S, this.L), u = o(c, 3);
                                    this.R = u[0], this.G = u[1], this.B = u[2], this.updatePointerSL(this.H, this.S, this.L), this.updateInputHSL(this.H, this.S, this.L), this.updateInputRGB(this.R, this.G, this.B), this.updateInputRGBHEX(this.R, this.G, this.B);
                                    break;
                                case "R":
                                    this.R = t;
                                    var h = (0, n.rgbToHsl)(this.R, this.G, this.B), p = o(h, 3);
                                    this.H = p[0], this.S = p[1], this.L = p[2], this.slBarHelper.setHue(this.H), this.updatePointerH(this.H), this.updatePointerSL(this.H, this.S, this.L), this.updateInputHSL(this.H, this.S, this.L), this.updateInputRGBHEX(this.R, this.G, this.B);
                                    break;
                                case "G":
                                    this.G = t;
                                    var d = (0, n.rgbToHsl)(this.R, this.G, this.B), v = o(d, 3);
                                    this.H = v[0], this.S = v[1], this.L = v[2], this.slBarHelper.setHue(this.H), this.updatePointerH(this.H), this.updatePointerSL(this.H, this.S, this.L), this.updateInputHSL(this.H, this.S, this.L), this.updateInputRGBHEX(this.R, this.G, this.B);
                                    break;
                                case "B":
                                    this.B = t;
                                    var m = (0, n.rgbToHsl)(this.R, this.G, this.B), A = o(m, 3);
                                    this.H = A[0], this.S = A[1], this.L = A[2], this.slBarHelper.setHue(this.H), this.updatePointerH(this.H), this.updatePointerSL(this.H, this.S, this.L), this.updateInputHSL(this.H, this.S, this.L), this.updateInputRGBHEX(this.R, this.G, this.B);
                                    break;
                                case "RGB":
                                    var y = o(t, 3);
                                    this.R = y[0], this.G = y[1], this.B = y[2];
                                    var k = (0, n.rgbToHsl)(this.R, this.G, this.B), F = o(k, 3);
                                    this.H = F[0], this.S = F[1], this.L = F[2], this.updateInputHSL(this.H, this.S, this.L), this.updateInputRGB(this.R, this.G, this.B), this.updateInputRGBHEX(this.R, this.G, this.B);
                                    break;
                                case g:
                                    var E = o(t, 4);
                                    this.R = E[0], this.G = E[1], this.B = E[2], this.A = E[3];
                                    var H = (0, n.rgbToHsl)(this.R, this.G, this.B), B = o(H, 3);
                                    this.H = B[0], this.S = B[1], this.L = B[2], this.slBarHelper.setHue(this.H), this.updatePointerH(this.H), this.updatePointerSL(this.H, this.S, this.L), this.updateInputHSL(this.H, this.S, this.L), this.updateInputRGB(this.R, this.G, this.B), this.updateInputRGBHEX(this.R, this.G, this.B), this.updatePointerA(this.A);
                                    break;
                                case b:
                                    var R = o(t, 4);
                                    this.H = R[0], this.S = R[1], this.L = R[2], this.A = R[3];
                                    var C = (0, n.hslToRgb)(this.H, this.S, this.L), S = o(C, 3);
                                    this.R = S[0], this.G = S[1], this.B = S[2], this.slBarHelper.setHue(this.H), this.updatePointerH(this.H), this.updatePointerSL(this.H, this.S, this.L), this.updateInputHSL(this.H, this.S, this.L), this.updateInputRGB(this.R, this.G, this.B), this.updateInputRGBHEX(this.R, this.G, this.B), this.updatePointerA(this.A);
                                    break;
                                case "RGBHEX":
                                    var L = (0, n.cssColorToRgb)(t) || [
                                        this.R,
                                        this.G,
                                        this.B
                                    ], w = o(L, 3);
                                    this.R = w[0], this.G = w[1], this.B = w[2];
                                    var T = (0, n.rgbToHsl)(this.R, this.G, this.B), x = o(T, 3);
                                    this.H = x[0], this.S = x[1], this.L = x[2], this.slBarHelper.setHue(this.H), this.updatePointerH(this.H), this.updatePointerSL(this.H, this.S, this.L), this.updateInputHSL(this.H, this.S, this.L), this.updateInputRGB(this.R, this.G, this.B);
                                    break;
                                case f:
                                    var G = (0, n.parseColor)(t, "rgba") || [
                                        0,
                                        0,
                                        0,
                                        1
                                    ], I = o(G, 4);
                                    this.R = I[0], this.G = I[1], this.B = I[2], this.A = I[3];
                                    var P = (0, n.rgbToHsl)(this.R, this.G, this.B), D = o(P, 3);
                                    this.H = D[0], this.S = D[1], this.L = D[2], this.slBarHelper.setHue(this.H), this.updatePointerH(this.H), this.updatePointerSL(this.H, this.S, this.L), this.updateInputHSL(this.H, this.S, this.L), this.updateInputRGB(this.R, this.G, this.B), this.updateInputRGBHEX(this.R, this.G, this.B), this.updatePointerA(this.A);
                                    break;
                                case "ALPHA":
                                    this.A = t;
                            }
                            1 === this.A ? this.preview.style.backgroundColor = "rgb(" + this.R + "," + this.G + "," + this.B + ")" : this.preview.style.backgroundColor = "rgba(" + this.R + "," + this.G + "," + this.B + "," + this.A + ")", r && r.silent || this.onchange && this.onchange(this.preview.style.backgroundColor);
                        }
                    },
                    {
                        key: "onPaletteColorAdd",
                        value: function(e1) {
                            this.oncoloradd && this.oncoloradd(e1);
                        }
                    },
                    {
                        key: "onPaletteColorRemove",
                        value: function(e1) {
                            this.oncolorremove && this.oncolorremove(e1);
                        }
                    },
                    {
                        key: "updateInputHSL",
                        value: function(e1, t, r) {
                            this.options.showHSL && (this.inputH.value = e1, this.inputS.value = t, this.inputL.value = r);
                        }
                    },
                    {
                        key: "updateInputRGB",
                        value: function(e1, t, r) {
                            this.options.showRGB && (this.inputR.value = e1, this.inputG.value = t, this.inputB.value = r);
                        }
                    },
                    {
                        key: "updateInputRGBHEX",
                        value: function(e1, t, r) {
                            this.options.showHEX && (this.inputRGBHEX.value = (0, n.rgbToHex)(e1, t, r));
                        }
                    },
                    {
                        key: "updatePointerH",
                        value: function(e1) {
                            var t = this.options.hueBarSize[0] * e1 / 360;
                            this.huePointer.style.left = t - 7 + "px";
                        }
                    },
                    {
                        key: "updatePointerSL",
                        value: function(e1, t, r) {
                            var i = (0, n.hslToRgb)(e1, t, r), s = o(i, 3), a = s[0], l = s[1], c = s[2], u = this.slBarHelper.findColor(a, l, c), h = o(u, 2), p = h[0], d = h[1];
                            p >= 0 && (this.slPointer.style.left = p - 7 + "px", this.slPointer.style.top = d - 7 + "px");
                        }
                    },
                    {
                        key: "updatePointerA",
                        value: function(e1) {
                            if (this.options.showAlpha) {
                                var t = this.options.alphaBarSize[0] * e1;
                                this.alphaPointer.style.left = t - 7 + "px";
                            }
                        }
                    }
                ]), e1;
            }(), F = function() {
                function e1(t) {
                    c(this, e1), this.name = t, this.listeners = [];
                }
                return i(e1, [
                    {
                        key: "on",
                        value: function(e1) {
                            e1 && this.listeners.push(e1);
                        }
                    },
                    {
                        key: "off",
                        value: function(e1) {
                            this.listeners = e1 ? this.listeners.filter(function(t) {
                                return t !== e1;
                            }) : [];
                        }
                    },
                    {
                        key: "emit",
                        value: function(e1, t) {
                            for(var r = this.listeners.slice(0), i = 0; i < r.length; i++)r[i].apply(t, e1);
                        }
                    }
                ]), e1;
            }();
            function E(e1, t) {
                var r = new k(e1, t), i = {
                    change: new F("change"),
                    coloradd: new F("coloradd"),
                    colorremove: new F("colorremove")
                }, s = !0, a = {}, l = {
                    get element () {
                        return r.element;
                    },
                    get rgb () {
                        return [
                            r.R,
                            r.G,
                            r.B
                        ];
                    },
                    set rgb (e){
                        var t1 = o(e, 3), i1 = t1[0], s1 = t1[1], a1 = t1[2], l1 = [
                            (0, n.limit)(i1, 0, 255),
                            (0, n.limit)(s1, 0, 255),
                            (0, n.limit)(a1, 0, 255)
                        ];
                        i1 = l1[0], s1 = l1[1], a1 = l1[2], r.onValueChanged(g, [
                            i1,
                            s1,
                            a1,
                            1
                        ]);
                    },
                    get hsl () {
                        return [
                            r.H,
                            r.S,
                            r.L
                        ];
                    },
                    set hsl (e){
                        var t2 = o(e, 3), i2 = t2[0], s2 = t2[1], a2 = t2[2], l2 = [
                            (0, n.limit)(i2, 0, 360),
                            (0, n.limit)(s2, 0, 100),
                            (0, n.limit)(a2, 0, 100)
                        ];
                        i2 = l2[0], s2 = l2[1], a2 = l2[2], r.onValueChanged(b, [
                            i2,
                            s2,
                            a2,
                            1
                        ]);
                    },
                    get rgbhex () {
                        return this.all.hex;
                    },
                    get rgba () {
                        return [
                            r.R,
                            r.G,
                            r.B,
                            r.A
                        ];
                    },
                    set rgba (e){
                        var t3 = o(e, 4), i3 = t3[0], s3 = t3[1], a3 = t3[2], l3 = t3[3], c = [
                            (0, n.limit)(i3, 0, 255),
                            (0, n.limit)(s3, 0, 255),
                            (0, n.limit)(a3, 0, 255),
                            (0, n.limit)(l3, 0, 1)
                        ];
                        i3 = c[0], s3 = c[1], a3 = c[2], l3 = c[3], r.onValueChanged(g, [
                            i3,
                            s3,
                            a3,
                            l3
                        ]);
                    },
                    get hsla () {
                        return [
                            r.H,
                            r.S,
                            r.L,
                            r.A
                        ];
                    },
                    set hsla (e){
                        var t4 = o(e, 4), i4 = t4[0], s4 = t4[1], a4 = t4[2], l4 = t4[3], c1 = [
                            (0, n.limit)(i4, 0, 360),
                            (0, n.limit)(s4, 0, 100),
                            (0, n.limit)(a4, 0, 100),
                            (0, n.limit)(l4, 0, 1)
                        ];
                        i4 = c1[0], s4 = c1[1], a4 = c1[2], l4 = c1[3], r.onValueChanged(b, [
                            i4,
                            s4,
                            a4,
                            l4
                        ]);
                    },
                    get color () {
                        return this.all.toString();
                    },
                    set color (e){
                        r.onValueChanged(f, e);
                    },
                    setColor: function(e1) {
                        var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                        r.onValueChanged(f, e1, {
                            silent: t
                        });
                    },
                    get all () {
                        if (s) {
                            var e2 = [
                                r.R,
                                r.G,
                                r.B,
                                r.A
                            ], t5 = r.A < 1 ? "rgba(" + r.R + "," + r.G + "," + r.B + "," + r.A + ")" : n.rgbToHex.apply(void 0, e2);
                            (a = (0, n.parseColor)(e2, a)).toString = function() {
                                return t5;
                            }, s = !1;
                        }
                        return Object.assign({}, a);
                    },
                    get onchange () {
                        return i.change && i.change.listeners[0];
                    },
                    set onchange (e){
                        this.off("change").on("change", e);
                    },
                    get oncoloradd () {
                        return i.coloradd && i.coloradd.listeners[0];
                    },
                    set oncoloradd (e){
                        this.off("coloradd").on("coloradd", e);
                    },
                    get oncolorremove () {
                        return i.colorremove && i.colorremove.listeners[0];
                    },
                    set oncolorremove (e){
                        this.off("colorremove").on("colorremove", e);
                    },
                    get palette () {
                        return Object.keys(r.palette).filter(function(e1) {
                            return r.palette[e1];
                        });
                    },
                    set palette (e){
                        r.updatePalette(e);
                    },
                    show: function() {
                        r.element.classList.remove("hidden");
                    },
                    hide: function() {
                        r.element.classList.add("hidden");
                    },
                    toggle: function() {
                        r.element.classList.toggle("hidden");
                    },
                    on: function(e1, t) {
                        return e1 && i[e1] && i[e1].on(t), this;
                    },
                    off: function(e1, t) {
                        return e1 && i[e1] && i[e1].off(t), this;
                    },
                    destroy: function() {
                        i.change.off(), i.coloradd.off(), i.colorremove.off(), r.element.remove(), i = null, r = null;
                    }
                };
                return r.onchange = function() {
                    for(var e1 = arguments.length, t = Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                    s = !0, i.change.emit([
                        l
                    ].concat(t), l);
                }, r.oncoloradd = function() {
                    for(var e1 = arguments.length, t = Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                    i.coloradd.emit([
                        l
                    ].concat(t), l);
                }, r.oncolorremove = function() {
                    for(var e1 = arguments.length, t = Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                    i.colorremove.emit([
                        l
                    ].concat(t), l);
                }, r.element.ctrl = l, l;
            }
            if ("undefined" != typeof window && !document.querySelector('head>style[data-source="a-color-picker"]')) {
                var H = r(5).toString(), B = document.createElement("style");
                B.setAttribute("type", "text/css"), B.setAttribute("data-source", "a-color-picker"), B.innerHTML = H, document.querySelector("head").appendChild(B);
            }
            t.createPicker = E, t.from = function(e1, t) {
                var r = (function(e1) {
                    return e1 ? Array.isArray(e1) ? e1 : e1 instanceof HTMLElement ? [
                        e1
                    ] : e1 instanceof NodeList ? [].concat(u(e1)) : "string" == typeof e1 ? [].concat(u(document.querySelectorAll(e1))) : e1.jquery ? e1.get() : [] : [];
                })(e1).map(function(e1, r) {
                    var i = E(e1, t);
                    return i.index = r, i;
                });
                return r.on = function(e1, t) {
                    return r.forEach(function(r) {
                        return r.on(e1, t);
                    }), this;
                }, r.off = function(e1) {
                    return r.forEach(function(t) {
                        return t.off(e1);
                    }), this;
                }, r;
            }, t.parseColorToRgb = n.parseColorToRgb, t.parseColorToRgba = n.parseColorToRgba, t.parseColorToHsl = n.parseColorToHsl, t.parseColorToHsla = n.parseColorToHsla, t.parseColor = n.parseColor, t.rgbToHex = n.rgbToHex, t.hslToRgb = n.hslToRgb, t.rgbToHsl = n.rgbToHsl, t.rgbToHsv = n.rgbToHsv, t.rgbToInt = n.rgbToInt, t.intToRgb = n.intToRgb, t.getLuminance = n.getLuminance, t.COLOR_NAMES = n.COLOR_NAMES, t.PALETTE_MATERIAL_500 = n.PALETTE_MATERIAL_500, t.PALETTE_MATERIAL_CHROME = n.PALETTE_MATERIAL_CHROME, t.VERSION = "1.2.1";
        },
        function(e1, t, r) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.nvl = t.ensureArray = t.limit = t.getLuminance = t.parseColor = t.parseColorToHsla = t.parseColorToHsl = t.cssHslaToHsla = t.cssHslToHsl = t.parseColorToRgba = t.parseColorToRgb = t.cssRgbaToRgba = t.cssRgbToRgb = t.cssColorToRgba = t.cssColorToRgb = t.intToRgb = t.rgbToInt = t.rgbToHsv = t.rgbToHsl = t.hslToRgb = t.rgbToHex = t.PALETTE_MATERIAL_CHROME = t.PALETTE_MATERIAL_500 = t.COLOR_NAMES = void 0;
            var i = function(e1, t) {
                if (Array.isArray(e1)) return e1;
                if (Symbol.iterator in Object(e1)) return function(e1, t) {
                    var r = [], i = !0, o = !1, n = void 0;
                    try {
                        for(var s, a = e1[Symbol.iterator](); !(i = (s = a.next()).done) && (r.push(s.value), !t || r.length !== t); i = !0);
                    } catch (e1) {
                        o = !0, n = e1;
                    } finally{
                        try {
                            !i && a.return && a.return();
                        } finally{
                            if (o) throw n;
                        }
                    }
                    return r;
                }(e1, t);
                throw new TypeError("Invalid attempt to destructure non-iterable instance");
            }, o = function(e1) {
                return e1 && e1.__esModule ? e1 : {
                    default: e1
                };
            }(r(0));
            function n(e1) {
                if (Array.isArray(e1)) {
                    for(var t = 0, r = Array(e1.length); t < e1.length; t++)r[t] = e1[t];
                    return r;
                }
                return Array.from(e1);
            }
            var s = {
                aliceblue: "#F0F8FF",
                antiquewhite: "#FAEBD7",
                aqua: "#00FFFF",
                aquamarine: "#7FFFD4",
                azure: "#F0FFFF",
                beige: "#F5F5DC",
                bisque: "#FFE4C4",
                black: "#000000",
                blanchedalmond: "#FFEBCD",
                blue: "#0000FF",
                blueviolet: "#8A2BE2",
                brown: "#A52A2A",
                burlywood: "#DEB887",
                cadetblue: "#5F9EA0",
                chartreuse: "#7FFF00",
                chocolate: "#D2691E",
                coral: "#FF7F50",
                cornflowerblue: "#6495ED",
                cornsilk: "#FFF8DC",
                crimson: "#DC143C",
                cyan: "#00FFFF",
                darkblue: "#00008B",
                darkcyan: "#008B8B",
                darkgoldenrod: "#B8860B",
                darkgray: "#A9A9A9",
                darkgrey: "#A9A9A9",
                darkgreen: "#006400",
                darkkhaki: "#BDB76B",
                darkmagenta: "#8B008B",
                darkolivegreen: "#556B2F",
                darkorange: "#FF8C00",
                darkorchid: "#9932CC",
                darkred: "#8B0000",
                darksalmon: "#E9967A",
                darkseagreen: "#8FBC8F",
                darkslateblue: "#483D8B",
                darkslategray: "#2F4F4F",
                darkslategrey: "#2F4F4F",
                darkturquoise: "#00CED1",
                darkviolet: "#9400D3",
                deeppink: "#FF1493",
                deepskyblue: "#00BFFF",
                dimgray: "#696969",
                dimgrey: "#696969",
                dodgerblue: "#1E90FF",
                firebrick: "#B22222",
                floralwhite: "#FFFAF0",
                forestgreen: "#228B22",
                fuchsia: "#FF00FF",
                gainsboro: "#DCDCDC",
                ghostwhite: "#F8F8FF",
                gold: "#FFD700",
                goldenrod: "#DAA520",
                gray: "#808080",
                grey: "#808080",
                green: "#008000",
                greenyellow: "#ADFF2F",
                honeydew: "#F0FFF0",
                hotpink: "#FF69B4",
                "indianred ": "#CD5C5C",
                "indigo ": "#4B0082",
                ivory: "#FFFFF0",
                khaki: "#F0E68C",
                lavender: "#E6E6FA",
                lavenderblush: "#FFF0F5",
                lawngreen: "#7CFC00",
                lemonchiffon: "#FFFACD",
                lightblue: "#ADD8E6",
                lightcoral: "#F08080",
                lightcyan: "#E0FFFF",
                lightgoldenrodyellow: "#FAFAD2",
                lightgray: "#D3D3D3",
                lightgrey: "#D3D3D3",
                lightgreen: "#90EE90",
                lightpink: "#FFB6C1",
                lightsalmon: "#FFA07A",
                lightseagreen: "#20B2AA",
                lightskyblue: "#87CEFA",
                lightslategray: "#778899",
                lightslategrey: "#778899",
                lightsteelblue: "#B0C4DE",
                lightyellow: "#FFFFE0",
                lime: "#00FF00",
                limegreen: "#32CD32",
                linen: "#FAF0E6",
                magenta: "#FF00FF",
                maroon: "#800000",
                mediumaquamarine: "#66CDAA",
                mediumblue: "#0000CD",
                mediumorchid: "#BA55D3",
                mediumpurple: "#9370DB",
                mediumseagreen: "#3CB371",
                mediumslateblue: "#7B68EE",
                mediumspringgreen: "#00FA9A",
                mediumturquoise: "#48D1CC",
                mediumvioletred: "#C71585",
                midnightblue: "#191970",
                mintcream: "#F5FFFA",
                mistyrose: "#FFE4E1",
                moccasin: "#FFE4B5",
                navajowhite: "#FFDEAD",
                navy: "#000080",
                oldlace: "#FDF5E6",
                olive: "#808000",
                olivedrab: "#6B8E23",
                orange: "#FFA500",
                orangered: "#FF4500",
                orchid: "#DA70D6",
                palegoldenrod: "#EEE8AA",
                palegreen: "#98FB98",
                paleturquoise: "#AFEEEE",
                palevioletred: "#DB7093",
                papayawhip: "#FFEFD5",
                peachpuff: "#FFDAB9",
                peru: "#CD853F",
                pink: "#FFC0CB",
                plum: "#DDA0DD",
                powderblue: "#B0E0E6",
                purple: "#800080",
                rebeccapurple: "#663399",
                red: "#FF0000",
                rosybrown: "#BC8F8F",
                royalblue: "#4169E1",
                saddlebrown: "#8B4513",
                salmon: "#FA8072",
                sandybrown: "#F4A460",
                seagreen: "#2E8B57",
                seashell: "#FFF5EE",
                sienna: "#A0522D",
                silver: "#C0C0C0",
                skyblue: "#87CEEB",
                slateblue: "#6A5ACD",
                slategray: "#708090",
                slategrey: "#708090",
                snow: "#FFFAFA",
                springgreen: "#00FF7F",
                steelblue: "#4682B4",
                tan: "#D2B48C",
                teal: "#008080",
                thistle: "#D8BFD8",
                tomato: "#FF6347",
                turquoise: "#40E0D0",
                violet: "#EE82EE",
                wheat: "#F5DEB3",
                white: "#FFFFFF",
                whitesmoke: "#F5F5F5",
                yellow: "#FFFF00",
                yellowgreen: "#9ACD32"
            };
            function a(e1, t, r) {
                return e1 = +e1, isNaN(e1) ? t : e1 < t ? t : e1 > r ? r : e1;
            }
            function l(e1, t) {
                return null == e1 ? t : e1;
            }
            function c(e1, t, r) {
                var i = [
                    a(e1, 0, 255),
                    a(t, 0, 255),
                    a(r, 0, 255)
                ];
                return "#" + ("000000" + ((e1 = i[0]) << 16 | (t = i[1]) << 8 | (r = i[2])).toString(16)).slice(-6);
            }
            function u(e1, t, r) {
                var i = void 0, o = void 0, n = void 0, s = [
                    a(e1, 0, 360) / 360,
                    a(t, 0, 100) / 100,
                    a(r, 0, 100) / 100
                ];
                if (e1 = s[0], r = s[2], 0 == (t = s[1])) i = o = n = r;
                else {
                    var l = function(e1, t, r) {
                        return r < 0 && (r += 1), r > 1 && (r -= 1), r < 1 / 6 ? e1 + 6 * (t - e1) * r : r < .5 ? t : r < 2 / 3 ? e1 + (t - e1) * (2 / 3 - r) * 6 : e1;
                    }, c = r < .5 ? r * (1 + t) : r + t - r * t, u = 2 * r - c;
                    i = l(u, c, e1 + 1 / 3), o = l(u, c, e1), n = l(u, c, e1 - 1 / 3);
                }
                return [
                    255 * i,
                    255 * o,
                    255 * n
                ].map(Math.round);
            }
            function h(e1, t, r) {
                var i = [
                    a(e1, 0, 255) / 255,
                    a(t, 0, 255) / 255,
                    a(r, 0, 255) / 255
                ];
                e1 = i[0], t = i[1], r = i[2];
                var o = Math.max(e1, t, r), n = Math.min(e1, t, r), s = void 0, l = void 0, c = (o + n) / 2;
                if (o == n) s = l = 0;
                else {
                    var u = o - n;
                    switch(l = c > .5 ? u / (2 - o - n) : u / (o + n), o){
                        case e1:
                            s = (t - r) / u + (t < r ? 6 : 0);
                            break;
                        case t:
                            s = (r - e1) / u + 2;
                            break;
                        case r:
                            s = (e1 - t) / u + 4;
                    }
                    s /= 6;
                }
                return [
                    360 * s,
                    100 * l,
                    100 * c
                ].map(Math.round);
            }
            function p(e1, t, r) {
                return e1 << 16 | t << 8 | r;
            }
            function d(e1) {
                if (e1) {
                    var t = s[e1.toString().toLowerCase()], r = /^\s*#?((([0-9A-F])([0-9A-F])([0-9A-F]))|(([0-9A-F]{2})([0-9A-F]{2})([0-9A-F]{2})))\s*$/i.exec(t || e1) || [], o = i(r, 10), n = o[3], a = o[4], l = o[5], c = o[7], u = o[8], h = o[9];
                    if (void 0 !== n) return [
                        parseInt(n + n, 16),
                        parseInt(a + a, 16),
                        parseInt(l + l, 16)
                    ];
                    if (void 0 !== c) return [
                        parseInt(c, 16),
                        parseInt(u, 16),
                        parseInt(h, 16)
                    ];
                }
            }
            function f(e1) {
                if (e1) {
                    var t = s[e1.toString().toLowerCase()], r = /^\s*#?((([0-9A-F])([0-9A-F])([0-9A-F])([0-9A-F])?)|(([0-9A-F]{2})([0-9A-F]{2})([0-9A-F]{2})([0-9A-F]{2})?))\s*$/i.exec(t || e1) || [], o = i(r, 12), n = o[3], a = o[4], l = o[5], c = o[6], u = o[8], h = o[9], p = o[10], d = o[11];
                    if (void 0 !== n) return [
                        parseInt(n + n, 16),
                        parseInt(a + a, 16),
                        parseInt(l + l, 16),
                        c ? +(parseInt(c + c, 16) / 255).toFixed(2) : 1
                    ];
                    if (void 0 !== u) return [
                        parseInt(u, 16),
                        parseInt(h, 16),
                        parseInt(p, 16),
                        d ? +(parseInt(d, 16) / 255).toFixed(2) : 1
                    ];
                }
            }
            function g(e1) {
                if (e1) {
                    var t = /^rgb\((\d+)[\s,](\d+)[\s,](\d+)\)/i.exec(e1) || [], r = i(t, 4), o = r[0], n = r[1], s = r[2], l = r[3];
                    return o ? [
                        a(n, 0, 255),
                        a(s, 0, 255),
                        a(l, 0, 255)
                    ] : void 0;
                }
            }
            function b(e1) {
                if (e1) {
                    var t = /^rgba?\((\d+)\s*[\s,]\s*(\d+)\s*[\s,]\s*(\d+)(\s*[\s,]\s*(\d*(.\d+)?))?\)/i.exec(e1) || [], r = i(t, 6), o = r[0], n = r[1], s = r[2], c = r[3], u = r[5];
                    return o ? [
                        a(n, 0, 255),
                        a(s, 0, 255),
                        a(c, 0, 255),
                        a(l(u, 1), 0, 1)
                    ] : void 0;
                }
            }
            function v(e1) {
                if (Array.isArray(e1)) return [
                    a(e1[0], 0, 255),
                    a(e1[1], 0, 255),
                    a(e1[2], 0, 255),
                    a(l(e1[3], 1), 0, 1)
                ];
                var t = f(e1) || b(e1);
                return t && 3 === t.length && t.push(1), t;
            }
            function m(e1) {
                if (e1) {
                    var t = /^hsl\((\d+)[\s,](\d+)[\s,](\d+)\)/i.exec(e1) || [], r = i(t, 4), o = r[0], n = r[1], s = r[2], l = r[3];
                    return o ? [
                        a(n, 0, 360),
                        a(s, 0, 100),
                        a(l, 0, 100)
                    ] : void 0;
                }
            }
            function A(e1) {
                if (e1) {
                    var t = /^hsla?\((\d+)\s*[\s,]\s*(\d+)\s*[\s,]\s*(\d+)(\s*[\s,]\s*(\d*(.\d+)?))?\)/i.exec(e1) || [], r = i(t, 6), o = r[0], n = r[1], s = r[2], c = r[3], u = r[5];
                    return o ? [
                        a(n, 0, 255),
                        a(s, 0, 255),
                        a(c, 0, 255),
                        a(l(u, 1), 0, 1)
                    ] : void 0;
                }
            }
            function y(e1) {
                if (Array.isArray(e1)) return [
                    a(e1[0], 0, 360),
                    a(e1[1], 0, 100),
                    a(e1[2], 0, 100),
                    a(l(e1[3], 1), 0, 1)
                ];
                var t = A(e1);
                return t && 3 === t.length && t.push(1), t;
            }
            function k(e1, t) {
                switch(t){
                    case "rgb":
                    default:
                        return e1.slice(0, 3);
                    case "rgbcss":
                        return "rgb(" + e1[0] + ", " + e1[1] + ", " + e1[2] + ")";
                    case "rgbcss4":
                        return "rgb(" + e1[0] + ", " + e1[1] + ", " + e1[2] + ", " + e1[3] + ")";
                    case "rgba":
                        return e1;
                    case "rgbacss":
                        return "rgba(" + e1[0] + ", " + e1[1] + ", " + e1[2] + ", " + e1[3] + ")";
                    case "hsl":
                        return h.apply(void 0, n(e1));
                    case "hslcss":
                        return "hsl(" + (e1 = h.apply(void 0, n(e1)))[0] + ", " + e1[1] + ", " + e1[2] + ")";
                    case "hslcss4":
                        var r = h.apply(void 0, n(e1));
                        return "hsl(" + r[0] + ", " + r[1] + ", " + r[2] + ", " + e1[3] + ")";
                    case "hsla":
                        return [].concat(n(h.apply(void 0, n(e1))), [
                            e1[3]
                        ]);
                    case "hslacss":
                        var i = h.apply(void 0, n(e1));
                        return "hsla(" + i[0] + ", " + i[1] + ", " + i[2] + ", " + e1[3] + ")";
                    case "hex":
                        return c.apply(void 0, n(e1));
                    case "hexcss4":
                        return c.apply(void 0, n(e1)) + ("00" + parseInt(255 * e1[3]).toString(16)).slice(-2);
                    case "int":
                        return p.apply(void 0, n(e1));
                }
            }
            t.COLOR_NAMES = s, t.PALETTE_MATERIAL_500 = [
                "#F44336",
                "#E91E63",
                "#E91E63",
                "#9C27B0",
                "#9C27B0",
                "#673AB7",
                "#673AB7",
                "#3F51B5",
                "#3F51B5",
                "#2196F3",
                "#2196F3",
                "#03A9F4",
                "#03A9F4",
                "#00BCD4",
                "#00BCD4",
                "#009688",
                "#009688",
                "#4CAF50",
                "#4CAF50",
                "#8BC34A",
                "#8BC34A",
                "#CDDC39",
                "#CDDC39",
                "#FFEB3B",
                "#FFEB3B",
                "#FFC107",
                "#FFC107",
                "#FF9800",
                "#FF9800",
                "#FF5722",
                "#FF5722",
                "#795548",
                "#795548",
                "#9E9E9E",
                "#9E9E9E",
                "#607D8B",
                "#607D8B"
            ], t.PALETTE_MATERIAL_CHROME = [
                "#f44336",
                "#e91e63",
                "#9c27b0",
                "#673ab7",
                "#3f51b5",
                "#2196f3",
                "#03a9f4",
                "#00bcd4",
                "#009688",
                "#4caf50",
                "#8bc34a",
                "#cddc39",
                "#ffeb3b",
                "#ffc107",
                "#ff9800",
                "#ff5722",
                "#795548",
                "#9e9e9e",
                "#607d8b"
            ], t.rgbToHex = c, t.hslToRgb = u, t.rgbToHsl = h, t.rgbToHsv = function(e1, t, r) {
                var i = [
                    a(e1, 0, 255) / 255,
                    a(t, 0, 255) / 255,
                    a(r, 0, 255) / 255
                ];
                e1 = i[0], t = i[1], r = i[2];
                var o, n = Math.max(e1, t, r), s = Math.min(e1, t, r), l = void 0, c = n, u = n - s;
                if (o = 0 === n ? 0 : u / n, n == s) l = 0;
                else {
                    switch(n){
                        case e1:
                            l = (t - r) / u + (t < r ? 6 : 0);
                            break;
                        case t:
                            l = (r - e1) / u + 2;
                            break;
                        case r:
                            l = (e1 - t) / u + 4;
                    }
                    l /= 6;
                }
                return [
                    l,
                    o,
                    c
                ];
            }, t.rgbToInt = p, t.intToRgb = function(e1) {
                return [
                    e1 >> 16 & 255,
                    e1 >> 8 & 255,
                    255 & e1
                ];
            }, t.cssColorToRgb = d, t.cssColorToRgba = f, t.cssRgbToRgb = g, t.cssRgbaToRgba = b, t.parseColorToRgb = function(e1) {
                return Array.isArray(e1) ? e1 = [
                    a(e1[0], 0, 255),
                    a(e1[1], 0, 255),
                    a(e1[2], 0, 255)
                ] : d(e1) || g(e1);
            }, t.parseColorToRgba = v, t.cssHslToHsl = m, t.cssHslaToHsla = A, t.parseColorToHsl = function(e1) {
                return Array.isArray(e1) ? e1 = [
                    a(e1[0], 0, 360),
                    a(e1[1], 0, 100),
                    a(e1[2], 0, 100)
                ] : m(e1);
            }, t.parseColorToHsla = y, t.parseColor = function(e1, t) {
                if (t = t || "rgb", null != e1) {
                    var r = void 0;
                    if ((r = v(e1)) || (r = y(e1)) && (r = [].concat(n(u.apply(void 0, n(r))), [
                        r[3]
                    ]))) return (0, o.default)(t) ? [
                        "rgb",
                        "rgbcss",
                        "rgbcss4",
                        "rgba",
                        "rgbacss",
                        "hsl",
                        "hslcss",
                        "hslcss4",
                        "hsla",
                        "hslacss",
                        "hex",
                        "hexcss4",
                        "int"
                    ].reduce(function(e1, t) {
                        return e1[t] = k(r, t), e1;
                    }, t || {}) : k(r, t.toString().toLowerCase());
                }
            }, t.getLuminance = function(e1, t, r) {
                return .2126 * (e1 = (e1 /= 255) < .03928 ? e1 / 12.92 : Math.pow((e1 + .055) / 1.055, 2.4)) + .7152 * (t = (t /= 255) < .03928 ? t / 12.92 : Math.pow((t + .055) / 1.055, 2.4)) + .0722 * ((r /= 255) < .03928 ? r / 12.92 : Math.pow((r + .055) / 1.055, 2.4));
            }, t.limit = a, t.ensureArray = function(e1) {
                return e1 ? Array.from(e1) : [];
            }, t.nvl = l;
        },
        function(e1, t, r) {
            "use strict";
            /*!
 * isobject <https://github.com/jonschlinkert/isobject>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */ e1.exports = function(e1) {
                return null != e1 && "object" == typeof e1 && !1 === Array.isArray(e1);
            };
        },
        function(e1, t) {
            e1.exports = '<div class="a-color-picker-row a-color-picker-stack a-color-picker-row-top"> <canvas class="a-color-picker-sl a-color-picker-transparent"></canvas> <div class=a-color-picker-dot></div> </div> <div class=a-color-picker-row> <div class="a-color-picker-stack a-color-picker-transparent a-color-picker-circle"> <div class=a-color-picker-preview> <input class=a-color-picker-clipbaord type=text> </div> </div> <div class=a-color-picker-column> <div class="a-color-picker-cell a-color-picker-stack"> <canvas class=a-color-picker-h></canvas> <div class=a-color-picker-dot></div> </div> <div class="a-color-picker-cell a-color-picker-alpha a-color-picker-stack" show-on-alpha> <canvas class="a-color-picker-a a-color-picker-transparent"></canvas> <div class=a-color-picker-dot></div> </div> </div> </div> <div class="a-color-picker-row a-color-picker-hsl" show-on-hsl> <label>H</label> <input nameref=H type=number maxlength=3 min=0 max=360 value=0> <label>S</label> <input nameref=S type=number maxlength=3 min=0 max=100 value=0> <label>L</label> <input nameref=L type=number maxlength=3 min=0 max=100 value=0> </div> <div class="a-color-picker-row a-color-picker-rgb" show-on-rgb> <label>R</label> <input nameref=R type=number maxlength=3 min=0 max=255 value=0> <label>G</label> <input nameref=G type=number maxlength=3 min=0 max=255 value=0> <label>B</label> <input nameref=B type=number maxlength=3 min=0 max=255 value=0> </div> <div class="a-color-picker-row a-color-picker-rgbhex a-color-picker-single-input" show-on-single-input> <label>HEX</label> <input nameref=RGBHEX type=text select-on-focus> </div> <div class="a-color-picker-row a-color-picker-palette"></div>';
        },
        function(e1, t, r) {
            var i = r(6);
            e1.exports = "string" == typeof i ? i : i.toString();
        },
        function(e1, t, r) {
            (e1.exports = r(7)(!1)).push([
                e1.i,
                "/*!\n * a-color-picker\n * https://github.com/narsenico/a-color-picker\n *\n * Copyright (c) 2017-2018, Gianfranco Caldi.\n * Released under the MIT License.\n */.a-color-picker{background-color:#fff;padding:0;display:inline-flex;flex-direction:column;user-select:none;width:232px;font:400 10px Helvetica,Arial,sans-serif;border-radius:3px;box-shadow:0 0 0 1px rgba(0,0,0,.05),0 2px 4px rgba(0,0,0,.25)}.a-color-picker,.a-color-picker-row,.a-color-picker input{box-sizing:border-box}.a-color-picker-row{padding:15px;display:flex;flex-direction:row;align-items:center;justify-content:space-between;user-select:none}.a-color-picker-row-top{padding:0}.a-color-picker-row:not(:first-child){border-top:1px solid #f5f5f5}.a-color-picker-column{display:flex;flex-direction:column}.a-color-picker-cell{flex:1 1 auto;margin-bottom:4px}.a-color-picker-cell:last-child{margin-bottom:0}.a-color-picker-stack{position:relative}.a-color-picker-dot{position:absolute;width:14px;height:14px;top:0;left:0;background:#fff;pointer-events:none;border-radius:50px;z-index:1000;box-shadow:0 1px 2px rgba(0,0,0,.75)}.a-color-picker-a,.a-color-picker-h,.a-color-picker-sl{cursor:cell}.a-color-picker-a+.a-color-picker-dot,.a-color-picker-h+.a-color-picker-dot{top:-2px}.a-color-picker-a,.a-color-picker-h{border-radius:2px}.a-color-picker-preview{box-sizing:border-box;width:30px;height:30px;user-select:none;border-radius:15px}.a-color-picker-circle{border-radius:50px;border:1px solid #eee}.a-color-picker-hsl,.a-color-picker-rgb,.a-color-picker-single-input{justify-content:space-evenly}.a-color-picker-hsl>label,.a-color-picker-rgb>label,.a-color-picker-single-input>label{padding:0 8px;flex:0 0 auto;color:#969696}.a-color-picker-hsl>input,.a-color-picker-rgb>input,.a-color-picker-single-input>input{text-align:center;padding:2px 0;width:0;flex:1 1 auto;border:1px solid #e0e0e0;line-height:20px}.a-color-picker-hsl>input::-webkit-inner-spin-button,.a-color-picker-rgb>input::-webkit-inner-spin-button,.a-color-picker-single-input>input::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}.a-color-picker-hsl>input:focus,.a-color-picker-rgb>input:focus,.a-color-picker-single-input>input:focus{border-color:#04a9f4;outline:none}.a-color-picker-transparent{background-image:linear-gradient(-45deg,#cdcdcd 25%,transparent 0),linear-gradient(45deg,#cdcdcd 25%,transparent 0),linear-gradient(-45deg,transparent 75%,#cdcdcd 0),linear-gradient(45deg,transparent 75%,#cdcdcd 0);background-size:11px 11px;background-position:0 0,0 -5.5px,-5.5px 5.5px,5.5px 0}.a-color-picker-sl{border-radius:3px 3px 0 0}.a-color-picker.hide-alpha [show-on-alpha],.a-color-picker.hide-hsl [show-on-hsl],.a-color-picker.hide-rgb [show-on-rgb],.a-color-picker.hide-single-input [show-on-single-input]{display:none}.a-color-picker-clipbaord{width:100%;height:100%;opacity:0;cursor:pointer}.a-color-picker-palette{flex-flow:wrap;flex-direction:row;justify-content:flex-start;padding:10px}.a-color-picker-palette-color{width:15px;height:15px;flex:0 1 15px;margin:3px;box-sizing:border-box;cursor:pointer;border-radius:3px;box-shadow:inset 0 0 0 1px rgba(0,0,0,.1)}.a-color-picker-palette-add{text-align:center;line-height:13px;color:#607d8b}.a-color-picker.hidden{display:none}",
                ""
            ]);
        },
        function(e1, t) {
            e1.exports = function(e1) {
                var t = [];
                return t.toString = function() {
                    return this.map(function(t) {
                        var r = function(e1, t) {
                            var r = e1[1] || "", i = e1[3];
                            if (!i) return r;
                            if (t && "function" == typeof btoa) {
                                var o = function(e1) {
                                    return "/*# sourceMappingURL=data:application/json;charset=utf-8;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(e1)))) + " */";
                                }(i), n = i.sources.map(function(e1) {
                                    return "/*# sourceURL=" + i.sourceRoot + e1 + " */";
                                });
                                return [
                                    r
                                ].concat(n).concat([
                                    o
                                ]).join("\n");
                            }
                            return [
                                r
                            ].join("\n");
                        }(t, e1);
                        return t[2] ? "@media " + t[2] + "{" + r + "}" : r;
                    }).join("");
                }, t.i = function(e1, r) {
                    "string" == typeof e1 && (e1 = [
                        [
                            null,
                            e1,
                            ""
                        ]
                    ]);
                    for(var i = {}, o = 0; o < this.length; o++){
                        var n = this[o][0];
                        "number" == typeof n && (i[n] = !0);
                    }
                    for(o = 0; o < e1.length; o++){
                        var s = e1[o];
                        "number" == typeof s[0] && i[s[0]] || (r && !s[2] ? s[2] = r : r && (s[2] = "(" + s[2] + ") and (" + r + ")"), t.push(s));
                    }
                }, t;
            };
        }
    ]);
});








const $96903e3f16465932$var$FILENAME = 'event-manager.js';
/**
 * About:
 * EventManager
 * 
 * Description:
 * Manages all events, both dispatching custom events and on/off of listeners.
 */ class $96903e3f16465932$export$cc74486daaaef499 extends (0, $8a2666592e7029ee$export$84777416d052f822) {
    //--------------------------------------------------------------------
    // # Section: Base Overrides
    //--------------------------------------------------------------------
    static async initAsync(options = {}) {
        (0, $b9b5c0363f244088$export$49b118289be48034).logDebug($96903e3f16465932$var$FILENAME, 'initAsync', 'Initialization started');
        return new Promise((resolve)=>{
            resolve({
                filename: $96903e3f16465932$var$FILENAME,
                result: true
            });
        });
    }
    static setMap(map) {}
    static getName() {
        return $96903e3f16465932$var$FILENAME;
    }
    //--------------------------------------------------------------------
    // # Section: Public API
    //--------------------------------------------------------------------
    static on(context, type, callback) {}
    static off(context, type) {}
    static dispatchEvent(elements, type, options = {}) {
        const event = new Event(type, options);
        elements.forEach((element)=>{
            element.dispatchEvent(event);
        });
        return event;
    }
    static dispatchCustomEvent(elements, type, options = {}) {
        const event = new CustomEvent(type, options);
        elements.forEach((element)=>{
            element.dispatchEvent(event);
        });
        return event;
    }
}




const $f886df948c341d69$var$FILENAME = 'color-picker-manager.js';
/**
 * About:
 * ColorPickerManager
 * 
 * Description:
 * Manages and simplifies the usage of the ACP instance (A Color Picker).
 * 
 * Note:
 * The ACP must be included in the above format or else the Parcel and/or Rollup fails
 */ class $f886df948c341d69$export$40ee9a3f4944191d extends (0, $8a2666592e7029ee$export$84777416d052f822) {
    static #colorPickerElement;
    static #colorPicker;
    //--------------------------------------------------------------------
    // # Section: Base Overrides
    //--------------------------------------------------------------------
    static async initAsync(options = {}) {
        (0, $b9b5c0363f244088$export$49b118289be48034).logDebug($f886df948c341d69$var$FILENAME, 'initAsync', 'Initialization started');
        this.#colorPickerElement = this.#createColorPickerElement();
        this.#colorPicker = $4fb5b3896f1b27ab$exports.createPicker(this.#colorPickerElement);
        return new Promise((resolve)=>{
            resolve({
                filename: $f886df948c341d69$var$FILENAME,
                result: true
            });
        });
    }
    static setMap(map) {}
    static getName() {
        return $f886df948c341d69$var$FILENAME;
    }
    //--------------------------------------------------------------------
    // # Section: User Interface
    //--------------------------------------------------------------------
    static #createColorPickerElement() {
        const palette = (0, $1e8c0ef90ed82280$export$a33e119b2316dcb7).getConfig().aColorPicker.palette;
        (0, $b9b5c0363f244088$export$49b118289be48034).logDebug($f886df948c341d69$var$FILENAME, 'initAsync', {
            count: palette.length,
            palette: palette
        });
        return (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'div',
            id: 'otlb-color-picker',
            class: 'oltb-mt-05 oltb-mb-0313',
            attributes: {
                'acp-color': '#D7E3FA',
                'acp-show-alpha': 'yes',
                'acp-show-rgb': 'no',
                'acp-show-hsl': 'no',
                'acp-show-hex': 'yes',
                'acp-palette': palette.join('|')
            }
        });
    }
    static #createColorPickerWrapper() {
        // Note:
        // [0] -> Gradiant-Adobe-Like-Picker
        // [1] -> Color and Opacity Sliders
        // [2] -> HEX In-/Output
        // [3] -> Color Palette
        const displayClass = 'oltb-d-none';
        const maxIncludedIndex = 2;
        const acpRows = this.#colorPickerElement.querySelectorAll('.a-color-picker-row');
        // Note:
        // The user can opt-out from hiding the full controls using the showPaletteAsDefault parameter
        const showPaletteAsDefault = (0, $1e8c0ef90ed82280$export$a33e119b2316dcb7).getConfig().aColorPicker.showPaletteAsDefault;
        if (showPaletteAsDefault && acpRows.length >= maxIncludedIndex) for(let i = 0; i <= maxIncludedIndex; ++i)acpRows[i].classList.add(displayClass);
        const acpHeader = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'div',
            class: 'oltb-acp__header',
            listeners: {
                'click': ()=>{
                    for(let i = 0; i <= maxIncludedIndex; ++i)acpRows[i].classList.toggle(displayClass);
                }
            }
        });
        // Note:
        // The Label and Toggle-icon can't be localized due to circular dependencies
        // This is not a critical translation so will use the en-us as the only language
        // src/oltb/js/managers/TranslationManager.js -> 
        // src/oltb/js/managers/TippyManager.js       -> 
        // src/oltb/js/managers/ColorPickerManager.js -> 
        // src/oltb/js/managers/TranslationManager.js
        const acpTitle = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'label',
            class: 'oltb-acp__title',
            text: 'Color Picker'
        });
        const acpIcon = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'label',
            class: 'oltb-acp__icon oltb-tippy',
            title: 'Toggle Section'
        });
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(acpHeader, [
            acpTitle,
            acpIcon
        ]);
        const acpWrapper = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'div',
            class: 'oltb-acp'
        });
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(acpWrapper, [
            acpHeader,
            this.#colorPickerElement
        ]);
        return acpWrapper;
    }
    //--------------------------------------------------------------------
    // # Section: Internal
    //--------------------------------------------------------------------
    static #isToPlaceBottom() {
        return window.innerWidth <= (0, $1e8c0ef90ed82280$export$a33e119b2316dcb7).getConfig().deviceWidth.sm || (0, $2d3c68c3d1a48cfe$export$2a62b49acb270576)();
    }
    //--------------------------------------------------------------------
    // # Section: Public API
    //--------------------------------------------------------------------
    static getColorPicker() {
        return this.#colorPicker;
    }
    static getColorPickerElement() {
        return this.#colorPickerElement;
    }
    static show(instance) {
        const colorPickerWrapper = this.#createColorPickerWrapper();
        instance.setContent(colorPickerWrapper);
        instance.setProps({
            placement: this.#isToPlaceBottom() ? 'bottom' : 'left'
        });
        // Note:
        // Apply a bit more distinct border in the Tooltip
        // because the colorpicker overlaps other elements
        const popper = instance.popper;
        popper.classList.add('tippy-color-picker');
        // Note:
        // Find all palette-colors and add the tippy-class to improve look and feel
        const paletteColors = this.#colorPickerElement.querySelectorAll('.a-color-picker-palette-color');
        paletteColors.forEach((color)=>{
            color.classList.add('oltb-tippy');
        });
        const selector = instance.reference.getAttribute('data-oltb-color-target');
        const uiRefTarget = window.document.querySelector(selector);
        this.#colorPicker.setColor(instance.reference.getAttribute('data-oltb-color'));
        this.#colorPicker.on((0, $a9807b370eed025c$export$ada873a34909da65).browser.change, (picker, color)=>{
            // Note: 
            // Important to always be HEX with Alpha value
            // Sometimes the two last digits are replaced with fixed alpha value
            color = $4fb5b3896f1b27ab$exports.parseColor(color, 'hexcss4');
            uiRefTarget.setAttribute('data-oltb-color', color);
            uiRefTarget.firstElementChild.style.backgroundColor = color;
            (0, $96903e3f16465932$export$cc74486daaaef499).dispatchEvent([
                instance.reference
            ], (0, $a9807b370eed025c$export$ada873a34909da65).custom.colorChange);
        });
        return colorPickerWrapper;
    }
}


const $31c79cd05d39fa2c$var$FILENAME = 'tippy-manager.js';
const $31c79cd05d39fa2c$var$CLASS__TOOL_BUTTON = 'oltb-tool-button';
/**
 * About:
 * TippyManager
 * 
 * Description:
 * Manages and simplifies the usage of the Tippy instance.
 */ class $31c79cd05d39fa2c$export$93efd44b9c955db5 extends (0, $8a2666592e7029ee$export$84777416d052f822) {
    static #toolButtonInstances;
    static #toolButtonTippy;
    static #dynamicTippy;
    static #colorTippy;
    //--------------------------------------------------------------------
    // # Section: Base Overrides
    //--------------------------------------------------------------------
    static async initAsync(options = {}) {
        (0, $b9b5c0363f244088$export$49b118289be48034).logDebug($31c79cd05d39fa2c$var$FILENAME, 'initAsync', 'Initialization started');
        this.#toolButtonInstances = [];
        this.#toolButtonTippy = this.#createToolButtonTippy();
        this.#dynamicTippy = this.#createDynamicTippy();
        this.#colorTippy = this.#createColorTippy();
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.resize, this.#onPlacementChange.bind(this));
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.toolbarDirectionChange, this.#onPlacementChange.bind(this));
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.ready, this.#onOLTBReady.bind(this));
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.browserStateCleared, this.#onWindowBrowserStateCleared.bind(this));
        return new Promise((resolve)=>{
            resolve({
                filename: $31c79cd05d39fa2c$var$FILENAME,
                result: true
            });
        });
    }
    static setMap(map) {}
    static getName() {
        return $31c79cd05d39fa2c$var$FILENAME;
    }
    //--------------------------------------------------------------------
    // # Section: Internal
    //--------------------------------------------------------------------
    static #isPlacementBottom() {
        return window.innerWidth <= (0, $1e8c0ef90ed82280$export$a33e119b2316dcb7).getConfig().deviceWidth.sm;
    }
    static #isPlacementForcedBottom() {
        return this.#isPlacementBottom() || (0, $2d3c68c3d1a48cfe$export$2a62b49acb270576)();
    }
    static #setToolButtonInstances() {
        // Note: 
        // Used when switching language
        // Destroy each instance so that the new content with correct lang can be added in the new
        this.#toolButtonInstances.forEach((instance)=>{
            instance.destroy();
        });
        this.#toolButtonInstances = (0, $43bf50b0fa1441ac$export$2e2bcd8739ae039)(`.${$31c79cd05d39fa2c$var$CLASS__TOOL_BUTTON}`);
        this.#toolButtonTippy.setInstances(this.#toolButtonInstances);
        this.#onPlacementChange();
    }
    //--------------------------------------------------------------------
    // # Section: Events
    //--------------------------------------------------------------------
    static #onOLTBReady(event) {
        this.#setToolButtonInstances();
    }
    static #onPlacementChange() {
        this.#toolButtonTippy.setProps({
            placement: this.#isPlacementForcedBottom() ? 'bottom' : 'right'
        });
    }
    static #onWindowBrowserStateCleared() {
        this.#toolButtonTippy.setProps({
            placement: this.#isPlacementBottom() ? 'bottom' : 'right'
        });
    }
    //--------------------------------------------------------------------
    // # Section: User Interface
    //--------------------------------------------------------------------
    static #createToolButtonTippy() {
        const uiRefMapElement = (0, $8f42450ebdd44f5e$export$8e7188a60a5bbe16).getMapElement();
        return (0, $43bf50b0fa1441ac$export$374c483667c1ea9b)([], {
            placement: 'right',
            appendTo: uiRefMapElement,
            offset: [
                0,
                12
            ],
            theme: 'oltb',
            touch: false
        });
    }
    static #createDynamicTippy() {
        const uiRefMapElement = (0, $8f42450ebdd44f5e$export$8e7188a60a5bbe16).getMapElement();
        const offset = (0, $1e8c0ef90ed82280$export$a33e119b2316dcb7).getConfig().tippy.offset;
        return (0, $43bf50b0fa1441ac$export$10b1921597150314)(uiRefMapElement, {
            target: '.oltb-tippy',
            placement: 'top',
            appendTo: uiRefMapElement,
            theme: 'oltb oltb-themed',
            offset: offset,
            touch: false,
            onShow (instance) {
                const element = instance.reference;
                const title = element.getAttribute('title') || element.getAttribute('data-tippy-value') || '';
                // Store the title to not have multiple tooltips
                element.setAttribute('data-tippy-value', title);
                element.removeAttribute('title');
                // Apply title in the custom tooltip
                instance.setContent(title);
            },
            onHidden (instance) {
                const element = instance.reference;
                const title = element.getAttribute('data-tippy-value') || element.getAttribute('title') || '';
                // Add back the title as pure title attribute for next time will be displayed
                element.setAttribute('title', title);
                element.removeAttribute('data-tippy-value');
                // Remove title from the custom tooltip
                instance.setContent('');
            }
        });
    }
    static #createColorTippy() {
        const uiRefMapElement = (0, $8f42450ebdd44f5e$export$8e7188a60a5bbe16).getMapElement();
        return (0, $43bf50b0fa1441ac$export$10b1921597150314)(uiRefMapElement, {
            target: '.oltb-color-tippy',
            placement: 'left',
            offset: [
                8,
                8
            ],
            trigger: 'click',
            appendTo: uiRefMapElement,
            theme: 'oltb oltb-inverted-themed',
            interactive: true,
            allowHTML: true,
            onShow (instance) {
                (0, $f886df948c341d69$export$40ee9a3f4944191d).show(instance);
            },
            onHide (instance) {
                (0, $f886df948c341d69$export$40ee9a3f4944191d).getColorPicker().off((0, $a9807b370eed025c$export$ada873a34909da65).browser.change);
            },
            onHidden (instance) {
                instance.setContent(null);
            }
        });
    }
    //--------------------------------------------------------------------
    // # Section: Public API
    //--------------------------------------------------------------------
    static applyLanguage() {
        this.#setToolButtonInstances();
    }
    static getToolButtonTippy() {
        return this.#toolButtonTippy;
    }
    static getDynamicTippy() {
        return this.#dynamicTippy;
    }
    static getColorTippy() {
        return this.#colorTippy;
    }
}




const $d9bbdacaac8cc617$export$fd7df0f5d29e233f = Object.freeze({
    meta: {
        text: 'English',
        value: 'en-us',
        info: 'This is the default translation instance and not the loaded en-us.json file'
    },
    commons: {
        titles: {
            edit: 'Edit',
            delete: 'Delete',
            dragToSort: 'Drag To Sort',
            download: 'Download',
            copyText: 'Copy Text',
            copyCoordinates: 'Copy Coordinates',
            showLayer: 'Show Layer',
            rename: 'Rename',
            toggleSection: 'Toggle Section',
            toggleVisibility: 'Toggle Visibility',
            zoomToCoordinates: 'Zoom To Coordinates'
        },
        types: {
            convertable: {
                drawing: 'Drawing',
                measurement: 'Measurement'
            }
        }
    },
    managers: {
        settingsManager: {
            settings: {
                mouseWheelZoom: 'Zoom Map Using Mousewheel Only',
                altShiftDragRotate: 'Rotate Map Using Shift + Alt + Drag',
                dragPan: 'Drag Map Using Mouse Only',
                keyboardZoom: 'Zoom Map Using Keyboard',
                keyboardPan: 'Pan Map Using Keyboard',
                selectVectorMapShapes: 'Select Shapes In Vector Map Layers',
                snapInteraction: 'Use Snap Interaction',
                snapHelpLines: 'Use Snap Help Lines',
                alwaysNewLayers: 'Create New Layer When Selecting Tool'
            }
        },
        errorManager: {
            toasts: {
                errors: {
                    uncaughtException: {
                        title: 'Error',
                        message: 'An unexpected error occurred'
                    }
                }
            }
        },
        infoWindowManager: {
            toasts: {
                infos: {
                    copyMarkerCoordinates: {
                        title: 'Copied',
                        message: 'Marker coordinates copied to clipboard'
                    },
                    copyMarkerInfo: {
                        title: 'Copied',
                        message: 'Marker info copied to clipboard'
                    }
                },
                errors: {
                    copyMarkerInfo: {
                        title: 'Error',
                        message: 'Failed to copy Marker info'
                    },
                    copyMarkerCoordinates: {
                        title: 'Error',
                        message: 'Failed to copy Marker coordinates'
                    }
                }
            },
            dialogs: {
                confirms: {
                    deleteMarker: {
                        title: 'Delete Marker',
                        message: 'Do you want to delete this Marker?',
                        confirmText: 'Delete',
                        cancelText: 'Cancel'
                    }
                }
            }
        }
    },
    modalExtensions: {
        coordinateModal: {
            title: 'Coordinates',
            form: {
                latitude: 'Latitude',
                longitude: 'Longitude',
                navigateTo: 'Navigate To',
                cancel: 'Cancel',
                description: 'Coordinates are given in WGS84/EPSG:4326'
            }
        },
        debugInfoModal: {
            title: 'Debug Information',
            noMapFound: 'No Map reference found',
            form: {
                doAction: 'Do Action',
                defaultItem: {
                    title: 'Select Action'
                },
                miscGroup: {
                    title: 'Misc',
                    items: {
                        logToBrowser: 'Log Map To Browser Console',
                        generateUUID: 'Generate UUID',
                        clearStyleManager: 'Clear Style Manager'
                    }
                },
                eventLogGroup: {
                    title: 'Event Log',
                    items: {
                        copyEventLog: 'Copy Event Log',
                        clearEventLog: 'Clear Event Log'
                    }
                }
            },
            sections: {
                appData: 'App Data',
                mapData: 'Map Data',
                browserData: 'Browser Data',
                localStorage: 'Local Storage',
                sessionStorage: 'Session Storage',
                cookies: 'Cookies',
                eventLog: 'Eventlog'
            },
            toasts: {
                infos: {
                    logMapObject: {
                        title: 'Logged',
                        message: 'Map object logged to console'
                    },
                    copyEventLog: {
                        title: 'Copied',
                        message: 'Event log copied to clipboard'
                    },
                    clearEventLog: {
                        title: 'Cleared',
                        message: 'Event log was cleared of all entries'
                    },
                    clearStyleManager: {
                        title: 'Cleared',
                        message: 'Style Manager was cleared of all entries'
                    }
                },
                errors: {
                    copyEventLog: {
                        title: 'Error',
                        message: 'Failed to copy Event log to clipboard'
                    }
                }
            }
        },
        downloadLayerModal: {
            title: 'Download Layer',
            form: {
                layerFormat: 'Layer format',
                download: 'Download Layer',
                cancel: 'Cancel'
            }
        },
        geometryDataModal: {
            title: 'Geometry Data',
            data: {
                id: 'Id',
                measurement: 'Measurement',
                oltbProperties: 'OLTB Properties',
                vertices: 'Vertices',
                coordinates: 'Coordinates'
            }
        },
        iconMarkerModal: {
            title: 'Marker Configuration',
            form: {
                title: 'Title',
                description: 'Description',
                latitude: 'Latitude',
                longitude: 'Longitude',
                markerFill: 'Marker Fill',
                markerStroke: 'Marker Stroke',
                icon: 'Icon',
                iconFill: 'Icon Fill',
                iconStroke: 'Icon Stroke',
                label: 'Label',
                labelFill: 'Label Fill',
                labelStroke: 'Label Stroke',
                labelStrokeWidth: 'Label Stroke Width',
                saveChanges: 'Save Changes',
                createMarker: 'Create Marker',
                cancel: 'Cancel'
            }
        },
        importLayerModal: {
            title: 'Import Layer',
            form: {
                featureProjection: 'Feature Projection',
                dataProjection: 'Data Projection',
                import: 'Import Layer',
                cancel: 'Cancel'
            }
        },
        layerModal: {
            title: 'Create Map Layer',
            form: {
                name: 'Name',
                layer: 'Layer',
                source: 'Source',
                projection: 'Projection',
                url: 'URL',
                parameters: 'Parameters (JSON)',
                wrapX: 'WrapX',
                cors: 'CORS',
                attributions: 'Attributions',
                createLayer: 'Create Layer',
                cancel: 'Cancel'
            }
        },
        settingsModal: {
            title: 'Settings',
            form: {
                save: 'Save Settings',
                cancel: 'Cancel'
            }
        }
    },
    tools: {
        hiddenAboutTool: {
            contextItems: {
                about: 'About OLTB'
            },
            modals: {
                about: {
                    title: 'About OLTB',
                    version: 'Version',
                    developedBy: 'Developed by Qulle',
                    usingOpenLayers: 'Using OpenLayers'
                }
            }
        },
        hiddenMapNavigationTool: {
            contextItems: {
                copyCoordinates: 'Copy Coordinates',
                navigateToCoordinates: 'Navigate To',
                centerMap: 'Center Here',
                focusMap: 'Focus Here'
            },
            toasts: {
                infos: {
                    coordinatesCopied: {
                        title: 'Copied',
                        message: 'Coordinates copied to clipboard'
                    }
                },
                errors: {
                    coordinatesCopy: {
                        title: 'Error',
                        message: 'Failed to copy coordinates'
                    },
                    parseUrlMarker: {
                        title: 'Error',
                        message: 'Failed to parse URL Marker'
                    },
                    missingProjection: {
                        title: 'Error',
                        message: 'Missing projection definition'
                    }
                }
            }
        },
        hiddenMarkerTool: {
            contextItems: {
                createMarker: 'Create Marker'
            }
        },
        bookmarkTool: {
            title: 'Bookmarks',
            toolbox: {
                titles: {
                    bookmarks: 'Bookmarks'
                },
                groups: {
                    addBookmark: {
                        placeholder: 'Name',
                        add: 'Add Bookmark'
                    }
                }
            },
            contextItems: {
                addBookmark: 'Add Bookmark',
                clearBookmarks: 'Clear Bookmarks'
            },
            layers: {
                bookmarks: 'Bookmarks'
            },
            toasts: {
                infos: {
                    clearBookmarks: {
                        title: 'Cleared',
                        message: 'All stored bookmarks was cleared'
                    },
                    createBookmark: {
                        title: 'New Bookmark',
                        message: 'A new Bookmark created'
                    },
                    copyCoordinates: {
                        title: 'Copied',
                        message: 'Coordinates copied to clipboard'
                    }
                },
                errors: {
                    copyCoordinates: {
                        title: 'Error',
                        message: 'Failed to copy coordinates'
                    }
                }
            },
            dialogs: {
                confirms: {
                    clearBookmarks: {
                        title: 'Clear Bookmarks',
                        message: 'Do you want to clear all Bookmarks?',
                        confirmText: 'Clear',
                        cancelText: 'Cancel'
                    },
                    deleteBookmark: {
                        title: 'Delete Bookmark',
                        message: 'Do you want to delete bookmark',
                        confirmText: 'Delete',
                        cancelText: 'Cancel'
                    }
                },
                prompts: {
                    editBookmark: {
                        title: 'Edit Name',
                        message: 'You are editing bookmark',
                        confirmText: 'Rename',
                        cancelText: 'Cancel'
                    }
                }
            }
        },
        coordinatesTool: {
            title: 'Show Coordinates',
            toolbox: {
                titles: {
                    coordinates: 'Coordinates'
                },
                groups: {
                    formats: {
                        title: 'Format',
                        dd: 'Decimal Degrees',
                        dms: 'Degrees, Minutes, Seconds'
                    },
                    coordinates: {
                        title: 'Coordinates'
                    }
                }
            },
            settings: {
                copyOnClick: 'Copy Coordinates On Click',
                updateToolboxOnHover: 'Update Toolbox Coordinates When Hover'
            },
            toasts: {
                infos: {
                    copyCoordinates: {
                        title: 'Copied',
                        message: 'Coordinates copied to clipboard'
                    }
                },
                errors: {
                    copyCoordinates: {
                        title: 'Error',
                        message: 'Failed to copy coordinates'
                    }
                }
            }
        },
        debugInfoTool: {
            title: 'Debug Info'
        },
        directionTool: {
            title: 'Toggle Direction'
        },
        drawTool: {
            title: 'Draw',
            toolbox: {
                titles: {
                    draw: 'Draw'
                },
                groups: {
                    shapes: {
                        title: 'Shape',
                        circle: 'Circle',
                        square: 'Square',
                        rectangle: 'Rectangle',
                        lineString: 'Line',
                        point: 'Point',
                        polygon: 'Polygon'
                    },
                    intersectable: {
                        title: 'Intersection',
                        true: 'Yes',
                        false: 'No'
                    },
                    strokeWidth: {
                        title: 'Stroke Width'
                    },
                    strokeColor: {
                        title: 'Stroke Color'
                    },
                    fillColor: {
                        title: 'Fill Color'
                    }
                }
            },
            layers: {
                defaultName: 'Drawing layer'
            },
            toasts: {
                infos: {
                    drawInHiddenLayer: {
                        title: 'Tip',
                        message: 'You are drawing in a hidden layer'
                    },
                    missingIntersections: {
                        title: 'Oops',
                        message: 'No intersecting object found'
                    }
                }
            }
        },
        editTool: {
            title: 'Edit',
            toolbox: {
                titles: {
                    edit: 'Edit'
                },
                groups: {
                    misc: {
                        title: 'Misc',
                        delete: 'Delete',
                        rotate: 'Rotate',
                        geometryData: 'Geometry Data',
                        convertFeature: 'Convert'
                    },
                    copying: {
                        title: 'Clipboard',
                        cut: 'Cut',
                        copy: 'Copy',
                        paste: 'Paste'
                    },
                    shapes: {
                        title: 'Shapes',
                        union: 'Union',
                        intersect: 'Intersect',
                        exclude: 'Exclude',
                        difference: 'Difference'
                    },
                    strokeColor: {
                        title: 'Stroke Color'
                    },
                    fillColor: {
                        title: 'Fill Color'
                    }
                }
            },
            settings: {
                mouseOnlyToEditVectorShapes: 'Mouse Only To Edit Vector Shapes'
            },
            toasts: {
                infos: {
                    copiedFeatures: {
                        title: 'Copied',
                        message: 'objects has been copied'
                    },
                    pastedFeatures: {
                        title: 'Pasted',
                        message: 'objects has been pasted'
                    },
                    cutFeatures: {
                        title: 'Cut',
                        message: 'objects has been cut'
                    },
                    missingFeatures: {
                        title: 'Oops',
                        message: 'No objects are selected'
                    },
                    strictOneFeature: {
                        title: 'Oops',
                        message: 'Strict one object can be selected'
                    },
                    strictTwoFeatures: {
                        title: 'Oops',
                        message: 'Strict two overlapping objects must be selected'
                    }
                },
                errors: {
                    operationFailed: {
                        title: 'Error',
                        message: 'Failed to perform shape operation'
                    },
                    invalidValue: {
                        title: 'Error',
                        message: 'Only digits are allowed as input'
                    }
                }
            },
            dialogs: {
                confirms: {
                    deleteFeatures: {
                        title: 'Delete',
                        message: 'Delete selected objects',
                        confirmText: 'Delete',
                        cancelText: 'Cancel'
                    }
                },
                prompts: {
                    rotateFeatures: {
                        title: 'Rotate',
                        message: 'Rotate objects by N-degrees',
                        confirmText: 'Rotate',
                        cancelText: 'Cancel'
                    },
                    convertFeatures: {
                        title: 'Convert',
                        message: 'Convert selected objects to',
                        confirmText: 'Convert',
                        cancelText: 'Cancel'
                    }
                }
            }
        },
        exportPngTool: {
            title: 'Export PNG',
            toasts: {
                errors: {
                    renderCanvas: {
                        title: 'Error',
                        message: 'Failed to export Canvas'
                    }
                }
            }
        },
        fullscreenTool: {
            title: 'Toggle Fullscreen',
            toasts: {
                errors: {
                    missingFullScreenSupport: {
                        title: 'Error',
                        message: 'Fullscreen is not supported by this browser'
                    }
                }
            }
        },
        graticuleTool: {
            title: 'Show Graticule'
        },
        helpTool: {
            title: 'Help',
            dialogs: {
                confirms: {
                    openHelp: {
                        title: 'Help Pages',
                        message: 'Browsers block automatic opening new windows, here is a button for you to press',
                        confirmText: 'Open Help',
                        cancelText: 'Cancel'
                    }
                }
            },
            toasts: {
                errors: {
                    blockedByBrowser: {
                        title: 'Error',
                        message: 'Action was restricted by browser settings'
                    }
                }
            }
        },
        homeTool: {
            title: 'Zoom Home',
            contextItems: {
                setHome: 'Set Home'
            },
            toasts: {
                infos: {
                    setHomeLocation: {
                        title: 'New Home',
                        message: 'New location was set as Home'
                    }
                }
            }
        },
        importVectorLayerTool: {
            title: 'Import Vector Layer',
            toasts: {
                errors: {
                    unsupportedFormat: {
                        title: 'Error',
                        message: 'The layer format is not supported'
                    },
                    importFailed: {
                        title: 'Error',
                        message: 'Failed to import vector layer'
                    }
                }
            }
        },
        infoTool: {
            title: 'Info'
        },
        layerTool: {
            title: 'Layers',
            toolbox: {
                titles: {
                    mapLayers: 'Map Layers',
                    featureLayers: 'Feature Layers'
                },
                groups: {
                    createMapLayer: {
                        placeholder: 'Name',
                        create: 'Create Map Layer'
                    },
                    createFeatureLayer: {
                        placeholder: 'Name',
                        create: 'Create Feature Layer'
                    }
                }
            },
            contextItems: {
                addMapLayer: 'Add Map Layer',
                addFeatureLayer: 'Add Feature Layer'
            },
            toasts: {
                infos: {
                    addFeatureLayer: {
                        title: 'New Layer',
                        message: 'A new Feature layer created'
                    }
                },
                errors: {
                    addFeatureLayer: {
                        title: 'Error',
                        message: 'Failed to create new layer'
                    },
                    missingProjection: {
                        title: 'Error',
                        message: 'Missing projection definition'
                    },
                    unsupportedFormat: {
                        title: 'Error',
                        message: 'The layer format is not supported'
                    }
                }
            },
            dialogs: {
                prompts: {
                    renameLayer: {
                        title: 'Edit Name',
                        message: 'Edit name for layer',
                        confirmText: 'Rename',
                        cancelText: 'Cancel'
                    }
                },
                confirms: {
                    deleteLayer: {
                        title: 'Delete Layer',
                        message: 'Do you want to delete layer',
                        confirmText: 'Delete',
                        cancelText: 'Cancel'
                    }
                }
            }
        },
        magnifyTool: {
            title: 'Magnify',
            toasts: {
                errors: {
                    renderCanvas: {
                        title: 'Error',
                        message: 'Unexpected error using magnifier'
                    }
                }
            }
        },
        measureTool: {
            title: 'Measure',
            toolbox: {
                titles: {
                    measure: 'Measure'
                },
                groups: {
                    type: {
                        title: 'Type',
                        lineString: 'Length',
                        polygon: 'Area'
                    },
                    strokeColor: {
                        title: 'Stroke Color'
                    },
                    fillColor: {
                        title: 'Fill Color'
                    }
                }
            },
            layers: {
                defaultName: 'Measurements layer'
            },
            toasts: {
                infos: {
                    drawInHiddenLayer: {
                        title: 'Tip',
                        message: 'You are measuring in a hidden layer'
                    }
                }
            }
        },
        myLocationTool: {
            title: 'My Location',
            dialogs: {
                confirms: {
                    exitFullscreen: {
                        title: 'Exit Fullscreen',
                        message: 'To use geolocation you must exit fullscreen',
                        confirmText: 'Exit Fullscreen',
                        cancelText: 'Cancel'
                    }
                }
            },
            toasts: {
                infos: {
                    fetchLocation: {
                        title: 'Searching',
                        message: 'Trying to find your location...'
                    }
                },
                errors: {
                    exitFullscreen: {
                        title: 'Error',
                        message: 'Failed to exit fullscreen'
                    },
                    locationNotFound: {
                        title: 'Error',
                        message: 'Failed to find location'
                    }
                }
            }
        },
        overviewTool: {
            title: 'Map Overview',
            toolbox: {
                titles: {
                    overview: 'Map Overview'
                }
            }
        },
        refreshTool: {
            title: 'Refresh Page'
        },
        resetNorthTool: {
            title: 'Reset North',
            contextItems: {
                rotate: 'Rotate Map'
            },
            dialogs: {
                prompts: {
                    rotateMap: {
                        title: 'Rotate Map',
                        message: 'Set Map rotation by degrees',
                        confirmText: 'Rotate Map',
                        cancelText: 'Cancel'
                    }
                }
            },
            toasts: {
                errors: {
                    invalidValue: {
                        title: 'Error',
                        message: 'Only digits are allowed as input'
                    }
                }
            }
        },
        scaleLineTool: {
            title: 'Scale Line'
        },
        scissorsTool: {
            title: 'Polygon Scissors',
            toasts: {
                infos: {
                    missingIntersections: {
                        title: 'Oops',
                        message: 'No intersecting object found'
                    }
                }
            }
        },
        settingsTool: {
            title: 'Settings',
            contextItems: {
                clearBrowserState: 'Clear Browser State'
            },
            toasts: {
                infos: {
                    clearBrowserState: {
                        title: 'Cleared',
                        message: 'All stored items was reset to default'
                    }
                },
                successes: {
                    savedSettings: {
                        title: 'Saved',
                        message: 'All settings saved in browser storage'
                    }
                }
            },
            dialogs: {
                confirms: {
                    clearBrowserState: {
                        title: 'Clear Browser State',
                        message: 'Do you want to reset all items to default state for the Toolbar?',
                        confirmText: 'Clear',
                        cancelText: 'Cancel'
                    }
                }
            }
        },
        splitViewTool: {
            title: 'Split View',
            toolbox: {
                titles: {
                    splitView: 'Split View'
                },
                groups: {
                    leftSide: {
                        title: 'Left Side'
                    },
                    rightSide: {
                        title: 'Right Side'
                    },
                    swapSides: {
                        swap: 'Swap Sides'
                    }
                },
                toasts: {
                    infos: {
                        strictOneLayer: {
                            title: 'Tip',
                            message: 'You must have more than one layer'
                        }
                    },
                    errors: {
                        layerFailedToLoad: {
                            title: 'Error',
                            message: 'Layer(s) could not be loaded'
                        }
                    }
                }
            }
        },
        themeTool: {
            title: 'Toggle Theme'
        },
        toolboxTool: {
            title: 'Toggle Toolbox'
        },
        translationTool: {
            title: 'Translate',
            dialogs: {
                selects: {
                    changeLanguage: {
                        title: 'Language',
                        message: 'Current language is',
                        confirmText: 'Switch Language',
                        cancelText: 'Cancel'
                    }
                }
            }
        },
        zoomboxTool: {
            title: 'Zoombox',
            tooltips: {
                dragToZoom: 'Drag To Zoom'
            }
        },
        zoomInTool: {
            title: 'Zoom In'
        },
        zoomOutTool: {
            title: 'Zoom Out'
        }
    }
});


const $aa968a2b9f70852c$var$FILENAME = 'translation-manager.js';
const $aa968a2b9f70852c$var$DefaultOptions = Object.freeze({
    url: './assets/i18n'
});
const $aa968a2b9f70852c$var$DefaultLanguage = Object.freeze({
    text: 'English',
    value: 'en-us',
    translation: (0, $d9bbdacaac8cc617$export$fd7df0f5d29e233f)
});
const $aa968a2b9f70852c$var$LocalStorageNodeName = (0, $52e25f2a10ab5b5c$export$ada36e8a1c3bc83a).translationManager;
const $aa968a2b9f70852c$var$LocalStorageDefaults = Object.freeze({
    activeLanguageValue: $aa968a2b9f70852c$var$DefaultLanguage.value
});
/**
 * About:
 * TranslationManager
 * 
 * Description:
 * Manages loading and switching between different localizations.
 * 
 * Note:
 * In this context a:
 * 'translation' is data containing the acually key-value translations
 *    'language' is a object holding three value in the following format
 * {
 *     text: 'English',
 *     value: 'en-us',
 *     translation: translation
 * }
 */ class $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad extends (0, $8a2666592e7029ee$export$84777416d052f822) {
    static #activeLanguage;
    static #languages;
    static #localStorage;
    static #options;
    //--------------------------------------------------------------------
    // # Section: Base Overrides
    //--------------------------------------------------------------------
    static async initAsync(options = {}) {
        this.#options = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep($aa968a2b9f70852c$var$DefaultOptions), options);
        (0, $b9b5c0363f244088$export$49b118289be48034).logDebug($aa968a2b9f70852c$var$FILENAME, 'initAsync', 'Initialization started');
        this.#localStorage = (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).getAndMergeStateObject($aa968a2b9f70852c$var$LocalStorageNodeName, $aa968a2b9f70852c$var$LocalStorageDefaults);
        this.#languages = [];
        // Note:
        // Languages added by user in config.json
        const languageValues = this.#getLanguageValues();
        // Note:
        // Asynchronously load all i18n-JSON-files defined by the user
        return this.#loadLanguagesAsync(languageValues);
    }
    static setMap(map) {}
    static getName() {
        return $aa968a2b9f70852c$var$FILENAME;
    }
    //--------------------------------------------------------------------
    // # Section: Fetching JSON-Languages
    //--------------------------------------------------------------------
    static async #fetchLanguagesAsync(values) {
        const timestamp = Date.now().toString();
        const requests = values.map(async (value)=>{
            return (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).get(`${this.#options.url}/${value}.json`, {
                responseType: 'application/json',
                params: {
                    cache: timestamp
                },
                headers: {
                    'Cache-Control': 'no-cache',
                    'Pragma': 'no-cache',
                    'Expires': '0'
                }
            }).then((result)=>{
                return JSON.parse(result.data);
            });
        });
        return await Promise.allSettled(requests);
    }
    static async #loadLanguagesAsync(values) {
        return this.#fetchLanguagesAsync(values).then((responses)=>{
            responses.forEach((response)=>{
                if (response.status === 'rejected') {
                    (0, $b9b5c0363f244088$export$49b118289be48034).logWarning($aa968a2b9f70852c$var$FILENAME, 'loadLanguagesAsync', {
                        info: 'Failed to load language(s)',
                        reason: response.reason,
                        status: response.status
                    });
                    return;
                }
                // Note:
                // The loaded translation must be paired with the correct language object
                // The meta object inside the <ab-cd>.json file has the text and value to use for this translation
                const loadedText = response.value.meta.text;
                const loadedValue = response.value.meta.value;
                if (!loadedText || !loadedValue) {
                    (0, $b9b5c0363f244088$export$49b118289be48034).logWarning($aa968a2b9f70852c$var$FILENAME, 'loadLanguagesAsync', {
                        info: 'Failed to find translation information in the meta section'
                    });
                    return;
                }
                const language = {
                    text: loadedText,
                    value: loadedValue,
                    translation: response.value
                };
                this.#languages.push(language);
            });
            if (this.#languages.length <= 0) {
                (0, $b9b5c0363f244088$export$49b118289be48034).logWarning($aa968a2b9f70852c$var$FILENAME, 'loadLanguagesAsync', {
                    info: 'No languages loaded, fallback to default language instance',
                    value: $aa968a2b9f70852c$var$DefaultLanguage.value
                });
                this.#languages.push((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep($aa968a2b9f70852c$var$DefaultLanguage));
            }
            // Note:
            // Decide the active language based on three conditions
            // 1. Stored language in localStorage
            // 2. Given active lang in config.json
            // 3. Fallback default language
            const storedLanguageValue = this.#localStorage.activeLanguageValue;
            const storedLanguage = this.#languages.find((language)=>{
                return language.value === storedLanguageValue;
            });
            const activeLanguageValue = (0, $1e8c0ef90ed82280$export$a33e119b2316dcb7).getConfig().localization.active;
            const activeLanguage = this.#languages.find((language)=>{
                return language.value === activeLanguageValue;
            });
            this.#activeLanguage = storedLanguage ?? activeLanguage ?? (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep($aa968a2b9f70852c$var$DefaultLanguage);
            return Promise.resolve({
                filename: $aa968a2b9f70852c$var$FILENAME,
                result: true
            });
        });
    }
    static #getLanguageValues() {
        const values = [];
        const userValues = (0, $1e8c0ef90ed82280$export$a33e119b2316dcb7).getConfig().localization.languages;
        userValues.forEach((value)=>{
            const exists = values.find((item)=>{
                return item === value;
            });
            if (exists) {
                (0, $b9b5c0363f244088$export$49b118289be48034).logWarning($aa968a2b9f70852c$var$FILENAME, 'getLanguageValues', {
                    info: 'Language already added to be loaded',
                    value: value
                });
                return;
            }
            values.push(value);
        });
        return values;
    }
    //--------------------------------------------------------------------
    // # Section: Changing Languages
    //--------------------------------------------------------------------
    static #applyLanguage() {
        const i18nKey = 'data-oltb-i18n';
        const elements = window.document.querySelectorAll(`[${i18nKey}]`);
        elements.forEach((element)=>{
            const path = element.getAttribute(i18nKey);
            const value = this.get(path);
            // Note: 
            // Tippy instances mus be handle first
            // This targets tool-buttons in the toolbar
            const tippyKey = 'data-tippy-content';
            if (element.hasAttribute(tippyKey)) {
                // Check if element should have pre or post content added
                const preValue = element.getAttribute('data-tippy-content-pre') || '';
                const postValue = element.getAttribute('data-tippy-content-post') || '';
                const concatedValue = `${preValue} ${value} ${postValue}`.trim();
                element.setAttribute(tippyKey, concatedValue);
                return;
            }
            // Note: 
            // Tippy instances mus be handle first
            // This targets all runtime delegates where the title attribute holds the tippy
            const tippyClass = 'oltb-tippy';
            if (element.classList.contains(tippyClass)) {
                element.setAttribute('title', value);
                return;
            }
            // Note: 
            // Input-fields with a placeholder value
            const placeholderKey = 'placeholder';
            if (element.hasAttribute(placeholderKey)) {
                element.setAttribute(placeholderKey, value);
                return;
            }
            // Note: 
            // Default is to replace the innerHTML for normal elements
            element.innerHTML = value;
        });
        // Note: 
        // The Tippy instances needs to be re-created
        (0, $31c79cd05d39fa2c$export$93efd44b9c955db5).applyLanguage();
    }
    //--------------------------------------------------------------------
    // # Section: Public API
    //--------------------------------------------------------------------
    static getDefaultLanguage() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep($aa968a2b9f70852c$var$DefaultLanguage);
    }
    static getLanguages() {
        return this.#languages;
    }
    static getActiveLanguage() {
        return this.#activeLanguage || (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep($aa968a2b9f70852c$var$DefaultLanguage);
    }
    static setActiveLanguage(toLanguage) {
        if (!this.#activeLanguage) this.#activeLanguage = this.getDefaultLanguage();
        if (this.#activeLanguage.value === toLanguage.value) {
            (0, $b9b5c0363f244088$export$49b118289be48034).logWarning($aa968a2b9f70852c$var$FILENAME, 'setActiveLanguage', {
                info: 'Aborting language change, selected language is already active',
                to: toLanguage.value,
                active: this.#activeLanguage.value
            });
            return;
        }
        const language = this.#languages.find((language)=>{
            return language.value === toLanguage.value;
        });
        if (!language || !(0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).has(language, [
            'translation'
        ])) {
            (0, $b9b5c0363f244088$export$49b118289be48034).logWarning($aa968a2b9f70852c$var$FILENAME, 'setActiveLanguage', {
                info: 'Selected language not found',
                language: toLanguage
            });
            return;
        }
        this.#activeLanguage = language;
        this.#localStorage.activeLanguageValue = language.value;
        // Note:
        // The apply method will do the actuall replacing of values in the UI
        this.#applyLanguage();
        // Note:
        // To remember the current chosen language after a reload/reopen of the browser
        (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).setStateObject($aa968a2b9f70852c$var$LocalStorageNodeName, this.#localStorage);
    }
    static get(path) {
        const keys = path.split('.');
        const language = this.getActiveLanguage();
        const result = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).get(language.translation, keys, path);
        // Note: 
        // Check if the path is the same as result
        // If so then we failed to find a translation
        // Not all missing translations are found by this comparison
        // An object with many translations can be returned and the view/controller might try and access one 
        // using the wrong name, this will cause 'empty'/undefined to be displayed in view
        if (result === path) (0, $b9b5c0363f244088$export$49b118289be48034).logWarning($aa968a2b9f70852c$var$FILENAME, 'get', {
            info: 'No translation found',
            keys: keys,
            path: path
        });
        return result;
    }
}


const $6155a6ed533e5b7b$var$CLASS__TOAST = 'oltb-toast';
const $6155a6ed533e5b7b$var$CLASS__ANIMATION = 'oltb-animation';
const $6155a6ed533e5b7b$var$CLASS__ANIMATION_SLIDE_IN = `${$6155a6ed533e5b7b$var$CLASS__ANIMATION}--slide-in`;
const $6155a6ed533e5b7b$var$CLASS__ANIMATION_SLIDE_OUT = `${$6155a6ed533e5b7b$var$CLASS__ANIMATION}--slide-out`;
const $6155a6ed533e5b7b$var$CLASS__ANIMATION_LINEAR_SPINNER = `${$6155a6ed533e5b7b$var$CLASS__ANIMATION}--linear-spinner`;
const $6155a6ed533e5b7b$var$DefaultOptions = Object.freeze({
    title: 'Toast',
    prefix: '',
    postfix: '',
    message: '',
    i18nKey: undefined,
    type: 'info',
    autoremove: false,
    clickToRemove: true,
    spinner: false
});
class $6155a6ed533e5b7b$export$7f6df2aba7ec538a {
    constructor(options = {}){
        this.options = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep($6155a6ed533e5b7b$var$DefaultOptions), options);
        this.#createToast();
    }
    #createToast() {
        this.toast = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'div',
            class: `${$6155a6ed533e5b7b$var$CLASS__TOAST} ${$6155a6ed533e5b7b$var$CLASS__TOAST}--${this.options.type} ${$6155a6ed533e5b7b$var$CLASS__ANIMATION} ${$6155a6ed533e5b7b$var$CLASS__ANIMATION_SLIDE_IN} oltb-d-flex`
        });
        if (this.options.clickToRemove) {
            this.toast.classList.add(`${$6155a6ed533e5b7b$var$CLASS__TOAST}--clickable`);
            this.toast.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.click, this.remove.bind(this));
        }
        if (this.options.spinner) {
            const spinnerElement = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
                element: 'div',
                class: `oltb-spinner oltb-spinner--small ${$6155a6ed533e5b7b$var$CLASS__ANIMATION} ${$6155a6ed533e5b7b$var$CLASS__ANIMATION_LINEAR_SPINNER}`
            });
            (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(this.toast, [
                spinnerElement
            ]);
        }
        const container = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'div',
            class: `${$6155a6ed533e5b7b$var$CLASS__TOAST}__container ${this.options.spinner ? 'oltb-ml-0625' : ''}`
        });
        // Note:
        // If the i18nKey is specified, the language must be fetched
        // The key is also appended to the title and message element
        // so that a active toast can do a hot-swap of the displayed language
        if (this.options.i18nKey) {
            const i18n = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get(this.options.i18nKey);
            this.options.title = i18n.title;
            this.options.message = i18n.message;
        }
        const title = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'h4',
            text: this.options.title,
            class: `${$6155a6ed533e5b7b$var$CLASS__TOAST}__title`,
            ...this.options.i18nKey && {
                attributes: {
                    'data-oltb-i18n': `${this.options.i18nKey}.title`
                }
            }
        });
        const concatMessage = `${this.options.prefix} ${this.options.message} ${this.options.postfix}`;
        const message = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'p',
            html: concatMessage,
            class: `${$6155a6ed533e5b7b$var$CLASS__TOAST}__message`,
            ...this.options.i18nKey && {
                attributes: {
                    'data-oltb-i18n': `${this.options.i18nKey}.message`
                }
            }
        });
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(container, [
            title,
            message
        ]);
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(this.toast, [
            container
        ]);
        const uiRefToastElement = (0, $8f42450ebdd44f5e$export$8e7188a60a5bbe16).getToastElement();
        uiRefToastElement.prepend(this.toast);
        if (this.options.autoremove) {
            const duration = (0, $1e8c0ef90ed82280$export$a33e119b2316dcb7).getConfig().autoRemovalDuation.normal;
            window.setTimeout(()=>{
                (0, $e1b36be5f031477b$export$cb0933279c36a66b).removeElement(this);
            }, duration);
        }
    }
    //--------------------------------------------------------------------
    // # Section: Public API
    //--------------------------------------------------------------------
    remove() {
        this.toast.classList.add(`${$6155a6ed533e5b7b$var$CLASS__TOAST}--remove`, $6155a6ed533e5b7b$var$CLASS__ANIMATION_SLIDE_OUT);
        // Note: 
        // Remove the toast from DOM after animation finishes
        const duration = (0, $1e8c0ef90ed82280$export$a33e119b2316dcb7).getConfig().animationDuration.fast;
        window.setTimeout(()=>{
            (0, $e1b36be5f031477b$export$cb0933279c36a66b).removeElement(this.toast);
            if (this.options.onRemove) this.options.onRemove();
        }, duration);
    }
    getType() {
        return this.options.type;
    }
    getTitle() {
        return this.options.title;
    }
    getMessage() {
        return this.options.message;
    }
    isSpinner() {
        return this.options.spinner;
    }
    isClickableToRemove() {
        return this.options.clickToRemove;
    }
    isAutoremove() {
        return this.options.autoremove;
    }
    getElement() {
        return this.toast;
    }
    getI18NKey() {
        return this.options.i18nKey;
    }
    static get Info() {
        return 'info';
    }
    static get Warning() {
        return 'warning';
    }
    static get Error() {
        return 'error';
    }
    static get Success() {
        return 'success';
    }
}


class $9051f0e072bf4341$export$8d8dc7d5f743331b {
    static info(options) {
        return new (0, $6155a6ed533e5b7b$export$7f6df2aba7ec538a)({
            ...options,
            type: (0, $6155a6ed533e5b7b$export$7f6df2aba7ec538a).Info
        });
    }
    static warning(options) {
        return new (0, $6155a6ed533e5b7b$export$7f6df2aba7ec538a)({
            ...options,
            type: (0, $6155a6ed533e5b7b$export$7f6df2aba7ec538a).Warning
        });
    }
    static success(options) {
        return new (0, $6155a6ed533e5b7b$export$7f6df2aba7ec538a)({
            ...options,
            type: (0, $6155a6ed533e5b7b$export$7f6df2aba7ec538a).Success
        });
    }
    static error(options) {
        return new (0, $6155a6ed533e5b7b$export$7f6df2aba7ec538a)({
            ...options,
            type: (0, $6155a6ed533e5b7b$export$7f6df2aba7ec538a).Error
        });
    }
}






const $7ffc1f94643dc7e4$var$randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $7ffc1f94643dc7e4$export$2e2bcd8739ae039 = {
    randomUUID: $7ffc1f94643dc7e4$var$randomUUID
};


let $568f4ee4022ba00e$var$getRandomValues;
const $568f4ee4022ba00e$var$rnds8 = new Uint8Array(16);
function $568f4ee4022ba00e$export$2e2bcd8739ae039() {
    if (!$568f4ee4022ba00e$var$getRandomValues) {
        if (typeof crypto === 'undefined' || !crypto.getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
        $568f4ee4022ba00e$var$getRandomValues = crypto.getRandomValues.bind(crypto);
    }
    return $568f4ee4022ba00e$var$getRandomValues($568f4ee4022ba00e$var$rnds8);
}


var $32c496bfb6c27b56$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/i;


function $46d323206dcbf256$var$validate(uuid) {
    return typeof uuid === 'string' && (0, $32c496bfb6c27b56$export$2e2bcd8739ae039).test(uuid);
}
var $46d323206dcbf256$export$2e2bcd8739ae039 = $46d323206dcbf256$var$validate;


const $1d0137947e8554ce$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$1d0137947e8554ce$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $1d0137947e8554ce$export$8fb373d660548968(arr, offset = 0) {
    return ($1d0137947e8554ce$var$byteToHex[arr[offset + 0]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 1]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 2]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 3]] + '-' + $1d0137947e8554ce$var$byteToHex[arr[offset + 4]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 5]] + '-' + $1d0137947e8554ce$var$byteToHex[arr[offset + 6]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 7]] + '-' + $1d0137947e8554ce$var$byteToHex[arr[offset + 8]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 9]] + '-' + $1d0137947e8554ce$var$byteToHex[arr[offset + 10]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 11]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 12]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 13]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 14]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 15]]).toLowerCase();
}
function $1d0137947e8554ce$var$stringify(arr, offset = 0) {
    const uuid = $1d0137947e8554ce$export$8fb373d660548968(arr, offset);
    if (!(0, $46d323206dcbf256$export$2e2bcd8739ae039)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
var $1d0137947e8554ce$export$2e2bcd8739ae039 = $1d0137947e8554ce$var$stringify;


function $3fa3ae484854b431$var$v4(options, buf, offset) {
    if ((0, $7ffc1f94643dc7e4$export$2e2bcd8739ae039).randomUUID && !buf && !options) return (0, $7ffc1f94643dc7e4$export$2e2bcd8739ae039).randomUUID();
    options = options || {};
    const rnds = options.random ?? options.rng?.() ?? (0, $568f4ee4022ba00e$export$2e2bcd8739ae039)();
    if (rnds.length < 16) throw new Error('Random bytes length must be >= 16');
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    if (buf) {
        offset = offset || 0;
        if (offset < 0 || offset + 16 > buf.length) throw new RangeError(`UUID byte range ${offset}:${offset + 15} is out of buffer bounds`);
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $1d0137947e8554ce$export$8fb373d660548968)(rnds);
}
var $3fa3ae484854b431$export$2e2bcd8739ae039 = $3fa3ae484854b431$var$v4;



var $f1q41 = parcelRequire("f1q41");
const $a439639f4ccc8a26$var$nullKey = Symbol('null'); // `objectHashes` key for null
let $a439639f4ccc8a26$var$keyCounter = 0;
class $a439639f4ccc8a26$export$2e2bcd8739ae039 extends Map {
    constructor(){
        super();
        this._objectHashes = new WeakMap();
        this._symbolHashes = new Map(); // https://github.com/tc39/ecma262/issues/1194
        this._publicKeys = new Map();
        const [pairs] = arguments; // Map compat
        if (pairs === null || pairs === undefined) return;
        if (typeof pairs[Symbol.iterator] !== 'function') throw new TypeError(typeof pairs + ' is not iterable (cannot read property Symbol(Symbol.iterator))');
        for (const [keys, value] of pairs)this.set(keys, value);
    }
    _getPublicKeys(keys, create = false) {
        if (!Array.isArray(keys)) throw new TypeError('The keys parameter must be an array');
        const privateKey = this._getPrivateKey(keys, create);
        let publicKey;
        if (privateKey && this._publicKeys.has(privateKey)) publicKey = this._publicKeys.get(privateKey);
        else if (create) {
            publicKey = [
                ...keys
            ]; // Regenerate keys array to avoid external interaction
            this._publicKeys.set(privateKey, publicKey);
        }
        return {
            privateKey: privateKey,
            publicKey: publicKey
        };
    }
    _getPrivateKey(keys, create = false) {
        const privateKeys = [];
        for (let key of keys){
            if (key === null) key = $a439639f4ccc8a26$var$nullKey;
            const hashes = typeof key === 'object' || typeof key === 'function' ? '_objectHashes' : typeof key === 'symbol' ? '_symbolHashes' : false;
            if (!hashes) privateKeys.push(key);
            else if (this[hashes].has(key)) privateKeys.push(this[hashes].get(key));
            else if (create) {
                const privateKey = `@@mkm-ref-${$a439639f4ccc8a26$var$keyCounter++}@@`;
                this[hashes].set(key, privateKey);
                privateKeys.push(privateKey);
            } else return false;
        }
        return JSON.stringify(privateKeys);
    }
    set(keys, value) {
        const { publicKey: publicKey } = this._getPublicKeys(keys, true);
        return super.set(publicKey, value);
    }
    get(keys) {
        const { publicKey: publicKey } = this._getPublicKeys(keys);
        return super.get(publicKey);
    }
    has(keys) {
        const { publicKey: publicKey } = this._getPublicKeys(keys);
        return super.has(publicKey);
    }
    delete(keys) {
        const { publicKey: publicKey, privateKey: privateKey } = this._getPublicKeys(keys);
        return Boolean(publicKey && super.delete(publicKey) && this._publicKeys.delete(privateKey));
    }
    clear() {
        super.clear();
        this._symbolHashes.clear();
        this._publicKeys.clear();
    }
    get [Symbol.toStringTag]() {
        return 'ManyKeysMap';
    }
    get size() {
        return super.size;
    }
}


/**
 * @module ol/geom/MultiPoint
 */ 






/**
 * @classdesc
 * Multi-point geometry.
 *
 * @api
 */ class $e6080c63a9451eda$var$MultiPoint extends (0, $c76e993e57efc8c4$export$2e2bcd8739ae039) {
    /**
   * @param {Array<import("../coordinate.js").Coordinate>|Array<number>} coordinates Coordinates.
   *     For internal use, flat coordinates in combination with `layout` are also accepted.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   */ constructor(coordinates, layout){
        super();
        if (layout && !Array.isArray(coordinates[0])) this.setFlatCoordinates(layout, /** @type {Array<number>} */ coordinates);
        else this.setCoordinates(/** @type {Array<import("../coordinate.js").Coordinate>} */ coordinates, layout);
    }
    /**
   * Append the passed point to this multipoint.
   * @param {Point} point Point.
   * @api
   */ appendPoint(point) {
        (0, $b998d41b678ed5d1$export$8b58be045bf06082)(this.flatCoordinates, point.getFlatCoordinates());
        this.changed();
    }
    /**
   * Make a complete copy of the geometry.
   * @return {!MultiPoint} Clone.
   * @api
   * @override
   */ clone() {
        const multiPoint = new $e6080c63a9451eda$var$MultiPoint(this.flatCoordinates.slice(), this.layout);
        multiPoint.applyProperties(this);
        return multiPoint;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   * @override
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < (0, $6da4c8ed3074c92b$export$cbe64c389534206f)(this.getExtent(), x, y)) return minSquaredDistance;
        const flatCoordinates = this.flatCoordinates;
        const stride = this.stride;
        for(let i = 0, ii = flatCoordinates.length; i < ii; i += stride){
            const squaredDistance = (0, $6b000a049d919fe5$export$88e6ebb4fe54f538)(x, y, flatCoordinates[i], flatCoordinates[i + 1]);
            if (squaredDistance < minSquaredDistance) {
                minSquaredDistance = squaredDistance;
                for(let j = 0; j < stride; ++j)closestPoint[j] = flatCoordinates[i + j];
                closestPoint.length = stride;
            }
        }
        return minSquaredDistance;
    }
    /**
   * Return the coordinates of the multipoint.
   * @return {Array<import("../coordinate.js").Coordinate>} Coordinates.
   * @api
   * @override
   */ getCoordinates() {
        return (0, $5454470599558ddd$export$9c0934e4e9c3f61e)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride);
    }
    /**
   * Return the point at the specified index.
   * @param {number} index Index.
   * @return {Point} Point.
   * @api
   */ getPoint(index) {
        const n = this.flatCoordinates.length / this.stride;
        if (index < 0 || n <= index) return null;
        return new (0, $6eced4c969949f6b$export$2e2bcd8739ae039)(this.flatCoordinates.slice(index * this.stride, (index + 1) * this.stride), this.layout);
    }
    /**
   * Return the points of this multipoint.
   * @return {Array<Point>} Points.
   * @api
   */ getPoints() {
        const flatCoordinates = this.flatCoordinates;
        const layout = this.layout;
        const stride = this.stride;
        /** @type {Array<Point>} */ const points = [];
        for(let i = 0, ii = flatCoordinates.length; i < ii; i += stride){
            const point = new (0, $6eced4c969949f6b$export$2e2bcd8739ae039)(flatCoordinates.slice(i, i + stride), layout);
            points.push(point);
        }
        return points;
    }
    /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   * @override
   */ getType() {
        return 'MultiPoint';
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   * @override
   */ intersectsExtent(extent) {
        const flatCoordinates = this.flatCoordinates;
        const stride = this.stride;
        for(let i = 0, ii = flatCoordinates.length; i < ii; i += stride){
            const x = flatCoordinates[i];
            const y = flatCoordinates[i + 1];
            if ((0, $6da4c8ed3074c92b$export$805bdfd6d6690e97)(extent, x, y)) return true;
        }
        return false;
    }
    /**
   * Set the coordinates of the multipoint.
   * @param {!Array<import("../coordinate.js").Coordinate>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   * @override
   */ setCoordinates(coordinates, layout) {
        this.setLayout(layout, coordinates, 1);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        this.flatCoordinates.length = (0, $6b086aa46281540d$export$5c4daf67e03c190f)(this.flatCoordinates, 0, coordinates, this.stride);
        this.changed();
    }
}
var $e6080c63a9451eda$export$2e2bcd8739ae039 = $e6080c63a9451eda$var$MultiPoint;






var $f1q41 = parcelRequire("f1q41");
const $6df69bb70a495c9c$export$3fddabec91763a6e = Object.freeze({
    knot0: '<path fill="rgba(59, 67, 82, 1)" d="M125,120c2.762,0,5,2.239,5,5c0,2.762-2.238,5-5,5c-2.761,0-5-2.238-5-5C120,122.239,122.239,120,125,120z"/><path fill="none" stroke="rgba(59, 67, 82, 1)" stroke-width="2" d="M125,115c5.523,0,10,4.477,10,10c0,5.523-4.477,10-10,10 c-5.523,0-10-4.477-10-10C115,119.477,119.477,115,125,115z "/>',
    knot2: '<path d="M125,112V76 M125,125l7-12.1h-14L125,125z"/>',
    knot5: '<path d="M125,112V76 M125,89l7-7 M125,125l7-12.1h-14L125,125z"/>',
    knot10: '<path d="M125,112V89 M125,89l14-14 M125,125l7-12.1h-14L125,125z"/>',
    knot15: '<path d="M125,112V89 M125,89l14-14 M125,100l7-7 M125,125l7-12.1h-14L125,125z"/>',
    knot20: '<path d="M125,112V89 M125,89l14-14 M125,100l14-14 M125,125l7-12.1h-14L125,125z"/>',
    knot25: '<path d="M125,112V79 M125,79l14-14 M125,90l14-14 M125,100l7-7 M125,125l7-12.1h-14L125,125z"/>',
    knot30: '<path d="M125,112V79 M125,79l14-14 M125,90l14-14 M125,100l14-14 M125,125l7-12.1h-14L125,125z"/>',
    knot35: '<path d="M125,112V69 M125,69l14-14 M125,80l14-14 M125,90l14-14 M125,100l7-7 M125,125l7-12.1h-14L125,125z"/>',
    knot40: '<path d="M125,112V69 M125,69l14-14 M125,80l14-14 M125,90l14-14 M125,100l14-14 M125,125l7-12.1h-14L125,125z"/>',
    knot45: '<path d="M125,112V59 M125,59l14-14 M125,70l14-14 M125,80l14-14 M125,90l14-14 M125,100l7-7 M125,125l7-12.1h-14 L125,125z"/>',
    knot50: '<path d="M125,112V76 M125,76h14l-14,14V76z M125,125l7-12.1h-14L125,125z"/>',
    knot55: '<path d="M125,112V76 M125,76h14l-14,14V76z M125,100l7-7 M125,125l7-12.1h-14L125,125z"/>',
    knot60: '<path d="M125,112V76 M125,76h14l-14,14V76z M125,100l14-14 M125,125l7-12.1h-14L125,125z"/>',
    knot65: '<path d="M125,112V66 M125,66h14l-14,14V66z M125,90l14-14 M125,100l7-7 M125,125l7-12.1h-14L125,125z"/>',
    knot70: '<path d="M125,112V66 M125,66h14l-14,14V66z M125,90l14-14 M125,100l14-14 M125,125l7-12.1h-14L125,125z"/>',
    knot75: '<path d="M125,112V56 M125,56h14l-14,14V56z M125,80l14-14 M125,90l14-14 M125,100l7-7 M125,125l7-12.1h-14L125,125z"/>',
    knot80: '<path d="M125,112V56 M125,56h14l-14,14V56z M125,80l14-14 M125,90l14-14 M125,100l14-14 M125,125l7-12.1h-14L125,125z"/>',
    knot85: '<path d="M125,112V46 M125,46h14l-14,14V46z M125,70l14-14 M125,80l14-14 M125,90l14-14 M125,100l7-7 M125,125l7-12.1 h-14L125,125z"/>',
    knot90: '<path d="M125,112V46 M125,46h14l-14,14V46z M125,70l14-14 M125,80l14-14 M125,90l14-14 M125,100l14-14 M125,125l7-12.1 h-14L125,125z"/>',
    knot95: '<path d="M125,112V36 M125,36h14l-14,14V36z M125,60l14-14 M125,70l14-14 M125,80l14-14 M125,90l14-14 M125,100l7-7 M125,125l7-12.1h-14L125,125z"/>',
    knot100: '<path d="M125,112V62 M125,62h14l-14,14V62z M125,76h14l-14,14V76z M125,125l7-12.1h-14L125,125z"/>',
    knot105: '<path d="M125,112V62 M125,62h14l-14,14V62z M125,76h14l-14,14V76z M125,100l7-7 M125,125l7-12.1h-14L125,125z"/>',
    knot110: '<path d="M125,112V62 M125,62h14l-14,14V62z M125,76h14l-14,14V76z M125,100l14-14 M125,125l7-12.1h-14L125,125z"/>',
    knot115: '<path d="M125,112V52 M125,52h14l-14,14V52z M125,66h14l-14,14V66z M125,90l14-14 M125,100l7-7 M125,125l7-12.1h-14 L125,125z"/>',
    knot120: '<path d="M125,112V52 M125,52h14l-14,14V52z M125,66h14l-14,14V66z M125,90l14-14 M125,100l14-14 M125,125l7-12.1h-14 L125,125z"/>',
    knot125: '<path d="M125,112V42 M125,42h14l-14,14V42z M125,56h14l-14,14V56z M125,80l14-14 M125,90l14-14 M125,100l7-7 M125,125 l7-12.1h-14L125,125z"/>',
    knot130: '<path d="M125,112V42 M125,42h14l-14,14V42z M125,56h14l-14,14V56z M125,80l14-14 M125,90l14-14 M125,100l14-14 M125,125 l7-12.1h-14L125,125z"/>',
    knot135: '<path d="M125,112V32 M125,32h14l-14,14V32z M125,46h14l-14,14V46z M125,70l14-14 M125,80l14-14 M125,90l14-14 M125,100 l7-7 M125,125l7-12.1h-14L125,125z"/>',
    knot140: '<path d="M125,112V32 M125,32h14l-14,14V32z M125,46h14l-14,14V46z M125,70l14-14 M125,80l14-14 M125,90l14-14 M125,100 l14-14 M125,125l7-12.1h-14L125,125z"/>',
    knot145: '<path d="M125,112V22 M125,22h14l-14,14V22z M125,36h14l-14,14V36z M125,60l14-14 M125,70l14-14 M125,80l14-14 M125,90 l14-14 M125,100l7-7 M125,125l7-12.1h-14L125,125z"/>',
    knot150: '<path d="M125,112V48 M125,48h14l-14,14V48z M125,62h14l-14,14V62z M125,76h14l-14,14V76z M125,125l7-12.1h-14L125,125z"/>',
    knot155: '<path d="M125,112V48 M125,48h14l-14,14V48z M125,62h14l-14,14V62z M125,76h14l-14,14V76z M125,100l7-7 M125,125l7-12.1 h-14L125,125z"/>',
    knot160: '<path d="M125,112V48 M125,48h14l-14,14V48z M125,62h14l-14,14V62z M125,76h14l-14,14V76z M125,100l14-14 M125,125 l7-12.1h-14L125,125z"/>',
    knot165: '<path d="M125,112V38 M125,38h14l-14,14V38z M125,52h14l-14,14V52z M125,66h14l-14,14V66z M125,90l14-14 M125,100l7-7 M125,125l7-12.1h-14L125,125z"/>',
    knot170: '<path d="M125,112V38 M125,38h14l-14,14V38z M125,52h14l-14,14V52z M125,66h14l-14,14V66z M125,90l14-14 M125,100l14-14 M125,125l7-12.1h-14L125,125z"/>',
    knot175: '<path d="M125,112V28 M125,28h14l-14,14V28z M125,42h14l-14,14V42z M125,56h14l-14,14V56z M125,80l14-14 M125,90l14-14 M125,100l7-7 M125,125l7-12.1h-14L125,125z"/>',
    knot180: '<path d="M125,112V28 M125,28h14l-14,14V28z M125,42h14l-14,14V42z M125,56h14l-14,14V56z M125,80l14-14 M125,90l14-14 M125,100l14-14 M125,125l7-12.1h-14L125,125z"/>',
    knot185: '<path d="M125,112V18 M125,18h14l-14,14V18z M125,32h14l-14,14V32z M125,46h14l-14,14V46z M125,70l14-14 M125,80l14-14 M125,90l14-14 M125,100l7-7 M125,125l7-12.1h-14L125,125z"/>',
    knot190: '<path d="M125,112V18 M125,18h14l-14,14V18z M125,32h14l-14,14V32z M125,46h14l-14,14V46z M125,70l14-14 M125,80l14-14 M125,90l14-14 M125,100l14-14 M125,125l7-12.1h-14L125,125z"/>'
});




const $206be50bf50f716a$var$FILENAME = 'conversion-manager.js';
/**
 * About:
 * ConversionManager
 * 
 * Description:
 * Manager responsible for converting different types of numerical values.
 */ class $206be50bf50f716a$export$53fa2d26c9df363b extends (0, $8a2666592e7029ee$export$84777416d052f822) {
    //--------------------------------------------------------------------
    // # Section: Base Overrides
    //--------------------------------------------------------------------
    static async initAsync(options = {}) {
        (0, $b9b5c0363f244088$export$49b118289be48034).logDebug($206be50bf50f716a$var$FILENAME, 'initAsync', 'Initialization started');
        return new Promise((resolve)=>{
            resolve({
                filename: $206be50bf50f716a$var$FILENAME,
                result: true
            });
        });
    }
    static setMap(map) {}
    static getName() {
        return $206be50bf50f716a$var$FILENAME;
    }
    //--------------------------------------------------------------------
    // # Section: Public API
    //--------------------------------------------------------------------
    static roundToNearest(value, nearest) {
        return Math.round(value / nearest) * nearest;
    }
    static roundUpToNearest(value, nearest) {
        return Math.ceil(value / nearest) * nearest;
    }
    static roundDownToNearest(value, nearest) {
        return Math.floor(value / nearest) * nearest;
    }
    static degreesToRadians(degrees) {
        return degrees * (Math.PI / 180);
    }
    static radiansToDegrees(radians) {
        return radians * (180 / Math.PI);
    }
    static metersPerSecondToKnots(mps) {
        return mps * 1.94384;
    }
    static knotsToMetersPerSecond(knots) {
        return knots * 0.51444;
    }
}


const $e5877a8f70dee3d8$var$getSvgPath = function(windSpeed) {
    // Note: 
    // Base case that breaks the pattern of 2.5 m/s steps
    if (windSpeed >= 1.0 && windSpeed < 2.5) return (0, $6df69bb70a495c9c$export$3fddabec91763a6e).knot2;
    const meterPerSecondStep = 2.5;
    const lowerMeterPerSecond = (0, $206be50bf50f716a$export$53fa2d26c9df363b).roundDownToNearest(windSpeed, meterPerSecondStep);
    const knots = (0, $206be50bf50f716a$export$53fa2d26c9df363b).metersPerSecondToKnots(lowerMeterPerSecond);
    const knotPerSecondStep = 5;
    const lowerKnotPerSecond = (0, $206be50bf50f716a$export$53fa2d26c9df363b).roundToNearest(knots, knotPerSecondStep);
    const windBarbName = `knot${lowerKnotPerSecond}`;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).has((0, $6df69bb70a495c9c$export$3fddabec91763a6e), [
        windBarbName
    ])) return (0, $6df69bb70a495c9c$export$3fddabec91763a6e)[windBarbName];
    return (0, $6df69bb70a495c9c$export$3fddabec91763a6e).knot0;
};
const $e5877a8f70dee3d8$var$DefaultOptions = Object.freeze({
    windSpeed: 0,
    width: 250,
    height: 250,
    fill: '#3B4352FF',
    stroke: '#3B4352FF',
    strokeWidth: 3,
    shouldReplaceHashtag: false
});
const $e5877a8f70dee3d8$export$4ca13446b4014f95 = function(options = {}) {
    options = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep($e5877a8f70dee3d8$var$DefaultOptions), options);
    // Note: 
    // HEX Colors are not valid in SVG 
    // Unless they are replaced with URL alternative char
    const ENCODED_HASHTAG = '%23';
    if (options.shouldReplaceHashtag) {
        options.fill = options.fill.replace('#', ENCODED_HASHTAG);
        options.stroke = options.stroke.replace('#', ENCODED_HASHTAG);
    }
    return `
        <svg xmlns="http://www.w3.org/2000/svg" 
            width="${options.width}" 
            height="${options.height}" 
            fill="${options.fill}"
            stroke="${options.stroke}"
            stroke-width="${options.strokeWidth}"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-miterlimit="10"
            viewBox="0 0 250 250">
            ${$e5877a8f70dee3d8$var$getSvgPath(options.windSpeed)}
        </svg>
    `;
};



// Note: 
// These properties are placed inside the oltb object in the feature
// So they don't need to be prefixed with oltb
const $60b20182c25e327b$export$2906e7f4b228efe9 = Object.freeze({
    type: Object.freeze({
        layer: 'layer',
        iconMarker: 'iconMarker',
        windBarb: 'windBarb',
        measurement: 'measurement',
        drawing: 'drawing',
        snapLine: 'snapLine'
    })
});



var $f1q41 = parcelRequire("f1q41");
const $35649bc6579784f8$export$3fddabec91763a6e = Object.freeze({
    airplane: Object.freeze({
        stroked: `
            <path d="M6.428 1.151C6.708.591 7.213 0 8 0s1.292.592 1.572 1.151C9.861 1.73 10 2.431 10 3v3.691l5.17 2.585a1.5 1.5 0 0 1 .83 1.342V12a.5.5 0 0 1-.582.493l-5.507-.918-.375 2.253 1.318 1.318A.5.5 0 0 1 10.5 16h-5a.5.5 0 0 1-.354-.854l1.319-1.318-.376-2.253-5.507.918A.5.5 0 0 1 0 12v-1.382a1.5 1.5 0 0 1 .83-1.342L6 6.691V3c0-.568.14-1.271.428-1.849Zm.894.448C7.111 2.02 7 2.569 7 3v4a.5.5 0 0 1-.276.447l-5.448 2.724a.5.5 0 0 0-.276.447v.792l5.418-.903a.5.5 0 0 1 .575.41l.5 3a.5.5 0 0 1-.14.437L6.708 15h2.586l-.647-.646a.5.5 0 0 1-.14-.436l.5-3a.5.5 0 0 1 .576-.411L15 11.41v-.792a.5.5 0 0 0-.276-.447L9.276 7.447A.5.5 0 0 1 9 7V3c0-.432-.11-.979-.322-1.401C8.458 1.159 8.213 1 8 1c-.213 0-.458.158-.678.599Z"/>
        `,
        filled: `
            <path d="M6.428 1.151C6.708.591 7.213 0 8 0s1.292.592 1.572 1.151C9.861 1.73 10 2.431 10 3v3.691l5.17 2.585a1.5 1.5 0 0 1 .83 1.342V12a.5.5 0 0 1-.582.493l-5.507-.918-.375 2.253 1.318 1.318A.5.5 0 0 1 10.5 16h-5a.5.5 0 0 1-.354-.854l1.319-1.318-.376-2.253-5.507.918A.5.5 0 0 1 0 12v-1.382a1.5 1.5 0 0 1 .83-1.342L6 6.691V3c0-.568.14-1.271.428-1.849Z"/>
        `
    }),
    arrowClockwise: Object.freeze({
        stroked: `
            <path fill-rule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"/>
            <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z"/>      
        `
    }),
    arrowLeftRight: Object.freeze({
        stroked: `
            <path fill-rule="evenodd" d="M1 11.5a.5.5 0 0 0 .5.5h11.793l-3.147 3.146a.5.5 0 0 0 .708.708l4-4a.5.5 0 0 0 0-.708l-4-4a.5.5 0 0 0-.708.708L13.293 11H1.5a.5.5 0 0 0-.5.5m14-7a.5.5 0 0 1-.5.5H2.707l3.147 3.146a.5.5 0 1 1-.708.708l-4-4a.5.5 0 0 1 0-.708l4-4a.5.5 0 1 1 .708.708L2.707 4H14.5a.5.5 0 0 1 .5.5"/>
        `
    }),
    arrowRepeat: Object.freeze({
        stroked: `
            <path d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41zm-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9z"/>
            <path fill-rule="evenodd" d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5.002 5.002 0 0 0 8 3zM3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9H3.1z"/>  
        `
    }),
    arrowsExpandHorizontal: Object.freeze({
        stroked: `
            <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 1 8ZM7.646.146a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 1.707V5.5a.5.5 0 0 1-1 0V1.707L6.354 2.854a.5.5 0 1 1-.708-.708l2-2ZM8 10a.5.5 0 0 1 .5.5v3.793l1.146-1.147a.5.5 0 0 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 0 1 .708-.708L7.5 14.293V10.5A.5.5 0 0 1 8 10Z"/>
        `
    }),
    arrowsExpandVertical: Object.freeze({
        stroked: `
            <path d="M8 15a.5.5 0 0 1-.5-.5v-13a.5.5 0 0 1 1 0v13a.5.5 0 0 1-.5.5ZM.146 8.354a.5.5 0 0 1 0-.708l2-2a.5.5 0 1 1 .708.708L1.707 7.5H5.5a.5.5 0 0 1 0 1H1.707l1.147 1.146a.5.5 0 0 1-.708.708l-2-2ZM10 8a.5.5 0 0 1 .5-.5h3.793l-1.147-1.146a.5.5 0 0 1 .708-.708l2 2a.5.5 0 0 1 0 .708l-2 2a.5.5 0 0 1-.708-.708L14.293 8.5H10.5A.5.5 0 0 1 10 8Z"/>
        `
    }),
    arrowsMove: Object.freeze({
        stroked: `
            <path fill-rule="evenodd" d="M7.646.146a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 1.707V5.5a.5.5 0 0 1-1 0V1.707L6.354 2.854a.5.5 0 1 1-.708-.708l2-2zM8 10a.5.5 0 0 1 .5.5v3.793l1.146-1.147a.5.5 0 0 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 0 1 .708-.708L7.5 14.293V10.5A.5.5 0 0 1 8 10zM.146 8.354a.5.5 0 0 1 0-.708l2-2a.5.5 0 1 1 .708.708L1.707 7.5H5.5a.5.5 0 0 1 0 1H1.707l1.147 1.146a.5.5 0 0 1-.708.708l-2-2zM10 8a.5.5 0 0 1 .5-.5h3.793l-1.147-1.146a.5.5 0 0 1 .708-.708l2 2a.5.5 0 0 1 0 .708l-2 2a.5.5 0 0 1-.708-.708L14.293 8.5H10.5A.5.5 0 0 1 10 8z"/>
        `
    }),
    aspectRatio: Object.freeze({
        stroked: `
            <path d="M0 3.5A1.5 1.5 0 0 1 1.5 2h13A1.5 1.5 0 0 1 16 3.5v9a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 12.5v-9zM1.5 3a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-13z"/>
            <path d="M2 4.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1H3v2.5a.5.5 0 0 1-1 0v-3zm12 7a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1 0-1H13V8.5a.5.5 0 0 1 1 0v3z"/>      
        `,
        filled: `
            <path d="M0 12.5v-9A1.5 1.5 0 0 1 1.5 2h13A1.5 1.5 0 0 1 16 3.5v9a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 12.5zM2.5 4a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 1 0V5h2.5a.5.5 0 0 0 0-1h-3zm11 8a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-1 0V11h-2.5a.5.5 0 0 0 0 1h3z"/>
        `
    }),
    bell: Object.freeze({
        stroked: `
            <path d="M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2zM8 1.918l-.797.161A4.002 4.002 0 0 0 4 6c0 .628-.134 2.197-.459 3.742-.16.767-.376 1.566-.663 2.258h10.244c-.287-.692-.502-1.49-.663-2.258C12.134 8.197 12 6.628 12 6a4.002 4.002 0 0 0-3.203-3.92L8 1.917zM14.22 12c.223.447.481.801.78 1H1c.299-.199.557-.553.78-1C2.68 10.2 3 6.88 3 6c0-2.42 1.72-4.44 4.005-4.901a1 1 0 1 1 1.99 0A5.002 5.002 0 0 1 13 6c0 .88.32 4.2 1.22 6z"/>
        `,
        filled: `
            <path d="M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2zm.995-14.901a1 1 0 1 0-1.99 0A5.002 5.002 0 0 0 3 6c0 1.098-.5 6-2 7h14c-1.5-1-2-5.902-2-7 0-2.42-1.72-4.44-4.005-4.901z"/>
        `
    }),
    bookmarkStar: Object.freeze({
        stroked: `
            <path d="M7.84 4.1a.178.178 0 0 1 .32 0l.634 1.285a.178.178 0 0 0 .134.098l1.42.206c.145.021.204.2.098.303L9.42 6.993a.178.178 0 0 0-.051.158l.242 1.414a.178.178 0 0 1-.258.187l-1.27-.668a.178.178 0 0 0-.165 0l-1.27.668a.178.178 0 0 1-.257-.187l.242-1.414a.178.178 0 0 0-.05-.158l-1.03-1.001a.178.178 0 0 1 .098-.303l1.42-.206a.178.178 0 0 0 .134-.098L7.84 4.1z"/>
            <path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v13.5a.5.5 0 0 1-.777.416L8 13.101l-5.223 2.815A.5.5 0 0 1 2 15.5V2zm2-1a1 1 0 0 0-1 1v12.566l4.723-2.482a.5.5 0 0 1 .554 0L13 14.566V2a1 1 0 0 0-1-1H4z"/>
        `,
        filled: `
            <path fill-rule="evenodd" d="M2 15.5V2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v13.5a.5.5 0 0 1-.74.439L8 13.069l-5.26 2.87A.5.5 0 0 1 2 15.5zM8.16 4.1a.178.178 0 0 0-.32 0l-.634 1.285a.178.178 0 0 1-.134.098l-1.42.206a.178.178 0 0 0-.098.303L6.58 6.993c.042.041.061.1.051.158L6.39 8.565a.178.178 0 0 0 .258.187l1.27-.668a.178.178 0 0 1 .165 0l1.27.668a.178.178 0 0 0 .257-.187L9.368 7.15a.178.178 0 0 1 .05-.158l1.028-1.001a.178.178 0 0 0-.098-.303l-1.42-.206a.178.178 0 0 1-.134-.098L8.16 4.1z"/>
        `
    }),
    bookmarkX: Object.freeze({
        stroked: `
            <path fill-rule="evenodd" d="M6.146 5.146a.5.5 0 0 1 .708 0L8 6.293l1.146-1.147a.5.5 0 1 1 .708.708L8.707 7l1.147 1.146a.5.5 0 0 1-.708.708L8 7.707 6.854 8.854a.5.5 0 1 1-.708-.708L7.293 7 6.146 5.854a.5.5 0 0 1 0-.708z"/>
            <path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v13.5a.5.5 0 0 1-.777.416L8 13.101l-5.223 2.815A.5.5 0 0 1 2 15.5V2zm2-1a1 1 0 0 0-1 1v12.566l4.723-2.482a.5.5 0 0 1 .554 0L13 14.566V2a1 1 0 0 0-1-1H4z"/>      
        `,
        filled: `
            <path fill-rule="evenodd" d="M2 15.5V2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v13.5a.5.5 0 0 1-.74.439L8 13.069l-5.26 2.87A.5.5 0 0 1 2 15.5zM6.854 5.146a.5.5 0 1 0-.708.708L7.293 7 6.146 8.146a.5.5 0 1 0 .708.708L8 7.707l1.146 1.147a.5.5 0 1 0 .708-.708L8.707 7l1.147-1.146a.5.5 0 0 0-.708-.708L8 6.293 6.854 5.146z"/>
        `
    }),
    boundingBoxCircles: Object.freeze({
        stroked: `
            <path d="M2 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM0 2a2 2 0 0 1 3.937-.5h8.126A2 2 0 1 1 14.5 3.937v8.126a2 2 0 1 1-2.437 2.437H3.937A2 2 0 1 1 1.5 12.063V3.937A2 2 0 0 1 0 2zm2.5 1.937v8.126c.703.18 1.256.734 1.437 1.437h8.126a2.004 2.004 0 0 1 1.437-1.437V3.937A2.004 2.004 0 0 1 12.063 2.5H3.937A2.004 2.004 0 0 1 2.5 3.937zM14 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM2 13a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm12 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"/>
        `
    }),
    braces: Object.freeze({
        stroked: `
            <path d="M2.114 8.063V7.9c1.005-.102 1.497-.615 1.497-1.6V4.503c0-1.094.39-1.538 1.354-1.538h.273V2h-.376C3.25 2 2.49 2.759 2.49 4.352v1.524c0 1.094-.376 1.456-1.49 1.456v1.299c1.114 0 1.49.362 1.49 1.456v1.524c0 1.593.759 2.352 2.372 2.352h.376v-.964h-.273c-.964 0-1.354-.444-1.354-1.538V9.663c0-.984-.492-1.497-1.497-1.6zM13.886 7.9v.163c-1.005.103-1.497.616-1.497 1.6v1.798c0 1.094-.39 1.538-1.354 1.538h-.273v.964h.376c1.613 0 2.372-.759 2.372-2.352v-1.524c0-1.094.376-1.456 1.49-1.456V7.332c-1.114 0-1.49-.362-1.49-1.456V4.352C13.51 2.759 12.75 2 11.138 2h-.376v.964h.273c.964 0 1.354.444 1.354 1.538V6.3c0 .984.492 1.497 1.497 1.6z"/>
        `
    }),
    bug: Object.freeze({
        stroked: `
            <path d="M4.355.522a.5.5 0 0 1 .623.333l.291.956A4.979 4.979 0 0 1 8 1c1.007 0 1.946.298 2.731.811l.29-.956a.5.5 0 1 1 .957.29l-.41 1.352A4.985 4.985 0 0 1 13 6h.5a.5.5 0 0 0 .5-.5V5a.5.5 0 0 1 1 0v.5A1.5 1.5 0 0 1 13.5 7H13v1h1.5a.5.5 0 0 1 0 1H13v1h.5a1.5 1.5 0 0 1 1.5 1.5v.5a.5.5 0 1 1-1 0v-.5a.5.5 0 0 0-.5-.5H13a5 5 0 0 1-10 0h-.5a.5.5 0 0 0-.5.5v.5a.5.5 0 1 1-1 0v-.5A1.5 1.5 0 0 1 2.5 10H3V9H1.5a.5.5 0 0 1 0-1H3V7h-.5A1.5 1.5 0 0 1 1 5.5V5a.5.5 0 0 1 1 0v.5a.5.5 0 0 0 .5.5H3c0-1.364.547-2.601 1.432-3.503l-.41-1.352a.5.5 0 0 1 .333-.623zM4 7v4a4 4 0 0 0 3.5 3.97V7H4zm4.5 0v7.97A4 4 0 0 0 12 11V7H8.5zM12 6a3.989 3.989 0 0 0-1.334-2.982A3.983 3.983 0 0 0 8 2a3.983 3.983 0 0 0-2.667 1.018A3.989 3.989 0 0 0 4 6h8z"/>
        `,
        filled: `
            <path d="M4.978.855a.5.5 0 1 0-.956.29l.41 1.352A4.985 4.985 0 0 0 3 6h10a4.985 4.985 0 0 0-1.432-3.503l.41-1.352a.5.5 0 1 0-.956-.29l-.291.956A4.978 4.978 0 0 0 8 1a4.979 4.979 0 0 0-2.731.811l-.29-.956z"/>
            <path d="M13 6v1H8.5v8.975A5 5 0 0 0 13 11h.5a.5.5 0 0 1 .5.5v.5a.5.5 0 1 0 1 0v-.5a1.5 1.5 0 0 0-1.5-1.5H13V9h1.5a.5.5 0 0 0 0-1H13V7h.5A1.5 1.5 0 0 0 15 5.5V5a.5.5 0 0 0-1 0v.5a.5.5 0 0 1-.5.5H13zm-5.5 9.975V7H3V6h-.5a.5.5 0 0 1-.5-.5V5a.5.5 0 0 0-1 0v.5A1.5 1.5 0 0 0 2.5 7H3v1H1.5a.5.5 0 0 0 0 1H3v1h-.5A1.5 1.5 0 0 0 1 11.5v.5a.5.5 0 1 0 1 0v-.5a.5.5 0 0 1 .5-.5H3a5 5 0 0 0 4.5 4.975z"/>
        `
    }),
    chevronExpand: Object.freeze({
        stroked: `
            <path fill-rule="evenodd" d="M3.646 9.146a.5.5 0 0 1 .708 0L8 12.793l3.646-3.647a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 0-.708zm0-2.292a.5.5 0 0 0 .708 0L8 3.207l3.646 3.647a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 0 0 0 .708z"/>
        `
    }),
    clipboard: Object.freeze({
        stroked: `
            <path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z"/>
            <path d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z"/>      
        `,
        filled: `
            <path fill-rule="evenodd" d="M10 1.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-1Zm-5 0A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5v1A1.5 1.5 0 0 1 9.5 4h-3A1.5 1.5 0 0 1 5 2.5v-1Zm-2 0h1v1A2.5 2.5 0 0 0 6.5 5h3A2.5 2.5 0 0 0 12 2.5v-1h1a2 2 0 0 1 2 2V14a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3.5a2 2 0 0 1 2-2Z"/>
        `
    }),
    close: Object.freeze({
        stroked: `
            <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
        `
    }),
    compass: Object.freeze({
        stroked: `
            <path d="M8 16.016a7.5 7.5 0 0 0 1.962-14.74A1 1 0 0 0 9 0H7a1 1 0 0 0-.962 1.276A7.5 7.5 0 0 0 8 16.016zm6.5-7.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0z"/>
            <path d="m6.94 7.44 4.95-2.83-2.83 4.95-4.949 2.83 2.828-4.95z"/>      
        `,
        filled: `
            <path d="M15.5 8.516a7.5 7.5 0 1 1-9.462-7.24A1 1 0 0 1 7 0h2a1 1 0 0 1 .962 1.276 7.503 7.503 0 0 1 5.538 7.24zm-3.61-3.905L6.94 7.439 4.11 12.39l4.95-2.828 2.828-4.95z"/>
        `
    }),
    copy: Object.freeze({
        stroked: `
            <path fill-rule="evenodd" d="M4 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1v1z"/>
        `
    }),
    crosshair: Object.freeze({
        stroked: `
            <path d="M8.5.5a.5.5 0 0 0-1 0v.518A7.001 7.001 0 0 0 1.018 7.5H.5a.5.5 0 0 0 0 1h.518A7.001 7.001 0 0 0 7.5 14.982v.518a.5.5 0 0 0 1 0v-.518A7.001 7.001 0 0 0 14.982 8.5h.518a.5.5 0 0 0 0-1h-.518A7.001 7.001 0 0 0 8.5 1.018V.5Zm-6.48 7A6.001 6.001 0 0 1 7.5 2.02v.48a.5.5 0 0 0 1 0v-.48a6.001 6.001 0 0 1 5.48 5.48h-.48a.5.5 0 0 0 0 1h.48a6.002 6.002 0 0 1-5.48 5.48v-.48a.5.5 0 0 0-1 0v.48A6.001 6.001 0 0 1 2.02 8.5h.48a.5.5 0 0 0 0-1h-.48ZM8 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"/>
        `
    }),
    cursor: {
        stroked: `
            <path d="M14.082 2.182a.5.5 0 0 1 .103.557L8.528 15.467a.5.5 0 0 1-.917-.007L5.57 10.694.803 8.652a.5.5 0 0 1-.006-.916l12.728-5.657a.5.5 0 0 1 .556.103zM2.25 8.184l3.897 1.67a.5.5 0 0 1 .262.263l1.67 3.897L12.743 3.52 2.25 8.184z"/>
        `,
        filled: `
            <path d="M14.082 2.182a.5.5 0 0 1 .103.557L8.528 15.467a.5.5 0 0 1-.917-.007L5.57 10.694.803 8.652a.5.5 0 0 1-.006-.916l12.728-5.657a.5.5 0 0 1 .556.103z"/>
        `
    },
    edit: Object.freeze({
        stroked: `
            <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z"/>
        `,
        filled: `
            <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z"/>
        `
    }),
    exclamationTriangle: Object.freeze({
        stroked: `
            <path d="M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.146.146 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.163.163 0 0 1-.054.06.116.116 0 0 1-.066.017H1.146a.115.115 0 0 1-.066-.017.163.163 0 0 1-.054-.06.176.176 0 0 1 .002-.183L7.884 2.073a.147.147 0 0 1 .054-.057zm1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566z"/>
            <path d="M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995z"/>
        `,
        filled: `
            <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>
        `
    }),
    exclude: Object.freeze({
        mixed: `
            <path d="M0 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v2h2a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-2H2a2 2 0 0 1-2-2V2zm12 2H5a1 1 0 0 0-1 1v7h7a1 1 0 0 0 1-1V4z"/>
        `
    }),
    fullscreen: Object.freeze({
        stroked: `
            <path d="M1.5 1a.5.5 0 0 0-.5.5v4a.5.5 0 0 1-1 0v-4A1.5 1.5 0 0 1 1.5 0h4a.5.5 0 0 1 0 1h-4zM10 .5a.5.5 0 0 1 .5-.5h4A1.5 1.5 0 0 1 16 1.5v4a.5.5 0 0 1-1 0v-4a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 1-.5-.5zM.5 10a.5.5 0 0 1 .5.5v4a.5.5 0 0 0 .5.5h4a.5.5 0 0 1 0 1h-4A1.5 1.5 0 0 1 0 14.5v-4a.5.5 0 0 1 .5-.5zm15 0a.5.5 0 0 1 .5.5v4a1.5 1.5 0 0 1-1.5 1.5h-4a.5.5 0 0 1 0-1h4a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 1 .5-.5z"/>
        `
    }),
    fullscreenExit: Object.freeze({
        stroked: `
            <path d="M5.5 0a.5.5 0 0 1 .5.5v4A1.5 1.5 0 0 1 4.5 6h-4a.5.5 0 0 1 0-1h4a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 1 .5-.5zm5 0a.5.5 0 0 1 .5.5v4a.5.5 0 0 0 .5.5h4a.5.5 0 0 1 0 1h-4A1.5 1.5 0 0 1 10 4.5v-4a.5.5 0 0 1 .5-.5zM0 10.5a.5.5 0 0 1 .5-.5h4A1.5 1.5 0 0 1 6 11.5v4a.5.5 0 0 1-1 0v-4a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 1-.5-.5zm10 1a1.5 1.5 0 0 1 1.5-1.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 0-.5.5v4a.5.5 0 0 1-1 0v-4z"/>
        `
    }),
    folderOpen: Object.freeze({
        stroked: `
            <path d="M1 3.5A1.5 1.5 0 0 1 2.5 2h2.764c.958 0 1.76.56 2.311 1.184C7.985 3.648 8.48 4 9 4h4.5A1.5 1.5 0 0 1 15 5.5v.64c.57.265.94.876.856 1.546l-.64 5.124A2.5 2.5 0 0 1 12.733 15H3.266a2.5 2.5 0 0 1-2.481-2.19l-.64-5.124A1.5 1.5 0 0 1 1 6.14V3.5zM2 6h12v-.5a.5.5 0 0 0-.5-.5H9c-.964 0-1.71-.629-2.174-1.154C6.374 3.334 5.82 3 5.264 3H2.5a.5.5 0 0 0-.5.5V6zm-.367 1a.5.5 0 0 0-.496.562l.64 5.124A1.5 1.5 0 0 0 3.266 14h9.468a1.5 1.5 0 0 0 1.489-1.314l.64-5.124A.5.5 0 0 0 14.367 7H1.633z"/>
        `
    }),
    gear: Object.freeze({
        stroked: `
            <path d="M8 4.754a3.246 3.246 0 1 0 0 6.492 3.246 3.246 0 0 0 0-6.492zM5.754 8a2.246 2.246 0 1 1 4.492 0 2.246 2.246 0 0 1-4.492 0z"/>
            <path d="M9.796 1.343c-.527-1.79-3.065-1.79-3.592 0l-.094.319a.873.873 0 0 1-1.255.52l-.292-.16c-1.64-.892-3.433.902-2.54 2.541l.159.292a.873.873 0 0 1-.52 1.255l-.319.094c-1.79.527-1.79 3.065 0 3.592l.319.094a.873.873 0 0 1 .52 1.255l-.16.292c-.892 1.64.901 3.434 2.541 2.54l.292-.159a.873.873 0 0 1 1.255.52l.094.319c.527 1.79 3.065 1.79 3.592 0l.094-.319a.873.873 0 0 1 1.255-.52l.292.16c1.64.893 3.434-.902 2.54-2.541l-.159-.292a.873.873 0 0 1 .52-1.255l.319-.094c1.79-.527 1.79-3.065 0-3.592l-.319-.094a.873.873 0 0 1-.52-1.255l.16-.292c.893-1.64-.902-3.433-2.541-2.54l-.292.159a.873.873 0 0 1-1.255-.52l-.094-.319zm-2.633.283c.246-.835 1.428-.835 1.674 0l.094.319a1.873 1.873 0 0 0 2.693 1.115l.291-.16c.764-.415 1.6.42 1.184 1.185l-.159.292a1.873 1.873 0 0 0 1.116 2.692l.318.094c.835.246.835 1.428 0 1.674l-.319.094a1.873 1.873 0 0 0-1.115 2.693l.16.291c.415.764-.42 1.6-1.185 1.184l-.291-.159a1.873 1.873 0 0 0-2.693 1.116l-.094.318c-.246.835-1.428.835-1.674 0l-.094-.319a1.873 1.873 0 0 0-2.692-1.115l-.292.16c-.764.415-1.6-.42-1.184-1.185l.159-.291A1.873 1.873 0 0 0 1.945 8.93l-.319-.094c-.835-.246-.835-1.428 0-1.674l.319-.094A1.873 1.873 0 0 0 3.06 4.377l-.16-.292c-.415-.764.42-1.6 1.185-1.184l.292.159a1.873 1.873 0 0 0 2.692-1.115l.094-.319z"/>
        `,
        filled: `
            <path d="M9.405 1.05c-.413-1.4-2.397-1.4-2.81 0l-.1.34a1.464 1.464 0 0 1-2.105.872l-.31-.17c-1.283-.698-2.686.705-1.987 1.987l.169.311c.446.82.023 1.841-.872 2.105l-.34.1c-1.4.413-1.4 2.397 0 2.81l.34.1a1.464 1.464 0 0 1 .872 2.105l-.17.31c-.698 1.283.705 2.686 1.987 1.987l.311-.169a1.464 1.464 0 0 1 2.105.872l.1.34c.413 1.4 2.397 1.4 2.81 0l.1-.34a1.464 1.464 0 0 1 2.105-.872l.31.17c1.283.698 2.686-.705 1.987-1.987l-.169-.311a1.464 1.464 0 0 1 .872-2.105l.34-.1c1.4-.413 1.4-2.397 0-2.81l-.34-.1a1.464 1.464 0 0 1-.872-2.105l.17-.31c.698-1.283-.705-2.686-1.987-1.987l-.311.169a1.464 1.464 0 0 1-2.105-.872l-.1-.34zM8 10.93a2.929 2.929 0 1 1 0-5.86 2.929 2.929 0 0 1 0 5.858z"/>
        `
    }),
    geoMarker: Object.freeze({
        stroked: `
            <path d="M12.166 8.94c-.524 1.062-1.234 2.12-1.96 3.07A31.493 31.493 0 0 1 8 14.58a31.481 31.481 0 0 1-2.206-2.57c-.726-.95-1.436-2.008-1.96-3.07C3.304 7.867 3 6.862 3 6a5 5 0 0 1 10 0c0 .862-.305 1.867-.834 2.94zM8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10z"/>
            <path d="M8 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm0 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/>
        `,
        filled: `
            <path d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10zm0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6z"/>
        `
    }),
    geoPin: Object.freeze({
        stroked: `
            <path fill-rule="evenodd" d="M8 1a3 3 0 1 0 0 6 3 3 0 0 0 0-6zM4 4a4 4 0 1 1 4.5 3.969V13.5a.5.5 0 0 1-1 0V7.97A4 4 0 0 1 4 3.999zm2.493 8.574a.5.5 0 0 1-.411.575c-.712.118-1.28.295-1.655.493a1.319 1.319 0 0 0-.37.265.301.301 0 0 0-.057.09V14l.002.008a.147.147 0 0 0 .016.033.617.617 0 0 0 .145.15c.165.13.435.27.813.395.751.25 1.82.414 3.024.414s2.273-.163 3.024-.414c.378-.126.648-.265.813-.395a.619.619 0 0 0 .146-.15.148.148 0 0 0 .015-.033L12 14v-.004a.301.301 0 0 0-.057-.09 1.318 1.318 0 0 0-.37-.264c-.376-.198-.943-.375-1.655-.493a.5.5 0 1 1 .164-.986c.77.127 1.452.328 1.957.594C12.5 13 13 13.4 13 14c0 .426-.26.752-.544.977-.29.228-.68.413-1.116.558-.878.293-2.059.465-3.34.465-1.281 0-2.462-.172-3.34-.465-.436-.145-.826-.33-1.116-.558C3.26 14.752 3 14.426 3 14c0-.599.5-1 .961-1.243.505-.266 1.187-.467 1.957-.594a.5.5 0 0 1 .575.411z"/>
        `,
        filled: `
            <path fill-rule="evenodd" d="M4 4a4 4 0 1 1 4.5 3.969V13.5a.5.5 0 0 1-1 0V7.97A4 4 0 0 1 4 3.999zm2.493 8.574a.5.5 0 0 1-.411.575c-.712.118-1.28.295-1.655.493a1.319 1.319 0 0 0-.37.265.301.301 0 0 0-.057.09V14l.002.008a.147.147 0 0 0 .016.033.617.617 0 0 0 .145.15c.165.13.435.27.813.395.751.25 1.82.414 3.024.414s2.273-.163 3.024-.414c.378-.126.648-.265.813-.395a.619.619 0 0 0 .146-.15.148.148 0 0 0 .015-.033L12 14v-.004a.301.301 0 0 0-.057-.09 1.318 1.318 0 0 0-.37-.264c-.376-.198-.943-.375-1.655-.493a.5.5 0 1 1 .164-.986c.77.127 1.452.328 1.957.594C12.5 13 13 13.4 13 14c0 .426-.26.752-.544.977-.29.228-.68.413-1.116.558-.878.293-2.059.465-3.34.465-1.281 0-2.462-.172-3.34-.465-.436-.145-.826-.33-1.116-.558C3.26 14.752 3 14.426 3 14c0-.599.5-1 .961-1.243.505-.266 1.187-.467 1.957-.594a.5.5 0 0 1 .575.411z"/>
        `
    }),
    gitHub: Object.freeze({
        mixed: `
            <path d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.012 8.012 0 0 0 16 8c0-4.42-3.58-8-8-8z"/>
        `
    }),
    globe: Object.freeze({
        stroked: `
            <path d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm7.5-6.923c-.67.204-1.335.82-1.887 1.855-.143.268-.276.56-.395.872.705.157 1.472.257 2.282.287V1.077zM4.249 3.539c.142-.384.304-.744.481-1.078a6.7 6.7 0 0 1 .597-.933A7.01 7.01 0 0 0 3.051 3.05c.362.184.763.349 1.198.49zM3.509 7.5c.036-1.07.188-2.087.436-3.008a9.124 9.124 0 0 1-1.565-.667A6.964 6.964 0 0 0 1.018 7.5h2.49zm1.4-2.741a12.344 12.344 0 0 0-.4 2.741H7.5V5.091c-.91-.03-1.783-.145-2.591-.332zM8.5 5.09V7.5h2.99a12.342 12.342 0 0 0-.399-2.741c-.808.187-1.681.301-2.591.332zM4.51 8.5c.035.987.176 1.914.399 2.741A13.612 13.612 0 0 1 7.5 10.91V8.5H4.51zm3.99 0v2.409c.91.03 1.783.145 2.591.332.223-.827.364-1.754.4-2.741H8.5zm-3.282 3.696c.12.312.252.604.395.872.552 1.035 1.218 1.65 1.887 1.855V11.91c-.81.03-1.577.13-2.282.287zm.11 2.276a6.696 6.696 0 0 1-.598-.933 8.853 8.853 0 0 1-.481-1.079 8.38 8.38 0 0 0-1.198.49 7.01 7.01 0 0 0 2.276 1.522zm-1.383-2.964A13.36 13.36 0 0 1 3.508 8.5h-2.49a6.963 6.963 0 0 0 1.362 3.675c.47-.258.995-.482 1.565-.667zm6.728 2.964a7.009 7.009 0 0 0 2.275-1.521 8.376 8.376 0 0 0-1.197-.49 8.853 8.853 0 0 1-.481 1.078 6.688 6.688 0 0 1-.597.933zM8.5 11.909v3.014c.67-.204 1.335-.82 1.887-1.855.143-.268.276-.56.395-.872A12.63 12.63 0 0 0 8.5 11.91zm3.555-.401c.57.185 1.095.409 1.565.667A6.963 6.963 0 0 0 14.982 8.5h-2.49a13.36 13.36 0 0 1-.437 3.008zM14.982 7.5a6.963 6.963 0 0 0-1.362-3.675c-.47.258-.995.482-1.565.667.248.92.4 1.938.437 3.008h2.49zM11.27 2.461c.177.334.339.694.482 1.078a8.368 8.368 0 0 0 1.196-.49 7.01 7.01 0 0 0-2.275-1.52c.218.283.418.597.597.932zm-.488 1.343a7.765 7.765 0 0 0-.395-.872C9.835 1.897 9.17 1.282 8.5 1.077V4.09c.81-.03 1.577-.13 2.282-.287z"/>
        `
    }),
    house: Object.freeze({
        stroked: `
            <path d="M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L2 8.207V13.5A1.5 1.5 0 0 0 3.5 15h9a1.5 1.5 0 0 0 1.5-1.5V8.207l.646.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.707 1.5ZM13 7.207V13.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V7.207l5-5 5 5Z"/>
        `,
        filled: `
            <path d="M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L8 2.207l6.646 6.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.707 1.5Z"/>
            <path d="M8 3.293 6 6V13.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 13.5V9.293l6-6Z"/>      
        `
    }),
    image: Object.freeze({
        mixed: `
            <path d="M6.002 5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"/>
            <path d="M2.002 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2h-12zm12 1a1 1 0 0 1 1 1v6.5l-3.777-1.947a.5.5 0 0 0-.577.093l-3.71 3.71-2.66-1.772a.5.5 0 0 0-.63.062L1.002 12V3a1 1 0 0 1 1-1h12z"/>
        `
    }),
    infoCircle: Object.freeze({
        stroked: `
            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
            <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>      
        `,
        filled: `
            <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"/>
        `
    }),
    intersect: Object.freeze({
        mixed: `
            <path d="M0 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v2h2a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-2H2a2 2 0 0 1-2-2V2zm5 10v2a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-2v5a2 2 0 0 1-2 2H5zm6-8V2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h2V6a2 2 0 0 1 2-2h5z"/>
        `
    }),
    layers: Object.freeze({
        stroked: `
            <path d="M8.235 1.559a.5.5 0 0 0-.47 0l-7.5 4a.5.5 0 0 0 0 .882L3.188 8 .264 9.559a.5.5 0 0 0 0 .882l7.5 4a.5.5 0 0 0 .47 0l7.5-4a.5.5 0 0 0 0-.882L12.813 8l2.922-1.559a.5.5 0 0 0 0-.882l-7.5-4zm3.515 7.008L14.438 10 8 13.433 1.562 10 4.25 8.567l3.515 1.874a.5.5 0 0 0 .47 0l3.515-1.874zM8 9.433L1.562 6 8 2.567 14.438 6 8 9.433z"/>
        `,
        filled: `
            <path d="M7.765 1.559a.5.5 0 0 1 .47 0l7.5 4a.5.5 0 0 1 0 .882l-7.5 4a.5.5 0 0 1-.47 0l-7.5-4a.5.5 0 0 1 0-.882l7.5-4z"/>
            <path d="m2.125 8.567-1.86.992a.5.5 0 0 0 0 .882l7.5 4a.5.5 0 0 0 .47 0l7.5-4a.5.5 0 0 0 0-.882l-1.86-.992-5.17 2.756a1.5 1.5 0 0 1-1.41 0l-5.17-2.756z"/>
        `
    }),
    layoutSidebarInset: Object.freeze({
        mixed: `
            <path d="M14 2a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1zM2 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2z"/>
            <path d="M3 4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1z"/>      
        `
    }),
    layoutSsidebarInsetReverse: Object.freeze({
        mixed: `
            <path d="M2 2a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zm12-1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2z"/>
            <path d="M13 4a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1z"/>      
        `
    }),
    lightbulb: Object.freeze({
        stroked: `
            <path d="M2 6a6 6 0 1 1 10.174 4.31c-.203.196-.359.4-.453.619l-.762 1.769A.5.5 0 0 1 10.5 13a.5.5 0 0 1 0 1 .5.5 0 0 1 0 1l-.224.447a1 1 0 0 1-.894.553H6.618a1 1 0 0 1-.894-.553L5.5 15a.5.5 0 0 1 0-1 .5.5 0 0 1 0-1 .5.5 0 0 1-.46-.302l-.761-1.77a1.964 1.964 0 0 0-.453-.618A5.984 5.984 0 0 1 2 6zm6-5a5 5 0 0 0-3.479 8.592c.263.254.514.564.676.941L5.83 12h4.342l.632-1.467c.162-.377.413-.687.676-.941A5 5 0 0 0 8 1z"/>
        `,
        filled: `
            <path d="M2 6a6 6 0 1 1 10.174 4.31c-.203.196-.359.4-.453.619l-.762 1.769A.5.5 0 0 1 10.5 13h-5a.5.5 0 0 1-.46-.302l-.761-1.77a1.964 1.964 0 0 0-.453-.618A5.984 5.984 0 0 1 2 6zm3 8.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1l-.224.447a1 1 0 0 1-.894.553H6.618a1 1 0 0 1-.894-.553L5.5 15a.5.5 0 0 1-.5-.5z"/>
        `
    }),
    lightbulbOff: Object.freeze({
        stroked: `
            <path fill-rule="evenodd" d="M2.23 4.35A6.004 6.004 0 0 0 2 6c0 1.691.7 3.22 1.826 4.31.203.196.359.4.453.619l.762 1.769A.5.5 0 0 0 5.5 13a.5.5 0 0 0 0 1 .5.5 0 0 0 0 1l.224.447a1 1 0 0 0 .894.553h2.764a1 1 0 0 0 .894-.553L10.5 15a.5.5 0 0 0 0-1 .5.5 0 0 0 0-1 .5.5 0 0 0 .288-.091L9.878 12H5.83l-.632-1.467a2.954 2.954 0 0 0-.676-.941 4.984 4.984 0 0 1-1.455-4.405l-.837-.836zm1.588-2.653.708.707a5 5 0 0 1 7.07 7.07l.707.707a6 6 0 0 0-8.484-8.484zm-2.172-.051a.5.5 0 0 1 .708 0l12 12a.5.5 0 0 1-.708.708l-12-12a.5.5 0 0 1 0-.708z"/>
        `,
        filled: `
            <path d="M2 6c0-.572.08-1.125.23-1.65l8.558 8.559A.5.5 0 0 1 10.5 13h-5a.5.5 0 0 1-.46-.302l-.761-1.77a1.964 1.964 0 0 0-.453-.618A5.984 5.984 0 0 1 2 6zm10.303 4.181L3.818 1.697a6 6 0 0 1 8.484 8.484zM5 14.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1l-.224.447a1 1 0 0 1-.894.553H6.618a1 1 0 0 1-.894-.553L5.5 15a.5.5 0 0 1-.5-.5zM2.354 1.646a.5.5 0 1 0-.708.708l12 12a.5.5 0 0 0 .708-.708l-12-12z"/>
        `
    }),
    moon: Object.freeze({
        stroked: `
            <path d="M6 .278a.768.768 0 0 1 .08.858 7.208 7.208 0 0 0-.878 3.46c0 4.021 3.278 7.277 7.318 7.277.527 0 1.04-.055 1.533-.16a.787.787 0 0 1 .81.316.733.733 0 0 1-.031.893A8.349 8.349 0 0 1 8.344 16C3.734 16 0 12.286 0 7.71 0 4.266 2.114 1.312 5.124.06A.752.752 0 0 1 6 .278zM4.858 1.311A7.269 7.269 0 0 0 1.025 7.71c0 4.02 3.279 7.276 7.319 7.276a7.316 7.316 0 0 0 5.205-2.162c-.337.042-.68.063-1.029.063-4.61 0-8.343-3.714-8.343-8.29 0-1.167.242-2.278.681-3.286z"/>
        `,
        filled: `
            <path d="M6 .278a.768.768 0 0 1 .08.858 7.208 7.208 0 0 0-.878 3.46c0 4.021 3.278 7.277 7.318 7.277.527 0 1.04-.055 1.533-.16a.787.787 0 0 1 .81.316.733.733 0 0 1-.031.893A8.349 8.349 0 0 1 8.344 16C3.734 16 0 12.286 0 7.71 0 4.266 2.114 1.312 5.124.06A.752.752 0 0 1 6 .278z"/>
        `
    }),
    moonStars: Object.freeze({
        stroked: `
            <path d="M6 .278a.768.768 0 0 1 .08.858 7.208 7.208 0 0 0-.878 3.46c0 4.021 3.278 7.277 7.318 7.277.527 0 1.04-.055 1.533-.16a.787.787 0 0 1 .81.316.733.733 0 0 1-.031.893A8.349 8.349 0 0 1 8.344 16C3.734 16 0 12.286 0 7.71 0 4.266 2.114 1.312 5.124.06A.752.752 0 0 1 6 .278zM4.858 1.311A7.269 7.269 0 0 0 1.025 7.71c0 4.02 3.279 7.276 7.319 7.276a7.316 7.316 0 0 0 5.205-2.162c-.337.042-.68.063-1.029.063-4.61 0-8.343-3.714-8.343-8.29 0-1.167.242-2.278.681-3.286z"/>
            <path d="M10.794 3.148a.217.217 0 0 1 .412 0l.387 1.162c.173.518.579.924 1.097 1.097l1.162.387a.217.217 0 0 1 0 .412l-1.162.387a1.734 1.734 0 0 0-1.097 1.097l-.387 1.162a.217.217 0 0 1-.412 0l-.387-1.162A1.734 1.734 0 0 0 9.31 6.593l-1.162-.387a.217.217 0 0 1 0-.412l1.162-.387a1.734 1.734 0 0 0 1.097-1.097l.387-1.162zM13.863.099a.145.145 0 0 1 .274 0l.258.774c.115.346.386.617.732.732l.774.258a.145.145 0 0 1 0 .274l-.774.258a1.156 1.156 0 0 0-.732.732l-.258.774a.145.145 0 0 1-.274 0l-.258-.774a1.156 1.156 0 0 0-.732-.732l-.774-.258a.145.145 0 0 1 0-.274l.774-.258c.346-.115.617-.386.732-.732L13.863.1z"/>      
        `,
        filled: `
            <path d="M6 .278a.768.768 0 0 1 .08.858 7.208 7.208 0 0 0-.878 3.46c0 4.021 3.278 7.277 7.318 7.277.527 0 1.04-.055 1.533-.16a.787.787 0 0 1 .81.316.733.733 0 0 1-.031.893A8.349 8.349 0 0 1 8.344 16C3.734 16 0 12.286 0 7.71 0 4.266 2.114 1.312 5.124.06A.752.752 0 0 1 6 .278z"/>
            <path d="M10.794 3.148a.217.217 0 0 1 .412 0l.387 1.162c.173.518.579.924 1.097 1.097l1.162.387a.217.217 0 0 1 0 .412l-1.162.387a1.734 1.734 0 0 0-1.097 1.097l-.387 1.162a.217.217 0 0 1-.412 0l-.387-1.162A1.734 1.734 0 0 0 9.31 6.593l-1.162-.387a.217.217 0 0 1 0-.412l1.162-.387a1.734 1.734 0 0 0 1.097-1.097l.387-1.162zM13.863.099a.145.145 0 0 1 .274 0l.258.774c.115.346.386.617.732.732l.774.258a.145.145 0 0 1 0 .274l-.774.258a1.156 1.156 0 0 0-.732.732l-.258.774a.145.145 0 0 1-.274 0l-.258-.774a1.156 1.156 0 0 0-.732-.732l-.774-.258a.145.145 0 0 1 0-.274l.774-.258c.346-.115.617-.386.732-.732L13.863.1z"/>      
        `
    }),
    person: Object.freeze({
        stroked: `
            <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4Zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10Z"/>
        `,
        filled: `
            <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3Zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"/>
        `
    }),
    pip: Object.freeze({
        stroked: `
            <path d="M0 3.5A1.5 1.5 0 0 1 1.5 2h13A1.5 1.5 0 0 1 16 3.5v9a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 12.5zM1.5 3a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5z"/>
            <path d="M8 8.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5z"/>      
        `,
        filled: `
            <path d="M1.5 2A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2zm7 6h5a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5"/>
        `
    }),
    plus: Object.freeze({
        stroked: `
            <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
        `
    }),
    plusLarge: Object.freeze({
        stroked: `
            <path fill-rule="evenodd" d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2Z"/>
        `
    }),
    questionCircle: Object.freeze({
        stroked: `
            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
            <path d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z"/>
        `
    }),
    rulers: Object.freeze({
        mixed: `
            <path d="M1 0a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h5v-1H2v-1h4v-1H4v-1h2v-1H2v-1h4V9H4V8h2V7H2V6h4V2h1v4h1V4h1v2h1V2h1v4h1V4h1v2h1V2h1v4h1V1a1 1 0 0 0-1-1H1z"/>
        `
    }),
    scissors: Object.freeze({
        filled: `
            <path d="M3.5 3.5c-.614-.884-.074-1.962.858-2.5L8 7.226 11.642 1c.932.538 1.472 1.616.858 2.5L8.81 8.61l1.556 2.661a2.5 2.5 0 1 1-.794.637L8 9.73l-1.572 2.177a2.5 2.5 0 1 1-.794-.637L7.19 8.61 3.5 3.5zm2.5 10a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0zm7 0a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0z"/>
        `
    }),
    shuffle: Object.freeze({
        stroked: `
            <path fill-rule="evenodd" d="M0 3.5A.5.5 0 0 1 .5 3H1c2.202 0 3.827 1.24 4.874 2.418.49.552.865 1.102 1.126 1.532.26-.43.636-.98 1.126-1.532C9.173 4.24 10.798 3 13 3v1c-1.798 0-3.173 1.01-4.126 2.082A9.6 9.6 0 0 0 7.556 8a9.6 9.6 0 0 0 1.317 1.918C9.828 10.99 11.204 12 13 12v1c-2.202 0-3.827-1.24-4.874-2.418A10.6 10.6 0 0 1 7 9.05c-.26.43-.636.98-1.126 1.532C4.827 11.76 3.202 13 1 13H.5a.5.5 0 0 1 0-1H1c1.798 0 3.173-1.01 4.126-2.082A9.6 9.6 0 0 0 6.444 8a9.6 9.6 0 0 0-1.317-1.918C4.172 5.01 2.796 4 1 4H.5a.5.5 0 0 1-.5-.5"/>
            <path d="M13 5.466V1.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384l-2.36 1.966a.25.25 0 0 1-.41-.192m0 9v-3.932a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384l-2.36 1.966a.25.25 0 0 1-.41-.192"/>
        `
    }),
    sun: Object.freeze({
        stroked: `
            <path d="M8 11a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm0 1a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM8 0a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 0zm0 13a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 13zm8-5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2a.5.5 0 0 1 .5.5zM3 8a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2A.5.5 0 0 1 3 8zm10.657-5.657a.5.5 0 0 1 0 .707l-1.414 1.415a.5.5 0 1 1-.707-.708l1.414-1.414a.5.5 0 0 1 .707 0zm-9.193 9.193a.5.5 0 0 1 0 .707L3.05 13.657a.5.5 0 0 1-.707-.707l1.414-1.414a.5.5 0 0 1 .707 0zm9.193 2.121a.5.5 0 0 1-.707 0l-1.414-1.414a.5.5 0 0 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .707zM4.464 4.465a.5.5 0 0 1-.707 0L2.343 3.05a.5.5 0 1 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .708z"/>
        `,
        filled: `
            <path d="M8 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM8 0a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 0zm0 13a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 13zm8-5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2a.5.5 0 0 1 .5.5zM3 8a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2A.5.5 0 0 1 3 8zm10.657-5.657a.5.5 0 0 1 0 .707l-1.414 1.415a.5.5 0 1 1-.707-.708l1.414-1.414a.5.5 0 0 1 .707 0zm-9.193 9.193a.5.5 0 0 1 0 .707L3.05 13.657a.5.5 0 0 1-.707-.707l1.414-1.414a.5.5 0 0 1 .707 0zm9.193 2.121a.5.5 0 0 1-.707 0l-1.414-1.414a.5.5 0 0 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .707zM4.464 4.465a.5.5 0 0 1-.707 0L2.343 3.05a.5.5 0 1 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .708z"/>
        `
    }),
    symmetryHorizontal: Object.freeze({
        mixed: `
            <path d="M13.5 7a.5.5 0 0 0 .24-.939l-11-6A.5.5 0 0 0 2 .5v6a.5.5 0 0 0 .5.5h11zm.485 2.376a.5.5 0 0 1-.246.563l-11 6A.5.5 0 0 1 2 15.5v-6a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 .485.376zM11.539 10H3v4.658L11.54 10z"/>
        `
    }),
    symmetryVertical: Object.freeze({
        mixed: `
            <path d="M7 2.5a.5.5 0 0 0-.939-.24l-6 11A.5.5 0 0 0 .5 14h6a.5.5 0 0 0 .5-.5v-11zm2.376-.484a.5.5 0 0 1 .563.245l6 11A.5.5 0 0 1 15.5 14h-6a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .376-.484zM10 4.46V13h4.658L10 4.46z"/>
        `
    }),
    scaleLine: Object.freeze({
        stroked: `
            <path d="M4.114 7.951l.397-.413L5.799 9.25h.742L4.935 7.097l1.439-1.545h-.77L4.453 6.769l-.339.406V4h-.632v5.25h.632V7.951zM7.638 5.962l-.017-.41h-.598V9.25h.632v-2.7c.153-.353.437-.53.851-.53.527 0 .79.269.79.807V9.25h.636V6.796a.846.846 0 01.27-.564.834.834 0 01.584-.212c.285 0 .488.066.609.198.12.13.18.327.18.592v2.44h.633V6.772c-.014-.86-.426-1.289-1.237-1.289-.27 0-.503.055-.701.164-.196.11-.355.253-.479.431-.186-.396-.538-.595-1.056-.595-.46 0-.826.16-1.097.479z"/>
            <path d="M1.5 10.75v-2.5h-1v3a.5.5 0 00.5.5h14a.5.5 0 00.5-.5v-3h-1v2.5h-13z"/>
        `
    }),
    search: Object.freeze({
        stroked: `
            <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/>
        `
    }),
    subtract: Object.freeze({
        mixed: `
            <path d="M0 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v2h2a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-2H2a2 2 0 0 1-2-2V2zm5 10v2a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-2v5a2 2 0 0 1-2 2H5z"/>
        `
    }),
    translate: Object.freeze({
        mixed: `
            <path d="M4.545 6.714 4.11 8H3l1.862-5h1.284L8 8H6.833l-.435-1.286H4.545zm1.634-.736L5.5 3.956h-.049l-.679 2.022H6.18z"/>
            <path d="M0 2a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v3h3a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-3H2a2 2 0 0 1-2-2V2zm2-1a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H2zm7.138 9.995c.193.301.402.583.63.846-.748.575-1.673 1.001-2.768 1.292.178.217.451.635.555.867 1.125-.359 2.08-.844 2.886-1.494.777.665 1.739 1.165 2.93 1.472.133-.254.414-.673.629-.89-1.125-.253-2.057-.694-2.82-1.284.681-.747 1.222-1.651 1.621-2.757H14V8h-3v1.047h.765c-.318.844-.74 1.546-1.272 2.13a6.066 6.066 0 0 1-.415-.492 1.988 1.988 0 0 1-.94.31z"/>      
        `
    }),
    trash: Object.freeze({
        stroked: `
            <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/>
            <path fill-rule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/>  
        `,
        filled: `
            <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z"/>
        `
    }),
    union: Object.freeze({
        mixed: `
            <path d="M0 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v2h2a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-2H2a2 2 0 0 1-2-2V2z"/>
        `
    }),
    vectorPen: Object.freeze({
        mixed: `
            <path fill-rule="evenodd" d="M10.646.646a.5.5 0 0 1 .708 0l4 4a.5.5 0 0 1 0 .708l-1.902 1.902-.829 3.313a1.5 1.5 0 0 1-1.024 1.073L1.254 14.746 4.358 4.4A1.5 1.5 0 0 1 5.43 3.377l3.313-.828L10.646.646zm-1.8 2.908-3.173.793a.5.5 0 0 0-.358.342l-2.57 8.565 8.567-2.57a.5.5 0 0 0 .34-.357l.794-3.174-3.6-3.6z"/>
            <path fill-rule="evenodd" d="M2.832 13.228 8 9a1 1 0 1 0-1-1l-4.228 5.168-.026.086.086-.026z"/>
        `
    }),
    zoomIn: Object.freeze({
        stroked: `
            <path fill-rule="evenodd" d="M6.5 12a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11zM13 6.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0z"/>
            <path d="M10.344 11.742c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1 6.538 6.538 0 0 1-1.398 1.4z"/>
            <path fill-rule="evenodd" d="M6.5 3a.5.5 0 0 1 .5.5V6h2.5a.5.5 0 0 1 0 1H7v2.5a.5.5 0 0 1-1 0V7H3.5a.5.5 0 0 1 0-1H6V3.5a.5.5 0 0 1 .5-.5z"/>
        `
    }),
    zoomOut: Object.freeze({
        stroked: `
            <path fill-rule="evenodd" d="M6.5 12a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11zM13 6.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0z"/>
            <path d="M10.344 11.742c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1 6.538 6.538 0 0 1-1.398 1.4z"/>
            <path fill-rule="evenodd" d="M3 6.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5z"/>
        `
    })
});


const $dcff5ab966a6537f$var$DefaultOptions = Object.freeze({
    path: (0, $35649bc6579784f8$export$3fddabec91763a6e).airplane.stroked,
    width: 24,
    height: 24,
    fill: 'currentColor',
    stroke: '#FFFFFFFF',
    strokeWidth: 0,
    shouldReplaceHashtag: false,
    class: ''
});
const $dcff5ab966a6537f$export$a297fe855adfd36c = function(options = {}) {
    options = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep($dcff5ab966a6537f$var$DefaultOptions), options);
    // Note: 
    // HEX Colors are not valid in SVG 
    // Unless they are replaced with URL alternative char
    const ENCODED_HASHTAG = '%23';
    if (options.shouldReplaceHashtag) {
        options.fill = options.fill.replace('#', ENCODED_HASHTAG);
        options.stroke = options.stroke.replace('#', ENCODED_HASHTAG);
    }
    return `
        <svg xmlns="http://www.w3.org/2000/svg" 
            width="${options.width}" 
            height="${options.height}" 
            fill="${options.fill}"
            stroke="${options.stroke}" 
            stroke-width="${options.strokeWidth}"
            class="${options.class}" 
            viewBox="0 0 16 16">
            ${options.path}
        </svg>
    `;
};



const $cb34cfd81f492a36$export$e85341f8480589d = function(coordinates) {
    function flatten(children) {
        return children.reduce((accumulator, value)=>Array.isArray(value) ? accumulator.concat(flatten(value)) : accumulator.concat(value), []);
    }
    const flattened = flatten(coordinates);
    const result = [];
    for(let i = 0; i < flattened.length; i += 2)result.push([
        flattened[i],
        flattened[i + 1]
    ]);
    return result;
};


const $2577fba4fdbf4b69$var$FILENAME = 'style-manager.js';
const $2577fba4fdbf4b69$var$DefaultDrawingStyle = new (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)({
    fill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
        color: '#D7E3FA80'
    }),
    stroke: new (0, $f9d0329c5c745263$export$2e2bcd8739ae039)({
        color: '#0166A5FF',
        width: 2.5
    })
});
const $2577fba4fdbf4b69$var$DefaultMeasurementStyle = new (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)({
    fill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
        color: '#FFFFFF66'
    }),
    stroke: new (0, $f9d0329c5c745263$export$2e2bcd8739ae039)({
        color: '#3B4352FF',
        lineDash: [
            2,
            5
        ],
        width: 2.5
    })
});
const $2577fba4fdbf4b69$var$DefaultSelectDrawingStyle = new (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)({
    fill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
        color: '#CEEEFF80'
    }),
    stroke: new (0, $f9d0329c5c745263$export$2e2bcd8739ae039)({
        color: '#0080C5FF',
        width: 2.5
    })
});
const $2577fba4fdbf4b69$var$DefaultSelectMeasurementStyle = new (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)({
    fill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
        color: '#CEEEFF80'
    }),
    stroke: new (0, $f9d0329c5c745263$export$2e2bcd8739ae039)({
        color: '#0080C5FF',
        lineDash: [
            2,
            5
        ],
        width: 2.5
    })
});
const $2577fba4fdbf4b69$var$DefaultSelectedVertices = new (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)({
    image: new (0, $06150d8570b7481b$export$2e2bcd8739ae039)({
        radius: 6,
        fill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
            color: '#0080C5FF'
        }),
        stroke: new (0, $f9d0329c5c745263$export$2e2bcd8739ae039)({
            color: '#FFFFFFFF',
            width: 2
        })
    }),
    geometry: (feature)=>{
        return new (0, $e6080c63a9451eda$export$2e2bcd8739ae039)((0, $cb34cfd81f492a36$export$e85341f8480589d)(feature.getGeometry().getCoordinates()));
    }
});
/**
 * About:
 * StyleManager
 * 
 * Description:
 * When creating Features and WindBarbs a lot of ol.style-objects are created that have the exact same properties.
 * The UI can be slow to respond to mouse-events due to heavy rendering.
 * 
 * Style can be applied to a vector-layer but i want the user to be able to set the style on individual objects.
 * 
 * A first attempt to optimize the rendering will be to have this manager to keep track of created styles 
 * using multiple keys (the recepie) and map to already existing style-objects that can be shared across many objects.
 * 
 * Note:
 * Rendering many labels is a costly operation. 
 * Especially when there are many markers or wind-barbs. 
 * Therefore, label style is not applied if the map is too zoomed out, so as not to affect movements and mouse events too much.
 */ class $2577fba4fdbf4b69$export$29bb23d12246c816 extends (0, $8a2666592e7029ee$export$84777416d052f822) {
    static #styles;
    //--------------------------------------------------------------------
    // # Section: Base Overrides
    //--------------------------------------------------------------------
    static async initAsync(options = {}) {
        (0, $b9b5c0363f244088$export$49b118289be48034).logDebug($2577fba4fdbf4b69$var$FILENAME, 'initAsync', 'Initialization started');
        this.#styles = new (0, $a439639f4ccc8a26$export$2e2bcd8739ae039)();
        return new Promise((resolve)=>{
            resolve({
                filename: $2577fba4fdbf4b69$var$FILENAME,
                result: true
            });
        });
    }
    static setMap(map) {}
    static getName() {
        return $2577fba4fdbf4b69$var$FILENAME;
    }
    //--------------------------------------------------------------------
    // # Section: Internal Logic
    //--------------------------------------------------------------------
    static #getIconStyle(keyIcon, keyRotation, keyWidth, keyHeight, keyFill, keyStroke, iconSvg) {
        const keys = [
            keyIcon,
            keyRotation,
            keyWidth,
            keyHeight,
            keyFill,
            keyStroke
        ];
        const existing = this.#styles.get(keys);
        if (existing) return existing;
        const style = new (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)({
            image: new (0, $8463d325b53eeb0c$export$2e2bcd8739ae039)({
                src: `data:image/svg+xml;utf8,${iconSvg}`,
                rotation: keyRotation,
                size: [
                    keyWidth,
                    keyHeight
                ]
            })
        });
        this.#styles.set(keys, style);
        return style;
    }
    static #getCircleStyle(keyRadius, keyWidth, keyFill, keyStroke) {
        const keys = [
            keyRadius,
            keyWidth,
            keyFill,
            keyStroke
        ];
        const existing = this.#styles.get(keys);
        if (existing) return existing;
        const style = new (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)({
            image: new (0, $06150d8570b7481b$export$2e2bcd8739ae039)({
                radius: keyRadius,
                fill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
                    color: keyFill
                }),
                stroke: new (0, $f9d0329c5c745263$export$2e2bcd8739ae039)({
                    color: keyStroke,
                    width: keyWidth
                })
            })
        });
        this.#styles.set(keys, style);
        return style;
    }
    static #getLabelStyle(keyLabel, keyLabelOffset, keyLabelUseUpperCase, keyLabelUseEllipsisAfter, keyFont, keyFill, keyStroke, keyStrokeWidth) {
        const keys = [
            keyLabel,
            keyLabelOffset,
            keyLabelUseUpperCase,
            keyLabelUseEllipsisAfter,
            keyFont,
            keyFill,
            keyStroke,
            keyStrokeWidth
        ];
        const existing = this.#styles.get(keys);
        if (existing) return existing;
        const text = keyLabelUseUpperCase ? keyLabel.toUpperCase() : keyLabel;
        const style = new (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)({
            text: new (0, $944be50faeff5321$export$2e2bcd8739ae039)({
                font: keyFont,
                text: text.ellipsis(keyLabelUseEllipsisAfter),
                placement: 'point',
                fill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
                    color: keyFill
                }),
                stroke: new (0, $f9d0329c5c745263$export$2e2bcd8739ae039)({
                    color: keyStroke,
                    width: keyStrokeWidth
                }),
                offsetY: keyLabelOffset
            })
        });
        this.#styles.set(keys, style);
        return style;
    }
    static #getIconMarkerStyle(properties, resolution) {
        const defaultIcon = 'geoPin.filled';
        const [iconName, iconVersion] = properties.icon.key.split('.');
        const [defaultIconName, defaultIconVersion] = defaultIcon.split('.');
        const path = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).has((0, $35649bc6579784f8$export$3fddabec91763a6e), [
            iconName,
            iconVersion
        ]) ? (0, $35649bc6579784f8$export$3fddabec91763a6e)[iconName][iconVersion] : (0, $35649bc6579784f8$export$3fddabec91763a6e)[defaultIconName][defaultIconVersion];
        const iconSvg = (0, $dcff5ab966a6537f$export$a297fe855adfd36c)({
            path: path,
            width: properties.icon.width,
            height: properties.icon.width,
            fill: properties.icon.fill,
            stroke: properties.icon.stroke,
            strokeWidth: properties.icon.strokeWidth,
            shouldReplaceHashtag: properties.settings.shouldReplaceHashtag
        });
        const iconStyle = this.#getIconStyle(properties.icon.key, properties.icon.rotation, properties.icon.width, properties.icon.height, properties.icon.fill, properties.icon.stroke, iconSvg);
        const circleStyle = this.#getCircleStyle(properties.marker.radius, properties.marker.width, properties.marker.fill, properties.marker.stroke);
        const styles = [
            circleStyle,
            iconStyle
        ];
        if ((0, $0a57fad3299da03c$export$ac4f8128ea29c5).marker.label.shouldRender && resolution < (0, $0a57fad3299da03c$export$ac4f8128ea29c5).marker.label.visibleUnderResolution) {
            const labelOffset = -35;
            const labelStyle = this.#getLabelStyle(properties.label.text, labelOffset, properties.label.useUpperCase, properties.label.useEllipsisAfter, properties.label.font, properties.label.fill, properties.label.stroke, properties.label.strokeWidth);
            styles.push(labelStyle);
        }
        return styles;
    }
    static #getWindBarbStyle(properties, resolution) {
        const iconSvg = (0, $e5877a8f70dee3d8$export$4ca13446b4014f95)({
            windSpeed: properties.icon.key,
            width: properties.icon.width,
            height: properties.icon.height,
            fill: properties.icon.fill,
            stroke: properties.icon.stroke,
            strokeWidth: properties.icon.strokeWidth,
            shouldReplaceHashtag: properties.settings.shouldReplaceHashtag
        });
        const rotation = (0, $206be50bf50f716a$export$53fa2d26c9df363b).degreesToRadians(properties.icon.rotation);
        const iconStyle = this.#getIconStyle(properties.icon.key, rotation, properties.icon.width, properties.icon.height, properties.icon.fill, properties.icon.stroke, iconSvg);
        const styles = [
            iconStyle
        ];
        if ((0, $0a57fad3299da03c$export$ac4f8128ea29c5).marker.label.shouldRender && resolution < (0, $0a57fad3299da03c$export$ac4f8128ea29c5).marker.label.visibleUnderResolution) {
            const labelOffsetY = 20;
            const labelOffsetDirection = rotation >= 90 && rotation <= 270 ? -1 : 1;
            const labelOffset = labelOffsetY * labelOffsetDirection;
            const labelStyle = this.#getLabelStyle(properties.label.text, labelOffset, properties.label.useUpperCase, properties.label.useEllipsisAfter, properties.label.font, properties.label.fill, properties.label.stroke, properties.label.strokeWidth);
            styles.push(labelStyle);
        }
        return styles;
    }
    // TODO:
    // What to use as default?
    static #getDefaultStyle() {
        return undefined;
    }
    // Note:
    // Needed to duplicate the FeatureManager.getType to avoid circular dependencies
    static #getType(feature) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).get(feature.getProperties(), [
            'oltb',
            'type'
        ], undefined);
    }
    //--------------------------------------------------------------------
    // # Section: Public API
    //--------------------------------------------------------------------
    static getStyle(feature, resolution) {
        const oltb = (0, $0a57fad3299da03c$export$ac4f8128ea29c5).toolbar.id;
        const properties = feature.get(oltb);
        if (!properties) return;
        if (properties.type === (0, $60b20182c25e327b$export$2906e7f4b228efe9).type.iconMarker) return this.#getIconMarkerStyle(properties, resolution);
        if (properties.type === (0, $60b20182c25e327b$export$2906e7f4b228efe9).type.windBarb) return this.#getWindBarbStyle(properties, resolution);
        return this.#getDefaultStyle();
    }
    static clearStyles() {
        this.#styles.clear();
    }
    static getSize() {
        return this.#styles.size || 0;
    }
    static getDefaultMeasurementStyle() {
        return $2577fba4fdbf4b69$var$DefaultMeasurementStyle;
    }
    static getDefaultDrawingStyle() {
        return $2577fba4fdbf4b69$var$DefaultDrawingStyle;
    }
    static getSelectedStyle(feature, resolution) {
        const type = this.#getType(feature);
        switch(type){
            case (0, $60b20182c25e327b$export$2906e7f4b228efe9).type.measurement:
                return this.getDefaultSelectMeasurementStyle();
            case (0, $60b20182c25e327b$export$2906e7f4b228efe9).type.drawing:
                return this.getDefaultSelectDrawingStyle();
            default:
                return this.getDefaultSelectDrawingStyle();
        }
    }
    static getDefaultSelectDrawingStyle() {
        return [
            $2577fba4fdbf4b69$var$DefaultSelectDrawingStyle,
            $2577fba4fdbf4b69$var$DefaultSelectedVertices
        ];
    }
    static getDefaultSelectMeasurementStyle() {
        return [
            $2577fba4fdbf4b69$var$DefaultSelectMeasurementStyle,
            $2577fba4fdbf4b69$var$DefaultSelectedVertices
        ];
    }
}




var $f1q41 = parcelRequire("f1q41");


/**
 * @module ol/Feature
 */ 



/**
 * @typedef {typeof Feature|typeof import("./render/Feature.js").default} FeatureClass
 */ /**
 * @typedef {Feature|import("./render/Feature.js").default} FeatureLike
 */ /***
 * @template Return
 * @typedef {import("./Observable").OnSignature<import("./Observable").EventTypes, import("./events/Event.js").default, Return> &
 *   import("./Observable").OnSignature<import("./ObjectEventType").Types|'change:geometry', import("./Object").ObjectEvent, Return> &
 *   import("./Observable").CombinedOnSignature<import("./Observable").EventTypes|import("./ObjectEventType").Types
 *     |'change:geometry', Return>} FeatureOnSignature
 */ /***
 * @template {import("./geom/Geometry.js").default} [Geometry=import("./geom/Geometry.js").default]
 * @typedef {Object<string, *> & { geometry?: Geometry }} ObjectWithGeometry
 */ /**
 * @classdesc
 * A vector object for geographic features with a geometry and other
 * attribute properties, similar to the features in vector file formats like
 * GeoJSON.
 *
 * Features can be styled individually with `setStyle`; otherwise they use the
 * style of their vector layer.
 *
 * Note that attribute properties are set as {@link module:ol/Object~BaseObject} properties on
 * the feature object, so they are observable, and have get/set accessors.
 *
 * Typically, a feature has a single geometry property. You can set the
 * geometry using the `setGeometry` method and get it with `getGeometry`.
 * It is possible to store more than one geometry on a feature using attribute
 * properties. By default, the geometry used for rendering is identified by
 * the property name `geometry`. If you want to use another geometry property
 * for rendering, use the `setGeometryName` method to change the attribute
 * property associated with the geometry for the feature.  For example:
 *
 * ```js
 *
 * import Feature from 'ol/Feature.js';
 * import Polygon from 'ol/geom/Polygon.js';
 * import Point from 'ol/geom/Point.js';
 *
 * const feature = new Feature({
 *   geometry: new Polygon(polyCoords),
 *   labelPoint: new Point(labelCoords),
 *   name: 'My Polygon',
 * });
 *
 * // get the polygon geometry
 * const poly = feature.getGeometry();
 *
 * // Render the feature as a point using the coordinates from labelPoint
 * feature.setGeometryName('labelPoint');
 *
 * // get the point geometry
 * const point = feature.getGeometry();
 * ```
 *
 * @api
 * @template {import("./geom/Geometry.js").default} [Geometry=import("./geom/Geometry.js").default]
 */ class $9fd014ab6df63665$var$Feature extends (0, $b68b3d6e32e3074a$export$2e2bcd8739ae039) {
    /**
   * @param {Geometry|ObjectWithGeometry<Geometry>} [geometryOrProperties]
   *     You may pass a Geometry object directly, or an object literal containing
   *     properties. If you pass an object literal, you may include a Geometry
   *     associated with a `geometry` key.
   */ constructor(geometryOrProperties){
        super();
        /***
     * @type {FeatureOnSignature<import("./events").EventsKey>}
     */ this.on;
        /***
     * @type {FeatureOnSignature<import("./events").EventsKey>}
     */ this.once;
        /***
     * @type {FeatureOnSignature<void>}
     */ this.un;
        /**
     * @private
     * @type {number|string|undefined}
     */ this.id_ = undefined;
        /**
     * @type {string}
     * @private
     */ this.geometryName_ = 'geometry';
        /**
     * User provided style.
     * @private
     * @type {import("./style/Style.js").StyleLike}
     */ this.style_ = null;
        /**
     * @private
     * @type {import("./style/Style.js").StyleFunction|undefined}
     */ this.styleFunction_ = undefined;
        /**
     * @private
     * @type {?import("./events.js").EventsKey}
     */ this.geometryChangeKey_ = null;
        this.addChangeListener(this.geometryName_, this.handleGeometryChanged_);
        if (geometryOrProperties) {
            if (typeof /** @type {?} */ geometryOrProperties.getSimplifiedGeometry === 'function') {
                const geometry = /** @type {Geometry} */ geometryOrProperties;
                this.setGeometry(geometry);
            } else {
                /** @type {Object<string, *>} */ const properties = geometryOrProperties;
                this.setProperties(properties);
            }
        }
    }
    /**
   * Clone this feature. If the original feature has a geometry it
   * is also cloned. The feature id is not set in the clone.
   * @return {Feature<Geometry>} The clone.
   * @api
   */ clone() {
        const clone = /** @type {Feature<Geometry>} */ new $9fd014ab6df63665$var$Feature(this.hasProperties() ? this.getProperties() : null);
        clone.setGeometryName(this.getGeometryName());
        const geometry = this.getGeometry();
        if (geometry) clone.setGeometry(/** @type {Geometry} */ geometry.clone());
        const style = this.getStyle();
        if (style) clone.setStyle(style);
        return clone;
    }
    /**
   * Get the feature's default geometry.  A feature may have any number of named
   * geometries.  The "default" geometry (the one that is rendered by default) is
   * set when calling {@link module:ol/Feature~Feature#setGeometry}.
   * @return {Geometry|undefined} The default geometry for the feature.
   * @api
   * @observable
   */ getGeometry() {
        return /** @type {Geometry|undefined} */ this.get(this.geometryName_);
    }
    /**
   * Get the feature identifier.  This is a stable identifier for the feature and
   * is either set when reading data from a remote source or set explicitly by
   * calling {@link module:ol/Feature~Feature#setId}.
   * @return {number|string|undefined} Id.
   * @api
   */ getId() {
        return this.id_;
    }
    /**
   * Get the name of the feature's default geometry.  By default, the default
   * geometry is named `geometry`.
   * @return {string} Get the property name associated with the default geometry
   *     for this feature.
   * @api
   */ getGeometryName() {
        return this.geometryName_;
    }
    /**
   * Get the feature's style. Will return what was provided to the
   * {@link module:ol/Feature~Feature#setStyle} method.
   * @return {import("./style/Style.js").StyleLike|undefined} The feature style.
   * @api
   */ getStyle() {
        return this.style_;
    }
    /**
   * Get the feature's style function.
   * @return {import("./style/Style.js").StyleFunction|undefined} Return a function
   * representing the current style of this feature.
   * @api
   */ getStyleFunction() {
        return this.styleFunction_;
    }
    /**
   * @private
   */ handleGeometryChange_() {
        this.changed();
    }
    /**
   * @private
   */ handleGeometryChanged_() {
        if (this.geometryChangeKey_) {
            (0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921)(this.geometryChangeKey_);
            this.geometryChangeKey_ = null;
        }
        const geometry = this.getGeometry();
        if (geometry) this.geometryChangeKey_ = (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(geometry, (0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE, this.handleGeometryChange_, this);
        this.changed();
    }
    /**
   * Set the default geometry for the feature.  This will update the property
   * with the name returned by {@link module:ol/Feature~Feature#getGeometryName}.
   * @param {Geometry|undefined} geometry The new geometry.
   * @api
   * @observable
   */ setGeometry(geometry) {
        this.set(this.geometryName_, geometry);
    }
    /**
   * Set the style for the feature to override the layer style.  This can be a
   * single style object, an array of styles, or a function that takes a
   * resolution and returns an array of styles. To unset the feature style, call
   * `setStyle()` without arguments or a falsey value.
   * @param {import("./style/Style.js").StyleLike} [style] Style for this feature.
   * @api
   * @fires module:ol/events/Event~BaseEvent#event:change
   */ setStyle(style) {
        this.style_ = style;
        this.styleFunction_ = !style ? undefined : $9fd014ab6df63665$export$bb06ddfd5d66e02e(style);
        this.changed();
    }
    /**
   * Set the feature id.  The feature id is considered stable and may be used when
   * requesting features or comparing identifiers returned from a remote source.
   * The feature id can be used with the
   * {@link module:ol/source/Vector~VectorSource#getFeatureById} method.
   * @param {number|string|undefined} id The feature id.
   * @api
   * @fires module:ol/events/Event~BaseEvent#event:change
   */ setId(id) {
        this.id_ = id;
        this.changed();
    }
    /**
   * Set the property name to be used when getting the feature's default geometry.
   * When calling {@link module:ol/Feature~Feature#getGeometry}, the value of the property with
   * this name will be returned.
   * @param {string} name The property name of the default geometry.
   * @api
   */ setGeometryName(name) {
        this.removeChangeListener(this.geometryName_, this.handleGeometryChanged_);
        this.geometryName_ = name;
        this.addChangeListener(this.geometryName_, this.handleGeometryChanged_);
        this.handleGeometryChanged_();
    }
}
function $9fd014ab6df63665$export$bb06ddfd5d66e02e(obj) {
    if (typeof obj === 'function') return obj;
    /**
   * @type {Array<import("./style/Style.js").default>}
   */ let styles;
    if (Array.isArray(obj)) styles = obj;
    else {
        (0, $35d5ec884318008e$export$a7a9523472993e97)(typeof /** @type {?} */ obj.getZIndex === 'function', 'Expected an `ol/style/Style` or an array of `ol/style/Style.js`');
        const style = /** @type {import("./style/Style.js").default} */ obj;
        styles = [
            style
        ];
    }
    return function() {
        return styles;
    };
}
var $9fd014ab6df63665$export$2e2bcd8739ae039 = $9fd014ab6df63665$var$Feature;







const $a8f2ca70ab701cb7$export$c4fdd084e378b052 = function(key, value) {
    if ((0, $ceccb931a11a5f0d$export$a8a17deeffd2032).includes(key)) return undefined;
    if (value instanceof Error) // Note:
    // Known properties from Error object
    // Native JS errors that inherits from Error
    return {
        name: value.name,
        message: value.message,
        fileName: value.fileName,
        lineNumber: value.lineNumber,
        columnNumber: value.columnNumber,
        stack: value.stack.split('\n').filter((element)=>element),
        cause: value.cause
    };
    if (value instanceof Response) // Note:
    // Known properties from Response object
    // Might bee a bad Fetch call that was thrown as an Error, contained inside cause property
    return {
        ok: value.ok,
        redirect: value.redirect,
        status: value.status,
        statusText: value.statusText,
        type: value.type,
        url: value.url
    };
    // Note:
    // Normal anonymous object or number/literal
    return value;
};



/**
 * @module ol/Overlay
 */ 





/**
 * @typedef {'bottom-left' | 'bottom-center' | 'bottom-right' | 'center-left' | 'center-center' | 'center-right' | 'top-left' | 'top-center' | 'top-right'} Positioning
 * The overlay position: `'bottom-left'`, `'bottom-center'`,  `'bottom-right'`,
 * `'center-left'`, `'center-center'`, `'center-right'`, `'top-left'`,
 * `'top-center'`, or `'top-right'`.
 */ /**
 * @typedef {Object} Options
 * @property {number|string} [id] Set the overlay id. The overlay id can be used
 * with the {@link module:ol/Map~Map#getOverlayById} method.
 * @property {HTMLElement} [element] The overlay element.
 * @property {Array<number>} [offset=[0, 0]] Offsets in pixels used when positioning
 * the overlay. The first element in the
 * array is the horizontal offset. A positive value shifts the overlay right.
 * The second element in the array is the vertical offset. A positive value
 * shifts the overlay down.
 * @property {import("./coordinate.js").Coordinate} [position] The overlay position
 * in map projection.
 * @property {Positioning} [positioning='top-left'] Defines how
 * the overlay is actually positioned with respect to its `position` property.
 * Possible values are `'bottom-left'`, `'bottom-center'`, `'bottom-right'`,
 * `'center-left'`, `'center-center'`, `'center-right'`, `'top-left'`,
 * `'top-center'`, and `'top-right'`.
 * @property {boolean} [stopEvent=true] Whether event propagation to the map
 * viewport should be stopped. If `true` the overlay is placed in the same
 * container as that of the controls (CSS class name
 * `ol-overlaycontainer-stopevent`); if `false` it is placed in the container
 * with CSS class name specified by the `className` property.
 * @property {boolean} [insertFirst=true] Whether the overlay is inserted first
 * in the overlay container, or appended. If the overlay is placed in the same
 * container as that of the controls (see the `stopEvent` option) you will
 * probably set `insertFirst` to `true` so the overlay is displayed below the
 * controls.
 * @property {PanIntoViewOptions|boolean} [autoPan=false] Pan the map when calling
 * `setPosition`, so that the overlay is entirely visible in the current viewport.
 * @property {string} [className='ol-overlay-container ol-selectable'] CSS class
 * name.
 */ /**
 * @typedef {Object} PanOptions
 * @property {number} [duration=1000] The duration of the animation in
 * milliseconds.
 * @property {function(number):number} [easing] The easing function to use. Can
 * be one from {@link module:ol/easing} or a custom function.
 * Default is {@link module:ol/easing.inAndOut}.
 */ /**
 * @typedef {Object} PanIntoViewOptions
 * @property {PanOptions} [animation={}] The animation parameters for the pan
 * @property {number} [margin=20] The margin (in pixels) between the
 * overlay and the borders of the map when panning into view.
 */ /**
 * @enum {string}
 * @protected
 */ const $c80d3ed2a84f41ed$var$Property = {
    ELEMENT: 'element',
    MAP: 'map',
    OFFSET: 'offset',
    POSITION: 'position',
    POSITIONING: 'positioning'
};
/**
 * @typedef {import("./ObjectEventType").Types|'change:element'|'change:map'|'change:offset'|'change:position'|
 *   'change:positioning'} OverlayObjectEventTypes
 */ /***
 * @template Return
 * @typedef {import("./Observable").OnSignature<import("./Observable").EventTypes, import("./events/Event.js").default, Return> &
 *   import("./Observable").OnSignature<OverlayObjectEventTypes, import("./Object").ObjectEvent, Return> &
 *   import("./Observable").CombinedOnSignature<import("./Observable").EventTypes|OverlayObjectEventTypes, Return>} OverlayOnSignature
 */ /**
 * @classdesc
 * An element to be displayed over the map and attached to a single map
 * location.  Like {@link module:ol/control/Control~Control}, Overlays are
 * visible widgets. Unlike Controls, they are not in a fixed position on the
 * screen, but are tied to a geographical coordinate, so panning the map will
 * move an Overlay but not a Control.
 *
 * Example:
 *
 *     import Overlay from 'ol/Overlay.js';
 *
 *     // ...
 *     const popup = new Overlay({
 *       element: document.getElementById('popup'),
 *     });
 *     popup.setPosition(coordinate);
 *     map.addOverlay(popup);
 *
 * @api
 */ class $c80d3ed2a84f41ed$var$Overlay extends (0, $b68b3d6e32e3074a$export$2e2bcd8739ae039) {
    /**
   * @param {Options} options Overlay options.
   */ constructor(options){
        super();
        /***
     * @type {OverlayOnSignature<import("./events").EventsKey>}
     */ this.on;
        /***
     * @type {OverlayOnSignature<import("./events").EventsKey>}
     */ this.once;
        /***
     * @type {OverlayOnSignature<void>}
     */ this.un;
        /**
     * @protected
     * @type {Options}
     */ this.options = options;
        /**
     * @protected
     * @type {number|string|undefined}
     */ this.id = options.id;
        /**
     * @protected
     * @type {boolean}
     */ this.insertFirst = options.insertFirst !== undefined ? options.insertFirst : true;
        /**
     * @protected
     * @type {boolean}
     */ this.stopEvent = options.stopEvent !== undefined ? options.stopEvent : true;
        /**
     * @protected
     * @type {HTMLElement}
     */ this.element = document.createElement('div');
        this.element.className = options.className !== undefined ? options.className : 'ol-overlay-container ' + (0, $ce07df6d5d4656f1$export$99b49471b0394319);
        this.element.style.position = 'absolute';
        this.element.style.pointerEvents = 'auto';
        /**
     * @protected
     * @type {PanIntoViewOptions|undefined}
     */ this.autoPan = options.autoPan === true ? {} : options.autoPan || undefined;
        /**
     * @protected
     * @type {{transform_: string,
     *         visible: boolean}}
     */ this.rendered = {
            transform_: '',
            visible: true
        };
        /**
     * @protected
     * @type {?import("./events.js").EventsKey}
     */ this.mapPostrenderListenerKey = null;
        this.addChangeListener($c80d3ed2a84f41ed$var$Property.ELEMENT, this.handleElementChanged);
        this.addChangeListener($c80d3ed2a84f41ed$var$Property.MAP, this.handleMapChanged);
        this.addChangeListener($c80d3ed2a84f41ed$var$Property.OFFSET, this.handleOffsetChanged);
        this.addChangeListener($c80d3ed2a84f41ed$var$Property.POSITION, this.handlePositionChanged);
        this.addChangeListener($c80d3ed2a84f41ed$var$Property.POSITIONING, this.handlePositioningChanged);
        if (options.element !== undefined) this.setElement(options.element);
        this.setOffset(options.offset !== undefined ? options.offset : [
            0,
            0
        ]);
        this.setPositioning(options.positioning || 'top-left');
        if (options.position !== undefined) this.setPosition(options.position);
    }
    /**
   * Get the DOM element of this overlay.
   * @return {HTMLElement|undefined} The Element containing the overlay.
   * @observable
   * @api
   */ getElement() {
        return /** @type {HTMLElement|undefined} */ this.get($c80d3ed2a84f41ed$var$Property.ELEMENT);
    }
    /**
   * Get the overlay identifier which is set on constructor.
   * @return {number|string|undefined} Id.
   * @api
   */ getId() {
        return this.id;
    }
    /**
   * Get the map associated with this overlay.
   * @return {import("./Map.js").default|null} The map that the
   * overlay is part of.
   * @observable
   * @api
   */ getMap() {
        return /** @type {import("./Map.js").default|null} */ this.get($c80d3ed2a84f41ed$var$Property.MAP) || null;
    }
    /**
   * Get the offset of this overlay.
   * @return {Array<number>} The offset.
   * @observable
   * @api
   */ getOffset() {
        return /** @type {Array<number>} */ this.get($c80d3ed2a84f41ed$var$Property.OFFSET);
    }
    /**
   * Get the current position of this overlay.
   * @return {import("./coordinate.js").Coordinate|undefined} The spatial point that the overlay is
   *     anchored at.
   * @observable
   * @api
   */ getPosition() {
        return /** @type {import("./coordinate.js").Coordinate|undefined} */ this.get($c80d3ed2a84f41ed$var$Property.POSITION);
    }
    /**
   * Get the current positioning of this overlay.
   * @return {Positioning} How the overlay is positioned
   *     relative to its point on the map.
   * @observable
   * @api
   */ getPositioning() {
        return /** @type {Positioning} */ this.get($c80d3ed2a84f41ed$var$Property.POSITIONING);
    }
    /**
   * @protected
   */ handleElementChanged() {
        (0, $075f937d7366f1a2$export$1e1c9bf5a4ffe0d1)(this.element);
        const element = this.getElement();
        if (element) this.element.appendChild(element);
    }
    /**
   * @protected
   */ handleMapChanged() {
        if (this.mapPostrenderListenerKey) {
            this.element?.remove();
            (0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921)(this.mapPostrenderListenerKey);
            this.mapPostrenderListenerKey = null;
        }
        const map = this.getMap();
        if (map) {
            this.mapPostrenderListenerKey = (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(map, (0, $e4ad75f913b6f7ff$export$2e2bcd8739ae039).POSTRENDER, this.render, this);
            this.updatePixelPosition();
            const container = this.stopEvent ? map.getOverlayContainerStopEvent() : map.getOverlayContainer();
            if (this.insertFirst) container.insertBefore(this.element, container.childNodes[0] || null);
            else container.appendChild(this.element);
            this.performAutoPan();
        }
    }
    /**
   * @protected
   */ render() {
        this.updatePixelPosition();
    }
    /**
   * @protected
   */ handleOffsetChanged() {
        this.updatePixelPosition();
    }
    /**
   * @protected
   */ handlePositionChanged() {
        this.updatePixelPosition();
        this.performAutoPan();
    }
    /**
   * @protected
   */ handlePositioningChanged() {
        this.updatePixelPosition();
    }
    /**
   * Set the DOM element to be associated with this overlay.
   * @param {HTMLElement|undefined} element The Element containing the overlay.
   * @observable
   * @api
   */ setElement(element) {
        this.set($c80d3ed2a84f41ed$var$Property.ELEMENT, element);
    }
    /**
   * Set the map to be associated with this overlay.
   * @param {import("./Map.js").default|null} map The map that the
   * overlay is part of. Pass `null` to just remove the overlay from the current map.
   * @observable
   * @api
   */ setMap(map) {
        this.set($c80d3ed2a84f41ed$var$Property.MAP, map);
    }
    /**
   * Set the offset for this overlay.
   * @param {Array<number>} offset Offset.
   * @observable
   * @api
   */ setOffset(offset) {
        this.set($c80d3ed2a84f41ed$var$Property.OFFSET, offset);
    }
    /**
   * Set the position for this overlay. If the position is `undefined` the
   * overlay is hidden.
   * @param {import("./coordinate.js").Coordinate|undefined} position The spatial point that the overlay
   *     is anchored at.
   * @observable
   * @api
   */ setPosition(position) {
        this.set($c80d3ed2a84f41ed$var$Property.POSITION, position);
    }
    /**
   * Pan the map so that the overlay is entirely visible in the current viewport
   * (if necessary) using the configured autoPan parameters
   * @protected
   */ performAutoPan() {
        if (this.autoPan) this.panIntoView(this.autoPan);
    }
    /**
   * Pan the map so that the overlay is entirely visible in the current viewport
   * (if necessary).
   * @param {PanIntoViewOptions} [panIntoViewOptions] Options for the pan action
   * @api
   */ panIntoView(panIntoViewOptions) {
        const map = this.getMap();
        if (!map || !map.getTargetElement() || !this.get($c80d3ed2a84f41ed$var$Property.POSITION)) return;
        const mapRect = this.getRect(map.getTargetElement(), map.getSize());
        const element = this.getElement();
        const overlayRect = this.getRect(element, [
            (0, $075f937d7366f1a2$export$e823f88e4111159a)(element),
            (0, $075f937d7366f1a2$export$fc5b8aac72846d1e)(element)
        ]);
        panIntoViewOptions = panIntoViewOptions || {};
        const myMargin = panIntoViewOptions.margin === undefined ? 20 : panIntoViewOptions.margin;
        if (!(0, $6da4c8ed3074c92b$export$be866b1e0809b17e)(mapRect, overlayRect)) {
            // the overlay is not completely inside the viewport, so pan the map
            const offsetLeft = overlayRect[0] - mapRect[0];
            const offsetRight = mapRect[2] - overlayRect[2];
            const offsetTop = overlayRect[1] - mapRect[1];
            const offsetBottom = mapRect[3] - overlayRect[3];
            const delta = [
                0,
                0
            ];
            if (offsetLeft < 0) // move map to the left
            delta[0] = offsetLeft - myMargin;
            else if (offsetRight < 0) // move map to the right
            delta[0] = Math.abs(offsetRight) + myMargin;
            if (offsetTop < 0) // move map up
            delta[1] = offsetTop - myMargin;
            else if (offsetBottom < 0) // move map down
            delta[1] = Math.abs(offsetBottom) + myMargin;
            if (delta[0] !== 0 || delta[1] !== 0) {
                const center = /** @type {import("./coordinate.js").Coordinate} */ map.getView().getCenterInternal();
                const centerPx = map.getPixelFromCoordinateInternal(center);
                if (!centerPx) return;
                const newCenterPx = [
                    centerPx[0] + delta[0],
                    centerPx[1] + delta[1]
                ];
                const panOptions = panIntoViewOptions.animation || {};
                map.getView().animateInternal({
                    center: map.getCoordinateFromPixelInternal(newCenterPx),
                    duration: panOptions.duration,
                    easing: panOptions.easing
                });
            }
        }
    }
    /**
   * Get the extent of an element relative to the document
   * @param {HTMLElement} element The element.
   * @param {import("./size.js").Size} size The size of the element.
   * @return {import("./extent.js").Extent} The extent.
   * @protected
   */ getRect(element, size) {
        const box = element.getBoundingClientRect();
        const offsetX = box.left + window.pageXOffset;
        const offsetY = box.top + window.pageYOffset;
        return [
            offsetX,
            offsetY,
            offsetX + size[0],
            offsetY + size[1]
        ];
    }
    /**
   * Set the positioning for this overlay.
   * @param {Positioning} positioning how the overlay is
   *     positioned relative to its point on the map.
   * @observable
   * @api
   */ setPositioning(positioning) {
        this.set($c80d3ed2a84f41ed$var$Property.POSITIONING, positioning);
    }
    /**
   * Modify the visibility of the element.
   * @param {boolean} visible Element visibility.
   * @protected
   */ setVisible(visible) {
        if (this.rendered.visible !== visible) {
            this.element.style.display = visible ? '' : 'none';
            this.rendered.visible = visible;
        }
    }
    /**
   * Update pixel position.
   * @protected
   */ updatePixelPosition() {
        const map = this.getMap();
        const position = this.getPosition();
        if (!map || !map.isRendered() || !position) {
            this.setVisible(false);
            return;
        }
        const pixel = map.getPixelFromCoordinate(position);
        const mapSize = map.getSize();
        this.updateRenderedPosition(pixel, mapSize);
    }
    /**
   * @param {import("./pixel.js").Pixel} pixel The pixel location.
   * @param {import("./size.js").Size|undefined} mapSize The map size.
   * @protected
   */ updateRenderedPosition(pixel, mapSize) {
        const style = this.element.style;
        const offset = this.getOffset();
        const positioning = this.getPositioning();
        this.setVisible(true);
        const x = `${pixel[0] + offset[0]}px`;
        const y = `${pixel[1] + offset[1]}px`;
        let posX = '0%';
        let posY = '0%';
        if (positioning == 'bottom-right' || positioning == 'center-right' || positioning == 'top-right') posX = '-100%';
        else if (positioning == 'bottom-center' || positioning == 'center-center' || positioning == 'top-center') posX = '-50%';
        if (positioning == 'bottom-left' || positioning == 'bottom-center' || positioning == 'bottom-right') posY = '-100%';
        else if (positioning == 'center-left' || positioning == 'center-center' || positioning == 'center-right') posY = '-50%';
        const transform = `translate(${posX}, ${posY}) translate(${x}, ${y})`;
        if (this.rendered.transform_ != transform) {
            this.rendered.transform_ = transform;
            style.transform = transform;
        }
    }
    /**
   * returns the options this Overlay has been created with
   * @return {Options} overlay options
   */ getOptions() {
        return this.options;
    }
}
var $c80d3ed2a84f41ed$export$2e2bcd8739ae039 = $c80d3ed2a84f41ed$var$Overlay;



const $318a0f888265a757$var$CLASS__OVERLAY_TOOLTIP = 'oltb-overlay-tooltip';
const $318a0f888265a757$export$d2807c45400bf836 = function(data = '') {
    const tooltip = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
        element: 'div',
        class: $318a0f888265a757$var$CLASS__OVERLAY_TOOLTIP
    });
    const item = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
        element: 'span',
        html: data,
        class: `${$318a0f888265a757$var$CLASS__OVERLAY_TOOLTIP}__item`
    });
    (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(tooltip, [
        item
    ]);
    const overlayOffset = (0, $1e8c0ef90ed82280$export$a33e119b2316dcb7).getConfig().overlayOffset;
    const overlay = new (0, $c80d3ed2a84f41ed$export$2e2bcd8739ae039)({
        element: tooltip,
        positioning: 'bottom-center',
        offset: [
            overlayOffset.horizontal,
            overlayOffset.vertical
        ]
    });
    return {
        getOverlay: ()=>{
            return overlay;
        },
        setPosition: (position)=>{
            overlay.setPosition(position);
        },
        getPositioin: ()=>{
            return overlay.getPosition();
        },
        setData: (data)=>{
            item.innerHTML = data;
        },
        getData: ()=>{
            return item.innerHTML;
        }
    };
};



const $923245ece89406d3$export$e8c24859bf18d46 = Object.freeze({
    lon: undefined,
    lat: undefined,
    infoWindow: undefined,
    title: '',
    description: '',
    settings: Object.freeze({
        shouldReplaceHashtag: true
    }),
    icon: Object.freeze({
        key: 0,
        width: 200,
        height: 200,
        rotation: 0,
        fill: '#3B4352FF',
        stroke: '#3B4352FF',
        strokeWidth: 3
    }),
    label: Object.freeze({
        text: '',
        font: '14px Calibri',
        fill: '#FFFFFFFF',
        stroke: '#3B4352CC',
        strokeWidth: 8,
        useEllipsisAfter: 20,
        useUpperCase: false
    })
});


const $1a398e8f0612651b$export$1a318632ed6f2b6b = Object.freeze({
    lon: undefined,
    lat: undefined,
    infoWindow: undefined,
    title: '',
    description: '',
    settings: Object.freeze({
        shouldReplaceHashtag: true
    }),
    marker: Object.freeze({
        width: 14,
        radius: 14,
        fill: '#0166A5FF',
        stroke: '#0166A566',
        strokeWidth: 2
    }),
    icon: Object.freeze({
        key: 'geoPin.filled',
        width: 14,
        height: 14,
        rotation: 0,
        fill: '#FFFFFFFF',
        stroke: '#FFFFFFFF',
        strokeWidth: 0
    }),
    label: Object.freeze({
        text: '',
        font: '14px Calibri',
        fill: '#FFFFFFFF',
        stroke: '#3B4352CC',
        strokeWidth: 8,
        useEllipsisAfter: 20,
        useUpperCase: false
    })
});




const $ef19f7475e8f20ad$export$c8fdb1ecc11e521e = function(geometry) {
    return geometry instanceof (0, $40aa8d43bbe572bf$export$2e2bcd8739ae039) ? $ef19f7475e8f20ad$var$formatArea(geometry) : $ef19f7475e8f20ad$var$formatLength(geometry);
};
const $ef19f7475e8f20ad$export$9a7874bcc72fae65 = function(geometry) {
    return geometry instanceof (0, $40aa8d43bbe572bf$export$2e2bcd8739ae039) ? geometry.getInteriorPoint().getCoordinates() : geometry.getLastCoordinate();
};
const $ef19f7475e8f20ad$var$formatLength = function(line) {
    const length = (0, $fb75384508533d8f$export$f0d11c074a923179)(line);
    if (length > 100) {
        const lengthKilometers = Math.round(length / 1000 * 100) / 100;
        return {
            value: lengthKilometers,
            unit: 'km'
        };
    }
    const lengthMeters = Math.round(length * 100) / 100;
    return {
        value: lengthMeters,
        unit: 'm'
    };
};
const $ef19f7475e8f20ad$var$formatArea = function(polygon) {
    const area = (0, $fb75384508533d8f$export$520c40045967cb15)(polygon);
    if (area > 10000) {
        const squareKilometer = Math.round(area / 1000000 * 100) / 100;
        return {
            value: squareKilometer,
            unit: 'km<sup>2</sup>'
        };
    }
    const squareMeter = Math.round(area * 100) / 100;
    return {
        value: squareMeter,
        unit: 'm<sup>2</sup>'
    };
};


/**
 * @module ol/interaction/Draw
 */ 








/**
 * @module ol/geom/Circle
 */ 



/**
 * @classdesc
 * Circle geometry.
 *
 * @api
 */ class $f6170f1a08d72585$var$Circle extends (0, $c76e993e57efc8c4$export$2e2bcd8739ae039) {
    /**
   * @param {!import("../coordinate.js").Coordinate} center Center.
   *     For internal use, flat coordinates in combination with `layout` and no
   *     `radius` are also accepted.
   * @param {number} [radius] Radius in units of the projection.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   */ constructor(center, radius, layout){
        super();
        if (layout !== undefined && radius === undefined) this.setFlatCoordinates(layout, center);
        else {
            radius = radius ? radius : 0;
            this.setCenterAndRadius(center, radius, layout);
        }
    }
    /**
   * Make a complete copy of the geometry.
   * @return {!Circle} Clone.
   * @api
   * @override
   */ clone() {
        const circle = new $f6170f1a08d72585$var$Circle(this.flatCoordinates.slice(), undefined, this.layout);
        circle.applyProperties(this);
        return circle;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   * @override
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        const flatCoordinates = this.flatCoordinates;
        const dx = x - flatCoordinates[0];
        const dy = y - flatCoordinates[1];
        const squaredDistance = dx * dx + dy * dy;
        if (squaredDistance < minSquaredDistance) {
            if (squaredDistance === 0) for(let i = 0; i < this.stride; ++i)closestPoint[i] = flatCoordinates[i];
            else {
                const delta = this.getRadius() / Math.sqrt(squaredDistance);
                closestPoint[0] = flatCoordinates[0] + delta * dx;
                closestPoint[1] = flatCoordinates[1] + delta * dy;
                for(let i = 2; i < this.stride; ++i)closestPoint[i] = flatCoordinates[i];
            }
            closestPoint.length = this.stride;
            return squaredDistance;
        }
        return minSquaredDistance;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @return {boolean} Contains (x, y).
   * @override
   */ containsXY(x, y) {
        const flatCoordinates = this.flatCoordinates;
        const dx = x - flatCoordinates[0];
        const dy = y - flatCoordinates[1];
        return dx * dx + dy * dy <= this.getRadiusSquared_();
    }
    /**
   * Return the center of the circle as {@link module:ol/coordinate~Coordinate coordinate}.
   * @return {import("../coordinate.js").Coordinate} Center.
   * @api
   */ getCenter() {
        return this.flatCoordinates.slice(0, this.stride);
    }
    /**
   * @param {import("../extent.js").Extent} extent Extent.
   * @protected
   * @return {import("../extent.js").Extent} extent Extent.
   * @override
   */ computeExtent(extent) {
        const flatCoordinates = this.flatCoordinates;
        const radius = flatCoordinates[this.stride] - flatCoordinates[0];
        return (0, $6da4c8ed3074c92b$export$958e3e1a02eac4b6)(flatCoordinates[0] - radius, flatCoordinates[1] - radius, flatCoordinates[0] + radius, flatCoordinates[1] + radius, extent);
    }
    /**
   * Return the radius of the circle.
   * @return {number} Radius.
   * @api
   */ getRadius() {
        return Math.sqrt(this.getRadiusSquared_());
    }
    /**
   * @private
   * @return {number} Radius squared.
   */ getRadiusSquared_() {
        const dx = this.flatCoordinates[this.stride] - this.flatCoordinates[0];
        const dy = this.flatCoordinates[this.stride + 1] - this.flatCoordinates[1];
        return dx * dx + dy * dy;
    }
    /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   * @override
   */ getType() {
        return 'Circle';
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   * @override
   */ intersectsExtent(extent) {
        const circleExtent = this.getExtent();
        if ((0, $6da4c8ed3074c92b$export$7b0a31e10bbff018)(extent, circleExtent)) {
            const center = this.getCenter();
            if (extent[0] <= center[0] && extent[2] >= center[0]) return true;
            if (extent[1] <= center[1] && extent[3] >= center[1]) return true;
            return (0, $6da4c8ed3074c92b$export$f9ed8a3d123a08e2)(extent, this.intersectsCoordinate.bind(this));
        }
        return false;
    }
    /**
   * Set the center of the circle as {@link module:ol/coordinate~Coordinate coordinate}.
   * @param {import("../coordinate.js").Coordinate} center Center.
   * @api
   */ setCenter(center) {
        const stride = this.stride;
        const radius = this.flatCoordinates[stride] - this.flatCoordinates[0];
        const flatCoordinates = center.slice();
        flatCoordinates[stride] = flatCoordinates[0] + radius;
        for(let i = 1; i < stride; ++i)flatCoordinates[stride + i] = center[i];
        this.setFlatCoordinates(this.layout, flatCoordinates);
        this.changed();
    }
    /**
   * Set the center (as {@link module:ol/coordinate~Coordinate coordinate}) and the radius (as
   * number) of the circle.
   * @param {!import("../coordinate.js").Coordinate} center Center.
   * @param {number} radius Radius.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   */ setCenterAndRadius(center, radius, layout) {
        this.setLayout(layout, center, 0);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        /** @type {Array<number>} */ const flatCoordinates = this.flatCoordinates;
        let offset = (0, $6b086aa46281540d$export$60815ead40ec79ab)(flatCoordinates, 0, center, this.stride);
        flatCoordinates[offset++] = flatCoordinates[0] + radius;
        for(let i = 1, ii = this.stride; i < ii; ++i)flatCoordinates[offset++] = flatCoordinates[i];
        flatCoordinates.length = offset;
        this.changed();
    }
    /**
   * @override
   */ getCoordinates() {
        return null;
    }
    /**
   * @override
   */ setCoordinates(coordinates, layout) {}
    /**
   * Set the radius of the circle. The radius is in the units of the projection.
   * @param {number} radius Radius.
   * @api
   */ setRadius(radius) {
        this.flatCoordinates[this.stride] = this.flatCoordinates[0] + radius;
        this.changed();
    }
    /**
   * Rotate the geometry around a given coordinate. This modifies the geometry
   * coordinates in place.
   * @param {number} angle Rotation angle in counter-clockwise radians.
   * @param {import("../coordinate.js").Coordinate} anchor The rotation center.
   * @api
   * @override
   */ rotate(angle, anchor) {
        const center = this.getCenter();
        const stride = this.getStride();
        this.setCenter((0, $14c6e714516e527b$export$bb628a54ab399bc9)(center, 0, center.length, stride, angle, anchor, center));
        this.changed();
    }
}
/**
 * Transform each coordinate of the circle from one coordinate reference system
 * to another. The geometry is modified in place.
 * If you do not want the geometry modified in place, first clone() it and
 * then use this function on the clone.
 *
 * Internally a circle is currently represented by two points: the center of
 * the circle `[cx, cy]`, and the point to the right of the circle
 * `[cx + r, cy]`. This `transform` function just transforms these two points.
 * So the resulting geometry is also a circle, and that circle does not
 * correspond to the shape that would be obtained by transforming every point
 * of the original circle.
 *
 * @param {import("../proj.js").ProjectionLike} source The current projection.  Can be a
 *     string identifier or a {@link module:ol/proj/Projection~Projection} object.
 * @param {import("../proj.js").ProjectionLike} destination The desired projection.  Can be a
 *     string identifier or a {@link module:ol/proj/Projection~Projection} object.
 * @return {Circle} This geometry.  Note that original geometry is
 *     modified in place.
 * @function
 * @api
 */ $f6170f1a08d72585$var$Circle.prototype.transform;
var $f6170f1a08d72585$export$2e2bcd8739ae039 = $f6170f1a08d72585$var$Circle;


/**
 * @module ol/geom/GeometryCollection
 */ 



/**
 * @classdesc
 * An array of {@link module:ol/geom/Geometry~Geometry} objects.
 *
 * @api
 */ class $0e4f3959219eede5$var$GeometryCollection extends (0, $50db89a00eb954f6$export$2e2bcd8739ae039) {
    /**
   * @param {Array<Geometry>} geometries Geometries.
   */ constructor(geometries){
        super();
        /**
     * @private
     * @type {Array<Geometry>}
     */ this.geometries_ = geometries;
        /**
     * @private
     * @type {Array<import("../events.js").EventsKey>}
     */ this.changeEventsKeys_ = [];
        this.listenGeometriesChange_();
    }
    /**
   * @private
   */ unlistenGeometriesChange_() {
        this.changeEventsKeys_.forEach((0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921));
        this.changeEventsKeys_.length = 0;
    }
    /**
   * @private
   */ listenGeometriesChange_() {
        const geometries = this.geometries_;
        for(let i = 0, ii = geometries.length; i < ii; ++i)this.changeEventsKeys_.push((0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(geometries[i], (0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE, this.changed, this));
    }
    /**
   * Make a complete copy of the geometry.
   * @return {!GeometryCollection} Clone.
   * @api
   * @override
   */ clone() {
        const geometryCollection = new $0e4f3959219eede5$var$GeometryCollection($0e4f3959219eede5$var$cloneGeometries(this.geometries_));
        geometryCollection.applyProperties(this);
        return geometryCollection;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   * @override
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < (0, $6da4c8ed3074c92b$export$cbe64c389534206f)(this.getExtent(), x, y)) return minSquaredDistance;
        const geometries = this.geometries_;
        for(let i = 0, ii = geometries.length; i < ii; ++i)minSquaredDistance = geometries[i].closestPointXY(x, y, closestPoint, minSquaredDistance);
        return minSquaredDistance;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @return {boolean} Contains (x, y).
   * @override
   */ containsXY(x, y) {
        const geometries = this.geometries_;
        for(let i = 0, ii = geometries.length; i < ii; ++i){
            if (geometries[i].containsXY(x, y)) return true;
        }
        return false;
    }
    /**
   * @param {import("../extent.js").Extent} extent Extent.
   * @protected
   * @return {import("../extent.js").Extent} extent Extent.
   * @override
   */ computeExtent(extent) {
        (0, $6da4c8ed3074c92b$export$3e2152b047719fa1)(extent);
        const geometries = this.geometries_;
        for(let i = 0, ii = geometries.length; i < ii; ++i)(0, $6da4c8ed3074c92b$export$8b58be045bf06082)(extent, geometries[i].getExtent());
        return extent;
    }
    /**
   * Return the geometries that make up this geometry collection.
   * @return {Array<Geometry>} Geometries.
   * @api
   */ getGeometries() {
        return $0e4f3959219eede5$var$cloneGeometries(this.geometries_);
    }
    /**
   * @return {Array<Geometry>} Geometries.
   */ getGeometriesArray() {
        return this.geometries_;
    }
    /**
   * @return {Array<Geometry>} Geometries.
   */ getGeometriesArrayRecursive() {
        /** @type {Array<Geometry>} */ let geometriesArray = [];
        const geometries = this.geometries_;
        for(let i = 0, ii = geometries.length; i < ii; ++i)if (geometries[i].getType() === this.getType()) geometriesArray = geometriesArray.concat(/** @type {GeometryCollection} */ geometries[i].getGeometriesArrayRecursive());
        else geometriesArray.push(geometries[i]);
        return geometriesArray;
    }
    /**
   * Create a simplified version of this geometry using the Douglas Peucker algorithm.
   * @param {number} squaredTolerance Squared tolerance.
   * @return {GeometryCollection} Simplified GeometryCollection.
   * @override
   */ getSimplifiedGeometry(squaredTolerance) {
        if (this.simplifiedGeometryRevision !== this.getRevision()) {
            this.simplifiedGeometryMaxMinSquaredTolerance = 0;
            this.simplifiedGeometryRevision = this.getRevision();
        }
        if (squaredTolerance < 0 || this.simplifiedGeometryMaxMinSquaredTolerance !== 0 && squaredTolerance < this.simplifiedGeometryMaxMinSquaredTolerance) return this;
        const simplifiedGeometries = [];
        const geometries = this.geometries_;
        let simplified = false;
        for(let i = 0, ii = geometries.length; i < ii; ++i){
            const geometry = geometries[i];
            const simplifiedGeometry = geometry.getSimplifiedGeometry(squaredTolerance);
            simplifiedGeometries.push(simplifiedGeometry);
            if (simplifiedGeometry !== geometry) simplified = true;
        }
        if (simplified) {
            const simplifiedGeometryCollection = new $0e4f3959219eede5$var$GeometryCollection(simplifiedGeometries);
            return simplifiedGeometryCollection;
        }
        this.simplifiedGeometryMaxMinSquaredTolerance = squaredTolerance;
        return this;
    }
    /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   * @override
   */ getType() {
        return 'GeometryCollection';
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   * @override
   */ intersectsExtent(extent) {
        const geometries = this.geometries_;
        for(let i = 0, ii = geometries.length; i < ii; ++i){
            if (geometries[i].intersectsExtent(extent)) return true;
        }
        return false;
    }
    /**
   * @return {boolean} Is empty.
   */ isEmpty() {
        return this.geometries_.length === 0;
    }
    /**
   * Rotate the geometry around a given coordinate. This modifies the geometry
   * coordinates in place.
   * @param {number} angle Rotation angle in radians.
   * @param {import("../coordinate.js").Coordinate} anchor The rotation center.
   * @api
   * @override
   */ rotate(angle, anchor) {
        const geometries = this.geometries_;
        for(let i = 0, ii = geometries.length; i < ii; ++i)geometries[i].rotate(angle, anchor);
        this.changed();
    }
    /**
   * Scale the geometry (with an optional origin).  This modifies the geometry
   * coordinates in place.
   * @abstract
   * @param {number} sx The scaling factor in the x-direction.
   * @param {number} [sy] The scaling factor in the y-direction (defaults to sx).
   * @param {import("../coordinate.js").Coordinate} [anchor] The scale origin (defaults to the center
   *     of the geometry extent).
   * @api
   * @override
   */ scale(sx, sy, anchor) {
        if (!anchor) anchor = (0, $6da4c8ed3074c92b$export$c91255cadecfe081)(this.getExtent());
        const geometries = this.geometries_;
        for(let i = 0, ii = geometries.length; i < ii; ++i)geometries[i].scale(sx, sy, anchor);
        this.changed();
    }
    /**
   * Set the geometries that make up this geometry collection.
   * @param {Array<Geometry>} geometries Geometries.
   * @api
   */ setGeometries(geometries) {
        this.setGeometriesArray($0e4f3959219eede5$var$cloneGeometries(geometries));
    }
    /**
   * @param {Array<Geometry>} geometries Geometries.
   */ setGeometriesArray(geometries) {
        this.unlistenGeometriesChange_();
        this.geometries_ = geometries;
        this.listenGeometriesChange_();
        this.changed();
    }
    /**
   * Apply a transform function to the coordinates of the geometry.
   * The geometry is modified in place.
   * If you do not want the geometry modified in place, first `clone()` it and
   * then use this function on the clone.
   * @param {import("../proj.js").TransformFunction} transformFn Transform function.
   * Called with a flat array of geometry coordinates.
   * @api
   * @override
   */ applyTransform(transformFn) {
        const geometries = this.geometries_;
        for(let i = 0, ii = geometries.length; i < ii; ++i)geometries[i].applyTransform(transformFn);
        this.changed();
    }
    /**
   * Translate the geometry.  This modifies the geometry coordinates in place.  If
   * instead you want a new geometry, first `clone()` this geometry.
   * @param {number} deltaX Delta X.
   * @param {number} deltaY Delta Y.
   * @api
   * @override
   */ translate(deltaX, deltaY) {
        const geometries = this.geometries_;
        for(let i = 0, ii = geometries.length; i < ii; ++i)geometries[i].translate(deltaX, deltaY);
        this.changed();
    }
    /**
   * Clean up.
   * @override
   */ disposeInternal() {
        this.unlistenGeometriesChange_();
        super.disposeInternal();
    }
}
/**
 * @param {Array<Geometry>} geometries Geometries.
 * @return {Array<Geometry>} Cloned geometries.
 */ function $0e4f3959219eede5$var$cloneGeometries(geometries) {
    return geometries.map((geometry)=>geometry.clone());
}
var $0e4f3959219eede5$export$2e2bcd8739ae039 = $0e4f3959219eede5$var$GeometryCollection;


/**
 * @module ol/geom/LineString
 */ 





/**
 * @module ol/geom/flat/interpolate
 */ 

function $43ed5485a1d0c509$export$687ff82efd78795b(flatCoordinates, offset, end, stride, fraction, dest, dimension) {
    let o, t;
    const n = (end - offset) / stride;
    if (n === 1) o = offset;
    else if (n === 2) {
        o = offset;
        t = fraction;
    } else if (n !== 0) {
        let x1 = flatCoordinates[offset];
        let y1 = flatCoordinates[offset + 1];
        let length = 0;
        const cumulativeLengths = [
            0
        ];
        for(let i = offset + stride; i < end; i += stride){
            const x2 = flatCoordinates[i];
            const y2 = flatCoordinates[i + 1];
            length += Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
            cumulativeLengths.push(length);
            x1 = x2;
            y1 = y2;
        }
        const target = fraction * length;
        const index = (0, $b998d41b678ed5d1$export$2e0ae67339d5f1ac)(cumulativeLengths, target);
        if (index < 0) {
            t = (target - cumulativeLengths[-index - 2]) / (cumulativeLengths[-index - 1] - cumulativeLengths[-index - 2]);
            o = offset + (-index - 2) * stride;
        } else o = offset + index * stride;
    }
    dimension = dimension > 1 ? dimension : 2;
    dest = dest ? dest : new Array(dimension);
    for(let i = 0; i < dimension; ++i)dest[i] = o === undefined ? NaN : t === undefined ? flatCoordinates[o + i] : (0, $6b000a049d919fe5$export$3a89f8d6f6bf6c9f)(flatCoordinates[o + i], flatCoordinates[o + stride + i], t);
    return dest;
}
function $43ed5485a1d0c509$export$8f44c3c220ef6f09(flatCoordinates, offset, end, stride, m, extrapolate) {
    if (end == offset) return null;
    let coordinate;
    if (m < flatCoordinates[offset + stride - 1]) {
        if (extrapolate) {
            coordinate = flatCoordinates.slice(offset, offset + stride);
            coordinate[stride - 1] = m;
            return coordinate;
        }
        return null;
    }
    if (flatCoordinates[end - 1] < m) {
        if (extrapolate) {
            coordinate = flatCoordinates.slice(end - stride, end);
            coordinate[stride - 1] = m;
            return coordinate;
        }
        return null;
    }
    // FIXME use O(1) search
    if (m == flatCoordinates[offset + stride - 1]) return flatCoordinates.slice(offset, offset + stride);
    let lo = offset / stride;
    let hi = end / stride;
    while(lo < hi){
        const mid = lo + hi >> 1;
        if (m < flatCoordinates[(mid + 1) * stride - 1]) hi = mid;
        else lo = mid + 1;
    }
    const m0 = flatCoordinates[lo * stride - 1];
    if (m == m0) return flatCoordinates.slice((lo - 1) * stride, (lo - 1) * stride + stride);
    const m1 = flatCoordinates[(lo + 1) * stride - 1];
    const t = (m - m0) / (m1 - m0);
    coordinate = [];
    for(let i = 0; i < stride - 1; ++i)coordinate.push((0, $6b000a049d919fe5$export$3a89f8d6f6bf6c9f)(flatCoordinates[(lo - 1) * stride + i], flatCoordinates[lo * stride + i], t));
    coordinate.push(m);
    return coordinate;
}
function $43ed5485a1d0c509$export$6a3300857e9ef453(flatCoordinates, offset, ends, stride, m, extrapolate, interpolate) {
    if (interpolate) return $43ed5485a1d0c509$export$8f44c3c220ef6f09(flatCoordinates, offset, ends[ends.length - 1], stride, m, extrapolate);
    let coordinate;
    if (m < flatCoordinates[stride - 1]) {
        if (extrapolate) {
            coordinate = flatCoordinates.slice(0, stride);
            coordinate[stride - 1] = m;
            return coordinate;
        }
        return null;
    }
    if (flatCoordinates[flatCoordinates.length - 1] < m) {
        if (extrapolate) {
            coordinate = flatCoordinates.slice(flatCoordinates.length - stride);
            coordinate[stride - 1] = m;
            return coordinate;
        }
        return null;
    }
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        if (offset == end) continue;
        if (m < flatCoordinates[offset + stride - 1]) return null;
        if (m <= flatCoordinates[end - 1]) return $43ed5485a1d0c509$export$8f44c3c220ef6f09(flatCoordinates, offset, end, stride, m, false);
        offset = end;
    }
    return null;
}



/**
 * @module ol/geom/flat/length
 */ /**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @return {number} Length.
 */ function $bf04349d827c1d16$export$153f8c6b4d8caebc(flatCoordinates, offset, end, stride) {
    let x1 = flatCoordinates[offset];
    let y1 = flatCoordinates[offset + 1];
    let length = 0;
    for(let i = offset + stride; i < end; i += stride){
        const x2 = flatCoordinates[i];
        const y2 = flatCoordinates[i + 1];
        length += Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
        x1 = x2;
        y1 = y2;
    }
    return length;
}
function $bf04349d827c1d16$export$2bbb4f6f727a75c2(flatCoordinates, offset, end, stride) {
    let perimeter = $bf04349d827c1d16$export$153f8c6b4d8caebc(flatCoordinates, offset, end, stride);
    const dx = flatCoordinates[end - stride] - flatCoordinates[offset];
    const dy = flatCoordinates[end - stride + 1] - flatCoordinates[offset + 1];
    perimeter += Math.sqrt(dx * dx + dy * dy);
    return perimeter;
}




/**
 * @classdesc
 * Linestring geometry.
 *
 * @api
 */ class $292e4002746c8223$var$LineString extends (0, $c76e993e57efc8c4$export$2e2bcd8739ae039) {
    /**
   * @param {Array<import("../coordinate.js").Coordinate>|Array<number>} coordinates Coordinates.
   *     For internal use, flat coordinates in combination with `layout` are also accepted.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   */ constructor(coordinates, layout){
        super();
        /**
     * @private
     * @type {import("../coordinate.js").Coordinate|null}
     */ this.flatMidpoint_ = null;
        /**
     * @private
     * @type {number}
     */ this.flatMidpointRevision_ = -1;
        /**
     * @private
     * @type {number}
     */ this.maxDelta_ = -1;
        /**
     * @private
     * @type {number}
     */ this.maxDeltaRevision_ = -1;
        if (layout !== undefined && !Array.isArray(coordinates[0])) this.setFlatCoordinates(layout, /** @type {Array<number>} */ coordinates);
        else this.setCoordinates(/** @type {Array<import("../coordinate.js").Coordinate>} */ coordinates, layout);
    }
    /**
   * Append the passed coordinate to the coordinates of the linestring.
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @api
   */ appendCoordinate(coordinate) {
        (0, $b998d41b678ed5d1$export$8b58be045bf06082)(this.flatCoordinates, coordinate);
        this.changed();
    }
    /**
   * Make a complete copy of the geometry.
   * @return {!LineString} Clone.
   * @api
   * @override
   */ clone() {
        const lineString = new $292e4002746c8223$var$LineString(this.flatCoordinates.slice(), this.layout);
        lineString.applyProperties(this);
        return lineString;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   * @override
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < (0, $6da4c8ed3074c92b$export$cbe64c389534206f)(this.getExtent(), x, y)) return minSquaredDistance;
        if (this.maxDeltaRevision_ != this.getRevision()) {
            this.maxDelta_ = Math.sqrt((0, $bf5604c1b8258b71$export$bc2eb611ddf80103)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, 0));
            this.maxDeltaRevision_ = this.getRevision();
        }
        return (0, $bf5604c1b8258b71$export$4adc8e5135fb44c)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, this.maxDelta_, false, x, y, closestPoint, minSquaredDistance);
    }
    /**
   * Iterate over each segment, calling the provided callback.
   * If the callback returns a truthy value the function returns that
   * value immediately. Otherwise the function returns `false`.
   *
   * @param {function(this: S, import("../coordinate.js").Coordinate, import("../coordinate.js").Coordinate): T} callback Function
   *     called for each segment. The function will receive two arguments, the start and end coordinates of the segment.
   * @return {T|boolean} Value.
   * @template T,S
   * @api
   */ forEachSegment(callback) {
        return (0, $3e64078bffae1cbd$export$4b80e395e36b5a56)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, callback);
    }
    /**
   * Returns the coordinate at `m` using linear interpolation, or `null` if no
   * such coordinate exists.
   *
   * `extrapolate` controls extrapolation beyond the range of Ms in the
   * MultiLineString. If `extrapolate` is `true` then Ms less than the first
   * M will return the first coordinate and Ms greater than the last M will
   * return the last coordinate.
   *
   * @param {number} m M.
   * @param {boolean} [extrapolate] Extrapolate. Default is `false`.
   * @return {import("../coordinate.js").Coordinate|null} Coordinate.
   * @api
   */ getCoordinateAtM(m, extrapolate) {
        if (this.layout != 'XYM' && this.layout != 'XYZM') return null;
        extrapolate = extrapolate !== undefined ? extrapolate : false;
        return (0, $43ed5485a1d0c509$export$8f44c3c220ef6f09)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, m, extrapolate);
    }
    /**
   * Return the coordinates of the linestring.
   * @return {Array<import("../coordinate.js").Coordinate>} Coordinates.
   * @api
   * @override
   */ getCoordinates() {
        return (0, $5454470599558ddd$export$9c0934e4e9c3f61e)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride);
    }
    /**
   * Return the coordinate at the provided fraction along the linestring.
   * The `fraction` is a number between 0 and 1, where 0 is the start of the
   * linestring and 1 is the end.
   * @param {number} fraction Fraction.
   * @param {import("../coordinate.js").Coordinate} [dest] Optional coordinate whose values will
   *     be modified. If not provided, a new coordinate will be returned.
   * @return {import("../coordinate.js").Coordinate} Coordinate of the interpolated point.
   * @api
   */ getCoordinateAt(fraction, dest) {
        return (0, $43ed5485a1d0c509$export$687ff82efd78795b)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, fraction, dest, this.stride);
    }
    /**
   * Return the length of the linestring on projected plane.
   * @return {number} Length (on projected plane).
   * @api
   */ getLength() {
        return (0, $bf04349d827c1d16$export$153f8c6b4d8caebc)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride);
    }
    /**
   * @return {Array<number>} Flat midpoint.
   */ getFlatMidpoint() {
        if (this.flatMidpointRevision_ != this.getRevision()) {
            this.flatMidpoint_ = this.getCoordinateAt(0.5, this.flatMidpoint_ ?? undefined);
            this.flatMidpointRevision_ = this.getRevision();
        }
        return /** @type {Array<number>} */ this.flatMidpoint_;
    }
    /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {LineString} Simplified LineString.
   * @protected
   * @override
   */ getSimplifiedGeometryInternal(squaredTolerance) {
        /** @type {Array<number>} */ const simplifiedFlatCoordinates = [];
        simplifiedFlatCoordinates.length = (0, $8780aae6970f5f65$export$ef693d1572e64fb8)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, squaredTolerance, simplifiedFlatCoordinates, 0);
        return new $292e4002746c8223$var$LineString(simplifiedFlatCoordinates, 'XY');
    }
    /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   * @override
   */ getType() {
        return 'LineString';
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   * @override
   */ intersectsExtent(extent) {
        return (0, $acee589e5b390c5c$export$40d8d71841a3d779)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, extent, this.getExtent());
    }
    /**
   * Set the coordinates of the linestring.
   * @param {!Array<import("../coordinate.js").Coordinate>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   * @override
   */ setCoordinates(coordinates, layout) {
        this.setLayout(layout, coordinates, 1);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        this.flatCoordinates.length = (0, $6b086aa46281540d$export$5c4daf67e03c190f)(this.flatCoordinates, 0, coordinates, this.stride);
        this.changed();
    }
}
var $292e4002746c8223$export$2e2bcd8739ae039 = $292e4002746c8223$var$LineString;


/**
 * @module ol/geom/MultiLineString
 */ 










/**
 * @classdesc
 * Multi-linestring geometry.
 *
 * @api
 */ class $b4c0e2e13beea46e$var$MultiLineString extends (0, $c76e993e57efc8c4$export$2e2bcd8739ae039) {
    /**
   * @param {Array<Array<import("../coordinate.js").Coordinate>|LineString>|Array<number>} coordinates
   *     Coordinates or LineString geometries. (For internal use, flat coordinates in
   *     combination with `layout` and `ends` are also accepted.)
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @param {Array<number>} [ends] Flat coordinate ends for internal use.
   */ constructor(coordinates, layout, ends){
        super();
        /**
     * @type {Array<number>}
     * @private
     */ this.ends_ = [];
        /**
     * @private
     * @type {number}
     */ this.maxDelta_ = -1;
        /**
     * @private
     * @type {number}
     */ this.maxDeltaRevision_ = -1;
        if (Array.isArray(coordinates[0])) this.setCoordinates(/** @type {Array<Array<import("../coordinate.js").Coordinate>>} */ coordinates, layout);
        else if (layout !== undefined && ends) {
            this.setFlatCoordinates(layout, /** @type {Array<number>} */ coordinates);
            this.ends_ = ends;
        } else {
            const lineStrings = /** @type {Array<LineString>} */ coordinates;
            /** @type {Array<number>} */ const flatCoordinates = [];
            const ends = [];
            for(let i = 0, ii = lineStrings.length; i < ii; ++i){
                const lineString = lineStrings[i];
                (0, $b998d41b678ed5d1$export$8b58be045bf06082)(flatCoordinates, lineString.getFlatCoordinates());
                ends.push(flatCoordinates.length);
            }
            const layout = lineStrings.length === 0 ? this.getLayout() : lineStrings[0].getLayout();
            this.setFlatCoordinates(layout, flatCoordinates);
            this.ends_ = ends;
        }
    }
    /**
   * Append the passed linestring to the multilinestring.
   * @param {LineString} lineString LineString.
   * @api
   */ appendLineString(lineString) {
        (0, $b998d41b678ed5d1$export$8b58be045bf06082)(this.flatCoordinates, lineString.getFlatCoordinates().slice());
        this.ends_.push(this.flatCoordinates.length);
        this.changed();
    }
    /**
   * Make a complete copy of the geometry.
   * @return {!MultiLineString} Clone.
   * @api
   * @override
   */ clone() {
        const multiLineString = new $b4c0e2e13beea46e$var$MultiLineString(this.flatCoordinates.slice(), this.layout, this.ends_.slice());
        multiLineString.applyProperties(this);
        return multiLineString;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   * @override
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < (0, $6da4c8ed3074c92b$export$cbe64c389534206f)(this.getExtent(), x, y)) return minSquaredDistance;
        if (this.maxDeltaRevision_ != this.getRevision()) {
            this.maxDelta_ = Math.sqrt((0, $bf5604c1b8258b71$export$fbf31c8f2668ed5a)(this.flatCoordinates, 0, this.ends_, this.stride, 0));
            this.maxDeltaRevision_ = this.getRevision();
        }
        return (0, $bf5604c1b8258b71$export$5a48a0eefcf14992)(this.flatCoordinates, 0, this.ends_, this.stride, this.maxDelta_, false, x, y, closestPoint, minSquaredDistance);
    }
    /**
   * Returns the coordinate at `m` using linear interpolation, or `null` if no
   * such coordinate exists.
   *
   * `extrapolate` controls extrapolation beyond the range of Ms in the
   * MultiLineString. If `extrapolate` is `true` then Ms less than the first
   * M will return the first coordinate and Ms greater than the last M will
   * return the last coordinate.
   *
   * `interpolate` controls interpolation between consecutive LineStrings
   * within the MultiLineString. If `interpolate` is `true` the coordinates
   * will be linearly interpolated between the last coordinate of one LineString
   * and the first coordinate of the next LineString.  If `interpolate` is
   * `false` then the function will return `null` for Ms falling between
   * LineStrings.
   *
   * @param {number} m M.
   * @param {boolean} [extrapolate] Extrapolate. Default is `false`.
   * @param {boolean} [interpolate] Interpolate. Default is `false`.
   * @return {import("../coordinate.js").Coordinate|null} Coordinate.
   * @api
   */ getCoordinateAtM(m, extrapolate, interpolate) {
        if (this.layout != 'XYM' && this.layout != 'XYZM' || this.flatCoordinates.length === 0) return null;
        extrapolate = extrapolate !== undefined ? extrapolate : false;
        interpolate = interpolate !== undefined ? interpolate : false;
        return (0, $43ed5485a1d0c509$export$6a3300857e9ef453)(this.flatCoordinates, 0, this.ends_, this.stride, m, extrapolate, interpolate);
    }
    /**
   * Return the coordinates of the multilinestring.
   * @return {Array<Array<import("../coordinate.js").Coordinate>>} Coordinates.
   * @api
   * @override
   */ getCoordinates() {
        return (0, $5454470599558ddd$export$cbb9596fc0f40db2)(this.flatCoordinates, 0, this.ends_, this.stride);
    }
    /**
   * @return {Array<number>} Ends.
   */ getEnds() {
        return this.ends_;
    }
    /**
   * Return the linestring at the specified index.
   * @param {number} index Index.
   * @return {LineString} LineString.
   * @api
   */ getLineString(index) {
        if (index < 0 || this.ends_.length <= index) return null;
        return new (0, $292e4002746c8223$export$2e2bcd8739ae039)(this.flatCoordinates.slice(index === 0 ? 0 : this.ends_[index - 1], this.ends_[index]), this.layout);
    }
    /**
   * Return the linestrings of this multilinestring.
   * @return {Array<LineString>} LineStrings.
   * @api
   */ getLineStrings() {
        const flatCoordinates = this.flatCoordinates;
        const ends = this.ends_;
        const layout = this.layout;
        /** @type {Array<LineString>} */ const lineStrings = [];
        let offset = 0;
        for(let i = 0, ii = ends.length; i < ii; ++i){
            const end = ends[i];
            const lineString = new (0, $292e4002746c8223$export$2e2bcd8739ae039)(flatCoordinates.slice(offset, end), layout);
            lineStrings.push(lineString);
            offset = end;
        }
        return lineStrings;
    }
    /**
   * Return the sum of all line string lengths
   * @return {number} Length (on projected plane).
   * @api
   */ getLength() {
        const ends = this.ends_;
        let start = 0;
        let length = 0;
        for(let i = 0, ii = ends.length; i < ii; ++i){
            length += (0, $bf04349d827c1d16$export$153f8c6b4d8caebc)(this.flatCoordinates, start, ends[i], this.stride);
            start = ends[i];
        }
        return length;
    }
    /**
   * @return {Array<number>} Flat midpoints.
   */ getFlatMidpoints() {
        /** @type {Array<number>} */ const midpoints = [];
        const flatCoordinates = this.flatCoordinates;
        let offset = 0;
        const ends = this.ends_;
        const stride = this.stride;
        for(let i = 0, ii = ends.length; i < ii; ++i){
            const end = ends[i];
            const midpoint = (0, $43ed5485a1d0c509$export$687ff82efd78795b)(flatCoordinates, offset, end, stride, 0.5);
            (0, $b998d41b678ed5d1$export$8b58be045bf06082)(midpoints, midpoint);
            offset = end;
        }
        return midpoints;
    }
    /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {MultiLineString} Simplified MultiLineString.
   * @protected
   * @override
   */ getSimplifiedGeometryInternal(squaredTolerance) {
        /** @type {Array<number>} */ const simplifiedFlatCoordinates = [];
        /** @type {Array<number>} */ const simplifiedEnds = [];
        simplifiedFlatCoordinates.length = (0, $8780aae6970f5f65$export$cedb9900c0b225c2)(this.flatCoordinates, 0, this.ends_, this.stride, squaredTolerance, simplifiedFlatCoordinates, 0, simplifiedEnds);
        return new $b4c0e2e13beea46e$var$MultiLineString(simplifiedFlatCoordinates, 'XY', simplifiedEnds);
    }
    /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   * @override
   */ getType() {
        return 'MultiLineString';
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   * @override
   */ intersectsExtent(extent) {
        return (0, $acee589e5b390c5c$export$fdb1d8e850bf7937)(this.flatCoordinates, 0, this.ends_, this.stride, extent);
    }
    /**
   * Set the coordinates of the multilinestring.
   * @param {!Array<Array<import("../coordinate.js").Coordinate>>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   * @override
   */ setCoordinates(coordinates, layout) {
        this.setLayout(layout, coordinates, 2);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        const ends = (0, $6b086aa46281540d$export$47c3746a74384d45)(this.flatCoordinates, 0, coordinates, this.stride, this.ends_);
        this.flatCoordinates.length = ends.length === 0 ? 0 : ends[ends.length - 1];
        this.changed();
    }
}
var $b4c0e2e13beea46e$export$2e2bcd8739ae039 = $b4c0e2e13beea46e$var$MultiLineString;



/**
 * @module ol/geom/MultiPolygon
 */ 





/**
 * @module ol/geom/flat/center
 */ 
function $9825fadaf3b68c4e$export$78e139679ca7205(flatCoordinates, offset, endss, stride) {
    const flatCenters = [];
    let extent = (0, $6da4c8ed3074c92b$export$fe201bb3bbe031e9)();
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        extent = (0, $6da4c8ed3074c92b$export$be0ab0bf96ca59ca)(flatCoordinates, offset, ends[0], stride);
        flatCenters.push((extent[0] + extent[2]) / 2, (extent[1] + extent[3]) / 2);
        offset = ends[ends.length - 1];
    }
    return flatCenters;
}










/**
 * @classdesc
 * Multi-polygon geometry.
 *
 * @api
 */ class $f73f35eb6af8b987$var$MultiPolygon extends (0, $c76e993e57efc8c4$export$2e2bcd8739ae039) {
    /**
   * @param {Array<Array<Array<import("../coordinate.js").Coordinate>>|Polygon>|Array<number>} coordinates Coordinates.
   *     For internal use, flat coordinates in combination with `layout` and `endss` are also accepted.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @param {Array<Array<number>>} [endss] Array of ends for internal use with flat coordinates.
   */ constructor(coordinates, layout, endss){
        super();
        /**
     * @type {Array<Array<number>>}
     * @private
     */ this.endss_ = [];
        /**
     * @private
     * @type {number}
     */ this.flatInteriorPointsRevision_ = -1;
        /**
     * @private
     * @type {Array<number>|null}
     */ this.flatInteriorPoints_ = null;
        /**
     * @private
     * @type {number}
     */ this.maxDelta_ = -1;
        /**
     * @private
     * @type {number}
     */ this.maxDeltaRevision_ = -1;
        /**
     * @private
     * @type {number}
     */ this.orientedRevision_ = -1;
        /**
     * @private
     * @type {Array<number>|null}
     */ this.orientedFlatCoordinates_ = null;
        if (!endss && !Array.isArray(coordinates[0])) {
            const polygons = /** @type {Array<Polygon>} */ coordinates;
            /** @type {Array<number>} */ const flatCoordinates = [];
            const thisEndss = [];
            for(let i = 0, ii = polygons.length; i < ii; ++i){
                const polygon = polygons[i];
                const offset = flatCoordinates.length;
                const ends = polygon.getEnds();
                for(let j = 0, jj = ends.length; j < jj; ++j)ends[j] += offset;
                (0, $b998d41b678ed5d1$export$8b58be045bf06082)(flatCoordinates, polygon.getFlatCoordinates());
                thisEndss.push(ends);
            }
            layout = polygons.length === 0 ? this.getLayout() : polygons[0].getLayout();
            coordinates = flatCoordinates;
            endss = thisEndss;
        }
        if (layout !== undefined && endss) {
            this.setFlatCoordinates(layout, /** @type {Array<number>} */ coordinates);
            this.endss_ = endss;
        } else this.setCoordinates(/** @type {Array<Array<Array<import("../coordinate.js").Coordinate>>>} */ coordinates, layout);
    }
    /**
   * Append the passed polygon to this multipolygon.
   * @param {Polygon} polygon Polygon.
   * @api
   */ appendPolygon(polygon) {
        /** @type {Array<number>} */ let ends;
        if (!this.flatCoordinates) {
            this.flatCoordinates = polygon.getFlatCoordinates().slice();
            ends = polygon.getEnds().slice();
            this.endss_.push();
        } else {
            const offset = this.flatCoordinates.length;
            (0, $b998d41b678ed5d1$export$8b58be045bf06082)(this.flatCoordinates, polygon.getFlatCoordinates());
            ends = polygon.getEnds().slice();
            for(let i = 0, ii = ends.length; i < ii; ++i)ends[i] += offset;
        }
        this.endss_.push(ends);
        this.changed();
    }
    /**
   * Make a complete copy of the geometry.
   * @return {!MultiPolygon} Clone.
   * @api
   * @override
   */ clone() {
        const len = this.endss_.length;
        const newEndss = new Array(len);
        for(let i = 0; i < len; ++i)newEndss[i] = this.endss_[i].slice();
        const multiPolygon = new $f73f35eb6af8b987$var$MultiPolygon(this.flatCoordinates.slice(), this.layout, newEndss);
        multiPolygon.applyProperties(this);
        return multiPolygon;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   * @override
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < (0, $6da4c8ed3074c92b$export$cbe64c389534206f)(this.getExtent(), x, y)) return minSquaredDistance;
        if (this.maxDeltaRevision_ != this.getRevision()) {
            this.maxDelta_ = Math.sqrt((0, $bf5604c1b8258b71$export$37c18e6e7d50501a)(this.flatCoordinates, 0, this.endss_, this.stride, 0));
            this.maxDeltaRevision_ = this.getRevision();
        }
        return (0, $bf5604c1b8258b71$export$60e067685eb8f9c4)(this.getOrientedFlatCoordinates(), 0, this.endss_, this.stride, this.maxDelta_, true, x, y, closestPoint, minSquaredDistance);
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @return {boolean} Contains (x, y).
   * @override
   */ containsXY(x, y) {
        return (0, $239aa88e7a573859$export$c760d9d16cf92043)(this.getOrientedFlatCoordinates(), 0, this.endss_, this.stride, x, y);
    }
    /**
   * Return the area of the multipolygon on projected plane.
   * @return {number} Area (on projected plane).
   * @api
   */ getArea() {
        return (0, $01ff26a2f986a1d0$export$78e139679ca7205)(this.getOrientedFlatCoordinates(), 0, this.endss_, this.stride);
    }
    /**
   * Get the coordinate array for this geometry.  This array has the structure
   * of a GeoJSON coordinate array for multi-polygons.
   *
   * @param {boolean} [right] Orient coordinates according to the right-hand
   *     rule (counter-clockwise for exterior and clockwise for interior rings).
   *     If `false`, coordinates will be oriented according to the left-hand rule
   *     (clockwise for exterior and counter-clockwise for interior rings).
   *     By default, coordinate orientation will depend on how the geometry was
   *     constructed.
   * @return {Array<Array<Array<import("../coordinate.js").Coordinate>>>} Coordinates.
   * @api
   * @override
   */ getCoordinates(right) {
        let flatCoordinates;
        if (right !== undefined) {
            flatCoordinates = this.getOrientedFlatCoordinates().slice();
            (0, $7892dc06ffd23218$export$ea9ed55fc2a85010)(flatCoordinates, 0, this.endss_, this.stride, right);
        } else flatCoordinates = this.flatCoordinates;
        return (0, $5454470599558ddd$export$915c7058aeb4dfeb)(flatCoordinates, 0, this.endss_, this.stride);
    }
    /**
   * @return {Array<Array<number>>} Endss.
   */ getEndss() {
        return this.endss_;
    }
    /**
   * @return {Array<number>} Flat interior points.
   */ getFlatInteriorPoints() {
        if (this.flatInteriorPointsRevision_ != this.getRevision()) {
            const flatCenters = (0, $9825fadaf3b68c4e$export$78e139679ca7205)(this.flatCoordinates, 0, this.endss_, this.stride);
            this.flatInteriorPoints_ = (0, $2166f19777f69377$export$11463803eda8a372)(this.getOrientedFlatCoordinates(), 0, this.endss_, this.stride, flatCenters);
            this.flatInteriorPointsRevision_ = this.getRevision();
        }
        return /** @type {Array<number>} */ this.flatInteriorPoints_;
    }
    /**
   * Return the interior points as {@link module:ol/geom/MultiPoint~MultiPoint multipoint}.
   * @return {MultiPoint} Interior points as XYM coordinates, where M is
   * the length of the horizontal intersection that the point belongs to.
   * @api
   */ getInteriorPoints() {
        return new (0, $e6080c63a9451eda$export$2e2bcd8739ae039)(this.getFlatInteriorPoints().slice(), 'XYM');
    }
    /**
   * @return {Array<number>} Oriented flat coordinates.
   */ getOrientedFlatCoordinates() {
        if (this.orientedRevision_ != this.getRevision()) {
            const flatCoordinates = this.flatCoordinates;
            if ((0, $7892dc06ffd23218$export$a1d138f4bd85f4b4)(flatCoordinates, 0, this.endss_, this.stride)) this.orientedFlatCoordinates_ = flatCoordinates;
            else {
                this.orientedFlatCoordinates_ = flatCoordinates.slice();
                this.orientedFlatCoordinates_.length = (0, $7892dc06ffd23218$export$ea9ed55fc2a85010)(this.orientedFlatCoordinates_, 0, this.endss_, this.stride);
            }
            this.orientedRevision_ = this.getRevision();
        }
        return /** @type {Array<number>} */ this.orientedFlatCoordinates_;
    }
    /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {MultiPolygon} Simplified MultiPolygon.
   * @protected
   * @override
   */ getSimplifiedGeometryInternal(squaredTolerance) {
        /** @type {Array<number>} */ const simplifiedFlatCoordinates = [];
        /** @type {Array<Array<number>>} */ const simplifiedEndss = [];
        simplifiedFlatCoordinates.length = (0, $8780aae6970f5f65$export$b9acf67ef05cd17c)(this.flatCoordinates, 0, this.endss_, this.stride, Math.sqrt(squaredTolerance), simplifiedFlatCoordinates, 0, simplifiedEndss);
        return new $f73f35eb6af8b987$var$MultiPolygon(simplifiedFlatCoordinates, 'XY', simplifiedEndss);
    }
    /**
   * Return the polygon at the specified index.
   * @param {number} index Index.
   * @return {Polygon} Polygon.
   * @api
   */ getPolygon(index) {
        if (index < 0 || this.endss_.length <= index) return null;
        let offset;
        if (index === 0) offset = 0;
        else {
            const prevEnds = this.endss_[index - 1];
            offset = prevEnds[prevEnds.length - 1];
        }
        const ends = this.endss_[index].slice();
        const end = ends[ends.length - 1];
        if (offset !== 0) for(let i = 0, ii = ends.length; i < ii; ++i)ends[i] -= offset;
        return new (0, $40aa8d43bbe572bf$export$2e2bcd8739ae039)(this.flatCoordinates.slice(offset, end), this.layout, ends);
    }
    /**
   * Return the polygons of this multipolygon.
   * @return {Array<Polygon>} Polygons.
   * @api
   */ getPolygons() {
        const layout = this.layout;
        const flatCoordinates = this.flatCoordinates;
        const endss = this.endss_;
        const polygons = [];
        let offset = 0;
        for(let i = 0, ii = endss.length; i < ii; ++i){
            const ends = endss[i].slice();
            const end = ends[ends.length - 1];
            if (offset !== 0) for(let j = 0, jj = ends.length; j < jj; ++j)ends[j] -= offset;
            const polygon = new (0, $40aa8d43bbe572bf$export$2e2bcd8739ae039)(flatCoordinates.slice(offset, end), layout, ends);
            polygons.push(polygon);
            offset = end;
        }
        return polygons;
    }
    /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   * @override
   */ getType() {
        return 'MultiPolygon';
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   * @override
   */ intersectsExtent(extent) {
        return (0, $acee589e5b390c5c$export$77b72fa3792f5bf0)(this.getOrientedFlatCoordinates(), 0, this.endss_, this.stride, extent);
    }
    /**
   * Set the coordinates of the multipolygon.
   * @param {!Array<Array<Array<import("../coordinate.js").Coordinate>>>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   * @override
   */ setCoordinates(coordinates, layout) {
        this.setLayout(layout, coordinates, 3);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        const endss = (0, $6b086aa46281540d$export$f9f2bb59da4accd3)(this.flatCoordinates, 0, coordinates, this.stride, this.endss_);
        if (endss.length === 0) this.flatCoordinates.length = 0;
        else {
            const lastEnds = endss[endss.length - 1];
            this.flatCoordinates.length = lastEnds.length === 0 ? 0 : lastEnds[lastEnds.length - 1];
        }
        this.changed();
    }
}
var $f73f35eb6af8b987$export$2e2bcd8739ae039 = $f73f35eb6af8b987$var$MultiPolygon;





/**
 * @module ol/layer/Vector
 */ /**
 * @module ol/renderer/canvas/VectorLayer
 */ 






/**
 * @module ol/render/canvas/BuilderGroup
 */ /**
 * @module ol/render/canvas/Builder
 */ 




/**
 * @module ol/render/VectorContext
 */ /**
 * @classdesc
 * Context for drawing geometries.  A vector context is available on render
 * events and does not need to be constructed directly.
 * @api
 */ class $eb0e5c3938110b4c$var$VectorContext {
    /**
   * Render a geometry with a custom renderer.
   *
   * @param {import("../geom/SimpleGeometry.js").default} geometry Geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {Function} renderer Renderer.
   * @param {Function} hitDetectionRenderer Renderer.
   * @param {number} [index] Render order index.
   */ drawCustom(geometry, feature, renderer, hitDetectionRenderer, index) {}
    /**
   * Render a geometry.
   *
   * @param {import("../geom/Geometry.js").default} geometry The geometry to render.
   */ drawGeometry(geometry) {}
    /**
   * Set the rendering style.
   *
   * @param {import("../style/Style.js").default} style The rendering style.
   */ setStyle(style) {}
    /**
   * @param {import("../geom/Circle.js").default} circleGeometry Circle geometry.
   * @param {import("../Feature.js").default} feature Feature.
   * @param {number} [index] Render order index.
   */ drawCircle(circleGeometry, feature, index) {}
    /**
   * @param {import("../Feature.js").default} feature Feature.
   * @param {import("../style/Style.js").default} style Style.
   * @param {number} [index] Render order index.
   */ drawFeature(feature, style, index) {}
    /**
   * @param {import("../geom/GeometryCollection.js").default} geometryCollectionGeometry Geometry collection.
   * @param {import("../Feature.js").default} feature Feature.
   * @param {number} [index] Render order index.
   */ drawGeometryCollection(geometryCollectionGeometry, feature, index) {}
    /**
   * @param {import("../geom/LineString.js").default|import("./Feature.js").default} lineStringGeometry Line string geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */ drawLineString(lineStringGeometry, feature, index) {}
    /**
   * @param {import("../geom/MultiLineString.js").default|import("./Feature.js").default} multiLineStringGeometry MultiLineString geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */ drawMultiLineString(multiLineStringGeometry, feature, index) {}
    /**
   * @param {import("../geom/MultiPoint.js").default|import("./Feature.js").default} multiPointGeometry MultiPoint geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */ drawMultiPoint(multiPointGeometry, feature, index) {}
    /**
   * @param {import("../geom/MultiPolygon.js").default} multiPolygonGeometry MultiPolygon geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */ drawMultiPolygon(multiPolygonGeometry, feature, index) {}
    /**
   * @param {import("../geom/Point.js").default|import("./Feature.js").default} pointGeometry Point geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */ drawPoint(pointGeometry, feature, index) {}
    /**
   * @param {import("../geom/Polygon.js").default|import("./Feature.js").default} polygonGeometry Polygon geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */ drawPolygon(polygonGeometry, feature, index) {}
    /**
   * @param {import("../geom/SimpleGeometry.js").default|import("./Feature.js").default} geometry Geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */ drawText(geometry, feature, index) {}
    /**
   * @param {import("../style/Fill.js").default} fillStyle Fill style.
   * @param {import("../style/Stroke.js").default} strokeStyle Stroke style.
   */ setFillStrokeStyle(fillStyle, strokeStyle) {}
    /**
   * @param {import("../style/Image.js").default} imageStyle Image style.
   * @param {import("../render/canvas.js").DeclutterImageWithText} [declutterImageWithText] Shared data for combined decluttering with a text style.
   */ setImageStyle(imageStyle, declutterImageWithText) {}
    /**
   * @param {import("../style/Text.js").default} textStyle Text style.
   * @param {import("../render/canvas.js").DeclutterImageWithText} [declutterImageWithText] Shared data for combined decluttering with an image style.
   */ setTextStyle(textStyle, declutterImageWithText) {}
}
var $eb0e5c3938110b4c$export$2e2bcd8739ae039 = $eb0e5c3938110b4c$var$VectorContext;



/**
 * @module ol/render/canvas/Instruction
 */ /**
 * @enum {number}
 */ const $cf547866e052f25b$var$Instruction = {
    BEGIN_GEOMETRY: 0,
    BEGIN_PATH: 1,
    CIRCLE: 2,
    CLOSE_PATH: 3,
    CUSTOM: 4,
    DRAW_CHARS: 5,
    DRAW_IMAGE: 6,
    END_GEOMETRY: 7,
    FILL: 8,
    MOVE_TO_LINE_TO: 9,
    SET_FILL_STYLE: 10,
    SET_STROKE_STYLE: 11,
    STROKE: 12
};
const $cf547866e052f25b$export$f21891651e408226 = [
    $cf547866e052f25b$var$Instruction.FILL
];
const $cf547866e052f25b$export$7a98aa5364d62ba8 = [
    $cf547866e052f25b$var$Instruction.STROKE
];
const $cf547866e052f25b$export$9f746cc58a899a00 = [
    $cf547866e052f25b$var$Instruction.BEGIN_PATH
];
const $cf547866e052f25b$export$89b10f327e413e71 = [
    $cf547866e052f25b$var$Instruction.CLOSE_PATH
];
var $cf547866e052f25b$export$2e2bcd8739ae039 = $cf547866e052f25b$var$Instruction;


class $2bb20f8873deb436$var$CanvasBuilder extends (0, $eb0e5c3938110b4c$export$2e2bcd8739ae039) {
    /**
   * @param {number} tolerance Tolerance.
   * @param {import("../../extent.js").Extent} maxExtent Maximum extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   */ constructor(tolerance, maxExtent, resolution, pixelRatio){
        super();
        /**
     * @protected
     * @type {number}
     */ this.tolerance = tolerance;
        /**
     * @protected
     * @const
     * @type {import("../../extent.js").Extent}
     */ this.maxExtent = maxExtent;
        /**
     * @protected
     * @type {number}
     */ this.pixelRatio = pixelRatio;
        /**
     * @protected
     * @type {number}
     */ this.maxLineWidth = 0;
        /**
     * @protected
     * @const
     * @type {number}
     */ this.resolution = resolution;
        /**
     * @private
     * @type {Array<*>}
     */ this.beginGeometryInstruction1_ = null;
        /**
     * @private
     * @type {Array<*>}
     */ this.beginGeometryInstruction2_ = null;
        /**
     * @private
     * @type {import("../../extent.js").Extent}
     */ this.bufferedMaxExtent_ = null;
        /**
     * @protected
     * @type {Array<*>}
     */ this.instructions = [];
        /**
     * @protected
     * @type {Array<number>}
     */ this.coordinates = [];
        /**
     * @private
     * @type {import("../../coordinate.js").Coordinate}
     */ this.tmpCoordinate_ = [];
        /**
     * @protected
     * @type {Array<*>}
     */ this.hitDetectionInstructions = [];
        /**
     * @protected
     * @type {import("../canvas.js").FillStrokeState}
     */ this.state = /** @type {import("../canvas.js").FillStrokeState} */ {};
    }
    /**
   * @protected
   * @param {Array<number>} dashArray Dash array.
   * @return {Array<number>} Dash array with pixel ratio applied
   */ applyPixelRatio(dashArray) {
        const pixelRatio = this.pixelRatio;
        return pixelRatio == 1 ? dashArray : dashArray.map(function(dash) {
            return dash * pixelRatio;
        });
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} stride Stride.
   * @protected
   * @return {number} My end
   */ appendFlatPointCoordinates(flatCoordinates, stride) {
        const extent = this.getBufferedMaxExtent();
        const tmpCoord = this.tmpCoordinate_;
        const coordinates = this.coordinates;
        let myEnd = coordinates.length;
        for(let i = 0, ii = flatCoordinates.length; i < ii; i += stride){
            tmpCoord[0] = flatCoordinates[i];
            tmpCoord[1] = flatCoordinates[i + 1];
            if ((0, $6da4c8ed3074c92b$export$ac68c24d37ca240f)(extent, tmpCoord)) {
                coordinates[myEnd++] = tmpCoord[0];
                coordinates[myEnd++] = tmpCoord[1];
            }
        }
        return myEnd;
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {number} end End.
   * @param {number} stride Stride.
   * @param {boolean} closed Last input coordinate equals first.
   * @param {boolean} skipFirst Skip first coordinate.
   * @protected
   * @return {number} My end.
   */ appendFlatLineCoordinates(flatCoordinates, offset, end, stride, closed, skipFirst) {
        const coordinates = this.coordinates;
        let myEnd = coordinates.length;
        const extent = this.getBufferedMaxExtent();
        if (skipFirst) offset += stride;
        let lastXCoord = flatCoordinates[offset];
        let lastYCoord = flatCoordinates[offset + 1];
        const nextCoord = this.tmpCoordinate_;
        let skipped = true;
        let i, lastRel, nextRel;
        for(i = offset + stride; i < end; i += stride){
            nextCoord[0] = flatCoordinates[i];
            nextCoord[1] = flatCoordinates[i + 1];
            nextRel = (0, $6da4c8ed3074c92b$export$f97905ead28c61a8)(extent, nextCoord);
            if (nextRel !== lastRel) {
                if (skipped) {
                    coordinates[myEnd++] = lastXCoord;
                    coordinates[myEnd++] = lastYCoord;
                    skipped = false;
                }
                coordinates[myEnd++] = nextCoord[0];
                coordinates[myEnd++] = nextCoord[1];
            } else if (nextRel === (0, $dab4245bc22b806c$export$2e2bcd8739ae039).INTERSECTING) {
                coordinates[myEnd++] = nextCoord[0];
                coordinates[myEnd++] = nextCoord[1];
                skipped = false;
            } else skipped = true;
            lastXCoord = nextCoord[0];
            lastYCoord = nextCoord[1];
            lastRel = nextRel;
        }
        // Last coordinate equals first or only one point to append:
        if (closed && skipped || i === offset + stride) {
            coordinates[myEnd++] = lastXCoord;
            coordinates[myEnd++] = lastYCoord;
        }
        return myEnd;
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {Array<number>} ends Ends.
   * @param {number} stride Stride.
   * @param {Array<number>} builderEnds Builder ends.
   * @return {number} Offset.
   */ drawCustomCoordinates_(flatCoordinates, offset, ends, stride, builderEnds) {
        for(let i = 0, ii = ends.length; i < ii; ++i){
            const end = ends[i];
            const builderEnd = this.appendFlatLineCoordinates(flatCoordinates, offset, end, stride, false, false);
            builderEnds.push(builderEnd);
            offset = end;
        }
        return offset;
    }
    /**
   * @param {import("../../geom/SimpleGeometry.js").default} geometry Geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {Function} renderer Renderer.
   * @param {Function} hitDetectionRenderer Renderer.
   * @param {number} [index] Render order index.
   * @override
   */ drawCustom(geometry, feature, renderer, hitDetectionRenderer, index) {
        this.beginGeometry(geometry, feature, index);
        const type = geometry.getType();
        const stride = geometry.getStride();
        const builderBegin = this.coordinates.length;
        let flatCoordinates, builderEnd, builderEnds, builderEndss;
        let offset;
        switch(type){
            case 'MultiPolygon':
                flatCoordinates = /** @type {import("../../geom/MultiPolygon.js").default} */ geometry.getOrientedFlatCoordinates();
                builderEndss = [];
                const endss = /** @type {import("../../geom/MultiPolygon.js").default} */ geometry.getEndss();
                offset = 0;
                for(let i = 0, ii = endss.length; i < ii; ++i){
                    const myEnds = [];
                    offset = this.drawCustomCoordinates_(flatCoordinates, offset, endss[i], stride, myEnds);
                    builderEndss.push(myEnds);
                }
                this.instructions.push([
                    (0, $cf547866e052f25b$export$2e2bcd8739ae039).CUSTOM,
                    builderBegin,
                    builderEndss,
                    geometry,
                    renderer,
                    (0, $5454470599558ddd$export$915c7058aeb4dfeb),
                    index
                ]);
                this.hitDetectionInstructions.push([
                    (0, $cf547866e052f25b$export$2e2bcd8739ae039).CUSTOM,
                    builderBegin,
                    builderEndss,
                    geometry,
                    hitDetectionRenderer || renderer,
                    (0, $5454470599558ddd$export$915c7058aeb4dfeb),
                    index
                ]);
                break;
            case 'Polygon':
            case 'MultiLineString':
                builderEnds = [];
                flatCoordinates = type == 'Polygon' ? /** @type {import("../../geom/Polygon.js").default} */ geometry.getOrientedFlatCoordinates() : geometry.getFlatCoordinates();
                offset = this.drawCustomCoordinates_(flatCoordinates, 0, /** @type {import("../../geom/Polygon.js").default|import("../../geom/MultiLineString.js").default} */ geometry.getEnds(), stride, builderEnds);
                this.instructions.push([
                    (0, $cf547866e052f25b$export$2e2bcd8739ae039).CUSTOM,
                    builderBegin,
                    builderEnds,
                    geometry,
                    renderer,
                    (0, $5454470599558ddd$export$cbb9596fc0f40db2),
                    index
                ]);
                this.hitDetectionInstructions.push([
                    (0, $cf547866e052f25b$export$2e2bcd8739ae039).CUSTOM,
                    builderBegin,
                    builderEnds,
                    geometry,
                    hitDetectionRenderer || renderer,
                    (0, $5454470599558ddd$export$cbb9596fc0f40db2),
                    index
                ]);
                break;
            case 'LineString':
            case 'Circle':
                flatCoordinates = geometry.getFlatCoordinates();
                builderEnd = this.appendFlatLineCoordinates(flatCoordinates, 0, flatCoordinates.length, stride, false, false);
                this.instructions.push([
                    (0, $cf547866e052f25b$export$2e2bcd8739ae039).CUSTOM,
                    builderBegin,
                    builderEnd,
                    geometry,
                    renderer,
                    (0, $5454470599558ddd$export$9c0934e4e9c3f61e),
                    index
                ]);
                this.hitDetectionInstructions.push([
                    (0, $cf547866e052f25b$export$2e2bcd8739ae039).CUSTOM,
                    builderBegin,
                    builderEnd,
                    geometry,
                    hitDetectionRenderer || renderer,
                    (0, $5454470599558ddd$export$9c0934e4e9c3f61e),
                    index
                ]);
                break;
            case 'MultiPoint':
                flatCoordinates = geometry.getFlatCoordinates();
                builderEnd = this.appendFlatPointCoordinates(flatCoordinates, stride);
                if (builderEnd > builderBegin) {
                    this.instructions.push([
                        (0, $cf547866e052f25b$export$2e2bcd8739ae039).CUSTOM,
                        builderBegin,
                        builderEnd,
                        geometry,
                        renderer,
                        (0, $5454470599558ddd$export$9c0934e4e9c3f61e),
                        index
                    ]);
                    this.hitDetectionInstructions.push([
                        (0, $cf547866e052f25b$export$2e2bcd8739ae039).CUSTOM,
                        builderBegin,
                        builderEnd,
                        geometry,
                        hitDetectionRenderer || renderer,
                        (0, $5454470599558ddd$export$9c0934e4e9c3f61e),
                        index
                    ]);
                }
                break;
            case 'Point':
                flatCoordinates = geometry.getFlatCoordinates();
                this.coordinates.push(flatCoordinates[0], flatCoordinates[1]);
                builderEnd = this.coordinates.length;
                this.instructions.push([
                    (0, $cf547866e052f25b$export$2e2bcd8739ae039).CUSTOM,
                    builderBegin,
                    builderEnd,
                    geometry,
                    renderer,
                    undefined,
                    index
                ]);
                this.hitDetectionInstructions.push([
                    (0, $cf547866e052f25b$export$2e2bcd8739ae039).CUSTOM,
                    builderBegin,
                    builderEnd,
                    geometry,
                    hitDetectionRenderer || renderer,
                    undefined,
                    index
                ]);
                break;
            default:
        }
        this.endGeometry(feature);
    }
    /**
   * @protected
   * @param {import("../../geom/Geometry").default|import("../Feature.js").default} geometry The geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} index Render order index
   */ beginGeometry(geometry, feature, index) {
        this.beginGeometryInstruction1_ = [
            (0, $cf547866e052f25b$export$2e2bcd8739ae039).BEGIN_GEOMETRY,
            feature,
            0,
            geometry,
            index
        ];
        this.instructions.push(this.beginGeometryInstruction1_);
        this.beginGeometryInstruction2_ = [
            (0, $cf547866e052f25b$export$2e2bcd8739ae039).BEGIN_GEOMETRY,
            feature,
            0,
            geometry,
            index
        ];
        this.hitDetectionInstructions.push(this.beginGeometryInstruction2_);
    }
    /**
   * @return {import("../canvas.js").SerializableInstructions} the serializable instructions.
   */ finish() {
        return {
            instructions: this.instructions,
            hitDetectionInstructions: this.hitDetectionInstructions,
            coordinates: this.coordinates
        };
    }
    /**
   * Reverse the hit detection instructions.
   */ reverseHitDetectionInstructions() {
        const hitDetectionInstructions = this.hitDetectionInstructions;
        // step 1 - reverse array
        hitDetectionInstructions.reverse();
        // step 2 - reverse instructions within geometry blocks
        let i;
        const n = hitDetectionInstructions.length;
        let instruction;
        let type;
        let begin = -1;
        for(i = 0; i < n; ++i){
            instruction = hitDetectionInstructions[i];
            type = /** @type {import("./Instruction.js").default} */ instruction[0];
            if (type == (0, $cf547866e052f25b$export$2e2bcd8739ae039).END_GEOMETRY) begin = i;
            else if (type == (0, $cf547866e052f25b$export$2e2bcd8739ae039).BEGIN_GEOMETRY) {
                instruction[2] = i;
                (0, $b998d41b678ed5d1$export$292cfa960964f0e0)(this.hitDetectionInstructions, begin, i);
                begin = -1;
            }
        }
    }
    /**
   * @param {import("../../style/Fill.js").default} fillStyle Fill style.
   * @param {import('../canvas.js').FillStrokeState} [state] State.
   * @return {import('../canvas.js').FillStrokeState} State.
   */ fillStyleToState(fillStyle, state = /** @type {import('../canvas.js').FillStrokeState} */ {}) {
        if (fillStyle) {
            const fillStyleColor = fillStyle.getColor();
            state.fillPatternScale = fillStyleColor && typeof fillStyleColor === 'object' && 'src' in fillStyleColor ? this.pixelRatio : 1;
            state.fillStyle = (0, $e0807f400ec9a0a9$export$dc5b1400ac3a10a8)(fillStyleColor ? fillStyleColor : (0, $d4aabc5c971073f1$export$c495d52ee3fd74b2));
        } else state.fillStyle = undefined;
        return state;
    }
    /**
   * @param {import("../../style/Stroke.js").default} strokeStyle Stroke style.
   * @param {import("../canvas.js").FillStrokeState} state State.
   * @return {import("../canvas.js").FillStrokeState} State.
   */ strokeStyleToState(strokeStyle, state = /** @type {import('../canvas.js').FillStrokeState} */ {}) {
        if (strokeStyle) {
            const strokeStyleColor = strokeStyle.getColor();
            state.strokeStyle = (0, $e0807f400ec9a0a9$export$dc5b1400ac3a10a8)(strokeStyleColor ? strokeStyleColor : (0, $d4aabc5c971073f1$export$1eb2eaecacf2031e));
            const strokeStyleLineCap = strokeStyle.getLineCap();
            state.lineCap = strokeStyleLineCap !== undefined ? strokeStyleLineCap : (0, $d4aabc5c971073f1$export$17bd0c38d6ae694e);
            const strokeStyleLineDash = strokeStyle.getLineDash();
            state.lineDash = strokeStyleLineDash ? strokeStyleLineDash.slice() : (0, $d4aabc5c971073f1$export$e21b4112fdc612fc);
            const strokeStyleLineDashOffset = strokeStyle.getLineDashOffset();
            state.lineDashOffset = strokeStyleLineDashOffset ? strokeStyleLineDashOffset : (0, $d4aabc5c971073f1$export$e06efc2409049f76);
            const strokeStyleLineJoin = strokeStyle.getLineJoin();
            state.lineJoin = strokeStyleLineJoin !== undefined ? strokeStyleLineJoin : (0, $d4aabc5c971073f1$export$365eb9648cf19bd0);
            const strokeStyleWidth = strokeStyle.getWidth();
            state.lineWidth = strokeStyleWidth !== undefined ? strokeStyleWidth : (0, $d4aabc5c971073f1$export$79661f132c62010e);
            const strokeStyleMiterLimit = strokeStyle.getMiterLimit();
            state.miterLimit = strokeStyleMiterLimit !== undefined ? strokeStyleMiterLimit : (0, $d4aabc5c971073f1$export$80c1c01844597b7b);
            if (state.lineWidth > this.maxLineWidth) {
                this.maxLineWidth = state.lineWidth;
                // invalidate the buffered max extent cache
                this.bufferedMaxExtent_ = null;
            }
        } else {
            state.strokeStyle = undefined;
            state.lineCap = undefined;
            state.lineDash = null;
            state.lineDashOffset = undefined;
            state.lineJoin = undefined;
            state.lineWidth = undefined;
            state.miterLimit = undefined;
        }
        return state;
    }
    /**
   * @param {import("../../style/Fill.js").default} fillStyle Fill style.
   * @param {import("../../style/Stroke.js").default} strokeStyle Stroke style.
   * @override
   */ setFillStrokeStyle(fillStyle, strokeStyle) {
        const state = this.state;
        this.fillStyleToState(fillStyle, state);
        this.strokeStyleToState(strokeStyle, state);
    }
    /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   * @return {Array<*>} Fill instruction.
   */ createFill(state) {
        const fillStyle = state.fillStyle;
        /** @type {Array<*>} */ const fillInstruction = [
            (0, $cf547866e052f25b$export$2e2bcd8739ae039).SET_FILL_STYLE,
            fillStyle
        ];
        if (typeof fillStyle !== 'string') // Fill is a pattern or gradient - align and scale it!
        fillInstruction.push(state.fillPatternScale);
        return fillInstruction;
    }
    /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   */ applyStroke(state) {
        this.instructions.push(this.createStroke(state));
    }
    /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   * @return {Array<*>} Stroke instruction.
   */ createStroke(state) {
        return [
            (0, $cf547866e052f25b$export$2e2bcd8739ae039).SET_STROKE_STYLE,
            state.strokeStyle,
            state.lineWidth * this.pixelRatio,
            state.lineCap,
            state.lineJoin,
            state.miterLimit,
            state.lineDash ? this.applyPixelRatio(state.lineDash) : null,
            state.lineDashOffset * this.pixelRatio
        ];
    }
    /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   * @param {function(this:CanvasBuilder, import("../canvas.js").FillStrokeState):Array<*>} createFill Create fill.
   */ updateFillStyle(state, createFill) {
        const fillStyle = state.fillStyle;
        if (typeof fillStyle !== 'string' || state.currentFillStyle != fillStyle) {
            this.instructions.push(createFill.call(this, state));
            state.currentFillStyle = fillStyle;
        }
    }
    /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   * @param {function(this:CanvasBuilder, import("../canvas.js").FillStrokeState): void} applyStroke Apply stroke.
   */ updateStrokeStyle(state, applyStroke) {
        const strokeStyle = state.strokeStyle;
        const lineCap = state.lineCap;
        const lineDash = state.lineDash;
        const lineDashOffset = state.lineDashOffset;
        const lineJoin = state.lineJoin;
        const lineWidth = state.lineWidth;
        const miterLimit = state.miterLimit;
        if (state.currentStrokeStyle != strokeStyle || state.currentLineCap != lineCap || lineDash != state.currentLineDash && !(0, $b998d41b678ed5d1$export$e9bab7fafb253603)(state.currentLineDash, lineDash) || state.currentLineDashOffset != lineDashOffset || state.currentLineJoin != lineJoin || state.currentLineWidth != lineWidth || state.currentMiterLimit != miterLimit) {
            applyStroke.call(this, state);
            state.currentStrokeStyle = strokeStyle;
            state.currentLineCap = lineCap;
            state.currentLineDash = lineDash;
            state.currentLineDashOffset = lineDashOffset;
            state.currentLineJoin = lineJoin;
            state.currentLineWidth = lineWidth;
            state.currentMiterLimit = miterLimit;
        }
    }
    /**
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   */ endGeometry(feature) {
        this.beginGeometryInstruction1_[2] = this.instructions.length;
        this.beginGeometryInstruction1_ = null;
        this.beginGeometryInstruction2_[2] = this.hitDetectionInstructions.length;
        this.beginGeometryInstruction2_ = null;
        const endGeometryInstruction = [
            (0, $cf547866e052f25b$export$2e2bcd8739ae039).END_GEOMETRY,
            feature
        ];
        this.instructions.push(endGeometryInstruction);
        this.hitDetectionInstructions.push(endGeometryInstruction);
    }
    /**
   * Get the buffered rendering extent.  Rendering will be clipped to the extent
   * provided to the constructor.  To account for symbolizers that may intersect
   * this extent, we calculate a buffered extent (e.g. based on stroke width).
   * @return {import("../../extent.js").Extent} The buffered rendering extent.
   * @protected
   */ getBufferedMaxExtent() {
        if (!this.bufferedMaxExtent_) {
            this.bufferedMaxExtent_ = (0, $6da4c8ed3074c92b$export$9cd59f9826255e47)(this.maxExtent);
            if (this.maxLineWidth > 0) {
                const width = this.resolution * (this.maxLineWidth + 1) / 2;
                (0, $6da4c8ed3074c92b$export$ab1029bcae9ddb4a)(this.bufferedMaxExtent_, width, this.bufferedMaxExtent_);
            }
        }
        return this.bufferedMaxExtent_;
    }
}
var $2bb20f8873deb436$export$2e2bcd8739ae039 = $2bb20f8873deb436$var$CanvasBuilder;


/**
 * @module ol/render/canvas/ImageBuilder
 */ 


class $b652f9dd73b29cfe$var$CanvasImageBuilder extends (0, $2bb20f8873deb436$export$2e2bcd8739ae039) {
    /**
   * @param {number} tolerance Tolerance.
   * @param {import("../../extent.js").Extent} maxExtent Maximum extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   */ constructor(tolerance, maxExtent, resolution, pixelRatio){
        super(tolerance, maxExtent, resolution, pixelRatio);
        /**
     * @private
     * @type {import('../../DataTile.js').ImageLike}
     */ this.hitDetectionImage_ = null;
        /**
     * @private
     * @type {import('../../DataTile.js').ImageLike}
     */ this.image_ = null;
        /**
     * @private
     * @type {number|undefined}
     */ this.imagePixelRatio_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.anchorX_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.anchorY_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.height_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.opacity_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.originX_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.originY_ = undefined;
        /**
     * @private
     * @type {boolean|undefined}
     */ this.rotateWithView_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.rotation_ = undefined;
        /**
     * @private
     * @type {import("../../size.js").Size|undefined}
     */ this.scale_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.width_ = undefined;
        /**
     * @private
     * @type {import('../../style/Style.js').DeclutterMode}
     */ this.declutterMode_ = undefined;
        /**
     * Data shared with a text builder for combined decluttering.
     * @private
     * @type {import("../canvas.js").DeclutterImageWithText}
     */ this.declutterImageWithText_ = undefined;
    }
    /**
   * @param {import("../../geom/Point.js").default|import("../Feature.js").default} pointGeometry Point geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   * @override
   */ drawPoint(pointGeometry, feature, index) {
        if (!this.image_ || this.maxExtent && !(0, $6da4c8ed3074c92b$export$ac68c24d37ca240f)(this.maxExtent, pointGeometry.getFlatCoordinates())) return;
        this.beginGeometry(pointGeometry, feature, index);
        const flatCoordinates = pointGeometry.getFlatCoordinates();
        const stride = pointGeometry.getStride();
        const myBegin = this.coordinates.length;
        const myEnd = this.appendFlatPointCoordinates(flatCoordinates, stride);
        this.instructions.push([
            (0, $cf547866e052f25b$export$2e2bcd8739ae039).DRAW_IMAGE,
            myBegin,
            myEnd,
            this.image_,
            // Remaining arguments to DRAW_IMAGE are in alphabetical order
            this.anchorX_ * this.imagePixelRatio_,
            this.anchorY_ * this.imagePixelRatio_,
            Math.ceil(this.height_ * this.imagePixelRatio_),
            this.opacity_,
            this.originX_ * this.imagePixelRatio_,
            this.originY_ * this.imagePixelRatio_,
            this.rotateWithView_,
            this.rotation_,
            [
                this.scale_[0] * this.pixelRatio / this.imagePixelRatio_,
                this.scale_[1] * this.pixelRatio / this.imagePixelRatio_
            ],
            Math.ceil(this.width_ * this.imagePixelRatio_),
            this.declutterMode_,
            this.declutterImageWithText_
        ]);
        this.hitDetectionInstructions.push([
            (0, $cf547866e052f25b$export$2e2bcd8739ae039).DRAW_IMAGE,
            myBegin,
            myEnd,
            this.hitDetectionImage_,
            // Remaining arguments to DRAW_IMAGE are in alphabetical order
            this.anchorX_,
            this.anchorY_,
            this.height_,
            1,
            this.originX_,
            this.originY_,
            this.rotateWithView_,
            this.rotation_,
            this.scale_,
            this.width_,
            this.declutterMode_,
            this.declutterImageWithText_
        ]);
        this.endGeometry(feature);
    }
    /**
   * @param {import("../../geom/MultiPoint.js").default|import("../Feature.js").default} multiPointGeometry MultiPoint geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   * @override
   */ drawMultiPoint(multiPointGeometry, feature, index) {
        if (!this.image_) return;
        this.beginGeometry(multiPointGeometry, feature, index);
        const flatCoordinates = multiPointGeometry.getFlatCoordinates();
        const filteredFlatCoordinates = [];
        for(let i = 0, ii = flatCoordinates.length; i < ii; i += multiPointGeometry.getStride())if (!this.maxExtent || (0, $6da4c8ed3074c92b$export$ac68c24d37ca240f)(this.maxExtent, flatCoordinates.slice(i, i + 2))) filteredFlatCoordinates.push(flatCoordinates[i], flatCoordinates[i + 1]);
        const myBegin = this.coordinates.length;
        const myEnd = this.appendFlatPointCoordinates(filteredFlatCoordinates, 2);
        this.instructions.push([
            (0, $cf547866e052f25b$export$2e2bcd8739ae039).DRAW_IMAGE,
            myBegin,
            myEnd,
            this.image_,
            // Remaining arguments to DRAW_IMAGE are in alphabetical order
            this.anchorX_ * this.imagePixelRatio_,
            this.anchorY_ * this.imagePixelRatio_,
            Math.ceil(this.height_ * this.imagePixelRatio_),
            this.opacity_,
            this.originX_ * this.imagePixelRatio_,
            this.originY_ * this.imagePixelRatio_,
            this.rotateWithView_,
            this.rotation_,
            [
                this.scale_[0] * this.pixelRatio / this.imagePixelRatio_,
                this.scale_[1] * this.pixelRatio / this.imagePixelRatio_
            ],
            Math.ceil(this.width_ * this.imagePixelRatio_),
            this.declutterMode_,
            this.declutterImageWithText_
        ]);
        this.hitDetectionInstructions.push([
            (0, $cf547866e052f25b$export$2e2bcd8739ae039).DRAW_IMAGE,
            myBegin,
            myEnd,
            this.hitDetectionImage_,
            // Remaining arguments to DRAW_IMAGE are in alphabetical order
            this.anchorX_,
            this.anchorY_,
            this.height_,
            1,
            this.originX_,
            this.originY_,
            this.rotateWithView_,
            this.rotation_,
            this.scale_,
            this.width_,
            this.declutterMode_,
            this.declutterImageWithText_
        ]);
        this.endGeometry(feature);
    }
    /**
   * @return {import("../canvas.js").SerializableInstructions} the serializable instructions.
   * @override
   */ finish() {
        this.reverseHitDetectionInstructions();
        // FIXME this doesn't really protect us against further calls to draw*Geometry
        this.anchorX_ = undefined;
        this.anchorY_ = undefined;
        this.hitDetectionImage_ = null;
        this.image_ = null;
        this.imagePixelRatio_ = undefined;
        this.height_ = undefined;
        this.scale_ = undefined;
        this.opacity_ = undefined;
        this.originX_ = undefined;
        this.originY_ = undefined;
        this.rotateWithView_ = undefined;
        this.rotation_ = undefined;
        this.width_ = undefined;
        return super.finish();
    }
    /**
   * @param {import("../../style/Image.js").default} imageStyle Image style.
   * @param {Object} [sharedData] Shared data.
   * @override
   */ setImageStyle(imageStyle, sharedData) {
        const anchor = imageStyle.getAnchor();
        const size = imageStyle.getSize();
        const origin = imageStyle.getOrigin();
        this.imagePixelRatio_ = imageStyle.getPixelRatio(this.pixelRatio);
        this.anchorX_ = anchor[0];
        this.anchorY_ = anchor[1];
        this.hitDetectionImage_ = imageStyle.getHitDetectionImage();
        this.image_ = imageStyle.getImage(this.pixelRatio);
        this.height_ = size[1];
        this.opacity_ = imageStyle.getOpacity();
        this.originX_ = origin[0];
        this.originY_ = origin[1];
        this.rotateWithView_ = imageStyle.getRotateWithView();
        this.rotation_ = imageStyle.getRotation();
        this.scale_ = imageStyle.getScaleArray();
        this.width_ = size[0];
        this.declutterMode_ = imageStyle.getDeclutterMode();
        this.declutterImageWithText_ = sharedData;
    }
}
var $b652f9dd73b29cfe$export$2e2bcd8739ae039 = $b652f9dd73b29cfe$var$CanvasImageBuilder;


/**
 * @module ol/render/canvas/LineStringBuilder
 */ 


class $a207f23baa5aa2c5$var$CanvasLineStringBuilder extends (0, $2bb20f8873deb436$export$2e2bcd8739ae039) {
    /**
   * @param {number} tolerance Tolerance.
   * @param {import("../../extent.js").Extent} maxExtent Maximum extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   */ constructor(tolerance, maxExtent, resolution, pixelRatio){
        super(tolerance, maxExtent, resolution, pixelRatio);
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {number} end End.
   * @param {number} stride Stride.
   * @private
   * @return {number} end.
   */ drawFlatCoordinates_(flatCoordinates, offset, end, stride) {
        const myBegin = this.coordinates.length;
        const myEnd = this.appendFlatLineCoordinates(flatCoordinates, offset, end, stride, false, false);
        const moveToLineToInstruction = [
            (0, $cf547866e052f25b$export$2e2bcd8739ae039).MOVE_TO_LINE_TO,
            myBegin,
            myEnd
        ];
        this.instructions.push(moveToLineToInstruction);
        this.hitDetectionInstructions.push(moveToLineToInstruction);
        return end;
    }
    /**
   * @param {import("../../geom/LineString.js").default|import("../Feature.js").default} lineStringGeometry Line string geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   * @override
   */ drawLineString(lineStringGeometry, feature, index) {
        const state = this.state;
        const strokeStyle = state.strokeStyle;
        const lineWidth = state.lineWidth;
        if (strokeStyle === undefined || lineWidth === undefined) return;
        this.updateStrokeStyle(state, this.applyStroke);
        this.beginGeometry(lineStringGeometry, feature, index);
        this.hitDetectionInstructions.push([
            (0, $cf547866e052f25b$export$2e2bcd8739ae039).SET_STROKE_STYLE,
            state.strokeStyle,
            state.lineWidth,
            state.lineCap,
            state.lineJoin,
            state.miterLimit,
            (0, $d4aabc5c971073f1$export$e21b4112fdc612fc),
            (0, $d4aabc5c971073f1$export$e06efc2409049f76)
        ], (0, $cf547866e052f25b$export$9f746cc58a899a00));
        const flatCoordinates = lineStringGeometry.getFlatCoordinates();
        const stride = lineStringGeometry.getStride();
        this.drawFlatCoordinates_(flatCoordinates, 0, flatCoordinates.length, stride);
        this.hitDetectionInstructions.push((0, $cf547866e052f25b$export$7a98aa5364d62ba8));
        this.endGeometry(feature);
    }
    /**
   * @param {import("../../geom/MultiLineString.js").default|import("../Feature.js").default} multiLineStringGeometry MultiLineString geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   * @override
   */ drawMultiLineString(multiLineStringGeometry, feature, index) {
        const state = this.state;
        const strokeStyle = state.strokeStyle;
        const lineWidth = state.lineWidth;
        if (strokeStyle === undefined || lineWidth === undefined) return;
        this.updateStrokeStyle(state, this.applyStroke);
        this.beginGeometry(multiLineStringGeometry, feature, index);
        this.hitDetectionInstructions.push([
            (0, $cf547866e052f25b$export$2e2bcd8739ae039).SET_STROKE_STYLE,
            state.strokeStyle,
            state.lineWidth,
            state.lineCap,
            state.lineJoin,
            state.miterLimit,
            (0, $d4aabc5c971073f1$export$e21b4112fdc612fc),
            (0, $d4aabc5c971073f1$export$e06efc2409049f76)
        ], (0, $cf547866e052f25b$export$9f746cc58a899a00));
        const ends = multiLineStringGeometry.getEnds();
        const flatCoordinates = multiLineStringGeometry.getFlatCoordinates();
        const stride = multiLineStringGeometry.getStride();
        let offset = 0;
        for(let i = 0, ii = ends.length; i < ii; ++i)offset = this.drawFlatCoordinates_(flatCoordinates, offset, /** @type {number} */ ends[i], stride);
        this.hitDetectionInstructions.push((0, $cf547866e052f25b$export$7a98aa5364d62ba8));
        this.endGeometry(feature);
    }
    /**
   * @return {import("../canvas.js").SerializableInstructions} the serializable instructions.
   * @override
   */ finish() {
        const state = this.state;
        if (state.lastStroke != undefined && state.lastStroke != this.coordinates.length) this.instructions.push((0, $cf547866e052f25b$export$7a98aa5364d62ba8));
        this.reverseHitDetectionInstructions();
        this.state = null;
        return super.finish();
    }
    /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   * @override
   */ applyStroke(state) {
        if (state.lastStroke != undefined && state.lastStroke != this.coordinates.length) {
            this.instructions.push((0, $cf547866e052f25b$export$7a98aa5364d62ba8));
            state.lastStroke = this.coordinates.length;
        }
        state.lastStroke = 0;
        super.applyStroke(state);
        this.instructions.push((0, $cf547866e052f25b$export$9f746cc58a899a00));
    }
}
var $a207f23baa5aa2c5$export$2e2bcd8739ae039 = $a207f23baa5aa2c5$var$CanvasLineStringBuilder;


/**
 * @module ol/render/canvas/PolygonBuilder
 */ 



class $7d2e8ba11a45ae8a$var$CanvasPolygonBuilder extends (0, $2bb20f8873deb436$export$2e2bcd8739ae039) {
    /**
   * @param {number} tolerance Tolerance.
   * @param {import("../../extent.js").Extent} maxExtent Maximum extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   */ constructor(tolerance, maxExtent, resolution, pixelRatio){
        super(tolerance, maxExtent, resolution, pixelRatio);
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {Array<number>} ends Ends.
   * @param {number} stride Stride.
   * @private
   * @return {number} End.
   */ drawFlatCoordinatess_(flatCoordinates, offset, ends, stride) {
        const state = this.state;
        const fill = state.fillStyle !== undefined;
        const stroke = state.strokeStyle !== undefined;
        const numEnds = ends.length;
        this.instructions.push((0, $cf547866e052f25b$export$9f746cc58a899a00));
        this.hitDetectionInstructions.push((0, $cf547866e052f25b$export$9f746cc58a899a00));
        for(let i = 0; i < numEnds; ++i){
            const end = ends[i];
            const myBegin = this.coordinates.length;
            const myEnd = this.appendFlatLineCoordinates(flatCoordinates, offset, end, stride, true, !stroke);
            const moveToLineToInstruction = [
                (0, $cf547866e052f25b$export$2e2bcd8739ae039).MOVE_TO_LINE_TO,
                myBegin,
                myEnd
            ];
            this.instructions.push(moveToLineToInstruction);
            this.hitDetectionInstructions.push(moveToLineToInstruction);
            if (stroke) {
                // Performance optimization: only call closePath() when we have a stroke.
                // Otherwise the ring is closed already (see appendFlatLineCoordinates above).
                this.instructions.push((0, $cf547866e052f25b$export$89b10f327e413e71));
                this.hitDetectionInstructions.push((0, $cf547866e052f25b$export$89b10f327e413e71));
            }
            offset = end;
        }
        if (fill) {
            this.instructions.push((0, $cf547866e052f25b$export$f21891651e408226));
            this.hitDetectionInstructions.push((0, $cf547866e052f25b$export$f21891651e408226));
        }
        if (stroke) {
            this.instructions.push((0, $cf547866e052f25b$export$7a98aa5364d62ba8));
            this.hitDetectionInstructions.push((0, $cf547866e052f25b$export$7a98aa5364d62ba8));
        }
        return offset;
    }
    /**
   * @param {import("../../geom/Circle.js").default} circleGeometry Circle geometry.
   * @param {import("../../Feature.js").default} feature Feature.
   * @param {number} [index] Render order index.
   * @override
   */ drawCircle(circleGeometry, feature, index) {
        const state = this.state;
        const fillStyle = state.fillStyle;
        const strokeStyle = state.strokeStyle;
        if (fillStyle === undefined && strokeStyle === undefined) return;
        this.setFillStrokeStyles_();
        this.beginGeometry(circleGeometry, feature, index);
        if (state.fillStyle !== undefined) this.hitDetectionInstructions.push([
            (0, $cf547866e052f25b$export$2e2bcd8739ae039).SET_FILL_STYLE,
            (0, $d4aabc5c971073f1$export$c495d52ee3fd74b2)
        ]);
        if (state.strokeStyle !== undefined) this.hitDetectionInstructions.push([
            (0, $cf547866e052f25b$export$2e2bcd8739ae039).SET_STROKE_STYLE,
            state.strokeStyle,
            state.lineWidth,
            state.lineCap,
            state.lineJoin,
            state.miterLimit,
            (0, $d4aabc5c971073f1$export$e21b4112fdc612fc),
            (0, $d4aabc5c971073f1$export$e06efc2409049f76)
        ]);
        const flatCoordinates = circleGeometry.getFlatCoordinates();
        const stride = circleGeometry.getStride();
        const myBegin = this.coordinates.length;
        this.appendFlatLineCoordinates(flatCoordinates, 0, flatCoordinates.length, stride, false, false);
        const circleInstruction = [
            (0, $cf547866e052f25b$export$2e2bcd8739ae039).CIRCLE,
            myBegin
        ];
        this.instructions.push((0, $cf547866e052f25b$export$9f746cc58a899a00), circleInstruction);
        this.hitDetectionInstructions.push((0, $cf547866e052f25b$export$9f746cc58a899a00), circleInstruction);
        if (state.fillStyle !== undefined) {
            this.instructions.push((0, $cf547866e052f25b$export$f21891651e408226));
            this.hitDetectionInstructions.push((0, $cf547866e052f25b$export$f21891651e408226));
        }
        if (state.strokeStyle !== undefined) {
            this.instructions.push((0, $cf547866e052f25b$export$7a98aa5364d62ba8));
            this.hitDetectionInstructions.push((0, $cf547866e052f25b$export$7a98aa5364d62ba8));
        }
        this.endGeometry(feature);
    }
    /**
   * @param {import("../../geom/Polygon.js").default|import("../Feature.js").default} polygonGeometry Polygon geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   * @override
   */ drawPolygon(polygonGeometry, feature, index) {
        const state = this.state;
        const fillStyle = state.fillStyle;
        const strokeStyle = state.strokeStyle;
        if (fillStyle === undefined && strokeStyle === undefined) return;
        this.setFillStrokeStyles_();
        this.beginGeometry(polygonGeometry, feature, index);
        if (state.fillStyle !== undefined) this.hitDetectionInstructions.push([
            (0, $cf547866e052f25b$export$2e2bcd8739ae039).SET_FILL_STYLE,
            (0, $d4aabc5c971073f1$export$c495d52ee3fd74b2)
        ]);
        if (state.strokeStyle !== undefined) this.hitDetectionInstructions.push([
            (0, $cf547866e052f25b$export$2e2bcd8739ae039).SET_STROKE_STYLE,
            state.strokeStyle,
            state.lineWidth,
            state.lineCap,
            state.lineJoin,
            state.miterLimit,
            (0, $d4aabc5c971073f1$export$e21b4112fdc612fc),
            (0, $d4aabc5c971073f1$export$e06efc2409049f76)
        ]);
        const ends = polygonGeometry.getEnds();
        const flatCoordinates = polygonGeometry.getOrientedFlatCoordinates();
        const stride = polygonGeometry.getStride();
        this.drawFlatCoordinatess_(flatCoordinates, 0, /** @type {Array<number>} */ ends, stride);
        this.endGeometry(feature);
    }
    /**
   * @param {import("../../geom/MultiPolygon.js").default} multiPolygonGeometry MultiPolygon geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   * @override
   */ drawMultiPolygon(multiPolygonGeometry, feature, index) {
        const state = this.state;
        const fillStyle = state.fillStyle;
        const strokeStyle = state.strokeStyle;
        if (fillStyle === undefined && strokeStyle === undefined) return;
        this.setFillStrokeStyles_();
        this.beginGeometry(multiPolygonGeometry, feature, index);
        if (state.fillStyle !== undefined) this.hitDetectionInstructions.push([
            (0, $cf547866e052f25b$export$2e2bcd8739ae039).SET_FILL_STYLE,
            (0, $d4aabc5c971073f1$export$c495d52ee3fd74b2)
        ]);
        if (state.strokeStyle !== undefined) this.hitDetectionInstructions.push([
            (0, $cf547866e052f25b$export$2e2bcd8739ae039).SET_STROKE_STYLE,
            state.strokeStyle,
            state.lineWidth,
            state.lineCap,
            state.lineJoin,
            state.miterLimit,
            (0, $d4aabc5c971073f1$export$e21b4112fdc612fc),
            (0, $d4aabc5c971073f1$export$e06efc2409049f76)
        ]);
        const endss = multiPolygonGeometry.getEndss();
        const flatCoordinates = multiPolygonGeometry.getOrientedFlatCoordinates();
        const stride = multiPolygonGeometry.getStride();
        let offset = 0;
        for(let i = 0, ii = endss.length; i < ii; ++i)offset = this.drawFlatCoordinatess_(flatCoordinates, offset, endss[i], stride);
        this.endGeometry(feature);
    }
    /**
   * @return {import("../canvas.js").SerializableInstructions} the serializable instructions.
   * @override
   */ finish() {
        this.reverseHitDetectionInstructions();
        this.state = null;
        // We want to preserve topology when drawing polygons.  Polygons are
        // simplified using quantization and point elimination. However, we might
        // have received a mix of quantized and non-quantized geometries, so ensure
        // that all are quantized by quantizing all coordinates in the batch.
        const tolerance = this.tolerance;
        if (tolerance !== 0) {
            const coordinates = this.coordinates;
            for(let i = 0, ii = coordinates.length; i < ii; ++i)coordinates[i] = (0, $8780aae6970f5f65$export$51a0620f7a28532b)(coordinates[i], tolerance);
        }
        return super.finish();
    }
    /**
   * @private
   */ setFillStrokeStyles_() {
        const state = this.state;
        this.updateFillStyle(state, this.createFill);
        this.updateStrokeStyle(state, this.applyStroke);
    }
}
var $7d2e8ba11a45ae8a$export$2e2bcd8739ae039 = $7d2e8ba11a45ae8a$var$CanvasPolygonBuilder;


/**
 * @module ol/render/canvas/TextBuilder
 */ 


function $7704cc1df2ddb619$export$f08272c6ff321e57(chunkLength, flatCoordinates, offset, end, stride) {
    const chunks = [];
    let cursor = offset;
    let chunkM = 0;
    let currentChunk = flatCoordinates.slice(offset, 2);
    while(chunkM < chunkLength && cursor + stride < end){
        const [x1, y1] = currentChunk.slice(-2);
        const x2 = flatCoordinates[cursor + stride];
        const y2 = flatCoordinates[cursor + stride + 1];
        const segmentLength = Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
        chunkM += segmentLength;
        if (chunkM >= chunkLength) {
            const m = (chunkLength - chunkM + segmentLength) / segmentLength;
            const x = (0, $6b000a049d919fe5$export$3a89f8d6f6bf6c9f)(x1, x2, m);
            const y = (0, $6b000a049d919fe5$export$3a89f8d6f6bf6c9f)(y1, y2, m);
            currentChunk.push(x, y);
            chunks.push(currentChunk);
            currentChunk = [
                x,
                y
            ];
            if (chunkM == chunkLength) cursor += stride;
            chunkM = 0;
        } else if (chunkM < chunkLength) {
            currentChunk.push(flatCoordinates[cursor + stride], flatCoordinates[cursor + stride + 1]);
            cursor += stride;
        } else {
            const missing = segmentLength - chunkM;
            const x = (0, $6b000a049d919fe5$export$3a89f8d6f6bf6c9f)(x1, x2, missing / segmentLength);
            const y = (0, $6b000a049d919fe5$export$3a89f8d6f6bf6c9f)(y1, y2, missing / segmentLength);
            currentChunk.push(x, y);
            chunks.push(currentChunk);
            currentChunk = [
                x,
                y
            ];
            chunkM = 0;
            cursor += stride;
        }
    }
    if (chunkM > 0) chunks.push(currentChunk);
    return chunks;
}


/**
 * @module ol/geom/flat/straightchunk
 */ /**
 * @param {number} maxAngle Maximum acceptable angle delta between segments.
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @return {Array<number>} Start and end of the first suitable chunk of the
 * given `flatCoordinates`.
 */ function $79529ab61b92f869$export$ed6c897eea07a254(maxAngle, flatCoordinates, offset, end, stride) {
    let chunkStart = offset;
    let chunkEnd = offset;
    let chunkM = 0;
    let m = 0;
    let start = offset;
    let acos, i, m12, m23, x1, y1, x12, y12, x23, y23;
    for(i = offset; i < end; i += stride){
        const x2 = flatCoordinates[i];
        const y2 = flatCoordinates[i + 1];
        if (x1 !== undefined) {
            x23 = x2 - x1;
            y23 = y2 - y1;
            m23 = Math.sqrt(x23 * x23 + y23 * y23);
            if (x12 !== undefined) {
                m += m12;
                acos = Math.acos((x12 * x23 + y12 * y23) / (m12 * m23));
                if (acos > maxAngle) {
                    if (m > chunkM) {
                        chunkM = m;
                        chunkStart = start;
                        chunkEnd = i;
                    }
                    m = 0;
                    start = i - stride;
                }
            }
            m12 = m23;
            x12 = x23;
            y12 = y23;
        }
        x1 = x2;
        y1 = y2;
    }
    m += m23;
    return m > chunkM ? [
        start,
        i
    ] : [
        chunkStart,
        chunkEnd
    ];
}






const $8243e906fae47bbe$export$91a016276e4aee96 = {
    'left': 0,
    'center': 0.5,
    'right': 1,
    'top': 0,
    'middle': 0.5,
    'hanging': 0.2,
    'alphabetic': 0.8,
    'ideographic': 0.8,
    'bottom': 1
};
class $8243e906fae47bbe$var$CanvasTextBuilder extends (0, $2bb20f8873deb436$export$2e2bcd8739ae039) {
    /**
   * @param {number} tolerance Tolerance.
   * @param {import("../../extent.js").Extent} maxExtent Maximum extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   */ constructor(tolerance, maxExtent, resolution, pixelRatio){
        super(tolerance, maxExtent, resolution, pixelRatio);
        /**
     * @private
     * @type {Array<HTMLCanvasElement>}
     */ this.labels_ = null;
        /**
     * @private
     * @type {string|Array<string>}
     */ this.text_ = '';
        /**
     * @private
     * @type {number}
     */ this.textOffsetX_ = 0;
        /**
     * @private
     * @type {number}
     */ this.textOffsetY_ = 0;
        /**
     * @private
     * @type {boolean|undefined}
     */ this.textRotateWithView_ = undefined;
        /**
     * @private
     * @type {boolean|undefined}
     */ this.textKeepUpright_ = undefined;
        /**
     * @private
     * @type {number}
     */ this.textRotation_ = 0;
        /**
     * @private
     * @type {?import("../canvas.js").FillState}
     */ this.textFillState_ = null;
        /**
     * @type {!Object<string, import("../canvas.js").FillState>}
     */ this.fillStates = {};
        this.fillStates[0, $d4aabc5c971073f1$export$c495d52ee3fd74b2] = {
            fillStyle: (0, $d4aabc5c971073f1$export$c495d52ee3fd74b2)
        };
        /**
     * @private
     * @type {?import("../canvas.js").StrokeState}
     */ this.textStrokeState_ = null;
        /**
     * @type {!Object<string, import("../canvas.js").StrokeState>}
     */ this.strokeStates = {};
        /**
     * @private
     * @type {import("../canvas.js").TextState}
     */ this.textState_ = /** @type {import("../canvas.js").TextState} */ {};
        /**
     * @type {!Object<string, import("../canvas.js").TextState>}
     */ this.textStates = {};
        /**
     * @private
     * @type {string}
     */ this.textKey_ = '';
        /**
     * @private
     * @type {string}
     */ this.fillKey_ = '';
        /**
     * @private
     * @type {string}
     */ this.strokeKey_ = '';
        /**
     * @private
     * @type {import('../../style/Style.js').DeclutterMode}
     */ this.declutterMode_ = undefined;
        /**
     * Data shared with an image builder for combined decluttering.
     * @private
     * @type {import("../canvas.js").DeclutterImageWithText}
     */ this.declutterImageWithText_ = undefined;
    }
    /**
   * @return {import("../canvas.js").SerializableInstructions} the serializable instructions.
   * @override
   */ finish() {
        const instructions = super.finish();
        instructions.textStates = this.textStates;
        instructions.fillStates = this.fillStates;
        instructions.strokeStates = this.strokeStates;
        return instructions;
    }
    /**
   * @param {import("../../geom/SimpleGeometry.js").default|import("../Feature.js").default} geometry Geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   * @override
   */ drawText(geometry, feature, index) {
        const fillState = this.textFillState_;
        const strokeState = this.textStrokeState_;
        const textState = this.textState_;
        if (this.text_ === '' || !textState || !fillState && !strokeState) return;
        const coordinates = this.coordinates;
        let begin = coordinates.length;
        const geometryType = geometry.getType();
        let flatCoordinates = null;
        let stride = geometry.getStride();
        if (textState.placement === 'line' && (geometryType == 'LineString' || geometryType == 'MultiLineString' || geometryType == 'Polygon' || geometryType == 'MultiPolygon')) {
            if (!(0, $6da4c8ed3074c92b$export$7b0a31e10bbff018)(this.maxExtent, geometry.getExtent())) return;
            let ends;
            flatCoordinates = geometry.getFlatCoordinates();
            if (geometryType == 'LineString') ends = [
                flatCoordinates.length
            ];
            else if (geometryType == 'MultiLineString') ends = /** @type {import("../../geom/MultiLineString.js").default} */ geometry.getEnds();
            else if (geometryType == 'Polygon') ends = /** @type {import("../../geom/Polygon.js").default} */ geometry.getEnds().slice(0, 1);
            else if (geometryType == 'MultiPolygon') {
                const endss = /** @type {import("../../geom/MultiPolygon.js").default} */ geometry.getEndss();
                ends = [];
                for(let i = 0, ii = endss.length; i < ii; ++i)ends.push(endss[i][0]);
            }
            this.beginGeometry(geometry, feature, index);
            const repeat = textState.repeat;
            const textAlign = repeat ? undefined : textState.textAlign;
            // No `justify` support for line placement.
            let flatOffset = 0;
            for(let o = 0, oo = ends.length; o < oo; ++o){
                let chunks;
                if (repeat) chunks = (0, $7704cc1df2ddb619$export$f08272c6ff321e57)(repeat * this.resolution, flatCoordinates, flatOffset, ends[o], stride);
                else chunks = [
                    flatCoordinates.slice(flatOffset, ends[o])
                ];
                for(let c = 0, cc = chunks.length; c < cc; ++c){
                    const chunk = chunks[c];
                    let chunkBegin = 0;
                    let chunkEnd = chunk.length;
                    if (textAlign == undefined) {
                        const range = (0, $79529ab61b92f869$export$ed6c897eea07a254)(textState.maxAngle, chunk, 0, chunk.length, 2);
                        chunkBegin = range[0];
                        chunkEnd = range[1];
                    }
                    for(let i = chunkBegin; i < chunkEnd; i += stride)coordinates.push(chunk[i], chunk[i + 1]);
                    const end = coordinates.length;
                    flatOffset = ends[o];
                    this.drawChars_(begin, end);
                    begin = end;
                }
            }
            this.endGeometry(feature);
        } else {
            let geometryWidths = textState.overflow ? null : [];
            switch(geometryType){
                case 'Point':
                case 'MultiPoint':
                    flatCoordinates = /** @type {import("../../geom/MultiPoint.js").default} */ geometry.getFlatCoordinates();
                    break;
                case 'LineString':
                    flatCoordinates = /** @type {import("../../geom/LineString.js").default} */ geometry.getFlatMidpoint();
                    break;
                case 'Circle':
                    flatCoordinates = /** @type {import("../../geom/Circle.js").default} */ geometry.getCenter();
                    break;
                case 'MultiLineString':
                    flatCoordinates = /** @type {import("../../geom/MultiLineString.js").default} */ geometry.getFlatMidpoints();
                    stride = 2;
                    break;
                case 'Polygon':
                    flatCoordinates = /** @type {import("../../geom/Polygon.js").default} */ geometry.getFlatInteriorPoint();
                    if (!textState.overflow) geometryWidths.push(flatCoordinates[2] / this.resolution);
                    stride = 3;
                    break;
                case 'MultiPolygon':
                    const interiorPoints = /** @type {import("../../geom/MultiPolygon.js").default} */ geometry.getFlatInteriorPoints();
                    flatCoordinates = [];
                    for(let i = 0, ii = interiorPoints.length; i < ii; i += 3){
                        if (!textState.overflow) geometryWidths.push(interiorPoints[i + 2] / this.resolution);
                        flatCoordinates.push(interiorPoints[i], interiorPoints[i + 1]);
                    }
                    if (flatCoordinates.length === 0) return;
                    stride = 2;
                    break;
                default:
            }
            const end = this.appendFlatPointCoordinates(flatCoordinates, stride);
            if (end === begin) return;
            if (geometryWidths && (end - begin) / 2 !== flatCoordinates.length / stride) {
                let beg = begin / 2;
                geometryWidths = geometryWidths.filter((w, i)=>{
                    const keep = coordinates[(beg + i) * 2] === flatCoordinates[i * stride] && coordinates[(beg + i) * 2 + 1] === flatCoordinates[i * stride + 1];
                    if (!keep) --beg;
                    return keep;
                });
            }
            this.saveTextStates_();
            const backgroundFill = textState.backgroundFill ? this.createFill(this.fillStyleToState(textState.backgroundFill)) : null;
            const backgroundStroke = textState.backgroundStroke ? this.createStroke(this.strokeStyleToState(textState.backgroundStroke)) : null;
            this.beginGeometry(geometry, feature, index);
            // adjust padding for negative scale
            let padding = textState.padding;
            if (padding != (0, $d4aabc5c971073f1$export$40a9eeef55665a40) && (textState.scale[0] < 0 || textState.scale[1] < 0)) {
                let p0 = textState.padding[0];
                let p1 = textState.padding[1];
                let p2 = textState.padding[2];
                let p3 = textState.padding[3];
                if (textState.scale[0] < 0) {
                    p1 = -p1;
                    p3 = -p3;
                }
                if (textState.scale[1] < 0) {
                    p0 = -p0;
                    p2 = -p2;
                }
                padding = [
                    p0,
                    p1,
                    p2,
                    p3
                ];
            }
            // The image is unknown at this stage so we pass null; it will be computed at render time.
            // For clarity, we pass NaN for offsetX, offsetY, width and height, which will be computed at
            // render time.
            const pixelRatio = this.pixelRatio;
            this.instructions.push([
                (0, $cf547866e052f25b$export$2e2bcd8739ae039).DRAW_IMAGE,
                begin,
                end,
                null,
                NaN,
                NaN,
                NaN,
                1,
                0,
                0,
                this.textRotateWithView_,
                this.textRotation_,
                [
                    1,
                    1
                ],
                NaN,
                this.declutterMode_,
                this.declutterImageWithText_,
                padding == (0, $d4aabc5c971073f1$export$40a9eeef55665a40) ? (0, $d4aabc5c971073f1$export$40a9eeef55665a40) : padding.map(function(p) {
                    return p * pixelRatio;
                }),
                backgroundFill,
                backgroundStroke,
                this.text_,
                this.textKey_,
                this.strokeKey_,
                this.fillKey_,
                this.textOffsetX_,
                this.textOffsetY_,
                geometryWidths
            ]);
            const scale = 1 / pixelRatio;
            // Set default fill for hit detection background
            const hitDetectionBackgroundFill = backgroundFill ? backgroundFill.slice(0) : null;
            if (hitDetectionBackgroundFill) hitDetectionBackgroundFill[1] = (0, $d4aabc5c971073f1$export$c495d52ee3fd74b2);
            this.hitDetectionInstructions.push([
                (0, $cf547866e052f25b$export$2e2bcd8739ae039).DRAW_IMAGE,
                begin,
                end,
                null,
                NaN,
                NaN,
                NaN,
                1,
                0,
                0,
                this.textRotateWithView_,
                this.textRotation_,
                [
                    scale,
                    scale
                ],
                NaN,
                this.declutterMode_,
                this.declutterImageWithText_,
                padding,
                hitDetectionBackgroundFill,
                backgroundStroke,
                this.text_,
                this.textKey_,
                this.strokeKey_,
                this.fillKey_ ? (0, $d4aabc5c971073f1$export$c495d52ee3fd74b2) : this.fillKey_,
                this.textOffsetX_,
                this.textOffsetY_,
                geometryWidths
            ]);
            this.endGeometry(feature);
        }
    }
    /**
   * @private
   */ saveTextStates_() {
        const strokeState = this.textStrokeState_;
        const textState = this.textState_;
        const fillState = this.textFillState_;
        const strokeKey = this.strokeKey_;
        if (strokeState) {
            if (!(strokeKey in this.strokeStates)) this.strokeStates[strokeKey] = {
                strokeStyle: strokeState.strokeStyle,
                lineCap: strokeState.lineCap,
                lineDashOffset: strokeState.lineDashOffset,
                lineWidth: strokeState.lineWidth,
                lineJoin: strokeState.lineJoin,
                miterLimit: strokeState.miterLimit,
                lineDash: strokeState.lineDash
            };
        }
        const textKey = this.textKey_;
        if (!(textKey in this.textStates)) this.textStates[textKey] = {
            font: textState.font,
            textAlign: textState.textAlign || (0, $d4aabc5c971073f1$export$94d53b95641b5766),
            justify: textState.justify,
            textBaseline: textState.textBaseline || (0, $d4aabc5c971073f1$export$cf2279a1bff62eb),
            scale: textState.scale
        };
        const fillKey = this.fillKey_;
        if (fillState) {
            if (!(fillKey in this.fillStates)) this.fillStates[fillKey] = {
                fillStyle: fillState.fillStyle
            };
        }
    }
    /**
   * @private
   * @param {number} begin Begin.
   * @param {number} end End.
   */ drawChars_(begin, end) {
        const strokeState = this.textStrokeState_;
        const textState = this.textState_;
        const strokeKey = this.strokeKey_;
        const textKey = this.textKey_;
        const fillKey = this.fillKey_;
        this.saveTextStates_();
        const pixelRatio = this.pixelRatio;
        const baseline = $8243e906fae47bbe$export$91a016276e4aee96[textState.textBaseline];
        const offsetY = this.textOffsetY_ * pixelRatio;
        const text = this.text_;
        const strokeWidth = strokeState ? strokeState.lineWidth * Math.abs(textState.scale[0]) / 2 : 0;
        this.instructions.push([
            (0, $cf547866e052f25b$export$2e2bcd8739ae039).DRAW_CHARS,
            begin,
            end,
            baseline,
            textState.overflow,
            fillKey,
            textState.maxAngle,
            pixelRatio,
            offsetY,
            strokeKey,
            strokeWidth * pixelRatio,
            text,
            textKey,
            1,
            this.declutterMode_,
            this.textKeepUpright_
        ]);
        this.hitDetectionInstructions.push([
            (0, $cf547866e052f25b$export$2e2bcd8739ae039).DRAW_CHARS,
            begin,
            end,
            baseline,
            textState.overflow,
            fillKey ? (0, $d4aabc5c971073f1$export$c495d52ee3fd74b2) : fillKey,
            textState.maxAngle,
            pixelRatio,
            offsetY,
            strokeKey,
            strokeWidth * pixelRatio,
            text,
            textKey,
            1 / pixelRatio,
            this.declutterMode_,
            this.textKeepUpright_
        ]);
    }
    /**
   * @param {import("../../style/Text.js").default} textStyle Text style.
   * @param {Object} [sharedData] Shared data.
   * @override
   */ setTextStyle(textStyle, sharedData) {
        let textState, fillState, strokeState;
        if (!textStyle) this.text_ = '';
        else {
            const textFillStyle = textStyle.getFill();
            if (!textFillStyle) {
                fillState = null;
                this.textFillState_ = fillState;
            } else {
                fillState = this.textFillState_;
                if (!fillState) {
                    fillState = /** @type {import("../canvas.js").FillState} */ {};
                    this.textFillState_ = fillState;
                }
                fillState.fillStyle = (0, $e0807f400ec9a0a9$export$dc5b1400ac3a10a8)(textFillStyle.getColor() || (0, $d4aabc5c971073f1$export$c495d52ee3fd74b2));
            }
            const textStrokeStyle = textStyle.getStroke();
            if (!textStrokeStyle) {
                strokeState = null;
                this.textStrokeState_ = strokeState;
            } else {
                strokeState = this.textStrokeState_;
                if (!strokeState) {
                    strokeState = /** @type {import("../canvas.js").StrokeState} */ {};
                    this.textStrokeState_ = strokeState;
                }
                const lineDash = textStrokeStyle.getLineDash();
                const lineDashOffset = textStrokeStyle.getLineDashOffset();
                const lineWidth = textStrokeStyle.getWidth();
                const miterLimit = textStrokeStyle.getMiterLimit();
                strokeState.lineCap = textStrokeStyle.getLineCap() || (0, $d4aabc5c971073f1$export$17bd0c38d6ae694e);
                strokeState.lineDash = lineDash ? lineDash.slice() : (0, $d4aabc5c971073f1$export$e21b4112fdc612fc);
                strokeState.lineDashOffset = lineDashOffset === undefined ? (0, $d4aabc5c971073f1$export$e06efc2409049f76) : lineDashOffset;
                strokeState.lineJoin = textStrokeStyle.getLineJoin() || (0, $d4aabc5c971073f1$export$365eb9648cf19bd0);
                strokeState.lineWidth = lineWidth === undefined ? (0, $d4aabc5c971073f1$export$79661f132c62010e) : lineWidth;
                strokeState.miterLimit = miterLimit === undefined ? (0, $d4aabc5c971073f1$export$80c1c01844597b7b) : miterLimit;
                strokeState.strokeStyle = (0, $e0807f400ec9a0a9$export$dc5b1400ac3a10a8)(textStrokeStyle.getColor() || (0, $d4aabc5c971073f1$export$1eb2eaecacf2031e));
            }
            textState = this.textState_;
            const font = textStyle.getFont() || (0, $d4aabc5c971073f1$export$3847dfea4f8d4dfa);
            (0, $d4aabc5c971073f1$export$a534074a28fa87ff)(font);
            const textScale = textStyle.getScaleArray();
            textState.overflow = textStyle.getOverflow();
            textState.font = font;
            textState.maxAngle = textStyle.getMaxAngle();
            textState.placement = textStyle.getPlacement();
            textState.textAlign = textStyle.getTextAlign();
            textState.repeat = textStyle.getRepeat();
            textState.justify = textStyle.getJustify();
            textState.textBaseline = textStyle.getTextBaseline() || (0, $d4aabc5c971073f1$export$cf2279a1bff62eb);
            textState.backgroundFill = textStyle.getBackgroundFill();
            textState.backgroundStroke = textStyle.getBackgroundStroke();
            textState.padding = textStyle.getPadding() || (0, $d4aabc5c971073f1$export$40a9eeef55665a40);
            textState.scale = textScale === undefined ? [
                1,
                1
            ] : textScale;
            const textOffsetX = textStyle.getOffsetX();
            const textOffsetY = textStyle.getOffsetY();
            const textRotateWithView = textStyle.getRotateWithView();
            const textKeepUpright = textStyle.getKeepUpright();
            const textRotation = textStyle.getRotation();
            this.text_ = textStyle.getText() || '';
            this.textOffsetX_ = textOffsetX === undefined ? 0 : textOffsetX;
            this.textOffsetY_ = textOffsetY === undefined ? 0 : textOffsetY;
            this.textRotateWithView_ = textRotateWithView === undefined ? false : textRotateWithView;
            this.textKeepUpright_ = textKeepUpright === undefined ? true : textKeepUpright;
            this.textRotation_ = textRotation === undefined ? 0 : textRotation;
            this.strokeKey_ = strokeState ? (typeof strokeState.strokeStyle == 'string' ? strokeState.strokeStyle : (0, $6c5e11070e371322$export$5e82334337e0f204)(strokeState.strokeStyle)) + strokeState.lineCap + strokeState.lineDashOffset + '|' + strokeState.lineWidth + strokeState.lineJoin + strokeState.miterLimit + '[' + strokeState.lineDash.join() + ']' : '';
            this.textKey_ = textState.font + textState.scale + (textState.textAlign || '?') + (textState.repeat || '?') + (textState.justify || '?') + (textState.textBaseline || '?');
            this.fillKey_ = fillState && fillState.fillStyle ? typeof fillState.fillStyle == 'string' ? fillState.fillStyle : '|' + (0, $6c5e11070e371322$export$5e82334337e0f204)(fillState.fillStyle) : '';
        }
        this.declutterMode_ = textStyle.getDeclutterMode();
        this.declutterImageWithText_ = sharedData;
    }
}
var $8243e906fae47bbe$export$2e2bcd8739ae039 = $8243e906fae47bbe$var$CanvasTextBuilder;


/**
 * @type {Object<import("../canvas.js").BuilderType, typeof Builder>}
 */ const $e22658f4b743550b$var$BATCH_CONSTRUCTORS = {
    'Circle': (0, $7d2e8ba11a45ae8a$export$2e2bcd8739ae039),
    'Default': (0, $2bb20f8873deb436$export$2e2bcd8739ae039),
    'Image': (0, $b652f9dd73b29cfe$export$2e2bcd8739ae039),
    'LineString': (0, $a207f23baa5aa2c5$export$2e2bcd8739ae039),
    'Polygon': (0, $7d2e8ba11a45ae8a$export$2e2bcd8739ae039),
    'Text': (0, $8243e906fae47bbe$export$2e2bcd8739ae039)
};
class $e22658f4b743550b$var$BuilderGroup {
    /**
   * @param {number} tolerance Tolerance.
   * @param {import("../../extent.js").Extent} maxExtent Max extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   */ constructor(tolerance, maxExtent, resolution, pixelRatio){
        /**
     * @private
     * @type {number}
     */ this.tolerance_ = tolerance;
        /**
     * @private
     * @type {import("../../extent.js").Extent}
     */ this.maxExtent_ = maxExtent;
        /**
     * @private
     * @type {number}
     */ this.pixelRatio_ = pixelRatio;
        /**
     * @private
     * @type {number}
     */ this.resolution_ = resolution;
        /**
     * @private
     * @type {!Object<string, !Object<import("../canvas.js").BuilderType, Builder>>}
     */ this.buildersByZIndex_ = {};
    }
    /**
   * @return {!Object<string, !Object<import("../canvas.js").BuilderType, import("./Builder.js").SerializableInstructions>>} The serializable instructions
   */ finish() {
        const builderInstructions = {};
        for(const zKey in this.buildersByZIndex_){
            builderInstructions[zKey] = builderInstructions[zKey] || {};
            const builders = this.buildersByZIndex_[zKey];
            for(const builderKey in builders){
                const builderInstruction = builders[builderKey].finish();
                builderInstructions[zKey][builderKey] = builderInstruction;
            }
        }
        return builderInstructions;
    }
    /**
   * @param {number|undefined} zIndex Z index.
   * @param {import("../canvas.js").BuilderType} builderType Replay type.
   * @return {import("../VectorContext.js").default} Replay.
   */ getBuilder(zIndex, builderType) {
        const zIndexKey = zIndex !== undefined ? zIndex.toString() : '0';
        let replays = this.buildersByZIndex_[zIndexKey];
        if (replays === undefined) {
            replays = {};
            this.buildersByZIndex_[zIndexKey] = replays;
        }
        let replay = replays[builderType];
        if (replay === undefined) {
            const Constructor = $e22658f4b743550b$var$BATCH_CONSTRUCTORS[builderType];
            replay = new Constructor(this.tolerance_, this.maxExtent_, this.resolution_, this.pixelRatio_);
            replays[builderType] = replay;
        }
        return replay;
    }
}
var $e22658f4b743550b$export$2e2bcd8739ae039 = $e22658f4b743550b$var$BuilderGroup;


/**
 * @module ol/render/canvas/ExecutorGroup
 */ 





/**
 * @module ol/render/canvas/Executor
 */ 


/**
 * @module ol/geom/flat/textpath
 */ 

function $f6421f31729929e6$export$153a9a17ab3e949f(flatCoordinates, offset, end, stride, text, startM, maxAngle, scale, measureAndCacheTextWidth, font, cache, rotation, keepUpright = true) {
    let x2 = flatCoordinates[offset];
    let y2 = flatCoordinates[offset + 1];
    let x1 = 0;
    let y1 = 0;
    let segmentLength = 0;
    let segmentM = 0;
    function advance() {
        x1 = x2;
        y1 = y2;
        offset += stride;
        x2 = flatCoordinates[offset];
        y2 = flatCoordinates[offset + 1];
        segmentM += segmentLength;
        segmentLength = Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
    }
    do advance();
    while (offset < end - stride && segmentM + segmentLength < startM);
    let interpolate = segmentLength === 0 ? 0 : (startM - segmentM) / segmentLength;
    const beginX = (0, $6b000a049d919fe5$export$3a89f8d6f6bf6c9f)(x1, x2, interpolate);
    const beginY = (0, $6b000a049d919fe5$export$3a89f8d6f6bf6c9f)(y1, y2, interpolate);
    const startOffset = offset - stride;
    const startLength = segmentM;
    const endM = startM + scale * measureAndCacheTextWidth(font, text, cache);
    while(offset < end - stride && segmentM + segmentLength < endM)advance();
    interpolate = segmentLength === 0 ? 0 : (endM - segmentM) / segmentLength;
    const endX = (0, $6b000a049d919fe5$export$3a89f8d6f6bf6c9f)(x1, x2, interpolate);
    const endY = (0, $6b000a049d919fe5$export$3a89f8d6f6bf6c9f)(y1, y2, interpolate);
    // Keep text upright if the option is selected
    let reverse = false;
    if (keepUpright) {
        if (rotation) {
            const flat = [
                beginX,
                beginY,
                endX,
                endY
            ];
            (0, $14c6e714516e527b$export$bb628a54ab399bc9)(flat, 0, 4, 2, rotation, flat, flat);
            reverse = flat[0] > flat[2];
        } else reverse = beginX > endX;
    }
    const PI = Math.PI;
    const result = [];
    const singleSegment = startOffset + stride === offset;
    offset = startOffset;
    segmentLength = 0;
    segmentM = startLength;
    x2 = flatCoordinates[offset];
    y2 = flatCoordinates[offset + 1];
    let previousAngle;
    // All on the same segment
    if (singleSegment) {
        advance();
        previousAngle = Math.atan2(y2 - y1, x2 - x1);
        if (reverse) previousAngle += previousAngle > 0 ? -PI : PI;
        const x = (endX + beginX) / 2;
        const y = (endY + beginY) / 2;
        result[0] = [
            x,
            y,
            (endM - startM) / 2,
            previousAngle,
            text
        ];
        return result;
    }
    // rendering across line segments
    text = text.replace(/\n/g, ' '); // ensure rendering in single-line as all calculations below don't handle multi-lines
    for(let i = 0, ii = text.length; i < ii;){
        advance();
        let angle = Math.atan2(y2 - y1, x2 - x1);
        if (reverse) angle += angle > 0 ? -PI : PI;
        if (previousAngle !== undefined) {
            let delta = angle - previousAngle;
            delta += delta > PI ? -2 * PI : delta < -PI ? 2 * PI : 0;
            if (Math.abs(delta) > maxAngle) return null;
        }
        previousAngle = angle;
        const iStart = i;
        let charLength = 0;
        for(; i < ii; ++i){
            const index = reverse ? ii - i - 1 : i;
            const len = scale * measureAndCacheTextWidth(font, text[index], cache);
            if (offset + stride < end && segmentM + segmentLength < startM + charLength + len / 2) break;
            charLength += len;
        }
        if (i === iStart) continue;
        const chars = reverse ? text.substring(ii - iStart, ii - i) : text.substring(iStart, i);
        interpolate = segmentLength === 0 ? 0 : (startM + charLength / 2 - segmentM) / segmentLength;
        const x = (0, $6b000a049d919fe5$export$3a89f8d6f6bf6c9f)(x1, x2, interpolate);
        const y = (0, $6b000a049d919fe5$export$3a89f8d6f6bf6c9f)(y1, y2, interpolate);
        result.push([
            x,
            y,
            charLength / 2,
            angle,
            chars
        ]);
        startM += charLength;
    }
    return result;
}








/**
 * @typedef {import('../../structs/RBush.js').Entry<import('../../Feature.js').FeatureLike>} DeclutterEntry
 */ /**
 * @typedef {Object} ImageOrLabelDimensions
 * @property {number} drawImageX DrawImageX.
 * @property {number} drawImageY DrawImageY.
 * @property {number} drawImageW DrawImageW.
 * @property {number} drawImageH DrawImageH.
 * @property {number} originX OriginX.
 * @property {number} originY OriginY.
 * @property {Array<number>} scale Scale.
 * @property {DeclutterEntry} declutterBox DeclutterBox.
 * @property {import("../../transform.js").Transform} canvasTransform CanvasTransform.
 */ /**
 * @typedef {{0: CanvasRenderingContext2D, 1: import('../../size.js').Size, 2: import("../canvas.js").Label|HTMLImageElement|HTMLCanvasElement|HTMLVideoElement, 3: ImageOrLabelDimensions, 4: number, 5: Array<*>, 6: Array<*>}} ReplayImageOrLabelArgs
 */ /**
 * @template T
 * @typedef {function(import("../../Feature.js").FeatureLike, import("../../geom/SimpleGeometry.js").default, import("../../style/Style.js").DeclutterMode): T} FeatureCallback
 */ /**
 * @type {import("../../extent.js").Extent}
 */ const $6526fa4ee42dc39d$var$tmpExtent = (0, $6da4c8ed3074c92b$export$fe201bb3bbe031e9)();
/** @type {import("../../coordinate.js").Coordinate} */ const $6526fa4ee42dc39d$var$p1 = [];
/** @type {import("../../coordinate.js").Coordinate} */ const $6526fa4ee42dc39d$var$p2 = [];
/** @type {import("../../coordinate.js").Coordinate} */ const $6526fa4ee42dc39d$var$p3 = [];
/** @type {import("../../coordinate.js").Coordinate} */ const $6526fa4ee42dc39d$var$p4 = [];
/**
 * @param {ReplayImageOrLabelArgs} replayImageOrLabelArgs Arguments to replayImageOrLabel
 * @return {DeclutterEntry} Declutter rbush entry.
 */ function $6526fa4ee42dc39d$var$getDeclutterBox(replayImageOrLabelArgs) {
    return replayImageOrLabelArgs[3].declutterBox;
}
const $6526fa4ee42dc39d$var$rtlRegEx = new RegExp(/* eslint-disable prettier/prettier */ '[' + String.fromCharCode(0x00591) + '-' + String.fromCharCode(0x008ff) + String.fromCharCode(0x0fb1d) + '-' + String.fromCharCode(0x0fdff) + String.fromCharCode(0x0fe70) + '-' + String.fromCharCode(0x0fefc) + String.fromCharCode(0x10800) + '-' + String.fromCharCode(0x10fff) + String.fromCharCode(0x1e800) + '-' + String.fromCharCode(0x1efff) + ']');
/**
 * @param {string} text Text.
 * @param {CanvasTextAlign} align Alignment.
 * @return {number} Text alignment.
 */ function $6526fa4ee42dc39d$var$horizontalTextAlign(text, align) {
    if (align === 'start') align = $6526fa4ee42dc39d$var$rtlRegEx.test(text) ? 'right' : 'left';
    else if (align === 'end') align = $6526fa4ee42dc39d$var$rtlRegEx.test(text) ? 'left' : 'right';
    return (0, $8243e906fae47bbe$export$91a016276e4aee96)[align];
}
/**
 * @param {Array<string>} acc Accumulator.
 * @param {string} line Line of text.
 * @param {number} i Index
 * @return {Array<string>} Accumulator.
 */ function $6526fa4ee42dc39d$var$createTextChunks(acc, line, i) {
    if (i > 0) acc.push('\n', '');
    acc.push(line, '');
    return acc;
}
/**
 * Converts rich text to plain text for text along lines.
 * @param {string} result The resulting plain text.
 * @param {string} part Item of the rich text array.
 * @param {number} index Index of the item in the rich text array.
 * @return {string} The resulting plain text.
 */ function $6526fa4ee42dc39d$var$richTextToPlainText(result, part, index) {
    if (index % 2 === 0) result += part;
    return result;
}
class $6526fa4ee42dc39d$var$Executor {
    /**
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   * @param {boolean} overlaps The replay can have overlapping geometries.
   * @param {import("../canvas.js").SerializableInstructions} instructions The serializable instructions.
   * @param {boolean} [deferredRendering] Enable deferred rendering.
   */ constructor(resolution, pixelRatio, overlaps, instructions, deferredRendering){
        /**
     * @protected
     * @type {boolean}
     */ this.overlaps = overlaps;
        /**
     * @protected
     * @type {number}
     */ this.pixelRatio = pixelRatio;
        /**
     * @protected
     * @const
     * @type {number}
     */ this.resolution = resolution;
        /**
     * @private
     * @type {number}
     */ this.alignAndScaleFill_;
        /**
     * @protected
     * @type {Array<*>}
     */ this.instructions = instructions.instructions;
        /**
     * @protected
     * @type {Array<number>}
     */ this.coordinates = instructions.coordinates;
        /**
     * @private
     * @type {!Object<number,import("../../coordinate.js").Coordinate|Array<import("../../coordinate.js").Coordinate>|Array<Array<import("../../coordinate.js").Coordinate>>>}
     */ this.coordinateCache_ = {};
        /**
     * @private
     * @type {!import("../../transform.js").Transform}
     */ this.renderedTransform_ = (0, $e22e7611e69f42a9$export$185802fd694ee1f5)();
        /**
     * @protected
     * @type {Array<*>}
     */ this.hitDetectionInstructions = instructions.hitDetectionInstructions;
        /**
     * @private
     * @type {Array<number>}
     */ this.pixelCoordinates_ = null;
        /**
     * @private
     * @type {number}
     */ this.viewRotation_ = 0;
        /**
     * @type {!Object<string, import("../canvas.js").FillState>}
     */ this.fillStates = instructions.fillStates || {};
        /**
     * @type {!Object<string, import("../canvas.js").StrokeState>}
     */ this.strokeStates = instructions.strokeStates || {};
        /**
     * @type {!Object<string, import("../canvas.js").TextState>}
     */ this.textStates = instructions.textStates || {};
        /**
     * @private
     * @type {Object<string, Object<string, number>>}
     */ this.widths_ = {};
        /**
     * @private
     * @type {Object<string, import("../canvas.js").Label>}
     */ this.labels_ = {};
        /**
     * @private
     * @type {import("../canvas/ZIndexContext.js").default}
     */ this.zIndexContext_ = deferredRendering ? new (0, $c1cb593c98d2cbd0$export$2e2bcd8739ae039)() : null;
    }
    /**
   * @return {ZIndexContext} ZIndex context.
   */ getZIndexContext() {
        return this.zIndexContext_;
    }
    /**
   * @param {string|Array<string>} text Text.
   * @param {string} textKey Text style key.
   * @param {string} fillKey Fill style key.
   * @param {string} strokeKey Stroke style key.
   * @return {import("../canvas.js").Label} Label.
   */ createLabel(text, textKey, fillKey, strokeKey) {
        const key = text + textKey + fillKey + strokeKey;
        if (this.labels_[key]) return this.labels_[key];
        const strokeState = strokeKey ? this.strokeStates[strokeKey] : null;
        const fillState = fillKey ? this.fillStates[fillKey] : null;
        const textState = this.textStates[textKey];
        const pixelRatio = this.pixelRatio;
        const scale = [
            textState.scale[0] * pixelRatio,
            textState.scale[1] * pixelRatio
        ];
        const align = textState.justify ? (0, $8243e906fae47bbe$export$91a016276e4aee96)[textState.justify] : $6526fa4ee42dc39d$var$horizontalTextAlign(Array.isArray(text) ? text[0] : text, textState.textAlign || (0, $d4aabc5c971073f1$export$94d53b95641b5766));
        const strokeWidth = strokeKey && strokeState.lineWidth ? strokeState.lineWidth : 0;
        const chunks = Array.isArray(text) ? text : String(text).split('\n').reduce($6526fa4ee42dc39d$var$createTextChunks, []);
        const { width: width, height: height, widths: widths, heights: heights, lineWidths: lineWidths } = (0, $d4aabc5c971073f1$export$7d7c13020df1e791)(textState, chunks);
        const renderWidth = width + strokeWidth;
        const contextInstructions = [];
        // make canvas 2 pixels wider to account for italic text width measurement errors
        const w = (renderWidth + 2) * scale[0];
        const h = (height + strokeWidth) * scale[1];
        /** @type {import("../canvas.js").Label} */ const label = {
            width: w < 0 ? Math.floor(w) : Math.ceil(w),
            height: h < 0 ? Math.floor(h) : Math.ceil(h),
            contextInstructions: contextInstructions
        };
        if (scale[0] != 1 || scale[1] != 1) contextInstructions.push('scale', scale);
        if (strokeKey) {
            contextInstructions.push('strokeStyle', strokeState.strokeStyle);
            contextInstructions.push('lineWidth', strokeWidth);
            contextInstructions.push('lineCap', strokeState.lineCap);
            contextInstructions.push('lineJoin', strokeState.lineJoin);
            contextInstructions.push('miterLimit', strokeState.miterLimit);
            contextInstructions.push('setLineDash', [
                strokeState.lineDash
            ]);
            contextInstructions.push('lineDashOffset', strokeState.lineDashOffset);
        }
        if (fillKey) contextInstructions.push('fillStyle', fillState.fillStyle);
        contextInstructions.push('textBaseline', 'middle');
        contextInstructions.push('textAlign', 'center');
        const leftRight = 0.5 - align;
        let x = align * renderWidth + leftRight * strokeWidth;
        const strokeInstructions = [];
        const fillInstructions = [];
        let lineHeight = 0;
        let lineOffset = 0;
        let widthHeightIndex = 0;
        let lineWidthIndex = 0;
        let previousFont;
        for(let i = 0, ii = chunks.length; i < ii; i += 2){
            const text = chunks[i];
            if (text === '\n') {
                lineOffset += lineHeight;
                lineHeight = 0;
                x = align * renderWidth + leftRight * strokeWidth;
                ++lineWidthIndex;
                continue;
            }
            const font = chunks[i + 1] || textState.font;
            if (font !== previousFont) {
                if (strokeKey) strokeInstructions.push('font', font);
                if (fillKey) fillInstructions.push('font', font);
                previousFont = font;
            }
            lineHeight = Math.max(lineHeight, heights[widthHeightIndex]);
            const fillStrokeArgs = [
                text,
                x + leftRight * widths[widthHeightIndex] + align * (widths[widthHeightIndex] - lineWidths[lineWidthIndex]),
                0.5 * (strokeWidth + lineHeight) + lineOffset
            ];
            x += widths[widthHeightIndex];
            if (strokeKey) strokeInstructions.push('strokeText', fillStrokeArgs);
            if (fillKey) fillInstructions.push('fillText', fillStrokeArgs);
            ++widthHeightIndex;
        }
        Array.prototype.push.apply(contextInstructions, strokeInstructions);
        Array.prototype.push.apply(contextInstructions, fillInstructions);
        this.labels_[key] = label;
        return label;
    }
    /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import("../../coordinate.js").Coordinate} p1 1st point of the background box.
   * @param {import("../../coordinate.js").Coordinate} p2 2nd point of the background box.
   * @param {import("../../coordinate.js").Coordinate} p3 3rd point of the background box.
   * @param {import("../../coordinate.js").Coordinate} p4 4th point of the background box.
   * @param {Array<*>} fillInstruction Fill instruction.
   * @param {Array<*>} strokeInstruction Stroke instruction.
   */ replayTextBackground_(context, p1, p2, p3, p4, fillInstruction, strokeInstruction) {
        context.beginPath();
        context.moveTo.apply(context, p1);
        context.lineTo.apply(context, p2);
        context.lineTo.apply(context, p3);
        context.lineTo.apply(context, p4);
        context.lineTo.apply(context, p1);
        if (fillInstruction) {
            this.alignAndScaleFill_ = /** @type {number} */ fillInstruction[2];
            context.fillStyle = /** @type {string} */ fillInstruction[1];
            this.fill_(context);
        }
        if (strokeInstruction) {
            this.setStrokeStyle_(context, /** @type {Array<*>} */ strokeInstruction);
            context.stroke();
        }
    }
    /**
   * @private
   * @param {number} sheetWidth Width of the sprite sheet.
   * @param {number} sheetHeight Height of the sprite sheet.
   * @param {number} centerX X.
   * @param {number} centerY Y.
   * @param {number} width Width.
   * @param {number} height Height.
   * @param {number} anchorX Anchor X.
   * @param {number} anchorY Anchor Y.
   * @param {number} originX Origin X.
   * @param {number} originY Origin Y.
   * @param {number} rotation Rotation.
   * @param {import("../../size.js").Size} scale Scale.
   * @param {boolean} snapToPixel Snap to pixel.
   * @param {Array<number>} padding Padding.
   * @param {boolean} fillStroke Background fill or stroke.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @return {ImageOrLabelDimensions} Dimensions for positioning and decluttering the image or label.
   */ calculateImageOrLabelDimensions_(sheetWidth, sheetHeight, centerX, centerY, width, height, anchorX, anchorY, originX, originY, rotation, scale, snapToPixel, padding, fillStroke, feature) {
        anchorX *= scale[0];
        anchorY *= scale[1];
        let x = centerX - anchorX;
        let y = centerY - anchorY;
        const w = width + originX > sheetWidth ? sheetWidth - originX : width;
        const h = height + originY > sheetHeight ? sheetHeight - originY : height;
        const boxW = padding[3] + w * scale[0] + padding[1];
        const boxH = padding[0] + h * scale[1] + padding[2];
        const boxX = x - padding[3];
        const boxY = y - padding[0];
        if (fillStroke || rotation !== 0) {
            $6526fa4ee42dc39d$var$p1[0] = boxX;
            $6526fa4ee42dc39d$var$p4[0] = boxX;
            $6526fa4ee42dc39d$var$p1[1] = boxY;
            $6526fa4ee42dc39d$var$p2[1] = boxY;
            $6526fa4ee42dc39d$var$p2[0] = boxX + boxW;
            $6526fa4ee42dc39d$var$p3[0] = $6526fa4ee42dc39d$var$p2[0];
            $6526fa4ee42dc39d$var$p3[1] = boxY + boxH;
            $6526fa4ee42dc39d$var$p4[1] = $6526fa4ee42dc39d$var$p3[1];
        }
        let transform;
        if (rotation !== 0) {
            transform = (0, $e22e7611e69f42a9$export$f672e0b6f7222cd7)((0, $e22e7611e69f42a9$export$185802fd694ee1f5)(), centerX, centerY, 1, 1, rotation, -centerX, -centerY);
            (0, $e22e7611e69f42a9$export$5635d7ef4b8fee1c)(transform, $6526fa4ee42dc39d$var$p1);
            (0, $e22e7611e69f42a9$export$5635d7ef4b8fee1c)(transform, $6526fa4ee42dc39d$var$p2);
            (0, $e22e7611e69f42a9$export$5635d7ef4b8fee1c)(transform, $6526fa4ee42dc39d$var$p3);
            (0, $e22e7611e69f42a9$export$5635d7ef4b8fee1c)(transform, $6526fa4ee42dc39d$var$p4);
            (0, $6da4c8ed3074c92b$export$958e3e1a02eac4b6)(Math.min($6526fa4ee42dc39d$var$p1[0], $6526fa4ee42dc39d$var$p2[0], $6526fa4ee42dc39d$var$p3[0], $6526fa4ee42dc39d$var$p4[0]), Math.min($6526fa4ee42dc39d$var$p1[1], $6526fa4ee42dc39d$var$p2[1], $6526fa4ee42dc39d$var$p3[1], $6526fa4ee42dc39d$var$p4[1]), Math.max($6526fa4ee42dc39d$var$p1[0], $6526fa4ee42dc39d$var$p2[0], $6526fa4ee42dc39d$var$p3[0], $6526fa4ee42dc39d$var$p4[0]), Math.max($6526fa4ee42dc39d$var$p1[1], $6526fa4ee42dc39d$var$p2[1], $6526fa4ee42dc39d$var$p3[1], $6526fa4ee42dc39d$var$p4[1]), $6526fa4ee42dc39d$var$tmpExtent);
        } else (0, $6da4c8ed3074c92b$export$958e3e1a02eac4b6)(Math.min(boxX, boxX + boxW), Math.min(boxY, boxY + boxH), Math.max(boxX, boxX + boxW), Math.max(boxY, boxY + boxH), $6526fa4ee42dc39d$var$tmpExtent);
        if (snapToPixel) {
            x = Math.round(x);
            y = Math.round(y);
        }
        return {
            drawImageX: x,
            drawImageY: y,
            drawImageW: w,
            drawImageH: h,
            originX: originX,
            originY: originY,
            declutterBox: {
                minX: $6526fa4ee42dc39d$var$tmpExtent[0],
                minY: $6526fa4ee42dc39d$var$tmpExtent[1],
                maxX: $6526fa4ee42dc39d$var$tmpExtent[2],
                maxY: $6526fa4ee42dc39d$var$tmpExtent[3],
                value: feature
            },
            canvasTransform: transform,
            scale: scale
        };
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import('../../size.js').Size} scaledCanvasSize Scaled canvas size.
   * @param {import("../canvas.js").Label|HTMLImageElement|HTMLCanvasElement|HTMLVideoElement} imageOrLabel Image.
   * @param {ImageOrLabelDimensions} dimensions Dimensions.
   * @param {number} opacity Opacity.
   * @param {Array<*>} fillInstruction Fill instruction.
   * @param {Array<*>} strokeInstruction Stroke instruction.
   * @return {boolean} The image or label was rendered.
   */ replayImageOrLabel_(context, scaledCanvasSize, imageOrLabel, dimensions, opacity, fillInstruction, strokeInstruction) {
        const fillStroke = !!(fillInstruction || strokeInstruction);
        const box = dimensions.declutterBox;
        const strokePadding = strokeInstruction ? strokeInstruction[2] * dimensions.scale[0] / 2 : 0;
        const intersects = box.minX - strokePadding <= scaledCanvasSize[0] && box.maxX + strokePadding >= 0 && box.minY - strokePadding <= scaledCanvasSize[1] && box.maxY + strokePadding >= 0;
        if (intersects) {
            if (fillStroke) this.replayTextBackground_(context, $6526fa4ee42dc39d$var$p1, $6526fa4ee42dc39d$var$p2, $6526fa4ee42dc39d$var$p3, $6526fa4ee42dc39d$var$p4, /** @type {Array<*>} */ fillInstruction, /** @type {Array<*>} */ strokeInstruction);
            (0, $d4aabc5c971073f1$export$3cb6f3a6e49cc0ee)(context, dimensions.canvasTransform, opacity, imageOrLabel, dimensions.originX, dimensions.originY, dimensions.drawImageW, dimensions.drawImageH, dimensions.drawImageX, dimensions.drawImageY, dimensions.scale);
        }
        return true;
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} context Context.
   */ fill_(context) {
        const alignAndScale = this.alignAndScaleFill_;
        if (alignAndScale) {
            const origin = (0, $e22e7611e69f42a9$export$5635d7ef4b8fee1c)(this.renderedTransform_, [
                0,
                0
            ]);
            const repeatSize = 512 * this.pixelRatio;
            context.save();
            context.translate(origin[0] % repeatSize, origin[1] % repeatSize);
            if (alignAndScale !== 1) context.scale(alignAndScale, alignAndScale);
            context.rotate(this.viewRotation_);
        }
        context.fill();
        if (alignAndScale) context.restore();
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} context Context.
   * @param {Array<*>} instruction Instruction.
   */ setStrokeStyle_(context, instruction) {
        context.strokeStyle = /** @type {import("../../colorlike.js").ColorLike} */ instruction[1];
        if (!instruction[1]) return;
        context.lineWidth = /** @type {number} */ instruction[2];
        context.lineCap = /** @type {CanvasLineCap} */ instruction[3];
        context.lineJoin = /** @type {CanvasLineJoin} */ instruction[4];
        context.miterLimit = /** @type {number} */ instruction[5];
        context.lineDashOffset = /** @type {number} */ instruction[7];
        context.setLineDash(/** @type {Array<number>} */ instruction[6]);
    }
    /**
   * @private
   * @param {string|Array<string>} text The text to draw.
   * @param {string} textKey The key of the text state.
   * @param {string} strokeKey The key for the stroke state.
   * @param {string} fillKey The key for the fill state.
   * @return {{label: import("../canvas.js").Label, anchorX: number, anchorY: number}} The text image and its anchor.
   */ drawLabelWithPointPlacement_(text, textKey, strokeKey, fillKey) {
        const textState = this.textStates[textKey];
        const label = this.createLabel(text, textKey, fillKey, strokeKey);
        const strokeState = this.strokeStates[strokeKey];
        const pixelRatio = this.pixelRatio;
        const align = $6526fa4ee42dc39d$var$horizontalTextAlign(Array.isArray(text) ? text[0] : text, textState.textAlign || (0, $d4aabc5c971073f1$export$94d53b95641b5766));
        const baseline = (0, $8243e906fae47bbe$export$91a016276e4aee96)[textState.textBaseline || (0, $d4aabc5c971073f1$export$cf2279a1bff62eb)];
        const strokeWidth = strokeState && strokeState.lineWidth ? strokeState.lineWidth : 0;
        // Remove the 2 pixels we added in createLabel() for the anchor
        const width = label.width / pixelRatio - 2 * textState.scale[0];
        const anchorX = align * width + 2 * (0.5 - align) * strokeWidth;
        const anchorY = baseline * label.height / pixelRatio + 2 * (0.5 - baseline) * strokeWidth;
        return {
            label: label,
            anchorX: anchorX,
            anchorY: anchorY
        };
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import('../../size.js').Size} scaledCanvasSize Scaled canvas size
   * @param {import("../../transform.js").Transform} transform Transform.
   * @param {Array<*>} instructions Instructions array.
   * @param {boolean} snapToPixel Snap point symbols and text to integer pixels.
   * @param {FeatureCallback<T>} [featureCallback] Feature callback.
   * @param {import("../../extent.js").Extent} [hitExtent] Only check
   *     features that intersect this extent.
   * @param {import("rbush").default<DeclutterEntry>} [declutterTree] Declutter tree.
   * @return {T|undefined} Callback result.
   * @template T
   */ execute_(context, scaledCanvasSize, transform, instructions, snapToPixel, featureCallback, hitExtent, declutterTree) {
        const zIndexContext = this.zIndexContext_;
        /** @type {Array<number>} */ let pixelCoordinates;
        if (this.pixelCoordinates_ && (0, $b998d41b678ed5d1$export$e9bab7fafb253603)(transform, this.renderedTransform_)) pixelCoordinates = this.pixelCoordinates_;
        else {
            if (!this.pixelCoordinates_) this.pixelCoordinates_ = [];
            pixelCoordinates = (0, $14c6e714516e527b$export$b92b2dedcfff79de)(this.coordinates, 0, this.coordinates.length, 2, transform, this.pixelCoordinates_);
            (0, $e22e7611e69f42a9$export$42b4187a82d80ed0)(this.renderedTransform_, transform);
        }
        let i = 0; // instruction index
        const ii = instructions.length; // end of instructions
        let d = 0; // data index
        let dd; // end of per-instruction data
        let anchorX, anchorY, /** @type {import('../../style/Style.js').DeclutterMode} */ declutterMode, prevX, prevY, roundX, roundY, image, text, textKey, strokeKey, fillKey;
        let pendingFill = 0;
        let pendingStroke = 0;
        const coordinateCache = this.coordinateCache_;
        const viewRotation = this.viewRotation_;
        const viewRotationFromTransform = Math.round(Math.atan2(-transform[1], transform[0]) * 1e12) / 1e12;
        const state = /** @type {import("../../render.js").State} */ {
            context: context,
            pixelRatio: this.pixelRatio,
            resolution: this.resolution,
            rotation: viewRotation
        };
        // When the batch size gets too big, performance decreases. 200 is a good
        // balance between batch size and number of fill/stroke instructions.
        const batchSize = this.instructions != instructions || this.overlaps ? 0 : 200;
        let /** @type {import("../../Feature.js").FeatureLike} */ feature;
        let x, y, currentGeometry;
        while(i < ii){
            const instruction = instructions[i];
            const type = /** @type {import("./Instruction.js").default} */ instruction[0];
            switch(type){
                case (0, $cf547866e052f25b$export$2e2bcd8739ae039).BEGIN_GEOMETRY:
                    feature = /** @type {import("../../Feature.js").FeatureLike} */ instruction[1];
                    currentGeometry = instruction[3];
                    if (!feature.getGeometry()) i = /** @type {number} */ instruction[2];
                    else if (hitExtent !== undefined && !(0, $6da4c8ed3074c92b$export$7b0a31e10bbff018)(hitExtent, currentGeometry.getExtent())) i = /** @type {number} */ instruction[2] + 1;
                    else ++i;
                    if (zIndexContext) zIndexContext.zIndex = instruction[4];
                    break;
                case (0, $cf547866e052f25b$export$2e2bcd8739ae039).BEGIN_PATH:
                    if (pendingFill > batchSize) {
                        this.fill_(context);
                        pendingFill = 0;
                    }
                    if (pendingStroke > batchSize) {
                        context.stroke();
                        pendingStroke = 0;
                    }
                    if (!pendingFill && !pendingStroke) {
                        context.beginPath();
                        prevX = NaN;
                        prevY = NaN;
                    }
                    ++i;
                    break;
                case (0, $cf547866e052f25b$export$2e2bcd8739ae039).CIRCLE:
                    d = /** @type {number} */ instruction[1];
                    const x1 = pixelCoordinates[d];
                    const y1 = pixelCoordinates[d + 1];
                    const x2 = pixelCoordinates[d + 2];
                    const y2 = pixelCoordinates[d + 3];
                    const dx = x2 - x1;
                    const dy = y2 - y1;
                    const r = Math.sqrt(dx * dx + dy * dy);
                    context.moveTo(x1 + r, y1);
                    context.arc(x1, y1, r, 0, 2 * Math.PI, true);
                    ++i;
                    break;
                case (0, $cf547866e052f25b$export$2e2bcd8739ae039).CLOSE_PATH:
                    context.closePath();
                    ++i;
                    break;
                case (0, $cf547866e052f25b$export$2e2bcd8739ae039).CUSTOM:
                    d = /** @type {number} */ instruction[1];
                    dd = instruction[2];
                    const geometry = /** @type {import("../../geom/SimpleGeometry.js").default} */ instruction[3];
                    const renderer = instruction[4];
                    const fn = instruction[5];
                    state.geometry = geometry;
                    state.feature = feature;
                    if (!(i in coordinateCache)) coordinateCache[i] = [];
                    const coords = coordinateCache[i];
                    if (fn) fn(pixelCoordinates, d, dd, 2, coords);
                    else {
                        coords[0] = pixelCoordinates[d];
                        coords[1] = pixelCoordinates[d + 1];
                        coords.length = 2;
                    }
                    if (zIndexContext) zIndexContext.zIndex = instruction[6];
                    renderer(coords, state);
                    ++i;
                    break;
                case (0, $cf547866e052f25b$export$2e2bcd8739ae039).DRAW_IMAGE:
                    d = /** @type {number} */ instruction[1];
                    dd = /** @type {number} */ instruction[2];
                    image = /** @type {HTMLCanvasElement|HTMLVideoElement|HTMLImageElement} */ instruction[3];
                    // Remaining arguments in DRAW_IMAGE are in alphabetical order
                    anchorX = /** @type {number} */ instruction[4];
                    anchorY = /** @type {number} */ instruction[5];
                    let height = /** @type {number} */ instruction[6];
                    const opacity = /** @type {number} */ instruction[7];
                    const originX = /** @type {number} */ instruction[8];
                    const originY = /** @type {number} */ instruction[9];
                    const rotateWithView = /** @type {boolean} */ instruction[10];
                    let rotation = /** @type {number} */ instruction[11];
                    const scale = /** @type {import("../../size.js").Size} */ instruction[12];
                    let width = /** @type {number} */ instruction[13];
                    declutterMode = instruction[14] || 'declutter';
                    const declutterImageWithText = /** @type {{args: import("../canvas.js").DeclutterImageWithText, declutterMode: import('../../style/Style.js').DeclutterMode}} */ instruction[15];
                    if (!image && instruction.length >= 20) {
                        // create label images
                        text = /** @type {string} */ instruction[19];
                        textKey = /** @type {string} */ instruction[20];
                        strokeKey = /** @type {string} */ instruction[21];
                        fillKey = /** @type {string} */ instruction[22];
                        const labelWithAnchor = this.drawLabelWithPointPlacement_(text, textKey, strokeKey, fillKey);
                        image = labelWithAnchor.label;
                        instruction[3] = image;
                        const textOffsetX = /** @type {number} */ instruction[23];
                        anchorX = (labelWithAnchor.anchorX - textOffsetX) * this.pixelRatio;
                        instruction[4] = anchorX;
                        const textOffsetY = /** @type {number} */ instruction[24];
                        anchorY = (labelWithAnchor.anchorY - textOffsetY) * this.pixelRatio;
                        instruction[5] = anchorY;
                        height = image.height;
                        instruction[6] = height;
                        width = image.width;
                        instruction[13] = width;
                    }
                    let geometryWidths;
                    if (instruction.length > 25) geometryWidths = /** @type {number} */ instruction[25];
                    let padding, backgroundFillInstruction, backgroundStrokeInstruction;
                    if (instruction.length > 17) {
                        padding = /** @type {Array<number>} */ instruction[16];
                        backgroundFillInstruction = /** @type {Array<*>} */ instruction[17];
                        backgroundStrokeInstruction = /** @type {Array<*>} */ instruction[18];
                    } else {
                        padding = (0, $d4aabc5c971073f1$export$40a9eeef55665a40);
                        backgroundFillInstruction = null;
                        backgroundStrokeInstruction = null;
                    }
                    if (rotateWithView && viewRotationFromTransform) // Canvas is expected to be rotated to reverse view rotation.
                    rotation += viewRotation;
                    else if (!rotateWithView && !viewRotationFromTransform) // Canvas is not rotated, images need to be rotated back to be north-up.
                    rotation -= viewRotation;
                    let widthIndex = 0;
                    for(; d < dd; d += 2){
                        if (geometryWidths && geometryWidths[widthIndex++] < width / this.pixelRatio) continue;
                        const dimensions = this.calculateImageOrLabelDimensions_(image.width, image.height, pixelCoordinates[d], pixelCoordinates[d + 1], width, height, anchorX, anchorY, originX, originY, rotation, scale, snapToPixel, padding, !!backgroundFillInstruction || !!backgroundStrokeInstruction, feature);
                        /** @type {ReplayImageOrLabelArgs} */ const args = [
                            context,
                            scaledCanvasSize,
                            image,
                            dimensions,
                            opacity,
                            backgroundFillInstruction,
                            backgroundStrokeInstruction
                        ];
                        if (declutterTree) {
                            let imageArgs, imageDeclutterMode, imageDeclutterBox;
                            if (declutterImageWithText) {
                                const index = dd - d;
                                if (!declutterImageWithText[index]) {
                                    // We now have the image for an image+text combination.
                                    declutterImageWithText[index] = {
                                        args: args,
                                        declutterMode: declutterMode
                                    };
                                    continue;
                                }
                                const imageDeclutter = declutterImageWithText[index];
                                imageArgs = imageDeclutter.args;
                                imageDeclutterMode = imageDeclutter.declutterMode;
                                delete declutterImageWithText[index];
                                imageDeclutterBox = $6526fa4ee42dc39d$var$getDeclutterBox(imageArgs);
                            }
                            // We now have image and text for an image+text combination.
                            let renderImage, renderText;
                            if (imageArgs && (imageDeclutterMode !== 'declutter' || !declutterTree.collides(imageDeclutterBox))) renderImage = true;
                            if (declutterMode !== 'declutter' || !declutterTree.collides(dimensions.declutterBox)) renderText = true;
                            if (imageDeclutterMode === 'declutter' && declutterMode === 'declutter') {
                                const render = renderImage && renderText;
                                renderImage = render;
                                renderText = render;
                            }
                            if (renderImage) {
                                if (imageDeclutterMode !== 'none') declutterTree.insert(imageDeclutterBox);
                                this.replayImageOrLabel_.apply(this, imageArgs);
                            }
                            if (renderText) {
                                if (declutterMode !== 'none') declutterTree.insert(dimensions.declutterBox);
                                this.replayImageOrLabel_.apply(this, args);
                            }
                        } else this.replayImageOrLabel_.apply(this, args);
                    }
                    ++i;
                    break;
                case (0, $cf547866e052f25b$export$2e2bcd8739ae039).DRAW_CHARS:
                    const begin = /** @type {number} */ instruction[1];
                    const end = /** @type {number} */ instruction[2];
                    const baseline = /** @type {number} */ instruction[3];
                    const overflow = /** @type {number} */ instruction[4];
                    fillKey = /** @type {string} */ instruction[5];
                    const maxAngle = /** @type {number} */ instruction[6];
                    const measurePixelRatio = /** @type {number} */ instruction[7];
                    const offsetY = /** @type {number} */ instruction[8];
                    strokeKey = /** @type {string} */ instruction[9];
                    const strokeWidth = /** @type {number} */ instruction[10];
                    text = /** @type {string|Array<string>} */ instruction[11];
                    if (Array.isArray(text)) //FIXME Add support for rich text along lines
                    text = text.reduce($6526fa4ee42dc39d$var$richTextToPlainText, '');
                    textKey = /** @type {string} */ instruction[12];
                    const pixelRatioScale = [
                        /** @type {number} */ instruction[13],
                        /** @type {number} */ instruction[13]
                    ];
                    declutterMode = instruction[14] || 'declutter';
                    const textKeepUpright = /** @type {boolean} */ instruction[15];
                    const textState = this.textStates[textKey];
                    const font = textState.font;
                    const textScale = [
                        textState.scale[0] * measurePixelRatio,
                        textState.scale[1] * measurePixelRatio
                    ];
                    let cachedWidths;
                    if (font in this.widths_) cachedWidths = this.widths_[font];
                    else {
                        cachedWidths = {};
                        this.widths_[font] = cachedWidths;
                    }
                    const pathLength = (0, $bf04349d827c1d16$export$153f8c6b4d8caebc)(pixelCoordinates, begin, end, 2);
                    const textLength = Math.abs(textScale[0]) * (0, $d4aabc5c971073f1$export$915c7ba51467308f)(font, text, cachedWidths);
                    if (overflow || textLength <= pathLength) {
                        const textAlign = this.textStates[textKey].textAlign;
                        const startM = (pathLength - textLength) * $6526fa4ee42dc39d$var$horizontalTextAlign(text, textAlign);
                        const parts = (0, $f6421f31729929e6$export$153a9a17ab3e949f)(pixelCoordinates, begin, end, 2, text, startM, maxAngle, Math.abs(textScale[0]), (0, $d4aabc5c971073f1$export$915c7ba51467308f), font, cachedWidths, viewRotationFromTransform ? 0 : this.viewRotation_, textKeepUpright);
                        drawChars: if (parts) {
                            /** @type {Array<ReplayImageOrLabelArgs>} */ const replayImageOrLabelArgs = [];
                            let c, cc, chars, label, part;
                            if (strokeKey) for(c = 0, cc = parts.length; c < cc; ++c){
                                part = parts[c]; // x, y, anchorX, rotation, chunk
                                chars = /** @type {string} */ part[4];
                                label = this.createLabel(chars, textKey, '', strokeKey);
                                anchorX = /** @type {number} */ part[2] + (textScale[0] < 0 ? -strokeWidth : strokeWidth);
                                anchorY = baseline * label.height + (0.5 - baseline) * 2 * strokeWidth * textScale[1] / textScale[0] - offsetY;
                                const dimensions = this.calculateImageOrLabelDimensions_(label.width, label.height, part[0], part[1], label.width, label.height, anchorX, anchorY, 0, 0, part[3], pixelRatioScale, false, (0, $d4aabc5c971073f1$export$40a9eeef55665a40), false, feature);
                                if (declutterTree && declutterMode === 'declutter' && declutterTree.collides(dimensions.declutterBox)) break drawChars;
                                replayImageOrLabelArgs.push([
                                    context,
                                    scaledCanvasSize,
                                    label,
                                    dimensions,
                                    1,
                                    null,
                                    null
                                ]);
                            }
                            if (fillKey) for(c = 0, cc = parts.length; c < cc; ++c){
                                part = parts[c]; // x, y, anchorX, rotation, chunk
                                chars = /** @type {string} */ part[4];
                                label = this.createLabel(chars, textKey, fillKey, '');
                                anchorX = /** @type {number} */ part[2];
                                anchorY = baseline * label.height - offsetY;
                                const dimensions = this.calculateImageOrLabelDimensions_(label.width, label.height, part[0], part[1], label.width, label.height, anchorX, anchorY, 0, 0, part[3], pixelRatioScale, false, (0, $d4aabc5c971073f1$export$40a9eeef55665a40), false, feature);
                                if (declutterTree && declutterMode === 'declutter' && declutterTree.collides(dimensions.declutterBox)) break drawChars;
                                replayImageOrLabelArgs.push([
                                    context,
                                    scaledCanvasSize,
                                    label,
                                    dimensions,
                                    1,
                                    null,
                                    null
                                ]);
                            }
                            if (declutterTree && declutterMode !== 'none') declutterTree.load(replayImageOrLabelArgs.map($6526fa4ee42dc39d$var$getDeclutterBox));
                            for(let i = 0, ii = replayImageOrLabelArgs.length; i < ii; ++i)this.replayImageOrLabel_.apply(this, replayImageOrLabelArgs[i]);
                        }
                    }
                    ++i;
                    break;
                case (0, $cf547866e052f25b$export$2e2bcd8739ae039).END_GEOMETRY:
                    if (featureCallback !== undefined) {
                        feature = /** @type {import("../../Feature.js").FeatureLike} */ instruction[1];
                        const result = featureCallback(feature, currentGeometry, declutterMode);
                        if (result) return result;
                    }
                    ++i;
                    break;
                case (0, $cf547866e052f25b$export$2e2bcd8739ae039).FILL:
                    if (batchSize) pendingFill++;
                    else this.fill_(context);
                    ++i;
                    break;
                case (0, $cf547866e052f25b$export$2e2bcd8739ae039).MOVE_TO_LINE_TO:
                    d = /** @type {number} */ instruction[1];
                    dd = /** @type {number} */ instruction[2];
                    x = pixelCoordinates[d];
                    y = pixelCoordinates[d + 1];
                    context.moveTo(x, y);
                    prevX = x + 0.5 | 0;
                    prevY = y + 0.5 | 0;
                    for(d += 2; d < dd; d += 2){
                        x = pixelCoordinates[d];
                        y = pixelCoordinates[d + 1];
                        roundX = x + 0.5 | 0;
                        roundY = y + 0.5 | 0;
                        if (d == dd - 2 || roundX !== prevX || roundY !== prevY) {
                            context.lineTo(x, y);
                            prevX = roundX;
                            prevY = roundY;
                        }
                    }
                    ++i;
                    break;
                case (0, $cf547866e052f25b$export$2e2bcd8739ae039).SET_FILL_STYLE:
                    this.alignAndScaleFill_ = instruction[2];
                    if (pendingFill) {
                        this.fill_(context);
                        pendingFill = 0;
                        if (pendingStroke) {
                            context.stroke();
                            pendingStroke = 0;
                        }
                    }
                    /** @type {import("../../colorlike.js").ColorLike} */ context.fillStyle = instruction[1];
                    ++i;
                    break;
                case (0, $cf547866e052f25b$export$2e2bcd8739ae039).SET_STROKE_STYLE:
                    if (pendingStroke) {
                        context.stroke();
                        pendingStroke = 0;
                    }
                    this.setStrokeStyle_(context, /** @type {Array<*>} */ instruction);
                    ++i;
                    break;
                case (0, $cf547866e052f25b$export$2e2bcd8739ae039).STROKE:
                    if (batchSize) pendingStroke++;
                    else context.stroke();
                    ++i;
                    break;
                default:
                    ++i;
                    break;
            }
        }
        if (pendingFill) this.fill_(context);
        if (pendingStroke) context.stroke();
        return undefined;
    }
    /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import('../../size.js').Size} scaledCanvasSize Scaled canvas size.
   * @param {import("../../transform.js").Transform} transform Transform.
   * @param {number} viewRotation View rotation.
   * @param {boolean} snapToPixel Snap point symbols and text to integer pixels.
   * @param {import("rbush").default<DeclutterEntry>} [declutterTree] Declutter tree.
   */ execute(context, scaledCanvasSize, transform, viewRotation, snapToPixel, declutterTree) {
        this.viewRotation_ = viewRotation;
        this.execute_(context, scaledCanvasSize, transform, this.instructions, snapToPixel, undefined, undefined, declutterTree);
    }
    /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import("../../transform.js").Transform} transform Transform.
   * @param {number} viewRotation View rotation.
   * @param {FeatureCallback<T>} [featureCallback] Feature callback.
   * @param {import("../../extent.js").Extent} [hitExtent] Only check
   *     features that intersect this extent.
   * @return {T|undefined} Callback result.
   * @template T
   */ executeHitDetection(context, transform, viewRotation, featureCallback, hitExtent) {
        this.viewRotation_ = viewRotation;
        return this.execute_(context, [
            context.canvas.width,
            context.canvas.height
        ], transform, this.hitDetectionInstructions, true, featureCallback, hitExtent);
    }
}
var $6526fa4ee42dc39d$export$2e2bcd8739ae039 = $6526fa4ee42dc39d$var$Executor;


const $a34a824d875e4ea1$export$61b49a5ae59d663 = [
    'Polygon',
    'Circle',
    'LineString',
    'Image',
    'Text',
    'Default'
];
const $a34a824d875e4ea1$export$6195a93a6c97ce02 = [
    'Image',
    'Text'
];
const $a34a824d875e4ea1$export$d0fe61ccfaa1ca87 = $a34a824d875e4ea1$export$61b49a5ae59d663.filter((builderType)=>!$a34a824d875e4ea1$export$6195a93a6c97ce02.includes(builderType));
class $a34a824d875e4ea1$var$ExecutorGroup {
    /**
   * @param {import("../../extent.js").Extent} maxExtent Max extent for clipping. When a
   * `maxExtent` was set on the Builder for this executor group, the same `maxExtent`
   * should be set here, unless the target context does not exceed that extent (which
   * can be the case when rendering to tiles).
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   * @param {boolean} overlaps The executor group can have overlapping geometries.
   * @param {!Object<string, !Object<import("../canvas.js").BuilderType, import("../canvas.js").SerializableInstructions>>} allInstructions
   * The serializable instructions.
   * @param {number} [renderBuffer] Optional rendering buffer.
   * @param {boolean} [deferredRendering] Enable deferred rendering with renderDeferred().
   */ constructor(maxExtent, resolution, pixelRatio, overlaps, allInstructions, renderBuffer, deferredRendering){
        /**
     * @private
     * @type {import("../../extent.js").Extent}
     */ this.maxExtent_ = maxExtent;
        /**
     * @private
     * @type {boolean}
     */ this.overlaps_ = overlaps;
        /**
     * @private
     * @type {number}
     */ this.pixelRatio_ = pixelRatio;
        /**
     * @private
     * @type {number}
     */ this.resolution_ = resolution;
        /**
     * @private
     * @type {number|undefined}
     */ this.renderBuffer_ = renderBuffer;
        /**
     * @private
     * @type {!Object<string, !Object<string, import("./Executor").default>>}
     */ this.executorsByZIndex_ = {};
        /**
     * @private
     * @type {CanvasRenderingContext2D}
     */ this.hitDetectionContext_ = null;
        /**
     * @private
     * @type {import("../../transform.js").Transform}
     */ this.hitDetectionTransform_ = (0, $e22e7611e69f42a9$export$185802fd694ee1f5)();
        /**
     * @private
     * @type {CanvasRenderingContext2D}
     */ this.renderedContext_ = null;
        /**
     * @private
     * @type {Object<number, Array<import("./ZIndexContext.js").default>>}
     */ this.deferredZIndexContexts_ = {};
        this.createExecutors_(allInstructions, deferredRendering);
    }
    /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import("../../transform.js").Transform} transform Transform.
   */ clip(context, transform) {
        const flatClipCoords = this.getClipCoords(transform);
        context.beginPath();
        context.moveTo(flatClipCoords[0], flatClipCoords[1]);
        context.lineTo(flatClipCoords[2], flatClipCoords[3]);
        context.lineTo(flatClipCoords[4], flatClipCoords[5]);
        context.lineTo(flatClipCoords[6], flatClipCoords[7]);
        context.clip();
    }
    /**
   * Create executors and populate them using the provided instructions.
   * @private
   * @param {!Object<string, !Object<string, import("../canvas.js").SerializableInstructions>>} allInstructions The serializable instructions
   * @param {boolean} deferredRendering Enable deferred rendering.
   */ createExecutors_(allInstructions, deferredRendering) {
        for(const zIndex in allInstructions){
            let executors = this.executorsByZIndex_[zIndex];
            if (executors === undefined) {
                executors = {};
                this.executorsByZIndex_[zIndex] = executors;
            }
            const instructionByZindex = allInstructions[zIndex];
            for(const builderType in instructionByZindex){
                const instructions = instructionByZindex[builderType];
                executors[builderType] = new (0, $6526fa4ee42dc39d$export$2e2bcd8739ae039)(this.resolution_, this.pixelRatio_, this.overlaps_, instructions, deferredRendering);
            }
        }
    }
    /**
   * @param {Array<import("../canvas.js").BuilderType>} executors Executors.
   * @return {boolean} Has executors of the provided types.
   */ hasExecutors(executors) {
        for(const zIndex in this.executorsByZIndex_){
            const candidates = this.executorsByZIndex_[zIndex];
            for(let i = 0, ii = executors.length; i < ii; ++i){
                if (executors[i] in candidates) return true;
            }
        }
        return false;
    }
    /**
   * @param {import("../../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {number} resolution Resolution.
   * @param {number} rotation Rotation.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @param {function(import("../../Feature.js").FeatureLike, import("../../geom/SimpleGeometry.js").default, number): T} callback Feature callback.
   * @param {Array<import("../../Feature.js").FeatureLike>} declutteredFeatures Decluttered features.
   * @return {T|undefined} Callback result.
   * @template T
   */ forEachFeatureAtCoordinate(coordinate, resolution, rotation, hitTolerance, callback, declutteredFeatures) {
        hitTolerance = Math.round(hitTolerance);
        const contextSize = hitTolerance * 2 + 1;
        const transform = (0, $e22e7611e69f42a9$export$f672e0b6f7222cd7)(this.hitDetectionTransform_, hitTolerance + 0.5, hitTolerance + 0.5, 1 / resolution, -1 / resolution, -rotation, -coordinate[0], -coordinate[1]);
        const newContext = !this.hitDetectionContext_;
        if (newContext) // Refrain from adding a 'willReadFrequently' hint in the options here.
        // While it will remove the "Canvas2D: Multiple readback operations using
        // getImageData are faster with the willReadFrequently attribute set
        // to true" warnings in the console, it makes hitDetection extremely
        // slow in Chrome when there are many features on the map
        this.hitDetectionContext_ = (0, $075f937d7366f1a2$export$9e05d10eae75c464)(contextSize, contextSize);
        const context = this.hitDetectionContext_;
        if (context.canvas.width !== contextSize || context.canvas.height !== contextSize) {
            context.canvas.width = contextSize;
            context.canvas.height = contextSize;
        } else if (!newContext) context.clearRect(0, 0, contextSize, contextSize);
        /** @type {import("../../extent.js").Extent|undefined} */ let hitExtent;
        if (this.renderBuffer_ !== undefined) {
            hitExtent = (0, $6da4c8ed3074c92b$export$fe201bb3bbe031e9)();
            (0, $6da4c8ed3074c92b$export$1f820e3920fa5715)(hitExtent, coordinate);
            (0, $6da4c8ed3074c92b$export$ab1029bcae9ddb4a)(hitExtent, resolution * (this.renderBuffer_ + hitTolerance), hitExtent);
        }
        const indexes = $a34a824d875e4ea1$export$96fc84ea21b8269f(hitTolerance);
        /** @type {import("../canvas.js").BuilderType} */ let builderType;
        /**
     * @param {import("../../Feature.js").FeatureLike} feature Feature.
     * @param {import("../../geom/SimpleGeometry.js").default} geometry Geometry.
     * @param {import('../../style/Style.js').DeclutterMode} declutterMode Declutter mode.
     * @return {T|undefined} Callback result.
     */ function featureCallback(feature, geometry, declutterMode) {
            const imageData = context.getImageData(0, 0, contextSize, contextSize).data;
            for(let i = 0, ii = indexes.length; i < ii; i++)if (imageData[indexes[i]] > 0) {
                if (!declutteredFeatures || declutterMode === 'none' || builderType !== 'Image' && builderType !== 'Text' || declutteredFeatures.includes(feature)) {
                    const idx = (indexes[i] - 3) / 4;
                    const x = hitTolerance - idx % contextSize;
                    const y = hitTolerance - (idx / contextSize | 0);
                    const result = callback(feature, geometry, x * x + y * y);
                    if (result) return result;
                }
                context.clearRect(0, 0, contextSize, contextSize);
                break;
            }
            return undefined;
        }
        /** @type {Array<number>} */ const zs = Object.keys(this.executorsByZIndex_).map(Number);
        zs.sort((0, $b998d41b678ed5d1$export$fcb633242ef15540));
        let i, j, executors, executor, result;
        for(i = zs.length - 1; i >= 0; --i){
            const zIndexKey = zs[i].toString();
            executors = this.executorsByZIndex_[zIndexKey];
            for(j = $a34a824d875e4ea1$export$61b49a5ae59d663.length - 1; j >= 0; --j){
                builderType = $a34a824d875e4ea1$export$61b49a5ae59d663[j];
                executor = executors[builderType];
                if (executor !== undefined) {
                    result = executor.executeHitDetection(context, transform, rotation, featureCallback, hitExtent);
                    if (result) return result;
                }
            }
        }
        return undefined;
    }
    /**
   * @param {import("../../transform.js").Transform} transform Transform.
   * @return {Array<number>|null} Clip coordinates.
   */ getClipCoords(transform) {
        const maxExtent = this.maxExtent_;
        if (!maxExtent) return null;
        const minX = maxExtent[0];
        const minY = maxExtent[1];
        const maxX = maxExtent[2];
        const maxY = maxExtent[3];
        const flatClipCoords = [
            minX,
            minY,
            minX,
            maxY,
            maxX,
            maxY,
            maxX,
            minY
        ];
        (0, $14c6e714516e527b$export$b92b2dedcfff79de)(flatClipCoords, 0, 8, 2, transform, flatClipCoords);
        return flatClipCoords;
    }
    /**
   * @return {boolean} Is empty.
   */ isEmpty() {
        return (0, $beaefe87199bb537$export$dd1bc94b04021eeb)(this.executorsByZIndex_);
    }
    /**
   * @param {CanvasRenderingContext2D} targetContext Context.
   * @param {import('../../size.js').Size} scaledCanvasSize Scale of the context.
   * @param {import("../../transform.js").Transform} transform Transform.
   * @param {number} viewRotation View rotation.
   * @param {boolean} snapToPixel Snap point symbols and test to integer pixel.
   * @param {Array<import("../canvas.js").BuilderType>} [builderTypes] Ordered replay types to replay.
   *     Default is {@link module:ol/render/replay~ALL}
   * @param {import("rbush").default<import('./Executor.js').DeclutterEntry>|null} [declutterTree] Declutter tree.
   *     When set to null, no decluttering is done, even when the executor group has a `ZIndexContext`.
   */ execute(targetContext, scaledCanvasSize, transform, viewRotation, snapToPixel, builderTypes, declutterTree) {
        const zs = Object.keys(this.executorsByZIndex_).map(Number);
        zs.sort(declutterTree ? (0, $b998d41b678ed5d1$export$4fa3190a997c3d8f) : (0, $b998d41b678ed5d1$export$fcb633242ef15540));
        builderTypes = builderTypes ? builderTypes : $a34a824d875e4ea1$export$61b49a5ae59d663;
        const maxBuilderTypes = $a34a824d875e4ea1$export$61b49a5ae59d663.length;
        for(let i = 0, ii = zs.length; i < ii; ++i){
            const zIndexKey = zs[i].toString();
            const replays = this.executorsByZIndex_[zIndexKey];
            for(let j = 0, jj = builderTypes.length; j < jj; ++j){
                const builderType = builderTypes[j];
                const replay = replays[builderType];
                if (replay !== undefined) {
                    const zIndexContext = declutterTree === null ? undefined : replay.getZIndexContext();
                    const context = zIndexContext ? zIndexContext.getContext() : targetContext;
                    const requireClip = this.maxExtent_ && builderType !== 'Image' && builderType !== 'Text';
                    if (requireClip) {
                        context.save();
                        // setup clipping so that the parts of over-simplified geometries are not
                        // visible outside the current extent when panning
                        this.clip(context, transform);
                    }
                    if (!zIndexContext || builderType === 'Text' || builderType === 'Image') replay.execute(context, scaledCanvasSize, transform, viewRotation, snapToPixel, declutterTree);
                    else zIndexContext.pushFunction((context)=>replay.execute(context, scaledCanvasSize, transform, viewRotation, snapToPixel, declutterTree));
                    if (requireClip) context.restore();
                    if (zIndexContext) {
                        zIndexContext.offset();
                        const index = zs[i] * maxBuilderTypes + $a34a824d875e4ea1$export$61b49a5ae59d663.indexOf(builderType);
                        if (!this.deferredZIndexContexts_[index]) this.deferredZIndexContexts_[index] = [];
                        this.deferredZIndexContexts_[index].push(zIndexContext);
                    }
                }
            }
        }
        this.renderedContext_ = targetContext;
    }
    getDeferredZIndexContexts() {
        return this.deferredZIndexContexts_;
    }
    getRenderedContext() {
        return this.renderedContext_;
    }
    renderDeferred() {
        const deferredZIndexContexts = this.deferredZIndexContexts_;
        const zs = Object.keys(deferredZIndexContexts).map(Number).sort((0, $b998d41b678ed5d1$export$fcb633242ef15540));
        for(let i = 0, ii = zs.length; i < ii; ++i){
            deferredZIndexContexts[zs[i]].forEach((zIndexContext)=>{
                zIndexContext.draw(this.renderedContext_); // FIXME Pass clip to replay for temporarily enabling clip
                zIndexContext.clear();
            });
            deferredZIndexContexts[zs[i]].length = 0;
        }
    }
}
/**
 * This cache is used to store arrays of indexes for calculated pixel circles
 * to increase performance.
 * It is a static property to allow each Replaygroup to access it.
 * @type {Object<number, Array<number>>}
 */ const $a34a824d875e4ea1$var$circlePixelIndexArrayCache = {};
function $a34a824d875e4ea1$export$96fc84ea21b8269f(radius) {
    if ($a34a824d875e4ea1$var$circlePixelIndexArrayCache[radius] !== undefined) return $a34a824d875e4ea1$var$circlePixelIndexArrayCache[radius];
    const size = radius * 2 + 1;
    const maxDistanceSq = radius * radius;
    const distances = new Array(maxDistanceSq + 1);
    for(let i = 0; i <= radius; ++i)for(let j = 0; j <= radius; ++j){
        const distanceSq = i * i + j * j;
        if (distanceSq > maxDistanceSq) break;
        let distance = distances[distanceSq];
        if (!distance) {
            distance = [];
            distances[distanceSq] = distance;
        }
        distance.push(((radius + i) * size + (radius + j)) * 4 + 3);
        if (i > 0) distance.push(((radius - i) * size + (radius + j)) * 4 + 3);
        if (j > 0) {
            distance.push(((radius + i) * size + (radius - j)) * 4 + 3);
            if (i > 0) distance.push(((radius - i) * size + (radius - j)) * 4 + 3);
        }
    }
    const pixelIndex = [];
    for(let i = 0, ii = distances.length; i < ii; ++i)if (distances[i]) pixelIndex.push(...distances[i]);
    $a34a824d875e4ea1$var$circlePixelIndexArrayCache[radius] = pixelIndex;
    return pixelIndex;
}
var $a34a824d875e4ea1$export$2e2bcd8739ae039 = $a34a824d875e4ea1$var$ExecutorGroup;


/**
 * @module ol/render/canvas/hitdetect
 */ 





/**
 * @module ol/render/canvas/Immediate
 */ // FIXME test, especially polygons with holes and multipolygons
// FIXME need to handle large thick features (where pixel size matters)
// FIXME add offset and end to ol/geom/flat/transform~transform2D?









/**
 * @classdesc
 * A concrete subclass of {@link module:ol/render/VectorContext~VectorContext} that implements
 * direct rendering of features and geometries to an HTML5 Canvas context.
 * Instances of this class are created internally by the library and
 * provided to application code as vectorContext member of the
 * {@link module:ol/render/Event~RenderEvent} object associated with postcompose, precompose and
 * render events emitted by layers and maps.
 */ class $7b0c2128a27f5020$var$CanvasImmediateRenderer extends (0, $eb0e5c3938110b4c$export$2e2bcd8739ae039) {
    /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../../extent.js").Extent} extent Extent.
   * @param {import("../../transform.js").Transform} transform Transform.
   * @param {number} viewRotation View rotation.
   * @param {number} [squaredTolerance] Optional squared tolerance for simplification.
   * @param {import("../../proj.js").TransformFunction} [userTransform] Transform from user to view projection.
   */ constructor(context, pixelRatio, extent, transform, viewRotation, squaredTolerance, userTransform){
        super();
        /**
     * @private
     * @type {CanvasRenderingContext2D}
     */ this.context_ = context;
        /**
     * @private
     * @type {number}
     */ this.pixelRatio_ = pixelRatio;
        /**
     * @private
     * @type {import("../../extent.js").Extent}
     */ this.extent_ = extent;
        /**
     * @private
     * @type {import("../../transform.js").Transform}
     */ this.transform_ = transform;
        /**
     * @private
     * @type {number}
     */ this.transformRotation_ = transform ? (0, $6b000a049d919fe5$export$a81f732198733497)(Math.atan2(transform[1], transform[0]), 10) : 0;
        /**
     * @private
     * @type {number}
     */ this.viewRotation_ = viewRotation;
        /**
     * @private
     * @type {number}
     */ this.squaredTolerance_ = squaredTolerance;
        /**
     * @private
     * @type {import("../../proj.js").TransformFunction}
     */ this.userTransform_ = userTransform;
        /**
     * @private
     * @type {?import("../canvas.js").FillState}
     */ this.contextFillState_ = null;
        /**
     * @private
     * @type {?import("../canvas.js").StrokeState}
     */ this.contextStrokeState_ = null;
        /**
     * @private
     * @type {?import("../canvas.js").TextState}
     */ this.contextTextState_ = null;
        /**
     * @private
     * @type {?import("../canvas.js").FillState}
     */ this.fillState_ = null;
        /**
     * @private
     * @type {?import("../canvas.js").StrokeState}
     */ this.strokeState_ = null;
        /**
     * @private
     * @type {import('../../DataTile.js').ImageLike}
     */ this.image_ = null;
        /**
     * @private
     * @type {number}
     */ this.imageAnchorX_ = 0;
        /**
     * @private
     * @type {number}
     */ this.imageAnchorY_ = 0;
        /**
     * @private
     * @type {number}
     */ this.imageHeight_ = 0;
        /**
     * @private
     * @type {number}
     */ this.imageOpacity_ = 0;
        /**
     * @private
     * @type {number}
     */ this.imageOriginX_ = 0;
        /**
     * @private
     * @type {number}
     */ this.imageOriginY_ = 0;
        /**
     * @private
     * @type {boolean}
     */ this.imageRotateWithView_ = false;
        /**
     * @private
     * @type {number}
     */ this.imageRotation_ = 0;
        /**
     * @private
     * @type {import("../../size.js").Size}
     */ this.imageScale_ = [
            0,
            0
        ];
        /**
     * @private
     * @type {number}
     */ this.imageWidth_ = 0;
        /**
     * @private
     * @type {string}
     */ this.text_ = '';
        /**
     * @private
     * @type {number}
     */ this.textOffsetX_ = 0;
        /**
     * @private
     * @type {number}
     */ this.textOffsetY_ = 0;
        /**
     * @private
     * @type {boolean}
     */ this.textRotateWithView_ = false;
        /**
     * @private
     * @type {number}
     */ this.textRotation_ = 0;
        /**
     * @private
     * @type {import("../../size.js").Size}
     */ this.textScale_ = [
            0,
            0
        ];
        /**
     * @private
     * @type {?import("../canvas.js").FillState}
     */ this.textFillState_ = null;
        /**
     * @private
     * @type {?import("../canvas.js").StrokeState}
     */ this.textStrokeState_ = null;
        /**
     * @private
     * @type {?import("../canvas.js").TextState}
     */ this.textState_ = null;
        /**
     * @private
     * @type {Array<number>}
     */ this.pixelCoordinates_ = [];
        /**
     * @private
     * @type {import("../../transform.js").Transform}
     */ this.tmpLocalTransform_ = (0, $e22e7611e69f42a9$export$185802fd694ee1f5)();
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {number} end End.
   * @param {number} stride Stride.
   * @private
   */ drawImages_(flatCoordinates, offset, end, stride) {
        if (!this.image_) return;
        const pixelCoordinates = (0, $14c6e714516e527b$export$b92b2dedcfff79de)(flatCoordinates, offset, end, stride, this.transform_, this.pixelCoordinates_);
        const context = this.context_;
        const localTransform = this.tmpLocalTransform_;
        const alpha = context.globalAlpha;
        if (this.imageOpacity_ != 1) context.globalAlpha = alpha * this.imageOpacity_;
        let rotation = this.imageRotation_;
        if (this.transformRotation_ === 0) rotation -= this.viewRotation_;
        if (this.imageRotateWithView_) rotation += this.viewRotation_;
        for(let i = 0, ii = pixelCoordinates.length; i < ii; i += 2){
            const x = pixelCoordinates[i] - this.imageAnchorX_;
            const y = pixelCoordinates[i + 1] - this.imageAnchorY_;
            if (rotation !== 0 || this.imageScale_[0] != 1 || this.imageScale_[1] != 1) {
                const centerX = x + this.imageAnchorX_;
                const centerY = y + this.imageAnchorY_;
                (0, $e22e7611e69f42a9$export$f672e0b6f7222cd7)(localTransform, centerX, centerY, 1, 1, rotation, -centerX, -centerY);
                context.save();
                context.transform.apply(context, localTransform);
                context.translate(centerX, centerY);
                context.scale(this.imageScale_[0], this.imageScale_[1]);
                context.drawImage(this.image_, this.imageOriginX_, this.imageOriginY_, this.imageWidth_, this.imageHeight_, -this.imageAnchorX_, -this.imageAnchorY_, this.imageWidth_, this.imageHeight_);
                context.restore();
            } else context.drawImage(this.image_, this.imageOriginX_, this.imageOriginY_, this.imageWidth_, this.imageHeight_, x, y, this.imageWidth_, this.imageHeight_);
        }
        if (this.imageOpacity_ != 1) context.globalAlpha = alpha;
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {number} end End.
   * @param {number} stride Stride.
   * @private
   */ drawText_(flatCoordinates, offset, end, stride) {
        if (!this.textState_ || this.text_ === '') return;
        if (this.textFillState_) this.setContextFillState_(this.textFillState_);
        if (this.textStrokeState_) this.setContextStrokeState_(this.textStrokeState_);
        this.setContextTextState_(this.textState_);
        const pixelCoordinates = (0, $14c6e714516e527b$export$b92b2dedcfff79de)(flatCoordinates, offset, end, stride, this.transform_, this.pixelCoordinates_);
        const context = this.context_;
        let rotation = this.textRotation_;
        if (this.transformRotation_ === 0) rotation -= this.viewRotation_;
        if (this.textRotateWithView_) rotation += this.viewRotation_;
        for(; offset < end; offset += stride){
            const x = pixelCoordinates[offset] + this.textOffsetX_;
            const y = pixelCoordinates[offset + 1] + this.textOffsetY_;
            if (rotation !== 0 || this.textScale_[0] != 1 || this.textScale_[1] != 1) {
                context.save();
                context.translate(x - this.textOffsetX_, y - this.textOffsetY_);
                context.rotate(rotation);
                context.translate(this.textOffsetX_, this.textOffsetY_);
                context.scale(this.textScale_[0], this.textScale_[1]);
                if (this.textStrokeState_) context.strokeText(this.text_, 0, 0);
                if (this.textFillState_) context.fillText(this.text_, 0, 0);
                context.restore();
            } else {
                if (this.textStrokeState_) context.strokeText(this.text_, x, y);
                if (this.textFillState_) context.fillText(this.text_, x, y);
            }
        }
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {number} end End.
   * @param {number} stride Stride.
   * @param {boolean} close Close.
   * @private
   * @return {number} end End.
   */ moveToLineTo_(flatCoordinates, offset, end, stride, close) {
        const context = this.context_;
        const pixelCoordinates = (0, $14c6e714516e527b$export$b92b2dedcfff79de)(flatCoordinates, offset, end, stride, this.transform_, this.pixelCoordinates_);
        context.moveTo(pixelCoordinates[0], pixelCoordinates[1]);
        let length = pixelCoordinates.length;
        if (close) length -= 2;
        for(let i = 2; i < length; i += 2)context.lineTo(pixelCoordinates[i], pixelCoordinates[i + 1]);
        if (close) context.closePath();
        return end;
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {Array<number>} ends Ends.
   * @param {number} stride Stride.
   * @private
   * @return {number} End.
   */ drawRings_(flatCoordinates, offset, ends, stride) {
        for(let i = 0, ii = ends.length; i < ii; ++i)offset = this.moveToLineTo_(flatCoordinates, offset, ends[i], stride, true);
        return offset;
    }
    /**
   * Render a circle geometry into the canvas.  Rendering is immediate and uses
   * the current fill and stroke styles.
   *
   * @param {import("../../geom/Circle.js").default} geometry Circle geometry.
   * @api
   * @override
   */ drawCircle(geometry) {
        if (this.squaredTolerance_) geometry = /** @type {import("../../geom/Circle.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
        if (!(0, $6da4c8ed3074c92b$export$7b0a31e10bbff018)(this.extent_, geometry.getExtent())) return;
        if (this.fillState_ || this.strokeState_) {
            if (this.fillState_) this.setContextFillState_(this.fillState_);
            if (this.strokeState_) this.setContextStrokeState_(this.strokeState_);
            const pixelCoordinates = (0, $c76e993e57efc8c4$export$a3767472617c7861)(geometry, this.transform_, this.pixelCoordinates_);
            const dx = pixelCoordinates[2] - pixelCoordinates[0];
            const dy = pixelCoordinates[3] - pixelCoordinates[1];
            const radius = Math.sqrt(dx * dx + dy * dy);
            const context = this.context_;
            context.beginPath();
            context.arc(pixelCoordinates[0], pixelCoordinates[1], radius, 0, 2 * Math.PI);
            if (this.fillState_) context.fill();
            if (this.strokeState_) context.stroke();
        }
        if (this.text_ !== '') this.drawText_(geometry.getCenter(), 0, 2, 2);
    }
    /**
   * Set the rendering style.  Note that since this is an immediate rendering API,
   * any `zIndex` on the provided style will be ignored.
   *
   * @param {import("../../style/Style.js").default} style The rendering style.
   * @api
   * @override
   */ setStyle(style) {
        this.setFillStrokeStyle(style.getFill(), style.getStroke());
        this.setImageStyle(style.getImage());
        this.setTextStyle(style.getText());
    }
    /**
   * @param {import("../../transform.js").Transform} transform Transform.
   */ setTransform(transform) {
        this.transform_ = transform;
    }
    /**
   * Render a geometry into the canvas.  Call
   * {@link module:ol/render/canvas/Immediate~CanvasImmediateRenderer#setStyle renderer.setStyle()} first to set the rendering style.
   *
   * @param {import("../../geom/Geometry.js").default|import("../Feature.js").default} geometry The geometry to render.
   * @api
   * @override
   */ drawGeometry(geometry) {
        const type = geometry.getType();
        switch(type){
            case 'Point':
                this.drawPoint(/** @type {import("../../geom/Point.js").default} */ geometry);
                break;
            case 'LineString':
                this.drawLineString(/** @type {import("../../geom/LineString.js").default} */ geometry);
                break;
            case 'Polygon':
                this.drawPolygon(/** @type {import("../../geom/Polygon.js").default} */ geometry);
                break;
            case 'MultiPoint':
                this.drawMultiPoint(/** @type {import("../../geom/MultiPoint.js").default} */ geometry);
                break;
            case 'MultiLineString':
                this.drawMultiLineString(/** @type {import("../../geom/MultiLineString.js").default} */ geometry);
                break;
            case 'MultiPolygon':
                this.drawMultiPolygon(/** @type {import("../../geom/MultiPolygon.js").default} */ geometry);
                break;
            case 'GeometryCollection':
                this.drawGeometryCollection(/** @type {import("../../geom/GeometryCollection.js").default} */ geometry);
                break;
            case 'Circle':
                this.drawCircle(/** @type {import("../../geom/Circle.js").default} */ geometry);
                break;
            default:
        }
    }
    /**
   * Render a feature into the canvas.  Note that any `zIndex` on the provided
   * style will be ignored - features are rendered immediately in the order that
   * this method is called.  If you need `zIndex` support, you should be using an
   * {@link module:ol/layer/Vector~VectorLayer} instead.
   *
   * @param {import("../../Feature.js").default} feature Feature.
   * @param {import("../../style/Style.js").default} style Style.
   * @api
   * @override
   */ drawFeature(feature, style) {
        const geometry = style.getGeometryFunction()(feature);
        if (!geometry) return;
        this.setStyle(style);
        this.drawGeometry(geometry);
    }
    /**
   * Render a GeometryCollection to the canvas.  Rendering is immediate and
   * uses the current styles appropriate for each geometry in the collection.
   *
   * @param {import("../../geom/GeometryCollection.js").default} geometry Geometry collection.
   * @override
   */ drawGeometryCollection(geometry) {
        const geometries = geometry.getGeometriesArray();
        for(let i = 0, ii = geometries.length; i < ii; ++i)this.drawGeometry(geometries[i]);
    }
    /**
   * Render a Point geometry into the canvas.  Rendering is immediate and uses
   * the current style.
   *
   * @param {import("../../geom/Point.js").default|import("../Feature.js").default} geometry Point geometry.
   * @override
   */ drawPoint(geometry) {
        if (this.squaredTolerance_) geometry = /** @type {import("../../geom/Point.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
        const flatCoordinates = geometry.getFlatCoordinates();
        const stride = geometry.getStride();
        if (this.image_) this.drawImages_(flatCoordinates, 0, flatCoordinates.length, stride);
        if (this.text_ !== '') this.drawText_(flatCoordinates, 0, flatCoordinates.length, stride);
    }
    /**
   * Render a MultiPoint geometry  into the canvas.  Rendering is immediate and
   * uses the current style.
   *
   * @param {import("../../geom/MultiPoint.js").default|import("../Feature.js").default} geometry MultiPoint geometry.
   * @override
   */ drawMultiPoint(geometry) {
        if (this.squaredTolerance_) geometry = /** @type {import("../../geom/MultiPoint.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
        const flatCoordinates = geometry.getFlatCoordinates();
        const stride = geometry.getStride();
        if (this.image_) this.drawImages_(flatCoordinates, 0, flatCoordinates.length, stride);
        if (this.text_ !== '') this.drawText_(flatCoordinates, 0, flatCoordinates.length, stride);
    }
    /**
   * Render a LineString into the canvas.  Rendering is immediate and uses
   * the current style.
   *
   * @param {import("../../geom/LineString.js").default|import("../Feature.js").default} geometry LineString geometry.
   * @override
   */ drawLineString(geometry) {
        if (this.squaredTolerance_) geometry = /** @type {import("../../geom/LineString.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
        if (!(0, $6da4c8ed3074c92b$export$7b0a31e10bbff018)(this.extent_, geometry.getExtent())) return;
        if (this.strokeState_) {
            this.setContextStrokeState_(this.strokeState_);
            const context = this.context_;
            const flatCoordinates = geometry.getFlatCoordinates();
            context.beginPath();
            this.moveToLineTo_(flatCoordinates, 0, flatCoordinates.length, geometry.getStride(), false);
            context.stroke();
        }
        if (this.text_ !== '') {
            const flatMidpoint = geometry.getFlatMidpoint();
            this.drawText_(flatMidpoint, 0, 2, 2);
        }
    }
    /**
   * Render a MultiLineString geometry into the canvas.  Rendering is immediate
   * and uses the current style.
   *
   * @param {import("../../geom/MultiLineString.js").default|import("../Feature.js").default} geometry MultiLineString geometry.
   * @override
   */ drawMultiLineString(geometry) {
        if (this.squaredTolerance_) geometry = /** @type {import("../../geom/MultiLineString.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
        const geometryExtent = geometry.getExtent();
        if (!(0, $6da4c8ed3074c92b$export$7b0a31e10bbff018)(this.extent_, geometryExtent)) return;
        if (this.strokeState_) {
            this.setContextStrokeState_(this.strokeState_);
            const context = this.context_;
            const flatCoordinates = geometry.getFlatCoordinates();
            let offset = 0;
            const ends = /** @type {Array<number>} */ geometry.getEnds();
            const stride = geometry.getStride();
            context.beginPath();
            for(let i = 0, ii = ends.length; i < ii; ++i)offset = this.moveToLineTo_(flatCoordinates, offset, ends[i], stride, false);
            context.stroke();
        }
        if (this.text_ !== '') {
            const flatMidpoints = geometry.getFlatMidpoints();
            this.drawText_(flatMidpoints, 0, flatMidpoints.length, 2);
        }
    }
    /**
   * Render a Polygon geometry into the canvas.  Rendering is immediate and uses
   * the current style.
   *
   * @param {import("../../geom/Polygon.js").default|import("../Feature.js").default} geometry Polygon geometry.
   * @override
   */ drawPolygon(geometry) {
        if (this.squaredTolerance_) geometry = /** @type {import("../../geom/Polygon.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
        if (!(0, $6da4c8ed3074c92b$export$7b0a31e10bbff018)(this.extent_, geometry.getExtent())) return;
        if (this.strokeState_ || this.fillState_) {
            if (this.fillState_) this.setContextFillState_(this.fillState_);
            if (this.strokeState_) this.setContextStrokeState_(this.strokeState_);
            const context = this.context_;
            context.beginPath();
            this.drawRings_(geometry.getOrientedFlatCoordinates(), 0, /** @type {Array<number>} */ geometry.getEnds(), geometry.getStride());
            if (this.fillState_) context.fill();
            if (this.strokeState_) context.stroke();
        }
        if (this.text_ !== '') {
            const flatInteriorPoint = geometry.getFlatInteriorPoint();
            this.drawText_(flatInteriorPoint, 0, 2, 2);
        }
    }
    /**
   * Render MultiPolygon geometry into the canvas.  Rendering is immediate and
   * uses the current style.
   * @param {import("../../geom/MultiPolygon.js").default} geometry MultiPolygon geometry.
   * @override
   */ drawMultiPolygon(geometry) {
        if (this.squaredTolerance_) geometry = /** @type {import("../../geom/MultiPolygon.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
        if (!(0, $6da4c8ed3074c92b$export$7b0a31e10bbff018)(this.extent_, geometry.getExtent())) return;
        if (this.strokeState_ || this.fillState_) {
            if (this.fillState_) this.setContextFillState_(this.fillState_);
            if (this.strokeState_) this.setContextStrokeState_(this.strokeState_);
            const context = this.context_;
            const flatCoordinates = geometry.getOrientedFlatCoordinates();
            let offset = 0;
            const endss = geometry.getEndss();
            const stride = geometry.getStride();
            context.beginPath();
            for(let i = 0, ii = endss.length; i < ii; ++i){
                const ends = endss[i];
                offset = this.drawRings_(flatCoordinates, offset, ends, stride);
            }
            if (this.fillState_) context.fill();
            if (this.strokeState_) context.stroke();
        }
        if (this.text_ !== '') {
            const flatInteriorPoints = geometry.getFlatInteriorPoints();
            this.drawText_(flatInteriorPoints, 0, flatInteriorPoints.length, 2);
        }
    }
    /**
   * @param {import("../canvas.js").FillState} fillState Fill state.
   * @private
   */ setContextFillState_(fillState) {
        const context = this.context_;
        const contextFillState = this.contextFillState_;
        if (!contextFillState) {
            context.fillStyle = fillState.fillStyle;
            this.contextFillState_ = {
                fillStyle: fillState.fillStyle
            };
        } else if (contextFillState.fillStyle != fillState.fillStyle) {
            contextFillState.fillStyle = fillState.fillStyle;
            context.fillStyle = fillState.fillStyle;
        }
    }
    /**
   * @param {import("../canvas.js").StrokeState} strokeState Stroke state.
   * @private
   */ setContextStrokeState_(strokeState) {
        const context = this.context_;
        const contextStrokeState = this.contextStrokeState_;
        if (!contextStrokeState) {
            context.lineCap = strokeState.lineCap;
            context.setLineDash(strokeState.lineDash);
            context.lineDashOffset = strokeState.lineDashOffset;
            context.lineJoin = strokeState.lineJoin;
            context.lineWidth = strokeState.lineWidth;
            context.miterLimit = strokeState.miterLimit;
            context.strokeStyle = strokeState.strokeStyle;
            this.contextStrokeState_ = {
                lineCap: strokeState.lineCap,
                lineDash: strokeState.lineDash,
                lineDashOffset: strokeState.lineDashOffset,
                lineJoin: strokeState.lineJoin,
                lineWidth: strokeState.lineWidth,
                miterLimit: strokeState.miterLimit,
                strokeStyle: strokeState.strokeStyle
            };
        } else {
            if (contextStrokeState.lineCap != strokeState.lineCap) {
                contextStrokeState.lineCap = strokeState.lineCap;
                context.lineCap = strokeState.lineCap;
            }
            if (!(0, $b998d41b678ed5d1$export$e9bab7fafb253603)(contextStrokeState.lineDash, strokeState.lineDash)) context.setLineDash(contextStrokeState.lineDash = strokeState.lineDash);
            if (contextStrokeState.lineDashOffset != strokeState.lineDashOffset) {
                contextStrokeState.lineDashOffset = strokeState.lineDashOffset;
                context.lineDashOffset = strokeState.lineDashOffset;
            }
            if (contextStrokeState.lineJoin != strokeState.lineJoin) {
                contextStrokeState.lineJoin = strokeState.lineJoin;
                context.lineJoin = strokeState.lineJoin;
            }
            if (contextStrokeState.lineWidth != strokeState.lineWidth) {
                contextStrokeState.lineWidth = strokeState.lineWidth;
                context.lineWidth = strokeState.lineWidth;
            }
            if (contextStrokeState.miterLimit != strokeState.miterLimit) {
                contextStrokeState.miterLimit = strokeState.miterLimit;
                context.miterLimit = strokeState.miterLimit;
            }
            if (contextStrokeState.strokeStyle != strokeState.strokeStyle) {
                contextStrokeState.strokeStyle = strokeState.strokeStyle;
                context.strokeStyle = strokeState.strokeStyle;
            }
        }
    }
    /**
   * @param {import("../canvas.js").TextState} textState Text state.
   * @private
   */ setContextTextState_(textState) {
        const context = this.context_;
        const contextTextState = this.contextTextState_;
        const textAlign = textState.textAlign ? textState.textAlign : (0, $d4aabc5c971073f1$export$94d53b95641b5766);
        if (!contextTextState) {
            context.font = textState.font;
            context.textAlign = textAlign;
            context.textBaseline = textState.textBaseline;
            this.contextTextState_ = {
                font: textState.font,
                textAlign: textAlign,
                textBaseline: textState.textBaseline
            };
        } else {
            if (contextTextState.font != textState.font) {
                contextTextState.font = textState.font;
                context.font = textState.font;
            }
            if (contextTextState.textAlign != textAlign) {
                contextTextState.textAlign = textAlign;
                context.textAlign = textAlign;
            }
            if (contextTextState.textBaseline != textState.textBaseline) {
                contextTextState.textBaseline = textState.textBaseline;
                context.textBaseline = textState.textBaseline;
            }
        }
    }
    /**
   * Set the fill and stroke style for subsequent draw operations.  To clear
   * either fill or stroke styles, pass null for the appropriate parameter.
   *
   * @param {import("../../style/Fill.js").default} fillStyle Fill style.
   * @param {import("../../style/Stroke.js").default} strokeStyle Stroke style.
   * @override
   */ setFillStrokeStyle(fillStyle, strokeStyle) {
        if (!fillStyle) this.fillState_ = null;
        else {
            const fillStyleColor = fillStyle.getColor();
            this.fillState_ = {
                fillStyle: (0, $e0807f400ec9a0a9$export$dc5b1400ac3a10a8)(fillStyleColor ? fillStyleColor : (0, $d4aabc5c971073f1$export$c495d52ee3fd74b2))
            };
        }
        if (!strokeStyle) this.strokeState_ = null;
        else {
            const strokeStyleColor = strokeStyle.getColor();
            const strokeStyleLineCap = strokeStyle.getLineCap();
            const strokeStyleLineDash = strokeStyle.getLineDash();
            const strokeStyleLineDashOffset = strokeStyle.getLineDashOffset();
            const strokeStyleLineJoin = strokeStyle.getLineJoin();
            const strokeStyleWidth = strokeStyle.getWidth();
            const strokeStyleMiterLimit = strokeStyle.getMiterLimit();
            const lineDash = strokeStyleLineDash ? strokeStyleLineDash : (0, $d4aabc5c971073f1$export$e21b4112fdc612fc);
            this.strokeState_ = {
                lineCap: strokeStyleLineCap !== undefined ? strokeStyleLineCap : (0, $d4aabc5c971073f1$export$17bd0c38d6ae694e),
                lineDash: this.pixelRatio_ === 1 ? lineDash : lineDash.map((n)=>n * this.pixelRatio_),
                lineDashOffset: (strokeStyleLineDashOffset ? strokeStyleLineDashOffset : (0, $d4aabc5c971073f1$export$e06efc2409049f76)) * this.pixelRatio_,
                lineJoin: strokeStyleLineJoin !== undefined ? strokeStyleLineJoin : (0, $d4aabc5c971073f1$export$365eb9648cf19bd0),
                lineWidth: (strokeStyleWidth !== undefined ? strokeStyleWidth : (0, $d4aabc5c971073f1$export$79661f132c62010e)) * this.pixelRatio_,
                miterLimit: strokeStyleMiterLimit !== undefined ? strokeStyleMiterLimit : (0, $d4aabc5c971073f1$export$80c1c01844597b7b),
                strokeStyle: (0, $e0807f400ec9a0a9$export$dc5b1400ac3a10a8)(strokeStyleColor ? strokeStyleColor : (0, $d4aabc5c971073f1$export$1eb2eaecacf2031e))
            };
        }
    }
    /**
   * Set the image style for subsequent draw operations.  Pass null to remove
   * the image style.
   *
   * @param {import("../../style/Image.js").default} imageStyle Image style.
   * @override
   */ setImageStyle(imageStyle) {
        let imageSize;
        if (!imageStyle || !(imageSize = imageStyle.getSize())) {
            this.image_ = null;
            return;
        }
        const imagePixelRatio = imageStyle.getPixelRatio(this.pixelRatio_);
        const imageAnchor = imageStyle.getAnchor();
        const imageOrigin = imageStyle.getOrigin();
        this.image_ = imageStyle.getImage(this.pixelRatio_);
        this.imageAnchorX_ = imageAnchor[0] * imagePixelRatio;
        this.imageAnchorY_ = imageAnchor[1] * imagePixelRatio;
        this.imageHeight_ = imageSize[1] * imagePixelRatio;
        this.imageOpacity_ = imageStyle.getOpacity();
        this.imageOriginX_ = imageOrigin[0];
        this.imageOriginY_ = imageOrigin[1];
        this.imageRotateWithView_ = imageStyle.getRotateWithView();
        this.imageRotation_ = imageStyle.getRotation();
        const imageScale = imageStyle.getScaleArray();
        this.imageScale_ = [
            imageScale[0] * this.pixelRatio_ / imagePixelRatio,
            imageScale[1] * this.pixelRatio_ / imagePixelRatio
        ];
        this.imageWidth_ = imageSize[0] * imagePixelRatio;
    }
    /**
   * Set the text style for subsequent draw operations.  Pass null to
   * remove the text style.
   *
   * @param {import("../../style/Text.js").default} textStyle Text style.
   * @override
   */ setTextStyle(textStyle) {
        if (!textStyle) this.text_ = '';
        else {
            const textFillStyle = textStyle.getFill();
            if (!textFillStyle) this.textFillState_ = null;
            else {
                const textFillStyleColor = textFillStyle.getColor();
                this.textFillState_ = {
                    fillStyle: (0, $e0807f400ec9a0a9$export$dc5b1400ac3a10a8)(textFillStyleColor ? textFillStyleColor : (0, $d4aabc5c971073f1$export$c495d52ee3fd74b2))
                };
            }
            const textStrokeStyle = textStyle.getStroke();
            if (!textStrokeStyle) this.textStrokeState_ = null;
            else {
                const textStrokeStyleColor = textStrokeStyle.getColor();
                const textStrokeStyleLineCap = textStrokeStyle.getLineCap();
                const textStrokeStyleLineDash = textStrokeStyle.getLineDash();
                const textStrokeStyleLineDashOffset = textStrokeStyle.getLineDashOffset();
                const textStrokeStyleLineJoin = textStrokeStyle.getLineJoin();
                const textStrokeStyleWidth = textStrokeStyle.getWidth();
                const textStrokeStyleMiterLimit = textStrokeStyle.getMiterLimit();
                this.textStrokeState_ = {
                    lineCap: textStrokeStyleLineCap !== undefined ? textStrokeStyleLineCap : (0, $d4aabc5c971073f1$export$17bd0c38d6ae694e),
                    lineDash: textStrokeStyleLineDash ? textStrokeStyleLineDash : (0, $d4aabc5c971073f1$export$e21b4112fdc612fc),
                    lineDashOffset: textStrokeStyleLineDashOffset ? textStrokeStyleLineDashOffset : (0, $d4aabc5c971073f1$export$e06efc2409049f76),
                    lineJoin: textStrokeStyleLineJoin !== undefined ? textStrokeStyleLineJoin : (0, $d4aabc5c971073f1$export$365eb9648cf19bd0),
                    lineWidth: textStrokeStyleWidth !== undefined ? textStrokeStyleWidth : (0, $d4aabc5c971073f1$export$79661f132c62010e),
                    miterLimit: textStrokeStyleMiterLimit !== undefined ? textStrokeStyleMiterLimit : (0, $d4aabc5c971073f1$export$80c1c01844597b7b),
                    strokeStyle: (0, $e0807f400ec9a0a9$export$dc5b1400ac3a10a8)(textStrokeStyleColor ? textStrokeStyleColor : (0, $d4aabc5c971073f1$export$1eb2eaecacf2031e))
                };
            }
            const textFont = textStyle.getFont();
            const textOffsetX = textStyle.getOffsetX();
            const textOffsetY = textStyle.getOffsetY();
            const textRotateWithView = textStyle.getRotateWithView();
            const textRotation = textStyle.getRotation();
            const textScale = textStyle.getScaleArray();
            const textText = textStyle.getText();
            const textTextAlign = textStyle.getTextAlign();
            const textTextBaseline = textStyle.getTextBaseline();
            this.textState_ = {
                font: textFont !== undefined ? textFont : (0, $d4aabc5c971073f1$export$3847dfea4f8d4dfa),
                textAlign: textTextAlign !== undefined ? textTextAlign : (0, $d4aabc5c971073f1$export$94d53b95641b5766),
                textBaseline: textTextBaseline !== undefined ? textTextBaseline : (0, $d4aabc5c971073f1$export$cf2279a1bff62eb)
            };
            this.text_ = textText !== undefined ? Array.isArray(textText) ? textText.reduce((acc, t, i)=>acc += i % 2 ? ' ' : t, '') : textText : '';
            this.textOffsetX_ = textOffsetX !== undefined ? this.pixelRatio_ * textOffsetX : 0;
            this.textOffsetY_ = textOffsetY !== undefined ? this.pixelRatio_ * textOffsetY : 0;
            this.textRotateWithView_ = textRotateWithView !== undefined ? textRotateWithView : false;
            this.textRotation_ = textRotation !== undefined ? textRotation : 0;
            this.textScale_ = [
                this.pixelRatio_ * textScale[0],
                this.pixelRatio_ * textScale[1]
            ];
        }
    }
}
var $7b0c2128a27f5020$export$2e2bcd8739ae039 = $7b0c2128a27f5020$var$CanvasImmediateRenderer;


const $13dfa0283bf5c35f$export$ab51038298418f25 = 0.5;
function $13dfa0283bf5c35f$export$bd05e394339d469(size, transforms, features, styleFunction, extent, resolution, rotation, squaredTolerance, projection) {
    const userExtent = projection ? (0, $9c4744460e43e41b$export$96bfd09e2cffb006)(extent, projection) : extent;
    const width = size[0] * $13dfa0283bf5c35f$export$ab51038298418f25;
    const height = size[1] * $13dfa0283bf5c35f$export$ab51038298418f25;
    const context = (0, $075f937d7366f1a2$export$9e05d10eae75c464)(width, height);
    context.imageSmoothingEnabled = false;
    const canvas = context.canvas;
    const renderer = new (0, $7b0c2128a27f5020$export$2e2bcd8739ae039)(context, $13dfa0283bf5c35f$export$ab51038298418f25, extent, null, rotation, squaredTolerance, projection ? (0, $9c4744460e43e41b$export$e3c4995a701c26a3)((0, $9c4744460e43e41b$export$3973b77d5f6f2790)(), projection) : null);
    const featureCount = features.length;
    // Stretch hit detection index to use the whole available color range
    const indexFactor = Math.floor(16777215 / featureCount);
    const featuresByZIndex = {};
    for(let i = 1; i <= featureCount; ++i){
        const feature = features[i - 1];
        const featureStyleFunction = feature.getStyleFunction() || styleFunction;
        if (!featureStyleFunction) continue;
        let styles = featureStyleFunction(feature, resolution);
        if (!styles) continue;
        if (!Array.isArray(styles)) styles = [
            styles
        ];
        const index = i * indexFactor;
        const color = index.toString(16).padStart(7, '#00000');
        for(let j = 0, jj = styles.length; j < jj; ++j){
            const originalStyle = styles[j];
            const geometry = originalStyle.getGeometryFunction()(feature);
            if (!geometry || !(0, $6da4c8ed3074c92b$export$7b0a31e10bbff018)(userExtent, geometry.getExtent())) continue;
            const style = originalStyle.clone();
            const fill = style.getFill();
            if (fill) fill.setColor(color);
            const stroke = style.getStroke();
            if (stroke) {
                stroke.setColor(color);
                stroke.setLineDash(null);
            }
            style.setText(undefined);
            const image = originalStyle.getImage();
            if (image) {
                const imgSize = image.getImageSize();
                if (!imgSize) continue;
                const imgContext = (0, $075f937d7366f1a2$export$9e05d10eae75c464)(imgSize[0], imgSize[1], undefined, {
                    alpha: false
                });
                const img = imgContext.canvas;
                imgContext.fillStyle = color;
                imgContext.fillRect(0, 0, img.width, img.height);
                style.setImage(new (0, $8463d325b53eeb0c$export$2e2bcd8739ae039)({
                    img: img,
                    anchor: image.getAnchor(),
                    anchorXUnits: 'pixels',
                    anchorYUnits: 'pixels',
                    offset: image.getOrigin(),
                    opacity: 1,
                    size: image.getSize(),
                    scale: image.getScale(),
                    rotation: image.getRotation(),
                    rotateWithView: image.getRotateWithView()
                }));
            }
            const zIndex = style.getZIndex() || 0;
            let byGeometryType = featuresByZIndex[zIndex];
            if (!byGeometryType) {
                byGeometryType = {};
                featuresByZIndex[zIndex] = byGeometryType;
                byGeometryType['Polygon'] = [];
                byGeometryType['Circle'] = [];
                byGeometryType['LineString'] = [];
                byGeometryType['Point'] = [];
            }
            const type = geometry.getType();
            if (type === 'GeometryCollection') {
                const geometries = /** @type {import("../../geom/GeometryCollection.js").default} */ geometry.getGeometriesArrayRecursive();
                for(let i = 0, ii = geometries.length; i < ii; ++i){
                    const geometry = geometries[i];
                    byGeometryType[geometry.getType().replace('Multi', '')].push(geometry, style);
                }
            } else byGeometryType[type.replace('Multi', '')].push(geometry, style);
        }
    }
    const zIndexKeys = Object.keys(featuresByZIndex).map(Number).sort((0, $b998d41b678ed5d1$export$fcb633242ef15540));
    for(let i = 0, ii = zIndexKeys.length; i < ii; ++i){
        const byGeometryType = featuresByZIndex[zIndexKeys[i]];
        for(const type in byGeometryType){
            const geomAndStyle = byGeometryType[type];
            for(let j = 0, jj = geomAndStyle.length; j < jj; j += 2){
                renderer.setStyle(geomAndStyle[j + 1]);
                for(let k = 0, kk = transforms.length; k < kk; ++k){
                    renderer.setTransform(transforms[k]);
                    renderer.drawGeometry(geomAndStyle[j]);
                }
            }
        }
    }
    return context.getImageData(0, 0, canvas.width, canvas.height);
}
function $13dfa0283bf5c35f$export$6d4d555ddbfffa32(pixel, features, imageData) {
    /** @type {Array<F>} */ const resultFeatures = [];
    if (imageData) {
        const x = Math.floor(Math.round(pixel[0]) * $13dfa0283bf5c35f$export$ab51038298418f25);
        const y = Math.floor(Math.round(pixel[1]) * $13dfa0283bf5c35f$export$ab51038298418f25);
        // The pixel coordinate is clamped down to the hit-detect canvas' size to account
        // for browsers returning coordinates slightly larger than the actual canvas size
        // due to a non-integer pixel ratio.
        const index = ((0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(x, 0, imageData.width - 1) + (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(y, 0, imageData.height - 1) * imageData.width) * 4;
        const r = imageData.data[index];
        const g = imageData.data[index + 1];
        const b = imageData.data[index + 2];
        const i = b + 256 * (g + 256 * r);
        const indexFactor = Math.floor(16777215 / features.length);
        if (i && i % indexFactor === 0) resultFeatures.push(features[i / indexFactor - 1]);
    }
    return resultFeatures;
}



/**
 * @module ol/renderer/vector
 */ 

/**
 * Feature callback. The callback will be called with three arguments. The first
 * argument is one {@link module:ol/Feature~Feature feature} or {@link module:ol/render/Feature~RenderFeature render feature}
 * at the pixel, the second is the {@link module:ol/layer/Layer~Layer layer} of the feature and will be null for
 * unmanaged layers. The third is the {@link module:ol/geom/SimpleGeometry~SimpleGeometry} of the feature. For features
 * with a GeometryCollection geometry, it will be the first detected geometry from the collection.
 * @template T
 * @typedef {function(import("../Feature.js").FeatureLike, import("../layer/Layer.js").default<import("../source/Source").default>, import("../geom/SimpleGeometry.js").default): T} FeatureCallback
 */ /**
 * Tolerance for geometry simplification in device pixels.
 * @type {number}
 */ const $4b9ac454600c05d2$var$SIMPLIFY_TOLERANCE = 0.5;
/**
 * @const
 * @type {Object<import("../geom/Geometry.js").Type,
 *                function(import("../render/canvas/BuilderGroup.js").default, import("../geom/Geometry.js").default,
 *                         import("../style/Style.js").default, Object): void>}
 */ const $4b9ac454600c05d2$var$GEOMETRY_RENDERERS = {
    'Point': $4b9ac454600c05d2$var$renderPointGeometry,
    'LineString': $4b9ac454600c05d2$var$renderLineStringGeometry,
    'Polygon': $4b9ac454600c05d2$var$renderPolygonGeometry,
    'MultiPoint': $4b9ac454600c05d2$var$renderMultiPointGeometry,
    'MultiLineString': $4b9ac454600c05d2$var$renderMultiLineStringGeometry,
    'MultiPolygon': $4b9ac454600c05d2$var$renderMultiPolygonGeometry,
    'GeometryCollection': $4b9ac454600c05d2$var$renderGeometryCollectionGeometry,
    'Circle': $4b9ac454600c05d2$var$renderCircleGeometry
};
function $4b9ac454600c05d2$export$531ddd8416d52dfc(feature1, feature2) {
    return parseInt((0, $6c5e11070e371322$export$5e82334337e0f204)(feature1), 10) - parseInt((0, $6c5e11070e371322$export$5e82334337e0f204)(feature2), 10);
}
function $4b9ac454600c05d2$export$75084a70d324c1e6(resolution, pixelRatio) {
    const tolerance = $4b9ac454600c05d2$export$bdacc5b475012edb(resolution, pixelRatio);
    return tolerance * tolerance;
}
function $4b9ac454600c05d2$export$bdacc5b475012edb(resolution, pixelRatio) {
    return $4b9ac454600c05d2$var$SIMPLIFY_TOLERANCE * resolution / pixelRatio;
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Builder group.
 * @param {import("../geom/Circle.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").default} feature Feature.
 * @param {number} [index] Render order index.
 */ function $4b9ac454600c05d2$var$renderCircleGeometry(builderGroup, geometry, style, feature, index) {
    const fillStyle = style.getFill();
    const strokeStyle = style.getStroke();
    if (fillStyle || strokeStyle) {
        const circleReplay = builderGroup.getBuilder(style.getZIndex(), 'Circle');
        circleReplay.setFillStrokeStyle(fillStyle, strokeStyle);
        circleReplay.drawCircle(geometry, feature, index);
    }
    const textStyle = style.getText();
    if (textStyle && textStyle.getText()) {
        const textReplay = builderGroup.getBuilder(style.getZIndex(), 'Text');
        textReplay.setTextStyle(textStyle);
        textReplay.drawText(geometry, feature);
    }
}
function $4b9ac454600c05d2$export$36f470a33a42f413(replayGroup, feature, style, squaredTolerance, listener, transform, declutter, index) {
    const loadingPromises = [];
    const imageStyle = style.getImage();
    if (imageStyle) {
        let loading = true;
        const imageState = imageStyle.getImageState();
        if (imageState == (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADED || imageState == (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).ERROR) loading = false;
        else if (imageState == (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).IDLE) imageStyle.load();
        if (loading) loadingPromises.push(imageStyle.ready());
    }
    const fillStyle = style.getFill();
    if (fillStyle && fillStyle.loading()) loadingPromises.push(fillStyle.ready());
    const loading = loadingPromises.length > 0;
    if (loading) Promise.all(loadingPromises).then(()=>listener(null));
    $4b9ac454600c05d2$var$renderFeatureInternal(replayGroup, feature, style, squaredTolerance, transform, declutter, index);
    return loading;
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} replayGroup Replay group.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {import("../style/Style.js").default} style Style.
 * @param {number} squaredTolerance Squared tolerance.
 * @param {import("../proj.js").TransformFunction} [transform] Optional transform function.
 * @param {boolean} [declutter] Enable decluttering.
 * @param {number} [index] Render order index..
 */ function $4b9ac454600c05d2$var$renderFeatureInternal(replayGroup, feature, style, squaredTolerance, transform, declutter, index) {
    const geometry = style.getGeometryFunction()(feature);
    if (!geometry) return;
    const simplifiedGeometry = geometry.simplifyTransformed(squaredTolerance, transform);
    const renderer = style.getRenderer();
    if (renderer) $4b9ac454600c05d2$var$renderGeometry(replayGroup, simplifiedGeometry, style, feature, index);
    else {
        const geometryRenderer = $4b9ac454600c05d2$var$GEOMETRY_RENDERERS[simplifiedGeometry.getType()];
        geometryRenderer(replayGroup, simplifiedGeometry, style, feature, index, declutter);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} replayGroup Replay group.
 * @param {import("../geom/Geometry.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {number} [index] Render order index.
 */ function $4b9ac454600c05d2$var$renderGeometry(replayGroup, geometry, style, feature, index) {
    if (geometry.getType() == 'GeometryCollection') {
        const geometries = /** @type {import("../geom/GeometryCollection.js").default} */ geometry.getGeometries();
        for(let i = 0, ii = geometries.length; i < ii; ++i)$4b9ac454600c05d2$var$renderGeometry(replayGroup, geometries[i], style, feature, index);
        return;
    }
    const replay = replayGroup.getBuilder(style.getZIndex(), 'Default');
    replay.drawCustom(/** @type {import("../geom/SimpleGeometry.js").default} */ geometry, feature, style.getRenderer(), style.getHitDetectionRenderer(), index);
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} replayGroup Replay group.
 * @param {import("../geom/GeometryCollection.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").default} feature Feature.
 * @param {import("../render/canvas/BuilderGroup.js").default} [declutterBuilderGroup] Builder for decluttering.
 * @param {number} [index] Render order index.
 */ function $4b9ac454600c05d2$var$renderGeometryCollectionGeometry(replayGroup, geometry, style, feature, declutterBuilderGroup, index) {
    const geometries = geometry.getGeometriesArray();
    let i, ii;
    for(i = 0, ii = geometries.length; i < ii; ++i){
        const geometryRenderer = $4b9ac454600c05d2$var$GEOMETRY_RENDERERS[geometries[i].getType()];
        geometryRenderer(replayGroup, geometries[i], style, feature, declutterBuilderGroup, index);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
 * @param {import("../geom/LineString.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {number} [index] Render order index.
 */ function $4b9ac454600c05d2$var$renderLineStringGeometry(builderGroup, geometry, style, feature, index) {
    const strokeStyle = style.getStroke();
    if (strokeStyle) {
        const lineStringReplay = builderGroup.getBuilder(style.getZIndex(), 'LineString');
        lineStringReplay.setFillStrokeStyle(null, strokeStyle);
        lineStringReplay.drawLineString(geometry, feature, index);
    }
    const textStyle = style.getText();
    if (textStyle && textStyle.getText()) {
        const textReplay = builderGroup.getBuilder(style.getZIndex(), 'Text');
        textReplay.setTextStyle(textStyle);
        textReplay.drawText(geometry, feature, index);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
 * @param {import("../geom/MultiLineString.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {number} [index] Render order index.
 */ function $4b9ac454600c05d2$var$renderMultiLineStringGeometry(builderGroup, geometry, style, feature, index) {
    const strokeStyle = style.getStroke();
    if (strokeStyle) {
        const lineStringReplay = builderGroup.getBuilder(style.getZIndex(), 'LineString');
        lineStringReplay.setFillStrokeStyle(null, strokeStyle);
        lineStringReplay.drawMultiLineString(geometry, feature, index);
    }
    const textStyle = style.getText();
    if (textStyle && textStyle.getText()) {
        const textReplay = builderGroup.getBuilder(style.getZIndex(), 'Text');
        textReplay.setTextStyle(textStyle);
        textReplay.drawText(geometry, feature, index);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
 * @param {import("../geom/MultiPolygon.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").default} feature Feature.
 * @param {number} [index] Render order index.
 */ function $4b9ac454600c05d2$var$renderMultiPolygonGeometry(builderGroup, geometry, style, feature, index) {
    const fillStyle = style.getFill();
    const strokeStyle = style.getStroke();
    if (strokeStyle || fillStyle) {
        const polygonReplay = builderGroup.getBuilder(style.getZIndex(), 'Polygon');
        polygonReplay.setFillStrokeStyle(fillStyle, strokeStyle);
        polygonReplay.drawMultiPolygon(geometry, feature, index);
    }
    const textStyle = style.getText();
    if (textStyle && textStyle.getText()) {
        const textReplay = builderGroup.getBuilder(style.getZIndex(), 'Text');
        textReplay.setTextStyle(textStyle);
        textReplay.drawText(geometry, feature, index);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
 * @param {import("../geom/Point.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {number} [index] Render order index.
 * @param {boolean} [declutter] Enable decluttering.
 */ function $4b9ac454600c05d2$var$renderPointGeometry(builderGroup, geometry, style, feature, index, declutter) {
    const imageStyle = style.getImage();
    const textStyle = style.getText();
    const hasText = textStyle && textStyle.getText();
    /** @type {import("../render/canvas.js").DeclutterImageWithText} */ const declutterImageWithText = declutter && imageStyle && hasText ? {} : undefined;
    if (imageStyle) {
        if (imageStyle.getImageState() != (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADED) return;
        const imageReplay = builderGroup.getBuilder(style.getZIndex(), 'Image');
        imageReplay.setImageStyle(imageStyle, declutterImageWithText);
        imageReplay.drawPoint(geometry, feature, index);
    }
    if (hasText) {
        const textReplay = builderGroup.getBuilder(style.getZIndex(), 'Text');
        textReplay.setTextStyle(textStyle, declutterImageWithText);
        textReplay.drawText(geometry, feature, index);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
 * @param {import("../geom/MultiPoint.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {number} [index] Render order index.
 * @param {boolean} [declutter] Enable decluttering.
 */ function $4b9ac454600c05d2$var$renderMultiPointGeometry(builderGroup, geometry, style, feature, index, declutter) {
    const imageStyle = style.getImage();
    const hasImage = imageStyle && imageStyle.getOpacity() !== 0;
    const textStyle = style.getText();
    const hasText = textStyle && textStyle.getText();
    /** @type {import("../render/canvas.js").DeclutterImageWithText} */ const declutterImageWithText = declutter && hasImage && hasText ? {} : undefined;
    if (hasImage) {
        if (imageStyle.getImageState() != (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADED) return;
        const imageReplay = builderGroup.getBuilder(style.getZIndex(), 'Image');
        imageReplay.setImageStyle(imageStyle, declutterImageWithText);
        imageReplay.drawMultiPoint(geometry, feature, index);
    }
    if (hasText) {
        const textReplay = builderGroup.getBuilder(style.getZIndex(), 'Text');
        textReplay.setTextStyle(textStyle, declutterImageWithText);
        textReplay.drawText(geometry, feature, index);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
 * @param {import("../geom/Polygon.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {number} [index] Render order index.
 */ function $4b9ac454600c05d2$var$renderPolygonGeometry(builderGroup, geometry, style, feature, index) {
    const fillStyle = style.getFill();
    const strokeStyle = style.getStroke();
    if (fillStyle || strokeStyle) {
        const polygonReplay = builderGroup.getBuilder(style.getZIndex(), 'Polygon');
        polygonReplay.setFillStrokeStyle(fillStyle, strokeStyle);
        polygonReplay.drawPolygon(geometry, feature, index);
    }
    const textStyle = style.getText();
    if (textStyle && textStyle.getText()) {
        const textReplay = builderGroup.getBuilder(style.getZIndex(), 'Text');
        textReplay.setTextStyle(textStyle);
        textReplay.drawText(geometry, feature, index);
    }
}



/**
 * @classdesc
 * Canvas renderer for vector layers.
 * @api
 */ class $659e0e97392a5f5e$var$CanvasVectorLayerRenderer extends (0, $42152f52b26b6ca7$export$2e2bcd8739ae039) {
    /**
   * @param {import("../../layer/BaseVector.js").default} vectorLayer Vector layer.
   */ constructor(vectorLayer){
        super(vectorLayer);
        /** @private */ this.boundHandleStyleImageChange_ = this.handleStyleImageChange_.bind(this);
        /**
     * @private
     * @type {boolean}
     */ this.animatingOrInteracting_;
        /**
     * @private
     * @type {ImageData|null}
     */ this.hitDetectionImageData_ = null;
        /**
     * @private
     * @type {boolean}
     */ this.clipped_ = false;
        /**
     * @private
     * @type {Array<import("../../Feature.js").default>}
     */ this.renderedFeatures_ = null;
        /**
     * @private
     * @type {number}
     */ this.renderedRevision_ = -1;
        /**
     * @private
     * @type {number}
     */ this.renderedResolution_ = NaN;
        /**
     * @private
     * @type {import("../../extent.js").Extent}
     */ this.renderedExtent_ = (0, $6da4c8ed3074c92b$export$fe201bb3bbe031e9)();
        /**
     * @private
     * @type {import("../../extent.js").Extent}
     */ this.wrappedRenderedExtent_ = (0, $6da4c8ed3074c92b$export$fe201bb3bbe031e9)();
        /**
     * @private
     * @type {number}
     */ this.renderedRotation_;
        /**
     * @private
     * @type {import("../../coordinate").Coordinate}
     */ this.renderedCenter_ = null;
        /**
     * @private
     * @type {import("../../proj/Projection").default}
     */ this.renderedProjection_ = null;
        /**
     * @private
     * @type {number}
     */ this.renderedPixelRatio_ = 1;
        /**
     * @private
     * @type {import("../../render.js").OrderFunction|null}
     */ this.renderedRenderOrder_ = null;
        /**
     * @private
     * @type {boolean}
     */ this.renderedFrameDeclutter_;
        /**
     * @private
     * @type {import("../../render/canvas/ExecutorGroup").default}
     */ this.replayGroup_ = null;
        /**
     * A new replay group had to be created by `prepareFrame()`
     * @type {boolean}
     */ this.replayGroupChanged = true;
        /**
     * Clipping to be performed by `renderFrame()`
     * @type {boolean}
     */ this.clipping = true;
        /**
     * @private
     * @type {CanvasRenderingContext2D}
     */ this.targetContext_ = null;
        /**
     * @private
     * @type {number}
     */ this.opacity_ = 1;
    }
    /**
   * @param {ExecutorGroup} executorGroup Executor group.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {boolean} [declutterable] `true` to only render declutterable items,
   *     `false` to only render non-declutterable items, `undefined` to render all.
   */ renderWorlds(executorGroup, frameState, declutterable) {
        const extent = frameState.extent;
        const viewState = frameState.viewState;
        const center = viewState.center;
        const resolution = viewState.resolution;
        const projection = viewState.projection;
        const rotation = viewState.rotation;
        const projectionExtent = projection.getExtent();
        const vectorSource = this.getLayer().getSource();
        const declutter = this.getLayer().getDeclutter();
        const pixelRatio = frameState.pixelRatio;
        const viewHints = frameState.viewHints;
        const snapToPixel = !(viewHints[(0, $7d362782b4ccb93d$export$2e2bcd8739ae039).ANIMATING] || viewHints[(0, $7d362782b4ccb93d$export$2e2bcd8739ae039).INTERACTING]);
        const context = this.context;
        const width = Math.round((0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(extent) / resolution * pixelRatio);
        const height = Math.round((0, $6da4c8ed3074c92b$export$c08559766941f856)(extent) / resolution * pixelRatio);
        const multiWorld = vectorSource.getWrapX() && projection.canWrapX();
        const worldWidth = multiWorld ? (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(projectionExtent) : null;
        const endWorld = multiWorld ? Math.ceil((extent[2] - projectionExtent[2]) / worldWidth) + 1 : 1;
        let world = multiWorld ? Math.floor((extent[0] - projectionExtent[0]) / worldWidth) : 0;
        do {
            let transform = this.getRenderTransform(center, resolution, 0, pixelRatio, width, height, world * worldWidth);
            if (frameState.declutter) transform = transform.slice(0);
            executorGroup.execute(context, [
                context.canvas.width,
                context.canvas.height
            ], transform, rotation, snapToPixel, declutterable === undefined ? (0, $a34a824d875e4ea1$export$61b49a5ae59d663) : declutterable ? (0, $a34a824d875e4ea1$export$6195a93a6c97ce02) : (0, $a34a824d875e4ea1$export$d0fe61ccfaa1ca87), declutterable ? declutter && frameState.declutter[declutter] : undefined);
        }while (++world < endWorld);
    }
    /**
   * @private
   */ setDrawContext_() {
        if (this.opacity_ !== 1) {
            this.targetContext_ = this.context;
            this.context = (0, $075f937d7366f1a2$export$9e05d10eae75c464)(this.context.canvas.width, this.context.canvas.height, (0, $42152f52b26b6ca7$export$a166f0857c555517));
        }
    }
    /**
   * @private
   */ resetDrawContext_() {
        if (this.opacity_ !== 1 && this.targetContext_) {
            const alpha = this.targetContext_.globalAlpha;
            this.targetContext_.globalAlpha = this.opacity_;
            this.targetContext_.drawImage(this.context.canvas, 0, 0);
            this.targetContext_.globalAlpha = alpha;
            (0, $075f937d7366f1a2$export$e918ac6a1026a12a)(this.context);
            (0, $42152f52b26b6ca7$export$a166f0857c555517).push(this.context.canvas);
            this.context = this.targetContext_;
            this.targetContext_ = null;
        }
    }
    /**
   * Render declutter items for this layer
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   */ renderDeclutter(frameState) {
        if (!this.replayGroup_ || !this.getLayer().getDeclutter()) return;
        this.renderWorlds(this.replayGroup_, frameState, true);
    }
    /**
   * Render deferred instructions.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @override
   */ renderDeferredInternal(frameState) {
        if (!this.replayGroup_) return;
        this.replayGroup_.renderDeferred();
        if (this.clipped_) this.context.restore();
        this.resetDrawContext_();
    }
    /**
   * Render the layer.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {HTMLElement|null} target Target that may be used to render content to.
   * @return {HTMLElement} The rendered element.
   * @override
   */ renderFrame(frameState, target) {
        const layerState = frameState.layerStatesArray[frameState.layerIndex];
        this.opacity_ = layerState.opacity;
        const viewState = frameState.viewState;
        this.prepareContainer(frameState, target);
        const context = this.context;
        const replayGroup = this.replayGroup_;
        let render = replayGroup && !replayGroup.isEmpty();
        if (!render) {
            const hasRenderListeners = this.getLayer().hasListener((0, $f5e92a4d985a2824$export$2e2bcd8739ae039).PRERENDER) || this.getLayer().hasListener((0, $f5e92a4d985a2824$export$2e2bcd8739ae039).POSTRENDER);
            if (!hasRenderListeners) return this.container;
        }
        this.setDrawContext_();
        this.preRender(context, frameState);
        const projection = viewState.projection;
        // clipped rendering if layer extent is set
        this.clipped_ = false;
        if (render && layerState.extent && this.clipping) {
            const layerExtent = (0, $9c4744460e43e41b$export$494be3a3a25689ca)(layerState.extent, projection);
            render = (0, $6da4c8ed3074c92b$export$7b0a31e10bbff018)(layerExtent, frameState.extent);
            this.clipped_ = render && !(0, $6da4c8ed3074c92b$export$be866b1e0809b17e)(layerExtent, frameState.extent);
            if (this.clipped_) this.clipUnrotated(context, frameState, layerExtent);
        }
        if (render) this.renderWorlds(replayGroup, frameState, this.getLayer().getDeclutter() ? false : undefined);
        if (!frameState.declutter && this.clipped_) context.restore();
        this.postRender(context, frameState);
        if (this.renderedRotation_ !== viewState.rotation) {
            this.renderedRotation_ = viewState.rotation;
            this.hitDetectionImageData_ = null;
        }
        if (!frameState.declutter) this.resetDrawContext_();
        return this.container;
    }
    /**
   * Asynchronous layer level hit detection.
   * @param {import("../../pixel.js").Pixel} pixel Pixel.
   * @return {Promise<Array<import("../../Feature").default>>} Promise
   * that resolves with an array of features.
   * @override
   */ getFeatures(pixel) {
        return new Promise((resolve)=>{
            if (this.frameState && !this.hitDetectionImageData_ && !this.animatingOrInteracting_) {
                const size = this.frameState.size.slice();
                const center = this.renderedCenter_;
                const resolution = this.renderedResolution_;
                const rotation = this.renderedRotation_;
                const projection = this.renderedProjection_;
                const extent = this.wrappedRenderedExtent_;
                const layer = this.getLayer();
                const transforms = [];
                const width = size[0] * (0, $13dfa0283bf5c35f$export$ab51038298418f25);
                const height = size[1] * (0, $13dfa0283bf5c35f$export$ab51038298418f25);
                transforms.push(this.getRenderTransform(center, resolution, rotation, (0, $13dfa0283bf5c35f$export$ab51038298418f25), width, height, 0).slice());
                const source = layer.getSource();
                const projectionExtent = projection.getExtent();
                if (source.getWrapX() && projection.canWrapX() && !(0, $6da4c8ed3074c92b$export$be866b1e0809b17e)(projectionExtent, extent)) {
                    let startX = extent[0];
                    const worldWidth = (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(projectionExtent);
                    let world = 0;
                    let offsetX;
                    while(startX < projectionExtent[0]){
                        --world;
                        offsetX = worldWidth * world;
                        transforms.push(this.getRenderTransform(center, resolution, rotation, (0, $13dfa0283bf5c35f$export$ab51038298418f25), width, height, offsetX).slice());
                        startX += worldWidth;
                    }
                    world = 0;
                    startX = extent[2];
                    while(startX > projectionExtent[2]){
                        ++world;
                        offsetX = worldWidth * world;
                        transforms.push(this.getRenderTransform(center, resolution, rotation, (0, $13dfa0283bf5c35f$export$ab51038298418f25), width, height, offsetX).slice());
                        startX -= worldWidth;
                    }
                }
                const userProjection = (0, $9c4744460e43e41b$export$3973b77d5f6f2790)();
                this.hitDetectionImageData_ = (0, $13dfa0283bf5c35f$export$bd05e394339d469)(size, transforms, this.renderedFeatures_, layer.getStyleFunction(), extent, resolution, rotation, (0, $4b9ac454600c05d2$export$75084a70d324c1e6)(resolution, this.renderedPixelRatio_), userProjection ? projection : null);
            }
            resolve((0, $13dfa0283bf5c35f$export$6d4d555ddbfffa32)(pixel, this.renderedFeatures_, this.hitDetectionImageData_));
        });
    }
    /**
   * @param {import("../../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @param {import("../vector.js").FeatureCallback<T>} callback Feature callback.
   * @param {Array<import("../Map.js").HitMatch<T>>} matches The hit detected matches with tolerance.
   * @return {T|undefined} Callback result.
   * @template T
   * @override
   */ forEachFeatureAtCoordinate(coordinate, frameState, hitTolerance, callback, matches) {
        if (!this.replayGroup_) return undefined;
        const resolution = frameState.viewState.resolution;
        const rotation = frameState.viewState.rotation;
        const layer = this.getLayer();
        /** @type {!Object<string, import("../Map.js").HitMatch<T>|true>} */ const features = {};
        /**
     * @param {import("../../Feature.js").FeatureLike} feature Feature.
     * @param {import("../../geom/SimpleGeometry.js").default} geometry Geometry.
     * @param {number} distanceSq The squared distance to the click position
     * @return {T|undefined} Callback result.
     */ const featureCallback = function(feature, geometry, distanceSq) {
            const key = (0, $6c5e11070e371322$export$5e82334337e0f204)(feature);
            const match = features[key];
            if (!match) {
                if (distanceSq === 0) {
                    features[key] = true;
                    return callback(feature, layer, geometry);
                }
                matches.push(features[key] = {
                    feature: feature,
                    layer: layer,
                    geometry: geometry,
                    distanceSq: distanceSq,
                    callback: callback
                });
            } else if (match !== true && distanceSq < match.distanceSq) {
                if (distanceSq === 0) {
                    features[key] = true;
                    matches.splice(matches.lastIndexOf(match), 1);
                    return callback(feature, layer, geometry);
                }
                match.geometry = geometry;
                match.distanceSq = distanceSq;
            }
            return undefined;
        };
        const declutter = this.getLayer().getDeclutter();
        return this.replayGroup_.forEachFeatureAtCoordinate(coordinate, resolution, rotation, hitTolerance, featureCallback, declutter ? frameState.declutter?.[declutter]?.all().map((item)=>item.value) : null);
    }
    /**
   * Perform action necessary to get the layer rendered after new fonts have loaded
   * @override
   */ handleFontsChanged() {
        const layer = this.getLayer();
        if (layer.getVisible() && this.replayGroup_) layer.changed();
    }
    /**
   * Handle changes in image style state.
   * @param {import("../../events/Event.js").default} event Image style change event.
   * @private
   */ handleStyleImageChange_(event) {
        this.renderIfReadyAndVisible();
    }
    /**
   * Determine whether render should be called.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @return {boolean} Layer is ready to be rendered.
   * @override
   */ prepareFrame(frameState) {
        const vectorLayer = this.getLayer();
        const vectorSource = vectorLayer.getSource();
        if (!vectorSource) return false;
        const animating = frameState.viewHints[(0, $7d362782b4ccb93d$export$2e2bcd8739ae039).ANIMATING];
        const interacting = frameState.viewHints[(0, $7d362782b4ccb93d$export$2e2bcd8739ae039).INTERACTING];
        const updateWhileAnimating = vectorLayer.getUpdateWhileAnimating();
        const updateWhileInteracting = vectorLayer.getUpdateWhileInteracting();
        if (this.ready && !updateWhileAnimating && animating || !updateWhileInteracting && interacting) {
            this.animatingOrInteracting_ = true;
            return true;
        }
        this.animatingOrInteracting_ = false;
        const frameStateExtent = frameState.extent;
        const viewState = frameState.viewState;
        const projection = viewState.projection;
        const resolution = viewState.resolution;
        const pixelRatio = frameState.pixelRatio;
        const vectorLayerRevision = vectorLayer.getRevision();
        const vectorLayerRenderBuffer = vectorLayer.getRenderBuffer();
        let vectorLayerRenderOrder = vectorLayer.getRenderOrder();
        if (vectorLayerRenderOrder === undefined) vectorLayerRenderOrder = (0, $4b9ac454600c05d2$export$531ddd8416d52dfc);
        const center = viewState.center.slice();
        const extent = (0, $6da4c8ed3074c92b$export$ab1029bcae9ddb4a)(frameStateExtent, vectorLayerRenderBuffer * resolution);
        const renderedExtent = extent.slice();
        const loadExtents = [
            extent.slice()
        ];
        const projectionExtent = projection.getExtent();
        if (vectorSource.getWrapX() && projection.canWrapX() && !(0, $6da4c8ed3074c92b$export$be866b1e0809b17e)(projectionExtent, frameState.extent)) {
            // For the replay group, we need an extent that intersects the real world
            // (-180° to +180°). To support geometries in a coordinate range from -540°
            // to +540°, we add at least 1 world width on each side of the projection
            // extent. If the viewport is wider than the world, we need to add half of
            // the viewport width to make sure we cover the whole viewport.
            const worldWidth = (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(projectionExtent);
            const gutter = Math.max((0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(extent) / 2, worldWidth);
            extent[0] = projectionExtent[0] - gutter;
            extent[2] = projectionExtent[2] + gutter;
            (0, $1bd0a226f9a16141$export$39a9ce3624977b84)(center, projection);
            const loadExtent = (0, $6da4c8ed3074c92b$export$39a9ce3624977b84)(loadExtents[0], projection);
            // If the extent crosses the date line, we load data for both edges of the worlds
            if (loadExtent[0] < projectionExtent[0] && loadExtent[2] < projectionExtent[2]) loadExtents.push([
                loadExtent[0] + worldWidth,
                loadExtent[1],
                loadExtent[2] + worldWidth,
                loadExtent[3]
            ]);
            else if (loadExtent[0] > projectionExtent[0] && loadExtent[2] > projectionExtent[2]) loadExtents.push([
                loadExtent[0] - worldWidth,
                loadExtent[1],
                loadExtent[2] - worldWidth,
                loadExtent[3]
            ]);
        }
        if (this.ready && this.renderedResolution_ == resolution && this.renderedRevision_ == vectorLayerRevision && this.renderedRenderOrder_ == vectorLayerRenderOrder && this.renderedFrameDeclutter_ === !!frameState.declutter && (0, $6da4c8ed3074c92b$export$be866b1e0809b17e)(this.wrappedRenderedExtent_, extent)) {
            if (!(0, $b998d41b678ed5d1$export$e9bab7fafb253603)(this.renderedExtent_, renderedExtent)) {
                this.hitDetectionImageData_ = null;
                this.renderedExtent_ = renderedExtent;
            }
            this.renderedCenter_ = center;
            this.replayGroupChanged = false;
            return true;
        }
        this.replayGroup_ = null;
        const replayGroup = new (0, $e22658f4b743550b$export$2e2bcd8739ae039)((0, $4b9ac454600c05d2$export$bdacc5b475012edb)(resolution, pixelRatio), extent, resolution, pixelRatio);
        const userProjection = (0, $9c4744460e43e41b$export$3973b77d5f6f2790)();
        let userTransform;
        if (userProjection) {
            for(let i = 0, ii = loadExtents.length; i < ii; ++i){
                const extent = loadExtents[i];
                const userExtent = (0, $9c4744460e43e41b$export$96bfd09e2cffb006)(extent, projection);
                vectorSource.loadFeatures(userExtent, (0, $9c4744460e43e41b$export$b56bb8ad8b3a00e9)(resolution, projection), userProjection);
            }
            userTransform = (0, $9c4744460e43e41b$export$e3c4995a701c26a3)(userProjection, projection);
        } else for(let i = 0, ii = loadExtents.length; i < ii; ++i)vectorSource.loadFeatures(loadExtents[i], resolution, projection);
        const squaredTolerance = (0, $4b9ac454600c05d2$export$75084a70d324c1e6)(resolution, pixelRatio);
        let ready = true;
        const render = /**
       * @param {import("../../Feature.js").default} feature Feature.
       * @param {number} index Index.
       */ (feature, index)=>{
            let styles;
            const styleFunction = feature.getStyleFunction() || vectorLayer.getStyleFunction();
            if (styleFunction) styles = styleFunction(feature, resolution);
            if (styles) {
                const dirty = this.renderFeature(feature, squaredTolerance, styles, replayGroup, userTransform, this.getLayer().getDeclutter(), index);
                ready = ready && !dirty;
            }
        };
        const userExtent = (0, $9c4744460e43e41b$export$96bfd09e2cffb006)(extent, projection);
        /** @type {Array<import("../../Feature.js").default>} */ const features = vectorSource.getFeaturesInExtent(userExtent);
        if (vectorLayerRenderOrder) features.sort(vectorLayerRenderOrder);
        for(let i = 0, ii = features.length; i < ii; ++i)render(features[i], i);
        this.renderedFeatures_ = features;
        this.ready = ready;
        const replayGroupInstructions = replayGroup.finish();
        const executorGroup = new (0, $a34a824d875e4ea1$export$2e2bcd8739ae039)(extent, resolution, pixelRatio, vectorSource.getOverlaps(), replayGroupInstructions, vectorLayer.getRenderBuffer(), !!frameState.declutter);
        this.renderedResolution_ = resolution;
        this.renderedRevision_ = vectorLayerRevision;
        this.renderedRenderOrder_ = vectorLayerRenderOrder;
        this.renderedFrameDeclutter_ = !!frameState.declutter;
        this.renderedExtent_ = renderedExtent;
        this.wrappedRenderedExtent_ = extent;
        this.renderedCenter_ = center;
        this.renderedProjection_ = projection;
        this.renderedPixelRatio_ = pixelRatio;
        this.replayGroup_ = executorGroup;
        this.hitDetectionImageData_ = null;
        this.replayGroupChanged = true;
        return true;
    }
    /**
   * @param {import("../../Feature.js").default} feature Feature.
   * @param {number} squaredTolerance Squared render tolerance.
   * @param {import("../../style/Style.js").default|Array<import("../../style/Style.js").default>} styles The style or array of styles.
   * @param {import("../../render/canvas/BuilderGroup.js").default} builderGroup Builder group.
   * @param {import("../../proj.js").TransformFunction} [transform] Transform from user to view projection.
   * @param {boolean} [declutter] Enable decluttering.
   * @param {number} [index] Render order index.
   * @return {boolean} `true` if an image is loading.
   */ renderFeature(feature, squaredTolerance, styles, builderGroup, transform, declutter, index) {
        if (!styles) return false;
        let loading = false;
        if (Array.isArray(styles)) for(let i = 0, ii = styles.length; i < ii; ++i)loading = (0, $4b9ac454600c05d2$export$36f470a33a42f413)(builderGroup, feature, styles[i], squaredTolerance, this.boundHandleStyleImageChange_, transform, declutter, index) || loading;
        else loading = (0, $4b9ac454600c05d2$export$36f470a33a42f413)(builderGroup, feature, styles, squaredTolerance, this.boundHandleStyleImageChange_, transform, declutter, index);
        return loading;
    }
}
var $659e0e97392a5f5e$export$2e2bcd8739ae039 = $659e0e97392a5f5e$var$CanvasVectorLayerRenderer;



/**
 * @template {import("../source/Vector.js").default<FeatureType>} [VectorSourceType=import("../source/Vector.js").default<*>]
 * @template {import('../Feature.js').FeatureLike} [FeatureType=import("./BaseVector.js").ExtractedFeatureType<VectorSourceType>]
 * @typedef {Object} Options
 * @property {string} [className='ol-layer'] A CSS class name to set to the layer element.
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {import("../render.js").OrderFunction} [renderOrder] Render order. Function to be used when sorting
 * features before rendering. By default features are drawn in the order that they are created. Use
 * `null` to avoid the sort, but get an undefined draw order.
 * @property {number} [renderBuffer=100] The buffer in pixels around the viewport extent used by the
 * renderer when getting features from the vector source for the rendering or hit-detection.
 * Recommended value: the size of the largest symbol, line width or label.
 * @property {VectorSourceType} [source] Source.
 * @property {import("../Map.js").default} [map] Sets the layer as overlay on a map. The map will not manage
 * this layer in its layers collection, and the layer will be rendered on top. This is useful for
 * temporary layers. The standard way to add a layer to a map and have it managed by the map is to
 * use [map.addLayer()]{@link import("../Map.js").default#addLayer}.
 * @property {boolean|string|number} [declutter=false] Declutter images and text. Any truthy value will enable
 * decluttering. Within a layer, a feature rendered before another has higher priority. All layers with the
 * same `declutter` value will be decluttered together. The priority is determined by the drawing order of the
 * layers with the same `declutter` value. Higher in the layer stack means higher priority. To declutter distinct
 * layers or groups of layers separately, use different truthy values for `declutter`.
 * @property {import("../style/Style.js").StyleLike|import("../style/flat.js").FlatStyleLike|null} [style] Layer style. When set to `null`, only
 * features that have their own style will be rendered. See {@link module:ol/style/Style~Style} for the default style
 * which will be used if this is not set.
 * @property {import("./Base.js").BackgroundColor} [background] Background color for the layer. If not specified, no background
 * will be rendered.
 * @property {boolean} [updateWhileAnimating=false] When set to `true`, feature batches will
 * be recreated during animations. This means that no vectors will be shown clipped, but the
 * setting will have a performance impact for large amounts of vector data. When set to `false`,
 * batches will be recreated when no animation is active.
 * @property {boolean} [updateWhileInteracting=false] When set to `true`, feature batches will
 * be recreated during interactions. See also `updateWhileAnimating`.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 */ /**
 * @classdesc
 * Vector data is rendered client-side, as vectors. This layer type provides most accurate rendering
 * even during animations. Points and labels stay upright on rotated views. For very large
 * amounts of vector data, performance may suffer during pan and zoom animations. In this case,
 * try {@link module:ol/layer/VectorImage~VectorImageLayer}.
 *
 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
 * property on the layer object; for example, setting `title: 'My Title'` in the
 * options means that `title` is observable, and has get/set accessors.
 *
 * @template {import("../source/Vector.js").default<FeatureType>} [VectorSourceType=import("../source/Vector.js").default<*>]
 * @template {import('../Feature.js').FeatureLike} [FeatureType=import("./BaseVector.js").ExtractedFeatureType<VectorSourceType>]
 * @extends {BaseVectorLayer<FeatureType, VectorSourceType, CanvasVectorLayerRenderer>}
 * @api
 */ class $82a68515bd6ef378$var$VectorLayer extends (0, $c8d6dc4c09ed9916$export$2e2bcd8739ae039) {
    /**
   * @param {Options<VectorSourceType, FeatureType>} [options] Options.
   */ constructor(options){
        super(options);
    }
    /**
   * @override
   */ createRenderer() {
        return new (0, $659e0e97392a5f5e$export$2e2bcd8739ae039)(this);
    }
}
var $82a68515bd6ef378$export$2e2bcd8739ae039 = $82a68515bd6ef378$var$VectorLayer;




/**
 * @module ol/source/Vector
 */ 








/**
 * @module ol/featureloader
 */ /**
 *
 * @type {boolean}
 * @private
 */ let $588823c001569193$var$withCredentials = false;
function $588823c001569193$export$441d7b57adab24d0(url, format, extent, resolution, projection, success, failure) {
    const xhr = new XMLHttpRequest();
    xhr.open('GET', typeof url === 'function' ? url(extent, resolution, projection) : url, true);
    if (format.getType() == 'arraybuffer') xhr.responseType = 'arraybuffer';
    xhr.withCredentials = $588823c001569193$var$withCredentials;
    /**
   * @param {Event} event Event.
   * @private
   */ xhr.onload = function(event) {
        // status will be 0 for file:// urls
        if (!xhr.status || xhr.status >= 200 && xhr.status < 300) {
            const type = format.getType();
            try {
                /** @type {Document|Node|Object|string|undefined} */ let source;
                if (type == 'text' || type == 'json') source = xhr.responseText;
                else if (type == 'xml') source = xhr.responseXML || xhr.responseText;
                else if (type == 'arraybuffer') source = /** @type {ArrayBuffer} */ xhr.response;
                if (source) success(/** @type {Array<FeatureType>} */ format.readFeatures(source, {
                    extent: extent,
                    featureProjection: projection
                }), format.readProjection(source));
                else failure();
            } catch  {
                failure();
            }
        } else failure();
    };
    /**
   * @private
   */ xhr.onerror = failure;
    xhr.send();
}
function $588823c001569193$export$14cc81df70b6707e(url, format) {
    /**
   * @param {import("./extent.js").Extent} extent Extent.
   * @param {number} resolution Resolution.
   * @param {import("./proj/Projection.js").default} projection Projection.
   * @param {function(Array<FeatureType>): void} [success] Success
   *      Function called when loading succeeded.
   * @param {function(): void} [failure] Failure
   *      Function called when loading failed.
   * @this {import("./source/Vector.js").default<FeatureType>}
   */ return function(extent, resolution, projection, success, failure) {
        $588823c001569193$export$441d7b57adab24d0(url, format, extent, resolution, projection, /**
       * @param {Array<FeatureType>} features The loaded features.
       * @param {import("./proj/Projection.js").default} dataProjection Data
       * projection.
       */ (features, dataProjection)=>{
            this.addFeatures(features);
            if (success !== undefined) success(features);
        }, ()=>{
            this.changed();
            if (failure !== undefined) failure();
        });
    };
}
function $588823c001569193$export$36fa6977a6d0d8fe(xhrWithCredentials) {
    $588823c001569193$var$withCredentials = xhrWithCredentials;
}



/**
 * @module ol/loadingstrategy
 */ 
function $eb51d0a16123ee90$export$84bf76cd7afc7469(extent, resolution) {
    return [
        [
            -Infinity,
            -Infinity,
            Infinity,
            Infinity
        ]
    ];
}
function $eb51d0a16123ee90$export$bf67010aacbe66fa(extent, resolution) {
    return [
        extent
    ];
}
function $eb51d0a16123ee90$export$3c17558da18e4d75(tileGrid) {
    return(/**
     * @param {import("./extent.js").Extent} extent Extent.
     * @param {number} resolution Resolution.
     * @param {import("./proj.js").Projection} projection Projection.
     * @return {Array<import("./extent.js").Extent>} Extents.
     */ function(extent, resolution, projection) {
        const z = tileGrid.getZForResolution((0, $9c4744460e43e41b$export$bd1cd3b88140b906)(resolution, projection));
        const tileRange = tileGrid.getTileRangeForExtentAndZ((0, $9c4744460e43e41b$export$494be3a3a25689ca)(extent, projection), z);
        /** @type {Array<import("./extent.js").Extent>} */ const extents = [];
        /** @type {import("./tilecoord.js").TileCoord} */ const tileCoord = [
            z,
            0,
            0
        ];
        for(tileCoord[1] = tileRange.minX; tileCoord[1] <= tileRange.maxX; ++tileCoord[1])for(tileCoord[2] = tileRange.minY; tileCoord[2] <= tileRange.maxY; ++tileCoord[2])extents.push((0, $9c4744460e43e41b$export$96bfd09e2cffb006)(tileGrid.getTileCoordExtent(tileCoord), projection));
        return extents;
    });
}



/**
 * @module ol/render/Feature
 */ 












/**
 * @typedef {'Point' | 'LineString' | 'LinearRing' | 'Polygon' | 'MultiPoint' | 'MultiLineString'} Type
 * The geometry type.  One of `'Point'`, `'LineString'`, `'LinearRing'`,
 * `'Polygon'`, `'MultiPoint'` or 'MultiLineString'`.
 */ /**
 * @type {import("../transform.js").Transform}
 */ const $36d6c36c1f9ad5d9$var$tmpTransform = (0, $e22e7611e69f42a9$export$185802fd694ee1f5)();
/**
 * Lightweight, read-only, {@link module:ol/Feature~Feature} and {@link module:ol/geom/Geometry~Geometry} like
 * structure, optimized for vector tile rendering and styling. Geometry access
 * through the API is limited to getting the type and extent of the geometry.
 */ class $36d6c36c1f9ad5d9$var$RenderFeature {
    /**
   * @param {Type} type Geometry type.
   * @param {Array<number>} flatCoordinates Flat coordinates. These always need
   *     to be right-handed for polygons.
   * @param {Array<number>} ends Ends.
   * @param {number} stride Stride.
   * @param {Object<string, *>} properties Properties.
   * @param {number|string|undefined} id Feature id.
   */ constructor(type, flatCoordinates, ends, stride, properties, id){
        /**
     * @type {import("../style/Style.js").StyleFunction|undefined}
     */ this.styleFunction;
        /**
     * @private
     * @type {import("../extent.js").Extent|undefined}
     */ this.extent_;
        /**
     * @private
     * @type {number|string|undefined}
     */ this.id_ = id;
        /**
     * @private
     * @type {Type}
     */ this.type_ = type;
        /**
     * @private
     * @type {Array<number>}
     */ this.flatCoordinates_ = flatCoordinates;
        /**
     * @private
     * @type {Array<number>}
     */ this.flatInteriorPoints_ = null;
        /**
     * @private
     * @type {Array<number>}
     */ this.flatMidpoints_ = null;
        /**
     * @private
     * @type {Array<number>|null}
     */ this.ends_ = ends || null;
        /**
     * @private
     * @type {Object<string, *>}
     */ this.properties_ = properties;
        /**
     * @private
     * @type {number}
     */ this.squaredTolerance_;
        /**
     * @private
     * @type {number}
     */ this.stride_ = stride;
        /**
     * @private
     * @type {RenderFeature}
     */ this.simplifiedGeometry_;
    }
    /**
   * Get a feature property by its key.
   * @param {string} key Key
   * @return {*} Value for the requested key.
   * @api
   */ get(key) {
        return this.properties_[key];
    }
    /**
   * Get the extent of this feature's geometry.
   * @return {import("../extent.js").Extent} Extent.
   * @api
   */ getExtent() {
        if (!this.extent_) this.extent_ = this.type_ === 'Point' ? (0, $6da4c8ed3074c92b$export$4838bf78d04a9440)(this.flatCoordinates_) : (0, $6da4c8ed3074c92b$export$be0ab0bf96ca59ca)(this.flatCoordinates_, 0, this.flatCoordinates_.length, 2);
        return this.extent_;
    }
    /**
   * @return {Array<number>} Flat interior points.
   */ getFlatInteriorPoint() {
        if (!this.flatInteriorPoints_) {
            const flatCenter = (0, $6da4c8ed3074c92b$export$c91255cadecfe081)(this.getExtent());
            this.flatInteriorPoints_ = (0, $2166f19777f69377$export$50e3b25928a5e892)(this.flatCoordinates_, 0, this.ends_, 2, flatCenter, 0);
        }
        return this.flatInteriorPoints_;
    }
    /**
   * @return {Array<number>} Flat interior points.
   */ getFlatInteriorPoints() {
        if (!this.flatInteriorPoints_) {
            const ends = (0, $7892dc06ffd23218$export$cb72ae403d6e78e6)(this.flatCoordinates_, this.ends_);
            const flatCenters = (0, $9825fadaf3b68c4e$export$78e139679ca7205)(this.flatCoordinates_, 0, ends, 2);
            this.flatInteriorPoints_ = (0, $2166f19777f69377$export$11463803eda8a372)(this.flatCoordinates_, 0, ends, 2, flatCenters);
        }
        return this.flatInteriorPoints_;
    }
    /**
   * @return {Array<number>} Flat midpoint.
   */ getFlatMidpoint() {
        if (!this.flatMidpoints_) this.flatMidpoints_ = (0, $43ed5485a1d0c509$export$687ff82efd78795b)(this.flatCoordinates_, 0, this.flatCoordinates_.length, 2, 0.5);
        return this.flatMidpoints_;
    }
    /**
   * @return {Array<number>} Flat midpoints.
   */ getFlatMidpoints() {
        if (!this.flatMidpoints_) {
            this.flatMidpoints_ = [];
            const flatCoordinates = this.flatCoordinates_;
            let offset = 0;
            const ends = /** @type {Array<number>} */ this.ends_;
            for(let i = 0, ii = ends.length; i < ii; ++i){
                const end = ends[i];
                const midpoint = (0, $43ed5485a1d0c509$export$687ff82efd78795b)(flatCoordinates, offset, end, 2, 0.5);
                (0, $b998d41b678ed5d1$export$8b58be045bf06082)(this.flatMidpoints_, midpoint);
                offset = end;
            }
        }
        return this.flatMidpoints_;
    }
    /**
   * Get the feature identifier.  This is a stable identifier for the feature and
   * is set when reading data from a remote source.
   * @return {number|string|undefined} Id.
   * @api
   */ getId() {
        return this.id_;
    }
    /**
   * @return {Array<number>} Flat coordinates.
   */ getOrientedFlatCoordinates() {
        return this.flatCoordinates_;
    }
    /**
   * For API compatibility with {@link module:ol/Feature~Feature}, this method is useful when
   * determining the geometry type in style function (see {@link #getType}).
   * @return {RenderFeature} Feature.
   * @api
   */ getGeometry() {
        return this;
    }
    /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {RenderFeature} Simplified geometry.
   */ getSimplifiedGeometry(squaredTolerance) {
        return this;
    }
    /**
   * Get a transformed and simplified version of the geometry.
   * @param {number} squaredTolerance Squared tolerance.
   * @param {import("../proj.js").TransformFunction} [transform] Optional transform function.
   * @return {RenderFeature} Simplified geometry.
   */ simplifyTransformed(squaredTolerance, transform) {
        return this;
    }
    /**
   * Get the feature properties.
   * @return {Object<string, *>} Feature properties.
   * @api
   */ getProperties() {
        return this.properties_;
    }
    /**
   * Get an object of all property names and values.  This has the same behavior as getProperties,
   * but is here to conform with the {@link module:ol/Feature~Feature} interface.
   * @return {Object<string, *>?} Object.
   */ getPropertiesInternal() {
        return this.properties_;
    }
    /**
   * @return {number} Stride.
   */ getStride() {
        return this.stride_;
    }
    /**
   * @return {import('../style/Style.js').StyleFunction|undefined} Style
   */ getStyleFunction() {
        return this.styleFunction;
    }
    /**
   * Get the type of this feature's geometry.
   * @return {Type} Geometry type.
   * @api
   */ getType() {
        return this.type_;
    }
    /**
   * Transform geometry coordinates from tile pixel space to projected.
   *
   * @param {import("../proj.js").ProjectionLike} projection The data projection
   */ transform(projection) {
        projection = (0, $9c4744460e43e41b$export$3988ae62b71be9a3)(projection);
        const pixelExtent = projection.getExtent();
        const projectedExtent = projection.getWorldExtent();
        if (pixelExtent && projectedExtent) {
            const scale = (0, $6da4c8ed3074c92b$export$c08559766941f856)(projectedExtent) / (0, $6da4c8ed3074c92b$export$c08559766941f856)(pixelExtent);
            (0, $e22e7611e69f42a9$export$f672e0b6f7222cd7)($36d6c36c1f9ad5d9$var$tmpTransform, projectedExtent[0], projectedExtent[3], scale, -scale, 0, 0, 0);
            (0, $14c6e714516e527b$export$b92b2dedcfff79de)(this.flatCoordinates_, 0, this.flatCoordinates_.length, 2, $36d6c36c1f9ad5d9$var$tmpTransform, this.flatCoordinates_);
        }
    }
    /**
   * Apply a transform function to the coordinates of the geometry.
   * The geometry is modified in place.
   * If you do not want the geometry modified in place, first `clone()` it and
   * then use this function on the clone.
   * @param {import("../proj.js").TransformFunction} transformFn Transform function.
   */ applyTransform(transformFn) {
        transformFn(this.flatCoordinates_, this.flatCoordinates_, this.stride_);
    }
    /**
   * @return {RenderFeature} A cloned render feature.
   */ clone() {
        return new $36d6c36c1f9ad5d9$var$RenderFeature(this.type_, this.flatCoordinates_.slice(), this.ends_?.slice(), this.stride_, Object.assign({}, this.properties_), this.id_);
    }
    /**
   * @return {Array<number>|null} Ends.
   */ getEnds() {
        return this.ends_;
    }
    /**
   * Add transform and resolution based geometry simplification to this instance.
   * @return {RenderFeature} This render feature.
   */ enableSimplifyTransformed() {
        this.simplifyTransformed = (0, $013a1733c226ec50$export$ff83df6f9971435f)((squaredTolerance, transform)=>{
            if (squaredTolerance === this.squaredTolerance_) return this.simplifiedGeometry_;
            this.simplifiedGeometry_ = this.clone();
            if (transform) this.simplifiedGeometry_.applyTransform(transform);
            const simplifiedFlatCoordinates = this.simplifiedGeometry_.getFlatCoordinates();
            let simplifiedEnds;
            switch(this.type_){
                case 'LineString':
                    simplifiedFlatCoordinates.length = (0, $8780aae6970f5f65$export$ef693d1572e64fb8)(simplifiedFlatCoordinates, 0, this.simplifiedGeometry_.flatCoordinates_.length, this.simplifiedGeometry_.stride_, squaredTolerance, simplifiedFlatCoordinates, 0);
                    simplifiedEnds = [
                        simplifiedFlatCoordinates.length
                    ];
                    break;
                case 'MultiLineString':
                    simplifiedEnds = [];
                    simplifiedFlatCoordinates.length = (0, $8780aae6970f5f65$export$cedb9900c0b225c2)(simplifiedFlatCoordinates, 0, this.simplifiedGeometry_.ends_, this.simplifiedGeometry_.stride_, squaredTolerance, simplifiedFlatCoordinates, 0, simplifiedEnds);
                    break;
                case 'Polygon':
                    simplifiedEnds = [];
                    simplifiedFlatCoordinates.length = (0, $8780aae6970f5f65$export$60a9904b67f8d51b)(simplifiedFlatCoordinates, 0, this.simplifiedGeometry_.ends_, this.simplifiedGeometry_.stride_, Math.sqrt(squaredTolerance), simplifiedFlatCoordinates, 0, simplifiedEnds);
                    break;
                default:
            }
            if (simplifiedEnds) this.simplifiedGeometry_ = new $36d6c36c1f9ad5d9$var$RenderFeature(this.type_, simplifiedFlatCoordinates, simplifiedEnds, 2, this.properties_, this.id_);
            this.squaredTolerance_ = squaredTolerance;
            return this.simplifiedGeometry_;
        });
        return this;
    }
}
/**
 * @return {Array<number>} Flat coordinates.
 */ $36d6c36c1f9ad5d9$var$RenderFeature.prototype.getFlatCoordinates = $36d6c36c1f9ad5d9$var$RenderFeature.prototype.getOrientedFlatCoordinates;
function $36d6c36c1f9ad5d9$export$b89ab3d1d30dec84(renderFeature) {
    const geometryType = renderFeature.getType();
    switch(geometryType){
        case 'Point':
            return new (0, $6eced4c969949f6b$export$2e2bcd8739ae039)(renderFeature.getFlatCoordinates());
        case 'MultiPoint':
            return new (0, $e6080c63a9451eda$export$2e2bcd8739ae039)(renderFeature.getFlatCoordinates(), 'XY');
        case 'LineString':
            return new (0, $292e4002746c8223$export$2e2bcd8739ae039)(renderFeature.getFlatCoordinates(), 'XY');
        case 'MultiLineString':
            return new (0, $b4c0e2e13beea46e$export$2e2bcd8739ae039)(renderFeature.getFlatCoordinates(), 'XY', /** @type {Array<number>} */ renderFeature.getEnds());
        case 'Polygon':
            const flatCoordinates = renderFeature.getFlatCoordinates();
            const ends = renderFeature.getEnds();
            const endss = (0, $7892dc06ffd23218$export$cb72ae403d6e78e6)(flatCoordinates, ends);
            return endss.length > 1 ? new (0, $f73f35eb6af8b987$export$2e2bcd8739ae039)(flatCoordinates, 'XY', endss) : new (0, $40aa8d43bbe572bf$export$2e2bcd8739ae039)(flatCoordinates, 'XY', ends);
        default:
            throw new Error('Invalid geometry type:' + geometryType);
    }
}
function $36d6c36c1f9ad5d9$export$ab19ba60efd1c4b5(renderFeature, geometryName) {
    const id = renderFeature.getId();
    const geometry = $36d6c36c1f9ad5d9$export$b89ab3d1d30dec84(renderFeature);
    const properties = renderFeature.getProperties();
    const feature = new (0, $9fd014ab6df63665$export$2e2bcd8739ae039)();
    if (geometryName !== undefined) feature.setGeometryName(geometryName);
    feature.setGeometry(geometry);
    if (id !== undefined) feature.setId(id);
    feature.setProperties(properties, true);
    return feature;
}
var $36d6c36c1f9ad5d9$export$2e2bcd8739ae039 = $36d6c36c1f9ad5d9$var$RenderFeature;


/**
 * @module ol/structs/RBush
 */ 



/**
 * @typedef {import("rbush").BBox & {value: T}} Entry
 * @template T
 */ /**
 * @classdesc
 * Wrapper around the RBush by Vladimir Agafonkin.
 * See https://github.com/mourner/rbush.
 *
 * @template {Object} T
 */ class $34c742891733e7a4$var$RBush {
    /**
   * @param {number} [maxEntries] Max entries.
   */ constructor(maxEntries){
        /**
     * @private
     * @type {RBush_<Entry<T>>}
     */ this.rbush_ = new (0, (/*@__PURE__*/$parcel$interopDefault($176ca75ee9f69668$exports)))(maxEntries);
        /**
     * A mapping between the objects added to this rbush wrapper
     * and the objects that are actually added to the internal rbush.
     * @private
     * @type {Object<string, Entry<T>>}
     */ this.items_ = {};
    }
    /**
   * Insert a value into the RBush.
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {T} value Value.
   */ insert(extent, value) {
        /** @type {Entry<T>} */ const item = {
            minX: extent[0],
            minY: extent[1],
            maxX: extent[2],
            maxY: extent[3],
            value: value
        };
        this.rbush_.insert(item);
        this.items_[(0, $6c5e11070e371322$export$5e82334337e0f204)(value)] = item;
    }
    /**
   * Bulk-insert values into the RBush.
   * @param {Array<import("../extent.js").Extent>} extents Extents.
   * @param {Array<T>} values Values.
   */ load(extents, values) {
        const items = new Array(values.length);
        for(let i = 0, l = values.length; i < l; i++){
            const extent = extents[i];
            const value = values[i];
            /** @type {Entry<T>} */ const item = {
                minX: extent[0],
                minY: extent[1],
                maxX: extent[2],
                maxY: extent[3],
                value: value
            };
            items[i] = item;
            this.items_[(0, $6c5e11070e371322$export$5e82334337e0f204)(value)] = item;
        }
        this.rbush_.load(items);
    }
    /**
   * Remove a value from the RBush.
   * @param {T} value Value.
   * @return {boolean} Removed.
   */ remove(value) {
        const uid = (0, $6c5e11070e371322$export$5e82334337e0f204)(value);
        // get the object in which the value was wrapped when adding to the
        // internal rbush. then use that object to do the removal.
        const item = this.items_[uid];
        delete this.items_[uid];
        return this.rbush_.remove(item) !== null;
    }
    /**
   * Update the extent of a value in the RBush.
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {T} value Value.
   */ update(extent, value) {
        const item = this.items_[(0, $6c5e11070e371322$export$5e82334337e0f204)(value)];
        const bbox = [
            item.minX,
            item.minY,
            item.maxX,
            item.maxY
        ];
        if (!(0, $6da4c8ed3074c92b$export$e9bab7fafb253603)(bbox, extent)) {
            this.remove(value);
            this.insert(extent, value);
        }
    }
    /**
   * Return all values in the RBush.
   * @return {Array<T>} All.
   */ getAll() {
        const items = this.rbush_.all();
        return items.map(function(item) {
            return item.value;
        });
    }
    /**
   * Return all values in the given extent.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {Array<T>} All in extent.
   */ getInExtent(extent) {
        /** @type {import("rbush").BBox} */ const bbox = {
            minX: extent[0],
            minY: extent[1],
            maxX: extent[2],
            maxY: extent[3]
        };
        const items = this.rbush_.search(bbox);
        return items.map(function(item) {
            return item.value;
        });
    }
    /**
   * Calls a callback function with each value in the tree.
   * If the callback returns a truthy value, this value is returned without
   * checking the rest of the tree.
   * @param {function(T): R} callback Callback.
   * @return {R|undefined} Callback return value.
   * @template R
   */ forEach(callback) {
        return this.forEach_(this.getAll(), callback);
    }
    /**
   * Calls a callback function with each value in the provided extent.
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {function(T): R} callback Callback.
   * @return {R|undefined} Callback return value.
   * @template R
   */ forEachInExtent(extent, callback) {
        return this.forEach_(this.getInExtent(extent), callback);
    }
    /**
   * @param {Array<T>} values Values.
   * @param {function(T): R} callback Callback.
   * @return {R|undefined} Callback return value.
   * @template R
   * @private
   */ forEach_(values, callback) {
        let result;
        for(let i = 0, l = values.length; i < l; i++){
            result = callback(values[i]);
            if (result) return result;
        }
        return result;
    }
    /**
   * @return {boolean} Is empty.
   */ isEmpty() {
        return (0, $beaefe87199bb537$export$dd1bc94b04021eeb)(this.items_);
    }
    /**
   * Remove all values from the RBush.
   */ clear() {
        this.rbush_.clear();
        this.items_ = {};
    }
    /**
   * @param {import("../extent.js").Extent} [extent] Extent.
   * @return {import("../extent.js").Extent} Extent.
   */ getExtent(extent) {
        const data = this.rbush_.toJSON();
        return (0, $6da4c8ed3074c92b$export$958e3e1a02eac4b6)(data.minX, data.minY, data.maxX, data.maxY, extent);
    }
    /**
   * @param {RBush<T>} rbush R-Tree.
   */ concat(rbush) {
        this.rbush_.load(rbush.rbush_.all());
        for(const i in rbush.items_)this.items_[i] = rbush.items_[i];
    }
}
var $34c742891733e7a4$export$2e2bcd8739ae039 = $34c742891733e7a4$var$RBush;




/**
 * @module ol/source/VectorEventType
 */ /**
 * @enum {string}
 */ var $ccc4e6f11f11978f$export$2e2bcd8739ae039 /**
 * @typedef {'addfeature'|'changefeature'|'clear'|'removefeature'|'featuresloadstart'|'featuresloadend'|'featuresloaderror'} VectorSourceEventTypes
 */  = {
    /**
   * Triggered when a feature is added to the source.
   * @event module:ol/source/Vector.VectorSourceEvent#addfeature
   * @api
   */ ADDFEATURE: 'addfeature',
    /**
   * Triggered when a feature is updated.
   * @event module:ol/source/Vector.VectorSourceEvent#changefeature
   * @api
   */ CHANGEFEATURE: 'changefeature',
    /**
   * Triggered when the clear method is called on the source.
   * @event module:ol/source/Vector.VectorSourceEvent#clear
   * @api
   */ CLEAR: 'clear',
    /**
   * Triggered when a feature is removed from the source.
   * See {@link module:ol/source/Vector~VectorSource#clear source.clear()} for exceptions.
   * @event module:ol/source/Vector.VectorSourceEvent#removefeature
   * @api
   */ REMOVEFEATURE: 'removefeature',
    /**
   * Triggered when features starts loading.
   * @event module:ol/source/Vector.VectorSourceEvent#featuresloadstart
   * @api
   */ FEATURESLOADSTART: 'featuresloadstart',
    /**
   * Triggered when features finishes loading.
   * @event module:ol/source/Vector.VectorSourceEvent#featuresloadend
   * @api
   */ FEATURESLOADEND: 'featuresloadend',
    /**
   * Triggered if feature loading results in an error.
   * @event module:ol/source/Vector.VectorSourceEvent#featuresloaderror
   * @api
   */ FEATURESLOADERROR: 'featuresloaderror'
};


class $84888e4daf3fdf44$export$d402fd02dc2b661c extends (0, $aeedce20e9577100$export$2e2bcd8739ae039) {
    /**
   * @param {string} type Type.
   * @param {FeatureType} [feature] Feature.
   * @param {Array<FeatureType>} [features] Features.
   */ constructor(type, feature, features){
        super(type);
        /**
     * The added or removed feature for the `ADDFEATURE` and `REMOVEFEATURE` events, `undefined` otherwise.
     * @type {FeatureType|undefined}
     * @api
     */ this.feature = feature;
        /**
     * The loaded features for the `FEATURESLOADED` event, `undefined` otherwise.
     * @type {Array<FeatureType>|undefined}
     * @api
     */ this.features = features;
    }
}
/***
 * @template {import("../Feature.js").FeatureLike} [T=import("../Feature.js").default]
 * @typedef {T extends RenderFeature ? T|Array<T> : T} FeatureClassOrArrayOfRenderFeatures
 */ /***
 * @template Return
 * @template {import("../Feature.js").FeatureLike} [FeatureType=import("../Feature.js").default]
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types, import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<import("./VectorEventType").VectorSourceEventTypes, VectorSourceEvent<FeatureType>, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types|
 *     import("./VectorEventType").VectorSourceEventTypes, Return>} VectorSourceOnSignature
 */ /**
 * @template {import("../Feature.js").FeatureLike} [FeatureType=import("../Feature.js").default]
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {Array<FeatureType>|Collection<FeatureType>} [features]
 * Features. If provided as {@link module:ol/Collection~Collection}, the features in the source
 * and the collection will stay in sync.
 * @property {import("../format/Feature.js").default<FeatureType>} [format] The feature format used by the XHR
 * feature loader when `url` is set. Required if `url` is set, otherwise ignored.
 * @property {import("../featureloader.js").FeatureLoader<FeatureType>} [loader]
 * The loader function used to load features, from a remote source for example.
 * If this is not set and `url` is set, the source will create and use an XHR
 * feature loader. The `'featuresloadend'` and `'featuresloaderror'` events
 * will only fire if the `success` and `failure` callbacks are used.
 *
 * Example:
 *
 * ```js
 * import Vector from 'ol/source/Vector.js';
 * import GeoJSON from 'ol/format/GeoJSON.js';
 * import {bbox} from 'ol/loadingstrategy.js';
 *
 * const vectorSource = new Vector({
 *   format: new GeoJSON(),
 *   loader: function(extent, resolution, projection, success, failure) {
 *      const proj = projection.getCode();
 *      const url = 'https://ahocevar.com/geoserver/wfs?service=WFS&' +
 *          'version=1.1.0&request=GetFeature&typename=osm:water_areas&' +
 *          'outputFormat=application/json&srsname=' + proj + '&' +
 *          'bbox=' + extent.join(',') + ',' + proj;
 *      const xhr = new XMLHttpRequest();
 *      xhr.open('GET', url);
 *      const onError = function() {
 *        vectorSource.removeLoadedExtent(extent);
 *        failure();
 *      }
 *      xhr.onerror = onError;
 *      xhr.onload = function() {
 *        if (xhr.status == 200) {
 *          const features = vectorSource.getFormat().readFeatures(xhr.responseText);
 *          vectorSource.addFeatures(features);
 *          success(features);
 *        } else {
 *          onError();
 *        }
 *      }
 *      xhr.send();
 *    },
 *    strategy: bbox,
 *  });
 * ```
 * @property {boolean} [overlaps=true] This source may have overlapping geometries.
 * Setting this to `false` (e.g. for sources with polygons that represent administrative
 * boundaries or TopoJSON sources) allows the renderer to optimise fill and
 * stroke operations.
 * @property {LoadingStrategy} [strategy] The loading strategy to use.
 * By default an {@link module:ol/loadingstrategy.all}
 * strategy is used, a one-off strategy which loads all features at once.
 * @property {string|import("../featureloader.js").FeatureUrlFunction} [url]
 * Setting this option instructs the source to load features using an XHR loader
 * (see {@link module:ol/featureloader.xhr}). Use a `string` and an
 * {@link module:ol/loadingstrategy.all} for a one-off download of all features from
 * the given URL. Use a {@link module:ol/featureloader~FeatureUrlFunction} to generate the url with
 * other loading strategies.
 * Requires `format` to be set as well.
 * When default XHR feature loader is provided, the features will
 * be transformed from the data projection to the view projection
 * during parsing. If your remote data source does not advertise its projection
 * properly, this transformation will be incorrect. For some formats, the
 * default projection (usually EPSG:4326) can be overridden by setting the
 * dataProjection constructor option on the format.
 * Note that if a source contains non-feature data, such as a GeoJSON geometry
 * or a KML NetworkLink, these will be ignored. Use a custom loader to load these.
 * @property {boolean} [useSpatialIndex=true]
 * By default, an RTree is used as spatial index. When features are removed and
 * added frequently, and the total number of features is low, setting this to
 * `false` may improve performance.
 *
 * Note that
 * {@link module:ol/source/Vector~VectorSource#getFeaturesInExtent},
 * {@link module:ol/source/Vector~VectorSource#getClosestFeatureToCoordinate} and
 * {@link module:ol/source/Vector~VectorSource#getExtent} cannot be used when `useSpatialIndex` is
 * set to `false`, and {@link module:ol/source/Vector~VectorSource#forEachFeatureInExtent} will loop
 * through all features.
 *
 * When set to `false`, the features will be maintained in an
 * {@link module:ol/Collection~Collection}, which can be retrieved through
 * {@link module:ol/source/Vector~VectorSource#getFeaturesCollection}.
 * @property {boolean} [wrapX=true] Wrap the world horizontally. For vector editing across the
 * -180° and 180° meridians to work properly, this should be set to `false`. The
 * resulting geometry coordinates will then exceed the world bounds.
 */ /**
 * @classdesc
 * Provides a source of features for vector layers. Vector features provided
 * by this source are suitable for editing. See {@link module:ol/source/VectorTile~VectorTile} for
 * vector data that is optimized for rendering.
 *
 * @fires VectorSourceEvent
 * @api
 * @template {import("../Feature.js").FeatureLike} [FeatureType=import("../Feature.js").default]
 */ class $84888e4daf3fdf44$var$VectorSource extends (0, $ed6dc99f268f3882$export$2e2bcd8739ae039) {
    /**
   * @param {Options<FeatureType>} [options] Vector source options.
   */ constructor(options){
        options = options || {};
        super({
            attributions: options.attributions,
            interpolate: true,
            projection: undefined,
            state: 'ready',
            wrapX: options.wrapX !== undefined ? options.wrapX : true
        });
        /***
     * @type {VectorSourceOnSignature<import("../events").EventsKey, FeatureType>}
     */ this.on;
        /***
     * @type {VectorSourceOnSignature<import("../events").EventsKey, FeatureType>}
     */ this.once;
        /***
     * @type {VectorSourceOnSignature<void>}
     */ this.un;
        /**
     * @private
     * @type {import("../featureloader.js").FeatureLoader<import("../Feature.js").FeatureLike>}
     */ this.loader_ = (0, $013a1733c226ec50$export$1cd1943b3a73bbe8);
        /**
     * @private
     * @type {import("../format/Feature.js").default<FeatureType>|null}
     */ this.format_ = options.format || null;
        /**
     * @private
     * @type {boolean}
     */ this.overlaps_ = options.overlaps === undefined ? true : options.overlaps;
        /**
     * @private
     * @type {string|import("../featureloader.js").FeatureUrlFunction|undefined}
     */ this.url_ = options.url;
        if (options.loader !== undefined) this.loader_ = options.loader;
        else if (this.url_ !== undefined) {
            (0, $35d5ec884318008e$export$a7a9523472993e97)(this.format_, '`format` must be set when `url` is set');
            // create a XHR feature loader for "url" and "format"
            this.loader_ = (0, $588823c001569193$export$14cc81df70b6707e)(this.url_, this.format_);
        }
        /**
     * @private
     * @type {LoadingStrategy}
     */ this.strategy_ = options.strategy !== undefined ? options.strategy : (0, $eb51d0a16123ee90$export$84bf76cd7afc7469);
        const useSpatialIndex = options.useSpatialIndex !== undefined ? options.useSpatialIndex : true;
        /**
     * @private
     * @type {RBush<FeatureType>}
     */ this.featuresRtree_ = useSpatialIndex ? new (0, $34c742891733e7a4$export$2e2bcd8739ae039)() : null;
        /**
     * @private
     * @type {RBush<{extent: import("../extent.js").Extent}>}
     */ this.loadedExtentsRtree_ = new (0, $34c742891733e7a4$export$2e2bcd8739ae039)();
        /**
     * @type {number}
     * @private
     */ this.loadingExtentsCount_ = 0;
        /**
     * @private
     * @type {!Object<string, FeatureType>}
     */ this.nullGeometryFeatures_ = {};
        /**
     * A lookup of features by id (the return from feature.getId()).
     * @private
     * @type {!Object<string, import('../Feature.js').FeatureLike|Array<import('../Feature.js').FeatureLike>>}
     */ this.idIndex_ = {};
        /**
     * A lookup of features by uid (using getUid(feature)).
     * @private
     * @type {!Object<string, FeatureType>}
     */ this.uidIndex_ = {};
        /**
     * @private
     * @type {Object<string, Array<import("../events.js").EventsKey>>}
     */ this.featureChangeKeys_ = {};
        /**
     * @private
     * @type {Collection<FeatureType>|null}
     */ this.featuresCollection_ = null;
        /** @type {Collection<FeatureType>} */ let collection;
        /** @type {Array<FeatureType>} */ let features;
        if (Array.isArray(options.features)) features = options.features;
        else if (options.features) {
            collection = options.features;
            features = collection.getArray();
        }
        if (!useSpatialIndex && collection === undefined) collection = new (0, $931ffc4e747c14db$export$2e2bcd8739ae039)(features);
        if (features !== undefined) this.addFeaturesInternal(features);
        if (collection !== undefined) this.bindFeaturesCollection_(collection);
    }
    /**
   * Add a single feature to the source.  If you want to add a batch of features
   * at once, call {@link module:ol/source/Vector~VectorSource#addFeatures #addFeatures()}
   * instead. A feature will not be added to the source if feature with
   * the same id is already there. The reason for this behavior is to avoid
   * feature duplication when using bbox or tile loading strategies.
   * Note: this also applies if a {@link module:ol/Collection~Collection} is used for features,
   * meaning that if a feature with a duplicate id is added in the collection, it will
   * be removed from it right away.
   * @param {FeatureType} feature Feature to add.
   * @api
   */ addFeature(feature) {
        this.addFeatureInternal(feature);
        this.changed();
    }
    /**
   * Add a feature without firing a `change` event.
   * @param {FeatureType} feature Feature.
   * @protected
   */ addFeatureInternal(feature) {
        const featureKey = (0, $6c5e11070e371322$export$5e82334337e0f204)(feature);
        if (!this.addToIndex_(featureKey, feature)) {
            if (this.featuresCollection_) this.featuresCollection_.remove(feature);
            return;
        }
        this.setupChangeEvents_(featureKey, feature);
        const geometry = feature.getGeometry();
        if (geometry) {
            const extent = geometry.getExtent();
            if (this.featuresRtree_) this.featuresRtree_.insert(extent, feature);
        } else this.nullGeometryFeatures_[featureKey] = feature;
        this.dispatchEvent(new $84888e4daf3fdf44$export$d402fd02dc2b661c((0, $ccc4e6f11f11978f$export$2e2bcd8739ae039).ADDFEATURE, feature));
    }
    /**
   * @param {string} featureKey Unique identifier for the feature.
   * @param {FeatureType} feature The feature.
   * @private
   */ setupChangeEvents_(featureKey, feature) {
        if (feature instanceof (0, $36d6c36c1f9ad5d9$export$2e2bcd8739ae039)) return;
        this.featureChangeKeys_[featureKey] = [
            (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(feature, (0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE, this.handleFeatureChange_, this),
            (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(feature, (0, $e881b5dca21eb5d4$export$2e2bcd8739ae039).PROPERTYCHANGE, this.handleFeatureChange_, this)
        ];
    }
    /**
   * @param {string} featureKey Unique identifier for the feature.
   * @param {FeatureType} feature The feature.
   * @return {boolean} The feature is "valid", in the sense that it is also a
   *     candidate for insertion into the Rtree.
   * @private
   */ addToIndex_(featureKey, feature) {
        let valid = true;
        if (feature.getId() !== undefined) {
            const id = String(feature.getId());
            if (!(id in this.idIndex_)) this.idIndex_[id] = feature;
            else if (feature instanceof (0, $36d6c36c1f9ad5d9$export$2e2bcd8739ae039)) {
                const indexedFeature = this.idIndex_[id];
                if (!(indexedFeature instanceof (0, $36d6c36c1f9ad5d9$export$2e2bcd8739ae039))) valid = false;
                else if (!Array.isArray(indexedFeature)) this.idIndex_[id] = [
                    indexedFeature,
                    feature
                ];
                else indexedFeature.push(feature);
            } else valid = false;
        }
        if (valid) {
            (0, $35d5ec884318008e$export$a7a9523472993e97)(!(featureKey in this.uidIndex_), 'The passed `feature` was already added to the source');
            this.uidIndex_[featureKey] = feature;
        }
        return valid;
    }
    /**
   * Add a batch of features to the source.
   * @param {Array<FeatureType>} features Features to add.
   * @api
   */ addFeatures(features) {
        this.addFeaturesInternal(features);
        this.changed();
    }
    /**
   * Add features without firing a `change` event.
   * @param {Array<FeatureType>} features Features.
   * @protected
   */ addFeaturesInternal(features) {
        const extents = [];
        /** @type {Array<FeatureType>} */ const newFeatures = [];
        /** @type {Array<FeatureType>} */ const geometryFeatures = [];
        for(let i = 0, length = features.length; i < length; i++){
            const feature = features[i];
            const featureKey = (0, $6c5e11070e371322$export$5e82334337e0f204)(feature);
            if (this.addToIndex_(featureKey, feature)) newFeatures.push(feature);
        }
        for(let i = 0, length = newFeatures.length; i < length; i++){
            const feature = newFeatures[i];
            const featureKey = (0, $6c5e11070e371322$export$5e82334337e0f204)(feature);
            this.setupChangeEvents_(featureKey, feature);
            const geometry = feature.getGeometry();
            if (geometry) {
                const extent = geometry.getExtent();
                extents.push(extent);
                geometryFeatures.push(feature);
            } else this.nullGeometryFeatures_[featureKey] = feature;
        }
        if (this.featuresRtree_) this.featuresRtree_.load(extents, geometryFeatures);
        if (this.hasListener((0, $ccc4e6f11f11978f$export$2e2bcd8739ae039).ADDFEATURE)) for(let i = 0, length = newFeatures.length; i < length; i++)this.dispatchEvent(new $84888e4daf3fdf44$export$d402fd02dc2b661c((0, $ccc4e6f11f11978f$export$2e2bcd8739ae039).ADDFEATURE, newFeatures[i]));
    }
    /**
   * @param {!Collection<FeatureType>} collection Collection.
   * @private
   */ bindFeaturesCollection_(collection) {
        let modifyingCollection = false;
        this.addEventListener((0, $ccc4e6f11f11978f$export$2e2bcd8739ae039).ADDFEATURE, /**
       * @param {VectorSourceEvent<FeatureType>} evt The vector source event
       */ function(evt) {
            if (!modifyingCollection) {
                modifyingCollection = true;
                collection.push(evt.feature);
                modifyingCollection = false;
            }
        });
        this.addEventListener((0, $ccc4e6f11f11978f$export$2e2bcd8739ae039).REMOVEFEATURE, /**
       * @param {VectorSourceEvent<FeatureType>} evt The vector source event
       */ function(evt) {
            if (!modifyingCollection) {
                modifyingCollection = true;
                collection.remove(evt.feature);
                modifyingCollection = false;
            }
        });
        collection.addEventListener((0, $161dd067fe2d672c$export$2e2bcd8739ae039).ADD, /**
       * @param {import("../Collection.js").CollectionEvent<FeatureType>} evt The collection event
       */ (evt)=>{
            if (!modifyingCollection) {
                modifyingCollection = true;
                this.addFeature(evt.element);
                modifyingCollection = false;
            }
        });
        collection.addEventListener((0, $161dd067fe2d672c$export$2e2bcd8739ae039).REMOVE, /**
       * @param {import("../Collection.js").CollectionEvent<FeatureType>} evt The collection event
       */ (evt)=>{
            if (!modifyingCollection) {
                modifyingCollection = true;
                this.removeFeature(evt.element);
                modifyingCollection = false;
            }
        });
        this.featuresCollection_ = collection;
    }
    /**
   * Remove all features from the source.
   * @param {boolean} [fast] Skip dispatching of {@link module:ol/source/Vector.VectorSourceEvent#event:removefeature} events.
   * @api
   */ clear(fast) {
        if (fast) {
            for(const featureId in this.featureChangeKeys_){
                const keys = this.featureChangeKeys_[featureId];
                keys.forEach((0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921));
            }
            if (!this.featuresCollection_) {
                this.featureChangeKeys_ = {};
                this.idIndex_ = {};
                this.uidIndex_ = {};
            }
        } else if (this.featuresRtree_) {
            this.featuresRtree_.forEach((feature)=>{
                this.removeFeatureInternal(feature);
            });
            for(const id in this.nullGeometryFeatures_)this.removeFeatureInternal(this.nullGeometryFeatures_[id]);
        }
        if (this.featuresCollection_) this.featuresCollection_.clear();
        if (this.featuresRtree_) this.featuresRtree_.clear();
        this.nullGeometryFeatures_ = {};
        const clearEvent = new $84888e4daf3fdf44$export$d402fd02dc2b661c((0, $ccc4e6f11f11978f$export$2e2bcd8739ae039).CLEAR);
        this.dispatchEvent(clearEvent);
        this.changed();
    }
    /**
   * Iterate through all features on the source, calling the provided callback
   * with each one.  If the callback returns any "truthy" value, iteration will
   * stop and the function will return the same value.
   * Note: this function only iterate through the feature that have a defined geometry.
   *
   * @param {function(FeatureType): T} callback Called with each feature
   *     on the source.  Return a truthy value to stop iteration.
   * @return {T|undefined} The return value from the last call to the callback.
   * @template T
   * @api
   */ forEachFeature(callback) {
        if (this.featuresRtree_) return this.featuresRtree_.forEach(callback);
        if (this.featuresCollection_) this.featuresCollection_.forEach(callback);
    }
    /**
   * Iterate through all features whose geometries contain the provided
   * coordinate, calling the callback with each feature.  If the callback returns
   * a "truthy" value, iteration will stop and the function will return the same
   * value.
   *
   * For {@link module:ol/render/Feature~RenderFeature} features, the callback will be
   * called for all features.
   *
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {function(FeatureType): T} callback Called with each feature
   *     whose goemetry contains the provided coordinate.
   * @return {T|undefined} The return value from the last call to the callback.
   * @template T
   */ forEachFeatureAtCoordinateDirect(coordinate, callback) {
        const extent = [
            coordinate[0],
            coordinate[1],
            coordinate[0],
            coordinate[1]
        ];
        return this.forEachFeatureInExtent(extent, function(feature) {
            const geometry = feature.getGeometry();
            if (geometry instanceof (0, $36d6c36c1f9ad5d9$export$2e2bcd8739ae039) || geometry.intersectsCoordinate(coordinate)) return callback(feature);
            return undefined;
        });
    }
    /**
   * Iterate through all features whose bounding box intersects the provided
   * extent (note that the feature's geometry may not intersect the extent),
   * calling the callback with each feature.  If the callback returns a "truthy"
   * value, iteration will stop and the function will return the same value.
   *
   * If you are interested in features whose geometry intersects an extent, call
   * the {@link module:ol/source/Vector~VectorSource#forEachFeatureIntersectingExtent #forEachFeatureIntersectingExtent()} method instead.
   *
   * When `useSpatialIndex` is set to false, this method will loop through all
   * features, equivalent to {@link module:ol/source/Vector~VectorSource#forEachFeature #forEachFeature()}.
   *
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {function(FeatureType): T} callback Called with each feature
   *     whose bounding box intersects the provided extent.
   * @return {T|undefined} The return value from the last call to the callback.
   * @template T
   * @api
   */ forEachFeatureInExtent(extent, callback) {
        if (this.featuresRtree_) return this.featuresRtree_.forEachInExtent(extent, callback);
        if (this.featuresCollection_) this.featuresCollection_.forEach(callback);
    }
    /**
   * Iterate through all features whose geometry intersects the provided extent,
   * calling the callback with each feature.  If the callback returns a "truthy"
   * value, iteration will stop and the function will return the same value.
   *
   * If you only want to test for bounding box intersection, call the
   * {@link module:ol/source/Vector~VectorSource#forEachFeatureInExtent #forEachFeatureInExtent()} method instead.
   *
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {function(FeatureType): T} callback Called with each feature
   *     whose geometry intersects the provided extent.
   * @return {T|undefined} The return value from the last call to the callback.
   * @template T
   * @api
   */ forEachFeatureIntersectingExtent(extent, callback) {
        return this.forEachFeatureInExtent(extent, /**
       * @param {FeatureType} feature Feature.
       * @return {T|undefined} The return value from the last call to the callback.
       */ function(feature) {
            const geometry = feature.getGeometry();
            if (geometry instanceof (0, $36d6c36c1f9ad5d9$export$2e2bcd8739ae039) || geometry.intersectsExtent(extent)) {
                const result = callback(feature);
                if (result) return result;
            }
        });
    }
    /**
   * Get the features collection associated with this source. Will be `null`
   * unless the source was configured with `useSpatialIndex` set to `false`, or
   * with a {@link module:ol/Collection~Collection} as `features`.
   * @return {Collection<FeatureType>|null} The collection of features.
   * @api
   */ getFeaturesCollection() {
        return this.featuresCollection_;
    }
    /**
   * Get a snapshot of the features currently on the source in random order. The returned array
   * is a copy, the features are references to the features in the source.
   * @return {Array<FeatureType>} Features.
   * @api
   */ getFeatures() {
        let features;
        if (this.featuresCollection_) features = this.featuresCollection_.getArray().slice(0);
        else if (this.featuresRtree_) {
            features = this.featuresRtree_.getAll();
            if (!(0, $beaefe87199bb537$export$dd1bc94b04021eeb)(this.nullGeometryFeatures_)) (0, $b998d41b678ed5d1$export$8b58be045bf06082)(features, Object.values(this.nullGeometryFeatures_));
        }
        return features;
    }
    /**
   * Get all features whose geometry intersects the provided coordinate.
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @return {Array<FeatureType>} Features.
   * @api
   */ getFeaturesAtCoordinate(coordinate) {
        /** @type {Array<FeatureType>} */ const features = [];
        this.forEachFeatureAtCoordinateDirect(coordinate, function(feature) {
            features.push(feature);
        });
        return features;
    }
    /**
   * Get all features whose bounding box intersects the provided extent.  Note that this returns an array of
   * all features intersecting the given extent in random order (so it may include
   * features whose geometries do not intersect the extent).
   *
   * When `useSpatialIndex` is set to false, this method will return all
   * features.
   *
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {import("../proj/Projection.js").default} [projection] Include features
   * where `extent` exceeds the x-axis bounds of `projection` and wraps around the world.
   * @return {Array<FeatureType>} Features.
   * @api
   */ getFeaturesInExtent(extent, projection) {
        if (this.featuresRtree_) {
            const multiWorld = projection && projection.canWrapX() && this.getWrapX();
            if (!multiWorld) return this.featuresRtree_.getInExtent(extent);
            const extents = (0, $6da4c8ed3074c92b$export$9031237f01de0947)(extent, projection);
            return [].concat(...extents.map((anExtent)=>this.featuresRtree_.getInExtent(anExtent)));
        }
        if (this.featuresCollection_) return this.featuresCollection_.getArray().slice(0);
        return [];
    }
    /**
   * Get the closest feature to the provided coordinate.
   *
   * This method is not available when the source is configured with
   * `useSpatialIndex` set to `false` and the features in this source are of type
   * {@link module:ol/Feature~Feature}.
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {function(FeatureType):boolean} [filter] Feature filter function.
   *     The filter function will receive one argument, the {@link module:ol/Feature~Feature feature}
   *     and it should return a boolean value. By default, no filtering is made.
   * @return {FeatureType|null} Closest feature (or `null` if none found).
   * @api
   */ getClosestFeatureToCoordinate(coordinate, filter) {
        // Find the closest feature using branch and bound.  We start searching an
        // infinite extent, and find the distance from the first feature found.  This
        // becomes the closest feature.  We then compute a smaller extent which any
        // closer feature must intersect.  We continue searching with this smaller
        // extent, trying to find a closer feature.  Every time we find a closer
        // feature, we update the extent being searched so that any even closer
        // feature must intersect it.  We continue until we run out of features.
        const x = coordinate[0];
        const y = coordinate[1];
        let closestFeature = null;
        const closestPoint = [
            NaN,
            NaN
        ];
        let minSquaredDistance = Infinity;
        const extent = [
            -Infinity,
            -Infinity,
            Infinity,
            Infinity
        ];
        filter = filter ? filter : (0, $013a1733c226ec50$export$22e23a2304399231);
        this.featuresRtree_.forEachInExtent(extent, /**
       * @param {FeatureType} feature Feature.
       */ function(feature) {
            if (filter(feature)) {
                const geometry = feature.getGeometry();
                const previousMinSquaredDistance = minSquaredDistance;
                minSquaredDistance = geometry instanceof (0, $36d6c36c1f9ad5d9$export$2e2bcd8739ae039) ? 0 : geometry.closestPointXY(x, y, closestPoint, minSquaredDistance);
                if (minSquaredDistance < previousMinSquaredDistance) {
                    closestFeature = feature;
                    // This is sneaky.  Reduce the extent that it is currently being
                    // searched while the R-Tree traversal using this same extent object
                    // is still in progress.  This is safe because the new extent is
                    // strictly contained by the old extent.
                    const minDistance = Math.sqrt(minSquaredDistance);
                    extent[0] = x - minDistance;
                    extent[1] = y - minDistance;
                    extent[2] = x + minDistance;
                    extent[3] = y + minDistance;
                }
            }
        });
        return closestFeature;
    }
    /**
   * Get the extent of the features currently in the source.
   *
   * This method is not available when the source is configured with
   * `useSpatialIndex` set to `false`.
   * @param {import("../extent.js").Extent} [extent] Destination extent. If provided, no new extent
   *     will be created. Instead, that extent's coordinates will be overwritten.
   * @return {import("../extent.js").Extent} Extent.
   * @api
   */ getExtent(extent) {
        return this.featuresRtree_.getExtent(extent);
    }
    /**
   * Get a feature by its identifier (the value returned by feature.getId()). When `RenderFeature`s
   * are used, `getFeatureById()` can return an array of `RenderFeature`s. This allows for handling
   * of `GeometryCollection` geometries, where format readers create one `RenderFeature` per
   * `GeometryCollection` member.
   * Note that the index treats string and numeric identifiers as the same.  So
   * `source.getFeatureById(2)` will return a feature with id `'2'` or `2`.
   *
   * @param {string|number} id Feature identifier.
   * @return {FeatureClassOrArrayOfRenderFeatures<FeatureType>|null} The feature (or `null` if not found).
   * @api
   */ getFeatureById(id) {
        const feature = this.idIndex_[id.toString()];
        return feature !== undefined ? /** @type {FeatureClassOrArrayOfRenderFeatures<FeatureType>} */ feature : null;
    }
    /**
   * Get a feature by its internal unique identifier (using `getUid`).
   *
   * @param {string} uid Feature identifier.
   * @return {FeatureType|null} The feature (or `null` if not found).
   */ getFeatureByUid(uid) {
        const feature = this.uidIndex_[uid];
        return feature !== undefined ? feature : null;
    }
    /**
   * Get the format associated with this source.
   *
   * @return {import("../format/Feature.js").default<FeatureType>|null}} The feature format.
   * @api
   */ getFormat() {
        return this.format_;
    }
    /**
   * @return {boolean} The source can have overlapping geometries.
   */ getOverlaps() {
        return this.overlaps_;
    }
    /**
   * Get the url associated with this source.
   *
   * @return {string|import("../featureloader.js").FeatureUrlFunction|undefined} The url.
   * @api
   */ getUrl() {
        return this.url_;
    }
    /**
   * @param {Event} event Event.
   * @private
   */ handleFeatureChange_(event) {
        const feature = /** @type {FeatureType} */ event.target;
        const featureKey = (0, $6c5e11070e371322$export$5e82334337e0f204)(feature);
        const geometry = feature.getGeometry();
        if (!geometry) {
            if (!(featureKey in this.nullGeometryFeatures_)) {
                if (this.featuresRtree_) this.featuresRtree_.remove(feature);
                this.nullGeometryFeatures_[featureKey] = feature;
            }
        } else {
            const extent = geometry.getExtent();
            if (featureKey in this.nullGeometryFeatures_) {
                delete this.nullGeometryFeatures_[featureKey];
                if (this.featuresRtree_) this.featuresRtree_.insert(extent, feature);
            } else if (this.featuresRtree_) this.featuresRtree_.update(extent, feature);
        }
        const id = feature.getId();
        if (id !== undefined) {
            const sid = id.toString();
            if (this.idIndex_[sid] !== feature) {
                this.removeFromIdIndex_(feature);
                this.idIndex_[sid] = feature;
            }
        } else {
            this.removeFromIdIndex_(feature);
            this.uidIndex_[featureKey] = feature;
        }
        this.changed();
        this.dispatchEvent(new $84888e4daf3fdf44$export$d402fd02dc2b661c((0, $ccc4e6f11f11978f$export$2e2bcd8739ae039).CHANGEFEATURE, feature));
    }
    /**
   * Returns true if the feature is contained within the source.
   * @param {FeatureType} feature Feature.
   * @return {boolean} Has feature.
   * @api
   */ hasFeature(feature) {
        const id = feature.getId();
        if (id !== undefined) return id in this.idIndex_;
        return (0, $6c5e11070e371322$export$5e82334337e0f204)(feature) in this.uidIndex_;
    }
    /**
   * @return {boolean} Is empty.
   */ isEmpty() {
        if (this.featuresRtree_) return this.featuresRtree_.isEmpty() && (0, $beaefe87199bb537$export$dd1bc94b04021eeb)(this.nullGeometryFeatures_);
        if (this.featuresCollection_) return this.featuresCollection_.getLength() === 0;
        return true;
    }
    /**
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {number} resolution Resolution.
   * @param {import("../proj/Projection.js").default} projection Projection.
   */ loadFeatures(extent, resolution, projection) {
        const loadedExtentsRtree = this.loadedExtentsRtree_;
        const extentsToLoad = this.strategy_(extent, resolution, projection);
        for(let i = 0, ii = extentsToLoad.length; i < ii; ++i){
            const extentToLoad = extentsToLoad[i];
            const alreadyLoaded = loadedExtentsRtree.forEachInExtent(extentToLoad, /**
         * @param {{extent: import("../extent.js").Extent}} object Object.
         * @return {boolean} Contains.
         */ function(object) {
                return (0, $6da4c8ed3074c92b$export$be866b1e0809b17e)(object.extent, extentToLoad);
            });
            if (!alreadyLoaded) {
                ++this.loadingExtentsCount_;
                this.dispatchEvent(new $84888e4daf3fdf44$export$d402fd02dc2b661c((0, $ccc4e6f11f11978f$export$2e2bcd8739ae039).FEATURESLOADSTART));
                this.loader_.call(this, extentToLoad, resolution, projection, /**
           * @param {Array<FeatureType>} features Loaded features
           */ (features)=>{
                    --this.loadingExtentsCount_;
                    this.dispatchEvent(new $84888e4daf3fdf44$export$d402fd02dc2b661c((0, $ccc4e6f11f11978f$export$2e2bcd8739ae039).FEATURESLOADEND, undefined, features));
                }, ()=>{
                    --this.loadingExtentsCount_;
                    this.dispatchEvent(new $84888e4daf3fdf44$export$d402fd02dc2b661c((0, $ccc4e6f11f11978f$export$2e2bcd8739ae039).FEATURESLOADERROR));
                });
                loadedExtentsRtree.insert(extentToLoad, {
                    extent: extentToLoad.slice()
                });
            }
        }
        this.loading = this.loader_.length < 4 ? false : this.loadingExtentsCount_ > 0;
    }
    /**
   * @override
   */ refresh() {
        this.clear(true);
        this.loadedExtentsRtree_.clear();
        super.refresh();
    }
    /**
   * Remove an extent from the list of loaded extents.
   * @param {import("../extent.js").Extent} extent Extent.
   * @api
   */ removeLoadedExtent(extent) {
        const loadedExtentsRtree = this.loadedExtentsRtree_;
        const obj = loadedExtentsRtree.forEachInExtent(extent, function(object) {
            if ((0, $6da4c8ed3074c92b$export$e9bab7fafb253603)(object.extent, extent)) return object;
        });
        if (obj) loadedExtentsRtree.remove(obj);
    }
    /**
   * Batch remove features from the source.  If you want to remove all features
   * at once, use the {@link module:ol/source/Vector~VectorSource#clear #clear()} method
   * instead.
   * @param {Array<FeatureType>} features Features to remove.
   * @api
   */ removeFeatures(features) {
        let removed = false;
        for(let i = 0, ii = features.length; i < ii; ++i)removed = this.removeFeatureInternal(features[i]) || removed;
        if (removed) this.changed();
    }
    /**
   * Remove a single feature from the source. If you want to batch remove
   * features, use the {@link module:ol/source/Vector~VectorSource#removeFeatures #removeFeatures()} method
   * instead.
   * @param {FeatureType} feature Feature to remove.
   * @api
   */ removeFeature(feature) {
        if (!feature) return;
        const removed = this.removeFeatureInternal(feature);
        if (removed) this.changed();
    }
    /**
   * Remove feature without firing a `change` event.
   * @param {FeatureType} feature Feature.
   * @return {boolean} True if the feature was removed, false if it was not found.
   * @protected
   */ removeFeatureInternal(feature) {
        const featureKey = (0, $6c5e11070e371322$export$5e82334337e0f204)(feature);
        if (!(featureKey in this.uidIndex_)) return false;
        if (featureKey in this.nullGeometryFeatures_) delete this.nullGeometryFeatures_[featureKey];
        else if (this.featuresRtree_) this.featuresRtree_.remove(feature);
        const featureChangeKeys = this.featureChangeKeys_[featureKey];
        featureChangeKeys?.forEach((0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921));
        delete this.featureChangeKeys_[featureKey];
        const id = feature.getId();
        if (id !== undefined) {
            const idString = id.toString();
            const indexedFeature = this.idIndex_[idString];
            if (indexedFeature === feature) delete this.idIndex_[idString];
            else if (Array.isArray(indexedFeature)) {
                indexedFeature.splice(indexedFeature.indexOf(feature), 1);
                if (indexedFeature.length === 1) this.idIndex_[idString] = indexedFeature[0];
            }
        }
        delete this.uidIndex_[featureKey];
        if (this.hasListener((0, $ccc4e6f11f11978f$export$2e2bcd8739ae039).REMOVEFEATURE)) this.dispatchEvent(new $84888e4daf3fdf44$export$d402fd02dc2b661c((0, $ccc4e6f11f11978f$export$2e2bcd8739ae039).REMOVEFEATURE, feature));
        return true;
    }
    /**
   * Remove a feature from the id index.  Called internally when the feature id
   * may have changed.
   * @param {FeatureType} feature The feature.
   * @private
   */ removeFromIdIndex_(feature) {
        for(const id in this.idIndex_)if (this.idIndex_[id] === feature) {
            delete this.idIndex_[id];
            break;
        }
    }
    /**
   * Set the new loader of the source. The next render cycle will use the
   * new loader.
   * @param {import("../featureloader.js").FeatureLoader} loader The loader to set.
   * @api
   */ setLoader(loader) {
        this.loader_ = loader;
    }
    /**
   * Points the source to a new url. The next render cycle will use the new url.
   * @param {string|import("../featureloader.js").FeatureUrlFunction} url Url.
   * @api
   */ setUrl(url) {
        (0, $35d5ec884318008e$export$a7a9523472993e97)(this.format_, '`format` must be set when `url` is set');
        this.url_ = url;
        this.setLoader((0, $588823c001569193$export$14cc81df70b6707e)(url, this.format_));
    }
    /**
   * @param {boolean} overlaps The source can have overlapping geometries.
   */ setOverlaps(overlaps) {
        this.overlaps_ = overlaps;
        this.changed();
    }
}
var $84888e4daf3fdf44$export$2e2bcd8739ae039 = $84888e4daf3fdf44$var$VectorSource;





/**
 * @typedef {Object} Options
 * @property {import("../geom/Geometry.js").Type} type Geometry type of
 * the geometries being drawn with this instance.
 * @property {number} [clickTolerance=6] The maximum distance in pixels between
 * "down" and "up" for a "up" event to be considered a "click" event and
 * actually add a point/vertex to the geometry being drawn.  The default of `6`
 * was chosen for the draw interaction to behave correctly on mouse as well as
 * on touch devices.
 * @property {import("../Collection.js").default<Feature>} [features]
 * Destination collection for the drawn features.
 * @property {VectorSource} [source] Destination source for
 * the drawn features.
 * @property {number} [dragVertexDelay=500] Delay in milliseconds after pointerdown
 * before the current vertex can be dragged to its exact position.
 * @property {number} [snapTolerance=12] Pixel distance for snapping to the
 * drawing finish. Must be greater than `0`.
 * @property {boolean} [stopClick=false] Stop click, singleclick, and
 * doubleclick events from firing during drawing.
 * @property {number} [maxPoints] The number of points that can be drawn before
 * a polygon ring or line string is finished. By default there is no
 * restriction.
 * @property {number} [minPoints] The number of points that must be drawn
 * before a polygon ring or line string can be finished. Default is `3` for
 * polygon rings and `2` for line strings.
 * @property {import("../events/condition.js").Condition} [finishCondition] A function
 * that takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether the drawing can be finished. Not used when drawing
 * POINT or MULTI_POINT geometries.
 * @property {import("../style/Style.js").StyleLike|import("../style/flat.js").FlatStyleLike} [style]
 * Style for sketch features. The draw interaction can have up to three sketch features, depending on the mode.
 * It will always contain a feature with a `Point` geometry that corresponds to the current cursor position.
 * If the mode is `LineString` or `Polygon`, and there is at least one drawn point, it will also contain a feature with
 * a `LineString` geometry that corresponds to the line between the already drawn points and the current cursor position.
 * If the mode is `Polygon`, and there is at least one drawn point, it will also contain a feature with a `Polygon`
 * geometry that corresponds to the polygon between the already drawn points and the current cursor position
 * (note that this polygon has only two points if only one point is drawn).
 * If the mode is `Circle`, and there is one point drawn, it will also contain a feature with a `Circle` geometry whose
 * center is the drawn point and the radius is determined by the distance between the drawn point and the cursor.
 * @property {GeometryFunction} [geometryFunction]
 * Function that is called when a geometry's coordinates are updated.
 * @property {string} [geometryName] Geometry name to use for features created
 * by the draw interaction.
 * @property {import("../events/condition.js").Condition} [condition] A function that
 * takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled.
 * By default {@link module:ol/events/condition.noModifierKeys}, i.e. a click,
 * adds a vertex or deactivates freehand drawing.
 * @property {boolean} [freehand=false] Operate in freehand mode for lines,
 * polygons, and circles.  This makes the interaction always operate in freehand
 * mode and takes precedence over any `freehandCondition` option.
 * @property {import("../events/condition.js").Condition} [freehandCondition]
 * Condition that activates freehand drawing for lines and polygons. This
 * function takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and
 * returns a boolean to indicate whether that event should be handled. The
 * default is {@link module:ol/events/condition.shiftKeyOnly}, meaning that the
 * Shift key activates freehand drawing.
 * @property {boolean|import("../events/condition.js").Condition} [trace=false] Trace a portion of another geometry.
 * Ignored when in freehand mode.
 * @property {VectorSource} [traceSource] Source for features to trace.  If tracing is active and a `traceSource` is
 * not provided, the interaction's `source` will be used.  Tracing requires that the interaction is configured with
 * either a `traceSource` or a `source`.
 * @property {boolean} [wrapX=false] Wrap the world horizontally on the sketch
 * overlay.
 * @property {import("../geom/Geometry.js").GeometryLayout} [geometryLayout='XY'] Layout of the
 * feature geometries created by the draw interaction.
 */ /**
 * Coordinate type when drawing points.
 * @typedef {import("../coordinate.js").Coordinate} PointCoordType
 */ /**
 * Coordinate type when drawing lines.
 * @typedef {Array<import("../coordinate.js").Coordinate>} LineCoordType
 */ /**
 * Coordinate type when drawing polygons.
 * @typedef {Array<Array<import("../coordinate.js").Coordinate>>} PolyCoordType
 */ /**
 * Types used for drawing coordinates.
 * @typedef {PointCoordType|LineCoordType|PolyCoordType} SketchCoordType
 */ /**
 * @typedef {Object} TraceState
 * @property {boolean} active Tracing active.
 * @property {import("../pixel.js").Pixel} [startPx] The initially clicked pixel location.
 * @property {Array<TraceTarget>} [targets] Targets available for tracing.
 * @property {number} [targetIndex] The index of the currently traced target.  A value of -1 indicates
 * that no trace target is active.
 */ /**
 * @typedef {Object} TraceTarget
 * @property {Array<import("../coordinate.js").Coordinate>} coordinates Target coordinates.
 * @property {boolean} ring The target coordinates are a linear ring.
 * @property {number} startIndex The index of first traced coordinate.  A fractional index represents an
 * edge intersection.  Index values for rings will wrap (may be negative or larger than coordinates length).
 * @property {number} endIndex The index of last traced coordinate.  Details from startIndex also apply here.
 */ /**
 * Function that takes an array of coordinates and an optional existing geometry
 * and a projection as arguments, and returns a geometry. The optional existing
 * geometry is the geometry that is returned when the function is called without
 * a second argument.
 * @typedef {function(!SketchCoordType, import("../geom/SimpleGeometry.js").default,
 *     import("../proj/Projection.js").default):
 *     import("../geom/SimpleGeometry.js").default} GeometryFunction
 */ /**
 * @typedef {'Point' | 'LineString' | 'Polygon' | 'Circle'} Mode
 * Draw mode.  This collapses multi-part geometry types with their single-part
 * cousins.
 */ /**
 * @enum {string}
 */ const $55fa2487efb2d4e1$var$DrawEventType = {
    /**
   * Triggered upon feature draw start
   * @event DrawEvent#drawstart
   * @api
   */ DRAWSTART: 'drawstart',
    /**
   * Triggered upon feature draw end
   * @event DrawEvent#drawend
   * @api
   */ DRAWEND: 'drawend',
    /**
   * Triggered upon feature draw abortion
   * @event DrawEvent#drawabort
   * @api
   */ DRAWABORT: 'drawabort'
};
class $55fa2487efb2d4e1$export$85a4910380d251a7 extends (0, $aeedce20e9577100$export$2e2bcd8739ae039) {
    /**
   * @param {DrawEventType} type Type.
   * @param {Feature} feature The feature drawn.
   */ constructor(type, feature){
        super(type);
        /**
     * The feature being drawn.
     * @type {Feature}
     * @api
     */ this.feature = feature;
    }
}
/**
 * @param {import("../coordinate.js").Coordinate} coordinate The coordinate.
 * @param {Array<Feature>} features The candidate features.
 * @return {Array<TraceTarget>} The trace targets.
 */ function $55fa2487efb2d4e1$var$getTraceTargets(coordinate, features) {
    /**
   * @type {Array<TraceTarget>}
   */ const targets = [];
    for(let i = 0; i < features.length; ++i){
        const feature = features[i];
        const geometry = feature.getGeometry();
        $55fa2487efb2d4e1$var$appendGeometryTraceTargets(coordinate, geometry, targets);
    }
    return targets;
}
/**
 * @param {import("../coordinate.js").Coordinate} a One coordinate.
 * @param {import("../coordinate.js").Coordinate} b Another coordinate.
 * @return {number} The squared distance between the two coordinates.
 */ function $55fa2487efb2d4e1$var$getSquaredDistance(a, b) {
    return (0, $6b000a049d919fe5$export$88e6ebb4fe54f538)(a[0], a[1], b[0], b[1]);
}
/**
 * @param {LineCoordType} coordinates The ring coordinates.
 * @param {number} index The index.  May be wrapped.
 * @return {import("../coordinate.js").Coordinate} The coordinate.
 */ function $55fa2487efb2d4e1$var$getCoordinate(coordinates, index) {
    const count = coordinates.length;
    if (index < 0) return coordinates[index + count];
    if (index >= count) return coordinates[index - count];
    return coordinates[index];
}
/**
 * Get the cumulative squared distance along a ring path.  The end index index may be "wrapped" and it may
 * be less than the start index to indicate the direction of travel.  The start and end index may have
 * a fractional part to indicate a point between two coordinates.
 * @param {LineCoordType} coordinates Ring coordinates.
 * @param {number} startIndex The start index.
 * @param {number} endIndex The end index.
 * @return {number} The cumulative squared distance along the ring path.
 */ function $55fa2487efb2d4e1$var$getCumulativeSquaredDistance(coordinates, startIndex, endIndex) {
    let lowIndex, highIndex;
    if (startIndex < endIndex) {
        lowIndex = startIndex;
        highIndex = endIndex;
    } else {
        lowIndex = endIndex;
        highIndex = startIndex;
    }
    const lowWholeIndex = Math.ceil(lowIndex);
    const highWholeIndex = Math.floor(highIndex);
    if (lowWholeIndex > highWholeIndex) {
        // both start and end are on the same segment
        const start = $55fa2487efb2d4e1$var$interpolateCoordinate(coordinates, lowIndex);
        const end = $55fa2487efb2d4e1$var$interpolateCoordinate(coordinates, highIndex);
        return $55fa2487efb2d4e1$var$getSquaredDistance(start, end);
    }
    let sd = 0;
    if (lowIndex < lowWholeIndex) {
        const start = $55fa2487efb2d4e1$var$interpolateCoordinate(coordinates, lowIndex);
        const end = $55fa2487efb2d4e1$var$getCoordinate(coordinates, lowWholeIndex);
        sd += $55fa2487efb2d4e1$var$getSquaredDistance(start, end);
    }
    if (highWholeIndex < highIndex) {
        const start = $55fa2487efb2d4e1$var$getCoordinate(coordinates, highWholeIndex);
        const end = $55fa2487efb2d4e1$var$interpolateCoordinate(coordinates, highIndex);
        sd += $55fa2487efb2d4e1$var$getSquaredDistance(start, end);
    }
    for(let i = lowWholeIndex; i < highWholeIndex - 1; ++i){
        const start = $55fa2487efb2d4e1$var$getCoordinate(coordinates, i);
        const end = $55fa2487efb2d4e1$var$getCoordinate(coordinates, i + 1);
        sd += $55fa2487efb2d4e1$var$getSquaredDistance(start, end);
    }
    return sd;
}
/**
 * @param {import("../coordinate.js").Coordinate} coordinate The coordinate.
 * @param {import("../geom/Geometry.js").default} geometry The candidate geometry.
 * @param {Array<TraceTarget>} targets The trace targets.
 */ function $55fa2487efb2d4e1$var$appendGeometryTraceTargets(coordinate, geometry, targets) {
    if (geometry instanceof (0, $292e4002746c8223$export$2e2bcd8739ae039)) {
        $55fa2487efb2d4e1$var$appendTraceTarget(coordinate, geometry.getCoordinates(), false, targets);
        return;
    }
    if (geometry instanceof (0, $b4c0e2e13beea46e$export$2e2bcd8739ae039)) {
        const coordinates = geometry.getCoordinates();
        for(let i = 0, ii = coordinates.length; i < ii; ++i)$55fa2487efb2d4e1$var$appendTraceTarget(coordinate, coordinates[i], false, targets);
        return;
    }
    if (geometry instanceof (0, $40aa8d43bbe572bf$export$2e2bcd8739ae039)) {
        const coordinates = geometry.getCoordinates();
        for(let i = 0, ii = coordinates.length; i < ii; ++i)$55fa2487efb2d4e1$var$appendTraceTarget(coordinate, coordinates[i], true, targets);
        return;
    }
    if (geometry instanceof (0, $f73f35eb6af8b987$export$2e2bcd8739ae039)) {
        const polys = geometry.getCoordinates();
        for(let i = 0, ii = polys.length; i < ii; ++i){
            const coordinates = polys[i];
            for(let j = 0, jj = coordinates.length; j < jj; ++j)$55fa2487efb2d4e1$var$appendTraceTarget(coordinate, coordinates[j], true, targets);
        }
        return;
    }
    if (geometry instanceof (0, $0e4f3959219eede5$export$2e2bcd8739ae039)) {
        const geometries = geometry.getGeometries();
        for(let i = 0; i < geometries.length; ++i)$55fa2487efb2d4e1$var$appendGeometryTraceTargets(coordinate, geometries[i], targets);
        return;
    }
// other types cannot be traced
}
/**
 * @typedef {Object} TraceTargetUpdateInfo
 * @property {number} index The new target index.
 * @property {number} endIndex The new segment end index.
 */ /**
 * @type {TraceTargetUpdateInfo}
 */ const $55fa2487efb2d4e1$var$sharedUpdateInfo = {
    index: -1,
    endIndex: NaN
};
/**
 * @param {import("../coordinate.js").Coordinate} coordinate The coordinate.
 * @param {TraceState} traceState The trace state.
 * @param {import("../Map.js").default} map The map.
 * @param {number} snapTolerance The snap tolerance.
 * @return {TraceTargetUpdateInfo} Information about the new trace target.  The returned
 * object is reused between calls and must not be modified by the caller.
 */ function $55fa2487efb2d4e1$var$getTraceTargetUpdate(coordinate, traceState, map, snapTolerance) {
    const x = coordinate[0];
    const y = coordinate[1];
    let closestTargetDistance = Infinity;
    let newTargetIndex = -1;
    let newEndIndex = NaN;
    for(let targetIndex = 0; targetIndex < traceState.targets.length; ++targetIndex){
        const target = traceState.targets[targetIndex];
        const coordinates = target.coordinates;
        let minSegmentDistance = Infinity;
        let endIndex;
        for(let coordinateIndex = 0; coordinateIndex < coordinates.length - 1; ++coordinateIndex){
            const start = coordinates[coordinateIndex];
            const end = coordinates[coordinateIndex + 1];
            const rel = $55fa2487efb2d4e1$var$getPointSegmentRelationship(x, y, start, end);
            if (rel.squaredDistance < minSegmentDistance) {
                minSegmentDistance = rel.squaredDistance;
                endIndex = coordinateIndex + rel.along;
            }
        }
        if (minSegmentDistance < closestTargetDistance) {
            closestTargetDistance = minSegmentDistance;
            if (target.ring && traceState.targetIndex === targetIndex) {
                // same target, maintain the same trace direction
                if (target.endIndex > target.startIndex) // forward trace
                {
                    if (endIndex < target.startIndex) endIndex += coordinates.length;
                } else if (target.endIndex < target.startIndex) // reverse trace
                {
                    if (endIndex > target.startIndex) endIndex -= coordinates.length;
                }
            }
            newEndIndex = endIndex;
            newTargetIndex = targetIndex;
        }
    }
    const newTarget = traceState.targets[newTargetIndex];
    let considerBothDirections = newTarget.ring;
    if (traceState.targetIndex === newTargetIndex && considerBothDirections) {
        // only consider switching trace direction if close to the start
        const newCoordinate = $55fa2487efb2d4e1$var$interpolateCoordinate(newTarget.coordinates, newEndIndex);
        const pixel = map.getPixelFromCoordinate(newCoordinate);
        if ((0, $1bd0a226f9a16141$export$9f17032d917177de)(pixel, traceState.startPx) > snapTolerance) considerBothDirections = false;
    }
    if (considerBothDirections) {
        const coordinates = newTarget.coordinates;
        const count = coordinates.length;
        const startIndex = newTarget.startIndex;
        const endIndex = newEndIndex;
        if (startIndex < endIndex) {
            const forwardDistance = $55fa2487efb2d4e1$var$getCumulativeSquaredDistance(coordinates, startIndex, endIndex);
            const reverseDistance = $55fa2487efb2d4e1$var$getCumulativeSquaredDistance(coordinates, startIndex, endIndex - count);
            if (reverseDistance < forwardDistance) newEndIndex -= count;
        } else {
            const reverseDistance = $55fa2487efb2d4e1$var$getCumulativeSquaredDistance(coordinates, startIndex, endIndex);
            const forwardDistance = $55fa2487efb2d4e1$var$getCumulativeSquaredDistance(coordinates, startIndex, endIndex + count);
            if (forwardDistance < reverseDistance) newEndIndex += count;
        }
    }
    $55fa2487efb2d4e1$var$sharedUpdateInfo.index = newTargetIndex;
    $55fa2487efb2d4e1$var$sharedUpdateInfo.endIndex = newEndIndex;
    return $55fa2487efb2d4e1$var$sharedUpdateInfo;
}
/**
 * @param {import("../coordinate.js").Coordinate} coordinate The clicked coordinate.
 * @param {Array<import("../coordinate.js").Coordinate>} coordinates The geometry component coordinates.
 * @param {boolean} ring The coordinates represent a linear ring.
 * @param {Array<TraceTarget>} targets The trace targets.
 */ function $55fa2487efb2d4e1$var$appendTraceTarget(coordinate, coordinates, ring, targets) {
    const x = coordinate[0];
    const y = coordinate[1];
    for(let i = 0, ii = coordinates.length - 1; i < ii; ++i){
        const start = coordinates[i];
        const end = coordinates[i + 1];
        const rel = $55fa2487efb2d4e1$var$getPointSegmentRelationship(x, y, start, end);
        if (rel.squaredDistance === 0) {
            const index = i + rel.along;
            targets.push({
                coordinates: coordinates,
                ring: ring,
                startIndex: index,
                endIndex: index
            });
            return;
        }
    }
}
/**
 * @typedef {Object} PointSegmentRelationship
 * @property {number} along The closest point expressed as a fraction along the segment length.
 * @property {number} squaredDistance The squared distance of the point to the segment.
 */ /**
 * @type {PointSegmentRelationship}
 */ const $55fa2487efb2d4e1$var$sharedRel = {
    along: 0,
    squaredDistance: 0
};
/**
 * @param {number} x The point x.
 * @param {number} y The point y.
 * @param {import("../coordinate.js").Coordinate} start The segment start.
 * @param {import("../coordinate.js").Coordinate} end The segment end.
 * @return {PointSegmentRelationship} The point segment relationship.  The returned object is
 * shared between calls and must not be modified by the caller.
 */ function $55fa2487efb2d4e1$var$getPointSegmentRelationship(x, y, start, end) {
    const x1 = start[0];
    const y1 = start[1];
    const x2 = end[0];
    const y2 = end[1];
    const dx = x2 - x1;
    const dy = y2 - y1;
    let along = 0;
    let px = x1;
    let py = y1;
    if (dx !== 0 || dy !== 0) {
        along = (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(((x - x1) * dx + (y - y1) * dy) / (dx * dx + dy * dy), 0, 1);
        px += dx * along;
        py += dy * along;
    }
    $55fa2487efb2d4e1$var$sharedRel.along = along;
    $55fa2487efb2d4e1$var$sharedRel.squaredDistance = (0, $6b000a049d919fe5$export$a81f732198733497)((0, $6b000a049d919fe5$export$88e6ebb4fe54f538)(x, y, px, py), 10);
    return $55fa2487efb2d4e1$var$sharedRel;
}
/**
 * @param {LineCoordType} coordinates The coordinates.
 * @param {number} index The index.  May be fractional and may wrap.
 * @return {import("../coordinate.js").Coordinate} The interpolated coordinate.
 */ function $55fa2487efb2d4e1$var$interpolateCoordinate(coordinates, index) {
    const count = coordinates.length;
    let startIndex = Math.floor(index);
    const along = index - startIndex;
    if (startIndex >= count) startIndex -= count;
    else if (startIndex < 0) startIndex += count;
    let endIndex = startIndex + 1;
    if (endIndex >= count) endIndex -= count;
    const start = coordinates[startIndex];
    const x0 = start[0];
    const y0 = start[1];
    const end = coordinates[endIndex];
    const dx = end[0] - x0;
    const dy = end[1] - y0;
    return [
        x0 + dx * along,
        y0 + dy * along
    ];
}
/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types|
 *     'change:active', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<'drawabort'|'drawend'|'drawstart', DrawEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types|
 *     'change:active'|'drawabort'|'drawend'|'drawstart', Return>} DrawOnSignature
 */ /**
 * @classdesc
 * Interaction for drawing feature geometries.
 *
 * @fires DrawEvent
 * @api
 */ class $55fa2487efb2d4e1$var$Draw extends (0, $cf1eb502962d87a8$export$2e2bcd8739ae039) {
    /**
   * @param {Options} options Options.
   */ constructor(options){
        const pointerOptions = /** @type {import("./Pointer.js").Options} */ options;
        if (!pointerOptions.stopDown) pointerOptions.stopDown = (0, $013a1733c226ec50$export$8f11cee4bdc7e668);
        super(pointerOptions);
        /***
     * @type {DrawOnSignature<import("../events").EventsKey>}
     */ this.on;
        /***
     * @type {DrawOnSignature<import("../events").EventsKey>}
     */ this.once;
        /***
     * @type {DrawOnSignature<void>}
     */ this.un;
        /**
     * @type {boolean}
     * @private
     */ this.shouldHandle_ = false;
        /**
     * @type {import("../pixel.js").Pixel}
     * @private
     */ this.downPx_ = null;
        /**
     * @type {ReturnType<typeof setTimeout>}
     * @private
     */ this.downTimeout_;
        /**
     * @type {number|undefined}
     * @private
     */ this.lastDragTime_;
        /**
     * Pointer type of the last pointermove event
     * @type {string}
     * @private
     */ this.pointerType_;
        /**
     * @type {boolean}
     * @private
     */ this.freehand_ = false;
        /**
     * Target source for drawn features.
     * @type {VectorSource|null}
     * @private
     */ this.source_ = options.source ? options.source : null;
        /**
     * Target collection for drawn features.
     * @type {import("../Collection.js").default<Feature>|null}
     * @private
     */ this.features_ = options.features ? options.features : null;
        /**
     * Pixel distance for snapping.
     * @type {number}
     * @private
     */ this.snapTolerance_ = options.snapTolerance ? options.snapTolerance : 12;
        /**
     * Geometry type.
     * @type {import("../geom/Geometry.js").Type}
     * @private
     */ this.type_ = /** @type {import("../geom/Geometry.js").Type} */ options.type;
        /**
     * Drawing mode (derived from geometry type.
     * @type {Mode}
     * @private
     */ this.mode_ = $55fa2487efb2d4e1$var$getMode(this.type_);
        /**
     * Stop click, singleclick, and doubleclick events from firing during drawing.
     * Default is `false`.
     * @type {boolean}
     * @private
     */ this.stopClick_ = !!options.stopClick;
        /**
     * The number of points that must be drawn before a polygon ring or line
     * string can be finished.  The default is 3 for polygon rings and 2 for
     * line strings.
     * @type {number}
     * @private
     */ this.minPoints_ = options.minPoints ? options.minPoints : this.mode_ === 'Polygon' ? 3 : 2;
        /**
     * The number of points that can be drawn before a polygon ring or line string
     * is finished. The default is no restriction.
     * @type {number}
     * @private
     */ this.maxPoints_ = this.mode_ === 'Circle' ? 2 : options.maxPoints ? options.maxPoints : Infinity;
        /**
     * A function to decide if a potential finish coordinate is permissible
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.finishCondition_ = options.finishCondition ? options.finishCondition : (0, $013a1733c226ec50$export$22e23a2304399231);
        /**
     * @private
     * @type {import("../geom/Geometry.js").GeometryLayout}
     */ this.geometryLayout_ = options.geometryLayout ? options.geometryLayout : 'XY';
        let geometryFunction = options.geometryFunction;
        if (!geometryFunction) {
            const mode = this.mode_;
            if (mode === 'Circle') /**
         * @param {!LineCoordType} coordinates The coordinates.
         * @param {import("../geom/SimpleGeometry.js").default|undefined} geometry Optional geometry.
         * @param {import("../proj/Projection.js").default} projection The view projection.
         * @return {import("../geom/SimpleGeometry.js").default} A geometry.
         */ geometryFunction = (coordinates, geometry, projection)=>{
                const circle = geometry ? /** @type {Circle} */ geometry : new (0, $f6170f1a08d72585$export$2e2bcd8739ae039)([
                    NaN,
                    NaN
                ]);
                const center = (0, $9c4744460e43e41b$export$d4b8ec0b96db1ee2)(coordinates[0], projection);
                const squaredLength = (0, $1bd0a226f9a16141$export$88e6ebb4fe54f538)(center, (0, $9c4744460e43e41b$export$d4b8ec0b96db1ee2)(coordinates[coordinates.length - 1], projection));
                circle.setCenterAndRadius(center, Math.sqrt(squaredLength), this.geometryLayout_);
                const userProjection = (0, $9c4744460e43e41b$export$3973b77d5f6f2790)();
                if (userProjection) circle.transform(projection, userProjection);
                return circle;
            };
            else {
                let Constructor;
                if (mode === 'Point') Constructor = (0, $6eced4c969949f6b$export$2e2bcd8739ae039);
                else if (mode === 'LineString') Constructor = (0, $292e4002746c8223$export$2e2bcd8739ae039);
                else if (mode === 'Polygon') Constructor = (0, $40aa8d43bbe572bf$export$2e2bcd8739ae039);
                /**
         * @param {!LineCoordType} coordinates The coordinates.
         * @param {import("../geom/SimpleGeometry.js").default|undefined} geometry Optional geometry.
         * @param {import("../proj/Projection.js").default} projection The view projection.
         * @return {import("../geom/SimpleGeometry.js").default} A geometry.
         */ geometryFunction = (coordinates, geometry, projection)=>{
                    if (geometry) {
                        if (mode === 'Polygon') {
                            if (coordinates[0].length) // Add a closing coordinate to match the first
                            geometry.setCoordinates([
                                coordinates[0].concat([
                                    coordinates[0][0]
                                ])
                            ], this.geometryLayout_);
                            else geometry.setCoordinates([], this.geometryLayout_);
                        } else geometry.setCoordinates(coordinates, this.geometryLayout_);
                    } else geometry = new Constructor(coordinates, this.geometryLayout_);
                    return geometry;
                };
            }
        }
        /**
     * @type {GeometryFunction}
     * @private
     */ this.geometryFunction_ = geometryFunction;
        /**
     * @type {number}
     * @private
     */ this.dragVertexDelay_ = options.dragVertexDelay !== undefined ? options.dragVertexDelay : 500;
        /**
     * Finish coordinate for the feature (first point for polygons, last point for
     * linestrings).
     * @type {import("../coordinate.js").Coordinate}
     * @private
     */ this.finishCoordinate_ = null;
        /**
     * Sketch feature.
     * @type {Feature<import('../geom/SimpleGeometry.js').default>}
     * @private
     */ this.sketchFeature_ = null;
        /**
     * Sketch point.
     * @type {Feature<Point>}
     * @private
     */ this.sketchPoint_ = null;
        /**
     * Sketch coordinates. Used when drawing a line or polygon.
     * @type {SketchCoordType}
     * @private
     */ this.sketchCoords_ = null;
        /**
     * Sketch line. Used when drawing polygon.
     * @type {Feature<LineString>}
     * @private
     */ this.sketchLine_ = null;
        /**
     * Sketch line coordinates. Used when drawing a polygon or circle.
     * @type {LineCoordType}
     * @private
     */ this.sketchLineCoords_ = null;
        /**
     * Squared tolerance for handling up events.  If the squared distance
     * between a down and up event is greater than this tolerance, up events
     * will not be handled.
     * @type {number}
     * @private
     */ this.squaredClickTolerance_ = options.clickTolerance ? options.clickTolerance * options.clickTolerance : 36;
        /**
     * Draw overlay where our sketch features are drawn.
     * @type {VectorLayer}
     * @private
     */ this.overlay_ = new (0, $82a68515bd6ef378$export$2e2bcd8739ae039)({
            source: new (0, $84888e4daf3fdf44$export$2e2bcd8739ae039)({
                useSpatialIndex: false,
                wrapX: options.wrapX ? options.wrapX : false
            }),
            style: options.style ? options.style : $55fa2487efb2d4e1$var$getDefaultStyleFunction(),
            updateWhileInteracting: true
        });
        /**
     * Name of the geometry attribute for newly created features.
     * @type {string|undefined}
     * @private
     */ this.geometryName_ = options.geometryName;
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.condition_ = options.condition ? options.condition : (0, $edf87b50170125f7$export$fdc892d0d8fe3bfb);
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.freehandCondition_;
        if (options.freehand) this.freehandCondition_ = (0, $edf87b50170125f7$export$ba9e5d519bc326ca);
        else this.freehandCondition_ = options.freehandCondition ? options.freehandCondition : (0, $edf87b50170125f7$export$5d31fe68a477cfbb);
        /**
     * @type {import("../events/condition.js").Condition}
     * @private
     */ this.traceCondition_;
        this.setTrace(options.trace || false);
        /**
     * @type {TraceState}
     * @private
     */ this.traceState_ = {
            active: false
        };
        /**
     * @type {VectorSource|null}
     * @private
     */ this.traceSource_ = options.traceSource || options.source || null;
        this.addChangeListener((0, $2c9e42723ccf2bfb$export$2e2bcd8739ae039).ACTIVE, this.updateState_);
    }
    /**
   * Toggle tracing mode or set a tracing condition.
   *
   * @param {boolean|import("../events/condition.js").Condition} trace A boolean to toggle tracing mode or an event
   *     condition that will be checked when a feature is clicked to determine if tracing should be active.
   */ setTrace(trace) {
        let condition;
        if (!trace) condition = (0, $edf87b50170125f7$export$b3e22bcfd64c1022);
        else if (trace === true) condition = (0, $edf87b50170125f7$export$ba9e5d519bc326ca);
        else condition = trace;
        this.traceCondition_ = condition;
    }
    /**
   * Remove the interaction from its current map and attach it to the new map.
   * Subclasses may set up event handlers to get notified about changes to
   * the map here.
   * @param {import("../Map.js").default} map Map.
   * @override
   */ setMap(map) {
        super.setMap(map);
        this.updateState_();
    }
    /**
   * Get the overlay layer that this interaction renders sketch features to.
   * @return {VectorLayer} Overlay layer.
   * @api
   */ getOverlay() {
        return this.overlay_;
    }
    /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} and may actually draw or finish the drawing.
   * @param {import("../MapBrowserEvent.js").default<PointerEvent>} event Map browser event.
   * @return {boolean} `false` to stop event propagation.
   * @api
   * @override
   */ handleEvent(event) {
        if (event.originalEvent.type === (0, $294047c5e65f31a3$export$2e2bcd8739ae039).CONTEXTMENU) // Avoid context menu for long taps when drawing on mobile
        event.originalEvent.preventDefault();
        this.freehand_ = this.mode_ !== 'Point' && this.freehandCondition_(event);
        let move = event.type === (0, $150f412a4a7fa263$export$2e2bcd8739ae039).POINTERMOVE;
        let pass = true;
        if (!this.freehand_ && this.lastDragTime_ && event.type === (0, $150f412a4a7fa263$export$2e2bcd8739ae039).POINTERDRAG) {
            const now = Date.now();
            if (now - this.lastDragTime_ >= this.dragVertexDelay_) {
                this.downPx_ = event.pixel;
                this.shouldHandle_ = !this.freehand_;
                move = true;
            } else this.lastDragTime_ = undefined;
            if (this.shouldHandle_ && this.downTimeout_ !== undefined) {
                clearTimeout(this.downTimeout_);
                this.downTimeout_ = undefined;
            }
        }
        if (this.freehand_ && event.type === (0, $150f412a4a7fa263$export$2e2bcd8739ae039).POINTERDRAG && this.sketchFeature_ !== null) {
            this.addToDrawing_(event.coordinate);
            pass = false;
        } else if (this.freehand_ && event.type === (0, $150f412a4a7fa263$export$2e2bcd8739ae039).POINTERDOWN) pass = false;
        else if (move && this.getPointerCount() < 2) {
            pass = event.type === (0, $150f412a4a7fa263$export$2e2bcd8739ae039).POINTERMOVE;
            if (pass && this.freehand_) {
                this.handlePointerMove_(event);
                if (this.shouldHandle_) // Avoid page scrolling when freehand drawing on mobile
                event.originalEvent.preventDefault();
            } else if (event.originalEvent.pointerType === 'mouse' || event.type === (0, $150f412a4a7fa263$export$2e2bcd8739ae039).POINTERDRAG && this.downTimeout_ === undefined) this.handlePointerMove_(event);
        } else if (event.type === (0, $150f412a4a7fa263$export$2e2bcd8739ae039).DBLCLICK) pass = false;
        return super.handleEvent(event) && pass;
    }
    /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default<PointerEvent>} event Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleDownEvent(event) {
        this.shouldHandle_ = !this.freehand_;
        if (this.freehand_) {
            this.downPx_ = event.pixel;
            if (!this.finishCoordinate_) this.startDrawing_(event.coordinate);
            return true;
        }
        if (!this.condition_(event)) {
            this.lastDragTime_ = undefined;
            return false;
        }
        this.lastDragTime_ = Date.now();
        this.downTimeout_ = setTimeout(()=>{
            this.handlePointerMove_(new (0, $a1b91f073c6a6c43$export$2e2bcd8739ae039)((0, $150f412a4a7fa263$export$2e2bcd8739ae039).POINTERMOVE, event.map, event.originalEvent, false, event.frameState));
        }, this.dragVertexDelay_);
        this.downPx_ = event.pixel;
        return true;
    }
    /**
   * @private
   */ deactivateTrace_() {
        this.traceState_ = {
            active: false
        };
    }
    /**
   * Activate or deactivate trace state based on a browser event.
   * @param {import("../MapBrowserEvent.js").default} event Event.
   * @private
   */ toggleTraceState_(event) {
        if (!this.traceSource_ || !this.traceCondition_(event)) return;
        if (this.traceState_.active) {
            this.deactivateTrace_();
            return;
        }
        const map = this.getMap();
        const lowerLeft = map.getCoordinateFromPixel([
            event.pixel[0] - this.snapTolerance_,
            event.pixel[1] + this.snapTolerance_
        ]);
        const upperRight = map.getCoordinateFromPixel([
            event.pixel[0] + this.snapTolerance_,
            event.pixel[1] - this.snapTolerance_
        ]);
        const extent = (0, $6da4c8ed3074c92b$export$8aceca7c77505534)([
            lowerLeft,
            upperRight
        ]);
        const features = this.traceSource_.getFeaturesInExtent(extent);
        if (features.length === 0) return;
        const targets = $55fa2487efb2d4e1$var$getTraceTargets(event.coordinate, features);
        if (targets.length) this.traceState_ = {
            active: true,
            startPx: event.pixel.slice(),
            targets: targets,
            targetIndex: -1
        };
    }
    /**
   * @param {TraceTarget} target The trace target.
   * @param {number} endIndex The new end index of the trace.
   * @private
   */ addOrRemoveTracedCoordinates_(target, endIndex) {
        // three cases to handle:
        //  1. traced in the same direction and points need adding
        //  2. traced in the same direction and points need removing
        //  3. traced in a new direction
        const previouslyForward = target.startIndex <= target.endIndex;
        const currentlyForward = target.startIndex <= endIndex;
        if (previouslyForward === currentlyForward) {
            // same direction
            if (previouslyForward && endIndex > target.endIndex || !previouslyForward && endIndex < target.endIndex) // case 1 - add new points
            this.addTracedCoordinates_(target, target.endIndex, endIndex);
            else if (previouslyForward && endIndex < target.endIndex || !previouslyForward && endIndex > target.endIndex) // case 2 - remove old points
            this.removeTracedCoordinates_(endIndex, target.endIndex);
        } else {
            // case 3 - remove old points, add new points
            this.removeTracedCoordinates_(target.startIndex, target.endIndex);
            this.addTracedCoordinates_(target, target.startIndex, endIndex);
        }
    }
    /**
   * @param {number} fromIndex The start index.
   * @param {number} toIndex The end index.
   * @private
   */ removeTracedCoordinates_(fromIndex, toIndex) {
        if (fromIndex === toIndex) return;
        let remove = 0;
        if (fromIndex < toIndex) {
            const start = Math.ceil(fromIndex);
            let end = Math.floor(toIndex);
            if (end === toIndex) end -= 1;
            remove = end - start + 1;
        } else {
            const start = Math.floor(fromIndex);
            let end = Math.ceil(toIndex);
            if (end === toIndex) end += 1;
            remove = start - end + 1;
        }
        if (remove > 0) this.removeLastPoints_(remove);
    }
    /**
   * @param {TraceTarget} target The trace target.
   * @param {number} fromIndex The start index.
   * @param {number} toIndex The end index.
   * @private
   */ addTracedCoordinates_(target, fromIndex, toIndex) {
        if (fromIndex === toIndex) return;
        const coordinates = [];
        if (fromIndex < toIndex) {
            // forward trace
            const start = Math.ceil(fromIndex);
            let end = Math.floor(toIndex);
            if (end === toIndex) // if end is snapped to a vertex, it will be added later
            end -= 1;
            for(let i = start; i <= end; ++i)coordinates.push($55fa2487efb2d4e1$var$getCoordinate(target.coordinates, i));
        } else {
            // reverse trace
            const start = Math.floor(fromIndex);
            let end = Math.ceil(toIndex);
            if (end === toIndex) end += 1;
            for(let i = start; i >= end; --i)coordinates.push($55fa2487efb2d4e1$var$getCoordinate(target.coordinates, i));
        }
        if (coordinates.length) this.appendCoordinates(coordinates);
    }
    /**
   * Update the trace.
   * @param {import("../MapBrowserEvent.js").default} event Event.
   * @private
   */ updateTrace_(event) {
        const traceState = this.traceState_;
        if (!traceState.active) return;
        if (traceState.targetIndex === -1) {
            // check if we are ready to pick a target
            if ((0, $1bd0a226f9a16141$export$9f17032d917177de)(traceState.startPx, event.pixel) < this.snapTolerance_) return;
        }
        const updatedTraceTarget = $55fa2487efb2d4e1$var$getTraceTargetUpdate(event.coordinate, traceState, this.getMap(), this.snapTolerance_);
        if (traceState.targetIndex !== updatedTraceTarget.index) {
            // target changed
            if (traceState.targetIndex !== -1) {
                // remove points added during previous trace
                const oldTarget = traceState.targets[traceState.targetIndex];
                this.removeTracedCoordinates_(oldTarget.startIndex, oldTarget.endIndex);
            }
            // add points for the new target
            const newTarget = traceState.targets[updatedTraceTarget.index];
            this.addTracedCoordinates_(newTarget, newTarget.startIndex, updatedTraceTarget.endIndex);
        } else {
            // target stayed the same
            const target = traceState.targets[traceState.targetIndex];
            this.addOrRemoveTracedCoordinates_(target, updatedTraceTarget.endIndex);
        }
        // modify the state with updated info
        traceState.targetIndex = updatedTraceTarget.index;
        const target = traceState.targets[traceState.targetIndex];
        target.endIndex = updatedTraceTarget.endIndex;
        // update event coordinate and pixel to match end point of final segment
        const coordinate = $55fa2487efb2d4e1$var$interpolateCoordinate(target.coordinates, target.endIndex);
        const pixel = this.getMap().getPixelFromCoordinate(coordinate);
        event.coordinate = coordinate;
        event.pixel = [
            Math.round(pixel[0]),
            Math.round(pixel[1])
        ];
    }
    /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default<PointerEvent>} event Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleUpEvent(event) {
        let pass = true;
        if (this.getPointerCount() === 0) {
            if (this.downTimeout_) {
                clearTimeout(this.downTimeout_);
                this.downTimeout_ = undefined;
            }
            this.handlePointerMove_(event);
            const tracing = this.traceState_.active;
            this.toggleTraceState_(event);
            if (this.shouldHandle_) {
                const startingToDraw = !this.finishCoordinate_;
                if (startingToDraw) this.startDrawing_(event.coordinate);
                if (!startingToDraw && this.freehand_) this.finishDrawing();
                else if (!this.freehand_ && (!startingToDraw || this.mode_ === 'Point')) {
                    if (this.atFinish_(event.pixel, tracing)) {
                        if (this.finishCondition_(event)) this.finishDrawing();
                    } else this.addToDrawing_(event.coordinate);
                }
                pass = false;
            } else if (this.freehand_) this.abortDrawing();
        }
        if (!pass && this.stopClick_) event.preventDefault();
        return pass;
    }
    /**
   * Handle move events.
   * @param {import("../MapBrowserEvent.js").default<PointerEvent>} event A move event.
   * @private
   */ handlePointerMove_(event) {
        this.pointerType_ = event.originalEvent.pointerType;
        if (this.downPx_ && (!this.freehand_ && this.shouldHandle_ || this.freehand_ && !this.shouldHandle_)) {
            const downPx = this.downPx_;
            const clickPx = event.pixel;
            const dx = downPx[0] - clickPx[0];
            const dy = downPx[1] - clickPx[1];
            const squaredDistance = dx * dx + dy * dy;
            this.shouldHandle_ = this.freehand_ ? squaredDistance > this.squaredClickTolerance_ : squaredDistance <= this.squaredClickTolerance_;
            if (!this.shouldHandle_) return;
        }
        if (!this.finishCoordinate_) {
            this.createOrUpdateSketchPoint_(event.coordinate.slice());
            return;
        }
        this.updateTrace_(event);
        this.modifyDrawing_(event.coordinate);
    }
    /**
   * Determine if an event is within the snapping tolerance of the start coord.
   * @param {import("../pixel.js").Pixel} pixel Pixel.
   * @param {boolean} [tracing] Drawing in trace mode (only stop if at the starting point).
   * @return {boolean} The event is within the snapping tolerance of the start.
   * @private
   */ atFinish_(pixel, tracing) {
        let at = false;
        if (this.sketchFeature_) {
            let potentiallyDone = false;
            let potentiallyFinishCoordinates = [
                this.finishCoordinate_
            ];
            const mode = this.mode_;
            if (mode === 'Point') at = true;
            else if (mode === 'Circle') at = this.sketchCoords_.length === 2;
            else if (mode === 'LineString') potentiallyDone = !tracing && this.sketchCoords_.length > this.minPoints_;
            else if (mode === 'Polygon') {
                const sketchCoords = /** @type {PolyCoordType} */ this.sketchCoords_;
                potentiallyDone = sketchCoords[0].length > this.minPoints_;
                potentiallyFinishCoordinates = [
                    sketchCoords[0][0],
                    sketchCoords[0][sketchCoords[0].length - 2]
                ];
                if (tracing) potentiallyFinishCoordinates = [
                    sketchCoords[0][0]
                ];
                else potentiallyFinishCoordinates = [
                    sketchCoords[0][0],
                    sketchCoords[0][sketchCoords[0].length - 2]
                ];
            }
            if (potentiallyDone) {
                const map = this.getMap();
                for(let i = 0, ii = potentiallyFinishCoordinates.length; i < ii; i++){
                    const finishCoordinate = potentiallyFinishCoordinates[i];
                    const finishPixel = map.getPixelFromCoordinate(finishCoordinate);
                    const dx = pixel[0] - finishPixel[0];
                    const dy = pixel[1] - finishPixel[1];
                    const snapTolerance = this.freehand_ ? 1 : this.snapTolerance_;
                    at = Math.sqrt(dx * dx + dy * dy) <= snapTolerance;
                    if (at) {
                        this.finishCoordinate_ = finishCoordinate;
                        break;
                    }
                }
            }
        }
        return at;
    }
    /**
   * @param {import("../coordinate").Coordinate} coordinates Coordinate.
   * @private
   */ createOrUpdateSketchPoint_(coordinates) {
        if (!this.sketchPoint_) {
            this.sketchPoint_ = new (0, $9fd014ab6df63665$export$2e2bcd8739ae039)(new (0, $6eced4c969949f6b$export$2e2bcd8739ae039)(coordinates));
            this.updateSketchFeatures_();
        } else {
            const sketchPointGeom = this.sketchPoint_.getGeometry();
            sketchPointGeom.setCoordinates(coordinates);
        }
    }
    /**
   * @param {import("../geom/Polygon.js").default} geometry Polygon geometry.
   * @private
   */ createOrUpdateCustomSketchLine_(geometry) {
        if (!this.sketchLine_) this.sketchLine_ = new (0, $9fd014ab6df63665$export$2e2bcd8739ae039)();
        const ring = geometry.getLinearRing(0);
        let sketchLineGeom = this.sketchLine_.getGeometry();
        if (!sketchLineGeom) {
            sketchLineGeom = new (0, $292e4002746c8223$export$2e2bcd8739ae039)(ring.getFlatCoordinates(), ring.getLayout());
            this.sketchLine_.setGeometry(sketchLineGeom);
        } else {
            sketchLineGeom.setFlatCoordinates(ring.getLayout(), ring.getFlatCoordinates());
            sketchLineGeom.changed();
        }
    }
    /**
   * Start the drawing.
   * @param {import("../coordinate.js").Coordinate} start Start coordinate.
   * @private
   */ startDrawing_(start) {
        const projection = this.getMap().getView().getProjection();
        const stride = (0, $c76e993e57efc8c4$export$6af0c1b4a8549a43)(this.geometryLayout_);
        while(start.length < stride)start.push(0);
        this.finishCoordinate_ = start;
        if (this.mode_ === 'Point') this.sketchCoords_ = start.slice();
        else if (this.mode_ === 'Polygon') {
            this.sketchCoords_ = [
                [
                    start.slice(),
                    start.slice()
                ]
            ];
            this.sketchLineCoords_ = this.sketchCoords_[0];
        } else this.sketchCoords_ = [
            start.slice(),
            start.slice()
        ];
        if (this.sketchLineCoords_) this.sketchLine_ = new (0, $9fd014ab6df63665$export$2e2bcd8739ae039)(new (0, $292e4002746c8223$export$2e2bcd8739ae039)(this.sketchLineCoords_));
        const geometry = this.geometryFunction_(this.sketchCoords_, undefined, projection);
        this.sketchFeature_ = new (0, $9fd014ab6df63665$export$2e2bcd8739ae039)();
        if (this.geometryName_) this.sketchFeature_.setGeometryName(this.geometryName_);
        this.sketchFeature_.setGeometry(geometry);
        this.updateSketchFeatures_();
        this.dispatchEvent(new $55fa2487efb2d4e1$export$85a4910380d251a7($55fa2487efb2d4e1$var$DrawEventType.DRAWSTART, this.sketchFeature_));
    }
    /**
   * Modify the drawing.
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @private
   */ modifyDrawing_(coordinate) {
        const map = this.getMap();
        const geometry = this.sketchFeature_.getGeometry();
        const projection = map.getView().getProjection();
        const stride = (0, $c76e993e57efc8c4$export$6af0c1b4a8549a43)(this.geometryLayout_);
        let coordinates, last;
        while(coordinate.length < stride)coordinate.push(0);
        if (this.mode_ === 'Point') last = this.sketchCoords_;
        else if (this.mode_ === 'Polygon') {
            coordinates = /** @type {PolyCoordType} */ this.sketchCoords_[0];
            last = coordinates[coordinates.length - 1];
            if (this.atFinish_(map.getPixelFromCoordinate(coordinate))) // snap to finish
            coordinate = this.finishCoordinate_.slice();
        } else {
            coordinates = this.sketchCoords_;
            last = coordinates[coordinates.length - 1];
        }
        last[0] = coordinate[0];
        last[1] = coordinate[1];
        this.geometryFunction_(/** @type {!LineCoordType} */ this.sketchCoords_, geometry, projection);
        if (this.sketchPoint_) {
            const sketchPointGeom = this.sketchPoint_.getGeometry();
            sketchPointGeom.setCoordinates(coordinate);
        }
        if (geometry.getType() === 'Polygon' && this.mode_ !== 'Polygon') this.createOrUpdateCustomSketchLine_(/** @type {Polygon} */ geometry);
        else if (this.sketchLineCoords_) {
            const sketchLineGeom = this.sketchLine_.getGeometry();
            sketchLineGeom.setCoordinates(this.sketchLineCoords_);
        }
        this.updateSketchFeatures_();
    }
    /**
   * Add a new coordinate to the drawing.
   * @param {!PointCoordType} coordinate Coordinate
   * @return {Feature<import("../geom/SimpleGeometry.js").default>} The sketch feature.
   * @private
   */ addToDrawing_(coordinate) {
        const geometry = this.sketchFeature_.getGeometry();
        const projection = this.getMap().getView().getProjection();
        let done;
        let coordinates;
        const mode = this.mode_;
        if (mode === 'LineString' || mode === 'Circle') {
            this.finishCoordinate_ = coordinate.slice();
            coordinates = /** @type {LineCoordType} */ this.sketchCoords_;
            if (coordinates.length >= this.maxPoints_) {
                if (this.freehand_) coordinates.pop();
                else done = true;
            }
            coordinates.push(coordinate.slice());
            this.geometryFunction_(coordinates, geometry, projection);
        } else if (mode === 'Polygon') {
            coordinates = /** @type {PolyCoordType} */ this.sketchCoords_[0];
            if (coordinates.length >= this.maxPoints_) {
                if (this.freehand_) coordinates.pop();
                else done = true;
            }
            coordinates.push(coordinate.slice());
            if (done) this.finishCoordinate_ = coordinates[0];
            this.geometryFunction_(this.sketchCoords_, geometry, projection);
        }
        this.createOrUpdateSketchPoint_(coordinate.slice());
        this.updateSketchFeatures_();
        if (done) return this.finishDrawing();
        return this.sketchFeature_;
    }
    /**
   * @param {number} n The number of points to remove.
   */ removeLastPoints_(n) {
        if (!this.sketchFeature_) return;
        const geometry = this.sketchFeature_.getGeometry();
        const projection = this.getMap().getView().getProjection();
        const mode = this.mode_;
        for(let i = 0; i < n; ++i){
            let coordinates;
            if (mode === 'LineString' || mode === 'Circle') {
                coordinates = /** @type {LineCoordType} */ this.sketchCoords_;
                coordinates.splice(-2, 1);
                if (coordinates.length >= 2) {
                    this.finishCoordinate_ = coordinates[coordinates.length - 2].slice();
                    const finishCoordinate = this.finishCoordinate_.slice();
                    coordinates[coordinates.length - 1] = finishCoordinate;
                    this.createOrUpdateSketchPoint_(finishCoordinate);
                }
                this.geometryFunction_(coordinates, geometry, projection);
                if (geometry.getType() === 'Polygon' && this.sketchLine_) this.createOrUpdateCustomSketchLine_(/** @type {Polygon} */ geometry);
            } else if (mode === 'Polygon') {
                coordinates = /** @type {PolyCoordType} */ this.sketchCoords_[0];
                coordinates.splice(-2, 1);
                const sketchLineGeom = this.sketchLine_.getGeometry();
                if (coordinates.length >= 2) {
                    const finishCoordinate = coordinates[coordinates.length - 2].slice();
                    coordinates[coordinates.length - 1] = finishCoordinate;
                    this.createOrUpdateSketchPoint_(finishCoordinate);
                }
                sketchLineGeom.setCoordinates(coordinates);
                this.geometryFunction_(this.sketchCoords_, geometry, projection);
            }
            if (coordinates.length === 1) {
                this.abortDrawing();
                break;
            }
        }
        this.updateSketchFeatures_();
    }
    /**
   * Remove last point of the feature currently being drawn. Does not do anything when
   * drawing POINT or MULTI_POINT geometries.
   * @api
   */ removeLastPoint() {
        this.removeLastPoints_(1);
    }
    /**
   * Stop drawing and add the sketch feature to the target layer.
   * The {@link module:ol/interaction/Draw~DrawEventType.DRAWEND} event is
   * dispatched before inserting the feature.
   * @return {Feature<import("../geom/SimpleGeometry.js").default>|null} The drawn feature.
   * @api
   */ finishDrawing() {
        const sketchFeature = this.abortDrawing_();
        if (!sketchFeature) return null;
        let coordinates = this.sketchCoords_;
        const geometry = sketchFeature.getGeometry();
        const projection = this.getMap().getView().getProjection();
        if (this.mode_ === 'LineString') {
            // remove the redundant last point
            coordinates.pop();
            this.geometryFunction_(coordinates, geometry, projection);
        } else if (this.mode_ === 'Polygon') {
            // remove the redundant last point in ring
            /** @type {PolyCoordType} */ coordinates[0].pop();
            this.geometryFunction_(coordinates, geometry, projection);
            coordinates = geometry.getCoordinates();
        }
        // cast multi-part geometries
        if (this.type_ === 'MultiPoint') sketchFeature.setGeometry(new (0, $e6080c63a9451eda$export$2e2bcd8739ae039)([
            /** @type {PointCoordType} */ coordinates
        ]));
        else if (this.type_ === 'MultiLineString') sketchFeature.setGeometry(new (0, $b4c0e2e13beea46e$export$2e2bcd8739ae039)([
            /** @type {LineCoordType} */ coordinates
        ]));
        else if (this.type_ === 'MultiPolygon') sketchFeature.setGeometry(new (0, $f73f35eb6af8b987$export$2e2bcd8739ae039)([
            /** @type {PolyCoordType} */ coordinates
        ]));
        // First dispatch event to allow full set up of feature
        this.dispatchEvent(new $55fa2487efb2d4e1$export$85a4910380d251a7($55fa2487efb2d4e1$var$DrawEventType.DRAWEND, sketchFeature));
        // Then insert feature
        if (this.features_) this.features_.push(sketchFeature);
        if (this.source_) this.source_.addFeature(sketchFeature);
        return sketchFeature;
    }
    /**
   * Stop drawing without adding the sketch feature to the target layer.
   * @return {Feature<import("../geom/SimpleGeometry.js").default>|null} The sketch feature (or null if none).
   * @private
   */ abortDrawing_() {
        this.finishCoordinate_ = null;
        const sketchFeature = this.sketchFeature_;
        this.sketchFeature_ = null;
        this.sketchPoint_ = null;
        this.sketchLine_ = null;
        this.overlay_.getSource().clear(true);
        this.deactivateTrace_();
        return sketchFeature;
    }
    /**
   * Stop drawing without adding the sketch feature to the target layer.
   * @api
   */ abortDrawing() {
        const sketchFeature = this.abortDrawing_();
        if (sketchFeature) this.dispatchEvent(new $55fa2487efb2d4e1$export$85a4910380d251a7($55fa2487efb2d4e1$var$DrawEventType.DRAWABORT, sketchFeature));
    }
    /**
   * Append coordinates to the end of the geometry that is currently being drawn.
   * This can be used when drawing LineStrings or Polygons. Coordinates will
   * either be appended to the current LineString or the outer ring of the current
   * Polygon. If no geometry is being drawn, a new one will be created.
   * @param {!LineCoordType} coordinates Linear coordinates to be appended to
   * the coordinate array.
   * @api
   */ appendCoordinates(coordinates) {
        const mode = this.mode_;
        const newDrawing = !this.sketchFeature_;
        if (newDrawing) this.startDrawing_(coordinates[0]);
        /** @type {LineCoordType} */ let sketchCoords;
        if (mode === 'LineString' || mode === 'Circle') sketchCoords = /** @type {LineCoordType} */ this.sketchCoords_;
        else if (mode === 'Polygon') sketchCoords = this.sketchCoords_ && this.sketchCoords_.length ? /** @type {PolyCoordType} */ this.sketchCoords_[0] : [];
        else return;
        if (newDrawing) sketchCoords.shift();
        // Remove last coordinate from sketch drawing (this coordinate follows cursor position)
        sketchCoords.pop();
        // Append coordinate list
        for(let i = 0; i < coordinates.length; i++)this.addToDrawing_(coordinates[i]);
        const ending = coordinates[coordinates.length - 1];
        // Duplicate last coordinate for sketch drawing (cursor position)
        this.sketchFeature_ = this.addToDrawing_(ending);
        this.modifyDrawing_(ending);
    }
    /**
   * Initiate draw mode by starting from an existing geometry which will
   * receive new additional points. This only works on features with
   * `LineString` geometries, where the interaction will extend lines by adding
   * points to the end of the coordinates array.
   * This will change the original feature, instead of drawing a copy.
   *
   * The function will dispatch a `drawstart` event.
   *
   * @param {!Feature<LineString>} feature Feature to be extended.
   * @api
   */ extend(feature) {
        const geometry = feature.getGeometry();
        const lineString = geometry;
        this.sketchFeature_ = feature;
        this.sketchCoords_ = lineString.getCoordinates();
        const last = this.sketchCoords_[this.sketchCoords_.length - 1];
        this.finishCoordinate_ = last.slice();
        this.sketchCoords_.push(last.slice());
        this.sketchPoint_ = new (0, $9fd014ab6df63665$export$2e2bcd8739ae039)(new (0, $6eced4c969949f6b$export$2e2bcd8739ae039)(last));
        this.updateSketchFeatures_();
        this.dispatchEvent(new $55fa2487efb2d4e1$export$85a4910380d251a7($55fa2487efb2d4e1$var$DrawEventType.DRAWSTART, this.sketchFeature_));
    }
    /**
   * Redraw the sketch features.
   * @private
   */ updateSketchFeatures_() {
        const sketchFeatures = [];
        if (this.sketchFeature_) sketchFeatures.push(this.sketchFeature_);
        if (this.sketchLine_) sketchFeatures.push(this.sketchLine_);
        if (this.sketchPoint_) sketchFeatures.push(this.sketchPoint_);
        const overlaySource = this.overlay_.getSource();
        overlaySource.clear(true);
        overlaySource.addFeatures(sketchFeatures);
    }
    /**
   * @private
   */ updateState_() {
        const map = this.getMap();
        const active = this.getActive();
        if (!map || !active) this.abortDrawing();
        this.overlay_.setMap(active ? map : null);
    }
}
/**
 * @return {import("../style/Style.js").StyleFunction} Styles.
 */ function $55fa2487efb2d4e1$var$getDefaultStyleFunction() {
    const styles = (0, $8c7f6dda98e8cb9c$export$ed1eaede5d0e77ac)();
    return function(feature, resolution) {
        return styles[feature.getGeometry().getType()];
    };
}
function $55fa2487efb2d4e1$export$e636e17021965266(sides, angle) {
    return function(coordinates, geometry, projection) {
        const center = (0, $9c4744460e43e41b$export$d4b8ec0b96db1ee2)(/** @type {LineCoordType} */ coordinates[0], projection);
        const end = (0, $9c4744460e43e41b$export$d4b8ec0b96db1ee2)(/** @type {LineCoordType} */ coordinates[coordinates.length - 1], projection);
        const radius = Math.sqrt((0, $1bd0a226f9a16141$export$88e6ebb4fe54f538)(center, end));
        geometry = geometry || (0, $40aa8d43bbe572bf$export$2451009d645fb8c2)(new (0, $f6170f1a08d72585$export$2e2bcd8739ae039)(center), sides);
        let internalAngle = angle;
        if (!angle && angle !== 0) {
            const x = end[0] - center[0];
            const y = end[1] - center[1];
            internalAngle = Math.atan2(y, x);
        }
        (0, $40aa8d43bbe572bf$export$87d6a1539a56e47f)(/** @type {Polygon} */ geometry, center, radius, internalAngle);
        const userProjection = (0, $9c4744460e43e41b$export$3973b77d5f6f2790)();
        if (userProjection) geometry.transform(projection, userProjection);
        return geometry;
    };
}
function $55fa2487efb2d4e1$export$6459fc9e86be362e() {
    return function(coordinates, geometry, projection) {
        const extent = (0, $6da4c8ed3074c92b$export$8aceca7c77505534)(/** @type {LineCoordType} */ [
            coordinates[0],
            coordinates[coordinates.length - 1]
        ].map(function(coordinate) {
            return (0, $9c4744460e43e41b$export$d4b8ec0b96db1ee2)(coordinate, projection);
        }));
        const boxCoordinates = [
            [
                (0, $6da4c8ed3074c92b$export$8d09f5e2e1bf560d)(extent),
                (0, $6da4c8ed3074c92b$export$e77c1cf70445e168)(extent),
                (0, $6da4c8ed3074c92b$export$b84fa077c8b05295)(extent),
                (0, $6da4c8ed3074c92b$export$cb1538b07e6964ff)(extent),
                (0, $6da4c8ed3074c92b$export$8d09f5e2e1bf560d)(extent)
            ]
        ];
        if (geometry) geometry.setCoordinates(boxCoordinates);
        else geometry = new (0, $40aa8d43bbe572bf$export$2e2bcd8739ae039)(boxCoordinates);
        const userProjection = (0, $9c4744460e43e41b$export$3973b77d5f6f2790)();
        if (userProjection) geometry.transform(projection, userProjection);
        return geometry;
    };
}
/**
 * Get the drawing mode.  The mode for multi-part geometries is the same as for
 * their single-part cousins.
 * @param {import("../geom/Geometry.js").Type} type Geometry type.
 * @return {Mode} Drawing mode.
 */ function $55fa2487efb2d4e1$var$getMode(type) {
    switch(type){
        case 'Point':
        case 'MultiPoint':
            return 'Point';
        case 'LineString':
        case 'MultiLineString':
            return 'LineString';
        case 'Polygon':
        case 'MultiPolygon':
            return 'Polygon';
        case 'Circle':
            return 'Circle';
        default:
            throw new Error('Invalid type: ' + type);
    }
}
var $55fa2487efb2d4e1$export$2e2bcd8739ae039 = $55fa2487efb2d4e1$var$Draw;


const $9977d850e6d2e896$export$a81fed67d3b83557 = Object.freeze([
    'Square',
    'Rectangle',
    'Circle'
]);
// Note: 
// Square and Rectangle are not official geometries
// They are replaced with Circle-geometry at runtime
const $9977d850e6d2e896$export$433ad4aa6deed6b2 = Object.freeze({
    'Square': {
        type: 'Circle',
        callback: (0, $55fa2487efb2d4e1$export$e636e17021965266),
        parameters: 4
    },
    'Rectangle': {
        type: 'Circle',
        callback: (0, $55fa2487efb2d4e1$export$6459fc9e86be362e),
        parameters: undefined
    },
    'Circle': {
        type: 'Circle',
        callback: (0, $55fa2487efb2d4e1$export$e636e17021965266),
        parameters: 32
    }
});
const $9977d850e6d2e896$export$8f4397a63c3cef66 = Object.freeze({
    Circle: 'Circle',
    LinearRing: 'LinearRing',
    LineString: 'LineString',
    MultiLineString: 'MultiLineString',
    MultiPoint: 'MultiPoint',
    MultiPolygon: 'MultiPolygon',
    Point: 'Point',
    Polygon: 'Polygon',
    Rectangle: 'Rectangle',
    Square: 'Square'
});
const $9977d850e6d2e896$export$9efafe6ae419b7d = function(name) {
    const defaultGeometryType = 'Polygon';
    if (!(name in $9977d850e6d2e896$export$8f4397a63c3cef66)) return [
        defaultGeometryType,
        undefined
    ];
    if (!(name in $9977d850e6d2e896$export$433ad4aa6deed6b2)) return [
        name,
        undefined
    ];
    const mapper = $9977d850e6d2e896$export$433ad4aa6deed6b2[name];
    const type = mapper.type;
    const callback = mapper.callback;
    const parameters = mapper.parameters;
    return [
        type,
        callback(parameters)
    ];
};


const $45f5d1a81c4ed6cb$var$FILENAME = 'feature-manager.js';
/**
 * About:
 * FeatureManager
 * 
 * Description:
 * Used to create IconMarkers and WindBarbs and to check for internal properties on those generated Features.
 */ class $45f5d1a81c4ed6cb$export$73e78dff44a347ad extends (0, $8a2666592e7029ee$export$84777416d052f822) {
    static #map;
    //--------------------------------------------------------------------
    // # Section: Base Overrides
    //--------------------------------------------------------------------
    static async initAsync(options = {}) {
        (0, $b9b5c0363f244088$export$49b118289be48034).logDebug($45f5d1a81c4ed6cb$var$FILENAME, 'initAsync', 'Initialization started');
        return new Promise((resolve)=>{
            resolve({
                filename: $45f5d1a81c4ed6cb$var$FILENAME,
                result: true
            });
        });
    }
    static setMap(map) {
        this.#map = map;
    }
    static getName() {
        return $45f5d1a81c4ed6cb$var$FILENAME;
    }
    //--------------------------------------------------------------------
    // # Section: Internal
    //--------------------------------------------------------------------
    static #generateOLTBObject(options, type, unique = {}) {
        return {
            oltb: {
                lon: options.lon,
                lat: options.lat,
                type: type,
                infoWindow: options.infoWindow,
                title: options.title,
                description: options.description,
                settings: {
                    shouldReplaceHashtag: options.settings.shouldReplaceHashtag
                },
                ...unique,
                icon: {
                    key: options.icon.key,
                    width: options.icon.width,
                    height: options.icon.height,
                    rotation: options.icon.rotation,
                    fill: options.icon.fill,
                    stroke: options.icon.stroke,
                    strokeWidth: options.icon.strokeWidth
                },
                label: {
                    text: options.label.text,
                    font: options.label.font,
                    fill: options.label.fill,
                    stroke: options.label.stroke,
                    strokeWidth: options.label.strokeWidth,
                    useEllipsisAfter: options.label.useEllipsisAfter,
                    useUpperCase: options.label.useUpperCase
                }
            }
        };
    }
    static #convertFeatureToDrawing(feature) {
        this.applyDrawingProperties(feature);
        feature.setStyle((0, $2577fba4fdbf4b69$export$29bb23d12246c816).getDefaultDrawingStyle());
    }
    static #converFeatureToMeasurement(feature) {
        this.applyMeasurementProperties(feature);
        this.#map.addOverlay(this.getTooltip(feature));
        feature.setStyle((0, $2577fba4fdbf4b69$export$29bb23d12246c816).getDefaultMeasurementStyle());
    }
    static #isConvertableType(type) {
        const types = [
            (0, $9977d850e6d2e896$export$8f4397a63c3cef66).Circle,
            (0, $9977d850e6d2e896$export$8f4397a63c3cef66).LineString,
            (0, $9977d850e6d2e896$export$8f4397a63c3cef66).LinearRing,
            (0, $9977d850e6d2e896$export$8f4397a63c3cef66).MultiLineString,
            (0, $9977d850e6d2e896$export$8f4397a63c3cef66).MultiPolygon,
            (0, $9977d850e6d2e896$export$8f4397a63c3cef66).Polygon,
            (0, $9977d850e6d2e896$export$8f4397a63c3cef66).Rectangle,
            (0, $9977d850e6d2e896$export$8f4397a63c3cef66).Square
        ];
        return types.includes(type);
    }
    //--------------------------------------------------------------------
    // # Section: Public API
    //--------------------------------------------------------------------
    static getType(feature) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).get(feature.getProperties(), [
            'oltb',
            'type'
        ], undefined);
    }
    static isWindBarbType(feature) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).get(feature.getProperties(), [
            'oltb',
            'type'
        ], undefined) === (0, $60b20182c25e327b$export$2906e7f4b228efe9).type.windBarb;
    }
    static isIconMarkerType(feature) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).get(feature.getProperties(), [
            'oltb',
            'type'
        ], undefined) === (0, $60b20182c25e327b$export$2906e7f4b228efe9).type.iconMarker;
    }
    static isMeasurementType(feature) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).get(feature.getProperties(), [
            'oltb',
            'type'
        ], undefined) === (0, $60b20182c25e327b$export$2906e7f4b228efe9).type.measurement;
    }
    static shouldHighlightOnHover(feature) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).get(feature.getProperties(), [
            'oltb',
            'settings',
            'shouldHighlightOnHover'
        ], undefined) === true;
    }
    static hasInfoWindow(feature) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).has(feature.getProperties(), [
            'oltb',
            'infoWindow'
        ]);
    }
    static getInfoWindow(feature) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).get(feature.getProperties(), [
            'oltb',
            'infoWindow'
        ], undefined);
    }
    static hasTooltip(feature) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).has(feature.getProperties(), [
            'oltb',
            'tooltip'
        ]);
    }
    static getTooltip(feature) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).get(feature.getProperties(), [
            'oltb',
            'tooltip'
        ], undefined);
    }
    static generateWindBarb(options = {}) {
        options = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep((0, $923245ece89406d3$export$e8c24859bf18d46)), options);
        const feature = new (0, $9fd014ab6df63665$export$2e2bcd8739ae039)({
            geometry: new (0, $6eced4c969949f6b$export$2e2bcd8739ae039)((0, $9c4744460e43e41b$export$b15d9668511529b9)([
                options.lon,
                options.lat
            ]))
        });
        // Note:
        // The LayerManager is responsible to render the Wind Barb
        // This way the style can be optimized and controlled depending on the resolution/zoom-level
        feature.setProperties(this.#generateOLTBObject(options, (0, $60b20182c25e327b$export$2906e7f4b228efe9).type.windBarb));
        return feature;
    }
    static generateIconMarker(options = {}) {
        options = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep((0, $1a398e8f0612651b$export$1a318632ed6f2b6b)), options);
        const feature = new (0, $9fd014ab6df63665$export$2e2bcd8739ae039)({
            geometry: new (0, $6eced4c969949f6b$export$2e2bcd8739ae039)((0, $9c4744460e43e41b$export$b15d9668511529b9)([
                options.lon,
                options.lat
            ]))
        });
        // Note:
        // The LayerManager is responsible to render the IconMarker
        // This way the style can be optimized and controlled depending on the resolution/zoom-level
        feature.setProperties(this.#generateOLTBObject(options, (0, $60b20182c25e327b$export$2906e7f4b228efe9).type.iconMarker, {
            marker: {
                width: options.marker.width,
                radius: options.marker.radius,
                fill: options.marker.fill,
                stroke: options.marker.stroke,
                strokeWidth: options.marker.strokeWidth
            }
        }));
        return feature;
    }
    static isSameFeature(a, b) {
        if (!a || !b) return false;
        if (!a['ol_uid'] || !b['ol_uid']) return false;
        return a.ol_uid === b.ol_uid;
    }
    static deepCopyVectorFeatureWithStyle(feature, originalFeatureStyles) {
        const featureId = (0, $6c5e11070e371322$export$5e82334337e0f204)(feature);
        const clonedFeature = feature.clone();
        const clonedProperties = JSON.parse(JSON.stringify(JSON.decycle(feature.getProperties()), (0, $a8f2ca70ab701cb7$export$c4fdd084e378b052)));
        clonedProperties.geometry = clonedFeature.getGeometry();
        clonedFeature.setProperties(clonedProperties, true);
        clonedFeature.setStyle(originalFeatureStyles[featureId]);
        if (this.isMeasurementType(feature)) this.applyMeasurementProperties(clonedFeature);
        return clonedFeature;
    }
    static applyMeasurementProperties(feature) {
        if (this.hasTooltip(feature)) this.#map.removeOverlay(this.getTooltip(feature));
        const tooltip = (0, $318a0f888265a757$export$d2807c45400bf836)();
        feature.setProperties({
            oltb: {
                type: (0, $60b20182c25e327b$export$2906e7f4b228efe9).type.measurement,
                tooltip: tooltip.getOverlay()
            }
        });
        const geometry = feature.getGeometry();
        const measureCoordinates = (0, $ef19f7475e8f20ad$export$9a7874bcc72fae65)(geometry);
        const measureValue = (0, $ef19f7475e8f20ad$export$c8fdb1ecc11e521e)(geometry);
        tooltip.setPosition(measureCoordinates);
        tooltip.setData(`${measureValue.value} ${measureValue.unit}`);
    }
    static applyDrawingProperties(feature) {
        if (this.hasTooltip(feature)) this.#map.removeOverlay(this.getTooltip(feature));
        feature.setProperties({
            oltb: {
                type: (0, $60b20182c25e327b$export$2906e7f4b228efe9).type.drawing
            }
        });
    }
    static convertFeaturesTo(features, format) {
        const formats = new Map([
            [
                (0, $60b20182c25e327b$export$2906e7f4b228efe9).type.drawing,
                this.#convertFeatureToDrawing.bind(this)
            ],
            [
                (0, $60b20182c25e327b$export$2906e7f4b228efe9).type.measurement,
                this.#converFeatureToMeasurement.bind(this)
            ]
        ]);
        features.forEach((feature)=>{
            const converter = formats.get(format.value);
            const type = feature.getGeometry().getType();
            if (converter && this.#isConvertableType(type)) converter(feature);
            else (0, $b9b5c0363f244088$export$49b118289be48034).logWarning($45f5d1a81c4ed6cb$var$FILENAME, 'convertFeaturesTo', {
                info: 'Unsupported format or geometry-type',
                format: format,
                type: type
            });
        });
    }
}




const $e75fe1c51a3d360c$var$FILENAME = 'layer-manager.js';
const $e75fe1c51a3d360c$var$DEFAULT__LAYER_NAME = 'New layer';
const $e75fe1c51a3d360c$var$ZINDEX__BASE_MAP_LAYER = 1;
const $e75fe1c51a3d360c$var$ZINDEX__BASE_FEATURE_LAYER = 1e6;
const $e75fe1c51a3d360c$var$DefaultFeatureLayerOptions = Object.freeze({
    name: '',
    isVisible: true,
    isSilent: false,
    disableFeatureLayerEditButton: false,
    disableFeatureLayerDownloadButton: false,
    disableFeatureLayerDeleteButton: false
});
const $e75fe1c51a3d360c$var$DefaultMapLayerOptions = Object.freeze({
    isVisible: true,
    isSilent: false,
    disableMapLayerEditButton: false,
    disableMapLayerDeleteButton: false
});
/**
 * About:
 * LayerManager
 * 
 * Description:
 * Manages all Map- and Feature layers as well as all added features that are tracked by the SnapManager.
 */ class $e75fe1c51a3d360c$export$eff87c52915dd7fe extends (0, $8a2666592e7029ee$export$84777416d052f822) {
    static #map;
    static #activeFeatureLayer;
    // Note: 
    // When using Snap interaction
    // Option 1: Using a dedicated source, not optimal, thus it is hard to know what layer each drawn feature belongs to
    // There is an event that always sets the active feature layer to the targeted source for the Snap interaction
    // Option 2: A collection of features, but requires some work to keep this collection updated
    // The LayerManager must be the single point of adding/removing features from a layer, or the layer must be observed
    static #snapFeatures = new (0, $931ffc4e747c14db$export$2e2bcd8739ae039)();
    static #queue = {
        mapLayers: [],
        featureLayers: []
    };
    static #layers = {
        mapLayers: [],
        featureLayers: []
    };
    //--------------------------------------------------------------------
    // # Section: Base Overrides
    //--------------------------------------------------------------------
    static async initAsync(options = {}) {
        (0, $b9b5c0363f244088$export$49b118289be48034).logDebug($e75fe1c51a3d360c$var$FILENAME, 'initAsync', 'Initialization started');
        return new Promise((resolve)=>{
            resolve({
                filename: $e75fe1c51a3d360c$var$FILENAME,
                result: true
            });
        });
    }
    static setMap(map) {
        (0, $b9b5c0363f244088$export$49b118289be48034).logDebug($e75fe1c51a3d360c$var$FILENAME, 'setMap', {
            info: 'Handling map-queues for layers that were added before the map was ready',
            adding: {
                mapLayers: this.#queue.mapLayers.length,
                featureLayers: this.#queue.featureLayers.length
            }
        });
        this.#map = map;
        this.#handleMapLayerQueue();
        this.#handleFeatureLayerQueue();
    }
    static getName() {
        return $e75fe1c51a3d360c$var$FILENAME;
    }
    //--------------------------------------------------------------------
    // Section: Init
    //--------------------------------------------------------------------
    static #handleMapLayerQueue() {
        this.#queue.mapLayers.forEach((item)=>{
            this.#addMapLayerToMap(item.layerWrapper, item.options);
        });
        this.#queue.mapLayers = [];
    }
    static #handleFeatureLayerQueue() {
        this.#queue.featureLayers.forEach((item)=>{
            this.#addFeatureLayerToMap(item.layerWrapper, item.options);
        });
        this.#queue.featureLayers = [];
    }
    //--------------------------------------------------------------------
    // Section: Internal
    //--------------------------------------------------------------------
    static #addPropertiesInterface(layerWrapper) {
        layerWrapper.getLayer = function() {
            return this.layer;
        };
        layerWrapper.setLayer = function(layer) {
            this.layer = layer;
        };
        layerWrapper.getName = function() {
            return this.name;
        };
        layerWrapper.setName = function(name) {
            this.name = name;
        };
        layerWrapper.getId = function() {
            return this.id;
        };
        layerWrapper.setId = function(id) {
            this.id = id;
        };
    }
    static #validateName(name) {
        name = name.trim();
        if (!name.length) name = $e75fe1c51a3d360c$var$DEFAULT__LAYER_NAME;
        return name;
    }
    static #getLayerWrapperFromFeature(target, layers) {
        for(let i = 0; i < layers.length; i++){
            const layerWrapper = layers[i];
            const layer = layerWrapper.getLayer();
            // Note:
            // Only vector layers can have features
            if (!this.isVectorLayer(layer)) continue;
            const source = layer.getSource();
            const features = source.getFeatures();
            for(let j = 0; j < features.length; j++){
                if (target === features[j]) return layerWrapper;
            }
        }
        return undefined;
    }
    static #removeLayerFromMap(layerWrapper) {
        this.#map.removeLayer(layerWrapper.getLayer());
    }
    static #handleFeatureOverlays(feature, layerWrapper) {
        const layer = layerWrapper.getLayer();
        const tooltip = (0, $45f5d1a81c4ed6cb$export$73e78dff44a347ad).getTooltip(feature);
        if (!tooltip) return;
        if (layer.getVisible()) tooltip.setMap(this.#map);
        else tooltip.setMap(null);
    }
    //--------------------------------------------------------------------
    // Section: Common Layers
    //--------------------------------------------------------------------
    static addFeatureToLayer(feature, layerWrapper, i18nKey) {
        const layer = layerWrapper.getLayer();
        const source = layer.getSource();
        if ((0, $45f5d1a81c4ed6cb$export$73e78dff44a347ad).hasTooltip(feature)) this.#map.addOverlay((0, $45f5d1a81c4ed6cb$export$73e78dff44a347ad).getTooltip(feature));
        source.addFeature(feature);
        this.#snapFeatures.push(feature);
        this.#handleFeatureOverlays(feature, layerWrapper);
        if (i18nKey && !layer.getVisible()) (0, $9051f0e072bf4341$export$8d8dc7d5f743331b).info({
            i18nKey: i18nKey,
            autoremove: true
        });
    }
    static removeFeatureFromLayer(feature, layerWrapper) {
        const layer = layerWrapper.getLayer();
        const source = layer.getSource();
        if ((0, $45f5d1a81c4ed6cb$export$73e78dff44a347ad).hasTooltip(feature)) this.#map.removeOverlay((0, $45f5d1a81c4ed6cb$export$73e78dff44a347ad).getTooltip(feature));
        source.removeFeature(feature);
        this.#snapFeatures.remove(feature);
    }
    static getSnapFeatures() {
        return this.#snapFeatures;
    }
    static clearSnapFeatures() {
        this.#snapFeatures = new (0, $931ffc4e747c14db$export$2e2bcd8739ae039)();
    }
    static isVectorLayer(layer) {
        return layer instanceof (0, $82a68515bd6ef378$export$2e2bcd8739ae039);
    }
    static isVectorSource(source) {
        return source instanceof (0, $84888e4daf3fdf44$export$2e2bcd8739ae039);
    }
    static getLayerFromFeature(feature) {
        const layerWrapper = this.getLayerWrapperFromFeature(feature);
        if (layerWrapper) return layerWrapper.getLayer();
        return undefined;
    }
    static getLayerWrapperFromFeature(feature) {
        let result = undefined;
        result = this.#getLayerWrapperFromFeature(feature, this.#layers.mapLayers);
        // Note:
        // The layer was found in the MapLayers, no need to look in the FeatureLayers
        if (result) return result;
        result = this.#getLayerWrapperFromFeature(feature, this.#layers.featureLayers);
        return result;
    }
    //--------------------------------------------------------------------
    // Section: Map Layers Specific
    //--------------------------------------------------------------------
    static #removeMapLayerFromInternal(layerWrapper) {
        this.#layers.mapLayers = this.#layers.mapLayers.filter((layer)=>{
            return layer.getId() !== layerWrapper.getId();
        });
    }
    static #removeMapOverlaysAndSnapFromInternal(layerWrapper) {
        const layer = layerWrapper.getLayer();
        if (this.isVectorLayer(layer)) layer.getSource().getFeatures().forEach((feature)=>{
            this.#snapFeatures.remove(feature);
        });
    }
    static #addMapLayerToMap(layerWrapper, options) {
        this.#layers.mapLayers.push(layerWrapper);
        this.#map.addLayer(layerWrapper.getLayer());
        (0, $96903e3f16465932$export$cc74486daaaef499).dispatchCustomEvent([
            window
        ], (0, $a9807b370eed025c$export$ada873a34909da65).custom.mapLayerAdded, {
            detail: {
                layerWrapper: layerWrapper,
                isSilent: options.isSilent,
                disableMapLayerEditButton: options.disableMapLayerEditButton,
                disableMapLayerDeleteButton: options.disableMapLayerDeleteButton
            }
        });
    }
    static addMapLayers(layerWrappers, options = {}) {
        for(let index in layerWrappers)this.addMapLayer(layerWrappers[index], options);
    }
    static addMapLayer(layerWrapper, options = {}) {
        const mergedOptions = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep($e75fe1c51a3d360c$var$DefaultMapLayerOptions), options);
        layerWrapper.name = this.#validateName(layerWrapper.name);
        (0, $b9b5c0363f244088$export$49b118289be48034).logDebug($e75fe1c51a3d360c$var$FILENAME, 'addMapLayer', layerWrapper.name);
        this.#addPropertiesInterface(layerWrapper);
        if (!layerWrapper.isDynamicallyAdded) layerWrapper.isDynamicallyAdded = false;
        if (!layerWrapper.getId()) {
            const layerId = (0, $3fa3ae484854b431$export$2e2bcd8739ae039)();
            layerWrapper.setId(layerId);
        }
        if (this.#map) this.#addMapLayerToMap(layerWrapper, mergedOptions);
        else this.#queue.mapLayers.push({
            layerWrapper: layerWrapper,
            options: mergedOptions
        });
        return layerWrapper;
    }
    static removeAllMapLayers() {
        this.#layers.mapLayers.forEach((layerWrapper)=>{
            this.removeMapLayer(layerWrapper);
        });
    }
    static removeMapLayer(layerWrapper, isSilent = false) {
        (0, $b9b5c0363f244088$export$49b118289be48034).logDebug($e75fe1c51a3d360c$var$FILENAME, 'removeMapLayer', layerWrapper.getName());
        this.#removeMapLayerFromInternal(layerWrapper);
        this.#removeMapOverlaysAndSnapFromInternal(layerWrapper);
        this.#removeLayerFromMap(layerWrapper);
        (0, $96903e3f16465932$export$cc74486daaaef499).dispatchCustomEvent([
            window
        ], (0, $a9807b370eed025c$export$ada873a34909da65).custom.mapLayerRemoved, {
            detail: {
                layerWrapper: layerWrapper,
                isSilent: isSilent
            }
        });
    }
    static hasMapLayerWithId(id) {
        return !!this.getMapLayerById(id);
    }
    static getMapLayers() {
        return this.#layers.mapLayers;
    }
    static getMapLayerById(id) {
        return this.#layers.mapLayers.find((layerWrapper)=>{
            return layerWrapper.getId() === id;
        });
    }
    static getOLMapLayers() {
        const layers = [];
        for(let index in this.#layers.mapLayers)layers.push(this.#layers.mapLayers[index].getLayer());
        return layers;
    }
    static setTopMapLayerAsOnlyVisible() {
        this.#layers.mapLayers.forEach((layerWrapper)=>{
            layerWrapper.getLayer().setVisible(false);
        });
        if (!this.isMapLayersEmpty()) this.#layers.mapLayers[0].getLayer().setVisible(true);
    }
    static getMapLayerSize() {
        return this.#layers.mapLayers.length;
    }
    static isMapLayersEmpty() {
        return this.getMapLayerSize() === 0;
    }
    static setMapLayerZIndex(layerId, index) {
        const layerWrapper = this.getMapLayerById(layerId);
        layerWrapper.getLayer().setZIndex($e75fe1c51a3d360c$var$ZINDEX__BASE_MAP_LAYER + index);
    }
    static belongsToMapLayer(feature) {
        return !!this.#layers.mapLayers.find((layerWrapper)=>{
            return layerWrapper.getLayer().getSource().hasFeature !== undefined && layerWrapper.getLayer().getSource().hasFeature(feature);
        });
    }
    //--------------------------------------------------------------------
    // Section: Feature Layers Specific
    //--------------------------------------------------------------------
    static #removeFeatureLayerFromInternal(layerWrapper) {
        this.#layers.featureLayers = this.#layers.featureLayers.filter((layer)=>{
            return layer.getId() !== layerWrapper.getId();
        });
    }
    static #removeFeatureOverlaysAndSnapFromInternal(layerWrapper) {
        layerWrapper.getLayer().getSource().getFeatures().forEach((feature)=>{
            this.#snapFeatures.remove(feature);
            if ((0, $45f5d1a81c4ed6cb$export$73e78dff44a347ad).hasTooltip(feature)) this.#map.removeOverlay((0, $45f5d1a81c4ed6cb$export$73e78dff44a347ad).getTooltip(feature));
        });
    }
    static #addFeatureLayerToMap(layerWrapper, options) {
        this.#layers.featureLayers.push(layerWrapper);
        this.#map.addLayer(layerWrapper.getLayer());
        (0, $96903e3f16465932$export$cc74486daaaef499).dispatchCustomEvent([
            window
        ], (0, $a9807b370eed025c$export$ada873a34909da65).custom.featureLayerAdded, {
            detail: {
                layerWrapper: layerWrapper,
                isSilent: options.isSilent,
                disableFeatureLayerEditButton: options.disableFeatureLayerEditButton,
                disableFeatureLayerDownloadButton: options.disableFeatureLayerDownloadButton,
                disableFeatureLayerDeleteButton: options.disableFeatureLayerDeleteButton
            }
        });
    }
    static #getNextActiveFeatureLayer() {
        if (this.isFeatureLayersEmpty()) return null;
        return this.#layers.featureLayers[this.#layers.featureLayers.length - 1];
    }
    static addFeatureLayer(options = {}) {
        const mergedOptions = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep($e75fe1c51a3d360c$var$DefaultFeatureLayerOptions), options);
        mergedOptions.name = this.#validateName(mergedOptions.name);
        (0, $b9b5c0363f244088$export$49b118289be48034).logDebug($e75fe1c51a3d360c$var$FILENAME, 'addFeatureLayer', mergedOptions.name);
        // Note:
        // Previously the styles for both IconMarkers and WindBarbs was generated
        // in each of the Generator-function. By using the vector-style-function
        // the render process can be better controlled and more effective.
        const layerWrapper = {
            id: mergedOptions.id,
            name: mergedOptions.name,
            sortIndex: mergedOptions.sortIndex,
            isDynamicallyAdded: mergedOptions.isDynamicallyAdded,
            layer: new (0, $82a68515bd6ef378$export$2e2bcd8739ae039)({
                source: new (0, $84888e4daf3fdf44$export$2e2bcd8739ae039)(),
                visible: mergedOptions.isVisible,
                style: function(feature, resolution) {
                    return (0, $2577fba4fdbf4b69$export$29bb23d12246c816).getStyle(feature, resolution);
                }
            })
        };
        this.#addPropertiesInterface(layerWrapper);
        if (!layerWrapper.isDynamicallyAdded) layerWrapper.isDynamicallyAdded = false;
        if (!layerWrapper.getId()) {
            const layerId = (0, $3fa3ae484854b431$export$2e2bcd8739ae039)();
            layerWrapper.setId(layerId);
        }
        this.setActiveFeatureLayer(layerWrapper);
        if (this.#map) this.#addFeatureLayerToMap(layerWrapper, mergedOptions);
        else this.#queue.featureLayers.push({
            layerWrapper: layerWrapper,
            options: mergedOptions
        });
        return layerWrapper;
    }
    static removeAllFeatureLayers() {
        this.#layers.featureLayers.forEach((layerWrapper)=>{
            this.removeFeatureLayer(layerWrapper);
        });
    }
    static removeFeatureLayer(layerWrapper, isSilent = false) {
        (0, $b9b5c0363f244088$export$49b118289be48034).logDebug($e75fe1c51a3d360c$var$FILENAME, 'removeFeatureLayer', layerWrapper.getName());
        this.#removeFeatureLayerFromInternal(layerWrapper);
        this.#removeFeatureOverlaysAndSnapFromInternal(layerWrapper);
        this.#removeLayerFromMap(layerWrapper);
        this.setNextActiveFeatureLayer();
        (0, $96903e3f16465932$export$cc74486daaaef499).dispatchCustomEvent([
            window
        ], (0, $a9807b370eed025c$export$ada873a34909da65).custom.featureLayerRemoved, {
            detail: {
                layerWrapper: layerWrapper,
                isSilent: isSilent
            }
        });
    }
    static getActiveFeatureLayer(options = {}) {
        if (!this.#activeFeatureLayer) this.addFeatureLayer({
            name: options.fallback,
            isDynamicallyAdded: true
        });
        return this.#activeFeatureLayer;
    }
    static setNextActiveFeatureLayer() {
        const nextLayer = this.#getNextActiveFeatureLayer();
        this.setActiveFeatureLayer(nextLayer);
    }
    static setActiveFeatureLayer(layerWrapper) {
        this.#activeFeatureLayer = layerWrapper;
        (0, $96903e3f16465932$export$cc74486daaaef499).dispatchCustomEvent([
            window
        ], (0, $a9807b370eed025c$export$ada873a34909da65).custom.activeFeatureLayerChange, {
            detail: {
                layerWrapper: layerWrapper
            }
        });
    }
    static hasFeatureLayerWithId(id) {
        return !!this.getFeatureLayerById(id);
    }
    static getFeatureLayers() {
        return this.#layers.featureLayers;
    }
    static getFeatureLayerById(id) {
        return this.#layers.featureLayers.find((layerWrapper)=>{
            return layerWrapper.getId() === id;
        });
    }
    static removeFeatureFromFeatureLayers(feature) {
        this.getFeatureLayers().forEach((layerWrapper)=>{
            layerWrapper.getLayer().getSource().removeFeature(feature);
        });
    }
    static getFeatureLayerSize() {
        return this.#layers.featureLayers.length;
    }
    static isFeatureLayersEmpty() {
        return this.getFeatureLayerSize() === 0;
    }
    static setFeatureLayerZIndex(layerId, index) {
        const layerWrapper = this.getFeatureLayerById(layerId);
        layerWrapper.getLayer().setZIndex($e75fe1c51a3d360c$var$ZINDEX__BASE_FEATURE_LAYER + index);
    }
    static belongsToFeatureLayer(feature) {
        return !!this.#layers.featureLayers.find((layerWrapper)=>{
            return layerWrapper.getLayer().getSource().hasFeature !== undefined && layerWrapper.getLayer().getSource().hasFeature(feature);
        });
    }
}


(0, $e75fe1c51a3d360c$export$eff87c52915dd7fe).addMapLayers([
    {
        id: '7b5399a8-9e57-4304-a233-cdf363c8ed93',
        name: 'Open Street Map',
        layer: new (0, $32e67a4d3559554a$export$2e2bcd8739ae039)({
            source: new (0, $6c8498cc816f2362$export$2e2bcd8739ae039)({
                crossOrigin: 'anonymous'
            }),
            visible: true
        })
    },
    {
        id: '97485b21-6a9d-48fb-9838-645543648daa',
        name: 'ArcGIS World Topo',
        layer: new (0, $32e67a4d3559554a$export$2e2bcd8739ae039)({
            source: new (0, $963a7ef65488964c$export$2e2bcd8739ae039)({
                crossOrigin: 'anonymous',
                attributions: 'Tiles \xa9 <a href="https://services.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer">ArcGIS</a>',
                url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}'
            }),
            visible: false
        })
    }
], {
    isSilent: true
});



var $f1q41 = parcelRequire("f1q41");

var $22dd7a6f15b3eb81$exports = {};
$22dd7a6f15b3eb81$exports = import.meta.resolve("4GFUf");







const $5ff055a036e0c1b4$var$FILENAME = 'layers/Wind.js';
const $5ff055a036e0c1b4$var$CLASS__FUNC_BUTTON = 'oltb-func-btn';
const $5ff055a036e0c1b4$var$ID__PREFIX_INFO_WINDOW = 'oltb-info-window-marker';
const $5ff055a036e0c1b4$var$LayerWrapper = (0, $e75fe1c51a3d360c$export$eff87c52915dd7fe).addFeatureLayer({
    id: 'fd319a29-d2ac-4b2b-b018-dc86cff22600',
    name: 'Wind Barbs',
    isVisible: false,
    isSilent: true
});
const $5ff055a036e0c1b4$var$getWindDirection = function(continentName) {
    const windDirections = Object.freeze({
        'Europe': 5,
        'Africa': 110,
        'Antarctica': 65,
        'Asia': 65,
        'Australia': 65,
        'Central America': 210,
        'North America': 210,
        'South America': 210,
        'UM': 210,
        'US': 210
    });
    return windDirections[continentName] || 0;
};
const $5ff055a036e0c1b4$var$parseGeoJson = function(data) {
    data.features.forEach((capital)=>{
        const coordinates = [
            Number(capital.geometry.coordinates[0]),
            Number(capital.geometry.coordinates[1])
        ];
        const prettyCoordinates = (0, $1bd0a226f9a16141$export$c883fd238161f841)(coordinates);
        const countryName = capital.properties.countryName;
        const continentName = capital.properties.continentName;
        // Note:
        // Get windspeed between 0 and 40m/s (75knots)
        // Get example direction to not have all wind barbs facing the same way
        const windSpeed = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).random(0, 40);
        const windDirection = $5ff055a036e0c1b4$var$getWindDirection(continentName);
        const timestamp = Date.now().toString();
        const placeholderImage = 'placeholder-9.jpeg';
        const description = `
            Current wind speed is ${windSpeed}m/s. The direction is ${windDirection}deg.
        `;
        const infoWindow = {
            title: countryName,
            content: `
                <p>${description}</p>
                <img src="./images/${placeholderImage}?cache=${timestamp}" alt="Placeholder Image" draggable="false" />
            `,
            footer: `
                <span class="oltb-info-window__coordinates">${prettyCoordinates}</span>
                <div class="oltb-info-window__buttons-wrapper">
                    <button class="${$5ff055a036e0c1b4$var$CLASS__FUNC_BUTTON} ${$5ff055a036e0c1b4$var$CLASS__FUNC_BUTTON}--delete oltb-tippy" title="Delete Marker" id="${$5ff055a036e0c1b4$var$ID__PREFIX_INFO_WINDOW}-remove"></button>
                    <button class="${$5ff055a036e0c1b4$var$CLASS__FUNC_BUTTON} ${$5ff055a036e0c1b4$var$CLASS__FUNC_BUTTON}--crosshair oltb-tippy" title="Copy Marker Coordinates" id="${$5ff055a036e0c1b4$var$ID__PREFIX_INFO_WINDOW}-copy-coordinates" data-oltb-coordinates="${prettyCoordinates}"></button>
                    <button class="${$5ff055a036e0c1b4$var$CLASS__FUNC_BUTTON} ${$5ff055a036e0c1b4$var$CLASS__FUNC_BUTTON}--copy oltb-tippy" title="Copy Marker Text" id="${$5ff055a036e0c1b4$var$ID__PREFIX_INFO_WINDOW}-copy-text" data-oltb-copy="${description}"></button>
                    <button class="${$5ff055a036e0c1b4$var$CLASS__FUNC_BUTTON} ${$5ff055a036e0c1b4$var$CLASS__FUNC_BUTTON}--layer oltb-tippy" title="Show Layer" id="${$5ff055a036e0c1b4$var$ID__PREFIX_INFO_WINDOW}-show-layer"></button>
                </div>
            `
        };
        const windBarb = (0, $45f5d1a81c4ed6cb$export$73e78dff44a347ad).generateWindBarb({
            lon: coordinates[0],
            lat: coordinates[1],
            infoWindow: infoWindow,
            title: countryName,
            description: description,
            icon: {
                key: windSpeed,
                rotation: windDirection
            },
            label: {
                text: `${windSpeed}m/s`
            }
        });
        $5ff055a036e0c1b4$var$LayerWrapper.getLayer().getSource().addFeature(windBarb);
    });
};
(0, $57966c7e0affc4cb$export$2e2bcd8739ae039).get((0, (/*@__PURE__*/$parcel$interopDefault($22dd7a6f15b3eb81$exports))), {
    responseType: 'application/json',
    headers: {
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache',
        'Expires': '0'
    }
}).then((response)=>{
    if (response.status !== 200) throw new Error('Failed to fetch local geojson', {
        cause: response
    });
    return JSON.parse(response.data);
}).then((data)=>{
    $5ff055a036e0c1b4$var$parseGeoJson(data);
}).catch((error)=>{
    const errorMessage = 'Failed to load Wind Barbs layer';
    (0, $b9b5c0363f244088$export$49b118289be48034).logError($5ff055a036e0c1b4$var$FILENAME, 'geoJsonPromise', {
        message: errorMessage,
        error: error
    });
    (0, $9051f0e072bf4341$export$8d8dc7d5f743331b).error({
        title: 'Error',
        message: errorMessage
    });
});



var $29dc715964bc53ac$exports = {};
$29dc715964bc53ac$exports = import.meta.resolve("fCY3N");







const $1f4a2c22fb9d5392$var$FILENAME = 'layers/Airports.js';
const $1f4a2c22fb9d5392$var$CLASS__FUNC_BUTTON = 'oltb-func-btn';
const $1f4a2c22fb9d5392$var$ID__PREFIX_INFO_WINDOW = 'oltb-info-window-marker';
const $1f4a2c22fb9d5392$var$LayerWrapper = (0, $e75fe1c51a3d360c$export$eff87c52915dd7fe).addFeatureLayer({
    id: '91a9a06f-7e49-4f85-a204-58dc7ab6a95e',
    name: '50 Airports',
    isVisible: false,
    isSilent: true
});
const $1f4a2c22fb9d5392$var$getMarkerColor = function() {
    return {
        fill: '#FCBE80FF',
        stroke: '#FCBE8066'
    };
};
const $1f4a2c22fb9d5392$var$parseGeoJson = function(data) {
    data.features.forEach((airport)=>{
        const coordinates = [
            Number(airport.geometry.coordinates[0]),
            Number(airport.geometry.coordinates[1])
        ];
        const prettyCoordinates = (0, $1bd0a226f9a16141$export$c883fd238161f841)(coordinates);
        const name = airport.properties.name;
        const location = airport.properties.location;
        const country = airport.properties.country;
        const totalPassengers = airport.properties.totalPassengers;
        const description = `
            ${name} is a airport located in ${location} in ${country}.
            Its total number of passenger is estimated to ${totalPassengers}.
        `;
        const infoWindow = {
            title: name,
            content: `
                <p>${description}</p>
                <p>
                    Google has more information about <a href="//www.google.com/search?q=${name}" target="_blank" class="oltb-link">${name}</a> 
                </p>
            `,
            footer: `
                <span class="oltb-info-window__coordinates">${prettyCoordinates}</span>
                <div class="oltb-info-window__buttons-wrapper">
                    <button class="${$1f4a2c22fb9d5392$var$CLASS__FUNC_BUTTON} ${$1f4a2c22fb9d5392$var$CLASS__FUNC_BUTTON}--delete oltb-tippy" title="Delete Marker" id="${$1f4a2c22fb9d5392$var$ID__PREFIX_INFO_WINDOW}-remove"></button>
                    <button class="${$1f4a2c22fb9d5392$var$CLASS__FUNC_BUTTON} ${$1f4a2c22fb9d5392$var$CLASS__FUNC_BUTTON}--crosshair oltb-tippy" title="Copy Marker Coordinates" id="${$1f4a2c22fb9d5392$var$ID__PREFIX_INFO_WINDOW}-copy-coordinates" data-oltb-coordinates="${prettyCoordinates}"></button>
                    <button class="${$1f4a2c22fb9d5392$var$CLASS__FUNC_BUTTON} ${$1f4a2c22fb9d5392$var$CLASS__FUNC_BUTTON}--copy oltb-tippy" title="Copy Marker Text" id="${$1f4a2c22fb9d5392$var$ID__PREFIX_INFO_WINDOW}-copy-text" data-oltb-copy="${description}"></button>
                    <button class="${$1f4a2c22fb9d5392$var$CLASS__FUNC_BUTTON} ${$1f4a2c22fb9d5392$var$CLASS__FUNC_BUTTON}--layer oltb-tippy" title="Show Layer" id="${$1f4a2c22fb9d5392$var$ID__PREFIX_INFO_WINDOW}-show-layer"></button>
                </div>
            `
        };
        const markerColor = $1f4a2c22fb9d5392$var$getMarkerColor();
        const marker = (0, $45f5d1a81c4ed6cb$export$73e78dff44a347ad).generateIconMarker({
            lon: coordinates[0],
            lat: coordinates[1],
            title: name,
            description: description,
            infoWindow: infoWindow,
            marker: {
                fill: markerColor.fill,
                stroke: markerColor.stroke
            },
            icon: {
                key: 'airplane.filled',
                fill: '#6B310AFF'
            },
            label: {
                text: name
            }
        });
        $1f4a2c22fb9d5392$var$LayerWrapper.getLayer().getSource().addFeature(marker);
    });
};
(0, $57966c7e0affc4cb$export$2e2bcd8739ae039).get((0, (/*@__PURE__*/$parcel$interopDefault($29dc715964bc53ac$exports))), {
    responseType: 'application/json',
    headers: {
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache',
        'Expires': '0'
    }
}).then((response)=>{
    if (response.status !== 200) throw new Error('Failed to fetch local geojson', {
        cause: response
    });
    return JSON.parse(response.data);
}).then((data)=>{
    $1f4a2c22fb9d5392$var$parseGeoJson(data);
}).catch((error)=>{
    const errorMessage = 'Failed to load Airports layer';
    (0, $b9b5c0363f244088$export$49b118289be48034).logError($1f4a2c22fb9d5392$var$FILENAME, 'geoJsonPromise', {
        message: errorMessage,
        error: error
    });
    (0, $9051f0e072bf4341$export$8d8dc7d5f743331b).error({
        title: 'Error',
        message: errorMessage
    });
});









const $5c0e3746d1608cd2$var$FILENAME = 'layers/Capitals.js';
const $5c0e3746d1608cd2$var$CLASS__FUNC_BUTTON = 'oltb-func-btn';
const $5c0e3746d1608cd2$var$ID__PREFIX_INFO_WINDOW = 'oltb-info-window-marker';
const $5c0e3746d1608cd2$var$LayerWrapper = (0, $e75fe1c51a3d360c$export$eff87c52915dd7fe).addFeatureLayer({
    id: '73e8b36c-6aa2-42b9-a97d-0e8288916050',
    name: 'Capitals',
    isVisible: true,
    isSilent: true
});
const $5c0e3746d1608cd2$var$getMarkerColor = function(name) {
    const colors = Object.freeze({
        'Europe': {
            fill: '#0166A5FF',
            stroke: '#0166A566'
        },
        'Africa': {
            fill: '#00959AFF',
            stroke: '#00959A66'
        },
        'Antarctica': {
            fill: '#007C70FF',
            stroke: '#007C7066'
        },
        'Asia': {
            fill: '#2357B1FF',
            stroke: '#2357B166'
        },
        'Australia': {
            fill: '#007C70FF',
            stroke: '#007C7066'
        },
        'Central America': {
            fill: '#0080C5FF',
            stroke: '#0080C566'
        },
        'North America': {
            fill: '#0080C5FF',
            stroke: '#0080C566'
        },
        'South America': {
            fill: '#0080C5FF',
            stroke: '#0080C566'
        },
        'UM': {
            fill: '#0080C5FF',
            stroke: '#0080C566'
        },
        'US': {
            fill: '#0080C5FF',
            stroke: '#0080C566'
        }
    });
    return colors[name] || {
        fill: '#0166A5FF',
        stroke: '#0166A566'
    };
};
const $5c0e3746d1608cd2$var$parseGeoJson = function(data) {
    data.features.forEach((capital)=>{
        const coordinates = [
            Number(capital.geometry.coordinates[0]),
            Number(capital.geometry.coordinates[1])
        ];
        const prettyCoordinates = (0, $1bd0a226f9a16141$export$c883fd238161f841)(coordinates);
        const countryName = capital.properties.countryName;
        const countryCode = capital.properties.countryCode;
        const capitalName = capital.properties.capitalName;
        const continentName = capital.properties.continentName;
        const timestamp = Date.now().toString();
        const placeholderImage = 'placeholder-1.jpeg';
        const description = `
            ${countryName} is a country located in ${continentName}.
            Its capital is ${capitalName} and its country code is ${countryCode}.
        `;
        const infoWindow = {
            title: countryName,
            content: `
                <p>${description}</p>
                <img src="./images/${placeholderImage}?cache=${timestamp}" alt="Placeholder Image" draggable="false" />
                <p>
                    Google has more information about <a href="//www.google.com/search?q=${countryName}" target="_blank" class="oltb-link">${countryName}</a>.
                </p>
            `,
            footer: `
                <span class="oltb-info-window__coordinates">${prettyCoordinates}</span>
                <div class="oltb-info-window__buttons-wrapper">
                    <button class="${$5c0e3746d1608cd2$var$CLASS__FUNC_BUTTON} ${$5c0e3746d1608cd2$var$CLASS__FUNC_BUTTON}--delete oltb-tippy" title="Delete Marker" id="${$5c0e3746d1608cd2$var$ID__PREFIX_INFO_WINDOW}-remove"></button>
                    <button class="${$5c0e3746d1608cd2$var$CLASS__FUNC_BUTTON} ${$5c0e3746d1608cd2$var$CLASS__FUNC_BUTTON}--crosshair oltb-tippy" title="Copy Marker Coordinates" id="${$5c0e3746d1608cd2$var$ID__PREFIX_INFO_WINDOW}-copy-coordinates" data-oltb-coordinates="${prettyCoordinates}"></button>
                    <button class="${$5c0e3746d1608cd2$var$CLASS__FUNC_BUTTON} ${$5c0e3746d1608cd2$var$CLASS__FUNC_BUTTON}--copy oltb-tippy" title="Copy Marker Text" id="${$5c0e3746d1608cd2$var$ID__PREFIX_INFO_WINDOW}-copy-text" data-oltb-copy="${description}"></button>
                    <button class="${$5c0e3746d1608cd2$var$CLASS__FUNC_BUTTON} ${$5c0e3746d1608cd2$var$CLASS__FUNC_BUTTON}--layer oltb-tippy" title="Show Layer" id="${$5c0e3746d1608cd2$var$ID__PREFIX_INFO_WINDOW}-show-layer"></button>
                </div>
            `
        };
        const markerColor = $5c0e3746d1608cd2$var$getMarkerColor(continentName);
        const marker = (0, $45f5d1a81c4ed6cb$export$73e78dff44a347ad).generateIconMarker({
            lon: coordinates[0],
            lat: coordinates[1],
            title: countryName,
            description: description,
            infoWindow: infoWindow,
            marker: {
                fill: markerColor.fill,
                stroke: markerColor.stroke
            },
            icon: {
                key: 'geoMarker.filled'
            },
            label: {
                text: countryName
            }
        });
        $5c0e3746d1608cd2$var$LayerWrapper.getLayer().getSource().addFeature(marker);
    });
};
(0, $57966c7e0affc4cb$export$2e2bcd8739ae039).get((0, (/*@__PURE__*/$parcel$interopDefault($22dd7a6f15b3eb81$exports))), {
    responseType: 'application/json',
    headers: {
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache',
        'Expires': '0'
    }
}).then((response)=>{
    if (response.status !== 200) throw new Error('Failed to fetch local geojson', {
        cause: response
    });
    return JSON.parse(response.data);
}).then((data)=>{
    $5c0e3746d1608cd2$var$parseGeoJson(data);
}).catch((error)=>{
    const errorMessage = 'Failed to load Capitals layer';
    (0, $b9b5c0363f244088$export$49b118289be48034).logError($5c0e3746d1608cd2$var$FILENAME, 'geoJsonPromise', {
        message: errorMessage,
        error: error
    });
    (0, $9051f0e072bf4341$export$8d8dc7d5f743331b).error({
        title: 'Error',
        message: errorMessage
    });
});



var $21c8051a108d3692$exports = {};
$21c8051a108d3692$exports = import.meta.resolve("dzYfg");




/**
 * @module ol/format/GeoJSON
 */ 





/**
 * @module ol/format/Feature
 */ 





/**
 * @typedef {Object} ReadOptions
 * @property {import("../proj.js").ProjectionLike} [dataProjection] Projection of the data we are reading.
 * If not provided, the projection will be derived from the data (where possible) or
 * the `dataProjection` of the format is assigned (where set). If the projection
 * can not be derived from the data and if no `dataProjection` is set for a format,
 * the features will not be reprojected.
 * @property {import("../extent.js").Extent} [extent] Tile extent in map units of the tile being read.
 * This is only required when reading data with tile pixels as geometry units. When configured,
 * a `dataProjection` with `TILE_PIXELS` as `units` and the tile's pixel extent as `extent` needs to be
 * provided.
 * @property {import("../proj.js").ProjectionLike} [featureProjection] Projection of the feature geometries
 * created by the format reader. If not provided, features will be returned in the
 * `dataProjection`.
 */ /**
 * @typedef {Object} WriteOptions
 * @property {import("../proj.js").ProjectionLike} [dataProjection] Projection of the data we are writing.
 * If not provided, the `dataProjection` of the format is assigned (where set).
 * If no `dataProjection` is set for a format, the features will be returned
 * in the `featureProjection`.
 * @property {import("../proj.js").ProjectionLike} [featureProjection] Projection of the feature geometries
 * that will be serialized by the format writer. If not provided, geometries are assumed
 * to be in the `dataProjection` if that is set; in other words, they are not transformed.
 * @property {boolean} [rightHanded] When writing geometries, follow the right-hand
 * rule for linear ring orientation.  This means that polygons will have counter-clockwise
 * exterior rings and clockwise interior rings.  By default, coordinates are serialized
 * as they are provided at construction.  If `true`, the right-hand rule will
 * be applied.  If `false`, the left-hand rule will be applied (clockwise for
 * exterior and counter-clockwise for interior rings).  Note that not all
 * formats support this.  The GeoJSON format does use this property when writing
 * geometries.
 * @property {number} [decimals] Maximum number of decimal places for coordinates.
 * Coordinates are stored internally as floats, but floating-point arithmetic can create
 * coordinates with a large number of decimal places, not generally wanted on output.
 * Set a number here to round coordinates. Can also be used to ensure that
 * coordinates read in can be written back out with the same number of decimals.
 * Default is no rounding.
 */ /**
 * @typedef {'arraybuffer' | 'json' | 'text' | 'xml'} Type
 */ /**
 * @typedef {Object} SimpleGeometryObject
 * @property {import('../geom/Geometry.js').Type} type Type.
 * @property {Array<number>} flatCoordinates Flat coordinates.
 * @property {Array<number>|Array<Array<number>>} [ends] Ends or endss.
 * @property {import('../geom/Geometry.js').GeometryLayout} [layout] Layout.
 */ /**
 * @typedef {Array<GeometryObject>} GeometryCollectionObject
 */ /**
 * @typedef {SimpleGeometryObject|GeometryCollectionObject} GeometryObject
 */ /**
 * @typedef {Object} FeatureObject
 * @property {string|number} [id] Id.
 * @property {GeometryObject} [geometry] Geometry.
 * @property {Object<string, *>} [properties] Properties.
 */ /***
 * @template {import('../Feature.js').FeatureLike} T
 * @typedef {T extends RenderFeature ? typeof RenderFeature : typeof Feature} FeatureToFeatureClass
 */ /***
 * @template {import("../Feature.js").FeatureClass} T
 * @typedef {T[keyof T] extends RenderFeature ? RenderFeature : Feature} FeatureClassToFeature
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Base class for feature formats.
 * {@link module:ol/format/Feature~FeatureFormat} subclasses provide the ability to decode and encode
 * {@link module:ol/Feature~Feature} objects from a variety of commonly used geospatial
 * file formats.  See the documentation for each format for more details.
 *
 * @template {import('../Feature.js').FeatureLike} [FeatureType=import("../Feature.js").default]
 * @abstract
 * @api
 */ class $ec084d0ff9c13a22$var$FeatureFormat {
    constructor(){
        /**
     * @protected
     * @type {import("../proj/Projection.js").default|undefined}
     */ this.dataProjection = undefined;
        /**
     * @protected
     * @type {import("../proj/Projection.js").default|undefined}
     */ this.defaultFeatureProjection = undefined;
        /**
     * @protected
     * @type {FeatureToFeatureClass<FeatureType>}
     */ this.featureClass = /** @type {FeatureToFeatureClass<FeatureType>} */ (0, $9fd014ab6df63665$export$2e2bcd8739ae039);
        /**
     * A list media types supported by the format in descending order of preference.
     * @type {Array<string>}
     */ this.supportedMediaTypes = null;
    }
    /**
   * Adds the data projection to the read options.
   * @param {Document|Element|Object|string} source Source.
   * @param {ReadOptions} [options] Options.
   * @return {ReadOptions|undefined} Options.
   * @protected
   */ getReadOptions(source, options) {
        if (options) {
            let dataProjection = options.dataProjection ? (0, $9c4744460e43e41b$export$3988ae62b71be9a3)(options.dataProjection) : this.readProjection(source);
            if (options.extent && dataProjection && dataProjection.getUnits() === 'tile-pixels') {
                dataProjection = (0, $9c4744460e43e41b$export$3988ae62b71be9a3)(dataProjection);
                dataProjection.setWorldExtent(options.extent);
            }
            options = {
                dataProjection: dataProjection,
                featureProjection: options.featureProjection
            };
        }
        return this.adaptOptions(options);
    }
    /**
   * Sets the `dataProjection` on the options, if no `dataProjection`
   * is set.
   * @param {WriteOptions|ReadOptions|undefined} options
   *     Options.
   * @protected
   * @return {WriteOptions|ReadOptions|undefined}
   *     Updated options.
   */ adaptOptions(options) {
        return Object.assign({
            dataProjection: this.dataProjection,
            featureProjection: this.defaultFeatureProjection,
            featureClass: this.featureClass
        }, options);
    }
    /**
   * @abstract
   * @return {Type} The format type.
   */ getType() {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Read a single feature from a source.
   *
   * @abstract
   * @param {Document|Element|Object|string} source Source.
   * @param {ReadOptions} [options] Read options.
   * @return {FeatureType|Array<FeatureType>} Feature.
   */ readFeature(source, options) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Read all features from a source.
   *
   * @abstract
   * @param {Document|Element|ArrayBuffer|Object|string} source Source.
   * @param {ReadOptions} [options] Read options.
   * @return {Array<FeatureType>} Features.
   */ readFeatures(source, options) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Read a single geometry from a source.
   *
   * @abstract
   * @param {Document|Element|Object|string} source Source.
   * @param {ReadOptions} [options] Read options.
   * @return {import("../geom/Geometry.js").default} Geometry.
   */ readGeometry(source, options) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Read the projection from a source.
   *
   * @abstract
   * @param {Document|Element|Object|string} source Source.
   * @return {import("../proj/Projection.js").default|undefined} Projection.
   */ readProjection(source) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Encode a feature in this format.
   *
   * @abstract
   * @param {Feature} feature Feature.
   * @param {WriteOptions} [options] Write options.
   * @return {string|ArrayBuffer} Result.
   */ writeFeature(feature, options) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Encode an array of features in this format.
   *
   * @abstract
   * @param {Array<Feature>} features Features.
   * @param {WriteOptions} [options] Write options.
   * @return {string|ArrayBuffer} Result.
   */ writeFeatures(features, options) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Write a single geometry in this format.
   *
   * @abstract
   * @param {import("../geom/Geometry.js").default} geometry Geometry.
   * @param {WriteOptions} [options] Write options.
   * @return {string|ArrayBuffer} Result.
   */ writeGeometry(geometry, options) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
}
var $ec084d0ff9c13a22$export$2e2bcd8739ae039 = $ec084d0ff9c13a22$var$FeatureFormat;
function $ec084d0ff9c13a22$export$7beeea566b560d4(geometry, write, options) {
    const featureProjection = options ? (0, $9c4744460e43e41b$export$3988ae62b71be9a3)(options.featureProjection) : null;
    const dataProjection = options ? (0, $9c4744460e43e41b$export$3988ae62b71be9a3)(options.dataProjection) : null;
    let transformed = geometry;
    if (featureProjection && dataProjection && !(0, $9c4744460e43e41b$export$fe091d73a555748b)(featureProjection, dataProjection)) {
        if (write) transformed = /** @type {T} */ geometry.clone();
        const fromProjection = write ? featureProjection : dataProjection;
        const toProjection = write ? dataProjection : featureProjection;
        if (fromProjection.getUnits() === 'tile-pixels') transformed.transform(fromProjection, toProjection);
        else transformed.applyTransform((0, $9c4744460e43e41b$export$fce0c6cfca85ed96)(fromProjection, toProjection));
    }
    if (write && options && /** @type {WriteOptions} */ options.decimals !== undefined) {
        const power = Math.pow(10, /** @type {WriteOptions} */ options.decimals);
        // if decimals option on write, round each coordinate appropriately
        /**
     * @param {Array<number>} coordinates Coordinates.
     * @return {Array<number>} Transformed coordinates.
     */ const transform = function(coordinates) {
            for(let i = 0, ii = coordinates.length; i < ii; ++i)coordinates[i] = Math.round(coordinates[i] * power) / power;
            return coordinates;
        };
        if (transformed === geometry) transformed = /** @type {T} */ geometry.clone();
        transformed.applyTransform(transform);
    }
    return transformed;
}
function $ec084d0ff9c13a22$export$d3e9e4b1c7f2405c(extent, options) {
    const featureProjection = options ? (0, $9c4744460e43e41b$export$3988ae62b71be9a3)(options.featureProjection) : null;
    const dataProjection = options ? (0, $9c4744460e43e41b$export$3988ae62b71be9a3)(options.dataProjection) : null;
    if (featureProjection && dataProjection && !(0, $9c4744460e43e41b$export$fe091d73a555748b)(featureProjection, dataProjection)) return (0, $9c4744460e43e41b$export$751c68e0e0efff79)(extent, dataProjection, featureProjection);
    return extent;
}
const $ec084d0ff9c13a22$var$GeometryConstructor = {
    Point: (0, $6eced4c969949f6b$export$2e2bcd8739ae039),
    LineString: (0, $292e4002746c8223$export$2e2bcd8739ae039),
    Polygon: (0, $40aa8d43bbe572bf$export$2e2bcd8739ae039),
    MultiPoint: (0, $e6080c63a9451eda$export$2e2bcd8739ae039),
    MultiLineString: (0, $b4c0e2e13beea46e$export$2e2bcd8739ae039),
    MultiPolygon: (0, $f73f35eb6af8b987$export$2e2bcd8739ae039)
};
function $ec084d0ff9c13a22$var$orientFlatCoordinates(flatCoordinates, ends, stride) {
    if (Array.isArray(ends[0])) {
        // MultiPolagon
        if (!(0, $7892dc06ffd23218$export$a1d138f4bd85f4b4)(flatCoordinates, 0, ends, stride)) {
            flatCoordinates = flatCoordinates.slice();
            (0, $7892dc06ffd23218$export$ea9ed55fc2a85010)(flatCoordinates, 0, ends, stride);
        }
        return flatCoordinates;
    }
    if (!(0, $7892dc06ffd23218$export$f27cd06e85f4ba28)(flatCoordinates, 0, ends, stride)) {
        flatCoordinates = flatCoordinates.slice();
        (0, $7892dc06ffd23218$export$b71b604ddfc778c7)(flatCoordinates, 0, ends, stride);
    }
    return flatCoordinates;
}
function $ec084d0ff9c13a22$export$f935e77582b330a(object, options) {
    const geometry = object.geometry;
    if (!geometry) return [];
    if (Array.isArray(geometry)) return geometry.map((geometry)=>$ec084d0ff9c13a22$export$f935e77582b330a({
            ...object,
            geometry: geometry
        })).flat();
    const geometryType = geometry.type === 'MultiPolygon' ? 'Polygon' : geometry.type;
    if (geometryType === 'GeometryCollection' || geometryType === 'Circle') throw new Error('Unsupported geometry type: ' + geometryType);
    const stride = geometry.layout.length;
    return $ec084d0ff9c13a22$export$7beeea566b560d4(new (0, $36d6c36c1f9ad5d9$export$2e2bcd8739ae039)(geometryType, geometryType === 'Polygon' ? $ec084d0ff9c13a22$var$orientFlatCoordinates(geometry.flatCoordinates, geometry.ends, stride) : geometry.flatCoordinates, geometry.ends?.flat(), stride, object.properties || {}, object.id).enableSimplifyTransformed(), false, options);
}
function $ec084d0ff9c13a22$export$322c9678d8c47bf(object, options) {
    if (!object) return null;
    if (Array.isArray(object)) {
        const geometries = object.map((geometry)=>$ec084d0ff9c13a22$export$322c9678d8c47bf(geometry, options));
        return new (0, $0e4f3959219eede5$export$2e2bcd8739ae039)(geometries);
    }
    const Geometry = $ec084d0ff9c13a22$var$GeometryConstructor[object.type];
    return $ec084d0ff9c13a22$export$7beeea566b560d4(new Geometry(object.flatCoordinates, object.layout || 'XY', object.ends), false, options);
}


/**
 * @module ol/format/JSONFeature
 */ 

/**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Base class for JSON feature formats.
 *
 * @template {import('../Feature.js').FeatureLike} [FeatureType=import("../Feature.js").default]
 * @extends {FeatureFormat<FeatureType>}
 * @abstract
 */ class $2f9f6f6b6e1ba437$var$JSONFeature extends (0, $ec084d0ff9c13a22$export$2e2bcd8739ae039) {
    constructor(){
        super();
    }
    /**
   * @return {import("./Feature.js").Type} Format.
   * @override
   */ getType() {
        return 'json';
    }
    /**
   * Read a feature.  Only works for a single feature. Use `readFeatures` to
   * read a feature collection.
   *
   * @param {ArrayBuffer|Document|Element|Object|string} source Source.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @return {FeatureType|Array<FeatureType>} Feature.
   * @api
   * @override
   */ readFeature(source, options) {
        return this.readFeatureFromObject($2f9f6f6b6e1ba437$var$getObject(source), this.getReadOptions(source, options));
    }
    /**
   * Read all features.  Works with both a single feature and a feature
   * collection.
   *
   * @param {ArrayBuffer|Document|Element|Object|string} source Source.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @return {Array<FeatureType>} Features.
   * @api
   * @override
   */ readFeatures(source, options) {
        return this.readFeaturesFromObject($2f9f6f6b6e1ba437$var$getObject(source), this.getReadOptions(source, options));
    }
    /**
   * @abstract
   * @param {Object} object Object.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @protected
   * @return {FeatureType|Array<FeatureType>} Feature.
   */ readFeatureFromObject(object, options) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * @abstract
   * @param {Object} object Object.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @protected
   * @return {Array<FeatureType>} Features.
   */ readFeaturesFromObject(object, options) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Read a geometry.
   *
   * @param {ArrayBuffer|Document|Element|Object|string} source Source.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @return {import("../geom/Geometry.js").default} Geometry.
   * @api
   * @override
   */ readGeometry(source, options) {
        return this.readGeometryFromObject($2f9f6f6b6e1ba437$var$getObject(source), this.getReadOptions(source, options));
    }
    /**
   * @abstract
   * @param {Object} object Object.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @protected
   * @return {import("../geom/Geometry.js").default} Geometry.
   */ readGeometryFromObject(object, options) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Read the projection.
   *
   * @param {ArrayBuffer|Document|Element|Object|string} source Source.
   * @return {import("../proj/Projection.js").default} Projection.
   * @api
   * @override
   */ readProjection(source) {
        return this.readProjectionFromObject($2f9f6f6b6e1ba437$var$getObject(source));
    }
    /**
   * @abstract
   * @param {Object} object Object.
   * @protected
   * @return {import("../proj/Projection.js").default} Projection.
   */ readProjectionFromObject(object) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Encode a feature as string.
   *
   * @param {import("../Feature.js").default} feature Feature.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {string} Encoded feature.
   * @api
   * @override
   */ writeFeature(feature, options) {
        return JSON.stringify(this.writeFeatureObject(feature, options));
    }
    /**
   * @abstract
   * @param {import("../Feature.js").default} feature Feature.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {Object} Object.
   */ writeFeatureObject(feature, options) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Encode an array of features as string.
   *
   * @param {Array<import("../Feature.js").default>} features Features.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {string} Encoded features.
   * @api
   * @override
   */ writeFeatures(features, options) {
        return JSON.stringify(this.writeFeaturesObject(features, options));
    }
    /**
   * @abstract
   * @param {Array<import("../Feature.js").default>} features Features.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {Object} Object.
   */ writeFeaturesObject(features, options) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Encode a geometry as string.
   *
   * @param {import("../geom/Geometry.js").default} geometry Geometry.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {string} Encoded geometry.
   * @api
   * @override
   */ writeGeometry(geometry, options) {
        return JSON.stringify(this.writeGeometryObject(geometry, options));
    }
    /**
   * @abstract
   * @param {import("../geom/Geometry.js").default} geometry Geometry.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {Object} Object.
   */ writeGeometryObject(geometry, options) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
}
/**
 * @param {Document|Element|Object|string} source Source.
 * @return {Object} Object.
 */ function $2f9f6f6b6e1ba437$var$getObject(source) {
    if (typeof source === 'string') {
        const object = JSON.parse(source);
        return object ? /** @type {Object} */ object : null;
    }
    if (source !== null) return source;
    return null;
}
var $2f9f6f6b6e1ba437$export$2e2bcd8739ae039 = $2f9f6f6b6e1ba437$var$JSONFeature;


/**
 * @typedef {import("geojson").GeoJSON} GeoJSONObject
 * @typedef {import("geojson").Feature} GeoJSONFeature
 * @typedef {import("geojson").FeatureCollection} GeoJSONFeatureCollection
 * @typedef {import("geojson").Geometry} GeoJSONGeometry
 * @typedef {import("geojson").Point} GeoJSONPoint
 * @typedef {import("geojson").LineString} GeoJSONLineString
 * @typedef {import("geojson").Polygon} GeoJSONPolygon
 * @typedef {import("geojson").MultiPoint} GeoJSONMultiPoint
 * @typedef {import("geojson").MultiLineString} GeoJSONMultiLineString
 * @typedef {import("geojson").MultiPolygon} GeoJSONMultiPolygon
 * @typedef {import("geojson").GeometryCollection} GeoJSONGeometryCollection
 */ /**
 * @template {import("../Feature.js").FeatureLike} [FeatureType=import("../Feature.js").default]
 * @typedef {Object} Options
 *
 * @property {import("../proj.js").ProjectionLike} [dataProjection='EPSG:4326'] Default data projection.
 * @property {import("../proj.js").ProjectionLike} [featureProjection] Projection for features read or
 * written by the format.  Options passed to read or write methods will take precedence.
 * @property {string} [geometryName] Geometry name to use when creating features.
 * @property {boolean} [extractGeometryName=false] Certain GeoJSON providers include
 * the geometry_name field in the feature GeoJSON. If set to `true` the GeoJSON reader
 * will look for that field to set the geometry name. If both this field is set to `true`
 * and a `geometryName` is provided, the `geometryName` will take precedence.
 * @property {import('./Feature.js').FeatureToFeatureClass<FeatureType>} [featureClass] Feature class
 * to be used when reading features. The default is {@link module:ol/Feature~Feature}. If performance is
 * the primary concern, and features are not going to be modified or round-tripped through the format,
 * consider using {@link module:ol/render/Feature~RenderFeature}
 */ /**
 * @classdesc
 * Feature format for reading and writing data in the GeoJSON format.
 *
 * @template {import('../Feature.js').FeatureLike} [FeatureType=import("../Feature.js").default]
 * @extends {JSONFeature<FeatureType>}
 * @api
 */ class $f602cef51a2e6950$var$GeoJSON extends (0, $2f9f6f6b6e1ba437$export$2e2bcd8739ae039) {
    /**
   * @param {Options<FeatureType>} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        super();
        /**
     * @type {import("../proj/Projection.js").default}
     */ this.dataProjection = (0, $9c4744460e43e41b$export$3988ae62b71be9a3)(options.dataProjection ? options.dataProjection : 'EPSG:4326');
        if (options.featureProjection) /**
       * @type {import("../proj/Projection.js").default}
       */ this.defaultFeatureProjection = (0, $9c4744460e43e41b$export$3988ae62b71be9a3)(options.featureProjection);
        if (options.featureClass) this.featureClass = options.featureClass;
        /**
     * Name of the geometry attribute for features.
     * @type {string|undefined}
     * @private
     */ this.geometryName_ = options.geometryName;
        /**
     * Look for the `geometry_name` in the feature GeoJSON
     * @type {boolean|undefined}
     * @private
     */ this.extractGeometryName_ = options.extractGeometryName;
        this.supportedMediaTypes = [
            'application/geo+json',
            'application/vnd.geo+json'
        ];
    }
    /**
   * @param {Object} object Object.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @protected
   * @return {FeatureType|Array<FeatureType>} Feature.
   * @override
   */ readFeatureFromObject(object, options) {
        /**
     * @type {GeoJSONFeature}
     */ let geoJSONFeature = null;
        if (object['type'] === 'Feature') geoJSONFeature = /** @type {GeoJSONFeature} */ object;
        else geoJSONFeature = {
            'type': 'Feature',
            'geometry': /** @type {GeoJSONGeometry} */ object,
            'properties': null
        };
        const geometry = $f602cef51a2e6950$var$readGeometryInternal(geoJSONFeature['geometry'], options);
        if (this.featureClass === (0, $36d6c36c1f9ad5d9$export$2e2bcd8739ae039)) return /** @type {FeatureType|Array<FeatureType>} */ (0, $ec084d0ff9c13a22$export$f935e77582b330a)({
            geometry: geometry,
            id: geoJSONFeature['id'],
            properties: geoJSONFeature['properties']
        }, options);
        const feature = new (0, $9fd014ab6df63665$export$2e2bcd8739ae039)();
        if (this.geometryName_) feature.setGeometryName(this.geometryName_);
        else if (this.extractGeometryName_ && geoJSONFeature['geometry_name']) feature.setGeometryName(geoJSONFeature['geometry_name']);
        feature.setGeometry((0, $ec084d0ff9c13a22$export$322c9678d8c47bf)(geometry, options));
        if ('id' in geoJSONFeature) feature.setId(geoJSONFeature['id']);
        if (geoJSONFeature['properties']) feature.setProperties(geoJSONFeature['properties'], true);
        return /** @type {FeatureType|Array<FeatureType>} */ feature;
    }
    /**
   * @param {Object} object Object.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @protected
   * @return {Array<FeatureType>} Features.
   * @override
   */ readFeaturesFromObject(object, options) {
        const geoJSONObject = /** @type {GeoJSONObject} */ object;
        let features = null;
        if (geoJSONObject['type'] === 'FeatureCollection') {
            const geoJSONFeatureCollection = /** @type {GeoJSONFeatureCollection} */ object;
            features = [];
            const geoJSONFeatures = geoJSONFeatureCollection['features'];
            for(let i = 0, ii = geoJSONFeatures.length; i < ii; ++i){
                const featureObject = this.readFeatureFromObject(geoJSONFeatures[i], options);
                if (!featureObject) continue;
                features.push(featureObject);
            }
        } else features = [
            this.readFeatureFromObject(object, options)
        ];
        return /** @type {Array<FeatureType>} */ features.flat();
    }
    /**
   * @param {GeoJSONGeometry} object Object.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @protected
   * @return {import("../geom/Geometry.js").default} Geometry.
   * @override
   */ readGeometryFromObject(object, options) {
        return $f602cef51a2e6950$var$readGeometry(object, options);
    }
    /**
   * @param {Object} object Object.
   * @protected
   * @return {import("../proj/Projection.js").default} Projection.
   * @override
   */ readProjectionFromObject(object) {
        const crs = object['crs'];
        let projection;
        if (crs) {
            if (crs['type'] == 'name') projection = (0, $9c4744460e43e41b$export$3988ae62b71be9a3)(crs['properties']['name']);
            else if (crs['type'] === 'EPSG') projection = (0, $9c4744460e43e41b$export$3988ae62b71be9a3)('EPSG:' + crs['properties']['code']);
            else throw new Error('Unknown SRS type');
        } else projection = this.dataProjection;
        return /** @type {import("../proj/Projection.js").default} */ projection;
    }
    /**
   * Encode a feature as a GeoJSON Feature object.
   *
   * @param {import("../Feature.js").default} feature Feature.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {GeoJSONFeature} Object.
   * @api
   * @override
   */ writeFeatureObject(feature, options) {
        options = this.adaptOptions(options);
        /** @type {GeoJSONFeature} */ const object = {
            'type': 'Feature',
            geometry: null,
            properties: null
        };
        const id = feature.getId();
        if (id !== undefined) object.id = id;
        if (!feature.hasProperties()) return object;
        const properties = feature.getProperties();
        const geometry = feature.getGeometry();
        if (geometry) {
            object.geometry = $f602cef51a2e6950$var$writeGeometry(geometry, options);
            delete properties[feature.getGeometryName()];
        }
        if (!(0, $beaefe87199bb537$export$dd1bc94b04021eeb)(properties)) object.properties = properties;
        return object;
    }
    /**
   * Encode an array of features as a GeoJSON object.
   *
   * @param {Array<import("../Feature.js").default>} features Features.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {GeoJSONFeatureCollection} GeoJSON Object.
   * @api
   * @override
   */ writeFeaturesObject(features, options) {
        options = this.adaptOptions(options);
        const objects = [];
        for(let i = 0, ii = features.length; i < ii; ++i)objects.push(this.writeFeatureObject(features[i], options));
        return {
            type: 'FeatureCollection',
            features: objects
        };
    }
    /**
   * Encode a geometry as a GeoJSON object.
   *
   * @param {import("../geom/Geometry.js").default} geometry Geometry.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {GeoJSONGeometry|GeoJSONGeometryCollection} Object.
   * @api
   * @override
   */ writeGeometryObject(geometry, options) {
        return $f602cef51a2e6950$var$writeGeometry(geometry, this.adaptOptions(options));
    }
}
/**
 * @param {GeoJSONGeometry|GeoJSONGeometryCollection} object Object.
 * @param {import("./Feature.js").ReadOptions} [options] Read options.
 * @return {import("./Feature.js").GeometryObject} Geometry.
 */ function $f602cef51a2e6950$var$readGeometryInternal(object, options) {
    if (!object) return null;
    /** @type {import("./Feature.js").GeometryObject} */ let geometry;
    switch(object['type']){
        case 'Point':
            geometry = $f602cef51a2e6950$var$readPointGeometry(/** @type {GeoJSONPoint} */ object);
            break;
        case 'LineString':
            geometry = $f602cef51a2e6950$var$readLineStringGeometry(/** @type {GeoJSONLineString} */ object);
            break;
        case 'Polygon':
            geometry = $f602cef51a2e6950$var$readPolygonGeometry(/** @type {GeoJSONPolygon} */ object);
            break;
        case 'MultiPoint':
            geometry = $f602cef51a2e6950$var$readMultiPointGeometry(/** @type {GeoJSONMultiPoint} */ object);
            break;
        case 'MultiLineString':
            geometry = $f602cef51a2e6950$var$readMultiLineStringGeometry(/** @type {GeoJSONMultiLineString} */ object);
            break;
        case 'MultiPolygon':
            geometry = $f602cef51a2e6950$var$readMultiPolygonGeometry(/** @type {GeoJSONMultiPolygon} */ object);
            break;
        case 'GeometryCollection':
            geometry = $f602cef51a2e6950$var$readGeometryCollectionGeometry(/** @type {GeoJSONGeometryCollection} */ object);
            break;
        default:
            throw new Error('Unsupported GeoJSON type: ' + object['type']);
    }
    return geometry;
}
/**
 * @param {GeoJSONGeometry|GeoJSONGeometryCollection} object Object.
 * @param {import("./Feature.js").ReadOptions} [options] Read options.
 * @return {import("../geom/Geometry.js").default} Geometry.
 */ function $f602cef51a2e6950$var$readGeometry(object, options) {
    const geometryObject = $f602cef51a2e6950$var$readGeometryInternal(object, options);
    return (0, $ec084d0ff9c13a22$export$322c9678d8c47bf)(geometryObject, options);
}
/**
 * @param {GeoJSONGeometryCollection} object Object.
 * @param {import("./Feature.js").ReadOptions} [options] Read options.
 * @return {import("./Feature.js").GeometryCollectionObject} Geometry collection.
 */ function $f602cef51a2e6950$var$readGeometryCollectionGeometry(object, options) {
    const geometries = object['geometries'].map(/**
     * @param {GeoJSONGeometry} geometry Geometry.
     * @return {import("./Feature.js").GeometryObject} geometry Geometry.
     */ function(geometry) {
        return $f602cef51a2e6950$var$readGeometryInternal(geometry, options);
    });
    return geometries;
}
/**
 * @param {GeoJSONPoint} object Input object.
 * @return {import("./Feature.js").GeometryObject} Point geometry.
 */ function $f602cef51a2e6950$var$readPointGeometry(object) {
    const flatCoordinates = object['coordinates'];
    return {
        type: 'Point',
        flatCoordinates: flatCoordinates,
        layout: (0, $c76e993e57efc8c4$export$61bb6938093db2c8)(flatCoordinates.length)
    };
}
/**
 * @param {GeoJSONLineString} object Object.
 * @return {import("./Feature.js").GeometryObject} LineString geometry.
 */ function $f602cef51a2e6950$var$readLineStringGeometry(object) {
    const coordinates = object['coordinates'];
    const flatCoordinates = coordinates.flat();
    return {
        type: 'LineString',
        flatCoordinates: flatCoordinates,
        ends: [
            flatCoordinates.length
        ],
        layout: (0, $c76e993e57efc8c4$export$61bb6938093db2c8)(coordinates[0]?.length || 2)
    };
}
/**
 * @param {GeoJSONMultiLineString} object Object.
 * @return {import("./Feature.js").GeometryObject} MultiLineString geometry.
 */ function $f602cef51a2e6950$var$readMultiLineStringGeometry(object) {
    const coordinates = object['coordinates'];
    const stride = coordinates[0]?.[0]?.length || 2;
    const flatCoordinates = [];
    const ends = (0, $6b086aa46281540d$export$47c3746a74384d45)(flatCoordinates, 0, coordinates, stride);
    return {
        type: 'MultiLineString',
        flatCoordinates: flatCoordinates,
        ends: ends,
        layout: (0, $c76e993e57efc8c4$export$61bb6938093db2c8)(stride)
    };
}
/**
 * @param {GeoJSONMultiPoint} object Object.
 * @return {import("./Feature.js").GeometryObject} MultiPoint geometry.
 */ function $f602cef51a2e6950$var$readMultiPointGeometry(object) {
    const coordinates = object['coordinates'];
    return {
        type: 'MultiPoint',
        flatCoordinates: coordinates.flat(),
        layout: (0, $c76e993e57efc8c4$export$61bb6938093db2c8)(coordinates[0]?.length || 2)
    };
}
/**
 * @param {GeoJSONMultiPolygon} object Object.
 * @return {import("./Feature.js").GeometryObject} MultiPolygon geometry.
 */ function $f602cef51a2e6950$var$readMultiPolygonGeometry(object) {
    const coordinates = object['coordinates'];
    const flatCoordinates = [];
    const stride = coordinates[0]?.[0]?.[0].length || 2;
    const endss = (0, $6b086aa46281540d$export$f9f2bb59da4accd3)(flatCoordinates, 0, coordinates, stride);
    return {
        type: 'MultiPolygon',
        flatCoordinates: flatCoordinates,
        ends: endss,
        layout: (0, $c76e993e57efc8c4$export$61bb6938093db2c8)(stride)
    };
}
/**
 * @param {GeoJSONPolygon} object Object.
 * @return {import("./Feature.js").GeometryObject} Polygon.
 */ function $f602cef51a2e6950$var$readPolygonGeometry(object) {
    const coordinates = object['coordinates'];
    const flatCoordinates = [];
    const stride = coordinates[0]?.[0]?.length;
    const ends = (0, $6b086aa46281540d$export$47c3746a74384d45)(flatCoordinates, 0, coordinates, stride);
    return {
        type: 'Polygon',
        flatCoordinates: flatCoordinates,
        ends: ends,
        layout: (0, $c76e993e57efc8c4$export$61bb6938093db2c8)(stride)
    };
}
/**
 * @param {import("../geom/Geometry.js").default} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions} [options] Write options.
 * @return {GeoJSONGeometry} GeoJSON geometry.
 */ function $f602cef51a2e6950$var$writeGeometry(geometry, options) {
    geometry = (0, $ec084d0ff9c13a22$export$7beeea566b560d4)(geometry, true, options);
    const type = geometry.getType();
    /** @type {GeoJSONGeometry} */ let geoJSON;
    switch(type){
        case 'Point':
            geoJSON = $f602cef51a2e6950$var$writePointGeometry(/** @type {import("../geom/Point.js").default} */ geometry, options);
            break;
        case 'LineString':
            geoJSON = $f602cef51a2e6950$var$writeLineStringGeometry(/** @type {import("../geom/LineString.js").default} */ geometry, options);
            break;
        case 'Polygon':
            geoJSON = $f602cef51a2e6950$var$writePolygonGeometry(/** @type {import("../geom/Polygon.js").default} */ geometry, options);
            break;
        case 'MultiPoint':
            geoJSON = $f602cef51a2e6950$var$writeMultiPointGeometry(/** @type {import("../geom/MultiPoint.js").default} */ geometry, options);
            break;
        case 'MultiLineString':
            geoJSON = $f602cef51a2e6950$var$writeMultiLineStringGeometry(/** @type {import("../geom/MultiLineString.js").default} */ geometry, options);
            break;
        case 'MultiPolygon':
            geoJSON = $f602cef51a2e6950$var$writeMultiPolygonGeometry(/** @type {import("../geom/MultiPolygon.js").default} */ geometry, options);
            break;
        case 'GeometryCollection':
            geoJSON = $f602cef51a2e6950$var$writeGeometryCollectionGeometry(/** @type {import("../geom/GeometryCollection.js").default} */ geometry, options);
            break;
        case 'Circle':
            geoJSON = {
                type: 'GeometryCollection',
                geometries: []
            };
            break;
        default:
            throw new Error('Unsupported geometry type: ' + type);
    }
    return geoJSON;
}
/**
 * @param {import("../geom/GeometryCollection.js").default} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions} [options] Write options.
 * @return {GeoJSONGeometryCollection} GeoJSON geometry collection.
 */ function $f602cef51a2e6950$var$writeGeometryCollectionGeometry(geometry, options) {
    options = Object.assign({}, options);
    delete options.featureProjection;
    const geometries = geometry.getGeometriesArray().map(function(geometry) {
        return $f602cef51a2e6950$var$writeGeometry(geometry, options);
    });
    return {
        type: 'GeometryCollection',
        geometries: geometries
    };
}
/**
 * @param {import("../geom/LineString.js").default} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions} [options] Write options.
 * @return {GeoJSONGeometry} GeoJSON geometry.
 */ function $f602cef51a2e6950$var$writeLineStringGeometry(geometry, options) {
    return {
        type: 'LineString',
        coordinates: geometry.getCoordinates()
    };
}
/**
 * @param {import("../geom/MultiLineString.js").default} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions} [options] Write options.
 * @return {GeoJSONGeometry} GeoJSON geometry.
 */ function $f602cef51a2e6950$var$writeMultiLineStringGeometry(geometry, options) {
    return {
        type: 'MultiLineString',
        coordinates: geometry.getCoordinates()
    };
}
/**
 * @param {import("../geom/MultiPoint.js").default} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions} [options] Write options.
 * @return {GeoJSONGeometry} GeoJSON geometry.
 */ function $f602cef51a2e6950$var$writeMultiPointGeometry(geometry, options) {
    return {
        type: 'MultiPoint',
        coordinates: geometry.getCoordinates()
    };
}
/**
 * @param {import("../geom/MultiPolygon.js").default} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions} [options] Write options.
 * @return {GeoJSONGeometry} GeoJSON geometry.
 */ function $f602cef51a2e6950$var$writeMultiPolygonGeometry(geometry, options) {
    let right;
    if (options) right = options.rightHanded;
    return {
        type: 'MultiPolygon',
        coordinates: geometry.getCoordinates(right)
    };
}
/**
 * @param {import("../geom/Point.js").default} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions} [options] Write options.
 * @return {GeoJSONGeometry} GeoJSON geometry.
 */ function $f602cef51a2e6950$var$writePointGeometry(geometry, options) {
    return {
        type: 'Point',
        coordinates: geometry.getCoordinates()
    };
}
/**
 * @param {import("../geom/Polygon.js").default} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions} [options] Write options.
 * @return {GeoJSONGeometry} GeoJSON geometry.
 */ function $f602cef51a2e6950$var$writePolygonGeometry(geometry, options) {
    let right;
    if (options) right = options.rightHanded;
    return {
        type: 'Polygon',
        coordinates: geometry.getCoordinates(right)
    };
}
var $f602cef51a2e6950$export$2e2bcd8739ae039 = $f602cef51a2e6950$var$GeoJSON;












const $85570605477afeab$var$FILENAME = 'layers/Countries.js';
const $85570605477afeab$var$CLASS__FUNC_BUTTON = 'oltb-func-btn';
const $85570605477afeab$var$ID__PREFIX_INFO_WINDOW = 'oltb-info-window-marker';
const $85570605477afeab$var$parseGeoJson = function(context, data, projection) {
    const features = new (0, $f602cef51a2e6950$export$2e2bcd8739ae039)({
        featureProjection: projection.getCode()
    }).readFeatures(data);
    const config = (0, $1e8c0ef90ed82280$export$a33e119b2316dcb7).getConfig();
    features.forEach((feature)=>{
        const coordinates = (0, $9c4744460e43e41b$export$51186ad6e864892a)((0, $6da4c8ed3074c92b$export$c91255cadecfe081)(feature.getGeometry().getExtent()), config.projection.default, config.projection.wgs84);
        const prettyCoordinates = (0, $1bd0a226f9a16141$export$c883fd238161f841)(coordinates);
        const measureValue = (0, $ef19f7475e8f20ad$export$c8fdb1ecc11e521e)(feature.getGeometry());
        const title = feature.get('name');
        const description = `
            Based on the geometric data, we estimate the area to be ${measureValue.value} ${measureValue.unit}.
        `;
        const infoWindow = {
            title: title,
            content: `
                <p>${description}</p>
            `,
            footer: `
                <span class="oltb-info-window__coordinates">${prettyCoordinates}</span>
                <div class="oltb-info-window__buttons-wrapper">
                    <button class="${$85570605477afeab$var$CLASS__FUNC_BUTTON} ${$85570605477afeab$var$CLASS__FUNC_BUTTON}--copy oltb-tippy" title="Copy Marker Text" id="${$85570605477afeab$var$ID__PREFIX_INFO_WINDOW}-copy-text" data-oltb-copy="${description}"></button>
                    <button class="${$85570605477afeab$var$CLASS__FUNC_BUTTON} ${$85570605477afeab$var$CLASS__FUNC_BUTTON}--layer oltb-tippy" title="Show Layer" id="${$85570605477afeab$var$ID__PREFIX_INFO_WINDOW}-show-layer"></button>
                </div>
            `
        };
        feature.setProperties({
            oltb: {
                type: (0, $60b20182c25e327b$export$2906e7f4b228efe9).type.layer,
                title: title,
                description: description,
                settings: {
                    shouldHighlightOnHover: true
                },
                infoWindow: infoWindow
            }
        });
    });
    context.addFeatures(features);
    return features;
};
const $85570605477afeab$var$loadGeoJson = function(extent, resolution, projection, success, failure) {
    (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).get((0, (/*@__PURE__*/$parcel$interopDefault($21c8051a108d3692$exports))), {
        responseType: 'application/json',
        headers: {
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache',
            'Expires': '0'
        }
    }).then((response)=>{
        if (response.status !== 200) throw new Error('Failed to fetch local geojson', {
            cause: response
        });
        return JSON.parse(response.data);
    }).then((data)=>{
        const features = $85570605477afeab$var$parseGeoJson(this, data, projection);
        success(features);
    }).catch((error)=>{
        const errorMessage = 'Failed to load Countries layer';
        (0, $b9b5c0363f244088$export$49b118289be48034).logError($85570605477afeab$var$FILENAME, 'geoJsonPromise', {
            message: errorMessage,
            error: error
        });
        (0, $9051f0e072bf4341$export$8d8dc7d5f743331b).error({
            title: 'Error',
            message: errorMessage
        });
        failure();
    });
};
(0, $e75fe1c51a3d360c$export$eff87c52915dd7fe).addMapLayers([
    {
        id: '90fcb696-0eca-43cf-897c-268f1d7d070f',
        name: 'Countries Overlay',
        layer: new (0, $82a68515bd6ef378$export$2e2bcd8739ae039)({
            source: new (0, $84888e4daf3fdf44$export$2e2bcd8739ae039)({
                format: new (0, $f602cef51a2e6950$export$2e2bcd8739ae039)({
                    featureProjection: (0, $1e8c0ef90ed82280$export$a33e119b2316dcb7).getConfig().projection.default
                }),
                loader: $85570605477afeab$var$loadGeoJson,
                strategy: (0, $eb51d0a16123ee90$export$bf67010aacbe66fa)
            }),
            visible: false
        })
    }
], {
    isSilent: true
});


var $1148a7bd44a47f54$exports = {};
$1148a7bd44a47f54$exports = import.meta.resolve("ll2lK");







(0, $e75fe1c51a3d360c$export$eff87c52915dd7fe).addMapLayers([
    {
        id: '7f6200e1-8a41-48a2-a39c-b8ff1ed4f7ec',
        name: 'Continents Overlay',
        layer: new (0, $82a68515bd6ef378$export$2e2bcd8739ae039)({
            source: new (0, $84888e4daf3fdf44$export$2e2bcd8739ae039)({
                url: (0, (/*@__PURE__*/$parcel$interopDefault($1148a7bd44a47f54$exports))),
                format: new (0, $f602cef51a2e6950$export$2e2bcd8739ae039)({
                    featureProjection: (0, $1e8c0ef90ed82280$export$a33e119b2316dcb7).getConfig().projection.default
                })
            }),
            visible: true
        })
    }
], {
    isSilent: true
});


// Cycle.js
// @ https://github.com/douglascrockford/JSON-js
if (typeof JSON.decycle !== 'function') JSON.decycle = function decycle(object, replacer) {
    'use strict';
    // Make a deep copy of an object or array, assuring that there is at most
    // one instance of each object or array in the resulting structure. The
    // duplicate references (which might be forming cycles) are replaced with
    // an object of the form
    //      {'$ref': PATH}
    // where the PATH is a JSONPath string that locates the first occurance.
    // So,
    //      var a = [];
    //      a[0] = a;
    //      return JSON.stringify(JSON.decycle(a));
    // produces the string '[{'$ref':'$'}]'.
    // If a replacer function is provided, then it will be called for each value.
    // A replacer function receives a value and returns a replacement value.
    // JSONPath is used to locate the unique object. $ indicates the top level of
    // the object or array. [NUMBER] or [STRING] indicates a child element or
    // property.
    var objects = new WeakMap(); // object to path mappings
    return function derez(value, path) {
        // The derez function recurses through the object, producing the deep copy.
        var oldPath; // The path of an earlier occurance of value
        var nu; // The new object or array
        // If a replacer function was provided, then call it to get a replacement value.
        if (replacer !== undefined) value = replacer(value);
        // typeof null === 'object', so go on if this value is really an object but not
        // one of the weird builtin objects.
        if (typeof value === 'object' && value !== null && !(value instanceof Boolean) && !(value instanceof Date) && !(value instanceof Number) && !(value instanceof RegExp) && !(value instanceof String)) {
            // If the value is an object or array, look to see if we have already
            // encountered it. If so, return a {'$ref':PATH} object. This uses an
            // ES6 WeakMap.
            oldPath = objects.get(value);
            if (oldPath !== undefined) return {
                $ref: oldPath
            };
            // Otherwise, accumulate the unique value and its path.
            objects.set(value, path);
            // If it is an array, replicate the array.
            if (Array.isArray(value)) {
                nu = [];
                value.forEach(function(element, i) {
                    nu[i] = derez(element, path + '[' + i + ']');
                });
            } else {
                // If it is an object, replicate the object.
                nu = {};
                Object.keys(value).forEach(function(name) {
                    nu[name] = derez(value[name], path + '[' + JSON.stringify(name) + ']');
                });
            }
            return nu;
        }
        return value;
    }(object, '$');
};
if (typeof JSON.retrocycle !== 'function') JSON.retrocycle = function retrocycle($) {
    'use strict';
    // Restore an object that was reduced by decycle. Members whose values are
    // objects of the form
    //      {$ref: PATH}
    // are replaced with references to the value found by the PATH. This will
    // restore cycles. The object will be mutated.
    // The eval function is used to locate the values described by a PATH. The
    // root object is kept in a $ variable. A regular expression is used to
    // assure that the PATH is extremely well formed. The regexp contains nested
    // * quantifiers. That has been known to have extremely bad performance
    // problems on some browsers for very long strings. A PATH is expected to be
    // reasonably short. A PATH is allowed to belong to a very restricted subset of
    // Goessner's JSONPath.
    // So,
    //      var s = '[{'$ref':'$'}]';
    //      return JSON.retrocycle(JSON.parse(s));
    // produces an array containing a single element which is the array itself.
    var px = /^\$(?:\[(?:\d+|"(?:[^\\"\u0000-\u001f]|\\(?:[\\"\\/bfnrt]|u[0-9a-zA-Z]{4}))*")\])*$/;
    (function rez(value) {
        // The rez function walks recursively through the object looking for $ref
        // properties. When it finds one that has a value that is a path, then it
        // replaces the $ref object with a reference to the value that is found by
        // the path.
        if (value && typeof value === 'object') {
            if (Array.isArray(value)) value.forEach(function(element, i) {
                if (typeof element === 'object' && element !== null) {
                    var path = element.$ref;
                    if (typeof path === 'string' && px.test(path)) // value[i] = eval(path);
                    value[i] = Function(path);
                    else rez(element);
                }
            });
            else Object.keys(value).forEach(function(name) {
                var item = value[name];
                if (typeof item === 'object' && item !== null) {
                    var path = item.$ref;
                    if (typeof path === 'string' && px.test(path)) // value[name] = eval(path);
                    value[name] = Function(path);
                    else rez(item);
                }
            });
        }
    })($);
    return $;
};


String.prototype.startsWithCapital = function() {
    return /^[A-Z]/.test(this);
};
String.prototype.capitalize = function() {
    return this.charAt(0).toUpperCase() + this.slice(1);
};
String.prototype.isDigitsOnly = function() {
    return this.match(/^-?[0-9]+$/) !== null;
};
String.prototype.ellipsis = function(limit) {
    if (this.length > limit) return `${this.substring(0, limit)}...`;
    return this;
};


// Plain JS SlideToggle
// https://github.com/ericbutler555/plain-js-slidetoggle
HTMLElement.prototype.slideToggle = function(duration, callback) {
    if (this.clientHeight === 0) $07dd1cad933f3124$var$slideToggle(this, duration, callback, true);
    else $07dd1cad933f3124$var$slideToggle(this, duration, callback);
};
HTMLElement.prototype.slideUp = function(duration, callback) {
    $07dd1cad933f3124$var$slideToggle(this, duration, callback);
};
HTMLElement.prototype.slideDown = function(duration, callback) {
    $07dd1cad933f3124$var$slideToggle(this, duration, callback, true);
};
const $07dd1cad933f3124$var$slideToggle = function(el, duration, callback, isDown) {
    if (typeof duration === 'undefined') duration = 200;
    if (typeof isDown === 'undefined') isDown = false;
    // Note:
    // Fix to avoid jumping behaviour if no content is present
    const hasContentHeight = parseFloat(window.getComputedStyle(el).getPropertyValue('height'));
    if (hasContentHeight === 0) return;
    el.style.overflow = 'hidden';
    if (isDown) el.style.display = 'block';
    const elStyles = window.getComputedStyle(el);
    const elHeight = parseFloat(elStyles.getPropertyValue('height'));
    const elPaddingTop = parseFloat(elStyles.getPropertyValue('padding-top'));
    const elPaddingBottom = parseFloat(elStyles.getPropertyValue('padding-bottom'));
    const elMarginTop = parseFloat(elStyles.getPropertyValue('margin-top'));
    const elMarginBottom = parseFloat(elStyles.getPropertyValue('margin-bottom'));
    const stepHeight = elHeight / duration;
    const stepPaddingTop = elPaddingTop / duration;
    const stepPaddingBottom = elPaddingBottom / duration;
    const stepMarginTop = elMarginTop / duration;
    const stepMarginBottom = elMarginBottom / duration;
    let start;
    const step = function(timestamp) {
        if (start === undefined) start = timestamp;
        const elapsed = timestamp - start;
        if (isDown) {
            el.style.height = `${stepHeight * elapsed}px`;
            el.style.paddingTop = `${stepPaddingTop * elapsed}px`;
            el.style.paddingBottom = `${stepPaddingBottom * elapsed}px`;
            el.style.marginTop = `${stepMarginTop * elapsed}px`;
            el.style.marginBottom = `${stepMarginBottom * elapsed}px`;
        } else {
            el.style.height = `${elHeight - stepHeight * elapsed}px`;
            el.style.paddingTop = `${elPaddingTop - stepPaddingTop * elapsed}px`;
            el.style.paddingBottom = `${elPaddingBottom - stepPaddingBottom * elapsed}px`;
            el.style.marginTop = `${elMarginTop - stepMarginTop * elapsed}px`;
            el.style.marginBottom = `${elMarginBottom - stepMarginBottom * elapsed}px`;
        }
        if (elapsed >= duration) {
            el.style.height = '';
            el.style.paddingTop = '';
            el.style.paddingBottom = '';
            el.style.marginTop = '';
            el.style.marginBottom = '';
            el.style.overflow = '';
            if (!isDown) el.style.display = 'none';
            if (callback instanceof Function) callback(!isDown);
        } else window.requestAnimationFrame(step);
    };
    window.requestAnimationFrame(step);
};



const $65522956a1f1a049$export$c72f6eaae7b9adff = Object.freeze({
    altShiftDragRotate: 'altShiftDragRotate',
    alwaysNewLayers: 'alwaysNewLayers',
    copyCoordinatesOnClick: 'copyCoordinatesOnClick',
    dragPan: 'dragPan',
    keyboardPan: 'keyboardPan',
    keyboardZoom: 'keyboardZoom',
    mouseOnlyToEditVectorShapes: 'mouseOnlyToEditVectorShapes',
    mouseWheelZoom: 'mouseWheelZoom',
    selectVectorMapShapes: 'selectVectorMapShapes',
    snapHelpLines: 'snapHelpLines',
    snapInteraction: 'snapInteraction',
    updateToolboxCoordinatesOnHover: 'updateToolboxCoordinatesOnHover'
});






const $af35fd2ff1608131$var$FILENAME = 'url-manager.js';
/**
 * About:
 * UrlManager
 * 
 * Description:
 * Manages and simplifies the usage of any GET-query parameter and the overall Location object.
 */ class $af35fd2ff1608131$export$fb10f6d9eb34a490 extends (0, $8a2666592e7029ee$export$84777416d052f822) {
    //--------------------------------------------------------------------
    // # Section: Base Overrides
    //--------------------------------------------------------------------
    static async initAsync(options = {}) {
        (0, $b9b5c0363f244088$export$49b118289be48034).logDebug($af35fd2ff1608131$var$FILENAME, 'initAsync', 'Initialization started');
        return new Promise((resolve)=>{
            resolve({
                filename: $af35fd2ff1608131$var$FILENAME,
                result: true
            });
        });
    }
    static setMap(map) {}
    static getName() {
        return $af35fd2ff1608131$var$FILENAME;
    }
    //--------------------------------------------------------------------
    // # Section: Public API
    //--------------------------------------------------------------------
    static getParameters() {
        const uri = decodeURI(window.location.search);
        const urlParameters = new URLSearchParams(uri);
        return urlParameters;
    }
    static getParameter(name, isLowerCase = true) {
        const parameters = this.getParameters();
        const parameter = parameters.get(name) || '';
        if (isLowerCase) return parameter.toLowerCase();
        return parameter;
    }
}



var $f1q41 = parcelRequire("f1q41");
const $28605f73e0f3ed41$export$ebd5ce00e70882e7 = Object.freeze([
    'Badger',
    'Bear',
    'Cat',
    'Cow',
    'Dog',
    'Donkey',
    'Elephant',
    'Frog',
    'Giraffe',
    'Koala',
    'Lemur',
    'Lizard',
    'Lynx',
    'Meerkat',
    'Moose',
    'Mosquito',
    'Mouse',
    'Otter',
    'Owl',
    'Panda',
    'Pelican',
    'Puma',
    'Rabbit',
    'Snow leopard'
]);


const $f9f7566e54ad82a7$export$a923f4cbc2f63a50 = Object.freeze([
    'Adorable',
    'Adored',
    'Angry',
    'Clever',
    'Clumsy',
    'Confused',
    'Dashing',
    'Dizzy',
    'Elegant',
    'Funny',
    'Glowing',
    'Happy',
    'Mysterious',
    'Notorious',
    'Running',
    'Slow',
    'Smooth',
    'Spooky',
    'Stubborn',
    'Suspicious',
    'Swimming',
    'Tired',
    'Triumphant',
    'Upset',
    'Yummy'
]);




const $676c8372f9654b59$var$FILENAME = 'name-manager.js';
const $676c8372f9654b59$var$INDEX__OFFSET = 1;
/**
 * About:
 * NameManager
 * 
 * Description:
 * Manager responsilbe for generating a random name.
 */ class $676c8372f9654b59$export$ac3128716fe7727f extends (0, $8a2666592e7029ee$export$84777416d052f822) {
    //--------------------------------------------------------------------
    // # Section: Base Overrides
    //--------------------------------------------------------------------
    static async initAsync(options = {}) {
        (0, $b9b5c0363f244088$export$49b118289be48034).logDebug($676c8372f9654b59$var$FILENAME, 'initAsync', 'Initialization started');
        return new Promise((resolve)=>{
            resolve({
                filename: $676c8372f9654b59$var$FILENAME,
                result: true
            });
        });
    }
    static setMap(map) {}
    static getName() {
        return $676c8372f9654b59$var$FILENAME;
    }
    //--------------------------------------------------------------------
    // # Section: Public API
    //--------------------------------------------------------------------
    static generate() {
        const animalIndex = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).random(0, (0, $28605f73e0f3ed41$export$ebd5ce00e70882e7).length - $676c8372f9654b59$var$INDEX__OFFSET);
        const adjectiveIndex = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).random(0, (0, $f9f7566e54ad82a7$export$a923f4cbc2f63a50).length - $676c8372f9654b59$var$INDEX__OFFSET);
        return `${(0, $f9f7566e54ad82a7$export$a923f4cbc2f63a50)[adjectiveIndex]} ${(0, $28605f73e0f3ed41$export$ebd5ce00e70882e7)[animalIndex]}`.capitalize();
    }
}




const $3110b1ed727d9f35$var$FILENAME = 'tool-manager.js';
/**
 * About:
 * ToolManager
 * 
 * Description:
 * Manages the current active tool that cannot be used with all other tools.
 * Examples are Edit-, Draw- and Measure tool.
 */ class $3110b1ed727d9f35$export$df4a79c26d3b48ff extends (0, $8a2666592e7029ee$export$84777416d052f822) {
    static #tool;
    //--------------------------------------------------------------------
    // # Section: Base Overrides
    //--------------------------------------------------------------------
    static async initAsync(options = {}) {
        (0, $b9b5c0363f244088$export$49b118289be48034).logDebug($3110b1ed727d9f35$var$FILENAME, 'initAsync', 'Initialization started');
        return new Promise((resolve)=>{
            resolve({
                filename: $3110b1ed727d9f35$var$FILENAME,
                result: true
            });
        });
    }
    static setMap(map) {}
    static getName() {
        return $3110b1ed727d9f35$var$FILENAME;
    }
    //--------------------------------------------------------------------
    // # Section: Public API
    //--------------------------------------------------------------------
    static setActiveTool(tool) {
        if (this.#tool && this.#tool !== tool) this.#tool.deselectTool();
        this.#tool = tool;
    }
    static getActiveTool() {
        return this.#tool;
    }
    static hasActiveTool() {
        return this.#tool !== undefined;
    }
    static removeActiveTool() {
        this.#tool = undefined;
    }
}



var $f1q41 = parcelRequire("f1q41");
/**
 * @module ol/interaction/Snap
 */ 


/**
 * @module ol/events/SnapEvent
 */ 
const $9eeb64783af33371$export$b29220a3eceb9d7b = {
    /**
   * Triggered upon snapping to vertex or edge
   * @event SnapEvent#snap
   * @api
   */ SNAP: 'snap',
    UNSNAP: 'unsnap'
};
class $9eeb64783af33371$export$4b90546510c2ba37 extends (0, $aeedce20e9577100$export$2e2bcd8739ae039) {
    /**
   * @param {SnapEventType} type Type.
   * @param {Object} options Options.
   * @param {import("../coordinate.js").Coordinate} options.vertex The snapped vertex.
   * @param {import("../coordinate.js").Coordinate} options.vertexPixel The pixel of the snapped vertex.
   * @param {import("../Feature.js").default} options.feature The feature being snapped.
   * @param {Array<import("../coordinate.js").Coordinate>|null} options.segment Segment, or `null` if snapped to a vertex.
   */ constructor(type, options){
        super(type);
        /**
     * The Map coordinate of the snapped point.
     * @type {import("../coordinate.js").Coordinate}
     * @api
     */ this.vertex = options.vertex;
        /**
     * The Map pixel of the snapped point.
     * @type {Array<number>&Array<number>}
     * @api
     */ this.vertexPixel = options.vertexPixel;
        /**
     * The feature closest to the snapped point.
     * @type {import("../Feature.js").default<import("../geom/Geometry.js").default>}
     * @api
     */ this.feature = options.feature;
        /**
     * The segment closest to the snapped point, if snapped to a segment.
     * @type {Array<import("../coordinate.js").Coordinate>|null}
     * @api
     */ this.segment = options.segment;
    }
}












/**
 * @typedef {Array<import("../coordinate.js").Coordinate>} Segment
 * An array of two coordinates representing a line segment, or an array of one
 * coordinate representing a point.
 */ /**
 * @typedef {Object} SegmentData
 * @property {import("../Feature.js").default} feature Feature.
 * @property {Segment} segment Segment.
 * @property {boolean} [isIntersection] Is intersection.
 */ /**
 * @template {import("../geom/Geometry.js").default} [GeometryType=import("../geom/Geometry.js").default]
 * @typedef {(geometry: GeometryType, projection?: import("../proj/Projection.js").default) => Array<Segment>} Segmenter
 * A function taking a {@link module:ol/geom/Geometry~Geometry} as argument and returning an array of {@link Segment}s.
 */ /**
 * Each segmenter specified here will override the default segmenter for the
 * corresponding geometry type. To exclude all geometries of a specific geometry type from being snapped to,
 * set the segmenter to `null`.
 * @typedef {Object} Segmenters
 * @property {Segmenter<import("../geom/Point.js").default>|null} [Point] Point segmenter.
 * @property {Segmenter<import("../geom/LineString.js").default>|null} [LineString] LineString segmenter.
 * @property {Segmenter<import("../geom/Polygon.js").default>|null} [Polygon] Polygon segmenter.
 * @property {Segmenter<import("../geom/Circle.js").default>|null} [Circle] Circle segmenter.
 * @property {Segmenter<import("../geom/GeometryCollection.js").default>|null} [GeometryCollection] GeometryCollection segmenter.
 * @property {Segmenter<import("../geom/MultiPoint.js").default>|null} [MultiPoint] MultiPoint segmenter.
 * @property {Segmenter<import("../geom/MultiLineString.js").default>|null} [MultiLineString] MultiLineString segmenter.
 * @property {Segmenter<import("../geom/MultiPolygon.js").default>|null} [MultiPolygon] MultiPolygon segmenter.
 */ /**
 * @typedef {Object} Options
 * @property {import("../Collection.js").default<import("../Feature.js").default>} [features] Snap to these features. Either this option or source should be provided.
 * @property {import("../source/Vector.js").default} [source] Snap to features from this source. Either this option or features should be provided
 * @property {boolean} [edge=true] Snap to edges.
 * @property {boolean} [vertex=true] Snap to vertices.
 * @property {boolean} [intersection=false] Snap to intersections between segments.
 * @property {number} [pixelTolerance=10] Pixel tolerance for considering the pointer close enough to a segment or
 * vertex for snapping.
 * @property {Segmenters} [segmenters] Custom segmenters by {@link module:ol/geom/Geometry~Type}. By default, the
 * following segmenters are used:
 *   - `Point`: A one-dimensional segment (e.g. `[[10, 20]]`) representing the point.
 *   - `LineString`: One two-dimensional segment (e.g. `[[10, 20], [30, 40]]`) for each segment of the linestring.
 *   - `Polygon`: One two-dimensional segment for each segment of the exterior ring and the interior rings.
 *   - `Circle`: One two-dimensional segment for each segment of a regular polygon with 32 points representing the circle circumference.
 *   - `GeometryCollection`: All segments of the contained geometries.
 *   - `MultiPoint`: One one-dimensional segment for each point.
 *   - `MultiLineString`: One two-dimensional segment for each segment of the linestrings.
 *   - `MultiPolygon`: One two-dimensional segment for each segment of the polygons.
 */ /**
 * Information about the last snapped state.
 * @typedef {Object} SnappedInfo
 * @property {import("../coordinate.js").Coordinate|null} vertex - The snapped vertex.
 * @property {import("../pixel.js").Pixel|null} vertexPixel - The pixel of the snapped vertex.
 * @property {import("../Feature.js").default|null} feature - The feature being snapped.
 * @property {Segment|null} segment - Segment, or `null` if snapped to a vertex.
 */ /***
 * @type {Object<string, Segmenter>}
 */ const $d4ff3154db04ce79$var$GEOMETRY_SEGMENTERS = {
    /**
   * @param {import("../geom/Circle.js").default} geometry Geometry.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {Array<Segment>} Segments
   */ Circle (geometry, projection) {
        let circleGeometry = geometry;
        const userProjection = (0, $9c4744460e43e41b$export$3973b77d5f6f2790)();
        if (userProjection) circleGeometry = circleGeometry.clone().transform(userProjection, projection);
        const polygon = (0, $40aa8d43bbe572bf$export$2451009d645fb8c2)(circleGeometry);
        if (userProjection) polygon.transform(projection, userProjection);
        return $d4ff3154db04ce79$var$GEOMETRY_SEGMENTERS.Polygon(polygon);
    },
    /**
   * @param {import("../geom/GeometryCollection.js").default} geometry Geometry.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {Array<Segment>} Segments
   */ GeometryCollection (geometry, projection) {
        /** @type {Array<Array<Segment>>} */ const segments = [];
        const geometries = geometry.getGeometriesArray();
        for(let i = 0; i < geometries.length; ++i){
            const segmenter = $d4ff3154db04ce79$var$GEOMETRY_SEGMENTERS[geometries[i].getType()];
            if (segmenter) segments.push(segmenter(geometries[i], projection));
        }
        return segments.flat();
    },
    /**
   * @param {import("../geom/LineString.js").default} geometry Geometry.
   * @return {Array<Segment>} Segments
   */ LineString (geometry) {
        /** @type {Array<Segment>} */ const segments = [];
        const coordinates = geometry.getFlatCoordinates();
        const stride = geometry.getStride();
        for(let i = 0, ii = coordinates.length - stride; i < ii; i += stride)segments.push([
            coordinates.slice(i, i + 2),
            coordinates.slice(i + stride, i + stride + 2)
        ]);
        return segments;
    },
    /**
   * @param {import("../geom/MultiLineString.js").default} geometry Geometry.
   * @return {Array<Segment>} Segments
   */ MultiLineString (geometry) {
        /** @type {Array<Segment>} */ const segments = [];
        const coordinates = geometry.getFlatCoordinates();
        const stride = geometry.getStride();
        const ends = geometry.getEnds();
        let offset = 0;
        for(let i = 0, ii = ends.length; i < ii; ++i){
            const end = ends[i];
            for(let j = offset, jj = end - stride; j < jj; j += stride)segments.push([
                coordinates.slice(j, j + 2),
                coordinates.slice(j + stride, j + stride + 2)
            ]);
            offset = end;
        }
        return segments;
    },
    /**
   * @param {import("../geom/MultiPoint.js").default} geometry Geometry.
   * @return {Array<Segment>} Segments
   */ MultiPoint (geometry) {
        /** @type {Array<Segment>} */ const segments = [];
        const coordinates = geometry.getFlatCoordinates();
        const stride = geometry.getStride();
        for(let i = 0, ii = coordinates.length; i < ii; i += stride)segments.push([
            coordinates.slice(i, i + 2)
        ]);
        return segments;
    },
    /**
   * @param {import("../geom/MultiPolygon.js").default} geometry Geometry.
   * @return {Array<Segment>} Segments
   */ MultiPolygon (geometry) {
        /** @type {Array<Segment>} */ const segments = [];
        const coordinates = geometry.getFlatCoordinates();
        const stride = geometry.getStride();
        const endss = geometry.getEndss();
        let offset = 0;
        for(let i = 0, ii = endss.length; i < ii; ++i){
            const ends = endss[i];
            for(let j = 0, jj = ends.length; j < jj; ++j){
                const end = ends[j];
                for(let k = offset, kk = end - stride; k < kk; k += stride)segments.push([
                    coordinates.slice(k, k + 2),
                    coordinates.slice(k + stride, k + stride + 2)
                ]);
                offset = end;
            }
        }
        return segments;
    },
    /**
   * @param {import("../geom/Point.js").default} geometry Geometry.
   * @return {Array<Segment>} Segments
   */ Point (geometry) {
        return [
            [
                geometry.getFlatCoordinates().slice(0, 2)
            ]
        ];
    },
    /**
   * @param {import("../geom/Polygon.js").default} geometry Geometry.
   * @return {Array<Segment>} Segments
   */ Polygon (geometry) {
        /** @type {Array<Segment>} */ const segments = [];
        const coordinates = geometry.getFlatCoordinates();
        const stride = geometry.getStride();
        const ends = geometry.getEnds();
        let offset = 0;
        for(let i = 0, ii = ends.length; i < ii; ++i){
            const end = ends[i];
            for(let j = offset, jj = end - stride; j < jj; j += stride)segments.push([
                coordinates.slice(j, j + 2),
                coordinates.slice(j + stride, j + stride + 2)
            ]);
            offset = end;
        }
        return segments;
    }
};
/**
 * @param  {import("../source/Vector.js").VectorSourceEvent|import("../Collection.js").CollectionEvent<import("../Feature.js").default>} evt Event.
 * @return {import("../Feature.js").default|null} Feature.
 */ function $d4ff3154db04ce79$var$getFeatureFromEvent(evt) {
    if (/** @type {import("../source/Vector.js").VectorSourceEvent} */ evt.feature) return /** @type {import("../source/Vector.js").VectorSourceEvent} */ evt.feature;
    if (/** @type {import("../Collection.js").CollectionEvent<import("../Feature.js").default>} */ evt.element) return /** @type {import("../Collection.js").CollectionEvent<import("../Feature.js").default>} */ evt.element;
    return null;
}
const $d4ff3154db04ce79$var$tempSegment = [];
/** @type {Array<import('../extent.js').Extent>} */ const $d4ff3154db04ce79$var$tempExtents = [];
/** @type {Array<SegmentData>} */ const $d4ff3154db04ce79$var$tempSegmentData = [];
/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types|
 *     'change:active', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<'snap'|'unsnap', SnapEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types|
 *     'change:active'|'snap'|'unsnap', Return>} SnapOnSignature
 */ /**
 * @classdesc
 * Handles snapping of vector features while modifying or drawing them.  The
 * features can come from a {@link module:ol/source/Vector~VectorSource} or {@link module:ol/Collection~Collection}
 * Any interaction object that allows the user to interact
 * with the features using the mouse can benefit from the snapping, as long
 * as it is added before.
 *
 * The snap interaction modifies map browser event `coordinate` and `pixel`
 * properties to force the snap to occur to any interaction that uses them.
 *
 * Example:
 *
 *     import Snap from 'ol/interaction/Snap.js';
 *
 *     const snap = new Snap({
 *       source: source
 *     });
 *
 *     map.addInteraction(snap);
 *
 * @fires SnapEvent
 * @api
 */ class $d4ff3154db04ce79$var$Snap extends (0, $cf1eb502962d87a8$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        const pointerOptions = /** @type {import("./Pointer.js").Options} */ options;
        if (!pointerOptions.handleDownEvent) pointerOptions.handleDownEvent = (0, $013a1733c226ec50$export$22e23a2304399231);
        if (!pointerOptions.stopDown) pointerOptions.stopDown = (0, $013a1733c226ec50$export$8f11cee4bdc7e668);
        super(pointerOptions);
        /***
     * @type {SnapOnSignature<import("../events").EventsKey>}
     */ this.on;
        /***
     * @type {SnapOnSignature<import("../events").EventsKey>}
     */ this.once;
        /***
     * @type {SnapOnSignature<void>}
     */ this.un;
        /**
     * @type {import("../source/Vector.js").default|null}
     * @private
     */ this.source_ = options.source ? options.source : null;
        /**
     * @private
     * @type {boolean}
     */ this.vertex_ = options.vertex !== undefined ? options.vertex : true;
        /**
     * @private
     * @type {boolean}
     */ this.edge_ = options.edge !== undefined ? options.edge : true;
        /**
     * @private
     * @type {boolean}
     */ this.intersection_ = options.intersection !== undefined ? options.intersection : false;
        /**
     * @type {import("../Collection.js").default<import("../Feature.js").default>|null}
     * @private
     */ this.features_ = options.features ? options.features : null;
        /**
     * @type {Array<import("../events.js").EventsKey>}
     * @private
     */ this.featuresListenerKeys_ = [];
        /**
     * @type {Object<string, import("../events.js").EventsKey>}
     * @private
     */ this.featureChangeListenerKeys_ = {};
        /**
     * Extents are preserved so indexed segment can be quickly removed
     * when its feature geometry changes
     * @type {Object<string, import("../extent.js").Extent>}
     * @private
     */ this.indexedFeaturesExtents_ = {};
        /**
     * If a feature geometry changes while a pointer drag|move event occurs, the
     * feature doesn't get updated right away.  It will be at the next 'pointerup'
     * event fired.
     * @type {!Object<string, import("../Feature.js").default>}
     * @private
     */ this.pendingFeatures_ = {};
        /**
     * @type {number}
     * @private
     */ this.pixelTolerance_ = options.pixelTolerance !== undefined ? options.pixelTolerance : 10;
        /**
     * Segment RTree for each layer
     * @type {import("../structs/RBush.js").default<SegmentData>}
     * @private
     */ this.rBush_ = new (0, $34c742891733e7a4$export$2e2bcd8739ae039)();
        /**
     * Holds information about the last snapped state.
     * @type {SnappedInfo|null}
     * @private
     */ this.snapped_ = null;
        /**
     * @type {Object<string, Segmenter>}
     * @private
     */ this.segmenters_ = Object.assign({}, $d4ff3154db04ce79$var$GEOMETRY_SEGMENTERS, options.segmenters);
    }
    /**
   * Add a feature to the collection of features that we may snap to.
   * @param {import("../Feature.js").default} feature Feature.
   * @param {boolean} [register] Whether to listen to the feature change or not
   *     Defaults to `true`.
   * @api
   */ addFeature(feature, register) {
        register = register !== undefined ? register : true;
        const feature_uid = (0, $6c5e11070e371322$export$5e82334337e0f204)(feature);
        const geometry = feature.getGeometry();
        if (geometry) {
            const segmenter = this.segmenters_[geometry.getType()];
            if (segmenter) {
                this.indexedFeaturesExtents_[feature_uid] = geometry.getExtent((0, $6da4c8ed3074c92b$export$fe201bb3bbe031e9)());
                const segments = segmenter(geometry, this.getMap().getView().getProjection());
                let segmentCount = segments.length;
                for(let i = 0; i < segmentCount; ++i){
                    const segment = segments[i];
                    $d4ff3154db04ce79$var$tempExtents[i] = (0, $6da4c8ed3074c92b$export$8aceca7c77505534)(segment);
                    $d4ff3154db04ce79$var$tempSegmentData[i] = {
                        feature: feature,
                        segment: segment
                    };
                }
                $d4ff3154db04ce79$var$tempExtents.length = segmentCount;
                $d4ff3154db04ce79$var$tempSegmentData.length = segmentCount;
                if (this.intersection_) for(let j = 0, jj = segments.length; j < jj; ++j){
                    const segment = segments[j];
                    if (segment.length === 1) continue;
                    const extent = $d4ff3154db04ce79$var$tempExtents[j];
                    // Calculate intersections with own segments
                    for(let k = 0, kk = segments.length; k < kk; ++k){
                        if (j === k || j - 1 === k || j + 1 === k) continue;
                        const otherSegment = segments[k];
                        if (!(0, $6da4c8ed3074c92b$export$7b0a31e10bbff018)(extent, $d4ff3154db04ce79$var$tempExtents[k])) continue;
                        const intersection = (0, $3e64078bffae1cbd$export$3f024338373820dc)(segment, otherSegment);
                        if (!intersection) continue;
                        const intersectionSegment = [
                            intersection
                        ];
                        $d4ff3154db04ce79$var$tempExtents[segmentCount] = (0, $6da4c8ed3074c92b$export$8aceca7c77505534)(intersectionSegment);
                        $d4ff3154db04ce79$var$tempSegmentData[segmentCount++] = {
                            feature: feature,
                            segment: intersectionSegment,
                            isIntersection: true
                        };
                    }
                    // Calculate intersections with existing segments
                    const otherSegments = this.rBush_.getInExtent($d4ff3154db04ce79$var$tempExtents[j]);
                    for (const { segment: otherSegment } of otherSegments){
                        if (otherSegment.length === 1) continue;
                        const intersection = (0, $3e64078bffae1cbd$export$3f024338373820dc)(segment, otherSegment);
                        if (!intersection) continue;
                        const intersectionSegment = [
                            intersection
                        ];
                        $d4ff3154db04ce79$var$tempExtents[segmentCount] = (0, $6da4c8ed3074c92b$export$8aceca7c77505534)(intersectionSegment);
                        $d4ff3154db04ce79$var$tempSegmentData[segmentCount++] = {
                            feature: feature,
                            segment: intersectionSegment,
                            isIntersection: true
                        };
                    }
                }
                if (segmentCount === 1) this.rBush_.insert($d4ff3154db04ce79$var$tempExtents[0], $d4ff3154db04ce79$var$tempSegmentData[0]);
                else this.rBush_.load($d4ff3154db04ce79$var$tempExtents, $d4ff3154db04ce79$var$tempSegmentData);
            }
        }
        if (register) this.featureChangeListenerKeys_[feature_uid] = (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(feature, (0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE, this.handleFeatureChange_, this);
    }
    /**
   * @return {import("../Collection.js").default<import("../Feature.js").default>|Array<import("../Feature.js").default>} Features.
   * @private
   */ getFeatures_() {
        /** @type {import("../Collection.js").default<import("../Feature.js").default>|Array<import("../Feature.js").default>} */ let features;
        if (this.features_) features = this.features_;
        else if (this.source_) features = this.source_.getFeatures();
        return features;
    }
    /**
   * Checks if two snap data sets are equal.
   * Compares the segment and the feature.
   *
   * @param {SnappedInfo} data1 The first snap data set.
   * @param {SnappedInfo} data2 The second snap data set.
   * @return {boolean} `true` if the data sets are equal, otherwise `false`.
   * @private
   */ areSnapDataEqual_(data1, data2) {
        return data1.segment === data2.segment && data1.feature === data2.feature;
    }
    /**
   * @param {import("../MapBrowserEvent.js").default} evt Map browser event.
   * @return {boolean} `false` to stop event propagation.
   * @api
   * @override
   */ handleEvent(evt) {
        const result = this.snapTo(evt.pixel, evt.coordinate, evt.map);
        if (result) {
            evt.coordinate = result.vertex.slice(0, 2);
            evt.pixel = result.vertexPixel;
            // Dispatch UNSNAP event if already snapped
            if (this.snapped_ && !this.areSnapDataEqual_(this.snapped_, result)) this.dispatchEvent(new (0, $9eeb64783af33371$export$4b90546510c2ba37)((0, $9eeb64783af33371$export$b29220a3eceb9d7b).UNSNAP, this.snapped_));
            this.snapped_ = {
                vertex: evt.coordinate,
                vertexPixel: evt.pixel,
                feature: result.feature,
                segment: result.segment
            };
            this.dispatchEvent(new (0, $9eeb64783af33371$export$4b90546510c2ba37)((0, $9eeb64783af33371$export$b29220a3eceb9d7b).SNAP, this.snapped_));
        } else if (this.snapped_) {
            // Dispatch UNSNAP event if no longer snapped
            this.dispatchEvent(new (0, $9eeb64783af33371$export$4b90546510c2ba37)((0, $9eeb64783af33371$export$b29220a3eceb9d7b).UNSNAP, this.snapped_));
            this.snapped_ = null;
        }
        return super.handleEvent(evt);
    }
    /**
   * @param {import("../source/Vector.js").VectorSourceEvent|import("../Collection.js").CollectionEvent<import("../Feature.js").default>} evt Event.
   * @private
   */ handleFeatureAdd_(evt) {
        const feature = $d4ff3154db04ce79$var$getFeatureFromEvent(evt);
        if (feature) this.addFeature(feature);
    }
    /**
   * @param {import("../source/Vector.js").VectorSourceEvent|import("../Collection.js").CollectionEvent<import("../Feature.js").default>} evt Event.
   * @private
   */ handleFeatureRemove_(evt) {
        const feature = $d4ff3154db04ce79$var$getFeatureFromEvent(evt);
        if (feature) this.removeFeature(feature);
    }
    /**
   * @param {import("../events/Event.js").default} evt Event.
   * @private
   */ handleFeatureChange_(evt) {
        const feature = /** @type {import("../Feature.js").default} */ evt.target;
        if (this.handlingDownUpSequence) {
            const uid = (0, $6c5e11070e371322$export$5e82334337e0f204)(feature);
            if (!(uid in this.pendingFeatures_)) this.pendingFeatures_[uid] = feature;
        } else this.updateFeature_(feature);
    }
    /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} evt Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleUpEvent(evt) {
        const featuresToUpdate = Object.values(this.pendingFeatures_);
        if (featuresToUpdate.length) for (const feature of featuresToUpdate)this.updateFeature_(feature);
        return false;
    }
    /**
   * Remove a feature from the collection of features that we may snap to.
   * @param {import("../Feature.js").default} feature Feature
   * @param {boolean} [unlisten] Whether to unlisten to the feature change
   *     or not. Defaults to `true`.
   * @api
   */ removeFeature(feature, unlisten) {
        const unregister = unlisten !== undefined ? unlisten : true;
        const feature_uid = (0, $6c5e11070e371322$export$5e82334337e0f204)(feature);
        const extent = this.indexedFeaturesExtents_[feature_uid];
        if (extent) {
            const rBush = this.rBush_;
            const nodesToRemove = [];
            rBush.forEachInExtent(extent, function(node) {
                if (feature === node.feature) nodesToRemove.push(node);
            });
            for(let i = nodesToRemove.length - 1; i >= 0; --i)rBush.remove(nodesToRemove[i]);
        }
        if (unregister) {
            (0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921)(this.featureChangeListenerKeys_[feature_uid]);
            delete this.featureChangeListenerKeys_[feature_uid];
        }
    }
    /**
   * Remove the interaction from its current map and attach it to the new map.
   * Subclasses may set up event handlers to get notified about changes to
   * the map here.
   * @param {import("../Map.js").default} map Map.
   * @override
   */ setMap(map) {
        const currentMap = this.getMap();
        const keys = this.featuresListenerKeys_;
        let features = this.getFeatures_();
        if (!Array.isArray(features)) features = features.getArray();
        if (currentMap) {
            keys.forEach((0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921));
            keys.length = 0;
            this.rBush_.clear();
            Object.values(this.featureChangeListenerKeys_).forEach((0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921));
            this.featureChangeListenerKeys_ = {};
        }
        super.setMap(map);
        if (map) {
            if (this.features_) keys.push((0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(this.features_, (0, $161dd067fe2d672c$export$2e2bcd8739ae039).ADD, this.handleFeatureAdd_, this), (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(this.features_, (0, $161dd067fe2d672c$export$2e2bcd8739ae039).REMOVE, this.handleFeatureRemove_, this));
            else if (this.source_) keys.push((0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(this.source_, (0, $ccc4e6f11f11978f$export$2e2bcd8739ae039).ADDFEATURE, this.handleFeatureAdd_, this), (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(this.source_, (0, $ccc4e6f11f11978f$export$2e2bcd8739ae039).REMOVEFEATURE, this.handleFeatureRemove_, this));
            for (const feature of features)this.addFeature(feature);
        }
    }
    /**
   * @param {import("../pixel.js").Pixel} pixel Pixel
   * @param {import("../coordinate.js").Coordinate} pixelCoordinate Coordinate
   * @param {import("../Map.js").default} map Map.
   * @return {SnappedInfo|null} Snap result
   */ snapTo(pixel, pixelCoordinate, map) {
        const projection = map.getView().getProjection();
        const projectedCoordinate = (0, $9c4744460e43e41b$export$d4b8ec0b96db1ee2)(pixelCoordinate, projection);
        const box = (0, $9c4744460e43e41b$export$96bfd09e2cffb006)((0, $6da4c8ed3074c92b$export$ab1029bcae9ddb4a)((0, $6da4c8ed3074c92b$export$8aceca7c77505534)([
            projectedCoordinate
        ]), map.getView().getResolution() * this.pixelTolerance_), projection);
        const segments = this.rBush_.getInExtent(box);
        const segmentsLength = segments.length;
        if (segmentsLength === 0) return null;
        let closestVertex;
        let minSquaredDistance = Infinity;
        let closestFeature;
        let closestSegment = null;
        let isIntersection;
        const squaredPixelTolerance = this.pixelTolerance_ * this.pixelTolerance_;
        const getResult = ()=>{
            if (closestVertex) {
                const vertexPixel = map.getPixelFromCoordinate(closestVertex);
                const squaredPixelDistance = (0, $1bd0a226f9a16141$export$88e6ebb4fe54f538)(pixel, vertexPixel);
                if (squaredPixelDistance <= squaredPixelTolerance && (isIntersection && this.intersection_ || !isIntersection && (this.vertex_ || this.edge_))) return {
                    vertex: closestVertex,
                    vertexPixel: [
                        Math.round(vertexPixel[0]),
                        Math.round(vertexPixel[1])
                    ],
                    feature: closestFeature,
                    segment: closestSegment
                };
            }
            return null;
        };
        if (this.vertex_ || this.intersection_) {
            for(let i = 0; i < segmentsLength; ++i){
                const segmentData = segments[i];
                if (segmentData.feature.getGeometry().getType() !== 'Circle') for (const vertex of segmentData.segment){
                    const tempVertexCoord = (0, $9c4744460e43e41b$export$d4b8ec0b96db1ee2)(vertex, projection);
                    const delta = (0, $1bd0a226f9a16141$export$88e6ebb4fe54f538)(projectedCoordinate, tempVertexCoord);
                    if (delta < minSquaredDistance) {
                        closestVertex = vertex;
                        minSquaredDistance = delta;
                        closestFeature = segmentData.feature;
                        isIntersection = segmentData.isIntersection;
                    }
                }
            }
            const result = getResult();
            if (result) return result;
        }
        if (this.edge_) {
            for(let i = 0; i < segmentsLength; ++i){
                let vertex = null;
                const segmentData = segments[i];
                if (segmentData.feature.getGeometry().getType() === 'Circle') {
                    let circleGeometry = segmentData.feature.getGeometry();
                    const userProjection = (0, $9c4744460e43e41b$export$3973b77d5f6f2790)();
                    if (userProjection) circleGeometry = circleGeometry.clone().transform(userProjection, projection);
                    vertex = (0, $1bd0a226f9a16141$export$cbe80a3fcd2b99b7)(projectedCoordinate, /** @type {import("../geom/Circle.js").default} */ circleGeometry);
                } else {
                    const [segmentStart, segmentEnd] = segmentData.segment;
                    // points have only one coordinate
                    if (segmentEnd) {
                        $d4ff3154db04ce79$var$tempSegment[0] = (0, $9c4744460e43e41b$export$d4b8ec0b96db1ee2)(segmentStart, projection);
                        $d4ff3154db04ce79$var$tempSegment[1] = (0, $9c4744460e43e41b$export$d4b8ec0b96db1ee2)(segmentEnd, projection);
                        vertex = (0, $1bd0a226f9a16141$export$18cdd31d17f97131)(projectedCoordinate, $d4ff3154db04ce79$var$tempSegment);
                    }
                }
                if (vertex) {
                    const delta = (0, $1bd0a226f9a16141$export$88e6ebb4fe54f538)(projectedCoordinate, vertex);
                    if (delta < minSquaredDistance) {
                        closestVertex = (0, $9c4744460e43e41b$export$698f563af1ba02a5)(vertex, projection);
                        closestSegment = segmentData.feature.getGeometry().getType() === 'Circle' ? null : segmentData.segment;
                        minSquaredDistance = delta;
                        closestFeature = segmentData.feature;
                    }
                }
            }
            const result = getResult();
            if (result) return result;
        }
        return null;
    }
    /**
   * @param {import("../Feature.js").default} feature Feature
   * @private
   */ updateFeature_(feature) {
        this.removeFeature(feature, false);
        this.addFeature(feature, false);
    }
}
var $d4ff3154db04ce79$export$2e2bcd8739ae039 = $d4ff3154db04ce79$var$Snap;












var $f1q41 = parcelRequire("f1q41");




const $bf32ce3e0d52a0ce$export$d27ee22fcaf69ea8 = new Map([
    [
        (0, $65522956a1f1a049$export$c72f6eaae7b9adff).mouseWheelZoom,
        {
            state: false
        }
    ],
    [
        (0, $65522956a1f1a049$export$c72f6eaae7b9adff).altShiftDragRotate,
        {
            state: true
        }
    ],
    [
        (0, $65522956a1f1a049$export$c72f6eaae7b9adff).dragPan,
        {
            state: true
        }
    ],
    [
        (0, $65522956a1f1a049$export$c72f6eaae7b9adff).keyboardZoom,
        {
            state: true
        }
    ],
    [
        (0, $65522956a1f1a049$export$c72f6eaae7b9adff).keyboardPan,
        {
            state: true
        }
    ],
    [
        (0, $65522956a1f1a049$export$c72f6eaae7b9adff).selectVectorMapShapes,
        {
            state: false
        }
    ],
    [
        (0, $65522956a1f1a049$export$c72f6eaae7b9adff).snapInteraction,
        {
            state: true
        }
    ],
    [
        (0, $65522956a1f1a049$export$c72f6eaae7b9adff).snapHelpLines,
        {
            state: true
        }
    ],
    [
        (0, $65522956a1f1a049$export$c72f6eaae7b9adff).alwaysNewLayers,
        {
            state: false
        }
    ]
]);



const $5547bbb6fff7ebf1$var$FILENAME = 'settings-manager.js';
const $5547bbb6fff7ebf1$var$I18N__BASE = 'managers.settingsManager.settings';
const $5547bbb6fff7ebf1$var$LocalStorageNodeName = (0, $52e25f2a10ab5b5c$export$ada36e8a1c3bc83a).settingsManager;
const $5547bbb6fff7ebf1$var$LocalStorageDefaults = Object.freeze({});
/**
 * About:
 * SettingsManager
 * 
 * Description:
 * Manages all user settings. 
 * The settings can be viewed and updated using the SettingsTool.
 */ class $5547bbb6fff7ebf1$export$3016a1f47b675883 extends (0, $8a2666592e7029ee$export$84777416d052f822) {
    static #localStorage;
    static #settings;
    //--------------------------------------------------------------------
    // # Section: Base Overrides
    //--------------------------------------------------------------------
    static async initAsync(options = {}) {
        (0, $b9b5c0363f244088$export$49b118289be48034).logDebug($5547bbb6fff7ebf1$var$FILENAME, 'initAsync', 'Initialization started');
        this.#localStorage = this.#getBrowserData();
        this.#settings = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep((0, $bf32ce3e0d52a0ce$export$d27ee22fcaf69ea8));
        // Note: 
        // The runtime state must be updated with values from localStorage
        this.#settings.forEach((value, key)=>{
            // Note:
            // Append the i18n data, the actual text for the current language
            // will be fetched when the SettingsModal is created each time
            value.i18nKey = key;
            value.i18nBase = $5547bbb6fff7ebf1$var$I18N__BASE;
            if (key in this.#localStorage) value.state = this.#localStorage[key];
        });
        return new Promise((resolve)=>{
            resolve({
                filename: $5547bbb6fff7ebf1$var$FILENAME,
                result: true
            });
        });
    }
    static setMap(map) {}
    static getName() {
        return $5547bbb6fff7ebf1$var$FILENAME;
    }
    //--------------------------------------------------------------------
    // # Section: Internal
    //--------------------------------------------------------------------
    static #getBrowserData() {
        (0, $b9b5c0363f244088$export$49b118289be48034).logDebug($5547bbb6fff7ebf1$var$FILENAME, 'getBrowserData', 'Loading settings from browser');
        const localStorage = (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).getAndMergeStateObject($5547bbb6fff7ebf1$var$LocalStorageNodeName, $5547bbb6fff7ebf1$var$LocalStorageDefaults);
        return localStorage;
    }
    //--------------------------------------------------------------------
    // # Section: Public API
    //--------------------------------------------------------------------
    static clear() {
        this.#settings = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep((0, $bf32ce3e0d52a0ce$export$d27ee22fcaf69ea8));
    }
    static addSetting(key, valueObj) {
        // Note: 
        // Check if there exists a value already in the browser for this setting
        // Must overwrite the literal value that the tools is adding
        const state = this.#localStorage[key];
        if (state !== undefined) valueObj.state = state;
        (0, $bf32ce3e0d52a0ce$export$d27ee22fcaf69ea8).set(key, (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep(valueObj));
        this.#settings.set(key, valueObj);
    }
    static setSetting(key, state) {
        this.#settings.get(key).state = state;
        this.#localStorage[key] = state;
        (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).setStateObject($5547bbb6fff7ebf1$var$LocalStorageNodeName, this.#localStorage);
    }
    static getSetting(key) {
        return this.#settings.get(key).state;
    }
    static getSettings() {
        return this.#settings;
    }
}






const $9829e24a28f9d958$var$FILENAME = 'snap-manager.js';
const $9829e24a28f9d958$var$PIXEL__TOLERANCE = 10;
const $9829e24a28f9d958$var$ZINDEX__SNAP_LINES_LAYER = 1e9;
const $9829e24a28f9d958$var$STYLE__SNAP_LINE_COLOR = '#EB4542FF';
const $9829e24a28f9d958$var$STYLE__SNAP_LINE_DASH = Object.freeze([
    2,
    5
]);
const $9829e24a28f9d958$var$STYLE__SNAP_LINE_WIDTH = 2.0;
/**
 * About:
 * SnapManager
 * 
 * Description:
 * Manages the Snap interaction. 
 * The Snap interaction can be requested by any tool that uses a Draw function such as the Draw-, Measure- and Scissors tool.
 */ class $9829e24a28f9d958$export$786f0b7d4117ba87 extends (0, $8a2666592e7029ee$export$84777416d052f822) {
    static #map;
    static #tool;
    static #snapLines;
    static #interaction;
    static #onPointerMoveListener;
    //--------------------------------------------------------------------
    // # Section: Base Overrides
    //--------------------------------------------------------------------
    static async initAsync(options = {}) {
        (0, $b9b5c0363f244088$export$49b118289be48034).logDebug($9829e24a28f9d958$var$FILENAME, 'initAsync', 'Initialization started');
        this.#snapLines = this.#createSnapLayer();
        this.#interaction = this.#createInteraction();
        this.#interaction.on((0, $a9807b370eed025c$export$ada873a34909da65).openLayers.snap, this.#onSnap.bind(this));
        this.#interaction.on((0, $a9807b370eed025c$export$ada873a34909da65).openLayers.unSnap, this.#onUnSnap.bind(this));
        return new Promise((resolve)=>{
            resolve({
                filename: $9829e24a28f9d958$var$FILENAME,
                result: true
            });
        });
    }
    static setMap(map) {
        this.#map = map;
    }
    static getName() {
        return $9829e24a28f9d958$var$FILENAME;
    }
    static #createSnapLayer() {
        return new (0, $82a68515bd6ef378$export$2e2bcd8739ae039)({
            zIndex: $9829e24a28f9d958$var$ZINDEX__SNAP_LINES_LAYER,
            source: new (0, $84888e4daf3fdf44$export$2e2bcd8739ae039)(),
            style: new (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)({
                stroke: new (0, $f9d0329c5c745263$export$2e2bcd8739ae039)({
                    color: $9829e24a28f9d958$var$STYLE__SNAP_LINE_COLOR,
                    lineDash: $9829e24a28f9d958$var$STYLE__SNAP_LINE_DASH,
                    width: $9829e24a28f9d958$var$STYLE__SNAP_LINE_WIDTH
                })
            })
        });
    }
    static #createInteraction() {
        const features = (0, $e75fe1c51a3d360c$export$eff87c52915dd7fe).getSnapFeatures();
        return new (0, $d4ff3154db04ce79$export$2e2bcd8739ae039)({
            features: features,
            pixelTolerance: $9829e24a28f9d958$var$PIXEL__TOLERANCE,
            edge: true,
            vertex: true,
            intersection: true
        });
    }
    //--------------------------------------------------------------------
    // # Section: Events
    //--------------------------------------------------------------------
    static #onSnap(event) {
        if (!this.isSnapLine(event.feature)) this.#tool.onSnap(event);
    }
    static #onUnSnap(event) {
        if (!this.isSnapLine(event.feature)) this.#tool.onUnSnap(event);
    }
    static #onPointerMove(event) {
        this.#handleSnapLines(event);
    }
    //--------------------------------------------------------------------
    // # Section: Internal
    //--------------------------------------------------------------------
    static #isSnapEnabled() {
        return (0, $5547bbb6fff7ebf1$export$3016a1f47b675883).getSetting((0, $65522956a1f1a049$export$c72f6eaae7b9adff).snapInteraction);
    }
    static #useSnapHelpLines() {
        return (0, $5547bbb6fff7ebf1$export$3016a1f47b675883).getSetting((0, $65522956a1f1a049$export$c72f6eaae7b9adff).snapHelpLines);
    }
    static #getStraightLinePoint(mouseCoordinate, featureCoordinate, tolerance) {
        const [mX, mY] = mouseCoordinate;
        const [fX, fY] = featureCoordinate;
        const isNearVertical = Math.abs(mX - fX) <= tolerance;
        const isNearHorizontal = Math.abs(mY - fY) <= tolerance;
        if (isNearHorizontal) return [
            mX,
            fY
        ];
        if (isNearVertical) return [
            fX,
            mY
        ];
        return null;
    }
    static #handleSnapLines(event) {
        // TODO:
        // Don't use snap-lines if the mouse has snapped to a feature segment or vertext
        const mouseCoordinates = event.coordinate;
        const trackedFeatures = (0, $e75fe1c51a3d360c$export$eff87c52915dd7fe).getSnapFeatures();
        const tolerance = this.#map.getView().getResolution() * $9829e24a28f9d958$var$PIXEL__TOLERANCE;
        // Note:
        // Remove old snapLines that are not relevant anymore
        this.#cleanSnapLines();
        // Note:
        // Find new vertices that are close to the current mouse location
        const snapSource = this.#snapLines.getSource();
        const snapLinesBuffer = [];
        trackedFeatures.forEach((feature)=>{
            (0, $cb34cfd81f492a36$export$e85341f8480589d)(feature.getGeometry().getCoordinates()).forEach((coordinates)=>{
                const nearestPoint = this.#getStraightLinePoint(mouseCoordinates, coordinates, tolerance);
                if (nearestPoint) {
                    const snapLine = new (0, $9fd014ab6df63665$export$2e2bcd8739ae039)({
                        geometry: new (0, $292e4002746c8223$export$2e2bcd8739ae039)([
                            coordinates,
                            nearestPoint
                        ]),
                        oltb: {
                            type: (0, $60b20182c25e327b$export$2906e7f4b228efe9).type.snapLine
                        }
                    });
                    snapLinesBuffer.push(snapLine);
                }
            });
        });
        snapLinesBuffer.forEach((snapLine)=>{
            snapSource.addFeature(snapLine);
            this.#interaction.addFeature(snapLine);
        });
    }
    static #cleanSnapLines() {
        const snapSource = this.#snapLines.getSource();
        const snapLines = snapSource.getFeatures();
        snapLines.forEach((snapLine)=>{
            this.#interaction.removeFeature(snapLine);
        });
        snapSource.clear();
    }
    //--------------------------------------------------------------------
    // # Section: Public API
    //--------------------------------------------------------------------
    static isSnapLine(feature) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).get(feature.getProperties(), [
            'oltb',
            'type'
        ], undefined) === (0, $60b20182c25e327b$export$2906e7f4b228efe9).type.snapLine;
    }
    static addSnap(tool) {
        const isEnabled = this.#isSnapEnabled();
        const useSnapHelpLines = this.#useSnapHelpLines();
        (0, $b9b5c0363f244088$export$49b118289be48034).logDebug($9829e24a28f9d958$var$FILENAME, 'addSnap', {
            info: 'Snap interaction requested',
            isEnabled: isEnabled,
            useSnapHelpLines: useSnapHelpLines,
            requestedBy: tool.getName()
        });
        if (!isEnabled) return;
        this.#tool = tool;
        this.#map.addInteraction(this.#interaction);
        if (this.#useSnapHelpLines()) {
            this.#map.addLayer(this.#snapLines);
            this.#onPointerMoveListener = this.#map.on((0, $a9807b370eed025c$export$ada873a34909da65).openLayers.pointerMove, this.#onPointerMove.bind(this));
        }
    }
    static removeSnap() {
        this.#tool = undefined;
        this.#map.removeLayer(this.#snapLines);
        this.#map.removeInteraction(this.#interaction);
        this.#cleanSnapLines();
        (0, $1f093ab5083c8a1f$export$b7ef3f8527533384)(this.#onPointerMoveListener);
    }
    static getActivatedBy() {
        return this.#tool;
    }
    static hasActiveTool() {
        return !!this.getActivatedBy();
    }
    static getInteraction() {
        return this.#interaction;
    }
}











const $b8ef36c3e7ea3a5d$var$FILENAME = 'error-manager.js';
const $b8ef36c3e7ea3a5d$var$I18N__BASE = 'managers.errorManager';
/**
 * About:
 * ErrorManager
 * 
 * Description:
 * Manages all uncaught errors.
 */ class $b8ef36c3e7ea3a5d$export$8117257dfd8bd5f2 extends (0, $8a2666592e7029ee$export$84777416d052f822) {
    //--------------------------------------------------------------------
    // # Section: Base Overrides
    //--------------------------------------------------------------------
    static async initAsync(options = {}) {
        (0, $b9b5c0363f244088$export$49b118289be48034).logDebug($b8ef36c3e7ea3a5d$var$FILENAME, 'initAsync', 'Initialization started');
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.error, this.#onError);
        return new Promise((resolve)=>{
            resolve({
                filename: $b8ef36c3e7ea3a5d$var$FILENAME,
                result: true
            });
        });
    }
    static setMap(map) {}
    static getName() {
        return $b8ef36c3e7ea3a5d$var$FILENAME;
    }
    //--------------------------------------------------------------------
    // # Section: Events
    //--------------------------------------------------------------------
    static #onError(error) {
        error.preventDefault();
        // Note: 
        // If the error is thrown before the application has launched
        // The console is always available
        window.console.error(error);
        (0, $b9b5c0363f244088$export$49b118289be48034).logFatal($b8ef36c3e7ea3a5d$var$FILENAME, 'onError', {
            info: 'Global uncaught error',
            error: error.error
        });
        (0, $9051f0e072bf4341$export$8d8dc7d5f743331b).error({
            i18nKey: `${$b8ef36c3e7ea3a5d$var$I18N__BASE}.toasts.errors.uncaughtException`
        });
    }
}











const $5289d96a2eaac637$var$FILENAME = 'tooltip-manager.js';
const $5289d96a2eaac637$var$CLASS__OVERLAY_TOOLTIP = 'oltb-overlay-tooltip';
/**
 * About:
 * TooltipManager
 * 
 * Description:
 * Manages and the creation of Tooltips that follows the mouse. 
 * Examples are coordinates tooltip, measurements etc.
 */ class $5289d96a2eaac637$export$3cf29e47efa41626 extends (0, $8a2666592e7029ee$export$84777416d052f822) {
    static #map;
    static #tooltipOverlay;
    static #onPointerMoveListener;
    static #onMoveEndListerner;
    static #tooltips = {};
    //--------------------------------------------------------------------
    // # Section: Base Overrides
    //--------------------------------------------------------------------
    static async initAsync(options = {}) {
        (0, $b9b5c0363f244088$export$49b118289be48034).logDebug($5289d96a2eaac637$var$FILENAME, 'initAsync', 'Initialization started');
        this.#tooltipOverlay = this.#createTooltipOverlay();
        return new Promise((resolve)=>{
            resolve({
                filename: $5289d96a2eaac637$var$FILENAME,
                result: true
            });
        });
    }
    static setMap(map) {
        this.#map = map;
    }
    static getName() {
        return $5289d96a2eaac637$var$FILENAME;
    }
    //--------------------------------------------------------------------
    // # Section: User Interface
    //--------------------------------------------------------------------
    static #createTooltipOverlay() {
        const overlayOffset = (0, $1e8c0ef90ed82280$export$a33e119b2316dcb7).getConfig().overlayOffset;
        const tooltipElement = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'div',
            class: $5289d96a2eaac637$var$CLASS__OVERLAY_TOOLTIP
        });
        return new (0, $c80d3ed2a84f41ed$export$2e2bcd8739ae039)({
            stopEvent: false,
            element: tooltipElement,
            positioning: 'bottom-center',
            offset: [
                overlayOffset.horizontal,
                overlayOffset.vertical
            ]
        });
    }
    //--------------------------------------------------------------------
    // # Section: Events
    //--------------------------------------------------------------------
    static #onPointerMove(event) {
        this.#tooltipOverlay.setPosition(event.coordinate);
    }
    static #onMoveEnd(event) {
        // TODO:
        // AsIs: Tooltip is still at old location until the mouse is moved
        // ToBe: Calculate the new position of the overlay based on how far the map moved
        this.#tooltipOverlay.setPosition(event.coordinate);
    }
    //--------------------------------------------------------------------
    // # Section: Public API
    //--------------------------------------------------------------------
    static getTooltips() {
        return this.#tooltips;
    }
    static getSize() {
        return Object.keys(this.#tooltips).length;
    }
    static isEmpty() {
        return this.getSize() === 0;
    }
    static getTooltip(key) {
        return this.#tooltips[key];
    }
    static push(key) {
        const tooltipItemElement = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'span',
            class: `${$5289d96a2eaac637$var$CLASS__OVERLAY_TOOLTIP}__item`
        });
        if (this.isEmpty()) {
            this.#map.addOverlay(this.#tooltipOverlay);
            this.#onPointerMoveListener = this.#map.on((0, $a9807b370eed025c$export$ada873a34909da65).openLayers.pointerMove, this.#onPointerMove.bind(this));
            this.#onMoveEndListerner = this.#map.on((0, $a9807b370eed025c$export$ada873a34909da65).openLayers.moveEnd, this.#onMoveEnd.bind(this));
        }
        this.#tooltips[key] = tooltipItemElement;
        this.#tooltipOverlay.getElement().prepend(tooltipItemElement);
        return tooltipItemElement;
    }
    static pop(key) {
        const tooltipItemElement = this.#tooltips[key];
        this.#tooltipOverlay.getElement().removeChild(tooltipItemElement);
        delete this.#tooltips[key];
        if (this.isEmpty()) {
            (0, $1f093ab5083c8a1f$export$b7ef3f8527533384)(this.#onPointerMoveListener);
            (0, $1f093ab5083c8a1f$export$b7ef3f8527533384)(this.#onMoveEndListerner);
            this.#map.removeOverlay(this.#tooltipOverlay);
            this.#tooltipOverlay.setPosition(null);
        }
        return tooltipItemElement;
    }
}









const $67f02e726366aa31$var$FILENAME = 'bootstrap-manager.js';
const $67f02e726366aa31$var$KEY__OL_VERSION = 'ol-version';
const $67f02e726366aa31$var$KEY__OLTB_VERSION = 'oltb-version';
/**
 * About:
 * BootstrapManager
 * 
 * Description:
 * Manages the init process and ensures that all code is executed in the correct order.
 */ class $67f02e726366aa31$export$34222ee0ce4be4c7 extends (0, $8a2666592e7029ee$export$84777416d052f822) {
    static #managers = [];
    //--------------------------------------------------------------------
    // # Section: Base Overrides
    //--------------------------------------------------------------------
    static async initAsync(items = []) {
        (0, $b9b5c0363f244088$export$49b118289be48034).logInformation($67f02e726366aa31$var$FILENAME, 'initAsync', 'Manager initialization started');
        const config = (0, $1e8c0ef90ed82280$export$a33e119b2316dcb7).getConfig();
        const oltbVersion = config.toolbar.version;
        const openLayersVersion = config.openLayers.version;
        window.document.documentElement.setAttribute($67f02e726366aa31$var$KEY__OL_VERSION, openLayersVersion);
        window.document.documentElement.setAttribute($67f02e726366aa31$var$KEY__OLTB_VERSION, oltbVersion);
        (0, $b9b5c0363f244088$export$49b118289be48034).logInformation($67f02e726366aa31$var$FILENAME, 'initAsync', `Running OL version ${openLayersVersion}`);
        (0, $b9b5c0363f244088$export$49b118289be48034).logInformation($67f02e726366aa31$var$FILENAME, 'initAsync', `Running OLTB version ${oltbVersion}`);
        const results = [];
        for (const item of items){
            const manager = item.manager;
            const options = item.options || {};
            this.#managers.push(manager);
            const result = await manager.initAsync(options);
            results.push(result);
        }
        (0, $b9b5c0363f244088$export$49b118289be48034).logInformation($67f02e726366aa31$var$FILENAME, 'initAsync', 'Manager initialization ended');
        (0, $b9b5c0363f244088$export$49b118289be48034).logInformation($67f02e726366aa31$var$FILENAME, 'initAsync', results);
    }
    static setMap(map) {
        (0, $b9b5c0363f244088$export$49b118289be48034).logInformation($67f02e726366aa31$var$FILENAME, 'setMap', 'OL is ready to use');
        this.#managers.forEach((manager)=>{
            manager.setMap(map);
        });
    }
    static getName() {
        return $67f02e726366aa31$var$FILENAME;
    }
    //--------------------------------------------------------------------
    // # Section: Public API
    //--------------------------------------------------------------------
    static ready() {
        (0, $b9b5c0363f244088$export$49b118289be48034).logInformation($67f02e726366aa31$var$FILENAME, 'ready', 'OLTB is ready to use');
        (0, $96903e3f16465932$export$cc74486daaaef499).dispatchEvent([
            window
        ], (0, $a9807b370eed025c$export$ada873a34909da65).custom.ready);
    }
}




var $f1q41 = parcelRequire("f1q41");







const $7cb32231c4f9783a$export$70f9e5bc10d7eac = Object.freeze({
    valueCancel: 'Cancel',
    valueHelp: 'Help',
    valueBackSpace: 'Backspace',
    valueTab: 'Tab',
    valueClear: 'Clear',
    valueEnter: 'Enter',
    valueReturn: 'Enter',
    valueShift: 'Shift',
    valueControl: 'Control',
    valueAlt: 'Alt',
    valueOperatingSystem: 'OS',
    valuePause: 'Pause',
    valueCapsLock: 'CapsLock',
    valueEscape: 'Escape',
    valueSpace: ' ',
    valuePageUp: 'PageUp',
    valuePageDown: 'PageDown',
    valueEnd: 'End',
    valueHome: 'Home',
    valueLeft: 'ArrowLeft',
    valueUp: 'ArrowUp',
    valueRight: 'ArrowRight',
    valueDown: 'ArrowDown',
    valuePrintScreen: 'PrintScreen',
    valueInsert: 'Insert',
    valueDelete: 'Delete',
    value0: '0',
    value1: '1',
    value2: '2',
    value3: '3',
    value4: '4',
    value5: '5',
    value6: '6',
    value7: '7',
    value8: '8',
    value9: '9',
    valueA: 'a',
    valueB: 'b',
    valueC: 'c',
    valueD: 'd',
    valueE: 'e',
    valueF: 'f',
    valueG: 'g',
    valueH: 'h',
    valueI: 'i',
    valueJ: 'j',
    valueK: 'k',
    valueL: 'l',
    valueM: 'm',
    valueN: 'n',
    valueO: 'o',
    valueP: 'p',
    valueQ: 'q',
    valueR: 'r',
    valueS: 's',
    valueT: 't',
    valueU: 'u',
    valueV: 'v',
    valueW: 'w',
    valueX: 'x',
    valueY: 'y',
    valueZ: 'z',
    valueMeta: 'Meta',
    valueLeftCmd: 'Meta',
    valueRightCmd: 'Meta',
    valueContextMenu: 'ContextMenu',
    valueNumpad0: '0',
    valueNumpad1: '1',
    valueNumpad2: '2',
    valueNumpad3: '3',
    valueNumpad4: '4',
    valueNumpad5: '5',
    valueNumpad6: '6',
    valueNumpad7: '7',
    valueNumpad8: '8',
    valueNumpad9: '9',
    valueMultiply: '*',
    valueAdd: '+',
    valueSubtract: '-',
    valueDecimal: '.',
    valueDivide: '/',
    valueF1: 'F1',
    valueF2: 'F2',
    valueF3: 'F3',
    valueF4: 'F4',
    valueF5: 'F5',
    valueF6: 'F6',
    valueF7: 'F7',
    valueF8: 'F8',
    valueF9: 'F9',
    valueF10: 'F10',
    valueF11: 'F11',
    valueF12: 'F12',
    valueF13: 'F13',
    valueF14: 'F14',
    valueF15: 'F15',
    valueF16: 'F16',
    valueF17: 'F17',
    valueF18: 'F18',
    valueF19: 'F19',
    valueF20: 'F20',
    valueF21: 'F21',
    valueF22: 'F22',
    valueF23: 'F23',
    valueF24: 'F24',
    valueNumLock: 'NumLock',
    valueScrollLock: 'ScrollLock',
    valueSemicolon: ',',
    valueEquals: '=',
    valueComma: ',',
    valueDash: '-',
    valuePeriod: '.',
    valueSlash: '/',
    valueBackQuote: '`',
    valueOpenBracket: '[',
    valueBackSlash: '\\',
    valueCloseBracket: ']',
    valueQuote: "'"
});


const $2c00c14ef3ff796f$export$bec45a54c2e66c22 = function(event) {
    const isTabKey = event.key === (0, $7cb32231c4f9783a$export$70f9e5bc10d7eac).valueTab;
    if (!isTabKey) return;
    const elements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
    const uiRefFirstElement = this.querySelectorAll(elements)[0];
    const uiRefContent = this.querySelectorAll(elements);
    const uiRefLastElement = uiRefContent[uiRefContent.length - 1];
    if (event.shiftKey) {
        if (window.document.activeElement === uiRefFirstElement) {
            uiRefLastElement.focus();
            event.preventDefault();
        }
    } else if (window.document.activeElement === uiRefLastElement) {
        uiRefFirstElement.focus();
        event.preventDefault();
    }
};












var $f1q41 = parcelRequire("f1q41");



var $f1q41 = parcelRequire("f1q41");






const $b12cc913018885a9$var$FILENAME = 'base-modal.js';
const $b12cc913018885a9$var$CLASS__ANIMATION = 'oltb-animation';
const $b12cc913018885a9$var$CLASS__ANIMATION_BOUNCE = `${$b12cc913018885a9$var$CLASS__ANIMATION}--bounce`;
const $b12cc913018885a9$var$CLASS__MODAL = 'oltb-modal';
const $b12cc913018885a9$var$CLASS__MODAL_BACKDROP = `${$b12cc913018885a9$var$CLASS__MODAL}-backdrop`;
const $b12cc913018885a9$var$DefaultOptions = Object.freeze({
    title: 'Modal',
    maximized: false,
    pushWidth: false,
    content: undefined,
    onClose: undefined
});
class $b12cc913018885a9$export$a703eb468fcf7e69 {
    #filename = $b12cc913018885a9$var$FILENAME;
    constructor(options = {}){
        this.options = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep($b12cc913018885a9$var$DefaultOptions), options);
        if (options.filename) this.#filename = options.filename;
        this.#createModal();
    }
    #createModal() {
        this.backdrop = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'div',
            class: `${$b12cc913018885a9$var$CLASS__MODAL_BACKDROP} ${$b12cc913018885a9$var$CLASS__MODAL_BACKDROP}--fixed`,
            attributes: {
                'tabindex': '-1'
            },
            listeners: {
                'click': this.#bounceAnimation.bind(this),
                'keydown': (0, $2c00c14ef3ff796f$export$bec45a54c2e66c22)
            }
        });
        this.modal = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'div',
            class: `${$b12cc913018885a9$var$CLASS__MODAL} ${this.options.maximized ? `${$b12cc913018885a9$var$CLASS__MODAL}--maximized` : ''} ${this.options.pushWidth ? `${$b12cc913018885a9$var$CLASS__MODAL}--push-width` : ''} ${$b12cc913018885a9$var$CLASS__ANIMATION} ${$b12cc913018885a9$var$CLASS__ANIMATION_BOUNCE}`
        });
        this.modalContent = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'div',
            class: `${$b12cc913018885a9$var$CLASS__MODAL}__content`
        });
        const modalHeader = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'div',
            class: `${$b12cc913018885a9$var$CLASS__MODAL}__header`
        });
        const modalTitle = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'h2',
            html: this.options.title,
            class: `${$b12cc913018885a9$var$CLASS__MODAL}__title`
        });
        const modalClose = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'button',
            html: (0, $dcff5ab966a6537f$export$a297fe855adfd36c)({
                path: (0, $35649bc6579784f8$export$3fddabec91763a6e).close.stroked,
                fill: 'none',
                stroke: 'currentColor',
                strokeWidth: 1
            }),
            class: `${$b12cc913018885a9$var$CLASS__MODAL}__close oltb-btn oltb-btn--blank`,
            attributes: {
                'type': 'button'
            },
            listeners: {
                'click': this.close.bind(this)
            }
        });
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(modalHeader, [
            modalTitle,
            modalClose
        ]);
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(this.modal, [
            modalHeader,
            this.modalContent
        ]);
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(this.backdrop, [
            this.modal
        ]);
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.keyUp, this.#onWindowKeyUp.bind(this));
        this.buttons = [
            modalClose
        ];
        if (this.options.content) this.show(this.options.content);
    }
    #isBackdropClicked(event) {
        return event.target === this.backdrop;
    }
    #bounceAnimation(event) {
        if (!this.#isBackdropClicked(event)) return;
        const modal = this.backdrop.firstElementChild;
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).runAnimation(modal, $b12cc913018885a9$var$CLASS__ANIMATION_BOUNCE);
    }
    //--------------------------------------------------------------------
    // # Section: Events
    //--------------------------------------------------------------------
    #onWindowKeyUp(event) {
        if (event.key === (0, $7cb32231c4f9783a$export$70f9e5bc10d7eac).valueEscape) this.close();
    }
    //--------------------------------------------------------------------
    // # Section: Base Methods
    //--------------------------------------------------------------------
    getName() {
        return this.#filename;
    }
    //--------------------------------------------------------------------
    // # Section: Public API
    //--------------------------------------------------------------------
    getTitle() {
        return this.options.title;
    }
    getContent() {
        return this.options.content;
    }
    getOnClose() {
        return this.options.onClose;
    }
    isMaximized() {
        return this.options.maximized;
    }
    show(content) {
        this.options.content = content;
        if (typeof content === 'string') this.modalContent.innerHTML = content;
        else (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(this.modalContent, [
            content
        ]);
        const uiRefMapElement = (0, $8f42450ebdd44f5e$export$8e7188a60a5bbe16).getMapElement();
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(uiRefMapElement, [
            this.backdrop
        ]);
        this.backdrop.focus();
    }
    close() {
        this.backdrop.removeEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.keyDown, (0, $2c00c14ef3ff796f$export$bec45a54c2e66c22));
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).removeElement(this.backdrop);
        // Note: 
        // @Consumer callback
        if (this.options.onClose) this.options.onClose();
    }
}



const $c63f096e37f334a4$export$5a63ccfbe4d87ef0 = function() {
    return window.document.body.classList.contains((0, $1e8c0ef90ed82280$export$a33e119b2316dcb7).getConfig().className.dark);
};



var $f1q41 = parcelRequire("f1q41");

const $b40309f6a4fce6ca$var$DefaultOptions = Object.freeze({
    idPrefix: '',
    idPostfix: '',
    text: '',
    value: '',
    placeholder: ''
});
const $b40309f6a4fce6ca$export$b9bff34c3ca2042f = function(options = {}) {
    options = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep($b40309f6a4fce6ca$var$DefaultOptions), options);
    const wrapper = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
        element: 'div',
        class: 'oltb-mt-0625'
    });
    const label = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
        element: 'label',
        text: options.text,
        class: 'oltb-label',
        attributes: {
            'for': `${options.idPrefix}${options.idPostfix}`
        }
    });
    const input = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
        element: 'input',
        id: `${options.idPrefix}${options.idPostfix}`,
        class: 'oltb-input',
        value: options.value,
        attributes: {
            'type': 'text',
            'placeholder': options.placeholder
        }
    });
    (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(wrapper, [
        label,
        input
    ]);
    return [
        wrapper,
        input
    ];
};



var $f1q41 = parcelRequire("f1q41");

const $8b36a4c9059be7ba$var$DefaultOptions = Object.freeze({
    idPrefix: '',
    idPostfix: '',
    text: '',
    options: [],
    value: undefined
});
const $8b36a4c9059be7ba$export$af1822d79ba4bb67 = function(options = {}) {
    options = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep($8b36a4c9059be7ba$var$DefaultOptions), options);
    const wrapper = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
        element: 'div',
        class: 'oltb-mt-0625'
    });
    const label = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
        element: 'label',
        text: options.text,
        class: 'oltb-label',
        attributes: {
            'for': `${options.idPrefix}${options.idPostfix}`
        }
    });
    const select = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
        element: 'select',
        id: `${options.idPrefix}${options.idPostfix}`,
        class: 'oltb-select'
    });
    options.options.forEach((item)=>{
        const option = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'option',
            text: item.text,
            value: item.value
        });
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(select, [
            option
        ]);
    });
    if (options.value) select.value = options.value;
    else if (options.options.length > 0) select.value = options.options[0].value;
    else select.value = '';
    (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(wrapper, [
        label,
        select
    ]);
    return [
        wrapper,
        select
    ];
};



var $f1q41 = parcelRequire("f1q41");

const $2bfc5da7dabc448d$var$CLASS__COLOR_INPUT = 'oltb-color-input';
const $2bfc5da7dabc448d$var$DefaultOptions = Object.freeze({
    idPrefix: '',
    idPostfix: '',
    text: '',
    color: ''
});
const $2bfc5da7dabc448d$export$611cd489655225dd = function(options = {}) {
    options = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep($2bfc5da7dabc448d$var$DefaultOptions), options);
    const wrapper = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
        element: 'div',
        class: 'oltb-mt-0625'
    });
    const label = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
        element: 'label',
        text: options.text,
        class: 'oltb-label',
        attributes: {
            'for': `${options.idPrefix}${options.idPostfix}`
        }
    });
    const input = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
        element: 'div',
        id: `${options.idPrefix}${options.idPostfix}`,
        class: `${$2bfc5da7dabc448d$var$CLASS__COLOR_INPUT} oltb-color-tippy`,
        attributes: {
            'tabindex': 0,
            'data-oltb-color-target': `#${options.idPrefix}${options.idPostfix}`,
            'data-oltb-color': options.color
        }
    });
    const inputInner = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
        element: 'div',
        class: `${$2bfc5da7dabc448d$var$CLASS__COLOR_INPUT}__inner`,
        style: {
            'background-color': `${options.color}`
        }
    });
    (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(input, [
        inputInner
    ]);
    (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(wrapper, [
        label,
        input
    ]);
    return [
        wrapper,
        input
    ];
};



const $c2db87d7a7fbc353$var$FILENAME = 'icon-marker-modal.js';
const $c2db87d7a7fbc353$var$ID__PREFIX = 'oltb-marker-modal-marker';
const $c2db87d7a7fbc353$var$I18N__BASE = 'modalExtensions.iconMarkerModal';
// Note:
// Only specify the unique options to this class
// Things to override on the BaseModal is passed directly
const $c2db87d7a7fbc353$var$DefaultOptions = Object.freeze({
    edit: false,
    coordinates: [
        0,
        0
    ],
    title: 'Marker',
    description: '',
    marker: Object.freeze({
        fill: '#0166A5FF',
        stroke: '#0166A566'
    }),
    icon: Object.freeze({
        key: 'geoPin.filled',
        fill: '#FFFFFFFF',
        stroke: '#FFFFFFFF'
    }),
    label: Object.freeze({
        text: 'Marker',
        fill: '#FFFFFF',
        stroke: '#3B4352CC',
        strokeWidth: 8
    }),
    maxLabelStrokeWidth: 24,
    onCreate: undefined,
    onCancel: undefined
});
/**
 * About:
 * Manager that handles creation of Icon-Markers
 */ class $c2db87d7a7fbc353$export$f4e5ae623d7eeeb5 extends (0, $b12cc913018885a9$export$a703eb468fcf7e69) {
    #buttons = [];
    constructor(options = {}){
        super({
            filename: $c2db87d7a7fbc353$var$FILENAME,
            title: (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get(`${$c2db87d7a7fbc353$var$I18N__BASE}.title`),
            ...options
        });
        this.options = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep($c2db87d7a7fbc353$var$DefaultOptions), options);
        this.#createModalContent();
    }
    //--------------------------------------------------------------------
    // # Section: Overridden
    //--------------------------------------------------------------------
    getName() {
        return super.getName();
    }
    //--------------------------------------------------------------------
    // # Section: User Interface
    //--------------------------------------------------------------------
    #createModalContent() {
        const i18n = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get(`${$c2db87d7a7fbc353$var$I18N__BASE}.form`);
        const [titleWrapper, titleInput] = (0, $b40309f6a4fce6ca$export$b9bff34c3ca2042f)({
            idPrefix: $c2db87d7a7fbc353$var$ID__PREFIX,
            idPostfix: '-title',
            text: i18n.title,
            value: this.options.title
        });
        const [descriptionWrapper, descriptionInput] = (0, $b40309f6a4fce6ca$export$b9bff34c3ca2042f)({
            idPrefix: $c2db87d7a7fbc353$var$ID__PREFIX,
            idPostfix: '-description',
            text: i18n.description,
            value: this.options.description
        });
        const [latWrapper, latInput] = (0, $b40309f6a4fce6ca$export$b9bff34c3ca2042f)({
            idPrefix: $c2db87d7a7fbc353$var$ID__PREFIX,
            idPostfix: '-lat',
            text: i18n.latitude,
            value: this.options.coordinates[1]
        });
        const [lonWrapper, lonInput] = (0, $b40309f6a4fce6ca$export$b9bff34c3ca2042f)({
            idPrefix: $c2db87d7a7fbc353$var$ID__PREFIX,
            idPostfix: '-lon',
            text: i18n.longitude,
            value: this.options.coordinates[0]
        });
        const markerColorGroup = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'div',
            class: 'oltb-group'
        });
        const [markerFillWrapper, markerFillInput] = (0, $2bfc5da7dabc448d$export$611cd489655225dd)({
            idPrefix: $c2db87d7a7fbc353$var$ID__PREFIX,
            idPostfix: '-marker-fill',
            text: i18n.markerFill,
            color: this.options.marker.fill
        });
        const [markerStrokeWrapper, markerStrokeInput] = (0, $2bfc5da7dabc448d$export$611cd489655225dd)({
            idPrefix: $c2db87d7a7fbc353$var$ID__PREFIX,
            idPostfix: '-marker-stroke',
            text: i18n.markerStroke,
            color: this.options.marker.stroke
        });
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(markerColorGroup, [
            markerFillWrapper,
            markerStrokeWrapper
        ]);
        const iconOptions = [];
        for(const path in 0, $35649bc6579784f8$export$3fddabec91763a6e)for(const version in (0, $35649bc6579784f8$export$3fddabec91763a6e)[path])iconOptions.push({
            text: `${path.capitalize()} | ${version}`,
            value: `${path}.${version}`
        });
        const [iconWrapper, iconSelect] = (0, $8b36a4c9059be7ba$export$af1822d79ba4bb67)({
            idPrefix: $c2db87d7a7fbc353$var$ID__PREFIX,
            idPostfix: '-icon',
            text: i18n.icon,
            options: iconOptions,
            value: this.options.icon.key
        });
        const iconColorGroup = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'div',
            class: 'oltb-group'
        });
        const [iconFillWrapper, iconFillInput] = (0, $2bfc5da7dabc448d$export$611cd489655225dd)({
            idPrefix: $c2db87d7a7fbc353$var$ID__PREFIX,
            idPostfix: '-icon-fill',
            text: i18n.iconFill,
            color: this.options.icon.fill
        });
        const [iconStrokeWrapper, iconStrokeInput] = (0, $2bfc5da7dabc448d$export$611cd489655225dd)({
            idPrefix: $c2db87d7a7fbc353$var$ID__PREFIX,
            idPostfix: '-icon-stroke',
            text: i18n.iconStroke,
            color: this.options.icon.stroke
        });
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(iconColorGroup, [
            iconFillWrapper,
            iconStrokeWrapper
        ]);
        const [labelWrapper, labelInput] = (0, $b40309f6a4fce6ca$export$b9bff34c3ca2042f)({
            idPrefix: $c2db87d7a7fbc353$var$ID__PREFIX,
            idPostfix: '-label',
            text: i18n.label,
            value: this.options.label.text
        });
        const labelColorGroup = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'div',
            class: 'oltb-group'
        });
        const [labelFillWrapper, labelFillInput] = (0, $2bfc5da7dabc448d$export$611cd489655225dd)({
            idPrefix: $c2db87d7a7fbc353$var$ID__PREFIX,
            idPostfix: '-label-fill',
            text: i18n.labelFill,
            color: this.options.label.fill
        });
        const [labelStrokeWrapper, labelStrokeInput] = (0, $2bfc5da7dabc448d$export$611cd489655225dd)({
            idPrefix: $c2db87d7a7fbc353$var$ID__PREFIX,
            idPostfix: '-label-stroke',
            text: i18n.labelStroke,
            color: this.options.label.stroke
        });
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(labelColorGroup, [
            labelFillWrapper,
            labelStrokeWrapper
        ]);
        const widthOptions = [];
        for(let i = 1; i <= this.options.maxLabelStrokeWidth; i++)widthOptions.push({
            text: i,
            value: i
        });
        const [labelStrokeWidthWrapper, labelStrokeWidthSelect] = (0, $8b36a4c9059be7ba$export$af1822d79ba4bb67)({
            idPrefix: $c2db87d7a7fbc353$var$ID__PREFIX,
            idPostfix: '-label-stroke-width',
            text: i18n.labelStrokeWidth,
            options: widthOptions,
            value: this.options.label.strokeWidth
        });
        const buttonsWrapper = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'div',
            class: 'oltb-d-flex oltb-justify-content-between oltb-mt-15'
        });
        const createButton = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'button',
            text: `${this.options.edit ? i18n.saveChanges : i18n.createMarker}`,
            class: 'oltb-dialog__btn oltb-btn oltb-btn--green-mid',
            attributes: {
                'type': 'button'
            },
            listeners: {
                'click': ()=>{
                    this.#onCreate({
                        latitude: parseFloat(latInput.value.trim()),
                        longitude: parseFloat(lonInput.value.trim()),
                        title: titleInput.value.trim(),
                        description: descriptionInput.value.trim(),
                        icon: iconSelect.value.trim(),
                        iconFill: iconFillInput.getAttribute('data-oltb-color'),
                        iconStroke: iconStrokeInput.getAttribute('data-oltb-color'),
                        markerFill: markerFillInput.getAttribute('data-oltb-color'),
                        markerStroke: markerStrokeInput.getAttribute('data-oltb-color'),
                        label: labelInput.value.trim(),
                        labelFill: labelFillInput.getAttribute('data-oltb-color'),
                        labelStroke: labelStrokeInput.getAttribute('data-oltb-color'),
                        labelStrokeWidth: labelStrokeWidthSelect.value.trim()
                    });
                }
            }
        });
        const cancelButton = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'button',
            text: i18n.cancel,
            class: `oltb-dialog__btn oltb-btn ${(0, $c63f096e37f334a4$export$5a63ccfbe4d87ef0)() ? 'oltb-btn--gray-mid' : 'oltb-btn--gray-dark'}`,
            attributes: {
                'type': 'button'
            },
            listeners: {
                'click': this.#onCancel.bind(this)
            }
        });
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(buttonsWrapper, [
            cancelButton,
            createButton
        ]);
        const modalContent = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'div',
            class: 'oltb-modal__content'
        });
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(modalContent, [
            titleWrapper,
            descriptionWrapper,
            latWrapper,
            lonWrapper,
            markerColorGroup,
            iconWrapper,
            iconColorGroup,
            labelWrapper,
            labelColorGroup,
            labelStrokeWidthWrapper,
            buttonsWrapper
        ]);
        this.#buttons = [
            cancelButton,
            createButton
        ];
        this.show(modalContent);
    }
    //--------------------------------------------------------------------
    // # Section: Events
    //--------------------------------------------------------------------
    #onCreate(result) {
        this.close();
        this.options.onCreate && this.options.onCreate(result);
    }
    #onCancel() {
        this.close();
        this.options.onCancel && this.options.onCancel();
    }
    //--------------------------------------------------------------------
    // # Section: Public API
    //--------------------------------------------------------------------
    getButtons() {
        return this.#buttons;
    }
}



const $1f2b3634eb149f4d$var$ID__PREFIX_INFO_WINDOW = 'oltb-info-window-marker';
const $1f2b3634eb149f4d$var$CLASS__FUNC_BUTTON = 'oltb-func-btn';
const $1f2b3634eb149f4d$var$I18N__BASE_COMMON = 'commons';
const $1f2b3634eb149f4d$export$15c57b05db5d9d69 = function(InfoWindowManager, beforeMarker) {
    const oltb = (0, $0a57fad3299da03c$export$ac4f8128ea29c5).toolbar.id;
    const properties = beforeMarker.get(oltb);
    const projection = (0, $1e8c0ef90ed82280$export$a33e119b2316dcb7).getConfig().projection;
    return new (0, $c2db87d7a7fbc353$export$f4e5ae623d7eeeb5)({
        edit: true,
        coordinates: (0, $9c4744460e43e41b$export$51186ad6e864892a)(beforeMarker.getGeometry().getCoordinates(), projection.default, projection.wgs84),
        title: properties.title,
        description: properties.description,
        marker: {
            fill: properties.marker.fill,
            stroke: properties.marker.stroke
        },
        icon: {
            key: properties.icon.key,
            fill: properties.icon.fill,
            stroke: properties.icon.stroke
        },
        label: {
            text: properties.label.text,
            fill: properties.label.fill,
            stroke: properties.label.stroke,
            strokeWidth: properties.label.strokeWidth
        },
        onCreate: (result)=>{
            $1f2b3634eb149f4d$var$onEditMarker(InfoWindowManager, beforeMarker, result);
        }
    });
};
const $1f2b3634eb149f4d$var$addMarkerToMap = function(marker) {
    const layerWrapper = (0, $e75fe1c51a3d360c$export$eff87c52915dd7fe).getActiveFeatureLayer({
        fallback: 'Markers'
    });
    layerWrapper.getLayer().getSource().addFeature(marker);
};
const $1f2b3634eb149f4d$var$onEditMarker = function(InfoWindowManager, beforeMarker, result) {
    InfoWindowManager.hideOverlay();
    // Note: 
    // Remove old marker and add new
    // Easier then updating the existing marker with new data.
    (0, $e75fe1c51a3d360c$export$eff87c52915dd7fe).removeFeatureFromFeatureLayers(beforeMarker);
    const i18n = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get(`${$1f2b3634eb149f4d$var$I18N__BASE_COMMON}.titles`);
    const coordinates = [
        result.longitude,
        result.latitude
    ];
    const prettyCoordinates = (0, $1bd0a226f9a16141$export$c883fd238161f841)(coordinates);
    const infoWindow = {
        title: result.title,
        content: `
            <p>${result.description}</p>
        `,
        footer: `
            <span class="oltb-info-window__coordinates">${prettyCoordinates}</span>
            <div class="oltb-info-window__buttons-wrapper">
                <button class="${$1f2b3634eb149f4d$var$CLASS__FUNC_BUTTON} ${$1f2b3634eb149f4d$var$CLASS__FUNC_BUTTON}--delete oltb-tippy" data-oltb-i18n="${$1f2b3634eb149f4d$var$I18N__BASE_COMMON}.titles.delete" title="${i18n.delete}" id="${$1f2b3634eb149f4d$var$ID__PREFIX_INFO_WINDOW}-remove"></button>
                <button class="${$1f2b3634eb149f4d$var$CLASS__FUNC_BUTTON} ${$1f2b3634eb149f4d$var$CLASS__FUNC_BUTTON}--crosshair oltb-tippy" data-oltb-i18n="${$1f2b3634eb149f4d$var$I18N__BASE_COMMON}.titles.copyCoordinates" title="${i18n.copyCoordinates}" id="${$1f2b3634eb149f4d$var$ID__PREFIX_INFO_WINDOW}-copy-coordinates" data-oltb-coordinates="${prettyCoordinates}"></button>
                <button class="${$1f2b3634eb149f4d$var$CLASS__FUNC_BUTTON} ${$1f2b3634eb149f4d$var$CLASS__FUNC_BUTTON}--copy oltb-tippy" data-oltb-i18n="${$1f2b3634eb149f4d$var$I18N__BASE_COMMON}.titles.copyText" title="${i18n.copyText}" id="${$1f2b3634eb149f4d$var$ID__PREFIX_INFO_WINDOW}-copy-text" data-oltb-copy="${result.title} ${result.description}"></button>
                <button class="${$1f2b3634eb149f4d$var$CLASS__FUNC_BUTTON} ${$1f2b3634eb149f4d$var$CLASS__FUNC_BUTTON}--edit oltb-tippy" data-oltb-i18n="${$1f2b3634eb149f4d$var$I18N__BASE_COMMON}.titles.edit" title="${i18n.edit}" id="${$1f2b3634eb149f4d$var$ID__PREFIX_INFO_WINDOW}-edit"></button>
                <button class="${$1f2b3634eb149f4d$var$CLASS__FUNC_BUTTON} ${$1f2b3634eb149f4d$var$CLASS__FUNC_BUTTON}--layer oltb-tippy" data-oltb-i18n="${$1f2b3634eb149f4d$var$I18N__BASE_COMMON}.titles.showLayer" title="${i18n.showLayer}" id="${$1f2b3634eb149f4d$var$ID__PREFIX_INFO_WINDOW}-show-layer"></button>
            </div>
        `
    };
    const afterMarker = (0, $45f5d1a81c4ed6cb$export$73e78dff44a347ad).generateIconMarker({
        lon: coordinates[0],
        lat: coordinates[1],
        title: result.title,
        description: result.description,
        infoWindow: infoWindow,
        marker: {
            fill: result.markerFill,
            stroke: result.markerStroke
        },
        icon: {
            key: result.icon,
            fill: result.iconFill,
            stroke: result.iconStroke
        },
        label: {
            text: result.label,
            fill: result.labelFill,
            stroke: result.labelStroke,
            strokeWidth: result.labelStrokeWidth
        }
    });
    $1f2b3634eb149f4d$var$addMarkerToMap(afterMarker);
    (0, $96903e3f16465932$export$cc74486daaaef499).dispatchCustomEvent([
        window
    ], (0, $a9807b370eed025c$export$ada873a34909da65).custom.featureEdited, {
        detail: {
            before: beforeMarker,
            after: afterMarker
        }
    });
};





var $f1q41 = parcelRequire("f1q41");





const $6f290307a15ad0a3$var$CLASS__ANIMATION = 'oltb-animation';
const $6f290307a15ad0a3$var$CLASS__ANIMATION_BOUNCE = `${$6f290307a15ad0a3$var$CLASS__ANIMATION}--bounce`;
const $6f290307a15ad0a3$var$CLASS__DIALOG_BACKDROP = 'oltb-dialog-backdrop';
class $6f290307a15ad0a3$export$a0609e4d602995aa {
    constructor(){
        this.backdrop = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'div',
            class: `${$6f290307a15ad0a3$var$CLASS__DIALOG_BACKDROP} ${$6f290307a15ad0a3$var$CLASS__DIALOG_BACKDROP}--fixed`,
            attributes: {
                'tabindex': '-1'
            },
            listeners: {
                'click': this.#bounceAnimation.bind(this),
                'keydown': (0, $2c00c14ef3ff796f$export$bec45a54c2e66c22)
            }
        });
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.keyUp, this.#onWindowKeyUp.bind(this));
    }
    #isBackdropClicked(event) {
        return event.target === this.backdrop;
    }
    #bounceAnimation(event) {
        if (!this.#isBackdropClicked(event)) return;
        const dialog = this.backdrop.firstElementChild;
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).runAnimation(dialog, $6f290307a15ad0a3$var$CLASS__ANIMATION_BOUNCE);
    }
    //--------------------------------------------------------------------
    // # Section: Events
    //--------------------------------------------------------------------
    #onWindowKeyUp(event) {
        if (event.key === (0, $7cb32231c4f9783a$export$70f9e5bc10d7eac).valueEscape) this.close();
    }
    //--------------------------------------------------------------------
    // # Section: Public API
    //--------------------------------------------------------------------
    close() {
        this.backdrop.removeEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.keyDown, (0, $2c00c14ef3ff796f$export$bec45a54c2e66c22));
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).removeElement(this.backdrop);
    }
}



const $f675a9190bfd0236$var$CLASS__DIALOG = 'oltb-dialog';
const $f675a9190bfd0236$var$CLASS__DIALOG_TYPE = `${$f675a9190bfd0236$var$CLASS__DIALOG}--alert`;
const $f675a9190bfd0236$var$CLASS__ANIMATION = 'oltb-animation';
const $f675a9190bfd0236$var$CLASS__ANIMATION_BOUNCE = `${$f675a9190bfd0236$var$CLASS__ANIMATION}--bounce`;
const $f675a9190bfd0236$var$DefaultOptions = Object.freeze({
    title: 'Alert',
    message: '',
    confirmText: 'Ok',
    onConfirm: undefined
});
class $f675a9190bfd0236$export$de466dd8317b0b75 extends (0, $6f290307a15ad0a3$export$a0609e4d602995aa) {
    constructor(options = {}){
        super();
        this.options = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep($f675a9190bfd0236$var$DefaultOptions), options);
        this.#createDialog();
    }
    #createDialog() {
        const dialog = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'div',
            class: `${$f675a9190bfd0236$var$CLASS__DIALOG} ${$f675a9190bfd0236$var$CLASS__DIALOG_TYPE} ${$f675a9190bfd0236$var$CLASS__ANIMATION} ${$f675a9190bfd0236$var$CLASS__ANIMATION_BOUNCE}`
        });
        const title = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'h2',
            class: `${$f675a9190bfd0236$var$CLASS__DIALOG}__title`,
            text: this.options.title
        });
        const message = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'p',
            class: `${$f675a9190bfd0236$var$CLASS__DIALOG}__message`,
            html: this.options.message
        });
        const buttonWrapper = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'div',
            class: `${$f675a9190bfd0236$var$CLASS__DIALOG}__buttons-wrapper`
        });
        const okButton = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'button',
            text: this.options.confirmText,
            class: `${$f675a9190bfd0236$var$CLASS__DIALOG}__btn oltb-btn oltb-btn--blue-mid`,
            attributes: {
                'type': 'button'
            },
            listeners: {
                'click': this.#onConfirm.bind(this)
            }
        });
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(buttonWrapper, [
            okButton
        ]);
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(dialog, [
            title,
            message,
            buttonWrapper
        ]);
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(this.backdrop, [
            dialog
        ]);
        const uiRefMapElement = (0, $8f42450ebdd44f5e$export$8e7188a60a5bbe16).getMapElement();
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(uiRefMapElement, [
            this.backdrop
        ]);
        this.buttons = [
            okButton
        ];
        this.backdrop.focus();
    }
    //--------------------------------------------------------------------
    // # Section: Events
    //--------------------------------------------------------------------
    #onConfirm() {
        this.close();
        this.options.onConfirm && this.options.onConfirm();
    }
    //--------------------------------------------------------------------
    // # Section: Public API
    //--------------------------------------------------------------------
    getClassType() {
        return $f675a9190bfd0236$var$CLASS__DIALOG_TYPE;
    }
}



var $f1q41 = parcelRequire("f1q41");




const $c42ddd4eedb1ba0e$var$CLASS__DIALOG = 'oltb-dialog';
const $c42ddd4eedb1ba0e$var$CLASS__DIALOG_TYPE = `${$c42ddd4eedb1ba0e$var$CLASS__DIALOG}--prompt`;
const $c42ddd4eedb1ba0e$var$CLASS__ANIMATION = 'oltb-animation';
const $c42ddd4eedb1ba0e$var$CLASS__ANIMATION_BOUNCE = `${$c42ddd4eedb1ba0e$var$CLASS__ANIMATION}--bounce`;
const $c42ddd4eedb1ba0e$var$DefaultOptions = Object.freeze({
    title: 'Prompt',
    message: '',
    placeholder: undefined,
    value: undefined,
    confirmClass: 'oltb-btn--green-mid',
    confirmText: 'Confirm',
    cancelText: 'Cancel',
    onConfirm: undefined,
    onCancel: undefined,
    onInput: undefined
});
class $c42ddd4eedb1ba0e$export$a551a871839880f9 extends (0, $6f290307a15ad0a3$export$a0609e4d602995aa) {
    constructor(options = {}){
        super();
        this.options = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep($c42ddd4eedb1ba0e$var$DefaultOptions), options);
        this.#createDialog();
    }
    #isValid(value) {
        return value !== undefined && value !== null;
    }
    #createDialog() {
        const dialog = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'div',
            class: `${$c42ddd4eedb1ba0e$var$CLASS__DIALOG} ${$c42ddd4eedb1ba0e$var$CLASS__DIALOG_TYPE} ${$c42ddd4eedb1ba0e$var$CLASS__ANIMATION} ${$c42ddd4eedb1ba0e$var$CLASS__ANIMATION_BOUNCE}`
        });
        const title = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'h2',
            class: `${$c42ddd4eedb1ba0e$var$CLASS__DIALOG}__title`,
            text: this.options.title
        });
        const message = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'p',
            class: `${$c42ddd4eedb1ba0e$var$CLASS__DIALOG}__message`,
            html: this.options.message
        });
        const input = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'input',
            class: `${$c42ddd4eedb1ba0e$var$CLASS__DIALOG}__input oltb-input`,
            attributes: {
                'type': 'text'
            },
            listeners: {
                'input': ()=>{
                    this.#onInput(input);
                }
            }
        });
        if (this.#isValid(this.options.placeholder)) input.setAttribute('placeholder', this.options.placeholder);
        if (this.#isValid(this.options.value)) input.value = this.options.value;
        const buttonWrapper = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'div',
            class: `${$c42ddd4eedb1ba0e$var$CLASS__DIALOG}__buttons-wrapper`
        });
        const confirmButton = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'button',
            text: this.options.confirmText,
            class: `${$c42ddd4eedb1ba0e$var$CLASS__DIALOG}__btn oltb-btn ${this.options.confirmClass}`,
            attributes: {
                'type': 'button'
            },
            listeners: {
                'click': this.#onConfirm.bind(this, input)
            }
        });
        const cancelButton = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'button',
            text: this.options.cancelText,
            class: `${$c42ddd4eedb1ba0e$var$CLASS__DIALOG}__btn oltb-btn ${(0, $c63f096e37f334a4$export$5a63ccfbe4d87ef0)() ? 'oltb-btn--gray-mid' : 'oltb-btn--gray-dark'}`,
            attributes: {
                'type': 'button'
            },
            listeners: {
                'click': this.#onCancel.bind(this)
            }
        });
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(buttonWrapper, [
            cancelButton,
            confirmButton
        ]);
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(dialog, [
            title,
            message,
            input,
            buttonWrapper
        ]);
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(this.backdrop, [
            dialog
        ]);
        const uiRefMapElement = (0, $8f42450ebdd44f5e$export$8e7188a60a5bbe16).getMapElement();
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(uiRefMapElement, [
            this.backdrop
        ]);
        this.buttons = [
            cancelButton,
            confirmButton
        ];
        this.backdrop.focus();
    }
    //--------------------------------------------------------------------
    // # Section: Events
    //--------------------------------------------------------------------
    #onInput(input) {
        this.options.onInput && this.options.onInput(input.value.trim());
    }
    #onConfirm(input) {
        this.close();
        this.options.onConfirm && this.options.onConfirm(input.value.trim());
    }
    #onCancel() {
        this.close();
        this.options.onCancel && this.options.onCancel();
    }
    //--------------------------------------------------------------------
    // # Section: Public API
    //--------------------------------------------------------------------
    getClassType() {
        return $c42ddd4eedb1ba0e$var$CLASS__DIALOG_TYPE;
    }
}



var $f1q41 = parcelRequire("f1q41");




const $aaefa5b13d3c65cd$var$CLASS__DIALOG = 'oltb-dialog';
const $aaefa5b13d3c65cd$var$CLASS__DIALOG_TYPE = `${$aaefa5b13d3c65cd$var$CLASS__DIALOG}--select`;
const $aaefa5b13d3c65cd$var$CLASS__ANIMATION = 'oltb-animation';
const $aaefa5b13d3c65cd$var$CLASS__ANIMATION_BOUNCE = `${$aaefa5b13d3c65cd$var$CLASS__ANIMATION}--bounce`;
const $aaefa5b13d3c65cd$var$DefaultOptions = Object.freeze({
    title: 'Select',
    message: '',
    value: undefined,
    options: [],
    confirmClass: 'oltb-btn--green-mid',
    confirmText: 'Confirm',
    cancelText: 'Cancel',
    onConfirm: undefined,
    onCancel: undefined,
    onChange: undefined
});
class $aaefa5b13d3c65cd$export$ac383859b8641449 extends (0, $6f290307a15ad0a3$export$a0609e4d602995aa) {
    constructor(options = {}){
        super();
        this.options = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep($aaefa5b13d3c65cd$var$DefaultOptions), options);
        this.#createDialog();
    }
    #createDialog() {
        const dialog = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'div',
            class: `${$aaefa5b13d3c65cd$var$CLASS__DIALOG} ${$aaefa5b13d3c65cd$var$CLASS__DIALOG_TYPE} ${$aaefa5b13d3c65cd$var$CLASS__ANIMATION} ${$aaefa5b13d3c65cd$var$CLASS__ANIMATION_BOUNCE}`
        });
        const title = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'h2',
            class: `${$aaefa5b13d3c65cd$var$CLASS__DIALOG}__title`,
            text: this.options.title
        });
        const message = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'p',
            class: `${$aaefa5b13d3c65cd$var$CLASS__DIALOG}__message`,
            html: this.options.message
        });
        const select = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'select',
            class: `${$aaefa5b13d3c65cd$var$CLASS__DIALOG}__select oltb-select`,
            listeners: {
                'change': ()=>{
                    this.#onChange(select);
                }
            }
        });
        this.options.options.forEach((item)=>{
            const option = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
                element: 'option',
                text: item.text,
                value: item.value
            });
            (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(select, [
                option
            ]);
        });
        if (this.options.value) select.value = this.options.value;
        else if (this.options.options.length > 0) select.value = this.options.options[0].value;
        else select.value = '';
        const buttonWrapper = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'div',
            class: `${$aaefa5b13d3c65cd$var$CLASS__DIALOG}__buttons-wrapper`
        });
        const confirmButton = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'button',
            text: this.options.confirmText,
            class: `${$aaefa5b13d3c65cd$var$CLASS__DIALOG}__btn oltb-btn ${this.options.confirmClass}`,
            attributes: {
                'type': 'button'
            },
            listeners: {
                'click': this.#onConfirm.bind(this, select)
            }
        });
        const cancelButton = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'button',
            text: this.options.cancelText,
            class: `${$aaefa5b13d3c65cd$var$CLASS__DIALOG}__btn oltb-btn ${(0, $c63f096e37f334a4$export$5a63ccfbe4d87ef0)() ? 'oltb-btn--gray-mid' : 'oltb-btn--gray-dark'}`,
            attributes: {
                'type': 'button'
            },
            listeners: {
                'click': this.#onCancel.bind(this)
            }
        });
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(buttonWrapper, [
            cancelButton,
            confirmButton
        ]);
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(dialog, [
            title,
            message,
            select,
            buttonWrapper
        ]);
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(this.backdrop, [
            dialog
        ]);
        const uiRefMapElement = (0, $8f42450ebdd44f5e$export$8e7188a60a5bbe16).getMapElement();
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(uiRefMapElement, [
            this.backdrop
        ]);
        this.buttons = [
            cancelButton,
            confirmButton
        ];
        this.backdrop.focus();
    }
    //--------------------------------------------------------------------
    // # Section: Events
    //--------------------------------------------------------------------
    #onChange(select) {
        this.options.onChange && this.options.onChange({
            text: select.options[select.selectedIndex].text.trim(),
            value: select.value.trim()
        });
    }
    #onConfirm(select) {
        this.close();
        const fromValue = this.options.value;
        const fromOption = this.options.options.find((option)=>{
            return option.value === fromValue;
        });
        const toValue = select.value;
        const toOption = select.options[select.selectedIndex];
        this.options.onConfirm && this.options.onConfirm({
            from: {
                text: fromOption.text.trim(),
                value: fromValue.trim()
            },
            to: {
                text: toOption.text.trim(),
                value: toValue.trim()
            }
        });
    }
    #onCancel() {
        this.close();
        this.options.onCancel && this.options.onCancel();
    }
    //--------------------------------------------------------------------
    // # Section: Public API
    //--------------------------------------------------------------------
    getClassType() {
        return $aaefa5b13d3c65cd$var$CLASS__DIALOG_TYPE;
    }
}



var $f1q41 = parcelRequire("f1q41");




const $2ed5611fd25ce000$var$CLASS__DIALOG = 'oltb-dialog';
const $2ed5611fd25ce000$var$CLASS__DIALOG_TYPE = `${$2ed5611fd25ce000$var$CLASS__DIALOG}--confirm`;
const $2ed5611fd25ce000$var$CLASS__ANIMATION = 'oltb-animation';
const $2ed5611fd25ce000$var$CLASS__ANIMATION_BOUNCE = `${$2ed5611fd25ce000$var$CLASS__ANIMATION}--bounce`;
const $2ed5611fd25ce000$var$DefaultOptions = Object.freeze({
    title: 'Confirm',
    message: '',
    confirmClass: 'oltb-btn--red-mid',
    confirmText: 'Yes',
    cancelText: 'Cancel',
    onConfirm: undefined,
    onCancel: undefined
});
class $2ed5611fd25ce000$export$2cc85109a937009e extends (0, $6f290307a15ad0a3$export$a0609e4d602995aa) {
    constructor(options = {}){
        super();
        this.options = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep($2ed5611fd25ce000$var$DefaultOptions), options);
        this.#createDialog();
    }
    #createDialog() {
        const dialog = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'div',
            class: `${$2ed5611fd25ce000$var$CLASS__DIALOG} ${$2ed5611fd25ce000$var$CLASS__DIALOG_TYPE} ${$2ed5611fd25ce000$var$CLASS__ANIMATION} ${$2ed5611fd25ce000$var$CLASS__ANIMATION_BOUNCE}`
        });
        const title = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'h2',
            class: `${$2ed5611fd25ce000$var$CLASS__DIALOG}__title`,
            text: this.options.title
        });
        const message = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'p',
            class: `${$2ed5611fd25ce000$var$CLASS__DIALOG}__message`,
            html: this.options.message
        });
        const buttonWrapper = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'div',
            class: `${$2ed5611fd25ce000$var$CLASS__DIALOG}__buttons-wrapper`
        });
        const confirmButton = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'button',
            text: this.options.confirmText,
            class: `${$2ed5611fd25ce000$var$CLASS__DIALOG}__btn oltb-btn ${this.options.confirmClass}`,
            attributes: {
                'type': 'button'
            },
            listeners: {
                'click': this.#onConfirm.bind(this)
            }
        });
        const cancelButton = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'button',
            text: this.options.cancelText,
            class: `${$2ed5611fd25ce000$var$CLASS__DIALOG}__btn oltb-btn ${(0, $c63f096e37f334a4$export$5a63ccfbe4d87ef0)() ? 'oltb-btn--gray-mid' : 'oltb-btn--gray-dark'}`,
            attributes: {
                'type': 'button'
            },
            listeners: {
                'click': this.#onCancel.bind(this)
            }
        });
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(buttonWrapper, [
            cancelButton,
            confirmButton
        ]);
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(dialog, [
            title,
            message,
            buttonWrapper
        ]);
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(this.backdrop, [
            dialog
        ]);
        const uiRefMapElement = (0, $8f42450ebdd44f5e$export$8e7188a60a5bbe16).getMapElement();
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(uiRefMapElement, [
            this.backdrop
        ]);
        this.buttons = [
            cancelButton,
            confirmButton
        ];
        this.backdrop.focus();
    }
    //--------------------------------------------------------------------
    // # Section: Events
    //--------------------------------------------------------------------
    #onConfirm() {
        this.close();
        this.options.onConfirm && this.options.onConfirm();
    }
    #onCancel() {
        this.close();
        this.options.onCancel && this.options.onCancel();
    }
    //--------------------------------------------------------------------
    // # Section: Public API
    //--------------------------------------------------------------------
    getClassType() {
        return $2ed5611fd25ce000$var$CLASS__DIALOG_TYPE;
    }
}


class $c815862f3b0d8f0b$export$3ddf2d174ce01153 {
    static alert(options) {
        return new (0, $f675a9190bfd0236$export$de466dd8317b0b75)(options);
    }
    static confirm(options) {
        return new (0, $2ed5611fd25ce000$export$2cc85109a937009e)(options);
    }
    static prompt(options) {
        return new (0, $c42ddd4eedb1ba0e$export$a551a871839880f9)(options);
    }
    static select(options) {
        return new (0, $aaefa5b13d3c65cd$export$ac383859b8641449)(options);
    }
    static get Success() {
        return 'oltb-btn--green-mid';
    }
    static get Danger() {
        return 'oltb-btn--red-mid';
    }
}






const $a18f76100c642f63$var$I18N__BASE = 'managers.infoWindowManager';
const $a18f76100c642f63$export$cc0a04ebb0421721 = function(InfoWindowManager, marker) {
    const i18n = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get(`${$a18f76100c642f63$var$I18N__BASE}.dialogs.confirms.deleteMarker`);
    return (0, $c815862f3b0d8f0b$export$3ddf2d174ce01153).confirm({
        title: i18n.title,
        message: i18n.message,
        confirmText: i18n.confirmText,
        cancelText: i18n.cancelText,
        onConfirm: ()=>{
            InfoWindowManager.hideOverlay();
            (0, $e75fe1c51a3d360c$export$eff87c52915dd7fe).removeFeatureFromFeatureLayers(marker);
            // Note:
            // Important to use feature as property key, not only markers can be removed
            (0, $96903e3f16465932$export$cc74486daaaef499).dispatchCustomEvent([
                window
            ], (0, $a9807b370eed025c$export$ada873a34909da65).custom.featureRemoved, {
                detail: {
                    feature: marker
                }
            });
        }
    });
};








const $b7c7b7c80a77d404$var$FILENAME = 'show-marker-layer.js';
const $b7c7b7c80a77d404$var$CLASS__TOOLBOX_INDICATE_ITEM = 'oltb-toolbox-list__item--indicate';
const $b7c7b7c80a77d404$export$725e0e2961a78dc = function(InfoWindowManager, marker) {
    const layerWrapper = (0, $e75fe1c51a3d360c$export$eff87c52915dd7fe).getLayerWrapperFromFeature(marker);
    if (!layerWrapper) {
        (0, $b9b5c0363f244088$export$49b118289be48034).logWarning($b7c7b7c80a77d404$var$FILENAME, 'showMarkerLayer', 'No layer found');
        return;
    }
    const layerElement = window.document.querySelector(`[data-oltb-id='${layerWrapper.getId()}']`);
    if (!layerElement) {
        (0, $b9b5c0363f244088$export$49b118289be48034).logWarning($b7c7b7c80a77d404$var$FILENAME, 'showMarkerLayer', 'No layer-element found');
        return;
    }
    (0, $e1b36be5f031477b$export$cb0933279c36a66b).flashClass(layerElement, $b7c7b7c80a77d404$var$CLASS__TOOLBOX_INDICATE_ITEM);
};


/**
 * @module ol/render
 */ 




function $806302f479c89a9b$export$f2d2c60ac41d8b0b(context, options) {
    const canvas = context.canvas;
    options = options ? options : {};
    const pixelRatio = options.pixelRatio || (0, $67c66761d21428d0$export$6b83a0446fc26f94);
    const size = options.size;
    if (size) {
        canvas.width = size[0] * pixelRatio;
        canvas.height = size[1] * pixelRatio;
        canvas.style.width = size[0] + 'px';
        canvas.style.height = size[1] + 'px';
    }
    const extent = [
        0,
        0,
        canvas.width,
        canvas.height
    ];
    const transform = (0, $e22e7611e69f42a9$export$dcdf75081b88279d)((0, $e22e7611e69f42a9$export$185802fd694ee1f5)(), pixelRatio, pixelRatio);
    return new (0, $7b0c2128a27f5020$export$2e2bcd8739ae039)(context, pixelRatio, extent, transform, 0);
}
function $806302f479c89a9b$export$4c1f9592b019a76d(event) {
    if (!(event.context instanceof CanvasRenderingContext2D)) throw new Error('Only works for render events from Canvas 2D layers');
    // canvas may be at a different pixel ratio than frameState.pixelRatio
    const a = event.inversePixelTransform[0];
    const b = event.inversePixelTransform[1];
    const canvasPixelRatio = Math.sqrt(a * a + b * b);
    const frameState = event.frameState;
    const transform = (0, $e22e7611e69f42a9$export$2060d2db72cce88f)(event.inversePixelTransform.slice(), frameState.coordinateToPixelTransform);
    const squaredTolerance = (0, $4b9ac454600c05d2$export$75084a70d324c1e6)(frameState.viewState.resolution, canvasPixelRatio);
    let userTransform;
    const userProjection = (0, $9c4744460e43e41b$export$3973b77d5f6f2790)();
    if (userProjection) userTransform = (0, $9c4744460e43e41b$export$e3c4995a701c26a3)(userProjection, frameState.viewState.projection);
    return new (0, $7b0c2128a27f5020$export$2e2bcd8739ae039)(event.context, canvasPixelRatio, frameState.extent, transform, frameState.viewState.rotation, squaredTolerance, userTransform);
}
function $806302f479c89a9b$export$5d5f40b190bc29f0(event, pixel) {
    return (0, $e22e7611e69f42a9$export$5635d7ef4b8fee1c)(event.inversePixelTransform, pixel.slice(0));
}



const $9af90f798dfee713$export$f7efa305aa33d09c = Object.freeze({
    100: 'FF',
    99: 'FC',
    98: 'FA',
    97: 'F7',
    96: 'F5',
    95: 'F2',
    94: 'F0',
    93: 'ED',
    92: 'EB',
    91: 'E8',
    90: 'E6',
    89: 'E3',
    88: 'E0',
    87: 'DE',
    86: 'DB',
    85: 'D9',
    84: 'D6',
    83: 'D4',
    82: 'D1',
    81: 'CF',
    80: 'CC',
    79: 'C9',
    78: 'C7',
    77: 'C4',
    76: 'C2',
    75: 'BF',
    74: 'BD',
    73: 'BA',
    72: 'B8',
    71: 'B5',
    70: 'B3',
    69: 'B0',
    68: 'AD',
    67: 'AB',
    66: 'A8',
    65: 'A6',
    64: 'A3',
    63: 'A1',
    62: '9E',
    61: '9C',
    60: '99',
    59: '96',
    58: '94',
    57: '91',
    56: '8F',
    55: '8C',
    54: '8A',
    53: '87',
    52: '85',
    51: '82',
    50: '80',
    49: '7D',
    48: '7A',
    47: '78',
    46: '75',
    45: '73',
    44: '70',
    43: '6E',
    42: '6B',
    41: '69',
    40: '66',
    39: '63',
    38: '61',
    37: '5E',
    36: '5C',
    35: '59',
    34: '57',
    33: '54',
    32: '52',
    31: '4F',
    30: '4D',
    29: '4A',
    28: '47',
    27: '45',
    26: '42',
    25: '40',
    24: '3D',
    23: '3B',
    22: '38',
    21: '36',
    20: '33',
    19: '30',
    18: '2E',
    17: '2B',
    16: '29',
    15: '26',
    14: '24',
    13: '21',
    12: '1F',
    11: '1C',
    10: '1A',
    9: '17',
    8: '14',
    7: '12',
    6: '0F',
    5: '0D',
    4: '0A',
    3: '08',
    2: '05',
    1: '03',
    0: '00'
});





const $9f66900afbcbe054$var$copyAsync = async function(text = '') {
    const value = text.trim();
    // Note:
    // Navigator clipboard API needs a secure context (https)
    // Fallback to old (deprecated window.document.execCommand) if https is not available
    if (window.navigator.clipboard && window.isSecureContext) await window.navigator.clipboard.writeText(value);
    else {
        const textArea = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'textarea',
            value: value,
            style: {
                'position': 'absolute',
                'left': '-999999px',
                'opacity': 0
            }
        });
        window.document.body.prepend(textArea);
        textArea.select();
        try {
            window.document.execCommand('copy');
        } finally{
            textArea.remove();
        }
    }
};
// Note:
// Had to wrap the function with an object to be able to run unit tests.
// Mocking or spying on the raw copy-function without an object never worked, not sure why.
const $9f66900afbcbe054$export$2cdf1b96a9f86d16 = {
    copyAsync: $9f66900afbcbe054$var$copyAsync
};


const $0004fb28f6e99f26$var$FILENAME = 'copy-marker-info.js';
const $0004fb28f6e99f26$var$I18N__BASE = 'managers.infoWindowManager';
const $0004fb28f6e99f26$export$cf8a344feccb06a0 = async function(InfoWindowManager, data) {
    try {
        await (0, $9f66900afbcbe054$export$2cdf1b96a9f86d16).copyAsync(data);
        (0, $9051f0e072bf4341$export$8d8dc7d5f743331b).info({
            i18nKey: `${$0004fb28f6e99f26$var$I18N__BASE}.toasts.infos.copyMarkerInfo`,
            autoremove: true
        });
    } catch (error) {
        (0, $b9b5c0363f244088$export$49b118289be48034).logError($0004fb28f6e99f26$var$FILENAME, 'copyMarkerInfoAsync', {
            message: 'Failed to copy Marker info',
            error: error
        });
        (0, $9051f0e072bf4341$export$8d8dc7d5f743331b).error({
            i18nKey: `${$0004fb28f6e99f26$var$I18N__BASE}.toasts.errors.copyMarkerInfo`
        });
    }
};






const $35260e77ba5fc851$var$FILENAME = 'copy-marker-coordinates.js';
const $35260e77ba5fc851$var$I18N__BASE = 'managers.infoWindowManager';
const $35260e77ba5fc851$export$c7af034d1bdd9c4d = async function(InfoWindowManager, data) {
    try {
        await (0, $9f66900afbcbe054$export$2cdf1b96a9f86d16).copyAsync(data);
        (0, $9051f0e072bf4341$export$8d8dc7d5f743331b).info({
            i18nKey: `${$35260e77ba5fc851$var$I18N__BASE}.toasts.infos.copyMarkerCoordinates`,
            autoremove: true
        });
    } catch (error) {
        (0, $b9b5c0363f244088$export$49b118289be48034).logError($35260e77ba5fc851$var$FILENAME, 'copyMarkerCoordinatesAsync', {
            message: 'Failed to copy Marker coordinates',
            error: error
        });
        (0, $9051f0e072bf4341$export$8d8dc7d5f743331b).error({
            i18nKey: `${$35260e77ba5fc851$var$I18N__BASE}.toasts.errors.copyMarkerCoordinates`
        });
    }
};



const $09399be6683278f4$var$FILENAME = 'info-window-manager.js';
const $09399be6683278f4$var$CLASS__ANIMATION = 'oltb-animation';
const $09399be6683278f4$var$CLASS__ANIMATION_CENTERED_BOUNCE = `${$09399be6683278f4$var$CLASS__ANIMATION}--centered-bounce`;
const $09399be6683278f4$var$CLASS__INFO_WINDOW = 'oltb-info-window';
const $09399be6683278f4$var$ID__PREFIX_INFO_WINDOW = 'oltb-info-window-marker';
const $09399be6683278f4$var$MouseCursors = Object.freeze({
    default: 'default',
    pointer: 'pointer'
});
// Note:
// Works best on IconMarkers.
// FeatureProperties.type.windBarb is removed from the types collection for now.
const $09399be6683278f4$var$AnimationTypes = [
    (0, $60b20182c25e327b$export$2906e7f4b228efe9).type.iconMarker
];
const $09399be6683278f4$var$DefaultHighlightStyle = new (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)({
    fill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
        color: '#254372AA'
    }),
    stroke: new (0, $f9d0329c5c745263$export$2e2bcd8739ae039)({
        color: '#369ACDFF',
        width: 1.5
    })
});
/**
 * About:
 * InfoWindowManager
 * 
 * Description:
 * Manages the Information Window that can be attached on Markers in the Map.
 */ class $09399be6683278f4$export$ffc0bcd424265bb8 extends (0, $8a2666592e7029ee$export$84777416d052f822) {
    static #map;
    static #infoWindow;
    static #overlay;
    static #title;
    static #content;
    static #footer;
    static #selectedFeature;
    static #selectedVectorSection;
    static #hoveredVectorSection;
    //--------------------------------------------------------------------
    // # Section: Base Overrides
    //--------------------------------------------------------------------
    static async initAsync(options = {}) {
        (0, $b9b5c0363f244088$export$49b118289be48034).logDebug($09399be6683278f4$var$FILENAME, 'initAsync', 'Initialization started');
        this.#createInfoWindow();
        return new Promise((resolve)=>{
            resolve({
                filename: $09399be6683278f4$var$FILENAME,
                result: true
            });
        });
    }
    static setMap(map) {
        this.#map = map;
        this.#map.addOverlay(this.#overlay);
        this.#map.on((0, $a9807b370eed025c$export$ada873a34909da65).openLayers.singleClick, this.#onSingleClick.bind(this));
        this.#map.on((0, $a9807b370eed025c$export$ada873a34909da65).openLayers.pointerMove, this.#onPointerMove.bind(this));
    }
    static getName() {
        return $09399be6683278f4$var$FILENAME;
    }
    //--------------------------------------------------------------------
    // # Section: User Interface
    //--------------------------------------------------------------------
    static #createInfoWindow() {
        this.#infoWindow = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'div',
            class: `${$09399be6683278f4$var$CLASS__INFO_WINDOW} ${$09399be6683278f4$var$CLASS__ANIMATION}`,
            attributes: {
                'tabindex': '-1'
            },
            listeners: {
                'keydown': (0, $2c00c14ef3ff796f$export$bec45a54c2e66c22)
            }
        });
        const header = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'div',
            class: `${$09399be6683278f4$var$CLASS__INFO_WINDOW}__header`
        });
        this.#title = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'h3',
            class: `${$09399be6683278f4$var$CLASS__INFO_WINDOW}__title`
        });
        const closeButton = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'button',
            html: (0, $dcff5ab966a6537f$export$a297fe855adfd36c)({
                path: (0, $35649bc6579784f8$export$3fddabec91763a6e).close.stroked,
                fill: 'none',
                stroke: 'currentColor',
                strokeWidth: 1
            }),
            class: `${$09399be6683278f4$var$CLASS__INFO_WINDOW}__close oltb-btn oltb-btn--blank`,
            listeners: {
                'click': this.hideOverlay.bind(this)
            }
        });
        this.#content = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'div',
            class: `${$09399be6683278f4$var$CLASS__INFO_WINDOW}__content`
        });
        this.#footer = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'div',
            class: `${$09399be6683278f4$var$CLASS__INFO_WINDOW}__footer oltb-hide-scrollbars`
        });
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(header, [
            this.#title,
            closeButton
        ]);
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(this.#infoWindow, [
            header,
            this.#content,
            this.#footer
        ]);
        const config = (0, $1e8c0ef90ed82280$export$a33e119b2316dcb7).getConfig();
        this.#overlay = new (0, $c80d3ed2a84f41ed$export$2e2bcd8739ae039)({
            element: this.#infoWindow,
            positioning: 'bottom-center',
            offset: [
                config.overlayOffset.horizontal,
                config.overlayOffset.vertical
            ],
            autoPan: true,
            autoPanAnimation: {
                duration: config.animationDuration.normal
            }
        });
    }
    //--------------------------------------------------------------------
    // # Section: Events
    //--------------------------------------------------------------------
    static #onSingleClick(event) {
        const results = this.#map.forEachFeatureAtPixel(event.pixel, function(feature, layer) {
            return [
                feature,
                layer
            ];
        });
        if (!results) {
            this.#doSingleClickNoResults();
            return;
        }
        this.#doSingleClickWithResuls(results);
    }
    static #onPointerMove(event) {
        const feature = this.#map.forEachFeatureAtPixel(event.pixel, function(feature) {
            return feature;
        });
        this.#handleVectorHoverSections(feature);
        if (!feature) {
            this.setViewportCursor($09399be6683278f4$var$MouseCursors.default);
            return;
        }
        this.#doPointerMoveWithResults(event, feature);
    }
    //--------------------------------------------------------------------
    // # Section: Internal
    //--------------------------------------------------------------------
    static #doSingleClickNoResults() {
        this.hideOverlay();
        this.deselectFeature();
        this.deselectHoveredVectorSection();
        this.deselectVectorSection();
    }
    static #doSingleClickWithResuls(results) {
        const [feature, layer] = results;
        this.tryPulseAnimation(feature, layer);
        const hasInfoWindow = (0, $45f5d1a81c4ed6cb$export$73e78dff44a347ad).hasInfoWindow(feature);
        if (hasInfoWindow) {
            this.showOverlay(feature);
            this.deselectVectorSection();
        } else {
            this.hideOverlay();
            this.deselectVectorSection();
        }
        const shouldHighlight = (0, $45f5d1a81c4ed6cb$export$73e78dff44a347ad).shouldHighlightOnHover(feature);
        if (hasInfoWindow && shouldHighlight) this.selectVectorSection(feature);
    }
    static #doPointerMoveWithResults(event, feature) {
        const shouldHighlight = (0, $45f5d1a81c4ed6cb$export$73e78dff44a347ad).shouldHighlightOnHover(feature);
        if (shouldHighlight) this.selectHoveredVectorSection(feature);
        const nodeName = event.originalEvent.target.nodeName;
        const hasInfoWindow = (0, $45f5d1a81c4ed6cb$export$73e78dff44a347ad).hasInfoWindow(feature);
        if (hasInfoWindow && nodeName === 'CANVAS') this.setViewportCursor($09399be6683278f4$var$MouseCursors.pointer);
        else this.setViewportCursor($09399be6683278f4$var$MouseCursors.default);
    }
    static #handleVectorHoverSections(feature) {
        if (!feature && !this.#selectedVectorSection) {
            this.deselectHoveredVectorSection();
            this.deselectVectorSection();
        }
        if (this.#hoveredVectorSection && this.#hoveredVectorSection !== feature && this.#hoveredVectorSection !== this.#selectedVectorSection) this.deselectHoveredVectorSection();
    }
    static #pulseAnimation(feature, layer, properties, animationConfig) {
        this.selectFeature(feature);
        const start = Date.now();
        const color = this.getAnimationColor(properties);
        const minSize = this.getAnimationMin(properties);
        const maxSize = this.getAnimationMax(properties);
        const duration = animationConfig.duration;
        const shouldLoop = animationConfig.shouldLoop;
        const strokeWidth = animationConfig.strokeWidth;
        const pulseGeometry = feature.getGeometry().clone();
        const listenerKey = layer.on((0, $a9807b370eed025c$export$ada873a34909da65).openLayers.postRender, animate.bind(this));
        // Note:
        // Render the map will trigger the postrender that runs the animation
        this.#map.render();
        function animate(event) {
            const frameState = event.frameState;
            const elapsed = frameState.time - start;
            if (elapsed >= duration || !this.#selectedFeature) {
                // Note:
                // Cancel active animation
                (0, $1f093ab5083c8a1f$export$b7ef3f8527533384)(listenerKey);
                // Note:
                // If the feature is still selected, rerun the animation
                if ((0, $45f5d1a81c4ed6cb$export$73e78dff44a347ad).isSameFeature(this.#selectedFeature, feature) && shouldLoop) this.#pulseAnimation(feature, layer, properties, animationConfig);
                return;
            }
            const vectorContext = (0, $806302f479c89a9b$export$4c1f9592b019a76d)(event);
            const elapsedRatio = elapsed / duration;
            const radius = (0, $c7ccf7e681a9b333$export$57636bb43b1ccbb0)(elapsedRatio) * maxSize + minSize;
            const opacity = (0, $c7ccf7e681a9b333$export$57636bb43b1ccbb0)(1 - elapsedRatio);
            const hexPercentage = Math.round(opacity * 100);
            const hex = (0, $9af90f798dfee713$export$f7efa305aa33d09c)[hexPercentage];
            const style = new (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)({
                image: new (0, $06150d8570b7481b$export$2e2bcd8739ae039)({
                    radius: radius,
                    stroke: new (0, $f9d0329c5c745263$export$2e2bcd8739ae039)({
                        color: `${color.slice(0, -2)}${hex}`,
                        width: strokeWidth + opacity
                    })
                })
            });
            vectorContext.setStyle(style);
            vectorContext.drawGeometry(pulseGeometry);
            // Note:
            // Continue to render the map until the animation has completed
            this.#map.render();
        }
    }
    static #attachFunctionButtons(feature) {
        const uiRefRemoveButton = this.#footer.querySelector(`#${$09399be6683278f4$var$ID__PREFIX_INFO_WINDOW}-remove`);
        if (uiRefRemoveButton) uiRefRemoveButton.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.click, (0, $a18f76100c642f63$export$cc0a04ebb0421721).bind(this, $09399be6683278f4$export$ffc0bcd424265bb8, feature));
        const uiRefCopyCoordinatesButton = this.#footer.querySelector(`#${$09399be6683278f4$var$ID__PREFIX_INFO_WINDOW}-copy-coordinates`);
        if (uiRefCopyCoordinatesButton) {
            const value = uiRefCopyCoordinatesButton.getAttribute('data-oltb-coordinates');
            uiRefCopyCoordinatesButton.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.click, (0, $35260e77ba5fc851$export$c7af034d1bdd9c4d).bind(this, $09399be6683278f4$export$ffc0bcd424265bb8, value));
        }
        const uiRefCopyInfoButton = this.#footer.querySelector(`#${$09399be6683278f4$var$ID__PREFIX_INFO_WINDOW}-copy-text`);
        if (uiRefCopyInfoButton) {
            const value = uiRefCopyInfoButton.getAttribute('data-oltb-copy');
            uiRefCopyInfoButton.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.click, (0, $0004fb28f6e99f26$export$cf8a344feccb06a0).bind(this, $09399be6683278f4$export$ffc0bcd424265bb8, value));
        }
        const uiRefEditButton = this.#footer.querySelector(`#${$09399be6683278f4$var$ID__PREFIX_INFO_WINDOW}-edit`);
        if (uiRefEditButton) uiRefEditButton.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.click, (0, $1f2b3634eb149f4d$export$15c57b05db5d9d69).bind(this, $09399be6683278f4$export$ffc0bcd424265bb8, feature));
        const uiRefShowLayer = this.#footer.querySelector(`#${$09399be6683278f4$var$ID__PREFIX_INFO_WINDOW}-show-layer`);
        if (uiRefShowLayer) uiRefShowLayer.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.click, (0, $b7c7b7c80a77d404$export$725e0e2961a78dc).bind(this, $09399be6683278f4$export$ffc0bcd424265bb8, feature));
    }
    //--------------------------------------------------------------------
    // # Section: Public API
    //--------------------------------------------------------------------
    static tryPulseAnimation(feature, layer) {
        // TODO:
        // This was a messy method, make it prettier in future.
        const oltb = (0, $0a57fad3299da03c$export$ac4f8128ea29c5).toolbar.id;
        const properties = feature.get(oltb);
        const animationConfig = (0, $1e8c0ef90ed82280$export$a33e119b2316dcb7).getConfig().marker.pulseAnimation;
        // Note:
        // Only animate oltb markers and wind-barbs
        if (!properties || !$09399be6683278f4$var$AnimationTypes.includes(properties.type) || !animationConfig.isEnabled) return;
        // Note:
        // This method might be invoked when the layer is "unknown", example navigating to a Bookmark
        // Try and find the layer from the LayerManager
        if (!layer) layer = (0, $e75fe1c51a3d360c$export$eff87c52915dd7fe).getLayerFromFeature(feature);
        if (!layer) {
            (0, $b9b5c0363f244088$export$49b118289be48034).logWarning($09399be6683278f4$var$FILENAME, 'pulseAnimation', {
                info: 'No layer found for feature',
                featureId: (0, $6c5e11070e371322$export$5e82334337e0f204)(feature)
            });
            return;
        }
        // Note:
        // Already animating this feature
        // Example if the user repeatedly navigates to the same Bookmark
        if (this.#selectedFeature && (0, $45f5d1a81c4ed6cb$export$73e78dff44a347ad).isSameFeature(this.#selectedFeature, feature)) return;
        this.#pulseAnimation(feature, layer, properties, animationConfig);
    }
    static showOverlay(feature, position) {
        this.showOverlayDelayed(feature, position, 0);
    }
    static showOverlayDelayed(feature, position, delay = (0, $1e8c0ef90ed82280$export$a33e119b2316dcb7).getConfig().animationDuration.normal) {
        window.setTimeout(()=>{
            const infoWindow = (0, $45f5d1a81c4ed6cb$export$73e78dff44a347ad).getInfoWindow(feature);
            if (!infoWindow) return;
            this.doShowOverlayWithResult(infoWindow, feature, position);
        }, delay);
    }
    static doShowOverlayWithResult(infoWindow, feature, position) {
        this.#title.innerHTML = infoWindow.title;
        this.#content.innerHTML = infoWindow.content;
        this.#footer.innerHTML = infoWindow.footer;
        if (position) this.#overlay.setPosition(position);
        else this.#overlay.setPosition((0, $6da4c8ed3074c92b$export$c91255cadecfe081)(feature.getGeometry().getExtent()));
        this.#attachFunctionButtons(feature);
        this.#infoWindow.focus();
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).runAnimation(this.#infoWindow, $09399be6683278f4$var$CLASS__ANIMATION_CENTERED_BOUNCE);
    }
    static hideOverlay() {
        this.deselectFeature();
        this.deselectHoveredVectorSection();
        this.deselectVectorSection();
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).clearElements([
            this.#title,
            this.#content,
            this.#footer
        ]);
        this.#overlay.setPosition(undefined);
    }
    static getAnimationMin(properties) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).has(properties, [
            'marker'
        ])) return properties.marker.radius;
        return (0, $0a57fad3299da03c$export$ac4f8128ea29c5).marker.pulseAnimation.defaultStartSize;
    }
    static getAnimationMax(properties) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).has(properties, [
            'marker'
        ])) return properties.marker.radius + properties.marker.radius / 2;
        return (0, $0a57fad3299da03c$export$ac4f8128ea29c5).marker.pulseAnimation.defaultEndSize;
    }
    static getAnimationColor(properties) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).has(properties, [
            'marker'
        ])) return properties.marker.fill;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).has(properties, [
            'icon'
        ])) return properties.icon.stroke;
        return (0, $0a57fad3299da03c$export$ac4f8128ea29c5).marker.pulseAnimation.defaultColor;
    }
    static isContentEmpty() {
        return this.#content.innerHTML.length === 0;
    }
    static getInfoWindow() {
        return this.#infoWindow;
    }
    static setViewportCursor(cursor) {
        this.#map.getViewport().style.cursor = cursor;
    }
    static getViewportCursor() {
        return this.#map.getViewport().style.cursor;
    }
    static selectFeature(feature) {
        this.#selectedFeature = feature;
        this.deselectVectorSection();
    }
    static deselectFeature() {
        this.#selectedFeature = undefined;
    }
    static isFeatureSelected() {
        return !!this.#selectedFeature;
    }
    static selectHoveredVectorSection(section) {
        section?.setStyle($09399be6683278f4$var$DefaultHighlightStyle);
        this.#hoveredVectorSection = section;
    }
    static deselectHoveredVectorSection() {
        this.#hoveredVectorSection?.setStyle(null);
        this.#hoveredVectorSection = undefined;
    }
    static isHoveredVectorSectionSelected() {
        return !!this.#hoveredVectorSection;
    }
    static selectVectorSection(section) {
        section?.setStyle($09399be6683278f4$var$DefaultHighlightStyle);
        this.#selectedVectorSection = section;
        this.deselectFeature();
    }
    static deselectVectorSection() {
        this.#selectedVectorSection?.setStyle(null);
        this.#selectedVectorSection = undefined;
    }
    static isVectorSectionSelected() {
        return !!this.#selectedVectorSection;
    }
}


function $95bfc720255032a6$export$2e2bcd8739ae039(defs) {
    defs('EPSG:4326', "+title=WGS 84 (long/lat) +proj=longlat +ellps=WGS84 +datum=WGS84 +units=degrees");
    defs('EPSG:4269', "+title=NAD83 (long/lat) +proj=longlat +a=6378137.0 +b=6356752.31414036 +ellps=GRS80 +datum=NAD83 +units=degrees");
    defs('EPSG:3857', "+title=WGS 84 / Pseudo-Mercator +proj=merc +a=6378137 +b=6378137 +lat_ts=0.0 +lon_0=0.0 +x_0=0.0 +y_0=0 +k=1.0 +units=m +nadgrids=@null +no_defs");
    // UTM WGS84
    for(var i = 1; i <= 60; ++i){
        defs('EPSG:' + (32600 + i), "+proj=utm +zone=" + i + " +datum=WGS84 +units=m");
        defs('EPSG:' + (32700 + i), "+proj=utm +zone=" + i + " +south +datum=WGS84 +units=m");
    }
    defs.WGS84 = defs['EPSG:4326'];
    defs['EPSG:3785'] = defs['EPSG:3857']; // maintain backward compat, official code is 3857
    defs.GOOGLE = defs['EPSG:3857'];
    defs['EPSG:900913'] = defs['EPSG:3857'];
    defs['EPSG:102113'] = defs['EPSG:3857'];
}



var $gyVUi = parcelRequire("gyVUi");
var $c0ed0517e336f22b$export$2e2bcd8739ae039 = {};
$c0ed0517e336f22b$export$2e2bcd8739ae039.greenwich = 0.0; //"0dE",
$c0ed0517e336f22b$export$2e2bcd8739ae039.lisbon = -9.131906111111; //"9d07'54.862\"W",
$c0ed0517e336f22b$export$2e2bcd8739ae039.paris = 2.337229166667; //"2d20'14.025\"E",
$c0ed0517e336f22b$export$2e2bcd8739ae039.bogota = -74.080916666667; //"74d04'51.3\"W",
$c0ed0517e336f22b$export$2e2bcd8739ae039.madrid = -3.687938888889; //"3d41'16.58\"W",
$c0ed0517e336f22b$export$2e2bcd8739ae039.rome = 12.452333333333; //"12d27'8.4\"E",
$c0ed0517e336f22b$export$2e2bcd8739ae039.bern = 7.439583333333; //"7d26'22.5\"E",
$c0ed0517e336f22b$export$2e2bcd8739ae039.jakarta = 106.807719444444; //"106d48'27.79\"E",
$c0ed0517e336f22b$export$2e2bcd8739ae039.ferro = -17.666666666667; //"17d40'W",
$c0ed0517e336f22b$export$2e2bcd8739ae039.brussels = 4.367975; //"4d22'4.71\"E",
$c0ed0517e336f22b$export$2e2bcd8739ae039.stockholm = 18.058277777778; //"18d3'29.8\"E",
$c0ed0517e336f22b$export$2e2bcd8739ae039.athens = 23.7163375; //"23d42'58.815\"E",
$c0ed0517e336f22b$export$2e2bcd8739ae039.oslo = 10.722916666667; //"10d43'22.5\"E"


var $4d34d8675ead8d22$export$2e2bcd8739ae039 = {
    'mm': {
        to_meter: 0.001
    },
    'cm': {
        to_meter: 0.01
    },
    'ft': {
        to_meter: 0.3048
    },
    'us-ft': {
        to_meter: 1200 / 3937
    },
    'fath': {
        to_meter: 1.8288
    },
    'kmi': {
        to_meter: 1852
    },
    'us-ch': {
        to_meter: 20.1168402336805
    },
    'us-mi': {
        to_meter: 1609.34721869444
    },
    'km': {
        to_meter: 1000
    },
    'ind-ft': {
        to_meter: 0.30479841
    },
    'ind-yd': {
        to_meter: 0.91439523
    },
    'mi': {
        to_meter: 1609.344
    },
    'yd': {
        to_meter: 0.9144
    },
    'ch': {
        to_meter: 20.1168
    },
    'link': {
        to_meter: 0.201168
    },
    'dm': {
        to_meter: 0.01
    },
    'in': {
        to_meter: 0.0254
    },
    'ind-ch': {
        to_meter: 20.11669506
    },
    'us-in': {
        to_meter: 0.025400050800101
    },
    'us-yd': {
        to_meter: 0.914401828803658
    }
};


var $ccc3ecc4732a4173$var$ignoredChar = /[\s_\-\/\(\)]/g;
function $ccc3ecc4732a4173$export$2e2bcd8739ae039(obj, key) {
    if (obj[key]) return obj[key];
    var keys = Object.keys(obj);
    var lkey = key.toLowerCase().replace($ccc3ecc4732a4173$var$ignoredChar, '');
    var i = -1;
    var testkey, processedKey;
    while(++i < keys.length){
        testkey = keys[i];
        processedKey = testkey.toLowerCase().replace($ccc3ecc4732a4173$var$ignoredChar, '');
        if (processedKey === lkey) return obj[testkey];
    }
}


function $583158df16d3522c$export$2e2bcd8739ae039(defData) {
    var self = {};
    var paramObj = defData.split('+').map(function(v) {
        return v.trim();
    }).filter(function(a) {
        return a;
    }).reduce(function(p, a) {
        var split = a.split('=');
        split.push(true);
        p[split[0].toLowerCase()] = split[1];
        return p;
    }, {});
    var paramName, paramVal, paramOutname;
    var params = {
        proj: 'projName',
        datum: 'datumCode',
        rf: function(v) {
            self.rf = parseFloat(v);
        },
        lat_0: function(v) {
            self.lat0 = v * (0, $gyVUi.D2R);
        },
        lat_1: function(v) {
            self.lat1 = v * (0, $gyVUi.D2R);
        },
        lat_2: function(v) {
            self.lat2 = v * (0, $gyVUi.D2R);
        },
        lat_ts: function(v) {
            self.lat_ts = v * (0, $gyVUi.D2R);
        },
        lon_0: function(v) {
            self.long0 = v * (0, $gyVUi.D2R);
        },
        lon_1: function(v) {
            self.long1 = v * (0, $gyVUi.D2R);
        },
        lon_2: function(v) {
            self.long2 = v * (0, $gyVUi.D2R);
        },
        alpha: function(v) {
            self.alpha = parseFloat(v) * (0, $gyVUi.D2R);
        },
        gamma: function(v) {
            self.rectified_grid_angle = parseFloat(v);
        },
        lonc: function(v) {
            self.longc = v * (0, $gyVUi.D2R);
        },
        x_0: function(v) {
            self.x0 = parseFloat(v);
        },
        y_0: function(v) {
            self.y0 = parseFloat(v);
        },
        k_0: function(v) {
            self.k0 = parseFloat(v);
        },
        k: function(v) {
            self.k0 = parseFloat(v);
        },
        a: function(v) {
            self.a = parseFloat(v);
        },
        b: function(v) {
            self.b = parseFloat(v);
        },
        r: function(v) {
            self.a = self.b = parseFloat(v);
        },
        r_a: function() {
            self.R_A = true;
        },
        zone: function(v) {
            self.zone = parseInt(v, 10);
        },
        south: function() {
            self.utmSouth = true;
        },
        towgs84: function(v) {
            self.datum_params = v.split(",").map(function(a) {
                return parseFloat(a);
            });
        },
        to_meter: function(v) {
            self.to_meter = parseFloat(v);
        },
        units: function(v) {
            self.units = v;
            var unit = (0, $ccc3ecc4732a4173$export$2e2bcd8739ae039)((0, $4d34d8675ead8d22$export$2e2bcd8739ae039), v);
            if (unit) self.to_meter = unit.to_meter;
        },
        from_greenwich: function(v) {
            self.from_greenwich = v * (0, $gyVUi.D2R);
        },
        pm: function(v) {
            var pm = (0, $ccc3ecc4732a4173$export$2e2bcd8739ae039)((0, $c0ed0517e336f22b$export$2e2bcd8739ae039), v);
            self.from_greenwich = (pm ? pm : parseFloat(v)) * (0, $gyVUi.D2R);
        },
        nadgrids: function(v) {
            if (v === '@null') self.datumCode = 'none';
            else self.nadgrids = v;
        },
        axis: function(v) {
            var legalAxis = "ewnsud";
            if (v.length === 3 && legalAxis.indexOf(v.substr(0, 1)) !== -1 && legalAxis.indexOf(v.substr(1, 1)) !== -1 && legalAxis.indexOf(v.substr(2, 1)) !== -1) self.axis = v;
        },
        approx: function() {
            self.approx = true;
        }
    };
    for(paramName in paramObj){
        paramVal = paramObj[paramName];
        if (paramName in params) {
            paramOutname = params[paramName];
            if (typeof paramOutname === 'function') paramOutname(paramVal);
            else self[paramOutname] = paramVal;
        } else self[paramName] = paramVal;
    }
    if (typeof self.datumCode === 'string' && self.datumCode !== "WGS84") self.datumCode = self.datumCode.toLowerCase();
    return self;
}


var $4f92c43f9960a1f4$export$2e2bcd8739ae039 = $4f92c43f9960a1f4$var$parseString;
var $4f92c43f9960a1f4$var$NEUTRAL = 1;
var $4f92c43f9960a1f4$var$KEYWORD = 2;
var $4f92c43f9960a1f4$var$NUMBER = 3;
var $4f92c43f9960a1f4$var$QUOTED = 4;
var $4f92c43f9960a1f4$var$AFTERQUOTE = 5;
var $4f92c43f9960a1f4$var$ENDED = -1;
var $4f92c43f9960a1f4$var$whitespace = /\s/;
var $4f92c43f9960a1f4$var$latin = /[A-Za-z]/;
var $4f92c43f9960a1f4$var$keyword = /[A-Za-z84_]/;
var $4f92c43f9960a1f4$var$endThings = /[,\]]/;
var $4f92c43f9960a1f4$var$digets = /[\d\.E\-\+]/;
// const ignoredChar = /[\s_\-\/\(\)]/g;
function $4f92c43f9960a1f4$var$Parser(text) {
    if (typeof text !== 'string') throw new Error('not a string');
    this.text = text.trim();
    this.level = 0;
    this.place = 0;
    this.root = null;
    this.stack = [];
    this.currentObject = null;
    this.state = $4f92c43f9960a1f4$var$NEUTRAL;
}
$4f92c43f9960a1f4$var$Parser.prototype.readCharicter = function() {
    var char = this.text[this.place++];
    if (this.state !== $4f92c43f9960a1f4$var$QUOTED) while($4f92c43f9960a1f4$var$whitespace.test(char)){
        if (this.place >= this.text.length) return;
        char = this.text[this.place++];
    }
    switch(this.state){
        case $4f92c43f9960a1f4$var$NEUTRAL:
            return this.neutral(char);
        case $4f92c43f9960a1f4$var$KEYWORD:
            return this.keyword(char);
        case $4f92c43f9960a1f4$var$QUOTED:
            return this.quoted(char);
        case $4f92c43f9960a1f4$var$AFTERQUOTE:
            return this.afterquote(char);
        case $4f92c43f9960a1f4$var$NUMBER:
            return this.number(char);
        case $4f92c43f9960a1f4$var$ENDED:
            return;
    }
};
$4f92c43f9960a1f4$var$Parser.prototype.afterquote = function(char) {
    if (char === '"') {
        this.word += '"';
        this.state = $4f92c43f9960a1f4$var$QUOTED;
        return;
    }
    if ($4f92c43f9960a1f4$var$endThings.test(char)) {
        this.word = this.word.trim();
        this.afterItem(char);
        return;
    }
    throw new Error('havn\'t handled "' + char + '" in afterquote yet, index ' + this.place);
};
$4f92c43f9960a1f4$var$Parser.prototype.afterItem = function(char) {
    if (char === ',') {
        if (this.word !== null) this.currentObject.push(this.word);
        this.word = null;
        this.state = $4f92c43f9960a1f4$var$NEUTRAL;
        return;
    }
    if (char === ']') {
        this.level--;
        if (this.word !== null) {
            this.currentObject.push(this.word);
            this.word = null;
        }
        this.state = $4f92c43f9960a1f4$var$NEUTRAL;
        this.currentObject = this.stack.pop();
        if (!this.currentObject) this.state = $4f92c43f9960a1f4$var$ENDED;
        return;
    }
};
$4f92c43f9960a1f4$var$Parser.prototype.number = function(char) {
    if ($4f92c43f9960a1f4$var$digets.test(char)) {
        this.word += char;
        return;
    }
    if ($4f92c43f9960a1f4$var$endThings.test(char)) {
        this.word = parseFloat(this.word);
        this.afterItem(char);
        return;
    }
    throw new Error('havn\'t handled "' + char + '" in number yet, index ' + this.place);
};
$4f92c43f9960a1f4$var$Parser.prototype.quoted = function(char) {
    if (char === '"') {
        this.state = $4f92c43f9960a1f4$var$AFTERQUOTE;
        return;
    }
    this.word += char;
    return;
};
$4f92c43f9960a1f4$var$Parser.prototype.keyword = function(char) {
    if ($4f92c43f9960a1f4$var$keyword.test(char)) {
        this.word += char;
        return;
    }
    if (char === '[') {
        var newObjects = [];
        newObjects.push(this.word);
        this.level++;
        if (this.root === null) this.root = newObjects;
        else this.currentObject.push(newObjects);
        this.stack.push(this.currentObject);
        this.currentObject = newObjects;
        this.state = $4f92c43f9960a1f4$var$NEUTRAL;
        return;
    }
    if ($4f92c43f9960a1f4$var$endThings.test(char)) {
        this.afterItem(char);
        return;
    }
    throw new Error('havn\'t handled "' + char + '" in keyword yet, index ' + this.place);
};
$4f92c43f9960a1f4$var$Parser.prototype.neutral = function(char) {
    if ($4f92c43f9960a1f4$var$latin.test(char)) {
        this.word = char;
        this.state = $4f92c43f9960a1f4$var$KEYWORD;
        return;
    }
    if (char === '"') {
        this.word = '';
        this.state = $4f92c43f9960a1f4$var$QUOTED;
        return;
    }
    if ($4f92c43f9960a1f4$var$digets.test(char)) {
        this.word = char;
        this.state = $4f92c43f9960a1f4$var$NUMBER;
        return;
    }
    if ($4f92c43f9960a1f4$var$endThings.test(char)) {
        this.afterItem(char);
        return;
    }
    throw new Error('havn\'t handled "' + char + '" in neutral yet, index ' + this.place);
};
$4f92c43f9960a1f4$var$Parser.prototype.output = function() {
    while(this.place < this.text.length)this.readCharicter();
    if (this.state === $4f92c43f9960a1f4$var$ENDED) return this.root;
    throw new Error('unable to parse string "' + this.text + '". State is ' + this.state);
};
function $4f92c43f9960a1f4$var$parseString(txt) {
    var parser = new $4f92c43f9960a1f4$var$Parser(txt);
    return parser.output();
}


function $5bda1e467f1c2649$var$mapit(obj, key, value) {
    if (Array.isArray(key)) {
        value.unshift(key);
        key = null;
    }
    var thing = key ? {} : obj;
    var out = value.reduce(function(newObj, item) {
        $5bda1e467f1c2649$export$337bc7a3aef1f775(item, newObj);
        return newObj;
    }, thing);
    if (key) obj[key] = out;
}
function $5bda1e467f1c2649$export$337bc7a3aef1f775(v, obj) {
    if (!Array.isArray(v)) {
        obj[v] = true;
        return;
    }
    var key = v.shift();
    if (key === 'PARAMETER') key = v.shift();
    if (v.length === 1) {
        if (Array.isArray(v[0])) {
            obj[key] = {};
            $5bda1e467f1c2649$export$337bc7a3aef1f775(v[0], obj[key]);
            return;
        }
        obj[key] = v[0];
        return;
    }
    if (!v.length) {
        obj[key] = true;
        return;
    }
    if (key === 'TOWGS84') {
        obj[key] = v;
        return;
    }
    if (key === 'AXIS') {
        if (!(key in obj)) obj[key] = [];
        obj[key].push(v);
        return;
    }
    if (!Array.isArray(key)) obj[key] = {};
    var i;
    switch(key){
        case 'UNIT':
        case 'PRIMEM':
        case 'VERT_DATUM':
            obj[key] = {
                name: v[0].toLowerCase(),
                convert: v[1]
            };
            if (v.length === 3) $5bda1e467f1c2649$export$337bc7a3aef1f775(v[2], obj[key]);
            return;
        case 'SPHEROID':
        case 'ELLIPSOID':
            obj[key] = {
                name: v[0],
                a: v[1],
                rf: v[2]
            };
            if (v.length === 4) $5bda1e467f1c2649$export$337bc7a3aef1f775(v[3], obj[key]);
            return;
        case 'EDATUM':
        case 'ENGINEERINGDATUM':
        case 'LOCAL_DATUM':
        case 'DATUM':
        case 'VERT_CS':
        case 'VERTCRS':
        case 'VERTICALCRS':
            v[0] = [
                'name',
                v[0]
            ];
            $5bda1e467f1c2649$var$mapit(obj, key, v);
            return;
        case 'COMPD_CS':
        case 'COMPOUNDCRS':
        case 'FITTED_CS':
        // the followings are the crs defined in
        // https://github.com/proj4js/proj4js/blob/1da4ed0b865d0fcb51c136090569210cdcc9019e/lib/parseCode.js#L11
        case 'PROJECTEDCRS':
        case 'PROJCRS':
        case 'GEOGCS':
        case 'GEOCCS':
        case 'PROJCS':
        case 'LOCAL_CS':
        case 'GEODCRS':
        case 'GEODETICCRS':
        case 'GEODETICDATUM':
        case 'ENGCRS':
        case 'ENGINEERINGCRS':
            v[0] = [
                'name',
                v[0]
            ];
            $5bda1e467f1c2649$var$mapit(obj, key, v);
            obj[key].type = key;
            return;
        default:
            i = -1;
            while(++i < v.length){
                if (!Array.isArray(v[i])) return $5bda1e467f1c2649$export$337bc7a3aef1f775(v, obj[key]);
            }
            return $5bda1e467f1c2649$var$mapit(obj, key, v);
    }
}


var $5c3aabf591259c07$var$D2R = 0.01745329251994329577;
var $5c3aabf591259c07$var$knownTypes = [
    'PROJECTEDCRS',
    'PROJCRS',
    'GEOGCS',
    'GEOCCS',
    'PROJCS',
    'LOCAL_CS',
    'GEODCRS',
    'GEODETICCRS',
    'GEODETICDATUM',
    'ENGCRS',
    'ENGINEERINGCRS'
];
function $5c3aabf591259c07$var$rename(obj, params) {
    var outName = params[0];
    var inName = params[1];
    if (!(outName in obj) && inName in obj) {
        obj[outName] = obj[inName];
        if (params.length === 3) obj[outName] = params[2](obj[outName]);
    }
}
function $5c3aabf591259c07$var$d2r(input) {
    return input * $5c3aabf591259c07$var$D2R;
}
function $5c3aabf591259c07$var$cleanWKT(wkt) {
    var keys = Object.keys(wkt);
    for(var i = 0, ii = keys.length; i < ii; ++i){
        var key = keys[i];
        // the followings are the crs defined in
        // https://github.com/proj4js/proj4js/blob/1da4ed0b865d0fcb51c136090569210cdcc9019e/lib/parseCode.js#L11
        if ($5c3aabf591259c07$var$knownTypes.indexOf(key) !== -1) $5c3aabf591259c07$var$setPropertiesFromWkt(wkt[key]);
        if (typeof wkt[key] === 'object') $5c3aabf591259c07$var$cleanWKT(wkt[key]);
    }
}
function $5c3aabf591259c07$var$setPropertiesFromWkt(wkt) {
    if (wkt.AUTHORITY) {
        var authority = Object.keys(wkt.AUTHORITY)[0];
        if (authority && authority in wkt.AUTHORITY) wkt.title = authority + ':' + wkt.AUTHORITY[authority];
    }
    if (wkt.type === 'GEOGCS') wkt.projName = 'longlat';
    else if (wkt.type === 'LOCAL_CS') {
        wkt.projName = 'identity';
        wkt.local = true;
    } else if (typeof wkt.PROJECTION === 'object') wkt.projName = Object.keys(wkt.PROJECTION)[0];
    else wkt.projName = wkt.PROJECTION;
    if (wkt.AXIS) {
        var axisOrder = '';
        for(var i = 0, ii = wkt.AXIS.length; i < ii; ++i){
            var axis = [
                wkt.AXIS[i][0].toLowerCase(),
                wkt.AXIS[i][1].toLowerCase()
            ];
            if (axis[0].indexOf('north') !== -1 || (axis[0] === 'y' || axis[0] === 'lat') && axis[1] === 'north') axisOrder += 'n';
            else if (axis[0].indexOf('south') !== -1 || (axis[0] === 'y' || axis[0] === 'lat') && axis[1] === 'south') axisOrder += 's';
            else if (axis[0].indexOf('east') !== -1 || (axis[0] === 'x' || axis[0] === 'lon') && axis[1] === 'east') axisOrder += 'e';
            else if (axis[0].indexOf('west') !== -1 || (axis[0] === 'x' || axis[0] === 'lon') && axis[1] === 'west') axisOrder += 'w';
        }
        if (axisOrder.length === 2) axisOrder += 'u';
        if (axisOrder.length === 3) wkt.axis = axisOrder;
    }
    if (wkt.UNIT) {
        wkt.units = wkt.UNIT.name.toLowerCase();
        if (wkt.units === 'metre') wkt.units = 'meter';
        if (wkt.UNIT.convert) {
            if (wkt.type === 'GEOGCS') {
                if (wkt.DATUM && wkt.DATUM.SPHEROID) wkt.to_meter = wkt.UNIT.convert * wkt.DATUM.SPHEROID.a;
            } else wkt.to_meter = wkt.UNIT.convert;
        }
    }
    var geogcs = wkt.GEOGCS;
    if (wkt.type === 'GEOGCS') geogcs = wkt;
    if (geogcs) {
        //if(wkt.GEOGCS.PRIMEM&&wkt.GEOGCS.PRIMEM.convert){
        //  wkt.from_greenwich=wkt.GEOGCS.PRIMEM.convert*D2R;
        //}
        if (geogcs.DATUM) wkt.datumCode = geogcs.DATUM.name.toLowerCase();
        else wkt.datumCode = geogcs.name.toLowerCase();
        if (wkt.datumCode.slice(0, 2) === 'd_') wkt.datumCode = wkt.datumCode.slice(2);
        if (wkt.datumCode === 'new_zealand_1949') wkt.datumCode = 'nzgd49';
        if (wkt.datumCode === 'wgs_1984' || wkt.datumCode === 'world_geodetic_system_1984') {
            if (wkt.PROJECTION === 'Mercator_Auxiliary_Sphere') wkt.sphere = true;
            wkt.datumCode = 'wgs84';
        }
        if (wkt.datumCode === 'belge_1972') wkt.datumCode = 'rnb72';
        if (geogcs.DATUM && geogcs.DATUM.SPHEROID) {
            wkt.ellps = geogcs.DATUM.SPHEROID.name.replace('_19', '').replace(/[Cc]larke\_18/, 'clrk');
            if (wkt.ellps.toLowerCase().slice(0, 13) === 'international') wkt.ellps = 'intl';
            wkt.a = geogcs.DATUM.SPHEROID.a;
            wkt.rf = parseFloat(geogcs.DATUM.SPHEROID.rf, 10);
        }
        if (geogcs.DATUM && geogcs.DATUM.TOWGS84) wkt.datum_params = geogcs.DATUM.TOWGS84;
        if (~wkt.datumCode.indexOf('osgb_1936')) wkt.datumCode = 'osgb36';
        if (~wkt.datumCode.indexOf('osni_1952')) wkt.datumCode = 'osni52';
        if (~wkt.datumCode.indexOf('tm65') || ~wkt.datumCode.indexOf('geodetic_datum_of_1965')) wkt.datumCode = 'ire65';
        if (wkt.datumCode === 'ch1903+') wkt.datumCode = 'ch1903';
        if (~wkt.datumCode.indexOf('israel')) wkt.datumCode = 'isr93';
    }
    if (wkt.b && !isFinite(wkt.b)) wkt.b = wkt.a;
    function toMeter(input) {
        var ratio = wkt.to_meter || 1;
        return input * ratio;
    }
    var renamer = function(a) {
        return $5c3aabf591259c07$var$rename(wkt, a);
    };
    var list = [
        [
            'standard_parallel_1',
            'Standard_Parallel_1'
        ],
        [
            'standard_parallel_1',
            'Latitude of 1st standard parallel'
        ],
        [
            'standard_parallel_2',
            'Standard_Parallel_2'
        ],
        [
            'standard_parallel_2',
            'Latitude of 2nd standard parallel'
        ],
        [
            'false_easting',
            'False_Easting'
        ],
        [
            'false_easting',
            'False easting'
        ],
        [
            'false-easting',
            'Easting at false origin'
        ],
        [
            'false_northing',
            'False_Northing'
        ],
        [
            'false_northing',
            'False northing'
        ],
        [
            'false_northing',
            'Northing at false origin'
        ],
        [
            'central_meridian',
            'Central_Meridian'
        ],
        [
            'central_meridian',
            'Longitude of natural origin'
        ],
        [
            'central_meridian',
            'Longitude of false origin'
        ],
        [
            'latitude_of_origin',
            'Latitude_Of_Origin'
        ],
        [
            'latitude_of_origin',
            'Central_Parallel'
        ],
        [
            'latitude_of_origin',
            'Latitude of natural origin'
        ],
        [
            'latitude_of_origin',
            'Latitude of false origin'
        ],
        [
            'scale_factor',
            'Scale_Factor'
        ],
        [
            'k0',
            'scale_factor'
        ],
        [
            'latitude_of_center',
            'Latitude_Of_Center'
        ],
        [
            'latitude_of_center',
            'Latitude_of_center'
        ],
        [
            'lat0',
            'latitude_of_center',
            $5c3aabf591259c07$var$d2r
        ],
        [
            'longitude_of_center',
            'Longitude_Of_Center'
        ],
        [
            'longitude_of_center',
            'Longitude_of_center'
        ],
        [
            'longc',
            'longitude_of_center',
            $5c3aabf591259c07$var$d2r
        ],
        [
            'x0',
            'false_easting',
            toMeter
        ],
        [
            'y0',
            'false_northing',
            toMeter
        ],
        [
            'long0',
            'central_meridian',
            $5c3aabf591259c07$var$d2r
        ],
        [
            'lat0',
            'latitude_of_origin',
            $5c3aabf591259c07$var$d2r
        ],
        [
            'lat0',
            'standard_parallel_1',
            $5c3aabf591259c07$var$d2r
        ],
        [
            'lat1',
            'standard_parallel_1',
            $5c3aabf591259c07$var$d2r
        ],
        [
            'lat2',
            'standard_parallel_2',
            $5c3aabf591259c07$var$d2r
        ],
        [
            'azimuth',
            'Azimuth'
        ],
        [
            'alpha',
            'azimuth',
            $5c3aabf591259c07$var$d2r
        ],
        [
            'srsCode',
            'name'
        ]
    ];
    list.forEach(renamer);
    if (!wkt.long0 && wkt.longc && (wkt.projName === 'Albers_Conic_Equal_Area' || wkt.projName === 'Lambert_Azimuthal_Equal_Area')) wkt.long0 = wkt.longc;
    if (!wkt.lat_ts && wkt.lat1 && (wkt.projName === 'Stereographic_South_Pole' || wkt.projName === 'Polar Stereographic (variant B)')) {
        wkt.lat0 = $5c3aabf591259c07$var$d2r(wkt.lat1 > 0 ? 90 : -90);
        wkt.lat_ts = wkt.lat1;
    } else if (!wkt.lat_ts && wkt.lat0 && wkt.projName === 'Polar_Stereographic') {
        wkt.lat_ts = wkt.lat0;
        wkt.lat0 = $5c3aabf591259c07$var$d2r(wkt.lat0 > 0 ? 90 : -90);
    }
}
function $5c3aabf591259c07$export$2e2bcd8739ae039(wkt) {
    var lisp = (0, $4f92c43f9960a1f4$export$2e2bcd8739ae039)(wkt);
    var type = lisp[0];
    var obj = {};
    (0, $5bda1e467f1c2649$export$337bc7a3aef1f775)(lisp, obj);
    $5c3aabf591259c07$var$cleanWKT(obj);
    return obj[type];
}


function $a9b3183caccb3297$var$defs(name) {
    /*global console*/ var that = this;
    if (arguments.length === 2) {
        var def = arguments[1];
        if (typeof def === 'string') {
            if (def.charAt(0) === '+') $a9b3183caccb3297$var$defs[name] = (0, $583158df16d3522c$export$2e2bcd8739ae039)(arguments[1]);
            else $a9b3183caccb3297$var$defs[name] = (0, $5c3aabf591259c07$export$2e2bcd8739ae039)(arguments[1]);
        } else $a9b3183caccb3297$var$defs[name] = def;
    } else if (arguments.length === 1) {
        if (Array.isArray(name)) return name.map(function(v) {
            if (Array.isArray(v)) $a9b3183caccb3297$var$defs.apply(that, v);
            else $a9b3183caccb3297$var$defs(v);
        });
        else if (typeof name === 'string') {
            if (name in $a9b3183caccb3297$var$defs) return $a9b3183caccb3297$var$defs[name];
        } else if ('EPSG' in name) $a9b3183caccb3297$var$defs['EPSG:' + name.EPSG] = name;
        else if ('ESRI' in name) $a9b3183caccb3297$var$defs['ESRI:' + name.ESRI] = name;
        else if ('IAU2000' in name) $a9b3183caccb3297$var$defs['IAU2000:' + name.IAU2000] = name;
        else console.log(name);
        return;
    }
}
(0, $95bfc720255032a6$export$2e2bcd8739ae039)($a9b3183caccb3297$var$defs);
var $a9b3183caccb3297$export$2e2bcd8739ae039 = $a9b3183caccb3297$var$defs;





function $bddd3b9c0d2064cd$var$testObj(code) {
    return typeof code === 'string';
}
function $bddd3b9c0d2064cd$var$testDef(code) {
    return code in (0, $a9b3183caccb3297$export$2e2bcd8739ae039);
}
var $bddd3b9c0d2064cd$var$codeWords = [
    'PROJECTEDCRS',
    'PROJCRS',
    'GEOGCS',
    'GEOCCS',
    'PROJCS',
    'LOCAL_CS',
    'GEODCRS',
    'GEODETICCRS',
    'GEODETICDATUM',
    'ENGCRS',
    'ENGINEERINGCRS'
];
function $bddd3b9c0d2064cd$var$testWKT(code) {
    return $bddd3b9c0d2064cd$var$codeWords.some(function(word) {
        return code.indexOf(word) > -1;
    });
}
var $bddd3b9c0d2064cd$var$codes = [
    '3857',
    '900913',
    '3785',
    '102113'
];
function $bddd3b9c0d2064cd$var$checkMercator(item) {
    var auth = (0, $ccc3ecc4732a4173$export$2e2bcd8739ae039)(item, 'authority');
    if (!auth) return;
    var code = (0, $ccc3ecc4732a4173$export$2e2bcd8739ae039)(auth, 'epsg');
    return code && $bddd3b9c0d2064cd$var$codes.indexOf(code) > -1;
}
function $bddd3b9c0d2064cd$var$checkProjStr(item) {
    var ext = (0, $ccc3ecc4732a4173$export$2e2bcd8739ae039)(item, 'extension');
    if (!ext) return;
    return (0, $ccc3ecc4732a4173$export$2e2bcd8739ae039)(ext, 'proj4');
}
function $bddd3b9c0d2064cd$var$testProj(code) {
    return code[0] === '+';
}
function $bddd3b9c0d2064cd$var$parse(code) {
    if ($bddd3b9c0d2064cd$var$testObj(code)) {
        //check to see if this is a WKT string
        if ($bddd3b9c0d2064cd$var$testDef(code)) return (0, $a9b3183caccb3297$export$2e2bcd8739ae039)[code];
        if ($bddd3b9c0d2064cd$var$testWKT(code)) {
            var out = (0, $5c3aabf591259c07$export$2e2bcd8739ae039)(code);
            // test of spetial case, due to this being a very common and often malformed
            if ($bddd3b9c0d2064cd$var$checkMercator(out)) return (0, $a9b3183caccb3297$export$2e2bcd8739ae039)['EPSG:3857'];
            var maybeProjStr = $bddd3b9c0d2064cd$var$checkProjStr(out);
            if (maybeProjStr) return (0, $583158df16d3522c$export$2e2bcd8739ae039)(maybeProjStr);
            return out;
        }
        if ($bddd3b9c0d2064cd$var$testProj(code)) return (0, $583158df16d3522c$export$2e2bcd8739ae039)(code);
    } else return code;
}
var $bddd3b9c0d2064cd$export$2e2bcd8739ae039 = $bddd3b9c0d2064cd$var$parse;


function $96b30a4c80088893$export$2e2bcd8739ae039(destination, source) {
    destination = destination || {};
    var value, property;
    if (!source) return destination;
    for(property in source){
        value = source[property];
        if (value !== undefined) destination[property] = value;
    }
    return destination;
}



var $bi5ZC = parcelRequire("bi5ZC");

var $a9oRf = parcelRequire("a9oRf");

var $3xC66 = parcelRequire("3xC66");

var $2AZR8 = parcelRequire("2AZR8");

var $gyVUi = parcelRequire("gyVUi");
function $d64d5a882433f366$export$2cd8252107eb640b() {
    var con = this.b / this.a;
    this.es = 1 - con * con;
    if (!('x0' in this)) this.x0 = 0;
    if (!('y0' in this)) this.y0 = 0;
    this.e = Math.sqrt(this.es);
    if (this.lat_ts) {
        if (this.sphere) this.k0 = Math.cos(this.lat_ts);
        else this.k0 = (0, $bi5ZC.default)(this.e, Math.sin(this.lat_ts), Math.cos(this.lat_ts));
    } else if (!this.k0) {
        if (this.k) this.k0 = this.k;
        else this.k0 = 1;
    }
}
function $d64d5a882433f366$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    // convert to radians
    if (lat * (0, $gyVUi.R2D) > 90 && lat * (0, $gyVUi.R2D) < -90 && lon * (0, $gyVUi.R2D) > 180 && lon * (0, $gyVUi.R2D) < -180) return null;
    var x, y;
    if (Math.abs(Math.abs(lat) - (0, $gyVUi.HALF_PI)) <= (0, $gyVUi.EPSLN)) return null;
    else {
        if (this.sphere) {
            x = this.x0 + this.a * this.k0 * (0, $a9oRf.default)(lon - this.long0);
            y = this.y0 + this.a * this.k0 * Math.log(Math.tan((0, $gyVUi.FORTPI) + 0.5 * lat));
        } else {
            var sinphi = Math.sin(lat);
            var ts = (0, $3xC66.default)(this.e, lat, sinphi);
            x = this.x0 + this.a * this.k0 * (0, $a9oRf.default)(lon - this.long0);
            y = this.y0 - this.a * this.k0 * Math.log(ts);
        }
        p.x = x;
        p.y = y;
        return p;
    }
}
function $d64d5a882433f366$export$70ae2c07e401031b(p) {
    var x = p.x - this.x0;
    var y = p.y - this.y0;
    var lon, lat;
    if (this.sphere) lat = (0, $gyVUi.HALF_PI) - 2 * Math.atan(Math.exp(-y / (this.a * this.k0)));
    else {
        var ts = Math.exp(-y / (this.a * this.k0));
        lat = (0, $2AZR8.default)(this.e, ts);
        if (lat === -9999) return null;
    }
    lon = (0, $a9oRf.default)(this.long0 + x / (this.a * this.k0));
    p.x = lon;
    p.y = lat;
    return p;
}
var $d64d5a882433f366$export$e4b2ac9215619f8d = [
    "Mercator",
    "Popular Visualisation Pseudo Mercator",
    "Mercator_1SP",
    "Mercator_Auxiliary_Sphere",
    "merc"
];
var $d64d5a882433f366$export$2e2bcd8739ae039 = {
    init: $d64d5a882433f366$export$2cd8252107eb640b,
    forward: $d64d5a882433f366$export$174bb771924e7eb1,
    inverse: $d64d5a882433f366$export$70ae2c07e401031b,
    names: $d64d5a882433f366$export$e4b2ac9215619f8d
};


function $dad2845bfa7291b9$export$2cd8252107eb640b() {
//no-op for longlat
}
function $dad2845bfa7291b9$export$174bb771924e7eb1(pt) {
    return pt;
}
var $dad2845bfa7291b9$export$e4b2ac9215619f8d = [
    "longlat",
    "identity"
];
var $dad2845bfa7291b9$export$2e2bcd8739ae039 = {
    init: $dad2845bfa7291b9$export$2cd8252107eb640b,
    forward: $dad2845bfa7291b9$export$174bb771924e7eb1,
    inverse: $dad2845bfa7291b9$export$174bb771924e7eb1,
    names: $dad2845bfa7291b9$export$e4b2ac9215619f8d
};


var $169de593aeaa174c$var$projs = [
    (0, $d64d5a882433f366$export$2e2bcd8739ae039),
    (0, $dad2845bfa7291b9$export$2e2bcd8739ae039)
];
var $169de593aeaa174c$var$names = {};
var $169de593aeaa174c$var$projStore = [];
function $169de593aeaa174c$export$e16d8520af44a096(proj, i) {
    var len = $169de593aeaa174c$var$projStore.length;
    if (!proj.names) {
        console.log(i);
        return true;
    }
    $169de593aeaa174c$var$projStore[len] = proj;
    proj.names.forEach(function(n) {
        $169de593aeaa174c$var$names[n.toLowerCase()] = len;
    });
    return this;
}
function $169de593aeaa174c$export$3988ae62b71be9a3(name) {
    if (!name) return false;
    var n = name.toLowerCase();
    if (typeof $169de593aeaa174c$var$names[n] !== 'undefined' && $169de593aeaa174c$var$projStore[$169de593aeaa174c$var$names[n]]) return $169de593aeaa174c$var$projStore[$169de593aeaa174c$var$names[n]];
}
function $169de593aeaa174c$export$b3571188c770cc5a() {
    $169de593aeaa174c$var$projs.forEach($169de593aeaa174c$export$e16d8520af44a096);
}
var $169de593aeaa174c$export$2e2bcd8739ae039 = {
    start: $169de593aeaa174c$export$b3571188c770cc5a,
    add: $169de593aeaa174c$export$e16d8520af44a096,
    get: $169de593aeaa174c$export$3988ae62b71be9a3
};



var $gyVUi = parcelRequire("gyVUi");
var $8988c354f092c217$export$2e2bcd8739ae039 = {};
$8988c354f092c217$export$2e2bcd8739ae039.MERIT = {
    a: 6378137.0,
    rf: 298.257,
    ellipseName: "MERIT 1983"
};
$8988c354f092c217$export$2e2bcd8739ae039.SGS85 = {
    a: 6378136.0,
    rf: 298.257,
    ellipseName: "Soviet Geodetic System 85"
};
$8988c354f092c217$export$2e2bcd8739ae039.GRS80 = {
    a: 6378137.0,
    rf: 298.257222101,
    ellipseName: "GRS 1980(IUGG, 1980)"
};
$8988c354f092c217$export$2e2bcd8739ae039.IAU76 = {
    a: 6378140.0,
    rf: 298.257,
    ellipseName: "IAU 1976"
};
$8988c354f092c217$export$2e2bcd8739ae039.airy = {
    a: 6377563.396,
    b: 6356256.910,
    ellipseName: "Airy 1830"
};
$8988c354f092c217$export$2e2bcd8739ae039.APL4 = {
    a: 6378137,
    rf: 298.25,
    ellipseName: "Appl. Physics. 1965"
};
$8988c354f092c217$export$2e2bcd8739ae039.NWL9D = {
    a: 6378145.0,
    rf: 298.25,
    ellipseName: "Naval Weapons Lab., 1965"
};
$8988c354f092c217$export$2e2bcd8739ae039.mod_airy = {
    a: 6377340.189,
    b: 6356034.446,
    ellipseName: "Modified Airy"
};
$8988c354f092c217$export$2e2bcd8739ae039.andrae = {
    a: 6377104.43,
    rf: 300.0,
    ellipseName: "Andrae 1876 (Den., Iclnd.)"
};
$8988c354f092c217$export$2e2bcd8739ae039.aust_SA = {
    a: 6378160.0,
    rf: 298.25,
    ellipseName: "Australian Natl & S. Amer. 1969"
};
$8988c354f092c217$export$2e2bcd8739ae039.GRS67 = {
    a: 6378160.0,
    rf: 298.2471674270,
    ellipseName: "GRS 67(IUGG 1967)"
};
$8988c354f092c217$export$2e2bcd8739ae039.bessel = {
    a: 6377397.155,
    rf: 299.1528128,
    ellipseName: "Bessel 1841"
};
$8988c354f092c217$export$2e2bcd8739ae039.bess_nam = {
    a: 6377483.865,
    rf: 299.1528128,
    ellipseName: "Bessel 1841 (Namibia)"
};
$8988c354f092c217$export$2e2bcd8739ae039.clrk66 = {
    a: 6378206.4,
    b: 6356583.8,
    ellipseName: "Clarke 1866"
};
$8988c354f092c217$export$2e2bcd8739ae039.clrk80 = {
    a: 6378249.145,
    rf: 293.4663,
    ellipseName: "Clarke 1880 mod."
};
$8988c354f092c217$export$2e2bcd8739ae039.clrk80ign = {
    a: 6378249.2,
    b: 6356515,
    rf: 293.4660213,
    ellipseName: "Clarke 1880 (IGN)"
};
$8988c354f092c217$export$2e2bcd8739ae039.clrk58 = {
    a: 6378293.645208759,
    rf: 294.2606763692654,
    ellipseName: "Clarke 1858"
};
$8988c354f092c217$export$2e2bcd8739ae039.CPM = {
    a: 6375738.7,
    rf: 334.29,
    ellipseName: "Comm. des Poids et Mesures 1799"
};
$8988c354f092c217$export$2e2bcd8739ae039.delmbr = {
    a: 6376428.0,
    rf: 311.5,
    ellipseName: "Delambre 1810 (Belgium)"
};
$8988c354f092c217$export$2e2bcd8739ae039.engelis = {
    a: 6378136.05,
    rf: 298.2566,
    ellipseName: "Engelis 1985"
};
$8988c354f092c217$export$2e2bcd8739ae039.evrst30 = {
    a: 6377276.345,
    rf: 300.8017,
    ellipseName: "Everest 1830"
};
$8988c354f092c217$export$2e2bcd8739ae039.evrst48 = {
    a: 6377304.063,
    rf: 300.8017,
    ellipseName: "Everest 1948"
};
$8988c354f092c217$export$2e2bcd8739ae039.evrst56 = {
    a: 6377301.243,
    rf: 300.8017,
    ellipseName: "Everest 1956"
};
$8988c354f092c217$export$2e2bcd8739ae039.evrst69 = {
    a: 6377295.664,
    rf: 300.8017,
    ellipseName: "Everest 1969"
};
$8988c354f092c217$export$2e2bcd8739ae039.evrstSS = {
    a: 6377298.556,
    rf: 300.8017,
    ellipseName: "Everest (Sabah & Sarawak)"
};
$8988c354f092c217$export$2e2bcd8739ae039.fschr60 = {
    a: 6378166.0,
    rf: 298.3,
    ellipseName: "Fischer (Mercury Datum) 1960"
};
$8988c354f092c217$export$2e2bcd8739ae039.fschr60m = {
    a: 6378155.0,
    rf: 298.3,
    ellipseName: "Fischer 1960"
};
$8988c354f092c217$export$2e2bcd8739ae039.fschr68 = {
    a: 6378150.0,
    rf: 298.3,
    ellipseName: "Fischer 1968"
};
$8988c354f092c217$export$2e2bcd8739ae039.helmert = {
    a: 6378200.0,
    rf: 298.3,
    ellipseName: "Helmert 1906"
};
$8988c354f092c217$export$2e2bcd8739ae039.hough = {
    a: 6378270.0,
    rf: 297.0,
    ellipseName: "Hough"
};
$8988c354f092c217$export$2e2bcd8739ae039.intl = {
    a: 6378388.0,
    rf: 297.0,
    ellipseName: "International 1909 (Hayford)"
};
$8988c354f092c217$export$2e2bcd8739ae039.kaula = {
    a: 6378163.0,
    rf: 298.24,
    ellipseName: "Kaula 1961"
};
$8988c354f092c217$export$2e2bcd8739ae039.lerch = {
    a: 6378139.0,
    rf: 298.257,
    ellipseName: "Lerch 1979"
};
$8988c354f092c217$export$2e2bcd8739ae039.mprts = {
    a: 6397300.0,
    rf: 191.0,
    ellipseName: "Maupertius 1738"
};
$8988c354f092c217$export$2e2bcd8739ae039.new_intl = {
    a: 6378157.5,
    b: 6356772.2,
    ellipseName: "New International 1967"
};
$8988c354f092c217$export$2e2bcd8739ae039.plessis = {
    a: 6376523.0,
    rf: 6355863.0,
    ellipseName: "Plessis 1817 (France)"
};
$8988c354f092c217$export$2e2bcd8739ae039.krass = {
    a: 6378245.0,
    rf: 298.3,
    ellipseName: "Krassovsky, 1942"
};
$8988c354f092c217$export$2e2bcd8739ae039.SEasia = {
    a: 6378155.0,
    b: 6356773.3205,
    ellipseName: "Southeast Asia"
};
$8988c354f092c217$export$2e2bcd8739ae039.walbeck = {
    a: 6376896.0,
    b: 6355834.8467,
    ellipseName: "Walbeck"
};
$8988c354f092c217$export$2e2bcd8739ae039.WGS60 = {
    a: 6378165.0,
    rf: 298.3,
    ellipseName: "WGS 60"
};
$8988c354f092c217$export$2e2bcd8739ae039.WGS66 = {
    a: 6378145.0,
    rf: 298.25,
    ellipseName: "WGS 66"
};
$8988c354f092c217$export$2e2bcd8739ae039.WGS7 = {
    a: 6378135.0,
    rf: 298.26,
    ellipseName: "WGS 72"
};
var $8988c354f092c217$export$a1db874f6c0f1ba1 = $8988c354f092c217$export$2e2bcd8739ae039.WGS84 = {
    a: 6378137.0,
    rf: 298.257223563,
    ellipseName: "WGS 84"
};
$8988c354f092c217$export$2e2bcd8739ae039.sphere = {
    a: 6370997.0,
    b: 6370997.0,
    ellipseName: "Normal Sphere (r=6370997)"
};



function $98f4ab684186b766$export$e3d7bf2ed2a7479f(a, b, rf, R_A) {
    var a2 = a * a; // used in geocentric
    var b2 = b * b; // used in geocentric
    var es = (a2 - b2) / a2; // e ^ 2
    var e = 0;
    if (R_A) {
        a *= 1 - es * ((0, $gyVUi.SIXTH) + es * ((0, $gyVUi.RA4) + es * (0, $gyVUi.RA6)));
        a2 = a * a;
        es = 0;
    } else e = Math.sqrt(es); // eccentricity
    var ep2 = (a2 - b2) / b2; // used in geocentric
    return {
        es: es,
        e: e,
        ep2: ep2
    };
}
function $98f4ab684186b766$export$b2690196de52b050(a, b, rf, ellps, sphere) {
    if (!a) {
        var ellipse = (0, $ccc3ecc4732a4173$export$2e2bcd8739ae039)((0, $8988c354f092c217$export$2e2bcd8739ae039), ellps);
        if (!ellipse) ellipse = (0, $8988c354f092c217$export$a1db874f6c0f1ba1);
        a = ellipse.a;
        b = ellipse.b;
        rf = ellipse.rf;
    }
    if (rf && !b) b = (1.0 - 1.0 / rf) * a;
    if (rf === 0 || Math.abs(a - b) < (0, $gyVUi.EPSLN)) {
        sphere = true;
        b = a;
    }
    return {
        a: a,
        b: b,
        rf: rf,
        sphere: sphere
    };
}


var $c36bbc8057de3d00$var$datums = {
    wgs84: {
        towgs84: "0,0,0",
        ellipse: "WGS84",
        datumName: "WGS84"
    },
    ch1903: {
        towgs84: "674.374,15.056,405.346",
        ellipse: "bessel",
        datumName: "swiss"
    },
    ggrs87: {
        towgs84: "-199.87,74.79,246.62",
        ellipse: "GRS80",
        datumName: "Greek_Geodetic_Reference_System_1987"
    },
    nad83: {
        towgs84: "0,0,0",
        ellipse: "GRS80",
        datumName: "North_American_Datum_1983"
    },
    nad27: {
        nadgrids: "@conus,@alaska,@ntv2_0.gsb,@ntv1_can.dat",
        ellipse: "clrk66",
        datumName: "North_American_Datum_1927"
    },
    potsdam: {
        towgs84: "598.1,73.7,418.2,0.202,0.045,-2.455,6.7",
        ellipse: "bessel",
        datumName: "Potsdam Rauenberg 1950 DHDN"
    },
    carthage: {
        towgs84: "-263.0,6.0,431.0",
        ellipse: "clark80",
        datumName: "Carthage 1934 Tunisia"
    },
    hermannskogel: {
        towgs84: "577.326,90.129,463.919,5.137,1.474,5.297,2.4232",
        ellipse: "bessel",
        datumName: "Hermannskogel"
    },
    mgi: {
        towgs84: "577.326,90.129,463.919,5.137,1.474,5.297,2.4232",
        ellipse: "bessel",
        datumName: "Militar-Geographische Institut"
    },
    osni52: {
        towgs84: "482.530,-130.596,564.557,-1.042,-0.214,-0.631,8.15",
        ellipse: "airy",
        datumName: "Irish National"
    },
    ire65: {
        towgs84: "482.530,-130.596,564.557,-1.042,-0.214,-0.631,8.15",
        ellipse: "mod_airy",
        datumName: "Ireland 1965"
    },
    rassadiran: {
        towgs84: "-133.63,-157.5,-158.62",
        ellipse: "intl",
        datumName: "Rassadiran"
    },
    nzgd49: {
        towgs84: "59.47,-5.04,187.44,0.47,-0.1,1.024,-4.5993",
        ellipse: "intl",
        datumName: "New Zealand Geodetic Datum 1949"
    },
    osgb36: {
        towgs84: "446.448,-125.157,542.060,0.1502,0.2470,0.8421,-20.4894",
        ellipse: "airy",
        datumName: "Ordnance Survey of Great Britain 1936"
    },
    s_jtsk: {
        towgs84: "589,76,480",
        ellipse: 'bessel',
        datumName: 'S-JTSK (Ferro)'
    },
    beduaram: {
        towgs84: '-106,-87,188',
        ellipse: 'clrk80',
        datumName: 'Beduaram'
    },
    gunung_segara: {
        towgs84: '-403,684,41',
        ellipse: 'bessel',
        datumName: 'Gunung Segara Jakarta'
    },
    rnb72: {
        towgs84: "106.869,-52.2978,103.724,-0.33657,0.456955,-1.84218,1",
        ellipse: "intl",
        datumName: "Reseau National Belge 1972"
    }
};
for(var $c36bbc8057de3d00$var$key in $c36bbc8057de3d00$var$datums){
    var $c36bbc8057de3d00$var$datum = $c36bbc8057de3d00$var$datums[$c36bbc8057de3d00$var$key];
    $c36bbc8057de3d00$var$datums[$c36bbc8057de3d00$var$datum.datumName] = $c36bbc8057de3d00$var$datum;
}
var $c36bbc8057de3d00$export$2e2bcd8739ae039 = $c36bbc8057de3d00$var$datums;



var $gyVUi = parcelRequire("gyVUi");
function $2c13a87cc45f972b$var$datum(datumCode, datum_params, a, b, es, ep2, nadgrids) {
    var out = {};
    if (datumCode === undefined || datumCode === 'none') out.datum_type = (0, $gyVUi.PJD_NODATUM);
    else out.datum_type = (0, $gyVUi.PJD_WGS84);
    if (datum_params) {
        out.datum_params = datum_params.map(parseFloat);
        if (out.datum_params[0] !== 0 || out.datum_params[1] !== 0 || out.datum_params[2] !== 0) out.datum_type = (0, $gyVUi.PJD_3PARAM);
        if (out.datum_params.length > 3) {
            if (out.datum_params[3] !== 0 || out.datum_params[4] !== 0 || out.datum_params[5] !== 0 || out.datum_params[6] !== 0) {
                out.datum_type = (0, $gyVUi.PJD_7PARAM);
                out.datum_params[3] *= (0, $gyVUi.SEC_TO_RAD);
                out.datum_params[4] *= (0, $gyVUi.SEC_TO_RAD);
                out.datum_params[5] *= (0, $gyVUi.SEC_TO_RAD);
                out.datum_params[6] = out.datum_params[6] / 1000000.0 + 1.0;
            }
        }
    }
    if (nadgrids) {
        out.datum_type = (0, $gyVUi.PJD_GRIDSHIFT);
        out.grids = nadgrids;
    }
    out.a = a; //datum object also uses these values
    out.b = b;
    out.es = es;
    out.ep2 = ep2;
    return out;
}
var $2c13a87cc45f972b$export$2e2bcd8739ae039 = $2c13a87cc45f972b$var$datum;



/**
 * Resources for details of NTv2 file formats:
 * - https://web.archive.org/web/20140127204822if_/http://www.mgs.gov.on.ca:80/stdprodconsume/groups/content/@mgs/@iandit/documents/resourcelist/stel02_047447.pdf
 * - http://mimaka.com/help/gs/html/004_NTV2%20Data%20Format.htm
 */ var $b2d482da445fbb18$var$loadedNadgrids = {};
function $b2d482da445fbb18$export$2e2bcd8739ae039(key, data) {
    var view = new DataView(data);
    var isLittleEndian = $b2d482da445fbb18$var$detectLittleEndian(view);
    var header = $b2d482da445fbb18$var$readHeader(view, isLittleEndian);
    var subgrids = $b2d482da445fbb18$var$readSubgrids(view, header, isLittleEndian);
    var nadgrid = {
        header: header,
        subgrids: subgrids
    };
    $b2d482da445fbb18$var$loadedNadgrids[key] = nadgrid;
    return nadgrid;
}
function $b2d482da445fbb18$export$31c4d9288d81329a(nadgrids) {
    // Format details: http://proj.maptools.org/gen_parms.html
    if (nadgrids === undefined) return null;
    var grids = nadgrids.split(',');
    return grids.map($b2d482da445fbb18$var$parseNadgridString);
}
function $b2d482da445fbb18$var$parseNadgridString(value) {
    if (value.length === 0) return null;
    var optional = value[0] === '@';
    if (optional) value = value.slice(1);
    if (value === 'null') return {
        name: 'null',
        mandatory: !optional,
        grid: null,
        isNull: true
    };
    return {
        name: value,
        mandatory: !optional,
        grid: $b2d482da445fbb18$var$loadedNadgrids[value] || null,
        isNull: false
    };
}
function $b2d482da445fbb18$var$secondsToRadians(seconds) {
    return seconds / 3600 * Math.PI / 180;
}
function $b2d482da445fbb18$var$detectLittleEndian(view) {
    var nFields = view.getInt32(8, false);
    if (nFields === 11) return false;
    nFields = view.getInt32(8, true);
    if (nFields !== 11) console.warn('Failed to detect nadgrid endian-ness, defaulting to little-endian');
    return true;
}
function $b2d482da445fbb18$var$readHeader(view, isLittleEndian) {
    return {
        nFields: view.getInt32(8, isLittleEndian),
        nSubgridFields: view.getInt32(24, isLittleEndian),
        nSubgrids: view.getInt32(40, isLittleEndian),
        shiftType: $b2d482da445fbb18$var$decodeString(view, 56, 64).trim(),
        fromSemiMajorAxis: view.getFloat64(120, isLittleEndian),
        fromSemiMinorAxis: view.getFloat64(136, isLittleEndian),
        toSemiMajorAxis: view.getFloat64(152, isLittleEndian),
        toSemiMinorAxis: view.getFloat64(168, isLittleEndian)
    };
}
function $b2d482da445fbb18$var$decodeString(view, start, end) {
    return String.fromCharCode.apply(null, new Uint8Array(view.buffer.slice(start, end)));
}
function $b2d482da445fbb18$var$readSubgrids(view, header, isLittleEndian) {
    var gridOffset = 176;
    var grids = [];
    for(var i = 0; i < header.nSubgrids; i++){
        var subHeader = $b2d482da445fbb18$var$readGridHeader(view, gridOffset, isLittleEndian);
        var nodes = $b2d482da445fbb18$var$readGridNodes(view, gridOffset, subHeader, isLittleEndian);
        var lngColumnCount = Math.round(1 + (subHeader.upperLongitude - subHeader.lowerLongitude) / subHeader.longitudeInterval);
        var latColumnCount = Math.round(1 + (subHeader.upperLatitude - subHeader.lowerLatitude) / subHeader.latitudeInterval);
        // Proj4 operates on radians whereas the coordinates are in seconds in the grid
        grids.push({
            ll: [
                $b2d482da445fbb18$var$secondsToRadians(subHeader.lowerLongitude),
                $b2d482da445fbb18$var$secondsToRadians(subHeader.lowerLatitude)
            ],
            del: [
                $b2d482da445fbb18$var$secondsToRadians(subHeader.longitudeInterval),
                $b2d482da445fbb18$var$secondsToRadians(subHeader.latitudeInterval)
            ],
            lim: [
                lngColumnCount,
                latColumnCount
            ],
            count: subHeader.gridNodeCount,
            cvs: $b2d482da445fbb18$var$mapNodes(nodes)
        });
        gridOffset += 176 + subHeader.gridNodeCount * 16;
    }
    return grids;
}
function $b2d482da445fbb18$var$mapNodes(nodes) {
    return nodes.map(function(r) {
        return [
            $b2d482da445fbb18$var$secondsToRadians(r.longitudeShift),
            $b2d482da445fbb18$var$secondsToRadians(r.latitudeShift)
        ];
    });
}
function $b2d482da445fbb18$var$readGridHeader(view, offset, isLittleEndian) {
    return {
        name: $b2d482da445fbb18$var$decodeString(view, offset + 8, offset + 16).trim(),
        parent: $b2d482da445fbb18$var$decodeString(view, offset + 24, offset + 24 + 8).trim(),
        lowerLatitude: view.getFloat64(offset + 72, isLittleEndian),
        upperLatitude: view.getFloat64(offset + 88, isLittleEndian),
        lowerLongitude: view.getFloat64(offset + 104, isLittleEndian),
        upperLongitude: view.getFloat64(offset + 120, isLittleEndian),
        latitudeInterval: view.getFloat64(offset + 136, isLittleEndian),
        longitudeInterval: view.getFloat64(offset + 152, isLittleEndian),
        gridNodeCount: view.getInt32(offset + 168, isLittleEndian)
    };
}
function $b2d482da445fbb18$var$readGridNodes(view, offset, gridHeader, isLittleEndian) {
    var nodesOffset = offset + 176;
    var gridRecordLength = 16;
    var gridShiftRecords = [];
    for(var i = 0; i < gridHeader.gridNodeCount; i++){
        var record = {
            latitudeShift: view.getFloat32(nodesOffset + i * gridRecordLength, isLittleEndian),
            longitudeShift: view.getFloat32(nodesOffset + i * gridRecordLength + 4, isLittleEndian),
            latitudeAccuracy: view.getFloat32(nodesOffset + i * gridRecordLength + 8, isLittleEndian),
            longitudeAccuracy: view.getFloat32(nodesOffset + i * gridRecordLength + 12, isLittleEndian)
        };
        gridShiftRecords.push(record);
    }
    return gridShiftRecords;
}


function $24869d6338533b3b$var$Projection(srsCode, callback) {
    if (!(this instanceof $24869d6338533b3b$var$Projection)) return new $24869d6338533b3b$var$Projection(srsCode);
    callback = callback || function(error) {
        if (error) throw error;
    };
    var json = (0, $bddd3b9c0d2064cd$export$2e2bcd8739ae039)(srsCode);
    if (typeof json !== 'object') {
        callback('Could not parse to valid json: ' + srsCode);
        return;
    }
    var ourProj = $24869d6338533b3b$var$Projection.projections.get(json.projName);
    if (!ourProj) {
        callback('Could not get projection name from: ' + srsCode);
        return;
    }
    if (json.datumCode && json.datumCode !== 'none') {
        var datumDef = (0, $ccc3ecc4732a4173$export$2e2bcd8739ae039)((0, $c36bbc8057de3d00$export$2e2bcd8739ae039), json.datumCode);
        if (datumDef) {
            json.datum_params = json.datum_params || (datumDef.towgs84 ? datumDef.towgs84.split(',') : null);
            json.ellps = datumDef.ellipse;
            json.datumName = datumDef.datumName ? datumDef.datumName : json.datumCode;
        }
    }
    json.k0 = json.k0 || 1.0;
    json.axis = json.axis || 'enu';
    json.ellps = json.ellps || 'wgs84';
    json.lat1 = json.lat1 || json.lat0; // Lambert_Conformal_Conic_1SP, for example, needs this
    var sphere_ = (0, $98f4ab684186b766$export$b2690196de52b050)(json.a, json.b, json.rf, json.ellps, json.sphere);
    var ecc = (0, $98f4ab684186b766$export$e3d7bf2ed2a7479f)(sphere_.a, sphere_.b, sphere_.rf, json.R_A);
    var nadgrids = (0, $b2d482da445fbb18$export$31c4d9288d81329a)(json.nadgrids);
    var datumObj = json.datum || (0, $2c13a87cc45f972b$export$2e2bcd8739ae039)(json.datumCode, json.datum_params, sphere_.a, sphere_.b, ecc.es, ecc.ep2, nadgrids);
    (0, $96b30a4c80088893$export$2e2bcd8739ae039)(this, json); // transfer everything over from the projection because we don't know what we'll need
    (0, $96b30a4c80088893$export$2e2bcd8739ae039)(this, ourProj); // transfer all the methods from the projection
    // copy the 4 things over we calculated in deriveConstants.sphere
    this.a = sphere_.a;
    this.b = sphere_.b;
    this.rf = sphere_.rf;
    this.sphere = sphere_.sphere;
    // copy the 3 things we calculated in deriveConstants.eccentricity
    this.es = ecc.es;
    this.e = ecc.e;
    this.ep2 = ecc.ep2;
    // add in the datum object
    this.datum = datumObj;
    // init the projection
    this.init();
    // legecy callback from back in the day when it went to spatialreference.org
    callback(null, this);
}
$24869d6338533b3b$var$Projection.projections = (0, $169de593aeaa174c$export$2e2bcd8739ae039);
$24869d6338533b3b$var$Projection.projections.start();
var $24869d6338533b3b$export$2e2bcd8739ae039 = $24869d6338533b3b$var$Projection;



var $gyVUi = parcelRequire("gyVUi");

var $gyVUi = parcelRequire("gyVUi");

var $gyVUi = parcelRequire("gyVUi");
'use strict';
function $3a04bd721826a648$export$68c8d8590fbb24e4(source, dest) {
    if (source.datum_type !== dest.datum_type) return false; // false, datums are not equal
    else if (source.a !== dest.a || Math.abs(source.es - dest.es) > 0.000000000050) // the tolerance for es is to ensure that GRS80 and WGS84
    // are considered identical
    return false;
    else if (source.datum_type === (0, $gyVUi.PJD_3PARAM)) return source.datum_params[0] === dest.datum_params[0] && source.datum_params[1] === dest.datum_params[1] && source.datum_params[2] === dest.datum_params[2];
    else if (source.datum_type === (0, $gyVUi.PJD_7PARAM)) return source.datum_params[0] === dest.datum_params[0] && source.datum_params[1] === dest.datum_params[1] && source.datum_params[2] === dest.datum_params[2] && source.datum_params[3] === dest.datum_params[3] && source.datum_params[4] === dest.datum_params[4] && source.datum_params[5] === dest.datum_params[5] && source.datum_params[6] === dest.datum_params[6];
    else return true; // datums are equal
} // cs_compare_datums()
function $3a04bd721826a648$export$4a4ae2976f9a808a(p, es, a) {
    var Longitude = p.x;
    var Latitude = p.y;
    var Height = p.z ? p.z : 0; //Z value not always supplied
    var Rn; /*  Earth radius at location  */ 
    var Sin_Lat; /*  Math.sin(Latitude)  */ 
    var Sin2_Lat; /*  Square of Math.sin(Latitude)  */ 
    var Cos_Lat; /*  Math.cos(Latitude)  */ 
    /*
   ** Don't blow up if Latitude is just a little out of the value
   ** range as it may just be a rounding issue.  Also removed longitude
   ** test, it should be wrapped by Math.cos() and Math.sin().  NFW for PROJ.4, Sep/2001.
   */ if (Latitude < -(0, $gyVUi.HALF_PI) && Latitude > -1.001 * (0, $gyVUi.HALF_PI)) Latitude = -(0, $gyVUi.HALF_PI);
    else if (Latitude > (0, $gyVUi.HALF_PI) && Latitude < 1.001 * (0, $gyVUi.HALF_PI)) Latitude = (0, $gyVUi.HALF_PI);
    else if (Latitude < -(0, $gyVUi.HALF_PI)) /* Latitude out of range */ //..reportError('geocent:lat out of range:' + Latitude);
    return {
        x: -Infinity,
        y: -Infinity,
        z: p.z
    };
    else if (Latitude > (0, $gyVUi.HALF_PI)) /* Latitude out of range */ return {
        x: Infinity,
        y: Infinity,
        z: p.z
    };
    if (Longitude > Math.PI) Longitude -= 2 * Math.PI;
    Sin_Lat = Math.sin(Latitude);
    Cos_Lat = Math.cos(Latitude);
    Sin2_Lat = Sin_Lat * Sin_Lat;
    Rn = a / Math.sqrt(1.0e0 - es * Sin2_Lat);
    return {
        x: (Rn + Height) * Cos_Lat * Math.cos(Longitude),
        y: (Rn + Height) * Cos_Lat * Math.sin(Longitude),
        z: (Rn * (1 - es) + Height) * Sin_Lat
    };
} // cs_geodetic_to_geocentric()
function $3a04bd721826a648$export$26210192c8922750(p, es, a, b) {
    /* local defintions and variables */ /* end-criterium of loop, accuracy of sin(Latitude) */ var genau = 1e-12;
    var genau2 = genau * genau;
    var maxiter = 30;
    var P; /* distance between semi-minor axis and location */ 
    var RR; /* distance between center and location */ 
    var CT; /* sin of geocentric latitude */ 
    var ST; /* cos of geocentric latitude */ 
    var RX;
    var RK;
    var RN; /* Earth radius at location */ 
    var CPHI0; /* cos of start or old geodetic latitude in iterations */ 
    var SPHI0; /* sin of start or old geodetic latitude in iterations */ 
    var CPHI; /* cos of searched geodetic latitude */ 
    var SPHI; /* sin of searched geodetic latitude */ 
    var SDPHI; /* end-criterium: addition-theorem of sin(Latitude(iter)-Latitude(iter-1)) */ 
    var iter; /* # of continous iteration, max. 30 is always enough (s.a.) */ 
    var X = p.x;
    var Y = p.y;
    var Z = p.z ? p.z : 0.0; //Z value not always supplied
    var Longitude;
    var Latitude;
    var Height;
    P = Math.sqrt(X * X + Y * Y);
    RR = Math.sqrt(X * X + Y * Y + Z * Z);
    /*      special cases for latitude and longitude */ if (P / a < genau) {
        /*  special case, if P=0. (X=0., Y=0.) */ Longitude = 0.0;
        /*  if (X,Y,Z)=(0.,0.,0.) then Height becomes semi-minor axis
     *  of ellipsoid (=center of mass), Latitude becomes PI/2 */ if (RR / a < genau) {
            Latitude = (0, $gyVUi.HALF_PI);
            Height = -b;
            return {
                x: p.x,
                y: p.y,
                z: p.z
            };
        }
    } else /*  ellipsoidal (geodetic) longitude
     *  interval: -PI < Longitude <= +PI */ Longitude = Math.atan2(Y, X);
    /* --------------------------------------------------------------
   * Following iterative algorithm was developped by
   * "Institut for Erdmessung", University of Hannover, July 1988.
   * Internet: www.ife.uni-hannover.de
   * Iterative computation of CPHI,SPHI and Height.
   * Iteration of CPHI and SPHI to 10**-12 radian resp.
   * 2*10**-7 arcsec.
   * --------------------------------------------------------------
   */ CT = Z / RR;
    ST = P / RR;
    RX = 1.0 / Math.sqrt(1.0 - es * (2.0 - es) * ST * ST);
    CPHI0 = ST * (1.0 - es) * RX;
    SPHI0 = CT * RX;
    iter = 0;
    /* loop to find sin(Latitude) resp. Latitude
   * until |sin(Latitude(iter)-Latitude(iter-1))| < genau */ do {
        iter++;
        RN = a / Math.sqrt(1.0 - es * SPHI0 * SPHI0);
        /*  ellipsoidal (geodetic) height */ Height = P * CPHI0 + Z * SPHI0 - RN * (1.0 - es * SPHI0 * SPHI0);
        RK = es * RN / (RN + Height);
        RX = 1.0 / Math.sqrt(1.0 - RK * (2.0 - RK) * ST * ST);
        CPHI = ST * (1.0 - RK) * RX;
        SPHI = CT * RX;
        SDPHI = SPHI * CPHI0 - CPHI * SPHI0;
        CPHI0 = CPHI;
        SPHI0 = SPHI;
    }while (SDPHI * SDPHI > genau2 && iter < maxiter);
    /*      ellipsoidal (geodetic) latitude */ Latitude = Math.atan(SPHI / Math.abs(CPHI));
    return {
        x: Longitude,
        y: Latitude,
        z: Height
    };
} // cs_geocentric_to_geodetic()
function $3a04bd721826a648$export$d18952b9ecb47c8f(p, datum_type, datum_params) {
    if (datum_type === (0, $gyVUi.PJD_3PARAM)) // if( x[io] === HUGE_VAL )
    //    continue;
    return {
        x: p.x + datum_params[0],
        y: p.y + datum_params[1],
        z: p.z + datum_params[2]
    };
    else if (datum_type === (0, $gyVUi.PJD_7PARAM)) {
        var Dx_BF = datum_params[0];
        var Dy_BF = datum_params[1];
        var Dz_BF = datum_params[2];
        var Rx_BF = datum_params[3];
        var Ry_BF = datum_params[4];
        var Rz_BF = datum_params[5];
        var M_BF = datum_params[6];
        // if( x[io] === HUGE_VAL )
        //    continue;
        return {
            x: M_BF * (p.x - Rz_BF * p.y + Ry_BF * p.z) + Dx_BF,
            y: M_BF * (Rz_BF * p.x + p.y - Rx_BF * p.z) + Dy_BF,
            z: M_BF * (-Ry_BF * p.x + Rx_BF * p.y + p.z) + Dz_BF
        };
    }
} // cs_geocentric_to_wgs84
function $3a04bd721826a648$export$2b744ad521e7ac0b(p, datum_type, datum_params) {
    if (datum_type === (0, $gyVUi.PJD_3PARAM)) //if( x[io] === HUGE_VAL )
    //    continue;
    return {
        x: p.x - datum_params[0],
        y: p.y - datum_params[1],
        z: p.z - datum_params[2]
    };
    else if (datum_type === (0, $gyVUi.PJD_7PARAM)) {
        var Dx_BF = datum_params[0];
        var Dy_BF = datum_params[1];
        var Dz_BF = datum_params[2];
        var Rx_BF = datum_params[3];
        var Ry_BF = datum_params[4];
        var Rz_BF = datum_params[5];
        var M_BF = datum_params[6];
        var x_tmp = (p.x - Dx_BF) / M_BF;
        var y_tmp = (p.y - Dy_BF) / M_BF;
        var z_tmp = (p.z - Dz_BF) / M_BF;
        //if( x[io] === HUGE_VAL )
        //    continue;
        return {
            x: x_tmp + Rz_BF * y_tmp - Ry_BF * z_tmp,
            y: -Rz_BF * x_tmp + y_tmp + Rx_BF * z_tmp,
            z: Ry_BF * x_tmp - Rx_BF * y_tmp + z_tmp
        };
    } //cs_geocentric_from_wgs84()
}



var $a9oRf = parcelRequire("a9oRf");
function $98d040a88dc0214f$var$checkParams(type) {
    return type === (0, $gyVUi.PJD_3PARAM) || type === (0, $gyVUi.PJD_7PARAM);
}
function $98d040a88dc0214f$export$2e2bcd8739ae039(source, dest, point) {
    // Short cut if the datums are identical.
    if ((0, $3a04bd721826a648$export$68c8d8590fbb24e4)(source, dest)) return point; // in this case, zero is sucess,
    // Explicitly skip datum transform by setting 'datum=none' as parameter for either source or dest
    if (source.datum_type === (0, $gyVUi.PJD_NODATUM) || dest.datum_type === (0, $gyVUi.PJD_NODATUM)) return point;
    // If this datum requires grid shifts, then apply it to geodetic coordinates.
    var source_a = source.a;
    var source_es = source.es;
    if (source.datum_type === (0, $gyVUi.PJD_GRIDSHIFT)) {
        var gridShiftCode = $98d040a88dc0214f$export$cfa06df23524576a(source, false, point);
        if (gridShiftCode !== 0) return undefined;
        source_a = (0, $gyVUi.SRS_WGS84_SEMIMAJOR);
        source_es = (0, $gyVUi.SRS_WGS84_ESQUARED);
    }
    var dest_a = dest.a;
    var dest_b = dest.b;
    var dest_es = dest.es;
    if (dest.datum_type === (0, $gyVUi.PJD_GRIDSHIFT)) {
        dest_a = (0, $gyVUi.SRS_WGS84_SEMIMAJOR);
        dest_b = (0, $gyVUi.SRS_WGS84_SEMIMINOR);
        dest_es = (0, $gyVUi.SRS_WGS84_ESQUARED);
    }
    // Do we need to go through geocentric coordinates?
    if (source_es === dest_es && source_a === dest_a && !$98d040a88dc0214f$var$checkParams(source.datum_type) && !$98d040a88dc0214f$var$checkParams(dest.datum_type)) return point;
    // Convert to geocentric coordinates.
    point = (0, $3a04bd721826a648$export$4a4ae2976f9a808a)(point, source_es, source_a);
    // Convert between datums
    if ($98d040a88dc0214f$var$checkParams(source.datum_type)) point = (0, $3a04bd721826a648$export$d18952b9ecb47c8f)(point, source.datum_type, source.datum_params);
    if ($98d040a88dc0214f$var$checkParams(dest.datum_type)) point = (0, $3a04bd721826a648$export$2b744ad521e7ac0b)(point, dest.datum_type, dest.datum_params);
    point = (0, $3a04bd721826a648$export$26210192c8922750)(point, dest_es, dest_a, dest_b);
    if (dest.datum_type === (0, $gyVUi.PJD_GRIDSHIFT)) {
        var destGridShiftResult = $98d040a88dc0214f$export$cfa06df23524576a(dest, true, point);
        if (destGridShiftResult !== 0) return undefined;
    }
    return point;
}
function $98d040a88dc0214f$export$cfa06df23524576a(source, inverse, point) {
    if (source.grids === null || source.grids.length === 0) {
        console.log('Grid shift grids not found');
        return -1;
    }
    var input = {
        x: -point.x,
        y: point.y
    };
    var output = {
        x: Number.NaN,
        y: Number.NaN
    };
    var onlyMandatoryGrids = false;
    var attemptedGrids = [];
    outer: for(var i = 0; i < source.grids.length; i++){
        var grid = source.grids[i];
        attemptedGrids.push(grid.name);
        if (grid.isNull) {
            output = input;
            break;
        }
        onlyMandatoryGrids = grid.mandatory;
        if (grid.grid === null) {
            if (grid.mandatory) {
                console.log("Unable to find mandatory grid '" + grid.name + "'");
                return -1;
            }
            continue;
        }
        var subgrids = grid.grid.subgrids;
        for(var j = 0, jj = subgrids.length; j < jj; j++){
            var subgrid = subgrids[j];
            // skip tables that don't match our point at all
            var epsilon = (Math.abs(subgrid.del[1]) + Math.abs(subgrid.del[0])) / 10000.0;
            var minX = subgrid.ll[0] - epsilon;
            var minY = subgrid.ll[1] - epsilon;
            var maxX = subgrid.ll[0] + (subgrid.lim[0] - 1) * subgrid.del[0] + epsilon;
            var maxY = subgrid.ll[1] + (subgrid.lim[1] - 1) * subgrid.del[1] + epsilon;
            if (minY > input.y || minX > input.x || maxY < input.y || maxX < input.x) continue;
            output = $98d040a88dc0214f$var$applySubgridShift(input, inverse, subgrid);
            if (!isNaN(output.x)) break outer;
        }
    }
    if (isNaN(output.x)) {
        console.log("Failed to find a grid shift table for location '" + -input.x * (0, $gyVUi.R2D) + " " + input.y * (0, $gyVUi.R2D) + " tried: '" + attemptedGrids + "'");
        return -1;
    }
    point.x = -output.x;
    point.y = output.y;
    return 0;
}
function $98d040a88dc0214f$var$applySubgridShift(pin, inverse, ct) {
    var val = {
        x: Number.NaN,
        y: Number.NaN
    };
    if (isNaN(pin.x)) return val;
    var tb = {
        x: pin.x,
        y: pin.y
    };
    tb.x -= ct.ll[0];
    tb.y -= ct.ll[1];
    tb.x = (0, $a9oRf.default)(tb.x - Math.PI) + Math.PI;
    var t = $98d040a88dc0214f$var$nadInterpolate(tb, ct);
    if (inverse) {
        if (isNaN(t.x)) return val;
        t.x = tb.x - t.x;
        t.y = tb.y - t.y;
        var i = 9, tol = 1e-12;
        var dif, del;
        do {
            del = $98d040a88dc0214f$var$nadInterpolate(t, ct);
            if (isNaN(del.x)) {
                console.log("Inverse grid shift iteration failed, presumably at grid edge.  Using first approximation.");
                break;
            }
            dif = {
                x: tb.x - (del.x + t.x),
                y: tb.y - (del.y + t.y)
            };
            t.x += dif.x;
            t.y += dif.y;
        }while (i-- && Math.abs(dif.x) > tol && Math.abs(dif.y) > tol);
        if (i < 0) {
            console.log("Inverse grid shift iterator failed to converge.");
            return val;
        }
        val.x = (0, $a9oRf.default)(t.x + ct.ll[0]);
        val.y = t.y + ct.ll[1];
    } else if (!isNaN(t.x)) {
        val.x = pin.x + t.x;
        val.y = pin.y + t.y;
    }
    return val;
}
function $98d040a88dc0214f$var$nadInterpolate(pin, ct) {
    var t = {
        x: pin.x / ct.del[0],
        y: pin.y / ct.del[1]
    };
    var indx = {
        x: Math.floor(t.x),
        y: Math.floor(t.y)
    };
    var frct = {
        x: t.x - 1.0 * indx.x,
        y: t.y - 1.0 * indx.y
    };
    var val = {
        x: Number.NaN,
        y: Number.NaN
    };
    var inx;
    if (indx.x < 0 || indx.x >= ct.lim[0]) return val;
    if (indx.y < 0 || indx.y >= ct.lim[1]) return val;
    inx = indx.y * ct.lim[0] + indx.x;
    var f00 = {
        x: ct.cvs[inx][0],
        y: ct.cvs[inx][1]
    };
    inx++;
    var f10 = {
        x: ct.cvs[inx][0],
        y: ct.cvs[inx][1]
    };
    inx += ct.lim[0];
    var f11 = {
        x: ct.cvs[inx][0],
        y: ct.cvs[inx][1]
    };
    inx--;
    var f01 = {
        x: ct.cvs[inx][0],
        y: ct.cvs[inx][1]
    };
    var m11 = frct.x * frct.y, m10 = frct.x * (1.0 - frct.y), m00 = (1.0 - frct.x) * (1.0 - frct.y), m01 = (1.0 - frct.x) * frct.y;
    val.x = m00 * f00.x + m10 * f10.x + m01 * f01.x + m11 * f11.x;
    val.y = m00 * f00.y + m10 * f10.y + m01 * f01.y + m11 * f11.y;
    return val;
}


function $cedb7bb5617791b0$export$2e2bcd8739ae039(crs, denorm, point) {
    var xin = point.x, yin = point.y, zin = point.z || 0.0;
    var v, t, i;
    var out = {};
    for(i = 0; i < 3; i++){
        if (denorm && i === 2 && point.z === undefined) continue;
        if (i === 0) {
            v = xin;
            if ("ew".indexOf(crs.axis[i]) !== -1) t = 'x';
            else t = 'y';
        } else if (i === 1) {
            v = yin;
            if ("ns".indexOf(crs.axis[i]) !== -1) t = 'y';
            else t = 'x';
        } else {
            v = zin;
            t = 'z';
        }
        switch(crs.axis[i]){
            case 'e':
                out[t] = v;
                break;
            case 'w':
                out[t] = -v;
                break;
            case 'n':
                out[t] = v;
                break;
            case 's':
                out[t] = -v;
                break;
            case 'u':
                if (point[t] !== undefined) out.z = v;
                break;
            case 'd':
                if (point[t] !== undefined) out.z = -v;
                break;
            default:
                //console.log("ERROR: unknow axis ("+crs.axis[i]+") - check definition of "+crs.projName);
                return null;
        }
    }
    return out;
}



function $01093474ae9bd8f6$export$2e2bcd8739ae039(array) {
    var out = {
        x: array[0],
        y: array[1]
    };
    if (array.length > 2) out.z = array[2];
    if (array.length > 3) out.m = array[3];
    return out;
}


function $906e8b8bdc80d434$export$2e2bcd8739ae039(point) {
    $906e8b8bdc80d434$var$checkCoord(point.x);
    $906e8b8bdc80d434$var$checkCoord(point.y);
}
function $906e8b8bdc80d434$var$checkCoord(num) {
    if (typeof Number.isFinite === 'function') {
        if (Number.isFinite(num)) return;
        throw new TypeError('coordinates must be finite numbers');
    }
    if (typeof num !== 'number' || num !== num || !isFinite(num)) throw new TypeError('coordinates must be finite numbers');
}


function $8e8cfb7cbefc2113$var$checkNotWGS(source, dest) {
    return (source.datum.datum_type === (0, $gyVUi.PJD_3PARAM) || source.datum.datum_type === (0, $gyVUi.PJD_7PARAM) || source.datum.datum_type === (0, $gyVUi.PJD_GRIDSHIFT)) && dest.datumCode !== 'WGS84' || (dest.datum.datum_type === (0, $gyVUi.PJD_3PARAM) || dest.datum.datum_type === (0, $gyVUi.PJD_7PARAM) || dest.datum.datum_type === (0, $gyVUi.PJD_GRIDSHIFT)) && source.datumCode !== 'WGS84';
}
function $8e8cfb7cbefc2113$export$2e2bcd8739ae039(source, dest, point, enforceAxis) {
    var wgs84;
    if (Array.isArray(point)) point = (0, $01093474ae9bd8f6$export$2e2bcd8739ae039)(point);
    else // Clone the point object so inputs don't get modified
    point = {
        x: point.x,
        y: point.y,
        z: point.z,
        m: point.m
    };
    var hasZ = point.z !== undefined;
    (0, $906e8b8bdc80d434$export$2e2bcd8739ae039)(point);
    // Workaround for datum shifts towgs84, if either source or destination projection is not wgs84
    if (source.datum && dest.datum && $8e8cfb7cbefc2113$var$checkNotWGS(source, dest)) {
        wgs84 = new (0, $24869d6338533b3b$export$2e2bcd8739ae039)('WGS84');
        point = $8e8cfb7cbefc2113$export$2e2bcd8739ae039(source, wgs84, point, enforceAxis);
        source = wgs84;
    }
    // DGR, 2010/11/12
    if (enforceAxis && source.axis !== 'enu') point = (0, $cedb7bb5617791b0$export$2e2bcd8739ae039)(source, false, point);
    // Transform source points to long/lat, if they aren't already.
    if (source.projName === 'longlat') point = {
        x: point.x * (0, $gyVUi.D2R),
        y: point.y * (0, $gyVUi.D2R),
        z: point.z || 0
    };
    else {
        if (source.to_meter) point = {
            x: point.x * source.to_meter,
            y: point.y * source.to_meter,
            z: point.z || 0
        };
        point = source.inverse(point); // Convert Cartesian to longlat
        if (!point) return;
    }
    // Adjust for the prime meridian if necessary
    if (source.from_greenwich) point.x += source.from_greenwich;
    // Convert datums if needed, and if possible.
    point = (0, $98d040a88dc0214f$export$2e2bcd8739ae039)(source.datum, dest.datum, point);
    if (!point) return;
    // Adjust for the prime meridian if necessary
    if (dest.from_greenwich) point = {
        x: point.x - dest.from_greenwich,
        y: point.y,
        z: point.z || 0
    };
    if (dest.projName === 'longlat') // convert radians to decimal degrees
    point = {
        x: point.x * (0, $gyVUi.R2D),
        y: point.y * (0, $gyVUi.R2D),
        z: point.z || 0
    };
    else {
        point = dest.forward(point);
        if (dest.to_meter) point = {
            x: point.x / dest.to_meter,
            y: point.y / dest.to_meter,
            z: point.z || 0
        };
    }
    // DGR, 2010/11/12
    if (enforceAxis && dest.axis !== 'enu') return (0, $cedb7bb5617791b0$export$2e2bcd8739ae039)(dest, true, point);
    if (point && !hasZ) delete point.z;
    return point;
}


var $471507637a3ff861$var$wgs84 = (0, $24869d6338533b3b$export$2e2bcd8739ae039)('WGS84');
function $471507637a3ff861$var$transformer(from, to, coords, enforceAxis) {
    var transformedArray, out, keys;
    if (Array.isArray(coords)) {
        transformedArray = (0, $8e8cfb7cbefc2113$export$2e2bcd8739ae039)(from, to, coords, enforceAxis) || {
            x: NaN,
            y: NaN
        };
        if (coords.length > 2) {
            if (typeof from.name !== 'undefined' && from.name === 'geocent' || typeof to.name !== 'undefined' && to.name === 'geocent') {
                if (typeof transformedArray.z === 'number') return [
                    transformedArray.x,
                    transformedArray.y,
                    transformedArray.z
                ].concat(coords.slice(3));
                else return [
                    transformedArray.x,
                    transformedArray.y,
                    coords[2]
                ].concat(coords.slice(3));
            } else return [
                transformedArray.x,
                transformedArray.y
            ].concat(coords.slice(2));
        } else return [
            transformedArray.x,
            transformedArray.y
        ];
    } else {
        out = (0, $8e8cfb7cbefc2113$export$2e2bcd8739ae039)(from, to, coords, enforceAxis);
        keys = Object.keys(coords);
        if (keys.length === 2) return out;
        keys.forEach(function(key) {
            if (typeof from.name !== 'undefined' && from.name === 'geocent' || typeof to.name !== 'undefined' && to.name === 'geocent') {
                if (key === 'x' || key === 'y' || key === 'z') return;
            } else {
                if (key === 'x' || key === 'y') return;
            }
            out[key] = coords[key];
        });
        return out;
    }
}
function $471507637a3ff861$var$checkProj(item) {
    if (item instanceof (0, $24869d6338533b3b$export$2e2bcd8739ae039)) return item;
    if (item.oProj) return item.oProj;
    return (0, $24869d6338533b3b$export$2e2bcd8739ae039)(item);
}
function $471507637a3ff861$var$proj4(fromProj, toProj, coord) {
    fromProj = $471507637a3ff861$var$checkProj(fromProj);
    var single = false;
    var obj;
    if (typeof toProj === 'undefined') {
        toProj = fromProj;
        fromProj = $471507637a3ff861$var$wgs84;
        single = true;
    } else if (typeof toProj.x !== 'undefined' || Array.isArray(toProj)) {
        coord = toProj;
        toProj = fromProj;
        fromProj = $471507637a3ff861$var$wgs84;
        single = true;
    }
    toProj = $471507637a3ff861$var$checkProj(toProj);
    if (coord) return $471507637a3ff861$var$transformer(fromProj, toProj, coord);
    else {
        obj = {
            forward: function(coords, enforceAxis) {
                return $471507637a3ff861$var$transformer(fromProj, toProj, coords, enforceAxis);
            },
            inverse: function(coords, enforceAxis) {
                return $471507637a3ff861$var$transformer(toProj, fromProj, coords, enforceAxis);
            }
        };
        if (single) obj.oProj = toProj;
        return obj;
    }
}
var $471507637a3ff861$export$2e2bcd8739ae039 = $471507637a3ff861$var$proj4;



/**
 * UTM zones are grouped, and assigned to one of a group of 6
 * sets.
 *
 * {int} @private
 */ var $31ee54b8e1d1cd8f$var$NUM_100K_SETS = 6;
/**
 * The column letters (for easting) of the lower left value, per
 * set.
 *
 * {string} @private
 */ var $31ee54b8e1d1cd8f$var$SET_ORIGIN_COLUMN_LETTERS = 'AJSAJS';
/**
 * The row letters (for northing) of the lower left value, per
 * set.
 *
 * {string} @private
 */ var $31ee54b8e1d1cd8f$var$SET_ORIGIN_ROW_LETTERS = 'AFAFAF';
var $31ee54b8e1d1cd8f$var$A = 65; // A
var $31ee54b8e1d1cd8f$var$I = 73; // I
var $31ee54b8e1d1cd8f$var$O = 79; // O
var $31ee54b8e1d1cd8f$var$V = 86; // V
var $31ee54b8e1d1cd8f$var$Z = 90; // Z
var $31ee54b8e1d1cd8f$export$2e2bcd8739ae039 = {
    forward: $31ee54b8e1d1cd8f$export$174bb771924e7eb1,
    inverse: $31ee54b8e1d1cd8f$export$70ae2c07e401031b,
    toPoint: $31ee54b8e1d1cd8f$export$b63cca88ddc558a9
};
function $31ee54b8e1d1cd8f$export$174bb771924e7eb1(ll, accuracy) {
    accuracy = accuracy || 5; // default accuracy 1m
    return $31ee54b8e1d1cd8f$var$encode($31ee54b8e1d1cd8f$var$LLtoUTM({
        lat: ll[1],
        lon: ll[0]
    }), accuracy);
}
function $31ee54b8e1d1cd8f$export$70ae2c07e401031b(mgrs) {
    var bbox = $31ee54b8e1d1cd8f$var$UTMtoLL($31ee54b8e1d1cd8f$var$decode(mgrs.toUpperCase()));
    if (bbox.lat && bbox.lon) return [
        bbox.lon,
        bbox.lat,
        bbox.lon,
        bbox.lat
    ];
    return [
        bbox.left,
        bbox.bottom,
        bbox.right,
        bbox.top
    ];
}
function $31ee54b8e1d1cd8f$export$b63cca88ddc558a9(mgrs) {
    var bbox = $31ee54b8e1d1cd8f$var$UTMtoLL($31ee54b8e1d1cd8f$var$decode(mgrs.toUpperCase()));
    if (bbox.lat && bbox.lon) return [
        bbox.lon,
        bbox.lat
    ];
    return [
        (bbox.left + bbox.right) / 2,
        (bbox.top + bbox.bottom) / 2
    ];
}
/**
 * Conversion from degrees to radians.
 *
 * @private
 * @param {number} deg the angle in degrees.
 * @return {number} the angle in radians.
 */ function $31ee54b8e1d1cd8f$var$degToRad(deg) {
    return deg * (Math.PI / 180.0);
}
/**
 * Conversion from radians to degrees.
 *
 * @private
 * @param {number} rad the angle in radians.
 * @return {number} the angle in degrees.
 */ function $31ee54b8e1d1cd8f$var$radToDeg(rad) {
    return 180.0 * (rad / Math.PI);
}
/**
 * Converts a set of Longitude and Latitude co-ordinates to UTM
 * using the WGS84 ellipsoid.
 *
 * @private
 * @param {object} ll Object literal with lat and lon properties
 *     representing the WGS84 coordinate to be converted.
 * @return {object} Object literal containing the UTM value with easting,
 *     northing, zoneNumber and zoneLetter properties, and an optional
 *     accuracy property in digits. Returns null if the conversion failed.
 */ function $31ee54b8e1d1cd8f$var$LLtoUTM(ll) {
    var Lat = ll.lat;
    var Long = ll.lon;
    var a = 6378137.0; //ellip.radius;
    var eccSquared = 0.00669438; //ellip.eccsq;
    var k0 = 0.9996;
    var LongOrigin;
    var eccPrimeSquared;
    var N, T, C, A, M;
    var LatRad = $31ee54b8e1d1cd8f$var$degToRad(Lat);
    var LongRad = $31ee54b8e1d1cd8f$var$degToRad(Long);
    var LongOriginRad;
    var ZoneNumber;
    // (int)
    ZoneNumber = Math.floor((Long + 180) / 6) + 1;
    //Make sure the longitude 180.00 is in Zone 60
    if (Long === 180) ZoneNumber = 60;
    // Special zone for Norway
    if (Lat >= 56.0 && Lat < 64.0 && Long >= 3.0 && Long < 12.0) ZoneNumber = 32;
    // Special zones for Svalbard
    if (Lat >= 72.0 && Lat < 84.0) {
        if (Long >= 0.0 && Long < 9.0) ZoneNumber = 31;
        else if (Long >= 9.0 && Long < 21.0) ZoneNumber = 33;
        else if (Long >= 21.0 && Long < 33.0) ZoneNumber = 35;
        else if (Long >= 33.0 && Long < 42.0) ZoneNumber = 37;
    }
    LongOrigin = (ZoneNumber - 1) * 6 - 180 + 3; //+3 puts origin
    // in middle of
    // zone
    LongOriginRad = $31ee54b8e1d1cd8f$var$degToRad(LongOrigin);
    eccPrimeSquared = eccSquared / (1 - eccSquared);
    N = a / Math.sqrt(1 - eccSquared * Math.sin(LatRad) * Math.sin(LatRad));
    T = Math.tan(LatRad) * Math.tan(LatRad);
    C = eccPrimeSquared * Math.cos(LatRad) * Math.cos(LatRad);
    A = Math.cos(LatRad) * (LongRad - LongOriginRad);
    M = a * ((1 - eccSquared / 4 - 3 * eccSquared * eccSquared / 64 - 5 * eccSquared * eccSquared * eccSquared / 256) * LatRad - (3 * eccSquared / 8 + 3 * eccSquared * eccSquared / 32 + 45 * eccSquared * eccSquared * eccSquared / 1024) * Math.sin(2 * LatRad) + (15 * eccSquared * eccSquared / 256 + 45 * eccSquared * eccSquared * eccSquared / 1024) * Math.sin(4 * LatRad) - 35 * eccSquared * eccSquared * eccSquared / 3072 * Math.sin(6 * LatRad));
    var UTMEasting = k0 * N * (A + (1 - T + C) * A * A * A / 6.0 + (5 - 18 * T + T * T + 72 * C - 58 * eccPrimeSquared) * A * A * A * A * A / 120.0) + 500000.0;
    var UTMNorthing = k0 * (M + N * Math.tan(LatRad) * (A * A / 2 + (5 - T + 9 * C + 4 * C * C) * A * A * A * A / 24.0 + (61 - 58 * T + T * T + 600 * C - 330 * eccPrimeSquared) * A * A * A * A * A * A / 720.0));
    if (Lat < 0.0) UTMNorthing += 10000000.0; //10000000 meter offset for
    return {
        northing: Math.round(UTMNorthing),
        easting: Math.round(UTMEasting),
        zoneNumber: ZoneNumber,
        zoneLetter: $31ee54b8e1d1cd8f$var$getLetterDesignator(Lat)
    };
}
/**
 * Converts UTM coords to lat/long, using the WGS84 ellipsoid. This is a convenience
 * class where the Zone can be specified as a single string eg."60N" which
 * is then broken down into the ZoneNumber and ZoneLetter.
 *
 * @private
 * @param {object} utm An object literal with northing, easting, zoneNumber
 *     and zoneLetter properties. If an optional accuracy property is
 *     provided (in meters), a bounding box will be returned instead of
 *     latitude and longitude.
 * @return {object} An object literal containing either lat and lon values
 *     (if no accuracy was provided), or top, right, bottom and left values
 *     for the bounding box calculated according to the provided accuracy.
 *     Returns null if the conversion failed.
 */ function $31ee54b8e1d1cd8f$var$UTMtoLL(utm) {
    var UTMNorthing = utm.northing;
    var UTMEasting = utm.easting;
    var zoneLetter = utm.zoneLetter;
    var zoneNumber = utm.zoneNumber;
    // check the ZoneNummber is valid
    if (zoneNumber < 0 || zoneNumber > 60) return null;
    var k0 = 0.9996;
    var a = 6378137.0; //ellip.radius;
    var eccSquared = 0.00669438; //ellip.eccsq;
    var eccPrimeSquared;
    var e1 = (1 - Math.sqrt(1 - eccSquared)) / (1 + Math.sqrt(1 - eccSquared));
    var N1, T1, C1, R1, D, M;
    var LongOrigin;
    var mu, phi1Rad;
    // remove 500,000 meter offset for longitude
    var x = UTMEasting - 500000.0;
    var y = UTMNorthing;
    // We must know somehow if we are in the Northern or Southern
    // hemisphere, this is the only time we use the letter So even
    // if the Zone letter isn't exactly correct it should indicate
    // the hemisphere correctly
    if (zoneLetter < 'N') y -= 10000000.0; // remove 10,000,000 meter offset used
    // There are 60 zones with zone 1 being at West -180 to -174
    LongOrigin = (zoneNumber - 1) * 6 - 180 + 3; // +3 puts origin
    // in middle of
    // zone
    eccPrimeSquared = eccSquared / (1 - eccSquared);
    M = y / k0;
    mu = M / (a * (1 - eccSquared / 4 - 3 * eccSquared * eccSquared / 64 - 5 * eccSquared * eccSquared * eccSquared / 256));
    phi1Rad = mu + (3 * e1 / 2 - 27 * e1 * e1 * e1 / 32) * Math.sin(2 * mu) + (21 * e1 * e1 / 16 - 55 * e1 * e1 * e1 * e1 / 32) * Math.sin(4 * mu) + 151 * e1 * e1 * e1 / 96 * Math.sin(6 * mu);
    // double phi1 = ProjMath.radToDeg(phi1Rad);
    N1 = a / Math.sqrt(1 - eccSquared * Math.sin(phi1Rad) * Math.sin(phi1Rad));
    T1 = Math.tan(phi1Rad) * Math.tan(phi1Rad);
    C1 = eccPrimeSquared * Math.cos(phi1Rad) * Math.cos(phi1Rad);
    R1 = a * (1 - eccSquared) / Math.pow(1 - eccSquared * Math.sin(phi1Rad) * Math.sin(phi1Rad), 1.5);
    D = x / (N1 * k0);
    var lat = phi1Rad - N1 * Math.tan(phi1Rad) / R1 * (D * D / 2 - (5 + 3 * T1 + 10 * C1 - 4 * C1 * C1 - 9 * eccPrimeSquared) * D * D * D * D / 24 + (61 + 90 * T1 + 298 * C1 + 45 * T1 * T1 - 252 * eccPrimeSquared - 3 * C1 * C1) * D * D * D * D * D * D / 720);
    lat = $31ee54b8e1d1cd8f$var$radToDeg(lat);
    var lon = (D - (1 + 2 * T1 + C1) * D * D * D / 6 + (5 - 2 * C1 + 28 * T1 - 3 * C1 * C1 + 8 * eccPrimeSquared + 24 * T1 * T1) * D * D * D * D * D / 120) / Math.cos(phi1Rad);
    lon = LongOrigin + $31ee54b8e1d1cd8f$var$radToDeg(lon);
    var result;
    if (utm.accuracy) {
        var topRight = $31ee54b8e1d1cd8f$var$UTMtoLL({
            northing: utm.northing + utm.accuracy,
            easting: utm.easting + utm.accuracy,
            zoneLetter: utm.zoneLetter,
            zoneNumber: utm.zoneNumber
        });
        result = {
            top: topRight.lat,
            right: topRight.lon,
            bottom: lat,
            left: lon
        };
    } else result = {
        lat: lat,
        lon: lon
    };
    return result;
}
/**
 * Calculates the MGRS letter designator for the given latitude.
 *
 * @private
 * @param {number} lat The latitude in WGS84 to get the letter designator
 *     for.
 * @return {char} The letter designator.
 */ function $31ee54b8e1d1cd8f$var$getLetterDesignator(lat) {
    //This is here as an error flag to show that the Latitude is
    //outside MGRS limits
    var LetterDesignator = 'Z';
    if (84 >= lat && lat >= 72) LetterDesignator = 'X';
    else if (72 > lat && lat >= 64) LetterDesignator = 'W';
    else if (64 > lat && lat >= 56) LetterDesignator = 'V';
    else if (56 > lat && lat >= 48) LetterDesignator = 'U';
    else if (48 > lat && lat >= 40) LetterDesignator = 'T';
    else if (40 > lat && lat >= 32) LetterDesignator = 'S';
    else if (32 > lat && lat >= 24) LetterDesignator = 'R';
    else if (24 > lat && lat >= 16) LetterDesignator = 'Q';
    else if (16 > lat && lat >= 8) LetterDesignator = 'P';
    else if (8 > lat && lat >= 0) LetterDesignator = 'N';
    else if (0 > lat && lat >= -8) LetterDesignator = 'M';
    else if (-8 > lat && lat >= -16) LetterDesignator = 'L';
    else if (-16 > lat && lat >= -24) LetterDesignator = 'K';
    else if (-24 > lat && lat >= -32) LetterDesignator = 'J';
    else if (-32 > lat && lat >= -40) LetterDesignator = 'H';
    else if (-40 > lat && lat >= -48) LetterDesignator = 'G';
    else if (-48 > lat && lat >= -56) LetterDesignator = 'F';
    else if (-56 > lat && lat >= -64) LetterDesignator = 'E';
    else if (-64 > lat && lat >= -72) LetterDesignator = 'D';
    else if (-72 > lat && lat >= -80) LetterDesignator = 'C';
    return LetterDesignator;
}
/**
 * Encodes a UTM location as MGRS string.
 *
 * @private
 * @param {object} utm An object literal with easting, northing,
 *     zoneLetter, zoneNumber
 * @param {number} accuracy Accuracy in digits (1-5).
 * @return {string} MGRS string for the given UTM location.
 */ function $31ee54b8e1d1cd8f$var$encode(utm, accuracy) {
    // prepend with leading zeroes
    var seasting = "00000" + utm.easting, snorthing = "00000" + utm.northing;
    return utm.zoneNumber + utm.zoneLetter + $31ee54b8e1d1cd8f$var$get100kID(utm.easting, utm.northing, utm.zoneNumber) + seasting.substr(seasting.length - 5, accuracy) + snorthing.substr(snorthing.length - 5, accuracy);
}
/**
 * Get the two letter 100k designator for a given UTM easting,
 * northing and zone number value.
 *
 * @private
 * @param {number} easting
 * @param {number} northing
 * @param {number} zoneNumber
 * @return the two letter 100k designator for the given UTM location.
 */ function $31ee54b8e1d1cd8f$var$get100kID(easting, northing, zoneNumber) {
    var setParm = $31ee54b8e1d1cd8f$var$get100kSetForZone(zoneNumber);
    var setColumn = Math.floor(easting / 100000);
    var setRow = Math.floor(northing / 100000) % 20;
    return $31ee54b8e1d1cd8f$var$getLetter100kID(setColumn, setRow, setParm);
}
/**
 * Given a UTM zone number, figure out the MGRS 100K set it is in.
 *
 * @private
 * @param {number} i An UTM zone number.
 * @return {number} the 100k set the UTM zone is in.
 */ function $31ee54b8e1d1cd8f$var$get100kSetForZone(i) {
    var setParm = i % $31ee54b8e1d1cd8f$var$NUM_100K_SETS;
    if (setParm === 0) setParm = $31ee54b8e1d1cd8f$var$NUM_100K_SETS;
    return setParm;
}
/**
 * Get the two-letter MGRS 100k designator given information
 * translated from the UTM northing, easting and zone number.
 *
 * @private
 * @param {number} column the column index as it relates to the MGRS
 *        100k set spreadsheet, created from the UTM easting.
 *        Values are 1-8.
 * @param {number} row the row index as it relates to the MGRS 100k set
 *        spreadsheet, created from the UTM northing value. Values
 *        are from 0-19.
 * @param {number} parm the set block, as it relates to the MGRS 100k set
 *        spreadsheet, created from the UTM zone. Values are from
 *        1-60.
 * @return two letter MGRS 100k code.
 */ function $31ee54b8e1d1cd8f$var$getLetter100kID(column, row, parm) {
    // colOrigin and rowOrigin are the letters at the origin of the set
    var index = parm - 1;
    var colOrigin = $31ee54b8e1d1cd8f$var$SET_ORIGIN_COLUMN_LETTERS.charCodeAt(index);
    var rowOrigin = $31ee54b8e1d1cd8f$var$SET_ORIGIN_ROW_LETTERS.charCodeAt(index);
    // colInt and rowInt are the letters to build to return
    var colInt = colOrigin + column - 1;
    var rowInt = rowOrigin + row;
    var rollover = false;
    if (colInt > $31ee54b8e1d1cd8f$var$Z) {
        colInt = colInt - $31ee54b8e1d1cd8f$var$Z + $31ee54b8e1d1cd8f$var$A - 1;
        rollover = true;
    }
    if (colInt === $31ee54b8e1d1cd8f$var$I || colOrigin < $31ee54b8e1d1cd8f$var$I && colInt > $31ee54b8e1d1cd8f$var$I || (colInt > $31ee54b8e1d1cd8f$var$I || colOrigin < $31ee54b8e1d1cd8f$var$I) && rollover) colInt++;
    if (colInt === $31ee54b8e1d1cd8f$var$O || colOrigin < $31ee54b8e1d1cd8f$var$O && colInt > $31ee54b8e1d1cd8f$var$O || (colInt > $31ee54b8e1d1cd8f$var$O || colOrigin < $31ee54b8e1d1cd8f$var$O) && rollover) {
        colInt++;
        if (colInt === $31ee54b8e1d1cd8f$var$I) colInt++;
    }
    if (colInt > $31ee54b8e1d1cd8f$var$Z) colInt = colInt - $31ee54b8e1d1cd8f$var$Z + $31ee54b8e1d1cd8f$var$A - 1;
    if (rowInt > $31ee54b8e1d1cd8f$var$V) {
        rowInt = rowInt - $31ee54b8e1d1cd8f$var$V + $31ee54b8e1d1cd8f$var$A - 1;
        rollover = true;
    } else rollover = false;
    if (rowInt === $31ee54b8e1d1cd8f$var$I || rowOrigin < $31ee54b8e1d1cd8f$var$I && rowInt > $31ee54b8e1d1cd8f$var$I || (rowInt > $31ee54b8e1d1cd8f$var$I || rowOrigin < $31ee54b8e1d1cd8f$var$I) && rollover) rowInt++;
    if (rowInt === $31ee54b8e1d1cd8f$var$O || rowOrigin < $31ee54b8e1d1cd8f$var$O && rowInt > $31ee54b8e1d1cd8f$var$O || (rowInt > $31ee54b8e1d1cd8f$var$O || rowOrigin < $31ee54b8e1d1cd8f$var$O) && rollover) {
        rowInt++;
        if (rowInt === $31ee54b8e1d1cd8f$var$I) rowInt++;
    }
    if (rowInt > $31ee54b8e1d1cd8f$var$V) rowInt = rowInt - $31ee54b8e1d1cd8f$var$V + $31ee54b8e1d1cd8f$var$A - 1;
    var twoLetter = String.fromCharCode(colInt) + String.fromCharCode(rowInt);
    return twoLetter;
}
/**
 * Decode the UTM parameters from a MGRS string.
 *
 * @private
 * @param {string} mgrsString an UPPERCASE coordinate string is expected.
 * @return {object} An object literal with easting, northing, zoneLetter,
 *     zoneNumber and accuracy (in meters) properties.
 */ function $31ee54b8e1d1cd8f$var$decode(mgrsString) {
    if (mgrsString && mgrsString.length === 0) throw "MGRSPoint coverting from nothing";
    var length = mgrsString.length;
    var hunK = null;
    var sb = "";
    var testChar;
    var i = 0;
    // get Zone number
    while(!/[A-Z]/.test(testChar = mgrsString.charAt(i))){
        if (i >= 2) throw "MGRSPoint bad conversion from: " + mgrsString;
        sb += testChar;
        i++;
    }
    var zoneNumber = parseInt(sb, 10);
    if (i === 0 || i + 3 > length) // A good MGRS string has to be 4-5 digits long,
    // ##AAA/#AAA at least.
    throw "MGRSPoint bad conversion from: " + mgrsString;
    var zoneLetter = mgrsString.charAt(i++);
    // Should we check the zone letter here? Why not.
    if (zoneLetter <= 'A' || zoneLetter === 'B' || zoneLetter === 'Y' || zoneLetter >= 'Z' || zoneLetter === 'I' || zoneLetter === 'O') throw "MGRSPoint zone letter " + zoneLetter + " not handled: " + mgrsString;
    hunK = mgrsString.substring(i, i += 2);
    var set = $31ee54b8e1d1cd8f$var$get100kSetForZone(zoneNumber);
    var east100k = $31ee54b8e1d1cd8f$var$getEastingFromChar(hunK.charAt(0), set);
    var north100k = $31ee54b8e1d1cd8f$var$getNorthingFromChar(hunK.charAt(1), set);
    // We have a bug where the northing may be 2000000 too low.
    // How
    // do we know when to roll over?
    while(north100k < $31ee54b8e1d1cd8f$var$getMinNorthing(zoneLetter))north100k += 2000000;
    // calculate the char index for easting/northing separator
    var remainder = length - i;
    if (remainder % 2 !== 0) throw "MGRSPoint has to have an even number \nof digits after the zone letter and two 100km letters - front \nhalf for easting meters, second half for \nnorthing meters" + mgrsString;
    var sep = remainder / 2;
    var sepEasting = 0.0;
    var sepNorthing = 0.0;
    var accuracyBonus, sepEastingString, sepNorthingString, easting, northing;
    if (sep > 0) {
        accuracyBonus = 100000.0 / Math.pow(10, sep);
        sepEastingString = mgrsString.substring(i, i + sep);
        sepEasting = parseFloat(sepEastingString) * accuracyBonus;
        sepNorthingString = mgrsString.substring(i + sep);
        sepNorthing = parseFloat(sepNorthingString) * accuracyBonus;
    }
    easting = sepEasting + east100k;
    northing = sepNorthing + north100k;
    return {
        easting: easting,
        northing: northing,
        zoneLetter: zoneLetter,
        zoneNumber: zoneNumber,
        accuracy: accuracyBonus
    };
}
/**
 * Given the first letter from a two-letter MGRS 100k zone, and given the
 * MGRS table set for the zone number, figure out the easting value that
 * should be added to the other, secondary easting value.
 *
 * @private
 * @param {char} e The first letter from a two-letter MGRS 100´k zone.
 * @param {number} set The MGRS table set for the zone number.
 * @return {number} The easting value for the given letter and set.
 */ function $31ee54b8e1d1cd8f$var$getEastingFromChar(e, set) {
    // colOrigin is the letter at the origin of the set for the
    // column
    var curCol = $31ee54b8e1d1cd8f$var$SET_ORIGIN_COLUMN_LETTERS.charCodeAt(set - 1);
    var eastingValue = 100000.0;
    var rewindMarker = false;
    while(curCol !== e.charCodeAt(0)){
        curCol++;
        if (curCol === $31ee54b8e1d1cd8f$var$I) curCol++;
        if (curCol === $31ee54b8e1d1cd8f$var$O) curCol++;
        if (curCol > $31ee54b8e1d1cd8f$var$Z) {
            if (rewindMarker) throw "Bad character: " + e;
            curCol = $31ee54b8e1d1cd8f$var$A;
            rewindMarker = true;
        }
        eastingValue += 100000.0;
    }
    return eastingValue;
}
/**
 * Given the second letter from a two-letter MGRS 100k zone, and given the
 * MGRS table set for the zone number, figure out the northing value that
 * should be added to the other, secondary northing value. You have to
 * remember that Northings are determined from the equator, and the vertical
 * cycle of letters mean a 2000000 additional northing meters. This happens
 * approx. every 18 degrees of latitude. This method does *NOT* count any
 * additional northings. You have to figure out how many 2000000 meters need
 * to be added for the zone letter of the MGRS coordinate.
 *
 * @private
 * @param {char} n Second letter of the MGRS 100k zone
 * @param {number} set The MGRS table set number, which is dependent on the
 *     UTM zone number.
 * @return {number} The northing value for the given letter and set.
 */ function $31ee54b8e1d1cd8f$var$getNorthingFromChar(n, set) {
    if (n > 'V') throw "MGRSPoint given invalid Northing " + n;
    // rowOrigin is the letter at the origin of the set for the
    // column
    var curRow = $31ee54b8e1d1cd8f$var$SET_ORIGIN_ROW_LETTERS.charCodeAt(set - 1);
    var northingValue = 0.0;
    var rewindMarker = false;
    while(curRow !== n.charCodeAt(0)){
        curRow++;
        if (curRow === $31ee54b8e1d1cd8f$var$I) curRow++;
        if (curRow === $31ee54b8e1d1cd8f$var$O) curRow++;
        // fixing a bug making whole application hang in this loop
        // when 'n' is a wrong character
        if (curRow > $31ee54b8e1d1cd8f$var$V) {
            if (rewindMarker) throw "Bad character: " + n;
            curRow = $31ee54b8e1d1cd8f$var$A;
            rewindMarker = true;
        }
        northingValue += 100000.0;
    }
    return northingValue;
}
/**
 * The function getMinNorthing returns the minimum northing value of a MGRS
 * zone.
 *
 * Ported from Geotrans' c Lattitude_Band_Value structure table.
 *
 * @private
 * @param {char} zoneLetter The MGRS zone to get the min northing for.
 * @return {number}
 */ function $31ee54b8e1d1cd8f$var$getMinNorthing(zoneLetter) {
    var northing;
    switch(zoneLetter){
        case 'C':
            northing = 1100000.0;
            break;
        case 'D':
            northing = 2000000.0;
            break;
        case 'E':
            northing = 2800000.0;
            break;
        case 'F':
            northing = 3700000.0;
            break;
        case 'G':
            northing = 4600000.0;
            break;
        case 'H':
            northing = 5500000.0;
            break;
        case 'J':
            northing = 6400000.0;
            break;
        case 'K':
            northing = 7300000.0;
            break;
        case 'L':
            northing = 8200000.0;
            break;
        case 'M':
            northing = 9100000.0;
            break;
        case 'N':
            northing = 0.0;
            break;
        case 'P':
            northing = 800000.0;
            break;
        case 'Q':
            northing = 1700000.0;
            break;
        case 'R':
            northing = 2600000.0;
            break;
        case 'S':
            northing = 3500000.0;
            break;
        case 'T':
            northing = 4400000.0;
            break;
        case 'U':
            northing = 5300000.0;
            break;
        case 'V':
            northing = 6200000.0;
            break;
        case 'W':
            northing = 7000000.0;
            break;
        case 'X':
            northing = 7900000.0;
            break;
        default:
            northing = -1;
    }
    if (northing >= 0.0) return northing;
    else throw "Invalid zone letter: " + zoneLetter;
}


function $d8ec3fc1ff061c76$var$Point(x, y, z) {
    if (!(this instanceof $d8ec3fc1ff061c76$var$Point)) return new $d8ec3fc1ff061c76$var$Point(x, y, z);
    if (Array.isArray(x)) {
        this.x = x[0];
        this.y = x[1];
        this.z = x[2] || 0.0;
    } else if (typeof x === 'object') {
        this.x = x.x;
        this.y = x.y;
        this.z = x.z || 0.0;
    } else if (typeof x === 'string' && typeof y === 'undefined') {
        var coords = x.split(',');
        this.x = parseFloat(coords[0], 10);
        this.y = parseFloat(coords[1], 10);
        this.z = parseFloat(coords[2], 10) || 0.0;
    } else {
        this.x = x;
        this.y = y;
        this.z = z || 0.0;
    }
    console.warn('proj4.Point will be removed in version 3, use proj4.toPoint');
}
$d8ec3fc1ff061c76$var$Point.fromMGRS = function(mgrsStr) {
    return new $d8ec3fc1ff061c76$var$Point((0, $31ee54b8e1d1cd8f$export$b63cca88ddc558a9)(mgrsStr));
};
$d8ec3fc1ff061c76$var$Point.prototype.toMGRS = function(accuracy) {
    return (0, $31ee54b8e1d1cd8f$export$174bb771924e7eb1)([
        this.x,
        this.y
    ], accuracy);
};
var $d8ec3fc1ff061c76$export$2e2bcd8739ae039 = $d8ec3fc1ff061c76$var$Point;








var $9t3dO = parcelRequire("9t3dO");

var $9zr9G = parcelRequire("9zr9G");

var $a9oRf = parcelRequire("a9oRf");
function $810f2c2910fd20b1$export$2e2bcd8739ae039(zone, lon) {
    if (zone === undefined) {
        zone = Math.floor(((0, $a9oRf.default)(lon) + Math.PI) * 30 / Math.PI) + 1;
        if (zone < 0) return 0;
        else if (zone > 60) return 60;
    }
    return zone;
}



var $9zr9G = parcelRequire("9zr9G");

var $gyVUi = parcelRequire("gyVUi");
var $efe46ba059d82de2$export$3f91ef0e0d0d8bf8 = 'etmerc';
function $efe46ba059d82de2$export$2cd8252107eb640b() {
    var zone = (0, $810f2c2910fd20b1$export$2e2bcd8739ae039)(this.zone, this.long0);
    if (zone === undefined) throw new Error('unknown utm zone');
    this.lat0 = 0;
    this.long0 = (6 * Math.abs(zone) - 183) * (0, $gyVUi.D2R);
    this.x0 = 500000;
    this.y0 = this.utmSouth ? 10000000 : 0;
    this.k0 = 0.9996;
    (0, $9zr9G.default).init.apply(this);
    this.forward = (0, $9zr9G.default).forward;
    this.inverse = (0, $9zr9G.default).inverse;
}
var $efe46ba059d82de2$export$e4b2ac9215619f8d = [
    "Universal Transverse Mercator System",
    "utm"
];
var $efe46ba059d82de2$export$2e2bcd8739ae039 = {
    init: $efe46ba059d82de2$export$2cd8252107eb640b,
    names: $efe46ba059d82de2$export$e4b2ac9215619f8d,
    dependsOn: $efe46ba059d82de2$export$3f91ef0e0d0d8bf8
};


function $5db95ad4da70d3a6$export$2e2bcd8739ae039(esinp, exp) {
    return Math.pow((1 - esinp) / (1 + esinp), exp);
}



var $gyVUi = parcelRequire("gyVUi");
var $06b464b721451620$var$MAX_ITER = 20;
function $06b464b721451620$export$2cd8252107eb640b() {
    var sphi = Math.sin(this.lat0);
    var cphi = Math.cos(this.lat0);
    cphi *= cphi;
    this.rc = Math.sqrt(1 - this.es) / (1 - this.es * sphi * sphi);
    this.C = Math.sqrt(1 + this.es * cphi * cphi / (1 - this.es));
    this.phic0 = Math.asin(sphi / this.C);
    this.ratexp = 0.5 * this.C * this.e;
    this.K = Math.tan(0.5 * this.phic0 + (0, $gyVUi.FORTPI)) / (Math.pow(Math.tan(0.5 * this.lat0 + (0, $gyVUi.FORTPI)), this.C) * (0, $5db95ad4da70d3a6$export$2e2bcd8739ae039)(this.e * sphi, this.ratexp));
}
function $06b464b721451620$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    p.y = 2 * Math.atan(this.K * Math.pow(Math.tan(0.5 * lat + (0, $gyVUi.FORTPI)), this.C) * (0, $5db95ad4da70d3a6$export$2e2bcd8739ae039)(this.e * Math.sin(lat), this.ratexp)) - (0, $gyVUi.HALF_PI);
    p.x = this.C * lon;
    return p;
}
function $06b464b721451620$export$70ae2c07e401031b(p) {
    var DEL_TOL = 1e-14;
    var lon = p.x / this.C;
    var lat = p.y;
    var num = Math.pow(Math.tan(0.5 * lat + (0, $gyVUi.FORTPI)) / this.K, 1 / this.C);
    for(var i = $06b464b721451620$var$MAX_ITER; i > 0; --i){
        lat = 2 * Math.atan(num * (0, $5db95ad4da70d3a6$export$2e2bcd8739ae039)(this.e * Math.sin(p.y), -0.5 * this.e)) - (0, $gyVUi.HALF_PI);
        if (Math.abs(lat - p.y) < DEL_TOL) break;
        p.y = lat;
    }
    /* convergence failed */ if (!i) return null;
    p.x = lon;
    p.y = lat;
    return p;
}
var $06b464b721451620$export$e4b2ac9215619f8d = [
    "gauss"
];
var $06b464b721451620$export$2e2bcd8739ae039 = {
    init: $06b464b721451620$export$2cd8252107eb640b,
    forward: $06b464b721451620$export$174bb771924e7eb1,
    inverse: $06b464b721451620$export$70ae2c07e401031b,
    names: $06b464b721451620$export$e4b2ac9215619f8d
};



var $a9oRf = parcelRequire("a9oRf");

var $jU5gu = parcelRequire("jU5gu");
function $4279f8b9d31284e6$export$2cd8252107eb640b() {
    (0, $06b464b721451620$export$2e2bcd8739ae039).init.apply(this);
    if (!this.rc) return;
    this.sinc0 = Math.sin(this.phic0);
    this.cosc0 = Math.cos(this.phic0);
    this.R2 = 2 * this.rc;
    if (!this.title) this.title = "Oblique Stereographic Alternative";
}
function $4279f8b9d31284e6$export$174bb771924e7eb1(p) {
    var sinc, cosc, cosl, k;
    p.x = (0, $a9oRf.default)(p.x - this.long0);
    (0, $06b464b721451620$export$2e2bcd8739ae039).forward.apply(this, [
        p
    ]);
    sinc = Math.sin(p.y);
    cosc = Math.cos(p.y);
    cosl = Math.cos(p.x);
    k = this.k0 * this.R2 / (1 + this.sinc0 * sinc + this.cosc0 * cosc * cosl);
    p.x = k * cosc * Math.sin(p.x);
    p.y = k * (this.cosc0 * sinc - this.sinc0 * cosc * cosl);
    p.x = this.a * p.x + this.x0;
    p.y = this.a * p.y + this.y0;
    return p;
}
function $4279f8b9d31284e6$export$70ae2c07e401031b(p) {
    var sinc, cosc, lon, lat, rho;
    p.x = (p.x - this.x0) / this.a;
    p.y = (p.y - this.y0) / this.a;
    p.x /= this.k0;
    p.y /= this.k0;
    if (rho = (0, $jU5gu.default)(p.x, p.y)) {
        var c = 2 * Math.atan2(rho, this.R2);
        sinc = Math.sin(c);
        cosc = Math.cos(c);
        lat = Math.asin(cosc * this.sinc0 + p.y * sinc * this.cosc0 / rho);
        lon = Math.atan2(p.x * sinc, rho * this.cosc0 * cosc - p.y * this.sinc0 * sinc);
    } else {
        lat = this.phic0;
        lon = 0;
    }
    p.x = lon;
    p.y = lat;
    (0, $06b464b721451620$export$2e2bcd8739ae039).inverse.apply(this, [
        p
    ]);
    p.x = (0, $a9oRf.default)(p.x + this.long0);
    return p;
}
var $4279f8b9d31284e6$export$e4b2ac9215619f8d = [
    "Stereographic_North_Pole",
    "Oblique_Stereographic",
    "sterea",
    "Oblique Stereographic Alternative",
    "Double_Stereographic"
];
var $4279f8b9d31284e6$export$2e2bcd8739ae039 = {
    init: $4279f8b9d31284e6$export$2cd8252107eb640b,
    forward: $4279f8b9d31284e6$export$174bb771924e7eb1,
    inverse: $4279f8b9d31284e6$export$70ae2c07e401031b,
    names: $4279f8b9d31284e6$export$e4b2ac9215619f8d
};



var $llHto = parcelRequire("llHto");
/*
  references:
    Formules et constantes pour le Calcul pour la
    projection cylindrique conforme à axe oblique et pour la transformation entre
    des systèmes de référence.
    http://www.swisstopo.admin.ch/internet/swisstopo/fr/home/topics/survey/sys/refsys/switzerland.parsysrelated1.31216.downloadList.77004.DownloadFile.tmp/swissprojectionfr.pdf
  */ function $31a8278a941356d4$export$2cd8252107eb640b() {
    var phy0 = this.lat0;
    this.lambda0 = this.long0;
    var sinPhy0 = Math.sin(phy0);
    var semiMajorAxis = this.a;
    var invF = this.rf;
    var flattening = 1 / invF;
    var e2 = 2 * flattening - Math.pow(flattening, 2);
    var e = this.e = Math.sqrt(e2);
    this.R = this.k0 * semiMajorAxis * Math.sqrt(1 - e2) / (1 - e2 * Math.pow(sinPhy0, 2));
    this.alpha = Math.sqrt(1 + e2 / (1 - e2) * Math.pow(Math.cos(phy0), 4));
    this.b0 = Math.asin(sinPhy0 / this.alpha);
    var k1 = Math.log(Math.tan(Math.PI / 4 + this.b0 / 2));
    var k2 = Math.log(Math.tan(Math.PI / 4 + phy0 / 2));
    var k3 = Math.log((1 + e * sinPhy0) / (1 - e * sinPhy0));
    this.K = k1 - this.alpha * k2 + this.alpha * e / 2 * k3;
}
function $31a8278a941356d4$export$174bb771924e7eb1(p) {
    var Sa1 = Math.log(Math.tan(Math.PI / 4 - p.y / 2));
    var Sa2 = this.e / 2 * Math.log((1 + this.e * Math.sin(p.y)) / (1 - this.e * Math.sin(p.y)));
    var S = -this.alpha * (Sa1 + Sa2) + this.K;
    // spheric latitude
    var b = 2 * (Math.atan(Math.exp(S)) - Math.PI / 4);
    // spheric longitude
    var I = this.alpha * (p.x - this.lambda0);
    // psoeudo equatorial rotation
    var rotI = Math.atan(Math.sin(I) / (Math.sin(this.b0) * Math.tan(b) + Math.cos(this.b0) * Math.cos(I)));
    var rotB = Math.asin(Math.cos(this.b0) * Math.sin(b) - Math.sin(this.b0) * Math.cos(b) * Math.cos(I));
    p.y = this.R / 2 * Math.log((1 + Math.sin(rotB)) / (1 - Math.sin(rotB))) + this.y0;
    p.x = this.R * rotI + this.x0;
    return p;
}
function $31a8278a941356d4$export$70ae2c07e401031b(p) {
    var Y = p.x - this.x0;
    var X = p.y - this.y0;
    var rotI = Y / this.R;
    var rotB = 2 * (Math.atan(Math.exp(X / this.R)) - Math.PI / 4);
    var b = Math.asin(Math.cos(this.b0) * Math.sin(rotB) + Math.sin(this.b0) * Math.cos(rotB) * Math.cos(rotI));
    var I = Math.atan(Math.sin(rotI) / (Math.cos(this.b0) * Math.cos(rotI) - Math.sin(this.b0) * Math.tan(rotB)));
    var lambda = this.lambda0 + I / this.alpha;
    var S = 0;
    var phy = b;
    var prevPhy = -1000;
    var iteration = 0;
    while(Math.abs(phy - prevPhy) > 0.0000001){
        if (++iteration > 20) //...reportError("omercFwdInfinity");
        return;
        //S = Math.log(Math.tan(Math.PI / 4 + phy / 2));
        S = 1 / this.alpha * (Math.log(Math.tan(Math.PI / 4 + b / 2)) - this.K) + this.e * Math.log(Math.tan(Math.PI / 4 + Math.asin(this.e * Math.sin(phy)) / 2));
        prevPhy = phy;
        phy = 2 * Math.atan(Math.exp(S)) - Math.PI / 2;
    }
    p.x = lambda;
    p.y = phy;
    return p;
}
var $31a8278a941356d4$export$e4b2ac9215619f8d = [
    "somerc"
];
var $31a8278a941356d4$export$2e2bcd8739ae039 = {
    init: $31a8278a941356d4$export$2cd8252107eb640b,
    forward: $31a8278a941356d4$export$174bb771924e7eb1,
    inverse: $31a8278a941356d4$export$70ae2c07e401031b,
    names: $31a8278a941356d4$export$e4b2ac9215619f8d
};



var $3xC66 = parcelRequire("3xC66");

var $a9oRf = parcelRequire("a9oRf");

var $2AZR8 = parcelRequire("2AZR8");

var $gyVUi = parcelRequire("gyVUi");
var $a6cb33582cb5910b$var$TOL = 1e-7;
function $a6cb33582cb5910b$var$isTypeA(P) {
    var typeAProjections = [
        'Hotine_Oblique_Mercator',
        'Hotine_Oblique_Mercator_Azimuth_Natural_Origin'
    ];
    var projectionName = typeof P.PROJECTION === "object" ? Object.keys(P.PROJECTION)[0] : P.PROJECTION;
    return 'no_uoff' in P || 'no_off' in P || typeAProjections.indexOf(projectionName) !== -1;
}
function $a6cb33582cb5910b$export$2cd8252107eb640b() {
    var con, com, cosph0, D, F, H, L, sinph0, p, J, gamma = 0, gamma0, lamc = 0, lam1 = 0, lam2 = 0, phi1 = 0, phi2 = 0, alpha_c = 0, AB;
    // only Type A uses the no_off or no_uoff property
    // https://github.com/OSGeo/proj.4/issues/104
    this.no_off = $a6cb33582cb5910b$var$isTypeA(this);
    this.no_rot = 'no_rot' in this;
    var alp = false;
    if ("alpha" in this) alp = true;
    var gam = false;
    if ("rectified_grid_angle" in this) gam = true;
    if (alp) alpha_c = this.alpha;
    if (gam) gamma = this.rectified_grid_angle * (0, $gyVUi.D2R);
    if (alp || gam) lamc = this.longc;
    else {
        lam1 = this.long1;
        phi1 = this.lat1;
        lam2 = this.long2;
        phi2 = this.lat2;
        if (Math.abs(phi1 - phi2) <= $a6cb33582cb5910b$var$TOL || (con = Math.abs(phi1)) <= $a6cb33582cb5910b$var$TOL || Math.abs(con - (0, $gyVUi.HALF_PI)) <= $a6cb33582cb5910b$var$TOL || Math.abs(Math.abs(this.lat0) - (0, $gyVUi.HALF_PI)) <= $a6cb33582cb5910b$var$TOL || Math.abs(Math.abs(phi2) - (0, $gyVUi.HALF_PI)) <= $a6cb33582cb5910b$var$TOL) throw new Error();
    }
    var one_es = 1.0 - this.es;
    com = Math.sqrt(one_es);
    if (Math.abs(this.lat0) > (0, $gyVUi.EPSLN)) {
        sinph0 = Math.sin(this.lat0);
        cosph0 = Math.cos(this.lat0);
        con = 1 - this.es * sinph0 * sinph0;
        this.B = cosph0 * cosph0;
        this.B = Math.sqrt(1 + this.es * this.B * this.B / one_es);
        this.A = this.B * this.k0 * com / con;
        D = this.B * com / (cosph0 * Math.sqrt(con));
        F = D * D - 1;
        if (F <= 0) F = 0;
        else {
            F = Math.sqrt(F);
            if (this.lat0 < 0) F = -F;
        }
        this.E = F += D;
        this.E *= Math.pow((0, $3xC66.default)(this.e, this.lat0, sinph0), this.B);
    } else {
        this.B = 1 / com;
        this.A = this.k0;
        this.E = D = F = 1;
    }
    if (alp || gam) {
        if (alp) {
            gamma0 = Math.asin(Math.sin(alpha_c) / D);
            if (!gam) gamma = alpha_c;
        } else {
            gamma0 = gamma;
            alpha_c = Math.asin(D * Math.sin(gamma0));
        }
        this.lam0 = lamc - Math.asin(0.5 * (F - 1 / F) * Math.tan(gamma0)) / this.B;
    } else {
        H = Math.pow((0, $3xC66.default)(this.e, phi1, Math.sin(phi1)), this.B);
        L = Math.pow((0, $3xC66.default)(this.e, phi2, Math.sin(phi2)), this.B);
        F = this.E / H;
        p = (L - H) / (L + H);
        J = this.E * this.E;
        J = (J - L * H) / (J + L * H);
        con = lam1 - lam2;
        if (con < -Math.pi) lam2 -= (0, $gyVUi.TWO_PI);
        else if (con > Math.pi) lam2 += (0, $gyVUi.TWO_PI);
        this.lam0 = (0, $a9oRf.default)(0.5 * (lam1 + lam2) - Math.atan(J * Math.tan(0.5 * this.B * (lam1 - lam2)) / p) / this.B);
        gamma0 = Math.atan(2 * Math.sin(this.B * (0, $a9oRf.default)(lam1 - this.lam0)) / (F - 1 / F));
        gamma = alpha_c = Math.asin(D * Math.sin(gamma0));
    }
    this.singam = Math.sin(gamma0);
    this.cosgam = Math.cos(gamma0);
    this.sinrot = Math.sin(gamma);
    this.cosrot = Math.cos(gamma);
    this.rB = 1 / this.B;
    this.ArB = this.A * this.rB;
    this.BrA = 1 / this.ArB;
    AB = this.A * this.B;
    if (this.no_off) this.u_0 = 0;
    else {
        this.u_0 = Math.abs(this.ArB * Math.atan(Math.sqrt(D * D - 1) / Math.cos(alpha_c)));
        if (this.lat0 < 0) this.u_0 = -this.u_0;
    }
    F = 0.5 * gamma0;
    this.v_pole_n = this.ArB * Math.log(Math.tan((0, $gyVUi.FORTPI) - F));
    this.v_pole_s = this.ArB * Math.log(Math.tan((0, $gyVUi.FORTPI) + F));
}
function $a6cb33582cb5910b$export$174bb771924e7eb1(p) {
    var coords = {};
    var S, T, U, V, W, temp, u, v;
    p.x = p.x - this.lam0;
    if (Math.abs(Math.abs(p.y) - (0, $gyVUi.HALF_PI)) > (0, $gyVUi.EPSLN)) {
        W = this.E / Math.pow((0, $3xC66.default)(this.e, p.y, Math.sin(p.y)), this.B);
        temp = 1 / W;
        S = 0.5 * (W - temp);
        T = 0.5 * (W + temp);
        V = Math.sin(this.B * p.x);
        U = (S * this.singam - V * this.cosgam) / T;
        if (Math.abs(Math.abs(U) - 1.0) < (0, $gyVUi.EPSLN)) throw new Error();
        v = 0.5 * this.ArB * Math.log((1 - U) / (1 + U));
        temp = Math.cos(this.B * p.x);
        if (Math.abs(temp) < $a6cb33582cb5910b$var$TOL) u = this.A * p.x;
        else u = this.ArB * Math.atan2(S * this.cosgam + V * this.singam, temp);
    } else {
        v = p.y > 0 ? this.v_pole_n : this.v_pole_s;
        u = this.ArB * p.y;
    }
    if (this.no_rot) {
        coords.x = u;
        coords.y = v;
    } else {
        u -= this.u_0;
        coords.x = v * this.cosrot + u * this.sinrot;
        coords.y = u * this.cosrot - v * this.sinrot;
    }
    coords.x = this.a * coords.x + this.x0;
    coords.y = this.a * coords.y + this.y0;
    return coords;
}
function $a6cb33582cb5910b$export$70ae2c07e401031b(p) {
    var u, v, Qp, Sp, Tp, Vp, Up;
    var coords = {};
    p.x = (p.x - this.x0) * (1.0 / this.a);
    p.y = (p.y - this.y0) * (1.0 / this.a);
    if (this.no_rot) {
        v = p.y;
        u = p.x;
    } else {
        v = p.x * this.cosrot - p.y * this.sinrot;
        u = p.y * this.cosrot + p.x * this.sinrot + this.u_0;
    }
    Qp = Math.exp(-this.BrA * v);
    Sp = 0.5 * (Qp - 1 / Qp);
    Tp = 0.5 * (Qp + 1 / Qp);
    Vp = Math.sin(this.BrA * u);
    Up = (Vp * this.cosgam + Sp * this.singam) / Tp;
    if (Math.abs(Math.abs(Up) - 1) < (0, $gyVUi.EPSLN)) {
        coords.x = 0;
        coords.y = Up < 0 ? -(0, $gyVUi.HALF_PI) : (0, $gyVUi.HALF_PI);
    } else {
        coords.y = this.E / Math.sqrt((1 + Up) / (1 - Up));
        coords.y = (0, $2AZR8.default)(this.e, Math.pow(coords.y, 1 / this.B));
        if (coords.y === Infinity) throw new Error();
        coords.x = -this.rB * Math.atan2(Sp * this.cosgam - Vp * this.singam, Math.cos(this.BrA * u));
    }
    coords.x += this.lam0;
    return coords;
}
var $a6cb33582cb5910b$export$e4b2ac9215619f8d = [
    "Hotine_Oblique_Mercator",
    "Hotine Oblique Mercator",
    "Hotine_Oblique_Mercator_Azimuth_Natural_Origin",
    "Hotine_Oblique_Mercator_Two_Point_Natural_Origin",
    "Hotine_Oblique_Mercator_Azimuth_Center",
    "Oblique_Mercator",
    "omerc"
];
var $a6cb33582cb5910b$export$2e2bcd8739ae039 = {
    init: $a6cb33582cb5910b$export$2cd8252107eb640b,
    forward: $a6cb33582cb5910b$export$174bb771924e7eb1,
    inverse: $a6cb33582cb5910b$export$70ae2c07e401031b,
    names: $a6cb33582cb5910b$export$e4b2ac9215619f8d
};



var $bi5ZC = parcelRequire("bi5ZC");

var $3xC66 = parcelRequire("3xC66");

var $boTd3 = parcelRequire("boTd3");

var $a9oRf = parcelRequire("a9oRf");

var $2AZR8 = parcelRequire("2AZR8");

var $gyVUi = parcelRequire("gyVUi");
function $d753eaf12887a276$export$2cd8252107eb640b() {
    //double lat0;                    /* the reference latitude               */
    //double long0;                   /* the reference longitude              */
    //double lat1;                    /* first standard parallel              */
    //double lat2;                    /* second standard parallel             */
    //double r_maj;                   /* major axis                           */
    //double r_min;                   /* minor axis                           */
    //double false_east;              /* x offset in meters                   */
    //double false_north;             /* y offset in meters                   */
    //the above value can be set with proj4.defs
    //example: proj4.defs("EPSG:2154","+proj=lcc +lat_1=49 +lat_2=44 +lat_0=46.5 +lon_0=3 +x_0=700000 +y_0=6600000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs");
    if (!this.lat2) this.lat2 = this.lat1;
     //if lat2 is not defined
    if (!this.k0) this.k0 = 1;
    this.x0 = this.x0 || 0;
    this.y0 = this.y0 || 0;
    // Standard Parallels cannot be equal and on opposite sides of the equator
    if (Math.abs(this.lat1 + this.lat2) < (0, $gyVUi.EPSLN)) return;
    var temp = this.b / this.a;
    this.e = Math.sqrt(1 - temp * temp);
    var sin1 = Math.sin(this.lat1);
    var cos1 = Math.cos(this.lat1);
    var ms1 = (0, $bi5ZC.default)(this.e, sin1, cos1);
    var ts1 = (0, $3xC66.default)(this.e, this.lat1, sin1);
    var sin2 = Math.sin(this.lat2);
    var cos2 = Math.cos(this.lat2);
    var ms2 = (0, $bi5ZC.default)(this.e, sin2, cos2);
    var ts2 = (0, $3xC66.default)(this.e, this.lat2, sin2);
    var ts0 = (0, $3xC66.default)(this.e, this.lat0, Math.sin(this.lat0));
    if (Math.abs(this.lat1 - this.lat2) > (0, $gyVUi.EPSLN)) this.ns = Math.log(ms1 / ms2) / Math.log(ts1 / ts2);
    else this.ns = sin1;
    if (isNaN(this.ns)) this.ns = sin1;
    this.f0 = ms1 / (this.ns * Math.pow(ts1, this.ns));
    this.rh = this.a * this.f0 * Math.pow(ts0, this.ns);
    if (!this.title) this.title = "Lambert Conformal Conic";
}
function $d753eaf12887a276$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    // singular cases :
    if (Math.abs(2 * Math.abs(lat) - Math.PI) <= (0, $gyVUi.EPSLN)) lat = (0, $boTd3.default)(lat) * ((0, $gyVUi.HALF_PI) - 2 * (0, $gyVUi.EPSLN));
    var con = Math.abs(Math.abs(lat) - (0, $gyVUi.HALF_PI));
    var ts, rh1;
    if (con > (0, $gyVUi.EPSLN)) {
        ts = (0, $3xC66.default)(this.e, lat, Math.sin(lat));
        rh1 = this.a * this.f0 * Math.pow(ts, this.ns);
    } else {
        con = lat * this.ns;
        if (con <= 0) return null;
        rh1 = 0;
    }
    var theta = this.ns * (0, $a9oRf.default)(lon - this.long0);
    p.x = this.k0 * (rh1 * Math.sin(theta)) + this.x0;
    p.y = this.k0 * (this.rh - rh1 * Math.cos(theta)) + this.y0;
    return p;
}
function $d753eaf12887a276$export$70ae2c07e401031b(p) {
    var rh1, con, ts;
    var lat, lon;
    var x = (p.x - this.x0) / this.k0;
    var y = this.rh - (p.y - this.y0) / this.k0;
    if (this.ns > 0) {
        rh1 = Math.sqrt(x * x + y * y);
        con = 1;
    } else {
        rh1 = -Math.sqrt(x * x + y * y);
        con = -1;
    }
    var theta = 0;
    if (rh1 !== 0) theta = Math.atan2(con * x, con * y);
    if (rh1 !== 0 || this.ns > 0) {
        con = 1 / this.ns;
        ts = Math.pow(rh1 / (this.a * this.f0), con);
        lat = (0, $2AZR8.default)(this.e, ts);
        if (lat === -9999) return null;
    } else lat = -(0, $gyVUi.HALF_PI);
    lon = (0, $a9oRf.default)(theta / this.ns + this.long0);
    p.x = lon;
    p.y = lat;
    return p;
}
var $d753eaf12887a276$export$e4b2ac9215619f8d = [
    "Lambert Tangential Conformal Conic Projection",
    "Lambert_Conformal_Conic",
    "Lambert_Conformal_Conic_1SP",
    "Lambert_Conformal_Conic_2SP",
    "lcc",
    "Lambert Conic Conformal (1SP)",
    "Lambert Conic Conformal (2SP)"
];
var $d753eaf12887a276$export$2e2bcd8739ae039 = {
    init: $d753eaf12887a276$export$2cd8252107eb640b,
    forward: $d753eaf12887a276$export$174bb771924e7eb1,
    inverse: $d753eaf12887a276$export$70ae2c07e401031b,
    names: $d753eaf12887a276$export$e4b2ac9215619f8d
};



var $a9oRf = parcelRequire("a9oRf");
function $c765c705b741a192$export$2cd8252107eb640b() {
    this.a = 6377397.155;
    this.es = 0.006674372230614;
    this.e = Math.sqrt(this.es);
    if (!this.lat0) this.lat0 = 0.863937979737193;
    if (!this.long0) this.long0 = 0.4334234309119251;
    /* if scale not set default to 0.9999 */ if (!this.k0) this.k0 = 0.9999;
    this.s45 = 0.785398163397448; /* 45 */ 
    this.s90 = 2 * this.s45;
    this.fi0 = this.lat0;
    this.e2 = this.es;
    this.e = Math.sqrt(this.e2);
    this.alfa = Math.sqrt(1 + this.e2 * Math.pow(Math.cos(this.fi0), 4) / (1 - this.e2));
    this.uq = 1.04216856380474;
    this.u0 = Math.asin(Math.sin(this.fi0) / this.alfa);
    this.g = Math.pow((1 + this.e * Math.sin(this.fi0)) / (1 - this.e * Math.sin(this.fi0)), this.alfa * this.e / 2);
    this.k = Math.tan(this.u0 / 2 + this.s45) / Math.pow(Math.tan(this.fi0 / 2 + this.s45), this.alfa) * this.g;
    this.k1 = this.k0;
    this.n0 = this.a * Math.sqrt(1 - this.e2) / (1 - this.e2 * Math.pow(Math.sin(this.fi0), 2));
    this.s0 = 1.37008346281555;
    this.n = Math.sin(this.s0);
    this.ro0 = this.k1 * this.n0 / Math.tan(this.s0);
    this.ad = this.s90 - this.uq;
}
function $c765c705b741a192$export$174bb771924e7eb1(p) {
    var gfi, u, deltav, s, d, eps, ro;
    var lon = p.x;
    var lat = p.y;
    var delta_lon = (0, $a9oRf.default)(lon - this.long0);
    /* Transformation */ gfi = Math.pow((1 + this.e * Math.sin(lat)) / (1 - this.e * Math.sin(lat)), this.alfa * this.e / 2);
    u = 2 * (Math.atan(this.k * Math.pow(Math.tan(lat / 2 + this.s45), this.alfa) / gfi) - this.s45);
    deltav = -delta_lon * this.alfa;
    s = Math.asin(Math.cos(this.ad) * Math.sin(u) + Math.sin(this.ad) * Math.cos(u) * Math.cos(deltav));
    d = Math.asin(Math.cos(u) * Math.sin(deltav) / Math.cos(s));
    eps = this.n * d;
    ro = this.ro0 * Math.pow(Math.tan(this.s0 / 2 + this.s45), this.n) / Math.pow(Math.tan(s / 2 + this.s45), this.n);
    p.y = ro * Math.cos(eps) / 1;
    p.x = ro * Math.sin(eps) / 1;
    if (!this.czech) {
        p.y *= -1;
        p.x *= -1;
    }
    return p;
}
function $c765c705b741a192$export$70ae2c07e401031b(p) {
    var u, deltav, s, d, eps, ro, fi1;
    var ok;
    /* Transformation */ /* revert y, x*/ var tmp = p.x;
    p.x = p.y;
    p.y = tmp;
    if (!this.czech) {
        p.y *= -1;
        p.x *= -1;
    }
    ro = Math.sqrt(p.x * p.x + p.y * p.y);
    eps = Math.atan2(p.y, p.x);
    d = eps / Math.sin(this.s0);
    s = 2 * (Math.atan(Math.pow(this.ro0 / ro, 1 / this.n) * Math.tan(this.s0 / 2 + this.s45)) - this.s45);
    u = Math.asin(Math.cos(this.ad) * Math.sin(s) - Math.sin(this.ad) * Math.cos(s) * Math.cos(d));
    deltav = Math.asin(Math.cos(s) * Math.sin(d) / Math.cos(u));
    p.x = this.long0 - deltav / this.alfa;
    fi1 = u;
    ok = 0;
    var iter = 0;
    do {
        p.y = 2 * (Math.atan(Math.pow(this.k, -1 / this.alfa) * Math.pow(Math.tan(u / 2 + this.s45), 1 / this.alfa) * Math.pow((1 + this.e * Math.sin(fi1)) / (1 - this.e * Math.sin(fi1)), this.e / 2)) - this.s45);
        if (Math.abs(fi1 - p.y) < 0.0000000001) ok = 1;
        fi1 = p.y;
        iter += 1;
    }while (ok === 0 && iter < 15);
    if (iter >= 15) return null;
    return p;
}
var $c765c705b741a192$export$e4b2ac9215619f8d = [
    "Krovak",
    "krovak"
];
var $c765c705b741a192$export$2e2bcd8739ae039 = {
    init: $c765c705b741a192$export$2cd8252107eb640b,
    forward: $c765c705b741a192$export$174bb771924e7eb1,
    inverse: $c765c705b741a192$export$70ae2c07e401031b,
    names: $c765c705b741a192$export$e4b2ac9215619f8d
};


function $af51062589eeb2ce$export$2e2bcd8739ae039(e0, e1, e2, e3, phi) {
    return e0 * phi - e1 * Math.sin(2 * phi) + e2 * Math.sin(4 * phi) - e3 * Math.sin(6 * phi);
}


function $8b22a51ec249391e$export$2e2bcd8739ae039(x) {
    return 1 - 0.25 * x * (1 + x / 16 * (3 + 1.25 * x));
}


function $d08e0117e308bb87$export$2e2bcd8739ae039(x) {
    return 0.375 * x * (1 + 0.25 * x * (1 + 0.46875 * x));
}


function $d36e2161accfe0ec$export$2e2bcd8739ae039(x) {
    return 0.05859375 * x * x * (1 + 0.75 * x);
}


function $89245c5bc9a5a616$export$2e2bcd8739ae039(x) {
    return x * x * x * (35 / 3072);
}


function $259e1333723cc7cb$export$2e2bcd8739ae039(a, e, sinphi) {
    var temp = e * sinphi;
    return a / Math.sqrt(1 - temp * temp);
}



var $a9oRf = parcelRequire("a9oRf");

var $gyVUi = parcelRequire("gyVUi");

var $boTd3 = parcelRequire("boTd3");
function $7bf9815baea17aa9$export$2e2bcd8739ae039(x) {
    return Math.abs(x) < (0, $gyVUi.HALF_PI) ? x : x - (0, $boTd3.default)(x) * Math.PI;
}


function $8ebd4771f70de1ee$export$2e2bcd8739ae039(ml, e0, e1, e2, e3) {
    var phi;
    var dphi;
    phi = ml / e0;
    for(var i = 0; i < 15; i++){
        dphi = (ml - (e0 * phi - e1 * Math.sin(2 * phi) + e2 * Math.sin(4 * phi) - e3 * Math.sin(6 * phi))) / (e0 - 2 * e1 * Math.cos(2 * phi) + 4 * e2 * Math.cos(4 * phi) - 6 * e3 * Math.cos(6 * phi));
        phi += dphi;
        if (Math.abs(dphi) <= 0.0000000001) return phi;
    }
    //..reportError("IMLFN-CONV:Latitude failed to converge after 15 iterations");
    return NaN;
}



var $gyVUi = parcelRequire("gyVUi");
function $00f791059e8f61f5$export$2cd8252107eb640b() {
    if (!this.sphere) {
        this.e0 = (0, $8b22a51ec249391e$export$2e2bcd8739ae039)(this.es);
        this.e1 = (0, $d08e0117e308bb87$export$2e2bcd8739ae039)(this.es);
        this.e2 = (0, $d36e2161accfe0ec$export$2e2bcd8739ae039)(this.es);
        this.e3 = (0, $89245c5bc9a5a616$export$2e2bcd8739ae039)(this.es);
        this.ml0 = this.a * (0, $af51062589eeb2ce$export$2e2bcd8739ae039)(this.e0, this.e1, this.e2, this.e3, this.lat0);
    }
}
function $00f791059e8f61f5$export$174bb771924e7eb1(p) {
    /* Forward equations
      -----------------*/ var x, y;
    var lam = p.x;
    var phi = p.y;
    lam = (0, $a9oRf.default)(lam - this.long0);
    if (this.sphere) {
        x = this.a * Math.asin(Math.cos(phi) * Math.sin(lam));
        y = this.a * (Math.atan2(Math.tan(phi), Math.cos(lam)) - this.lat0);
    } else {
        //ellipsoid
        var sinphi = Math.sin(phi);
        var cosphi = Math.cos(phi);
        var nl = (0, $259e1333723cc7cb$export$2e2bcd8739ae039)(this.a, this.e, sinphi);
        var tl = Math.tan(phi) * Math.tan(phi);
        var al = lam * Math.cos(phi);
        var asq = al * al;
        var cl = this.es * cosphi * cosphi / (1 - this.es);
        var ml = this.a * (0, $af51062589eeb2ce$export$2e2bcd8739ae039)(this.e0, this.e1, this.e2, this.e3, phi);
        x = nl * al * (1 - asq * tl * (1 / 6 - (8 - tl + 8 * cl) * asq / 120));
        y = ml - this.ml0 + nl * sinphi / cosphi * asq * (0.5 + (5 - tl + 6 * cl) * asq / 24);
    }
    p.x = x + this.x0;
    p.y = y + this.y0;
    return p;
}
function $00f791059e8f61f5$export$70ae2c07e401031b(p) {
    p.x -= this.x0;
    p.y -= this.y0;
    var x = p.x / this.a;
    var y = p.y / this.a;
    var phi, lam;
    if (this.sphere) {
        var dd = y + this.lat0;
        phi = Math.asin(Math.sin(dd) * Math.cos(x));
        lam = Math.atan2(Math.tan(x), Math.cos(dd));
    } else {
        /* ellipsoid */ var ml1 = this.ml0 / this.a + y;
        var phi1 = (0, $8ebd4771f70de1ee$export$2e2bcd8739ae039)(ml1, this.e0, this.e1, this.e2, this.e3);
        if (Math.abs(Math.abs(phi1) - (0, $gyVUi.HALF_PI)) <= (0, $gyVUi.EPSLN)) {
            p.x = this.long0;
            p.y = (0, $gyVUi.HALF_PI);
            if (y < 0) p.y *= -1;
            return p;
        }
        var nl1 = (0, $259e1333723cc7cb$export$2e2bcd8739ae039)(this.a, this.e, Math.sin(phi1));
        var rl1 = nl1 * nl1 * nl1 / this.a / this.a * (1 - this.es);
        var tl1 = Math.pow(Math.tan(phi1), 2);
        var dl = x * this.a / nl1;
        var dsq = dl * dl;
        phi = phi1 - nl1 * Math.tan(phi1) / rl1 * dl * dl * (0.5 - (1 + 3 * tl1) * dl * dl / 24);
        lam = dl * (1 - dsq * (tl1 / 3 + (1 + 3 * tl1) * tl1 * dsq / 15)) / Math.cos(phi1);
    }
    p.x = (0, $a9oRf.default)(lam + this.long0);
    p.y = (0, $7bf9815baea17aa9$export$2e2bcd8739ae039)(phi);
    return p;
}
var $00f791059e8f61f5$export$e4b2ac9215619f8d = [
    "Cassini",
    "Cassini_Soldner",
    "cass"
];
var $00f791059e8f61f5$export$2e2bcd8739ae039 = {
    init: $00f791059e8f61f5$export$2cd8252107eb640b,
    forward: $00f791059e8f61f5$export$174bb771924e7eb1,
    inverse: $00f791059e8f61f5$export$70ae2c07e401031b,
    names: $00f791059e8f61f5$export$e4b2ac9215619f8d
};



var $deudM = parcelRequire("deudM");

var $8mhgZ = parcelRequire("8mhgZ");

var $a9oRf = parcelRequire("a9oRf");

var $ljPJJ = parcelRequire("ljPJJ");

var $gyVUi = parcelRequire("gyVUi");
function $dbf05e97c9232a2a$export$2cd8252107eb640b() {
    /* Place parameters in static storage for common use
      -------------------------------------------------*/ this.sin_p14 = Math.sin(this.lat0);
    this.cos_p14 = Math.cos(this.lat0);
    // Approximation for projecting points to the horizon (infinity)
    this.infinity_dist = 1000 * this.a;
    this.rc = 1;
}
function $dbf05e97c9232a2a$export$174bb771924e7eb1(p) {
    var sinphi, cosphi; /* sin and cos value        */ 
    var dlon; /* delta longitude value      */ 
    var coslon; /* cos of longitude        */ 
    var ksp; /* scale factor          */ 
    var g;
    var x, y;
    var lon = p.x;
    var lat = p.y;
    /* Forward equations
      -----------------*/ dlon = (0, $a9oRf.default)(lon - this.long0);
    sinphi = Math.sin(lat);
    cosphi = Math.cos(lat);
    coslon = Math.cos(dlon);
    g = this.sin_p14 * sinphi + this.cos_p14 * cosphi * coslon;
    ksp = 1;
    if (g > 0 || Math.abs(g) <= (0, $gyVUi.EPSLN)) {
        x = this.x0 + this.a * ksp * cosphi * Math.sin(dlon) / g;
        y = this.y0 + this.a * ksp * (this.cos_p14 * sinphi - this.sin_p14 * cosphi * coslon) / g;
    } else {
        // Point is in the opposing hemisphere and is unprojectable
        // We still need to return a reasonable point, so we project
        // to infinity, on a bearing
        // equivalent to the northern hemisphere equivalent
        // This is a reasonable approximation for short shapes and lines that
        // straddle the horizon.
        x = this.x0 + this.infinity_dist * cosphi * Math.sin(dlon);
        y = this.y0 + this.infinity_dist * (this.cos_p14 * sinphi - this.sin_p14 * cosphi * coslon);
    }
    p.x = x;
    p.y = y;
    return p;
}
function $dbf05e97c9232a2a$export$70ae2c07e401031b(p) {
    var rh; /* Rho */ 
    var sinc, cosc;
    var c;
    var lon, lat;
    /* Inverse equations
      -----------------*/ p.x = (p.x - this.x0) / this.a;
    p.y = (p.y - this.y0) / this.a;
    p.x /= this.k0;
    p.y /= this.k0;
    if (rh = Math.sqrt(p.x * p.x + p.y * p.y)) {
        c = Math.atan2(rh, this.rc);
        sinc = Math.sin(c);
        cosc = Math.cos(c);
        lat = (0, $ljPJJ.default)(cosc * this.sin_p14 + p.y * sinc * this.cos_p14 / rh);
        lon = Math.atan2(p.x * sinc, rh * this.cos_p14 * cosc - p.y * this.sin_p14 * sinc);
        lon = (0, $a9oRf.default)(this.long0 + lon);
    } else {
        lat = this.phic0;
        lon = 0;
    }
    p.x = lon;
    p.y = lat;
    return p;
}
var $dbf05e97c9232a2a$export$e4b2ac9215619f8d = [
    "gnom"
];
var $dbf05e97c9232a2a$export$2e2bcd8739ae039 = {
    init: $dbf05e97c9232a2a$export$2cd8252107eb640b,
    forward: $dbf05e97c9232a2a$export$174bb771924e7eb1,
    inverse: $dbf05e97c9232a2a$export$70ae2c07e401031b,
    names: $dbf05e97c9232a2a$export$e4b2ac9215619f8d
};



var $a9oRf = parcelRequire("a9oRf");

var $874JP = parcelRequire("874JP");

var $bi5ZC = parcelRequire("bi5ZC");

var $gyVUi = parcelRequire("gyVUi");
function $81070f0f2a61f650$export$2e2bcd8739ae039(eccent, q) {
    var temp = 1 - (1 - eccent * eccent) / (2 * eccent) * Math.log((1 - eccent) / (1 + eccent));
    if (Math.abs(Math.abs(q) - temp) < 1.0E-6) {
        if (q < 0) return -1 * (0, $gyVUi.HALF_PI);
        else return 0, $gyVUi.HALF_PI;
    }
    //var phi = 0.5* q/(1-eccent*eccent);
    var phi = Math.asin(0.5 * q);
    var dphi;
    var sin_phi;
    var cos_phi;
    var con;
    for(var i = 0; i < 30; i++){
        sin_phi = Math.sin(phi);
        cos_phi = Math.cos(phi);
        con = eccent * sin_phi;
        dphi = Math.pow(1 - con * con, 2) / (2 * cos_phi) * (q / (1 - eccent * eccent) - sin_phi / (1 - con * con) + 0.5 / eccent * Math.log((1 - con) / (1 + con)));
        phi += dphi;
        if (Math.abs(dphi) <= 0.0000000001) return phi;
    }
    //console.log("IQSFN-CONV:Latitude failed to converge after 30 iterations");
    return NaN;
}


function $4d31684dfe594c29$export$2cd8252107eb640b() {
    //no-op
    if (!this.sphere) this.k0 = (0, $bi5ZC.default)(this.e, Math.sin(this.lat_ts), Math.cos(this.lat_ts));
}
function $4d31684dfe594c29$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    var x, y;
    /* Forward equations
      -----------------*/ var dlon = (0, $a9oRf.default)(lon - this.long0);
    if (this.sphere) {
        x = this.x0 + this.a * dlon * Math.cos(this.lat_ts);
        y = this.y0 + this.a * Math.sin(lat) / Math.cos(this.lat_ts);
    } else {
        var qs = (0, $874JP.default)(this.e, Math.sin(lat));
        x = this.x0 + this.a * this.k0 * dlon;
        y = this.y0 + this.a * qs * 0.5 / this.k0;
    }
    p.x = x;
    p.y = y;
    return p;
}
function $4d31684dfe594c29$export$70ae2c07e401031b(p) {
    p.x -= this.x0;
    p.y -= this.y0;
    var lon, lat;
    if (this.sphere) {
        lon = (0, $a9oRf.default)(this.long0 + p.x / this.a / Math.cos(this.lat_ts));
        lat = Math.asin(p.y / this.a * Math.cos(this.lat_ts));
    } else {
        lat = (0, $81070f0f2a61f650$export$2e2bcd8739ae039)(this.e, 2 * p.y * this.k0 / this.a);
        lon = (0, $a9oRf.default)(this.long0 + p.x / (this.a * this.k0));
    }
    p.x = lon;
    p.y = lat;
    return p;
}
var $4d31684dfe594c29$export$e4b2ac9215619f8d = [
    "cea"
];
var $4d31684dfe594c29$export$2e2bcd8739ae039 = {
    init: $4d31684dfe594c29$export$2cd8252107eb640b,
    forward: $4d31684dfe594c29$export$174bb771924e7eb1,
    inverse: $4d31684dfe594c29$export$70ae2c07e401031b,
    names: $4d31684dfe594c29$export$e4b2ac9215619f8d
};



var $a9oRf = parcelRequire("a9oRf");

function $936a7dd52884a3fc$export$2cd8252107eb640b() {
    this.x0 = this.x0 || 0;
    this.y0 = this.y0 || 0;
    this.lat0 = this.lat0 || 0;
    this.long0 = this.long0 || 0;
    this.lat_ts = this.lat_ts || 0;
    this.title = this.title || "Equidistant Cylindrical (Plate Carre)";
    this.rc = Math.cos(this.lat_ts);
}
function $936a7dd52884a3fc$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    var dlon = (0, $a9oRf.default)(lon - this.long0);
    var dlat = (0, $7bf9815baea17aa9$export$2e2bcd8739ae039)(lat - this.lat0);
    p.x = this.x0 + this.a * dlon * this.rc;
    p.y = this.y0 + this.a * dlat;
    return p;
}
function $936a7dd52884a3fc$export$70ae2c07e401031b(p) {
    var x = p.x;
    var y = p.y;
    p.x = (0, $a9oRf.default)(this.long0 + (x - this.x0) / (this.a * this.rc));
    p.y = (0, $7bf9815baea17aa9$export$2e2bcd8739ae039)(this.lat0 + (y - this.y0) / this.a);
    return p;
}
var $936a7dd52884a3fc$export$e4b2ac9215619f8d = [
    "Equirectangular",
    "Equidistant_Cylindrical",
    "eqc"
];
var $936a7dd52884a3fc$export$2e2bcd8739ae039 = {
    init: $936a7dd52884a3fc$export$2cd8252107eb640b,
    forward: $936a7dd52884a3fc$export$174bb771924e7eb1,
    inverse: $936a7dd52884a3fc$export$70ae2c07e401031b,
    names: $936a7dd52884a3fc$export$e4b2ac9215619f8d
};







var $a9oRf = parcelRequire("a9oRf");



var $gyVUi = parcelRequire("gyVUi");

var $20353e9e716518d0$var$MAX_ITER = 20;
function $20353e9e716518d0$export$2cd8252107eb640b() {
    /* Place parameters in static storage for common use
      -------------------------------------------------*/ this.temp = this.b / this.a;
    this.es = 1 - Math.pow(this.temp, 2); // devait etre dans tmerc.js mais n y est pas donc je commente sinon retour de valeurs nulles
    this.e = Math.sqrt(this.es);
    this.e0 = (0, $8b22a51ec249391e$export$2e2bcd8739ae039)(this.es);
    this.e1 = (0, $d08e0117e308bb87$export$2e2bcd8739ae039)(this.es);
    this.e2 = (0, $d36e2161accfe0ec$export$2e2bcd8739ae039)(this.es);
    this.e3 = (0, $89245c5bc9a5a616$export$2e2bcd8739ae039)(this.es);
    this.ml0 = this.a * (0, $af51062589eeb2ce$export$2e2bcd8739ae039)(this.e0, this.e1, this.e2, this.e3, this.lat0); //si que des zeros le calcul ne se fait pas
}
function $20353e9e716518d0$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    var x, y, el;
    var dlon = (0, $a9oRf.default)(lon - this.long0);
    el = dlon * Math.sin(lat);
    if (this.sphere) {
        if (Math.abs(lat) <= (0, $gyVUi.EPSLN)) {
            x = this.a * dlon;
            y = -1 * this.a * this.lat0;
        } else {
            x = this.a * Math.sin(el) / Math.tan(lat);
            y = this.a * ((0, $7bf9815baea17aa9$export$2e2bcd8739ae039)(lat - this.lat0) + (1 - Math.cos(el)) / Math.tan(lat));
        }
    } else if (Math.abs(lat) <= (0, $gyVUi.EPSLN)) {
        x = this.a * dlon;
        y = -1 * this.ml0;
    } else {
        var nl = (0, $259e1333723cc7cb$export$2e2bcd8739ae039)(this.a, this.e, Math.sin(lat)) / Math.tan(lat);
        x = nl * Math.sin(el);
        y = this.a * (0, $af51062589eeb2ce$export$2e2bcd8739ae039)(this.e0, this.e1, this.e2, this.e3, lat) - this.ml0 + nl * (1 - Math.cos(el));
    }
    p.x = x + this.x0;
    p.y = y + this.y0;
    return p;
}
function $20353e9e716518d0$export$70ae2c07e401031b(p) {
    var lon, lat, x, y, i;
    var al, bl;
    var phi, dphi;
    x = p.x - this.x0;
    y = p.y - this.y0;
    if (this.sphere) {
        if (Math.abs(y + this.a * this.lat0) <= (0, $gyVUi.EPSLN)) {
            lon = (0, $a9oRf.default)(x / this.a + this.long0);
            lat = 0;
        } else {
            al = this.lat0 + y / this.a;
            bl = x * x / this.a / this.a + al * al;
            phi = al;
            var tanphi;
            for(i = $20353e9e716518d0$var$MAX_ITER; i; --i){
                tanphi = Math.tan(phi);
                dphi = -1 * (al * (phi * tanphi + 1) - phi - 0.5 * (phi * phi + bl) * tanphi) / ((phi - al) / tanphi - 1);
                phi += dphi;
                if (Math.abs(dphi) <= (0, $gyVUi.EPSLN)) {
                    lat = phi;
                    break;
                }
            }
            lon = (0, $a9oRf.default)(this.long0 + Math.asin(x * Math.tan(phi) / this.a) / Math.sin(lat));
        }
    } else if (Math.abs(y + this.ml0) <= (0, $gyVUi.EPSLN)) {
        lat = 0;
        lon = (0, $a9oRf.default)(this.long0 + x / this.a);
    } else {
        al = (this.ml0 + y) / this.a;
        bl = x * x / this.a / this.a + al * al;
        phi = al;
        var cl, mln, mlnp, ma;
        var con;
        for(i = $20353e9e716518d0$var$MAX_ITER; i; --i){
            con = this.e * Math.sin(phi);
            cl = Math.sqrt(1 - con * con) * Math.tan(phi);
            mln = this.a * (0, $af51062589eeb2ce$export$2e2bcd8739ae039)(this.e0, this.e1, this.e2, this.e3, phi);
            mlnp = this.e0 - 2 * this.e1 * Math.cos(2 * phi) + 4 * this.e2 * Math.cos(4 * phi) - 6 * this.e3 * Math.cos(6 * phi);
            ma = mln / this.a;
            dphi = (al * (cl * ma + 1) - ma - 0.5 * cl * (ma * ma + bl)) / (this.es * Math.sin(2 * phi) * (ma * ma + bl - 2 * al * ma) / (4 * cl) + (al - ma) * (cl * mlnp - 2 / Math.sin(2 * phi)) - mlnp);
            phi -= dphi;
            if (Math.abs(dphi) <= (0, $gyVUi.EPSLN)) {
                lat = phi;
                break;
            }
        }
        //lat=phi4z(this.e,this.e0,this.e1,this.e2,this.e3,al,bl,0,0);
        cl = Math.sqrt(1 - this.es * Math.pow(Math.sin(lat), 2)) * Math.tan(lat);
        lon = (0, $a9oRf.default)(this.long0 + Math.asin(x * cl / this.a) / Math.sin(lat));
    }
    p.x = lon;
    p.y = lat;
    return p;
}
var $20353e9e716518d0$export$e4b2ac9215619f8d = [
    "Polyconic",
    "poly"
];
var $20353e9e716518d0$export$2e2bcd8739ae039 = {
    init: $20353e9e716518d0$export$2cd8252107eb640b,
    forward: $20353e9e716518d0$export$174bb771924e7eb1,
    inverse: $20353e9e716518d0$export$70ae2c07e401031b,
    names: $20353e9e716518d0$export$e4b2ac9215619f8d
};



var $6Eu1X = parcelRequire("6Eu1X");

var $a9oRf = parcelRequire("a9oRf");
function $b37863f65bf2a2a4$export$2cd8252107eb640b() {
//no-op
}
function $b37863f65bf2a2a4$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    /* Forward equations
      -----------------*/ var dlon = (0, $a9oRf.default)(lon - this.long0);
    var x = this.x0 + this.a * dlon;
    var y = this.y0 + this.a * Math.log(Math.tan(Math.PI / 4 + lat / 2.5)) * 1.25;
    p.x = x;
    p.y = y;
    return p;
}
function $b37863f65bf2a2a4$export$70ae2c07e401031b(p) {
    p.x -= this.x0;
    p.y -= this.y0;
    var lon = (0, $a9oRf.default)(this.long0 + p.x / this.a);
    var lat = 2.5 * (Math.atan(Math.exp(0.8 * p.y / this.a)) - Math.PI / 4);
    p.x = lon;
    p.y = lat;
    return p;
}
var $b37863f65bf2a2a4$export$e4b2ac9215619f8d = [
    "Miller_Cylindrical",
    "mill"
];
var $b37863f65bf2a2a4$export$2e2bcd8739ae039 = {
    init: $b37863f65bf2a2a4$export$2cd8252107eb640b,
    forward: $b37863f65bf2a2a4$export$174bb771924e7eb1,
    inverse: $b37863f65bf2a2a4$export$70ae2c07e401031b,
    names: $b37863f65bf2a2a4$export$e4b2ac9215619f8d
};



var $a9oRf = parcelRequire("a9oRf");


var $gqKpL = parcelRequire("gqKpL");

var $hpUQm = parcelRequire("hpUQm");

var $jQUK6 = parcelRequire("jQUK6");

var $gyVUi = parcelRequire("gyVUi");

var $ljPJJ = parcelRequire("ljPJJ");
var $a9d7febe7a8566f2$var$MAX_ITER = 20;
function $a9d7febe7a8566f2$export$2cd8252107eb640b() {
    /* Place parameters in static storage for common use
    -------------------------------------------------*/ if (!this.sphere) this.en = (0, $gqKpL.default)(this.es);
    else {
        this.n = 1;
        this.m = 0;
        this.es = 0;
        this.C_y = Math.sqrt((this.m + 1) / this.n);
        this.C_x = this.C_y / (this.m + 1);
    }
}
function $a9d7febe7a8566f2$export$174bb771924e7eb1(p) {
    var x, y;
    var lon = p.x;
    var lat = p.y;
    /* Forward equations
    -----------------*/ lon = (0, $a9oRf.default)(lon - this.long0);
    if (this.sphere) {
        if (!this.m) lat = this.n !== 1 ? Math.asin(this.n * Math.sin(lat)) : lat;
        else {
            var k = this.n * Math.sin(lat);
            for(var i = $a9d7febe7a8566f2$var$MAX_ITER; i; --i){
                var V = (this.m * lat + Math.sin(lat) - k) / (this.m + Math.cos(lat));
                lat -= V;
                if (Math.abs(V) < (0, $gyVUi.EPSLN)) break;
            }
        }
        x = this.a * this.C_x * lon * (this.m + Math.cos(lat));
        y = this.a * this.C_y * lat;
    } else {
        var s = Math.sin(lat);
        var c = Math.cos(lat);
        y = this.a * (0, $hpUQm.default)(lat, s, c, this.en);
        x = this.a * lon * c / Math.sqrt(1 - this.es * s * s);
    }
    p.x = x;
    p.y = y;
    return p;
}
function $a9d7febe7a8566f2$export$70ae2c07e401031b(p) {
    var lat, temp, lon, s;
    p.x -= this.x0;
    lon = p.x / this.a;
    p.y -= this.y0;
    lat = p.y / this.a;
    if (this.sphere) {
        lat /= this.C_y;
        lon = lon / (this.C_x * (this.m + Math.cos(lat)));
        if (this.m) lat = (0, $ljPJJ.default)((this.m * lat + Math.sin(lat)) / this.n);
        else if (this.n !== 1) lat = (0, $ljPJJ.default)(Math.sin(lat) / this.n);
        lon = (0, $a9oRf.default)(lon + this.long0);
        lat = (0, $7bf9815baea17aa9$export$2e2bcd8739ae039)(lat);
    } else {
        lat = (0, $jQUK6.default)(p.y / this.a, this.es, this.en);
        s = Math.abs(lat);
        if (s < (0, $gyVUi.HALF_PI)) {
            s = Math.sin(lat);
            temp = this.long0 + p.x * Math.sqrt(1 - this.es * s * s) / (this.a * Math.cos(lat));
            //temp = this.long0 + p.x / (this.a * Math.cos(lat));
            lon = (0, $a9oRf.default)(temp);
        } else if (s - (0, $gyVUi.EPSLN) < (0, $gyVUi.HALF_PI)) lon = this.long0;
    }
    p.x = lon;
    p.y = lat;
    return p;
}
var $a9d7febe7a8566f2$export$e4b2ac9215619f8d = [
    "Sinusoidal",
    "sinu"
];
var $a9d7febe7a8566f2$export$2e2bcd8739ae039 = {
    init: $a9d7febe7a8566f2$export$2cd8252107eb640b,
    forward: $a9d7febe7a8566f2$export$174bb771924e7eb1,
    inverse: $a9d7febe7a8566f2$export$70ae2c07e401031b,
    names: $a9d7febe7a8566f2$export$e4b2ac9215619f8d
};



var $a9oRf = parcelRequire("a9oRf");

var $gyVUi = parcelRequire("gyVUi");
function $57490138fba0a0b8$export$2cd8252107eb640b() {}
function $57490138fba0a0b8$export$174bb771924e7eb1(p) {
    /* Forward equations
      -----------------*/ var lon = p.x;
    var lat = p.y;
    var delta_lon = (0, $a9oRf.default)(lon - this.long0);
    var theta = lat;
    var con = Math.PI * Math.sin(lat);
    /* Iterate using the Newton-Raphson method to find theta
      -----------------------------------------------------*/ while(true){
        var delta_theta = -(theta + Math.sin(theta) - con) / (1 + Math.cos(theta));
        theta += delta_theta;
        if (Math.abs(delta_theta) < (0, $gyVUi.EPSLN)) break;
    }
    theta /= 2;
    /* If the latitude is 90 deg, force the x coordinate to be "0 + false easting"
       this is done here because of precision problems with "cos(theta)"
       --------------------------------------------------------------------------*/ if (Math.PI / 2 - Math.abs(lat) < (0, $gyVUi.EPSLN)) delta_lon = 0;
    var x = 0.900316316158 * this.a * delta_lon * Math.cos(theta) + this.x0;
    var y = 1.4142135623731 * this.a * Math.sin(theta) + this.y0;
    p.x = x;
    p.y = y;
    return p;
}
function $57490138fba0a0b8$export$70ae2c07e401031b(p) {
    var theta;
    var arg;
    /* Inverse equations
      -----------------*/ p.x -= this.x0;
    p.y -= this.y0;
    arg = p.y / (1.4142135623731 * this.a);
    /* Because of division by zero problems, 'arg' can not be 1.  Therefore
       a number very close to one is used instead.
       -------------------------------------------------------------------*/ if (Math.abs(arg) > 0.999999999999) arg = 0.999999999999;
    theta = Math.asin(arg);
    var lon = (0, $a9oRf.default)(this.long0 + p.x / (0.900316316158 * this.a * Math.cos(theta)));
    if (lon < -Math.PI) lon = -Math.PI;
    if (lon > Math.PI) lon = Math.PI;
    arg = (2 * theta + Math.sin(2 * theta)) / Math.PI;
    if (Math.abs(arg) > 1) arg = 1;
    var lat = Math.asin(arg);
    p.x = lon;
    p.y = lat;
    return p;
}
var $57490138fba0a0b8$export$e4b2ac9215619f8d = [
    "Mollweide",
    "moll"
];
var $57490138fba0a0b8$export$2e2bcd8739ae039 = {
    init: $57490138fba0a0b8$export$2cd8252107eb640b,
    forward: $57490138fba0a0b8$export$174bb771924e7eb1,
    inverse: $57490138fba0a0b8$export$70ae2c07e401031b,
    names: $57490138fba0a0b8$export$e4b2ac9215619f8d
};







var $bi5ZC = parcelRequire("bi5ZC");


var $a9oRf = parcelRequire("a9oRf");



var $gyVUi = parcelRequire("gyVUi");
function $cab513e7d920927e$export$2cd8252107eb640b() {
    /* Place parameters in static storage for common use
      -------------------------------------------------*/ // Standard Parallels cannot be equal and on opposite sides of the equator
    if (Math.abs(this.lat1 + this.lat2) < (0, $gyVUi.EPSLN)) return;
    this.lat2 = this.lat2 || this.lat1;
    this.temp = this.b / this.a;
    this.es = 1 - Math.pow(this.temp, 2);
    this.e = Math.sqrt(this.es);
    this.e0 = (0, $8b22a51ec249391e$export$2e2bcd8739ae039)(this.es);
    this.e1 = (0, $d08e0117e308bb87$export$2e2bcd8739ae039)(this.es);
    this.e2 = (0, $d36e2161accfe0ec$export$2e2bcd8739ae039)(this.es);
    this.e3 = (0, $89245c5bc9a5a616$export$2e2bcd8739ae039)(this.es);
    this.sinphi = Math.sin(this.lat1);
    this.cosphi = Math.cos(this.lat1);
    this.ms1 = (0, $bi5ZC.default)(this.e, this.sinphi, this.cosphi);
    this.ml1 = (0, $af51062589eeb2ce$export$2e2bcd8739ae039)(this.e0, this.e1, this.e2, this.e3, this.lat1);
    if (Math.abs(this.lat1 - this.lat2) < (0, $gyVUi.EPSLN)) this.ns = this.sinphi;
    else {
        this.sinphi = Math.sin(this.lat2);
        this.cosphi = Math.cos(this.lat2);
        this.ms2 = (0, $bi5ZC.default)(this.e, this.sinphi, this.cosphi);
        this.ml2 = (0, $af51062589eeb2ce$export$2e2bcd8739ae039)(this.e0, this.e1, this.e2, this.e3, this.lat2);
        this.ns = (this.ms1 - this.ms2) / (this.ml2 - this.ml1);
    }
    this.g = this.ml1 + this.ms1 / this.ns;
    this.ml0 = (0, $af51062589eeb2ce$export$2e2bcd8739ae039)(this.e0, this.e1, this.e2, this.e3, this.lat0);
    this.rh = this.a * (this.g - this.ml0);
}
function $cab513e7d920927e$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    var rh1;
    /* Forward equations
      -----------------*/ if (this.sphere) rh1 = this.a * (this.g - lat);
    else {
        var ml = (0, $af51062589eeb2ce$export$2e2bcd8739ae039)(this.e0, this.e1, this.e2, this.e3, lat);
        rh1 = this.a * (this.g - ml);
    }
    var theta = this.ns * (0, $a9oRf.default)(lon - this.long0);
    var x = this.x0 + rh1 * Math.sin(theta);
    var y = this.y0 + this.rh - rh1 * Math.cos(theta);
    p.x = x;
    p.y = y;
    return p;
}
function $cab513e7d920927e$export$70ae2c07e401031b(p) {
    p.x -= this.x0;
    p.y = this.rh - p.y + this.y0;
    var con, rh1, lat, lon;
    if (this.ns >= 0) {
        rh1 = Math.sqrt(p.x * p.x + p.y * p.y);
        con = 1;
    } else {
        rh1 = -Math.sqrt(p.x * p.x + p.y * p.y);
        con = -1;
    }
    var theta = 0;
    if (rh1 !== 0) theta = Math.atan2(con * p.x, con * p.y);
    if (this.sphere) {
        lon = (0, $a9oRf.default)(this.long0 + theta / this.ns);
        lat = (0, $7bf9815baea17aa9$export$2e2bcd8739ae039)(this.g - rh1 / this.a);
        p.x = lon;
        p.y = lat;
        return p;
    } else {
        var ml = this.g - rh1 / this.a;
        lat = (0, $8ebd4771f70de1ee$export$2e2bcd8739ae039)(ml, this.e0, this.e1, this.e2, this.e3);
        lon = (0, $a9oRf.default)(this.long0 + theta / this.ns);
        p.x = lon;
        p.y = lat;
        return p;
    }
}
var $cab513e7d920927e$export$e4b2ac9215619f8d = [
    "Equidistant_Conic",
    "eqdc"
];
var $cab513e7d920927e$export$2e2bcd8739ae039 = {
    init: $cab513e7d920927e$export$2cd8252107eb640b,
    forward: $cab513e7d920927e$export$174bb771924e7eb1,
    inverse: $cab513e7d920927e$export$70ae2c07e401031b,
    names: $cab513e7d920927e$export$e4b2ac9215619f8d
};



var $a9oRf = parcelRequire("a9oRf");

var $gyVUi = parcelRequire("gyVUi");

var $ljPJJ = parcelRequire("ljPJJ");
function $168e5f6524a6fc5f$export$2cd8252107eb640b() {
    //this.R = 6370997; //Radius of earth
    this.R = this.a;
}
function $168e5f6524a6fc5f$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    /* Forward equations
    -----------------*/ var dlon = (0, $a9oRf.default)(lon - this.long0);
    var x, y;
    if (Math.abs(lat) <= (0, $gyVUi.EPSLN)) {
        x = this.x0 + this.R * dlon;
        y = this.y0;
    }
    var theta = (0, $ljPJJ.default)(2 * Math.abs(lat / Math.PI));
    if (Math.abs(dlon) <= (0, $gyVUi.EPSLN) || Math.abs(Math.abs(lat) - (0, $gyVUi.HALF_PI)) <= (0, $gyVUi.EPSLN)) {
        x = this.x0;
        if (lat >= 0) y = this.y0 + Math.PI * this.R * Math.tan(0.5 * theta);
        else y = this.y0 + Math.PI * this.R * -Math.tan(0.5 * theta);
    //  return(OK);
    }
    var al = 0.5 * Math.abs(Math.PI / dlon - dlon / Math.PI);
    var asq = al * al;
    var sinth = Math.sin(theta);
    var costh = Math.cos(theta);
    var g = costh / (sinth + costh - 1);
    var gsq = g * g;
    var m = g * (2 / sinth - 1);
    var msq = m * m;
    var con = Math.PI * this.R * (al * (g - msq) + Math.sqrt(asq * (g - msq) * (g - msq) - (msq + asq) * (gsq - msq))) / (msq + asq);
    if (dlon < 0) con = -con;
    x = this.x0 + con;
    //con = Math.abs(con / (Math.PI * this.R));
    var q = asq + g;
    con = Math.PI * this.R * (m * q - al * Math.sqrt((msq + asq) * (asq + 1) - q * q)) / (msq + asq);
    if (lat >= 0) //y = this.y0 + Math.PI * this.R * Math.sqrt(1 - con * con - 2 * al * con);
    y = this.y0 + con;
    else //y = this.y0 - Math.PI * this.R * Math.sqrt(1 - con * con - 2 * al * con);
    y = this.y0 - con;
    p.x = x;
    p.y = y;
    return p;
}
function $168e5f6524a6fc5f$export$70ae2c07e401031b(p) {
    var lon, lat;
    var xx, yy, xys, c1, c2, c3;
    var a1;
    var m1;
    var con;
    var th1;
    var d;
    /* inverse equations
    -----------------*/ p.x -= this.x0;
    p.y -= this.y0;
    con = Math.PI * this.R;
    xx = p.x / con;
    yy = p.y / con;
    xys = xx * xx + yy * yy;
    c1 = -Math.abs(yy) * (1 + xys);
    c2 = c1 - 2 * yy * yy + xx * xx;
    c3 = -2 * c1 + 1 + 2 * yy * yy + xys * xys;
    d = yy * yy / c3 + (2 * c2 * c2 * c2 / c3 / c3 / c3 - 9 * c1 * c2 / c3 / c3) / 27;
    a1 = (c1 - c2 * c2 / 3 / c3) / c3;
    m1 = 2 * Math.sqrt(-a1 / 3);
    con = 3 * d / a1 / m1;
    if (Math.abs(con) > 1) {
        if (con >= 0) con = 1;
        else con = -1;
    }
    th1 = Math.acos(con) / 3;
    if (p.y >= 0) lat = (-m1 * Math.cos(th1 + Math.PI / 3) - c2 / 3 / c3) * Math.PI;
    else lat = -(-m1 * Math.cos(th1 + Math.PI / 3) - c2 / 3 / c3) * Math.PI;
    if (Math.abs(xx) < (0, $gyVUi.EPSLN)) lon = this.long0;
    else lon = (0, $a9oRf.default)(this.long0 + Math.PI * (xys - 1 + Math.sqrt(1 + 2 * (xx * xx - yy * yy) + xys * xys)) / 2 / xx);
    p.x = lon;
    p.y = lat;
    return p;
}
var $168e5f6524a6fc5f$export$e4b2ac9215619f8d = [
    "Van_der_Grinten_I",
    "VanDerGrinten",
    "vandg"
];
var $168e5f6524a6fc5f$export$2e2bcd8739ae039 = {
    init: $168e5f6524a6fc5f$export$2cd8252107eb640b,
    forward: $168e5f6524a6fc5f$export$174bb771924e7eb1,
    inverse: $168e5f6524a6fc5f$export$70ae2c07e401031b,
    names: $168e5f6524a6fc5f$export$e4b2ac9215619f8d
};



var $a9oRf = parcelRequire("a9oRf");

var $gyVUi = parcelRequire("gyVUi");







var $ljPJJ = parcelRequire("ljPJJ");

function $d2d34f4dbda3af26$export$2cd8252107eb640b() {
    this.sin_p12 = Math.sin(this.lat0);
    this.cos_p12 = Math.cos(this.lat0);
}
function $d2d34f4dbda3af26$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    var sinphi = Math.sin(p.y);
    var cosphi = Math.cos(p.y);
    var dlon = (0, $a9oRf.default)(lon - this.long0);
    var e0, e1, e2, e3, Mlp, Ml, tanphi, Nl1, Nl, psi, Az, G, H, GH, Hs, c, kp, cos_c, s, s2, s3, s4, s5;
    if (this.sphere) {
        if (Math.abs(this.sin_p12 - 1) <= (0, $gyVUi.EPSLN)) {
            //North Pole case
            p.x = this.x0 + this.a * ((0, $gyVUi.HALF_PI) - lat) * Math.sin(dlon);
            p.y = this.y0 - this.a * ((0, $gyVUi.HALF_PI) - lat) * Math.cos(dlon);
            return p;
        } else if (Math.abs(this.sin_p12 + 1) <= (0, $gyVUi.EPSLN)) {
            //South Pole case
            p.x = this.x0 + this.a * ((0, $gyVUi.HALF_PI) + lat) * Math.sin(dlon);
            p.y = this.y0 + this.a * ((0, $gyVUi.HALF_PI) + lat) * Math.cos(dlon);
            return p;
        } else {
            //default case
            cos_c = this.sin_p12 * sinphi + this.cos_p12 * cosphi * Math.cos(dlon);
            c = Math.acos(cos_c);
            kp = c ? c / Math.sin(c) : 1;
            p.x = this.x0 + this.a * kp * cosphi * Math.sin(dlon);
            p.y = this.y0 + this.a * kp * (this.cos_p12 * sinphi - this.sin_p12 * cosphi * Math.cos(dlon));
            return p;
        }
    } else {
        e0 = (0, $8b22a51ec249391e$export$2e2bcd8739ae039)(this.es);
        e1 = (0, $d08e0117e308bb87$export$2e2bcd8739ae039)(this.es);
        e2 = (0, $d36e2161accfe0ec$export$2e2bcd8739ae039)(this.es);
        e3 = (0, $89245c5bc9a5a616$export$2e2bcd8739ae039)(this.es);
        if (Math.abs(this.sin_p12 - 1) <= (0, $gyVUi.EPSLN)) {
            //North Pole case
            Mlp = this.a * (0, $af51062589eeb2ce$export$2e2bcd8739ae039)(e0, e1, e2, e3, (0, $gyVUi.HALF_PI));
            Ml = this.a * (0, $af51062589eeb2ce$export$2e2bcd8739ae039)(e0, e1, e2, e3, lat);
            p.x = this.x0 + (Mlp - Ml) * Math.sin(dlon);
            p.y = this.y0 - (Mlp - Ml) * Math.cos(dlon);
            return p;
        } else if (Math.abs(this.sin_p12 + 1) <= (0, $gyVUi.EPSLN)) {
            //South Pole case
            Mlp = this.a * (0, $af51062589eeb2ce$export$2e2bcd8739ae039)(e0, e1, e2, e3, (0, $gyVUi.HALF_PI));
            Ml = this.a * (0, $af51062589eeb2ce$export$2e2bcd8739ae039)(e0, e1, e2, e3, lat);
            p.x = this.x0 + (Mlp + Ml) * Math.sin(dlon);
            p.y = this.y0 + (Mlp + Ml) * Math.cos(dlon);
            return p;
        } else {
            //Default case
            tanphi = sinphi / cosphi;
            Nl1 = (0, $259e1333723cc7cb$export$2e2bcd8739ae039)(this.a, this.e, this.sin_p12);
            Nl = (0, $259e1333723cc7cb$export$2e2bcd8739ae039)(this.a, this.e, sinphi);
            psi = Math.atan((1 - this.es) * tanphi + this.es * Nl1 * this.sin_p12 / (Nl * cosphi));
            Az = Math.atan2(Math.sin(dlon), this.cos_p12 * Math.tan(psi) - this.sin_p12 * Math.cos(dlon));
            if (Az === 0) s = Math.asin(this.cos_p12 * Math.sin(psi) - this.sin_p12 * Math.cos(psi));
            else if (Math.abs(Math.abs(Az) - Math.PI) <= (0, $gyVUi.EPSLN)) s = -Math.asin(this.cos_p12 * Math.sin(psi) - this.sin_p12 * Math.cos(psi));
            else s = Math.asin(Math.sin(dlon) * Math.cos(psi) / Math.sin(Az));
            G = this.e * this.sin_p12 / Math.sqrt(1 - this.es);
            H = this.e * this.cos_p12 * Math.cos(Az) / Math.sqrt(1 - this.es);
            GH = G * H;
            Hs = H * H;
            s2 = s * s;
            s3 = s2 * s;
            s4 = s3 * s;
            s5 = s4 * s;
            c = Nl1 * s * (1 - s2 * Hs * (1 - Hs) / 6 + s3 / 8 * GH * (1 - 2 * Hs) + s4 / 120 * (Hs * (4 - 7 * Hs) - 3 * G * G * (1 - 7 * Hs)) - s5 / 48 * GH);
            p.x = this.x0 + c * Math.sin(Az);
            p.y = this.y0 + c * Math.cos(Az);
            return p;
        }
    }
}
function $d2d34f4dbda3af26$export$70ae2c07e401031b(p) {
    p.x -= this.x0;
    p.y -= this.y0;
    var rh, z, sinz, cosz, lon, lat, con, e0, e1, e2, e3, Mlp, M, N1, psi, Az, cosAz, tmp, A, B, D, Ee, F, sinpsi;
    if (this.sphere) {
        rh = Math.sqrt(p.x * p.x + p.y * p.y);
        if (rh > 2 * (0, $gyVUi.HALF_PI) * this.a) return;
        z = rh / this.a;
        sinz = Math.sin(z);
        cosz = Math.cos(z);
        lon = this.long0;
        if (Math.abs(rh) <= (0, $gyVUi.EPSLN)) lat = this.lat0;
        else {
            lat = (0, $ljPJJ.default)(cosz * this.sin_p12 + p.y * sinz * this.cos_p12 / rh);
            con = Math.abs(this.lat0) - (0, $gyVUi.HALF_PI);
            if (Math.abs(con) <= (0, $gyVUi.EPSLN)) {
                if (this.lat0 >= 0) lon = (0, $a9oRf.default)(this.long0 + Math.atan2(p.x, -p.y));
                else lon = (0, $a9oRf.default)(this.long0 - Math.atan2(-p.x, p.y));
            } else /*con = cosz - this.sin_p12 * Math.sin(lat);
        if ((Math.abs(con) < EPSLN) && (Math.abs(p.x) < EPSLN)) {
          //no-op, just keep the lon value as is
        } else {
          var temp = Math.atan2((p.x * sinz * this.cos_p12), (con * rh));
          lon = adjust_lon(this.long0 + Math.atan2((p.x * sinz * this.cos_p12), (con * rh)));
        }*/ lon = (0, $a9oRf.default)(this.long0 + Math.atan2(p.x * sinz, rh * this.cos_p12 * cosz - p.y * this.sin_p12 * sinz));
        }
        p.x = lon;
        p.y = lat;
        return p;
    } else {
        e0 = (0, $8b22a51ec249391e$export$2e2bcd8739ae039)(this.es);
        e1 = (0, $d08e0117e308bb87$export$2e2bcd8739ae039)(this.es);
        e2 = (0, $d36e2161accfe0ec$export$2e2bcd8739ae039)(this.es);
        e3 = (0, $89245c5bc9a5a616$export$2e2bcd8739ae039)(this.es);
        if (Math.abs(this.sin_p12 - 1) <= (0, $gyVUi.EPSLN)) {
            //North pole case
            Mlp = this.a * (0, $af51062589eeb2ce$export$2e2bcd8739ae039)(e0, e1, e2, e3, (0, $gyVUi.HALF_PI));
            rh = Math.sqrt(p.x * p.x + p.y * p.y);
            M = Mlp - rh;
            lat = (0, $8ebd4771f70de1ee$export$2e2bcd8739ae039)(M / this.a, e0, e1, e2, e3);
            lon = (0, $a9oRf.default)(this.long0 + Math.atan2(p.x, -1 * p.y));
            p.x = lon;
            p.y = lat;
            return p;
        } else if (Math.abs(this.sin_p12 + 1) <= (0, $gyVUi.EPSLN)) {
            //South pole case
            Mlp = this.a * (0, $af51062589eeb2ce$export$2e2bcd8739ae039)(e0, e1, e2, e3, (0, $gyVUi.HALF_PI));
            rh = Math.sqrt(p.x * p.x + p.y * p.y);
            M = rh - Mlp;
            lat = (0, $8ebd4771f70de1ee$export$2e2bcd8739ae039)(M / this.a, e0, e1, e2, e3);
            lon = (0, $a9oRf.default)(this.long0 + Math.atan2(p.x, p.y));
            p.x = lon;
            p.y = lat;
            return p;
        } else {
            //default case
            rh = Math.sqrt(p.x * p.x + p.y * p.y);
            Az = Math.atan2(p.x, p.y);
            N1 = (0, $259e1333723cc7cb$export$2e2bcd8739ae039)(this.a, this.e, this.sin_p12);
            cosAz = Math.cos(Az);
            tmp = this.e * this.cos_p12 * cosAz;
            A = -tmp * tmp / (1 - this.es);
            B = 3 * this.es * (1 - A) * this.sin_p12 * this.cos_p12 * cosAz / (1 - this.es);
            D = rh / N1;
            Ee = D - A * (1 + A) * Math.pow(D, 3) / 6 - B * (1 + 3 * A) * Math.pow(D, 4) / 24;
            F = 1 - A * Ee * Ee / 2 - D * Ee * Ee * Ee / 6;
            psi = Math.asin(this.sin_p12 * Math.cos(Ee) + this.cos_p12 * Math.sin(Ee) * cosAz);
            lon = (0, $a9oRf.default)(this.long0 + Math.asin(Math.sin(Az) * Math.sin(Ee) / Math.cos(psi)));
            sinpsi = Math.sin(psi);
            lat = Math.atan2((sinpsi - this.es * F * this.sin_p12) * Math.tan(psi), sinpsi * (1 - this.es));
            p.x = lon;
            p.y = lat;
            return p;
        }
    }
}
var $d2d34f4dbda3af26$export$e4b2ac9215619f8d = [
    "Azimuthal_Equidistant",
    "aeqd"
];
var $d2d34f4dbda3af26$export$2e2bcd8739ae039 = {
    init: $d2d34f4dbda3af26$export$2cd8252107eb640b,
    forward: $d2d34f4dbda3af26$export$174bb771924e7eb1,
    inverse: $d2d34f4dbda3af26$export$70ae2c07e401031b,
    names: $d2d34f4dbda3af26$export$e4b2ac9215619f8d
};



var $a9oRf = parcelRequire("a9oRf");

var $ljPJJ = parcelRequire("ljPJJ");

var $gyVUi = parcelRequire("gyVUi");
function $24629f153ebf2c1f$export$2cd8252107eb640b() {
    //double temp;      /* temporary variable    */
    /* Place parameters in static storage for common use
      -------------------------------------------------*/ this.sin_p14 = Math.sin(this.lat0);
    this.cos_p14 = Math.cos(this.lat0);
}
function $24629f153ebf2c1f$export$174bb771924e7eb1(p) {
    var sinphi, cosphi; /* sin and cos value        */ 
    var dlon; /* delta longitude value      */ 
    var coslon; /* cos of longitude        */ 
    var ksp; /* scale factor          */ 
    var g, x, y;
    var lon = p.x;
    var lat = p.y;
    /* Forward equations
      -----------------*/ dlon = (0, $a9oRf.default)(lon - this.long0);
    sinphi = Math.sin(lat);
    cosphi = Math.cos(lat);
    coslon = Math.cos(dlon);
    g = this.sin_p14 * sinphi + this.cos_p14 * cosphi * coslon;
    ksp = 1;
    if (g > 0 || Math.abs(g) <= (0, $gyVUi.EPSLN)) {
        x = this.a * ksp * cosphi * Math.sin(dlon);
        y = this.y0 + this.a * ksp * (this.cos_p14 * sinphi - this.sin_p14 * cosphi * coslon);
    }
    p.x = x;
    p.y = y;
    return p;
}
function $24629f153ebf2c1f$export$70ae2c07e401031b(p) {
    var rh; /* height above ellipsoid      */ 
    var z; /* angle          */ 
    var sinz, cosz; /* sin of z and cos of z      */ 
    var con;
    var lon, lat;
    /* Inverse equations
      -----------------*/ p.x -= this.x0;
    p.y -= this.y0;
    rh = Math.sqrt(p.x * p.x + p.y * p.y);
    z = (0, $ljPJJ.default)(rh / this.a);
    sinz = Math.sin(z);
    cosz = Math.cos(z);
    lon = this.long0;
    if (Math.abs(rh) <= (0, $gyVUi.EPSLN)) {
        lat = this.lat0;
        p.x = lon;
        p.y = lat;
        return p;
    }
    lat = (0, $ljPJJ.default)(cosz * this.sin_p14 + p.y * sinz * this.cos_p14 / rh);
    con = Math.abs(this.lat0) - (0, $gyVUi.HALF_PI);
    if (Math.abs(con) <= (0, $gyVUi.EPSLN)) {
        if (this.lat0 >= 0) lon = (0, $a9oRf.default)(this.long0 + Math.atan2(p.x, -p.y));
        else lon = (0, $a9oRf.default)(this.long0 - Math.atan2(-p.x, p.y));
        p.x = lon;
        p.y = lat;
        return p;
    }
    lon = (0, $a9oRf.default)(this.long0 + Math.atan2(p.x * sinz, rh * this.cos_p14 * cosz - p.y * this.sin_p14 * sinz));
    p.x = lon;
    p.y = lat;
    return p;
}
var $24629f153ebf2c1f$export$e4b2ac9215619f8d = [
    "ortho"
];
var $24629f153ebf2c1f$export$2e2bcd8739ae039 = {
    init: $24629f153ebf2c1f$export$2cd8252107eb640b,
    forward: $24629f153ebf2c1f$export$174bb771924e7eb1,
    inverse: $24629f153ebf2c1f$export$70ae2c07e401031b,
    names: $24629f153ebf2c1f$export$e4b2ac9215619f8d
};


// QSC projection rewritten from the original PROJ4
// https://github.com/OSGeo/proj.4/blob/master/src/PJ_qsc.c

var $gyVUi = parcelRequire("gyVUi");
/* constants */ var $228cab2632c5bcf7$var$FACE_ENUM = {
    FRONT: 1,
    RIGHT: 2,
    BACK: 3,
    LEFT: 4,
    TOP: 5,
    BOTTOM: 6
};
var $228cab2632c5bcf7$var$AREA_ENUM = {
    AREA_0: 1,
    AREA_1: 2,
    AREA_2: 3,
    AREA_3: 4
};
function $228cab2632c5bcf7$export$2cd8252107eb640b() {
    this.x0 = this.x0 || 0;
    this.y0 = this.y0 || 0;
    this.lat0 = this.lat0 || 0;
    this.long0 = this.long0 || 0;
    this.lat_ts = this.lat_ts || 0;
    this.title = this.title || "Quadrilateralized Spherical Cube";
    /* Determine the cube face from the center of projection. */ if (this.lat0 >= (0, $gyVUi.HALF_PI) - (0, $gyVUi.FORTPI) / 2.0) this.face = $228cab2632c5bcf7$var$FACE_ENUM.TOP;
    else if (this.lat0 <= -((0, $gyVUi.HALF_PI) - (0, $gyVUi.FORTPI) / 2.0)) this.face = $228cab2632c5bcf7$var$FACE_ENUM.BOTTOM;
    else if (Math.abs(this.long0) <= (0, $gyVUi.FORTPI)) this.face = $228cab2632c5bcf7$var$FACE_ENUM.FRONT;
    else if (Math.abs(this.long0) <= (0, $gyVUi.HALF_PI) + (0, $gyVUi.FORTPI)) this.face = this.long0 > 0.0 ? $228cab2632c5bcf7$var$FACE_ENUM.RIGHT : $228cab2632c5bcf7$var$FACE_ENUM.LEFT;
    else this.face = $228cab2632c5bcf7$var$FACE_ENUM.BACK;
    /* Fill in useful values for the ellipsoid <-> sphere shift
   * described in [LK12]. */ if (this.es !== 0) {
        this.one_minus_f = 1 - (this.a - this.b) / this.a;
        this.one_minus_f_squared = this.one_minus_f * this.one_minus_f;
    }
}
function $228cab2632c5bcf7$export$174bb771924e7eb1(p) {
    var xy = {
        x: 0,
        y: 0
    };
    var lat, lon;
    var theta, phi;
    var t, mu;
    /* nu; */ var area = {
        value: 0
    };
    // move lon according to projection's lon
    p.x -= this.long0;
    /* Convert the geodetic latitude to a geocentric latitude.
   * This corresponds to the shift from the ellipsoid to the sphere
   * described in [LK12]. */ if (this.es !== 0) lat = Math.atan(this.one_minus_f_squared * Math.tan(p.y));
    else lat = p.y;
    /* Convert the input lat, lon into theta, phi as used by QSC.
   * This depends on the cube face and the area on it.
   * For the top and bottom face, we can compute theta and phi
   * directly from phi, lam. For the other faces, we must use
   * unit sphere cartesian coordinates as an intermediate step. */ lon = p.x; //lon = lp.lam;
    if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.TOP) {
        phi = (0, $gyVUi.HALF_PI) - lat;
        if (lon >= (0, $gyVUi.FORTPI) && lon <= (0, $gyVUi.HALF_PI) + (0, $gyVUi.FORTPI)) {
            area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_0;
            theta = lon - (0, $gyVUi.HALF_PI);
        } else if (lon > (0, $gyVUi.HALF_PI) + (0, $gyVUi.FORTPI) || lon <= -((0, $gyVUi.HALF_PI) + (0, $gyVUi.FORTPI))) {
            area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_1;
            theta = lon > 0.0 ? lon - (0, $gyVUi.SPI) : lon + (0, $gyVUi.SPI);
        } else if (lon > -((0, $gyVUi.HALF_PI) + (0, $gyVUi.FORTPI)) && lon <= -(0, $gyVUi.FORTPI)) {
            area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_2;
            theta = lon + (0, $gyVUi.HALF_PI);
        } else {
            area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_3;
            theta = lon;
        }
    } else if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.BOTTOM) {
        phi = (0, $gyVUi.HALF_PI) + lat;
        if (lon >= (0, $gyVUi.FORTPI) && lon <= (0, $gyVUi.HALF_PI) + (0, $gyVUi.FORTPI)) {
            area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_0;
            theta = -lon + (0, $gyVUi.HALF_PI);
        } else if (lon < (0, $gyVUi.FORTPI) && lon >= -(0, $gyVUi.FORTPI)) {
            area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_1;
            theta = -lon;
        } else if (lon < -(0, $gyVUi.FORTPI) && lon >= -((0, $gyVUi.HALF_PI) + (0, $gyVUi.FORTPI))) {
            area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_2;
            theta = -lon - (0, $gyVUi.HALF_PI);
        } else {
            area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_3;
            theta = lon > 0.0 ? -lon + (0, $gyVUi.SPI) : -lon - (0, $gyVUi.SPI);
        }
    } else {
        var q, r, s;
        var sinlat, coslat;
        var sinlon, coslon;
        if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.RIGHT) lon = $228cab2632c5bcf7$var$qsc_shift_lon_origin(lon, +(0, $gyVUi.HALF_PI));
        else if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.BACK) lon = $228cab2632c5bcf7$var$qsc_shift_lon_origin(lon, +(0, $gyVUi.SPI));
        else if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.LEFT) lon = $228cab2632c5bcf7$var$qsc_shift_lon_origin(lon, -(0, $gyVUi.HALF_PI));
        sinlat = Math.sin(lat);
        coslat = Math.cos(lat);
        sinlon = Math.sin(lon);
        coslon = Math.cos(lon);
        q = coslat * coslon;
        r = coslat * sinlon;
        s = sinlat;
        if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.FRONT) {
            phi = Math.acos(q);
            theta = $228cab2632c5bcf7$var$qsc_fwd_equat_face_theta(phi, s, r, area);
        } else if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.RIGHT) {
            phi = Math.acos(r);
            theta = $228cab2632c5bcf7$var$qsc_fwd_equat_face_theta(phi, s, -q, area);
        } else if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.BACK) {
            phi = Math.acos(-q);
            theta = $228cab2632c5bcf7$var$qsc_fwd_equat_face_theta(phi, s, -r, area);
        } else if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.LEFT) {
            phi = Math.acos(-r);
            theta = $228cab2632c5bcf7$var$qsc_fwd_equat_face_theta(phi, s, q, area);
        } else {
            /* Impossible */ phi = theta = 0;
            area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_0;
        }
    }
    /* Compute mu and nu for the area of definition.
   * For mu, see Eq. (3-21) in [OL76], but note the typos:
   * compare with Eq. (3-14). For nu, see Eq. (3-38). */ mu = Math.atan(12 / (0, $gyVUi.SPI) * (theta + Math.acos(Math.sin(theta) * Math.cos((0, $gyVUi.FORTPI))) - (0, $gyVUi.HALF_PI)));
    t = Math.sqrt((1 - Math.cos(phi)) / (Math.cos(mu) * Math.cos(mu)) / (1 - Math.cos(Math.atan(1 / Math.cos(theta)))));
    /* Apply the result to the real area. */ if (area.value === $228cab2632c5bcf7$var$AREA_ENUM.AREA_1) mu += (0, $gyVUi.HALF_PI);
    else if (area.value === $228cab2632c5bcf7$var$AREA_ENUM.AREA_2) mu += (0, $gyVUi.SPI);
    else if (area.value === $228cab2632c5bcf7$var$AREA_ENUM.AREA_3) mu += 1.5 * (0, $gyVUi.SPI);
    /* Now compute x, y from mu and nu */ xy.x = t * Math.cos(mu);
    xy.y = t * Math.sin(mu);
    xy.x = xy.x * this.a + this.x0;
    xy.y = xy.y * this.a + this.y0;
    p.x = xy.x;
    p.y = xy.y;
    return p;
}
function $228cab2632c5bcf7$export$70ae2c07e401031b(p) {
    var lp = {
        lam: 0,
        phi: 0
    };
    var mu, nu, cosmu, tannu;
    var tantheta, theta, cosphi, phi;
    var t;
    var area = {
        value: 0
    };
    /* de-offset */ p.x = (p.x - this.x0) / this.a;
    p.y = (p.y - this.y0) / this.a;
    /* Convert the input x, y to the mu and nu angles as used by QSC.
   * This depends on the area of the cube face. */ nu = Math.atan(Math.sqrt(p.x * p.x + p.y * p.y));
    mu = Math.atan2(p.y, p.x);
    if (p.x >= 0.0 && p.x >= Math.abs(p.y)) area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_0;
    else if (p.y >= 0.0 && p.y >= Math.abs(p.x)) {
        area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_1;
        mu -= (0, $gyVUi.HALF_PI);
    } else if (p.x < 0.0 && -p.x >= Math.abs(p.y)) {
        area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_2;
        mu = mu < 0.0 ? mu + (0, $gyVUi.SPI) : mu - (0, $gyVUi.SPI);
    } else {
        area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_3;
        mu += (0, $gyVUi.HALF_PI);
    }
    /* Compute phi and theta for the area of definition.
   * The inverse projection is not described in the original paper, but some
   * good hints can be found here (as of 2011-12-14):
   * http://fits.gsfc.nasa.gov/fitsbits/saf.93/saf.9302
   * (search for "Message-Id: <9302181759.AA25477 at fits.cv.nrao.edu>") */ t = (0, $gyVUi.SPI) / 12 * Math.tan(mu);
    tantheta = Math.sin(t) / (Math.cos(t) - 1 / Math.sqrt(2));
    theta = Math.atan(tantheta);
    cosmu = Math.cos(mu);
    tannu = Math.tan(nu);
    cosphi = 1 - cosmu * cosmu * tannu * tannu * (1 - Math.cos(Math.atan(1 / Math.cos(theta))));
    if (cosphi < -1) cosphi = -1;
    else if (cosphi > 1) cosphi = 1;
    /* Apply the result to the real area on the cube face.
   * For the top and bottom face, we can compute phi and lam directly.
   * For the other faces, we must use unit sphere cartesian coordinates
   * as an intermediate step. */ if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.TOP) {
        phi = Math.acos(cosphi);
        lp.phi = (0, $gyVUi.HALF_PI) - phi;
        if (area.value === $228cab2632c5bcf7$var$AREA_ENUM.AREA_0) lp.lam = theta + (0, $gyVUi.HALF_PI);
        else if (area.value === $228cab2632c5bcf7$var$AREA_ENUM.AREA_1) lp.lam = theta < 0.0 ? theta + (0, $gyVUi.SPI) : theta - (0, $gyVUi.SPI);
        else if (area.value === $228cab2632c5bcf7$var$AREA_ENUM.AREA_2) lp.lam = theta - (0, $gyVUi.HALF_PI);
        else lp.lam = theta;
    } else if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.BOTTOM) {
        phi = Math.acos(cosphi);
        lp.phi = phi - (0, $gyVUi.HALF_PI);
        if (area.value === $228cab2632c5bcf7$var$AREA_ENUM.AREA_0) lp.lam = -theta + (0, $gyVUi.HALF_PI);
        else if (area.value === $228cab2632c5bcf7$var$AREA_ENUM.AREA_1) lp.lam = -theta;
        else if (area.value === $228cab2632c5bcf7$var$AREA_ENUM.AREA_2) lp.lam = -theta - (0, $gyVUi.HALF_PI);
        else lp.lam = theta < 0.0 ? -theta - (0, $gyVUi.SPI) : -theta + (0, $gyVUi.SPI);
    } else {
        /* Compute phi and lam via cartesian unit sphere coordinates. */ var q, r, s;
        q = cosphi;
        t = q * q;
        if (t >= 1) s = 0;
        else s = Math.sqrt(1 - t) * Math.sin(theta);
        t += s * s;
        if (t >= 1) r = 0;
        else r = Math.sqrt(1 - t);
        /* Rotate q,r,s into the correct area. */ if (area.value === $228cab2632c5bcf7$var$AREA_ENUM.AREA_1) {
            t = r;
            r = -s;
            s = t;
        } else if (area.value === $228cab2632c5bcf7$var$AREA_ENUM.AREA_2) {
            r = -r;
            s = -s;
        } else if (area.value === $228cab2632c5bcf7$var$AREA_ENUM.AREA_3) {
            t = r;
            r = s;
            s = -t;
        }
        /* Rotate q,r,s into the correct cube face. */ if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.RIGHT) {
            t = q;
            q = -r;
            r = t;
        } else if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.BACK) {
            q = -q;
            r = -r;
        } else if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.LEFT) {
            t = q;
            q = r;
            r = -t;
        }
        /* Now compute phi and lam from the unit sphere coordinates. */ lp.phi = Math.acos(-s) - (0, $gyVUi.HALF_PI);
        lp.lam = Math.atan2(r, q);
        if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.RIGHT) lp.lam = $228cab2632c5bcf7$var$qsc_shift_lon_origin(lp.lam, -(0, $gyVUi.HALF_PI));
        else if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.BACK) lp.lam = $228cab2632c5bcf7$var$qsc_shift_lon_origin(lp.lam, -(0, $gyVUi.SPI));
        else if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.LEFT) lp.lam = $228cab2632c5bcf7$var$qsc_shift_lon_origin(lp.lam, +(0, $gyVUi.HALF_PI));
    }
    /* Apply the shift from the sphere to the ellipsoid as described
   * in [LK12]. */ if (this.es !== 0) {
        var invert_sign;
        var tanphi, xa;
        invert_sign = lp.phi < 0 ? 1 : 0;
        tanphi = Math.tan(lp.phi);
        xa = this.b / Math.sqrt(tanphi * tanphi + this.one_minus_f_squared);
        lp.phi = Math.atan(Math.sqrt(this.a * this.a - xa * xa) / (this.one_minus_f * xa));
        if (invert_sign) lp.phi = -lp.phi;
    }
    lp.lam += this.long0;
    p.x = lp.lam;
    p.y = lp.phi;
    return p;
}
/* Helper function for forward projection: compute the theta angle
 * and determine the area number. */ function $228cab2632c5bcf7$var$qsc_fwd_equat_face_theta(phi, y, x, area) {
    var theta;
    if (phi < (0, $gyVUi.EPSLN)) {
        area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_0;
        theta = 0.0;
    } else {
        theta = Math.atan2(y, x);
        if (Math.abs(theta) <= (0, $gyVUi.FORTPI)) area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_0;
        else if (theta > (0, $gyVUi.FORTPI) && theta <= (0, $gyVUi.HALF_PI) + (0, $gyVUi.FORTPI)) {
            area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_1;
            theta -= (0, $gyVUi.HALF_PI);
        } else if (theta > (0, $gyVUi.HALF_PI) + (0, $gyVUi.FORTPI) || theta <= -((0, $gyVUi.HALF_PI) + (0, $gyVUi.FORTPI))) {
            area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_2;
            theta = theta >= 0.0 ? theta - (0, $gyVUi.SPI) : theta + (0, $gyVUi.SPI);
        } else {
            area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_3;
            theta += (0, $gyVUi.HALF_PI);
        }
    }
    return theta;
}
/* Helper function: shift the longitude. */ function $228cab2632c5bcf7$var$qsc_shift_lon_origin(lon, offset) {
    var slon = lon + offset;
    if (slon < -(0, $gyVUi.SPI)) slon += (0, $gyVUi.TWO_PI);
    else if (slon > +(0, $gyVUi.SPI)) slon -= (0, $gyVUi.TWO_PI);
    return slon;
}
var $228cab2632c5bcf7$export$e4b2ac9215619f8d = [
    "Quadrilateralized Spherical Cube",
    "Quadrilateralized_Spherical_Cube",
    "qsc"
];
var $228cab2632c5bcf7$export$2e2bcd8739ae039 = {
    init: $228cab2632c5bcf7$export$2cd8252107eb640b,
    forward: $228cab2632c5bcf7$export$174bb771924e7eb1,
    inverse: $228cab2632c5bcf7$export$70ae2c07e401031b,
    names: $228cab2632c5bcf7$export$e4b2ac9215619f8d
};


// Robinson projection
// Based on https://github.com/OSGeo/proj.4/blob/master/src/PJ_robin.c
// Polynomial coeficients from http://article.gmane.org/gmane.comp.gis.proj-4.devel/6039

var $gyVUi = parcelRequire("gyVUi");

var $a9oRf = parcelRequire("a9oRf");
var $86b26d30d3579075$var$COEFS_X = [
    [
        1.0000,
        2.2199e-17,
        -0.0000715515,
        3.1103e-06
    ],
    [
        0.9986,
        -0.000482243,
        -0.000024897,
        -0.0000013309
    ],
    [
        0.9954,
        -0.00083103,
        -0.0000448605,
        -0.000000986701
    ],
    [
        0.9900,
        -0.00135364,
        -0.000059661,
        3.6777e-06
    ],
    [
        0.9822,
        -0.00167442,
        -0.00000449547,
        -0.00000572411
    ],
    [
        0.9730,
        -0.00214868,
        -0.0000903571,
        1.8736e-08
    ],
    [
        0.9600,
        -0.00305085,
        -0.0000900761,
        1.64917e-06
    ],
    [
        0.9427,
        -0.00382792,
        -0.0000653386,
        -0.0000026154
    ],
    [
        0.9216,
        -0.00467746,
        -0.00010457,
        4.81243e-06
    ],
    [
        0.8962,
        -0.00536223,
        -0.0000323831,
        -0.00000543432
    ],
    [
        0.8679,
        -0.00609363,
        -0.000113898,
        3.32484e-06
    ],
    [
        0.8350,
        -0.00698325,
        -0.0000640253,
        9.34959e-07
    ],
    [
        0.7986,
        -0.00755338,
        -0.0000500009,
        9.35324e-07
    ],
    [
        0.7597,
        -0.00798324,
        -0.000035971,
        -0.00000227626
    ],
    [
        0.7186,
        -0.00851367,
        -0.0000701149,
        -0.0000086303
    ],
    [
        0.6732,
        -0.00986209,
        -0.000199569,
        1.91974e-05
    ],
    [
        0.6213,
        -0.010418,
        8.83923e-05,
        6.24051e-06
    ],
    [
        0.5722,
        -0.00906601,
        0.000182,
        6.24051e-06
    ],
    [
        0.5322,
        -0.00677797,
        0.000275608,
        6.24051e-06
    ]
];
var $86b26d30d3579075$var$COEFS_Y = [
    [
        -0.00000000000000000520417,
        0.0124,
        1.21431e-18,
        -0.0000000000845284
    ],
    [
        0.0620,
        0.0124,
        -0.00000000126793,
        4.22642e-10
    ],
    [
        0.1240,
        0.0124,
        5.07171e-09,
        -0.00000000160604
    ],
    [
        0.1860,
        0.0123999,
        -0.0000000190189,
        6.00152e-09
    ],
    [
        0.2480,
        0.0124002,
        7.10039e-08,
        -0.0000000224
    ],
    [
        0.3100,
        0.0123992,
        -0.000000264997,
        8.35986e-08
    ],
    [
        0.3720,
        0.0124029,
        9.88983e-07,
        -0.000000311994
    ],
    [
        0.4340,
        0.0123893,
        -0.00000369093,
        -0.000000435621
    ],
    [
        0.4958,
        0.0123198,
        -0.0000102252,
        -0.000000345523
    ],
    [
        0.5571,
        0.0121916,
        -0.0000154081,
        -0.000000582288
    ],
    [
        0.6176,
        0.0119938,
        -0.0000241424,
        -0.000000525327
    ],
    [
        0.6769,
        0.011713,
        -0.0000320223,
        -0.000000516405
    ],
    [
        0.7346,
        0.0113541,
        -0.0000397684,
        -0.000000609052
    ],
    [
        0.7903,
        0.0109107,
        -0.0000489042,
        -0.00000104739
    ],
    [
        0.8435,
        0.0103431,
        -0.000064615,
        -0.00000000140374
    ],
    [
        0.8936,
        0.00969686,
        -0.000064636,
        -0.000008547
    ],
    [
        0.9394,
        0.00840947,
        -0.000192841,
        -0.0000042106
    ],
    [
        0.9761,
        0.00616527,
        -0.000256,
        -0.0000042106
    ],
    [
        1.0000,
        0.00328947,
        -0.000319159,
        -0.0000042106
    ]
];
var $86b26d30d3579075$var$FXC = 0.8487;
var $86b26d30d3579075$var$FYC = 1.3523;
var $86b26d30d3579075$var$C1 = (0, $gyVUi.R2D) / 5; // rad to 5-degree interval
var $86b26d30d3579075$var$RC1 = 1 / $86b26d30d3579075$var$C1;
var $86b26d30d3579075$var$NODES = 18;
var $86b26d30d3579075$var$poly3_val = function(coefs, x) {
    return coefs[0] + x * (coefs[1] + x * (coefs[2] + x * coefs[3]));
};
var $86b26d30d3579075$var$poly3_der = function(coefs, x) {
    return coefs[1] + x * (2 * coefs[2] + x * 3 * coefs[3]);
};
function $86b26d30d3579075$var$newton_rapshon(f_df, start, max_err, iters) {
    var x = start;
    for(; iters; --iters){
        var upd = f_df(x);
        x -= upd;
        if (Math.abs(upd) < max_err) break;
    }
    return x;
}
function $86b26d30d3579075$export$2cd8252107eb640b() {
    this.x0 = this.x0 || 0;
    this.y0 = this.y0 || 0;
    this.long0 = this.long0 || 0;
    this.es = 0;
    this.title = this.title || "Robinson";
}
function $86b26d30d3579075$export$174bb771924e7eb1(ll) {
    var lon = (0, $a9oRf.default)(ll.x - this.long0);
    var dphi = Math.abs(ll.y);
    var i = Math.floor(dphi * $86b26d30d3579075$var$C1);
    if (i < 0) i = 0;
    else if (i >= $86b26d30d3579075$var$NODES) i = $86b26d30d3579075$var$NODES - 1;
    dphi = (0, $gyVUi.R2D) * (dphi - $86b26d30d3579075$var$RC1 * i);
    var xy = {
        x: $86b26d30d3579075$var$poly3_val($86b26d30d3579075$var$COEFS_X[i], dphi) * lon,
        y: $86b26d30d3579075$var$poly3_val($86b26d30d3579075$var$COEFS_Y[i], dphi)
    };
    if (ll.y < 0) xy.y = -xy.y;
    xy.x = xy.x * this.a * $86b26d30d3579075$var$FXC + this.x0;
    xy.y = xy.y * this.a * $86b26d30d3579075$var$FYC + this.y0;
    return xy;
}
function $86b26d30d3579075$export$70ae2c07e401031b(xy) {
    var ll = {
        x: (xy.x - this.x0) / (this.a * $86b26d30d3579075$var$FXC),
        y: Math.abs(xy.y - this.y0) / (this.a * $86b26d30d3579075$var$FYC)
    };
    if (ll.y >= 1) {
        ll.x /= $86b26d30d3579075$var$COEFS_X[$86b26d30d3579075$var$NODES][0];
        ll.y = xy.y < 0 ? -(0, $gyVUi.HALF_PI) : (0, $gyVUi.HALF_PI);
    } else {
        // find table interval
        var i = Math.floor(ll.y * $86b26d30d3579075$var$NODES);
        if (i < 0) i = 0;
        else if (i >= $86b26d30d3579075$var$NODES) i = $86b26d30d3579075$var$NODES - 1;
        for(;;){
            if ($86b26d30d3579075$var$COEFS_Y[i][0] > ll.y) --i;
            else if ($86b26d30d3579075$var$COEFS_Y[i + 1][0] <= ll.y) ++i;
            else break;
        }
        // linear interpolation in 5 degree interval
        var coefs = $86b26d30d3579075$var$COEFS_Y[i];
        var t = 5 * (ll.y - coefs[0]) / ($86b26d30d3579075$var$COEFS_Y[i + 1][0] - coefs[0]);
        // find t so that poly3_val(coefs, t) = ll.y
        t = $86b26d30d3579075$var$newton_rapshon(function(x) {
            return ($86b26d30d3579075$var$poly3_val(coefs, x) - ll.y) / $86b26d30d3579075$var$poly3_der(coefs, x);
        }, t, (0, $gyVUi.EPSLN), 100);
        ll.x /= $86b26d30d3579075$var$poly3_val($86b26d30d3579075$var$COEFS_X[i], t);
        ll.y = (5 * i + t) * (0, $gyVUi.D2R);
        if (xy.y < 0) ll.y = -ll.y;
    }
    ll.x = (0, $a9oRf.default)(ll.x + this.long0);
    return ll;
}
var $86b26d30d3579075$export$e4b2ac9215619f8d = [
    "Robinson",
    "robin"
];
var $86b26d30d3579075$export$2e2bcd8739ae039 = {
    init: $86b26d30d3579075$export$2cd8252107eb640b,
    forward: $86b26d30d3579075$export$174bb771924e7eb1,
    inverse: $86b26d30d3579075$export$70ae2c07e401031b,
    names: $86b26d30d3579075$export$e4b2ac9215619f8d
};



function $07c2abe70612fbc5$export$2cd8252107eb640b() {
    this.name = 'geocent';
}
function $07c2abe70612fbc5$export$174bb771924e7eb1(p) {
    var point = (0, $3a04bd721826a648$export$4a4ae2976f9a808a)(p, this.es, this.a);
    return point;
}
function $07c2abe70612fbc5$export$70ae2c07e401031b(p) {
    var point = (0, $3a04bd721826a648$export$26210192c8922750)(p, this.es, this.a, this.b);
    return point;
}
var $07c2abe70612fbc5$export$e4b2ac9215619f8d = [
    "Geocentric",
    'geocentric',
    "geocent",
    "Geocent"
];
var $07c2abe70612fbc5$export$2e2bcd8739ae039 = {
    init: $07c2abe70612fbc5$export$2cd8252107eb640b,
    forward: $07c2abe70612fbc5$export$174bb771924e7eb1,
    inverse: $07c2abe70612fbc5$export$70ae2c07e401031b,
    names: $07c2abe70612fbc5$export$e4b2ac9215619f8d
};



var $gyVUi = parcelRequire("gyVUi");

var $jU5gu = parcelRequire("jU5gu");
var $ab98c67e9f567a4b$var$mode = {
    N_POLE: 0,
    S_POLE: 1,
    EQUIT: 2,
    OBLIQ: 3
};
var $ab98c67e9f567a4b$var$params = {
    h: {
        def: 100000,
        num: true
    },
    azi: {
        def: 0,
        num: true,
        degrees: true
    },
    tilt: {
        def: 0,
        num: true,
        degrees: true
    },
    long0: {
        def: 0,
        num: true
    },
    lat0: {
        def: 0,
        num: true
    } // default is Equator, conversion to rad is automatic
};
function $ab98c67e9f567a4b$export$2cd8252107eb640b() {
    Object.keys($ab98c67e9f567a4b$var$params).forEach((function(p) {
        if (typeof this[p] === "undefined") this[p] = $ab98c67e9f567a4b$var$params[p].def;
        else if ($ab98c67e9f567a4b$var$params[p].num && isNaN(this[p])) throw new Error("Invalid parameter value, must be numeric " + p + " = " + this[p]);
        else if ($ab98c67e9f567a4b$var$params[p].num) this[p] = parseFloat(this[p]);
        if ($ab98c67e9f567a4b$var$params[p].degrees) this[p] = this[p] * (0, $gyVUi.D2R);
    }).bind(this));
    if (Math.abs(Math.abs(this.lat0) - (0, $gyVUi.HALF_PI)) < (0, $gyVUi.EPSLN)) this.mode = this.lat0 < 0 ? $ab98c67e9f567a4b$var$mode.S_POLE : $ab98c67e9f567a4b$var$mode.N_POLE;
    else if (Math.abs(this.lat0) < (0, $gyVUi.EPSLN)) this.mode = $ab98c67e9f567a4b$var$mode.EQUIT;
    else {
        this.mode = $ab98c67e9f567a4b$var$mode.OBLIQ;
        this.sinph0 = Math.sin(this.lat0);
        this.cosph0 = Math.cos(this.lat0);
    }
    this.pn1 = this.h / this.a; // Normalize relative to the Earth's radius
    if (this.pn1 <= 0 || this.pn1 > 1e10) throw new Error("Invalid height");
    this.p = 1 + this.pn1;
    this.rp = 1 / this.p;
    this.h1 = 1 / this.pn1;
    this.pfact = (this.p + 1) * this.h1;
    this.es = 0;
    var omega = this.tilt;
    var gamma = this.azi;
    this.cg = Math.cos(gamma);
    this.sg = Math.sin(gamma);
    this.cw = Math.cos(omega);
    this.sw = Math.sin(omega);
}
function $ab98c67e9f567a4b$export$174bb771924e7eb1(p) {
    p.x -= this.long0;
    var sinphi = Math.sin(p.y);
    var cosphi = Math.cos(p.y);
    var coslam = Math.cos(p.x);
    var x, y;
    switch(this.mode){
        case $ab98c67e9f567a4b$var$mode.OBLIQ:
            y = this.sinph0 * sinphi + this.cosph0 * cosphi * coslam;
            break;
        case $ab98c67e9f567a4b$var$mode.EQUIT:
            y = cosphi * coslam;
            break;
        case $ab98c67e9f567a4b$var$mode.S_POLE:
            y = -sinphi;
            break;
        case $ab98c67e9f567a4b$var$mode.N_POLE:
            y = sinphi;
            break;
    }
    y = this.pn1 / (this.p - y);
    x = y * cosphi * Math.sin(p.x);
    switch(this.mode){
        case $ab98c67e9f567a4b$var$mode.OBLIQ:
            y *= this.cosph0 * sinphi - this.sinph0 * cosphi * coslam;
            break;
        case $ab98c67e9f567a4b$var$mode.EQUIT:
            y *= sinphi;
            break;
        case $ab98c67e9f567a4b$var$mode.N_POLE:
            y *= -(cosphi * coslam);
            break;
        case $ab98c67e9f567a4b$var$mode.S_POLE:
            y *= cosphi * coslam;
            break;
    }
    // Tilt 
    var yt, ba;
    yt = y * this.cg + x * this.sg;
    ba = 1 / (yt * this.sw * this.h1 + this.cw);
    x = (x * this.cg - y * this.sg) * this.cw * ba;
    y = yt * ba;
    p.x = x * this.a;
    p.y = y * this.a;
    return p;
}
function $ab98c67e9f567a4b$export$70ae2c07e401031b(p) {
    p.x /= this.a;
    p.y /= this.a;
    var r = {
        x: p.x,
        y: p.y
    };
    // Un-Tilt
    var bm, bq, yt;
    yt = 1 / (this.pn1 - p.y * this.sw);
    bm = this.pn1 * p.x * yt;
    bq = this.pn1 * p.y * this.cw * yt;
    p.x = bm * this.cg + bq * this.sg;
    p.y = bq * this.cg - bm * this.sg;
    var rh = (0, $jU5gu.default)(p.x, p.y);
    if (Math.abs(rh) < (0, $gyVUi.EPSLN)) {
        r.x = 0;
        r.y = p.y;
    } else {
        var cosz, sinz;
        sinz = 1 - rh * rh * this.pfact;
        sinz = (this.p - Math.sqrt(sinz)) / (this.pn1 / rh + rh / this.pn1);
        cosz = Math.sqrt(1 - sinz * sinz);
        switch(this.mode){
            case $ab98c67e9f567a4b$var$mode.OBLIQ:
                r.y = Math.asin(cosz * this.sinph0 + p.y * sinz * this.cosph0 / rh);
                p.y = (cosz - this.sinph0 * Math.sin(r.y)) * rh;
                p.x *= sinz * this.cosph0;
                break;
            case $ab98c67e9f567a4b$var$mode.EQUIT:
                r.y = Math.asin(p.y * sinz / rh);
                p.y = cosz * rh;
                p.x *= sinz;
                break;
            case $ab98c67e9f567a4b$var$mode.N_POLE:
                r.y = Math.asin(cosz);
                p.y = -p.y;
                break;
            case $ab98c67e9f567a4b$var$mode.S_POLE:
                r.y = -Math.asin(cosz);
                break;
        }
        r.x = Math.atan2(p.x, p.y);
    }
    p.x = r.x + this.long0;
    p.y = r.y;
    return p;
}
var $ab98c67e9f567a4b$export$e4b2ac9215619f8d = [
    "Tilted_Perspective",
    "tpers"
];
var $ab98c67e9f567a4b$export$2e2bcd8739ae039 = {
    init: $ab98c67e9f567a4b$export$2cd8252107eb640b,
    forward: $ab98c67e9f567a4b$export$174bb771924e7eb1,
    inverse: $ab98c67e9f567a4b$export$70ae2c07e401031b,
    names: $ab98c67e9f567a4b$export$e4b2ac9215619f8d
};



var $jU5gu = parcelRequire("jU5gu");
function $e5c7855edcbcda04$export$2cd8252107eb640b() {
    this.flip_axis = this.sweep === 'x' ? 1 : 0;
    this.h = Number(this.h);
    this.radius_g_1 = this.h / this.a;
    if (this.radius_g_1 <= 0 || this.radius_g_1 > 1e10) throw new Error();
    this.radius_g = 1.0 + this.radius_g_1;
    this.C = this.radius_g * this.radius_g - 1.0;
    if (this.es !== 0.0) {
        var one_es = 1.0 - this.es;
        var rone_es = 1 / one_es;
        this.radius_p = Math.sqrt(one_es);
        this.radius_p2 = one_es;
        this.radius_p_inv2 = rone_es;
        this.shape = 'ellipse'; // Use as a condition in the forward and inverse functions.
    } else {
        this.radius_p = 1.0;
        this.radius_p2 = 1.0;
        this.radius_p_inv2 = 1.0;
        this.shape = 'sphere'; // Use as a condition in the forward and inverse functions.
    }
    if (!this.title) this.title = "Geostationary Satellite View";
}
function $e5c7855edcbcda04$var$forward(p) {
    var lon = p.x;
    var lat = p.y;
    var tmp, v_x, v_y, v_z;
    lon = lon - this.long0;
    if (this.shape === 'ellipse') {
        lat = Math.atan(this.radius_p2 * Math.tan(lat));
        var r = this.radius_p / (0, $jU5gu.default)(this.radius_p * Math.cos(lat), Math.sin(lat));
        v_x = r * Math.cos(lon) * Math.cos(lat);
        v_y = r * Math.sin(lon) * Math.cos(lat);
        v_z = r * Math.sin(lat);
        if ((this.radius_g - v_x) * v_x - v_y * v_y - v_z * v_z * this.radius_p_inv2 < 0.0) {
            p.x = Number.NaN;
            p.y = Number.NaN;
            return p;
        }
        tmp = this.radius_g - v_x;
        if (this.flip_axis) {
            p.x = this.radius_g_1 * Math.atan(v_y / (0, $jU5gu.default)(v_z, tmp));
            p.y = this.radius_g_1 * Math.atan(v_z / tmp);
        } else {
            p.x = this.radius_g_1 * Math.atan(v_y / tmp);
            p.y = this.radius_g_1 * Math.atan(v_z / (0, $jU5gu.default)(v_y, tmp));
        }
    } else if (this.shape === 'sphere') {
        tmp = Math.cos(lat);
        v_x = Math.cos(lon) * tmp;
        v_y = Math.sin(lon) * tmp;
        v_z = Math.sin(lat);
        tmp = this.radius_g - v_x;
        if (this.flip_axis) {
            p.x = this.radius_g_1 * Math.atan(v_y / (0, $jU5gu.default)(v_z, tmp));
            p.y = this.radius_g_1 * Math.atan(v_z / tmp);
        } else {
            p.x = this.radius_g_1 * Math.atan(v_y / tmp);
            p.y = this.radius_g_1 * Math.atan(v_z / (0, $jU5gu.default)(v_y, tmp));
        }
    }
    p.x = p.x * this.a;
    p.y = p.y * this.a;
    return p;
}
function $e5c7855edcbcda04$var$inverse(p) {
    var v_x = -1;
    var v_y = 0.0;
    var v_z = 0.0;
    var a, b, det, k;
    p.x = p.x / this.a;
    p.y = p.y / this.a;
    if (this.shape === 'ellipse') {
        if (this.flip_axis) {
            v_z = Math.tan(p.y / this.radius_g_1);
            v_y = Math.tan(p.x / this.radius_g_1) * (0, $jU5gu.default)(1.0, v_z);
        } else {
            v_y = Math.tan(p.x / this.radius_g_1);
            v_z = Math.tan(p.y / this.radius_g_1) * (0, $jU5gu.default)(1.0, v_y);
        }
        var v_zp = v_z / this.radius_p;
        a = v_y * v_y + v_zp * v_zp + v_x * v_x;
        b = 2 * this.radius_g * v_x;
        det = b * b - 4 * a * this.C;
        if (det < 0.0) {
            p.x = Number.NaN;
            p.y = Number.NaN;
            return p;
        }
        k = (-b - Math.sqrt(det)) / (2.0 * a);
        v_x = this.radius_g + k * v_x;
        v_y *= k;
        v_z *= k;
        p.x = Math.atan2(v_y, v_x);
        p.y = Math.atan(v_z * Math.cos(p.x) / v_x);
        p.y = Math.atan(this.radius_p_inv2 * Math.tan(p.y));
    } else if (this.shape === 'sphere') {
        if (this.flip_axis) {
            v_z = Math.tan(p.y / this.radius_g_1);
            v_y = Math.tan(p.x / this.radius_g_1) * Math.sqrt(1.0 + v_z * v_z);
        } else {
            v_y = Math.tan(p.x / this.radius_g_1);
            v_z = Math.tan(p.y / this.radius_g_1) * Math.sqrt(1.0 + v_y * v_y);
        }
        a = v_y * v_y + v_z * v_z + v_x * v_x;
        b = 2 * this.radius_g * v_x;
        det = b * b - 4 * a * this.C;
        if (det < 0.0) {
            p.x = Number.NaN;
            p.y = Number.NaN;
            return p;
        }
        k = (-b - Math.sqrt(det)) / (2.0 * a);
        v_x = this.radius_g + k * v_x;
        v_y *= k;
        v_z *= k;
        p.x = Math.atan2(v_y, v_x);
        p.y = Math.atan(v_z * Math.cos(p.x) / v_x);
    }
    p.x = p.x + this.long0;
    return p;
}
var $e5c7855edcbcda04$export$e4b2ac9215619f8d = [
    "Geostationary Satellite View",
    "Geostationary_Satellite",
    "geos"
];
var $e5c7855edcbcda04$export$2e2bcd8739ae039 = {
    init: $e5c7855edcbcda04$export$2cd8252107eb640b,
    forward: $e5c7855edcbcda04$var$forward,
    inverse: $e5c7855edcbcda04$var$inverse,
    names: $e5c7855edcbcda04$export$e4b2ac9215619f8d
};


/**
 * Copyright 2018 Bernie Jenny, Monash University, Melbourne, Australia.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Equal Earth is a projection inspired by the Robinson projection, but unlike
 * the Robinson projection retains the relative size of areas. The projection
 * was designed in 2018 by Bojan Savric, Tom Patterson and Bernhard Jenny.
 *
 * Publication:
 * Bojan Savric, Tom Patterson & Bernhard Jenny (2018). The Equal Earth map
 * projection, International Journal of Geographical Information Science,
 * DOI: 10.1080/13658816.2018.1504949
 *
 * Code released August 2018
 * Ported to JavaScript and adapted for mapshaper-proj by Matthew Bloch August 2018
 * Modified for proj4js by Andreas Hocevar by Andreas Hocevar March 2024
 */ 
var $a9oRf = parcelRequire("a9oRf");
var $8df30f7b6f96e4d8$var$A1 = 1.340264, $8df30f7b6f96e4d8$var$A2 = -0.081106, $8df30f7b6f96e4d8$var$A3 = 0.000893, $8df30f7b6f96e4d8$var$A4 = 0.003796, $8df30f7b6f96e4d8$var$M = Math.sqrt(3) / 2.0;
function $8df30f7b6f96e4d8$export$2cd8252107eb640b() {
    this.es = 0;
    this.long0 = this.long0 !== undefined ? this.long0 : 0;
}
function $8df30f7b6f96e4d8$export$174bb771924e7eb1(p) {
    var lam = (0, $a9oRf.default)(p.x - this.long0);
    var phi = p.y;
    var paramLat = Math.asin($8df30f7b6f96e4d8$var$M * Math.sin(phi)), paramLatSq = paramLat * paramLat, paramLatPow6 = paramLatSq * paramLatSq * paramLatSq;
    p.x = lam * Math.cos(paramLat) / ($8df30f7b6f96e4d8$var$M * ($8df30f7b6f96e4d8$var$A1 + 3 * $8df30f7b6f96e4d8$var$A2 * paramLatSq + paramLatPow6 * (7 * $8df30f7b6f96e4d8$var$A3 + 9 * $8df30f7b6f96e4d8$var$A4 * paramLatSq)));
    p.y = paramLat * ($8df30f7b6f96e4d8$var$A1 + $8df30f7b6f96e4d8$var$A2 * paramLatSq + paramLatPow6 * ($8df30f7b6f96e4d8$var$A3 + $8df30f7b6f96e4d8$var$A4 * paramLatSq));
    p.x = this.a * p.x + this.x0;
    p.y = this.a * p.y + this.y0;
    return p;
}
function $8df30f7b6f96e4d8$export$70ae2c07e401031b(p) {
    p.x = (p.x - this.x0) / this.a;
    p.y = (p.y - this.y0) / this.a;
    var EPS = 1e-9, NITER = 12, paramLat = p.y, paramLatSq, paramLatPow6, fy, fpy, dlat, i;
    for(i = 0; i < NITER; ++i){
        paramLatSq = paramLat * paramLat;
        paramLatPow6 = paramLatSq * paramLatSq * paramLatSq;
        fy = paramLat * ($8df30f7b6f96e4d8$var$A1 + $8df30f7b6f96e4d8$var$A2 * paramLatSq + paramLatPow6 * ($8df30f7b6f96e4d8$var$A3 + $8df30f7b6f96e4d8$var$A4 * paramLatSq)) - p.y;
        fpy = $8df30f7b6f96e4d8$var$A1 + 3 * $8df30f7b6f96e4d8$var$A2 * paramLatSq + paramLatPow6 * (7 * $8df30f7b6f96e4d8$var$A3 + 9 * $8df30f7b6f96e4d8$var$A4 * paramLatSq);
        paramLat -= dlat = fy / fpy;
        if (Math.abs(dlat) < EPS) break;
    }
    paramLatSq = paramLat * paramLat;
    paramLatPow6 = paramLatSq * paramLatSq * paramLatSq;
    p.x = $8df30f7b6f96e4d8$var$M * p.x * ($8df30f7b6f96e4d8$var$A1 + 3 * $8df30f7b6f96e4d8$var$A2 * paramLatSq + paramLatPow6 * (7 * $8df30f7b6f96e4d8$var$A3 + 9 * $8df30f7b6f96e4d8$var$A4 * paramLatSq)) / Math.cos(paramLat);
    p.y = Math.asin(Math.sin(paramLat) / $8df30f7b6f96e4d8$var$M);
    p.x = (0, $a9oRf.default)(p.x + this.long0);
    return p;
}
var $8df30f7b6f96e4d8$export$e4b2ac9215619f8d = [
    "eqearth",
    "Equal Earth",
    "Equal_Earth"
];
var $8df30f7b6f96e4d8$export$2e2bcd8739ae039 = {
    init: $8df30f7b6f96e4d8$export$2cd8252107eb640b,
    forward: $8df30f7b6f96e4d8$export$174bb771924e7eb1,
    inverse: $8df30f7b6f96e4d8$export$70ae2c07e401031b,
    names: $8df30f7b6f96e4d8$export$e4b2ac9215619f8d
};




var $a9oRf = parcelRequire("a9oRf");

var $jU5gu = parcelRequire("jU5gu");

var $gqKpL = parcelRequire("gqKpL");

var $jQUK6 = parcelRequire("jQUK6");

var $hpUQm = parcelRequire("hpUQm");

var $gyVUi = parcelRequire("gyVUi");
var $bffedda91368999e$var$EPS10 = 1e-10;
function $bffedda91368999e$export$2cd8252107eb640b() {
    var c;
    this.phi1 = this.lat1;
    if (Math.abs(this.phi1) < $bffedda91368999e$var$EPS10) throw new Error();
    if (this.es) {
        this.en = (0, $gqKpL.default)(this.es);
        this.m1 = (0, $hpUQm.default)(this.phi1, this.am1 = Math.sin(this.phi1), c = Math.cos(this.phi1), this.en);
        this.am1 = c / (Math.sqrt(1 - this.es * this.am1 * this.am1) * this.am1);
        this.inverse = $bffedda91368999e$var$e_inv;
        this.forward = $bffedda91368999e$var$e_fwd;
    } else {
        if (Math.abs(this.phi1) + $bffedda91368999e$var$EPS10 >= (0, $gyVUi.HALF_PI)) this.cphi1 = 0;
        else this.cphi1 = 1 / Math.tan(this.phi1);
        this.inverse = $bffedda91368999e$var$s_inv;
        this.forward = $bffedda91368999e$var$s_fwd;
    }
}
function $bffedda91368999e$var$e_fwd(p) {
    var lam = (0, $a9oRf.default)(p.x - (this.long0 || 0));
    var phi = p.y;
    var rh, E, c;
    rh = this.am1 + this.m1 - (0, $hpUQm.default)(phi, E = Math.sin(phi), c = Math.cos(phi), this.en);
    E = c * lam / (rh * Math.sqrt(1 - this.es * E * E));
    p.x = rh * Math.sin(E);
    p.y = this.am1 - rh * Math.cos(E);
    p.x = this.a * p.x + (this.x0 || 0);
    p.y = this.a * p.y + (this.y0 || 0);
    return p;
}
function $bffedda91368999e$var$e_inv(p) {
    p.x = (p.x - (this.x0 || 0)) / this.a;
    p.y = (p.y - (this.y0 || 0)) / this.a;
    var s, rh, lam, phi;
    rh = (0, $jU5gu.default)(p.x, p.y = this.am1 - p.y);
    phi = (0, $jQUK6.default)(this.am1 + this.m1 - rh, this.es, this.en);
    if ((s = Math.abs(phi)) < (0, $gyVUi.HALF_PI)) {
        s = Math.sin(phi);
        lam = rh * Math.atan2(p.x, p.y) * Math.sqrt(1 - this.es * s * s) / Math.cos(phi);
    } else if (Math.abs(s - (0, $gyVUi.HALF_PI)) <= $bffedda91368999e$var$EPS10) lam = 0;
    else throw new Error();
    p.x = (0, $a9oRf.default)(lam + (this.long0 || 0));
    p.y = (0, $7bf9815baea17aa9$export$2e2bcd8739ae039)(phi);
    return p;
}
function $bffedda91368999e$var$s_fwd(p) {
    var lam = (0, $a9oRf.default)(p.x - (this.long0 || 0));
    var phi = p.y;
    var E, rh;
    rh = this.cphi1 + this.phi1 - phi;
    if (Math.abs(rh) > $bffedda91368999e$var$EPS10) {
        p.x = rh * Math.sin(E = lam * Math.cos(phi) / rh);
        p.y = this.cphi1 - rh * Math.cos(E);
    } else p.x = p.y = 0;
    p.x = this.a * p.x + (this.x0 || 0);
    p.y = this.a * p.y + (this.y0 || 0);
    return p;
}
function $bffedda91368999e$var$s_inv(p) {
    p.x = (p.x - (this.x0 || 0)) / this.a;
    p.y = (p.y - (this.y0 || 0)) / this.a;
    var lam, phi;
    var rh = (0, $jU5gu.default)(p.x, p.y = this.cphi1 - p.y);
    phi = this.cphi1 + this.phi1 - rh;
    if (Math.abs(phi) > (0, $gyVUi.HALF_PI)) throw new Error();
    if (Math.abs(Math.abs(phi) - (0, $gyVUi.HALF_PI)) <= $bffedda91368999e$var$EPS10) lam = 0;
    else lam = rh * Math.atan2(p.x, p.y) / Math.cos(phi);
    p.x = (0, $a9oRf.default)(lam + (this.long0 || 0));
    p.y = (0, $7bf9815baea17aa9$export$2e2bcd8739ae039)(phi);
    return p;
}
var $bffedda91368999e$export$e4b2ac9215619f8d = [
    "bonne",
    "Bonne (Werner lat_1=90)"
];
var $bffedda91368999e$export$2e2bcd8739ae039 = {
    init: $bffedda91368999e$export$2cd8252107eb640b,
    names: $bffedda91368999e$export$e4b2ac9215619f8d
};


function $de14c0a63cfa0e0d$export$2e2bcd8739ae039(proj4) {
    proj4.Proj.projections.add((0, $9t3dO.default));
    proj4.Proj.projections.add((0, $9zr9G.default));
    proj4.Proj.projections.add((0, $efe46ba059d82de2$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $4279f8b9d31284e6$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $llHto.default));
    proj4.Proj.projections.add((0, $31a8278a941356d4$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $a6cb33582cb5910b$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $d753eaf12887a276$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $c765c705b741a192$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $00f791059e8f61f5$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $deudM.default));
    proj4.Proj.projections.add((0, $8mhgZ.default));
    proj4.Proj.projections.add((0, $dbf05e97c9232a2a$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $4d31684dfe594c29$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $936a7dd52884a3fc$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $20353e9e716518d0$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $6Eu1X.default));
    proj4.Proj.projections.add((0, $b37863f65bf2a2a4$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $a9d7febe7a8566f2$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $57490138fba0a0b8$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $cab513e7d920927e$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $168e5f6524a6fc5f$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $d2d34f4dbda3af26$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $24629f153ebf2c1f$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $228cab2632c5bcf7$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $86b26d30d3579075$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $07c2abe70612fbc5$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $ab98c67e9f567a4b$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $e5c7855edcbcda04$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $8df30f7b6f96e4d8$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $bffedda91368999e$export$2e2bcd8739ae039));
}


(0, $471507637a3ff861$export$2e2bcd8739ae039).defaultDatum = 'WGS84'; //default datum
(0, $471507637a3ff861$export$2e2bcd8739ae039).Proj = (0, $24869d6338533b3b$export$2e2bcd8739ae039);
(0, $471507637a3ff861$export$2e2bcd8739ae039).WGS84 = new (0, $471507637a3ff861$export$2e2bcd8739ae039).Proj('WGS84');
(0, $471507637a3ff861$export$2e2bcd8739ae039).Point = (0, $d8ec3fc1ff061c76$export$2e2bcd8739ae039);
(0, $471507637a3ff861$export$2e2bcd8739ae039).toPoint = (0, $01093474ae9bd8f6$export$2e2bcd8739ae039);
(0, $471507637a3ff861$export$2e2bcd8739ae039).defs = (0, $a9b3183caccb3297$export$2e2bcd8739ae039);
(0, $471507637a3ff861$export$2e2bcd8739ae039).nadgrid = (0, $b2d482da445fbb18$export$2e2bcd8739ae039);
(0, $471507637a3ff861$export$2e2bcd8739ae039).transform = (0, $8e8cfb7cbefc2113$export$2e2bcd8739ae039);
(0, $471507637a3ff861$export$2e2bcd8739ae039).mgrs = (0, $31ee54b8e1d1cd8f$export$2e2bcd8739ae039);
(0, $471507637a3ff861$export$2e2bcd8739ae039).version = '__VERSION__';
(0, $de14c0a63cfa0e0d$export$2e2bcd8739ae039)((0, $471507637a3ff861$export$2e2bcd8739ae039));
var $a52c207aab93bf4f$export$2e2bcd8739ae039 = (0, $471507637a3ff861$export$2e2bcd8739ae039);


/**
 * @module ol/proj/proj4
 */ 



/**
 * @type {import("proj4")|null}
 */ let $2f5e3cce9f26ffcd$var$registered = null;
function $2f5e3cce9f26ffcd$export$bd9a8eae248cc953() {
    return !!$2f5e3cce9f26ffcd$var$registered;
}
function $2f5e3cce9f26ffcd$export$d07f55d4c15c0440() {
    $2f5e3cce9f26ffcd$var$registered = null;
}
function $2f5e3cce9f26ffcd$export$6503ec6e8aabbaf(proj4) {
    $2f5e3cce9f26ffcd$var$registered = proj4;
    const projCodes = Object.keys(proj4.defs);
    const len = projCodes.length;
    let i, j;
    for(i = 0; i < len; ++i){
        const code = projCodes[i];
        if (!(0, $f5ec5c943d804ecb$export$3988ae62b71be9a3)(code)) {
            const def = proj4.defs(code);
            let units = /** @type {import("./Units.js").Units} */ def.units;
            if (!units && def.projName === 'longlat') units = 'degrees';
            (0, $9c4744460e43e41b$export$59ae956cd3e343f7)(new (0, $6dc418afeec7068a$export$2e2bcd8739ae039)({
                code: code,
                axisOrientation: def.axis,
                metersPerUnit: def.to_meter,
                units: units
            }));
        }
    }
    for(i = 0; i < len; ++i){
        const code1 = projCodes[i];
        const proj1 = (0, $f5ec5c943d804ecb$export$3988ae62b71be9a3)(code1);
        for(j = 0; j < len; ++j){
            const code2 = projCodes[j];
            const proj2 = (0, $f5ec5c943d804ecb$export$3988ae62b71be9a3)(code2);
            if (!(0, $11b5dd198626e1de$export$3988ae62b71be9a3)(code1, code2)) {
                if (proj4.defs[code1] === proj4.defs[code2]) (0, $9c4744460e43e41b$export$eeb8392580a05a37)([
                    proj1,
                    proj2
                ]);
                else {
                    const transform = proj4(code1, code2);
                    (0, $9c4744460e43e41b$export$6b1c2e6623f4f49d)(proj1, proj2, (0, $9c4744460e43e41b$export$1873f9cfeb8bd1d6)(proj1, proj2, transform.forward), (0, $9c4744460e43e41b$export$1873f9cfeb8bd1d6)(proj2, proj1, transform.inverse));
                }
            }
        }
    }
}
/**
 * @param {number} code The EPSG code.
 * @return {Promise<string>} The proj4 definition.
 */ let $2f5e3cce9f26ffcd$var$epsgLookup = async function(code) {
    const response = await fetch(`https://epsg.io/${code}.proj4`);
    if (!response.ok) throw new Error(`Unexpected response from epsg.io: ${response.status}`);
    return response.text();
};
function $2f5e3cce9f26ffcd$export$a2ab1dacaf978878(func) {
    $2f5e3cce9f26ffcd$var$epsgLookup = func;
}
function $2f5e3cce9f26ffcd$export$740126bd4cc01b24() {
    return $2f5e3cce9f26ffcd$var$epsgLookup;
}
async function $2f5e3cce9f26ffcd$export$8d835cefe312e037(code) {
    if (typeof code === 'string') code = parseInt(code.split(':').pop(), 10);
    const proj4 = $2f5e3cce9f26ffcd$var$registered;
    if (!proj4) throw new Error('Proj4 must be registered first with register(proj4)');
    const epsgCode = 'EPSG:' + code;
    if (proj4.defs(epsgCode)) return (0, $f5ec5c943d804ecb$export$3988ae62b71be9a3)(epsgCode);
    proj4.defs(epsgCode, await $2f5e3cce9f26ffcd$var$epsgLookup(code));
    $2f5e3cce9f26ffcd$export$6503ec6e8aabbaf(proj4);
    return (0, $f5ec5c943d804ecb$export$3988ae62b71be9a3)(epsgCode);
}
function $2f5e3cce9f26ffcd$export$71e713433eeb8730(key) {
    return async function(code) {
        const response = await fetch(`https://api.maptiler.com/coordinates/search/code:${code}.json?transformations=true&exports=true&key=${key}`);
        if (!response.ok) throw new Error(`Unexpected response from maptiler.com: ${response.status}`);
        return response.json().then((json)=>{
            const results = json['results'];
            if (results?.length > 0) {
                const result = results.filter((r)=>r['id']?.['authority'] === 'EPSG' && r['id']?.['code'] === code)[0];
                if (result) {
                    const transforms = result['transformations'];
                    if (transforms?.length > 0) {
                        // use default transform if it does not require grids
                        const defaultTransform = result['default_transformation'];
                        if (transforms.filter((t)=>t['id']?.['authority'] === defaultTransform?.['authority'] && t['id']?.['code'] === defaultTransform?.['code'] && t['grids']?.length === 0).length > 0) return result['exports']?.['proj4'];
                        // otherwise use most accurate alternative without grids
                        const transform = transforms.filter((t)=>t['grids']?.length === 0 && t['target_crs']?.['authority'] === 'EPSG' && t['target_crs']?.['code'] === 4326 && t['deprecated'] === false && t['usable'] === true).sort((t1, t2)=>t1['accuracy'] - t2['accuracy'])[0]?.['exports']?.['proj4'];
                        if (transform) return transform;
                    }
                    // fallback to default
                    return result['exports']?.['proj4'];
                }
            }
        });
    };
}




const $3d63321abab47ecf$var$FILENAME = 'projection-manager.js';
/**
 * About:
 * ProjectionManager
 * 
 * Description:
 * Manages all EPSG projections.
 */ class $3d63321abab47ecf$export$38112acb54e12e1 extends (0, $8a2666592e7029ee$export$84777416d052f822) {
    // Note: 
    // More projections can be fetched from here: https://epsg.io/
    static #projections = [
        {
            isActive: true,
            code: 'EPSG:3857',
            name: 'WGS 84 / Pseudo-Mercator',
            proj4def: '+proj=merc +a=6378137 +b=6378137 +lat_ts=0 +lon_0=0 +x_0=0 +y_0=0 +k=1 +units=m +nadgrids=@null +wktext +no_defs +type=crs'
        },
        {
            isActive: true,
            code: 'EPSG:4326',
            name: 'WGS 84',
            proj4def: '+proj=longlat +datum=WGS84 +no_defs +type=crs'
        },
        {
            isActive: true,
            code: 'EPSG:7789',
            name: 'ITRF2014',
            proj4def: '+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs'
        },
        {
            isActive: true,
            code: 'EPSG:3006',
            name: 'SWEREF99 TM',
            proj4def: '+proj=utm +zone=33 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs +type=crs'
        },
        {
            isActive: true,
            code: 'EPSG:3021',
            name: 'RT90 2.5 gon V',
            proj4def: '+proj=tmerc +lat_0=0 +lon_0=15.8082777777778 +k=1 +x_0=1500000 +y_0=0 +ellps=bessel +towgs84=414.1,41.3,603.1,0.855,-2.141,7.023,0 +units=m +no_defs +type=crs'
        }
    ];
    //--------------------------------------------------------------------
    // # Section: Base Overrides
    //--------------------------------------------------------------------
    static async initAsync(options = {}) {
        (0, $b9b5c0363f244088$export$49b118289be48034).logDebug($3d63321abab47ecf$var$FILENAME, 'initAsync', 'Adding default projections');
        const projectionsToAdd = [];
        this.#projections.forEach((projection)=>{
            if (!projection.isActive) {
                (0, $b9b5c0363f244088$export$49b118289be48034).logDebug($3d63321abab47ecf$var$FILENAME, 'initAsync', `Skipping projection (${projection.code} ${projection.name})`);
                return;
            }
            (0, $b9b5c0363f244088$export$49b118289be48034).logDebug($3d63321abab47ecf$var$FILENAME, 'initAsync', `Adding projection (${projection.code} ${projection.name})`);
            projectionsToAdd.push([
                projection.code,
                projection.proj4def
            ]);
        });
        this.#registerProjections(projectionsToAdd);
        return new Promise((resolve)=>{
            resolve({
                filename: $3d63321abab47ecf$var$FILENAME,
                result: true
            });
        });
    }
    static setMap(map) {}
    static getName() {
        return $3d63321abab47ecf$var$FILENAME;
    }
    //--------------------------------------------------------------------
    // # Section: Internal
    //--------------------------------------------------------------------
    static #registerProjections(projections) {
        (0, $a52c207aab93bf4f$export$2e2bcd8739ae039).defs(projections);
        (0, $2f5e3cce9f26ffcd$export$6503ec6e8aabbaf)((0, $a52c207aab93bf4f$export$2e2bcd8739ae039));
    }
    static #registerProjection(code, proj4def) {
        (0, $a52c207aab93bf4f$export$2e2bcd8739ae039).defs(code, proj4def);
        (0, $2f5e3cce9f26ffcd$export$6503ec6e8aabbaf)((0, $a52c207aab93bf4f$export$2e2bcd8739ae039));
    }
    //--------------------------------------------------------------------
    // # Section: Public API
    //--------------------------------------------------------------------
    static addProjection(code, name, proj4def, active) {
        this.#projections.push({
            active: active,
            code: code,
            name: name,
            proj4def: proj4def
        });
        this.#registerProjection(code, proj4def);
    }
    static getSize() {
        return this.#projections.length || 0;
    }
    static getProjections() {
        return this.#projections;
    }
    static hasProjection(code) {
        return !!this.#projections.find((projection)=>{
            return projection.code === code?.toUpperCase();
        });
    }
}








const $6600835a70a26b10$var$FILENAME = 'accessibility-manager.js';
const $6600835a70a26b10$var$CLASS__ACCESSIBILITY = 'oltb-using-keyboard';
/**
 * About:
 * AccessibilityManager
 * 
 * Description:
 * Manages toggle of class 'oltb-using-keyboard' on the body element that is used to enable specific
 * styling on elements. Example button focus style.
 */ class $6600835a70a26b10$export$a2c2de1efa8671eb extends (0, $8a2666592e7029ee$export$84777416d052f822) {
    //--------------------------------------------------------------------
    // # Section: Base Overrides
    //--------------------------------------------------------------------
    static async initAsync(options = {}) {
        (0, $b9b5c0363f244088$export$49b118289be48034).logDebug($6600835a70a26b10$var$FILENAME, 'initAsync', 'Initialization started');
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.mouseDown, this.#onMouseDown.bind(this));
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.keyDown, this.#onKeyboardDown.bind(this));
        return new Promise((resolve)=>{
            resolve({
                filename: $6600835a70a26b10$var$FILENAME,
                result: true
            });
        });
    }
    static setMap(map) {}
    static getName() {
        return $6600835a70a26b10$var$FILENAME;
    }
    //--------------------------------------------------------------------
    // # Section: Events
    //--------------------------------------------------------------------
    static #onKeyboardDown(event) {
        if (event.key === (0, $7cb32231c4f9783a$export$70f9e5bc10d7eac).valueTab) this.addAccessibilityClass();
    }
    static #onMouseDown(event) {
        this.removeAccessibilityClass();
    }
    //--------------------------------------------------------------------
    // # Section: Public API
    //--------------------------------------------------------------------
    static addAccessibilityClass() {
        window.document.body.classList.add($6600835a70a26b10$var$CLASS__ACCESSIBILITY);
    }
    static removeAccessibilityClass() {
        window.document.body.classList.remove($6600835a70a26b10$var$CLASS__ACCESSIBILITY);
    }
}



var $f1q41 = parcelRequire("f1q41");






const $10d08d54da4ecbc4$var$FILENAME = 'base-tool.js';
class $10d08d54da4ecbc4$export$cf198134d112da63 extends (0, $b978dafe8f7d27ff$export$2e2bcd8739ae039) {
    #filename = $10d08d54da4ecbc4$var$FILENAME;
    constructor(options = {}){
        super({
            element: options.element ?? (0, $8f42450ebdd44f5e$export$8e7188a60a5bbe16).getToolbarElement()
        });
        if (options.filename) this.#filename = options.filename;
    }
    detachGlobalListeners() {}
    //--------------------------------------------------------------------
    // # Section: Base Methods
    //--------------------------------------------------------------------
    getName() {
        return this.#filename;
    }
    onClickTool(event) {
        (0, $b9b5c0363f244088$export$49b118289be48034).logDebug(this.#filename, 'onClickTool', 'User clicked tool');
    }
}



var $f1q41 = parcelRequire("f1q41");



const $eb687437705d7055$var$DurationNormal = (0, $1e8c0ef90ed82280$export$a33e119b2316dcb7).getConfig().animationDuration.normal;
const $eb687437705d7055$var$DefaultOptions = Object.freeze({
    map: undefined,
    coordinates: [
        0,
        0
    ],
    zoom: undefined,
    rotation: undefined,
    duration: $eb687437705d7055$var$DurationNormal,
    onDone: undefined
});
const $eb687437705d7055$export$cc43ef3ca2ae36e8 = function(options) {
    options = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep($eb687437705d7055$var$DefaultOptions), options);
    if (!options.map) return;
    const view = options.map.getView();
    if (!view) return;
    if (view.getAnimating()) view.cancelAnimations();
    view.animate({
        rotation: options.rotation,
        center: (0, $9c4744460e43e41b$export$b15d9668511529b9)(options.coordinates),
        zoom: options.zoom,
        duration: options.duration,
        easing: (0, $c7ccf7e681a9b333$export$57636bb43b1ccbb0)
    }, function(result) {
        // Note: 
        // @Consumer callback
        if (options.onDone) options.onDone(result);
    });
};



const $a256deadcc62504f$export$4384767a59dc851d = Object.freeze({
    overviewTool: 'A',
    bookmarkTool: 'B',
    coordinatesTool: 'C',
    directionTool: 'D',
    exportPngTool: 'E',
    fullscreenTool: 'F',
    myLocationTool: 'G',
    homeTool: 'H',
    infoTool: 'I',
    graticuleTool: 'J',
    scaleLineTool: 'K',
    layerTool: 'L',
    measureTool: 'M',
    resetNorthTool: 'N',
    importVectorLayerTool: 'O',
    drawTool: 'P',
    zoomInTool: 'Q',
    refreshPageTool: 'R',
    splitViewTool: 'S',
    themeTool: 'T',
    zoomboxTool: 'U',
    editTool: 'V',
    zoomOutTool: 'W',
    scissorsTool: 'X',
    toolboxTool: 'Y',
    magnifyTool: 'Z',
    helpTool: '1',
    settingsTool: '2',
    translationTool: '3',
    debugInfoTool: '4'
});




var $f1q41 = parcelRequire("f1q41");











const $062067ac9882af21$var$FILENAME = 'context-menu-tool.js';
const $062067ac9882af21$var$CLASS__CONTEXT_MENU = 'oltb-context-menu';
const $062067ac9882af21$var$DefaultOptions = Object.freeze({
    name: 'MainContextMenu'
});
class $062067ac9882af21$export$b6aef0d24cd6ce8c extends (0, $10d08d54da4ecbc4$export$cf198134d112da63) {
    static #isDebug = false;
    static #queue = [];
    #items = [];
    static addItem(item) {
        this.#queue.push(item);
    }
    constructor(options = {}){
        super({
            filename: $062067ac9882af21$var$FILENAME,
            element: (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
                element: 'ul',
                class: $062067ac9882af21$var$CLASS__CONTEXT_MENU,
                attributes: {
                    'tabindex': '-1'
                },
                listeners: {
                    'keydown': (0, $2c00c14ef3ff796f$export$bec45a54c2e66c22)
                }
            })
        });
        this.options = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep($062067ac9882af21$var$DefaultOptions), options);
        this.menu = this.element;
        const debugKey = (0, $1e8c0ef90ed82280$export$a33e119b2316dcb7).getConfig().urlParameter.debug;
        $062067ac9882af21$export$b6aef0d24cd6ce8c.#isDebug = (0, $af35fd2ff1608131$export$fb10f6d9eb34a490).getParameter(debugKey) === 'true';
        $062067ac9882af21$export$b6aef0d24cd6ce8c.#queue.forEach((item)=>{
            this.addMenuItem(item);
        });
        const uiRefMapElement = (0, $8f42450ebdd44f5e$export$8e7188a60a5bbe16).getMapElement();
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(uiRefMapElement, [
            this.menu
        ]);
        uiRefMapElement.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.contextMenu, this.#onContextMenu.bind(this));
        uiRefMapElement.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.click, this.#onMapClick.bind(this));
        uiRefMapElement.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.keyUp, this.#onMapKeyUp.bind(this));
        this.uiRefMapElement = uiRefMapElement;
    }
    //--------------------------------------------------------------------
    // # Section: Overridden
    //--------------------------------------------------------------------
    getName() {
        return super.getName();
    }
    //--------------------------------------------------------------------
    // # Section: Internal
    //--------------------------------------------------------------------
    #getMenuCoordinatesInBounds(x, y) {
        const rem = 16;
        const pivotValue = 0;
        const mapElement = (0, $8f42450ebdd44f5e$export$8e7188a60a5bbe16).getMapElement();
        const mapHeight = mapElement.offsetHeight;
        const menuElement = this.menu;
        const menuHeight = menuElement.offsetHeight;
        const distanceAvailable = mapHeight - y;
        const distanceOutBounds = menuHeight - distanceAvailable;
        const dY = y - distanceOutBounds - rem;
        const isMenuInBounds = distanceOutBounds < pivotValue;
        const menuX = x;
        const menuY = isMenuInBounds ? y : dY;
        (0, $b9b5c0363f244088$export$49b118289be48034).logDebug($062067ac9882af21$var$FILENAME, 'getMenuCoordinatesInView', {
            mapHeight: mapHeight,
            menuHeight: menuHeight,
            distanceAvailable: distanceAvailable,
            distanceOutBounds: distanceOutBounds,
            isMenuInBounds: isMenuInBounds,
            originalX: x,
            originalY: y,
            menuX: menuX,
            menuY: menuY,
            dY: dY
        });
        return {
            x: menuX,
            y: menuY
        };
    }
    #isMenuItem(item) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).has(item, [
            'i18nKey'
        ]);
    }
    //--------------------------------------------------------------------
    // # Section: Events
    //--------------------------------------------------------------------
    #onContextMenu(event) {
        this.show(event);
    }
    #onMapClick(event) {
        this.hide(event);
    }
    #onMapKeyUp(event) {
        const key = event.key;
        if (key === (0, $7cb32231c4f9783a$export$70f9e5bc10d7eac).valueEscape) this.hide();
    }
    //--------------------------------------------------------------------
    // # Section: Public API
    //--------------------------------------------------------------------
    getSize() {
        return this.#items.length || 0;
    }
    addMenuSeparator() {
        const li = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'li',
            class: `${$062067ac9882af21$var$CLASS__CONTEXT_MENU}__divider`
        });
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(this.menu, [
            li
        ]);
        return li;
    }
    addMenuItem(item) {
        if (!this.#isMenuItem(item)) return this.addMenuSeparator();
        this.#items.push(item);
        const i18n = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get(item.i18nKey);
        const li = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'li',
            class: `${$062067ac9882af21$var$CLASS__CONTEXT_MENU}__item`,
            attributes: {
                'tabindex': '0'
            },
            listeners: {
                'click': this.click.bind(this, item),
                'keyup': (event)=>{
                    const key = event.key;
                    if (key === (0, $7cb32231c4f9783a$export$70f9e5bc10d7eac).valueEnter) this.click(item);
                }
            }
        });
        const icon = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'span',
            html: item.icon,
            class: `${$062067ac9882af21$var$CLASS__CONTEXT_MENU}__icon`
        });
        const text = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'span',
            text: i18n,
            class: `${$062067ac9882af21$var$CLASS__CONTEXT_MENU}__text`,
            attributes: {
                'data-oltb-i18n': item.i18nKey
            }
        });
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(li, [
            icon,
            text
        ]);
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(this.menu, [
            li
        ]);
        return li;
    }
    show(event) {
        // Note: 
        // Disable native context menu
        if (!$062067ac9882af21$export$b6aef0d24cd6ce8c.#isDebug) event.preventDefault();
        const map = this.getMap();
        if (!map) return;
        const projection = (0, $1e8c0ef90ed82280$export$a33e119b2316dcb7).getConfig().projection;
        this.coordinates = (0, $9c4744460e43e41b$export$51186ad6e864892a)(map.getEventCoordinate(event), projection.default, projection.wgs84);
        // Note:
        // The class must added first 
        // otherwise the offsetHeight or the getComputedStyle can't be extracted
        this.menu.classList.add(`${$062067ac9882af21$var$CLASS__CONTEXT_MENU}--show`);
        // Note:
        // If the user clicks at a location in the map where the height of the menu
        // will exceed the of the height of the parent (the map) 
        // Calculate the overflow value to move the menu negative dY pixels towards the top
        const menuCoordinates = this.#getMenuCoordinatesInBounds(event.clientX, event.clientY);
        this.menu.style.left = `${menuCoordinates.x}px`;
        this.menu.style.top = `${menuCoordinates.y}px`;
        this.menu.focus();
    }
    hide() {
        this.menu.classList.remove(`${$062067ac9882af21$var$CLASS__CONTEXT_MENU}--show`);
    }
    click(item) {
        item.fn(this.getMap(), this.coordinates, this.target);
        this.hide();
    }
}




const $fbd95439548fdf50$export$ad7bf7af8762113 = function(event, key) {
    return window.document.activeElement.nodeName !== 'TEXTAREA' && window.document.activeElement.nodeName !== 'INPUT' && !event.ctrlKey && !event.shiftKey && !event.altKey && !event.metaKey && event.key.toUpperCase() !== (0, $7cb32231c4f9783a$export$70f9e5bc10d7eac).valueOperatingSystem && event.key.toUpperCase() === key;
};




const $d8c7e32a69d15871$var$FILENAME = 'home-tool.js';
const $d8c7e32a69d15871$var$CLASS__TOOL_BUTTON = 'oltb-tool-button';
const $d8c7e32a69d15871$var$I18N__BASE = 'tools.homeTool';
const $d8c7e32a69d15871$var$DefaultLocation = (0, $1e8c0ef90ed82280$export$a33e119b2316dcb7).getConfig().location.default;
const $d8c7e32a69d15871$var$DefaultOptions = Object.freeze({
    lon: $d8c7e32a69d15871$var$DefaultLocation.lon,
    lat: $d8c7e32a69d15871$var$DefaultLocation.lat,
    zoom: $d8c7e32a69d15871$var$DefaultLocation.zoom,
    rotation: $d8c7e32a69d15871$var$DefaultLocation.rotation,
    onInitiated: undefined,
    onClicked: undefined,
    onBrowserStateCleared: undefined,
    onNavigatedHome: undefined
});
const $d8c7e32a69d15871$var$LocalStorageNodeName = (0, $52e25f2a10ab5b5c$export$ada36e8a1c3bc83a).homeTool;
const $d8c7e32a69d15871$var$LocalStorageDefaults = Object.freeze({
    lon: $d8c7e32a69d15871$var$DefaultLocation.lon,
    lat: $d8c7e32a69d15871$var$DefaultLocation.lat,
    zoom: $d8c7e32a69d15871$var$DefaultLocation.zoom,
    rotation: $d8c7e32a69d15871$var$DefaultLocation.rotation
});
/**
 * About:
 * Navigate to your home location
 * 
 * Description:
 * Your home position is a fixed point that you can have as a base to start from. 
 * It can be set through the constructor and changed by the user.
 */ class $d8c7e32a69d15871$export$6e06cb1e6abfcb87 extends (0, $10d08d54da4ecbc4$export$cf198134d112da63) {
    constructor(options = {}){
        super({
            filename: $d8c7e32a69d15871$var$FILENAME
        });
        this.icon = (0, $dcff5ab966a6537f$export$a297fe855adfd36c)({
            path: (0, $35649bc6579784f8$export$3fddabec91763a6e).house.stroked,
            class: `${$d8c7e32a69d15871$var$CLASS__TOOL_BUTTON}__icon`
        });
        const i18n = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get($d8c7e32a69d15871$var$I18N__BASE);
        const button = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'button',
            html: this.icon,
            class: $d8c7e32a69d15871$var$CLASS__TOOL_BUTTON,
            attributes: {
                'type': 'button',
                'data-tippy-content': `${i18n.title} (${(0, $a256deadcc62504f$export$4384767a59dc851d).homeTool})`,
                'data-tippy-content-post': `(${(0, $a256deadcc62504f$export$4384767a59dc851d).homeTool})`,
                'data-oltb-i18n': `${$d8c7e32a69d15871$var$I18N__BASE}.title`
            },
            listeners: {
                'click': this.onClickTool.bind(this)
            }
        });
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(this.element, [
            button
        ]);
        this.button = button;
        this.options = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep($d8c7e32a69d15871$var$DefaultOptions), options);
        this.localStorage = (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).getAndMergeStateObject($d8c7e32a69d15871$var$LocalStorageNodeName, $d8c7e32a69d15871$var$LocalStorageDefaults);
        this.#initContextMenuItems();
        this.attachGlobalListeners();
        // Note: 
        // @Consumer callback
        if (this.options.onInitiated) this.options.onInitiated();
    }
    attachGlobalListeners() {
        this.onWindowKeyUpBind = this.#onWindowKeyUp.bind(this);
        this.onWindowBrowserStateClearedBind = this.#onWindowBrowserStateCleared.bind(this);
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.keyUp, this.onWindowKeyUpBind);
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.ready, this.onOLTBReadyBind);
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.browserStateCleared, this.onWindowBrowserStateClearedBind);
    }
    detachGlobalListeners() {
        window.removeEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.keyUp, this.onWindowKeyUpBind);
        window.removeEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.browserStateCleared, this.onWindowBrowserStateClearedBind);
    }
    //--------------------------------------------------------------------
    // # Section: Overridden
    //--------------------------------------------------------------------
    getName() {
        return super.getName();
    }
    onClickTool(event) {
        super.onClickTool(event);
        this.momentaryActivation();
        // Note: 
        // @Consumer callback
        if (this.options.onClicked) this.options.onClicked();
    }
    //--------------------------------------------------------------------
    // # Section: Init Helpers
    //--------------------------------------------------------------------
    #initContextMenuItems() {
        (0, $062067ac9882af21$export$b6aef0d24cd6ce8c).addItem({
            icon: this.icon,
            i18nKey: `${$d8c7e32a69d15871$var$I18N__BASE}.contextItems.setHome`,
            fn: this.#onContextMenuSetHomeLocation.bind(this)
        });
    }
    //--------------------------------------------------------------------
    // # Section: Tool Control
    //--------------------------------------------------------------------
    momentaryActivation() {
        this.doNavigateHome();
    }
    //--------------------------------------------------------------------
    // # Section: Browser Events
    //--------------------------------------------------------------------
    #onWindowKeyUp(event) {
        if ((0, $fbd95439548fdf50$export$ad7bf7af8762113)(event, (0, $a256deadcc62504f$export$4384767a59dc851d).homeTool)) this.onClickTool(event);
    }
    #onWindowBrowserStateCleared() {
        this.doClearState();
        this.doNavigateHome();
        // Note: 
        // @Consumer callback
        if (this.options.onBrowserStateCleared) this.options.onBrowserStateCleared();
    }
    //--------------------------------------------------------------------
    // # Section: Map/UI Callbacks
    //--------------------------------------------------------------------
    #onContextMenuSetHomeLocation(map, coordinates, target) {
        this.doCreateNewHome(coordinates);
    }
    //--------------------------------------------------------------------
    // # Section: Getters and Setters
    //--------------------------------------------------------------------
    getZoom() {
        if (this.localStorage.zoom !== this.options.zoom) return this.localStorage.zoom;
        return this.options.zoom;
    }
    getRotation() {
        if (this.localStorage.rotation !== this.options.rotation) return this.localStorage.rotation;
        return this.options.rotation;
    }
    getLocation() {
        if (this.localStorage.lon !== this.options.lon || this.localStorage.lat !== this.options.lat) return [
            this.localStorage.lon,
            this.localStorage.lat
        ];
        return [
            this.options.lon,
            this.options.lat
        ];
    }
    //--------------------------------------------------------------------
    // # Section: Tool DoActions
    //--------------------------------------------------------------------
    doClearState() {
        this.localStorage = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep($d8c7e32a69d15871$var$LocalStorageDefaults);
        (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).setStateObject($d8c7e32a69d15871$var$LocalStorageNodeName, $d8c7e32a69d15871$var$LocalStorageDefaults);
    }
    doCreateNewHome(coordinates) {
        const map = this.getMap();
        if (!map) return;
        const view = map.getView();
        const zoom = view.getZoom();
        const rotation = view.getRotation();
        this.localStorage.zoom = zoom;
        this.localStorage.rotation = rotation;
        this.localStorage.lon = coordinates[0];
        this.localStorage.lat = coordinates[1];
        (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).setStateObject($d8c7e32a69d15871$var$LocalStorageNodeName, this.localStorage);
        (0, $9051f0e072bf4341$export$8d8dc7d5f743331b).success({
            i18nKey: `${$d8c7e32a69d15871$var$I18N__BASE}.toasts.infos.setHomeLocation`,
            autoremove: true
        });
    }
    doNavigateHome() {
        const map = this.getMap();
        if (!map) return;
        const zoom = this.getZoom();
        const rotation = this.getRotation();
        const location = this.getLocation();
        (0, $eb687437705d7055$export$cc43ef3ca2ae36e8)({
            map: map,
            coordinates: location,
            zoom: zoom,
            rotation: rotation,
            onDone: (result)=>{
                // Note: 
                // @Consumer callback
                if (this.options.onNavigatedHome) this.options.onNavigatedHome(result);
            }
        });
    }
}



var $f1q41 = parcelRequire("f1q41");

























const $2db50dd924175022$export$38c8292316e98279 = function(type, geometry) {
    return type !== (0, $60b20182c25e327b$export$2906e7f4b228efe9).type.iconMarker && type !== (0, $60b20182c25e327b$export$2906e7f4b228efe9).type.windBarb && type !== (0, $60b20182c25e327b$export$2906e7f4b228efe9).type.measurement && type !== (0, $60b20182c25e327b$export$2906e7f4b228efe9).type.layer && geometry.getType() !== (0, $9977d850e6d2e896$export$8f4397a63c3cef66).LineString && geometry.getType() !== (0, $9977d850e6d2e896$export$8f4397a63c3cef66).Point;
};




const $4612de54ed55adf8$var$FILENAME = 'draw-tool.js';
const $4612de54ed55adf8$var$CLASS__TOOL_BUTTON = 'oltb-tool-button';
const $4612de54ed55adf8$var$CLASS__TOOLBOX_SECTION = 'oltb-toolbox-section';
const $4612de54ed55adf8$var$CLASS__TOGGLEABLE = 'oltb-toggleable';
const $4612de54ed55adf8$var$ID__PREFIX = 'oltb-draw';
const $4612de54ed55adf8$var$I18N__BASE = 'tools.drawTool';
const $4612de54ed55adf8$var$I18N__BASE_COMMON = 'commons';
const $4612de54ed55adf8$var$DefaultOptions = Object.freeze({
    circleSize: 5,
    onInitiated: undefined,
    onClicked: undefined,
    onBrowserStateCleared: undefined,
    onStart: undefined,
    onEnd: undefined,
    onAbort: undefined,
    onError: undefined,
    onIntersected: undefined,
    onSnapped: undefined,
    onUnSnapped: undefined
});
const $4612de54ed55adf8$var$LocalStorageNodeName = (0, $52e25f2a10ab5b5c$export$ada36e8a1c3bc83a).drawTool;
const $4612de54ed55adf8$var$LocalStorageDefaults = Object.freeze({
    isActive: false,
    isCollapsed: false,
    toolType: (0, $9977d850e6d2e896$export$8f4397a63c3cef66).Polygon,
    strokeWidth: '2.5',
    strokeColor: '#0166A5FF',
    fillColor: '#D7E3FA80'
});
/**
 * About:
 * Draw objects on the Map
 * 
 * Description:
 * Draw Circles, Squares, Rectangles, Lines, Points and Polygons. Ability to draw with different styles and colors.
 */ class $4612de54ed55adf8$export$ccea04be742b1ba4 extends (0, $10d08d54da4ecbc4$export$cf198134d112da63) {
    constructor(options = {}){
        super({
            filename: $4612de54ed55adf8$var$FILENAME
        });
        const icon = (0, $dcff5ab966a6537f$export$a297fe855adfd36c)({
            path: (0, $35649bc6579784f8$export$3fddabec91763a6e).vectorPen.mixed,
            class: `${$4612de54ed55adf8$var$CLASS__TOOL_BUTTON}__icon`
        });
        const i18n = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get($4612de54ed55adf8$var$I18N__BASE);
        const button = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'button',
            html: icon,
            class: $4612de54ed55adf8$var$CLASS__TOOL_BUTTON,
            attributes: {
                'type': 'button',
                'data-tippy-content': `${i18n.title} (${(0, $a256deadcc62504f$export$4384767a59dc851d).drawTool})`,
                'data-tippy-content-post': `(${(0, $a256deadcc62504f$export$4384767a59dc851d).drawTool})`,
                'data-oltb-i18n': `${$4612de54ed55adf8$var$I18N__BASE}.title`
            },
            listeners: {
                'click': this.onClickTool.bind(this)
            }
        });
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(this.element, [
            button
        ]);
        this.button = button;
        this.isActive = false;
        this.intersectedFeatures = [];
        this.options = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep($4612de54ed55adf8$var$DefaultOptions), options);
        this.localStorage = (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).getAndMergeStateObject($4612de54ed55adf8$var$LocalStorageNodeName, $4612de54ed55adf8$var$LocalStorageDefaults);
        this.#initToolboxHTML();
        this.uiRefToolboxSection = window.document.querySelector(`#${$4612de54ed55adf8$var$ID__PREFIX}-toolbox`);
        this.#initToggleables();
        this.uiRefToolType = this.uiRefToolboxSection.querySelector(`#${$4612de54ed55adf8$var$ID__PREFIX}-type`);
        this.uiRefToolType.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.change, this.updateTool.bind(this));
        this.uiRefIntersectionEnable = this.uiRefToolboxSection.querySelector(`#${$4612de54ed55adf8$var$ID__PREFIX}-intersection-enable`);
        this.uiRefIntersectionEnable.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.change, this.updateTool.bind(this));
        this.uiRefFillColor = this.uiRefToolboxSection.querySelector(`#${$4612de54ed55adf8$var$ID__PREFIX}-fill-color`);
        this.uiRefFillColor.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.colorChange, this.updateTool.bind(this));
        this.uiRefStrokeWidth = this.uiRefToolboxSection.querySelector(`#${$4612de54ed55adf8$var$ID__PREFIX}-stroke-width`);
        this.uiRefStrokeWidth.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.change, this.updateTool.bind(this));
        this.uiRefStrokeColor = this.uiRefToolboxSection.querySelector(`#${$4612de54ed55adf8$var$ID__PREFIX}-stroke-color`);
        this.uiRefStrokeColor.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.colorChange, this.updateTool.bind(this));
        this.#initDefaultValues();
        this.attachGlobalListeners();
        // Note: 
        // @Consumer callback
        if (this.options.onInitiated) this.options.onInitiated();
    }
    attachGlobalListeners() {
        this.onWindowKeyUpBind = this.#onWindowKeyUp.bind(this);
        this.onOLTBReadyBind = this.#onOLTBReady.bind(this);
        this.onWindowBrowserStateClearedBind = this.#onWindowBrowserStateCleared.bind(this);
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.keyUp, this.onWindowKeyUpBind);
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.ready, this.onOLTBReadyBind);
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.browserStateCleared, this.onWindowBrowserStateClearedBind);
    }
    detachGlobalListeners() {
        window.removeEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.keyUp, this.onWindowKeyUpBind);
        window.removeEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.ready, this.onOLTBReadyBind);
        window.removeEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.browserStateCleared, this.onWindowBrowserStateClearedBind);
    }
    //--------------------------------------------------------------------
    // # Section: Overridden
    //--------------------------------------------------------------------
    getName() {
        return super.getName();
    }
    onClickTool(event) {
        super.onClickTool(event);
        if (this.isActive) this.deactivateTool();
        else this.activateTool();
        // Note: 
        // @Consumer callback
        if (this.options.onClicked) this.options.onClicked();
    }
    //--------------------------------------------------------------------
    // # Section: Init Helpers
    //--------------------------------------------------------------------
    #initToolboxHTML() {
        const i18n = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get(`${$4612de54ed55adf8$var$I18N__BASE}.toolbox`);
        const i18nCommon = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get(`${$4612de54ed55adf8$var$I18N__BASE_COMMON}.titles`);
        const html = `
            <div id="${$4612de54ed55adf8$var$ID__PREFIX}-toolbox" class="${$4612de54ed55adf8$var$CLASS__TOOLBOX_SECTION}">
                <div class="${$4612de54ed55adf8$var$CLASS__TOOLBOX_SECTION}__header oltb-toggleable" data-oltb-toggleable-target="${$4612de54ed55adf8$var$ID__PREFIX}-toolbox-collapsed">
                    <h4 class="${$4612de54ed55adf8$var$CLASS__TOOLBOX_SECTION}__title" data-oltb-i18n="${$4612de54ed55adf8$var$I18N__BASE}.toolbox.titles.draw">${i18n.titles.draw}</h4>
                    <span class="${$4612de54ed55adf8$var$CLASS__TOOLBOX_SECTION}__icon oltb-tippy" data-oltb-i18n="${$4612de54ed55adf8$var$I18N__BASE_COMMON}.titles.toggleSection" title="${i18nCommon.toggleSection}"></span>
                </div>
                <div class="${$4612de54ed55adf8$var$CLASS__TOOLBOX_SECTION}__groups" id="${$4612de54ed55adf8$var$ID__PREFIX}-toolbox-collapsed" style="display: ${this.localStorage.isCollapsed ? 'none' : 'block'}">
                    <div class="${$4612de54ed55adf8$var$CLASS__TOOLBOX_SECTION}__group">
                        <label class="oltb-label" for="${$4612de54ed55adf8$var$ID__PREFIX}-type" data-oltb-i18n="${$4612de54ed55adf8$var$I18N__BASE}.toolbox.groups.shapes.title">${i18n.groups.shapes.title}</label>
                        <select id="${$4612de54ed55adf8$var$ID__PREFIX}-type" class="oltb-select">
                            <option value="Circle" data-oltb-i18n="${$4612de54ed55adf8$var$I18N__BASE}.toolbox.groups.shapes.circle">${i18n.groups.shapes.circle}</option>
                            <option value="Square" data-oltb-i18n="${$4612de54ed55adf8$var$I18N__BASE}.toolbox.groups.shapes.square">${i18n.groups.shapes.square}</option>
                            <option value="Rectangle" data-oltb-i18n="${$4612de54ed55adf8$var$I18N__BASE}.toolbox.groups.shapes.rectangle">${i18n.groups.shapes.rectangle}</option>
                            <option value="LineString" data-oltb-i18n="${$4612de54ed55adf8$var$I18N__BASE}.toolbox.groups.shapes.lineString">${i18n.groups.shapes.lineString}</option>
                            <option value="Point" data-oltb-i18n="${$4612de54ed55adf8$var$I18N__BASE}.toolbox.groups.shapes.point">${i18n.groups.shapes.point}</option>
                            <option value="Polygon" data-oltb-i18n="${$4612de54ed55adf8$var$I18N__BASE}.toolbox.groups.shapes.polygon">${i18n.groups.shapes.polygon}</option>
                        </select>
                    </div>
                    <div class="${$4612de54ed55adf8$var$CLASS__TOOLBOX_SECTION}__group ${$4612de54ed55adf8$var$CLASS__TOOLBOX_SECTION}__group--split-group">
                        <div class="${$4612de54ed55adf8$var$CLASS__TOOLBOX_SECTION}__group-part">
                            <label class="oltb-label" for="${$4612de54ed55adf8$var$ID__PREFIX}-intersection-enable" data-oltb-i18n="${$4612de54ed55adf8$var$I18N__BASE}.toolbox.groups.intersectable.title">${i18n.groups.intersectable.title}</label>
                            <select id="${$4612de54ed55adf8$var$ID__PREFIX}-intersection-enable" class="oltb-select">
                                <option value="false" data-oltb-i18n="${$4612de54ed55adf8$var$I18N__BASE}.toolbox.groups.intersectable.false">${i18n.groups.intersectable.false}</option>
                                <option value="true" data-oltb-i18n="${$4612de54ed55adf8$var$I18N__BASE}.toolbox.groups.intersectable.true">${i18n.groups.intersectable.true}</option>
                            </select>
                        </div>
                        <div class="${$4612de54ed55adf8$var$CLASS__TOOLBOX_SECTION}__group-part">
                            <label class="oltb-label" for="${$4612de54ed55adf8$var$ID__PREFIX}-stroke-width" data-oltb-i18n="${$4612de54ed55adf8$var$I18N__BASE}.toolbox.groups.strokeWidth.title">${i18n.groups.strokeWidth.title}</label>
                            <select id="${$4612de54ed55adf8$var$ID__PREFIX}-stroke-width" class="oltb-select">
                                <option value="1">1</option>
                                <option value="1.25">1.25</option>
                                <option value="1.5">1.5</option>
                                <option value="2">2</option>
                                <option value="2.5">2.5</option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                                <option value="5">5</option>
                                <option value="6">6</option>
                                <option value="7">7</option>
                                <option value="8">8</option>
                                <option value="9">9</option>
                                <option value="10">10</option>
                            </select>
                        </div>
                    </div>
                    <div class="${$4612de54ed55adf8$var$CLASS__TOOLBOX_SECTION}__group ${$4612de54ed55adf8$var$CLASS__TOOLBOX_SECTION}__group--split-group">
                        <div class="${$4612de54ed55adf8$var$CLASS__TOOLBOX_SECTION}__group-part">
                            <label class="oltb-label" for="${$4612de54ed55adf8$var$ID__PREFIX}-stroke-color" data-oltb-i18n="${$4612de54ed55adf8$var$I18N__BASE}.toolbox.groups.strokeColor.title">${i18n.groups.strokeColor.title}</label>
                            <div id="${$4612de54ed55adf8$var$ID__PREFIX}-stroke-color" class="oltb-color-input oltb-color-tippy" data-oltb-color-target="#${$4612de54ed55adf8$var$ID__PREFIX}-stroke-color" data-oltb-color="${this.localStorage.strokeColor}" tabindex="0">
                                <div class="oltb-color-input__inner" style="background-color: ${this.localStorage.strokeColor};"></div>
                            </div>
                        </div>
                        <div class="${$4612de54ed55adf8$var$CLASS__TOOLBOX_SECTION}__group-part">
                            <label class="oltb-label" for="${$4612de54ed55adf8$var$ID__PREFIX}-fill-color" data-oltb-i18n="${$4612de54ed55adf8$var$I18N__BASE}.toolbox.groups.fillColor.title">${i18n.groups.fillColor.title}</label>
                            <div id="${$4612de54ed55adf8$var$ID__PREFIX}-fill-color" class="oltb-color-input oltb-color-tippy" data-oltb-color-target="#${$4612de54ed55adf8$var$ID__PREFIX}-fill-color" data-oltb-color="${this.localStorage.fillColor}" tabindex="0">
                                <div class="oltb-color-input__inner" style="background-color: ${this.localStorage.fillColor};"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        `;
        (0, $8f42450ebdd44f5e$export$8e7188a60a5bbe16).getToolboxElement().insertAdjacentHTML('beforeend', html);
    }
    #initToggleables() {
        this.uiRefToolboxSection.querySelectorAll(`.${$4612de54ed55adf8$var$CLASS__TOGGLEABLE}`).forEach((toggle)=>{
            toggle.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.click, this.#onToggleToolbox.bind(this, toggle));
        });
    }
    #initDefaultValues() {
        this.uiRefToolType.value = this.localStorage.toolType;
        this.uiRefStrokeWidth.value = this.localStorage.strokeWidth;
        this.uiRefIntersectionEnable.value = 'false';
    }
    //--------------------------------------------------------------------
    // # Section: Tool Control
    //--------------------------------------------------------------------
    activateTool() {
        this.isActive = true;
        this.uiRefToolboxSection.classList.add(`${$4612de54ed55adf8$var$CLASS__TOOLBOX_SECTION}--show`);
        this.button.classList.add(`${$4612de54ed55adf8$var$CLASS__TOOL_BUTTON}--active`);
        (0, $3110b1ed727d9f35$export$df4a79c26d3b48ff).setActiveTool(this);
        if (this.shouldAlwaysCreateNewLayer()) (0, $e75fe1c51a3d360c$export$eff87c52915dd7fe).addFeatureLayer({
            name: (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get(`${$4612de54ed55adf8$var$I18N__BASE}.layers.defaultName`)
        });
        // Important:
        // Triggers activation of the tool
        (0, $96903e3f16465932$export$cc74486daaaef499).dispatchEvent([
            this.uiRefToolType
        ], (0, $a9807b370eed025c$export$ada873a34909da65).browser.change);
        this.localStorage.isActive = true;
        (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).setStateObject($4612de54ed55adf8$var$LocalStorageNodeName, this.localStorage);
        this.uiRefToolboxSection.scrollIntoView({
            behavior: 'smooth',
            block: 'end',
            inline: 'nearest'
        });
    }
    deactivateTool() {
        const map = this.getMap();
        if (!map) return;
        this.isActive = false;
        this.uiRefToolboxSection.classList.remove(`${$4612de54ed55adf8$var$CLASS__TOOLBOX_SECTION}--show`);
        this.button.classList.remove(`${$4612de54ed55adf8$var$CLASS__TOOL_BUTTON}--active`);
        this.doRemoveDrawInteraction();
        (0, $3110b1ed727d9f35$export$df4a79c26d3b48ff).removeActiveTool();
        (0, $9829e24a28f9d958$export$786f0b7d4117ba87).removeSnap();
        this.localStorage.isActive = false;
        (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).setStateObject($4612de54ed55adf8$var$LocalStorageNodeName, this.localStorage);
    }
    deselectTool() {
        this.deactivateTool();
    }
    updateTool() {
        // Note: 
        // Remember options until next time
        this.localStorage.toolType = this.uiRefToolType.value;
        this.localStorage.strokeWidth = this.uiRefStrokeWidth.value;
        this.localStorage.fillColor = this.uiRefFillColor.getAttribute('data-oltb-color');
        this.localStorage.strokeColor = this.uiRefStrokeColor.getAttribute('data-oltb-color');
        (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).setStateObject($4612de54ed55adf8$var$LocalStorageNodeName, this.localStorage);
        // Note: 
        // IntersectionMode doesn't play well when tool is LineString or Point
        if (this.isIntersectionModeAvailable()) {
            this.uiRefIntersectionEnable.value = 'false';
            this.uiRefIntersectionEnable.disabled = true;
        } else this.uiRefIntersectionEnable.disabled = false;
        this.doUpdateTool(this.uiRefToolType.value, this.uiRefStrokeWidth.value, this.uiRefFillColor.getAttribute('data-oltb-color'), this.uiRefStrokeColor.getAttribute('data-oltb-color'));
    }
    //--------------------------------------------------------------------
    // # Section: Browser Events
    //--------------------------------------------------------------------
    #onOLTBReady(event) {
        if (this.localStorage.isActive) this.activateTool();
    }
    #onWindowKeyUp(event) {
        const key = event.key;
        if (key === (0, $7cb32231c4f9783a$export$70f9e5bc10d7eac).valueEscape) {
            if (this.interactionDraw) this.interactionDraw.abortDrawing();
        } else if (event.ctrlKey && key === (0, $7cb32231c4f9783a$export$70f9e5bc10d7eac).valueZ) {
            if (this.interactionDraw) this.interactionDraw.removeLastPoint();
        } else if ((0, $fbd95439548fdf50$export$ad7bf7af8762113)(event, (0, $a256deadcc62504f$export$4384767a59dc851d).drawTool)) this.onClickTool(event);
    }
    #onWindowBrowserStateCleared() {
        this.doClearState();
        this.doClearColors();
        if (this.isActive) this.deactivateTool();
        // Note: 
        // @Consumer callback
        if (this.options.onBrowserStateCleared) this.options.onBrowserStateCleared();
    }
    //--------------------------------------------------------------------
    // # Section: Map/UI Callbacks
    //--------------------------------------------------------------------
    #onToggleToolbox(toggle) {
        const targetName = toggle.dataset.oltbToggleableTarget;
        this.doToggleToolboxSection(targetName);
    }
    #onDrawStart(event) {
        this.doDrawStart(event);
    }
    #onDrawEnd(event) {
        this.doDrawEnd(event);
    }
    #onDrawAbort(event) {
        this.doDrawAbort(event);
    }
    #onDrawError(event) {
        this.doDrawError(event);
    }
    // Note:
    // This is a global event that is invoked from the SnapManager
    onSnap(event) {
        this.doSnap(event);
    }
    onUnSnap(event) {
        this.doUnSnap(event);
    }
    //--------------------------------------------------------------------
    // # Section: Conversions/Validation
    //--------------------------------------------------------------------
    shouldAlwaysCreateNewLayer() {
        return (0, $5547bbb6fff7ebf1$export$3016a1f47b675883).getSetting((0, $65522956a1f1a049$export$c72f6eaae7b9adff).alwaysNewLayers);
    }
    isIntersectionModeAvailable() {
        return this.uiRefToolType.value === (0, $9977d850e6d2e896$export$8f4397a63c3cef66).LineString || this.uiRefToolType.value === (0, $9977d850e6d2e896$export$8f4397a63c3cef66).Point;
    }
    isIntersectionEnabled() {
        return this.uiRefIntersectionEnable.value.toLowerCase() === 'true';
    }
    //--------------------------------------------------------------------
    // # Section: Generator Helpers
    //--------------------------------------------------------------------
    #generateOLInteractionDraw(type, geometryFunction) {
        return new (0, $55fa2487efb2d4e1$export$2e2bcd8739ae039)({
            type: type,
            style: this.style,
            stopClick: true,
            geometryFunction: geometryFunction
        });
    }
    #generateOLStyleObject(strokeWidth, fillColor, strokeColor) {
        return new (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)({
            image: new (0, $06150d8570b7481b$export$2e2bcd8739ae039)({
                fill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
                    color: fillColor
                }),
                stroke: new (0, $f9d0329c5c745263$export$2e2bcd8739ae039)({
                    color: strokeColor,
                    width: strokeWidth
                }),
                radius: this.options.circleSize
            }),
            fill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
                color: fillColor
            }),
            stroke: new (0, $f9d0329c5c745263$export$2e2bcd8739ae039)({
                color: strokeColor,
                width: strokeWidth
            })
        });
    }
    //--------------------------------------------------------------------
    // # Section: Tool DoActions
    //--------------------------------------------------------------------
    doClearState() {
        this.localStorage = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep($4612de54ed55adf8$var$LocalStorageDefaults);
        (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).setStateObject($4612de54ed55adf8$var$LocalStorageNodeName, $4612de54ed55adf8$var$LocalStorageDefaults);
    }
    doToggleToolboxSection(targetName) {
        const targetNode = window.document.getElementById(targetName);
        const duration = (0, $1e8c0ef90ed82280$export$a33e119b2316dcb7).getConfig().animationDuration.fast;
        targetNode?.slideToggle(duration, (collapsed)=>{
            this.localStorage.isCollapsed = collapsed;
            (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).setStateObject($4612de54ed55adf8$var$LocalStorageNodeName, this.localStorage);
        });
    }
    doDrawStart(event) {
        // Note: 
        // @Consumer callback
        if (this.options.onStart) this.options.onStart(event);
    }
    doDrawEnd(event) {
        const layerWrapper = (0, $e75fe1c51a3d360c$export$eff87c52915dd7fe).getActiveFeatureLayer({
            fallback: (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get(`${$4612de54ed55adf8$var$I18N__BASE}.layers.defaultName`)
        });
        if (this.isIntersectionEnabled()) this.doDrawEndIntersection(event);
        else this.doDrawEndNormal(layerWrapper, event);
    }
    doDrawEndNormal(layerWrapper, event) {
        const feature = event.feature;
        if (feature) {
            feature.setStyle(this.style);
            feature.setProperties({
                oltb: {
                    type: (0, $60b20182c25e327b$export$2906e7f4b228efe9).type.drawing
                }
            });
            (0, $e75fe1c51a3d360c$export$eff87c52915dd7fe).addFeatureToLayer(feature, layerWrapper, `${$4612de54ed55adf8$var$I18N__BASE}.toasts.infos.drawInHiddenLayer`);
        }
        // Note: 
        // @Consumer callback
        if (this.options.onEnd) this.options.onEnd(event);
    }
    doDrawEndIntersection(event) {
        const feature = event.feature;
        const featureGeometry = feature.getGeometry();
        // Note: 
        // Must search all layers thus features from different layers can be targeted
        const oltb = (0, $0a57fad3299da03c$export$ac4f8128ea29c5).toolbar.id;
        const layerWrappers = (0, $e75fe1c51a3d360c$export$eff87c52915dd7fe).getFeatureLayers();
        layerWrappers.forEach((layerWrapper)=>{
            const layer = layerWrapper.getLayer();
            if (!layer.getVisible()) return;
            const source = layer.getSource();
            source.forEachFeatureIntersectingExtent(featureGeometry.getExtent(), (intersectedFeature)=>{
                const type = intersectedFeature.getProperties(oltb)?.type;
                const geometry = intersectedFeature.getGeometry();
                if ((0, $2db50dd924175022$export$38c8292316e98279)(type, geometry)) this.intersectedFeatures.push(intersectedFeature);
            });
        });
        this.intersectedFeatures.forEach((intersected)=>{
            const coordinates = intersected.getGeometry().getCoordinates();
            const geometry = new (0, $40aa8d43bbe572bf$export$2e2bcd8739ae039)(coordinates.slice(0, coordinates.length));
            const linearRing = new (0, $548636579b4087f2$export$2e2bcd8739ae039)(featureGeometry.getCoordinates()[0]);
            geometry.appendLinearRing(linearRing);
            intersected.setGeometry(geometry);
        });
        if (this.intersectedFeatures.length === 0) (0, $9051f0e072bf4341$export$8d8dc7d5f743331b).info({
            i18nKey: `${$4612de54ed55adf8$var$I18N__BASE}.toasts.infos.missingIntersections`,
            autoremove: true
        });
        // Note: 
        // @Consumer callback
        if (this.options.onIntersected) this.options.onIntersected(event, this.intersectedFeatures);
        this.intersectedFeatures = [];
    }
    doDrawAbort(event) {
        // Note: 
        // @Consumer callback
        if (this.options.onAbort) this.options.onAbort(event);
    }
    doDrawError(event) {
        // Note: 
        // @Consumer callback
        if (this.options.onError) this.options.onError(event);
    }
    doSnap(event) {
        // Note: 
        // @Consumer callback
        if (this.options.onSnapped) this.options.onSnapped(event);
    }
    doUnSnap(event) {
        // Note: 
        // @Consumer callback
        if (this.options.onUnSnapped) this.options.onUnSnapped(event);
    }
    doClearColors() {
        this.uiRefFillColor.setAttribute('data-oltb-color', this.localStorage.fillColor);
        this.uiRefFillColor.firstElementChild.style.backgroundColor = this.localStorage.fillColor;
        this.uiRefStrokeColor.setAttribute('data-oltb-color', this.localStorage.strokeColor);
        this.uiRefStrokeColor.firstElementChild.style.backgroundColor = this.localStorage.strokeColor;
    }
    doUpdateTool(toolType, strokeWidth, fillColor, strokeColor) {
        const map = this.getMap();
        if (!map) return;
        // Note: 
        // Remove previous interaction if tool is changed
        if (this.interactionDraw) {
            this.doRemoveDrawInteraction();
            (0, $9829e24a28f9d958$export$786f0b7d4117ba87).removeSnap();
        }
        this.style = this.#generateOLStyleObject(strokeWidth, fillColor, strokeColor);
        const [geometryType, geometryFunction] = (0, $9977d850e6d2e896$export$9efafe6ae419b7d)(toolType);
        this.interactionDraw = this.#generateOLInteractionDraw(geometryType, geometryFunction);
        this.interactionDraw.on((0, $a9807b370eed025c$export$ada873a34909da65).openLayers.drawStart, this.#onDrawStart.bind(this));
        this.interactionDraw.on((0, $a9807b370eed025c$export$ada873a34909da65).openLayers.drawEnd, this.#onDrawEnd.bind(this));
        this.interactionDraw.on((0, $a9807b370eed025c$export$ada873a34909da65).openLayers.drawAbort, this.#onDrawAbort.bind(this));
        this.interactionDraw.on((0, $a9807b370eed025c$export$ada873a34909da65).openLayers.error, this.#onDrawError.bind(this));
        // Note: 
        // The Snap interaction must be added last
        this.doAddDrawInteraction();
        (0, $9829e24a28f9d958$export$786f0b7d4117ba87).addSnap(this);
    }
    doAddDrawInteraction() {
        this.getMap().addInteraction(this.interactionDraw);
    }
    doRemoveDrawInteraction() {
        this.getMap().removeInteraction(this.interactionDraw);
    }
}



var $f1q41 = parcelRequire("f1q41");
var $89c443a2e3946d4f$exports = {};
/**
 * JSTS. See https://github.com/bjornharrtell/jsts
 * https://github.com/bjornharrtell/jsts/blob/master/LICENSE_EDLv1.txt
 * https://github.com/bjornharrtell/jsts/blob/master/LICENSE_EPLv1.txt
 * @license
 */ !function(t, e) {
    e($89c443a2e3946d4f$exports);
}($89c443a2e3946d4f$exports, function(t) {
    "use strict";
    class e {
        static equalsWithTolerance(t, e, s) {
            return Math.abs(t - e) <= s;
        }
    }
    class s extends Error {
        constructor(t){
            super(t), this.name = Object.keys({
                Exception: s
            })[0];
        }
        toString() {
            return this.message;
        }
    }
    class n extends s {
        constructor(t){
            super(t), this.name = Object.keys({
                IllegalArgumentException: n
            })[0];
        }
    }
    class i {
        constructor(t, e){
            this.low = e || 0, this.high = t || 0;
        }
        static toBinaryString(t) {
            let e, s = "";
            for(e = 2147483648; e > 0; e >>>= 1)s += (t.high & e) === e ? "1" : "0";
            for(e = 2147483648; e > 0; e >>>= 1)s += (t.low & e) === e ? "1" : "0";
            return s;
        }
    }
    function r() {}
    function o() {}
    function l() {}
    r.NaN = NaN, r.isNaN = (t)=>Number.isNaN(t), r.isInfinite = (t)=>!Number.isFinite(t), r.MAX_VALUE = Number.MAX_VALUE, r.POSITIVE_INFINITY = Number.POSITIVE_INFINITY, r.NEGATIVE_INFINITY = Number.NEGATIVE_INFINITY, "function" == typeof Float64Array && "function" == typeof Int32Array ? function() {
        const t = 2146435072, e = new Float64Array(1), s = new Int32Array(e.buffer);
        r.doubleToLongBits = function(n) {
            e[0] = n;
            let r = 0 | s[0], o = 0 | s[1];
            return (o & t) === t && 1048575 & o && 0 !== r && (r = 0, o = 2146959360), new i(o, r);
        }, r.longBitsToDouble = function(t) {
            return s[0] = t.low, s[1] = t.high, e[0];
        };
    }() : function() {
        const t = 1023, e = Math.log2, s = Math.floor, n = Math.pow, o = function() {
            for(let t = 53; t > 0; t--){
                const i = n(2, t) - 1;
                if (s(e(i)) + 1 === t) return i;
            }
            return 0;
        }();
        r.doubleToLongBits = function(r) {
            let l, a, c, h, u, g, d, _, p;
            if (r < 0 || 1 / r === Number.NEGATIVE_INFINITY ? (g = -2147483648, r = -r) : g = 0, 0 === r) return p = 0, _ = g, new i(_, p);
            if (r === 1 / 0) return p = 0, _ = 2146435072 | g, new i(_, p);
            if (r != r) return p = 0, _ = 2146959360, new i(_, p);
            if (h = 0, p = 0, l = s(r), l > 1) {
                if (l <= o) h = s(e(l)), h <= 20 ? (p = 0, _ = l << 20 - h & 1048575) : (c = h - 20, a = n(2, c), p = l % a << 32 - c, _ = l / a & 1048575);
                else for(c = l, p = 0; a = c / 2, c = s(a), 0 !== c;)h++, p >>>= 1, p |= (1 & _) << 31, _ >>>= 1, a !== c && (_ |= 524288);
            }
            if (d = h + t, u = 0 === l, l = r - l, h < 52 && 0 !== l) for(c = 0;;){
                if (a = 2 * l, a >= 1 ? (l = a - 1, u ? (d--, u = !1) : (c <<= 1, c |= 1, h++)) : (l = a, u ? 0 == --d && (h++, u = !1) : (c <<= 1, h++)), 20 === h) _ |= c, c = 0;
                else if (52 === h) {
                    p |= c;
                    break;
                }
                if (1 === a) {
                    h < 20 ? _ |= c << 20 - h : h < 52 && (p |= c << 52 - h);
                    break;
                }
            }
            return _ |= d << 20, _ |= g, new i(_, p);
        }, r.longBitsToDouble = function(e) {
            let s, i, r, o;
            const l = e.high, a = e.low, c = l & -2147483648 ? -1 : 1;
            for(r = ((2146435072 & l) >> 20) - t, o = 0, i = 524288, s = 1; s <= 20; s++)l & i && (o += n(2, -s)), i >>>= 1;
            for(i = -2147483648, s = 21; s <= 52; s++)a & i && (o += n(2, -s)), i >>>= 1;
            if (-1023 === r) {
                if (0 === o) return 0 * c;
                r = -1022;
            } else {
                if (1024 === r) return 0 === o ? c / 0 : NaN;
                o += 1;
            }
            return c * o * n(2, r);
        };
    }();
    class a extends s {
        constructor(t){
            super(t), this.name = Object.keys({
                RuntimeException: a
            })[0];
        }
    }
    class c extends a {
        constructor(){
            super(), c.constructor_.apply(this, arguments);
        }
        static constructor_() {
            if (0 === arguments.length) a.constructor_.call(this);
            else if (1 === arguments.length) {
                const t = arguments[0];
                a.constructor_.call(this, t);
            }
        }
    }
    class h {
        static isTrue() {
            if (1 === arguments.length) {
                const t = arguments[0];
                h.isTrue(t, null);
            } else if (2 === arguments.length) {
                const t = arguments[1];
                if (!arguments[0]) throw null === t ? new c : new c(t);
            }
        }
        static shouldNeverReachHere() {
            if (0 === arguments.length) h.shouldNeverReachHere(null);
            else if (1 === arguments.length) {
                const t = arguments[0];
                throw new c("Should never reach here" + (null !== t ? ": " + t : ""));
            }
        }
        static equals() {
            if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                h.equals(t, e, null);
            } else if (3 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = arguments[2];
                if (!e.equals(t)) throw new c("Expected " + t + " but encountered " + e + (null !== s ? ": " + s : ""));
            }
        }
    }
    function u() {}
    function g() {}
    const d = new ArrayBuffer(8), _ = new Float64Array(d), p = new Int32Array(d);
    class m {
        constructor(){
            m.constructor_.apply(this, arguments);
        }
        static constructor_() {
            if (this.x = null, this.y = null, this.z = null, 0 === arguments.length) m.constructor_.call(this, 0, 0);
            else if (1 === arguments.length) {
                const t = arguments[0];
                m.constructor_.call(this, t.x, t.y, t.getZ());
            } else if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                m.constructor_.call(this, t, e, m.NULL_ORDINATE);
            } else if (3 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = arguments[2];
                this.x = t, this.y = e, this.z = s;
            }
        }
        static hashCode(t) {
            return _[0] = t, p[0] ^ p[1];
        }
        equals2D() {
            if (1 === arguments.length) {
                const t = arguments[0];
                return this.x === t.x && this.y === t.y;
            }
            if (2 === arguments.length) {
                const t = arguments[0], s = arguments[1];
                return !!e.equalsWithTolerance(this.x, t.x, s) && !!e.equalsWithTolerance(this.y, t.y, s);
            }
        }
        setM(t) {
            throw new n("Invalid ordinate index: " + m.M);
        }
        equals3D(t) {
            return this.x === t.x && this.y === t.y && (this.getZ() === t.getZ() || r.isNaN(this.getZ()) && r.isNaN(t.getZ()));
        }
        setX(t) {
            this.x = t;
        }
        compareTo(t) {
            const e = t;
            return this.x < e.x ? -1 : this.x > e.x ? 1 : this.y < e.y ? -1 : this.y > e.y ? 1 : 0;
        }
        getX() {
            return this.x;
        }
        copy() {
            return new m(this);
        }
        toString() {
            return "(" + this.x + ", " + this.y + ", " + this.getZ() + ")";
        }
        distance3D(t) {
            const e = this.x - t.x, s = this.y - t.y, n = this.getZ() - t.getZ();
            return Math.sqrt(e * e + s * s + n * n);
        }
        getY() {
            return this.y;
        }
        getM() {
            return r.NaN;
        }
        setOrdinate(t, e) {
            switch(t){
                case m.X:
                    this.x = e;
                    break;
                case m.Y:
                    this.y = e;
                    break;
                case m.Z:
                    this.setZ(e);
                    break;
                default:
                    throw new n("Invalid ordinate index: " + t);
            }
        }
        getZ() {
            return this.z;
        }
        getOrdinate(t) {
            switch(t){
                case m.X:
                    return this.x;
                case m.Y:
                    return this.y;
                case m.Z:
                    return this.getZ();
            }
            throw new n("Invalid ordinate index: " + t);
        }
        equals(t) {
            return t instanceof m && this.equals2D(t);
        }
        equalInZ(t, s) {
            return e.equalsWithTolerance(this.getZ(), t.getZ(), s);
        }
        setZ(t) {
            this.z = t;
        }
        clone() {
            try {
                return null;
            } catch (t) {
                if (t instanceof CloneNotSupportedException) return h.shouldNeverReachHere("this shouldn't happen because this class is Cloneable"), null;
                throw t;
            }
        }
        setY(t) {
            this.y = t;
        }
        distance(t) {
            const e = this.x - t.x, s = this.y - t.y;
            return Math.sqrt(e * e + s * s);
        }
        hashCode() {
            let t = 17;
            return t = 37 * t + m.hashCode(this.x), t = 37 * t + m.hashCode(this.y), t;
        }
        setCoordinate(t) {
            this.x = t.x, this.y = t.y, this.z = t.getZ();
        }
        get interfaces_() {
            return [
                o,
                u,
                l
            ];
        }
    }
    class f {
        constructor(){
            f.constructor_.apply(this, arguments);
        }
        static constructor_() {
            if (this._dimensionsToTest = 2, 0 === arguments.length) f.constructor_.call(this, 2);
            else if (1 === arguments.length) {
                const t = arguments[0];
                if (2 !== t && 3 !== t) throw new n("only 2 or 3 dimensions may be specified");
                this._dimensionsToTest = t;
            }
        }
        static compare(t, e) {
            return t < e ? -1 : t > e ? 1 : r.isNaN(t) ? r.isNaN(e) ? 0 : -1 : r.isNaN(e) ? 1 : 0;
        }
        compare(t, e) {
            const s = f.compare(t.x, e.x);
            if (0 !== s) return s;
            const n = f.compare(t.y, e.y);
            if (0 !== n) return n;
            if (this._dimensionsToTest <= 2) return 0;
            return f.compare(t.getZ(), e.getZ());
        }
        get interfaces_() {
            return [
                g
            ];
        }
    }
    m.DimensionalComparator = f, m.NULL_ORDINATE = r.NaN, m.X = 0, m.Y = 1, m.Z = 2, m.M = 3;
    class y extends m {
        constructor(){
            super(), y.constructor_.apply(this, arguments);
        }
        static constructor_() {
            if (0 === arguments.length) m.constructor_.call(this);
            else if (1 === arguments.length) {
                if (arguments[0] instanceof y) {
                    const t = arguments[0];
                    m.constructor_.call(this, t.x, t.y);
                } else if (arguments[0] instanceof m) {
                    const t = arguments[0];
                    m.constructor_.call(this, t.x, t.y);
                }
            } else if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                m.constructor_.call(this, t, e, m.NULL_ORDINATE);
            }
        }
        setOrdinate(t, e) {
            switch(t){
                case y.X:
                    this.x = e;
                    break;
                case y.Y:
                    this.y = e;
                    break;
                default:
                    throw new n("Invalid ordinate index: " + t);
            }
        }
        setZ(t) {
            throw new n("CoordinateXY dimension 2 does not support z-ordinate");
        }
        copy() {
            return new y(this);
        }
        toString() {
            return "(" + this.x + ", " + this.y + ")";
        }
        setCoordinate(t) {
            this.x = t.x, this.y = t.y, this.z = t.getZ();
        }
        getZ() {
            return m.NULL_ORDINATE;
        }
        getOrdinate(t) {
            switch(t){
                case y.X:
                    return this.x;
                case y.Y:
                    return this.y;
            }
            throw new n("Invalid ordinate index: " + t);
        }
    }
    y.X = 0, y.Y = 1, y.Z = -1, y.M = -1;
    class x extends m {
        constructor(){
            super(), x.constructor_.apply(this, arguments);
        }
        static constructor_() {
            if (this._m = null, 0 === arguments.length) m.constructor_.call(this), this._m = 0;
            else if (1 === arguments.length) {
                if (arguments[0] instanceof x) {
                    const t = arguments[0];
                    m.constructor_.call(this, t.x, t.y), this._m = t._m;
                } else if (arguments[0] instanceof m) {
                    const t = arguments[0];
                    m.constructor_.call(this, t.x, t.y), this._m = this.getM();
                }
            } else if (3 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = arguments[2];
                m.constructor_.call(this, t, e, m.NULL_ORDINATE), this._m = s;
            }
        }
        setM(t) {
            this._m = t;
        }
        setZ(t) {
            throw new n("CoordinateXY dimension 2 does not support z-ordinate");
        }
        copy() {
            return new x(this);
        }
        toString() {
            return "(" + this.x + ", " + this.y + " m=" + this.getM() + ")";
        }
        setCoordinate(t) {
            this.x = t.x, this.y = t.y, this.z = t.getZ(), this._m = t.getM();
        }
        getM() {
            return this._m;
        }
        setOrdinate(t, e) {
            switch(t){
                case x.X:
                    this.x = e;
                    break;
                case x.Y:
                    this.y = e;
                    break;
                case x.M:
                    this._m = e;
                    break;
                default:
                    throw new n("Invalid ordinate index: " + t);
            }
        }
        getZ() {
            return m.NULL_ORDINATE;
        }
        getOrdinate(t) {
            switch(t){
                case x.X:
                    return this.x;
                case x.Y:
                    return this.y;
                case x.M:
                    return this._m;
            }
            throw new n("Invalid ordinate index: " + t);
        }
    }
    x.X = 0, x.Y = 1, x.Z = -1, x.M = 2;
    class E extends m {
        constructor(){
            super(), E.constructor_.apply(this, arguments);
        }
        static constructor_() {
            if (this._m = null, 0 === arguments.length) m.constructor_.call(this), this._m = 0;
            else if (1 === arguments.length) {
                if (arguments[0] instanceof E) {
                    const t = arguments[0];
                    m.constructor_.call(this, t), this._m = t._m;
                } else if (arguments[0] instanceof m) {
                    const t = arguments[0];
                    m.constructor_.call(this, t), this._m = this.getM();
                }
            } else if (4 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = arguments[2], n = arguments[3];
                m.constructor_.call(this, t, e, s), this._m = n;
            }
        }
        setM(t) {
            this._m = t;
        }
        getOrdinate(t) {
            switch(t){
                case m.X:
                    return this.x;
                case m.Y:
                    return this.y;
                case m.Z:
                    return this.getZ();
                case m.M:
                    return this.getM();
            }
            throw new n("Invalid ordinate index: " + t);
        }
        copy() {
            return new E(this);
        }
        toString() {
            return "(" + this.x + ", " + this.y + ", " + this.getZ() + " m=" + this.getM() + ")";
        }
        setCoordinate(t) {
            this.x = t.x, this.y = t.y, this.z = t.getZ(), this._m = t.getM();
        }
        getM() {
            return this._m;
        }
        setOrdinate(t, e) {
            switch(t){
                case m.X:
                    this.x = e;
                    break;
                case m.Y:
                    this.y = e;
                    break;
                case m.Z:
                    this.z = e;
                    break;
                case m.M:
                    this._m = e;
                    break;
                default:
                    throw new n("Invalid ordinate index: " + t);
            }
        }
    }
    function I(t, e) {
        return t.interfaces_ && t.interfaces_.indexOf(e) > -1;
    }
    class N {
        add() {}
        addAll() {}
        isEmpty() {}
        iterator() {}
        size() {}
        toArray() {}
        remove() {}
    }
    class w extends s {
        constructor(t){
            super(t), this.name = Object.keys({
                IndexOutOfBoundsException: w
            })[0];
        }
    }
    class C extends N {
        get() {}
        set() {}
        isEmpty() {}
    }
    class S extends s {
        constructor(t){
            super(t), this.name = Object.keys({
                NoSuchElementException: S
            })[0];
        }
    }
    class L extends C {
        constructor(t){
            super(), this.array = [], t instanceof N && this.addAll(t);
        }
        get interfaces_() {
            return [
                C,
                N
            ];
        }
        ensureCapacity() {}
        add(t) {
            return 1 === arguments.length ? this.array.push(t) : this.array.splice(arguments[0], 0, arguments[1]), !0;
        }
        clear() {
            this.array = [];
        }
        addAll(t) {
            for (const e of t)this.array.push(e);
        }
        set(t, e) {
            const s = this.array[t];
            return this.array[t] = e, s;
        }
        iterator() {
            return new T(this);
        }
        get(t) {
            if (t < 0 || t >= this.size()) throw new w;
            return this.array[t];
        }
        isEmpty() {
            return 0 === this.array.length;
        }
        sort(t) {
            t ? this.array.sort((e, s)=>t.compare(e, s)) : this.array.sort();
        }
        size() {
            return this.array.length;
        }
        toArray() {
            return this.array.slice();
        }
        remove(t) {
            for(let e = 0, s = this.array.length; e < s; e++)if (this.array[e] === t) return !!this.array.splice(e, 1);
            return !1;
        }
        [Symbol.iterator]() {
            return this.array.values();
        }
    }
    let T = class {
        constructor(t){
            this.arrayList = t, this.position = 0;
        }
        next() {
            if (this.position === this.arrayList.size()) throw new S;
            return this.arrayList.get(this.position++);
        }
        hasNext() {
            return this.position < this.arrayList.size();
        }
        set(t) {
            return this.arrayList.set(this.position - 1, t);
        }
        remove() {
            this.arrayList.remove(this.arrayList.get(this.position));
        }
    };
    class R extends L {
        constructor(){
            super(), R.constructor_.apply(this, arguments);
        }
        static constructor_() {
            if (0 === arguments.length) ;
            else if (1 === arguments.length) {
                const t = arguments[0];
                this.ensureCapacity(t.length), this.add(t, !0);
            } else if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                this.ensureCapacity(t.length), this.add(t, e);
            }
        }
        getCoordinate(t) {
            return this.get(t);
        }
        addAll() {
            if (2 === arguments.length && "boolean" == typeof arguments[1] && I(arguments[0], N)) {
                const t = arguments[1];
                let e = !1;
                for(let s = arguments[0].iterator(); s.hasNext();)this.add(s.next(), t), e = !0;
                return e;
            }
            return super.addAll.apply(this, arguments);
        }
        clone() {
            const t = super.clone.call(this);
            for(let e = 0; e < this.size(); e++)t.add(e, this.get(e).clone());
            return t;
        }
        closeRing() {
            if (this.size() > 0) {
                const t = this.get(0).copy();
                this.add(t, !1);
            }
        }
        toCoordinateArray() {
            if (0 === arguments.length) return this.toArray(R.coordArrayType);
            if (1 === arguments.length) {
                if (arguments[0]) return this.toArray(R.coordArrayType);
                const t = this.size(), e = new Array(t).fill(null);
                for(let s = 0; s < t; s++)e[s] = this.get(t - s - 1);
                return e;
            }
        }
        add() {
            if (1 === arguments.length) {
                const t = arguments[0];
                return super.add.call(this, t);
            }
            if (2 === arguments.length) {
                if (arguments[0] instanceof Array && "boolean" == typeof arguments[1]) {
                    const t = arguments[0], e = arguments[1];
                    return this.add(t, e, !0), !0;
                }
                if (arguments[0] instanceof m && "boolean" == typeof arguments[1]) {
                    const t = arguments[0];
                    if (!arguments[1] && this.size() >= 1) {
                        if (this.get(this.size() - 1).equals2D(t)) return null;
                    }
                    super.add.call(this, t);
                } else if (arguments[0] instanceof Object && "boolean" == typeof arguments[1]) {
                    const t = arguments[0], e = arguments[1];
                    return this.add(t, e), !0;
                }
            } else if (3 === arguments.length) {
                if ("boolean" == typeof arguments[2] && arguments[0] instanceof Array && "boolean" == typeof arguments[1]) {
                    const t = arguments[0], e = arguments[1];
                    if (arguments[2]) for(let s = 0; s < t.length; s++)this.add(t[s], e);
                    else for(let s = t.length - 1; s >= 0; s--)this.add(t[s], e);
                    return !0;
                }
                if ("boolean" == typeof arguments[2] && Number.isInteger(arguments[0]) && arguments[1] instanceof m) {
                    const t = arguments[0], e = arguments[1];
                    if (!arguments[2]) {
                        const s = this.size();
                        if (s > 0) {
                            if (t > 0) {
                                if (this.get(t - 1).equals2D(e)) return null;
                            }
                            if (t < s) {
                                if (this.get(t).equals2D(e)) return null;
                            }
                        }
                    }
                    super.add.call(this, t, e);
                }
            } else if (4 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = arguments[2], n = arguments[3];
                let i = 1;
                s > n && (i = -1);
                for(let r = s; r !== n; r += i)this.add(t[r], e);
                return !0;
            }
        }
    }
    R.coordArrayType = new Array(0).fill(null);
    class P {
        filter(t, e) {}
        isGeometryChanged() {}
        isDone() {}
    }
    class O {
        constructor(){
            O.constructor_.apply(this, arguments);
        }
        static constructor_() {
            if (this._minx = null, this._maxx = null, this._miny = null, this._maxy = null, 0 === arguments.length) this.init();
            else if (1 === arguments.length) {
                if (arguments[0] instanceof m) {
                    const t = arguments[0];
                    this.init(t.x, t.x, t.y, t.y);
                } else if (arguments[0] instanceof O) {
                    const t = arguments[0];
                    this.init(t);
                }
            } else if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                this.init(t.x, e.x, t.y, e.y);
            } else if (4 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = arguments[2], n = arguments[3];
                this.init(t, e, s, n);
            }
        }
        static intersects() {
            if (3 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = arguments[2];
                return s.x >= (t.x < e.x ? t.x : e.x) && s.x <= (t.x > e.x ? t.x : e.x) && s.y >= (t.y < e.y ? t.y : e.y) && s.y <= (t.y > e.y ? t.y : e.y);
            }
            if (4 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = arguments[2], n = arguments[3];
                let i = Math.min(s.x, n.x), r = Math.max(s.x, n.x), o = Math.min(t.x, e.x), l = Math.max(t.x, e.x);
                return !(o > r) && !(l < i) && (i = Math.min(s.y, n.y), r = Math.max(s.y, n.y), o = Math.min(t.y, e.y), l = Math.max(t.y, e.y), !(o > r) && !(l < i));
            }
        }
        getArea() {
            return this.getWidth() * this.getHeight();
        }
        getMinX() {
            return this._minx;
        }
        expandToInclude() {
            if (1 === arguments.length) {
                if (arguments[0] instanceof m) {
                    const t = arguments[0];
                    this.expandToInclude(t.x, t.y);
                } else if (arguments[0] instanceof O) {
                    const t = arguments[0];
                    if (t.isNull()) return null;
                    this.isNull() ? (this._minx = t.getMinX(), this._maxx = t.getMaxX(), this._miny = t.getMinY(), this._maxy = t.getMaxY()) : (t._minx < this._minx && (this._minx = t._minx), t._maxx > this._maxx && (this._maxx = t._maxx), t._miny < this._miny && (this._miny = t._miny), t._maxy > this._maxy && (this._maxy = t._maxy));
                }
            } else if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                this.isNull() ? (this._minx = t, this._maxx = t, this._miny = e, this._maxy = e) : (t < this._minx && (this._minx = t), t > this._maxx && (this._maxx = t), e < this._miny && (this._miny = e), e > this._maxy && (this._maxy = e));
            }
        }
        compareTo(t) {
            const e = t;
            return this.isNull() ? e.isNull() ? 0 : -1 : e.isNull() ? 1 : this._minx < e._minx ? -1 : this._minx > e._minx ? 1 : this._miny < e._miny ? -1 : this._miny > e._miny ? 1 : this._maxx < e._maxx ? -1 : this._maxx > e._maxx ? 1 : this._maxy < e._maxy ? -1 : this._maxy > e._maxy ? 1 : 0;
        }
        translate(t, e) {
            if (this.isNull()) return null;
            this.init(this.getMinX() + t, this.getMaxX() + t, this.getMinY() + e, this.getMaxY() + e);
        }
        copy() {
            return new O(this);
        }
        expandBy() {
            if (1 === arguments.length) {
                const t = arguments[0];
                this.expandBy(t, t);
            } else if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                if (this.isNull()) return null;
                this._minx -= t, this._maxx += t, this._miny -= e, this._maxy += e, (this._minx > this._maxx || this._miny > this._maxy) && this.setToNull();
            }
        }
        contains() {
            if (1 === arguments.length) {
                if (arguments[0] instanceof O) {
                    const t = arguments[0];
                    return this.covers(t);
                }
                if (arguments[0] instanceof m) {
                    const t = arguments[0];
                    return this.covers(t);
                }
            } else if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                return this.covers(t, e);
            }
        }
        hashCode() {
            let t = 17;
            return t = 37 * t + m.hashCode(this._minx), t = 37 * t + m.hashCode(this._maxx), t = 37 * t + m.hashCode(this._miny), t = 37 * t + m.hashCode(this._maxy), t;
        }
        equals(t) {
            if (!(t instanceof O)) return !1;
            const e = t;
            return this.isNull() ? e.isNull() : this._maxx === e.getMaxX() && this._maxy === e.getMaxY() && this._minx === e.getMinX() && this._miny === e.getMinY();
        }
        intersection(t) {
            if (this.isNull() || t.isNull() || !this.intersects(t)) return new O;
            const e = this._minx > t._minx ? this._minx : t._minx, s = this._miny > t._miny ? this._miny : t._miny, n = this._maxx < t._maxx ? this._maxx : t._maxx, i = this._maxy < t._maxy ? this._maxy : t._maxy;
            return new O(e, n, s, i);
        }
        isNull() {
            return this._maxx < this._minx;
        }
        getMaxX() {
            return this._maxx;
        }
        covers() {
            if (1 === arguments.length) {
                if (arguments[0] instanceof m) {
                    const t = arguments[0];
                    return this.covers(t.x, t.y);
                }
                if (arguments[0] instanceof O) {
                    const t = arguments[0];
                    return !this.isNull() && !t.isNull() && t.getMinX() >= this._minx && t.getMaxX() <= this._maxx && t.getMinY() >= this._miny && t.getMaxY() <= this._maxy;
                }
            } else if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                return !this.isNull() && t >= this._minx && t <= this._maxx && e >= this._miny && e <= this._maxy;
            }
        }
        intersects() {
            if (1 === arguments.length) {
                if (arguments[0] instanceof O) {
                    const t = arguments[0];
                    return !this.isNull() && !t.isNull() && !(t._minx > this._maxx || t._maxx < this._minx || t._miny > this._maxy || t._maxy < this._miny);
                }
                if (arguments[0] instanceof m) {
                    const t = arguments[0];
                    return this.intersects(t.x, t.y);
                }
            } else if (2 === arguments.length) {
                if (arguments[0] instanceof m && arguments[1] instanceof m) {
                    const t = arguments[0], e = arguments[1];
                    if (this.isNull()) return !1;
                    if ((t.x < e.x ? t.x : e.x) > this._maxx) return !1;
                    if ((t.x > e.x ? t.x : e.x) < this._minx) return !1;
                    if ((t.y < e.y ? t.y : e.y) > this._maxy) return !1;
                    return !((t.y > e.y ? t.y : e.y) < this._miny);
                }
                if ("number" == typeof arguments[0] && "number" == typeof arguments[1]) {
                    const t = arguments[0], e = arguments[1];
                    return !this.isNull() && !(t > this._maxx || t < this._minx || e > this._maxy || e < this._miny);
                }
            }
        }
        getMinY() {
            return this._miny;
        }
        getDiameter() {
            if (this.isNull()) return 0;
            const t = this.getWidth(), e = this.getHeight();
            return Math.sqrt(t * t + e * e);
        }
        minExtent() {
            if (this.isNull()) return 0;
            const t = this.getWidth(), e = this.getHeight();
            return t < e ? t : e;
        }
        getWidth() {
            return this.isNull() ? 0 : this._maxx - this._minx;
        }
        toString() {
            return "Env[" + this._minx + " : " + this._maxx + ", " + this._miny + " : " + this._maxy + "]";
        }
        setToNull() {
            this._minx = 0, this._maxx = -1, this._miny = 0, this._maxy = -1;
        }
        disjoint(t) {
            return !(!this.isNull() && !t.isNull()) || t._minx > this._maxx || t._maxx < this._minx || t._miny > this._maxy || t._maxy < this._miny;
        }
        getHeight() {
            return this.isNull() ? 0 : this._maxy - this._miny;
        }
        maxExtent() {
            if (this.isNull()) return 0;
            const t = this.getWidth(), e = this.getHeight();
            return t > e ? t : e;
        }
        centre() {
            return this.isNull() ? null : new m((this.getMinX() + this.getMaxX()) / 2, (this.getMinY() + this.getMaxY()) / 2);
        }
        init() {
            if (0 === arguments.length) this.setToNull();
            else if (1 === arguments.length) {
                if (arguments[0] instanceof m) {
                    const t = arguments[0];
                    this.init(t.x, t.x, t.y, t.y);
                } else if (arguments[0] instanceof O) {
                    const t = arguments[0];
                    this._minx = t._minx, this._maxx = t._maxx, this._miny = t._miny, this._maxy = t._maxy;
                }
            } else if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                this.init(t.x, e.x, t.y, e.y);
            } else if (4 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = arguments[2], n = arguments[3];
                t < e ? (this._minx = t, this._maxx = e) : (this._minx = e, this._maxx = t), s < n ? (this._miny = s, this._maxy = n) : (this._miny = n, this._maxy = s);
            }
        }
        getMaxY() {
            return this._maxy;
        }
        distance(t) {
            if (this.intersects(t)) return 0;
            let e = 0;
            this._maxx < t._minx ? e = t._minx - this._maxx : this._minx > t._maxx && (e = this._minx - t._maxx);
            let s = 0;
            return this._maxy < t._miny ? s = t._miny - this._maxy : this._miny > t._maxy && (s = this._miny - t._maxy), 0 === e ? s : 0 === s ? e : Math.sqrt(e * e + s * s);
        }
        get interfaces_() {
            return [
                o,
                l
            ];
        }
    }
    class v {
        constructor(t){
            this.str = t;
        }
        append(t) {
            this.str += t;
        }
        setCharAt(t, e) {
            this.str = this.str.substr(0, t) + e + this.str.substr(t + 1);
        }
        toString() {
            return this.str;
        }
    }
    class M {
        constructor(t){
            this.value = t;
        }
        intValue() {
            return this.value;
        }
        compareTo(t) {
            return this.value < t ? -1 : this.value > t ? 1 : 0;
        }
        static compare(t, e) {
            return t < e ? -1 : t > e ? 1 : 0;
        }
        static isNan(t) {
            return Number.isNaN(t);
        }
        static valueOf(t) {
            return new M(t);
        }
    }
    class b {
        static isWhitespace(t) {
            return t <= 32 && t >= 0 || 127 === t;
        }
        static toUpperCase(t) {
            return t.toUpperCase();
        }
    }
    class D extends s {
        constructor(t){
            super(t), this.name = Object.keys({
                IllegalStateException: D
            })[0];
        }
    }
    class A {
        constructor(){
            A.constructor_.apply(this, arguments);
        }
        static constructor_() {
            if (this._hi = 0, this._lo = 0, 0 === arguments.length) this.init(0);
            else if (1 === arguments.length) {
                if ("number" == typeof arguments[0]) {
                    const t = arguments[0];
                    this.init(t);
                } else if (arguments[0] instanceof A) {
                    const t = arguments[0];
                    this.init(t);
                } else if ("string" == typeof arguments[0]) {
                    const t = arguments[0];
                    A.constructor_.call(this, A.parse(t));
                }
            } else if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                this.init(t, e);
            }
        }
        static determinant() {
            if ("number" == typeof arguments[3] && "number" == typeof arguments[2] && "number" == typeof arguments[0] && "number" == typeof arguments[1]) {
                const t = arguments[0], e = arguments[1], s = arguments[2], n = arguments[3];
                return A.determinant(A.valueOf(t), A.valueOf(e), A.valueOf(s), A.valueOf(n));
            }
            if (arguments[3] instanceof A && arguments[2] instanceof A && arguments[0] instanceof A && arguments[1] instanceof A) {
                const t = arguments[1], e = arguments[2], s = arguments[3];
                return arguments[0].multiply(s).selfSubtract(t.multiply(e));
            }
        }
        static sqr(t) {
            return A.valueOf(t).selfMultiply(t);
        }
        static valueOf() {
            if ("string" == typeof arguments[0]) {
                const t = arguments[0];
                return A.parse(t);
            }
            if ("number" == typeof arguments[0]) return new A(arguments[0]);
        }
        static sqrt(t) {
            return A.valueOf(t).sqrt();
        }
        static parse(t) {
            let e = 0;
            const s = t.length;
            for(; b.isWhitespace(t.charAt(e));)e++;
            let n = !1;
            if (e < s) {
                const s = t.charAt(e);
                "-" !== s && "+" !== s || (e++, "-" === s && (n = !0));
            }
            const i = new A;
            let r = 0, o = 0, l = 0, a = !1;
            for(; !(e >= s);){
                const s = t.charAt(e);
                if (e++, b.isDigit(s)) {
                    const t = s - "0";
                    i.selfMultiply(A.TEN), i.selfAdd(t), r++;
                } else {
                    if ("." !== s) {
                        if ("e" === s || "E" === s) {
                            const s = t.substring(e);
                            try {
                                l = M.parseInt(s);
                            } catch (e) {
                                throw e instanceof NumberFormatException ? new NumberFormatException("Invalid exponent " + s + " in string " + t) : e;
                            }
                            break;
                        }
                        throw new NumberFormatException("Unexpected character '" + s + "' at position " + e + " in string " + t);
                    }
                    o = r, a = !0;
                }
            }
            let c = i;
            a || (o = r);
            const h = r - o - l;
            if (0 === h) c = i;
            else if (h > 0) {
                const t = A.TEN.pow(h);
                c = i.divide(t);
            } else if (h < 0) {
                const t = A.TEN.pow(-h);
                c = i.multiply(t);
            }
            return n ? c.negate() : c;
        }
        static createNaN() {
            return new A(r.NaN, r.NaN);
        }
        static copy(t) {
            return new A(t);
        }
        static magnitude(t) {
            const e = Math.abs(t), s = Math.log(e) / Math.log(10);
            let n = Math.trunc(Math.floor(s));
            return 10 * Math.pow(10, n) <= e && (n += 1), n;
        }
        static stringOfChar(t, e) {
            const s = new v;
            for(let n = 0; n < e; n++)s.append(t);
            return s.toString();
        }
        le(t) {
            return this._hi < t._hi || this._hi === t._hi && this._lo <= t._lo;
        }
        extractSignificantDigits(t, e) {
            let s = this.abs(), n = A.magnitude(s._hi);
            const i = A.TEN.pow(n);
            s = s.divide(i), s.gt(A.TEN) ? (s = s.divide(A.TEN), n += 1) : s.lt(A.ONE) && (s = s.multiply(A.TEN), n -= 1);
            const r = n + 1, o = new v, l = A.MAX_PRINT_DIGITS - 1;
            for(let e = 0; e <= l; e++){
                t && e === r && o.append(".");
                const n = Math.trunc(s._hi);
                if (n < 0) break;
                let i = !1, a = 0;
                n > 9 ? (i = !0, a = "9") : a = "0" + n, o.append(a), s = s.subtract(A.valueOf(n)).multiply(A.TEN), i && s.selfAdd(A.TEN);
                let c = !0;
                const h = A.magnitude(s._hi);
                if (h < 0 && Math.abs(h) >= l - e && (c = !1), !c) break;
            }
            return e[0] = n, o.toString();
        }
        sqr() {
            return this.multiply(this);
        }
        getSpecialNumberString() {
            return this.isZero() ? "0.0" : this.isNaN() ? "NaN " : null;
        }
        setValue() {
            if (arguments[0] instanceof A) {
                const t = arguments[0];
                return this.init(t), this;
            }
            if ("number" == typeof arguments[0]) {
                const t = arguments[0];
                return this.init(t), this;
            }
        }
        multiply() {
            if (arguments[0] instanceof A) {
                const t = arguments[0];
                return t.isNaN() ? A.createNaN() : A.copy(this).selfMultiply(t);
            }
            if ("number" == typeof arguments[0]) {
                const t = arguments[0];
                return r.isNaN(t) ? A.createNaN() : A.copy(this).selfMultiply(t, 0);
            }
        }
        isNaN() {
            return r.isNaN(this._hi);
        }
        reciprocal() {
            let t = null, e = null, s = null, n = null, i = null, r = null, o = null, l = null;
            i = 1 / this._hi, r = A.SPLIT * i, t = r - i, l = A.SPLIT * this._hi, t = r - t, e = i - t, s = l - this._hi, o = i * this._hi, s = l - s, n = this._hi - s, l = t * s - o + t * n + e * s + e * n, r = (1 - o - l - i * this._lo) / this._hi;
            const a = i + r;
            return new A(a, i - a + r);
        }
        doubleValue() {
            return this._hi + this._lo;
        }
        subtract() {
            if (arguments[0] instanceof A) {
                const t = arguments[0];
                return this.add(t.negate());
            }
            if ("number" == typeof arguments[0]) {
                const t = arguments[0];
                return this.add(-t);
            }
        }
        equals() {
            if (1 === arguments.length && arguments[0] instanceof A) {
                const t = arguments[0];
                return this._hi === t._hi && this._lo === t._lo;
            }
        }
        isZero() {
            return 0 === this._hi && 0 === this._lo;
        }
        selfSubtract() {
            if (arguments[0] instanceof A) {
                const t = arguments[0];
                return this.isNaN() ? this : this.selfAdd(-t._hi, -t._lo);
            }
            if ("number" == typeof arguments[0]) {
                const t = arguments[0];
                return this.isNaN() ? this : this.selfAdd(-t, 0);
            }
        }
        min(t) {
            return this.le(t) ? this : t;
        }
        selfDivide() {
            if (1 === arguments.length) {
                if (arguments[0] instanceof A) {
                    const t = arguments[0];
                    return this.selfDivide(t._hi, t._lo);
                }
                if ("number" == typeof arguments[0]) {
                    const t = arguments[0];
                    return this.selfDivide(t, 0);
                }
            } else if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                let s = null, n = null, i = null, r = null, o = null, l = null, a = null, c = null;
                return o = this._hi / t, l = A.SPLIT * o, s = l - o, c = A.SPLIT * t, s = l - s, n = o - s, i = c - t, a = o * t, i = c - i, r = t - i, c = s * i - a + s * r + n * i + n * r, l = (this._hi - a - c + this._lo - o * e) / t, c = o + l, this._hi = c, this._lo = o - c + l, this;
            }
        }
        dump() {
            return "DD<" + this._hi + ", " + this._lo + ">";
        }
        divide() {
            if (arguments[0] instanceof A) {
                const t = arguments[0];
                let e = null, s = null, n = null, i = null, r = null, o = null, l = null, a = null;
                r = this._hi / t._hi, o = A.SPLIT * r, e = o - r, a = A.SPLIT * t._hi, e = o - e, s = r - e, n = a - t._hi, l = r * t._hi, n = a - n, i = t._hi - n, a = e * n - l + e * i + s * n + s * i, o = (this._hi - l - a + this._lo - r * t._lo) / t._hi, a = r + o;
                return new A(a, r - a + o);
            }
            if ("number" == typeof arguments[0]) {
                const t = arguments[0];
                return r.isNaN(t) ? A.createNaN() : A.copy(this).selfDivide(t, 0);
            }
        }
        ge(t) {
            return this._hi > t._hi || this._hi === t._hi && this._lo >= t._lo;
        }
        pow(t) {
            if (0 === t) return A.valueOf(1);
            let e = new A(this), s = A.valueOf(1), n = Math.abs(t);
            if (n > 1) for(; n > 0;)n % 2 == 1 && s.selfMultiply(e), n /= 2, n > 0 && (e = e.sqr());
            else s = e;
            return t < 0 ? s.reciprocal() : s;
        }
        ceil() {
            if (this.isNaN()) return A.NaN;
            const t = Math.ceil(this._hi);
            let e = 0;
            return t === this._hi && (e = Math.ceil(this._lo)), new A(t, e);
        }
        compareTo(t) {
            const e = t;
            return this._hi < e._hi ? -1 : this._hi > e._hi ? 1 : this._lo < e._lo ? -1 : this._lo > e._lo ? 1 : 0;
        }
        rint() {
            if (this.isNaN()) return this;
            return this.add(.5).floor();
        }
        max(t) {
            return this.ge(t) ? this : t;
        }
        sqrt() {
            if (this.isZero()) return A.valueOf(0);
            if (this.isNegative()) return A.NaN;
            const t = 1 / Math.sqrt(this._hi), e = this._hi * t, s = A.valueOf(e), n = this.subtract(s.sqr())._hi * (.5 * t);
            return s.add(n);
        }
        selfAdd() {
            if (1 === arguments.length) {
                if (arguments[0] instanceof A) {
                    const t = arguments[0];
                    return this.selfAdd(t._hi, t._lo);
                }
                if ("number" == typeof arguments[0]) {
                    const t = arguments[0];
                    let e = null, s = null, n = null, i = null, r = null, o = null;
                    return n = this._hi + t, r = n - this._hi, i = n - r, i = t - r + (this._hi - i), o = i + this._lo, e = n + o, s = o + (n - e), this._hi = e + s, this._lo = s + (e - this._hi), this;
                }
            } else if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                let s = null, n = null, i = null, r = null, o = null, l = null, a = null, c = null;
                o = this._hi + t, i = this._lo + e, a = o - this._hi, c = i - this._lo, l = o - a, r = i - c, l = t - a + (this._hi - l), r = e - c + (this._lo - r), a = l + i, s = o + a, n = a + (o - s), a = r + n;
                const h = s + a, u = a + (s - h);
                return this._hi = h, this._lo = u, this;
            }
        }
        selfMultiply() {
            if (1 === arguments.length) {
                if (arguments[0] instanceof A) {
                    const t = arguments[0];
                    return this.selfMultiply(t._hi, t._lo);
                }
                if ("number" == typeof arguments[0]) {
                    const t = arguments[0];
                    return this.selfMultiply(t, 0);
                }
            } else if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                let s = null, n = null, i = null, r = null, o = null, l = null;
                o = A.SPLIT * this._hi, s = o - this._hi, l = A.SPLIT * t, s = o - s, n = this._hi - s, i = l - t, o = this._hi * t, i = l - i, r = t - i, l = s * i - o + s * r + n * i + n * r + (this._hi * e + this._lo * t);
                const a = o + l;
                s = o - a;
                const c = l + s;
                return this._hi = a, this._lo = c, this;
            }
        }
        selfSqr() {
            return this.selfMultiply(this);
        }
        floor() {
            if (this.isNaN()) return A.NaN;
            const t = Math.floor(this._hi);
            let e = 0;
            return t === this._hi && (e = Math.floor(this._lo)), new A(t, e);
        }
        negate() {
            return this.isNaN() ? this : new A(-this._hi, -this._lo);
        }
        clone() {
            try {
                return null;
            } catch (t) {
                if (t instanceof CloneNotSupportedException) return null;
                throw t;
            }
        }
        intValue() {
            return Math.trunc(this._hi);
        }
        toString() {
            const t = A.magnitude(this._hi);
            return t >= -3 && t <= 20 ? this.toStandardNotation() : this.toSciNotation();
        }
        toStandardNotation() {
            const t = this.getSpecialNumberString();
            if (null !== t) return t;
            const e = new Array(1).fill(null), s = this.extractSignificantDigits(!0, e), n = e[0] + 1;
            let i = s;
            if ("." === s.charAt(0)) i = "0" + s;
            else if (n < 0) i = "0." + A.stringOfChar("0", -n) + s;
            else if (-1 === s.indexOf(".")) {
                const t = n - s.length;
                i = s + A.stringOfChar("0", t) + ".0";
            }
            return this.isNegative() ? "-" + i : i;
        }
        toSciNotation() {
            if (this.isZero()) return A.SCI_NOT_ZERO;
            const t = this.getSpecialNumberString();
            if (null !== t) return t;
            const e = new Array(1).fill(null), s = this.extractSignificantDigits(!1, e), n = A.SCI_NOT_EXPONENT_CHAR + e[0];
            if ("0" === s.charAt(0)) throw new D("Found leading zero: " + s);
            let i = "";
            s.length > 1 && (i = s.substring(1));
            const r = s.charAt(0) + "." + i;
            return this.isNegative() ? "-" + r + n : r + n;
        }
        abs() {
            return this.isNaN() ? A.NaN : this.isNegative() ? this.negate() : new A(this);
        }
        isPositive() {
            return this._hi > 0 || 0 === this._hi && this._lo > 0;
        }
        lt(t) {
            return this._hi < t._hi || this._hi === t._hi && this._lo < t._lo;
        }
        add() {
            if (arguments[0] instanceof A) {
                const t = arguments[0];
                return A.copy(this).selfAdd(t);
            }
            if ("number" == typeof arguments[0]) {
                const t = arguments[0];
                return A.copy(this).selfAdd(t);
            }
        }
        init() {
            if (1 === arguments.length) {
                if ("number" == typeof arguments[0]) {
                    const t = arguments[0];
                    this._hi = t, this._lo = 0;
                } else if (arguments[0] instanceof A) {
                    const t = arguments[0];
                    this._hi = t._hi, this._lo = t._lo;
                }
            } else if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                this._hi = t, this._lo = e;
            }
        }
        gt(t) {
            return this._hi > t._hi || this._hi === t._hi && this._lo > t._lo;
        }
        isNegative() {
            return this._hi < 0 || 0 === this._hi && this._lo < 0;
        }
        trunc() {
            return this.isNaN() ? A.NaN : this.isPositive() ? this.floor() : this.ceil();
        }
        signum() {
            return this._hi > 0 ? 1 : this._hi < 0 ? -1 : this._lo > 0 ? 1 : this._lo < 0 ? -1 : 0;
        }
        get interfaces_() {
            return [
                l,
                o,
                u
            ];
        }
    }
    A.PI = new A(3.141592653589793, 12246467991473532e-32), A.TWO_PI = new A(6.283185307179586, 24492935982947064e-32), A.PI_2 = new A(1.5707963267948966, 6123233995736766e-32), A.E = new A(2.718281828459045, 14456468917292502e-32), A.NaN = new A(r.NaN, r.NaN), A.EPS = 123259516440783e-46, A.SPLIT = 134217729, A.MAX_PRINT_DIGITS = 32, A.TEN = A.valueOf(10), A.ONE = A.valueOf(1), A.SCI_NOT_EXPONENT_CHAR = "E", A.SCI_NOT_ZERO = "0.0E0";
    class F {
        static orientationIndex(t, e, s) {
            const n = F.orientationIndexFilter(t, e, s);
            if (n <= 1) return n;
            const i = A.valueOf(e.x).selfAdd(-t.x), r = A.valueOf(e.y).selfAdd(-t.y), o = A.valueOf(s.x).selfAdd(-e.x), l = A.valueOf(s.y).selfAdd(-e.y);
            return i.selfMultiply(l).selfSubtract(r.selfMultiply(o)).signum();
        }
        static signOfDet2x2() {
            if (arguments[3] instanceof A && arguments[2] instanceof A && arguments[0] instanceof A && arguments[1] instanceof A) {
                const t = arguments[1], e = arguments[2], s = arguments[3];
                return arguments[0].multiply(s).selfSubtract(t.multiply(e)).signum();
            }
            if ("number" == typeof arguments[3] && "number" == typeof arguments[2] && "number" == typeof arguments[0] && "number" == typeof arguments[1]) {
                const t = arguments[0], e = arguments[1], s = arguments[2], n = arguments[3], i = A.valueOf(t), r = A.valueOf(e), o = A.valueOf(s), l = A.valueOf(n);
                return i.multiply(l).selfSubtract(r.multiply(o)).signum();
            }
        }
        static intersection(t, e, s, n) {
            const i = new A(t.y).selfSubtract(e.y), o = new A(e.x).selfSubtract(t.x), l = new A(t.x).selfMultiply(e.y).selfSubtract(new A(e.x).selfMultiply(t.y)), a = new A(s.y).selfSubtract(n.y), c = new A(n.x).selfSubtract(s.x), h = new A(s.x).selfMultiply(n.y).selfSubtract(new A(n.x).selfMultiply(s.y)), u = o.multiply(h).selfSubtract(c.multiply(l)), g = a.multiply(l).selfSubtract(i.multiply(h)), d = i.multiply(c).selfSubtract(a.multiply(o)), _ = u.selfDivide(d).doubleValue(), p = g.selfDivide(d).doubleValue();
            return r.isNaN(_) || r.isInfinite(_) || r.isNaN(p) || r.isInfinite(p) ? null : new m(_, p);
        }
        static orientationIndexFilter(t, e, s) {
            let n = null;
            const i = (t.x - s.x) * (e.y - s.y), r = (t.y - s.y) * (e.x - s.x), o = i - r;
            if (i > 0) {
                if (r <= 0) return F.signum(o);
                n = i + r;
            } else {
                if (!(i < 0)) return F.signum(o);
                if (r >= 0) return F.signum(o);
                n = -i - r;
            }
            const l = F.DP_SAFE_EPSILON * n;
            return o >= l || -o >= l ? F.signum(o) : 2;
        }
        static signum(t) {
            return t > 0 ? 1 : t < 0 ? -1 : 0;
        }
    }
    F.DP_SAFE_EPSILON = 1e-15;
    class G {
        getCoordinate() {}
        getCoordinateCopy(t) {}
        createCoordinate() {}
        getDimension() {}
        hasM() {
            return this.getMeasures() > 0;
        }
        getX(t) {}
        hasZ() {
            return this.getDimension() - this.getMeasures() > 2;
        }
        getMeasures() {
            return 0;
        }
        expandEnvelope(t) {}
        copy() {}
        getY(t) {}
        toCoordinateArray() {}
        getM(t) {
            if (this.hasM()) {
                const e = this.getDimension() - this.getMeasures();
                return this.getOrdinate(t, e);
            }
            return r.NaN;
        }
        setOrdinate(t, e, s) {}
        getZ(t) {
            return this.hasZ() ? this.getOrdinate(t, 2) : r.NaN;
        }
        size() {}
        getOrdinate(t, e) {}
        get interfaces_() {
            return [
                u
            ];
        }
    }
    G.X = 0, G.Y = 1, G.Z = 2, G.M = 3;
    class q {
        static isCCW() {
            if (arguments[0] instanceof Array) {
                const t = arguments[0], e = t.length - 1;
                if (e < 3) throw new n("Ring has fewer than 4 points, so orientation cannot be determined");
                let s = t[0], i = 0;
                for(let n = 1; n <= e; n++){
                    const e = t[n];
                    e.y > s.y && (s = e, i = n);
                }
                let r = i;
                do r -= 1, r < 0 && (r = e);
                while (t[r].equals2D(s) && r !== i);
                let o = i;
                do o = (o + 1) % e;
                while (t[o].equals2D(s) && o !== i);
                const l = t[r], a = t[o];
                if (l.equals2D(s) || a.equals2D(s) || l.equals2D(a)) return !1;
                const c = q.index(l, s, a);
                let h = null;
                return h = 0 === c ? l.x > a.x : c > 0, h;
            }
            if (I(arguments[0], G)) {
                const t = arguments[0], e = t.size() - 1;
                if (e < 3) throw new n("Ring has fewer than 4 points, so orientation cannot be determined");
                let s = t.getCoordinate(0), i = 0;
                for(let n = 1; n <= e; n++){
                    const e = t.getCoordinate(n);
                    e.y > s.y && (s = e, i = n);
                }
                let r = null, o = i;
                do o -= 1, o < 0 && (o = e), r = t.getCoordinate(o);
                while (r.equals2D(s) && o !== i);
                let l = null, a = i;
                do a = (a + 1) % e, l = t.getCoordinate(a);
                while (l.equals2D(s) && a !== i);
                if (r.equals2D(s) || l.equals2D(s) || r.equals2D(l)) return !1;
                const c = q.index(r, s, l);
                let h = null;
                return h = 0 === c ? r.x > l.x : c > 0, h;
            }
        }
        static index(t, e, s) {
            return F.orientationIndex(t, e, s);
        }
    }
    q.CLOCKWISE = -1, q.RIGHT = q.CLOCKWISE, q.COUNTERCLOCKWISE = 1, q.LEFT = q.COUNTERCLOCKWISE, q.COLLINEAR = 0, q.STRAIGHT = q.COLLINEAR;
    class B {
        static intersection(t, e, s, n) {
            const i = t.x < e.x ? t.x : e.x, o = t.y < e.y ? t.y : e.y, l = t.x > e.x ? t.x : e.x, a = t.y > e.y ? t.y : e.y, c = s.x < n.x ? s.x : n.x, h = s.y < n.y ? s.y : n.y, u = s.x > n.x ? s.x : n.x, g = s.y > n.y ? s.y : n.y, d = ((i > c ? i : c) + (l < u ? l : u)) / 2, _ = ((o > h ? o : h) + (a < g ? a : g)) / 2, p = t.x - d, f = t.y - _, y = e.x - d, x = e.y - _, E = s.x - d, I = s.y - _, N = n.x - d, w = n.y - _, C = f - x, S = y - p, L = p * x - y * f, T = I - w, R = N - E, P = E * w - N * I, O = C * R - T * S, v = (S * P - R * L) / O, M = (T * L - C * P) / O;
            return r.isNaN(v) || r.isInfinite(v) || r.isNaN(M) || r.isInfinite(M) ? null : new m(v + d, M + _);
        }
    }
    class Y {
        static arraycopy(t, e, s, n, i) {
            let r = 0;
            for(let o = e; o < e + i; o++)s[n + r] = t[o], r++;
        }
        static getProperty(t) {
            return ({
                "line.separator": "\n"
            })[t];
        }
    }
    class z {
        static log10(t) {
            const e = Math.log(t);
            return r.isInfinite(e) || r.isNaN(e) ? e : e / z.LOG_10;
        }
        static min(t, e, s, n) {
            let i = t;
            return e < i && (i = e), s < i && (i = s), n < i && (i = n), i;
        }
        static clamp() {
            if ("number" == typeof arguments[2] && "number" == typeof arguments[0] && "number" == typeof arguments[1]) {
                const t = arguments[0], e = arguments[1], s = arguments[2];
                return t < e ? e : t > s ? s : t;
            }
            if (Number.isInteger(arguments[2]) && Number.isInteger(arguments[0]) && Number.isInteger(arguments[1])) {
                const t = arguments[0], e = arguments[1], s = arguments[2];
                return t < e ? e : t > s ? s : t;
            }
        }
        static average(t, e) {
            return (t + e) / 2;
        }
        static wrap(t, e) {
            return t < 0 ? e - -t % e : t % e;
        }
        static max() {
            if (3 === arguments.length) {
                const t = arguments[1], e = arguments[2];
                let s = arguments[0];
                return t > s && (s = t), e > s && (s = e), s;
            }
            if (4 === arguments.length) {
                const t = arguments[1], e = arguments[2], s = arguments[3];
                let n = arguments[0];
                return t > n && (n = t), e > n && (n = e), s > n && (n = s), n;
            }
        }
    }
    z.LOG_10 = Math.log(10);
    class V {
        static pointToSegmentString(t, e) {
            if (0 === e.length) throw new n("Line array must contain at least one vertex");
            let s = t.distance(e[0]);
            for(let n = 0; n < e.length - 1; n++){
                const i = V.pointToSegment(t, e[n], e[n + 1]);
                i < s && (s = i);
            }
            return s;
        }
        static segmentToSegment(t, e, s, n) {
            if (t.equals(e)) return V.pointToSegment(t, s, n);
            if (s.equals(n)) return V.pointToSegment(n, t, e);
            let i = !1;
            if (O.intersects(t, e, s, n)) {
                const r = (e.x - t.x) * (n.y - s.y) - (e.y - t.y) * (n.x - s.x);
                if (0 === r) i = !0;
                else {
                    const o = (t.y - s.y) * (n.x - s.x) - (t.x - s.x) * (n.y - s.y), l = ((t.y - s.y) * (e.x - t.x) - (t.x - s.x) * (e.y - t.y)) / r, a = o / r;
                    (a < 0 || a > 1 || l < 0 || l > 1) && (i = !0);
                }
            } else i = !0;
            return i ? z.min(V.pointToSegment(t, s, n), V.pointToSegment(e, s, n), V.pointToSegment(s, t, e), V.pointToSegment(n, t, e)) : 0;
        }
        static pointToLinePerpendicular(t, e, s) {
            const n = (s.x - e.x) * (s.x - e.x) + (s.y - e.y) * (s.y - e.y), i = ((e.y - t.y) * (s.x - e.x) - (e.x - t.x) * (s.y - e.y)) / n;
            return Math.abs(i) * Math.sqrt(n);
        }
        static pointToSegment(t, e, s) {
            if (e.x === s.x && e.y === s.y) return t.distance(e);
            const n = (s.x - e.x) * (s.x - e.x) + (s.y - e.y) * (s.y - e.y), i = ((t.x - e.x) * (s.x - e.x) + (t.y - e.y) * (s.y - e.y)) / n;
            if (i <= 0) return t.distance(e);
            if (i >= 1) return t.distance(s);
            const r = ((e.y - t.y) * (s.x - e.x) - (e.x - t.x) * (s.y - e.y)) / n;
            return Math.abs(r) * Math.sqrt(n);
        }
    }
    class k {
        static ofLine(t) {
            const e = t.size();
            if (e <= 1) return 0;
            let s = 0;
            const n = new m;
            t.getCoordinate(0, n);
            let i = n.x, r = n.y;
            for(let o = 1; o < e; o++){
                t.getCoordinate(o, n);
                const e = n.x, l = n.y, a = e - i, c = l - r;
                s += Math.sqrt(a * a + c * c), i = e, r = l;
            }
            return s;
        }
    }
    class X {
        filter(t) {}
    }
    class U extends s {
        constructor(t){
            super(t), this.name = Object.keys({
                UnsupportedOperationException: U
            })[0];
        }
    }
    class H {
        static measures(t) {
            return t instanceof y ? 0 : t instanceof x || t instanceof E ? 1 : 0;
        }
        static create() {
            if (1 === arguments.length) {
                const t = arguments[0];
                return H.create(t, 0);
            }
            if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                return 2 === t ? new y : 3 === t && 0 === e ? new m : 3 === t && 1 === e ? new x : 4 === t && 1 === e ? new E : new m;
            }
        }
        static dimension(t) {
            return t instanceof y ? 2 : t instanceof x ? 3 : t instanceof E ? 4 : 3;
        }
    }
    class W {
        static scroll(t, e) {
            const s = W.indexOf(e, t);
            if (s < 0) return null;
            const n = new Array(t.length).fill(null);
            Y.arraycopy(t, s, n, 0, t.length - s), Y.arraycopy(t, 0, n, t.length - s, s), Y.arraycopy(n, 0, t, 0, t.length);
        }
        static removeRepeatedPoints(t) {
            if (!W.hasRepeatedPoints(t)) return t;
            return new R(t, !1).toCoordinateArray();
        }
        static reverse(t) {
            const e = t.length - 1, s = Math.trunc(e / 2);
            for(let n = 0; n <= s; n++){
                const s = t[n];
                t[n] = t[e - n], t[e - n] = s;
            }
        }
        static removeNull(t) {
            let e = 0;
            for(let s = 0; s < t.length; s++)null !== t[s] && e++;
            const s = new Array(e).fill(null);
            if (0 === e) return s;
            let n = 0;
            for(let e = 0; e < t.length; e++)null !== t[e] && (s[n++] = t[e]);
            return s;
        }
        static copyDeep() {
            if (1 === arguments.length) {
                const t = arguments[0], e = new Array(t.length).fill(null);
                for(let s = 0; s < t.length; s++)e[s] = t[s].copy();
                return e;
            }
            if (5 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = arguments[2], n = arguments[3], i = arguments[4];
                for(let r = 0; r < i; r++)s[n + r] = t[e + r].copy();
            }
        }
        static isEqualReversed(t, e) {
            for(let s = 0; s < t.length; s++){
                const n = t[s], i = e[t.length - s - 1];
                if (0 !== n.compareTo(i)) return !1;
            }
            return !0;
        }
        static envelope(t) {
            const e = new O;
            for(let s = 0; s < t.length; s++)e.expandToInclude(t[s]);
            return e;
        }
        static extract(t, e, s) {
            e = z.clamp(e, 0, t.length);
            let n = (s = z.clamp(s, -1, t.length)) - e + 1;
            s < 0 && (n = 0), e >= t.length && (n = 0), s < e && (n = 0);
            const i = new Array(n).fill(null);
            if (0 === n) return i;
            let r = 0;
            for(let n = e; n <= s; n++)i[r++] = t[n];
            return i;
        }
        static isRing(t) {
            return !(t.length < 4) && !!t[0].equals2D(t[t.length - 1]);
        }
        static ptNotInList(t, e) {
            for(let s = 0; s < t.length; s++){
                const n = t[s];
                if (W.indexOf(n, e) < 0) return n;
            }
            return null;
        }
        static equals() {
            if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                if (t === e) return !0;
                if (null === t || null === e) return !1;
                if (t.length !== e.length) return !1;
                for(let s = 0; s < t.length; s++)if (!t[s].equals(e[s])) return !1;
                return !0;
            }
            if (3 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = arguments[2];
                if (t === e) return !0;
                if (null === t || null === e) return !1;
                if (t.length !== e.length) return !1;
                for(let n = 0; n < t.length; n++)if (0 !== s.compare(t[n], e[n])) return !1;
                return !0;
            }
        }
        static intersection(t, e) {
            const s = new R;
            for(let n = 0; n < t.length; n++)e.intersects(t[n]) && s.add(t[n], !0);
            return s.toCoordinateArray();
        }
        static measures(t) {
            if (null === t || 0 === t.length) return 0;
            let e = 0;
            for (const s of t)e = Math.max(e, H.measures(s));
            return e;
        }
        static hasRepeatedPoints(t) {
            for(let e = 1; e < t.length; e++)if (t[e - 1].equals(t[e])) return !0;
            return !1;
        }
        static toCoordinateArray(t) {
            return t.toArray(W.coordArrayType);
        }
        static dimension(t) {
            if (null === t || 0 === t.length) return 3;
            let e = 0;
            for (const s of t)e = Math.max(e, H.dimension(s));
            return e;
        }
        static atLeastNCoordinatesOrNothing(t, e) {
            return e.length >= t ? e : [];
        }
        static indexOf(t, e) {
            for(let s = 0; s < e.length; s++)if (t.equals(e[s])) return s;
            return -1;
        }
        static increasingDirection(t) {
            for(let e = 0; e < Math.trunc(t.length / 2); e++){
                const s = t.length - 1 - e, n = t[e].compareTo(t[s]);
                if (0 !== n) return n;
            }
            return 1;
        }
        static compare(t, e) {
            let s = 0;
            for(; s < t.length && s < e.length;){
                const n = t[s].compareTo(e[s]);
                if (0 !== n) return n;
                s++;
            }
            return s < e.length ? -1 : s < t.length ? 1 : 0;
        }
        static minCoordinate(t) {
            let e = null;
            for(let s = 0; s < t.length; s++)(null === e || e.compareTo(t[s]) > 0) && (e = t[s]);
            return e;
        }
    }
    W.ForwardComparator = class {
        compare(t, e) {
            const s = t, n = e;
            return W.compare(s, n);
        }
        get interfaces_() {
            return [
                g
            ];
        }
    }, W.BidirectionalComparator = class {
        compare(t, e) {
            const s = t, n = e;
            if (s.length < n.length) return -1;
            if (s.length > n.length) return 1;
            if (0 === s.length) return 0;
            const i = W.compare(s, n);
            return W.isEqualReversed(s, n) ? 0 : i;
        }
        OLDcompare(t, e) {
            const s = t, n = e;
            if (s.length < n.length) return -1;
            if (s.length > n.length) return 1;
            if (0 === s.length) return 0;
            const i = W.increasingDirection(s), r = W.increasingDirection(n);
            let o = i > 0 ? 0 : s.length - 1, l = r > 0 ? 0 : s.length - 1;
            for(let t = 0; t < s.length; t++){
                const t = s[o].compareTo(n[l]);
                if (0 !== t) return t;
                o += i, l += r;
            }
            return 0;
        }
        get interfaces_() {
            return [
                g
            ];
        }
    }, W.coordArrayType = new Array(0).fill(null);
    class Z {
        static toDimensionSymbol(t) {
            switch(t){
                case Z.FALSE:
                    return Z.SYM_FALSE;
                case Z.TRUE:
                    return Z.SYM_TRUE;
                case Z.DONTCARE:
                    return Z.SYM_DONTCARE;
                case Z.P:
                    return Z.SYM_P;
                case Z.L:
                    return Z.SYM_L;
                case Z.A:
                    return Z.SYM_A;
            }
            throw new n("Unknown dimension value: " + t);
        }
        static toDimensionValue(t) {
            switch(b.toUpperCase(t)){
                case Z.SYM_FALSE:
                    return Z.FALSE;
                case Z.SYM_TRUE:
                    return Z.TRUE;
                case Z.SYM_DONTCARE:
                    return Z.DONTCARE;
                case Z.SYM_P:
                    return Z.P;
                case Z.SYM_L:
                    return Z.L;
                case Z.SYM_A:
                    return Z.A;
            }
            throw new n("Unknown dimension symbol: " + t);
        }
    }
    Z.P = 0, Z.L = 1, Z.A = 2, Z.FALSE = -1, Z.TRUE = -2, Z.DONTCARE = -3, Z.SYM_FALSE = "F", Z.SYM_TRUE = "T", Z.SYM_DONTCARE = "*", Z.SYM_P = "0", Z.SYM_L = "1", Z.SYM_A = "2";
    class j {
        constructor(){
            j.constructor_.apply(this, arguments);
        }
        isGeometryCollection() {
            return this.getTypeCode() === j.TYPECODE_GEOMETRYCOLLECTION;
        }
        getFactory() {
            return this._factory;
        }
        getGeometryN(t) {
            return this;
        }
        getArea() {
            return 0;
        }
        isRectangle() {
            return !1;
        }
        equalsExact(t) {
            return this === t || this.equalsExact(t, 0);
        }
        geometryChanged() {
            this.apply(j.geometryChangedFilter);
        }
        geometryChangedAction() {
            this._envelope = null;
        }
        equalsNorm(t) {
            return null !== t && this.norm().equalsExact(t.norm());
        }
        getLength() {
            return 0;
        }
        getNumGeometries() {
            return 1;
        }
        compareTo() {
            let t;
            if (1 === arguments.length) {
                const e = arguments[0];
                return t = e, this.getTypeCode() !== t.getTypeCode() ? this.getTypeCode() - t.getTypeCode() : this.isEmpty() && t.isEmpty() ? 0 : this.isEmpty() ? -1 : t.isEmpty() ? 1 : this.compareToSameClass(e);
            }
            if (2 === arguments.length) {
                const e = arguments[0], s = arguments[1];
                return t = e, this.getTypeCode() !== t.getTypeCode() ? this.getTypeCode() - t.getTypeCode() : this.isEmpty() && t.isEmpty() ? 0 : this.isEmpty() ? -1 : t.isEmpty() ? 1 : this.compareToSameClass(e, s);
            }
        }
        getUserData() {
            return this._userData;
        }
        getSRID() {
            return this._SRID;
        }
        getEnvelope() {
            return this.getFactory().toGeometry(this.getEnvelopeInternal());
        }
        static checkNotGeometryCollection(t) {
            if (t.getTypeCode() === j.TYPECODE_GEOMETRYCOLLECTION) throw new n("This method does not support GeometryCollection arguments");
        }
        equal(t, e, s) {
            return 0 === s ? t.equals(e) : t.distance(e) <= s;
        }
        norm() {
            const t = this.copy();
            return t.normalize(), t;
        }
        reverse() {
            const t = this.reverseInternal();
            return null != this.envelope && (t.envelope = this.envelope.copy()), t.setSRID(this.getSRID()), t;
        }
        copy() {
            const t = this.copyInternal();
            return t.envelope = null == this._envelope ? null : this._envelope.copy(), t._SRID = this._SRID, t._userData = this._userData, t;
        }
        getPrecisionModel() {
            return this._factory.getPrecisionModel();
        }
        getEnvelopeInternal() {
            return null === this._envelope && (this._envelope = this.computeEnvelopeInternal()), new O(this._envelope);
        }
        setSRID(t) {
            this._SRID = t;
        }
        setUserData(t) {
            this._userData = t;
        }
        compare(t, e) {
            const s = t.iterator(), n = e.iterator();
            for(; s.hasNext() && n.hasNext();){
                const t = s.next(), e = n.next(), i = t.compareTo(e);
                if (0 !== i) return i;
            }
            return s.hasNext() ? 1 : n.hasNext() ? -1 : 0;
        }
        hashCode() {
            return this.getEnvelopeInternal().hashCode();
        }
        isEquivalentClass(t) {
            return this.getTypeCode() == t.getTypeCode();
        }
        get interfaces_() {
            return [
                u,
                o,
                l
            ];
        }
        getClass() {
            return j;
        }
        static hasNonEmptyElements(t) {
            for(let e = 0; e < t.length; e++)if (!t[e].isEmpty()) return !0;
            return !1;
        }
        static hasNullElements(t) {
            for(let e = 0; e < t.length; e++)if (null === t[e]) return !0;
            return !1;
        }
    }
    j.constructor_ = function(t) {
        t && (this._envelope = null, this._userData = null, this._factory = t, this._SRID = t.getSRID());
    }, j.TYPECODE_POINT = 0, j.TYPECODE_MULTIPOINT = 1, j.TYPECODE_LINESTRING = 2, j.TYPECODE_LINEARRING = 3, j.TYPECODE_MULTILINESTRING = 4, j.TYPECODE_POLYGON = 5, j.TYPECODE_MULTIPOLYGON = 6, j.TYPECODE_GEOMETRYCOLLECTION = 7, j.TYPENAME_POINT = "Point", j.TYPENAME_MULTIPOINT = "MultiPoint", j.TYPENAME_LINESTRING = "LineString", j.TYPENAME_LINEARRING = "LinearRing", j.TYPENAME_MULTILINESTRING = "MultiLineString", j.TYPENAME_POLYGON = "Polygon", j.TYPENAME_MULTIPOLYGON = "MultiPolygon", j.TYPENAME_GEOMETRYCOLLECTION = "GeometryCollection", j.geometryChangedFilter = {
        get interfaces_ () {
            return [
                X
            ];
        },
        filter (t) {
            t.geometryChangedAction();
        }
    };
    class K {
        filter(t) {}
    }
    class Q {
    }
    class J {
        static scroll() {
            if (2 === arguments.length) {
                if (I(arguments[0], G) && Number.isInteger(arguments[1])) {
                    const t = arguments[0], e = arguments[1];
                    J.scroll(t, e, J.isRing(t));
                } else if (I(arguments[0], G) && arguments[1] instanceof m) {
                    const t = arguments[0], e = arguments[1], s = J.indexOf(e, t);
                    if (s <= 0) return null;
                    J.scroll(t, s);
                }
            } else if (3 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = arguments[2];
                if (e <= 0) return null;
                const n = t.copy(), i = s ? t.size() - 1 : t.size();
                for(let s = 0; s < i; s++)for(let r = 0; r < t.getDimension(); r++)t.setOrdinate(s, r, n.getOrdinate((e + s) % i, r));
                if (s) for(let e = 0; e < t.getDimension(); e++)t.setOrdinate(i, e, t.getOrdinate(0, e));
            }
        }
        static isEqual(t, e) {
            const s = t.size();
            if (s !== e.size()) return !1;
            const n = Math.min(t.getDimension(), e.getDimension());
            for(let i = 0; i < s; i++)for(let s = 0; s < n; s++){
                const n = t.getOrdinate(i, s), o = e.getOrdinate(i, s);
                if (t.getOrdinate(i, s) !== e.getOrdinate(i, s) && (!r.isNaN(n) || !r.isNaN(o))) return !1;
            }
            return !0;
        }
        static minCoordinateIndex() {
            if (1 === arguments.length) {
                const t = arguments[0];
                return J.minCoordinateIndex(t, 0, t.size() - 1);
            }
            if (3 === arguments.length) {
                const t = arguments[0], e = arguments[2];
                let s = -1, n = null;
                for(let i = arguments[1]; i <= e; i++){
                    const e = t.getCoordinate(i);
                    (null === n || n.compareTo(e) > 0) && (n = e, s = i);
                }
                return s;
            }
        }
        static extend(t, e, s) {
            const n = t.create(s, e.getDimension()), i = e.size();
            if (J.copy(e, 0, n, 0, i), i > 0) for(let t = i; t < s; t++)J.copy(e, i - 1, n, t, 1);
            return n;
        }
        static reverse(t) {
            const e = t.size() - 1, s = Math.trunc(e / 2);
            for(let n = 0; n <= s; n++)J.swap(t, n, e - n);
        }
        static ensureValidRing(t, e) {
            const s = e.size();
            if (0 === s) return e;
            if (s <= 3) return J.createClosedRing(t, e, 4);
            return e.getOrdinate(0, G.X) === e.getOrdinate(s - 1, G.X) && e.getOrdinate(0, G.Y) === e.getOrdinate(s - 1, G.Y) ? e : J.createClosedRing(t, e, s + 1);
        }
        static minCoordinate(t) {
            let e = null;
            for(let s = 0; s < t.size(); s++){
                const n = t.getCoordinate(s);
                (null === e || e.compareTo(n) > 0) && (e = n);
            }
            return e;
        }
        static copyCoord(t, e, s, n) {
            const i = Math.min(t.getDimension(), s.getDimension());
            for(let r = 0; r < i; r++)s.setOrdinate(n, r, t.getOrdinate(e, r));
        }
        static isRing(t) {
            const e = t.size();
            return 0 === e || !(e <= 3) && t.getOrdinate(0, G.X) === t.getOrdinate(e - 1, G.X) && t.getOrdinate(0, G.Y) === t.getOrdinate(e - 1, G.Y);
        }
        static swap(t, e, s) {
            if (e === s) return null;
            for(let n = 0; n < t.getDimension(); n++){
                const i = t.getOrdinate(e, n);
                t.setOrdinate(e, n, t.getOrdinate(s, n)), t.setOrdinate(s, n, i);
            }
        }
        static copy(t, e, s, n, i) {
            for(let r = 0; r < i; r++)J.copyCoord(t, e + r, s, n + r);
        }
        static indexOf(t, e) {
            for(let s = 0; s < e.size(); s++)if (t.x === e.getOrdinate(s, G.X) && t.y === e.getOrdinate(s, G.Y)) return s;
            return -1;
        }
        static createClosedRing(t, e, s) {
            const n = t.create(s, e.getDimension()), i = e.size();
            J.copy(e, 0, n, 0, i);
            for(let t = i; t < s; t++)J.copy(e, 0, n, t, 1);
            return n;
        }
    }
    class $ {
        filter(t) {}
    }
    class tt extends j {
        constructor(){
            super(), tt.constructor_.apply(this, arguments);
        }
        static constructor_() {
            if (this._points = null, 0 === arguments.length) ;
            else if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                j.constructor_.call(this, e), this.init(t);
            }
        }
        computeEnvelopeInternal() {
            return this.isEmpty() ? new O : this._points.expandEnvelope(new O);
        }
        isRing() {
            return this.isClosed() && W.isRing(this.getCoordinates());
        }
        getCoordinates() {
            return this._points.toCoordinateArray();
        }
        copyInternal() {
            return new tt(this._points.copy(), this._factory);
        }
        equalsExact() {
            if (2 === arguments.length && "number" == typeof arguments[1] && arguments[0] instanceof j) {
                const t = arguments[0], e = arguments[1];
                if (!this.isEquivalentClass(t)) return !1;
                const s = t;
                if (this._points.size() !== s._points.size()) return !1;
                for(let t = 0; t < this._points.size(); t++)if (!this.equal(this._points.getCoordinate(t), s._points.getCoordinate(t), e)) return !1;
                return !0;
            }
            return super.equalsExact.apply(this, arguments);
        }
        isClosed() {
            return !this.isEmpty() && this.getCoordinateN(0).equals2D(this.getCoordinateN(this.getNumPoints() - 1));
        }
        reverseInternal() {
            const t = this._points.copy();
            return J.reverse(t), this.getFactory().createLineString(t);
        }
        getEndPoint() {
            return this.isEmpty() ? null : this.getPointN(this.getNumPoints() - 1);
        }
        getTypeCode() {
            return j.TYPECODE_LINESTRING;
        }
        getDimension() {
            return 1;
        }
        getBoundary() {
            throw new U;
        }
        isEquivalentClass(t) {
            return t instanceof tt;
        }
        getCoordinateSequence() {
            return this._points;
        }
        getPointN(t) {
            return this.getFactory().createPoint(this._points.getCoordinate(t));
        }
        normalize() {
            for(let t = 0; t < Math.trunc(this._points.size() / 2); t++){
                const e = this._points.size() - 1 - t;
                if (!this._points.getCoordinate(t).equals(this._points.getCoordinate(e))) {
                    if (this._points.getCoordinate(t).compareTo(this._points.getCoordinate(e)) > 0) {
                        const t = this._points.copy();
                        J.reverse(t), this._points = t;
                    }
                    return null;
                }
            }
        }
        getCoordinate() {
            return this.isEmpty() ? null : this._points.getCoordinate(0);
        }
        getBoundaryDimension() {
            return this.isClosed() ? Z.FALSE : 0;
        }
        getLength() {
            return k.ofLine(this._points);
        }
        getNumPoints() {
            return this._points.size();
        }
        compareToSameClass() {
            if (1 === arguments.length) {
                const t = arguments[0];
                let e = 0, s = 0;
                for(; e < this._points.size() && s < t._points.size();){
                    const n = this._points.getCoordinate(e).compareTo(t._points.getCoordinate(s));
                    if (0 !== n) return n;
                    e++, s++;
                }
                return e < this._points.size() ? 1 : s < t._points.size() ? -1 : 0;
            }
            if (2 === arguments.length) {
                const t = arguments[0];
                return arguments[1].compare(this._points, t._points);
            }
        }
        apply() {
            if (I(arguments[0], K)) {
                const t = arguments[0];
                for(let e = 0; e < this._points.size(); e++)t.filter(this._points.getCoordinate(e));
            } else if (I(arguments[0], P)) {
                const t = arguments[0];
                if (0 === this._points.size()) return null;
                for(let e = 0; e < this._points.size() && (t.filter(this._points, e), !t.isDone()); e++);
                t.isGeometryChanged() && this.geometryChanged();
            } else if (I(arguments[0], $)) arguments[0].filter(this);
            else if (I(arguments[0], X)) arguments[0].filter(this);
        }
        getCoordinateN(t) {
            return this._points.getCoordinate(t);
        }
        getGeometryType() {
            return j.TYPENAME_LINESTRING;
        }
        isEmpty() {
            return 0 === this._points.size();
        }
        init(t) {
            if (null === t && (t = this.getFactory().getCoordinateSequenceFactory().create([])), 1 === t.size()) throw new n("Invalid number of points in LineString (found " + t.size() + " - must be 0 or >= 2)");
            this._points = t;
        }
        isCoordinate(t) {
            for(let e = 0; e < this._points.size(); e++)if (this._points.getCoordinate(e).equals(t)) return !0;
            return !1;
        }
        getStartPoint() {
            return this.isEmpty() ? null : this.getPointN(0);
        }
        get interfaces_() {
            return [
                Q
            ];
        }
    }
    class et extends tt {
        constructor(){
            super(), et.constructor_.apply(this, arguments);
        }
        static constructor_() {
            const t = arguments[0], e = arguments[1];
            tt.constructor_.call(this, t, e), this.validateConstruction();
        }
        copyInternal() {
            return new et(this._points.copy(), this._factory);
        }
        getBoundaryDimension() {
            return Z.FALSE;
        }
        isClosed() {
            return !!this.isEmpty() || super.isClosed.call(this);
        }
        reverseInternal() {
            const t = this._points.copy();
            return J.reverse(t), this.getFactory().createLinearRing(t);
        }
        getTypeCode() {
            return j.TYPECODE_LINEARRING;
        }
        validateConstruction() {
            if (!this.isEmpty() && !super.isClosed.call(this)) throw new n("Points of LinearRing do not form a closed linestring");
            if (this.getCoordinateSequence().size() >= 1 && this.getCoordinateSequence().size() < et.MINIMUM_VALID_SIZE) throw new n("Invalid number of points in LinearRing (found " + this.getCoordinateSequence().size() + " - must be 0 or >= 4)");
        }
        getGeometryType() {
            return j.TYPENAME_LINEARRING;
        }
    }
    et.MINIMUM_VALID_SIZE = 4;
    class st {
        create() {
            if (1 === arguments.length) arguments[0] instanceof Array || I(arguments[0], G);
            else if (2 === arguments.length) ;
            else if (3 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                return this.create(t, e);
            }
        }
    }
    class nt {
        constructor(t){
            this.str = t;
        }
        append(t) {
            this.str += t;
        }
        setCharAt(t, e) {
            this.str = this.str.substr(0, t) + e + this.str.substr(t + 1);
        }
        toString() {
            return this.str;
        }
    }
    class it {
        constructor(){
            it.constructor_.apply(this, arguments);
        }
        static constructor_() {
            if (this._dimension = 3, this._measures = 0, this._coordinates = null, 1 === arguments.length) {
                if (arguments[0] instanceof Array) {
                    const t = arguments[0];
                    it.constructor_.call(this, t, W.dimension(t), W.measures(t));
                } else if (Number.isInteger(arguments[0])) {
                    const t = arguments[0];
                    this._coordinates = new Array(t).fill(null);
                    for(let e = 0; e < t; e++)this._coordinates[e] = new m;
                } else if (I(arguments[0], G)) {
                    const t = arguments[0];
                    if (null === t) return this._coordinates = new Array(0).fill(null), null;
                    this._dimension = t.getDimension(), this._measures = t.getMeasures(), this._coordinates = new Array(t.size()).fill(null);
                    for(let e = 0; e < this._coordinates.length; e++)this._coordinates[e] = t.getCoordinateCopy(e);
                }
            } else if (2 === arguments.length) {
                if (arguments[0] instanceof Array && Number.isInteger(arguments[1])) {
                    const t = arguments[0], e = arguments[1];
                    it.constructor_.call(this, t, e, W.measures(t));
                } else if (Number.isInteger(arguments[0]) && Number.isInteger(arguments[1])) {
                    const t = arguments[0], e = arguments[1];
                    this._coordinates = new Array(t).fill(null), this._dimension = e;
                    for(let s = 0; s < t; s++)this._coordinates[s] = H.create(e);
                }
            } else if (3 === arguments.length) {
                if (Number.isInteger(arguments[2]) && arguments[0] instanceof Array && Number.isInteger(arguments[1])) {
                    const t = arguments[0], e = arguments[1], s = arguments[2];
                    this._dimension = e, this._measures = s, this._coordinates = null === t ? new Array(0).fill(null) : t;
                } else if (Number.isInteger(arguments[2]) && Number.isInteger(arguments[0]) && Number.isInteger(arguments[1])) {
                    const t = arguments[0], e = arguments[1], s = arguments[2];
                    this._coordinates = new Array(t).fill(null), this._dimension = e, this._measures = s;
                    for(let e = 0; e < t; e++)this._coordinates[e] = this.createCoordinate();
                }
            }
        }
        getCoordinate() {
            if (1 === arguments.length) {
                const t = arguments[0];
                return this._coordinates[t];
            }
            if (2 === arguments.length) {
                const t = arguments[0];
                arguments[1].setCoordinate(this._coordinates[t]);
            }
        }
        getCoordinateCopy(t) {
            const e = this.createCoordinate();
            return e.setCoordinate(this._coordinates[t]), e;
        }
        createCoordinate() {
            return H.create(this.getDimension(), this.getMeasures());
        }
        getDimension() {
            return this._dimension;
        }
        getX(t) {
            return this._coordinates[t].x;
        }
        getMeasures() {
            return this._measures;
        }
        expandEnvelope(t) {
            for(let e = 0; e < this._coordinates.length; e++)t.expandToInclude(this._coordinates[e]);
            return t;
        }
        copy() {
            const t = new Array(this.size()).fill(null);
            for(let e = 0; e < this._coordinates.length; e++){
                const s = this.createCoordinate();
                s.setCoordinate(this._coordinates[e]), t[e] = s;
            }
            return new it(t, this._dimension, this._measures);
        }
        toString() {
            if (this._coordinates.length > 0) {
                const t = new nt(17 * this._coordinates.length);
                t.append("("), t.append(this._coordinates[0]);
                for(let e = 1; e < this._coordinates.length; e++)t.append(", "), t.append(this._coordinates[e]);
                return t.append(")"), t.toString();
            }
            return "()";
        }
        getY(t) {
            return this._coordinates[t].y;
        }
        toCoordinateArray() {
            return this._coordinates;
        }
        getM(t) {
            return this.hasM() ? this._coordinates[t].getM() : r.NaN;
        }
        setOrdinate(t, e, s) {
            switch(e){
                case G.X:
                    this._coordinates[t].x = s;
                    break;
                case G.Y:
                    this._coordinates[t].y = s;
                    break;
                default:
                    this._coordinates[t].setOrdinate(e, s);
            }
        }
        getZ(t) {
            return this.hasZ() ? this._coordinates[t].getZ() : r.NaN;
        }
        size() {
            return this._coordinates.length;
        }
        getOrdinate(t, e) {
            switch(e){
                case G.X:
                    return this._coordinates[t].x;
                case G.Y:
                    return this._coordinates[t].y;
                default:
                    return this._coordinates[t].getOrdinate(e);
            }
        }
        get interfaces_() {
            return [
                G,
                l
            ];
        }
    }
    class rt {
        static instance() {
            return rt.instanceObject;
        }
        readResolve() {
            return rt.instance();
        }
        create() {
            if (1 === arguments.length) {
                if (arguments[0] instanceof Array) return new it(arguments[0]);
                if (I(arguments[0], G)) return new it(arguments[0]);
            } else {
                if (2 === arguments.length) {
                    let t = arguments[1];
                    return t > 3 && (t = 3), t < 2 && (t = 2), new it(arguments[0], t);
                }
                if (3 === arguments.length) {
                    let t = arguments[2], e = arguments[1] - t;
                    return t > 1 && (t = 1), e > 3 && (e = 3), e < 2 && (e = 2), new it(arguments[0], e + t, t);
                }
            }
        }
        get interfaces_() {
            return [
                st,
                l
            ];
        }
    }
    rt.instanceObject = new rt;
    class ot extends N {
        contains() {}
    }
    class lt extends ot {
    }
    class at extends lt {
        constructor(t){
            super(), this.array = [], t instanceof N && this.addAll(t);
        }
        contains(t) {
            for (const e of this.array)if (0 === e.compareTo(t)) return !0;
            return !1;
        }
        add(t) {
            if (this.contains(t)) return !1;
            for(let e = 0, s = this.array.length; e < s; e++){
                if (1 === this.array[e].compareTo(t)) return !!this.array.splice(e, 0, t);
            }
            return this.array.push(t), !0;
        }
        addAll(t) {
            for (const e of t)this.add(e);
            return !0;
        }
        remove() {
            throw new U;
        }
        size() {
            return this.array.length;
        }
        isEmpty() {
            return 0 === this.array.length;
        }
        toArray() {
            return this.array.slice();
        }
        iterator() {
            return new ct(this.array);
        }
    }
    let ct = class {
        constructor(t){
            this.array = t, this.position = 0;
        }
        next() {
            if (this.position === this.array.length) throw new S;
            return this.array[this.position++];
        }
        hasNext() {
            return this.position < this.array.length;
        }
        remove() {
            throw new U;
        }
    };
    class ht {
        static sort() {
            const t = arguments[0];
            if (1 === arguments.length) t.sort((t, e)=>t.compareTo(e));
            else if (2 === arguments.length) t.sort((t, e)=>arguments[1].compare(t, e));
            else if (3 === arguments.length) {
                const e = t.slice(arguments[1], arguments[2]);
                e.sort();
                const s = t.slice(0, arguments[1]).concat(e, t.slice(arguments[2], t.length));
                t.splice(0, t.length);
                for (const e of s)t.push(e);
            } else if (4 === arguments.length) {
                const e = t.slice(arguments[1], arguments[2]);
                e.sort((t, e)=>arguments[3].compare(t, e));
                const s = t.slice(0, arguments[1]).concat(e, t.slice(arguments[2], t.length));
                t.splice(0, t.length);
                for (const e of s)t.push(e);
            }
        }
        static asList(t) {
            const e = new L;
            for (const s of t)e.add(s);
            return e;
        }
        static copyOf(t, e) {
            return t.slice(0, e);
        }
    }
    class ut extends j {
        constructor(){
            super(), ut.constructor_.apply(this, arguments);
        }
        static constructor_() {
            if (this._geometries = null, 0 === arguments.length) ;
            else if (2 === arguments.length) {
                let t = arguments[0], e = arguments[1];
                if (j.constructor_.call(this, e), null === t && (t = []), j.hasNullElements(t)) throw new n("geometries must not contain null elements");
                this._geometries = t;
            }
        }
        computeEnvelopeInternal() {
            const t = new O;
            for(let e = 0; e < this._geometries.length; e++)t.expandToInclude(this._geometries[e].getEnvelopeInternal());
            return t;
        }
        getGeometryN(t) {
            return this._geometries[t];
        }
        getCoordinates() {
            const t = new Array(this.getNumPoints()).fill(null);
            let e = -1;
            for(let s = 0; s < this._geometries.length; s++){
                const n = this._geometries[s].getCoordinates();
                for(let s = 0; s < n.length; s++)e++, t[e] = n[s];
            }
            return t;
        }
        getArea() {
            let t = 0;
            for(let e = 0; e < this._geometries.length; e++)t += this._geometries[e].getArea();
            return t;
        }
        copyInternal() {
            const t = new Array(this._geometries.length).fill(null);
            for(let e = 0; e < t.length; e++)t[e] = this._geometries[e].copy();
            return new ut(t, this._factory);
        }
        equalsExact() {
            if (2 === arguments.length && "number" == typeof arguments[1] && arguments[0] instanceof j) {
                const t = arguments[0], e = arguments[1];
                if (!this.isEquivalentClass(t)) return !1;
                const s = t;
                if (this._geometries.length !== s._geometries.length) return !1;
                for(let t = 0; t < this._geometries.length; t++)if (!this._geometries[t].equalsExact(s._geometries[t], e)) return !1;
                return !0;
            }
            return super.equalsExact.apply(this, arguments);
        }
        reverseInternal() {
            const t = this._geometries.length, e = new L(t);
            for(let s = 0; s < t; s++)e.add(this._geometries[s].reverse());
            return this.getFactory().buildGeometry(e);
        }
        getTypeCode() {
            return j.TYPECODE_GEOMETRYCOLLECTION;
        }
        getDimension() {
            let t = Z.FALSE;
            for(let e = 0; e < this._geometries.length; e++)t = Math.max(t, this._geometries[e].getDimension());
            return t;
        }
        getNumGeometries() {
            return this._geometries.length;
        }
        getBoundary() {
            return j.checkNotGeometryCollection(this), h.shouldNeverReachHere(), null;
        }
        getGeometryType() {
            return j.TYPENAME_GEOMETRYCOLLECTION;
        }
        isEmpty() {
            for(let t = 0; t < this._geometries.length; t++)if (!this._geometries[t].isEmpty()) return !1;
            return !0;
        }
        normalize() {
            for(let t = 0; t < this._geometries.length; t++)this._geometries[t].normalize();
            ht.sort(this._geometries);
        }
        getCoordinate() {
            return this.isEmpty() ? null : this._geometries[0].getCoordinate();
        }
        getBoundaryDimension() {
            let t = Z.FALSE;
            for(let e = 0; e < this._geometries.length; e++)t = Math.max(t, this._geometries[e].getBoundaryDimension());
            return t;
        }
        getLength() {
            let t = 0;
            for(let e = 0; e < this._geometries.length; e++)t += this._geometries[e].getLength();
            return t;
        }
        getNumPoints() {
            let t = 0;
            for(let e = 0; e < this._geometries.length; e++)t += this._geometries[e].getNumPoints();
            return t;
        }
        compareToSameClass() {
            if (1 === arguments.length) {
                const t = arguments[0], e = new at(ht.asList(this._geometries)), s = new at(ht.asList(t._geometries));
                return this.compare(e, s);
            }
            if (2 === arguments.length) {
                const t = arguments[1], e = arguments[0], s = this.getNumGeometries(), n = e.getNumGeometries();
                let i = 0;
                for(; i < s && i < n;){
                    const s = this.getGeometryN(i), n = e.getGeometryN(i), r = s.compareToSameClass(n, t);
                    if (0 !== r) return r;
                    i++;
                }
                return i < s ? 1 : i < n ? -1 : 0;
            }
        }
        apply() {
            if (I(arguments[0], K)) {
                const t = arguments[0];
                for(let e = 0; e < this._geometries.length; e++)this._geometries[e].apply(t);
            } else if (I(arguments[0], P)) {
                const t = arguments[0];
                if (0 === this._geometries.length) return null;
                for(let e = 0; e < this._geometries.length && (this._geometries[e].apply(t), !t.isDone()); e++);
                t.isGeometryChanged() && this.geometryChanged();
            } else if (I(arguments[0], $)) {
                const t = arguments[0];
                t.filter(this);
                for(let e = 0; e < this._geometries.length; e++)this._geometries[e].apply(t);
            } else if (I(arguments[0], X)) {
                const t = arguments[0];
                t.filter(this);
                for(let e = 0; e < this._geometries.length; e++)this._geometries[e].apply(t);
            }
        }
    }
    class gt {
    }
    class dt extends ut {
        constructor(){
            super(), dt.constructor_.apply(this, arguments);
        }
        static constructor_() {
            const t = arguments[0], e = arguments[1];
            ut.constructor_.call(this, t, e);
        }
        copyInternal() {
            const t = new Array(this._geometries.length).fill(null);
            for(let e = 0; e < t.length; e++)t[e] = this._geometries[e].copy();
            return new dt(t, this._factory);
        }
        equalsExact() {
            if (2 === arguments.length && "number" == typeof arguments[1] && arguments[0] instanceof j) {
                const t = arguments[0], e = arguments[1];
                return !!this.isEquivalentClass(t) && super.equalsExact.call(this, t, e);
            }
            return super.equalsExact.apply(this, arguments);
        }
        getBoundaryDimension() {
            return 1;
        }
        getTypeCode() {
            return j.TYPECODE_MULTIPOLYGON;
        }
        getDimension() {
            return 2;
        }
        getBoundary() {
            if (this.isEmpty()) return this.getFactory().createMultiLineString();
            const t = new L;
            for(let e = 0; e < this._geometries.length; e++){
                const s = this._geometries[e].getBoundary();
                for(let e = 0; e < s.getNumGeometries(); e++)t.add(s.getGeometryN(e));
            }
            const e = new Array(t.size()).fill(null);
            return this.getFactory().createMultiLineString(t.toArray(e));
        }
        getGeometryType() {
            return j.TYPENAME_MULTIPOLYGON;
        }
        get interfaces_() {
            return [
                gt
            ];
        }
    }
    let _t = class {
        get() {}
        put() {}
        size() {}
        values() {}
        entrySet() {}
    };
    class pt extends ot {
        constructor(t){
            super(), this.map = new Map, t instanceof N && this.addAll(t);
        }
        contains(t) {
            const e = t.hashCode ? t.hashCode() : t;
            return !!this.map.has(e);
        }
        add(t) {
            const e = t.hashCode ? t.hashCode() : t;
            return !this.map.has(e) && !!this.map.set(e, t);
        }
        addAll(t) {
            for (const e of t)this.add(e);
            return !0;
        }
        remove() {
            throw new U;
        }
        size() {
            return this.map.size;
        }
        isEmpty() {
            return 0 === this.map.size;
        }
        toArray() {
            return Array.from(this.map.values());
        }
        iterator() {
            return new mt(this.map);
        }
        [Symbol.iterator]() {
            return this.map;
        }
    }
    let mt = class {
        constructor(t){
            this.iterator = t.values();
            const { done: e, value: s } = this.iterator.next();
            this.done = e, this.value = s;
        }
        next() {
            if (this.done) throw new S;
            const t = this.value, { done: e, value: s } = this.iterator.next();
            return this.done = e, this.value = s, t;
        }
        hasNext() {
            return !this.done;
        }
        remove() {
            throw new U;
        }
    };
    class ft extends _t {
        constructor(){
            super(), this.map = new Map;
        }
        get(t) {
            return this.map.get(t) || null;
        }
        put(t, e) {
            return this.map.set(t, e), e;
        }
        values() {
            const t = new L, e = this.map.values();
            let s = e.next();
            for(; !s.done;)t.add(s.value), s = e.next();
            return t;
        }
        entrySet() {
            const t = new pt;
            return this.map.entries().forEach((e)=>t.add(e)), t;
        }
        size() {
            return this.map.size();
        }
    }
    class yt {
        constructor(){
            yt.constructor_.apply(this, arguments);
        }
        static constructor_() {
            if (this._modelType = null, this._scale = null, 0 === arguments.length) this._modelType = yt.FLOATING;
            else if (1 === arguments.length) {
                if (arguments[0] instanceof xt) {
                    const t = arguments[0];
                    this._modelType = t, t === yt.FIXED && this.setScale(1);
                } else if ("number" == typeof arguments[0]) {
                    const t = arguments[0];
                    this._modelType = yt.FIXED, this.setScale(t);
                } else if (arguments[0] instanceof yt) {
                    const t = arguments[0];
                    this._modelType = t._modelType, this._scale = t._scale;
                }
            }
        }
        static mostPrecise(t, e) {
            return t.compareTo(e) >= 0 ? t : e;
        }
        equals(t) {
            if (!(t instanceof yt)) return !1;
            const e = t;
            return this._modelType === e._modelType && this._scale === e._scale;
        }
        compareTo(t) {
            const e = t, s = this.getMaximumSignificantDigits(), n = e.getMaximumSignificantDigits();
            return M.compare(s, n);
        }
        getType() {
            return this._modelType;
        }
        toString() {
            let t = "UNKNOWN";
            return this._modelType === yt.FLOATING ? t = "Floating" : this._modelType === yt.FLOATING_SINGLE ? t = "Floating-Single" : this._modelType === yt.FIXED && (t = "Fixed (Scale=" + this.getScale() + ")"), t;
        }
        makePrecise() {
            if ("number" == typeof arguments[0]) {
                const t = arguments[0];
                if (r.isNaN(t)) return t;
                if (this._modelType === yt.FLOATING_SINGLE) return t;
                return this._modelType === yt.FIXED ? Math.round(t * this._scale) / this._scale : t;
            }
            if (arguments[0] instanceof m) {
                const t = arguments[0];
                if (this._modelType === yt.FLOATING) return null;
                t.x = this.makePrecise(t.x), t.y = this.makePrecise(t.y);
            }
        }
        getMaximumSignificantDigits() {
            let t = 16;
            return this._modelType === yt.FLOATING ? t = 16 : this._modelType === yt.FLOATING_SINGLE ? t = 6 : this._modelType === yt.FIXED && (t = 1 + Math.trunc(Math.ceil(Math.log(this.getScale()) / Math.log(10)))), t;
        }
        setScale(t) {
            this._scale = Math.abs(t);
        }
        getScale() {
            return this._scale;
        }
        isFloating() {
            return this._modelType === yt.FLOATING || this._modelType === yt.FLOATING_SINGLE;
        }
        get interfaces_() {
            return [
                l,
                o
            ];
        }
    }
    class xt {
        constructor(){
            xt.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._name = null;
            const t = arguments[0];
            this._name = t, xt.nameToTypeMap.put(t, this);
        }
        readResolve() {
            return xt.nameToTypeMap.get(this._name);
        }
        toString() {
            return this._name;
        }
        get interfaces_() {
            return [
                l
            ];
        }
    }
    xt.nameToTypeMap = new ft, yt.Type = xt, yt.FIXED = new xt("FIXED"), yt.FLOATING = new xt("FLOATING"), yt.FLOATING_SINGLE = new xt("FLOATING SINGLE"), yt.maximumPreciseValue = 9007199254740992;
    class Et extends ut {
        constructor(){
            super(), Et.constructor_.apply(this, arguments);
        }
        static constructor_() {
            const t = arguments[0], e = arguments[1];
            ut.constructor_.call(this, t, e);
        }
        copyInternal() {
            const t = new Array(this._geometries.length).fill(null);
            for(let e = 0; e < t.length; e++)t[e] = this._geometries[e].copy();
            return new Et(t, this._factory);
        }
        equalsExact() {
            if (2 === arguments.length && "number" == typeof arguments[1] && arguments[0] instanceof j) {
                const t = arguments[0], e = arguments[1];
                return !!this.isEquivalentClass(t) && super.equalsExact.call(this, t, e);
            }
            return super.equalsExact.apply(this, arguments);
        }
        getBoundaryDimension() {
            return this.isClosed() ? Z.FALSE : 0;
        }
        isClosed() {
            if (this.isEmpty()) return !1;
            for(let t = 0; t < this._geometries.length; t++)if (!this._geometries[t].isClosed()) return !1;
            return !0;
        }
        getTypeCode() {
            return j.TYPECODE_MULTILINESTRING;
        }
        getDimension() {
            return 1;
        }
        getBoundary() {
            throw new U;
        }
        getGeometryType() {
            return j.TYPENAME_MULTILINESTRING;
        }
        get interfaces_() {
            return [
                Q
            ];
        }
    }
    class It {
    }
    class Nt extends j {
        constructor(){
            super(), Nt.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._coordinates = null;
            const t = arguments[0], e = arguments[1];
            j.constructor_.call(this, e), this.init(t);
        }
        computeEnvelopeInternal() {
            if (this.isEmpty()) return new O;
            const t = new O;
            return t.expandToInclude(this._coordinates.getX(0), this._coordinates.getY(0)), t;
        }
        getCoordinates() {
            return this.isEmpty() ? [] : [
                this.getCoordinate()
            ];
        }
        copyInternal() {
            return new Nt(this._coordinates.copy(), this._factory);
        }
        equalsExact() {
            if (2 === arguments.length && "number" == typeof arguments[1] && arguments[0] instanceof j) {
                const t = arguments[0], e = arguments[1];
                return !!this.isEquivalentClass(t) && (!(!this.isEmpty() || !t.isEmpty()) || this.isEmpty() === t.isEmpty() && this.equal(t.getCoordinate(), this.getCoordinate(), e));
            }
            return super.equalsExact.apply(this, arguments);
        }
        reverseInternal() {
            return this.getFactory().createPoint(this._coordinates.copy());
        }
        getTypeCode() {
            return j.TYPECODE_POINT;
        }
        getDimension() {
            return 0;
        }
        getNumPoints() {
            return this.isEmpty() ? 0 : 1;
        }
        getX() {
            if (null === this.getCoordinate()) throw new D("getX called on empty Point");
            return this.getCoordinate().x;
        }
        getBoundary() {
            return this.getFactory().createGeometryCollection();
        }
        getGeometryType() {
            return j.TYPENAME_POINT;
        }
        getCoordinateSequence() {
            return this._coordinates;
        }
        getY() {
            if (null === this.getCoordinate()) throw new D("getY called on empty Point");
            return this.getCoordinate().y;
        }
        isSimple() {
            return !0;
        }
        normalize() {}
        getCoordinate() {
            return 0 !== this._coordinates.size() ? this._coordinates.getCoordinate(0) : null;
        }
        getBoundaryDimension() {
            return Z.FALSE;
        }
        compareToSameClass() {
            if (1 === arguments.length) {
                const t = arguments[0];
                return this.getCoordinate().compareTo(t.getCoordinate());
            }
            if (2 === arguments.length) {
                const t = arguments[0];
                return arguments[1].compare(this._coordinates, t._coordinates);
            }
        }
        apply() {
            if (I(arguments[0], K)) {
                const t = arguments[0];
                if (this.isEmpty()) return null;
                t.filter(this.getCoordinate());
            } else if (I(arguments[0], P)) {
                const t = arguments[0];
                if (this.isEmpty()) return null;
                t.filter(this._coordinates, 0), t.isGeometryChanged() && this.geometryChanged();
            } else if (I(arguments[0], $)) arguments[0].filter(this);
            else if (I(arguments[0], X)) arguments[0].filter(this);
        }
        isEmpty() {
            return 0 === this._coordinates.size();
        }
        init(t) {
            null === t && (t = this.getFactory().getCoordinateSequenceFactory().create([])), h.isTrue(t.size() <= 1), this._coordinates = t;
        }
        get interfaces_() {
            return [
                It
            ];
        }
    }
    class wt {
        static ofRingSigned() {
            if (arguments[0] instanceof Array) {
                const t = arguments[0];
                if (t.length < 3) return 0;
                let e = 0;
                const s = t[0].x;
                for(let n = 1; n < t.length - 1; n++){
                    const i = t[n].x - s, r = t[n + 1].y;
                    e += i * (t[n - 1].y - r);
                }
                return e / 2;
            }
            if (I(arguments[0], G)) {
                const t = arguments[0], e = t.size();
                if (e < 3) return 0;
                const s = new m, n = new m, i = new m;
                t.getCoordinate(0, n), t.getCoordinate(1, i);
                const r = n.x;
                i.x -= r;
                let o = 0;
                for(let l = 1; l < e - 1; l++)s.y = n.y, n.x = i.x, n.y = i.y, t.getCoordinate(l + 1, i), i.x -= r, o += n.x * (s.y - i.y);
                return o / 2;
            }
        }
        static ofRing() {
            if (arguments[0] instanceof Array) {
                const t = arguments[0];
                return Math.abs(wt.ofRingSigned(t));
            }
            if (I(arguments[0], G)) {
                const t = arguments[0];
                return Math.abs(wt.ofRingSigned(t));
            }
        }
    }
    class Ct extends j {
        constructor(){
            super(), Ct.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._shell = null, this._holes = null;
            let t = arguments[0], e = arguments[1], s = arguments[2];
            if (j.constructor_.call(this, s), null === t && (t = this.getFactory().createLinearRing()), null === e && (e = []), j.hasNullElements(e)) throw new n("holes must not contain null elements");
            if (t.isEmpty() && j.hasNonEmptyElements(e)) throw new n("shell is empty but holes are not");
            this._shell = t, this._holes = e;
        }
        computeEnvelopeInternal() {
            return this._shell.getEnvelopeInternal();
        }
        getCoordinates() {
            if (this.isEmpty()) return [];
            const t = new Array(this.getNumPoints()).fill(null);
            let e = -1;
            const s = this._shell.getCoordinates();
            for(let n = 0; n < s.length; n++)e++, t[e] = s[n];
            for(let s = 0; s < this._holes.length; s++){
                const n = this._holes[s].getCoordinates();
                for(let s = 0; s < n.length; s++)e++, t[e] = n[s];
            }
            return t;
        }
        getArea() {
            let t = 0;
            t += wt.ofRing(this._shell.getCoordinateSequence());
            for(let e = 0; e < this._holes.length; e++)t -= wt.ofRing(this._holes[e].getCoordinateSequence());
            return t;
        }
        equalsExact() {
            if (2 === arguments.length && "number" == typeof arguments[1] && arguments[0] instanceof j) {
                const t = arguments[0], e = arguments[1];
                if (!this.isEquivalentClass(t)) return !1;
                const s = t, n = this._shell, i = s._shell;
                if (!n.equalsExact(i, e)) return !1;
                if (this._holes.length !== s._holes.length) return !1;
                for(let t = 0; t < this._holes.length; t++)if (!this._holes[t].equalsExact(s._holes[t], e)) return !1;
                return !0;
            }
            return super.equalsExact.apply(this, arguments);
        }
        reverseInternal() {
            const t = this.getExteriorRing().reverse(), e = new Array(this.getNumInteriorRing()).fill(null);
            for(let t = 0; t < e.length; t++)e[t] = this.getInteriorRingN(t).reverse();
            return this.getFactory().createPolygon(t, e);
        }
        getTypeCode() {
            return j.TYPECODE_POLYGON;
        }
        getDimension() {
            return 2;
        }
        getBoundary() {
            if (this.isEmpty()) return this.getFactory().createMultiLineString();
            const t = new Array(this._holes.length + 1).fill(null);
            t[0] = this._shell;
            for(let e = 0; e < this._holes.length; e++)t[e + 1] = this._holes[e];
            return t.length <= 1 ? this.getFactory().createLinearRing(t[0].getCoordinateSequence()) : this.getFactory().createMultiLineString(t);
        }
        getGeometryType() {
            return j.TYPENAME_POLYGON;
        }
        getExteriorRing() {
            return this._shell;
        }
        copyInternal() {
            const t = this._shell.copy(), e = new Array(this._holes.length).fill(null);
            for(let t = 0; t < this._holes.length; t++)e[t] = this._holes[t].copy();
            return new Ct(t, e, this._factory);
        }
        isRectangle() {
            if (0 !== this.getNumInteriorRing()) return !1;
            if (null === this._shell) return !1;
            if (5 !== this._shell.getNumPoints()) return !1;
            const t = this._shell.getCoordinateSequence(), e = this.getEnvelopeInternal();
            for(let s = 0; s < 5; s++){
                const n = t.getX(s);
                if (n !== e.getMinX() && n !== e.getMaxX()) return !1;
                const i = t.getY(s);
                if (i !== e.getMinY() && i !== e.getMaxY()) return !1;
            }
            let s = t.getX(0), n = t.getY(0);
            for(let e = 1; e <= 4; e++){
                const i = t.getX(e), r = t.getY(e);
                if (i !== s === (r !== n)) return !1;
                s = i, n = r;
            }
            return !0;
        }
        normalize() {
            if (0 === arguments.length) {
                this._shell = this.normalized(this._shell, !0);
                for(let t = 0; t < this._holes.length; t++)this._holes[t] = this.normalized(this._holes[t], !1);
                ht.sort(this._holes);
            } else if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                if (t.isEmpty()) return null;
                const s = t.getCoordinateSequence(), n = J.minCoordinateIndex(s, 0, s.size() - 2);
                J.scroll(s, n, !0), q.isCCW(s) === e && J.reverse(s);
            }
        }
        getCoordinate() {
            return this._shell.getCoordinate();
        }
        getNumInteriorRing() {
            return this._holes.length;
        }
        getBoundaryDimension() {
            return 1;
        }
        getLength() {
            let t = 0;
            t += this._shell.getLength();
            for(let e = 0; e < this._holes.length; e++)t += this._holes[e].getLength();
            return t;
        }
        getNumPoints() {
            let t = this._shell.getNumPoints();
            for(let e = 0; e < this._holes.length; e++)t += this._holes[e].getNumPoints();
            return t;
        }
        convexHull() {
            return this.getExteriorRing().convexHull();
        }
        normalized(t, e) {
            const s = t.copy();
            return this.normalize(s, e), s;
        }
        compareToSameClass() {
            if (1 === arguments.length) {
                const t = arguments[0], e = this._shell, s = t._shell;
                return e.compareToSameClass(s);
            }
            if (2 === arguments.length) {
                const t = arguments[1], e = arguments[0], s = this._shell, n = e._shell, i = s.compareToSameClass(n, t);
                if (0 !== i) return i;
                const r = this.getNumInteriorRing(), o = e.getNumInteriorRing();
                let l = 0;
                for(; l < r && l < o;){
                    const s = this.getInteriorRingN(l), n = e.getInteriorRingN(l), i = s.compareToSameClass(n, t);
                    if (0 !== i) return i;
                    l++;
                }
                return l < r ? 1 : l < o ? -1 : 0;
            }
        }
        apply() {
            if (I(arguments[0], K)) {
                const t = arguments[0];
                this._shell.apply(t);
                for(let e = 0; e < this._holes.length; e++)this._holes[e].apply(t);
            } else if (I(arguments[0], P)) {
                const t = arguments[0];
                if (this._shell.apply(t), !t.isDone()) for(let e = 0; e < this._holes.length && (this._holes[e].apply(t), !t.isDone()); e++);
                t.isGeometryChanged() && this.geometryChanged();
            } else if (I(arguments[0], $)) arguments[0].filter(this);
            else if (I(arguments[0], X)) {
                const t = arguments[0];
                t.filter(this), this._shell.apply(t);
                for(let e = 0; e < this._holes.length; e++)this._holes[e].apply(t);
            }
        }
        isEmpty() {
            return this._shell.isEmpty();
        }
        getInteriorRingN(t) {
            return this._holes[t];
        }
        get interfaces_() {
            return [
                gt
            ];
        }
    }
    class St extends ut {
        constructor(){
            super(), St.constructor_.apply(this, arguments);
        }
        static constructor_() {
            const t = arguments[0], e = arguments[1];
            ut.constructor_.call(this, t, e);
        }
        equalsExact() {
            if (2 === arguments.length && "number" == typeof arguments[1] && arguments[0] instanceof j) {
                const t = arguments[0], e = arguments[1];
                return !!this.isEquivalentClass(t) && super.equalsExact.call(this, t, e);
            }
            return super.equalsExact.apply(this, arguments);
        }
        getTypeCode() {
            return j.TYPECODE_MULTIPOINT;
        }
        getDimension() {
            return 0;
        }
        getBoundary() {
            return this.getFactory().createGeometryCollection();
        }
        getGeometryType() {
            return j.TYPENAME_MULTIPOINT;
        }
        copyInternal() {
            const t = new Array(this._geometries.length).fill(null);
            for(let e = 0; e < t.length; e++)t[e] = this._geometries[e].copy();
            return new St(t, this._factory);
        }
        isValid() {
            return !0;
        }
        getCoordinate() {
            if (1 === arguments.length && Number.isInteger(arguments[0])) {
                const t = arguments[0];
                return this._geometries[t].getCoordinate();
            }
            return super.getCoordinate.apply(this, arguments);
        }
        getBoundaryDimension() {
            return Z.FALSE;
        }
        get interfaces_() {
            return [
                It
            ];
        }
    }
    class Lt {
        constructor(){
            Lt.constructor_.apply(this, arguments);
        }
        static constructor_() {
            if (this._precisionModel = null, this._coordinateSequenceFactory = null, this._SRID = null, 0 === arguments.length) Lt.constructor_.call(this, new yt, 0);
            else if (1 === arguments.length) {
                if (I(arguments[0], st)) {
                    const t = arguments[0];
                    Lt.constructor_.call(this, new yt, 0, t);
                } else if (arguments[0] instanceof yt) {
                    const t = arguments[0];
                    Lt.constructor_.call(this, t, 0, Lt.getDefaultCoordinateSequenceFactory());
                }
            } else if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                Lt.constructor_.call(this, t, e, Lt.getDefaultCoordinateSequenceFactory());
            } else if (3 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = arguments[2];
                this._precisionModel = t, this._coordinateSequenceFactory = s, this._SRID = e;
            }
        }
        static toMultiPolygonArray(t) {
            const e = new Array(t.size()).fill(null);
            return t.toArray(e);
        }
        static toGeometryArray(t) {
            if (null === t) return null;
            const e = new Array(t.size()).fill(null);
            return t.toArray(e);
        }
        static getDefaultCoordinateSequenceFactory() {
            return rt.instance();
        }
        static toMultiLineStringArray(t) {
            const e = new Array(t.size()).fill(null);
            return t.toArray(e);
        }
        static toLineStringArray(t) {
            const e = new Array(t.size()).fill(null);
            return t.toArray(e);
        }
        static toMultiPointArray(t) {
            const e = new Array(t.size()).fill(null);
            return t.toArray(e);
        }
        static toLinearRingArray(t) {
            const e = new Array(t.size()).fill(null);
            return t.toArray(e);
        }
        static toPointArray(t) {
            const e = new Array(t.size()).fill(null);
            return t.toArray(e);
        }
        static toPolygonArray(t) {
            const e = new Array(t.size()).fill(null);
            return t.toArray(e);
        }
        static createPointFromInternalCoord(t, e) {
            return e.getPrecisionModel().makePrecise(t), e.getFactory().createPoint(t);
        }
        createEmpty(t) {
            switch(t){
                case -1:
                    return this.createGeometryCollection();
                case 0:
                    return this.createPoint();
                case 1:
                    return this.createLineString();
                case 2:
                    return this.createPolygon();
                default:
                    throw new n("Invalid dimension: " + t);
            }
        }
        toGeometry(t) {
            return t.isNull() ? this.createPoint() : t.getMinX() === t.getMaxX() && t.getMinY() === t.getMaxY() ? this.createPoint(new m(t.getMinX(), t.getMinY())) : t.getMinX() === t.getMaxX() || t.getMinY() === t.getMaxY() ? this.createLineString([
                new m(t.getMinX(), t.getMinY()),
                new m(t.getMaxX(), t.getMaxY())
            ]) : this.createPolygon(this.createLinearRing([
                new m(t.getMinX(), t.getMinY()),
                new m(t.getMinX(), t.getMaxY()),
                new m(t.getMaxX(), t.getMaxY()),
                new m(t.getMaxX(), t.getMinY()),
                new m(t.getMinX(), t.getMinY())
            ]), null);
        }
        createLineString() {
            if (0 === arguments.length) return this.createLineString(this.getCoordinateSequenceFactory().create([]));
            if (1 === arguments.length) {
                if (arguments[0] instanceof Array) {
                    const t = arguments[0];
                    return this.createLineString(null !== t ? this.getCoordinateSequenceFactory().create(t) : null);
                }
                if (I(arguments[0], G)) return new tt(arguments[0], this);
            }
        }
        createMultiLineString() {
            if (0 === arguments.length) return new Et(null, this);
            if (1 === arguments.length) return new Et(arguments[0], this);
        }
        createPolygon() {
            if (0 === arguments.length) return this.createPolygon(null, null);
            if (1 === arguments.length) {
                if (I(arguments[0], G)) {
                    const t = arguments[0];
                    return this.createPolygon(this.createLinearRing(t));
                }
                if (arguments[0] instanceof Array) {
                    const t = arguments[0];
                    return this.createPolygon(this.createLinearRing(t));
                }
                if (arguments[0] instanceof et) {
                    const t = arguments[0];
                    return this.createPolygon(t, null);
                }
            } else if (2 === arguments.length) return new Ct(arguments[0], arguments[1], this);
        }
        getSRID() {
            return this._SRID;
        }
        createGeometryCollection() {
            if (0 === arguments.length) return new ut(null, this);
            if (1 === arguments.length) return new ut(arguments[0], this);
        }
        getPrecisionModel() {
            return this._precisionModel;
        }
        createLinearRing() {
            if (0 === arguments.length) return this.createLinearRing(this.getCoordinateSequenceFactory().create([]));
            if (1 === arguments.length) {
                if (arguments[0] instanceof Array) {
                    const t = arguments[0];
                    return this.createLinearRing(null !== t ? this.getCoordinateSequenceFactory().create(t) : null);
                }
                if (I(arguments[0], G)) return new et(arguments[0], this);
            }
        }
        createMultiPolygon() {
            if (0 === arguments.length) return new dt(null, this);
            if (1 === arguments.length) return new dt(arguments[0], this);
        }
        createMultiPoint() {
            if (0 === arguments.length) return new St(null, this);
            if (1 === arguments.length) {
                if (arguments[0] instanceof Array) return new St(arguments[0], this);
                if (I(arguments[0], G)) {
                    const t = arguments[0];
                    if (null === t) return this.createMultiPoint(new Array(0).fill(null));
                    const e = new Array(t.size()).fill(null);
                    for(let s = 0; s < t.size(); s++){
                        const n = this.getCoordinateSequenceFactory().create(1, t.getDimension(), t.getMeasures());
                        J.copy(t, s, n, 0, 1), e[s] = this.createPoint(n);
                    }
                    return this.createMultiPoint(e);
                }
            }
        }
        buildGeometry(t) {
            let e = null, s = !1, n = !1;
            for(let i = t.iterator(); i.hasNext();){
                const t = i.next(), r = t.getTypeCode();
                null === e && (e = r), r !== e && (s = !0), t instanceof ut && (n = !0);
            }
            if (null === e) return this.createGeometryCollection();
            if (s || n) return this.createGeometryCollection(Lt.toGeometryArray(t));
            const i = t.iterator().next();
            if (t.size() > 1) {
                if (i instanceof Ct) return this.createMultiPolygon(Lt.toPolygonArray(t));
                if (i instanceof tt) return this.createMultiLineString(Lt.toLineStringArray(t));
                if (i instanceof Nt) return this.createMultiPoint(Lt.toPointArray(t));
                h.shouldNeverReachHere("Unhandled geometry type: " + i.getGeometryType());
            }
            return i;
        }
        createMultiPointFromCoords(t) {
            return this.createMultiPoint(null !== t ? this.getCoordinateSequenceFactory().create(t) : null);
        }
        createPoint() {
            if (0 === arguments.length) return this.createPoint(this.getCoordinateSequenceFactory().create([]));
            if (1 === arguments.length) {
                if (arguments[0] instanceof m) {
                    const t = arguments[0];
                    return this.createPoint(null !== t ? this.getCoordinateSequenceFactory().create([
                        t
                    ]) : null);
                }
                if (I(arguments[0], G)) return new Nt(arguments[0], this);
            }
        }
        getCoordinateSequenceFactory() {
            return this._coordinateSequenceFactory;
        }
        get interfaces_() {
            return [
                l
            ];
        }
    }
    const Tt = "XY", Rt = "XYZ", Pt = "XYM", Ot = "XYZM", vt = {
        POINT: "Point",
        LINE_STRING: "LineString",
        LINEAR_RING: "LinearRing",
        POLYGON: "Polygon",
        MULTI_POINT: "MultiPoint",
        MULTI_LINE_STRING: "MultiLineString",
        MULTI_POLYGON: "MultiPolygon",
        GEOMETRY_COLLECTION: "GeometryCollection",
        CIRCLE: "Circle"
    }, Mt = "EMPTY", bt = 1, Dt = 2, At = 3, Ft = 4, Gt = 5, qt = 6;
    for(const t in vt)vt[t].toUpperCase();
    class Bt {
        constructor(t){
            this.wkt = t, this.index_ = -1;
        }
        isAlpha_(t) {
            return t >= "a" && t <= "z" || t >= "A" && t <= "Z";
        }
        isNumeric_(t, e) {
            return t >= "0" && t <= "9" || "." == t && !(void 0 !== e && e);
        }
        isWhiteSpace_(t) {
            return " " == t || "\t" == t || "\r" == t || "\n" == t;
        }
        nextChar_() {
            return this.wkt.charAt(++this.index_);
        }
        nextToken() {
            const t = this.nextChar_(), e = this.index_;
            let s, n = t;
            if ("(" == t) s = Dt;
            else if ("," == t) s = Gt;
            else if (")" == t) s = At;
            else if (this.isNumeric_(t) || "-" == t) s = Ft, n = this.readNumber_();
            else if (this.isAlpha_(t)) s = bt, n = this.readText_();
            else {
                if (this.isWhiteSpace_(t)) return this.nextToken();
                if ("" !== t) throw new Error("Unexpected character: " + t);
                s = qt;
            }
            return {
                position: e,
                value: n,
                type: s
            };
        }
        readNumber_() {
            let t;
            const e = this.index_;
            let s = !1, n = !1;
            do "." == t ? s = !0 : "e" != t && "E" != t || (n = !0), t = this.nextChar_();
            while (this.isNumeric_(t, s) || !n && ("e" == t || "E" == t) || n && ("-" == t || "+" == t));
            return parseFloat(this.wkt.substring(e, this.index_--));
        }
        readText_() {
            let t;
            const e = this.index_;
            do t = this.nextChar_();
            while (this.isAlpha_(t));
            return this.wkt.substring(e, this.index_--).toUpperCase();
        }
    }
    class Yt {
        constructor(t, e){
            this.lexer_ = t, this.token_, this.layout_ = Tt, this.factory = e;
        }
        consume_() {
            this.token_ = this.lexer_.nextToken();
        }
        isTokenType(t) {
            return this.token_.type == t;
        }
        match(t) {
            const e = this.isTokenType(t);
            return e && this.consume_(), e;
        }
        parse() {
            this.consume_();
            return this.parseGeometry_();
        }
        parseGeometryLayout_() {
            let t = Tt;
            const e = this.token_;
            if (this.isTokenType(bt)) {
                const s = e.value;
                "Z" === s ? t = Rt : "M" === s ? t = Pt : "ZM" === s && (t = Ot), t !== Tt && this.consume_();
            }
            return t;
        }
        parseGeometryCollectionText_() {
            if (this.match(Dt)) {
                const t = [];
                do t.push(this.parseGeometry_());
                while (this.match(Gt));
                if (this.match(At)) return t;
            } else if (this.isEmptyGeometry_()) return [];
            throw new Error(this.formatErrorMessage_());
        }
        parsePointText_() {
            if (this.match(Dt)) {
                const t = this.parsePoint_();
                if (this.match(At)) return t;
            } else if (this.isEmptyGeometry_()) return null;
            throw new Error(this.formatErrorMessage_());
        }
        parseLineStringText_() {
            if (this.match(Dt)) {
                const t = this.parsePointList_();
                if (this.match(At)) return t;
            } else if (this.isEmptyGeometry_()) return [];
            throw new Error(this.formatErrorMessage_());
        }
        parsePolygonText_() {
            if (this.match(Dt)) {
                const t = this.parseLineStringTextList_();
                if (this.match(At)) return t;
            } else if (this.isEmptyGeometry_()) return [];
            throw new Error(this.formatErrorMessage_());
        }
        parseMultiPointText_() {
            if (this.match(Dt)) {
                let t;
                if (t = this.token_.type == Dt ? this.parsePointTextList_() : this.parsePointList_(), this.match(At)) return t;
            } else if (this.isEmptyGeometry_()) return [];
            throw new Error(this.formatErrorMessage_());
        }
        parseMultiLineStringText_() {
            if (this.match(Dt)) {
                const t = this.parseLineStringTextList_();
                if (this.match(At)) return t;
            } else if (this.isEmptyGeometry_()) return [];
            throw new Error(this.formatErrorMessage_());
        }
        parseMultiPolygonText_() {
            if (this.match(Dt)) {
                const t = this.parsePolygonTextList_();
                if (this.match(At)) return t;
            } else if (this.isEmptyGeometry_()) return [];
            throw new Error(this.formatErrorMessage_());
        }
        parsePoint_() {
            const t = [], e = this.layout_.length;
            for(let s = 0; s < e; ++s){
                const e = this.token_;
                if (!this.match(Ft)) break;
                t.push(e.value);
            }
            if (t.length == e) return t;
            throw new Error(this.formatErrorMessage_());
        }
        parsePointList_() {
            const t = [
                this.parsePoint_()
            ];
            for(; this.match(Gt);)t.push(this.parsePoint_());
            return t;
        }
        parsePointTextList_() {
            const t = [
                this.parsePointText_()
            ];
            for(; this.match(Gt);)t.push(this.parsePointText_());
            return t;
        }
        parseLineStringTextList_() {
            const t = [
                this.parseLineStringText_()
            ];
            for(; this.match(Gt);)t.push(this.parseLineStringText_());
            return t;
        }
        parsePolygonTextList_() {
            const t = [
                this.parsePolygonText_()
            ];
            for(; this.match(Gt);)t.push(this.parsePolygonText_());
            return t;
        }
        isEmptyGeometry_() {
            const t = this.isTokenType(bt) && this.token_.value == Mt;
            return t && this.consume_(), t;
        }
        formatErrorMessage_() {
            return "Unexpected `" + this.token_.value + "` at position " + this.token_.position + " in `" + this.lexer_.wkt + "`";
        }
        parseGeometry_() {
            const t = this.factory, e = (t)=>t ? new m(...t) : new m, s = (s)=>{
                const n = s.map((s)=>t.createLinearRing(s.map(e)));
                return n.length > 1 ? t.createPolygon(n[0], n.slice(1)) : 1 === n.length ? t.createPolygon(n[0]) : t.createPolygon();
            }, n = this.token_;
            if (this.match(bt)) {
                const i = n.value;
                if (this.layout_ = this.parseGeometryLayout_(), "GEOMETRYCOLLECTION" == i) {
                    const e = this.parseGeometryCollectionText_();
                    return t.createGeometryCollection(e);
                }
                switch(i){
                    case "POINT":
                        {
                            const e = this.parsePointText_();
                            return e ? t.createPoint(new m(...e)) : t.createPoint();
                        }
                    case "LINESTRING":
                        {
                            const s = this.parseLineStringText_().map(e);
                            return t.createLineString(s);
                        }
                    case "LINEARRING":
                        {
                            const s = this.parseLineStringText_().map(e);
                            return t.createLinearRing(s);
                        }
                    case "POLYGON":
                        {
                            const e = this.parsePolygonText_();
                            return e && 0 !== e.length ? s(e) : t.createPolygon();
                        }
                    case "MULTIPOINT":
                        {
                            const s = this.parseMultiPointText_();
                            if (!s || 0 === s.length) return t.createMultiPoint();
                            const n = s.map(e).map((e)=>t.createPoint(e));
                            return t.createMultiPoint(n);
                        }
                    case "MULTILINESTRING":
                        {
                            const s = this.parseMultiLineStringText_().map((s)=>t.createLineString(s.map(e)));
                            return t.createMultiLineString(s);
                        }
                    case "MULTIPOLYGON":
                        {
                            const e = this.parseMultiPolygonText_();
                            if (!e || 0 === e.length) return t.createMultiPolygon();
                            const n = e.map(s);
                            return t.createMultiPolygon(n);
                        }
                    default:
                        throw new Error("Invalid geometry type: " + i);
                }
            }
            throw new Error(this.formatErrorMessage_());
        }
    }
    function zt(t) {
        if (t.isEmpty()) return "";
        const e = t.getCoordinate(), s = [
            e.x,
            e.y
        ];
        return void 0 === e.z || Number.isNaN(e.z) || s.push(e.z), void 0 === e.m || Number.isNaN(e.m) || s.push(e.m), s.join(" ");
    }
    function Vt(t) {
        const e = t.getCoordinates().map((t)=>{
            const e = [
                t.x,
                t.y
            ];
            return void 0 === t.z || Number.isNaN(t.z) || e.push(t.z), void 0 === t.m || Number.isNaN(t.m) || e.push(t.m), e;
        }), s = [];
        for(let t = 0, n = e.length; t < n; ++t)s.push(e[t].join(" "));
        return s.join(", ");
    }
    function kt(t) {
        const e = [];
        e.push("(" + Vt(t.getExteriorRing()) + ")");
        for(let s = 0, n = t.getNumInteriorRing(); s < n; ++s)e.push("(" + Vt(t.getInteriorRingN(s)) + ")");
        return e.join(", ");
    }
    const Xt = {
        Point: zt,
        LineString: Vt,
        LinearRing: Vt,
        Polygon: kt,
        MultiPoint: function(t) {
            const e = [];
            for(let s = 0, n = t.getNumGeometries(); s < n; ++s)e.push("(" + zt(t.getGeometryN(s)) + ")");
            return e.join(", ");
        },
        MultiLineString: function(t) {
            const e = [];
            for(let s = 0, n = t.getNumGeometries(); s < n; ++s)e.push("(" + Vt(t.getGeometryN(s)) + ")");
            return e.join(", ");
        },
        MultiPolygon: function(t) {
            const e = [];
            for(let s = 0, n = t.getNumGeometries(); s < n; ++s)e.push("(" + kt(t.getGeometryN(s)) + ")");
            return e.join(", ");
        },
        GeometryCollection: function(t) {
            const e = [];
            for(let s = 0, n = t.getNumGeometries(); s < n; ++s)e.push(Ut(t.getGeometryN(s)));
            return e.join(", ");
        }
    };
    function Ut(t) {
        let e = t.getGeometryType();
        const s = Xt[e];
        e = e.toUpperCase();
        const n = function(t) {
            let e = "";
            if (t.isEmpty()) return e;
            const s = t.getCoordinate();
            return void 0 === s.z || Number.isNaN(s.z) || (e += "Z"), void 0 === s.m || Number.isNaN(s.m) || (e += "M"), e;
        }(t);
        if (n.length > 0 && (e += " " + n), t.isEmpty()) return e + " " + Mt;
        return e + " (" + s(t) + ")";
    }
    class Ht {
        constructor(t){
            this.geometryFactory = t || new Lt, this.precisionModel = this.geometryFactory.getPrecisionModel();
        }
        read(t) {
            const e = new Bt(t);
            return new Yt(e, this.geometryFactory).parse();
        }
        write(t) {
            return Ut(t);
        }
    }
    class Wt {
        constructor(t){
            this.parser = new Ht(t);
        }
        write(t) {
            return this.parser.write(t);
        }
        static toLineString(t, e) {
            if (2 !== arguments.length) throw new Error("Not implemented");
            return "LINESTRING ( " + t.x + " " + t.y + ", " + e.x + " " + e.y + " )";
        }
    }
    class Zt {
        constructor(){
            Zt.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._result = null, this._inputLines = Array(2).fill().map(()=>Array(2)), this._intPt = new Array(2).fill(null), this._intLineIndex = null, this._isProper = null, this._pa = null, this._pb = null, this._precisionModel = null, this._intPt[0] = new m, this._intPt[1] = new m, this._pa = this._intPt[0], this._pb = this._intPt[1], this._result = 0;
        }
        static nonRobustComputeEdgeDistance(t, e, s) {
            const n = t.x - e.x, i = t.y - e.y, r = Math.sqrt(n * n + i * i);
            return h.isTrue(!(0 === r && !t.equals(e)), "Invalid distance calculation"), r;
        }
        static computeEdgeDistance(t, e, s) {
            const n = Math.abs(s.x - e.x), i = Math.abs(s.y - e.y);
            let r = -1;
            if (t.equals(e)) r = 0;
            else if (t.equals(s)) r = n > i ? n : i;
            else {
                const s = Math.abs(t.x - e.x), o = Math.abs(t.y - e.y);
                r = n > i ? s : o, 0 !== r || t.equals(e) || (r = Math.max(s, o));
            }
            return h.isTrue(!(0 === r && !t.equals(e)), "Bad distance calculation"), r;
        }
        computeIntersection(t, e, s, n) {
            this._inputLines[0][0] = t, this._inputLines[0][1] = e, this._inputLines[1][0] = s, this._inputLines[1][1] = n, this._result = this.computeIntersect(t, e, s, n);
        }
        getIntersectionNum() {
            return this._result;
        }
        computeIntLineIndex() {
            if (0 === arguments.length) null === this._intLineIndex && (this._intLineIndex = Array(2).fill().map(()=>Array(2)), this.computeIntLineIndex(0), this.computeIntLineIndex(1));
            else if (1 === arguments.length) {
                const t = arguments[0];
                this.getEdgeDistance(t, 0) > this.getEdgeDistance(t, 1) ? (this._intLineIndex[t][0] = 0, this._intLineIndex[t][1] = 1) : (this._intLineIndex[t][0] = 1, this._intLineIndex[t][1] = 0);
            }
        }
        isInteriorIntersection() {
            if (0 === arguments.length) return !!this.isInteriorIntersection(0) || !!this.isInteriorIntersection(1);
            if (1 === arguments.length) {
                const t = arguments[0];
                for(let e = 0; e < this._result; e++)if (!this._intPt[e].equals2D(this._inputLines[t][0]) && !this._intPt[e].equals2D(this._inputLines[t][1])) return !0;
                return !1;
            }
        }
        getIntersection(t) {
            return this._intPt[t];
        }
        getEdgeDistance(t, e) {
            return Zt.computeEdgeDistance(this._intPt[e], this._inputLines[t][0], this._inputLines[t][1]);
        }
        isCollinear() {
            return this._result === Zt.COLLINEAR_INTERSECTION;
        }
        toString() {
            return Wt.toLineString(this._inputLines[0][0], this._inputLines[0][1]) + " - " + Wt.toLineString(this._inputLines[1][0], this._inputLines[1][1]) + this.getTopologySummary();
        }
        getEndpoint(t, e) {
            return this._inputLines[t][e];
        }
        getIndexAlongSegment(t, e) {
            return this.computeIntLineIndex(), this._intLineIndex[t][e];
        }
        getTopologySummary() {
            const t = new nt;
            return this.isEndPoint() && t.append(" endpoint"), this._isProper && t.append(" proper"), this.isCollinear() && t.append(" collinear"), t.toString();
        }
        isProper() {
            return this.hasIntersection() && this._isProper;
        }
        setPrecisionModel(t) {
            this._precisionModel = t;
        }
        isEndPoint() {
            return this.hasIntersection() && !this._isProper;
        }
        hasIntersection() {
            return this._result !== Zt.NO_INTERSECTION;
        }
        isIntersection(t) {
            for(let e = 0; e < this._result; e++)if (this._intPt[e].equals2D(t)) return !0;
            return !1;
        }
        getIntersectionAlongSegment(t, e) {
            return this.computeIntLineIndex(), this._intPt[this._intLineIndex[t][e]];
        }
    }
    Zt.DONT_INTERSECT = 0, Zt.DO_INTERSECT = 1, Zt.COLLINEAR = 2, Zt.NO_INTERSECTION = 0, Zt.POINT_INTERSECTION = 1, Zt.COLLINEAR_INTERSECTION = 2;
    class jt extends Zt {
        constructor(){
            super();
        }
        static nearestEndpoint(t, e, s, n) {
            let i = t, r = V.pointToSegment(t, s, n), o = V.pointToSegment(e, s, n);
            return o < r && (r = o, i = e), o = V.pointToSegment(s, t, e), o < r && (r = o, i = s), o = V.pointToSegment(n, t, e), o < r && (r = o, i = n), i;
        }
        isInSegmentEnvelopes(t) {
            const e = new O(this._inputLines[0][0], this._inputLines[0][1]), s = new O(this._inputLines[1][0], this._inputLines[1][1]);
            return e.contains(t) && s.contains(t);
        }
        computeIntersection() {
            if (3 !== arguments.length) return super.computeIntersection.apply(this, arguments);
            {
                const t = arguments[0], e = arguments[1], s = arguments[2];
                if (this._isProper = !1, O.intersects(e, s, t) && 0 === q.index(e, s, t) && 0 === q.index(s, e, t)) return this._isProper = !0, (t.equals(e) || t.equals(s)) && (this._isProper = !1), this._result = Zt.POINT_INTERSECTION, null;
                this._result = Zt.NO_INTERSECTION;
            }
        }
        intersection(t, e, s, n) {
            let i = this.intersectionSafe(t, e, s, n);
            return this.isInSegmentEnvelopes(i) || (i = new m(jt.nearestEndpoint(t, e, s, n))), null !== this._precisionModel && this._precisionModel.makePrecise(i), i;
        }
        checkDD(t, e, s, n, i) {
            const r = F.intersection(t, e, s, n), o = this.isInSegmentEnvelopes(r);
            Y.out.println("DD in env = " + o + "  --------------------- " + r), i.distance(r) > 1e-4 && Y.out.println("Distance = " + i.distance(r));
        }
        intersectionSafe(t, e, s, n) {
            let i = B.intersection(t, e, s, n);
            return null === i && (i = jt.nearestEndpoint(t, e, s, n)), i;
        }
        computeCollinearIntersection(t, e, s, n) {
            const i = O.intersects(t, e, s), r = O.intersects(t, e, n), o = O.intersects(s, n, t), l = O.intersects(s, n, e);
            return i && r ? (this._intPt[0] = s, this._intPt[1] = n, Zt.COLLINEAR_INTERSECTION) : o && l ? (this._intPt[0] = t, this._intPt[1] = e, Zt.COLLINEAR_INTERSECTION) : i && o ? (this._intPt[0] = s, this._intPt[1] = t, !s.equals(t) || r || l ? Zt.COLLINEAR_INTERSECTION : Zt.POINT_INTERSECTION) : i && l ? (this._intPt[0] = s, this._intPt[1] = e, !s.equals(e) || r || o ? Zt.COLLINEAR_INTERSECTION : Zt.POINT_INTERSECTION) : r && o ? (this._intPt[0] = n, this._intPt[1] = t, !n.equals(t) || i || l ? Zt.COLLINEAR_INTERSECTION : Zt.POINT_INTERSECTION) : r && l ? (this._intPt[0] = n, this._intPt[1] = e, !n.equals(e) || i || o ? Zt.COLLINEAR_INTERSECTION : Zt.POINT_INTERSECTION) : Zt.NO_INTERSECTION;
        }
        computeIntersect(t, e, s, n) {
            if (this._isProper = !1, !O.intersects(t, e, s, n)) return Zt.NO_INTERSECTION;
            const i = q.index(t, e, s), r = q.index(t, e, n);
            if (i > 0 && r > 0 || i < 0 && r < 0) return Zt.NO_INTERSECTION;
            const o = q.index(s, n, t), l = q.index(s, n, e);
            if (o > 0 && l > 0 || o < 0 && l < 0) return Zt.NO_INTERSECTION;
            return 0 === i && 0 === r && 0 === o && 0 === l ? this.computeCollinearIntersection(t, e, s, n) : (0 === i || 0 === r || 0 === o || 0 === l ? (this._isProper = !1, t.equals2D(s) || t.equals2D(n) ? this._intPt[0] = t : e.equals2D(s) || e.equals2D(n) ? this._intPt[0] = e : 0 === i ? this._intPt[0] = new m(s) : 0 === r ? this._intPt[0] = new m(n) : 0 === o ? this._intPt[0] = new m(t) : 0 === l && (this._intPt[0] = new m(e))) : (this._isProper = !0, this._intPt[0] = this.intersection(t, e, s, n)), Zt.POINT_INTERSECTION);
        }
    }
    class Kt {
        constructor(){
            Kt.constructor_.apply(this, arguments);
        }
        static constructor_() {
            if (this.p0 = null, this.p1 = null, 0 === arguments.length) Kt.constructor_.call(this, new m, new m);
            else if (1 === arguments.length) {
                const t = arguments[0];
                Kt.constructor_.call(this, t.p0, t.p1);
            } else if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                this.p0 = t, this.p1 = e;
            } else if (4 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = arguments[2], n = arguments[3];
                Kt.constructor_.call(this, new m(t, e), new m(s, n));
            }
        }
        static midPoint(t, e) {
            return new m((t.x + e.x) / 2, (t.y + e.y) / 2);
        }
        minX() {
            return Math.min(this.p0.x, this.p1.x);
        }
        orientationIndex() {
            if (arguments[0] instanceof Kt) {
                const t = arguments[0], e = q.index(this.p0, this.p1, t.p0), s = q.index(this.p0, this.p1, t.p1);
                return e >= 0 && s >= 0 || e <= 0 && s <= 0 ? Math.max(e, s) : 0;
            }
            if (arguments[0] instanceof m) {
                const t = arguments[0];
                return q.index(this.p0, this.p1, t);
            }
        }
        toGeometry(t) {
            return t.createLineString([
                this.p0,
                this.p1
            ]);
        }
        isVertical() {
            return this.p0.x === this.p1.x;
        }
        minY() {
            return Math.min(this.p0.y, this.p1.y);
        }
        midPoint() {
            return Kt.midPoint(this.p0, this.p1);
        }
        maxY() {
            return Math.max(this.p0.y, this.p1.y);
        }
        pointAlongOffset(t, e) {
            const s = this.p0.x + t * (this.p1.x - this.p0.x), n = this.p0.y + t * (this.p1.y - this.p0.y), i = this.p1.x - this.p0.x, r = this.p1.y - this.p0.y, o = Math.sqrt(i * i + r * r);
            let l = 0, a = 0;
            if (0 !== e) {
                if (o <= 0) throw new D("Cannot compute offset from zero-length line segment");
                l = e * i / o, a = e * r / o;
            }
            return new m(s - a, n + l);
        }
        setCoordinates() {
            if (1 === arguments.length) {
                const t = arguments[0];
                this.setCoordinates(t.p0, t.p1);
            } else if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                this.p0.x = t.x, this.p0.y = t.y, this.p1.x = e.x, this.p1.y = e.y;
            }
        }
        segmentFraction(t) {
            let e = this.projectionFactor(t);
            return e < 0 ? e = 0 : (e > 1 || r.isNaN(e)) && (e = 1), e;
        }
        toString() {
            return "LINESTRING( " + this.p0.x + " " + this.p0.y + ", " + this.p1.x + " " + this.p1.y + ")";
        }
        distance() {
            if (arguments[0] instanceof Kt) {
                const t = arguments[0];
                return V.segmentToSegment(this.p0, this.p1, t.p0, t.p1);
            }
            if (arguments[0] instanceof m) {
                const t = arguments[0];
                return V.pointToSegment(t, this.p0, this.p1);
            }
        }
        equals(t) {
            if (!(t instanceof Kt)) return !1;
            const e = t;
            return this.p0.equals(e.p0) && this.p1.equals(e.p1);
        }
        intersection(t) {
            const e = new jt;
            return e.computeIntersection(this.p0, this.p1, t.p0, t.p1), e.hasIntersection() ? e.getIntersection(0) : null;
        }
        project() {
            if (arguments[0] instanceof m) {
                const t = arguments[0];
                if (t.equals(this.p0) || t.equals(this.p1)) return new m(t);
                const e = this.projectionFactor(t), s = new m;
                return s.x = this.p0.x + e * (this.p1.x - this.p0.x), s.y = this.p0.y + e * (this.p1.y - this.p0.y), s;
            }
            if (arguments[0] instanceof Kt) {
                const t = arguments[0], e = this.projectionFactor(t.p0), s = this.projectionFactor(t.p1);
                if (e >= 1 && s >= 1) return null;
                if (e <= 0 && s <= 0) return null;
                let n = this.project(t.p0);
                e < 0 && (n = this.p0), e > 1 && (n = this.p1);
                let i = this.project(t.p1);
                return s < 0 && (i = this.p0), s > 1 && (i = this.p1), new Kt(n, i);
            }
        }
        normalize() {
            this.p1.compareTo(this.p0) < 0 && this.reverse();
        }
        angle() {
            return Math.atan2(this.p1.y - this.p0.y, this.p1.x - this.p0.x);
        }
        getCoordinate(t) {
            return 0 === t ? this.p0 : this.p1;
        }
        distancePerpendicular(t) {
            return V.pointToLinePerpendicular(t, this.p0, this.p1);
        }
        closestPoint(t) {
            const e = this.projectionFactor(t);
            if (e > 0 && e < 1) return this.project(t);
            return this.p0.distance(t) < this.p1.distance(t) ? this.p0 : this.p1;
        }
        projectionFactor(t) {
            if (t.equals(this.p0)) return 0;
            if (t.equals(this.p1)) return 1;
            const e = this.p1.x - this.p0.x, s = this.p1.y - this.p0.y, n = e * e + s * s;
            if (n <= 0) return r.NaN;
            return ((t.x - this.p0.x) * e + (t.y - this.p0.y) * s) / n;
        }
        closestPoints(t) {
            const e = this.intersection(t);
            if (null !== e) return [
                e,
                e
            ];
            const s = new Array(2).fill(null);
            let n = r.MAX_VALUE, i = null;
            const o = this.closestPoint(t.p0);
            n = o.distance(t.p0), s[0] = o, s[1] = t.p0;
            const l = this.closestPoint(t.p1);
            i = l.distance(t.p1), i < n && (n = i, s[0] = l, s[1] = t.p1);
            const a = t.closestPoint(this.p0);
            i = a.distance(this.p0), i < n && (n = i, s[0] = this.p0, s[1] = a);
            const c = t.closestPoint(this.p1);
            return i = c.distance(this.p1), i < n && (n = i, s[0] = this.p1, s[1] = c), s;
        }
        maxX() {
            return Math.max(this.p0.x, this.p1.x);
        }
        getLength() {
            return this.p0.distance(this.p1);
        }
        compareTo(t) {
            const e = t, s = this.p0.compareTo(e.p0);
            return 0 !== s ? s : this.p1.compareTo(e.p1);
        }
        reverse() {
            const t = this.p0;
            this.p0 = this.p1, this.p1 = t;
        }
        equalsTopo(t) {
            return this.p0.equals(t.p0) && this.p1.equals(t.p1) || this.p0.equals(t.p1) && this.p1.equals(t.p0);
        }
        lineIntersection(t) {
            return B.intersection(this.p0, this.p1, t.p0, t.p1);
        }
        isHorizontal() {
            return this.p0.y === this.p1.y;
        }
        reflect(t) {
            const e = this.p1.getY() - this.p0.getY(), s = this.p0.getX() - this.p1.getX(), n = this.p0.getY() * (this.p1.getX() - this.p0.getX()) - this.p0.getX() * (this.p1.getY() - this.p0.getY()), i = e * e + s * s, r = e * e - s * s, o = t.getX(), l = t.getY();
            return new m((-r * o - 2 * e * s * l - 2 * e * n) / i, (r * l - 2 * e * s * o - 2 * s * n) / i);
        }
        pointAlong(t) {
            const e = new m;
            return e.x = this.p0.x + t * (this.p1.x - this.p0.x), e.y = this.p0.y + t * (this.p1.y - this.p0.y), e;
        }
        hashCode() {
            let t = r.doubleToLongBits(this.p0.x);
            t ^= 31 * r.doubleToLongBits(this.p0.y);
            const e = Math.trunc(t) ^ Math.trunc(t >> 32);
            let s = r.doubleToLongBits(this.p1.x);
            s ^= 31 * r.doubleToLongBits(this.p1.y);
            return e ^ (Math.trunc(s) ^ Math.trunc(s >> 32));
        }
        get interfaces_() {
            return [
                o,
                l
            ];
        }
    }
    class Qt {
        static toLocationSymbol(t) {
            switch(t){
                case Qt.EXTERIOR:
                    return "e";
                case Qt.BOUNDARY:
                    return "b";
                case Qt.INTERIOR:
                    return "i";
                case Qt.NONE:
                    return "-";
            }
            throw new n("Unknown location value: " + t);
        }
    }
    Qt.INTERIOR = 0, Qt.BOUNDARY = 1, Qt.EXTERIOR = 2, Qt.NONE = -1;
    class Jt {
        constructor(){
            Jt.constructor_.apply(this, arguments);
        }
        static constructor_() {
            if (this._matrix = null, 0 === arguments.length) this._matrix = Array(3).fill().map(()=>Array(3)), this.setAll(Z.FALSE);
            else if (1 === arguments.length) {
                if ("string" == typeof arguments[0]) {
                    const t = arguments[0];
                    Jt.constructor_.call(this), this.set(t);
                } else if (arguments[0] instanceof Jt) {
                    const t = arguments[0];
                    Jt.constructor_.call(this), this._matrix[Qt.INTERIOR][Qt.INTERIOR] = t._matrix[Qt.INTERIOR][Qt.INTERIOR], this._matrix[Qt.INTERIOR][Qt.BOUNDARY] = t._matrix[Qt.INTERIOR][Qt.BOUNDARY], this._matrix[Qt.INTERIOR][Qt.EXTERIOR] = t._matrix[Qt.INTERIOR][Qt.EXTERIOR], this._matrix[Qt.BOUNDARY][Qt.INTERIOR] = t._matrix[Qt.BOUNDARY][Qt.INTERIOR], this._matrix[Qt.BOUNDARY][Qt.BOUNDARY] = t._matrix[Qt.BOUNDARY][Qt.BOUNDARY], this._matrix[Qt.BOUNDARY][Qt.EXTERIOR] = t._matrix[Qt.BOUNDARY][Qt.EXTERIOR], this._matrix[Qt.EXTERIOR][Qt.INTERIOR] = t._matrix[Qt.EXTERIOR][Qt.INTERIOR], this._matrix[Qt.EXTERIOR][Qt.BOUNDARY] = t._matrix[Qt.EXTERIOR][Qt.BOUNDARY], this._matrix[Qt.EXTERIOR][Qt.EXTERIOR] = t._matrix[Qt.EXTERIOR][Qt.EXTERIOR];
                }
            }
        }
        static isTrue(t) {
            return t >= 0 || t === Z.TRUE;
        }
        static matches() {
            if (Number.isInteger(arguments[0]) && "string" == typeof arguments[1]) {
                const t = arguments[0], e = arguments[1];
                return e === Z.SYM_DONTCARE || e === Z.SYM_TRUE && (t >= 0 || t === Z.TRUE) || e === Z.SYM_FALSE && t === Z.FALSE || e === Z.SYM_P && t === Z.P || e === Z.SYM_L && t === Z.L || e === Z.SYM_A && t === Z.A;
            }
            if ("string" == typeof arguments[0] && "string" == typeof arguments[1]) {
                const t = arguments[1];
                return new Jt(arguments[0]).matches(t);
            }
        }
        isIntersects() {
            return !this.isDisjoint();
        }
        set() {
            if (1 === arguments.length) {
                const t = arguments[0];
                for(let e = 0; e < t.length; e++){
                    const s = Math.trunc(e / 3), n = e % 3;
                    this._matrix[s][n] = Z.toDimensionValue(t.charAt(e));
                }
            } else if (3 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = arguments[2];
                this._matrix[t][e] = s;
            }
        }
        isContains() {
            return Jt.isTrue(this._matrix[Qt.INTERIOR][Qt.INTERIOR]) && this._matrix[Qt.EXTERIOR][Qt.INTERIOR] === Z.FALSE && this._matrix[Qt.EXTERIOR][Qt.BOUNDARY] === Z.FALSE;
        }
        isWithin() {
            return Jt.isTrue(this._matrix[Qt.INTERIOR][Qt.INTERIOR]) && this._matrix[Qt.INTERIOR][Qt.EXTERIOR] === Z.FALSE && this._matrix[Qt.BOUNDARY][Qt.EXTERIOR] === Z.FALSE;
        }
        isTouches(t, e) {
            return t > e ? this.isTouches(e, t) : (t === Z.A && e === Z.A || t === Z.L && e === Z.L || t === Z.L && e === Z.A || t === Z.P && e === Z.A || t === Z.P && e === Z.L) && this._matrix[Qt.INTERIOR][Qt.INTERIOR] === Z.FALSE && (Jt.isTrue(this._matrix[Qt.INTERIOR][Qt.BOUNDARY]) || Jt.isTrue(this._matrix[Qt.BOUNDARY][Qt.INTERIOR]) || Jt.isTrue(this._matrix[Qt.BOUNDARY][Qt.BOUNDARY]));
        }
        isOverlaps(t, e) {
            return t === Z.P && e === Z.P || t === Z.A && e === Z.A ? Jt.isTrue(this._matrix[Qt.INTERIOR][Qt.INTERIOR]) && Jt.isTrue(this._matrix[Qt.INTERIOR][Qt.EXTERIOR]) && Jt.isTrue(this._matrix[Qt.EXTERIOR][Qt.INTERIOR]) : t === Z.L && e === Z.L && 1 === this._matrix[Qt.INTERIOR][Qt.INTERIOR] && Jt.isTrue(this._matrix[Qt.INTERIOR][Qt.EXTERIOR]) && Jt.isTrue(this._matrix[Qt.EXTERIOR][Qt.INTERIOR]);
        }
        isEquals(t, e) {
            return t === e && Jt.isTrue(this._matrix[Qt.INTERIOR][Qt.INTERIOR]) && this._matrix[Qt.INTERIOR][Qt.EXTERIOR] === Z.FALSE && this._matrix[Qt.BOUNDARY][Qt.EXTERIOR] === Z.FALSE && this._matrix[Qt.EXTERIOR][Qt.INTERIOR] === Z.FALSE && this._matrix[Qt.EXTERIOR][Qt.BOUNDARY] === Z.FALSE;
        }
        matches(t) {
            if (9 !== t.length) throw new n("Should be length 9: " + t);
            for(let e = 0; e < 3; e++)for(let s = 0; s < 3; s++)if (!Jt.matches(this._matrix[e][s], t.charAt(3 * e + s))) return !1;
            return !0;
        }
        add(t) {
            for(let e = 0; e < 3; e++)for(let s = 0; s < 3; s++)this.setAtLeast(e, s, t.get(e, s));
        }
        isDisjoint() {
            return this._matrix[Qt.INTERIOR][Qt.INTERIOR] === Z.FALSE && this._matrix[Qt.INTERIOR][Qt.BOUNDARY] === Z.FALSE && this._matrix[Qt.BOUNDARY][Qt.INTERIOR] === Z.FALSE && this._matrix[Qt.BOUNDARY][Qt.BOUNDARY] === Z.FALSE;
        }
        isCrosses(t, e) {
            return t === Z.P && e === Z.L || t === Z.P && e === Z.A || t === Z.L && e === Z.A ? Jt.isTrue(this._matrix[Qt.INTERIOR][Qt.INTERIOR]) && Jt.isTrue(this._matrix[Qt.INTERIOR][Qt.EXTERIOR]) : t === Z.L && e === Z.P || t === Z.A && e === Z.P || t === Z.A && e === Z.L ? Jt.isTrue(this._matrix[Qt.INTERIOR][Qt.INTERIOR]) && Jt.isTrue(this._matrix[Qt.EXTERIOR][Qt.INTERIOR]) : t === Z.L && e === Z.L && 0 === this._matrix[Qt.INTERIOR][Qt.INTERIOR];
        }
        isCovers() {
            return (Jt.isTrue(this._matrix[Qt.INTERIOR][Qt.INTERIOR]) || Jt.isTrue(this._matrix[Qt.INTERIOR][Qt.BOUNDARY]) || Jt.isTrue(this._matrix[Qt.BOUNDARY][Qt.INTERIOR]) || Jt.isTrue(this._matrix[Qt.BOUNDARY][Qt.BOUNDARY])) && this._matrix[Qt.EXTERIOR][Qt.INTERIOR] === Z.FALSE && this._matrix[Qt.EXTERIOR][Qt.BOUNDARY] === Z.FALSE;
        }
        isCoveredBy() {
            return (Jt.isTrue(this._matrix[Qt.INTERIOR][Qt.INTERIOR]) || Jt.isTrue(this._matrix[Qt.INTERIOR][Qt.BOUNDARY]) || Jt.isTrue(this._matrix[Qt.BOUNDARY][Qt.INTERIOR]) || Jt.isTrue(this._matrix[Qt.BOUNDARY][Qt.BOUNDARY])) && this._matrix[Qt.INTERIOR][Qt.EXTERIOR] === Z.FALSE && this._matrix[Qt.BOUNDARY][Qt.EXTERIOR] === Z.FALSE;
        }
        setAtLeast() {
            if (1 === arguments.length) {
                const t = arguments[0];
                for(let e = 0; e < t.length; e++){
                    const s = Math.trunc(e / 3), n = e % 3;
                    this.setAtLeast(s, n, Z.toDimensionValue(t.charAt(e)));
                }
            } else if (3 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = arguments[2];
                this._matrix[t][e] < s && (this._matrix[t][e] = s);
            }
        }
        setAtLeastIfValid(t, e, s) {
            t >= 0 && e >= 0 && this.setAtLeast(t, e, s);
        }
        toString() {
            const t = new nt("123456789");
            for(let e = 0; e < 3; e++)for(let s = 0; s < 3; s++)t.setCharAt(3 * e + s, Z.toDimensionSymbol(this._matrix[e][s]));
            return t.toString();
        }
        setAll(t) {
            for(let e = 0; e < 3; e++)for(let s = 0; s < 3; s++)this._matrix[e][s] = t;
        }
        get(t, e) {
            return this._matrix[t][e];
        }
        transpose() {
            let t = this._matrix[1][0];
            return this._matrix[1][0] = this._matrix[0][1], this._matrix[0][1] = t, t = this._matrix[2][0], this._matrix[2][0] = this._matrix[0][2], this._matrix[0][2] = t, t = this._matrix[2][1], this._matrix[2][1] = this._matrix[1][2], this._matrix[1][2] = t, this;
        }
        get interfaces_() {
            return [
                u
            ];
        }
    }
    class $t {
        static toDegrees(t) {
            return 180 * t / Math.PI;
        }
        static isAcute(t, e, s) {
            const n = t.x - e.x, i = t.y - e.y;
            return n * (s.x - e.x) + i * (s.y - e.y) > 0;
        }
        static isObtuse(t, e, s) {
            const n = t.x - e.x, i = t.y - e.y;
            return n * (s.x - e.x) + i * (s.y - e.y) < 0;
        }
        static interiorAngle(t, e, s) {
            const n = $t.angle(e, t), i = $t.angle(e, s);
            return Math.abs(i - n);
        }
        static normalizePositive(t) {
            if (t < 0) {
                for(; t < 0;)t += $t.PI_TIMES_2;
                t >= $t.PI_TIMES_2 && (t = 0);
            } else {
                for(; t >= $t.PI_TIMES_2;)t -= $t.PI_TIMES_2;
                t < 0 && (t = 0);
            }
            return t;
        }
        static angleBetween(t, e, s) {
            const n = $t.angle(e, t), i = $t.angle(e, s);
            return $t.diff(n, i);
        }
        static diff(t, e) {
            let s = null;
            return s = t < e ? e - t : t - e, s > Math.PI && (s = 2 * Math.PI - s), s;
        }
        static toRadians(t) {
            return t * Math.PI / 180;
        }
        static normalize(t) {
            for(; t > Math.PI;)t -= $t.PI_TIMES_2;
            for(; t <= -Math.PI;)t += $t.PI_TIMES_2;
            return t;
        }
        static angle() {
            if (1 === arguments.length) {
                const t = arguments[0];
                return Math.atan2(t.y, t.x);
            }
            if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = e.x - t.x, n = e.y - t.y;
                return Math.atan2(n, s);
            }
        }
        static getTurn(t, e) {
            const s = Math.sin(e - t);
            return s > 0 ? $t.COUNTERCLOCKWISE : s < 0 ? $t.CLOCKWISE : $t.NONE;
        }
        static angleBetweenOriented(t, e, s) {
            const n = $t.angle(e, t), i = $t.angle(e, s) - n;
            return i <= -Math.PI ? i + $t.PI_TIMES_2 : i > Math.PI ? i - $t.PI_TIMES_2 : i;
        }
    }
    $t.PI_TIMES_2 = 2 * Math.PI, $t.PI_OVER_2 = Math.PI / 2, $t.PI_OVER_4 = Math.PI / 4, $t.COUNTERCLOCKWISE = q.COUNTERCLOCKWISE, $t.CLOCKWISE = q.CLOCKWISE, $t.NONE = q.COLLINEAR;
    class te extends s {
        constructor(){
            super(), te.constructor_.apply(this, arguments);
        }
        static constructor_() {
            s.constructor_.call(this, "Projective point not representable on the Cartesian plane.");
        }
    }
    class ee {
        constructor(){
            ee.constructor_.apply(this, arguments);
        }
        static constructor_() {
            if (this.x = null, this.y = null, this.w = null, 0 === arguments.length) this.x = 0, this.y = 0, this.w = 1;
            else if (1 === arguments.length) {
                const t = arguments[0];
                this.x = t.x, this.y = t.y, this.w = 1;
            } else if (2 === arguments.length) {
                if ("number" == typeof arguments[0] && "number" == typeof arguments[1]) {
                    const t = arguments[0], e = arguments[1];
                    this.x = t, this.y = e, this.w = 1;
                } else if (arguments[0] instanceof ee && arguments[1] instanceof ee) {
                    const t = arguments[0], e = arguments[1];
                    this.x = t.y * e.w - e.y * t.w, this.y = e.x * t.w - t.x * e.w, this.w = t.x * e.y - e.x * t.y;
                } else if (arguments[0] instanceof m && arguments[1] instanceof m) {
                    const t = arguments[0], e = arguments[1];
                    this.x = t.y - e.y, this.y = e.x - t.x, this.w = t.x * e.y - e.x * t.y;
                }
            } else if (3 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = arguments[2];
                this.x = t, this.y = e, this.w = s;
            } else if (4 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = arguments[2], n = arguments[3], i = t.y - e.y, r = e.x - t.x, o = t.x * e.y - e.x * t.y, l = s.y - n.y, a = n.x - s.x, c = s.x * n.y - n.x * s.y;
                this.x = r * c - a * o, this.y = l * o - i * c, this.w = i * a - l * r;
            }
        }
        getCoordinate() {
            const t = new m;
            return t.x = this.getX(), t.y = this.getY(), t;
        }
        getX() {
            const t = this.x / this.w;
            if (r.isNaN(t) || r.isInfinite(t)) throw new te;
            return t;
        }
        getY() {
            const t = this.y / this.w;
            if (r.isNaN(t) || r.isInfinite(t)) throw new te;
            return t;
        }
    }
    class se {
        constructor(){
            se.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this.p0 = null, this.p1 = null, this.p2 = null;
            const t = arguments[0], e = arguments[1], s = arguments[2];
            this.p0 = t, this.p1 = e, this.p2 = s;
        }
        static isAcute(t, e, s) {
            return !!$t.isAcute(t, e, s) && !!$t.isAcute(e, s, t) && !!$t.isAcute(s, t, e);
        }
        static circumcentre(t, e, s) {
            const n = s.x, i = s.y, r = t.x - n, o = t.y - i, l = e.x - n, a = e.y - i, c = 2 * se.det(r, o, l, a), h = se.det(o, r * r + o * o, a, l * l + a * a), u = se.det(r, r * r + o * o, l, l * l + a * a);
            return new m(n - h / c, i + u / c);
        }
        static perpendicularBisector(t, e) {
            const s = e.x - t.x, n = e.y - t.y, i = new ee(t.x + s / 2, t.y + n / 2, 1), r = new ee(t.x - n + s / 2, t.y + s + n / 2, 1);
            return new ee(i, r);
        }
        static angleBisector(t, e, s) {
            const n = e.distance(t), i = n / (n + e.distance(s)), r = s.x - t.x, o = s.y - t.y;
            return new m(t.x + i * r, t.y + i * o);
        }
        static inCentre(t, e, s) {
            const n = e.distance(s), i = t.distance(s), r = t.distance(e), o = n + i + r, l = (n * t.x + i * e.x + r * s.x) / o, a = (n * t.y + i * e.y + r * s.y) / o;
            return new m(l, a);
        }
        static area(t, e, s) {
            return Math.abs(((s.x - t.x) * (e.y - t.y) - (e.x - t.x) * (s.y - t.y)) / 2);
        }
        static signedArea(t, e, s) {
            return ((s.x - t.x) * (e.y - t.y) - (e.x - t.x) * (s.y - t.y)) / 2;
        }
        static det(t, e, s, n) {
            return t * n - e * s;
        }
        static interpolateZ(t, e, s, n) {
            const i = e.x, r = e.y, o = s.x - i, l = n.x - i, a = s.y - r, c = n.y - r, h = o * c - l * a, u = t.x - i, g = t.y - r, d = (c * u - l * g) / h, _ = (-a * u + o * g) / h;
            return e.getZ() + d * (s.getZ() - e.getZ()) + _ * (n.getZ() - e.getZ());
        }
        static longestSideLength(t, e, s) {
            const n = t.distance(e), i = e.distance(s), r = s.distance(t);
            let o = n;
            return i > o && (o = i), r > o && (o = r), o;
        }
        static circumcentreDD(t, e, s) {
            const n = A.valueOf(t.x).subtract(s.x), i = A.valueOf(t.y).subtract(s.y), r = A.valueOf(e.x).subtract(s.x), o = A.valueOf(e.y).subtract(s.y), l = A.determinant(n, i, r, o).multiply(2), a = n.sqr().add(i.sqr()), c = r.sqr().add(o.sqr()), h = A.determinant(i, a, o, c), u = A.determinant(n, a, r, c), g = A.valueOf(s.x).subtract(h.divide(l)).doubleValue(), d = A.valueOf(s.y).add(u.divide(l)).doubleValue();
            return new m(g, d);
        }
        static area3D(t, e, s) {
            const n = e.x - t.x, i = e.y - t.y, r = e.getZ() - t.getZ(), o = s.x - t.x, l = s.y - t.y, a = s.getZ() - t.getZ(), c = i * a - r * l, h = r * o - n * a, u = n * l - i * o, g = c * c + h * h + u * u;
            return Math.sqrt(g) / 2;
        }
        static centroid(t, e, s) {
            const n = (t.x + e.x + s.x) / 3, i = (t.y + e.y + s.y) / 3;
            return new m(n, i);
        }
        interpolateZ(t) {
            if (null === t) throw new n("Supplied point is null.");
            return se.interpolateZ(t, this.p0, this.p1, this.p2);
        }
        longestSideLength() {
            return se.longestSideLength(this.p0, this.p1, this.p2);
        }
        isAcute() {
            return se.isAcute(this.p0, this.p1, this.p2);
        }
        circumcentre() {
            return se.circumcentre(this.p0, this.p1, this.p2);
        }
        inCentre() {
            return se.inCentre(this.p0, this.p1, this.p2);
        }
        area() {
            return se.area(this.p0, this.p1, this.p2);
        }
        signedArea() {
            return se.signedArea(this.p0, this.p1, this.p2);
        }
        area3D() {
            return se.area3D(this.p0, this.p1, this.p2);
        }
        centroid() {
            return se.centroid(this.p0, this.p1, this.p2);
        }
    }
    class ne extends s {
        constructor(){
            super(), ne.constructor_.apply(this, arguments);
        }
        static constructor_() {
            if (0 === arguments.length) s.constructor_.call(this);
            else if (1 === arguments.length) {
                const t = arguments[0];
                s.constructor_.call(this, t);
            }
        }
    }
    class ie {
        constructor(){
            ie.constructor_.apply(this, arguments);
        }
        static constructor_() {
            if (this._m00 = null, this._m01 = null, this._m02 = null, this._m10 = null, this._m11 = null, this._m12 = null, 0 === arguments.length) this.setToIdentity();
            else if (1 === arguments.length) {
                if (arguments[0] instanceof Array) {
                    const t = arguments[0];
                    this._m00 = t[0], this._m01 = t[1], this._m02 = t[2], this._m10 = t[3], this._m11 = t[4], this._m12 = t[5];
                } else if (arguments[0] instanceof ie) {
                    const t = arguments[0];
                    this.setTransformation(t);
                }
            } else if (6 === arguments.length && "number" == typeof arguments[5] && "number" == typeof arguments[4] && "number" == typeof arguments[3] && "number" == typeof arguments[2] && "number" == typeof arguments[0] && "number" == typeof arguments[1]) {
                const t = arguments[0], e = arguments[1], s = arguments[2], n = arguments[3], i = arguments[4], r = arguments[5];
                this.setTransformation(t, e, s, n, i, r);
            }
        }
        static translationInstance(t, e) {
            const s = new ie;
            return s.setToTranslation(t, e), s;
        }
        static shearInstance(t, e) {
            const s = new ie;
            return s.setToShear(t, e), s;
        }
        static reflectionInstance() {
            if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = new ie;
                return s.setToReflection(t, e), s;
            }
            if (4 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = arguments[2], n = arguments[3], i = new ie;
                return i.setToReflection(t, e, s, n), i;
            }
        }
        static rotationInstance() {
            if (1 === arguments.length) {
                const t = arguments[0];
                return ie.rotationInstance(Math.sin(t), Math.cos(t));
            }
            if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = new ie;
                return s.setToRotation(t, e), s;
            }
            if (3 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = arguments[2];
                return ie.rotationInstance(Math.sin(t), Math.cos(t), e, s);
            }
            if (4 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = arguments[2], n = arguments[3], i = new ie;
                return i.setToRotation(t, e, s, n), i;
            }
        }
        static scaleInstance() {
            if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = new ie;
                return s.setToScale(t, e), s;
            }
            if (4 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = arguments[2], n = arguments[3], i = new ie;
                return i.translate(-s, -n), i.scale(t, e), i.translate(s, n), i;
            }
        }
        setToReflectionBasic(t, e, s, i) {
            if (t === s && e === i) throw new n("Reflection line points must be distinct");
            const r = s - t, o = i - e, l = Math.sqrt(r * r + o * o), a = o / l, c = r / l, h = 2 * a * c, u = c * c - a * a;
            return this._m00 = u, this._m01 = h, this._m02 = 0, this._m10 = h, this._m11 = -u, this._m12 = 0, this;
        }
        setToRotation() {
            if (1 === arguments.length) {
                const t = arguments[0];
                return this.setToRotation(Math.sin(t), Math.cos(t)), this;
            }
            if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                return this._m00 = e, this._m01 = -t, this._m02 = 0, this._m10 = t, this._m11 = e, this._m12 = 0, this;
            }
            if (3 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = arguments[2];
                return this.setToRotation(Math.sin(t), Math.cos(t), e, s), this;
            }
            if (4 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = arguments[2], n = arguments[3];
                return this._m00 = e, this._m01 = -t, this._m02 = s - s * e + n * t, this._m10 = t, this._m11 = e, this._m12 = n - s * t - n * e, this;
            }
        }
        getMatrixEntries() {
            return [
                this._m00,
                this._m01,
                this._m02,
                this._m10,
                this._m11,
                this._m12
            ];
        }
        filter(t, e) {
            this.transform(t, e);
        }
        composeBefore(t) {
            const e = this._m00 * t._m00 + this._m01 * t._m10, s = this._m00 * t._m01 + this._m01 * t._m11, n = this._m00 * t._m02 + this._m01 * t._m12 + this._m02, i = this._m10 * t._m00 + this._m11 * t._m10, r = this._m10 * t._m01 + this._m11 * t._m11, o = this._m10 * t._m02 + this._m11 * t._m12 + this._m12;
            return this._m00 = e, this._m01 = s, this._m02 = n, this._m10 = i, this._m11 = r, this._m12 = o, this;
        }
        clone() {
            try {
                return null;
            } catch (t) {
                if (!(t instanceof s)) throw t;
                h.shouldNeverReachHere();
            }
            return null;
        }
        translate(t, e) {
            return this.compose(ie.translationInstance(t, e)), this;
        }
        setToReflection() {
            if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                if (0 === t && 0 === e) throw new n("Reflection vector must be non-zero");
                if (t === e) return this._m00 = 0, this._m01 = 1, this._m02 = 0, this._m10 = 1, this._m11 = 0, this._m12 = 0, this;
                const s = Math.sqrt(t * t + e * e), i = e / s, r = t / s;
                return this.rotate(-i, r), this.scale(1, -1), this.rotate(i, r), this;
            }
            if (4 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = arguments[2], i = arguments[3];
                if (t === s && e === i) throw new n("Reflection line points must be distinct");
                this.setToTranslation(-t, -e);
                const r = s - t, o = i - e, l = Math.sqrt(r * r + o * o), a = o / l, c = r / l;
                return this.rotate(-a, c), this.scale(1, -1), this.rotate(a, c), this.translate(t, e), this;
            }
        }
        shear(t, e) {
            return this.compose(ie.shearInstance(t, e)), this;
        }
        getInverse() {
            const t = this.getDeterminant();
            if (0 === t) throw new ne("Transformation is non-invertible");
            const e = this._m11 / t, s = -this._m10 / t, n = -this._m01 / t, i = this._m00 / t, r = (this._m01 * this._m12 - this._m02 * this._m11) / t, o = (-this._m00 * this._m12 + this._m10 * this._m02) / t;
            return new ie(e, n, r, s, i, o);
        }
        compose(t) {
            const e = t._m00 * this._m00 + t._m01 * this._m10, s = t._m00 * this._m01 + t._m01 * this._m11, n = t._m00 * this._m02 + t._m01 * this._m12 + t._m02, i = t._m10 * this._m00 + t._m11 * this._m10, r = t._m10 * this._m01 + t._m11 * this._m11, o = t._m10 * this._m02 + t._m11 * this._m12 + t._m12;
            return this._m00 = e, this._m01 = s, this._m02 = n, this._m10 = i, this._m11 = r, this._m12 = o, this;
        }
        equals(t) {
            if (null === t) return !1;
            if (!(t instanceof ie)) return !1;
            const e = t;
            return this._m00 === e._m00 && this._m01 === e._m01 && this._m02 === e._m02 && this._m10 === e._m10 && this._m11 === e._m11 && this._m12 === e._m12;
        }
        setToScale(t, e) {
            return this._m00 = t, this._m01 = 0, this._m02 = 0, this._m10 = 0, this._m11 = e, this._m12 = 0, this;
        }
        isIdentity() {
            return 1 === this._m00 && 0 === this._m01 && 0 === this._m02 && 0 === this._m10 && 1 === this._m11 && 0 === this._m12;
        }
        scale(t, e) {
            return this.compose(ie.scaleInstance(t, e)), this;
        }
        setToIdentity() {
            return this._m00 = 1, this._m01 = 0, this._m02 = 0, this._m10 = 0, this._m11 = 1, this._m12 = 0, this;
        }
        isGeometryChanged() {
            return !0;
        }
        setTransformation() {
            if (1 === arguments.length) {
                const t = arguments[0];
                return this._m00 = t._m00, this._m01 = t._m01, this._m02 = t._m02, this._m10 = t._m10, this._m11 = t._m11, this._m12 = t._m12, this;
            }
            if (6 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = arguments[2], n = arguments[3], i = arguments[4], r = arguments[5];
                return this._m00 = t, this._m01 = e, this._m02 = s, this._m10 = n, this._m11 = i, this._m12 = r, this;
            }
        }
        rotate() {
            if (1 === arguments.length) {
                const t = arguments[0];
                return this.compose(ie.rotationInstance(t)), this;
            }
            if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                return this.compose(ie.rotationInstance(t, e)), this;
            }
            if (3 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = arguments[2];
                return this.compose(ie.rotationInstance(t, e, s)), this;
            }
            if (4 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = arguments[2], n = arguments[3];
                return this.compose(ie.rotationInstance(t, e, s, n)), this;
            }
        }
        getDeterminant() {
            return this._m00 * this._m11 - this._m01 * this._m10;
        }
        setToShear(t, e) {
            return this._m00 = 1, this._m01 = t, this._m02 = 0, this._m10 = e, this._m11 = 1, this._m12 = 0, this;
        }
        isDone() {
            return !1;
        }
        toString() {
            return "AffineTransformation[[" + this._m00 + ", " + this._m01 + ", " + this._m02 + "], [" + this._m10 + ", " + this._m11 + ", " + this._m12 + "]]";
        }
        setToTranslation(t, e) {
            return this._m00 = 1, this._m01 = 0, this._m02 = t, this._m10 = 0, this._m11 = 1, this._m12 = e, this;
        }
        transform() {
            if (1 === arguments.length) {
                const t = arguments[0].copy();
                return t.apply(this), t;
            }
            if (2 === arguments.length) {
                if (arguments[0] instanceof m && arguments[1] instanceof m) {
                    const t = arguments[0], e = arguments[1], s = this._m00 * t.x + this._m01 * t.y + this._m02, n = this._m10 * t.x + this._m11 * t.y + this._m12;
                    return e.x = s, e.y = n, e;
                }
                if (I(arguments[0], G) && Number.isInteger(arguments[1])) {
                    const t = arguments[0], e = arguments[1], s = this._m00 * t.getOrdinate(e, 0) + this._m01 * t.getOrdinate(e, 1) + this._m02, n = this._m10 * t.getOrdinate(e, 0) + this._m11 * t.getOrdinate(e, 1) + this._m12;
                    t.setOrdinate(e, 0, s), t.setOrdinate(e, 1, n);
                }
            }
        }
        reflect() {
            if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                return this.compose(ie.reflectionInstance(t, e)), this;
            }
            if (4 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = arguments[2], n = arguments[3];
                return this.compose(ie.reflectionInstance(t, e, s, n)), this;
            }
        }
        get interfaces_() {
            return [
                u,
                P
            ];
        }
    }
    class re {
        static solve(t, e) {
            const s = e.length;
            if (t.length !== s || t[0].length !== s) throw new n("Matrix A is incorrectly sized");
            for(let n = 0; n < s; n++){
                let i = n;
                for(let e = n + 1; e < s; e++)Math.abs(t[e][n]) > Math.abs(t[i][n]) && (i = e);
                if (0 === t[i][n]) return null;
                re.swapRows(t, n, i), re.swapRows(e, n, i);
                for(let i = n + 1; i < s; i++){
                    const r = t[i][n] / t[n][n];
                    for(let e = s - 1; e >= n; e--)t[i][e] -= t[n][e] * r;
                    e[i] -= e[n] * r;
                }
            }
            const i = new Array(s).fill(null);
            for(let n = s - 1; n >= 0; n--){
                let r = 0;
                for(let e = n + 1; e < s; e++)r += t[n][e] * i[e];
                i[n] = (e[n] - r) / t[n][n];
            }
            return i;
        }
        static swapRows() {
            if (Number.isInteger(arguments[2]) && arguments[0] instanceof Array && Number.isInteger(arguments[1])) {
                const t = arguments[0], e = arguments[1], s = arguments[2];
                if (e === s) return null;
                for(let n = 0; n < t[0].length; n++){
                    const i = t[e][n];
                    t[e][n] = t[s][n], t[s][n] = i;
                }
            } else if (Number.isInteger(arguments[2]) && arguments[0] instanceof Array && Number.isInteger(arguments[1])) {
                const t = arguments[0], e = arguments[1], s = arguments[2];
                if (e === s) return null;
                const n = t[e];
                t[e] = t[s], t[s] = n;
            }
        }
    }
    class oe {
        constructor(){
            oe.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._src0 = null, this._src1 = null, this._src2 = null, this._dest0 = null, this._dest1 = null, this._dest2 = null, this._m00 = null, this._m01 = null, this._m02 = null, this._m10 = null, this._m11 = null, this._m12 = null;
            const t = arguments[0], e = arguments[1], s = arguments[2], n = arguments[3], i = arguments[4], r = arguments[5];
            this._src0 = t, this._src1 = e, this._src2 = s, this._dest0 = n, this._dest1 = i, this._dest2 = r;
        }
        compute() {
            const t = [
                this._dest0.x,
                this._dest1.x,
                this._dest2.x
            ], e = this.solve(t);
            if (null === e) return !1;
            this._m00 = e[0], this._m01 = e[1], this._m02 = e[2];
            const s = [
                this._dest0.y,
                this._dest1.y,
                this._dest2.y
            ], n = this.solve(s);
            return null !== n && (this._m10 = n[0], this._m11 = n[1], this._m12 = n[2], !0);
        }
        getTransformation() {
            return this.compute() ? new ie(this._m00, this._m01, this._m02, this._m10, this._m11, this._m12) : null;
        }
        solve(t) {
            const e = [
                [
                    this._src0.x,
                    this._src0.y,
                    1
                ],
                [
                    this._src1.x,
                    this._src1.y,
                    1
                ],
                [
                    this._src2.x,
                    this._src2.y,
                    1
                ]
            ];
            return re.solve(e, t);
        }
    }
    class le {
        static createFromBaseLines(t, e, s, n) {
            const i = new m(t.x + n.x - s.x, t.y + n.y - s.y), r = $t.angleBetweenOriented(e, t, i), o = e.distance(t), l = n.distance(s);
            if (0 === o) return new ie;
            const a = l / o, c = ie.translationInstance(-t.x, -t.y);
            return c.rotate(r), c.scale(a, a), c.translate(s.x, s.y), c;
        }
        static createFromControlVectors() {
            if (2 === arguments.length) {
                if (arguments[0] instanceof m && arguments[1] instanceof m) {
                    const t = arguments[0], e = arguments[1], s = e.x - t.x, n = e.y - t.y;
                    return ie.translationInstance(s, n);
                }
                if (arguments[0] instanceof Array && arguments[1] instanceof Array) {
                    const t = arguments[0], e = arguments[1];
                    if (t.length !== e.length) throw new n("Src and Dest arrays are not the same length");
                    if (t.length <= 0) throw new n("Too few control points");
                    if (t.length > 3) throw new n("Too many control points");
                    return 1 === t.length ? le.createFromControlVectors(t[0], e[0]) : 2 === t.length ? le.createFromControlVectors(t[0], t[1], e[0], e[1]) : le.createFromControlVectors(t[0], t[1], t[2], e[0], e[1], e[2]);
                }
            } else {
                if (4 === arguments.length) {
                    const t = arguments[0], e = arguments[1], s = arguments[2], n = arguments[3], i = new m(n.x - s.x, n.y - s.y), r = $t.angleBetweenOriented(e, t, i), o = e.distance(t), l = n.distance(s);
                    if (0 === o) return null;
                    const a = l / o, c = ie.translationInstance(-t.x, -t.y);
                    return c.rotate(r), c.scale(a, a), c.translate(s.x, s.y), c;
                }
                if (6 === arguments.length) return new oe(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]).getTransformation();
            }
        }
    }
    class ae {
        constructor(){
            ae.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._coords = null;
            const t = arguments[0];
            this._coords = t;
        }
        static getCoordinates(t) {
            const e = new L;
            return t.apply(new ae(e)), e;
        }
        filter(t) {
            (t instanceof tt || t instanceof Nt) && this._coords.add(t.getCoordinate());
        }
        get interfaces_() {
            return [
                X
            ];
        }
    }
    class ce {
        constructor(){
            ce.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._mapOp = null;
            const t = arguments[0];
            this._mapOp = t;
        }
        static map(t, e) {
            return new ce(e).map(t);
        }
        map(t) {
            const e = new L;
            for(let s = 0; s < t.getNumGeometries(); s++){
                const n = this._mapOp.map(t.getGeometryN(s));
                n.isEmpty() || e.add(n);
            }
            return t.getFactory().createGeometryCollection(Lt.toGeometryArray(e));
        }
    }
    class he {
        constructor(){
            he.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._geomFactory = null, this._skipEmpty = !1, this._inputGeoms = null;
            const t = arguments[0];
            this._geomFactory = he.extractFactory(t), this._inputGeoms = t;
        }
        static extractFactory(t) {
            return t.isEmpty() ? null : t.iterator().next().getFactory();
        }
        static createList() {
            if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = new L;
                return s.add(t), s.add(e), s;
            }
            if (3 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = arguments[2], n = new L;
                return n.add(t), n.add(e), n.add(s), n;
            }
        }
        static combine() {
            if (1 === arguments.length) return new he(arguments[0]).combine();
            if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                return new he(he.createList(t, e)).combine();
            }
            if (3 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = arguments[2];
                return new he(he.createList(t, e, s)).combine();
            }
        }
        extractElements(t, e) {
            if (null === t) return null;
            for(let s = 0; s < t.getNumGeometries(); s++){
                const n = t.getGeometryN(s);
                this._skipEmpty && n.isEmpty() || e.add(n);
            }
        }
        combine() {
            const t = new L;
            for(let e = this._inputGeoms.iterator(); e.hasNext();){
                const s = e.next();
                this.extractElements(s, t);
            }
            return 0 === t.size() ? null !== this._geomFactory ? this._geomFactory.createGeometryCollection() : null : this._geomFactory.buildGeometry(t);
        }
    }
    class ue {
        constructor(){
            ue.constructor_.apply(this, arguments);
        }
        static constructor_() {
            if (this._factory = null, this._isUserDataCopied = !1, 0 === arguments.length) ;
            else if (1 === arguments.length) {
                const t = arguments[0];
                this._factory = t;
            }
        }
        setCopyUserData(t) {
            this._isUserDataCopied = t;
        }
        edit(t, e) {
            if (null === t) return null;
            const s = this.editInternal(t, e);
            return this._isUserDataCopied && s.setUserData(t.getUserData()), s;
        }
        editInternal(t, e) {
            return null === this._factory && (this._factory = t.getFactory()), t instanceof ut ? this.editGeometryCollection(t, e) : t instanceof Ct ? this.editPolygon(t, e) : t instanceof Nt || t instanceof tt ? e.edit(t, this._factory) : (h.shouldNeverReachHere("Unsupported Geometry type: " + t.getGeometryType()), null);
        }
        editGeometryCollection(t, e) {
            const s = e.edit(t, this._factory), n = new L;
            for(let t = 0; t < s.getNumGeometries(); t++){
                const i = this.edit(s.getGeometryN(t), e);
                null === i || i.isEmpty() || n.add(i);
            }
            return s.getGeometryType() === j.TYPENAME_MULTIPOINT ? this._factory.createMultiPoint(n.toArray([])) : s.getGeometryType() === j.TYPENAME_MULTILINESTRING ? this._factory.createMultiLineString(n.toArray([])) : s.getGeometryType() === j.TYPENAME_MULTIPOLYGON ? this._factory.createMultiPolygon(n.toArray([])) : this._factory.createGeometryCollection(n.toArray([]));
        }
        editPolygon(t, e) {
            let s = e.edit(t, this._factory);
            if (null === s && (s = this._factory.createPolygon()), s.isEmpty()) return s;
            const n = this.edit(s.getExteriorRing(), e);
            if (null === n || n.isEmpty()) return this._factory.createPolygon();
            const i = new L;
            for(let t = 0; t < s.getNumInteriorRing(); t++){
                const n = this.edit(s.getInteriorRingN(t), e);
                null === n || n.isEmpty() || i.add(n);
            }
            return this._factory.createPolygon(n, i.toArray([]));
        }
    }
    function ge() {}
    ue.GeometryEditorOperation = ge;
    ue.NoOpGeometryOperation = class {
        edit(t, e) {
            return t;
        }
        get interfaces_() {
            return [
                ge
            ];
        }
    }, ue.CoordinateOperation = class {
        edit(t, e) {
            const s = this.edit(t.getCoordinates(), t);
            return t instanceof et ? null === s ? e.createLinearRing() : e.createLinearRing(s) : t instanceof tt ? null === s ? e.createLineString() : e.createLineString(s) : t instanceof Nt ? null === s || 0 === s.length ? e.createPoint() : e.createPoint(s[0]) : t;
        }
        get interfaces_() {
            return [
                ge
            ];
        }
    }, ue.CoordinateSequenceOperation = class {
        edit(t, e) {
            return t instanceof et ? e.createLinearRing(this.edit(t.getCoordinateSequence(), t)) : t instanceof tt ? e.createLineString(this.edit(t.getCoordinateSequence(), t)) : t instanceof Nt ? e.createPoint(this.edit(t.getCoordinateSequence(), t)) : t;
        }
        get interfaces_() {
            return [
                ge
            ];
        }
    };
    class de {
        constructor(){
            de.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._geometryType = null, this._comps = null;
            const t = arguments[0], e = arguments[1];
            this._geometryType = t, this._comps = e;
        }
        static extract() {
            if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                return de.extract(t, e, new L);
            }
            if (3 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = arguments[2];
                return t.getGeometryType() === e ? s.add(t) : t instanceof ut && t.apply(new de(e, s)), s;
            }
        }
        static isOfType(t, e) {
            return t.getGeometryType() === e || e === j.TYPENAME_LINESTRING && t.getGeometryType() === j.TYPENAME_LINEARRING;
        }
        filter(t) {
            (null === this._geometryType || de.isOfType(t, this._geometryType)) && this._comps.add(t);
        }
        get interfaces_() {
            return [
                $
            ];
        }
    }
    class _e {
        static map() {
            if (arguments[0] instanceof j && I(arguments[1], pe)) {
                const t = arguments[0], e = arguments[1], s = new L;
                for(let n = 0; n < t.getNumGeometries(); n++){
                    const i = e.map(t.getGeometryN(n));
                    null !== i && s.add(i);
                }
                return t.getFactory().buildGeometry(s);
            }
            if (I(arguments[0], N) && I(arguments[1], pe)) {
                const t = arguments[0], e = arguments[1], s = new L;
                for(let n = t.iterator(); n.hasNext();){
                    const t = n.next(), i = e.map(t);
                    null !== i && s.add(i);
                }
                return s;
            }
        }
    }
    function pe() {}
    _e.MapOp = pe;
    class me {
        constructor(){
            me.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._inputGeom = null, this._factory = null, this._pruneEmptyGeometry = !0, this._preserveGeometryCollectionType = !0, this._preserveCollections = !1, this._preserveType = !1;
        }
        transformPoint(t, e) {
            return this._factory.createPoint(this.transformCoordinates(t.getCoordinateSequence(), t));
        }
        transformPolygon(t, e) {
            let s = !0;
            const n = this.transformLinearRing(t.getExteriorRing(), t);
            null !== n && n instanceof et && !n.isEmpty() || (s = !1);
            const i = new L;
            for(let e = 0; e < t.getNumInteriorRing(); e++){
                const n = this.transformLinearRing(t.getInteriorRingN(e), t);
                null === n || n.isEmpty() || (n instanceof et || (s = !1), i.add(n));
            }
            if (s) return this._factory.createPolygon(n, i.toArray([]));
            {
                const t = new L;
                return null !== n && t.add(n), t.addAll(i), this._factory.buildGeometry(t);
            }
        }
        createCoordinateSequence(t) {
            return this._factory.getCoordinateSequenceFactory().create(t);
        }
        getInputGeometry() {
            return this._inputGeom;
        }
        transformMultiLineString(t, e) {
            const s = new L;
            for(let e = 0; e < t.getNumGeometries(); e++){
                const n = this.transformLineString(t.getGeometryN(e), t);
                null !== n && (n.isEmpty() || s.add(n));
            }
            return this._factory.buildGeometry(s);
        }
        transformCoordinates(t, e) {
            return this.copy(t);
        }
        transformLineString(t, e) {
            return this._factory.createLineString(this.transformCoordinates(t.getCoordinateSequence(), t));
        }
        transformMultiPoint(t, e) {
            const s = new L;
            for(let e = 0; e < t.getNumGeometries(); e++){
                const n = this.transformPoint(t.getGeometryN(e), t);
                null !== n && (n.isEmpty() || s.add(n));
            }
            return this._factory.buildGeometry(s);
        }
        transformMultiPolygon(t, e) {
            const s = new L;
            for(let e = 0; e < t.getNumGeometries(); e++){
                const n = this.transformPolygon(t.getGeometryN(e), t);
                null !== n && (n.isEmpty() || s.add(n));
            }
            return this._factory.buildGeometry(s);
        }
        copy(t) {
            return t.copy();
        }
        transformLinearRing(t, e) {
            const s = this.transformCoordinates(t.getCoordinateSequence(), t);
            if (null === s) return this._factory.createLinearRing(null);
            const n = s.size();
            return n > 0 && n < 4 && !this._preserveType ? this._factory.createLineString(s) : this._factory.createLinearRing(s);
        }
        transformGeometryCollection(t, e) {
            const s = new L;
            for(let e = 0; e < t.getNumGeometries(); e++){
                const n = this.transform(t.getGeometryN(e));
                null !== n && (this._pruneEmptyGeometry && n.isEmpty() || s.add(n));
            }
            return this._preserveGeometryCollectionType ? this._factory.createGeometryCollection(Lt.toGeometryArray(s)) : this._factory.buildGeometry(s);
        }
        transform(t) {
            if (this._inputGeom = t, this._factory = t.getFactory(), t instanceof Nt) return this.transformPoint(t, null);
            if (t instanceof St) return this.transformMultiPoint(t, null);
            if (t instanceof et) return this.transformLinearRing(t, null);
            if (t instanceof tt) return this.transformLineString(t, null);
            if (t instanceof Et) return this.transformMultiLineString(t, null);
            if (t instanceof Ct) return this.transformPolygon(t, null);
            if (t instanceof dt) return this.transformMultiPolygon(t, null);
            if (t instanceof ut) return this.transformGeometryCollection(t, null);
            throw new n("Unknown Geometry subtype: " + t.getGeometryType());
        }
    }
    class fe {
        constructor(){
            fe.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._comps = null;
            const t = arguments[0];
            this._comps = t;
        }
        static getLines() {
            if (1 === arguments.length) {
                const t = arguments[0];
                return fe.getLines(t, new L);
            }
            if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                return t instanceof tt ? e.add(t) : t instanceof ut && t.apply(new fe(e)), e;
            }
        }
        static getGeometry(t) {
            return t.getFactory().buildGeometry(fe.getLines(t));
        }
        filter(t) {
            t instanceof tt && this._comps.add(t);
        }
        get interfaces_() {
            return [
                $
            ];
        }
    }
    class ye {
        constructor(){
            ye.constructor_.apply(this, arguments);
        }
        static constructor_() {
            if (this._lines = null, this._isForcedToLineString = !1, 1 === arguments.length) {
                const t = arguments[0];
                this._lines = t;
            } else if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                this._lines = t, this._isForcedToLineString = e;
            }
        }
        static getLines() {
            if (1 === arguments.length) {
                const t = arguments[0];
                return ye.getLines(t, !1);
            }
            if (2 === arguments.length) {
                if (I(arguments[0], N) && I(arguments[1], N)) {
                    const t = arguments[1];
                    for(let e = arguments[0].iterator(); e.hasNext();){
                        const s = e.next();
                        ye.getLines(s, t);
                    }
                    return t;
                }
                if (arguments[0] instanceof j && "boolean" == typeof arguments[1]) {
                    const t = arguments[0], e = arguments[1], s = new L;
                    return t.apply(new ye(s, e)), s;
                }
                if (arguments[0] instanceof j && I(arguments[1], N)) {
                    const t = arguments[0], e = arguments[1];
                    return t instanceof tt ? e.add(t) : t.apply(new ye(e)), e;
                }
            } else if (3 === arguments.length) {
                if ("boolean" == typeof arguments[2] && I(arguments[0], N) && I(arguments[1], N)) {
                    const t = arguments[1], e = arguments[2];
                    for(let s = arguments[0].iterator(); s.hasNext();){
                        const n = s.next();
                        ye.getLines(n, t, e);
                    }
                    return t;
                }
                if ("boolean" == typeof arguments[2] && arguments[0] instanceof j && I(arguments[1], N)) {
                    const t = arguments[1], e = arguments[2];
                    return arguments[0].apply(new ye(t, e)), t;
                }
            }
        }
        static getGeometry() {
            if (1 === arguments.length) {
                const t = arguments[0];
                return t.getFactory().buildGeometry(ye.getLines(t));
            }
            if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                return t.getFactory().buildGeometry(ye.getLines(t, e));
            }
        }
        filter(t) {
            if (this._isForcedToLineString && t instanceof et) {
                const e = t.getFactory().createLineString(t.getCoordinateSequence());
                return this._lines.add(e), null;
            }
            t instanceof tt && this._lines.add(t);
        }
        setForceToLineString(t) {
            this._isForcedToLineString = t;
        }
        get interfaces_() {
            return [
                X
            ];
        }
    }
    const xe = {
        reverseOrder: function() {
            return {
                compare: (t, e)=>e.compareTo(t)
            };
        },
        min: function(t) {
            return xe.sort(t), t.get(0);
        },
        sort: function(t, e) {
            const s = t.toArray();
            e ? ht.sort(s, e) : ht.sort(s);
            const n = t.iterator();
            for(let t = 0, e = s.length; t < e; t++)n.next(), n.set(s[t]);
        },
        singletonList: function(t) {
            const e = new L;
            return e.add(t), e;
        }
    };
    class Ee {
        constructor(){
            Ee.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._pts = null;
            const t = arguments[0];
            this._pts = t;
        }
        static getPoints() {
            if (1 === arguments.length) {
                const t = arguments[0];
                return t instanceof Nt ? xe.singletonList(t) : Ee.getPoints(t, new L);
            }
            if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                return t instanceof Nt ? e.add(t) : t instanceof ut && t.apply(new Ee(e)), e;
            }
        }
        filter(t) {
            t instanceof Nt && this._pts.add(t);
        }
        get interfaces_() {
            return [
                $
            ];
        }
    }
    class Ie {
        constructor(){
            Ie.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._comps = null;
            const t = arguments[0];
            this._comps = t;
        }
        static getPolygons() {
            if (1 === arguments.length) {
                const t = arguments[0];
                return Ie.getPolygons(t, new L);
            }
            if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                return t instanceof Ct ? e.add(t) : t instanceof ut && t.apply(new Ie(e)), e;
            }
        }
        filter(t) {
            t instanceof Ct && this._comps.add(t);
        }
        get interfaces_() {
            return [
                $
            ];
        }
    }
    class Ne {
        constructor(){
            Ne.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._isDone = !1;
        }
        applyTo(t) {
            for(let e = 0; e < t.getNumGeometries() && !this._isDone; e++){
                const s = t.getGeometryN(e);
                if (s instanceof ut) this.applyTo(s);
                else if (this.visit(s), this.isDone()) return this._isDone = !0, null;
            }
        }
    }
    class we {
        constructor(){
            we.constructor_.apply(this, arguments);
        }
        static constructor_() {
            if (this._geomFact = null, this._precModel = null, this._dim = new Ce, this._nPts = 100, this._rotationAngle = 0, 0 === arguments.length) we.constructor_.call(this, new Lt);
            else if (1 === arguments.length) {
                const t = arguments[0];
                this._geomFact = t, this._precModel = t.getPrecisionModel();
            }
        }
        setBase(t) {
            this._dim.setBase(t);
        }
        setRotation(t) {
            this._rotationAngle = t;
        }
        setWidth(t) {
            this._dim.setWidth(t);
        }
        createEllipse() {
            const t = this._dim.getEnvelope(), e = t.getWidth() / 2, s = t.getHeight() / 2, n = t.getMinX() + e, i = t.getMinY() + s, r = new Array(this._nPts + 1).fill(null);
            let o = 0;
            for(let t = 0; t < this._nPts; t++){
                const l = t * (2 * Math.PI / this._nPts), a = e * Math.cos(l) + n, c = s * Math.sin(l) + i;
                r[o++] = this.coord(a, c);
            }
            r[o] = new m(r[0]);
            const l = this._geomFact.createLinearRing(r), a = this._geomFact.createPolygon(l);
            return this.rotate(a);
        }
        createArc(t, e) {
            const s = this._dim.getEnvelope(), n = s.getWidth() / 2, i = s.getHeight() / 2, r = s.getMinX() + n, o = s.getMinY() + i;
            let l = e;
            (l <= 0 || l > 2 * Math.PI) && (l = 2 * Math.PI);
            const a = l / (this._nPts - 1), c = new Array(this._nPts).fill(null);
            let h = 0;
            for(let e = 0; e < this._nPts; e++){
                const s = t + e * a, l = n * Math.cos(s) + r, u = i * Math.sin(s) + o;
                c[h++] = this.coord(l, u);
            }
            const u = this._geomFact.createLineString(c);
            return this.rotate(u);
        }
        rotate(t) {
            if (0 !== this._rotationAngle) {
                const e = ie.rotationInstance(this._rotationAngle, this._dim.getCentre().x, this._dim.getCentre().y);
                t.apply(e);
            }
            return t;
        }
        coord(t, e) {
            const s = new m(t, e);
            return this._precModel.makePrecise(s), s;
        }
        createArcPolygon(t, e) {
            const s = this._dim.getEnvelope(), n = s.getWidth() / 2, i = s.getHeight() / 2, r = s.getMinX() + n, o = s.getMinY() + i;
            let l = e;
            (l <= 0 || l > 2 * Math.PI) && (l = 2 * Math.PI);
            const a = l / (this._nPts - 1), c = new Array(this._nPts + 2).fill(null);
            let h = 0;
            c[h++] = this.coord(r, o);
            for(let e = 0; e < this._nPts; e++){
                const s = t + a * e, l = n * Math.cos(s) + r, u = i * Math.sin(s) + o;
                c[h++] = this.coord(l, u);
            }
            c[h++] = this.coord(r, o);
            const u = this._geomFact.createLinearRing(c), g = this._geomFact.createPolygon(u);
            return this.rotate(g);
        }
        createRectangle() {
            let t = null, e = 0, s = Math.trunc(this._nPts / 4);
            s < 1 && (s = 1);
            const n = this._dim.getEnvelope().getWidth() / s, i = this._dim.getEnvelope().getHeight() / s, r = new Array(4 * s + 1).fill(null), o = this._dim.getEnvelope();
            for(t = 0; t < s; t++){
                const s = o.getMinX() + t * n, i = o.getMinY();
                r[e++] = this.coord(s, i);
            }
            for(t = 0; t < s; t++){
                const s = o.getMaxX(), n = o.getMinY() + t * i;
                r[e++] = this.coord(s, n);
            }
            for(t = 0; t < s; t++){
                const s = o.getMaxX() - t * n, i = o.getMaxY();
                r[e++] = this.coord(s, i);
            }
            for(t = 0; t < s; t++){
                const s = o.getMinX(), n = o.getMaxY() - t * i;
                r[e++] = this.coord(s, n);
            }
            r[e++] = new m(r[0]);
            const l = this._geomFact.createLinearRing(r), a = this._geomFact.createPolygon(l);
            return this.rotate(a);
        }
        createCircle() {
            return this.createEllipse();
        }
        setHeight(t) {
            this._dim.setHeight(t);
        }
        setSize(t) {
            this._dim.setSize(t);
        }
        createSupercircle(t) {
            const e = 1 / t, s = this._dim.getMinSize() / 2, n = this._dim.getCentre(), i = Math.pow(s, t), r = s, o = Math.pow(i / 2, e), l = Math.trunc(this._nPts / 8), a = new Array(8 * l + 1).fill(null), c = o / l;
            for(let s = 0; s <= l; s++){
                let o = 0, h = r;
                if (0 !== s) {
                    o = c * s;
                    const n = Math.pow(o, t);
                    h = Math.pow(i - n, e);
                }
                a[s] = this.coordTrans(o, h, n), a[2 * l - s] = this.coordTrans(h, o, n), a[2 * l + s] = this.coordTrans(h, -o, n), a[4 * l - s] = this.coordTrans(o, -h, n), a[4 * l + s] = this.coordTrans(-o, -h, n), a[6 * l - s] = this.coordTrans(-h, -o, n), a[6 * l + s] = this.coordTrans(-h, o, n), a[8 * l - s] = this.coordTrans(-o, h, n);
            }
            a[a.length - 1] = new m(a[0]);
            const h = this._geomFact.createLinearRing(a), u = this._geomFact.createPolygon(h);
            return this.rotate(u);
        }
        setNumPoints(t) {
            this._nPts = t;
        }
        coordTrans(t, e, s) {
            return this.coord(t + s.x, e + s.y);
        }
        createSquircle() {
            return this.createSupercircle(4);
        }
        setEnvelope(t) {
            this._dim.setEnvelope(t);
        }
        setCentre(t) {
            this._dim.setCentre(t);
        }
    }
    class Ce {
        constructor(){
            Ce.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this.base = null, this.centre = null, this.width = null, this.height = null;
        }
        setBase(t) {
            this.base = t;
        }
        setWidth(t) {
            this.width = t;
        }
        getBase() {
            return this.base;
        }
        getWidth() {
            return this.width;
        }
        getEnvelope() {
            return null !== this.base ? new O(this.base.x, this.base.x + this.width, this.base.y, this.base.y + this.height) : null !== this.centre ? new O(this.centre.x - this.width / 2, this.centre.x + this.width / 2, this.centre.y - this.height / 2, this.centre.y + this.height / 2) : new O(0, this.width, 0, this.height);
        }
        getCentre() {
            return null === this.centre && (this.centre = new m(this.base.x + this.width / 2, this.base.y + this.height / 2)), this.centre;
        }
        getHeight() {
            return this.height;
        }
        setHeight(t) {
            this.height = t;
        }
        setSize(t) {
            this.height = t, this.width = t;
        }
        setEnvelope(t) {
            this.width = t.getWidth(), this.height = t.getHeight(), this.base = new m(t.getMinX(), t.getMinY()), this.centre = new m(t.centre());
        }
        setCentre(t) {
            this.centre = t;
        }
        getMinSize() {
            return Math.min(this.width, this.height);
        }
    }
    we.Dimensions = Ce;
    class Se extends we {
        constructor(){
            super(), Se.constructor_.apply(this, arguments);
        }
        static constructor_() {
            if (this._numArms = 8, this._armLengthRatio = .5, 0 === arguments.length) we.constructor_.call(this);
            else if (1 === arguments.length) {
                const t = arguments[0];
                we.constructor_.call(this, t);
            }
        }
        static create(t, e, s, n, i) {
            const r = new Se;
            r.setCentre(t), r.setSize(e), r.setNumPoints(s), r.setArmLengthRatio(i), r.setNumArms(n);
            return r.createSineStar();
        }
        setArmLengthRatio(t) {
            this._armLengthRatio = t;
        }
        createSineStar() {
            const t = this._dim.getEnvelope(), e = t.getWidth() / 2;
            let s = this._armLengthRatio;
            s < 0 && (s = 0), s > 1 && (s = 1);
            const n = s * e, i = (1 - s) * e, r = t.getMinX() + e, o = t.getMinY() + e, l = new Array(this._nPts + 1).fill(null);
            let a = 0;
            for(let t = 0; t < this._nPts; t++){
                const e = t / this._nPts * this._numArms, s = e - Math.floor(e), c = 2 * Math.PI * s, h = i + n * ((Math.cos(c) + 1) / 2), u = t * (2 * Math.PI / this._nPts), g = h * Math.cos(u) + r, d = h * Math.sin(u) + o;
                l[a++] = this.coord(g, d);
            }
            l[a] = new m(l[0]);
            const c = this._geomFact.createLinearRing(l);
            return this._geomFact.createPolygon(c);
        }
        setNumArms(t) {
            this._numArms = t;
        }
    }
    var Le = Object.freeze({
        __proto__: null,
        AffineTransformation: ie,
        AffineTransformationBuilder: oe,
        AffineTransformationFactory: le,
        ComponentCoordinateExtracter: ae,
        GeometryCollectionMapper: ce,
        GeometryCombiner: he,
        GeometryEditor: ue,
        GeometryExtracter: de,
        GeometryMapper: _e,
        GeometryTransformer: me,
        LineStringExtracter: fe,
        LinearComponentExtracter: ye,
        PointExtracter: Ee,
        PolygonExtracter: Ie,
        ShortCircuitedGeometryVisitor: Ne,
        SineStarFactory: Se
    }), Te = Object.freeze({
        __proto__: null,
        Coordinate: m,
        CoordinateList: R,
        CoordinateSequenceFilter: P,
        CoordinateXY: y,
        CoordinateXYM: x,
        CoordinateXYZM: E,
        Dimension: Z,
        Envelope: O,
        Geometry: j,
        GeometryCollection: ut,
        GeometryFactory: Lt,
        IntersectionMatrix: Jt,
        LineSegment: Kt,
        LineString: tt,
        LinearRing: et,
        Location: Qt,
        MultiLineString: Et,
        MultiPoint: St,
        MultiPolygon: dt,
        Point: Nt,
        Polygon: Ct,
        PrecisionModel: yt,
        Triangle: se,
        util: Le
    });
    class Re {
        constructor(){
            Re.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._pt = [
                new m,
                new m
            ], this._distance = r.NaN, this._isNull = !0;
        }
        getCoordinates() {
            return this._pt;
        }
        getCoordinate(t) {
            return this._pt[t];
        }
        setMinimum() {
            if (1 === arguments.length) {
                const t = arguments[0];
                this.setMinimum(t._pt[0], t._pt[1]);
            } else if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                if (this._isNull) return this.initialize(t, e), null;
                const s = t.distance(e);
                s < this._distance && this.initialize(t, e, s);
            }
        }
        initialize() {
            if (0 === arguments.length) this._isNull = !0;
            else if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                this._pt[0].setCoordinate(t), this._pt[1].setCoordinate(e), this._distance = t.distance(e), this._isNull = !1;
            } else if (3 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = arguments[2];
                this._pt[0].setCoordinate(t), this._pt[1].setCoordinate(e), this._distance = s, this._isNull = !1;
            }
        }
        toString() {
            return Wt.toLineString(this._pt[0], this._pt[1]);
        }
        getDistance() {
            return this._distance;
        }
        setMaximum() {
            if (1 === arguments.length) {
                const t = arguments[0];
                this.setMaximum(t._pt[0], t._pt[1]);
            } else if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                if (this._isNull) return this.initialize(t, e), null;
                const s = t.distance(e);
                s > this._distance && this.initialize(t, e, s);
            }
        }
    }
    class Pe {
        static computeDistance() {
            if (arguments[2] instanceof Re && arguments[0] instanceof tt && arguments[1] instanceof m) {
                const t = arguments[0], e = arguments[1], s = arguments[2], n = new Kt, i = t.getCoordinates();
                for(let t = 0; t < i.length - 1; t++){
                    n.setCoordinates(i[t], i[t + 1]);
                    const r = n.closestPoint(e);
                    s.setMinimum(r, e);
                }
            } else if (arguments[2] instanceof Re && arguments[0] instanceof Ct && arguments[1] instanceof m) {
                const t = arguments[0], e = arguments[1], s = arguments[2];
                Pe.computeDistance(t.getExteriorRing(), e, s);
                for(let n = 0; n < t.getNumInteriorRing(); n++)Pe.computeDistance(t.getInteriorRingN(n), e, s);
            } else if (arguments[2] instanceof Re && arguments[0] instanceof j && arguments[1] instanceof m) {
                const t = arguments[0], e = arguments[1], s = arguments[2];
                if (t instanceof tt) Pe.computeDistance(t, e, s);
                else if (t instanceof Ct) Pe.computeDistance(t, e, s);
                else if (t instanceof ut) {
                    const n = t;
                    for(let t = 0; t < n.getNumGeometries(); t++){
                        const i = n.getGeometryN(t);
                        Pe.computeDistance(i, e, s);
                    }
                } else s.setMinimum(t.getCoordinate(), e);
            } else if (arguments[2] instanceof Re && arguments[0] instanceof Kt && arguments[1] instanceof m) {
                const t = arguments[1], e = arguments[2], s = arguments[0].closestPoint(t);
                e.setMinimum(s, t);
            }
        }
    }
    class Oe {
        constructor(){
            Oe.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._g0 = null, this._g1 = null, this._ptDist = new Re, this._densifyFrac = 0;
            const t = arguments[0], e = arguments[1];
            this._g0 = t, this._g1 = e;
        }
        static distance() {
            if (2 === arguments.length) return new Oe(arguments[0], arguments[1]).distance();
            if (3 === arguments.length) {
                const t = arguments[2], e = new Oe(arguments[0], arguments[1]);
                return e.setDensifyFraction(t), e.distance();
            }
        }
        getCoordinates() {
            return this._ptDist.getCoordinates();
        }
        setDensifyFraction(t) {
            if (t > 1 || t <= 0) throw new n("Fraction is not in range (0.0 - 1.0]");
            this._densifyFrac = t;
        }
        compute(t, e) {
            this.computeOrientedDistance(t, e, this._ptDist), this.computeOrientedDistance(e, t, this._ptDist);
        }
        distance() {
            return this.compute(this._g0, this._g1), this._ptDist.getDistance();
        }
        computeOrientedDistance(t, e, s) {
            const n = new ve(e);
            if (t.apply(n), s.setMaximum(n.getMaxPointDistance()), this._densifyFrac > 0) {
                const n = new Me(e, this._densifyFrac);
                t.apply(n), s.setMaximum(n.getMaxPointDistance());
            }
        }
        orientedDistance() {
            return this.computeOrientedDistance(this._g0, this._g1, this._ptDist), this._ptDist.getDistance();
        }
    }
    class ve {
        constructor(){
            ve.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._maxPtDist = new Re, this._minPtDist = new Re, this._euclideanDist = new Pe, this._geom = null;
            const t = arguments[0];
            this._geom = t;
        }
        filter(t) {
            this._minPtDist.initialize(), Pe.computeDistance(this._geom, t, this._minPtDist), this._maxPtDist.setMaximum(this._minPtDist);
        }
        getMaxPointDistance() {
            return this._maxPtDist;
        }
        get interfaces_() {
            return [
                K
            ];
        }
    }
    class Me {
        constructor(){
            Me.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._maxPtDist = new Re, this._minPtDist = new Re, this._geom = null, this._numSubSegs = 0;
            const t = arguments[0], e = arguments[1];
            this._geom = t, this._numSubSegs = Math.trunc(Math.round(1 / e));
        }
        filter(t, e) {
            if (0 === e) return null;
            const s = t.getCoordinate(e - 1), n = t.getCoordinate(e), i = (n.x - s.x) / this._numSubSegs, r = (n.y - s.y) / this._numSubSegs;
            for(let t = 0; t < this._numSubSegs; t++){
                const e = s.x + t * i, n = s.y + t * r, o = new m(e, n);
                this._minPtDist.initialize(), Pe.computeDistance(this._geom, o, this._minPtDist), this._maxPtDist.setMaximum(this._minPtDist);
            }
        }
        isGeometryChanged() {
            return !1;
        }
        getMaxPointDistance() {
            return this._maxPtDist;
        }
        isDone() {
            return !1;
        }
        get interfaces_() {
            return [
                P
            ];
        }
    }
    Oe.MaxPointDistanceFilter = ve, Oe.MaxDensifiedByFractionDistanceFilter = Me;
    var be = Object.freeze({
        __proto__: null,
        DiscreteHausdorffDistance: Oe,
        DistanceToPoint: Pe,
        PointPairDistance: Re
    });
    class De {
        visitItem(t) {}
    }
    class Ae {
        locate(t) {}
    }
    class Fe {
        constructor(){
            Fe.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._min = r.POSITIVE_INFINITY, this._max = r.NEGATIVE_INFINITY;
        }
        getMin() {
            return this._min;
        }
        intersects(t, e) {
            return !(this._min > e || this._max < t);
        }
        getMax() {
            return this._max;
        }
        toString() {
            return Wt.toLineString(new m(this._min, 0), new m(this._max, 0));
        }
    }
    Fe.NodeComparator = class {
        compare(t, e) {
            const s = t, n = e, i = (s._min + s._max) / 2, r = (n._min + n._max) / 2;
            return i < r ? -1 : i > r ? 1 : 0;
        }
        get interfaces_() {
            return [
                g
            ];
        }
    };
    class Ge extends Fe {
        constructor(){
            super(), Ge.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._item = null;
            const t = arguments[0], e = arguments[1], s = arguments[2];
            this._min = t, this._max = e, this._item = s;
        }
        query(t, e, s) {
            if (!this.intersects(t, e)) return null;
            s.visitItem(this._item);
        }
    }
    class qe extends Fe {
        constructor(){
            super(), qe.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._node1 = null, this._node2 = null;
            const t = arguments[0], e = arguments[1];
            this._node1 = t, this._node2 = e, this.buildExtent(this._node1, this._node2);
        }
        buildExtent(t, e) {
            this._min = Math.min(t._min, e._min), this._max = Math.max(t._max, e._max);
        }
        query(t, e, s) {
            if (!this.intersects(t, e)) return null;
            null !== this._node1 && this._node1.query(t, e, s), null !== this._node2 && this._node2.query(t, e, s);
        }
    }
    class Be {
        constructor(){
            Be.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._leaves = new L, this._root = null, this._level = 0;
        }
        buildTree() {
            xe.sort(this._leaves, new Fe.NodeComparator);
            let t = this._leaves, e = null, s = new L;
            for(;;){
                if (this.buildLevel(t, s), 1 === s.size()) return s.get(0);
                e = t, t = s, s = e;
            }
        }
        insert(t, e, s) {
            if (null !== this._root) throw new D("Index cannot be added to once it has been queried");
            this._leaves.add(new Ge(t, e, s));
        }
        query(t, e, s) {
            if (this.init(), null === this._root) return null;
            this._root.query(t, e, s);
        }
        buildRoot() {
            if (null !== this._root) return null;
            this._root = this.buildTree();
        }
        printNode(t) {
            Y.out.println(Wt.toLineString(new m(t._min, this._level), new m(t._max, this._level)));
        }
        init() {
            return null !== this._root || 0 === this._leaves.size() ? null : void this.buildRoot();
        }
        buildLevel(t, e) {
            this._level++, e.clear();
            for(let s = 0; s < t.size(); s += 2){
                const n = t.get(s);
                if (null === (s + 1 < t.size() ? t.get(s) : null)) e.add(n);
                else {
                    const n = new qe(t.get(s), t.get(s + 1));
                    e.add(n);
                }
            }
        }
    }
    class Ye {
        constructor(){
            Ye.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._items = new L;
        }
        getItems() {
            return this._items;
        }
        visitItem(t) {
            this._items.add(t);
        }
        get interfaces_() {
            return [
                De
            ];
        }
    }
    class ze {
        constructor(){
            ze.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._p = null, this._crossingCount = 0, this._isPointOnSegment = !1;
            const t = arguments[0];
            this._p = t;
        }
        static locatePointInRing() {
            if (arguments[0] instanceof m && I(arguments[1], G)) {
                const t = arguments[1], e = new ze(arguments[0]), s = new m, n = new m;
                for(let i = 1; i < t.size(); i++)if (t.getCoordinate(i, s), t.getCoordinate(i - 1, n), e.countSegment(s, n), e.isOnSegment()) return e.getLocation();
                return e.getLocation();
            }
            if (arguments[0] instanceof m && arguments[1] instanceof Array) {
                const t = arguments[1], e = new ze(arguments[0]);
                for(let s = 1; s < t.length; s++){
                    const n = t[s], i = t[s - 1];
                    if (e.countSegment(n, i), e.isOnSegment()) return e.getLocation();
                }
                return e.getLocation();
            }
        }
        getLocation() {
            return this._isPointOnSegment ? Qt.BOUNDARY : this._crossingCount % 2 == 1 ? Qt.INTERIOR : Qt.EXTERIOR;
        }
        isPointInPolygon() {
            return this.getLocation() !== Qt.EXTERIOR;
        }
        isOnSegment() {
            return this._isPointOnSegment;
        }
        countSegment(t, e) {
            if (t.x < this._p.x && e.x < this._p.x) return null;
            if (this._p.x === e.x && this._p.y === e.y) return this._isPointOnSegment = !0, null;
            if (t.y === this._p.y && e.y === this._p.y) {
                let s = t.x, n = e.x;
                return s > n && (s = e.x, n = t.x), this._p.x >= s && this._p.x <= n && (this._isPointOnSegment = !0), null;
            }
            if (t.y > this._p.y && e.y <= this._p.y || e.y > this._p.y && t.y <= this._p.y) {
                let s = q.index(t, e, this._p);
                if (s === q.COLLINEAR) return this._isPointOnSegment = !0, null;
                e.y < t.y && (s = -s), s === q.LEFT && this._crossingCount++;
            }
        }
    }
    class Ve {
        constructor(){
            Ve.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._geom = null, this._index = null;
            const t = arguments[0];
            if (!(I(t, gt) || t instanceof et)) throw new n("Argument must be Polygonal or LinearRing");
            this._geom = t;
        }
        locate(t) {
            null === this._index && (this._index = new Xe(this._geom), this._geom = null);
            const e = new ze(t), s = new ke(e);
            return this._index.query(t.y, t.y, s), e.getLocation();
        }
        get interfaces_() {
            return [
                Ae
            ];
        }
    }
    class ke {
        constructor(){
            ke.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._counter = null;
            const t = arguments[0];
            this._counter = t;
        }
        visitItem(t) {
            const e = t;
            this._counter.countSegment(e.getCoordinate(0), e.getCoordinate(1));
        }
        get interfaces_() {
            return [
                De
            ];
        }
    }
    class Xe {
        constructor(){
            Xe.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._isEmpty = !1, this._index = new Be;
            const t = arguments[0];
            t.isEmpty() ? this._isEmpty = !0 : this.init(t);
        }
        init(t) {
            for(let e = ye.getLines(t).iterator(); e.hasNext();){
                const t = e.next().getCoordinates();
                this.addLine(t);
            }
        }
        addLine(t) {
            for(let e = 1; e < t.length; e++){
                const s = new Kt(t[e - 1], t[e]), n = Math.min(s.p0.y, s.p1.y), i = Math.max(s.p0.y, s.p1.y);
                this._index.insert(n, i, s);
            }
        }
        query() {
            if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                if (this._isEmpty) return new L;
                const s = new Ye;
                return this._index.query(t, e, s), s.getItems();
            }
            if (3 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = arguments[2];
                if (this._isEmpty) return null;
                this._index.query(t, e, s);
            }
        }
    }
    Ve.SegmentVisitor = ke, Ve.IntervalIndexedGeometry = Xe;
    class Ue {
        static isInRing(t, e) {
            return Ue.locateInRing(t, e) !== Qt.EXTERIOR;
        }
        static locateInRing(t, e) {
            return ze.locatePointInRing(t, e);
        }
        static isOnLine() {
            if (arguments[0] instanceof m && I(arguments[1], G)) {
                const t = arguments[0], e = arguments[1], s = new jt, n = new m, i = new m, r = e.size();
                for(let o = 1; o < r; o++)if (e.getCoordinate(o - 1, n), e.getCoordinate(o, i), s.computeIntersection(t, n, i), s.hasIntersection()) return !0;
                return !1;
            }
            if (arguments[0] instanceof m && arguments[1] instanceof Array) {
                const t = arguments[0], e = arguments[1], s = new jt;
                for(let n = 1; n < e.length; n++){
                    const i = e[n - 1], r = e[n];
                    if (s.computeIntersection(t, i, r), s.hasIntersection()) return !0;
                }
                return !1;
            }
        }
    }
    class He {
        hasNext() {}
        next() {}
        remove() {}
    }
    class We {
        constructor(){
            We.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._parent = null, this._atStart = null, this._max = null, this._index = null, this._subcollectionIterator = null;
            const t = arguments[0];
            this._parent = t, this._atStart = !0, this._index = 0, this._max = t.getNumGeometries();
        }
        static isAtomic(t) {
            return !(t instanceof ut);
        }
        next() {
            if (this._atStart) return this._atStart = !1, We.isAtomic(this._parent) && this._index++, this._parent;
            if (null !== this._subcollectionIterator) {
                if (this._subcollectionIterator.hasNext()) return this._subcollectionIterator.next();
                this._subcollectionIterator = null;
            }
            if (this._index >= this._max) throw new S;
            const t = this._parent.getGeometryN(this._index++);
            return t instanceof ut ? (this._subcollectionIterator = new We(t), this._subcollectionIterator.next()) : t;
        }
        hasNext() {
            if (this._atStart) return !0;
            if (null !== this._subcollectionIterator) {
                if (this._subcollectionIterator.hasNext()) return !0;
                this._subcollectionIterator = null;
            }
            return !(this._index >= this._max);
        }
        remove() {
            throw new U(this.getClass().getName());
        }
        get interfaces_() {
            return [
                He
            ];
        }
    }
    class Ze {
        constructor(){
            Ze.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._geom = null;
            const t = arguments[0];
            this._geom = t;
        }
        static locatePointInPolygon(t, e) {
            if (e.isEmpty()) return Qt.EXTERIOR;
            const s = e.getExteriorRing(), n = Ze.locatePointInRing(t, s);
            if (n !== Qt.INTERIOR) return n;
            for(let s = 0; s < e.getNumInteriorRing(); s++){
                const n = e.getInteriorRingN(s), i = Ze.locatePointInRing(t, n);
                if (i === Qt.BOUNDARY) return Qt.BOUNDARY;
                if (i === Qt.INTERIOR) return Qt.EXTERIOR;
            }
            return Qt.INTERIOR;
        }
        static locatePointInRing(t, e) {
            return e.getEnvelopeInternal().intersects(t) ? Ue.locateInRing(t, e.getCoordinates()) : Qt.EXTERIOR;
        }
        static isContained(t, e) {
            return Qt.EXTERIOR !== Ze.locate(t, e);
        }
        static locate(t, e) {
            return e.isEmpty() ? Qt.EXTERIOR : e.getEnvelopeInternal().intersects(t) ? Ze.locateInGeometry(t, e) : Qt.EXTERIOR;
        }
        static containsPointInPolygon(t, e) {
            return Qt.EXTERIOR !== Ze.locatePointInPolygon(t, e);
        }
        static locateInGeometry(t, e) {
            if (e instanceof Ct) return Ze.locatePointInPolygon(t, e);
            if (e instanceof ut) {
                const s = new We(e);
                for(; s.hasNext();){
                    const n = s.next();
                    if (n !== e) {
                        const e = Ze.locateInGeometry(t, n);
                        if (e !== Qt.EXTERIOR) return e;
                    }
                }
            }
            return Qt.EXTERIOR;
        }
        locate(t) {
            return Ze.locate(t, this._geom);
        }
        get interfaces_() {
            return [
                Ae
            ];
        }
    }
    var je = Object.freeze({
        __proto__: null,
        IndexedPointInAreaLocator: Ve,
        PointOnGeometryLocator: Ae,
        SimplePointInAreaLocator: Ze
    });
    class Ke {
        measure(t, e) {}
    }
    class Qe {
        constructor(){
            Qe.constructor_.apply(this, arguments);
        }
        static constructor_() {
            if (this._quadrantSegments = Qe.DEFAULT_QUADRANT_SEGMENTS, this._endCapStyle = Qe.CAP_ROUND, this._joinStyle = Qe.JOIN_ROUND, this._mitreLimit = Qe.DEFAULT_MITRE_LIMIT, this._isSingleSided = !1, this._simplifyFactor = Qe.DEFAULT_SIMPLIFY_FACTOR, 0 === arguments.length) ;
            else if (1 === arguments.length) {
                const t = arguments[0];
                this.setQuadrantSegments(t);
            } else if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                this.setQuadrantSegments(t), this.setEndCapStyle(e);
            } else if (4 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = arguments[2], n = arguments[3];
                this.setQuadrantSegments(t), this.setEndCapStyle(e), this.setJoinStyle(s), this.setMitreLimit(n);
            }
        }
        static bufferDistanceError(t) {
            const e = Math.PI / 2 / t;
            return 1 - Math.cos(e / 2);
        }
        getEndCapStyle() {
            return this._endCapStyle;
        }
        isSingleSided() {
            return this._isSingleSided;
        }
        setQuadrantSegments(t) {
            this._quadrantSegments = t, 0 === this._quadrantSegments && (this._joinStyle = Qe.JOIN_BEVEL), this._quadrantSegments < 0 && (this._joinStyle = Qe.JOIN_MITRE, this._mitreLimit = Math.abs(this._quadrantSegments)), t <= 0 && (this._quadrantSegments = 1), this._joinStyle !== Qe.JOIN_ROUND && (this._quadrantSegments = Qe.DEFAULT_QUADRANT_SEGMENTS);
        }
        getJoinStyle() {
            return this._joinStyle;
        }
        setJoinStyle(t) {
            this._joinStyle = t;
        }
        setSimplifyFactor(t) {
            this._simplifyFactor = t < 0 ? 0 : t;
        }
        getSimplifyFactor() {
            return this._simplifyFactor;
        }
        getQuadrantSegments() {
            return this._quadrantSegments;
        }
        setEndCapStyle(t) {
            this._endCapStyle = t;
        }
        getMitreLimit() {
            return this._mitreLimit;
        }
        setMitreLimit(t) {
            this._mitreLimit = t;
        }
        setSingleSided(t) {
            this._isSingleSided = t;
        }
    }
    Qe.CAP_ROUND = 1, Qe.CAP_FLAT = 2, Qe.CAP_SQUARE = 3, Qe.JOIN_ROUND = 1, Qe.JOIN_MITRE = 2, Qe.JOIN_BEVEL = 3, Qe.DEFAULT_QUADRANT_SEGMENTS = 8, Qe.DEFAULT_MITRE_LIMIT = 5, Qe.DEFAULT_SIMPLIFY_FACTOR = .01;
    class Je {
        static relativeSign(t, e) {
            return t < e ? -1 : t > e ? 1 : 0;
        }
        static compareValue(t, e) {
            return t < 0 ? -1 : t > 0 ? 1 : e < 0 ? -1 : e > 0 ? 1 : 0;
        }
        static compare(t, e, s) {
            if (e.equals2D(s)) return 0;
            const n = Je.relativeSign(e.x, s.x), i = Je.relativeSign(e.y, s.y);
            switch(t){
                case 0:
                    return Je.compareValue(n, i);
                case 1:
                    return Je.compareValue(i, n);
                case 2:
                    return Je.compareValue(i, -n);
                case 3:
                    return Je.compareValue(-n, i);
                case 4:
                    return Je.compareValue(-n, -i);
                case 5:
                    return Je.compareValue(-i, -n);
                case 6:
                    return Je.compareValue(-i, n);
                case 7:
                    return Je.compareValue(n, -i);
            }
            return h.shouldNeverReachHere("invalid octant value"), 0;
        }
    }
    class $e {
        constructor(){
            $e.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._segString = null, this.coord = null, this.segmentIndex = null, this._segmentOctant = null, this._isInterior = null;
            const t = arguments[0], e = arguments[1], s = arguments[2], n = arguments[3];
            this._segString = t, this.coord = new m(e), this.segmentIndex = s, this._segmentOctant = n, this._isInterior = !e.equals2D(t.getCoordinate(s));
        }
        getCoordinate() {
            return this.coord;
        }
        print(t) {
            t.print(this.coord), t.print(" seg # = " + this.segmentIndex);
        }
        compareTo(t) {
            const e = t;
            return this.segmentIndex < e.segmentIndex ? -1 : this.segmentIndex > e.segmentIndex ? 1 : this.coord.equals2D(e.coord) ? 0 : this._isInterior ? e._isInterior ? Je.compare(this._segmentOctant, this.coord, e.coord) : 1 : -1;
        }
        isEndPoint(t) {
            return 0 === this.segmentIndex && !this._isInterior || this.segmentIndex === t;
        }
        toString() {
            return this.segmentIndex + ":" + this.coord.toString();
        }
        isInterior() {
            return this._isInterior;
        }
        get interfaces_() {
            return [
                o
            ];
        }
    }
    class ts extends _t {
    }
    function es(t) {
        return null == t ? 0 : t.color;
    }
    function ss(t) {
        return null == t ? null : t.parent;
    }
    function ns(t, e) {
        null !== t && (t.color = e);
    }
    function is(t) {
        return null == t ? null : t.left;
    }
    function rs(t) {
        return null == t ? null : t.right;
    }
    class os extends ts {
        constructor(){
            super(), this.root_ = null, this.size_ = 0;
        }
        get(t) {
            let e = this.root_;
            for(; null !== e;){
                const s = t.compareTo(e.key);
                if (s < 0) e = e.left;
                else {
                    if (!(s > 0)) return e.value;
                    e = e.right;
                }
            }
            return null;
        }
        put(t, e) {
            if (null === this.root_) return this.root_ = {
                key: t,
                value: e,
                left: null,
                right: null,
                parent: null,
                color: 0,
                getValue () {
                    return this.value;
                },
                getKey () {
                    return this.key;
                }
            }, this.size_ = 1, null;
            let s, n, i = this.root_;
            do if (s = i, n = t.compareTo(i.key), n < 0) i = i.left;
            else {
                if (!(n > 0)) {
                    const t = i.value;
                    return i.value = e, t;
                }
                i = i.right;
            }
            while (null !== i);
            const r = {
                key: t,
                left: null,
                right: null,
                value: e,
                parent: s,
                color: 0,
                getValue () {
                    return this.value;
                },
                getKey () {
                    return this.key;
                }
            };
            return n < 0 ? s.left = r : s.right = r, this.fixAfterInsertion(r), this.size_++, null;
        }
        fixAfterInsertion(t) {
            let e;
            for(t.color = 1; null != t && t !== this.root_ && 1 === t.parent.color;)ss(t) === is(ss(ss(t))) ? (e = rs(ss(ss(t))), 1 === es(e) ? (ns(ss(t), 0), ns(e, 0), ns(ss(ss(t)), 1), t = ss(ss(t))) : (t === rs(ss(t)) && (t = ss(t), this.rotateLeft(t)), ns(ss(t), 0), ns(ss(ss(t)), 1), this.rotateRight(ss(ss(t))))) : (e = is(ss(ss(t))), 1 === es(e) ? (ns(ss(t), 0), ns(e, 0), ns(ss(ss(t)), 1), t = ss(ss(t))) : (t === is(ss(t)) && (t = ss(t), this.rotateRight(t)), ns(ss(t), 0), ns(ss(ss(t)), 1), this.rotateLeft(ss(ss(t)))));
            this.root_.color = 0;
        }
        values() {
            const t = new L;
            let e = this.getFirstEntry();
            if (null !== e) for(t.add(e.value); null !== (e = os.successor(e));)t.add(e.value);
            return t;
        }
        entrySet() {
            const t = new pt;
            let e = this.getFirstEntry();
            if (null !== e) for(t.add(e); null !== (e = os.successor(e));)t.add(e);
            return t;
        }
        rotateLeft(t) {
            if (null != t) {
                const e = t.right;
                t.right = e.left, null != e.left && (e.left.parent = t), e.parent = t.parent, null == t.parent ? this.root_ = e : t.parent.left === t ? t.parent.left = e : t.parent.right = e, e.left = t, t.parent = e;
            }
        }
        rotateRight(t) {
            if (null != t) {
                const e = t.left;
                t.left = e.right, null != e.right && (e.right.parent = t), e.parent = t.parent, null == t.parent ? this.root_ = e : t.parent.right === t ? t.parent.right = e : t.parent.left = e, e.right = t, t.parent = e;
            }
        }
        getFirstEntry() {
            let t = this.root_;
            if (null != t) for(; null != t.left;)t = t.left;
            return t;
        }
        static successor(t) {
            let e;
            if (null === t) return null;
            if (null !== t.right) {
                for(e = t.right; null !== e.left;)e = e.left;
                return e;
            }
            {
                e = t.parent;
                let s = t;
                for(; null !== e && s === e.right;)s = e, e = e.parent;
                return e;
            }
        }
        size() {
            return this.size_;
        }
        containsKey(t) {
            let e = this.root_;
            for(; null !== e;){
                const s = t.compareTo(e.key);
                if (s < 0) e = e.left;
                else {
                    if (!(s > 0)) return !0;
                    e = e.right;
                }
            }
            return !1;
        }
    }
    class ls {
        constructor(){
            ls.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._nodeMap = new os, this._edge = null;
            const t = arguments[0];
            this._edge = t;
        }
        getSplitCoordinates() {
            const t = new R;
            this.addEndpoints();
            const e = this.iterator();
            let s = e.next();
            for(; e.hasNext();){
                const n = e.next();
                this.addEdgeCoordinates(s, n, t), s = n;
            }
            return t.toCoordinateArray();
        }
        print(t) {
            t.println("Intersections:");
            for(let e = this.iterator(); e.hasNext();)e.next().print(t);
        }
        findCollapsesFromExistingVertices(t) {
            for(let e = 0; e < this._edge.size() - 2; e++){
                const s = this._edge.getCoordinate(e);
                this._edge.getCoordinate(e + 1);
                const n = this._edge.getCoordinate(e + 2);
                s.equals2D(n) && t.add(M.valueOf(e + 1));
            }
        }
        addEdgeCoordinates(t, e, s) {
            const n = this.createSplitEdgePts(t, e);
            s.add(n, !1);
        }
        findCollapseIndex(t, e, s) {
            if (!t.coord.equals2D(e.coord)) return !1;
            let n = e.segmentIndex - t.segmentIndex;
            return e.isInterior() || n--, 1 === n && (s[0] = t.segmentIndex + 1, !0);
        }
        findCollapsesFromInsertedNodes(t) {
            const e = new Array(1).fill(null), s = this.iterator();
            let n = s.next();
            for(; s.hasNext();){
                const i = s.next();
                this.findCollapseIndex(n, i, e) && t.add(M.valueOf(e[0])), n = i;
            }
        }
        getEdge() {
            return this._edge;
        }
        addEndpoints() {
            const t = this._edge.size() - 1;
            this.add(this._edge.getCoordinate(0), 0), this.add(this._edge.getCoordinate(t), t);
        }
        createSplitEdge(t, e) {
            const s = this.createSplitEdgePts(t, e);
            return new us(s, this._edge.getData());
        }
        add(t, e) {
            const s = new $e(this._edge, t, e, this._edge.getSegmentOctant(e)), n = this._nodeMap.get(s);
            return null !== n ? (h.isTrue(n.coord.equals2D(t), "Found equal nodes with different coordinates"), n) : (this._nodeMap.put(s, s), s);
        }
        checkSplitEdgesCorrectness(t) {
            const e = this._edge.getCoordinates(), s = t.get(0).getCoordinate(0);
            if (!s.equals2D(e[0])) throw new a("bad split edge start point at " + s);
            const n = t.get(t.size() - 1).getCoordinates(), i = n[n.length - 1];
            if (!i.equals2D(e[e.length - 1])) throw new a("bad split edge end point at " + i);
        }
        addCollapsedNodes() {
            const t = new L;
            this.findCollapsesFromInsertedNodes(t), this.findCollapsesFromExistingVertices(t);
            for(let e = t.iterator(); e.hasNext();){
                const t = e.next().intValue();
                this.add(this._edge.getCoordinate(t), t);
            }
        }
        createSplitEdgePts(t, e) {
            let s = e.segmentIndex - t.segmentIndex + 2;
            if (2 === s) return [
                new m(t.coord),
                new m(e.coord)
            ];
            const n = this._edge.getCoordinate(e.segmentIndex), i = e.isInterior() || !e.coord.equals2D(n);
            i || s--;
            const r = new Array(s).fill(null);
            let o = 0;
            r[o++] = new m(t.coord);
            for(let s = t.segmentIndex + 1; s <= e.segmentIndex; s++)r[o++] = this._edge.getCoordinate(s);
            return i && (r[o] = new m(e.coord)), r;
        }
        iterator() {
            return this._nodeMap.values().iterator();
        }
        addSplitEdges(t) {
            this.addEndpoints(), this.addCollapsedNodes();
            const e = this.iterator();
            let s = e.next();
            for(; e.hasNext();){
                const n = e.next(), i = this.createSplitEdge(s, n);
                t.add(i), s = n;
            }
        }
    }
    class as {
        static octant() {
            if ("number" == typeof arguments[0] && "number" == typeof arguments[1]) {
                const t = arguments[0], e = arguments[1];
                if (0 === t && 0 === e) throw new n("Cannot compute the octant for point ( " + t + ", " + e + " )");
                const s = Math.abs(t), i = Math.abs(e);
                return t >= 0 ? e >= 0 ? s >= i ? 0 : 1 : s >= i ? 7 : 6 : e >= 0 ? s >= i ? 3 : 2 : s >= i ? 4 : 5;
            }
            if (arguments[0] instanceof m && arguments[1] instanceof m) {
                const t = arguments[0], e = arguments[1], s = e.x - t.x, i = e.y - t.y;
                if (0 === s && 0 === i) throw new n("Cannot compute the octant for two identical points " + t);
                return as.octant(s, i);
            }
        }
    }
    class cs {
        getCoordinates() {}
        size() {}
        getCoordinate(t) {}
        isClosed() {}
        setData(t) {}
        getData() {}
    }
    class hs {
        addIntersection(t, e) {}
        get interfaces_() {
            return [
                cs
            ];
        }
    }
    class us {
        constructor(){
            us.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._nodeList = new ls(this), this._pts = null, this._data = null;
            const t = arguments[0], e = arguments[1];
            this._pts = t, this._data = e;
        }
        static getNodedSubstrings() {
            if (1 === arguments.length) {
                const t = arguments[0], e = new L;
                return us.getNodedSubstrings(t, e), e;
            }
            if (2 === arguments.length) {
                const t = arguments[1];
                for(let e = arguments[0].iterator(); e.hasNext();)e.next().getNodeList().addSplitEdges(t);
            }
        }
        getCoordinates() {
            return this._pts;
        }
        size() {
            return this._pts.length;
        }
        getCoordinate(t) {
            return this._pts[t];
        }
        isClosed() {
            return this._pts[0].equals(this._pts[this._pts.length - 1]);
        }
        getSegmentOctant(t) {
            return t === this._pts.length - 1 ? -1 : this.safeOctant(this.getCoordinate(t), this.getCoordinate(t + 1));
        }
        toString() {
            return Wt.toLineString(new it(this._pts));
        }
        getNodeList() {
            return this._nodeList;
        }
        addIntersectionNode(t, e) {
            let s = e;
            const n = s + 1;
            if (n < this._pts.length) {
                const e = this._pts[n];
                t.equals2D(e) && (s = n);
            }
            return this._nodeList.add(t, s);
        }
        addIntersections(t, e, s) {
            for(let n = 0; n < t.getIntersectionNum(); n++)this.addIntersection(t, e, s, n);
        }
        setData(t) {
            this._data = t;
        }
        safeOctant(t, e) {
            return t.equals2D(e) ? 0 : as.octant(t, e);
        }
        getData() {
            return this._data;
        }
        addIntersection() {
            if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                this.addIntersectionNode(t, e);
            } else if (4 === arguments.length) {
                const t = arguments[1], e = arguments[3], s = new m(arguments[0].getIntersection(e));
                this.addIntersection(s, t);
            }
        }
        get interfaces_() {
            return [
                hs
            ];
        }
    }
    class gs {
        getNodedSubstrings() {}
        computeNodes(t) {}
    }
    class ds {
        constructor(){
            ds.constructor_.apply(this, arguments);
        }
        static constructor_() {
            if (this._noder = null, this._scaleFactor = null, this._offsetX = null, this._offsetY = null, this._isScaled = !1, 2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                ds.constructor_.call(this, t, e, 0, 0);
            } else if (4 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                this._noder = t, this._scaleFactor = e, this._isScaled = !this.isIntegerPrecision();
            }
        }
        rescale() {
            if (I(arguments[0], N)) for(let t = arguments[0].iterator(); t.hasNext();){
                const e = t.next();
                this.rescale(e.getCoordinates());
            }
            else if (arguments[0] instanceof Array) {
                const t = arguments[0];
                for(let e = 0; e < t.length; e++)t[e].x = t[e].x / this._scaleFactor + this._offsetX, t[e].y = t[e].y / this._scaleFactor + this._offsetY;
                2 === t.length && t[0].equals2D(t[1]) && Y.out.println(t);
            }
        }
        scale() {
            if (I(arguments[0], N)) {
                const t = arguments[0], e = new L(t.size());
                for(let s = t.iterator(); s.hasNext();){
                    const t = s.next();
                    e.add(new us(this.scale(t.getCoordinates()), t.getData()));
                }
                return e;
            }
            if (arguments[0] instanceof Array) {
                const t = arguments[0], e = new Array(t.length).fill(null);
                for(let s = 0; s < t.length; s++)e[s] = new m(Math.round((t[s].x - this._offsetX) * this._scaleFactor), Math.round((t[s].y - this._offsetY) * this._scaleFactor), t[s].getZ());
                return W.removeRepeatedPoints(e);
            }
        }
        isIntegerPrecision() {
            return 1 === this._scaleFactor;
        }
        getNodedSubstrings() {
            const t = this._noder.getNodedSubstrings();
            return this._isScaled && this.rescale(t), t;
        }
        computeNodes(t) {
            let e = t;
            this._isScaled && (e = this.scale(t)), this._noder.computeNodes(e);
        }
        get interfaces_() {
            return [
                gs
            ];
        }
    }
    class _s extends a {
        constructor(t, e){
            super(e ? t + " [ " + e + " ]" : t), this.pt = e ? new m(e) : void 0, this.name = Object.keys({
                TopologyException: _s
            })[0];
        }
        getCoordinate() {
            return this.pt;
        }
    }
    class ps {
        constructor(){
            ps.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._li = new jt, this._segStrings = null;
            const t = arguments[0];
            this._segStrings = t;
        }
        checkEndPtVertexIntersections() {
            if (0 === arguments.length) for(let t = this._segStrings.iterator(); t.hasNext();){
                const e = t.next().getCoordinates();
                this.checkEndPtVertexIntersections(e[0], this._segStrings), this.checkEndPtVertexIntersections(e[e.length - 1], this._segStrings);
            }
            else if (2 === arguments.length) {
                const t = arguments[0];
                for(let e = arguments[1].iterator(); e.hasNext();){
                    const s = e.next().getCoordinates();
                    for(let e = 1; e < s.length - 1; e++)if (s[e].equals(t)) throw new a("found endpt/interior pt intersection at index " + e + " :pt " + t);
                }
            }
        }
        checkInteriorIntersections() {
            if (0 === arguments.length) for(let t = this._segStrings.iterator(); t.hasNext();){
                const e = t.next();
                for(let t = this._segStrings.iterator(); t.hasNext();){
                    const s = t.next();
                    this.checkInteriorIntersections(e, s);
                }
            }
            else if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = t.getCoordinates(), n = e.getCoordinates();
                for(let i = 0; i < s.length - 1; i++)for(let s = 0; s < n.length - 1; s++)this.checkInteriorIntersections(t, i, e, s);
            } else if (4 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = arguments[2], n = arguments[3];
                if (t === s && e === n) return null;
                const i = t.getCoordinates()[e], r = t.getCoordinates()[e + 1], o = s.getCoordinates()[n], l = s.getCoordinates()[n + 1];
                if (this._li.computeIntersection(i, r, o, l), this._li.hasIntersection() && (this._li.isProper() || this.hasInteriorIntersection(this._li, i, r) || this.hasInteriorIntersection(this._li, o, l))) throw new a("found non-noded intersection at " + i + "-" + r + " and " + o + "-" + l);
            }
        }
        checkValid() {
            this.checkEndPtVertexIntersections(), this.checkInteriorIntersections(), this.checkCollapses();
        }
        checkCollapses() {
            if (0 === arguments.length) for(let t = this._segStrings.iterator(); t.hasNext();){
                const e = t.next();
                this.checkCollapses(e);
            }
            else if (1 === arguments.length) {
                const t = arguments[0].getCoordinates();
                for(let e = 0; e < t.length - 2; e++)this.checkCollapse(t[e], t[e + 1], t[e + 2]);
            }
        }
        hasInteriorIntersection(t, e, s) {
            for(let n = 0; n < t.getIntersectionNum(); n++){
                const i = t.getIntersection(n);
                if (!i.equals(e) && !i.equals(s)) return !0;
            }
            return !1;
        }
        checkCollapse(t, e, s) {
            if (t.equals(s)) throw new a("found non-noded collapse at " + ps.fact.createLineString([
                t,
                e,
                s
            ]));
        }
    }
    ps.fact = new Lt;
    class ms {
        getBounds() {}
    }
    class fs {
        constructor(){
            fs.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._bounds = null, this._item = null;
            const t = arguments[0], e = arguments[1];
            this._bounds = t, this._item = e;
        }
        getItem() {
            return this._item;
        }
        getBounds() {
            return this._bounds;
        }
        get interfaces_() {
            return [
                ms,
                l
            ];
        }
    }
    function ys(t) {
        return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
    }
    var xs, Es;
    var Is = function() {
        if (Es) return xs;
        Es = 1;
        var t = function(t, e) {
            return t < e;
        };
        function e(s) {
            if (!(this instanceof e)) return new e(s);
            this.array = [], this.size = 0, this.compare = s || t;
        }
        return e.prototype.clone = function() {
            var t = new e(this.compare);
            return t.size = this.size, t.array = this.array.slice(0, this.size), t;
        }, e.prototype.add = function(t) {
            var e, s, n = this.size;
            for(this.array[this.size] = t, this.size += 1; n > 0 && (e = n - 1 >> 1, s = this.array[e], this.compare(t, s));)this.array[n] = s, n = e;
            this.array[n] = t;
        }, e.prototype.heapify = function(t) {
            var e;
            for(this.array = t, this.size = t.length, e = this.size >> 1; e >= 0; e--)this._percolateDown(e);
        }, e.prototype._percolateUp = function(t, e) {
            for(var s, n, i = this.array[t]; t > 0 && (s = t - 1 >> 1, n = this.array[s], e || this.compare(i, n));)this.array[t] = n, t = s;
            this.array[t] = i;
        }, e.prototype._percolateDown = function(t) {
            for(var e, s, n, i = this.size, r = this.size >>> 1, o = this.array[t]; t < r && (s = (e = 1 + (t << 1)) + 1, n = this.array[e], s < i && this.compare(this.array[s], n) && (e = s, n = this.array[s]), this.compare(n, o));)this.array[t] = n, t = e;
            this.array[t] = o;
        }, e.prototype._removeAt = function(t) {
            if (!(t > this.size - 1 || t < 0)) return this._percolateUp(t, !0), this.poll();
        }, e.prototype.remove = function(t) {
            for(var e = 0; e < this.size; e++)if (!this.compare(this.array[e], t) && !this.compare(t, this.array[e])) return this._removeAt(e), !0;
            return !1;
        }, e.prototype.removeOne = function(t) {
            if ("function" == typeof t) {
                for(var e = 0; e < this.size; e++)if (t(this.array[e])) return this._removeAt(e);
            }
        }, e.prototype.removeMany = function(t, e) {
            if ("function" != typeof t || this.size < 1) return [];
            e = e ? Math.min(e, this.size) : this.size;
            for(var s = 0, n = new Array(e), i = 0, r = new Array(this.size); s < e && !this.isEmpty();){
                var o = this.poll();
                t(o) ? n[s++] = o : r[i++] = o;
            }
            n.length = s;
            for(var l = 0; l < i;)this.add(r[l++]);
            return n;
        }, e.prototype.peek = function() {
            if (0 != this.size) return this.array[0];
        }, e.prototype.poll = function() {
            if (0 != this.size) {
                var t = this.array[0];
                return this.size > 1 ? (this.array[0] = this.array[--this.size], this._percolateDown(0)) : this.size -= 1, t;
            }
        }, e.prototype.replaceTop = function(t) {
            if (0 != this.size) {
                var e = this.array[0];
                return this.array[0] = t, this._percolateDown(0), e;
            }
        }, e.prototype.trim = function() {
            this.array = this.array.slice(0, this.size);
        }, e.prototype.isEmpty = function() {
            return 0 === this.size;
        }, e.prototype.forEach = function(t) {
            if (!this.isEmpty() && "function" == typeof t) for(var e = 0, s = this.clone(); !s.isEmpty();)t(s.poll(), e++);
        }, e.prototype.kSmallest = function(t) {
            if (0 == this.size || t <= 0) return [];
            t = Math.min(this.size, t);
            const s = Math.min(this.size, 2 ** (t - 1) + 1);
            if (s < 2) return [
                this.peek()
            ];
            const n = new e(this.compare);
            n.size = s, n.array = this.array.slice(0, s);
            const i = new Array(t);
            for(let e = 0; e < t; e++)i[e] = n.poll();
            return i;
        }, xs = e;
    }(), Ns = ys(Is);
    let ws = class {
        constructor(){
            this._fpQueue = new Ns((t, e)=>t.compareTo(e) < 0);
        }
        poll() {
            return this._fpQueue.poll();
        }
        size() {
            return this._fpQueue.size;
        }
        clear() {
            this._fpQueue = new Ns;
        }
        peek() {
            return this._fpQueue.peek();
        }
        remove() {
            return this._fpQueue.poll();
        }
        isEmpty() {
            return this._fpQueue.isEmpty();
        }
        add(t) {
            this._fpQueue.add(t);
        }
    };
    class Cs {
        query() {}
        insert(t, e) {}
        remove(t, e) {}
    }
    class Ss {
        constructor(){
            Ss.constructor_.apply(this, arguments);
        }
        static constructor_() {
            if (this._childBoundables = new L, this._bounds = null, this._level = null, 0 === arguments.length) ;
            else if (1 === arguments.length) {
                const t = arguments[0];
                this._level = t;
            }
        }
        getLevel() {
            return this._level;
        }
        addChildBoundable(t) {
            h.isTrue(null === this._bounds), this._childBoundables.add(t);
        }
        isEmpty() {
            return this._childBoundables.isEmpty();
        }
        getBounds() {
            return null === this._bounds && (this._bounds = this.computeBounds()), this._bounds;
        }
        size() {
            return this._childBoundables.size();
        }
        getChildBoundables() {
            return this._childBoundables;
        }
        get interfaces_() {
            return [
                ms,
                l
            ];
        }
    }
    class Ls {
        static distance(t, e, s, n) {
            const i = s - t, r = n - e;
            return Math.sqrt(i * i + r * r);
        }
        static maximumDistance(t, e) {
            const s = Math.min(t.getMinX(), e.getMinX()), n = Math.min(t.getMinY(), e.getMinY()), i = Math.max(t.getMaxX(), e.getMaxX()), r = Math.max(t.getMaxY(), e.getMaxY());
            return Ls.distance(s, n, i, r);
        }
        static minMaxDistance(t, e) {
            const s = t.getMinX(), n = t.getMinY(), i = t.getMaxX(), r = t.getMaxY(), o = e.getMinX(), l = e.getMinY(), a = e.getMaxX(), c = e.getMaxY();
            let h = Ls.maxDistance(s, n, s, r, o, l, o, c);
            return h = Math.min(h, Ls.maxDistance(s, n, s, r, o, l, a, l)), h = Math.min(h, Ls.maxDistance(s, n, s, r, a, c, o, c)), h = Math.min(h, Ls.maxDistance(s, n, s, r, a, c, a, l)), h = Math.min(h, Ls.maxDistance(s, n, i, n, o, l, o, c)), h = Math.min(h, Ls.maxDistance(s, n, i, n, o, l, a, l)), h = Math.min(h, Ls.maxDistance(s, n, i, n, a, c, o, c)), h = Math.min(h, Ls.maxDistance(s, n, i, n, a, c, a, l)), h = Math.min(h, Ls.maxDistance(i, r, s, r, o, l, o, c)), h = Math.min(h, Ls.maxDistance(i, r, s, r, o, l, a, l)), h = Math.min(h, Ls.maxDistance(i, r, s, r, a, c, o, c)), h = Math.min(h, Ls.maxDistance(i, r, s, r, a, c, a, l)), h = Math.min(h, Ls.maxDistance(i, r, i, n, o, l, o, c)), h = Math.min(h, Ls.maxDistance(i, r, i, n, o, l, a, l)), h = Math.min(h, Ls.maxDistance(i, r, i, n, a, c, o, c)), h = Math.min(h, Ls.maxDistance(i, r, i, n, a, c, a, l)), h;
        }
        static maxDistance(t, e, s, n, i, r, o, l) {
            let a = Ls.distance(t, e, i, r);
            return a = Math.max(a, Ls.distance(t, e, o, l)), a = Math.max(a, Ls.distance(s, n, i, r)), a = Math.max(a, Ls.distance(s, n, o, l)), a;
        }
    }
    class Ts {
        constructor(){
            Ts.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._boundable1 = null, this._boundable2 = null, this._distance = null, this._itemDistance = null;
            const t = arguments[0], e = arguments[1], s = arguments[2];
            this._boundable1 = t, this._boundable2 = e, this._itemDistance = s, this._distance = this.distance();
        }
        static area(t) {
            return t.getBounds().getArea();
        }
        static isComposite(t) {
            return t instanceof Ss;
        }
        maximumDistance() {
            return Ls.maximumDistance(this._boundable1.getBounds(), this._boundable2.getBounds());
        }
        expandToQueue(t, e) {
            const s = Ts.isComposite(this._boundable1), i = Ts.isComposite(this._boundable2);
            if (s && i) return Ts.area(this._boundable1) > Ts.area(this._boundable2) ? (this.expand(this._boundable1, this._boundable2, !1, t, e), null) : (this.expand(this._boundable2, this._boundable1, !0, t, e), null);
            if (s) return this.expand(this._boundable1, this._boundable2, !1, t, e), null;
            if (i) return this.expand(this._boundable2, this._boundable1, !0, t, e), null;
            throw new n("neither boundable is composite");
        }
        isLeaves() {
            return !(Ts.isComposite(this._boundable1) || Ts.isComposite(this._boundable2));
        }
        getBoundable(t) {
            return 0 === t ? this._boundable1 : this._boundable2;
        }
        getDistance() {
            return this._distance;
        }
        distance() {
            return this.isLeaves() ? this._itemDistance.distance(this._boundable1, this._boundable2) : this._boundable1.getBounds().distance(this._boundable2.getBounds());
        }
        compareTo(t) {
            const e = t;
            return this._distance < e._distance ? -1 : this._distance > e._distance ? 1 : 0;
        }
        expand(t, e, s, n, i) {
            for(let r = t.getChildBoundables().iterator(); r.hasNext();){
                const t = r.next();
                let o = null;
                o = s ? new Ts(e, t, this._itemDistance) : new Ts(t, e, this._itemDistance), o.getDistance() < i && n.add(o);
            }
        }
        get interfaces_() {
            return [
                o
            ];
        }
    }
    class Rs {
        constructor(){
            Rs.constructor_.apply(this, arguments);
        }
        static constructor_() {
            if (this._root = null, this._built = !1, this._itemBoundables = new L, this._nodeCapacity = null, 0 === arguments.length) Rs.constructor_.call(this, Rs.DEFAULT_NODE_CAPACITY);
            else if (1 === arguments.length) {
                const t = arguments[0];
                h.isTrue(t > 1, "Node capacity must be greater than 1"), this._nodeCapacity = t;
            }
        }
        static compareDoubles(t, e) {
            return t > e ? 1 : t < e ? -1 : 0;
        }
        queryInternal() {
            if (I(arguments[2], De) && arguments[0] instanceof Object && arguments[1] instanceof Ss) {
                const t = arguments[0], e = arguments[2], s = arguments[1].getChildBoundables();
                for(let n = 0; n < s.size(); n++){
                    const i = s.get(n);
                    this.getIntersectsOp().intersects(i.getBounds(), t) && (i instanceof Ss ? this.queryInternal(t, i, e) : i instanceof fs ? e.visitItem(i.getItem()) : h.shouldNeverReachHere());
                }
            } else if (I(arguments[2], C) && arguments[0] instanceof Object && arguments[1] instanceof Ss) {
                const t = arguments[0], e = arguments[2], s = arguments[1].getChildBoundables();
                for(let n = 0; n < s.size(); n++){
                    const i = s.get(n);
                    this.getIntersectsOp().intersects(i.getBounds(), t) && (i instanceof Ss ? this.queryInternal(t, i, e) : i instanceof fs ? e.add(i.getItem()) : h.shouldNeverReachHere());
                }
            }
        }
        insert(t, e) {
            h.isTrue(!this._built, "Cannot insert items into an STR packed R-tree after it has been built."), this._itemBoundables.add(new fs(t, e));
        }
        boundablesAtLevel() {
            if (1 === arguments.length) {
                const t = arguments[0], e = new L;
                return this.boundablesAtLevel(t, this._root, e), e;
            }
            if (3 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = arguments[2];
                if (h.isTrue(t > -2), e.getLevel() === t) return s.add(e), null;
                for(let n = e.getChildBoundables().iterator(); n.hasNext();){
                    const e = n.next();
                    e instanceof Ss ? this.boundablesAtLevel(t, e, s) : (h.isTrue(e instanceof fs), -1 === t && s.add(e));
                }
                return null;
            }
        }
        getRoot() {
            return this.build(), this._root;
        }
        remove() {
            if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                return this.build(), !!this.getIntersectsOp().intersects(this._root.getBounds(), t) && this.remove(t, this._root, e);
            }
            if (3 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = arguments[2];
                let n = this.removeItem(e, s);
                if (n) return !0;
                let i = null;
                for(let r = e.getChildBoundables().iterator(); r.hasNext();){
                    const e = r.next();
                    if (this.getIntersectsOp().intersects(e.getBounds(), t) && e instanceof Ss && (n = this.remove(t, e, s), n)) {
                        i = e;
                        break;
                    }
                }
                return null !== i && i.getChildBoundables().isEmpty() && e.getChildBoundables().remove(i), n;
            }
        }
        createHigherLevels(t, e) {
            h.isTrue(!t.isEmpty());
            const s = this.createParentBoundables(t, e + 1);
            return 1 === s.size() ? s.get(0) : this.createHigherLevels(s, e + 1);
        }
        depth() {
            if (0 === arguments.length) return this.isEmpty() ? 0 : (this.build(), this.depth(this._root));
            if (1 === arguments.length) {
                let t = 0;
                for(let e = arguments[0].getChildBoundables().iterator(); e.hasNext();){
                    const s = e.next();
                    if (s instanceof Ss) {
                        const e = this.depth(s);
                        e > t && (t = e);
                    }
                }
                return t + 1;
            }
        }
        createParentBoundables(t, e) {
            h.isTrue(!t.isEmpty());
            const s = new L;
            s.add(this.createNode(e));
            const n = new L(t);
            xe.sort(n, this.getComparator());
            for(let t = n.iterator(); t.hasNext();){
                const n = t.next();
                this.lastNode(s).getChildBoundables().size() === this.getNodeCapacity() && s.add(this.createNode(e)), this.lastNode(s).addChildBoundable(n);
            }
            return s;
        }
        isEmpty() {
            return this._built ? this._root.isEmpty() : this._itemBoundables.isEmpty();
        }
        getNodeCapacity() {
            return this._nodeCapacity;
        }
        lastNode(t) {
            return t.get(t.size() - 1);
        }
        size() {
            if (0 === arguments.length) return this.isEmpty() ? 0 : (this.build(), this.size(this._root));
            if (1 === arguments.length) {
                let t = 0;
                for(let e = arguments[0].getChildBoundables().iterator(); e.hasNext();){
                    const s = e.next();
                    s instanceof Ss ? t += this.size(s) : s instanceof fs && (t += 1);
                }
                return t;
            }
        }
        removeItem(t, e) {
            let s = null;
            for(let n = t.getChildBoundables().iterator(); n.hasNext();){
                const t = n.next();
                t instanceof fs && t.getItem() === e && (s = t);
            }
            return null !== s && (t.getChildBoundables().remove(s), !0);
        }
        itemsTree() {
            if (0 === arguments.length) {
                this.build();
                const t = this.itemsTree(this._root);
                return null === t ? new L : t;
            }
            if (1 === arguments.length) {
                const t = arguments[0], e = new L;
                for(let s = t.getChildBoundables().iterator(); s.hasNext();){
                    const t = s.next();
                    if (t instanceof Ss) {
                        const s = this.itemsTree(t);
                        null !== s && e.add(s);
                    } else t instanceof fs ? e.add(t.getItem()) : h.shouldNeverReachHere();
                }
                return e.size() <= 0 ? null : e;
            }
        }
        query() {
            if (1 === arguments.length) {
                const t = arguments[0];
                this.build();
                const e = new L;
                return this.isEmpty() || this.getIntersectsOp().intersects(this._root.getBounds(), t) && this.queryInternal(t, this._root, e), e;
            }
            if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                if (this.build(), this.isEmpty()) return null;
                this.getIntersectsOp().intersects(this._root.getBounds(), t) && this.queryInternal(t, this._root, e);
            }
        }
        build() {
            if (this._built) return null;
            this._root = this._itemBoundables.isEmpty() ? this.createNode(0) : this.createHigherLevels(this._itemBoundables, -1), this._itemBoundables = null, this._built = !0;
        }
        get interfaces_() {
            return [
                l
            ];
        }
    }
    Rs.IntersectsOp = function() {}, Rs.DEFAULT_NODE_CAPACITY = 10;
    class Ps {
        distance(t, e) {}
    }
    class Os extends Rs {
        constructor(){
            super(), Os.constructor_.apply(this, arguments);
        }
        static constructor_() {
            if (0 === arguments.length) Os.constructor_.call(this, Os.DEFAULT_NODE_CAPACITY);
            else if (1 === arguments.length) {
                const t = arguments[0];
                Rs.constructor_.call(this, t);
            }
        }
        static getItems(t) {
            const e = new Array(t.size()).fill(null);
            let s = 0;
            for(; !t.isEmpty();){
                const n = t.poll();
                e[s] = n.getBoundable(0).getItem(), s++;
            }
            return e;
        }
        static avg(t, e) {
            return (t + e) / 2;
        }
        static centreY(t) {
            return Os.avg(t.getMinY(), t.getMaxY());
        }
        static centreX(t) {
            return Os.avg(t.getMinX(), t.getMaxX());
        }
        size() {
            return 0 === arguments.length ? super.size.call(this) : super.size.apply(this, arguments);
        }
        insert() {
            if (!(2 === arguments.length && arguments[1] instanceof Object && arguments[0] instanceof O)) return super.insert.apply(this, arguments);
            {
                const t = arguments[0], e = arguments[1];
                if (t.isNull()) return null;
                super.insert.call(this, t, e);
            }
        }
        getIntersectsOp() {
            return Os.intersectsOp;
        }
        verticalSlices(t, e) {
            const s = Math.trunc(Math.ceil(t.size() / e)), n = new Array(e).fill(null), i = t.iterator();
            for(let t = 0; t < e; t++){
                n[t] = new L;
                let e = 0;
                for(; i.hasNext() && e < s;){
                    const s = i.next();
                    n[t].add(s), e++;
                }
            }
            return n;
        }
        query() {
            if (1 === arguments.length) {
                const t = arguments[0];
                return super.query.call(this, t);
            }
            if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                super.query.call(this, t, e);
            }
        }
        getComparator() {
            return Os.yComparator;
        }
        createParentBoundablesFromVerticalSlice(t, e) {
            return super.createParentBoundables.call(this, t, e);
        }
        remove() {
            if (2 === arguments.length && arguments[1] instanceof Object && arguments[0] instanceof O) {
                const t = arguments[0], e = arguments[1];
                return super.remove.call(this, t, e);
            }
            return super.remove.apply(this, arguments);
        }
        depth() {
            return 0 === arguments.length ? super.depth.call(this) : super.depth.apply(this, arguments);
        }
        createParentBoundables(t, e) {
            h.isTrue(!t.isEmpty());
            const s = Math.trunc(Math.ceil(t.size() / this.getNodeCapacity())), n = new L(t);
            xe.sort(n, Os.xComparator);
            const i = this.verticalSlices(n, Math.trunc(Math.ceil(Math.sqrt(s))));
            return this.createParentBoundablesFromVerticalSlices(i, e);
        }
        nearestNeighbour() {
            if (1 === arguments.length) {
                if (I(arguments[0], Ps)) {
                    const t = arguments[0];
                    if (this.isEmpty()) return null;
                    const e = new Ts(this.getRoot(), this.getRoot(), t);
                    return this.nearestNeighbour(e);
                }
                if (arguments[0] instanceof Ts) {
                    const t = arguments[0];
                    let e = r.POSITIVE_INFINITY, s = null;
                    const n = new ws;
                    for(n.add(t); !n.isEmpty() && e > 0;){
                        const t = n.poll(), i = t.getDistance();
                        if (i >= e) break;
                        t.isLeaves() ? (e = i, s = t) : t.expandToQueue(n, e);
                    }
                    return null === s ? null : [
                        s.getBoundable(0).getItem(),
                        s.getBoundable(1).getItem()
                    ];
                }
            } else {
                if (2 === arguments.length) {
                    const t = arguments[0], e = arguments[1];
                    if (this.isEmpty() || t.isEmpty()) return null;
                    const s = new Ts(this.getRoot(), t.getRoot(), e);
                    return this.nearestNeighbour(s);
                }
                if (3 === arguments.length) {
                    const t = arguments[2], e = new fs(arguments[0], arguments[1]), s = new Ts(this.getRoot(), e, t);
                    return this.nearestNeighbour(s)[0];
                }
                if (4 === arguments.length) {
                    const t = arguments[2], e = arguments[3], s = new fs(arguments[0], arguments[1]), n = new Ts(this.getRoot(), s, t);
                    return this.nearestNeighbourK(n, e);
                }
            }
        }
        isWithinDistance() {
            if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                let s = r.POSITIVE_INFINITY;
                const n = new ws;
                for(n.add(t); !n.isEmpty();){
                    const t = n.poll(), i = t.getDistance();
                    if (i > e) return !1;
                    if (t.maximumDistance() <= e) return !0;
                    if (t.isLeaves()) {
                        if (s = i, s <= e) return !0;
                    } else t.expandToQueue(n, s);
                }
                return !1;
            }
            if (3 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = arguments[2], n = new Ts(this.getRoot(), t.getRoot(), e);
                return this.isWithinDistance(n, s);
            }
        }
        createParentBoundablesFromVerticalSlices(t, e) {
            h.isTrue(t.length > 0);
            const s = new L;
            for(let n = 0; n < t.length; n++)s.addAll(this.createParentBoundablesFromVerticalSlice(t[n], e));
            return s;
        }
        nearestNeighbourK() {
            if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                return this.nearestNeighbourK(t, r.POSITIVE_INFINITY, e);
            }
            if (3 === arguments.length) {
                const t = arguments[0], e = arguments[2];
                let s = arguments[1];
                const n = new ws;
                n.add(t);
                const i = new ws;
                for(; !n.isEmpty() && s >= 0;){
                    const t = n.poll(), r = t.getDistance();
                    if (r >= s) break;
                    if (t.isLeaves()) {
                        if (i.size() < e) i.add(t);
                        else {
                            i.peek().getDistance() > r && (i.poll(), i.add(t));
                            s = i.peek().getDistance();
                        }
                    } else t.expandToQueue(n, s);
                }
                return Os.getItems(i);
            }
        }
        createNode(t) {
            return new vs(t);
        }
        get interfaces_() {
            return [
                Cs,
                l
            ];
        }
    }
    class vs extends Ss {
        constructor(){
            super(), vs.constructor_.apply(this, arguments);
        }
        static constructor_() {
            const t = arguments[0];
            Ss.constructor_.call(this, t);
        }
        computeBounds() {
            let t = null;
            for(let e = this.getChildBoundables().iterator(); e.hasNext();){
                const s = e.next();
                null === t ? t = new O(s.getBounds()) : t.expandToInclude(s.getBounds());
            }
            return t;
        }
    }
    Os.STRtreeNode = vs, Os.xComparator = new class {
        get interfaces_() {
            return [
                g
            ];
        }
        compare(t, e) {
            return Rs.compareDoubles(Os.centreX(t.getBounds()), Os.centreX(e.getBounds()));
        }
    }, Os.yComparator = new class {
        get interfaces_() {
            return [
                g
            ];
        }
        compare(t, e) {
            return Rs.compareDoubles(Os.centreY(t.getBounds()), Os.centreY(e.getBounds()));
        }
    }, Os.intersectsOp = new class {
        get interfaces_() {
            return [
                IntersectsOp
            ];
        }
        intersects(t, e) {
            return t.intersects(e);
        }
    }, Os.DEFAULT_NODE_CAPACITY = 10;
    class Ms {
        constructor(){
            Ms.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._overlapSeg1 = new Kt, this._overlapSeg2 = new Kt;
        }
        overlap() {
            if (2 === arguments.length) ;
            else if (4 === arguments.length) {
                const t = arguments[1], e = arguments[2], s = arguments[3];
                arguments[0].getLineSegment(t, this._overlapSeg1), e.getLineSegment(s, this._overlapSeg2), this.overlap(this._overlapSeg1, this._overlapSeg2);
            }
        }
    }
    let bs = class t {
        constructor(){
            t.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._pts = null, this._start = null, this._end = null, this._env = null, this._context = null, this._id = null;
            const t = arguments[0], e = arguments[1], s = arguments[2], n = arguments[3];
            this._pts = t, this._start = e, this._end = s, this._context = n;
        }
        computeOverlaps() {
            if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                this.computeOverlaps(this._start, this._end, t, t._start, t._end, e);
            } else if (6 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = arguments[2], n = arguments[3], i = arguments[4], r = arguments[5];
                if (e - t == 1 && i - n == 1) return r.overlap(this, t, s, n), null;
                if (!this.overlaps(t, e, s, n, i)) return null;
                const o = Math.trunc((t + e) / 2), l = Math.trunc((n + i) / 2);
                t < o && (n < l && this.computeOverlaps(t, o, s, n, l, r), l < i && this.computeOverlaps(t, o, s, l, i, r)), o < e && (n < l && this.computeOverlaps(o, e, s, n, l, r), l < i && this.computeOverlaps(o, e, s, l, i, r));
            }
        }
        setId(t) {
            this._id = t;
        }
        select(t, e) {
            this.computeSelect(t, this._start, this._end, e);
        }
        getEnvelope() {
            if (null === this._env) {
                const t = this._pts[this._start], e = this._pts[this._end];
                this._env = new O(t, e);
            }
            return this._env;
        }
        overlaps(t, e, s, n, i) {
            return O.intersects(this._pts[t], this._pts[e], s._pts[n], s._pts[i]);
        }
        getEndIndex() {
            return this._end;
        }
        getStartIndex() {
            return this._start;
        }
        getContext() {
            return this._context;
        }
        getId() {
            return this._id;
        }
        getLineSegment(t, e) {
            e.p0 = this._pts[t], e.p1 = this._pts[t + 1];
        }
        computeSelect(t, e, s, n) {
            const i = this._pts[e], r = this._pts[s];
            if (s - e == 1) return n.select(this, e), null;
            if (!t.intersects(i, r)) return null;
            const o = Math.trunc((e + s) / 2);
            e < o && this.computeSelect(t, e, o, n), o < s && this.computeSelect(t, o, s, n);
        }
        getCoordinates() {
            const t = new Array(this._end - this._start + 1).fill(null);
            let e = 0;
            for(let s = this._start; s <= this._end; s++)t[e++] = this._pts[s];
            return t;
        }
    };
    class Ds {
        static isNorthern(t) {
            return t === Ds.NE || t === Ds.NW;
        }
        static isOpposite(t, e) {
            if (t === e) return !1;
            return 2 === (t - e + 4) % 4;
        }
        static commonHalfPlane(t, e) {
            if (t === e) return t;
            if (2 === (t - e + 4) % 4) return -1;
            const s = t < e ? t : e;
            return 0 === s && 3 === (t > e ? t : e) ? 3 : s;
        }
        static isInHalfPlane(t, e) {
            return e === Ds.SE ? t === Ds.SE || t === Ds.SW : t === e || t === e + 1;
        }
        static quadrant() {
            if ("number" == typeof arguments[0] && "number" == typeof arguments[1]) {
                const t = arguments[0], e = arguments[1];
                if (0 === t && 0 === e) throw new n("Cannot compute the quadrant for point ( " + t + ", " + e + " )");
                return t >= 0 ? e >= 0 ? Ds.NE : Ds.SE : e >= 0 ? Ds.NW : Ds.SW;
            }
            if (arguments[0] instanceof m && arguments[1] instanceof m) {
                const t = arguments[0], e = arguments[1];
                if (e.x === t.x && e.y === t.y) throw new n("Cannot compute the quadrant for two identical points " + t);
                return e.x >= t.x ? e.y >= t.y ? Ds.NE : Ds.SE : e.y >= t.y ? Ds.NW : Ds.SW;
            }
        }
    }
    Ds.NE = 0, Ds.NW = 1, Ds.SW = 2, Ds.SE = 3;
    class As {
        static findChainEnd(t, e) {
            let s = e;
            for(; s < t.length - 1 && t[s].equals2D(t[s + 1]);)s++;
            if (s >= t.length - 1) return t.length - 1;
            const n = Ds.quadrant(t[s], t[s + 1]);
            let i = e + 1;
            for(; i < t.length;){
                if (!t[i - 1].equals2D(t[i])) {
                    if (Ds.quadrant(t[i - 1], t[i]) !== n) break;
                }
                i++;
            }
            return i - 1;
        }
        static getChains() {
            if (1 === arguments.length) {
                const t = arguments[0];
                return As.getChains(t, null);
            }
            if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = new L;
                let n = 0;
                do {
                    const i = As.findChainEnd(t, n), r = new bs(t, n, i, e);
                    s.add(r), n = i;
                }while (n < t.length - 1);
                return s;
            }
        }
    }
    class Fs {
        constructor(){
            Fs.constructor_.apply(this, arguments);
        }
        static constructor_() {
            if (this._segInt = null, 0 === arguments.length) ;
            else if (1 === arguments.length) {
                const t = arguments[0];
                this.setSegmentIntersector(t);
            }
        }
        setSegmentIntersector(t) {
            this._segInt = t;
        }
        get interfaces_() {
            return [
                gs
            ];
        }
    }
    class Gs extends Fs {
        constructor(){
            super(), Gs.constructor_.apply(this, arguments);
        }
        static constructor_() {
            if (this._monoChains = new L, this._index = new Os, this._idCounter = 0, this._nodedSegStrings = null, this._nOverlaps = 0, 0 === arguments.length) ;
            else if (1 === arguments.length) {
                const t = arguments[0];
                Fs.constructor_.call(this, t);
            }
        }
        getMonotoneChains() {
            return this._monoChains;
        }
        getNodedSubstrings() {
            return us.getNodedSubstrings(this._nodedSegStrings);
        }
        getIndex() {
            return this._index;
        }
        add(t) {
            for(let e = As.getChains(t.getCoordinates(), t).iterator(); e.hasNext();){
                const t = e.next();
                t.setId(this._idCounter++), this._index.insert(t.getEnvelope(), t), this._monoChains.add(t);
            }
        }
        computeNodes(t) {
            this._nodedSegStrings = t;
            for(let e = t.iterator(); e.hasNext();)this.add(e.next());
            this.intersectChains();
        }
        intersectChains() {
            const t = new qs(this._segInt);
            for(let e = this._monoChains.iterator(); e.hasNext();){
                const s = e.next();
                for(let e = this._index.query(s.getEnvelope()).iterator(); e.hasNext();){
                    const n = e.next();
                    if (n.getId() > s.getId() && (s.computeOverlaps(n, t), this._nOverlaps++), this._segInt.isDone()) return null;
                }
            }
        }
    }
    class qs extends Ms {
        constructor(){
            super(), qs.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._si = null;
            const t = arguments[0];
            this._si = t;
        }
        overlap() {
            if (4 !== arguments.length) return super.overlap.apply(this, arguments);
            {
                const t = arguments[1], e = arguments[2], s = arguments[3], n = arguments[0].getContext(), i = e.getContext();
                this._si.processIntersections(n, t, i, s);
            }
        }
    }
    Gs.SegmentOverlapAction = qs;
    class Bs {
        constructor(){
            Bs.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._li = null, this._pt = null, this._originalPt = null, this._ptScaled = null, this._p0Scaled = null, this._p1Scaled = null, this._scaleFactor = null, this._minx = null, this._maxx = null, this._miny = null, this._maxy = null, this._corner = new Array(4).fill(null), this._safeEnv = null;
            const t = arguments[0], e = arguments[1], s = arguments[2];
            if (this._originalPt = t, this._pt = t, this._scaleFactor = e, this._li = s, e <= 0) throw new n("Scale factor must be non-zero");
            1 !== e && (this._pt = new m(this.scale(t.x), this.scale(t.y)), this._p0Scaled = new m, this._p1Scaled = new m), this.initCorners(this._pt);
        }
        intersectsScaled(t, e) {
            const s = Math.min(t.x, e.x), n = Math.max(t.x, e.x), i = Math.min(t.y, e.y), r = Math.max(t.y, e.y), o = this._maxx < s || this._minx > n || this._maxy < i || this._miny > r;
            if (o) return !1;
            const l = this.intersectsToleranceSquare(t, e);
            return h.isTrue(!(o && l), "Found bad envelope test"), l;
        }
        copyScaled(t, e) {
            e.x = this.scale(t.x), e.y = this.scale(t.y);
        }
        getSafeEnvelope() {
            if (null === this._safeEnv) {
                const t = Bs.SAFE_ENV_EXPANSION_FACTOR / this._scaleFactor;
                this._safeEnv = new O(this._originalPt.x - t, this._originalPt.x + t, this._originalPt.y - t, this._originalPt.y + t);
            }
            return this._safeEnv;
        }
        intersectsPixelClosure(t, e) {
            return this._li.computeIntersection(t, e, this._corner[0], this._corner[1]), !!this._li.hasIntersection() || (this._li.computeIntersection(t, e, this._corner[1], this._corner[2]), !!this._li.hasIntersection() || (this._li.computeIntersection(t, e, this._corner[2], this._corner[3]), !!this._li.hasIntersection() || (this._li.computeIntersection(t, e, this._corner[3], this._corner[0]), !!this._li.hasIntersection())));
        }
        intersectsToleranceSquare(t, e) {
            let s = !1, n = !1;
            return this._li.computeIntersection(t, e, this._corner[0], this._corner[1]), !!this._li.isProper() || (this._li.computeIntersection(t, e, this._corner[1], this._corner[2]), !!this._li.isProper() || (this._li.hasIntersection() && (s = !0), this._li.computeIntersection(t, e, this._corner[2], this._corner[3]), !!this._li.isProper() || (this._li.hasIntersection() && (n = !0), this._li.computeIntersection(t, e, this._corner[3], this._corner[0]), !!this._li.isProper() || !(!s || !n) || !!t.equals(this._pt) || !!e.equals(this._pt))));
        }
        addSnappedNode(t, e) {
            const s = t.getCoordinate(e), n = t.getCoordinate(e + 1);
            return !!this.intersects(s, n) && (t.addIntersection(this.getCoordinate(), e), !0);
        }
        initCorners(t) {
            const e = .5;
            this._minx = t.x - e, this._maxx = t.x + e, this._miny = t.y - e, this._maxy = t.y + e, this._corner[0] = new m(this._maxx, this._maxy), this._corner[1] = new m(this._minx, this._maxy), this._corner[2] = new m(this._minx, this._miny), this._corner[3] = new m(this._maxx, this._miny);
        }
        intersects(t, e) {
            return 1 === this._scaleFactor ? this.intersectsScaled(t, e) : (this.copyScaled(t, this._p0Scaled), this.copyScaled(e, this._p1Scaled), this.intersectsScaled(this._p0Scaled, this._p1Scaled));
        }
        scale(t) {
            return Math.round(t * this._scaleFactor);
        }
        getCoordinate() {
            return this._originalPt;
        }
    }
    Bs.SAFE_ENV_EXPANSION_FACTOR = .75;
    class Ys {
        constructor(){
            Ys.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this.selectedSegment = new Kt;
        }
        select() {
            if (1 === arguments.length) ;
            else if (2 === arguments.length) {
                const t = arguments[1];
                arguments[0].getLineSegment(t, this.selectedSegment), this.select(this.selectedSegment);
            }
        }
    }
    class zs {
        constructor(){
            zs.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._index = null;
            const t = arguments[0];
            this._index = t;
        }
        snap() {
            if (1 === arguments.length) {
                const t = arguments[0];
                return this.snap(t, null, -1);
            }
            if (3 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = arguments[2], n = t.getSafeEnvelope(), i = new Vs(t, e, s);
                return this._index.query(n, new class {
                    get interfaces_() {
                        return [
                            De
                        ];
                    }
                    visitItem(t) {
                        t.select(n, i);
                    }
                }), i.isNodeAdded();
            }
        }
    }
    class Vs extends Ys {
        constructor(){
            super(), Vs.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._hotPixel = null, this._parentEdge = null, this._hotPixelVertexIndex = null, this._isNodeAdded = !1;
            const t = arguments[0], e = arguments[1], s = arguments[2];
            this._hotPixel = t, this._parentEdge = e, this._hotPixelVertexIndex = s;
        }
        select() {
            if (!(2 === arguments.length && Number.isInteger(arguments[1]) && arguments[0] instanceof bs)) return super.select.apply(this, arguments);
            {
                const t = arguments[1], e = arguments[0].getContext();
                if (this._parentEdge === e && (t === this._hotPixelVertexIndex || t + 1 === this._hotPixelVertexIndex)) return null;
                this._isNodeAdded |= this._hotPixel.addSnappedNode(e, t);
            }
        }
        isNodeAdded() {
            return this._isNodeAdded;
        }
    }
    zs.HotPixelSnapAction = Vs;
    let ks = class {
        isDone() {}
        processIntersections(t, e, s, n) {}
    };
    class Xs {
        constructor(){
            Xs.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._li = null, this._interiorIntersections = null;
            const t = arguments[0];
            this._li = t, this._interiorIntersections = new L;
        }
        isDone() {
            return !1;
        }
        processIntersections(t, e, s, n) {
            if (t === s && e === n) return null;
            const i = t.getCoordinates()[e], r = t.getCoordinates()[e + 1], o = s.getCoordinates()[n], l = s.getCoordinates()[n + 1];
            if (this._li.computeIntersection(i, r, o, l), this._li.hasIntersection() && this._li.isInteriorIntersection()) {
                for(let t = 0; t < this._li.getIntersectionNum(); t++)this._interiorIntersections.add(this._li.getIntersection(t));
                t.addIntersections(this._li, e, 0), s.addIntersections(this._li, n, 1);
            }
        }
        getInteriorIntersections() {
            return this._interiorIntersections;
        }
        get interfaces_() {
            return [
                ks
            ];
        }
    }
    class Us {
        constructor(){
            Us.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._pm = null, this._li = null, this._scaleFactor = null, this._noder = null, this._pointSnapper = null, this._nodedSegStrings = null;
            const t = arguments[0];
            this._pm = t, this._li = new jt, this._li.setPrecisionModel(t), this._scaleFactor = t.getScale();
        }
        checkCorrectness(t) {
            const e = us.getNodedSubstrings(t), n = new ps(e);
            try {
                n.checkValid();
            } catch (t) {
                if (!(t instanceof s)) throw t;
                t.printStackTrace();
            }
        }
        getNodedSubstrings() {
            return us.getNodedSubstrings(this._nodedSegStrings);
        }
        snapRound(t, e) {
            const s = this.findInteriorIntersections(t, e);
            this.computeIntersectionSnaps(s), this.computeVertexSnaps(t);
        }
        findInteriorIntersections(t, e) {
            const s = new Xs(e);
            return this._noder.setSegmentIntersector(s), this._noder.computeNodes(t), s.getInteriorIntersections();
        }
        computeVertexSnaps() {
            if (I(arguments[0], N)) for(let t = arguments[0].iterator(); t.hasNext();){
                const e = t.next();
                this.computeVertexSnaps(e);
            }
            else if (arguments[0] instanceof us) {
                const t = arguments[0], e = t.getCoordinates();
                for(let s = 0; s < e.length; s++){
                    const n = new Bs(e[s], this._scaleFactor, this._li);
                    this._pointSnapper.snap(n, t, s) && t.addIntersection(e[s], s);
                }
            }
        }
        computeNodes(t) {
            this._nodedSegStrings = t, this._noder = new Gs, this._pointSnapper = new zs(this._noder.getIndex()), this.snapRound(t, this._li);
        }
        computeIntersectionSnaps(t) {
            for(let e = t.iterator(); e.hasNext();){
                const t = e.next(), s = new Bs(t, this._scaleFactor, this._li);
                this._pointSnapper.snap(s);
            }
        }
        get interfaces_() {
            return [
                gs
            ];
        }
    }
    class Hs {
        static opposite(t) {
            return t === Hs.LEFT ? Hs.RIGHT : t === Hs.RIGHT ? Hs.LEFT : t;
        }
    }
    Hs.ON = 0, Hs.LEFT = 1, Hs.RIGHT = 2;
    class Ws extends s {
        constructor(t){
            super(t), this.name = Object.keys({
                EmptyStackException: Ws
            })[0];
        }
    }
    class Zs extends C {
        constructor(){
            super(), this.array = [];
        }
        add(t) {
            return this.array.push(t), !0;
        }
        get(t) {
            if (t < 0 || t >= this.size()) throw new w;
            return this.array[t];
        }
        push(t) {
            return this.array.push(t), t;
        }
        pop() {
            if (0 === this.array.length) throw new Ws;
            return this.array.pop();
        }
        peek() {
            if (0 === this.array.length) throw new Ws;
            return this.array[this.array.length - 1];
        }
        empty() {
            return 0 === this.array.length;
        }
        isEmpty() {
            return this.empty();
        }
        search(t) {
            return this.array.indexOf(t);
        }
        size() {
            return this.array.length;
        }
        toArray() {
            return this.array.slice();
        }
    }
    class js {
        constructor(){
            js.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._minIndex = -1, this._minCoord = null, this._minDe = null, this._orientedDe = null;
        }
        getCoordinate() {
            return this._minCoord;
        }
        getRightmostSide(t, e) {
            let s = this.getRightmostSideOfSegment(t, e);
            return s < 0 && (s = this.getRightmostSideOfSegment(t, e - 1)), s < 0 && (this._minCoord = null, this.checkForRightmostCoordinate(t)), s;
        }
        findRightmostEdgeAtVertex() {
            const t = this._minDe.getEdge().getCoordinates();
            h.isTrue(this._minIndex > 0 && this._minIndex < t.length, "rightmost point expected to be interior vertex of edge");
            const e = t[this._minIndex - 1], s = t[this._minIndex + 1], n = q.index(this._minCoord, s, e);
            let i = !1;
            (e.y < this._minCoord.y && s.y < this._minCoord.y && n === q.COUNTERCLOCKWISE || e.y > this._minCoord.y && s.y > this._minCoord.y && n === q.CLOCKWISE) && (i = !0), i && (this._minIndex = this._minIndex - 1);
        }
        getRightmostSideOfSegment(t, e) {
            const s = t.getEdge().getCoordinates();
            if (e < 0 || e + 1 >= s.length) return -1;
            if (s[e].y === s[e + 1].y) return -1;
            let n = Hs.LEFT;
            return s[e].y < s[e + 1].y && (n = Hs.RIGHT), n;
        }
        getEdge() {
            return this._orientedDe;
        }
        checkForRightmostCoordinate(t) {
            const e = t.getEdge().getCoordinates();
            for(let s = 0; s < e.length - 1; s++)(null === this._minCoord || e[s].x > this._minCoord.x) && (this._minDe = t, this._minIndex = s, this._minCoord = e[s]);
        }
        findRightmostEdgeAtNode() {
            const t = this._minDe.getNode().getEdges();
            this._minDe = t.getRightmostEdge(), this._minDe.isForward() || (this._minDe = this._minDe.getSym(), this._minIndex = this._minDe.getEdge().getCoordinates().length - 1);
        }
        findEdge(t) {
            for(let e = t.iterator(); e.hasNext();){
                const t = e.next();
                t.isForward() && this.checkForRightmostCoordinate(t);
            }
            h.isTrue(0 !== this._minIndex || this._minCoord.equals(this._minDe.getCoordinate()), "inconsistency in rightmost processing"), 0 === this._minIndex ? this.findRightmostEdgeAtNode() : this.findRightmostEdgeAtVertex(), this._orientedDe = this._minDe;
            this.getRightmostSide(this._minDe, this._minIndex) === Hs.LEFT && (this._orientedDe = this._minDe.getSym());
        }
    }
    class Ks {
        constructor(){
            this.array = [];
        }
        addLast(t) {
            this.array.push(t);
        }
        removeFirst() {
            return this.array.shift();
        }
        isEmpty() {
            return 0 === this.array.length;
        }
    }
    class Qs {
        constructor(){
            Qs.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._finder = null, this._dirEdgeList = new L, this._nodes = new L, this._rightMostCoord = null, this._env = null, this._finder = new js;
        }
        clearVisitedEdges() {
            for(let t = this._dirEdgeList.iterator(); t.hasNext();)t.next().setVisited(!1);
        }
        compareTo(t) {
            const e = t;
            return this._rightMostCoord.x < e._rightMostCoord.x ? -1 : this._rightMostCoord.x > e._rightMostCoord.x ? 1 : 0;
        }
        getEnvelope() {
            if (null === this._env) {
                const t = new O;
                for(let e = this._dirEdgeList.iterator(); e.hasNext();){
                    const s = e.next().getEdge().getCoordinates();
                    for(let e = 0; e < s.length - 1; e++)t.expandToInclude(s[e]);
                }
                this._env = t;
            }
            return this._env;
        }
        addReachable(t) {
            const e = new Zs;
            for(e.add(t); !e.empty();){
                const t = e.pop();
                this.add(t, e);
            }
        }
        copySymDepths(t) {
            const e = t.getSym();
            e.setDepth(Hs.LEFT, t.getDepth(Hs.RIGHT)), e.setDepth(Hs.RIGHT, t.getDepth(Hs.LEFT));
        }
        add(t, e) {
            t.setVisited(!0), this._nodes.add(t);
            for(let s = t.getEdges().iterator(); s.hasNext();){
                const t = s.next();
                this._dirEdgeList.add(t);
                const n = t.getSym().getNode();
                n.isVisited() || e.push(n);
            }
        }
        getRightmostCoordinate() {
            return this._rightMostCoord;
        }
        computeNodeDepth(t) {
            let e = null;
            for(let s = t.getEdges().iterator(); s.hasNext();){
                const t = s.next();
                if (t.isVisited() || t.getSym().isVisited()) {
                    e = t;
                    break;
                }
            }
            if (null === e) throw new _s("unable to find edge to compute depths at " + t.getCoordinate());
            t.getEdges().computeDepths(e);
            for(let e = t.getEdges().iterator(); e.hasNext();){
                const t = e.next();
                t.setVisited(!0), this.copySymDepths(t);
            }
        }
        computeDepth(t) {
            this.clearVisitedEdges();
            const e = this._finder.getEdge();
            e.getNode(), e.getLabel(), e.setEdgeDepths(Hs.RIGHT, t), this.copySymDepths(e), this.computeDepths(e);
        }
        create(t) {
            this.addReachable(t), this._finder.findEdge(this._dirEdgeList), this._rightMostCoord = this._finder.getCoordinate();
        }
        findResultEdges() {
            for(let t = this._dirEdgeList.iterator(); t.hasNext();){
                const e = t.next();
                e.getDepth(Hs.RIGHT) >= 1 && e.getDepth(Hs.LEFT) <= 0 && !e.isInteriorAreaEdge() && e.setInResult(!0);
            }
        }
        computeDepths(t) {
            const e = new pt, s = new Ks, n = t.getNode();
            for(s.addLast(n), e.add(n), t.setVisited(!0); !s.isEmpty();){
                const t = s.removeFirst();
                e.add(t), this.computeNodeDepth(t);
                for(let n = t.getEdges().iterator(); n.hasNext();){
                    const t = n.next().getSym();
                    if (t.isVisited()) continue;
                    const i = t.getNode();
                    e.contains(i) || (s.addLast(i), e.add(i));
                }
            }
        }
        getNodes() {
            return this._nodes;
        }
        getDirectedEdges() {
            return this._dirEdgeList;
        }
        get interfaces_() {
            return [
                o
            ];
        }
    }
    class Js {
        constructor(){
            Js.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._inputLine = null, this._distanceTol = null, this._isDeleted = null, this._angleOrientation = q.COUNTERCLOCKWISE;
            const t = arguments[0];
            this._inputLine = t;
        }
        static simplify(t, e) {
            return new Js(t).simplify(e);
        }
        isDeletable(t, e, s, n) {
            const i = this._inputLine[t], r = this._inputLine[e], o = this._inputLine[s];
            return !!this.isConcave(i, r, o) && !!this.isShallow(i, r, o, n) && this.isShallowSampled(i, r, t, s, n);
        }
        deleteShallowConcavities() {
            let t = 1, e = this.findNextNonDeletedIndex(t), s = this.findNextNonDeletedIndex(e), n = !1;
            for(; s < this._inputLine.length;){
                let i = !1;
                this.isDeletable(t, e, s, this._distanceTol) && (this._isDeleted[e] = Js.DELETE, i = !0, n = !0), t = i ? s : e, e = this.findNextNonDeletedIndex(t), s = this.findNextNonDeletedIndex(e);
            }
            return n;
        }
        isShallowConcavity(t, e, s, n) {
            if (!(q.index(t, e, s) === this._angleOrientation)) return !1;
            return V.pointToSegment(e, t, s) < n;
        }
        isShallowSampled(t, e, s, n, i) {
            let r = Math.trunc((n - s) / Js.NUM_PTS_TO_CHECK);
            r <= 0 && (r = 1);
            for(let o = s; o < n; o += r)if (!this.isShallow(t, e, this._inputLine[o], i)) return !1;
            return !0;
        }
        isConcave(t, e, s) {
            return q.index(t, e, s) === this._angleOrientation;
        }
        simplify(t) {
            this._distanceTol = Math.abs(t), t < 0 && (this._angleOrientation = q.CLOCKWISE), this._isDeleted = new Array(this._inputLine.length).fill(null);
            let e = !1;
            do e = this.deleteShallowConcavities();
            while (e);
            return this.collapseLine();
        }
        findNextNonDeletedIndex(t) {
            let e = t + 1;
            for(; e < this._inputLine.length && this._isDeleted[e] === Js.DELETE;)e++;
            return e;
        }
        isShallow(t, e, s, n) {
            return V.pointToSegment(e, t, s) < n;
        }
        collapseLine() {
            const t = new R;
            for(let e = 0; e < this._inputLine.length; e++)this._isDeleted[e] !== Js.DELETE && t.add(this._inputLine[e]);
            return t.toCoordinateArray();
        }
    }
    Js.INIT = 0, Js.DELETE = 1, Js.KEEP = 1, Js.NUM_PTS_TO_CHECK = 10;
    class $s {
        constructor(){
            $s.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._ptList = null, this._precisionModel = null, this._minimimVertexDistance = 0, this._ptList = new L;
        }
        getCoordinates() {
            return this._ptList.toArray($s.COORDINATE_ARRAY_TYPE);
        }
        setPrecisionModel(t) {
            this._precisionModel = t;
        }
        addPt(t) {
            const e = new m(t);
            if (this._precisionModel.makePrecise(e), this.isRedundant(e)) return null;
            this._ptList.add(e);
        }
        reverse() {}
        addPts(t, e) {
            if (e) for(let e = 0; e < t.length; e++)this.addPt(t[e]);
            else for(let e = t.length - 1; e >= 0; e--)this.addPt(t[e]);
        }
        isRedundant(t) {
            if (this._ptList.size() < 1) return !1;
            const e = this._ptList.get(this._ptList.size() - 1);
            return t.distance(e) < this._minimimVertexDistance;
        }
        toString() {
            return (new Lt).createLineString(this.getCoordinates()).toString();
        }
        closeRing() {
            if (this._ptList.size() < 1) return null;
            const t = new m(this._ptList.get(0)), e = this._ptList.get(this._ptList.size() - 1);
            if (t.equals(e)) return null;
            this._ptList.add(t);
        }
        setMinimumVertexDistance(t) {
            this._minimimVertexDistance = t;
        }
    }
    $s.COORDINATE_ARRAY_TYPE = new Array(0).fill(null);
    class tn {
        constructor(){
            tn.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._maxCurveSegmentError = 0, this._filletAngleQuantum = null, this._closingSegLengthFactor = 1, this._segList = null, this._distance = 0, this._precisionModel = null, this._bufParams = null, this._li = null, this._s0 = null, this._s1 = null, this._s2 = null, this._seg0 = new Kt, this._seg1 = new Kt, this._offset0 = new Kt, this._offset1 = new Kt, this._side = 0, this._hasNarrowConcaveAngle = !1;
            const t = arguments[0], e = arguments[1], s = arguments[2];
            this._precisionModel = t, this._bufParams = e, this._li = new jt, this._filletAngleQuantum = Math.PI / 2 / e.getQuadrantSegments(), e.getQuadrantSegments() >= 8 && e.getJoinStyle() === Qe.JOIN_ROUND && (this._closingSegLengthFactor = tn.MAX_CLOSING_SEG_LEN_FACTOR), this.init(s);
        }
        getCoordinates() {
            return this._segList.getCoordinates();
        }
        addMitreJoin(t, e, s, n) {
            const i = B.intersection(e.p0, e.p1, s.p0, s.p1);
            if (null !== i) {
                if ((n <= 0 ? 1 : i.distance(t) / Math.abs(n)) <= this._bufParams.getMitreLimit()) return this._segList.addPt(i), null;
            }
            this.addLimitedMitreJoin(e, s, n, this._bufParams.getMitreLimit());
        }
        addLastSegment() {
            this._segList.addPt(this._offset1.p1);
        }
        initSideSegments(t, e, s) {
            this._s1 = t, this._s2 = e, this._side = s, this._seg1.setCoordinates(t, e), this.computeOffsetSegment(this._seg1, s, this._distance, this._offset1);
        }
        addLimitedMitreJoin(t, e, s, n) {
            const i = this._seg0.p1, r = $t.angle(i, this._seg0.p0), o = $t.angleBetweenOriented(this._seg0.p0, i, this._seg1.p1) / 2, l = $t.normalize(r + o), a = $t.normalize(l + Math.PI), c = n * s, h = s - c * Math.abs(Math.sin(o)), u = i.x + c * Math.cos(a), g = i.y + c * Math.sin(a), d = new m(u, g), _ = new Kt(i, d), p = _.pointAlongOffset(1, h), f = _.pointAlongOffset(1, -h);
            this._side === Hs.LEFT ? (this._segList.addPt(p), this._segList.addPt(f)) : (this._segList.addPt(f), this._segList.addPt(p));
        }
        addDirectedFillet(t, e, s, n, i) {
            const r = n === q.CLOCKWISE ? -1 : 1, o = Math.abs(e - s), l = Math.trunc(o / this._filletAngleQuantum + .5);
            if (l < 1) return null;
            const a = o / l, c = new m;
            for(let s = 0; s < l; s++){
                const n = e + r * s * a;
                c.x = t.x + i * Math.cos(n), c.y = t.y + i * Math.sin(n), this._segList.addPt(c);
            }
        }
        computeOffsetSegment(t, e, s, n) {
            const i = e === Hs.LEFT ? 1 : -1, r = t.p1.x - t.p0.x, o = t.p1.y - t.p0.y, l = Math.sqrt(r * r + o * o), a = i * s * r / l, c = i * s * o / l;
            n.p0.x = t.p0.x - c, n.p0.y = t.p0.y + a, n.p1.x = t.p1.x - c, n.p1.y = t.p1.y + a;
        }
        addInsideTurn(t, e) {
            if (this._li.computeIntersection(this._offset0.p0, this._offset0.p1, this._offset1.p0, this._offset1.p1), this._li.hasIntersection()) this._segList.addPt(this._li.getIntersection(0));
            else if (this._hasNarrowConcaveAngle = !0, this._offset0.p1.distance(this._offset1.p0) < this._distance * tn.INSIDE_TURN_VERTEX_SNAP_DISTANCE_FACTOR) this._segList.addPt(this._offset0.p1);
            else {
                if (this._segList.addPt(this._offset0.p1), this._closingSegLengthFactor > 0) {
                    const t = new m((this._closingSegLengthFactor * this._offset0.p1.x + this._s1.x) / (this._closingSegLengthFactor + 1), (this._closingSegLengthFactor * this._offset0.p1.y + this._s1.y) / (this._closingSegLengthFactor + 1));
                    this._segList.addPt(t);
                    const e = new m((this._closingSegLengthFactor * this._offset1.p0.x + this._s1.x) / (this._closingSegLengthFactor + 1), (this._closingSegLengthFactor * this._offset1.p0.y + this._s1.y) / (this._closingSegLengthFactor + 1));
                    this._segList.addPt(e);
                } else this._segList.addPt(this._s1);
                this._segList.addPt(this._offset1.p0);
            }
        }
        createCircle(t) {
            const e = new m(t.x + this._distance, t.y);
            this._segList.addPt(e), this.addDirectedFillet(t, 0, 2 * Math.PI, -1, this._distance), this._segList.closeRing();
        }
        addBevelJoin(t, e) {
            this._segList.addPt(t.p1), this._segList.addPt(e.p0);
        }
        init(t) {
            this._distance = t, this._maxCurveSegmentError = t * (1 - Math.cos(this._filletAngleQuantum / 2)), this._segList = new $s, this._segList.setPrecisionModel(this._precisionModel), this._segList.setMinimumVertexDistance(t * tn.CURVE_VERTEX_SNAP_DISTANCE_FACTOR);
        }
        addCollinear(t) {
            this._li.computeIntersection(this._s0, this._s1, this._s1, this._s2);
            this._li.getIntersectionNum() >= 2 && (this._bufParams.getJoinStyle() === Qe.JOIN_BEVEL || this._bufParams.getJoinStyle() === Qe.JOIN_MITRE ? (t && this._segList.addPt(this._offset0.p1), this._segList.addPt(this._offset1.p0)) : this.addCornerFillet(this._s1, this._offset0.p1, this._offset1.p0, q.CLOCKWISE, this._distance));
        }
        addNextSegment(t, e) {
            if (this._s0 = this._s1, this._s1 = this._s2, this._s2 = t, this._seg0.setCoordinates(this._s0, this._s1), this.computeOffsetSegment(this._seg0, this._side, this._distance, this._offset0), this._seg1.setCoordinates(this._s1, this._s2), this.computeOffsetSegment(this._seg1, this._side, this._distance, this._offset1), this._s1.equals(this._s2)) return null;
            const s = q.index(this._s0, this._s1, this._s2), n = s === q.CLOCKWISE && this._side === Hs.LEFT || s === q.COUNTERCLOCKWISE && this._side === Hs.RIGHT;
            0 === s ? this.addCollinear(e) : n ? this.addOutsideTurn(s, e) : this.addInsideTurn(s, e);
        }
        addLineEndCap(t, e) {
            const s = new Kt(t, e), n = new Kt;
            this.computeOffsetSegment(s, Hs.LEFT, this._distance, n);
            const i = new Kt;
            this.computeOffsetSegment(s, Hs.RIGHT, this._distance, i);
            const r = e.x - t.x, o = e.y - t.y, l = Math.atan2(o, r);
            switch(this._bufParams.getEndCapStyle()){
                case Qe.CAP_ROUND:
                    this._segList.addPt(n.p1), this.addDirectedFillet(e, l + Math.PI / 2, l - Math.PI / 2, q.CLOCKWISE, this._distance), this._segList.addPt(i.p1);
                    break;
                case Qe.CAP_FLAT:
                    this._segList.addPt(n.p1), this._segList.addPt(i.p1);
                    break;
                case Qe.CAP_SQUARE:
                    const t1 = new m;
                    t1.x = Math.abs(this._distance) * Math.cos(l), t1.y = Math.abs(this._distance) * Math.sin(l);
                    const s1 = new m(n.p1.x + t1.x, n.p1.y + t1.y), r1 = new m(i.p1.x + t1.x, i.p1.y + t1.y);
                    this._segList.addPt(s1), this._segList.addPt(r1);
            }
        }
        addOutsideTurn(t, e) {
            if (this._offset0.p1.distance(this._offset1.p0) < this._distance * tn.OFFSET_SEGMENT_SEPARATION_FACTOR) return this._segList.addPt(this._offset0.p1), null;
            this._bufParams.getJoinStyle() === Qe.JOIN_MITRE ? this.addMitreJoin(this._s1, this._offset0, this._offset1, this._distance) : this._bufParams.getJoinStyle() === Qe.JOIN_BEVEL ? this.addBevelJoin(this._offset0, this._offset1) : (e && this._segList.addPt(this._offset0.p1), this.addCornerFillet(this._s1, this._offset0.p1, this._offset1.p0, t, this._distance), this._segList.addPt(this._offset1.p0));
        }
        createSquare(t) {
            this._segList.addPt(new m(t.x + this._distance, t.y + this._distance)), this._segList.addPt(new m(t.x + this._distance, t.y - this._distance)), this._segList.addPt(new m(t.x - this._distance, t.y - this._distance)), this._segList.addPt(new m(t.x - this._distance, t.y + this._distance)), this._segList.closeRing();
        }
        addSegments(t, e) {
            this._segList.addPts(t, e);
        }
        addFirstSegment() {
            this._segList.addPt(this._offset1.p0);
        }
        addCornerFillet(t, e, s, n, i) {
            const r = e.x - t.x, o = e.y - t.y;
            let l = Math.atan2(o, r);
            const a = s.x - t.x, c = s.y - t.y, h = Math.atan2(c, a);
            n === q.CLOCKWISE ? l <= h && (l += 2 * Math.PI) : l >= h && (l -= 2 * Math.PI), this._segList.addPt(e), this.addDirectedFillet(t, l, h, n, i), this._segList.addPt(s);
        }
        closeRing() {
            this._segList.closeRing();
        }
        hasNarrowConcaveAngle() {
            return this._hasNarrowConcaveAngle;
        }
    }
    tn.OFFSET_SEGMENT_SEPARATION_FACTOR = .001, tn.INSIDE_TURN_VERTEX_SNAP_DISTANCE_FACTOR = .001, tn.CURVE_VERTEX_SNAP_DISTANCE_FACTOR = 1e-6, tn.MAX_CLOSING_SEG_LEN_FACTOR = 80;
    class en {
        constructor(){
            en.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._distance = 0, this._precisionModel = null, this._bufParams = null;
            const t = arguments[0], e = arguments[1];
            this._precisionModel = t, this._bufParams = e;
        }
        static copyCoordinates(t) {
            const e = new Array(t.length).fill(null);
            for(let s = 0; s < e.length; s++)e[s] = new m(t[s]);
            return e;
        }
        getOffsetCurve(t, e) {
            if (this._distance = e, 0 === e) return null;
            const s = e < 0, n = Math.abs(e), i = this.getSegGen(n);
            t.length <= 1 ? this.computePointCurve(t[0], i) : this.computeOffsetCurve(t, s, i);
            const r = i.getCoordinates();
            return s && W.reverse(r), r;
        }
        computeSingleSidedBufferCurve(t, e, s) {
            const n = this.simplifyTolerance(this._distance);
            if (e) {
                s.addSegments(t, !0);
                const e = Js.simplify(t, -n), i = e.length - 1;
                s.initSideSegments(e[i], e[i - 1], Hs.LEFT), s.addFirstSegment();
                for(let t = i - 2; t >= 0; t--)s.addNextSegment(e[t], !0);
            } else {
                s.addSegments(t, !1);
                const e = Js.simplify(t, n), i = e.length - 1;
                s.initSideSegments(e[0], e[1], Hs.LEFT), s.addFirstSegment();
                for(let t = 2; t <= i; t++)s.addNextSegment(e[t], !0);
            }
            s.addLastSegment(), s.closeRing();
        }
        computeRingBufferCurve(t, e, s) {
            let n = this.simplifyTolerance(this._distance);
            e === Hs.RIGHT && (n = -n);
            const i = Js.simplify(t, n), r = i.length - 1;
            s.initSideSegments(i[r - 1], i[0], e);
            for(let t = 1; t <= r; t++){
                const e = 1 !== t;
                s.addNextSegment(i[t], e);
            }
            s.closeRing();
        }
        computeLineBufferCurve(t, e) {
            const s = this.simplifyTolerance(this._distance), n = Js.simplify(t, s), i = n.length - 1;
            e.initSideSegments(n[0], n[1], Hs.LEFT);
            for(let t = 2; t <= i; t++)e.addNextSegment(n[t], !0);
            e.addLastSegment(), e.addLineEndCap(n[i - 1], n[i]);
            const r = Js.simplify(t, -s), o = r.length - 1;
            e.initSideSegments(r[o], r[o - 1], Hs.LEFT);
            for(let t = o - 2; t >= 0; t--)e.addNextSegment(r[t], !0);
            e.addLastSegment(), e.addLineEndCap(r[1], r[0]), e.closeRing();
        }
        computePointCurve(t, e) {
            switch(this._bufParams.getEndCapStyle()){
                case Qe.CAP_ROUND:
                    e.createCircle(t);
                    break;
                case Qe.CAP_SQUARE:
                    e.createSquare(t);
            }
        }
        getLineCurve(t, e) {
            if (this._distance = e, this.isLineOffsetEmpty(e)) return null;
            const s = Math.abs(e), n = this.getSegGen(s);
            if (t.length <= 1) this.computePointCurve(t[0], n);
            else if (this._bufParams.isSingleSided()) {
                const s = e < 0;
                this.computeSingleSidedBufferCurve(t, s, n);
            } else this.computeLineBufferCurve(t, n);
            return n.getCoordinates();
        }
        getBufferParameters() {
            return this._bufParams;
        }
        simplifyTolerance(t) {
            return t * this._bufParams.getSimplifyFactor();
        }
        getRingCurve(t, e, s) {
            if (this._distance = s, t.length <= 2) return this.getLineCurve(t, s);
            if (0 === s) return en.copyCoordinates(t);
            const n = this.getSegGen(s);
            return this.computeRingBufferCurve(t, e, n), n.getCoordinates();
        }
        computeOffsetCurve(t, e, s) {
            const n = this.simplifyTolerance(this._distance);
            if (e) {
                const e = Js.simplify(t, -n), i = e.length - 1;
                s.initSideSegments(e[i], e[i - 1], Hs.LEFT), s.addFirstSegment();
                for(let t = i - 2; t >= 0; t--)s.addNextSegment(e[t], !0);
            } else {
                const e = Js.simplify(t, n), i = e.length - 1;
                s.initSideSegments(e[0], e[1], Hs.LEFT), s.addFirstSegment();
                for(let t = 2; t <= i; t++)s.addNextSegment(e[t], !0);
            }
            s.addLastSegment();
        }
        isLineOffsetEmpty(t) {
            return 0 === t || t < 0 && !this._bufParams.isSingleSided();
        }
        getSegGen(t) {
            return new tn(this._precisionModel, this._bufParams, t);
        }
    }
    class sn {
        constructor(){
            sn.constructor_.apply(this, arguments);
        }
        static constructor_() {
            if (this.location = null, 1 === arguments.length) {
                if (arguments[0] instanceof Array) {
                    const t = arguments[0];
                    this.init(t.length);
                } else if (Number.isInteger(arguments[0])) {
                    const t = arguments[0];
                    this.init(1), this.location[Hs.ON] = t;
                } else if (arguments[0] instanceof sn) {
                    const t = arguments[0];
                    if (this.init(t.location.length), null !== t) for(let e = 0; e < this.location.length; e++)this.location[e] = t.location[e];
                }
            } else if (3 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = arguments[2];
                this.init(3), this.location[Hs.ON] = t, this.location[Hs.LEFT] = e, this.location[Hs.RIGHT] = s;
            }
        }
        setAllLocations(t) {
            for(let e = 0; e < this.location.length; e++)this.location[e] = t;
        }
        isNull() {
            for(let t = 0; t < this.location.length; t++)if (this.location[t] !== Qt.NONE) return !1;
            return !0;
        }
        setAllLocationsIfNull(t) {
            for(let e = 0; e < this.location.length; e++)this.location[e] === Qt.NONE && (this.location[e] = t);
        }
        isLine() {
            return 1 === this.location.length;
        }
        merge(t) {
            if (t.location.length > this.location.length) {
                const t = new Array(3).fill(null);
                t[Hs.ON] = this.location[Hs.ON], t[Hs.LEFT] = Qt.NONE, t[Hs.RIGHT] = Qt.NONE, this.location = t;
            }
            for(let e = 0; e < this.location.length; e++)this.location[e] === Qt.NONE && e < t.location.length && (this.location[e] = t.location[e]);
        }
        getLocations() {
            return this.location;
        }
        flip() {
            if (this.location.length <= 1) return null;
            const t = this.location[Hs.LEFT];
            this.location[Hs.LEFT] = this.location[Hs.RIGHT], this.location[Hs.RIGHT] = t;
        }
        get(t) {
            return t < this.location.length ? this.location[t] : Qt.NONE;
        }
        isEqualOnSide(t, e) {
            return this.location[e] === t.location[e];
        }
        allPositionsEqual(t) {
            for(let e = 0; e < this.location.length; e++)if (this.location[e] !== t) return !1;
            return !0;
        }
        toString() {
            const t = new v;
            return this.location.length > 1 && t.append(Qt.toLocationSymbol(this.location[Hs.LEFT])), t.append(Qt.toLocationSymbol(this.location[Hs.ON])), this.location.length > 1 && t.append(Qt.toLocationSymbol(this.location[Hs.RIGHT])), t.toString();
        }
        setLocations(t, e, s) {
            this.location[Hs.ON] = t, this.location[Hs.LEFT] = e, this.location[Hs.RIGHT] = s;
        }
        isArea() {
            return this.location.length > 1;
        }
        isAnyNull() {
            for(let t = 0; t < this.location.length; t++)if (this.location[t] === Qt.NONE) return !0;
            return !1;
        }
        setLocation() {
            if (1 === arguments.length) {
                const t = arguments[0];
                this.setLocation(Hs.ON, t);
            } else if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                this.location[t] = e;
            }
        }
        init(t) {
            this.location = new Array(t).fill(null), this.setAllLocations(Qt.NONE);
        }
    }
    class nn {
        constructor(){
            nn.constructor_.apply(this, arguments);
        }
        static constructor_() {
            if (this.elt = new Array(2).fill(null), 1 === arguments.length) {
                if (Number.isInteger(arguments[0])) {
                    const t = arguments[0];
                    this.elt[0] = new sn(t), this.elt[1] = new sn(t);
                } else if (arguments[0] instanceof nn) {
                    const t = arguments[0];
                    this.elt[0] = new sn(t.elt[0]), this.elt[1] = new sn(t.elt[1]);
                }
            } else if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                this.elt[0] = new sn(Qt.NONE), this.elt[1] = new sn(Qt.NONE), this.elt[t].setLocation(e);
            } else if (3 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = arguments[2];
                this.elt[0] = new sn(t, e, s), this.elt[1] = new sn(t, e, s);
            } else if (4 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = arguments[2], n = arguments[3];
                this.elt[0] = new sn(Qt.NONE, Qt.NONE, Qt.NONE), this.elt[1] = new sn(Qt.NONE, Qt.NONE, Qt.NONE), this.elt[t].setLocations(e, s, n);
            }
        }
        static toLineLabel(t) {
            const e = new nn(Qt.NONE);
            for(let s = 0; s < 2; s++)e.setLocation(s, t.getLocation(s));
            return e;
        }
        getGeometryCount() {
            let t = 0;
            return this.elt[0].isNull() || t++, this.elt[1].isNull() || t++, t;
        }
        setAllLocations(t, e) {
            this.elt[t].setAllLocations(e);
        }
        isNull(t) {
            return this.elt[t].isNull();
        }
        setAllLocationsIfNull() {
            if (1 === arguments.length) {
                const t = arguments[0];
                this.setAllLocationsIfNull(0, t), this.setAllLocationsIfNull(1, t);
            } else if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                this.elt[t].setAllLocationsIfNull(e);
            }
        }
        isLine(t) {
            return this.elt[t].isLine();
        }
        merge(t) {
            for(let e = 0; e < 2; e++)null === this.elt[e] && null !== t.elt[e] ? this.elt[e] = new sn(t.elt[e]) : this.elt[e].merge(t.elt[e]);
        }
        flip() {
            this.elt[0].flip(), this.elt[1].flip();
        }
        getLocation() {
            if (1 === arguments.length) {
                const t = arguments[0];
                return this.elt[t].get(Hs.ON);
            }
            if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                return this.elt[t].get(e);
            }
        }
        toString() {
            const t = new v;
            return null !== this.elt[0] && (t.append("A:"), t.append(this.elt[0].toString())), null !== this.elt[1] && (t.append(" B:"), t.append(this.elt[1].toString())), t.toString();
        }
        setLocation() {
            if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                this.elt[t].setLocation(Hs.ON, e);
            } else if (3 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = arguments[2];
                this.elt[t].setLocation(e, s);
            }
        }
        isEqualOnSide(t, e) {
            return this.elt[0].isEqualOnSide(t.elt[0], e) && this.elt[1].isEqualOnSide(t.elt[1], e);
        }
        allPositionsEqual(t, e) {
            return this.elt[t].allPositionsEqual(e);
        }
        toLine(t) {
            this.elt[t].isArea() && (this.elt[t] = new sn(this.elt[t].location[0]));
        }
        isArea() {
            if (0 === arguments.length) return this.elt[0].isArea() || this.elt[1].isArea();
            if (1 === arguments.length) {
                const t = arguments[0];
                return this.elt[t].isArea();
            }
        }
        isAnyNull(t) {
            return this.elt[t].isAnyNull();
        }
    }
    let rn = class t {
        constructor(){
            t.constructor_.apply(this, arguments);
        }
        static constructor_() {
            if (this._label = null, this._isInResult = !1, this._isCovered = !1, this._isCoveredSet = !1, this._isVisited = !1, 0 === arguments.length) ;
            else if (1 === arguments.length) {
                const t = arguments[0];
                this._label = t;
            }
        }
        setVisited(t) {
            this._isVisited = t;
        }
        setInResult(t) {
            this._isInResult = t;
        }
        setLabel(t) {
            this._label = t;
        }
        getLabel() {
            return this._label;
        }
        setCovered(t) {
            this._isCovered = t, this._isCoveredSet = !0;
        }
        updateIM(t) {
            h.isTrue(this._label.getGeometryCount() >= 2, "found partial label"), this.computeIM(t);
        }
        isCovered() {
            return this._isCovered;
        }
        isCoveredSet() {
            return this._isCoveredSet;
        }
        isInResult() {
            return this._isInResult;
        }
        isVisited() {
            return this._isVisited;
        }
    }, on = class t extends rn {
        constructor(){
            super(), t.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._coord = null, this._edges = null;
            const t = arguments[0], e = arguments[1];
            this._coord = t, this._edges = e, this._label = new nn(0, Qt.NONE);
        }
        isIncidentEdgeInResult() {
            for(let t = this.getEdges().getEdges().iterator(); t.hasNext();){
                if (t.next().getEdge().isInResult()) return !0;
            }
            return !1;
        }
        isIsolated() {
            return 1 === this._label.getGeometryCount();
        }
        getCoordinate() {
            return this._coord;
        }
        computeMergedLocation(t, e) {
            let s = Qt.NONE;
            if (s = this._label.getLocation(e), !t.isNull(e)) {
                const n = t.getLocation(e);
                s !== Qt.BOUNDARY && (s = n);
            }
            return s;
        }
        setLabel() {
            if (2 !== arguments.length || !Number.isInteger(arguments[1]) || !Number.isInteger(arguments[0])) return super.setLabel.apply(this, arguments);
            {
                const t = arguments[0], e = arguments[1];
                null === this._label ? this._label = new nn(t, e) : this._label.setLocation(t, e);
            }
        }
        getEdges() {
            return this._edges;
        }
        mergeLabel() {
            if (arguments[0] instanceof t) {
                const t = arguments[0];
                this.mergeLabel(t._label);
            } else if (arguments[0] instanceof nn) {
                const t = arguments[0];
                for(let e = 0; e < 2; e++){
                    const s = this.computeMergedLocation(t, e);
                    this._label.getLocation(e) === Qt.NONE && this._label.setLocation(e, s);
                }
            }
        }
        add(t) {
            this._edges.insert(t), t.setNode(this);
        }
        setLabelBoundary(t) {
            if (null === this._label) return null;
            let e = Qt.NONE;
            null !== this._label && (e = this._label.getLocation(t));
            let s = null;
            switch(e){
                case Qt.BOUNDARY:
                    s = Qt.INTERIOR;
                    break;
                case Qt.INTERIOR:
                default:
                    s = Qt.BOUNDARY;
            }
            this._label.setLocation(t, s);
        }
        print(t) {
            t.println("node " + this._coord + " lbl: " + this._label);
        }
        computeIM(t) {}
    }, ln = class t {
        constructor(){
            t.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this.nodeMap = new os, this.nodeFact = null;
            const t = arguments[0];
            this.nodeFact = t;
        }
        print(t) {
            for(let e = this.iterator(); e.hasNext();)e.next().print(t);
        }
        iterator() {
            return this.nodeMap.values().iterator();
        }
        values() {
            return this.nodeMap.values();
        }
        getBoundaryNodes(t) {
            const e = new L;
            for(let s = this.iterator(); s.hasNext();){
                const n = s.next();
                n.getLabel().getLocation(t) === Qt.BOUNDARY && e.add(n);
            }
            return e;
        }
        add(t) {
            const e = t.getCoordinate();
            this.addNode(e).add(t);
        }
        find(t) {
            return this.nodeMap.get(t);
        }
        addNode() {
            if (arguments[0] instanceof m) {
                const t = arguments[0];
                let e = this.nodeMap.get(t);
                return null === e && (e = this.nodeFact.createNode(t), this.nodeMap.put(t, e)), e;
            }
            if (arguments[0] instanceof on) {
                const t = arguments[0], e = this.nodeMap.get(t.getCoordinate());
                return null === e ? (this.nodeMap.put(t.getCoordinate(), t), t) : (e.mergeLabel(t), e);
            }
        }
    };
    class an {
        createNode(t) {
            return new on(t, null);
        }
    }
    class cn {
        constructor(){
            cn.constructor_.apply(this, arguments);
        }
        static constructor_() {
            if (this._edge = null, this._label = null, this._node = null, this._p0 = null, this._p1 = null, this._dx = null, this._dy = null, this._quadrant = null, 1 === arguments.length) {
                const t = arguments[0];
                this._edge = t;
            } else if (3 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = arguments[2];
                cn.constructor_.call(this, t, e, s, null);
            } else if (4 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = arguments[2], n = arguments[3];
                cn.constructor_.call(this, t), this.init(e, s), this._label = n;
            }
        }
        compareDirection(t) {
            return this._dx === t._dx && this._dy === t._dy ? 0 : this._quadrant > t._quadrant ? 1 : this._quadrant < t._quadrant ? -1 : q.index(t._p0, t._p1, this._p1);
        }
        getDy() {
            return this._dy;
        }
        print(t) {
            const e = Math.atan2(this._dy, this._dx), s = this.getClass().getName(), n = s.lastIndexOf("."), i = s.substring(n + 1);
            t.print("  " + i + ": " + this._p0 + " - " + this._p1 + " " + this._quadrant + ":" + e + "   " + this._label);
        }
        getLabel() {
            return this._label;
        }
        getEdge() {
            return this._edge;
        }
        toString() {
            const t = Math.atan2(this._dy, this._dx), e = this.getClass().getName(), s = e.lastIndexOf(".");
            return "  " + e.substring(s + 1) + ": " + this._p0 + " - " + this._p1 + " " + this._quadrant + ":" + t + "   " + this._label;
        }
        computeLabel(t) {}
        init(t, e) {
            this._p0 = t, this._p1 = e, this._dx = e.x - t.x, this._dy = e.y - t.y, this._quadrant = Ds.quadrant(this._dx, this._dy), h.isTrue(!(0 === this._dx && 0 === this._dy), "EdgeEnd with identical endpoints found");
        }
        getCoordinate() {
            return this._p0;
        }
        setNode(t) {
            this._node = t;
        }
        compareTo(t) {
            const e = t;
            return this.compareDirection(e);
        }
        getDirectedCoordinate() {
            return this._p1;
        }
        getDx() {
            return this._dx;
        }
        getQuadrant() {
            return this._quadrant;
        }
        getNode() {
            return this._node;
        }
        get interfaces_() {
            return [
                o
            ];
        }
    }
    let hn = class t extends cn {
        constructor(){
            super(), t.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._isForward = null, this._isInResult = !1, this._isVisited = !1, this._sym = null, this._next = null, this._nextMin = null, this._edgeRing = null, this._minEdgeRing = null, this._depth = [
                0,
                -999,
                -999
            ];
            const t = arguments[0], e = arguments[1];
            if (cn.constructor_.call(this, t), this._isForward = e, e) this.init(t.getCoordinate(0), t.getCoordinate(1));
            else {
                const e = t.getNumPoints() - 1;
                this.init(t.getCoordinate(e), t.getCoordinate(e - 1));
            }
            this.computeDirectedLabel();
        }
        static depthFactor(t, e) {
            return t === Qt.EXTERIOR && e === Qt.INTERIOR ? 1 : t === Qt.INTERIOR && e === Qt.EXTERIOR ? -1 : 0;
        }
        setVisited(t) {
            this._isVisited = t;
        }
        setDepth(t, e) {
            if (-999 !== this._depth[t] && this._depth[t] !== e) throw new _s("assigned depths do not match", this.getCoordinate());
            this._depth[t] = e;
        }
        isInteriorAreaEdge() {
            let t = !0;
            for(let e = 0; e < 2; e++)this._label.isArea(e) && this._label.getLocation(e, Hs.LEFT) === Qt.INTERIOR && this._label.getLocation(e, Hs.RIGHT) === Qt.INTERIOR || (t = !1);
            return t;
        }
        setNextMin(t) {
            this._nextMin = t;
        }
        print(t) {
            super.print.call(this, t), t.print(" " + this._depth[Hs.LEFT] + "/" + this._depth[Hs.RIGHT]), t.print(" (" + this.getDepthDelta() + ")"), this._isInResult && t.print(" inResult");
        }
        setMinEdgeRing(t) {
            this._minEdgeRing = t;
        }
        getSym() {
            return this._sym;
        }
        isForward() {
            return this._isForward;
        }
        setSym(t) {
            this._sym = t;
        }
        setVisitedEdge(t) {
            this.setVisited(t), this._sym.setVisited(t);
        }
        getNextMin() {
            return this._nextMin;
        }
        getDepth(t) {
            return this._depth[t];
        }
        computeDirectedLabel() {
            this._label = new nn(this._edge.getLabel()), this._isForward || this._label.flip();
        }
        getNext() {
            return this._next;
        }
        isLineEdge() {
            const t = this._label.isLine(0) || this._label.isLine(1), e = !this._label.isArea(0) || this._label.allPositionsEqual(0, Qt.EXTERIOR), s = !this._label.isArea(1) || this._label.allPositionsEqual(1, Qt.EXTERIOR);
            return t && e && s;
        }
        setEdgeRing(t) {
            this._edgeRing = t;
        }
        getMinEdgeRing() {
            return this._minEdgeRing;
        }
        getDepthDelta() {
            let t = this._edge.getDepthDelta();
            return this._isForward || (t = -t), t;
        }
        setInResult(t) {
            this._isInResult = t;
        }
        getEdge() {
            return this._edge;
        }
        printEdge(t) {
            this.print(t), t.print(" "), this._isForward ? this._edge.print(t) : this._edge.printReverse(t);
        }
        setEdgeDepths(t, e) {
            let s = this.getEdge().getDepthDelta();
            this._isForward || (s = -s);
            let n = 1;
            t === Hs.LEFT && (n = -1);
            const i = Hs.opposite(t), r = e + s * n;
            this.setDepth(t, e), this.setDepth(i, r);
        }
        getEdgeRing() {
            return this._edgeRing;
        }
        isInResult() {
            return this._isInResult;
        }
        setNext(t) {
            this._next = t;
        }
        isVisited() {
            return this._isVisited;
        }
    }, un = class t {
        constructor(){
            t.constructor_.apply(this, arguments);
        }
        static constructor_() {
            if (this._edges = new L, this._nodes = null, this._edgeEndList = new L, 0 === arguments.length) this._nodes = new ln(new an);
            else if (1 === arguments.length) {
                const t = arguments[0];
                this._nodes = new ln(t);
            }
        }
        static linkResultDirectedEdges(t) {
            for(let e = t.iterator(); e.hasNext();)e.next().getEdges().linkResultDirectedEdges();
        }
        printEdges(t) {
            t.println("Edges:");
            for(let e = 0; e < this._edges.size(); e++){
                t.println("edge " + e + ":");
                const s = this._edges.get(e);
                s.print(t), s.eiList.print(t);
            }
        }
        debugPrintln(t) {
            Y.out.println(t);
        }
        isBoundaryNode(t, e) {
            const s = this._nodes.find(e);
            if (null === s) return !1;
            const n = s.getLabel();
            return null !== n && n.getLocation(t) === Qt.BOUNDARY;
        }
        linkAllDirectedEdges() {
            for(let t = this._nodes.iterator(); t.hasNext();)t.next().getEdges().linkAllDirectedEdges();
        }
        debugPrint(t) {
            Y.out.print(t);
        }
        findEdgeEnd(t) {
            for(let e = this.getEdgeEnds().iterator(); e.hasNext();){
                const s = e.next();
                if (s.getEdge() === t) return s;
            }
            return null;
        }
        getNodes() {
            return this._nodes.values();
        }
        findEdge(t, e) {
            for(let s = 0; s < this._edges.size(); s++){
                const n = this._edges.get(s), i = n.getCoordinates();
                if (t.equals(i[0]) && e.equals(i[1])) return n;
            }
            return null;
        }
        find(t) {
            return this._nodes.find(t);
        }
        addNode() {
            if (arguments[0] instanceof on) {
                const t = arguments[0];
                return this._nodes.addNode(t);
            }
            if (arguments[0] instanceof m) {
                const t = arguments[0];
                return this._nodes.addNode(t);
            }
        }
        getNodeIterator() {
            return this._nodes.iterator();
        }
        linkResultDirectedEdges() {
            for(let t = this._nodes.iterator(); t.hasNext();)t.next().getEdges().linkResultDirectedEdges();
        }
        matchInSameDirection(t, e, s, n) {
            return !!t.equals(s) && q.index(t, e, n) === q.COLLINEAR && Ds.quadrant(t, e) === Ds.quadrant(s, n);
        }
        getEdgeEnds() {
            return this._edgeEndList;
        }
        getEdgeIterator() {
            return this._edges.iterator();
        }
        findEdgeInSameDirection(t, e) {
            for(let s = 0; s < this._edges.size(); s++){
                const n = this._edges.get(s), i = n.getCoordinates();
                if (this.matchInSameDirection(t, e, i[0], i[1])) return n;
                if (this.matchInSameDirection(t, e, i[i.length - 1], i[i.length - 2])) return n;
            }
            return null;
        }
        insertEdge(t) {
            this._edges.add(t);
        }
        addEdges(t) {
            for(let e = t.iterator(); e.hasNext();){
                const t = e.next();
                this._edges.add(t);
                const s = new hn(t, !0), n = new hn(t, !1);
                s.setSym(n), n.setSym(s), this.add(s), this.add(n);
            }
        }
        add(t) {
            this._nodes.add(t), this._edgeEndList.add(t);
        }
    }, gn = class t {
        constructor(){
            t.constructor_.apply(this, arguments);
        }
        static constructor_() {
            if (this._startDe = null, this._maxNodeDegree = -1, this._edges = new L, this._pts = new L, this._label = new nn(Qt.NONE), this._ring = null, this._isHole = null, this._shell = null, this._holes = new L, this._geometryFactory = null, 0 === arguments.length) ;
            else if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                this._geometryFactory = e, this.computePoints(t), this.computeRing();
            }
        }
        computeRing() {
            if (null !== this._ring) return null;
            const t = new Array(this._pts.size()).fill(null);
            for(let e = 0; e < this._pts.size(); e++)t[e] = this._pts.get(e);
            this._ring = this._geometryFactory.createLinearRing(t), this._isHole = q.isCCW(this._ring.getCoordinates());
        }
        isIsolated() {
            return 1 === this._label.getGeometryCount();
        }
        computePoints(t) {
            this._startDe = t;
            let e = t, s = !0;
            do {
                if (null === e) throw new _s("Found null DirectedEdge");
                if (e.getEdgeRing() === this) throw new _s("Directed Edge visited twice during ring-building at " + e.getCoordinate());
                this._edges.add(e);
                const t = e.getLabel();
                h.isTrue(t.isArea()), this.mergeLabel(t), this.addPoints(e.getEdge(), e.isForward(), s), s = !1, this.setEdgeRing(e, this), e = this.getNext(e);
            }while (e !== this._startDe);
        }
        getLinearRing() {
            return this._ring;
        }
        getCoordinate(t) {
            return this._pts.get(t);
        }
        computeMaxNodeDegree() {
            this._maxNodeDegree = 0;
            let t = this._startDe;
            do {
                const e = t.getNode().getEdges().getOutgoingDegree(this);
                e > this._maxNodeDegree && (this._maxNodeDegree = e), t = this.getNext(t);
            }while (t !== this._startDe);
            this._maxNodeDegree *= 2;
        }
        addPoints(t, e, s) {
            const n = t.getCoordinates();
            if (e) {
                let t = 1;
                s && (t = 0);
                for(let e = t; e < n.length; e++)this._pts.add(n[e]);
            } else {
                let t = n.length - 2;
                s && (t = n.length - 1);
                for(let e = t; e >= 0; e--)this._pts.add(n[e]);
            }
        }
        containsPoint(t) {
            const e = this.getLinearRing();
            if (!e.getEnvelopeInternal().contains(t)) return !1;
            if (!Ue.isInRing(t, e.getCoordinates())) return !1;
            for(let e = this._holes.iterator(); e.hasNext();){
                if (e.next().containsPoint(t)) return !1;
            }
            return !0;
        }
        getMaxNodeDegree() {
            return this._maxNodeDegree < 0 && this.computeMaxNodeDegree(), this._maxNodeDegree;
        }
        setShell(t) {
            this._shell = t, null !== t && t.addHole(this);
        }
        toPolygon(t) {
            const e = new Array(this._holes.size()).fill(null);
            for(let t = 0; t < this._holes.size(); t++)e[t] = this._holes.get(t).getLinearRing();
            return t.createPolygon(this.getLinearRing(), e);
        }
        isHole() {
            return this._isHole;
        }
        setInResult() {
            let t = this._startDe;
            do t.getEdge().setInResult(!0), t = t.getNext();
            while (t !== this._startDe);
        }
        addHole(t) {
            this._holes.add(t);
        }
        isShell() {
            return null === this._shell;
        }
        getLabel() {
            return this._label;
        }
        getEdges() {
            return this._edges;
        }
        getShell() {
            return this._shell;
        }
        mergeLabel() {
            if (1 === arguments.length) {
                const t = arguments[0];
                this.mergeLabel(t, 0), this.mergeLabel(t, 1);
            } else if (2 === arguments.length) {
                const t = arguments[1], e = arguments[0].getLocation(t, Hs.RIGHT);
                if (e === Qt.NONE) return null;
                if (this._label.getLocation(t) === Qt.NONE) return this._label.setLocation(t, e), null;
            }
        }
    };
    class dn extends gn {
        constructor(){
            super(), dn.constructor_.apply(this, arguments);
        }
        static constructor_() {
            const t = arguments[0], e = arguments[1];
            gn.constructor_.call(this, t, e);
        }
        getNext(t) {
            return t.getNextMin();
        }
        setEdgeRing(t, e) {
            t.setMinEdgeRing(e);
        }
    }
    class _n extends gn {
        constructor(){
            super(), _n.constructor_.apply(this, arguments);
        }
        static constructor_() {
            const t = arguments[0], e = arguments[1];
            gn.constructor_.call(this, t, e);
        }
        linkDirectedEdgesForMinimalEdgeRings() {
            let t = this._startDe;
            do t.getNode().getEdges().linkMinimalDirectedEdges(this), t = t.getNext();
            while (t !== this._startDe);
        }
        buildMinimalRings() {
            const t = new L;
            let e = this._startDe;
            do {
                if (null === e.getMinEdgeRing()) {
                    const s = new dn(e, this._geometryFactory);
                    t.add(s);
                }
                e = e.getNext();
            }while (e !== this._startDe);
            return t;
        }
        getNext(t) {
            return t.getNext();
        }
        setEdgeRing(t, e) {
            t.setEdgeRing(e);
        }
    }
    class pn {
        constructor(){
            pn.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._geometryFactory = null, this._shellList = new L;
            const t = arguments[0];
            this._geometryFactory = t;
        }
        static findEdgeRingContaining(t, e) {
            const s = t.getLinearRing(), n = s.getEnvelopeInternal();
            let i = s.getCoordinateN(0), r = null, o = null;
            for(let t = e.iterator(); t.hasNext();){
                const e = t.next(), l = e.getLinearRing(), a = l.getEnvelopeInternal();
                if (a.equals(n)) continue;
                if (!a.contains(n)) continue;
                i = W.ptNotInList(s.getCoordinates(), l.getCoordinates());
                let c = !1;
                Ue.isInRing(i, l.getCoordinates()) && (c = !0), c && (null === r || o.contains(a)) && (r = e, o = r.getLinearRing().getEnvelopeInternal());
            }
            return r;
        }
        sortShellsAndHoles(t, e, s) {
            for(let n = t.iterator(); n.hasNext();){
                const t = n.next();
                t.isHole() ? s.add(t) : e.add(t);
            }
        }
        computePolygons(t) {
            const e = new L;
            for(let s = t.iterator(); s.hasNext();){
                const t = s.next().toPolygon(this._geometryFactory);
                e.add(t);
            }
            return e;
        }
        placeFreeHoles(t, e) {
            for(let s = e.iterator(); s.hasNext();){
                const e = s.next();
                if (null === e.getShell()) {
                    const s = pn.findEdgeRingContaining(e, t);
                    if (null === s) throw new _s("unable to assign hole to a shell", e.getCoordinate(0));
                    e.setShell(s);
                }
            }
        }
        buildMinimalEdgeRings(t, e, s) {
            const n = new L;
            for(let i = t.iterator(); i.hasNext();){
                const t = i.next();
                if (t.getMaxNodeDegree() > 2) {
                    t.linkDirectedEdgesForMinimalEdgeRings();
                    const n = t.buildMinimalRings(), i = this.findShell(n);
                    null !== i ? (this.placePolygonHoles(i, n), e.add(i)) : s.addAll(n);
                } else n.add(t);
            }
            return n;
        }
        buildMaximalEdgeRings(t) {
            const e = new L;
            for(let s = t.iterator(); s.hasNext();){
                const t = s.next();
                if (t.isInResult() && t.getLabel().isArea() && null === t.getEdgeRing()) {
                    const s = new _n(t, this._geometryFactory);
                    e.add(s), s.setInResult();
                }
            }
            return e;
        }
        placePolygonHoles(t, e) {
            for(let s = e.iterator(); s.hasNext();){
                const e = s.next();
                e.isHole() && e.setShell(t);
            }
        }
        getPolygons() {
            return this.computePolygons(this._shellList);
        }
        findShell(t) {
            let e = 0, s = null;
            for(let n = t.iterator(); n.hasNext();){
                const t = n.next();
                t.isHole() || (s = t, e++);
            }
            return h.isTrue(e <= 1, "found two shells in MinimalEdgeRing list"), s;
        }
        add() {
            if (1 === arguments.length) {
                const t = arguments[0];
                this.add(t.getEdgeEnds(), t.getNodes());
            } else if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                un.linkResultDirectedEdges(e);
                const s = this.buildMaximalEdgeRings(t), n = new L, i = this.buildMinimalEdgeRings(s, this._shellList, n);
                this.sortShellsAndHoles(i, this._shellList, n), this.placeFreeHoles(this._shellList, n);
            }
        }
    }
    class mn {
        constructor(){
            mn.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._subgraphs = null, this._seg = new Kt;
            const t = arguments[0];
            this._subgraphs = t;
        }
        findStabbedSegments() {
            if (1 === arguments.length) {
                const t = arguments[0], e = new L;
                for(let s = this._subgraphs.iterator(); s.hasNext();){
                    const n = s.next(), i = n.getEnvelope();
                    t.y < i.getMinY() || t.y > i.getMaxY() || this.findStabbedSegments(t, n.getDirectedEdges(), e);
                }
                return e;
            }
            if (3 === arguments.length) {
                if (I(arguments[2], C) && arguments[0] instanceof m && arguments[1] instanceof hn) {
                    const t = arguments[0], e = arguments[1], s = arguments[2], n = e.getEdge().getCoordinates();
                    for(let i = 0; i < n.length - 1; i++){
                        this._seg.p0 = n[i], this._seg.p1 = n[i + 1], this._seg.p0.y > this._seg.p1.y && this._seg.reverse();
                        if (Math.max(this._seg.p0.x, this._seg.p1.x) < t.x) continue;
                        if (this._seg.isHorizontal()) continue;
                        if (t.y < this._seg.p0.y || t.y > this._seg.p1.y) continue;
                        if (q.index(this._seg.p0, this._seg.p1, t) === q.RIGHT) continue;
                        let r = e.getDepth(Hs.LEFT);
                        this._seg.p0.equals(n[i]) || (r = e.getDepth(Hs.RIGHT));
                        const o = new fn(this._seg, r);
                        s.add(o);
                    }
                } else if (I(arguments[2], C) && arguments[0] instanceof m && I(arguments[1], C)) {
                    const t = arguments[0], e = arguments[2];
                    for(let s = arguments[1].iterator(); s.hasNext();){
                        const n = s.next();
                        n.isForward() && this.findStabbedSegments(t, n, e);
                    }
                }
            }
        }
        getDepth(t) {
            const e = this.findStabbedSegments(t);
            if (0 === e.size()) return 0;
            return xe.min(e)._leftDepth;
        }
    }
    class fn {
        constructor(){
            fn.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._upwardSeg = null, this._leftDepth = null;
            const t = arguments[0], e = arguments[1];
            this._upwardSeg = new Kt(t), this._leftDepth = e;
        }
        compareX(t, e) {
            const s = t.p0.compareTo(e.p0);
            return 0 !== s ? s : t.p1.compareTo(e.p1);
        }
        toString() {
            return this._upwardSeg.toString();
        }
        compareTo(t) {
            const e = t;
            if (this._upwardSeg.minX() >= e._upwardSeg.maxX()) return 1;
            if (this._upwardSeg.maxX() <= e._upwardSeg.minX()) return -1;
            let s = this._upwardSeg.orientationIndex(e._upwardSeg);
            return 0 !== s ? s : (s = -1 * e._upwardSeg.orientationIndex(this._upwardSeg), 0 !== s ? s : this._upwardSeg.compareTo(e._upwardSeg));
        }
        get interfaces_() {
            return [
                o
            ];
        }
    }
    mn.DepthSegment = fn;
    class yn {
        constructor(){
            yn.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._inputGeom = null, this._distance = null, this._curveBuilder = null, this._curveList = new L;
            const t = arguments[0], e = arguments[1], s = arguments[2];
            this._inputGeom = t, this._distance = e, this._curveBuilder = s;
        }
        addRingSide(t, e, s, n, i) {
            if (0 === e && t.length < et.MINIMUM_VALID_SIZE) return null;
            let r = n, o = i;
            t.length >= et.MINIMUM_VALID_SIZE && q.isCCW(t) && (r = i, o = n, s = Hs.opposite(s));
            const l = this._curveBuilder.getRingCurve(t, s, e);
            this.addCurve(l, r, o);
        }
        addRingBothSides(t, e) {
            this.addRingSide(t, e, Hs.LEFT, Qt.EXTERIOR, Qt.INTERIOR), this.addRingSide(t, e, Hs.RIGHT, Qt.INTERIOR, Qt.EXTERIOR);
        }
        addPoint(t) {
            if (this._distance <= 0) return null;
            const e = t.getCoordinates(), s = this._curveBuilder.getLineCurve(e, this._distance);
            this.addCurve(s, Qt.EXTERIOR, Qt.INTERIOR);
        }
        addPolygon(t) {
            let e = this._distance, s = Hs.LEFT;
            this._distance < 0 && (e = -this._distance, s = Hs.RIGHT);
            const n = t.getExteriorRing(), i = W.removeRepeatedPoints(n.getCoordinates());
            if (this._distance < 0 && this.isErodedCompletely(n, this._distance)) return null;
            if (this._distance <= 0 && i.length < 3) return null;
            this.addRingSide(i, e, s, Qt.EXTERIOR, Qt.INTERIOR);
            for(let n = 0; n < t.getNumInteriorRing(); n++){
                const i = t.getInteriorRingN(n), r = W.removeRepeatedPoints(i.getCoordinates());
                this._distance > 0 && this.isErodedCompletely(i, -this._distance) || this.addRingSide(r, e, Hs.opposite(s), Qt.INTERIOR, Qt.EXTERIOR);
            }
        }
        isTriangleErodedCompletely(t, e) {
            const s = new se(t[0], t[1], t[2]), n = s.inCentre();
            return V.pointToSegment(n, s.p0, s.p1) < Math.abs(e);
        }
        addLineString(t) {
            if (this._curveBuilder.isLineOffsetEmpty(this._distance)) return null;
            const e = W.removeRepeatedPoints(t.getCoordinates());
            if (W.isRing(e) && !this._curveBuilder.getBufferParameters().isSingleSided()) this.addRingBothSides(e, this._distance);
            else {
                const t = this._curveBuilder.getLineCurve(e, this._distance);
                this.addCurve(t, Qt.EXTERIOR, Qt.INTERIOR);
            }
        }
        add(t) {
            if (t.isEmpty()) return null;
            if (t instanceof Ct) this.addPolygon(t);
            else if (t instanceof tt) this.addLineString(t);
            else if (t instanceof Nt) this.addPoint(t);
            else if (t instanceof St) this.addCollection(t);
            else if (t instanceof Et) this.addCollection(t);
            else if (t instanceof dt) this.addCollection(t);
            else {
                if (!(t instanceof ut)) throw new U(t.getGeometryType());
                this.addCollection(t);
            }
        }
        addCurve(t, e, s) {
            if (null === t || t.length < 2) return null;
            const n = new us(t, new nn(0, Qt.BOUNDARY, e, s));
            this._curveList.add(n);
        }
        getCurves() {
            return this.add(this._inputGeom), this._curveList;
        }
        isErodedCompletely(t, e) {
            const s = t.getCoordinates();
            if (s.length < 4) return e < 0;
            if (4 === s.length) return this.isTriangleErodedCompletely(s, e);
            const n = t.getEnvelopeInternal(), i = Math.min(n.getHeight(), n.getWidth());
            return e < 0 && 2 * Math.abs(e) > i;
        }
        addCollection(t) {
            for(let e = 0; e < t.getNumGeometries(); e++){
                const s = t.getGeometryN(e);
                this.add(s);
            }
        }
    }
    class xn {
        constructor(){
            xn.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._edgeMap = new os, this._edgeList = null, this._ptInAreaLocation = [
                Qt.NONE,
                Qt.NONE
            ];
        }
        getNextCW(t) {
            this.getEdges();
            const e = this._edgeList.indexOf(t);
            let s = e - 1;
            return 0 === e && (s = this._edgeList.size() - 1), this._edgeList.get(s);
        }
        propagateSideLabels(t) {
            let e = Qt.NONE;
            for(let s = this.iterator(); s.hasNext();){
                const n = s.next().getLabel();
                n.isArea(t) && n.getLocation(t, Hs.LEFT) !== Qt.NONE && (e = n.getLocation(t, Hs.LEFT));
            }
            if (e === Qt.NONE) return null;
            let s = e;
            for(let e = this.iterator(); e.hasNext();){
                const n = e.next(), i = n.getLabel();
                if (i.getLocation(t, Hs.ON) === Qt.NONE && i.setLocation(t, Hs.ON, s), i.isArea(t)) {
                    const e = i.getLocation(t, Hs.LEFT), r = i.getLocation(t, Hs.RIGHT);
                    if (r !== Qt.NONE) {
                        if (r !== s) throw new _s("side location conflict", n.getCoordinate());
                        e === Qt.NONE && h.shouldNeverReachHere("found single null side (at " + n.getCoordinate() + ")"), s = e;
                    } else h.isTrue(i.getLocation(t, Hs.LEFT) === Qt.NONE, "found single null side"), i.setLocation(t, Hs.RIGHT, s), i.setLocation(t, Hs.LEFT, s);
                }
            }
        }
        getCoordinate() {
            const t = this.iterator();
            if (!t.hasNext()) return null;
            return t.next().getCoordinate();
        }
        checkAreaLabelsConsistent(t) {
            const e = this.getEdges();
            if (e.size() <= 0) return !0;
            const s = e.size() - 1, n = e.get(s).getLabel().getLocation(t, Hs.LEFT);
            h.isTrue(n !== Qt.NONE, "Found unlabelled area edge");
            let i = n;
            for(let e = this.iterator(); e.hasNext();){
                const s = e.next().getLabel();
                h.isTrue(s.isArea(t), "Found non-area edge");
                const n = s.getLocation(t, Hs.LEFT), r = s.getLocation(t, Hs.RIGHT);
                if (n === r) return !1;
                if (r !== i) return !1;
                i = n;
            }
            return !0;
        }
        findIndex(t) {
            this.iterator();
            for(let e = 0; e < this._edgeList.size(); e++){
                if (this._edgeList.get(e) === t) return e;
            }
            return -1;
        }
        iterator() {
            return this.getEdges().iterator();
        }
        getEdges() {
            return null === this._edgeList && (this._edgeList = new L(this._edgeMap.values())), this._edgeList;
        }
        getLocation(t, e, s) {
            return this._ptInAreaLocation[t] === Qt.NONE && (this._ptInAreaLocation[t] = Ze.locate(e, s[t].getGeometry())), this._ptInAreaLocation[t];
        }
        toString() {
            const t = new v;
            t.append("EdgeEndStar:   " + this.getCoordinate()), t.append("\n");
            for(let e = this.iterator(); e.hasNext();){
                const s = e.next();
                t.append(s), t.append("\n");
            }
            return t.toString();
        }
        computeEdgeEndLabels(t) {
            for(let e = this.iterator(); e.hasNext();)e.next().computeLabel(t);
        }
        computeLabelling(t) {
            this.computeEdgeEndLabels(t[0].getBoundaryNodeRule()), this.propagateSideLabels(0), this.propagateSideLabels(1);
            const e = [
                !1,
                !1
            ];
            for(let t = this.iterator(); t.hasNext();){
                const s = t.next().getLabel();
                for(let t = 0; t < 2; t++)s.isLine(t) && s.getLocation(t) === Qt.BOUNDARY && (e[t] = !0);
            }
            for(let s = this.iterator(); s.hasNext();){
                const n = s.next(), i = n.getLabel();
                for(let s = 0; s < 2; s++)if (i.isAnyNull(s)) {
                    let r = Qt.NONE;
                    if (e[s]) r = Qt.EXTERIOR;
                    else {
                        const e = n.getCoordinate();
                        r = this.getLocation(s, e, t);
                    }
                    i.setAllLocationsIfNull(s, r);
                }
            }
        }
        getDegree() {
            return this._edgeMap.size();
        }
        insertEdgeEnd(t, e) {
            this._edgeMap.put(t, e), this._edgeList = null;
        }
        print(t) {
            Y.out.println("EdgeEndStar:   " + this.getCoordinate());
            for(let e = this.iterator(); e.hasNext();)e.next().print(t);
        }
        isAreaLabelsConsistent(t) {
            return this.computeEdgeEndLabels(t.getBoundaryNodeRule()), this.checkAreaLabelsConsistent(0);
        }
    }
    let En = class t extends xn {
        constructor(){
            super(), t.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._resultAreaEdgeList = null, this._label = null, this._SCANNING_FOR_INCOMING = 1, this._LINKING_TO_OUTGOING = 2;
        }
        linkResultDirectedEdges() {
            this.getResultAreaEdges();
            let t = null, e = null, s = this._SCANNING_FOR_INCOMING;
            for(let n = 0; n < this._resultAreaEdgeList.size(); n++){
                const i = this._resultAreaEdgeList.get(n), r = i.getSym();
                if (i.getLabel().isArea()) switch(null === t && i.isInResult() && (t = i), s){
                    case this._SCANNING_FOR_INCOMING:
                        if (!r.isInResult()) continue;
                        e = r, s = this._LINKING_TO_OUTGOING;
                        break;
                    case this._LINKING_TO_OUTGOING:
                        if (!i.isInResult()) continue;
                        e.setNext(i), s = this._SCANNING_FOR_INCOMING;
                }
            }
            if (s === this._LINKING_TO_OUTGOING) {
                if (null === t) throw new _s("no outgoing dirEdge found", this.getCoordinate());
                h.isTrue(t.isInResult(), "unable to link last incoming dirEdge"), e.setNext(t);
            }
        }
        insert(t) {
            const e = t;
            this.insertEdgeEnd(e, e);
        }
        getRightmostEdge() {
            const t = this.getEdges(), e = t.size();
            if (e < 1) return null;
            const s = t.get(0);
            if (1 === e) return s;
            const n = t.get(e - 1), i = s.getQuadrant(), r = n.getQuadrant();
            return Ds.isNorthern(i) && Ds.isNorthern(r) ? s : Ds.isNorthern(i) || Ds.isNorthern(r) ? 0 !== s.getDy() ? s : 0 !== n.getDy() ? n : (h.shouldNeverReachHere("found two horizontal edges incident on node"), null) : n;
        }
        updateLabelling(t) {
            for(let e = this.iterator(); e.hasNext();){
                const s = e.next().getLabel();
                s.setAllLocationsIfNull(0, t.getLocation(0)), s.setAllLocationsIfNull(1, t.getLocation(1));
            }
        }
        linkAllDirectedEdges() {
            this.getEdges();
            let t = null, e = null;
            for(let s = this._edgeList.size() - 1; s >= 0; s--){
                const n = this._edgeList.get(s), i = n.getSym();
                null === e && (e = i), null !== t && i.setNext(t), t = n;
            }
            e.setNext(t);
        }
        computeDepths() {
            if (1 === arguments.length) {
                const t = arguments[0], e = this.findIndex(t), s = t.getDepth(Hs.LEFT), n = t.getDepth(Hs.RIGHT), i = this.computeDepths(e + 1, this._edgeList.size(), s);
                if (this.computeDepths(0, e, i) !== n) throw new _s("depth mismatch at " + t.getCoordinate());
            } else if (3 === arguments.length) {
                const t = arguments[1];
                let e = arguments[2];
                for(let s = arguments[0]; s < t; s++){
                    const t = this._edgeList.get(s);
                    t.setEdgeDepths(Hs.RIGHT, e), e = t.getDepth(Hs.LEFT);
                }
                return e;
            }
        }
        mergeSymLabels() {
            for(let t = this.iterator(); t.hasNext();){
                const e = t.next();
                e.getLabel().merge(e.getSym().getLabel());
            }
        }
        linkMinimalDirectedEdges(t) {
            let e = null, s = null, n = this._SCANNING_FOR_INCOMING;
            for(let i = this._resultAreaEdgeList.size() - 1; i >= 0; i--){
                const r = this._resultAreaEdgeList.get(i), o = r.getSym();
                switch(null === e && r.getEdgeRing() === t && (e = r), n){
                    case this._SCANNING_FOR_INCOMING:
                        if (o.getEdgeRing() !== t) continue;
                        s = o, n = this._LINKING_TO_OUTGOING;
                        break;
                    case this._LINKING_TO_OUTGOING:
                        if (r.getEdgeRing() !== t) continue;
                        s.setNextMin(r), n = this._SCANNING_FOR_INCOMING;
                }
            }
            n === this._LINKING_TO_OUTGOING && (h.isTrue(null !== e, "found null for first outgoing dirEdge"), h.isTrue(e.getEdgeRing() === t, "unable to link last incoming dirEdge"), s.setNextMin(e));
        }
        getOutgoingDegree() {
            if (0 === arguments.length) {
                let t = 0;
                for(let e = this.iterator(); e.hasNext();)e.next().isInResult() && t++;
                return t;
            }
            if (1 === arguments.length) {
                const t = arguments[0];
                let e = 0;
                for(let s = this.iterator(); s.hasNext();)s.next().getEdgeRing() === t && e++;
                return e;
            }
        }
        getLabel() {
            return this._label;
        }
        findCoveredLineEdges() {
            let t = Qt.NONE;
            for(let e = this.iterator(); e.hasNext();){
                const s = e.next(), n = s.getSym();
                if (!s.isLineEdge()) {
                    if (s.isInResult()) {
                        t = Qt.INTERIOR;
                        break;
                    }
                    if (n.isInResult()) {
                        t = Qt.EXTERIOR;
                        break;
                    }
                }
            }
            if (t === Qt.NONE) return null;
            let e = t;
            for(let t = this.iterator(); t.hasNext();){
                const s = t.next(), n = s.getSym();
                s.isLineEdge() ? s.getEdge().setCovered(e === Qt.INTERIOR) : (s.isInResult() && (e = Qt.EXTERIOR), n.isInResult() && (e = Qt.INTERIOR));
            }
        }
        computeLabelling(t) {
            super.computeLabelling.call(this, t), this._label = new nn(Qt.NONE);
            for(let t = this.iterator(); t.hasNext();){
                const e = t.next().getEdge().getLabel();
                for(let t = 0; t < 2; t++){
                    const s = e.getLocation(t);
                    s !== Qt.INTERIOR && s !== Qt.BOUNDARY || this._label.setLocation(t, Qt.INTERIOR);
                }
            }
        }
        print(t) {
            Y.out.println("DirectedEdgeStar: " + this.getCoordinate());
            for(let e = this.iterator(); e.hasNext();){
                const s = e.next();
                t.print("out "), s.print(t), t.println(), t.print("in "), s.getSym().print(t), t.println();
            }
        }
        getResultAreaEdges() {
            if (null !== this._resultAreaEdgeList) return this._resultAreaEdgeList;
            this._resultAreaEdgeList = new L;
            for(let t = this.iterator(); t.hasNext();){
                const e = t.next();
                (e.isInResult() || e.getSym().isInResult()) && this._resultAreaEdgeList.add(e);
            }
            return this._resultAreaEdgeList;
        }
    };
    class In extends an {
        constructor(){
            super();
        }
        createNode(t) {
            return new on(t, new En);
        }
    }
    class Nn {
        constructor(){
            Nn.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._pts = null, this._orientation = null;
            const t = arguments[0];
            this._pts = t, this._orientation = Nn.orientation(t);
        }
        static orientation(t) {
            return 1 === W.increasingDirection(t);
        }
        static compareOriented(t, e, s, n) {
            const i = e ? 1 : -1, r = n ? 1 : -1, o = e ? t.length : -1, l = n ? s.length : -1;
            let a = e ? 0 : t.length - 1, c = n ? 0 : s.length - 1;
            for(;;){
                const e = t[a].compareTo(s[c]);
                if (0 !== e) return e;
                a += i, c += r;
                const n = a === o, h = c === l;
                if (n && !h) return -1;
                if (!n && h) return 1;
                if (n && h) return 0;
            }
        }
        compareTo(t) {
            const e = t;
            return Nn.compareOriented(this._pts, this._orientation, e._pts, e._orientation);
        }
        get interfaces_() {
            return [
                o
            ];
        }
    }
    class wn {
        constructor(){
            wn.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._edges = new L, this._ocaMap = new os;
        }
        print(t) {
            t.print("MULTILINESTRING ( ");
            for(let e = 0; e < this._edges.size(); e++){
                const s = this._edges.get(e);
                e > 0 && t.print(","), t.print("(");
                const n = s.getCoordinates();
                for(let e = 0; e < n.length; e++)e > 0 && t.print(","), t.print(n[e].x + " " + n[e].y);
                t.println(")");
            }
            t.print(")  ");
        }
        addAll(t) {
            for(let e = t.iterator(); e.hasNext();)this.add(e.next());
        }
        findEdgeIndex(t) {
            for(let e = 0; e < this._edges.size(); e++)if (this._edges.get(e).equals(t)) return e;
            return -1;
        }
        iterator() {
            return this._edges.iterator();
        }
        getEdges() {
            return this._edges;
        }
        get(t) {
            return this._edges.get(t);
        }
        findEqualEdge(t) {
            const e = new Nn(t.getCoordinates());
            return this._ocaMap.get(e);
        }
        add(t) {
            this._edges.add(t);
            const e = new Nn(t.getCoordinates());
            this._ocaMap.put(e, t);
        }
    }
    class Cn {
        constructor(){
            Cn.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._hasIntersection = !1, this._hasProper = !1, this._hasProperInterior = !1, this._hasInterior = !1, this._properIntersectionPoint = null, this._li = null, this._isSelfIntersection = null, this.numIntersections = 0, this.numInteriorIntersections = 0, this.numProperIntersections = 0, this.numTests = 0;
            const t = arguments[0];
            this._li = t;
        }
        static isAdjacentSegments(t, e) {
            return 1 === Math.abs(t - e);
        }
        isTrivialIntersection(t, e, s, n) {
            if (t === s && 1 === this._li.getIntersectionNum()) {
                if (Cn.isAdjacentSegments(e, n)) return !0;
                if (t.isClosed()) {
                    const s = t.size() - 1;
                    if (0 === e && n === s || 0 === n && e === s) return !0;
                }
            }
            return !1;
        }
        getProperIntersectionPoint() {
            return this._properIntersectionPoint;
        }
        hasProperInteriorIntersection() {
            return this._hasProperInterior;
        }
        getLineIntersector() {
            return this._li;
        }
        hasProperIntersection() {
            return this._hasProper;
        }
        processIntersections(t, e, s, n) {
            if (t === s && e === n) return null;
            this.numTests++;
            const i = t.getCoordinates()[e], r = t.getCoordinates()[e + 1], o = s.getCoordinates()[n], l = s.getCoordinates()[n + 1];
            this._li.computeIntersection(i, r, o, l), this._li.hasIntersection() && (this.numIntersections++, this._li.isInteriorIntersection() && (this.numInteriorIntersections++, this._hasInterior = !0), this.isTrivialIntersection(t, e, s, n) || (this._hasIntersection = !0, t.addIntersections(this._li, e, 0), s.addIntersections(this._li, n, 1), this._li.isProper() && (this.numProperIntersections++, this._hasProper = !0, this._hasProperInterior = !0)));
        }
        hasIntersection() {
            return this._hasIntersection;
        }
        isDone() {
            return !1;
        }
        hasInteriorIntersection() {
            return this._hasInterior;
        }
        get interfaces_() {
            return [
                ks
            ];
        }
    }
    class Sn {
        constructor(){
            Sn.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this.coord = null, this.segmentIndex = null, this.dist = null;
            const t = arguments[0], e = arguments[1], s = arguments[2];
            this.coord = new m(t), this.segmentIndex = e, this.dist = s;
        }
        getSegmentIndex() {
            return this.segmentIndex;
        }
        getCoordinate() {
            return this.coord;
        }
        print(t) {
            t.print(this.coord), t.print(" seg # = " + this.segmentIndex), t.println(" dist = " + this.dist);
        }
        compareTo(t) {
            const e = t;
            return this.compare(e.segmentIndex, e.dist);
        }
        isEndPoint(t) {
            return 0 === this.segmentIndex && 0 === this.dist || this.segmentIndex === t;
        }
        toString() {
            return this.coord + " seg # = " + this.segmentIndex + " dist = " + this.dist;
        }
        getDistance() {
            return this.dist;
        }
        compare(t, e) {
            return this.segmentIndex < t ? -1 : this.segmentIndex > t ? 1 : this.dist < e ? -1 : this.dist > e ? 1 : 0;
        }
        get interfaces_() {
            return [
                o
            ];
        }
    }
    class Ln {
        constructor(){
            Ln.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._nodeMap = new os, this.edge = null;
            const t = arguments[0];
            this.edge = t;
        }
        print(t) {
            t.println("Intersections:");
            for(let e = this.iterator(); e.hasNext();)e.next().print(t);
        }
        addEndpoints() {
            const t = this.edge.pts.length - 1;
            this.add(this.edge.pts[0], 0, 0), this.add(this.edge.pts[t], t, 0);
        }
        createSplitEdge(t, e) {
            let s = e.segmentIndex - t.segmentIndex + 2;
            const n = this.edge.pts[e.segmentIndex], i = e.dist > 0 || !e.coord.equals2D(n);
            i || s--;
            const r = new Array(s).fill(null);
            let o = 0;
            r[o++] = new m(t.coord);
            for(let s = t.segmentIndex + 1; s <= e.segmentIndex; s++)r[o++] = this.edge.pts[s];
            return i && (r[o] = e.coord), new vn(r, new nn(this.edge._label));
        }
        add(t, e, s) {
            const n = new Sn(t, e, s), i = this._nodeMap.get(n);
            return null !== i ? i : (this._nodeMap.put(n, n), n);
        }
        isIntersection(t) {
            for(let e = this.iterator(); e.hasNext();){
                if (e.next().coord.equals(t)) return !0;
            }
            return !1;
        }
        iterator() {
            return this._nodeMap.values().iterator();
        }
        addSplitEdges(t) {
            this.addEndpoints();
            const e = this.iterator();
            let s = e.next();
            for(; e.hasNext();){
                const n = e.next(), i = this.createSplitEdge(s, n);
                t.add(i), s = n;
            }
        }
    }
    class Tn {
        constructor(){
            Tn.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._depth = Array(2).fill().map(()=>Array(3));
            for(let t = 0; t < 2; t++)for(let e = 0; e < 3; e++)this._depth[t][e] = Tn.NULL_VALUE;
        }
        static depthAtLocation(t) {
            return t === Qt.EXTERIOR ? 0 : t === Qt.INTERIOR ? 1 : Tn.NULL_VALUE;
        }
        getDepth(t, e) {
            return this._depth[t][e];
        }
        setDepth(t, e, s) {
            this._depth[t][e] = s;
        }
        isNull() {
            if (0 === arguments.length) {
                for(let t = 0; t < 2; t++)for(let e = 0; e < 3; e++)if (this._depth[t][e] !== Tn.NULL_VALUE) return !1;
                return !0;
            }
            if (1 === arguments.length) {
                const t = arguments[0];
                return this._depth[t][1] === Tn.NULL_VALUE;
            }
            if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                return this._depth[t][e] === Tn.NULL_VALUE;
            }
        }
        normalize() {
            for(let t = 0; t < 2; t++)if (!this.isNull(t)) {
                let e = this._depth[t][1];
                this._depth[t][2] < e && (e = this._depth[t][2]), e < 0 && (e = 0);
                for(let s = 1; s < 3; s++){
                    let n = 0;
                    this._depth[t][s] > e && (n = 1), this._depth[t][s] = n;
                }
            }
        }
        getDelta(t) {
            return this._depth[t][Hs.RIGHT] - this._depth[t][Hs.LEFT];
        }
        getLocation(t, e) {
            return this._depth[t][e] <= 0 ? Qt.EXTERIOR : Qt.INTERIOR;
        }
        toString() {
            return "A: " + this._depth[0][1] + "," + this._depth[0][2] + " B: " + this._depth[1][1] + "," + this._depth[1][2];
        }
        add() {
            if (1 === arguments.length) {
                const t = arguments[0];
                for(let e = 0; e < 2; e++)for(let s = 1; s < 3; s++){
                    const n = t.getLocation(e, s);
                    n !== Qt.EXTERIOR && n !== Qt.INTERIOR || (this.isNull(e, s) ? this._depth[e][s] = Tn.depthAtLocation(n) : this._depth[e][s] += Tn.depthAtLocation(n));
                }
            } else if (3 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                arguments[2] === Qt.INTERIOR && this._depth[t][e]++;
            }
        }
    }
    Tn.NULL_VALUE = -1;
    class Rn {
        constructor(){
            Rn.constructor_.apply(this, arguments);
        }
        static constructor_() {
            if (this._data = null, this._size = 0, 0 === arguments.length) Rn.constructor_.call(this, 10);
            else if (1 === arguments.length) {
                const t = arguments[0];
                this._data = new Array(t).fill(null);
            }
        }
        size() {
            return this._size;
        }
        addAll(t) {
            return null === t || 0 === t.length ? null : (this.ensureCapacity(this._size + t.length), Y.arraycopy(t, 0, this._data, this._size, t.length), void (this._size += t.length));
        }
        ensureCapacity(t) {
            if (t <= this._data.length) return null;
            const e = Math.max(t, 2 * this._data.length);
            this._data = ht.copyOf(this._data, e);
        }
        toArray() {
            const t = new Array(this._size).fill(null);
            return Y.arraycopy(this._data, 0, t, 0, this._size), t;
        }
        add(t) {
            this.ensureCapacity(this._size + 1), this._data[this._size] = t, ++this._size;
        }
    }
    class Pn {
        static toIntArray(t) {
            const e = new Array(t.size()).fill(null);
            for(let s = 0; s < e.length; s++)e[s] = t.get(s).intValue();
            return e;
        }
        findChainEnd(t, e) {
            const s = Ds.quadrant(t[e], t[e + 1]);
            let n = e + 1;
            for(; n < t.length;){
                if (Ds.quadrant(t[n - 1], t[n]) !== s) break;
                n++;
            }
            return n - 1;
        }
        OLDgetChainStartIndices(t) {
            let e = 0;
            const s = new L;
            s.add(e);
            do {
                const n = this.findChainEnd(t, e);
                s.add(n), e = n;
            }while (e < t.length - 1);
            return Pn.toIntArray(s);
        }
        getChainStartIndices(t) {
            let e = 0;
            const s = new Rn(Math.trunc(t.length / 2));
            s.add(e);
            do {
                const n = this.findChainEnd(t, e);
                s.add(n), e = n;
            }while (e < t.length - 1);
            return s.toArray();
        }
    }
    class On {
        constructor(){
            On.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this.e = null, this.pts = null, this.startIndex = null;
            const t = arguments[0];
            this.e = t, this.pts = t.getCoordinates();
            const e = new Pn;
            this.startIndex = e.getChainStartIndices(this.pts);
        }
        getCoordinates() {
            return this.pts;
        }
        getMaxX(t) {
            const e = this.pts[this.startIndex[t]].x, s = this.pts[this.startIndex[t + 1]].x;
            return e > s ? e : s;
        }
        getMinX(t) {
            const e = this.pts[this.startIndex[t]].x, s = this.pts[this.startIndex[t + 1]].x;
            return e < s ? e : s;
        }
        computeIntersectsForChain() {
            if (4 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = arguments[2], n = arguments[3];
                this.computeIntersectsForChain(this.startIndex[t], this.startIndex[t + 1], e, e.startIndex[s], e.startIndex[s + 1], n);
            } else if (6 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = arguments[2], n = arguments[3], i = arguments[4], r = arguments[5];
                if (e - t == 1 && i - n == 1) return r.addIntersections(this.e, t, s.e, n), null;
                if (!this.overlaps(t, e, s, n, i)) return null;
                const o = Math.trunc((t + e) / 2), l = Math.trunc((n + i) / 2);
                t < o && (n < l && this.computeIntersectsForChain(t, o, s, n, l, r), l < i && this.computeIntersectsForChain(t, o, s, l, i, r)), o < e && (n < l && this.computeIntersectsForChain(o, e, s, n, l, r), l < i && this.computeIntersectsForChain(o, e, s, l, i, r));
            }
        }
        overlaps(t, e, s, n, i) {
            return O.intersects(this.pts[t], this.pts[e], s.pts[n], s.pts[i]);
        }
        getStartIndexes() {
            return this.startIndex;
        }
        computeIntersects(t, e) {
            for(let s = 0; s < this.startIndex.length - 1; s++)for(let n = 0; n < t.startIndex.length - 1; n++)this.computeIntersectsForChain(s, t, n, e);
        }
    }
    let vn = class t extends rn {
        constructor(){
            super(), t.constructor_.apply(this, arguments);
        }
        static constructor_() {
            if (this.pts = null, this._env = null, this.eiList = new Ln(this), this._name = null, this._mce = null, this._isIsolated = !0, this._depth = new Tn, this._depthDelta = 0, 1 === arguments.length) {
                const e = arguments[0];
                t.constructor_.call(this, e, null);
            } else if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                this.pts = t, this._label = e;
            }
        }
        static updateIM() {
            if (!(2 === arguments.length && arguments[1] instanceof Jt && arguments[0] instanceof nn)) return super.updateIM.apply(this, arguments);
            {
                const t = arguments[0], e = arguments[1];
                e.setAtLeastIfValid(t.getLocation(0, Hs.ON), t.getLocation(1, Hs.ON), 1), t.isArea() && (e.setAtLeastIfValid(t.getLocation(0, Hs.LEFT), t.getLocation(1, Hs.LEFT), 2), e.setAtLeastIfValid(t.getLocation(0, Hs.RIGHT), t.getLocation(1, Hs.RIGHT), 2));
            }
        }
        getDepth() {
            return this._depth;
        }
        getCollapsedEdge() {
            const e = new Array(2).fill(null);
            e[0] = this.pts[0], e[1] = this.pts[1];
            return new t(e, nn.toLineLabel(this._label));
        }
        setIsolated(t) {
            this._isIsolated = t;
        }
        setName(t) {
            this._name = t;
        }
        equals(e) {
            if (!(e instanceof t)) return !1;
            const s = e;
            if (this.pts.length !== s.pts.length) return !1;
            let n = !0, i = !0, r = this.pts.length;
            for(let t = 0; t < this.pts.length; t++)if (this.pts[t].equals2D(s.pts[t]) || (n = !1), this.pts[t].equals2D(s.pts[--r]) || (i = !1), !n && !i) return !1;
            return !0;
        }
        getCoordinate() {
            if (0 === arguments.length) return this.pts.length > 0 ? this.pts[0] : null;
            if (1 === arguments.length) {
                const t = arguments[0];
                return this.pts[t];
            }
        }
        isClosed() {
            return this.pts[0].equals(this.pts[this.pts.length - 1]);
        }
        getMaximumSegmentIndex() {
            return this.pts.length - 1;
        }
        setDepthDelta(t) {
            this._depthDelta = t;
        }
        getEdgeIntersectionList() {
            return this.eiList;
        }
        addIntersections(t, e, s) {
            for(let n = 0; n < t.getIntersectionNum(); n++)this.addIntersection(t, e, s, n);
        }
        isIsolated() {
            return this._isIsolated;
        }
        getCoordinates() {
            return this.pts;
        }
        print(t) {
            t.print("edge " + this._name + ": "), t.print("LINESTRING (");
            for(let e = 0; e < this.pts.length; e++)e > 0 && t.print(","), t.print(this.pts[e].x + " " + this.pts[e].y);
            t.print(")  " + this._label + " " + this._depthDelta);
        }
        computeIM(e) {
            t.updateIM(this._label, e);
        }
        isCollapsed() {
            return !!this._label.isArea() && 3 === this.pts.length && !!this.pts[0].equals(this.pts[2]);
        }
        getDepthDelta() {
            return this._depthDelta;
        }
        getNumPoints() {
            return this.pts.length;
        }
        printReverse(t) {
            t.print("edge " + this._name + ": ");
            for(let e = this.pts.length - 1; e >= 0; e--)t.print(this.pts[e] + " ");
            t.println("");
        }
        getMonotoneChainEdge() {
            return null === this._mce && (this._mce = new On(this)), this._mce;
        }
        getEnvelope() {
            if (null === this._env) {
                this._env = new O;
                for(let t = 0; t < this.pts.length; t++)this._env.expandToInclude(this.pts[t]);
            }
            return this._env;
        }
        addIntersection(t, e, s, n) {
            const i = new m(t.getIntersection(n));
            let r = e, o = t.getEdgeDistance(s, n);
            const l = r + 1;
            if (l < this.pts.length) {
                const t = this.pts[l];
                i.equals2D(t) && (r = l, o = 0);
            }
            this.eiList.add(i, r, o);
        }
        toString() {
            const t = new nt;
            t.append("edge " + this._name + ": "), t.append("LINESTRING (");
            for(let e = 0; e < this.pts.length; e++)e > 0 && t.append(","), t.append(this.pts[e].x + " " + this.pts[e].y);
            return t.append(")  " + this._label + " " + this._depthDelta), t.toString();
        }
        isPointwiseEqual(t) {
            if (this.pts.length !== t.pts.length) return !1;
            for(let e = 0; e < this.pts.length; e++)if (!this.pts[e].equals2D(t.pts[e])) return !1;
            return !0;
        }
    };
    class Mn {
        constructor(){
            Mn.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._bufParams = null, this._workingPrecisionModel = null, this._workingNoder = null, this._geomFact = null, this._graph = null, this._edgeList = new wn;
            const t = arguments[0];
            this._bufParams = t;
        }
        static convertSegStrings(t) {
            const e = new Lt, s = new L;
            for(; t.hasNext();){
                const n = t.next(), i = e.createLineString(n.getCoordinates());
                s.add(i);
            }
            return e.buildGeometry(s);
        }
        static depthDelta(t) {
            const e = t.getLocation(0, Hs.LEFT), s = t.getLocation(0, Hs.RIGHT);
            return e === Qt.INTERIOR && s === Qt.EXTERIOR ? 1 : e === Qt.EXTERIOR && s === Qt.INTERIOR ? -1 : 0;
        }
        createEmptyResultGeometry() {
            return this._geomFact.createPolygon();
        }
        getNoder(t) {
            if (null !== this._workingNoder) return this._workingNoder;
            const e = new Gs, s = new jt;
            return s.setPrecisionModel(t), e.setSegmentIntersector(new Cn(s)), e;
        }
        buffer(t, e) {
            let s = this._workingPrecisionModel;
            null === s && (s = t.getPrecisionModel()), this._geomFact = t.getFactory();
            const n = new en(s, this._bufParams), i = new yn(t, e, n).getCurves();
            if (i.size() <= 0) return this.createEmptyResultGeometry();
            this.computeNodedEdges(i, s), this._graph = new un(new In), this._graph.addEdges(this._edgeList.getEdges());
            const r = this.createSubgraphs(this._graph), o = new pn(this._geomFact);
            this.buildSubgraphs(r, o);
            const l = o.getPolygons();
            if (l.size() <= 0) return this.createEmptyResultGeometry();
            return this._geomFact.buildGeometry(l);
        }
        computeNodedEdges(t, e) {
            const s = this.getNoder(e);
            s.computeNodes(t);
            for(let t = s.getNodedSubstrings().iterator(); t.hasNext();){
                const e = t.next(), s = e.getCoordinates();
                if (2 === s.length && s[0].equals2D(s[1])) continue;
                const n = e.getData(), i = new vn(e.getCoordinates(), new nn(n));
                this.insertUniqueEdge(i);
            }
        }
        setNoder(t) {
            this._workingNoder = t;
        }
        setWorkingPrecisionModel(t) {
            this._workingPrecisionModel = t;
        }
        insertUniqueEdge(t) {
            const e = this._edgeList.findEqualEdge(t);
            if (null !== e) {
                const s = e.getLabel();
                let n = t.getLabel();
                e.isPointwiseEqual(t) || (n = new nn(t.getLabel()), n.flip()), s.merge(n);
                const i = Mn.depthDelta(n), r = e.getDepthDelta() + i;
                e.setDepthDelta(r);
            } else this._edgeList.add(t), t.setDepthDelta(Mn.depthDelta(t.getLabel()));
        }
        buildSubgraphs(t, e) {
            const s = new L;
            for(let n = t.iterator(); n.hasNext();){
                const t = n.next(), i = t.getRightmostCoordinate(), r = new mn(s).getDepth(i);
                t.computeDepth(r), t.findResultEdges(), s.add(t), e.add(t.getDirectedEdges(), t.getNodes());
            }
        }
        createSubgraphs(t) {
            const e = new L;
            for(let s = t.getNodes().iterator(); s.hasNext();){
                const t = s.next();
                if (!t.isVisited()) {
                    const s = new Qs;
                    s.create(t), e.add(s);
                }
            }
            return xe.sort(e, xe.reverseOrder()), e;
        }
    }
    class bn {
        constructor(){
            bn.constructor_.apply(this, arguments);
        }
        static constructor_() {
            if (this._argGeom = null, this._distance = null, this._bufParams = new Qe, this._resultGeometry = null, this._saveException = null, 1 === arguments.length) {
                const t = arguments[0];
                this._argGeom = t;
            } else if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                this._argGeom = t, this._bufParams = e;
            }
        }
        static bufferOp() {
            if (2 === arguments.length) {
                const t = arguments[1];
                return new bn(arguments[0]).getResultGeometry(t);
            }
            if (3 === arguments.length) {
                if (Number.isInteger(arguments[2]) && arguments[0] instanceof j && "number" == typeof arguments[1]) {
                    const t = arguments[1], e = arguments[2], s = new bn(arguments[0]);
                    s.setQuadrantSegments(e);
                    return s.getResultGeometry(t);
                }
                if (arguments[2] instanceof Qe && arguments[0] instanceof j && "number" == typeof arguments[1]) {
                    const t = arguments[1];
                    return new bn(arguments[0], arguments[2]).getResultGeometry(t);
                }
            } else if (4 === arguments.length) {
                const t = arguments[1], e = arguments[2], s = arguments[3], n = new bn(arguments[0]);
                n.setQuadrantSegments(e), n.setEndCapStyle(s);
                return n.getResultGeometry(t);
            }
        }
        static precisionScaleFactor(t, e, s) {
            const n = t.getEnvelopeInternal(), i = z.max(Math.abs(n.getMaxX()), Math.abs(n.getMaxY()), Math.abs(n.getMinX()), Math.abs(n.getMinY())) + 2 * (e > 0 ? e : 0), r = s - Math.trunc(Math.log(i) / Math.log(10) + 1);
            return Math.pow(10, r);
        }
        bufferFixedPrecision(t) {
            const e = new ds(new Us(new yt(1)), t.getScale()), s = new Mn(this._bufParams);
            s.setWorkingPrecisionModel(t), s.setNoder(e), this._resultGeometry = s.buffer(this._argGeom, this._distance);
        }
        bufferReducedPrecision() {
            if (0 === arguments.length) {
                for(let t = bn.MAX_PRECISION_DIGITS; t >= 0; t--){
                    try {
                        this.bufferReducedPrecision(t);
                    } catch (t) {
                        if (!(t instanceof _s)) throw t;
                        this._saveException = t;
                    }
                    if (null !== this._resultGeometry) return null;
                }
                throw this._saveException;
            }
            if (1 === arguments.length) {
                const t = arguments[0], e = bn.precisionScaleFactor(this._argGeom, this._distance, t), s = new yt(e);
                this.bufferFixedPrecision(s);
            }
        }
        bufferOriginalPrecision() {
            try {
                const t = new Mn(this._bufParams);
                this._resultGeometry = t.buffer(this._argGeom, this._distance);
            } catch (t) {
                if (!(t instanceof a)) throw t;
                this._saveException = t;
            }
        }
        getResultGeometry(t) {
            return this._distance = t, this.computeGeometry(), this._resultGeometry;
        }
        setEndCapStyle(t) {
            this._bufParams.setEndCapStyle(t);
        }
        computeGeometry() {
            if (this.bufferOriginalPrecision(), null !== this._resultGeometry) return null;
            const t = this._argGeom.getFactory().getPrecisionModel();
            t.getType() === yt.FIXED ? this.bufferFixedPrecision(t) : this.bufferReducedPrecision();
        }
        setQuadrantSegments(t) {
            this._bufParams.setQuadrantSegments(t);
        }
    }
    bn.CAP_ROUND = Qe.CAP_ROUND, bn.CAP_BUTT = Qe.CAP_FLAT, bn.CAP_FLAT = Qe.CAP_FLAT, bn.CAP_SQUARE = Qe.CAP_SQUARE, bn.MAX_PRECISION_DIGITS = 12;
    class Dn {
        constructor(){
            Dn.constructor_.apply(this, arguments);
        }
        static constructor_() {
            if (this._snapTolerance = 0, this._srcPts = null, this._seg = new Kt, this._allowSnappingToSourceVertices = !1, this._isClosed = !1, arguments[0] instanceof tt && "number" == typeof arguments[1]) {
                const t = arguments[0], e = arguments[1];
                Dn.constructor_.call(this, t.getCoordinates(), e);
            } else if (arguments[0] instanceof Array && "number" == typeof arguments[1]) {
                const t = arguments[0], e = arguments[1];
                this._srcPts = t, this._isClosed = Dn.isClosed(t), this._snapTolerance = e;
            }
        }
        static isClosed(t) {
            return !(t.length <= 1) && t[0].equals2D(t[t.length - 1]);
        }
        snapVertices(t, e) {
            const s = this._isClosed ? t.size() - 1 : t.size();
            for(let n = 0; n < s; n++){
                const s = t.get(n), i = this.findSnapForVertex(s, e);
                null !== i && (t.set(n, new m(i)), 0 === n && this._isClosed && t.set(t.size() - 1, new m(i)));
            }
        }
        findSnapForVertex(t, e) {
            for(let s = 0; s < e.length; s++){
                if (t.equals2D(e[s])) return null;
                if (t.distance(e[s]) < this._snapTolerance) return e[s];
            }
            return null;
        }
        snapTo(t) {
            const e = new R(this._srcPts);
            this.snapVertices(e, t), this.snapSegments(e, t);
            return e.toCoordinateArray();
        }
        snapSegments(t, e) {
            if (0 === e.length) return null;
            let s = e.length;
            e[0].equals2D(e[e.length - 1]) && (s = e.length - 1);
            for(let n = 0; n < s; n++){
                const s = e[n], i = this.findSegmentIndexToSnap(s, t);
                i >= 0 && t.add(i + 1, new m(s), !1);
            }
        }
        findSegmentIndexToSnap(t, e) {
            let s = r.MAX_VALUE, n = -1;
            for(let i = 0; i < e.size() - 1; i++){
                if (this._seg.p0 = e.get(i), this._seg.p1 = e.get(i + 1), this._seg.p0.equals2D(t) || this._seg.p1.equals2D(t)) {
                    if (this._allowSnappingToSourceVertices) continue;
                    return -1;
                }
                const r = this._seg.distance(t);
                r < this._snapTolerance && r < s && (s = r, n = i);
            }
            return n;
        }
        setAllowSnappingToSourceVertices(t) {
            this._allowSnappingToSourceVertices = t;
        }
    }
    class An {
        constructor(){
            An.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._srcGeom = null;
            const t = arguments[0];
            this._srcGeom = t;
        }
        static computeSizeBasedSnapTolerance(t) {
            const e = t.getEnvelopeInternal();
            return Math.min(e.getHeight(), e.getWidth()) * An.SNAP_PRECISION_FACTOR;
        }
        static computeOverlaySnapTolerance() {
            if (1 === arguments.length) {
                const t = arguments[0];
                let e = An.computeSizeBasedSnapTolerance(t);
                const s = t.getPrecisionModel();
                if (s.getType() === yt.FIXED) {
                    const t = 1 / s.getScale() * 2 / 1.415;
                    t > e && (e = t);
                }
                return e;
            }
            if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                return Math.min(An.computeOverlaySnapTolerance(t), An.computeOverlaySnapTolerance(e));
            }
        }
        static snapToSelf(t, e, s) {
            return new An(t).snapToSelf(e, s);
        }
        static snap(t, e, s) {
            const n = new Array(2).fill(null), i = new An(t);
            n[0] = i.snapTo(e, s);
            const r = new An(e);
            return n[1] = r.snapTo(n[0], s), n;
        }
        computeSnapTolerance(t) {
            return this.computeMinimumSegmentLength(t) / 10;
        }
        snapTo(t, e) {
            const s = this.extractTargetCoordinates(t);
            return new Fn(e, s).transform(this._srcGeom);
        }
        snapToSelf(t, e) {
            const s = this.extractTargetCoordinates(this._srcGeom), n = new Fn(t, s, !0).transform(this._srcGeom);
            let i = n;
            return e && I(i, gt) && (i = bn.bufferOp(n, 0)), i;
        }
        extractTargetCoordinates(t) {
            const e = new at, s = t.getCoordinates();
            for(let t = 0; t < s.length; t++)e.add(s[t]);
            return e.toArray(new Array(0).fill(null));
        }
        computeMinimumSegmentLength(t) {
            let e = r.MAX_VALUE;
            for(let s = 0; s < t.length - 1; s++){
                const n = t[s].distance(t[s + 1]);
                n < e && (e = n);
            }
            return e;
        }
    }
    An.SNAP_PRECISION_FACTOR = 1e-9;
    class Fn extends me {
        constructor(){
            super(), Fn.constructor_.apply(this, arguments);
        }
        static constructor_() {
            if (this._snapTolerance = null, this._snapPts = null, this._isSelfSnap = !1, 2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                this._snapTolerance = t, this._snapPts = e;
            } else if (3 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = arguments[2];
                this._snapTolerance = t, this._snapPts = e, this._isSelfSnap = s;
            }
        }
        transformCoordinates(t, e) {
            const s = t.toCoordinateArray(), n = this.snapLine(s, this._snapPts);
            return this._factory.getCoordinateSequenceFactory().create(n);
        }
        snapLine(t, e) {
            const s = new Dn(t, this._snapTolerance);
            return s.setAllowSnappingToSourceVertices(this._isSelfSnap), s.snapTo(e);
        }
    }
    class Gn {
        constructor(){
            this._isFirst = !0, this._commonMantissaBitsCount = 53, this._commonBits = new i, this._commonSignExp = null;
        }
        getCommon() {
            return r.longBitsToDouble(this._commonBits);
        }
        add(t) {
            const e = r.doubleToLongBits(t);
            if (this._isFirst) return this._commonBits = e, this._commonSignExp = Gn.signExpBits(this._commonBits), this._isFirst = !1, null;
            if (Gn.signExpBits(e) !== this._commonSignExp) return this._commonBits.high = 0, this._commonBits.low = 0, null;
            this._commonMantissaBitsCount = Gn.numCommonMostSigMantissaBits(this._commonBits, e), this._commonBits = Gn.zeroLowerBits(this._commonBits, 64 - (12 + this._commonMantissaBitsCount));
        }
        toString() {
            if (1 === arguments.length) {
                const t = arguments[0], e = r.longBitsToDouble(t), s = "0000000000000000000000000000000000000000000000000000000000000000" + i.toBinaryString(t), n = s.substring(s.length - 64);
                return n.substring(0, 1) + "  " + n.substring(1, 12) + "(exp) " + n.substring(12) + " [ " + e + " ]";
            }
        }
        getClass() {
            return Gn;
        }
        get interfaces_() {
            return [];
        }
        static getBit(t, e) {
            const s = 1 << e % 32;
            return e < 32 ? t.low & s ? 1 : 0 : t.high & s ? 1 : 0;
        }
        static signExpBits(t) {
            return t.high >>> 20;
        }
        static zeroLowerBits(t, e) {
            let s = "low";
            if (e > 32 && (t.low = 0, e %= 32, s = "high"), e > 0) {
                const n = e < 32 ? ~((1 << e) - 1) : 0;
                t[s] &= n;
            }
            return t;
        }
        static numCommonMostSigMantissaBits(t, e) {
            let s = 0;
            for(let n = 52; n >= 0; n--){
                if (Gn.getBit(t, n) !== Gn.getBit(e, n)) return s;
                s++;
            }
            return 52;
        }
    }
    class qn {
        constructor(){
            qn.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._commonCoord = null, this._ccFilter = new Bn;
        }
        add(t) {
            t.apply(this._ccFilter), this._commonCoord = this._ccFilter.getCommonCoordinate();
        }
        removeCommonBits(t) {
            if (0 === this._commonCoord.x && 0 === this._commonCoord.y) return t;
            const e = new m(this._commonCoord);
            e.x = -e.x, e.y = -e.y;
            const s = new Yn(e);
            return t.apply(s), t.geometryChanged(), t;
        }
        addCommonBits(t) {
            const e = new Yn(this._commonCoord);
            t.apply(e), t.geometryChanged();
        }
        getCommonCoordinate() {
            return this._commonCoord;
        }
    }
    class Bn {
        constructor(){
            Bn.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._commonBitsX = new Gn, this._commonBitsY = new Gn;
        }
        filter(t) {
            this._commonBitsX.add(t.x), this._commonBitsY.add(t.y);
        }
        getCommonCoordinate() {
            return new m(this._commonBitsX.getCommon(), this._commonBitsY.getCommon());
        }
        get interfaces_() {
            return [
                K
            ];
        }
    }
    class Yn {
        constructor(){
            Yn.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this.trans = null;
            const t = arguments[0];
            this.trans = t;
        }
        filter(t, e) {
            const s = t.getOrdinate(e, 0) + this.trans.x, n = t.getOrdinate(e, 1) + this.trans.y;
            t.setOrdinate(e, 0, s), t.setOrdinate(e, 1, n);
        }
        isGeometryChanged() {
            return !0;
        }
        isDone() {
            return !1;
        }
        get interfaces_() {
            return [
                P
            ];
        }
    }
    qn.CommonCoordinateFilter = Bn, qn.Translater = Yn;
    class zn {
        constructor(){
            zn.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._op = null, this._geometryFactory = null, this._ptLocator = null, this._lineEdgesList = new L, this._resultLineList = new L;
            const t = arguments[0], e = arguments[1], s = arguments[2];
            this._op = t, this._geometryFactory = e, this._ptLocator = s;
        }
        collectLines(t) {
            for(let e = this._op.getGraph().getEdgeEnds().iterator(); e.hasNext();){
                const s = e.next();
                this.collectLineEdge(s, t, this._lineEdgesList), this.collectBoundaryTouchEdge(s, t, this._lineEdgesList);
            }
        }
        labelIsolatedLine(t, e) {
            const s = this._ptLocator.locate(t.getCoordinate(), this._op.getArgGeometry(e));
            t.getLabel().setLocation(e, s);
        }
        build(t) {
            return this.findCoveredLineEdges(), this.collectLines(t), this.buildLines(t), this._resultLineList;
        }
        collectLineEdge(t, e, s) {
            const n = t.getLabel(), i = t.getEdge();
            t.isLineEdge() && (t.isVisited() || !oi.isResultOfOp(n, e) || i.isCovered() || (s.add(i), t.setVisitedEdge(!0)));
        }
        findCoveredLineEdges() {
            for(let t = this._op.getGraph().getNodes().iterator(); t.hasNext();)t.next().getEdges().findCoveredLineEdges();
            for(let t = this._op.getGraph().getEdgeEnds().iterator(); t.hasNext();){
                const e = t.next(), s = e.getEdge();
                if (e.isLineEdge() && !s.isCoveredSet()) {
                    const t = this._op.isCoveredByA(e.getCoordinate());
                    s.setCovered(t);
                }
            }
        }
        labelIsolatedLines(t) {
            for(let e = t.iterator(); e.hasNext();){
                const t = e.next(), s = t.getLabel();
                t.isIsolated() && (s.isNull(0) ? this.labelIsolatedLine(t, 0) : this.labelIsolatedLine(t, 1));
            }
        }
        buildLines(t) {
            for(let t = this._lineEdgesList.iterator(); t.hasNext();){
                const e = t.next(), s = this._geometryFactory.createLineString(e.getCoordinates());
                this._resultLineList.add(s), e.setInResult(!0);
            }
        }
        collectBoundaryTouchEdge(t, e, s) {
            const n = t.getLabel();
            return t.isLineEdge() || t.isVisited() || t.isInteriorAreaEdge() || t.getEdge().isInResult() ? null : (h.isTrue(!(t.isInResult() || t.getSym().isInResult()) || !t.getEdge().isInResult()), void (oi.isResultOfOp(n, e) && e === oi.INTERSECTION && (s.add(t.getEdge()), t.setVisitedEdge(!0))));
        }
    }
    class Vn {
        constructor(){
            Vn.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._op = null, this._geometryFactory = null, this._resultPointList = new L;
            const t = arguments[0], e = arguments[1];
            this._op = t, this._geometryFactory = e;
        }
        build(t) {
            return this.extractNonCoveredResultNodes(t), this._resultPointList;
        }
        extractNonCoveredResultNodes(t) {
            for(let e = this._op.getGraph().getNodes().iterator(); e.hasNext();){
                const s = e.next();
                if (!s.isInResult() && !s.isIncidentEdgeInResult() && (0 === s.getEdges().getDegree() || t === oi.INTERSECTION)) {
                    const e = s.getLabel();
                    oi.isResultOfOp(e, t) && this.filterCoveredNodeToPoint(s);
                }
            }
        }
        filterCoveredNodeToPoint(t) {
            const e = t.getCoordinate();
            if (!this._op.isCoveredByLA(e)) {
                const t = this._geometryFactory.createPoint(e);
                this._resultPointList.add(t);
            }
        }
    }
    class kn {
        isInBoundary(t) {}
    }
    class Xn {
        isInBoundary(t) {
            return t % 2 == 1;
        }
        get interfaces_() {
            return [
                kn
            ];
        }
    }
    class Un {
        isInBoundary(t) {
            return t > 0;
        }
        get interfaces_() {
            return [
                kn
            ];
        }
    }
    class Hn {
        isInBoundary(t) {
            return t > 1;
        }
        get interfaces_() {
            return [
                kn
            ];
        }
    }
    class Wn {
        isInBoundary(t) {
            return 1 === t;
        }
        get interfaces_() {
            return [
                kn
            ];
        }
    }
    kn.Mod2BoundaryNodeRule = Xn, kn.EndPointBoundaryNodeRule = Un, kn.MultiValentEndPointBoundaryNodeRule = Hn, kn.MonoValentEndPointBoundaryNodeRule = Wn, kn.MOD2_BOUNDARY_RULE = new Xn, kn.ENDPOINT_BOUNDARY_RULE = new Un, kn.MULTIVALENT_ENDPOINT_BOUNDARY_RULE = new Hn, kn.MONOVALENT_ENDPOINT_BOUNDARY_RULE = new Wn, kn.OGC_SFS_BOUNDARY_RULE = kn.MOD2_BOUNDARY_RULE;
    class Zn {
        constructor(){
            Zn.constructor_.apply(this, arguments);
        }
        static constructor_() {
            if (this._boundaryRule = kn.OGC_SFS_BOUNDARY_RULE, this._isIn = null, this._numBoundaries = null, 0 === arguments.length) ;
            else if (1 === arguments.length) {
                const t = arguments[0];
                if (null === t) throw new n("Rule must be non-null");
                this._boundaryRule = t;
            }
        }
        locateInPolygonRing(t, e) {
            return e.getEnvelopeInternal().intersects(t) ? Ue.locateInRing(t, e.getCoordinates()) : Qt.EXTERIOR;
        }
        intersects(t, e) {
            return this.locate(t, e) !== Qt.EXTERIOR;
        }
        updateLocationInfo(t) {
            t === Qt.INTERIOR && (this._isIn = !0), t === Qt.BOUNDARY && this._numBoundaries++;
        }
        computeLocation(t, e) {
            if (e instanceof Nt && this.updateLocationInfo(this.locateOnPoint(t, e)), e instanceof tt) this.updateLocationInfo(this.locateOnLineString(t, e));
            else if (e instanceof Ct) this.updateLocationInfo(this.locateInPolygon(t, e));
            else if (e instanceof Et) {
                const s = e;
                for(let e = 0; e < s.getNumGeometries(); e++){
                    const n = s.getGeometryN(e);
                    this.updateLocationInfo(this.locateOnLineString(t, n));
                }
            } else if (e instanceof dt) {
                const s = e;
                for(let e = 0; e < s.getNumGeometries(); e++){
                    const n = s.getGeometryN(e);
                    this.updateLocationInfo(this.locateInPolygon(t, n));
                }
            } else if (e instanceof ut) {
                const s = new We(e);
                for(; s.hasNext();){
                    const n = s.next();
                    n !== e && this.computeLocation(t, n);
                }
            }
        }
        locateOnPoint(t, e) {
            return e.getCoordinate().equals2D(t) ? Qt.INTERIOR : Qt.EXTERIOR;
        }
        locateOnLineString(t, e) {
            if (!e.getEnvelopeInternal().intersects(t)) return Qt.EXTERIOR;
            const s = e.getCoordinateSequence();
            return e.isClosed() || !t.equals(s.getCoordinate(0)) && !t.equals(s.getCoordinate(s.size() - 1)) ? Ue.isOnLine(t, s) ? Qt.INTERIOR : Qt.EXTERIOR : Qt.BOUNDARY;
        }
        locateInPolygon(t, e) {
            if (e.isEmpty()) return Qt.EXTERIOR;
            const s = e.getExteriorRing(), n = this.locateInPolygonRing(t, s);
            if (n === Qt.EXTERIOR) return Qt.EXTERIOR;
            if (n === Qt.BOUNDARY) return Qt.BOUNDARY;
            for(let s = 0; s < e.getNumInteriorRing(); s++){
                const n = e.getInteriorRingN(s), i = this.locateInPolygonRing(t, n);
                if (i === Qt.INTERIOR) return Qt.EXTERIOR;
                if (i === Qt.BOUNDARY) return Qt.BOUNDARY;
            }
            return Qt.INTERIOR;
        }
        locate(t, e) {
            return e.isEmpty() ? Qt.EXTERIOR : e instanceof tt ? this.locateOnLineString(t, e) : e instanceof Ct ? this.locateInPolygon(t, e) : (this._isIn = !1, this._numBoundaries = 0, this.computeLocation(t, e), this._boundaryRule.isInBoundary(this._numBoundaries) ? Qt.BOUNDARY : this._numBoundaries > 0 || this._isIn ? Qt.INTERIOR : Qt.EXTERIOR);
        }
    }
    class jn {
        constructor(){
            jn.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._pts = null, this._data = null;
            const t = arguments[0], e = arguments[1];
            this._pts = t, this._data = e;
        }
        getCoordinates() {
            return this._pts;
        }
        size() {
            return this._pts.length;
        }
        getCoordinate(t) {
            return this._pts[t];
        }
        isClosed() {
            return this._pts[0].equals(this._pts[this._pts.length - 1]);
        }
        getSegmentOctant(t) {
            return t === this._pts.length - 1 ? -1 : as.octant(this.getCoordinate(t), this.getCoordinate(t + 1));
        }
        setData(t) {
            this._data = t;
        }
        getData() {
            return this._data;
        }
        toString() {
            return Wt.toLineString(new it(this._pts));
        }
        get interfaces_() {
            return [
                cs
            ];
        }
    }
    class Kn {
        constructor(){
            Kn.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._findAllIntersections = !1, this._isCheckEndSegmentsOnly = !1, this._keepIntersections = !0, this._isInteriorIntersectionsOnly = !1, this._li = null, this._interiorIntersection = null, this._intSegments = null, this._intersections = new L, this._intersectionCount = 0;
            const t = arguments[0];
            this._li = t, this._interiorIntersection = null;
        }
        static createAllIntersectionsFinder(t) {
            const e = new Kn(t);
            return e.setFindAllIntersections(!0), e;
        }
        static isInteriorVertexIntersection() {
            if (4 === arguments.length) {
                const t = arguments[1];
                return (!arguments[2] || !arguments[3]) && !!arguments[0].equals2D(t);
            }
            if (8 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = arguments[2], n = arguments[3], i = arguments[4], r = arguments[5], o = arguments[6], l = arguments[7];
                return !!Kn.isInteriorVertexIntersection(t, s, i, o) || !!Kn.isInteriorVertexIntersection(t, n, i, l) || !!Kn.isInteriorVertexIntersection(e, s, r, o) || !!Kn.isInteriorVertexIntersection(e, n, r, l);
            }
        }
        static createInteriorIntersectionCounter(t) {
            const e = new Kn(t);
            return e.setInteriorIntersectionsOnly(!0), e.setFindAllIntersections(!0), e.setKeepIntersections(!1), e;
        }
        static createIntersectionCounter(t) {
            const e = new Kn(t);
            return e.setFindAllIntersections(!0), e.setKeepIntersections(!1), e;
        }
        static isEndSegment(t, e) {
            return 0 === e || e >= t.size() - 2;
        }
        static createAnyIntersectionFinder(t) {
            return new Kn(t);
        }
        static createInteriorIntersectionsFinder(t) {
            const e = new Kn(t);
            return e.setFindAllIntersections(!0), e.setInteriorIntersectionsOnly(!0), e;
        }
        count() {
            return this._intersectionCount;
        }
        getIntersections() {
            return this._intersections;
        }
        setFindAllIntersections(t) {
            this._findAllIntersections = t;
        }
        setKeepIntersections(t) {
            this._keepIntersections = t;
        }
        getIntersection() {
            return this._interiorIntersection;
        }
        processIntersections(t, e, s, n) {
            if (!this._findAllIntersections && this.hasIntersection()) return null;
            const i = t === s;
            if (i && e === n) return null;
            if (this._isCheckEndSegmentsOnly) {
                if (!(Kn.isEndSegment(t, e) || Kn.isEndSegment(s, n))) return null;
            }
            const r = t.getCoordinate(e), o = t.getCoordinate(e + 1), l = s.getCoordinate(n), a = s.getCoordinate(n + 1), c = 0 === e, h = e + 2 === t.size(), u = 0 === n, g = n + 2 === s.size();
            this._li.computeIntersection(r, o, l, a);
            const d = this._li.hasIntersection() && this._li.isInteriorIntersection();
            let _ = !1;
            if (!this._isInteriorIntersectionsOnly) _ = !(i && Math.abs(n - e) <= 1) && Kn.isInteriorVertexIntersection(r, o, l, a, c, h, u, g);
            (d || _) && (this._intSegments = new Array(4).fill(null), this._intSegments[0] = r, this._intSegments[1] = o, this._intSegments[2] = l, this._intSegments[3] = a, this._interiorIntersection = this._li.getIntersection(0), this._keepIntersections && this._intersections.add(this._interiorIntersection), this._intersectionCount++);
        }
        hasIntersection() {
            return null !== this._interiorIntersection;
        }
        isDone() {
            return !this._findAllIntersections && null !== this._interiorIntersection;
        }
        setInteriorIntersectionsOnly(t) {
            this._isInteriorIntersectionsOnly = t;
        }
        setCheckEndSegmentsOnly(t) {
            this._isCheckEndSegmentsOnly = t;
        }
        getIntersectionSegments() {
            return this._intSegments;
        }
        get interfaces_() {
            return [
                ks
            ];
        }
    }
    class Qn {
        constructor(){
            Qn.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._li = new jt, this._segStrings = null, this._findAllIntersections = !1, this._segInt = null, this._isValid = !0;
            const t = arguments[0];
            this._segStrings = t;
        }
        static computeIntersections(t) {
            const e = new Qn(t);
            return e.setFindAllIntersections(!0), e.isValid(), e.getIntersections();
        }
        isValid() {
            return this.execute(), this._isValid;
        }
        setFindAllIntersections(t) {
            this._findAllIntersections = t;
        }
        checkInteriorIntersections() {
            this._isValid = !0, this._segInt = new Kn(this._li), this._segInt.setFindAllIntersections(this._findAllIntersections);
            const t = new Gs;
            if (t.setSegmentIntersector(this._segInt), t.computeNodes(this._segStrings), this._segInt.hasIntersection()) return this._isValid = !1, null;
        }
        checkValid() {
            if (this.execute(), !this._isValid) throw new _s(this.getErrorMessage(), this._segInt.getIntersection());
        }
        getErrorMessage() {
            if (this._isValid) return "no intersections found";
            const t = this._segInt.getIntersectionSegments();
            return "found non-noded intersection between " + Wt.toLineString(t[0], t[1]) + " and " + Wt.toLineString(t[2], t[3]);
        }
        execute() {
            if (null !== this._segInt) return null;
            this.checkInteriorIntersections();
        }
        getIntersections() {
            return this._segInt.getIntersections();
        }
    }
    class Jn {
        constructor(){
            Jn.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._nv = null;
            const t = arguments[0];
            this._nv = new Qn(Jn.toSegmentStrings(t));
        }
        static toSegmentStrings(t) {
            const e = new L;
            for(let s = t.iterator(); s.hasNext();){
                const t = s.next();
                e.add(new jn(t.getCoordinates(), t));
            }
            return e;
        }
        static checkValid(t) {
            new Jn(t).checkValid();
        }
        checkValid() {
            this._nv.checkValid();
        }
    }
    class $n {
    }
    class ti {
        constructor(){
            ti.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._hasIntersection = !1, this._hasProper = !1, this._hasProperInterior = !1, this._properIntersectionPoint = null, this._li = null, this._includeProper = null, this._recordIsolated = null, this._isSelfIntersection = null, this._numIntersections = 0, this.numTests = 0, this._bdyNodes = null, this._isDone = !1, this._isDoneWhenProperInt = !1;
            const t = arguments[0], e = arguments[1], s = arguments[2];
            this._li = t, this._includeProper = e, this._recordIsolated = s;
        }
        static isAdjacentSegments(t, e) {
            return 1 === Math.abs(t - e);
        }
        isTrivialIntersection(t, e, s, n) {
            if (t === s && 1 === this._li.getIntersectionNum()) {
                if (ti.isAdjacentSegments(e, n)) return !0;
                if (t.isClosed()) {
                    const s = t.getNumPoints() - 1;
                    if (0 === e && n === s || 0 === n && e === s) return !0;
                }
            }
            return !1;
        }
        hasProperInteriorIntersection() {
            return this._hasProperInterior;
        }
        isBoundaryPointInternal(t, e) {
            for(let s = e.iterator(); s.hasNext();){
                const e = s.next().getCoordinate();
                if (t.isIntersection(e)) return !0;
            }
            return !1;
        }
        hasProperIntersection() {
            return this._hasProper;
        }
        hasIntersection() {
            return this._hasIntersection;
        }
        isDone() {
            return this._isDone;
        }
        isBoundaryPoint(t, e) {
            return null !== e && (!!this.isBoundaryPointInternal(t, e[0]) || !!this.isBoundaryPointInternal(t, e[1]));
        }
        setBoundaryNodes(t, e) {
            this._bdyNodes = new Array(2).fill(null), this._bdyNodes[0] = t, this._bdyNodes[1] = e;
        }
        addIntersections(t, e, s, n) {
            if (t === s && e === n) return null;
            this.numTests++;
            const i = t.getCoordinates()[e], r = t.getCoordinates()[e + 1], o = s.getCoordinates()[n], l = s.getCoordinates()[n + 1];
            this._li.computeIntersection(i, r, o, l), this._li.hasIntersection() && (this._recordIsolated && (t.setIsolated(!1), s.setIsolated(!1)), this._numIntersections++, this.isTrivialIntersection(t, e, s, n) || (this._hasIntersection = !0, !this._includeProper && this._li.isProper() || (t.addIntersections(this._li, e, 0), s.addIntersections(this._li, n, 1)), this._li.isProper() && (this._properIntersectionPoint = this._li.getIntersection(0).copy(), this._hasProper = !0, this._isDoneWhenProperInt && (this._isDone = !0), this.isBoundaryPoint(this._li, this._bdyNodes) || (this._hasProperInterior = !0))));
        }
        getProperIntersectionPoint() {
            return this._properIntersectionPoint;
        }
        setIsDoneIfProperInt(t) {
            this._isDoneWhenProperInt = t;
        }
    }
    class ei {
        constructor(){
            ei.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this.mce = null, this.chainIndex = null;
            const t = arguments[0], e = arguments[1];
            this.mce = t, this.chainIndex = e;
        }
        computeIntersections(t, e) {
            this.mce.computeIntersectsForChain(this.chainIndex, t.mce, t.chainIndex, e);
        }
    }
    class si {
        constructor(){
            si.constructor_.apply(this, arguments);
        }
        static constructor_() {
            if (this._label = null, this._xValue = null, this._eventType = null, this._insertEvent = null, this._deleteEventIndex = null, this._obj = null, 2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                this._eventType = si.DELETE, this._xValue = t, this._insertEvent = e;
            } else if (3 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = arguments[2];
                this._eventType = si.INSERT, this._label = t, this._xValue = e, this._obj = s;
            }
        }
        getObject() {
            return this._obj;
        }
        getDeleteEventIndex() {
            return this._deleteEventIndex;
        }
        isDelete() {
            return this._eventType === si.DELETE;
        }
        setDeleteEventIndex(t) {
            this._deleteEventIndex = t;
        }
        compareTo(t) {
            const e = t;
            return this._xValue < e._xValue ? -1 : this._xValue > e._xValue ? 1 : this._eventType < e._eventType ? -1 : this._eventType > e._eventType ? 1 : 0;
        }
        getInsertEvent() {
            return this._insertEvent;
        }
        isInsert() {
            return this._eventType === si.INSERT;
        }
        isSameLabel(t) {
            return null !== this._label && this._label === t._label;
        }
        get interfaces_() {
            return [
                o
            ];
        }
    }
    si.INSERT = 1, si.DELETE = 2;
    class ni extends $n {
        constructor(){
            super(), ni.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this.events = new L, this.nOverlaps = null;
        }
        prepareEvents() {
            xe.sort(this.events);
            for(let t = 0; t < this.events.size(); t++){
                const e = this.events.get(t);
                e.isDelete() && e.getInsertEvent().setDeleteEventIndex(t);
            }
        }
        computeIntersections() {
            if (1 === arguments.length) {
                const t = arguments[0];
                this.nOverlaps = 0, this.prepareEvents();
                for(let e = 0; e < this.events.size(); e++){
                    const s = this.events.get(e);
                    if (s.isInsert() && this.processOverlaps(e, s.getDeleteEventIndex(), s, t), t.isDone()) break;
                }
            } else if (3 === arguments.length) {
                if (arguments[2] instanceof ti && I(arguments[0], C) && I(arguments[1], C)) {
                    const t = arguments[0], e = arguments[1], s = arguments[2];
                    this.addEdges(t, t), this.addEdges(e, e), this.computeIntersections(s);
                } else if ("boolean" == typeof arguments[2] && I(arguments[0], C) && arguments[1] instanceof ti) {
                    const t = arguments[0], e = arguments[1];
                    arguments[2] ? this.addEdges(t, null) : this.addEdges(t), this.computeIntersections(e);
                }
            }
        }
        addEdge(t, e) {
            const s = t.getMonotoneChainEdge(), n = s.getStartIndexes();
            for(let t = 0; t < n.length - 1; t++){
                const n = new ei(s, t), i = new si(e, s.getMinX(t), n);
                this.events.add(i), this.events.add(new si(s.getMaxX(t), i));
            }
        }
        processOverlaps(t, e, s, n) {
            const i = s.getObject();
            for(let r = t; r < e; r++){
                const t = this.events.get(r);
                if (t.isInsert()) {
                    const e = t.getObject();
                    s.isSameLabel(t) || (i.computeIntersections(e, n), this.nOverlaps++);
                }
            }
        }
        addEdges() {
            if (1 === arguments.length) for(let t = arguments[0].iterator(); t.hasNext();){
                const e = t.next();
                this.addEdge(e, e);
            }
            else if (2 === arguments.length) {
                const t = arguments[1];
                for(let e = arguments[0].iterator(); e.hasNext();){
                    const s = e.next();
                    this.addEdge(s, t);
                }
            }
        }
    }
    class ii extends un {
        constructor(){
            super(), ii.constructor_.apply(this, arguments);
        }
        static constructor_() {
            if (this._parentGeom = null, this._lineEdgeMap = new ft, this._boundaryNodeRule = null, this._useBoundaryDeterminationRule = !0, this._argIndex = null, this._boundaryNodes = null, this._hasTooFewPoints = !1, this._invalidPoint = null, this._areaPtLocator = null, this._ptLocator = new Zn, 2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                ii.constructor_.call(this, t, e, kn.OGC_SFS_BOUNDARY_RULE);
            } else if (3 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = arguments[2];
                this._argIndex = t, this._parentGeom = e, this._boundaryNodeRule = s, null !== e && this.add(e);
            }
        }
        static determineBoundary(t, e) {
            return t.isInBoundary(e) ? Qt.BOUNDARY : Qt.INTERIOR;
        }
        insertBoundaryPoint(t, e) {
            const s = this._nodes.addNode(e).getLabel();
            let n = 1, i = Qt.NONE;
            i = s.getLocation(t, Hs.ON), i === Qt.BOUNDARY && n++;
            const r = ii.determineBoundary(this._boundaryNodeRule, n);
            s.setLocation(t, r);
        }
        computeSelfNodes() {
            if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                return this.computeSelfNodes(t, e, !1);
            }
            if (3 === arguments.length) {
                const t = arguments[1], e = arguments[2], s = new ti(arguments[0], !0, !1);
                s.setIsDoneIfProperInt(e);
                const n = this.createEdgeSetIntersector(), i = this._parentGeom instanceof et || this._parentGeom instanceof Ct || this._parentGeom instanceof dt, r = t || !i;
                return n.computeIntersections(this._edges, s, r), this.addSelfIntersectionNodes(this._argIndex), s;
            }
        }
        addPolygon(t) {
            this.addPolygonRing(t.getExteriorRing(), Qt.EXTERIOR, Qt.INTERIOR);
            for(let e = 0; e < t.getNumInteriorRing(); e++){
                const s = t.getInteriorRingN(e);
                this.addPolygonRing(s, Qt.INTERIOR, Qt.EXTERIOR);
            }
        }
        addEdge(t) {
            this.insertEdge(t);
            const e = t.getCoordinates();
            this.insertPoint(this._argIndex, e[0], Qt.BOUNDARY), this.insertPoint(this._argIndex, e[e.length - 1], Qt.BOUNDARY);
        }
        addLineString(t) {
            const e = W.removeRepeatedPoints(t.getCoordinates());
            if (e.length < 2) return this._hasTooFewPoints = !0, this._invalidPoint = e[0], null;
            const s = new vn(e, new nn(this._argIndex, Qt.INTERIOR));
            this._lineEdgeMap.put(t, s), this.insertEdge(s), h.isTrue(e.length >= 2, "found LineString with single point"), this.insertBoundaryPoint(this._argIndex, e[0]), this.insertBoundaryPoint(this._argIndex, e[e.length - 1]);
        }
        getInvalidPoint() {
            return this._invalidPoint;
        }
        getBoundaryPoints() {
            const t = this.getBoundaryNodes(), e = new Array(t.size()).fill(null);
            let s = 0;
            for(let n = t.iterator(); n.hasNext();){
                const t = n.next();
                e[s++] = t.getCoordinate().copy();
            }
            return e;
        }
        addSelfIntersectionNodes(t) {
            for(let e = this._edges.iterator(); e.hasNext();){
                const s = e.next(), n = s.getLabel().getLocation(t);
                for(let e = s.eiList.iterator(); e.hasNext();){
                    const s = e.next();
                    this.addSelfIntersectionNode(t, s.coord, n);
                }
            }
        }
        add() {
            if (!(1 === arguments.length && arguments[0] instanceof j)) return super.add.apply(this, arguments);
            {
                const t = arguments[0];
                if (t.isEmpty()) return null;
                if (t instanceof dt && (this._useBoundaryDeterminationRule = !1), t instanceof Ct) this.addPolygon(t);
                else if (t instanceof tt) this.addLineString(t);
                else if (t instanceof Nt) this.addPoint(t);
                else if (t instanceof St) this.addCollection(t);
                else if (t instanceof Et) this.addCollection(t);
                else if (t instanceof dt) this.addCollection(t);
                else {
                    if (!(t instanceof ut)) throw new U(t.getGeometryType());
                    this.addCollection(t);
                }
            }
        }
        addCollection(t) {
            for(let e = 0; e < t.getNumGeometries(); e++){
                const s = t.getGeometryN(e);
                this.add(s);
            }
        }
        locate(t) {
            return I(this._parentGeom, gt) && this._parentGeom.getNumGeometries() > 50 ? (null === this._areaPtLocator && (this._areaPtLocator = new Ve(this._parentGeom)), this._areaPtLocator.locate(t)) : this._ptLocator.locate(t, this._parentGeom);
        }
        findEdge() {
            if (1 === arguments.length && arguments[0] instanceof tt) {
                const t = arguments[0];
                return this._lineEdgeMap.get(t);
            }
            return super.findEdge.apply(this, arguments);
        }
        computeSplitEdges(t) {
            for(let e = this._edges.iterator(); e.hasNext();)e.next().eiList.addSplitEdges(t);
        }
        computeEdgeIntersections(t, e, s) {
            const n = new ti(e, s, !0);
            n.setBoundaryNodes(this.getBoundaryNodes(), t.getBoundaryNodes());
            return this.createEdgeSetIntersector().computeIntersections(this._edges, t._edges, n), n;
        }
        getGeometry() {
            return this._parentGeom;
        }
        getBoundaryNodeRule() {
            return this._boundaryNodeRule;
        }
        hasTooFewPoints() {
            return this._hasTooFewPoints;
        }
        addPoint() {
            if (arguments[0] instanceof Nt) {
                const t = arguments[0].getCoordinate();
                this.insertPoint(this._argIndex, t, Qt.INTERIOR);
            } else if (arguments[0] instanceof m) {
                const t = arguments[0];
                this.insertPoint(this._argIndex, t, Qt.INTERIOR);
            }
        }
        getBoundaryNodes() {
            return null === this._boundaryNodes && (this._boundaryNodes = this._nodes.getBoundaryNodes(this._argIndex)), this._boundaryNodes;
        }
        addSelfIntersectionNode(t, e, s) {
            if (this.isBoundaryNode(t, e)) return null;
            s === Qt.BOUNDARY && this._useBoundaryDeterminationRule ? this.insertBoundaryPoint(t, e) : this.insertPoint(t, e, s);
        }
        addPolygonRing(t, e, s) {
            if (t.isEmpty()) return null;
            const n = W.removeRepeatedPoints(t.getCoordinates());
            if (n.length < 4) return this._hasTooFewPoints = !0, this._invalidPoint = n[0], null;
            let i = e, r = s;
            q.isCCW(n) && (i = s, r = e);
            const o = new vn(n, new nn(this._argIndex, Qt.BOUNDARY, i, r));
            this._lineEdgeMap.put(t, o), this.insertEdge(o), this.insertPoint(this._argIndex, n[0], Qt.BOUNDARY);
        }
        insertPoint(t, e, s) {
            const n = this._nodes.addNode(e), i = n.getLabel();
            null === i ? n._label = new nn(t, s) : i.setLocation(t, s);
        }
        createEdgeSetIntersector() {
            return new ni;
        }
    }
    class ri {
        constructor(){
            ri.constructor_.apply(this, arguments);
        }
        static constructor_() {
            if (this._li = new jt, this._resultPrecisionModel = null, this._arg = null, 1 === arguments.length) {
                const t = arguments[0];
                this.setComputationPrecision(t.getPrecisionModel()), this._arg = new Array(1).fill(null), this._arg[0] = new ii(0, t);
            } else if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                ri.constructor_.call(this, t, e, kn.OGC_SFS_BOUNDARY_RULE);
            } else if (3 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = arguments[2];
                t.getPrecisionModel().compareTo(e.getPrecisionModel()) >= 0 ? this.setComputationPrecision(t.getPrecisionModel()) : this.setComputationPrecision(e.getPrecisionModel()), this._arg = new Array(2).fill(null), this._arg[0] = new ii(0, t, s), this._arg[1] = new ii(1, e, s);
            }
        }
        setComputationPrecision(t) {
            this._resultPrecisionModel = t, this._li.setPrecisionModel(this._resultPrecisionModel);
        }
        getArgGeometry(t) {
            return this._arg[t].getGeometry();
        }
    }
    class oi extends ri {
        constructor(){
            super(), oi.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._ptLocator = new Zn, this._geomFact = null, this._resultGeom = null, this._graph = null, this._edgeList = new wn, this._resultPolyList = new L, this._resultLineList = new L, this._resultPointList = new L;
            const t = arguments[0], e = arguments[1];
            ri.constructor_.call(this, t, e), this._graph = new un(new In), this._geomFact = t.getFactory();
        }
        static overlayOp(t, e, s) {
            return new oi(t, e).getResultGeometry(s);
        }
        static union(t, e) {
            if (t.isEmpty() || e.isEmpty()) {
                if (t.isEmpty() && e.isEmpty()) return oi.createEmptyResult(oi.UNION, t, e, t.getFactory());
                if (t.isEmpty()) return e.copy();
                if (e.isEmpty()) return t.copy();
            }
            if (t.isGeometryCollection() || e.isGeometryCollection()) throw new n("This method does not support GeometryCollection arguments");
            return ai.overlayOp(t, e, oi.UNION);
        }
        static intersection(t, e) {
            if (t.isEmpty() || e.isEmpty()) return oi.createEmptyResult(oi.INTERSECTION, t, e, t.getFactory());
            if (t.isGeometryCollection()) {
                const s = e;
                return ce.map(t, new class {
                    get interfaces_() {
                        return [
                            MapOp
                        ];
                    }
                    map(t) {
                        return oi.intersection(t, s);
                    }
                });
            }
            return ai.overlayOp(t, e, oi.INTERSECTION);
        }
        static symDifference(t, e) {
            if (t.isEmpty() || e.isEmpty()) {
                if (t.isEmpty() && e.isEmpty()) return oi.createEmptyResult(oi.SYMDIFFERENCE, t, e, t.getFactory());
                if (t.isEmpty()) return e.copy();
                if (e.isEmpty()) return t.copy();
            }
            if (t.isGeometryCollection() || e.isGeometryCollection()) throw new n("This method does not support GeometryCollection arguments");
            return ai.overlayOp(t, e, oi.SYMDIFFERENCE);
        }
        static resultDimension(t, e, s) {
            const n = e.getDimension(), i = s.getDimension();
            let r = -1;
            switch(t){
                case oi.INTERSECTION:
                    r = Math.min(n, i);
                    break;
                case oi.UNION:
                    r = Math.max(n, i);
                    break;
                case oi.DIFFERENCE:
                    r = n;
                    break;
                case oi.SYMDIFFERENCE:
                    r = Math.max(n, i);
            }
            return r;
        }
        static createEmptyResult(t, e, s, n) {
            const i = oi.resultDimension(t, e, s);
            return n.createEmpty(i);
        }
        static difference(t, e) {
            if (t.isEmpty()) return oi.createEmptyResult(oi.DIFFERENCE, t, e, t.getFactory());
            if (e.isEmpty()) return t.copy();
            if (t.isGeometryCollection() || e.isGeometryCollection()) throw new n("This method does not support GeometryCollection arguments");
            return ai.overlayOp(t, e, oi.DIFFERENCE);
        }
        static isResultOfOp() {
            if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = t.getLocation(0), n = t.getLocation(1);
                return oi.isResultOfOp(s, n, e);
            }
            if (3 === arguments.length) {
                let t = arguments[0], e = arguments[1], s = arguments[2];
                switch(t === Qt.BOUNDARY && (t = Qt.INTERIOR), e === Qt.BOUNDARY && (e = Qt.INTERIOR), s){
                    case oi.INTERSECTION:
                        return t === Qt.INTERIOR && e === Qt.INTERIOR;
                    case oi.UNION:
                        return t === Qt.INTERIOR || e === Qt.INTERIOR;
                    case oi.DIFFERENCE:
                        return t === Qt.INTERIOR && e !== Qt.INTERIOR;
                    case oi.SYMDIFFERENCE:
                        return t === Qt.INTERIOR && e !== Qt.INTERIOR || t !== Qt.INTERIOR && e === Qt.INTERIOR;
                }
                return !1;
            }
        }
        insertUniqueEdge(t) {
            const e = this._edgeList.findEqualEdge(t);
            if (null !== e) {
                const s = e.getLabel();
                let n = t.getLabel();
                e.isPointwiseEqual(t) || (n = new nn(t.getLabel()), n.flip());
                const i = e.getDepth();
                i.isNull() && i.add(s), i.add(n), s.merge(n);
            } else this._edgeList.add(t);
        }
        getGraph() {
            return this._graph;
        }
        cancelDuplicateResultEdges() {
            for(let t = this._graph.getEdgeEnds().iterator(); t.hasNext();){
                const e = t.next(), s = e.getSym();
                e.isInResult() && s.isInResult() && (e.setInResult(!1), s.setInResult(!1));
            }
        }
        mergeSymLabels() {
            for(let t = this._graph.getNodes().iterator(); t.hasNext();)t.next().getEdges().mergeSymLabels();
        }
        computeOverlay(t) {
            this.copyPoints(0), this.copyPoints(1), this._arg[0].computeSelfNodes(this._li, !1), this._arg[1].computeSelfNodes(this._li, !1), this._arg[0].computeEdgeIntersections(this._arg[1], this._li, !0);
            const e = new L;
            this._arg[0].computeSplitEdges(e), this._arg[1].computeSplitEdges(e), this.insertUniqueEdges(e), this.computeLabelsFromDepths(), this.replaceCollapsedEdges(), Jn.checkValid(this._edgeList.getEdges()), this._graph.addEdges(this._edgeList.getEdges()), this.computeLabelling(), this.labelIncompleteNodes(), this.findResultAreaEdges(t), this.cancelDuplicateResultEdges();
            const s = new pn(this._geomFact);
            s.add(this._graph), this._resultPolyList = s.getPolygons();
            const n = new zn(this, this._geomFact, this._ptLocator);
            this._resultLineList = n.build(t);
            const i = new Vn(this, this._geomFact, this._ptLocator);
            this._resultPointList = i.build(t), this._resultGeom = this.computeGeometry(this._resultPointList, this._resultLineList, this._resultPolyList, t);
        }
        findResultAreaEdges(t) {
            for(let e = this._graph.getEdgeEnds().iterator(); e.hasNext();){
                const s = e.next(), n = s.getLabel();
                n.isArea() && !s.isInteriorAreaEdge() && oi.isResultOfOp(n.getLocation(0, Hs.RIGHT), n.getLocation(1, Hs.RIGHT), t) && s.setInResult(!0);
            }
        }
        computeLabelsFromDepths() {
            for(let t = this._edgeList.iterator(); t.hasNext();){
                const e = t.next(), s = e.getLabel(), n = e.getDepth();
                if (!n.isNull()) {
                    n.normalize();
                    for(let t = 0; t < 2; t++)s.isNull(t) || !s.isArea() || n.isNull(t) || (0 === n.getDelta(t) ? s.toLine(t) : (h.isTrue(!n.isNull(t, Hs.LEFT), "depth of LEFT side has not been initialized"), s.setLocation(t, Hs.LEFT, n.getLocation(t, Hs.LEFT)), h.isTrue(!n.isNull(t, Hs.RIGHT), "depth of RIGHT side has not been initialized"), s.setLocation(t, Hs.RIGHT, n.getLocation(t, Hs.RIGHT))));
                }
            }
        }
        isCoveredByA(t) {
            return !!this.isCovered(t, this._resultPolyList);
        }
        isCoveredByLA(t) {
            return !!this.isCovered(t, this._resultLineList) || !!this.isCovered(t, this._resultPolyList);
        }
        computeGeometry(t, e, s, n) {
            const i = new L;
            return i.addAll(t), i.addAll(e), i.addAll(s), i.isEmpty() ? oi.createEmptyResult(n, this._arg[0].getGeometry(), this._arg[1].getGeometry(), this._geomFact) : this._geomFact.buildGeometry(i);
        }
        isCovered(t, e) {
            for(let s = e.iterator(); s.hasNext();){
                const e = s.next();
                if (this._ptLocator.locate(t, e) !== Qt.EXTERIOR) return !0;
            }
            return !1;
        }
        replaceCollapsedEdges() {
            const t = new L;
            for(let e = this._edgeList.iterator(); e.hasNext();){
                const s = e.next();
                s.isCollapsed() && (e.remove(), t.add(s.getCollapsedEdge()));
            }
            this._edgeList.addAll(t);
        }
        updateNodeLabelling() {
            for(let t = this._graph.getNodes().iterator(); t.hasNext();){
                const e = t.next(), s = e.getEdges().getLabel();
                e.getLabel().merge(s);
            }
        }
        getResultGeometry(t) {
            return this.computeOverlay(t), this._resultGeom;
        }
        insertUniqueEdges(t) {
            for(let e = t.iterator(); e.hasNext();){
                const t = e.next();
                this.insertUniqueEdge(t);
            }
        }
        labelIncompleteNode(t, e) {
            const s = this._ptLocator.locate(t.getCoordinate(), this._arg[e].getGeometry());
            t.getLabel().setLocation(e, s);
        }
        copyPoints(t) {
            for(let e = this._arg[t].getNodeIterator(); e.hasNext();){
                const s = e.next();
                this._graph.addNode(s.getCoordinate()).setLabel(t, s.getLabel().getLocation(t));
            }
        }
        computeLabelling() {
            for(let t = this._graph.getNodes().iterator(); t.hasNext();)t.next().getEdges().computeLabelling(this._arg);
            this.mergeSymLabels(), this.updateNodeLabelling();
        }
        labelIncompleteNodes() {
            for(let t = this._graph.getNodes().iterator(); t.hasNext();){
                const e = t.next(), s = e.getLabel();
                e.isIsolated() && (s.isNull(0) ? this.labelIncompleteNode(e, 0) : this.labelIncompleteNode(e, 1)), e.getEdges().updateLabelling(s);
            }
        }
    }
    oi.INTERSECTION = 1, oi.UNION = 2, oi.DIFFERENCE = 3, oi.SYMDIFFERENCE = 4;
    class li {
        constructor(){
            li.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._geom = new Array(2).fill(null), this._snapTolerance = null, this._cbr = null;
            const t = arguments[0], e = arguments[1];
            this._geom[0] = t, this._geom[1] = e, this.computeSnapTolerance();
        }
        static overlayOp(t, e, s) {
            return new li(t, e).getResultGeometry(s);
        }
        static union(t, e) {
            return li.overlayOp(t, e, oi.UNION);
        }
        static intersection(t, e) {
            return li.overlayOp(t, e, oi.INTERSECTION);
        }
        static symDifference(t, e) {
            return li.overlayOp(t, e, oi.SYMDIFFERENCE);
        }
        static difference(t, e) {
            return li.overlayOp(t, e, oi.DIFFERENCE);
        }
        selfSnap(t) {
            return new An(t).snapTo(t, this._snapTolerance);
        }
        removeCommonBits(t) {
            this._cbr = new qn, this._cbr.add(t[0]), this._cbr.add(t[1]);
            const e = new Array(2).fill(null);
            return e[0] = this._cbr.removeCommonBits(t[0].copy()), e[1] = this._cbr.removeCommonBits(t[1].copy()), e;
        }
        prepareResult(t) {
            return this._cbr.addCommonBits(t), t;
        }
        getResultGeometry(t) {
            const e = this.snap(this._geom), s = oi.overlayOp(e[0], e[1], t);
            return this.prepareResult(s);
        }
        checkValid(t) {
            t.isValid() || Y.out.println("Snapped geometry is invalid");
        }
        computeSnapTolerance() {
            this._snapTolerance = An.computeOverlaySnapTolerance(this._geom[0], this._geom[1]);
        }
        snap(t) {
            const e = this.removeCommonBits(t);
            return An.snap(e[0], e[1], this._snapTolerance);
        }
    }
    class ai {
        constructor(){
            ai.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._geom = new Array(2).fill(null);
            const t = arguments[0], e = arguments[1];
            this._geom[0] = t, this._geom[1] = e;
        }
        static overlayOp(t, e, s) {
            return new ai(t, e).getResultGeometry(s);
        }
        static union(t, e) {
            return ai.overlayOp(t, e, oi.UNION);
        }
        static intersection(t, e) {
            return ai.overlayOp(t, e, oi.INTERSECTION);
        }
        static symDifference(t, e) {
            return ai.overlayOp(t, e, oi.SYMDIFFERENCE);
        }
        static difference(t, e) {
            return ai.overlayOp(t, e, oi.DIFFERENCE);
        }
        getResultGeometry(t) {
            let e = null, s = !1, n = null;
            try {
                e = oi.overlayOp(this._geom[0], this._geom[1], t);
                s = !0;
            } catch (t) {
                if (!(t instanceof a)) throw t;
                n = t;
            }
            if (!s) try {
                e = li.overlayOp(this._geom[0], this._geom[1], t);
            } catch (t) {
                throw t instanceof a ? n : t;
            }
            return e;
        }
    }
    class ci {
        static union(t, e) {
            if (t.isEmpty() || e.isEmpty()) {
                if (t.isEmpty() && e.isEmpty()) return oi.createEmptyResult(oi.UNION, t, e, t.getFactory());
                if (t.isEmpty()) return e.copy();
                if (e.isEmpty()) return t.copy();
            }
            return j.checkNotGeometryCollection(t), j.checkNotGeometryCollection(e), ai.overlayOp(t, e, oi.UNION);
        }
    }
    class hi {
        static diagonalSize(t) {
            if (t.isNull()) return 0;
            const e = t.getWidth(), s = t.getHeight();
            return Math.sqrt(e * e + s * s);
        }
        measure(t, e) {
            const s = Oe.distance(t, e, hi.DENSIFY_FRACTION), n = new O(t.getEnvelopeInternal());
            n.expandToInclude(e.getEnvelopeInternal());
            return 1 - s / hi.diagonalSize(n);
        }
        get interfaces_() {
            return [
                Ke
            ];
        }
    }
    hi.DENSIFY_FRACTION = .25;
    var ui = Object.freeze({
        __proto__: null,
        AreaSimilarityMeasure: class {
            measure(t, e) {
                return oi.intersection(t, e).getArea() / ci.union(t, e).getArea();
            }
            get interfaces_() {
                return [
                    Ke
                ];
            }
        },
        HausdorffSimilarityMeasure: hi,
        SimilarityMeasure: Ke,
        SimilarityMeasureCombiner: class {
            static combine(t, e) {
                return Math.min(t, e);
            }
        }
    });
    class gi {
        constructor(){
            gi.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._areaBasePt = null, this._triangleCent3 = new m, this._areasum2 = 0, this._cg3 = new m, this._lineCentSum = new m, this._totalLength = 0, this._ptCount = 0, this._ptCentSum = new m;
            const t = arguments[0];
            this._areaBasePt = null, this.add(t);
        }
        static centroid3(t, e, s, n) {
            return n.x = t.x + e.x + s.x, n.y = t.y + e.y + s.y, null;
        }
        static getCentroid(t) {
            return new gi(t).getCentroid();
        }
        static area2(t, e, s) {
            return (e.x - t.x) * (s.y - t.y) - (s.x - t.x) * (e.y - t.y);
        }
        setAreaBasePoint(t) {
            this._areaBasePt = t;
        }
        addPoint(t) {
            this._ptCount += 1, this._ptCentSum.x += t.x, this._ptCentSum.y += t.y;
        }
        addLineSegments(t) {
            let e = 0;
            for(let s = 0; s < t.length - 1; s++){
                const n = t[s].distance(t[s + 1]);
                if (0 === n) continue;
                e += n;
                const i = (t[s].x + t[s + 1].x) / 2;
                this._lineCentSum.x += n * i;
                const r = (t[s].y + t[s + 1].y) / 2;
                this._lineCentSum.y += n * r;
            }
            this._totalLength += e, 0 === e && t.length > 0 && this.addPoint(t[0]);
        }
        addHole(t) {
            const e = q.isCCW(t);
            for(let s = 0; s < t.length - 1; s++)this.addTriangle(this._areaBasePt, t[s], t[s + 1], e);
            this.addLineSegments(t);
        }
        getCentroid() {
            const t = new m;
            if (Math.abs(this._areasum2) > 0) t.x = this._cg3.x / 3 / this._areasum2, t.y = this._cg3.y / 3 / this._areasum2;
            else if (this._totalLength > 0) t.x = this._lineCentSum.x / this._totalLength, t.y = this._lineCentSum.y / this._totalLength;
            else {
                if (!(this._ptCount > 0)) return null;
                t.x = this._ptCentSum.x / this._ptCount, t.y = this._ptCentSum.y / this._ptCount;
            }
            return t;
        }
        add() {
            if (arguments[0] instanceof Ct) {
                const t = arguments[0];
                this.addShell(t.getExteriorRing().getCoordinates());
                for(let e = 0; e < t.getNumInteriorRing(); e++)this.addHole(t.getInteriorRingN(e).getCoordinates());
            } else if (arguments[0] instanceof j) {
                const t = arguments[0];
                if (t.isEmpty()) return null;
                if (t instanceof Nt) this.addPoint(t.getCoordinate());
                else if (t instanceof tt) this.addLineSegments(t.getCoordinates());
                else if (t instanceof Ct) {
                    const e = t;
                    this.add(e);
                } else if (t instanceof ut) {
                    const e = t;
                    for(let t = 0; t < e.getNumGeometries(); t++)this.add(e.getGeometryN(t));
                }
            }
        }
        addShell(t) {
            t.length > 0 && this.setAreaBasePoint(t[0]);
            const e = !q.isCCW(t);
            for(let s = 0; s < t.length - 1; s++)this.addTriangle(this._areaBasePt, t[s], t[s + 1], e);
            this.addLineSegments(t);
        }
        addTriangle(t, e, s, n) {
            const i = n ? 1 : -1;
            gi.centroid3(t, e, s, this._triangleCent3);
            const r = gi.area2(t, e, s);
            this._cg3.x += i * r * this._triangleCent3.x, this._cg3.y += i * r * this._triangleCent3.y, this._areasum2 += i * r;
        }
    }
    class di {
        constructor(){
            di.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._coordSet = new pt, this._list = new L;
        }
        static filterCoordinates(t) {
            const e = new di;
            for(let s = 0; s < t.length; s++)e.filter(t[s]);
            return e.getCoordinates();
        }
        filter(t) {
            this._coordSet.add(t) && this._list.add(t);
        }
        getCoordinates() {
            const t = new Array(this._list.size()).fill(null);
            return this._list.toArray(t);
        }
        get interfaces_() {
            return [
                K
            ];
        }
    }
    class _i {
        constructor(){
            _i.constructor_.apply(this, arguments);
        }
        static constructor_() {
            if (this._geomFactory = null, this._inputPts = null, 1 === arguments.length) {
                const t = arguments[0];
                _i.constructor_.call(this, _i.extractCoordinates(t), t.getFactory());
            } else if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                this._inputPts = di.filterCoordinates(t), this._geomFactory = e;
            }
        }
        static extractCoordinates(t) {
            const e = new di;
            return t.apply(e), e.getCoordinates();
        }
        lineOrPolygon(t) {
            if (3 === (t = this.cleanRing(t)).length) return this._geomFactory.createLineString([
                t[0],
                t[1]
            ]);
            const e = this._geomFactory.createLinearRing(t);
            return this._geomFactory.createPolygon(e);
        }
        cleanRing(t) {
            h.equals(t[0], t[t.length - 1]);
            const e = new L;
            let s = null;
            for(let n = 0; n <= t.length - 2; n++){
                const i = t[n], r = t[n + 1];
                i.equals(r) || null !== s && this.isBetween(s, i, r) || (e.add(i), s = i);
            }
            e.add(t[t.length - 1]);
            const n = new Array(e.size()).fill(null);
            return e.toArray(n);
        }
        isBetween(t, e, s) {
            if (0 !== q.index(t, e, s)) return !1;
            if (t.x !== s.x) {
                if (t.x <= e.x && e.x <= s.x) return !0;
                if (s.x <= e.x && e.x <= t.x) return !0;
            }
            if (t.y !== s.y) {
                if (t.y <= e.y && e.y <= s.y) return !0;
                if (s.y <= e.y && e.y <= t.y) return !0;
            }
            return !1;
        }
        reduce(t) {
            const e = this.computeOctRing(t);
            if (null === e) return t;
            const s = new at;
            for(let t = 0; t < e.length; t++)s.add(e[t]);
            for(let n = 0; n < t.length; n++)Ue.isInRing(t[n], e) || s.add(t[n]);
            const n = W.toCoordinateArray(s);
            return n.length < 3 ? this.padArray3(n) : n;
        }
        getConvexHull() {
            if (0 === this._inputPts.length) return this._geomFactory.createGeometryCollection();
            if (1 === this._inputPts.length) return this._geomFactory.createPoint(this._inputPts[0]);
            if (2 === this._inputPts.length) return this._geomFactory.createLineString(this._inputPts);
            let t = this._inputPts;
            this._inputPts.length > 50 && (t = this.reduce(this._inputPts));
            const e = this.preSort(t), s = this.grahamScan(e), n = this.toCoordinateArray(s);
            return this.lineOrPolygon(n);
        }
        padArray3(t) {
            const e = new Array(3).fill(null);
            for(let s = 0; s < e.length; s++)s < t.length ? e[s] = t[s] : e[s] = t[0];
            return e;
        }
        computeOctPts(t) {
            const e = new Array(8).fill(null);
            for(let s = 0; s < e.length; s++)e[s] = t[0];
            for(let s = 1; s < t.length; s++)t[s].x < e[0].x && (e[0] = t[s]), t[s].x - t[s].y < e[1].x - e[1].y && (e[1] = t[s]), t[s].y > e[2].y && (e[2] = t[s]), t[s].x + t[s].y > e[3].x + e[3].y && (e[3] = t[s]), t[s].x > e[4].x && (e[4] = t[s]), t[s].x - t[s].y > e[5].x - e[5].y && (e[5] = t[s]), t[s].y < e[6].y && (e[6] = t[s]), t[s].x + t[s].y < e[7].x + e[7].y && (e[7] = t[s]);
            return e;
        }
        toCoordinateArray(t) {
            const e = new Array(t.size()).fill(null);
            for(let s = 0; s < t.size(); s++){
                const n = t.get(s);
                e[s] = n;
            }
            return e;
        }
        grahamScan(t) {
            let e = null;
            const s = new Zs;
            s.push(t[0]), s.push(t[1]), s.push(t[2]);
            for(let n = 3; n < t.length; n++){
                for(e = s.pop(); !s.empty() && q.index(s.peek(), e, t[n]) > 0;)e = s.pop();
                s.push(e), s.push(t[n]);
            }
            return s.push(t[0]), s;
        }
        preSort(t) {
            let e = null;
            for(let s = 1; s < t.length; s++)(t[s].y < t[0].y || t[s].y === t[0].y && t[s].x < t[0].x) && (e = t[0], t[0] = t[s], t[s] = e);
            return ht.sort(t, 1, t.length, new pi(t[0])), t;
        }
        computeOctRing(t) {
            const e = this.computeOctPts(t), s = new R;
            return s.add(e, !1), s.size() < 3 ? null : (s.closeRing(), s.toCoordinateArray());
        }
    }
    class pi {
        constructor(){
            pi.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._origin = null;
            const t = arguments[0];
            this._origin = t;
        }
        static polarCompare(t, e, s) {
            const n = e.x - t.x, i = e.y - t.y, r = s.x - t.x, o = s.y - t.y, l = q.index(t, e, s);
            if (l === q.COUNTERCLOCKWISE) return 1;
            if (l === q.CLOCKWISE) return -1;
            const a = n * n + i * i, c = r * r + o * o;
            return a < c ? -1 : a > c ? 1 : 0;
        }
        compare(t, e) {
            const s = t, n = e;
            return pi.polarCompare(this._origin, s, n);
        }
        get interfaces_() {
            return [
                g
            ];
        }
    }
    _i.RadialComparator = pi;
    class mi {
        constructor(){
            mi.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._interiorPoint = null, this._maxWidth = -1;
            const t = arguments[0];
            this.process(t);
        }
        static avg(t, e) {
            return (t + e) / 2;
        }
        static getInteriorPoint(t) {
            return new mi(t).getInteriorPoint();
        }
        process(t) {
            if (t.isEmpty()) return null;
            if (t instanceof Ct) this.processPolygon(t);
            else if (t instanceof ut) {
                const e = t;
                for(let t = 0; t < e.getNumGeometries(); t++)this.process(e.getGeometryN(t));
            }
        }
        getInteriorPoint() {
            return this._interiorPoint;
        }
        processPolygon(t) {
            const e = new fi(t);
            e.process();
            const s = e.getWidth();
            s > this._maxWidth && (this._maxWidth = s, this._interiorPoint = e.getInteriorPoint());
        }
    }
    class fi {
        constructor(){
            fi.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._polygon = null, this._interiorPointY = null, this._interiorSectionWidth = 0, this._interiorPoint = null;
            const t = arguments[0];
            this._polygon = t, this._interiorPointY = xi.getScanLineY(t);
        }
        static isEdgeCrossingCounted(t, e, s) {
            const n = t.getY(), i = e.getY();
            return n !== i && !(n === s && i < s) && !(i === s && n < s);
        }
        static intersectsHorizontalLine() {
            if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                return !(e < t.getMinY()) && !(e > t.getMaxY());
            }
            if (3 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = arguments[2];
                return !(t.getY() > s && e.getY() > s) && !(t.getY() < s && e.getY() < s);
            }
        }
        static intersection(t, e, s) {
            const n = t.getX(), i = e.getX();
            if (n === i) return n;
            const r = i - n, o = (e.getY() - t.getY()) / r;
            return n + (s - t.getY()) / o;
        }
        findBestMidpoint(t) {
            if (0 === t.size()) return null;
            h.isTrue(0 == t.size() % 2, "Interior Point robustness failure: odd number of scanline crossings"), t.sort(new yi);
            for(let e = 0; e < t.size(); e += 2){
                const s = t.get(e), n = t.get(e + 1), i = n - s;
                if (i > this._interiorSectionWidth) {
                    this._interiorSectionWidth = i;
                    const t = mi.avg(s, n);
                    this._interiorPoint = new m(t, this._interiorPointY);
                }
            }
        }
        getWidth() {
            return this._interiorSectionWidth;
        }
        getInteriorPoint() {
            return this._interiorPoint;
        }
        addEdgeCrossing(t, e, s, n) {
            if (!fi.intersectsHorizontalLine(t, e, s)) return null;
            if (!fi.isEdgeCrossingCounted(t, e, s)) return null;
            const i = fi.intersection(t, e, s);
            n.add(i);
        }
        process() {
            if (this._polygon.isEmpty()) return null;
            this._interiorPoint = new m(this._polygon.getCoordinate());
            const t = new L;
            this.scanRing(this._polygon.getExteriorRing(), t);
            for(let e = 0; e < this._polygon.getNumInteriorRing(); e++)this.scanRing(this._polygon.getInteriorRingN(e), t);
            this.findBestMidpoint(t);
        }
        scanRing(t, e) {
            if (!fi.intersectsHorizontalLine(t.getEnvelopeInternal(), this._interiorPointY)) return null;
            const s = t.getCoordinateSequence();
            for(let t = 1; t < s.size(); t++){
                const n = s.getCoordinate(t - 1), i = s.getCoordinate(t);
                this.addEdgeCrossing(n, i, this._interiorPointY, e);
            }
        }
    }
    class yi {
        compare(t, e) {
            return t < e ? -1 : t > e ? 1 : 0;
        }
        get interfaces_() {
            return [
                g
            ];
        }
    }
    fi.DoubleComparator = yi;
    class xi {
        constructor(){
            xi.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._poly = null, this._centreY = null, this._hiY = r.MAX_VALUE, this._loY = -r.MAX_VALUE;
            const t = arguments[0];
            this._poly = t, this._hiY = t.getEnvelopeInternal().getMaxY(), this._loY = t.getEnvelopeInternal().getMinY(), this._centreY = mi.avg(this._loY, this._hiY);
        }
        static getScanLineY(t) {
            return new xi(t).getScanLineY();
        }
        process(t) {
            const e = t.getCoordinateSequence();
            for(let t = 0; t < e.size(); t++){
                const s = e.getY(t);
                this.updateInterval(s);
            }
        }
        getScanLineY() {
            this.process(this._poly.getExteriorRing());
            for(let t = 0; t < this._poly.getNumInteriorRing(); t++)this.process(this._poly.getInteriorRingN(t));
            return mi.avg(this._hiY, this._loY);
        }
        updateInterval(t) {
            t <= this._centreY ? t > this._loY && (this._loY = t) : t > this._centreY && t < this._hiY && (this._hiY = t);
        }
    }
    mi.InteriorPointPolygon = fi, mi.ScanLineYOrdinateFinder = xi;
    class Ei {
        constructor(){
            Ei.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._centroid = null, this._minDistance = r.MAX_VALUE, this._interiorPoint = null;
            const t = arguments[0];
            t.isEmpty() ? this._centroid = null : (this._centroid = gi.getCentroid(t), t.getPrecisionModel().makePrecise(this._centroid)), this.addInterior(t), null === this._interiorPoint && this.addEndpoints(t);
        }
        static getInteriorPoint(t) {
            return new Ei(t).getInteriorPoint();
        }
        add(t) {
            const e = t.distance(this._centroid);
            e < this._minDistance && (this._interiorPoint = new m(t), this._minDistance = e);
        }
        getInteriorPoint() {
            return this._interiorPoint;
        }
        addEndpoints() {
            if (arguments[0] instanceof j) {
                const t = arguments[0];
                if (t instanceof tt) this.addEndpoints(t.getCoordinates());
                else if (t instanceof ut) {
                    const e = t;
                    for(let t = 0; t < e.getNumGeometries(); t++)this.addEndpoints(e.getGeometryN(t));
                }
            } else if (arguments[0] instanceof Array) {
                const t = arguments[0];
                this.add(t[0]), this.add(t[t.length - 1]);
            }
        }
        addInterior() {
            if (arguments[0] instanceof j) {
                const t = arguments[0];
                if (t instanceof tt) this.addInterior(t.getCoordinates());
                else if (t instanceof ut) {
                    const e = t;
                    for(let t = 0; t < e.getNumGeometries(); t++)this.addInterior(e.getGeometryN(t));
                }
            } else if (arguments[0] instanceof Array) {
                const t = arguments[0];
                for(let e = 1; e < t.length - 1; e++)this.add(t[e]);
            }
        }
    }
    class Ii {
        constructor(){
            Ii.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._centroid = null, this._minDistance = r.MAX_VALUE, this._interiorPoint = null;
            const t = arguments[0];
            this._centroid = gi.getCentroid(t), this.add(t);
        }
        static getInteriorPoint(t) {
            return new Ii(t).getInteriorPoint();
        }
        add() {
            if (arguments[0] instanceof j) {
                const t = arguments[0];
                if (t instanceof Nt) this.add(t.getCoordinate());
                else if (t instanceof ut) {
                    const e = t;
                    for(let t = 0; t < e.getNumGeometries(); t++)this.add(e.getGeometryN(t));
                }
            } else if (arguments[0] instanceof m) {
                const t = arguments[0], e = t.distance(this._centroid);
                e < this._minDistance && (this._interiorPoint = new m(t), this._minDistance = e);
            }
        }
        getInteriorPoint() {
            return this._interiorPoint;
        }
    }
    class Ni {
        constructor(){
            Ni.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._input = null, this._extremalPts = null, this._centre = null, this._radius = 0;
            const t = arguments[0];
            this._input = t;
        }
        static pointWithMinAngleWithSegment(t, e, s) {
            let n = r.MAX_VALUE, i = null;
            for(let r = 0; r < t.length; r++){
                const o = t[r];
                if (o === e) continue;
                if (o === s) continue;
                const l = $t.angleBetween(e, o, s);
                l < n && (n = l, i = o);
            }
            return i;
        }
        static pointWitMinAngleWithX(t, e) {
            let s = r.MAX_VALUE, n = null;
            for(let i = 0; i < t.length; i++){
                const r = t[i];
                if (r === e) continue;
                const o = r.x - e.x;
                let l = r.y - e.y;
                l < 0 && (l = -l);
                const a = l / Math.sqrt(o * o + l * l);
                a < s && (s = a, n = r);
            }
            return n;
        }
        static lowestPoint(t) {
            let e = t[0];
            for(let s = 1; s < t.length; s++)t[s].y < e.y && (e = t[s]);
            return e;
        }
        static farthestPoints(t) {
            const e = t[0].distance(t[1]), s = t[1].distance(t[2]), n = t[2].distance(t[0]);
            return e >= s && e >= n ? [
                t[0],
                t[1]
            ] : s >= e && s >= n ? [
                t[1],
                t[2]
            ] : [
                t[2],
                t[0]
            ];
        }
        getRadius() {
            return this.compute(), this._radius;
        }
        getDiameter() {
            switch(this.compute(), this._extremalPts.length){
                case 0:
                    return this._input.getFactory().createLineString();
                case 1:
                    return this._input.getFactory().createPoint(this._centre);
            }
            const t = this._extremalPts[0], e = this._extremalPts[1];
            return this._input.getFactory().createLineString([
                t,
                e
            ]);
        }
        getExtremalPoints() {
            return this.compute(), this._extremalPts;
        }
        computeCirclePoints() {
            if (this._input.isEmpty()) return this._extremalPts = new Array(0).fill(null), null;
            if (1 === this._input.getNumPoints()) {
                const t = this._input.getCoordinates();
                return this._extremalPts = [
                    new m(t[0])
                ], null;
            }
            const t = this._input.convexHull().getCoordinates();
            let e = t;
            if (t[0].equals2D(t[t.length - 1]) && (e = new Array(t.length - 1).fill(null), W.copyDeep(t, 0, e, 0, t.length - 1)), e.length <= 2) return this._extremalPts = W.copyDeep(e), null;
            let s = Ni.lowestPoint(e), n = Ni.pointWitMinAngleWithX(e, s);
            for(let t = 0; t < e.length; t++){
                const t = Ni.pointWithMinAngleWithSegment(e, s, n);
                if ($t.isObtuse(s, t, n)) return this._extremalPts = [
                    new m(s),
                    new m(n)
                ], null;
                if ($t.isObtuse(t, s, n)) s = t;
                else {
                    if (!$t.isObtuse(t, n, s)) return this._extremalPts = [
                        new m(s),
                        new m(n),
                        new m(t)
                    ], null;
                    n = t;
                }
            }
            h.shouldNeverReachHere("Logic failure in Minimum Bounding Circle algorithm!");
        }
        compute() {
            if (null !== this._extremalPts) return null;
            this.computeCirclePoints(), this.computeCentre(), null !== this._centre && (this._radius = this._centre.distance(this._extremalPts[0]));
        }
        getCircle() {
            if (this.compute(), null === this._centre) return this._input.getFactory().createPolygon();
            const t = this._input.getFactory().createPoint(this._centre);
            return 0 === this._radius ? t : bn.bufferOp(t, this._radius);
        }
        getCentre() {
            return this.compute(), this._centre;
        }
        getMaximumDiameter() {
            switch(this.compute(), this._extremalPts.length){
                case 0:
                    return this._input.getFactory().createLineString();
                case 1:
                    return this._input.getFactory().createPoint(this._centre);
                case 2:
                    return this._input.getFactory().createLineString([
                        this._extremalPts[0],
                        this._extremalPts[1]
                    ]);
                default:
                    const t = Ni.farthestPoints(this._extremalPts);
                    return this._input.getFactory().createLineString(t);
            }
        }
        computeCentre() {
            switch(this._extremalPts.length){
                case 0:
                    this._centre = null;
                    break;
                case 1:
                    this._centre = this._extremalPts[0];
                    break;
                case 2:
                    this._centre = new m((this._extremalPts[0].x + this._extremalPts[1].x) / 2, (this._extremalPts[0].y + this._extremalPts[1].y) / 2);
                    break;
                case 3:
                    this._centre = se.circumcentre(this._extremalPts[0], this._extremalPts[1], this._extremalPts[2]);
            }
        }
    }
    class wi {
        constructor(){
            wi.constructor_.apply(this, arguments);
        }
        static constructor_() {
            if (this._inputGeom = null, this._isConvex = null, this._convexHullPts = null, this._minBaseSeg = new Kt, this._minWidthPt = null, this._minPtIndex = null, this._minWidth = 0, 1 === arguments.length) {
                const t = arguments[0];
                wi.constructor_.call(this, t, !1);
            } else if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                this._inputGeom = t, this._isConvex = e;
            }
        }
        static nextIndex(t, e) {
            return ++e >= t.length && (e = 0), e;
        }
        static computeC(t, e, s) {
            return t * s.y - e * s.x;
        }
        static getMinimumDiameter(t) {
            return new wi(t).getDiameter();
        }
        static getMinimumRectangle(t) {
            return new wi(t).getMinimumRectangle();
        }
        static computeSegmentForLine(t, e, s) {
            let n = null, i = null;
            return Math.abs(e) > Math.abs(t) ? (n = new m(0, s / e), i = new m(1, s / e - t / e)) : (n = new m(s / t, 0), i = new m(s / t - e / t, 1)), new Kt(n, i);
        }
        getWidthCoordinate() {
            return this.computeMinimumDiameter(), this._minWidthPt;
        }
        getSupportingSegment() {
            return this.computeMinimumDiameter(), this._inputGeom.getFactory().createLineString([
                this._minBaseSeg.p0,
                this._minBaseSeg.p1
            ]);
        }
        getDiameter() {
            if (this.computeMinimumDiameter(), null === this._minWidthPt) return this._inputGeom.getFactory().createLineString();
            const t = this._minBaseSeg.project(this._minWidthPt);
            return this._inputGeom.getFactory().createLineString([
                t,
                this._minWidthPt
            ]);
        }
        computeWidthConvex(t) {
            this._convexHullPts = t instanceof Ct ? t.getExteriorRing().getCoordinates() : t.getCoordinates(), 0 === this._convexHullPts.length ? (this._minWidth = 0, this._minWidthPt = null, this._minBaseSeg = null) : 1 === this._convexHullPts.length ? (this._minWidth = 0, this._minWidthPt = this._convexHullPts[0], this._minBaseSeg.p0 = this._convexHullPts[0], this._minBaseSeg.p1 = this._convexHullPts[0]) : 2 === this._convexHullPts.length || 3 === this._convexHullPts.length ? (this._minWidth = 0, this._minWidthPt = this._convexHullPts[0], this._minBaseSeg.p0 = this._convexHullPts[0], this._minBaseSeg.p1 = this._convexHullPts[1]) : this.computeConvexRingMinDiameter(this._convexHullPts);
        }
        computeConvexRingMinDiameter(t) {
            this._minWidth = r.MAX_VALUE;
            let e = 1;
            const s = new Kt;
            for(let n = 0; n < t.length - 1; n++)s.p0 = t[n], s.p1 = t[n + 1], e = this.findMaxPerpDistance(t, s, e);
        }
        findMaxPerpDistance(t, e, s) {
            let n = e.distancePerpendicular(t[s]), i = n, r = s, o = r;
            for(; i >= n;)n = i, r = o, o = wi.nextIndex(t, r), i = e.distancePerpendicular(t[o]);
            return n < this._minWidth && (this._minPtIndex = r, this._minWidth = n, this._minWidthPt = t[this._minPtIndex], this._minBaseSeg = new Kt(e)), r;
        }
        getMinimumRectangle() {
            if (this.computeMinimumDiameter(), 0 === this._minWidth) return this._minBaseSeg.p0.equals2D(this._minBaseSeg.p1) ? this._inputGeom.getFactory().createPoint(this._minBaseSeg.p0) : this._minBaseSeg.toGeometry(this._inputGeom.getFactory());
            const t = this._minBaseSeg.p1.x - this._minBaseSeg.p0.x, e = this._minBaseSeg.p1.y - this._minBaseSeg.p0.y;
            let s = r.MAX_VALUE, n = -r.MAX_VALUE, i = r.MAX_VALUE, o = -r.MAX_VALUE;
            for(let r = 0; r < this._convexHullPts.length; r++){
                const l = wi.computeC(t, e, this._convexHullPts[r]);
                l > n && (n = l), l < s && (s = l);
                const a = wi.computeC(-e, t, this._convexHullPts[r]);
                a > o && (o = a), a < i && (i = a);
            }
            const l = wi.computeSegmentForLine(-t, -e, o), a = wi.computeSegmentForLine(-t, -e, i), c = wi.computeSegmentForLine(-e, t, n), h = wi.computeSegmentForLine(-e, t, s), u = c.lineIntersection(l), g = h.lineIntersection(l), d = h.lineIntersection(a), _ = c.lineIntersection(a), p = this._inputGeom.getFactory().createLinearRing([
                u,
                g,
                d,
                _,
                u
            ]);
            return this._inputGeom.getFactory().createPolygon(p);
        }
        computeMinimumDiameter() {
            if (null !== this._minWidthPt) return null;
            if (this._isConvex) this.computeWidthConvex(this._inputGeom);
            else {
                const t = new _i(this._inputGeom).getConvexHull();
                this.computeWidthConvex(t);
            }
        }
        getLength() {
            return this.computeMinimumDiameter(), this._minWidth;
        }
    }
    var Ci = Object.freeze({
        __proto__: null,
        Angle: $t,
        Area: wt,
        Centroid: gi,
        ConvexHull: _i,
        Distance: V,
        InteriorPointArea: mi,
        InteriorPointLine: Ei,
        InteriorPointPoint: Ii,
        Length: k,
        MinimumBoundingCircle: Ni,
        MinimumDiameter: wi,
        Orientation: q,
        PointLocation: Ue,
        PointLocator: Zn,
        RobustLineIntersector: jt,
        distance: be,
        locate: je,
        match: ui
    });
    class Si {
        constructor(){
            Si.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._inputGeom = null, this._distanceTolerance = null;
            const t = arguments[0];
            this._inputGeom = t;
        }
        static densify(t, e) {
            const s = new Si(t);
            return s.setDistanceTolerance(e), s.getResultGeometry();
        }
        static densifyPoints(t, e, s) {
            const n = new Kt, i = new R;
            for(let r = 0; r < t.length - 1; r++){
                n.p0 = t[r], n.p1 = t[r + 1], i.add(n.p0, !1);
                const o = n.getLength(), l = Math.trunc(o / e) + 1;
                if (l > 1) {
                    const t = o / l;
                    for(let e = 1; e < l; e++){
                        const r = e * t / o, l = n.pointAlong(r);
                        s.makePrecise(l), i.add(l, !1);
                    }
                }
            }
            return i.add(t[t.length - 1], !1), i.toCoordinateArray();
        }
        setDistanceTolerance(t) {
            if (t <= 0) throw new n("Tolerance must be positive");
            this._distanceTolerance = t;
        }
        getResultGeometry() {
            return new Li(this._distanceTolerance).transform(this._inputGeom);
        }
    }
    class Li extends me {
        constructor(){
            super(), Li.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this.distanceTolerance = null;
            const t = arguments[0];
            this.distanceTolerance = t;
        }
        transformCoordinates(t, e) {
            const s = t.toCoordinateArray();
            let n = Si.densifyPoints(s, this.distanceTolerance, e.getPrecisionModel());
            return e instanceof tt && 1 === n.length && (n = new Array(0).fill(null)), this._factory.getCoordinateSequenceFactory().create(n);
        }
        transformPolygon(t, e) {
            const s = super.transformPolygon.call(this, t, e);
            return e instanceof dt ? s : this.createValidArea(s);
        }
        createValidArea(t) {
            return bn.bufferOp(t, 0);
        }
        transformMultiPolygon(t, e) {
            const s = super.transformMultiPolygon.call(this, t, e);
            return this.createValidArea(s);
        }
    }
    Si.DensifyTransformer = Li;
    var Ti = Object.freeze({
        __proto__: null,
        Densifier: Si
    });
    class Ri {
        constructor(){
            Ri.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._orig = null, this._sym = null, this._next = null;
            const t = arguments[0];
            this._orig = t;
        }
        static create(t, e) {
            const s = new Ri(t), n = new Ri(e);
            return s.link(n), s;
        }
        oNext() {
            return this._sym._next;
        }
        directionY() {
            return this.directionPt().getY() - this._orig.getY();
        }
        equals() {
            if (2 === arguments.length && arguments[1] instanceof m && arguments[0] instanceof m) {
                const t = arguments[0], e = arguments[1];
                return this._orig.equals2D(t) && this._sym._orig.equals(e);
            }
        }
        findLowest() {
            let t = this, e = this.oNext();
            do e.compareTo(t) < 0 && (t = e), e = e.oNext();
            while (e !== this);
            return t;
        }
        compareTo(t) {
            const e = t;
            return this.compareAngularDirection(e);
        }
        toStringNode() {
            const t = this.orig();
            this.dest();
            const e = new nt;
            e.append("Node( " + Wt.format(t) + " )\n");
            let s = this;
            do e.append("  -> " + s), e.append("\n"), s = s.oNext();
            while (s !== this);
            return e.toString();
        }
        link(t) {
            this.setSym(t), t.setSym(this), this.setNext(t), t.setNext(this);
        }
        orig() {
            return this._orig;
        }
        setNext(t) {
            this._next = t;
        }
        find(t) {
            let e = this;
            do {
                if (null === e) return null;
                if (e.dest().equals2D(t)) return e;
                e = e.oNext();
            }while (e !== this);
            return null;
        }
        dest() {
            return this._sym._orig;
        }
        isEdgesSorted() {
            const t = this.findLowest();
            let e = t;
            do {
                const s = e.oNext();
                if (s === t) break;
                if (!(s.compareTo(e) > 0)) return !1;
                e = s;
            }while (e !== t);
            return !0;
        }
        insert(t) {
            if (this.oNext() === this) return this.insertAfter(t), null;
            this.insertionEdge(t).insertAfter(t);
        }
        insertAfter(t) {
            h.equals(this._orig, t.orig());
            const e = this.oNext();
            this._sym.setNext(t), t.sym().setNext(e);
        }
        degree() {
            let t = 0, e = this;
            do t++, e = e.oNext();
            while (e !== this);
            return t;
        }
        directionPt() {
            return this.dest();
        }
        sym() {
            return this._sym;
        }
        prev() {
            return this._sym.next()._sym;
        }
        compareAngularDirection(t) {
            const e = this.directionX(), s = this.directionY(), n = t.directionX(), i = t.directionY();
            if (e === n && s === i) return 0;
            const r = Ds.quadrant(e, s), o = Ds.quadrant(n, i);
            if (r > o) return 1;
            if (r < o) return -1;
            const l = this.directionPt(), a = t.directionPt();
            return q.index(t._orig, a, l);
        }
        prevNode() {
            let t = this;
            for(; 2 === t.degree();)if (t = t.prev(), t === this) return null;
            return t;
        }
        directionX() {
            return this.directionPt().getX() - this._orig.getX();
        }
        insertionEdge(t) {
            let e = this;
            do {
                const s = e.oNext();
                if (s.compareTo(e) > 0 && t.compareTo(e) >= 0 && t.compareTo(s) <= 0) return e;
                if (s.compareTo(e) <= 0 && (t.compareTo(s) <= 0 || t.compareTo(e) >= 0)) return e;
                e = s;
            }while (e !== this);
            return h.shouldNeverReachHere(), null;
        }
        next() {
            return this._next;
        }
        setSym(t) {
            this._sym = t;
        }
        toString() {
            return "HE(" + this._orig.x + " " + this._orig.y + ", " + this._sym._orig.x + " " + this._sym._orig.y + ")";
        }
        toStringNodeEdge() {
            return "  -> (" + Wt.format(this.dest());
        }
    }
    class Pi extends Ri {
        constructor(){
            super(), Pi.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._isMarked = !1;
            const t = arguments[0];
            Ri.constructor_.call(this, t);
        }
        static setMarkBoth(t, e) {
            t.setMark(e), t.sym().setMark(e);
        }
        static isMarked(t) {
            return t.isMarked();
        }
        static setMark(t, e) {
            t.setMark(e);
        }
        static markBoth(t) {
            t.mark(), t.sym().mark();
        }
        static mark(t) {
            t.mark();
        }
        setMark(t) {
            this._isMarked = t;
        }
        mark() {
            this._isMarked = !0;
        }
        isMarked() {
            return this._isMarked;
        }
    }
    class Oi {
        constructor(){
            Oi.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._vertexMap = new ft;
        }
        static isValidEdge(t, e) {
            return 0 !== e.compareTo(t);
        }
        insert(t, e, s) {
            const n = this.create(t, e);
            null !== s ? s.insert(n) : this._vertexMap.put(t, n);
            const i = this._vertexMap.get(e);
            return null !== i ? i.insert(n.sym()) : this._vertexMap.put(e, n.sym()), n;
        }
        create(t, e) {
            const s = this.createEdge(t), n = this.createEdge(e);
            return s.link(n), s;
        }
        createEdge(t) {
            return new Ri(t);
        }
        addEdge(t, e) {
            if (!Oi.isValidEdge(t, e)) return null;
            const s = this._vertexMap.get(t);
            let n = null;
            if (null !== s && (n = s.find(e)), null !== n) return n;
            return this.insert(t, e, s);
        }
        getVertexEdges() {
            return this._vertexMap.values();
        }
        findEdge(t, e) {
            const s = this._vertexMap.get(t);
            return null === s ? null : s.find(e);
        }
    }
    class vi extends Pi {
        constructor(){
            super(), vi.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._isStart = !1;
            const t = arguments[0];
            Pi.constructor_.call(this, t);
        }
        setStart() {
            this._isStart = !0;
        }
        isStart() {
            return this._isStart;
        }
    }
    class Mi extends Oi {
        constructor(){
            super();
        }
        createEdge(t) {
            return new vi(t);
        }
    }
    class bi {
        constructor(){
            bi.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._result = null, this._factory = null, this._graph = null, this._lines = new L, this._nodeEdgeStack = new Zs, this._ringStartEdge = null, this._graph = new Mi;
        }
        static dissolve(t) {
            const e = new bi;
            return e.add(t), e.getResult();
        }
        addLine(t) {
            this._lines.add(this._factory.createLineString(t.toCoordinateArray()));
        }
        updateRingStartEdge(t) {
            return t.isStart() || (t = t.sym()).isStart() ? null === this._ringStartEdge ? (this._ringStartEdge = t, null) : void (t.orig().compareTo(this._ringStartEdge.orig()) < 0 && (this._ringStartEdge = t)) : null;
        }
        getResult() {
            return null === this._result && this.computeResult(), this._result;
        }
        process(t) {
            let e = t.prevNode();
            null === e && (e = t), this.stackEdges(e), this.buildLines();
        }
        stackEdges(t) {
            let e = t;
            do Pi.isMarked(e) || this._nodeEdgeStack.add(e), e = e.oNext();
            while (e !== t);
        }
        computeResult() {
            for(let t = this._graph.getVertexEdges().iterator(); t.hasNext();){
                const e = t.next();
                Pi.isMarked(e) || this.process(e);
            }
            this._result = this._factory.buildGeometry(this._lines);
        }
        buildLines() {
            for(; !this._nodeEdgeStack.empty();){
                const t = this._nodeEdgeStack.pop();
                Pi.isMarked(t) || this.buildLine(t);
            }
        }
        add() {
            if (arguments[0] instanceof j) arguments[0].apply(new class {
                get interfaces_() {
                    return [
                        X
                    ];
                }
                filter(t) {
                    t instanceof tt && this.add(t);
                }
            });
            else if (I(arguments[0], N)) for(let t = arguments[0].iterator(); t.hasNext();){
                const e = t.next();
                this.add(e);
            }
            else if (arguments[0] instanceof tt) {
                const t = arguments[0];
                null === this._factory && (this._factory = t.getFactory());
                const e = t.getCoordinateSequence();
                let s = !1;
                for(let t = 1; t < e.size(); t++){
                    const n = this._graph.addEdge(e.getCoordinate(t - 1), e.getCoordinate(t));
                    null !== n && (s || (n.setStart(), s = !0));
                }
            }
        }
        buildRing(t) {
            const e = new R;
            let s = t;
            for(e.add(s.orig().copy(), !1); 2 === s.sym().degree();){
                const n = s.next();
                if (n === t) break;
                e.add(n.orig().copy(), !1), s = n;
            }
            e.add(s.dest().copy(), !1), this.addLine(e);
        }
        buildLine(t) {
            const e = new R;
            let s = t;
            for(this._ringStartEdge = null, Pi.markBoth(s), e.add(s.orig().copy(), !1); 2 === s.sym().degree();){
                this.updateRingStartEdge(s);
                const n = s.next();
                if (n === t) return this.buildRing(this._ringStartEdge), null;
                e.add(n.orig().copy(), !1), s = n, Pi.markBoth(s);
            }
            e.add(s.dest().clone(), !1), this.stackEdges(s.sym()), this.addLine(e);
        }
    }
    var Di = Object.freeze({
        __proto__: null,
        LineDissolver: bi
    }), Ai = Object.freeze({
        __proto__: null,
        GeometryGraph: ii
    });
    class Fi {
        visit(t) {}
    }
    class Gi {
        constructor(){
            Gi.constructor_.apply(this, arguments);
        }
        static constructor_() {
            if (this._p = null, this._data = null, this._left = null, this._right = null, this._count = null, 2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                this._p = new m(t), this._left = null, this._right = null, this._count = 1, this._data = e;
            } else if (3 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = arguments[2];
                this._p = new m(t, e), this._left = null, this._right = null, this._count = 1, this._data = s;
            }
        }
        isRepeated() {
            return this._count > 1;
        }
        getRight() {
            return this._right;
        }
        getCoordinate() {
            return this._p;
        }
        setLeft(t) {
            this._left = t;
        }
        getX() {
            return this._p.x;
        }
        getData() {
            return this._data;
        }
        getCount() {
            return this._count;
        }
        increment() {
            this._count = this._count + 1;
        }
        setRight(t) {
            this._right = t;
        }
        getLeft() {
            return this._left;
        }
        getY() {
            return this._p.y;
        }
    }
    class qi {
        constructor(){
            qi.constructor_.apply(this, arguments);
        }
        static constructor_() {
            if (this._root = null, this._numberOfNodes = null, this._tolerance = null, 0 === arguments.length) qi.constructor_.call(this, 0);
            else if (1 === arguments.length) {
                const t = arguments[0];
                this._tolerance = t;
            }
        }
        static toCoordinates() {
            if (1 === arguments.length) {
                const t = arguments[0];
                return qi.toCoordinates(t, !1);
            }
            if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = new R;
                for(let n = t.iterator(); n.hasNext();){
                    const t = n.next(), i = e ? t.getCount() : 1;
                    for(let e = 0; e < i; e++)s.add(t.getCoordinate(), !0);
                }
                return s.toCoordinateArray();
            }
        }
        insert() {
            if (1 === arguments.length) {
                const t = arguments[0];
                return this.insert(t, null);
            }
            if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                if (null === this._root) return this._root = new Gi(t, e), this._root;
                if (this._tolerance > 0) {
                    const e = this.findBestMatchNode(t);
                    if (null !== e) return e.increment(), e;
                }
                return this.insertExact(t, e);
            }
        }
        query() {
            if (1 === arguments.length) {
                const t = arguments[0], e = new L;
                return this.query(t, e), e;
            }
            if (2 === arguments.length) {
                if (arguments[0] instanceof O && I(arguments[1], C)) {
                    const t = arguments[0], e = arguments[1];
                    this.queryNode(this._root, t, !0, new class {
                        get interfaces_() {
                            return [
                                Fi
                            ];
                        }
                        visit(t) {
                            e.add(t);
                        }
                    });
                } else if (arguments[0] instanceof O && I(arguments[1], Fi)) {
                    const t = arguments[0], e = arguments[1];
                    this.queryNode(this._root, t, !0, e);
                }
            }
        }
        queryNode(t, e, s, n) {
            if (null === t) return null;
            let i = null, r = null, o = null;
            s ? (i = e.getMinX(), r = e.getMaxX(), o = t.getX()) : (i = e.getMinY(), r = e.getMaxY(), o = t.getY());
            const l = o <= r;
            i < o && this.queryNode(t.getLeft(), e, !s, n), e.contains(t.getCoordinate()) && n.visit(t), l && this.queryNode(t.getRight(), e, !s, n);
        }
        findBestMatchNode(t) {
            const e = new Bi(t, this._tolerance);
            return this.query(e.queryEnvelope(), e), e.getNode();
        }
        isEmpty() {
            return null === this._root;
        }
        insertExact(t, e) {
            let s = this._root, n = this._root, i = !0, r = !0;
            for(; null !== s;){
                if (null !== s) {
                    if (t.distance(s.getCoordinate()) <= this._tolerance) return s.increment(), s;
                }
                r = i ? t.x < s.getX() : t.y < s.getY(), n = s, s = r ? s.getLeft() : s.getRight(), i = !i;
            }
            this._numberOfNodes = this._numberOfNodes + 1;
            const o = new Gi(t, e);
            return r ? n.setLeft(o) : n.setRight(o), o;
        }
    }
    class Bi {
        constructor(){
            Bi.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._tolerance = null, this._matchNode = null, this._matchDist = 0, this._p = null;
            const t = arguments[0], e = arguments[1];
            this._p = t, this._tolerance = e;
        }
        queryEnvelope() {
            const t = new O(this._p);
            return t.expandBy(this._tolerance), t;
        }
        getNode() {
            return this._matchNode;
        }
        visit(t) {
            const e = this._p.distance(t.getCoordinate());
            if (!(e <= this._tolerance)) return null;
            let s = !1;
            (null === this._matchNode || e < this._matchDist || null !== this._matchNode && e === this._matchDist && t.getCoordinate().compareTo(this._matchNode.getCoordinate()) < 1) && (s = !0), s && (this._matchNode = t, this._matchDist = e);
        }
        get interfaces_() {
            return [
                Fi
            ];
        }
    }
    qi.BestMatchVisitor = Bi;
    var Yi = Object.freeze({
        __proto__: null,
        KdTree: qi
    });
    class zi {
        constructor(){
            zi.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._items = new L, this._subnode = new Array(4).fill(null);
        }
        static getSubnodeIndex(t, e, s) {
            let n = -1;
            return t.getMinX() >= e && (t.getMinY() >= s && (n = 3), t.getMaxY() <= s && (n = 1)), t.getMaxX() <= e && (t.getMinY() >= s && (n = 2), t.getMaxY() <= s && (n = 0)), n;
        }
        size() {
            let t = 0;
            for(let e = 0; e < 4; e++)null !== this._subnode[e] && (t += this._subnode[e].size());
            return t + this._items.size();
        }
        addAllItemsFromOverlapping(t, e) {
            if (!this.isSearchMatch(t)) return null;
            e.addAll(this._items);
            for(let s = 0; s < 4; s++)null !== this._subnode[s] && this._subnode[s].addAllItemsFromOverlapping(t, e);
        }
        visitItems(t, e) {
            for(let t = this._items.iterator(); t.hasNext();)e.visitItem(t.next());
        }
        hasItems() {
            return !this._items.isEmpty();
        }
        remove(t, e) {
            if (!this.isSearchMatch(t)) return !1;
            let s = !1;
            for(let n = 0; n < 4; n++)if (null !== this._subnode[n] && (s = this._subnode[n].remove(t, e), s)) {
                this._subnode[n].isPrunable() && (this._subnode[n] = null);
                break;
            }
            return s || (s = this._items.remove(e), s);
        }
        visit(t, e) {
            if (!this.isSearchMatch(t)) return null;
            this.visitItems(t, e);
            for(let s = 0; s < 4; s++)null !== this._subnode[s] && this._subnode[s].visit(t, e);
        }
        getItems() {
            return this._items;
        }
        depth() {
            let t = 0;
            for(let e = 0; e < 4; e++)if (null !== this._subnode[e]) {
                const s = this._subnode[e].depth();
                s > t && (t = s);
            }
            return t + 1;
        }
        hasChildren() {
            for(let t = 0; t < 4; t++)if (null !== this._subnode[t]) return !0;
            return !1;
        }
        isPrunable() {
            return !(this.hasChildren() || this.hasItems());
        }
        addAllItems(t) {
            t.addAll(this._items);
            for(let e = 0; e < 4; e++)null !== this._subnode[e] && this._subnode[e].addAllItems(t);
            return t;
        }
        getNodeCount() {
            let t = 0;
            for(let e = 0; e < 4; e++)null !== this._subnode[e] && (t += this._subnode[e].size());
            return t + 1;
        }
        isEmpty() {
            let t = !0;
            if (this._items.isEmpty()) {
                for(let e = 0; e < 4; e++)if (null !== this._subnode[e] && !this._subnode[e].isEmpty()) {
                    t = !1;
                    break;
                }
            } else t = !1;
            return t;
        }
        add(t) {
            this._items.add(t);
        }
        get interfaces_() {
            return [
                l
            ];
        }
    }
    function Vi() {}
    Vi.exponent = function(t) {
        return function(t, e) {
            let s, n, i, r;
            const o = {
                64: {
                    d: 32752,
                    c: 0,
                    b: 0,
                    a: 0
                }
            }, l = {
                64: 11
            }[t];
            r || (s = e < 0 || 1 / e < 0, isFinite(e) || (r = o[t], s && (r.d += 1 << t / 4 - 1), n = Math.pow(2, l) - 1, i = 0));
            if (!r) {
                for(n = ({
                    64: 1023
                })[t], i = Math.abs(e); i >= 2;)n++, i /= 2;
                for(; i < 1 && n > 0;)n--, i *= 2;
                n <= 0 && (i /= 2);
            }
            return n;
        }(64, t) - 1023;
    }, Vi.powerOf2 = function(t) {
        return Math.pow(2, t);
    };
    class ki {
        constructor(){
            ki.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._pt = new m, this._level = 0, this._env = null;
            const t = arguments[0];
            this.computeKey(t);
        }
        static computeQuadLevel(t) {
            const e = t.getWidth(), s = t.getHeight(), n = e > s ? e : s;
            return Vi.exponent(n) + 1;
        }
        getLevel() {
            return this._level;
        }
        computeKey() {
            if (1 === arguments.length) {
                const t = arguments[0];
                for(this._level = ki.computeQuadLevel(t), this._env = new O, this.computeKey(this._level, t); !this._env.contains(t);)this._level += 1, this.computeKey(this._level, t);
            } else if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = Vi.powerOf2(t);
                this._pt.x = Math.floor(e.getMinX() / s) * s, this._pt.y = Math.floor(e.getMinY() / s) * s, this._env.init(this._pt.x, this._pt.x + s, this._pt.y, this._pt.y + s);
            }
        }
        getEnvelope() {
            return this._env;
        }
        getCentre() {
            return new m((this._env.getMinX() + this._env.getMaxX()) / 2, (this._env.getMinY() + this._env.getMaxY()) / 2);
        }
        getPoint() {
            return this._pt;
        }
    }
    let Xi = class t extends zi {
        constructor(){
            super(), t.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._env = null, this._centrex = null, this._centrey = null, this._level = null;
            const t = arguments[0], e = arguments[1];
            this._env = t, this._level = e, this._centrex = (t.getMinX() + t.getMaxX()) / 2, this._centrey = (t.getMinY() + t.getMaxY()) / 2;
        }
        static createNode(e) {
            const s = new ki(e);
            return new t(s.getEnvelope(), s.getLevel());
        }
        static createExpanded(e, s) {
            const n = new O(s);
            null !== e && n.expandToInclude(e._env);
            const i = t.createNode(n);
            return null !== e && i.insertNode(e), i;
        }
        find(t) {
            const e = zi.getSubnodeIndex(t, this._centrex, this._centrey);
            if (-1 === e) return this;
            if (null !== this._subnode[e]) return this._subnode[e].find(t);
            return this;
        }
        isSearchMatch(t) {
            return null !== t && this._env.intersects(t);
        }
        getSubnode(t) {
            return null === this._subnode[t] && (this._subnode[t] = this.createSubnode(t)), this._subnode[t];
        }
        getEnvelope() {
            return this._env;
        }
        getNode(t) {
            const e = zi.getSubnodeIndex(t, this._centrex, this._centrey);
            if (-1 !== e) return this.getSubnode(e).getNode(t);
            return this;
        }
        createSubnode(e) {
            let s = 0, n = 0, i = 0, r = 0;
            switch(e){
                case 0:
                    s = this._env.getMinX(), n = this._centrex, i = this._env.getMinY(), r = this._centrey;
                    break;
                case 1:
                    s = this._centrex, n = this._env.getMaxX(), i = this._env.getMinY(), r = this._centrey;
                    break;
                case 2:
                    s = this._env.getMinX(), n = this._centrex, i = this._centrey, r = this._env.getMaxY();
                    break;
                case 3:
                    s = this._centrex, n = this._env.getMaxX(), i = this._centrey, r = this._env.getMaxY();
            }
            const o = new O(s, n, i, r);
            return new t(o, this._level - 1);
        }
        insertNode(t) {
            h.isTrue(null === this._env || this._env.contains(t._env));
            const e = zi.getSubnodeIndex(t._env, this._centrex, this._centrey);
            if (t._level === this._level - 1) this._subnode[e] = t;
            else {
                const s = this.createSubnode(e);
                s.insertNode(t), this._subnode[e] = s;
            }
        }
    };
    class Ui {
        static isZeroWidth(t, e) {
            const s = e - t;
            if (0 === s) return !0;
            const n = s / Math.max(Math.abs(t), Math.abs(e));
            return Vi.exponent(n) <= Ui.MIN_BINARY_EXPONENT;
        }
    }
    Ui.MIN_BINARY_EXPONENT = -50;
    class Hi extends zi {
        constructor(){
            super();
        }
        insertContained(t, e, s) {
            h.isTrue(t.getEnvelope().contains(e));
            const n = Ui.isZeroWidth(e.getMinX(), e.getMaxX()), i = Ui.isZeroWidth(e.getMinY(), e.getMaxY());
            let r = null;
            r = n || i ? t.find(e) : t.getNode(e), r.add(s);
        }
        isSearchMatch(t) {
            return !0;
        }
        insert(t, e) {
            const s = zi.getSubnodeIndex(t, Hi.origin.x, Hi.origin.y);
            if (-1 === s) return this.add(e), null;
            const n = this._subnode[s];
            if (null === n || !n.getEnvelope().contains(t)) {
                const e = Xi.createExpanded(n, t);
                this._subnode[s] = e;
            }
            this.insertContained(this._subnode[s], t, e);
        }
    }
    Hi.origin = new m(0, 0);
    class Wi {
        constructor(){
            Wi.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._root = null, this._minExtent = 1, this._root = new Hi;
        }
        static ensureExtent(t, e) {
            let s = t.getMinX(), n = t.getMaxX(), i = t.getMinY(), r = t.getMaxY();
            return s !== n && i !== r ? t : (s === n && (s -= e / 2, n += e / 2), i === r && (i -= e / 2, r += e / 2), new O(s, n, i, r));
        }
        size() {
            return null !== this._root ? this._root.size() : 0;
        }
        insert(t, e) {
            this.collectStats(t);
            const s = Wi.ensureExtent(t, this._minExtent);
            this._root.insert(s, e);
        }
        query() {
            if (1 === arguments.length) {
                const t = arguments[0], e = new Ye;
                return this.query(t, e), e.getItems();
            }
            if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                this._root.visit(t, e);
            }
        }
        queryAll() {
            const t = new L;
            return this._root.addAllItems(t), t;
        }
        remove(t, e) {
            const s = Wi.ensureExtent(t, this._minExtent);
            return this._root.remove(s, e);
        }
        collectStats(t) {
            const e = t.getWidth();
            e < this._minExtent && e > 0 && (this._minExtent = e);
            const s = t.getHeight();
            s < this._minExtent && s > 0 && (this._minExtent = s);
        }
        depth() {
            return null !== this._root ? this._root.depth() : 0;
        }
        isEmpty() {
            return null === this._root || this._root.isEmpty();
        }
        get interfaces_() {
            return [
                Cs,
                l
            ];
        }
    }
    var Zi = Object.freeze({
        __proto__: null,
        Quadtree: Wi
    }), ji = Object.freeze({
        __proto__: null,
        STRtree: Os
    }), Ki = Object.freeze({
        __proto__: null,
        kdtree: Yi,
        quadtree: Zi,
        strtree: ji
    });
    const Qi = [
        "Point",
        "MultiPoint",
        "LineString",
        "MultiLineString",
        "Polygon",
        "MultiPolygon"
    ];
    class Ji {
        constructor(t){
            this.geometryFactory = t || new Lt;
        }
        read(t) {
            let e;
            e = "string" == typeof t ? JSON.parse(t) : t;
            const s = e.type;
            if (!$i[s]) throw new Error("Unknown GeoJSON type: " + e.type);
            return -1 !== Qi.indexOf(s) ? $i[s].call(this, e.coordinates) : "GeometryCollection" === s ? $i[s].call(this, e.geometries) : $i[s].call(this, e);
        }
        write(t) {
            const e = t.getGeometryType();
            if (!tr[e]) throw new Error("Geometry is not supported");
            return tr[e].call(this, t);
        }
    }
    const $i = {
        Feature: function(t) {
            const e = {};
            for(const s in t)e[s] = t[s];
            if (t.geometry) {
                const s = t.geometry.type;
                if (!$i[s]) throw new Error("Unknown GeoJSON type: " + t.type);
                e.geometry = this.read(t.geometry);
            }
            return t.bbox && (e.bbox = $i.bbox.call(this, t.bbox)), e;
        },
        FeatureCollection: function(t) {
            const e = {};
            if (t.features) {
                e.features = [];
                for(let s = 0; s < t.features.length; ++s)e.features.push(this.read(t.features[s]));
            }
            return t.bbox && (e.bbox = this.parse.bbox.call(this, t.bbox)), e;
        },
        coordinates: function(t) {
            const e = [];
            for(let s = 0; s < t.length; ++s){
                const n = t[s];
                e.push(new m(...n));
            }
            return e;
        },
        bbox: function(t) {
            return this.geometryFactory.createLinearRing([
                new m(t[0], t[1]),
                new m(t[2], t[1]),
                new m(t[2], t[3]),
                new m(t[0], t[3]),
                new m(t[0], t[1])
            ]);
        },
        Point: function(t) {
            const e = new m(...t);
            return this.geometryFactory.createPoint(e);
        },
        MultiPoint: function(t) {
            const e = [];
            for(let s = 0; s < t.length; ++s)e.push($i.Point.call(this, t[s]));
            return this.geometryFactory.createMultiPoint(e);
        },
        LineString: function(t) {
            const e = $i.coordinates.call(this, t);
            return this.geometryFactory.createLineString(e);
        },
        MultiLineString: function(t) {
            const e = [];
            for(let s = 0; s < t.length; ++s)e.push($i.LineString.call(this, t[s]));
            return this.geometryFactory.createMultiLineString(e);
        },
        Polygon: function(t) {
            const e = $i.coordinates.call(this, t[0]), s = this.geometryFactory.createLinearRing(e), n = [];
            for(let e = 1; e < t.length; ++e){
                const s = t[e], i = $i.coordinates.call(this, s), r = this.geometryFactory.createLinearRing(i);
                n.push(r);
            }
            return this.geometryFactory.createPolygon(s, n);
        },
        MultiPolygon: function(t) {
            const e = [];
            for(let s = 0; s < t.length; ++s){
                const n = t[s];
                e.push($i.Polygon.call(this, n));
            }
            return this.geometryFactory.createMultiPolygon(e);
        },
        GeometryCollection: function(t) {
            const e = [];
            for(let s = 0; s < t.length; ++s){
                const n = t[s];
                e.push(this.read(n));
            }
            return this.geometryFactory.createGeometryCollection(e);
        }
    }, tr = {
        coordinate: function(t) {
            const e = [
                t.x,
                t.y
            ];
            return t.z && e.push(t.z), t.m && e.push(t.m), e;
        },
        Point: function(t) {
            return {
                type: "Point",
                coordinates: tr.coordinate.call(this, t.getCoordinate())
            };
        },
        MultiPoint: function(t) {
            const e = [];
            for(let s = 0; s < t._geometries.length; ++s){
                const n = t._geometries[s], i = tr.Point.call(this, n);
                e.push(i.coordinates);
            }
            return {
                type: "MultiPoint",
                coordinates: e
            };
        },
        LineString: function(t) {
            const e = [], s = t.getCoordinates();
            for(let t = 0; t < s.length; ++t){
                const n = s[t];
                e.push(tr.coordinate.call(this, n));
            }
            return {
                type: "LineString",
                coordinates: e
            };
        },
        MultiLineString: function(t) {
            const e = [];
            for(let s = 0; s < t._geometries.length; ++s){
                const n = t._geometries[s], i = tr.LineString.call(this, n);
                e.push(i.coordinates);
            }
            return {
                type: "MultiLineString",
                coordinates: e
            };
        },
        Polygon: function(t) {
            const e = [], s = tr.LineString.call(this, t._shell);
            e.push(s.coordinates);
            for(let s = 0; s < t._holes.length; ++s){
                const n = t._holes[s], i = tr.LineString.call(this, n);
                e.push(i.coordinates);
            }
            return {
                type: "Polygon",
                coordinates: e
            };
        },
        MultiPolygon: function(t) {
            const e = [];
            for(let s = 0; s < t._geometries.length; ++s){
                const n = t._geometries[s], i = tr.Polygon.call(this, n);
                e.push(i.coordinates);
            }
            return {
                type: "MultiPolygon",
                coordinates: e
            };
        },
        GeometryCollection: function(t) {
            const e = [];
            for(let s = 0; s < t._geometries.length; ++s){
                const n = t._geometries[s], i = n.getGeometryType();
                e.push(tr[i].call(this, n));
            }
            return {
                type: "GeometryCollection",
                geometries: e
            };
        }
    };
    function er(t) {
        return [
            t.x,
            t.y
        ];
    }
    var sr = Object.freeze({
        __proto__: null,
        GeoJSONReader: class {
            constructor(t){
                this.parser = new Ji(t || new Lt);
            }
            read(t) {
                return this.parser.read(t);
            }
        },
        GeoJSONWriter: class {
            constructor(){
                this.parser = new Ji(this.geometryFactory);
            }
            write(t) {
                return this.parser.write(t);
            }
        },
        OL3Parser: class {
            constructor(t, e){
                this.geometryFactory = t || new Lt, this.ol = e || "undefined" != typeof ol && ol;
            }
            inject(t, e, s, n, i, r, o, l) {
                this.ol = {
                    geom: {
                        Point: t,
                        LineString: e,
                        LinearRing: s,
                        Polygon: n,
                        MultiPoint: i,
                        MultiLineString: r,
                        MultiPolygon: o,
                        GeometryCollection: l
                    }
                };
            }
            read(t) {
                const e = this.ol;
                return t instanceof e.geom.Point ? this.convertFromPoint(t) : t instanceof e.geom.LineString ? this.convertFromLineString(t) : t instanceof e.geom.LinearRing ? this.convertFromLinearRing(t) : t instanceof e.geom.Polygon ? this.convertFromPolygon(t) : t instanceof e.geom.MultiPoint ? this.convertFromMultiPoint(t) : t instanceof e.geom.MultiLineString ? this.convertFromMultiLineString(t) : t instanceof e.geom.MultiPolygon ? this.convertFromMultiPolygon(t) : t instanceof e.geom.GeometryCollection ? this.convertFromCollection(t) : void 0;
            }
            convertFromPoint(t) {
                const e = t.getCoordinates();
                return this.geometryFactory.createPoint(new m(e[0], e[1]));
            }
            convertFromLineString(t) {
                return this.geometryFactory.createLineString(t.getCoordinates().map(function(t) {
                    return new m(t[0], t[1]);
                }));
            }
            convertFromLinearRing(t) {
                return this.geometryFactory.createLinearRing(t.getCoordinates().map(function(t) {
                    return new m(t[0], t[1]);
                }));
            }
            convertFromPolygon(t) {
                const e = t.getLinearRings();
                let s = null;
                const n = [];
                for(let t = 0; t < e.length; t++){
                    const i = this.convertFromLinearRing(e[t]);
                    0 === t ? s = i : n.push(i);
                }
                return this.geometryFactory.createPolygon(s, n);
            }
            convertFromMultiPoint(t) {
                const e = t.getPoints().map(function(t) {
                    return this.convertFromPoint(t);
                }, this);
                return this.geometryFactory.createMultiPoint(e);
            }
            convertFromMultiLineString(t) {
                const e = t.getLineStrings().map(function(t) {
                    return this.convertFromLineString(t);
                }, this);
                return this.geometryFactory.createMultiLineString(e);
            }
            convertFromMultiPolygon(t) {
                const e = t.getPolygons().map(function(t) {
                    return this.convertFromPolygon(t);
                }, this);
                return this.geometryFactory.createMultiPolygon(e);
            }
            convertFromCollection(t) {
                const e = t.getGeometries().map(function(t) {
                    return this.read(t);
                }, this);
                return this.geometryFactory.createGeometryCollection(e);
            }
            write(t) {
                return "Point" === t.getGeometryType() ? this.convertToPoint(t.getCoordinate()) : "LineString" === t.getGeometryType() ? this.convertToLineString(t) : "LinearRing" === t.getGeometryType() ? this.convertToLinearRing(t) : "Polygon" === t.getGeometryType() ? this.convertToPolygon(t) : "MultiPoint" === t.getGeometryType() ? this.convertToMultiPoint(t) : "MultiLineString" === t.getGeometryType() ? this.convertToMultiLineString(t) : "MultiPolygon" === t.getGeometryType() ? this.convertToMultiPolygon(t) : "GeometryCollection" === t.getGeometryType() ? this.convertToCollection(t) : void 0;
            }
            convertToPoint(t) {
                return new this.ol.geom.Point([
                    t.x,
                    t.y
                ]);
            }
            convertToLineString(t) {
                const e = t._points._coordinates.map(er);
                return new this.ol.geom.LineString(e);
            }
            convertToLinearRing(t) {
                const e = t._points._coordinates.map(er);
                return new this.ol.geom.LinearRing(e);
            }
            convertToPolygon(t) {
                const e = [
                    t._shell._points._coordinates.map(er)
                ];
                for(let s = 0; s < t._holes.length; s++)e.push(t._holes[s]._points._coordinates.map(er));
                return new this.ol.geom.Polygon(e);
            }
            convertToMultiPoint(t) {
                return new this.ol.geom.MultiPoint(t.getCoordinates().map(er));
            }
            convertToMultiLineString(t) {
                const e = [];
                for(let s = 0; s < t._geometries.length; s++)e.push(this.convertToLineString(t._geometries[s]).getCoordinates());
                return new this.ol.geom.MultiLineString(e);
            }
            convertToMultiPolygon(t) {
                const e = [];
                for(let s = 0; s < t._geometries.length; s++)e.push(this.convertToPolygon(t._geometries[s]).getCoordinates());
                return new this.ol.geom.MultiPolygon(e);
            }
            convertToCollection(t) {
                const e = [];
                for(let s = 0; s < t._geometries.length; s++){
                    const n = t._geometries[s];
                    e.push(this.write(n));
                }
                return new this.ol.geom.GeometryCollection(e);
            }
        },
        WKTReader: class {
            constructor(t){
                this.parser = new Ht(t || new Lt);
            }
            read(t) {
                return this.parser.read(t);
            }
        },
        WKTWriter: Wt
    }), nr = Object.freeze({
        __proto__: null,
        MCIndexNoder: Gs,
        ScaledNoder: ds,
        SegmentString: cs
    });
    class ir {
        constructor(){
            ir.constructor_.apply(this, arguments);
        }
        static constructor_() {
            if (this._geom = null, this._geomFact = null, this._bnRule = null, this._endpointMap = null, 1 === arguments.length) {
                const t = arguments[0];
                ir.constructor_.call(this, t, kn.MOD2_BOUNDARY_RULE);
            } else if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                this._geom = t, this._geomFact = t.getFactory(), this._bnRule = e;
            }
        }
        static getBoundary() {
            if (1 === arguments.length) return new ir(arguments[0]).getBoundary();
            if (2 === arguments.length) return new ir(arguments[0], arguments[1]).getBoundary();
        }
        boundaryMultiLineString(t) {
            if (this._geom.isEmpty()) return this.getEmptyMultiPoint();
            const e = this.computeBoundaryCoordinates(t);
            return 1 === e.length ? this._geomFact.createPoint(e[0]) : this._geomFact.createMultiPointFromCoords(e);
        }
        getBoundary() {
            return this._geom instanceof tt ? this.boundaryLineString(this._geom) : this._geom instanceof Et ? this.boundaryMultiLineString(this._geom) : this._geom.getBoundary();
        }
        boundaryLineString(t) {
            if (this._geom.isEmpty()) return this.getEmptyMultiPoint();
            if (t.isClosed()) return this._bnRule.isInBoundary(2) ? t.getStartPoint() : this._geomFact.createMultiPoint();
            return this._geomFact.createMultiPoint([
                t.getStartPoint(),
                t.getEndPoint()
            ]);
        }
        getEmptyMultiPoint() {
            return this._geomFact.createMultiPoint();
        }
        computeBoundaryCoordinates(t) {
            const e = new L;
            this._endpointMap = new os;
            for(let e = 0; e < t.getNumGeometries(); e++){
                const s = t.getGeometryN(e);
                0 !== s.getNumPoints() && (this.addEndpoint(s.getCoordinateN(0)), this.addEndpoint(s.getCoordinateN(s.getNumPoints() - 1)));
            }
            for(let t = this._endpointMap.entrySet().iterator(); t.hasNext();){
                const s = t.next(), n = s.getValue().count;
                this._bnRule.isInBoundary(n) && e.add(s.getKey());
            }
            return W.toCoordinateArray(e);
        }
        addEndpoint(t) {
            let e = this._endpointMap.get(t);
            null === e && (e = new rr, this._endpointMap.put(t, e)), e.count++;
        }
    }
    let rr = class t {
        constructor(){
            t.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this.count = null;
        }
    };
    class or {
        constructor(){
            or.constructor_.apply(this, arguments);
        }
        static constructor_() {
            if (this._inputGeom = null, this._isClosedEndpointsInInterior = !0, this._nonSimpleLocation = null, 1 === arguments.length) {
                const t = arguments[0];
                this._inputGeom = t;
            } else if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                this._inputGeom = t, this._isClosedEndpointsInInterior = !e.isInBoundary(2);
            }
        }
        static isSimple() {
            if (1 === arguments.length) return new or(arguments[0]).isSimple();
            if (2 === arguments.length) return new or(arguments[0], arguments[1]).isSimple();
        }
        isSimpleMultiPoint(t) {
            if (t.isEmpty()) return !0;
            const e = new at;
            for(let s = 0; s < t.getNumGeometries(); s++){
                const n = t.getGeometryN(s).getCoordinate();
                if (e.contains(n)) return this._nonSimpleLocation = n, !1;
                e.add(n);
            }
            return !0;
        }
        isSimplePolygonal(t) {
            for(let e = ye.getLines(t).iterator(); e.hasNext();){
                const t = e.next();
                if (!this.isSimpleLinearGeometry(t)) return !1;
            }
            return !0;
        }
        hasClosedEndpointIntersection(t) {
            const e = new os;
            for(let s = t.getEdgeIterator(); s.hasNext();){
                const t = s.next(), n = t.isClosed(), i = t.getCoordinate(0);
                this.addEndpoint(e, i, n);
                const r = t.getCoordinate(t.getNumPoints() - 1);
                this.addEndpoint(e, r, n);
            }
            for(let t = e.values().iterator(); t.hasNext();){
                const e = t.next();
                if (e.isClosed && 2 !== e.degree) return this._nonSimpleLocation = e.getCoordinate(), !0;
            }
            return !1;
        }
        getNonSimpleLocation() {
            return this._nonSimpleLocation;
        }
        isSimpleLinearGeometry(t) {
            if (t.isEmpty()) return !0;
            const e = new ii(0, t), s = new jt, n = e.computeSelfNodes(s, !0);
            return !n.hasIntersection() || (n.hasProperIntersection() ? (this._nonSimpleLocation = n.getProperIntersectionPoint(), !1) : !this.hasNonEndpointIntersection(e) && (!this._isClosedEndpointsInInterior || !this.hasClosedEndpointIntersection(e)));
        }
        hasNonEndpointIntersection(t) {
            for(let e = t.getEdgeIterator(); e.hasNext();){
                const t = e.next(), s = t.getMaximumSegmentIndex();
                for(let e = t.getEdgeIntersectionList().iterator(); e.hasNext();){
                    const t = e.next();
                    if (!t.isEndPoint(s)) return this._nonSimpleLocation = t.getCoordinate(), !0;
                }
            }
            return !1;
        }
        addEndpoint(t, e, s) {
            let n = t.get(e);
            null === n && (n = new lr(e), t.put(e, n)), n.addEndpoint(s);
        }
        computeSimple(t) {
            return this._nonSimpleLocation = null, !!t.isEmpty() || (t instanceof tt || t instanceof Et ? this.isSimpleLinearGeometry(t) : t instanceof St ? this.isSimpleMultiPoint(t) : I(t, gt) ? this.isSimplePolygonal(t) : !(t instanceof ut) || this.isSimpleGeometryCollection(t));
        }
        isSimple() {
            return this._nonSimpleLocation = null, this.computeSimple(this._inputGeom);
        }
        isSimpleGeometryCollection(t) {
            for(let e = 0; e < t.getNumGeometries(); e++){
                const s = t.getGeometryN(e);
                if (!this.computeSimple(s)) return !1;
            }
            return !0;
        }
    }
    class lr {
        constructor(){
            lr.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this.pt = null, this.isClosed = null, this.degree = null;
            const t = arguments[0];
            this.pt = t, this.isClosed = !1, this.degree = 0;
        }
        getCoordinate() {
            return this.pt;
        }
        addEndpoint(t) {
            this.degree++, this.isClosed |= t;
        }
    }
    or.EndpointInfo = lr;
    var ar = Object.freeze({
        __proto__: null,
        BufferOp: bn,
        BufferParameters: Qe
    });
    class cr {
        constructor(){
            cr.constructor_.apply(this, arguments);
        }
        static constructor_() {
            if (this._component = null, this._segIndex = null, this._pt = null, 2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                cr.constructor_.call(this, t, cr.INSIDE_AREA, e);
            } else if (3 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = arguments[2];
                this._component = t, this._segIndex = e, this._pt = s;
            }
        }
        getSegmentIndex() {
            return this._segIndex;
        }
        getCoordinate() {
            return this._pt;
        }
        isInsideArea() {
            return this._segIndex === cr.INSIDE_AREA;
        }
        toString() {
            return this._component.getGeometryType() + "[" + this._segIndex + "]-" + Wt.toPoint(this._pt);
        }
        getGeometryComponent() {
            return this._component;
        }
    }
    cr.INSIDE_AREA = -1;
    class hr {
        constructor(){
            hr.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._locations = null;
            const t = arguments[0];
            this._locations = t;
        }
        static getLocations(t) {
            const e = new L;
            return t.apply(new hr(e)), e;
        }
        filter(t) {
            if (t.isEmpty()) return null;
            (t instanceof Nt || t instanceof tt || t instanceof Ct) && this._locations.add(new cr(t, 0, t.getCoordinate()));
        }
        get interfaces_() {
            return [
                $
            ];
        }
    }
    class ur {
        constructor(){
            ur.constructor_.apply(this, arguments);
        }
        static constructor_() {
            if (this._geom = null, this._terminateDistance = 0, this._ptLocator = new Zn, this._minDistanceLocation = null, this._minDistance = r.MAX_VALUE, 2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                ur.constructor_.call(this, t, e, 0);
            } else if (3 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = arguments[2];
                this._geom = new Array(2).fill(null), this._geom[0] = t, this._geom[1] = e, this._terminateDistance = s;
            }
        }
        static distance(t, e) {
            return new ur(t, e).distance();
        }
        static isWithinDistance(t, e, s) {
            if (t.getEnvelopeInternal().distance(e.getEnvelopeInternal()) > s) return !1;
            return new ur(t, e, s).distance() <= s;
        }
        static nearestPoints(t, e) {
            return new ur(t, e).nearestPoints();
        }
        computeContainmentDistance() {
            if (0 === arguments.length) {
                const t = new Array(2).fill(null);
                if (this.computeContainmentDistance(0, t), this._minDistance <= this._terminateDistance) return null;
                this.computeContainmentDistance(1, t);
            } else if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = this._geom[t];
                if (s.getDimension() < 2) return null;
                const n = 1 - t, i = Ie.getPolygons(s);
                if (i.size() > 0) {
                    const s = hr.getLocations(this._geom[n]);
                    if (this.computeContainmentDistance(s, i, e), this._minDistance <= this._terminateDistance) return this._minDistanceLocation[n] = e[0], this._minDistanceLocation[t] = e[1], null;
                }
            } else if (3 === arguments.length) {
                if (arguments[2] instanceof Array && I(arguments[0], C) && I(arguments[1], C)) {
                    const t = arguments[0], e = arguments[1], s = arguments[2];
                    for(let n = 0; n < t.size(); n++){
                        const i = t.get(n);
                        for(let t = 0; t < e.size(); t++)if (this.computeContainmentDistance(i, e.get(t), s), this._minDistance <= this._terminateDistance) return null;
                    }
                } else if (arguments[2] instanceof Array && arguments[0] instanceof cr && arguments[1] instanceof Ct) {
                    const t = arguments[0], e = arguments[1], s = arguments[2], n = t.getCoordinate();
                    if (Qt.EXTERIOR !== this._ptLocator.locate(n, e)) return this._minDistance = 0, s[0] = t, s[1] = new cr(e, n), null;
                }
            }
        }
        computeMinDistanceLinesPoints(t, e, s) {
            for(let n = 0; n < t.size(); n++){
                const i = t.get(n);
                for(let t = 0; t < e.size(); t++){
                    const n = e.get(t);
                    if (this.computeMinDistance(i, n, s), this._minDistance <= this._terminateDistance) return null;
                }
            }
        }
        computeFacetDistance() {
            const t = new Array(2).fill(null), e = ye.getLines(this._geom[0]), s = ye.getLines(this._geom[1]), n = Ee.getPoints(this._geom[0]), i = Ee.getPoints(this._geom[1]);
            return this.computeMinDistanceLines(e, s, t), this.updateMinDistance(t, !1), this._minDistance <= this._terminateDistance ? null : (t[0] = null, t[1] = null, this.computeMinDistanceLinesPoints(e, i, t), this.updateMinDistance(t, !1), this._minDistance <= this._terminateDistance ? null : (t[0] = null, t[1] = null, this.computeMinDistanceLinesPoints(s, n, t), this.updateMinDistance(t, !0), this._minDistance <= this._terminateDistance ? null : (t[0] = null, t[1] = null, this.computeMinDistancePoints(n, i, t), void this.updateMinDistance(t, !1))));
        }
        nearestLocations() {
            return this.computeMinDistance(), this._minDistanceLocation;
        }
        updateMinDistance(t, e) {
            if (null === t[0]) return null;
            e ? (this._minDistanceLocation[0] = t[1], this._minDistanceLocation[1] = t[0]) : (this._minDistanceLocation[0] = t[0], this._minDistanceLocation[1] = t[1]);
        }
        nearestPoints() {
            this.computeMinDistance();
            return [
                this._minDistanceLocation[0].getCoordinate(),
                this._minDistanceLocation[1].getCoordinate()
            ];
        }
        computeMinDistance() {
            if (0 === arguments.length) {
                if (null !== this._minDistanceLocation) return null;
                if (this._minDistanceLocation = new Array(2).fill(null), this.computeContainmentDistance(), this._minDistance <= this._terminateDistance) return null;
                this.computeFacetDistance();
            } else if (3 === arguments.length) {
                if (arguments[2] instanceof Array && arguments[0] instanceof tt && arguments[1] instanceof Nt) {
                    const t = arguments[0], e = arguments[1], s = arguments[2];
                    if (t.getEnvelopeInternal().distance(e.getEnvelopeInternal()) > this._minDistance) return null;
                    const n = t.getCoordinates(), i = e.getCoordinate();
                    for(let r = 0; r < n.length - 1; r++){
                        const o = V.pointToSegment(i, n[r], n[r + 1]);
                        if (o < this._minDistance) {
                            this._minDistance = o;
                            const l = new Kt(n[r], n[r + 1]).closestPoint(i);
                            s[0] = new cr(t, r, l), s[1] = new cr(e, 0, i);
                        }
                        if (this._minDistance <= this._terminateDistance) return null;
                    }
                } else if (arguments[2] instanceof Array && arguments[0] instanceof tt && arguments[1] instanceof tt) {
                    const t = arguments[0], e = arguments[1], s = arguments[2];
                    if (t.getEnvelopeInternal().distance(e.getEnvelopeInternal()) > this._minDistance) return null;
                    const n = t.getCoordinates(), i = e.getCoordinates();
                    for(let r = 0; r < n.length - 1; r++){
                        const o = new O(n[r], n[r + 1]);
                        if (!(o.distance(e.getEnvelopeInternal()) > this._minDistance)) for(let l = 0; l < i.length - 1; l++){
                            const a = new O(i[l], i[l + 1]);
                            if (o.distance(a) > this._minDistance) continue;
                            const c = V.segmentToSegment(n[r], n[r + 1], i[l], i[l + 1]);
                            if (c < this._minDistance) {
                                this._minDistance = c;
                                const o = new Kt(n[r], n[r + 1]), a = new Kt(i[l], i[l + 1]), h = o.closestPoints(a);
                                s[0] = new cr(t, r, h[0]), s[1] = new cr(e, l, h[1]);
                            }
                            if (this._minDistance <= this._terminateDistance) return null;
                        }
                    }
                }
            }
        }
        computeMinDistancePoints(t, e, s) {
            for(let n = 0; n < t.size(); n++){
                const i = t.get(n);
                for(let t = 0; t < e.size(); t++){
                    const n = e.get(t), r = i.getCoordinate().distance(n.getCoordinate());
                    if (r < this._minDistance && (this._minDistance = r, s[0] = new cr(i, 0, i.getCoordinate()), s[1] = new cr(n, 0, n.getCoordinate())), this._minDistance <= this._terminateDistance) return null;
                }
            }
        }
        distance() {
            if (null === this._geom[0] || null === this._geom[1]) throw new n("null geometries are not supported");
            return this._geom[0].isEmpty() || this._geom[1].isEmpty() ? 0 : (this.computeMinDistance(), this._minDistance);
        }
        computeMinDistanceLines(t, e, s) {
            for(let n = 0; n < t.size(); n++){
                const i = t.get(n);
                for(let t = 0; t < e.size(); t++){
                    const n = e.get(t);
                    if (this.computeMinDistance(i, n, s), this._minDistance <= this._terminateDistance) return null;
                }
            }
        }
    }
    var gr = Object.freeze({
        __proto__: null,
        DistanceOp: ur
    });
    class dr {
        constructor(){
            dr.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._factory = null, this._directedEdges = new L, this._coordinates = null;
            const t = arguments[0];
            this._factory = t;
        }
        add(t) {
            this._directedEdges.add(t);
        }
        toLineString() {
            return this._factory.createLineString(this.getCoordinates());
        }
        getCoordinates() {
            if (null === this._coordinates) {
                let t = 0, e = 0;
                const s = new R;
                for(let n = this._directedEdges.iterator(); n.hasNext();){
                    const i = n.next();
                    i.getEdgeDirection() ? t++ : e++, s.add(i.getEdge().getLine().getCoordinates(), !1, i.getEdgeDirection());
                }
                this._coordinates = s.toCoordinateArray(), e > t && W.reverse(this._coordinates);
            }
            return this._coordinates;
        }
    }
    class _r {
        constructor(){
            _r.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._isMarked = !1, this._isVisited = !1, this._data = null;
        }
        static setMarked(t, e) {
            for(; t.hasNext();)t.next().setMarked(e);
        }
        static setVisited(t, e) {
            for(; t.hasNext();)t.next().setVisited(e);
        }
        static getComponentWithVisitedState(t, e) {
            for(; t.hasNext();){
                const s = t.next();
                if (s.isVisited() === e) return s;
            }
            return null;
        }
        setVisited(t) {
            this._isVisited = t;
        }
        isMarked() {
            return this._isMarked;
        }
        setData(t) {
            this._data = t;
        }
        getData() {
            return this._data;
        }
        setMarked(t) {
            this._isMarked = t;
        }
        getContext() {
            return this._data;
        }
        isVisited() {
            return this._isVisited;
        }
        setContext(t) {
            this._data = t;
        }
    }
    class pr extends _r {
        constructor(){
            super(), pr.constructor_.apply(this, arguments);
        }
        static constructor_() {
            if (this._parentEdge = null, this._from = null, this._to = null, this._p0 = null, this._p1 = null, this._sym = null, this._edgeDirection = null, this._quadrant = null, this._angle = null, 0 === arguments.length) ;
            else if (4 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = arguments[2], n = arguments[3];
                this._from = t, this._to = e, this._edgeDirection = n, this._p0 = t.getCoordinate(), this._p1 = s;
                const i = this._p1.x - this._p0.x, r = this._p1.y - this._p0.y;
                this._quadrant = Ds.quadrant(i, r), this._angle = Math.atan2(r, i);
            }
        }
        static toEdges(t) {
            const e = new L;
            for(let s = t.iterator(); s.hasNext();)e.add(s.next()._parentEdge);
            return e;
        }
        isRemoved() {
            return null === this._parentEdge;
        }
        compareDirection(t) {
            return this._quadrant > t._quadrant ? 1 : this._quadrant < t._quadrant ? -1 : q.index(t._p0, t._p1, this._p1);
        }
        getCoordinate() {
            return this._from.getCoordinate();
        }
        print(t) {
            const e = this.getClass().getName(), s = e.lastIndexOf("."), n = e.substring(s + 1);
            t.print("  " + n + ": " + this._p0 + " - " + this._p1 + " " + this._quadrant + ":" + this._angle);
        }
        getDirectionPt() {
            return this._p1;
        }
        getAngle() {
            return this._angle;
        }
        getSym() {
            return this._sym;
        }
        getEdge() {
            return this._parentEdge;
        }
        getToNode() {
            return this._to;
        }
        getEdgeDirection() {
            return this._edgeDirection;
        }
        compareTo(t) {
            const e = t;
            return this.compareDirection(e);
        }
        getFromNode() {
            return this._from;
        }
        setEdge(t) {
            this._parentEdge = t;
        }
        remove() {
            this._sym = null, this._parentEdge = null;
        }
        getQuadrant() {
            return this._quadrant;
        }
        setSym(t) {
            this._sym = t;
        }
        get interfaces_() {
            return [
                o
            ];
        }
    }
    class mr extends pr {
        constructor(){
            super(), mr.constructor_.apply(this, arguments);
        }
        static constructor_() {
            const t = arguments[0], e = arguments[1], s = arguments[2], n = arguments[3];
            pr.constructor_.call(this, t, e, s, n);
        }
        getNext() {
            return 2 !== this.getToNode().getDegree() ? null : this.getToNode().getOutEdges().getEdges().get(0) === this.getSym() ? this.getToNode().getOutEdges().getEdges().get(1) : (h.isTrue(this.getToNode().getOutEdges().getEdges().get(1) === this.getSym()), this.getToNode().getOutEdges().getEdges().get(0));
        }
    }
    class fr extends _r {
        constructor(){
            super(), fr.constructor_.apply(this, arguments);
        }
        static constructor_() {
            if (this._dirEdge = null, 0 === arguments.length) ;
            else if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                this.setDirectedEdges(t, e);
            }
        }
        isRemoved() {
            return null === this._dirEdge;
        }
        setDirectedEdges(t, e) {
            this._dirEdge = [
                t,
                e
            ], t.setEdge(this), e.setEdge(this), t.setSym(e), e.setSym(t), t.getFromNode().addOutEdge(t), e.getFromNode().addOutEdge(e);
        }
        getDirEdge() {
            if (Number.isInteger(arguments[0])) {
                const t = arguments[0];
                return this._dirEdge[t];
            }
            if (arguments[0] instanceof xr) {
                const t = arguments[0];
                return this._dirEdge[0].getFromNode() === t ? this._dirEdge[0] : this._dirEdge[1].getFromNode() === t ? this._dirEdge[1] : null;
            }
        }
        remove() {
            this._dirEdge = null;
        }
        getOppositeNode(t) {
            return this._dirEdge[0].getFromNode() === t ? this._dirEdge[0].getToNode() : this._dirEdge[1].getFromNode() === t ? this._dirEdge[1].getToNode() : null;
        }
    }
    class yr {
        constructor(){
            yr.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._outEdges = new L, this._sorted = !1;
        }
        getNextEdge(t) {
            const e = this.getIndex(t);
            return this._outEdges.get(this.getIndex(e + 1));
        }
        getCoordinate() {
            const t = this.iterator();
            if (!t.hasNext()) return null;
            return t.next().getCoordinate();
        }
        iterator() {
            return this.sortEdges(), this._outEdges.iterator();
        }
        sortEdges() {
            this._sorted || (xe.sort(this._outEdges), this._sorted = !0);
        }
        remove(t) {
            this._outEdges.remove(t);
        }
        getEdges() {
            return this.sortEdges(), this._outEdges;
        }
        getNextCWEdge(t) {
            const e = this.getIndex(t);
            return this._outEdges.get(this.getIndex(e - 1));
        }
        getIndex() {
            if (arguments[0] instanceof fr) {
                const t = arguments[0];
                this.sortEdges();
                for(let e = 0; e < this._outEdges.size(); e++){
                    if (this._outEdges.get(e).getEdge() === t) return e;
                }
                return -1;
            }
            if (arguments[0] instanceof pr) {
                const t = arguments[0];
                this.sortEdges();
                for(let e = 0; e < this._outEdges.size(); e++){
                    if (this._outEdges.get(e) === t) return e;
                }
                return -1;
            }
            if (Number.isInteger(arguments[0])) {
                let t = arguments[0] % this._outEdges.size();
                return t < 0 && (t += this._outEdges.size()), t;
            }
        }
        add(t) {
            this._outEdges.add(t), this._sorted = !1;
        }
        getDegree() {
            return this._outEdges.size();
        }
    }
    class xr extends _r {
        constructor(){
            super(), xr.constructor_.apply(this, arguments);
        }
        static constructor_() {
            if (this._pt = null, this._deStar = null, 1 === arguments.length) {
                const t = arguments[0];
                xr.constructor_.call(this, t, new yr);
            } else if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                this._pt = t, this._deStar = e;
            }
        }
        static getEdgesBetween(t, e) {
            const s = pr.toEdges(t.getOutEdges().getEdges()), n = new pt(s), i = pr.toEdges(e.getOutEdges().getEdges());
            return n.retainAll(i), n;
        }
        isRemoved() {
            return null === this._pt;
        }
        addOutEdge(t) {
            this._deStar.add(t);
        }
        getCoordinate() {
            return this._pt;
        }
        getOutEdges() {
            return this._deStar;
        }
        remove() {
            if (0 === arguments.length) this._pt = null;
            else if (1 === arguments.length) {
                const t = arguments[0];
                this._deStar.remove(t);
            }
        }
        getIndex(t) {
            return this._deStar.getIndex(t);
        }
        getDegree() {
            return this._deStar.getDegree();
        }
    }
    class Er extends fr {
        constructor(){
            super(), Er.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._line = null;
            const t = arguments[0];
            this._line = t;
        }
        getLine() {
            return this._line;
        }
    }
    class Ir {
        constructor(){
            Ir.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._nodeMap = new os;
        }
        find(t) {
            return this._nodeMap.get(t);
        }
        iterator() {
            return this._nodeMap.values().iterator();
        }
        remove(t) {
            return this._nodeMap.remove(t);
        }
        values() {
            return this._nodeMap.values();
        }
        add(t) {
            return this._nodeMap.put(t.getCoordinate(), t), t;
        }
    }
    class Nr {
        constructor(){
            Nr.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._edges = new pt, this._dirEdges = new pt, this._nodeMap = new Ir;
        }
        findNodesOfDegree(t) {
            const e = new L;
            for(let s = this.nodeIterator(); s.hasNext();){
                const n = s.next();
                n.getDegree() === t && e.add(n);
            }
            return e;
        }
        dirEdgeIterator() {
            return this._dirEdges.iterator();
        }
        edgeIterator() {
            return this._edges.iterator();
        }
        getEdges() {
            return this._edges;
        }
        nodeIterator() {
            return this._nodeMap.iterator();
        }
        contains() {
            if (arguments[0] instanceof fr) {
                const t = arguments[0];
                return this._edges.contains(t);
            }
            if (arguments[0] instanceof pr) {
                const t = arguments[0];
                return this._dirEdges.contains(t);
            }
        }
        add() {
            if (arguments[0] instanceof xr) {
                const t = arguments[0];
                this._nodeMap.add(t);
            } else if (arguments[0] instanceof fr) {
                const t = arguments[0];
                this._edges.add(t), this.add(t.getDirEdge(0)), this.add(t.getDirEdge(1));
            } else if (arguments[0] instanceof pr) {
                const t = arguments[0];
                this._dirEdges.add(t);
            }
        }
        getNodes() {
            return this._nodeMap.values();
        }
        remove() {
            if (arguments[0] instanceof fr) {
                const t = arguments[0];
                this.remove(t.getDirEdge(0)), this.remove(t.getDirEdge(1)), this._edges.remove(t), t.remove();
            } else if (arguments[0] instanceof pr) {
                const t = arguments[0], e = t.getSym();
                null !== e && e.setSym(null), t.getFromNode().remove(t), t.remove(), this._dirEdges.remove(t);
            } else if (arguments[0] instanceof xr) {
                const t = arguments[0];
                for(let e = t.getOutEdges().getEdges().iterator(); e.hasNext();){
                    const t = e.next(), s = t.getSym();
                    null !== s && this.remove(s), this._dirEdges.remove(t);
                    const n = t.getEdge();
                    null !== n && this._edges.remove(n);
                }
                this._nodeMap.remove(t.getCoordinate()), t.remove();
            }
        }
        findNode(t) {
            return this._nodeMap.find(t);
        }
    }
    class wr extends Nr {
        constructor(){
            super();
        }
        getNode(t) {
            let e = this.findNode(t);
            return null === e && (e = new xr(t), this.add(e)), e;
        }
        addEdge(t) {
            if (t.isEmpty()) return null;
            const e = W.removeRepeatedPoints(t.getCoordinates());
            if (e.length <= 1) return null;
            const s = e[0], n = e[e.length - 1], i = this.getNode(s), r = this.getNode(n), o = new mr(i, r, e[1], !0), l = new mr(r, i, e[e.length - 2], !1), a = new Er(t);
            a.setDirectedEdges(o, l), this.add(a);
        }
    }
    class Cr {
        constructor(){
            Cr.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._graph = new wr, this._mergedLineStrings = null, this._factory = null, this._edgeStrings = null;
        }
        buildEdgeStringsForUnprocessedNodes() {
            for(let t = this._graph.getNodes().iterator(); t.hasNext();){
                const e = t.next();
                e.isMarked() || (h.isTrue(2 === e.getDegree()), this.buildEdgeStringsStartingAt(e), e.setMarked(!0));
            }
        }
        buildEdgeStringsForNonDegree2Nodes() {
            for(let t = this._graph.getNodes().iterator(); t.hasNext();){
                const e = t.next();
                2 !== e.getDegree() && (this.buildEdgeStringsStartingAt(e), e.setMarked(!0));
            }
        }
        buildEdgeStringsStartingAt(t) {
            for(let e = t.getOutEdges().iterator(); e.hasNext();){
                const t = e.next();
                t.getEdge().isMarked() || this._edgeStrings.add(this.buildEdgeStringStartingWith(t));
            }
        }
        merge() {
            if (null !== this._mergedLineStrings) return null;
            _r.setMarked(this._graph.nodeIterator(), !1), _r.setMarked(this._graph.edgeIterator(), !1), this._edgeStrings = new L, this.buildEdgeStringsForObviousStartNodes(), this.buildEdgeStringsForIsolatedLoops(), this._mergedLineStrings = new L;
            for(let t = this._edgeStrings.iterator(); t.hasNext();){
                const e = t.next();
                this._mergedLineStrings.add(e.toLineString());
            }
        }
        addLineString(t) {
            null === this._factory && (this._factory = t.getFactory()), this._graph.addEdge(t);
        }
        buildEdgeStringStartingWith(t) {
            const e = new dr(this._factory);
            let s = t;
            do e.add(s), s.getEdge().setMarked(!0), s = s.getNext();
            while (null !== s && s !== t);
            return e;
        }
        add() {
            if (arguments[0] instanceof j) {
                const t = arguments[0];
                for(let e = 0; e < t.getNumGeometries(); e++){
                    const s = t.getGeometryN(e);
                    s instanceof tt && this.addLineString(s);
                }
            } else if (I(arguments[0], N)) {
                const t = arguments[0];
                this._mergedLineStrings = null;
                for(let e = t.iterator(); e.hasNext();){
                    const t = e.next();
                    this.add(t);
                }
            }
        }
        buildEdgeStringsForIsolatedLoops() {
            this.buildEdgeStringsForUnprocessedNodes();
        }
        buildEdgeStringsForObviousStartNodes() {
            this.buildEdgeStringsForNonDegree2Nodes();
        }
        getMergedLineStrings() {
            return this.merge(), this._mergedLineStrings;
        }
    }
    class Sr {
        constructor(){
            Sr.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._parentGraph = null, this._edges = new pt, this._dirEdges = new L, this._nodeMap = new Ir;
            const t = arguments[0];
            this._parentGraph = t;
        }
        dirEdgeIterator() {
            return this._dirEdges.iterator();
        }
        edgeIterator() {
            return this._edges.iterator();
        }
        getParent() {
            return this._parentGraph;
        }
        nodeIterator() {
            return this._nodeMap.iterator();
        }
        contains(t) {
            return this._edges.contains(t);
        }
        add(t) {
            if (this._edges.contains(t)) return null;
            this._edges.add(t), this._dirEdges.add(t.getDirEdge(0)), this._dirEdges.add(t.getDirEdge(1)), this._nodeMap.add(t.getDirEdge(0).getFromNode()), this._nodeMap.add(t.getDirEdge(1).getFromNode());
        }
    }
    class Lr {
        constructor(){
            Lr.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._graph = null;
            const t = arguments[0];
            this._graph = t;
        }
        findSubgraph(t) {
            const e = new Sr(this._graph);
            return this.addReachable(t, e), e;
        }
        addEdges(t, e, s) {
            t.setVisited(!0);
            for(let n = t.getOutEdges().iterator(); n.hasNext();){
                const t = n.next();
                s.add(t.getEdge());
                const i = t.getToNode();
                i.isVisited() || e.push(i);
            }
        }
        addReachable(t, e) {
            const s = new Zs;
            for(s.add(t); !s.empty();){
                const t = s.pop();
                this.addEdges(t, s, e);
            }
        }
        getConnectedSubgraphs() {
            const t = new L;
            _r.setVisited(this._graph.nodeIterator(), !1);
            for(let e = this._graph.edgeIterator(); e.hasNext();){
                const s = e.next().getDirEdge(0).getFromNode();
                s.isVisited() || t.add(this.findSubgraph(s));
            }
            return t;
        }
    }
    class Tr {
        constructor(){
            Tr.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._graph = new wr, this._factory = new Lt, this._lineCount = 0, this._isRun = !1, this._sequencedGeometry = null, this._isSequenceable = !1;
        }
        static findUnvisitedBestOrientedDE(t) {
            let e = null, s = null;
            for(let n = t.getOutEdges().iterator(); n.hasNext();){
                const t = n.next();
                t.getEdge().isVisited() || (s = t, t.getEdgeDirection() && (e = t));
            }
            return null !== e ? e : s;
        }
        static findLowestDegreeNode(t) {
            let e = M.MAX_VALUE, s = null;
            for(let n = t.nodeIterator(); n.hasNext();){
                const t = n.next();
                (null === s || t.getDegree() < e) && (e = t.getDegree(), s = t);
            }
            return s;
        }
        static isSequenced(t) {
            if (!(t instanceof Et)) return !0;
            const e = t, s = new at;
            let n = null;
            const i = new L;
            for(let t = 0; t < e.getNumGeometries(); t++){
                const r = e.getGeometryN(t), o = r.getCoordinateN(0), l = r.getCoordinateN(r.getNumPoints() - 1);
                if (s.contains(o)) return !1;
                if (s.contains(l)) return !1;
                null !== n && (o.equals(n) || (s.addAll(i), i.clear())), i.add(o), i.add(l), n = l;
            }
            return !0;
        }
        static reverse(t) {
            const e = t.getCoordinates(), s = new Array(e.length).fill(null), n = e.length;
            for(let t = 0; t < n; t++)s[n - 1 - t] = new m(e[t]);
            return t.getFactory().createLineString(s);
        }
        static sequence(t) {
            const e = new Tr;
            return e.add(t), e.getSequencedLineStrings();
        }
        computeSequence() {
            if (this._isRun) return null;
            this._isRun = !0;
            const t = this.findSequences();
            if (null === t) return null;
            this._sequencedGeometry = this.buildSequencedGeometry(t), this._isSequenceable = !0;
            const e = this._sequencedGeometry.getNumGeometries();
            h.isTrue(this._lineCount === e, "Lines were missing from result"), h.isTrue(this._sequencedGeometry instanceof tt || this._sequencedGeometry instanceof Et, "Result is not lineal");
        }
        findSequences() {
            const t = new L;
            for(let e = new Lr(this._graph).getConnectedSubgraphs().iterator(); e.hasNext();){
                const s = e.next();
                if (!this.hasSequence(s)) return null;
                {
                    const e = this.findSequence(s);
                    t.add(e);
                }
            }
            return t;
        }
        addReverseSubpath(t, e, s) {
            const n = t.getToNode();
            let i = null;
            for(;;){
                e.add(t.getSym()), t.getEdge().setVisited(!0), i = t.getFromNode();
                const s = Tr.findUnvisitedBestOrientedDE(i);
                if (null === s) break;
                t = s.getSym();
            }
            s && h.isTrue(i === n, "path not contiguous");
        }
        findSequence(t) {
            _r.setVisited(t.edgeIterator(), !1);
            const e = Tr.findLowestDegreeNode(t).getOutEdges().iterator().next().getSym(), s = new Ks, n = s.listIterator();
            for(this.addReverseSubpath(e, n, !1); n.hasPrevious();){
                const t = n.previous(), e = Tr.findUnvisitedBestOrientedDE(t.getFromNode());
                null !== e && this.addReverseSubpath(e.getSym(), n, !0);
            }
            return this.orient(s);
        }
        reverse(t) {
            const e = new Ks;
            for(let s = t.iterator(); s.hasNext();){
                const t = s.next();
                e.addFirst(t.getSym());
            }
            return e;
        }
        add() {
            if (I(arguments[0], N)) for(let t = arguments[0].iterator(); t.hasNext();){
                const e = t.next();
                this.add(e);
            }
            else if (arguments[0] instanceof j) arguments[0].apply(new class {
                get interfaces_() {
                    return [
                        X
                    ];
                }
                filter(t) {
                    t instanceof tt && this.addLine(t);
                }
            });
        }
        addLine(t) {
            null === this._factory && (this._factory = t.getFactory()), this._graph.addEdge(t), this._lineCount++;
        }
        hasSequence(t) {
            let e = 0;
            for(let s = t.nodeIterator(); s.hasNext();)s.next().getDegree() % 2 == 1 && e++;
            return e <= 2;
        }
        orient(t) {
            const e = t.get(0), s = t.get(t.size() - 1), n = e.getFromNode(), i = s.getToNode();
            let r = !1;
            if (1 === n.getDegree() || 1 === i.getDegree()) {
                let t = !1;
                1 === s.getToNode().getDegree() && !1 === s.getEdgeDirection() && (t = !0, r = !0), 1 === e.getFromNode().getDegree() && !0 === e.getEdgeDirection() && (t = !0, r = !1), t || 1 === e.getFromNode().getDegree() && (r = !0);
            }
            return r ? this.reverse(t) : t;
        }
        buildSequencedGeometry(t) {
            const e = new L;
            for(let s = t.iterator(); s.hasNext();)for(let t = s.next().iterator(); t.hasNext();){
                const s = t.next(), n = s.getEdge().getLine();
                let i = n;
                s.getEdgeDirection() || n.isClosed() || (i = Tr.reverse(n)), e.add(i);
            }
            return 0 === e.size() ? this._factory.createMultiLineString(new Array(0).fill(null)) : this._factory.buildGeometry(e);
        }
        getSequencedLineStrings() {
            return this.computeSequence(), this._sequencedGeometry;
        }
        isSequenceable() {
            return this.computeSequence(), this._isSequenceable;
        }
    }
    var Rr = Object.freeze({
        __proto__: null,
        LineMerger: Cr,
        LineSequencer: Tr
    }), Pr = Object.freeze({
        __proto__: null,
        GeometrySnapper: An,
        LineStringSnapper: Dn
    }), Or = Object.freeze({
        __proto__: null,
        OverlayOp: oi,
        snap: Pr
    });
    class vr {
        constructor(){
            vr.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._geometryFactory = new Lt, this._geomGraph = null, this._disconnectedRingcoord = null;
            const t = arguments[0];
            this._geomGraph = t;
        }
        static findDifferentPoint(t, e) {
            for(let s = 0; s < t.length; s++)if (!t[s].equals(e)) return t[s];
            return null;
        }
        visitInteriorRing(t, e) {
            if (t.isEmpty()) return null;
            const s = t.getCoordinates(), n = s[0], i = vr.findDifferentPoint(s, n), r = e.findEdgeInSameDirection(n, i), o = e.findEdgeEnd(r);
            let l = null;
            o.getLabel().getLocation(0, Hs.RIGHT) === Qt.INTERIOR ? l = o : o.getSym().getLabel().getLocation(0, Hs.RIGHT) === Qt.INTERIOR && (l = o.getSym()), h.isTrue(null !== l, "unable to find dirEdge with Interior on RHS"), this.visitLinkedDirectedEdges(l);
        }
        visitShellInteriors(t, e) {
            if (t instanceof Ct) {
                const s = t;
                this.visitInteriorRing(s.getExteriorRing(), e);
            }
            if (t instanceof dt) {
                const s = t;
                for(let t = 0; t < s.getNumGeometries(); t++){
                    const n = s.getGeometryN(t);
                    this.visitInteriorRing(n.getExteriorRing(), e);
                }
            }
        }
        getCoordinate() {
            return this._disconnectedRingcoord;
        }
        setInteriorEdgesInResult(t) {
            for(let e = t.getEdgeEnds().iterator(); e.hasNext();){
                const t = e.next();
                t.getLabel().getLocation(0, Hs.RIGHT) === Qt.INTERIOR && t.setInResult(!0);
            }
        }
        visitLinkedDirectedEdges(t) {
            const e = t;
            let s = t;
            do h.isTrue(null !== s, "found null Directed Edge"), s.setVisited(!0), s = s.getNext();
            while (s !== e);
        }
        buildEdgeRings(t) {
            const e = new L;
            for(let s = t.iterator(); s.hasNext();){
                const t = s.next();
                if (t.isInResult() && null === t.getEdgeRing()) {
                    const s = new _n(t, this._geometryFactory);
                    s.linkDirectedEdgesForMinimalEdgeRings();
                    const n = s.buildMinimalRings();
                    e.addAll(n);
                }
            }
            return e;
        }
        hasUnvisitedShellEdge(t) {
            for(let e = 0; e < t.size(); e++){
                const s = t.get(e);
                if (s.isHole()) continue;
                const n = s.getEdges();
                let i = n.get(0);
                if (i.getLabel().getLocation(0, Hs.RIGHT) === Qt.INTERIOR) {
                    for(let t = 0; t < n.size(); t++)if (i = n.get(t), !i.isVisited()) return this._disconnectedRingcoord = i.getCoordinate(), !0;
                }
            }
            return !1;
        }
        isInteriorsConnected() {
            const t = new L;
            this._geomGraph.computeSplitEdges(t);
            const e = new un(new In);
            e.addEdges(t), this.setInteriorEdgesInResult(e), e.linkResultDirectedEdges();
            const s = this.buildEdgeRings(e.getEdgeEnds());
            return this.visitShellInteriors(this._geomGraph.getGeometry(), e), !this.hasUnvisitedShellEdge(s);
        }
    }
    class Mr {
        computeEdgeEnds() {
            if (1 === arguments.length) {
                const t = arguments[0], e = new L;
                for(let s = t; s.hasNext();){
                    const t = s.next();
                    this.computeEdgeEnds(t, e);
                }
                return e;
            }
            if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = t.getEdgeIntersectionList();
                s.addEndpoints();
                const n = s.iterator();
                let i = null, r = null;
                if (!n.hasNext()) return null;
                let o = n.next();
                do i = r, r = o, o = null, n.hasNext() && (o = n.next()), null !== r && (this.createEdgeEndForPrev(t, e, r, i), this.createEdgeEndForNext(t, e, r, o));
                while (null !== r);
            }
        }
        createEdgeEndForNext(t, e, s, n) {
            const i = s.segmentIndex + 1;
            if (i >= t.getNumPoints() && null === n) return null;
            let r = t.getCoordinate(i);
            null !== n && n.segmentIndex === s.segmentIndex && (r = n.coord);
            const o = new cn(t, s.coord, r, new nn(t.getLabel()));
            e.add(o);
        }
        createEdgeEndForPrev(t, e, s, n) {
            let i = s.segmentIndex;
            if (0 === s.dist) {
                if (0 === i) return null;
                i--;
            }
            let r = t.getCoordinate(i);
            null !== n && n.segmentIndex >= i && (r = n.coord);
            const o = new nn(t.getLabel());
            o.flip();
            const l = new cn(t, s.coord, r, o);
            e.add(l);
        }
    }
    class br extends cn {
        constructor(){
            super(), br.constructor_.apply(this, arguments);
        }
        static constructor_() {
            if (this._edgeEnds = new L, 1 === arguments.length) {
                const t = arguments[0];
                br.constructor_.call(this, null, t);
            } else if (2 === arguments.length) {
                const t = arguments[1];
                cn.constructor_.call(this, t.getEdge(), t.getCoordinate(), t.getDirectedCoordinate(), new nn(t.getLabel())), this.insert(t);
            }
        }
        insert(t) {
            this._edgeEnds.add(t);
        }
        print(t) {
            t.println("EdgeEndBundle--\x3e Label: " + this._label);
            for(let e = this.iterator(); e.hasNext();)e.next().print(t), t.println();
        }
        iterator() {
            return this._edgeEnds.iterator();
        }
        getEdgeEnds() {
            return this._edgeEnds;
        }
        computeLabelOn(t, e) {
            let s = 0, n = !1;
            for(let e = this.iterator(); e.hasNext();){
                const i = e.next().getLabel().getLocation(t);
                i === Qt.BOUNDARY && s++, i === Qt.INTERIOR && (n = !0);
            }
            let i = Qt.NONE;
            n && (i = Qt.INTERIOR), s > 0 && (i = ii.determineBoundary(e, s)), this._label.setLocation(t, i);
        }
        computeLabelSide(t, e) {
            for(let s = this.iterator(); s.hasNext();){
                const n = s.next();
                if (n.getLabel().isArea()) {
                    const s = n.getLabel().getLocation(t, e);
                    if (s === Qt.INTERIOR) return this._label.setLocation(t, e, Qt.INTERIOR), null;
                    s === Qt.EXTERIOR && this._label.setLocation(t, e, Qt.EXTERIOR);
                }
            }
        }
        getLabel() {
            return this._label;
        }
        computeLabelSides(t) {
            this.computeLabelSide(t, Hs.LEFT), this.computeLabelSide(t, Hs.RIGHT);
        }
        updateIM(t) {
            vn.updateIM(this._label, t);
        }
        computeLabel(t) {
            let e = !1;
            for(let t = this.iterator(); t.hasNext();)t.next().getLabel().isArea() && (e = !0);
            this._label = e ? new nn(Qt.NONE, Qt.NONE, Qt.NONE) : new nn(Qt.NONE);
            for(let s = 0; s < 2; s++)this.computeLabelOn(s, t), e && this.computeLabelSides(s);
        }
    }
    class Dr extends xn {
        constructor(){
            super();
        }
        updateIM(t) {
            for(let e = this.iterator(); e.hasNext();)e.next().updateIM(t);
        }
        insert(t) {
            let e = this._edgeMap.get(t);
            null === e ? (e = new br(t), this.insertEdgeEnd(t, e)) : e.insert(t);
        }
    }
    class Ar extends on {
        constructor(){
            super(), Ar.constructor_.apply(this, arguments);
        }
        static constructor_() {
            const t = arguments[0], e = arguments[1];
            on.constructor_.call(this, t, e);
        }
        computeIM(t) {
            t.setAtLeastIfValid(this._label.getLocation(0), this._label.getLocation(1), 0);
        }
        updateIMFromEdges(t) {
            this._edges.updateIM(t);
        }
    }
    class Fr extends an {
        constructor(){
            super();
        }
        createNode(t) {
            return new Ar(t, new Dr);
        }
    }
    class Gr {
        constructor(){
            Gr.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._nodes = new ln(new Fr);
        }
        insertEdgeEnds(t) {
            for(let e = t.iterator(); e.hasNext();){
                const t = e.next();
                this._nodes.add(t);
            }
        }
        getNodeIterator() {
            return this._nodes.iterator();
        }
        copyNodesAndLabels(t, e) {
            for(let s = t.getNodeIterator(); s.hasNext();){
                const t = s.next();
                this._nodes.addNode(t.getCoordinate()).setLabel(e, t.getLabel().getLocation(e));
            }
        }
        build(t) {
            this.computeIntersectionNodes(t, 0), this.copyNodesAndLabels(t, 0);
            const e = (new Mr).computeEdgeEnds(t.getEdgeIterator());
            this.insertEdgeEnds(e);
        }
        computeIntersectionNodes(t, e) {
            for(let s = t.getEdgeIterator(); s.hasNext();){
                const t = s.next(), n = t.getLabel().getLocation(e);
                for(let s = t.getEdgeIntersectionList().iterator(); s.hasNext();){
                    const t = s.next(), i = this._nodes.addNode(t.coord);
                    n === Qt.BOUNDARY ? i.setLabelBoundary(e) : i.getLabel().isNull(e) && i.setLabel(e, Qt.INTERIOR);
                }
            }
        }
    }
    class qr {
        constructor(){
            qr.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._li = new jt, this._geomGraph = null, this._nodeGraph = new Gr, this._invalidPoint = null;
            const t = arguments[0];
            this._geomGraph = t;
        }
        isNodeEdgeAreaLabelsConsistent() {
            for(let t = this._nodeGraph.getNodeIterator(); t.hasNext();){
                const e = t.next();
                if (!e.getEdges().isAreaLabelsConsistent(this._geomGraph)) return this._invalidPoint = e.getCoordinate().copy(), !1;
            }
            return !0;
        }
        hasDuplicateRings() {
            for(let t = this._nodeGraph.getNodeIterator(); t.hasNext();)for(let e = t.next().getEdges().iterator(); e.hasNext();){
                const t = e.next();
                if (t.getEdgeEnds().size() > 1) return this._invalidPoint = t.getEdge().getCoordinate(0), !0;
            }
            return !1;
        }
        isNodeConsistentArea() {
            const t = this._geomGraph.computeSelfNodes(this._li, !0, !0);
            return t.hasProperIntersection() ? (this._invalidPoint = t.getProperIntersectionPoint(), !1) : (this._nodeGraph.build(this._geomGraph), this.isNodeEdgeAreaLabelsConsistent());
        }
        getInvalidPoint() {
            return this._invalidPoint;
        }
    }
    class Br {
        constructor(){
            Br.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._graph = null, this._rings = new L, this._totalEnv = new O, this._index = null, this._nestedPt = null;
            const t = arguments[0];
            this._graph = t;
        }
        add(t) {
            this._rings.add(t), this._totalEnv.expandToInclude(t.getEnvelopeInternal());
        }
        getNestedPoint() {
            return this._nestedPt;
        }
        buildIndex() {
            this._index = new Os;
            for(let t = 0; t < this._rings.size(); t++){
                const e = this._rings.get(t), s = e.getEnvelopeInternal();
                this._index.insert(s, e);
            }
        }
        isNonNested() {
            this.buildIndex();
            for(let t = 0; t < this._rings.size(); t++){
                const e = this._rings.get(t), s = e.getCoordinates(), n = this._index.query(e.getEnvelopeInternal());
                for(let t = 0; t < n.size(); t++){
                    const i = n.get(t), r = i.getCoordinates();
                    if (e === i) continue;
                    if (!e.getEnvelopeInternal().intersects(i.getEnvelopeInternal())) continue;
                    const o = zr.findPtNotNode(s, i, this._graph);
                    if (null === o) continue;
                    if (Ue.isInRing(o, r)) return this._nestedPt = o, !1;
                }
            }
            return !0;
        }
    }
    class Yr {
        constructor(){
            Yr.constructor_.apply(this, arguments);
        }
        static constructor_() {
            if (this._errorType = null, this._pt = null, 1 === arguments.length) {
                const t = arguments[0];
                Yr.constructor_.call(this, t, null);
            } else if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                this._errorType = t, null !== e && (this._pt = e.copy());
            }
        }
        getCoordinate() {
            return this._pt;
        }
        getMessage() {
            return Yr.errMsg[this._errorType];
        }
        toString() {
            let t = "";
            return null !== this._pt && (t = " at or near point " + this._pt), this.getMessage() + t;
        }
        getErrorType() {
            return this._errorType;
        }
    }
    Yr.ERROR = 0, Yr.REPEATED_POINT = 1, Yr.HOLE_OUTSIDE_SHELL = 2, Yr.NESTED_HOLES = 3, Yr.DISCONNECTED_INTERIOR = 4, Yr.SELF_INTERSECTION = 5, Yr.RING_SELF_INTERSECTION = 6, Yr.NESTED_SHELLS = 7, Yr.DUPLICATE_RINGS = 8, Yr.TOO_FEW_POINTS = 9, Yr.INVALID_COORDINATE = 10, Yr.RING_NOT_CLOSED = 11, Yr.errMsg = [
        "Topology Validation Error",
        "Repeated Point",
        "Hole lies outside shell",
        "Holes are nested",
        "Interior is disconnected",
        "Self-intersection",
        "Ring Self-intersection",
        "Nested shells",
        "Duplicate Rings",
        "Too few distinct points in geometry component",
        "Invalid Coordinate",
        "Ring is not closed"
    ];
    class zr {
        constructor(){
            zr.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._parentGeometry = null, this._isSelfTouchingRingFormingHoleValid = !1, this._validErr = null;
            const t = arguments[0];
            this._parentGeometry = t;
        }
        static findPtNotNode(t, e, s) {
            const n = s.findEdge(e).getEdgeIntersectionList();
            for(let e = 0; e < t.length; e++){
                const s = t[e];
                if (!n.isIntersection(s)) return s;
            }
            return null;
        }
        static isValid() {
            if (arguments[0] instanceof j) return new zr(arguments[0]).isValid();
            if (arguments[0] instanceof m) {
                const t = arguments[0];
                return !r.isNaN(t.x) && !r.isInfinite(t.x) && !r.isNaN(t.y) && !r.isInfinite(t.y);
            }
        }
        checkInvalidCoordinates() {
            if (arguments[0] instanceof Array) {
                const t = arguments[0];
                for(let e = 0; e < t.length; e++)if (!zr.isValid(t[e])) return this._validErr = new Yr(Yr.INVALID_COORDINATE, t[e]), null;
            } else if (arguments[0] instanceof Ct) {
                const t = arguments[0];
                if (this.checkInvalidCoordinates(t.getExteriorRing().getCoordinates()), null !== this._validErr) return null;
                for(let e = 0; e < t.getNumInteriorRing(); e++)if (this.checkInvalidCoordinates(t.getInteriorRingN(e).getCoordinates()), null !== this._validErr) return null;
            }
        }
        checkHolesNotNested(t, e) {
            if (t.getNumInteriorRing() <= 0) return null;
            const s = new Br(e);
            for(let e = 0; e < t.getNumInteriorRing(); e++){
                const n = t.getInteriorRingN(e);
                n.isEmpty() || s.add(n);
            }
            s.isNonNested() || (this._validErr = new Yr(Yr.NESTED_HOLES, s.getNestedPoint()));
        }
        checkConsistentArea(t) {
            const e = new qr(t);
            if (!e.isNodeConsistentArea()) return this._validErr = new Yr(Yr.SELF_INTERSECTION, e.getInvalidPoint()), null;
            e.hasDuplicateRings() && (this._validErr = new Yr(Yr.DUPLICATE_RINGS, e.getInvalidPoint()));
        }
        isValid() {
            return this.checkValid(this._parentGeometry), null === this._validErr;
        }
        checkShellInsideHole(t, e, s) {
            const n = t.getCoordinates(), i = e.getCoordinates(), r = zr.findPtNotNode(n, e, s);
            if (null !== r) {
                if (!Ue.isInRing(r, i)) return r;
            }
            const o = zr.findPtNotNode(i, t, s);
            if (null !== o) return Ue.isInRing(o, n) ? o : null;
            return h.shouldNeverReachHere("points in shell and hole appear to be equal"), null;
        }
        checkNoSelfIntersectingRings(t) {
            for(let e = t.getEdgeIterator(); e.hasNext();){
                const t = e.next();
                if (this.checkNoSelfIntersectingRing(t.getEdgeIntersectionList()), null !== this._validErr) return null;
            }
        }
        checkHolesInShell(t, e) {
            if (t.getNumInteriorRing() <= 0) return null;
            const s = t.getExteriorRing(), n = s.isEmpty(), i = new Ve(s);
            for(let r = 0; r < t.getNumInteriorRing(); r++){
                const o = t.getInteriorRingN(r);
                let l = null;
                if (o.isEmpty()) continue;
                if (l = zr.findPtNotNode(o.getCoordinates(), s, e), null === l) return null;
                if (n || Qt.EXTERIOR === i.locate(l)) return this._validErr = new Yr(Yr.HOLE_OUTSIDE_SHELL, l), null;
            }
        }
        checkShellNotNested(t, e, s) {
            const n = t.getCoordinates(), i = e.getExteriorRing();
            if (i.isEmpty()) return null;
            const r = i.getCoordinates(), o = zr.findPtNotNode(n, i, s);
            if (null === o) return null;
            if (!Ue.isInRing(o, r)) return null;
            if (e.getNumInteriorRing() <= 0) return this._validErr = new Yr(Yr.NESTED_SHELLS, o), null;
            let l = null;
            for(let n = 0; n < e.getNumInteriorRing(); n++){
                const i = e.getInteriorRingN(n);
                if (l = this.checkShellInsideHole(t, i, s), null === l) return null;
            }
            this._validErr = new Yr(Yr.NESTED_SHELLS, l);
        }
        checkClosedRings(t) {
            if (this.checkClosedRing(t.getExteriorRing()), null !== this._validErr) return null;
            for(let e = 0; e < t.getNumInteriorRing(); e++)if (this.checkClosedRing(t.getInteriorRingN(e)), null !== this._validErr) return null;
        }
        checkConnectedInteriors(t) {
            const e = new vr(t);
            e.isInteriorsConnected() || (this._validErr = new Yr(Yr.DISCONNECTED_INTERIOR, e.getCoordinate()));
        }
        checkNoSelfIntersectingRing(t) {
            const e = new at;
            let s = !0;
            for(let n = t.iterator(); n.hasNext();){
                const t = n.next();
                if (s) s = !1;
                else {
                    if (e.contains(t.coord)) return this._validErr = new Yr(Yr.RING_SELF_INTERSECTION, t.coord), null;
                    e.add(t.coord);
                }
            }
        }
        checkTooFewPoints(t) {
            if (t.hasTooFewPoints()) return this._validErr = new Yr(Yr.TOO_FEW_POINTS, t.getInvalidPoint()), null;
        }
        getValidationError() {
            return this.checkValid(this._parentGeometry), this._validErr;
        }
        checkValid() {
            if (arguments[0] instanceof Nt) {
                const t = arguments[0];
                this.checkInvalidCoordinates(t.getCoordinates());
            } else if (arguments[0] instanceof St) {
                const t = arguments[0];
                this.checkInvalidCoordinates(t.getCoordinates());
            } else if (arguments[0] instanceof et) {
                const t = arguments[0];
                if (this.checkInvalidCoordinates(t.getCoordinates()), null !== this._validErr) return null;
                if (this.checkClosedRing(t), null !== this._validErr) return null;
                const e = new ii(0, t);
                if (this.checkTooFewPoints(e), null !== this._validErr) return null;
                const s = new jt;
                e.computeSelfNodes(s, !0, !0), this.checkNoSelfIntersectingRings(e);
            } else if (arguments[0] instanceof tt) {
                const t = arguments[0];
                if (this.checkInvalidCoordinates(t.getCoordinates()), null !== this._validErr) return null;
                const e = new ii(0, t);
                this.checkTooFewPoints(e);
            } else if (arguments[0] instanceof Ct) {
                const t = arguments[0];
                if (this.checkInvalidCoordinates(t), null !== this._validErr) return null;
                if (this.checkClosedRings(t), null !== this._validErr) return null;
                const e = new ii(0, t);
                if (this.checkTooFewPoints(e), null !== this._validErr) return null;
                if (this.checkConsistentArea(e), null !== this._validErr) return null;
                if (!this._isSelfTouchingRingFormingHoleValid && (this.checkNoSelfIntersectingRings(e), null !== this._validErr)) return null;
                if (this.checkHolesInShell(t, e), null !== this._validErr) return null;
                if (this.checkHolesNotNested(t, e), null !== this._validErr) return null;
                this.checkConnectedInteriors(e);
            } else if (arguments[0] instanceof dt) {
                const t = arguments[0];
                for(let e = 0; e < t.getNumGeometries(); e++){
                    const s = t.getGeometryN(e);
                    if (this.checkInvalidCoordinates(s), null !== this._validErr) return null;
                    if (this.checkClosedRings(s), null !== this._validErr) return null;
                }
                const e = new ii(0, t);
                if (this.checkTooFewPoints(e), null !== this._validErr) return null;
                if (this.checkConsistentArea(e), null !== this._validErr) return null;
                if (!this._isSelfTouchingRingFormingHoleValid && (this.checkNoSelfIntersectingRings(e), null !== this._validErr)) return null;
                for(let s = 0; s < t.getNumGeometries(); s++){
                    const n = t.getGeometryN(s);
                    if (this.checkHolesInShell(n, e), null !== this._validErr) return null;
                }
                for(let s = 0; s < t.getNumGeometries(); s++){
                    const n = t.getGeometryN(s);
                    if (this.checkHolesNotNested(n, e), null !== this._validErr) return null;
                }
                if (this.checkShellsNotNested(t, e), null !== this._validErr) return null;
                this.checkConnectedInteriors(e);
            } else if (arguments[0] instanceof ut) {
                const t = arguments[0];
                for(let e = 0; e < t.getNumGeometries(); e++){
                    const s = t.getGeometryN(e);
                    if (this.checkValid(s), null !== this._validErr) return null;
                }
            } else if (arguments[0] instanceof j) {
                const t = arguments[0];
                if (this._validErr = null, t.isEmpty()) return null;
                if (t instanceof Nt) this.checkValid(t);
                else if (t instanceof St) this.checkValid(t);
                else if (t instanceof et) this.checkValid(t);
                else if (t instanceof tt) this.checkValid(t);
                else if (t instanceof Ct) this.checkValid(t);
                else if (t instanceof dt) this.checkValid(t);
                else {
                    if (!(t instanceof ut)) throw new U(t.getGeometryType());
                    this.checkValid(t);
                }
            }
        }
        setSelfTouchingRingFormingHoleValid(t) {
            this._isSelfTouchingRingFormingHoleValid = t;
        }
        checkClosedRing(t) {
            if (t.isEmpty()) return null;
            if (!t.isClosed()) {
                let e = null;
                t.getNumPoints() >= 1 && (e = t.getCoordinateN(0)), this._validErr = new Yr(Yr.RING_NOT_CLOSED, e);
            }
        }
        checkShellsNotNested(t, e) {
            for(let s = 0; s < t.getNumGeometries(); s++){
                const n = t.getGeometryN(s).getExteriorRing();
                for(let i = 0; i < t.getNumGeometries(); i++){
                    if (s === i) continue;
                    const r = t.getGeometryN(i);
                    if (this.checkShellNotNested(n, r, e), null !== this._validErr) return null;
                }
            }
        }
    }
    class Vr {
        constructor(){
            Vr.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._factory = null, this._deList = new L, this._lowestEdge = null, this._ring = null, this._locator = null, this._ringPts = null, this._holes = null, this._shell = null, this._isHole = null, this._isProcessed = !1, this._isIncludedSet = !1, this._isIncluded = !1;
            const t = arguments[0];
            this._factory = t;
        }
        static findEdgeRingContaining(t, e) {
            const s = t.getRing(), n = s.getEnvelopeInternal();
            let i = s.getCoordinateN(0), r = null, o = null;
            for(let t = e.iterator(); t.hasNext();){
                const e = t.next(), l = e.getRing().getEnvelopeInternal();
                if (l.equals(n)) continue;
                if (!l.contains(n)) continue;
                i = W.ptNotInList(s.getCoordinates(), e.getCoordinates());
                e.isInRing(i) && (null === r || o.contains(l)) && (r = e, o = r.getRing().getEnvelopeInternal());
            }
            return r;
        }
        static addEdge(t, e, s) {
            if (e) for(let e = 0; e < t.length; e++)s.add(t[e], !1);
            else for(let e = t.length - 1; e >= 0; e--)s.add(t[e], !1);
        }
        static findDirEdgesInRing(t) {
            let e = t;
            const s = new L;
            do s.add(e), e = e.getNext(), h.isTrue(null !== e, "found null DE in ring"), h.isTrue(e === t || !e.isInRing(), "found DE already in ring");
            while (e !== t);
            return s;
        }
        isIncluded() {
            return this._isIncluded;
        }
        getCoordinates() {
            if (null === this._ringPts) {
                const t = new R;
                for(let e = this._deList.iterator(); e.hasNext();){
                    const s = e.next(), n = s.getEdge();
                    Vr.addEdge(n.getLine().getCoordinates(), s.getEdgeDirection(), t);
                }
                this._ringPts = t.toCoordinateArray();
            }
            return this._ringPts;
        }
        build(t) {
            let e = t;
            do this.add(e), e.setRing(this), e = e.getNext(), h.isTrue(null !== e, "found null DE in ring"), h.isTrue(e === t || !e.isInRing(), "found DE already in ring");
            while (e !== t);
        }
        isInRing(t) {
            return Qt.EXTERIOR !== this.getLocator().locate(t);
        }
        addHole() {
            if (arguments[0] instanceof et) {
                const t = arguments[0];
                null === this._holes && (this._holes = new L), this._holes.add(t);
            } else if (arguments[0] instanceof Vr) {
                const t = arguments[0];
                t.setShell(this);
                const e = t.getRing();
                null === this._holes && (this._holes = new L), this._holes.add(e);
            }
        }
        computeHole() {
            const t = this.getRing();
            this._isHole = q.isCCW(t.getCoordinates());
        }
        getLocator() {
            return null === this._locator && (this._locator = new Ve(this.getRing())), this._locator;
        }
        getShell() {
            return this.isHole() ? this._shell : this;
        }
        updateIncluded() {
            if (this.isHole()) return null;
            for(let t = 0; t < this._deList.size(); t++){
                const e = this._deList.get(t).getSym().getRing().getShell();
                if (null !== e && e.isIncludedSet()) return this.setIncluded(!e.isIncluded()), null;
            }
        }
        setShell(t) {
            this._shell = t;
        }
        setProcessed(t) {
            this._isProcessed = t;
        }
        isIncludedSet() {
            return this._isIncludedSet;
        }
        isValid() {
            return this.getCoordinates(), !(this._ringPts.length <= 3) && (this.getRing(), zr.isValid(this._ring));
        }
        isOuterHole() {
            return !!this._isHole && !this.hasShell();
        }
        getPolygon() {
            let t = null;
            if (null !== this._holes) {
                t = new Array(this._holes.size()).fill(null);
                for(let e = 0; e < this._holes.size(); e++)t[e] = this._holes.get(e);
            }
            return this._factory.createPolygon(this._ring, t);
        }
        isHole() {
            return this._isHole;
        }
        isProcessed() {
            return this._isProcessed;
        }
        setIncluded(t) {
            this._isIncluded = t, this._isIncludedSet = !0;
        }
        getOuterHole() {
            if (this.isHole()) return null;
            for(let t = 0; t < this._deList.size(); t++){
                const e = this._deList.get(t).getSym().getRing();
                if (e.isOuterHole()) return e;
            }
            return null;
        }
        hasShell() {
            return null !== this._shell;
        }
        isOuterShell() {
            return null !== this.getOuterHole();
        }
        getLineString() {
            return this.getCoordinates(), this._factory.createLineString(this._ringPts);
        }
        toString() {
            return Wt.toLineString(new it(this.getCoordinates()));
        }
        add(t) {
            this._deList.add(t);
        }
        getRing() {
            if (null !== this._ring) return this._ring;
            this.getCoordinates(), this._ringPts.length < 3 && Y.out.println(this._ringPts);
            try {
                this._ring = this._factory.createLinearRing(this._ringPts);
            } catch (t) {
                if (!(t instanceof s)) throw t;
                Y.out.println(this._ringPts);
            }
            return this._ring;
        }
    }
    Vr.EnvelopeComparator = class {
        compare(t, e) {
            const s = e;
            return t.getRing().getEnvelope().compareTo(s.getRing().getEnvelope());
        }
        get interfaces_() {
            return [
                g
            ];
        }
    };
    class kr {
        constructor(){
            kr.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._shells = null, this._shellIndex = null;
            const t = arguments[0];
            this._shells = t, this.buildIndex();
        }
        static assignHolesToShells(t, e) {
            new kr(e).assignHolesToShells(t);
        }
        assignHolesToShells(t) {
            for(let e = t.iterator(); e.hasNext();){
                const t = e.next();
                this.assignHoleToShell(t);
            }
        }
        buildIndex() {
            this._shellIndex = new Os;
            for (const t of this._shells)this._shellIndex.insert(t.getRing().getEnvelopeInternal(), t);
        }
        queryOverlappingShells(t) {
            return this._shellIndex.query(t);
        }
        findShellContaining(t) {
            const e = t.getRing().getEnvelopeInternal(), s = this.queryOverlappingShells(e);
            return Vr.findEdgeRingContaining(t, s);
        }
        assignHoleToShell(t) {
            const e = this.findShellContaining(t);
            null !== e && e.addHole(t);
        }
    }
    class Xr extends pr {
        constructor(){
            super(), Xr.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._edgeRing = null, this._next = null, this._label = -1;
            const t = arguments[0], e = arguments[1], s = arguments[2], n = arguments[3];
            pr.constructor_.call(this, t, e, s, n);
        }
        getNext() {
            return this._next;
        }
        isInRing() {
            return null !== this._edgeRing;
        }
        setRing(t) {
            this._edgeRing = t;
        }
        setLabel(t) {
            this._label = t;
        }
        getLabel() {
            return this._label;
        }
        setNext(t) {
            this._next = t;
        }
        getRing() {
            return this._edgeRing;
        }
    }
    class Ur extends fr {
        constructor(){
            super(), Ur.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._line = null;
            const t = arguments[0];
            this._line = t;
        }
        getLine() {
            return this._line;
        }
    }
    class Hr extends Nr {
        constructor(){
            super(), Hr.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._factory = null;
            const t = arguments[0];
            this._factory = t;
        }
        static findLabeledEdgeRings(t) {
            const e = new L;
            let s = 1;
            for(let n = t.iterator(); n.hasNext();){
                const t = n.next();
                if (t.isMarked()) continue;
                if (t.getLabel() >= 0) continue;
                e.add(t);
                const i = Vr.findDirEdgesInRing(t);
                Hr.label(i, s), s++;
            }
            return e;
        }
        static getDegreeNonDeleted(t) {
            let e = 0;
            for(let s = t.getOutEdges().getEdges().iterator(); s.hasNext();)s.next().isMarked() || e++;
            return e;
        }
        static deleteAllEdges(t) {
            for(let e = t.getOutEdges().getEdges().iterator(); e.hasNext();){
                const t = e.next();
                t.setMarked(!0);
                const s = t.getSym();
                null !== s && s.setMarked(!0);
            }
        }
        static label(t, e) {
            for(let s = t.iterator(); s.hasNext();)s.next().setLabel(e);
        }
        static computeNextCWEdges(t) {
            let e = null, s = null;
            for(let n = t.getOutEdges().getEdges().iterator(); n.hasNext();){
                const t = n.next();
                if (!t.isMarked()) {
                    if (null === e && (e = t), null !== s) s.getSym().setNext(t);
                    s = t;
                }
            }
            if (null !== s) s.getSym().setNext(e);
        }
        static computeNextCCWEdges(t, e) {
            let s = null, n = null;
            const i = t.getOutEdges().getEdges();
            for(let t = i.size() - 1; t >= 0; t--){
                const r = i.get(t), o = r.getSym();
                let l = null;
                r.getLabel() === e && (l = r);
                let a = null;
                o.getLabel() === e && (a = o), null === l && null === a || (null !== a && (n = a), null !== l && (null !== n && (n.setNext(l), n = null), null === s && (s = l)));
            }
            null !== n && (h.isTrue(null !== s), n.setNext(s));
        }
        static getDegree(t, e) {
            let s = 0;
            for(let n = t.getOutEdges().getEdges().iterator(); n.hasNext();)n.next().getLabel() === e && s++;
            return s;
        }
        static findIntersectionNodes(t, e) {
            let s = t, n = null;
            do {
                const i = s.getFromNode();
                Hr.getDegree(i, e) > 1 && (null === n && (n = new L), n.add(i)), s = s.getNext(), h.isTrue(null !== s, "found null DE in ring"), h.isTrue(s === t || !s.isInRing(), "found DE already in ring");
            }while (s !== t);
            return n;
        }
        findEdgeRing(t) {
            const e = new Vr(this._factory);
            return e.build(t), e;
        }
        computeDepthParity() {
            if (0 === arguments.length) for(;;)return null;
        }
        computeNextCWEdges() {
            for(let t = this.nodeIterator(); t.hasNext();){
                const e = t.next();
                Hr.computeNextCWEdges(e);
            }
        }
        addEdge(t) {
            if (t.isEmpty()) return null;
            const e = W.removeRepeatedPoints(t.getCoordinates());
            if (e.length < 2) return null;
            const s = e[0], n = e[e.length - 1], i = this.getNode(s), r = this.getNode(n), o = new Xr(i, r, e[1], !0), l = new Xr(r, i, e[e.length - 2], !1), a = new Ur(t);
            a.setDirectedEdges(o, l), this.add(a);
        }
        deleteCutEdges() {
            this.computeNextCWEdges(), Hr.findLabeledEdgeRings(this._dirEdges);
            const t = new L;
            for(let e = this._dirEdges.iterator(); e.hasNext();){
                const s = e.next();
                if (s.isMarked()) continue;
                const n = s.getSym();
                if (s.getLabel() === n.getLabel()) {
                    s.setMarked(!0), n.setMarked(!0);
                    const e = s.getEdge();
                    t.add(e.getLine());
                }
            }
            return t;
        }
        getEdgeRings() {
            this.computeNextCWEdges(), Hr.label(this._dirEdges, -1);
            const t = Hr.findLabeledEdgeRings(this._dirEdges);
            this.convertMaximalToMinimalEdgeRings(t);
            const e = new L;
            for(let t = this._dirEdges.iterator(); t.hasNext();){
                const s = t.next();
                if (s.isMarked()) continue;
                if (s.isInRing()) continue;
                const n = this.findEdgeRing(s);
                e.add(n);
            }
            return e;
        }
        getNode(t) {
            let e = this.findNode(t);
            return null === e && (e = new xr(t), this.add(e)), e;
        }
        convertMaximalToMinimalEdgeRings(t) {
            for(let e = t.iterator(); e.hasNext();){
                const t = e.next(), s = t.getLabel(), n = Hr.findIntersectionNodes(t, s);
                if (null !== n) for(let t = n.iterator(); t.hasNext();){
                    const e = t.next();
                    Hr.computeNextCCWEdges(e, s);
                }
            }
        }
        deleteDangles() {
            const t = this.findNodesOfDegree(1), e = new pt, s = new Zs;
            for(let e = t.iterator(); e.hasNext();)s.push(e.next());
            for(; !s.isEmpty();){
                const t = s.pop();
                Hr.deleteAllEdges(t);
                for(let n = t.getOutEdges().getEdges().iterator(); n.hasNext();){
                    const t = n.next();
                    t.setMarked(!0);
                    const i = t.getSym();
                    null !== i && i.setMarked(!0);
                    const r = t.getEdge();
                    e.add(r.getLine());
                    const o = t.getToNode();
                    1 === Hr.getDegreeNonDeleted(o) && s.push(o);
                }
            }
            return e;
        }
    }
    class Wr {
        constructor(){
            Wr.constructor_.apply(this, arguments);
        }
        static constructor_() {
            if (this._lineStringAdder = new Zr(this), this._graph = null, this._dangles = new L, this._cutEdges = new L, this._invalidRingLines = new L, this._holeList = null, this._shellList = null, this._polyList = null, this._isCheckingRingsValid = !0, this._extractOnlyPolygonal = null, this._geomFactory = null, 0 === arguments.length) Wr.constructor_.call(this, !1);
            else if (1 === arguments.length) {
                const t = arguments[0];
                this._extractOnlyPolygonal = t;
            }
        }
        static findOuterShells(t) {
            for(let e = t.iterator(); e.hasNext();){
                const t = e.next(), s = t.getOuterHole();
                null === s || s.isProcessed() || (t.setIncluded(!0), s.setProcessed(!0));
            }
        }
        static extractPolygons(t, e) {
            const s = new L;
            for(let n = t.iterator(); n.hasNext();){
                const t = n.next();
                (e || t.isIncluded()) && s.add(t.getPolygon());
            }
            return s;
        }
        static findDisjointShells(t) {
            Wr.findOuterShells(t);
            let e = null;
            do {
                e = !1;
                for(let s = t.iterator(); s.hasNext();){
                    const t = s.next();
                    t.isIncludedSet() || (t.updateIncluded(), t.isIncludedSet() || (e = !0));
                }
            }while (e);
        }
        getGeometry() {
            return null === this._geomFactory && (this._geomFactory = new Lt), this.polygonize(), this._extractOnlyPolygonal ? this._geomFactory.buildGeometry(this._polyList) : this._geomFactory.createGeometryCollection(Lt.toGeometryArray(this._polyList));
        }
        getInvalidRingLines() {
            return this.polygonize(), this._invalidRingLines;
        }
        findValidRings(t, e, s) {
            for(let n = t.iterator(); n.hasNext();){
                const t = n.next();
                t.isValid() ? e.add(t) : s.add(t.getLineString());
            }
        }
        polygonize() {
            if (null !== this._polyList) return null;
            if (this._polyList = new L, null === this._graph) return null;
            this._dangles = this._graph.deleteDangles(), this._cutEdges = this._graph.deleteCutEdges();
            const t = this._graph.getEdgeRings();
            let e = new L;
            this._invalidRingLines = new L, this._isCheckingRingsValid ? this.findValidRings(t, e, this._invalidRingLines) : e = t, this.findShellsAndHoles(e), kr.assignHolesToShells(this._holeList, this._shellList), xe.sort(this._shellList, new Vr.EnvelopeComparator);
            let s = !0;
            this._extractOnlyPolygonal && (Wr.findDisjointShells(this._shellList), s = !1), this._polyList = Wr.extractPolygons(this._shellList, s);
        }
        getDangles() {
            return this.polygonize(), this._dangles;
        }
        add() {
            if (I(arguments[0], N)) for(let t = arguments[0].iterator(); t.hasNext();){
                const e = t.next();
                this.add(e);
            }
            else if (arguments[0] instanceof tt) {
                const t = arguments[0];
                this._geomFactory = t.getFactory(), null === this._graph && (this._graph = new Hr(this._geomFactory)), this._graph.addEdge(t);
            } else if (arguments[0] instanceof j) arguments[0].apply(this._lineStringAdder);
        }
        setCheckRingsValid(t) {
            this._isCheckingRingsValid = t;
        }
        findShellsAndHoles(t) {
            this._holeList = new L, this._shellList = new L;
            for(let e = t.iterator(); e.hasNext();){
                const t = e.next();
                t.computeHole(), t.isHole() ? this._holeList.add(t) : this._shellList.add(t);
            }
        }
        getCutEdges() {
            return this.polygonize(), this._cutEdges;
        }
        getPolygons() {
            return this.polygonize(), this._polyList;
        }
    }
    class Zr {
        constructor(){
            Zr.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this.p = null;
            const t = arguments[0];
            this.p = t;
        }
        filter(t) {
            t instanceof tt && this.p.add(t);
        }
        get interfaces_() {
            return [
                X
            ];
        }
    }
    Wr.LineStringAdder = Zr;
    var jr = Object.freeze({
        __proto__: null,
        Polygonizer: Wr
    });
    class Kr {
        constructor(){
            Kr.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._li = new jt, this._ptLocator = new Zn, this._arg = null, this._nodes = new ln(new Fr), this._im = null, this._isolatedEdges = new L, this._invalidPoint = null;
            const t = arguments[0];
            this._arg = t;
        }
        insertEdgeEnds(t) {
            for(let e = t.iterator(); e.hasNext();){
                const t = e.next();
                this._nodes.add(t);
            }
        }
        computeProperIntersectionIM(t, e) {
            const s = this._arg[0].getGeometry().getDimension(), n = this._arg[1].getGeometry().getDimension(), i = t.hasProperIntersection(), r = t.hasProperInteriorIntersection();
            2 === s && 2 === n ? i && e.setAtLeast("212101212") : 2 === s && 1 === n ? (i && e.setAtLeast("FFF0FFFF2"), r && e.setAtLeast("1FFFFF1FF")) : 1 === s && 2 === n ? (i && e.setAtLeast("F0FFFFFF2"), r && e.setAtLeast("1F1FFFFFF")) : 1 === s && 1 === n && r && e.setAtLeast("0FFFFFFFF");
        }
        labelIsolatedEdges(t, e) {
            for(let s = this._arg[t].getEdgeIterator(); s.hasNext();){
                const t = s.next();
                t.isIsolated() && (this.labelIsolatedEdge(t, e, this._arg[e].getGeometry()), this._isolatedEdges.add(t));
            }
        }
        labelIsolatedEdge(t, e, s) {
            if (s.getDimension() > 0) {
                const n = this._ptLocator.locate(t.getCoordinate(), s);
                t.getLabel().setAllLocations(e, n);
            } else t.getLabel().setAllLocations(e, Qt.EXTERIOR);
        }
        computeIM() {
            const t = new Jt;
            if (t.set(Qt.EXTERIOR, Qt.EXTERIOR, 2), !this._arg[0].getGeometry().getEnvelopeInternal().intersects(this._arg[1].getGeometry().getEnvelopeInternal())) return this.computeDisjointIM(t), t;
            this._arg[0].computeSelfNodes(this._li, !1), this._arg[1].computeSelfNodes(this._li, !1);
            const e = this._arg[0].computeEdgeIntersections(this._arg[1], this._li, !1);
            this.computeIntersectionNodes(0), this.computeIntersectionNodes(1), this.copyNodesAndLabels(0), this.copyNodesAndLabels(1), this.labelIsolatedNodes(), this.computeProperIntersectionIM(e, t);
            const s = new Mr, n = s.computeEdgeEnds(this._arg[0].getEdgeIterator());
            this.insertEdgeEnds(n);
            const i = s.computeEdgeEnds(this._arg[1].getEdgeIterator());
            return this.insertEdgeEnds(i), this.labelNodeEdges(), this.labelIsolatedEdges(0, 1), this.labelIsolatedEdges(1, 0), this.updateIM(t), t;
        }
        labelNodeEdges() {
            for(let t = this._nodes.iterator(); t.hasNext();)t.next().getEdges().computeLabelling(this._arg);
        }
        copyNodesAndLabels(t) {
            for(let e = this._arg[t].getNodeIterator(); e.hasNext();){
                const s = e.next();
                this._nodes.addNode(s.getCoordinate()).setLabel(t, s.getLabel().getLocation(t));
            }
        }
        labelIntersectionNodes(t) {
            for(let e = this._arg[t].getEdgeIterator(); e.hasNext();){
                const s = e.next(), n = s.getLabel().getLocation(t);
                for(let e = s.getEdgeIntersectionList().iterator(); e.hasNext();){
                    const s = e.next(), i = this._nodes.find(s.coord);
                    i.getLabel().isNull(t) && (n === Qt.BOUNDARY ? i.setLabelBoundary(t) : i.setLabel(t, Qt.INTERIOR));
                }
            }
        }
        labelIsolatedNode(t, e) {
            const s = this._ptLocator.locate(t.getCoordinate(), this._arg[e].getGeometry());
            t.getLabel().setAllLocations(e, s);
        }
        computeIntersectionNodes(t) {
            for(let e = this._arg[t].getEdgeIterator(); e.hasNext();){
                const s = e.next(), n = s.getLabel().getLocation(t);
                for(let e = s.getEdgeIntersectionList().iterator(); e.hasNext();){
                    const s = e.next(), i = this._nodes.addNode(s.coord);
                    n === Qt.BOUNDARY ? i.setLabelBoundary(t) : i.getLabel().isNull(t) && i.setLabel(t, Qt.INTERIOR);
                }
            }
        }
        labelIsolatedNodes() {
            for(let t = this._nodes.iterator(); t.hasNext();){
                const e = t.next(), s = e.getLabel();
                h.isTrue(s.getGeometryCount() > 0, "node with empty label found"), e.isIsolated() && (s.isNull(0) ? this.labelIsolatedNode(e, 0) : this.labelIsolatedNode(e, 1));
            }
        }
        updateIM(t) {
            for(let e = this._isolatedEdges.iterator(); e.hasNext();)e.next().updateIM(t);
            for(let e = this._nodes.iterator(); e.hasNext();){
                const s = e.next();
                s.updateIM(t), s.updateIMFromEdges(t);
            }
        }
        computeDisjointIM(t) {
            const e = this._arg[0].getGeometry();
            e.isEmpty() || (t.set(Qt.INTERIOR, Qt.EXTERIOR, e.getDimension()), t.set(Qt.BOUNDARY, Qt.EXTERIOR, e.getBoundaryDimension()));
            const s = this._arg[1].getGeometry();
            s.isEmpty() || (t.set(Qt.EXTERIOR, Qt.INTERIOR, s.getDimension()), t.set(Qt.EXTERIOR, Qt.BOUNDARY, s.getBoundaryDimension()));
        }
    }
    class Qr {
        constructor(){
            Qr.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._rectEnv = null;
            const t = arguments[0];
            this._rectEnv = t.getEnvelopeInternal();
        }
        static contains(t, e) {
            return new Qr(t).contains(e);
        }
        isContainedInBoundary(t) {
            if (t instanceof Ct) return !1;
            if (t instanceof Nt) return this.isPointContainedInBoundary(t);
            if (t instanceof tt) return this.isLineStringContainedInBoundary(t);
            for(let e = 0; e < t.getNumGeometries(); e++){
                const s = t.getGeometryN(e);
                if (!this.isContainedInBoundary(s)) return !1;
            }
            return !0;
        }
        isLineSegmentContainedInBoundary(t, e) {
            if (t.equals(e)) return this.isPointContainedInBoundary(t);
            if (t.x === e.x) {
                if (t.x === this._rectEnv.getMinX() || t.x === this._rectEnv.getMaxX()) return !0;
            } else if (t.y === e.y && (t.y === this._rectEnv.getMinY() || t.y === this._rectEnv.getMaxY())) return !0;
            return !1;
        }
        isLineStringContainedInBoundary(t) {
            const e = t.getCoordinateSequence(), s = new m, n = new m;
            for(let t = 0; t < e.size() - 1; t++)if (e.getCoordinate(t, s), e.getCoordinate(t + 1, n), !this.isLineSegmentContainedInBoundary(s, n)) return !1;
            return !0;
        }
        isPointContainedInBoundary() {
            if (arguments[0] instanceof Nt) {
                const t = arguments[0];
                return this.isPointContainedInBoundary(t.getCoordinate());
            }
            if (arguments[0] instanceof m) {
                const t = arguments[0];
                return t.x === this._rectEnv.getMinX() || t.x === this._rectEnv.getMaxX() || t.y === this._rectEnv.getMinY() || t.y === this._rectEnv.getMaxY();
            }
        }
        contains(t) {
            return !!this._rectEnv.contains(t.getEnvelopeInternal()) && !this.isContainedInBoundary(t);
        }
    }
    class Jr {
        constructor(){
            Jr.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._li = new jt, this._rectEnv = null, this._diagUp0 = null, this._diagUp1 = null, this._diagDown0 = null, this._diagDown1 = null;
            const t = arguments[0];
            this._rectEnv = t, this._diagUp0 = new m(t.getMinX(), t.getMinY()), this._diagUp1 = new m(t.getMaxX(), t.getMaxY()), this._diagDown0 = new m(t.getMinX(), t.getMaxY()), this._diagDown1 = new m(t.getMaxX(), t.getMinY());
        }
        intersects(t, e) {
            const s = new O(t, e);
            if (!this._rectEnv.intersects(s)) return !1;
            if (this._rectEnv.intersects(t)) return !0;
            if (this._rectEnv.intersects(e)) return !0;
            if (t.compareTo(e) > 0) {
                const s = t;
                t = e, e = s;
            }
            let n = !1;
            return e.y > t.y && (n = !0), n ? this._li.computeIntersection(t, e, this._diagDown0, this._diagDown1) : this._li.computeIntersection(t, e, this._diagUp0, this._diagUp1), !!this._li.hasIntersection();
        }
    }
    class $r {
        constructor(){
            $r.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._rectangle = null, this._rectEnv = null;
            const t = arguments[0];
            this._rectangle = t, this._rectEnv = t.getEnvelopeInternal();
        }
        static intersects(t, e) {
            return new $r(t).intersects(e);
        }
        intersects(t) {
            if (!this._rectEnv.intersects(t.getEnvelopeInternal())) return !1;
            const e = new to(this._rectEnv);
            if (e.applyTo(t), e.intersects()) return !0;
            const s = new eo(this._rectangle);
            if (s.applyTo(t), s.containsPoint()) return !0;
            const n = new so(this._rectangle);
            return n.applyTo(t), !!n.intersects();
        }
    }
    class to extends Ne {
        constructor(){
            super(), to.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._rectEnv = null, this._intersects = !1;
            const t = arguments[0];
            this._rectEnv = t;
        }
        intersects() {
            return this._intersects;
        }
        visit(t) {
            const e = t.getEnvelopeInternal();
            return this._rectEnv.intersects(e) ? this._rectEnv.contains(e) || e.getMinX() >= this._rectEnv.getMinX() && e.getMaxX() <= this._rectEnv.getMaxX() || e.getMinY() >= this._rectEnv.getMinY() && e.getMaxY() <= this._rectEnv.getMaxY() ? (this._intersects = !0, null) : void 0 : null;
        }
        isDone() {
            return !0 === this._intersects;
        }
    }
    class eo extends Ne {
        constructor(){
            super(), eo.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._rectSeq = null, this._rectEnv = null, this._containsPoint = !1;
            const t = arguments[0];
            this._rectSeq = t.getExteriorRing().getCoordinateSequence(), this._rectEnv = t.getEnvelopeInternal();
        }
        visit(t) {
            if (!(t instanceof Ct)) return null;
            const e = t.getEnvelopeInternal();
            if (!this._rectEnv.intersects(e)) return null;
            const s = new m;
            for(let n = 0; n < 4; n++)if (this._rectSeq.getCoordinate(n, s), e.contains(s) && Ze.containsPointInPolygon(s, t)) return this._containsPoint = !0, null;
        }
        containsPoint() {
            return this._containsPoint;
        }
        isDone() {
            return !0 === this._containsPoint;
        }
    }
    class so extends Ne {
        constructor(){
            super(), so.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._rectEnv = null, this._rectIntersector = null, this._hasIntersection = !1, this._p0 = new m, this._p1 = new m;
            const t = arguments[0];
            this._rectEnv = t.getEnvelopeInternal(), this._rectIntersector = new Jr(this._rectEnv);
        }
        intersects() {
            return this._hasIntersection;
        }
        isDone() {
            return !0 === this._hasIntersection;
        }
        visit(t) {
            const e = t.getEnvelopeInternal();
            if (!this._rectEnv.intersects(e)) return null;
            const s = ye.getLines(t);
            this.checkIntersectionWithLineStrings(s);
        }
        checkIntersectionWithLineStrings(t) {
            for(let e = t.iterator(); e.hasNext();){
                const t = e.next();
                if (this.checkIntersectionWithSegments(t), this._hasIntersection) return null;
            }
        }
        checkIntersectionWithSegments(t) {
            const e = t.getCoordinateSequence();
            for(let t = 1; t < e.size(); t++)if (e.getCoordinate(t - 1, this._p0), e.getCoordinate(t, this._p1), this._rectIntersector.intersects(this._p0, this._p1)) return this._hasIntersection = !0, null;
        }
    }
    class no extends ri {
        constructor(){
            super(), no.constructor_.apply(this, arguments);
        }
        static constructor_() {
            if (this._relate = null, 2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                ri.constructor_.call(this, t, e), this._relate = new Kr(this._arg);
            } else if (3 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = arguments[2];
                ri.constructor_.call(this, t, e, s), this._relate = new Kr(this._arg);
            }
        }
        static equalsTopo(t, e) {
            return !!t.getEnvelopeInternal().equals(e.getEnvelopeInternal()) && no.relate(t, e).isEquals(t.getDimension(), e.getDimension());
        }
        static relate() {
            if (2 === arguments.length) return new no(arguments[0], arguments[1]).getIntersectionMatrix();
            if (3 === arguments.length) return new no(arguments[0], arguments[1], arguments[2]).getIntersectionMatrix();
        }
        static overlaps(t, e) {
            return !!t.getEnvelopeInternal().intersects(e.getEnvelopeInternal()) && new no(t, e).getIntersectionMatrix().isOverlaps(t.getDimension(), e.getDimension());
        }
        static disjoint(t, e) {
            return !no.intersects(t, e);
        }
        static covers(t, e) {
            return !(2 === e.getDimension() && t.getDimension() < 2) && !(1 === e.getDimension() && t.getDimension() < 1 && e.getLength() > 0) && !!t.getEnvelopeInternal().covers(e.getEnvelopeInternal()) && (!!t.isRectangle() || new no(t, e).getIntersectionMatrix().isCovers());
        }
        static intersects(t, e) {
            if (!t.getEnvelopeInternal().intersects(e.getEnvelopeInternal())) return !1;
            if (t.isRectangle()) return $r.intersects(t, e);
            if (e.isRectangle()) return $r.intersects(e, t);
            if (t.isGeometryCollection() || e.isGeometryCollection()) {
                for(let s = 0; s < t.getNumGeometries(); s++)for(let n = 0; n < e.getNumGeometries(); n++)if (no.intersects(t.getGeometryN(s), e.getGeometryN(n))) return !0;
                return !1;
            }
            return new no(t, e).getIntersectionMatrix().isIntersects();
        }
        static touches(t, e) {
            return !!t.getEnvelopeInternal().intersects(e.getEnvelopeInternal()) && new no(t, e).getIntersectionMatrix().isTouches(t.getDimension(), e.getDimension());
        }
        static crosses(t, e) {
            return !!t.getEnvelopeInternal().intersects(e.getEnvelopeInternal()) && new no(t, e).getIntersectionMatrix().isCrosses(t.getDimension(), e.getDimension());
        }
        static contains(t, e) {
            return !(2 === e.getDimension() && t.getDimension() < 2) && !(1 === e.getDimension() && t.getDimension() < 1 && e.getLength() > 0) && !!t.getEnvelopeInternal().contains(e.getEnvelopeInternal()) && (t.isRectangle() ? Qr.contains(t, e) : new no(t, e).getIntersectionMatrix().isContains());
        }
        getIntersectionMatrix() {
            return this._relate.computeIM();
        }
    }
    var io = Object.freeze({
        __proto__: null,
        RelateOp: no
    });
    class ro {
        constructor(){
            ro.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._geomFactory = null, this._polygons = new L, this._lines = new L, this._points = new L, this._dimension = Z.FALSE;
        }
        static extract() {
            if (I(arguments[0], N)) {
                const t = arguments[0], e = new ro;
                return e.add(t), e;
            }
            if (arguments[0] instanceof j) {
                const t = arguments[0], e = new ro;
                return e.add(t), e;
            }
        }
        getFactory() {
            return this._geomFactory;
        }
        filter(t) {
            return this.recordDimension(t.getDimension()), t instanceof ut || t.isEmpty() ? null : t instanceof Ct ? (this._polygons.add(t), null) : t instanceof tt ? (this._lines.add(t), null) : t instanceof Nt ? (this._points.add(t), null) : void h.shouldNeverReachHere("Unhandled geometry type: " + t.getGeometryType());
        }
        getExtract(t) {
            switch(t){
                case 0:
                    return this._points;
                case 1:
                    return this._lines;
                case 2:
                    return this._polygons;
            }
            return h.shouldNeverReachHere("Invalid dimension: " + t), null;
        }
        recordDimension(t) {
            t > this._dimension && (this._dimension = t);
        }
        getDimension() {
            return this._dimension;
        }
        isEmpty() {
            return this._polygons.isEmpty() && this._lines.isEmpty() && this._points.isEmpty();
        }
        add() {
            if (I(arguments[0], N)) {
                const t = arguments[0];
                for (const e of t)this.add(e);
            } else if (arguments[0] instanceof j) {
                const t = arguments[0];
                null === this._geomFactory && (this._geomFactory = t.getFactory()), t.apply(this);
            }
        }
        get interfaces_() {
            return [
                $
            ];
        }
    }
    class oo {
        constructor(){
            oo.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._pointGeom = null, this._otherGeom = null, this._geomFact = null;
            const t = arguments[0], e = arguments[1];
            this._pointGeom = t, this._otherGeom = e, this._geomFact = e.getFactory();
        }
        static union(t, e) {
            return new oo(t, e).union();
        }
        union() {
            const t = new Zn, e = new at;
            for(let s = 0; s < this._pointGeom.getNumGeometries(); s++){
                const n = this._pointGeom.getGeometryN(s).getCoordinate();
                t.locate(n, this._otherGeom) === Qt.EXTERIOR && e.add(n);
            }
            if (0 === e.size()) return this._otherGeom;
            let s = null;
            const n = W.toCoordinateArray(e);
            return s = 1 === n.length ? this._geomFact.createPoint(n[0]) : this._geomFact.createMultiPointFromCoords(n), he.combine(s, this._otherGeom);
        }
    }
    class lo {
        constructor(){
            lo.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._geomFactory = null, this._g0 = null, this._g1 = null, this._isUnionSafe = null;
            const t = arguments[0], e = arguments[1];
            this._g0 = t, this._g1 = e, this._geomFactory = t.getFactory();
        }
        static containsProperly() {
            if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                return !t.isNull() && e.getX() > t.getMinX() && e.getX() < t.getMaxX() && e.getY() > t.getMinY() && e.getY() < t.getMaxY();
            }
            if (3 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = arguments[2];
                return lo.containsProperly(t, e) && lo.containsProperly(t, s);
            }
        }
        static union(t, e) {
            return new lo(t, e).union();
        }
        static intersects(t, e, s) {
            return t.intersects(e) || t.intersects(s);
        }
        static overlapEnvelope(t, e) {
            const s = t.getEnvelopeInternal(), n = e.getEnvelopeInternal();
            return s.intersection(n);
        }
        static extractBorderSegments(t, e, s) {
            t.apply(new class {
                get interfaces_() {
                    return [
                        P
                    ];
                }
                filter(t, n) {
                    if (n <= 0) return null;
                    const i = t.getCoordinate(n - 1), r = t.getCoordinate(n);
                    if (lo.intersects(e, i, r) && !lo.containsProperly(e, i, r)) {
                        const t = new Kt(i, r);
                        s.add(t);
                    }
                }
                isDone() {
                    return !1;
                }
                isGeometryChanged() {
                    return !1;
                }
            });
        }
        static unionBuffer(t, e) {
            const s = t.getFactory().createGeometryCollection([
                t,
                e
            ]);
            return bn.bufferOp(s, 0);
        }
        isBorderSegmentsSame(t, e) {
            const s = this.extractBorderSegments(this._g0, this._g1, e), n = new L;
            return lo.extractBorderSegments(t, e, n), this.isEqual(s, n);
        }
        union() {
            const t = lo.overlapEnvelope(this._g0, this._g1);
            if (t.isNull()) {
                const t = this._g0.copy(), e = this._g1.copy();
                return he.combine(t, e);
            }
            const e = new L, s = this.extractByEnvelope(t, this._g0, e), n = this.extractByEnvelope(t, this._g1, e), i = this.unionFull(s, n);
            let r = null;
            return this._isUnionSafe = this.isBorderSegmentsSame(i, t), r = this._isUnionSafe ? this.combine(i, e) : this.unionFull(this._g0, this._g1), r;
        }
        extractBorderSegments(t, e, s) {
            const n = new L;
            return lo.extractBorderSegments(t, s, n), null !== e && lo.extractBorderSegments(e, s, n), n;
        }
        isUnionOptimized() {
            return this._isUnionSafe;
        }
        extractByEnvelope(t, e, s) {
            const n = new L;
            for(let i = 0; i < e.getNumGeometries(); i++){
                const r = e.getGeometryN(i);
                if (r.getEnvelopeInternal().intersects(t)) n.add(r);
                else {
                    const t = r.copy();
                    s.add(t);
                }
            }
            return this._geomFactory.buildGeometry(n);
        }
        isEqual(t, e) {
            if (t.size() !== e.size()) return !1;
            const s = new pt(t);
            for (const t of e)if (!s.contains(t)) return !1;
            return !0;
        }
        combine(t, e) {
            if (e.size() <= 0) return t;
            e.add(t);
            return he.combine(e);
        }
        unionFull(t, e) {
            try {
                return ci.union(t, e);
            } catch (s) {
                if (s instanceof _s) return lo.unionBuffer(t, e);
                throw s;
            }
        }
    }
    class ao {
        constructor(){
            ao.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._inputPolys = null, this._geomFactory = null;
            const t = arguments[0];
            this._inputPolys = t, null === this._inputPolys && (this._inputPolys = new L);
        }
        static getGeometry(t, e) {
            return e >= t.size() ? null : t.get(e);
        }
        static union(t) {
            return new ao(t).union();
        }
        static restrictToPolygons(t) {
            if (I(t, gt)) return t;
            const e = Ie.getPolygons(t);
            return 1 === e.size() ? e.get(0) : t.getFactory().createMultiPolygon(Lt.toPolygonArray(e));
        }
        reduceToGeometries(t) {
            const e = new L;
            for(let s = t.iterator(); s.hasNext();){
                const t = s.next();
                let n = null;
                I(t, C) ? n = this.unionTree(t) : t instanceof j && (n = t), e.add(n);
            }
            return e;
        }
        union() {
            if (null === this._inputPolys) throw new D("union() method cannot be called twice");
            if (this._inputPolys.isEmpty()) return null;
            this._geomFactory = this._inputPolys.iterator().next().getFactory();
            const t = new Os(ao.STRTREE_NODE_CAPACITY);
            for(let e = this._inputPolys.iterator(); e.hasNext();){
                const s = e.next();
                t.insert(s.getEnvelopeInternal(), s);
            }
            this._inputPolys = null;
            const e = t.itemsTree();
            return this.unionTree(e);
        }
        binaryUnion() {
            if (1 === arguments.length) {
                const t = arguments[0];
                return this.binaryUnion(t, 0, t.size());
            }
            if (3 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = arguments[2];
                if (s - e <= 1) {
                    const s = ao.getGeometry(t, e);
                    return this.unionSafe(s, null);
                }
                if (s - e == 2) return this.unionSafe(ao.getGeometry(t, e), ao.getGeometry(t, e + 1));
                {
                    const n = Math.trunc((s + e) / 2), i = this.binaryUnion(t, e, n), r = this.binaryUnion(t, n, s);
                    return this.unionSafe(i, r);
                }
            }
        }
        unionSafe(t, e) {
            return null === t && null === e ? null : null === t ? e.copy() : null === e ? t.copy() : this.unionActual(t, e);
        }
        unionActual(t, e) {
            const s = lo.union(t, e);
            return ao.restrictToPolygons(s);
        }
        unionTree(t) {
            const e = this.reduceToGeometries(t);
            return this.binaryUnion(e);
        }
    }
    ao.STRTREE_NODE_CAPACITY = 4;
    class co {
        constructor(){
            co.constructor_.apply(this, arguments);
        }
        static constructor_() {
            if (this._geomFact = null, this._extracter = null, 1 === arguments.length) {
                if (I(arguments[0], N)) {
                    const t = arguments[0];
                    this.extract(t);
                } else if (arguments[0] instanceof j) {
                    const t = arguments[0];
                    this.extract(t);
                }
            } else if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                this._geomFact = e, this.extract(t);
            }
        }
        static union() {
            if (1 === arguments.length) {
                if (I(arguments[0], N)) return new co(arguments[0]).union();
                if (arguments[0] instanceof j) return new co(arguments[0]).union();
            } else if (2 === arguments.length) return new co(arguments[0], arguments[1]).union();
        }
        extract() {
            if (I(arguments[0], N)) {
                const t = arguments[0];
                this._extracter = ro.extract(t);
            } else if (arguments[0] instanceof j) {
                const t = arguments[0];
                this._extracter = ro.extract(t);
            }
        }
        unionWithNull(t, e) {
            return null === t && null === e ? null : null === e ? t : null === t ? e : oi.union(t, e);
        }
        unionNoOpt(t) {
            const e = this._geomFact.createPoint();
            return ai.overlayOp(t, e, oi.UNION);
        }
        union() {
            if (null === this._geomFact && (this._geomFact = this._extracter.getFactory()), null === this._geomFact) return null;
            if (this._extracter.isEmpty()) return this._geomFact.createEmpty(this._extracter.getDimension());
            const t = this._extracter.getExtract(0), e = this._extracter.getExtract(1), s = this._extracter.getExtract(2);
            let n = null;
            if (t.size() > 0) {
                const e = this._geomFact.buildGeometry(t);
                n = this.unionNoOpt(e);
            }
            let i = null;
            if (e.size() > 0) {
                const t = this._geomFact.buildGeometry(e);
                i = this.unionNoOpt(t);
            }
            let r = null;
            s.size() > 0 && (r = ao.union(s));
            const o = this.unionWithNull(i, r);
            let l = null;
            return l = null === n ? o : null === o ? n : oo.union(n, o), null === l ? this._geomFact.createGeometryCollection() : l;
        }
    }
    var ho = Object.freeze({
        __proto__: null,
        UnaryUnionOp: co
    }), uo = Object.freeze({
        __proto__: null,
        ConsistentAreaTester: qr,
        IsValidOp: zr
    }), go = Object.freeze({
        __proto__: null,
        BoundaryOp: ir,
        IsSimpleOp: or,
        buffer: ar,
        distance: gr,
        linemerge: Rr,
        overlay: Or,
        polygonize: jr,
        relate: io,
        union: ho,
        valid: uo
    });
    class _o {
        constructor(){
            _o.constructor_.apply(this, arguments);
        }
        static constructor_() {
            if (this._returnToOriginalPrecision = !0, this._cbr = null, 0 === arguments.length) _o.constructor_.call(this, !0);
            else if (1 === arguments.length) {
                const t = arguments[0];
                this._returnToOriginalPrecision = t;
            }
        }
        computeResultPrecision(t) {
            return this._returnToOriginalPrecision && this._cbr.addCommonBits(t), t;
        }
        union(t, e) {
            const s = this.removeCommonBits(t, e);
            return this.computeResultPrecision(ci.union(s[0], s[1]));
        }
        intersection(t, e) {
            const s = this.removeCommonBits(t, e);
            return this.computeResultPrecision(oi.intersection(s[0], s[1]));
        }
        removeCommonBits() {
            if (1 === arguments.length) {
                const t = arguments[0];
                this._cbr = new qn, this._cbr.add(t);
                return this._cbr.removeCommonBits(t.copy());
            }
            if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                this._cbr = new qn, this._cbr.add(t), this._cbr.add(e);
                const s = new Array(2).fill(null);
                return s[0] = this._cbr.removeCommonBits(t.copy()), s[1] = this._cbr.removeCommonBits(e.copy()), s;
            }
        }
        buffer(t, e) {
            const s = this.removeCommonBits(t);
            return this.computeResultPrecision(bn.bufferOp(s, e));
        }
        symDifference(t, e) {
            const s = this.removeCommonBits(t, e);
            return this.computeResultPrecision(oi.symDifference(s[0], s[1]));
        }
        difference(t, e) {
            const s = this.removeCommonBits(t, e);
            return this.computeResultPrecision(oi.difference(s[0], s[1]));
        }
    }
    class po extends ue.CoordinateOperation {
        constructor(){
            super(), po.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._targetPM = null, this._removeCollapsed = !0;
            const t = arguments[0], e = arguments[1];
            this._targetPM = t, this._removeCollapsed = e;
        }
        edit() {
            if (2 === arguments.length && arguments[1] instanceof j && arguments[0] instanceof Array) {
                const t = arguments[0], e = arguments[1];
                if (0 === t.length) return null;
                const s = new Array(t.length).fill(null);
                for(let e = 0; e < t.length; e++){
                    const n = new m(t[e]);
                    this._targetPM.makePrecise(n), s[e] = n;
                }
                const n = new R(s, !1).toCoordinateArray();
                let i = 0;
                e instanceof tt && (i = 2), e instanceof et && (i = 4);
                let r = s;
                return this._removeCollapsed && (r = null), n.length < i ? r : n;
            }
            return super.edit.apply(this, arguments);
        }
    }
    class mo {
        constructor(){
            mo.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._targetPM = null, this._removeCollapsed = !0, this._changePrecisionModel = !1, this._isPointwise = !1;
            const t = arguments[0];
            this._targetPM = t;
        }
        static reduce(t, e) {
            return new mo(e).reduce(t);
        }
        static reducePointwise(t, e) {
            const s = new mo(e);
            return s.setPointwise(!0), s.reduce(t);
        }
        fixPolygonalTopology(t) {
            let e = t;
            this._changePrecisionModel || (e = this.changePM(t, this._targetPM));
            return bn.bufferOp(e, 0);
        }
        reducePointwise(t) {
            let e = null;
            if (this._changePrecisionModel) {
                const s = this.createFactory(t.getFactory(), this._targetPM);
                e = new ue(s);
            } else e = new ue;
            let s = this._removeCollapsed;
            t.getDimension() >= 2 && (s = !0);
            return e.edit(t, new po(this._targetPM, s));
        }
        changePM(t, e) {
            return this.createEditor(t.getFactory(), e).edit(t, new ue.NoOpGeometryOperation);
        }
        setRemoveCollapsedComponents(t) {
            this._removeCollapsed = t;
        }
        createFactory(t, e) {
            return new Lt(e, t.getSRID(), t.getCoordinateSequenceFactory());
        }
        setChangePrecisionModel(t) {
            this._changePrecisionModel = t;
        }
        reduce(t) {
            const e = this.reducePointwise(t);
            return this._isPointwise ? e : I(e, gt) ? zr.isValid(e) ? e : this.fixPolygonalTopology(e) : e;
        }
        setPointwise(t) {
            this._isPointwise = t;
        }
        createEditor(t, e) {
            if (t.getPrecisionModel() === e) return new ue;
            const s = this.createFactory(t, e);
            return new ue(s);
        }
    }
    class fo {
        constructor(){
            fo.constructor_.apply(this, arguments);
        }
        static constructor_() {
            if (this._geom = null, this._pts = null, this._start = null, this._end = null, 2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                this._pts = t, this._start = e, this._end = e + 1;
            } else if (3 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = arguments[2];
                this._pts = t, this._start = e, this._end = s;
            } else if (4 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = arguments[2], n = arguments[3];
                this._geom = t, this._pts = e, this._start = s, this._end = n;
            }
        }
        size() {
            return this._end - this._start;
        }
        getCoordinate(t) {
            return this._pts.getCoordinate(this._start + t);
        }
        updateNearestLocationsLineLine(t, e, s, n, i, r, o, l) {
            const a = new Kt(e, s), c = new Kt(r, o), h = a.closestPoints(c);
            l[0] = new cr(this._geom, t, new m(h[0])), l[1] = new cr(n._geom, i, new m(h[1]));
        }
        toString() {
            const t = new v;
            t.append("LINESTRING ( ");
            const e = new m;
            for(let s = this._start; s < this._end; s++)s > this._start && t.append(", "), this._pts.getCoordinate(s, e), t.append(e.x + " " + e.y);
            return t.append(" )"), t.toString();
        }
        computeDistancePointLine(t, e, s) {
            let n = r.MAX_VALUE;
            for(let i = e._start; i < e._end - 1; i++){
                const r = e._pts.getCoordinate(i), o = e._pts.getCoordinate(i + 1), l = V.pointToSegment(t, r, o);
                if (l < n && (n = l, null !== s && this.updateNearestLocationsPointLine(t, e, i, r, o, s), n <= 0)) return n;
            }
            return n;
        }
        isPoint() {
            return this._end - this._start == 1;
        }
        distance(t) {
            const e = this.isPoint(), s = t.isPoint();
            let n = null;
            if (e && s) {
                const e = this._pts.getCoordinate(this._start), s = t._pts.getCoordinate(t._start);
                n = e.distance(s);
            } else if (e) {
                const e = this._pts.getCoordinate(this._start);
                n = this.computeDistancePointLine(e, t, null);
            } else if (s) {
                const e = t._pts.getCoordinate(t._start);
                n = this.computeDistancePointLine(e, this, null);
            } else n = this.computeDistanceLineLine(t, null);
            return n;
        }
        computeDistanceLineLine(t, e) {
            let s = r.MAX_VALUE;
            for(let n = this._start; n < this._end - 1; n++){
                const i = this._pts.getCoordinate(n), r = this._pts.getCoordinate(n + 1);
                for(let o = t._start; o < t._end - 1; o++){
                    const l = t._pts.getCoordinate(o), a = t._pts.getCoordinate(o + 1), c = V.segmentToSegment(i, r, l, a);
                    if (c < s && (s = c, null !== e && this.updateNearestLocationsLineLine(n, i, r, t, o, l, a, e), s <= 0)) return s;
                }
            }
            return s;
        }
        updateNearestLocationsPointLine(t, e, s, n, i, r) {
            r[0] = new cr(this._geom, this._start, new m(t));
            const o = new Kt(n, i).closestPoint(t);
            r[1] = new cr(e._geom, s, new m(o));
        }
        nearestLocations(t) {
            const e = this.isPoint(), s = t.isPoint(), n = new Array(2).fill(null);
            if (e && s) {
                const e = this._pts.getCoordinate(this._start), s = t._pts.getCoordinate(t._start);
                n[0] = new cr(this._geom, this._start, new m(e)), n[1] = new cr(t._geom, t._start, new m(s));
            } else if (e) {
                const e = this._pts.getCoordinate(this._start);
                this.computeDistancePointLine(e, t, n);
            } else if (s) {
                const e = t._pts.getCoordinate(t._start);
                this.computeDistancePointLine(e, this, n);
                const s = n[0];
                n[0] = n[1], n[1] = s;
            } else this.computeDistanceLineLine(t, n);
            return n;
        }
        getEnvelope() {
            const t = new O;
            for(let e = this._start; e < this._end; e++)t.expandToInclude(this._pts.getX(e), this._pts.getY(e));
            return t;
        }
    }
    class yo {
        static addFacetSequences(t, e, s) {
            let n = 0;
            const i = e.size();
            for(; n <= i - 1;){
                let r = n + yo.FACET_SEQUENCE_SIZE + 1;
                r >= i - 1 && (r = i);
                const o = new fo(t, e, n, r);
                s.add(o), n += yo.FACET_SEQUENCE_SIZE;
            }
        }
        static build(t) {
            const e = new Os(yo.STR_TREE_NODE_CAPACITY);
            for(let s = yo.computeFacetSequences(t).iterator(); s.hasNext();){
                const t = s.next();
                e.insert(t.getEnvelope(), t);
            }
            return e.build(), e;
        }
        static computeFacetSequences(t) {
            const e = new L;
            return t.apply(new class {
                get interfaces_() {
                    return [
                        X
                    ];
                }
                filter(t) {
                    let s = null;
                    (t instanceof tt || t instanceof Nt) && (s = t.getCoordinateSequence(), yo.addFacetSequences(t, s, e));
                }
            }), e;
        }
    }
    yo.FACET_SEQUENCE_SIZE = 6, yo.STR_TREE_NODE_CAPACITY = 4;
    class xo {
        constructor(){
            xo.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._inputGeom = null, this._minClearance = null, this._minClearancePts = null;
            const t = arguments[0];
            this._inputGeom = t;
        }
        static getDistance(t) {
            return new xo(t).getDistance();
        }
        static getLine(t) {
            return new xo(t).getLine();
        }
        getDistance() {
            return this.compute(), this._minClearance;
        }
        compute() {
            if (null !== this._minClearancePts) return null;
            if (this._minClearancePts = new Array(2).fill(null), this._minClearance = r.MAX_VALUE, this._inputGeom.isEmpty()) return null;
            const t = yo.build(this._inputGeom).nearestNeighbour(new Eo), e = new Eo;
            this._minClearance = e.distance(t[0], t[1]), this._minClearancePts = e.getCoordinates();
        }
        getLine() {
            return this.compute(), null === this._minClearancePts || null === this._minClearancePts[0] ? this._inputGeom.getFactory().createLineString() : this._inputGeom.getFactory().createLineString(this._minClearancePts);
        }
    }
    class Eo {
        constructor(){
            Eo.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._minDist = r.MAX_VALUE, this._minPts = new Array(2).fill(null);
        }
        vertexDistance(t, e) {
            for(let s = 0; s < t.size(); s++)for(let n = 0; n < e.size(); n++){
                const i = t.getCoordinate(s), r = e.getCoordinate(n);
                if (!i.equals2D(r)) {
                    const t = i.distance(r);
                    if (t < this._minDist && (this._minDist = t, this._minPts[0] = i, this._minPts[1] = r, 0 === t)) return t;
                }
            }
            return this._minDist;
        }
        getCoordinates() {
            return this._minPts;
        }
        segmentDistance(t, e) {
            for(let s = 0; s < t.size(); s++)for(let n = 1; n < e.size(); n++){
                const i = t.getCoordinate(s), r = e.getCoordinate(n - 1), o = e.getCoordinate(n);
                if (!i.equals2D(r) && !i.equals2D(o)) {
                    const t = V.pointToSegment(i, r, o);
                    if (t < this._minDist && (this._minDist = t, this.updatePts(i, r, o), 0 === t)) return t;
                }
            }
            return this._minDist;
        }
        distance() {
            if (arguments[0] instanceof fs && arguments[1] instanceof fs) {
                const t = arguments[1], e = arguments[0].getItem(), s = t.getItem();
                return this._minDist = r.MAX_VALUE, this.distance(e, s);
            }
            if (arguments[0] instanceof fo && arguments[1] instanceof fo) {
                const t = arguments[0], e = arguments[1];
                return this.vertexDistance(t, e), 1 === t.size() && 1 === e.size() ? this._minDist : this._minDist <= 0 ? this._minDist : (this.segmentDistance(t, e), this._minDist <= 0 || this.segmentDistance(e, t), this._minDist);
            }
        }
        updatePts(t, e, s) {
            this._minPts[0] = t;
            const n = new Kt(e, s);
            this._minPts[1] = new m(n.closestPoint(t));
        }
        get interfaces_() {
            return [
                Ps
            ];
        }
    }
    xo.MinClearanceDistance = Eo;
    class Io {
        constructor(){
            Io.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._inputGeom = null, this._minClearance = null, this._minClearancePts = null;
            const t = arguments[0];
            this._inputGeom = t;
        }
        static getDistance(t) {
            return new Io(t).getDistance();
        }
        static getLine(t) {
            return new Io(t).getLine();
        }
        getDistance() {
            return this.compute(), this._minClearance;
        }
        compute() {
            if (null !== this._minClearancePts) return null;
            this._minClearancePts = new Array(2).fill(null), this._minClearance = r.MAX_VALUE, this._inputGeom.apply(new No(this));
        }
        updateClearance() {
            if (3 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = arguments[2];
                t < this._minClearance && (this._minClearance = t, this._minClearancePts[0] = new m(e), this._minClearancePts[1] = new m(s));
            } else if (4 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = arguments[2], n = arguments[3];
                if (t < this._minClearance) {
                    this._minClearance = t, this._minClearancePts[0] = new m(e);
                    const i = new Kt(s, n);
                    this._minClearancePts[1] = new m(i.closestPoint(e));
                }
            }
        }
        getLine() {
            return this.compute(), this._inputGeom.getFactory().createLineString(this._minClearancePts);
        }
    }
    class No {
        constructor(){
            No.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this.smc = null;
            const t = arguments[0];
            this.smc = t;
        }
        filter(t) {
            this.smc._inputGeom.apply(new wo(this.smc, t));
        }
        get interfaces_() {
            return [
                K
            ];
        }
    }
    class wo {
        constructor(){
            wo.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this.smc = null, this._queryPt = null;
            const t = arguments[0], e = arguments[1];
            this.smc = t, this._queryPt = e;
        }
        filter(t, e) {
            this.checkVertexDistance(t.getCoordinate(e)), e > 0 && this.checkSegmentDistance(t.getCoordinate(e - 1), t.getCoordinate(e));
        }
        checkSegmentDistance(t, e) {
            if (this._queryPt.equals2D(t) || this._queryPt.equals2D(e)) return null;
            const s = V.pointToSegment(this._queryPt, e, t);
            s > 0 && this.smc.updateClearance(s, this._queryPt, e, t);
        }
        isDone() {
            return !1;
        }
        isGeometryChanged() {
            return !1;
        }
        checkVertexDistance(t) {
            const e = t.distance(this._queryPt);
            e > 0 && this.smc.updateClearance(e, this._queryPt, t);
        }
        get interfaces_() {
            return [
                P
            ];
        }
    }
    Io.VertexCoordinateFilter = No, Io.ComputeMCCoordinateSequenceFilter = wo;
    var Co = Object.freeze({
        __proto__: null,
        CommonBits: Gn,
        CommonBitsOp: _o,
        CommonBitsRemover: qn,
        EnhancedPrecisionOp: class {
            static union(t, e) {
                let s = null;
                try {
                    return ci.union(t, e);
                } catch (t) {
                    if (!(t instanceof a)) throw t;
                    s = t;
                }
                try {
                    const n = new _o(!0).union(t, e);
                    if (!n.isValid()) throw s;
                    return n;
                } catch (t) {
                    throw t instanceof a ? s : t;
                }
            }
            static intersection(t, e) {
                let s = null;
                try {
                    return oi.intersection(t, e);
                } catch (t) {
                    if (!(t instanceof a)) throw t;
                    s = t;
                }
                try {
                    const n = new _o(!0).intersection(t, e);
                    if (!n.isValid()) throw s;
                    return n;
                } catch (t) {
                    throw t instanceof a ? s : t;
                }
            }
            static buffer(t, e) {
                let s = null;
                try {
                    return bn.bufferOp(t, e);
                } catch (t) {
                    if (!(t instanceof a)) throw t;
                    s = t;
                }
                try {
                    const n = new _o(!0).buffer(t, e);
                    if (!n.isValid()) throw s;
                    return n;
                } catch (t) {
                    throw t instanceof a ? s : t;
                }
            }
            static symDifference(t, e) {
                let s = null;
                try {
                    return oi.symDifference(t, e);
                } catch (t) {
                    if (!(t instanceof a)) throw t;
                    s = t;
                }
                try {
                    const n = new _o(!0).symDifference(t, e);
                    if (!n.isValid()) throw s;
                    return n;
                } catch (t) {
                    throw t instanceof a ? s : t;
                }
            }
            static difference(t, e) {
                let s = null;
                try {
                    return oi.difference(t, e);
                } catch (t) {
                    if (!(t instanceof a)) throw t;
                    s = t;
                }
                try {
                    const n = new _o(!0).difference(t, e);
                    if (!n.isValid()) throw s;
                    return n;
                } catch (t) {
                    throw t instanceof a ? s : t;
                }
            }
        },
        GeometryPrecisionReducer: mo,
        MinimumClearance: xo,
        SimpleMinimumClearance: Io
    });
    class So {
        constructor(){
            So.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._pts = null, this._usePt = null, this._distanceTolerance = null, this._seg = new Kt;
            const t = arguments[0];
            this._pts = t;
        }
        static simplify(t, e) {
            const s = new So(t);
            return s.setDistanceTolerance(e), s.simplify();
        }
        setDistanceTolerance(t) {
            this._distanceTolerance = t;
        }
        simplifySection(t, e) {
            if (t + 1 === e) return null;
            this._seg.p0 = this._pts[t], this._seg.p1 = this._pts[e];
            let s = -1, n = t;
            for(let i = t + 1; i < e; i++){
                const t = this._seg.distance(this._pts[i]);
                t > s && (s = t, n = i);
            }
            if (s <= this._distanceTolerance) for(let s = t + 1; s < e; s++)this._usePt[s] = !1;
            else this.simplifySection(t, n), this.simplifySection(n, e);
        }
        simplify() {
            this._usePt = new Array(this._pts.length).fill(null);
            for(let t = 0; t < this._pts.length; t++)this._usePt[t] = !0;
            this.simplifySection(0, this._pts.length - 1);
            const t = new R;
            for(let e = 0; e < this._pts.length; e++)this._usePt[e] && t.add(new m(this._pts[e]));
            return t.toCoordinateArray();
        }
    }
    class Lo {
        constructor(){
            Lo.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._inputGeom = null, this._distanceTolerance = null, this._isEnsureValidTopology = !0;
            const t = arguments[0];
            this._inputGeom = t;
        }
        static simplify(t, e) {
            const s = new Lo(t);
            return s.setDistanceTolerance(e), s.getResultGeometry();
        }
        setDistanceTolerance(t) {
            if (t < 0) throw new n("Tolerance must be non-negative");
            this._distanceTolerance = t;
        }
        getResultGeometry() {
            return this._inputGeom.isEmpty() ? this._inputGeom.copy() : new To(this._isEnsureValidTopology, this._distanceTolerance).transform(this._inputGeom);
        }
        setEnsureValid(t) {
            this._isEnsureValidTopology = t;
        }
    }
    class To extends me {
        constructor(){
            super(), To.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._isEnsureValidTopology = !0, this._distanceTolerance = null;
            const t = arguments[0], e = arguments[1];
            this._isEnsureValidTopology = t, this._distanceTolerance = e;
        }
        transformPolygon(t, e) {
            if (t.isEmpty()) return null;
            const s = super.transformPolygon.call(this, t, e);
            return e instanceof dt ? s : this.createValidArea(s);
        }
        createValidArea(t) {
            return this._isEnsureValidTopology ? bn.bufferOp(t, 0) : t;
        }
        transformCoordinates(t, e) {
            const s = t.toCoordinateArray();
            let n = null;
            return n = 0 === s.length ? new Array(0).fill(null) : So.simplify(s, this._distanceTolerance), this._factory.getCoordinateSequenceFactory().create(n);
        }
        transformMultiPolygon(t, e) {
            const s = super.transformMultiPolygon.call(this, t, e);
            return this.createValidArea(s);
        }
        transformLinearRing(t, e) {
            const s = e instanceof Ct, n = super.transformLinearRing.call(this, t, e);
            return !s || n instanceof et ? n : null;
        }
    }
    Lo.DPTransformer = To;
    class Ro extends Kt {
        constructor(){
            super(), Ro.constructor_.apply(this, arguments);
        }
        static constructor_() {
            if (this._parent = null, this._index = null, 2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                Ro.constructor_.call(this, t, e, null, -1);
            } else if (4 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = arguments[2], n = arguments[3];
                Kt.constructor_.call(this, t, e), this._parent = s, this._index = n;
            }
        }
        getParent() {
            return this._parent;
        }
        getIndex() {
            return this._index;
        }
    }
    class Po {
        constructor(){
            Po.constructor_.apply(this, arguments);
        }
        static constructor_() {
            if (this._parentLine = null, this._segs = null, this._resultSegs = new L, this._minimumSize = null, 1 === arguments.length) {
                const t = arguments[0];
                Po.constructor_.call(this, t, 2);
            } else if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                this._parentLine = t, this._minimumSize = e, this.init();
            }
        }
        static extractCoordinates(t) {
            const e = new Array(t.size() + 1).fill(null);
            let s = null;
            for(let n = 0; n < t.size(); n++)s = t.get(n), e[n] = s.p0;
            return e[e.length - 1] = s.p1, e;
        }
        addToResult(t) {
            this._resultSegs.add(t);
        }
        asLineString() {
            return this._parentLine.getFactory().createLineString(Po.extractCoordinates(this._resultSegs));
        }
        getResultSize() {
            const t = this._resultSegs.size();
            return 0 === t ? 0 : t + 1;
        }
        getParentCoordinates() {
            return this._parentLine.getCoordinates();
        }
        getMinimumSize() {
            return this._minimumSize;
        }
        asLinearRing() {
            return this._parentLine.getFactory().createLinearRing(Po.extractCoordinates(this._resultSegs));
        }
        getSegments() {
            return this._segs;
        }
        init() {
            const t = this._parentLine.getCoordinates();
            this._segs = new Array(t.length - 1).fill(null);
            for(let e = 0; e < t.length - 1; e++){
                const s = new Ro(t[e], t[e + 1], this._parentLine, e);
                this._segs[e] = s;
            }
        }
        getResultCoordinates() {
            return Po.extractCoordinates(this._resultSegs);
        }
        getParent() {
            return this._parentLine;
        }
        getSegment(t) {
            return this._segs[t];
        }
    }
    class Oo {
        constructor(){
            Oo.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._index = new Wi;
        }
        add() {
            if (arguments[0] instanceof Po) {
                const t = arguments[0].getSegments();
                for(let e = 0; e < t.length; e++){
                    const s = t[e];
                    this.add(s);
                }
            } else if (arguments[0] instanceof Kt) {
                const t = arguments[0];
                this._index.insert(new O(t.p0, t.p1), t);
            }
        }
        query(t) {
            const e = new O(t.p0, t.p1), s = new vo(t);
            this._index.query(e, s);
            return s.getItems();
        }
        remove(t) {
            this._index.remove(new O(t.p0, t.p1), t);
        }
    }
    class vo {
        constructor(){
            vo.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._querySeg = null, this._items = new L;
            const t = arguments[0];
            this._querySeg = t;
        }
        getItems() {
            return this._items;
        }
        visitItem(t) {
            const e = t;
            O.intersects(e.p0, e.p1, this._querySeg.p0, this._querySeg.p1) && this._items.add(t);
        }
        get interfaces_() {
            return [
                De
            ];
        }
    }
    class Mo {
        constructor(){
            Mo.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._li = new jt, this._inputIndex = new Oo, this._outputIndex = new Oo, this._line = null, this._linePts = null, this._distanceTolerance = 0;
            const t = arguments[0], e = arguments[1];
            this._inputIndex = t, this._outputIndex = e;
        }
        static isInLineSection(t, e, s) {
            if (s.getParent() !== t.getParent()) return !1;
            const n = s.getIndex();
            return n >= e[0] && n < e[1];
        }
        flatten(t, e) {
            const s = this._linePts[t], n = this._linePts[e], i = new Kt(s, n);
            return this.remove(this._line, t, e), this._outputIndex.add(i), i;
        }
        hasBadIntersection(t, e, s) {
            return !!this.hasBadOutputIntersection(s) || !!this.hasBadInputIntersection(t, e, s);
        }
        setDistanceTolerance(t) {
            this._distanceTolerance = t;
        }
        simplifySection(t, e, s) {
            s += 1;
            const n = new Array(2).fill(null);
            if (t + 1 === e) {
                const e = this._line.getSegment(t);
                return this._line.addToResult(e), null;
            }
            let i = !0;
            if (this._line.getResultSize() < this._line.getMinimumSize()) s + 1 < this._line.getMinimumSize() && (i = !1);
            const r = new Array(1).fill(null), o = this.findFurthestPoint(this._linePts, t, e, r);
            r[0] > this._distanceTolerance && (i = !1);
            const l = new Kt;
            if (l.p0 = this._linePts[t], l.p1 = this._linePts[e], n[0] = t, n[1] = e, this.hasBadIntersection(this._line, n, l) && (i = !1), i) {
                const s = this.flatten(t, e);
                return this._line.addToResult(s), null;
            }
            this.simplifySection(t, o, s), this.simplifySection(o, e, s);
        }
        hasBadOutputIntersection(t) {
            for(let e = this._outputIndex.query(t).iterator(); e.hasNext();){
                const s = e.next();
                if (this.hasInteriorIntersection(s, t)) return !0;
            }
            return !1;
        }
        hasInteriorIntersection(t, e) {
            return this._li.computeIntersection(t.p0, t.p1, e.p0, e.p1), this._li.isInteriorIntersection();
        }
        hasBadInputIntersection(t, e, s) {
            for(let n = this._inputIndex.query(s).iterator(); n.hasNext();){
                const i = n.next();
                if (this.hasInteriorIntersection(i, s)) {
                    if (Mo.isInLineSection(t, e, i)) continue;
                    return !0;
                }
            }
            return !1;
        }
        findFurthestPoint(t, e, s, n) {
            const i = new Kt;
            i.p0 = t[e], i.p1 = t[s];
            let r = -1, o = e;
            for(let n = e + 1; n < s; n++){
                const e = t[n], s = i.distance(e);
                s > r && (r = s, o = n);
            }
            return n[0] = r, o;
        }
        simplify(t) {
            this._line = t, this._linePts = t.getParentCoordinates(), this.simplifySection(0, this._linePts.length - 1, 0);
        }
        remove(t, e, s) {
            for(let n = e; n < s; n++){
                const e = t.getSegment(n);
                this._inputIndex.remove(e);
            }
        }
    }
    class bo {
        constructor(){
            bo.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._inputIndex = new Oo, this._outputIndex = new Oo, this._distanceTolerance = 0;
        }
        setDistanceTolerance(t) {
            this._distanceTolerance = t;
        }
        simplify(t) {
            for(let e = t.iterator(); e.hasNext();)this._inputIndex.add(e.next());
            for(let e = t.iterator(); e.hasNext();){
                const t = new Mo(this._inputIndex, this._outputIndex);
                t.setDistanceTolerance(this._distanceTolerance), t.simplify(e.next());
            }
        }
    }
    class Do {
        constructor(){
            Do.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._inputGeom = null, this._lineSimplifier = new bo, this._linestringMap = null;
            const t = arguments[0];
            this._inputGeom = t;
        }
        static simplify(t, e) {
            const s = new Do(t);
            return s.setDistanceTolerance(e), s.getResultGeometry();
        }
        setDistanceTolerance(t) {
            if (t < 0) throw new n("Tolerance must be non-negative");
            this._lineSimplifier.setDistanceTolerance(t);
        }
        getResultGeometry() {
            if (this._inputGeom.isEmpty()) return this._inputGeom.copy();
            this._linestringMap = new ft, this._inputGeom.apply(new Fo(this)), this._lineSimplifier.simplify(this._linestringMap.values());
            return new Ao(this._linestringMap).transform(this._inputGeom);
        }
    }
    class Ao extends me {
        constructor(){
            super(), Ao.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._linestringMap = null;
            const t = arguments[0];
            this._linestringMap = t;
        }
        transformCoordinates(t, e) {
            if (0 === t.size()) return null;
            if (e instanceof tt) {
                const t = this._linestringMap.get(e);
                return this.createCoordinateSequence(t.getResultCoordinates());
            }
            return super.transformCoordinates.call(this, t, e);
        }
    }
    class Fo {
        constructor(){
            Fo.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this.tps = null;
            const t = arguments[0];
            this.tps = t;
        }
        filter(t) {
            if (t instanceof tt) {
                const e = t;
                if (e.isEmpty()) return null;
                const s = e.isClosed() ? 4 : 2, n = new Po(e, s);
                this.tps._linestringMap.put(e, n);
            }
        }
        get interfaces_() {
            return [
                X
            ];
        }
    }
    Do.LineStringTransformer = Ao, Do.LineStringMapBuilderFilter = Fo;
    class Go {
        constructor(){
            Go.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._pts = null, this._tolerance = null;
            const t = arguments[0], e = arguments[1];
            this._pts = t, this._tolerance = e * e;
        }
        static simplify(t, e) {
            return new Go(t, e).simplify();
        }
        simplifyVertex(t) {
            let e = t, s = e.getArea(), n = null;
            for(; null !== e;){
                const t = e.getArea();
                t < s && (s = t, n = e), e = e._next;
            }
            return null !== n && s < this._tolerance && n.remove(), t.isLive() ? s : -1;
        }
        simplify() {
            const t = qo.buildLine(this._pts);
            let e = this._tolerance;
            do e = this.simplifyVertex(t);
            while (e < this._tolerance);
            const s = t.getCoordinates();
            return s.length < 2 ? [
                s[0],
                new m(s[0])
            ] : s;
        }
    }
    class qo {
        constructor(){
            qo.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._pt = null, this._prev = null, this._next = null, this._area = qo.MAX_AREA, this._isLive = !0;
            const t = arguments[0];
            this._pt = t;
        }
        static buildLine(t) {
            let e = null, s = null;
            for(let n = 0; n < t.length; n++){
                const i = new qo(t[n]);
                null === e && (e = i), i.setPrev(s), null !== s && (s.setNext(i), s.updateArea()), s = i;
            }
            return e;
        }
        getCoordinates() {
            const t = new R;
            let e = this;
            do t.add(e._pt, !1), e = e._next;
            while (null !== e);
            return t.toCoordinateArray();
        }
        getArea() {
            return this._area;
        }
        updateArea() {
            if (null === this._prev || null === this._next) return this._area = qo.MAX_AREA, null;
            this._area = Math.abs(se.area(this._prev._pt, this._pt, this._next._pt));
        }
        remove() {
            const t = this._prev, e = this._next;
            let s = null;
            return null !== this._prev && (this._prev.setNext(e), this._prev.updateArea(), s = this._prev), null !== this._next && (this._next.setPrev(t), this._next.updateArea(), null === s && (s = this._next)), this._isLive = !1, s;
        }
        isLive() {
            return this._isLive;
        }
        setPrev(t) {
            this._prev = t;
        }
        setNext(t) {
            this._next = t;
        }
    }
    qo.MAX_AREA = r.MAX_VALUE, Go.VWVertex = qo;
    class Bo {
        constructor(){
            Bo.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._inputGeom = null, this._distanceTolerance = null, this._isEnsureValidTopology = !0;
            const t = arguments[0];
            this._inputGeom = t;
        }
        static simplify(t, e) {
            const s = new Bo(t);
            return s.setDistanceTolerance(e), s.getResultGeometry();
        }
        setDistanceTolerance(t) {
            if (t < 0) throw new n("Tolerance must be non-negative");
            this._distanceTolerance = t;
        }
        getResultGeometry() {
            return this._inputGeom.isEmpty() ? this._inputGeom.copy() : new Yo(this._isEnsureValidTopology, this._distanceTolerance).transform(this._inputGeom);
        }
        setEnsureValid(t) {
            this._isEnsureValidTopology = t;
        }
    }
    class Yo extends me {
        constructor(){
            super(), Yo.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._isEnsureValidTopology = !0, this._distanceTolerance = null;
            const t = arguments[0], e = arguments[1];
            this._isEnsureValidTopology = t, this._distanceTolerance = e;
        }
        transformPolygon(t, e) {
            if (t.isEmpty()) return null;
            const s = super.transformPolygon.call(this, t, e);
            return e instanceof dt ? s : this.createValidArea(s);
        }
        createValidArea(t) {
            return this._isEnsureValidTopology ? bn.bufferOp(t, 0) : t;
        }
        transformCoordinates(t, e) {
            const s = t.toCoordinateArray();
            let n = null;
            return n = 0 === s.length ? new Array(0).fill(null) : Go.simplify(s, this._distanceTolerance), this._factory.getCoordinateSequenceFactory().create(n);
        }
        transformMultiPolygon(t, e) {
            const s = super.transformMultiPolygon.call(this, t, e);
            return this.createValidArea(s);
        }
        transformLinearRing(t, e) {
            const s = e instanceof Ct, n = super.transformLinearRing.call(this, t, e);
            return !s || n instanceof et ? n : null;
        }
    }
    Bo.VWTransformer = Yo;
    var zo = Object.freeze({
        __proto__: null,
        DouglasPeuckerSimplifier: Lo,
        TopologyPreservingSimplifier: Do,
        VWSimplifier: Bo
    });
    class Vo {
        locate(t) {}
    }
    class ko {
        constructor(){
            ko.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._subdiv = null, this._lastEdge = null;
            const t = arguments[0];
            this._subdiv = t, this.init();
        }
        init() {
            this._lastEdge = this.findEdge();
        }
        locate(t) {
            this._lastEdge.isLive() || this.init();
            const e = this._subdiv.locateFromEdge(t, this._lastEdge);
            return this._lastEdge = e, e;
        }
        findEdge() {
            return this._subdiv.getEdges().iterator().next();
        }
        get interfaces_() {
            return [
                Vo
            ];
        }
    }
    class Xo {
        constructor(){
            Xo.constructor_.apply(this, arguments);
        }
        static constructor_() {
            if (this._ls = null, this._data = null, 2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                this._ls = new Kt(t, e);
            } else if (3 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = arguments[2];
                this._ls = new Kt(t, e), this._data = s;
            } else if (6 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = arguments[2], n = arguments[3], i = arguments[4], r = arguments[5];
                Xo.constructor_.call(this, new m(t, e, s), new m(n, i, r));
            } else if (7 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = arguments[2], n = arguments[3], i = arguments[4], r = arguments[5], o = arguments[6];
                Xo.constructor_.call(this, new m(t, e, s), new m(n, i, r), o);
            }
        }
        getStartZ() {
            return this._ls.getCoordinate(0).getZ();
        }
        intersection(t) {
            return this._ls.intersection(t.getLineSegment());
        }
        getStart() {
            return this._ls.getCoordinate(0);
        }
        getEnd() {
            return this._ls.getCoordinate(1);
        }
        getEndY() {
            return this._ls.getCoordinate(1).y;
        }
        getStartX() {
            return this._ls.getCoordinate(0).x;
        }
        setData(t) {
            this._data = t;
        }
        getData() {
            return this._data;
        }
        getEndX() {
            return this._ls.getCoordinate(1).x;
        }
        toString() {
            return this._ls.toString();
        }
        getLineSegment() {
            return this._ls;
        }
        getEndZ() {
            return this._ls.getCoordinate(1).getZ();
        }
        equalsTopo(t) {
            return this._ls.equalsTopo(t.getLineSegment());
        }
        getStartY() {
            return this._ls.getCoordinate(0).y;
        }
    }
    class Uo {
        constructor(){
            Uo.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._seg = null, this._segLen = null, this._splitPt = null, this._minimumLen = 0;
            const t = arguments[0];
            this._seg = t, this._segLen = t.getLength();
        }
        static pointAlongReverse(t, e) {
            const s = new m;
            return s.x = t.p1.x - e * (t.p1.x - t.p0.x), s.y = t.p1.y - e * (t.p1.y - t.p0.y), s;
        }
        splitAt() {
            if (1 === arguments.length) {
                const t = arguments[0], e = this._minimumLen / this._segLen;
                if (t.distance(this._seg.p0) < this._minimumLen) return this._splitPt = this._seg.pointAlong(e), null;
                if (t.distance(this._seg.p1) < this._minimumLen) return this._splitPt = Uo.pointAlongReverse(this._seg, e), null;
                this._splitPt = t;
            } else if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = this.getConstrainedLength(t) / this._segLen;
                e.equals2D(this._seg.p0) ? this._splitPt = this._seg.pointAlong(s) : this._splitPt = Uo.pointAlongReverse(this._seg, s);
            }
        }
        getSplitPoint() {
            return this._splitPt;
        }
        getConstrainedLength(t) {
            return t < this._minimumLen ? this._minimumLen : t;
        }
        setMinimumLength(t) {
            this._minimumLen = t;
        }
    }
    class Ho {
        findSplitPoint(t, e) {}
    }
    class Wo {
        static projectedSplitPoint(t, e) {
            return t.getLineSegment().project(e);
        }
        findSplitPoint(t, e) {
            const s = t.getLineSegment(), n = s.getLength() / 2, i = new Uo(s), r = Wo.projectedSplitPoint(t, e);
            let o = 2 * r.distance(e) * .8;
            return o > n && (o = n), i.setMinimumLength(o), i.splitAt(r), i.getSplitPoint();
        }
        get interfaces_() {
            return [
                Ho
            ];
        }
    }
    class Zo {
        static checkRobustInCircle(t, e, s, n) {
            const i = Zo.isInCircleNonRobust(t, e, s, n), r = Zo.isInCircleDDSlow(t, e, s, n), o = Zo.isInCircleCC(t, e, s, n), l = se.circumcentre(t, e, s);
            Y.out.println("p radius diff a = " + Math.abs(n.distance(l) - t.distance(l)) / t.distance(l)), i === r && i === o || (Y.out.println("inCircle robustness failure (double result = " + i + ", DD result = " + r + ", CC result = " + o + ")"), Y.out.println(Wt.toLineString(new it([
                t,
                e,
                s,
                n
            ]))), Y.out.println("Circumcentre = " + Wt.toPoint(l) + " radius = " + t.distance(l)), Y.out.println("p radius diff a = " + Math.abs(n.distance(l) / t.distance(l) - 1)), Y.out.println("p radius diff b = " + Math.abs(n.distance(l) / e.distance(l) - 1)), Y.out.println("p radius diff c = " + Math.abs(n.distance(l) / s.distance(l) - 1)), Y.out.println());
        }
        static isInCircleDDFast(t, e, s, n) {
            const i = A.sqr(t.x).selfAdd(A.sqr(t.y)).selfMultiply(Zo.triAreaDDFast(e, s, n)), r = A.sqr(e.x).selfAdd(A.sqr(e.y)).selfMultiply(Zo.triAreaDDFast(t, s, n)), o = A.sqr(s.x).selfAdd(A.sqr(s.y)).selfMultiply(Zo.triAreaDDFast(t, e, n)), l = A.sqr(n.x).selfAdd(A.sqr(n.y)).selfMultiply(Zo.triAreaDDFast(t, e, s));
            return i.selfSubtract(r).selfAdd(o).selfSubtract(l).doubleValue() > 0;
        }
        static isInCircleCC(t, e, s, n) {
            const i = se.circumcentre(t, e, s), r = t.distance(i);
            return n.distance(i) - r <= 0;
        }
        static isInCircleNormalized(t, e, s, n) {
            const i = t.x - n.x, r = t.y - n.y, o = e.x - n.x, l = e.y - n.y, a = s.x - n.x, c = s.y - n.y;
            return (i * i + r * r) * (o * c - a * l) + (o * o + l * l) * (a * r - i * c) + (a * a + c * c) * (i * l - o * r) > 0;
        }
        static isInCircleDDSlow(t, e, s, n) {
            const i = A.valueOf(n.x), r = A.valueOf(n.y), o = A.valueOf(t.x), l = A.valueOf(t.y), a = A.valueOf(e.x), c = A.valueOf(e.y), h = A.valueOf(s.x), u = A.valueOf(s.y), g = o.multiply(o).add(l.multiply(l)).multiply(Zo.triAreaDDSlow(a, c, h, u, i, r)), d = a.multiply(a).add(c.multiply(c)).multiply(Zo.triAreaDDSlow(o, l, h, u, i, r)), _ = h.multiply(h).add(u.multiply(u)).multiply(Zo.triAreaDDSlow(o, l, a, c, i, r)), p = i.multiply(i).add(r.multiply(r)).multiply(Zo.triAreaDDSlow(o, l, a, c, h, u));
            return g.subtract(d).add(_).subtract(p).doubleValue() > 0;
        }
        static isInCircleNonRobust(t, e, s, n) {
            return (t.x * t.x + t.y * t.y) * Zo.triArea(e, s, n) - (e.x * e.x + e.y * e.y) * Zo.triArea(t, s, n) + (s.x * s.x + s.y * s.y) * Zo.triArea(t, e, n) - (n.x * n.x + n.y * n.y) * Zo.triArea(t, e, s) > 0;
        }
        static isInCircleRobust(t, e, s, n) {
            return Zo.isInCircleNormalized(t, e, s, n);
        }
        static triAreaDDSlow(t, e, s, n, i, r) {
            return s.subtract(t).multiply(r.subtract(e)).subtract(n.subtract(e).multiply(i.subtract(t)));
        }
        static triAreaDDFast(t, e, s) {
            const n = A.valueOf(e.x).selfSubtract(t.x).selfMultiply(A.valueOf(s.y).selfSubtract(t.y)), i = A.valueOf(e.y).selfSubtract(t.y).selfMultiply(A.valueOf(s.x).selfSubtract(t.x));
            return n.selfSubtract(i);
        }
        static triArea(t, e, s) {
            return (e.x - t.x) * (s.y - t.y) - (e.y - t.y) * (s.x - t.x);
        }
        static isInCircleDDNormalized(t, e, s, n) {
            const i = A.valueOf(t.x).selfSubtract(n.x), r = A.valueOf(t.y).selfSubtract(n.y), o = A.valueOf(e.x).selfSubtract(n.x), l = A.valueOf(e.y).selfSubtract(n.y), a = A.valueOf(s.x).selfSubtract(n.x), c = A.valueOf(s.y).selfSubtract(n.y), h = i.multiply(l).selfSubtract(o.multiply(r)), u = o.multiply(c).selfSubtract(a.multiply(l)), g = a.multiply(r).selfSubtract(i.multiply(c)), d = i.multiply(i).selfAdd(r.multiply(r)), _ = o.multiply(o).selfAdd(l.multiply(l)), p = a.multiply(a).selfAdd(c.multiply(c));
            return d.selfMultiply(u).selfAdd(_.selfMultiply(g)).selfAdd(p.selfMultiply(h)).doubleValue() > 0;
        }
    }
    class jo {
        constructor(){
            jo.constructor_.apply(this, arguments);
        }
        static constructor_() {
            if (this._p = null, 1 === arguments.length) {
                const t = arguments[0];
                this._p = new m(t);
            } else if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                this._p = new m(t, e);
            } else if (3 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = arguments[2];
                this._p = new m(t, e, s);
            }
        }
        static interpolateZ() {
            if (3 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = arguments[2], n = e.distance(s), i = t.distance(e), r = s.getZ() - e.getZ();
                return e.getZ() + r * (i / n);
            }
            if (4 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = arguments[2], n = arguments[3], i = e.x, r = e.y, o = s.x - i, l = n.x - i, a = s.y - r, c = n.y - r, h = o * c - l * a, u = t.x - i, g = t.y - r, d = (c * u - l * g) / h, _ = (-a * u + o * g) / h;
                return e.getZ() + d * (s.getZ() - e.getZ()) + _ * (n.getZ() - e.getZ());
            }
        }
        magn() {
            return Math.sqrt(this._p.x * this._p.x + this._p.y * this._p.y);
        }
        equals() {
            if (1 === arguments.length) {
                const t = arguments[0];
                return this._p.x === t.getX() && this._p.y === t.getY();
            }
            if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                return this._p.distance(t.getCoordinate()) < e;
            }
        }
        rightOf(t) {
            return this.isCCW(t.dest(), t.orig());
        }
        isCCW(t, e) {
            return (t._p.x - this._p.x) * (e._p.y - this._p.y) - (t._p.y - this._p.y) * (e._p.x - this._p.x) > 0;
        }
        getX() {
            return this._p.x;
        }
        crossProduct(t) {
            return this._p.x * t.getY() - this._p.y * t.getX();
        }
        setZ(t) {
            this._p.setZ(t);
        }
        times(t) {
            return new jo(t * this._p.x, t * this._p.y);
        }
        cross() {
            return new jo(this._p.y, -this._p.x);
        }
        leftOf(t) {
            return this.isCCW(t.orig(), t.dest());
        }
        getY() {
            return this._p.y;
        }
        classify(t, e) {
            const s = this, n = e.sub(t), i = s.sub(t), r = n.crossProduct(i);
            return r > 0 ? jo.LEFT : r < 0 ? jo.RIGHT : n.getX() * i.getX() < 0 || n.getY() * i.getY() < 0 ? jo.BEHIND : n.magn() < i.magn() ? jo.BEYOND : t.equals(s) ? jo.ORIGIN : e.equals(s) ? jo.DESTINATION : jo.BETWEEN;
        }
        circumRadiusRatio(t, e) {
            const s = this.circleCenter(t, e), n = this.distance(s, t);
            let i = this.distance(this, t), r = this.distance(t, e);
            return r < i && (i = r), r = this.distance(e, this), r < i && (i = r), n / i;
        }
        circleCenter(t, e) {
            const s = new jo(this.getX(), this.getY()), n = this.bisector(s, t), i = this.bisector(t, e), r = new ee(n, i);
            let o = null;
            try {
                o = new jo(r.getX(), r.getY());
            } catch (n) {
                if (!(n instanceof te)) throw n;
                Y.err.println("a: " + s + "  b: " + t + "  c: " + e), Y.err.println(n);
            }
            return o;
        }
        dot(t) {
            return this._p.x * t.getX() + this._p.y * t.getY();
        }
        getZ() {
            return this._p.getZ();
        }
        bisector(t, e) {
            const s = e.getX() - t.getX(), n = e.getY() - t.getY(), i = new ee(t.getX() + s / 2, t.getY() + n / 2, 1), r = new ee(t.getX() - n + s / 2, t.getY() + s + n / 2, 1);
            return new ee(i, r);
        }
        getCoordinate() {
            return this._p;
        }
        isInCircle(t, e, s) {
            return Zo.isInCircleRobust(t._p, e._p, s._p, this._p);
        }
        interpolateZValue(t, e, s) {
            const n = t.getX(), i = t.getY(), r = e.getX() - n, o = s.getX() - n, l = e.getY() - i, a = s.getY() - i, c = r * a - o * l, h = this.getX() - n, u = this.getY() - i, g = (a * h - o * u) / c, d = (-l * h + r * u) / c;
            return t.getZ() + g * (e.getZ() - t.getZ()) + d * (s.getZ() - t.getZ());
        }
        midPoint(t) {
            const e = (this._p.x + t.getX()) / 2, s = (this._p.y + t.getY()) / 2, n = (this._p.getZ() + t.getZ()) / 2;
            return new jo(e, s, n);
        }
        toString() {
            return "POINT (" + this._p.x + " " + this._p.y + ")";
        }
        sub(t) {
            return new jo(this._p.x - t.getX(), this._p.y - t.getY());
        }
        sum(t) {
            return new jo(this._p.x + t.getX(), this._p.y + t.getY());
        }
        distance(t, e) {
            return Math.sqrt(Math.pow(e.getX() - t.getX(), 2) + Math.pow(e.getY() - t.getY(), 2));
        }
    }
    jo.LEFT = 0, jo.RIGHT = 1, jo.BEYOND = 2, jo.BEHIND = 3, jo.BETWEEN = 4, jo.ORIGIN = 5, jo.DESTINATION = 6;
    class Ko extends jo {
        constructor(){
            super(), Ko.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._isOnConstraint = null, this._constraint = null;
            const t = arguments[0];
            jo.constructor_.call(this, t);
        }
        getConstraint() {
            return this._constraint;
        }
        setOnConstraint(t) {
            this._isOnConstraint = t;
        }
        setConstraint(t) {
            this._isOnConstraint = !0, this._constraint = t;
        }
        merge(t) {
            t._isOnConstraint && (this._isOnConstraint = !0, this._constraint = t._constraint);
        }
        isOnConstraint() {
            return this._isOnConstraint;
        }
    }
    class Qo {
        constructor(){
            Qo.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._rot = null, this._vertex = null, this._next = null, this._data = null;
        }
        static swap(t) {
            const e = t.oPrev(), s = t.sym().oPrev();
            Qo.splice(t, e), Qo.splice(t.sym(), s), Qo.splice(t, e.lNext()), Qo.splice(t.sym(), s.lNext()), t.setOrig(e.dest()), t.setDest(s.dest());
        }
        static splice(t, e) {
            const s = t.oNext().rot(), n = e.oNext().rot(), i = e.oNext(), r = t.oNext(), o = n.oNext(), l = s.oNext();
            t.setNext(i), e.setNext(r), s.setNext(o), n.setNext(l);
        }
        static makeEdge(t, e) {
            const s = new Qo, n = new Qo, i = new Qo, r = new Qo;
            s._rot = n, n._rot = i, i._rot = r, r._rot = s, s.setNext(s), n.setNext(r), i.setNext(i), r.setNext(n);
            const o = s;
            return o.setOrig(t), o.setDest(e), o;
        }
        static connect(t, e) {
            const s = Qo.makeEdge(t.dest(), e.orig());
            return Qo.splice(s, t.lNext()), Qo.splice(s.sym(), e), s;
        }
        equalsNonOriented(t) {
            return !!this.equalsOriented(t) || !!this.equalsOriented(t.sym());
        }
        oNext() {
            return this._next;
        }
        equalsOriented(t) {
            return !(!this.orig().getCoordinate().equals2D(t.orig().getCoordinate()) || !this.dest().getCoordinate().equals2D(t.dest().getCoordinate()));
        }
        dNext() {
            return this.sym().oNext().sym();
        }
        lPrev() {
            return this._next.sym();
        }
        rPrev() {
            return this.sym().oNext();
        }
        rot() {
            return this._rot;
        }
        oPrev() {
            return this._rot._next._rot;
        }
        sym() {
            return this._rot._rot;
        }
        setOrig(t) {
            this._vertex = t;
        }
        lNext() {
            return this.invRot().oNext().rot();
        }
        getLength() {
            return this.orig().getCoordinate().distance(this.dest().getCoordinate());
        }
        setData(t) {
            this._data = t;
        }
        getData() {
            return this._data;
        }
        delete() {
            this._rot = null;
        }
        toString() {
            const t = this._vertex.getCoordinate(), e = this.dest().getCoordinate();
            return Wt.toLineString(t, e);
        }
        isLive() {
            return null !== this._rot;
        }
        getPrimary() {
            return this.orig().getCoordinate().compareTo(this.dest().getCoordinate()) <= 0 ? this : this.sym();
        }
        toLineSegment() {
            return new Kt(this._vertex.getCoordinate(), this.dest().getCoordinate());
        }
        dest() {
            return this.sym().orig();
        }
        invRot() {
            return this._rot.sym();
        }
        setDest(t) {
            this.sym().setOrig(t);
        }
        orig() {
            return this._vertex;
        }
        rNext() {
            return this._rot._next.invRot();
        }
        dPrev() {
            return this.invRot().oNext().invRot();
        }
        setNext(t) {
            this._next = t;
        }
    }
    class Jo {
        constructor(){
            Jo.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._subdiv = null, this._isUsingTolerance = !1;
            const t = arguments[0];
            this._subdiv = t, this._isUsingTolerance = t.getTolerance() > 0;
        }
        insertSite(t) {
            let e = this._subdiv.locate(t);
            if (this._subdiv.isVertexOfEdge(e, t)) return e;
            this._subdiv.isOnEdge(e, t.getCoordinate()) && (e = e.oPrev(), this._subdiv.delete(e.oNext()));
            let s = this._subdiv.makeEdge(e.orig(), t);
            Qo.splice(s, e);
            const n = s;
            do s = this._subdiv.connect(e, s.sym()), e = s.oPrev();
            while (e.lNext() !== n);
            for(;;){
                const i = e.oPrev();
                if (i.dest().rightOf(e) && t.isInCircle(e.orig(), i.dest(), e.dest())) Qo.swap(e), e = e.oPrev();
                else {
                    if (e.oNext() === n) return s;
                    e = e.oNext().lPrev();
                }
            }
        }
        insertSites(t) {
            for(let e = t.iterator(); e.hasNext();){
                const t = e.next();
                this.insertSite(t);
            }
        }
    }
    class $o extends a {
        constructor(){
            super(), $o.constructor_.apply(this, arguments);
        }
        static constructor_() {
            if (this._seg = null, 1 === arguments.length) {
                if ("string" == typeof arguments[0]) {
                    const t = arguments[0];
                    a.constructor_.call(this, t);
                } else if (arguments[0] instanceof Kt) {
                    const t = arguments[0];
                    a.constructor_.call(this, "Locate failed to converge (at edge: " + t + ").  Possible causes include invalid Subdivision topology or very close sites"), this._seg = new Kt(t);
                }
            } else if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                a.constructor_.call(this, $o.msgWithSpatial(t, e)), this._seg = new Kt(e);
            }
        }
        static msgWithSpatial(t, e) {
            return null !== e ? t + " [ " + e + " ]" : t;
        }
        getSegment() {
            return this._seg;
        }
    }
    class tl {
        visit(t) {}
    }
    class el {
        constructor(){
            el.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._visitedKey = 0, this._quadEdges = new L, this._startingEdge = null, this._tolerance = null, this._edgeCoincidenceTolerance = null, this._frameVertex = new Array(3).fill(null), this._frameEnv = null, this._locator = null, this._seg = new Kt, this._triEdges = new Array(3).fill(null);
            const t = arguments[0], e = arguments[1];
            this._tolerance = e, this._edgeCoincidenceTolerance = e / el.EDGE_COINCIDENCE_TOL_FACTOR, this.createFrame(t), this._startingEdge = this.initSubdiv(), this._locator = new ko(this);
        }
        static getTriangleEdges(t, e) {
            if (e[0] = t, e[1] = e[0].lNext(), e[2] = e[1].lNext(), e[2].lNext() !== e[0]) throw new n("Edges do not form a triangle");
        }
        getTriangleVertices(t) {
            const e = new il;
            return this.visitTriangles(e, t), e.getTriangleVertices();
        }
        isFrameVertex(t) {
            return !!t.equals(this._frameVertex[0]) || !!t.equals(this._frameVertex[1]) || !!t.equals(this._frameVertex[2]);
        }
        isVertexOfEdge(t, e) {
            return !(!e.equals(t.orig(), this._tolerance) && !e.equals(t.dest(), this._tolerance));
        }
        connect(t, e) {
            const s = Qo.connect(t, e);
            return this._quadEdges.add(s), s;
        }
        visitTriangles(t, e) {
            this._visitedKey++;
            const s = new Zs;
            s.push(this._startingEdge);
            const n = new pt;
            for(; !s.empty();){
                const i = s.pop();
                if (!n.contains(i)) {
                    const r = this.fetchTriangleToVisit(i, s, e, n);
                    null !== r && t.visit(r);
                }
            }
        }
        isFrameEdge(t) {
            return !(!this.isFrameVertex(t.orig()) && !this.isFrameVertex(t.dest()));
        }
        isOnEdge(t, e) {
            this._seg.setCoordinates(t.orig().getCoordinate(), t.dest().getCoordinate());
            return this._seg.distance(e) < this._edgeCoincidenceTolerance;
        }
        getEnvelope() {
            return new O(this._frameEnv);
        }
        getVertexUniqueEdges(t) {
            const e = new L, s = new pt;
            for(let n = this._quadEdges.iterator(); n.hasNext();){
                const i = n.next(), r = i.orig();
                s.contains(r) || (s.add(r), !t && this.isFrameVertex(r) || e.add(i));
                const o = i.sym(), l = o.orig();
                s.contains(l) || (s.add(l), !t && this.isFrameVertex(l) || e.add(o));
            }
            return e;
        }
        locateFromEdge(t, e) {
            let s = 0;
            const n = this._quadEdges.size();
            let i = e;
            for(;;){
                if (s++, s > n) throw new $o(i.toLineSegment());
                if (t.equals(i.orig()) || t.equals(i.dest())) break;
                if (t.rightOf(i)) i = i.sym();
                else if (t.rightOf(i.oNext())) {
                    if (t.rightOf(i.dPrev())) break;
                    i = i.dPrev();
                } else i = i.oNext();
            }
            return i;
        }
        getVoronoiDiagram(t) {
            const e = this.getVoronoiCellPolygons(t);
            return t.createGeometryCollection(Lt.toGeometryArray(e));
        }
        getTriangles(t) {
            const e = this.getTriangleCoordinates(!1), s = new Array(e.size()).fill(null);
            let n = 0;
            for(let i = e.iterator(); i.hasNext();){
                const e = i.next();
                s[n++] = t.createPolygon(t.createLinearRing(e));
            }
            return t.createGeometryCollection(s);
        }
        getVoronoiCellPolygon(t, e) {
            const s = new L, n = t;
            do {
                const e = t.rot().orig().getCoordinate();
                s.add(e), t = t.oPrev();
            }while (t !== n);
            const i = new R;
            i.addAll(s, !1), i.closeRing(), i.size() < 4 && (Y.out.println(i), i.add(i.get(i.size() - 1), !0));
            const r = i.toCoordinateArray(), o = e.createPolygon(e.createLinearRing(r)), l = n.orig();
            return o.setUserData(l.getCoordinate()), o;
        }
        setLocator(t) {
            this._locator = t;
        }
        initSubdiv() {
            const t = this.makeEdge(this._frameVertex[0], this._frameVertex[1]), e = this.makeEdge(this._frameVertex[1], this._frameVertex[2]);
            Qo.splice(t.sym(), e);
            const s = this.makeEdge(this._frameVertex[2], this._frameVertex[0]);
            return Qo.splice(e.sym(), s), Qo.splice(s.sym(), t), t;
        }
        isFrameBorderEdge(t) {
            const e = new Array(3).fill(null);
            el.getTriangleEdges(t, e);
            const s = new Array(3).fill(null);
            el.getTriangleEdges(t.sym(), s);
            const n = t.lNext().dest();
            if (this.isFrameVertex(n)) return !0;
            const i = t.sym().lNext().dest();
            return !!this.isFrameVertex(i);
        }
        makeEdge(t, e) {
            const s = Qo.makeEdge(t, e);
            return this._quadEdges.add(s), s;
        }
        createFrame(t) {
            const e = t.getWidth(), s = t.getHeight();
            let n = 0;
            n = e > s ? 10 * e : 10 * s, this._frameVertex[0] = new jo((t.getMaxX() + t.getMinX()) / 2, t.getMaxY() + n), this._frameVertex[1] = new jo(t.getMinX() - n, t.getMinY() - n), this._frameVertex[2] = new jo(t.getMaxX() + n, t.getMinY() - n), this._frameEnv = new O(this._frameVertex[0].getCoordinate(), this._frameVertex[1].getCoordinate()), this._frameEnv.expandToInclude(this._frameVertex[2].getCoordinate());
        }
        getTriangleCoordinates(t) {
            const e = new rl;
            return this.visitTriangles(e, t), e.getTriangles();
        }
        getVertices(t) {
            const e = new pt;
            for(let s = this._quadEdges.iterator(); s.hasNext();){
                const n = s.next(), i = n.orig();
                !t && this.isFrameVertex(i) || e.add(i);
                const r = n.dest();
                !t && this.isFrameVertex(r) || e.add(r);
            }
            return e;
        }
        fetchTriangleToVisit(t, e, s, n) {
            let i = t, r = 0, o = !1;
            do {
                this._triEdges[r] = i, this.isFrameEdge(i) && (o = !0);
                const t = i.sym();
                n.contains(t) || e.push(t), n.add(i), r++, i = i.lNext();
            }while (i !== t);
            return o && !s ? null : this._triEdges;
        }
        getEdges() {
            if (0 === arguments.length) return this._quadEdges;
            if (1 === arguments.length) {
                const t = arguments[0], e = this.getPrimaryEdges(!1), s = new Array(e.size()).fill(null);
                let n = 0;
                for(let i = e.iterator(); i.hasNext();){
                    const e = i.next();
                    s[n++] = t.createLineString([
                        e.orig().getCoordinate(),
                        e.dest().getCoordinate()
                    ]);
                }
                return t.createMultiLineString(s);
            }
        }
        getTriangleEdges(t) {
            const e = new nl;
            return this.visitTriangles(e, t), e.getTriangleEdges();
        }
        getPrimaryEdges(t) {
            this._visitedKey++;
            const e = new L, s = new Zs;
            s.push(this._startingEdge);
            const n = new pt;
            for(; !s.empty();){
                const i = s.pop();
                if (!n.contains(i)) {
                    const r = i.getPrimary();
                    !t && this.isFrameEdge(r) || e.add(r), s.push(i.oNext()), s.push(i.sym().oNext()), n.add(i), n.add(i.sym());
                }
            }
            return e;
        }
        delete(t) {
            Qo.splice(t, t.oPrev()), Qo.splice(t.sym(), t.sym().oPrev());
            const e = t.sym(), s = t.rot(), n = t.rot().sym();
            this._quadEdges.remove(t), this._quadEdges.remove(e), this._quadEdges.remove(s), this._quadEdges.remove(n), t.delete(), e.delete(), s.delete(), n.delete();
        }
        getTolerance() {
            return this._tolerance;
        }
        getVoronoiCellPolygons(t) {
            this.visitTriangles(new sl, !0);
            const e = new L;
            for(let s = this.getVertexUniqueEdges(!1).iterator(); s.hasNext();){
                const n = s.next();
                e.add(this.getVoronoiCellPolygon(n, t));
            }
            return e;
        }
        insertSite(t) {
            let e = this.locate(t);
            if (t.equals(e.orig(), this._tolerance) || t.equals(e.dest(), this._tolerance)) return e;
            let s = this.makeEdge(e.orig(), t);
            Qo.splice(s, e);
            const n = s;
            do s = this.connect(e, s.sym()), e = s.oPrev();
            while (e.lNext() !== n);
            return n;
        }
        locate() {
            if (1 === arguments.length) {
                if (arguments[0] instanceof jo) {
                    const t = arguments[0];
                    return this._locator.locate(t);
                }
                if (arguments[0] instanceof m) {
                    const t = arguments[0];
                    return this._locator.locate(new jo(t));
                }
            } else if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = this._locator.locate(new jo(t));
                if (null === s) return null;
                let n = s;
                s.dest().getCoordinate().equals2D(t) && (n = s.sym());
                let i = n;
                do {
                    if (i.dest().getCoordinate().equals2D(e)) return i;
                    i = i.oNext();
                }while (i !== n);
                return null;
            }
        }
    }
    class sl {
        visit(t) {
            const e = t[0].orig().getCoordinate(), s = t[1].orig().getCoordinate(), n = t[2].orig().getCoordinate(), i = se.circumcentreDD(e, s, n), r = new jo(i);
            for(let e = 0; e < 3; e++)t[e].rot().setOrig(r);
        }
        get interfaces_() {
            return [
                tl
            ];
        }
    }
    class nl {
        constructor(){
            nl.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._triList = new L;
        }
        getTriangleEdges() {
            return this._triList;
        }
        visit(t) {
            this._triList.add(t);
        }
        get interfaces_() {
            return [
                tl
            ];
        }
    }
    class il {
        constructor(){
            il.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._triList = new L;
        }
        getTriangleVertices() {
            return this._triList;
        }
        visit(t) {
            this._triList.add([
                t[0].orig(),
                t[1].orig(),
                t[2].orig()
            ]);
        }
        get interfaces_() {
            return [
                tl
            ];
        }
    }
    class rl {
        constructor(){
            rl.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._coordList = new R, this._triCoords = new L;
        }
        checkTriangleSize(t) {
            t.length >= 2 ? Wt.toLineString(t[0], t[1]) : t.length >= 1 && Wt.toPoint(t[0]);
        }
        visit(t) {
            this._coordList.clear();
            for(let e = 0; e < 3; e++){
                const s = t[e].orig();
                this._coordList.add(s.getCoordinate());
            }
            if (this._coordList.size() > 0) {
                this._coordList.closeRing();
                const t = this._coordList.toCoordinateArray();
                if (4 !== t.length) return null;
                this._triCoords.add(t);
            }
        }
        getTriangles() {
            return this._triCoords;
        }
        get interfaces_() {
            return [
                tl
            ];
        }
    }
    el.TriangleCircumcentreVisitor = sl, el.TriangleEdgesListVisitor = nl, el.TriangleVertexListVisitor = il, el.TriangleCoordinatesVisitor = rl, el.EDGE_COINCIDENCE_TOL_FACTOR = 1e3;
    class ll extends a {
        constructor(){
            super(), ll.constructor_.apply(this, arguments);
        }
        static constructor_() {
            if (this._pt = null, 1 === arguments.length) {
                const t = arguments[0];
                a.constructor_.call(this, t);
            } else if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                a.constructor_.call(this, ll.msgWithCoord(t, e)), this._pt = new m(e);
            }
        }
        static msgWithCoord(t, e) {
            return null !== e ? t + " [ " + Wt.toPoint(e) + " ]" : t;
        }
        getCoordinate() {
            return this._pt;
        }
    }
    class al {
        constructor(){
            al.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._initialVertices = null, this._segVertices = null, this._segments = new L, this._subdiv = null, this._incDel = null, this._convexHull = null, this._splitFinder = new Wo, this._kdt = null, this._vertexFactory = null, this._computeAreaEnv = null, this._splitPt = null, this._tolerance = null;
            const t = arguments[0], e = arguments[1];
            this._initialVertices = new L(t), this._tolerance = e, this._kdt = new qi(e);
        }
        static computeVertexEnvelope(t) {
            const e = new O;
            for(let s = t.iterator(); s.hasNext();){
                const t = s.next();
                e.expandToInclude(t.getCoordinate());
            }
            return e;
        }
        getInitialVertices() {
            return this._initialVertices;
        }
        getKDT() {
            return this._kdt;
        }
        setConstraints(t, e) {
            this._segments = t, this._segVertices = e;
        }
        computeConvexHull() {
            const t = new Lt, e = this.getPointArray(), s = new _i(e, t);
            this._convexHull = s.getConvexHull();
        }
        addConstraintVertices() {
            this.computeConvexHull(), this.insertSites(this._segVertices);
        }
        getTolerance() {
            return this._tolerance;
        }
        setVertexFactory(t) {
            this._vertexFactory = t;
        }
        formInitialDelaunay() {
            this.computeBoundingBox(), this._subdiv = new el(this._computeAreaEnv, this._tolerance), this._subdiv.setLocator(new ko(this._subdiv)), this._incDel = new Jo(this._subdiv), this.insertSites(this._initialVertices);
        }
        insertSite() {
            if (arguments[0] instanceof Ko) {
                const t = arguments[0], e = this._kdt.insert(t.getCoordinate(), t);
                if (e.isRepeated()) {
                    const s = e.getData();
                    return s.merge(t), s;
                }
                return this._incDel.insertSite(t), t;
            }
            if (arguments[0] instanceof m) {
                const t = arguments[0];
                this.insertSite(this.createVertex(t));
            }
        }
        enforceConstraints() {
            this.addConstraintVertices();
            let t = 0, e = 0;
            do e = this.enforceGabriel(this._segments), t++;
            while (e > 0 && t < al.MAX_SPLIT_ITER);
            if (t === al.MAX_SPLIT_ITER) throw new ll("Too many splitting iterations while enforcing constraints.  Last split point was at: ", this._splitPt);
        }
        insertSites(t) {
            for(let e = t.iterator(); e.hasNext();){
                const t = e.next();
                this.insertSite(t);
            }
        }
        getVertexFactory() {
            return this._vertexFactory;
        }
        getPointArray() {
            const t = new Array(this._initialVertices.size() + this._segVertices.size()).fill(null);
            let e = 0;
            for(let s = this._initialVertices.iterator(); s.hasNext();){
                const n = s.next();
                t[e++] = n.getCoordinate();
            }
            for(let s = this._segVertices.iterator(); s.hasNext();){
                const n = s.next();
                t[e++] = n.getCoordinate();
            }
            return t;
        }
        findNonGabrielPoint(t) {
            const e = t.getStart(), s = t.getEnd(), n = new m((e.x + s.x) / 2, (e.y + s.y) / 2), i = e.distance(n), o = new O(n);
            o.expandBy(i);
            const l = this._kdt.query(o);
            let a = null, c = r.MAX_VALUE;
            for(let t = l.iterator(); t.hasNext();){
                const r = t.next().getCoordinate();
                if (r.equals2D(e) || r.equals2D(s)) continue;
                const o = n.distance(r);
                if (o < i) (null === a || o < c) && (a = r, c = o);
            }
            return a;
        }
        getConstraintSegments() {
            return this._segments;
        }
        setSplitPointFinder(t) {
            this._splitFinder = t;
        }
        getConvexHull() {
            return this._convexHull;
        }
        enforceGabriel(t) {
            const e = new L;
            let s = 0;
            const n = new L;
            for(let i = t.iterator(); i.hasNext();){
                const t = i.next(), r = this.findNonGabrielPoint(t);
                if (null === r) continue;
                this._splitPt = this._splitFinder.findSplitPoint(t, r);
                const o = this.createVertex(this._splitPt, t);
                this.insertSite(o).getCoordinate().equals2D(this._splitPt);
                const l = new Xo(t.getStartX(), t.getStartY(), t.getStartZ(), o.getX(), o.getY(), o.getZ(), t.getData()), a = new Xo(o.getX(), o.getY(), o.getZ(), t.getEndX(), t.getEndY(), t.getEndZ(), t.getData());
                e.add(l), e.add(a), n.add(t), s += 1;
            }
            return t.removeAll(n), t.addAll(e), s;
        }
        createVertex() {
            if (1 === arguments.length) {
                const t = arguments[0];
                let e = null;
                return e = null !== this._vertexFactory ? this._vertexFactory.createVertex(t, null) : new Ko(t), e;
            }
            if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                let s = null;
                return s = null !== this._vertexFactory ? this._vertexFactory.createVertex(t, e) : new Ko(t), s.setOnConstraint(!0), s;
            }
        }
        getSubdivision() {
            return this._subdiv;
        }
        computeBoundingBox() {
            const t = al.computeVertexEnvelope(this._initialVertices), e = al.computeVertexEnvelope(this._segVertices), s = new O(t);
            s.expandToInclude(e);
            const n = .2 * s.getWidth(), i = .2 * s.getHeight(), r = Math.max(n, i);
            this._computeAreaEnv = new O(s), this._computeAreaEnv.expandBy(r);
        }
    }
    al.MAX_SPLIT_ITER = 99;
    class cl {
        constructor(){
            cl.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._siteCoords = null, this._tolerance = 0, this._subdiv = null;
        }
        static envelope(t) {
            const e = new O;
            for(let s = t.iterator(); s.hasNext();){
                const t = s.next();
                e.expandToInclude(t);
            }
            return e;
        }
        static unique(t) {
            const e = W.copyDeep(t);
            ht.sort(e);
            return new R(e, !1);
        }
        static extractUniqueCoordinates(t) {
            if (null === t) return new R;
            const e = t.getCoordinates();
            return cl.unique(e);
        }
        static toVertices(t) {
            const e = new L;
            for(let s = t.iterator(); s.hasNext();){
                const t = s.next();
                e.add(new jo(t));
            }
            return e;
        }
        create() {
            if (null !== this._subdiv) return null;
            const t = cl.envelope(this._siteCoords), e = cl.toVertices(this._siteCoords);
            this._subdiv = new el(t, this._tolerance);
            new Jo(this._subdiv).insertSites(e);
        }
        setTolerance(t) {
            this._tolerance = t;
        }
        setSites() {
            if (arguments[0] instanceof j) {
                const t = arguments[0];
                this._siteCoords = cl.extractUniqueCoordinates(t);
            } else if (I(arguments[0], N)) {
                const t = arguments[0];
                this._siteCoords = cl.unique(W.toCoordinateArray(t));
            }
        }
        getEdges(t) {
            return this.create(), this._subdiv.getEdges(t);
        }
        getSubdivision() {
            return this.create(), this._subdiv;
        }
        getTriangles(t) {
            return this.create(), this._subdiv.getTriangles(t);
        }
    }
    class hl {
        constructor(){
            hl.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._siteCoords = null, this._constraintLines = null, this._tolerance = 0, this._subdiv = null, this._constraintVertexMap = new os;
        }
        static createConstraintSegments() {
            if (1 === arguments.length) {
                const t = arguments[0], e = ye.getLines(t), s = new L;
                for(let t = e.iterator(); t.hasNext();){
                    const e = t.next();
                    hl.createConstraintSegments(e, s);
                }
                return s;
            }
            if (2 === arguments.length) {
                const t = arguments[1], e = arguments[0].getCoordinates();
                for(let s = 1; s < e.length; s++)t.add(new Xo(e[s - 1], e[s]));
            }
        }
        createSiteVertices(t) {
            const e = new L;
            for(let s = t.iterator(); s.hasNext();){
                const t = s.next();
                this._constraintVertexMap.containsKey(t) || e.add(new Ko(t));
            }
            return e;
        }
        create() {
            if (null !== this._subdiv) return null;
            const t = cl.envelope(this._siteCoords);
            let e = new L;
            null !== this._constraintLines && (t.expandToInclude(this._constraintLines.getEnvelopeInternal()), this.createVertices(this._constraintLines), e = hl.createConstraintSegments(this._constraintLines));
            const s = this.createSiteVertices(this._siteCoords), n = new al(s, this._tolerance);
            n.setConstraints(e, new L(this._constraintVertexMap.values())), n.formInitialDelaunay(), n.enforceConstraints(), this._subdiv = n.getSubdivision();
        }
        setTolerance(t) {
            this._tolerance = t;
        }
        setConstraints(t) {
            this._constraintLines = t;
        }
        setSites(t) {
            this._siteCoords = cl.extractUniqueCoordinates(t);
        }
        getEdges(t) {
            return this.create(), this._subdiv.getEdges(t);
        }
        getSubdivision() {
            return this.create(), this._subdiv;
        }
        getTriangles(t) {
            return this.create(), this._subdiv.getTriangles(t);
        }
        createVertices(t) {
            const e = t.getCoordinates();
            for(let t = 0; t < e.length; t++){
                const s = new Ko(e[t]);
                this._constraintVertexMap.put(e[t], s);
            }
        }
    }
    class ul {
        constructor(){
            ul.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._siteCoords = null, this._tolerance = 0, this._subdiv = null, this._clipEnv = null, this._diagramEnv = null;
        }
        static clipGeometryCollection(t, e) {
            const s = t.getFactory().toGeometry(e), n = new L;
            for(let i = 0; i < t.getNumGeometries(); i++){
                const r = t.getGeometryN(i);
                let o = null;
                e.contains(r.getEnvelopeInternal()) ? o = r : e.intersects(r.getEnvelopeInternal()) && (o = oi.intersection(s, r), o.setUserData(r.getUserData())), null === o || o.isEmpty() || n.add(o);
            }
            return t.getFactory().createGeometryCollection(Lt.toGeometryArray(n));
        }
        create() {
            if (null !== this._subdiv) return null;
            const t = cl.envelope(this._siteCoords);
            if (this._diagramEnv = this._clipEnv, null === this._diagramEnv) {
                this._diagramEnv = t;
                const e = this._diagramEnv.getDiameter();
                this._diagramEnv.expandBy(e);
            }
            const e = cl.toVertices(this._siteCoords);
            this._subdiv = new el(t, this._tolerance);
            new Jo(this._subdiv).insertSites(e);
        }
        setSites() {
            if (arguments[0] instanceof j) {
                const t = arguments[0];
                this._siteCoords = cl.extractUniqueCoordinates(t);
            } else if (I(arguments[0], N)) {
                const t = arguments[0];
                this._siteCoords = cl.unique(W.toCoordinateArray(t));
            }
        }
        setClipEnvelope(t) {
            this._clipEnv = t;
        }
        getSubdivision() {
            return this.create(), this._subdiv;
        }
        getDiagram(t) {
            this.create();
            const e = this._subdiv.getVoronoiDiagram(t);
            return ul.clipGeometryCollection(e, this._diagramEnv);
        }
        setTolerance(t) {
            this._tolerance = t;
        }
    }
    var gl = Object.freeze({
        __proto__: null,
        Vertex: jo
    }), dl = Object.freeze({
        __proto__: null,
        ConformingDelaunayTriangulationBuilder: hl,
        DelaunayTriangulationBuilder: cl,
        VoronoiDiagramBuilder: ul,
        quadedge: gl
    });
    class _l {
        constructor(){
            _l.constructor_.apply(this, arguments);
        }
        static constructor_() {
            if (this._linearGeom = null, this._numLines = null, this._currentLine = null, this._componentIndex = 0, this._vertexIndex = 0, 1 === arguments.length) {
                const t = arguments[0];
                _l.constructor_.call(this, t, 0, 0);
            } else if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                _l.constructor_.call(this, t, e.getComponentIndex(), _l.segmentEndVertexIndex(e));
            } else if (3 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = arguments[2];
                if (!I(t, Q)) throw new n("Lineal geometry is required");
                this._linearGeom = t, this._numLines = t.getNumGeometries(), this._componentIndex = e, this._vertexIndex = s, this.loadCurrentLine();
            }
        }
        static segmentEndVertexIndex(t) {
            return t.getSegmentFraction() > 0 ? t.getSegmentIndex() + 1 : t.getSegmentIndex();
        }
        getComponentIndex() {
            return this._componentIndex;
        }
        getLine() {
            return this._currentLine;
        }
        getVertexIndex() {
            return this._vertexIndex;
        }
        getSegmentEnd() {
            return this._vertexIndex < this.getLine().getNumPoints() - 1 ? this._currentLine.getCoordinateN(this._vertexIndex + 1) : null;
        }
        next() {
            if (!this.hasNext()) return null;
            this._vertexIndex++, this._vertexIndex >= this._currentLine.getNumPoints() && (this._componentIndex++, this.loadCurrentLine(), this._vertexIndex = 0);
        }
        loadCurrentLine() {
            if (this._componentIndex >= this._numLines) return this._currentLine = null, null;
            this._currentLine = this._linearGeom.getGeometryN(this._componentIndex);
        }
        getSegmentStart() {
            return this._currentLine.getCoordinateN(this._vertexIndex);
        }
        isEndOfLine() {
            return !(this._componentIndex >= this._numLines) && !(this._vertexIndex < this._currentLine.getNumPoints() - 1);
        }
        hasNext() {
            return !(this._componentIndex >= this._numLines) && !(this._componentIndex === this._numLines - 1 && this._vertexIndex >= this._currentLine.getNumPoints());
        }
    }
    class pl {
        constructor(){
            pl.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._linearGeom = null;
            const t = arguments[0];
            this._linearGeom = t;
        }
        static indexOf(t, e) {
            return new pl(t).indexOf(e);
        }
        static indexOfAfter(t, e, s) {
            return new pl(t).indexOfAfter(e, s);
        }
        segmentNearestMeasure(t, e, s) {
            const n = t.projectionFactor(e);
            return n <= 0 ? s : n <= 1 ? s + n * t.getLength() : s + t.getLength();
        }
        indexOfFromStart(t, e) {
            let s = r.MAX_VALUE, n = e, i = 0;
            const o = new Kt, l = new _l(this._linearGeom);
            for(; l.hasNext();){
                if (!l.isEndOfLine()) {
                    o.p0 = l.getSegmentStart(), o.p1 = l.getSegmentEnd();
                    const r = o.distance(t), a = this.segmentNearestMeasure(o, t, i);
                    r < s && a > e && (n = a, s = r), i += o.getLength();
                }
                l.next();
            }
            return n;
        }
        indexOf(t) {
            return this.indexOfFromStart(t, -1);
        }
        indexOfAfter(t, e) {
            if (e < 0) return this.indexOf(t);
            const s = this._linearGeom.getLength();
            if (s < e) return s;
            const n = this.indexOfFromStart(t, e);
            return h.isTrue(n >= e, "computed index is before specified minimum index"), n;
        }
    }
    class ml {
        constructor(){
            ml.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._geomFact = null, this._lines = new L, this._coordList = null, this._ignoreInvalidLines = !1, this._fixInvalidLines = !1, this._lastPt = null;
            const t = arguments[0];
            this._geomFact = t;
        }
        getGeometry() {
            return this.endLine(), this._geomFact.buildGeometry(this._lines);
        }
        getLastCoordinate() {
            return this._lastPt;
        }
        endLine() {
            if (null === this._coordList) return null;
            if (this._ignoreInvalidLines && this._coordList.size() < 2) return this._coordList = null, null;
            const t = this._coordList.toCoordinateArray();
            let e = t;
            this._fixInvalidLines && (e = this.validCoordinateSequence(t)), this._coordList = null;
            let s = null;
            try {
                s = this._geomFact.createLineString(e);
            } catch (t) {
                if (!(t instanceof n)) throw t;
                if (!this._ignoreInvalidLines) throw t;
            }
            null !== s && this._lines.add(s);
        }
        setFixInvalidLines(t) {
            this._fixInvalidLines = t;
        }
        add() {
            if (1 === arguments.length) {
                const t = arguments[0];
                this.add(t, !0);
            } else if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                null === this._coordList && (this._coordList = new R), this._coordList.add(t, e), this._lastPt = t;
            }
        }
        setIgnoreInvalidLines(t) {
            this._ignoreInvalidLines = t;
        }
        validCoordinateSequence(t) {
            if (t.length >= 2) return t;
            return [
                t[0],
                t[0]
            ];
        }
    }
    class fl {
        constructor(){
            fl.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._line = null;
            const t = arguments[0];
            this._line = t;
        }
        static extract(t, e, s) {
            return new fl(t).extract(e, s);
        }
        extract(t, e) {
            return e.compareTo(t) < 0 ? this.reverse(this.computeLinear(e, t)) : this.computeLinear(t, e);
        }
        computeLine(t, e) {
            const s = this._line.getCoordinates(), n = new R;
            let i = t.getSegmentIndex();
            t.getSegmentFraction() > 0 && (i += 1);
            let r = e.getSegmentIndex();
            1 === e.getSegmentFraction() && (r += 1), r >= s.length && (r = s.length - 1), t.isVertex() || n.add(t.getCoordinate(this._line));
            for(let t = i; t <= r; t++)n.add(s[t]);
            e.isVertex() || n.add(e.getCoordinate(this._line)), n.size() <= 0 && n.add(t.getCoordinate(this._line));
            let o = n.toCoordinateArray();
            return o.length <= 1 && (o = [
                o[0],
                o[0]
            ]), this._line.getFactory().createLineString(o);
        }
        reverse(t) {
            return I(t, Q) ? t.reverse() : (h.shouldNeverReachHere("non-linear geometry encountered"), null);
        }
        computeLinear(t, e) {
            const s = new ml(this._line.getFactory());
            s.setFixInvalidLines(!0), t.isVertex() || s.add(t.getCoordinate(this._line));
            for(let n = new _l(this._line, t); n.hasNext() && !(e.compareLocationValues(n.getComponentIndex(), n.getVertexIndex(), 0) < 0); n.next()){
                const t = n.getSegmentStart();
                s.add(t), n.isEndOfLine() && s.endLine();
            }
            return e.isVertex() || s.add(e.getCoordinate(this._line)), s.getGeometry();
        }
    }
    class yl {
        constructor(){
            yl.constructor_.apply(this, arguments);
        }
        static constructor_() {
            if (this._componentIndex = 0, this._segmentIndex = 0, this._segmentFraction = 0, 0 === arguments.length) ;
            else if (1 === arguments.length) {
                const t = arguments[0];
                this._componentIndex = t._componentIndex, this._segmentIndex = t._segmentIndex, this._segmentFraction = t._segmentFraction;
            } else if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                yl.constructor_.call(this, 0, t, e);
            } else if (3 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = arguments[2];
                this._componentIndex = t, this._segmentIndex = e, this._segmentFraction = s, this.normalize();
            } else if (4 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = arguments[2], n = arguments[3];
                this._componentIndex = t, this._segmentIndex = e, this._segmentFraction = s, n && this.normalize();
            }
        }
        static numSegments(t) {
            const e = t.getNumPoints();
            return e <= 1 ? 0 : e - 1;
        }
        static compareLocationValues(t, e, s, n, i, r) {
            return t < n ? -1 : t > n ? 1 : e < i ? -1 : e > i ? 1 : s < r ? -1 : s > r ? 1 : 0;
        }
        static pointAlongSegmentByFraction(t, e, s) {
            if (s <= 0) return t;
            if (s >= 1) return e;
            const n = (e.x - t.x) * s + t.x, i = (e.y - t.y) * s + t.y, r = (e.getZ() - t.getZ()) * s + t.getZ();
            return new m(n, i, r);
        }
        static getEndLocation(t) {
            const e = new yl;
            return e.setToEnd(t), e;
        }
        getSegmentIndex() {
            return this._segmentIndex;
        }
        getComponentIndex() {
            return this._componentIndex;
        }
        getSegmentFraction() {
            return this._segmentFraction;
        }
        setToEnd(t) {
            this._componentIndex = t.getNumGeometries() - 1;
            const e = t.getGeometryN(this._componentIndex);
            this._segmentIndex = yl.numSegments(e), this._segmentFraction = 0;
        }
        compareTo(t) {
            const e = t;
            return this._componentIndex < e._componentIndex ? -1 : this._componentIndex > e._componentIndex ? 1 : this._segmentIndex < e._segmentIndex ? -1 : this._segmentIndex > e._segmentIndex ? 1 : this._segmentFraction < e._segmentFraction ? -1 : this._segmentFraction > e._segmentFraction ? 1 : 0;
        }
        copy() {
            return new yl(this._componentIndex, this._segmentIndex, this._segmentFraction);
        }
        toString() {
            return "LinearLoc[" + this._componentIndex + ", " + this._segmentIndex + ", " + this._segmentFraction + "]";
        }
        compareLocationValues(t, e, s) {
            return this._componentIndex < t ? -1 : this._componentIndex > t ? 1 : this._segmentIndex < e ? -1 : this._segmentIndex > e ? 1 : this._segmentFraction < s ? -1 : this._segmentFraction > s ? 1 : 0;
        }
        getSegmentLength(t) {
            const e = t.getGeometryN(this._componentIndex);
            let s = this._segmentIndex;
            this._segmentIndex >= yl.numSegments(e) && (s = e.getNumPoints() - 2);
            const n = e.getCoordinateN(s), i = e.getCoordinateN(s + 1);
            return n.distance(i);
        }
        isVertex() {
            return this._segmentFraction <= 0 || this._segmentFraction >= 1;
        }
        isEndpoint(t) {
            const e = t.getGeometryN(this._componentIndex), s = yl.numSegments(e);
            return this._segmentIndex >= s || this._segmentIndex === s - 1 && this._segmentFraction >= 1;
        }
        isValid(t) {
            if (this._componentIndex < 0 || this._componentIndex >= t.getNumGeometries()) return !1;
            const e = t.getGeometryN(this._componentIndex);
            return !(this._segmentIndex < 0 || this._segmentIndex > e.getNumPoints()) && (this._segmentIndex !== e.getNumPoints() || 0 === this._segmentFraction) && !(this._segmentFraction < 0 || this._segmentFraction > 1);
        }
        normalize() {
            this._segmentFraction < 0 && (this._segmentFraction = 0), this._segmentFraction > 1 && (this._segmentFraction = 1), this._componentIndex < 0 && (this._componentIndex = 0, this._segmentIndex = 0, this._segmentFraction = 0), this._segmentIndex < 0 && (this._segmentIndex = 0, this._segmentFraction = 0), 1 === this._segmentFraction && (this._segmentFraction = 0, this._segmentIndex += 1);
        }
        toLowest(t) {
            const e = t.getGeometryN(this._componentIndex), s = yl.numSegments(e);
            return this._segmentIndex < s ? this : new yl(this._componentIndex, s - 1, 1, !1);
        }
        getCoordinate(t) {
            const e = t.getGeometryN(this._componentIndex), s = e.getCoordinateN(this._segmentIndex);
            if (this._segmentIndex >= yl.numSegments(e)) return s;
            const n = e.getCoordinateN(this._segmentIndex + 1);
            return yl.pointAlongSegmentByFraction(s, n, this._segmentFraction);
        }
        getSegment(t) {
            const e = t.getGeometryN(this._componentIndex), s = e.getCoordinateN(this._segmentIndex);
            if (this._segmentIndex >= yl.numSegments(e)) {
                const t = e.getCoordinateN(e.getNumPoints() - 2);
                return new Kt(t, s);
            }
            const n = e.getCoordinateN(this._segmentIndex + 1);
            return new Kt(s, n);
        }
        clamp(t) {
            if (this._componentIndex >= t.getNumGeometries()) return this.setToEnd(t), null;
            if (this._segmentIndex >= t.getNumPoints()) {
                const e = t.getGeometryN(this._componentIndex);
                this._segmentIndex = yl.numSegments(e), this._segmentFraction = 1;
            }
        }
        isOnSameSegment(t) {
            return this._componentIndex === t._componentIndex && (this._segmentIndex === t._segmentIndex || t._segmentIndex - this._segmentIndex == 1 && 0 === t._segmentFraction || this._segmentIndex - t._segmentIndex == 1 && 0 === this._segmentFraction);
        }
        snapToVertex(t, e) {
            if (this._segmentFraction <= 0 || this._segmentFraction >= 1) return null;
            const s = this.getSegmentLength(t), n = this._segmentFraction * s, i = s - n;
            n <= i && n < e ? this._segmentFraction = 0 : i <= n && i < e && (this._segmentFraction = 1);
        }
        get interfaces_() {
            return [
                o
            ];
        }
    }
    class xl {
        constructor(){
            xl.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._linearGeom = null;
            const t = arguments[0];
            this._linearGeom = t;
        }
        static indexOf(t, e) {
            return new xl(t).indexOf(e);
        }
        static indexOfAfter(t, e, s) {
            return new xl(t).indexOfAfter(e, s);
        }
        indexOfFromStart(t, e) {
            let s = r.MAX_VALUE, n = 0, i = 0, o = -1;
            const l = new Kt;
            for(let r = new _l(this._linearGeom); r.hasNext(); r.next())if (!r.isEndOfLine()) {
                l.p0 = r.getSegmentStart(), l.p1 = r.getSegmentEnd();
                const a = l.distance(t), c = l.segmentFraction(t), h = r.getComponentIndex(), u = r.getVertexIndex();
                a < s && (null === e || e.compareLocationValues(h, u, c) < 0) && (n = h, i = u, o = c, s = a);
            }
            if (s === r.MAX_VALUE) return new yl(e);
            return new yl(n, i, o);
        }
        indexOf(t) {
            return this.indexOfFromStart(t, null);
        }
        indexOfAfter(t, e) {
            if (null === e) return this.indexOf(t);
            const s = yl.getEndLocation(this._linearGeom);
            if (s.compareTo(e) <= 0) return s;
            const n = this.indexOfFromStart(t, e);
            return h.isTrue(n.compareTo(e) >= 0, "computed location is before specified minimum location"), n;
        }
    }
    class El {
        constructor(){
            El.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._linearGeom = null;
            const t = arguments[0];
            this._linearGeom = t;
        }
        static indicesOf(t, e) {
            return new El(t).indicesOf(e);
        }
        indicesOf(t) {
            const e = t.getGeometryN(0).getCoordinateN(0), s = t.getGeometryN(t.getNumGeometries() - 1), n = s.getCoordinateN(s.getNumPoints() - 1), i = new xl(this._linearGeom), r = new Array(2).fill(null);
            return r[0] = i.indexOf(e), 0 === t.getLength() ? r[1] = r[0].copy() : r[1] = i.indexOfAfter(n, r[0]), r;
        }
    }
    class Il {
        constructor(){
            Il.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._linearGeom = null;
            const t = arguments[0];
            this._linearGeom = t;
        }
        static getLocation() {
            if (2 === arguments.length) {
                const t = arguments[1];
                return new Il(arguments[0]).getLocation(t);
            }
            if (3 === arguments.length) {
                const t = arguments[1], e = arguments[2];
                return new Il(arguments[0]).getLocation(t, e);
            }
        }
        static getLength(t, e) {
            return new Il(t).getLength(e);
        }
        getLocation() {
            if (1 === arguments.length) {
                const t = arguments[0];
                return this.getLocation(t, !0);
            }
            if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                let s = t;
                if (t < 0) s = this._linearGeom.getLength() + t;
                const n = this.getLocationForward(s);
                return e ? n : this.resolveHigher(n);
            }
        }
        getLocationForward(t) {
            if (t <= 0) return new yl;
            let e = 0;
            const s = new _l(this._linearGeom);
            for(; s.hasNext();){
                if (s.isEndOfLine()) {
                    if (e === t) {
                        const t = s.getComponentIndex(), e = s.getVertexIndex();
                        return new yl(t, e, 0);
                    }
                } else {
                    const n = s.getSegmentStart(), i = s.getSegmentEnd().distance(n);
                    if (e + i > t) {
                        const n = (t - e) / i, r = s.getComponentIndex(), o = s.getVertexIndex();
                        return new yl(r, o, n);
                    }
                    e += i;
                }
                s.next();
            }
            return yl.getEndLocation(this._linearGeom);
        }
        getLength(t) {
            let e = 0;
            const s = new _l(this._linearGeom);
            for(; s.hasNext();){
                if (!s.isEndOfLine()) {
                    const n = s.getSegmentStart(), i = s.getSegmentEnd().distance(n);
                    if (t.getComponentIndex() === s.getComponentIndex() && t.getSegmentIndex() === s.getVertexIndex()) return e + i * t.getSegmentFraction();
                    e += i;
                }
                s.next();
            }
            return e;
        }
        resolveHigher(t) {
            if (!t.isEndpoint(this._linearGeom)) return t;
            let e = t.getComponentIndex();
            if (e >= this._linearGeom.getNumGeometries() - 1) return t;
            do e++;
            while (e < this._linearGeom.getNumGeometries() - 1 && 0 === this._linearGeom.getGeometryN(e).getLength());
            return new yl(e, 0, 0);
        }
    }
    class Nl {
        constructor(){
            Nl.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._linearGeom = null;
            const t = arguments[0];
            this._linearGeom = t;
        }
        clampIndex(t) {
            const e = this.positiveIndex(t), s = this.getStartIndex();
            if (e < s) return s;
            const n = this.getEndIndex();
            return e > n ? n : e;
        }
        locationOf() {
            if (1 === arguments.length) {
                const t = arguments[0];
                return Il.getLocation(this._linearGeom, t);
            }
            if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                return Il.getLocation(this._linearGeom, t, e);
            }
        }
        project(t) {
            return pl.indexOf(this._linearGeom, t);
        }
        positiveIndex(t) {
            return t >= 0 ? t : this._linearGeom.getLength() + t;
        }
        extractPoint() {
            if (1 === arguments.length) {
                const t = arguments[0];
                return Il.getLocation(this._linearGeom, t).getCoordinate(this._linearGeom);
            }
            if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1], s = Il.getLocation(this._linearGeom, t).toLowest(this._linearGeom);
                return s.getSegment(this._linearGeom).pointAlongOffset(s.getSegmentFraction(), e);
            }
        }
        getStartIndex() {
            return 0;
        }
        indexOfAfter(t, e) {
            return pl.indexOfAfter(this._linearGeom, t, e);
        }
        extractLine(t, e) {
            const s = this.clampIndex(t), n = this.clampIndex(e), i = s === n, r = this.locationOf(s, i), o = this.locationOf(n);
            return fl.extract(this._linearGeom, r, o);
        }
        isValidIndex(t) {
            return t >= this.getStartIndex() && t <= this.getEndIndex();
        }
        getEndIndex() {
            return this._linearGeom.getLength();
        }
        indexOf(t) {
            return pl.indexOf(this._linearGeom, t);
        }
        indicesOf(t) {
            const e = El.indicesOf(this._linearGeom, t);
            return [
                Il.getLength(this._linearGeom, e[0]),
                Il.getLength(this._linearGeom, e[1])
            ];
        }
    }
    class wl {
        constructor(){
            wl.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._linearGeom = null;
            const t = arguments[0];
            this._linearGeom = t, this.checkGeometryType();
        }
        clampIndex(t) {
            const e = t.copy();
            return e.clamp(this._linearGeom), e;
        }
        project(t) {
            return xl.indexOf(this._linearGeom, t);
        }
        checkGeometryType() {
            if (!(this._linearGeom instanceof tt || this._linearGeom instanceof Et)) throw new n("Input geometry must be linear");
        }
        extractPoint() {
            if (1 === arguments.length) return arguments[0].getCoordinate(this._linearGeom);
            if (2 === arguments.length) {
                const t = arguments[1], e = arguments[0].toLowest(this._linearGeom);
                return e.getSegment(this._linearGeom).pointAlongOffset(e.getSegmentFraction(), t);
            }
        }
        getStartIndex() {
            return new yl;
        }
        indexOfAfter(t, e) {
            return xl.indexOfAfter(this._linearGeom, t, e);
        }
        extractLine(t, e) {
            return fl.extract(this._linearGeom, t, e);
        }
        isValidIndex(t) {
            return t.isValid(this._linearGeom);
        }
        getEndIndex() {
            return yl.getEndLocation(this._linearGeom);
        }
        indexOf(t) {
            return xl.indexOf(this._linearGeom, t);
        }
        indicesOf(t) {
            return El.indicesOf(this._linearGeom, t);
        }
    }
    var Cl = Object.freeze({
        __proto__: null,
        LengthIndexedLine: Nl,
        LengthLocationMap: Il,
        LinearGeometryBuilder: ml,
        LinearIterator: _l,
        LinearLocation: yl,
        LocationIndexedLine: wl
    });
    class Sl {
        static transform(t, e) {
            const s = new L;
            for(let n = t.iterator(); n.hasNext();)s.add(e.execute(n.next()));
            return s;
        }
        static select(t, e) {
            const s = new L;
            for(let n = t.iterator(); n.hasNext();){
                const t = n.next();
                Boolean.TRUE.equals(e.execute(t)) && s.add(t);
            }
            return s;
        }
        static apply(t, e) {
            for(let s = t.iterator(); s.hasNext();)e.execute(s.next());
        }
    }
    Sl.Function = function() {};
    class Ll {
        constructor(){
            Ll.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this.pts = null, this.n = 0;
            const t = arguments[0];
            this.pts = new Array(t).fill(null);
        }
        filter(t) {
            this.pts[this.n++] = t;
        }
        getCoordinates() {
            return this.pts;
        }
        get interfaces_() {
            return [
                K
            ];
        }
    }
    class Tl {
        constructor(){
            Tl.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._n = 0;
        }
        filter(t) {
            this._n++;
        }
        getCount() {
            return this._n;
        }
        get interfaces_() {
            return [
                K
            ];
        }
    }
    class Rl {
        constructor(){
            Rl.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._counts = new ft;
        }
        add(t) {
            const e = this._counts.get(t);
            null === e ? this._counts.put(t, new Pl(1)) : e.increment();
        }
        count(t) {
            const e = this._counts.get(t);
            return null === e ? 0 : e.count();
        }
    }
    class Pl {
        constructor(){
            Pl.constructor_.apply(this, arguments);
        }
        static constructor_() {
            if (this.count = 0, 0 === arguments.length) ;
            else if (1 === arguments.length) {
                const t = arguments[0];
                this.count = t;
            }
        }
        count() {
            return this.count;
        }
        increment() {
            this.count++;
        }
    }
    Rl.Counter = Pl;
    class Ol {
        constructor(){
            Ol.constructor_.apply(this, arguments);
        }
        static constructor_() {
            this._size = null, this._items = null, this._size = 0, this._items = new L, this._items.add(null);
        }
        poll() {
            if (this.isEmpty()) return null;
            const t = this._items.get(1);
            return this._items.set(1, this._items.get(this._size)), this._size -= 1, this.reorder(1), t;
        }
        size() {
            return this._size;
        }
        reorder(t) {
            let e = null;
            const s = this._items.get(t);
            for(; 2 * t <= this._size && (e = 2 * t, e !== this._size && this._items.get(e + 1).compareTo(this._items.get(e)) < 0 && e++, this._items.get(e).compareTo(s) < 0); t = e)this._items.set(t, this._items.get(e));
            this._items.set(t, s);
        }
        clear() {
            this._size = 0, this._items.clear();
        }
        peek() {
            if (this.isEmpty()) return null;
            return this._items.get(1);
        }
        isEmpty() {
            return 0 === this._size;
        }
        add(t) {
            this._items.add(null), this._size += 1;
            let e = this._size;
            for(this._items.set(0, t); t.compareTo(this._items.get(Math.trunc(e / 2))) < 0; e /= 2)this._items.set(e, this._items.get(Math.trunc(e / 2)));
            this._items.set(e, t);
        }
    }
    function vl() {}
    function Ml() {}
    function bl() {}
    function Dl() {}
    class Al extends s {
    }
    class Fl {
        static split(t, e) {
            const s = e.length, n = new L;
            let i = "" + t, r = i.indexOf(e);
            for(; r >= 0;){
                const t = i.substring(0, r);
                n.add(t), i = i.substring(r + s), r = i.indexOf(e);
            }
            i.length > 0 && n.add(i);
            const o = new Array(n.size()).fill(null);
            for(let t = 0; t < o.length; t++)o[t] = n.get(t);
            return o;
        }
        static getStackTrace() {
            if (1 === arguments.length) {
                const t = arguments[0], e = new Dl, s = new vl;
                return t.printStackTrace(s), e.toString();
            }
            if (2 === arguments.length) {
                const t = arguments[0], e = arguments[1];
                let s = "";
                new Ml(Fl.getStackTrace(t));
                const n = new bl;
                for(let t = 0; t < e; t++)try {
                    s += n.readLine() + Fl.NEWLINE;
                } catch (t) {
                    if (!(t instanceof Al)) throw t;
                    h.shouldNeverReachHere();
                }
                return s;
            }
        }
        static spaces(t) {
            return Fl.chars(" ", t);
        }
        static chars(t, e) {
            const s = new Array(e).fill(null);
            for(let n = 0; n < e; n++)s[n] = t;
            return new String(s);
        }
    }
    Fl.NEWLINE = Y.getProperty("line.separator");
    var Gl = Object.freeze({
        __proto__: null,
        CollectionUtil: Sl,
        CoordinateArrayFilter: Ll,
        CoordinateCountFilter: Tl,
        GeometricShapeFactory: we,
        NumberUtil: e,
        ObjectCounter: Rl,
        PriorityQueue: Ol,
        StringUtil: Fl,
        UniqueCoordinateArrayFilter: di
    });
    tt.prototype.getBoundary = function() {
        return ir.getBoundary(this);
    }, Et.prototype.getBoundary = function() {
        return ir.getBoundary(this);
    }, j.prototype.equalsTopo = function(t) {
        return no.equalsTopo(this, t);
    }, j.prototype.equals = function(t) {
        return null !== t && no.equalsTopo(this, t);
    }, j.prototype.union = function() {
        if (0 === arguments.length) return co.union(this);
        if (1 === arguments.length) {
            const t = arguments[0];
            return ci.union(this, t);
        }
    }, j.prototype.isValid = function() {
        return zr.isValid(this);
    }, j.prototype.intersection = function(t) {
        return oi.intersection(this, t);
    }, j.prototype.covers = function(t) {
        return no.covers(this, t);
    }, j.prototype.coveredBy = function(t) {
        return no.covers(t, this);
    }, j.prototype.touches = function(t) {
        return no.touches(this, t);
    }, j.prototype.intersects = function(t) {
        return no.intersects(this, t);
    }, j.prototype.within = function(t) {
        return no.contains(t, this);
    }, j.prototype.overlaps = function(t) {
        return no.overlaps(this, t);
    }, j.prototype.disjoint = function(t) {
        return no.disjoint(this, t);
    }, j.prototype.crosses = function(t) {
        return no.crosses(this, t);
    }, j.prototype.buffer = function() {
        if (1 === arguments.length) {
            const t = arguments[0];
            return bn.bufferOp(this, t);
        }
        if (2 === arguments.length) {
            const t = arguments[0], e = arguments[1];
            return bn.bufferOp(this, t, e);
        }
        if (3 === arguments.length) {
            const t = arguments[0], e = arguments[1], s = arguments[2];
            return bn.bufferOp(this, t, e, s);
        }
    }, j.prototype.convexHull = function() {
        return new _i(this).getConvexHull();
    }, j.prototype.relate = function() {
        if (1 === arguments.length) {
            const t = arguments[0];
            return no.relate(this, t);
        }
        if (2 === arguments.length) {
            const t = arguments[0], e = arguments[1];
            return no.relate(this, t).matches(e);
        }
    }, j.prototype.getCentroid = function() {
        if (this.isEmpty()) return this._factory.createPoint();
        const t = gi.getCentroid(this);
        return this.createPointFromInternalCoord(t, this);
    }, j.prototype.getInteriorPoint = function() {
        if (this.isEmpty()) return this._factory.createPoint();
        let t = null;
        const e = this.getDimension();
        t = 0 === e ? new Ii(this) : 1 === e ? new Ei(this) : new mi(this);
        const s = t.getInteriorPoint();
        return this.createPointFromInternalCoord(s, this);
    }, j.prototype.symDifference = function(t) {
        return oi.symDifference(this, t);
    }, j.prototype.createPointFromInternalCoord = function(t, e) {
        return e.getPrecisionModel().makePrecise(t), e.getFactory().createPoint(t);
    }, j.prototype.toText = function() {
        return (new Wt).write(this);
    }, j.prototype.toString = function() {
        return this.toText();
    }, j.prototype.contains = function(t) {
        return no.contains(this, t);
    }, j.prototype.difference = function(t) {
        return oi.difference(this, t);
    }, j.prototype.isSimple = function() {
        return new or(this).isSimple();
    }, j.prototype.isWithinDistance = function(t, e) {
        return !(this.getEnvelopeInternal().distance(t.getEnvelopeInternal()) > e) && ur.isWithinDistance(this, t, e);
    }, j.prototype.distance = function(t) {
        return ur.distance(this, t);
    };
    t.algorithm = Ci, t.densify = Ti, t.dissolve = Di, t.geom = Te, t.geomgraph = Ai, t.index = Ki, t.io = sr, t.linearref = Cl, t.noding = nr, t.operation = go, t.precision = Co, t.simplify = zo, t.triangulate = dl, t.util = Gl, t.version = "2.12.1";
});































var $f1q41 = parcelRequire("f1q41");



const $da0e0978dae16334$var$FILENAME = 'geometry-data-modal.js';
const $da0e0978dae16334$var$I18N__BASE = 'modalExtensions.geometryDataModal';
// Note:
// Only specify the unique options to this class
// Things to override on the BaseModal is passed directly
const $da0e0978dae16334$var$DefaultOptions = Object.freeze({
    data: {}
});
/**
 * About:
 * Manager that handles downloading of vector layers
 */ class $da0e0978dae16334$export$a868fcd9c55b091 extends (0, $b12cc913018885a9$export$a703eb468fcf7e69) {
    #buttons = [];
    constructor(options = {}){
        super({
            filename: $da0e0978dae16334$var$FILENAME,
            title: (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get(`${$da0e0978dae16334$var$I18N__BASE}.title`),
            ...options
        });
        this.options = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep($da0e0978dae16334$var$DefaultOptions), options);
        this.#createModalContent();
    }
    //--------------------------------------------------------------------
    // # Section: Overridden
    //--------------------------------------------------------------------
    getName() {
        return super.getName();
    }
    //--------------------------------------------------------------------
    // # Section: User Interface
    //--------------------------------------------------------------------
    #createModalContent() {
        const modalContent = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'div',
            class: 'oltb-modal__content'
        });
        const table = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'table',
            class: 'oltb-table oltb-table--vertical'
        });
        const tbody = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'tbody'
        });
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(table, [
            tbody
        ]);
        // TODO:
        // How to handle translations? 
        // For now the key for each property is used as the descriptor
        for (const [key, value] of Object.entries(this.options.data)){
            const tr = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
                element: 'tr'
            });
            const i18n = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get(`${$da0e0978dae16334$var$I18N__BASE}.data`);
            const th = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
                element: 'th',
                text: i18n[key]
            });
            const td = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
                element: 'td',
                html: value
            });
            (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(tr, [
                th,
                td
            ]);
            (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(tbody, [
                tr
            ]);
        }
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(modalContent, [
            table
        ]);
        this.show(modalContent);
    }
}







/**
 * @module ol/interaction/Modify
 */ 



















/**
 * The segment index assigned to a circle's center when
 * breaking up a circle into ModifySegmentDataType segments.
 * @type {number}
 */ const $8c24f34a0807f744$var$CIRCLE_CENTER_INDEX = 0;
/**
 * The segment index assigned to a circle's circumference when
 * breaking up a circle into ModifySegmentDataType segments.
 * @type {number}
 */ const $8c24f34a0807f744$var$CIRCLE_CIRCUMFERENCE_INDEX = 1;
const $8c24f34a0807f744$var$tempExtent = [
    0,
    0,
    0,
    0
];
const $8c24f34a0807f744$var$tempSegment = [];
/**
 * @enum {string}
 */ const $8c24f34a0807f744$var$ModifyEventType = {
    /**
   * Triggered upon feature modification start
   * @event ModifyEvent#modifystart
   * @api
   */ MODIFYSTART: 'modifystart',
    /**
   * Triggered upon feature modification end
   * @event ModifyEvent#modifyend
   * @api
   */ MODIFYEND: 'modifyend'
};
class $8c24f34a0807f744$export$eb2af8bb6aa1fb54 extends (0, $aeedce20e9577100$export$2e2bcd8739ae039) {
    /**
   * @param {ModifyEventType} type Type.
   * @param {Collection<Feature>} features
   * The features modified.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent
   * Associated {@link module:ol/MapBrowserEvent~MapBrowserEvent}.
   */ constructor(type, features, mapBrowserEvent){
        super(type);
        /**
     * The features being modified.
     * @type {Collection<Feature>}
     * @api
     */ this.features = features;
        /**
     * Associated {@link module:ol/MapBrowserEvent~MapBrowserEvent}.
     * @type {import("../MapBrowserEvent.js").default}
     * @api
     */ this.mapBrowserEvent = mapBrowserEvent;
    }
}
/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types|
 *     'change:active', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<'modifyend'|'modifystart', ModifyEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types|
 *     'change:active'|'modifyend'|'modifystart', Return>} ModifyOnSignature
 */ /**
 * @classdesc
 * Interaction for modifying feature geometries.  To modify features that have
 * been added to an existing source, construct the modify interaction with the
 * `source` option.  If you want to modify features in a collection (for example,
 * the collection used by a select interaction), construct the interaction with
 * the `features` option.  The interaction must be constructed with either a
 * `source` or `features` option.
 *
 * Cartesian distance from the pointer is used to determine the features that
 * will be modified. This means that geometries will only be considered for
 * modification when they are within the configured `pixelTolerance`. For point
 * geometries, the `hitDetection` option can be used to match their visual
 * appearance.
 *
 * By default, the interaction will allow deletion of vertices when the `alt`
 * key is pressed.  To configure the interaction with a different condition
 * for deletion, use the `deleteCondition` option.
 * @fires ModifyEvent
 * @api
 */ class $8c24f34a0807f744$var$Modify extends (0, $cf1eb502962d87a8$export$2e2bcd8739ae039) {
    /**
   * @param {Options} options Options.
   */ constructor(options){
        super(/** @type {import("./Pointer.js").Options} */ options);
        /***
     * @type {ModifyOnSignature<import("../events").EventsKey>}
     */ this.on;
        /***
     * @type {ModifyOnSignature<import("../events").EventsKey>}
     */ this.once;
        /***
     * @type {ModifyOnSignature<void>}
     */ this.un;
        /** @private */ this.boundHandleFeatureChange_ = this.handleFeatureChange_.bind(this);
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.condition_ = options.condition ? options.condition : (0, $edf87b50170125f7$export$189f0d593022b199);
        /**
     * @private
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Browser event.
     * @return {boolean} Combined condition result.
     */ this.defaultDeleteCondition_ = function(mapBrowserEvent) {
            return (0, $edf87b50170125f7$export$573409992e89967e)(mapBrowserEvent) && (0, $edf87b50170125f7$export$194df8bad091b401)(mapBrowserEvent);
        };
        /**
     * @type {import("../events/condition.js").Condition}
     * @private
     */ this.deleteCondition_ = options.deleteCondition ? options.deleteCondition : this.defaultDeleteCondition_;
        /**
     * @type {import("../events/condition.js").Condition}
     * @private
     */ this.insertVertexCondition_ = options.insertVertexCondition ? options.insertVertexCondition : (0, $edf87b50170125f7$export$ba9e5d519bc326ca);
        /**
     * Editing vertex.
     * @type {Feature<Point>}
     * @private
     */ this.vertexFeature_ = null;
        /**
     * Segments intersecting {@link this.vertexFeature_} by segment uid.
     * @type {Object<string, boolean>}
     * @private
     */ this.vertexSegments_ = null;
        /**
     * @type {import("../pixel.js").Pixel}
     * @private
     */ this.lastPixel_ = [
            0,
            0
        ];
        /**
     * Tracks if the next `singleclick` event should be ignored to prevent
     * accidental deletion right after vertex creation.
     * @type {boolean}
     * @private
     */ this.ignoreNextSingleClick_ = false;
        /**
     * @type {Collection<Feature>}
     * @private
     */ this.featuresBeingModified_ = null;
        /**
     * Segment RTree for each layer
     * @type {RBush<SegmentData>}
     * @private
     */ this.rBush_ = new (0, $34c742891733e7a4$export$2e2bcd8739ae039)();
        /**
     * @type {number}
     * @private
     */ this.pixelTolerance_ = options.pixelTolerance !== undefined ? options.pixelTolerance : 10;
        /**
     * @type {boolean}
     * @private
     */ this.snappedToVertex_ = false;
        /**
     * Indicate whether the interaction is currently changing a feature's
     * coordinates.
     * @type {boolean}
     * @private
     */ this.changingFeature_ = false;
        /**
     * @type {Array<DragSegment>}
     * @private
     */ this.dragSegments_ = [];
        /**
     * Draw overlay where sketch features are drawn.
     * @type {VectorLayer}
     * @private
     */ this.overlay_ = new (0, $82a68515bd6ef378$export$2e2bcd8739ae039)({
            source: new (0, $84888e4daf3fdf44$export$2e2bcd8739ae039)({
                useSpatialIndex: false,
                wrapX: !!options.wrapX
            }),
            style: options.style ? options.style : $8c24f34a0807f744$var$getDefaultStyleFunction(),
            updateWhileAnimating: true,
            updateWhileInteracting: true
        });
        /**
     * @const
     * @private
     * @type {!Object<string, function(Feature, import("../geom/Geometry.js").default): void>}
     */ this.SEGMENT_WRITERS_ = {
            'Point': this.writePointGeometry_.bind(this),
            'LineString': this.writeLineStringGeometry_.bind(this),
            'LinearRing': this.writeLineStringGeometry_.bind(this),
            'Polygon': this.writePolygonGeometry_.bind(this),
            'MultiPoint': this.writeMultiPointGeometry_.bind(this),
            'MultiLineString': this.writeMultiLineStringGeometry_.bind(this),
            'MultiPolygon': this.writeMultiPolygonGeometry_.bind(this),
            'Circle': this.writeCircleGeometry_.bind(this),
            'GeometryCollection': this.writeGeometryCollectionGeometry_.bind(this)
        };
        /**
     * @type {VectorSource}
     * @private
     */ this.source_ = null;
        /**
     * @type {boolean|import("../layer/BaseVector").default}
     * @private
     */ this.hitDetection_ = null;
        /** @type {Collection<Feature>} */ let features;
        if (options.features) features = options.features;
        else if (options.source) {
            this.source_ = options.source;
            features = new (0, $931ffc4e747c14db$export$2e2bcd8739ae039)(this.source_.getFeatures());
            this.source_.addEventListener((0, $ccc4e6f11f11978f$export$2e2bcd8739ae039).ADDFEATURE, this.handleSourceAdd_.bind(this));
            this.source_.addEventListener((0, $ccc4e6f11f11978f$export$2e2bcd8739ae039).REMOVEFEATURE, this.handleSourceRemove_.bind(this));
        }
        if (!features) throw new Error('The modify interaction requires features, a source or a layer');
        if (options.hitDetection) this.hitDetection_ = options.hitDetection;
        /**
     * @type {Collection<Feature>}
     * @private
     */ this.features_ = features;
        this.features_.forEach(this.addFeature_.bind(this));
        this.features_.addEventListener((0, $161dd067fe2d672c$export$2e2bcd8739ae039).ADD, this.handleFeatureAdd_.bind(this));
        this.features_.addEventListener((0, $161dd067fe2d672c$export$2e2bcd8739ae039).REMOVE, this.handleFeatureRemove_.bind(this));
        /**
     * @type {import("../MapBrowserEvent.js").default}
     * @private
     */ this.lastPointerEvent_ = null;
        /**
     * Delta (x, y in map units) between matched rtree vertex and pointer vertex.
     * @type {Array<number>}
     * @private
     */ this.delta_ = [
            0,
            0
        ];
        /**
     * @private
     */ this.snapToPointer_ = options.snapToPointer === undefined ? !this.hitDetection_ : options.snapToPointer;
    }
    /**
   * @param {Feature} feature Feature.
   * @private
   */ addFeature_(feature) {
        const geometry = feature.getGeometry();
        if (geometry) {
            const writer = this.SEGMENT_WRITERS_[geometry.getType()];
            if (writer) writer(feature, geometry);
        }
        const map = this.getMap();
        if (map && map.isRendered() && this.getActive()) this.handlePointerAtPixel_(map.getCoordinateFromPixel(this.lastPixel_));
        feature.addEventListener((0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE, this.boundHandleFeatureChange_);
    }
    /**
   * @param {import("../MapBrowserEvent.js").default} evt Map browser event.
   * @param {Array<SegmentData>} segments The segments subject to modification.
   * @private
   */ willModifyFeatures_(evt, segments) {
        if (!this.featuresBeingModified_) {
            this.featuresBeingModified_ = new (0, $931ffc4e747c14db$export$2e2bcd8739ae039)();
            const features = this.featuresBeingModified_.getArray();
            for(let i = 0, ii = segments.length; i < ii; ++i){
                const feature = segments[i].feature;
                if (feature && !features.includes(feature)) this.featuresBeingModified_.push(feature);
            }
            if (this.featuresBeingModified_.getLength() === 0) this.featuresBeingModified_ = null;
            else this.dispatchEvent(new $8c24f34a0807f744$export$eb2af8bb6aa1fb54($8c24f34a0807f744$var$ModifyEventType.MODIFYSTART, this.featuresBeingModified_, evt));
        }
    }
    /**
   * @param {Feature} feature Feature.
   * @private
   */ removeFeature_(feature) {
        this.removeFeatureSegmentData_(feature);
        // Remove the vertex feature if the collection of candidate features is empty.
        if (this.vertexFeature_ && this.features_.getLength() === 0) {
            this.overlay_.getSource().removeFeature(this.vertexFeature_);
            this.vertexFeature_ = null;
        }
        feature.removeEventListener((0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE, this.boundHandleFeatureChange_);
    }
    /**
   * @param {Feature} feature Feature.
   * @private
   */ removeFeatureSegmentData_(feature) {
        const rBush = this.rBush_;
        /** @type {Array<SegmentData>} */ const nodesToRemove = [];
        rBush.forEach(/**
       * @param {SegmentData} node RTree node.
       */ function(node) {
            if (feature === node.feature) nodesToRemove.push(node);
        });
        for(let i = nodesToRemove.length - 1; i >= 0; --i){
            const nodeToRemove = nodesToRemove[i];
            for(let j = this.dragSegments_.length - 1; j >= 0; --j)if (this.dragSegments_[j][0] === nodeToRemove) this.dragSegments_.splice(j, 1);
            rBush.remove(nodeToRemove);
        }
    }
    /**
   * Activate or deactivate the interaction.
   * @param {boolean} active Active.
   * @observable
   * @api
   * @override
   */ setActive(active) {
        if (this.vertexFeature_ && !active) {
            this.overlay_.getSource().removeFeature(this.vertexFeature_);
            this.vertexFeature_ = null;
        }
        super.setActive(active);
    }
    /**
   * Remove the interaction from its current map and attach it to the new map.
   * Subclasses may set up event handlers to get notified about changes to
   * the map here.
   * @param {import("../Map.js").default} map Map.
   * @override
   */ setMap(map) {
        this.overlay_.setMap(map);
        super.setMap(map);
    }
    /**
   * Get the overlay layer that this interaction renders the modification point or vertex to.
   * @return {VectorLayer} Overlay layer.
   * @api
   */ getOverlay() {
        return this.overlay_;
    }
    /**
   * @param {import("../source/Vector.js").VectorSourceEvent} event Event.
   * @private
   */ handleSourceAdd_(event) {
        if (event.feature) this.features_.push(event.feature);
    }
    /**
   * @param {import("../source/Vector.js").VectorSourceEvent} event Event.
   * @private
   */ handleSourceRemove_(event) {
        if (event.feature) this.features_.remove(event.feature);
    }
    /**
   * @param {import("../Collection.js").CollectionEvent<Feature>} evt Event.
   * @private
   */ handleFeatureAdd_(evt) {
        this.addFeature_(evt.element);
    }
    /**
   * @param {import("../events/Event.js").default} evt Event.
   * @private
   */ handleFeatureChange_(evt) {
        if (!this.changingFeature_) {
            const feature = /** @type {Feature} */ evt.target;
            this.removeFeature_(feature);
            this.addFeature_(feature);
        }
    }
    /**
   * @param {import("../Collection.js").CollectionEvent<Feature>} evt Event.
   * @private
   */ handleFeatureRemove_(evt) {
        this.removeFeature_(evt.element);
    }
    /**
   * @param {Feature} feature Feature
   * @param {Point} geometry Geometry.
   * @private
   */ writePointGeometry_(feature, geometry) {
        const coordinates = geometry.getCoordinates();
        /** @type {SegmentData} */ const segmentData = {
            feature: feature,
            geometry: geometry,
            segment: [
                coordinates,
                coordinates
            ]
        };
        this.rBush_.insert(geometry.getExtent(), segmentData);
    }
    /**
   * @param {Feature} feature Feature
   * @param {import("../geom/MultiPoint.js").default} geometry Geometry.
   * @private
   */ writeMultiPointGeometry_(feature, geometry) {
        const points = geometry.getCoordinates();
        for(let i = 0, ii = points.length; i < ii; ++i){
            const coordinates = points[i];
            /** @type {SegmentData} */ const segmentData = {
                feature: feature,
                geometry: geometry,
                depth: [
                    i
                ],
                index: i,
                segment: [
                    coordinates,
                    coordinates
                ]
            };
            this.rBush_.insert(geometry.getExtent(), segmentData);
        }
    }
    /**
   * @param {Feature} feature Feature
   * @param {import("../geom/LineString.js").default} geometry Geometry.
   * @private
   */ writeLineStringGeometry_(feature, geometry) {
        const coordinates = geometry.getCoordinates();
        for(let i = 0, ii = coordinates.length - 1; i < ii; ++i){
            const segment = coordinates.slice(i, i + 2);
            /** @type {SegmentData} */ const segmentData = {
                feature: feature,
                geometry: geometry,
                index: i,
                segment: segment
            };
            this.rBush_.insert((0, $6da4c8ed3074c92b$export$8aceca7c77505534)(segment), segmentData);
        }
    }
    /**
   * @param {Feature} feature Feature
   * @param {import("../geom/MultiLineString.js").default} geometry Geometry.
   * @private
   */ writeMultiLineStringGeometry_(feature, geometry) {
        const lines = geometry.getCoordinates();
        for(let j = 0, jj = lines.length; j < jj; ++j){
            const coordinates = lines[j];
            for(let i = 0, ii = coordinates.length - 1; i < ii; ++i){
                const segment = coordinates.slice(i, i + 2);
                /** @type {SegmentData} */ const segmentData = {
                    feature: feature,
                    geometry: geometry,
                    depth: [
                        j
                    ],
                    index: i,
                    segment: segment
                };
                this.rBush_.insert((0, $6da4c8ed3074c92b$export$8aceca7c77505534)(segment), segmentData);
            }
        }
    }
    /**
   * @param {Feature} feature Feature
   * @param {import("../geom/Polygon.js").default} geometry Geometry.
   * @private
   */ writePolygonGeometry_(feature, geometry) {
        const rings = geometry.getCoordinates();
        for(let j = 0, jj = rings.length; j < jj; ++j){
            const coordinates = rings[j];
            for(let i = 0, ii = coordinates.length - 1; i < ii; ++i){
                const segment = coordinates.slice(i, i + 2);
                /** @type {SegmentData} */ const segmentData = {
                    feature: feature,
                    geometry: geometry,
                    depth: [
                        j
                    ],
                    index: i,
                    segment: segment
                };
                this.rBush_.insert((0, $6da4c8ed3074c92b$export$8aceca7c77505534)(segment), segmentData);
            }
        }
    }
    /**
   * @param {Feature} feature Feature
   * @param {import("../geom/MultiPolygon.js").default} geometry Geometry.
   * @private
   */ writeMultiPolygonGeometry_(feature, geometry) {
        const polygons = geometry.getCoordinates();
        for(let k = 0, kk = polygons.length; k < kk; ++k){
            const rings = polygons[k];
            for(let j = 0, jj = rings.length; j < jj; ++j){
                const coordinates = rings[j];
                for(let i = 0, ii = coordinates.length - 1; i < ii; ++i){
                    const segment = coordinates.slice(i, i + 2);
                    /** @type {SegmentData} */ const segmentData = {
                        feature: feature,
                        geometry: geometry,
                        depth: [
                            j,
                            k
                        ],
                        index: i,
                        segment: segment
                    };
                    this.rBush_.insert((0, $6da4c8ed3074c92b$export$8aceca7c77505534)(segment), segmentData);
                }
            }
        }
    }
    /**
   * We convert a circle into two segments.  The segment at index
   * {@link CIRCLE_CENTER_INDEX} is the
   * circle's center (a point).  The segment at index
   * {@link CIRCLE_CIRCUMFERENCE_INDEX} is
   * the circumference, and is not a line segment.
   *
   * @param {Feature} feature Feature.
   * @param {import("../geom/Circle.js").default} geometry Geometry.
   * @private
   */ writeCircleGeometry_(feature, geometry) {
        const coordinates = geometry.getCenter();
        /** @type {SegmentData} */ const centerSegmentData = {
            feature: feature,
            geometry: geometry,
            index: $8c24f34a0807f744$var$CIRCLE_CENTER_INDEX,
            segment: [
                coordinates,
                coordinates
            ]
        };
        /** @type {SegmentData} */ const circumferenceSegmentData = {
            feature: feature,
            geometry: geometry,
            index: $8c24f34a0807f744$var$CIRCLE_CIRCUMFERENCE_INDEX,
            segment: [
                coordinates,
                coordinates
            ]
        };
        const featureSegments = [
            centerSegmentData,
            circumferenceSegmentData
        ];
        centerSegmentData.featureSegments = featureSegments;
        circumferenceSegmentData.featureSegments = featureSegments;
        this.rBush_.insert((0, $6da4c8ed3074c92b$export$4838bf78d04a9440)(coordinates), centerSegmentData);
        let circleGeometry = /** @type {import("../geom/Geometry.js").default} */ geometry;
        const userProjection = (0, $9c4744460e43e41b$export$3973b77d5f6f2790)();
        if (userProjection && this.getMap()) {
            const projection = this.getMap().getView().getProjection();
            circleGeometry = circleGeometry.clone().transform(userProjection, projection);
            circleGeometry = (0, $40aa8d43bbe572bf$export$2451009d645fb8c2)(/** @type {import("../geom/Circle.js").default} */ circleGeometry).transform(projection, userProjection);
        }
        this.rBush_.insert(circleGeometry.getExtent(), circumferenceSegmentData);
    }
    /**
   * @param {Feature} feature Feature
   * @param {import("../geom/GeometryCollection.js").default} geometry Geometry.
   * @private
   */ writeGeometryCollectionGeometry_(feature, geometry) {
        const geometries = geometry.getGeometriesArray();
        for(let i = 0; i < geometries.length; ++i){
            const geometry = geometries[i];
            const writer = this.SEGMENT_WRITERS_[geometry.getType()];
            writer(feature, geometry);
        }
    }
    /**
   * @param {import("../coordinate.js").Coordinate} coordinates Coordinates.
   * @param {Array<Feature>} features The features being modified.
   * @param {Array<import("../geom/SimpleGeometry.js").default>} geometries The geometries being modified.
   * @param {boolean} existing The vertex represents an existing vertex.
   * @return {Feature} Vertex feature.
   * @private
   */ createOrUpdateVertexFeature_(coordinates, features, geometries, existing) {
        let vertexFeature = this.vertexFeature_;
        if (!vertexFeature) {
            vertexFeature = new (0, $9fd014ab6df63665$export$2e2bcd8739ae039)(new (0, $6eced4c969949f6b$export$2e2bcd8739ae039)(coordinates));
            this.vertexFeature_ = vertexFeature;
            this.overlay_.getSource().addFeature(vertexFeature);
        } else {
            const geometry = vertexFeature.getGeometry();
            geometry.setCoordinates(coordinates);
        }
        vertexFeature.set('features', features);
        vertexFeature.set('geometries', geometries);
        vertexFeature.set('existing', existing);
        return vertexFeature;
    }
    /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} and may modify the geometry.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   * @override
   */ handleEvent(mapBrowserEvent) {
        if (!mapBrowserEvent.originalEvent) return true;
        this.lastPointerEvent_ = mapBrowserEvent;
        let handled;
        if (!mapBrowserEvent.map.getView().getInteracting() && mapBrowserEvent.type == (0, $150f412a4a7fa263$export$2e2bcd8739ae039).POINTERMOVE && !this.handlingDownUpSequence) this.handlePointerMove_(mapBrowserEvent);
        if (this.vertexFeature_ && this.deleteCondition_(mapBrowserEvent)) {
            if (mapBrowserEvent.type != (0, $150f412a4a7fa263$export$2e2bcd8739ae039).SINGLECLICK || !this.ignoreNextSingleClick_) handled = this.removePoint();
            else handled = true;
        }
        if (mapBrowserEvent.type == (0, $150f412a4a7fa263$export$2e2bcd8739ae039).SINGLECLICK) this.ignoreNextSingleClick_ = false;
        return super.handleEvent(mapBrowserEvent) && !handled;
    }
    findInsertVerticesAndUpdateDragSegments_(pixelCoordinate) {
        this.handlePointerAtPixel_(pixelCoordinate);
        this.dragSegments_.length = 0;
        this.featuresBeingModified_ = null;
        const vertexFeature = this.vertexFeature_;
        if (!vertexFeature) return;
        const projection = this.getMap().getView().getProjection();
        const insertVertices = [];
        const vertex = vertexFeature.getGeometry().getCoordinates();
        const vertexExtent = (0, $6da4c8ed3074c92b$export$8aceca7c77505534)([
            vertex
        ]);
        const segmentDataMatches = this.rBush_.getInExtent(vertexExtent);
        const componentSegments = {};
        segmentDataMatches.sort($8c24f34a0807f744$var$compareIndexes);
        for(let i = 0, ii = segmentDataMatches.length; i < ii; ++i){
            const segmentDataMatch = segmentDataMatches[i];
            const segment = segmentDataMatch.segment;
            let uid = (0, $6c5e11070e371322$export$5e82334337e0f204)(segmentDataMatch.geometry);
            const depth = segmentDataMatch.depth;
            if (depth) uid += '-' + depth.join('-'); // separate feature components
            if (!componentSegments[uid]) componentSegments[uid] = new Array(2);
            if (segmentDataMatch.geometry.getType() === 'Circle' && segmentDataMatch.index === $8c24f34a0807f744$var$CIRCLE_CIRCUMFERENCE_INDEX) {
                const closestVertex = $8c24f34a0807f744$var$closestOnSegmentData(pixelCoordinate, segmentDataMatch, projection);
                if ((0, $1bd0a226f9a16141$export$e9bab7fafb253603)(closestVertex, vertex) && !componentSegments[uid][0]) {
                    this.dragSegments_.push([
                        segmentDataMatch,
                        0
                    ]);
                    componentSegments[uid][0] = segmentDataMatch;
                }
                continue;
            }
            if ((0, $1bd0a226f9a16141$export$e9bab7fafb253603)(segment[0], vertex) && !componentSegments[uid][0]) {
                this.dragSegments_.push([
                    segmentDataMatch,
                    0
                ]);
                componentSegments[uid][0] = segmentDataMatch;
                continue;
            }
            if ((0, $1bd0a226f9a16141$export$e9bab7fafb253603)(segment[1], vertex) && !componentSegments[uid][1]) {
                if (componentSegments[uid][0] && componentSegments[uid][0].index === 0) {
                    let coordinates = segmentDataMatch.geometry.getCoordinates();
                    switch(segmentDataMatch.geometry.getType()){
                        // prevent dragging closed linestrings by the connecting node
                        case 'LineString':
                        case 'MultiLineString':
                            continue;
                        // if dragging the first vertex of a polygon, ensure the other segment
                        // belongs to the closing vertex of the linear ring
                        case 'MultiPolygon':
                            coordinates = coordinates[depth[1]];
                        /* falls through */ case 'Polygon':
                            if (segmentDataMatch.index !== coordinates[depth[0]].length - 2) continue;
                            break;
                        default:
                    }
                }
                this.dragSegments_.push([
                    segmentDataMatch,
                    1
                ]);
                componentSegments[uid][1] = segmentDataMatch;
                continue;
            }
            if ((0, $6c5e11070e371322$export$5e82334337e0f204)(segment) in this.vertexSegments_ && !componentSegments[uid][0] && !componentSegments[uid][1]) insertVertices.push(segmentDataMatch);
        }
        return insertVertices;
    }
    /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} evt Event.
   * @override
   */ handleDragEvent(evt) {
        this.ignoreNextSingleClick_ = false;
        this.willModifyFeatures_(evt, this.dragSegments_.map(([segment])=>segment));
        const vertex = [
            evt.coordinate[0] + this.delta_[0],
            evt.coordinate[1] + this.delta_[1]
        ];
        const features = [];
        const geometries = [];
        for(let i = 0, ii = this.dragSegments_.length; i < ii; ++i){
            const dragSegment = this.dragSegments_[i];
            const segmentData = dragSegment[0];
            const feature = segmentData.feature;
            if (!features.includes(feature)) features.push(feature);
            const geometry = segmentData.geometry;
            if (!geometries.includes(geometry)) geometries.push(geometry);
            const depth = segmentData.depth;
            let coordinates;
            const segment = segmentData.segment;
            const index = dragSegment[1];
            while(vertex.length < geometry.getStride())vertex.push(segment[index][vertex.length]);
            switch(geometry.getType()){
                case 'Point':
                    coordinates = vertex;
                    segment[0] = vertex;
                    segment[1] = vertex;
                    break;
                case 'MultiPoint':
                    coordinates = geometry.getCoordinates();
                    coordinates[segmentData.index] = vertex;
                    segment[0] = vertex;
                    segment[1] = vertex;
                    break;
                case 'LineString':
                    coordinates = geometry.getCoordinates();
                    coordinates[segmentData.index + index] = vertex;
                    segment[index] = vertex;
                    break;
                case 'MultiLineString':
                    coordinates = geometry.getCoordinates();
                    coordinates[depth[0]][segmentData.index + index] = vertex;
                    segment[index] = vertex;
                    break;
                case 'Polygon':
                    coordinates = geometry.getCoordinates();
                    coordinates[depth[0]][segmentData.index + index] = vertex;
                    segment[index] = vertex;
                    break;
                case 'MultiPolygon':
                    coordinates = geometry.getCoordinates();
                    coordinates[depth[1]][depth[0]][segmentData.index + index] = vertex;
                    segment[index] = vertex;
                    break;
                case 'Circle':
                    const circle = /** @type {import("../geom/Circle.js").default} */ geometry;
                    segment[0] = vertex;
                    segment[1] = vertex;
                    if (segmentData.index === $8c24f34a0807f744$var$CIRCLE_CENTER_INDEX) {
                        this.changingFeature_ = true;
                        circle.setCenter(vertex);
                        this.changingFeature_ = false;
                    } else {
                        // We're dragging the circle's circumference:
                        this.changingFeature_ = true;
                        const projection = evt.map.getView().getProjection();
                        let radius = (0, $1bd0a226f9a16141$export$9f17032d917177de)((0, $9c4744460e43e41b$export$d4b8ec0b96db1ee2)(circle.getCenter(), projection), (0, $9c4744460e43e41b$export$d4b8ec0b96db1ee2)(vertex, projection));
                        const userProjection = (0, $9c4744460e43e41b$export$3973b77d5f6f2790)();
                        if (userProjection) {
                            const circleGeometry = circle.clone().transform(userProjection, projection);
                            circleGeometry.setRadius(radius);
                            radius = circleGeometry.transform(projection, userProjection).getRadius();
                        }
                        circle.setRadius(radius);
                        this.changingFeature_ = false;
                    }
                    break;
                default:
            }
            if (coordinates) this.setGeometryCoordinates_(geometry, coordinates);
        }
        this.createOrUpdateVertexFeature_(vertex, features, geometries, true);
    }
    /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} evt Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleDownEvent(evt) {
        if (!this.condition_(evt)) return false;
        const pixelCoordinate = evt.coordinate;
        const insertVertices = this.findInsertVerticesAndUpdateDragSegments_(pixelCoordinate);
        if (insertVertices?.length && this.insertVertexCondition_(evt)) {
            this.willModifyFeatures_(evt, insertVertices);
            if (this.vertexFeature_) {
                const vertex = this.vertexFeature_.getGeometry().getCoordinates();
                for(let j = insertVertices.length - 1; j >= 0; --j)this.insertVertex_(insertVertices[j], vertex);
                this.ignoreNextSingleClick_ = true;
            }
        }
        return !!this.vertexFeature_;
    }
    /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} evt Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleUpEvent(evt) {
        for(let i = this.dragSegments_.length - 1; i >= 0; --i){
            const segmentData = this.dragSegments_[i][0];
            const geometry = segmentData.geometry;
            if (geometry.getType() === 'Circle') {
                const circle = /** @type {import("../geom/Circle.js").default} */ geometry;
                // Update a circle object in the R* bush:
                const coordinates = circle.getCenter();
                const centerSegmentData = segmentData.featureSegments[0];
                const circumferenceSegmentData = segmentData.featureSegments[1];
                centerSegmentData.segment[0] = coordinates;
                centerSegmentData.segment[1] = coordinates;
                circumferenceSegmentData.segment[0] = coordinates;
                circumferenceSegmentData.segment[1] = coordinates;
                this.rBush_.update((0, $6da4c8ed3074c92b$export$4838bf78d04a9440)(coordinates), centerSegmentData);
                /** @type {import("../geom/Circle.js").default | import("../geom/Polygon.js").default} */ let circleGeometry = circle;
                const userProjection = (0, $9c4744460e43e41b$export$3973b77d5f6f2790)();
                if (userProjection) {
                    const projection = evt.map.getView().getProjection();
                    circleGeometry = circleGeometry.clone().transform(userProjection, projection);
                    circleGeometry = (0, $40aa8d43bbe572bf$export$2451009d645fb8c2)(circleGeometry).transform(projection, userProjection);
                }
                this.rBush_.update(circleGeometry.getExtent(), circumferenceSegmentData);
            } else this.rBush_.update((0, $6da4c8ed3074c92b$export$8aceca7c77505534)(segmentData.segment), segmentData);
        }
        if (this.featuresBeingModified_) {
            this.dispatchEvent(new $8c24f34a0807f744$export$eb2af8bb6aa1fb54($8c24f34a0807f744$var$ModifyEventType.MODIFYEND, this.featuresBeingModified_, evt));
            this.featuresBeingModified_ = null;
        }
        return false;
    }
    /**
   * @param {import("../MapBrowserEvent.js").default} evt Event.
   * @private
   */ handlePointerMove_(evt) {
        this.lastPixel_ = evt.pixel;
        this.handlePointerAtPixel_(evt.coordinate);
    }
    /**
   * @param {import("../coordinate.js").Coordinate} pixelCoordinate The pixel Coordinate.
   * @private
   */ handlePointerAtPixel_(pixelCoordinate) {
        const map = this.getMap();
        const pixel = map.getPixelFromCoordinate(pixelCoordinate);
        const projection = map.getView().getProjection();
        const sortByDistance = function(a, b) {
            return $8c24f34a0807f744$var$projectedDistanceToSegmentDataSquared(pixelCoordinate, a, projection) - $8c24f34a0807f744$var$projectedDistanceToSegmentDataSquared(pixelCoordinate, b, projection);
        };
        /** @type {Array<SegmentData>|undefined} */ let nodes;
        /** @type {Point|undefined} */ let hitPointGeometry;
        if (this.hitDetection_) {
            const layerFilter = typeof this.hitDetection_ === 'object' ? (layer)=>layer === this.hitDetection_ : undefined;
            map.forEachFeatureAtPixel(pixel, (feature, layer, geometry)=>{
                if (geometry && geometry.getType() === 'Point') geometry = new (0, $6eced4c969949f6b$export$2e2bcd8739ae039)((0, $9c4744460e43e41b$export$698f563af1ba02a5)(geometry.getCoordinates(), projection));
                const geom = geometry || feature.getGeometry();
                if (geom && geom.getType() === 'Point' && feature instanceof (0, $9fd014ab6df63665$export$2e2bcd8739ae039) && this.features_.getArray().includes(feature)) {
                    hitPointGeometry = /** @type {Point} */ geom;
                    const coordinate = /** @type {Point} */ feature.getGeometry().getFlatCoordinates().slice(0, 2);
                    nodes = [
                        {
                            feature: feature,
                            geometry: hitPointGeometry,
                            segment: [
                                coordinate,
                                coordinate
                            ]
                        }
                    ];
                }
                return true;
            }, {
                layerFilter: layerFilter
            });
        }
        if (!nodes) {
            const viewExtent = (0, $9c4744460e43e41b$export$494be3a3a25689ca)((0, $6da4c8ed3074c92b$export$4838bf78d04a9440)(pixelCoordinate, $8c24f34a0807f744$var$tempExtent), projection);
            const buffer = map.getView().getResolution() * this.pixelTolerance_;
            const box = (0, $9c4744460e43e41b$export$96bfd09e2cffb006)((0, $6da4c8ed3074c92b$export$ab1029bcae9ddb4a)(viewExtent, buffer, $8c24f34a0807f744$var$tempExtent), projection);
            nodes = this.rBush_.getInExtent(box);
        }
        if (nodes && nodes.length > 0) {
            const node = nodes.sort(sortByDistance)[0];
            const closestSegment = node.segment;
            let vertex = $8c24f34a0807f744$var$closestOnSegmentData(pixelCoordinate, node, projection);
            const vertexPixel = map.getPixelFromCoordinate(vertex);
            let dist = (0, $1bd0a226f9a16141$export$9f17032d917177de)(pixel, vertexPixel);
            if (hitPointGeometry || dist <= this.pixelTolerance_) {
                /** @type {Object<string, boolean>} */ const vertexSegments = {};
                vertexSegments[(0, $6c5e11070e371322$export$5e82334337e0f204)(closestSegment)] = true;
                if (!this.snapToPointer_) {
                    this.delta_[0] = vertex[0] - pixelCoordinate[0];
                    this.delta_[1] = vertex[1] - pixelCoordinate[1];
                }
                if (node.geometry.getType() === 'Circle' && node.index === $8c24f34a0807f744$var$CIRCLE_CIRCUMFERENCE_INDEX) {
                    this.snappedToVertex_ = true;
                    this.createOrUpdateVertexFeature_(vertex, [
                        node.feature
                    ], [
                        node.geometry
                    ], this.snappedToVertex_);
                } else {
                    const pixel1 = map.getPixelFromCoordinate(closestSegment[0]);
                    const pixel2 = map.getPixelFromCoordinate(closestSegment[1]);
                    const squaredDist1 = (0, $1bd0a226f9a16141$export$88e6ebb4fe54f538)(vertexPixel, pixel1);
                    const squaredDist2 = (0, $1bd0a226f9a16141$export$88e6ebb4fe54f538)(vertexPixel, pixel2);
                    dist = Math.sqrt(Math.min(squaredDist1, squaredDist2));
                    this.snappedToVertex_ = dist <= this.pixelTolerance_;
                    // Stop and cleanup overlay vertex feature if a segment was hit and new vertex creation is not allowed by the insertVertexCondition
                    if (!this.snappedToVertex_ && !this.insertVertexCondition_(this.lastPointerEvent_)) {
                        if (this.vertexFeature_) {
                            this.overlay_.getSource().removeFeature(this.vertexFeature_);
                            this.vertexFeature_ = null;
                        }
                        return;
                    }
                    if (this.snappedToVertex_) vertex = squaredDist1 > squaredDist2 ? closestSegment[1] : closestSegment[0];
                    this.createOrUpdateVertexFeature_(vertex, [
                        node.feature
                    ], [
                        node.geometry
                    ], this.snappedToVertex_);
                    const geometries = {};
                    geometries[(0, $6c5e11070e371322$export$5e82334337e0f204)(node.geometry)] = true;
                    for(let i = 1, ii = nodes.length; i < ii; ++i){
                        const segment = nodes[i].segment;
                        if ((0, $1bd0a226f9a16141$export$e9bab7fafb253603)(closestSegment[0], segment[0]) && (0, $1bd0a226f9a16141$export$e9bab7fafb253603)(closestSegment[1], segment[1]) || (0, $1bd0a226f9a16141$export$e9bab7fafb253603)(closestSegment[0], segment[1]) && (0, $1bd0a226f9a16141$export$e9bab7fafb253603)(closestSegment[1], segment[0])) {
                            const geometryUid = (0, $6c5e11070e371322$export$5e82334337e0f204)(nodes[i].geometry);
                            if (!(geometryUid in geometries)) {
                                geometries[geometryUid] = true;
                                vertexSegments[(0, $6c5e11070e371322$export$5e82334337e0f204)(segment)] = true;
                            }
                        } else break;
                    }
                }
                this.vertexSegments_ = vertexSegments;
                return;
            }
        }
        if (this.vertexFeature_) {
            this.overlay_.getSource().removeFeature(this.vertexFeature_);
            this.vertexFeature_ = null;
        }
    }
    /**
   * @param {SegmentData} segmentData Segment data.
   * @param {import("../coordinate.js").Coordinate} vertex Vertex.
   * @return {boolean} A vertex was inserted.
   * @private
   */ insertVertex_(segmentData, vertex) {
        const segment = segmentData.segment;
        const feature = segmentData.feature;
        const geometry = segmentData.geometry;
        const depth = segmentData.depth;
        const index = segmentData.index;
        let coordinates;
        while(vertex.length < geometry.getStride())vertex.push(0);
        switch(geometry.getType()){
            case 'MultiLineString':
                coordinates = geometry.getCoordinates();
                coordinates[depth[0]].splice(index + 1, 0, vertex);
                break;
            case 'Polygon':
                coordinates = geometry.getCoordinates();
                coordinates[depth[0]].splice(index + 1, 0, vertex);
                break;
            case 'MultiPolygon':
                coordinates = geometry.getCoordinates();
                coordinates[depth[1]][depth[0]].splice(index + 1, 0, vertex);
                break;
            case 'LineString':
                coordinates = geometry.getCoordinates();
                coordinates.splice(index + 1, 0, vertex);
                break;
            default:
                return false;
        }
        this.setGeometryCoordinates_(geometry, coordinates);
        const rTree = this.rBush_;
        rTree.remove(segmentData);
        this.updateSegmentIndices_(geometry, index, depth, 1);
        /** @type {SegmentData} */ const newSegmentData = {
            segment: [
                segment[0],
                vertex
            ],
            feature: feature,
            geometry: geometry,
            depth: depth,
            index: index
        };
        rTree.insert((0, $6da4c8ed3074c92b$export$8aceca7c77505534)(newSegmentData.segment), newSegmentData);
        this.dragSegments_.push([
            newSegmentData,
            1
        ]);
        /** @type {SegmentData} */ const newSegmentData2 = {
            segment: [
                vertex,
                segment[1]
            ],
            feature: feature,
            geometry: geometry,
            depth: depth,
            index: index + 1
        };
        rTree.insert((0, $6da4c8ed3074c92b$export$8aceca7c77505534)(newSegmentData2.segment), newSegmentData2);
        this.dragSegments_.push([
            newSegmentData2,
            0
        ]);
        return true;
    }
    updatePointer_(coordinate) {
        if (coordinate) this.findInsertVerticesAndUpdateDragSegments_(coordinate);
        return this.vertexFeature_?.getGeometry().getCoordinates();
    }
    /**
   * Get the current pointer position.
   * @return {import("../coordinate.js").Coordinate | null} The current pointer coordinate.
   */ getPoint() {
        const coordinate = this.vertexFeature_?.getGeometry().getCoordinates();
        if (!coordinate) return null;
        return (0, $9c4744460e43e41b$export$698f563af1ba02a5)(coordinate, this.getMap().getView().getProjection());
    }
    /**
   * Check if a point can be removed from the current linestring or polygon at the current
   * pointer position.
   * @return {boolean} A point can be deleted at the current pointer position.
   * @api
   */ canRemovePoint() {
        if (!this.vertexFeature_) return false;
        if (this.vertexFeature_.get('geometries').every((geometry)=>geometry.getType() === 'Circle' || geometry.getType().endsWith('Point'))) return false;
        const coordinate = this.vertexFeature_.getGeometry().getCoordinates();
        const segments = this.rBush_.getInExtent((0, $6da4c8ed3074c92b$export$8aceca7c77505534)([
            coordinate
        ]));
        return segments.some(({ segment: segment })=>(0, $1bd0a226f9a16141$export$e9bab7fafb253603)(segment[0], coordinate) || (0, $1bd0a226f9a16141$export$e9bab7fafb253603)(segment[1], coordinate));
    }
    /**
   * Removes the vertex currently being pointed from the current linestring or polygon.
   * @param {import('../coordinate.js').Coordinate} [coordinate] If provided, the pointer
   * will be set to the provided coordinate. If not, the current pointer coordinate will be used.
   * @return {boolean} True when a vertex was removed.
   * @api
   */ removePoint(coordinate) {
        if (coordinate) {
            coordinate = (0, $9c4744460e43e41b$export$d4b8ec0b96db1ee2)(coordinate, this.getMap().getView().getProjection());
            this.updatePointer_(coordinate);
        }
        if (!this.lastPointerEvent_ || this.lastPointerEvent_ && this.lastPointerEvent_.type != (0, $150f412a4a7fa263$export$2e2bcd8739ae039).POINTERDRAG) {
            const evt = this.lastPointerEvent_;
            this.willModifyFeatures_(evt, this.dragSegments_.map(([segment])=>segment));
            const removed = this.removeVertex_();
            if (this.featuresBeingModified_) this.dispatchEvent(new $8c24f34a0807f744$export$eb2af8bb6aa1fb54($8c24f34a0807f744$var$ModifyEventType.MODIFYEND, this.featuresBeingModified_, evt));
            this.featuresBeingModified_ = null;
            return removed;
        }
        return false;
    }
    /**
   * Removes a vertex from all matching features.
   * @return {boolean} True when a vertex was removed.
   * @private
   */ removeVertex_() {
        const dragSegments = this.dragSegments_;
        const segmentsByFeature = {};
        let deleted = false;
        let component, coordinates, dragSegment, geometry, i, index, left;
        let newIndex, right, segmentData, uid;
        for(i = dragSegments.length - 1; i >= 0; --i){
            dragSegment = dragSegments[i];
            segmentData = dragSegment[0];
            uid = (0, $6c5e11070e371322$export$5e82334337e0f204)(segmentData.feature);
            if (segmentData.depth) // separate feature components
            uid += '-' + segmentData.depth.join('-');
            if (!(uid in segmentsByFeature)) segmentsByFeature[uid] = {};
            if (dragSegment[1] === 0) {
                segmentsByFeature[uid].right = segmentData;
                segmentsByFeature[uid].index = segmentData.index;
            } else if (dragSegment[1] == 1) {
                segmentsByFeature[uid].left = segmentData;
                segmentsByFeature[uid].index = segmentData.index + 1;
            }
        }
        for(uid in segmentsByFeature){
            right = segmentsByFeature[uid].right;
            left = segmentsByFeature[uid].left;
            index = segmentsByFeature[uid].index;
            newIndex = index - 1;
            if (left !== undefined) segmentData = left;
            else segmentData = right;
            if (newIndex < 0) newIndex = 0;
            geometry = segmentData.geometry;
            coordinates = geometry.getCoordinates();
            component = coordinates;
            deleted = false;
            switch(geometry.getType()){
                case 'MultiLineString':
                    if (coordinates[segmentData.depth[0]].length > 2) {
                        coordinates[segmentData.depth[0]].splice(index, 1);
                        deleted = true;
                    }
                    break;
                case 'LineString':
                    if (coordinates.length > 2) {
                        coordinates.splice(index, 1);
                        deleted = true;
                    }
                    break;
                case 'MultiPolygon':
                    component = component[segmentData.depth[1]];
                /* falls through */ case 'Polygon':
                    component = component[segmentData.depth[0]];
                    if (component.length > 4) {
                        if (index == component.length - 1) index = 0;
                        component.splice(index, 1);
                        deleted = true;
                        if (index === 0) {
                            // close the ring again
                            component.pop();
                            component.push(component[0]);
                            newIndex = component.length - 1;
                        }
                    }
                    break;
                default:
            }
            if (deleted) {
                this.setGeometryCoordinates_(geometry, coordinates);
                const segments = [];
                if (left !== undefined) {
                    this.rBush_.remove(left);
                    segments.push(left.segment[0]);
                }
                if (right !== undefined) {
                    this.rBush_.remove(right);
                    segments.push(right.segment[1]);
                }
                if (left !== undefined && right !== undefined) {
                    /** @type {SegmentData} */ const newSegmentData = {
                        depth: segmentData.depth,
                        feature: segmentData.feature,
                        geometry: segmentData.geometry,
                        index: newIndex,
                        segment: segments
                    };
                    this.rBush_.insert((0, $6da4c8ed3074c92b$export$8aceca7c77505534)(newSegmentData.segment), newSegmentData);
                }
                this.updateSegmentIndices_(geometry, index, segmentData.depth, -1);
                if (this.vertexFeature_) {
                    this.overlay_.getSource().removeFeature(this.vertexFeature_);
                    this.vertexFeature_ = null;
                }
                dragSegments.length = 0;
            }
        }
        return deleted;
    }
    /**
   * Check if a point can be inserted to the current linestring or polygon at the current
   * pointer position.
   * @return {boolean} A point can be inserted at the current pointer position.
   * @api
   */ canInsertPoint() {
        if (!this.vertexFeature_) return false;
        if (this.vertexFeature_.get('geometries').every((geometry)=>geometry.getType() === 'Circle' || geometry.getType().endsWith('Point'))) return false;
        const coordinate = this.vertexFeature_.getGeometry().getCoordinates();
        const segments = this.rBush_.getInExtent((0, $6da4c8ed3074c92b$export$8aceca7c77505534)([
            coordinate
        ]));
        return segments.some(({ segment: segment })=>!((0, $1bd0a226f9a16141$export$e9bab7fafb253603)(segment[0], coordinate) || (0, $1bd0a226f9a16141$export$e9bab7fafb253603)(segment[1], coordinate)));
    }
    /**
   * Inserts the vertex currently being pointed to the current linestring or polygon.
   * @param {import('../coordinate.js').Coordinate} [coordinate] If provided, the pointer
   * will be set to the provided coordinate. If not, the current pointer coordinate will be used.
   * @return {boolean} A vertex was inserted.
   * @api
   */ insertPoint(coordinate) {
        const pixelCoordinate = coordinate ? (0, $9c4744460e43e41b$export$d4b8ec0b96db1ee2)(coordinate, this.getMap().getView().getProjection()) : this.vertexFeature_?.getGeometry().getCoordinates();
        if (!pixelCoordinate) return false;
        const insertVertices = this.findInsertVerticesAndUpdateDragSegments_(pixelCoordinate);
        return insertVertices.reduce((prev, segmentData)=>prev || this.insertVertex_(segmentData, pixelCoordinate), false);
    }
    /**
   * @param {import("../geom/SimpleGeometry.js").default} geometry Geometry.
   * @param {Array} coordinates Coordinates.
   * @private
   */ setGeometryCoordinates_(geometry, coordinates) {
        this.changingFeature_ = true;
        geometry.setCoordinates(coordinates);
        this.changingFeature_ = false;
    }
    /**
   * @param {import("../geom/SimpleGeometry.js").default} geometry Geometry.
   * @param {number} index Index.
   * @param {Array<number>|undefined} depth Depth.
   * @param {number} delta Delta (1 or -1).
   * @private
   */ updateSegmentIndices_(geometry, index, depth, delta) {
        this.rBush_.forEachInExtent(geometry.getExtent(), function(segmentDataMatch) {
            if (segmentDataMatch.geometry === geometry && (depth === undefined || segmentDataMatch.depth === undefined || (0, $b998d41b678ed5d1$export$e9bab7fafb253603)(segmentDataMatch.depth, depth)) && segmentDataMatch.index > index) segmentDataMatch.index += delta;
        });
    }
}
/**
 * @param {SegmentData} a The first segment data.
 * @param {SegmentData} b The second segment data.
 * @return {number} The difference in indexes.
 */ function $8c24f34a0807f744$var$compareIndexes(a, b) {
    return a.index - b.index;
}
/**
 * Returns the distance from a point to a line segment.
 *
 * @param {import("../coordinate.js").Coordinate} pointCoordinates The coordinates of the point from
 *        which to calculate the distance.
 * @param {SegmentData} segmentData The object describing the line
 *        segment we are calculating the distance to.
 * @param {import("../proj/Projection.js").default} projection The view projection.
 * @return {number} The square of the distance between a point and a line segment.
 */ function $8c24f34a0807f744$var$projectedDistanceToSegmentDataSquared(pointCoordinates, segmentData, projection) {
    const geometry = segmentData.geometry;
    if (geometry.getType() === 'Circle') {
        let circleGeometry = /** @type {import("../geom/Circle.js").default} */ geometry;
        if (segmentData.index === $8c24f34a0807f744$var$CIRCLE_CIRCUMFERENCE_INDEX) {
            const userProjection = (0, $9c4744460e43e41b$export$3973b77d5f6f2790)();
            if (userProjection) circleGeometry = circleGeometry.clone().transform(userProjection, projection);
            const distanceToCenterSquared = (0, $1bd0a226f9a16141$export$88e6ebb4fe54f538)(circleGeometry.getCenter(), (0, $9c4744460e43e41b$export$d4b8ec0b96db1ee2)(pointCoordinates, projection));
            const distanceToCircumference = Math.sqrt(distanceToCenterSquared) - circleGeometry.getRadius();
            return distanceToCircumference * distanceToCircumference;
        }
    }
    const coordinate = (0, $9c4744460e43e41b$export$d4b8ec0b96db1ee2)(pointCoordinates, projection);
    $8c24f34a0807f744$var$tempSegment[0] = (0, $9c4744460e43e41b$export$d4b8ec0b96db1ee2)(segmentData.segment[0], projection);
    $8c24f34a0807f744$var$tempSegment[1] = (0, $9c4744460e43e41b$export$d4b8ec0b96db1ee2)(segmentData.segment[1], projection);
    return (0, $1bd0a226f9a16141$export$6985570514055196)(coordinate, $8c24f34a0807f744$var$tempSegment);
}
/**
 * Returns the point closest to a given line segment.
 *
 * @param {import("../coordinate.js").Coordinate} pointCoordinates The point to which a closest point
 *        should be found.
 * @param {SegmentData} segmentData The object describing the line
 *        segment which should contain the closest point.
 * @param {import("../proj/Projection.js").default} projection The view projection.
 * @return {import("../coordinate.js").Coordinate} The point closest to the specified line segment.
 */ function $8c24f34a0807f744$var$closestOnSegmentData(pointCoordinates, segmentData, projection) {
    const geometry = segmentData.geometry;
    if (geometry.getType() === 'Circle' && segmentData.index === $8c24f34a0807f744$var$CIRCLE_CIRCUMFERENCE_INDEX) {
        let circleGeometry = /** @type {import("../geom/Circle.js").default} */ geometry;
        const userProjection = (0, $9c4744460e43e41b$export$3973b77d5f6f2790)();
        if (userProjection) circleGeometry = circleGeometry.clone().transform(userProjection, projection);
        return (0, $9c4744460e43e41b$export$698f563af1ba02a5)(circleGeometry.getClosestPoint((0, $9c4744460e43e41b$export$d4b8ec0b96db1ee2)(pointCoordinates, projection)), projection);
    }
    const coordinate = (0, $9c4744460e43e41b$export$d4b8ec0b96db1ee2)(pointCoordinates, projection);
    $8c24f34a0807f744$var$tempSegment[0] = (0, $9c4744460e43e41b$export$d4b8ec0b96db1ee2)(segmentData.segment[0], projection);
    $8c24f34a0807f744$var$tempSegment[1] = (0, $9c4744460e43e41b$export$d4b8ec0b96db1ee2)(segmentData.segment[1], projection);
    return (0, $9c4744460e43e41b$export$698f563af1ba02a5)((0, $1bd0a226f9a16141$export$18cdd31d17f97131)(coordinate, $8c24f34a0807f744$var$tempSegment), projection);
}
/**
 * @return {import("../style/Style.js").StyleFunction} Styles.
 */ function $8c24f34a0807f744$var$getDefaultStyleFunction() {
    const style = (0, $8c7f6dda98e8cb9c$export$ed1eaede5d0e77ac)();
    return function(feature, resolution) {
        return style['Point'];
    };
}
var $8c24f34a0807f744$export$2e2bcd8739ae039 = $8c24f34a0807f744$var$Modify;

/**
 * @module ol/interaction/Select
 */ 











/**
 * @enum {string}
 */ const $3a11846c6d9add3f$var$SelectEventType = {
    /**
   * Triggered when feature(s) has been (de)selected.
   * @event SelectEvent#select
   * @api
   */ SELECT: 'select'
};
class $3a11846c6d9add3f$export$1bcc516ebf36ffe2 extends (0, $aeedce20e9577100$export$2e2bcd8739ae039) {
    /**
   * @param {SelectEventType} type The event type.
   * @param {Array<import("../Feature.js").default>} selected Selected features.
   * @param {Array<import("../Feature.js").default>} deselected Deselected features.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Associated
   *     {@link module:ol/MapBrowserEvent~MapBrowserEvent}.
   */ constructor(type, selected, deselected, mapBrowserEvent){
        super(type);
        /**
     * Selected features array.
     * @type {Array<import("../Feature.js").default>}
     * @api
     */ this.selected = selected;
        /**
     * Deselected features array.
     * @type {Array<import("../Feature.js").default>}
     * @api
     */ this.deselected = deselected;
        /**
     * Associated {@link module:ol/MapBrowserEvent~MapBrowserEvent}.
     * @type {import("../MapBrowserEvent.js").default}
     * @api
     */ this.mapBrowserEvent = mapBrowserEvent;
    }
}
/**
 * Original feature styles to reset to when features are no longer selected.
 * @type {Object<number, import("../style/Style.js").default|Array<import("../style/Style.js").default>|import("../style/Style.js").StyleFunction>}
 */ const $3a11846c6d9add3f$var$originalFeatureStyles = {};
/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types|
 *     'change:active', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<'select', SelectEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types|
 *     'change:active'|'select', Return>} SelectOnSignature
 */ /**
 * @classdesc
 * Interaction for selecting vector features. By default, selected features are
 * styled differently, so this interaction can be used for visual highlighting,
 * as well as selecting features for other actions, such as modification or
 * output. There are three ways of controlling which features are selected:
 * using the browser event as defined by the `condition` and optionally the
 * `toggle`, `add`/`remove`, and `multi` options; a `layers` filter; and a
 * further feature filter using the `filter` option.
 *
 * @fires SelectEvent
 * @api
 */ class $3a11846c6d9add3f$var$Select extends (0, $39210df8527e63e5$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        super();
        /***
     * @type {SelectOnSignature<import("../events").EventsKey>}
     */ this.on;
        /***
     * @type {SelectOnSignature<import("../events").EventsKey>}
     */ this.once;
        /***
     * @type {SelectOnSignature<void>}
     */ this.un;
        options = options ? options : {};
        /**
     * @private
     */ this.boundAddFeature_ = this.addFeature_.bind(this);
        /**
     * @private
     */ this.boundRemoveFeature_ = this.removeFeature_.bind(this);
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.condition_ = options.condition ? options.condition : (0, $edf87b50170125f7$export$194df8bad091b401);
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.addCondition_ = options.addCondition ? options.addCondition : (0, $edf87b50170125f7$export$b3e22bcfd64c1022);
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.removeCondition_ = options.removeCondition ? options.removeCondition : (0, $edf87b50170125f7$export$b3e22bcfd64c1022);
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.toggleCondition_ = options.toggleCondition ? options.toggleCondition : (0, $edf87b50170125f7$export$5d31fe68a477cfbb);
        /**
     * @private
     * @type {boolean}
     */ this.multi_ = options.multi ? options.multi : false;
        /**
     * @private
     * @type {FilterFunction}
     */ this.filter_ = options.filter ? options.filter : (0, $013a1733c226ec50$export$22e23a2304399231);
        /**
     * @private
     * @type {number}
     */ this.hitTolerance_ = options.hitTolerance ? options.hitTolerance : 0;
        /**
     * @private
     * @type {import("../style/Style.js").default|Array<import("../style/Style.js").default>|import("../style/Style.js").StyleFunction|null}
     */ this.style_ = options.style !== undefined ? options.style : $3a11846c6d9add3f$var$getDefaultStyleFunction();
        /**
     * @private
     * @type {Collection<Feature>}
     */ this.features_ = options.features || new (0, $931ffc4e747c14db$export$2e2bcd8739ae039)();
        /** @type {function(import("../layer/Layer.js").default<import("../source/Source").default>): boolean} */ let layerFilter;
        if (options.layers) {
            if (typeof options.layers === 'function') layerFilter = options.layers;
            else {
                const layers = options.layers;
                layerFilter = function(layer) {
                    return layers.includes(layer);
                };
            }
        } else layerFilter = (0, $013a1733c226ec50$export$22e23a2304399231);
        /**
     * @private
     * @type {function(import("../layer/Layer.js").default<import("../source/Source").default>): boolean}
     */ this.layerFilter_ = layerFilter;
        /**
     * An association between selected feature (key)
     * and layer (value)
     * @private
     * @type {Object<string, import("../layer/Layer.js").default>}
     */ this.featureLayerAssociation_ = {};
    }
    /**
   * @param {import("../Feature.js").default} feature Feature.
   * @param {import("../layer/Layer.js").default} layer Layer.
   * @private
   */ addFeatureLayerAssociation_(feature, layer) {
        this.featureLayerAssociation_[(0, $6c5e11070e371322$export$5e82334337e0f204)(feature)] = layer;
    }
    /**
   * Get the selected features.
   * @return {Collection<Feature>} Features collection.
   * @api
   */ getFeatures() {
        return this.features_;
    }
    /**
   * Returns the Hit-detection tolerance.
   * @return {number} Hit tolerance in pixels.
   * @api
   */ getHitTolerance() {
        return this.hitTolerance_;
    }
    /**
   * Returns the associated {@link module:ol/layer/Vector~VectorLayer vector layer} of
   * a selected feature.
   * @param {import("../Feature.js").default} feature Feature
   * @return {import('../layer/Vector.js').default} Layer.
   * @api
   */ getLayer(feature) {
        return /** @type {import('../layer/Vector.js').default} */ this.featureLayerAssociation_[(0, $6c5e11070e371322$export$5e82334337e0f204)(feature)];
    }
    /**
   * Hit-detection tolerance. Pixels inside the radius around the given position
   * will be checked for features.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @api
   */ setHitTolerance(hitTolerance) {
        this.hitTolerance_ = hitTolerance;
    }
    /**
   * Remove the interaction from its current map, if any,  and attach it to a new
   * map, if any. Pass `null` to just remove the interaction from the current map.
   * @param {import("../Map.js").default|null} map Map.
   * @api
   * @override
   */ setMap(map) {
        const currentMap = this.getMap();
        if (currentMap && this.style_) this.features_.forEach(this.restorePreviousStyle_.bind(this));
        super.setMap(map);
        if (map) {
            this.features_.addEventListener((0, $161dd067fe2d672c$export$2e2bcd8739ae039).ADD, this.boundAddFeature_);
            this.features_.addEventListener((0, $161dd067fe2d672c$export$2e2bcd8739ae039).REMOVE, this.boundRemoveFeature_);
            if (this.style_) this.features_.forEach(this.applySelectedStyle_.bind(this));
        } else {
            this.features_.removeEventListener((0, $161dd067fe2d672c$export$2e2bcd8739ae039).ADD, this.boundAddFeature_);
            this.features_.removeEventListener((0, $161dd067fe2d672c$export$2e2bcd8739ae039).REMOVE, this.boundRemoveFeature_);
        }
    }
    /**
   * @param {import("../Collection.js").CollectionEvent<Feature>} evt Event.
   * @private
   */ addFeature_(evt) {
        const feature = evt.element;
        if (this.style_) this.applySelectedStyle_(feature);
        if (!this.getLayer(feature)) {
            const layer = /** @type {VectorLayer} */ this.getMap().getAllLayers().find(function(layer) {
                if (layer instanceof (0, $82a68515bd6ef378$export$2e2bcd8739ae039) && layer.getSource() && layer.getSource().hasFeature(feature)) return layer;
            });
            if (layer) this.addFeatureLayerAssociation_(feature, layer);
        }
    }
    /**
   * @param {import("../Collection.js").CollectionEvent<Feature>} evt Event.
   * @private
   */ removeFeature_(evt) {
        if (this.style_) this.restorePreviousStyle_(evt.element);
    }
    /**
   * @return {import("../style/Style.js").StyleLike|null} Select style.
   */ getStyle() {
        return this.style_;
    }
    /**
   * @param {Feature} feature Feature
   * @private
   */ applySelectedStyle_(feature) {
        const key = (0, $6c5e11070e371322$export$5e82334337e0f204)(feature);
        if (!(key in $3a11846c6d9add3f$var$originalFeatureStyles)) $3a11846c6d9add3f$var$originalFeatureStyles[key] = feature.getStyle();
        feature.setStyle(this.style_);
    }
    /**
   * @param {Feature} feature Feature
   * @private
   */ restorePreviousStyle_(feature) {
        const interactions = this.getMap().getInteractions().getArray();
        for(let i = interactions.length - 1; i >= 0; --i){
            const interaction = interactions[i];
            if (interaction !== this && interaction instanceof $3a11846c6d9add3f$var$Select && interaction.getStyle() && interaction.getFeatures().getArray().lastIndexOf(feature) !== -1) {
                feature.setStyle(interaction.getStyle());
                return;
            }
        }
        const key = (0, $6c5e11070e371322$export$5e82334337e0f204)(feature);
        feature.setStyle($3a11846c6d9add3f$var$originalFeatureStyles[key]);
        delete $3a11846c6d9add3f$var$originalFeatureStyles[key];
    }
    /**
   * @param {Feature} feature Feature.
   * @private
   */ removeFeatureLayerAssociation_(feature) {
        delete this.featureLayerAssociation_[(0, $6c5e11070e371322$export$5e82334337e0f204)(feature)];
    }
    /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} and may change the
   * selected state of features.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   * @override
   */ handleEvent(mapBrowserEvent) {
        if (!this.condition_(mapBrowserEvent)) return true;
        const add = this.addCondition_(mapBrowserEvent);
        const remove = this.removeCondition_(mapBrowserEvent);
        const toggle = this.toggleCondition_(mapBrowserEvent);
        const set = !add && !remove && !toggle;
        const map = mapBrowserEvent.map;
        const features = this.getFeatures();
        /**
     * @type {Array<Feature>}
     */ const deselected = [];
        /**
     * @type {Array<Feature>}
     */ const selected = [];
        if (set) {
            // Replace the currently selected feature(s) with the feature(s) at the
            // pixel, or clear the selected feature(s) if there is no feature at
            // the pixel.
            (0, $beaefe87199bb537$export$42ffd38884aecdac)(this.featureLayerAssociation_);
            map.forEachFeatureAtPixel(mapBrowserEvent.pixel, /**
         * @param {import("../Feature.js").FeatureLike} feature Feature.
         * @param {import("../layer/Layer.js").default} layer Layer.
         * @return {boolean|undefined} Continue to iterate over the features.
         */ (feature, layer)=>{
                if (!(feature instanceof (0, $9fd014ab6df63665$export$2e2bcd8739ae039)) || !this.filter_(feature, layer)) return;
                this.addFeatureLayerAssociation_(feature, layer);
                selected.push(feature);
                return !this.multi_;
            }, {
                layerFilter: this.layerFilter_,
                hitTolerance: this.hitTolerance_
            });
            for(let i = features.getLength() - 1; i >= 0; --i){
                const feature = features.item(i);
                const index = selected.indexOf(feature);
                if (index > -1) // feature is already selected
                selected.splice(index, 1);
                else {
                    features.remove(feature);
                    deselected.push(feature);
                }
            }
            if (selected.length !== 0) features.extend(selected);
        } else {
            // Modify the currently selected feature(s).
            map.forEachFeatureAtPixel(mapBrowserEvent.pixel, /**
         * @param {import("../Feature.js").FeatureLike} feature Feature.
         * @param {import("../layer/Layer.js").default} layer Layer.
         * @return {boolean|undefined} Continue to iterate over the features.
         */ (feature, layer)=>{
                if (!(feature instanceof (0, $9fd014ab6df63665$export$2e2bcd8739ae039)) || !this.filter_(feature, layer)) return;
                if ((add || toggle) && !features.getArray().includes(feature)) {
                    this.addFeatureLayerAssociation_(feature, layer);
                    selected.push(feature);
                } else if ((remove || toggle) && features.getArray().includes(feature)) {
                    deselected.push(feature);
                    this.removeFeatureLayerAssociation_(feature);
                }
                return !this.multi_;
            }, {
                layerFilter: this.layerFilter_,
                hitTolerance: this.hitTolerance_
            });
            for(let j = deselected.length - 1; j >= 0; --j)features.remove(deselected[j]);
            features.extend(selected);
        }
        if (selected.length > 0 || deselected.length > 0) this.dispatchEvent(new $3a11846c6d9add3f$export$1bcc516ebf36ffe2($3a11846c6d9add3f$var$SelectEventType.SELECT, selected, deselected, mapBrowserEvent));
        return true;
    }
}
/**
 * @return {import("../style/Style.js").StyleFunction} Styles.
 */ function $3a11846c6d9add3f$var$getDefaultStyleFunction() {
    const styles = (0, $8c7f6dda98e8cb9c$export$ed1eaede5d0e77ac)();
    (0, $b998d41b678ed5d1$export$8b58be045bf06082)(styles['Polygon'], styles['LineString']);
    (0, $b998d41b678ed5d1$export$8b58be045bf06082)(styles['GeometryCollection'], styles['LineString']);
    return function(feature) {
        if (!feature.getGeometry()) return null;
        return styles[feature.getGeometry().getType()];
    };
}
var $3a11846c6d9add3f$export$2e2bcd8739ae039 = $3a11846c6d9add3f$var$Select;

/**
 * @module ol/interaction/Translate
 */ 







/**
 * @enum {string}
 */ const $de2b65ee847802a8$var$TranslateEventType = {
    /**
   * Triggered upon feature translation start.
   * @event TranslateEvent#translatestart
   * @api
   */ TRANSLATESTART: 'translatestart',
    /**
   * Triggered upon feature translation.
   * @event TranslateEvent#translating
   * @api
   */ TRANSLATING: 'translating',
    /**
   * Triggered upon feature translation end.
   * @event TranslateEvent#translateend
   * @api
   */ TRANSLATEEND: 'translateend'
};
class $de2b65ee847802a8$export$1766f140d6979b9 extends (0, $aeedce20e9577100$export$2e2bcd8739ae039) {
    /**
   * @param {TranslateEventType} type Type.
   * @param {Collection<Feature>} features The features translated.
   * @param {import("../coordinate.js").Coordinate} coordinate The event coordinate.
   * @param {import("../coordinate.js").Coordinate} startCoordinate The original coordinates before.translation started
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   */ constructor(type, features, coordinate, startCoordinate, mapBrowserEvent){
        super(type);
        /**
     * The features being translated.
     * @type {Collection<Feature>}
     * @api
     */ this.features = features;
        /**
     * The coordinate of the drag event.
     * @const
     * @type {import("../coordinate.js").Coordinate}
     * @api
     */ this.coordinate = coordinate;
        /**
     * The coordinate of the start position before translation started.
     * @const
     * @type {import("../coordinate.js").Coordinate}
     * @api
     */ this.startCoordinate = startCoordinate;
        /**
     * Associated {@link module:ol/MapBrowserEvent~MapBrowserEvent}.
     * @type {import("../MapBrowserEvent.js").default}
     * @api
     */ this.mapBrowserEvent = mapBrowserEvent;
    }
}
/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types|
 *     'change:active', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<'translateend'|'translatestart'|'translating', TranslateEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types|
 *     'change:active'|'translateend'|'translatestart'|'translating', Return>} TranslateOnSignature
 */ /**
 * @classdesc
 * Interaction for translating (moving) features.
 * If you want to translate multiple features in a single action (for example,
 * the collection used by a select interaction), construct the interaction with
 * the `features` option.
 *
 * @fires TranslateEvent
 * @api
 */ class $de2b65ee847802a8$var$Translate extends (0, $cf1eb502962d87a8$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        super(/** @type {import("./Pointer.js").Options} */ options);
        /***
     * @type {TranslateOnSignature<import("../events").EventsKey>}
     */ this.on;
        /***
     * @type {TranslateOnSignature<import("../events").EventsKey>}
     */ this.once;
        /***
     * @type {TranslateOnSignature<void>}
     */ this.un;
        /**
     * The last position we translated to.
     * @type {import("../coordinate.js").Coordinate}
     * @private
     */ this.lastCoordinate_ = null;
        /**
     * The start position before translation started.
     * @type {import("../coordinate.js").Coordinate}
     * @private
     */ this.startCoordinate_ = null;
        /**
     * @type {Collection<Feature>|null}
     * @private
     */ this.features_ = options.features !== undefined ? options.features : null;
        /** @type {function(import("../layer/Layer.js").default<import("../source/Source").default>): boolean} */ let layerFilter;
        if (options.layers && !this.features_) {
            if (typeof options.layers === 'function') layerFilter = options.layers;
            else {
                const layers = options.layers;
                layerFilter = function(layer) {
                    return layers.includes(layer);
                };
            }
        } else layerFilter = (0, $013a1733c226ec50$export$22e23a2304399231);
        /**
     * @private
     * @type {function(import("../layer/Layer.js").default<import("../source/Source").default>): boolean}
     */ this.layerFilter_ = layerFilter;
        /**
     * @private
     * @type {FilterFunction}
     */ this.filter_ = options.filter && !this.features_ ? options.filter : (0, $013a1733c226ec50$export$22e23a2304399231);
        /**
     * @private
     * @type {number}
     */ this.hitTolerance_ = options.hitTolerance ? options.hitTolerance : 0;
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.condition_ = options.condition ? options.condition : (0, $edf87b50170125f7$export$ba9e5d519bc326ca);
        /**
     * @type {Feature}
     * @private
     */ this.lastFeature_ = null;
        this.addChangeListener((0, $2c9e42723ccf2bfb$export$2e2bcd8739ae039).ACTIVE, this.handleActiveChanged_);
    }
    /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} event Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleDownEvent(event) {
        if (!event.originalEvent || !this.condition_(event)) return false;
        this.lastFeature_ = this.featuresAtPixel_(event.pixel, event.map);
        if (!this.lastCoordinate_ && this.lastFeature_) {
            this.startCoordinate_ = event.coordinate;
            this.lastCoordinate_ = event.coordinate;
            this.handleMoveEvent(event);
            const features = this.features_ || new (0, $931ffc4e747c14db$export$2e2bcd8739ae039)([
                this.lastFeature_
            ]);
            this.dispatchEvent(new $de2b65ee847802a8$export$1766f140d6979b9($de2b65ee847802a8$var$TranslateEventType.TRANSLATESTART, features, event.coordinate, this.startCoordinate_, event));
            return true;
        }
        return false;
    }
    /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} event Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleUpEvent(event) {
        if (this.lastCoordinate_) {
            this.lastCoordinate_ = null;
            this.handleMoveEvent(event);
            const features = this.features_ || new (0, $931ffc4e747c14db$export$2e2bcd8739ae039)([
                this.lastFeature_
            ]);
            this.dispatchEvent(new $de2b65ee847802a8$export$1766f140d6979b9($de2b65ee847802a8$var$TranslateEventType.TRANSLATEEND, features, event.coordinate, this.startCoordinate_, event));
            // cleanup
            this.startCoordinate_ = null;
            return true;
        }
        return false;
    }
    /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} event Event.
   * @override
   */ handleDragEvent(event) {
        if (this.lastCoordinate_) {
            const newCoordinate = event.coordinate;
            const projection = event.map.getView().getProjection();
            const newViewCoordinate = (0, $9c4744460e43e41b$export$d4b8ec0b96db1ee2)(newCoordinate, projection);
            const lastViewCoordinate = (0, $9c4744460e43e41b$export$d4b8ec0b96db1ee2)(this.lastCoordinate_, projection);
            const deltaX = newViewCoordinate[0] - lastViewCoordinate[0];
            const deltaY = newViewCoordinate[1] - lastViewCoordinate[1];
            const features = this.features_ || new (0, $931ffc4e747c14db$export$2e2bcd8739ae039)([
                this.lastFeature_
            ]);
            const userProjection = (0, $9c4744460e43e41b$export$3973b77d5f6f2790)();
            features.forEach(function(feature) {
                const geom = feature.getGeometry();
                if (userProjection) {
                    geom.transform(userProjection, projection);
                    geom.translate(deltaX, deltaY);
                    geom.transform(projection, userProjection);
                } else geom.translate(deltaX, deltaY);
                feature.setGeometry(geom);
            });
            this.lastCoordinate_ = newCoordinate;
            this.dispatchEvent(new $de2b65ee847802a8$export$1766f140d6979b9($de2b65ee847802a8$var$TranslateEventType.TRANSLATING, features, newCoordinate, this.startCoordinate_, event));
        }
    }
    /**
   * Handle pointer move events.
   * @param {import("../MapBrowserEvent.js").default} event Event.
   * @override
   */ handleMoveEvent(event) {
        const elem = event.map.getViewport();
        // Change the cursor to grab/grabbing if hovering any of the features managed
        // by the interaction
        if (this.featuresAtPixel_(event.pixel, event.map)) {
            elem.classList.remove(this.lastCoordinate_ ? 'ol-grab' : 'ol-grabbing');
            elem.classList.add(this.lastCoordinate_ ? 'ol-grabbing' : 'ol-grab');
        } else elem.classList.remove('ol-grab', 'ol-grabbing');
    }
    /**
   * Tests to see if the given coordinates intersects any of our selected
   * features.
   * @param {import("../pixel.js").Pixel} pixel Pixel coordinate to test for intersection.
   * @param {import("../Map.js").default} map Map to test the intersection on.
   * @return {Feature} Returns the feature found at the specified pixel
   * coordinates.
   * @private
   */ featuresAtPixel_(pixel, map) {
        return map.forEachFeatureAtPixel(pixel, (feature, layer)=>{
            if (!(feature instanceof (0, $9fd014ab6df63665$export$2e2bcd8739ae039)) || !this.filter_(feature, layer)) return undefined;
            if (this.features_ && !this.features_.getArray().includes(feature)) return undefined;
            return feature;
        }, {
            layerFilter: this.layerFilter_,
            hitTolerance: this.hitTolerance_
        });
    }
    /**
   * Returns the Hit-detection tolerance.
   * @return {number} Hit tolerance in pixels.
   * @api
   */ getHitTolerance() {
        return this.hitTolerance_;
    }
    /**
   * Hit-detection tolerance. Pixels inside the radius around the given position
   * will be checked for features.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @api
   */ setHitTolerance(hitTolerance) {
        this.hitTolerance_ = hitTolerance;
    }
    /**
   * Remove the interaction from its current map and attach it to the new map.
   * Subclasses may set up event handlers to get notified about changes to
   * the map here.
   * @param {import("../Map.js").default} map Map.
   * @override
   */ setMap(map) {
        const oldMap = this.getMap();
        super.setMap(map);
        this.updateState_(oldMap);
    }
    /**
   * @private
   */ handleActiveChanged_() {
        this.updateState_(null);
    }
    /**
   * @param {import("../Map.js").default} oldMap Old map.
   * @private
   */ updateState_(oldMap) {
        let map = this.getMap();
        const active = this.getActive();
        if (!map || !active) {
            map = map || oldMap;
            if (map) {
                const elem = map.getViewport();
                elem.classList.remove('ol-grab', 'ol-grabbing');
            }
        }
    }
}
var $de2b65ee847802a8$export$2e2bcd8739ae039 = $de2b65ee847802a8$var$Translate;




const $58f704a3861e5d5d$var$FILENAME = 'edit-tool.js';
const $58f704a3861e5d5d$var$CLASS__TOOL_BUTTON = 'oltb-tool-button';
const $58f704a3861e5d5d$var$CLASS__TOOLBOX_SECTION = 'oltb-toolbox-section';
const $58f704a3861e5d5d$var$CLASS__TOGGLEABLE = 'oltb-toggleable';
const $58f704a3861e5d5d$var$ID__PREFIX = 'oltb-edit';
const $58f704a3861e5d5d$var$KEY__TOOLTIP = 'tools.editTool';
const $58f704a3861e5d5d$var$I18N__BASE = 'tools.editTool';
const $58f704a3861e5d5d$var$I18N__BASE_COMMON = 'commons';
const $58f704a3861e5d5d$var$DefaultOptions = Object.freeze({
    hitTolerance: 5,
    onInitiated: undefined,
    onClicked: undefined,
    onBrowserStateCleared: undefined,
    onStyleChange: undefined,
    onCutFeatures: undefined,
    onCopyFeatures: undefined,
    onPasteFeatures: undefined,
    onShapeOperation: undefined,
    onSelectAdd: undefined,
    onSelectRemove: undefined,
    onModifyStart: undefined,
    onModifyEnd: undefined,
    onTranslateStart: undefined,
    onTranslateEnd: undefined,
    onRemovedFeatures: undefined,
    onError: undefined,
    onSnapped: undefined,
    onUnSnapped: undefined
});
const $58f704a3861e5d5d$var$LocalStorageNodeName = (0, $52e25f2a10ab5b5c$export$ada36e8a1c3bc83a).editTool;
const $58f704a3861e5d5d$var$LocalStorageDefaults = Object.freeze({
    isActive: false,
    isCollapsed: false,
    strokeColor: '#0166A5FF',
    fillColor: '#D7E3FA80'
});
const $58f704a3861e5d5d$var$DefaultButtonProps = Object.freeze({
    width: 20,
    height: 20,
    fill: '#FFFFFFFF',
    stroke: 'none',
    class: 'oltb-btn__icon'
});
/**
 * About:
 * Edit objects on the Map
 * 
 * Description:
 * Edit previously drawn objects (including measurements) in the map. Change there size, color, shape and location. 
 * Apply various shape functions such as Union, Intersect, Exclude and Difference.
 */ class $58f704a3861e5d5d$export$f634386f0fc361c4 extends (0, $10d08d54da4ecbc4$export$cf198134d112da63) {
    constructor(options = {}){
        super({
            filename: $58f704a3861e5d5d$var$FILENAME
        });
        const icon = (0, $dcff5ab966a6537f$export$a297fe855adfd36c)({
            path: (0, $35649bc6579784f8$export$3fddabec91763a6e).cursor.stroked,
            class: `${$58f704a3861e5d5d$var$CLASS__TOOL_BUTTON}__icon`
        });
        const i18n = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get($58f704a3861e5d5d$var$I18N__BASE);
        const button = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'button',
            html: icon,
            class: $58f704a3861e5d5d$var$CLASS__TOOL_BUTTON,
            attributes: {
                'type': 'button',
                'data-tippy-content': `${i18n.title} (${(0, $a256deadcc62504f$export$4384767a59dc851d).editTool})`,
                'data-tippy-content-post': `(${(0, $a256deadcc62504f$export$4384767a59dc851d).editTool})`,
                'data-oltb-i18n': `${$58f704a3861e5d5d$var$I18N__BASE}.title`
            },
            listeners: {
                'click': this.onClickTool.bind(this)
            }
        });
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(this.element, [
            button
        ]);
        this.button = button;
        this.isActive = false;
        this.lastStyle = undefined;
        this.options = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep($58f704a3861e5d5d$var$DefaultOptions), options);
        this.localStorage = (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).getAndMergeStateObject($58f704a3861e5d5d$var$LocalStorageNodeName, $58f704a3861e5d5d$var$LocalStorageDefaults);
        this.originalFeatureStyles = {};
        this.featureClipboard = [];
        this.parser = new $89c443a2e3946d4f$exports.io.OL3Parser();
        this.parser.inject((0, $6eced4c969949f6b$export$2e2bcd8739ae039), (0, $292e4002746c8223$export$2e2bcd8739ae039), (0, $548636579b4087f2$export$2e2bcd8739ae039), (0, $40aa8d43bbe572bf$export$2e2bcd8739ae039), (0, $e6080c63a9451eda$export$2e2bcd8739ae039), (0, $b4c0e2e13beea46e$export$2e2bcd8739ae039), (0, $f73f35eb6af8b987$export$2e2bcd8739ae039), (0, $0e4f3959219eede5$export$2e2bcd8739ae039));
        this.#initToolboxHTML();
        this.uiRefToolboxSection = window.document.querySelector(`#${$58f704a3861e5d5d$var$ID__PREFIX}-toolbox`);
        this.#initToggleables();
        this.#initSettings();
        this.uiRefDeleteSelectedButton = this.uiRefToolboxSection.querySelector(`#${$58f704a3861e5d5d$var$ID__PREFIX}-delete-selected-button`);
        this.uiRefDeleteSelectedButton.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.click, this.#onDeleteSelectedFeatures.bind(this));
        this.uiRefRotateSelectedButton = this.uiRefToolboxSection.querySelector(`#${$58f704a3861e5d5d$var$ID__PREFIX}-rotate-selected-button`);
        this.uiRefRotateSelectedButton.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.click, this.#onRotateSelectedFeatures.bind(this));
        this.uiRefInfoSelectedButton = this.uiRefToolboxSection.querySelector(`#${$58f704a3861e5d5d$var$ID__PREFIX}-info-button`);
        this.uiRefInfoSelectedButton.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.click, this.#onInfoSelectedFeatures.bind(this));
        this.uiRefConvertSelectedButton = this.uiRefToolboxSection.querySelector(`#${$58f704a3861e5d5d$var$ID__PREFIX}-convert-button`);
        this.uiRefConvertSelectedButton.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.click, this.#onConvertSelectedFeatures.bind(this));
        this.uiRefCutSelectedButton = this.uiRefToolboxSection.querySelector(`#${$58f704a3861e5d5d$var$ID__PREFIX}-cut-selected-button`);
        this.uiRefCutSelectedButton.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.click, this.#onCutSelectedFeatures.bind(this));
        this.uiRefCopySelectedButton = this.uiRefToolboxSection.querySelector(`#${$58f704a3861e5d5d$var$ID__PREFIX}-copy-selected-button`);
        this.uiRefCopySelectedButton.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.click, this.#onCopySelectedFeatures.bind(this));
        this.uiRefPasteSelectedButton = this.uiRefToolboxSection.querySelector(`#${$58f704a3861e5d5d$var$ID__PREFIX}-paste-selected-button`);
        this.uiRefPasteSelectedButton.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.click, this.#onPasteSelectedFeatures.bind(this));
        this.uiRefUnionSelectedButton = this.uiRefToolboxSection.querySelector(`#${$58f704a3861e5d5d$var$ID__PREFIX}-union-selected-button`);
        this.uiRefUnionSelectedButton.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.click, this.#onShapeOperator.bind(this, this.unionFeatures, 'union'));
        this.uiRefIntersectSelectedButton = this.uiRefToolboxSection.querySelector(`#${$58f704a3861e5d5d$var$ID__PREFIX}-intersect-selected-button`);
        this.uiRefIntersectSelectedButton.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.click, this.#onShapeOperator.bind(this, this.intersectFeatures, 'intersect'));
        this.uiRefExcludeSelectedButton = this.uiRefToolboxSection.querySelector(`#${$58f704a3861e5d5d$var$ID__PREFIX}-exclude-selected-button`);
        this.uiRefExcludeSelectedButton.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.click, this.#onShapeOperator.bind(this, this.excludeFeatures, 'exclude'));
        this.uiRefDifferenceSelectedButton = this.uiRefToolboxSection.querySelector(`#${$58f704a3861e5d5d$var$ID__PREFIX}-difference-selected-button`);
        this.uiRefDifferenceSelectedButton.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.click, this.#onShapeOperator.bind(this, this.differenceFeatures, 'difference'));
        this.uiRefFillColor = this.uiRefToolboxSection.querySelector(`#${$58f704a3861e5d5d$var$ID__PREFIX}-fill-color`);
        this.uiRefFillColor.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.colorChange, this.#onFeatureColorChange.bind(this));
        this.uiRefStrokeColor = this.uiRefToolboxSection.querySelector(`#${$58f704a3861e5d5d$var$ID__PREFIX}-stroke-color`);
        this.uiRefStrokeColor.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.colorChange, this.#onFeatureColorChange.bind(this));
        this.interactionSelect = this.#generateOLInteractionSelect();
        this.interactionModify = this.#generateOLInteractionModify();
        this.interactionTranslate = this.#generateOLInteractionTranslate();
        this.interactionSelect.getFeatures().on((0, $a9807b370eed025c$export$ada873a34909da65).openLayers.add, this.#onSelectFeatureAdd.bind(this));
        this.interactionSelect.getFeatures().on((0, $a9807b370eed025c$export$ada873a34909da65).openLayers.remove, this.#onSelectFeatureRemove.bind(this));
        this.interactionModify.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).openLayers.modifyStart, this.#onModifyStart.bind(this));
        this.interactionModify.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).openLayers.modifyEnd, this.#onModifyEnd.bind(this));
        this.interactionTranslate.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).openLayers.translateStart, this.#onTranslateStart.bind(this));
        this.interactionTranslate.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).openLayers.translateEnd, this.#onTranslateEnd.bind(this));
        this.attachGlobalListeners();
        // Note: 
        // @Consumer callback
        if (this.options.onInitiated) this.options.onInitiated();
    }
    attachGlobalListeners() {
        this.onWindowKeyUpBind = this.#onWindowKeyUp.bind(this);
        this.onOLTBReadyBind = this.#onOLTBReady.bind(this);
        this.onWindowBrowserStateClearedBind = this.#onWindowBrowserStateCleared.bind(this);
        this.onWindowFeatureLayerRemovedBind = this.#onWindowFeatureLayerRemoved.bind(this);
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.keyUp, this.onWindowKeyUpBind);
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.ready, this.onOLTBReadyBind);
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.browserStateCleared, this.onWindowBrowserStateClearedBind);
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.featureLayerRemoved, this.onWindowFeatureLayerRemovedBind);
    }
    detachGlobalListeners() {
        window.removeEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.keyUp, this.onWindowKeyUpBind);
        window.removeEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.ready, this.onOLTBReadyBind);
        window.removeEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.browserStateCleared, this.onWindowBrowserStateClearedBind);
        window.removeEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.featureLayerRemoved, this.onWindowFeatureLayerRemovedBind);
    }
    //--------------------------------------------------------------------
    // # Section: Overridden
    //--------------------------------------------------------------------
    getName() {
        return super.getName();
    }
    onClickTool(event) {
        super.onClickTool(event);
        if (this.isActive) this.deactivateTool();
        else this.activateTool();
        // Note: 
        // @Consumer callback
        if (this.options.onClicked) this.options.onClicked();
    }
    //--------------------------------------------------------------------
    // # Section: Init Helpers
    //--------------------------------------------------------------------
    #initToolboxHTML() {
        const i18n = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get(`${$58f704a3861e5d5d$var$I18N__BASE}.toolbox`);
        const i18nCommon = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get(`${$58f704a3861e5d5d$var$I18N__BASE_COMMON}.titles`);
        const buttonClasses = 'class="oltb-btn oltb-btn--blue-mid oltb-tippy"';
        const html = `
            <div id="${$58f704a3861e5d5d$var$ID__PREFIX}-toolbox" class="${$58f704a3861e5d5d$var$CLASS__TOOLBOX_SECTION}">
                <div class="${$58f704a3861e5d5d$var$CLASS__TOOLBOX_SECTION}__header oltb-toggleable" data-oltb-toggleable-target="${$58f704a3861e5d5d$var$ID__PREFIX}-toolbox-collapsed">
                    <h4 class="${$58f704a3861e5d5d$var$CLASS__TOOLBOX_SECTION}__title" data-oltb-i18n="${$58f704a3861e5d5d$var$I18N__BASE}.toolbox.titles.edit">${i18n.titles.edit}</h4>
                    <span class="${$58f704a3861e5d5d$var$CLASS__TOOLBOX_SECTION}__icon oltb-tippy" data-oltb-i18n="${$58f704a3861e5d5d$var$I18N__BASE_COMMON}.titles.toggleSection" title="${i18nCommon.toggleSection}"></span>
                </div>
                <div class="${$58f704a3861e5d5d$var$CLASS__TOOLBOX_SECTION}__groups" id="${$58f704a3861e5d5d$var$ID__PREFIX}-toolbox-collapsed" style="display: ${this.localStorage.isCollapsed ? 'none' : 'block'}">
                    <div class="${$58f704a3861e5d5d$var$CLASS__TOOLBOX_SECTION}__group ${$58f704a3861e5d5d$var$CLASS__TOOLBOX_SECTION}__group--sub-toolbar">
                        <label class="oltb-label" data-oltb-i18n="${$58f704a3861e5d5d$var$I18N__BASE}.toolbox.groups.misc.title">${i18n.groups.misc.title}</label>
                        <button type="button" id="${$58f704a3861e5d5d$var$ID__PREFIX}-delete-selected-button" ${buttonClasses} data-oltb-i18n="${$58f704a3861e5d5d$var$I18N__BASE}.toolbox.groups.misc.delete" title="${i18n.groups.misc.delete}">
                            ${(0, $dcff5ab966a6537f$export$a297fe855adfd36c)({
            ...$58f704a3861e5d5d$var$DefaultButtonProps,
            path: (0, $35649bc6579784f8$export$3fddabec91763a6e).trash.stroked
        })}
                        </button>
                        <button type="button" id="${$58f704a3861e5d5d$var$ID__PREFIX}-rotate-selected-button" ${buttonClasses} data-oltb-i18n="${$58f704a3861e5d5d$var$I18N__BASE}.toolbox.groups.misc.rotate" title="${i18n.groups.misc.rotate}">
                            ${(0, $dcff5ab966a6537f$export$a297fe855adfd36c)({
            ...$58f704a3861e5d5d$var$DefaultButtonProps,
            path: (0, $35649bc6579784f8$export$3fddabec91763a6e).arrowRepeat.stroked
        })}
                        </button>
                        <button type="button" id="${$58f704a3861e5d5d$var$ID__PREFIX}-info-button" ${buttonClasses} data-oltb-i18n="${$58f704a3861e5d5d$var$I18N__BASE}.toolbox.groups.misc.geometryData" title="${i18n.groups.misc.geometryData}">
                            ${(0, $dcff5ab966a6537f$export$a297fe855adfd36c)({
            ...$58f704a3861e5d5d$var$DefaultButtonProps,
            path: (0, $35649bc6579784f8$export$3fddabec91763a6e).infoCircle.stroked
        })}
                        </button>
                        <button type="button" id="${$58f704a3861e5d5d$var$ID__PREFIX}-convert-button" ${buttonClasses} data-oltb-i18n="${$58f704a3861e5d5d$var$I18N__BASE}.toolbox.groups.misc.convertFeature" title="${i18n.groups.misc.convertFeature}">
                            ${(0, $dcff5ab966a6537f$export$a297fe855adfd36c)({
            ...$58f704a3861e5d5d$var$DefaultButtonProps,
            path: (0, $35649bc6579784f8$export$3fddabec91763a6e).shuffle.stroked
        })}
                        </button>
                    </div>
                    <div class="${$58f704a3861e5d5d$var$CLASS__TOOLBOX_SECTION}__group ${$58f704a3861e5d5d$var$CLASS__TOOLBOX_SECTION}__group--sub-toolbar">
                        <label class="oltb-label" data-oltb-i18n="${$58f704a3861e5d5d$var$I18N__BASE}.toolbox.groups.copying.title">${i18n.groups.copying.title}</label>
                        <button type="button" id="${$58f704a3861e5d5d$var$ID__PREFIX}-cut-selected-button" ${buttonClasses} data-oltb-i18n="${$58f704a3861e5d5d$var$I18N__BASE}.toolbox.groups.copying.cut" title="${i18n.groups.copying.cut}">
                            ${(0, $dcff5ab966a6537f$export$a297fe855adfd36c)({
            ...$58f704a3861e5d5d$var$DefaultButtonProps,
            path: (0, $35649bc6579784f8$export$3fddabec91763a6e).scissors.filled
        })}
                        </button>
                        <button type="button" id="${$58f704a3861e5d5d$var$ID__PREFIX}-copy-selected-button" ${buttonClasses} data-oltb-i18n="${$58f704a3861e5d5d$var$I18N__BASE}.toolbox.groups.copying.copy" title="${i18n.groups.copying.copy}">
                            ${(0, $dcff5ab966a6537f$export$a297fe855adfd36c)({
            ...$58f704a3861e5d5d$var$DefaultButtonProps,
            path: (0, $35649bc6579784f8$export$3fddabec91763a6e).copy.stroked
        })}
                        </button>
                        <button type="button" id="${$58f704a3861e5d5d$var$ID__PREFIX}-paste-selected-button" ${buttonClasses} data-oltb-i18n="${$58f704a3861e5d5d$var$I18N__BASE}.toolbox.groups.copying.paste" title="${i18n.groups.copying.paste}">
                            ${(0, $dcff5ab966a6537f$export$a297fe855adfd36c)({
            ...$58f704a3861e5d5d$var$DefaultButtonProps,
            path: (0, $35649bc6579784f8$export$3fddabec91763a6e).clipboard.stroked
        })}
                        </button>
                    </div>
                    <div class="${$58f704a3861e5d5d$var$CLASS__TOOLBOX_SECTION}__group ${$58f704a3861e5d5d$var$CLASS__TOOLBOX_SECTION}__group--sub-toolbar ${$58f704a3861e5d5d$var$CLASS__TOOLBOX_SECTION}__group--split-group">
                        <label class="oltb-label" data-oltb-i18n="${$58f704a3861e5d5d$var$I18N__BASE}.toolbox.groups.shapes.title">${i18n.groups.shapes.title}</label>
                        <button type="button" id="${$58f704a3861e5d5d$var$ID__PREFIX}-union-selected-button" ${buttonClasses} data-oltb-i18n="${$58f704a3861e5d5d$var$I18N__BASE}.toolbox.groups.shapes.union" title="${i18n.groups.shapes.union}">
                            ${(0, $dcff5ab966a6537f$export$a297fe855adfd36c)({
            ...$58f704a3861e5d5d$var$DefaultButtonProps,
            path: (0, $35649bc6579784f8$export$3fddabec91763a6e).union.mixed
        })}
                        </button>
                        <button type="button" id="${$58f704a3861e5d5d$var$ID__PREFIX}-intersect-selected-button" ${buttonClasses} data-oltb-i18n="${$58f704a3861e5d5d$var$I18N__BASE}.toolbox.groups.shapes.intersect" title="${i18n.groups.shapes.intersect}">
                            ${(0, $dcff5ab966a6537f$export$a297fe855adfd36c)({
            ...$58f704a3861e5d5d$var$DefaultButtonProps,
            path: (0, $35649bc6579784f8$export$3fddabec91763a6e).intersect.mixed
        })}
                        </button>
                        <button type="button" id="${$58f704a3861e5d5d$var$ID__PREFIX}-exclude-selected-button" ${buttonClasses} data-oltb-i18n="${$58f704a3861e5d5d$var$I18N__BASE}.toolbox.groups.shapes.exclude" title="${i18n.groups.shapes.exclude}">
                            ${(0, $dcff5ab966a6537f$export$a297fe855adfd36c)({
            ...$58f704a3861e5d5d$var$DefaultButtonProps,
            path: (0, $35649bc6579784f8$export$3fddabec91763a6e).exclude.mixed
        })}
                        </button>
                        <button type="button" id="${$58f704a3861e5d5d$var$ID__PREFIX}-difference-selected-button" ${buttonClasses} data-oltb-i18n="${$58f704a3861e5d5d$var$I18N__BASE}.toolbox.groups.shapes.difference" title="${i18n.groups.shapes.difference}">
                            ${(0, $dcff5ab966a6537f$export$a297fe855adfd36c)({
            ...$58f704a3861e5d5d$var$DefaultButtonProps,
            path: (0, $35649bc6579784f8$export$3fddabec91763a6e).subtract.mixed
        })}
                        </button>
                    </div>
                    <div class="${$58f704a3861e5d5d$var$CLASS__TOOLBOX_SECTION}__group ${$58f704a3861e5d5d$var$CLASS__TOOLBOX_SECTION}__group--split-group">
                        <div class="${$58f704a3861e5d5d$var$CLASS__TOOLBOX_SECTION}__group-part">
                            <label class="oltb-label" for="${$58f704a3861e5d5d$var$ID__PREFIX}-stroke-color" data-oltb-i18n="${$58f704a3861e5d5d$var$I18N__BASE}.toolbox.groups.strokeColor.title">${i18n.groups.strokeColor.title}</label>
                            <div id="${$58f704a3861e5d5d$var$ID__PREFIX}-stroke-color" class="oltb-color-input oltb-color-tippy" data-oltb-color-target="#${$58f704a3861e5d5d$var$ID__PREFIX}-stroke-color" data-oltb-color="${this.localStorage.strokeColor}" tabindex="0">
                                <div class="oltb-color-input__inner" style="background-color: ${this.localStorage.strokeColor};"></div>
                            </div>
                        </div>
                        <div class="${$58f704a3861e5d5d$var$CLASS__TOOLBOX_SECTION}__group-part">
                            <label class="oltb-label" for="${$58f704a3861e5d5d$var$ID__PREFIX}-fill-color" data-oltb-i18n="${$58f704a3861e5d5d$var$I18N__BASE}.toolbox.groups.fillColor.title">${i18n.groups.fillColor.title}</label>
                            <div id="${$58f704a3861e5d5d$var$ID__PREFIX}-fill-color" class="oltb-color-input oltb-color-tippy" data-oltb-color-target="#${$58f704a3861e5d5d$var$ID__PREFIX}-fill-color" data-oltb-color="${this.localStorage.fillColor}" tabindex="0">
                                <div class="oltb-color-input__inner" style="background-color: ${this.localStorage.fillColor};"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        `;
        (0, $8f42450ebdd44f5e$export$8e7188a60a5bbe16).getToolboxElement().insertAdjacentHTML('beforeend', html);
    }
    #initToggleables() {
        this.uiRefToolboxSection.querySelectorAll(`.${$58f704a3861e5d5d$var$CLASS__TOGGLEABLE}`).forEach((toggle)=>{
            toggle.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.click, this.#onToggleToolbox.bind(this, toggle));
        });
    }
    #initSettings() {
        (0, $5547bbb6fff7ebf1$export$3016a1f47b675883).addSetting((0, $65522956a1f1a049$export$c72f6eaae7b9adff).mouseOnlyToEditVectorShapes, {
            state: true,
            i18nBase: `${$58f704a3861e5d5d$var$I18N__BASE}.settings`,
            i18nKey: 'mouseOnlyToEditVectorShapes'
        });
    }
    //--------------------------------------------------------------------
    // # Section: Generate Helpers
    //--------------------------------------------------------------------
    #generateOLInteractionSelect() {
        return new (0, $3a11846c6d9add3f$export$2e2bcd8739ae039)({
            hitTolerance: this.options.hitTolerance,
            style: (feature, resolution)=>{
                return (0, $2577fba4fdbf4b69$export$29bb23d12246c816).getSelectedStyle(feature, resolution);
            },
            filter: (feature, layer)=>{
                const isIconMarker = (0, $45f5d1a81c4ed6cb$export$73e78dff44a347ad).isIconMarkerType(feature);
                if (isIconMarker) return false;
                const isWindBarb = (0, $45f5d1a81c4ed6cb$export$73e78dff44a347ad).isWindBarbType(feature);
                if (isWindBarb) return false;
                const belongsToFeatureLayer = (0, $e75fe1c51a3d360c$export$eff87c52915dd7fe).belongsToFeatureLayer(feature);
                if (belongsToFeatureLayer) return true;
                const selectVectorShapesInMapLayers = (0, $5547bbb6fff7ebf1$export$3016a1f47b675883).getSetting((0, $65522956a1f1a049$export$c72f6eaae7b9adff).selectVectorMapShapes);
                const belongsToMapLayer = (0, $e75fe1c51a3d360c$export$eff87c52915dd7fe).belongsToMapLayer(feature);
                if (belongsToMapLayer && selectVectorShapesInMapLayers) return true;
                return false;
            }
        });
    }
    #generateOLInteractionModify() {
        return new (0, $8c24f34a0807f744$export$2e2bcd8739ae039)({
            features: this.interactionSelect.getFeatures(),
            condition: (event)=>{
                return (0, $edf87b50170125f7$export$5d31fe68a477cfbb)(event) || this.useMouseOnlyToEditVectorShapes();
            }
        });
    }
    #generateOLInteractionTranslate() {
        return new (0, $de2b65ee847802a8$export$2e2bcd8739ae039)({
            features: this.interactionSelect.getFeatures()
        });
    }
    //--------------------------------------------------------------------
    // # Section: Tool Control
    //--------------------------------------------------------------------
    activateTool() {
        const map = this.getMap();
        if (!map) return;
        [
            this.interactionSelect,
            this.interactionTranslate,
            this.interactionModify
        ].forEach((item)=>{
            map.addInteraction(item);
        });
        (0, $3110b1ed727d9f35$export$df4a79c26d3b48ff).setActiveTool(this);
        (0, $9829e24a28f9d958$export$786f0b7d4117ba87).addSnap(this);
        this.isActive = true;
        this.uiRefToolboxSection.classList.add(`${$58f704a3861e5d5d$var$CLASS__TOOLBOX_SECTION}--show`);
        this.button.classList.add(`${$58f704a3861e5d5d$var$CLASS__TOOL_BUTTON}--active`);
        this.localStorage.isActive = true;
        (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).setStateObject($58f704a3861e5d5d$var$LocalStorageNodeName, this.localStorage);
        this.uiRefToolboxSection.scrollIntoView({
            behavior: 'smooth',
            block: 'end',
            inline: 'nearest'
        });
    }
    deactivateTool() {
        [
            this.interactionSelect,
            this.interactionTranslate,
            this.interactionModify
        ].forEach((item)=>{
            this.getMap().removeInteraction(item);
        });
        this.interactionSelect.getFeatures().clear();
        (0, $3110b1ed727d9f35$export$df4a79c26d3b48ff).removeActiveTool();
        (0, $9829e24a28f9d958$export$786f0b7d4117ba87).removeSnap();
        this.isActive = false;
        this.uiRefToolboxSection.classList.remove(`${$58f704a3861e5d5d$var$CLASS__TOOLBOX_SECTION}--show`);
        this.button.classList.remove(`${$58f704a3861e5d5d$var$CLASS__TOOL_BUTTON}--active`);
        this.localStorage.isActive = false;
        (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).setStateObject($58f704a3861e5d5d$var$LocalStorageNodeName, this.localStorage);
    }
    deselectTool() {
        this.deactivateTool();
    }
    //--------------------------------------------------------------------
    // # Section: Internal
    //--------------------------------------------------------------------
    #deleteFeatures(features) {
        // Note: 
        // The user can select features from any layer
        // Each feature needs to be removed from its associated layer
        const layerWrappers = (0, $e75fe1c51a3d360c$export$eff87c52915dd7fe).getFeatureLayers();
        features.forEach((feature)=>{
            layerWrappers.forEach((layerWrapper)=>{
                if (layerWrapper.getLayer().getSource().hasFeature === undefined || !layerWrapper.getLayer().getSource().hasFeature(feature)) return;
                (0, $e75fe1c51a3d360c$export$eff87c52915dd7fe).removeFeatureFromLayer(feature, layerWrapper);
                this.interactionSelect.getFeatures().remove(feature);
            });
        });
    }
    //--------------------------------------------------------------------
    // # Section: Browser Events
    //--------------------------------------------------------------------
    #onOLTBReady(event) {
        if (this.localStorage.isActive) this.activateTool();
    }
    #onWindowKeyUp(event) {
        if ((0, $fbd95439548fdf50$export$ad7bf7af8762113)(event, (0, $a256deadcc62504f$export$4384767a59dc851d).editTool)) this.onClickTool(event);
        else if (this.isActive && event.key === (0, $7cb32231c4f9783a$export$70f9e5bc10d7eac).valueDelete) this.#onDeleteSelectedFeatures();
    }
    #onWindowBrowserStateCleared() {
        this.doClearState();
        this.doClearColors();
        if (this.isActive) this.deactivateTool();
        // Note:
        // @Consumer callback
        if (this.options.onBrowserStateCleared) this.options.onBrowserStateCleared();
    }
    #onWindowFeatureLayerRemoved(event) {
        this.interactionSelect.getFeatures().clear();
    }
    //--------------------------------------------------------------------
    // # Section: Map/UI Callbacks
    //--------------------------------------------------------------------
    #onToggleToolbox(toggle) {
        const targetName = toggle.dataset.oltbToggleableTarget;
        this.doToggleToolboxSection(targetName);
    }
    #onSelectFeatureAdd(event) {
        this.doSelectFeatureAdd(event);
    }
    #onSelectFeatureRemove(event) {
        this.doSelectFeatureRemove(event);
    }
    #onModifyStart(event) {
        this.doModifyStart(event);
    }
    #onModifyEnd(event) {
        this.doModifyEnd(event);
    }
    #onTranslateStart(event) {
        this.doTranslateStart(event);
    }
    #onTranslateEnd(event) {
        this.doTranslateEnd(event);
    }
    #onDeleteSelectedFeatures() {
        const features = [
            ...this.interactionSelect.getFeatures().getArray()
        ];
        const autoremove = true;
        if (features.length === 0) {
            (0, $9051f0e072bf4341$export$8d8dc7d5f743331b).info({
                i18nKey: `${$58f704a3861e5d5d$var$I18N__BASE}.toasts.infos.missingFeatures`,
                autoremove: autoremove
            });
            return;
        }
        this.askToDeleteFeatures(features);
    }
    #onRotateSelectedFeatures() {
        const features = [
            ...this.interactionSelect.getFeatures().getArray()
        ];
        const autoremove = true;
        if (features.length === 0) {
            (0, $9051f0e072bf4341$export$8d8dc7d5f743331b).info({
                i18nKey: `${$58f704a3861e5d5d$var$I18N__BASE}.toasts.infos.missingFeatures`,
                autoremove: autoremove
            });
            return;
        }
        this.askToRotateSelectedFeatures(features);
    }
    #onInfoSelectedFeatures() {
        const features = [
            ...this.interactionSelect.getFeatures().getArray()
        ];
        if (features.length === 0) {
            (0, $9051f0e072bf4341$export$8d8dc7d5f743331b).info({
                i18nKey: `${$58f704a3861e5d5d$var$I18N__BASE}.toasts.infos.missingFeatures`,
                autoremove: true
            });
            return;
        }
        if (features.length >= 2) {
            (0, $9051f0e072bf4341$export$8d8dc7d5f743331b).info({
                i18nKey: `${$58f704a3861e5d5d$var$I18N__BASE}.toasts.infos.strictOneFeature`,
                autoremove: true
            });
            return;
        }
        this.doShowFeatureInfo(features[0]);
    }
    #onConvertSelectedFeatures() {
        const features = [
            ...this.interactionSelect.getFeatures().getArray()
        ];
        if (features.length === 0) {
            (0, $9051f0e072bf4341$export$8d8dc7d5f743331b).info({
                i18nKey: `${$58f704a3861e5d5d$var$I18N__BASE}.toasts.infos.missingFeatures`,
                autoremove: true
            });
            return;
        }
        this.askToConvertSelectedFeatures(features);
    }
    #onCutSelectedFeatures(event) {
        const features = [
            ...this.interactionSelect.getFeatures().getArray()
        ];
        if (features.length === 0) {
            (0, $9051f0e072bf4341$export$8d8dc7d5f743331b).info({
                i18nKey: `${$58f704a3861e5d5d$var$I18N__BASE}.toasts.infos.missingFeatures`,
                autoremove: true
            });
            return;
        }
        this.doCutFeatures(features);
    }
    #onCopySelectedFeatures(event) {
        const features = [
            ...this.interactionSelect.getFeatures().getArray()
        ];
        if (features.length === 0) {
            (0, $9051f0e072bf4341$export$8d8dc7d5f743331b).info({
                i18nKey: `${$58f704a3861e5d5d$var$I18N__BASE}.toasts.infos.missingFeatures`,
                autoremove: true
            });
            return;
        }
        this.doCopyFeatures(features);
    }
    #onPasteSelectedFeatures(event) {
        if (this.featureClipboard.length === 0) {
            (0, $9051f0e072bf4341$export$8d8dc7d5f743331b).info({
                i18nKey: `${$58f704a3861e5d5d$var$I18N__BASE}.toasts.infos.missingFeatures`,
                autoremove: true
            });
            return;
        }
        this.doPasteFeatures();
    }
    #onFeatureColorChange(event) {
        this.doFeatureColorChange(event);
    }
    #onFeatureChange(feature) {
        this.doFeatureChange(feature);
    }
    #onShapeOperator(operation, type) {
        const features = [
            ...this.interactionSelect.getFeatures().getArray()
        ];
        if (!this.isTwoAndOnlyTwoShapes(features)) {
            (0, $9051f0e072bf4341$export$8d8dc7d5f743331b).info({
                i18nKey: `${$58f704a3861e5d5d$var$I18N__BASE}.toasts.infos.strictTwoFeatures`,
                autoremove: true
            });
            return;
        }
        this.doShapeOperation(features, operation, type);
    }
    // Note:
    // This is a global event that is invoked from the SnapManager
    onSnap(event) {
        this.doSnap(event);
    }
    onUnSnap(event) {
        this.doUnSnap(event);
    }
    //--------------------------------------------------------------------
    // # Section: Listeners Subscriptions
    //--------------------------------------------------------------------
    attachOnChange(feature) {
        const selectedFeatures = this.interactionSelect.getFeatures().getArray();
        const hasOtherTooltip = !(0, $5289d96a2eaac637$export$3cf29e47efa41626).isEmpty();
        if (hasOtherTooltip && selectedFeatures.length === 1) this.tooltipItem = (0, $5289d96a2eaac637$export$3cf29e47efa41626).push($58f704a3861e5d5d$var$KEY__TOOLTIP);
        const oltb = (0, $0a57fad3299da03c$export$ac4f8128ea29c5).toolbar.id;
        const properties = feature.get(oltb);
        const hiddenTooltip = hasOtherTooltip && selectedFeatures.length === 1;
        properties.onChangeListener = feature.getGeometry().on((0, $a9807b370eed025c$export$ada873a34909da65).openLayers.change, this.#onFeatureChange.bind(this, feature));
        properties.tooltip.getElement().className = `oltb-overlay-tooltip ${hiddenTooltip ? 'oltb-overlay-tooltip--hidden' : ''}`;
    }
    detachOnChange(feature) {
        const selectedFeatures = this.interactionSelect.getFeatures().getArray();
        const hasOtherTooltip = !(0, $5289d96a2eaac637$export$3cf29e47efa41626).isEmpty();
        if (hasOtherTooltip && selectedFeatures.length === 1) (0, $5289d96a2eaac637$export$3cf29e47efa41626).pop($58f704a3861e5d5d$var$KEY__TOOLTIP);
        const oltb = (0, $0a57fad3299da03c$export$ac4f8128ea29c5).toolbar.id;
        const properties = feature.get(oltb);
        const geometry = feature.getGeometry();
        (0, $1f093ab5083c8a1f$export$b7ef3f8527533384)(properties.onChangeListener);
        const overlay = properties.tooltip;
        const tooltip = overlay.getElement();
        const measureCoordinates = (0, $ef19f7475e8f20ad$export$9a7874bcc72fae65)(geometry);
        const measureValue = (0, $ef19f7475e8f20ad$export$c8fdb1ecc11e521e)(geometry);
        overlay.setPosition(measureCoordinates);
        tooltip.className = 'oltb-overlay-tooltip';
        tooltip.firstElementChild.innerHTML = `${measureValue.value} ${measureValue.unit}`;
    }
    //--------------------------------------------------------------------
    // # Section: JSTS Functions
    //--------------------------------------------------------------------
    unionFeatures(a, b) {
        return $89c443a2e3946d4f$exports.operation.overlay.OverlayOp.union(a, b);
    }
    intersectFeatures(a, b) {
        return $89c443a2e3946d4f$exports.operation.overlay.OverlayOp.intersection(a, b);
    }
    excludeFeatures(a, b) {
        return $89c443a2e3946d4f$exports.operation.overlay.OverlayOp.symDifference(a, b);
    }
    differenceFeatures(a, b) {
        return $89c443a2e3946d4f$exports.operation.overlay.OverlayOp.difference(a, b);
    }
    //--------------------------------------------------------------------
    // # Section: Conversions/Validation
    //--------------------------------------------------------------------
    useMouseOnlyToEditVectorShapes() {
        return (0, $5547bbb6fff7ebf1$export$3016a1f47b675883).getSetting((0, $65522956a1f1a049$export$c72f6eaae7b9adff).mouseOnlyToEditVectorShapes);
    }
    isTwoAndOnlyTwoShapes(features) {
        return features.length === 2;
    }
    //--------------------------------------------------------------------
    // # Section: Getters and Setters
    //--------------------------------------------------------------------
    getNumSelectedFeatures() {
        return this.interactionSelect.getFeatures().getLength();
    }
    //--------------------------------------------------------------------
    // # Section: Ask User
    //--------------------------------------------------------------------
    askToDeleteFeatures(features) {
        const i18n = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get(`${$58f704a3861e5d5d$var$I18N__BASE}.dialogs.confirms.deleteFeatures`);
        return (0, $c815862f3b0d8f0b$export$3ddf2d174ce01153).confirm({
            title: i18n.title,
            message: `${i18n.message} ${features.length}st?`,
            confirmText: i18n.confirmText,
            cancelText: i18n.cancelText,
            onConfirm: ()=>{
                this.doDeleteFeatures(features);
            }
        });
    }
    askToRotateSelectedFeatures(features, value = '0') {
        const i18n = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get(`${$58f704a3861e5d5d$var$I18N__BASE}.dialogs.prompts.rotateFeatures`);
        return (0, $c815862f3b0d8f0b$export$3ddf2d174ce01153).prompt({
            title: i18n.title,
            message: `${i18n.message}`,
            value: value,
            confirmText: i18n.confirmText,
            cancelText: i18n.cancelText,
            onConfirm: (result)=>{
                if (result.isDigitsOnly()) this.doRotateFeatures(features, result);
                else {
                    (0, $b9b5c0363f244088$export$49b118289be48034).logError($58f704a3861e5d5d$var$FILENAME, 'askToRotateSelectedFeatures', {
                        message: 'Only digits are allowed as input',
                        result: result
                    });
                    (0, $9051f0e072bf4341$export$8d8dc7d5f743331b).error({
                        i18nKey: `${$58f704a3861e5d5d$var$I18N__BASE}.toasts.errors.invalidValue`
                    });
                }
            }
        });
    }
    askToConvertSelectedFeatures(features) {
        const i18n = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get(`${$58f704a3861e5d5d$var$I18N__BASE}.dialogs.prompts.convertFeatures`);
        const i18nCommon = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get(`${$58f704a3861e5d5d$var$I18N__BASE_COMMON}.types.convertable`);
        return (0, $c815862f3b0d8f0b$export$3ddf2d174ce01153).select({
            title: i18n.title,
            message: i18n.message,
            value: (0, $60b20182c25e327b$export$2906e7f4b228efe9).type.measurement,
            options: [
                {
                    text: i18nCommon.drawing,
                    value: (0, $60b20182c25e327b$export$2906e7f4b228efe9).type.drawing
                },
                {
                    text: i18nCommon.measurement,
                    value: (0, $60b20182c25e327b$export$2906e7f4b228efe9).type.measurement
                }
            ],
            confirmText: i18n.confirmText,
            cancelText: i18n.cancelText,
            onConfirm: (result)=>{
                this.doConvertFeatures(features, result);
            }
        });
    }
    //--------------------------------------------------------------------
    // # Section: Tool DoActions
    //--------------------------------------------------------------------
    doPushFeatureStyle(feature) {
        const featureId = (0, $6c5e11070e371322$export$5e82334337e0f204)(feature);
        this.originalFeatureStyles[featureId] = feature.getStyle();
    }
    doPopFeatureStyle(feature) {
        const featureId = (0, $6c5e11070e371322$export$5e82334337e0f204)(feature);
        feature.setStyle(this.originalFeatureStyles[featureId]);
        delete this.originalFeatureStyles[featureId];
    }
    doClearState() {
        this.localStorage = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep($58f704a3861e5d5d$var$LocalStorageDefaults);
        (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).setStateObject($58f704a3861e5d5d$var$LocalStorageNodeName, $58f704a3861e5d5d$var$LocalStorageDefaults);
    }
    doToggleToolboxSection(targetName) {
        const targetNode = window.document.getElementById(targetName);
        const duration = (0, $1e8c0ef90ed82280$export$a33e119b2316dcb7).getConfig().animationDuration.fast;
        targetNode?.slideToggle(duration, (collapsed)=>{
            this.localStorage.isCollapsed = collapsed;
            (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).setStateObject($58f704a3861e5d5d$var$LocalStorageNodeName, this.localStorage);
        });
    }
    doSelectFeatureAdd(event) {
        const feature = event.element;
        this.doPushFeatureStyle(feature);
        // Note: 
        // @Consumer callback
        if (this.options.onSelectAdd) this.options.onSelectAdd(event);
    }
    doSelectFeatureRemove(event) {
        const feature = event.element;
        // Note: 
        // The setTimeout must be used
        // If not, the style will be reset to the style used before the feature was selected
        feature && window.setTimeout(()=>{
            if (!this.colorHasChanged) return;
            // Set the lastStyle as the default style
            feature.setStyle(this.lastStyle);
            if ((0, $45f5d1a81c4ed6cb$export$73e78dff44a347ad).isMeasurementType(feature)) {
                // To add lineDash, a new Style object must be used
                // If the lastStyle is used all object that is referenced with that object will get a dashed line
                // TODO:
                // This should be a method in the style-manager to convert
                const style = new (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)({
                    fill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
                        color: this.lastStyle.getFill().getColor()
                    }),
                    stroke: new (0, $f9d0329c5c745263$export$2e2bcd8739ae039)({
                        color: this.lastStyle.getStroke().getColor(),
                        width: this.lastStyle.getStroke().getWidth(),
                        lineDash: [
                            2,
                            5
                        ]
                    })
                });
                feature.setStyle(style);
            }
            // Note: 
            // @Consumer callback
            if (this.options.onStyleChange) this.options.onStyleChange(event, this.lastStyle);
            // Reset for the last deselected item
            if (event.index === 0) this.colorHasChanged = false;
        });
        // Note: 
        // @Consumer callback
        if (this.options.onSelectRemove) this.options.onSelectRemove(event);
    }
    doModifyStart(event) {
        const features = event.features || [];
        features.forEach((feature)=>{
            if ((0, $45f5d1a81c4ed6cb$export$73e78dff44a347ad).hasTooltip(feature)) this.attachOnChange(feature);
        });
        // Note: 
        // @Consumer callback
        if (this.options.onModifyStart) this.options.onModifyStart(event);
    }
    doModifyEnd(event) {
        const features = event.features || [];
        features.forEach((feature)=>{
            if ((0, $45f5d1a81c4ed6cb$export$73e78dff44a347ad).hasTooltip(feature)) this.detachOnChange(feature);
        });
        // Note: 
        // @Consumer callback
        if (this.options.onModifyEnd) this.options.onModifyEnd(event);
    }
    doTranslateStart(event) {
        const features = event.features || [];
        features.forEach((feature)=>{
            if ((0, $45f5d1a81c4ed6cb$export$73e78dff44a347ad).hasTooltip(feature)) this.attachOnChange(feature);
        });
        // Note: 
        // @Consumer callback
        if (this.options.onTranslateStart) this.options.onTranslateStart(event);
    }
    doTranslateEnd(event) {
        const features = event.features || [];
        features.forEach((feature)=>{
            if ((0, $45f5d1a81c4ed6cb$export$73e78dff44a347ad).hasTooltip(feature)) this.detachOnChange(feature);
        });
        // Note: 
        // @Consumer callback
        if (this.options.onTranslateEnd) this.options.onTranslateEnd(event);
    }
    doSnap(event) {
        // Note: 
        // @Consumer callback
        if (this.options.onSnapped) this.options.onSnapped(event);
    }
    doUnSnap(event) {
        // Note: 
        // @Consumer callback
        if (this.options.onUnSnapped) this.options.onUnSnapped(event);
    }
    doFeatureColorChange(event) {
        this.colorHasChanged = true;
        const fillColor = this.uiRefFillColor.getAttribute('data-oltb-color');
        const strokeColor = this.uiRefStrokeColor.getAttribute('data-oltb-color');
        const features = [
            ...this.interactionSelect.getFeatures().getArray()
        ];
        this.lastStyle = new (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)({
            fill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
                color: fillColor
            }),
            stroke: new (0, $f9d0329c5c745263$export$2e2bcd8739ae039)({
                color: strokeColor,
                width: 2.5
            })
        });
        features.forEach((feature)=>{
            feature.setStyle(this.lastStyle);
        });
        this.localStorage.fillColor = this.lastStyle.getFill().getColor();
        this.localStorage.strokeColor = this.lastStyle.getStroke().getColor();
        (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).setStateObject($58f704a3861e5d5d$var$LocalStorageNodeName, this.localStorage);
    }
    doFeatureChange(feature) {
        const selectedFeatures = this.interactionSelect.getFeatures().getArray();
        const hasOtherTooltip = !(0, $5289d96a2eaac637$export$3cf29e47efa41626).isEmpty();
        const geometry = feature.getGeometry();
        const measureValue = (0, $ef19f7475e8f20ad$export$c8fdb1ecc11e521e)(geometry);
        if (hasOtherTooltip && selectedFeatures.length === 1) this.tooltipItem.innerHTML = `${measureValue.value} ${measureValue.unit}`;
        else {
            const overlay = (0, $45f5d1a81c4ed6cb$export$73e78dff44a347ad).getTooltip(feature);
            overlay.setPosition((0, $ef19f7475e8f20ad$export$9a7874bcc72fae65)(geometry));
            const tooltip = overlay.getElement();
            tooltip.firstElementChild.innerHTML = `${measureValue.value} ${measureValue.unit}`;
        }
    }
    doShapeOperation(features, operation, type) {
        try {
            const a = features[0];
            const b = features[1];
            const aGeometry = this.parser.read(a.getGeometry());
            const bGeometry = this.parser.read(b.getGeometry());
            const shape = operation(aGeometry, bGeometry);
            const shapedFeature = new (0, $9fd014ab6df63665$export$2e2bcd8739ae039)({
                geometry: new (0, $40aa8d43bbe572bf$export$2e2bcd8739ae039)(this.parser.write(shape).getCoordinates())
            });
            if ((0, $45f5d1a81c4ed6cb$export$73e78dff44a347ad).isMeasurementType(a) || (0, $45f5d1a81c4ed6cb$export$73e78dff44a347ad).isMeasurementType(b)) {
                (0, $45f5d1a81c4ed6cb$export$73e78dff44a347ad).applyMeasurementProperties(shapedFeature);
                shapedFeature.setStyle((0, $2577fba4fdbf4b69$export$29bb23d12246c816).getDefaultMeasurementStyle());
            } else shapedFeature.setStyle((0, $2577fba4fdbf4b69$export$29bb23d12246c816).getDefaultDrawingStyle());
            const layerWrapper = (0, $e75fe1c51a3d360c$export$eff87c52915dd7fe).getActiveFeatureLayer();
            (0, $e75fe1c51a3d360c$export$eff87c52915dd7fe).addFeatureToLayer(shapedFeature, layerWrapper);
            this.doDeleteFeatures(features);
            // Note: 
            // @Consumer callback
            if (this.options.onShapeOperation) this.options.onShapeOperation(type, a, b, shapedFeature);
        } catch (error) {
            (0, $b9b5c0363f244088$export$49b118289be48034).logError($58f704a3861e5d5d$var$FILENAME, 'onShapeOperator', {
                message: 'Failed to perform shape operation',
                error: error
            });
            (0, $9051f0e072bf4341$export$8d8dc7d5f743331b).error({
                i18nKey: `${$58f704a3861e5d5d$var$I18N__BASE}.toasts.operationFailed`
            });
            // Note: 
            // @Consumer callback
            if (this.options.onError) this.options.onError(error);
        }
    }
    doClearColors() {
        this.uiRefFillColor.setAttribute('data-oltb-color', this.localStorage.fillColor);
        this.uiRefFillColor.firstElementChild.style.backgroundColor = this.localStorage.fillColor;
        this.uiRefStrokeColor.setAttribute('data-oltb-color', this.localStorage.strokeColor);
        this.uiRefStrokeColor.firstElementChild.style.backgroundColor = this.localStorage.strokeColor;
    }
    doDeleteFeatures(features) {
        this.#deleteFeatures(features);
        // Note: 
        // @Consumer callback
        if (this.options.onRemovedFeatures) this.options.onRemovedFeatures(features);
    }
    doRotateFeatures(features, rotation) {
        const radians = (0, $206be50bf50f716a$export$53fa2d26c9df363b).degreesToRadians(rotation);
        features.forEach((feature)=>{
            const geometry = feature.getGeometry();
            const center = (0, $6da4c8ed3074c92b$export$c91255cadecfe081)(geometry.getExtent());
            geometry.rotate(radians, center);
        });
    }
    doCutFeatures(features) {
        features.forEach((feature)=>{
            const clonedFeature = (0, $45f5d1a81c4ed6cb$export$73e78dff44a347ad).deepCopyVectorFeatureWithStyle(feature, this.originalFeatureStyles);
            this.featureClipboard.push(clonedFeature);
        });
        this.#deleteFeatures(features);
        (0, $9051f0e072bf4341$export$8d8dc7d5f743331b).info({
            prefix: features.length,
            i18nKey: `${$58f704a3861e5d5d$var$I18N__BASE}.toasts.infos.cutFeatures`,
            autoremove: true
        });
        // Note: 
        // @Consumer callback
        if (this.options.onCutFeatures) this.options.onCutFeatures(features);
    }
    doCopyFeatures(features) {
        features.forEach((feature)=>{
            const clonedFeature = (0, $45f5d1a81c4ed6cb$export$73e78dff44a347ad).deepCopyVectorFeatureWithStyle(feature, this.originalFeatureStyles);
            this.featureClipboard.push(clonedFeature);
        });
        (0, $9051f0e072bf4341$export$8d8dc7d5f743331b).info({
            prefix: features.length,
            i18nKey: `${$58f704a3861e5d5d$var$I18N__BASE}.toasts.infos.copiedFeatures`,
            autoremove: true
        });
        // Note: 
        // @Consumer callback
        if (this.options.onCopyFeatures) this.options.onCopyFeatures(features);
    }
    doPasteFeatures() {
        const copies = [
            ...this.featureClipboard
        ];
        this.featureClipboard = [];
        const layerWrapper = (0, $e75fe1c51a3d360c$export$eff87c52915dd7fe).getActiveFeatureLayer();
        copies.forEach((feature)=>{
            (0, $e75fe1c51a3d360c$export$eff87c52915dd7fe).addFeatureToLayer(feature, layerWrapper);
        });
        (0, $9051f0e072bf4341$export$8d8dc7d5f743331b).info({
            prefix: copies.length,
            i18nKey: `${$58f704a3861e5d5d$var$I18N__BASE}.toasts.infos.pastedFeatures`,
            autoremove: true
        });
        // Note: 
        // @Consumer callback
        if (this.options.onPasteFeatures) this.options.onPasteFeatures(copies, layerWrapper);
    }
    doAddSelectedFeature(feature) {
        this.interactionSelect.getFeatures().push(feature);
    }
    doRemoveSelectedFeature(feature) {
        this.interactionSelect.getFeatures().remove(feature);
    }
    doClearSelectedFeatures() {
        this.interactionSelect.getFeatures().clear();
    }
    doConvertFeatures(features, format) {
        this.doClearSelectedFeatures();
        (0, $45f5d1a81c4ed6cb$export$73e78dff44a347ad).convertFeaturesTo(features, format.to);
    }
    doShowFeatureInfo(feature) {
        // TODO:
        // Why is the [0] on the coordiantes required?
        const featureId = (0, $6c5e11070e371322$export$5e82334337e0f204)(feature);
        const geometry = feature.getGeometry();
        const measurement = (0, $ef19f7475e8f20ad$export$c8fdb1ecc11e521e)(geometry);
        const coordinates = geometry.getCoordinates()[0];
        const vertices = coordinates.length;
        const indentation = 4;
        const coordinatesText = JSON.stringify(JSON.decycle(coordinates), (0, $a8f2ca70ab701cb7$export$c4fdd084e378b052), indentation);
        const oltb = (0, $0a57fad3299da03c$export$ac4f8128ea29c5).toolbar.id;
        const properties = feature.get(oltb);
        const propertiesText = JSON.stringify(JSON.decycle(properties), (0, $a8f2ca70ab701cb7$export$c4fdd084e378b052), indentation);
        // Note:
        // The data properties are used as keys in the translation-files
        const options = {
            data: {
                id: featureId,
                measurement: `${measurement.value} ${measurement.unit}`,
                oltbProperties: `<pre><code>${propertiesText}</code></pre>`,
                vertices: vertices,
                coordinates: `<pre><code>${coordinatesText}</code></pre>`
            }
        };
        return new (0, $da0e0978dae16334$export$a868fcd9c55b091)(options);
    }
}



var $f1q41 = parcelRequire("f1q41");


class $4b70eea868544fc1$export$2b77a92f1a5ad772 {
    static create(options = {}) {
        return new (0, $b12cc913018885a9$export$a703eb468fcf7e69)({
            title: options.title,
            maximized: options.maximized,
            pushWidth: options.pushWidth,
            onClose: options.onClose,
            content: options.content
        });
    }
}








const $82e635ddc0e2b45d$var$FILENAME = 'info-tool.js';
const $82e635ddc0e2b45d$var$CLASS__TOOL_BUTTON = 'oltb-tool-button';
const $82e635ddc0e2b45d$var$I18N__BASE = 'tools.infoTool';
const $82e635ddc0e2b45d$var$DefaultOptions = Object.freeze({
    title: 'Hey!',
    content: 'This is the default content, try adding some content of your own.',
    onInitiated: undefined,
    onClicked: undefined
});
/**
 * About:
 * Display an information modal
 * 
 * Description:
 * The information window can contain shorter help descriptions, news, shortcuts, operating information, etc.
 */ class $82e635ddc0e2b45d$export$1135e9e24c4d5ed9 extends (0, $10d08d54da4ecbc4$export$cf198134d112da63) {
    constructor(options = {}){
        super({
            filename: $82e635ddc0e2b45d$var$FILENAME
        });
        const icon = (0, $dcff5ab966a6537f$export$a297fe855adfd36c)({
            path: (0, $35649bc6579784f8$export$3fddabec91763a6e).infoCircle.stroked,
            class: `${$82e635ddc0e2b45d$var$CLASS__TOOL_BUTTON}__icon`
        });
        const i18n = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get($82e635ddc0e2b45d$var$I18N__BASE);
        const button = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'button',
            html: icon,
            class: $82e635ddc0e2b45d$var$CLASS__TOOL_BUTTON,
            attributes: {
                'type': 'button',
                'data-tippy-content': `${i18n.title} (${(0, $a256deadcc62504f$export$4384767a59dc851d).infoTool})`,
                'data-tippy-content-post': `(${(0, $a256deadcc62504f$export$4384767a59dc851d).infoTool})`,
                'data-oltb-i18n': `${$82e635ddc0e2b45d$var$I18N__BASE}.title`
            },
            listeners: {
                'click': this.onClickTool.bind(this)
            }
        });
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(this.element, [
            button
        ]);
        this.button = button;
        this.infoModal = undefined;
        this.options = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep($82e635ddc0e2b45d$var$DefaultOptions), options);
        this.attachGlobalListeners();
        // Note: 
        // @Consumer callback
        if (this.options.onInitiated) this.options.onInitiated();
    }
    attachGlobalListeners() {
        this.onWindowKeyUpBind = this.#onWindowKeyUp.bind(this);
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.keyUp, this.onWindowKeyUpBind);
    }
    detachGlobalListeners() {
        window.removeEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.keyUp, this.onWindowKeyUpBind);
    }
    //--------------------------------------------------------------------
    // # Section: Overridden
    //--------------------------------------------------------------------
    getName() {
        return super.getName();
    }
    onClickTool(event) {
        super.onClickTool(event);
        this.momentaryActivation();
        // Note: 
        // @Consumer callback
        if (this.options.onClicked) this.options.onClicked();
    }
    //--------------------------------------------------------------------
    // # Section: Tool Control
    //--------------------------------------------------------------------
    momentaryActivation() {
        this.doShowInfoModal();
    }
    //--------------------------------------------------------------------
    // # Section: Browser Events
    //--------------------------------------------------------------------
    #onWindowKeyUp(event) {
        if ((0, $fbd95439548fdf50$export$ad7bf7af8762113)(event, (0, $a256deadcc62504f$export$4384767a59dc851d).infoTool)) this.onClickTool(event);
    }
    //--------------------------------------------------------------------
    // # Section: Tool DoActions
    //--------------------------------------------------------------------
    doShowInfoModal() {
        if (this.infoModal) return;
        this.infoModal = (0, $4b70eea868544fc1$export$2b77a92f1a5ad772).create({
            title: this.options.title,
            content: this.options.content,
            onClose: ()=>{
                this.infoModal = undefined;
            }
        });
    }
}



var $f1q41 = parcelRequire("f1q41");










const $7e9db0c7a37b0431$var$FILENAME = 'help-tool.js';
const $7e9db0c7a37b0431$var$CLASS__TOOL_BUTTON = 'oltb-tool-button';
const $7e9db0c7a37b0431$var$I18N__BASE = 'tools.helpTool';
const $7e9db0c7a37b0431$var$DefaultOptions = Object.freeze({
    url: 'https://github.com/qulle/oltb',
    target: '_blank',
    onInitiated: undefined,
    onClicked: undefined
});
/**
 * About:
 * Open help or documentation pages
 * 
 * Description:
 * Open documentation for the functions of the Map or your application as a whole, corresponds to F1 in many computer applications.
 */ class $7e9db0c7a37b0431$export$1ba0bc57075465bf extends (0, $10d08d54da4ecbc4$export$cf198134d112da63) {
    constructor(options = {}){
        super({
            filename: $7e9db0c7a37b0431$var$FILENAME
        });
        const icon = (0, $dcff5ab966a6537f$export$a297fe855adfd36c)({
            path: (0, $35649bc6579784f8$export$3fddabec91763a6e).questionCircle.stroked,
            class: `${$7e9db0c7a37b0431$var$CLASS__TOOL_BUTTON}__icon`
        });
        const i18n = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get($7e9db0c7a37b0431$var$I18N__BASE);
        const button = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'button',
            html: icon,
            class: $7e9db0c7a37b0431$var$CLASS__TOOL_BUTTON,
            attributes: {
                'type': 'button',
                'data-tippy-content': `${i18n.title} (${(0, $a256deadcc62504f$export$4384767a59dc851d).helpTool})`,
                'data-tippy-content-post': `(${(0, $a256deadcc62504f$export$4384767a59dc851d).helpTool})`,
                'data-oltb-i18n': `${$7e9db0c7a37b0431$var$I18N__BASE}.title`
            },
            listeners: {
                'click': this.onClickTool.bind(this)
            }
        });
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(this.element, [
            button
        ]);
        this.button = button;
        this.helpDialog = undefined;
        this.options = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep($7e9db0c7a37b0431$var$DefaultOptions), options);
        this.attachGlobalListeners();
        // Note: 
        // @Consumer callback
        if (this.options.onInitiated) this.options.onInitiated();
    }
    attachGlobalListeners() {
        this.onWindowKeyUpBind = this.#onWindowKeyUp.bind(this);
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.keyUp, this.onWindowKeyUpBind);
    }
    detachGlobalListeners() {
        window.removeEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.keyUp, this.onWindowKeyUpBind);
    }
    //--------------------------------------------------------------------
    // # Section: Overridden
    //--------------------------------------------------------------------
    getName() {
        return super.getName();
    }
    onClickTool(event) {
        super.onClickTool(event);
        this.momentaryActivation();
        // Note: 
        // @Consumer callback
        if (this.options.onClicked) this.options.onClicked();
    }
    //--------------------------------------------------------------------
    // # Section: Tool Control
    //--------------------------------------------------------------------
    momentaryActivation() {
        this.askToOpenTabOrWindow();
    }
    //--------------------------------------------------------------------
    // # Section: Browser Events
    //--------------------------------------------------------------------
    #onWindowKeyUp(event) {
        if ((0, $fbd95439548fdf50$export$ad7bf7af8762113)(event, (0, $a256deadcc62504f$export$4384767a59dc851d).helpTool)) this.onClickTool();
    }
    //--------------------------------------------------------------------
    // # Section: Ask User
    //--------------------------------------------------------------------
    askToOpenTabOrWindow() {
        if (this.helpDialog) return;
        const i18n = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get(`${$7e9db0c7a37b0431$var$I18N__BASE}.dialogs.confirms.openHelp`);
        this.helpDialog = (0, $c815862f3b0d8f0b$export$3ddf2d174ce01153).confirm({
            title: i18n.title,
            message: i18n.message,
            confirmClass: (0, $c815862f3b0d8f0b$export$3ddf2d174ce01153).Success,
            confirmText: i18n.confirmText,
            cancelText: i18n.cancelText,
            onConfirm: ()=>{
                this.doOpenTabOrWindow();
                this.helpDialog = undefined;
            },
            onCancel: ()=>{
                this.helpDialog = undefined;
            }
        });
    }
    //--------------------------------------------------------------------
    // # Section: Tool DoActions
    //--------------------------------------------------------------------
    doOpenTabOrWindow() {
        try {
            window.open(this.options.url, this.options.target).focus();
        } catch (error) {
            (0, $b9b5c0363f244088$export$49b118289be48034).logError($7e9db0c7a37b0431$var$FILENAME, 'doOpenTabOrWindow', {
                message: 'Action was restricted by browser settings',
                error: error
            });
            (0, $9051f0e072bf4341$export$8d8dc7d5f743331b).error({
                i18nKey: `${$7e9db0c7a37b0431$var$I18N__BASE}.toasts.errors.blockedByBrowser`
            });
        }
    }
}



var $f1q41 = parcelRequire("f1q41");











const $d9f58fc8021bc237$var$FILENAME = 'theme-tool.js';
const $d9f58fc8021bc237$var$CLASS__TOOL_BUTTON = 'oltb-tool-button';
const $d9f58fc8021bc237$var$I18N__BASE = 'tools.themeTool';
const $d9f58fc8021bc237$var$DefaultOptions = Object.freeze({
    onInitiated: undefined,
    onClicked: undefined,
    onBrowserStateCleared: undefined,
    onChanged: undefined
});
const $d9f58fc8021bc237$var$ThemesData = Object.freeze({
    light: {
        class: 'light',
        icon: (0, $dcff5ab966a6537f$export$a297fe855adfd36c)({
            path: (0, $35649bc6579784f8$export$3fddabec91763a6e).moonStars.stroked,
            class: `${$d9f58fc8021bc237$var$CLASS__TOOL_BUTTON}__icon`
        })
    },
    dark: {
        class: 'dark',
        icon: (0, $dcff5ab966a6537f$export$a297fe855adfd36c)({
            path: (0, $35649bc6579784f8$export$3fddabec91763a6e).sun.stroked,
            class: `${$d9f58fc8021bc237$var$CLASS__TOOL_BUTTON}__icon`
        })
    }
});
const $d9f58fc8021bc237$var$LocalStorageNodeName = (0, $52e25f2a10ab5b5c$export$ada36e8a1c3bc83a).themeTool;
const $d9f58fc8021bc237$var$LocalStorageDefaults = Object.freeze({
    theme: $d9f58fc8021bc237$var$ThemesData.light.class
});
/**
 * About:
 * Change theme of the Toolbar
 * 
 * Description:
 * The Toolbar is light by default, via this tool the Toolbar can be made dark to be better seen against a bright Map image.
 */ class $d9f58fc8021bc237$export$9825cbaf8781ca03 extends (0, $10d08d54da4ecbc4$export$cf198134d112da63) {
    constructor(options = {}){
        super({
            filename: $d9f58fc8021bc237$var$FILENAME
        });
        const i18n = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get($d9f58fc8021bc237$var$I18N__BASE);
        const button = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'button',
            html: this.getToolIcon(),
            class: $d9f58fc8021bc237$var$CLASS__TOOL_BUTTON,
            attributes: {
                'type': 'button',
                'data-tippy-content': `${i18n.title} (${(0, $a256deadcc62504f$export$4384767a59dc851d).themeTool})`,
                'data-tippy-content-post': `(${(0, $a256deadcc62504f$export$4384767a59dc851d).themeTool})`,
                'data-oltb-i18n': `${$d9f58fc8021bc237$var$I18N__BASE}.title`
            },
            listeners: {
                'click': this.onClickTool.bind(this)
            },
            prototypes: {
                getTippy: function() {
                    return this._tippy;
                }
            }
        });
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(this.element, [
            button
        ]);
        this.button = button;
        this.isActive = false;
        this.options = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep($d9f58fc8021bc237$var$DefaultOptions), options);
        this.localStorage = (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).getAndMergeStateObject($d9f58fc8021bc237$var$LocalStorageNodeName, $d9f58fc8021bc237$var$LocalStorageDefaults);
        this.attachGlobalListeners();
        // Note: 
        // @Consumer callback
        if (this.options.onInitiated) this.options.onInitiated();
    }
    attachGlobalListeners() {
        this.onWindowKeyUpBind = this.#onWindowKeyUp.bind(this);
        this.onWindowBrowserStateClearedBind = this.#onWindowBrowserStateCleared.bind(this);
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.keyUp, this.onWindowKeyUpBind);
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.browserStateCleared, this.onWindowBrowserStateClearedBind);
    }
    detachGlobalListeners() {
        window.removeEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.keyUp, this.onWindowKeyUpBind);
        window.removeEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.browserStateCleared, this.onWindowBrowserStateClearedBind);
    }
    //--------------------------------------------------------------------
    // # Section: Overridden
    //--------------------------------------------------------------------
    getName() {
        return super.getName();
    }
    onClickTool(event) {
        super.onClickTool(event);
        this.momentaryActivation();
        // Note: 
        // @Consumer callback
        if (this.options.onClicked) this.options.onClicked();
    }
    //--------------------------------------------------------------------
    // # Section: Tool Control
    //--------------------------------------------------------------------
    momentaryActivation() {
        this.doToggleTheme();
    }
    //--------------------------------------------------------------------
    // # Section: Browser Events
    //--------------------------------------------------------------------
    #onWindowKeyUp(event) {
        if ((0, $fbd95439548fdf50$export$ad7bf7af8762113)(event, (0, $a256deadcc62504f$export$4384767a59dc851d).themeTool)) this.onClickTool(event);
    }
    #onWindowBrowserStateCleared() {
        const active = this.getActiveTheme();
        this.doSwitchThemeFromTo(active, $d9f58fc8021bc237$var$ThemesData.light);
        // Note: 
        // @Consumer callback
        if (this.options.onBrowserStateCleared) this.options.onBrowserStateCleared();
    }
    //--------------------------------------------------------------------
    // # Section: Getters and Setters
    //--------------------------------------------------------------------
    getToolIcon() {
        return (0, $c63f096e37f334a4$export$5a63ccfbe4d87ef0)() ? $d9f58fc8021bc237$var$ThemesData.dark.icon : $d9f58fc8021bc237$var$ThemesData.light.icon;
    }
    getInActiveThem() {
        return (0, $c63f096e37f334a4$export$5a63ccfbe4d87ef0)() ? $d9f58fc8021bc237$var$ThemesData.light : $d9f58fc8021bc237$var$ThemesData.dark;
    }
    getActiveTheme() {
        return (0, $c63f096e37f334a4$export$5a63ccfbe4d87ef0)() ? $d9f58fc8021bc237$var$ThemesData.dark : $d9f58fc8021bc237$var$ThemesData.light;
    }
    //--------------------------------------------------------------------
    // # Section: Tool DoActions
    //--------------------------------------------------------------------
    doToggleTheme() {
        const active = this.getActiveTheme();
        const inActive = this.getInActiveThem();
        this.doSwitchThemeFromTo(active, inActive);
        // Note: 
        // @Consumer callback
        if (this.options.onChanged) this.options.onChanged(inActive.class);
    }
    doSwitchThemeFromTo(from, to) {
        this.localStorage.theme = to.class;
        (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).setStateObject($d9f58fc8021bc237$var$LocalStorageNodeName, this.localStorage);
        const baseClass = 'oltb';
        const uiRefToolbarElement = (0, $8f42450ebdd44f5e$export$8e7188a60a5bbe16).getToolbarElement();
        uiRefToolbarElement.classList.remove(from.class);
        window.document.body.classList.remove(`${baseClass}-${from.class}`);
        uiRefToolbarElement.classList.add(to.class);
        window.document.body.classList.add(`${baseClass}-${to.class}`);
        this.button.removeChild(this.button.firstElementChild);
        this.button.insertAdjacentHTML('afterbegin', to.icon);
    }
}



var $f1q41 = parcelRequire("f1q41");

/**!
 * Sortable 1.15.6
 * @author	RubaXa   <trash@rubaxa.org>
 * @author	owenm    <owen23355@gmail.com>
 * @license MIT
 */ function $dc7ec905e041f51c$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $dc7ec905e041f51c$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $dc7ec905e041f51c$var$ownKeys(Object(source), true).forEach(function(key) {
            $dc7ec905e041f51c$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $dc7ec905e041f51c$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $dc7ec905e041f51c$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $dc7ec905e041f51c$var$_typeof = function(obj) {
        return typeof obj;
    };
    else $dc7ec905e041f51c$var$_typeof = function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $dc7ec905e041f51c$var$_typeof(obj);
}
function $dc7ec905e041f51c$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $dc7ec905e041f51c$var$_extends() {
    $dc7ec905e041f51c$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $dc7ec905e041f51c$var$_extends.apply(this, arguments);
}
function $dc7ec905e041f51c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $dc7ec905e041f51c$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $dc7ec905e041f51c$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $dc7ec905e041f51c$var$_toConsumableArray(arr) {
    return $dc7ec905e041f51c$var$_arrayWithoutHoles(arr) || $dc7ec905e041f51c$var$_iterableToArray(arr) || $dc7ec905e041f51c$var$_unsupportedIterableToArray(arr) || $dc7ec905e041f51c$var$_nonIterableSpread();
}
function $dc7ec905e041f51c$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $dc7ec905e041f51c$var$_arrayLikeToArray(arr);
}
function $dc7ec905e041f51c$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $dc7ec905e041f51c$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $dc7ec905e041f51c$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $dc7ec905e041f51c$var$_arrayLikeToArray(o, minLen);
}
function $dc7ec905e041f51c$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $dc7ec905e041f51c$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var $dc7ec905e041f51c$var$version = "1.15.6";
function $dc7ec905e041f51c$var$userAgent(pattern) {
    if (typeof window !== 'undefined' && window.navigator) return !!/*@__PURE__*/ navigator.userAgent.match(pattern);
}
var $dc7ec905e041f51c$var$IE11OrLess = $dc7ec905e041f51c$var$userAgent(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i);
var $dc7ec905e041f51c$var$Edge = $dc7ec905e041f51c$var$userAgent(/Edge/i);
var $dc7ec905e041f51c$var$FireFox = $dc7ec905e041f51c$var$userAgent(/firefox/i);
var $dc7ec905e041f51c$var$Safari = $dc7ec905e041f51c$var$userAgent(/safari/i) && !$dc7ec905e041f51c$var$userAgent(/chrome/i) && !$dc7ec905e041f51c$var$userAgent(/android/i);
var $dc7ec905e041f51c$var$IOS = $dc7ec905e041f51c$var$userAgent(/iP(ad|od|hone)/i);
var $dc7ec905e041f51c$var$ChromeForAndroid = $dc7ec905e041f51c$var$userAgent(/chrome/i) && $dc7ec905e041f51c$var$userAgent(/android/i);
var $dc7ec905e041f51c$var$captureMode = {
    capture: false,
    passive: false
};
function $dc7ec905e041f51c$var$on(el, event, fn) {
    el.addEventListener(event, fn, !$dc7ec905e041f51c$var$IE11OrLess && $dc7ec905e041f51c$var$captureMode);
}
function $dc7ec905e041f51c$var$off(el, event, fn) {
    el.removeEventListener(event, fn, !$dc7ec905e041f51c$var$IE11OrLess && $dc7ec905e041f51c$var$captureMode);
}
function $dc7ec905e041f51c$var$matches(/**HTMLElement*/ el, /**String*/ selector) {
    if (!selector) return;
    selector[0] === '>' && (selector = selector.substring(1));
    if (el) try {
        if (el.matches) return el.matches(selector);
        else if (el.msMatchesSelector) return el.msMatchesSelector(selector);
        else if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);
    } catch (_) {
        return false;
    }
    return false;
}
function $dc7ec905e041f51c$var$getParentOrHost(el) {
    return el.host && el !== document && el.host.nodeType ? el.host : el.parentNode;
}
function $dc7ec905e041f51c$var$closest(/**HTMLElement*/ el, /**String*/ selector, /**HTMLElement*/ ctx, includeCTX) {
    if (el) {
        ctx = ctx || document;
        do {
            if (selector != null && (selector[0] === '>' ? el.parentNode === ctx && $dc7ec905e041f51c$var$matches(el, selector) : $dc7ec905e041f51c$var$matches(el, selector)) || includeCTX && el === ctx) return el;
            if (el === ctx) break;
        /* jshint boss:true */ }while (el = $dc7ec905e041f51c$var$getParentOrHost(el));
    }
    return null;
}
var $dc7ec905e041f51c$var$R_SPACE = /\s+/g;
function $dc7ec905e041f51c$var$toggleClass(el, name, state) {
    if (el && name) {
        if (el.classList) el.classList[state ? 'add' : 'remove'](name);
        else {
            var className = (' ' + el.className + ' ').replace($dc7ec905e041f51c$var$R_SPACE, ' ').replace(' ' + name + ' ', ' ');
            el.className = (className + (state ? ' ' + name : '')).replace($dc7ec905e041f51c$var$R_SPACE, ' ');
        }
    }
}
function $dc7ec905e041f51c$var$css(el, prop, val) {
    var style = el && el.style;
    if (style) {
        if (val === void 0) {
            if (document.defaultView && document.defaultView.getComputedStyle) val = document.defaultView.getComputedStyle(el, '');
            else if (el.currentStyle) val = el.currentStyle;
            return prop === void 0 ? val : val[prop];
        } else {
            if (!(prop in style) && prop.indexOf('webkit') === -1) prop = '-webkit-' + prop;
            style[prop] = val + (typeof val === 'string' ? '' : 'px');
        }
    }
}
function $dc7ec905e041f51c$var$matrix(el, selfOnly) {
    var appliedTransforms = '';
    if (typeof el === 'string') appliedTransforms = el;
    else do {
        var transform = $dc7ec905e041f51c$var$css(el, 'transform');
        if (transform && transform !== 'none') appliedTransforms = transform + ' ' + appliedTransforms;
    /* jshint boss:true */ }while (!selfOnly && (el = el.parentNode));
    var matrixFn = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix || window.MSCSSMatrix;
    /*jshint -W056 */ return matrixFn && new matrixFn(appliedTransforms);
}
function $dc7ec905e041f51c$var$find(ctx, tagName, iterator) {
    if (ctx) {
        var list = ctx.getElementsByTagName(tagName), i = 0, n = list.length;
        if (iterator) for(; i < n; i++)iterator(list[i], i);
        return list;
    }
    return [];
}
function $dc7ec905e041f51c$var$getWindowScrollingElement() {
    var scrollingElement = document.scrollingElement;
    if (scrollingElement) return scrollingElement;
    else return document.documentElement;
}
/**
 * Returns the "bounding client rect" of given element
 * @param  {HTMLElement} el                       The element whose boundingClientRect is wanted
 * @param  {[Boolean]} relativeToContainingBlock  Whether the rect should be relative to the containing block of (including) the container
 * @param  {[Boolean]} relativeToNonStaticParent  Whether the rect should be relative to the relative parent of (including) the contaienr
 * @param  {[Boolean]} undoScale                  Whether the container's scale() should be undone
 * @param  {[HTMLElement]} container              The parent the element will be placed in
 * @return {Object}                               The boundingClientRect of el, with specified adjustments
 */ function $dc7ec905e041f51c$var$getRect(el, relativeToContainingBlock, relativeToNonStaticParent, undoScale, container) {
    if (!el.getBoundingClientRect && el !== window) return;
    var elRect, top, left, bottom, right, height, width;
    if (el !== window && el.parentNode && el !== $dc7ec905e041f51c$var$getWindowScrollingElement()) {
        elRect = el.getBoundingClientRect();
        top = elRect.top;
        left = elRect.left;
        bottom = elRect.bottom;
        right = elRect.right;
        height = elRect.height;
        width = elRect.width;
    } else {
        top = 0;
        left = 0;
        bottom = window.innerHeight;
        right = window.innerWidth;
        height = window.innerHeight;
        width = window.innerWidth;
    }
    if ((relativeToContainingBlock || relativeToNonStaticParent) && el !== window) {
        // Adjust for translate()
        container = container || el.parentNode;
        // solves #1123 (see: https://stackoverflow.com/a/37953806/6088312)
        // Not needed on <= IE11
        if (!$dc7ec905e041f51c$var$IE11OrLess) {
            do if (container && container.getBoundingClientRect && ($dc7ec905e041f51c$var$css(container, 'transform') !== 'none' || relativeToNonStaticParent && $dc7ec905e041f51c$var$css(container, 'position') !== 'static')) {
                var containerRect = container.getBoundingClientRect();
                // Set relative to edges of padding box of container
                top -= containerRect.top + parseInt($dc7ec905e041f51c$var$css(container, 'border-top-width'));
                left -= containerRect.left + parseInt($dc7ec905e041f51c$var$css(container, 'border-left-width'));
                bottom = top + elRect.height;
                right = left + elRect.width;
                break;
            }
            while (container = container.parentNode);
        }
    }
    if (undoScale && el !== window) {
        // Adjust for scale()
        var elMatrix = $dc7ec905e041f51c$var$matrix(container || el), scaleX = elMatrix && elMatrix.a, scaleY = elMatrix && elMatrix.d;
        if (elMatrix) {
            top /= scaleY;
            left /= scaleX;
            width /= scaleX;
            height /= scaleY;
            bottom = top + height;
            right = left + width;
        }
    }
    return {
        top: top,
        left: left,
        bottom: bottom,
        right: right,
        width: width,
        height: height
    };
}
/**
 * Checks if a side of an element is scrolled past a side of its parents
 * @param  {HTMLElement}  el           The element who's side being scrolled out of view is in question
 * @param  {String}       elSide       Side of the element in question ('top', 'left', 'right', 'bottom')
 * @param  {String}       parentSide   Side of the parent in question ('top', 'left', 'right', 'bottom')
 * @return {HTMLElement}               The parent scroll element that the el's side is scrolled past, or null if there is no such element
 */ function $dc7ec905e041f51c$var$isScrolledPast(el, elSide, parentSide) {
    var parent = $dc7ec905e041f51c$var$getParentAutoScrollElement(el, true), elSideVal = $dc7ec905e041f51c$var$getRect(el)[elSide];
    /* jshint boss:true */ while(parent){
        var parentSideVal = $dc7ec905e041f51c$var$getRect(parent)[parentSide], visible = void 0;
        if (parentSide === 'top' || parentSide === 'left') visible = elSideVal >= parentSideVal;
        else visible = elSideVal <= parentSideVal;
        if (!visible) return parent;
        if (parent === $dc7ec905e041f51c$var$getWindowScrollingElement()) break;
        parent = $dc7ec905e041f51c$var$getParentAutoScrollElement(parent, false);
    }
    return false;
}
/**
 * Gets nth child of el, ignoring hidden children, sortable's elements (does not ignore clone if it's visible)
 * and non-draggable elements
 * @param  {HTMLElement} el       The parent element
 * @param  {Number} childNum      The index of the child
 * @param  {Object} options       Parent Sortable's options
 * @return {HTMLElement}          The child at index childNum, or null if not found
 */ function $dc7ec905e041f51c$var$getChild(el, childNum, options, includeDragEl) {
    var currentChild = 0, i = 0, children = el.children;
    while(i < children.length){
        if (children[i].style.display !== 'none' && children[i] !== $dc7ec905e041f51c$export$31b3ca70d8f57423.ghost && (includeDragEl || children[i] !== $dc7ec905e041f51c$export$31b3ca70d8f57423.dragged) && $dc7ec905e041f51c$var$closest(children[i], options.draggable, el, false)) {
            if (currentChild === childNum) return children[i];
            currentChild++;
        }
        i++;
    }
    return null;
}
/**
 * Gets the last child in the el, ignoring ghostEl or invisible elements (clones)
 * @param  {HTMLElement} el       Parent element
 * @param  {selector} selector    Any other elements that should be ignored
 * @return {HTMLElement}          The last child, ignoring ghostEl
 */ function $dc7ec905e041f51c$var$lastChild(el, selector) {
    var last = el.lastElementChild;
    while(last && (last === $dc7ec905e041f51c$export$31b3ca70d8f57423.ghost || $dc7ec905e041f51c$var$css(last, 'display') === 'none' || selector && !$dc7ec905e041f51c$var$matches(last, selector)))last = last.previousElementSibling;
    return last || null;
}
/**
 * Returns the index of an element within its parent for a selected set of
 * elements
 * @param  {HTMLElement} el
 * @param  {selector} selector
 * @return {number}
 */ function $dc7ec905e041f51c$var$index(el, selector) {
    var index = 0;
    if (!el || !el.parentNode) return -1;
    /* jshint boss:true */ while(el = el.previousElementSibling)if (el.nodeName.toUpperCase() !== 'TEMPLATE' && el !== $dc7ec905e041f51c$export$31b3ca70d8f57423.clone && (!selector || $dc7ec905e041f51c$var$matches(el, selector))) index++;
    return index;
}
/**
 * Returns the scroll offset of the given element, added with all the scroll offsets of parent elements.
 * The value is returned in real pixels.
 * @param  {HTMLElement} el
 * @return {Array}             Offsets in the format of [left, top]
 */ function $dc7ec905e041f51c$var$getRelativeScrollOffset(el) {
    var offsetLeft = 0, offsetTop = 0, winScroller = $dc7ec905e041f51c$var$getWindowScrollingElement();
    if (el) do {
        var elMatrix = $dc7ec905e041f51c$var$matrix(el), scaleX = elMatrix.a, scaleY = elMatrix.d;
        offsetLeft += el.scrollLeft * scaleX;
        offsetTop += el.scrollTop * scaleY;
    }while (el !== winScroller && (el = el.parentNode));
    return [
        offsetLeft,
        offsetTop
    ];
}
/**
 * Returns the index of the object within the given array
 * @param  {Array} arr   Array that may or may not hold the object
 * @param  {Object} obj  An object that has a key-value pair unique to and identical to a key-value pair in the object you want to find
 * @return {Number}      The index of the object in the array, or -1
 */ function $dc7ec905e041f51c$var$indexOfObject(arr, obj) {
    for(var i in arr){
        if (!arr.hasOwnProperty(i)) continue;
        for(var key in obj){
            if (obj.hasOwnProperty(key) && obj[key] === arr[i][key]) return Number(i);
        }
    }
    return -1;
}
function $dc7ec905e041f51c$var$getParentAutoScrollElement(el, includeSelf) {
    // skip to window
    if (!el || !el.getBoundingClientRect) return $dc7ec905e041f51c$var$getWindowScrollingElement();
    var elem = el;
    var gotSelf = false;
    do // we don't need to get elem css if it isn't even overflowing in the first place (performance)
    if (elem.clientWidth < elem.scrollWidth || elem.clientHeight < elem.scrollHeight) {
        var elemCSS = $dc7ec905e041f51c$var$css(elem);
        if (elem.clientWidth < elem.scrollWidth && (elemCSS.overflowX == 'auto' || elemCSS.overflowX == 'scroll') || elem.clientHeight < elem.scrollHeight && (elemCSS.overflowY == 'auto' || elemCSS.overflowY == 'scroll')) {
            if (!elem.getBoundingClientRect || elem === document.body) return $dc7ec905e041f51c$var$getWindowScrollingElement();
            if (gotSelf || includeSelf) return elem;
            gotSelf = true;
        }
    }
    while (elem = elem.parentNode);
    return $dc7ec905e041f51c$var$getWindowScrollingElement();
}
function $dc7ec905e041f51c$var$extend(dst, src) {
    if (dst && src) {
        for(var key in src)if (src.hasOwnProperty(key)) dst[key] = src[key];
    }
    return dst;
}
function $dc7ec905e041f51c$var$isRectEqual(rect1, rect2) {
    return Math.round(rect1.top) === Math.round(rect2.top) && Math.round(rect1.left) === Math.round(rect2.left) && Math.round(rect1.height) === Math.round(rect2.height) && Math.round(rect1.width) === Math.round(rect2.width);
}
var $dc7ec905e041f51c$var$_throttleTimeout;
function $dc7ec905e041f51c$var$throttle(callback, ms) {
    return function() {
        if (!$dc7ec905e041f51c$var$_throttleTimeout) {
            var args = arguments, _this = this;
            if (args.length === 1) callback.call(_this, args[0]);
            else callback.apply(_this, args);
            $dc7ec905e041f51c$var$_throttleTimeout = setTimeout(function() {
                $dc7ec905e041f51c$var$_throttleTimeout = void 0;
            }, ms);
        }
    };
}
function $dc7ec905e041f51c$var$cancelThrottle() {
    clearTimeout($dc7ec905e041f51c$var$_throttleTimeout);
    $dc7ec905e041f51c$var$_throttleTimeout = void 0;
}
function $dc7ec905e041f51c$var$scrollBy(el, x, y) {
    el.scrollLeft += x;
    el.scrollTop += y;
}
function $dc7ec905e041f51c$var$clone(el) {
    var Polymer = window.Polymer;
    var $ = window.jQuery || window.Zepto;
    if (Polymer && Polymer.dom) return Polymer.dom(el).cloneNode(true);
    else if ($) return $(el).clone(true)[0];
    else return el.cloneNode(true);
}
function $dc7ec905e041f51c$var$setRect(el, rect) {
    $dc7ec905e041f51c$var$css(el, 'position', 'absolute');
    $dc7ec905e041f51c$var$css(el, 'top', rect.top);
    $dc7ec905e041f51c$var$css(el, 'left', rect.left);
    $dc7ec905e041f51c$var$css(el, 'width', rect.width);
    $dc7ec905e041f51c$var$css(el, 'height', rect.height);
}
function $dc7ec905e041f51c$var$unsetRect(el) {
    $dc7ec905e041f51c$var$css(el, 'position', '');
    $dc7ec905e041f51c$var$css(el, 'top', '');
    $dc7ec905e041f51c$var$css(el, 'left', '');
    $dc7ec905e041f51c$var$css(el, 'width', '');
    $dc7ec905e041f51c$var$css(el, 'height', '');
}
function $dc7ec905e041f51c$var$getChildContainingRectFromElement(container, options, ghostEl) {
    var rect = {};
    Array.from(container.children).forEach(function(child) {
        var _rect$left, _rect$top, _rect$right, _rect$bottom;
        if (!$dc7ec905e041f51c$var$closest(child, options.draggable, container, false) || child.animated || child === ghostEl) return;
        var childRect = $dc7ec905e041f51c$var$getRect(child);
        rect.left = Math.min((_rect$left = rect.left) !== null && _rect$left !== void 0 ? _rect$left : Infinity, childRect.left);
        rect.top = Math.min((_rect$top = rect.top) !== null && _rect$top !== void 0 ? _rect$top : Infinity, childRect.top);
        rect.right = Math.max((_rect$right = rect.right) !== null && _rect$right !== void 0 ? _rect$right : -Infinity, childRect.right);
        rect.bottom = Math.max((_rect$bottom = rect.bottom) !== null && _rect$bottom !== void 0 ? _rect$bottom : -Infinity, childRect.bottom);
    });
    rect.width = rect.right - rect.left;
    rect.height = rect.bottom - rect.top;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
var $dc7ec905e041f51c$var$expando = 'Sortable' + new Date().getTime();
function $dc7ec905e041f51c$var$AnimationStateManager() {
    var animationStates = [], animationCallbackId;
    return {
        captureAnimationState: function captureAnimationState() {
            animationStates = [];
            if (!this.options.animation) return;
            var children = [].slice.call(this.el.children);
            children.forEach(function(child) {
                if ($dc7ec905e041f51c$var$css(child, 'display') === 'none' || child === $dc7ec905e041f51c$export$31b3ca70d8f57423.ghost) return;
                animationStates.push({
                    target: child,
                    rect: $dc7ec905e041f51c$var$getRect(child)
                });
                var fromRect = $dc7ec905e041f51c$var$_objectSpread2({}, animationStates[animationStates.length - 1].rect);
                // If animating: compensate for current animation
                if (child.thisAnimationDuration) {
                    var childMatrix = $dc7ec905e041f51c$var$matrix(child, true);
                    if (childMatrix) {
                        fromRect.top -= childMatrix.f;
                        fromRect.left -= childMatrix.e;
                    }
                }
                child.fromRect = fromRect;
            });
        },
        addAnimationState: function addAnimationState(state) {
            animationStates.push(state);
        },
        removeAnimationState: function removeAnimationState(target) {
            animationStates.splice($dc7ec905e041f51c$var$indexOfObject(animationStates, {
                target: target
            }), 1);
        },
        animateAll: function animateAll(callback) {
            var _this = this;
            if (!this.options.animation) {
                clearTimeout(animationCallbackId);
                if (typeof callback === 'function') callback();
                return;
            }
            var animating = false, animationTime = 0;
            animationStates.forEach(function(state) {
                var time = 0, target = state.target, fromRect = target.fromRect, toRect = $dc7ec905e041f51c$var$getRect(target), prevFromRect = target.prevFromRect, prevToRect = target.prevToRect, animatingRect = state.rect, targetMatrix = $dc7ec905e041f51c$var$matrix(target, true);
                if (targetMatrix) {
                    // Compensate for current animation
                    toRect.top -= targetMatrix.f;
                    toRect.left -= targetMatrix.e;
                }
                target.toRect = toRect;
                if (target.thisAnimationDuration) // Could also check if animatingRect is between fromRect and toRect
                {
                    if ($dc7ec905e041f51c$var$isRectEqual(prevFromRect, toRect) && !$dc7ec905e041f51c$var$isRectEqual(fromRect, toRect) && // Make sure animatingRect is on line between toRect & fromRect
                    (animatingRect.top - toRect.top) / (animatingRect.left - toRect.left) === (fromRect.top - toRect.top) / (fromRect.left - toRect.left)) // If returning to same place as started from animation and on same axis
                    time = $dc7ec905e041f51c$var$calculateRealTime(animatingRect, prevFromRect, prevToRect, _this.options);
                }
                // if fromRect != toRect: animate
                if (!$dc7ec905e041f51c$var$isRectEqual(toRect, fromRect)) {
                    target.prevFromRect = fromRect;
                    target.prevToRect = toRect;
                    if (!time) time = _this.options.animation;
                    _this.animate(target, animatingRect, toRect, time);
                }
                if (time) {
                    animating = true;
                    animationTime = Math.max(animationTime, time);
                    clearTimeout(target.animationResetTimer);
                    target.animationResetTimer = setTimeout(function() {
                        target.animationTime = 0;
                        target.prevFromRect = null;
                        target.fromRect = null;
                        target.prevToRect = null;
                        target.thisAnimationDuration = null;
                    }, time);
                    target.thisAnimationDuration = time;
                }
            });
            clearTimeout(animationCallbackId);
            if (!animating) {
                if (typeof callback === 'function') callback();
            } else animationCallbackId = setTimeout(function() {
                if (typeof callback === 'function') callback();
            }, animationTime);
            animationStates = [];
        },
        animate: function animate(target, currentRect, toRect, duration) {
            if (duration) {
                $dc7ec905e041f51c$var$css(target, 'transition', '');
                $dc7ec905e041f51c$var$css(target, 'transform', '');
                var elMatrix = $dc7ec905e041f51c$var$matrix(this.el), scaleX = elMatrix && elMatrix.a, scaleY = elMatrix && elMatrix.d, translateX = (currentRect.left - toRect.left) / (scaleX || 1), translateY = (currentRect.top - toRect.top) / (scaleY || 1);
                target.animatingX = !!translateX;
                target.animatingY = !!translateY;
                $dc7ec905e041f51c$var$css(target, 'transform', 'translate3d(' + translateX + 'px,' + translateY + 'px,0)');
                this.forRepaintDummy = $dc7ec905e041f51c$var$repaint(target); // repaint
                $dc7ec905e041f51c$var$css(target, 'transition', 'transform ' + duration + 'ms' + (this.options.easing ? ' ' + this.options.easing : ''));
                $dc7ec905e041f51c$var$css(target, 'transform', 'translate3d(0,0,0)');
                typeof target.animated === 'number' && clearTimeout(target.animated);
                target.animated = setTimeout(function() {
                    $dc7ec905e041f51c$var$css(target, 'transition', '');
                    $dc7ec905e041f51c$var$css(target, 'transform', '');
                    target.animated = false;
                    target.animatingX = false;
                    target.animatingY = false;
                }, duration);
            }
        }
    };
}
function $dc7ec905e041f51c$var$repaint(target) {
    return target.offsetWidth;
}
function $dc7ec905e041f51c$var$calculateRealTime(animatingRect, fromRect, toRect, options) {
    return Math.sqrt(Math.pow(fromRect.top - animatingRect.top, 2) + Math.pow(fromRect.left - animatingRect.left, 2)) / Math.sqrt(Math.pow(fromRect.top - toRect.top, 2) + Math.pow(fromRect.left - toRect.left, 2)) * options.animation;
}
var $dc7ec905e041f51c$var$plugins = [];
var $dc7ec905e041f51c$var$defaults = {
    initializeByDefault: true
};
var $dc7ec905e041f51c$var$PluginManager = {
    mount: function mount(plugin) {
        // Set default static properties
        for(var option in $dc7ec905e041f51c$var$defaults)if ($dc7ec905e041f51c$var$defaults.hasOwnProperty(option) && !(option in plugin)) plugin[option] = $dc7ec905e041f51c$var$defaults[option];
        $dc7ec905e041f51c$var$plugins.forEach(function(p) {
            if (p.pluginName === plugin.pluginName) throw "Sortable: Cannot mount plugin ".concat(plugin.pluginName, " more than once");
        });
        $dc7ec905e041f51c$var$plugins.push(plugin);
    },
    pluginEvent: function pluginEvent(eventName, sortable, evt) {
        var _this = this;
        this.eventCanceled = false;
        evt.cancel = function() {
            _this.eventCanceled = true;
        };
        var eventNameGlobal = eventName + 'Global';
        $dc7ec905e041f51c$var$plugins.forEach(function(plugin) {
            if (!sortable[plugin.pluginName]) return;
            // Fire global events if it exists in this sortable
            if (sortable[plugin.pluginName][eventNameGlobal]) sortable[plugin.pluginName][eventNameGlobal]($dc7ec905e041f51c$var$_objectSpread2({
                sortable: sortable
            }, evt));
            // Only fire plugin event if plugin is enabled in this sortable,
            // and plugin has event defined
            if (sortable.options[plugin.pluginName] && sortable[plugin.pluginName][eventName]) sortable[plugin.pluginName][eventName]($dc7ec905e041f51c$var$_objectSpread2({
                sortable: sortable
            }, evt));
        });
    },
    initializePlugins: function initializePlugins(sortable, el, defaults, options) {
        $dc7ec905e041f51c$var$plugins.forEach(function(plugin) {
            var pluginName = plugin.pluginName;
            if (!sortable.options[pluginName] && !plugin.initializeByDefault) return;
            var initialized = new plugin(sortable, el, sortable.options);
            initialized.sortable = sortable;
            initialized.options = sortable.options;
            sortable[pluginName] = initialized;
            // Add default options from plugin
            $dc7ec905e041f51c$var$_extends(defaults, initialized.defaults);
        });
        for(var option in sortable.options){
            if (!sortable.options.hasOwnProperty(option)) continue;
            var modified = this.modifyOption(sortable, option, sortable.options[option]);
            if (typeof modified !== 'undefined') sortable.options[option] = modified;
        }
    },
    getEventProperties: function getEventProperties(name, sortable) {
        var eventProperties = {};
        $dc7ec905e041f51c$var$plugins.forEach(function(plugin) {
            if (typeof plugin.eventProperties !== 'function') return;
            $dc7ec905e041f51c$var$_extends(eventProperties, plugin.eventProperties.call(sortable[plugin.pluginName], name));
        });
        return eventProperties;
    },
    modifyOption: function modifyOption(sortable, name, value) {
        var modifiedValue;
        $dc7ec905e041f51c$var$plugins.forEach(function(plugin) {
            // Plugin must exist on the Sortable
            if (!sortable[plugin.pluginName]) return;
            // If static option listener exists for this option, call in the context of the Sortable's instance of this plugin
            if (plugin.optionListeners && typeof plugin.optionListeners[name] === 'function') modifiedValue = plugin.optionListeners[name].call(sortable[plugin.pluginName], value);
        });
        return modifiedValue;
    }
};
function $dc7ec905e041f51c$var$dispatchEvent(_ref) {
    var sortable = _ref.sortable, rootEl = _ref.rootEl, name = _ref.name, targetEl = _ref.targetEl, cloneEl = _ref.cloneEl, toEl = _ref.toEl, fromEl = _ref.fromEl, oldIndex = _ref.oldIndex, newIndex = _ref.newIndex, oldDraggableIndex = _ref.oldDraggableIndex, newDraggableIndex = _ref.newDraggableIndex, originalEvent = _ref.originalEvent, putSortable = _ref.putSortable, extraEventProperties = _ref.extraEventProperties;
    sortable = sortable || rootEl && rootEl[$dc7ec905e041f51c$var$expando];
    if (!sortable) return;
    var evt, options = sortable.options, onName = 'on' + name.charAt(0).toUpperCase() + name.substr(1);
    // Support for new CustomEvent feature
    if (window.CustomEvent && !$dc7ec905e041f51c$var$IE11OrLess && !$dc7ec905e041f51c$var$Edge) evt = new CustomEvent(name, {
        bubbles: true,
        cancelable: true
    });
    else {
        evt = document.createEvent('Event');
        evt.initEvent(name, true, true);
    }
    evt.to = toEl || rootEl;
    evt.from = fromEl || rootEl;
    evt.item = targetEl || rootEl;
    evt.clone = cloneEl;
    evt.oldIndex = oldIndex;
    evt.newIndex = newIndex;
    evt.oldDraggableIndex = oldDraggableIndex;
    evt.newDraggableIndex = newDraggableIndex;
    evt.originalEvent = originalEvent;
    evt.pullMode = putSortable ? putSortable.lastPutMode : undefined;
    var allEventProperties = $dc7ec905e041f51c$var$_objectSpread2($dc7ec905e041f51c$var$_objectSpread2({}, extraEventProperties), $dc7ec905e041f51c$var$PluginManager.getEventProperties(name, sortable));
    for(var option in allEventProperties)evt[option] = allEventProperties[option];
    if (rootEl) rootEl.dispatchEvent(evt);
    if (options[onName]) options[onName].call(sortable, evt);
}
var $dc7ec905e041f51c$var$_excluded = [
    "evt"
];
var $dc7ec905e041f51c$var$pluginEvent = function pluginEvent(eventName, sortable) {
    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {}, originalEvent = _ref.evt, data = $dc7ec905e041f51c$var$_objectWithoutProperties(_ref, $dc7ec905e041f51c$var$_excluded);
    $dc7ec905e041f51c$var$PluginManager.pluginEvent.bind($dc7ec905e041f51c$export$31b3ca70d8f57423)(eventName, sortable, $dc7ec905e041f51c$var$_objectSpread2({
        dragEl: $dc7ec905e041f51c$var$dragEl,
        parentEl: $dc7ec905e041f51c$var$parentEl,
        ghostEl: $dc7ec905e041f51c$var$ghostEl,
        rootEl: $dc7ec905e041f51c$var$rootEl,
        nextEl: $dc7ec905e041f51c$var$nextEl,
        lastDownEl: $dc7ec905e041f51c$var$lastDownEl,
        cloneEl: $dc7ec905e041f51c$var$cloneEl,
        cloneHidden: $dc7ec905e041f51c$var$cloneHidden,
        dragStarted: $dc7ec905e041f51c$var$moved,
        putSortable: $dc7ec905e041f51c$var$putSortable,
        activeSortable: $dc7ec905e041f51c$export$31b3ca70d8f57423.active,
        originalEvent: originalEvent,
        oldIndex: $dc7ec905e041f51c$var$oldIndex,
        oldDraggableIndex: $dc7ec905e041f51c$var$oldDraggableIndex,
        newIndex: $dc7ec905e041f51c$var$newIndex,
        newDraggableIndex: $dc7ec905e041f51c$var$newDraggableIndex,
        hideGhostForTarget: $dc7ec905e041f51c$var$_hideGhostForTarget,
        unhideGhostForTarget: $dc7ec905e041f51c$var$_unhideGhostForTarget,
        cloneNowHidden: function cloneNowHidden() {
            $dc7ec905e041f51c$var$cloneHidden = true;
        },
        cloneNowShown: function cloneNowShown() {
            $dc7ec905e041f51c$var$cloneHidden = false;
        },
        dispatchSortableEvent: function dispatchSortableEvent(name) {
            $dc7ec905e041f51c$var$_dispatchEvent({
                sortable: sortable,
                name: name,
                originalEvent: originalEvent
            });
        }
    }, data));
};
function $dc7ec905e041f51c$var$_dispatchEvent(info) {
    $dc7ec905e041f51c$var$dispatchEvent($dc7ec905e041f51c$var$_objectSpread2({
        putSortable: $dc7ec905e041f51c$var$putSortable,
        cloneEl: $dc7ec905e041f51c$var$cloneEl,
        targetEl: $dc7ec905e041f51c$var$dragEl,
        rootEl: $dc7ec905e041f51c$var$rootEl,
        oldIndex: $dc7ec905e041f51c$var$oldIndex,
        oldDraggableIndex: $dc7ec905e041f51c$var$oldDraggableIndex,
        newIndex: $dc7ec905e041f51c$var$newIndex,
        newDraggableIndex: $dc7ec905e041f51c$var$newDraggableIndex
    }, info));
}
var $dc7ec905e041f51c$var$dragEl, $dc7ec905e041f51c$var$parentEl, $dc7ec905e041f51c$var$ghostEl, $dc7ec905e041f51c$var$rootEl, $dc7ec905e041f51c$var$nextEl, $dc7ec905e041f51c$var$lastDownEl, $dc7ec905e041f51c$var$cloneEl, $dc7ec905e041f51c$var$cloneHidden, $dc7ec905e041f51c$var$oldIndex, $dc7ec905e041f51c$var$newIndex, $dc7ec905e041f51c$var$oldDraggableIndex, $dc7ec905e041f51c$var$newDraggableIndex, $dc7ec905e041f51c$var$activeGroup, $dc7ec905e041f51c$var$putSortable, $dc7ec905e041f51c$var$awaitingDragStarted = false, $dc7ec905e041f51c$var$ignoreNextClick = false, $dc7ec905e041f51c$var$sortables = [], $dc7ec905e041f51c$var$tapEvt, $dc7ec905e041f51c$var$touchEvt, $dc7ec905e041f51c$var$lastDx, $dc7ec905e041f51c$var$lastDy, $dc7ec905e041f51c$var$tapDistanceLeft, $dc7ec905e041f51c$var$tapDistanceTop, $dc7ec905e041f51c$var$moved, $dc7ec905e041f51c$var$lastTarget, $dc7ec905e041f51c$var$lastDirection, $dc7ec905e041f51c$var$pastFirstInvertThresh = false, $dc7ec905e041f51c$var$isCircumstantialInvert = false, $dc7ec905e041f51c$var$targetMoveDistance, // For positioning ghost absolutely
$dc7ec905e041f51c$var$ghostRelativeParent, $dc7ec905e041f51c$var$ghostRelativeParentInitialScroll = [], // (left, top)
$dc7ec905e041f51c$var$_silent = false, $dc7ec905e041f51c$var$savedInputChecked = [];
/** @const */ var $dc7ec905e041f51c$var$documentExists = typeof document !== 'undefined', $dc7ec905e041f51c$var$PositionGhostAbsolutely = $dc7ec905e041f51c$var$IOS, $dc7ec905e041f51c$var$CSSFloatProperty = $dc7ec905e041f51c$var$Edge || $dc7ec905e041f51c$var$IE11OrLess ? 'cssFloat' : 'float', // This will not pass for IE9, because IE9 DnD only works on anchors
$dc7ec905e041f51c$var$supportDraggable = $dc7ec905e041f51c$var$documentExists && !$dc7ec905e041f51c$var$ChromeForAndroid && !$dc7ec905e041f51c$var$IOS && 'draggable' in document.createElement('div'), $dc7ec905e041f51c$var$supportCssPointerEvents = function() {
    if (!$dc7ec905e041f51c$var$documentExists) return;
    // false when <= IE11
    if ($dc7ec905e041f51c$var$IE11OrLess) return false;
    var el = document.createElement('x');
    el.style.cssText = 'pointer-events:auto';
    return el.style.pointerEvents === 'auto';
}(), $dc7ec905e041f51c$var$_detectDirection = function _detectDirection(el, options) {
    var elCSS = $dc7ec905e041f51c$var$css(el), elWidth = parseInt(elCSS.width) - parseInt(elCSS.paddingLeft) - parseInt(elCSS.paddingRight) - parseInt(elCSS.borderLeftWidth) - parseInt(elCSS.borderRightWidth), child1 = $dc7ec905e041f51c$var$getChild(el, 0, options), child2 = $dc7ec905e041f51c$var$getChild(el, 1, options), firstChildCSS = child1 && $dc7ec905e041f51c$var$css(child1), secondChildCSS = child2 && $dc7ec905e041f51c$var$css(child2), firstChildWidth = firstChildCSS && parseInt(firstChildCSS.marginLeft) + parseInt(firstChildCSS.marginRight) + $dc7ec905e041f51c$var$getRect(child1).width, secondChildWidth = secondChildCSS && parseInt(secondChildCSS.marginLeft) + parseInt(secondChildCSS.marginRight) + $dc7ec905e041f51c$var$getRect(child2).width;
    if (elCSS.display === 'flex') return elCSS.flexDirection === 'column' || elCSS.flexDirection === 'column-reverse' ? 'vertical' : 'horizontal';
    if (elCSS.display === 'grid') return elCSS.gridTemplateColumns.split(' ').length <= 1 ? 'vertical' : 'horizontal';
    if (child1 && firstChildCSS["float"] && firstChildCSS["float"] !== 'none') {
        var touchingSideChild2 = firstChildCSS["float"] === 'left' ? 'left' : 'right';
        return child2 && (secondChildCSS.clear === 'both' || secondChildCSS.clear === touchingSideChild2) ? 'vertical' : 'horizontal';
    }
    return child1 && (firstChildCSS.display === 'block' || firstChildCSS.display === 'flex' || firstChildCSS.display === 'table' || firstChildCSS.display === 'grid' || firstChildWidth >= elWidth && elCSS[$dc7ec905e041f51c$var$CSSFloatProperty] === 'none' || child2 && elCSS[$dc7ec905e041f51c$var$CSSFloatProperty] === 'none' && firstChildWidth + secondChildWidth > elWidth) ? 'vertical' : 'horizontal';
}, $dc7ec905e041f51c$var$_dragElInRowColumn = function _dragElInRowColumn(dragRect, targetRect, vertical) {
    var dragElS1Opp = vertical ? dragRect.left : dragRect.top, dragElS2Opp = vertical ? dragRect.right : dragRect.bottom, dragElOppLength = vertical ? dragRect.width : dragRect.height, targetS1Opp = vertical ? targetRect.left : targetRect.top, targetS2Opp = vertical ? targetRect.right : targetRect.bottom, targetOppLength = vertical ? targetRect.width : targetRect.height;
    return dragElS1Opp === targetS1Opp || dragElS2Opp === targetS2Opp || dragElS1Opp + dragElOppLength / 2 === targetS1Opp + targetOppLength / 2;
}, /**
   * Detects first nearest empty sortable to X and Y position using emptyInsertThreshold.
   * @param  {Number} x      X position
   * @param  {Number} y      Y position
   * @return {HTMLElement}   Element of the first found nearest Sortable
   */ $dc7ec905e041f51c$var$_detectNearestEmptySortable = function _detectNearestEmptySortable(x, y) {
    var ret;
    $dc7ec905e041f51c$var$sortables.some(function(sortable) {
        var threshold = sortable[$dc7ec905e041f51c$var$expando].options.emptyInsertThreshold;
        if (!threshold || $dc7ec905e041f51c$var$lastChild(sortable)) return;
        var rect = $dc7ec905e041f51c$var$getRect(sortable), insideHorizontally = x >= rect.left - threshold && x <= rect.right + threshold, insideVertically = y >= rect.top - threshold && y <= rect.bottom + threshold;
        if (insideHorizontally && insideVertically) return ret = sortable;
    });
    return ret;
}, $dc7ec905e041f51c$var$_prepareGroup = function _prepareGroup(options) {
    function toFn(value, pull) {
        return function(to, from, dragEl, evt) {
            var sameGroup = to.options.group.name && from.options.group.name && to.options.group.name === from.options.group.name;
            if (value == null && (pull || sameGroup)) // Default pull value
            // Default pull and put value if same group
            return true;
            else if (value == null || value === false) return false;
            else if (pull && value === 'clone') return value;
            else if (typeof value === 'function') return toFn(value(to, from, dragEl, evt), pull)(to, from, dragEl, evt);
            else {
                var otherGroup = (pull ? to : from).options.group.name;
                return value === true || typeof value === 'string' && value === otherGroup || value.join && value.indexOf(otherGroup) > -1;
            }
        };
    }
    var group = {};
    var originalGroup = options.group;
    if (!originalGroup || $dc7ec905e041f51c$var$_typeof(originalGroup) != 'object') originalGroup = {
        name: originalGroup
    };
    group.name = originalGroup.name;
    group.checkPull = toFn(originalGroup.pull, true);
    group.checkPut = toFn(originalGroup.put);
    group.revertClone = originalGroup.revertClone;
    options.group = group;
}, $dc7ec905e041f51c$var$_hideGhostForTarget = function _hideGhostForTarget() {
    if (!$dc7ec905e041f51c$var$supportCssPointerEvents && $dc7ec905e041f51c$var$ghostEl) $dc7ec905e041f51c$var$css($dc7ec905e041f51c$var$ghostEl, 'display', 'none');
}, $dc7ec905e041f51c$var$_unhideGhostForTarget = function _unhideGhostForTarget() {
    if (!$dc7ec905e041f51c$var$supportCssPointerEvents && $dc7ec905e041f51c$var$ghostEl) $dc7ec905e041f51c$var$css($dc7ec905e041f51c$var$ghostEl, 'display', '');
};
// #1184 fix - Prevent click event on fallback if dragged but item not changed position
if ($dc7ec905e041f51c$var$documentExists && !$dc7ec905e041f51c$var$ChromeForAndroid) document.addEventListener('click', function(evt) {
    if ($dc7ec905e041f51c$var$ignoreNextClick) {
        evt.preventDefault();
        evt.stopPropagation && evt.stopPropagation();
        evt.stopImmediatePropagation && evt.stopImmediatePropagation();
        $dc7ec905e041f51c$var$ignoreNextClick = false;
        return false;
    }
}, true);
var $dc7ec905e041f51c$var$nearestEmptyInsertDetectEvent = function nearestEmptyInsertDetectEvent(evt) {
    if ($dc7ec905e041f51c$var$dragEl) {
        evt = evt.touches ? evt.touches[0] : evt;
        var nearest = $dc7ec905e041f51c$var$_detectNearestEmptySortable(evt.clientX, evt.clientY);
        if (nearest) {
            // Create imitation event
            var event = {};
            for(var i in evt)if (evt.hasOwnProperty(i)) event[i] = evt[i];
            event.target = event.rootEl = nearest;
            event.preventDefault = void 0;
            event.stopPropagation = void 0;
            nearest[$dc7ec905e041f51c$var$expando]._onDragOver(event);
        }
    }
};
var $dc7ec905e041f51c$var$_checkOutsideTargetEl = function _checkOutsideTargetEl(evt) {
    if ($dc7ec905e041f51c$var$dragEl) $dc7ec905e041f51c$var$dragEl.parentNode[$dc7ec905e041f51c$var$expando]._isOutsideThisEl(evt.target);
};
/**
 * @class  Sortable
 * @param  {HTMLElement}  el
 * @param  {Object}       [options]
 */ function $dc7ec905e041f51c$export$31b3ca70d8f57423(el, options) {
    if (!(el && el.nodeType && el.nodeType === 1)) throw "Sortable: `el` must be an HTMLElement, not ".concat(({}).toString.call(el));
    this.el = el; // root element
    this.options = options = $dc7ec905e041f51c$var$_extends({}, options);
    // Export instance
    el[$dc7ec905e041f51c$var$expando] = this;
    var defaults = {
        group: null,
        sort: true,
        disabled: false,
        store: null,
        handle: null,
        draggable: /^[uo]l$/i.test(el.nodeName) ? '>li' : '>*',
        swapThreshold: 1,
        // percentage; 0 <= x <= 1
        invertSwap: false,
        // invert always
        invertedSwapThreshold: null,
        // will be set to same as swapThreshold if default
        removeCloneOnHide: true,
        direction: function direction() {
            return $dc7ec905e041f51c$var$_detectDirection(el, this.options);
        },
        ghostClass: 'sortable-ghost',
        chosenClass: 'sortable-chosen',
        dragClass: 'sortable-drag',
        ignore: 'a, img',
        filter: null,
        preventOnFilter: true,
        animation: 0,
        easing: null,
        setData: function setData(dataTransfer, dragEl) {
            dataTransfer.setData('Text', dragEl.textContent);
        },
        dropBubble: false,
        dragoverBubble: false,
        dataIdAttr: 'data-id',
        delay: 0,
        delayOnTouchOnly: false,
        touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1,
        forceFallback: false,
        fallbackClass: 'sortable-fallback',
        fallbackOnBody: false,
        fallbackTolerance: 0,
        fallbackOffset: {
            x: 0,
            y: 0
        },
        // Disabled on Safari: #1571; Enabled on Safari IOS: #2244
        supportPointer: $dc7ec905e041f51c$export$31b3ca70d8f57423.supportPointer !== false && 'PointerEvent' in window && (!$dc7ec905e041f51c$var$Safari || $dc7ec905e041f51c$var$IOS),
        emptyInsertThreshold: 5
    };
    $dc7ec905e041f51c$var$PluginManager.initializePlugins(this, el, defaults);
    // Set default options
    for(var name in defaults)!(name in options) && (options[name] = defaults[name]);
    $dc7ec905e041f51c$var$_prepareGroup(options);
    // Bind all private methods
    for(var fn in this)if (fn.charAt(0) === '_' && typeof this[fn] === 'function') this[fn] = this[fn].bind(this);
    // Setup drag mode
    this.nativeDraggable = options.forceFallback ? false : $dc7ec905e041f51c$var$supportDraggable;
    if (this.nativeDraggable) // Touch start threshold cannot be greater than the native dragstart threshold
    this.options.touchStartThreshold = 1;
    // Bind events
    if (options.supportPointer) $dc7ec905e041f51c$var$on(el, 'pointerdown', this._onTapStart);
    else {
        $dc7ec905e041f51c$var$on(el, 'mousedown', this._onTapStart);
        $dc7ec905e041f51c$var$on(el, 'touchstart', this._onTapStart);
    }
    if (this.nativeDraggable) {
        $dc7ec905e041f51c$var$on(el, 'dragover', this);
        $dc7ec905e041f51c$var$on(el, 'dragenter', this);
    }
    $dc7ec905e041f51c$var$sortables.push(this.el);
    // Restore sorting
    options.store && options.store.get && this.sort(options.store.get(this) || []);
    // Add animation state manager
    $dc7ec905e041f51c$var$_extends(this, $dc7ec905e041f51c$var$AnimationStateManager());
}
$dc7ec905e041f51c$export$31b3ca70d8f57423.prototype = /** @lends Sortable.prototype */ {
    constructor: $dc7ec905e041f51c$export$31b3ca70d8f57423,
    _isOutsideThisEl: function _isOutsideThisEl(target) {
        if (!this.el.contains(target) && target !== this.el) $dc7ec905e041f51c$var$lastTarget = null;
    },
    _getDirection: function _getDirection(evt, target) {
        return typeof this.options.direction === 'function' ? this.options.direction.call(this, evt, target, $dc7ec905e041f51c$var$dragEl) : this.options.direction;
    },
    _onTapStart: function _onTapStart(/** Event|TouchEvent */ evt) {
        if (!evt.cancelable) return;
        var _this = this, el = this.el, options = this.options, preventOnFilter = options.preventOnFilter, type = evt.type, touch = evt.touches && evt.touches[0] || evt.pointerType && evt.pointerType === 'touch' && evt, target = (touch || evt).target, originalTarget = evt.target.shadowRoot && (evt.path && evt.path[0] || evt.composedPath && evt.composedPath()[0]) || target, filter = options.filter;
        $dc7ec905e041f51c$var$_saveInputCheckedState(el);
        // Don't trigger start event when an element is been dragged, otherwise the evt.oldindex always wrong when set option.group.
        if ($dc7ec905e041f51c$var$dragEl) return;
        if (/mousedown|pointerdown/.test(type) && evt.button !== 0 || options.disabled) return; // only left button and enabled
        // cancel dnd if original target is content editable
        if (originalTarget.isContentEditable) return;
        // Safari ignores further event handling after mousedown
        if (!this.nativeDraggable && $dc7ec905e041f51c$var$Safari && target && target.tagName.toUpperCase() === 'SELECT') return;
        target = $dc7ec905e041f51c$var$closest(target, options.draggable, el, false);
        if (target && target.animated) return;
        if ($dc7ec905e041f51c$var$lastDownEl === target) // Ignoring duplicate `down`
        return;
        // Get the index of the dragged element within its parent
        $dc7ec905e041f51c$var$oldIndex = $dc7ec905e041f51c$var$index(target);
        $dc7ec905e041f51c$var$oldDraggableIndex = $dc7ec905e041f51c$var$index(target, options.draggable);
        // Check filter
        if (typeof filter === 'function') {
            if (filter.call(this, evt, target, this)) {
                $dc7ec905e041f51c$var$_dispatchEvent({
                    sortable: _this,
                    rootEl: originalTarget,
                    name: 'filter',
                    targetEl: target,
                    toEl: el,
                    fromEl: el
                });
                $dc7ec905e041f51c$var$pluginEvent('filter', _this, {
                    evt: evt
                });
                preventOnFilter && evt.preventDefault();
                return; // cancel dnd
            }
        } else if (filter) {
            filter = filter.split(',').some(function(criteria) {
                criteria = $dc7ec905e041f51c$var$closest(originalTarget, criteria.trim(), el, false);
                if (criteria) {
                    $dc7ec905e041f51c$var$_dispatchEvent({
                        sortable: _this,
                        rootEl: criteria,
                        name: 'filter',
                        targetEl: target,
                        fromEl: el,
                        toEl: el
                    });
                    $dc7ec905e041f51c$var$pluginEvent('filter', _this, {
                        evt: evt
                    });
                    return true;
                }
            });
            if (filter) {
                preventOnFilter && evt.preventDefault();
                return; // cancel dnd
            }
        }
        if (options.handle && !$dc7ec905e041f51c$var$closest(originalTarget, options.handle, el, false)) return;
        // Prepare `dragstart`
        this._prepareDragStart(evt, touch, target);
    },
    _prepareDragStart: function _prepareDragStart(/** Event */ evt, /** Touch */ touch, /** HTMLElement */ target) {
        var _this = this, el = _this.el, options = _this.options, ownerDocument = el.ownerDocument, dragStartFn;
        if (target && !$dc7ec905e041f51c$var$dragEl && target.parentNode === el) {
            var dragRect = $dc7ec905e041f51c$var$getRect(target);
            $dc7ec905e041f51c$var$rootEl = el;
            $dc7ec905e041f51c$var$dragEl = target;
            $dc7ec905e041f51c$var$parentEl = $dc7ec905e041f51c$var$dragEl.parentNode;
            $dc7ec905e041f51c$var$nextEl = $dc7ec905e041f51c$var$dragEl.nextSibling;
            $dc7ec905e041f51c$var$lastDownEl = target;
            $dc7ec905e041f51c$var$activeGroup = options.group;
            $dc7ec905e041f51c$export$31b3ca70d8f57423.dragged = $dc7ec905e041f51c$var$dragEl;
            $dc7ec905e041f51c$var$tapEvt = {
                target: $dc7ec905e041f51c$var$dragEl,
                clientX: (touch || evt).clientX,
                clientY: (touch || evt).clientY
            };
            $dc7ec905e041f51c$var$tapDistanceLeft = $dc7ec905e041f51c$var$tapEvt.clientX - dragRect.left;
            $dc7ec905e041f51c$var$tapDistanceTop = $dc7ec905e041f51c$var$tapEvt.clientY - dragRect.top;
            this._lastX = (touch || evt).clientX;
            this._lastY = (touch || evt).clientY;
            $dc7ec905e041f51c$var$dragEl.style['will-change'] = 'all';
            dragStartFn = function dragStartFn() {
                $dc7ec905e041f51c$var$pluginEvent('delayEnded', _this, {
                    evt: evt
                });
                if ($dc7ec905e041f51c$export$31b3ca70d8f57423.eventCanceled) {
                    _this._onDrop();
                    return;
                }
                // Delayed drag has been triggered
                // we can re-enable the events: touchmove/mousemove
                _this._disableDelayedDragEvents();
                if (!$dc7ec905e041f51c$var$FireFox && _this.nativeDraggable) $dc7ec905e041f51c$var$dragEl.draggable = true;
                // Bind the events: dragstart/dragend
                _this._triggerDragStart(evt, touch);
                // Drag start event
                $dc7ec905e041f51c$var$_dispatchEvent({
                    sortable: _this,
                    name: 'choose',
                    originalEvent: evt
                });
                // Chosen item
                $dc7ec905e041f51c$var$toggleClass($dc7ec905e041f51c$var$dragEl, options.chosenClass, true);
            };
            // Disable "draggable"
            options.ignore.split(',').forEach(function(criteria) {
                $dc7ec905e041f51c$var$find($dc7ec905e041f51c$var$dragEl, criteria.trim(), $dc7ec905e041f51c$var$_disableDraggable);
            });
            $dc7ec905e041f51c$var$on(ownerDocument, 'dragover', $dc7ec905e041f51c$var$nearestEmptyInsertDetectEvent);
            $dc7ec905e041f51c$var$on(ownerDocument, 'mousemove', $dc7ec905e041f51c$var$nearestEmptyInsertDetectEvent);
            $dc7ec905e041f51c$var$on(ownerDocument, 'touchmove', $dc7ec905e041f51c$var$nearestEmptyInsertDetectEvent);
            if (options.supportPointer) {
                $dc7ec905e041f51c$var$on(ownerDocument, 'pointerup', _this._onDrop);
                // Native D&D triggers pointercancel
                !this.nativeDraggable && $dc7ec905e041f51c$var$on(ownerDocument, 'pointercancel', _this._onDrop);
            } else {
                $dc7ec905e041f51c$var$on(ownerDocument, 'mouseup', _this._onDrop);
                $dc7ec905e041f51c$var$on(ownerDocument, 'touchend', _this._onDrop);
                $dc7ec905e041f51c$var$on(ownerDocument, 'touchcancel', _this._onDrop);
            }
            // Make dragEl draggable (must be before delay for FireFox)
            if ($dc7ec905e041f51c$var$FireFox && this.nativeDraggable) {
                this.options.touchStartThreshold = 4;
                $dc7ec905e041f51c$var$dragEl.draggable = true;
            }
            $dc7ec905e041f51c$var$pluginEvent('delayStart', this, {
                evt: evt
            });
            // Delay is impossible for native DnD in Edge or IE
            if (options.delay && (!options.delayOnTouchOnly || touch) && (!this.nativeDraggable || !($dc7ec905e041f51c$var$Edge || $dc7ec905e041f51c$var$IE11OrLess))) {
                if ($dc7ec905e041f51c$export$31b3ca70d8f57423.eventCanceled) {
                    this._onDrop();
                    return;
                }
                // If the user moves the pointer or let go the click or touch
                // before the delay has been reached:
                // disable the delayed drag
                if (options.supportPointer) {
                    $dc7ec905e041f51c$var$on(ownerDocument, 'pointerup', _this._disableDelayedDrag);
                    $dc7ec905e041f51c$var$on(ownerDocument, 'pointercancel', _this._disableDelayedDrag);
                } else {
                    $dc7ec905e041f51c$var$on(ownerDocument, 'mouseup', _this._disableDelayedDrag);
                    $dc7ec905e041f51c$var$on(ownerDocument, 'touchend', _this._disableDelayedDrag);
                    $dc7ec905e041f51c$var$on(ownerDocument, 'touchcancel', _this._disableDelayedDrag);
                }
                $dc7ec905e041f51c$var$on(ownerDocument, 'mousemove', _this._delayedDragTouchMoveHandler);
                $dc7ec905e041f51c$var$on(ownerDocument, 'touchmove', _this._delayedDragTouchMoveHandler);
                options.supportPointer && $dc7ec905e041f51c$var$on(ownerDocument, 'pointermove', _this._delayedDragTouchMoveHandler);
                _this._dragStartTimer = setTimeout(dragStartFn, options.delay);
            } else dragStartFn();
        }
    },
    _delayedDragTouchMoveHandler: function _delayedDragTouchMoveHandler(/** TouchEvent|PointerEvent **/ e) {
        var touch = e.touches ? e.touches[0] : e;
        if (Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1))) this._disableDelayedDrag();
    },
    _disableDelayedDrag: function _disableDelayedDrag() {
        $dc7ec905e041f51c$var$dragEl && $dc7ec905e041f51c$var$_disableDraggable($dc7ec905e041f51c$var$dragEl);
        clearTimeout(this._dragStartTimer);
        this._disableDelayedDragEvents();
    },
    _disableDelayedDragEvents: function _disableDelayedDragEvents() {
        var ownerDocument = this.el.ownerDocument;
        $dc7ec905e041f51c$var$off(ownerDocument, 'mouseup', this._disableDelayedDrag);
        $dc7ec905e041f51c$var$off(ownerDocument, 'touchend', this._disableDelayedDrag);
        $dc7ec905e041f51c$var$off(ownerDocument, 'touchcancel', this._disableDelayedDrag);
        $dc7ec905e041f51c$var$off(ownerDocument, 'pointerup', this._disableDelayedDrag);
        $dc7ec905e041f51c$var$off(ownerDocument, 'pointercancel', this._disableDelayedDrag);
        $dc7ec905e041f51c$var$off(ownerDocument, 'mousemove', this._delayedDragTouchMoveHandler);
        $dc7ec905e041f51c$var$off(ownerDocument, 'touchmove', this._delayedDragTouchMoveHandler);
        $dc7ec905e041f51c$var$off(ownerDocument, 'pointermove', this._delayedDragTouchMoveHandler);
    },
    _triggerDragStart: function _triggerDragStart(/** Event */ evt, /** Touch */ touch) {
        touch = touch || evt.pointerType == 'touch' && evt;
        if (!this.nativeDraggable || touch) {
            if (this.options.supportPointer) $dc7ec905e041f51c$var$on(document, 'pointermove', this._onTouchMove);
            else if (touch) $dc7ec905e041f51c$var$on(document, 'touchmove', this._onTouchMove);
            else $dc7ec905e041f51c$var$on(document, 'mousemove', this._onTouchMove);
        } else {
            $dc7ec905e041f51c$var$on($dc7ec905e041f51c$var$dragEl, 'dragend', this);
            $dc7ec905e041f51c$var$on($dc7ec905e041f51c$var$rootEl, 'dragstart', this._onDragStart);
        }
        try {
            if (document.selection) $dc7ec905e041f51c$var$_nextTick(function() {
                document.selection.empty();
            });
            else window.getSelection().removeAllRanges();
        } catch (err) {}
    },
    _dragStarted: function _dragStarted(fallback, evt) {
        $dc7ec905e041f51c$var$awaitingDragStarted = false;
        if ($dc7ec905e041f51c$var$rootEl && $dc7ec905e041f51c$var$dragEl) {
            $dc7ec905e041f51c$var$pluginEvent('dragStarted', this, {
                evt: evt
            });
            if (this.nativeDraggable) $dc7ec905e041f51c$var$on(document, 'dragover', $dc7ec905e041f51c$var$_checkOutsideTargetEl);
            var options = this.options;
            // Apply effect
            !fallback && $dc7ec905e041f51c$var$toggleClass($dc7ec905e041f51c$var$dragEl, options.dragClass, false);
            $dc7ec905e041f51c$var$toggleClass($dc7ec905e041f51c$var$dragEl, options.ghostClass, true);
            $dc7ec905e041f51c$export$31b3ca70d8f57423.active = this;
            fallback && this._appendGhost();
            // Drag start event
            $dc7ec905e041f51c$var$_dispatchEvent({
                sortable: this,
                name: 'start',
                originalEvent: evt
            });
        } else this._nulling();
    },
    _emulateDragOver: function _emulateDragOver() {
        if ($dc7ec905e041f51c$var$touchEvt) {
            this._lastX = $dc7ec905e041f51c$var$touchEvt.clientX;
            this._lastY = $dc7ec905e041f51c$var$touchEvt.clientY;
            $dc7ec905e041f51c$var$_hideGhostForTarget();
            var target = document.elementFromPoint($dc7ec905e041f51c$var$touchEvt.clientX, $dc7ec905e041f51c$var$touchEvt.clientY);
            var parent = target;
            while(target && target.shadowRoot){
                target = target.shadowRoot.elementFromPoint($dc7ec905e041f51c$var$touchEvt.clientX, $dc7ec905e041f51c$var$touchEvt.clientY);
                if (target === parent) break;
                parent = target;
            }
            $dc7ec905e041f51c$var$dragEl.parentNode[$dc7ec905e041f51c$var$expando]._isOutsideThisEl(target);
            if (parent) do {
                if (parent[$dc7ec905e041f51c$var$expando]) {
                    var inserted = void 0;
                    inserted = parent[$dc7ec905e041f51c$var$expando]._onDragOver({
                        clientX: $dc7ec905e041f51c$var$touchEvt.clientX,
                        clientY: $dc7ec905e041f51c$var$touchEvt.clientY,
                        target: target,
                        rootEl: parent
                    });
                    if (inserted && !this.options.dragoverBubble) break;
                }
                target = parent; // store last element
            }while (parent = $dc7ec905e041f51c$var$getParentOrHost(parent));
            $dc7ec905e041f51c$var$_unhideGhostForTarget();
        }
    },
    _onTouchMove: function _onTouchMove(/**TouchEvent*/ evt) {
        if ($dc7ec905e041f51c$var$tapEvt) {
            var options = this.options, fallbackTolerance = options.fallbackTolerance, fallbackOffset = options.fallbackOffset, touch = evt.touches ? evt.touches[0] : evt, ghostMatrix = $dc7ec905e041f51c$var$ghostEl && $dc7ec905e041f51c$var$matrix($dc7ec905e041f51c$var$ghostEl, true), scaleX = $dc7ec905e041f51c$var$ghostEl && ghostMatrix && ghostMatrix.a, scaleY = $dc7ec905e041f51c$var$ghostEl && ghostMatrix && ghostMatrix.d, relativeScrollOffset = $dc7ec905e041f51c$var$PositionGhostAbsolutely && $dc7ec905e041f51c$var$ghostRelativeParent && $dc7ec905e041f51c$var$getRelativeScrollOffset($dc7ec905e041f51c$var$ghostRelativeParent), dx = (touch.clientX - $dc7ec905e041f51c$var$tapEvt.clientX + fallbackOffset.x) / (scaleX || 1) + (relativeScrollOffset ? relativeScrollOffset[0] - $dc7ec905e041f51c$var$ghostRelativeParentInitialScroll[0] : 0) / (scaleX || 1), dy = (touch.clientY - $dc7ec905e041f51c$var$tapEvt.clientY + fallbackOffset.y) / (scaleY || 1) + (relativeScrollOffset ? relativeScrollOffset[1] - $dc7ec905e041f51c$var$ghostRelativeParentInitialScroll[1] : 0) / (scaleY || 1);
            // only set the status to dragging, when we are actually dragging
            if (!$dc7ec905e041f51c$export$31b3ca70d8f57423.active && !$dc7ec905e041f51c$var$awaitingDragStarted) {
                if (fallbackTolerance && Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) < fallbackTolerance) return;
                this._onDragStart(evt, true);
            }
            if ($dc7ec905e041f51c$var$ghostEl) {
                if (ghostMatrix) {
                    ghostMatrix.e += dx - ($dc7ec905e041f51c$var$lastDx || 0);
                    ghostMatrix.f += dy - ($dc7ec905e041f51c$var$lastDy || 0);
                } else ghostMatrix = {
                    a: 1,
                    b: 0,
                    c: 0,
                    d: 1,
                    e: dx,
                    f: dy
                };
                var cssMatrix = "matrix(".concat(ghostMatrix.a, ",").concat(ghostMatrix.b, ",").concat(ghostMatrix.c, ",").concat(ghostMatrix.d, ",").concat(ghostMatrix.e, ",").concat(ghostMatrix.f, ")");
                $dc7ec905e041f51c$var$css($dc7ec905e041f51c$var$ghostEl, 'webkitTransform', cssMatrix);
                $dc7ec905e041f51c$var$css($dc7ec905e041f51c$var$ghostEl, 'mozTransform', cssMatrix);
                $dc7ec905e041f51c$var$css($dc7ec905e041f51c$var$ghostEl, 'msTransform', cssMatrix);
                $dc7ec905e041f51c$var$css($dc7ec905e041f51c$var$ghostEl, 'transform', cssMatrix);
                $dc7ec905e041f51c$var$lastDx = dx;
                $dc7ec905e041f51c$var$lastDy = dy;
                $dc7ec905e041f51c$var$touchEvt = touch;
            }
            evt.cancelable && evt.preventDefault();
        }
    },
    _appendGhost: function _appendGhost() {
        // Bug if using scale(): https://stackoverflow.com/questions/2637058
        // Not being adjusted for
        if (!$dc7ec905e041f51c$var$ghostEl) {
            var container = this.options.fallbackOnBody ? document.body : $dc7ec905e041f51c$var$rootEl, rect = $dc7ec905e041f51c$var$getRect($dc7ec905e041f51c$var$dragEl, true, $dc7ec905e041f51c$var$PositionGhostAbsolutely, true, container), options = this.options;
            // Position absolutely
            if ($dc7ec905e041f51c$var$PositionGhostAbsolutely) {
                // Get relatively positioned parent
                $dc7ec905e041f51c$var$ghostRelativeParent = container;
                while($dc7ec905e041f51c$var$css($dc7ec905e041f51c$var$ghostRelativeParent, 'position') === 'static' && $dc7ec905e041f51c$var$css($dc7ec905e041f51c$var$ghostRelativeParent, 'transform') === 'none' && $dc7ec905e041f51c$var$ghostRelativeParent !== document)$dc7ec905e041f51c$var$ghostRelativeParent = $dc7ec905e041f51c$var$ghostRelativeParent.parentNode;
                if ($dc7ec905e041f51c$var$ghostRelativeParent !== document.body && $dc7ec905e041f51c$var$ghostRelativeParent !== document.documentElement) {
                    if ($dc7ec905e041f51c$var$ghostRelativeParent === document) $dc7ec905e041f51c$var$ghostRelativeParent = $dc7ec905e041f51c$var$getWindowScrollingElement();
                    rect.top += $dc7ec905e041f51c$var$ghostRelativeParent.scrollTop;
                    rect.left += $dc7ec905e041f51c$var$ghostRelativeParent.scrollLeft;
                } else $dc7ec905e041f51c$var$ghostRelativeParent = $dc7ec905e041f51c$var$getWindowScrollingElement();
                $dc7ec905e041f51c$var$ghostRelativeParentInitialScroll = $dc7ec905e041f51c$var$getRelativeScrollOffset($dc7ec905e041f51c$var$ghostRelativeParent);
            }
            $dc7ec905e041f51c$var$ghostEl = $dc7ec905e041f51c$var$dragEl.cloneNode(true);
            $dc7ec905e041f51c$var$toggleClass($dc7ec905e041f51c$var$ghostEl, options.ghostClass, false);
            $dc7ec905e041f51c$var$toggleClass($dc7ec905e041f51c$var$ghostEl, options.fallbackClass, true);
            $dc7ec905e041f51c$var$toggleClass($dc7ec905e041f51c$var$ghostEl, options.dragClass, true);
            $dc7ec905e041f51c$var$css($dc7ec905e041f51c$var$ghostEl, 'transition', '');
            $dc7ec905e041f51c$var$css($dc7ec905e041f51c$var$ghostEl, 'transform', '');
            $dc7ec905e041f51c$var$css($dc7ec905e041f51c$var$ghostEl, 'box-sizing', 'border-box');
            $dc7ec905e041f51c$var$css($dc7ec905e041f51c$var$ghostEl, 'margin', 0);
            $dc7ec905e041f51c$var$css($dc7ec905e041f51c$var$ghostEl, 'top', rect.top);
            $dc7ec905e041f51c$var$css($dc7ec905e041f51c$var$ghostEl, 'left', rect.left);
            $dc7ec905e041f51c$var$css($dc7ec905e041f51c$var$ghostEl, 'width', rect.width);
            $dc7ec905e041f51c$var$css($dc7ec905e041f51c$var$ghostEl, 'height', rect.height);
            $dc7ec905e041f51c$var$css($dc7ec905e041f51c$var$ghostEl, 'opacity', '0.8');
            $dc7ec905e041f51c$var$css($dc7ec905e041f51c$var$ghostEl, 'position', $dc7ec905e041f51c$var$PositionGhostAbsolutely ? 'absolute' : 'fixed');
            $dc7ec905e041f51c$var$css($dc7ec905e041f51c$var$ghostEl, 'zIndex', '100000');
            $dc7ec905e041f51c$var$css($dc7ec905e041f51c$var$ghostEl, 'pointerEvents', 'none');
            $dc7ec905e041f51c$export$31b3ca70d8f57423.ghost = $dc7ec905e041f51c$var$ghostEl;
            container.appendChild($dc7ec905e041f51c$var$ghostEl);
            // Set transform-origin
            $dc7ec905e041f51c$var$css($dc7ec905e041f51c$var$ghostEl, 'transform-origin', $dc7ec905e041f51c$var$tapDistanceLeft / parseInt($dc7ec905e041f51c$var$ghostEl.style.width) * 100 + '% ' + $dc7ec905e041f51c$var$tapDistanceTop / parseInt($dc7ec905e041f51c$var$ghostEl.style.height) * 100 + '%');
        }
    },
    _onDragStart: function _onDragStart(/**Event*/ evt, /**boolean*/ fallback) {
        var _this = this;
        var dataTransfer = evt.dataTransfer;
        var options = _this.options;
        $dc7ec905e041f51c$var$pluginEvent('dragStart', this, {
            evt: evt
        });
        if ($dc7ec905e041f51c$export$31b3ca70d8f57423.eventCanceled) {
            this._onDrop();
            return;
        }
        $dc7ec905e041f51c$var$pluginEvent('setupClone', this);
        if (!$dc7ec905e041f51c$export$31b3ca70d8f57423.eventCanceled) {
            $dc7ec905e041f51c$var$cloneEl = $dc7ec905e041f51c$var$clone($dc7ec905e041f51c$var$dragEl);
            $dc7ec905e041f51c$var$cloneEl.removeAttribute("id");
            $dc7ec905e041f51c$var$cloneEl.draggable = false;
            $dc7ec905e041f51c$var$cloneEl.style['will-change'] = '';
            this._hideClone();
            $dc7ec905e041f51c$var$toggleClass($dc7ec905e041f51c$var$cloneEl, this.options.chosenClass, false);
            $dc7ec905e041f51c$export$31b3ca70d8f57423.clone = $dc7ec905e041f51c$var$cloneEl;
        }
        // #1143: IFrame support workaround
        _this.cloneId = $dc7ec905e041f51c$var$_nextTick(function() {
            $dc7ec905e041f51c$var$pluginEvent('clone', _this);
            if ($dc7ec905e041f51c$export$31b3ca70d8f57423.eventCanceled) return;
            if (!_this.options.removeCloneOnHide) $dc7ec905e041f51c$var$rootEl.insertBefore($dc7ec905e041f51c$var$cloneEl, $dc7ec905e041f51c$var$dragEl);
            _this._hideClone();
            $dc7ec905e041f51c$var$_dispatchEvent({
                sortable: _this,
                name: 'clone'
            });
        });
        !fallback && $dc7ec905e041f51c$var$toggleClass($dc7ec905e041f51c$var$dragEl, options.dragClass, true);
        // Set proper drop events
        if (fallback) {
            $dc7ec905e041f51c$var$ignoreNextClick = true;
            _this._loopId = setInterval(_this._emulateDragOver, 50);
        } else {
            // Undo what was set in _prepareDragStart before drag started
            $dc7ec905e041f51c$var$off(document, 'mouseup', _this._onDrop);
            $dc7ec905e041f51c$var$off(document, 'touchend', _this._onDrop);
            $dc7ec905e041f51c$var$off(document, 'touchcancel', _this._onDrop);
            if (dataTransfer) {
                dataTransfer.effectAllowed = 'move';
                options.setData && options.setData.call(_this, dataTransfer, $dc7ec905e041f51c$var$dragEl);
            }
            $dc7ec905e041f51c$var$on(document, 'drop', _this);
            // #1276 fix:
            $dc7ec905e041f51c$var$css($dc7ec905e041f51c$var$dragEl, 'transform', 'translateZ(0)');
        }
        $dc7ec905e041f51c$var$awaitingDragStarted = true;
        _this._dragStartId = $dc7ec905e041f51c$var$_nextTick(_this._dragStarted.bind(_this, fallback, evt));
        $dc7ec905e041f51c$var$on(document, 'selectstart', _this);
        $dc7ec905e041f51c$var$moved = true;
        window.getSelection().removeAllRanges();
        if ($dc7ec905e041f51c$var$Safari) $dc7ec905e041f51c$var$css(document.body, 'user-select', 'none');
    },
    // Returns true - if no further action is needed (either inserted or another condition)
    _onDragOver: function _onDragOver(/**Event*/ evt) {
        var el = this.el, target = evt.target, dragRect, targetRect, revert, options = this.options, group = options.group, activeSortable = $dc7ec905e041f51c$export$31b3ca70d8f57423.active, isOwner = $dc7ec905e041f51c$var$activeGroup === group, canSort = options.sort, fromSortable = $dc7ec905e041f51c$var$putSortable || activeSortable, vertical, _this = this, completedFired = false;
        if ($dc7ec905e041f51c$var$_silent) return;
        function dragOverEvent(name, extra) {
            $dc7ec905e041f51c$var$pluginEvent(name, _this, $dc7ec905e041f51c$var$_objectSpread2({
                evt: evt,
                isOwner: isOwner,
                axis: vertical ? 'vertical' : 'horizontal',
                revert: revert,
                dragRect: dragRect,
                targetRect: targetRect,
                canSort: canSort,
                fromSortable: fromSortable,
                target: target,
                completed: completed,
                onMove: function onMove(target, after) {
                    return $dc7ec905e041f51c$var$_onMove($dc7ec905e041f51c$var$rootEl, el, $dc7ec905e041f51c$var$dragEl, dragRect, target, $dc7ec905e041f51c$var$getRect(target), evt, after);
                },
                changed: changed
            }, extra));
        }
        // Capture animation state
        function capture() {
            dragOverEvent('dragOverAnimationCapture');
            _this.captureAnimationState();
            if (_this !== fromSortable) fromSortable.captureAnimationState();
        }
        // Return invocation when dragEl is inserted (or completed)
        function completed(insertion) {
            dragOverEvent('dragOverCompleted', {
                insertion: insertion
            });
            if (insertion) {
                // Clones must be hidden before folding animation to capture dragRectAbsolute properly
                if (isOwner) activeSortable._hideClone();
                else activeSortable._showClone(_this);
                if (_this !== fromSortable) {
                    // Set ghost class to new sortable's ghost class
                    $dc7ec905e041f51c$var$toggleClass($dc7ec905e041f51c$var$dragEl, $dc7ec905e041f51c$var$putSortable ? $dc7ec905e041f51c$var$putSortable.options.ghostClass : activeSortable.options.ghostClass, false);
                    $dc7ec905e041f51c$var$toggleClass($dc7ec905e041f51c$var$dragEl, options.ghostClass, true);
                }
                if ($dc7ec905e041f51c$var$putSortable !== _this && _this !== $dc7ec905e041f51c$export$31b3ca70d8f57423.active) $dc7ec905e041f51c$var$putSortable = _this;
                else if (_this === $dc7ec905e041f51c$export$31b3ca70d8f57423.active && $dc7ec905e041f51c$var$putSortable) $dc7ec905e041f51c$var$putSortable = null;
                // Animation
                if (fromSortable === _this) _this._ignoreWhileAnimating = target;
                _this.animateAll(function() {
                    dragOverEvent('dragOverAnimationComplete');
                    _this._ignoreWhileAnimating = null;
                });
                if (_this !== fromSortable) {
                    fromSortable.animateAll();
                    fromSortable._ignoreWhileAnimating = null;
                }
            }
            // Null lastTarget if it is not inside a previously swapped element
            if (target === $dc7ec905e041f51c$var$dragEl && !$dc7ec905e041f51c$var$dragEl.animated || target === el && !target.animated) $dc7ec905e041f51c$var$lastTarget = null;
            // no bubbling and not fallback
            if (!options.dragoverBubble && !evt.rootEl && target !== document) {
                $dc7ec905e041f51c$var$dragEl.parentNode[$dc7ec905e041f51c$var$expando]._isOutsideThisEl(evt.target);
                // Do not detect for empty insert if already inserted
                !insertion && $dc7ec905e041f51c$var$nearestEmptyInsertDetectEvent(evt);
            }
            !options.dragoverBubble && evt.stopPropagation && evt.stopPropagation();
            return completedFired = true;
        }
        // Call when dragEl has been inserted
        function changed() {
            $dc7ec905e041f51c$var$newIndex = $dc7ec905e041f51c$var$index($dc7ec905e041f51c$var$dragEl);
            $dc7ec905e041f51c$var$newDraggableIndex = $dc7ec905e041f51c$var$index($dc7ec905e041f51c$var$dragEl, options.draggable);
            $dc7ec905e041f51c$var$_dispatchEvent({
                sortable: _this,
                name: 'change',
                toEl: el,
                newIndex: $dc7ec905e041f51c$var$newIndex,
                newDraggableIndex: $dc7ec905e041f51c$var$newDraggableIndex,
                originalEvent: evt
            });
        }
        if (evt.preventDefault !== void 0) evt.cancelable && evt.preventDefault();
        target = $dc7ec905e041f51c$var$closest(target, options.draggable, el, true);
        dragOverEvent('dragOver');
        if ($dc7ec905e041f51c$export$31b3ca70d8f57423.eventCanceled) return completedFired;
        if ($dc7ec905e041f51c$var$dragEl.contains(evt.target) || target.animated && target.animatingX && target.animatingY || _this._ignoreWhileAnimating === target) return completed(false);
        $dc7ec905e041f51c$var$ignoreNextClick = false;
        if (activeSortable && !options.disabled && (isOwner ? canSort || (revert = $dc7ec905e041f51c$var$parentEl !== $dc7ec905e041f51c$var$rootEl // Reverting item into the original list
        ) : $dc7ec905e041f51c$var$putSortable === this || (this.lastPutMode = $dc7ec905e041f51c$var$activeGroup.checkPull(this, activeSortable, $dc7ec905e041f51c$var$dragEl, evt)) && group.checkPut(this, activeSortable, $dc7ec905e041f51c$var$dragEl, evt))) {
            vertical = this._getDirection(evt, target) === 'vertical';
            dragRect = $dc7ec905e041f51c$var$getRect($dc7ec905e041f51c$var$dragEl);
            dragOverEvent('dragOverValid');
            if ($dc7ec905e041f51c$export$31b3ca70d8f57423.eventCanceled) return completedFired;
            if (revert) {
                $dc7ec905e041f51c$var$parentEl = $dc7ec905e041f51c$var$rootEl; // actualization
                capture();
                this._hideClone();
                dragOverEvent('revert');
                if (!$dc7ec905e041f51c$export$31b3ca70d8f57423.eventCanceled) {
                    if ($dc7ec905e041f51c$var$nextEl) $dc7ec905e041f51c$var$rootEl.insertBefore($dc7ec905e041f51c$var$dragEl, $dc7ec905e041f51c$var$nextEl);
                    else $dc7ec905e041f51c$var$rootEl.appendChild($dc7ec905e041f51c$var$dragEl);
                }
                return completed(true);
            }
            var elLastChild = $dc7ec905e041f51c$var$lastChild(el, options.draggable);
            if (!elLastChild || $dc7ec905e041f51c$var$_ghostIsLast(evt, vertical, this) && !elLastChild.animated) {
                // Insert to end of list
                // If already at end of list: Do not insert
                if (elLastChild === $dc7ec905e041f51c$var$dragEl) return completed(false);
                // if there is a last element, it is the target
                if (elLastChild && el === evt.target) target = elLastChild;
                if (target) targetRect = $dc7ec905e041f51c$var$getRect(target);
                if ($dc7ec905e041f51c$var$_onMove($dc7ec905e041f51c$var$rootEl, el, $dc7ec905e041f51c$var$dragEl, dragRect, target, targetRect, evt, !!target) !== false) {
                    capture();
                    if (elLastChild && elLastChild.nextSibling) // the last draggable element is not the last node
                    el.insertBefore($dc7ec905e041f51c$var$dragEl, elLastChild.nextSibling);
                    else el.appendChild($dc7ec905e041f51c$var$dragEl);
                    $dc7ec905e041f51c$var$parentEl = el; // actualization
                    changed();
                    return completed(true);
                }
            } else if (elLastChild && $dc7ec905e041f51c$var$_ghostIsFirst(evt, vertical, this)) {
                // Insert to start of list
                var firstChild = $dc7ec905e041f51c$var$getChild(el, 0, options, true);
                if (firstChild === $dc7ec905e041f51c$var$dragEl) return completed(false);
                target = firstChild;
                targetRect = $dc7ec905e041f51c$var$getRect(target);
                if ($dc7ec905e041f51c$var$_onMove($dc7ec905e041f51c$var$rootEl, el, $dc7ec905e041f51c$var$dragEl, dragRect, target, targetRect, evt, false) !== false) {
                    capture();
                    el.insertBefore($dc7ec905e041f51c$var$dragEl, firstChild);
                    $dc7ec905e041f51c$var$parentEl = el; // actualization
                    changed();
                    return completed(true);
                }
            } else if (target.parentNode === el) {
                targetRect = $dc7ec905e041f51c$var$getRect(target);
                var direction = 0, targetBeforeFirstSwap, differentLevel = $dc7ec905e041f51c$var$dragEl.parentNode !== el, differentRowCol = !$dc7ec905e041f51c$var$_dragElInRowColumn($dc7ec905e041f51c$var$dragEl.animated && $dc7ec905e041f51c$var$dragEl.toRect || dragRect, target.animated && target.toRect || targetRect, vertical), side1 = vertical ? 'top' : 'left', scrolledPastTop = $dc7ec905e041f51c$var$isScrolledPast(target, 'top', 'top') || $dc7ec905e041f51c$var$isScrolledPast($dc7ec905e041f51c$var$dragEl, 'top', 'top'), scrollBefore = scrolledPastTop ? scrolledPastTop.scrollTop : void 0;
                if ($dc7ec905e041f51c$var$lastTarget !== target) {
                    targetBeforeFirstSwap = targetRect[side1];
                    $dc7ec905e041f51c$var$pastFirstInvertThresh = false;
                    $dc7ec905e041f51c$var$isCircumstantialInvert = !differentRowCol && options.invertSwap || differentLevel;
                }
                direction = $dc7ec905e041f51c$var$_getSwapDirection(evt, target, targetRect, vertical, differentRowCol ? 1 : options.swapThreshold, options.invertedSwapThreshold == null ? options.swapThreshold : options.invertedSwapThreshold, $dc7ec905e041f51c$var$isCircumstantialInvert, $dc7ec905e041f51c$var$lastTarget === target);
                var sibling;
                if (direction !== 0) {
                    // Check if target is beside dragEl in respective direction (ignoring hidden elements)
                    var dragIndex = $dc7ec905e041f51c$var$index($dc7ec905e041f51c$var$dragEl);
                    do {
                        dragIndex -= direction;
                        sibling = $dc7ec905e041f51c$var$parentEl.children[dragIndex];
                    }while (sibling && ($dc7ec905e041f51c$var$css(sibling, 'display') === 'none' || sibling === $dc7ec905e041f51c$var$ghostEl));
                }
                // If dragEl is already beside target: Do not insert
                if (direction === 0 || sibling === target) return completed(false);
                $dc7ec905e041f51c$var$lastTarget = target;
                $dc7ec905e041f51c$var$lastDirection = direction;
                var nextSibling = target.nextElementSibling, after = false;
                after = direction === 1;
                var moveVector = $dc7ec905e041f51c$var$_onMove($dc7ec905e041f51c$var$rootEl, el, $dc7ec905e041f51c$var$dragEl, dragRect, target, targetRect, evt, after);
                if (moveVector !== false) {
                    if (moveVector === 1 || moveVector === -1) after = moveVector === 1;
                    $dc7ec905e041f51c$var$_silent = true;
                    setTimeout($dc7ec905e041f51c$var$_unsilent, 30);
                    capture();
                    if (after && !nextSibling) el.appendChild($dc7ec905e041f51c$var$dragEl);
                    else target.parentNode.insertBefore($dc7ec905e041f51c$var$dragEl, after ? nextSibling : target);
                    // Undo chrome's scroll adjustment (has no effect on other browsers)
                    if (scrolledPastTop) $dc7ec905e041f51c$var$scrollBy(scrolledPastTop, 0, scrollBefore - scrolledPastTop.scrollTop);
                    $dc7ec905e041f51c$var$parentEl = $dc7ec905e041f51c$var$dragEl.parentNode; // actualization
                    // must be done before animation
                    if (targetBeforeFirstSwap !== undefined && !$dc7ec905e041f51c$var$isCircumstantialInvert) $dc7ec905e041f51c$var$targetMoveDistance = Math.abs(targetBeforeFirstSwap - $dc7ec905e041f51c$var$getRect(target)[side1]);
                    changed();
                    return completed(true);
                }
            }
            if (el.contains($dc7ec905e041f51c$var$dragEl)) return completed(false);
        }
        return false;
    },
    _ignoreWhileAnimating: null,
    _offMoveEvents: function _offMoveEvents() {
        $dc7ec905e041f51c$var$off(document, 'mousemove', this._onTouchMove);
        $dc7ec905e041f51c$var$off(document, 'touchmove', this._onTouchMove);
        $dc7ec905e041f51c$var$off(document, 'pointermove', this._onTouchMove);
        $dc7ec905e041f51c$var$off(document, 'dragover', $dc7ec905e041f51c$var$nearestEmptyInsertDetectEvent);
        $dc7ec905e041f51c$var$off(document, 'mousemove', $dc7ec905e041f51c$var$nearestEmptyInsertDetectEvent);
        $dc7ec905e041f51c$var$off(document, 'touchmove', $dc7ec905e041f51c$var$nearestEmptyInsertDetectEvent);
    },
    _offUpEvents: function _offUpEvents() {
        var ownerDocument = this.el.ownerDocument;
        $dc7ec905e041f51c$var$off(ownerDocument, 'mouseup', this._onDrop);
        $dc7ec905e041f51c$var$off(ownerDocument, 'touchend', this._onDrop);
        $dc7ec905e041f51c$var$off(ownerDocument, 'pointerup', this._onDrop);
        $dc7ec905e041f51c$var$off(ownerDocument, 'pointercancel', this._onDrop);
        $dc7ec905e041f51c$var$off(ownerDocument, 'touchcancel', this._onDrop);
        $dc7ec905e041f51c$var$off(document, 'selectstart', this);
    },
    _onDrop: function _onDrop(/**Event*/ evt) {
        var el = this.el, options = this.options;
        // Get the index of the dragged element within its parent
        $dc7ec905e041f51c$var$newIndex = $dc7ec905e041f51c$var$index($dc7ec905e041f51c$var$dragEl);
        $dc7ec905e041f51c$var$newDraggableIndex = $dc7ec905e041f51c$var$index($dc7ec905e041f51c$var$dragEl, options.draggable);
        $dc7ec905e041f51c$var$pluginEvent('drop', this, {
            evt: evt
        });
        $dc7ec905e041f51c$var$parentEl = $dc7ec905e041f51c$var$dragEl && $dc7ec905e041f51c$var$dragEl.parentNode;
        // Get again after plugin event
        $dc7ec905e041f51c$var$newIndex = $dc7ec905e041f51c$var$index($dc7ec905e041f51c$var$dragEl);
        $dc7ec905e041f51c$var$newDraggableIndex = $dc7ec905e041f51c$var$index($dc7ec905e041f51c$var$dragEl, options.draggable);
        if ($dc7ec905e041f51c$export$31b3ca70d8f57423.eventCanceled) {
            this._nulling();
            return;
        }
        $dc7ec905e041f51c$var$awaitingDragStarted = false;
        $dc7ec905e041f51c$var$isCircumstantialInvert = false;
        $dc7ec905e041f51c$var$pastFirstInvertThresh = false;
        clearInterval(this._loopId);
        clearTimeout(this._dragStartTimer);
        $dc7ec905e041f51c$var$_cancelNextTick(this.cloneId);
        $dc7ec905e041f51c$var$_cancelNextTick(this._dragStartId);
        // Unbind events
        if (this.nativeDraggable) {
            $dc7ec905e041f51c$var$off(document, 'drop', this);
            $dc7ec905e041f51c$var$off(el, 'dragstart', this._onDragStart);
        }
        this._offMoveEvents();
        this._offUpEvents();
        if ($dc7ec905e041f51c$var$Safari) $dc7ec905e041f51c$var$css(document.body, 'user-select', '');
        $dc7ec905e041f51c$var$css($dc7ec905e041f51c$var$dragEl, 'transform', '');
        if (evt) {
            if ($dc7ec905e041f51c$var$moved) {
                evt.cancelable && evt.preventDefault();
                !options.dropBubble && evt.stopPropagation();
            }
            $dc7ec905e041f51c$var$ghostEl && $dc7ec905e041f51c$var$ghostEl.parentNode && $dc7ec905e041f51c$var$ghostEl.parentNode.removeChild($dc7ec905e041f51c$var$ghostEl);
            if ($dc7ec905e041f51c$var$rootEl === $dc7ec905e041f51c$var$parentEl || $dc7ec905e041f51c$var$putSortable && $dc7ec905e041f51c$var$putSortable.lastPutMode !== 'clone') // Remove clone(s)
            $dc7ec905e041f51c$var$cloneEl && $dc7ec905e041f51c$var$cloneEl.parentNode && $dc7ec905e041f51c$var$cloneEl.parentNode.removeChild($dc7ec905e041f51c$var$cloneEl);
            if ($dc7ec905e041f51c$var$dragEl) {
                if (this.nativeDraggable) $dc7ec905e041f51c$var$off($dc7ec905e041f51c$var$dragEl, 'dragend', this);
                $dc7ec905e041f51c$var$_disableDraggable($dc7ec905e041f51c$var$dragEl);
                $dc7ec905e041f51c$var$dragEl.style['will-change'] = '';
                // Remove classes
                // ghostClass is added in dragStarted
                if ($dc7ec905e041f51c$var$moved && !$dc7ec905e041f51c$var$awaitingDragStarted) $dc7ec905e041f51c$var$toggleClass($dc7ec905e041f51c$var$dragEl, $dc7ec905e041f51c$var$putSortable ? $dc7ec905e041f51c$var$putSortable.options.ghostClass : this.options.ghostClass, false);
                $dc7ec905e041f51c$var$toggleClass($dc7ec905e041f51c$var$dragEl, this.options.chosenClass, false);
                // Drag stop event
                $dc7ec905e041f51c$var$_dispatchEvent({
                    sortable: this,
                    name: 'unchoose',
                    toEl: $dc7ec905e041f51c$var$parentEl,
                    newIndex: null,
                    newDraggableIndex: null,
                    originalEvent: evt
                });
                if ($dc7ec905e041f51c$var$rootEl !== $dc7ec905e041f51c$var$parentEl) {
                    if ($dc7ec905e041f51c$var$newIndex >= 0) {
                        // Add event
                        $dc7ec905e041f51c$var$_dispatchEvent({
                            rootEl: $dc7ec905e041f51c$var$parentEl,
                            name: 'add',
                            toEl: $dc7ec905e041f51c$var$parentEl,
                            fromEl: $dc7ec905e041f51c$var$rootEl,
                            originalEvent: evt
                        });
                        // Remove event
                        $dc7ec905e041f51c$var$_dispatchEvent({
                            sortable: this,
                            name: 'remove',
                            toEl: $dc7ec905e041f51c$var$parentEl,
                            originalEvent: evt
                        });
                        // drag from one list and drop into another
                        $dc7ec905e041f51c$var$_dispatchEvent({
                            rootEl: $dc7ec905e041f51c$var$parentEl,
                            name: 'sort',
                            toEl: $dc7ec905e041f51c$var$parentEl,
                            fromEl: $dc7ec905e041f51c$var$rootEl,
                            originalEvent: evt
                        });
                        $dc7ec905e041f51c$var$_dispatchEvent({
                            sortable: this,
                            name: 'sort',
                            toEl: $dc7ec905e041f51c$var$parentEl,
                            originalEvent: evt
                        });
                    }
                    $dc7ec905e041f51c$var$putSortable && $dc7ec905e041f51c$var$putSortable.save();
                } else {
                    if ($dc7ec905e041f51c$var$newIndex !== $dc7ec905e041f51c$var$oldIndex) {
                        if ($dc7ec905e041f51c$var$newIndex >= 0) {
                            // drag & drop within the same list
                            $dc7ec905e041f51c$var$_dispatchEvent({
                                sortable: this,
                                name: 'update',
                                toEl: $dc7ec905e041f51c$var$parentEl,
                                originalEvent: evt
                            });
                            $dc7ec905e041f51c$var$_dispatchEvent({
                                sortable: this,
                                name: 'sort',
                                toEl: $dc7ec905e041f51c$var$parentEl,
                                originalEvent: evt
                            });
                        }
                    }
                }
                if ($dc7ec905e041f51c$export$31b3ca70d8f57423.active) {
                    /* jshint eqnull:true */ if ($dc7ec905e041f51c$var$newIndex == null || $dc7ec905e041f51c$var$newIndex === -1) {
                        $dc7ec905e041f51c$var$newIndex = $dc7ec905e041f51c$var$oldIndex;
                        $dc7ec905e041f51c$var$newDraggableIndex = $dc7ec905e041f51c$var$oldDraggableIndex;
                    }
                    $dc7ec905e041f51c$var$_dispatchEvent({
                        sortable: this,
                        name: 'end',
                        toEl: $dc7ec905e041f51c$var$parentEl,
                        originalEvent: evt
                    });
                    // Save sorting
                    this.save();
                }
            }
        }
        this._nulling();
    },
    _nulling: function _nulling() {
        $dc7ec905e041f51c$var$pluginEvent('nulling', this);
        $dc7ec905e041f51c$var$rootEl = $dc7ec905e041f51c$var$dragEl = $dc7ec905e041f51c$var$parentEl = $dc7ec905e041f51c$var$ghostEl = $dc7ec905e041f51c$var$nextEl = $dc7ec905e041f51c$var$cloneEl = $dc7ec905e041f51c$var$lastDownEl = $dc7ec905e041f51c$var$cloneHidden = $dc7ec905e041f51c$var$tapEvt = $dc7ec905e041f51c$var$touchEvt = $dc7ec905e041f51c$var$moved = $dc7ec905e041f51c$var$newIndex = $dc7ec905e041f51c$var$newDraggableIndex = $dc7ec905e041f51c$var$oldIndex = $dc7ec905e041f51c$var$oldDraggableIndex = $dc7ec905e041f51c$var$lastTarget = $dc7ec905e041f51c$var$lastDirection = $dc7ec905e041f51c$var$putSortable = $dc7ec905e041f51c$var$activeGroup = $dc7ec905e041f51c$export$31b3ca70d8f57423.dragged = $dc7ec905e041f51c$export$31b3ca70d8f57423.ghost = $dc7ec905e041f51c$export$31b3ca70d8f57423.clone = $dc7ec905e041f51c$export$31b3ca70d8f57423.active = null;
        $dc7ec905e041f51c$var$savedInputChecked.forEach(function(el) {
            el.checked = true;
        });
        $dc7ec905e041f51c$var$savedInputChecked.length = $dc7ec905e041f51c$var$lastDx = $dc7ec905e041f51c$var$lastDy = 0;
    },
    handleEvent: function handleEvent(/**Event*/ evt) {
        switch(evt.type){
            case 'drop':
            case 'dragend':
                this._onDrop(evt);
                break;
            case 'dragenter':
            case 'dragover':
                if ($dc7ec905e041f51c$var$dragEl) {
                    this._onDragOver(evt);
                    $dc7ec905e041f51c$var$_globalDragOver(evt);
                }
                break;
            case 'selectstart':
                evt.preventDefault();
                break;
        }
    },
    /**
   * Serializes the item into an array of string.
   * @returns {String[]}
   */ toArray: function toArray() {
        var order = [], el, children = this.el.children, i = 0, n = children.length, options = this.options;
        for(; i < n; i++){
            el = children[i];
            if ($dc7ec905e041f51c$var$closest(el, options.draggable, this.el, false)) order.push(el.getAttribute(options.dataIdAttr) || $dc7ec905e041f51c$var$_generateId(el));
        }
        return order;
    },
    /**
   * Sorts the elements according to the array.
   * @param  {String[]}  order  order of the items
   */ sort: function sort(order, useAnimation) {
        var items = {}, rootEl = this.el;
        this.toArray().forEach(function(id, i) {
            var el = rootEl.children[i];
            if ($dc7ec905e041f51c$var$closest(el, this.options.draggable, rootEl, false)) items[id] = el;
        }, this);
        useAnimation && this.captureAnimationState();
        order.forEach(function(id) {
            if (items[id]) {
                rootEl.removeChild(items[id]);
                rootEl.appendChild(items[id]);
            }
        });
        useAnimation && this.animateAll();
    },
    /**
   * Save the current sorting
   */ save: function save() {
        var store = this.options.store;
        store && store.set && store.set(this);
    },
    /**
   * For each element in the set, get the first element that matches the selector by testing the element itself and traversing up through its ancestors in the DOM tree.
   * @param   {HTMLElement}  el
   * @param   {String}       [selector]  default: `options.draggable`
   * @returns {HTMLElement|null}
   */ closest: function closest$1(el, selector) {
        return $dc7ec905e041f51c$var$closest(el, selector || this.options.draggable, this.el, false);
    },
    /**
   * Set/get option
   * @param   {string} name
   * @param   {*}      [value]
   * @returns {*}
   */ option: function option(name, value) {
        var options = this.options;
        if (value === void 0) return options[name];
        else {
            var modifiedValue = $dc7ec905e041f51c$var$PluginManager.modifyOption(this, name, value);
            if (typeof modifiedValue !== 'undefined') options[name] = modifiedValue;
            else options[name] = value;
            if (name === 'group') $dc7ec905e041f51c$var$_prepareGroup(options);
        }
    },
    /**
   * Destroy
   */ destroy: function destroy() {
        $dc7ec905e041f51c$var$pluginEvent('destroy', this);
        var el = this.el;
        el[$dc7ec905e041f51c$var$expando] = null;
        $dc7ec905e041f51c$var$off(el, 'mousedown', this._onTapStart);
        $dc7ec905e041f51c$var$off(el, 'touchstart', this._onTapStart);
        $dc7ec905e041f51c$var$off(el, 'pointerdown', this._onTapStart);
        if (this.nativeDraggable) {
            $dc7ec905e041f51c$var$off(el, 'dragover', this);
            $dc7ec905e041f51c$var$off(el, 'dragenter', this);
        }
        // Remove draggable attributes
        Array.prototype.forEach.call(el.querySelectorAll('[draggable]'), function(el) {
            el.removeAttribute('draggable');
        });
        this._onDrop();
        this._disableDelayedDragEvents();
        $dc7ec905e041f51c$var$sortables.splice($dc7ec905e041f51c$var$sortables.indexOf(this.el), 1);
        this.el = el = null;
    },
    _hideClone: function _hideClone() {
        if (!$dc7ec905e041f51c$var$cloneHidden) {
            $dc7ec905e041f51c$var$pluginEvent('hideClone', this);
            if ($dc7ec905e041f51c$export$31b3ca70d8f57423.eventCanceled) return;
            $dc7ec905e041f51c$var$css($dc7ec905e041f51c$var$cloneEl, 'display', 'none');
            if (this.options.removeCloneOnHide && $dc7ec905e041f51c$var$cloneEl.parentNode) $dc7ec905e041f51c$var$cloneEl.parentNode.removeChild($dc7ec905e041f51c$var$cloneEl);
            $dc7ec905e041f51c$var$cloneHidden = true;
        }
    },
    _showClone: function _showClone(putSortable) {
        if (putSortable.lastPutMode !== 'clone') {
            this._hideClone();
            return;
        }
        if ($dc7ec905e041f51c$var$cloneHidden) {
            $dc7ec905e041f51c$var$pluginEvent('showClone', this);
            if ($dc7ec905e041f51c$export$31b3ca70d8f57423.eventCanceled) return;
            // show clone at dragEl or original position
            if ($dc7ec905e041f51c$var$dragEl.parentNode == $dc7ec905e041f51c$var$rootEl && !this.options.group.revertClone) $dc7ec905e041f51c$var$rootEl.insertBefore($dc7ec905e041f51c$var$cloneEl, $dc7ec905e041f51c$var$dragEl);
            else if ($dc7ec905e041f51c$var$nextEl) $dc7ec905e041f51c$var$rootEl.insertBefore($dc7ec905e041f51c$var$cloneEl, $dc7ec905e041f51c$var$nextEl);
            else $dc7ec905e041f51c$var$rootEl.appendChild($dc7ec905e041f51c$var$cloneEl);
            if (this.options.group.revertClone) this.animate($dc7ec905e041f51c$var$dragEl, $dc7ec905e041f51c$var$cloneEl);
            $dc7ec905e041f51c$var$css($dc7ec905e041f51c$var$cloneEl, 'display', '');
            $dc7ec905e041f51c$var$cloneHidden = false;
        }
    }
};
function $dc7ec905e041f51c$var$_globalDragOver(/**Event*/ evt) {
    if (evt.dataTransfer) evt.dataTransfer.dropEffect = 'move';
    evt.cancelable && evt.preventDefault();
}
function $dc7ec905e041f51c$var$_onMove(fromEl, toEl, dragEl, dragRect, targetEl, targetRect, originalEvent, willInsertAfter) {
    var evt, sortable = fromEl[$dc7ec905e041f51c$var$expando], onMoveFn = sortable.options.onMove, retVal;
    // Support for new CustomEvent feature
    if (window.CustomEvent && !$dc7ec905e041f51c$var$IE11OrLess && !$dc7ec905e041f51c$var$Edge) evt = new CustomEvent('move', {
        bubbles: true,
        cancelable: true
    });
    else {
        evt = document.createEvent('Event');
        evt.initEvent('move', true, true);
    }
    evt.to = toEl;
    evt.from = fromEl;
    evt.dragged = dragEl;
    evt.draggedRect = dragRect;
    evt.related = targetEl || toEl;
    evt.relatedRect = targetRect || $dc7ec905e041f51c$var$getRect(toEl);
    evt.willInsertAfter = willInsertAfter;
    evt.originalEvent = originalEvent;
    fromEl.dispatchEvent(evt);
    if (onMoveFn) retVal = onMoveFn.call(sortable, evt, originalEvent);
    return retVal;
}
function $dc7ec905e041f51c$var$_disableDraggable(el) {
    el.draggable = false;
}
function $dc7ec905e041f51c$var$_unsilent() {
    $dc7ec905e041f51c$var$_silent = false;
}
function $dc7ec905e041f51c$var$_ghostIsFirst(evt, vertical, sortable) {
    var firstElRect = $dc7ec905e041f51c$var$getRect($dc7ec905e041f51c$var$getChild(sortable.el, 0, sortable.options, true));
    var childContainingRect = $dc7ec905e041f51c$var$getChildContainingRectFromElement(sortable.el, sortable.options, $dc7ec905e041f51c$var$ghostEl);
    var spacer = 10;
    return vertical ? evt.clientX < childContainingRect.left - spacer || evt.clientY < firstElRect.top && evt.clientX < firstElRect.right : evt.clientY < childContainingRect.top - spacer || evt.clientY < firstElRect.bottom && evt.clientX < firstElRect.left;
}
function $dc7ec905e041f51c$var$_ghostIsLast(evt, vertical, sortable) {
    var lastElRect = $dc7ec905e041f51c$var$getRect($dc7ec905e041f51c$var$lastChild(sortable.el, sortable.options.draggable));
    var childContainingRect = $dc7ec905e041f51c$var$getChildContainingRectFromElement(sortable.el, sortable.options, $dc7ec905e041f51c$var$ghostEl);
    var spacer = 10;
    return vertical ? evt.clientX > childContainingRect.right + spacer || evt.clientY > lastElRect.bottom && evt.clientX > lastElRect.left : evt.clientY > childContainingRect.bottom + spacer || evt.clientX > lastElRect.right && evt.clientY > lastElRect.top;
}
function $dc7ec905e041f51c$var$_getSwapDirection(evt, target, targetRect, vertical, swapThreshold, invertedSwapThreshold, invertSwap, isLastTarget) {
    var mouseOnAxis = vertical ? evt.clientY : evt.clientX, targetLength = vertical ? targetRect.height : targetRect.width, targetS1 = vertical ? targetRect.top : targetRect.left, targetS2 = vertical ? targetRect.bottom : targetRect.right, invert = false;
    if (!invertSwap) {
        // Never invert or create dragEl shadow when target movemenet causes mouse to move past the end of regular swapThreshold
        if (isLastTarget && $dc7ec905e041f51c$var$targetMoveDistance < targetLength * swapThreshold) {
            // multiplied only by swapThreshold because mouse will already be inside target by (1 - threshold) * targetLength / 2
            // check if past first invert threshold on side opposite of lastDirection
            if (!$dc7ec905e041f51c$var$pastFirstInvertThresh && ($dc7ec905e041f51c$var$lastDirection === 1 ? mouseOnAxis > targetS1 + targetLength * invertedSwapThreshold / 2 : mouseOnAxis < targetS2 - targetLength * invertedSwapThreshold / 2)) // past first invert threshold, do not restrict inverted threshold to dragEl shadow
            $dc7ec905e041f51c$var$pastFirstInvertThresh = true;
            if (!$dc7ec905e041f51c$var$pastFirstInvertThresh) {
                // dragEl shadow (target move distance shadow)
                if ($dc7ec905e041f51c$var$lastDirection === 1 ? mouseOnAxis < targetS1 + $dc7ec905e041f51c$var$targetMoveDistance // over dragEl shadow
                 : mouseOnAxis > targetS2 - $dc7ec905e041f51c$var$targetMoveDistance) return -$dc7ec905e041f51c$var$lastDirection;
            } else invert = true;
        } else {
            // Regular
            if (mouseOnAxis > targetS1 + targetLength * (1 - swapThreshold) / 2 && mouseOnAxis < targetS2 - targetLength * (1 - swapThreshold) / 2) return $dc7ec905e041f51c$var$_getInsertDirection(target);
        }
    }
    invert = invert || invertSwap;
    if (invert) {
        // Invert of regular
        if (mouseOnAxis < targetS1 + targetLength * invertedSwapThreshold / 2 || mouseOnAxis > targetS2 - targetLength * invertedSwapThreshold / 2) return mouseOnAxis > targetS1 + targetLength / 2 ? 1 : -1;
    }
    return 0;
}
/**
 * Gets the direction dragEl must be swapped relative to target in order to make it
 * seem that dragEl has been "inserted" into that element's position
 * @param  {HTMLElement} target       The target whose position dragEl is being inserted at
 * @return {Number}                   Direction dragEl must be swapped
 */ function $dc7ec905e041f51c$var$_getInsertDirection(target) {
    if ($dc7ec905e041f51c$var$index($dc7ec905e041f51c$var$dragEl) < $dc7ec905e041f51c$var$index(target)) return 1;
    else return -1;
}
/**
 * Generate id
 * @param   {HTMLElement} el
 * @returns {String}
 * @private
 */ function $dc7ec905e041f51c$var$_generateId(el) {
    var str = el.tagName + el.className + el.src + el.href + el.textContent, i = str.length, sum = 0;
    while(i--)sum += str.charCodeAt(i);
    return sum.toString(36);
}
function $dc7ec905e041f51c$var$_saveInputCheckedState(root) {
    $dc7ec905e041f51c$var$savedInputChecked.length = 0;
    var inputs = root.getElementsByTagName('input');
    var idx = inputs.length;
    while(idx--){
        var el = inputs[idx];
        el.checked && $dc7ec905e041f51c$var$savedInputChecked.push(el);
    }
}
function $dc7ec905e041f51c$var$_nextTick(fn) {
    return setTimeout(fn, 0);
}
function $dc7ec905e041f51c$var$_cancelNextTick(id) {
    return clearTimeout(id);
}
// Fixed #973:
if ($dc7ec905e041f51c$var$documentExists) $dc7ec905e041f51c$var$on(document, 'touchmove', function(evt) {
    if (($dc7ec905e041f51c$export$31b3ca70d8f57423.active || $dc7ec905e041f51c$var$awaitingDragStarted) && evt.cancelable) evt.preventDefault();
});
// Export utils
$dc7ec905e041f51c$export$31b3ca70d8f57423.utils = {
    on: $dc7ec905e041f51c$var$on,
    off: $dc7ec905e041f51c$var$off,
    css: $dc7ec905e041f51c$var$css,
    find: $dc7ec905e041f51c$var$find,
    is: function is(el, selector) {
        return !!$dc7ec905e041f51c$var$closest(el, selector, el, false);
    },
    extend: $dc7ec905e041f51c$var$extend,
    throttle: $dc7ec905e041f51c$var$throttle,
    closest: $dc7ec905e041f51c$var$closest,
    toggleClass: $dc7ec905e041f51c$var$toggleClass,
    clone: $dc7ec905e041f51c$var$clone,
    index: $dc7ec905e041f51c$var$index,
    nextTick: $dc7ec905e041f51c$var$_nextTick,
    cancelNextTick: $dc7ec905e041f51c$var$_cancelNextTick,
    detectDirection: $dc7ec905e041f51c$var$_detectDirection,
    getChild: $dc7ec905e041f51c$var$getChild,
    expando: $dc7ec905e041f51c$var$expando
};
/**
 * Get the Sortable instance of an element
 * @param  {HTMLElement} element The element
 * @return {Sortable|undefined}         The instance of Sortable
 */ $dc7ec905e041f51c$export$31b3ca70d8f57423.get = function(element) {
    return element[$dc7ec905e041f51c$var$expando];
};
/**
 * Mount a plugin to Sortable
 * @param  {...SortablePlugin|SortablePlugin[]} plugins       Plugins being mounted
 */ $dc7ec905e041f51c$export$31b3ca70d8f57423.mount = function() {
    for(var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++)plugins[_key] = arguments[_key];
    if (plugins[0].constructor === Array) plugins = plugins[0];
    plugins.forEach(function(plugin) {
        if (!plugin.prototype || !plugin.prototype.constructor) throw "Sortable: Mounted plugin must be a constructor function, not ".concat(({}).toString.call(plugin));
        if (plugin.utils) $dc7ec905e041f51c$export$31b3ca70d8f57423.utils = $dc7ec905e041f51c$var$_objectSpread2($dc7ec905e041f51c$var$_objectSpread2({}, $dc7ec905e041f51c$export$31b3ca70d8f57423.utils), plugin.utils);
        $dc7ec905e041f51c$var$PluginManager.mount(plugin);
    });
};
/**
 * Create sortable instance
 * @param {HTMLElement}  el
 * @param {Object}      [options]
 */ $dc7ec905e041f51c$export$31b3ca70d8f57423.create = function(el, options) {
    return new $dc7ec905e041f51c$export$31b3ca70d8f57423(el, options);
};
// Export
$dc7ec905e041f51c$export$31b3ca70d8f57423.version = $dc7ec905e041f51c$var$version;
var $dc7ec905e041f51c$var$autoScrolls = [], $dc7ec905e041f51c$var$scrollEl, $dc7ec905e041f51c$var$scrollRootEl, $dc7ec905e041f51c$var$scrolling = false, $dc7ec905e041f51c$var$lastAutoScrollX, $dc7ec905e041f51c$var$lastAutoScrollY, $dc7ec905e041f51c$var$touchEvt$1, $dc7ec905e041f51c$var$pointerElemChangedInterval;
function $dc7ec905e041f51c$var$AutoScrollPlugin() {
    function AutoScroll() {
        this.defaults = {
            scroll: true,
            forceAutoScrollFallback: false,
            scrollSensitivity: 30,
            scrollSpeed: 10,
            bubbleScroll: true
        };
        // Bind all private methods
        for(var fn in this)if (fn.charAt(0) === '_' && typeof this[fn] === 'function') this[fn] = this[fn].bind(this);
    }
    AutoScroll.prototype = {
        dragStarted: function dragStarted(_ref) {
            var originalEvent = _ref.originalEvent;
            if (this.sortable.nativeDraggable) $dc7ec905e041f51c$var$on(document, 'dragover', this._handleAutoScroll);
            else {
                if (this.options.supportPointer) $dc7ec905e041f51c$var$on(document, 'pointermove', this._handleFallbackAutoScroll);
                else if (originalEvent.touches) $dc7ec905e041f51c$var$on(document, 'touchmove', this._handleFallbackAutoScroll);
                else $dc7ec905e041f51c$var$on(document, 'mousemove', this._handleFallbackAutoScroll);
            }
        },
        dragOverCompleted: function dragOverCompleted(_ref2) {
            var originalEvent = _ref2.originalEvent;
            // For when bubbling is canceled and using fallback (fallback 'touchmove' always reached)
            if (!this.options.dragOverBubble && !originalEvent.rootEl) this._handleAutoScroll(originalEvent);
        },
        drop: function drop() {
            if (this.sortable.nativeDraggable) $dc7ec905e041f51c$var$off(document, 'dragover', this._handleAutoScroll);
            else {
                $dc7ec905e041f51c$var$off(document, 'pointermove', this._handleFallbackAutoScroll);
                $dc7ec905e041f51c$var$off(document, 'touchmove', this._handleFallbackAutoScroll);
                $dc7ec905e041f51c$var$off(document, 'mousemove', this._handleFallbackAutoScroll);
            }
            $dc7ec905e041f51c$var$clearPointerElemChangedInterval();
            $dc7ec905e041f51c$var$clearAutoScrolls();
            $dc7ec905e041f51c$var$cancelThrottle();
        },
        nulling: function nulling() {
            $dc7ec905e041f51c$var$touchEvt$1 = $dc7ec905e041f51c$var$scrollRootEl = $dc7ec905e041f51c$var$scrollEl = $dc7ec905e041f51c$var$scrolling = $dc7ec905e041f51c$var$pointerElemChangedInterval = $dc7ec905e041f51c$var$lastAutoScrollX = $dc7ec905e041f51c$var$lastAutoScrollY = null;
            $dc7ec905e041f51c$var$autoScrolls.length = 0;
        },
        _handleFallbackAutoScroll: function _handleFallbackAutoScroll(evt) {
            this._handleAutoScroll(evt, true);
        },
        _handleAutoScroll: function _handleAutoScroll(evt, fallback) {
            var _this = this;
            var x = (evt.touches ? evt.touches[0] : evt).clientX, y = (evt.touches ? evt.touches[0] : evt).clientY, elem = document.elementFromPoint(x, y);
            $dc7ec905e041f51c$var$touchEvt$1 = evt;
            // IE does not seem to have native autoscroll,
            // Edge's autoscroll seems too conditional,
            // MACOS Safari does not have autoscroll,
            // Firefox and Chrome are good
            if (fallback || this.options.forceAutoScrollFallback || $dc7ec905e041f51c$var$Edge || $dc7ec905e041f51c$var$IE11OrLess || $dc7ec905e041f51c$var$Safari) {
                $dc7ec905e041f51c$var$autoScroll(evt, this.options, elem, fallback);
                // Listener for pointer element change
                var ogElemScroller = $dc7ec905e041f51c$var$getParentAutoScrollElement(elem, true);
                if ($dc7ec905e041f51c$var$scrolling && (!$dc7ec905e041f51c$var$pointerElemChangedInterval || x !== $dc7ec905e041f51c$var$lastAutoScrollX || y !== $dc7ec905e041f51c$var$lastAutoScrollY)) {
                    $dc7ec905e041f51c$var$pointerElemChangedInterval && $dc7ec905e041f51c$var$clearPointerElemChangedInterval();
                    // Detect for pointer elem change, emulating native DnD behaviour
                    $dc7ec905e041f51c$var$pointerElemChangedInterval = setInterval(function() {
                        var newElem = $dc7ec905e041f51c$var$getParentAutoScrollElement(document.elementFromPoint(x, y), true);
                        if (newElem !== ogElemScroller) {
                            ogElemScroller = newElem;
                            $dc7ec905e041f51c$var$clearAutoScrolls();
                        }
                        $dc7ec905e041f51c$var$autoScroll(evt, _this.options, newElem, fallback);
                    }, 10);
                    $dc7ec905e041f51c$var$lastAutoScrollX = x;
                    $dc7ec905e041f51c$var$lastAutoScrollY = y;
                }
            } else {
                // if DnD is enabled (and browser has good autoscrolling), first autoscroll will already scroll, so get parent autoscroll of first autoscroll
                if (!this.options.bubbleScroll || $dc7ec905e041f51c$var$getParentAutoScrollElement(elem, true) === $dc7ec905e041f51c$var$getWindowScrollingElement()) {
                    $dc7ec905e041f51c$var$clearAutoScrolls();
                    return;
                }
                $dc7ec905e041f51c$var$autoScroll(evt, this.options, $dc7ec905e041f51c$var$getParentAutoScrollElement(elem, false), false);
            }
        }
    };
    return $dc7ec905e041f51c$var$_extends(AutoScroll, {
        pluginName: 'scroll',
        initializeByDefault: true
    });
}
function $dc7ec905e041f51c$var$clearAutoScrolls() {
    $dc7ec905e041f51c$var$autoScrolls.forEach(function(autoScroll) {
        clearInterval(autoScroll.pid);
    });
    $dc7ec905e041f51c$var$autoScrolls = [];
}
function $dc7ec905e041f51c$var$clearPointerElemChangedInterval() {
    clearInterval($dc7ec905e041f51c$var$pointerElemChangedInterval);
}
var $dc7ec905e041f51c$var$autoScroll = $dc7ec905e041f51c$var$throttle(function(evt, options, rootEl, isFallback) {
    // Bug: https://bugzilla.mozilla.org/show_bug.cgi?id=505521
    if (!options.scroll) return;
    var x = (evt.touches ? evt.touches[0] : evt).clientX, y = (evt.touches ? evt.touches[0] : evt).clientY, sens = options.scrollSensitivity, speed = options.scrollSpeed, winScroller = $dc7ec905e041f51c$var$getWindowScrollingElement();
    var scrollThisInstance = false, scrollCustomFn;
    // New scroll root, set scrollEl
    if ($dc7ec905e041f51c$var$scrollRootEl !== rootEl) {
        $dc7ec905e041f51c$var$scrollRootEl = rootEl;
        $dc7ec905e041f51c$var$clearAutoScrolls();
        $dc7ec905e041f51c$var$scrollEl = options.scroll;
        scrollCustomFn = options.scrollFn;
        if ($dc7ec905e041f51c$var$scrollEl === true) $dc7ec905e041f51c$var$scrollEl = $dc7ec905e041f51c$var$getParentAutoScrollElement(rootEl, true);
    }
    var layersOut = 0;
    var currentParent = $dc7ec905e041f51c$var$scrollEl;
    do {
        var el = currentParent, rect = $dc7ec905e041f51c$var$getRect(el), top = rect.top, bottom = rect.bottom, left = rect.left, right = rect.right, width = rect.width, height = rect.height, canScrollX = void 0, canScrollY = void 0, scrollWidth = el.scrollWidth, scrollHeight = el.scrollHeight, elCSS = $dc7ec905e041f51c$var$css(el), scrollPosX = el.scrollLeft, scrollPosY = el.scrollTop;
        if (el === winScroller) {
            canScrollX = width < scrollWidth && (elCSS.overflowX === 'auto' || elCSS.overflowX === 'scroll' || elCSS.overflowX === 'visible');
            canScrollY = height < scrollHeight && (elCSS.overflowY === 'auto' || elCSS.overflowY === 'scroll' || elCSS.overflowY === 'visible');
        } else {
            canScrollX = width < scrollWidth && (elCSS.overflowX === 'auto' || elCSS.overflowX === 'scroll');
            canScrollY = height < scrollHeight && (elCSS.overflowY === 'auto' || elCSS.overflowY === 'scroll');
        }
        var vx = canScrollX && (Math.abs(right - x) <= sens && scrollPosX + width < scrollWidth) - (Math.abs(left - x) <= sens && !!scrollPosX);
        var vy = canScrollY && (Math.abs(bottom - y) <= sens && scrollPosY + height < scrollHeight) - (Math.abs(top - y) <= sens && !!scrollPosY);
        if (!$dc7ec905e041f51c$var$autoScrolls[layersOut]) {
            for(var i = 0; i <= layersOut; i++)if (!$dc7ec905e041f51c$var$autoScrolls[i]) $dc7ec905e041f51c$var$autoScrolls[i] = {};
        }
        if ($dc7ec905e041f51c$var$autoScrolls[layersOut].vx != vx || $dc7ec905e041f51c$var$autoScrolls[layersOut].vy != vy || $dc7ec905e041f51c$var$autoScrolls[layersOut].el !== el) {
            $dc7ec905e041f51c$var$autoScrolls[layersOut].el = el;
            $dc7ec905e041f51c$var$autoScrolls[layersOut].vx = vx;
            $dc7ec905e041f51c$var$autoScrolls[layersOut].vy = vy;
            clearInterval($dc7ec905e041f51c$var$autoScrolls[layersOut].pid);
            if (vx != 0 || vy != 0) {
                scrollThisInstance = true;
                /* jshint loopfunc:true */ $dc7ec905e041f51c$var$autoScrolls[layersOut].pid = setInterval((function() {
                    // emulate drag over during autoscroll (fallback), emulating native DnD behaviour
                    if (isFallback && this.layer === 0) $dc7ec905e041f51c$export$31b3ca70d8f57423.active._onTouchMove($dc7ec905e041f51c$var$touchEvt$1); // To move ghost if it is positioned absolutely
                    var scrollOffsetY = $dc7ec905e041f51c$var$autoScrolls[this.layer].vy ? $dc7ec905e041f51c$var$autoScrolls[this.layer].vy * speed : 0;
                    var scrollOffsetX = $dc7ec905e041f51c$var$autoScrolls[this.layer].vx ? $dc7ec905e041f51c$var$autoScrolls[this.layer].vx * speed : 0;
                    if (typeof scrollCustomFn === 'function') {
                        if (scrollCustomFn.call($dc7ec905e041f51c$export$31b3ca70d8f57423.dragged.parentNode[$dc7ec905e041f51c$var$expando], scrollOffsetX, scrollOffsetY, evt, $dc7ec905e041f51c$var$touchEvt$1, $dc7ec905e041f51c$var$autoScrolls[this.layer].el) !== 'continue') return;
                    }
                    $dc7ec905e041f51c$var$scrollBy($dc7ec905e041f51c$var$autoScrolls[this.layer].el, scrollOffsetX, scrollOffsetY);
                }).bind({
                    layer: layersOut
                }), 24);
            }
        }
        layersOut++;
    }while (options.bubbleScroll && currentParent !== winScroller && (currentParent = $dc7ec905e041f51c$var$getParentAutoScrollElement(currentParent, false)));
    $dc7ec905e041f51c$var$scrolling = scrollThisInstance; // in case another function catches scrolling as false in between when it is not
}, 30);
var $dc7ec905e041f51c$var$drop = function drop(_ref) {
    var originalEvent = _ref.originalEvent, putSortable = _ref.putSortable, dragEl = _ref.dragEl, activeSortable = _ref.activeSortable, dispatchSortableEvent = _ref.dispatchSortableEvent, hideGhostForTarget = _ref.hideGhostForTarget, unhideGhostForTarget = _ref.unhideGhostForTarget;
    if (!originalEvent) return;
    var toSortable = putSortable || activeSortable;
    hideGhostForTarget();
    var touch = originalEvent.changedTouches && originalEvent.changedTouches.length ? originalEvent.changedTouches[0] : originalEvent;
    var target = document.elementFromPoint(touch.clientX, touch.clientY);
    unhideGhostForTarget();
    if (toSortable && !toSortable.el.contains(target)) {
        dispatchSortableEvent('spill');
        this.onSpill({
            dragEl: dragEl,
            putSortable: putSortable
        });
    }
};
function $dc7ec905e041f51c$var$Revert() {}
$dc7ec905e041f51c$var$Revert.prototype = {
    startIndex: null,
    dragStart: function dragStart(_ref2) {
        var oldDraggableIndex = _ref2.oldDraggableIndex;
        this.startIndex = oldDraggableIndex;
    },
    onSpill: function onSpill(_ref3) {
        var dragEl = _ref3.dragEl, putSortable = _ref3.putSortable;
        this.sortable.captureAnimationState();
        if (putSortable) putSortable.captureAnimationState();
        var nextSibling = $dc7ec905e041f51c$var$getChild(this.sortable.el, this.startIndex, this.options);
        if (nextSibling) this.sortable.el.insertBefore(dragEl, nextSibling);
        else this.sortable.el.appendChild(dragEl);
        this.sortable.animateAll();
        if (putSortable) putSortable.animateAll();
    },
    drop: $dc7ec905e041f51c$var$drop
};
$dc7ec905e041f51c$var$_extends($dc7ec905e041f51c$var$Revert, {
    pluginName: 'revertOnSpill'
});
function $dc7ec905e041f51c$var$Remove() {}
$dc7ec905e041f51c$var$Remove.prototype = {
    onSpill: function onSpill(_ref4) {
        var dragEl = _ref4.dragEl, putSortable = _ref4.putSortable;
        var parentSortable = putSortable || this.sortable;
        parentSortable.captureAnimationState();
        dragEl.parentNode && dragEl.parentNode.removeChild(dragEl);
        parentSortable.animateAll();
    },
    drop: $dc7ec905e041f51c$var$drop
};
$dc7ec905e041f51c$var$_extends($dc7ec905e041f51c$var$Remove, {
    pluginName: 'removeOnSpill'
});
var $dc7ec905e041f51c$var$lastSwapEl;
function $dc7ec905e041f51c$export$bdb5f0a1b77546f4() {
    function Swap() {
        this.defaults = {
            swapClass: 'sortable-swap-highlight'
        };
    }
    Swap.prototype = {
        dragStart: function dragStart(_ref) {
            var dragEl = _ref.dragEl;
            $dc7ec905e041f51c$var$lastSwapEl = dragEl;
        },
        dragOverValid: function dragOverValid(_ref2) {
            var completed = _ref2.completed, target = _ref2.target, onMove = _ref2.onMove, activeSortable = _ref2.activeSortable, changed = _ref2.changed, cancel = _ref2.cancel;
            if (!activeSortable.options.swap) return;
            var el = this.sortable.el, options = this.options;
            if (target && target !== el) {
                var prevSwapEl = $dc7ec905e041f51c$var$lastSwapEl;
                if (onMove(target) !== false) {
                    $dc7ec905e041f51c$var$toggleClass(target, options.swapClass, true);
                    $dc7ec905e041f51c$var$lastSwapEl = target;
                } else $dc7ec905e041f51c$var$lastSwapEl = null;
                if (prevSwapEl && prevSwapEl !== $dc7ec905e041f51c$var$lastSwapEl) $dc7ec905e041f51c$var$toggleClass(prevSwapEl, options.swapClass, false);
            }
            changed();
            completed(true);
            cancel();
        },
        drop: function drop(_ref3) {
            var activeSortable = _ref3.activeSortable, putSortable = _ref3.putSortable, dragEl = _ref3.dragEl;
            var toSortable = putSortable || this.sortable;
            var options = this.options;
            $dc7ec905e041f51c$var$lastSwapEl && $dc7ec905e041f51c$var$toggleClass($dc7ec905e041f51c$var$lastSwapEl, options.swapClass, false);
            if ($dc7ec905e041f51c$var$lastSwapEl && (options.swap || putSortable && putSortable.options.swap)) {
                if (dragEl !== $dc7ec905e041f51c$var$lastSwapEl) {
                    toSortable.captureAnimationState();
                    if (toSortable !== activeSortable) activeSortable.captureAnimationState();
                    $dc7ec905e041f51c$var$swapNodes(dragEl, $dc7ec905e041f51c$var$lastSwapEl);
                    toSortable.animateAll();
                    if (toSortable !== activeSortable) activeSortable.animateAll();
                }
            }
        },
        nulling: function nulling() {
            $dc7ec905e041f51c$var$lastSwapEl = null;
        }
    };
    return $dc7ec905e041f51c$var$_extends(Swap, {
        pluginName: 'swap',
        eventProperties: function eventProperties() {
            return {
                swapItem: $dc7ec905e041f51c$var$lastSwapEl
            };
        }
    });
}
function $dc7ec905e041f51c$var$swapNodes(n1, n2) {
    var p1 = n1.parentNode, p2 = n2.parentNode, i1, i2;
    if (!p1 || !p2 || p1.isEqualNode(n2) || p2.isEqualNode(n1)) return;
    i1 = $dc7ec905e041f51c$var$index(n1);
    i2 = $dc7ec905e041f51c$var$index(n2);
    if (p1.isEqualNode(p2) && i1 < i2) i2++;
    p1.insertBefore(n2, p1.children[i1]);
    p2.insertBefore(n1, p2.children[i2]);
}
var $dc7ec905e041f51c$var$multiDragElements = [], $dc7ec905e041f51c$var$multiDragClones = [], $dc7ec905e041f51c$var$lastMultiDragSelect, // for selection with modifier key down (SHIFT)
$dc7ec905e041f51c$var$multiDragSortable, $dc7ec905e041f51c$var$initialFolding = false, // Initial multi-drag fold when drag started
$dc7ec905e041f51c$var$folding = false, // Folding any other time
$dc7ec905e041f51c$var$dragStarted = false, $dc7ec905e041f51c$var$dragEl$1, $dc7ec905e041f51c$var$clonesFromRect, $dc7ec905e041f51c$var$clonesHidden;
function $dc7ec905e041f51c$export$18e5d2a5d1df842d() {
    function MultiDrag(sortable) {
        // Bind all private methods
        for(var fn in this)if (fn.charAt(0) === '_' && typeof this[fn] === 'function') this[fn] = this[fn].bind(this);
        if (!sortable.options.avoidImplicitDeselect) {
            if (sortable.options.supportPointer) $dc7ec905e041f51c$var$on(document, 'pointerup', this._deselectMultiDrag);
            else {
                $dc7ec905e041f51c$var$on(document, 'mouseup', this._deselectMultiDrag);
                $dc7ec905e041f51c$var$on(document, 'touchend', this._deselectMultiDrag);
            }
        }
        $dc7ec905e041f51c$var$on(document, 'keydown', this._checkKeyDown);
        $dc7ec905e041f51c$var$on(document, 'keyup', this._checkKeyUp);
        this.defaults = {
            selectedClass: 'sortable-selected',
            multiDragKey: null,
            avoidImplicitDeselect: false,
            setData: function setData(dataTransfer, dragEl) {
                var data = '';
                if ($dc7ec905e041f51c$var$multiDragElements.length && $dc7ec905e041f51c$var$multiDragSortable === sortable) $dc7ec905e041f51c$var$multiDragElements.forEach(function(multiDragElement, i) {
                    data += (!i ? '' : ', ') + multiDragElement.textContent;
                });
                else data = dragEl.textContent;
                dataTransfer.setData('Text', data);
            }
        };
    }
    MultiDrag.prototype = {
        multiDragKeyDown: false,
        isMultiDrag: false,
        delayStartGlobal: function delayStartGlobal(_ref) {
            var dragged = _ref.dragEl;
            $dc7ec905e041f51c$var$dragEl$1 = dragged;
        },
        delayEnded: function delayEnded() {
            this.isMultiDrag = ~$dc7ec905e041f51c$var$multiDragElements.indexOf($dc7ec905e041f51c$var$dragEl$1);
        },
        setupClone: function setupClone(_ref2) {
            var sortable = _ref2.sortable, cancel = _ref2.cancel;
            if (!this.isMultiDrag) return;
            for(var i = 0; i < $dc7ec905e041f51c$var$multiDragElements.length; i++){
                $dc7ec905e041f51c$var$multiDragClones.push($dc7ec905e041f51c$var$clone($dc7ec905e041f51c$var$multiDragElements[i]));
                $dc7ec905e041f51c$var$multiDragClones[i].sortableIndex = $dc7ec905e041f51c$var$multiDragElements[i].sortableIndex;
                $dc7ec905e041f51c$var$multiDragClones[i].draggable = false;
                $dc7ec905e041f51c$var$multiDragClones[i].style['will-change'] = '';
                $dc7ec905e041f51c$var$toggleClass($dc7ec905e041f51c$var$multiDragClones[i], this.options.selectedClass, false);
                $dc7ec905e041f51c$var$multiDragElements[i] === $dc7ec905e041f51c$var$dragEl$1 && $dc7ec905e041f51c$var$toggleClass($dc7ec905e041f51c$var$multiDragClones[i], this.options.chosenClass, false);
            }
            sortable._hideClone();
            cancel();
        },
        clone: function clone(_ref3) {
            var sortable = _ref3.sortable, rootEl = _ref3.rootEl, dispatchSortableEvent = _ref3.dispatchSortableEvent, cancel = _ref3.cancel;
            if (!this.isMultiDrag) return;
            if (!this.options.removeCloneOnHide) {
                if ($dc7ec905e041f51c$var$multiDragElements.length && $dc7ec905e041f51c$var$multiDragSortable === sortable) {
                    $dc7ec905e041f51c$var$insertMultiDragClones(true, rootEl);
                    dispatchSortableEvent('clone');
                    cancel();
                }
            }
        },
        showClone: function showClone(_ref4) {
            var cloneNowShown = _ref4.cloneNowShown, rootEl = _ref4.rootEl, cancel = _ref4.cancel;
            if (!this.isMultiDrag) return;
            $dc7ec905e041f51c$var$insertMultiDragClones(false, rootEl);
            $dc7ec905e041f51c$var$multiDragClones.forEach(function(clone) {
                $dc7ec905e041f51c$var$css(clone, 'display', '');
            });
            cloneNowShown();
            $dc7ec905e041f51c$var$clonesHidden = false;
            cancel();
        },
        hideClone: function hideClone(_ref5) {
            var _this = this;
            var sortable = _ref5.sortable, cloneNowHidden = _ref5.cloneNowHidden, cancel = _ref5.cancel;
            if (!this.isMultiDrag) return;
            $dc7ec905e041f51c$var$multiDragClones.forEach(function(clone) {
                $dc7ec905e041f51c$var$css(clone, 'display', 'none');
                if (_this.options.removeCloneOnHide && clone.parentNode) clone.parentNode.removeChild(clone);
            });
            cloneNowHidden();
            $dc7ec905e041f51c$var$clonesHidden = true;
            cancel();
        },
        dragStartGlobal: function dragStartGlobal(_ref6) {
            var sortable = _ref6.sortable;
            if (!this.isMultiDrag && $dc7ec905e041f51c$var$multiDragSortable) $dc7ec905e041f51c$var$multiDragSortable.multiDrag._deselectMultiDrag();
            $dc7ec905e041f51c$var$multiDragElements.forEach(function(multiDragElement) {
                multiDragElement.sortableIndex = $dc7ec905e041f51c$var$index(multiDragElement);
            });
            // Sort multi-drag elements
            $dc7ec905e041f51c$var$multiDragElements = $dc7ec905e041f51c$var$multiDragElements.sort(function(a, b) {
                return a.sortableIndex - b.sortableIndex;
            });
            $dc7ec905e041f51c$var$dragStarted = true;
        },
        dragStarted: function dragStarted(_ref7) {
            var _this2 = this;
            var sortable = _ref7.sortable;
            if (!this.isMultiDrag) return;
            if (this.options.sort) {
                // Capture rects,
                // hide multi drag elements (by positioning them absolute),
                // set multi drag elements rects to dragRect,
                // show multi drag elements,
                // animate to rects,
                // unset rects & remove from DOM
                sortable.captureAnimationState();
                if (this.options.animation) {
                    $dc7ec905e041f51c$var$multiDragElements.forEach(function(multiDragElement) {
                        if (multiDragElement === $dc7ec905e041f51c$var$dragEl$1) return;
                        $dc7ec905e041f51c$var$css(multiDragElement, 'position', 'absolute');
                    });
                    var dragRect = $dc7ec905e041f51c$var$getRect($dc7ec905e041f51c$var$dragEl$1, false, true, true);
                    $dc7ec905e041f51c$var$multiDragElements.forEach(function(multiDragElement) {
                        if (multiDragElement === $dc7ec905e041f51c$var$dragEl$1) return;
                        $dc7ec905e041f51c$var$setRect(multiDragElement, dragRect);
                    });
                    $dc7ec905e041f51c$var$folding = true;
                    $dc7ec905e041f51c$var$initialFolding = true;
                }
            }
            sortable.animateAll(function() {
                $dc7ec905e041f51c$var$folding = false;
                $dc7ec905e041f51c$var$initialFolding = false;
                if (_this2.options.animation) $dc7ec905e041f51c$var$multiDragElements.forEach(function(multiDragElement) {
                    $dc7ec905e041f51c$var$unsetRect(multiDragElement);
                });
                // Remove all auxiliary multidrag items from el, if sorting enabled
                if (_this2.options.sort) $dc7ec905e041f51c$var$removeMultiDragElements();
            });
        },
        dragOver: function dragOver(_ref8) {
            var target = _ref8.target, completed = _ref8.completed, cancel = _ref8.cancel;
            if ($dc7ec905e041f51c$var$folding && ~$dc7ec905e041f51c$var$multiDragElements.indexOf(target)) {
                completed(false);
                cancel();
            }
        },
        revert: function revert(_ref9) {
            var fromSortable = _ref9.fromSortable, rootEl = _ref9.rootEl, sortable = _ref9.sortable, dragRect = _ref9.dragRect;
            if ($dc7ec905e041f51c$var$multiDragElements.length > 1) {
                // Setup unfold animation
                $dc7ec905e041f51c$var$multiDragElements.forEach(function(multiDragElement) {
                    sortable.addAnimationState({
                        target: multiDragElement,
                        rect: $dc7ec905e041f51c$var$folding ? $dc7ec905e041f51c$var$getRect(multiDragElement) : dragRect
                    });
                    $dc7ec905e041f51c$var$unsetRect(multiDragElement);
                    multiDragElement.fromRect = dragRect;
                    fromSortable.removeAnimationState(multiDragElement);
                });
                $dc7ec905e041f51c$var$folding = false;
                $dc7ec905e041f51c$var$insertMultiDragElements(!this.options.removeCloneOnHide, rootEl);
            }
        },
        dragOverCompleted: function dragOverCompleted(_ref10) {
            var sortable = _ref10.sortable, isOwner = _ref10.isOwner, insertion = _ref10.insertion, activeSortable = _ref10.activeSortable, parentEl = _ref10.parentEl, putSortable = _ref10.putSortable;
            var options = this.options;
            if (insertion) {
                // Clones must be hidden before folding animation to capture dragRectAbsolute properly
                if (isOwner) activeSortable._hideClone();
                $dc7ec905e041f51c$var$initialFolding = false;
                // If leaving sort:false root, or already folding - Fold to new location
                if (options.animation && $dc7ec905e041f51c$var$multiDragElements.length > 1 && ($dc7ec905e041f51c$var$folding || !isOwner && !activeSortable.options.sort && !putSortable)) {
                    // Fold: Set all multi drag elements's rects to dragEl's rect when multi-drag elements are invisible
                    var dragRectAbsolute = $dc7ec905e041f51c$var$getRect($dc7ec905e041f51c$var$dragEl$1, false, true, true);
                    $dc7ec905e041f51c$var$multiDragElements.forEach(function(multiDragElement) {
                        if (multiDragElement === $dc7ec905e041f51c$var$dragEl$1) return;
                        $dc7ec905e041f51c$var$setRect(multiDragElement, dragRectAbsolute);
                        // Move element(s) to end of parentEl so that it does not interfere with multi-drag clones insertion if they are inserted
                        // while folding, and so that we can capture them again because old sortable will no longer be fromSortable
                        parentEl.appendChild(multiDragElement);
                    });
                    $dc7ec905e041f51c$var$folding = true;
                }
                // Clones must be shown (and check to remove multi drags) after folding when interfering multiDragElements are moved out
                if (!isOwner) {
                    // Only remove if not folding (folding will remove them anyways)
                    if (!$dc7ec905e041f51c$var$folding) $dc7ec905e041f51c$var$removeMultiDragElements();
                    if ($dc7ec905e041f51c$var$multiDragElements.length > 1) {
                        var clonesHiddenBefore = $dc7ec905e041f51c$var$clonesHidden;
                        activeSortable._showClone(sortable);
                        // Unfold animation for clones if showing from hidden
                        if (activeSortable.options.animation && !$dc7ec905e041f51c$var$clonesHidden && clonesHiddenBefore) $dc7ec905e041f51c$var$multiDragClones.forEach(function(clone) {
                            activeSortable.addAnimationState({
                                target: clone,
                                rect: $dc7ec905e041f51c$var$clonesFromRect
                            });
                            clone.fromRect = $dc7ec905e041f51c$var$clonesFromRect;
                            clone.thisAnimationDuration = null;
                        });
                    } else activeSortable._showClone(sortable);
                }
            }
        },
        dragOverAnimationCapture: function dragOverAnimationCapture(_ref11) {
            var dragRect = _ref11.dragRect, isOwner = _ref11.isOwner, activeSortable = _ref11.activeSortable;
            $dc7ec905e041f51c$var$multiDragElements.forEach(function(multiDragElement) {
                multiDragElement.thisAnimationDuration = null;
            });
            if (activeSortable.options.animation && !isOwner && activeSortable.multiDrag.isMultiDrag) {
                $dc7ec905e041f51c$var$clonesFromRect = $dc7ec905e041f51c$var$_extends({}, dragRect);
                var dragMatrix = $dc7ec905e041f51c$var$matrix($dc7ec905e041f51c$var$dragEl$1, true);
                $dc7ec905e041f51c$var$clonesFromRect.top -= dragMatrix.f;
                $dc7ec905e041f51c$var$clonesFromRect.left -= dragMatrix.e;
            }
        },
        dragOverAnimationComplete: function dragOverAnimationComplete() {
            if ($dc7ec905e041f51c$var$folding) {
                $dc7ec905e041f51c$var$folding = false;
                $dc7ec905e041f51c$var$removeMultiDragElements();
            }
        },
        drop: function drop(_ref12) {
            var evt = _ref12.originalEvent, rootEl = _ref12.rootEl, parentEl = _ref12.parentEl, sortable = _ref12.sortable, dispatchSortableEvent = _ref12.dispatchSortableEvent, oldIndex = _ref12.oldIndex, putSortable = _ref12.putSortable;
            var toSortable = putSortable || this.sortable;
            if (!evt) return;
            var options = this.options, children = parentEl.children;
            // Multi-drag selection
            if (!$dc7ec905e041f51c$var$dragStarted) {
                if (options.multiDragKey && !this.multiDragKeyDown) this._deselectMultiDrag();
                $dc7ec905e041f51c$var$toggleClass($dc7ec905e041f51c$var$dragEl$1, options.selectedClass, !~$dc7ec905e041f51c$var$multiDragElements.indexOf($dc7ec905e041f51c$var$dragEl$1));
                if (!~$dc7ec905e041f51c$var$multiDragElements.indexOf($dc7ec905e041f51c$var$dragEl$1)) {
                    $dc7ec905e041f51c$var$multiDragElements.push($dc7ec905e041f51c$var$dragEl$1);
                    $dc7ec905e041f51c$var$dispatchEvent({
                        sortable: sortable,
                        rootEl: rootEl,
                        name: 'select',
                        targetEl: $dc7ec905e041f51c$var$dragEl$1,
                        originalEvent: evt
                    });
                    // Modifier activated, select from last to dragEl
                    if (evt.shiftKey && $dc7ec905e041f51c$var$lastMultiDragSelect && sortable.el.contains($dc7ec905e041f51c$var$lastMultiDragSelect)) {
                        var lastIndex = $dc7ec905e041f51c$var$index($dc7ec905e041f51c$var$lastMultiDragSelect), currentIndex = $dc7ec905e041f51c$var$index($dc7ec905e041f51c$var$dragEl$1);
                        if (~lastIndex && ~currentIndex && lastIndex !== currentIndex) (function() {
                            // Must include lastMultiDragSelect (select it), in case modified selection from no selection
                            // (but previous selection existed)
                            var n, i;
                            if (currentIndex > lastIndex) {
                                i = lastIndex;
                                n = currentIndex;
                            } else {
                                i = currentIndex;
                                n = lastIndex + 1;
                            }
                            var filter = options.filter;
                            for(; i < n; i++){
                                if (~$dc7ec905e041f51c$var$multiDragElements.indexOf(children[i])) continue;
                                // Check if element is draggable
                                if (!$dc7ec905e041f51c$var$closest(children[i], options.draggable, parentEl, false)) continue;
                                // Check if element is filtered
                                var filtered = filter && (typeof filter === 'function' ? filter.call(sortable, evt, children[i], sortable) : filter.split(',').some(function(criteria) {
                                    return $dc7ec905e041f51c$var$closest(children[i], criteria.trim(), parentEl, false);
                                }));
                                if (filtered) continue;
                                $dc7ec905e041f51c$var$toggleClass(children[i], options.selectedClass, true);
                                $dc7ec905e041f51c$var$multiDragElements.push(children[i]);
                                $dc7ec905e041f51c$var$dispatchEvent({
                                    sortable: sortable,
                                    rootEl: rootEl,
                                    name: 'select',
                                    targetEl: children[i],
                                    originalEvent: evt
                                });
                            }
                        })();
                    } else $dc7ec905e041f51c$var$lastMultiDragSelect = $dc7ec905e041f51c$var$dragEl$1;
                    $dc7ec905e041f51c$var$multiDragSortable = toSortable;
                } else {
                    $dc7ec905e041f51c$var$multiDragElements.splice($dc7ec905e041f51c$var$multiDragElements.indexOf($dc7ec905e041f51c$var$dragEl$1), 1);
                    $dc7ec905e041f51c$var$lastMultiDragSelect = null;
                    $dc7ec905e041f51c$var$dispatchEvent({
                        sortable: sortable,
                        rootEl: rootEl,
                        name: 'deselect',
                        targetEl: $dc7ec905e041f51c$var$dragEl$1,
                        originalEvent: evt
                    });
                }
            }
            // Multi-drag drop
            if ($dc7ec905e041f51c$var$dragStarted && this.isMultiDrag) {
                $dc7ec905e041f51c$var$folding = false;
                // Do not "unfold" after around dragEl if reverted
                if ((parentEl[$dc7ec905e041f51c$var$expando].options.sort || parentEl !== rootEl) && $dc7ec905e041f51c$var$multiDragElements.length > 1) {
                    var dragRect = $dc7ec905e041f51c$var$getRect($dc7ec905e041f51c$var$dragEl$1), multiDragIndex = $dc7ec905e041f51c$var$index($dc7ec905e041f51c$var$dragEl$1, ':not(.' + this.options.selectedClass + ')');
                    if (!$dc7ec905e041f51c$var$initialFolding && options.animation) $dc7ec905e041f51c$var$dragEl$1.thisAnimationDuration = null;
                    toSortable.captureAnimationState();
                    if (!$dc7ec905e041f51c$var$initialFolding) {
                        if (options.animation) {
                            $dc7ec905e041f51c$var$dragEl$1.fromRect = dragRect;
                            $dc7ec905e041f51c$var$multiDragElements.forEach(function(multiDragElement) {
                                multiDragElement.thisAnimationDuration = null;
                                if (multiDragElement !== $dc7ec905e041f51c$var$dragEl$1) {
                                    var rect = $dc7ec905e041f51c$var$folding ? $dc7ec905e041f51c$var$getRect(multiDragElement) : dragRect;
                                    multiDragElement.fromRect = rect;
                                    // Prepare unfold animation
                                    toSortable.addAnimationState({
                                        target: multiDragElement,
                                        rect: rect
                                    });
                                }
                            });
                        }
                        // Multi drag elements are not necessarily removed from the DOM on drop, so to reinsert
                        // properly they must all be removed
                        $dc7ec905e041f51c$var$removeMultiDragElements();
                        $dc7ec905e041f51c$var$multiDragElements.forEach(function(multiDragElement) {
                            if (children[multiDragIndex]) parentEl.insertBefore(multiDragElement, children[multiDragIndex]);
                            else parentEl.appendChild(multiDragElement);
                            multiDragIndex++;
                        });
                        // If initial folding is done, the elements may have changed position because they are now
                        // unfolding around dragEl, even though dragEl may not have his index changed, so update event
                        // must be fired here as Sortable will not.
                        if (oldIndex === $dc7ec905e041f51c$var$index($dc7ec905e041f51c$var$dragEl$1)) {
                            var update = false;
                            $dc7ec905e041f51c$var$multiDragElements.forEach(function(multiDragElement) {
                                if (multiDragElement.sortableIndex !== $dc7ec905e041f51c$var$index(multiDragElement)) {
                                    update = true;
                                    return;
                                }
                            });
                            if (update) {
                                dispatchSortableEvent('update');
                                dispatchSortableEvent('sort');
                            }
                        }
                    }
                    // Must be done after capturing individual rects (scroll bar)
                    $dc7ec905e041f51c$var$multiDragElements.forEach(function(multiDragElement) {
                        $dc7ec905e041f51c$var$unsetRect(multiDragElement);
                    });
                    toSortable.animateAll();
                }
                $dc7ec905e041f51c$var$multiDragSortable = toSortable;
            }
            // Remove clones if necessary
            if (rootEl === parentEl || putSortable && putSortable.lastPutMode !== 'clone') $dc7ec905e041f51c$var$multiDragClones.forEach(function(clone) {
                clone.parentNode && clone.parentNode.removeChild(clone);
            });
        },
        nullingGlobal: function nullingGlobal() {
            this.isMultiDrag = $dc7ec905e041f51c$var$dragStarted = false;
            $dc7ec905e041f51c$var$multiDragClones.length = 0;
        },
        destroyGlobal: function destroyGlobal() {
            this._deselectMultiDrag();
            $dc7ec905e041f51c$var$off(document, 'pointerup', this._deselectMultiDrag);
            $dc7ec905e041f51c$var$off(document, 'mouseup', this._deselectMultiDrag);
            $dc7ec905e041f51c$var$off(document, 'touchend', this._deselectMultiDrag);
            $dc7ec905e041f51c$var$off(document, 'keydown', this._checkKeyDown);
            $dc7ec905e041f51c$var$off(document, 'keyup', this._checkKeyUp);
        },
        _deselectMultiDrag: function _deselectMultiDrag(evt) {
            if (typeof $dc7ec905e041f51c$var$dragStarted !== "undefined" && $dc7ec905e041f51c$var$dragStarted) return;
            // Only deselect if selection is in this sortable
            if ($dc7ec905e041f51c$var$multiDragSortable !== this.sortable) return;
            // Only deselect if target is not item in this sortable
            if (evt && $dc7ec905e041f51c$var$closest(evt.target, this.options.draggable, this.sortable.el, false)) return;
            // Only deselect if left click
            if (evt && evt.button !== 0) return;
            while($dc7ec905e041f51c$var$multiDragElements.length){
                var el = $dc7ec905e041f51c$var$multiDragElements[0];
                $dc7ec905e041f51c$var$toggleClass(el, this.options.selectedClass, false);
                $dc7ec905e041f51c$var$multiDragElements.shift();
                $dc7ec905e041f51c$var$dispatchEvent({
                    sortable: this.sortable,
                    rootEl: this.sortable.el,
                    name: 'deselect',
                    targetEl: el,
                    originalEvent: evt
                });
            }
        },
        _checkKeyDown: function _checkKeyDown(evt) {
            if (evt.key === this.options.multiDragKey) this.multiDragKeyDown = true;
        },
        _checkKeyUp: function _checkKeyUp(evt) {
            if (evt.key === this.options.multiDragKey) this.multiDragKeyDown = false;
        }
    };
    return $dc7ec905e041f51c$var$_extends(MultiDrag, {
        // Static methods & properties
        pluginName: 'multiDrag',
        utils: {
            /**
       * Selects the provided multi-drag item
       * @param  {HTMLElement} el    The element to be selected
       */ select: function select(el) {
                var sortable = el.parentNode[$dc7ec905e041f51c$var$expando];
                if (!sortable || !sortable.options.multiDrag || ~$dc7ec905e041f51c$var$multiDragElements.indexOf(el)) return;
                if ($dc7ec905e041f51c$var$multiDragSortable && $dc7ec905e041f51c$var$multiDragSortable !== sortable) {
                    $dc7ec905e041f51c$var$multiDragSortable.multiDrag._deselectMultiDrag();
                    $dc7ec905e041f51c$var$multiDragSortable = sortable;
                }
                $dc7ec905e041f51c$var$toggleClass(el, sortable.options.selectedClass, true);
                $dc7ec905e041f51c$var$multiDragElements.push(el);
            },
            /**
       * Deselects the provided multi-drag item
       * @param  {HTMLElement} el    The element to be deselected
       */ deselect: function deselect(el) {
                var sortable = el.parentNode[$dc7ec905e041f51c$var$expando], index = $dc7ec905e041f51c$var$multiDragElements.indexOf(el);
                if (!sortable || !sortable.options.multiDrag || !~index) return;
                $dc7ec905e041f51c$var$toggleClass(el, sortable.options.selectedClass, false);
                $dc7ec905e041f51c$var$multiDragElements.splice(index, 1);
            }
        },
        eventProperties: function eventProperties() {
            var _this3 = this;
            var oldIndicies = [], newIndicies = [];
            $dc7ec905e041f51c$var$multiDragElements.forEach(function(multiDragElement) {
                oldIndicies.push({
                    multiDragElement: multiDragElement,
                    index: multiDragElement.sortableIndex
                });
                // multiDragElements will already be sorted if folding
                var newIndex;
                if ($dc7ec905e041f51c$var$folding && multiDragElement !== $dc7ec905e041f51c$var$dragEl$1) newIndex = -1;
                else if ($dc7ec905e041f51c$var$folding) newIndex = $dc7ec905e041f51c$var$index(multiDragElement, ':not(.' + _this3.options.selectedClass + ')');
                else newIndex = $dc7ec905e041f51c$var$index(multiDragElement);
                newIndicies.push({
                    multiDragElement: multiDragElement,
                    index: newIndex
                });
            });
            return {
                items: $dc7ec905e041f51c$var$_toConsumableArray($dc7ec905e041f51c$var$multiDragElements),
                clones: [].concat($dc7ec905e041f51c$var$multiDragClones),
                oldIndicies: oldIndicies,
                newIndicies: newIndicies
            };
        },
        optionListeners: {
            multiDragKey: function multiDragKey(key) {
                key = key.toLowerCase();
                if (key === 'ctrl') key = 'Control';
                else if (key.length > 1) key = key.charAt(0).toUpperCase() + key.substr(1);
                return key;
            }
        }
    });
}
function $dc7ec905e041f51c$var$insertMultiDragElements(clonesInserted, rootEl) {
    $dc7ec905e041f51c$var$multiDragElements.forEach(function(multiDragElement, i) {
        var target = rootEl.children[multiDragElement.sortableIndex + (clonesInserted ? Number(i) : 0)];
        if (target) rootEl.insertBefore(multiDragElement, target);
        else rootEl.appendChild(multiDragElement);
    });
}
/**
 * Insert multi-drag clones
 * @param  {[Boolean]} elementsInserted  Whether the multi-drag elements are inserted
 * @param  {HTMLElement} rootEl
 */ function $dc7ec905e041f51c$var$insertMultiDragClones(elementsInserted, rootEl) {
    $dc7ec905e041f51c$var$multiDragClones.forEach(function(clone, i) {
        var target = rootEl.children[clone.sortableIndex + (elementsInserted ? Number(i) : 0)];
        if (target) rootEl.insertBefore(clone, target);
        else rootEl.appendChild(clone);
    });
}
function $dc7ec905e041f51c$var$removeMultiDragElements() {
    $dc7ec905e041f51c$var$multiDragElements.forEach(function(multiDragElement) {
        if (multiDragElement === $dc7ec905e041f51c$var$dragEl$1) return;
        multiDragElement.parentNode && multiDragElement.parentNode.removeChild(multiDragElement);
    });
}
$dc7ec905e041f51c$export$31b3ca70d8f57423.mount(new $dc7ec905e041f51c$var$AutoScrollPlugin());
$dc7ec905e041f51c$export$31b3ca70d8f57423.mount($dc7ec905e041f51c$var$Remove, $dc7ec905e041f51c$var$Revert);
var $dc7ec905e041f51c$export$2e2bcd8739ae039 = $dc7ec905e041f51c$export$31b3ca70d8f57423;









var $f1q41 = parcelRequire("f1q41");




const $9670560ff2a74fee$export$32d4e8e96c41cdee = Object.freeze([
    {
        text: 'Tile',
        value: 'Tile'
    },
    {
        text: 'Vector',
        value: 'Vector'
    }
]);
const $9670560ff2a74fee$export$551ff448b1eb3ef1 = Object.freeze({
    'Tile': (0, $32e67a4d3559554a$export$2e2bcd8739ae039),
    'Vector': (0, $82a68515bd6ef378$export$2e2bcd8739ae039)
});
const $9670560ff2a74fee$export$982135f5c36d616f = function(name, options) {
    if (!(name in $9670560ff2a74fee$export$551ff448b1eb3ef1)) return null;
    return new $9670560ff2a74fee$export$551ff448b1eb3ef1[name](options);
};


/**
 * @module ol/source/TileWMS
 */ 







/**
 * @module ol/source/wms
 */ 





/**
 * @module ol/source/Image
 */ 







/**
 * @module ol/reproj/Image
 */ 





/**
 * @module ol/resolution
 */ /**
 * @typedef {number|Array<number>} ResolutionLike
 */ /**
 * @param {ResolutionLike} resolution Resolution.
 * @return {number} Resolution.
 */ function $294095e38e30fd4e$export$bc4231bf34bfa9ad(resolution) {
    if (Array.isArray(resolution)) return Math.min(...resolution);
    return resolution;
}




/**
 * @typedef {function(import("../extent.js").Extent, number, number) : import("../Image.js").default} FunctionType
 */ /**
 * @classdesc
 * Class encapsulating single reprojected image.
 * See {@link module:ol/source/Image~ImageSource}.
 */ class $22666d8766dd8ace$var$ReprojImage extends (0, $b54439be79d4619a$export$2e2bcd8739ae039) {
    /**
   * @param {import("../proj/Projection.js").default} sourceProj Source projection (of the data).
   * @param {import("../proj/Projection.js").default} targetProj Target projection.
   * @param {import("../extent.js").Extent} targetExtent Target extent.
   * @param {number} targetResolution Target resolution.
   * @param {number} pixelRatio Pixel ratio.
   * @param {FunctionType} getImageFunction
   *     Function returning source images (extent, resolution, pixelRatio).
   * @param {boolean} interpolate Use linear interpolation when resampling.
   */ constructor(sourceProj, targetProj, targetExtent, targetResolution, pixelRatio, getImageFunction, interpolate){
        let maxSourceExtent = sourceProj.getExtent();
        if (maxSourceExtent && sourceProj.canWrapX()) {
            maxSourceExtent = maxSourceExtent.slice();
            maxSourceExtent[0] = -Infinity;
            maxSourceExtent[2] = Infinity;
        }
        let maxTargetExtent = targetProj.getExtent();
        if (maxTargetExtent && targetProj.canWrapX()) {
            maxTargetExtent = maxTargetExtent.slice();
            maxTargetExtent[0] = -Infinity;
            maxTargetExtent[2] = Infinity;
        }
        const limitedTargetExtent = maxTargetExtent ? (0, $6da4c8ed3074c92b$export$72209efa88586d42)(targetExtent, maxTargetExtent) : targetExtent;
        const targetCenter = (0, $6da4c8ed3074c92b$export$c91255cadecfe081)(limitedTargetExtent);
        const sourceResolution = (0, $2b0a118af78fb031$export$5fbb958059b7e71f)(sourceProj, targetProj, targetCenter, targetResolution);
        const errorThresholdInPixels = (0, $8ea51dd7be3ba5e2$export$3ecb4bcfa5aae855);
        const triangulation = new (0, $6be53f6edfbf1854$export$2e2bcd8739ae039)(sourceProj, targetProj, limitedTargetExtent, maxSourceExtent, sourceResolution * errorThresholdInPixels, targetResolution);
        const sourceExtent = triangulation.calculateSourceExtent();
        const sourceImage = (0, $6da4c8ed3074c92b$export$dd1bc94b04021eeb)(sourceExtent) ? null : getImageFunction(sourceExtent, sourceResolution, pixelRatio);
        const state = sourceImage ? (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).IDLE : (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).EMPTY;
        const sourcePixelRatio = sourceImage ? sourceImage.getPixelRatio() : 1;
        super(targetExtent, targetResolution, sourcePixelRatio, state);
        /**
     * @private
     * @type {import("../proj/Projection.js").default}
     */ this.targetProj_ = targetProj;
        /**
     * @private
     * @type {import("../extent.js").Extent}
     */ this.maxSourceExtent_ = maxSourceExtent;
        /**
     * @private
     * @type {!import("./Triangulation.js").default}
     */ this.triangulation_ = triangulation;
        /**
     * @private
     * @type {number}
     */ this.targetResolution_ = targetResolution;
        /**
     * @private
     * @type {import("../extent.js").Extent}
     */ this.targetExtent_ = targetExtent;
        /**
     * @private
     * @type {import("../Image.js").default}
     */ this.sourceImage_ = sourceImage;
        /**
     * @private
     * @type {number}
     */ this.sourcePixelRatio_ = sourcePixelRatio;
        /**
     * @private
     * @type {boolean}
     */ this.interpolate_ = interpolate;
        /**
     * @private
     * @type {HTMLCanvasElement}
     */ this.canvas_ = null;
        /**
     * @private
     * @type {?import("../events.js").EventsKey}
     */ this.sourceListenerKey_ = null;
    }
    /**
   * Clean up.
   * @override
   */ disposeInternal() {
        if (this.state == (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADING) this.unlistenSource_();
        super.disposeInternal();
    }
    /**
   * @return {HTMLCanvasElement} Image.
   * @override
   */ getImage() {
        return this.canvas_;
    }
    /**
   * @return {import("../proj/Projection.js").default} Projection.
   */ getProjection() {
        return this.targetProj_;
    }
    /**
   * @private
   */ reproject_() {
        const sourceState = this.sourceImage_.getState();
        if (sourceState == (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADED) {
            const width = (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(this.targetExtent_) / this.targetResolution_;
            const height = (0, $6da4c8ed3074c92b$export$c08559766941f856)(this.targetExtent_) / this.targetResolution_;
            this.canvas_ = (0, $2b0a118af78fb031$export$b3890eb0ae9dca99)(width, height, this.sourcePixelRatio_, (0, $294095e38e30fd4e$export$bc4231bf34bfa9ad)(this.sourceImage_.getResolution()), this.maxSourceExtent_, this.targetResolution_, this.targetExtent_, this.triangulation_, [
                {
                    extent: this.sourceImage_.getExtent(),
                    image: this.sourceImage_.getImage()
                }
            ], 0, undefined, this.interpolate_, true);
        }
        this.state = sourceState;
        this.changed();
    }
    /**
   * Load not yet loaded URI.
   * @override
   */ load() {
        if (this.state == (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).IDLE) {
            this.state = (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADING;
            this.changed();
            const sourceState = this.sourceImage_.getState();
            if (sourceState == (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADED || sourceState == (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).ERROR) this.reproject_();
            else {
                this.sourceListenerKey_ = (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(this.sourceImage_, (0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE, (e)=>{
                    const sourceState = this.sourceImage_.getState();
                    if (sourceState == (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADED || sourceState == (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).ERROR) {
                        this.unlistenSource_();
                        this.reproject_();
                    }
                });
                this.sourceImage_.load();
            }
        }
    }
    /**
   * @private
   */ unlistenSource_() {
        (0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921)(/** @type {!import("../events.js").EventsKey} */ this.sourceListenerKey_);
        this.sourceListenerKey_ = null;
    }
}
var $22666d8766dd8ace$export$2e2bcd8739ae039 = $22666d8766dd8ace$var$ReprojImage;




/**
 * @module ol/source/common
 */ /**
 * Default WMS version.
 * @type {string}
 */ const $1dd040dde677fb20$export$8c33e4eedb20eeb5 = '1.3.0';
const $1dd040dde677fb20$export$48fbc15abf52505f = 4;


const $ff537d321d4e1584$export$4e0f6da20e5dcc4f = {
    /**
   * Triggered when an image starts loading.
   * @event module:ol/source/Image.ImageSourceEvent#imageloadstart
   * @api
   */ IMAGELOADSTART: 'imageloadstart',
    /**
   * Triggered when an image finishes loading.
   * @event module:ol/source/Image.ImageSourceEvent#imageloadend
   * @api
   */ IMAGELOADEND: 'imageloadend',
    /**
   * Triggered if image loading results in an error.
   * @event module:ol/source/Image.ImageSourceEvent#imageloaderror
   * @api
   */ IMAGELOADERROR: 'imageloaderror'
};
class $ff537d321d4e1584$export$58d3276cd83daede extends (0, $aeedce20e9577100$export$2e2bcd8739ae039) {
    /**
   * @param {string} type Type.
   * @param {import("../Image.js").default} image The image.
   */ constructor(type, image){
        super(type);
        /**
     * The image related to the event.
     * @type {import("../Image.js").default}
     * @api
     */ this.image = image;
    }
}
/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types, import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<ImageSourceEventTypes, ImageSourceEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types
 *     |ImageSourceEventTypes, Return>} ImageSourceOnSignature
 */ /**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {boolean} [interpolate=true] Use interpolated values when resampling.  By default,
 * linear interpolation is used when resampling.  Set to false to use the nearest neighbor instead.
 * @property {import("../Image.js").Loader} [loader] Loader. Can either be a custom loader, or one of the
 * loaders created with a `createLoader()` function ({@link module:ol/source/wms.createLoader wms},
 * {@link module:ol/source/arcgisRest.createLoader arcgisRest}, {@link module:ol/source/mapguide.createLoader mapguide},
 * {@link module:ol/source/static.createLoader static}).
 * @property {import("../proj.js").ProjectionLike} [projection] Projection.
 * @property {Array<number>} [resolutions] Resolutions.
 * @property {import("./Source.js").State} [state] State.
 */ /**
 * @classdesc
 * Base class for sources providing a single image.
 * @fires module:ol/source/Image.ImageSourceEvent
 * @api
 */ class $ff537d321d4e1584$var$ImageSource extends (0, $ed6dc99f268f3882$export$2e2bcd8739ae039) {
    /**
   * @param {Options} options Single image source options.
   */ constructor(options){
        super({
            attributions: options.attributions,
            projection: options.projection,
            state: options.state,
            interpolate: options.interpolate !== undefined ? options.interpolate : true
        });
        /***
     * @type {ImageSourceOnSignature<import("../events").EventsKey>}
     */ this.on;
        /***
     * @type {ImageSourceOnSignature<import("../events").EventsKey>}
     */ this.once;
        /***
     * @type {ImageSourceOnSignature<void>}
     */ this.un;
        /**
     * @protected
     * @type {import("../Image.js").Loader}
     */ this.loader = options.loader || null;
        /**
     * @private
     * @type {Array<number>|null}
     */ this.resolutions_ = options.resolutions !== undefined ? options.resolutions : null;
        /**
     * @private
     * @type {import("../reproj/Image.js").default}
     */ this.reprojectedImage_ = null;
        /**
     * @private
     * @type {number}
     */ this.reprojectedRevision_ = 0;
        /**
     * @protected
     * @type {import("../Image.js").default}
     */ this.image = null;
        /**
     * @private
     * @type {import("../extent.js").Extent}
     */ this.wantedExtent_;
        /**
     * @private
     * @type {number}
     */ this.wantedResolution_;
        /**
     * @private
     * @type {boolean}
     */ this.static_ = options.loader ? options.loader.length === 0 : false;
        /**
     * @private
     * @type {import("../proj/Projection.js").default}
     */ this.wantedProjection_ = null;
    }
    /**
   * @return {Array<number>|null} Resolutions.
   * @override
   */ getResolutions() {
        return this.resolutions_;
    }
    /**
   * @param {Array<number>|null} resolutions Resolutions.
   */ setResolutions(resolutions) {
        this.resolutions_ = resolutions;
    }
    /**
   * @protected
   * @param {number} resolution Resolution.
   * @return {number} Resolution.
   */ findNearestResolution(resolution) {
        const resolutions = this.getResolutions();
        if (resolutions) {
            const idx = (0, $b998d41b678ed5d1$export$8a3786cc03fdb777)(resolutions, resolution, 0);
            resolution = resolutions[idx];
        }
        return resolution;
    }
    /**
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {import("../Image.js").default} Single image.
   */ getImage(extent, resolution, pixelRatio, projection) {
        const sourceProjection = this.getProjection();
        if (!sourceProjection || !projection || (0, $9c4744460e43e41b$export$fe091d73a555748b)(sourceProjection, projection)) {
            if (sourceProjection) projection = sourceProjection;
            return this.getImageInternal(extent, resolution, pixelRatio, projection);
        }
        if (this.reprojectedImage_) {
            if (this.reprojectedRevision_ == this.getRevision() && (0, $9c4744460e43e41b$export$fe091d73a555748b)(this.reprojectedImage_.getProjection(), projection) && this.reprojectedImage_.getResolution() == resolution && (0, $6da4c8ed3074c92b$export$e9bab7fafb253603)(this.reprojectedImage_.getExtent(), extent)) return this.reprojectedImage_;
            this.reprojectedImage_.dispose();
            this.reprojectedImage_ = null;
        }
        this.reprojectedImage_ = new (0, $22666d8766dd8ace$export$2e2bcd8739ae039)(sourceProjection, projection, extent, resolution, pixelRatio, (extent, resolution, pixelRatio)=>this.getImageInternal(extent, resolution, pixelRatio, sourceProjection), this.getInterpolate());
        this.reprojectedRevision_ = this.getRevision();
        return this.reprojectedImage_;
    }
    /**
   * @abstract
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {import("../Image.js").default} Single image.
   * @protected
   */ getImageInternal(extent, resolution, pixelRatio, projection) {
        if (this.loader) {
            const requestExtent = $ff537d321d4e1584$export$2a9dcc8f63da1787(extent, resolution, pixelRatio, 1);
            const requestResolution = this.findNearestResolution(resolution);
            if (this.image && (this.static_ || this.wantedProjection_ === projection && (this.wantedExtent_ && (0, $6da4c8ed3074c92b$export$be866b1e0809b17e)(this.wantedExtent_, requestExtent) || (0, $6da4c8ed3074c92b$export$be866b1e0809b17e)(this.image.getExtent(), requestExtent)) && (this.wantedResolution_ && (0, $294095e38e30fd4e$export$bc4231bf34bfa9ad)(this.wantedResolution_) === requestResolution || (0, $294095e38e30fd4e$export$bc4231bf34bfa9ad)(this.image.getResolution()) === requestResolution))) return this.image;
            this.wantedProjection_ = projection;
            this.wantedExtent_ = requestExtent;
            this.wantedResolution_ = requestResolution;
            this.image = new (0, $b54439be79d4619a$export$2e2bcd8739ae039)(requestExtent, requestResolution, pixelRatio, this.loader);
            this.image.addEventListener((0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE, this.handleImageChange.bind(this));
        }
        return this.image;
    }
    /**
   * Handle image change events.
   * @param {import("../events/Event.js").default} event Event.
   * @protected
   */ handleImageChange(event) {
        const image = /** @type {import("../Image.js").default} */ event.target;
        let type;
        switch(image.getState()){
            case (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADING:
                this.loading = true;
                type = $ff537d321d4e1584$export$4e0f6da20e5dcc4f.IMAGELOADSTART;
                break;
            case (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADED:
                this.loading = false;
                type = $ff537d321d4e1584$export$4e0f6da20e5dcc4f.IMAGELOADEND;
                break;
            case (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).ERROR:
                this.loading = false;
                type = $ff537d321d4e1584$export$4e0f6da20e5dcc4f.IMAGELOADERROR;
                break;
            default:
                return;
        }
        if (this.hasListener(type)) this.dispatchEvent(new $ff537d321d4e1584$export$58d3276cd83daede(type, image));
    }
}
function $ff537d321d4e1584$export$584f102f75ff44b3(image, src) {
    /** @type {HTMLImageElement|HTMLVideoElement} */ image.getImage().src = src;
}
function $ff537d321d4e1584$export$2a9dcc8f63da1787(extent, resolution, pixelRatio, ratio) {
    const imageResolution = resolution / pixelRatio;
    const center = (0, $6da4c8ed3074c92b$export$c91255cadecfe081)(extent);
    const viewWidth = (0, $6b000a049d919fe5$export$803ce6b71a0a94b2)((0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(extent) / imageResolution, (0, $1dd040dde677fb20$export$48fbc15abf52505f));
    const viewHeight = (0, $6b000a049d919fe5$export$803ce6b71a0a94b2)((0, $6da4c8ed3074c92b$export$c08559766941f856)(extent) / imageResolution, (0, $1dd040dde677fb20$export$48fbc15abf52505f));
    const marginWidth = (0, $6b000a049d919fe5$export$803ce6b71a0a94b2)((ratio - 1) * viewWidth / 2, (0, $1dd040dde677fb20$export$48fbc15abf52505f));
    const requestWidth = viewWidth + 2 * marginWidth;
    const marginHeight = (0, $6b000a049d919fe5$export$803ce6b71a0a94b2)((ratio - 1) * viewHeight / 2, (0, $1dd040dde677fb20$export$48fbc15abf52505f));
    const requestHeight = viewHeight + 2 * marginHeight;
    return (0, $6da4c8ed3074c92b$export$13ba650faf8308)(center, imageResolution, 0, [
        requestWidth,
        requestHeight
    ]);
}
var $ff537d321d4e1584$export$2e2bcd8739ae039 = $ff537d321d4e1584$var$ImageSource;



const $186e1be7a71804ce$export$363ebe89e6e7aeef = '1.3.0';
/**
 * @const
 * @type {import("../size.js").Size}
 */ const $186e1be7a71804ce$var$GETFEATUREINFO_IMAGE_SIZE = [
    101,
    101
];
function $186e1be7a71804ce$export$14619c0eed01a470(baseUrl, extent, size, projection, params) {
    params['WIDTH'] = size[0];
    params['HEIGHT'] = size[1];
    const axisOrientation = projection.getAxisOrientation();
    const v13 = (0, $ff7180bdd45ebb19$export$66e1c0999abad646)(params['VERSION'], '1.3') >= 0;
    params[v13 ? 'CRS' : 'SRS'] = projection.getCode();
    const bbox = v13 && axisOrientation.startsWith('ne') ? [
        extent[1],
        extent[0],
        extent[3],
        extent[2]
    ] : extent;
    params['BBOX'] = bbox.join(',');
    return (0, $60db182c0252e220$export$c202e3cb8db99a95)(baseUrl, params);
}
function $186e1be7a71804ce$export$ef1c8480e0b65584(extent, resolution, pixelRatio, projection, url, params, serverType) {
    params = Object.assign({
        REQUEST: 'GetMap'
    }, params);
    const imageResolution = resolution / pixelRatio;
    const imageSize = [
        (0, $6b000a049d919fe5$export$2077e0241d6afd3c)((0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(extent) / imageResolution, (0, $1dd040dde677fb20$export$48fbc15abf52505f)),
        (0, $6b000a049d919fe5$export$2077e0241d6afd3c)((0, $6da4c8ed3074c92b$export$c08559766941f856)(extent) / imageResolution, (0, $1dd040dde677fb20$export$48fbc15abf52505f))
    ];
    if (pixelRatio != 1) switch(serverType){
        case 'geoserver':
            const dpi = 90 * pixelRatio + 0.5 | 0;
            if ('FORMAT_OPTIONS' in params) params['FORMAT_OPTIONS'] += ';dpi:' + dpi;
            else params['FORMAT_OPTIONS'] = 'dpi:' + dpi;
            break;
        case 'mapserver':
            params['MAP_RESOLUTION'] = 90 * pixelRatio;
            break;
        case 'carmentaserver':
        case 'qgis':
            params['DPI'] = 90 * pixelRatio;
            break;
        default:
            throw new Error('Unknown `serverType` configured');
    }
    const src = $186e1be7a71804ce$export$14619c0eed01a470(url, extent, imageSize, projection, params);
    return src;
}
function $186e1be7a71804ce$export$a4c60e148c7af082(params, request) {
    return Object.assign({
        'REQUEST': request,
        'SERVICE': 'WMS',
        'VERSION': $186e1be7a71804ce$export$363ebe89e6e7aeef,
        'FORMAT': 'image/png',
        'STYLES': '',
        'TRANSPARENT': 'TRUE'
    }, params);
}
function $186e1be7a71804ce$export$8e84ca9bef6adc3a(options) {
    const hidpi = options.hidpi === undefined ? true : options.hidpi;
    const projection = (0, $9c4744460e43e41b$export$3988ae62b71be9a3)(options.projection || 'EPSG:3857');
    const ratio = options.ratio || 1.5;
    const load = options.load || (0, $b54439be79d4619a$export$2f872c0f2117be69);
    const crossOrigin = options.crossOrigin ?? null;
    return (extent, resolution, pixelRatio)=>{
        extent = (0, $ff537d321d4e1584$export$2a9dcc8f63da1787)(extent, resolution, pixelRatio, ratio);
        if (pixelRatio != 1 && (!hidpi || options.serverType === undefined)) pixelRatio = 1;
        const src = $186e1be7a71804ce$export$ef1c8480e0b65584(extent, resolution, pixelRatio, projection, options.url, $186e1be7a71804ce$export$a4c60e148c7af082(options.params, 'GetMap'), options.serverType);
        const image = new Image();
        image.crossOrigin = crossOrigin;
        return load(image, src).then((image)=>({
                image: image,
                extent: extent,
                pixelRatio: pixelRatio
            }));
    };
}
function $186e1be7a71804ce$export$6f3ec358b8c06c5b(options, coordinate, resolution) {
    if (options.url === undefined) return undefined;
    const projectionObj = (0, $9c4744460e43e41b$export$3988ae62b71be9a3)(options.projection || 'EPSG:3857');
    const extent = (0, $6da4c8ed3074c92b$export$13ba650faf8308)(coordinate, resolution, 0, $186e1be7a71804ce$var$GETFEATUREINFO_IMAGE_SIZE);
    const baseParams = {
        'QUERY_LAYERS': options.params['LAYERS'],
        'INFO_FORMAT': 'application/json'
    };
    Object.assign(baseParams, $186e1be7a71804ce$export$a4c60e148c7af082(options.params, 'GetFeatureInfo'), options.params);
    const x = (0, $6b000a049d919fe5$export$a3fe094919f356fd)((coordinate[0] - extent[0]) / resolution, (0, $1dd040dde677fb20$export$48fbc15abf52505f));
    const y = (0, $6b000a049d919fe5$export$a3fe094919f356fd)((extent[3] - coordinate[1]) / resolution, (0, $1dd040dde677fb20$export$48fbc15abf52505f));
    const v13 = (0, $ff7180bdd45ebb19$export$66e1c0999abad646)(baseParams['VERSION'], '1.3') >= 0;
    baseParams[v13 ? 'I' : 'X'] = x;
    baseParams[v13 ? 'J' : 'Y'] = y;
    return $186e1be7a71804ce$export$14619c0eed01a470(options.url, extent, $186e1be7a71804ce$var$GETFEATUREINFO_IMAGE_SIZE, projectionObj, baseParams);
}
function $186e1be7a71804ce$export$9ee42325bd9ccc93(options, resolution) {
    if (options.url === undefined) return undefined;
    const baseParams = {
        'SERVICE': 'WMS',
        'VERSION': $186e1be7a71804ce$export$363ebe89e6e7aeef,
        'REQUEST': 'GetLegendGraphic',
        'FORMAT': 'image/png'
    };
    if (resolution !== undefined) {
        const mpu = (0, $9c4744460e43e41b$export$3988ae62b71be9a3)(options.projection || 'EPSG:3857').getMetersPerUnit() || 1;
        const pixelSize = 0.00028;
        baseParams['SCALE'] = resolution * mpu / pixelSize;
    }
    Object.assign(baseParams, options.params);
    if (options.params !== undefined && baseParams['LAYER'] === undefined) {
        const layers = baseParams['LAYERS'];
        const isSingleLayer = !Array.isArray(layers) || layers.length !== 1;
        if (!isSingleLayer) return undefined;
        baseParams['LAYER'] = layers;
    }
    return (0, $60db182c0252e220$export$c202e3cb8db99a95)(options.url, baseParams);
}


/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
 * @property {number} [cacheSize] Deprecated.  Use the cacheSize option on the layer instead.
 * @property {null|string} [crossOrigin] The `crossOrigin` attribute for loaded images.  Note that
 * you must provide a `crossOrigin` value if you want to access pixel data with the Canvas renderer.
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
 * @property {boolean} [interpolate=true] Use interpolated values when resampling.  By default,
 * linear interpolation is used when resampling.  Set to false to use the nearest neighbor instead.
 * @property {Object<string,*>} params WMS request parameters.
 * At least a `LAYERS` param is required. `STYLES` is
 * `''` by default. `VERSION` is `1.3.0` by default. `WIDTH`, `HEIGHT`, `BBOX`
 * and `CRS` (`SRS` for WMS version < 1.3.0) will be set dynamically.
 * @property {number} [gutter=0]
 * The size in pixels of the gutter around image tiles to ignore. By setting
 * this property to a non-zero value, images will be requested that are wider
 * and taller than the tile size by a value of `2 x gutter`.
 * Using a non-zero value allows artifacts of rendering at tile edges to be
 * ignored. If you control the WMS service it is recommended to address
 * "artifacts at tile edges" issues by properly configuring the WMS service. For
 * example, MapServer has a `tile_map_edge_buffer` configuration parameter for
 * this. See https://mapserver.org/output/tile_mode.html.
 * @property {boolean} [hidpi=true] Use the `ol/Map#pixelRatio` value when requesting
 * the image from the remote server.
 * @property {import("../proj.js").ProjectionLike} [projection] Projection. Default is the view projection.
 * @property {number} [reprojectionErrorThreshold=0.5] Maximum allowed reprojection error (in pixels).
 * Higher values can increase reprojection performance, but decrease precision.
 * @property {typeof import("../ImageTile.js").default} [tileClass] Class used to instantiate image tiles.
 * Default is {@link module:ol/ImageTile~ImageTile}.
 * @property {import("../tilegrid/TileGrid.js").default} [tileGrid] Tile grid. Base this on the resolutions,
 * tilesize and extent supported by the server.
 * If this is not defined, a default grid will be used: if there is a projection
 * extent, the grid will be based on that; if not, a grid based on a global
 * extent with origin at 0,0 will be used.
 * @property {import("./wms.js").ServerType} [serverType] The type of
 * the remote WMS server: `mapserver`, `geoserver`, `carmentaserver`, or `qgis`.
 * Only needed if `hidpi` is `true`.
 * @property {import("../Tile.js").LoadFunction} [tileLoadFunction] Optional function to load a tile given a URL. The default is
 * ```js
 * function(imageTile, src) {
 *   imageTile.getImage().src = src;
 * };
 * ```
 * @property {string} [url] WMS service URL.
 * @property {Array<string>} [urls] WMS service urls.
 * Use this instead of `url` when the WMS supports multiple urls for GetMap requests.
 * @property {boolean} [wrapX=true] Whether to wrap the world horizontally.
 * When set to `false`, only one world
 * will be rendered. When `true`, tiles will be requested for one world only,
 * but they will be wrapped horizontally to render multiple worlds.
 * @property {number} [transition] Duration of the opacity transition for rendering.
 * To disable the opacity transition, pass `transition: 0`.
 * @property {number|import("../array.js").NearestDirectionFunction} [zDirection=0]
 * Choose whether to use tiles with a higher or lower zoom level when between integer
 * zoom levels. See {@link module:ol/tilegrid/TileGrid~TileGrid#getZForResolution}.
 */ /**
 * @classdesc
 * Layer source for tile data from WMS servers.
 * @api
 */ class $6a269de6fca6e364$var$TileWMS extends (0, $51d055913ca55b5e$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Tile WMS options.
   */ constructor(options){
        options = options ? options : /** @type {Options} */ {};
        const params = Object.assign({}, options.params);
        super({
            attributions: options.attributions,
            attributionsCollapsible: options.attributionsCollapsible,
            cacheSize: options.cacheSize,
            crossOrigin: options.crossOrigin,
            interpolate: options.interpolate,
            projection: options.projection,
            reprojectionErrorThreshold: options.reprojectionErrorThreshold,
            tileClass: options.tileClass,
            tileGrid: options.tileGrid,
            tileLoadFunction: options.tileLoadFunction,
            url: options.url,
            urls: options.urls,
            wrapX: options.wrapX !== undefined ? options.wrapX : true,
            transition: options.transition,
            zDirection: options.zDirection
        });
        /**
     * @private
     * @type {number}
     */ this.gutter_ = options.gutter !== undefined ? options.gutter : 0;
        /**
     * @private
     * @type {!Object}
     */ this.params_ = params;
        /**
     * @private
     * @type {boolean}
     */ this.v13_ = true;
        /**
     * @private
     * @type {import("./wms.js").ServerType}
     */ this.serverType_ = options.serverType;
        /**
     * @private
     * @type {boolean}
     */ this.hidpi_ = options.hidpi !== undefined ? options.hidpi : true;
        /**
     * @private
     * @type {import("../extent.js").Extent}
     */ this.tmpExtent_ = (0, $6da4c8ed3074c92b$export$fe201bb3bbe031e9)();
        this.updateV13_();
        this.setKey(this.getKeyForParams_());
    }
    /**
   * Return the GetFeatureInfo URL for the passed coordinate, resolution, and
   * projection. Return `undefined` if the GetFeatureInfo URL cannot be
   * constructed.
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {number} resolution Resolution.
   * @param {import("../proj.js").ProjectionLike} projection Projection.
   * @param {!Object} params GetFeatureInfo params. `INFO_FORMAT` at least should
   *     be provided. If `QUERY_LAYERS` is not provided then the layers specified
   *     in the `LAYERS` parameter will be used. `VERSION` should not be
   *     specified here.
   * @return {string|undefined} GetFeatureInfo URL.
   * @api
   */ getFeatureInfoUrl(coordinate, resolution, projection, params) {
        const projectionObj = (0, $9c4744460e43e41b$export$3988ae62b71be9a3)(projection);
        const sourceProjectionObj = this.getProjection() || projectionObj;
        let tileGrid = this.getTileGrid();
        if (!tileGrid) tileGrid = this.getTileGridForProjection(sourceProjectionObj);
        const sourceProjCoord = (0, $9c4744460e43e41b$export$51186ad6e864892a)(coordinate, projectionObj, sourceProjectionObj);
        const sourceResolution = (0, $2b0a118af78fb031$export$5fbb958059b7e71f)(sourceProjectionObj, projectionObj, coordinate, resolution);
        const z = tileGrid.getZForResolution(sourceResolution, this.zDirection);
        const tileResolution = tileGrid.getResolution(z);
        const tileCoord = tileGrid.getTileCoordForCoordAndZ(sourceProjCoord, z);
        if (tileGrid.getResolutions().length <= tileCoord[0]) return undefined;
        let tileExtent = tileGrid.getTileCoordExtent(tileCoord, this.tmpExtent_);
        const gutter = this.gutter_;
        if (gutter !== 0) tileExtent = (0, $6da4c8ed3074c92b$export$ab1029bcae9ddb4a)(tileExtent, tileResolution * gutter, tileExtent);
        const baseParams = {
            'QUERY_LAYERS': this.params_['LAYERS']
        };
        Object.assign(baseParams, (0, $186e1be7a71804ce$export$a4c60e148c7af082)(this.params_, 'GetFeatureInfo'), params);
        const x = Math.floor((sourceProjCoord[0] - tileExtent[0]) / tileResolution);
        const y = Math.floor((tileExtent[3] - sourceProjCoord[1]) / tileResolution);
        baseParams[this.v13_ ? 'I' : 'X'] = x;
        baseParams[this.v13_ ? 'J' : 'Y'] = y;
        return this.getRequestUrl_(tileCoord, tileExtent, 1, sourceProjectionObj || projectionObj, baseParams);
    }
    /**
   * Return the GetLegendGraphic URL, optionally optimized for the passed
   * resolution and possibly including any passed specific parameters. Returns
   * `undefined` if the GetLegendGraphic URL cannot be constructed.
   *
   * @param {number} [resolution] Resolution. If set to undefined, `SCALE`
   *     will not be calculated and included in URL.
   * @param {Object} [params] GetLegendGraphic params. If `LAYER` is set, the
   *     request is generated for this wms layer, else it will try to use the
   *     configured wms layer. Default `FORMAT` is `image/png`.
   *     `VERSION` should not be specified here.
   * @return {string|undefined} GetLegendGraphic URL.
   * @api
   */ getLegendUrl(resolution, params) {
        if (this.urls[0] === undefined) return undefined;
        const baseParams = {
            'SERVICE': 'WMS',
            'VERSION': (0, $186e1be7a71804ce$export$363ebe89e6e7aeef),
            'REQUEST': 'GetLegendGraphic',
            'FORMAT': 'image/png'
        };
        if (params === undefined || params['LAYER'] === undefined) {
            const layers = this.params_.LAYERS;
            const isSingleLayer = !Array.isArray(layers) || layers.length === 1;
            if (!isSingleLayer) return undefined;
            baseParams['LAYER'] = layers;
        }
        if (resolution !== undefined) {
            const mpu = this.getProjection() ? this.getProjection().getMetersPerUnit() : 1;
            const pixelSize = 0.00028;
            baseParams['SCALE'] = resolution * mpu / pixelSize;
        }
        Object.assign(baseParams, params);
        return (0, $60db182c0252e220$export$c202e3cb8db99a95)(/** @type {string} */ this.urls[0], baseParams);
    }
    /**
   * @return {number} Gutter.
   * @override
   */ getGutter() {
        return this.gutter_;
    }
    /**
   * Get the user-provided params, i.e. those passed to the constructor through
   * the "params" option, and possibly updated using the updateParams method.
   * @return {Object} Params.
   * @api
   */ getParams() {
        return this.params_;
    }
    /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {import("../extent.js").Extent} tileExtent Tile extent.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @param {Object} params Params.
   * @return {string|undefined} Request URL.
   * @private
   */ getRequestUrl_(tileCoord, tileExtent, pixelRatio, projection, params) {
        const urls = this.urls;
        if (!urls) return undefined;
        let url;
        if (urls.length == 1) url = urls[0];
        else {
            const index = (0, $6b000a049d919fe5$export$ba467bec01d66def)((0, $bf2a04496fadabc6$export$d6af199866bfb566)(tileCoord), urls.length);
            url = urls[index];
        }
        return (0, $186e1be7a71804ce$export$ef1c8480e0b65584)(tileExtent, (this.tileGrid || this.getTileGridForProjection(projection)).getResolution(tileCoord[0]), pixelRatio, projection, url, params, this.serverType_);
    }
    /**
   * Get the tile pixel ratio for this source.
   * @param {number} pixelRatio Pixel ratio.
   * @return {number} Tile pixel ratio.
   * @override
   */ getTilePixelRatio(pixelRatio) {
        return !this.hidpi_ || this.serverType_ === undefined ? 1 : pixelRatio;
    }
    /**
   * @private
   * @return {string} The key for the current params.
   */ getKeyForParams_() {
        let i = 0;
        const res = [];
        for(const key in this.params_)res[i++] = key + '-' + this.params_[key];
        return res.join('/');
    }
    /**
   * @param {Object} params New URL paremeters.
   * @private
   */ setParams_(params) {
        this.params_ = params;
        this.updateV13_();
        this.setKey(this.getKeyForParams_());
    }
    /**
   * Set the URL parameters passed to the WMS source.
   * @param {Object} params New URL paremeters.
   * @api
   */ setParams(params) {
        this.setParams_(Object.assign({}, params));
    }
    /**
   * Update the URL parameters. This method can be used to update a subset of the WMS
   * parameters. Call `setParams` to set all of the parameters.
   * @param {Object} params Updated URL parameters.
   * @api
   */ updateParams(params) {
        this.setParams_(Object.assign(this.params_, params));
    }
    /**
   * @private
   */ updateV13_() {
        const version = this.params_['VERSION'] || (0, $186e1be7a71804ce$export$363ebe89e6e7aeef);
        this.v13_ = (0, $ff7180bdd45ebb19$export$66e1c0999abad646)(version, '1.3') >= 0;
    }
    /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord The tile coordinate
   * @param {number} pixelRatio The pixel ratio
   * @param {import("../proj/Projection.js").default} projection The projection
   * @return {string|undefined} The tile URL
   * @override
   */ tileUrlFunction(tileCoord, pixelRatio, projection) {
        let tileGrid = this.getTileGrid();
        if (!tileGrid) tileGrid = this.getTileGridForProjection(projection);
        if (tileGrid.getResolutions().length <= tileCoord[0]) return undefined;
        if (pixelRatio != 1 && (!this.hidpi_ || this.serverType_ === undefined)) pixelRatio = 1;
        const tileResolution = tileGrid.getResolution(tileCoord[0]);
        let tileExtent = tileGrid.getTileCoordExtent(tileCoord, this.tmpExtent_);
        const gutter = this.gutter_;
        if (gutter !== 0) tileExtent = (0, $6da4c8ed3074c92b$export$ab1029bcae9ddb4a)(tileExtent, tileResolution * gutter, tileExtent);
        const baseParams = Object.assign({}, (0, $186e1be7a71804ce$export$a4c60e148c7af082)(this.params_, 'GetMap'));
        return this.getRequestUrl_(tileCoord, tileExtent, pixelRatio, projection, baseParams);
    }
}
var $6a269de6fca6e364$export$2e2bcd8739ae039 = $6a269de6fca6e364$var$TileWMS;


const $aecb76f616dc0475$export$9b1a6b19cb24518e = Object.freeze([
    {
        text: 'TileWMS',
        value: 'TileWMS'
    },
    {
        text: 'XYZ',
        value: 'XYZ'
    },
    {
        text: 'OSM',
        value: 'OSM'
    },
    {
        text: 'Vector',
        value: 'Vector'
    }
]);
const $aecb76f616dc0475$export$d95e7684b6658cc2 = Object.freeze({
    'TileWMS': (0, $6a269de6fca6e364$export$2e2bcd8739ae039),
    'XYZ': (0, $963a7ef65488964c$export$2e2bcd8739ae039),
    'OSM': (0, $6c8498cc816f2362$export$2e2bcd8739ae039),
    'Vector': (0, $84888e4daf3fdf44$export$2e2bcd8739ae039)
});
const $aecb76f616dc0475$export$31ffe23a319daad5 = function(name, options) {
    if (!(name in $aecb76f616dc0475$export$d95e7684b6658cc2)) return null;
    return new $aecb76f616dc0475$export$d95e7684b6658cc2[name](options);
};







const $463eac1678c4e35c$var$FILENAME = 'layer-modal.js';
const $463eac1678c4e35c$var$ID__PREFIX = 'oltb-layer-modal';
const $463eac1678c4e35c$var$I18N__BASE = 'modalExtensions.layerModal';
// Note:
// Only specify the unique options to this class
// Things to override on the BaseModal is passed directly
const $463eac1678c4e35c$var$DefaultOptions = Object.freeze({
    name: '',
    onCreate: undefined,
    onCancel: undefined
});
/**
 * About:
 * Manager that handles creation of Map-Layers
 */ class $463eac1678c4e35c$export$a3ac271c78b4db14 extends (0, $b12cc913018885a9$export$a703eb468fcf7e69) {
    #buttons = [];
    constructor(options = {}){
        super({
            filename: $463eac1678c4e35c$var$FILENAME,
            title: (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get(`${$463eac1678c4e35c$var$I18N__BASE}.title`),
            ...options
        });
        this.options = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep($463eac1678c4e35c$var$DefaultOptions), options);
        this.#createModalContent();
    }
    //--------------------------------------------------------------------
    // # Section: Overridden
    //--------------------------------------------------------------------
    getName() {
        return super.getName();
    }
    //--------------------------------------------------------------------
    // # Section: User Interface
    //--------------------------------------------------------------------
    #createModalContent() {
        const i18n = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get(`${$463eac1678c4e35c$var$I18N__BASE}.form`);
        const [nameWrapper, nameInput] = (0, $b40309f6a4fce6ca$export$b9bff34c3ca2042f)({
            idPrefix: $463eac1678c4e35c$var$ID__PREFIX,
            idPostfix: '-name',
            text: i18n.name,
            value: this.options.name ?? 'New map layer'
        });
        const [typeWrapper, typeSelect] = (0, $8b36a4c9059be7ba$export$af1822d79ba4bb67)({
            idPrefix: $463eac1678c4e35c$var$ID__PREFIX,
            idPostfix: '-type',
            text: i18n.layer,
            options: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep((0, $9670560ff2a74fee$export$32d4e8e96c41cdee))
        });
        const [sourceWrapper, sourceSelect] = (0, $8b36a4c9059be7ba$export$af1822d79ba4bb67)({
            idPrefix: $463eac1678c4e35c$var$ID__PREFIX,
            idPostfix: '-source',
            text: i18n.source,
            options: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep((0, $aecb76f616dc0475$export$9b1a6b19cb24518e))
        });
        const projectionOptions = [];
        const projections = (0, $3d63321abab47ecf$export$38112acb54e12e1).getProjections();
        projections.forEach((projection)=>{
            projectionOptions.push({
                text: `${projection.name} (${projection.code})`,
                value: projection.code
            });
        });
        const [projectionWrapper, projectionSelect] = (0, $8b36a4c9059be7ba$export$af1822d79ba4bb67)({
            idPrefix: $463eac1678c4e35c$var$ID__PREFIX,
            idPostfix: '-projection',
            text: i18n.projection,
            options: projectionOptions,
            value: (0, $1e8c0ef90ed82280$export$a33e119b2316dcb7).getConfig().projection.default
        });
        const [urlWrapper, urlInput] = (0, $b40309f6a4fce6ca$export$b9bff34c3ca2042f)({
            idPrefix: $463eac1678c4e35c$var$ID__PREFIX,
            idPostfix: '-url',
            text: i18n.url
        });
        const [parametersWrapper, parametersInput] = (0, $b40309f6a4fce6ca$export$b9bff34c3ca2042f)({
            idPrefix: $463eac1678c4e35c$var$ID__PREFIX,
            idPostfix: '-parameters',
            text: i18n.parameters,
            placeholder: '{"Layers": "HPD_TRP"}'
        });
        const [wrapXWrapper, wrapXSelect] = (0, $8b36a4c9059be7ba$export$af1822d79ba4bb67)({
            idPrefix: $463eac1678c4e35c$var$ID__PREFIX,
            idPostfix: '-wrapx',
            text: i18n.wrapX,
            options: [
                {
                    text: 'False',
                    value: 'False'
                },
                {
                    text: 'True',
                    value: 'True'
                }
            ]
        });
        const [corsWrapper, corsSelect] = (0, $8b36a4c9059be7ba$export$af1822d79ba4bb67)({
            idPrefix: $463eac1678c4e35c$var$ID__PREFIX,
            idPostfix: '-cors',
            text: i18n.cors,
            options: [
                {
                    text: 'Anonymous',
                    value: 'anonymous'
                },
                {
                    text: 'Credentials',
                    value: 'use-credentials'
                },
                {
                    text: 'None',
                    value: 'undefined'
                }
            ]
        });
        const [attributionsWrapper, attributionsInput] = (0, $b40309f6a4fce6ca$export$b9bff34c3ca2042f)({
            idPrefix: $463eac1678c4e35c$var$ID__PREFIX,
            idPostfix: '-attributions',
            text: i18n.attributions
        });
        const buttonsWrapper = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'div',
            class: 'oltb-d-flex oltb-justify-content-between oltb-mt-15'
        });
        const defaultProjection = (0, $1e8c0ef90ed82280$export$a33e119b2316dcb7).getConfig().projection.default;
        const createButton = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'button',
            text: i18n.createLayer,
            class: 'oltb-dialog__btn oltb-btn oltb-btn--green-mid',
            attributes: {
                'type': 'button'
            },
            listeners: {
                'click': ()=>{
                    this.#onCreate({
                        name: nameInput.value.trim(),
                        layer: typeSelect.value.trim(),
                        source: sourceSelect.value.trim(),
                        projection: projectionSelect.value.trim() || defaultProjection,
                        url: urlInput.value.trim(),
                        parameters: parametersInput.value.trim() || '{}',
                        wrapX: wrapXSelect.value.trim(),
                        crossOrigin: corsSelect.value.trim(),
                        attributions: attributionsInput.value.trim(),
                        isDynamicallyAdded: true
                    });
                }
            }
        });
        const cancelButton = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'button',
            text: i18n.cancel,
            class: `oltb-dialog__btn oltb-btn ${(0, $c63f096e37f334a4$export$5a63ccfbe4d87ef0)() ? 'oltb-btn--gray-mid' : 'oltb-btn--gray-dark'}`,
            attributes: {
                'type': 'button'
            },
            listeners: {
                'click': this.#onCancel.bind(this)
            }
        });
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(buttonsWrapper, [
            cancelButton,
            createButton
        ]);
        const modalContent = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'div',
            class: 'oltb-modal__content'
        });
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(modalContent, [
            nameWrapper,
            typeWrapper,
            sourceWrapper,
            projectionWrapper,
            urlWrapper,
            parametersWrapper,
            wrapXWrapper,
            corsWrapper,
            attributionsWrapper,
            buttonsWrapper
        ]);
        this.#buttons = [
            cancelButton,
            createButton
        ];
        this.show(modalContent);
    }
    //--------------------------------------------------------------------
    // # Section: Events
    //--------------------------------------------------------------------
    #onCreate(result) {
        this.close();
        this.options.onCreate && this.options.onCreate(result);
    }
    #onCancel() {
        this.close();
        this.options.onCancel && this.options.onCancel();
    }
    //--------------------------------------------------------------------
    // # Section: Public API
    //--------------------------------------------------------------------
    getButtons() {
        return this.#buttons;
    }
}







const $8659bbf0c949ad4c$var$FILENAME = 'download-file.js';
const $8659bbf0c949ad4c$var$isImage = function(name) {
    return name.split('.').pop().match(/jpg|jpeg|png|gif|svg/i) !== null;
};
const $8659bbf0c949ad4c$export$bb3b75778e3e272 = function(name, content) {
    (0, $b9b5c0363f244088$export$49b118289be48034).logDebug($8659bbf0c949ad4c$var$FILENAME, 'downloadFile', name);
    const downloadTrigger = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
        element: 'a',
        attributes: {
            'download': name
        }
    });
    const data = $8659bbf0c949ad4c$var$isImage(name) ? content : `data:text/plain;charset=utf-8,${encodeURIComponent(content)}`;
    downloadTrigger.setAttribute('href', data);
    downloadTrigger.click();
};









var $f1q41 = parcelRequire("f1q41");


const $d4a181242e81568c$var$CLASS__CHECKBOX_WRAPPER = 'oltb-checkbox-wrapper';
const $d4a181242e81568c$var$DefaultOptions = Object.freeze({
    idPrefix: '',
    idPostfix: '',
    i18nKey: undefined,
    text: '',
    checked: false,
    bottomMargin: false,
    listeners: []
});
const $d4a181242e81568c$export$cb0362de623b471b = function(options = {}) {
    options = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep($d4a181242e81568c$var$DefaultOptions), options);
    const wrapper = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
        element: 'div',
        class: `${$d4a181242e81568c$var$CLASS__CHECKBOX_WRAPPER} ${options.bottomMargin ? `${$d4a181242e81568c$var$CLASS__CHECKBOX_WRAPPER}--margin` : ''}`
    });
    // Note:
    // If the i18nKey is specified, the language must be fetched
    // The key is also appended to the title and message element
    // so that a active toast can do a hot-swap of the displayed language
    if (options.i18nKey) options.text = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get(options.i18nKey);
    const label = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
        element: 'label',
        text: options.text,
        class: `${$d4a181242e81568c$var$CLASS__CHECKBOX_WRAPPER}__title oltb-label--inline oltb-m-0`,
        attributes: {
            'for': `${options.idPrefix}${options.idPostfix}`,
            ...options.i18nKey && {
                'data-oltb-i18n': options.i18nKey
            }
        }
    });
    const checkbox = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
        element: 'input',
        id: `${options.idPrefix}${options.idPostfix}`,
        class: `${$d4a181242e81568c$var$CLASS__CHECKBOX_WRAPPER}__checkbox`,
        attributes: {
            'type': 'checkbox'
        }
    });
    if (options.checked) checkbox.setAttribute('checked', '');
    // Note:
    // Attach given callbacks, given as object or list of
    for(const listener in options.listeners){
        const callbacks = options.listeners[listener];
        if (Array.isArray(callbacks)) callbacks.forEach((callback)=>{
            checkbox.addEventListener(listener, callback);
        });
        else checkbox.addEventListener(listener, callbacks);
    }
    (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(wrapper, [
        checkbox,
        label
    ]);
    return [
        wrapper,
        checkbox
    ];
};




/**
 * @module ol/format/KML
 */ 

















/**
 * @module ol/xml
 */ 
const $a4f89edd2ef65182$export$be284679de3fbea8 = 'http://www.w3.org/2001/XMLSchema-instance';
function $a4f89edd2ef65182$export$7094a064528c7fee(namespaceURI, qualifiedName) {
    return $a4f89edd2ef65182$export$f65ca476c09acec0().createElementNS(namespaceURI, qualifiedName);
}
function $a4f89edd2ef65182$export$b089dda0fde13047(node, normalizeWhitespace) {
    return $a4f89edd2ef65182$export$caa0047a9c11e135(node, normalizeWhitespace, []).join('');
}
function $a4f89edd2ef65182$export$caa0047a9c11e135(node, normalizeWhitespace, accumulator) {
    if (node.nodeType == Node.CDATA_SECTION_NODE || node.nodeType == Node.TEXT_NODE) {
        if (normalizeWhitespace) accumulator.push(String(node.nodeValue).replace(/(\r\n|\r|\n)/g, ''));
        else accumulator.push(node.nodeValue);
    } else {
        let n;
        for(n = node.firstChild; n; n = n.nextSibling)$a4f89edd2ef65182$export$caa0047a9c11e135(n, normalizeWhitespace, accumulator);
    }
    return accumulator;
}
function $a4f89edd2ef65182$export$62858bae88b53fd0(object) {
    return 'documentElement' in object;
}
function $a4f89edd2ef65182$export$199b05d6829fbbad(node, namespaceURI, name) {
    return node.getAttributeNS(namespaceURI, name) || '';
}
function $a4f89edd2ef65182$export$98e6a39c04603d36(xml) {
    return new DOMParser().parseFromString(xml, 'application/xml');
}
function $a4f89edd2ef65182$export$b2d5eb949eb55a2a(valueReader, thisArg) {
    return(/**
     * @param {Node} node Node.
     * @param {Array<*>} objectStack Object stack.
     * @this {*}
     */ function(node, objectStack) {
        const value = valueReader.call(thisArg ?? this, node, objectStack);
        if (value !== undefined) {
            const array = /** @type {Array<*>} */ objectStack[objectStack.length - 1];
            (0, $b998d41b678ed5d1$export$8b58be045bf06082)(array, value);
        }
    });
}
function $a4f89edd2ef65182$export$18ed2f5932a1b385(valueReader, thisArg) {
    return(/**
     * @param {Element} node Node.
     * @param {Array<*>} objectStack Object stack.
     * @this {*}
     */ function(node, objectStack) {
        const value = valueReader.call(thisArg ?? this, node, objectStack);
        if (value !== undefined) {
            const array = /** @type {Array<*>} */ objectStack[objectStack.length - 1];
            array.push(value);
        }
    });
}
function $a4f89edd2ef65182$export$b1b80676c57c5713(valueReader, thisArg) {
    return(/**
     * @param {Node} node Node.
     * @param {Array<*>} objectStack Object stack.
     * @this {*}
     */ function(node, objectStack) {
        const value = valueReader.call(thisArg ?? this, node, objectStack);
        if (value !== undefined) objectStack[objectStack.length - 1] = value;
    });
}
function $a4f89edd2ef65182$export$145ce5485ab74220(valueReader, property, thisArg) {
    return(/**
     * @param {Element} node Node.
     * @param {Array<*>} objectStack Object stack.
     * @this {*}
     */ function(node, objectStack) {
        const value = valueReader.call(thisArg ?? this, node, objectStack);
        if (value !== undefined) {
            const object = /** @type {!Object} */ objectStack[objectStack.length - 1];
            const name = property !== undefined ? property : node.localName;
            let array;
            if (name in object) array = object[name];
            else {
                array = [];
                object[name] = array;
            }
            array.push(value);
        }
    });
}
function $a4f89edd2ef65182$export$b69a91976ee81208(valueReader, property, thisArg) {
    return(/**
     * @param {Element} node Node.
     * @param {Array<*>} objectStack Object stack.
     * @this {*}
     */ function(node, objectStack) {
        const value = valueReader.call(thisArg ?? this, node, objectStack);
        if (value !== undefined) {
            const object = /** @type {!Object} */ objectStack[objectStack.length - 1];
            const name = property !== undefined ? property : node.localName;
            object[name] = value;
        }
    });
}
function $a4f89edd2ef65182$export$77b73fc7f982cc07(nodeWriter, thisArg) {
    return(/**
     * @param {Element} node Node.
     * @param {*} value Value to be written.
     * @param {Array<*>} objectStack Object stack.
     * @this {*}
     */ function(node, value, objectStack) {
        nodeWriter.call(thisArg ?? this, node, value, objectStack);
        const parent = /** @type {NodeStackItem} */ objectStack[objectStack.length - 1];
        const parentNode = parent.node;
        parentNode.appendChild(node);
    });
}
function $a4f89edd2ef65182$export$fa227189764d6986(nodeWriter, thisArg) {
    let serializersNS, nodeFactory;
    return function(node, value, objectStack) {
        if (serializersNS === undefined) {
            serializersNS = {};
            const serializers = {};
            serializers[node.localName] = nodeWriter;
            serializersNS[node.namespaceURI] = serializers;
            nodeFactory = $a4f89edd2ef65182$export$7989129829daaabf(node.localName);
        }
        $a4f89edd2ef65182$export$dfdc1655ccc5b9cb(serializersNS, nodeFactory, value, objectStack);
    };
}
function $a4f89edd2ef65182$export$7989129829daaabf(fixedNodeName, fixedNamespaceURI) {
    return(/**
     * @param {*} value Value.
     * @param {Array<*>} objectStack Object stack.
     * @param {string} [newNodeName] Node name.
     * @return {Node} Node.
     */ function(value, objectStack, newNodeName) {
        const context = /** @type {NodeStackItem} */ objectStack[objectStack.length - 1];
        const node = context.node;
        let nodeName = fixedNodeName;
        if (nodeName === undefined) nodeName = newNodeName;
        const namespaceURI = fixedNamespaceURI !== undefined ? fixedNamespaceURI : node.namespaceURI;
        return $a4f89edd2ef65182$export$7094a064528c7fee(namespaceURI, /** @type {string} */ nodeName);
    });
}
const $a4f89edd2ef65182$export$d91b08b611cef144 = $a4f89edd2ef65182$export$7989129829daaabf();
function $a4f89edd2ef65182$export$939885a13683f4dc(object, orderedKeys) {
    const length = orderedKeys.length;
    const sequence = new Array(length);
    for(let i = 0; i < length; ++i)sequence[i] = object[orderedKeys[i]];
    return sequence;
}
function $a4f89edd2ef65182$export$c6eb0402f939765f(namespaceURIs, structure, structureNS) {
    structureNS = structureNS !== undefined ? structureNS : {};
    let i, ii;
    for(i = 0, ii = namespaceURIs.length; i < ii; ++i)structureNS[namespaceURIs[i]] = structure;
    return structureNS;
}
function $a4f89edd2ef65182$export$dc8ce45ce1679f4f(parsersNS, node, objectStack, thisArg) {
    let n;
    for(n = node.firstElementChild; n; n = n.nextElementSibling){
        const parsers = parsersNS[n.namespaceURI];
        if (parsers !== undefined) {
            const parser = parsers[n.localName];
            if (parser !== undefined) parser.call(thisArg, n, objectStack);
        }
    }
}
function $a4f89edd2ef65182$export$5c934df85741dbd1(object, parsersNS, node, objectStack, thisArg) {
    objectStack.push(object);
    $a4f89edd2ef65182$export$dc8ce45ce1679f4f(parsersNS, node, objectStack, thisArg);
    return /** @type {T} */ objectStack.pop();
}
function $a4f89edd2ef65182$export$dfdc1655ccc5b9cb(serializersNS, nodeFactory, values, objectStack, keys, thisArg) {
    const length = (keys !== undefined ? keys : values).length;
    let value, node;
    for(let i = 0; i < length; ++i){
        value = values[i];
        if (value !== undefined) {
            node = nodeFactory.call(thisArg, value, objectStack, keys !== undefined ? keys[i] : undefined);
            if (node !== undefined) serializersNS[node.namespaceURI][node.localName].call(thisArg, node, value, objectStack);
        }
    }
}
function $a4f89edd2ef65182$export$a79a01f4edad8da8(object, serializersNS, nodeFactory, values, objectStack, keys, thisArg) {
    objectStack.push(object);
    $a4f89edd2ef65182$export$dfdc1655ccc5b9cb(serializersNS, nodeFactory, values, objectStack, keys, thisArg);
    return /** @type {O|undefined} */ objectStack.pop();
}
let $a4f89edd2ef65182$var$xmlSerializer_ = undefined;
function $a4f89edd2ef65182$export$6d77e0eada4b836a(xmlSerializer) {
    $a4f89edd2ef65182$var$xmlSerializer_ = xmlSerializer;
}
function $a4f89edd2ef65182$export$e087df39da12b01f() {
    if ($a4f89edd2ef65182$var$xmlSerializer_ === undefined && typeof XMLSerializer !== 'undefined') $a4f89edd2ef65182$var$xmlSerializer_ = new XMLSerializer();
    return $a4f89edd2ef65182$var$xmlSerializer_;
}
let $a4f89edd2ef65182$var$document_ = undefined;
function $a4f89edd2ef65182$export$4bebdef07101fbd4(document1) {
    $a4f89edd2ef65182$var$document_ = document1;
}
function $a4f89edd2ef65182$export$f65ca476c09acec0() {
    if ($a4f89edd2ef65182$var$document_ === undefined && typeof document !== 'undefined') $a4f89edd2ef65182$var$document_ = document.implementation.createDocument('', '', null);
    return $a4f89edd2ef65182$var$document_;
}



/**
 * @module ol/format/XMLFeature
 */ 



/**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Base class for XML feature formats.
 *
 * @abstract
 */ class $ce16c3ce3167dc37$var$XMLFeature extends (0, $ec084d0ff9c13a22$export$2e2bcd8739ae039) {
    constructor(){
        super();
        /**
     * @type {XMLSerializer}
     * @private
     */ this.xmlSerializer_ = (0, $a4f89edd2ef65182$export$e087df39da12b01f)();
    }
    /**
   * @return {import("./Feature.js").Type} Format.
   * @override
   */ getType() {
        return 'xml';
    }
    /**
   * Read a single feature.
   *
   * @param {Document|Element|Object|string} source Source.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @return {import("../Feature.js").default} Feature.
   * @api
   * @override
   */ readFeature(source, options) {
        if (!source) return null;
        if (typeof source === 'string') {
            const doc = (0, $a4f89edd2ef65182$export$98e6a39c04603d36)(source);
            return this.readFeatureFromDocument(doc, options);
        }
        if ((0, $a4f89edd2ef65182$export$62858bae88b53fd0)(source)) return this.readFeatureFromDocument(/** @type {Document} */ source, options);
        return this.readFeatureFromNode(/** @type {Element} */ source, options);
    }
    /**
   * @param {Document} doc Document.
   * @param {import("./Feature.js").ReadOptions} [options] Options.
   * @return {import("../Feature.js").default} Feature.
   */ readFeatureFromDocument(doc, options) {
        const features = this.readFeaturesFromDocument(doc, options);
        if (features.length > 0) return features[0];
        return null;
    }
    /**
   * @param {Element} node Node.
   * @param {import("./Feature.js").ReadOptions} [options] Options.
   * @return {import("../Feature.js").default} Feature.
   */ readFeatureFromNode(node, options) {
        return null; // not implemented
    }
    /**
   * Read all features from a feature collection.
   *
   * @param {Document|Element|Object|string} source Source.
   * @param {import("./Feature.js").ReadOptions} [options] Options.
   * @return {Array<import("../Feature.js").default>} Features.
   * @api
   * @override
   */ readFeatures(source, options) {
        if (!source) return [];
        if (typeof source === 'string') {
            const doc = (0, $a4f89edd2ef65182$export$98e6a39c04603d36)(source);
            return this.readFeaturesFromDocument(doc, options);
        }
        if ((0, $a4f89edd2ef65182$export$62858bae88b53fd0)(source)) return this.readFeaturesFromDocument(/** @type {Document} */ source, options);
        return this.readFeaturesFromNode(/** @type {Element} */ source, options);
    }
    /**
   * @param {Document} doc Document.
   * @param {import("./Feature.js").ReadOptions} [options] Options.
   * @protected
   * @return {Array<import("../Feature.js").default>} Features.
   */ readFeaturesFromDocument(doc, options) {
        /** @type {Array<import("../Feature.js").default>} */ const features = [];
        for(let n = doc.firstChild; n; n = n.nextSibling)if (n.nodeType == Node.ELEMENT_NODE) (0, $b998d41b678ed5d1$export$8b58be045bf06082)(features, this.readFeaturesFromNode(/** @type {Element} */ n, options));
        return features;
    }
    /**
   * @abstract
   * @param {Element} node Node.
   * @param {import("./Feature.js").ReadOptions} [options] Options.
   * @protected
   * @return {Array<import("../Feature.js").default>} Features.
   */ readFeaturesFromNode(node, options) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Read a single geometry from a source.
   *
   * @param {Document|Element|Object|string} source Source.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @return {import("../geom/Geometry.js").default} Geometry.
   * @override
   */ readGeometry(source, options) {
        if (!source) return null;
        if (typeof source === 'string') {
            const doc = (0, $a4f89edd2ef65182$export$98e6a39c04603d36)(source);
            return this.readGeometryFromDocument(doc, options);
        }
        if ((0, $a4f89edd2ef65182$export$62858bae88b53fd0)(source)) return this.readGeometryFromDocument(/** @type {Document} */ source, options);
        return this.readGeometryFromNode(/** @type {Element} */ source, options);
    }
    /**
   * @param {Document} doc Document.
   * @param {import("./Feature.js").ReadOptions} [options] Options.
   * @protected
   * @return {import("../geom/Geometry.js").default} Geometry.
   */ readGeometryFromDocument(doc, options) {
        return null; // not implemented
    }
    /**
   * @param {Element} node Node.
   * @param {import("./Feature.js").ReadOptions} [options] Options.
   * @protected
   * @return {import("../geom/Geometry.js").default} Geometry.
   */ readGeometryFromNode(node, options) {
        return null; // not implemented
    }
    /**
   * Read the projection from the source.
   *
   * @param {Document|Element|Object|string} source Source.
   * @return {import("../proj/Projection.js").default} Projection.
   * @api
   * @override
   */ readProjection(source) {
        if (!source) return null;
        if (typeof source === 'string') {
            const doc = (0, $a4f89edd2ef65182$export$98e6a39c04603d36)(source);
            return this.readProjectionFromDocument(doc);
        }
        if ((0, $a4f89edd2ef65182$export$62858bae88b53fd0)(source)) return this.readProjectionFromDocument(/** @type {Document} */ source);
        return this.readProjectionFromNode(/** @type {Element} */ source);
    }
    /**
   * @param {Document} doc Document.
   * @protected
   * @return {import("../proj/Projection.js").default} Projection.
   */ readProjectionFromDocument(doc) {
        return this.dataProjection;
    }
    /**
   * @param {Element} node Node.
   * @protected
   * @return {import("../proj/Projection.js").default} Projection.
   */ readProjectionFromNode(node) {
        return this.dataProjection;
    }
    /**
   * Encode a feature as string.
   *
   * @param {import("../Feature.js").default} feature Feature.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {string} Encoded feature.
   * @override
   */ writeFeature(feature, options) {
        const node = this.writeFeatureNode(feature, options);
        return this.xmlSerializer_.serializeToString(node);
    }
    /**
   * @param {import("../Feature.js").default} feature Feature.
   * @param {import("./Feature.js").WriteOptions} [options] Options.
   * @protected
   * @return {Node} Node.
   */ writeFeatureNode(feature, options) {
        return null; // not implemented
    }
    /**
   * Encode an array of features as string.
   *
   * @param {Array<import("../Feature.js").default>} features Features.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {string} Result.
   * @api
   * @override
   */ writeFeatures(features, options) {
        const node = this.writeFeaturesNode(features, options);
        return this.xmlSerializer_.serializeToString(node);
    }
    /**
   * @param {Array<import("../Feature.js").default>} features Features.
   * @param {import("./Feature.js").WriteOptions} [options] Options.
   * @return {Node} Node.
   */ writeFeaturesNode(features, options) {
        return null; // not implemented
    }
    /**
   * Encode a geometry as string.
   *
   * @param {import("../geom/Geometry.js").default} geometry Geometry.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {string} Encoded geometry.
   * @override
   */ writeGeometry(geometry, options) {
        const node = this.writeGeometryNode(geometry, options);
        return this.xmlSerializer_.serializeToString(node);
    }
    /**
   * @param {import("../geom/Geometry.js").default} geometry Geometry.
   * @param {import("./Feature.js").WriteOptions} [options] Options.
   * @return {Node} Node.
   */ writeGeometryNode(geometry, options) {
        return null; // not implemented
    }
}
var $ce16c3ce3167dc37$export$2e2bcd8739ae039 = $ce16c3ce3167dc37$var$XMLFeature;


/**
 * @module ol/format/xsd
 */ 

function $d5e0fde316cac971$export$f9a84177eae95ed5(node) {
    const s = (0, $a4f89edd2ef65182$export$b089dda0fde13047)(node, false);
    return $d5e0fde316cac971$export$a8558234a836634(s);
}
function $d5e0fde316cac971$export$a8558234a836634(string) {
    const m = /^\s*(true|1)|(false|0)\s*$/.exec(string);
    if (m) return m[1] !== undefined || false;
    return undefined;
}
function $d5e0fde316cac971$export$5079def2140fe6f2(node) {
    const s = (0, $a4f89edd2ef65182$export$b089dda0fde13047)(node, false);
    const dateTime = Date.parse(s);
    return isNaN(dateTime) ? undefined : dateTime / 1000;
}
function $d5e0fde316cac971$export$5be9c99d34ad295b(node) {
    const s = (0, $a4f89edd2ef65182$export$b089dda0fde13047)(node, false);
    return $d5e0fde316cac971$export$5a7483b211367c0c(s);
}
function $d5e0fde316cac971$export$5a7483b211367c0c(string) {
    // FIXME check spec
    const m = /^\s*([+\-]?\d*\.?\d+(?:e[+\-]?\d+)?)\s*$/i.exec(string);
    if (m) return parseFloat(m[1]);
    return undefined;
}
function $d5e0fde316cac971$export$6161a72ab5b6b722(node) {
    const s = (0, $a4f89edd2ef65182$export$b089dda0fde13047)(node, false);
    return $d5e0fde316cac971$export$1c8fe3e9d3126f53(s);
}
function $d5e0fde316cac971$export$1c8fe3e9d3126f53(string) {
    const m = /^\s*(\d+)\s*$/.exec(string);
    if (m) return parseInt(m[1], 10);
    return undefined;
}
function $d5e0fde316cac971$export$dda73877cb166cd3(node) {
    return (0, $a4f89edd2ef65182$export$b089dda0fde13047)(node, false).trim();
}
function $d5e0fde316cac971$export$9de8e8a584a450b7(node, bool) {
    $d5e0fde316cac971$export$3255ca5635e70aed(node, bool ? '1' : '0');
}
function $d5e0fde316cac971$export$d6c624180454e8f9(node, string) {
    node.appendChild((0, $a4f89edd2ef65182$export$f65ca476c09acec0)().createCDATASection(string));
}
function $d5e0fde316cac971$export$4e91791cb8677e27(node, dateTime) {
    const date = new Date(dateTime * 1000);
    const string = date.getUTCFullYear() + '-' + (0, $ff7180bdd45ebb19$export$24be126cb0a7bbeb)(date.getUTCMonth() + 1, 2) + '-' + (0, $ff7180bdd45ebb19$export$24be126cb0a7bbeb)(date.getUTCDate(), 2) + 'T' + (0, $ff7180bdd45ebb19$export$24be126cb0a7bbeb)(date.getUTCHours(), 2) + ':' + (0, $ff7180bdd45ebb19$export$24be126cb0a7bbeb)(date.getUTCMinutes(), 2) + ':' + (0, $ff7180bdd45ebb19$export$24be126cb0a7bbeb)(date.getUTCSeconds(), 2) + 'Z';
    node.appendChild((0, $a4f89edd2ef65182$export$f65ca476c09acec0)().createTextNode(string));
}
function $d5e0fde316cac971$export$f8009f9ca036d7d1(node, decimal) {
    const string = decimal.toPrecision();
    node.appendChild((0, $a4f89edd2ef65182$export$f65ca476c09acec0)().createTextNode(string));
}
function $d5e0fde316cac971$export$b6c828910b813a07(node, nonNegativeInteger) {
    const string = nonNegativeInteger.toString();
    node.appendChild((0, $a4f89edd2ef65182$export$f65ca476c09acec0)().createTextNode(string));
}
const $d5e0fde316cac971$var$whiteSpaceStart = /^\s/;
const $d5e0fde316cac971$var$whiteSpaceEnd = /\s$/;
const $d5e0fde316cac971$var$cdataCharacters = /(\n|\t|\r|<|&| {2})/;
function $d5e0fde316cac971$export$3255ca5635e70aed(node, string) {
    if (typeof string === 'string' && ($d5e0fde316cac971$var$whiteSpaceStart.test(string) || $d5e0fde316cac971$var$whiteSpaceEnd.test(string) || $d5e0fde316cac971$var$cdataCharacters.test(string))) string.split(']]>').forEach((part, i, a)=>{
        if (i < a.length - 1) part += ']]';
        if (i > 0) part = '>' + part;
        $d5e0fde316cac971$export$d6c624180454e8f9(node, part);
    });
    else node.appendChild((0, $a4f89edd2ef65182$export$f65ca476c09acec0)().createTextNode(string));
}


/**
 * @typedef {Object} Vec2
 * @property {number} x X coordinate.
 * @property {import("../style/Icon.js").IconAnchorUnits} xunits Units of x.
 * @property {number} y Y coordinate.
 * @property {import("../style/Icon.js").IconAnchorUnits} yunits Units of Y.
 * @property {import("../style/Icon.js").IconOrigin} [origin] Origin.
 */ /**
 * @typedef {Object} GxTrackObject
 * @property {Array<Array<number>>} coordinates Coordinates.
 * @property {Array<number>} whens Whens.
 */ /**
 * @const
 * @type {Array<string>}
 */ const $1140dfbeee585f32$var$GX_NAMESPACE_URIS = [
    'http://www.google.com/kml/ext/2.2'
];
/**
 * @const
 * @type {Array<null|string>}
 */ const $1140dfbeee585f32$var$NAMESPACE_URIS = [
    null,
    'http://earth.google.com/kml/2.0',
    'http://earth.google.com/kml/2.1',
    'http://earth.google.com/kml/2.2',
    'http://www.opengis.net/kml/2.2'
];
/**
 * @const
 * @type {string}
 */ const $1140dfbeee585f32$var$SCHEMA_LOCATION = "http://www.opengis.net/kml/2.2 https://developers.google.com/kml/schema/kml22gx.xsd";
/**
 * @type {Object<string, import("../style/Icon.js").IconAnchorUnits>}
 */ const $1140dfbeee585f32$var$ICON_ANCHOR_UNITS_MAP = {
    'fraction': 'fraction',
    'pixels': 'pixels',
    'insetPixels': 'pixels'
};
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$PLACEMARK_PARSERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, {
    'ExtendedData': $1140dfbeee585f32$var$extendedDataParser,
    'Region': $1140dfbeee585f32$var$regionParser,
    'MultiGeometry': (0, $a4f89edd2ef65182$export$b69a91976ee81208)($1140dfbeee585f32$var$readMultiGeometry, 'geometry'),
    'LineString': (0, $a4f89edd2ef65182$export$b69a91976ee81208)($1140dfbeee585f32$var$readLineString, 'geometry'),
    'LinearRing': (0, $a4f89edd2ef65182$export$b69a91976ee81208)($1140dfbeee585f32$var$readLinearRing, 'geometry'),
    'Point': (0, $a4f89edd2ef65182$export$b69a91976ee81208)($1140dfbeee585f32$var$readPoint, 'geometry'),
    'Polygon': (0, $a4f89edd2ef65182$export$b69a91976ee81208)($1140dfbeee585f32$var$readPolygon, 'geometry'),
    'Style': (0, $a4f89edd2ef65182$export$b69a91976ee81208)($1140dfbeee585f32$var$readStyle),
    'StyleMap': $1140dfbeee585f32$var$placemarkStyleMapParser,
    'address': (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$dda73877cb166cd3)),
    'description': (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$dda73877cb166cd3)),
    'name': (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$dda73877cb166cd3)),
    'open': (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$f9a84177eae95ed5)),
    'phoneNumber': (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$dda73877cb166cd3)),
    'styleUrl': (0, $a4f89edd2ef65182$export$b69a91976ee81208)($1140dfbeee585f32$var$readStyleURL),
    'visibility': (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$f9a84177eae95ed5))
}, (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$GX_NAMESPACE_URIS, {
    'MultiTrack': (0, $a4f89edd2ef65182$export$b69a91976ee81208)($1140dfbeee585f32$var$readGxMultiTrack, 'geometry'),
    'Track': (0, $a4f89edd2ef65182$export$b69a91976ee81208)($1140dfbeee585f32$var$readGxTrack, 'geometry')
}));
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$NETWORK_LINK_PARSERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, {
    'ExtendedData': $1140dfbeee585f32$var$extendedDataParser,
    'Region': $1140dfbeee585f32$var$regionParser,
    'Link': $1140dfbeee585f32$var$linkParser,
    'address': (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$dda73877cb166cd3)),
    'description': (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$dda73877cb166cd3)),
    'name': (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$dda73877cb166cd3)),
    'open': (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$f9a84177eae95ed5)),
    'phoneNumber': (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$dda73877cb166cd3)),
    'visibility': (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$f9a84177eae95ed5))
});
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$LINK_PARSERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, {
    'href': (0, $a4f89edd2ef65182$export$b69a91976ee81208)($1140dfbeee585f32$var$readURI)
});
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$CAMERA_PARSERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, {
    Altitude: (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$5be9c99d34ad295b)),
    Longitude: (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$5be9c99d34ad295b)),
    Latitude: (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$5be9c99d34ad295b)),
    Tilt: (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$5be9c99d34ad295b)),
    AltitudeMode: (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$dda73877cb166cd3)),
    Heading: (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$5be9c99d34ad295b)),
    Roll: (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$5be9c99d34ad295b))
});
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$REGION_PARSERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, {
    'LatLonAltBox': $1140dfbeee585f32$var$latLonAltBoxParser,
    'Lod': $1140dfbeee585f32$var$lodParser
});
/**
 * @const
 * @type {Object<string, Array<string>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$KML_SEQUENCE = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, [
    'Document',
    'Placemark'
]);
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$KML_SERIALIZERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, {
    'Document': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)($1140dfbeee585f32$var$writeDocument),
    'Placemark': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)($1140dfbeee585f32$var$writePlacemark)
});
/**
 * @type {import("../color.js").Color}
 */ let $1140dfbeee585f32$var$DEFAULT_COLOR;
/**
 * @type {Fill|null}
 */ let $1140dfbeee585f32$var$DEFAULT_FILL_STYLE = null;
function $1140dfbeee585f32$export$21e811a557b26b54() {
    return $1140dfbeee585f32$var$DEFAULT_FILL_STYLE;
}
/**
 * @type {import("../size.js").Size}
 */ let $1140dfbeee585f32$var$DEFAULT_IMAGE_STYLE_ANCHOR;
/**
 * @type {import("../style/Icon.js").IconAnchorUnits}
 */ let $1140dfbeee585f32$var$DEFAULT_IMAGE_STYLE_ANCHOR_X_UNITS;
/**
 * @type {import("../style/Icon.js").IconAnchorUnits}
 */ let $1140dfbeee585f32$var$DEFAULT_IMAGE_STYLE_ANCHOR_Y_UNITS;
/**
 * @type {import("../size.js").Size}
 */ let $1140dfbeee585f32$var$DEFAULT_IMAGE_STYLE_SIZE;
/**
 * @type {string}
 */ let $1140dfbeee585f32$var$DEFAULT_IMAGE_STYLE_SRC;
/**
 * @type {import("../style/Image.js").default|null}
 */ let $1140dfbeee585f32$var$DEFAULT_IMAGE_STYLE = null;
function $1140dfbeee585f32$export$a17963acbf6c1558() {
    return $1140dfbeee585f32$var$DEFAULT_IMAGE_STYLE;
}
/**
 * @type {string}
 */ let $1140dfbeee585f32$var$DEFAULT_NO_IMAGE_STYLE;
/**
 * @type {Stroke|null}
 */ let $1140dfbeee585f32$var$DEFAULT_STROKE_STYLE = null;
function $1140dfbeee585f32$export$3207aea01810180d() {
    return $1140dfbeee585f32$var$DEFAULT_STROKE_STYLE;
}
/**
 * @type {Stroke}
 */ let $1140dfbeee585f32$var$DEFAULT_TEXT_STROKE_STYLE;
/**
 * @type {Text|null}
 */ let $1140dfbeee585f32$var$DEFAULT_TEXT_STYLE = null;
function $1140dfbeee585f32$export$58459f1e3c16c230() {
    return $1140dfbeee585f32$var$DEFAULT_TEXT_STYLE;
}
/**
 * @type {Style|null}
 */ let $1140dfbeee585f32$var$DEFAULT_STYLE = null;
function $1140dfbeee585f32$export$26ecbb5c9753d95f() {
    return $1140dfbeee585f32$var$DEFAULT_STYLE;
}
/**
 * @type {Array<Style>|null}
 */ let $1140dfbeee585f32$var$DEFAULT_STYLE_ARRAY = null;
function $1140dfbeee585f32$export$f1c529e822ec2fdc() {
    return $1140dfbeee585f32$var$DEFAULT_STYLE_ARRAY;
}
/**
 * Function that returns the scale needed to normalize an icon image to 32 pixels.
 * @param {import("../size.js").Size} size Image size.
 * @return {number} Scale.
 */ function $1140dfbeee585f32$var$scaleForSize(size) {
    return 32 / Math.min(size[0], size[1]);
}
function $1140dfbeee585f32$var$createStyleDefaults() {
    $1140dfbeee585f32$var$DEFAULT_COLOR = [
        255,
        255,
        255,
        1
    ];
    $1140dfbeee585f32$var$DEFAULT_FILL_STYLE = new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
        color: $1140dfbeee585f32$var$DEFAULT_COLOR
    });
    $1140dfbeee585f32$var$DEFAULT_IMAGE_STYLE_ANCHOR = [
        20,
        2
    ];
    $1140dfbeee585f32$var$DEFAULT_IMAGE_STYLE_ANCHOR_X_UNITS = 'pixels';
    $1140dfbeee585f32$var$DEFAULT_IMAGE_STYLE_ANCHOR_Y_UNITS = 'pixels';
    $1140dfbeee585f32$var$DEFAULT_IMAGE_STYLE_SIZE = [
        64,
        64
    ];
    $1140dfbeee585f32$var$DEFAULT_IMAGE_STYLE_SRC = 'https://maps.google.com/mapfiles/kml/pushpin/ylw-pushpin.png';
    $1140dfbeee585f32$var$DEFAULT_IMAGE_STYLE = new (0, $8463d325b53eeb0c$export$2e2bcd8739ae039)({
        anchor: $1140dfbeee585f32$var$DEFAULT_IMAGE_STYLE_ANCHOR,
        anchorOrigin: 'bottom-left',
        anchorXUnits: $1140dfbeee585f32$var$DEFAULT_IMAGE_STYLE_ANCHOR_X_UNITS,
        anchorYUnits: $1140dfbeee585f32$var$DEFAULT_IMAGE_STYLE_ANCHOR_Y_UNITS,
        crossOrigin: 'anonymous',
        rotation: 0,
        scale: $1140dfbeee585f32$var$scaleForSize($1140dfbeee585f32$var$DEFAULT_IMAGE_STYLE_SIZE),
        size: $1140dfbeee585f32$var$DEFAULT_IMAGE_STYLE_SIZE,
        src: $1140dfbeee585f32$var$DEFAULT_IMAGE_STYLE_SRC
    });
    $1140dfbeee585f32$var$DEFAULT_NO_IMAGE_STYLE = 'NO_IMAGE';
    $1140dfbeee585f32$var$DEFAULT_STROKE_STYLE = new (0, $f9d0329c5c745263$export$2e2bcd8739ae039)({
        color: $1140dfbeee585f32$var$DEFAULT_COLOR,
        width: 1
    });
    $1140dfbeee585f32$var$DEFAULT_TEXT_STROKE_STYLE = new (0, $f9d0329c5c745263$export$2e2bcd8739ae039)({
        color: [
            51,
            51,
            51,
            1
        ],
        width: 2
    });
    $1140dfbeee585f32$var$DEFAULT_TEXT_STYLE = new (0, $944be50faeff5321$export$2e2bcd8739ae039)({
        font: 'bold 16px Helvetica',
        fill: $1140dfbeee585f32$var$DEFAULT_FILL_STYLE,
        stroke: $1140dfbeee585f32$var$DEFAULT_TEXT_STROKE_STYLE,
        scale: 0.8
    });
    $1140dfbeee585f32$var$DEFAULT_STYLE = new (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)({
        fill: $1140dfbeee585f32$var$DEFAULT_FILL_STYLE,
        image: $1140dfbeee585f32$var$DEFAULT_IMAGE_STYLE,
        text: $1140dfbeee585f32$var$DEFAULT_TEXT_STYLE,
        stroke: $1140dfbeee585f32$var$DEFAULT_STROKE_STYLE,
        zIndex: 0
    });
    $1140dfbeee585f32$var$DEFAULT_STYLE_ARRAY = [
        $1140dfbeee585f32$var$DEFAULT_STYLE
    ];
}
/**
 * @type {HTMLTextAreaElement}
 */ let $1140dfbeee585f32$var$TEXTAREA;
/**
 * A function that takes a url `{string}` and returns a url `{string}`.
 * Might be used to change an icon path or to substitute a
 * data url obtained from a KMZ array buffer.
 *
 * @typedef {function(string):string} IconUrlFunction
 * @api
 */ /**
 * Function that returns a url unchanged.
 * @param {string} href Input url.
 * @return {string} Output url.
 */ function $1140dfbeee585f32$var$defaultIconUrlFunction(href) {
    return href;
}
/**
 * @typedef {Object} Options
 * @property {boolean} [extractStyles=true] Extract styles from the KML.
 * @property {boolean} [showPointNames=true] Show names as labels for placemarks which contain points.
 * @property {Array<Style>} [defaultStyle] Default style. The
 * default default style is the same as Google Earth.
 * @property {boolean} [writeStyles=true] Write styles into KML.
 * @property {null|string} [crossOrigin='anonymous'] The `crossOrigin` attribute for loaded images. Note that you must provide a
 * `crossOrigin` value if you want to access pixel data with the Canvas renderer.
 * @property {IconUrlFunction} [iconUrlFunction] Function that takes a url string and returns a url string.
 * Might be used to change an icon path or to substitute a data url obtained from a KMZ array buffer.
 */ /**
 * @classdesc
 * Feature format for reading and writing data in the KML format.
 *
 * {@link module:ol/format/KML~KML#readFeature} will read the first feature from
 * a KML source.
 *
 * MultiGeometries are converted into GeometryCollections if they are a mix of
 * geometry types, and into MultiPoint/MultiLineString/MultiPolygon if they are
 * all of the same type.
 *
 * @api
 */ class $1140dfbeee585f32$var$KML extends (0, $ce16c3ce3167dc37$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        super();
        options = options ? options : {};
        if (!$1140dfbeee585f32$var$DEFAULT_STYLE_ARRAY) $1140dfbeee585f32$var$createStyleDefaults();
        /**
     * @type {import("../proj/Projection.js").default}
     */ this.dataProjection = (0, $9c4744460e43e41b$export$3988ae62b71be9a3)('EPSG:4326');
        /**
     * @private
     * @type {Array<Style>}
     */ this.defaultStyle_ = options.defaultStyle ? options.defaultStyle : $1140dfbeee585f32$var$DEFAULT_STYLE_ARRAY;
        /**
     * @private
     * @type {boolean}
     */ this.extractStyles_ = options.extractStyles !== undefined ? options.extractStyles : true;
        /**
     * @type {boolean}
     */ this.writeStyles_ = options.writeStyles !== undefined ? options.writeStyles : true;
        /**
     * @private
     * @type {!Object<string, (Array<Style>|string)>}
     */ this.sharedStyles_ = {};
        /**
     * @private
     * @type {boolean}
     */ this.showPointNames_ = options.showPointNames !== undefined ? options.showPointNames : true;
        /**
     * @type {null|string}
     */ this.crossOrigin_ = options.crossOrigin !== undefined ? options.crossOrigin : 'anonymous';
        /**
     * @type {IconUrlFunction}
     */ this.iconUrlFunction_ = options.iconUrlFunction ? options.iconUrlFunction : $1140dfbeee585f32$var$defaultIconUrlFunction;
        this.supportedMediaTypes = [
            'application/vnd.google-earth.kml+xml'
        ];
    }
    /**
   * @param {Node} node Node.
   * @param {Array<*>} objectStack Object stack.
   * @private
   * @return {Array<Feature>|undefined} Features.
   */ readDocumentOrFolder_(node, objectStack) {
        // FIXME use scope somehow
        const parsersNS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, {
            'Document': (0, $a4f89edd2ef65182$export$b2d5eb949eb55a2a)(this.readDocumentOrFolder_, this),
            'Folder': (0, $a4f89edd2ef65182$export$b2d5eb949eb55a2a)(this.readDocumentOrFolder_, this),
            'Placemark': (0, $a4f89edd2ef65182$export$18ed2f5932a1b385)(this.readPlacemark_, this),
            'Style': this.readSharedStyle_.bind(this),
            'StyleMap': this.readSharedStyleMap_.bind(this)
        });
        /** @type {Array<Feature>} */ // @ts-ignore
        const features = (0, $a4f89edd2ef65182$export$5c934df85741dbd1)([], parsersNS, node, objectStack, this);
        if (features) return features;
        return undefined;
    }
    /**
   * @param {Element} node Node.
   * @param {Array<*>} objectStack Object stack.
   * @private
   * @return {Feature|undefined} Feature.
   */ readPlacemark_(node, objectStack) {
        const object = (0, $a4f89edd2ef65182$export$5c934df85741dbd1)({
            'geometry': null
        }, $1140dfbeee585f32$var$PLACEMARK_PARSERS, node, objectStack, this);
        if (!object) return undefined;
        const feature = new (0, $9fd014ab6df63665$export$2e2bcd8739ae039)();
        const id = node.getAttribute('id');
        if (id !== null) feature.setId(id);
        const options = /** @type {import("./Feature.js").ReadOptions} */ objectStack[0];
        const geometry = object['geometry'];
        if (geometry) (0, $ec084d0ff9c13a22$export$7beeea566b560d4)(geometry, false, options);
        feature.setGeometry(geometry);
        delete object['geometry'];
        if (this.extractStyles_) {
            const style = object['Style'];
            const styleUrl = object['styleUrl'];
            const styleFunction = $1140dfbeee585f32$var$createFeatureStyleFunction(style, styleUrl, this.defaultStyle_, this.sharedStyles_, this.showPointNames_);
            feature.setStyle(styleFunction);
        }
        delete object['Style'];
        // we do not remove the styleUrl property from the object, so it
        // gets stored on feature when setProperties is called
        feature.setProperties(object, true);
        return feature;
    }
    /**
   * @param {Element} node Node.
   * @param {Array<*>} objectStack Object stack.
   * @private
   */ readSharedStyle_(node, objectStack) {
        const id = node.getAttribute('id');
        if (id !== null) {
            const style = $1140dfbeee585f32$var$readStyle.call(this, node, objectStack);
            if (style) {
                let styleUri;
                let baseURI = node.baseURI;
                if (!baseURI || baseURI == 'about:blank') baseURI = window.location.href;
                if (baseURI) {
                    const url = new URL('#' + id, baseURI);
                    styleUri = url.href;
                } else styleUri = '#' + id;
                this.sharedStyles_[styleUri] = style;
            }
        }
    }
    /**
   * @param {Element} node Node.
   * @param {Array<*>} objectStack Object stack.
   * @private
   */ readSharedStyleMap_(node, objectStack) {
        const id = node.getAttribute('id');
        if (id === null) return;
        const styleMapValue = $1140dfbeee585f32$var$readStyleMapValue.call(this, node, objectStack);
        if (!styleMapValue) return;
        let styleUri;
        let baseURI = node.baseURI;
        if (!baseURI || baseURI == 'about:blank') baseURI = window.location.href;
        if (baseURI) {
            const url = new URL('#' + id, baseURI);
            styleUri = url.href;
        } else styleUri = '#' + id;
        this.sharedStyles_[styleUri] = styleMapValue;
    }
    /**
   * @param {Element} node Node.
   * @param {import("./Feature.js").ReadOptions} [options] Options.
   * @return {import("../Feature.js").default} Feature.
   * @override
   */ readFeatureFromNode(node, options) {
        if (!$1140dfbeee585f32$var$NAMESPACE_URIS.includes(node.namespaceURI)) return null;
        const feature = this.readPlacemark_(node, [
            this.getReadOptions(node, options)
        ]);
        if (feature) return feature;
        return null;
    }
    /**
   * @protected
   * @param {Element} node Node.
   * @param {import("./Feature.js").ReadOptions} [options] Options.
   * @return {Array<import("../Feature.js").default>} Features.
   * @override
   */ readFeaturesFromNode(node, options) {
        if (!$1140dfbeee585f32$var$NAMESPACE_URIS.includes(node.namespaceURI)) return [];
        let features;
        const localName = node.localName;
        if (localName == 'Document' || localName == 'Folder') {
            features = this.readDocumentOrFolder_(node, [
                this.getReadOptions(node, options)
            ]);
            if (features) return features;
            return [];
        }
        if (localName == 'Placemark') {
            const feature = this.readPlacemark_(node, [
                this.getReadOptions(node, options)
            ]);
            if (feature) return [
                feature
            ];
            return [];
        }
        if (localName == 'kml') {
            features = [];
            for(let n = node.firstElementChild; n; n = n.nextElementSibling){
                const fs = this.readFeaturesFromNode(n, options);
                if (fs) (0, $b998d41b678ed5d1$export$8b58be045bf06082)(features, fs);
            }
            return features;
        }
        return [];
    }
    /**
   * Read the name of the KML.
   *
   * @param {Document|Element|string} source Source.
   * @return {string|undefined} Name.
   * @api
   */ readName(source) {
        if (!source) return undefined;
        if (typeof source === 'string') {
            const doc = (0, $a4f89edd2ef65182$export$98e6a39c04603d36)(source);
            return this.readNameFromDocument(doc);
        }
        if ((0, $a4f89edd2ef65182$export$62858bae88b53fd0)(source)) return this.readNameFromDocument(/** @type {Document} */ source);
        return this.readNameFromNode(/** @type {Element} */ source);
    }
    /**
   * @param {Document} doc Document.
   * @return {string|undefined} Name.
   */ readNameFromDocument(doc) {
        for(let n = /** @type {Node} */ doc.firstChild; n; n = n.nextSibling)if (n.nodeType == Node.ELEMENT_NODE) {
            const name = this.readNameFromNode(/** @type {Element} */ n);
            if (name) return name;
        }
        return undefined;
    }
    /**
   * @param {Element} node Node.
   * @return {string|undefined} Name.
   */ readNameFromNode(node) {
        for(let n = node.firstElementChild; n; n = n.nextElementSibling){
            if ($1140dfbeee585f32$var$NAMESPACE_URIS.includes(n.namespaceURI) && n.localName == 'name') return (0, $d5e0fde316cac971$export$dda73877cb166cd3)(n);
        }
        for(let n = node.firstElementChild; n; n = n.nextElementSibling){
            const localName = n.localName;
            if ($1140dfbeee585f32$var$NAMESPACE_URIS.includes(n.namespaceURI) && (localName == 'Document' || localName == 'Folder' || localName == 'Placemark' || localName == 'kml')) {
                const name = this.readNameFromNode(n);
                if (name) return name;
            }
        }
        return undefined;
    }
    /**
   * Read the network links of the KML.
   *
   * @param {Document|Element|string} source Source.
   * @return {Array<Object>} Network links.
   * @api
   */ readNetworkLinks(source) {
        const networkLinks = [];
        if (typeof source === 'string') {
            const doc = (0, $a4f89edd2ef65182$export$98e6a39c04603d36)(source);
            (0, $b998d41b678ed5d1$export$8b58be045bf06082)(networkLinks, this.readNetworkLinksFromDocument(doc));
        } else if ((0, $a4f89edd2ef65182$export$62858bae88b53fd0)(source)) (0, $b998d41b678ed5d1$export$8b58be045bf06082)(networkLinks, this.readNetworkLinksFromDocument(/** @type {Document} */ source));
        else (0, $b998d41b678ed5d1$export$8b58be045bf06082)(networkLinks, this.readNetworkLinksFromNode(/** @type {Element} */ source));
        return networkLinks;
    }
    /**
   * @param {Document} doc Document.
   * @return {Array<Object>} Network links.
   */ readNetworkLinksFromDocument(doc) {
        const networkLinks = [];
        for(let n = /** @type {Node} */ doc.firstChild; n; n = n.nextSibling)if (n.nodeType == Node.ELEMENT_NODE) (0, $b998d41b678ed5d1$export$8b58be045bf06082)(networkLinks, this.readNetworkLinksFromNode(/** @type {Element} */ n));
        return networkLinks;
    }
    /**
   * @param {Element} node Node.
   * @return {Array<Object>} Network links.
   */ readNetworkLinksFromNode(node) {
        const networkLinks = [];
        for(let n = node.firstElementChild; n; n = n.nextElementSibling)if ($1140dfbeee585f32$var$NAMESPACE_URIS.includes(n.namespaceURI) && n.localName == 'NetworkLink') {
            const obj = (0, $a4f89edd2ef65182$export$5c934df85741dbd1)({}, $1140dfbeee585f32$var$NETWORK_LINK_PARSERS, n, []);
            networkLinks.push(obj);
        }
        for(let n = node.firstElementChild; n; n = n.nextElementSibling){
            const localName = n.localName;
            if ($1140dfbeee585f32$var$NAMESPACE_URIS.includes(n.namespaceURI) && (localName == 'Document' || localName == 'Folder' || localName == 'kml')) (0, $b998d41b678ed5d1$export$8b58be045bf06082)(networkLinks, this.readNetworkLinksFromNode(n));
        }
        return networkLinks;
    }
    /**
   * Read the regions of the KML.
   *
   * @param {Document|Element|string} source Source.
   * @return {Array<Object>} Regions.
   * @api
   */ readRegion(source) {
        const regions = [];
        if (typeof source === 'string') {
            const doc = (0, $a4f89edd2ef65182$export$98e6a39c04603d36)(source);
            (0, $b998d41b678ed5d1$export$8b58be045bf06082)(regions, this.readRegionFromDocument(doc));
        } else if ((0, $a4f89edd2ef65182$export$62858bae88b53fd0)(source)) (0, $b998d41b678ed5d1$export$8b58be045bf06082)(regions, this.readRegionFromDocument(/** @type {Document} */ source));
        else (0, $b998d41b678ed5d1$export$8b58be045bf06082)(regions, this.readRegionFromNode(/** @type {Element} */ source));
        return regions;
    }
    /**
   * @param {Document} doc Document.
   * @return {Array<Object>} Region.
   */ readRegionFromDocument(doc) {
        const regions = [];
        for(let n = /** @type {Node} */ doc.firstChild; n; n = n.nextSibling)if (n.nodeType == Node.ELEMENT_NODE) (0, $b998d41b678ed5d1$export$8b58be045bf06082)(regions, this.readRegionFromNode(/** @type {Element} */ n));
        return regions;
    }
    /**
   * @param {Element} node Node.
   * @return {Array<Object>} Region.
   * @api
   */ readRegionFromNode(node) {
        const regions = [];
        for(let n = node.firstElementChild; n; n = n.nextElementSibling)if ($1140dfbeee585f32$var$NAMESPACE_URIS.includes(n.namespaceURI) && n.localName == 'Region') {
            const obj = (0, $a4f89edd2ef65182$export$5c934df85741dbd1)({}, $1140dfbeee585f32$var$REGION_PARSERS, n, []);
            regions.push(obj);
        }
        for(let n = node.firstElementChild; n; n = n.nextElementSibling){
            const localName = n.localName;
            if ($1140dfbeee585f32$var$NAMESPACE_URIS.includes(n.namespaceURI) && (localName == 'Document' || localName == 'Folder' || localName == 'kml')) (0, $b998d41b678ed5d1$export$8b58be045bf06082)(regions, this.readRegionFromNode(n));
        }
        return regions;
    }
    /**
   * @typedef {Object} KMLCamera Specifies the observer's viewpoint and associated view parameters.
   * @property {number} [Latitude] Latitude of the camera.
   * @property {number} [Longitude] Longitude of the camera.
   * @property {number} [Altitude] Altitude of the camera.
   * @property {string} [AltitudeMode] Floor-related altitude mode.
   * @property {number} [Heading] Horizontal camera rotation.
   * @property {number} [Tilt] Lateral camera rotation.
   * @property {number} [Roll] Vertical camera rotation.
   */ /**
   * Read the cameras of the KML.
   *
   * @param {Document|Element|string} source Source.
   * @return {Array<KMLCamera>} Cameras.
   * @api
   */ readCamera(source) {
        const cameras = [];
        if (typeof source === 'string') {
            const doc = (0, $a4f89edd2ef65182$export$98e6a39c04603d36)(source);
            (0, $b998d41b678ed5d1$export$8b58be045bf06082)(cameras, this.readCameraFromDocument(doc));
        } else if ((0, $a4f89edd2ef65182$export$62858bae88b53fd0)(source)) (0, $b998d41b678ed5d1$export$8b58be045bf06082)(cameras, this.readCameraFromDocument(/** @type {Document} */ source));
        else (0, $b998d41b678ed5d1$export$8b58be045bf06082)(cameras, this.readCameraFromNode(/** @type {Element} */ source));
        return cameras;
    }
    /**
   * @param {Document} doc Document.
   * @return {Array<KMLCamera>} Cameras.
   */ readCameraFromDocument(doc) {
        const cameras = [];
        for(let n = /** @type {Node} */ doc.firstChild; n; n = n.nextSibling)if (n.nodeType === Node.ELEMENT_NODE) (0, $b998d41b678ed5d1$export$8b58be045bf06082)(cameras, this.readCameraFromNode(/** @type {Element} */ n));
        return cameras;
    }
    /**
   * @param {Element} node Node.
   * @return {Array<KMLCamera>} Cameras.
   * @api
   */ readCameraFromNode(node) {
        const cameras = [];
        for(let n = node.firstElementChild; n; n = n.nextElementSibling)if ($1140dfbeee585f32$var$NAMESPACE_URIS.includes(n.namespaceURI) && n.localName === 'Camera') {
            const obj = (0, $a4f89edd2ef65182$export$5c934df85741dbd1)({}, $1140dfbeee585f32$var$CAMERA_PARSERS, n, []);
            cameras.push(obj);
        }
        for(let n = node.firstElementChild; n; n = n.nextElementSibling){
            const localName = n.localName;
            if ($1140dfbeee585f32$var$NAMESPACE_URIS.includes(n.namespaceURI) && (localName === 'Document' || localName === 'Folder' || localName === 'Placemark' || localName === 'kml')) (0, $b998d41b678ed5d1$export$8b58be045bf06082)(cameras, this.readCameraFromNode(n));
        }
        return cameras;
    }
    /**
   * Encode an array of features in the KML format as an XML node. GeometryCollections,
   * MultiPoints, MultiLineStrings, and MultiPolygons are output as MultiGeometries.
   *
   * @param {Array<Feature>} features Features.
   * @param {import("./Feature.js").WriteOptions} [options] Options.
   * @return {Node} Node.
   * @api
   * @override
   */ writeFeaturesNode(features, options) {
        options = this.adaptOptions(options);
        const kml = (0, $a4f89edd2ef65182$export$7094a064528c7fee)($1140dfbeee585f32$var$NAMESPACE_URIS[4], 'kml');
        const xmlnsUri = 'http://www.w3.org/2000/xmlns/';
        kml.setAttributeNS(xmlnsUri, 'xmlns:gx', $1140dfbeee585f32$var$GX_NAMESPACE_URIS[0]);
        kml.setAttributeNS(xmlnsUri, 'xmlns:xsi', (0, $a4f89edd2ef65182$export$be284679de3fbea8));
        kml.setAttributeNS((0, $a4f89edd2ef65182$export$be284679de3fbea8), 'xsi:schemaLocation', $1140dfbeee585f32$var$SCHEMA_LOCATION);
        const /** @type {import("../xml.js").NodeStackItem} */ context = {
            node: kml
        };
        /** @type {!Object<string, (Array<Feature>|Feature|undefined)>} */ const properties = {};
        if (features.length > 1) properties['Document'] = features;
        else if (features.length == 1) properties['Placemark'] = features[0];
        const orderedKeys = $1140dfbeee585f32$var$KML_SEQUENCE[kml.namespaceURI];
        const values = (0, $a4f89edd2ef65182$export$939885a13683f4dc)(properties, orderedKeys);
        (0, $a4f89edd2ef65182$export$a79a01f4edad8da8)(context, $1140dfbeee585f32$var$KML_SERIALIZERS, (0, $a4f89edd2ef65182$export$d91b08b611cef144), values, [
            options
        ], orderedKeys, this);
        return kml;
    }
}
/**
 * @param {Style|undefined} foundStyle Style.
 * @param {string} name Name.
 * @return {Style} style Style.
 */ function $1140dfbeee585f32$var$createNameStyleFunction(foundStyle, name) {
    const textOffset = [
        0,
        0
    ];
    /** @type {CanvasTextAlign} */ let textAlign = 'start';
    const imageStyle = foundStyle.getImage();
    if (imageStyle) {
        const imageSize = imageStyle.getSize();
        if (imageSize && imageSize.length == 2) {
            const imageScale = imageStyle.getScaleArray();
            const anchor = imageStyle.getAnchor();
            // Offset the label to be centered to the right of the icon,
            // if there is one.
            textOffset[0] = imageScale[0] * (imageSize[0] - anchor[0]);
            textOffset[1] = imageScale[1] * (imageSize[1] / 2 - anchor[1]);
            textAlign = 'left';
        }
    }
    let textStyle = foundStyle.getText();
    if (textStyle) {
        // clone the text style, customizing it with name, alignments and offset.
        // Note that kml does not support many text options that OpenLayers does (rotation, textBaseline).
        textStyle = textStyle.clone();
        textStyle.setFont(textStyle.getFont() || $1140dfbeee585f32$var$DEFAULT_TEXT_STYLE.getFont());
        textStyle.setScale(textStyle.getScale() || $1140dfbeee585f32$var$DEFAULT_TEXT_STYLE.getScale());
        textStyle.setFill(textStyle.getFill() || $1140dfbeee585f32$var$DEFAULT_TEXT_STYLE.getFill());
        textStyle.setStroke(textStyle.getStroke() || $1140dfbeee585f32$var$DEFAULT_TEXT_STROKE_STYLE);
    } else textStyle = $1140dfbeee585f32$var$DEFAULT_TEXT_STYLE.clone();
    textStyle.setText(name);
    textStyle.setOffsetX(textOffset[0]);
    textStyle.setOffsetY(textOffset[1]);
    textStyle.setTextAlign(textAlign);
    const nameStyle = new (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)({
        image: imageStyle,
        text: textStyle
    });
    return nameStyle;
}
/**
 * @param {Array<Style>|undefined} style Style.
 * @param {string} styleUrl Style URL.
 * @param {Array<Style>} defaultStyle Default style.
 * @param {!Object<string, (Array<Style>|string)>} sharedStyles Shared styles.
 * @param {boolean|undefined} showPointNames true to show names for point placemarks.
 * @return {import("../style/Style.js").StyleFunction} Feature style function.
 */ function $1140dfbeee585f32$var$createFeatureStyleFunction(style, styleUrl, defaultStyle, sharedStyles, showPointNames) {
    return(/**
     * @param {Feature} feature feature.
     * @param {number} resolution Resolution.
     * @return {Array<Style>|Style} Style.
     */ function(feature, resolution) {
        let drawName = showPointNames;
        let name = '';
        let multiGeometryPoints = [];
        if (drawName) {
            const geometry = feature.getGeometry();
            if (geometry) {
                if (geometry instanceof (0, $0e4f3959219eede5$export$2e2bcd8739ae039)) {
                    multiGeometryPoints = geometry.getGeometriesArrayRecursive().filter(function(geometry) {
                        const type = geometry.getType();
                        return type === 'Point' || type === 'MultiPoint';
                    });
                    drawName = multiGeometryPoints.length > 0;
                } else {
                    const type = geometry.getType();
                    drawName = type === 'Point' || type === 'MultiPoint';
                }
            }
        }
        if (drawName) {
            name = /** @type {string} */ feature.get('name');
            drawName = drawName && !!name;
            // convert any html character codes
            if (drawName && /&[^&]+;/.test(name)) {
                if (!$1140dfbeee585f32$var$TEXTAREA) $1140dfbeee585f32$var$TEXTAREA = document.createElement('textarea');
                $1140dfbeee585f32$var$TEXTAREA.innerHTML = name;
                name = $1140dfbeee585f32$var$TEXTAREA.value;
            }
        }
        let featureStyle = defaultStyle;
        if (style) featureStyle = style;
        else if (styleUrl) featureStyle = $1140dfbeee585f32$var$findStyle(styleUrl, defaultStyle, sharedStyles);
        if (drawName) {
            const nameStyle = $1140dfbeee585f32$var$createNameStyleFunction(featureStyle[0], name);
            if (multiGeometryPoints.length > 0) {
                // in multigeometries restrict the name style to points and create a
                // style without image or text for geometries requiring fill or stroke
                // including any polygon specific style if there is one
                nameStyle.setGeometry(new (0, $0e4f3959219eede5$export$2e2bcd8739ae039)(multiGeometryPoints));
                const baseStyle = new (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)({
                    geometry: featureStyle[0].getGeometry(),
                    image: null,
                    fill: featureStyle[0].getFill(),
                    stroke: featureStyle[0].getStroke(),
                    text: null
                });
                return [
                    nameStyle,
                    baseStyle
                ].concat(featureStyle.slice(1));
            }
            return nameStyle;
        }
        return featureStyle;
    });
}
/**
 * @param {Array<Style>|string|undefined} styleValue Style value.
 * @param {Array<Style>} defaultStyle Default style.
 * @param {!Object<string, (Array<Style>|string)>} sharedStyles
 * Shared styles.
 * @return {Array<Style>} Style.
 */ function $1140dfbeee585f32$var$findStyle(styleValue, defaultStyle, sharedStyles) {
    if (Array.isArray(styleValue)) return styleValue;
    if (typeof styleValue === 'string') return $1140dfbeee585f32$var$findStyle(sharedStyles[styleValue], defaultStyle, sharedStyles);
    return defaultStyle;
}
/**
 * @param {Node} node Node.
 * @return {import("../color.js").Color|undefined} Color.
 */ function $1140dfbeee585f32$var$readColor(node) {
    const s = (0, $a4f89edd2ef65182$export$b089dda0fde13047)(node, false);
    // The KML specification states that colors should not include a leading `#`
    // but we tolerate them.
    const m = /^\s*#?\s*([0-9A-Fa-f]{8})\s*$/.exec(s);
    if (m) {
        const hexColor = m[1];
        return [
            parseInt(hexColor.substr(6, 2), 16),
            parseInt(hexColor.substr(4, 2), 16),
            parseInt(hexColor.substr(2, 2), 16),
            parseInt(hexColor.substr(0, 2), 16) / 255
        ];
    }
    return undefined;
}
function $1140dfbeee585f32$export$b231062f8c36cd1(node) {
    let s = (0, $a4f89edd2ef65182$export$b089dda0fde13047)(node, false);
    const flatCoordinates = [];
    // The KML specification states that coordinate tuples should not include
    // spaces, but we tolerate them.
    s = s.replace(/\s*,\s*/g, ',');
    const re = /^\s*([+\-]?\d*\.?\d+(?:e[+\-]?\d+)?),([+\-]?\d*\.?\d+(?:e[+\-]?\d+)?)(?:\s+|,|$)(?:([+\-]?\d*\.?\d+(?:e[+\-]?\d+)?)(?:\s+|$))?\s*/i;
    let m;
    while(m = re.exec(s)){
        const x = parseFloat(m[1]);
        const y = parseFloat(m[2]);
        const z = m[3] ? parseFloat(m[3]) : 0;
        flatCoordinates.push(x, y, z);
        s = s.substr(m[0].length);
    }
    if (s !== '') return undefined;
    return flatCoordinates;
}
/**
 * @param {Node} node Node.
 * @return {string} URI.
 */ function $1140dfbeee585f32$var$readURI(node) {
    const s = (0, $a4f89edd2ef65182$export$b089dda0fde13047)(node, false).trim();
    let baseURI = node.baseURI;
    if (!baseURI || baseURI == 'about:blank') baseURI = window.location.href;
    if (baseURI) {
        const url = new URL(s, baseURI);
        return url.href;
    }
    return s;
}
/**
 * @param {Node} node Node.
 * @return {string} URI.
 */ function $1140dfbeee585f32$var$readStyleURL(node) {
    // KML files in the wild occasionally forget the leading
    // `#` on styleUrlsdefined in the same document.
    const s = (0, $a4f89edd2ef65182$export$b089dda0fde13047)(node, false).trim().replace(/^(?!.*#)/, '#');
    let baseURI = node.baseURI;
    if (!baseURI || baseURI == 'about:blank') baseURI = window.location.href;
    if (baseURI) {
        const url = new URL(s, baseURI);
        return url.href;
    }
    return s;
}
/**
 * @param {Element} node Node.
 * @return {Vec2} Vec2.
 */ function $1140dfbeee585f32$var$readVec2(node) {
    const xunits = node.getAttribute('xunits');
    const yunits = node.getAttribute('yunits');
    /** @type {import('../style/Icon.js').IconOrigin} */ let origin;
    if (xunits !== 'insetPixels') {
        if (yunits !== 'insetPixels') origin = 'bottom-left';
        else origin = 'top-left';
    } else if (yunits !== 'insetPixels') origin = 'bottom-right';
    else origin = 'top-right';
    return {
        x: parseFloat(node.getAttribute('x')),
        xunits: $1140dfbeee585f32$var$ICON_ANCHOR_UNITS_MAP[xunits],
        y: parseFloat(node.getAttribute('y')),
        yunits: $1140dfbeee585f32$var$ICON_ANCHOR_UNITS_MAP[yunits],
        origin: origin
    };
}
/**
 * @param {Node} node Node.
 * @return {number|undefined} Scale.
 */ function $1140dfbeee585f32$var$readScale(node) {
    return (0, $d5e0fde316cac971$export$5be9c99d34ad295b)(node);
}
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$STYLE_MAP_PARSERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, {
    'Pair': $1140dfbeee585f32$var$pairDataParser
});
/**
 * @this {KML}
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {Array<Style>|string|undefined} StyleMap.
 */ function $1140dfbeee585f32$var$readStyleMapValue(node, objectStack) {
    return (0, $a4f89edd2ef65182$export$5c934df85741dbd1)(undefined, $1140dfbeee585f32$var$STYLE_MAP_PARSERS, node, objectStack, this);
}
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$ICON_STYLE_PARSERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, {
    'Icon': (0, $a4f89edd2ef65182$export$b69a91976ee81208)($1140dfbeee585f32$var$readIcon),
    'color': (0, $a4f89edd2ef65182$export$b69a91976ee81208)($1140dfbeee585f32$var$readColor),
    'heading': (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$5be9c99d34ad295b)),
    'hotSpot': (0, $a4f89edd2ef65182$export$b69a91976ee81208)($1140dfbeee585f32$var$readVec2),
    'scale': (0, $a4f89edd2ef65182$export$b69a91976ee81208)($1140dfbeee585f32$var$readScale)
});
/**
 * @this {KML}
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 */ function $1140dfbeee585f32$var$iconStyleParser(node, objectStack) {
    // FIXME refreshMode
    // FIXME refreshInterval
    // FIXME viewRefreshTime
    // FIXME viewBoundScale
    // FIXME viewFormat
    // FIXME httpQuery
    const object = (0, $a4f89edd2ef65182$export$5c934df85741dbd1)({}, $1140dfbeee585f32$var$ICON_STYLE_PARSERS, node, objectStack);
    if (!object) return;
    const styleObject = /** @type {Object} */ objectStack[objectStack.length - 1];
    const IconObject = 'Icon' in object ? object['Icon'] : {};
    const drawIcon = !('Icon' in object) || Object.keys(IconObject).length > 0;
    let src;
    const href = /** @type {string|undefined} */ IconObject['href'];
    if (href) src = href;
    else if (drawIcon) src = $1140dfbeee585f32$var$DEFAULT_IMAGE_STYLE_SRC;
    let anchor, anchorXUnits, anchorYUnits;
    /** @type {import('../style/Icon.js').IconOrigin|undefined} */ let anchorOrigin = 'bottom-left';
    const hotSpot = /** @type {Vec2|undefined} */ object['hotSpot'];
    if (hotSpot) {
        anchor = [
            hotSpot.x,
            hotSpot.y
        ];
        anchorXUnits = hotSpot.xunits;
        anchorYUnits = hotSpot.yunits;
        anchorOrigin = hotSpot.origin;
    } else if (/^https?:\/\/maps\.(?:google|gstatic)\.com\//.test(src)) {
        // Google hotspots from https://kml4earth.appspot.com/icons.html#notes
        if (src.includes('pushpin')) {
            anchor = $1140dfbeee585f32$var$DEFAULT_IMAGE_STYLE_ANCHOR;
            anchorXUnits = $1140dfbeee585f32$var$DEFAULT_IMAGE_STYLE_ANCHOR_X_UNITS;
            anchorYUnits = $1140dfbeee585f32$var$DEFAULT_IMAGE_STYLE_ANCHOR_Y_UNITS;
        } else if (src.includes('arrow-reverse')) {
            anchor = [
                54,
                42
            ];
            anchorXUnits = $1140dfbeee585f32$var$DEFAULT_IMAGE_STYLE_ANCHOR_X_UNITS;
            anchorYUnits = $1140dfbeee585f32$var$DEFAULT_IMAGE_STYLE_ANCHOR_Y_UNITS;
        } else if (src.includes('paddle')) {
            anchor = [
                32,
                1
            ];
            anchorXUnits = $1140dfbeee585f32$var$DEFAULT_IMAGE_STYLE_ANCHOR_X_UNITS;
            anchorYUnits = $1140dfbeee585f32$var$DEFAULT_IMAGE_STYLE_ANCHOR_Y_UNITS;
        }
    }
    let offset;
    const x = /** @type {number|undefined} */ IconObject['x'];
    const y = /** @type {number|undefined} */ IconObject['y'];
    if (x !== undefined && y !== undefined) offset = [
        x,
        y
    ];
    let size;
    const w = /** @type {number|undefined} */ IconObject['w'];
    const h = /** @type {number|undefined} */ IconObject['h'];
    if (w !== undefined && h !== undefined) size = [
        w,
        h
    ];
    let rotation;
    const heading = /** @type {number} */ object['heading'];
    if (heading !== undefined) rotation = (0, $6b000a049d919fe5$export$cba01ba138429a1d)(heading);
    const scale = /** @type {number|undefined} */ object['scale'];
    const color = /** @type {Array<number>|undefined} */ object['color'];
    if (drawIcon) {
        if (src == $1140dfbeee585f32$var$DEFAULT_IMAGE_STYLE_SRC) size = $1140dfbeee585f32$var$DEFAULT_IMAGE_STYLE_SIZE;
        const imageStyle = new (0, $8463d325b53eeb0c$export$2e2bcd8739ae039)({
            anchor: anchor,
            anchorOrigin: anchorOrigin,
            anchorXUnits: anchorXUnits,
            anchorYUnits: anchorYUnits,
            crossOrigin: this.crossOrigin_,
            offset: offset,
            offsetOrigin: 'bottom-left',
            rotation: rotation,
            scale: scale,
            size: size,
            src: this.iconUrlFunction_(src),
            color: color
        });
        const imageScale = imageStyle.getScaleArray()[0];
        const imageSize = imageStyle.getSize();
        if (imageSize === null) {
            const imageState = imageStyle.getImageState();
            if (imageState === (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).IDLE || imageState === (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADING) {
                const listener = function() {
                    const imageState = imageStyle.getImageState();
                    if (!(imageState === (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).IDLE || imageState === (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADING)) {
                        const imageSize = imageStyle.getSize();
                        if (imageSize && imageSize.length == 2) {
                            const resizeScale = $1140dfbeee585f32$var$scaleForSize(imageSize);
                            imageStyle.setScale(imageScale * resizeScale);
                        }
                        imageStyle.unlistenImageChange(listener);
                    }
                };
                imageStyle.listenImageChange(listener);
                if (imageState === (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).IDLE) imageStyle.load();
            }
        } else if (imageSize.length == 2) {
            const resizeScale = $1140dfbeee585f32$var$scaleForSize(imageSize);
            imageStyle.setScale(imageScale * resizeScale);
        }
        styleObject['imageStyle'] = imageStyle;
    } else // handle the case when we explicitly want to draw no icon.
    styleObject['imageStyle'] = $1140dfbeee585f32$var$DEFAULT_NO_IMAGE_STYLE;
}
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$LABEL_STYLE_PARSERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, {
    'color': (0, $a4f89edd2ef65182$export$b69a91976ee81208)($1140dfbeee585f32$var$readColor),
    'scale': (0, $a4f89edd2ef65182$export$b69a91976ee81208)($1140dfbeee585f32$var$readScale)
});
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 */ function $1140dfbeee585f32$var$labelStyleParser(node, objectStack) {
    // FIXME colorMode
    const object = (0, $a4f89edd2ef65182$export$5c934df85741dbd1)({}, $1140dfbeee585f32$var$LABEL_STYLE_PARSERS, node, objectStack);
    if (!object) return;
    const styleObject = objectStack[objectStack.length - 1];
    const textStyle = new (0, $944be50faeff5321$export$2e2bcd8739ae039)({
        fill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
            color: /** @type {import("../color.js").Color} */ 'color' in object ? object['color'] : $1140dfbeee585f32$var$DEFAULT_COLOR
        }),
        scale: /** @type {number|undefined} */ object['scale']
    });
    styleObject['textStyle'] = textStyle;
}
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$LINE_STYLE_PARSERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, {
    'color': (0, $a4f89edd2ef65182$export$b69a91976ee81208)($1140dfbeee585f32$var$readColor),
    'width': (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$5be9c99d34ad295b))
});
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 */ function $1140dfbeee585f32$var$lineStyleParser(node, objectStack) {
    // FIXME colorMode
    // FIXME gx:outerColor
    // FIXME gx:outerWidth
    // FIXME gx:physicalWidth
    // FIXME gx:labelVisibility
    const object = (0, $a4f89edd2ef65182$export$5c934df85741dbd1)({}, $1140dfbeee585f32$var$LINE_STYLE_PARSERS, node, objectStack);
    if (!object) return;
    const styleObject = objectStack[objectStack.length - 1];
    const strokeStyle = new (0, $f9d0329c5c745263$export$2e2bcd8739ae039)({
        color: /** @type {import("../color.js").Color} */ 'color' in object ? object['color'] : $1140dfbeee585f32$var$DEFAULT_COLOR,
        width: /** @type {number} */ 'width' in object ? object['width'] : 1
    });
    styleObject['strokeStyle'] = strokeStyle;
}
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$POLY_STYLE_PARSERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, {
    'color': (0, $a4f89edd2ef65182$export$b69a91976ee81208)($1140dfbeee585f32$var$readColor),
    'fill': (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$f9a84177eae95ed5)),
    'outline': (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$f9a84177eae95ed5))
});
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 */ function $1140dfbeee585f32$var$polyStyleParser(node, objectStack) {
    // FIXME colorMode
    const object = (0, $a4f89edd2ef65182$export$5c934df85741dbd1)({}, $1140dfbeee585f32$var$POLY_STYLE_PARSERS, node, objectStack);
    if (!object) return;
    const styleObject = objectStack[objectStack.length - 1];
    const fillStyle = new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
        color: /** @type {import("../color.js").Color} */ 'color' in object ? object['color'] : $1140dfbeee585f32$var$DEFAULT_COLOR
    });
    styleObject['fillStyle'] = fillStyle;
    const fill = /** @type {boolean|undefined} */ object['fill'];
    if (fill !== undefined) styleObject['fill'] = fill;
    const outline = /** @type {boolean|undefined} */ object['outline'];
    if (outline !== undefined) styleObject['outline'] = outline;
}
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$FLAT_LINEAR_RING_PARSERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, {
    'coordinates': (0, $a4f89edd2ef65182$export$b1b80676c57c5713)($1140dfbeee585f32$export$b231062f8c36cd1)
});
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {Array<number>} LinearRing flat coordinates.
 */ function $1140dfbeee585f32$var$readFlatLinearRing(node, objectStack) {
    return (0, $a4f89edd2ef65182$export$5c934df85741dbd1)(null, $1140dfbeee585f32$var$FLAT_LINEAR_RING_PARSERS, node, objectStack);
}
/**
 * @param {Node} node Node.
 * @param {Array<*>} objectStack Object stack.
 */ function $1140dfbeee585f32$var$gxCoordParser(node, objectStack) {
    const gxTrackObject = /** @type {GxTrackObject} */ objectStack[objectStack.length - 1];
    const coordinates = gxTrackObject.coordinates;
    const s = (0, $a4f89edd2ef65182$export$b089dda0fde13047)(node, false);
    const re = /^\s*([+\-]?\d+(?:\.\d*)?(?:e[+\-]?\d*)?)\s+([+\-]?\d+(?:\.\d*)?(?:e[+\-]?\d*)?)\s+([+\-]?\d+(?:\.\d*)?(?:e[+\-]?\d*)?)\s*$/i;
    const m = re.exec(s);
    if (m) {
        const x = parseFloat(m[1]);
        const y = parseFloat(m[2]);
        const z = parseFloat(m[3]);
        coordinates.push([
            x,
            y,
            z
        ]);
    } else coordinates.push([]);
}
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$GX_MULTITRACK_GEOMETRY_PARSERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$GX_NAMESPACE_URIS, {
    'Track': (0, $a4f89edd2ef65182$export$18ed2f5932a1b385)($1140dfbeee585f32$var$readGxTrack)
});
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {MultiLineString|undefined} MultiLineString.
 */ function $1140dfbeee585f32$var$readGxMultiTrack(node, objectStack) {
    const lineStrings = (0, $a4f89edd2ef65182$export$5c934df85741dbd1)([], $1140dfbeee585f32$var$GX_MULTITRACK_GEOMETRY_PARSERS, node, objectStack);
    if (!lineStrings) return undefined;
    return new (0, $b4c0e2e13beea46e$export$2e2bcd8739ae039)(lineStrings);
}
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$GX_TRACK_PARSERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, {
    'when': $1140dfbeee585f32$var$whenParser
}, (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$GX_NAMESPACE_URIS, {
    'coord': $1140dfbeee585f32$var$gxCoordParser
}));
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {LineString|undefined} LineString.
 */ function $1140dfbeee585f32$var$readGxTrack(node, objectStack) {
    const gxTrackObject = (0, $a4f89edd2ef65182$export$5c934df85741dbd1)(/** @type {GxTrackObject} */ {
        coordinates: [],
        whens: []
    }, $1140dfbeee585f32$var$GX_TRACK_PARSERS, node, objectStack);
    if (!gxTrackObject) return undefined;
    const flatCoordinates = [];
    const coordinates = gxTrackObject.coordinates;
    const whens = gxTrackObject.whens;
    for(let i = 0, ii = Math.min(coordinates.length, whens.length); i < ii; ++i)if (coordinates[i].length == 3) flatCoordinates.push(coordinates[i][0], coordinates[i][1], coordinates[i][2], whens[i]);
    return new (0, $292e4002746c8223$export$2e2bcd8739ae039)(flatCoordinates, 'XYZM');
}
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$ICON_PARSERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, {
    'href': (0, $a4f89edd2ef65182$export$b69a91976ee81208)($1140dfbeee585f32$var$readURI)
}, (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$GX_NAMESPACE_URIS, {
    'x': (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$5be9c99d34ad295b)),
    'y': (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$5be9c99d34ad295b)),
    'w': (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$5be9c99d34ad295b)),
    'h': (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$5be9c99d34ad295b))
}));
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {Object} Icon object.
 */ function $1140dfbeee585f32$var$readIcon(node, objectStack) {
    const iconObject = (0, $a4f89edd2ef65182$export$5c934df85741dbd1)({}, $1140dfbeee585f32$var$ICON_PARSERS, node, objectStack);
    if (iconObject) return iconObject;
    return null;
}
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$GEOMETRY_FLAT_COORDINATES_PARSERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, {
    'coordinates': (0, $a4f89edd2ef65182$export$b1b80676c57c5713)($1140dfbeee585f32$export$b231062f8c36cd1)
});
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {Array<number>} Flat coordinates.
 */ function $1140dfbeee585f32$var$readFlatCoordinatesFromNode(node, objectStack) {
    return (0, $a4f89edd2ef65182$export$5c934df85741dbd1)(null, $1140dfbeee585f32$var$GEOMETRY_FLAT_COORDINATES_PARSERS, node, objectStack);
}
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$EXTRUDE_AND_ALTITUDE_MODE_PARSERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, {
    'extrude': (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$f9a84177eae95ed5)),
    'tessellate': (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$f9a84177eae95ed5)),
    'altitudeMode': (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$dda73877cb166cd3))
});
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {LineString|undefined} LineString.
 */ function $1140dfbeee585f32$var$readLineString(node, objectStack) {
    const properties = (0, $a4f89edd2ef65182$export$5c934df85741dbd1)({}, $1140dfbeee585f32$var$EXTRUDE_AND_ALTITUDE_MODE_PARSERS, node, objectStack);
    const flatCoordinates = $1140dfbeee585f32$var$readFlatCoordinatesFromNode(node, objectStack);
    if (flatCoordinates) {
        const lineString = new (0, $292e4002746c8223$export$2e2bcd8739ae039)(flatCoordinates, 'XYZ');
        lineString.setProperties(properties, true);
        return lineString;
    }
    return undefined;
}
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {Polygon|undefined} Polygon.
 */ function $1140dfbeee585f32$var$readLinearRing(node, objectStack) {
    const properties = (0, $a4f89edd2ef65182$export$5c934df85741dbd1)({}, $1140dfbeee585f32$var$EXTRUDE_AND_ALTITUDE_MODE_PARSERS, node, objectStack);
    const flatCoordinates = $1140dfbeee585f32$var$readFlatCoordinatesFromNode(node, objectStack);
    if (flatCoordinates) {
        const polygon = new (0, $40aa8d43bbe572bf$export$2e2bcd8739ae039)(flatCoordinates, 'XYZ', [
            flatCoordinates.length
        ]);
        polygon.setProperties(properties, true);
        return polygon;
    }
    return undefined;
}
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$MULTI_GEOMETRY_PARSERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, {
    'LineString': (0, $a4f89edd2ef65182$export$18ed2f5932a1b385)($1140dfbeee585f32$var$readLineString),
    'LinearRing': (0, $a4f89edd2ef65182$export$18ed2f5932a1b385)($1140dfbeee585f32$var$readLinearRing),
    'MultiGeometry': (0, $a4f89edd2ef65182$export$18ed2f5932a1b385)($1140dfbeee585f32$var$readMultiGeometry),
    'Point': (0, $a4f89edd2ef65182$export$18ed2f5932a1b385)($1140dfbeee585f32$var$readPoint),
    'Polygon': (0, $a4f89edd2ef65182$export$18ed2f5932a1b385)($1140dfbeee585f32$var$readPolygon)
});
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {import("../geom/Geometry.js").default} Geometry.
 */ function $1140dfbeee585f32$var$readMultiGeometry(node, objectStack) {
    const geometries = (0, $a4f89edd2ef65182$export$5c934df85741dbd1)([], $1140dfbeee585f32$var$MULTI_GEOMETRY_PARSERS, node, objectStack);
    if (!geometries) return null;
    if (geometries.length === 0) return new (0, $0e4f3959219eede5$export$2e2bcd8739ae039)(geometries);
    let multiGeometry;
    let homogeneous = true;
    const type = geometries[0].getType();
    let geometry;
    for(let i = 1, ii = geometries.length; i < ii; ++i){
        geometry = geometries[i];
        if (geometry.getType() != type) {
            homogeneous = false;
            break;
        }
    }
    if (homogeneous) {
        let layout;
        let flatCoordinates;
        if (type == 'Point') {
            const point = geometries[0];
            layout = point.getLayout();
            flatCoordinates = point.getFlatCoordinates();
            for(let i = 1, ii = geometries.length; i < ii; ++i){
                geometry = geometries[i];
                (0, $b998d41b678ed5d1$export$8b58be045bf06082)(flatCoordinates, geometry.getFlatCoordinates());
            }
            multiGeometry = new (0, $e6080c63a9451eda$export$2e2bcd8739ae039)(flatCoordinates, layout);
            $1140dfbeee585f32$var$setCommonGeometryProperties(multiGeometry, geometries);
        } else if (type == 'LineString') {
            multiGeometry = new (0, $b4c0e2e13beea46e$export$2e2bcd8739ae039)(geometries);
            $1140dfbeee585f32$var$setCommonGeometryProperties(multiGeometry, geometries);
        } else if (type == 'Polygon') {
            multiGeometry = new (0, $f73f35eb6af8b987$export$2e2bcd8739ae039)(geometries);
            $1140dfbeee585f32$var$setCommonGeometryProperties(multiGeometry, geometries);
        } else if (type == 'GeometryCollection' || type.startsWith('Multi')) multiGeometry = new (0, $0e4f3959219eede5$export$2e2bcd8739ae039)(geometries);
        else throw new Error('Unknown geometry type found');
    } else multiGeometry = new (0, $0e4f3959219eede5$export$2e2bcd8739ae039)(geometries);
    return /** @type {import("../geom/Geometry.js").default} */ multiGeometry;
}
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {Point|undefined} Point.
 */ function $1140dfbeee585f32$var$readPoint(node, objectStack) {
    const properties = (0, $a4f89edd2ef65182$export$5c934df85741dbd1)({}, $1140dfbeee585f32$var$EXTRUDE_AND_ALTITUDE_MODE_PARSERS, node, objectStack);
    const flatCoordinates = $1140dfbeee585f32$var$readFlatCoordinatesFromNode(node, objectStack);
    if (flatCoordinates) {
        const point = new (0, $6eced4c969949f6b$export$2e2bcd8739ae039)(flatCoordinates, 'XYZ');
        point.setProperties(properties, true);
        return point;
    }
    return undefined;
}
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$FLAT_LINEAR_RINGS_PARSERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, {
    'innerBoundaryIs': $1140dfbeee585f32$var$innerBoundaryIsParser,
    'outerBoundaryIs': $1140dfbeee585f32$var$outerBoundaryIsParser
});
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {Polygon|undefined} Polygon.
 */ function $1140dfbeee585f32$var$readPolygon(node, objectStack) {
    const properties = (0, $a4f89edd2ef65182$export$5c934df85741dbd1)(/** @type {Object<string,*>} */ {}, $1140dfbeee585f32$var$EXTRUDE_AND_ALTITUDE_MODE_PARSERS, node, objectStack);
    const flatLinearRings = (0, $a4f89edd2ef65182$export$5c934df85741dbd1)([
        null
    ], $1140dfbeee585f32$var$FLAT_LINEAR_RINGS_PARSERS, node, objectStack);
    if (flatLinearRings && flatLinearRings[0]) {
        const flatCoordinates = flatLinearRings[0];
        const ends = [
            flatCoordinates.length
        ];
        for(let i = 1, ii = flatLinearRings.length; i < ii; ++i){
            (0, $b998d41b678ed5d1$export$8b58be045bf06082)(flatCoordinates, flatLinearRings[i]);
            ends.push(flatCoordinates.length);
        }
        const polygon = new (0, $40aa8d43bbe572bf$export$2e2bcd8739ae039)(flatCoordinates, 'XYZ', ends);
        polygon.setProperties(properties, true);
        return polygon;
    }
    return undefined;
}
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$STYLE_PARSERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, {
    'IconStyle': $1140dfbeee585f32$var$iconStyleParser,
    'LabelStyle': $1140dfbeee585f32$var$labelStyleParser,
    'LineStyle': $1140dfbeee585f32$var$lineStyleParser,
    'PolyStyle': $1140dfbeee585f32$var$polyStyleParser
});
/**
 * @this {KML}
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {Array<Style>} Style.
 */ function $1140dfbeee585f32$var$readStyle(node, objectStack) {
    const styleObject = (0, $a4f89edd2ef65182$export$5c934df85741dbd1)({}, $1140dfbeee585f32$var$STYLE_PARSERS, node, objectStack, this);
    if (!styleObject) return null;
    let fillStyle = /** @type {Fill} */ 'fillStyle' in styleObject ? styleObject['fillStyle'] : $1140dfbeee585f32$var$DEFAULT_FILL_STYLE;
    const fill = /** @type {boolean|undefined} */ styleObject['fill'];
    if (fill !== undefined && !fill) fillStyle = null;
    let imageStyle;
    if ('imageStyle' in styleObject) {
        if (styleObject['imageStyle'] != $1140dfbeee585f32$var$DEFAULT_NO_IMAGE_STYLE) imageStyle = /** @type {import("../style/Image.js").default} */ styleObject['imageStyle'];
    } else imageStyle = $1140dfbeee585f32$var$DEFAULT_IMAGE_STYLE;
    const textStyle = /** @type {Text} */ 'textStyle' in styleObject ? styleObject['textStyle'] : $1140dfbeee585f32$var$DEFAULT_TEXT_STYLE;
    const strokeStyle = /** @type {Stroke} */ 'strokeStyle' in styleObject ? styleObject['strokeStyle'] : $1140dfbeee585f32$var$DEFAULT_STROKE_STYLE;
    const outline = /** @type {boolean|undefined} */ styleObject['outline'];
    if (outline !== undefined && !outline) // if the polystyle specifies no outline two styles are needed,
    // one for non-polygon geometries where linestrings require a stroke
    // and one for polygons where there should be no stroke
    return [
        new (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)({
            geometry: function(feature) {
                const geometry = feature.getGeometry();
                const type = geometry.getType();
                if (type === 'GeometryCollection') {
                    const collection = /** @type {import("../geom/GeometryCollection").default} */ geometry;
                    return new (0, $0e4f3959219eede5$export$2e2bcd8739ae039)(collection.getGeometriesArrayRecursive().filter(function(geometry) {
                        const type = geometry.getType();
                        return type !== 'Polygon' && type !== 'MultiPolygon';
                    }));
                }
                if (type !== 'Polygon' && type !== 'MultiPolygon') return geometry;
            },
            fill: fillStyle,
            image: imageStyle,
            stroke: strokeStyle,
            text: textStyle,
            zIndex: undefined
        }),
        new (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)({
            geometry: function(feature) {
                const geometry = feature.getGeometry();
                const type = geometry.getType();
                if (type === 'GeometryCollection') {
                    const collection = /** @type {import("../geom/GeometryCollection").default} */ geometry;
                    return new (0, $0e4f3959219eede5$export$2e2bcd8739ae039)(collection.getGeometriesArrayRecursive().filter(function(geometry) {
                        const type = geometry.getType();
                        return type === 'Polygon' || type === 'MultiPolygon';
                    }));
                }
                if (type === 'Polygon' || type === 'MultiPolygon') return geometry;
            },
            fill: fillStyle,
            stroke: null,
            zIndex: undefined
        })
    ];
    return [
        new (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)({
            fill: fillStyle,
            image: imageStyle,
            stroke: strokeStyle,
            text: textStyle,
            zIndex: undefined
        })
    ];
}
/**
 * Reads an array of geometries and creates arrays for common geometry
 * properties. Then sets them to the multi geometry.
 * @param {MultiPoint|MultiLineString|MultiPolygon} multiGeometry A multi-geometry.
 * @param {Array<import("../geom/Geometry.js").default>} geometries List of geometries.
 */ function $1140dfbeee585f32$var$setCommonGeometryProperties(multiGeometry, geometries) {
    const ii = geometries.length;
    const extrudes = new Array(geometries.length);
    const tessellates = new Array(geometries.length);
    const altitudeModes = new Array(geometries.length);
    let hasExtrude, hasTessellate, hasAltitudeMode;
    hasExtrude = false;
    hasTessellate = false;
    hasAltitudeMode = false;
    for(let i = 0; i < ii; ++i){
        const geometry = geometries[i];
        extrudes[i] = geometry.get('extrude');
        tessellates[i] = geometry.get('tessellate');
        altitudeModes[i] = geometry.get('altitudeMode');
        hasExtrude = hasExtrude || extrudes[i] !== undefined;
        hasTessellate = hasTessellate || tessellates[i] !== undefined;
        hasAltitudeMode = hasAltitudeMode || altitudeModes[i];
    }
    if (hasExtrude) multiGeometry.set('extrude', extrudes);
    if (hasTessellate) multiGeometry.set('tessellate', tessellates);
    if (hasAltitudeMode) multiGeometry.set('altitudeMode', altitudeModes);
}
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$DATA_PARSERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, {
    'displayName': (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$dda73877cb166cd3)),
    'value': (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$dda73877cb166cd3))
});
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 */ function $1140dfbeee585f32$var$dataParser(node, objectStack) {
    const name = node.getAttribute('name');
    (0, $a4f89edd2ef65182$export$dc8ce45ce1679f4f)($1140dfbeee585f32$var$DATA_PARSERS, node, objectStack);
    const featureObject = /** @type {Object} */ objectStack[objectStack.length - 1];
    if (name && featureObject.displayName) featureObject[name] = {
        value: featureObject.value,
        displayName: featureObject.displayName,
        toString: function() {
            return featureObject.value;
        }
    };
    else if (name !== null) featureObject[name] = featureObject.value;
    else if (featureObject.displayName !== null) featureObject[featureObject.displayName] = featureObject.value;
    delete featureObject['value'];
}
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$EXTENDED_DATA_PARSERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, {
    'Data': $1140dfbeee585f32$var$dataParser,
    'SchemaData': $1140dfbeee585f32$var$schemaDataParser
});
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 */ function $1140dfbeee585f32$var$extendedDataParser(node, objectStack) {
    (0, $a4f89edd2ef65182$export$dc8ce45ce1679f4f)($1140dfbeee585f32$var$EXTENDED_DATA_PARSERS, node, objectStack);
}
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 */ function $1140dfbeee585f32$var$regionParser(node, objectStack) {
    (0, $a4f89edd2ef65182$export$dc8ce45ce1679f4f)($1140dfbeee585f32$var$REGION_PARSERS, node, objectStack);
}
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$PAIR_PARSERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, {
    'Style': (0, $a4f89edd2ef65182$export$b69a91976ee81208)($1140dfbeee585f32$var$readStyle),
    'key': (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$dda73877cb166cd3)),
    'styleUrl': (0, $a4f89edd2ef65182$export$b69a91976ee81208)($1140dfbeee585f32$var$readStyleURL)
});
/**
 * @this {KML}
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 */ function $1140dfbeee585f32$var$pairDataParser(node, objectStack) {
    const pairObject = (0, $a4f89edd2ef65182$export$5c934df85741dbd1)({}, $1140dfbeee585f32$var$PAIR_PARSERS, node, objectStack, this);
    if (!pairObject) return;
    const key = /** @type {string|undefined} */ pairObject['key'];
    if (key && key == 'normal') {
        const styleUrl = /** @type {string|undefined} */ pairObject['styleUrl'];
        if (styleUrl) objectStack[objectStack.length - 1] = styleUrl;
        const style = /** @type {Style} */ pairObject['Style'];
        if (style) objectStack[objectStack.length - 1] = style;
    }
}
/**
 * @this {KML}
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 */ function $1140dfbeee585f32$var$placemarkStyleMapParser(node, objectStack) {
    const styleMapValue = $1140dfbeee585f32$var$readStyleMapValue.call(this, node, objectStack);
    if (!styleMapValue) return;
    const placemarkObject = objectStack[objectStack.length - 1];
    if (Array.isArray(styleMapValue)) placemarkObject['Style'] = styleMapValue;
    else if (typeof styleMapValue === 'string') placemarkObject['styleUrl'] = styleMapValue;
    else throw new Error('`styleMapValue` has an unknown type');
}
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$SCHEMA_DATA_PARSERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, {
    'SimpleData': $1140dfbeee585f32$var$simpleDataParser
});
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 */ function $1140dfbeee585f32$var$schemaDataParser(node, objectStack) {
    (0, $a4f89edd2ef65182$export$dc8ce45ce1679f4f)($1140dfbeee585f32$var$SCHEMA_DATA_PARSERS, node, objectStack);
}
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 */ function $1140dfbeee585f32$var$simpleDataParser(node, objectStack) {
    const name = node.getAttribute('name');
    if (name !== null) {
        const data = (0, $d5e0fde316cac971$export$dda73877cb166cd3)(node);
        const featureObject = /** @type {Object} */ objectStack[objectStack.length - 1];
        featureObject[name] = data;
    }
}
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$LAT_LON_ALT_BOX_PARSERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, {
    'altitudeMode': (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$dda73877cb166cd3)),
    'minAltitude': (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$5be9c99d34ad295b)),
    'maxAltitude': (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$5be9c99d34ad295b)),
    'north': (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$5be9c99d34ad295b)),
    'south': (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$5be9c99d34ad295b)),
    'east': (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$5be9c99d34ad295b)),
    'west': (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$5be9c99d34ad295b))
});
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 */ function $1140dfbeee585f32$var$latLonAltBoxParser(node, objectStack) {
    const object = (0, $a4f89edd2ef65182$export$5c934df85741dbd1)({}, $1140dfbeee585f32$var$LAT_LON_ALT_BOX_PARSERS, node, objectStack);
    if (!object) return;
    const regionObject = /** @type {Object} */ objectStack[objectStack.length - 1];
    const extent = [
        parseFloat(object['west']),
        parseFloat(object['south']),
        parseFloat(object['east']),
        parseFloat(object['north'])
    ];
    regionObject['extent'] = extent;
    regionObject['altitudeMode'] = object['altitudeMode'];
    regionObject['minAltitude'] = parseFloat(object['minAltitude']);
    regionObject['maxAltitude'] = parseFloat(object['maxAltitude']);
}
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$LOD_PARSERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, {
    'minLodPixels': (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$5be9c99d34ad295b)),
    'maxLodPixels': (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$5be9c99d34ad295b)),
    'minFadeExtent': (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$5be9c99d34ad295b)),
    'maxFadeExtent': (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$5be9c99d34ad295b))
});
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 */ function $1140dfbeee585f32$var$lodParser(node, objectStack) {
    const object = (0, $a4f89edd2ef65182$export$5c934df85741dbd1)({}, $1140dfbeee585f32$var$LOD_PARSERS, node, objectStack);
    if (!object) return;
    const lodObject = /** @type {Object} */ objectStack[objectStack.length - 1];
    lodObject['minLodPixels'] = parseFloat(object['minLodPixels']);
    lodObject['maxLodPixels'] = parseFloat(object['maxLodPixels']);
    lodObject['minFadeExtent'] = parseFloat(object['minFadeExtent']);
    lodObject['maxFadeExtent'] = parseFloat(object['maxFadeExtent']);
}
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$INNER_BOUNDARY_IS_PARSERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, {
    // KML spec only allows one LinearRing  per innerBoundaryIs, but Google Earth
    // allows multiple, so we parse multiple here too.
    'LinearRing': (0, $a4f89edd2ef65182$export$18ed2f5932a1b385)($1140dfbeee585f32$var$readFlatLinearRing)
});
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 */ function $1140dfbeee585f32$var$innerBoundaryIsParser(node, objectStack) {
    const innerBoundaryFlatLinearRings = (0, $a4f89edd2ef65182$export$5c934df85741dbd1)(/** @type {Array<Array<number>>} */ [], $1140dfbeee585f32$var$INNER_BOUNDARY_IS_PARSERS, node, objectStack);
    if (innerBoundaryFlatLinearRings.length > 0) {
        const flatLinearRings = /** @type {Array<Array<number>>} */ objectStack[objectStack.length - 1];
        flatLinearRings.push(...innerBoundaryFlatLinearRings);
    }
}
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$OUTER_BOUNDARY_IS_PARSERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, {
    'LinearRing': (0, $a4f89edd2ef65182$export$b1b80676c57c5713)($1140dfbeee585f32$var$readFlatLinearRing)
});
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 */ function $1140dfbeee585f32$var$outerBoundaryIsParser(node, objectStack) {
    /** @type {Array<number>|undefined} */ const flatLinearRing = (0, $a4f89edd2ef65182$export$5c934df85741dbd1)(undefined, $1140dfbeee585f32$var$OUTER_BOUNDARY_IS_PARSERS, node, objectStack);
    if (flatLinearRing) {
        const flatLinearRings = /** @type {Array<Array<number>>} */ objectStack[objectStack.length - 1];
        flatLinearRings[0] = flatLinearRing;
    }
}
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 */ function $1140dfbeee585f32$var$linkParser(node, objectStack) {
    (0, $a4f89edd2ef65182$export$dc8ce45ce1679f4f)($1140dfbeee585f32$var$LINK_PARSERS, node, objectStack);
}
/**
 * @param {Node} node Node.
 * @param {Array<*>} objectStack Object stack.
 */ function $1140dfbeee585f32$var$whenParser(node, objectStack) {
    const gxTrackObject = /** @type {GxTrackObject} */ objectStack[objectStack.length - 1];
    const whens = gxTrackObject.whens;
    const s = (0, $a4f89edd2ef65182$export$b089dda0fde13047)(node, false);
    const when = Date.parse(s);
    whens.push(isNaN(when) ? 0 : when);
}
/**
 * @param {Node} node Node to append a TextNode with the color to.
 * @param {import("../color.js").Color|string} color Color.
 */ function $1140dfbeee585f32$var$writeColorTextNode(node, color) {
    const rgba = (0, $322346e1ff7894ca$export$75093a47a9fa838d)(color);
    const opacity = rgba.length == 4 ? rgba[3] : 1;
    /** @type {Array<string|number>} */ const abgr = [
        opacity * 255,
        rgba[2],
        rgba[1],
        rgba[0]
    ];
    for(let i = 0; i < 4; ++i){
        const hex = Math.floor(/** @type {number} */ abgr[i]).toString(16);
        abgr[i] = hex.length == 1 ? '0' + hex : hex;
    }
    (0, $d5e0fde316cac971$export$3255ca5635e70aed)(node, abgr.join(''));
}
/**
 * @param {Node} node Node to append a TextNode with the coordinates to.
 * @param {Array<number>} coordinates Coordinates.
 * @param {Array<*>} objectStack Object stack.
 */ function $1140dfbeee585f32$var$writeCoordinatesTextNode(node, coordinates, objectStack) {
    const context = objectStack[objectStack.length - 1];
    const layout = context['layout'];
    const stride = context['stride'];
    let dimension;
    if (layout == 'XY' || layout == 'XYM') dimension = 2;
    else if (layout == 'XYZ' || layout == 'XYZM') dimension = 3;
    else throw new Error('Invalid geometry layout');
    const ii = coordinates.length;
    let text = '';
    if (ii > 0) {
        text += coordinates[0];
        for(let d = 1; d < dimension; ++d)text += ',' + coordinates[d];
        for(let i = stride; i < ii; i += stride){
            text += ' ' + coordinates[i];
            for(let d = 1; d < dimension; ++d)text += ',' + coordinates[i + d];
        }
    }
    (0, $d5e0fde316cac971$export$3255ca5635e70aed)(node, text);
}
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$EXTENDEDDATA_NODE_SERIALIZERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, {
    'Data': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)($1140dfbeee585f32$var$writeDataNode),
    'value': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)($1140dfbeee585f32$var$writeDataNodeValue),
    'displayName': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)($1140dfbeee585f32$var$writeDataNodeName)
});
/**
 * @param {Element} node Node.
 * @param {{name: *, value: *}} pair Name value pair.
 * @param {Array<*>} objectStack Object stack.
 */ function $1140dfbeee585f32$var$writeDataNode(node, pair, objectStack) {
    node.setAttribute('name', pair.name);
    const /** @type {import("../xml.js").NodeStackItem} */ context = {
        node: node
    };
    const value = pair.value;
    if (typeof value == 'object') {
        if (value !== null && value.displayName) (0, $a4f89edd2ef65182$export$a79a01f4edad8da8)(context, $1140dfbeee585f32$var$EXTENDEDDATA_NODE_SERIALIZERS, (0, $a4f89edd2ef65182$export$d91b08b611cef144), [
            value.displayName
        ], objectStack, [
            'displayName'
        ]);
        if (value !== null && value.value) (0, $a4f89edd2ef65182$export$a79a01f4edad8da8)(context, $1140dfbeee585f32$var$EXTENDEDDATA_NODE_SERIALIZERS, (0, $a4f89edd2ef65182$export$d91b08b611cef144), [
            value.value
        ], objectStack, [
            'value'
        ]);
    } else (0, $a4f89edd2ef65182$export$a79a01f4edad8da8)(context, $1140dfbeee585f32$var$EXTENDEDDATA_NODE_SERIALIZERS, (0, $a4f89edd2ef65182$export$d91b08b611cef144), [
        value
    ], objectStack, [
        'value'
    ]);
}
/**
 * @param {Node} node Node to append a TextNode with the name to.
 * @param {string} name DisplayName.
 */ function $1140dfbeee585f32$var$writeDataNodeName(node, name) {
    (0, $d5e0fde316cac971$export$3255ca5635e70aed)(node, name);
}
/**
 * @param {Node} node Node to append a CDATA Section with the value to.
 * @param {string} value Value.
 */ function $1140dfbeee585f32$var$writeDataNodeValue(node, value) {
    (0, $d5e0fde316cac971$export$3255ca5635e70aed)(node, value);
}
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$DOCUMENT_SERIALIZERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, {
    'Placemark': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)($1140dfbeee585f32$var$writePlacemark)
});
/**
 * @const
 * @param {*} value Value.
 * @param {Array<*>} objectStack Object stack.
 * @param {string} [nodeName] Node name.
 * @return {Node|undefined} Node.
 */ const $1140dfbeee585f32$var$DOCUMENT_NODE_FACTORY = function(value, objectStack, nodeName) {
    const parentNode = objectStack[objectStack.length - 1].node;
    return (0, $a4f89edd2ef65182$export$7094a064528c7fee)(parentNode.namespaceURI, 'Placemark');
};
/**
 * @param {Element} node Node.
 * @param {Array<Feature>} features Features.
 * @param {Array<*>} objectStack Object stack.
 * @this {KML}
 */ function $1140dfbeee585f32$var$writeDocument(node, features, objectStack) {
    const /** @type {import("../xml.js").NodeStackItem} */ context = {
        node: node
    };
    (0, $a4f89edd2ef65182$export$a79a01f4edad8da8)(context, $1140dfbeee585f32$var$DOCUMENT_SERIALIZERS, $1140dfbeee585f32$var$DOCUMENT_NODE_FACTORY, features, objectStack, undefined, this);
}
/**
 * A factory for creating Data nodes.
 * @const
 * @type {function(*, Array<*>): (Node|undefined)}
 */ const $1140dfbeee585f32$var$DATA_NODE_FACTORY = (0, $a4f89edd2ef65182$export$7989129829daaabf)('Data');
/**
 * @param {Element} node Node.
 * @param {{names: Array<string>, values: (Array<*>)}} namesAndValues Names and values.
 * @param {Array<*>} objectStack Object stack.
 */ function $1140dfbeee585f32$var$writeExtendedData(node, namesAndValues, objectStack) {
    const /** @type {import("../xml.js").NodeStackItem} */ context = {
        node: node
    };
    const names = namesAndValues.names;
    const values = namesAndValues.values;
    const length = names.length;
    for(let i = 0; i < length; i++)(0, $a4f89edd2ef65182$export$a79a01f4edad8da8)(context, $1140dfbeee585f32$var$EXTENDEDDATA_NODE_SERIALIZERS, $1140dfbeee585f32$var$DATA_NODE_FACTORY, [
        {
            name: names[i],
            value: values[i]
        }
    ], objectStack);
}
/**
 * @const
 * @type {Object<string, Array<string>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$ICON_SEQUENCE = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, [
    'href'
], (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$GX_NAMESPACE_URIS, [
    'x',
    'y',
    'w',
    'h'
]));
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$ICON_SERIALIZERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, {
    'href': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$3255ca5635e70aed))
}, (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$GX_NAMESPACE_URIS, {
    'x': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$f8009f9ca036d7d1)),
    'y': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$f8009f9ca036d7d1)),
    'w': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$f8009f9ca036d7d1)),
    'h': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$f8009f9ca036d7d1))
}));
/**
 * @const
 * @param {*} value Value.
 * @param {Array<*>} objectStack Object stack.
 * @param {string} [nodeName] Node name.
 * @return {Node|undefined} Node.
 */ const $1140dfbeee585f32$var$GX_NODE_FACTORY = function(value, objectStack, nodeName) {
    return (0, $a4f89edd2ef65182$export$7094a064528c7fee)($1140dfbeee585f32$var$GX_NAMESPACE_URIS[0], 'gx:' + nodeName);
};
/**
 * @param {Element} node Node.
 * @param {Object} icon Icon object.
 * @param {Array<*>} objectStack Object stack.
 */ function $1140dfbeee585f32$var$writeIcon(node, icon, objectStack) {
    const /** @type {import("../xml.js").NodeStackItem} */ context = {
        node: node
    };
    const parentNode = objectStack[objectStack.length - 1].node;
    let orderedKeys = $1140dfbeee585f32$var$ICON_SEQUENCE[parentNode.namespaceURI];
    let values = (0, $a4f89edd2ef65182$export$939885a13683f4dc)(icon, orderedKeys);
    (0, $a4f89edd2ef65182$export$a79a01f4edad8da8)(context, $1140dfbeee585f32$var$ICON_SERIALIZERS, (0, $a4f89edd2ef65182$export$d91b08b611cef144), values, objectStack, orderedKeys);
    orderedKeys = $1140dfbeee585f32$var$ICON_SEQUENCE[$1140dfbeee585f32$var$GX_NAMESPACE_URIS[0]];
    values = (0, $a4f89edd2ef65182$export$939885a13683f4dc)(icon, orderedKeys);
    (0, $a4f89edd2ef65182$export$a79a01f4edad8da8)(context, $1140dfbeee585f32$var$ICON_SERIALIZERS, $1140dfbeee585f32$var$GX_NODE_FACTORY, values, objectStack, orderedKeys);
}
/**
 * @const
 * @type {Object<string, Array<string>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$ICON_STYLE_SEQUENCE = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, [
    'scale',
    'heading',
    'Icon',
    'color',
    'hotSpot'
]);
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$ICON_STYLE_SERIALIZERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, {
    'Icon': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)($1140dfbeee585f32$var$writeIcon),
    'color': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)($1140dfbeee585f32$var$writeColorTextNode),
    'heading': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$f8009f9ca036d7d1)),
    'hotSpot': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)($1140dfbeee585f32$var$writeVec2),
    'scale': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)($1140dfbeee585f32$var$writeScaleTextNode)
});
/**
 * @param {Element} node Node.
 * @param {import("../style/Icon.js").default} style Icon style.
 * @param {Array<*>} objectStack Object stack.
 */ function $1140dfbeee585f32$var$writeIconStyle(node, style, objectStack) {
    const /** @type {import("../xml.js").NodeStackItem} */ context = {
        node: node
    };
    const /** @type {Object<string, any>} */ properties = {};
    const src = style.getSrc();
    const size = style.getSize();
    const iconImageSize = style.getImageSize();
    const iconProperties = {
        'href': src
    };
    if (size) {
        iconProperties['w'] = size[0];
        iconProperties['h'] = size[1];
        const anchor = style.getAnchor(); // top-left
        const origin = style.getOrigin(); // top-left
        if (origin && iconImageSize && origin[0] !== 0 && origin[1] !== size[1]) {
            iconProperties['x'] = origin[0];
            iconProperties['y'] = iconImageSize[1] - (origin[1] + size[1]);
        }
        if (anchor && (anchor[0] !== size[0] / 2 || anchor[1] !== size[1] / 2)) {
            const /** @type {Vec2} */ hotSpot = {
                x: anchor[0],
                xunits: 'pixels',
                y: size[1] - anchor[1],
                yunits: 'pixels'
            };
            properties['hotSpot'] = hotSpot;
        }
    }
    properties['Icon'] = iconProperties;
    let scale = style.getScaleArray()[0];
    let imageSize = size;
    if (imageSize === null) imageSize = $1140dfbeee585f32$var$DEFAULT_IMAGE_STYLE_SIZE;
    if (imageSize.length == 2) {
        const resizeScale = $1140dfbeee585f32$var$scaleForSize(imageSize);
        scale = scale / resizeScale;
    }
    if (scale !== 1) properties['scale'] = scale;
    const rotation = style.getRotation();
    if (rotation !== 0) properties['heading'] = rotation; // 0-360
    const color = style.getColor();
    if (color) properties['color'] = color;
    const parentNode = objectStack[objectStack.length - 1].node;
    const orderedKeys = $1140dfbeee585f32$var$ICON_STYLE_SEQUENCE[parentNode.namespaceURI];
    const values = (0, $a4f89edd2ef65182$export$939885a13683f4dc)(properties, orderedKeys);
    (0, $a4f89edd2ef65182$export$a79a01f4edad8da8)(context, $1140dfbeee585f32$var$ICON_STYLE_SERIALIZERS, (0, $a4f89edd2ef65182$export$d91b08b611cef144), values, objectStack, orderedKeys);
}
/**
 * @const
 * @type {Object<string, Array<string>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$LABEL_STYLE_SEQUENCE = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, [
    'color',
    'scale'
]);
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$LABEL_STYLE_SERIALIZERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, {
    'color': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)($1140dfbeee585f32$var$writeColorTextNode),
    'scale': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)($1140dfbeee585f32$var$writeScaleTextNode)
});
/**
 * @param {Element} node Node.
 * @param {Text} style style.
 * @param {Array<*>} objectStack Object stack.
 */ function $1140dfbeee585f32$var$writeLabelStyle(node, style, objectStack) {
    const /** @type {import("../xml.js").NodeStackItem} */ context = {
        node: node
    };
    const properties = {};
    const fill = style.getFill();
    if (fill) properties['color'] = fill.getColor();
    const scale = style.getScale();
    if (scale && scale !== 1) properties['scale'] = scale;
    const parentNode = objectStack[objectStack.length - 1].node;
    const orderedKeys = $1140dfbeee585f32$var$LABEL_STYLE_SEQUENCE[parentNode.namespaceURI];
    const values = (0, $a4f89edd2ef65182$export$939885a13683f4dc)(properties, orderedKeys);
    (0, $a4f89edd2ef65182$export$a79a01f4edad8da8)(context, $1140dfbeee585f32$var$LABEL_STYLE_SERIALIZERS, (0, $a4f89edd2ef65182$export$d91b08b611cef144), values, objectStack, orderedKeys);
}
/**
 * @const
 * @type {Object<string, Array<string>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$LINE_STYLE_SEQUENCE = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, [
    'color',
    'width'
]);
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$LINE_STYLE_SERIALIZERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, {
    'color': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)($1140dfbeee585f32$var$writeColorTextNode),
    'width': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$f8009f9ca036d7d1))
});
/**
 * @param {Element} node Node.
 * @param {Stroke} style style.
 * @param {Array<*>} objectStack Object stack.
 */ function $1140dfbeee585f32$var$writeLineStyle(node, style, objectStack) {
    const /** @type {import("../xml.js").NodeStackItem} */ context = {
        node: node
    };
    const properties = {
        'color': style.getColor(),
        'width': Number(style.getWidth()) || 1
    };
    const parentNode = objectStack[objectStack.length - 1].node;
    const orderedKeys = $1140dfbeee585f32$var$LINE_STYLE_SEQUENCE[parentNode.namespaceURI];
    const values = (0, $a4f89edd2ef65182$export$939885a13683f4dc)(properties, orderedKeys);
    (0, $a4f89edd2ef65182$export$a79a01f4edad8da8)(context, $1140dfbeee585f32$var$LINE_STYLE_SERIALIZERS, (0, $a4f89edd2ef65182$export$d91b08b611cef144), values, objectStack, orderedKeys);
}
/**
 * @const
 * @type {Object<string, string>}
 */ const $1140dfbeee585f32$var$GEOMETRY_TYPE_TO_NODENAME = {
    'Point': 'Point',
    'LineString': 'LineString',
    'LinearRing': 'LinearRing',
    'Polygon': 'Polygon',
    'MultiPoint': 'MultiGeometry',
    'MultiLineString': 'MultiGeometry',
    'MultiPolygon': 'MultiGeometry',
    'GeometryCollection': 'MultiGeometry'
};
/**
 * @const
 * @param {*} value Value.
 * @param {Array<*>} objectStack Object stack.
 * @param {string} [nodeName] Node name.
 * @return {Node|undefined} Node.
 */ const $1140dfbeee585f32$var$GEOMETRY_NODE_FACTORY = function(value, objectStack, nodeName) {
    if (value) {
        const parentNode = objectStack[objectStack.length - 1].node;
        return (0, $a4f89edd2ef65182$export$7094a064528c7fee)(parentNode.namespaceURI, $1140dfbeee585f32$var$GEOMETRY_TYPE_TO_NODENAME[/** @type {import("../geom/Geometry.js").default} */ value.getType()]);
    }
};
/**
 * A factory for creating Point nodes.
 * @const
 * @type {function(*, Array<*>, string=): (Node|undefined)}
 */ const $1140dfbeee585f32$var$POINT_NODE_FACTORY = (0, $a4f89edd2ef65182$export$7989129829daaabf)('Point');
/**
 * A factory for creating LineString nodes.
 * @const
 * @type {function(*, Array<*>, string=): (Node|undefined)}
 */ const $1140dfbeee585f32$var$LINE_STRING_NODE_FACTORY = (0, $a4f89edd2ef65182$export$7989129829daaabf)('LineString');
/**
 * A factory for creating LinearRing nodes.
 * @const
 * @type {function(*, Array<*>, string=): (Node|undefined)}
 */ const $1140dfbeee585f32$var$LINEAR_RING_NODE_FACTORY = (0, $a4f89edd2ef65182$export$7989129829daaabf)('LinearRing');
/**
 * A factory for creating Polygon nodes.
 * @const
 * @type {function(*, Array<*>, string=): (Node|undefined)}
 */ const $1140dfbeee585f32$var$POLYGON_NODE_FACTORY = (0, $a4f89edd2ef65182$export$7989129829daaabf)('Polygon');
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$MULTI_GEOMETRY_SERIALIZERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, {
    'LineString': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)($1140dfbeee585f32$var$writePrimitiveGeometry),
    'Point': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)($1140dfbeee585f32$var$writePrimitiveGeometry),
    'Polygon': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)($1140dfbeee585f32$var$writePolygon),
    'GeometryCollection': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)($1140dfbeee585f32$var$writeMultiGeometry)
});
/**
 * @param {Element} node Node.
 * @param {import("../geom/Geometry.js").default} geometry Geometry.
 * @param {Array<*>} objectStack Object stack.
 */ function $1140dfbeee585f32$var$writeMultiGeometry(node, geometry, objectStack) {
    /** @type {import("../xml.js").NodeStackItem} */ const context = {
        node: node
    };
    const type = geometry.getType();
    /** @type {Array<import("../geom/Geometry.js").default>} */ let geometries = [];
    /** @type {function(*, Array<*>, string=): (Node|undefined)} */ let factory;
    if (type === 'GeometryCollection') {
        /** @type {GeometryCollection} */ geometry.getGeometriesArrayRecursive().forEach(function(geometry) {
            const type = geometry.getType();
            if (type === 'MultiPoint') geometries = geometries.concat(/** @type {MultiPoint} */ geometry.getPoints());
            else if (type === 'MultiLineString') geometries = geometries.concat(/** @type {MultiLineString} */ geometry.getLineStrings());
            else if (type === 'MultiPolygon') geometries = geometries.concat(/** @type {MultiPolygon} */ geometry.getPolygons());
            else if (type === 'Point' || type === 'LineString' || type === 'Polygon') geometries.push(geometry);
            else throw new Error('Unknown geometry type');
        });
        factory = $1140dfbeee585f32$var$GEOMETRY_NODE_FACTORY;
    } else if (type === 'MultiPoint') {
        geometries = /** @type {MultiPoint} */ geometry.getPoints();
        factory = $1140dfbeee585f32$var$POINT_NODE_FACTORY;
    } else if (type === 'MultiLineString') {
        geometries = /** @type {MultiLineString} */ geometry.getLineStrings();
        factory = $1140dfbeee585f32$var$LINE_STRING_NODE_FACTORY;
    } else if (type === 'MultiPolygon') {
        geometries = /** @type {MultiPolygon} */ geometry.getPolygons();
        factory = $1140dfbeee585f32$var$POLYGON_NODE_FACTORY;
    } else throw new Error('Unknown geometry type');
    (0, $a4f89edd2ef65182$export$a79a01f4edad8da8)(context, $1140dfbeee585f32$var$MULTI_GEOMETRY_SERIALIZERS, factory, geometries, objectStack);
}
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$BOUNDARY_IS_SERIALIZERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, {
    'LinearRing': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)($1140dfbeee585f32$var$writePrimitiveGeometry)
});
/**
 * @param {Element} node Node.
 * @param {import("../geom/LinearRing.js").default} linearRing Linear ring.
 * @param {Array<*>} objectStack Object stack.
 */ function $1140dfbeee585f32$var$writeBoundaryIs(node, linearRing, objectStack) {
    const /** @type {import("../xml.js").NodeStackItem} */ context = {
        node: node
    };
    (0, $a4f89edd2ef65182$export$a79a01f4edad8da8)(context, $1140dfbeee585f32$var$BOUNDARY_IS_SERIALIZERS, $1140dfbeee585f32$var$LINEAR_RING_NODE_FACTORY, [
        linearRing
    ], objectStack);
}
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$PLACEMARK_SERIALIZERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, {
    'ExtendedData': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)($1140dfbeee585f32$var$writeExtendedData),
    'MultiGeometry': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)($1140dfbeee585f32$var$writeMultiGeometry),
    'LineString': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)($1140dfbeee585f32$var$writePrimitiveGeometry),
    'LinearRing': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)($1140dfbeee585f32$var$writePrimitiveGeometry),
    'Point': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)($1140dfbeee585f32$var$writePrimitiveGeometry),
    'Polygon': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)($1140dfbeee585f32$var$writePolygon),
    'Style': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)($1140dfbeee585f32$var$writeStyle),
    'address': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$3255ca5635e70aed)),
    'description': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$3255ca5635e70aed)),
    'name': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$3255ca5635e70aed)),
    'open': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$9de8e8a584a450b7)),
    'phoneNumber': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$3255ca5635e70aed)),
    'styleUrl': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$3255ca5635e70aed)),
    'visibility': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$9de8e8a584a450b7))
});
/**
 * @const
 * @type {Object<string, Array<string>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$PLACEMARK_SEQUENCE = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, [
    'name',
    'open',
    'visibility',
    'address',
    'phoneNumber',
    'description',
    'styleUrl',
    'Style'
]);
/**
 * A factory for creating ExtendedData nodes.
 * @const
 * @type {function(*, Array<*>): (Node|undefined)}
 */ const $1140dfbeee585f32$var$EXTENDEDDATA_NODE_FACTORY = (0, $a4f89edd2ef65182$export$7989129829daaabf)('ExtendedData');
/**
 * FIXME currently we do serialize arbitrary/custom feature properties
 * (ExtendedData).
 * @param {Element} node Node.
 * @param {Feature} feature Feature.
 * @param {Array<*>} objectStack Object stack.
 * @this {KML}
 */ function $1140dfbeee585f32$var$writePlacemark(node, feature, objectStack) {
    const /** @type {import("../xml.js").NodeStackItem} */ context = {
        node: node
    };
    // set id
    if (feature.getId()) node.setAttribute('id', /** @type {string} */ feature.getId());
    // serialize properties (properties unknown to KML are not serialized)
    const properties = feature.getProperties();
    // don't export these to ExtendedData
    const filter = {
        'address': 1,
        'description': 1,
        'name': 1,
        'open': 1,
        'phoneNumber': 1,
        'styleUrl': 1,
        'visibility': 1
    };
    filter[feature.getGeometryName()] = 1;
    const keys = Object.keys(properties || {}).sort().filter(function(v) {
        return !filter[v];
    });
    const styleFunction = feature.getStyleFunction();
    if (styleFunction) {
        // FIXME the styles returned by the style function are supposed to be
        // resolution-independent here
        const styles = styleFunction(feature, 0);
        if (styles) {
            const styleArray = Array.isArray(styles) ? styles : [
                styles
            ];
            let pointStyles = styleArray;
            if (feature.getGeometry()) {
                pointStyles = styleArray.filter(function(style) {
                    const geometry = style.getGeometryFunction()(feature);
                    if (geometry) {
                        const type = geometry.getType();
                        if (type === 'GeometryCollection') return /** @type {GeometryCollection} */ geometry.getGeometriesArrayRecursive().filter(function(geometry) {
                            const type = geometry.getType();
                            return type === 'Point' || type === 'MultiPoint';
                        }).length;
                        return type === 'Point' || type === 'MultiPoint';
                    }
                });
                'Point';
            }
            if (this.writeStyles_) {
                let lineStyles = styleArray;
                let polyStyles = styleArray;
                if (feature.getGeometry()) {
                    lineStyles = styleArray.filter(function(style) {
                        const geometry = style.getGeometryFunction()(feature);
                        if (geometry) {
                            const type = geometry.getType();
                            if (type === 'GeometryCollection') return /** @type {GeometryCollection} */ geometry.getGeometriesArrayRecursive().filter(function(geometry) {
                                const type = geometry.getType();
                                return type === 'LineString' || type === 'MultiLineString';
                            }).length;
                            return type === 'LineString' || type === 'MultiLineString';
                        }
                    });
                    polyStyles = styleArray.filter(function(style) {
                        const geometry = style.getGeometryFunction()(feature);
                        if (geometry) {
                            const type = geometry.getType();
                            if (type === 'GeometryCollection') return /** @type {GeometryCollection} */ geometry.getGeometriesArrayRecursive().filter(function(geometry) {
                                const type = geometry.getType();
                                return type === 'Polygon' || type === 'MultiPolygon';
                            }).length;
                            return type === 'Polygon' || type === 'MultiPolygon';
                        }
                    });
                }
                properties['Style'] = {
                    pointStyles: pointStyles,
                    lineStyles: lineStyles,
                    polyStyles: polyStyles
                };
            }
            if (pointStyles.length && properties['name'] === undefined) {
                const textStyle = pointStyles[0].getText();
                if (textStyle) properties['name'] = textStyle.getText();
            }
        }
    }
    const parentNode = objectStack[objectStack.length - 1].node;
    const orderedKeys = $1140dfbeee585f32$var$PLACEMARK_SEQUENCE[parentNode.namespaceURI];
    const values = (0, $a4f89edd2ef65182$export$939885a13683f4dc)(properties, orderedKeys);
    (0, $a4f89edd2ef65182$export$a79a01f4edad8da8)(context, $1140dfbeee585f32$var$PLACEMARK_SERIALIZERS, (0, $a4f89edd2ef65182$export$d91b08b611cef144), values, objectStack, orderedKeys);
    if (keys.length > 0) {
        const sequence = (0, $a4f89edd2ef65182$export$939885a13683f4dc)(properties, keys);
        const namesAndValues = {
            names: keys,
            values: sequence
        };
        (0, $a4f89edd2ef65182$export$a79a01f4edad8da8)(context, $1140dfbeee585f32$var$PLACEMARK_SERIALIZERS, $1140dfbeee585f32$var$EXTENDEDDATA_NODE_FACTORY, [
            namesAndValues
        ], objectStack);
    }
    // serialize geometry
    const options = /** @type {import("./Feature.js").WriteOptions} */ objectStack[0];
    let geometry = feature.getGeometry();
    if (geometry) geometry = (0, $ec084d0ff9c13a22$export$7beeea566b560d4)(geometry, true, options);
    (0, $a4f89edd2ef65182$export$a79a01f4edad8da8)(context, $1140dfbeee585f32$var$PLACEMARK_SERIALIZERS, $1140dfbeee585f32$var$GEOMETRY_NODE_FACTORY, [
        geometry
    ], objectStack);
}
/**
 * @const
 * @type {Object<string, Array<string>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$PRIMITIVE_GEOMETRY_SEQUENCE = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, [
    'extrude',
    'tessellate',
    'altitudeMode',
    'coordinates'
]);
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$PRIMITIVE_GEOMETRY_SERIALIZERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, {
    'extrude': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$9de8e8a584a450b7)),
    'tessellate': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$9de8e8a584a450b7)),
    'altitudeMode': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$3255ca5635e70aed)),
    'coordinates': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)($1140dfbeee585f32$var$writeCoordinatesTextNode)
});
/**
 * @param {Element} node Node.
 * @param {import("../geom/SimpleGeometry.js").default} geometry Geometry.
 * @param {Array<*>} objectStack Object stack.
 */ function $1140dfbeee585f32$var$writePrimitiveGeometry(node, geometry, objectStack) {
    const flatCoordinates = geometry.getFlatCoordinates();
    const /** @type {import("../xml.js").NodeStackItem} */ context = {
        node: node
    };
    context['layout'] = geometry.getLayout();
    context['stride'] = geometry.getStride();
    // serialize properties (properties unknown to KML are not serialized)
    const properties = geometry.getProperties();
    properties.coordinates = flatCoordinates;
    const parentNode = objectStack[objectStack.length - 1].node;
    const orderedKeys = $1140dfbeee585f32$var$PRIMITIVE_GEOMETRY_SEQUENCE[parentNode.namespaceURI];
    const values = (0, $a4f89edd2ef65182$export$939885a13683f4dc)(properties, orderedKeys);
    (0, $a4f89edd2ef65182$export$a79a01f4edad8da8)(context, $1140dfbeee585f32$var$PRIMITIVE_GEOMETRY_SERIALIZERS, (0, $a4f89edd2ef65182$export$d91b08b611cef144), values, objectStack, orderedKeys);
}
/**
 * @const
 * @type {Object<string, Array<string>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$POLY_STYLE_SEQUENCE = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, [
    'color',
    'fill',
    'outline'
]);
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$POLYGON_SERIALIZERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, {
    'outerBoundaryIs': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)($1140dfbeee585f32$var$writeBoundaryIs),
    'innerBoundaryIs': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)($1140dfbeee585f32$var$writeBoundaryIs)
});
/**
 * A factory for creating innerBoundaryIs nodes.
 * @const
 * @type {function(*, Array<*>, string=): (Node|undefined)}
 */ const $1140dfbeee585f32$var$INNER_BOUNDARY_NODE_FACTORY = (0, $a4f89edd2ef65182$export$7989129829daaabf)('innerBoundaryIs');
/**
 * A factory for creating outerBoundaryIs nodes.
 * @const
 * @type {function(*, Array<*>, string=): (Node|undefined)}
 */ const $1140dfbeee585f32$var$OUTER_BOUNDARY_NODE_FACTORY = (0, $a4f89edd2ef65182$export$7989129829daaabf)('outerBoundaryIs');
/**
 * @param {Element} node Node.
 * @param {Polygon} polygon Polygon.
 * @param {Array<*>} objectStack Object stack.
 */ function $1140dfbeee585f32$var$writePolygon(node, polygon, objectStack) {
    const linearRings = polygon.getLinearRings();
    const outerRing = linearRings.shift();
    const /** @type {import("../xml.js").NodeStackItem} */ context = {
        node: node
    };
    // inner rings
    (0, $a4f89edd2ef65182$export$a79a01f4edad8da8)(context, $1140dfbeee585f32$var$POLYGON_SERIALIZERS, $1140dfbeee585f32$var$INNER_BOUNDARY_NODE_FACTORY, linearRings, objectStack);
    // outer ring
    (0, $a4f89edd2ef65182$export$a79a01f4edad8da8)(context, $1140dfbeee585f32$var$POLYGON_SERIALIZERS, $1140dfbeee585f32$var$OUTER_BOUNDARY_NODE_FACTORY, [
        outerRing
    ], objectStack);
}
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$POLY_STYLE_SERIALIZERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, {
    'color': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)($1140dfbeee585f32$var$writeColorTextNode),
    'fill': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$9de8e8a584a450b7)),
    'outline': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$9de8e8a584a450b7))
});
/**
 * @param {Element} node Node.
 * @param {Style} style Style.
 * @param {Array<*>} objectStack Object stack.
 */ function $1140dfbeee585f32$var$writePolyStyle(node, style, objectStack) {
    const /** @type {import("../xml.js").NodeStackItem} */ context = {
        node: node
    };
    const fill = style.getFill();
    const stroke = style.getStroke();
    const properties = {
        'color': fill ? fill.getColor() : undefined,
        'fill': fill ? undefined : false,
        'outline': stroke ? undefined : false
    };
    const parentNode = objectStack[objectStack.length - 1].node;
    const orderedKeys = $1140dfbeee585f32$var$POLY_STYLE_SEQUENCE[parentNode.namespaceURI];
    const values = (0, $a4f89edd2ef65182$export$939885a13683f4dc)(properties, orderedKeys);
    (0, $a4f89edd2ef65182$export$a79a01f4edad8da8)(context, $1140dfbeee585f32$var$POLY_STYLE_SERIALIZERS, (0, $a4f89edd2ef65182$export$d91b08b611cef144), values, objectStack, orderedKeys);
}
/**
 * @param {Node} node Node to append a TextNode with the scale to.
 * @param {number|undefined} scale Scale.
 */ function $1140dfbeee585f32$var$writeScaleTextNode(node, scale) {
    // the Math is to remove any excess decimals created by float arithmetic
    (0, $d5e0fde316cac971$export$f8009f9ca036d7d1)(node, Math.round(scale * 1e6) / 1e6);
}
/**
 * @const
 * @type {Object<string, Array<string>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$STYLE_SEQUENCE = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, [
    'IconStyle',
    'LabelStyle',
    'LineStyle',
    'PolyStyle'
]);
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$STYLE_SERIALIZERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, {
    'IconStyle': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)($1140dfbeee585f32$var$writeIconStyle),
    'LabelStyle': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)($1140dfbeee585f32$var$writeLabelStyle),
    'LineStyle': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)($1140dfbeee585f32$var$writeLineStyle),
    'PolyStyle': (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)($1140dfbeee585f32$var$writePolyStyle)
});
/**
 * @param {Element} node Node.
 * @param {Object<string, Array<Style>>} styles Styles.
 * @param {Array<*>} objectStack Object stack.
 */ function $1140dfbeee585f32$var$writeStyle(node, styles, objectStack) {
    const /** @type {import("../xml.js").NodeStackItem} */ context = {
        node: node
    };
    const properties = {};
    if (styles.pointStyles.length) {
        const textStyle = styles.pointStyles[0].getText();
        if (textStyle) properties['LabelStyle'] = textStyle;
        const imageStyle = styles.pointStyles[0].getImage();
        if (imageStyle && typeof /** @type {?} */ imageStyle.getSrc === 'function') properties['IconStyle'] = imageStyle;
    }
    if (styles.lineStyles.length) {
        const strokeStyle = styles.lineStyles[0].getStroke();
        if (strokeStyle) properties['LineStyle'] = strokeStyle;
    }
    if (styles.polyStyles.length) {
        const strokeStyle = styles.polyStyles[0].getStroke();
        if (strokeStyle && !properties['LineStyle']) properties['LineStyle'] = strokeStyle;
        properties['PolyStyle'] = styles.polyStyles[0];
    }
    const parentNode = objectStack[objectStack.length - 1].node;
    const orderedKeys = $1140dfbeee585f32$var$STYLE_SEQUENCE[parentNode.namespaceURI];
    const values = (0, $a4f89edd2ef65182$export$939885a13683f4dc)(properties, orderedKeys);
    (0, $a4f89edd2ef65182$export$a79a01f4edad8da8)(context, $1140dfbeee585f32$var$STYLE_SERIALIZERS, (0, $a4f89edd2ef65182$export$d91b08b611cef144), values, objectStack, orderedKeys);
}
/**
 * @param {Element} node Node to append a TextNode with the Vec2 to.
 * @param {Vec2} vec2 Vec2.
 */ function $1140dfbeee585f32$var$writeVec2(node, vec2) {
    node.setAttribute('x', String(vec2.x));
    node.setAttribute('y', String(vec2.y));
    node.setAttribute('xunits', vec2.xunits);
    node.setAttribute('yunits', vec2.yunits);
}
var $1140dfbeee585f32$export$2e2bcd8739ae039 = $1140dfbeee585f32$var$KML;


const $33d6a58e88aba98a$export$c1fb0eb1ea3f6fb6 = Object.freeze([
    {
        text: 'GeoJSON',
        value: 'GeoJSON'
    },
    {
        text: 'KML',
        value: 'KML'
    }
]);
const $33d6a58e88aba98a$export$6f7aa03db31f8f57 = Object.freeze({
    'GeoJSON': (0, $f602cef51a2e6950$export$2e2bcd8739ae039),
    'KML': (0, $1140dfbeee585f32$export$2e2bcd8739ae039)
});
const $33d6a58e88aba98a$export$570785d7398311f5 = function(name, options) {
    if (!(name in $33d6a58e88aba98a$export$6f7aa03db31f8f57)) return null;
    return new $33d6a58e88aba98a$export$6f7aa03db31f8f57[name](options);
};







var $f1q41 = parcelRequire("f1q41");






const $2d7a7b1f7c01fb97$var$FILENAME = 'download-layer-modal.js';
const $2d7a7b1f7c01fb97$var$ID__PREFIX = 'oltb-download-layer-modal';
const $2d7a7b1f7c01fb97$var$I18N__BASE = 'modalExtensions.downloadLayerModal';
// Note:
// Only specify the unique options to this class
// Things to override on the BaseModal is passed directly
const $2d7a7b1f7c01fb97$var$DefaultOptions = Object.freeze({
    onDownload: undefined,
    onCancel: undefined
});
/**
 * About:
 * Manager that handles downloading of vector layers
 */ class $2d7a7b1f7c01fb97$export$ec53fcc6e8f0dd7f extends (0, $b12cc913018885a9$export$a703eb468fcf7e69) {
    #buttons = [];
    constructor(options = {}){
        super({
            filename: $2d7a7b1f7c01fb97$var$FILENAME,
            title: (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get(`${$2d7a7b1f7c01fb97$var$I18N__BASE}.title`),
            ...options
        });
        this.options = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep($2d7a7b1f7c01fb97$var$DefaultOptions), options);
        this.#createModalContent();
    }
    //--------------------------------------------------------------------
    // # Section: Overridden
    //--------------------------------------------------------------------
    getName() {
        return super.getName();
    }
    //--------------------------------------------------------------------
    // # Section: User Interface
    //--------------------------------------------------------------------
    #createModalContent() {
        const i18n = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get(`${$2d7a7b1f7c01fb97$var$I18N__BASE}.form`);
        const [formatWrapper, formatSelect] = (0, $8b36a4c9059be7ba$export$af1822d79ba4bb67)({
            idPrefix: $2d7a7b1f7c01fb97$var$ID__PREFIX,
            idPostfix: '-format',
            text: i18n.layerFormat,
            options: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep((0, $33d6a58e88aba98a$export$c1fb0eb1ea3f6fb6))
        });
        const buttonsWrapper = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'div',
            class: 'oltb-d-flex oltb-justify-content-between oltb-mt-15'
        });
        const downloadButton = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'button',
            text: i18n.download,
            class: 'oltb-dialog__btn oltb-btn oltb-btn--green-mid',
            attributes: {
                'type': 'button'
            },
            listeners: {
                'click': ()=>{
                    this.#onDownload({
                        format: formatSelect.value.trim()
                    });
                }
            }
        });
        const cancelButton = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'button',
            text: i18n.cancel,
            class: `oltb-dialog__btn oltb-btn ${(0, $c63f096e37f334a4$export$5a63ccfbe4d87ef0)() ? 'oltb-btn--gray-mid' : 'oltb-btn--gray-dark'}`,
            attributes: {
                'type': 'button'
            },
            listeners: {
                'click': this.#onCancel.bind(this)
            }
        });
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(buttonsWrapper, [
            cancelButton,
            downloadButton
        ]);
        const modalContent = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'div',
            class: 'oltb-modal__content'
        });
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(modalContent, [
            formatWrapper,
            buttonsWrapper
        ]);
        this.#buttons = [
            cancelButton,
            downloadButton
        ];
        this.show(modalContent);
    }
    //--------------------------------------------------------------------
    // # Section: Events
    //--------------------------------------------------------------------
    #onDownload(result) {
        this.close();
        this.options.onDownload && this.options.onDownload(result);
    }
    #onCancel() {
        this.close();
        this.options.onCancel && this.options.onCancel();
    }
    //--------------------------------------------------------------------
    // # Section: Public API
    //--------------------------------------------------------------------
    getButtons() {
        return this.#buttons;
    }
}



const $8c356da77b85a9b0$var$FILENAME = 'layer-tool.js';
const $8c356da77b85a9b0$var$CLASS__TOOL_BUTTON = 'oltb-tool-button';
const $8c356da77b85a9b0$var$CLASS__TOOLBOX_SECTION = 'oltb-toolbox-section';
const $8c356da77b85a9b0$var$CLASS__TOOLBOX_LIST = 'oltb-toolbox-list';
const $8c356da77b85a9b0$var$CLASS__FUNC_BUTTON = 'oltb-func-btn';
const $8c356da77b85a9b0$var$CLASS__TOGGLEABLE = 'oltb-toggleable';
const $8c356da77b85a9b0$var$ID__PREFIX = 'oltb-layer';
const $8c356da77b85a9b0$var$SORTABLE_MAP_LAYERS = 'sortableMapLayers';
const $8c356da77b85a9b0$var$SORTABLE_FEATURE_LAYERS = 'sortableFeatureLayers';
const $8c356da77b85a9b0$var$INDEX_OFFSET = 1;
const $8c356da77b85a9b0$var$I18N__BASE = 'tools.layerTool';
const $8c356da77b85a9b0$var$I18N__BASE_COMMON = 'commons';
const $8c356da77b85a9b0$var$DefaultOptions = Object.freeze({
    disableMapCreateLayerButton: false,
    disableMapLayerEditButton: false,
    disableMapLayerDeleteButton: false,
    disableFeatureCreateLayerButton: false,
    disableFeatureLayerEditButton: false,
    disableFeatureLayerDeleteButton: false,
    disableFeatureLayerDownloadButton: false,
    onClicked: undefined,
    onInitiated: undefined,
    onBrowserStateCleared: undefined,
    onMapLayerAdded: undefined,
    onMapLayerRemoved: undefined,
    onMapLayerRenamed: undefined,
    onMapLayerVisibilityChanged: undefined,
    onMapLayerDragged: undefined,
    onFeatureLayerAdded: undefined,
    onFeatureLayerRemoved: undefined,
    onFeatureLayerRenamed: undefined,
    onFeatureLayerVisibilityChanged: undefined,
    onFeatureLayerDownloaded: undefined,
    onFeatureLayerDragged: undefined
});
/* 
    Because this tool has two different sections that can be collapsed it's not a viable solution to have a single collapsed property. 
    Unfortunately this results in two longer names stored in localStorage.
*/ const $8c356da77b85a9b0$var$LocalStorageNodeName = (0, $52e25f2a10ab5b5c$export$ada36e8a1c3bc83a).layerTool;
const $8c356da77b85a9b0$var$LocalStorageDefaults = Object.freeze({
    isActive: false,
    mapLayers: [],
    featureLayers: [],
    'oltb-layer-map-toolbox-collapsed': false,
    'oltb-layer-feature-toolbox-collapsed': false
});
/**
 * About:
 * Manage Map- and Feature layers
 * 
 * Description:
 * Create and manage layers for both Map and Markers. 
 * Sorting can be done by simple drag and drop.
 */ class $8c356da77b85a9b0$export$5184c141f545a20 extends (0, $10d08d54da4ecbc4$export$cf198134d112da63) {
    constructor(options = {}){
        super({
            filename: $8c356da77b85a9b0$var$FILENAME
        });
        this.icon = (0, $dcff5ab966a6537f$export$a297fe855adfd36c)({
            path: (0, $35649bc6579784f8$export$3fddabec91763a6e).layers.stroked,
            class: `${$8c356da77b85a9b0$var$CLASS__TOOL_BUTTON}__icon`
        });
        const i18n = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get($8c356da77b85a9b0$var$I18N__BASE);
        const button = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'button',
            html: this.icon,
            class: $8c356da77b85a9b0$var$CLASS__TOOL_BUTTON,
            attributes: {
                'type': 'button',
                'data-tippy-content': `${i18n.title} (${(0, $a256deadcc62504f$export$4384767a59dc851d).layerTool})`,
                'data-tippy-content-post': `(${(0, $a256deadcc62504f$export$4384767a59dc851d).layerTool})`,
                'data-oltb-i18n': `${$8c356da77b85a9b0$var$I18N__BASE}.title`
            },
            listeners: {
                'click': this.onClickTool.bind(this)
            }
        });
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(this.element, [
            button
        ]);
        this.button = button;
        this.isActive = false;
        this.layerModal = undefined;
        this.options = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep($8c356da77b85a9b0$var$DefaultOptions), options);
        this.localStorage = (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).getAndMergeStateObject($8c356da77b85a9b0$var$LocalStorageNodeName, $8c356da77b85a9b0$var$LocalStorageDefaults);
        this.#initToolboxHTML();
        this.uiRefToolboxSection = window.document.querySelector(`#${$8c356da77b85a9b0$var$ID__PREFIX}-toolbox`);
        this.#initToggleables();
        this.uiRefMapLayerStack = this.uiRefToolboxSection.querySelector(`#${$8c356da77b85a9b0$var$ID__PREFIX}-map-stack`);
        this.uiRefAddMapLayerButton = this.uiRefToolboxSection.querySelector(`#${$8c356da77b85a9b0$var$ID__PREFIX}-map-stack-add-button`);
        this.uiRefAddMapLayerText = this.uiRefToolboxSection.querySelector(`#${$8c356da77b85a9b0$var$ID__PREFIX}-map-stack-add-text`);
        this.sortableMapLayerStack = this.#generateSortable(this.uiRefMapLayerStack, {
            group: $8c356da77b85a9b0$var$SORTABLE_MAP_LAYERS,
            callback: this.options.onMapLayerDragged,
            setZIndex: (0, $e75fe1c51a3d360c$export$eff87c52915dd7fe).setMapLayerZIndex.bind((0, $e75fe1c51a3d360c$export$eff87c52915dd7fe)),
            getLayerItemById: (0, $e75fe1c51a3d360c$export$eff87c52915dd7fe).getMapLayerById.bind((0, $e75fe1c51a3d360c$export$eff87c52915dd7fe)),
            getLocalStorageItemById: this.getLocalStorageMapLayerById.bind(this),
            stack: this.localStorage.mapLayers
        });
        this.uiRefFeatureLayerStack = this.uiRefToolboxSection.querySelector(`#${$8c356da77b85a9b0$var$ID__PREFIX}-feature-stack`);
        this.uiRefAddFeatureLayerButton = this.uiRefToolboxSection.querySelector(`#${$8c356da77b85a9b0$var$ID__PREFIX}-feature-stack-add-button`);
        this.uiRefAddFeatureLayerText = this.uiRefToolboxSection.querySelector(`#${$8c356da77b85a9b0$var$ID__PREFIX}-feature-stack-add-text`);
        this.sortableFeatureLayerStack = this.#generateSortable(this.uiRefFeatureLayerStack, {
            group: $8c356da77b85a9b0$var$SORTABLE_FEATURE_LAYERS,
            callback: this.options.onFeatureLayerDragged,
            setZIndex: (0, $e75fe1c51a3d360c$export$eff87c52915dd7fe).setFeatureLayerZIndex.bind((0, $e75fe1c51a3d360c$export$eff87c52915dd7fe)),
            getLayerItemById: (0, $e75fe1c51a3d360c$export$eff87c52915dd7fe).getFeatureLayerById.bind((0, $e75fe1c51a3d360c$export$eff87c52915dd7fe)),
            getLocalStorageItemById: this.getLocalStorageFeatureLayerById.bind(this),
            stack: this.localStorage.featureLayers
        });
        // Note: 
        // The three refs below might be null due to the user
        // disabled them in the constructor options
        if (this.uiRefAddMapLayerButton) this.uiRefAddMapLayerButton.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.click, this.#onShowAddMapLayerModal.bind(this));
        if (this.uiRefAddFeatureLayerButton) this.uiRefAddFeatureLayerButton.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.click, this.#onAddFeatureLayerByClick.bind(this));
        if (this.uiRefAddFeatureLayerText) this.uiRefAddFeatureLayerText.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.keyUp, this.#onAddFeatureLayerByKey.bind(this));
        this.#initContextMenuItems();
        this.attachGlobalListeners();
        // Note: 
        // @Consumer callback
        if (this.options.onInitiated) this.options.onInitiated();
    }
    attachGlobalListeners() {
        this.onWindowKeyUpBind = this.#onWindowKeyUp.bind(this);
        this.onOLTBReadyBind = this.#onOLTBReady.bind(this);
        this.onWindowMapLayerAddedBind = this.#onWindowMapLayerAdded.bind(this);
        this.onWindowMapLayerRemovedBind = this.#onWindowMapLayerRemoved.bind(this);
        this.onWindowFeatureLayerAddedBind = this.#onWindowFeatureLayerAdded.bind(this);
        this.onWindowFeatureLayerRemovedBind = this.#onWindowFeatureLayerRemoved.bind(this);
        this.onWindowBrowserStateClearedBind = this.#onWindowBrowserStateCleared.bind(this);
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.keyUp, this.onWindowKeyUpBind);
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.ready, this.onOLTBReadyBind);
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.mapLayerAdded, this.onWindowMapLayerAddedBind);
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.mapLayerRemoved, this.onWindowMapLayerRemovedBind);
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.featureLayerAdded, this.onWindowFeatureLayerAddedBind);
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.featureLayerRemoved, this.onWindowFeatureLayerRemovedBind);
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.browserStateCleared, this.onWindowBrowserStateClearedBind);
    }
    detachGlobalListeners() {
        window.removeEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.keyUp, this.onWindowKeyUpBind);
        window.removeEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.ready, this.onOLTBReadyBind);
        window.removeEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.mapLayerAdded, this.onWindowMapLayerAddedBind);
        window.removeEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.mapLayerRemoved, this.onWindowMapLayerRemovedBind);
        window.removeEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.featureLayerAdded, this.onWindowFeatureLayerAddedBind);
        window.removeEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.featureLayerRemoved, this.onWindowFeatureLayerRemovedBind);
        window.removeEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.browserStateCleared, this.onWindowBrowserStateClearedBind);
    }
    //--------------------------------------------------------------------
    // # Section: Overridden
    //--------------------------------------------------------------------
    getName() {
        return super.getName();
    }
    onClickTool(event) {
        super.onClickTool(event);
        if (this.isActive) this.deactivateTool();
        else this.activateTool();
        // Note: 
        // @Consumer callback
        if (this.options.onClicked) this.options.onClicked();
    }
    //--------------------------------------------------------------------
    // # Section: Init Helpers
    //--------------------------------------------------------------------
    #initToolboxHTML() {
        const i18n = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get(`${$8c356da77b85a9b0$var$I18N__BASE}.toolbox`);
        const i18nCommon = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get(`${$8c356da77b85a9b0$var$I18N__BASE_COMMON}.titles`);
        const html = `
            <div id="${$8c356da77b85a9b0$var$ID__PREFIX}-toolbox" class="${$8c356da77b85a9b0$var$CLASS__TOOLBOX_SECTION}">
                <div class="${$8c356da77b85a9b0$var$CLASS__TOOLBOX_SECTION}__header oltb-toggleable" data-oltb-toggleable-target="${$8c356da77b85a9b0$var$ID__PREFIX}-map-toolbox-collapsed">
                    <h4 class="${$8c356da77b85a9b0$var$CLASS__TOOLBOX_SECTION}__title" data-oltb-i18n="${$8c356da77b85a9b0$var$I18N__BASE}.toolbox.titles.mapLayers">${i18n.titles.mapLayers}</h4>
                    <span class="${$8c356da77b85a9b0$var$CLASS__TOOLBOX_SECTION}__icon oltb-tippy" data-oltb-i18n="${$8c356da77b85a9b0$var$I18N__BASE_COMMON}.titles.toggleSection" title="${i18nCommon.toggleSection}"></span>
                </div>
                <div class="${$8c356da77b85a9b0$var$CLASS__TOOLBOX_SECTION}__groups" id="${$8c356da77b85a9b0$var$ID__PREFIX}-map-toolbox-collapsed" style="display: ${this.localStorage[`${$8c356da77b85a9b0$var$ID__PREFIX}-map-toolbox-collapsed`] ? 'none' : 'block'}">
                    ${this.options.disableMapCreateLayerButton ? '' : `
                            <div class="${$8c356da77b85a9b0$var$CLASS__TOOLBOX_SECTION}__group">
                                <div class="oltb-input-button-group">
                                    <input type="text" id="${$8c356da77b85a9b0$var$ID__PREFIX}-map-stack-add-text" class="oltb-input" data-oltb-i18n="${$8c356da77b85a9b0$var$I18N__BASE}.toolbox.groups.createMapLayer.placeholder" placeholder="${i18n.groups.createMapLayer.placeholder}">
                                    <button type="button" id="${$8c356da77b85a9b0$var$ID__PREFIX}-map-stack-add-button" class="oltb-btn oltb-btn--green-mid oltb-tippy" data-oltb-i18n="${$8c356da77b85a9b0$var$I18N__BASE}.toolbox.groups.createMapLayer.create" title="${i18n.groups.createMapLayer.create}">
                                        ${(0, $dcff5ab966a6537f$export$a297fe855adfd36c)({
            path: (0, $35649bc6579784f8$export$3fddabec91763a6e).plus.stroked,
            width: 20,
            height: 20,
            fill: 'none',
            stroke: '#FFFFFFFF',
            strokeWidth: 1,
            class: 'oltb-btn__icon'
        })}
                                    </button>
                                </div>
                            </div>
                        `}
                    <div class="${$8c356da77b85a9b0$var$CLASS__TOOLBOX_SECTION}__group ${this.options.disableMapCreateLayerButton ? `${$8c356da77b85a9b0$var$CLASS__TOOLBOX_SECTION}__group--topmost` : ''}">
                        <ul id="${$8c356da77b85a9b0$var$ID__PREFIX}-map-stack" class="${$8c356da77b85a9b0$var$CLASS__TOOLBOX_LIST}"></ul>
                    </div>
                </div>
                <div class="${$8c356da77b85a9b0$var$CLASS__TOOLBOX_SECTION}__header oltb-toggleable" data-oltb-toggleable-target="${$8c356da77b85a9b0$var$ID__PREFIX}-feature-toolbox-collapsed">
                    <h4 class="${$8c356da77b85a9b0$var$CLASS__TOOLBOX_SECTION}__title" data-oltb-i18n="${$8c356da77b85a9b0$var$I18N__BASE}.toolbox.titles.featureLayers">${i18n.titles.featureLayers}</h4>
                    <span class="${$8c356da77b85a9b0$var$CLASS__TOOLBOX_SECTION}__icon oltb-tippy" data-oltb-i18n="${$8c356da77b85a9b0$var$I18N__BASE_COMMON}.titles.toggleSection" title="${i18nCommon.toggleSection}"></span>
                </div>
                <div class="${$8c356da77b85a9b0$var$CLASS__TOOLBOX_SECTION}__groups" id="${$8c356da77b85a9b0$var$ID__PREFIX}-feature-toolbox-collapsed" style="display: ${this.localStorage[`${$8c356da77b85a9b0$var$ID__PREFIX}-feature-toolbox-collapsed`] ? 'none' : 'block'}">
                    <div class="${$8c356da77b85a9b0$var$CLASS__TOOLBOX_SECTION}__group">
                        ${this.options.disableFeatureCreateLayerButton ? '' : `
                                <div class="oltb-input-button-group">
                                    <input type="text" id="${$8c356da77b85a9b0$var$ID__PREFIX}-feature-stack-add-text" class="oltb-input" data-oltb-i18n="${$8c356da77b85a9b0$var$I18N__BASE}.toolbox.groups.createFeatureLayer.placeholder" placeholder="${i18n.groups.createFeatureLayer.placeholder}">
                                    <button type="button" id="${$8c356da77b85a9b0$var$ID__PREFIX}-feature-stack-add-button" class="oltb-btn oltb-btn--green-mid oltb-tippy" data-oltb-i18n="${$8c356da77b85a9b0$var$I18N__BASE}.toolbox.groups.createFeatureLayer.create" title="${i18n.groups.createFeatureLayer.create}">
                                        ${(0, $dcff5ab966a6537f$export$a297fe855adfd36c)({
            path: (0, $35649bc6579784f8$export$3fddabec91763a6e).plus.stroked,
            width: 20,
            height: 20,
            fill: 'none',
            stroke: '#FFFFFFFF',
            strokeWidth: 1,
            class: 'oltb-btn__icon'
        })}
                                    </button>
                                </div>
                            `}
                    </div>
                    <div class="${$8c356da77b85a9b0$var$CLASS__TOOLBOX_SECTION}__group ${this.options.disableFeatureCreateLayerButton ? `${$8c356da77b85a9b0$var$CLASS__TOOLBOX_SECTION}__group--topmost` : ''}">
                        <ul id="${$8c356da77b85a9b0$var$ID__PREFIX}-feature-stack" class="${$8c356da77b85a9b0$var$CLASS__TOOLBOX_LIST} ${$8c356da77b85a9b0$var$CLASS__TOOLBOX_LIST}--selectable"></ul>
                    </div>
                </div>
            </div>
        `;
        (0, $8f42450ebdd44f5e$export$8e7188a60a5bbe16).getToolboxElement().insertAdjacentHTML('beforeend', html);
    }
    #initToggleables() {
        this.uiRefToolboxSection.querySelectorAll(`.${$8c356da77b85a9b0$var$CLASS__TOGGLEABLE}`).forEach((toggle)=>{
            toggle.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.click, this.#onToggleToolbox.bind(this, toggle));
        });
    }
    #initContextMenuItems() {
        if (!this.options.disableMapCreateLayerButton || !this.options.disableFeatureCreateLayerButton) (0, $062067ac9882af21$export$b6aef0d24cd6ce8c).addItem({});
        if (!this.options.disableMapCreateLayerButton) (0, $062067ac9882af21$export$b6aef0d24cd6ce8c).addItem({
            icon: this.icon,
            i18nKey: `${$8c356da77b85a9b0$var$I18N__BASE}.contextItems.addMapLayer`,
            fn: this.#onContextMenuAddMapLayerModal.bind(this)
        });
        if (!this.options.disableFeatureCreateLayerButton) (0, $062067ac9882af21$export$b6aef0d24cd6ce8c).addItem({
            icon: this.icon,
            i18nKey: `${$8c356da77b85a9b0$var$I18N__BASE}.contextItems.addFeatureLayer`,
            fn: this.#onContextMenuAddFeatureLayer.bind(this)
        });
    }
    //--------------------------------------------------------------------
    // # Section: Tool Control
    //--------------------------------------------------------------------
    activateTool() {
        this.isActive = true;
        this.uiRefToolboxSection.classList.add(`${$8c356da77b85a9b0$var$CLASS__TOOLBOX_SECTION}--show`);
        this.button.classList.add(`${$8c356da77b85a9b0$var$CLASS__TOOL_BUTTON}--active`);
        this.localStorage.isActive = true;
        (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).setStateObject($8c356da77b85a9b0$var$LocalStorageNodeName, this.localStorage);
        this.uiRefToolboxSection.scrollIntoView({
            behavior: 'smooth',
            block: 'end',
            inline: 'nearest'
        });
    }
    deactivateTool() {
        this.isActive = false;
        this.uiRefToolboxSection.classList.remove(`${$8c356da77b85a9b0$var$CLASS__TOOLBOX_SECTION}--show`);
        this.button.classList.remove(`${$8c356da77b85a9b0$var$CLASS__TOOL_BUTTON}--active`);
        this.localStorage.isActive = false;
        (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).setStateObject($8c356da77b85a9b0$var$LocalStorageNodeName, this.localStorage);
    }
    //--------------------------------------------------------------------
    // # Section: Browser Events
    //--------------------------------------------------------------------
    #onOLTBReady(event) {
        if (this.localStorage.isActive) this.activateTool();
        // Note:
        // Need to clean unused map- and feature layers
        // These can be layers that the user have created and that (at this point) is not persisted when app is reloaded
        this.removeUnusedLayers();
    }
    #onWindowBrowserStateCleared() {
        this.doClearState();
        if (this.isActive) this.deactivateTool();
        // Note: 
        // @Consumer callback
        if (this.options.onBrowserStateCleared) this.options.onBrowserStateCleared();
    }
    #onWindowKeyUp(event) {
        if ((0, $fbd95439548fdf50$export$ad7bf7af8762113)(event, (0, $a256deadcc62504f$export$4384767a59dc851d).layerTool)) this.onClickTool(event);
    }
    #onWindowMapLayerAdded(event) {
        this.doMapLayerAdded(event);
    }
    #onWindowMapLayerRemoved(event) {
        this.doMapLayerRemoved(event);
    }
    #onWindowFeatureLayerAdded(event) {
        this.doFeatureLayerAdded(event);
    }
    #onWindowFeatureLayerRemoved(event) {
        this.doFeatureLayerRemoved(event);
    }
    //--------------------------------------------------------------------
    // # Section: LocalStorage Helpers
    //--------------------------------------------------------------------
    removeUnusedLayers() {
        // Note:
        // MapLayers
        const mapLayersToRemove = [];
        this.localStorage.mapLayers.forEach((layer)=>{
            if (!(0, $e75fe1c51a3d360c$export$eff87c52915dd7fe).hasMapLayerWithId(layer.id)) mapLayersToRemove.push(layer);
        });
        mapLayersToRemove.forEach((layerToRemove)=>{
            this.localStorage.mapLayers = this.localStorage.mapLayers.filter((layer)=>{
                return layerToRemove.id !== layer.id;
            });
        });
        // Note:
        // FeatureLayers
        const featureLayersToRemove = [];
        this.localStorage.featureLayers.forEach((layer)=>{
            if (!(0, $e75fe1c51a3d360c$export$eff87c52915dd7fe).hasFeatureLayerWithId(layer.id)) featureLayersToRemove.push(layer);
        });
        featureLayersToRemove.forEach((layerToRemove)=>{
            this.localStorage.featureLayers = this.localStorage.featureLayers.filter((layer)=>{
                return layerToRemove.id !== layer.id;
            });
        });
        (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).setStateObject($8c356da77b85a9b0$var$LocalStorageNodeName, this.localStorage);
        (0, $b9b5c0363f244088$export$49b118289be48034).logDebug($8c356da77b85a9b0$var$FILENAME, 'removeUnusedLayers', {
            info: 'Removing unused layers',
            mapLayers: mapLayersToRemove,
            featureLayers: featureLayersToRemove
        });
    }
    getLocalStorageFeatureLayerById(id) {
        const layer = this.localStorage.featureLayers.find((item)=>{
            return item.id === id;
        });
        return layer;
    }
    hasLocalStorageFeatureLayerById(id) {
        return !!this.getLocalStorageFeatureLayerById(id);
    }
    getLocalStorageMapLayerById(id) {
        const layer = this.localStorage.mapLayers.find((item)=>{
            return item.id === id;
        });
        return layer;
    }
    hasLocalStorageMapLayerById(id) {
        return !!this.getLocalStorageMapLayerById(id);
    }
    //--------------------------------------------------------------------
    // # Section: ContextMenu Callbacks
    //--------------------------------------------------------------------
    #onContextMenuAddMapLayerModal() {
        this.doShowAddMapLayerModal();
    }
    #onContextMenuAddFeatureLayer() {
        this.doAddFeatureLayer({
            name: '',
            isDynamicallyAdded: true
        });
        // Note: 
        // Alert the user, the Layer was created when the tool was not active
        if (!this.isActive) (0, $9051f0e072bf4341$export$8d8dc7d5f743331b).success({
            i18nKey: `${$8c356da77b85a9b0$var$I18N__BASE}.toasts.infos.addFeatureLayer`,
            autoremove: true
        });
    }
    //--------------------------------------------------------------------
    // # Section: Sortable
    //--------------------------------------------------------------------
    #generateSortable(element, options) {
        const duration = (0, $1e8c0ef90ed82280$export$a33e119b2316dcb7).getConfig().animationDuration.warp;
        return (0, $dc7ec905e041f51c$export$2e2bcd8739ae039).create(element, {
            group: options.group,
            dataIdAttr: 'data-oltb-sort-index',
            animation: duration,
            forceFallback: true,
            handle: `.${$8c356da77b85a9b0$var$CLASS__TOOLBOX_LIST}__handle`,
            chosenClass: `${$8c356da77b85a9b0$var$CLASS__TOOLBOX_LIST}__item--chosen`,
            dragClass: `${$8c356da77b85a9b0$var$CLASS__TOOLBOX_LIST}__item--drag`,
            ghostClass: `${$8c356da77b85a9b0$var$CLASS__TOOLBOX_LIST}__item--ghost`,
            onEnd: (event)=>this.#onEndSortable(event, options)
        });
    }
    #onEndSortable(event, options) {
        // Note: 
        // User callback data
        // The old/new are swapped due to the list beeing reversed in DESC order
        const list = [];
        const currentItem = {
            id: event.item.getAttribute('data-oltb-id'),
            oldIndex: event.newDraggableIndex,
            newIndex: event.oldDraggableIndex
        };
        const ul = event.to;
        ul.childNodes.forEach((li, index)=>{
            // Note: 
            // Reverse the index so that 0 is at bottom of list not top
            const reversedIndex = ul.childNodes.length - index - $8c356da77b85a9b0$var$INDEX_OFFSET;
            // Update data-attribute, this is used by Sortable.js to do the sorting
            li.setAttribute('data-oltb-sort-index', reversedIndex);
            // Update state that is stored in localStorage
            // This will keep track of the sort after a reload
            const id = li.getAttribute('data-oltb-id');
            // Note: 
            // Only meta data about a layer is stored in LocalStorage
            // This is not true for the BookmarkTool that has slightly different logic
            const layerMetaItem = options.getLocalStorageItemById(id);
            if (layerMetaItem) layerMetaItem.sortIndex = reversedIndex;
            // Note: 
            // The actual layer must also be updated
            const layerItem = options.getLayerItemById(id);
            if (layerItem) layerItem.sortIndex = reversedIndex;
            // Update each layer with the new ZIndex
            options.setZIndex(id, reversedIndex);
            // Update callback data
            list.push({
                id: id,
                index: reversedIndex
            });
        });
        (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).setStateObject($8c356da77b85a9b0$var$LocalStorageNodeName, this.localStorage);
        (0, $b9b5c0363f244088$export$49b118289be48034).logDebug($8c356da77b85a9b0$var$FILENAME, 'onEndSortable', {
            currentItem: currentItem,
            list: list
        });
        // Note: 
        // @Consumer callback
        if (options.callback) options.callback(currentItem, list);
    }
    #sortSortableDesc(sortable, animate = false) {
        const order = sortable.toArray().sort().reverse();
        sortable.sort(order, animate);
    }
    //--------------------------------------------------------------------
    // # Section: Conversions/Validation
    //--------------------------------------------------------------------
    isValidEnter(event) {
        return event.type === (0, $a9807b370eed025c$export$ada873a34909da65).browser.keyUp && event.key === (0, $7cb32231c4f9783a$export$70f9e5bc10d7eac).valueEnter;
    }
    hasLayerFeatures(layer) {
        return layer.getSource().getFeatures instanceof Function && layer.getSource().getFeatures().length > 0;
    }
    hasProjection(projection) {
        const hasProjection = (0, $3d63321abab47ecf$export$38112acb54e12e1).hasProjection(projection);
        if (!hasProjection) {
            (0, $b9b5c0363f244088$export$49b118289be48034).logError($8c356da77b85a9b0$var$FILENAME, 'hasProjection', {
                message: 'Missing projection definition',
                projection: projection
            });
            (0, $9051f0e072bf4341$export$8d8dc7d5f743331b).error({
                i18nKey: `${$8c356da77b85a9b0$var$I18N__BASE}.toasts.errors.missingProjection`
            });
        }
        return hasProjection;
    }
    //--------------------------------------------------------------------
    // # Section: Map/UI Callbacks
    //--------------------------------------------------------------------
    #onToggleToolbox(toggle) {
        const targetName = toggle.dataset.oltbToggleableTarget;
        this.doToggleToolboxSection(targetName);
    }
    #onAddFeatureLayerByKey(event) {
        if (!this.isValidEnter(event)) return;
        this.#onAddFeatureLayerByClick(event);
    }
    #onAddFeatureLayerByClick(event) {
        const name = this.uiRefAddFeatureLayerText.value;
        this.uiRefAddFeatureLayerText.value = '';
        this.doAddFeatureLayer({
            name: name,
            isDynamicallyAdded: true
        });
    }
    #onCreateMapLayer(result) {
        if (!this.hasProjection(result.projection)) return;
        try {
            this.doAddMapLayer(result);
        } catch (error) {
            (0, $b9b5c0363f244088$export$49b118289be48034).logError($8c356da77b85a9b0$var$FILENAME, 'onCreateMapLayer', {
                message: 'Failed to create new layer',
                error: error
            });
            (0, $9051f0e072bf4341$export$8d8dc7d5f743331b).error({
                i18nKey: `${$8c356da77b85a9b0$var$I18N__BASE}.toasts.errors.addFeatureLayer`
            });
        }
    }
    #onMapLayerPropertyChange(id, layerElement, checkbox, event) {
        // Note:
        // Only run for visibility changes
        const property = event.key;
        if (property !== 'visible') return;
        layerElement.classList.toggle(`${$8c356da77b85a9b0$var$CLASS__TOOLBOX_LIST}__item--hidden`);
        const isVisible = !layerElement.classList.contains(`${$8c356da77b85a9b0$var$CLASS__TOOLBOX_LIST}__item--hidden`);
        const storedLayerState = this.getLocalStorageMapLayerById(id);
        checkbox.checked = isVisible;
        // Note: 
        // storedLayerState is a reference to a object inside this.localStorage
        if (storedLayerState) {
            storedLayerState.isVisible = isVisible;
            (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).setStateObject($8c356da77b85a9b0$var$LocalStorageNodeName, this.localStorage);
        }
    }
    #onFeatureLayerPropertyChange(id, layerElement, checkbox, event) {
        // Note:
        // Only run for visibility changes
        const property = event.key;
        if (property !== 'visible') return;
        layerElement.classList.toggle(`${$8c356da77b85a9b0$var$CLASS__TOOLBOX_LIST}__item--hidden`);
        const isVisible = !layerElement.classList.contains(`${$8c356da77b85a9b0$var$CLASS__TOOLBOX_LIST}__item--hidden`);
        const storedLayerState = this.getLocalStorageFeatureLayerById(id);
        checkbox.checked = isVisible;
        // Note: 
        // storedLayerState is a reference to a object inside this.localStorage
        if (storedLayerState) {
            storedLayerState.isVisible = isVisible;
            (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).setStateObject($8c356da77b85a9b0$var$LocalStorageNodeName, this.localStorage);
        }
    }
    #onLayerDelete(layerWrapper, callback) {
        this.askToDeleteLayer(layerWrapper, callback);
    }
    #onLayerVisibilityChange(layerWrapper, callback, layerName) {
        this.doChangeLayerVisibility(layerWrapper, callback);
    }
    #onLayerEdit(layerWrapper, callback, layerName) {
        this.askToRenameLayer(layerWrapper, callback, layerName);
    }
    #onLayerDownload(layerWrapper, callback) {
        this.askToDownloadLayer(layerWrapper, callback);
    }
    #onShowAddMapLayerModal() {
        this.doShowAddMapLayerModal();
    }
    //--------------------------------------------------------------------
    // # Section: Listeners Subscriptions
    //--------------------------------------------------------------------
    attachUIButtonCallbacks(options, layerWrapper, rightWrapper, layerName) {
        for(const name in options){
            const functionObject = options[name];
            const button = functionObject.function.call(this, layerWrapper, functionObject.callback, layerName);
            (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(rightWrapper, [
                button
            ]);
        }
    }
    //--------------------------------------------------------------------
    // # Section: User Interface
    //--------------------------------------------------------------------
    #createUILayerNameTippy(layerName) {
        return (0, $43bf50b0fa1441ac$export$2e2bcd8739ae039)(layerName, {
            content (reference) {
                const title = reference.getAttribute('title');
                reference.removeAttribute('title');
                return title;
            },
            placement: 'top',
            theme: 'oltb oltb-themed',
            delay: (0, $1e8c0ef90ed82280$export$a33e119b2316dcb7).getConfig().tippy.delay
        });
    }
    #createUIMapLayerItem(layerWrapper, options) {
        const layer = layerWrapper.getLayer();
        // Note: 
        // The state of the layer is a combination of data stored from localStorage and 
        // data if it is the first time the layer is added
        const layerId = layerWrapper.getId();
        const defaultSortIndex = this.uiRefMapLayerStack.childNodes.length;
        const defaultVisibility = layer.getVisible();
        const layerState = {
            id: layerId,
            sortIndex: defaultSortIndex,
            isVisible: defaultVisibility
        };
        // Note: 
        // Check if the state needs to be updated or stored for the first time
        const storedLayerState = this.getLocalStorageMapLayerById(layerId);
        if (storedLayerState) {
            layerState.sortIndex = storedLayerState.sortIndex;
            layerState.isVisible = storedLayerState.isVisible;
            layerWrapper.sortIndex = layerState.sortIndex;
            layer.setVisible(layerState.isVisible);
        } else this.localStorage.mapLayers.push({
            id: layerId,
            sortIndex: layerState.sortIndex,
            isVisible: layerState.isVisible
        });
        (0, $e75fe1c51a3d360c$export$eff87c52915dd7fe).setMapLayerZIndex(layerId, layerState.sortIndex);
        const layerElement = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'li',
            id: `${$8c356da77b85a9b0$var$ID__PREFIX}-map-${layerId}`,
            class: `
                ${$8c356da77b85a9b0$var$CLASS__TOOLBOX_LIST}__item
                ${!layerState.isVisible ? `${$8c356da77b85a9b0$var$CLASS__TOOLBOX_LIST}__item--hidden` : ''}
            `,
            attributes: {
                'data-oltb-id': layerId,
                'data-oltb-sort-index': layerState.sortIndex
            }
        });
        const layerName = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'span',
            text: layerWrapper.getName().ellipsis(20),
            class: `${$8c356da77b85a9b0$var$CLASS__TOOLBOX_LIST}__title`,
            title: layerWrapper.getName(),
            prototypes: {
                getTippy: function() {
                    return this._tippy;
                }
            }
        });
        // Note: 
        // This tooltip can not be triggered by the delegated .oltb-tippy class
        // Because the tooltip instance can not be reached in the renaming function unless it is known during "compile time"
        this.#createUILayerNameTippy(layerName);
        const leftWrapper = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'div',
            class: `${$8c356da77b85a9b0$var$CLASS__TOOLBOX_LIST}__wrapper`
        });
        const [checkboxWrapper, checkbox] = (0, $d4a181242e81568c$export$cb0362de623b471b)({
            checked: layerState.isVisible,
            listeners: {
                'click': this.#onLayerVisibilityChange.bind(this, layerWrapper, this.options.onMapLayerVisibilityChanged, layerName)
            }
        });
        layer.on((0, $a9807b370eed025c$export$ada873a34909da65).openLayers.propertyChange, this.#onMapLayerPropertyChange.bind(this, layerId, layerElement, checkbox));
        const layerDot = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'div',
            class: `${$8c356da77b85a9b0$var$CLASS__TOOLBOX_LIST}__dot`
        });
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(leftWrapper, [
            layerDot,
            checkboxWrapper
        ]);
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(leftWrapper, [
            layerName
        ]);
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(layerElement, [
            leftWrapper
        ]);
        const rightWrapper = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'div',
            class: `${$8c356da77b85a9b0$var$CLASS__TOOLBOX_LIST}__wrapper`
        });
        this.attachUIButtonCallbacks(options, layerWrapper, rightWrapper, layerName);
        const i18n = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get(`${$8c356da77b85a9b0$var$I18N__BASE_COMMON}.titles`);
        const layerHandle = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'div',
            class: `${$8c356da77b85a9b0$var$CLASS__TOOLBOX_LIST}__handle oltb-tippy`,
            title: i18n.dragToSort
        });
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(rightWrapper, [
            layerHandle
        ]);
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(layerElement, [
            rightWrapper
        ]);
        this.uiRefMapLayerStack.append(layerElement);
        this.#sortSortableDesc(this.sortableMapLayerStack);
    }
    #createUIFeatureLayerItem(layerWrapper, options) {
        const layer = layerWrapper.getLayer();
        // Note: 
        // The state of the layer is a combination of data stored from localStorage and 
        // data if it is the first time the layer is added
        const layerId = layerWrapper.getId();
        const defaultSortIndex = this.uiRefFeatureLayerStack.childNodes.length;
        const defaultVisibility = layer.getVisible();
        const layerState = {
            id: layerId,
            sortIndex: defaultSortIndex,
            isVisible: defaultVisibility
        };
        // Check if the state needs to be updated or stored for the first time
        const storedLayerState = this.getLocalStorageFeatureLayerById(layerId);
        if (storedLayerState) {
            layerState.sortIndex = storedLayerState.sortIndex;
            layerState.isVisible = storedLayerState.isVisible;
            layerWrapper.sortIndex = layerState.sortIndex;
            layer.setVisible(layerState.isVisible);
        } else this.localStorage.featureLayers.push({
            id: layerId,
            sortIndex: layerState.sortIndex,
            isVisible: layerState.isVisible
        });
        (0, $e75fe1c51a3d360c$export$eff87c52915dd7fe).setFeatureLayerZIndex(layerId, layerState.sortIndex);
        const layerElement = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'li',
            id: `${$8c356da77b85a9b0$var$ID__PREFIX}-feature-${layerId}`,
            class: `
                ${$8c356da77b85a9b0$var$CLASS__TOOLBOX_LIST}__item 
                ${$8c356da77b85a9b0$var$CLASS__TOOLBOX_LIST}__item--active
                ${!layerState.isVisible ? `${$8c356da77b85a9b0$var$CLASS__TOOLBOX_LIST}__item--hidden` : ''}
            `,
            attributes: {
                'data-oltb-id': layerId,
                'data-oltb-sort-index': layerState.sortIndex
            }
        });
        const layerName = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'span',
            text: layerWrapper.getName().ellipsis(20),
            class: `${$8c356da77b85a9b0$var$CLASS__TOOLBOX_LIST}__title`,
            title: layerWrapper.getName(),
            prototypes: {
                getTippy: function() {
                    return this._tippy;
                }
            },
            listeners: {
                'click': this.doSetFeatureLayerAsActive.bind(this, layerWrapper, layerElement)
            }
        });
        // Note: 
        // This tooltip can not be triggered by the delegated .oltb-tippy class
        // Because the tooltip instance can not be reached in the renaming function unless it is known during "compile time"
        this.#createUILayerNameTippy(layerName);
        const leftWrapper = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'div',
            class: `${$8c356da77b85a9b0$var$CLASS__TOOLBOX_LIST}__wrapper`
        });
        const [checkboxWrapper, checkbox] = (0, $d4a181242e81568c$export$cb0362de623b471b)({
            checked: layerState.isVisible,
            listeners: {
                'click': this.#onLayerVisibilityChange.bind(this, layerWrapper, this.options.onFeatureLayerVisibilityChanged, layerName)
            }
        });
        layer.on((0, $a9807b370eed025c$export$ada873a34909da65).openLayers.propertyChange, this.#onFeatureLayerPropertyChange.bind(this, layerId, layerElement, checkbox));
        const layerDot = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'div',
            class: `${$8c356da77b85a9b0$var$CLASS__TOOLBOX_LIST}__dot`,
            listeners: {
                'click': this.doSetFeatureLayerAsActive.bind(this, layerWrapper, layerElement)
            }
        });
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(leftWrapper, [
            layerDot,
            checkboxWrapper
        ]);
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(leftWrapper, [
            layerName
        ]);
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(layerElement, [
            leftWrapper
        ]);
        const rightWrapper = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'div',
            class: `${$8c356da77b85a9b0$var$CLASS__TOOLBOX_LIST}__wrapper`
        });
        this.attachUIButtonCallbacks(options, layerWrapper, rightWrapper, layerName);
        const i18n = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get(`${$8c356da77b85a9b0$var$I18N__BASE_COMMON}.titles`);
        const layerHandle = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'div',
            class: `${$8c356da77b85a9b0$var$CLASS__TOOLBOX_LIST}__handle oltb-tippy`,
            title: i18n.dragToSort,
            attributes: {
                'data-oltb-i18n': `${$8c356da77b85a9b0$var$I18N__BASE_COMMON}.titles.dragToSort`
            }
        });
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(rightWrapper, [
            layerHandle
        ]);
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(layerElement, [
            rightWrapper
        ]);
        this.uiRefFeatureLayerStack.append(layerElement);
        this.#sortSortableDesc(this.sortableFeatureLayerStack);
    }
    #createUIDeleteButton(layerWrapper, callback) {
        const i18nKey = `${$8c356da77b85a9b0$var$I18N__BASE_COMMON}.titles.delete`;
        const deleteButton = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'button',
            class: `${$8c356da77b85a9b0$var$CLASS__FUNC_BUTTON} ${$8c356da77b85a9b0$var$CLASS__FUNC_BUTTON}--delete oltb-tippy`,
            title: (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get(i18nKey),
            attributes: {
                'type': 'button',
                'data-oltb-i18n': i18nKey
            },
            listeners: {
                'click': this.#onLayerDelete.bind(this, layerWrapper, callback)
            }
        });
        return deleteButton;
    }
    #createUIDownloadButton(layerWrapper, callback) {
        const i18nKey = `${$8c356da77b85a9b0$var$I18N__BASE_COMMON}.titles.download`;
        const downloadButton = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'button',
            class: `${$8c356da77b85a9b0$var$CLASS__FUNC_BUTTON} ${$8c356da77b85a9b0$var$CLASS__FUNC_BUTTON}--download oltb-tippy`,
            title: (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get(i18nKey),
            attributes: {
                'type': 'button',
                'data-oltb-i18n': i18nKey
            },
            listeners: {
                'click': this.#onLayerDownload.bind(this, layerWrapper, callback)
            }
        });
        return downloadButton;
    }
    #createUIEditButton(layerWrapper, callback, layerName) {
        const i18nKey = `${$8c356da77b85a9b0$var$I18N__BASE_COMMON}.titles.rename`;
        const editButton = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'button',
            class: `${$8c356da77b85a9b0$var$CLASS__FUNC_BUTTON} ${$8c356da77b85a9b0$var$CLASS__FUNC_BUTTON}--edit oltb-tippy`,
            title: (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get(i18nKey),
            attributes: {
                'type': 'button',
                'data-oltb-i18n': i18nKey
            },
            listeners: {
                'click': this.#onLayerEdit.bind(this, layerWrapper, callback, layerName)
            }
        });
        return editButton;
    }
    //--------------------------------------------------------------------
    // # Section: Ask User
    //--------------------------------------------------------------------
    askToDownloadLayer(layerWrapper, callback) {
        return new (0, $2d7a7b1f7c01fb97$export$ec53fcc6e8f0dd7f)({
            onDownload: (result)=>{
                const format = (0, $33d6a58e88aba98a$export$570785d7398311f5)(result.format);
                if (!format) {
                    (0, $b9b5c0363f244088$export$49b118289be48034).logError($8c356da77b85a9b0$var$FILENAME, 'onLayerDownload', {
                        title: 'Error',
                        message: `The layer format is not supported (${format})`
                    });
                    (0, $9051f0e072bf4341$export$8d8dc7d5f743331b).error({
                        i18nKey: `${$8c356da77b85a9b0$var$I18N__BASE}.toasts.errors.unsupportedFormat`
                    });
                    return;
                }
                (0, $b9b5c0363f244088$export$49b118289be48034).logDebug($8c356da77b85a9b0$var$FILENAME, 'onLayerDownload', {
                    layerName: layerWrapper.getName(),
                    formatName: result.format,
                    format: format
                });
                this.doDownloadLayer(layerWrapper, format, result, callback);
            }
        });
    }
    askToRenameLayer(layerWrapper, callback, layerName) {
        const i18n = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get(`${$8c356da77b85a9b0$var$I18N__BASE}.dialogs.prompts.renameLayer`);
        return (0, $c815862f3b0d8f0b$export$3ddf2d174ce01153).prompt({
            title: i18n.title,
            message: `${i18n.message} <strong>${layerWrapper.getName()}</strong>`,
            value: layerWrapper.getName(),
            confirmText: i18n.confirmText,
            cancelText: i18n.cancelText,
            onConfirm: (result)=>{
                if (result !== null && !!result.length) {
                    // Update model
                    layerWrapper.setName(result);
                    // Update UI-item
                    layerName.innerText = result.ellipsis(20);
                    layerName.getTippy().setContent(result);
                    // Note: 
                    // @Consumer callback
                    if (callback) callback(layerWrapper);
                }
            }
        });
    }
    askToDeleteLayer(layerWrapper, callback) {
        const i18n = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get(`${$8c356da77b85a9b0$var$I18N__BASE}.dialogs.confirms.deleteLayer`);
        return (0, $c815862f3b0d8f0b$export$3ddf2d174ce01153).confirm({
            title: i18n.title,
            message: `${i18n.message} <strong>${layerWrapper.getName()}</strong>?`,
            confirmText: i18n.confirmText,
            cancelText: i18n.cancelText,
            onConfirm: ()=>{
                callback(layerWrapper);
            }
        });
    }
    //--------------------------------------------------------------------
    // # Section: Tool DoActions
    //--------------------------------------------------------------------
    doClearState() {
        this.localStorage = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep($8c356da77b85a9b0$var$LocalStorageDefaults);
        (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).setStateObject($8c356da77b85a9b0$var$LocalStorageNodeName, $8c356da77b85a9b0$var$LocalStorageDefaults);
    }
    doToggleToolboxSection(targetName) {
        const targetNode = window.document.getElementById(targetName);
        const duration = (0, $1e8c0ef90ed82280$export$a33e119b2316dcb7).getConfig().animationDuration.fast;
        targetNode?.slideToggle(duration, (collapsed)=>{
            this.localStorage[targetName] = collapsed;
            (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).setStateObject($8c356da77b85a9b0$var$LocalStorageNodeName, this.localStorage);
        });
    }
    doMapLayerAdded(event) {
        const isSilent = event.detail.isSilent;
        const layerWrapper = event.detail.layerWrapper;
        const disableEditButton = event.detail.disableMapLayerEditButton || this.options.disableMapLayerEditButton || false;
        const disableDeleteButton = event.detail.disableMapLayerDeleteButton || this.options.disableMapLayerDeleteButton || false;
        this.#createUIMapLayerItem(layerWrapper, {
            ...!disableEditButton && {
                editButton: {
                    function: this.#createUIEditButton.bind(this),
                    callback: this.options.onMapLayerRenamed.bind(this)
                }
            },
            ...!disableDeleteButton && {
                deleteButton: {
                    function: this.#createUIDeleteButton.bind(this),
                    callback: (0, $e75fe1c51a3d360c$export$eff87c52915dd7fe).removeMapLayer.bind((0, $e75fe1c51a3d360c$export$eff87c52915dd7fe))
                }
            }
        });
        // Note: 
        // @Consumer callback
        if (!isSilent && this.options.onMapLayerAdded) this.options.onMapLayerAdded(layerWrapper);
    }
    doRemoveUILayerItem(uiRefStack, selector) {
        const uiRefLayer = uiRefStack.querySelector(selector);
        if (uiRefLayer) (0, $e1b36be5f031477b$export$cb0933279c36a66b).removeElement(uiRefLayer);
    }
    doMapLayerRemoved(event) {
        (0, $09399be6683278f4$export$ffc0bcd424265bb8).hideOverlay();
        const isSilent = event.detail.isSilent;
        const layerWrapper = event.detail.layerWrapper;
        const layerId = layerWrapper.getId();
        this.doRemoveUILayerItem(this.uiRefMapLayerStack, `#${$8c356da77b85a9b0$var$ID__PREFIX}-map-${layerId}`);
        // Note: 
        // @Consumer callback
        if (!isSilent && this.options.onMapLayerRemoved) this.options.onMapLayerRemoved(layerWrapper);
    }
    doFeatureLayerAdded(event) {
        const isSilent = event.detail.isSilent;
        const layerWrapper = event.detail.layerWrapper;
        const disableEditButton = event.detail.disableFeatureLayerEditButton || this.options.disableFeatureLayerEditButton || false;
        const disableDownloadButton = event.detail.disableFeatureLayerDownloadButton || this.options.disableFeatureLayerDownloadButton || false;
        const disableDeleteButton = event.detail.disableFeatureLayerDeleteButton || this.options.disableFeatureLayerDeleteButton || false;
        this.doRemoveActiveFeatureLayerClass();
        this.#createUIFeatureLayerItem(layerWrapper, {
            ...!disableEditButton && {
                editButton: {
                    function: this.#createUIEditButton.bind(this),
                    callback: this.options.onFeatureLayerRenamed
                }
            },
            ...!disableDownloadButton && {
                downloadButton: {
                    function: this.#createUIDownloadButton.bind(this),
                    callback: this.options.onFeatureLayerDownloaded
                }
            },
            ...!disableDeleteButton && {
                deleteButton: {
                    function: this.#createUIDeleteButton.bind(this),
                    callback: (0, $e75fe1c51a3d360c$export$eff87c52915dd7fe).removeFeatureLayer.bind((0, $e75fe1c51a3d360c$export$eff87c52915dd7fe))
                }
            }
        });
        // Note: 
        // @Consumer callback
        if (!isSilent && this.options.onFeatureLayerAdded) this.options.onFeatureLayerAdded(layerWrapper);
    }
    doSetActiveLayerAsSelected(uiRefStack) {
        const activeFeatureLayer = (0, $e75fe1c51a3d360c$export$eff87c52915dd7fe).getActiveFeatureLayer();
        if (activeFeatureLayer) uiRefStack.querySelectorAll('li').forEach((item)=>{
            if (activeFeatureLayer.getId() === item.getAttribute('data-oltb-id')) item.classList.add(`${$8c356da77b85a9b0$var$CLASS__TOOLBOX_LIST}__item--active`);
        });
    }
    doFeatureLayerRemoved(event) {
        (0, $09399be6683278f4$export$ffc0bcd424265bb8).hideOverlay();
        const isSilent = event.detail.isSilent;
        const layerWrapper = event.detail.layerWrapper;
        const layerId = layerWrapper.getId();
        this.doRemoveUILayerItem(this.uiRefFeatureLayerStack, `#${$8c356da77b85a9b0$var$ID__PREFIX}-feature-${layerId}`);
        this.doRemoveActiveFeatureLayerClass();
        this.doSetActiveLayerAsSelected(this.uiRefFeatureLayerStack);
        // Note: 
        // @Consumer callback
        if (!isSilent && this.options.onFeatureLayerRemoved) this.options.onFeatureLayerRemoved(layerWrapper);
    }
    doSetFeatureLayerAsActive(layerWrapper, layerElement) {
        this.doRemoveActiveFeatureLayerClass();
        (0, $e75fe1c51a3d360c$export$eff87c52915dd7fe).setActiveFeatureLayer(layerWrapper);
        layerElement.classList.add(`${$8c356da77b85a9b0$var$CLASS__TOOLBOX_LIST}__item--active`);
    }
    doRemoveActiveFeatureLayerClass() {
        // Note: 
        // Should just be one li-item that has the active class
        // Just in case, clean all items
        this.uiRefFeatureLayerStack.querySelectorAll('li').forEach((item)=>{
            item.classList.remove(`${$8c356da77b85a9b0$var$CLASS__TOOLBOX_LIST}__item--active`);
        });
    }
    doToggleLayerVisibility(layerWrapper) {
        const layer = layerWrapper.getLayer();
        const flippedVisibility = !layer.getVisible();
        layer.setVisible(flippedVisibility);
        return flippedVisibility;
    }
    doSetLayerFeaturesVisibility(layerWrapper, map, visibility = false) {
        const layer = layerWrapper.getLayer();
        if (!this.hasLayerFeatures(layer)) return;
        layer.getSource().getFeatures().forEach((feature)=>{
            if ((0, $45f5d1a81c4ed6cb$export$73e78dff44a347ad).hasTooltip(feature)) (0, $45f5d1a81c4ed6cb$export$73e78dff44a347ad).getTooltip(feature).setMap(visibility ? map : null);
        });
    }
    doChangeLayerVisibility(layerWrapper, callback) {
        const map = this.getMap();
        if (!map) return;
        (0, $09399be6683278f4$export$ffc0bcd424265bb8).hideOverlay();
        const visibility = this.doToggleLayerVisibility(layerWrapper);
        this.doSetLayerFeaturesVisibility(layerWrapper, map, visibility);
        // Note: 
        // @Consumer callback
        if (callback) callback(layerWrapper);
    }
    doDownloadLayer(layerWrapper, format, result, callback) {
        const features = layerWrapper.getLayer().getSource().getFeatures();
        const content = format.writeFeatures(features, {
            featureProjection: (0, $1e8c0ef90ed82280$export$a33e119b2316dcb7).getConfig().projection.default
        });
        const filename = `${layerWrapper.getName()}.${result.format.toLowerCase()}`;
        (0, $8659bbf0c949ad4c$export$bb3b75778e3e272)(filename, content);
        // Note: 
        // @Consumer callback
        if (callback) callback(layerWrapper, filename, content);
    }
    doAddMapLayer(options) {
        const layer = (0, $9670560ff2a74fee$export$982135f5c36d616f)(options.layer, {
            projection: options.projection || (0, $1e8c0ef90ed82280$export$a33e119b2316dcb7).getConfig().projection.default,
            source: (0, $aecb76f616dc0475$export$31ffe23a319daad5)(options.source, {
                url: options.url,
                params: JSON.parse(options.parameters),
                wrapX: options.wrapX,
                attributions: options.attributions,
                ...options.crossOrigin !== 'undefined' && {
                    crossOrigin: options.crossOrigin
                },
                format: (0, $33d6a58e88aba98a$export$570785d7398311f5)(options.source)
            })
        });
        return (0, $e75fe1c51a3d360c$export$eff87c52915dd7fe).addMapLayer({
            name: options.name,
            sortIndex: 0,
            isDynamicallyAdded: options.isDynamicallyAdded,
            layer: layer
        });
    }
    doAddFeatureLayer(options) {
        return (0, $e75fe1c51a3d360c$export$eff87c52915dd7fe).addFeatureLayer({
            name: options.name,
            sortIndex: 0,
            isDynamicallyAdded: options.isDynamicallyAdded
        });
    }
    doShowAddMapLayerModal() {
        if (this.layerModal) return;
        const name = this.uiRefAddMapLayerText.value;
        this.layerModal = new (0, $463eac1678c4e35c$export$a3ac271c78b4db14)({
            name: name,
            onCreate: (result)=>{
                this.#onCreateMapLayer(result);
            },
            onClose: ()=>{
                this.layerModal = undefined;
            }
        });
    }
}



var $f1q41 = parcelRequire("f1q41");









const $2321400a3a921fc4$var$FILENAME = 'zoom-in-tool.js';
const $2321400a3a921fc4$var$CLASS__TOOL_BUTTON = 'oltb-tool-button';
const $2321400a3a921fc4$var$I18N__BASE = 'tools.zoomInTool';
const $2321400a3a921fc4$var$DefaultOptions = Object.freeze({
    delta: 1,
    onInitiated: undefined,
    onClicked: undefined,
    onZoomed: undefined
});
/**
 * About:
 * Zoom into the Map
 * 
 * Description:
 * Increase zoom and go deeper into the Map's more detailed images.
 */ class $2321400a3a921fc4$export$99c93d665eb844f0 extends (0, $10d08d54da4ecbc4$export$cf198134d112da63) {
    constructor(options = {}){
        super({
            filename: $2321400a3a921fc4$var$FILENAME
        });
        const icon = (0, $dcff5ab966a6537f$export$a297fe855adfd36c)({
            path: (0, $35649bc6579784f8$export$3fddabec91763a6e).zoomIn.stroked,
            class: `${$2321400a3a921fc4$var$CLASS__TOOL_BUTTON}__icon`
        });
        const i18n = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get($2321400a3a921fc4$var$I18N__BASE);
        const button = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'button',
            html: icon,
            class: $2321400a3a921fc4$var$CLASS__TOOL_BUTTON,
            attributes: {
                'type': 'button',
                'data-tippy-content': `${i18n.title} (${(0, $a256deadcc62504f$export$4384767a59dc851d).zoomInTool})`,
                'data-tippy-content-post': `(${(0, $a256deadcc62504f$export$4384767a59dc851d).zoomInTool})`,
                'data-oltb-i18n': `${$2321400a3a921fc4$var$I18N__BASE}.title`
            },
            listeners: {
                'click': this.onClickTool.bind(this)
            }
        });
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(this.element, [
            button
        ]);
        this.button = button;
        this.options = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep($2321400a3a921fc4$var$DefaultOptions), options);
        this.attachGlobalListeners();
        // Note: 
        // @Consumer callback
        if (this.options.onInitiated) this.options.onInitiated();
    }
    attachGlobalListeners() {
        this.onWindowKeyUpBind = this.#onWindowKeyUp.bind(this);
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.keyUp, this.onWindowKeyUpBind);
    }
    detachGlobalListeners() {
        window.removeEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.keyUp, this.onWindowKeyUpBind);
    }
    //--------------------------------------------------------------------
    // # Section: Overridden
    //--------------------------------------------------------------------
    getName() {
        return super.getName();
    }
    onClickTool(event) {
        super.onClickTool(event);
        this.momentaryActivation();
        // Note: 
        // @Consumer callback
        if (this.options.onClicked) this.options.onClicked();
    }
    //--------------------------------------------------------------------
    // # Section: Tool Control
    //--------------------------------------------------------------------
    momentaryActivation() {
        const map = this.getMap();
        if (!map) return;
        this.doZoomIn(map);
    }
    //--------------------------------------------------------------------
    // # Section: Browser Events
    //--------------------------------------------------------------------
    #onWindowKeyUp(event) {
        if ((0, $fbd95439548fdf50$export$ad7bf7af8762113)(event, (0, $a256deadcc62504f$export$4384767a59dc851d).zoomInTool)) this.onClickTool(event);
    }
    //--------------------------------------------------------------------
    // # Section: Tool DoActions
    //--------------------------------------------------------------------
    doZoomIn(map) {
        const view = map.getView();
        const coordinates = (0, $9c4744460e43e41b$export$3fb495868742d370)(view.getCenter());
        const currentZoom = view.getZoom();
        const calculatedZoom = view.getConstrainedZoom(currentZoom + this.options.delta);
        (0, $eb687437705d7055$export$cc43ef3ca2ae36e8)({
            map: map,
            coordinates: coordinates,
            zoom: calculatedZoom,
            onDone: (result)=>{
                // Note: 
                // @Consumer callback
                if (this.options.onZoomed) this.options.onZoomed(result);
            }
        });
    }
}



var $f1q41 = parcelRequire("f1q41");

























const $6097679d5ffd37cd$var$FILENAME = 'measure-tool.js';
const $6097679d5ffd37cd$var$CLASS__TOOL_BUTTON = 'oltb-tool-button';
const $6097679d5ffd37cd$var$CLASS__TOOLBOX_SECTION = 'oltb-toolbox-section';
const $6097679d5ffd37cd$var$CLASS__TOGGLEABLE = 'oltb-toggleable';
const $6097679d5ffd37cd$var$ID__PREFIX = 'oltb-measure';
const $6097679d5ffd37cd$var$KEY__TOOLTIP = 'tools.measureTool';
const $6097679d5ffd37cd$var$I18N__BASE = 'tools.measureTool';
const $6097679d5ffd37cd$var$I18N__BASE_COMMON = 'commons';
const $6097679d5ffd37cd$var$DefaultOptions = Object.freeze({
    onInitiated: undefined,
    onClicked: undefined,
    onBrowserStateCleared: undefined,
    onStart: undefined,
    onEnd: undefined,
    onAbort: undefined,
    onError: undefined,
    onSnapped: undefined,
    onUnSnapped: undefined
});
const $6097679d5ffd37cd$var$LocalStorageNodeName = (0, $52e25f2a10ab5b5c$export$ada36e8a1c3bc83a).measureTool;
const $6097679d5ffd37cd$var$LocalStorageDefaults = Object.freeze({
    isActive: false,
    isCollapsed: false,
    toolType: (0, $9977d850e6d2e896$export$8f4397a63c3cef66).LineString,
    strokeColor: '#3B4352FF',
    fillColor: '#D7E3FA80'
});
/**
 * About:
 * Measure distances and areas
 * 
 * Description:
 * Measure distances and areas in metric scale. 
 * These objects can be edited and merged using the Edit tool.
 */ class $6097679d5ffd37cd$export$9ddc54d50debd217 extends (0, $10d08d54da4ecbc4$export$cf198134d112da63) {
    constructor(options = {}){
        super({
            filename: $6097679d5ffd37cd$var$FILENAME
        });
        const icon = (0, $dcff5ab966a6537f$export$a297fe855adfd36c)({
            path: (0, $35649bc6579784f8$export$3fddabec91763a6e).rulers.mixed,
            class: `${$6097679d5ffd37cd$var$CLASS__TOOL_BUTTON}__icon`
        });
        const i18n = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get($6097679d5ffd37cd$var$I18N__BASE);
        const button = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'button',
            html: icon,
            class: $6097679d5ffd37cd$var$CLASS__TOOL_BUTTON,
            attributes: {
                'type': 'button',
                'data-tippy-content': `${i18n.title} (${(0, $a256deadcc62504f$export$4384767a59dc851d).measureTool})`,
                'data-tippy-content-post': `(${(0, $a256deadcc62504f$export$4384767a59dc851d).measureTool})`,
                'data-oltb-i18n': `${$6097679d5ffd37cd$var$I18N__BASE}.title`
            },
            listeners: {
                'click': this.onClickTool.bind(this)
            }
        });
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(this.element, [
            button
        ]);
        this.button = button;
        this.isActive = false;
        this.options = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep($6097679d5ffd37cd$var$DefaultOptions), options);
        this.localStorage = (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).getAndMergeStateObject($6097679d5ffd37cd$var$LocalStorageNodeName, $6097679d5ffd37cd$var$LocalStorageDefaults);
        this.#initToolboxHTML();
        this.uiRefToolboxSection = window.document.querySelector(`#${$6097679d5ffd37cd$var$ID__PREFIX}-toolbox`);
        this.#initToggleables();
        this.uiRefToolType = this.uiRefToolboxSection.querySelector(`#${$6097679d5ffd37cd$var$ID__PREFIX}-type`);
        this.uiRefToolType.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.change, this.updateTool.bind(this));
        this.uiRefFillColor = this.uiRefToolboxSection.querySelector(`#${$6097679d5ffd37cd$var$ID__PREFIX}-fill-color`);
        this.uiRefFillColor.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.colorChange, this.updateTool.bind(this));
        this.uiRefStrokeColor = this.uiRefToolboxSection.querySelector(`#${$6097679d5ffd37cd$var$ID__PREFIX}-stroke-color`);
        this.uiRefStrokeColor.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.colorChange, this.updateTool.bind(this));
        this.#initDefaultValues();
        this.attachGlobalListeners();
        // Note: 
        // @Consumer callback
        if (this.options.onInitiated) this.options.onInitiated();
    }
    attachGlobalListeners() {
        this.onWindowKeyUpBind = this.#onWindowKeyUp.bind(this);
        this.onOLTBReadyBind = this.#onOLTBReady.bind(this);
        this.onWindowBrowserStateClearedBind = this.#onWindowBrowserStateCleared.bind(this);
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.keyUp, this.onWindowKeyUpBind);
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.ready, this.onOLTBReadyBind);
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.browserStateCleared, this.onWindowBrowserStateClearedBind);
    }
    detachGlobalListeners() {
        window.removeEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.keyUp, this.onWindowKeyUpBind);
        window.removeEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.ready, this.onOLTBReadyBind);
        window.removeEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.browserStateCleared, this.onWindowBrowserStateClearedBind);
    }
    //--------------------------------------------------------------------
    // # Section: Overridden
    //--------------------------------------------------------------------
    getName() {
        return super.getName();
    }
    onClickTool(event) {
        super.onClickTool(event);
        if (this.isActive) this.deactivateTool();
        else this.activateTool();
        // Note: 
        // @Consumer callback
        if (this.options.onClicked) this.options.onClicked();
    }
    //--------------------------------------------------------------------
    // # Section: Init Helpers
    //--------------------------------------------------------------------
    #initToolboxHTML() {
        const i18n = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get(`${$6097679d5ffd37cd$var$I18N__BASE}.toolbox`);
        const i18nCommon = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get(`${$6097679d5ffd37cd$var$I18N__BASE_COMMON}.titles`);
        const html = `
            <div id="${$6097679d5ffd37cd$var$ID__PREFIX}-toolbox" class="${$6097679d5ffd37cd$var$CLASS__TOOLBOX_SECTION}">
                <div class="${$6097679d5ffd37cd$var$CLASS__TOOLBOX_SECTION}__header oltb-toggleable" data-oltb-toggleable-target="${$6097679d5ffd37cd$var$ID__PREFIX}-toolbox-collapsed">
                    <h4 class="${$6097679d5ffd37cd$var$CLASS__TOOLBOX_SECTION}__title" data-oltb-i18n="${$6097679d5ffd37cd$var$I18N__BASE}.toolbox.titles.measure">${i18n.titles.measure}</h4>
                    <span class="${$6097679d5ffd37cd$var$CLASS__TOOLBOX_SECTION}__icon oltb-tippy" data-oltb-i18n="${$6097679d5ffd37cd$var$I18N__BASE_COMMON}.titles.toggleSection" title="${i18nCommon.toggleSection}"></span>
                </div>
                <div class="${$6097679d5ffd37cd$var$CLASS__TOOLBOX_SECTION}__groups" id="${$6097679d5ffd37cd$var$ID__PREFIX}-toolbox-collapsed" style="display: ${this.localStorage.isCollapsed ? 'none' : 'block'}">
                    <div class="${$6097679d5ffd37cd$var$CLASS__TOOLBOX_SECTION}__group">
                        <label class="oltb-label" for="${$6097679d5ffd37cd$var$ID__PREFIX}-type" data-oltb-i18n="${$6097679d5ffd37cd$var$I18N__BASE}.toolbox.groups.type.title">${i18n.groups.type.title}</label>
                        <select id="${$6097679d5ffd37cd$var$ID__PREFIX}-type" class="oltb-select">
                            <option value="LineString" data-oltb-i18n="${$6097679d5ffd37cd$var$I18N__BASE}.toolbox.groups.type.lineString">${i18n.groups.type.lineString}</option>
                            <option value="Polygon" data-oltb-i18n="${$6097679d5ffd37cd$var$I18N__BASE}.toolbox.groups.type.polygon">${i18n.groups.type.polygon}</option>
                        </select>
                    </div>
                    <div class="${$6097679d5ffd37cd$var$CLASS__TOOLBOX_SECTION}__group ${$6097679d5ffd37cd$var$CLASS__TOOLBOX_SECTION}__group--split-group">
                        <div class="${$6097679d5ffd37cd$var$CLASS__TOOLBOX_SECTION}__group-part">
                            <label class="oltb-label" for="${$6097679d5ffd37cd$var$ID__PREFIX}-stroke-color" data-oltb-i18n="${$6097679d5ffd37cd$var$I18N__BASE}.toolbox.groups.strokeColor.title">${i18n.groups.strokeColor.title}</label>
                            <div id="${$6097679d5ffd37cd$var$ID__PREFIX}-stroke-color" class="oltb-color-input oltb-color-tippy" data-oltb-color-target="#${$6097679d5ffd37cd$var$ID__PREFIX}-stroke-color" data-oltb-color="${this.localStorage.strokeColor}" tabindex="0">
                                <div class="oltb-color-input__inner" style="background-color: ${this.localStorage.strokeColor};"></div>
                            </div>
                        </div>
                        <div class="${$6097679d5ffd37cd$var$CLASS__TOOLBOX_SECTION}__group-part">
                            <label class="oltb-label" for="${$6097679d5ffd37cd$var$ID__PREFIX}-fill-color" data-oltb-i18n="${$6097679d5ffd37cd$var$I18N__BASE}.toolbox.groups.fillColor.title">${i18n.groups.fillColor.title}</label>
                            <div id="${$6097679d5ffd37cd$var$ID__PREFIX}-fill-color" class="oltb-color-input oltb-color-tippy" data-oltb-color-target="#${$6097679d5ffd37cd$var$ID__PREFIX}-fill-color" data-oltb-color="${this.localStorage.fillColor}" tabindex="0">
                                <div class="oltb-color-input__inner" style="background-color: ${this.localStorage.fillColor};"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        `;
        (0, $8f42450ebdd44f5e$export$8e7188a60a5bbe16).getToolboxElement().insertAdjacentHTML('beforeend', html);
    }
    #initToggleables() {
        this.uiRefToolboxSection.querySelectorAll(`.${$6097679d5ffd37cd$var$CLASS__TOGGLEABLE}`).forEach((toggle)=>{
            toggle.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.click, this.#onToggleToolbox.bind(this, toggle));
        });
    }
    #initDefaultValues() {
        this.uiRefToolType.value = this.localStorage.toolType;
    }
    //--------------------------------------------------------------------
    // # Section: Tool Control
    //--------------------------------------------------------------------
    activateTool() {
        this.isActive = true;
        this.uiRefToolboxSection.classList.add(`${$6097679d5ffd37cd$var$CLASS__TOOLBOX_SECTION}--show`);
        this.button.classList.add(`${$6097679d5ffd37cd$var$CLASS__TOOL_BUTTON}--active`);
        (0, $3110b1ed727d9f35$export$df4a79c26d3b48ff).setActiveTool(this);
        if (this.shouldAlwaysCreateNewLayer()) (0, $e75fe1c51a3d360c$export$eff87c52915dd7fe).addFeatureLayer({
            name: (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get(`${$6097679d5ffd37cd$var$I18N__BASE}.layers.defaultName`)
        });
        // Important:
        // Triggers activation of the tool
        (0, $96903e3f16465932$export$cc74486daaaef499).dispatchEvent([
            this.uiRefToolType
        ], (0, $a9807b370eed025c$export$ada873a34909da65).browser.change);
        this.localStorage.isActive = true;
        (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).setStateObject($6097679d5ffd37cd$var$LocalStorageNodeName, this.localStorage);
        this.uiRefToolboxSection.scrollIntoView({
            behavior: 'smooth',
            block: 'end',
            inline: 'nearest'
        });
    }
    deactivateTool() {
        const map = this.getMap();
        if (!map) return;
        this.isActive = false;
        this.uiRefToolboxSection.classList.remove(`${$6097679d5ffd37cd$var$CLASS__TOOLBOX_SECTION}--show`);
        this.button.classList.remove(`${$6097679d5ffd37cd$var$CLASS__TOOL_BUTTON}--active`);
        this.doRemoveDrawInteraction();
        (0, $3110b1ed727d9f35$export$df4a79c26d3b48ff).removeActiveTool();
        (0, $9829e24a28f9d958$export$786f0b7d4117ba87).removeSnap();
        this.localStorage.isActive = false;
        (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).setStateObject($6097679d5ffd37cd$var$LocalStorageNodeName, this.localStorage);
    }
    deselectTool() {
        this.deactivateTool();
    }
    updateTool() {
        // Note: 
        // Remember options until next time
        this.localStorage.toolType = this.uiRefToolType.value;
        this.localStorage.fillColor = this.uiRefFillColor.getAttribute('data-oltb-color');
        this.localStorage.strokeColor = this.uiRefStrokeColor.getAttribute('data-oltb-color');
        (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).setStateObject($6097679d5ffd37cd$var$LocalStorageNodeName, this.localStorage);
        this.doUpdateTool(this.uiRefToolType.value, this.uiRefFillColor.getAttribute('data-oltb-color'), this.uiRefStrokeColor.getAttribute('data-oltb-color'));
    }
    //--------------------------------------------------------------------
    // # Section: Browser Events
    //--------------------------------------------------------------------
    #onOLTBReady(event) {
        if (this.localStorage.isActive) this.activateTool();
    }
    #onWindowKeyUp(event) {
        const key = event.key;
        if (key === (0, $7cb32231c4f9783a$export$70f9e5bc10d7eac).valueEscape) {
            if (this.interactionDraw) this.interactionDraw.abortDrawing();
        } else if (event.ctrlKey && key === (0, $7cb32231c4f9783a$export$70f9e5bc10d7eac).valueZ) {
            if (this.interactionDraw) this.interactionDraw.removeLastPoint();
        } else if ((0, $fbd95439548fdf50$export$ad7bf7af8762113)(event, (0, $a256deadcc62504f$export$4384767a59dc851d).measureTool)) this.onClickTool(event);
    }
    #onWindowBrowserStateCleared() {
        this.doClearState();
        this.doClearColors();
        if (this.isActive) this.deactivateTool();
        // Note: 
        // @Consumer callback
        if (this.options.onBrowserStateCleared) this.options.onBrowserStateCleared();
    }
    //--------------------------------------------------------------------
    // # Section: Map/UI Callbacks
    //--------------------------------------------------------------------
    #onToggleToolbox(toggle) {
        const targetName = toggle.dataset.oltbToggleableTarget;
        this.doToggleToolboxSection(targetName);
    }
    #onDrawStart(event) {
        this.doDrawStart(event);
    }
    #onDrawEnd(event) {
        this.doDrawEnd(event);
    }
    #onDrawAbort(event) {
        this.doDrawAbort(event);
    }
    #onDrawError(event) {
        this.doDrawError(event);
    }
    // Note:
    // This is a global event that is invoked from the SnapManager
    onSnap(event) {
        this.doSnap(event);
    }
    onUnSnap(event) {
        this.doUnSnap(event);
    }
    //--------------------------------------------------------------------
    // # Section: Conversions/Validation
    //--------------------------------------------------------------------
    shouldAlwaysCreateNewLayer() {
        return (0, $5547bbb6fff7ebf1$export$3016a1f47b675883).getSetting((0, $65522956a1f1a049$export$c72f6eaae7b9adff).alwaysNewLayers);
    }
    //--------------------------------------------------------------------
    // # Section: Generator Helpers
    //--------------------------------------------------------------------
    #generateOLInteractionDraw(type) {
        return new (0, $55fa2487efb2d4e1$export$2e2bcd8739ae039)({
            type: type,
            stopClick: true,
            style: this.styles
        });
    }
    #generateOLStyleObject(fillColor, strokeColor) {
        return new (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)({
            image: new (0, $06150d8570b7481b$export$2e2bcd8739ae039)({
                fill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
                    color: fillColor
                }),
                stroke: new (0, $f9d0329c5c745263$export$2e2bcd8739ae039)({
                    color: strokeColor,
                    width: 2
                }),
                radius: 5
            }),
            fill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
                color: fillColor
            }),
            stroke: new (0, $f9d0329c5c745263$export$2e2bcd8739ae039)({
                color: strokeColor,
                lineDash: [
                    2,
                    5
                ],
                width: 2.5
            })
        });
    }
    //--------------------------------------------------------------------
    // # Section: Tool DoActions
    //--------------------------------------------------------------------
    doClearState() {
        this.localStorage = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep($6097679d5ffd37cd$var$LocalStorageDefaults);
        (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).setStateObject($6097679d5ffd37cd$var$LocalStorageNodeName, $6097679d5ffd37cd$var$LocalStorageDefaults);
    }
    doToggleToolboxSection(targetName) {
        const targetNode = window.document.getElementById(targetName);
        const duration = (0, $1e8c0ef90ed82280$export$a33e119b2316dcb7).getConfig().animationDuration.fast;
        targetNode?.slideToggle(duration, (collapsed)=>{
            this.localStorage.isCollapsed = collapsed;
            (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).setStateObject($6097679d5ffd37cd$var$LocalStorageNodeName, this.localStorage);
        });
    }
    doDrawStart(event) {
        const feature = event.feature;
        const tooltipItem = (0, $5289d96a2eaac637$export$3cf29e47efa41626).push($6097679d5ffd37cd$var$KEY__TOOLTIP);
        if (feature) this.onChangeListener = feature.getGeometry().on((0, $a9807b370eed025c$export$ada873a34909da65).openLayers.change, (event)=>{
            const measureValue = (0, $ef19f7475e8f20ad$export$c8fdb1ecc11e521e)(event.target);
            tooltipItem.innerHTML = `${measureValue.value} ${measureValue.unit}`;
        });
        // Note: 
        // @Consumer callback
        if (this.options.onStart) this.options.onStart(event);
    }
    doDrawEnd(event) {
        (0, $1f093ab5083c8a1f$export$b7ef3f8527533384)(this.onChangeListener);
        const feature = event.feature;
        if (feature) {
            (0, $5289d96a2eaac637$export$3cf29e47efa41626).pop($6097679d5ffd37cd$var$KEY__TOOLTIP);
            (0, $45f5d1a81c4ed6cb$export$73e78dff44a347ad).applyMeasurementProperties(feature);
            feature.setStyle(this.styles);
            const layerWrapper = (0, $e75fe1c51a3d360c$export$eff87c52915dd7fe).getActiveFeatureLayer({
                fallback: (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get(`${$6097679d5ffd37cd$var$I18N__BASE}.layers.defaultName`)
            });
            (0, $e75fe1c51a3d360c$export$eff87c52915dd7fe).addFeatureToLayer(feature, layerWrapper, `${$6097679d5ffd37cd$var$I18N__BASE}.toasts.infos.drawInHiddenLayer`);
        }
        // Note: 
        // @Consumer callback
        if (this.options.onEnd) this.options.onEnd(event);
    }
    doDrawAbort(event) {
        (0, $1f093ab5083c8a1f$export$b7ef3f8527533384)(this.onChangeListener);
        (0, $5289d96a2eaac637$export$3cf29e47efa41626).pop($6097679d5ffd37cd$var$KEY__TOOLTIP);
        // Note: 
        // @Consumer callback
        if (this.options.onAbort) this.options.onAbort(event);
    }
    doDrawError(event) {
        // Note: 
        // @Consumer callback
        if (this.options.onError) this.options.onError(event);
    }
    doSnap(event) {
        // Note: 
        // @Consumer callback
        if (this.options.onSnapped) this.options.onSnapped(event);
    }
    doUnSnap(event) {
        // Note: 
        // @Consumer callback
        if (this.options.onUnSnapped) this.options.onUnSnapped(event);
    }
    doClearColors() {
        this.uiRefFillColor.setAttribute('data-oltb-color', this.localStorage.fillColor);
        this.uiRefFillColor.firstElementChild.style.backgroundColor = this.localStorage.fillColor;
        this.uiRefStrokeColor.setAttribute('data-oltb-color', this.localStorage.strokeColor);
        this.uiRefStrokeColor.firstElementChild.style.backgroundColor = this.localStorage.strokeColor;
    }
    doUpdateTool(toolType, fillColor, strokeColor) {
        const map = this.getMap();
        if (!map) return;
        // Note: 
        // Remove previous interaction if tool is changed
        if (this.interactionDraw) {
            this.doRemoveDrawInteraction();
            (0, $9829e24a28f9d958$export$786f0b7d4117ba87).removeSnap();
        }
        this.styles = this.#generateOLStyleObject(fillColor, strokeColor);
        this.interactionDraw = this.#generateOLInteractionDraw(toolType);
        this.interactionDraw.on((0, $a9807b370eed025c$export$ada873a34909da65).openLayers.drawStart, this.#onDrawStart.bind(this));
        this.interactionDraw.on((0, $a9807b370eed025c$export$ada873a34909da65).openLayers.drawEnd, this.#onDrawEnd.bind(this));
        this.interactionDraw.on((0, $a9807b370eed025c$export$ada873a34909da65).openLayers.drawAbort, this.#onDrawAbort.bind(this));
        this.interactionDraw.on((0, $a9807b370eed025c$export$ada873a34909da65).openLayers.error, this.#onDrawError.bind(this));
        // Note: 
        // The Snap interaction must be added last
        this.doAddDrawInteraction();
        (0, $9829e24a28f9d958$export$786f0b7d4117ba87).addSnap(this);
    }
    doAddDrawInteraction() {
        this.getMap().addInteraction(this.interactionDraw);
    }
    doRemoveDrawInteraction() {
        this.getMap().removeInteraction(this.interactionDraw);
    }
}



var $f1q41 = parcelRequire("f1q41");














const $4c53a8ab81ec152a$var$FILENAME = 'magnify-tool.js';
const $4c53a8ab81ec152a$var$CLASS__TOOL_BUTTON = 'oltb-tool-button';
const $4c53a8ab81ec152a$var$I18N__BASE = 'tools.magnifyTool';
const $4c53a8ab81ec152a$var$DefaultOptions = Object.freeze({
    radius: 75,
    min: 25,
    max: 150,
    onInitiated: undefined,
    onClicked: undefined,
    onBrowserStateCleared: undefined
});
const $4c53a8ab81ec152a$var$LocalStorageNodeName = (0, $52e25f2a10ab5b5c$export$ada36e8a1c3bc83a).magnifyTool;
const $4c53a8ab81ec152a$var$LocalStorageDefaults = Object.freeze({
    isActive: false
});
/**
 * About:
 * Enlarge parts of the Map under the mouse
 * 
 * Description:
 * The magnifying glass allows you to enlarge parts of the map that are under the mouse. 
 * The image often becomes pixelated as it is bitmap images that are enlarged.
 */ class $4c53a8ab81ec152a$export$ea8566250e234470 extends (0, $10d08d54da4ecbc4$export$cf198134d112da63) {
    constructor(options = {}){
        super({
            filename: $4c53a8ab81ec152a$var$FILENAME
        });
        const icon = (0, $dcff5ab966a6537f$export$a297fe855adfd36c)({
            path: (0, $35649bc6579784f8$export$3fddabec91763a6e).search.stroked,
            class: `${$4c53a8ab81ec152a$var$CLASS__TOOL_BUTTON}__icon`
        });
        const i18n = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get($4c53a8ab81ec152a$var$I18N__BASE);
        const button = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'button',
            html: icon,
            class: $4c53a8ab81ec152a$var$CLASS__TOOL_BUTTON,
            attributes: {
                'type': 'button',
                'data-tippy-content': `${i18n.title} (${(0, $a256deadcc62504f$export$4384767a59dc851d).magnifyTool})`,
                'data-tippy-content-post': `(${(0, $a256deadcc62504f$export$4384767a59dc851d).magnifyTool})`,
                'data-oltb-i18n': `${$4c53a8ab81ec152a$var$I18N__BASE}.title`
            },
            listeners: {
                'click': this.onClickTool.bind(this)
            }
        });
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(this.element, [
            button
        ]);
        this.button = button;
        this.options = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep($4c53a8ab81ec152a$var$DefaultOptions), options);
        this.localStorage = (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).getAndMergeStateObject($4c53a8ab81ec152a$var$LocalStorageNodeName, $4c53a8ab81ec152a$var$LocalStorageDefaults);
        this.attachGlobalListeners();
        // Note: 
        // @Consumer callback
        if (this.options.onInitiated) this.options.onInitiated();
    }
    attachGlobalListeners() {
        this.onWindowKeyUpBind = this.#onWindowKeyUp.bind(this);
        this.onOLTBReadyBind = this.#onOLTBReady.bind(this);
        this.onWindowBrowserStateClearedBind = this.#onWindowBrowserStateCleared.bind(this);
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.keyUp, this.onWindowKeyUpBind);
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.ready, this.onOLTBReadyBind);
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.browserStateCleared, this.onWindowBrowserStateClearedBind);
    }
    detachGlobalListeners() {
        window.removeEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.keyUp, this.onWindowKeyUpBind);
        window.removeEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.ready, this.onOLTBReadyBind);
        window.removeEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.browserStateCleared, this.onWindowBrowserStateClearedBind);
    }
    //--------------------------------------------------------------------
    // # Section: Overridden
    //--------------------------------------------------------------------
    getName() {
        return super.getName();
    }
    onClickTool(event) {
        super.onClickTool(event);
        if (this.isActive) this.deactivateTool();
        else this.activateTool();
        // Note: 
        // @Consumer callback
        if (this.options.onClicked) this.options.onClicked();
    }
    //--------------------------------------------------------------------
    // # Section: Tool Control
    //--------------------------------------------------------------------
    activateTool() {
        this.attachMapListeners();
        this.isActive = true;
        this.button.classList.add(`${$4c53a8ab81ec152a$var$CLASS__TOOL_BUTTON}--active`);
        this.localStorage.isActive = true;
        (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).setStateObject($4c53a8ab81ec152a$var$LocalStorageNodeName, this.localStorage);
    }
    deactivateTool() {
        this.detachMapListeners();
        this.isActive = false;
        this.button.classList.remove(`${$4c53a8ab81ec152a$var$CLASS__TOOL_BUTTON}--active`);
        this.localStorage.isActive = false;
        (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).setStateObject($4c53a8ab81ec152a$var$LocalStorageNodeName, this.localStorage);
    }
    //--------------------------------------------------------------------
    // # Section: Browser Events
    //--------------------------------------------------------------------
    #onOLTBReady(event) {
        if (this.localStorage.isActive) this.activateTool();
    }
    #onWindowKeyUp(event) {
        if ((0, $fbd95439548fdf50$export$ad7bf7af8762113)(event, (0, $a256deadcc62504f$export$4384767a59dc851d).magnifyTool)) this.onClickTool(event);
    }
    #onKeydown(event) {
        // Note:
        // Disable map-zoom when changing size of magnifier
        event.preventDefault();
        const key = event.key;
        const map = this.getMap();
        if (!map) return;
        this.doChangeMagnifyerSize(key);
        map.render();
    }
    #onWindowBrowserStateCleared() {
        this.doClearState();
        if (this.isActive) this.deactivateTool();
        // Note: 
        // @Consumer callback
        if (this.options.onBrowserStateCleared) this.options.onBrowserStateCleared();
    }
    //--------------------------------------------------------------------
    // # Section: Map/UI Callbacks
    //--------------------------------------------------------------------
    #onMousemove(event) {
        const map = this.getMap();
        if (!map) return;
        this.mousePosition = map.getEventPixel(event);
        map.render();
    }
    #onMouseout(event) {
        const map = this.getMap();
        if (!map) return;
        this.mousePosition = undefined;
        map.render();
    }
    #onPostrender(event) {
        if (!this.mousePosition) return;
        this.doPostRender(event);
    }
    //--------------------------------------------------------------------
    // # Section: Listeners Subscriptions
    //--------------------------------------------------------------------
    attachMapListeners() {
        const map = this.getMap();
        if (!map) return;
        const mapContainer = map.getTarget();
        this.onMousemoveListenert = this.#onMousemove.bind(this);
        this.onMouseoutListenert = this.#onMouseout.bind(this);
        this.onKeydownListener = this.#onKeydown.bind(this);
        mapContainer.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.mouseMove, this.onMousemoveListenert);
        mapContainer.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.mouseOut, this.onMouseoutListenert);
        window.document.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.keyDown, this.onKeydownListener);
        this.onPostrenderListeners = [];
        map.getLayers().getArray().forEach((layer)=>{
            this.onPostrenderListeners.push(layer.on((0, $a9807b370eed025c$export$ada873a34909da65).openLayers.postRender, this.#onPostrender.bind(this)));
        });
    }
    detachMapListeners() {
        const map = this.getMap();
        if (!map) return;
        const mapContainer = map.getTarget();
        mapContainer.removeEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.mouseMove, this.onMousemoveListenert);
        mapContainer.removeEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.mouseOut, this.onMouseoutListenert);
        window.document.removeEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.keyDown, this.onKeydownListener);
        this.onPostrenderListeners.forEach((listener)=>{
            (0, $1f093ab5083c8a1f$export$b7ef3f8527533384)(listener);
        });
        // Note: 
        // Render to remove the magnifier
        map.render();
    }
    //--------------------------------------------------------------------
    // # Section: Tool DoActions
    //--------------------------------------------------------------------
    doChangeMagnifyerSize(key) {
        const distance = 5;
        if (key === (0, $7cb32231c4f9783a$export$70f9e5bc10d7eac).valueAdd) this.options.radius = Math.min(this.options.radius + distance, this.options.max);
        else if (key === (0, $7cb32231c4f9783a$export$70f9e5bc10d7eac).valueSubtract) this.options.radius = Math.max(this.options.radius - distance, this.options.min);
    }
    doClearState() {
        this.localStorage = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep($4c53a8ab81ec152a$var$LocalStorageDefaults);
        (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).setStateObject($4c53a8ab81ec152a$var$LocalStorageNodeName, $4c53a8ab81ec152a$var$LocalStorageDefaults);
    }
    doPostRender(event) {
        const mousePosition = this.mousePosition;
        const radius = this.options.radius;
        const pixel = (0, $806302f479c89a9b$export$5d5f40b190bc29f0)(event, mousePosition);
        const offset = (0, $806302f479c89a9b$export$5d5f40b190bc29f0)(event, [
            mousePosition[0] + radius,
            mousePosition[1]
        ]);
        const half = Math.sqrt(Math.pow(offset[0] - pixel[0], 2) + Math.pow(offset[1] - pixel[1], 2));
        const context = event.context;
        const centerX = pixel[0];
        const centerY = pixel[1];
        const originX = centerX - half;
        const originY = centerY - half;
        const size = Math.round(2 * half + 1);
        try {
            const sourceData = context.getImageData(originX, originY, size, size).data;
            const dest = context.createImageData(size, size);
            const destData = dest.data;
            for(let j = 0; j < size; ++j)for(let i = 0; i < size; ++i){
                const dI = i - half;
                const dJ = j - half;
                const dist = Math.sqrt(dI * dI + dJ * dJ);
                let sourceI = i;
                let sourceJ = j;
                if (dist < half) {
                    sourceI = Math.round(half + dI / 2);
                    sourceJ = Math.round(half + dJ / 2);
                }
                const destOffset = (j * size + i) * 4;
                const sourceOffset = (sourceJ * size + sourceI) * 4;
                destData[destOffset] = sourceData[sourceOffset];
                destData[destOffset + 1] = sourceData[sourceOffset + 1];
                destData[destOffset + 2] = sourceData[sourceOffset + 2];
                destData[destOffset + 3] = sourceData[sourceOffset + 3];
            }
            context.beginPath();
            context.arc(centerX, centerY, half, 0, 2 * Math.PI);
            context.lineWidth = 3 * half / radius;
            context.strokeStyle = '#3b4352FF';
            context.putImageData(dest, originX, originY);
            context.stroke();
            context.restore();
        } catch (error) {
            this.deactivateTool();
            (0, $b9b5c0363f244088$export$49b118289be48034).logError($4c53a8ab81ec152a$var$FILENAME, 'onPostrender', {
                message: 'Unexpected error using magnifyer',
                error: error
            });
            (0, $9051f0e072bf4341$export$8d8dc7d5f743331b).error({
                i18nKey: `${$4c53a8ab81ec152a$var$I18N__BASE}.toasts.errors.renderCanvas`
            });
        }
    }
}



var $f1q41 = parcelRequire("f1q41");









const $6f3bdb1dde171a4c$var$FILENAME = 'zoom-out-tool.js';
const $6f3bdb1dde171a4c$var$CLASS__TOOL_BUTTON = 'oltb-tool-button';
const $6f3bdb1dde171a4c$var$I18N__BASE = 'tools.zoomOutTool';
const $6f3bdb1dde171a4c$var$DefaultOptions = Object.freeze({
    delta: -1,
    onInitiated: undefined,
    onClicked: undefined,
    onZoomed: undefined
});
/**
 * About:
 * Zoom out of the Map
 * 
 * Description:
 * Reduce zooming and get a more comprehensive view of the surroundings in the Map.
 */ class $6f3bdb1dde171a4c$export$22efc6033f101985 extends (0, $10d08d54da4ecbc4$export$cf198134d112da63) {
    constructor(options = {}){
        super({
            filename: $6f3bdb1dde171a4c$var$FILENAME
        });
        const icon = (0, $dcff5ab966a6537f$export$a297fe855adfd36c)({
            path: (0, $35649bc6579784f8$export$3fddabec91763a6e).zoomOut.stroked,
            class: `${$6f3bdb1dde171a4c$var$CLASS__TOOL_BUTTON}__icon`
        });
        const i18n = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get($6f3bdb1dde171a4c$var$I18N__BASE);
        const button = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'button',
            html: icon,
            class: $6f3bdb1dde171a4c$var$CLASS__TOOL_BUTTON,
            attributes: {
                'type': 'button',
                'data-tippy-content': `${i18n.title} (${(0, $a256deadcc62504f$export$4384767a59dc851d).zoomOutTool})`,
                'data-tippy-content-post': `(${(0, $a256deadcc62504f$export$4384767a59dc851d).zoomOutTool})`,
                'data-oltb-i18n': `${$6f3bdb1dde171a4c$var$I18N__BASE}.title`
            },
            listeners: {
                'click': this.onClickTool.bind(this)
            }
        });
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(this.element, [
            button
        ]);
        this.button = button;
        this.options = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep($6f3bdb1dde171a4c$var$DefaultOptions), options);
        this.attachGlobalListeners();
        // Note: 
        // @Consumer callback
        if (this.options.onInitiated) this.options.onInitiated();
    }
    attachGlobalListeners() {
        this.onWindowKeyUpBind = this.#onWindowKeyUp.bind(this);
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.keyUp, this.onWindowKeyUpBind);
    }
    detachGlobalListeners() {
        window.removeEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.keyUp, this.onWindowKeyUpBind);
    }
    //--------------------------------------------------------------------
    // # Section: Overridden
    //--------------------------------------------------------------------
    getName() {
        return super.getName();
    }
    onClickTool(event) {
        super.onClickTool(event);
        this.momentaryActivation();
        // Note: 
        // @Consumer callback
        if (this.options.onClicked) this.options.onClicked();
    }
    //--------------------------------------------------------------------
    // # Section: Tool Control
    //--------------------------------------------------------------------
    momentaryActivation() {
        const map = this.getMap();
        if (!map) return;
        this.doZoomOut(map);
    }
    //--------------------------------------------------------------------
    // # Section: Browser Events
    //--------------------------------------------------------------------
    #onWindowKeyUp(event) {
        if ((0, $fbd95439548fdf50$export$ad7bf7af8762113)(event, (0, $a256deadcc62504f$export$4384767a59dc851d).zoomOutTool)) this.onClickTool(event);
    }
    //--------------------------------------------------------------------
    // # Section: Tool DoActions
    //--------------------------------------------------------------------
    doZoomOut(map) {
        const view = map.getView();
        const coordinates = (0, $9c4744460e43e41b$export$3fb495868742d370)(view.getCenter());
        const currentZoom = view.getZoom();
        const calculatedZoom = view.getConstrainedZoom(currentZoom + this.options.delta);
        (0, $eb687437705d7055$export$cc43ef3ca2ae36e8)({
            map: map,
            coordinates: coordinates,
            zoom: calculatedZoom,
            onDone: (result)=>{
                // Note: 
                // @Consumer callback
                if (this.options.onZoomed) this.options.onZoomed(result);
            }
        });
    }
}



var $f1q41 = parcelRequire("f1q41");







const $6641dd59bdf059c4$var$FILENAME = 'refresh-tool.js';
const $6641dd59bdf059c4$var$CLASS__TOOL_BUTTON = 'oltb-tool-button';
const $6641dd59bdf059c4$var$I18N__BASE = 'tools.refreshTool';
const $6641dd59bdf059c4$var$DefaultOptions = Object.freeze({
    onInitiated: undefined,
    onClicked: undefined
});
/**
 * About:
 * Reload the application
 * 
 * Description:
 * The entire browser window will reload.
 */ class $6641dd59bdf059c4$export$fbf3f3c99f167d31 extends (0, $10d08d54da4ecbc4$export$cf198134d112da63) {
    constructor(options = {}){
        super({
            filename: $6641dd59bdf059c4$var$FILENAME
        });
        const icon = (0, $dcff5ab966a6537f$export$a297fe855adfd36c)({
            path: (0, $35649bc6579784f8$export$3fddabec91763a6e).arrowClockwise.stroked,
            class: `${$6641dd59bdf059c4$var$CLASS__TOOL_BUTTON}__icon`
        });
        const i18n = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get($6641dd59bdf059c4$var$I18N__BASE);
        const button = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'button',
            html: icon,
            class: $6641dd59bdf059c4$var$CLASS__TOOL_BUTTON,
            attributes: {
                'type': 'button',
                'data-tippy-content': `${i18n.title} (${(0, $a256deadcc62504f$export$4384767a59dc851d).refreshPageTool})`,
                'data-tippy-content-post': `(${(0, $a256deadcc62504f$export$4384767a59dc851d).refreshPageTool})`,
                'data-oltb-i18n': `${$6641dd59bdf059c4$var$I18N__BASE}.title`
            },
            listeners: {
                'click': this.onClickTool.bind(this)
            }
        });
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(this.element, [
            button
        ]);
        this.button = button;
        this.options = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep($6641dd59bdf059c4$var$DefaultOptions), options);
        this.attachGlobalListeners();
        // Note: 
        // @Consumer callback
        if (this.options.onInitiated) this.options.onInitiated();
    }
    attachGlobalListeners() {
        this.onWindowKeyUpBind = this.#onWindowKeyUp.bind(this);
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.keyUp, this.onWindowKeyUpBind);
    }
    detachGlobalListeners() {
        window.removeEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.keyUp, this.onWindowKeyUpBind);
    }
    //--------------------------------------------------------------------
    // # Section: Overridden
    //--------------------------------------------------------------------
    getName() {
        return super.getName();
    }
    onClickTool(event) {
        super.onClickTool(event);
        this.momentaryActivation();
        // Note: 
        // @Consumer callback
        if (this.options.onClicked) this.options.onClicked();
    }
    //--------------------------------------------------------------------
    // # Section: Tool Control
    //--------------------------------------------------------------------
    momentaryActivation() {
        this.doWindowReload();
    }
    //--------------------------------------------------------------------
    // # Section: Browser Events
    //--------------------------------------------------------------------
    #onWindowKeyUp(event) {
        if ((0, $fbd95439548fdf50$export$ad7bf7af8762113)(event, (0, $a256deadcc62504f$export$4384767a59dc851d).refreshPageTool)) this.onClickTool(event);
    }
    //--------------------------------------------------------------------
    // # Section: Tool DoActions
    //--------------------------------------------------------------------
    doWindowReload() {
        window.location.reload();
    }
}



var $f1q41 = parcelRequire("f1q41");















const $80358e12c7bd59d1$var$FILENAME = 'zoombox-tool.js';
const $80358e12c7bd59d1$var$CLASS__TOOL_BUTTON = 'oltb-tool-button';
const $80358e12c7bd59d1$var$KEY__TOOLTIP = 'tools.zoomboxTool';
const $80358e12c7bd59d1$var$I18N__BASE = 'tools.zoomboxTool';
const $80358e12c7bd59d1$var$OL__INTERNAL_OUT = 'out_';
const $80358e12c7bd59d1$var$DefaultOptions = Object.freeze({
    onInitiated: undefined,
    onClicked: undefined,
    onBrowserStateCleared: undefined,
    onStart: undefined,
    onEnd: undefined,
    onDrag: undefined,
    onCancel: undefined,
    onError: undefined
});
const $80358e12c7bd59d1$var$LocalStorageNodeName = (0, $52e25f2a10ab5b5c$export$ada36e8a1c3bc83a).zoomboxTool;
const $80358e12c7bd59d1$var$LocalStorageDefaults = Object.freeze({
    isActive: false
});
/**
 * About:
 * Zoom using dragging a bounding box
 * 
 * Description:
 * Increase or reduce zoom by dragging a bounding box selection. Hold down Ctrl to zoom out.
 * Note that this tools functionality is also available by pressing Shift + Drag without having the tool active.
 */ class $80358e12c7bd59d1$export$f58d84789496517c extends (0, $10d08d54da4ecbc4$export$cf198134d112da63) {
    constructor(options = {}){
        super({
            filename: $80358e12c7bd59d1$var$FILENAME
        });
        const icon = (0, $dcff5ab966a6537f$export$a297fe855adfd36c)({
            path: (0, $35649bc6579784f8$export$3fddabec91763a6e).boundingBoxCircles.stroked,
            class: `${$80358e12c7bd59d1$var$CLASS__TOOL_BUTTON}__icon`
        });
        const i18n = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get($80358e12c7bd59d1$var$I18N__BASE);
        const button = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'button',
            html: icon,
            class: $80358e12c7bd59d1$var$CLASS__TOOL_BUTTON,
            attributes: {
                'type': 'button',
                'data-tippy-content': `${i18n.title} (${(0, $a256deadcc62504f$export$4384767a59dc851d).zoomboxTool})`,
                'data-tippy-content-post': `(${(0, $a256deadcc62504f$export$4384767a59dc851d).zoomboxTool})`,
                'data-oltb-i18n': `${$80358e12c7bd59d1$var$I18N__BASE}.title`
            },
            listeners: {
                'click': this.onClickTool.bind(this)
            }
        });
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(this.element, [
            button
        ]);
        this.button = button;
        this.isActive = false;
        this.isSpaceKeyPressed = false;
        this.tooltip = undefined;
        this.options = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep($80358e12c7bd59d1$var$DefaultOptions), options);
        this.localStorage = (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).getAndMergeStateObject($80358e12c7bd59d1$var$LocalStorageNodeName, $80358e12c7bd59d1$var$LocalStorageDefaults);
        this.interactionDragZoom = this.#generateOLInteractionDragZoom();
        this.interactionDragZoom.on((0, $a9807b370eed025c$export$ada873a34909da65).openLayers.boxStart, this.#onBoxDragStart.bind(this));
        this.interactionDragZoom.on((0, $a9807b370eed025c$export$ada873a34909da65).openLayers.boxEnd, this.#onBoxDragEnd.bind(this));
        this.interactionDragZoom.on((0, $a9807b370eed025c$export$ada873a34909da65).openLayers.boxDrag, this.#onBoxDragDrag.bind(this));
        this.interactionDragZoom.on((0, $a9807b370eed025c$export$ada873a34909da65).openLayers.boxCancel, this.#onBoxDragCancel.bind(this));
        this.interactionDragZoom.on((0, $a9807b370eed025c$export$ada873a34909da65).openLayers.error, this.#onBoxDragError.bind(this));
        this.attachGlobalListeners();
        // Note: 
        // @Consumer callback
        if (this.options.onInitiated) this.options.onInitiated();
    }
    attachGlobalListeners() {
        this.onWindowKeyUpBind = this.#onWindowKeyUp.bind(this);
        this.onWindowKeyDownBind = this.#onWindowKeyDown.bind(this);
        this.onOLTBReadyBind = this.#onOLTBReady.bind(this);
        this.onWindowBrowserStateClearedBind = this.#onWindowBrowserStateCleared.bind(this);
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.keyUp, this.onWindowKeyUpBind);
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.keyDown, this.onWindowKeyDownBind);
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.ready, this.onOLTBReadyBind);
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.browserStateCleared, this.onWindowBrowserStateClearedBind);
    }
    detachGlobalListeners() {
        window.removeEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.keyUp, this.onWindowKeyUpBind);
        window.removeEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.keyDown, this.onWindowKeyDownBind);
        window.removeEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.ready, this.onOLTBReadyBind);
        window.removeEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.browserStateCleared, this.onWindowBrowserStateClearedBind);
    }
    //--------------------------------------------------------------------
    // # Section: Overridden
    //--------------------------------------------------------------------
    getName() {
        return super.getName();
    }
    onClickTool(event) {
        super.onClickTool(event);
        if (this.isActive) this.deactivateTool();
        else this.activateTool();
        // Note: 
        // @Consumer callback
        if (this.options.onClicked) this.options.onClicked();
    }
    //--------------------------------------------------------------------
    // # Section: Tool Control
    //--------------------------------------------------------------------
    activateTool() {
        const map = this.getMap();
        if (!map) return;
        (0, $3110b1ed727d9f35$export$df4a79c26d3b48ff).setActiveTool(this);
        this.doAddDragZoom();
        this.doAddTooltip();
        this.isActive = true;
        this.button.classList.add(`${$80358e12c7bd59d1$var$CLASS__TOOL_BUTTON}--active`);
        this.localStorage.isActive = true;
        (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).setStateObject($80358e12c7bd59d1$var$LocalStorageNodeName, this.localStorage);
    }
    deactivateTool() {
        const map = this.getMap();
        if (!map) return;
        (0, $3110b1ed727d9f35$export$df4a79c26d3b48ff).removeActiveTool();
        this.doRemoveDragZoom();
        this.doRemoveTooltip();
        this.isActive = false;
        this.button.classList.remove(`${$80358e12c7bd59d1$var$CLASS__TOOL_BUTTON}--active`);
        this.localStorage.isActive = false;
        (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).setStateObject($80358e12c7bd59d1$var$LocalStorageNodeName, this.localStorage);
    }
    deselectTool() {
        this.deactivateTool();
    }
    //--------------------------------------------------------------------
    // # Section: Browser Events
    //--------------------------------------------------------------------
    #onOLTBReady(event) {
        if (this.localStorage.isActive) this.activateTool();
    }
    #onWindowKeyUp(event) {
        this.isSpaceKeyPressed = false;
        // Note: 
        // Setting the internal OL variable
        // Option 1: Re-create the interaction to set the inverted out value
        // Option 2: Have two interactions that are swapped with one beeing active at the time
        this.interactionDragZoom[$80358e12c7bd59d1$var$OL__INTERNAL_OUT] = false;
        if ((0, $fbd95439548fdf50$export$ad7bf7af8762113)(event, (0, $a256deadcc62504f$export$4384767a59dc851d).zoomboxTool)) this.onClickTool(event);
    }
    #onWindowKeyDown(event) {
        const key = event.key;
        if (key === (0, $7cb32231c4f9783a$export$70f9e5bc10d7eac).valueSpace) this.isSpaceKeyPressed = true;
        // Note: 
        // Setting the internal OL variable
        // Option 1: Re-create the interaction to set the inverted out value
        // Option 2: Have two interactions that are swapped with one beeing active at the time
        if (event.ctrlKey) this.interactionDragZoom[$80358e12c7bd59d1$var$OL__INTERNAL_OUT] = true;
    }
    #onWindowBrowserStateCleared() {
        this.doClearState();
        if (this.isActive) this.deactivateTool();
        // Note: 
        // @Consumer callback
        if (this.options.onBrowserStateCleared) this.options.onBrowserStateCleared();
    }
    //--------------------------------------------------------------------
    // # Section: Map/UI Callbacks
    //--------------------------------------------------------------------
    #onBoxDragStart(event) {
        this.doBoxDragStart(event);
    }
    #onBoxDragEnd(event) {
        this.doBoxDragEnd(event);
    }
    #onBoxDragDrag(event) {
        this.doBoxDragDrag(event);
    }
    #onBoxDragCancel(event) {
        this.doBoxDragCancel(event);
    }
    #onBoxDragError(event) {
        this.doBoxDragError(event);
    }
    //--------------------------------------------------------------------
    // # Section: Generator Helpers
    //--------------------------------------------------------------------
    #generateOLInteractionDragZoom() {
        const duration = (0, $1e8c0ef90ed82280$export$a33e119b2316dcb7).getConfig().animationDuration.normal;
        return new (0, $afc7f51010a5b660$export$2e2bcd8739ae039)({
            duration: duration,
            condition: (event)=>{
                return (0, $edf87b50170125f7$export$64ef1bee2b9504c1) && !this.isSpaceKeyPressed;
            },
            out: false
        });
    }
    //--------------------------------------------------------------------
    // # Section: Tool DoActions
    //--------------------------------------------------------------------
    doClearState() {
        this.localStorage = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep($80358e12c7bd59d1$var$LocalStorageDefaults);
        (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).setStateObject($80358e12c7bd59d1$var$LocalStorageNodeName, $80358e12c7bd59d1$var$LocalStorageDefaults);
    }
    doBoxDragStart(event) {
        // Note: 
        // @Consumer callback
        if (this.options.onStart) this.options.onStart(event);
    }
    doBoxDragEnd(event) {
        // Note: 
        // @Consumer callback
        if (this.options.onEnd) this.options.onEnd(event);
    }
    doBoxDragDrag(event) {
        // Note: 
        // @Consumer callback
        if (this.options.onDrag) this.options.onDrag(event);
    }
    doBoxDragCancel(event) {
        // Note: 
        // @Consumer callback
        if (this.options.onCancel) this.options.onCancel(event);
    }
    doBoxDragError(event) {
        // Note: 
        // @Consumer callback
        if (this.options.onError) this.options.onError(event);
    }
    doAddDragZoom() {
        this.getMap().addInteraction(this.interactionDragZoom);
    }
    doRemoveDragZoom() {
        this.getMap().removeInteraction(this.interactionDragZoom);
    }
    doAddTooltip() {
        const i18n = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get(`${$80358e12c7bd59d1$var$I18N__BASE}.tooltips`);
        this.tooltip = (0, $5289d96a2eaac637$export$3cf29e47efa41626).push($80358e12c7bd59d1$var$KEY__TOOLTIP);
        this.tooltip.innerHTML = i18n.dragToZoom;
    }
    doRemoveTooltip() {
        (0, $5289d96a2eaac637$export$3cf29e47efa41626).pop($80358e12c7bd59d1$var$KEY__TOOLTIP);
        this.tooltip = undefined;
    }
}



var $f1q41 = parcelRequire("f1q41");










const $16d88fca5cfe660f$var$FILENAME = 'toolbox-tool.js';
const $16d88fca5cfe660f$var$CLASS__TOOL_BUTTON = 'oltb-tool-button';
const $16d88fca5cfe660f$var$CLASS__TOOLBOX_HIDDEN = 'oltb-toolbox-container--hidden';
const $16d88fca5cfe660f$var$I18N__BASE = 'tools.toolboxTool';
const $16d88fca5cfe660f$var$DefaultOptions = Object.freeze({
    onInitiated: undefined,
    onClicked: undefined,
    onBrowserStateCleared: undefined,
    onChanged: undefined
});
const $16d88fca5cfe660f$var$LocalStorageNodeName = (0, $52e25f2a10ab5b5c$export$ada36e8a1c3bc83a).toolboxTool;
const $16d88fca5cfe660f$var$LocalStorageDefaults = Object.freeze({
    isActive: false
});
/**
 * About:
 * Collapse/Hide the Toolbox-container
 * 
 * Description:
 * Via this tool the Toolbox can be swiped of-canvas with a small animation.
 */ class $16d88fca5cfe660f$export$1a5db0ee78d96ac4 extends (0, $10d08d54da4ecbc4$export$cf198134d112da63) {
    constructor(options = {}){
        super({
            filename: $16d88fca5cfe660f$var$FILENAME
        });
        const icon = (0, $dcff5ab966a6537f$export$a297fe855adfd36c)({
            path: (0, $35649bc6579784f8$export$3fddabec91763a6e).layoutSsidebarInsetReverse.mixed,
            class: `${$16d88fca5cfe660f$var$CLASS__TOOL_BUTTON}__icon`
        });
        const i18n = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get($16d88fca5cfe660f$var$I18N__BASE);
        const button = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'button',
            html: icon,
            class: $16d88fca5cfe660f$var$CLASS__TOOL_BUTTON,
            attributes: {
                'type': 'button',
                'data-tippy-content': `${i18n.title} (${(0, $a256deadcc62504f$export$4384767a59dc851d).toolboxTool})`,
                'data-tippy-content-post': `(${(0, $a256deadcc62504f$export$4384767a59dc851d).toolboxTool})`,
                'data-oltb-i18n': `${$16d88fca5cfe660f$var$I18N__BASE}.title`
            },
            listeners: {
                'click': this.onClickTool.bind(this)
            },
            prototypes: {
                getTippy: function() {
                    return this._tippy;
                }
            }
        });
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(this.element, [
            button
        ]);
        this.button = button;
        this.isActive = false;
        this.options = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep($16d88fca5cfe660f$var$DefaultOptions), options);
        this.localStorage = (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).getAndMergeStateObject($16d88fca5cfe660f$var$LocalStorageNodeName, $16d88fca5cfe660f$var$LocalStorageDefaults);
        this.attachGlobalListeners();
        // Note: 
        // @Consumer callback
        if (this.options.onInitiated) this.options.onInitiated();
    }
    attachGlobalListeners() {
        this.onWindowKeyUpBind = this.#onWindowKeyUp.bind(this);
        this.onOLTBReadyBind = this.#onOLTBReady.bind(this);
        this.onWindowBrowserStateClearedBind = this.#onWindowBrowserStateCleared.bind(this);
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.keyUp, this.onWindowKeyUpBind);
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.ready, this.onOLTBReadyBind);
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.browserStateCleared, this.onWindowBrowserStateClearedBind);
    }
    detachGlobalListeners() {
        window.removeEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.keyUp, this.onWindowKeyUpBind);
        window.removeEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.ready, this.onOLTBReadyBind);
        window.removeEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.browserStateCleared, this.onWindowBrowserStateClearedBind);
    }
    //--------------------------------------------------------------------
    // # Section: Overridden
    //--------------------------------------------------------------------
    getName() {
        return super.getName();
    }
    onClickTool(event) {
        super.onClickTool(event);
        if (this.isActive) this.deactivateTool();
        else this.activateTool();
        // Note: 
        // @Consumer callback
        if (this.options.onClicked) this.options.onClicked();
    }
    //--------------------------------------------------------------------
    // # Section: Tool Control
    //--------------------------------------------------------------------
    activateTool() {
        this.doHideToolbox();
        this.isActive = true;
        this.button.classList.add(`${$16d88fca5cfe660f$var$CLASS__TOOL_BUTTON}--active`);
        this.localStorage.isActive = true;
        (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).setStateObject($16d88fca5cfe660f$var$LocalStorageNodeName, this.localStorage);
    }
    deactivateTool() {
        this.doShowToolbox();
        this.isActive = false;
        this.button.classList.remove(`${$16d88fca5cfe660f$var$CLASS__TOOL_BUTTON}--active`);
        this.localStorage.isActive = false;
        (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).setStateObject($16d88fca5cfe660f$var$LocalStorageNodeName, this.localStorage);
    }
    //--------------------------------------------------------------------
    // # Section: Browser Events
    //--------------------------------------------------------------------
    #onOLTBReady(event) {
        if (this.localStorage.isActive) this.activateTool();
    }
    #onWindowKeyUp(event) {
        if ((0, $fbd95439548fdf50$export$ad7bf7af8762113)(event, (0, $a256deadcc62504f$export$4384767a59dc851d).toolboxTool)) this.onClickTool(event);
    }
    #onWindowBrowserStateCleared() {
        this.doShowToolbox();
        this.doClearState();
        if (this.isActive) this.deactivateTool();
        // Note: 
        // @Consumer callback
        if (this.options.onBrowserStateCleared) this.options.onBrowserStateCleared();
    }
    //--------------------------------------------------------------------
    // # Section: Tool DoActions
    //--------------------------------------------------------------------
    doClearState() {
        this.localStorage = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep($16d88fca5cfe660f$var$LocalStorageDefaults);
        (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).setStateObject($16d88fca5cfe660f$var$LocalStorageNodeName, $16d88fca5cfe660f$var$LocalStorageDefaults);
    }
    doShowToolbox() {
        const uiRefToolboxElement = (0, $8f42450ebdd44f5e$export$8e7188a60a5bbe16).getToolboxElement();
        uiRefToolboxElement.classList.remove($16d88fca5cfe660f$var$CLASS__TOOLBOX_HIDDEN);
        // Note: 
        // @Consumer callback
        if (this.options.onChanged) this.options.onChanged('visible');
    }
    doHideToolbox() {
        const uiRefToolboxElement = (0, $8f42450ebdd44f5e$export$8e7188a60a5bbe16).getToolboxElement();
        uiRefToolboxElement.classList.add($16d88fca5cfe660f$var$CLASS__TOOLBOX_HIDDEN);
        // Note: 
        // @Consumer callback
        if (this.options.onChanged) this.options.onChanged('hidden');
    }
}



var $f1q41 = parcelRequire("f1q41");























const $f5908b407f28646c$var$FILENAME = 'scissors-tool.js';
const $f5908b407f28646c$var$CLASS__TOOL_BUTTON = 'oltb-tool-button';
const $f5908b407f28646c$var$I18N__BASE = 'tools.scissorsTool';
const $f5908b407f28646c$var$DefaultOptions = Object.freeze({
    strokeWidth: '2.5',
    strokeColor: '#0166A5FF',
    fillColor: '#D7E3FA80',
    onInitiated: undefined,
    onClicked: undefined,
    onBrowserStateCleared: undefined,
    onStart: undefined,
    onEnd: undefined,
    onAbort: undefined,
    onError: undefined,
    onSnapped: undefined,
    onUnSnapped: undefined
});
const $f5908b407f28646c$var$LocalStorageNodeName = (0, $52e25f2a10ab5b5c$export$ada36e8a1c3bc83a).scissorsTool;
const $f5908b407f28646c$var$LocalStorageDefaults = Object.freeze({
    isActive: false
});
/**
 * About:
 * Cut polygon shapes in smaller parts
 * 
 * Description:
 * Draw a line to cut polygon shapes in half.
 */ class $f5908b407f28646c$export$3b3d473fba97a2cb extends (0, $10d08d54da4ecbc4$export$cf198134d112da63) {
    constructor(options = {}){
        super({
            filename: $f5908b407f28646c$var$FILENAME
        });
        const icon = (0, $dcff5ab966a6537f$export$a297fe855adfd36c)({
            path: (0, $35649bc6579784f8$export$3fddabec91763a6e).scissors.filled,
            class: `${$f5908b407f28646c$var$CLASS__TOOL_BUTTON}__icon`
        });
        const i18n = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get($f5908b407f28646c$var$I18N__BASE);
        const button = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'button',
            html: icon,
            class: $f5908b407f28646c$var$CLASS__TOOL_BUTTON,
            attributes: {
                'type': 'button',
                'data-tippy-content': `${i18n.title} (${(0, $a256deadcc62504f$export$4384767a59dc851d).scissorsTool})`,
                'data-tippy-content-post': `(${(0, $a256deadcc62504f$export$4384767a59dc851d).scissorsTool})`,
                'data-oltb-i18n': `${$f5908b407f28646c$var$I18N__BASE}.title`
            },
            listeners: {
                'click': this.onClickTool.bind(this)
            }
        });
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(this.element, [
            button
        ]);
        this.button = button;
        this.isActive = false;
        this.intersectedFeatures = [];
        this.options = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep($f5908b407f28646c$var$DefaultOptions), options);
        this.localStorage = (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).getAndMergeStateObject($f5908b407f28646c$var$LocalStorageNodeName, $f5908b407f28646c$var$LocalStorageDefaults);
        this.parser = new $89c443a2e3946d4f$exports.io.OL3Parser();
        this.parser.inject((0, $6eced4c969949f6b$export$2e2bcd8739ae039), (0, $292e4002746c8223$export$2e2bcd8739ae039), (0, $548636579b4087f2$export$2e2bcd8739ae039), (0, $40aa8d43bbe572bf$export$2e2bcd8739ae039), (0, $e6080c63a9451eda$export$2e2bcd8739ae039), (0, $b4c0e2e13beea46e$export$2e2bcd8739ae039), (0, $f73f35eb6af8b987$export$2e2bcd8739ae039), (0, $0e4f3959219eede5$export$2e2bcd8739ae039));
        this.interactionDraw = this.#generateOLInteractionDraw();
        this.interactionDraw.on((0, $a9807b370eed025c$export$ada873a34909da65).openLayers.drawStart, this.#onDrawStart.bind(this));
        this.interactionDraw.on((0, $a9807b370eed025c$export$ada873a34909da65).openLayers.drawEnd, this.#onDrawEnd.bind(this));
        this.interactionDraw.on((0, $a9807b370eed025c$export$ada873a34909da65).openLayers.drawAbort, this.#onDrawAbort.bind(this));
        this.interactionDraw.on((0, $a9807b370eed025c$export$ada873a34909da65).openLayers.error, this.#onDrawError.bind(this));
        this.attachGlobalListeners();
        // Note: 
        // @Consumer callback
        if (this.options.onInitiated) this.options.onInitiated();
    }
    attachGlobalListeners() {
        this.onWindowKeyUpBind = this.#onWindowKeyUp.bind(this);
        this.onOLTBReadyBind = this.#onOLTBReady.bind(this);
        this.onWindowBrowserStateClearedBind = this.#onWindowBrowserStateCleared.bind(this);
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.keyUp, this.onWindowKeyUpBind);
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.ready, this.onOLTBReadyBind);
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.browserStateCleared, this.onWindowBrowserStateClearedBind);
    }
    detachGlobalListeners() {
        window.removeEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.keyUp, this.onWindowKeyUpBind);
        window.removeEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.ready, this.onOLTBReadyBind);
        window.removeEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.browserStateCleared, this.onWindowBrowserStateClearedBind);
    }
    //--------------------------------------------------------------------
    // # Section: Overridden
    //--------------------------------------------------------------------
    getName() {
        return super.getName();
    }
    onClickTool(event) {
        super.onClickTool(event);
        if (this.isActive) this.deactivateTool();
        else this.activateTool();
        // Note: 
        // @Consumer callback
        if (this.options.onClicked) this.options.onClicked();
    }
    //--------------------------------------------------------------------
    // # Section: Tool Control
    //--------------------------------------------------------------------
    activateTool() {
        const map = this.getMap();
        if (!map) return;
        // Note: 
        // The Snap interaction must be added last
        this.doAddDrawInteraction();
        (0, $3110b1ed727d9f35$export$df4a79c26d3b48ff).setActiveTool(this);
        (0, $9829e24a28f9d958$export$786f0b7d4117ba87).addSnap(this);
        this.isActive = true;
        this.button.classList.add(`${$f5908b407f28646c$var$CLASS__TOOL_BUTTON}--active`);
        this.localStorage.isActive = true;
        (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).setStateObject($f5908b407f28646c$var$LocalStorageNodeName, this.localStorage);
    }
    deactivateTool() {
        const map = this.getMap();
        if (!map) return;
        this.doRemoveDrawInteraction();
        (0, $3110b1ed727d9f35$export$df4a79c26d3b48ff).removeActiveTool();
        (0, $9829e24a28f9d958$export$786f0b7d4117ba87).removeSnap();
        this.isActive = false;
        this.button.classList.remove(`${$f5908b407f28646c$var$CLASS__TOOL_BUTTON}--active`);
        this.localStorage.isActive = false;
        (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).setStateObject($f5908b407f28646c$var$LocalStorageNodeName, this.localStorage);
    }
    deselectTool() {
        this.deactivateTool();
    }
    //--------------------------------------------------------------------
    // # Section: Browser Events
    //--------------------------------------------------------------------
    #onOLTBReady(event) {
        if (this.localStorage.isActive) this.activateTool();
    }
    #onWindowKeyUp(event) {
        const key = event.key;
        if (key === (0, $7cb32231c4f9783a$export$70f9e5bc10d7eac).valueEscape) {
            if (this.interactionDraw) this.interactionDraw.abortDrawing();
        } else if (event.ctrlKey && key === (0, $7cb32231c4f9783a$export$70f9e5bc10d7eac).valueZ) {
            if (this.interactionDraw) this.interactionDraw.removeLastPoint();
        } else if ((0, $fbd95439548fdf50$export$ad7bf7af8762113)(event, (0, $a256deadcc62504f$export$4384767a59dc851d).scissorsTool)) this.onClickTool(event);
    }
    #onWindowBrowserStateCleared() {
        this.doClearState();
        if (this.isActive) this.deactivateTool();
        // Note: 
        // @Consumer callback
        if (this.options.onBrowserStateCleared) this.options.onBrowserStateCleared();
    }
    //--------------------------------------------------------------------
    // # Section: Map/UI Callbacks
    //--------------------------------------------------------------------
    #onDrawStart(event) {
        this.doDrawStart(event);
    }
    #onDrawEnd(event) {
        this.doDrawEnd(event);
    }
    #onDrawAbort(event) {
        this.doDrawAbort(event);
    }
    #onDrawError(event) {
        this.doDrawError(event);
    }
    // Note:
    // This is a global event that is invoked from the SnapManager
    onSnap(event) {
        this.doSnap(event);
    }
    onUnSnap(event) {
        this.doUnSnap(event);
    }
    //--------------------------------------------------------------------
    // # Section: Generator Helpers
    //--------------------------------------------------------------------
    #generateOLInteractionDraw() {
        const style = this.#generateOLStyleObject();
        return new (0, $55fa2487efb2d4e1$export$2e2bcd8739ae039)({
            type: (0, $9977d850e6d2e896$export$8f4397a63c3cef66).LineString,
            stopClick: true,
            style: style
        });
    }
    #generateOLStyleObject() {
        return new (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)({
            image: new (0, $06150d8570b7481b$export$2e2bcd8739ae039)({
                fill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
                    color: this.options.fillColor
                }),
                stroke: new (0, $f9d0329c5c745263$export$2e2bcd8739ae039)({
                    color: this.options.strokeColor,
                    width: this.options.strokeWidth
                }),
                radius: 5
            }),
            fill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
                color: this.options.fillColor
            }),
            stroke: new (0, $f9d0329c5c745263$export$2e2bcd8739ae039)({
                color: this.options.strokeColor,
                width: this.options.strokeWidth
            })
        });
    }
    #generateJSTSPolygonizer() {
        return new $89c443a2e3946d4f$exports.operation.polygonize.Polygonizer();
    }
    //--------------------------------------------------------------------
    // # Section: Tool DoActions
    //--------------------------------------------------------------------
    doClearState() {
        this.localStorage = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep($f5908b407f28646c$var$LocalStorageDefaults);
        (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).setStateObject($f5908b407f28646c$var$LocalStorageNodeName, $f5908b407f28646c$var$LocalStorageDefaults);
    }
    doDrawStart(event) {
        // Note: 
        // @Consumer callback
        if (this.options.onStart) this.options.onStart(event);
    }
    doDrawEnd(event) {
        const lineFeature = event.feature;
        const featureGeometry = lineFeature.getGeometry();
        // Note: 
        // Must search all layers thus features from different layers can be targeted
        const layerWrappers = (0, $e75fe1c51a3d360c$export$eff87c52915dd7fe).getFeatureLayers();
        layerWrappers.forEach((layerWrapper)=>{
            const layer = layerWrapper.getLayer();
            if (!layer.getVisible()) return;
            const source = layer.getSource();
            source.forEachFeatureIntersectingExtent(featureGeometry.getExtent(), (intersectedFeature)=>{
                const type = (0, $45f5d1a81c4ed6cb$export$73e78dff44a347ad).getType(intersectedFeature);
                const geometry = intersectedFeature.getGeometry();
                if ((0, $2db50dd924175022$export$38c8292316e98279)(type, geometry)) this.intersectedFeatures.push(intersectedFeature);
            });
        });
        this.intersectedFeatures.forEach((intersected)=>{
            const type = intersected.getGeometry().getType();
            if (type === (0, $9977d850e6d2e896$export$8f4397a63c3cef66).Polygon) this.doSplitPolygon(intersected, lineFeature);
        });
        if (this.intersectedFeatures.length === 0) (0, $9051f0e072bf4341$export$8d8dc7d5f743331b).info({
            i18nKey: `${$f5908b407f28646c$var$I18N__BASE}.toasts.infos.missingIntersections`,
            autoremove: true
        });
        // Note: 
        // @Consumer callback
        if (this.options.onEnd) this.options.onEnd(event);
        this.intersectedFeatures = [];
    }
    doDrawAbort(event) {
        // Note: 
        // @Consumer callback
        if (this.options.onAbort) this.options.onAbort(event);
    }
    doDrawError(event) {
        // Note: 
        // @Consumer callback
        if (this.options.onError) this.options.onError(event);
    }
    doSnap(event) {
        // Note: 
        // @Consumer callback
        if (this.options.onSnapped) this.options.onSnapped(event);
    }
    doUnSnap(event) {
        // Note: 
        // @Consumer callback
        if (this.options.onUnSnapped) this.options.onUnSnapped(event);
    }
    doAddDrawInteraction() {
        this.getMap().addInteraction(this.interactionDraw);
    }
    doRemoveDrawInteraction() {
        this.getMap().removeInteraction(this.interactionDraw);
    }
    doSplitPolygon(polygonFeature, lineFeature) {
        // Check if original feature has any custom type
        const featureType = (0, $45f5d1a81c4ed6cb$export$73e78dff44a347ad).getType(polygonFeature) || (0, $60b20182c25e327b$export$2906e7f4b228efe9).type.drawing;
        // Parse into JSTS objects
        const parsedPolygon = this.parser.read(polygonFeature.getGeometry());
        const parsedLine = this.parser.read(lineFeature.getGeometry());
        // Splitting polygon in two part
        const polygonizer = this.#generateJSTSPolygonizer();
        const union = parsedPolygon.getExteriorRing().union(parsedLine);
        polygonizer.add(union);
        const polygons = polygonizer.getPolygons();
        // Note: 
        // Only proceed if two parts
        if (polygons.array.length !== 2) return;
        const numHoles = parsedPolygon.getNumInteriorRing();
        polygons.array.forEach((geometry)=>{
            // Logic for splitting polygon with holes
            for(let a = 0; a < numHoles; a++){
                let hole = parsedPolygon.getInteriorRingN(a);
                const holeCoordinates = [];
                for(let b in hole.getCoordinates())holeCoordinates.push([
                    hole.getCoordinates()[b].x,
                    hole.getCoordinates()[b].y
                ]);
                hole = this.parser.read(new (0, $40aa8d43bbe572bf$export$2e2bcd8739ae039)([
                    holeCoordinates
                ]));
                geometry = geometry.difference(hole);
            }
            // Apply style and add the polygons to the layer
            const style = this.#generateOLStyleObject();
            const featureCoordiantes = this.parser.write(geometry).getCoordinates();
            const splittedPolygonFeature = new (0, $9fd014ab6df63665$export$2e2bcd8739ae039)({
                geometry: new (0, $40aa8d43bbe572bf$export$2e2bcd8739ae039)(featureCoordiantes),
                oltb: {
                    type: featureType
                }
            });
            splittedPolygonFeature.setStyle(style);
            const layerWrapper = (0, $e75fe1c51a3d360c$export$eff87c52915dd7fe).getActiveFeatureLayer();
            (0, $e75fe1c51a3d360c$export$eff87c52915dd7fe).addFeatureToLayer(splittedPolygonFeature, layerWrapper);
        });
        (0, $e75fe1c51a3d360c$export$eff87c52915dd7fe).removeFeatureFromFeatureLayers(polygonFeature);
    }
}



var $f1q41 = parcelRequire("f1q41");









var $f1q41 = parcelRequire("f1q41");






const $120d639f9f3e79d9$var$FILENAME = 'settings-modal.js';
const $120d639f9f3e79d9$var$I18N__BASE = 'modalExtensions.settingsModal';
// Note:
// Only specify the unique options to this class
// Things to override on the BaseModal is passed directly
const $120d639f9f3e79d9$var$DefaultOptions = Object.freeze({
    onSave: undefined,
    onCancel: undefined
});
/**
 * About:
 * Manager that handles settings
 */ class $120d639f9f3e79d9$export$dfaef62a0892bd28 extends (0, $b12cc913018885a9$export$a703eb468fcf7e69) {
    #buttons = [];
    #state = new Map();
    constructor(options = {}){
        super({
            filename: $120d639f9f3e79d9$var$FILENAME,
            title: (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get(`${$120d639f9f3e79d9$var$I18N__BASE}.title`),
            ...options
        });
        this.options = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep($120d639f9f3e79d9$var$DefaultOptions), options);
        this.#createModalContent();
    }
    //--------------------------------------------------------------------
    // # Section: Overridden
    //--------------------------------------------------------------------
    getName() {
        return super.getName();
    }
    //--------------------------------------------------------------------
    // # Section: User Interface
    //--------------------------------------------------------------------
    #createModalContent() {
        const i18n = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get(`${$120d639f9f3e79d9$var$I18N__BASE}.form`);
        const settingsFragment = window.document.createDocumentFragment();
        const settings = (0, $5547bbb6fff7ebf1$export$3016a1f47b675883).getSettings();
        settings.forEach((settingObj, key)=>{
            const [checkboxWrapper, checkbox] = (0, $d4a181242e81568c$export$cb0362de623b471b)({
                idPrefix: key,
                i18nKey: `${settingObj.i18nBase}.${settingObj.i18nKey}`,
                checked: settingObj.state,
                bottomMargin: true,
                listeners: {
                    'click': ()=>{
                        // Note:
                        // Update local state contained in the modal
                        // The state is saved persistently when the save button in the modal is pressed
                        this.#state.set(key, checkbox.checked);
                    }
                }
            });
            // Copy current state of each setting
            this.#state.set(key, settingObj.state);
            (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(settingsFragment, [
                checkboxWrapper
            ]);
        });
        const buttonsWrapper = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'div',
            class: 'oltb-d-flex oltb-justify-content-between oltb-mt-15'
        });
        const saveButton = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'button',
            text: i18n.save,
            class: 'oltb-dialog__btn oltb-btn oltb-btn--green-mid',
            attributes: {
                'type': 'button'
            },
            listeners: {
                'click': this.#onSave.bind(this)
            }
        });
        const cancelButton = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'button',
            text: i18n.cancel,
            class: `oltb-dialog__btn oltb-btn ${(0, $c63f096e37f334a4$export$5a63ccfbe4d87ef0)() ? 'oltb-btn--gray-mid' : 'oltb-btn--gray-dark'}`,
            attributes: {
                'type': 'button'
            },
            listeners: {
                'click': this.#onCancel.bind(this)
            }
        });
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(buttonsWrapper, [
            cancelButton,
            saveButton
        ]);
        const modalContent = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'div',
            class: 'oltb-modal__content'
        });
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(modalContent, [
            settingsFragment,
            buttonsWrapper
        ]);
        this.#buttons = [
            cancelButton,
            saveButton
        ];
        this.show(modalContent);
    }
    //--------------------------------------------------------------------
    // # Section: Events
    //--------------------------------------------------------------------
    #onSave() {
        this.#state.forEach((value, key)=>{
            (0, $5547bbb6fff7ebf1$export$3016a1f47b675883).setSetting(key, value);
        });
        this.#state.clear();
        this.close();
        this.options.onSave && this.options.onSave();
    }
    #onCancel() {
        this.close();
        this.options.onCancel && this.options.onCancel();
    }
    //--------------------------------------------------------------------
    // # Section: Public API
    //--------------------------------------------------------------------
    getButtons() {
        return this.#buttons;
    }
}







const $0fafd5258faf4813$var$FILENAME = 'settings-tool.js';
const $0fafd5258faf4813$var$CLASS__TOOL_BUTTON = 'oltb-tool-button';
const $0fafd5258faf4813$var$I18N__BASE = 'tools.settingsTool';
const $0fafd5258faf4813$var$DefaultOptions = Object.freeze({
    onInitiated: undefined,
    onClicked: undefined,
    onBrowserStateCleared: undefined
});
/**
 * About:
 * Various settings for the Map and its tools
 * 
 * Description:
 * Check settings for Map zooming, panning, rotating, copying coordinates, etc.
 */ class $0fafd5258faf4813$export$c4a0621dfea561e1 extends (0, $10d08d54da4ecbc4$export$cf198134d112da63) {
    constructor(options = {}){
        super({
            filename: $0fafd5258faf4813$var$FILENAME
        });
        this.icon = (0, $dcff5ab966a6537f$export$a297fe855adfd36c)({
            path: (0, $35649bc6579784f8$export$3fddabec91763a6e).gear.stroked,
            class: `${$0fafd5258faf4813$var$CLASS__TOOL_BUTTON}__icon`
        });
        const i18n = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get($0fafd5258faf4813$var$I18N__BASE);
        const button = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'button',
            html: this.icon,
            class: $0fafd5258faf4813$var$CLASS__TOOL_BUTTON,
            attributes: {
                'type': 'button',
                'data-tippy-content': `${i18n.title} (${(0, $a256deadcc62504f$export$4384767a59dc851d).settingsTool})`,
                'data-tippy-content-post': `(${(0, $a256deadcc62504f$export$4384767a59dc851d).settingsTool})`,
                'data-oltb-i18n': `${$0fafd5258faf4813$var$I18N__BASE}.title`
            },
            listeners: {
                'click': this.onClickTool.bind(this)
            }
        });
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(this.element, [
            button
        ]);
        this.button = button;
        this.settingsModal = undefined;
        this.options = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep($0fafd5258faf4813$var$DefaultOptions), options);
        this.#initContextMenuItems();
        this.attachGlobalListeners();
        // Note: 
        // @Consumer callback
        if (this.options.onInitiated) this.options.onInitiated();
    }
    attachGlobalListeners() {
        this.onWindowKeyUpBind = this.#onWindowKeyUp.bind(this);
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.keyUp, this.onWindowKeyUpBind);
    }
    detachGlobalListeners() {
        window.removeEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.keyUp, this.onWindowKeyUpBind);
    }
    //--------------------------------------------------------------------
    // # Section: Overridden
    //--------------------------------------------------------------------
    getName() {
        return super.getName();
    }
    onClickTool(event) {
        super.onClickTool(event);
        this.momentaryActivation();
        // Note: 
        // @Consumer callback
        if (this.options.onClicked) this.options.onClicked();
    }
    //--------------------------------------------------------------------
    // # Section: Init Helpers
    //--------------------------------------------------------------------
    #initContextMenuItems() {
        (0, $062067ac9882af21$export$b6aef0d24cd6ce8c).addItem({});
        (0, $062067ac9882af21$export$b6aef0d24cd6ce8c).addItem({
            icon: this.icon,
            i18nKey: `${$0fafd5258faf4813$var$I18N__BASE}.contextItems.clearBrowserState`,
            fn: this.#onContextMenuBrowserStateClear.bind(this)
        });
    }
    //--------------------------------------------------------------------
    // # Section: Tool Control
    //--------------------------------------------------------------------
    momentaryActivation() {
        this.doShowSettingsModal();
    }
    //--------------------------------------------------------------------
    // # Section: Browser Events
    //--------------------------------------------------------------------
    #onWindowKeyUp(event) {
        if ((0, $fbd95439548fdf50$export$ad7bf7af8762113)(event, (0, $a256deadcc62504f$export$4384767a59dc851d).settingsTool)) this.onClickTool(event);
    }
    //--------------------------------------------------------------------
    // # Section: ContextMenu Callbacks
    //--------------------------------------------------------------------
    #onContextMenuBrowserStateClear(map, coordinates, target) {
        this.askToClearBrowserState();
    }
    //--------------------------------------------------------------------
    // # Section: Tool DoActions
    //--------------------------------------------------------------------
    askToClearBrowserState() {
        const i18n = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get(`${$0fafd5258faf4813$var$I18N__BASE}.dialogs.confirms.clearBrowserState`);
        return (0, $c815862f3b0d8f0b$export$3ddf2d174ce01153).confirm({
            title: i18n.title,
            message: i18n.message,
            confirmText: i18n.confirmText,
            cancelText: i18n.cancelText,
            onConfirm: ()=>{
                this.doClearBrowserState();
            }
        });
    }
    //--------------------------------------------------------------------
    // # Section: Tool DoActions
    //--------------------------------------------------------------------
    doClearBrowserState() {
        this.doDispatchBrowserStateCleared();
        (0, $9051f0e072bf4341$export$8d8dc7d5f743331b).info({
            i18nKey: `${$0fafd5258faf4813$var$I18N__BASE}.toasts.infos.clearBrowserState`,
            autoremove: true
        });
    }
    doShowSettingsModal() {
        if (this.settingsModal) return;
        this.settingsModal = new (0, $120d639f9f3e79d9$export$dfaef62a0892bd28)({
            onSave: ()=>{
                (0, $9051f0e072bf4341$export$8d8dc7d5f743331b).success({
                    i18nKey: `${$0fafd5258faf4813$var$I18N__BASE}.toasts.successes.savedSettings`,
                    autoremove: true
                });
            },
            onClose: ()=>{
                this.settingsModal = undefined;
            }
        });
    }
    doDispatchBrowserStateCleared() {
        // Note: 
        // Trigger event so that any tool can clean up
        (0, $96903e3f16465932$export$cc74486daaaef499).dispatchCustomEvent([
            window
        ], (0, $a9807b370eed025c$export$ada873a34909da65).custom.browserStateCleared);
        [
            (0, $5547bbb6fff7ebf1$export$3016a1f47b675883),
            (0, $c40ede3e491a5acd$export$4d5c8163a511d38a)
        ].forEach((manager)=>{
            manager.clear();
        });
        // Note: 
        // @Consumer callback
        if (this.options.onBrowserStateCleared) this.options.onBrowserStateCleared();
    }
}



var $f1q41 = parcelRequire("f1q41");





/**
 * @module ol/control/OverviewMap
 */ 














/**
 * Maximum width and/or height extent ratio that determines when the overview
 * map should be zoomed out.
 * @type {number}
 */ const $9b9124d9a2183215$var$MAX_RATIO = 0.75;
/**
 * Minimum width and/or height extent ratio that determines when the overview
 * map should be zoomed in.
 * @type {number}
 */ const $9b9124d9a2183215$var$MIN_RATIO = 0.1;
/**
 * @typedef {Object} Options
 * @property {string} [className='ol-overviewmap'] CSS class name.
 * @property {boolean} [collapsed=true] Whether the control should start collapsed or not (expanded).
 * @property {string|HTMLElement} [collapseLabel='‹'] Text label to use for the
 * expanded overviewmap button. Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {boolean} [collapsible=true] Whether the control can be collapsed or not.
 * @property {string|HTMLElement} [label='›'] Text label to use for the collapsed
 * overviewmap button. Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {Array<import("../layer/Base.js").default>|import("../Collection.js").default<import("../layer/Base.js").default>} [layers]
 * Layers for the overview map.
 * @property {function(import("../MapEvent.js").default):void} [render] Function called when the control
 * should be re-rendered. This is called in a `requestAnimationFrame` callback.
 * @property {boolean} [rotateWithView=false] Whether the control view should rotate with the main map view.
 * @property {HTMLElement|string} [target] Specify a target if you want the control
 * to be rendered outside of the map's viewport.
 * @property {string} [tipLabel='Overview map'] Text label to use for the button tip.
 * @property {View} [view] Custom view for the overview map (should use same projection as main map). If not provided,
 * a default view with the same projection as the main map will be used.
 */ /**
 * Create a new control with a map acting as an overview map for another
 * defined map.
 *
 * @api
 */ class $9b9124d9a2183215$var$OverviewMap extends (0, $b978dafe8f7d27ff$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] OverviewMap options.
   */ constructor(options){
        options = options ? options : {};
        super({
            element: document.createElement('div'),
            render: options.render,
            target: options.target
        });
        /**
     * @private
     */ this.boundHandleRotationChanged_ = this.handleRotationChanged_.bind(this);
        /**
     * @type {boolean}
     * @private
     */ this.collapsed_ = options.collapsed !== undefined ? options.collapsed : true;
        /**
     * @private
     * @type {boolean}
     */ this.collapsible_ = options.collapsible !== undefined ? options.collapsible : true;
        if (!this.collapsible_) this.collapsed_ = false;
        /**
     * @private
     * @type {boolean}
     */ this.rotateWithView_ = options.rotateWithView !== undefined ? options.rotateWithView : false;
        /**
     * @private
     * @type {import("../extent.js").Extent|undefined}
     */ this.viewExtent_ = undefined;
        const className = options.className !== undefined ? options.className : 'ol-overviewmap';
        const tipLabel = options.tipLabel !== undefined ? options.tipLabel : 'Overview map';
        const collapseLabel = options.collapseLabel !== undefined ? options.collapseLabel : '\u2039';
        if (typeof collapseLabel === 'string') {
            /**
       * @private
       * @type {HTMLElement}
       */ this.collapseLabel_ = document.createElement('span');
            this.collapseLabel_.textContent = collapseLabel;
        } else this.collapseLabel_ = collapseLabel;
        const label = options.label !== undefined ? options.label : '\u203A';
        if (typeof label === 'string') {
            /**
       * @private
       * @type {HTMLElement}
       */ this.label_ = document.createElement('span');
            this.label_.textContent = label;
        } else this.label_ = label;
        const activeLabel = this.collapsible_ && !this.collapsed_ ? this.collapseLabel_ : this.label_;
        const button = document.createElement('button');
        button.setAttribute('type', 'button');
        button.title = tipLabel;
        button.appendChild(activeLabel);
        button.addEventListener((0, $294047c5e65f31a3$export$2e2bcd8739ae039).CLICK, this.handleClick_.bind(this), false);
        /**
     * @type {HTMLElement}
     * @private
     */ this.ovmapDiv_ = document.createElement('div');
        this.ovmapDiv_.className = 'ol-overviewmap-map';
        /**
     * Explicitly given view to be used instead of a view derived from the main map.
     * @type {View}
     * @private
     */ this.view_ = options.view;
        const ovmap = new (0, $41aa29ae0c4b607a$export$2e2bcd8739ae039)({
            view: options.view,
            controls: new (0, $931ffc4e747c14db$export$2e2bcd8739ae039)(),
            interactions: new (0, $931ffc4e747c14db$export$2e2bcd8739ae039)()
        });
        /**
     * @type {Map}
     * @private
     */ this.ovmap_ = ovmap;
        if (options.layers) options.layers.forEach(function(layer) {
            ovmap.addLayer(layer);
        });
        const box = document.createElement('div');
        box.className = 'ol-overviewmap-box';
        box.style.boxSizing = 'border-box';
        /**
     * @type {import("../Overlay.js").default}
     * @private
     */ this.boxOverlay_ = new (0, $c80d3ed2a84f41ed$export$2e2bcd8739ae039)({
            position: [
                0,
                0
            ],
            positioning: 'center-center',
            element: box
        });
        this.ovmap_.addOverlay(this.boxOverlay_);
        const cssClasses = className + ' ' + (0, $ce07df6d5d4656f1$export$1afde3d6e16a7b29) + ' ' + (0, $ce07df6d5d4656f1$export$4d4f8be70b656192) + (this.collapsed_ && this.collapsible_ ? ' ' + (0, $ce07df6d5d4656f1$export$e16017ac68d14492) : '') + (this.collapsible_ ? '' : ' ol-uncollapsible');
        const element = this.element;
        element.className = cssClasses;
        element.appendChild(this.ovmapDiv_);
        element.appendChild(button);
        /* Interactive map */ const overlay = this.boxOverlay_;
        const overlayBox = this.boxOverlay_.getElement();
        /* Functions definition */ const computeDesiredMousePosition = (mousePosition)=>{
            return {
                clientX: mousePosition.clientX,
                clientY: mousePosition.clientY
            };
        };
        const move = function(event) {
            const position = /** @type {?} */ computeDesiredMousePosition(event);
            const coordinates = ovmap.getEventCoordinate(/** @type {MouseEvent} */ position);
            overlay.setPosition(coordinates);
        };
        const endMoving = (event)=>{
            const coordinates = ovmap.getEventCoordinateInternal(event);
            const map = this.getMap();
            map.getView().setCenterInternal(coordinates);
            const ownerDocument = map.getOwnerDocument();
            ownerDocument.removeEventListener('pointermove', move);
            ownerDocument.removeEventListener('pointerup', endMoving);
        };
        /* Binding */ this.ovmapDiv_.addEventListener('pointerdown', (event)=>{
            const ownerDocument = this.getMap().getOwnerDocument();
            if (event.target === overlayBox) ownerDocument.addEventListener('pointermove', move);
            ownerDocument.addEventListener('pointerup', endMoving);
        });
    }
    /**
   * Remove the control from its current map and attach it to the new map.
   * Pass `null` to just remove the control from the current map.
   * Subclasses may set up event handlers to get notified about changes to
   * the map here.
   * @param {import("../Map.js").default|null} map Map.
   * @api
   * @override
   */ setMap(map) {
        const oldMap = this.getMap();
        if (map === oldMap) return;
        if (oldMap) {
            const oldView = oldMap.getView();
            if (oldView) this.unbindView_(oldView);
            this.ovmap_.setTarget(null);
        }
        super.setMap(map);
        if (map) {
            this.ovmap_.setTarget(this.ovmapDiv_);
            this.listenerKeys.push((0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(map, (0, $e881b5dca21eb5d4$export$2e2bcd8739ae039).PROPERTYCHANGE, this.handleMapPropertyChange_, this));
            const view = map.getView();
            if (view) this.bindView_(view);
            if (!this.ovmap_.isRendered()) this.updateBoxAfterOvmapIsRendered_();
        }
    }
    /**
   * Handle map property changes.  This only deals with changes to the map's view.
   * @param {import("../Object.js").ObjectEvent} event The propertychange event.
   * @private
   */ handleMapPropertyChange_(event) {
        if (event.key === (0, $07fa325567004bb7$export$2e2bcd8739ae039).VIEW) {
            const oldView = /** @type {import("../View.js").default} */ event.oldValue;
            if (oldView) this.unbindView_(oldView);
            const newView = this.getMap().getView();
            this.bindView_(newView);
        } else if (!this.ovmap_.isRendered() && (event.key === (0, $07fa325567004bb7$export$2e2bcd8739ae039).TARGET || event.key === (0, $07fa325567004bb7$export$2e2bcd8739ae039).SIZE)) this.ovmap_.updateSize();
    }
    /**
   * Register listeners for view property changes.
   * @param {import("../View.js").default} view The view.
   * @private
   */ bindView_(view) {
        if (!this.view_) {
            // Unless an explicit view definition was given, derive default from whatever main map uses.
            const newView = new (0, $70364d0195659942$export$2e2bcd8739ae039)({
                projection: view.getProjection()
            });
            this.ovmap_.setView(newView);
        }
        view.addChangeListener((0, $d35baefbe89be4c5$export$2e2bcd8739ae039).ROTATION, this.boundHandleRotationChanged_);
        // Sync once with the new view
        this.handleRotationChanged_();
        if (view.isDef()) {
            this.ovmap_.updateSize();
            this.resetExtent_();
        }
    }
    /**
   * Unregister listeners for view property changes.
   * @param {import("../View.js").default} view The view.
   * @private
   */ unbindView_(view) {
        view.removeChangeListener((0, $d35baefbe89be4c5$export$2e2bcd8739ae039).ROTATION, this.boundHandleRotationChanged_);
    }
    /**
   * Handle rotation changes to the main map.
   * @private
   */ handleRotationChanged_() {
        if (this.rotateWithView_) this.ovmap_.getView().setRotation(this.getMap().getView().getRotation());
    }
    /**
   * Reset the overview map extent if the box size (width or
   * height) is less than the size of the overview map size times minRatio
   * or is greater than the size of the overview size times maxRatio.
   *
   * If the map extent was not reset, the box size can fits in the defined
   * ratio sizes. This method then checks if is contained inside the overview
   * map current extent. If not, recenter the overview map to the current
   * main map center location.
   * @private
   */ validateExtent_() {
        const map = this.getMap();
        const ovmap = this.ovmap_;
        if (!map.isRendered() || !ovmap.isRendered()) return;
        const mapSize = /** @type {import("../size.js").Size} */ map.getSize();
        const view = map.getView();
        const extent = view.calculateExtentInternal(mapSize);
        if (this.viewExtent_ && (0, $6da4c8ed3074c92b$export$e9bab7fafb253603)(extent, this.viewExtent_)) // repeats of the same extent may indicate constraint conflicts leading to an endless cycle
        return;
        this.viewExtent_ = extent;
        const ovmapSize = /** @type {import("../size.js").Size} */ ovmap.getSize();
        const ovview = ovmap.getView();
        const ovextent = ovview.calculateExtentInternal(ovmapSize);
        const topLeftPixel = ovmap.getPixelFromCoordinateInternal((0, $6da4c8ed3074c92b$export$cb1538b07e6964ff)(extent));
        const bottomRightPixel = ovmap.getPixelFromCoordinateInternal((0, $6da4c8ed3074c92b$export$e77c1cf70445e168)(extent));
        const boxWidth = Math.abs(topLeftPixel[0] - bottomRightPixel[0]);
        const boxHeight = Math.abs(topLeftPixel[1] - bottomRightPixel[1]);
        const ovmapWidth = ovmapSize[0];
        const ovmapHeight = ovmapSize[1];
        if (boxWidth < ovmapWidth * $9b9124d9a2183215$var$MIN_RATIO || boxHeight < ovmapHeight * $9b9124d9a2183215$var$MIN_RATIO || boxWidth > ovmapWidth * $9b9124d9a2183215$var$MAX_RATIO || boxHeight > ovmapHeight * $9b9124d9a2183215$var$MAX_RATIO) this.resetExtent_();
        else if (!(0, $6da4c8ed3074c92b$export$be866b1e0809b17e)(ovextent, extent)) this.recenter_();
    }
    /**
   * Reset the overview map extent to half calculated min and max ratio times
   * the extent of the main map.
   * @private
   */ resetExtent_() {
        if ($9b9124d9a2183215$var$MAX_RATIO === 0 || $9b9124d9a2183215$var$MIN_RATIO === 0) return;
        const map = this.getMap();
        const ovmap = this.ovmap_;
        const mapSize = /** @type {import("../size.js").Size} */ map.getSize();
        const view = map.getView();
        const extent = view.calculateExtentInternal(mapSize);
        const ovview = ovmap.getView();
        // get how many times the current map overview could hold different
        // box sizes using the min and max ratio, pick the step in the middle used
        // to calculate the extent from the main map to set it to the overview map,
        const steps = Math.log($9b9124d9a2183215$var$MAX_RATIO / $9b9124d9a2183215$var$MIN_RATIO) / Math.LN2;
        const ratio = 1 / (Math.pow(2, steps / 2) * $9b9124d9a2183215$var$MIN_RATIO);
        (0, $6da4c8ed3074c92b$export$80cbab86674143b6)(extent, ratio);
        ovview.fitInternal((0, $40aa8d43bbe572bf$export$c16b671815801c75)(extent));
    }
    /**
   * Set the center of the overview map to the map center without changing its
   * resolution.
   * @private
   */ recenter_() {
        const map = this.getMap();
        const ovmap = this.ovmap_;
        const view = map.getView();
        const ovview = ovmap.getView();
        ovview.setCenterInternal(view.getCenterInternal());
    }
    /**
   * Update the box using the main map extent
   * @private
   */ updateBox_() {
        const map = this.getMap();
        const ovmap = this.ovmap_;
        if (!map.isRendered() || !ovmap.isRendered()) return;
        const mapSize = /** @type {import("../size.js").Size} */ map.getSize();
        const view = map.getView();
        const ovview = ovmap.getView();
        const rotation = this.rotateWithView_ ? 0 : -view.getRotation();
        const overlay = this.boxOverlay_;
        const box = this.boxOverlay_.getElement();
        const center = view.getCenter();
        const resolution = view.getResolution();
        const ovresolution = ovview.getResolution();
        const width = mapSize[0] * resolution / ovresolution;
        const height = mapSize[1] * resolution / ovresolution;
        // set position using center coordinates
        overlay.setPosition(center);
        // set box size calculated from map extent size and overview map resolution
        if (box) {
            box.style.width = width + 'px';
            box.style.height = height + 'px';
            const transform = 'rotate(' + rotation + 'rad)';
            box.style.transform = transform;
        }
    }
    /**
   * @private
   */ updateBoxAfterOvmapIsRendered_() {
        if (this.ovmapPostrenderKey_) return;
        this.ovmapPostrenderKey_ = (0, $d5bf8abd656a3cdc$export$8d2a95bc11b44725)(this.ovmap_, (0, $e4ad75f913b6f7ff$export$2e2bcd8739ae039).POSTRENDER, (event)=>{
            delete this.ovmapPostrenderKey_;
            this.updateBox_();
        });
    }
    /**
   * @param {MouseEvent} event The event to handle
   * @private
   */ handleClick_(event) {
        event.preventDefault();
        this.handleToggle_();
    }
    /**
   * @private
   */ handleToggle_() {
        this.element.classList.toggle((0, $ce07df6d5d4656f1$export$e16017ac68d14492));
        if (this.collapsed_) (0, $075f937d7366f1a2$export$5542201de9311ab2)(this.collapseLabel_, this.label_);
        else (0, $075f937d7366f1a2$export$5542201de9311ab2)(this.label_, this.collapseLabel_);
        this.collapsed_ = !this.collapsed_;
        // manage overview map if it had not been rendered before and control
        // is expanded
        const ovmap = this.ovmap_;
        if (!this.collapsed_) {
            if (ovmap.isRendered()) {
                this.viewExtent_ = undefined;
                ovmap.render();
                return;
            }
            ovmap.updateSize();
            this.resetExtent_();
            this.updateBoxAfterOvmapIsRendered_();
        }
    }
    /**
   * Return `true` if the overview map is collapsible, `false` otherwise.
   * @return {boolean} True if the widget is collapsible.
   * @api
   */ getCollapsible() {
        return this.collapsible_;
    }
    /**
   * Set whether the overview map should be collapsible.
   * @param {boolean} collapsible True if the widget is collapsible.
   * @api
   */ setCollapsible(collapsible) {
        if (this.collapsible_ === collapsible) return;
        this.collapsible_ = collapsible;
        this.element.classList.toggle('ol-uncollapsible');
        if (!collapsible && this.collapsed_) this.handleToggle_();
    }
    /**
   * Collapse or expand the overview map according to the passed parameter. Will
   * not do anything if the overview map isn't collapsible or if the current
   * collapsed state is already the one requested.
   * @param {boolean} collapsed True if the widget is collapsed.
   * @api
   */ setCollapsed(collapsed) {
        if (!this.collapsible_ || this.collapsed_ === collapsed) return;
        this.handleToggle_();
    }
    /**
   * Determine if the overview map is collapsed.
   * @return {boolean} The overview map is collapsed.
   * @api
   */ getCollapsed() {
        return this.collapsed_;
    }
    /**
   * Return `true` if the overview map view can rotate, `false` otherwise.
   * @return {boolean} True if the control view can rotate.
   * @api
   */ getRotateWithView() {
        return this.rotateWithView_;
    }
    /**
   * Set whether the overview map view should rotate with the main map view.
   * @param {boolean} rotateWithView True if the control view should rotate.
   * @api
   */ setRotateWithView(rotateWithView) {
        if (this.rotateWithView_ === rotateWithView) return;
        this.rotateWithView_ = rotateWithView;
        if (this.getMap().getView().getRotation() !== 0) {
            if (this.rotateWithView_) this.handleRotationChanged_();
            else this.ovmap_.getView().setRotation(0);
            this.viewExtent_ = undefined;
            this.validateExtent_();
            this.updateBox_();
        }
    }
    /**
   * Return the overview map.
   * @return {import("../Map.js").default} Overview map.
   * @api
   */ getOverviewMap() {
        return this.ovmap_;
    }
    /**
   * Update the overview map element.
   * @param {import("../MapEvent.js").default} mapEvent Map event.
   * @override
   */ render(mapEvent) {
        this.validateExtent_();
        this.updateBox_();
    }
}
var $9b9124d9a2183215$export$2e2bcd8739ae039 = $9b9124d9a2183215$var$OverviewMap;










const $928bfa8cf54ec183$var$FILENAME = 'overview-tool.js';
const $928bfa8cf54ec183$var$CLASS__TOOL_BUTTON = 'oltb-tool-button';
const $928bfa8cf54ec183$var$CLASS__TOOLBOX_SECTION = 'oltb-toolbox-section';
const $928bfa8cf54ec183$var$CLASS__TOGGLEABLE = 'oltb-toggleable';
const $928bfa8cf54ec183$var$ID__PREFIX = 'oltb-overview';
const $928bfa8cf54ec183$var$ID__OVERVIEW_TARGET = `${$928bfa8cf54ec183$var$ID__PREFIX}-target`;
const $928bfa8cf54ec183$var$I18N__BASE = 'tools.overviewTool';
const $928bfa8cf54ec183$var$I18N__BASE_COMMON = 'commons';
const $928bfa8cf54ec183$var$DefaultOptions = Object.freeze({
    onInitiated: undefined,
    onClicked: undefined,
    onBrowserStateCleared: undefined
});
const $928bfa8cf54ec183$var$LocalStorageNodeName = (0, $52e25f2a10ab5b5c$export$ada36e8a1c3bc83a).overviewTool;
const $928bfa8cf54ec183$var$LocalStorageDefaults = Object.freeze({
    isActive: false,
    isCollapsed: false
});
/**
 * About:
 * Thumbnail overview
 * 
 * Description:
 * See the Map and its current view in a thumbnail version of the Map.
 */ class $928bfa8cf54ec183$export$f99b096e17f85829 extends (0, $10d08d54da4ecbc4$export$cf198134d112da63) {
    constructor(options = {}){
        super({
            filename: $928bfa8cf54ec183$var$FILENAME
        });
        const icon = (0, $dcff5ab966a6537f$export$a297fe855adfd36c)({
            path: (0, $35649bc6579784f8$export$3fddabec91763a6e).pip.stroked,
            class: `${$928bfa8cf54ec183$var$CLASS__TOOL_BUTTON}__icon`
        });
        const i18n = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get($928bfa8cf54ec183$var$I18N__BASE);
        const button = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'button',
            html: icon,
            class: $928bfa8cf54ec183$var$CLASS__TOOL_BUTTON,
            attributes: {
                'type': 'button',
                'data-tippy-content': `${i18n.title} (${(0, $a256deadcc62504f$export$4384767a59dc851d).overviewTool})`,
                'data-tippy-content-post': `(${(0, $a256deadcc62504f$export$4384767a59dc851d).overviewTool})`,
                'data-oltb-i18n': `${$928bfa8cf54ec183$var$I18N__BASE}.title`
            },
            listeners: {
                'click': this.onClickTool.bind(this)
            }
        });
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(this.element, [
            button
        ]);
        this.button = button;
        this.isActive = false;
        this.options = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep($928bfa8cf54ec183$var$DefaultOptions), options);
        this.localStorage = (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).getAndMergeStateObject($928bfa8cf54ec183$var$LocalStorageNodeName, $928bfa8cf54ec183$var$LocalStorageDefaults);
        this.#initToolboxHTML();
        this.uiRefToolboxSection = window.document.querySelector(`#${$928bfa8cf54ec183$var$ID__PREFIX}-toolbox`);
        this.#initToggleables();
        this.overviewMap = this.#generateOLOverviewMap();
        this.attachGlobalListeners();
        // Note: 
        // @Consumer callback
        if (this.options.onInitiated) this.options.onInitiated();
    }
    attachGlobalListeners() {
        this.onWindowKeyUpBind = this.#onWindowKeyUp.bind(this);
        this.onOLTBReadyBind = this.#onOLTBReady.bind(this);
        this.onWindowBrowserStateClearedBind = this.#onWindowBrowserStateCleared.bind(this);
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.keyUp, this.onWindowKeyUpBind);
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.ready, this.onOLTBReadyBind);
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.browserStateCleared, this.onWindowBrowserStateClearedBind);
    }
    detachGlobalListeners() {
        window.removeEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.keyUp, this.onWindowKeyUpBind);
        window.removeEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.ready, this.onOLTBReadyBind);
        window.removeEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.browserStateCleared, this.onWindowBrowserStateClearedBind);
    }
    //--------------------------------------------------------------------
    // # Section: Overridden
    //--------------------------------------------------------------------
    getName() {
        return super.getName();
    }
    onClickTool(event) {
        super.onClickTool(event);
        if (this.isActive) this.deactivateTool();
        else this.activateTool();
        // Note: 
        // @Consumer callback
        if (this.options.onClicked) this.options.onClicked();
    }
    //--------------------------------------------------------------------
    // # Section: Init Helpers
    //--------------------------------------------------------------------
    #initToolboxHTML() {
        const i18n = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get(`${$928bfa8cf54ec183$var$I18N__BASE}.toolbox`);
        const i18nCommon = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get(`${$928bfa8cf54ec183$var$I18N__BASE_COMMON}.titles`);
        const html = `
            <div id="${$928bfa8cf54ec183$var$ID__PREFIX}-toolbox" class="${$928bfa8cf54ec183$var$CLASS__TOOLBOX_SECTION}">
                <div class="${$928bfa8cf54ec183$var$CLASS__TOOLBOX_SECTION}__header oltb-toggleable" data-oltb-toggleable-target="${$928bfa8cf54ec183$var$ID__PREFIX}-toolbox-collapsed">
                <h4 class="${$928bfa8cf54ec183$var$CLASS__TOOLBOX_SECTION}__title" data-oltb-i18n="${$928bfa8cf54ec183$var$I18N__BASE}.toolbox.titles.overview">${i18n.titles.overview}</h4>
                    <span class="${$928bfa8cf54ec183$var$CLASS__TOOLBOX_SECTION}__icon oltb-tippy" data-oltb-i18n="${$928bfa8cf54ec183$var$I18N__BASE_COMMON}.titles.toggleSection" title="${i18nCommon.toggleSection}"></span>
                </div>
                <div class="${$928bfa8cf54ec183$var$CLASS__TOOLBOX_SECTION}__groups" id="${$928bfa8cf54ec183$var$ID__PREFIX}-toolbox-collapsed" style="display: ${this.localStorage.isCollapsed ? 'none' : 'block'}">
                    <div class="${$928bfa8cf54ec183$var$CLASS__TOOLBOX_SECTION}__group" id="${$928bfa8cf54ec183$var$ID__OVERVIEW_TARGET}"></div>
                </div>
            </div>
        `;
        (0, $8f42450ebdd44f5e$export$8e7188a60a5bbe16).getToolboxElement().insertAdjacentHTML('beforeend', html);
    }
    #initToggleables() {
        this.uiRefToolboxSection.querySelectorAll(`.${$928bfa8cf54ec183$var$CLASS__TOGGLEABLE}`).forEach((toggle)=>{
            toggle.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.click, this.#onToggleToolbox.bind(this, toggle));
        });
    }
    //--------------------------------------------------------------------
    // # Section: Generate Helpers
    //--------------------------------------------------------------------
    #generateOLOverviewMap() {
        return new (0, $9b9124d9a2183215$export$2e2bcd8739ae039)({
            target: $928bfa8cf54ec183$var$ID__OVERVIEW_TARGET,
            isCollapsed: false,
            collapsible: false,
            layers: [
                new (0, $32e67a4d3559554a$export$2e2bcd8739ae039)({
                    source: new (0, $6c8498cc816f2362$export$2e2bcd8739ae039)()
                })
            ]
        });
    }
    //--------------------------------------------------------------------
    // # Section: Tool Control
    //--------------------------------------------------------------------
    activateTool() {
        const map = this.getMap();
        if (!map) return;
        // Note:
        // The class must be added before setMap or the overview will not render correctly
        this.uiRefToolboxSection.classList.add(`${$928bfa8cf54ec183$var$CLASS__TOOLBOX_SECTION}--show`);
        this.doAddOverview(map);
        this.isActive = true;
        this.button.classList.add(`${$928bfa8cf54ec183$var$CLASS__TOOL_BUTTON}--active`);
        this.localStorage.isActive = true;
        (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).setStateObject($928bfa8cf54ec183$var$LocalStorageNodeName, this.localStorage);
        this.uiRefToolboxSection.scrollIntoView({
            behavior: 'smooth',
            block: 'end',
            inline: 'nearest'
        });
    }
    deactivateTool() {
        this.doRemoveOverview();
        this.isActive = false;
        this.button.classList.remove(`${$928bfa8cf54ec183$var$CLASS__TOOL_BUTTON}--active`);
        this.uiRefToolboxSection.classList.remove(`${$928bfa8cf54ec183$var$CLASS__TOOLBOX_SECTION}--show`);
        this.localStorage.isActive = false;
        (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).setStateObject($928bfa8cf54ec183$var$LocalStorageNodeName, this.localStorage);
    }
    //--------------------------------------------------------------------
    // # Section: Map/UI Callbacks
    //--------------------------------------------------------------------
    #onToggleToolbox(toggle) {
        const map = this.getMap();
        if (!map) return;
        const targetName = toggle.dataset.oltbToggleableTarget;
        this.doToggleToolboxSection(targetName);
    }
    //--------------------------------------------------------------------
    // # Section: Browser Events
    //--------------------------------------------------------------------
    #onOLTBReady(event) {
        if (this.localStorage.isActive) this.activateTool();
    }
    #onWindowKeyUp(event) {
        if ((0, $fbd95439548fdf50$export$ad7bf7af8762113)(event, (0, $a256deadcc62504f$export$4384767a59dc851d).overviewTool)) this.onClickTool(event);
    }
    #onWindowBrowserStateCleared() {
        this.doClearState();
        if (this.isActive) this.deactivateTool();
        // Note: 
        // @Consumer callback
        if (this.options.onBrowserStateCleared) this.options.onBrowserStateCleared();
    }
    //--------------------------------------------------------------------
    // # Section: Tool DoActions
    //--------------------------------------------------------------------
    doClearState() {
        this.localStorage = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep($928bfa8cf54ec183$var$LocalStorageDefaults);
        (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).setStateObject($928bfa8cf54ec183$var$LocalStorageNodeName, $928bfa8cf54ec183$var$LocalStorageDefaults);
    }
    doToggleToolboxSection(targetName) {
        const targetNode = window.document.getElementById(targetName);
        const duration = (0, $1e8c0ef90ed82280$export$a33e119b2316dcb7).getConfig().animationDuration.fast;
        targetNode?.slideToggle(duration, (collapsed)=>{
            this.localStorage.isCollapsed = collapsed;
            (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).setStateObject($928bfa8cf54ec183$var$LocalStorageNodeName, this.localStorage);
            // Note: 
            // Force render of overview, 
            // Other solutions will not render the dashed box correctly until the map is moved
            const map = this.getMap();
            this.overviewMap.setMap(null);
            this.overviewMap.setMap(map);
        });
    }
    doAddOverview(map) {
        this.overviewMap.setMap(map);
    }
    doRemoveOverview() {
        this.overviewMap.setMap(null);
    }
}



var $f1q41 = parcelRequire("f1q41");



























const $8e6511d79a653738$var$FILENAME = 'bookmark-tool.js';
const $8e6511d79a653738$var$CLASS__TOOL_BUTTON = 'oltb-tool-button';
const $8e6511d79a653738$var$CLASS__TOOLBOX_SECTION = 'oltb-toolbox-section';
const $8e6511d79a653738$var$CLASS__TOOLBOX_LIST = 'oltb-toolbox-list';
const $8e6511d79a653738$var$CLASS__FUNC_BUTTON = 'oltb-func-btn';
const $8e6511d79a653738$var$CLASS__TOGGLEABLE = 'oltb-toggleable';
const $8e6511d79a653738$var$ID__PREFIX = 'oltb-bookmark';
const $8e6511d79a653738$var$ID__PREFIX_INFO_WINDOW = 'oltb-info-window-marker';
const $8e6511d79a653738$var$ID__MARKER_PATH = 'bookmarkStar.filled';
const $8e6511d79a653738$var$ID__BOOKMARK_LAYER_UUID = '1fde0d79-46f9-4c92-8f9c-eb0e98f46772';
const $8e6511d79a653738$var$SORTABLE_BOOKMARKS = 'sortableBookmarks';
const $8e6511d79a653738$var$INDEX_OFFSET = 1;
const $8e6511d79a653738$var$I18N__BASE = 'tools.bookmarkTool';
const $8e6511d79a653738$var$I18N__BASE_COMMON = 'commons';
const $8e6511d79a653738$var$DefaultOptions = Object.freeze({
    markerLayerVisibleOnLoad: true,
    markerLabelUseEllipsisAfter: 20,
    markerLabelUseUpperCase: false,
    bookmarks: [],
    onInitiated: undefined,
    onClicked: undefined,
    onBrowserStateCleared: undefined,
    onAdded: undefined,
    onRemoved: undefined,
    onRenamed: undefined,
    onZoomedTo: undefined,
    onCleared: undefined,
    onDragged: undefined
});
const $8e6511d79a653738$var$LocalStorageNodeName = (0, $52e25f2a10ab5b5c$export$ada36e8a1c3bc83a).bookmarkTool;
const $8e6511d79a653738$var$LocalStorageDefaults = Object.freeze({
    isActive: false,
    isCollapsed: false,
    bookmarks: []
});
/**
 * About:
 * Create locations as Bookmarks 
 * 
 * Description:
 * A marker on the map shows the location and is also found in the Toolbox.
 * Sorting can be done by simple drag and drop.
 */ class $8e6511d79a653738$export$decc95b1d1db7cc5 extends (0, $10d08d54da4ecbc4$export$cf198134d112da63) {
    constructor(options = {}){
        super({
            filename: $8e6511d79a653738$var$FILENAME
        });
        this.icon = (0, $dcff5ab966a6537f$export$a297fe855adfd36c)({
            path: (0, $35649bc6579784f8$export$3fddabec91763a6e).bookmarkStar.stroked,
            class: `${$8e6511d79a653738$var$CLASS__TOOL_BUTTON}__icon`
        });
        this.clearBookmarksIcon = (0, $dcff5ab966a6537f$export$a297fe855adfd36c)({
            path: (0, $35649bc6579784f8$export$3fddabec91763a6e).bookmarkX.stroked
        });
        const i18n = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get($8e6511d79a653738$var$I18N__BASE);
        const button = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'button',
            html: this.icon,
            class: $8e6511d79a653738$var$CLASS__TOOL_BUTTON,
            attributes: {
                'type': 'button',
                'data-tippy-content': `${i18n.title} (${(0, $a256deadcc62504f$export$4384767a59dc851d).bookmarkTool})`,
                'data-tippy-content-post': `(${(0, $a256deadcc62504f$export$4384767a59dc851d).bookmarkTool})`,
                'data-oltb-i18n': `${$8e6511d79a653738$var$I18N__BASE}.title`
            },
            listeners: {
                'click': this.onClickTool.bind(this)
            }
        });
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(this.element, [
            button
        ]);
        this.button = button;
        this.isActive = false;
        this.options = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep($8e6511d79a653738$var$DefaultOptions), options);
        this.localStorage = (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).getAndMergeStateObject($8e6511d79a653738$var$LocalStorageNodeName, $8e6511d79a653738$var$LocalStorageDefaults);
        this.layerWrapper = this.#generateBookmarkLayer();
        this.#initToolboxHTML();
        this.uiRefToolboxSection = window.document.querySelector(`#${$8e6511d79a653738$var$ID__PREFIX}-toolbox`);
        this.#initToggleables();
        this.uiRefAddBookmarkText = this.uiRefToolboxSection.querySelector(`#${$8e6511d79a653738$var$ID__PREFIX}-add-text`);
        this.uiRefAddBookmarkButton = this.uiRefToolboxSection.querySelector(`#${$8e6511d79a653738$var$ID__PREFIX}-add-button`);
        this.uiRefAddBookmarkText.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.keyUp, this.#onAddBookmarkByKey.bind(this));
        this.uiRefAddBookmarkButton.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.click, this.#onAddBookmarkByClick.bind(this));
        this.uiRefBookmarkStack = this.uiRefToolboxSection.querySelector(`#${$8e6511d79a653738$var$ID__PREFIX}-stack`);
        this.sortableBookmarkStack = this.#generateSortable(this.uiRefBookmarkStack, {
            group: $8e6511d79a653738$var$SORTABLE_BOOKMARKS,
            callback: this.options.onDragged,
            stack: this.localStorage.bookmarks
        });
        this.#initState();
        this.#initContextMenuItems();
        this.attachGlobalListeners();
        // Note: 
        // @Consumer callback
        if (this.options.onInitiated) this.options.onInitiated();
    }
    attachGlobalListeners() {
        this.onWindowKeyUpBind = this.#onWindowKeyUp.bind(this);
        this.onOLTBReadyBind = this.#onOLTBReady.bind(this);
        this.onWindowBrowserStateClearedBind = this.#onWindowBrowserStateCleared.bind(this);
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.keyUp, this.onWindowKeyUpBind);
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.ready, this.onOLTBReadyBind);
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.browserStateCleared, this.onWindowBrowserStateClearedBind);
    }
    detachGlobalListeners() {
        window.removeEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.keyUp, this.onWindowKeyUpBind);
        window.removeEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.ready, this.onOLTBReadyBind);
        window.removeEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.browserStateCleared, this.onWindowBrowserStateClearedBind);
    }
    //--------------------------------------------------------------------
    // # Section: Overridden
    //--------------------------------------------------------------------
    getName() {
        return super.getName();
    }
    onClickTool(event) {
        super.onClickTool(event);
        if (this.isActive) this.deactivateTool();
        else this.activateTool();
        // Note: 
        // @Consumer callback
        if (this.options.onClicked) this.options.onClicked();
    }
    //--------------------------------------------------------------------
    // # Section: Init Helpers
    //--------------------------------------------------------------------
    #initToolboxHTML() {
        const i18n = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get(`${$8e6511d79a653738$var$I18N__BASE}.toolbox`);
        const i18nCommon = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get(`${$8e6511d79a653738$var$I18N__BASE_COMMON}.titles`);
        const html = `
            <div id="${$8e6511d79a653738$var$ID__PREFIX}-toolbox" class="${$8e6511d79a653738$var$CLASS__TOOLBOX_SECTION}">
                <div class="${$8e6511d79a653738$var$CLASS__TOOLBOX_SECTION}__header oltb-toggleable" data-oltb-toggleable-target="${$8e6511d79a653738$var$ID__PREFIX}-toolbox-collapsed">
                    <h4 class="${$8e6511d79a653738$var$CLASS__TOOLBOX_SECTION}__title" data-oltb-i18n="${$8e6511d79a653738$var$I18N__BASE}.toolbox.titles.bookmarks">${i18n.titles.bookmarks}</h4>
                    <span class="${$8e6511d79a653738$var$CLASS__TOOLBOX_SECTION}__icon oltb-tippy" data-oltb-i18n="${$8e6511d79a653738$var$I18N__BASE_COMMON}.titles.toggleSection" title="${i18nCommon.toggleSection}"></span>
                </div>
                <div class="${$8e6511d79a653738$var$CLASS__TOOLBOX_SECTION}__groups" id="${$8e6511d79a653738$var$ID__PREFIX}-toolbox-collapsed" style="display: ${this.localStorage.isCollapsed ? 'none' : 'block'}">
                    <div class="${$8e6511d79a653738$var$CLASS__TOOLBOX_SECTION}__group">
                        <div class="oltb-input-button-group">
                            <input type="text" id="${$8e6511d79a653738$var$ID__PREFIX}-add-text" class="oltb-input" data-oltb-i18n="${$8e6511d79a653738$var$I18N__BASE}.toolbox.groups.addBookmark.placeholder" placeholder="${i18n.groups.addBookmark.placeholder}">
                            <button type="button" id="${$8e6511d79a653738$var$ID__PREFIX}-add-button" class="oltb-btn oltb-btn--green-mid oltb-tippy" data-oltb-i18n="${$8e6511d79a653738$var$I18N__BASE}.toolbox.groups.addBookmark.add" title="${i18n.groups.addBookmark.add}">
                                ${(0, $dcff5ab966a6537f$export$a297fe855adfd36c)({
            path: (0, $35649bc6579784f8$export$3fddabec91763a6e).plus.stroked,
            width: 20,
            height: 20,
            fill: 'none',
            stroke: '#FFFFFFFF',
            strokeWidth: 1,
            class: 'oltb-btn__icon'
        })}
                            </button>
                        </div>
                    </div>
                    <div class="${$8e6511d79a653738$var$CLASS__TOOLBOX_SECTION}__group">
                        <ul id="${$8e6511d79a653738$var$ID__PREFIX}-stack" class="${$8e6511d79a653738$var$CLASS__TOOLBOX_LIST}"></ul>
                    </div>
                </div>
            </div>
        `;
        (0, $8f42450ebdd44f5e$export$8e7188a60a5bbe16).getToolboxElement().insertAdjacentHTML('beforeend', html);
    }
    #initToggleables() {
        this.uiRefToolboxSection.querySelectorAll(`.${$8e6511d79a653738$var$CLASS__TOGGLEABLE}`).forEach((toggle)=>{
            toggle.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.click, this.#onToggleToolbox.bind(this, toggle));
        });
    }
    #initState() {
        // Note:
        // Process all Bookmarks from constructor
        // Check if the id of the Bookmark is already in local storage, if not, add it
        this.options.bookmarks.forEach((bookmark)=>{
            if (!this.hasLocalStorageBookmarkById(bookmark.id)) {
                bookmark.sortIndex = 0;
                bookmark.isDynamicallyAdded = false;
                this.localStorage.bookmarks.push(bookmark);
            }
        });
        this.localStorage.bookmarks.forEach((bookmark)=>{
            this.#createUIBookmark(bookmark);
        });
        (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).setStateObject($8e6511d79a653738$var$LocalStorageNodeName, this.localStorage);
    }
    #initContextMenuItems() {
        (0, $062067ac9882af21$export$b6aef0d24cd6ce8c).addItem({
            icon: this.icon,
            i18nKey: `${$8e6511d79a653738$var$I18N__BASE}.contextItems.addBookmark`,
            fn: this.#onContextMenuBookmarkAdd.bind(this)
        });
        (0, $062067ac9882af21$export$b6aef0d24cd6ce8c).addItem({
            icon: this.clearBookmarksIcon,
            i18nKey: `${$8e6511d79a653738$var$I18N__BASE}.contextItems.clearBookmarks`,
            fn: this.#onContextMenuBookmarksClear.bind(this)
        });
    }
    //--------------------------------------------------------------------
    // # Section: Generate Helpers
    //--------------------------------------------------------------------
    #generateBookmarkLayer() {
        return (0, $e75fe1c51a3d360c$export$eff87c52915dd7fe).addFeatureLayer({
            id: $8e6511d79a653738$var$ID__BOOKMARK_LAYER_UUID,
            name: (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get(`${$8e6511d79a653738$var$I18N__BASE}.layers.bookmarks`),
            isVisible: this.options.markerLayerVisibleOnLoad,
            isSilent: true,
            disableFeatureLayerEditButton: false,
            disableFeatureLayerDownloadButton: true,
            disableFeatureLayerDeleteButton: true
        });
    }
    //--------------------------------------------------------------------
    // # Section: Tool Control
    //--------------------------------------------------------------------
    activateTool() {
        this.isActive = true;
        this.uiRefToolboxSection.classList.add(`${$8e6511d79a653738$var$CLASS__TOOLBOX_SECTION}--show`);
        this.button.classList.add(`${$8e6511d79a653738$var$CLASS__TOOL_BUTTON}--active`);
        this.localStorage.isActive = true;
        (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).setStateObject($8e6511d79a653738$var$LocalStorageNodeName, this.localStorage);
        this.uiRefToolboxSection.scrollIntoView({
            behavior: 'smooth',
            block: 'end',
            inline: 'nearest'
        });
    }
    deactivateTool() {
        this.isActive = false;
        this.uiRefToolboxSection.classList.remove(`${$8e6511d79a653738$var$CLASS__TOOLBOX_SECTION}--show`);
        this.button.classList.remove(`${$8e6511d79a653738$var$CLASS__TOOL_BUTTON}--active`);
        this.localStorage.isActive = false;
        (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).setStateObject($8e6511d79a653738$var$LocalStorageNodeName, this.localStorage);
    }
    //--------------------------------------------------------------------
    // # Section: Browser Events
    //--------------------------------------------------------------------
    #onOLTBReady(event) {
        if (this.localStorage.isActive) this.activateTool();
    }
    #onWindowKeyUp(event) {
        if ((0, $fbd95439548fdf50$export$ad7bf7af8762113)(event, (0, $a256deadcc62504f$export$4384767a59dc851d).bookmarkTool)) this.onClickTool(event);
    }
    #onWindowBrowserStateCleared() {
        this.doClearBookmarks();
        this.doClearState();
        if (this.isActive) this.deactivateTool();
        // Note: 
        // @Consumer callback
        if (this.options.onBrowserStateCleared) this.options.onBrowserStateCleared();
    }
    //--------------------------------------------------------------------
    // # Section: Tool Callbacks
    //--------------------------------------------------------------------
    #onZoomToBookmark(bookmark) {
        this.doZoomToBookmark(bookmark);
    }
    #onCopyBookmarkCoordinates(bookmark) {
        this.doCopyBookmarkCoordinatesAsync(bookmark);
    }
    #onDeleteBookmark(bookmark, bookmarkElement) {
        this.askToDeleteBookmark(bookmark, bookmarkElement);
    }
    #onEditBookmark(bookmark, bookmarkName) {
        this.askToEditBookmark(bookmark, bookmarkName);
    }
    //--------------------------------------------------------------------
    // # Section: ContextMenu Callbacks
    //--------------------------------------------------------------------
    #onContextMenuBookmarkAdd(map, coordinates, target) {
        this.doAddBookmark('', coordinates);
    }
    #onContextMenuBookmarksClear(map, coordinates, target) {
        this.askToClearBookmarks();
    }
    //--------------------------------------------------------------------
    // # Section: Map/UI Callbacks
    //--------------------------------------------------------------------
    #onToggleToolbox(toggle) {
        const targetName = toggle.dataset.oltbToggleableTarget;
        this.doToggleToolboxSection(targetName);
    }
    #onAddBookmarkByKey(event) {
        if (!this.#isValidEnterKey(event)) return;
        this.onAddBookmarkByClick(event);
    }
    #onAddBookmarkByClick(event) {
        const name = this.uiRefAddBookmarkText.value;
        this.uiRefAddBookmarkText.value = '';
        this.doAddBookmark(name);
    }
    //--------------------------------------------------------------------
    // # Section: LocalStorage Helpers
    //--------------------------------------------------------------------
    getLocalStorageBookmarkById(id) {
        const bookmark = this.localStorage.bookmarks.find((item)=>{
            return item.id === id;
        });
        return bookmark;
    }
    hasLocalStorageBookmarkById(id) {
        return !!this.getLocalStorageBookmarkById(id);
    }
    //--------------------------------------------------------------------
    // # Section: OpenLayers Shortcut
    //--------------------------------------------------------------------
    addMarkerToMap(marker) {
        this.layerWrapper.getLayer().getSource().addFeature(marker);
    }
    removeMarkerFromMap(marker) {
        this.layerWrapper.getLayer().getSource().removeFeature(marker);
    }
    clearMarkersFromMap() {
        this.layerWrapper.getLayer().getSource().clear();
    }
    isLayerVisible() {
        return this.layerWrapper.getLayer().getVisible();
    }
    //--------------------------------------------------------------------
    // # Section: Sortable
    //--------------------------------------------------------------------
    #generateSortable(element, options) {
        const duration = (0, $1e8c0ef90ed82280$export$a33e119b2316dcb7).getConfig().animationDuration.warp;
        return (0, $dc7ec905e041f51c$export$2e2bcd8739ae039).create(element, {
            group: options.group,
            dataIdAttr: 'data-oltb-sort-index',
            animation: duration,
            forceFallback: true,
            handle: `.${$8e6511d79a653738$var$CLASS__TOOLBOX_LIST}__handle`,
            chosenClass: `${$8e6511d79a653738$var$CLASS__TOOLBOX_LIST}__item--chosen`,
            dragClass: `${$8e6511d79a653738$var$CLASS__TOOLBOX_LIST}__item--drag`,
            ghostClass: `${$8e6511d79a653738$var$CLASS__TOOLBOX_LIST}__item--ghost`,
            onEnd: (event)=>this.#onEndSortable(event, options)
        });
    }
    #onEndSortable(event, options) {
        // Note: 
        // User callback data
        // The old/new are swapped due to the list beeing reversed in DESC order
        const list = [];
        const currentItem = {
            id: event.item.getAttribute('data-oltb-id'),
            oldIndex: event.newDraggableIndex,
            newIndex: event.oldDraggableIndex
        };
        const ul = event.to;
        ul.childNodes.forEach((li, index)=>{
            // Note: 
            // Reverse the index so that 0 is at bottom of list not top
            const reversedIndex = ul.childNodes.length - index - $8e6511d79a653738$var$INDEX_OFFSET;
            li.setAttribute('data-oltb-sort-index', reversedIndex);
            const id = li.getAttribute('data-oltb-id');
            // Note: 
            // The Bookmark item is one and the same for LocalStorage
            // This is not true for the LayerTool that has slightly different logic
            const bookmarkItem = this.getLocalStorageBookmarkById(id);
            if (bookmarkItem) bookmarkItem.sortIndex = reversedIndex;
            list.push({
                id: id,
                index: reversedIndex
            });
        });
        (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).setStateObject($8e6511d79a653738$var$LocalStorageNodeName, this.localStorage);
        // Note: 
        // @Consumer callback
        if (options.callback) options.callback(currentItem, list);
    }
    #sortSortableDesc(sortable, isAnimated = false) {
        const order = sortable.toArray().sort().reverse();
        sortable.sort(order, isAnimated);
    }
    #getSortableIndexFromBookmarkId(primary, secondary, id) {
        const item = primary.find((item)=>{
            return item.id === id;
        });
        if (item && item.sortIndex !== undefined) return item.sortIndex;
        return secondary.length;
    }
    //--------------------------------------------------------------------
    // # Section: Conversions/Validation
    //--------------------------------------------------------------------
    #validateName(name) {
        name = name.trim();
        if (!this.#isValid(name)) name = (0, $676c8372f9654b59$export$ac3128716fe7727f).generate();
        return name;
    }
    #isValid(result) {
        return result !== null && result !== undefined && !!result.length;
    }
    #isValidEnterKey(event) {
        return event.type === (0, $a9807b370eed025c$export$ada873a34909da65).browser.keyUp && event.key === (0, $7cb32231c4f9783a$export$70f9e5bc10d7eac).valueEnter;
    }
    //--------------------------------------------------------------------
    // # Section: User Interface
    //--------------------------------------------------------------------
    #createUIBookmarkNameTippy(bookmarkName) {
        return (0, $43bf50b0fa1441ac$export$2e2bcd8739ae039)(bookmarkName, {
            content (reference) {
                const title = reference.getAttribute('title');
                reference.removeAttribute('title');
                return title;
            },
            placement: 'top',
            theme: 'oltb oltb-themed',
            delay: (0, $1e8c0ef90ed82280$export$a33e119b2316dcb7).getConfig().tippy.delay
        });
    }
    #createUIBookmark(bookmark) {
        (0, $b9b5c0363f244088$export$49b118289be48034).logDebug($8e6511d79a653738$var$FILENAME, 'createUIBookmark', bookmark);
        this.#createUIBookmarkItem(bookmark);
        this.doAddIconMarker(bookmark);
        if (!this.hasLocalStorageBookmarkById(bookmark.id)) {
            this.localStorage.bookmarks.push(bookmark);
            (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).setStateObject($8e6511d79a653738$var$LocalStorageNodeName, this.localStorage);
        }
    }
    #createUIBookmarkItem(bookmark) {
        const sortIndex = this.#getSortableIndexFromBookmarkId(this.localStorage.bookmarks, this.uiRefBookmarkStack.childNodes, bookmark.id);
        // Note: 
        // This is the current true sortIndex
        bookmark.sortIndex = sortIndex;
        const bookmarkElement = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'li',
            id: `${$8e6511d79a653738$var$ID__PREFIX}-${bookmark.id}`,
            class: `${$8e6511d79a653738$var$CLASS__TOOLBOX_LIST}__item`,
            attributes: {
                'data-oltb-id': bookmark.id,
                'data-oltb-sort-index': sortIndex
            }
        });
        const bookmarkName = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'span',
            text: bookmark.name.ellipsis(20),
            class: `${$8e6511d79a653738$var$CLASS__TOOLBOX_LIST}__title`,
            title: bookmark.name,
            prototypes: {
                getTippy: function() {
                    return this._tippy;
                }
            }
        });
        // Note: 
        // This tooltip can not be triggered by the delegated .oltb-tippy class
        // Because the tooltip instance can not be reached in the renaming function unless it is known during "compile time"
        this.#createUIBookmarkNameTippy(bookmarkName);
        const leftWrapper = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'div',
            class: `${$8e6511d79a653738$var$CLASS__TOOLBOX_LIST}__wrapper`
        });
        const layerActiveDot = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'div',
            class: `${$8e6511d79a653738$var$CLASS__TOOLBOX_LIST}__dot`
        });
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(leftWrapper, [
            layerActiveDot
        ]);
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(leftWrapper, [
            bookmarkName
        ]);
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(bookmarkElement, [
            leftWrapper
        ]);
        const rightWrapper = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'div',
            class: `${$8e6511d79a653738$var$CLASS__TOOLBOX_LIST}__wrapper`
        });
        const i18n = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get($8e6511d79a653738$var$I18N__BASE_COMMON);
        const zoomToButton = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'button',
            class: `${$8e6511d79a653738$var$CLASS__FUNC_BUTTON} ${$8e6511d79a653738$var$CLASS__FUNC_BUTTON}--geo-pin oltb-tippy`,
            title: i18n.titles.zoomToCoordinates,
            attributes: {
                'type': 'button'
            },
            listeners: {
                'click': this.#onZoomToBookmark.bind(this, bookmark)
            }
        });
        const copyCoordinatesButton = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'button',
            class: `${$8e6511d79a653738$var$CLASS__FUNC_BUTTON} ${$8e6511d79a653738$var$CLASS__FUNC_BUTTON}--crosshair oltb-tippy`,
            title: i18n.titles.copyCoordinates,
            attributes: {
                'type': 'button'
            },
            listeners: {
                'click': this.#onCopyBookmarkCoordinates.bind(this, bookmark)
            }
        });
        const editButton = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'button',
            class: `${$8e6511d79a653738$var$CLASS__FUNC_BUTTON} ${$8e6511d79a653738$var$CLASS__FUNC_BUTTON}--edit oltb-tippy`,
            title: i18n.titles.rename,
            attributes: {
                'type': 'button'
            },
            listeners: {
                'click': this.#onEditBookmark.bind(this, bookmark, bookmarkName)
            }
        });
        const deleteButton = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'button',
            class: `${$8e6511d79a653738$var$CLASS__FUNC_BUTTON} ${$8e6511d79a653738$var$CLASS__FUNC_BUTTON}--delete oltb-tippy`,
            title: i18n.titles.delete,
            attributes: {
                'type': 'button'
            },
            listeners: {
                'click': this.#onDeleteBookmark.bind(this, bookmark, bookmarkElement)
            }
        });
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(rightWrapper, [
            zoomToButton,
            copyCoordinatesButton,
            editButton,
            deleteButton
        ]);
        const layerHandle = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'div',
            class: `${$8e6511d79a653738$var$CLASS__TOOLBOX_LIST}__handle oltb-tippy`,
            title: i18n.titles.dragToSort
        });
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(rightWrapper, [
            layerHandle
        ]);
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(bookmarkElement, [
            rightWrapper
        ]);
        this.uiRefBookmarkStack.append(bookmarkElement);
        this.#sortSortableDesc(this.sortableBookmarkStack);
    }
    //--------------------------------------------------------------------
    // # Section: Ask User
    //--------------------------------------------------------------------
    askToClearBookmarks() {
        const i18n = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get(`${$8e6511d79a653738$var$I18N__BASE}.dialogs.confirms.clearBookmarks`);
        return (0, $c815862f3b0d8f0b$export$3ddf2d174ce01153).confirm({
            title: i18n.title,
            message: i18n.message,
            confirmText: i18n.confirmText,
            cancelText: i18n.cancelText,
            onConfirm: ()=>{
                this.doClearBookmarks();
                (0, $9051f0e072bf4341$export$8d8dc7d5f743331b).info({
                    i18nKey: `${$8e6511d79a653738$var$I18N__BASE}.toasts.infos.clearBookmarks`,
                    autoremove: true
                });
            }
        });
    }
    askToDeleteBookmark(bookmark, bookmarkElement) {
        const i18n = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get(`${$8e6511d79a653738$var$I18N__BASE}.dialogs.confirms.clearBookmarks`);
        return (0, $c815862f3b0d8f0b$export$3ddf2d174ce01153).confirm({
            title: i18n.title,
            message: `${i18n.message} <strong>${bookmark.name}</strong>?`,
            confirmText: i18n.confirmText,
            cancelText: i18n.cancelText,
            onConfirm: ()=>{
                (0, $09399be6683278f4$export$ffc0bcd424265bb8).hideOverlay();
                this.doRemoveBookmark(bookmark, bookmarkElement);
            }
        });
    }
    askToEditBookmark(bookmark, bookmarkName) {
        const i18n = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get(`${$8e6511d79a653738$var$I18N__BASE}.dialogs.prompts.editBookmark`);
        return (0, $c815862f3b0d8f0b$export$3ddf2d174ce01153).prompt({
            title: i18n.title,
            message: `${i18n.message} <strong>${bookmark.name}</strong>`,
            value: bookmark.name,
            confirmText: i18n.confirmText,
            cancelText: i18n.cancelText,
            onConfirm: (result)=>{
                (0, $09399be6683278f4$export$ffc0bcd424265bb8).hideOverlay();
                if (this.#isValid(result)) this.doEditBookmark(bookmark, bookmarkName, result);
            }
        });
    }
    //--------------------------------------------------------------------
    // # Section: Tool DoActions
    //--------------------------------------------------------------------
    doClearState() {
        this.localStorage = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep($8e6511d79a653738$var$LocalStorageDefaults);
        (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).setStateObject($8e6511d79a653738$var$LocalStorageNodeName, $8e6511d79a653738$var$LocalStorageDefaults);
    }
    doToggleToolboxSection(targetName) {
        const targetNode = window.document.getElementById(targetName);
        const duration = (0, $1e8c0ef90ed82280$export$a33e119b2316dcb7).getConfig().animationDuration.fast;
        targetNode?.slideToggle(duration, (collapsed)=>{
            this.localStorage.isCollapsed = collapsed;
            (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).setStateObject($8e6511d79a653738$var$LocalStorageNodeName, this.localStorage);
        });
    }
    doAddIconMarker(bookmark) {
        const i18n = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get(`${$8e6511d79a653738$var$I18N__BASE_COMMON}.titles`);
        const coordinates = bookmark.coordinates;
        const prettyCoordinates = (0, $1bd0a226f9a16141$export$c883fd238161f841)(coordinates);
        const infoWindow = {
            title: bookmark.name,
            content: '',
            footer: `
                <span class="oltb-info-window__coordinates">${prettyCoordinates}</span>
                <div class="oltb-info-window__buttons-wrapper">
                    <button class="${$8e6511d79a653738$var$CLASS__FUNC_BUTTON} ${$8e6511d79a653738$var$CLASS__FUNC_BUTTON}--crosshair oltb-tippy" data-oltb-i18n="${$8e6511d79a653738$var$I18N__BASE_COMMON}.titles.copyCoordinates" title="${i18n.copyCoordinates}" id="${$8e6511d79a653738$var$ID__PREFIX_INFO_WINDOW}-copy-coordinates" data-oltb-coordinates="${prettyCoordinates}"></button>
                    <button class="${$8e6511d79a653738$var$CLASS__FUNC_BUTTON} ${$8e6511d79a653738$var$CLASS__FUNC_BUTTON}--copy oltb-tippy" data-oltb-i18n="${$8e6511d79a653738$var$I18N__BASE_COMMON}.titles.copyText" title="${i18n.copyText}" id="${$8e6511d79a653738$var$ID__PREFIX_INFO_WINDOW}-copy-text" data-oltb-copy="${bookmark.name}"></button>
                    <button class="${$8e6511d79a653738$var$CLASS__FUNC_BUTTON} ${$8e6511d79a653738$var$CLASS__FUNC_BUTTON}--layer oltb-tippy" data-oltb-i18n="${$8e6511d79a653738$var$I18N__BASE_COMMON}.titles.showLayer" title="${i18n.showLayer}" id="${$8e6511d79a653738$var$ID__PREFIX_INFO_WINDOW}-show-layer"></button>
                </div>
            `
        };
        const marker = (0, $45f5d1a81c4ed6cb$export$73e78dff44a347ad).generateIconMarker({
            lon: coordinates[0],
            lat: coordinates[1],
            title: bookmark.name,
            infoWindow: infoWindow,
            marker: {
                fill: '#3B4352FF',
                stroke: '#3B435266'
            },
            icon: {
                key: $8e6511d79a653738$var$ID__MARKER_PATH
            },
            label: {
                text: bookmark.name,
                useEllipsisAfter: this.options.markerLabelUseEllipsisAfter,
                useUpperCase: this.options.markerLabelUseUpperCase
            }
        });
        bookmark.marker = marker;
        this.addMarkerToMap(marker);
        return marker;
    }
    createBookmarkObject(map, name, coordinates) {
        const view = map.getView();
        const zoom = view.getZoom();
        const transformedCoordinates = coordinates ?? (0, $9c4744460e43e41b$export$3fb495868742d370)(view.getCenter());
        const id = (0, $3fa3ae484854b431$export$2e2bcd8739ae039)();
        const bookmark = {
            id: id,
            name: name,
            zoom: zoom,
            coordinates: transformedCoordinates,
            isDynamicallyAdded: true,
            sortIndex: 0
        };
        return bookmark;
    }
    doAddBookmark(name, coordinates) {
        const map = this.getMap();
        if (!map) return;
        name = this.#validateName(name);
        const bookmark = this.createBookmarkObject(map, name, coordinates);
        this.#createUIBookmark(bookmark);
        // Note: 
        // Alert the user, the Bookmark was created when the tool was not active
        if (!this.isActive) (0, $9051f0e072bf4341$export$8d8dc7d5f743331b).success({
            i18nKey: `${$8e6511d79a653738$var$I18N__BASE}.toasts.infos.createBookmark`,
            autoremove: true
        });
        // Note: 
        // @Consumer callback
        if (this.options.onAdded) this.options.onAdded(bookmark);
        return bookmark;
    }
    doRemoveBookmark(bookmark, bookmarkElement) {
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).removeElement(bookmarkElement);
        this.removeMarkerFromMap(bookmark.marker);
        this.localStorage.bookmarks = this.localStorage.bookmarks.filter((item)=>{
            return item.id !== bookmark.id;
        });
        this.localStorage.bookmarks.forEach((item)=>{
            if (item.sortIndex > bookmark.sortIndex) item.sortIndex -= 1;
        });
        this.uiRefBookmarkStack.childNodes.forEach((item)=>{
            const sortIndex = Number(item.getAttribute('data-oltb-sort-index'));
            if (sortIndex > bookmark.sortIndex) bookmarkElement.setAttribute('data-oltb-sort-index', sortIndex - 1);
        });
        this.#sortSortableDesc(this.sortableBookmarkStack);
        (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).setStateObject($8e6511d79a653738$var$LocalStorageNodeName, this.localStorage);
        // Note: 
        // @Consumer callback
        if (this.options.onRemoved) this.options.onRemoved(bookmark);
    }
    doEditBookmark(bookmark, bookmarkName, result) {
        bookmark.name = result;
        bookmarkName.innerText = result.ellipsis(20);
        bookmarkName.getTippy().setContent(result);
        // Note: 
        // Easiest to delete and add a new Marker at the same location
        this.removeMarkerFromMap(bookmark.marker);
        this.doAddIconMarker(bookmark);
        (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).setStateObject($8e6511d79a653738$var$LocalStorageNodeName, this.localStorage);
        // Note: 
        // @Consumer callback
        if (this.options.onRenamed) this.options.onRenamed(bookmark);
    }
    doClearBookmarks() {
        (0, $b9b5c0363f244088$export$49b118289be48034).logDebug($8e6511d79a653738$var$FILENAME, 'doClearBookmarks', 'All bookmarks cleared');
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).clearElement(this.uiRefBookmarkStack);
        this.clearMarkersFromMap();
        this.localStorage.bookmarks = [];
        (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).setStateObject($8e6511d79a653738$var$LocalStorageNodeName, this.localStorage);
        // Note: 
        // @Consumer callback
        if (this.options.onCleared) this.options.onCleared();
    }
    doZoomToBookmark(bookmark) {
        const map = this.getMap();
        if (!map) return;
        (0, $eb687437705d7055$export$cc43ef3ca2ae36e8)({
            map: map,
            coordinates: bookmark.coordinates,
            zoom: bookmark.zoom,
            onDone: (result)=>{
                if (this.isLayerVisible()) {
                    (0, $09399be6683278f4$export$ffc0bcd424265bb8).tryPulseAnimation(bookmark.marker);
                    (0, $09399be6683278f4$export$ffc0bcd424265bb8).showOverlay(bookmark.marker, (0, $9c4744460e43e41b$export$b15d9668511529b9)(bookmark.coordinates));
                }
            }
        });
        // Note: 
        // @Consumer callback
        if (this.options.onZoomedTo) this.options.onZoomedTo(bookmark);
    }
    async doCopyBookmarkCoordinatesAsync(bookmark) {
        const prettyCoordinates = (0, $1bd0a226f9a16141$export$c883fd238161f841)(bookmark.coordinates);
        try {
            await (0, $9f66900afbcbe054$export$2cdf1b96a9f86d16).copyAsync(prettyCoordinates);
            (0, $9051f0e072bf4341$export$8d8dc7d5f743331b).info({
                i18nKey: `${$8e6511d79a653738$var$I18N__BASE}.toasts.infos.copyCoordinates`,
                autoremove: true
            });
        } catch (error) {
            (0, $b9b5c0363f244088$export$49b118289be48034).logError($8e6511d79a653738$var$FILENAME, 'doCopyBookmarkCoordinatesAsync', {
                message: 'Failed to copy coordinates',
                error: error
            });
            (0, $9051f0e072bf4341$export$8d8dc7d5f743331b).error({
                i18nKey: `${$8e6511d79a653738$var$I18N__BASE}.toasts.errors.copyCoordinates`
            });
        }
    }
}



var $f1q41 = parcelRequire("f1q41");













const $4d95197552cbc5f9$var$FILENAME = 'direction-tool.js';
const $4d95197552cbc5f9$var$CLASS__TOOL_BUTTON = 'oltb-tool-button';
const $4d95197552cbc5f9$var$I18N__BASE = 'tools.directionTool';
const $4d95197552cbc5f9$var$DefaultOptions = Object.freeze({
    onInitiated: undefined,
    onClicked: undefined,
    onBrowserStateCleared: undefined,
    onChanged: undefined
});
const $4d95197552cbc5f9$var$DirectionData = Object.freeze({
    col: {
        class: 'col',
        icon: (0, $dcff5ab966a6537f$export$a297fe855adfd36c)({
            path: (0, $35649bc6579784f8$export$3fddabec91763a6e).symmetryHorizontal.mixed,
            class: `${$4d95197552cbc5f9$var$CLASS__TOOL_BUTTON}__icon`
        })
    },
    row: {
        class: 'row',
        icon: (0, $dcff5ab966a6537f$export$a297fe855adfd36c)({
            path: (0, $35649bc6579784f8$export$3fddabec91763a6e).symmetryVertical.mixed,
            class: `${$4d95197552cbc5f9$var$CLASS__TOOL_BUTTON}__icon`
        })
    }
});
const $4d95197552cbc5f9$var$LocalStorageNodeName = (0, $52e25f2a10ab5b5c$export$ada36e8a1c3bc83a).directionTool;
const $4d95197552cbc5f9$var$LocalStorageDefaults = Object.freeze({
    direction: $4d95197552cbc5f9$var$DirectionData.col.class
});
/**
 * About:
 * Change direction of the Toolbar
 * 
 * Description:
 * The Toolbar is vertical by default, via this tool the Toolbar can be made horizontal.
 */ class $4d95197552cbc5f9$export$609ef3da15019a40 extends (0, $10d08d54da4ecbc4$export$cf198134d112da63) {
    constructor(options = {}){
        super({
            filename: $4d95197552cbc5f9$var$FILENAME
        });
        const i18n = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get($4d95197552cbc5f9$var$I18N__BASE);
        const button = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'button',
            html: this.getToolIcon(),
            class: $4d95197552cbc5f9$var$CLASS__TOOL_BUTTON,
            attributes: {
                'type': 'button',
                'data-tippy-content': `${i18n.title} (${(0, $a256deadcc62504f$export$4384767a59dc851d).directionTool})`,
                'data-tippy-content-post': `(${(0, $a256deadcc62504f$export$4384767a59dc851d).directionTool})`,
                'data-oltb-i18n': `${$4d95197552cbc5f9$var$I18N__BASE}.title`
            },
            listeners: {
                'click': this.onClickTool.bind(this)
            },
            prototypes: {
                getTippy: function() {
                    return this._tippy;
                }
            }
        });
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(this.element, [
            button
        ]);
        this.button = button;
        this.isActive = false;
        this.options = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep($4d95197552cbc5f9$var$DefaultOptions), options);
        this.localStorage = (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).getAndMergeStateObject($4d95197552cbc5f9$var$LocalStorageNodeName, $4d95197552cbc5f9$var$LocalStorageDefaults);
        this.shouldToolButtonBeHidden();
        this.attachGlobalListeners();
        // Note: 
        // @Consumer callback
        if (this.options.onInitiated) this.options.onInitiated();
    }
    attachGlobalListeners() {
        this.onWindowKeyUpBind = this.#onWindowKeyUp.bind(this);
        this.onWindowSizeCheckBind = this.#onWindowSizeCheck.bind(this);
        this.onWindowBrowserStateClearedBind = this.#onWindowBrowserStateCleared.bind(this);
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.keyUp, this.onWindowKeyUpBind);
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.resize, this.onWindowSizeCheckBind);
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.browserStateCleared, this.onWindowBrowserStateClearedBind);
    }
    detachGlobalListeners() {
        window.removeEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.keyUp, this.onWindowKeyUpBind);
        window.removeEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.ready, this.onWindowSizeCheckBind);
        window.removeEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.browserStateCleared, this.onWindowBrowserStateClearedBind);
    }
    //--------------------------------------------------------------------
    // # Section: Overridden
    //--------------------------------------------------------------------
    getName() {
        return super.getName();
    }
    onClickTool(event) {
        super.onClickTool(event);
        this.momentaryActivation();
        // Note: 
        // @Consumer callback
        if (this.options.onClicked) this.options.onClicked();
    }
    //--------------------------------------------------------------------
    // # Section: Tool Control
    //--------------------------------------------------------------------
    momentaryActivation() {
        this.doToggleDirection();
        const active = this.getActiveDirection();
        (0, $96903e3f16465932$export$cc74486daaaef499).dispatchCustomEvent([
            window
        ], (0, $a9807b370eed025c$export$ada873a34909da65).custom.toolbarDirectionChange, {
            detail: {
                direction: active.class
            }
        });
    }
    //--------------------------------------------------------------------
    // # Section: Browser Events
    //--------------------------------------------------------------------
    #onWindowKeyUp(event) {
        if ((0, $fbd95439548fdf50$export$ad7bf7af8762113)(event, (0, $a256deadcc62504f$export$4384767a59dc851d).directionTool)) this.onClickTool(event);
    }
    #onWindowSizeCheck(event) {
        this.shouldToolButtonBeHidden();
    }
    #onWindowBrowserStateCleared() {
        const active = this.getActiveDirection();
        this.doSwitchDirectionFromTo(active, $4d95197552cbc5f9$var$DirectionData.col);
        // Note: 
        // @Consumer callback
        if (this.options.onBrowserStateCleared) this.options.onBrowserStateCleared();
    }
    //--------------------------------------------------------------------
    // # Section: Conversions/Validation
    //--------------------------------------------------------------------
    shouldToolButtonBeHidden() {
        if (window.innerWidth <= (0, $1e8c0ef90ed82280$export$a33e119b2316dcb7).getConfig().deviceWidth.sm) this.button.classList.add(`${$4d95197552cbc5f9$var$CLASS__TOOL_BUTTON}--hidden`);
        else this.button.classList.remove(`${$4d95197552cbc5f9$var$CLASS__TOOL_BUTTON}--hidden`);
    }
    //--------------------------------------------------------------------
    // # Section: Getters and Setters
    //--------------------------------------------------------------------
    getToolIcon() {
        return (0, $2d3c68c3d1a48cfe$export$2a62b49acb270576)() ? $4d95197552cbc5f9$var$DirectionData.row.icon : $4d95197552cbc5f9$var$DirectionData.col.icon;
    }
    getInActiveDirection() {
        return (0, $2d3c68c3d1a48cfe$export$2a62b49acb270576)() ? $4d95197552cbc5f9$var$DirectionData.col : $4d95197552cbc5f9$var$DirectionData.row;
    }
    getActiveDirection() {
        return (0, $2d3c68c3d1a48cfe$export$2a62b49acb270576)() ? $4d95197552cbc5f9$var$DirectionData.row : $4d95197552cbc5f9$var$DirectionData.col;
    }
    //--------------------------------------------------------------------
    // # Section: Tool DoActions
    //--------------------------------------------------------------------
    doToggleDirection() {
        const active = this.getActiveDirection();
        const inActive = this.getInActiveDirection();
        this.doSwitchDirectionFromTo(active, inActive);
        // Note: 
        // @Consumer callback
        if (this.options.onChanged) this.options.onChanged(inActive.class);
    }
    doSwitchDirectionFromTo(from, to) {
        this.localStorage.direction = to.class;
        (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).setStateObject($4d95197552cbc5f9$var$LocalStorageNodeName, this.localStorage);
        const baseClass = 'oltb';
        const uiRefToolbarElement = (0, $8f42450ebdd44f5e$export$8e7188a60a5bbe16).getToolbarElement();
        uiRefToolbarElement.classList.remove(from.class);
        window.document.body.classList.remove(`${baseClass}-${from.class}`);
        uiRefToolbarElement.classList.add(to.class);
        window.document.body.classList.add(`${baseClass}-${to.class}`);
        this.button.removeChild(this.button.firstElementChild);
        this.button.insertAdjacentHTML('afterbegin', to.icon);
    }
}



var $f1q41 = parcelRequire("f1q41");







var $f1q41 = parcelRequire("f1q41");
var $a7b6ef1ceade0603$export$160b56df2dc88fda = {
    chrome: "Google Chrome",
    brave: "Brave",
    crios: "Google Chrome",
    edge: "Microsoft Edge",
    edg: "Microsoft Edge",
    edgios: "Microsoft Edge",
    fennec: "Mozilla Firefox",
    jsdom: "JsDOM",
    mozilla: "Mozilla Firefox",
    fxios: "Mozilla Firefox",
    msie: "Microsoft Internet Explorer",
    opera: "Opera",
    opios: "Opera",
    opr: "Opera",
    opt: "Opera",
    rv: "Microsoft Internet Explorer",
    safari: "Safari",
    samsungbrowser: "Samsung Browser",
    electron: "Electron"
}, $a7b6ef1ceade0603$export$9fd1ac1e5354d96c = {
    android: "Android",
    androidTablet: "Android Tablet",
    cros: "Chrome OS",
    fennec: "Android Tablet",
    ipad: "IPad",
    ipod: "IPod",
    iphone: "IPhone",
    jsdom: "JsDOM",
    linux: "Linux",
    mac: "Macintosh",
    tablet: "Android Tablet",
    win: "Windows",
    "windows phone": "Windows Phone",
    xbox: "Microsoft Xbox"
};
var $a7b6ef1ceade0603$var$k = (d, r = -1)=>{
    let e = new RegExp(`^-?\\d+(?:.\\d{0,${r}})?`), s = Number(d).toString().match(e);
    return s ? s[0] : null;
}, $a7b6ef1ceade0603$var$w = {
    toFixed: $a7b6ef1ceade0603$var$k
};
var $a7b6ef1ceade0603$var$m = "4.1.0";
var $a7b6ef1ceade0603$var$u = ()=>typeof window < "u" ? window.navigator : null, $a7b6ef1ceade0603$export$e8551d08bf651ea9 = class {
    userAgent;
    constructor(r){
        this.userAgent = r || $a7b6ef1ceade0603$var$u()?.userAgent || null;
    }
    static get VERSION() {
        return $a7b6ef1ceade0603$var$m;
    }
    parseUserAgent(r) {
        let e = {}, s = r || this.userAgent || "", o = s.toLowerCase().replace(/\s\s+/g, " "), t = /(edge)\/([\w.]+)/.exec(o) || /(edg)[/]([\w.]+)/.exec(o) || /(opr)[/]([\w.]+)/.exec(o) || /(opt)[/]([\w.]+)/.exec(o) || /(fxios)[/]([\w.]+)/.exec(o) || /(edgios)[/]([\w.]+)/.exec(o) || /(jsdom)[/]([\w.]+)/.exec(o) || /(samsungbrowser)[/]([\w.]+)/.exec(o) || /(electron)[/]([\w.]+)/.exec(o) || /(chrome)[/]([\w.]+)/.exec(o) || /(crios)[/]([\w.]+)/.exec(o) || /(opios)[/]([\w.]+)/.exec(o) || /(version)(applewebkit)[/]([\w.]+).*(safari)[/]([\w.]+)/.exec(o) || /(webkit)[/]([\w.]+).*(version)[/]([\w.]+).*(safari)[/]([\w.]+)/.exec(o) || /(applewebkit)[/]([\w.]+).*(safari)[/]([\w.]+)/.exec(o) || /(webkit)[/]([\w.]+)/.exec(o) || /(opera)(?:.*version|)[/]([\w.]+)/.exec(o) || /(msie) ([\w.]+)/.exec(o) || /(fennec)[/]([\w.]+)/.exec(o) || o.indexOf("trident") >= 0 && /(rv)(?::| )([\w.]+)/.exec(o) || o.indexOf("compatible") < 0 && /(mozilla)(?:.*? rv:([\w.]+)|)/.exec(o) || [], b = /(ipad)/.exec(o) || /(ipod)/.exec(o) || /(iphone)/.exec(o) || /(jsdom)/.exec(o) || /(windows phone)/.exec(o) || /(xbox)/.exec(o) || /(win)/.exec(o) || /(tablet)/.exec(o) || /(android)/.test(o) && /(mobile)/.test(o) === !1 && [
            "androidTablet"
        ] || /(android)/.exec(o) || /(mac)/.exec(o) || /(linux)/.exec(o) || /(cros)/.exec(o) || [], i = t[5] || t[3] || t[1] || null, n = b[0] || null, a = t[4] || t[2] || null, g = $a7b6ef1ceade0603$var$u();
        i === "chrome" && typeof g?.brave?.isBrave == "function" && (i = "brave"), i && (e[i] = !0), n && (e[n] = !0);
        let x = !!(e.tablet || e.android || e.androidTablet), f = !!(e.ipad || e.tablet || e.androidTablet), h = !!(e.android || e.androidTablet || e.tablet || e.ipad || e.ipod || e.iphone || e["windows phone"]), v = !!(e.cros || e.mac || e.linux || e.win), y = !!(e.brave || e.chrome || e.crios || e.opr || e.safari || e.edg || e.electron), B = !!(e.msie || e.rv), M = !!(e.chrome || e.crios), j = !!(e.fxios || e.fennec || e.mozilla), E = !!e.safari, K = !!(e.opera || e.opios || e.opr || e.opt), A = !!(e.edg || e.edge || e.edgios);
        return {
            name: $a7b6ef1ceade0603$export$160b56df2dc88fda[i] ?? null,
            platform: $a7b6ef1ceade0603$export$9fd1ac1e5354d96c[n] ?? null,
            userAgent: s,
            version: a,
            shortVersion: a ? $a7b6ef1ceade0603$var$w.toFixed(parseFloat(a), 2) : null,
            isAndroid: x,
            isTablet: f,
            isMobile: h,
            isDesktop: v,
            isWebkit: y,
            isIE: B,
            isChrome: M,
            isFireFox: j,
            isSafari: E,
            isOpera: K,
            isEdge: A
        };
    }
    getBrowserInfo() {
        let r = this.parseUserAgent();
        return {
            name: r.name,
            platform: r.platform,
            userAgent: r.userAgent,
            version: r.version,
            shortVersion: r.shortVersion
        };
    }
};
var $a7b6ef1ceade0603$export$2e2bcd8739ae039 = $a7b6ef1ceade0603$export$e8551d08bf651ea9;
















const $1bd9029e4404b75f$var$FILENAME = 'debug-info-modal.js';
const $1bd9029e4404b75f$var$ID__PREFIX = 'oltb-debug';
const $1bd9029e4404b75f$var$ID__EVENT_LOG = 'oltb-event-log';
const $1bd9029e4404b75f$var$CLASS__TOGGLEABLE = 'oltb-toggleable';
const $1bd9029e4404b75f$var$I18N__BASE = 'modalExtensions.debugInfoModal';
const $1bd9029e4404b75f$var$I18N__BASE_COMMON = 'commons';
// Note:
// Only specify the unique options to this class
// Things to override on the BaseModal is passed directly
const $1bd9029e4404b75f$var$DefaultOptions = Object.freeze({
    map: undefined
});
/**
 * About:
 * Manager providing debugging information
 */ class $1bd9029e4404b75f$export$af19d572a3080fdc extends (0, $b12cc913018885a9$export$a703eb468fcf7e69) {
    #buttons = [];
    constructor(options = {}){
        super({
            filename: $1bd9029e4404b75f$var$FILENAME,
            title: (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get(`${$1bd9029e4404b75f$var$I18N__BASE}.title`),
            pushWidth: true,
            ...options
        });
        this.options = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep($1bd9029e4404b75f$var$DefaultOptions), options);
        this.#createModalContent();
    }
    //--------------------------------------------------------------------
    // # Section: Overridden
    //--------------------------------------------------------------------
    getName() {
        return super.getName();
    }
    //--------------------------------------------------------------------
    // # Section: User Interface
    //--------------------------------------------------------------------
    #createModalContent() {
        // Note:
        // Create a summary log-entry as the top item with some usefull information
        const logManagerSize = (0, $b9b5c0363f244088$export$49b118289be48034).getSize();
        const styleManagerSize = (0, $2577fba4fdbf4b69$export$29bb23d12246c816).getSize();
        (0, $b9b5c0363f244088$export$49b118289be48034).logInformation($1bd9029e4404b75f$var$FILENAME, 'summary', {
            logManager: {
                size: logManagerSize
            },
            styleManager: {
                size: styleManagerSize
            }
        });
        const modalContent = this.#generateModalContent();
        this.show(modalContent);
        modalContent.querySelectorAll(`.${$1bd9029e4404b75f$var$CLASS__TOGGLEABLE}`).forEach((toggle)=>{
            toggle.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.click, this.#onToggleSection.bind(this, toggle));
        });
    }
    #generateCommandSection() {
        const i18n = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get(`${$1bd9029e4404b75f$var$I18N__BASE}.form`);
        const commandsCollection = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'select',
            class: 'oltb-select'
        });
        // Default item, the top element that tells user to pick an item
        const option = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'option',
            text: i18n.defaultItem.title,
            attributes: {
                disabled: 'disabled',
                selected: 'selected'
            }
        });
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(commandsCollection, [
            option
        ]);
        // Note:
        // All groups that will contain selectable elements as children
        [
            {
                name: i18n.miscGroup.title,
                items: [
                    {
                        name: i18n.miscGroup.items.logToBrowser,
                        action: 'log.map.to.console'
                    },
                    {
                        name: i18n.miscGroup.items.generateUUID,
                        action: 'generate.uuid'
                    },
                    {
                        name: i18n.miscGroup.items.clearStyleManager,
                        action: 'clear.style.manager'
                    }
                ]
            },
            {
                name: i18n.eventLogGroup.title,
                items: [
                    {
                        name: i18n.eventLogGroup.items.copyEventLog,
                        action: 'copy.event.log'
                    },
                    {
                        name: i18n.eventLogGroup.items.clearEventLog,
                        action: 'clear.event.log'
                    }
                ]
            }
        ].forEach((group)=>{
            const optgroup = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
                element: 'optgroup',
                attributes: {
                    label: group.name
                }
            });
            (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(commandsCollection, [
                optgroup
            ]);
            // Note:
            // Children to each group (the selectable items)
            group.items.forEach((item)=>{
                const option = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
                    element: 'option',
                    text: item.name,
                    value: item.action
                });
                (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(optgroup, [
                    option
                ]);
            });
        });
        const actionButton = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'button',
            text: i18n.doAction,
            class: 'oltb-btn oltb-btn--blue-mid oltb-ml-05',
            attributes: {
                'type': 'button'
            },
            listeners: {
                'click': this.#onAction.bind(this)
            }
        });
        const commandsWrapper = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'div',
            class: 'oltb-debug__commands oltb-d-flex oltb-justify-content-between oltb-mt-15'
        });
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(commandsWrapper, [
            commandsCollection,
            actionButton
        ]);
        this.commandsCollection = commandsCollection;
        return commandsWrapper;
    }
    #generateSection(section, index) {
        const i18n = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get(`${$1bd9029e4404b75f$var$I18N__BASE_COMMON}.titles`);
        const sectionWrapper = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'div',
            class: 'oltb-debug'
        });
        const sectionHeader = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'div',
            class: 'oltb-debug__header oltb-toggleable',
            attributes: {
                'data-oltb-toggleable-target': `${$1bd9029e4404b75f$var$ID__PREFIX}-section-${index}`
            }
        });
        const sectionTitle = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'h4',
            class: 'oltb-debug__title',
            text: section.title
        });
        const sectionToggle = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'button',
            html: (0, $dcff5ab966a6537f$export$a297fe855adfd36c)({
                path: (0, $35649bc6579784f8$export$3fddabec91763a6e).chevronExpand.stroked,
                fill: 'none',
                stroke: 'currentColor',
                strokeWidth: 1,
                width: 16,
                height: 16
            }),
            title: i18n.toggleSection,
            class: 'oltb-debug__toggle oltb-btn oltb-btn--blank oltb-tippy',
            attributes: {
                'type': 'button'
            }
        });
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(sectionHeader, [
            sectionTitle,
            sectionToggle
        ]);
        const sectionContent = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'div',
            id: `${$1bd9029e4404b75f$var$ID__PREFIX}-section-${index}`,
            class: 'oltb-debug__content',
            style: {
                'display': `${section.display}`
            }
        });
        if (section.json) {
            const jsonSection = this.#generateJsonSection(section);
            (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(sectionContent, [
                jsonSection
            ]);
        } else {
            const logSection = this.#generateLogSection(section);
            (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(sectionContent, [
                logSection
            ]);
        }
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(sectionWrapper, [
            sectionHeader,
            sectionContent
        ]);
        return sectionWrapper;
    }
    #generateJsonSection(section) {
        const sectionPre = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'pre',
            class: `${section.class} oltb-thin-scrollbars`
        });
        const indentation = 4;
        const sectionCode = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'code',
            text: JSON.stringify(JSON.retrocycle(section.content), (0, $a8f2ca70ab701cb7$export$c4fdd084e378b052), indentation)
        });
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(sectionPre, [
            sectionCode
        ]);
        return sectionPre;
    }
    #generateLogSection(section) {
        // Note:
        // Defining the default Map to contain all levels regardless of the log contains that level or not
        const chips = new Map();
        const defaultLevels = (0, $b9b5c0363f244088$export$49b118289be48034).getLogLevels();
        for (const [key, value] of Object.entries(defaultLevels))chips.set(value.name, {
            count: 0,
            name: value.name,
            visible: value.visible,
            color: value.color,
            key: key,
            backgroundColor: value.backgroundColor,
            borderColor: value.borderColor
        });
        const eventLog = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'div',
            id: $1bd9029e4404b75f$var$ID__EVENT_LOG,
            class: 'oltb-log oltb-thin-scrollbars'
        });
        section.content.forEach((entry, index)=>{
            // Note:
            // To create a filter using chips above the eventlog
            // Updating the count of the chip to the correct value
            const current = chips.get(entry.level.name);
            chips.set(entry.level.name, {
                count: current.count + 1,
                name: entry.level.name,
                visible: entry.level.visible,
                color: entry.level.color,
                backgroundColor: entry.level.backgroundColor,
                borderColor: entry.level.borderColor
            });
            // Note:
            // Both normal strings and complex JSON structures can be logged
            if (typeof entry.value === 'string') {
                const logItem = this.#generateTextLogItem(entry);
                (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(eventLog, [
                    logItem
                ]);
            } else {
                const logItem = this.#generateObjectLogItem(entry, index);
                (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(eventLog, [
                    logItem
                ]);
            }
        });
        const eventLogWrapper = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'div',
            class: 'oltb-log__wrapper'
        });
        const chipWrapper = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'div',
            class: 'oltb-log__filter oltb-hide-scrollbars'
        });
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(eventLogWrapper, [
            chipWrapper,
            eventLog
        ]);
        chips.forEach((value, key, map)=>{
            const chip = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
                element: 'span',
                class: `oltb-chip ${!value.visible ? 'oltb-chip--deactivated' : ''}`,
                text: `${key} (${value.count})`,
                attributes: {
                    'data-oltb-reset-value': `${key} (0)`
                },
                listeners: {
                    click: ()=>{
                        this.doFilterEventLog(chip, value.name, eventLog);
                    }
                },
                style: {
                    'background-color': value.backgroundColor,
                    'color': value.color,
                    'border': `1px solid ${value.borderColor}`
                }
            });
            (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(chipWrapper, [
                chip
            ]);
        });
        return eventLogWrapper;
    }
    #generateTextLogItem(entry) {
        const logHeader = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'div',
            class: 'oltb-log__header'
        });
        const logTitle = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'div',
            class: 'oltb-log__title',
            html: `
                </span><span class="oltb-log__timestamp">${entry.timestamp}</span> &rarr; ${entry.origin} &rarr; ${entry.method} &rarr; ${entry.value}
            `
        });
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(logHeader, [
            logTitle
        ]);
        const logItem = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'div',
            class: `oltb-log__item ${!entry.level.visible ? 'oltb-log__item--hidden' : ''}`,
            attributes: {
                'data-oltb-log-name': entry.level.name
            },
            style: {
                'background-color': entry.level.backgroundColor,
                'color': entry.level.color,
                'border': `1px solid ${entry.level.borderColor}`
            }
        });
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(logItem, [
            logHeader
        ]);
        return logItem;
    }
    #generateObjectLogItem(entry, index) {
        const i18n = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get(`${$1bd9029e4404b75f$var$I18N__BASE_COMMON}.titles`);
        const logHeader = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'div',
            class: 'oltb-log__header oltb-log__header--toggleable oltb-toggleable',
            attributes: {
                'data-oltb-toggleable-target': `${$1bd9029e4404b75f$var$ID__PREFIX}-log-item-${index}`
            }
        });
        const logTitle = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'div',
            class: 'oltb-log__title',
            html: `
                </span><span class="oltb-log__timestamp">${entry.timestamp}</span> &rarr; ${entry.origin} &rarr; ${entry.method}
            `
        });
        const logToggle = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'button',
            html: (0, $dcff5ab966a6537f$export$a297fe855adfd36c)({
                path: (0, $35649bc6579784f8$export$3fddabec91763a6e).chevronExpand.stroked,
                fill: 'none',
                stroke: 'currentColor',
                strokeWidth: 1,
                width: 16,
                height: 16
            }),
            title: i18n.toggleSection,
            class: 'oltb-log__toggle oltb-btn oltb-btn--blank oltb-tippy',
            attributes: {
                'type': 'button'
            }
        });
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(logHeader, [
            logTitle,
            logToggle
        ]);
        const logContent = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'div',
            id: `${$1bd9029e4404b75f$var$ID__PREFIX}-log-item-${index}`,
            style: {
                'display': 'none'
            }
        });
        const jsonSection = this.#generateJsonSection({
            content: entry.value,
            class: 'oltb-log__json'
        }, true);
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(logContent, [
            jsonSection
        ]);
        const logItem = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'div',
            class: `oltb-log__item ${!entry.level.visible ? 'oltb-log__item--hidden' : ''}`,
            attributes: {
                'data-oltb-log-name': entry.level.name
            },
            style: {
                'background-color': entry.level.backgroundColor,
                'color': entry.level.color,
                'border': `1px solid ${entry.level.borderColor}`
            }
        });
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(logItem, [
            logHeader,
            logContent
        ]);
        return logItem;
    }
    #generateModalContent() {
        const commandsWrapper = this.#generateCommandSection();
        const config = (0, $1e8c0ef90ed82280$export$a33e119b2316dcb7).getConfig();
        // TODO:
        // Move http-links to config.json? or central config-file?
        // App Information
        const appDataContent = {
            oltb: {
                version: config.toolbar.version,
                url: 'https://github.com/qulle/oltb'
            },
            ol: {
                version: config.openLayers.version,
                url: `https://openlayers.org/en/v${config.openLayers.version}/apidoc/`
            },
            defaultConfig: config
        };
        // Loaded Translations
        const languages = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).getLanguages();
        const languageSections = [];
        languages.forEach((language)=>{
            const section = {
                title: `${language.value}.json | ${language.text}`,
                content: language.translation,
                class: 'oltb-debug__json',
                display: 'none',
                json: true
            };
            languageSections.push(section);
        });
        // Map Information
        const view = this.options.map?.getView();
        const mapDataContent = view ? {
            zoom: view.getZoom(),
            location: (0, $9c4744460e43e41b$export$3fb495868742d370)(view.getCenter()),
            rotation: view.getRotation(),
            projection: view.getProjection(),
            proj4Defs: (0, $3d63321abab47ecf$export$38112acb54e12e1).getProjections()
        } : {
            info: (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get(`${$1bd9029e4404b75f$var$I18N__BASE}.noMapFound`)
        };
        const browser = new (0, $a7b6ef1ceade0603$export$2e2bcd8739ae039)(window.navigator.userAgent);
        const userAgent = browser.parseUserAgent();
        const browserDataContent = {
            userAgent: userAgent,
            device: {
                isSecureContext: window.isSecureContext,
                location: {
                    protocol: window.location.protocol,
                    domain: window.location.hostname,
                    path: window.location.pathname,
                    port: window.location.port
                },
                screen: {
                    width: window.screen.width,
                    height: window.screen.height
                },
                window: {
                    width: window.innerWidth,
                    height: window.innerHeight,
                    pixelRatio: {
                        scalar: window.devicePixelRatio,
                        percentage: `${window.devicePixelRatio * 100}%`
                    }
                }
            }
        };
        // Browser LocalStorage
        const localStorageContent = {};
        Object.keys(window.localStorage).forEach((key)=>{
            try {
                localStorageContent[key] = JSON.parse(window.localStorage.getItem(key)) || {};
            } catch (error) {
                (0, $b9b5c0363f244088$export$49b118289be48034).logError($1bd9029e4404b75f$var$FILENAME, 'generateModalContent', {
                    message: 'Error parsing localstorage',
                    error: error
                });
            }
        });
        // Browser SessionStorage
        const sessionStorageContent = {};
        Object.keys(window.sessionStorage).forEach((key)=>{
            try {
                sessionStorageContent[key] = JSON.parse(window.sessionStorage.getItem(key)) || {};
            } catch (error) {
                (0, $b9b5c0363f244088$export$49b118289be48034).logError($1bd9029e4404b75f$var$FILENAME, 'generateModalContent', {
                    message: 'Error parsing sessionStorage',
                    error: error
                });
            }
        });
        // Browser Cookies
        const cookiesContent = Object.fromEntries(window.document.cookie.split('; ').map((c)=>{
            return c.split('=');
        }));
        // Eventlog
        const eventLog = (0, $b9b5c0363f244088$export$49b118289be48034).getLog().slice().reverse();
        // Generate sections
        const i18n = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get(`${$1bd9029e4404b75f$var$I18N__BASE}.sections`);
        const sectionFragment = window.document.createDocumentFragment();
        [
            {
                title: i18n.appData,
                content: appDataContent,
                class: 'oltb-debug__json',
                display: 'none',
                json: true
            },
            {
                title: i18n.mapData,
                content: mapDataContent,
                class: 'oltb-debug__json',
                display: 'none',
                json: true
            },
            {
                title: i18n.browserData,
                content: browserDataContent,
                class: 'oltb-debug__json',
                display: 'none',
                json: true
            },
            {
                title: i18n.localStorage,
                content: localStorageContent,
                class: 'oltb-debug__json',
                display: 'none',
                json: true
            },
            {
                title: i18n.sessionStorage,
                content: sessionStorageContent,
                class: 'oltb-debug__json',
                display: 'none',
                json: true
            },
            {
                title: i18n.cookies,
                content: cookiesContent,
                class: 'oltb-debug__json',
                display: 'none',
                json: true
            },
            ...languageSections,
            {
                title: i18n.eventLog,
                content: eventLog,
                class: 'oltb-debug__json',
                display: 'block',
                json: false
            }
        ].forEach((section, index)=>{
            const sectionWrapper = this.#generateSection(section, index);
            (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(sectionFragment, [
                sectionWrapper
            ]);
        });
        const modalContent = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'div',
            class: 'oltb-modal__content'
        });
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(modalContent, [
            commandsWrapper,
            sectionFragment
        ]);
        return modalContent;
    }
    //--------------------------------------------------------------------
    // # Section: Events
    //--------------------------------------------------------------------
    #onToggleSection(toggle) {
        const targetName = toggle.dataset.oltbToggleableTarget;
        const duration = (0, $1e8c0ef90ed82280$export$a33e119b2316dcb7).getConfig().animationDuration.fast;
        window.document.getElementById(targetName)?.slideToggle(duration);
    }
    #onAction() {
        this.doActionByName(this.commandsCollection.value);
    }
    //--------------------------------------------------------------------
    // # Section: DoActions
    //--------------------------------------------------------------------
    doActionByName(name) {
        const actions = {
            'log.map.to.console': this.doActionLoggingMap.bind(this),
            'generate.uuid': this.doActionGenerateUUID.bind(this),
            'copy.event.log': this.doActionCopyEventLogAsync.bind(this),
            'clear.event.log': this.doActionClearEventLog.bind(this),
            'clear.style.manager': this.doActionClearStyleManager.bind(this)
        };
        const actionMethod = actions[name];
        if (actionMethod) actionMethod.call();
        else (0, $b9b5c0363f244088$export$49b118289be48034).logWarning($1bd9029e4404b75f$var$FILENAME, 'doActionByName', {
            info: 'Missing action',
            name: name
        });
    }
    doFilterEventLog(chip, value, eventLog) {
        chip.classList.toggle('oltb-chip--deactivated');
        // Apply filter to the targeted log-items
        const logItems = eventLog.querySelectorAll(`[data-oltb-log-name="${value}"]`);
        logItems.forEach((item)=>{
            item.classList.toggle('oltb-log__item--hidden');
        });
        // Note:
        // :empty is difficult to use beacuase of white spaces
        // Check if all items in the log are hidden
        // Then apply helper class to the eventLog itself
        const logItemsNotHidden = eventLog.querySelectorAll('.oltb-log__item:not(.oltb-log__item--hidden)');
        if (logItemsNotHidden.length === 0) eventLog.classList.add('oltb-log--empty');
        else eventLog.classList.remove('oltb-log--empty');
    }
    doActionLoggingMap() {
        window.console.dir(this.options.map);
        (0, $9051f0e072bf4341$export$8d8dc7d5f743331b).info({
            i18nKey: `${$1bd9029e4404b75f$var$I18N__BASE}.toasts.infos.logMapObject`,
            autoremove: true
        });
    }
    doActionGenerateUUID() {
        const uuid = (0, $3fa3ae484854b431$export$2e2bcd8739ae039)();
        const entry = (0, $b9b5c0363f244088$export$49b118289be48034).logInformation($1bd9029e4404b75f$var$FILENAME, 'actionGenerateUUID', uuid);
        const eventLog = window.document.getElementById($1bd9029e4404b75f$var$ID__EVENT_LOG);
        const logItem = this.#generateTextLogItem(entry);
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).prependChildren(eventLog, [
            logItem
        ]);
    }
    async doActionCopyEventLogAsync() {
        const eventLog = (0, $b9b5c0363f244088$export$49b118289be48034).getLog().slice().reverse();
        try {
            const indentation = 4;
            const serialized = JSON.stringify(JSON.retrocycle(eventLog), (0, $a8f2ca70ab701cb7$export$c4fdd084e378b052), indentation);
            await (0, $9f66900afbcbe054$export$2cdf1b96a9f86d16).copyAsync(serialized);
            (0, $9051f0e072bf4341$export$8d8dc7d5f743331b).info({
                i18nKey: `${$1bd9029e4404b75f$var$I18N__BASE}.toasts.infos.copyEventLog`,
                autoremove: true
            });
        } catch (error) {
            (0, $b9b5c0363f244088$export$49b118289be48034).logError($1bd9029e4404b75f$var$FILENAME, 'doActionCopyEventLogAsync', {
                message: 'Failed to copy Event Log',
                error: error
            });
            (0, $9051f0e072bf4341$export$8d8dc7d5f743331b).error({
                i18nKey: `${$1bd9029e4404b75f$var$I18N__BASE}.toasts.errors.copyEventLog`
            });
        }
    }
    doActionClearEventLog() {
        (0, $b9b5c0363f244088$export$49b118289be48034).clearLog();
        // Clear eventlog
        const uiRefEventLog = window.document.getElementById($1bd9029e4404b75f$var$ID__EVENT_LOG);
        if (uiRefEventLog) (0, $e1b36be5f031477b$export$cb0933279c36a66b).clearElement(uiRefEventLog);
        // Reset chips to zero value
        const chipResetKey = 'data-oltb-reset-value';
        const uiRefChips = window.document.querySelectorAll(`[${chipResetKey}]`);
        uiRefChips.forEach((chip)=>{
            chip.innerHTML = chip.getAttribute(chipResetKey);
        });
        (0, $9051f0e072bf4341$export$8d8dc7d5f743331b).info({
            i18nKey: `${$1bd9029e4404b75f$var$I18N__BASE}.toasts.infos.clearEventLog`,
            autoremove: true
        });
    }
    doActionClearStyleManager() {
        const beforeSize = (0, $2577fba4fdbf4b69$export$29bb23d12246c816).getSize();
        (0, $2577fba4fdbf4b69$export$29bb23d12246c816).clearStyles();
        const afterSize = (0, $2577fba4fdbf4b69$export$29bb23d12246c816).getSize();
        (0, $b9b5c0363f244088$export$49b118289be48034).logInformation($1bd9029e4404b75f$var$FILENAME, 'doActionClearStyleManager', {
            info: 'StyleManager cleared',
            beforeSize: beforeSize,
            afterSize: afterSize
        });
        (0, $9051f0e072bf4341$export$8d8dc7d5f743331b).info({
            i18nKey: `${$1bd9029e4404b75f$var$I18N__BASE}.toasts.infos.clearStyleManager`,
            autoremove: true
        });
        return [
            beforeSize,
            afterSize
        ];
    }
}





const $325075bf9e711270$var$FILENAME = 'debug-info-tool.js';
const $325075bf9e711270$var$CLASS__TOOL_BUTTON = 'oltb-tool-button';
const $325075bf9e711270$var$I18N__BASE = 'tools.debugInfoTool';
const $325075bf9e711270$var$DefaultOptions = Object.freeze({
    onlyWhenGetParameter: false,
    onInitiated: undefined,
    onClicked: undefined
});
/**
 * About:
 * Show debug information and event log
 * 
 * Description: 
 * Errors happen and when they do this tool is a good place to start. 
 * Check browser version, status in localStorage and a complete log of what happened in different parts of the Map.
 */ class $325075bf9e711270$export$3bfb3488296c969e extends (0, $10d08d54da4ecbc4$export$cf198134d112da63) {
    constructor(options = {}){
        super({
            filename: $325075bf9e711270$var$FILENAME
        });
        const icon = (0, $dcff5ab966a6537f$export$a297fe855adfd36c)({
            path: (0, $35649bc6579784f8$export$3fddabec91763a6e).bug.stroked,
            class: `${$325075bf9e711270$var$CLASS__TOOL_BUTTON}__icon`
        });
        const i18n = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get($325075bf9e711270$var$I18N__BASE);
        const button = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'button',
            html: icon,
            class: $325075bf9e711270$var$CLASS__TOOL_BUTTON,
            attributes: {
                'type': 'button',
                'data-tippy-content': `${i18n.title} (${(0, $a256deadcc62504f$export$4384767a59dc851d).debugInfoTool})`,
                'data-tippy-content-post': `(${(0, $a256deadcc62504f$export$4384767a59dc851d).debugInfoTool})`,
                'data-oltb-i18n': `${$325075bf9e711270$var$I18N__BASE}.title`
            },
            listeners: {
                'click': this.onClickTool.bind(this)
            }
        });
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(this.element, [
            button
        ]);
        this.button = button;
        this.debugInfoModal = undefined;
        this.options = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep($325075bf9e711270$var$DefaultOptions), options);
        this.#initDebugState();
        this.attachGlobalListeners();
        // Note: 
        // @Consumer callback
        if (this.options.onInitiated) this.options.onInitiated();
    }
    attachGlobalListeners() {
        this.onWindowKeyUpBind = this.#onWindowKeyUp.bind(this);
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.keyUp, this.onWindowKeyUpBind);
    }
    detachGlobalListeners() {
        window.removeEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.keyUp, this.onWindowKeyUpBind);
    }
    //--------------------------------------------------------------------
    // # Section: Overridden
    //--------------------------------------------------------------------
    getName() {
        return super.getName();
    }
    onClickTool(event) {
        super.onClickTool(event);
        this.momentaryActivation();
        // Note: 
        // @Consumer callback
        if (this.options.onClicked) this.options.onClicked();
    }
    //--------------------------------------------------------------------
    // # Section: Init Helpers
    //--------------------------------------------------------------------
    #initDebugState() {
        const debugKey = (0, $1e8c0ef90ed82280$export$a33e119b2316dcb7).getConfig().urlParameter.debug;
        const isDebug = (0, $af35fd2ff1608131$export$fb10f6d9eb34a490).getParameter(debugKey) === 'true';
        if (!isDebug && this.options.onlyWhenGetParameter) this.button.classList.add(`${$325075bf9e711270$var$CLASS__TOOL_BUTTON}--hidden`);
    }
    //--------------------------------------------------------------------
    // # Section: Tool Control
    //--------------------------------------------------------------------
    momentaryActivation() {
        this.doShowDebugInfoModal();
    }
    //--------------------------------------------------------------------
    // # Section: Browser Events
    //--------------------------------------------------------------------
    #onWindowKeyUp(event) {
        if ((0, $fbd95439548fdf50$export$ad7bf7af8762113)(event, (0, $a256deadcc62504f$export$4384767a59dc851d).debugInfoTool)) this.onClickTool(event);
    }
    //--------------------------------------------------------------------
    // # Section: Tool DoActions
    //--------------------------------------------------------------------
    doShowDebugInfoModal() {
        if (this.debugInfoModal) return;
        const map = this.getMap();
        if (!map) return;
        this.debugInfoModal = new (0, $1bd9029e4404b75f$export$af19d572a3080fdc)({
            map: map,
            onClose: ()=>{
                this.debugInfoModal = undefined;
            }
        });
    }
}



var $f1q41 = parcelRequire("f1q41");

















const $fd2b4deaeb353245$var$FILENAME = 'split-view-tool.js';
const $fd2b4deaeb353245$var$CLASS__TOOL_BUTTON = 'oltb-tool-button';
const $fd2b4deaeb353245$var$CLASS__TOOLBOX_SECTION = 'oltb-toolbox-section';
const $fd2b4deaeb353245$var$CLASS__SLIDER = 'oltb-slider';
const $fd2b4deaeb353245$var$CLASS__TOGGLEABLE = 'oltb-toggleable';
const $fd2b4deaeb353245$var$ID__PREFIX = 'oltb-split-view';
const $fd2b4deaeb353245$var$INDEX__DEFAULT_RIGHT = 0;
const $fd2b4deaeb353245$var$INDEX__DEFAULT_LEFT = 1;
const $fd2b4deaeb353245$var$DEFAULT__MIN_NUM_LAYERS = 2;
const $fd2b4deaeb353245$var$I18N__BASE = 'tools.splitViewTool';
const $fd2b4deaeb353245$var$I18N__BASE_COMMON = 'commons';
const $fd2b4deaeb353245$var$DefaultOptions = Object.freeze({
    onInitiated: undefined,
    onClicked: undefined,
    onBrowserStateCleared: undefined
});
const $fd2b4deaeb353245$var$LocalStorageNodeName = (0, $52e25f2a10ab5b5c$export$ada36e8a1c3bc83a).splitViewTool;
const $fd2b4deaeb353245$var$LocalStorageDefaults = Object.freeze({
    isActive: false,
    isCollapsed: false
});
/**
 * About:
 * Review two overlapping Map layers side by side
 * 
 * Description:
 * Compares two different Map images and enables staggered overlap.
 */ class $fd2b4deaeb353245$export$9228e7c177fdff68 extends (0, $10d08d54da4ecbc4$export$cf198134d112da63) {
    constructor(options = {}){
        super({
            filename: $fd2b4deaeb353245$var$FILENAME
        });
        const icon = (0, $dcff5ab966a6537f$export$a297fe855adfd36c)({
            path: (0, $35649bc6579784f8$export$3fddabec91763a6e).arrowsExpandVertical.stroked,
            class: `${$fd2b4deaeb353245$var$CLASS__TOOL_BUTTON}__icon`
        });
        const i18n = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get($fd2b4deaeb353245$var$I18N__BASE);
        const button = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'button',
            html: icon,
            class: $fd2b4deaeb353245$var$CLASS__TOOL_BUTTON,
            attributes: {
                'type': 'button',
                'data-tippy-content': `${i18n.title} (${(0, $a256deadcc62504f$export$4384767a59dc851d).splitViewTool})`,
                'data-tippy-content-post': `(${(0, $a256deadcc62504f$export$4384767a59dc851d).splitViewTool})`,
                'data-oltb-i18n': `${$fd2b4deaeb353245$var$I18N__BASE}.title`
            },
            listeners: {
                'click': this.onClickTool.bind(this)
            }
        });
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(this.element, [
            button
        ]);
        this.button = button;
        this.isActive = false;
        this.options = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep($fd2b4deaeb353245$var$DefaultOptions), options);
        this.localStorage = (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).getAndMergeStateObject($fd2b4deaeb353245$var$LocalStorageNodeName, $fd2b4deaeb353245$var$LocalStorageDefaults);
        this.#initToolboxHTML();
        this.#initMapHTML();
        this.uiRefToolboxSection = window.document.querySelector(`#${$fd2b4deaeb353245$var$ID__PREFIX}-toolbox`);
        this.#initToggleables();
        this.uiRefLeftSource = this.uiRefToolboxSection.querySelector(`#${$fd2b4deaeb353245$var$ID__PREFIX}-left-source`);
        this.uiRefLeftSource.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.change, this.updateTool.bind(this));
        this.uiRefRightSource = this.uiRefToolboxSection.querySelector(`#${$fd2b4deaeb353245$var$ID__PREFIX}-right-source`);
        this.uiRefRightSource.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.change, this.updateTool.bind(this));
        const uiRefSwapSidesButton = this.uiRefToolboxSection.querySelector(`#${$fd2b4deaeb353245$var$ID__PREFIX}-swap-button`);
        uiRefSwapSidesButton.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.click, (event)=>{
            this.#onSwapLayerSides();
        });
        this.uiRefSplitViewSlider = (0, $8f42450ebdd44f5e$export$8e7188a60a5bbe16).getMapElement().querySelector(`#${$fd2b4deaeb353245$var$ID__PREFIX}-slider`);
        this.uiRefSplitViewSlider.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.input, this.#onSliderInput.bind(this));
        this.attachGlobalListeners();
        // Note: 
        // @Consumer callback
        if (this.options.onInitiated) this.options.onInitiated();
    }
    attachGlobalListeners() {
        this.onWindowKeyUpBind = this.#onWindowKeyUp.bind(this);
        this.onOLTBReadyBind = this.#onOLTBReady.bind(this);
        this.onWindowMapLayerAddedBind = this.#onWindowMapLayerAdded.bind(this);
        this.onWindowMapLayerRemovedBind = this.#onWindowMapLayerRemoved.bind(this);
        this.onWindowBrowserStateClearedBind = this.#onWindowBrowserStateCleared.bind(this);
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.keyUp, this.onWindowKeyUpBind);
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.ready, this.onOLTBReadyBind);
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.mapLayerAdded, this.onWindowMapLayerAddedBind);
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.mapLayerRemoved, this.onWindowMapLayerRemovedBind);
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.browserStateCleared, this.onWindowBrowserStateClearedBind);
    }
    detachGlobalListeners() {
        window.removeEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.keyUp, this.onWindowKeyUpBind);
        window.removeEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.ready, this.onOLTBReadyBind);
        window.removeEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.mapLayerAdded, this.onWindowMapLayerAddedBind);
        window.removeEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.mapLayerRemoved, this.onWindowMapLayerRemovedBind);
        window.removeEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.browserStateCleared, this.onWindowBrowserStateClearedBind);
    }
    //--------------------------------------------------------------------
    // # Section: Overridden
    //--------------------------------------------------------------------
    getName() {
        return super.getName();
    }
    onClickTool(event) {
        super.onClickTool(event);
        if ((0, $e75fe1c51a3d360c$export$eff87c52915dd7fe).getMapLayerSize() < $fd2b4deaeb353245$var$DEFAULT__MIN_NUM_LAYERS) {
            (0, $9051f0e072bf4341$export$8d8dc7d5f743331b).info({
                i18nKey: `${$fd2b4deaeb353245$var$I18N__BASE}.toasts.infos.strictOneLayer`
            });
            return;
        }
        if (this.isActive) this.deactivateTool();
        else this.activateTool();
        // Note: 
        // @Consumer callback
        if (this.options.onClicked) this.options.onClicked();
    }
    //--------------------------------------------------------------------
    // # Section: Init Helpers
    //--------------------------------------------------------------------
    #initToolboxHTML() {
        const i18n = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get(`${$fd2b4deaeb353245$var$I18N__BASE}.toolbox`);
        const i18nCommon = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get(`${$fd2b4deaeb353245$var$I18N__BASE_COMMON}.titles`);
        const html = `
            <div id="${$fd2b4deaeb353245$var$ID__PREFIX}-toolbox" class="${$fd2b4deaeb353245$var$CLASS__TOOLBOX_SECTION}">
                <div class="${$fd2b4deaeb353245$var$CLASS__TOOLBOX_SECTION}__header oltb-toggleable" data-oltb-toggleable-target="${$fd2b4deaeb353245$var$ID__PREFIX}-toolbox-collapsed">
                    <h4 class="${$fd2b4deaeb353245$var$CLASS__TOOLBOX_SECTION}__title" data-oltb-i18n="${$fd2b4deaeb353245$var$I18N__BASE}.toolbox.titles.splitView">${i18n.titles.splitView}</h4>
                    <span class="${$fd2b4deaeb353245$var$CLASS__TOOLBOX_SECTION}__icon oltb-tippy" data-oltb-i18n="${$fd2b4deaeb353245$var$I18N__BASE_COMMON}.titles.toggleSection" title="${i18nCommon.toggleSection}"></span>
                </div>
                <div class="${$fd2b4deaeb353245$var$CLASS__TOOLBOX_SECTION}__groups" id="${$fd2b4deaeb353245$var$ID__PREFIX}-toolbox-collapsed" style="display: ${this.localStorage.isCollapsed ? 'none' : 'block'}">
                    <div class="${$fd2b4deaeb353245$var$CLASS__TOOLBOX_SECTION}__group ${$fd2b4deaeb353245$var$CLASS__TOOLBOX_SECTION}__group--split-group">
                        <div class="${$fd2b4deaeb353245$var$CLASS__TOOLBOX_SECTION}__group-part">
                            <label class="oltb-label" for="${$fd2b4deaeb353245$var$ID__PREFIX}-left-source" data-oltb-i18n="${$fd2b4deaeb353245$var$I18N__BASE}.toolbox.groups.leftSide.title">${i18n.groups.leftSide.title}</label>
                            <select id="${$fd2b4deaeb353245$var$ID__PREFIX}-left-source" class="oltb-select"></select>
                        </div>
                        <div class="${$fd2b4deaeb353245$var$CLASS__TOOLBOX_SECTION}__group-part" style="flex: none;">
                            <button type="button" id="${$fd2b4deaeb353245$var$ID__PREFIX}-swap-button" class="oltb-btn oltb-btn--green-mid oltb-tippy" title="${i18n.groups.swapSides.swap}">
                                ${(0, $dcff5ab966a6537f$export$a297fe855adfd36c)({
            path: (0, $35649bc6579784f8$export$3fddabec91763a6e).arrowLeftRight.stroked,
            width: 20,
            height: 20,
            class: 'oltb-btn__icon'
        })}
                            </button>
                        </div>
                        <div class="${$fd2b4deaeb353245$var$CLASS__TOOLBOX_SECTION}__group-part">
                            <label class="oltb-label" for="${$fd2b4deaeb353245$var$ID__PREFIX}-source" data-oltb-i18n="${$fd2b4deaeb353245$var$I18N__BASE}.toolbox.groups.rightSide.title">${i18n.groups.rightSide.title}</label>
                            <select id="${$fd2b4deaeb353245$var$ID__PREFIX}-right-source" class="oltb-select"></select>
                        </div>
                    </div>
                </div>
            </div>
        `;
        (0, $8f42450ebdd44f5e$export$8e7188a60a5bbe16).getToolboxElement().insertAdjacentHTML('beforeend', html);
    }
    #initMapHTML() {
        (0, $8f42450ebdd44f5e$export$8e7188a60a5bbe16).getMapElement().insertAdjacentHTML('beforeend', `
            <input type="range" min="0" max="100" value="50" class="oltb-slider" id="${$fd2b4deaeb353245$var$ID__PREFIX}-slider">
        `);
    }
    #initToggleables() {
        this.uiRefToolboxSection.querySelectorAll(`.${$fd2b4deaeb353245$var$CLASS__TOGGLEABLE}`).forEach((toggle)=>{
            toggle.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.click, this.#onToggleToolbox.bind(this, toggle));
        });
    }
    //--------------------------------------------------------------------
    // # Section: Tool Control
    //--------------------------------------------------------------------
    activateTool() {
        // Note: 
        // The active switch must be enabled first
        // Events can be triggered by other tools that should not be handled if the tools is not in use 
        this.isActive = true;
        this.setDefaultSelectedIndexes().doDispatchChangeEvent();
        // Note:
        // Some layer related error, missing or rendering
        // Is triggered by eventDispatcher change-event
        if (this.layerLoadingError) {
            this.isActive = false;
            return;
        }
        this.uiRefToolboxSection.classList.add(`${$fd2b4deaeb353245$var$CLASS__TOOLBOX_SECTION}--show`);
        this.uiRefSplitViewSlider.classList.add(`${$fd2b4deaeb353245$var$CLASS__SLIDER}--show`);
        this.button.classList.add(`${$fd2b4deaeb353245$var$CLASS__TOOL_BUTTON}--active`);
        this.localStorage.isActive = true;
        (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).setStateObject($fd2b4deaeb353245$var$LocalStorageNodeName, this.localStorage);
        this.uiRefToolboxSection.scrollIntoView({
            behavior: 'smooth',
            block: 'end',
            inline: 'nearest'
        });
    }
    deactivateTool() {
        const map = this.getMap();
        if (!map) return;
        // Note:
        // Remove previosly added listeners
        (0, $1f093ab5083c8a1f$export$b7ef3f8527533384)(this.onPreRenderListener);
        (0, $1f093ab5083c8a1f$export$b7ef3f8527533384)(this.onPostRenderListener);
        // Remove the ol-split-view-layers from the map
        (0, $e75fe1c51a3d360c$export$eff87c52915dd7fe).getMapLayers().forEach((layerWrapper)=>{
            map.removeLayer(layerWrapper.getLayer());
        });
        // Add back all the original layers to the map
        (0, $e75fe1c51a3d360c$export$eff87c52915dd7fe).getMapLayers().forEach((layerWrapper)=>{
            map.addLayer(layerWrapper.getLayer());
        });
        // Note:
        // This method picks the top-most layer meaning the [0] index
        // In the future make it pix the one with highest Z-index or pick the one active before the tool was activated
        (0, $e75fe1c51a3d360c$export$eff87c52915dd7fe).setTopMapLayerAsOnlyVisible();
        this.isActive = false;
        this.uiRefToolboxSection.classList.remove(`${$fd2b4deaeb353245$var$CLASS__TOOLBOX_SECTION}--show`);
        this.uiRefSplitViewSlider.classList.remove(`${$fd2b4deaeb353245$var$CLASS__SLIDER}--show`);
        this.button.classList.remove(`${$fd2b4deaeb353245$var$CLASS__TOOL_BUTTON}--active`);
        this.localStorage.isActive = false;
        (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).setStateObject($fd2b4deaeb353245$var$LocalStorageNodeName, this.localStorage);
    }
    updateTool() {
        this.doUpdateTool(this.uiRefLeftSource.value, this.uiRefRightSource.value);
    }
    //--------------------------------------------------------------------
    // # Section: Browser Events
    //--------------------------------------------------------------------
    #onOLTBReady(event) {
        if (this.localStorage.isActive) this.activateTool();
    }
    #onWindowKeyUp(event) {
        if ((0, $fbd95439548fdf50$export$ad7bf7af8762113)(event, (0, $a256deadcc62504f$export$4384767a59dc851d).splitViewTool)) this.onClickTool(event);
    }
    #onWindowBrowserStateCleared() {
        this.doClearState();
        if (this.isActive) this.deactivateTool();
        // Note: 
        // @Consumer callback
        if (this.options.onBrowserStateCleared) this.options.onBrowserStateCleared();
    }
    #onWindowMapLayerAdded(event) {
        this.doMapLayerAdded(event);
    }
    #onWindowMapLayerRemoved(event) {
        this.doMapLayerRemoved(event);
        this.doDispatchChangeEvent();
    }
    //--------------------------------------------------------------------
    // # Section: Map/UI Callbacks
    //--------------------------------------------------------------------
    #onToggleToolbox(toggle) {
        const targetName = toggle.dataset.oltbToggleableTarget;
        this.doToggleToolboxSection(targetName);
    }
    #onSwapLayerSides() {
        this.doSwapLayerSides();
        this.doDispatchChangeEvent();
    }
    #onSliderInput(event) {
        const map = this.getMap();
        if (!map) return;
        map.render();
    }
    #onPreRender(event) {
        const map = this.getMap();
        if (!map) return;
        this.doPreRender(event, map);
    }
    #onPostRender(event) {
        event.context.restore();
    }
    //--------------------------------------------------------------------
    // # Getters and Setters
    //--------------------------------------------------------------------
    setDefaultSelectedIndexes() {
        this.uiRefLeftSource.selectedIndex = String($fd2b4deaeb353245$var$INDEX__DEFAULT_LEFT);
        this.uiRefRightSource.selectedIndex = String($fd2b4deaeb353245$var$INDEX__DEFAULT_RIGHT);
        return this;
    }
    setLoadingError() {
        this.layerLoadingError = true;
        (0, $b9b5c0363f244088$export$49b118289be48034).logError($fd2b4deaeb353245$var$FILENAME, 'setLoadingError', {
            message: 'One or both of the layers could not be loaded'
        });
        (0, $9051f0e072bf4341$export$8d8dc7d5f743331b).error({
            i18nKey: `${$fd2b4deaeb353245$var$I18N__BASE}.toasts.errors.layerFailedToLoad`
        });
    }
    //--------------------------------------------------------------------
    // # Section: Tool DoActions
    //--------------------------------------------------------------------
    doClearState() {
        this.localStorage = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep($fd2b4deaeb353245$var$LocalStorageDefaults);
        (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).setStateObject($fd2b4deaeb353245$var$LocalStorageNodeName, $fd2b4deaeb353245$var$LocalStorageDefaults);
    }
    doToggleToolboxSection(targetName) {
        const targetNode = window.document.getElementById(targetName);
        const duration = (0, $1e8c0ef90ed82280$export$a33e119b2316dcb7).getConfig().animationDuration.fast;
        targetNode?.slideToggle(duration, (collapsed)=>{
            this.localStorage.isCollapsed = collapsed;
            (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).setStateObject($fd2b4deaeb353245$var$LocalStorageNodeName, this.localStorage);
        });
    }
    doMapLayerRemoved(event) {
        const layerWrapper = event.detail.layerWrapper;
        this.uiRefLeftSource.childNodes.forEach((option)=>{
            if (option.value === layerWrapper.getId()) (0, $e1b36be5f031477b$export$cb0933279c36a66b).removeElement(option);
        });
        this.uiRefRightSource.childNodes.forEach((option)=>{
            if (option.value === layerWrapper.getId()) (0, $e1b36be5f031477b$export$cb0933279c36a66b).removeElement(option);
        });
    }
    doMapLayerAdded(event) {
        const layerWrapper = event.detail.layerWrapper;
        const leftOption = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'option',
            text: layerWrapper.getName(),
            value: layerWrapper.getId().toString()
        });
        const rightOption = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'option',
            text: layerWrapper.getName(),
            value: layerWrapper.getId().toString()
        });
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(this.uiRefLeftSource, [
            leftOption
        ]);
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(this.uiRefRightSource, [
            rightOption
        ]);
    }
    doPreRender(event, map) {
        const context = event.context;
        const mapSize = map.getSize();
        // Calculate offset for the handlebar. 
        // The range slider is not perfectly linear towards the edges. 
        const halfHandleWidth = (0, $1e8c0ef90ed82280$export$a33e119b2316dcb7).getConfig().browser.rem;
        const sliderWidth = this.uiRefSplitViewSlider.offsetWidth;
        const sliderCenter = sliderWidth / 2;
        const percentOfRange = this.uiRefSplitViewSlider.value / (this.uiRefSplitViewSlider.max - this.uiRefSplitViewSlider.min);
        const valuePxPosition = percentOfRange * sliderWidth;
        const distFromCenter = valuePxPosition - sliderCenter;
        const percentDistFromCenter = distFromCenter / sliderCenter;
        const offset = percentDistFromCenter * halfHandleWidth;
        const mapWidth = mapSize[0];
        const mapHeight = mapSize[1];
        // Displaying two maps next to each other.
        const width = mapWidth * (this.uiRefSplitViewSlider.value / this.uiRefSplitViewSlider.max) - offset;
        const tl = (0, $806302f479c89a9b$export$5d5f40b190bc29f0)(event, [
            width,
            0
        ]);
        const tr = (0, $806302f479c89a9b$export$5d5f40b190bc29f0)(event, [
            mapWidth,
            0
        ]);
        const bl = (0, $806302f479c89a9b$export$5d5f40b190bc29f0)(event, [
            width,
            mapHeight
        ]);
        const br = (0, $806302f479c89a9b$export$5d5f40b190bc29f0)(event, [
            mapWidth,
            mapHeight
        ]);
        context.save();
        context.beginPath();
        context.moveTo(tl[0], tl[1]);
        context.lineTo(bl[0], bl[1]);
        context.lineTo(br[0], br[1]);
        context.lineTo(tr[0], tr[1]);
        context.closePath();
        context.clip();
    }
    doSwapLayerSides() {
        const currentRightId = this.uiRefRightSource.value;
        this.uiRefRightSource.value = this.uiRefLeftSource.value;
        this.uiRefLeftSource.value = currentRightId;
    }
    doDispatchChangeEvent() {
        (0, $96903e3f16465932$export$cc74486daaaef499).dispatchEvent([
            this.uiRefLeftSource,
            this.uiRefRightSource
        ], (0, $a9807b370eed025c$export$ada873a34909da65).browser.change);
    }
    doAddMapLayer(layer) {
        layer.setVisible(true);
        this.getMap().addLayer(layer);
    }
    doRemoveMapLayer(layer) {
        layer.setVisible(false);
        this.getMap().removeLayer(layer);
    }
    doUpdateTool(leftId, rightId) {
        // Note: 
        // Block access for events that are captured when the tool is not activated
        // Example removing a layer in the LayerTool
        if (!this.isActive) return;
        const map = this.getMap();
        if (!map) return;
        // Remove previously added listeners
        (0, $1f093ab5083c8a1f$export$b7ef3f8527533384)(this.onPreRenderListener);
        (0, $1f093ab5083c8a1f$export$b7ef3f8527533384)(this.onPostRenderListener);
        // Remove current layers from the map
        // Only the left and right layer will be added later
        (0, $e75fe1c51a3d360c$export$eff87c52915dd7fe).getMapLayers().forEach((layerWrapper)=>{
            this.doRemoveMapLayer(layerWrapper.getLayer());
        });
        // Get layers to view in split-mode
        const leftLayerWrapper = (0, $e75fe1c51a3d360c$export$eff87c52915dd7fe).getMapLayerById(leftId);
        const rightLayerWrapper = (0, $e75fe1c51a3d360c$export$eff87c52915dd7fe).getMapLayerById(rightId);
        // This should not happen, but just in case
        if (!leftLayerWrapper || !rightLayerWrapper) {
            this.setLoadingError();
            return;
        }
        const leftLayer = leftLayerWrapper.getLayer();
        const rightLayer = rightLayerWrapper.getLayer();
        this.doAddMapLayer(leftLayer);
        // Note: 
        // Only render right side layer if it is different from the left layer
        if (leftId !== rightId) {
            this.doAddMapLayer(rightLayer);
            // Attach listeners to the right layer
            // Pre/Post render will only show part of the right map
            this.onPreRenderListener = rightLayer.on((0, $a9807b370eed025c$export$ada873a34909da65).openLayers.preRender, this.#onPreRender.bind(this));
            this.onPostRenderListener = rightLayer.on((0, $a9807b370eed025c$export$ada873a34909da65).openLayers.postRender, this.#onPostRender.bind(this));
        }
        map.render();
    }
}



var $f1q41 = parcelRequire("f1q41");
var $5a197630e9446689$exports = {};
/*!
 * html2canvas 1.4.1 <https://html2canvas.hertzen.com>
 * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */ (function(global, factory) {
    $5a197630e9446689$exports = factory();
})($5a197630e9446689$exports, function() {
    'use strict';
    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */ /* global Reflect, Promise */ var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    function __extends(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }
    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for(var s, i = 1, n = arguments.length; i < n; i++){
                s = arguments[i];
                for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };
    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) {
            return value instanceof P ? value : new P(function(resolve) {
                resolve(value);
            });
        }
        return new (P || (P = Promise))(function(resolve, reject) {
            function fulfilled(value) {
                try {
                    step(generator.next(value));
                } catch (e) {
                    reject(e);
                }
            }
            function rejected(value) {
                try {
                    step(generator["throw"](value));
                } catch (e) {
                    reject(e);
                }
            }
            function step(result) {
                result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }
    function __generator(thisArg, body) {
        var _ = {
            label: 0,
            sent: function() {
                if (t[0] & 1) throw t[1];
                return t[1];
            },
            trys: [],
            ops: []
        }, f, y, t, g;
        return g = {
            next: verb(0),
            "throw": verb(1),
            "return": verb(2)
        }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
            return this;
        }), g;
        function verb(n) {
            return function(v) {
                return step([
                    n,
                    v
                ]);
            };
        }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while(_)try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [
                    op[0] & 2,
                    t.value
                ];
                switch(op[0]){
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return {
                            value: op[1],
                            done: false
                        };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [
                            0
                        ];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2]) _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            } catch (e) {
                op = [
                    6,
                    e
                ];
                y = 0;
            } finally{
                f = t = 0;
            }
            if (op[0] & 5) throw op[1];
            return {
                value: op[0] ? op[1] : void 0,
                done: true
            };
        }
    }
    function __spreadArray(to, from, pack) {
        if (pack || arguments.length === 2) {
            for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
                if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                ar[i] = from[i];
            }
        }
        return to.concat(ar || from);
    }
    var Bounds = /** @class */ function() {
        function Bounds(left, top, width, height) {
            this.left = left;
            this.top = top;
            this.width = width;
            this.height = height;
        }
        Bounds.prototype.add = function(x, y, w, h) {
            return new Bounds(this.left + x, this.top + y, this.width + w, this.height + h);
        };
        Bounds.fromClientRect = function(context, clientRect) {
            return new Bounds(clientRect.left + context.windowBounds.left, clientRect.top + context.windowBounds.top, clientRect.width, clientRect.height);
        };
        Bounds.fromDOMRectList = function(context, domRectList) {
            var domRect = Array.from(domRectList).find(function(rect) {
                return rect.width !== 0;
            });
            return domRect ? new Bounds(domRect.left + context.windowBounds.left, domRect.top + context.windowBounds.top, domRect.width, domRect.height) : Bounds.EMPTY;
        };
        Bounds.EMPTY = new Bounds(0, 0, 0, 0);
        return Bounds;
    }();
    var parseBounds = function(context, node) {
        return Bounds.fromClientRect(context, node.getBoundingClientRect());
    };
    var parseDocumentSize = function(document1) {
        var body = document1.body;
        var documentElement = document1.documentElement;
        if (!body || !documentElement) throw new Error("Unable to get document size");
        var width = Math.max(Math.max(body.scrollWidth, documentElement.scrollWidth), Math.max(body.offsetWidth, documentElement.offsetWidth), Math.max(body.clientWidth, documentElement.clientWidth));
        var height = Math.max(Math.max(body.scrollHeight, documentElement.scrollHeight), Math.max(body.offsetHeight, documentElement.offsetHeight), Math.max(body.clientHeight, documentElement.clientHeight));
        return new Bounds(0, 0, width, height);
    };
    /*
     * css-line-break 2.1.0 <https://github.com/niklasvh/css-line-break#readme>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var toCodePoints$1 = function(str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while(i < length){
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                else {
                    codePoints.push(value);
                    i--;
                }
            } else codePoints.push(value);
        }
        return codePoints;
    };
    var fromCodePoint$1 = function() {
        var codePoints = [];
        for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
        if (String.fromCodePoint) return String.fromCodePoint.apply(String, codePoints);
        var length = codePoints.length;
        if (!length) return '';
        var codeUnits = [];
        var index = -1;
        var result = '';
        while(++index < length){
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) codeUnits.push(codePoint);
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, codePoint % 0x400 + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var chars$2 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$2 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i$2 = 0; i$2 < chars$2.length; i$2++)lookup$2[chars$2.charCodeAt(i$2)] = i$2;
    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$1$1 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$1$1 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i$1$1 = 0; i$1$1 < chars$1$1.length; i$1$1++)lookup$1$1[chars$1$1.charCodeAt(i$1$1)] = i$1$1;
    var decode$1 = function(base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === '=') {
            bufferLength--;
            if (base64[base64.length - 2] === '=') bufferLength--;
        }
        var buffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined' && typeof Uint8Array.prototype.slice !== 'undefined' ? new ArrayBuffer(bufferLength) : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for(i = 0; i < len; i += 4){
            encoded1 = lookup$1$1[base64.charCodeAt(i)];
            encoded2 = lookup$1$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1$1[base64.charCodeAt(i + 3)];
            bytes[p++] = encoded1 << 2 | encoded2 >> 4;
            bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
            bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
        }
        return buffer;
    };
    var polyUint16Array$1 = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 2)bytes.push(buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    var polyUint32Array$1 = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 4)bytes.push(buffer[i + 3] << 24 | buffer[i + 2] << 16 | buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    /** Shift size for getting the index-2 table offset. */ var UTRIE2_SHIFT_2$1 = 5;
    /** Shift size for getting the index-1 table offset. */ var UTRIE2_SHIFT_1$1 = 11;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */ var UTRIE2_INDEX_SHIFT$1 = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */ var UTRIE2_SHIFT_1_2$1 = UTRIE2_SHIFT_1$1 - UTRIE2_SHIFT_2$1;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */ var UTRIE2_LSCP_INDEX_2_OFFSET$1 = 0x10000 >> UTRIE2_SHIFT_2$1;
    /** Number of entries in a data block. 32=0x20 */ var UTRIE2_DATA_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_2$1;
    /** Mask for getting the lower bits for the in-data-block offset. */ var UTRIE2_DATA_MASK$1 = UTRIE2_DATA_BLOCK_LENGTH$1 - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH$1 = 0x400 >> UTRIE2_SHIFT_2$1;
    /** Count the lengths of both BMP pieces. 2080=0x820 */ var UTRIE2_INDEX_2_BMP_LENGTH$1 = UTRIE2_LSCP_INDEX_2_OFFSET$1 + UTRIE2_LSCP_INDEX_2_LENGTH$1;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */ var UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 = UTRIE2_INDEX_2_BMP_LENGTH$1;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH$1 = 32; /* U+0800 is the first code point after 2-byte UTF-8 */ 
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */ var UTRIE2_INDEX_1_OFFSET$1 = UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 + UTRIE2_UTF8_2B_INDEX_2_LENGTH$1;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */ var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 = 0x10000 >> UTRIE2_SHIFT_1$1;
    /** Number of entries in an index-2 block. 64=0x40 */ var UTRIE2_INDEX_2_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_1_2$1;
    /** Mask for getting the lower bits for the in-index-2-block offset. */ var UTRIE2_INDEX_2_MASK$1 = UTRIE2_INDEX_2_BLOCK_LENGTH$1 - 1;
    var slice16$1 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32$1 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64$1 = function(base64, _byteLength) {
        var buffer = decode$1(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array$1(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array$1(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16$1(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2 ? slice16$1(view16, (headerLength + view32[4]) / 2) : slice32$1(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie$1(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie$1 = /** @class */ function() {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */ Trie.prototype.get = function(codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || codePoint > 0x0dbff && codePoint <= 0x0ffff) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2$1];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET$1 + (codePoint - 0xd800 >> UTRIE2_SHIFT_2$1)];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET$1 - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 + (codePoint >> UTRIE2_SHIFT_1$1);
                    ix = this.index[ix];
                    ix += codePoint >> UTRIE2_SHIFT_2$1 & UTRIE2_INDEX_2_MASK$1;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) return this.data[this.highValueIndex];
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }();
    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$3 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$3 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i$3 = 0; i$3 < chars$3.length; i$3++)lookup$3[chars$3.charCodeAt(i$3)] = i$3;
    var base64$1 = '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';
    var LETTER_NUMBER_MODIFIER = 50;
    // Non-tailorable Line Breaking Classes
    var BK = 1; //  Cause a line break (after)
    var CR$1 = 2; //  Cause a line break (after), except between CR and LF
    var LF$1 = 3; //  Cause a line break (after)
    var CM = 4; //  Prohibit a line break between the character and the preceding character
    var NL = 5; //  Cause a line break (after)
    var WJ = 7; //  Prohibit line breaks before and after
    var ZW = 8; //  Provide a break opportunity
    var GL = 9; //  Prohibit line breaks before and after
    var SP = 10; // Enable indirect line breaks
    var ZWJ$1 = 11; // Prohibit line breaks within joiner sequences
    // Break Opportunities
    var B2 = 12; //  Provide a line break opportunity before and after the character
    var BA = 13; //  Generally provide a line break opportunity after the character
    var BB = 14; //  Generally provide a line break opportunity before the character
    var HY = 15; //  Provide a line break opportunity after the character, except in numeric context
    var CB = 16; //   Provide a line break opportunity contingent on additional information
    // Characters Prohibiting Certain Breaks
    var CL = 17; //  Prohibit line breaks before
    var CP = 18; //  Prohibit line breaks before
    var EX = 19; //  Prohibit line breaks before
    var IN = 20; //  Allow only indirect line breaks between pairs
    var NS = 21; //  Allow only indirect line breaks before
    var OP = 22; //  Prohibit line breaks after
    var QU = 23; //  Act like they are both opening and closing
    // Numeric Context
    var IS = 24; //  Prevent breaks after any and before numeric
    var NU = 25; //  Form numeric expressions for line breaking purposes
    var PO = 26; //  Do not break following a numeric expression
    var PR = 27; //  Do not break in front of a numeric expression
    var SY = 28; //  Prevent a break before; and allow a break after
    // Other Characters
    var AI = 29; //  Act like AL when the resolvedEAW is N; otherwise; act as ID
    var AL = 30; //  Are alphabetic characters or symbols that are used with alphabetic characters
    var CJ = 31; //  Treat as NS or ID for strict or normal breaking.
    var EB = 32; //  Do not break from following Emoji Modifier
    var EM = 33; //  Do not break from preceding Emoji Base
    var H2 = 34; //  Form Korean syllable blocks
    var H3 = 35; //  Form Korean syllable blocks
    var HL = 36; //  Do not break around a following hyphen; otherwise act as Alphabetic
    var ID = 37; //  Break before or after; except in some numeric context
    var JL = 38; //  Form Korean syllable blocks
    var JV = 39; //  Form Korean syllable blocks
    var JT = 40; //  Form Korean syllable blocks
    var RI$1 = 41; //  Keep pairs together. For pairs; break before and after other classes
    var SA = 42; //  Provide a line break opportunity contingent on additional, language-specific context analysis
    var XX = 43; //  Have as yet unknown line breaking behavior or unassigned code positions
    var ea_OP = [
        0x2329,
        0xff08
    ];
    var BREAK_MANDATORY = '!';
    var BREAK_NOT_ALLOWED$1 = "\xd7";
    var BREAK_ALLOWED$1 = "\xf7";
    var UnicodeTrie$1 = createTrieFromBase64$1(base64$1);
    var ALPHABETICS = [
        AL,
        HL
    ];
    var HARD_LINE_BREAKS = [
        BK,
        CR$1,
        LF$1,
        NL
    ];
    var SPACE$1 = [
        SP,
        ZW
    ];
    var PREFIX_POSTFIX = [
        PR,
        PO
    ];
    var LINE_BREAKS = HARD_LINE_BREAKS.concat(SPACE$1);
    var KOREAN_SYLLABLE_BLOCK = [
        JL,
        JV,
        JT,
        H2,
        H3
    ];
    var HYPHEN = [
        HY,
        BA
    ];
    var codePointsToCharacterClasses = function(codePoints, lineBreak) {
        if (lineBreak === void 0) lineBreak = 'strict';
        var types = [];
        var indices = [];
        var categories = [];
        codePoints.forEach(function(codePoint, index) {
            var classType = UnicodeTrie$1.get(codePoint);
            if (classType > LETTER_NUMBER_MODIFIER) {
                categories.push(true);
                classType -= LETTER_NUMBER_MODIFIER;
            } else categories.push(false);
            if ([
                'normal',
                'auto',
                'loose'
            ].indexOf(lineBreak) !== -1) // U+2010, – U+2013, 〜 U+301C, ゠ U+30A0
            {
                if ([
                    0x2010,
                    0x2013,
                    0x301c,
                    0x30a0
                ].indexOf(codePoint) !== -1) {
                    indices.push(index);
                    return types.push(CB);
                }
            }
            if (classType === CM || classType === ZWJ$1) {
                // LB10 Treat any remaining combining mark or ZWJ as AL.
                if (index === 0) {
                    indices.push(index);
                    return types.push(AL);
                }
                // LB9 Do not break a combining character sequence; treat it as if it has the line breaking class of
                // the base character in all of the following rules. Treat ZWJ as if it were CM.
                var prev = types[index - 1];
                if (LINE_BREAKS.indexOf(prev) === -1) {
                    indices.push(indices[index - 1]);
                    return types.push(prev);
                }
                indices.push(index);
                return types.push(AL);
            }
            indices.push(index);
            if (classType === CJ) return types.push(lineBreak === 'strict' ? NS : ID);
            if (classType === SA) return types.push(AL);
            if (classType === AI) return types.push(AL);
            // For supplementary characters, a useful default is to treat characters in the range 10000..1FFFD as AL
            // and characters in the ranges 20000..2FFFD and 30000..3FFFD as ID, until the implementation can be revised
            // to take into account the actual line breaking properties for these characters.
            if (classType === XX) {
                if (codePoint >= 0x20000 && codePoint <= 0x2fffd || codePoint >= 0x30000 && codePoint <= 0x3fffd) return types.push(ID);
                else return types.push(AL);
            }
            types.push(classType);
        });
        return [
            indices,
            types,
            categories
        ];
    };
    var isAdjacentWithSpaceIgnored = function(a, b, currentIndex, classTypes) {
        var current = classTypes[currentIndex];
        if (Array.isArray(a) ? a.indexOf(current) !== -1 : a === current) {
            var i = currentIndex;
            while(i <= classTypes.length){
                i++;
                var next = classTypes[i];
                if (next === b) return true;
                if (next !== SP) break;
            }
        }
        if (current === SP) {
            var i = currentIndex;
            while(i > 0){
                i--;
                var prev = classTypes[i];
                if (Array.isArray(a) ? a.indexOf(prev) !== -1 : a === prev) {
                    var n = currentIndex;
                    while(n <= classTypes.length){
                        n++;
                        var next = classTypes[n];
                        if (next === b) return true;
                        if (next !== SP) break;
                    }
                }
                if (prev !== SP) break;
            }
        }
        return false;
    };
    var previousNonSpaceClassType = function(currentIndex, classTypes) {
        var i = currentIndex;
        while(i >= 0){
            var type = classTypes[i];
            if (type === SP) i--;
            else return type;
        }
        return 0;
    };
    var _lineBreakAtIndex = function(codePoints, classTypes, indicies, index, forbiddenBreaks) {
        if (indicies[index] === 0) return BREAK_NOT_ALLOWED$1;
        var currentIndex = index - 1;
        if (Array.isArray(forbiddenBreaks) && forbiddenBreaks[currentIndex] === true) return BREAK_NOT_ALLOWED$1;
        var beforeIndex = currentIndex - 1;
        var afterIndex = currentIndex + 1;
        var current = classTypes[currentIndex];
        // LB4 Always break after hard line breaks.
        // LB5 Treat CR followed by LF, as well as CR, LF, and NL as hard line breaks.
        var before = beforeIndex >= 0 ? classTypes[beforeIndex] : 0;
        var next = classTypes[afterIndex];
        if (current === CR$1 && next === LF$1) return BREAK_NOT_ALLOWED$1;
        if (HARD_LINE_BREAKS.indexOf(current) !== -1) return BREAK_MANDATORY;
        // LB6 Do not break before hard line breaks.
        if (HARD_LINE_BREAKS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB7 Do not break before spaces or zero width space.
        if (SPACE$1.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB8 Break before any character following a zero-width space, even if one or more spaces intervene.
        if (previousNonSpaceClassType(currentIndex, classTypes) === ZW) return BREAK_ALLOWED$1;
        // LB8a Do not break after a zero width joiner.
        if (UnicodeTrie$1.get(codePoints[currentIndex]) === ZWJ$1) return BREAK_NOT_ALLOWED$1;
        // zwj emojis
        if ((current === EB || current === EM) && UnicodeTrie$1.get(codePoints[afterIndex]) === ZWJ$1) return BREAK_NOT_ALLOWED$1;
        // LB11 Do not break before or after Word joiner and related characters.
        if (current === WJ || next === WJ) return BREAK_NOT_ALLOWED$1;
        // LB12 Do not break after NBSP and related characters.
        if (current === GL) return BREAK_NOT_ALLOWED$1;
        // LB12a Do not break before NBSP and related characters, except after spaces and hyphens.
        if ([
            SP,
            BA,
            HY
        ].indexOf(current) === -1 && next === GL) return BREAK_NOT_ALLOWED$1;
        // LB13 Do not break before ‘]’ or ‘!’ or ‘;’ or ‘/’, even after spaces.
        if ([
            CL,
            CP,
            EX,
            IS,
            SY
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB14 Do not break after ‘[’, even after spaces.
        if (previousNonSpaceClassType(currentIndex, classTypes) === OP) return BREAK_NOT_ALLOWED$1;
        // LB15 Do not break within ‘”[’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(QU, OP, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB16 Do not break between closing punctuation and a nonstarter (lb=NS), even with intervening spaces.
        if (isAdjacentWithSpaceIgnored([
            CL,
            CP
        ], NS, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB17 Do not break within ‘——’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(B2, B2, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB18 Break after spaces.
        if (current === SP) return BREAK_ALLOWED$1;
        // LB19 Do not break before or after quotation marks, such as ‘ ” ’.
        if (current === QU || next === QU) return BREAK_NOT_ALLOWED$1;
        // LB20 Break before and after unresolved CB.
        if (next === CB || current === CB) return BREAK_ALLOWED$1;
        // LB21 Do not break before hyphen-minus, other hyphens, fixed-width spaces, small kana, and other non-starters, or after acute accents.
        if ([
            BA,
            HY,
            NS
        ].indexOf(next) !== -1 || current === BB) return BREAK_NOT_ALLOWED$1;
        // LB21a Don't break after Hebrew + Hyphen.
        if (before === HL && HYPHEN.indexOf(current) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB21b Don’t break between Solidus and Hebrew letters.
        if (current === SY && next === HL) return BREAK_NOT_ALLOWED$1;
        // LB22 Do not break before ellipsis.
        if (next === IN) return BREAK_NOT_ALLOWED$1;
        // LB23 Do not break between digits and letters.
        if (ALPHABETICS.indexOf(next) !== -1 && current === NU || ALPHABETICS.indexOf(current) !== -1 && next === NU) return BREAK_NOT_ALLOWED$1;
        // LB23a Do not break between numeric prefixes and ideographs, or between ideographs and numeric postfixes.
        if (current === PR && [
            ID,
            EB,
            EM
        ].indexOf(next) !== -1 || [
            ID,
            EB,
            EM
        ].indexOf(current) !== -1 && next === PO) return BREAK_NOT_ALLOWED$1;
        // LB24 Do not break between numeric prefix/postfix and letters, or between letters and prefix/postfix.
        if (ALPHABETICS.indexOf(current) !== -1 && PREFIX_POSTFIX.indexOf(next) !== -1 || PREFIX_POSTFIX.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB25 Do not break between the following pairs of classes relevant to numbers:
        if (// (PR | PO) × ( OP | HY )? NU
        [
            PR,
            PO
        ].indexOf(current) !== -1 && (next === NU || [
            OP,
            HY
        ].indexOf(next) !== -1 && classTypes[afterIndex + 1] === NU) || // ( OP | HY ) × NU
        [
            OP,
            HY
        ].indexOf(current) !== -1 && next === NU || // NU ×	(NU | SY | IS)
        current === NU && [
            NU,
            SY,
            IS
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // NU (NU | SY | IS)* × (NU | SY | IS | CL | CP)
        if ([
            NU,
            SY,
            IS,
            CL,
            CP
        ].indexOf(next) !== -1) {
            var prevIndex = currentIndex;
            while(prevIndex >= 0){
                var type = classTypes[prevIndex];
                if (type === NU) return BREAK_NOT_ALLOWED$1;
                else if ([
                    SY,
                    IS
                ].indexOf(type) !== -1) prevIndex--;
                else break;
            }
        }
        // NU (NU | SY | IS)* (CL | CP)? × (PO | PR))
        if ([
            PR,
            PO
        ].indexOf(next) !== -1) {
            var prevIndex = [
                CL,
                CP
            ].indexOf(current) !== -1 ? beforeIndex : currentIndex;
            while(prevIndex >= 0){
                var type = classTypes[prevIndex];
                if (type === NU) return BREAK_NOT_ALLOWED$1;
                else if ([
                    SY,
                    IS
                ].indexOf(type) !== -1) prevIndex--;
                else break;
            }
        }
        // LB26 Do not break a Korean syllable.
        if (JL === current && [
            JL,
            JV,
            H2,
            H3
        ].indexOf(next) !== -1 || [
            JV,
            H2
        ].indexOf(current) !== -1 && [
            JV,
            JT
        ].indexOf(next) !== -1 || [
            JT,
            H3
        ].indexOf(current) !== -1 && next === JT) return BREAK_NOT_ALLOWED$1;
        // LB27 Treat a Korean Syllable Block the same as ID.
        if (KOREAN_SYLLABLE_BLOCK.indexOf(current) !== -1 && [
            IN,
            PO
        ].indexOf(next) !== -1 || KOREAN_SYLLABLE_BLOCK.indexOf(next) !== -1 && current === PR) return BREAK_NOT_ALLOWED$1;
        // LB28 Do not break between alphabetics (“at”).
        if (ALPHABETICS.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB29 Do not break between numeric punctuation and alphabetics (“e.g.”).
        if (current === IS && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB30 Do not break between letters, numbers, or ordinary symbols and opening or closing parentheses.
        if (ALPHABETICS.concat(NU).indexOf(current) !== -1 && next === OP && ea_OP.indexOf(codePoints[afterIndex]) === -1 || ALPHABETICS.concat(NU).indexOf(next) !== -1 && current === CP) return BREAK_NOT_ALLOWED$1;
        // LB30a Break between two regional indicator symbols if and only if there are an even number of regional
        // indicators preceding the position of the break.
        if (current === RI$1 && next === RI$1) {
            var i = indicies[currentIndex];
            var count = 1;
            while(i > 0){
                i--;
                if (classTypes[i] === RI$1) count++;
                else break;
            }
            if (count % 2 !== 0) return BREAK_NOT_ALLOWED$1;
        }
        // LB30b Do not break between an emoji base and an emoji modifier.
        if (current === EB && next === EM) return BREAK_NOT_ALLOWED$1;
        return BREAK_ALLOWED$1;
    };
    var cssFormattedClasses = function(codePoints, options) {
        if (!options) options = {
            lineBreak: 'normal',
            wordBreak: 'normal'
        };
        var _a = codePointsToCharacterClasses(codePoints, options.lineBreak), indicies = _a[0], classTypes = _a[1], isLetterNumber = _a[2];
        if (options.wordBreak === 'break-all' || options.wordBreak === 'break-word') classTypes = classTypes.map(function(type) {
            return [
                NU,
                AL,
                SA
            ].indexOf(type) !== -1 ? ID : type;
        });
        var forbiddenBreakpoints = options.wordBreak === 'keep-all' ? isLetterNumber.map(function(letterNumber, i) {
            return letterNumber && codePoints[i] >= 0x4e00 && codePoints[i] <= 0x9fff;
        }) : undefined;
        return [
            indicies,
            classTypes,
            forbiddenBreakpoints
        ];
    };
    var Break = /** @class */ function() {
        function Break(codePoints, lineBreak, start, end) {
            this.codePoints = codePoints;
            this.required = lineBreak === BREAK_MANDATORY;
            this.start = start;
            this.end = end;
        }
        Break.prototype.slice = function() {
            return fromCodePoint$1.apply(void 0, this.codePoints.slice(this.start, this.end));
        };
        return Break;
    }();
    var LineBreaker = function(str, options) {
        var codePoints = toCodePoints$1(str);
        var _a = cssFormattedClasses(codePoints, options), indicies = _a[0], classTypes = _a[1], forbiddenBreakpoints = _a[2];
        var length = codePoints.length;
        var lastEnd = 0;
        var nextIndex = 0;
        return {
            next: function() {
                if (nextIndex >= length) return {
                    done: true,
                    value: null
                };
                var lineBreak = BREAK_NOT_ALLOWED$1;
                while(nextIndex < length && (lineBreak = _lineBreakAtIndex(codePoints, classTypes, indicies, ++nextIndex, forbiddenBreakpoints)) === BREAK_NOT_ALLOWED$1);
                if (lineBreak !== BREAK_NOT_ALLOWED$1 || nextIndex === length) {
                    var value = new Break(codePoints, lineBreak, lastEnd, nextIndex);
                    lastEnd = nextIndex;
                    return {
                        value: value,
                        done: false
                    };
                }
                return {
                    done: true,
                    value: null
                };
            }
        };
    };
    // https://www.w3.org/TR/css-syntax-3
    var FLAG_UNRESTRICTED = 1;
    var FLAG_ID = 2;
    var FLAG_INTEGER = 4;
    var FLAG_NUMBER = 8;
    var LINE_FEED = 0x000a;
    var SOLIDUS = 0x002f;
    var REVERSE_SOLIDUS = 0x005c;
    var CHARACTER_TABULATION = 0x0009;
    var SPACE = 0x0020;
    var QUOTATION_MARK = 0x0022;
    var EQUALS_SIGN = 0x003d;
    var NUMBER_SIGN = 0x0023;
    var DOLLAR_SIGN = 0x0024;
    var PERCENTAGE_SIGN = 0x0025;
    var APOSTROPHE = 0x0027;
    var LEFT_PARENTHESIS = 0x0028;
    var RIGHT_PARENTHESIS = 0x0029;
    var LOW_LINE = 0x005f;
    var HYPHEN_MINUS = 0x002d;
    var EXCLAMATION_MARK = 0x0021;
    var LESS_THAN_SIGN = 0x003c;
    var GREATER_THAN_SIGN = 0x003e;
    var COMMERCIAL_AT = 0x0040;
    var LEFT_SQUARE_BRACKET = 0x005b;
    var RIGHT_SQUARE_BRACKET = 0x005d;
    var CIRCUMFLEX_ACCENT = 0x003d;
    var LEFT_CURLY_BRACKET = 0x007b;
    var QUESTION_MARK = 0x003f;
    var RIGHT_CURLY_BRACKET = 0x007d;
    var VERTICAL_LINE = 0x007c;
    var TILDE = 0x007e;
    var CONTROL = 0x0080;
    var REPLACEMENT_CHARACTER = 0xfffd;
    var ASTERISK = 0x002a;
    var PLUS_SIGN = 0x002b;
    var COMMA = 0x002c;
    var COLON = 0x003a;
    var SEMICOLON = 0x003b;
    var FULL_STOP = 0x002e;
    var NULL = 0x0000;
    var BACKSPACE = 0x0008;
    var LINE_TABULATION = 0x000b;
    var SHIFT_OUT = 0x000e;
    var INFORMATION_SEPARATOR_ONE = 0x001f;
    var DELETE = 0x007f;
    var EOF = -1;
    var ZERO = 0x0030;
    var a = 0x0061;
    var e = 0x0065;
    var f = 0x0066;
    var u = 0x0075;
    var z = 0x007a;
    var A = 0x0041;
    var E = 0x0045;
    var F = 0x0046;
    var U = 0x0055;
    var Z = 0x005a;
    var isDigit = function(codePoint) {
        return codePoint >= ZERO && codePoint <= 0x0039;
    };
    var isSurrogateCodePoint = function(codePoint) {
        return codePoint >= 0xd800 && codePoint <= 0xdfff;
    };
    var isHex = function(codePoint) {
        return isDigit(codePoint) || codePoint >= A && codePoint <= F || codePoint >= a && codePoint <= f;
    };
    var isLowerCaseLetter = function(codePoint) {
        return codePoint >= a && codePoint <= z;
    };
    var isUpperCaseLetter = function(codePoint) {
        return codePoint >= A && codePoint <= Z;
    };
    var isLetter = function(codePoint) {
        return isLowerCaseLetter(codePoint) || isUpperCaseLetter(codePoint);
    };
    var isNonASCIICodePoint = function(codePoint) {
        return codePoint >= CONTROL;
    };
    var isWhiteSpace = function(codePoint) {
        return codePoint === LINE_FEED || codePoint === CHARACTER_TABULATION || codePoint === SPACE;
    };
    var isNameStartCodePoint = function(codePoint) {
        return isLetter(codePoint) || isNonASCIICodePoint(codePoint) || codePoint === LOW_LINE;
    };
    var isNameCodePoint = function(codePoint) {
        return isNameStartCodePoint(codePoint) || isDigit(codePoint) || codePoint === HYPHEN_MINUS;
    };
    var isNonPrintableCodePoint = function(codePoint) {
        return codePoint >= NULL && codePoint <= BACKSPACE || codePoint === LINE_TABULATION || codePoint >= SHIFT_OUT && codePoint <= INFORMATION_SEPARATOR_ONE || codePoint === DELETE;
    };
    var isValidEscape = function(c1, c2) {
        if (c1 !== REVERSE_SOLIDUS) return false;
        return c2 !== LINE_FEED;
    };
    var isIdentifierStart = function(c1, c2, c3) {
        if (c1 === HYPHEN_MINUS) return isNameStartCodePoint(c2) || isValidEscape(c2, c3);
        else if (isNameStartCodePoint(c1)) return true;
        else if (c1 === REVERSE_SOLIDUS && isValidEscape(c1, c2)) return true;
        return false;
    };
    var isNumberStart = function(c1, c2, c3) {
        if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) {
            if (isDigit(c2)) return true;
            return c2 === FULL_STOP && isDigit(c3);
        }
        if (c1 === FULL_STOP) return isDigit(c2);
        return isDigit(c1);
    };
    var stringToNumber = function(codePoints) {
        var c = 0;
        var sign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) sign = -1;
            c++;
        }
        var integers = [];
        while(isDigit(codePoints[c]))integers.push(codePoints[c++]);
        var int = integers.length ? parseInt(fromCodePoint$1.apply(void 0, integers), 10) : 0;
        if (codePoints[c] === FULL_STOP) c++;
        var fraction = [];
        while(isDigit(codePoints[c]))fraction.push(codePoints[c++]);
        var fracd = fraction.length;
        var frac = fracd ? parseInt(fromCodePoint$1.apply(void 0, fraction), 10) : 0;
        if (codePoints[c] === E || codePoints[c] === e) c++;
        var expsign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) expsign = -1;
            c++;
        }
        var exponent = [];
        while(isDigit(codePoints[c]))exponent.push(codePoints[c++]);
        var exp = exponent.length ? parseInt(fromCodePoint$1.apply(void 0, exponent), 10) : 0;
        return sign * (int + frac * Math.pow(10, -fracd)) * Math.pow(10, expsign * exp);
    };
    var LEFT_PARENTHESIS_TOKEN = {
        type: 2 /* LEFT_PARENTHESIS_TOKEN */ 
    };
    var RIGHT_PARENTHESIS_TOKEN = {
        type: 3 /* RIGHT_PARENTHESIS_TOKEN */ 
    };
    var COMMA_TOKEN = {
        type: 4 /* COMMA_TOKEN */ 
    };
    var SUFFIX_MATCH_TOKEN = {
        type: 13 /* SUFFIX_MATCH_TOKEN */ 
    };
    var PREFIX_MATCH_TOKEN = {
        type: 8 /* PREFIX_MATCH_TOKEN */ 
    };
    var COLUMN_TOKEN = {
        type: 21 /* COLUMN_TOKEN */ 
    };
    var DASH_MATCH_TOKEN = {
        type: 9 /* DASH_MATCH_TOKEN */ 
    };
    var INCLUDE_MATCH_TOKEN = {
        type: 10 /* INCLUDE_MATCH_TOKEN */ 
    };
    var LEFT_CURLY_BRACKET_TOKEN = {
        type: 11 /* LEFT_CURLY_BRACKET_TOKEN */ 
    };
    var RIGHT_CURLY_BRACKET_TOKEN = {
        type: 12 /* RIGHT_CURLY_BRACKET_TOKEN */ 
    };
    var SUBSTRING_MATCH_TOKEN = {
        type: 14 /* SUBSTRING_MATCH_TOKEN */ 
    };
    var BAD_URL_TOKEN = {
        type: 23 /* BAD_URL_TOKEN */ 
    };
    var BAD_STRING_TOKEN = {
        type: 1 /* BAD_STRING_TOKEN */ 
    };
    var CDO_TOKEN = {
        type: 25 /* CDO_TOKEN */ 
    };
    var CDC_TOKEN = {
        type: 24 /* CDC_TOKEN */ 
    };
    var COLON_TOKEN = {
        type: 26 /* COLON_TOKEN */ 
    };
    var SEMICOLON_TOKEN = {
        type: 27 /* SEMICOLON_TOKEN */ 
    };
    var LEFT_SQUARE_BRACKET_TOKEN = {
        type: 28 /* LEFT_SQUARE_BRACKET_TOKEN */ 
    };
    var RIGHT_SQUARE_BRACKET_TOKEN = {
        type: 29 /* RIGHT_SQUARE_BRACKET_TOKEN */ 
    };
    var WHITESPACE_TOKEN = {
        type: 31 /* WHITESPACE_TOKEN */ 
    };
    var EOF_TOKEN = {
        type: 32 /* EOF_TOKEN */ 
    };
    var Tokenizer = /** @class */ function() {
        function Tokenizer() {
            this._value = [];
        }
        Tokenizer.prototype.write = function(chunk) {
            this._value = this._value.concat(toCodePoints$1(chunk));
        };
        Tokenizer.prototype.read = function() {
            var tokens = [];
            var token = this.consumeToken();
            while(token !== EOF_TOKEN){
                tokens.push(token);
                token = this.consumeToken();
            }
            return tokens;
        };
        Tokenizer.prototype.consumeToken = function() {
            var codePoint = this.consumeCodePoint();
            switch(codePoint){
                case QUOTATION_MARK:
                    return this.consumeStringToken(QUOTATION_MARK);
                case NUMBER_SIGN:
                    var c1 = this.peekCodePoint(0);
                    var c2 = this.peekCodePoint(1);
                    var c3 = this.peekCodePoint(2);
                    if (isNameCodePoint(c1) || isValidEscape(c2, c3)) {
                        var flags = isIdentifierStart(c1, c2, c3) ? FLAG_ID : FLAG_UNRESTRICTED;
                        var value = this.consumeName();
                        return {
                            type: 5 /* HASH_TOKEN */ ,
                            value: value,
                            flags: flags
                        };
                    }
                    break;
                case DOLLAR_SIGN:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUFFIX_MATCH_TOKEN;
                    }
                    break;
                case APOSTROPHE:
                    return this.consumeStringToken(APOSTROPHE);
                case LEFT_PARENTHESIS:
                    return LEFT_PARENTHESIS_TOKEN;
                case RIGHT_PARENTHESIS:
                    return RIGHT_PARENTHESIS_TOKEN;
                case ASTERISK:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUBSTRING_MATCH_TOKEN;
                    }
                    break;
                case PLUS_SIGN:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case COMMA:
                    return COMMA_TOKEN;
                case HYPHEN_MINUS:
                    var e1 = codePoint;
                    var e2 = this.peekCodePoint(0);
                    var e3 = this.peekCodePoint(1);
                    if (isNumberStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    if (isIdentifierStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    if (e2 === HYPHEN_MINUS && e3 === GREATER_THAN_SIGN) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDC_TOKEN;
                    }
                    break;
                case FULL_STOP:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case SOLIDUS:
                    if (this.peekCodePoint(0) === ASTERISK) {
                        this.consumeCodePoint();
                        while(true){
                            var c = this.consumeCodePoint();
                            if (c === ASTERISK) {
                                c = this.consumeCodePoint();
                                if (c === SOLIDUS) return this.consumeToken();
                            }
                            if (c === EOF) return this.consumeToken();
                        }
                    }
                    break;
                case COLON:
                    return COLON_TOKEN;
                case SEMICOLON:
                    return SEMICOLON_TOKEN;
                case LESS_THAN_SIGN:
                    if (this.peekCodePoint(0) === EXCLAMATION_MARK && this.peekCodePoint(1) === HYPHEN_MINUS && this.peekCodePoint(2) === HYPHEN_MINUS) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDO_TOKEN;
                    }
                    break;
                case COMMERCIAL_AT:
                    var a1 = this.peekCodePoint(0);
                    var a2 = this.peekCodePoint(1);
                    var a3 = this.peekCodePoint(2);
                    if (isIdentifierStart(a1, a2, a3)) {
                        var value = this.consumeName();
                        return {
                            type: 7 /* AT_KEYWORD_TOKEN */ ,
                            value: value
                        };
                    }
                    break;
                case LEFT_SQUARE_BRACKET:
                    return LEFT_SQUARE_BRACKET_TOKEN;
                case REVERSE_SOLIDUS:
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    break;
                case RIGHT_SQUARE_BRACKET:
                    return RIGHT_SQUARE_BRACKET_TOKEN;
                case CIRCUMFLEX_ACCENT:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return PREFIX_MATCH_TOKEN;
                    }
                    break;
                case LEFT_CURLY_BRACKET:
                    return LEFT_CURLY_BRACKET_TOKEN;
                case RIGHT_CURLY_BRACKET:
                    return RIGHT_CURLY_BRACKET_TOKEN;
                case u:
                case U:
                    var u1 = this.peekCodePoint(0);
                    var u2 = this.peekCodePoint(1);
                    if (u1 === PLUS_SIGN && (isHex(u2) || u2 === QUESTION_MARK)) {
                        this.consumeCodePoint();
                        this.consumeUnicodeRangeToken();
                    }
                    this.reconsumeCodePoint(codePoint);
                    return this.consumeIdentLikeToken();
                case VERTICAL_LINE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return DASH_MATCH_TOKEN;
                    }
                    if (this.peekCodePoint(0) === VERTICAL_LINE) {
                        this.consumeCodePoint();
                        return COLUMN_TOKEN;
                    }
                    break;
                case TILDE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return INCLUDE_MATCH_TOKEN;
                    }
                    break;
                case EOF:
                    return EOF_TOKEN;
            }
            if (isWhiteSpace(codePoint)) {
                this.consumeWhiteSpace();
                return WHITESPACE_TOKEN;
            }
            if (isDigit(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeNumericToken();
            }
            if (isNameStartCodePoint(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeIdentLikeToken();
            }
            return {
                type: 6 /* DELIM_TOKEN */ ,
                value: fromCodePoint$1(codePoint)
            };
        };
        Tokenizer.prototype.consumeCodePoint = function() {
            var value = this._value.shift();
            return typeof value === 'undefined' ? -1 : value;
        };
        Tokenizer.prototype.reconsumeCodePoint = function(codePoint) {
            this._value.unshift(codePoint);
        };
        Tokenizer.prototype.peekCodePoint = function(delta) {
            if (delta >= this._value.length) return -1;
            return this._value[delta];
        };
        Tokenizer.prototype.consumeUnicodeRangeToken = function() {
            var digits = [];
            var codePoint = this.consumeCodePoint();
            while(isHex(codePoint) && digits.length < 6){
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
            }
            var questionMarks = false;
            while(codePoint === QUESTION_MARK && digits.length < 6){
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
                questionMarks = true;
            }
            if (questionMarks) {
                var start_1 = parseInt(fromCodePoint$1.apply(void 0, digits.map(function(digit) {
                    return digit === QUESTION_MARK ? ZERO : digit;
                })), 16);
                var end = parseInt(fromCodePoint$1.apply(void 0, digits.map(function(digit) {
                    return digit === QUESTION_MARK ? F : digit;
                })), 16);
                return {
                    type: 30 /* UNICODE_RANGE_TOKEN */ ,
                    start: start_1,
                    end: end
                };
            }
            var start = parseInt(fromCodePoint$1.apply(void 0, digits), 16);
            if (this.peekCodePoint(0) === HYPHEN_MINUS && isHex(this.peekCodePoint(1))) {
                this.consumeCodePoint();
                codePoint = this.consumeCodePoint();
                var endDigits = [];
                while(isHex(codePoint) && endDigits.length < 6){
                    endDigits.push(codePoint);
                    codePoint = this.consumeCodePoint();
                }
                var end = parseInt(fromCodePoint$1.apply(void 0, endDigits), 16);
                return {
                    type: 30 /* UNICODE_RANGE_TOKEN */ ,
                    start: start,
                    end: end
                };
            } else return {
                type: 30 /* UNICODE_RANGE_TOKEN */ ,
                start: start,
                end: start
            };
        };
        Tokenizer.prototype.consumeIdentLikeToken = function() {
            var value = this.consumeName();
            if (value.toLowerCase() === 'url' && this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return this.consumeUrlToken();
            } else if (this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return {
                    type: 19 /* FUNCTION_TOKEN */ ,
                    value: value
                };
            }
            return {
                type: 20 /* IDENT_TOKEN */ ,
                value: value
            };
        };
        Tokenizer.prototype.consumeUrlToken = function() {
            var value = [];
            this.consumeWhiteSpace();
            if (this.peekCodePoint(0) === EOF) return {
                type: 22 /* URL_TOKEN */ ,
                value: ''
            };
            var next = this.peekCodePoint(0);
            if (next === APOSTROPHE || next === QUOTATION_MARK) {
                var stringToken = this.consumeStringToken(this.consumeCodePoint());
                if (stringToken.type === 0 /* STRING_TOKEN */ ) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return {
                            type: 22 /* URL_TOKEN */ ,
                            value: stringToken.value
                        };
                    }
                }
                this.consumeBadUrlRemnants();
                return BAD_URL_TOKEN;
            }
            while(true){
                var codePoint = this.consumeCodePoint();
                if (codePoint === EOF || codePoint === RIGHT_PARENTHESIS) return {
                    type: 22 /* URL_TOKEN */ ,
                    value: fromCodePoint$1.apply(void 0, value)
                };
                else if (isWhiteSpace(codePoint)) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return {
                            type: 22 /* URL_TOKEN */ ,
                            value: fromCodePoint$1.apply(void 0, value)
                        };
                    }
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                } else if (codePoint === QUOTATION_MARK || codePoint === APOSTROPHE || codePoint === LEFT_PARENTHESIS || isNonPrintableCodePoint(codePoint)) {
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                } else if (codePoint === REVERSE_SOLIDUS) {
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) value.push(this.consumeEscapedCodePoint());
                    else {
                        this.consumeBadUrlRemnants();
                        return BAD_URL_TOKEN;
                    }
                } else value.push(codePoint);
            }
        };
        Tokenizer.prototype.consumeWhiteSpace = function() {
            while(isWhiteSpace(this.peekCodePoint(0)))this.consumeCodePoint();
        };
        Tokenizer.prototype.consumeBadUrlRemnants = function() {
            while(true){
                var codePoint = this.consumeCodePoint();
                if (codePoint === RIGHT_PARENTHESIS || codePoint === EOF) return;
                if (isValidEscape(codePoint, this.peekCodePoint(0))) this.consumeEscapedCodePoint();
            }
        };
        Tokenizer.prototype.consumeStringSlice = function(count) {
            var SLICE_STACK_SIZE = 50000;
            var value = '';
            while(count > 0){
                var amount = Math.min(SLICE_STACK_SIZE, count);
                value += fromCodePoint$1.apply(void 0, this._value.splice(0, amount));
                count -= amount;
            }
            this._value.shift();
            return value;
        };
        Tokenizer.prototype.consumeStringToken = function(endingCodePoint) {
            var value = '';
            var i = 0;
            do {
                var codePoint = this._value[i];
                if (codePoint === EOF || codePoint === undefined || codePoint === endingCodePoint) {
                    value += this.consumeStringSlice(i);
                    return {
                        type: 0 /* STRING_TOKEN */ ,
                        value: value
                    };
                }
                if (codePoint === LINE_FEED) {
                    this._value.splice(0, i);
                    return BAD_STRING_TOKEN;
                }
                if (codePoint === REVERSE_SOLIDUS) {
                    var next = this._value[i + 1];
                    if (next !== EOF && next !== undefined) {
                        if (next === LINE_FEED) {
                            value += this.consumeStringSlice(i);
                            i = -1;
                            this._value.shift();
                        } else if (isValidEscape(codePoint, next)) {
                            value += this.consumeStringSlice(i);
                            value += fromCodePoint$1(this.consumeEscapedCodePoint());
                            i = -1;
                        }
                    }
                }
                i++;
            }while (true);
        };
        Tokenizer.prototype.consumeNumber = function() {
            var repr = [];
            var type = FLAG_INTEGER;
            var c1 = this.peekCodePoint(0);
            if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) repr.push(this.consumeCodePoint());
            while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            if (c1 === FULL_STOP && isDigit(c2)) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            }
            c1 = this.peekCodePoint(0);
            c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if ((c1 === E || c1 === e) && ((c2 === PLUS_SIGN || c2 === HYPHEN_MINUS) && isDigit(c3) || isDigit(c2))) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            }
            return [
                stringToNumber(repr),
                type
            ];
        };
        Tokenizer.prototype.consumeNumericToken = function() {
            var _a = this.consumeNumber(), number = _a[0], flags = _a[1];
            var c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if (isIdentifierStart(c1, c2, c3)) {
                var unit = this.consumeName();
                return {
                    type: 15 /* DIMENSION_TOKEN */ ,
                    number: number,
                    flags: flags,
                    unit: unit
                };
            }
            if (c1 === PERCENTAGE_SIGN) {
                this.consumeCodePoint();
                return {
                    type: 16 /* PERCENTAGE_TOKEN */ ,
                    number: number,
                    flags: flags
                };
            }
            return {
                type: 17 /* NUMBER_TOKEN */ ,
                number: number,
                flags: flags
            };
        };
        Tokenizer.prototype.consumeEscapedCodePoint = function() {
            var codePoint = this.consumeCodePoint();
            if (isHex(codePoint)) {
                var hex = fromCodePoint$1(codePoint);
                while(isHex(this.peekCodePoint(0)) && hex.length < 6)hex += fromCodePoint$1(this.consumeCodePoint());
                if (isWhiteSpace(this.peekCodePoint(0))) this.consumeCodePoint();
                var hexCodePoint = parseInt(hex, 16);
                if (hexCodePoint === 0 || isSurrogateCodePoint(hexCodePoint) || hexCodePoint > 0x10ffff) return REPLACEMENT_CHARACTER;
                return hexCodePoint;
            }
            if (codePoint === EOF) return REPLACEMENT_CHARACTER;
            return codePoint;
        };
        Tokenizer.prototype.consumeName = function() {
            var result = '';
            while(true){
                var codePoint = this.consumeCodePoint();
                if (isNameCodePoint(codePoint)) result += fromCodePoint$1(codePoint);
                else if (isValidEscape(codePoint, this.peekCodePoint(0))) result += fromCodePoint$1(this.consumeEscapedCodePoint());
                else {
                    this.reconsumeCodePoint(codePoint);
                    return result;
                }
            }
        };
        return Tokenizer;
    }();
    var Parser = /** @class */ function() {
        function Parser(tokens) {
            this._tokens = tokens;
        }
        Parser.create = function(value) {
            var tokenizer = new Tokenizer();
            tokenizer.write(value);
            return new Parser(tokenizer.read());
        };
        Parser.parseValue = function(value) {
            return Parser.create(value).parseComponentValue();
        };
        Parser.parseValues = function(value) {
            return Parser.create(value).parseComponentValues();
        };
        Parser.prototype.parseComponentValue = function() {
            var token = this.consumeToken();
            while(token.type === 31 /* WHITESPACE_TOKEN */ )token = this.consumeToken();
            if (token.type === 32 /* EOF_TOKEN */ ) throw new SyntaxError("Error parsing CSS component value, unexpected EOF");
            this.reconsumeToken(token);
            var value = this.consumeComponentValue();
            do token = this.consumeToken();
            while (token.type === 31 /* WHITESPACE_TOKEN */ );
            if (token.type === 32 /* EOF_TOKEN */ ) return value;
            throw new SyntaxError("Error parsing CSS component value, multiple values found when expecting only one");
        };
        Parser.prototype.parseComponentValues = function() {
            var values = [];
            while(true){
                var value = this.consumeComponentValue();
                if (value.type === 32 /* EOF_TOKEN */ ) return values;
                values.push(value);
                values.push();
            }
        };
        Parser.prototype.consumeComponentValue = function() {
            var token = this.consumeToken();
            switch(token.type){
                case 11 /* LEFT_CURLY_BRACKET_TOKEN */ :
                case 28 /* LEFT_SQUARE_BRACKET_TOKEN */ :
                case 2 /* LEFT_PARENTHESIS_TOKEN */ :
                    return this.consumeSimpleBlock(token.type);
                case 19 /* FUNCTION_TOKEN */ :
                    return this.consumeFunction(token);
            }
            return token;
        };
        Parser.prototype.consumeSimpleBlock = function(type) {
            var block = {
                type: type,
                values: []
            };
            var token = this.consumeToken();
            while(true){
                if (token.type === 32 /* EOF_TOKEN */  || isEndingTokenFor(token, type)) return block;
                this.reconsumeToken(token);
                block.values.push(this.consumeComponentValue());
                token = this.consumeToken();
            }
        };
        Parser.prototype.consumeFunction = function(functionToken) {
            var cssFunction = {
                name: functionToken.value,
                values: [],
                type: 18 /* FUNCTION */ 
            };
            while(true){
                var token = this.consumeToken();
                if (token.type === 32 /* EOF_TOKEN */  || token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */ ) return cssFunction;
                this.reconsumeToken(token);
                cssFunction.values.push(this.consumeComponentValue());
            }
        };
        Parser.prototype.consumeToken = function() {
            var token = this._tokens.shift();
            return typeof token === 'undefined' ? EOF_TOKEN : token;
        };
        Parser.prototype.reconsumeToken = function(token) {
            this._tokens.unshift(token);
        };
        return Parser;
    }();
    var isDimensionToken = function(token) {
        return token.type === 15 /* DIMENSION_TOKEN */ ;
    };
    var isNumberToken = function(token) {
        return token.type === 17 /* NUMBER_TOKEN */ ;
    };
    var isIdentToken = function(token) {
        return token.type === 20 /* IDENT_TOKEN */ ;
    };
    var isStringToken = function(token) {
        return token.type === 0 /* STRING_TOKEN */ ;
    };
    var isIdentWithValue = function(token, value) {
        return isIdentToken(token) && token.value === value;
    };
    var nonWhiteSpace = function(token) {
        return token.type !== 31 /* WHITESPACE_TOKEN */ ;
    };
    var nonFunctionArgSeparator = function(token) {
        return token.type !== 31 /* WHITESPACE_TOKEN */  && token.type !== 4 /* COMMA_TOKEN */ ;
    };
    var parseFunctionArgs = function(tokens) {
        var args = [];
        var arg = [];
        tokens.forEach(function(token) {
            if (token.type === 4 /* COMMA_TOKEN */ ) {
                if (arg.length === 0) throw new Error("Error parsing function args, zero tokens for arg");
                args.push(arg);
                arg = [];
                return;
            }
            if (token.type !== 31 /* WHITESPACE_TOKEN */ ) arg.push(token);
        });
        if (arg.length) args.push(arg);
        return args;
    };
    var isEndingTokenFor = function(token, type) {
        if (type === 11 /* LEFT_CURLY_BRACKET_TOKEN */  && token.type === 12 /* RIGHT_CURLY_BRACKET_TOKEN */ ) return true;
        if (type === 28 /* LEFT_SQUARE_BRACKET_TOKEN */  && token.type === 29 /* RIGHT_SQUARE_BRACKET_TOKEN */ ) return true;
        return type === 2 /* LEFT_PARENTHESIS_TOKEN */  && token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */ ;
    };
    var isLength = function(token) {
        return token.type === 17 /* NUMBER_TOKEN */  || token.type === 15 /* DIMENSION_TOKEN */ ;
    };
    var isLengthPercentage = function(token) {
        return token.type === 16 /* PERCENTAGE_TOKEN */  || isLength(token);
    };
    var parseLengthPercentageTuple = function(tokens) {
        return tokens.length > 1 ? [
            tokens[0],
            tokens[1]
        ] : [
            tokens[0]
        ];
    };
    var ZERO_LENGTH = {
        type: 17 /* NUMBER_TOKEN */ ,
        number: 0,
        flags: FLAG_INTEGER
    };
    var FIFTY_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 50,
        flags: FLAG_INTEGER
    };
    var HUNDRED_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 100,
        flags: FLAG_INTEGER
    };
    var getAbsoluteValueForTuple = function(tuple, width, height) {
        var x = tuple[0], y = tuple[1];
        return [
            getAbsoluteValue(x, width),
            getAbsoluteValue(typeof y !== 'undefined' ? y : x, height)
        ];
    };
    var getAbsoluteValue = function(token, parent) {
        if (token.type === 16 /* PERCENTAGE_TOKEN */ ) return token.number / 100 * parent;
        if (isDimensionToken(token)) switch(token.unit){
            case 'rem':
            case 'em':
                return 16 * token.number; // TODO use correct font-size
            case 'px':
            default:
                return token.number;
        }
        return token.number;
    };
    var DEG = 'deg';
    var GRAD = 'grad';
    var RAD = 'rad';
    var TURN = 'turn';
    var angle = {
        name: 'angle',
        parse: function(_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */ ) switch(value.unit){
                case DEG:
                    return Math.PI * value.number / 180;
                case GRAD:
                    return Math.PI / 200 * value.number;
                case RAD:
                    return value.number;
                case TURN:
                    return Math.PI * 2 * value.number;
            }
            throw new Error("Unsupported angle type");
        }
    };
    var isAngle = function(value) {
        if (value.type === 15 /* DIMENSION_TOKEN */ ) {
            if (value.unit === DEG || value.unit === GRAD || value.unit === RAD || value.unit === TURN) return true;
        }
        return false;
    };
    var parseNamedSide = function(tokens) {
        var sideOrCorner = tokens.filter(isIdentToken).map(function(ident) {
            return ident.value;
        }).join(' ');
        switch(sideOrCorner){
            case 'to bottom right':
            case 'to right bottom':
            case 'left top':
            case 'top left':
                return [
                    ZERO_LENGTH,
                    ZERO_LENGTH
                ];
            case 'to top':
            case 'bottom':
                return deg(0);
            case 'to bottom left':
            case 'to left bottom':
            case 'right top':
            case 'top right':
                return [
                    ZERO_LENGTH,
                    HUNDRED_PERCENT
                ];
            case 'to right':
            case 'left':
                return deg(90);
            case 'to top left':
            case 'to left top':
            case 'right bottom':
            case 'bottom right':
                return [
                    HUNDRED_PERCENT,
                    HUNDRED_PERCENT
                ];
            case 'to bottom':
            case 'top':
                return deg(180);
            case 'to top right':
            case 'to right top':
            case 'left bottom':
            case 'bottom left':
                return [
                    HUNDRED_PERCENT,
                    ZERO_LENGTH
                ];
            case 'to left':
            case 'right':
                return deg(270);
        }
        return 0;
    };
    var deg = function(deg) {
        return Math.PI * deg / 180;
    };
    var color$1 = {
        name: 'color',
        parse: function(context, value) {
            if (value.type === 18 /* FUNCTION */ ) {
                var colorFunction = SUPPORTED_COLOR_FUNCTIONS[value.name];
                if (typeof colorFunction === 'undefined') throw new Error("Attempting to parse an unsupported color function \"" + value.name + "\"");
                return colorFunction(context, value.values);
            }
            if (value.type === 5 /* HASH_TOKEN */ ) {
                if (value.value.length === 3) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), 1);
                }
                if (value.value.length === 4) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    var a = value.value.substring(3, 4);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), parseInt(a + a, 16) / 255);
                }
                if (value.value.length === 6) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), 1);
                }
                if (value.value.length === 8) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    var a = value.value.substring(6, 8);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), parseInt(a, 16) / 255);
                }
            }
            if (value.type === 20 /* IDENT_TOKEN */ ) {
                var namedColor = COLORS[value.value.toUpperCase()];
                if (typeof namedColor !== 'undefined') return namedColor;
            }
            return COLORS.TRANSPARENT;
        }
    };
    var isTransparent = function(color) {
        return (0xff & color) === 0;
    };
    var asString = function(color) {
        var alpha = 0xff & color;
        var blue = 0xff & color >> 8;
        var green = 0xff & color >> 16;
        var red = 0xff & color >> 24;
        return alpha < 255 ? "rgba(" + red + "," + green + "," + blue + "," + alpha / 255 + ")" : "rgb(" + red + "," + green + "," + blue + ")";
    };
    var pack = function(r, g, b, a) {
        return (r << 24 | g << 16 | b << 8 | Math.round(a * 255) << 0) >>> 0;
    };
    var getTokenColorValue = function(token, i) {
        if (token.type === 17 /* NUMBER_TOKEN */ ) return token.number;
        if (token.type === 16 /* PERCENTAGE_TOKEN */ ) {
            var max = i === 3 ? 1 : 255;
            return i === 3 ? token.number / 100 * max : Math.round(token.number / 100 * max);
        }
        return 0;
    };
    var rgb = function(_context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        if (tokens.length === 3) {
            var _a = tokens.map(getTokenColorValue), r = _a[0], g = _a[1], b = _a[2];
            return pack(r, g, b, 1);
        }
        if (tokens.length === 4) {
            var _b = tokens.map(getTokenColorValue), r = _b[0], g = _b[1], b = _b[2], a = _b[3];
            return pack(r, g, b, a);
        }
        return 0;
    };
    function hue2rgb(t1, t2, hue) {
        if (hue < 0) hue += 1;
        if (hue >= 1) hue -= 1;
        if (hue < 1 / 6) return (t2 - t1) * hue * 6 + t1;
        else if (hue < 0.5) return t2;
        else if (hue < 2 / 3) return (t2 - t1) * 6 * (2 / 3 - hue) + t1;
        else return t1;
    }
    var hsl = function(context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        var hue = tokens[0], saturation = tokens[1], lightness = tokens[2], alpha = tokens[3];
        var h = (hue.type === 17 /* NUMBER_TOKEN */  ? deg(hue.number) : angle.parse(context, hue)) / (Math.PI * 2);
        var s = isLengthPercentage(saturation) ? saturation.number / 100 : 0;
        var l = isLengthPercentage(lightness) ? lightness.number / 100 : 0;
        var a = typeof alpha !== 'undefined' && isLengthPercentage(alpha) ? getAbsoluteValue(alpha, 1) : 1;
        if (s === 0) return pack(l * 255, l * 255, l * 255, 1);
        var t2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
        var t1 = l * 2 - t2;
        var r = hue2rgb(t1, t2, h + 1 / 3);
        var g = hue2rgb(t1, t2, h);
        var b = hue2rgb(t1, t2, h - 1 / 3);
        return pack(r * 255, g * 255, b * 255, a);
    };
    var SUPPORTED_COLOR_FUNCTIONS = {
        hsl: hsl,
        hsla: hsl,
        rgb: rgb,
        rgba: rgb
    };
    var parseColor = function(context, value) {
        return color$1.parse(context, Parser.create(value).parseComponentValue());
    };
    var COLORS = {
        ALICEBLUE: 0xf0f8ffff,
        ANTIQUEWHITE: 0xfaebd7ff,
        AQUA: 0x00ffffff,
        AQUAMARINE: 0x7fffd4ff,
        AZURE: 0xf0ffffff,
        BEIGE: 0xf5f5dcff,
        BISQUE: 0xffe4c4ff,
        BLACK: 0x000000ff,
        BLANCHEDALMOND: 0xffebcdff,
        BLUE: 0x0000ffff,
        BLUEVIOLET: 0x8a2be2ff,
        BROWN: 0xa52a2aff,
        BURLYWOOD: 0xdeb887ff,
        CADETBLUE: 0x5f9ea0ff,
        CHARTREUSE: 0x7fff00ff,
        CHOCOLATE: 0xd2691eff,
        CORAL: 0xff7f50ff,
        CORNFLOWERBLUE: 0x6495edff,
        CORNSILK: 0xfff8dcff,
        CRIMSON: 0xdc143cff,
        CYAN: 0x00ffffff,
        DARKBLUE: 0x00008bff,
        DARKCYAN: 0x008b8bff,
        DARKGOLDENROD: 0xb886bbff,
        DARKGRAY: 0xa9a9a9ff,
        DARKGREEN: 0x006400ff,
        DARKGREY: 0xa9a9a9ff,
        DARKKHAKI: 0xbdb76bff,
        DARKMAGENTA: 0x8b008bff,
        DARKOLIVEGREEN: 0x556b2fff,
        DARKORANGE: 0xff8c00ff,
        DARKORCHID: 0x9932ccff,
        DARKRED: 0x8b0000ff,
        DARKSALMON: 0xe9967aff,
        DARKSEAGREEN: 0x8fbc8fff,
        DARKSLATEBLUE: 0x483d8bff,
        DARKSLATEGRAY: 0x2f4f4fff,
        DARKSLATEGREY: 0x2f4f4fff,
        DARKTURQUOISE: 0x00ced1ff,
        DARKVIOLET: 0x9400d3ff,
        DEEPPINK: 0xff1493ff,
        DEEPSKYBLUE: 0x00bfffff,
        DIMGRAY: 0x696969ff,
        DIMGREY: 0x696969ff,
        DODGERBLUE: 0x1e90ffff,
        FIREBRICK: 0xb22222ff,
        FLORALWHITE: 0xfffaf0ff,
        FORESTGREEN: 0x228b22ff,
        FUCHSIA: 0xff00ffff,
        GAINSBORO: 0xdcdcdcff,
        GHOSTWHITE: 0xf8f8ffff,
        GOLD: 0xffd700ff,
        GOLDENROD: 0xdaa520ff,
        GRAY: 0x808080ff,
        GREEN: 0x008000ff,
        GREENYELLOW: 0xadff2fff,
        GREY: 0x808080ff,
        HONEYDEW: 0xf0fff0ff,
        HOTPINK: 0xff69b4ff,
        INDIANRED: 0xcd5c5cff,
        INDIGO: 0x4b0082ff,
        IVORY: 0xfffff0ff,
        KHAKI: 0xf0e68cff,
        LAVENDER: 0xe6e6faff,
        LAVENDERBLUSH: 0xfff0f5ff,
        LAWNGREEN: 0x7cfc00ff,
        LEMONCHIFFON: 0xfffacdff,
        LIGHTBLUE: 0xadd8e6ff,
        LIGHTCORAL: 0xf08080ff,
        LIGHTCYAN: 0xe0ffffff,
        LIGHTGOLDENRODYELLOW: 0xfafad2ff,
        LIGHTGRAY: 0xd3d3d3ff,
        LIGHTGREEN: 0x90ee90ff,
        LIGHTGREY: 0xd3d3d3ff,
        LIGHTPINK: 0xffb6c1ff,
        LIGHTSALMON: 0xffa07aff,
        LIGHTSEAGREEN: 0x20b2aaff,
        LIGHTSKYBLUE: 0x87cefaff,
        LIGHTSLATEGRAY: 0x778899ff,
        LIGHTSLATEGREY: 0x778899ff,
        LIGHTSTEELBLUE: 0xb0c4deff,
        LIGHTYELLOW: 0xffffe0ff,
        LIME: 0x00ff00ff,
        LIMEGREEN: 0x32cd32ff,
        LINEN: 0xfaf0e6ff,
        MAGENTA: 0xff00ffff,
        MAROON: 0x800000ff,
        MEDIUMAQUAMARINE: 0x66cdaaff,
        MEDIUMBLUE: 0x0000cdff,
        MEDIUMORCHID: 0xba55d3ff,
        MEDIUMPURPLE: 0x9370dbff,
        MEDIUMSEAGREEN: 0x3cb371ff,
        MEDIUMSLATEBLUE: 0x7b68eeff,
        MEDIUMSPRINGGREEN: 0x00fa9aff,
        MEDIUMTURQUOISE: 0x48d1ccff,
        MEDIUMVIOLETRED: 0xc71585ff,
        MIDNIGHTBLUE: 0x191970ff,
        MINTCREAM: 0xf5fffaff,
        MISTYROSE: 0xffe4e1ff,
        MOCCASIN: 0xffe4b5ff,
        NAVAJOWHITE: 0xffdeadff,
        NAVY: 0x000080ff,
        OLDLACE: 0xfdf5e6ff,
        OLIVE: 0x808000ff,
        OLIVEDRAB: 0x6b8e23ff,
        ORANGE: 0xffa500ff,
        ORANGERED: 0xff4500ff,
        ORCHID: 0xda70d6ff,
        PALEGOLDENROD: 0xeee8aaff,
        PALEGREEN: 0x98fb98ff,
        PALETURQUOISE: 0xafeeeeff,
        PALEVIOLETRED: 0xdb7093ff,
        PAPAYAWHIP: 0xffefd5ff,
        PEACHPUFF: 0xffdab9ff,
        PERU: 0xcd853fff,
        PINK: 0xffc0cbff,
        PLUM: 0xdda0ddff,
        POWDERBLUE: 0xb0e0e6ff,
        PURPLE: 0x800080ff,
        REBECCAPURPLE: 0x663399ff,
        RED: 0xff0000ff,
        ROSYBROWN: 0xbc8f8fff,
        ROYALBLUE: 0x4169e1ff,
        SADDLEBROWN: 0x8b4513ff,
        SALMON: 0xfa8072ff,
        SANDYBROWN: 0xf4a460ff,
        SEAGREEN: 0x2e8b57ff,
        SEASHELL: 0xfff5eeff,
        SIENNA: 0xa0522dff,
        SILVER: 0xc0c0c0ff,
        SKYBLUE: 0x87ceebff,
        SLATEBLUE: 0x6a5acdff,
        SLATEGRAY: 0x708090ff,
        SLATEGREY: 0x708090ff,
        SNOW: 0xfffafaff,
        SPRINGGREEN: 0x00ff7fff,
        STEELBLUE: 0x4682b4ff,
        TAN: 0xd2b48cff,
        TEAL: 0x008080ff,
        THISTLE: 0xd8bfd8ff,
        TOMATO: 0xff6347ff,
        TRANSPARENT: 0x00000000,
        TURQUOISE: 0x40e0d0ff,
        VIOLET: 0xee82eeff,
        WHEAT: 0xf5deb3ff,
        WHITE: 0xffffffff,
        WHITESMOKE: 0xf5f5f5ff,
        YELLOW: 0xffff00ff,
        YELLOWGREEN: 0x9acd32ff
    };
    var backgroundClip = {
        name: 'background-clip',
        initialValue: 'border-box',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.map(function(token) {
                if (isIdentToken(token)) switch(token.value){
                    case 'padding-box':
                        return 1 /* PADDING_BOX */ ;
                    case 'content-box':
                        return 2 /* CONTENT_BOX */ ;
                }
                return 0 /* BORDER_BOX */ ;
            });
        }
    };
    var backgroundColor = {
        name: "background-color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'color'
    };
    var parseColorStop = function(context, args) {
        var color = color$1.parse(context, args[0]);
        var stop = args[1];
        return stop && isLengthPercentage(stop) ? {
            color: color,
            stop: stop
        } : {
            color: color,
            stop: null
        };
    };
    var processColorStops = function(stops, lineLength) {
        var first = stops[0];
        var last = stops[stops.length - 1];
        if (first.stop === null) first.stop = ZERO_LENGTH;
        if (last.stop === null) last.stop = HUNDRED_PERCENT;
        var processStops = [];
        var previous = 0;
        for(var i = 0; i < stops.length; i++){
            var stop_1 = stops[i].stop;
            if (stop_1 !== null) {
                var absoluteValue = getAbsoluteValue(stop_1, lineLength);
                if (absoluteValue > previous) processStops.push(absoluteValue);
                else processStops.push(previous);
                previous = absoluteValue;
            } else processStops.push(null);
        }
        var gapBegin = null;
        for(var i = 0; i < processStops.length; i++){
            var stop_2 = processStops[i];
            if (stop_2 === null) {
                if (gapBegin === null) gapBegin = i;
            } else if (gapBegin !== null) {
                var gapLength = i - gapBegin;
                var beforeGap = processStops[gapBegin - 1];
                var gapValue = (stop_2 - beforeGap) / (gapLength + 1);
                for(var g = 1; g <= gapLength; g++)processStops[gapBegin + g - 1] = gapValue * g;
                gapBegin = null;
            }
        }
        return stops.map(function(_a, i) {
            var color = _a.color;
            return {
                color: color,
                stop: Math.max(Math.min(1, processStops[i] / lineLength), 0)
            };
        });
    };
    var getAngleFromCorner = function(corner, width, height) {
        var centerX = width / 2;
        var centerY = height / 2;
        var x = getAbsoluteValue(corner[0], width) - centerX;
        var y = centerY - getAbsoluteValue(corner[1], height);
        return (Math.atan2(y, x) + Math.PI * 2) % (Math.PI * 2);
    };
    var calculateGradientDirection = function(angle, width, height) {
        var radian = typeof angle === 'number' ? angle : getAngleFromCorner(angle, width, height);
        var lineLength = Math.abs(width * Math.sin(radian)) + Math.abs(height * Math.cos(radian));
        var halfWidth = width / 2;
        var halfHeight = height / 2;
        var halfLineLength = lineLength / 2;
        var yDiff = Math.sin(radian - Math.PI / 2) * halfLineLength;
        var xDiff = Math.cos(radian - Math.PI / 2) * halfLineLength;
        return [
            lineLength,
            halfWidth - xDiff,
            halfWidth + xDiff,
            halfHeight - yDiff,
            halfHeight + yDiff
        ];
    };
    var distance = function(a, b) {
        return Math.sqrt(a * a + b * b);
    };
    var findCorner = function(width, height, x, y, closest) {
        var corners = [
            [
                0,
                0
            ],
            [
                0,
                height
            ],
            [
                width,
                0
            ],
            [
                width,
                height
            ]
        ];
        return corners.reduce(function(stat, corner) {
            var cx = corner[0], cy = corner[1];
            var d = distance(x - cx, y - cy);
            if (closest ? d < stat.optimumDistance : d > stat.optimumDistance) return {
                optimumCorner: corner,
                optimumDistance: d
            };
            return stat;
        }, {
            optimumDistance: closest ? Infinity : -Infinity,
            optimumCorner: null
        }).optimumCorner;
    };
    var calculateRadius = function(gradient, x, y, width, height) {
        var rx = 0;
        var ry = 0;
        switch(gradient.size){
            case 0 /* CLOSEST_SIDE */ :
                // The ending shape is sized so that that it exactly meets the side of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, it exactly meets the closest side in each dimension.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.min(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    rx = Math.min(Math.abs(x), Math.abs(x - width));
                    ry = Math.min(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 2 /* CLOSEST_CORNER */ :
                // The ending shape is sized so that that it passes through the corner of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, the ending shape is given the same aspect-ratio it would have if closest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.min(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    // Compute the ratio ry/rx (which is to be the same as for "closest-side")
                    var c = Math.min(Math.abs(y), Math.abs(y - height)) / Math.min(Math.abs(x), Math.abs(x - width));
                    var _a = findCorner(width, height, x, y, true), cx = _a[0], cy = _a[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
            case 1 /* FARTHEST_SIDE */ :
                // Same as closest-side, except the ending shape is sized based on the farthest side(s)
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.max(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    rx = Math.max(Math.abs(x), Math.abs(x - width));
                    ry = Math.max(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 3 /* FARTHEST_CORNER */ :
                // Same as closest-corner, except the ending shape is sized based on the farthest corner.
                // If the shape is an ellipse, the ending shape is given the same aspect ratio it would have if farthest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.max(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    // Compute the ratio ry/rx (which is to be the same as for "farthest-side")
                    var c = Math.max(Math.abs(y), Math.abs(y - height)) / Math.max(Math.abs(x), Math.abs(x - width));
                    var _b = findCorner(width, height, x, y, false), cx = _b[0], cy = _b[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
        }
        if (Array.isArray(gradient.size)) {
            rx = getAbsoluteValue(gradient.size[0], width);
            ry = gradient.size.length === 2 ? getAbsoluteValue(gradient.size[1], height) : rx;
        }
        return [
            rx,
            ry
        ];
    };
    var linearGradient = function(context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */  && firstToken.value === 'to') {
                    angle$1 = parseNamedSide(arg);
                    return;
                } else if (isAngle(firstToken)) {
                    angle$1 = angle.parse(context, firstToken);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return {
            angle: angle$1,
            stops: stops,
            type: 1 /* LINEAR_GRADIENT */ 
        };
    };
    var prefixLinearGradient = function(context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */  && [
                    'top',
                    'left',
                    'right',
                    'bottom'
                ].indexOf(firstToken.value) !== -1) {
                    angle$1 = parseNamedSide(arg);
                    return;
                } else if (isAngle(firstToken)) {
                    angle$1 = (angle.parse(context, firstToken) + deg(270)) % deg(360);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return {
            angle: angle$1,
            stops: stops,
            type: 1 /* LINEAR_GRADIENT */ 
        };
    };
    var webkitGradient = function(context, tokens) {
        var angle = deg(180);
        var stops = [];
        var type = 1 /* LINEAR_GRADIENT */ ;
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var firstToken = arg[0];
            if (i === 0) {
                if (isIdentToken(firstToken) && firstToken.value === 'linear') {
                    type = 1 /* LINEAR_GRADIENT */ ;
                    return;
                } else if (isIdentToken(firstToken) && firstToken.value === 'radial') {
                    type = 2 /* RADIAL_GRADIENT */ ;
                    return;
                }
            }
            if (firstToken.type === 18 /* FUNCTION */ ) {
                if (firstToken.name === 'from') {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({
                        stop: ZERO_LENGTH,
                        color: color
                    });
                } else if (firstToken.name === 'to') {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({
                        stop: HUNDRED_PERCENT,
                        color: color
                    });
                } else if (firstToken.name === 'color-stop') {
                    var values = firstToken.values.filter(nonFunctionArgSeparator);
                    if (values.length === 2) {
                        var color = color$1.parse(context, values[1]);
                        var stop_1 = values[0];
                        if (isNumberToken(stop_1)) stops.push({
                            stop: {
                                type: 16 /* PERCENTAGE_TOKEN */ ,
                                number: stop_1.number * 100,
                                flags: stop_1.flags
                            },
                            color: color
                        });
                    }
                }
            }
        });
        return type === 1 /* LINEAR_GRADIENT */  ? {
            angle: (angle + deg(180)) % deg(360),
            stops: stops,
            type: type
        } : {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: type
        };
    };
    var CLOSEST_SIDE = 'closest-side';
    var FARTHEST_SIDE = 'farthest-side';
    var CLOSEST_CORNER = 'closest-corner';
    var FARTHEST_CORNER = 'farthest-corner';
    var CIRCLE = 'circle';
    var ELLIPSE = 'ellipse';
    var COVER = 'cover';
    var CONTAIN = 'contain';
    var radialGradient = function(context, tokens) {
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var isColorStop = true;
            if (i === 0) {
                var isAtPosition_1 = false;
                isColorStop = arg.reduce(function(acc, token) {
                    if (isAtPosition_1) {
                        if (isIdentToken(token)) switch(token.value){
                            case 'center':
                                position.push(FIFTY_PERCENT);
                                return acc;
                            case 'top':
                            case 'left':
                                position.push(ZERO_LENGTH);
                                return acc;
                            case 'right':
                            case 'bottom':
                                position.push(HUNDRED_PERCENT);
                                return acc;
                        }
                        else if (isLengthPercentage(token) || isLength(token)) position.push(token);
                    } else if (isIdentToken(token)) switch(token.value){
                        case CIRCLE:
                            shape = 0 /* CIRCLE */ ;
                            return false;
                        case ELLIPSE:
                            shape = 1 /* ELLIPSE */ ;
                            return false;
                        case 'at':
                            isAtPosition_1 = true;
                            return false;
                        case CLOSEST_SIDE:
                            size = 0 /* CLOSEST_SIDE */ ;
                            return false;
                        case COVER:
                        case FARTHEST_SIDE:
                            size = 1 /* FARTHEST_SIDE */ ;
                            return false;
                        case CONTAIN:
                        case CLOSEST_CORNER:
                            size = 2 /* CLOSEST_CORNER */ ;
                            return false;
                        case FARTHEST_CORNER:
                            size = 3 /* FARTHEST_CORNER */ ;
                            return false;
                    }
                    else if (isLength(token) || isLengthPercentage(token)) {
                        if (!Array.isArray(size)) size = [];
                        size.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: 2 /* RADIAL_GRADIENT */ 
        };
    };
    var prefixRadialGradient = function(context, tokens) {
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var isColorStop = true;
            if (i === 0) isColorStop = arg.reduce(function(acc, token) {
                if (isIdentToken(token)) switch(token.value){
                    case 'center':
                        position.push(FIFTY_PERCENT);
                        return false;
                    case 'top':
                    case 'left':
                        position.push(ZERO_LENGTH);
                        return false;
                    case 'right':
                    case 'bottom':
                        position.push(HUNDRED_PERCENT);
                        return false;
                }
                else if (isLengthPercentage(token) || isLength(token)) {
                    position.push(token);
                    return false;
                }
                return acc;
            }, isColorStop);
            else if (i === 1) isColorStop = arg.reduce(function(acc, token) {
                if (isIdentToken(token)) switch(token.value){
                    case CIRCLE:
                        shape = 0 /* CIRCLE */ ;
                        return false;
                    case ELLIPSE:
                        shape = 1 /* ELLIPSE */ ;
                        return false;
                    case CONTAIN:
                    case CLOSEST_SIDE:
                        size = 0 /* CLOSEST_SIDE */ ;
                        return false;
                    case FARTHEST_SIDE:
                        size = 1 /* FARTHEST_SIDE */ ;
                        return false;
                    case CLOSEST_CORNER:
                        size = 2 /* CLOSEST_CORNER */ ;
                        return false;
                    case COVER:
                    case FARTHEST_CORNER:
                        size = 3 /* FARTHEST_CORNER */ ;
                        return false;
                }
                else if (isLength(token) || isLengthPercentage(token)) {
                    if (!Array.isArray(size)) size = [];
                    size.push(token);
                    return false;
                }
                return acc;
            }, isColorStop);
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: 2 /* RADIAL_GRADIENT */ 
        };
    };
    var isLinearGradient = function(background) {
        return background.type === 1 /* LINEAR_GRADIENT */ ;
    };
    var isRadialGradient = function(background) {
        return background.type === 2 /* RADIAL_GRADIENT */ ;
    };
    var image = {
        name: 'image',
        parse: function(context, value) {
            if (value.type === 22 /* URL_TOKEN */ ) {
                var image_1 = {
                    url: value.value,
                    type: 0 /* URL */ 
                };
                context.cache.addImage(value.value);
                return image_1;
            }
            if (value.type === 18 /* FUNCTION */ ) {
                var imageFunction = SUPPORTED_IMAGE_FUNCTIONS[value.name];
                if (typeof imageFunction === 'undefined') throw new Error("Attempting to parse an unsupported image function \"" + value.name + "\"");
                return imageFunction(context, value.values);
            }
            throw new Error("Unsupported image type " + value.type);
        }
    };
    function isSupportedImage(value) {
        return !(value.type === 20 /* IDENT_TOKEN */  && value.value === 'none') && (value.type !== 18 /* FUNCTION */  || !!SUPPORTED_IMAGE_FUNCTIONS[value.name]);
    }
    var SUPPORTED_IMAGE_FUNCTIONS = {
        'linear-gradient': linearGradient,
        '-moz-linear-gradient': prefixLinearGradient,
        '-ms-linear-gradient': prefixLinearGradient,
        '-o-linear-gradient': prefixLinearGradient,
        '-webkit-linear-gradient': prefixLinearGradient,
        'radial-gradient': radialGradient,
        '-moz-radial-gradient': prefixRadialGradient,
        '-ms-radial-gradient': prefixRadialGradient,
        '-o-radial-gradient': prefixRadialGradient,
        '-webkit-radial-gradient': prefixRadialGradient,
        '-webkit-gradient': webkitGradient
    };
    var backgroundImage = {
        name: 'background-image',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(context, tokens) {
            if (tokens.length === 0) return [];
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === 'none') return [];
            return tokens.filter(function(value) {
                return nonFunctionArgSeparator(value) && isSupportedImage(value);
            }).map(function(value) {
                return image.parse(context, value);
            });
        }
    };
    var backgroundOrigin = {
        name: 'background-origin',
        initialValue: 'border-box',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.map(function(token) {
                if (isIdentToken(token)) switch(token.value){
                    case 'padding-box':
                        return 1 /* PADDING_BOX */ ;
                    case 'content-box':
                        return 2 /* CONTENT_BOX */ ;
                }
                return 0 /* BORDER_BOX */ ;
            });
        }
    };
    var backgroundPosition = {
        name: 'background-position',
        initialValue: '0% 0%',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isLengthPercentage);
            }).map(parseLengthPercentageTuple);
        }
    };
    var backgroundRepeat = {
        name: 'background-repeat',
        initialValue: 'repeat',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isIdentToken).map(function(token) {
                    return token.value;
                }).join(' ');
            }).map(parseBackgroundRepeat);
        }
    };
    var parseBackgroundRepeat = function(value) {
        switch(value){
            case 'no-repeat':
                return 1 /* NO_REPEAT */ ;
            case 'repeat-x':
            case 'repeat no-repeat':
                return 2 /* REPEAT_X */ ;
            case 'repeat-y':
            case 'no-repeat repeat':
                return 3 /* REPEAT_Y */ ;
            case 'repeat':
            default:
                return 0 /* REPEAT */ ;
        }
    };
    var BACKGROUND_SIZE;
    (function(BACKGROUND_SIZE) {
        BACKGROUND_SIZE["AUTO"] = "auto";
        BACKGROUND_SIZE["CONTAIN"] = "contain";
        BACKGROUND_SIZE["COVER"] = "cover";
    })(BACKGROUND_SIZE || (BACKGROUND_SIZE = {}));
    var backgroundSize = {
        name: 'background-size',
        initialValue: '0',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isBackgroundSizeInfoToken);
            });
        }
    };
    var isBackgroundSizeInfoToken = function(value) {
        return isIdentToken(value) || isLengthPercentage(value);
    };
    var borderColorForSide = function(side) {
        return {
            name: "border-" + side + "-color",
            initialValue: 'transparent',
            prefix: false,
            type: 3 /* TYPE_VALUE */ ,
            format: 'color'
        };
    };
    var borderTopColor = borderColorForSide('top');
    var borderRightColor = borderColorForSide('right');
    var borderBottomColor = borderColorForSide('bottom');
    var borderLeftColor = borderColorForSide('left');
    var borderRadiusForSide = function(side) {
        return {
            name: "border-radius-" + side,
            initialValue: '0 0',
            prefix: false,
            type: 1 /* LIST */ ,
            parse: function(_context, tokens) {
                return parseLengthPercentageTuple(tokens.filter(isLengthPercentage));
            }
        };
    };
    var borderTopLeftRadius = borderRadiusForSide('top-left');
    var borderTopRightRadius = borderRadiusForSide('top-right');
    var borderBottomRightRadius = borderRadiusForSide('bottom-right');
    var borderBottomLeftRadius = borderRadiusForSide('bottom-left');
    var borderStyleForSide = function(side) {
        return {
            name: "border-" + side + "-style",
            initialValue: 'solid',
            prefix: false,
            type: 2 /* IDENT_VALUE */ ,
            parse: function(_context, style) {
                switch(style){
                    case 'none':
                        return 0 /* NONE */ ;
                    case 'dashed':
                        return 2 /* DASHED */ ;
                    case 'dotted':
                        return 3 /* DOTTED */ ;
                    case 'double':
                        return 4 /* DOUBLE */ ;
                }
                return 1 /* SOLID */ ;
            }
        };
    };
    var borderTopStyle = borderStyleForSide('top');
    var borderRightStyle = borderStyleForSide('right');
    var borderBottomStyle = borderStyleForSide('bottom');
    var borderLeftStyle = borderStyleForSide('left');
    var borderWidthForSide = function(side) {
        return {
            name: "border-" + side + "-width",
            initialValue: '0',
            type: 0 /* VALUE */ ,
            prefix: false,
            parse: function(_context, token) {
                if (isDimensionToken(token)) return token.number;
                return 0;
            }
        };
    };
    var borderTopWidth = borderWidthForSide('top');
    var borderRightWidth = borderWidthForSide('right');
    var borderBottomWidth = borderWidthForSide('bottom');
    var borderLeftWidth = borderWidthForSide('left');
    var color = {
        name: "color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'color'
    };
    var direction = {
        name: 'direction',
        initialValue: 'ltr',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, direction) {
            switch(direction){
                case 'rtl':
                    return 1 /* RTL */ ;
                case 'ltr':
                default:
                    return 0 /* LTR */ ;
            }
        }
    };
    var display = {
        name: 'display',
        initialValue: 'inline-block',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).reduce(function(bit, token) {
                return bit | parseDisplayValue(token.value);
            }, 0 /* NONE */ );
        }
    };
    var parseDisplayValue = function(display) {
        switch(display){
            case 'block':
            case '-webkit-box':
                return 2 /* BLOCK */ ;
            case 'inline':
                return 4 /* INLINE */ ;
            case 'run-in':
                return 8 /* RUN_IN */ ;
            case 'flow':
                return 16 /* FLOW */ ;
            case 'flow-root':
                return 32 /* FLOW_ROOT */ ;
            case 'table':
                return 64 /* TABLE */ ;
            case 'flex':
            case '-webkit-flex':
                return 128 /* FLEX */ ;
            case 'grid':
            case '-ms-grid':
                return 256 /* GRID */ ;
            case 'ruby':
                return 512 /* RUBY */ ;
            case 'subgrid':
                return 1024 /* SUBGRID */ ;
            case 'list-item':
                return 2048 /* LIST_ITEM */ ;
            case 'table-row-group':
                return 4096 /* TABLE_ROW_GROUP */ ;
            case 'table-header-group':
                return 8192 /* TABLE_HEADER_GROUP */ ;
            case 'table-footer-group':
                return 16384 /* TABLE_FOOTER_GROUP */ ;
            case 'table-row':
                return 32768 /* TABLE_ROW */ ;
            case 'table-cell':
                return 65536 /* TABLE_CELL */ ;
            case 'table-column-group':
                return 131072 /* TABLE_COLUMN_GROUP */ ;
            case 'table-column':
                return 262144 /* TABLE_COLUMN */ ;
            case 'table-caption':
                return 524288 /* TABLE_CAPTION */ ;
            case 'ruby-base':
                return 1048576 /* RUBY_BASE */ ;
            case 'ruby-text':
                return 2097152 /* RUBY_TEXT */ ;
            case 'ruby-base-container':
                return 4194304 /* RUBY_BASE_CONTAINER */ ;
            case 'ruby-text-container':
                return 8388608 /* RUBY_TEXT_CONTAINER */ ;
            case 'contents':
                return 16777216 /* CONTENTS */ ;
            case 'inline-block':
                return 33554432 /* INLINE_BLOCK */ ;
            case 'inline-list-item':
                return 67108864 /* INLINE_LIST_ITEM */ ;
            case 'inline-table':
                return 134217728 /* INLINE_TABLE */ ;
            case 'inline-flex':
                return 268435456 /* INLINE_FLEX */ ;
            case 'inline-grid':
                return 536870912 /* INLINE_GRID */ ;
        }
        return 0 /* NONE */ ;
    };
    var float = {
        name: 'float',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, float) {
            switch(float){
                case 'left':
                    return 1 /* LEFT */ ;
                case 'right':
                    return 2 /* RIGHT */ ;
                case 'inline-start':
                    return 3 /* INLINE_START */ ;
                case 'inline-end':
                    return 4 /* INLINE_END */ ;
            }
            return 0 /* NONE */ ;
        }
    };
    var letterSpacing = {
        name: 'letter-spacing',
        initialValue: '0',
        prefix: false,
        type: 0 /* VALUE */ ,
        parse: function(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === 'normal') return 0;
            if (token.type === 17 /* NUMBER_TOKEN */ ) return token.number;
            if (token.type === 15 /* DIMENSION_TOKEN */ ) return token.number;
            return 0;
        }
    };
    var LINE_BREAK;
    (function(LINE_BREAK) {
        LINE_BREAK["NORMAL"] = "normal";
        LINE_BREAK["STRICT"] = "strict";
    })(LINE_BREAK || (LINE_BREAK = {}));
    var lineBreak = {
        name: 'line-break',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, lineBreak) {
            switch(lineBreak){
                case 'strict':
                    return LINE_BREAK.STRICT;
                case 'normal':
                default:
                    return LINE_BREAK.NORMAL;
            }
        }
    };
    var lineHeight = {
        name: 'line-height',
        initialValue: 'normal',
        prefix: false,
        type: 4 /* TOKEN_VALUE */ 
    };
    var computeLineHeight = function(token, fontSize) {
        if (isIdentToken(token) && token.value === 'normal') return 1.2 * fontSize;
        else if (token.type === 17 /* NUMBER_TOKEN */ ) return fontSize * token.number;
        else if (isLengthPercentage(token)) return getAbsoluteValue(token, fontSize);
        return fontSize;
    };
    var listStyleImage = {
        name: 'list-style-image',
        initialValue: 'none',
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === 'none') return null;
            return image.parse(context, token);
        }
    };
    var listStylePosition = {
        name: 'list-style-position',
        initialValue: 'outside',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, position) {
            switch(position){
                case 'inside':
                    return 0 /* INSIDE */ ;
                case 'outside':
                default:
                    return 1 /* OUTSIDE */ ;
            }
        }
    };
    var listStyleType = {
        name: 'list-style-type',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, type) {
            switch(type){
                case 'disc':
                    return 0 /* DISC */ ;
                case 'circle':
                    return 1 /* CIRCLE */ ;
                case 'square':
                    return 2 /* SQUARE */ ;
                case 'decimal':
                    return 3 /* DECIMAL */ ;
                case 'cjk-decimal':
                    return 4 /* CJK_DECIMAL */ ;
                case 'decimal-leading-zero':
                    return 5 /* DECIMAL_LEADING_ZERO */ ;
                case 'lower-roman':
                    return 6 /* LOWER_ROMAN */ ;
                case 'upper-roman':
                    return 7 /* UPPER_ROMAN */ ;
                case 'lower-greek':
                    return 8 /* LOWER_GREEK */ ;
                case 'lower-alpha':
                    return 9 /* LOWER_ALPHA */ ;
                case 'upper-alpha':
                    return 10 /* UPPER_ALPHA */ ;
                case 'arabic-indic':
                    return 11 /* ARABIC_INDIC */ ;
                case 'armenian':
                    return 12 /* ARMENIAN */ ;
                case 'bengali':
                    return 13 /* BENGALI */ ;
                case 'cambodian':
                    return 14 /* CAMBODIAN */ ;
                case 'cjk-earthly-branch':
                    return 15 /* CJK_EARTHLY_BRANCH */ ;
                case 'cjk-heavenly-stem':
                    return 16 /* CJK_HEAVENLY_STEM */ ;
                case 'cjk-ideographic':
                    return 17 /* CJK_IDEOGRAPHIC */ ;
                case 'devanagari':
                    return 18 /* DEVANAGARI */ ;
                case 'ethiopic-numeric':
                    return 19 /* ETHIOPIC_NUMERIC */ ;
                case 'georgian':
                    return 20 /* GEORGIAN */ ;
                case 'gujarati':
                    return 21 /* GUJARATI */ ;
                case 'gurmukhi':
                    return 22 /* GURMUKHI */ ;
                case 'hebrew':
                    return 22 /* HEBREW */ ;
                case 'hiragana':
                    return 23 /* HIRAGANA */ ;
                case 'hiragana-iroha':
                    return 24 /* HIRAGANA_IROHA */ ;
                case 'japanese-formal':
                    return 25 /* JAPANESE_FORMAL */ ;
                case 'japanese-informal':
                    return 26 /* JAPANESE_INFORMAL */ ;
                case 'kannada':
                    return 27 /* KANNADA */ ;
                case 'katakana':
                    return 28 /* KATAKANA */ ;
                case 'katakana-iroha':
                    return 29 /* KATAKANA_IROHA */ ;
                case 'khmer':
                    return 30 /* KHMER */ ;
                case 'korean-hangul-formal':
                    return 31 /* KOREAN_HANGUL_FORMAL */ ;
                case 'korean-hanja-formal':
                    return 32 /* KOREAN_HANJA_FORMAL */ ;
                case 'korean-hanja-informal':
                    return 33 /* KOREAN_HANJA_INFORMAL */ ;
                case 'lao':
                    return 34 /* LAO */ ;
                case 'lower-armenian':
                    return 35 /* LOWER_ARMENIAN */ ;
                case 'malayalam':
                    return 36 /* MALAYALAM */ ;
                case 'mongolian':
                    return 37 /* MONGOLIAN */ ;
                case 'myanmar':
                    return 38 /* MYANMAR */ ;
                case 'oriya':
                    return 39 /* ORIYA */ ;
                case 'persian':
                    return 40 /* PERSIAN */ ;
                case 'simp-chinese-formal':
                    return 41 /* SIMP_CHINESE_FORMAL */ ;
                case 'simp-chinese-informal':
                    return 42 /* SIMP_CHINESE_INFORMAL */ ;
                case 'tamil':
                    return 43 /* TAMIL */ ;
                case 'telugu':
                    return 44 /* TELUGU */ ;
                case 'thai':
                    return 45 /* THAI */ ;
                case 'tibetan':
                    return 46 /* TIBETAN */ ;
                case 'trad-chinese-formal':
                    return 47 /* TRAD_CHINESE_FORMAL */ ;
                case 'trad-chinese-informal':
                    return 48 /* TRAD_CHINESE_INFORMAL */ ;
                case 'upper-armenian':
                    return 49 /* UPPER_ARMENIAN */ ;
                case 'disclosure-open':
                    return 50 /* DISCLOSURE_OPEN */ ;
                case 'disclosure-closed':
                    return 51 /* DISCLOSURE_CLOSED */ ;
                case 'none':
                default:
                    return -1 /* NONE */ ;
            }
        }
    };
    var marginForSide = function(side) {
        return {
            name: "margin-" + side,
            initialValue: '0',
            prefix: false,
            type: 4 /* TOKEN_VALUE */ 
        };
    };
    var marginTop = marginForSide('top');
    var marginRight = marginForSide('right');
    var marginBottom = marginForSide('bottom');
    var marginLeft = marginForSide('left');
    var overflow = {
        name: 'overflow',
        initialValue: 'visible',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(overflow) {
                switch(overflow.value){
                    case 'hidden':
                        return 1 /* HIDDEN */ ;
                    case 'scroll':
                        return 2 /* SCROLL */ ;
                    case 'clip':
                        return 3 /* CLIP */ ;
                    case 'auto':
                        return 4 /* AUTO */ ;
                    case 'visible':
                    default:
                        return 0 /* VISIBLE */ ;
                }
            });
        }
    };
    var overflowWrap = {
        name: 'overflow-wrap',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, overflow) {
            switch(overflow){
                case 'break-word':
                    return "break-word" /* BREAK_WORD */ ;
                case 'normal':
                default:
                    return "normal" /* NORMAL */ ;
            }
        }
    };
    var paddingForSide = function(side) {
        return {
            name: "padding-" + side,
            initialValue: '0',
            prefix: false,
            type: 3 /* TYPE_VALUE */ ,
            format: 'length-percentage'
        };
    };
    var paddingTop = paddingForSide('top');
    var paddingRight = paddingForSide('right');
    var paddingBottom = paddingForSide('bottom');
    var paddingLeft = paddingForSide('left');
    var textAlign = {
        name: 'text-align',
        initialValue: 'left',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, textAlign) {
            switch(textAlign){
                case 'right':
                    return 2 /* RIGHT */ ;
                case 'center':
                case 'justify':
                    return 1 /* CENTER */ ;
                case 'left':
                default:
                    return 0 /* LEFT */ ;
            }
        }
    };
    var position = {
        name: 'position',
        initialValue: 'static',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, position) {
            switch(position){
                case 'relative':
                    return 1 /* RELATIVE */ ;
                case 'absolute':
                    return 2 /* ABSOLUTE */ ;
                case 'fixed':
                    return 3 /* FIXED */ ;
                case 'sticky':
                    return 4 /* STICKY */ ;
            }
            return 0 /* STATIC */ ;
        }
    };
    var textShadow = {
        name: 'text-shadow',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) return [];
            return parseFunctionArgs(tokens).map(function(values) {
                var shadow = {
                    color: COLORS.TRANSPARENT,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH
                };
                var c = 0;
                for(var i = 0; i < values.length; i++){
                    var token = values[i];
                    if (isLength(token)) {
                        if (c === 0) shadow.offsetX = token;
                        else if (c === 1) shadow.offsetY = token;
                        else shadow.blur = token;
                        c++;
                    } else shadow.color = color$1.parse(context, token);
                }
                return shadow;
            });
        }
    };
    var textTransform = {
        name: 'text-transform',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, textTransform) {
            switch(textTransform){
                case 'uppercase':
                    return 2 /* UPPERCASE */ ;
                case 'lowercase':
                    return 1 /* LOWERCASE */ ;
                case 'capitalize':
                    return 3 /* CAPITALIZE */ ;
            }
            return 0 /* NONE */ ;
        }
    };
    var transform$1 = {
        name: 'transform',
        initialValue: 'none',
        prefix: true,
        type: 0 /* VALUE */ ,
        parse: function(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === 'none') return null;
            if (token.type === 18 /* FUNCTION */ ) {
                var transformFunction = SUPPORTED_TRANSFORM_FUNCTIONS[token.name];
                if (typeof transformFunction === 'undefined') throw new Error("Attempting to parse an unsupported transform function \"" + token.name + "\"");
                return transformFunction(token.values);
            }
            return null;
        }
    };
    var matrix = function(args) {
        var values = args.filter(function(arg) {
            return arg.type === 17 /* NUMBER_TOKEN */ ;
        }).map(function(arg) {
            return arg.number;
        });
        return values.length === 6 ? values : null;
    };
    // doesn't support 3D transforms at the moment
    var matrix3d = function(args) {
        var values = args.filter(function(arg) {
            return arg.type === 17 /* NUMBER_TOKEN */ ;
        }).map(function(arg) {
            return arg.number;
        });
        var a1 = values[0], b1 = values[1];
        values[2];
        values[3];
        var a2 = values[4], b2 = values[5];
        values[6];
        values[7];
        values[8];
        values[9];
        values[10];
        values[11];
        var a4 = values[12], b4 = values[13];
        values[14];
        values[15];
        return values.length === 16 ? [
            a1,
            b1,
            a2,
            b2,
            a4,
            b4
        ] : null;
    };
    var SUPPORTED_TRANSFORM_FUNCTIONS = {
        matrix: matrix,
        matrix3d: matrix3d
    };
    var DEFAULT_VALUE = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 50,
        flags: FLAG_INTEGER
    };
    var DEFAULT = [
        DEFAULT_VALUE,
        DEFAULT_VALUE
    ];
    var transformOrigin = {
        name: 'transform-origin',
        initialValue: '50% 50%',
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            var origins = tokens.filter(isLengthPercentage);
            if (origins.length !== 2) return DEFAULT;
            return [
                origins[0],
                origins[1]
            ];
        }
    };
    var visibility = {
        name: 'visible',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, visibility) {
            switch(visibility){
                case 'hidden':
                    return 1 /* HIDDEN */ ;
                case 'collapse':
                    return 2 /* COLLAPSE */ ;
                case 'visible':
                default:
                    return 0 /* VISIBLE */ ;
            }
        }
    };
    var WORD_BREAK;
    (function(WORD_BREAK) {
        WORD_BREAK["NORMAL"] = "normal";
        WORD_BREAK["BREAK_ALL"] = "break-all";
        WORD_BREAK["KEEP_ALL"] = "keep-all";
    })(WORD_BREAK || (WORD_BREAK = {}));
    var wordBreak = {
        name: 'word-break',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, wordBreak) {
            switch(wordBreak){
                case 'break-all':
                    return WORD_BREAK.BREAK_ALL;
                case 'keep-all':
                    return WORD_BREAK.KEEP_ALL;
                case 'normal':
                default:
                    return WORD_BREAK.NORMAL;
            }
        }
    };
    var zIndex = {
        name: 'z-index',
        initialValue: 'auto',
        prefix: false,
        type: 0 /* VALUE */ ,
        parse: function(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */ ) return {
                auto: true,
                order: 0
            };
            if (isNumberToken(token)) return {
                auto: false,
                order: token.number
            };
            throw new Error("Invalid z-index number parsed");
        }
    };
    var time = {
        name: 'time',
        parse: function(_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */ ) switch(value.unit.toLowerCase()){
                case 's':
                    return 1000 * value.number;
                case 'ms':
                    return value.number;
            }
            throw new Error("Unsupported time type");
        }
    };
    var opacity = {
        name: 'opacity',
        initialValue: '1',
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(_context, token) {
            if (isNumberToken(token)) return token.number;
            return 1;
        }
    };
    var textDecorationColor = {
        name: "text-decoration-color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'color'
    };
    var textDecorationLine = {
        name: 'text-decoration-line',
        initialValue: 'none',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(token) {
                switch(token.value){
                    case 'underline':
                        return 1 /* UNDERLINE */ ;
                    case 'overline':
                        return 2 /* OVERLINE */ ;
                    case 'line-through':
                        return 3 /* LINE_THROUGH */ ;
                    case 'none':
                        return 4 /* BLINK */ ;
                }
                return 0 /* NONE */ ;
            }).filter(function(line) {
                return line !== 0 /* NONE */ ;
            });
        }
    };
    var fontFamily = {
        name: "font-family",
        initialValue: '',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            var accumulator = [];
            var results = [];
            tokens.forEach(function(token) {
                switch(token.type){
                    case 20 /* IDENT_TOKEN */ :
                    case 0 /* STRING_TOKEN */ :
                        accumulator.push(token.value);
                        break;
                    case 17 /* NUMBER_TOKEN */ :
                        accumulator.push(token.number.toString());
                        break;
                    case 4 /* COMMA_TOKEN */ :
                        results.push(accumulator.join(' '));
                        accumulator.length = 0;
                        break;
                }
            });
            if (accumulator.length) results.push(accumulator.join(' '));
            return results.map(function(result) {
                return result.indexOf(' ') === -1 ? result : "'" + result + "'";
            });
        }
    };
    var fontSize = {
        name: "font-size",
        initialValue: '0',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'length'
    };
    var fontWeight = {
        name: 'font-weight',
        initialValue: 'normal',
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(_context, token) {
            if (isNumberToken(token)) return token.number;
            if (isIdentToken(token)) switch(token.value){
                case 'bold':
                    return 700;
                case 'normal':
                default:
                    return 400;
            }
            return 400;
        }
    };
    var fontVariant = {
        name: 'font-variant',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(token) {
                return token.value;
            });
        }
    };
    var fontStyle = {
        name: 'font-style',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, overflow) {
            switch(overflow){
                case 'oblique':
                    return "oblique" /* OBLIQUE */ ;
                case 'italic':
                    return "italic" /* ITALIC */ ;
                case 'normal':
                default:
                    return "normal" /* NORMAL */ ;
            }
        }
    };
    var contains = function(bit, value) {
        return (bit & value) !== 0;
    };
    var content = {
        name: 'content',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return [];
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === 'none') return [];
            return tokens;
        }
    };
    var counterIncrement = {
        name: 'counter-increment',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return null;
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === 'none') return null;
            var increments = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for(var i = 0; i < filtered.length; i++){
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (counter.type === 20 /* IDENT_TOKEN */ ) {
                    var increment = next && isNumberToken(next) ? next.number : 1;
                    increments.push({
                        counter: counter.value,
                        increment: increment
                    });
                }
            }
            return increments;
        }
    };
    var counterReset = {
        name: 'counter-reset',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return [];
            var resets = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for(var i = 0; i < filtered.length; i++){
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (isIdentToken(counter) && counter.value !== 'none') {
                    var reset = next && isNumberToken(next) ? next.number : 0;
                    resets.push({
                        counter: counter.value,
                        reset: reset
                    });
                }
            }
            return resets;
        }
    };
    var duration = {
        name: 'duration',
        initialValue: '0s',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(context, tokens) {
            return tokens.filter(isDimensionToken).map(function(token) {
                return time.parse(context, token);
            });
        }
    };
    var quotes = {
        name: 'quotes',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return null;
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === 'none') return null;
            var quotes = [];
            var filtered = tokens.filter(isStringToken);
            if (filtered.length % 2 !== 0) return null;
            for(var i = 0; i < filtered.length; i += 2){
                var open_1 = filtered[i].value;
                var close_1 = filtered[i + 1].value;
                quotes.push({
                    open: open_1,
                    close: close_1
                });
            }
            return quotes;
        }
    };
    var getQuote = function(quotes, depth, open) {
        if (!quotes) return '';
        var quote = quotes[Math.min(depth, quotes.length - 1)];
        if (!quote) return '';
        return open ? quote.open : quote.close;
    };
    var boxShadow = {
        name: 'box-shadow',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) return [];
            return parseFunctionArgs(tokens).map(function(values) {
                var shadow = {
                    color: 0x000000ff,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH,
                    spread: ZERO_LENGTH,
                    inset: false
                };
                var c = 0;
                for(var i = 0; i < values.length; i++){
                    var token = values[i];
                    if (isIdentWithValue(token, 'inset')) shadow.inset = true;
                    else if (isLength(token)) {
                        if (c === 0) shadow.offsetX = token;
                        else if (c === 1) shadow.offsetY = token;
                        else if (c === 2) shadow.blur = token;
                        else shadow.spread = token;
                        c++;
                    } else shadow.color = color$1.parse(context, token);
                }
                return shadow;
            });
        }
    };
    var paintOrder = {
        name: 'paint-order',
        initialValue: 'normal',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            var DEFAULT_VALUE = [
                0 /* FILL */ ,
                1 /* STROKE */ ,
                2 /* MARKERS */ 
            ];
            var layers = [];
            tokens.filter(isIdentToken).forEach(function(token) {
                switch(token.value){
                    case 'stroke':
                        layers.push(1 /* STROKE */ );
                        break;
                    case 'fill':
                        layers.push(0 /* FILL */ );
                        break;
                    case 'markers':
                        layers.push(2 /* MARKERS */ );
                        break;
                }
            });
            DEFAULT_VALUE.forEach(function(value) {
                if (layers.indexOf(value) === -1) layers.push(value);
            });
            return layers;
        }
    };
    var webkitTextStrokeColor = {
        name: "-webkit-text-stroke-color",
        initialValue: 'currentcolor',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'color'
    };
    var webkitTextStrokeWidth = {
        name: "-webkit-text-stroke-width",
        initialValue: '0',
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(_context, token) {
            if (isDimensionToken(token)) return token.number;
            return 0;
        }
    };
    var CSSParsedDeclaration = /** @class */ function() {
        function CSSParsedDeclaration(context, declaration) {
            var _a, _b;
            this.animationDuration = parse(context, duration, declaration.animationDuration);
            this.backgroundClip = parse(context, backgroundClip, declaration.backgroundClip);
            this.backgroundColor = parse(context, backgroundColor, declaration.backgroundColor);
            this.backgroundImage = parse(context, backgroundImage, declaration.backgroundImage);
            this.backgroundOrigin = parse(context, backgroundOrigin, declaration.backgroundOrigin);
            this.backgroundPosition = parse(context, backgroundPosition, declaration.backgroundPosition);
            this.backgroundRepeat = parse(context, backgroundRepeat, declaration.backgroundRepeat);
            this.backgroundSize = parse(context, backgroundSize, declaration.backgroundSize);
            this.borderTopColor = parse(context, borderTopColor, declaration.borderTopColor);
            this.borderRightColor = parse(context, borderRightColor, declaration.borderRightColor);
            this.borderBottomColor = parse(context, borderBottomColor, declaration.borderBottomColor);
            this.borderLeftColor = parse(context, borderLeftColor, declaration.borderLeftColor);
            this.borderTopLeftRadius = parse(context, borderTopLeftRadius, declaration.borderTopLeftRadius);
            this.borderTopRightRadius = parse(context, borderTopRightRadius, declaration.borderTopRightRadius);
            this.borderBottomRightRadius = parse(context, borderBottomRightRadius, declaration.borderBottomRightRadius);
            this.borderBottomLeftRadius = parse(context, borderBottomLeftRadius, declaration.borderBottomLeftRadius);
            this.borderTopStyle = parse(context, borderTopStyle, declaration.borderTopStyle);
            this.borderRightStyle = parse(context, borderRightStyle, declaration.borderRightStyle);
            this.borderBottomStyle = parse(context, borderBottomStyle, declaration.borderBottomStyle);
            this.borderLeftStyle = parse(context, borderLeftStyle, declaration.borderLeftStyle);
            this.borderTopWidth = parse(context, borderTopWidth, declaration.borderTopWidth);
            this.borderRightWidth = parse(context, borderRightWidth, declaration.borderRightWidth);
            this.borderBottomWidth = parse(context, borderBottomWidth, declaration.borderBottomWidth);
            this.borderLeftWidth = parse(context, borderLeftWidth, declaration.borderLeftWidth);
            this.boxShadow = parse(context, boxShadow, declaration.boxShadow);
            this.color = parse(context, color, declaration.color);
            this.direction = parse(context, direction, declaration.direction);
            this.display = parse(context, display, declaration.display);
            this.float = parse(context, float, declaration.cssFloat);
            this.fontFamily = parse(context, fontFamily, declaration.fontFamily);
            this.fontSize = parse(context, fontSize, declaration.fontSize);
            this.fontStyle = parse(context, fontStyle, declaration.fontStyle);
            this.fontVariant = parse(context, fontVariant, declaration.fontVariant);
            this.fontWeight = parse(context, fontWeight, declaration.fontWeight);
            this.letterSpacing = parse(context, letterSpacing, declaration.letterSpacing);
            this.lineBreak = parse(context, lineBreak, declaration.lineBreak);
            this.lineHeight = parse(context, lineHeight, declaration.lineHeight);
            this.listStyleImage = parse(context, listStyleImage, declaration.listStyleImage);
            this.listStylePosition = parse(context, listStylePosition, declaration.listStylePosition);
            this.listStyleType = parse(context, listStyleType, declaration.listStyleType);
            this.marginTop = parse(context, marginTop, declaration.marginTop);
            this.marginRight = parse(context, marginRight, declaration.marginRight);
            this.marginBottom = parse(context, marginBottom, declaration.marginBottom);
            this.marginLeft = parse(context, marginLeft, declaration.marginLeft);
            this.opacity = parse(context, opacity, declaration.opacity);
            var overflowTuple = parse(context, overflow, declaration.overflow);
            this.overflowX = overflowTuple[0];
            this.overflowY = overflowTuple[overflowTuple.length > 1 ? 1 : 0];
            this.overflowWrap = parse(context, overflowWrap, declaration.overflowWrap);
            this.paddingTop = parse(context, paddingTop, declaration.paddingTop);
            this.paddingRight = parse(context, paddingRight, declaration.paddingRight);
            this.paddingBottom = parse(context, paddingBottom, declaration.paddingBottom);
            this.paddingLeft = parse(context, paddingLeft, declaration.paddingLeft);
            this.paintOrder = parse(context, paintOrder, declaration.paintOrder);
            this.position = parse(context, position, declaration.position);
            this.textAlign = parse(context, textAlign, declaration.textAlign);
            this.textDecorationColor = parse(context, textDecorationColor, (_a = declaration.textDecorationColor) !== null && _a !== void 0 ? _a : declaration.color);
            this.textDecorationLine = parse(context, textDecorationLine, (_b = declaration.textDecorationLine) !== null && _b !== void 0 ? _b : declaration.textDecoration);
            this.textShadow = parse(context, textShadow, declaration.textShadow);
            this.textTransform = parse(context, textTransform, declaration.textTransform);
            this.transform = parse(context, transform$1, declaration.transform);
            this.transformOrigin = parse(context, transformOrigin, declaration.transformOrigin);
            this.visibility = parse(context, visibility, declaration.visibility);
            this.webkitTextStrokeColor = parse(context, webkitTextStrokeColor, declaration.webkitTextStrokeColor);
            this.webkitTextStrokeWidth = parse(context, webkitTextStrokeWidth, declaration.webkitTextStrokeWidth);
            this.wordBreak = parse(context, wordBreak, declaration.wordBreak);
            this.zIndex = parse(context, zIndex, declaration.zIndex);
        }
        CSSParsedDeclaration.prototype.isVisible = function() {
            return this.display > 0 && this.opacity > 0 && this.visibility === 0 /* VISIBLE */ ;
        };
        CSSParsedDeclaration.prototype.isTransparent = function() {
            return isTransparent(this.backgroundColor);
        };
        CSSParsedDeclaration.prototype.isTransformed = function() {
            return this.transform !== null;
        };
        CSSParsedDeclaration.prototype.isPositioned = function() {
            return this.position !== 0 /* STATIC */ ;
        };
        CSSParsedDeclaration.prototype.isPositionedWithZIndex = function() {
            return this.isPositioned() && !this.zIndex.auto;
        };
        CSSParsedDeclaration.prototype.isFloating = function() {
            return this.float !== 0 /* NONE */ ;
        };
        CSSParsedDeclaration.prototype.isInlineLevel = function() {
            return contains(this.display, 4 /* INLINE */ ) || contains(this.display, 33554432 /* INLINE_BLOCK */ ) || contains(this.display, 268435456 /* INLINE_FLEX */ ) || contains(this.display, 536870912 /* INLINE_GRID */ ) || contains(this.display, 67108864 /* INLINE_LIST_ITEM */ ) || contains(this.display, 134217728 /* INLINE_TABLE */ );
        };
        return CSSParsedDeclaration;
    }();
    var CSSParsedPseudoDeclaration = /** @class */ function() {
        function CSSParsedPseudoDeclaration(context, declaration) {
            this.content = parse(context, content, declaration.content);
            this.quotes = parse(context, quotes, declaration.quotes);
        }
        return CSSParsedPseudoDeclaration;
    }();
    var CSSParsedCounterDeclaration = /** @class */ function() {
        function CSSParsedCounterDeclaration(context, declaration) {
            this.counterIncrement = parse(context, counterIncrement, declaration.counterIncrement);
            this.counterReset = parse(context, counterReset, declaration.counterReset);
        }
        return CSSParsedCounterDeclaration;
    }();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var parse = function(context, descriptor, style) {
        var tokenizer = new Tokenizer();
        var value = style !== null && typeof style !== 'undefined' ? style.toString() : descriptor.initialValue;
        tokenizer.write(value);
        var parser = new Parser(tokenizer.read());
        switch(descriptor.type){
            case 2 /* IDENT_VALUE */ :
                var token = parser.parseComponentValue();
                return descriptor.parse(context, isIdentToken(token) ? token.value : descriptor.initialValue);
            case 0 /* VALUE */ :
                return descriptor.parse(context, parser.parseComponentValue());
            case 1 /* LIST */ :
                return descriptor.parse(context, parser.parseComponentValues());
            case 4 /* TOKEN_VALUE */ :
                return parser.parseComponentValue();
            case 3 /* TYPE_VALUE */ :
                switch(descriptor.format){
                    case 'angle':
                        return angle.parse(context, parser.parseComponentValue());
                    case 'color':
                        return color$1.parse(context, parser.parseComponentValue());
                    case 'image':
                        return image.parse(context, parser.parseComponentValue());
                    case 'length':
                        var length_1 = parser.parseComponentValue();
                        return isLength(length_1) ? length_1 : ZERO_LENGTH;
                    case 'length-percentage':
                        var value_1 = parser.parseComponentValue();
                        return isLengthPercentage(value_1) ? value_1 : ZERO_LENGTH;
                    case 'time':
                        return time.parse(context, parser.parseComponentValue());
                }
                break;
        }
    };
    var elementDebuggerAttribute = 'data-html2canvas-debug';
    var getElementDebugType = function(element) {
        var attribute = element.getAttribute(elementDebuggerAttribute);
        switch(attribute){
            case 'all':
                return 1 /* ALL */ ;
            case 'clone':
                return 2 /* CLONE */ ;
            case 'parse':
                return 3 /* PARSE */ ;
            case 'render':
                return 4 /* RENDER */ ;
            default:
                return 0 /* NONE */ ;
        }
    };
    var isDebugging = function(element, type) {
        var elementType = getElementDebugType(element);
        return elementType === 1 /* ALL */  || type === elementType;
    };
    var ElementContainer = /** @class */ function() {
        function ElementContainer(context, element) {
            this.context = context;
            this.textNodes = [];
            this.elements = [];
            this.flags = 0;
            if (isDebugging(element, 3 /* PARSE */ )) debugger;
            this.styles = new CSSParsedDeclaration(context, window.getComputedStyle(element, null));
            if (isHTMLElementNode(element)) {
                if (this.styles.animationDuration.some(function(duration) {
                    return duration > 0;
                })) element.style.animationDuration = '0s';
                if (this.styles.transform !== null) // getBoundingClientRect takes transforms into account
                element.style.transform = 'none';
            }
            this.bounds = parseBounds(this.context, element);
            if (isDebugging(element, 4 /* RENDER */ )) this.flags |= 16 /* DEBUG_RENDER */ ;
        }
        return ElementContainer;
    }();
    /*
     * text-segmentation 1.0.3 <https://github.com/niklasvh/text-segmentation>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var base64 = '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';
    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$1 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$1 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i$1 = 0; i$1 < chars$1.length; i$1++)lookup$1[chars$1.charCodeAt(i$1)] = i$1;
    var decode = function(base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === '=') {
            bufferLength--;
            if (base64[base64.length - 2] === '=') bufferLength--;
        }
        var buffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined' && typeof Uint8Array.prototype.slice !== 'undefined' ? new ArrayBuffer(bufferLength) : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for(i = 0; i < len; i += 4){
            encoded1 = lookup$1[base64.charCodeAt(i)];
            encoded2 = lookup$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1[base64.charCodeAt(i + 3)];
            bytes[p++] = encoded1 << 2 | encoded2 >> 4;
            bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
            bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
        }
        return buffer;
    };
    var polyUint16Array = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 2)bytes.push(buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    var polyUint32Array = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 4)bytes.push(buffer[i + 3] << 24 | buffer[i + 2] << 16 | buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    /** Shift size for getting the index-2 table offset. */ var UTRIE2_SHIFT_2 = 5;
    /** Shift size for getting the index-1 table offset. */ var UTRIE2_SHIFT_1 = 11;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */ var UTRIE2_INDEX_SHIFT = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */ var UTRIE2_SHIFT_1_2 = UTRIE2_SHIFT_1 - UTRIE2_SHIFT_2;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */ var UTRIE2_LSCP_INDEX_2_OFFSET = 0x10000 >> UTRIE2_SHIFT_2;
    /** Number of entries in a data block. 32=0x20 */ var UTRIE2_DATA_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_2;
    /** Mask for getting the lower bits for the in-data-block offset. */ var UTRIE2_DATA_MASK = UTRIE2_DATA_BLOCK_LENGTH - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH = 0x400 >> UTRIE2_SHIFT_2;
    /** Count the lengths of both BMP pieces. 2080=0x820 */ var UTRIE2_INDEX_2_BMP_LENGTH = UTRIE2_LSCP_INDEX_2_OFFSET + UTRIE2_LSCP_INDEX_2_LENGTH;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */ var UTRIE2_UTF8_2B_INDEX_2_OFFSET = UTRIE2_INDEX_2_BMP_LENGTH;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH = 32; /* U+0800 is the first code point after 2-byte UTF-8 */ 
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */ var UTRIE2_INDEX_1_OFFSET = UTRIE2_UTF8_2B_INDEX_2_OFFSET + UTRIE2_UTF8_2B_INDEX_2_LENGTH;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */ var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH = 0x10000 >> UTRIE2_SHIFT_1;
    /** Number of entries in an index-2 block. 64=0x40 */ var UTRIE2_INDEX_2_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_1_2;
    /** Mask for getting the lower bits for the in-index-2-block offset. */ var UTRIE2_INDEX_2_MASK = UTRIE2_INDEX_2_BLOCK_LENGTH - 1;
    var slice16 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64 = function(base64, _byteLength) {
        var buffer = decode(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2 ? slice16(view16, (headerLength + view32[4]) / 2) : slice32(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie = /** @class */ function() {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */ Trie.prototype.get = function(codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || codePoint > 0x0dbff && codePoint <= 0x0ffff) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET + (codePoint - 0xd800 >> UTRIE2_SHIFT_2)];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH + (codePoint >> UTRIE2_SHIFT_1);
                    ix = this.index[ix];
                    ix += codePoint >> UTRIE2_SHIFT_2 & UTRIE2_INDEX_2_MASK;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) return this.data[this.highValueIndex];
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }();
    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i = 0; i < chars.length; i++)lookup[chars.charCodeAt(i)] = i;
    var Prepend = 1;
    var CR = 2;
    var LF = 3;
    var Control = 4;
    var Extend = 5;
    var SpacingMark = 7;
    var L = 8;
    var V = 9;
    var T = 10;
    var LV = 11;
    var LVT = 12;
    var ZWJ = 13;
    var Extended_Pictographic = 14;
    var RI = 15;
    var toCodePoints = function(str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while(i < length){
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                else {
                    codePoints.push(value);
                    i--;
                }
            } else codePoints.push(value);
        }
        return codePoints;
    };
    var fromCodePoint = function() {
        var codePoints = [];
        for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
        if (String.fromCodePoint) return String.fromCodePoint.apply(String, codePoints);
        var length = codePoints.length;
        if (!length) return '';
        var codeUnits = [];
        var index = -1;
        var result = '';
        while(++index < length){
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) codeUnits.push(codePoint);
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, codePoint % 0x400 + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var UnicodeTrie = createTrieFromBase64(base64);
    var BREAK_NOT_ALLOWED = "\xd7";
    var BREAK_ALLOWED = "\xf7";
    var codePointToClass = function(codePoint) {
        return UnicodeTrie.get(codePoint);
    };
    var _graphemeBreakAtIndex = function(_codePoints, classTypes, index) {
        var prevIndex = index - 2;
        var prev = classTypes[prevIndex];
        var current = classTypes[index - 1];
        var next = classTypes[index];
        // GB3 Do not break between a CR and LF
        if (current === CR && next === LF) return BREAK_NOT_ALLOWED;
        // GB4 Otherwise, break before and after controls.
        if (current === CR || current === LF || current === Control) return BREAK_ALLOWED;
        // GB5
        if (next === CR || next === LF || next === Control) return BREAK_ALLOWED;
        // Do not break Hangul syllable sequences.
        // GB6
        if (current === L && [
            L,
            V,
            LV,
            LVT
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED;
        // GB7
        if ((current === LV || current === V) && (next === V || next === T)) return BREAK_NOT_ALLOWED;
        // GB8
        if ((current === LVT || current === T) && next === T) return BREAK_NOT_ALLOWED;
        // GB9 Do not break before extending characters or ZWJ.
        if (next === ZWJ || next === Extend) return BREAK_NOT_ALLOWED;
        // Do not break before SpacingMarks, or after Prepend characters.
        // GB9a
        if (next === SpacingMark) return BREAK_NOT_ALLOWED;
        // GB9a
        if (current === Prepend) return BREAK_NOT_ALLOWED;
        // GB11 Do not break within emoji modifier sequences or emoji zwj sequences.
        if (current === ZWJ && next === Extended_Pictographic) {
            while(prev === Extend)prev = classTypes[--prevIndex];
            if (prev === Extended_Pictographic) return BREAK_NOT_ALLOWED;
        }
        // GB12 Do not break within emoji flag sequences.
        // That is, do not break between regional indicator (RI) symbols
        // if there is an odd number of RI characters before the break point.
        if (current === RI && next === RI) {
            var countRI = 0;
            while(prev === RI){
                countRI++;
                prev = classTypes[--prevIndex];
            }
            if (countRI % 2 === 0) return BREAK_NOT_ALLOWED;
        }
        return BREAK_ALLOWED;
    };
    var GraphemeBreaker = function(str) {
        var codePoints = toCodePoints(str);
        var length = codePoints.length;
        var index = 0;
        var lastEnd = 0;
        var classTypes = codePoints.map(codePointToClass);
        return {
            next: function() {
                if (index >= length) return {
                    done: true,
                    value: null
                };
                var graphemeBreak = BREAK_NOT_ALLOWED;
                while(index < length && (graphemeBreak = _graphemeBreakAtIndex(codePoints, classTypes, ++index)) === BREAK_NOT_ALLOWED);
                if (graphemeBreak !== BREAK_NOT_ALLOWED || index === length) {
                    var value = fromCodePoint.apply(null, codePoints.slice(lastEnd, index));
                    lastEnd = index;
                    return {
                        value: value,
                        done: false
                    };
                }
                return {
                    done: true,
                    value: null
                };
            }
        };
    };
    var splitGraphemes = function(str) {
        var breaker = GraphemeBreaker(str);
        var graphemes = [];
        var bk;
        while(!(bk = breaker.next()).done)if (bk.value) graphemes.push(bk.value.slice());
        return graphemes;
    };
    var testRangeBounds = function(document1) {
        var TEST_HEIGHT = 123;
        if (document1.createRange) {
            var range = document1.createRange();
            if (range.getBoundingClientRect) {
                var testElement = document1.createElement('boundtest');
                testElement.style.height = TEST_HEIGHT + "px";
                testElement.style.display = 'block';
                document1.body.appendChild(testElement);
                range.selectNode(testElement);
                var rangeBounds = range.getBoundingClientRect();
                var rangeHeight = Math.round(rangeBounds.height);
                document1.body.removeChild(testElement);
                if (rangeHeight === TEST_HEIGHT) return true;
            }
        }
        return false;
    };
    var testIOSLineBreak = function(document1) {
        var testElement = document1.createElement('boundtest');
        testElement.style.width = '50px';
        testElement.style.display = 'block';
        testElement.style.fontSize = '12px';
        testElement.style.letterSpacing = '0px';
        testElement.style.wordSpacing = '0px';
        document1.body.appendChild(testElement);
        var range = document1.createRange();
        testElement.innerHTML = typeof ''.repeat === 'function' ? '&#128104;'.repeat(10) : '';
        var node = testElement.firstChild;
        var textList = toCodePoints$1(node.data).map(function(i) {
            return fromCodePoint$1(i);
        });
        var offset = 0;
        var prev = {};
        // ios 13 does not handle range getBoundingClientRect line changes correctly #2177
        var supports = textList.every(function(text, i) {
            range.setStart(node, offset);
            range.setEnd(node, offset + text.length);
            var rect = range.getBoundingClientRect();
            offset += text.length;
            var boundAhead = rect.x > prev.x || rect.y > prev.y;
            prev = rect;
            if (i === 0) return true;
            return boundAhead;
        });
        document1.body.removeChild(testElement);
        return supports;
    };
    var testCORS = function() {
        return typeof new Image().crossOrigin !== 'undefined';
    };
    var testResponseType = function() {
        return typeof new XMLHttpRequest().responseType === 'string';
    };
    var testSVG = function(document1) {
        var img = new Image();
        var canvas = document1.createElement('canvas');
        var ctx = canvas.getContext('2d');
        if (!ctx) return false;
        img.src = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";
        try {
            ctx.drawImage(img, 0, 0);
            canvas.toDataURL();
        } catch (e) {
            return false;
        }
        return true;
    };
    var isGreenPixel = function(data) {
        return data[0] === 0 && data[1] === 255 && data[2] === 0 && data[3] === 255;
    };
    var testForeignObject = function(document1) {
        var canvas = document1.createElement('canvas');
        var size = 100;
        canvas.width = size;
        canvas.height = size;
        var ctx = canvas.getContext('2d');
        if (!ctx) return Promise.reject(false);
        ctx.fillStyle = 'rgb(0, 255, 0)';
        ctx.fillRect(0, 0, size, size);
        var img = new Image();
        var greenImageSrc = canvas.toDataURL();
        img.src = greenImageSrc;
        var svg = createForeignObjectSVG(size, size, 0, 0, img);
        ctx.fillStyle = 'red';
        ctx.fillRect(0, 0, size, size);
        return loadSerializedSVG$1(svg).then(function(img) {
            ctx.drawImage(img, 0, 0);
            var data = ctx.getImageData(0, 0, size, size).data;
            ctx.fillStyle = 'red';
            ctx.fillRect(0, 0, size, size);
            var node = document1.createElement('div');
            node.style.backgroundImage = "url(" + greenImageSrc + ")";
            node.style.height = size + "px";
            // Firefox 55 does not render inline <img /> tags
            return isGreenPixel(data) ? loadSerializedSVG$1(createForeignObjectSVG(size, size, 0, 0, node)) : Promise.reject(false);
        }).then(function(img) {
            ctx.drawImage(img, 0, 0);
            // Edge does not render background-images
            return isGreenPixel(ctx.getImageData(0, 0, size, size).data);
        }).catch(function() {
            return false;
        });
    };
    var createForeignObjectSVG = function(width, height, x, y, node) {
        var xmlns = 'http://www.w3.org/2000/svg';
        var svg = document.createElementNS(xmlns, 'svg');
        var foreignObject = document.createElementNS(xmlns, 'foreignObject');
        svg.setAttributeNS(null, 'width', width.toString());
        svg.setAttributeNS(null, 'height', height.toString());
        foreignObject.setAttributeNS(null, 'width', '100%');
        foreignObject.setAttributeNS(null, 'height', '100%');
        foreignObject.setAttributeNS(null, 'x', x.toString());
        foreignObject.setAttributeNS(null, 'y', y.toString());
        foreignObject.setAttributeNS(null, 'externalResourcesRequired', 'true');
        svg.appendChild(foreignObject);
        foreignObject.appendChild(node);
        return svg;
    };
    var loadSerializedSVG$1 = function(svg) {
        return new Promise(function(resolve, reject) {
            var img = new Image();
            img.onload = function() {
                return resolve(img);
            };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };
    var FEATURES = {
        get SUPPORT_RANGE_BOUNDS () {
            var value = testRangeBounds(document);
            Object.defineProperty(FEATURES, 'SUPPORT_RANGE_BOUNDS', {
                value: value
            });
            return value;
        },
        get SUPPORT_WORD_BREAKING () {
            var value1 = FEATURES.SUPPORT_RANGE_BOUNDS && testIOSLineBreak(document);
            Object.defineProperty(FEATURES, 'SUPPORT_WORD_BREAKING', {
                value: value1
            });
            return value1;
        },
        get SUPPORT_SVG_DRAWING () {
            var value2 = testSVG(document);
            Object.defineProperty(FEATURES, 'SUPPORT_SVG_DRAWING', {
                value: value2
            });
            return value2;
        },
        get SUPPORT_FOREIGNOBJECT_DRAWING () {
            var value3 = typeof Array.from === 'function' && typeof window.fetch === 'function' ? testForeignObject(document) : Promise.resolve(false);
            Object.defineProperty(FEATURES, 'SUPPORT_FOREIGNOBJECT_DRAWING', {
                value: value3
            });
            return value3;
        },
        get SUPPORT_CORS_IMAGES () {
            var value4 = testCORS();
            Object.defineProperty(FEATURES, 'SUPPORT_CORS_IMAGES', {
                value: value4
            });
            return value4;
        },
        get SUPPORT_RESPONSE_TYPE () {
            var value5 = testResponseType();
            Object.defineProperty(FEATURES, 'SUPPORT_RESPONSE_TYPE', {
                value: value5
            });
            return value5;
        },
        get SUPPORT_CORS_XHR () {
            var value6 = 'withCredentials' in new XMLHttpRequest();
            Object.defineProperty(FEATURES, 'SUPPORT_CORS_XHR', {
                value: value6
            });
            return value6;
        },
        get SUPPORT_NATIVE_TEXT_SEGMENTATION () {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var value7 = !!(typeof Intl !== 'undefined' && Intl.Segmenter);
            Object.defineProperty(FEATURES, 'SUPPORT_NATIVE_TEXT_SEGMENTATION', {
                value: value7
            });
            return value7;
        }
    };
    var TextBounds = /** @class */ function() {
        function TextBounds(text, bounds) {
            this.text = text;
            this.bounds = bounds;
        }
        return TextBounds;
    }();
    var parseTextBounds = function(context, value, styles, node) {
        var textList = breakText(value, styles);
        var textBounds = [];
        var offset = 0;
        textList.forEach(function(text) {
            if (styles.textDecorationLine.length || text.trim().length > 0) {
                if (FEATURES.SUPPORT_RANGE_BOUNDS) {
                    var clientRects = createRange(node, offset, text.length).getClientRects();
                    if (clientRects.length > 1) {
                        var subSegments = segmentGraphemes(text);
                        var subOffset_1 = 0;
                        subSegments.forEach(function(subSegment) {
                            textBounds.push(new TextBounds(subSegment, Bounds.fromDOMRectList(context, createRange(node, subOffset_1 + offset, subSegment.length).getClientRects())));
                            subOffset_1 += subSegment.length;
                        });
                    } else textBounds.push(new TextBounds(text, Bounds.fromDOMRectList(context, clientRects)));
                } else {
                    var replacementNode = node.splitText(text.length);
                    textBounds.push(new TextBounds(text, getWrapperBounds(context, node)));
                    node = replacementNode;
                }
            } else if (!FEATURES.SUPPORT_RANGE_BOUNDS) node = node.splitText(text.length);
            offset += text.length;
        });
        return textBounds;
    };
    var getWrapperBounds = function(context, node) {
        var ownerDocument = node.ownerDocument;
        if (ownerDocument) {
            var wrapper = ownerDocument.createElement('html2canvaswrapper');
            wrapper.appendChild(node.cloneNode(true));
            var parentNode = node.parentNode;
            if (parentNode) {
                parentNode.replaceChild(wrapper, node);
                var bounds = parseBounds(context, wrapper);
                if (wrapper.firstChild) parentNode.replaceChild(wrapper.firstChild, wrapper);
                return bounds;
            }
        }
        return Bounds.EMPTY;
    };
    var createRange = function(node, offset, length) {
        var ownerDocument = node.ownerDocument;
        if (!ownerDocument) throw new Error('Node has no owner document');
        var range = ownerDocument.createRange();
        range.setStart(node, offset);
        range.setEnd(node, offset + length);
        return range;
    };
    var segmentGraphemes = function(value) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, {
                granularity: 'grapheme'
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function(segment) {
                return segment.segment;
            });
        }
        return splitGraphemes(value);
    };
    var segmentWords = function(value, styles) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, {
                granularity: 'word'
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function(segment) {
                return segment.segment;
            });
        }
        return breakWords(value, styles);
    };
    var breakText = function(value, styles) {
        return styles.letterSpacing !== 0 ? segmentGraphemes(value) : segmentWords(value, styles);
    };
    // https://drafts.csswg.org/css-text/#word-separator
    var wordSeparators = [
        0x0020,
        0x00a0,
        0x1361,
        0x10100,
        0x10101,
        0x1039,
        0x1091
    ];
    var breakWords = function(str, styles) {
        var breaker = LineBreaker(str, {
            lineBreak: styles.lineBreak,
            wordBreak: styles.overflowWrap === "break-word" /* BREAK_WORD */  ? 'break-word' : styles.wordBreak
        });
        var words = [];
        var bk;
        var _loop_1 = function() {
            if (bk.value) {
                var value = bk.value.slice();
                var codePoints = toCodePoints$1(value);
                var word_1 = '';
                codePoints.forEach(function(codePoint) {
                    if (wordSeparators.indexOf(codePoint) === -1) word_1 += fromCodePoint$1(codePoint);
                    else {
                        if (word_1.length) words.push(word_1);
                        words.push(fromCodePoint$1(codePoint));
                        word_1 = '';
                    }
                });
                if (word_1.length) words.push(word_1);
            }
        };
        while(!(bk = breaker.next()).done)_loop_1();
        return words;
    };
    var TextContainer = /** @class */ function() {
        function TextContainer(context, node, styles) {
            this.text = transform(node.data, styles.textTransform);
            this.textBounds = parseTextBounds(context, this.text, styles, node);
        }
        return TextContainer;
    }();
    var transform = function(text, transform) {
        switch(transform){
            case 1 /* LOWERCASE */ :
                return text.toLowerCase();
            case 3 /* CAPITALIZE */ :
                return text.replace(CAPITALIZE, capitalize);
            case 2 /* UPPERCASE */ :
                return text.toUpperCase();
            default:
                return text;
        }
    };
    var CAPITALIZE = /(^|\s|:|-|\(|\))([a-z])/g;
    var capitalize = function(m, p1, p2) {
        if (m.length > 0) return p1 + p2.toUpperCase();
        return m;
    };
    var ImageElementContainer = /** @class */ function(_super) {
        __extends(ImageElementContainer, _super);
        function ImageElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            _this.src = img.currentSrc || img.src;
            _this.intrinsicWidth = img.naturalWidth;
            _this.intrinsicHeight = img.naturalHeight;
            _this.context.cache.addImage(_this.src);
            return _this;
        }
        return ImageElementContainer;
    }(ElementContainer);
    var CanvasElementContainer = /** @class */ function(_super) {
        __extends(CanvasElementContainer, _super);
        function CanvasElementContainer(context, canvas) {
            var _this = _super.call(this, context, canvas) || this;
            _this.canvas = canvas;
            _this.intrinsicWidth = canvas.width;
            _this.intrinsicHeight = canvas.height;
            return _this;
        }
        return CanvasElementContainer;
    }(ElementContainer);
    var SVGElementContainer = /** @class */ function(_super) {
        __extends(SVGElementContainer, _super);
        function SVGElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            var s = new XMLSerializer();
            var bounds = parseBounds(context, img);
            img.setAttribute('width', bounds.width + "px");
            img.setAttribute('height', bounds.height + "px");
            _this.svg = "data:image/svg+xml," + encodeURIComponent(s.serializeToString(img));
            _this.intrinsicWidth = img.width.baseVal.value;
            _this.intrinsicHeight = img.height.baseVal.value;
            _this.context.cache.addImage(_this.svg);
            return _this;
        }
        return SVGElementContainer;
    }(ElementContainer);
    var LIElementContainer = /** @class */ function(_super) {
        __extends(LIElementContainer, _super);
        function LIElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        }
        return LIElementContainer;
    }(ElementContainer);
    var OLElementContainer = /** @class */ function(_super) {
        __extends(OLElementContainer, _super);
        function OLElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.start = element.start;
            _this.reversed = typeof element.reversed === 'boolean' && element.reversed === true;
            return _this;
        }
        return OLElementContainer;
    }(ElementContainer);
    var CHECKBOX_BORDER_RADIUS = [
        {
            type: 15 /* DIMENSION_TOKEN */ ,
            flags: 0,
            unit: 'px',
            number: 3
        }
    ];
    var RADIO_BORDER_RADIUS = [
        {
            type: 16 /* PERCENTAGE_TOKEN */ ,
            flags: 0,
            number: 50
        }
    ];
    var reformatInputBounds = function(bounds) {
        if (bounds.width > bounds.height) return new Bounds(bounds.left + (bounds.width - bounds.height) / 2, bounds.top, bounds.height, bounds.height);
        else if (bounds.width < bounds.height) return new Bounds(bounds.left, bounds.top + (bounds.height - bounds.width) / 2, bounds.width, bounds.width);
        return bounds;
    };
    var getInputValue = function(node) {
        var value = node.type === PASSWORD ? new Array(node.value.length + 1).join('\u2022') : node.value;
        return value.length === 0 ? node.placeholder || '' : value;
    };
    var CHECKBOX = 'checkbox';
    var RADIO = 'radio';
    var PASSWORD = 'password';
    var INPUT_COLOR = 0x2a2a2aff;
    var InputElementContainer = /** @class */ function(_super) {
        __extends(InputElementContainer, _super);
        function InputElementContainer(context, input) {
            var _this = _super.call(this, context, input) || this;
            _this.type = input.type.toLowerCase();
            _this.checked = input.checked;
            _this.value = getInputValue(input);
            if (_this.type === CHECKBOX || _this.type === RADIO) {
                _this.styles.backgroundColor = 0xdededeff;
                _this.styles.borderTopColor = _this.styles.borderRightColor = _this.styles.borderBottomColor = _this.styles.borderLeftColor = 0xa5a5a5ff;
                _this.styles.borderTopWidth = _this.styles.borderRightWidth = _this.styles.borderBottomWidth = _this.styles.borderLeftWidth = 1;
                _this.styles.borderTopStyle = _this.styles.borderRightStyle = _this.styles.borderBottomStyle = _this.styles.borderLeftStyle = 1 /* SOLID */ ;
                _this.styles.backgroundClip = [
                    0 /* BORDER_BOX */ 
                ];
                _this.styles.backgroundOrigin = [
                    0 /* BORDER_BOX */ 
                ];
                _this.bounds = reformatInputBounds(_this.bounds);
            }
            switch(_this.type){
                case CHECKBOX:
                    _this.styles.borderTopRightRadius = _this.styles.borderTopLeftRadius = _this.styles.borderBottomRightRadius = _this.styles.borderBottomLeftRadius = CHECKBOX_BORDER_RADIUS;
                    break;
                case RADIO:
                    _this.styles.borderTopRightRadius = _this.styles.borderTopLeftRadius = _this.styles.borderBottomRightRadius = _this.styles.borderBottomLeftRadius = RADIO_BORDER_RADIUS;
                    break;
            }
            return _this;
        }
        return InputElementContainer;
    }(ElementContainer);
    var SelectElementContainer = /** @class */ function(_super) {
        __extends(SelectElementContainer, _super);
        function SelectElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            var option = element.options[element.selectedIndex || 0];
            _this.value = option ? option.text || '' : '';
            return _this;
        }
        return SelectElementContainer;
    }(ElementContainer);
    var TextareaElementContainer = /** @class */ function(_super) {
        __extends(TextareaElementContainer, _super);
        function TextareaElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        }
        return TextareaElementContainer;
    }(ElementContainer);
    var IFrameElementContainer = /** @class */ function(_super) {
        __extends(IFrameElementContainer, _super);
        function IFrameElementContainer(context, iframe) {
            var _this = _super.call(this, context, iframe) || this;
            _this.src = iframe.src;
            _this.width = parseInt(iframe.width, 10) || 0;
            _this.height = parseInt(iframe.height, 10) || 0;
            _this.backgroundColor = _this.styles.backgroundColor;
            try {
                if (iframe.contentWindow && iframe.contentWindow.document && iframe.contentWindow.document.documentElement) {
                    _this.tree = parseTree(context, iframe.contentWindow.document.documentElement);
                    // http://www.w3.org/TR/css3-background/#special-backgrounds
                    var documentBackgroundColor = iframe.contentWindow.document.documentElement ? parseColor(context, getComputedStyle(iframe.contentWindow.document.documentElement).backgroundColor) : COLORS.TRANSPARENT;
                    var bodyBackgroundColor = iframe.contentWindow.document.body ? parseColor(context, getComputedStyle(iframe.contentWindow.document.body).backgroundColor) : COLORS.TRANSPARENT;
                    _this.backgroundColor = isTransparent(documentBackgroundColor) ? isTransparent(bodyBackgroundColor) ? _this.styles.backgroundColor : bodyBackgroundColor : documentBackgroundColor;
                }
            } catch (e) {}
            return _this;
        }
        return IFrameElementContainer;
    }(ElementContainer);
    var LIST_OWNERS = [
        'OL',
        'UL',
        'MENU'
    ];
    var parseNodeTree = function(context, node, parent, root) {
        for(var childNode = node.firstChild, nextNode = void 0; childNode; childNode = nextNode){
            nextNode = childNode.nextSibling;
            if (isTextNode(childNode) && childNode.data.trim().length > 0) parent.textNodes.push(new TextContainer(context, childNode, parent.styles));
            else if (isElementNode(childNode)) {
                if (isSlotElement(childNode) && childNode.assignedNodes) childNode.assignedNodes().forEach(function(childNode) {
                    return parseNodeTree(context, childNode, parent, root);
                });
                else {
                    var container = createContainer(context, childNode);
                    if (container.styles.isVisible()) {
                        if (createsRealStackingContext(childNode, container, root)) container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */ ;
                        else if (createsStackingContext(container.styles)) container.flags |= 2 /* CREATES_STACKING_CONTEXT */ ;
                        if (LIST_OWNERS.indexOf(childNode.tagName) !== -1) container.flags |= 8 /* IS_LIST_OWNER */ ;
                        parent.elements.push(container);
                        childNode.slot;
                        if (childNode.shadowRoot) parseNodeTree(context, childNode.shadowRoot, container, root);
                        else if (!isTextareaElement(childNode) && !isSVGElement(childNode) && !isSelectElement(childNode)) parseNodeTree(context, childNode, container, root);
                    }
                }
            }
        }
    };
    var createContainer = function(context, element) {
        if (isImageElement(element)) return new ImageElementContainer(context, element);
        if (isCanvasElement(element)) return new CanvasElementContainer(context, element);
        if (isSVGElement(element)) return new SVGElementContainer(context, element);
        if (isLIElement(element)) return new LIElementContainer(context, element);
        if (isOLElement(element)) return new OLElementContainer(context, element);
        if (isInputElement(element)) return new InputElementContainer(context, element);
        if (isSelectElement(element)) return new SelectElementContainer(context, element);
        if (isTextareaElement(element)) return new TextareaElementContainer(context, element);
        if (isIFrameElement(element)) return new IFrameElementContainer(context, element);
        return new ElementContainer(context, element);
    };
    var parseTree = function(context, element) {
        var container = createContainer(context, element);
        container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */ ;
        parseNodeTree(context, element, container, container);
        return container;
    };
    var createsRealStackingContext = function(node, container, root) {
        return container.styles.isPositionedWithZIndex() || container.styles.opacity < 1 || container.styles.isTransformed() || isBodyElement(node) && root.styles.isTransparent();
    };
    var createsStackingContext = function(styles) {
        return styles.isPositioned() || styles.isFloating();
    };
    var isTextNode = function(node) {
        return node.nodeType === Node.TEXT_NODE;
    };
    var isElementNode = function(node) {
        return node.nodeType === Node.ELEMENT_NODE;
    };
    var isHTMLElementNode = function(node) {
        return isElementNode(node) && typeof node.style !== 'undefined' && !isSVGElementNode(node);
    };
    var isSVGElementNode = function(element) {
        return typeof element.className === 'object';
    };
    var isLIElement = function(node) {
        return node.tagName === 'LI';
    };
    var isOLElement = function(node) {
        return node.tagName === 'OL';
    };
    var isInputElement = function(node) {
        return node.tagName === 'INPUT';
    };
    var isHTMLElement = function(node) {
        return node.tagName === 'HTML';
    };
    var isSVGElement = function(node) {
        return node.tagName === 'svg';
    };
    var isBodyElement = function(node) {
        return node.tagName === 'BODY';
    };
    var isCanvasElement = function(node) {
        return node.tagName === 'CANVAS';
    };
    var isVideoElement = function(node) {
        return node.tagName === 'VIDEO';
    };
    var isImageElement = function(node) {
        return node.tagName === 'IMG';
    };
    var isIFrameElement = function(node) {
        return node.tagName === 'IFRAME';
    };
    var isStyleElement = function(node) {
        return node.tagName === 'STYLE';
    };
    var isScriptElement = function(node) {
        return node.tagName === 'SCRIPT';
    };
    var isTextareaElement = function(node) {
        return node.tagName === 'TEXTAREA';
    };
    var isSelectElement = function(node) {
        return node.tagName === 'SELECT';
    };
    var isSlotElement = function(node) {
        return node.tagName === 'SLOT';
    };
    // https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
    var isCustomElement = function(node) {
        return node.tagName.indexOf('-') > 0;
    };
    var CounterState = /** @class */ function() {
        function CounterState() {
            this.counters = {};
        }
        CounterState.prototype.getCounterValue = function(name) {
            var counter = this.counters[name];
            if (counter && counter.length) return counter[counter.length - 1];
            return 1;
        };
        CounterState.prototype.getCounterValues = function(name) {
            var counter = this.counters[name];
            return counter ? counter : [];
        };
        CounterState.prototype.pop = function(counters) {
            var _this = this;
            counters.forEach(function(counter) {
                return _this.counters[counter].pop();
            });
        };
        CounterState.prototype.parse = function(style) {
            var _this = this;
            var counterIncrement = style.counterIncrement;
            var counterReset = style.counterReset;
            var canReset = true;
            if (counterIncrement !== null) counterIncrement.forEach(function(entry) {
                var counter = _this.counters[entry.counter];
                if (counter && entry.increment !== 0) {
                    canReset = false;
                    if (!counter.length) counter.push(1);
                    counter[Math.max(0, counter.length - 1)] += entry.increment;
                }
            });
            var counterNames = [];
            if (canReset) counterReset.forEach(function(entry) {
                var counter = _this.counters[entry.counter];
                counterNames.push(entry.counter);
                if (!counter) counter = _this.counters[entry.counter] = [];
                counter.push(entry.reset);
            });
            return counterNames;
        };
        return CounterState;
    }();
    var ROMAN_UPPER = {
        integers: [
            1000,
            900,
            500,
            400,
            100,
            90,
            50,
            40,
            10,
            9,
            5,
            4,
            1
        ],
        values: [
            'M',
            'CM',
            'D',
            'CD',
            'C',
            'XC',
            'L',
            'XL',
            'X',
            'IX',
            'V',
            'IV',
            'I'
        ]
    };
    var ARMENIAN = {
        integers: [
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            900,
            800,
            700,
            600,
            500,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u0554",
            "\u0553",
            "\u0552",
            "\u0551",
            "\u0550",
            "\u054F",
            "\u054E",
            "\u054D",
            "\u054C",
            "\u054B",
            "\u054A",
            "\u0549",
            "\u0548",
            "\u0547",
            "\u0546",
            "\u0545",
            "\u0544",
            "\u0543",
            "\u0542",
            "\u0541",
            "\u0540",
            "\u053F",
            "\u053E",
            "\u053D",
            "\u053C",
            "\u053B",
            "\u053A",
            "\u0539",
            "\u0538",
            "\u0537",
            "\u0536",
            "\u0535",
            "\u0534",
            "\u0533",
            "\u0532",
            "\u0531"
        ]
    };
    var HEBREW = {
        integers: [
            10000,
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            19,
            18,
            17,
            16,
            15,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u05D9\u05F3",
            "\u05D8\u05F3",
            "\u05D7\u05F3",
            "\u05D6\u05F3",
            "\u05D5\u05F3",
            "\u05D4\u05F3",
            "\u05D3\u05F3",
            "\u05D2\u05F3",
            "\u05D1\u05F3",
            "\u05D0\u05F3",
            "\u05EA",
            "\u05E9",
            "\u05E8",
            "\u05E7",
            "\u05E6",
            "\u05E4",
            "\u05E2",
            "\u05E1",
            "\u05E0",
            "\u05DE",
            "\u05DC",
            "\u05DB",
            "\u05D9\u05D8",
            "\u05D9\u05D7",
            "\u05D9\u05D6",
            "\u05D8\u05D6",
            "\u05D8\u05D5",
            "\u05D9",
            "\u05D8",
            "\u05D7",
            "\u05D6",
            "\u05D5",
            "\u05D4",
            "\u05D3",
            "\u05D2",
            "\u05D1",
            "\u05D0"
        ]
    };
    var GEORGIAN = {
        integers: [
            10000,
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            900,
            800,
            700,
            600,
            500,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u10F5",
            "\u10F0",
            "\u10EF",
            "\u10F4",
            "\u10EE",
            "\u10ED",
            "\u10EC",
            "\u10EB",
            "\u10EA",
            "\u10E9",
            "\u10E8",
            "\u10E7",
            "\u10E6",
            "\u10E5",
            "\u10E4",
            "\u10F3",
            "\u10E2",
            "\u10E1",
            "\u10E0",
            "\u10DF",
            "\u10DE",
            "\u10DD",
            "\u10F2",
            "\u10DC",
            "\u10DB",
            "\u10DA",
            "\u10D9",
            "\u10D8",
            "\u10D7",
            "\u10F1",
            "\u10D6",
            "\u10D5",
            "\u10D4",
            "\u10D3",
            "\u10D2",
            "\u10D1",
            "\u10D0"
        ]
    };
    var createAdditiveCounter = function(value, min, max, symbols, fallback, suffix) {
        if (value < min || value > max) return createCounterText(value, fallback, suffix.length > 0);
        return symbols.integers.reduce(function(string, integer, index) {
            while(value >= integer){
                value -= integer;
                string += symbols.values[index];
            }
            return string;
        }, '') + suffix;
    };
    var createCounterStyleWithSymbolResolver = function(value, codePointRangeLength, isNumeric, resolver) {
        var string = '';
        do {
            if (!isNumeric) value--;
            string = resolver(value) + string;
            value /= codePointRangeLength;
        }while (value * codePointRangeLength >= codePointRangeLength);
        return string;
    };
    var createCounterStyleFromRange = function(value, codePointRangeStart, codePointRangeEnd, isNumeric, suffix) {
        var codePointRangeLength = codePointRangeEnd - codePointRangeStart + 1;
        return (value < 0 ? '-' : '') + (createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, isNumeric, function(codePoint) {
            return fromCodePoint$1(Math.floor(codePoint % codePointRangeLength) + codePointRangeStart);
        }) + suffix);
    };
    var createCounterStyleFromSymbols = function(value, symbols, suffix) {
        if (suffix === void 0) suffix = '. ';
        var codePointRangeLength = symbols.length;
        return createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, false, function(codePoint) {
            return symbols[Math.floor(codePoint % codePointRangeLength)];
        }) + suffix;
    };
    var CJK_ZEROS = 1;
    var CJK_TEN_COEFFICIENTS = 2;
    var CJK_TEN_HIGH_COEFFICIENTS = 4;
    var CJK_HUNDRED_COEFFICIENTS = 8;
    var createCJKCounter = function(value, numbers, multipliers, negativeSign, suffix, flags) {
        if (value < -9999 || value > 9999) return createCounterText(value, 4 /* CJK_DECIMAL */ , suffix.length > 0);
        var tmp = Math.abs(value);
        var string = suffix;
        if (tmp === 0) return numbers[0] + string;
        for(var digit = 0; tmp > 0 && digit <= 4; digit++){
            var coefficient = tmp % 10;
            if (coefficient === 0 && contains(flags, CJK_ZEROS) && string !== '') string = numbers[coefficient] + string;
            else if (coefficient > 1 || coefficient === 1 && digit === 0 || coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_COEFFICIENTS) || coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_HIGH_COEFFICIENTS) && value > 100 || coefficient === 1 && digit > 1 && contains(flags, CJK_HUNDRED_COEFFICIENTS)) string = numbers[coefficient] + (digit > 0 ? multipliers[digit - 1] : '') + string;
            else if (coefficient === 1 && digit > 0) string = multipliers[digit - 1] + string;
            tmp = Math.floor(tmp / 10);
        }
        return (value < 0 ? negativeSign : '') + string;
    };
    var CHINESE_INFORMAL_MULTIPLIERS = "\u5341\u767E\u5343\u842C";
    var CHINESE_FORMAL_MULTIPLIERS = "\u62FE\u4F70\u4EDF\u842C";
    var JAPANESE_NEGATIVE = "\u30DE\u30A4\u30CA\u30B9";
    var KOREAN_NEGATIVE = "\uB9C8\uC774\uB108\uC2A4";
    var createCounterText = function(value, type, appendSuffix) {
        var defaultSuffix = appendSuffix ? '. ' : '';
        var cjkSuffix = appendSuffix ? "\u3001" : '';
        var koreanSuffix = appendSuffix ? ', ' : '';
        var spaceSuffix = appendSuffix ? ' ' : '';
        switch(type){
            case 0 /* DISC */ :
                return "\u2022" + spaceSuffix;
            case 1 /* CIRCLE */ :
                return "\u25E6" + spaceSuffix;
            case 2 /* SQUARE */ :
                return "\u25FE" + spaceSuffix;
            case 5 /* DECIMAL_LEADING_ZERO */ :
                var string = createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
                return string.length < 4 ? "0" + string : string;
            case 4 /* CJK_DECIMAL */ :
                return createCounterStyleFromSymbols(value, "\u3007\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", cjkSuffix);
            case 6 /* LOWER_ROMAN */ :
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */ , defaultSuffix).toLowerCase();
            case 7 /* UPPER_ROMAN */ :
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */ , defaultSuffix);
            case 8 /* LOWER_GREEK */ :
                return createCounterStyleFromRange(value, 945, 969, false, defaultSuffix);
            case 9 /* LOWER_ALPHA */ :
                return createCounterStyleFromRange(value, 97, 122, false, defaultSuffix);
            case 10 /* UPPER_ALPHA */ :
                return createCounterStyleFromRange(value, 65, 90, false, defaultSuffix);
            case 11 /* ARABIC_INDIC */ :
                return createCounterStyleFromRange(value, 1632, 1641, true, defaultSuffix);
            case 12 /* ARMENIAN */ :
            case 49 /* UPPER_ARMENIAN */ :
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */ , defaultSuffix);
            case 35 /* LOWER_ARMENIAN */ :
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */ , defaultSuffix).toLowerCase();
            case 13 /* BENGALI */ :
                return createCounterStyleFromRange(value, 2534, 2543, true, defaultSuffix);
            case 14 /* CAMBODIAN */ :
            case 30 /* KHMER */ :
                return createCounterStyleFromRange(value, 6112, 6121, true, defaultSuffix);
            case 15 /* CJK_EARTHLY_BRANCH */ :
                return createCounterStyleFromSymbols(value, "\u5B50\u4E11\u5BC5\u536F\u8FB0\u5DF3\u5348\u672A\u7533\u9149\u620C\u4EA5", cjkSuffix);
            case 16 /* CJK_HEAVENLY_STEM */ :
                return createCounterStyleFromSymbols(value, "\u7532\u4E59\u4E19\u4E01\u620A\u5DF1\u5E9A\u8F9B\u58EC\u7678", cjkSuffix);
            case 17 /* CJK_IDEOGRAPHIC */ :
            case 48 /* TRAD_CHINESE_INFORMAL */ :
                return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", CHINESE_INFORMAL_MULTIPLIERS, "\u8CA0", cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 47 /* TRAD_CHINESE_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F9\u8CB3\u53C3\u8086\u4F0D\u9678\u67D2\u634C\u7396", CHINESE_FORMAL_MULTIPLIERS, "\u8CA0", cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 42 /* SIMP_CHINESE_INFORMAL */ :
                return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", CHINESE_INFORMAL_MULTIPLIERS, "\u8D1F", cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 41 /* SIMP_CHINESE_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F9\u8D30\u53C1\u8086\u4F0D\u9646\u67D2\u634C\u7396", CHINESE_FORMAL_MULTIPLIERS, "\u8D1F", cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 26 /* JAPANESE_INFORMAL */ :
                return createCJKCounter(value, "\u3007\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u5341\u767E\u5343\u4E07", JAPANESE_NEGATIVE, cjkSuffix, 0);
            case 25 /* JAPANESE_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F1\u5F10\u53C2\u56DB\u4F0D\u516D\u4E03\u516B\u4E5D", "\u62FE\u767E\u5343\u4E07", JAPANESE_NEGATIVE, cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 31 /* KOREAN_HANGUL_FORMAL */ :
                return createCJKCounter(value, "\uC601\uC77C\uC774\uC0BC\uC0AC\uC624\uC721\uCE60\uD314\uAD6C", "\uC2ED\uBC31\uCC9C\uB9CC", KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 33 /* KOREAN_HANJA_INFORMAL */ :
                return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u5341\u767E\u5343\u842C", KOREAN_NEGATIVE, koreanSuffix, 0);
            case 32 /* KOREAN_HANJA_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F9\u8CB3\u53C3\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u62FE\u767E\u5343", KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 18 /* DEVANAGARI */ :
                return createCounterStyleFromRange(value, 0x966, 0x96f, true, defaultSuffix);
            case 20 /* GEORGIAN */ :
                return createAdditiveCounter(value, 1, 19999, GEORGIAN, 3 /* DECIMAL */ , defaultSuffix);
            case 21 /* GUJARATI */ :
                return createCounterStyleFromRange(value, 0xae6, 0xaef, true, defaultSuffix);
            case 22 /* GURMUKHI */ :
                return createCounterStyleFromRange(value, 0xa66, 0xa6f, true, defaultSuffix);
            case 22 /* HEBREW */ :
                return createAdditiveCounter(value, 1, 10999, HEBREW, 3 /* DECIMAL */ , defaultSuffix);
            case 23 /* HIRAGANA */ :
                return createCounterStyleFromSymbols(value, "\u3042\u3044\u3046\u3048\u304A\u304B\u304D\u304F\u3051\u3053\u3055\u3057\u3059\u305B\u305D\u305F\u3061\u3064\u3066\u3068\u306A\u306B\u306C\u306D\u306E\u306F\u3072\u3075\u3078\u307B\u307E\u307F\u3080\u3081\u3082\u3084\u3086\u3088\u3089\u308A\u308B\u308C\u308D\u308F\u3090\u3091\u3092\u3093");
            case 24 /* HIRAGANA_IROHA */ :
                return createCounterStyleFromSymbols(value, "\u3044\u308D\u306F\u306B\u307B\u3078\u3068\u3061\u308A\u306C\u308B\u3092\u308F\u304B\u3088\u305F\u308C\u305D\u3064\u306D\u306A\u3089\u3080\u3046\u3090\u306E\u304A\u304F\u3084\u307E\u3051\u3075\u3053\u3048\u3066\u3042\u3055\u304D\u3086\u3081\u307F\u3057\u3091\u3072\u3082\u305B\u3059");
            case 27 /* KANNADA */ :
                return createCounterStyleFromRange(value, 0xce6, 0xcef, true, defaultSuffix);
            case 28 /* KATAKANA */ :
                return createCounterStyleFromSymbols(value, "\u30A2\u30A4\u30A6\u30A8\u30AA\u30AB\u30AD\u30AF\u30B1\u30B3\u30B5\u30B7\u30B9\u30BB\u30BD\u30BF\u30C1\u30C4\u30C6\u30C8\u30CA\u30CB\u30CC\u30CD\u30CE\u30CF\u30D2\u30D5\u30D8\u30DB\u30DE\u30DF\u30E0\u30E1\u30E2\u30E4\u30E6\u30E8\u30E9\u30EA\u30EB\u30EC\u30ED\u30EF\u30F0\u30F1\u30F2\u30F3", cjkSuffix);
            case 29 /* KATAKANA_IROHA */ :
                return createCounterStyleFromSymbols(value, "\u30A4\u30ED\u30CF\u30CB\u30DB\u30D8\u30C8\u30C1\u30EA\u30CC\u30EB\u30F2\u30EF\u30AB\u30E8\u30BF\u30EC\u30BD\u30C4\u30CD\u30CA\u30E9\u30E0\u30A6\u30F0\u30CE\u30AA\u30AF\u30E4\u30DE\u30B1\u30D5\u30B3\u30A8\u30C6\u30A2\u30B5\u30AD\u30E6\u30E1\u30DF\u30B7\u30F1\u30D2\u30E2\u30BB\u30B9", cjkSuffix);
            case 34 /* LAO */ :
                return createCounterStyleFromRange(value, 0xed0, 0xed9, true, defaultSuffix);
            case 37 /* MONGOLIAN */ :
                return createCounterStyleFromRange(value, 0x1810, 0x1819, true, defaultSuffix);
            case 38 /* MYANMAR */ :
                return createCounterStyleFromRange(value, 0x1040, 0x1049, true, defaultSuffix);
            case 39 /* ORIYA */ :
                return createCounterStyleFromRange(value, 0xb66, 0xb6f, true, defaultSuffix);
            case 40 /* PERSIAN */ :
                return createCounterStyleFromRange(value, 0x6f0, 0x6f9, true, defaultSuffix);
            case 43 /* TAMIL */ :
                return createCounterStyleFromRange(value, 0xbe6, 0xbef, true, defaultSuffix);
            case 44 /* TELUGU */ :
                return createCounterStyleFromRange(value, 0xc66, 0xc6f, true, defaultSuffix);
            case 45 /* THAI */ :
                return createCounterStyleFromRange(value, 0xe50, 0xe59, true, defaultSuffix);
            case 46 /* TIBETAN */ :
                return createCounterStyleFromRange(value, 0xf20, 0xf29, true, defaultSuffix);
            case 3 /* DECIMAL */ :
            default:
                return createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
        }
    };
    var IGNORE_ATTRIBUTE = 'data-html2canvas-ignore';
    var DocumentCloner = /** @class */ function() {
        function DocumentCloner(context, element, options) {
            this.context = context;
            this.options = options;
            this.scrolledElements = [];
            this.referenceElement = element;
            this.counters = new CounterState();
            this.quoteDepth = 0;
            if (!element.ownerDocument) throw new Error('Cloned element does not have an owner document');
            this.documentElement = this.cloneNode(element.ownerDocument.documentElement, false);
        }
        DocumentCloner.prototype.toIFrame = function(ownerDocument, windowSize) {
            var _this = this;
            var iframe = createIFrameContainer(ownerDocument, windowSize);
            if (!iframe.contentWindow) return Promise.reject("Unable to find iframe window");
            var scrollX = ownerDocument.defaultView.pageXOffset;
            var scrollY = ownerDocument.defaultView.pageYOffset;
            var cloneWindow = iframe.contentWindow;
            var documentClone = cloneWindow.document;
            /* Chrome doesn't detect relative background-images assigned in inline <style> sheets when fetched through getComputedStyle
             if window url is about:blank, we can assign the url to current by writing onto the document
             */ var iframeLoad = iframeLoader(iframe).then(function() {
                return __awaiter(_this, void 0, void 0, function() {
                    var onclone, referenceElement;
                    return __generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                this.scrolledElements.forEach(restoreNodeScroll);
                                if (cloneWindow) {
                                    cloneWindow.scrollTo(windowSize.left, windowSize.top);
                                    if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent) && (cloneWindow.scrollY !== windowSize.top || cloneWindow.scrollX !== windowSize.left)) {
                                        this.context.logger.warn('Unable to restore scroll position for cloned document');
                                        this.context.windowBounds = this.context.windowBounds.add(cloneWindow.scrollX - windowSize.left, cloneWindow.scrollY - windowSize.top, 0, 0);
                                    }
                                }
                                onclone = this.options.onclone;
                                referenceElement = this.clonedReferenceElement;
                                if (typeof referenceElement === 'undefined') return [
                                    2 /*return*/ ,
                                    Promise.reject("Error finding the " + this.referenceElement.nodeName + " in the cloned document")
                                ];
                                if (!(documentClone.fonts && documentClone.fonts.ready)) return [
                                    3 /*break*/ ,
                                    2
                                ];
                                return [
                                    4 /*yield*/ ,
                                    documentClone.fonts.ready
                                ];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2:
                                if (!/(AppleWebKit)/g.test(navigator.userAgent)) return [
                                    3 /*break*/ ,
                                    4
                                ];
                                return [
                                    4 /*yield*/ ,
                                    imagesReady(documentClone)
                                ];
                            case 3:
                                _a.sent();
                                _a.label = 4;
                            case 4:
                                if (typeof onclone === 'function') return [
                                    2 /*return*/ ,
                                    Promise.resolve().then(function() {
                                        return onclone(documentClone, referenceElement);
                                    }).then(function() {
                                        return iframe;
                                    })
                                ];
                                return [
                                    2 /*return*/ ,
                                    iframe
                                ];
                        }
                    });
                });
            });
            documentClone.open();
            documentClone.write(serializeDoctype(document.doctype) + "<html></html>");
            // Chrome scrolls the parent document for some reason after the write to the cloned window???
            restoreOwnerScroll(this.referenceElement.ownerDocument, scrollX, scrollY);
            documentClone.replaceChild(documentClone.adoptNode(this.documentElement), documentClone.documentElement);
            documentClone.close();
            return iframeLoad;
        };
        DocumentCloner.prototype.createElementClone = function(node) {
            if (isDebugging(node, 2 /* CLONE */ )) debugger;
            if (isCanvasElement(node)) return this.createCanvasClone(node);
            if (isVideoElement(node)) return this.createVideoClone(node);
            if (isStyleElement(node)) return this.createStyleClone(node);
            var clone = node.cloneNode(false);
            if (isImageElement(clone)) {
                if (isImageElement(node) && node.currentSrc && node.currentSrc !== node.src) {
                    clone.src = node.currentSrc;
                    clone.srcset = '';
                }
                if (clone.loading === 'lazy') clone.loading = 'eager';
            }
            if (isCustomElement(clone)) return this.createCustomElementClone(clone);
            return clone;
        };
        DocumentCloner.prototype.createCustomElementClone = function(node) {
            var clone = document.createElement('html2canvascustomelement');
            copyCSSStyles(node.style, clone);
            return clone;
        };
        DocumentCloner.prototype.createStyleClone = function(node) {
            try {
                var sheet = node.sheet;
                if (sheet && sheet.cssRules) {
                    var css = [].slice.call(sheet.cssRules, 0).reduce(function(css, rule) {
                        if (rule && typeof rule.cssText === 'string') return css + rule.cssText;
                        return css;
                    }, '');
                    var style = node.cloneNode(false);
                    style.textContent = css;
                    return style;
                }
            } catch (e) {
                // accessing node.sheet.cssRules throws a DOMException
                this.context.logger.error('Unable to access cssRules property', e);
                if (e.name !== 'SecurityError') throw e;
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.createCanvasClone = function(canvas) {
            var _a;
            if (this.options.inlineImages && canvas.ownerDocument) {
                var img = canvas.ownerDocument.createElement('img');
                try {
                    img.src = canvas.toDataURL();
                    return img;
                } catch (e) {
                    this.context.logger.info("Unable to inline canvas contents, canvas is tainted", canvas);
                }
            }
            var clonedCanvas = canvas.cloneNode(false);
            try {
                clonedCanvas.width = canvas.width;
                clonedCanvas.height = canvas.height;
                var ctx = canvas.getContext('2d');
                var clonedCtx = clonedCanvas.getContext('2d');
                if (clonedCtx) {
                    if (!this.options.allowTaint && ctx) clonedCtx.putImageData(ctx.getImageData(0, 0, canvas.width, canvas.height), 0, 0);
                    else {
                        var gl = (_a = canvas.getContext('webgl2')) !== null && _a !== void 0 ? _a : canvas.getContext('webgl');
                        if (gl) {
                            var attribs = gl.getContextAttributes();
                            if ((attribs === null || attribs === void 0 ? void 0 : attribs.preserveDrawingBuffer) === false) this.context.logger.warn('Unable to clone WebGL context as it has preserveDrawingBuffer=false', canvas);
                        }
                        clonedCtx.drawImage(canvas, 0, 0);
                    }
                }
                return clonedCanvas;
            } catch (e) {
                this.context.logger.info("Unable to clone canvas as it is tainted", canvas);
            }
            return clonedCanvas;
        };
        DocumentCloner.prototype.createVideoClone = function(video) {
            var canvas = video.ownerDocument.createElement('canvas');
            canvas.width = video.offsetWidth;
            canvas.height = video.offsetHeight;
            var ctx = canvas.getContext('2d');
            try {
                if (ctx) {
                    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                    if (!this.options.allowTaint) ctx.getImageData(0, 0, canvas.width, canvas.height);
                }
                return canvas;
            } catch (e) {
                this.context.logger.info("Unable to clone video as it is tainted", video);
            }
            var blankCanvas = video.ownerDocument.createElement('canvas');
            blankCanvas.width = video.offsetWidth;
            blankCanvas.height = video.offsetHeight;
            return blankCanvas;
        };
        DocumentCloner.prototype.appendChildNode = function(clone, child, copyStyles) {
            if (!isElementNode(child) || !isScriptElement(child) && !child.hasAttribute(IGNORE_ATTRIBUTE) && (typeof this.options.ignoreElements !== 'function' || !this.options.ignoreElements(child))) {
                if (!this.options.copyStyles || !isElementNode(child) || !isStyleElement(child)) clone.appendChild(this.cloneNode(child, copyStyles));
            }
        };
        DocumentCloner.prototype.cloneChildNodes = function(node, clone, copyStyles) {
            var _this = this;
            for(var child = node.shadowRoot ? node.shadowRoot.firstChild : node.firstChild; child; child = child.nextSibling)if (isElementNode(child) && isSlotElement(child) && typeof child.assignedNodes === 'function') {
                var assignedNodes = child.assignedNodes();
                if (assignedNodes.length) assignedNodes.forEach(function(assignedNode) {
                    return _this.appendChildNode(clone, assignedNode, copyStyles);
                });
            } else this.appendChildNode(clone, child, copyStyles);
        };
        DocumentCloner.prototype.cloneNode = function(node, copyStyles) {
            if (isTextNode(node)) return document.createTextNode(node.data);
            if (!node.ownerDocument) return node.cloneNode(false);
            var window1 = node.ownerDocument.defaultView;
            if (window1 && isElementNode(node) && (isHTMLElementNode(node) || isSVGElementNode(node))) {
                var clone = this.createElementClone(node);
                clone.style.transitionProperty = 'none';
                var style = window1.getComputedStyle(node);
                var styleBefore = window1.getComputedStyle(node, ':before');
                var styleAfter = window1.getComputedStyle(node, ':after');
                if (this.referenceElement === node && isHTMLElementNode(clone)) this.clonedReferenceElement = clone;
                if (isBodyElement(clone)) createPseudoHideStyles(clone);
                var counters = this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
                var before = this.resolvePseudoContent(node, clone, styleBefore, PseudoElementType.BEFORE);
                if (isCustomElement(node)) copyStyles = true;
                if (!isVideoElement(node)) this.cloneChildNodes(node, clone, copyStyles);
                if (before) clone.insertBefore(before, clone.firstChild);
                var after = this.resolvePseudoContent(node, clone, styleAfter, PseudoElementType.AFTER);
                if (after) clone.appendChild(after);
                this.counters.pop(counters);
                if (style && (this.options.copyStyles || isSVGElementNode(node)) && !isIFrameElement(node) || copyStyles) copyCSSStyles(style, clone);
                if (node.scrollTop !== 0 || node.scrollLeft !== 0) this.scrolledElements.push([
                    clone,
                    node.scrollLeft,
                    node.scrollTop
                ]);
                if ((isTextareaElement(node) || isSelectElement(node)) && (isTextareaElement(clone) || isSelectElement(clone))) clone.value = node.value;
                return clone;
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.resolvePseudoContent = function(node, clone, style, pseudoElt) {
            var _this = this;
            if (!style) return;
            var value = style.content;
            var document1 = clone.ownerDocument;
            if (!document1 || !value || value === 'none' || value === '-moz-alt-content' || style.display === 'none') return;
            this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
            var declaration = new CSSParsedPseudoDeclaration(this.context, style);
            var anonymousReplacedElement = document1.createElement('html2canvaspseudoelement');
            copyCSSStyles(style, anonymousReplacedElement);
            declaration.content.forEach(function(token) {
                if (token.type === 0 /* STRING_TOKEN */ ) anonymousReplacedElement.appendChild(document1.createTextNode(token.value));
                else if (token.type === 22 /* URL_TOKEN */ ) {
                    var img = document1.createElement('img');
                    img.src = token.value;
                    img.style.opacity = '1';
                    anonymousReplacedElement.appendChild(img);
                } else if (token.type === 18 /* FUNCTION */ ) {
                    if (token.name === 'attr') {
                        var attr = token.values.filter(isIdentToken);
                        if (attr.length) anonymousReplacedElement.appendChild(document1.createTextNode(node.getAttribute(attr[0].value) || ''));
                    } else if (token.name === 'counter') {
                        var _a = token.values.filter(nonFunctionArgSeparator), counter = _a[0], counterStyle = _a[1];
                        if (counter && isIdentToken(counter)) {
                            var counterState = _this.counters.getCounterValue(counter.value);
                            var counterType = counterStyle && isIdentToken(counterStyle) ? listStyleType.parse(_this.context, counterStyle.value) : 3 /* DECIMAL */ ;
                            anonymousReplacedElement.appendChild(document1.createTextNode(createCounterText(counterState, counterType, false)));
                        }
                    } else if (token.name === 'counters') {
                        var _b = token.values.filter(nonFunctionArgSeparator), counter = _b[0], delim = _b[1], counterStyle = _b[2];
                        if (counter && isIdentToken(counter)) {
                            var counterStates = _this.counters.getCounterValues(counter.value);
                            var counterType_1 = counterStyle && isIdentToken(counterStyle) ? listStyleType.parse(_this.context, counterStyle.value) : 3 /* DECIMAL */ ;
                            var separator = delim && delim.type === 0 /* STRING_TOKEN */  ? delim.value : '';
                            var text = counterStates.map(function(value) {
                                return createCounterText(value, counterType_1, false);
                            }).join(separator);
                            anonymousReplacedElement.appendChild(document1.createTextNode(text));
                        }
                    }
                } else if (token.type === 20 /* IDENT_TOKEN */ ) switch(token.value){
                    case 'open-quote':
                        anonymousReplacedElement.appendChild(document1.createTextNode(getQuote(declaration.quotes, _this.quoteDepth++, true)));
                        break;
                    case 'close-quote':
                        anonymousReplacedElement.appendChild(document1.createTextNode(getQuote(declaration.quotes, --_this.quoteDepth, false)));
                        break;
                    default:
                        // safari doesn't parse string tokens correctly because of lack of quotes
                        anonymousReplacedElement.appendChild(document1.createTextNode(token.value));
                }
            });
            anonymousReplacedElement.className = PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            var newClassName = pseudoElt === PseudoElementType.BEFORE ? " " + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE : " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            if (isSVGElementNode(clone)) clone.className.baseValue += newClassName;
            else clone.className += newClassName;
            return anonymousReplacedElement;
        };
        DocumentCloner.destroy = function(container) {
            if (container.parentNode) {
                container.parentNode.removeChild(container);
                return true;
            }
            return false;
        };
        return DocumentCloner;
    }();
    var PseudoElementType;
    (function(PseudoElementType) {
        PseudoElementType[PseudoElementType["BEFORE"] = 0] = "BEFORE";
        PseudoElementType[PseudoElementType["AFTER"] = 1] = "AFTER";
    })(PseudoElementType || (PseudoElementType = {}));
    var createIFrameContainer = function(ownerDocument, bounds) {
        var cloneIframeContainer = ownerDocument.createElement('iframe');
        cloneIframeContainer.className = 'html2canvas-container';
        cloneIframeContainer.style.visibility = 'hidden';
        cloneIframeContainer.style.position = 'fixed';
        cloneIframeContainer.style.left = '-10000px';
        cloneIframeContainer.style.top = '0px';
        cloneIframeContainer.style.border = '0';
        cloneIframeContainer.width = bounds.width.toString();
        cloneIframeContainer.height = bounds.height.toString();
        cloneIframeContainer.scrolling = 'no'; // ios won't scroll without it
        cloneIframeContainer.setAttribute(IGNORE_ATTRIBUTE, 'true');
        ownerDocument.body.appendChild(cloneIframeContainer);
        return cloneIframeContainer;
    };
    var imageReady = function(img) {
        return new Promise(function(resolve) {
            if (img.complete) {
                resolve();
                return;
            }
            if (!img.src) {
                resolve();
                return;
            }
            img.onload = resolve;
            img.onerror = resolve;
        });
    };
    var imagesReady = function(document1) {
        return Promise.all([].slice.call(document1.images, 0).map(imageReady));
    };
    var iframeLoader = function(iframe) {
        return new Promise(function(resolve, reject) {
            var cloneWindow = iframe.contentWindow;
            if (!cloneWindow) return reject("No window assigned for iframe");
            var documentClone = cloneWindow.document;
            cloneWindow.onload = iframe.onload = function() {
                cloneWindow.onload = iframe.onload = null;
                var interval = setInterval(function() {
                    if (documentClone.body.childNodes.length > 0 && documentClone.readyState === 'complete') {
                        clearInterval(interval);
                        resolve(iframe);
                    }
                }, 50);
            };
        });
    };
    var ignoredStyleProperties = [
        'all',
        'd',
        'content' // Safari shows pseudoelements if content is set
    ];
    var copyCSSStyles = function(style, target) {
        // Edge does not provide value for cssText
        for(var i = style.length - 1; i >= 0; i--){
            var property = style.item(i);
            if (ignoredStyleProperties.indexOf(property) === -1) target.style.setProperty(property, style.getPropertyValue(property));
        }
        return target;
    };
    var serializeDoctype = function(doctype) {
        var str = '';
        if (doctype) {
            str += '<!DOCTYPE ';
            if (doctype.name) str += doctype.name;
            if (doctype.internalSubset) str += doctype.internalSubset;
            if (doctype.publicId) str += "\"" + doctype.publicId + "\"";
            if (doctype.systemId) str += "\"" + doctype.systemId + "\"";
            str += '>';
        }
        return str;
    };
    var restoreOwnerScroll = function(ownerDocument, x, y) {
        if (ownerDocument && ownerDocument.defaultView && (x !== ownerDocument.defaultView.pageXOffset || y !== ownerDocument.defaultView.pageYOffset)) ownerDocument.defaultView.scrollTo(x, y);
    };
    var restoreNodeScroll = function(_a) {
        var element = _a[0], x = _a[1], y = _a[2];
        element.scrollLeft = x;
        element.scrollTop = y;
    };
    var PSEUDO_BEFORE = ':before';
    var PSEUDO_AFTER = ':after';
    var PSEUDO_HIDE_ELEMENT_CLASS_BEFORE = '___html2canvas___pseudoelement_before';
    var PSEUDO_HIDE_ELEMENT_CLASS_AFTER = '___html2canvas___pseudoelement_after';
    var PSEUDO_HIDE_ELEMENT_STYLE = "{\n    content: \"\" !important;\n    display: none !important;\n}";
    var createPseudoHideStyles = function(body) {
        createStyles(body, "." + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + PSEUDO_BEFORE + PSEUDO_HIDE_ELEMENT_STYLE + "\n         ." + PSEUDO_HIDE_ELEMENT_CLASS_AFTER + PSEUDO_AFTER + PSEUDO_HIDE_ELEMENT_STYLE);
    };
    var createStyles = function(body, styles) {
        var document1 = body.ownerDocument;
        if (document1) {
            var style = document1.createElement('style');
            style.textContent = styles;
            body.appendChild(style);
        }
    };
    var CacheStorage = /** @class */ function() {
        function CacheStorage() {}
        CacheStorage.getOrigin = function(url) {
            var link = CacheStorage._link;
            if (!link) return 'about:blank';
            link.href = url;
            link.href = link.href; // IE9, LOL! - http://jsfiddle.net/niklasvh/2e48b/
            return link.protocol + link.hostname + link.port;
        };
        CacheStorage.isSameOrigin = function(src) {
            return CacheStorage.getOrigin(src) === CacheStorage._origin;
        };
        CacheStorage.setContext = function(window1) {
            CacheStorage._link = window1.document.createElement('a');
            CacheStorage._origin = CacheStorage.getOrigin(window1.location.href);
        };
        CacheStorage._origin = 'about:blank';
        return CacheStorage;
    }();
    var Cache = /** @class */ function() {
        function Cache(context, _options) {
            this.context = context;
            this._options = _options;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this._cache = {};
        }
        Cache.prototype.addImage = function(src) {
            var result = Promise.resolve();
            if (this.has(src)) return result;
            if (isBlobImage(src) || isRenderable(src)) {
                (this._cache[src] = this.loadImage(src)).catch(function() {
                // prevent unhandled rejection
                });
                return result;
            }
            return result;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Cache.prototype.match = function(src) {
            return this._cache[src];
        };
        Cache.prototype.loadImage = function(key) {
            return __awaiter(this, void 0, void 0, function() {
                var isSameOrigin, useCORS, useProxy, src;
                var _this = this;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            isSameOrigin = CacheStorage.isSameOrigin(key);
                            useCORS = !isInlineImage(key) && this._options.useCORS === true && FEATURES.SUPPORT_CORS_IMAGES && !isSameOrigin;
                            useProxy = !isInlineImage(key) && !isSameOrigin && !isBlobImage(key) && typeof this._options.proxy === 'string' && FEATURES.SUPPORT_CORS_XHR && !useCORS;
                            if (!isSameOrigin && this._options.allowTaint === false && !isInlineImage(key) && !isBlobImage(key) && !useProxy && !useCORS) return [
                                2 /*return*/ 
                            ];
                            src = key;
                            if (!useProxy) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.proxy(src)
                            ];
                        case 1:
                            src = _a.sent();
                            _a.label = 2;
                        case 2:
                            this.context.logger.debug("Added image " + key.substring(0, 256));
                            return [
                                4 /*yield*/ ,
                                new Promise(function(resolve, reject) {
                                    var img = new Image();
                                    img.onload = function() {
                                        return resolve(img);
                                    };
                                    img.onerror = reject;
                                    //ios safari 10.3 taints canvas with data urls unless crossOrigin is set to anonymous
                                    if (isInlineBase64Image(src) || useCORS) img.crossOrigin = 'anonymous';
                                    img.src = src;
                                    if (img.complete === true) // Inline XML images may fail to parse, throwing an Error later on
                                    setTimeout(function() {
                                        return resolve(img);
                                    }, 500);
                                    if (_this._options.imageTimeout > 0) setTimeout(function() {
                                        return reject("Timed out (" + _this._options.imageTimeout + "ms) loading image");
                                    }, _this._options.imageTimeout);
                                })
                            ];
                        case 3:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        };
        Cache.prototype.has = function(key) {
            return typeof this._cache[key] !== 'undefined';
        };
        Cache.prototype.keys = function() {
            return Promise.resolve(Object.keys(this._cache));
        };
        Cache.prototype.proxy = function(src) {
            var _this = this;
            var proxy = this._options.proxy;
            if (!proxy) throw new Error('No proxy defined');
            var key = src.substring(0, 256);
            return new Promise(function(resolve, reject) {
                var responseType = FEATURES.SUPPORT_RESPONSE_TYPE ? 'blob' : 'text';
                var xhr = new XMLHttpRequest();
                xhr.onload = function() {
                    if (xhr.status === 200) {
                        if (responseType === 'text') resolve(xhr.response);
                        else {
                            var reader_1 = new FileReader();
                            reader_1.addEventListener('load', function() {
                                return resolve(reader_1.result);
                            }, false);
                            reader_1.addEventListener('error', function(e) {
                                return reject(e);
                            }, false);
                            reader_1.readAsDataURL(xhr.response);
                        }
                    } else reject("Failed to proxy resource " + key + " with status code " + xhr.status);
                };
                xhr.onerror = reject;
                var queryString = proxy.indexOf('?') > -1 ? '&' : '?';
                xhr.open('GET', "" + proxy + queryString + "url=" + encodeURIComponent(src) + "&responseType=" + responseType);
                if (responseType !== 'text' && xhr instanceof XMLHttpRequest) xhr.responseType = responseType;
                if (_this._options.imageTimeout) {
                    var timeout_1 = _this._options.imageTimeout;
                    xhr.timeout = timeout_1;
                    xhr.ontimeout = function() {
                        return reject("Timed out (" + timeout_1 + "ms) proxying " + key);
                    };
                }
                xhr.send();
            });
        };
        return Cache;
    }();
    var INLINE_SVG = /^data:image\/svg\+xml/i;
    var INLINE_BASE64 = /^data:image\/.*;base64,/i;
    var INLINE_IMG = /^data:image\/.*/i;
    var isRenderable = function(src) {
        return FEATURES.SUPPORT_SVG_DRAWING || !isSVG(src);
    };
    var isInlineImage = function(src) {
        return INLINE_IMG.test(src);
    };
    var isInlineBase64Image = function(src) {
        return INLINE_BASE64.test(src);
    };
    var isBlobImage = function(src) {
        return src.substr(0, 4) === 'blob';
    };
    var isSVG = function(src) {
        return src.substr(-3).toLowerCase() === 'svg' || INLINE_SVG.test(src);
    };
    var Vector = /** @class */ function() {
        function Vector(x, y) {
            this.type = 0 /* VECTOR */ ;
            this.x = x;
            this.y = y;
        }
        Vector.prototype.add = function(deltaX, deltaY) {
            return new Vector(this.x + deltaX, this.y + deltaY);
        };
        return Vector;
    }();
    var lerp = function(a, b, t) {
        return new Vector(a.x + (b.x - a.x) * t, a.y + (b.y - a.y) * t);
    };
    var BezierCurve = /** @class */ function() {
        function BezierCurve(start, startControl, endControl, end) {
            this.type = 1 /* BEZIER_CURVE */ ;
            this.start = start;
            this.startControl = startControl;
            this.endControl = endControl;
            this.end = end;
        }
        BezierCurve.prototype.subdivide = function(t, firstHalf) {
            var ab = lerp(this.start, this.startControl, t);
            var bc = lerp(this.startControl, this.endControl, t);
            var cd = lerp(this.endControl, this.end, t);
            var abbc = lerp(ab, bc, t);
            var bccd = lerp(bc, cd, t);
            var dest = lerp(abbc, bccd, t);
            return firstHalf ? new BezierCurve(this.start, ab, abbc, dest) : new BezierCurve(dest, bccd, cd, this.end);
        };
        BezierCurve.prototype.add = function(deltaX, deltaY) {
            return new BezierCurve(this.start.add(deltaX, deltaY), this.startControl.add(deltaX, deltaY), this.endControl.add(deltaX, deltaY), this.end.add(deltaX, deltaY));
        };
        BezierCurve.prototype.reverse = function() {
            return new BezierCurve(this.end, this.endControl, this.startControl, this.start);
        };
        return BezierCurve;
    }();
    var isBezierCurve = function(path) {
        return path.type === 1 /* BEZIER_CURVE */ ;
    };
    var BoundCurves = /** @class */ function() {
        function BoundCurves(element) {
            var styles = element.styles;
            var bounds = element.bounds;
            var _a = getAbsoluteValueForTuple(styles.borderTopLeftRadius, bounds.width, bounds.height), tlh = _a[0], tlv = _a[1];
            var _b = getAbsoluteValueForTuple(styles.borderTopRightRadius, bounds.width, bounds.height), trh = _b[0], trv = _b[1];
            var _c = getAbsoluteValueForTuple(styles.borderBottomRightRadius, bounds.width, bounds.height), brh = _c[0], brv = _c[1];
            var _d = getAbsoluteValueForTuple(styles.borderBottomLeftRadius, bounds.width, bounds.height), blh = _d[0], blv = _d[1];
            var factors = [];
            factors.push((tlh + trh) / bounds.width);
            factors.push((blh + brh) / bounds.width);
            factors.push((tlv + blv) / bounds.height);
            factors.push((trv + brv) / bounds.height);
            var maxFactor = Math.max.apply(Math, factors);
            if (maxFactor > 1) {
                tlh /= maxFactor;
                tlv /= maxFactor;
                trh /= maxFactor;
                trv /= maxFactor;
                brh /= maxFactor;
                brv /= maxFactor;
                blh /= maxFactor;
                blv /= maxFactor;
            }
            var topWidth = bounds.width - trh;
            var rightHeight = bounds.height - brv;
            var bottomWidth = bounds.width - brh;
            var leftHeight = bounds.height - blv;
            var borderTopWidth = styles.borderTopWidth;
            var borderRightWidth = styles.borderRightWidth;
            var borderBottomWidth = styles.borderBottomWidth;
            var borderLeftWidth = styles.borderLeftWidth;
            var paddingTop = getAbsoluteValue(styles.paddingTop, element.bounds.width);
            var paddingRight = getAbsoluteValue(styles.paddingRight, element.bounds.width);
            var paddingBottom = getAbsoluteValue(styles.paddingBottom, element.bounds.width);
            var paddingLeft = getAbsoluteValue(styles.paddingLeft, element.bounds.width);
            this.topLeftBorderDoubleOuterBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3, tlh - borderLeftWidth / 3, tlv - borderTopWidth / 3, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3);
            this.topRightBorderDoubleOuterBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 3, trh - borderRightWidth / 3, trv - borderTopWidth / 3, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + borderTopWidth / 3);
            this.bottomRightBorderDoubleOuterBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 3, brv - borderBottomWidth / 3, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.bottomLeftBorderDoubleOuterBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + leftHeight, blh - borderLeftWidth / 3, blv - borderBottomWidth / 3, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.topLeftBorderDoubleInnerBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3, tlh - borderLeftWidth * 2 / 3, tlv - borderTopWidth * 2 / 3, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3);
            this.topRightBorderDoubleInnerBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth * 2 / 3, trh - borderRightWidth * 2 / 3, trv - borderTopWidth * 2 / 3, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3);
            this.bottomRightBorderDoubleInnerBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth * 2 / 3, brv - borderBottomWidth * 2 / 3, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth * 2 / 3, bounds.top + bounds.height - borderBottomWidth * 2 / 3);
            this.bottomLeftBorderDoubleInnerBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth * 2 / 3, bounds.top + leftHeight, blh - borderLeftWidth * 2 / 3, blv - borderBottomWidth * 2 / 3, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth * 2 / 3, bounds.top + bounds.height - borderBottomWidth * 2 / 3);
            this.topLeftBorderStroke = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2, tlh - borderLeftWidth / 2, tlv - borderTopWidth / 2, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2);
            this.topRightBorderStroke = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 2, trh - borderRightWidth / 2, trv - borderTopWidth / 2, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + borderTopWidth / 2);
            this.bottomRightBorderStroke = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 2, brv - borderBottomWidth / 2, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.bottomLeftBorderStroke = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + leftHeight, blh - borderLeftWidth / 2, blv - borderBottomWidth / 2, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.topLeftBorderBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left, bounds.top, tlh, tlv, CORNER.TOP_LEFT) : new Vector(bounds.left, bounds.top);
            this.topRightBorderBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top, trh, trv, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width, bounds.top);
            this.bottomRightBorderBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh, brv, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width, bounds.top + bounds.height);
            this.bottomLeftBorderBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left, bounds.top + leftHeight, blh, blv, CORNER.BOTTOM_LEFT) : new Vector(bounds.left, bounds.top + bounds.height);
            this.topLeftPaddingBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + borderTopWidth, Math.max(0, tlh - borderLeftWidth), Math.max(0, tlv - borderTopWidth), CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth, bounds.top + borderTopWidth);
            this.topRightPaddingBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width - borderRightWidth), bounds.top + borderTopWidth, topWidth > bounds.width + borderRightWidth ? 0 : Math.max(0, trh - borderRightWidth), Math.max(0, trv - borderTopWidth), CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + borderTopWidth);
            this.bottomRightPaddingBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - borderLeftWidth), bounds.top + Math.min(rightHeight, bounds.height - borderBottomWidth), Math.max(0, brh - borderRightWidth), Math.max(0, brv - borderBottomWidth), CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + bounds.height - borderBottomWidth);
            this.bottomLeftPaddingBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + Math.min(leftHeight, bounds.height - borderBottomWidth), Math.max(0, blh - borderLeftWidth), Math.max(0, blv - borderBottomWidth), CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth, bounds.top + bounds.height - borderBottomWidth);
            this.topLeftContentBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop, Math.max(0, tlh - (borderLeftWidth + paddingLeft)), Math.max(0, tlv - (borderTopWidth + paddingTop)), CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop);
            this.topRightContentBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width + borderLeftWidth + paddingLeft), bounds.top + borderTopWidth + paddingTop, topWidth > bounds.width + borderLeftWidth + paddingLeft ? 0 : trh - borderLeftWidth + paddingLeft, trv - (borderTopWidth + paddingTop), CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + borderTopWidth + paddingTop);
            this.bottomRightContentBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - (borderLeftWidth + paddingLeft)), bounds.top + Math.min(rightHeight, bounds.height + borderTopWidth + paddingTop), Math.max(0, brh - (borderRightWidth + paddingRight)), brv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
            this.bottomLeftContentBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + leftHeight, Math.max(0, blh - (borderLeftWidth + paddingLeft)), blv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
        }
        return BoundCurves;
    }();
    var CORNER;
    (function(CORNER) {
        CORNER[CORNER["TOP_LEFT"] = 0] = "TOP_LEFT";
        CORNER[CORNER["TOP_RIGHT"] = 1] = "TOP_RIGHT";
        CORNER[CORNER["BOTTOM_RIGHT"] = 2] = "BOTTOM_RIGHT";
        CORNER[CORNER["BOTTOM_LEFT"] = 3] = "BOTTOM_LEFT";
    })(CORNER || (CORNER = {}));
    var getCurvePoints = function(x, y, r1, r2, position) {
        var kappa = 4 * ((Math.sqrt(2) - 1) / 3);
        var ox = r1 * kappa; // control point offset horizontal
        var oy = r2 * kappa; // control point offset vertical
        var xm = x + r1; // x-middle
        var ym = y + r2; // y-middle
        switch(position){
            case CORNER.TOP_LEFT:
                return new BezierCurve(new Vector(x, ym), new Vector(x, ym - oy), new Vector(xm - ox, y), new Vector(xm, y));
            case CORNER.TOP_RIGHT:
                return new BezierCurve(new Vector(x, y), new Vector(x + ox, y), new Vector(xm, ym - oy), new Vector(xm, ym));
            case CORNER.BOTTOM_RIGHT:
                return new BezierCurve(new Vector(xm, y), new Vector(xm, y + oy), new Vector(x + ox, ym), new Vector(x, ym));
            case CORNER.BOTTOM_LEFT:
            default:
                return new BezierCurve(new Vector(xm, ym), new Vector(xm - ox, ym), new Vector(x, y + oy), new Vector(x, y));
        }
    };
    var calculateBorderBoxPath = function(curves) {
        return [
            curves.topLeftBorderBox,
            curves.topRightBorderBox,
            curves.bottomRightBorderBox,
            curves.bottomLeftBorderBox
        ];
    };
    var calculateContentBoxPath = function(curves) {
        return [
            curves.topLeftContentBox,
            curves.topRightContentBox,
            curves.bottomRightContentBox,
            curves.bottomLeftContentBox
        ];
    };
    var calculatePaddingBoxPath = function(curves) {
        return [
            curves.topLeftPaddingBox,
            curves.topRightPaddingBox,
            curves.bottomRightPaddingBox,
            curves.bottomLeftPaddingBox
        ];
    };
    var TransformEffect = /** @class */ function() {
        function TransformEffect(offsetX, offsetY, matrix) {
            this.offsetX = offsetX;
            this.offsetY = offsetY;
            this.matrix = matrix;
            this.type = 0 /* TRANSFORM */ ;
            this.target = 6 /* CONTENT */ ;
        }
        return TransformEffect;
    }();
    var ClipEffect = /** @class */ function() {
        function ClipEffect(path, target) {
            this.path = path;
            this.target = target;
            this.type = 1 /* CLIP */ ;
        }
        return ClipEffect;
    }();
    var OpacityEffect = /** @class */ function() {
        function OpacityEffect(opacity) {
            this.opacity = opacity;
            this.type = 2 /* OPACITY */ ;
            this.target = 6 /* CONTENT */ ;
        }
        return OpacityEffect;
    }();
    var isTransformEffect = function(effect) {
        return effect.type === 0 /* TRANSFORM */ ;
    };
    var isClipEffect = function(effect) {
        return effect.type === 1 /* CLIP */ ;
    };
    var isOpacityEffect = function(effect) {
        return effect.type === 2 /* OPACITY */ ;
    };
    var equalPath = function(a, b) {
        if (a.length === b.length) return a.some(function(v, i) {
            return v === b[i];
        });
        return false;
    };
    var transformPath = function(path, deltaX, deltaY, deltaW, deltaH) {
        return path.map(function(point, index) {
            switch(index){
                case 0:
                    return point.add(deltaX, deltaY);
                case 1:
                    return point.add(deltaX + deltaW, deltaY);
                case 2:
                    return point.add(deltaX + deltaW, deltaY + deltaH);
                case 3:
                    return point.add(deltaX, deltaY + deltaH);
            }
            return point;
        });
    };
    var StackingContext = /** @class */ function() {
        function StackingContext(container) {
            this.element = container;
            this.inlineLevel = [];
            this.nonInlineLevel = [];
            this.negativeZIndex = [];
            this.zeroOrAutoZIndexOrTransformedOrOpacity = [];
            this.positiveZIndex = [];
            this.nonPositionedFloats = [];
            this.nonPositionedInlineLevel = [];
        }
        return StackingContext;
    }();
    var ElementPaint = /** @class */ function() {
        function ElementPaint(container, parent) {
            this.container = container;
            this.parent = parent;
            this.effects = [];
            this.curves = new BoundCurves(this.container);
            if (this.container.styles.opacity < 1) this.effects.push(new OpacityEffect(this.container.styles.opacity));
            if (this.container.styles.transform !== null) {
                var offsetX = this.container.bounds.left + this.container.styles.transformOrigin[0].number;
                var offsetY = this.container.bounds.top + this.container.styles.transformOrigin[1].number;
                var matrix = this.container.styles.transform;
                this.effects.push(new TransformEffect(offsetX, offsetY, matrix));
            }
            if (this.container.styles.overflowX !== 0 /* VISIBLE */ ) {
                var borderBox = calculateBorderBoxPath(this.curves);
                var paddingBox = calculatePaddingBoxPath(this.curves);
                if (equalPath(borderBox, paddingBox)) this.effects.push(new ClipEffect(borderBox, 6 /* CONTENT */ ));
                else {
                    this.effects.push(new ClipEffect(borderBox, 2 /* BACKGROUND_BORDERS */ ));
                    this.effects.push(new ClipEffect(paddingBox, 4 /* CONTENT */ ));
                }
            }
        }
        ElementPaint.prototype.getEffects = function(target) {
            var inFlow = [
                2 /* ABSOLUTE */ ,
                3 /* FIXED */ 
            ].indexOf(this.container.styles.position) === -1;
            var parent = this.parent;
            var effects = this.effects.slice(0);
            while(parent){
                var croplessEffects = parent.effects.filter(function(effect) {
                    return !isClipEffect(effect);
                });
                if (inFlow || parent.container.styles.position !== 0 /* STATIC */  || !parent.parent) {
                    effects.unshift.apply(effects, croplessEffects);
                    inFlow = [
                        2 /* ABSOLUTE */ ,
                        3 /* FIXED */ 
                    ].indexOf(parent.container.styles.position) === -1;
                    if (parent.container.styles.overflowX !== 0 /* VISIBLE */ ) {
                        var borderBox = calculateBorderBoxPath(parent.curves);
                        var paddingBox = calculatePaddingBoxPath(parent.curves);
                        if (!equalPath(borderBox, paddingBox)) effects.unshift(new ClipEffect(paddingBox, 6 /* CONTENT */ ));
                    }
                } else effects.unshift.apply(effects, croplessEffects);
                parent = parent.parent;
            }
            return effects.filter(function(effect) {
                return contains(effect.target, target);
            });
        };
        return ElementPaint;
    }();
    var parseStackTree = function(parent, stackingContext, realStackingContext, listItems) {
        parent.container.elements.forEach(function(child) {
            var treatAsRealStackingContext = contains(child.flags, 4 /* CREATES_REAL_STACKING_CONTEXT */ );
            var createsStackingContext = contains(child.flags, 2 /* CREATES_STACKING_CONTEXT */ );
            var paintContainer = new ElementPaint(child, parent);
            if (contains(child.styles.display, 2048 /* LIST_ITEM */ )) listItems.push(paintContainer);
            var listOwnerItems = contains(child.flags, 8 /* IS_LIST_OWNER */ ) ? [] : listItems;
            if (treatAsRealStackingContext || createsStackingContext) {
                var parentStack = treatAsRealStackingContext || child.styles.isPositioned() ? realStackingContext : stackingContext;
                var stack = new StackingContext(paintContainer);
                if (child.styles.isPositioned() || child.styles.opacity < 1 || child.styles.isTransformed()) {
                    var order_1 = child.styles.zIndex.order;
                    if (order_1 < 0) {
                        var index_1 = 0;
                        parentStack.negativeZIndex.some(function(current, i) {
                            if (order_1 > current.element.container.styles.zIndex.order) {
                                index_1 = i;
                                return false;
                            } else if (index_1 > 0) return true;
                            return false;
                        });
                        parentStack.negativeZIndex.splice(index_1, 0, stack);
                    } else if (order_1 > 0) {
                        var index_2 = 0;
                        parentStack.positiveZIndex.some(function(current, i) {
                            if (order_1 >= current.element.container.styles.zIndex.order) {
                                index_2 = i + 1;
                                return false;
                            } else if (index_2 > 0) return true;
                            return false;
                        });
                        parentStack.positiveZIndex.splice(index_2, 0, stack);
                    } else parentStack.zeroOrAutoZIndexOrTransformedOrOpacity.push(stack);
                } else if (child.styles.isFloating()) parentStack.nonPositionedFloats.push(stack);
                else parentStack.nonPositionedInlineLevel.push(stack);
                parseStackTree(paintContainer, stack, treatAsRealStackingContext ? stack : realStackingContext, listOwnerItems);
            } else {
                if (child.styles.isInlineLevel()) stackingContext.inlineLevel.push(paintContainer);
                else stackingContext.nonInlineLevel.push(paintContainer);
                parseStackTree(paintContainer, stackingContext, realStackingContext, listOwnerItems);
            }
            if (contains(child.flags, 8 /* IS_LIST_OWNER */ )) processListItems(child, listOwnerItems);
        });
    };
    var processListItems = function(owner, elements) {
        var numbering = owner instanceof OLElementContainer ? owner.start : 1;
        var reversed = owner instanceof OLElementContainer ? owner.reversed : false;
        for(var i = 0; i < elements.length; i++){
            var item = elements[i];
            if (item.container instanceof LIElementContainer && typeof item.container.value === 'number' && item.container.value !== 0) numbering = item.container.value;
            item.listValue = createCounterText(numbering, item.container.styles.listStyleType, true);
            numbering += reversed ? -1 : 1;
        }
    };
    var parseStackingContexts = function(container) {
        var paintContainer = new ElementPaint(container, null);
        var root = new StackingContext(paintContainer);
        var listItems = [];
        parseStackTree(paintContainer, root, root, listItems);
        processListItems(paintContainer.container, listItems);
        return root;
    };
    var parsePathForBorder = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftPaddingBox, curves.topRightBorderBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightPaddingBox, curves.bottomRightBorderBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox, curves.topLeftBorderBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderDoubleOuter = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox, curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox, curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox, curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox, curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox);
        }
    };
    var parsePathForBorderDoubleInner = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox, curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox, curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox, curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderStroke = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createStrokePathFromCurves(curves.topLeftBorderStroke, curves.topRightBorderStroke);
            case 1:
                return createStrokePathFromCurves(curves.topRightBorderStroke, curves.bottomRightBorderStroke);
            case 2:
                return createStrokePathFromCurves(curves.bottomRightBorderStroke, curves.bottomLeftBorderStroke);
            case 3:
            default:
                return createStrokePathFromCurves(curves.bottomLeftBorderStroke, curves.topLeftBorderStroke);
        }
    };
    var createStrokePathFromCurves = function(outer1, outer2) {
        var path = [];
        if (isBezierCurve(outer1)) path.push(outer1.subdivide(0.5, false));
        else path.push(outer1);
        if (isBezierCurve(outer2)) path.push(outer2.subdivide(0.5, true));
        else path.push(outer2);
        return path;
    };
    var createPathFromCurves = function(outer1, inner1, outer2, inner2) {
        var path = [];
        if (isBezierCurve(outer1)) path.push(outer1.subdivide(0.5, false));
        else path.push(outer1);
        if (isBezierCurve(outer2)) path.push(outer2.subdivide(0.5, true));
        else path.push(outer2);
        if (isBezierCurve(inner2)) path.push(inner2.subdivide(0.5, true).reverse());
        else path.push(inner2);
        if (isBezierCurve(inner1)) path.push(inner1.subdivide(0.5, false).reverse());
        else path.push(inner1);
        return path;
    };
    var paddingBox = function(element) {
        var bounds = element.bounds;
        var styles = element.styles;
        return bounds.add(styles.borderLeftWidth, styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth), -(styles.borderTopWidth + styles.borderBottomWidth));
    };
    var contentBox = function(element) {
        var styles = element.styles;
        var bounds = element.bounds;
        var paddingLeft = getAbsoluteValue(styles.paddingLeft, bounds.width);
        var paddingRight = getAbsoluteValue(styles.paddingRight, bounds.width);
        var paddingTop = getAbsoluteValue(styles.paddingTop, bounds.width);
        var paddingBottom = getAbsoluteValue(styles.paddingBottom, bounds.width);
        return bounds.add(paddingLeft + styles.borderLeftWidth, paddingTop + styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth + paddingLeft + paddingRight), -(styles.borderTopWidth + styles.borderBottomWidth + paddingTop + paddingBottom));
    };
    var calculateBackgroundPositioningArea = function(backgroundOrigin, element) {
        if (backgroundOrigin === 0 /* BORDER_BOX */ ) return element.bounds;
        if (backgroundOrigin === 2 /* CONTENT_BOX */ ) return contentBox(element);
        return paddingBox(element);
    };
    var calculateBackgroundPaintingArea = function(backgroundClip, element) {
        if (backgroundClip === 0 /* BORDER_BOX */ ) return element.bounds;
        if (backgroundClip === 2 /* CONTENT_BOX */ ) return contentBox(element);
        return paddingBox(element);
    };
    var calculateBackgroundRendering = function(container, index, intrinsicSize) {
        var backgroundPositioningArea = calculateBackgroundPositioningArea(getBackgroundValueForIndex(container.styles.backgroundOrigin, index), container);
        var backgroundPaintingArea = calculateBackgroundPaintingArea(getBackgroundValueForIndex(container.styles.backgroundClip, index), container);
        var backgroundImageSize = calculateBackgroundSize(getBackgroundValueForIndex(container.styles.backgroundSize, index), intrinsicSize, backgroundPositioningArea);
        var sizeWidth = backgroundImageSize[0], sizeHeight = backgroundImageSize[1];
        var position = getAbsoluteValueForTuple(getBackgroundValueForIndex(container.styles.backgroundPosition, index), backgroundPositioningArea.width - sizeWidth, backgroundPositioningArea.height - sizeHeight);
        var path = calculateBackgroundRepeatPath(getBackgroundValueForIndex(container.styles.backgroundRepeat, index), position, backgroundImageSize, backgroundPositioningArea, backgroundPaintingArea);
        var offsetX = Math.round(backgroundPositioningArea.left + position[0]);
        var offsetY = Math.round(backgroundPositioningArea.top + position[1]);
        return [
            path,
            offsetX,
            offsetY,
            sizeWidth,
            sizeHeight
        ];
    };
    var isAuto = function(token) {
        return isIdentToken(token) && token.value === BACKGROUND_SIZE.AUTO;
    };
    var hasIntrinsicValue = function(value) {
        return typeof value === 'number';
    };
    var calculateBackgroundSize = function(size, _a, bounds) {
        var intrinsicWidth = _a[0], intrinsicHeight = _a[1], intrinsicProportion = _a[2];
        var first = size[0], second = size[1];
        if (!first) return [
            0,
            0
        ];
        if (isLengthPercentage(first) && second && isLengthPercentage(second)) return [
            getAbsoluteValue(first, bounds.width),
            getAbsoluteValue(second, bounds.height)
        ];
        var hasIntrinsicProportion = hasIntrinsicValue(intrinsicProportion);
        if (isIdentToken(first) && (first.value === BACKGROUND_SIZE.CONTAIN || first.value === BACKGROUND_SIZE.COVER)) {
            if (hasIntrinsicValue(intrinsicProportion)) {
                var targetRatio = bounds.width / bounds.height;
                return targetRatio < intrinsicProportion !== (first.value === BACKGROUND_SIZE.COVER) ? [
                    bounds.width,
                    bounds.width / intrinsicProportion
                ] : [
                    bounds.height * intrinsicProportion,
                    bounds.height
                ];
            }
            return [
                bounds.width,
                bounds.height
            ];
        }
        var hasIntrinsicWidth = hasIntrinsicValue(intrinsicWidth);
        var hasIntrinsicHeight = hasIntrinsicValue(intrinsicHeight);
        var hasIntrinsicDimensions = hasIntrinsicWidth || hasIntrinsicHeight;
        // If the background-size is auto or auto auto:
        if (isAuto(first) && (!second || isAuto(second))) {
            // If the image has both horizontal and vertical intrinsic dimensions, it's rendered at that size.
            if (hasIntrinsicWidth && hasIntrinsicHeight) return [
                intrinsicWidth,
                intrinsicHeight
            ];
            // If the image has no intrinsic dimensions and has no intrinsic proportions,
            // it's rendered at the size of the background positioning area.
            if (!hasIntrinsicProportion && !hasIntrinsicDimensions) return [
                bounds.width,
                bounds.height
            ];
            // TODO If the image has no intrinsic dimensions but has intrinsic proportions, it's rendered as if contain had been specified instead.
            // If the image has only one intrinsic dimension and has intrinsic proportions, it's rendered at the size corresponding to that one dimension.
            // The other dimension is computed using the specified dimension and the intrinsic proportions.
            if (hasIntrinsicDimensions && hasIntrinsicProportion) {
                var width_1 = hasIntrinsicWidth ? intrinsicWidth : intrinsicHeight * intrinsicProportion;
                var height_1 = hasIntrinsicHeight ? intrinsicHeight : intrinsicWidth / intrinsicProportion;
                return [
                    width_1,
                    height_1
                ];
            }
            // If the image has only one intrinsic dimension but has no intrinsic proportions,
            // it's rendered using the specified dimension and the other dimension of the background positioning area.
            var width_2 = hasIntrinsicWidth ? intrinsicWidth : bounds.width;
            var height_2 = hasIntrinsicHeight ? intrinsicHeight : bounds.height;
            return [
                width_2,
                height_2
            ];
        }
        // If the image has intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the specified dimension and the intrinsic proportions.
        if (hasIntrinsicProportion) {
            var width_3 = 0;
            var height_3 = 0;
            if (isLengthPercentage(first)) width_3 = getAbsoluteValue(first, bounds.width);
            else if (isLengthPercentage(second)) height_3 = getAbsoluteValue(second, bounds.height);
            if (isAuto(first)) width_3 = height_3 * intrinsicProportion;
            else if (!second || isAuto(second)) height_3 = width_3 / intrinsicProportion;
            return [
                width_3,
                height_3
            ];
        }
        // If the image has no intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the image's corresponding intrinsic dimension,
        // if there is one. If there is no such intrinsic dimension,
        // it becomes the corresponding dimension of the background positioning area.
        var width = null;
        var height = null;
        if (isLengthPercentage(first)) width = getAbsoluteValue(first, bounds.width);
        else if (second && isLengthPercentage(second)) height = getAbsoluteValue(second, bounds.height);
        if (width !== null && (!second || isAuto(second))) height = hasIntrinsicWidth && hasIntrinsicHeight ? width / intrinsicWidth * intrinsicHeight : bounds.height;
        if (height !== null && isAuto(first)) width = hasIntrinsicWidth && hasIntrinsicHeight ? height / intrinsicHeight * intrinsicWidth : bounds.width;
        if (width !== null && height !== null) return [
            width,
            height
        ];
        throw new Error("Unable to calculate background-size for element");
    };
    var getBackgroundValueForIndex = function(values, index) {
        var value = values[index];
        if (typeof value === 'undefined') return values[0];
        return value;
    };
    var calculateBackgroundRepeatPath = function(repeat, _a, _b, backgroundPositioningArea, backgroundPaintingArea) {
        var x = _a[0], y = _a[1];
        var width = _b[0], height = _b[1];
        switch(repeat){
            case 2 /* REPEAT_X */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(height + backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(height + backgroundPositioningArea.top + y))
                ];
            case 3 /* REPEAT_Y */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top))
                ];
            case 1 /* NO_REPEAT */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y + height)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y + height))
                ];
            default:
                return [
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top))
                ];
        }
    };
    var SMALL_IMAGE = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
    var SAMPLE_TEXT = 'Hidden Text';
    var FontMetrics = /** @class */ function() {
        function FontMetrics(document1) {
            this._data = {};
            this._document = document1;
        }
        FontMetrics.prototype.parseMetrics = function(fontFamily, fontSize) {
            var container = this._document.createElement('div');
            var img = this._document.createElement('img');
            var span = this._document.createElement('span');
            var body = this._document.body;
            container.style.visibility = 'hidden';
            container.style.fontFamily = fontFamily;
            container.style.fontSize = fontSize;
            container.style.margin = '0';
            container.style.padding = '0';
            container.style.whiteSpace = 'nowrap';
            body.appendChild(container);
            img.src = SMALL_IMAGE;
            img.width = 1;
            img.height = 1;
            img.style.margin = '0';
            img.style.padding = '0';
            img.style.verticalAlign = 'baseline';
            span.style.fontFamily = fontFamily;
            span.style.fontSize = fontSize;
            span.style.margin = '0';
            span.style.padding = '0';
            span.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.appendChild(span);
            container.appendChild(img);
            var baseline = img.offsetTop - span.offsetTop + 2;
            container.removeChild(span);
            container.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.style.lineHeight = 'normal';
            img.style.verticalAlign = 'super';
            var middle = img.offsetTop - container.offsetTop + 2;
            body.removeChild(container);
            return {
                baseline: baseline,
                middle: middle
            };
        };
        FontMetrics.prototype.getMetrics = function(fontFamily, fontSize) {
            var key = fontFamily + " " + fontSize;
            if (typeof this._data[key] === 'undefined') this._data[key] = this.parseMetrics(fontFamily, fontSize);
            return this._data[key];
        };
        return FontMetrics;
    }();
    var Renderer = /** @class */ function() {
        function Renderer(context, options) {
            this.context = context;
            this.options = options;
        }
        return Renderer;
    }();
    var MASK_OFFSET = 10000;
    var CanvasRenderer = /** @class */ function(_super) {
        __extends(CanvasRenderer, _super);
        function CanvasRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this._activeEffects = [];
            _this.canvas = options.canvas ? options.canvas : document.createElement('canvas');
            _this.ctx = _this.canvas.getContext('2d');
            if (!options.canvas) {
                _this.canvas.width = Math.floor(options.width * options.scale);
                _this.canvas.height = Math.floor(options.height * options.scale);
                _this.canvas.style.width = options.width + "px";
                _this.canvas.style.height = options.height + "px";
            }
            _this.fontMetrics = new FontMetrics(document);
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.ctx.textBaseline = 'bottom';
            _this._activeEffects = [];
            _this.context.logger.debug("Canvas renderer initialized (" + options.width + "x" + options.height + ") with scale " + options.scale);
            return _this;
        }
        CanvasRenderer.prototype.applyEffects = function(effects) {
            var _this = this;
            while(this._activeEffects.length)this.popEffect();
            effects.forEach(function(effect) {
                return _this.applyEffect(effect);
            });
        };
        CanvasRenderer.prototype.applyEffect = function(effect) {
            this.ctx.save();
            if (isOpacityEffect(effect)) this.ctx.globalAlpha = effect.opacity;
            if (isTransformEffect(effect)) {
                this.ctx.translate(effect.offsetX, effect.offsetY);
                this.ctx.transform(effect.matrix[0], effect.matrix[1], effect.matrix[2], effect.matrix[3], effect.matrix[4], effect.matrix[5]);
                this.ctx.translate(-effect.offsetX, -effect.offsetY);
            }
            if (isClipEffect(effect)) {
                this.path(effect.path);
                this.ctx.clip();
            }
            this._activeEffects.push(effect);
        };
        CanvasRenderer.prototype.popEffect = function() {
            this._activeEffects.pop();
            this.ctx.restore();
        };
        CanvasRenderer.prototype.renderStack = function(stack) {
            return __awaiter(this, void 0, void 0, function() {
                var styles;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            styles = stack.element.container.styles;
                            if (!styles.isVisible()) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderStackContent(stack)
                            ];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNode = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (contains(paint.container.flags, 16 /* DEBUG_RENDER */ )) debugger;
                            if (!paint.container.styles.isVisible()) return [
                                3 /*break*/ ,
                                3
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderNodeBackgroundAndBorders(paint)
                            ];
                        case 1:
                            _a.sent();
                            return [
                                4 /*yield*/ ,
                                this.renderNodeContent(paint)
                            ];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderTextWithLetterSpacing = function(text, letterSpacing, baseline) {
            var _this = this;
            if (letterSpacing === 0) this.ctx.fillText(text.text, text.bounds.left, text.bounds.top + baseline);
            else {
                var letters = segmentGraphemes(text.text);
                letters.reduce(function(left, letter) {
                    _this.ctx.fillText(letter, left, text.bounds.top + baseline);
                    return left + _this.ctx.measureText(letter).width;
                }, text.bounds.left);
            }
        };
        CanvasRenderer.prototype.createFontStyle = function(styles) {
            var fontVariant = styles.fontVariant.filter(function(variant) {
                return variant === 'normal' || variant === 'small-caps';
            }).join('');
            var fontFamily = fixIOSSystemFonts(styles.fontFamily).join(', ');
            var fontSize = isDimensionToken(styles.fontSize) ? "" + styles.fontSize.number + styles.fontSize.unit : styles.fontSize.number + "px";
            return [
                [
                    styles.fontStyle,
                    fontVariant,
                    styles.fontWeight,
                    fontSize,
                    fontFamily
                ].join(' '),
                fontFamily,
                fontSize
            ];
        };
        CanvasRenderer.prototype.renderTextNode = function(text, styles) {
            return __awaiter(this, void 0, void 0, function() {
                var _a, font, fontFamily, fontSize, _b, baseline, middle, paintOrder;
                var _this = this;
                return __generator(this, function(_c) {
                    _a = this.createFontStyle(styles), font = _a[0], fontFamily = _a[1], fontSize = _a[2];
                    this.ctx.font = font;
                    this.ctx.direction = styles.direction === 1 /* RTL */  ? 'rtl' : 'ltr';
                    this.ctx.textAlign = 'left';
                    this.ctx.textBaseline = 'alphabetic';
                    _b = this.fontMetrics.getMetrics(fontFamily, fontSize), baseline = _b.baseline, middle = _b.middle;
                    paintOrder = styles.paintOrder;
                    text.textBounds.forEach(function(text) {
                        paintOrder.forEach(function(paintOrderLayer) {
                            switch(paintOrderLayer){
                                case 0 /* FILL */ :
                                    _this.ctx.fillStyle = asString(styles.color);
                                    _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                    var textShadows = styles.textShadow;
                                    if (textShadows.length && text.text.trim().length) {
                                        textShadows.slice(0).reverse().forEach(function(textShadow) {
                                            _this.ctx.shadowColor = asString(textShadow.color);
                                            _this.ctx.shadowOffsetX = textShadow.offsetX.number * _this.options.scale;
                                            _this.ctx.shadowOffsetY = textShadow.offsetY.number * _this.options.scale;
                                            _this.ctx.shadowBlur = textShadow.blur.number;
                                            _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                        });
                                        _this.ctx.shadowColor = '';
                                        _this.ctx.shadowOffsetX = 0;
                                        _this.ctx.shadowOffsetY = 0;
                                        _this.ctx.shadowBlur = 0;
                                    }
                                    if (styles.textDecorationLine.length) {
                                        _this.ctx.fillStyle = asString(styles.textDecorationColor || styles.color);
                                        styles.textDecorationLine.forEach(function(textDecorationLine) {
                                            switch(textDecorationLine){
                                                case 1 /* UNDERLINE */ :
                                                    // Draws a line at the baseline of the font
                                                    // TODO As some browsers display the line as more than 1px if the font-size is big,
                                                    // need to take that into account both in position and size
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top + baseline), text.bounds.width, 1);
                                                    break;
                                                case 2 /* OVERLINE */ :
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top), text.bounds.width, 1);
                                                    break;
                                                case 3 /* LINE_THROUGH */ :
                                                    // TODO try and find exact position for line-through
                                                    _this.ctx.fillRect(text.bounds.left, Math.ceil(text.bounds.top + middle), text.bounds.width, 1);
                                                    break;
                                            }
                                        });
                                    }
                                    break;
                                case 1 /* STROKE */ :
                                    if (styles.webkitTextStrokeWidth && text.text.trim().length) {
                                        _this.ctx.strokeStyle = asString(styles.webkitTextStrokeColor);
                                        _this.ctx.lineWidth = styles.webkitTextStrokeWidth;
                                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                        _this.ctx.lineJoin = !!window.chrome ? 'miter' : 'round';
                                        _this.ctx.strokeText(text.text, text.bounds.left, text.bounds.top + baseline);
                                    }
                                    _this.ctx.strokeStyle = '';
                                    _this.ctx.lineWidth = 0;
                                    _this.ctx.lineJoin = 'miter';
                                    break;
                            }
                        });
                    });
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.renderReplacedElement = function(container, curves, image) {
            if (image && container.intrinsicWidth > 0 && container.intrinsicHeight > 0) {
                var box = contentBox(container);
                var path = calculatePaddingBoxPath(curves);
                this.path(path);
                this.ctx.save();
                this.ctx.clip();
                this.ctx.drawImage(image, 0, 0, container.intrinsicWidth, container.intrinsicHeight, box.left, box.top, box.width, box.height);
                this.ctx.restore();
            }
        };
        CanvasRenderer.prototype.renderNodeContent = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                var container, curves, styles, _i, _a, child, image, image, iframeRenderer, canvas, size, _b, fontFamily, fontSize, baseline, bounds, x, textBounds, img, image, url, fontFamily, bounds;
                return __generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            this.applyEffects(paint.getEffects(4 /* CONTENT */ ));
                            container = paint.container;
                            curves = paint.curves;
                            styles = container.styles;
                            _i = 0, _a = container.textNodes;
                            _c.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                4
                            ];
                            child = _a[_i];
                            return [
                                4 /*yield*/ ,
                                this.renderTextNode(child, styles)
                            ];
                        case 2:
                            _c.sent();
                            _c.label = 3;
                        case 3:
                            _i++;
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 4:
                            if (!(container instanceof ImageElementContainer)) return [
                                3 /*break*/ ,
                                8
                            ];
                            _c.label = 5;
                        case 5:
                            _c.trys.push([
                                5,
                                7,
                                ,
                                8
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(container.src)
                            ];
                        case 6:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 7:
                            _c.sent();
                            this.context.logger.error("Error loading image " + container.src);
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 8:
                            if (container instanceof CanvasElementContainer) this.renderReplacedElement(container, curves, container.canvas);
                            if (!(container instanceof SVGElementContainer)) return [
                                3 /*break*/ ,
                                12
                            ];
                            _c.label = 9;
                        case 9:
                            _c.trys.push([
                                9,
                                11,
                                ,
                                12
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(container.svg)
                            ];
                        case 10:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case 11:
                            _c.sent();
                            this.context.logger.error("Error loading svg " + container.svg.substring(0, 255));
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case 12:
                            if (!(container instanceof IFrameElementContainer && container.tree)) return [
                                3 /*break*/ ,
                                14
                            ];
                            iframeRenderer = new CanvasRenderer(this.context, {
                                scale: this.options.scale,
                                backgroundColor: container.backgroundColor,
                                x: 0,
                                y: 0,
                                width: container.width,
                                height: container.height
                            });
                            return [
                                4 /*yield*/ ,
                                iframeRenderer.render(container.tree)
                            ];
                        case 13:
                            canvas = _c.sent();
                            if (container.width && container.height) this.ctx.drawImage(canvas, 0, 0, container.width, container.height, container.bounds.left, container.bounds.top, container.bounds.width, container.bounds.height);
                            _c.label = 14;
                        case 14:
                            if (container instanceof InputElementContainer) {
                                size = Math.min(container.bounds.width, container.bounds.height);
                                if (container.type === CHECKBOX) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.path([
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79),
                                            new Vector(container.bounds.left + size * 0.16, container.bounds.top + size * 0.5549),
                                            new Vector(container.bounds.left + size * 0.27347, container.bounds.top + size * 0.44071),
                                            new Vector(container.bounds.left + size * 0.39694, container.bounds.top + size * 0.5649),
                                            new Vector(container.bounds.left + size * 0.72983, container.bounds.top + size * 0.23),
                                            new Vector(container.bounds.left + size * 0.84, container.bounds.top + size * 0.34085),
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79)
                                        ]);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                } else if (container.type === RADIO) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.ctx.beginPath();
                                        this.ctx.arc(container.bounds.left + size / 2, container.bounds.top + size / 2, size / 4, 0, Math.PI * 2, true);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                }
                            }
                            if (isTextInputElement(container) && container.value.length) {
                                _b = this.createFontStyle(styles), fontFamily = _b[0], fontSize = _b[1];
                                baseline = this.fontMetrics.getMetrics(fontFamily, fontSize).baseline;
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = 'alphabetic';
                                this.ctx.textAlign = canvasTextAlign(container.styles.textAlign);
                                bounds = contentBox(container);
                                x = 0;
                                switch(container.styles.textAlign){
                                    case 1 /* CENTER */ :
                                        x += bounds.width / 2;
                                        break;
                                    case 2 /* RIGHT */ :
                                        x += bounds.width;
                                        break;
                                }
                                textBounds = bounds.add(x, 0, 0, -bounds.height / 2 + 1);
                                this.ctx.save();
                                this.path([
                                    new Vector(bounds.left, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top + bounds.height),
                                    new Vector(bounds.left, bounds.top + bounds.height)
                                ]);
                                this.ctx.clip();
                                this.renderTextWithLetterSpacing(new TextBounds(container.value, textBounds), styles.letterSpacing, baseline);
                                this.ctx.restore();
                                this.ctx.textBaseline = 'alphabetic';
                                this.ctx.textAlign = 'left';
                            }
                            if (!contains(container.styles.display, 2048 /* LIST_ITEM */ )) return [
                                3 /*break*/ ,
                                20
                            ];
                            if (!(container.styles.listStyleImage !== null)) return [
                                3 /*break*/ ,
                                19
                            ];
                            img = container.styles.listStyleImage;
                            if (!(img.type === 0 /* URL */ )) return [
                                3 /*break*/ ,
                                18
                            ];
                            image = void 0;
                            url = img.url;
                            _c.label = 15;
                        case 15:
                            _c.trys.push([
                                15,
                                17,
                                ,
                                18
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(url)
                            ];
                        case 16:
                            image = _c.sent();
                            this.ctx.drawImage(image, container.bounds.left - (image.width + 10), container.bounds.top);
                            return [
                                3 /*break*/ ,
                                18
                            ];
                        case 17:
                            _c.sent();
                            this.context.logger.error("Error loading list-style-image " + url);
                            return [
                                3 /*break*/ ,
                                18
                            ];
                        case 18:
                            return [
                                3 /*break*/ ,
                                20
                            ];
                        case 19:
                            if (paint.listValue && container.styles.listStyleType !== -1 /* NONE */ ) {
                                fontFamily = this.createFontStyle(styles)[0];
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = 'middle';
                                this.ctx.textAlign = 'right';
                                bounds = new Bounds(container.bounds.left, container.bounds.top + getAbsoluteValue(container.styles.paddingTop, container.bounds.width), container.bounds.width, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 1);
                                this.renderTextWithLetterSpacing(new TextBounds(paint.listValue, bounds), styles.letterSpacing, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 2);
                                this.ctx.textBaseline = 'bottom';
                                this.ctx.textAlign = 'left';
                            }
                            _c.label = 20;
                        case 20:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderStackContent = function(stack) {
            return __awaiter(this, void 0, void 0, function() {
                var _i, _a, child, _b, _c, child, _d, _e, child, _f, _g, child, _h, _j, child, _k, _l, child, _m, _o, child;
                return __generator(this, function(_p) {
                    switch(_p.label){
                        case 0:
                            if (contains(stack.element.container.flags, 16 /* DEBUG_RENDER */ )) debugger;
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            return [
                                4 /*yield*/ ,
                                this.renderNodeBackgroundAndBorders(stack.element)
                            ];
                        case 1:
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            _p.sent();
                            _i = 0, _a = stack.negativeZIndex;
                            _p.label = 2;
                        case 2:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                5
                            ];
                            child = _a[_i];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 3:
                            _p.sent();
                            _p.label = 4;
                        case 4:
                            _i++;
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case 5:
                            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                            return [
                                4 /*yield*/ ,
                                this.renderNodeContent(stack.element)
                            ];
                        case 6:
                            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                            _p.sent();
                            _b = 0, _c = stack.nonInlineLevel;
                            _p.label = 7;
                        case 7:
                            if (!(_b < _c.length)) return [
                                3 /*break*/ ,
                                10
                            ];
                            child = _c[_b];
                            return [
                                4 /*yield*/ ,
                                this.renderNode(child)
                            ];
                        case 8:
                            _p.sent();
                            _p.label = 9;
                        case 9:
                            _b++;
                            return [
                                3 /*break*/ ,
                                7
                            ];
                        case 10:
                            _d = 0, _e = stack.nonPositionedFloats;
                            _p.label = 11;
                        case 11:
                            if (!(_d < _e.length)) return [
                                3 /*break*/ ,
                                14
                            ];
                            child = _e[_d];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 12:
                            _p.sent();
                            _p.label = 13;
                        case 13:
                            _d++;
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 14:
                            _f = 0, _g = stack.nonPositionedInlineLevel;
                            _p.label = 15;
                        case 15:
                            if (!(_f < _g.length)) return [
                                3 /*break*/ ,
                                18
                            ];
                            child = _g[_f];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 16:
                            _p.sent();
                            _p.label = 17;
                        case 17:
                            _f++;
                            return [
                                3 /*break*/ ,
                                15
                            ];
                        case 18:
                            _h = 0, _j = stack.inlineLevel;
                            _p.label = 19;
                        case 19:
                            if (!(_h < _j.length)) return [
                                3 /*break*/ ,
                                22
                            ];
                            child = _j[_h];
                            return [
                                4 /*yield*/ ,
                                this.renderNode(child)
                            ];
                        case 20:
                            _p.sent();
                            _p.label = 21;
                        case 21:
                            _h++;
                            return [
                                3 /*break*/ ,
                                19
                            ];
                        case 22:
                            _k = 0, _l = stack.zeroOrAutoZIndexOrTransformedOrOpacity;
                            _p.label = 23;
                        case 23:
                            if (!(_k < _l.length)) return [
                                3 /*break*/ ,
                                26
                            ];
                            child = _l[_k];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 24:
                            _p.sent();
                            _p.label = 25;
                        case 25:
                            _k++;
                            return [
                                3 /*break*/ ,
                                23
                            ];
                        case 26:
                            _m = 0, _o = stack.positiveZIndex;
                            _p.label = 27;
                        case 27:
                            if (!(_m < _o.length)) return [
                                3 /*break*/ ,
                                30
                            ];
                            child = _o[_m];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 28:
                            _p.sent();
                            _p.label = 29;
                        case 29:
                            _m++;
                            return [
                                3 /*break*/ ,
                                27
                            ];
                        case 30:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.mask = function(paths) {
            this.ctx.beginPath();
            this.ctx.moveTo(0, 0);
            this.ctx.lineTo(this.canvas.width, 0);
            this.ctx.lineTo(this.canvas.width, this.canvas.height);
            this.ctx.lineTo(0, this.canvas.height);
            this.ctx.lineTo(0, 0);
            this.formatPath(paths.slice(0).reverse());
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.path = function(paths) {
            this.ctx.beginPath();
            this.formatPath(paths);
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.formatPath = function(paths) {
            var _this = this;
            paths.forEach(function(point, index) {
                var start = isBezierCurve(point) ? point.start : point;
                if (index === 0) _this.ctx.moveTo(start.x, start.y);
                else _this.ctx.lineTo(start.x, start.y);
                if (isBezierCurve(point)) _this.ctx.bezierCurveTo(point.startControl.x, point.startControl.y, point.endControl.x, point.endControl.y, point.end.x, point.end.y);
            });
        };
        CanvasRenderer.prototype.renderRepeat = function(path, pattern, offsetX, offsetY) {
            this.path(path);
            this.ctx.fillStyle = pattern;
            this.ctx.translate(offsetX, offsetY);
            this.ctx.fill();
            this.ctx.translate(-offsetX, -offsetY);
        };
        CanvasRenderer.prototype.resizeImage = function(image, width, height) {
            var _a;
            if (image.width === width && image.height === height) return image;
            var ownerDocument = (_a = this.canvas.ownerDocument) !== null && _a !== void 0 ? _a : document;
            var canvas = ownerDocument.createElement('canvas');
            canvas.width = Math.max(1, width);
            canvas.height = Math.max(1, height);
            var ctx = canvas.getContext('2d');
            ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, width, height);
            return canvas;
        };
        CanvasRenderer.prototype.renderBackgroundImage = function(container) {
            return __awaiter(this, void 0, void 0, function() {
                var index, _loop_1, this_1, _i, _a, backgroundImage;
                return __generator(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            index = container.styles.backgroundImage.length - 1;
                            _loop_1 = function(backgroundImage) {
                                var image, url, _c, path, x, y, width, height, pattern, _d, path, x, y, width, height, _e, lineLength, x0, x1, y0, y1, canvas, ctx, gradient_1, pattern, _f, path, left, top_1, width, height, position, x, y, _g, rx, ry, radialGradient_1, midX, midY, f, invF;
                                return __generator(this, function(_h) {
                                    switch(_h.label){
                                        case 0:
                                            if (!(backgroundImage.type === 0 /* URL */ )) return [
                                                3 /*break*/ ,
                                                5
                                            ];
                                            image = void 0;
                                            url = backgroundImage.url;
                                            _h.label = 1;
                                        case 1:
                                            _h.trys.push([
                                                1,
                                                3,
                                                ,
                                                4
                                            ]);
                                            return [
                                                4 /*yield*/ ,
                                                this_1.context.cache.match(url)
                                            ];
                                        case 2:
                                            image = _h.sent();
                                            return [
                                                3 /*break*/ ,
                                                4
                                            ];
                                        case 3:
                                            _h.sent();
                                            this_1.context.logger.error("Error loading background-image " + url);
                                            return [
                                                3 /*break*/ ,
                                                4
                                            ];
                                        case 4:
                                            if (image) {
                                                _c = calculateBackgroundRendering(container, index, [
                                                    image.width,
                                                    image.height,
                                                    image.width / image.height
                                                ]), path = _c[0], x = _c[1], y = _c[2], width = _c[3], height = _c[4];
                                                pattern = this_1.ctx.createPattern(this_1.resizeImage(image, width, height), 'repeat');
                                                this_1.renderRepeat(path, pattern, x, y);
                                            }
                                            return [
                                                3 /*break*/ ,
                                                6
                                            ];
                                        case 5:
                                            if (isLinearGradient(backgroundImage)) {
                                                _d = calculateBackgroundRendering(container, index, [
                                                    null,
                                                    null,
                                                    null
                                                ]), path = _d[0], x = _d[1], y = _d[2], width = _d[3], height = _d[4];
                                                _e = calculateGradientDirection(backgroundImage.angle, width, height), lineLength = _e[0], x0 = _e[1], x1 = _e[2], y0 = _e[3], y1 = _e[4];
                                                canvas = document.createElement('canvas');
                                                canvas.width = width;
                                                canvas.height = height;
                                                ctx = canvas.getContext('2d');
                                                gradient_1 = ctx.createLinearGradient(x0, y0, x1, y1);
                                                processColorStops(backgroundImage.stops, lineLength).forEach(function(colorStop) {
                                                    return gradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                });
                                                ctx.fillStyle = gradient_1;
                                                ctx.fillRect(0, 0, width, height);
                                                if (width > 0 && height > 0) {
                                                    pattern = this_1.ctx.createPattern(canvas, 'repeat');
                                                    this_1.renderRepeat(path, pattern, x, y);
                                                }
                                            } else if (isRadialGradient(backgroundImage)) {
                                                _f = calculateBackgroundRendering(container, index, [
                                                    null,
                                                    null,
                                                    null
                                                ]), path = _f[0], left = _f[1], top_1 = _f[2], width = _f[3], height = _f[4];
                                                position = backgroundImage.position.length === 0 ? [
                                                    FIFTY_PERCENT
                                                ] : backgroundImage.position;
                                                x = getAbsoluteValue(position[0], width);
                                                y = getAbsoluteValue(position[position.length - 1], height);
                                                _g = calculateRadius(backgroundImage, x, y, width, height), rx = _g[0], ry = _g[1];
                                                if (rx > 0 && ry > 0) {
                                                    radialGradient_1 = this_1.ctx.createRadialGradient(left + x, top_1 + y, 0, left + x, top_1 + y, rx);
                                                    processColorStops(backgroundImage.stops, rx * 2).forEach(function(colorStop) {
                                                        return radialGradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                    });
                                                    this_1.path(path);
                                                    this_1.ctx.fillStyle = radialGradient_1;
                                                    if (rx !== ry) {
                                                        midX = container.bounds.left + 0.5 * container.bounds.width;
                                                        midY = container.bounds.top + 0.5 * container.bounds.height;
                                                        f = ry / rx;
                                                        invF = 1 / f;
                                                        this_1.ctx.save();
                                                        this_1.ctx.translate(midX, midY);
                                                        this_1.ctx.transform(1, 0, 0, f, 0, 0);
                                                        this_1.ctx.translate(-midX, -midY);
                                                        this_1.ctx.fillRect(left, invF * (top_1 - midY) + midY, width, height * invF);
                                                        this_1.ctx.restore();
                                                    } else this_1.ctx.fill();
                                                }
                                            }
                                            _h.label = 6;
                                        case 6:
                                            index--;
                                            return [
                                                2 /*return*/ 
                                            ];
                                    }
                                });
                            };
                            this_1 = this;
                            _i = 0, _a = container.styles.backgroundImage.slice(0).reverse();
                            _b.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                4
                            ];
                            backgroundImage = _a[_i];
                            return [
                                5 /*yield**/ ,
                                _loop_1(backgroundImage)
                            ];
                        case 2:
                            _b.sent();
                            _b.label = 3;
                        case 3:
                            _i++;
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 4:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderSolidBorder = function(color, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    this.path(parsePathForBorder(curvePoints, side));
                    this.ctx.fillStyle = asString(color);
                    this.ctx.fill();
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.renderDoubleBorder = function(color, width, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function() {
                var outerPaths, innerPaths;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!(width < 3)) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderSolidBorder(color, side, curvePoints)
                            ];
                        case 1:
                            _a.sent();
                            return [
                                2 /*return*/ 
                            ];
                        case 2:
                            outerPaths = parsePathForBorderDoubleOuter(curvePoints, side);
                            this.path(outerPaths);
                            this.ctx.fillStyle = asString(color);
                            this.ctx.fill();
                            innerPaths = parsePathForBorderDoubleInner(curvePoints, side);
                            this.path(innerPaths);
                            this.ctx.fill();
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNodeBackgroundAndBorders = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                var styles, hasBackground, borders, backgroundPaintingArea, side, _i, borders_1, border;
                var _this = this;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            this.applyEffects(paint.getEffects(2 /* BACKGROUND_BORDERS */ ));
                            styles = paint.container.styles;
                            hasBackground = !isTransparent(styles.backgroundColor) || styles.backgroundImage.length;
                            borders = [
                                {
                                    style: styles.borderTopStyle,
                                    color: styles.borderTopColor,
                                    width: styles.borderTopWidth
                                },
                                {
                                    style: styles.borderRightStyle,
                                    color: styles.borderRightColor,
                                    width: styles.borderRightWidth
                                },
                                {
                                    style: styles.borderBottomStyle,
                                    color: styles.borderBottomColor,
                                    width: styles.borderBottomWidth
                                },
                                {
                                    style: styles.borderLeftStyle,
                                    color: styles.borderLeftColor,
                                    width: styles.borderLeftWidth
                                }
                            ];
                            backgroundPaintingArea = calculateBackgroundCurvedPaintingArea(getBackgroundValueForIndex(styles.backgroundClip, 0), paint.curves);
                            if (!(hasBackground || styles.boxShadow.length)) return [
                                3 /*break*/ ,
                                2
                            ];
                            this.ctx.save();
                            this.path(backgroundPaintingArea);
                            this.ctx.clip();
                            if (!isTransparent(styles.backgroundColor)) {
                                this.ctx.fillStyle = asString(styles.backgroundColor);
                                this.ctx.fill();
                            }
                            return [
                                4 /*yield*/ ,
                                this.renderBackgroundImage(paint.container)
                            ];
                        case 1:
                            _a.sent();
                            this.ctx.restore();
                            styles.boxShadow.slice(0).reverse().forEach(function(shadow) {
                                _this.ctx.save();
                                var borderBoxArea = calculateBorderBoxPath(paint.curves);
                                var maskOffset = shadow.inset ? 0 : MASK_OFFSET;
                                var shadowPaintingArea = transformPath(borderBoxArea, -maskOffset + (shadow.inset ? 1 : -1) * shadow.spread.number, (shadow.inset ? 1 : -1) * shadow.spread.number, shadow.spread.number * (shadow.inset ? -2 : 2), shadow.spread.number * (shadow.inset ? -2 : 2));
                                if (shadow.inset) {
                                    _this.path(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.mask(shadowPaintingArea);
                                } else {
                                    _this.mask(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.path(shadowPaintingArea);
                                }
                                _this.ctx.shadowOffsetX = shadow.offsetX.number + maskOffset;
                                _this.ctx.shadowOffsetY = shadow.offsetY.number;
                                _this.ctx.shadowColor = asString(shadow.color);
                                _this.ctx.shadowBlur = shadow.blur.number;
                                _this.ctx.fillStyle = shadow.inset ? asString(shadow.color) : 'rgba(0,0,0,1)';
                                _this.ctx.fill();
                                _this.ctx.restore();
                            });
                            _a.label = 2;
                        case 2:
                            side = 0;
                            _i = 0, borders_1 = borders;
                            _a.label = 3;
                        case 3:
                            if (!(_i < borders_1.length)) return [
                                3 /*break*/ ,
                                13
                            ];
                            border = borders_1[_i];
                            if (!(border.style !== 0 /* NONE */  && !isTransparent(border.color) && border.width > 0)) return [
                                3 /*break*/ ,
                                11
                            ];
                            if (!(border.style === 2 /* DASHED */ )) return [
                                3 /*break*/ ,
                                5
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 2 /* DASHED */ )
                            ];
                        case 4:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 5:
                            if (!(border.style === 3 /* DOTTED */ )) return [
                                3 /*break*/ ,
                                7
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 3 /* DOTTED */ )
                            ];
                        case 6:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 7:
                            if (!(border.style === 4 /* DOUBLE */ )) return [
                                3 /*break*/ ,
                                9
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDoubleBorder(border.color, border.width, side, paint.curves)
                            ];
                        case 8:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 9:
                            return [
                                4 /*yield*/ ,
                                this.renderSolidBorder(border.color, side, paint.curves)
                            ];
                        case 10:
                            _a.sent();
                            _a.label = 11;
                        case 11:
                            side++;
                            _a.label = 12;
                        case 12:
                            _i++;
                            return [
                                3 /*break*/ ,
                                3
                            ];
                        case 13:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderDashedDottedBorder = function(color, width, side, curvePoints, style) {
            return __awaiter(this, void 0, void 0, function() {
                var strokePaths, boxPaths, startX, startY, endX, endY, length, dashLength, spaceLength, useLineDash, multiplier, numberOfDashes, minSpace, maxSpace, path1, path2, path1, path2;
                return __generator(this, function(_a) {
                    this.ctx.save();
                    strokePaths = parsePathForBorderStroke(curvePoints, side);
                    boxPaths = parsePathForBorder(curvePoints, side);
                    if (style === 2 /* DASHED */ ) {
                        this.path(boxPaths);
                        this.ctx.clip();
                    }
                    if (isBezierCurve(boxPaths[0])) {
                        startX = boxPaths[0].start.x;
                        startY = boxPaths[0].start.y;
                    } else {
                        startX = boxPaths[0].x;
                        startY = boxPaths[0].y;
                    }
                    if (isBezierCurve(boxPaths[1])) {
                        endX = boxPaths[1].end.x;
                        endY = boxPaths[1].end.y;
                    } else {
                        endX = boxPaths[1].x;
                        endY = boxPaths[1].y;
                    }
                    if (side === 0 || side === 2) length = Math.abs(startX - endX);
                    else length = Math.abs(startY - endY);
                    this.ctx.beginPath();
                    if (style === 3 /* DOTTED */ ) this.formatPath(strokePaths);
                    else this.formatPath(boxPaths.slice(0, 2));
                    dashLength = width < 3 ? width * 3 : width * 2;
                    spaceLength = width < 3 ? width * 2 : width;
                    if (style === 3 /* DOTTED */ ) {
                        dashLength = width;
                        spaceLength = width;
                    }
                    useLineDash = true;
                    if (length <= dashLength * 2) useLineDash = false;
                    else if (length <= dashLength * 2 + spaceLength) {
                        multiplier = length / (2 * dashLength + spaceLength);
                        dashLength *= multiplier;
                        spaceLength *= multiplier;
                    } else {
                        numberOfDashes = Math.floor((length + spaceLength) / (dashLength + spaceLength));
                        minSpace = (length - numberOfDashes * dashLength) / (numberOfDashes - 1);
                        maxSpace = (length - (numberOfDashes + 1) * dashLength) / numberOfDashes;
                        spaceLength = maxSpace <= 0 || Math.abs(spaceLength - minSpace) < Math.abs(spaceLength - maxSpace) ? minSpace : maxSpace;
                    }
                    if (useLineDash) {
                        if (style === 3 /* DOTTED */ ) this.ctx.setLineDash([
                            0,
                            dashLength + spaceLength
                        ]);
                        else this.ctx.setLineDash([
                            dashLength,
                            spaceLength
                        ]);
                    }
                    if (style === 3 /* DOTTED */ ) {
                        this.ctx.lineCap = 'round';
                        this.ctx.lineWidth = width;
                    } else this.ctx.lineWidth = width * 2 + 1.1;
                    this.ctx.strokeStyle = asString(color);
                    this.ctx.stroke();
                    this.ctx.setLineDash([]);
                    // dashed round edge gap
                    if (style === 2 /* DASHED */ ) {
                        if (isBezierCurve(boxPaths[0])) {
                            path1 = boxPaths[3];
                            path2 = boxPaths[0];
                            this.ctx.beginPath();
                            this.formatPath([
                                new Vector(path1.end.x, path1.end.y),
                                new Vector(path2.start.x, path2.start.y)
                            ]);
                            this.ctx.stroke();
                        }
                        if (isBezierCurve(boxPaths[1])) {
                            path1 = boxPaths[1];
                            path2 = boxPaths[2];
                            this.ctx.beginPath();
                            this.formatPath([
                                new Vector(path1.end.x, path1.end.y),
                                new Vector(path2.start.x, path2.start.y)
                            ]);
                            this.ctx.stroke();
                        }
                    }
                    this.ctx.restore();
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.render = function(element) {
            return __awaiter(this, void 0, void 0, function() {
                var stack;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(this.options.x, this.options.y, this.options.width, this.options.height);
                            }
                            stack = parseStackingContexts(element);
                            return [
                                4 /*yield*/ ,
                                this.renderStack(stack)
                            ];
                        case 1:
                            _a.sent();
                            this.applyEffects([]);
                            return [
                                2 /*return*/ ,
                                this.canvas
                            ];
                    }
                });
            });
        };
        return CanvasRenderer;
    }(Renderer);
    var isTextInputElement = function(container) {
        if (container instanceof TextareaElementContainer) return true;
        else if (container instanceof SelectElementContainer) return true;
        else if (container instanceof InputElementContainer && container.type !== RADIO && container.type !== CHECKBOX) return true;
        return false;
    };
    var calculateBackgroundCurvedPaintingArea = function(clip, curves) {
        switch(clip){
            case 0 /* BORDER_BOX */ :
                return calculateBorderBoxPath(curves);
            case 2 /* CONTENT_BOX */ :
                return calculateContentBoxPath(curves);
            case 1 /* PADDING_BOX */ :
            default:
                return calculatePaddingBoxPath(curves);
        }
    };
    var canvasTextAlign = function(textAlign) {
        switch(textAlign){
            case 1 /* CENTER */ :
                return 'center';
            case 2 /* RIGHT */ :
                return 'right';
            case 0 /* LEFT */ :
            default:
                return 'left';
        }
    };
    // see https://github.com/niklasvh/html2canvas/pull/2645
    var iOSBrokenFonts = [
        '-apple-system',
        'system-ui'
    ];
    var fixIOSSystemFonts = function(fontFamilies) {
        return /iPhone OS 15_(0|1)/.test(window.navigator.userAgent) ? fontFamilies.filter(function(fontFamily) {
            return iOSBrokenFonts.indexOf(fontFamily) === -1;
        }) : fontFamilies;
    };
    var ForeignObjectRenderer = /** @class */ function(_super) {
        __extends(ForeignObjectRenderer, _super);
        function ForeignObjectRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this.canvas = options.canvas ? options.canvas : document.createElement('canvas');
            _this.ctx = _this.canvas.getContext('2d');
            _this.options = options;
            _this.canvas.width = Math.floor(options.width * options.scale);
            _this.canvas.height = Math.floor(options.height * options.scale);
            _this.canvas.style.width = options.width + "px";
            _this.canvas.style.height = options.height + "px";
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.context.logger.debug("EXPERIMENTAL ForeignObject renderer initialized (" + options.width + "x" + options.height + " at " + options.x + "," + options.y + ") with scale " + options.scale);
            return _this;
        }
        ForeignObjectRenderer.prototype.render = function(element) {
            return __awaiter(this, void 0, void 0, function() {
                var svg, img;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            svg = createForeignObjectSVG(this.options.width * this.options.scale, this.options.height * this.options.scale, this.options.scale, this.options.scale, element);
                            return [
                                4 /*yield*/ ,
                                loadSerializedSVG(svg)
                            ];
                        case 1:
                            img = _a.sent();
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(0, 0, this.options.width * this.options.scale, this.options.height * this.options.scale);
                            }
                            this.ctx.drawImage(img, -this.options.x * this.options.scale, -this.options.y * this.options.scale);
                            return [
                                2 /*return*/ ,
                                this.canvas
                            ];
                    }
                });
            });
        };
        return ForeignObjectRenderer;
    }(Renderer);
    var loadSerializedSVG = function(svg) {
        return new Promise(function(resolve, reject) {
            var img = new Image();
            img.onload = function() {
                resolve(img);
            };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };
    var Logger = /** @class */ function() {
        function Logger(_a) {
            var id = _a.id, enabled = _a.enabled;
            this.id = id;
            this.enabled = enabled;
            this.start = Date.now();
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.debug = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.debug === 'function') // eslint-disable-next-line no-console
                console.debug.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        Logger.prototype.getTime = function() {
            return Date.now() - this.start;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.info = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) // eslint-disable-next-line no-console
            {
                if (typeof window !== 'undefined' && window.console && typeof console.info === 'function') // eslint-disable-next-line no-console
                console.info.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.warn = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.warn === 'function') // eslint-disable-next-line no-console
                console.warn.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.error = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.error === 'function') // eslint-disable-next-line no-console
                console.error.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        Logger.instances = {};
        return Logger;
    }();
    var Context = /** @class */ function() {
        function Context(options, windowBounds) {
            var _a;
            this.windowBounds = windowBounds;
            this.instanceName = "#" + Context.instanceCount++;
            this.logger = new Logger({
                id: this.instanceName,
                enabled: options.logging
            });
            this.cache = (_a = options.cache) !== null && _a !== void 0 ? _a : new Cache(this, options);
        }
        Context.instanceCount = 1;
        return Context;
    }();
    var html2canvas = function(element, options) {
        if (options === void 0) options = {};
        return renderElement(element, options);
    };
    if (typeof window !== 'undefined') CacheStorage.setContext(window);
    var renderElement = function(element, opts) {
        return __awaiter(void 0, void 0, void 0, function() {
            var ownerDocument, defaultView, resourceOptions, contextOptions, windowOptions, windowBounds, context, foreignObjectRendering, cloneOptions, documentCloner, clonedElement, container, _a, width, height, left, top, backgroundColor, renderOptions, canvas, renderer, root, renderer;
            var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
            return __generator(this, function(_u) {
                switch(_u.label){
                    case 0:
                        if (!element || typeof element !== 'object') return [
                            2 /*return*/ ,
                            Promise.reject('Invalid element provided as first argument')
                        ];
                        ownerDocument = element.ownerDocument;
                        if (!ownerDocument) throw new Error("Element is not attached to a Document");
                        defaultView = ownerDocument.defaultView;
                        if (!defaultView) throw new Error("Document is not attached to a Window");
                        resourceOptions = {
                            allowTaint: (_b = opts.allowTaint) !== null && _b !== void 0 ? _b : false,
                            imageTimeout: (_c = opts.imageTimeout) !== null && _c !== void 0 ? _c : 15000,
                            proxy: opts.proxy,
                            useCORS: (_d = opts.useCORS) !== null && _d !== void 0 ? _d : false
                        };
                        contextOptions = __assign({
                            logging: (_e = opts.logging) !== null && _e !== void 0 ? _e : true,
                            cache: opts.cache
                        }, resourceOptions);
                        windowOptions = {
                            windowWidth: (_f = opts.windowWidth) !== null && _f !== void 0 ? _f : defaultView.innerWidth,
                            windowHeight: (_g = opts.windowHeight) !== null && _g !== void 0 ? _g : defaultView.innerHeight,
                            scrollX: (_h = opts.scrollX) !== null && _h !== void 0 ? _h : defaultView.pageXOffset,
                            scrollY: (_j = opts.scrollY) !== null && _j !== void 0 ? _j : defaultView.pageYOffset
                        };
                        windowBounds = new Bounds(windowOptions.scrollX, windowOptions.scrollY, windowOptions.windowWidth, windowOptions.windowHeight);
                        context = new Context(contextOptions, windowBounds);
                        foreignObjectRendering = (_k = opts.foreignObjectRendering) !== null && _k !== void 0 ? _k : false;
                        cloneOptions = {
                            allowTaint: (_l = opts.allowTaint) !== null && _l !== void 0 ? _l : false,
                            onclone: opts.onclone,
                            ignoreElements: opts.ignoreElements,
                            inlineImages: foreignObjectRendering,
                            copyStyles: foreignObjectRendering
                        };
                        context.logger.debug("Starting document clone with size " + windowBounds.width + "x" + windowBounds.height + " scrolled to " + -windowBounds.left + "," + -windowBounds.top);
                        documentCloner = new DocumentCloner(context, element, cloneOptions);
                        clonedElement = documentCloner.clonedReferenceElement;
                        if (!clonedElement) return [
                            2 /*return*/ ,
                            Promise.reject("Unable to find element in cloned iframe")
                        ];
                        return [
                            4 /*yield*/ ,
                            documentCloner.toIFrame(ownerDocument, windowBounds)
                        ];
                    case 1:
                        container = _u.sent();
                        _a = isBodyElement(clonedElement) || isHTMLElement(clonedElement) ? parseDocumentSize(clonedElement.ownerDocument) : parseBounds(context, clonedElement), width = _a.width, height = _a.height, left = _a.left, top = _a.top;
                        backgroundColor = parseBackgroundColor(context, clonedElement, opts.backgroundColor);
                        renderOptions = {
                            canvas: opts.canvas,
                            backgroundColor: backgroundColor,
                            scale: (_o = (_m = opts.scale) !== null && _m !== void 0 ? _m : defaultView.devicePixelRatio) !== null && _o !== void 0 ? _o : 1,
                            x: ((_p = opts.x) !== null && _p !== void 0 ? _p : 0) + left,
                            y: ((_q = opts.y) !== null && _q !== void 0 ? _q : 0) + top,
                            width: (_r = opts.width) !== null && _r !== void 0 ? _r : Math.ceil(width),
                            height: (_s = opts.height) !== null && _s !== void 0 ? _s : Math.ceil(height)
                        };
                        if (!foreignObjectRendering) return [
                            3 /*break*/ ,
                            3
                        ];
                        context.logger.debug("Document cloned, using foreign object rendering");
                        renderer = new ForeignObjectRenderer(context, renderOptions);
                        return [
                            4 /*yield*/ ,
                            renderer.render(clonedElement)
                        ];
                    case 2:
                        canvas = _u.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 3:
                        context.logger.debug("Document cloned, element located at " + left + "," + top + " with size " + width + "x" + height + " using computed rendering");
                        context.logger.debug("Starting DOM parsing");
                        root = parseTree(context, clonedElement);
                        if (backgroundColor === root.styles.backgroundColor) root.styles.backgroundColor = COLORS.TRANSPARENT;
                        context.logger.debug("Starting renderer for element at " + renderOptions.x + "," + renderOptions.y + " with size " + renderOptions.width + "x" + renderOptions.height);
                        renderer = new CanvasRenderer(context, renderOptions);
                        return [
                            4 /*yield*/ ,
                            renderer.render(root)
                        ];
                    case 4:
                        canvas = _u.sent();
                        _u.label = 5;
                    case 5:
                        if ((_t = opts.removeContainer) !== null && _t !== void 0 ? _t : true) {
                            if (!DocumentCloner.destroy(container)) context.logger.error("Cannot detach cloned iframe as it is not in the DOM anymore");
                        }
                        context.logger.debug("Finished rendering");
                        return [
                            2 /*return*/ ,
                            canvas
                        ];
                }
            });
        });
    };
    var parseBackgroundColor = function(context, element, backgroundColorOverride) {
        var ownerDocument = element.ownerDocument;
        // http://www.w3.org/TR/css3-background/#special-backgrounds
        var documentBackgroundColor = ownerDocument.documentElement ? parseColor(context, getComputedStyle(ownerDocument.documentElement).backgroundColor) : COLORS.TRANSPARENT;
        var bodyBackgroundColor = ownerDocument.body ? parseColor(context, getComputedStyle(ownerDocument.body).backgroundColor) : COLORS.TRANSPARENT;
        var defaultBackgroundColor = typeof backgroundColorOverride === 'string' ? parseColor(context, backgroundColorOverride) : backgroundColorOverride === null ? COLORS.TRANSPARENT : 0xffffffff;
        return element === ownerDocument.documentElement ? isTransparent(documentBackgroundColor) ? isTransparent(bodyBackgroundColor) ? defaultBackgroundColor : bodyBackgroundColor : documentBackgroundColor : defaultBackgroundColor;
    };
    return html2canvas;
});















const $b75b4a9c88d279cf$var$FILENAME = 'export-png-tool.js';
const $b75b4a9c88d279cf$var$CLASS__TOOL_BUTTON = 'oltb-tool-button';
const $b75b4a9c88d279cf$var$I18N__BASE = 'tools.exportPngTool';
const $b75b4a9c88d279cf$var$DefaultOptions = Object.freeze({
    filename: 'map-image-export',
    appendTime: false,
    onInitiated: undefined,
    onClicked: undefined,
    onExported: undefined,
    onError: undefined
});
/**
 * About:
 * Take a picture of the Map
 * 
 * Description:
 * Instead of taking a screenshot, a complete PNG-image can be exported. 
 * The export combines the actual canvas that makes up the Map with various overlays such as information boxes that are actual HTML elements.
 */ class $b75b4a9c88d279cf$export$b88f5ca7e6588e92 extends (0, $10d08d54da4ecbc4$export$cf198134d112da63) {
    constructor(options = {}){
        super({
            filename: $b75b4a9c88d279cf$var$FILENAME
        });
        const icon = (0, $dcff5ab966a6537f$export$a297fe855adfd36c)({
            path: (0, $35649bc6579784f8$export$3fddabec91763a6e).image.mixed,
            class: `${$b75b4a9c88d279cf$var$CLASS__TOOL_BUTTON}__icon`
        });
        const i18n = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get($b75b4a9c88d279cf$var$I18N__BASE);
        const button = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'button',
            html: icon,
            class: $b75b4a9c88d279cf$var$CLASS__TOOL_BUTTON,
            attributes: {
                'type': 'button',
                'data-tippy-content': `${i18n.title} (${(0, $a256deadcc62504f$export$4384767a59dc851d).exportPngTool})`,
                'data-tippy-content-post': `(${(0, $a256deadcc62504f$export$4384767a59dc851d).exportPngTool})`,
                'data-oltb-i18n': `${$b75b4a9c88d279cf$var$I18N__BASE}.title`
            },
            listeners: {
                'click': this.onClickTool.bind(this)
            }
        });
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(this.element, [
            button
        ]);
        this.button = button;
        this.options = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep($b75b4a9c88d279cf$var$DefaultOptions), options);
        this.#initDebugState();
        this.attachGlobalListeners();
        // Note: 
        // @Consumer callback
        if (this.options.onInitiated) this.options.onInitiated();
    }
    attachGlobalListeners() {
        this.onWindowKeyUpBind = this.#onWindowKeyUp.bind(this);
        this.onOLTBReadyBind = this.#onOLTBReady.bind(this);
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.keyUp, this.onWindowKeyUpBind);
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.ready, this.onOLTBReadyBind);
    }
    detachGlobalListeners() {
        window.removeEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.keyUp, this.onWindowKeyUpBind);
        window.removeEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.ready, this.onOLTBReadyBind);
    }
    //--------------------------------------------------------------------
    // # Section: Overridden
    //--------------------------------------------------------------------
    getName() {
        return super.getName();
    }
    onClickTool(event) {
        super.onClickTool(event);
        this.momentaryActivation();
        // Note: 
        // @Consumer callback
        if (this.options.onClicked) this.options.onClicked();
    }
    //--------------------------------------------------------------------
    // # Section: Init Helpers
    //--------------------------------------------------------------------
    #initDebugState() {
        const debugKey = (0, $1e8c0ef90ed82280$export$a33e119b2316dcb7).getConfig().urlParameter.debug;
        this.isDebug = (0, $af35fd2ff1608131$export$fb10f6d9eb34a490).getParameter(debugKey) === 'true';
    }
    //--------------------------------------------------------------------
    // # Section: Tool Control
    //--------------------------------------------------------------------
    momentaryActivation() {
        this.doRenderOnce();
    }
    //--------------------------------------------------------------------
    // # Section: Browser Events
    //--------------------------------------------------------------------
    #onOLTBReady(event) {
        const uiRefMapElement = (0, $8f42450ebdd44f5e$export$8e7188a60a5bbe16).getMapElement();
        const uiRefAttribution = uiRefMapElement.querySelector('.ol-attribution');
        if (uiRefAttribution) uiRefAttribution.setAttribute('data-html2canvas-ignore', 'true');
    }
    #onWindowKeyUp(event) {
        if ((0, $fbd95439548fdf50$export$ad7bf7af8762113)(event, (0, $a256deadcc62504f$export$4384767a59dc851d).exportPngTool)) this.onClickTool(event);
    }
    //--------------------------------------------------------------------
    // # Section: Map/UI Callbacks
    //--------------------------------------------------------------------
    async #onRenderCompleteAsync() {
        const map = this.getMap();
        if (!map) return;
        await this.doRenderCompleteAsync(map);
    }
    //--------------------------------------------------------------------
    // # Section: User Interface
    //--------------------------------------------------------------------
    #createUICanvas(width, height) {
        return (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'canvas',
            attributes: {
                'width': width,
                'height': height
            }
        });
    }
    //--------------------------------------------------------------------
    // # Section: Getters and Setters
    //--------------------------------------------------------------------
    getCanvasMatrix(uiRefCanvas) {
        return uiRefCanvas.style.transform.match(/^matrix\(([^(]*)\)$/)[1].split(',').map(Number);
    }
    //--------------------------------------------------------------------
    // # Section: Tool DoActions
    //--------------------------------------------------------------------
    async doRenderCompleteAsync(map) {
        try {
            const uiRefMapElement = (0, $8f42450ebdd44f5e$export$8e7188a60a5bbe16).getMapElement();
            const size = map.getSize();
            const pngCanvas = this.#createUICanvas(size[0], size[1]);
            const pngContext = pngCanvas.getContext('2d');
            // Note:
            // When the overview tool is active a second map-canvas is present in the DOM
            // Appending the :not selector in the querySelector makes it possible to target the correct canvas 
            // Draw map layers (Canvases)
            const fullOpacity = 1;
            const uiRefMapCanvas = uiRefMapElement.querySelector('.ol-layer canvas:not(.ol-overviewmap-map canvas)');
            const opacity = uiRefMapCanvas.parentNode.style.opacity;
            pngContext.globalAlpha = opacity === '' ? fullOpacity : Number(opacity);
            const matrix = this.getCanvasMatrix(uiRefMapCanvas);
            CanvasRenderingContext2D.prototype.setTransform.apply(pngContext, matrix);
            pngContext.drawImage(uiRefMapCanvas, 0, 0);
            // Note:
            // When the overview tool is active a second map-canvas is present in the DOM
            // Appending the :not selector in the querySelector makes it possible to target the correct canvas 
            // Draw overlays souch as Tooltips and InfoWindows
            const uiRefOverlay = uiRefMapElement.querySelector('.ol-overlaycontainer-stopevent:not(.ol-overviewmap-map .ol-overlaycontainer-stopevent)');
            const overlayCanvas = await (0, (/*@__PURE__*/$parcel$interopDefault($5a197630e9446689$exports)))(uiRefOverlay, {
                scrollX: 0,
                scrollY: 0,
                backgroundColor: null,
                logging: this.isDebug
            });
            pngContext.drawImage(overlayCanvas, 0, 0);
            this.doDownloadCanvas(pngCanvas);
        } catch (error) {
            // Note: 
            // @Consumer callback
            if (this.options.onError) this.options.onError(error);
            (0, $b9b5c0363f244088$export$49b118289be48034).logError($b75b4a9c88d279cf$var$FILENAME, 'doRenderCompleteAsync', {
                message: 'Failed to export canvas image',
                error: error
            });
            (0, $9051f0e072bf4341$export$8d8dc7d5f743331b).error({
                i18nKey: `${$b75b4a9c88d279cf$var$I18N__BASE}.toasts.errors.renderCanvas`
            });
        }
    }
    doRenderOnce() {
        const map = this.getMap();
        if (!map) return;
        // Note: 
        // RenderSync will trigger the export the png
        map.once((0, $a9807b370eed025c$export$ada873a34909da65).openLayers.renderComplete, this.#onRenderCompleteAsync.bind(this));
        map.renderSync();
    }
    doDownloadCanvas(pngCanvas) {
        const locale = (0, $1e8c0ef90ed82280$export$a33e119b2316dcb7).getConfig().localization.active;
        const timestamp = this.options.appendTime ? `-${new Date().toLocaleString(locale)}` : '';
        const filename = `${this.options.filename}${timestamp}.png`;
        const content = window.navigator.msSaveBlob ? pngCanvas.msToBlob() : pngCanvas.toDataURL();
        if (window.navigator.msSaveBlob) window.navigator.msSaveBlob(content, filename);
        else (0, $8659bbf0c949ad4c$export$bb3b75778e3e272)(filename, content);
        // Note: 
        // @Consumer callback
        if (this.options.onExported) this.options.onExported(filename, content);
    }
}



var $f1q41 = parcelRequire("f1q41");



/**
 * @module ol/control/ScaleLine
 */ 


/**
 * @type {string}
 */ const $68ee08a302ae701e$var$UNITS_PROP = 'units';
/**
 * @typedef {'degrees' | 'imperial' | 'nautical' | 'metric' | 'us'} Units
 * Units for the scale line.
 */ /**
 * @const
 * @type {Array<number>}
 */ const $68ee08a302ae701e$var$LEADING_DIGITS = [
    1,
    2,
    5
];
/**
 * @const
 * @type {number}
 */ const $68ee08a302ae701e$var$DEFAULT_DPI = 25.4 / 0.28;
/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types|
 *     'change:units', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types
 *     |'change:units', Return>} ScaleLineOnSignature
 */ /**
 * @typedef {Object} Options
 * @property {string} [className] CSS class name. The default is `ol-scale-bar` when configured with
 * `bar: true`. Otherwise the default is `ol-scale-line`.
 * @property {number} [minWidth=64] Minimum width in pixels at the OGC default dpi. The width will be
 * adjusted to match the dpi used.
 * @property {number} [maxWidth] Maximum width in pixels at the OGC default dpi. The width will be
 * adjusted to match the dpi used.
 * @property {function(import("../MapEvent.js").default):void} [render] Function called when the control
 * should be re-rendered. This is called in a `requestAnimationFrame` callback.
 * @property {HTMLElement|string} [target] Specify a target if you want the control
 * to be rendered outside of the map's viewport.
 * @property {Units} [units='metric'] Units.
 * @property {boolean} [bar=false] Render scalebars instead of a line.
 * @property {number} [steps=4] Number of steps the scalebar should use. Use even numbers
 * for best results. Only applies when `bar` is `true`.
 * @property {boolean} [text=false] Render the text scale above of the scalebar. Only applies
 * when `bar` is `true`.
 * @property {number|undefined} [dpi=undefined] dpi of output device such as printer. Only applies
 * when `bar` is `true`. If undefined the OGC default screen pixel size of 0.28mm will be assumed.
 */ /**
 * @classdesc
 * A control displaying rough y-axis distances, calculated for the center of the
 * viewport. For conformal projections (e.g. EPSG:3857, the default view
 * projection in OpenLayers), the scale is valid for all directions.
 * No scale line will be shown when the y-axis distance of a pixel at the
 * viewport center cannot be calculated in the view projection.
 * By default the scale line will show in the bottom left portion of the map,
 * but this can be changed by using the css selector `.ol-scale-line`.
 * When specifying `bar` as `true`, a scalebar will be rendered instead
 * of a scaleline.
 * For cartesian measurements of the scaleline, you need to set the
 * `getPointResolution` method of your projection to simply return the input
 * value, e.g. `projection.setGetPointResolution(r => r);`
 *
 * @api
 */ class $68ee08a302ae701e$var$ScaleLine extends (0, $b978dafe8f7d27ff$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Scale line options.
   */ constructor(options){
        options = options ? options : {};
        const element = document.createElement('div');
        element.style.pointerEvents = 'none';
        super({
            element: element,
            render: options.render,
            target: options.target
        });
        /***
     * @type {ScaleLineOnSignature<import("../events").EventsKey>}
     */ this.on;
        /***
     * @type {ScaleLineOnSignature<import("../events").EventsKey>}
     */ this.once;
        /***
     * @type {ScaleLineOnSignature<void>}
     */ this.un;
        const className = options.className !== undefined ? options.className : options.bar ? 'ol-scale-bar' : 'ol-scale-line';
        /**
     * @private
     * @type {HTMLElement}
     */ this.innerElement_ = document.createElement('div');
        this.innerElement_.className = className + '-inner';
        this.element.className = className + ' ' + (0, $ce07df6d5d4656f1$export$1afde3d6e16a7b29);
        this.element.appendChild(this.innerElement_);
        /**
     * @private
     * @type {?import("../View.js").State}
     */ this.viewState_ = null;
        /**
     * @private
     * @type {number}
     */ this.minWidth_ = options.minWidth !== undefined ? options.minWidth : 64;
        /**
     * @private
     * @type {number|undefined}
     */ this.maxWidth_ = options.maxWidth;
        /**
     * @private
     * @type {boolean}
     */ this.renderedVisible_ = false;
        /**
     * @private
     * @type {number|undefined}
     */ this.renderedWidth_ = undefined;
        /**
     * @private
     * @type {string}
     */ this.renderedHTML_ = '';
        this.addChangeListener($68ee08a302ae701e$var$UNITS_PROP, this.handleUnitsChanged_);
        this.setUnits(options.units || 'metric');
        /**
     * @private
     * @type {boolean}
     */ this.scaleBar_ = options.bar || false;
        /**
     * @private
     * @type {number}
     */ this.scaleBarSteps_ = options.steps || 4;
        /**
     * @private
     * @type {boolean}
     */ this.scaleBarText_ = options.text || false;
        /**
     * @private
     * @type {number|undefined}
     */ this.dpi_ = options.dpi || undefined;
    }
    /**
   * Return the units to use in the scale line.
   * @return {Units} The units
   * to use in the scale line.
   * @observable
   * @api
   */ getUnits() {
        return this.get($68ee08a302ae701e$var$UNITS_PROP);
    }
    /**
   * @private
   */ handleUnitsChanged_() {
        this.updateElement_();
    }
    /**
   * Set the units to use in the scale line.
   * @param {Units} units The units to use in the scale line.
   * @observable
   * @api
   */ setUnits(units) {
        this.set($68ee08a302ae701e$var$UNITS_PROP, units);
    }
    /**
   * Specify the dpi of output device such as printer.
   * @param {number|undefined} dpi The dpi of output device.
   * @api
   */ setDpi(dpi) {
        this.dpi_ = dpi;
    }
    /**
   * @private
   */ updateElement_() {
        const viewState = this.viewState_;
        if (!viewState) {
            if (this.renderedVisible_) {
                this.element.style.display = 'none';
                this.renderedVisible_ = false;
            }
            return;
        }
        const center = viewState.center;
        const projection = viewState.projection;
        const units = this.getUnits();
        const pointResolutionUnits = units == 'degrees' ? 'degrees' : 'm';
        let pointResolution = (0, $9c4744460e43e41b$export$2d8f7b4eec383d44)(projection, viewState.resolution, center, pointResolutionUnits);
        const minWidth = this.minWidth_ * (this.dpi_ || $68ee08a302ae701e$var$DEFAULT_DPI) / $68ee08a302ae701e$var$DEFAULT_DPI;
        const maxWidth = this.maxWidth_ !== undefined ? this.maxWidth_ * (this.dpi_ || $68ee08a302ae701e$var$DEFAULT_DPI) / $68ee08a302ae701e$var$DEFAULT_DPI : undefined;
        let nominalCount = minWidth * pointResolution;
        let suffix = '';
        if (units == 'degrees') {
            const metersPerDegree = (0, $03edbd434a9e6608$export$1482081eec883108).degrees;
            nominalCount *= metersPerDegree;
            if (nominalCount < metersPerDegree / 60) {
                suffix = '\u2033'; // seconds
                pointResolution *= 3600;
            } else if (nominalCount < metersPerDegree) {
                suffix = '\u2032'; // minutes
                pointResolution *= 60;
            } else suffix = '\u00b0'; // degrees
        } else if (units == 'imperial') {
            if (nominalCount < 0.9144) {
                suffix = 'in';
                pointResolution /= 0.0254;
            } else if (nominalCount < 1609.344) {
                suffix = 'ft';
                pointResolution /= 0.3048;
            } else {
                suffix = 'mi';
                pointResolution /= 1609.344;
            }
        } else if (units == 'nautical') {
            pointResolution /= 1852;
            suffix = 'NM';
        } else if (units == 'metric') {
            if (nominalCount < 1e-6) {
                suffix = 'nm';
                pointResolution *= 1e9;
            } else if (nominalCount < 0.001) {
                suffix = "\u03BCm";
                pointResolution *= 1000000;
            } else if (nominalCount < 1) {
                suffix = 'mm';
                pointResolution *= 1000;
            } else if (nominalCount < 1000) suffix = 'm';
            else {
                suffix = 'km';
                pointResolution /= 1000;
            }
        } else if (units == 'us') {
            if (nominalCount < 0.9144) {
                suffix = 'in';
                pointResolution *= 39.37;
            } else if (nominalCount < 1609.344) {
                suffix = 'ft';
                pointResolution /= 0.30480061;
            } else {
                suffix = 'mi';
                pointResolution /= 1609.3472;
            }
        } else throw new Error('Invalid units');
        let i = 3 * Math.floor(Math.log(minWidth * pointResolution) / Math.log(10));
        let count, width, decimalCount;
        let previousCount = 0;
        let previousWidth, previousDecimalCount;
        while(true){
            decimalCount = Math.floor(i / 3);
            const decimal = Math.pow(10, decimalCount);
            count = $68ee08a302ae701e$var$LEADING_DIGITS[(i % 3 + 3) % 3] * decimal;
            width = Math.round(count / pointResolution);
            if (isNaN(width)) {
                this.element.style.display = 'none';
                this.renderedVisible_ = false;
                return;
            }
            if (maxWidth !== undefined && width >= maxWidth) {
                count = previousCount;
                width = previousWidth;
                decimalCount = previousDecimalCount;
                break;
            } else if (width >= minWidth) break;
            previousCount = count;
            previousWidth = width;
            previousDecimalCount = decimalCount;
            ++i;
        }
        const html = this.scaleBar_ ? this.createScaleBar(width, count, suffix) : count.toFixed(decimalCount < 0 ? -decimalCount : 0) + ' ' + suffix;
        if (this.renderedHTML_ != html) {
            this.innerElement_.innerHTML = html;
            this.renderedHTML_ = html;
        }
        if (this.renderedWidth_ != width) {
            this.innerElement_.style.width = width + 'px';
            this.renderedWidth_ = width;
        }
        if (!this.renderedVisible_) {
            this.element.style.display = '';
            this.renderedVisible_ = true;
        }
    }
    /**
   * @private
   * @param {number} width The current width of the scalebar.
   * @param {number} scale The current scale.
   * @param {string} suffix The suffix to append to the scale text.
   * @return {string} The stringified HTML of the scalebar.
   */ createScaleBar(width, scale, suffix) {
        const resolutionScale = this.getScaleForResolution();
        const mapScale = resolutionScale < 1 ? Math.round(1 / resolutionScale).toLocaleString() + ' : 1' : '1 : ' + Math.round(resolutionScale).toLocaleString();
        const steps = this.scaleBarSteps_;
        const stepWidth = width / steps;
        const scaleSteps = [
            this.createMarker('absolute')
        ];
        for(let i = 0; i < steps; ++i){
            const cls = i % 2 === 0 ? 'ol-scale-singlebar-odd' : 'ol-scale-singlebar-even';
            scaleSteps.push("<div><div " + `class="ol-scale-singlebar ${cls}" ` + `style="width: ${stepWidth}px;"` + '>' + '</div>' + this.createMarker('relative') + // render text every second step, except when only 2 steps
            (i % 2 === 0 || steps === 2 ? this.createStepText(i, width, false, scale, suffix) : '') + '</div>');
        }
        // render text at the end
        scaleSteps.push(this.createStepText(steps, width, true, scale, suffix));
        const scaleBarText = this.scaleBarText_ ? `<div class="ol-scale-text" style="width: ${width}px;">` + mapScale + '</div>' : '';
        return scaleBarText + scaleSteps.join('');
    }
    /**
   * Creates a marker at given position
   * @param {'absolute'|'relative'} position The position, absolute or relative
   * @return {string} The stringified div containing the marker
   */ createMarker(position) {
        const top = position === 'absolute' ? 3 : -10;
        return '<div class="ol-scale-step-marker" ' + `style="position: ${position}; top: ${top}px;"` + '></div>';
    }
    /**
   * Creates the label for a marker marker at given position
   * @param {number} i The iterator
   * @param {number} width The width the scalebar will currently use
   * @param {boolean} isLast Flag indicating if we add the last step text
   * @param {number} scale The current scale for the whole scalebar
   * @param {string} suffix The suffix for the scale
   * @return {string} The stringified div containing the step text
   */ createStepText(i, width, isLast, scale, suffix) {
        const length = i === 0 ? 0 : Math.round(scale / this.scaleBarSteps_ * i * 100) / 100;
        const lengthString = length + (i === 0 ? '' : ' ' + suffix);
        const margin = i === 0 ? -3 : width / this.scaleBarSteps_ * -1;
        const minWidth = i === 0 ? 0 : width / this.scaleBarSteps_ * 2;
        return '<div class="ol-scale-step-text" style="' + `margin-left: ${margin}px;` + `text-align: ${i === 0 ? 'left' : 'center'};` + `min-width: ${minWidth}px;` + `left: ${isLast ? width + 'px' : 'unset'};` + '">' + lengthString + '</div>';
    }
    /**
   * Returns the appropriate scale for the given resolution and units.
   * @return {number} The appropriate scale.
   */ getScaleForResolution() {
        const resolution = (0, $9c4744460e43e41b$export$2d8f7b4eec383d44)(this.viewState_.projection, this.viewState_.resolution, this.viewState_.center, 'm');
        const dpi = this.dpi_ || $68ee08a302ae701e$var$DEFAULT_DPI;
        const inchesPerMeter = 1000 / 25.4;
        return resolution * inchesPerMeter * dpi;
    }
    /**
   * Update the scale line element.
   * @param {import("../MapEvent.js").default} mapEvent Map event.
   * @override
   */ render(mapEvent) {
        const frameState = mapEvent.frameState;
        if (!frameState) this.viewState_ = null;
        else this.viewState_ = frameState.viewState;
        this.updateElement_();
    }
}
var $68ee08a302ae701e$export$2e2bcd8739ae039 = $68ee08a302ae701e$var$ScaleLine;








const $947f84f7bf1b0e06$var$FILENAME = 'scale-line-tool.js';
const $947f84f7bf1b0e06$var$CLASS__TOOL_BUTTON = 'oltb-tool-button';
const $947f84f7bf1b0e06$var$I18N__BASE = 'tools.scaleLineTool';
const $947f84f7bf1b0e06$var$DefaultOptions = Object.freeze({
    units: 'metric',
    onInitiated: undefined,
    onClicked: undefined,
    onBrowserStateCleared: undefined
});
const $947f84f7bf1b0e06$var$LocalStorageNodeName = (0, $52e25f2a10ab5b5c$export$ada36e8a1c3bc83a).scaleLineTool;
const $947f84f7bf1b0e06$var$LocalStorageDefaults = Object.freeze({
    isActive: false
});
/**
 * About:
 * Show current distance scaling
 * 
 * Description:
 * Depending on zoom level and position on the Map, a fixed distance will vary in value. 
 * This is reflected in the scaling component.
 */ class $947f84f7bf1b0e06$export$8df575533410ebb8 extends (0, $10d08d54da4ecbc4$export$cf198134d112da63) {
    constructor(options = {}){
        super({
            filename: $947f84f7bf1b0e06$var$FILENAME
        });
        const icon = (0, $dcff5ab966a6537f$export$a297fe855adfd36c)({
            path: (0, $35649bc6579784f8$export$3fddabec91763a6e).scaleLine.stroked,
            class: `${$947f84f7bf1b0e06$var$CLASS__TOOL_BUTTON}__icon`
        });
        const i18n = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get($947f84f7bf1b0e06$var$I18N__BASE);
        const button = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'button',
            html: icon,
            class: $947f84f7bf1b0e06$var$CLASS__TOOL_BUTTON,
            attributes: {
                'type': 'button',
                'data-tippy-content': `${i18n.title} (${(0, $a256deadcc62504f$export$4384767a59dc851d).scaleLineTool})`,
                'data-tippy-content-post': `(${(0, $a256deadcc62504f$export$4384767a59dc851d).scaleLineTool})`,
                'data-oltb-i18n': `${$947f84f7bf1b0e06$var$I18N__BASE}.title`
            },
            listeners: {
                'click': this.onClickTool.bind(this)
            }
        });
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(this.element, [
            button
        ]);
        this.button = button;
        this.isActive = false;
        this.options = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep($947f84f7bf1b0e06$var$DefaultOptions), options);
        this.localStorage = (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).getAndMergeStateObject($947f84f7bf1b0e06$var$LocalStorageNodeName, $947f84f7bf1b0e06$var$LocalStorageDefaults);
        this.scaleLine = this.#generateOLScaleLine();
        this.attachGlobalListeners();
        // Note: 
        // @Consumer callback
        if (this.options.onInitiated) this.options.onInitiated();
    }
    attachGlobalListeners() {
        this.onWindowKeyUpBind = this.#onWindowKeyUp.bind(this);
        this.onOLTBReadyBind = this.#onOLTBReady.bind(this);
        this.onWindowBrowserStateClearedBind = this.#onWindowBrowserStateCleared.bind(this);
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.keyUp, this.onWindowKeyUpBind);
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.ready, this.onOLTBReadyBind);
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.browserStateCleared, this.onWindowBrowserStateClearedBind);
    }
    detachGlobalListeners() {
        window.removeEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.keyUp, this.onWindowKeyUpBind);
        window.removeEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.ready, this.onOLTBReadyBind);
        window.removeEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.browserStateCleared, this.onWindowBrowserStateClearedBind);
    }
    //--------------------------------------------------------------------
    // # Section: Overridden
    //--------------------------------------------------------------------
    getName() {
        return super.getName();
    }
    onClickTool(event) {
        super.onClickTool(event);
        if (this.isActive) this.deactivateTool();
        else this.activateTool();
        // Note: 
        // @Consumer callback
        if (this.options.onClicked) this.options.onClicked();
    }
    //--------------------------------------------------------------------
    // # Section: Tool Control
    //--------------------------------------------------------------------
    activateTool() {
        const map = this.getMap();
        if (!map) return;
        this.doAddScaleLine(map);
        this.isActive = true;
        this.button.classList.add(`${$947f84f7bf1b0e06$var$CLASS__TOOL_BUTTON}--active`);
        this.localStorage.isActive = true;
        (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).setStateObject($947f84f7bf1b0e06$var$LocalStorageNodeName, this.localStorage);
    }
    deactivateTool() {
        this.doRemoveScaleLine();
        this.isActive = false;
        this.button.classList.remove(`${$947f84f7bf1b0e06$var$CLASS__TOOL_BUTTON}--active`);
        this.localStorage.isActive = false;
        (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).setStateObject($947f84f7bf1b0e06$var$LocalStorageNodeName, this.localStorage);
    }
    //--------------------------------------------------------------------
    // # Section: Generate Helpers
    //--------------------------------------------------------------------
    #generateOLScaleLine() {
        return new (0, $68ee08a302ae701e$export$2e2bcd8739ae039)({
            units: this.options.units
        });
    }
    //--------------------------------------------------------------------
    // # Section: Browser Events
    //--------------------------------------------------------------------
    #onOLTBReady(event) {
        if (this.localStorage.isActive) this.activateTool();
    }
    #onWindowKeyUp(event) {
        if ((0, $fbd95439548fdf50$export$ad7bf7af8762113)(event, (0, $a256deadcc62504f$export$4384767a59dc851d).scaleLineTool)) this.onClickTool(event);
    }
    #onWindowBrowserStateCleared() {
        this.doClearState();
        if (this.isActive) this.deactivateTool();
        // Note: 
        // @Consumer callback
        if (this.options.onBrowserStateCleared) this.options.onBrowserStateCleared();
    }
    //--------------------------------------------------------------------
    // # Section: Tool DoActions
    //--------------------------------------------------------------------
    doClearState() {
        this.localStorage = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep($947f84f7bf1b0e06$var$LocalStorageDefaults);
        (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).setStateObject($947f84f7bf1b0e06$var$LocalStorageNodeName, $947f84f7bf1b0e06$var$LocalStorageDefaults);
    }
    doAddScaleLine(map) {
        this.scaleLine.setMap(map);
    }
    doRemoveScaleLine() {
        this.scaleLine.setMap(null);
    }
}



var $f1q41 = parcelRequire("f1q41");




/**
 * @module ol/layer/Graticule
 */ 





/**
 * @module ol/geom/flat/geodesic
 */ 

/**
 * @param {function(number): import("../../coordinate.js").Coordinate} interpolate Interpolate function.
 * @param {import("../../proj.js").TransformFunction} transform Transform from longitude/latitude to
 *     projected coordinates.
 * @param {number} squaredTolerance Squared tolerance.
 * @return {Array<number>} Flat coordinates.
 */ function $f75093ed6511c732$var$line(interpolate, transform, squaredTolerance) {
    // FIXME reduce garbage generation
    // FIXME optimize stack operations
    /** @type {Array<number>} */ const flatCoordinates = [];
    let geoA = interpolate(0);
    let geoB = interpolate(1);
    let a = transform(geoA);
    let b = transform(geoB);
    /** @type {Array<import("../../coordinate.js").Coordinate>} */ const geoStack = [
        geoB,
        geoA
    ];
    /** @type {Array<import("../../coordinate.js").Coordinate>} */ const stack = [
        b,
        a
    ];
    /** @type {Array<number>} */ const fractionStack = [
        1,
        0
    ];
    /** @type {!Object<string, boolean>} */ const fractions = {};
    let maxIterations = 1e5;
    let geoM, m, fracA, fracB, fracM, key;
    while(--maxIterations > 0 && fractionStack.length > 0){
        // Pop the a coordinate off the stack
        fracA = fractionStack.pop();
        geoA = geoStack.pop();
        a = stack.pop();
        // Add the a coordinate if it has not been added yet
        key = fracA.toString();
        if (!(key in fractions)) {
            flatCoordinates.push(a[0], a[1]);
            fractions[key] = true;
        }
        // Pop the b coordinate off the stack
        fracB = fractionStack.pop();
        geoB = geoStack.pop();
        b = stack.pop();
        // Find the m point between the a and b coordinates
        fracM = (fracA + fracB) / 2;
        geoM = interpolate(fracM);
        m = transform(geoM);
        if ((0, $6b000a049d919fe5$export$251bb0a9cef172e6)(m[0], m[1], a[0], a[1], b[0], b[1]) < squaredTolerance) {
            // If the m point is sufficiently close to the straight line, then we
            // discard it.  Just use the b coordinate and move on to the next line
            // segment.
            flatCoordinates.push(b[0], b[1]);
            key = fracB.toString();
            fractions[key] = true;
        } else {
            // Otherwise, we need to subdivide the current line segment.  Split it
            // into two and push the two line segments onto the stack.
            fractionStack.push(fracB, fracM, fracM, fracA);
            stack.push(b, m, m, a);
            geoStack.push(geoB, geoM, geoM, geoA);
        }
    }
    return flatCoordinates;
}
function $f75093ed6511c732$export$f609b135d996b7e2(lon1, lat1, lon2, lat2, projection, squaredTolerance) {
    const geoProjection = (0, $9c4744460e43e41b$export$3988ae62b71be9a3)('EPSG:4326');
    const cosLat1 = Math.cos((0, $6b000a049d919fe5$export$cba01ba138429a1d)(lat1));
    const sinLat1 = Math.sin((0, $6b000a049d919fe5$export$cba01ba138429a1d)(lat1));
    const cosLat2 = Math.cos((0, $6b000a049d919fe5$export$cba01ba138429a1d)(lat2));
    const sinLat2 = Math.sin((0, $6b000a049d919fe5$export$cba01ba138429a1d)(lat2));
    const cosDeltaLon = Math.cos((0, $6b000a049d919fe5$export$cba01ba138429a1d)(lon2 - lon1));
    const sinDeltaLon = Math.sin((0, $6b000a049d919fe5$export$cba01ba138429a1d)(lon2 - lon1));
    const d = sinLat1 * sinLat2 + cosLat1 * cosLat2 * cosDeltaLon;
    return $f75093ed6511c732$var$line(/**
     * @param {number} frac Fraction.
     * @return {import("../../coordinate.js").Coordinate} Coordinate.
     */ function(frac) {
        if (1 <= d) return [
            lon2,
            lat2
        ];
        const D = frac * Math.acos(d);
        const cosD = Math.cos(D);
        const sinD = Math.sin(D);
        const y = sinDeltaLon * cosLat2;
        const x = cosLat1 * sinLat2 - sinLat1 * cosLat2 * cosDeltaLon;
        const theta = Math.atan2(y, x);
        const lat = Math.asin(sinLat1 * cosD + cosLat1 * sinD * Math.cos(theta));
        const lon = (0, $6b000a049d919fe5$export$cba01ba138429a1d)(lon1) + Math.atan2(Math.sin(theta) * sinD * cosLat1, cosD - sinLat1 * Math.sin(lat));
        return [
            (0, $6b000a049d919fe5$export$56cb859c01fa134d)(lon),
            (0, $6b000a049d919fe5$export$56cb859c01fa134d)(lat)
        ];
    }, (0, $9c4744460e43e41b$export$fce0c6cfca85ed96)(geoProjection, projection), squaredTolerance);
}
function $f75093ed6511c732$export$8314518f9c22f11b(lon, lat1, lat2, projection, squaredTolerance) {
    const epsg4326Projection = (0, $9c4744460e43e41b$export$3988ae62b71be9a3)('EPSG:4326');
    return $f75093ed6511c732$var$line(/**
     * @param {number} frac Fraction.
     * @return {import("../../coordinate.js").Coordinate} Coordinate.
     */ function(frac) {
        return [
            lon,
            lat1 + (lat2 - lat1) * frac
        ];
    }, (0, $9c4744460e43e41b$export$fce0c6cfca85ed96)(epsg4326Projection, projection), squaredTolerance);
}
function $f75093ed6511c732$export$451942af9381149c(lat, lon1, lon2, projection, squaredTolerance) {
    const epsg4326Projection = (0, $9c4744460e43e41b$export$3988ae62b71be9a3)('EPSG:4326');
    return $f75093ed6511c732$var$line(/**
     * @param {number} frac Fraction.
     * @return {import("../../coordinate.js").Coordinate} Coordinate.
     */ function(frac) {
        return [
            lon1 + (lon2 - lon1) * frac,
            lat
        ];
    }, (0, $9c4744460e43e41b$export$fce0c6cfca85ed96)(epsg4326Projection, projection), squaredTolerance);
}












/**
 * @type {Stroke}
 * @private
 * @const
 */ const $5c86e5d1e6a6cb96$var$DEFAULT_STROKE_STYLE = new (0, $f9d0329c5c745263$export$2e2bcd8739ae039)({
    color: 'rgba(0,0,0,0.2)'
});
/**
 * @type {Array<number>}
 * @private
 */ const $5c86e5d1e6a6cb96$var$INTERVALS = [
    90,
    45,
    30,
    20,
    10,
    5,
    2,
    1,
    0.5,
    20 / 60,
    10 / 60,
    5 / 60,
    2 / 60,
    1 / 60,
    30 / 3600,
    20 / 3600,
    10 / 3600,
    5 / 3600,
    2 / 3600,
    1 / 3600
];
/**
 * @typedef {Object} GraticuleLabelDataType
 * @property {Point} geom Geometry.
 * @property {string} text Text.
 */ /**
 * @typedef {Object} Options
 * @property {string} [className='ol-layer'] A CSS class name to set to the layer element.
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {number} [maxLines=100] The maximum number of meridians and
 * parallels from the center of the map. The default value of 100 means that at
 * most 200 meridians and 200 parallels will be displayed. The default value is
 * appropriate for conformal projections like Spherical Mercator. If you
 * increase the value, more lines will be drawn and the drawing performance will
 * decrease.
 * @property {Stroke} [strokeStyle] The
 * stroke style to use for drawing the graticule. If not provided, the following stroke will be used:
 * ```js
 * new Stroke({
 *   color: 'rgba(0, 0, 0, 0.2)' // a not fully opaque black
 * });
 * ```
 * @property {number} [targetSize=100] The target size of the graticule cells,
 * in pixels.
 * @property {boolean} [showLabels=false] Render a label with the respective
 * latitude/longitude for each graticule line.
 * @property {function(number):string} [lonLabelFormatter] Label formatter for
 * longitudes. This function is called with the longitude as argument, and
 * should return a formatted string representing the longitude. By default,
 * labels are formatted as degrees, minutes, seconds and hemisphere.
 * @property {function(number):string} [latLabelFormatter] Label formatter for
 * latitudes. This function is called with the latitude as argument, and
 * should return a formatted string representing the latitude. By default,
 * labels are formatted as degrees, minutes, seconds and hemisphere.
 * @property {number} [lonLabelPosition=0] Longitude label position in fractions
 * (0..1) of view extent. 0 means at the bottom of the viewport, 1 means at the
 * top.
 * @property {number} [latLabelPosition=1] Latitude label position in fractions
 * (0..1) of view extent. 0 means at the left of the viewport, 1 means at the
 * right.
 * @property {Text} [lonLabelStyle] Longitude label text
 * style. If not provided, the following style will be used:
 * ```js
 * new Text({
 *   font: '12px Calibri,sans-serif',
 *   textBaseline: 'bottom',
 *   fill: new Fill({
 *     color: 'rgba(0,0,0,1)'
 *   }),
 *   stroke: new Stroke({
 *     color: 'rgba(255,255,255,1)',
 *     width: 3
 *   })
 * });
 * ```
 * Note that the default's `textBaseline` configuration will not work well for
 * `lonLabelPosition` configurations that position labels close to the top of
 * the viewport.
 * @property {Text} [latLabelStyle] Latitude label text style.
 * If not provided, the following style will be used:
 * ```js
 * new Text({
 *   font: '12px Calibri,sans-serif',
 *   textAlign: 'end',
 *   fill: new Fill({
 *     color: 'rgba(0,0,0,1)'
 *   }),
 *   stroke: Stroke({
 *     color: 'rgba(255,255,255,1)',
 *     width: 3
 *   })
 * });
 * ```
 * Note that the default's `textAlign` configuration will not work well for
 * `latLabelPosition` configurations that position labels close to the left of
 * the viewport.
 * @property {Array<number>} [intervals=[90, 45, 30, 20, 10, 5, 2, 1, 30/60, 20/60, 10/60, 5/60, 2/60, 1/60, 30/3600, 20/3600, 10/3600, 5/3600, 2/3600, 1/3600]]
 * Intervals (in degrees) for the graticule. Example to limit graticules to 30 and 10 degrees intervals:
 * ```js
 * [30, 10]
 * ```
 * @property {boolean} [wrapX=true] Whether to repeat the graticule horizontally.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 */ /**
 * @classdesc
 * Layer that renders a grid for a coordinate system (currently only EPSG:4326 is supported).
 * Note that the view projection must define both extent and worldExtent.
 *
 * @fires import("../render/Event.js").RenderEvent#prerender
 * @fires import("../render/Event.js").RenderEvent#postrender
 * @extends {VectorLayer<VectorSource<Feature>>}
 * @api
 */ class $5c86e5d1e6a6cb96$var$Graticule extends (0, $82a68515bd6ef378$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        const baseOptions = Object.assign({
            updateWhileAnimating: true,
            updateWhileInteracting: true,
            renderBuffer: 0
        }, options);
        delete baseOptions.maxLines;
        delete baseOptions.strokeStyle;
        delete baseOptions.targetSize;
        delete baseOptions.showLabels;
        delete baseOptions.lonLabelFormatter;
        delete baseOptions.latLabelFormatter;
        delete baseOptions.lonLabelPosition;
        delete baseOptions.latLabelPosition;
        delete baseOptions.lonLabelStyle;
        delete baseOptions.latLabelStyle;
        delete baseOptions.intervals;
        super(baseOptions);
        /**
     * @type {import("../proj/Projection.js").default}
     * @private
     */ this.projection_ = null;
        /**
     * @type {number}
     * @private
     */ this.maxLat_ = Infinity;
        /**
     * @type {number}
     * @private
     */ this.maxLon_ = Infinity;
        /**
     * @type {number}
     * @private
     */ this.minLat_ = -Infinity;
        /**
     * @type {number}
     * @private
     */ this.minLon_ = -Infinity;
        /**
     * @type {number}
     * @private
     */ this.maxX_ = Infinity;
        /**
     * @type {number}
     * @private
     */ this.maxY_ = Infinity;
        /**
     * @type {number}
     * @private
     */ this.minX_ = -Infinity;
        /**
     * @type {number}
     * @private
     */ this.minY_ = -Infinity;
        /**
     * @type {number}
     * @private
     */ this.targetSize_ = options.targetSize !== undefined ? options.targetSize : 100;
        /**
     * @type {number}
     * @private
     */ this.maxLines_ = options.maxLines !== undefined ? options.maxLines : 100;
        /**
     * @type {Array<LineString>}
     * @private
     */ this.meridians_ = [];
        /**
     * @type {Array<LineString>}
     * @private
     */ this.parallels_ = [];
        /**
     * @type {Stroke}
     * @private
     */ this.strokeStyle_ = options.strokeStyle !== undefined ? options.strokeStyle : $5c86e5d1e6a6cb96$var$DEFAULT_STROKE_STYLE;
        /**
     * @type {import("../proj.js").TransformFunction|undefined}
     * @private
     */ this.fromLonLatTransform_ = undefined;
        /**
     * @type {import("../proj.js").TransformFunction|undefined}
     * @private
     */ this.toLonLatTransform_ = undefined;
        /**
     * @type {import("../coordinate.js").Coordinate}
     * @private
     */ this.projectionCenterLonLat_ = null;
        /**
     * @type {import("../coordinate.js").Coordinate}
     * @private
     */ this.bottomLeft_ = null;
        /**
     * @type {import("../coordinate.js").Coordinate}
     * @private
     */ this.bottomRight_ = null;
        /**
     * @type {import("../coordinate.js").Coordinate}
     * @private
     */ this.topLeft_ = null;
        /**
     * @type {import("../coordinate.js").Coordinate}
     * @private
     */ this.topRight_ = null;
        /**
     * @type {Array<GraticuleLabelDataType>}
     * @private
     */ this.meridiansLabels_ = null;
        /**
     * @type {Array<GraticuleLabelDataType>}
     * @private
     */ this.parallelsLabels_ = null;
        if (options.showLabels) {
            /**
       * @type {null|function(number):string}
       * @private
       */ this.lonLabelFormatter_ = options.lonLabelFormatter == undefined ? (0, $1bd0a226f9a16141$export$6eb0ac5f024d8590).bind(this, 'EW') : options.lonLabelFormatter;
            /**
       * @type {function(number):string}
       * @private
       */ this.latLabelFormatter_ = options.latLabelFormatter == undefined ? (0, $1bd0a226f9a16141$export$6eb0ac5f024d8590).bind(this, 'NS') : options.latLabelFormatter;
            /**
       * Longitude label position in fractions (0..1) of view extent. 0 means
       * bottom, 1 means top.
       * @type {number}
       * @private
       */ this.lonLabelPosition_ = options.lonLabelPosition == undefined ? 0 : options.lonLabelPosition;
            /**
       * Latitude Label position in fractions (0..1) of view extent. 0 means left, 1
       * means right.
       * @type {number}
       * @private
       */ this.latLabelPosition_ = options.latLabelPosition == undefined ? 1 : options.latLabelPosition;
            /**
       * @type {Style}
       * @private
       */ this.lonLabelStyleBase_ = new (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)({
                text: options.lonLabelStyle !== undefined ? options.lonLabelStyle.clone() : new (0, $944be50faeff5321$export$2e2bcd8739ae039)({
                    font: '12px Calibri,sans-serif',
                    textBaseline: 'bottom',
                    fill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
                        color: 'rgba(0,0,0,1)'
                    }),
                    stroke: new (0, $f9d0329c5c745263$export$2e2bcd8739ae039)({
                        color: 'rgba(255,255,255,1)',
                        width: 3
                    })
                })
            });
            /**
       * @private
       * @param {import("../Feature").default} feature Feature
       * @return {Style} style
       */ this.lonLabelStyle_ = (feature)=>{
                const label = feature.get('graticule_label');
                this.lonLabelStyleBase_.getText().setText(label);
                return this.lonLabelStyleBase_;
            };
            /**
       * @type {Style}
       * @private
       */ this.latLabelStyleBase_ = new (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)({
                text: options.latLabelStyle !== undefined ? options.latLabelStyle.clone() : new (0, $944be50faeff5321$export$2e2bcd8739ae039)({
                    font: '12px Calibri,sans-serif',
                    textAlign: 'right',
                    fill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
                        color: 'rgba(0,0,0,1)'
                    }),
                    stroke: new (0, $f9d0329c5c745263$export$2e2bcd8739ae039)({
                        color: 'rgba(255,255,255,1)',
                        width: 3
                    })
                })
            });
            /**
       * @private
       * @param {import("../Feature").default} feature Feature
       * @return {Style} style
       */ this.latLabelStyle_ = (feature)=>{
                const label = feature.get('graticule_label');
                this.latLabelStyleBase_.getText().setText(label);
                return this.latLabelStyleBase_;
            };
            this.meridiansLabels_ = [];
            this.parallelsLabels_ = [];
            this.addEventListener((0, $f5e92a4d985a2824$export$2e2bcd8739ae039).POSTRENDER, this.drawLabels_.bind(this));
        }
        /**
     * @type {Array<number>}
     * @private
     */ this.intervals_ = options.intervals !== undefined ? options.intervals : $5c86e5d1e6a6cb96$var$INTERVALS;
        // use a source with a custom loader for lines & text
        this.setSource(new (0, $84888e4daf3fdf44$export$2e2bcd8739ae039)({
            loader: this.loaderFunction.bind(this),
            strategy: this.strategyFunction.bind(this),
            features: new (0, $931ffc4e747c14db$export$2e2bcd8739ae039)(),
            overlaps: false,
            useSpatialIndex: false,
            wrapX: options.wrapX
        }));
        /**
     * feature pool to use when updating graticule
     * @type {Array<Feature>}
     * @private
     */ this.featurePool_ = [];
        /**
     * @type {Style}
     * @private
     */ this.lineStyle_ = new (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)({
            stroke: this.strokeStyle_
        });
        /**
     * @type {?import("../extent.js").Extent}
     * @private
     */ this.loadedExtent_ = null;
        /**
     * @type {?import("../extent.js").Extent}
     * @private
     */ this.renderedExtent_ = null;
        /**
     * @type {?number}
     * @private
     */ this.renderedResolution_ = null;
        this.setRenderOrder(null);
    }
    /**
   * Strategy function for loading features based on the view's extent and
   * resolution.
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {number} resolution Resolution.
   * @return {Array<import("../extent.js").Extent>} Extents.
   */ strategyFunction(extent, resolution) {
        // extents may be passed in different worlds, to avoid endless loop we use only one
        let realWorldExtent = extent.slice();
        if (this.projection_ && this.getSource().getWrapX()) (0, $6da4c8ed3074c92b$export$39a9ce3624977b84)(realWorldExtent, this.projection_);
        if (this.loadedExtent_) {
            if ((0, $6da4c8ed3074c92b$export$998afeab28643bd6)(this.loadedExtent_, realWorldExtent, resolution)) // make sure result is exactly equal to previous extent
            realWorldExtent = this.loadedExtent_.slice();
            else // we should not keep track of loaded extents
            this.getSource().removeLoadedExtent(this.loadedExtent_);
        }
        return [
            realWorldExtent
        ];
    }
    /**
   * Update geometries in the source based on current view
   * @param {import("../extent").Extent} extent Extent
   * @param {number} resolution Resolution
   * @param {import("../proj/Projection.js").default} projection Projection
   */ loaderFunction(extent, resolution, projection) {
        this.loadedExtent_ = extent;
        const source = this.getSource();
        // only consider the intersection between our own extent & the requested one
        const layerExtent = this.getExtent() || [
            -Infinity,
            -Infinity,
            Infinity,
            Infinity
        ];
        const renderExtent = (0, $6da4c8ed3074c92b$export$72209efa88586d42)(layerExtent, extent);
        if (this.renderedExtent_ && (0, $6da4c8ed3074c92b$export$e9bab7fafb253603)(this.renderedExtent_, renderExtent) && this.renderedResolution_ === resolution) return;
        this.renderedExtent_ = renderExtent;
        this.renderedResolution_ = resolution;
        // bail out if nothing to render
        if ((0, $6da4c8ed3074c92b$export$dd1bc94b04021eeb)(renderExtent)) return;
        // update projection info
        const center = (0, $6da4c8ed3074c92b$export$c91255cadecfe081)(renderExtent);
        const squaredTolerance = resolution * resolution / 4;
        const updateProjectionInfo = !this.projection_ || !(0, $9c4744460e43e41b$export$fe091d73a555748b)(this.projection_, projection);
        if (updateProjectionInfo) this.updateProjectionInfo_(projection);
        this.createGraticule_(renderExtent, center, resolution, squaredTolerance);
        // first make sure we have enough features in the pool
        let featureCount = this.meridians_.length + this.parallels_.length;
        if (this.meridiansLabels_) featureCount += this.meridians_.length;
        if (this.parallelsLabels_) featureCount += this.parallels_.length;
        let feature;
        while(featureCount > this.featurePool_.length){
            feature = new (0, $9fd014ab6df63665$export$2e2bcd8739ae039)();
            this.featurePool_.push(feature);
        }
        const featuresColl = source.getFeaturesCollection();
        featuresColl.clear();
        let poolIndex = 0;
        // add features for the lines & labels
        let i, l;
        for(i = 0, l = this.meridians_.length; i < l; ++i){
            feature = this.featurePool_[poolIndex++];
            feature.setGeometry(this.meridians_[i]);
            feature.setStyle(this.lineStyle_);
            featuresColl.push(feature);
        }
        for(i = 0, l = this.parallels_.length; i < l; ++i){
            feature = this.featurePool_[poolIndex++];
            feature.setGeometry(this.parallels_[i]);
            feature.setStyle(this.lineStyle_);
            featuresColl.push(feature);
        }
    }
    /**
   * @param {number} lon Longitude.
   * @param {number} minLat Minimal latitude.
   * @param {number} maxLat Maximal latitude.
   * @param {number} squaredTolerance Squared tolerance.
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {number} index Index.
   * @return {number} Index.
   * @private
   */ addMeridian_(lon, minLat, maxLat, squaredTolerance, extent, index) {
        const lineString = this.getMeridian_(lon, minLat, maxLat, squaredTolerance, index);
        if ((0, $6da4c8ed3074c92b$export$7b0a31e10bbff018)(lineString.getExtent(), extent)) {
            if (this.meridiansLabels_) {
                const text = this.lonLabelFormatter_(lon);
                if (index in this.meridiansLabels_) this.meridiansLabels_[index].text = text;
                else this.meridiansLabels_[index] = {
                    geom: new (0, $6eced4c969949f6b$export$2e2bcd8739ae039)([]),
                    text: text
                };
            }
            this.meridians_[index++] = lineString;
        }
        return index;
    }
    /**
   * @param {number} lat Latitude.
   * @param {number} minLon Minimal longitude.
   * @param {number} maxLon Maximal longitude.
   * @param {number} squaredTolerance Squared tolerance.
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {number} index Index.
   * @return {number} Index.
   * @private
   */ addParallel_(lat, minLon, maxLon, squaredTolerance, extent, index) {
        const lineString = this.getParallel_(lat, minLon, maxLon, squaredTolerance, index);
        if ((0, $6da4c8ed3074c92b$export$7b0a31e10bbff018)(lineString.getExtent(), extent)) {
            if (this.parallelsLabels_) {
                const text = this.latLabelFormatter_(lat);
                if (index in this.parallelsLabels_) this.parallelsLabels_[index].text = text;
                else this.parallelsLabels_[index] = {
                    geom: new (0, $6eced4c969949f6b$export$2e2bcd8739ae039)([]),
                    text: text
                };
            }
            this.parallels_[index++] = lineString;
        }
        return index;
    }
    /**
   * @param {import("../render/Event.js").default} event Render event.
   * @private
   */ drawLabels_(event) {
        const rotation = event.frameState.viewState.rotation;
        const resolution = event.frameState.viewState.resolution;
        const size = event.frameState.size;
        const extent = event.frameState.extent;
        const rotationCenter = (0, $6da4c8ed3074c92b$export$c91255cadecfe081)(extent);
        let rotationExtent = extent;
        if (rotation) {
            const unrotatedWidth = size[0] * resolution;
            const unrotatedHeight = size[1] * resolution;
            rotationExtent = [
                rotationCenter[0] - unrotatedWidth / 2,
                rotationCenter[1] - unrotatedHeight / 2,
                rotationCenter[0] + unrotatedWidth / 2,
                rotationCenter[1] + unrotatedHeight / 2
            ];
        }
        let startWorld = 0;
        let endWorld = 0;
        let labelsAtStart = this.latLabelPosition_ < 0.5;
        const projectionExtent = this.projection_.getExtent();
        const worldWidth = (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(projectionExtent);
        if (this.getSource().getWrapX() && this.projection_.canWrapX() && !(0, $6da4c8ed3074c92b$export$be866b1e0809b17e)(projectionExtent, extent)) {
            startWorld = Math.floor((extent[0] - projectionExtent[0]) / worldWidth);
            endWorld = Math.ceil((extent[2] - projectionExtent[2]) / worldWidth);
            const inverted = Math.abs(rotation) > Math.PI / 2;
            labelsAtStart = labelsAtStart !== inverted;
        }
        const vectorContext = (0, $806302f479c89a9b$export$4c1f9592b019a76d)(event);
        for(let world = startWorld; world <= endWorld; ++world){
            let poolIndex = this.meridians_.length + this.parallels_.length;
            let feature, index, l, textPoint;
            if (this.meridiansLabels_) for(index = 0, l = this.meridiansLabels_.length; index < l; ++index){
                const lineString = this.meridians_[index];
                if (!rotation && world === 0) textPoint = this.getMeridianPoint_(lineString, extent, index);
                else {
                    const clone = lineString.clone();
                    clone.translate(world * worldWidth, 0);
                    clone.rotate(-rotation, rotationCenter);
                    textPoint = this.getMeridianPoint_(clone, rotationExtent, index);
                    textPoint.rotate(rotation, rotationCenter);
                }
                feature = this.featurePool_[poolIndex++];
                feature.setGeometry(textPoint);
                feature.set('graticule_label', this.meridiansLabels_[index].text);
                vectorContext.drawFeature(feature, this.lonLabelStyle_(feature));
            }
            if (this.parallelsLabels_) {
                if (world === startWorld && labelsAtStart || world === endWorld && !labelsAtStart) for(index = 0, l = this.parallels_.length; index < l; ++index){
                    const lineString = this.parallels_[index];
                    if (!rotation && world === 0) textPoint = this.getParallelPoint_(lineString, extent, index);
                    else {
                        const clone = lineString.clone();
                        clone.translate(world * worldWidth, 0);
                        clone.rotate(-rotation, rotationCenter);
                        textPoint = this.getParallelPoint_(clone, rotationExtent, index);
                        textPoint.rotate(rotation, rotationCenter);
                    }
                    feature = this.featurePool_[poolIndex++];
                    feature.setGeometry(textPoint);
                    feature.set('graticule_label', this.parallelsLabels_[index].text);
                    vectorContext.drawFeature(feature, this.latLabelStyle_(feature));
                }
            }
        }
    }
    /**
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {import("../coordinate.js").Coordinate} center Center.
   * @param {number} resolution Resolution.
   * @param {number} squaredTolerance Squared tolerance.
   * @private
   */ createGraticule_(extent, center, resolution, squaredTolerance) {
        const interval = this.getInterval_(resolution);
        if (interval == -1) {
            this.meridians_.length = 0;
            this.parallels_.length = 0;
            if (this.meridiansLabels_) this.meridiansLabels_.length = 0;
            if (this.parallelsLabels_) this.parallelsLabels_.length = 0;
            return;
        }
        let wrapX = false;
        const projectionExtent = this.projection_.getExtent();
        const worldWidth = (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(projectionExtent);
        if (this.getSource().getWrapX() && this.projection_.canWrapX() && !(0, $6da4c8ed3074c92b$export$be866b1e0809b17e)(projectionExtent, extent)) {
            if ((0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(extent) >= worldWidth) {
                extent[0] = projectionExtent[0];
                extent[2] = projectionExtent[2];
            } else wrapX = true;
        }
        // Constrain the center to fit into the extent available to the graticule
        const validCenterP = [
            (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(center[0], this.minX_, this.maxX_),
            (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(center[1], this.minY_, this.maxY_)
        ];
        // Transform the center to lon lat
        // Some projections may have a void area at the poles
        // so replace any NaN latitudes with the min or max value closest to a pole
        const centerLonLat = this.toLonLatTransform_(validCenterP);
        if (isNaN(centerLonLat[1])) centerLonLat[1] = Math.abs(this.maxLat_) >= Math.abs(this.minLat_) ? this.maxLat_ : this.minLat_;
        let centerLon = (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(centerLonLat[0], this.minLon_, this.maxLon_);
        let centerLat = (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(centerLonLat[1], this.minLat_, this.maxLat_);
        const maxLines = this.maxLines_;
        let cnt, idx, lat, lon;
        // Limit the extent to fit into the extent available to the graticule
        let validExtentP = extent;
        if (!wrapX) validExtentP = [
            (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(extent[0], this.minX_, this.maxX_),
            (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(extent[1], this.minY_, this.maxY_),
            (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(extent[2], this.minX_, this.maxX_),
            (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(extent[3], this.minY_, this.maxY_)
        ];
        // Transform the extent to get the lon lat ranges for the edges of the extent
        const validExtent = (0, $6da4c8ed3074c92b$export$9f9dcb98c894b623)(validExtentP, this.toLonLatTransform_, undefined, 8);
        let maxLat = validExtent[3];
        let maxLon = validExtent[2];
        let minLat = validExtent[1];
        let minLon = validExtent[0];
        if (!wrapX) {
            // Check if extremities of the world extent lie inside the extent
            // (for example the pole in a polar projection)
            // and extend the extent as appropriate
            if ((0, $6da4c8ed3074c92b$export$ac68c24d37ca240f)(validExtentP, this.bottomLeft_)) {
                minLon = this.minLon_;
                minLat = this.minLat_;
            }
            if ((0, $6da4c8ed3074c92b$export$ac68c24d37ca240f)(validExtentP, this.bottomRight_)) {
                maxLon = this.maxLon_;
                minLat = this.minLat_;
            }
            if ((0, $6da4c8ed3074c92b$export$ac68c24d37ca240f)(validExtentP, this.topLeft_)) {
                minLon = this.minLon_;
                maxLat = this.maxLat_;
            }
            if ((0, $6da4c8ed3074c92b$export$ac68c24d37ca240f)(validExtentP, this.topRight_)) {
                maxLon = this.maxLon_;
                maxLat = this.maxLat_;
            }
            // The transformed center may also extend the lon lat ranges used for rendering
            maxLat = (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(maxLat, centerLat, this.maxLat_);
            maxLon = (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(maxLon, centerLon, this.maxLon_);
            minLat = (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(minLat, this.minLat_, centerLat);
            minLon = (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(minLon, this.minLon_, centerLon);
        }
        // Create meridians
        centerLon = Math.floor(centerLon / interval) * interval;
        lon = (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(centerLon, this.minLon_, this.maxLon_);
        idx = this.addMeridian_(lon, minLat, maxLat, squaredTolerance, extent, 0);
        cnt = 0;
        if (wrapX) while((lon -= interval) >= minLon && cnt++ < maxLines)idx = this.addMeridian_(lon, minLat, maxLat, squaredTolerance, extent, idx);
        else while(lon != this.minLon_ && cnt++ < maxLines){
            lon = Math.max(lon - interval, this.minLon_);
            idx = this.addMeridian_(lon, minLat, maxLat, squaredTolerance, extent, idx);
        }
        lon = (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(centerLon, this.minLon_, this.maxLon_);
        cnt = 0;
        if (wrapX) while((lon += interval) <= maxLon && cnt++ < maxLines)idx = this.addMeridian_(lon, minLat, maxLat, squaredTolerance, extent, idx);
        else while(lon != this.maxLon_ && cnt++ < maxLines){
            lon = Math.min(lon + interval, this.maxLon_);
            idx = this.addMeridian_(lon, minLat, maxLat, squaredTolerance, extent, idx);
        }
        this.meridians_.length = idx;
        if (this.meridiansLabels_) this.meridiansLabels_.length = idx;
        // Create parallels
        centerLat = Math.floor(centerLat / interval) * interval;
        lat = (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(centerLat, this.minLat_, this.maxLat_);
        idx = this.addParallel_(lat, minLon, maxLon, squaredTolerance, extent, 0);
        cnt = 0;
        while(lat != this.minLat_ && cnt++ < maxLines){
            lat = Math.max(lat - interval, this.minLat_);
            idx = this.addParallel_(lat, minLon, maxLon, squaredTolerance, extent, idx);
        }
        lat = (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(centerLat, this.minLat_, this.maxLat_);
        cnt = 0;
        while(lat != this.maxLat_ && cnt++ < maxLines){
            lat = Math.min(lat + interval, this.maxLat_);
            idx = this.addParallel_(lat, minLon, maxLon, squaredTolerance, extent, idx);
        }
        this.parallels_.length = idx;
        if (this.parallelsLabels_) this.parallelsLabels_.length = idx;
    }
    /**
   * @param {number} resolution Resolution.
   * @return {number} The interval in degrees.
   * @private
   */ getInterval_(resolution) {
        const centerLon = this.projectionCenterLonLat_[0];
        const centerLat = this.projectionCenterLonLat_[1];
        let interval = -1;
        const target = Math.pow(this.targetSize_ * resolution, 2);
        /** @type {Array<number>} **/ const p1 = [];
        /** @type {Array<number>} **/ const p2 = [];
        for(let i = 0, ii = this.intervals_.length; i < ii; ++i){
            const delta = (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(this.intervals_[i] / 2, 0, 90);
            // Don't attempt to transform latitudes beyond the poles!
            const clampedLat = (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(centerLat, -90 + delta, 90 - delta);
            p1[0] = centerLon - delta;
            p1[1] = clampedLat - delta;
            p2[0] = centerLon + delta;
            p2[1] = clampedLat + delta;
            this.fromLonLatTransform_(p1, p1);
            this.fromLonLatTransform_(p2, p2);
            const dist = Math.pow(p2[0] - p1[0], 2) + Math.pow(p2[1] - p1[1], 2);
            if (dist <= target) break;
            interval = this.intervals_[i];
        }
        return interval;
    }
    /**
   * @param {number} lon Longitude.
   * @param {number} minLat Minimal latitude.
   * @param {number} maxLat Maximal latitude.
   * @param {number} squaredTolerance Squared tolerance.
   * @return {LineString} The meridian line string.
   * @param {number} index Index.
   * @private
   */ getMeridian_(lon, minLat, maxLat, squaredTolerance, index) {
        const flatCoordinates = (0, $f75093ed6511c732$export$8314518f9c22f11b)(lon, minLat, maxLat, this.projection_, squaredTolerance);
        let lineString = this.meridians_[index];
        if (!lineString) {
            lineString = new (0, $292e4002746c8223$export$2e2bcd8739ae039)(flatCoordinates, 'XY');
            this.meridians_[index] = lineString;
        } else {
            lineString.setFlatCoordinates('XY', flatCoordinates);
            lineString.changed();
        }
        return lineString;
    }
    /**
   * @param {LineString} lineString Meridian
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {number} index Index.
   * @return {Point} Meridian point.
   * @private
   */ getMeridianPoint_(lineString, extent, index) {
        const flatCoordinates = lineString.getFlatCoordinates();
        let bottom = 1;
        let top = flatCoordinates.length - 1;
        if (flatCoordinates[bottom] > flatCoordinates[top]) {
            bottom = top;
            top = 1;
        }
        const clampedBottom = Math.max(extent[1], flatCoordinates[bottom]);
        const clampedTop = Math.min(extent[3], flatCoordinates[top]);
        const lat = (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(extent[1] + Math.abs(extent[1] - extent[3]) * this.lonLabelPosition_, clampedBottom, clampedTop);
        const coordinate0 = flatCoordinates[bottom - 1] + (flatCoordinates[top - 1] - flatCoordinates[bottom - 1]) * (lat - flatCoordinates[bottom]) / (flatCoordinates[top] - flatCoordinates[bottom]);
        const coordinate = [
            coordinate0,
            lat
        ];
        const point = this.meridiansLabels_[index].geom;
        point.setCoordinates(coordinate);
        return point;
    }
    /**
   * Get the list of meridians.  Meridians are lines of equal longitude.
   * @return {Array<LineString>} The meridians.
   * @api
   */ getMeridians() {
        return this.meridians_;
    }
    /**
   * @param {number} lat Latitude.
   * @param {number} minLon Minimal longitude.
   * @param {number} maxLon Maximal longitude.
   * @param {number} squaredTolerance Squared tolerance.
   * @return {LineString} The parallel line string.
   * @param {number} index Index.
   * @private
   */ getParallel_(lat, minLon, maxLon, squaredTolerance, index) {
        const flatCoordinates = (0, $f75093ed6511c732$export$451942af9381149c)(lat, minLon, maxLon, this.projection_, squaredTolerance);
        let lineString = this.parallels_[index];
        if (!lineString) lineString = new (0, $292e4002746c8223$export$2e2bcd8739ae039)(flatCoordinates, 'XY');
        else {
            lineString.setFlatCoordinates('XY', flatCoordinates);
            lineString.changed();
        }
        return lineString;
    }
    /**
   * @param {LineString} lineString Parallels.
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {number} index Index.
   * @return {Point} Parallel point.
   * @private
   */ getParallelPoint_(lineString, extent, index) {
        const flatCoordinates = lineString.getFlatCoordinates();
        let left = 0;
        let right = flatCoordinates.length - 2;
        if (flatCoordinates[left] > flatCoordinates[right]) {
            left = right;
            right = 0;
        }
        const clampedLeft = Math.max(extent[0], flatCoordinates[left]);
        const clampedRight = Math.min(extent[2], flatCoordinates[right]);
        const lon = (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(extent[0] + Math.abs(extent[0] - extent[2]) * this.latLabelPosition_, clampedLeft, clampedRight);
        const coordinate1 = flatCoordinates[left + 1] + (flatCoordinates[right + 1] - flatCoordinates[left + 1]) * (lon - flatCoordinates[left]) / (flatCoordinates[right] - flatCoordinates[left]);
        const coordinate = [
            lon,
            coordinate1
        ];
        const point = this.parallelsLabels_[index].geom;
        point.setCoordinates(coordinate);
        return point;
    }
    /**
   * Get the list of parallels.  Parallels are lines of equal latitude.
   * @return {Array<LineString>} The parallels.
   * @api
   */ getParallels() {
        return this.parallels_;
    }
    /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @private
   */ updateProjectionInfo_(projection) {
        const epsg4326Projection = (0, $9c4744460e43e41b$export$3988ae62b71be9a3)('EPSG:4326');
        const worldExtent = projection.getWorldExtent();
        this.maxLat_ = worldExtent[3];
        this.maxLon_ = worldExtent[2];
        this.minLat_ = worldExtent[1];
        this.minLon_ = worldExtent[0];
        // If the world extent crosses the dateline define a custom transform to
        // return longitudes which wrap the dateline
        const toLonLatTransform = (0, $9c4744460e43e41b$export$fce0c6cfca85ed96)(projection, epsg4326Projection);
        if (this.minLon_ < this.maxLon_) this.toLonLatTransform_ = toLonLatTransform;
        else {
            const split = this.minLon_ + this.maxLon_ / 2;
            this.maxLon_ += 360;
            this.toLonLatTransform_ = function(coordinates, output, dimension) {
                dimension = dimension || 2;
                const lonLatCoordinates = toLonLatTransform(coordinates, output, dimension);
                for(let i = 0, l = lonLatCoordinates.length; i < l; i += dimension)if (lonLatCoordinates[i] < split) lonLatCoordinates[i] += 360;
                return lonLatCoordinates;
            };
        }
        // Transform the extent to get the limits of the view projection extent
        // which should be available to the graticule
        this.fromLonLatTransform_ = (0, $9c4744460e43e41b$export$fce0c6cfca85ed96)(epsg4326Projection, projection);
        const worldExtentP = (0, $6da4c8ed3074c92b$export$9f9dcb98c894b623)([
            this.minLon_,
            this.minLat_,
            this.maxLon_,
            this.maxLat_
        ], this.fromLonLatTransform_, undefined, 8);
        this.minX_ = worldExtentP[0];
        this.maxX_ = worldExtentP[2];
        this.minY_ = worldExtentP[1];
        this.maxY_ = worldExtentP[3];
        // Determine the view projection coordinates of the extremities of the world extent
        // as these may lie inside a view extent (for example the pole in a polar projection)
        this.bottomLeft_ = this.fromLonLatTransform_([
            this.minLon_,
            this.minLat_
        ]);
        this.bottomRight_ = this.fromLonLatTransform_([
            this.maxLon_,
            this.minLat_
        ]);
        this.topLeft_ = this.fromLonLatTransform_([
            this.minLon_,
            this.maxLat_
        ]);
        this.topRight_ = this.fromLonLatTransform_([
            this.maxLon_,
            this.maxLat_
        ]);
        // Transform the projection center to lon lat
        // Some projections may have a void area at the poles
        // so replace any NaN latitudes with the min or max value closest to a pole
        this.projectionCenterLonLat_ = this.toLonLatTransform_((0, $6da4c8ed3074c92b$export$c91255cadecfe081)(projection.getExtent()));
        if (isNaN(this.projectionCenterLonLat_[1])) this.projectionCenterLonLat_[1] = Math.abs(this.maxLat_) >= Math.abs(this.minLat_) ? this.maxLat_ : this.minLat_;
        this.projection_ = projection;
    }
}
var $5c86e5d1e6a6cb96$export$2e2bcd8739ae039 = $5c86e5d1e6a6cb96$var$Graticule;








const $c681c904fb3b4803$var$FILENAME = 'graticule-tool.js';
const $c681c904fb3b4803$var$CLASS__TOOL_BUTTON = 'oltb-tool-button';
const $c681c904fb3b4803$var$I18N__BASE = 'tools.graticuleTool';
const $c681c904fb3b4803$var$DASHED_ON = [
    1,
    4
];
const $c681c904fb3b4803$var$DASHED_OFF = [
    0,
    0
];
const $c681c904fb3b4803$var$DefaultOptions = Object.freeze({
    color: '#3B4352E6',
    dashed: true,
    width: 2,
    showLabels: true,
    wrapX: true,
    onInitiated: undefined,
    onClicked: undefined,
    onBrowserStateCleared: undefined
});
const $c681c904fb3b4803$var$LocalStorageNodeName = (0, $52e25f2a10ab5b5c$export$ada36e8a1c3bc83a).graticuleTool;
const $c681c904fb3b4803$var$LocalStorageDefaults = Object.freeze({
    isActive: false
});
/**
 * About:
 * Graphical depiction of a coordinate system as a grid of lines
 * 
 * Description:
 * Show a graphical depiction of a coordinate system as a grid of lines both in vertical and horizontal directions.
 */ class $c681c904fb3b4803$export$470a47c7d25f2673 extends (0, $10d08d54da4ecbc4$export$cf198134d112da63) {
    constructor(options = {}){
        super({
            filename: $c681c904fb3b4803$var$FILENAME
        });
        const icon = (0, $dcff5ab966a6537f$export$a297fe855adfd36c)({
            path: (0, $35649bc6579784f8$export$3fddabec91763a6e).globe.stroked,
            class: `${$c681c904fb3b4803$var$CLASS__TOOL_BUTTON}__icon`
        });
        const i18n = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get($c681c904fb3b4803$var$I18N__BASE);
        const button = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'button',
            html: icon,
            class: $c681c904fb3b4803$var$CLASS__TOOL_BUTTON,
            attributes: {
                'type': 'button',
                'data-tippy-content': `${i18n.title} (${(0, $a256deadcc62504f$export$4384767a59dc851d).graticuleTool})`,
                'data-tippy-content-post': `(${(0, $a256deadcc62504f$export$4384767a59dc851d).graticuleTool})`,
                'data-oltb-i18n': `${$c681c904fb3b4803$var$I18N__BASE}.title`
            },
            listeners: {
                'click': this.onClickTool.bind(this)
            }
        });
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(this.element, [
            button
        ]);
        this.button = button;
        this.isActive = false;
        this.options = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep($c681c904fb3b4803$var$DefaultOptions), options);
        this.localStorage = (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).getAndMergeStateObject($c681c904fb3b4803$var$LocalStorageNodeName, $c681c904fb3b4803$var$LocalStorageDefaults);
        this.graticule = this.#generateOLGraticule();
        this.attachGlobalListeners();
        // Note: 
        // @Consumer callback
        if (this.options.onInitiated) this.options.onInitiated();
    }
    attachGlobalListeners() {
        this.onWindowKeyUpBind = this.#onWindowKeyUp.bind(this);
        this.onOLTBReadyBind = this.#onOLTBReady.bind(this);
        this.onWindowBrowserStateClearedBind = this.#onWindowBrowserStateCleared.bind(this);
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.keyUp, this.onWindowKeyUpBind);
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.ready, this.onOLTBReadyBind);
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.browserStateCleared, this.onWindowBrowserStateClearedBind);
    }
    detachGlobalListeners() {
        window.removeEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.keyUp, this.onWindowKeyUpBind);
        window.removeEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.ready, this.onOLTBReadyBind);
        window.removeEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.browserStateCleared, this.onWindowBrowserStateClearedBind);
    }
    //--------------------------------------------------------------------
    // # Section: Overridden
    //--------------------------------------------------------------------
    getName() {
        return super.getName();
    }
    onClickTool(event) {
        super.onClickTool(event);
        if (this.isActive) this.deactivateTool();
        else this.activateTool();
        // Note: 
        // @Consumer callback
        if (this.options.onClicked) this.options.onClicked();
    }
    //--------------------------------------------------------------------
    // # Section: Generate Helpers
    //--------------------------------------------------------------------
    #generateOLGraticule() {
        return new (0, $5c86e5d1e6a6cb96$export$2e2bcd8739ae039)({
            strokeStyle: new (0, $f9d0329c5c745263$export$2e2bcd8739ae039)({
                color: this.options.color,
                width: this.options.width,
                lineDash: this.options.dashed ? $c681c904fb3b4803$var$DASHED_ON : $c681c904fb3b4803$var$DASHED_OFF
            }),
            showLabels: this.options.showLabels,
            isVisible: true,
            wrapX: this.options.wrapX
        });
    }
    //--------------------------------------------------------------------
    // # Section: Tool Control
    //--------------------------------------------------------------------
    activateTool() {
        const map = this.getMap();
        if (!map) return;
        this.doAddGraticuleLines(map);
        this.isActive = true;
        this.button.classList.add(`${$c681c904fb3b4803$var$CLASS__TOOL_BUTTON}--active`);
        this.localStorage.isActive = true;
        (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).setStateObject($c681c904fb3b4803$var$LocalStorageNodeName, this.localStorage);
    }
    deactivateTool() {
        this.doRemoveGraticuleLines();
        this.isActive = false;
        this.button.classList.remove(`${$c681c904fb3b4803$var$CLASS__TOOL_BUTTON}--active`);
        this.localStorage.isActive = false;
        (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).setStateObject($c681c904fb3b4803$var$LocalStorageNodeName, this.localStorage);
    }
    //--------------------------------------------------------------------
    // # Section: Browser Events
    //--------------------------------------------------------------------
    #onOLTBReady(event) {
        if (this.localStorage.isActive) this.activateTool();
    }
    #onWindowKeyUp(event) {
        if ((0, $fbd95439548fdf50$export$ad7bf7af8762113)(event, (0, $a256deadcc62504f$export$4384767a59dc851d).graticuleTool)) this.onClickTool(event);
    }
    #onWindowBrowserStateCleared() {
        this.doClearState();
        if (this.isActive) this.deactivateTool();
        // Note: 
        // @Consumer callback
        if (this.options.onBrowserStateCleared) this.options.onBrowserStateCleared();
    }
    //--------------------------------------------------------------------
    // # Section: Tool DoActions
    //--------------------------------------------------------------------
    doClearState() {
        this.localStorage = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep($c681c904fb3b4803$var$LocalStorageDefaults);
        (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).setStateObject($c681c904fb3b4803$var$LocalStorageNodeName, $c681c904fb3b4803$var$LocalStorageDefaults);
    }
    doAddGraticuleLines(map) {
        this.graticule.setMap(map);
    }
    doRemoveGraticuleLines() {
        this.graticule.setMap(null);
    }
}



var $f1q41 = parcelRequire("f1q41");
/* eslint-disable promise/prefer-await-to-then */ const $0fb704a73fce4e36$var$methodMap = [
    [
        'requestFullscreen',
        'exitFullscreen',
        'fullscreenElement',
        'fullscreenEnabled',
        'fullscreenchange',
        'fullscreenerror'
    ],
    // New WebKit
    [
        'webkitRequestFullscreen',
        'webkitExitFullscreen',
        'webkitFullscreenElement',
        'webkitFullscreenEnabled',
        'webkitfullscreenchange',
        'webkitfullscreenerror'
    ],
    // Old WebKit
    [
        'webkitRequestFullScreen',
        'webkitCancelFullScreen',
        'webkitCurrentFullScreenElement',
        'webkitCancelFullScreen',
        'webkitfullscreenchange',
        'webkitfullscreenerror'
    ],
    [
        'mozRequestFullScreen',
        'mozCancelFullScreen',
        'mozFullScreenElement',
        'mozFullScreenEnabled',
        'mozfullscreenchange',
        'mozfullscreenerror'
    ],
    [
        'msRequestFullscreen',
        'msExitFullscreen',
        'msFullscreenElement',
        'msFullscreenEnabled',
        'MSFullscreenChange',
        'MSFullscreenError'
    ]
];
const $0fb704a73fce4e36$var$nativeAPI = (()=>{
    if (typeof document === 'undefined') return false;
    const unprefixedMethods = $0fb704a73fce4e36$var$methodMap[0];
    const returnValue = {};
    for (const methodList of $0fb704a73fce4e36$var$methodMap){
        const exitFullscreenMethod = methodList?.[1];
        if (exitFullscreenMethod in document) {
            for (const [index, method] of methodList.entries())returnValue[unprefixedMethods[index]] = method;
            return returnValue;
        }
    }
    return false;
})();
const $0fb704a73fce4e36$var$eventNameMap = {
    change: $0fb704a73fce4e36$var$nativeAPI.fullscreenchange,
    error: $0fb704a73fce4e36$var$nativeAPI.fullscreenerror
};
// eslint-disable-next-line import/no-mutable-exports
let $0fb704a73fce4e36$var$screenfull = {
    // eslint-disable-next-line default-param-last
    request (element = document.documentElement, options) {
        return new Promise((resolve, reject)=>{
            const onFullScreenEntered = ()=>{
                $0fb704a73fce4e36$var$screenfull.off('change', onFullScreenEntered);
                resolve();
            };
            $0fb704a73fce4e36$var$screenfull.on('change', onFullScreenEntered);
            const returnPromise = element[$0fb704a73fce4e36$var$nativeAPI.requestFullscreen](options);
            if (returnPromise instanceof Promise) returnPromise.then(onFullScreenEntered).catch(reject);
        });
    },
    exit () {
        return new Promise((resolve, reject)=>{
            if (!$0fb704a73fce4e36$var$screenfull.isFullscreen) {
                resolve();
                return;
            }
            const onFullScreenExit = ()=>{
                $0fb704a73fce4e36$var$screenfull.off('change', onFullScreenExit);
                resolve();
            };
            $0fb704a73fce4e36$var$screenfull.on('change', onFullScreenExit);
            const returnPromise = document[$0fb704a73fce4e36$var$nativeAPI.exitFullscreen]();
            if (returnPromise instanceof Promise) returnPromise.then(onFullScreenExit).catch(reject);
        });
    },
    toggle (element, options) {
        return $0fb704a73fce4e36$var$screenfull.isFullscreen ? $0fb704a73fce4e36$var$screenfull.exit() : $0fb704a73fce4e36$var$screenfull.request(element, options);
    },
    onchange (callback) {
        $0fb704a73fce4e36$var$screenfull.on('change', callback);
    },
    onerror (callback) {
        $0fb704a73fce4e36$var$screenfull.on('error', callback);
    },
    on (event, callback) {
        const eventName = $0fb704a73fce4e36$var$eventNameMap[event];
        if (eventName) document.addEventListener(eventName, callback, false);
    },
    off (event, callback) {
        const eventName = $0fb704a73fce4e36$var$eventNameMap[event];
        if (eventName) document.removeEventListener(eventName, callback, false);
    },
    raw: $0fb704a73fce4e36$var$nativeAPI
};
Object.defineProperties($0fb704a73fce4e36$var$screenfull, {
    isFullscreen: {
        get: ()=>Boolean(document[$0fb704a73fce4e36$var$nativeAPI.fullscreenElement])
    },
    element: {
        enumerable: true,
        get: ()=>document[$0fb704a73fce4e36$var$nativeAPI.fullscreenElement] ?? undefined
    },
    isEnabled: {
        enumerable: true,
        // Coerce to boolean in case of old WebKit.
        get: ()=>Boolean(document[$0fb704a73fce4e36$var$nativeAPI.fullscreenEnabled])
    }
});
if (!$0fb704a73fce4e36$var$nativeAPI) $0fb704a73fce4e36$var$screenfull = {
    isEnabled: false
};
var $0fb704a73fce4e36$export$2e2bcd8739ae039 = $0fb704a73fce4e36$var$screenfull;



















const $7dd4fce02670c9f4$var$FILENAME = 'my-location-tool.js';
const $7dd4fce02670c9f4$var$CLASS__TOOL_BUTTON = 'oltb-tool-button';
const $7dd4fce02670c9f4$var$CLASS__FUNC_BUTTON = 'oltb-func-btn';
const $7dd4fce02670c9f4$var$ID__PREFIX_INFO_WINDOW = 'oltb-info-window-marker';
const $7dd4fce02670c9f4$var$ID__MARKER_PATH = 'person.filled';
const $7dd4fce02670c9f4$var$I18N__BASE = 'tools.myLocationTool';
const $7dd4fce02670c9f4$var$I18N__BASE_COMMON = 'commons';
const $7dd4fce02670c9f4$var$DefaultOptions = Object.freeze({
    title: 'My Location',
    description: 'This is the location that the browser was able to find. It might not be your actual location.',
    enableHighAccuracy: true,
    timeout: 10000,
    markerLabelUseEllipsisAfter: 20,
    markerLabelUseUpperCase: false,
    onInitiated: undefined,
    onClicked: undefined,
    onLocationFound: undefined,
    onError: undefined
});
/**
 * About:
 * Mark your geographic location
 * 
 * Description:
 * Ask the browser's built-in API for your current location. 
 * A separate layer is created for this which contains a Marker with your position.
 */ class $7dd4fce02670c9f4$export$4904c93a070eae15 extends (0, $10d08d54da4ecbc4$export$cf198134d112da63) {
    constructor(options = {}){
        super({
            filename: $7dd4fce02670c9f4$var$FILENAME
        });
        const icon = (0, $dcff5ab966a6537f$export$a297fe855adfd36c)({
            path: (0, $35649bc6579784f8$export$3fddabec91763a6e).geoMarker.stroked,
            class: `${$7dd4fce02670c9f4$var$CLASS__TOOL_BUTTON}__icon`
        });
        const i18n = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get($7dd4fce02670c9f4$var$I18N__BASE);
        const button = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'button',
            html: icon,
            class: $7dd4fce02670c9f4$var$CLASS__TOOL_BUTTON,
            attributes: {
                'type': 'button',
                'data-tippy-content': `${i18n.title} (${(0, $a256deadcc62504f$export$4384767a59dc851d).myLocationTool})`,
                'data-tippy-content-post': `(${(0, $a256deadcc62504f$export$4384767a59dc851d).myLocationTool})`,
                'data-oltb-i18n': `${$7dd4fce02670c9f4$var$I18N__BASE}.title`
            },
            listeners: {
                'click': this.onClickTool.bind(this)
            }
        });
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(this.element, [
            button
        ]);
        this.button = button;
        this.options = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep($7dd4fce02670c9f4$var$DefaultOptions), options);
        this.attachGlobalListeners();
        // Note: 
        // @Consumer callback
        if (this.options.onInitiated) this.options.onInitiated();
    }
    attachGlobalListeners() {
        this.onWindowKeyUpBind = this.#onWindowKeyUp.bind(this);
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.keyUp, this.onWindowKeyUpBind);
    }
    detachGlobalListeners() {
        window.removeEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.keyUp, this.onWindowKeyUpBind);
    }
    //--------------------------------------------------------------------
    // # Section: Overridden
    //--------------------------------------------------------------------
    getName() {
        return super.getName();
    }
    onClickTool(event) {
        super.onClickTool(event);
        this.momentaryActivation();
        // Note: 
        // @Consumer callback
        if (this.options.onClicked) this.options.onClicked();
    }
    //--------------------------------------------------------------------
    // # Section: Tool Control
    //--------------------------------------------------------------------
    momentaryActivation() {
        if ((0, $0fb704a73fce4e36$export$2e2bcd8739ae039).isFullscreen) this.askToExitFullscreen();
        else this.doGeoLocationSearch();
    }
    //--------------------------------------------------------------------
    // # Section: Browser Events
    //--------------------------------------------------------------------
    #onWindowKeyUp(event) {
        if ((0, $fbd95439548fdf50$export$ad7bf7af8762113)(event, (0, $a256deadcc62504f$export$4384767a59dc851d).myLocationTool)) this.onClickTool(event);
    }
    //--------------------------------------------------------------------
    // # Section: Map/UI Callbacks
    //--------------------------------------------------------------------
    #onSuccess(location) {
        this.doLocationFound(location);
    }
    #onError(error) {
        this.doLocationError(error);
    }
    //--------------------------------------------------------------------
    // # Section: Ask User
    //--------------------------------------------------------------------
    askToExitFullscreen() {
        const i18n = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get(`${$7dd4fce02670c9f4$var$I18N__BASE}.dialogs.confirms.exitFullscreen`);
        return (0, $c815862f3b0d8f0b$export$3ddf2d174ce01153).confirm({
            title: i18n.title,
            message: i18n.message,
            confirmClass: (0, $c815862f3b0d8f0b$export$3ddf2d174ce01153).Success,
            confirmText: i18n.confirmText,
            cancelText: i18n.cancelText,
            onConfirm: async ()=>{
                return (0, $0fb704a73fce4e36$export$2e2bcd8739ae039).exit().then(()=>{
                    this.doGeoLocationSearch();
                }).catch((error)=>{
                    (0, $b9b5c0363f244088$export$49b118289be48034).logError($7dd4fce02670c9f4$var$FILENAME, 'askToExitFullscreen', {
                        message: 'Failed to exit fullscreen',
                        error: error
                    });
                    (0, $9051f0e072bf4341$export$8d8dc7d5f743331b).error({
                        i18nKey: `${$7dd4fce02670c9f4$var$I18N__BASE}.toasts.errors.exitFullscreen`
                    });
                });
            }
        });
    }
    //--------------------------------------------------------------------
    // # Section: Tool DoActions
    //--------------------------------------------------------------------
    doLocationFound(location) {
        const map = this.getMap();
        if (!map) return;
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).removeElement(this.loadingToast);
        const coordinates = [
            location.coords.longitude,
            location.coords.latitude
        ];
        const marker = this.doAddIconMarker(coordinates);
        this.doFocusMarker(map, marker, coordinates, (0, $1e8c0ef90ed82280$export$a33e119b2316dcb7).getConfig().marker.focusZoom);
        // Note: 
        // @Consumer callback
        if (this.options.onLocationFound) this.options.onLocationFound(location);
    }
    doLocationError(error) {
        (0, $b9b5c0363f244088$export$49b118289be48034).logError($7dd4fce02670c9f4$var$FILENAME, 'doLocationError', {
            message: error.message,
            error: error
        });
        (0, $9051f0e072bf4341$export$8d8dc7d5f743331b).error({
            i18nKey: `${$7dd4fce02670c9f4$var$I18N__BASE}.toasts.errors.locationNotFound`
        });
        // Note: 
        // @Consumer callback
        if (this.options.onError) this.options.onError(error);
        if (this.loadingToast) (0, $e1b36be5f031477b$export$cb0933279c36a66b).removeElement(this.loadingToast);
    }
    doFocusMarker(map, marker, coordinates, zoom) {
        (0, $eb687437705d7055$export$cc43ef3ca2ae36e8)({
            map: map,
            coordinates: coordinates,
            zoom: zoom,
            onDone: (result)=>{
                (0, $09399be6683278f4$export$ffc0bcd424265bb8).tryPulseAnimation(marker);
                (0, $09399be6683278f4$export$ffc0bcd424265bb8).showOverlay(marker, (0, $9c4744460e43e41b$export$b15d9668511529b9)(coordinates));
            }
        });
    }
    doAddMarkerToMap(marker) {
        const layerWrapper = (0, $e75fe1c51a3d360c$export$eff87c52915dd7fe).addFeatureLayer({
            name: this.options.title
        });
        layerWrapper.getLayer().getSource().addFeature(marker);
    }
    doAddIconMarker(coordinates) {
        const i18n = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get(`${$7dd4fce02670c9f4$var$I18N__BASE_COMMON}.titles`);
        const prettyCoordinates = (0, $1bd0a226f9a16141$export$c883fd238161f841)(coordinates);
        const infoWindow = {
            title: this.options.title,
            content: `
                <p>${this.options.description}</p>
            `,
            footer: `
                <span class="oltb-info-window__coordinates">${prettyCoordinates}</span>
                <div class="oltb-info-window__buttons-wrapper">
                    <button class="${$7dd4fce02670c9f4$var$CLASS__FUNC_BUTTON} ${$7dd4fce02670c9f4$var$CLASS__FUNC_BUTTON}--delete oltb-tippy" data-oltb-i18n="${$7dd4fce02670c9f4$var$I18N__BASE_COMMON}.titles.delete" title="${i18n.delete}" id="${$7dd4fce02670c9f4$var$ID__PREFIX_INFO_WINDOW}-remove"></button>
                    <button class="${$7dd4fce02670c9f4$var$CLASS__FUNC_BUTTON} ${$7dd4fce02670c9f4$var$CLASS__FUNC_BUTTON}--crosshair oltb-tippy" data-oltb-i18n="${$7dd4fce02670c9f4$var$I18N__BASE_COMMON}.titles.copyCoordinates" title="${i18n.copyCoordinates}" id="${$7dd4fce02670c9f4$var$ID__PREFIX_INFO_WINDOW}-copy-coordinates" data-oltb-coordinates="${prettyCoordinates}"></button>
                    <button class="${$7dd4fce02670c9f4$var$CLASS__FUNC_BUTTON} ${$7dd4fce02670c9f4$var$CLASS__FUNC_BUTTON}--copy oltb-tippy" data-oltb-i18n="${$7dd4fce02670c9f4$var$I18N__BASE_COMMON}.titles.copyText" title="${i18n.copyText}" id="${$7dd4fce02670c9f4$var$ID__PREFIX_INFO_WINDOW}-copy-text" data-oltb-copy="${this.options.description}"></button>
                    <button class="${$7dd4fce02670c9f4$var$CLASS__FUNC_BUTTON} ${$7dd4fce02670c9f4$var$CLASS__FUNC_BUTTON}--layer oltb-tippy" data-oltb-i18n="${$7dd4fce02670c9f4$var$I18N__BASE_COMMON}.titles.showLayer" title="${i18n.showLayer}" id="${$7dd4fce02670c9f4$var$ID__PREFIX_INFO_WINDOW}-show-layer"></button>
                </div>
            `
        };
        const marker = (0, $45f5d1a81c4ed6cb$export$73e78dff44a347ad).generateIconMarker({
            lon: coordinates[0],
            lat: coordinates[1],
            title: this.options.title,
            description: this.options.description,
            infoWindow: infoWindow,
            icon: {
                key: $7dd4fce02670c9f4$var$ID__MARKER_PATH
            },
            label: {
                text: this.options.title,
                useEllipsisAfter: this.options.markerLabelUseEllipsisAfter,
                useUpperCase: this.options.markerLabelUseUpperCase
            }
        });
        this.doAddMarkerToMap(marker);
        return marker;
    }
    doGeoLocationSearch() {
        if (this.loadingToast) return;
        if (!window.navigator || !window.navigator.geolocation) {
            this.#onError({
                message: 'Geolocation is not supported'
            });
            return;
        }
        this.loadingToast = (0, $9051f0e072bf4341$export$8d8dc7d5f743331b).info({
            i18nKey: `${$7dd4fce02670c9f4$var$I18N__BASE}.toasts.infos.fetchLocation`,
            clickToRemove: false,
            spinner: true,
            onRemove: ()=>{
                this.loadingToast = undefined;
            }
        });
        window.navigator.geolocation.getCurrentPosition(this.#onSuccess.bind(this), this.#onError.bind(this), {
            enableHighAccuracy: this.options.enableHighAccuracy,
            timeout: this.options.timeout
        });
    }
}



var $f1q41 = parcelRequire("f1q41");














const $46d01ba1c938131e$var$FILENAME = 'reset-north-tool.js';
const $46d01ba1c938131e$var$CLASS__TOOL_BUTTON = 'oltb-tool-button';
const $46d01ba1c938131e$var$I18N__BASE = 'tools.resetNorthTool';
const $46d01ba1c938131e$var$DefaultOptions = Object.freeze({
    onInitiated: undefined,
    onClicked: undefined,
    onReset: undefined
});
/**
 * About:
 * Reset the Map rotation to 0 degrees
 * 
 * Description:
 * The Map can be rotated using keyboard shortcuts and the mouse or using a specific number of degrees.
 */ class $46d01ba1c938131e$export$230d38141a067e83 extends (0, $10d08d54da4ecbc4$export$cf198134d112da63) {
    constructor(options = {}){
        super({
            filename: $46d01ba1c938131e$var$FILENAME
        });
        this.icon = (0, $dcff5ab966a6537f$export$a297fe855adfd36c)({
            path: (0, $35649bc6579784f8$export$3fddabec91763a6e).compass.stroked,
            class: `${$46d01ba1c938131e$var$CLASS__TOOL_BUTTON}__icon`
        });
        this.resetRotationIcon = (0, $dcff5ab966a6537f$export$a297fe855adfd36c)({
            path: (0, $35649bc6579784f8$export$3fddabec91763a6e).arrowRepeat.stroked,
            class: `${$46d01ba1c938131e$var$CLASS__TOOL_BUTTON}__icon`
        });
        const i18n = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get($46d01ba1c938131e$var$I18N__BASE);
        const button = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'button',
            html: this.icon,
            class: $46d01ba1c938131e$var$CLASS__TOOL_BUTTON,
            attributes: {
                'type': 'button',
                'data-tippy-content': `${i18n.title} (${(0, $a256deadcc62504f$export$4384767a59dc851d).resetNorthTool})`,
                'data-tippy-content-post': `(${(0, $a256deadcc62504f$export$4384767a59dc851d).resetNorthTool})`,
                'data-oltb-i18n': `${$46d01ba1c938131e$var$I18N__BASE}.title`
            },
            listeners: {
                'click': this.onClickTool.bind(this)
            }
        });
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(this.element, [
            button
        ]);
        this.button = button;
        this.options = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep($46d01ba1c938131e$var$DefaultOptions), options);
        this.#initContextMenuItems();
        this.attachGlobalListeners();
        // Note: 
        // @Consumer callback
        if (this.options.onInitiated) this.options.onInitiated();
    }
    attachGlobalListeners() {
        this.onWindowKeyUpBind = this.#onWindowKeyUp.bind(this);
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.keyUp, this.onWindowKeyUpBind);
    }
    detachGlobalListeners() {
        window.removeEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.keyUp, this.onWindowKeyUpBind);
    }
    //--------------------------------------------------------------------
    // # Section: Overridden
    //--------------------------------------------------------------------
    getName() {
        return super.getName();
    }
    onClickTool(event) {
        super.onClickTool(event);
        this.momentaryActivation();
        // Note: 
        // @Consumer callback
        if (this.options.onClicked) this.options.onClicked();
    }
    //--------------------------------------------------------------------
    // # Section: Init Helpers
    //--------------------------------------------------------------------
    #initContextMenuItems() {
        (0, $062067ac9882af21$export$b6aef0d24cd6ce8c).addItem({
            icon: this.resetRotationIcon,
            i18nKey: `${$46d01ba1c938131e$var$I18N__BASE}.contextItems.rotate`,
            fn: this.#onContextMenuSetRotation.bind(this)
        });
    }
    //--------------------------------------------------------------------
    // # Section: Tool Control
    //--------------------------------------------------------------------
    momentaryActivation() {
        const map = this.getMap();
        if (!map) return;
        const view = map.getView();
        const zoom = view.getZoom();
        const coordinates = (0, $9c4744460e43e41b$export$3fb495868742d370)(view.getCenter());
        (0, $eb687437705d7055$export$cc43ef3ca2ae36e8)({
            map: map,
            coordinates: coordinates,
            zoom: zoom,
            rotation: 0,
            onDone: (result)=>{
                // Note: 
                // @Consumer callback
                if (this.options.onReset) this.options.onReset(result);
            }
        });
    }
    //--------------------------------------------------------------------
    // # Section: Browser Events
    //--------------------------------------------------------------------
    #onWindowKeyUp(event) {
        if ((0, $fbd95439548fdf50$export$ad7bf7af8762113)(event, (0, $a256deadcc62504f$export$4384767a59dc851d).resetNorthTool)) this.onClickTool(event);
    }
    //--------------------------------------------------------------------
    // # Section: ContextMenu Callbacks
    //--------------------------------------------------------------------
    #onContextMenuSetRotation(map, coordinates, target) {
        this.askToSetRotation(map);
    }
    //--------------------------------------------------------------------
    // # Section: Ask User
    //--------------------------------------------------------------------
    askToSetRotation(map) {
        const view = map.getView();
        const zoom = view.getZoom();
        const rotation = (0, $206be50bf50f716a$export$53fa2d26c9df363b).radiansToDegrees(view.getRotation());
        const normalizationMinLimit = 0;
        const normalizationMaxLimit = 360;
        const normalizedRotation = rotation < normalizationMinLimit ? rotation + normalizationMaxLimit : rotation;
        // Note: 
        // Must use the center of the view, not the clicked coordinates
        const coordinates = (0, $9c4744460e43e41b$export$3fb495868742d370)(view.getCenter());
        const i18n = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get(`${$46d01ba1c938131e$var$I18N__BASE}.dialogs.prompts.rotateMap`);
        return (0, $c815862f3b0d8f0b$export$3ddf2d174ce01153).prompt({
            title: i18n.title,
            message: i18n.message,
            value: Math.round(normalizedRotation),
            confirmText: i18n.confirmText,
            cancelText: i18n.cancelText,
            onConfirm: (result)=>{
                if (result.isDigitsOnly()) this.doRotation(map, coordinates, zoom, result);
                else {
                    (0, $b9b5c0363f244088$export$49b118289be48034).logError($46d01ba1c938131e$var$FILENAME, 'askToSetRotation', {
                        message: 'Only digits are allowed as input',
                        result: result
                    });
                    (0, $9051f0e072bf4341$export$8d8dc7d5f743331b).error({
                        i18nKey: `${$46d01ba1c938131e$var$I18N__BASE}.toasts.errors.invalidValue`
                    });
                }
            }
        });
    }
    //--------------------------------------------------------------------
    // # Section: Tool DoActions
    //--------------------------------------------------------------------
    doRotation(map, coordinates, zoom, degrees) {
        const radians = (0, $206be50bf50f716a$export$53fa2d26c9df363b).degreesToRadians(degrees);
        (0, $b9b5c0363f244088$export$49b118289be48034).logDebug($46d01ba1c938131e$var$FILENAME, 'doRotation', {
            degrees: degrees,
            radians: radians
        });
        (0, $eb687437705d7055$export$cc43ef3ca2ae36e8)({
            map: map,
            coordinates: coordinates,
            zoome: zoom,
            rotation: radians
        });
    }
}



var $f1q41 = parcelRequire("f1q41");










const $4de09c416369dd54$var$FILENAME = 'fullscreen-tool.js';
const $4de09c416369dd54$var$CLASS__TOOL_BUTTON = 'oltb-tool-button';
const $4de09c416369dd54$var$I18N__BASE = 'tools.fullscreenTool';
const $4de09c416369dd54$var$DefaultOptions = Object.freeze({
    onInitiated: undefined,
    onClicked: undefined,
    onEnter: undefined,
    onLeave: undefined
});
/**
 * About:
 * Use your entire screen and view the Map in full screen
 * 
 * Description:
 * The Map element is rendered in full screen and any other panels in an external application are not included in what is shown on the screen.
 */ class $4de09c416369dd54$export$760fd550653b494c extends (0, $10d08d54da4ecbc4$export$cf198134d112da63) {
    constructor(options = {}){
        super({
            filename: $4de09c416369dd54$var$FILENAME
        });
        this.enterFullscreenIcon = (0, $dcff5ab966a6537f$export$a297fe855adfd36c)({
            path: (0, $35649bc6579784f8$export$3fddabec91763a6e).fullscreen.stroked,
            class: `${$4de09c416369dd54$var$CLASS__TOOL_BUTTON}__icon`
        });
        this.exitFullscreenIcon = (0, $dcff5ab966a6537f$export$a297fe855adfd36c)({
            path: (0, $35649bc6579784f8$export$3fddabec91763a6e).fullscreenExit.stroked,
            class: `${$4de09c416369dd54$var$CLASS__TOOL_BUTTON}__icon`
        });
        const i18n = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get($4de09c416369dd54$var$I18N__BASE);
        const button = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'button',
            html: this.getToolIcon(),
            class: $4de09c416369dd54$var$CLASS__TOOL_BUTTON,
            attributes: {
                'type': 'button',
                'data-tippy-content': `${i18n.title} (${(0, $a256deadcc62504f$export$4384767a59dc851d).fullscreenTool})`,
                'data-tippy-content-post': `(${(0, $a256deadcc62504f$export$4384767a59dc851d).fullscreenTool})`,
                'data-oltb-i18n': `${$4de09c416369dd54$var$I18N__BASE}.title`
            },
            listeners: {
                'click': this.onClickTool.bind(this)
            },
            prototypes: {
                getTippy: function() {
                    return this._tippy;
                }
            }
        });
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(this.element, [
            button
        ]);
        this.button = button;
        this.isActive = false;
        this.listenerKeys = [];
        this.options = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep($4de09c416369dd54$var$DefaultOptions), options);
        this.attachGlobalListeners();
        // Note: 
        // @Consumer callback
        if (this.options.onInitiated) this.options.onInitiated();
    }
    attachGlobalListeners() {
        this.onWindowKeyUpBind = this.#onWindowKeyUp.bind(this);
        this.onFullScreenChangeBind = this.#onFullScreenChange.bind(this);
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.keyUp, this.onWindowKeyUpBind);
        window.document.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.fullScreenChange, this.onFullScreenChangeBind);
    }
    detachGlobalListeners() {
        window.removeEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.keyUp, this.onWindowKeyUpBind);
        window.document.removeEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.fullScreenChange, this.onFullScreenChangeBind);
    }
    //--------------------------------------------------------------------
    // # Section: Overridden
    //--------------------------------------------------------------------
    getName() {
        return super.getName();
    }
    onClickTool(event) {
        super.onClickTool(event);
        this.momentaryActivation();
        // Note: 
        // @Consumer callback
        if (this.options.onClicked) this.options.onClicked();
    }
    //--------------------------------------------------------------------
    // # Section: Tool Control
    //--------------------------------------------------------------------
    momentaryActivation() {
        if (!this.isFullScreenSupportedByBrowser()) return;
        if ((0, $0fb704a73fce4e36$export$2e2bcd8739ae039).isFullscreen) this.doRequestExitFullScreen();
        else this.doRequestEnterFullScreen();
    }
    //--------------------------------------------------------------------
    // # Section: Browser Events
    //--------------------------------------------------------------------
    #onWindowKeyUp(event) {
        if ((0, $fbd95439548fdf50$export$ad7bf7af8762113)(event, (0, $a256deadcc62504f$export$4384767a59dc851d).fullscreenTool)) this.onClickTool(event);
    }
    #onFullScreenChange(event) {
        this.doFullScreenChange(event);
    }
    //--------------------------------------------------------------------
    // # Section: Conversions/Validation
    //--------------------------------------------------------------------
    isFullScreenSupportedByBrowser() {
        if (!(0, $0fb704a73fce4e36$export$2e2bcd8739ae039).isEnabled) {
            (0, $b9b5c0363f244088$export$49b118289be48034).logError($4de09c416369dd54$var$FILENAME, 'isFullScreenSupportedByBrowser', {
                title: 'Error',
                error: 'Fullscreen is not supported by this browser'
            });
            (0, $9051f0e072bf4341$export$8d8dc7d5f743331b).error({
                i18nKey: `${$4de09c416369dd54$var$I18N__BASE}.toasts.errors.missingFullScreenSupport`
            });
        }
        return (0, $0fb704a73fce4e36$export$2e2bcd8739ae039).isEnabled;
    }
    //--------------------------------------------------------------------
    // # Section: Getters and Setters
    //--------------------------------------------------------------------
    getToolIcon() {
        return (0, $0fb704a73fce4e36$export$2e2bcd8739ae039).isFullscreen ? this.exitFullscreenIcon : this.enterFullscreenIcon;
    }
    //--------------------------------------------------------------------
    // # Section: Tool DoActions
    //--------------------------------------------------------------------
    doRequestExitFullScreen() {
        return (0, $0fb704a73fce4e36$export$2e2bcd8739ae039).exit();
    }
    doRequestEnterFullScreen() {
        const map = this.getMap();
        if (!map) return;
        const element = map.getTargetElement();
        return (0, $0fb704a73fce4e36$export$2e2bcd8739ae039).request(element);
    }
    doUpdateMapSize() {
        const map = this.getMap();
        if (!map) return;
        map.updateSize();
    }
    doFullScreenChange(event) {
        if (window.document.fullscreenElement) {
            this.button.removeChild(this.button.firstElementChild);
            this.button.insertAdjacentHTML('afterbegin', this.exitFullscreenIcon);
            // Note: 
            // @Consumer callback
            if (this.options.onEnter) this.options.onEnter(event);
        } else {
            this.button.removeChild(this.button.firstElementChild);
            this.button.insertAdjacentHTML('afterbegin', this.enterFullscreenIcon);
            // Note: 
            // @Consumer callback
            if (this.options.onLeave) this.options.onLeave(event);
        }
        this.isActive = !this.isActive;
        this.button.classList.toggle(`${$4de09c416369dd54$var$CLASS__TOOL_BUTTON}--active`);
    }
}



var $f1q41 = parcelRequire("f1q41");






















const $2191e019b62f26fa$var$FILENAME = 'coordinates-tool.js';
const $2191e019b62f26fa$var$CLASS__TOOL_BUTTON = 'oltb-tool-button';
const $2191e019b62f26fa$var$CLASS__TOOLBOX_SECTION = 'oltb-toolbox-section';
const $2191e019b62f26fa$var$CLASS__TOGGLEABLE = 'oltb-toggleable';
const $2191e019b62f26fa$var$ID__PREFIX = 'oltb-coordinates';
const $2191e019b62f26fa$var$KEY__TOOLTIP = 'tools.coordinatesTool';
const $2191e019b62f26fa$var$FORMAT_DECIMAL_DEGREES = 'DD';
const $2191e019b62f26fa$var$FORMAT_DEGREE_MINUTES_SECONDS = 'DMS';
const $2191e019b62f26fa$var$I18N__BASE = 'tools.coordinatesTool';
const $2191e019b62f26fa$var$I18N__BASE_COMMON = 'commons';
const $2191e019b62f26fa$var$DefaultOptions = Object.freeze({
    onInitiated: undefined,
    onClicked: undefined,
    onMapClicked: undefined,
    onBrowserStateCleared: undefined
});
const $2191e019b62f26fa$var$LocalStorageNodeName = (0, $52e25f2a10ab5b5c$export$ada36e8a1c3bc83a).coordinatesTool;
const $2191e019b62f26fa$var$LocalStorageDefaults = Object.freeze({
    isActive: false,
    coordinatesFormat: $2191e019b62f26fa$var$FORMAT_DECIMAL_DEGREES
});
/**
 * About:
 * Display and copy Coordinates
 * 
 * Description:
 * The coordinates are shown in a Tooltip and in the Toolbox in all projections that have been registered.
 */ class $2191e019b62f26fa$export$2576ed38d7a1302e extends (0, $10d08d54da4ecbc4$export$cf198134d112da63) {
    constructor(options = {}){
        super({
            filename: $2191e019b62f26fa$var$FILENAME
        });
        const icon = (0, $dcff5ab966a6537f$export$a297fe855adfd36c)({
            path: (0, $35649bc6579784f8$export$3fddabec91763a6e).crosshair.stroked,
            class: `${$2191e019b62f26fa$var$CLASS__TOOL_BUTTON}__icon`
        });
        const i18n = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get($2191e019b62f26fa$var$I18N__BASE);
        const button = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'button',
            html: icon,
            class: $2191e019b62f26fa$var$CLASS__TOOL_BUTTON,
            attributes: {
                'type': 'button',
                'data-tippy-content': `${i18n.title} (${(0, $a256deadcc62504f$export$4384767a59dc851d).coordinatesTool})`,
                'data-tippy-content-post': `(${(0, $a256deadcc62504f$export$4384767a59dc851d).coordinatesTool})`,
                'data-oltb-i18n': `${$2191e019b62f26fa$var$I18N__BASE}.title`
            },
            listeners: {
                'click': this.onClickTool.bind(this)
            }
        });
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(this.element, [
            button
        ]);
        this.button = button;
        this.isActive = false;
        this.tooltipItem = undefined;
        this.projections = new Map();
        this.options = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep($2191e019b62f26fa$var$DefaultOptions), options);
        this.localStorage = (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).getAndMergeStateObject($2191e019b62f26fa$var$LocalStorageNodeName, $2191e019b62f26fa$var$LocalStorageDefaults);
        this.#initToolboxHTML();
        this.uiRefToolboxSection = window.document.querySelector(`#${$2191e019b62f26fa$var$ID__PREFIX}-toolbox`);
        this.#initToggleables();
        this.#initSettings();
        this.uiRefCoordinatesTable = this.uiRefToolboxSection.querySelector(`#${$2191e019b62f26fa$var$ID__PREFIX}-table`);
        this.uiRefCoordinatesFormat = this.uiRefToolboxSection.querySelector(`#${$2191e019b62f26fa$var$ID__PREFIX}-format`);
        this.uiRefCoordinatesFormat.value = this.localStorage.coordinatesFormat;
        this.uiRefCoordinatesFormat.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.change, this.#onCoordinatesFormatChange.bind(this));
        this.attachGlobalListeners();
        // Note: 
        // @Consumer callback
        if (this.options.onInitiated) this.options.onInitiated();
    }
    attachGlobalListeners() {
        this.onWindowKeyDownBind = this.#onWindowKeyDown.bind(this);
        this.onOLTBReadyBind = this.#onOLTBReady.bind(this);
        this.onWindowBrowserStateClearedBind = this.#onWindowBrowserStateCleared.bind(this);
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.keyDown, this.onWindowKeyDownBind);
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.ready, this.onOLTBReadyBind);
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.browserStateCleared, this.onWindowBrowserStateClearedBind);
    }
    detachGlobalListeners() {
        window.removeEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.keyDown, this.onWindowKeyDownBind);
        window.removeEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.ready, this.onOLTBReadyBind);
        window.removeEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.browserStateCleared, this.onWindowBrowserStateClearedBind);
    }
    //--------------------------------------------------------------------
    // # Section: Overridden
    //--------------------------------------------------------------------
    getName() {
        return super.getName();
    }
    onClickTool(event) {
        super.onClickTool(event);
        if (this.isActive) this.deactivateTool();
        else this.activateTool();
        // Note: 
        // @Consumer callback
        if (this.options.onClicked) this.options.onClicked();
    }
    //--------------------------------------------------------------------
    // # Section: Init Helpers
    //--------------------------------------------------------------------
    #initToolboxHTML() {
        const i18n = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get(`${$2191e019b62f26fa$var$I18N__BASE}.toolbox`);
        const i18nCommon = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get(`${$2191e019b62f26fa$var$I18N__BASE_COMMON}.titles`);
        const html = `
            <div id="${$2191e019b62f26fa$var$ID__PREFIX}-toolbox" class="${$2191e019b62f26fa$var$CLASS__TOOLBOX_SECTION}">
                <div class="${$2191e019b62f26fa$var$CLASS__TOOLBOX_SECTION}__header oltb-toggleable" data-oltb-toggleable-target="${$2191e019b62f26fa$var$ID__PREFIX}-toolbox-collapsed">
                    <h4 class="${$2191e019b62f26fa$var$CLASS__TOOLBOX_SECTION}__title" data-oltb-i18n="${$2191e019b62f26fa$var$I18N__BASE}.toolbox.titles.coordinates">${i18n.titles.coordinates}</h4>
                    <span class="${$2191e019b62f26fa$var$CLASS__TOOLBOX_SECTION}__icon oltb-tippy" data-oltb-i18n="${$2191e019b62f26fa$var$I18N__BASE_COMMON}.titles.toggleSection" title="${i18nCommon.toggleSection}"></span>
                </div>
                <div class="${$2191e019b62f26fa$var$CLASS__TOOLBOX_SECTION}__groups" id="${$2191e019b62f26fa$var$ID__PREFIX}-toolbox-collapsed" style="display: ${this.localStorage.isCollapsed ? 'none' : 'block'}">
                    <div class="${$2191e019b62f26fa$var$CLASS__TOOLBOX_SECTION}__group">
                        <label class="oltb-label" for="${$2191e019b62f26fa$var$ID__PREFIX}-format" data-oltb-i18n="${$2191e019b62f26fa$var$I18N__BASE}.toolbox.groups.formats.title">${i18n.groups.formats.title}</label>
                        <select id="${$2191e019b62f26fa$var$ID__PREFIX}-format" class="oltb-select">
                            <option value="DD" data-oltb-i18n="${$2191e019b62f26fa$var$I18N__BASE}.toolbox.groups.formats.dd">${i18n.groups.formats.dd}</option>
                            <option value="DMS" data-oltb-i18n="${$2191e019b62f26fa$var$I18N__BASE}.toolbox.groups.formats.dms">${i18n.groups.formats.dms}</option>
                        </select>
                    </div>
                    <div class="${$2191e019b62f26fa$var$CLASS__TOOLBOX_SECTION}__group">
                        <label class="oltb-label" data-oltb-i18n="${$2191e019b62f26fa$var$I18N__BASE}.toolbox.groups.coordinates.title">${i18n.groups.coordinates.title} <em>(Lat, Lon)</em></label>
                        <table class="oltb-table oltb-table--horizontal oltb-table--no-background oltb-table--tight-bottom-and-top oltb-mt-05" id="${$2191e019b62f26fa$var$ID__PREFIX}-table"></table>
                    </div>
                </div>
            </div>
        `;
        (0, $8f42450ebdd44f5e$export$8e7188a60a5bbe16).getToolboxElement().insertAdjacentHTML('beforeend', html);
    }
    #initToggleables() {
        this.uiRefToolboxSection.querySelectorAll(`.${$2191e019b62f26fa$var$CLASS__TOGGLEABLE}`).forEach((toggle)=>{
            toggle.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.click, this.#onToggleToolbox.bind(this, toggle));
        });
    }
    #initSettings() {
        (0, $5547bbb6fff7ebf1$export$3016a1f47b675883).addSetting((0, $65522956a1f1a049$export$c72f6eaae7b9adff).copyCoordinatesOnClick, {
            state: true,
            i18nBase: `${$2191e019b62f26fa$var$I18N__BASE}.settings`,
            i18nKey: 'copyOnClick'
        });
        (0, $5547bbb6fff7ebf1$export$3016a1f47b675883).addSetting((0, $65522956a1f1a049$export$c72f6eaae7b9adff).updateToolboxCoordinatesOnHover, {
            state: true,
            i18nBase: `${$2191e019b62f26fa$var$I18N__BASE}.settings`,
            i18nKey: 'updateToolboxOnHover'
        });
    }
    //--------------------------------------------------------------------
    // # Section: Tool Control
    //--------------------------------------------------------------------
    activateTool() {
        this.#createUIProjections();
        this.isActive = true;
        this.uiRefToolboxSection.classList.add(`${$2191e019b62f26fa$var$CLASS__TOOLBOX_SECTION}--show`);
        this.button.classList.add(`${$2191e019b62f26fa$var$CLASS__TOOL_BUTTON}--active`);
        this.localStorage.isActive = true;
        (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).setStateObject($2191e019b62f26fa$var$LocalStorageNodeName, this.localStorage);
        this.uiRefToolboxSection.scrollIntoView({
            behavior: 'smooth',
            block: 'end',
            inline: 'nearest'
        });
    }
    deactivateTool() {
        this.#removeUIProjections();
        this.isActive = false;
        this.uiRefToolboxSection.classList.remove(`${$2191e019b62f26fa$var$CLASS__TOOLBOX_SECTION}--show`);
        this.button.classList.remove(`${$2191e019b62f26fa$var$CLASS__TOOL_BUTTON}--active`);
        this.localStorage.isActive = false;
        (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).setStateObject($2191e019b62f26fa$var$LocalStorageNodeName, this.localStorage);
    }
    //--------------------------------------------------------------------
    // # Section: Browser Events
    //--------------------------------------------------------------------
    #onOLTBReady(event) {
        if (this.localStorage.isActive) this.activateTool();
    }
    #onWindowKeyDown(event) {
        if ((0, $fbd95439548fdf50$export$ad7bf7af8762113)(event, (0, $a256deadcc62504f$export$4384767a59dc851d).coordinatesTool)) this.onClickTool(event);
    }
    #onWindowBrowserStateCleared() {
        this.doClearState();
        if (this.isActive) this.deactivateTool();
        // Note: 
        // @Consumer callback
        if (this.options.onBrowserStateCleared) this.options.onBrowserStateCleared();
    }
    //--------------------------------------------------------------------
    // # Section: Map/UI Callbacks
    //--------------------------------------------------------------------
    #onToggleToolbox(toggle) {
        const targetName = toggle.dataset.oltbToggleableTarget;
        this.doToggleToolboxSection(targetName);
    }
    #onCoordinatesFormatChange() {
        this.localStorage.coordinatesFormat = this.uiRefCoordinatesFormat.value;
        (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).setStateObject($2191e019b62f26fa$var$LocalStorageNodeName, this.localStorage);
    }
    #onPointerMove(event) {
        this.doCreateTooltipCoordinates(event);
        if (this.shouldUpdateToolboxCoordinatesOnHover()) this.doCreateToolboxCoordinates(event);
    }
    #onMapClick(event) {
        this.doCopyCoordinatesAsync(event);
        if (!this.shouldCopyCoordinatesOnClick()) this.toolboxCoordinates(event);
        const allCoordinates = this.doCreateToolCoordinatesList(event.coordinate);
        // Note: 
        // @Consumer callback
        if (this.options.onMapClicked) this.options.onMapClicked(allCoordinates);
    }
    //--------------------------------------------------------------------
    // # Section: Conversions/Validation
    //--------------------------------------------------------------------
    shouldCopyCoordinatesOnClick() {
        return (0, $5547bbb6fff7ebf1$export$3016a1f47b675883).getSetting((0, $65522956a1f1a049$export$c72f6eaae7b9adff).copyCoordinatesOnClick);
    }
    shouldUpdateToolboxCoordinatesOnHover() {
        return (0, $5547bbb6fff7ebf1$export$3016a1f47b675883).getSetting((0, $65522956a1f1a049$export$c72f6eaae7b9adff).updateToolboxCoordinatesOnHover);
    }
    toDecimalDegrees(cell, coordinates) {
        cell.innerHTML = `
            ${parseFloat(coordinates[1]).toFixed(4)}, 
            ${parseFloat(coordinates[0]).toFixed(4)}
        `;
    }
    toDegreeMinutesSeconds(cell, coordinates) {
        const prettyCoordinates = (0, $1bd0a226f9a16141$export$c883fd238161f841)(coordinates);
        cell.innerHTML = prettyCoordinates;
    }
    //--------------------------------------------------------------------
    // # Section: User Interface
    //--------------------------------------------------------------------
    #createUIProjections() {
        const map = this.getMap();
        if (!map) return;
        const projections = (0, $3d63321abab47ecf$export$38112acb54e12e1).getProjections();
        projections.forEach((projection)=>{
            const projectionRow = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
                element: 'tr'
            });
            const projectionName = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
                element: 'th',
                text: projection.name,
                title: projection.code,
                class: 'oltb-tippy'
            });
            (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(projectionRow, [
                projectionName
            ]);
            const coordinatesRow = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
                element: 'tr'
            });
            const coordinatesCell = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
                element: 'td',
                text: '-'
            });
            (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(coordinatesRow, [
                coordinatesCell
            ]);
            (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(this.uiRefCoordinatesTable, [
                projectionRow,
                coordinatesRow
            ]);
            this.projections.set(projection.code, coordinatesCell);
        });
        this.tooltipItem = (0, $5289d96a2eaac637$export$3cf29e47efa41626).push($2191e019b62f26fa$var$KEY__TOOLTIP);
        this.onPointerMoveListener = map.on((0, $a9807b370eed025c$export$ada873a34909da65).openLayers.pointerMove, this.#onPointerMove.bind(this));
        this.onMapClickListener = map.on((0, $a9807b370eed025c$export$ada873a34909da65).browser.click, this.#onMapClick.bind(this));
    }
    #removeUIProjections() {
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).clearElement(this.uiRefCoordinatesTable);
        (0, $5289d96a2eaac637$export$3cf29e47efa41626).pop($2191e019b62f26fa$var$KEY__TOOLTIP);
        (0, $1f093ab5083c8a1f$export$b7ef3f8527533384)(this.onPointerMoveListener);
        (0, $1f093ab5083c8a1f$export$b7ef3f8527533384)(this.onMapClickListener);
    }
    //--------------------------------------------------------------------
    // # Section: Tool DoActions
    //--------------------------------------------------------------------
    doClearState() {
        this.localStorage = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep($2191e019b62f26fa$var$LocalStorageDefaults);
        (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).setStateObject($2191e019b62f26fa$var$LocalStorageNodeName, $2191e019b62f26fa$var$LocalStorageDefaults);
    }
    doToggleToolboxSection(targetName) {
        const targetNode = window.document.getElementById(targetName);
        const duration = (0, $1e8c0ef90ed82280$export$a33e119b2316dcb7).getConfig().animationDuration.fast;
        targetNode?.slideToggle(duration, (collapsed)=>{
            this.localStorage.isCollapsed = collapsed;
            (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).setStateObject($2191e019b62f26fa$var$LocalStorageNodeName, this.localStorage);
        });
    }
    doCreateToolCoordinatesList(coordinates) {
        const projections = (0, $3d63321abab47ecf$export$38112acb54e12e1).getProjections();
        const result = [];
        projections.forEach((projection)=>{
            const transformedCoordinates = (0, $9c4744460e43e41b$export$51186ad6e864892a)(coordinates, (0, $1e8c0ef90ed82280$export$a33e119b2316dcb7).getConfig().projection.default, projection.code);
            const prettyCoordinates = (0, $1bd0a226f9a16141$export$c883fd238161f841)(transformedCoordinates);
            result.push({
                code: projection.code,
                name: projection.name,
                coordinates: transformedCoordinates,
                prettyCoordinates: prettyCoordinates
            });
        });
        return result;
    }
    doCreateTooltipCoordinates(event) {
        const projection = (0, $1e8c0ef90ed82280$export$a33e119b2316dcb7).getConfig().projection;
        const coordinates = (0, $9c4744460e43e41b$export$51186ad6e864892a)(event.coordinate, projection.default, projection.wgs84);
        const prettyCoordinates = (0, $1bd0a226f9a16141$export$c883fd238161f841)(coordinates);
        this.tooltipItem.innerHTML = prettyCoordinates;
    }
    doCreateToolboxCoordinates(event) {
        const projections = (0, $3d63321abab47ecf$export$38112acb54e12e1).getProjections();
        projections.forEach((projection)=>{
            const coordinates = (0, $9c4744460e43e41b$export$51186ad6e864892a)(event.coordinate, (0, $1e8c0ef90ed82280$export$a33e119b2316dcb7).getConfig().projection.default, projection.code);
            const format = this.uiRefCoordinatesFormat.value;
            const cell = this.projections.get(projection.code);
            if (format === $2191e019b62f26fa$var$FORMAT_DEGREE_MINUTES_SECONDS) this.toDegreeMinutesSeconds(cell, coordinates);
            else this.toDecimalDegrees(cell, coordinates);
        });
    }
    async doCopyCoordinatesAsync(event) {
        if (!this.shouldCopyCoordinatesOnClick() || (0, $3110b1ed727d9f35$export$df4a79c26d3b48ff).hasActiveTool()) return;
        const projection = (0, $1e8c0ef90ed82280$export$a33e119b2316dcb7).getConfig().projection;
        const coordinates = (0, $9c4744460e43e41b$export$51186ad6e864892a)(event.coordinate, projection.default, projection.wgs84);
        const prettyCoordinates = (0, $1bd0a226f9a16141$export$c883fd238161f841)(coordinates);
        try {
            await (0, $9f66900afbcbe054$export$2cdf1b96a9f86d16).copyAsync(prettyCoordinates);
            (0, $9051f0e072bf4341$export$8d8dc7d5f743331b).info({
                i18nKey: `${$2191e019b62f26fa$var$I18N__BASE}.toasts.infos.copyCoordinates`,
                autoremove: true
            });
        } catch (error) {
            (0, $b9b5c0363f244088$export$49b118289be48034).logError($2191e019b62f26fa$var$FILENAME, 'doCopyCoordinatesAsync', {
                message: 'Failed to copy coordinates',
                error: error
            });
            (0, $9051f0e072bf4341$export$8d8dc7d5f743331b).error({
                i18nKey: `${$2191e019b62f26fa$var$I18N__BASE}.toasts.errors.copyCoordinates`
            });
        }
    }
}



var $f1q41 = parcelRequire("f1q41");









const $f485bed103ff05f7$var$FILENAME = 'translation-tool.js';
const $f485bed103ff05f7$var$CLASS__TOOL_BUTTON = 'oltb-tool-button';
const $f485bed103ff05f7$var$I18N__BASE = 'tools.translationTool';
const $f485bed103ff05f7$var$DefaultOptions = Object.freeze({
    onInitiated: undefined,
    onClicked: undefined
});
/**
 * About:
 * Display dialog to change current language
 * 
 * Description:
 * The languag can be changed on the fly and also new languages can be added in the configuration without the need to rebuild the code.
 */ class $f485bed103ff05f7$export$b1c96e73ae2e8b82 extends (0, $10d08d54da4ecbc4$export$cf198134d112da63) {
    constructor(options = {}){
        super({
            filename: $f485bed103ff05f7$var$FILENAME
        });
        const icon = (0, $dcff5ab966a6537f$export$a297fe855adfd36c)({
            path: (0, $35649bc6579784f8$export$3fddabec91763a6e).translate.mixed,
            class: `${$f485bed103ff05f7$var$CLASS__TOOL_BUTTON}__icon`
        });
        const i18n = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get($f485bed103ff05f7$var$I18N__BASE);
        const button = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'button',
            html: icon,
            class: $f485bed103ff05f7$var$CLASS__TOOL_BUTTON,
            attributes: {
                'type': 'button',
                'data-tippy-content': `${i18n.title} (${(0, $a256deadcc62504f$export$4384767a59dc851d).translationTool})`,
                'data-tippy-content-post': `(${(0, $a256deadcc62504f$export$4384767a59dc851d).translationTool})`,
                'data-oltb-i18n': `${$f485bed103ff05f7$var$I18N__BASE}.title`
            },
            listeners: {
                'click': this.onClickTool.bind(this)
            }
        });
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(this.element, [
            button
        ]);
        this.button = button;
        this.languageDialog = undefined;
        this.options = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep($f485bed103ff05f7$var$DefaultOptions), options);
        this.attachGlobalListeners();
        // Note: 
        // @Consumer callback
        if (this.options.onInitiated) this.options.onInitiated();
    }
    attachGlobalListeners() {
        this.onWindowKeyUpBind = this.#onWindowKeyUp.bind(this);
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.keyUp, this.onWindowKeyUpBind);
    }
    detachGlobalListeners() {
        window.removeEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.keyUp, this.onWindowKeyUpBind);
    }
    //--------------------------------------------------------------------
    // # Section: Overridden
    //--------------------------------------------------------------------
    getName() {
        return super.getName();
    }
    onClickTool(event) {
        super.onClickTool(event);
        this.momentaryActivation();
        // Note: 
        // @Consumer callback
        if (this.options.onClicked) this.options.onClicked();
    }
    //--------------------------------------------------------------------
    // # Section: Tool Control
    //--------------------------------------------------------------------
    momentaryActivation() {
        this.askToChangeLanguage();
    }
    //--------------------------------------------------------------------
    // # Section: Browser Events
    //--------------------------------------------------------------------
    #onWindowKeyUp(event) {
        if ((0, $fbd95439548fdf50$export$ad7bf7af8762113)(event, (0, $a256deadcc62504f$export$4384767a59dc851d).translationTool)) this.onClickTool(event);
    }
    //--------------------------------------------------------------------
    // # Section: Ask User
    //--------------------------------------------------------------------
    askToChangeLanguage() {
        if (this.languageDialog) return;
        const languages = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).getLanguages();
        const currentLanguage = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).getActiveLanguage();
        const i18n = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get(`${$f485bed103ff05f7$var$I18N__BASE}.dialogs.selects.changeLanguage`);
        this.languageDialog = (0, $c815862f3b0d8f0b$export$3ddf2d174ce01153).select({
            title: i18n.title,
            message: `${i18n.message} <strong>${currentLanguage.text}</strong>`,
            value: currentLanguage.value,
            options: languages,
            confirmText: i18n.confirmText,
            cancelText: i18n.cancelText,
            onConfirm: (result)=>{
                this.doChangeLanguage(result);
                this.languageDialog = undefined;
            },
            onCancel: ()=>{
                this.languageDialog = undefined;
            }
        });
    }
    //--------------------------------------------------------------------
    // # Section: Tool DoActions
    //--------------------------------------------------------------------
    doChangeLanguage(result) {
        (0, $b9b5c0363f244088$export$49b118289be48034).logInformation($f485bed103ff05f7$var$FILENAME, 'doChangeLanguage', {
            from: result.from,
            to: result.to
        });
        (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).setActiveLanguage(result.to);
    }
}








const $69f2a1d756f96602$var$FILENAME = 'hidden-about-tool.js';
const $69f2a1d756f96602$var$I18N__BASE = 'tools.hiddenAboutTool';
/**
 * About:
 * Show information about OLTB
 * 
 * Description:
 * Show information about the project, version and links to the source code etc.
 */ class $69f2a1d756f96602$export$c24ab6799594c540 extends (0, $10d08d54da4ecbc4$export$cf198134d112da63) {
    constructor(){
        super({
            filename: $69f2a1d756f96602$var$FILENAME
        });
        this.icon = (0, $dcff5ab966a6537f$export$a297fe855adfd36c)({
            path: (0, $35649bc6579784f8$export$3fddabec91763a6e).gitHub.mixed
        });
        this.aboutInfoModal = undefined;
        this.#initContextMenuItems();
    }
    //--------------------------------------------------------------------
    // # Section: Overridden
    //--------------------------------------------------------------------
    getName() {
        return super.getName();
    }
    //--------------------------------------------------------------------
    // # Section: Init Helpers
    //--------------------------------------------------------------------
    #initContextMenuItems() {
        (0, $062067ac9882af21$export$b6aef0d24cd6ce8c).addItem({});
        (0, $062067ac9882af21$export$b6aef0d24cd6ce8c).addItem({
            icon: this.icon,
            i18nKey: `${$69f2a1d756f96602$var$I18N__BASE}.contextItems.about`,
            fn: this.#onContextMenuAbout.bind(this)
        });
    }
    //--------------------------------------------------------------------
    // # Section: ContextMenu Callbacks
    //--------------------------------------------------------------------
    #onContextMenuAbout(map, coordinates, target) {
        this.doShowAboutModal();
    }
    //--------------------------------------------------------------------
    // # Section: Tool DoActions
    //--------------------------------------------------------------------
    doShowAboutModal() {
        if (this.aboutInfoModal) return;
        const config = (0, $1e8c0ef90ed82280$export$a33e119b2316dcb7).getConfig();
        const i18n = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get(`${$69f2a1d756f96602$var$I18N__BASE}.modals.about`);
        const content = `
            <p>${i18n.version} ${config.toolbar.version}</p>
            <p>${i18n.developedBy} <a href="//github.com/qulle/oltb" target="_blank" class="oltb-link">github.com/qulle/oltb</a></p>
            <p>${i18n.usingOpenLayers} <a href="//openlayers.org/en/v${config.openLayers.version}/apidoc/" target="_blank" class="oltb-link">${config.openLayers.version}</a></p>
        `;
        this.aboutInfoModal = (0, $4b70eea868544fc1$export$2b77a92f1a5ad772).create({
            title: i18n.title,
            content: content,
            onClose: ()=>{
                this.aboutInfoModal = undefined;
            }
        });
    }
}




var $f1q41 = parcelRequire("f1q41");









const $52634d1816cb8c89$var$FILENAME = 'hidden-marker-tool.js';
const $52634d1816cb8c89$var$CLASS__FUNC_BUTTON = 'oltb-func-btn';
const $52634d1816cb8c89$var$ID__PREFIX_INFO_WINDOW = 'oltb-info-window-marker';
const $52634d1816cb8c89$var$I18N__BASE = 'tools.hiddenMarkerTool';
const $52634d1816cb8c89$var$I18N__BASE_COMMON = 'commons';
const $52634d1816cb8c89$var$DefaultOptions = Object.freeze({
    onAdded: undefined,
    onRemoved: undefined,
    onEdited: undefined
});
/**
 * About:
 * Create Markers in the Map
 * 
 * Description:
 * Create Markers with icons in the Map to visualize places, Bookmarks, etc.
 */ class $52634d1816cb8c89$export$4602f3257ee20a0f extends (0, $10d08d54da4ecbc4$export$cf198134d112da63) {
    constructor(options = {}){
        super({
            filename: $52634d1816cb8c89$var$FILENAME
        });
        this.iconMarkerModal = undefined;
        this.options = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep($52634d1816cb8c89$var$DefaultOptions), options);
        this.createIcon = (0, $dcff5ab966a6537f$export$a297fe855adfd36c)({
            path: (0, $35649bc6579784f8$export$3fddabec91763a6e).plusLarge.stroked
        });
        this.#initContextMenuItems();
        this.attachGlobalListeners();
    }
    attachGlobalListeners() {
        this.onWindowFeatureEditedBind = this.#onWindowFeatureEdited.bind(this);
        this.onWindowFeatureRemovedBind = this.#onWindowFeatureRemoved.bind(this);
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.featureEdited, this.onWindowFeatureEditedBind);
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.featureRemoved, this.onWindowFeatureRemovedBind);
    }
    detachGlobalListeners() {
        window.removeEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.featureEdited, this.onWindowFeatureEditedBind);
        window.removeEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.featureRemoved, this.onWindowFeatureRemovedBind);
    }
    //--------------------------------------------------------------------
    // # Section: Overridden
    //--------------------------------------------------------------------
    getName() {
        return super.getName();
    }
    //--------------------------------------------------------------------
    // # Section: Init Helpers
    //--------------------------------------------------------------------
    #initContextMenuItems() {
        (0, $062067ac9882af21$export$b6aef0d24cd6ce8c).addItem({
            icon: this.createIcon,
            i18nKey: `${$52634d1816cb8c89$var$I18N__BASE}.contextItems.createMarker`,
            fn: this.#onContextMenuCreateMarker.bind(this)
        });
        (0, $062067ac9882af21$export$b6aef0d24cd6ce8c).addItem({});
    }
    //--------------------------------------------------------------------
    // # Section: ContextMenu Callbacks
    //--------------------------------------------------------------------
    #onContextMenuCreateMarker(map, coordinates, target) {
        this.doShowIconMarkerModal(coordinates);
    }
    //--------------------------------------------------------------------
    // # Section: Browser Events
    //--------------------------------------------------------------------
    #onWindowFeatureEdited(event) {
        // Note: 
        // @Consumer callback
        if (this.options.onEdited) this.options.onEdited(event.detail.before, event.detail.after);
    }
    #onWindowFeatureRemoved(event) {
        // Note: 
        // @Consumer callback
        if (this.options.onRemoved) this.options.onRemoved(event.detail.feature);
    }
    //--------------------------------------------------------------------
    // # Section: Map/UI Callbacks
    //--------------------------------------------------------------------
    #onCreateMarker(result) {
        this.doAddIconMarker(result);
    }
    //--------------------------------------------------------------------
    // # Section: Tool DoActions
    //--------------------------------------------------------------------
    doShowIconMarkerModal(coordinates) {
        if (this.iconMarkerModal) return;
        this.iconMarkerModal = new (0, $c2db87d7a7fbc353$export$f4e5ae623d7eeeb5)({
            coordinates: coordinates,
            onCreate: (result)=>{
                this.#onCreateMarker(result);
            },
            onClose: ()=>{
                this.iconMarkerModal = undefined;
            }
        });
    }
    doAddMarkerToMap(marker) {
        const layerWrapper = (0, $e75fe1c51a3d360c$export$eff87c52915dd7fe).getActiveFeatureLayer({
            fallback: 'Markers'
        });
        layerWrapper.getLayer().getSource().addFeature(marker);
    }
    doAddIconMarker(result) {
        const coordinates = [
            Number(result.longitude),
            Number(result.latitude)
        ];
        const i18n = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get(`${$52634d1816cb8c89$var$I18N__BASE_COMMON}.titles`);
        const prettyCoordinates = (0, $1bd0a226f9a16141$export$c883fd238161f841)(coordinates);
        const infoWindow = {
            title: result.title,
            content: `
                <p>${result.description}</p>
            `,
            footer: `
                <span class="oltb-info-window__coordinates">${prettyCoordinates}</span>
                <div class="oltb-info-window__buttons-wrapper">
                    <button class="${$52634d1816cb8c89$var$CLASS__FUNC_BUTTON} ${$52634d1816cb8c89$var$CLASS__FUNC_BUTTON}--delete oltb-tippy" data-oltb-i18n="${$52634d1816cb8c89$var$I18N__BASE_COMMON}.titles.delete" title="${i18n.delete}" id="${$52634d1816cb8c89$var$ID__PREFIX_INFO_WINDOW}-remove"></button>
                    <button class="${$52634d1816cb8c89$var$CLASS__FUNC_BUTTON} ${$52634d1816cb8c89$var$CLASS__FUNC_BUTTON}--crosshair oltb-tippy" data-oltb-i18n="${$52634d1816cb8c89$var$I18N__BASE_COMMON}.titles.copyCoordinates" title="${i18n.copyCoordinates}" id="${$52634d1816cb8c89$var$ID__PREFIX_INFO_WINDOW}-copy-coordinates" data-oltb-coordinates="${prettyCoordinates}"></button>
                    <button class="${$52634d1816cb8c89$var$CLASS__FUNC_BUTTON} ${$52634d1816cb8c89$var$CLASS__FUNC_BUTTON}--copy oltb-tippy" data-oltb-i18n="${$52634d1816cb8c89$var$I18N__BASE_COMMON}.titles.copyText" title="${i18n.copyText}" id="${$52634d1816cb8c89$var$ID__PREFIX_INFO_WINDOW}-copy-text" data-oltb-copy="${result.title}, ${result.description}"></button>
                    <button class="${$52634d1816cb8c89$var$CLASS__FUNC_BUTTON} ${$52634d1816cb8c89$var$CLASS__FUNC_BUTTON}--edit oltb-tippy" data-oltb-i18n="${$52634d1816cb8c89$var$I18N__BASE_COMMON}.titles.edit" title="${i18n.edit}" id="${$52634d1816cb8c89$var$ID__PREFIX_INFO_WINDOW}-edit"></button>
                    <button class="${$52634d1816cb8c89$var$CLASS__FUNC_BUTTON} ${$52634d1816cb8c89$var$CLASS__FUNC_BUTTON}--layer oltb-tippy" data-oltb-i18n="${$52634d1816cb8c89$var$I18N__BASE_COMMON}.titles.showLayer" title="${i18n.showLayer}" id="${$52634d1816cb8c89$var$ID__PREFIX_INFO_WINDOW}-show-layer"></button>
                </div>
            `
        };
        const marker = (0, $45f5d1a81c4ed6cb$export$73e78dff44a347ad).generateIconMarker({
            lon: coordinates[0],
            lat: coordinates[1],
            title: result.title,
            description: result.description,
            infoWindow: infoWindow,
            marker: {
                fill: result.markerFill,
                stroke: result.markerStroke
            },
            icon: {
                key: result.icon,
                fill: result.iconFill,
                stroke: result.iconStroke
            },
            label: {
                text: result.label,
                fill: result.labelFill,
                stroke: result.labelStroke,
                strokeWidth: result.labelStrokeWidth
            }
        });
        this.doAddMarkerToMap(marker);
        // Note: 
        // @Consumer callback
        if (this.options.onAdded) this.options.onAdded(marker);
        return marker;
    }
}



var $f1q41 = parcelRequire("f1q41");









var $f1q41 = parcelRequire("f1q41");







const $3d6ecff41ce30a75$var$FILENAME = 'import-layer-modal.js';
const $3d6ecff41ce30a75$var$ID__PREFIX = 'oltb-import-layer-modal';
const $3d6ecff41ce30a75$var$I18N__BASE = 'modalExtensions.importLayerModal';
// Note:
// Only specify the unique options to this class
// Things to override on the BaseModal is passed directly
const $3d6ecff41ce30a75$var$DefaultOptions = Object.freeze({
    onImport: undefined,
    onCancel: undefined
});
/**
 * About:
 * Manager that handles importing of vector layers
 */ class $3d6ecff41ce30a75$export$22cffae5d5ca5853 extends (0, $b12cc913018885a9$export$a703eb468fcf7e69) {
    #buttons = [];
    constructor(options = {}){
        super({
            filename: $3d6ecff41ce30a75$var$FILENAME,
            title: (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get(`${$3d6ecff41ce30a75$var$I18N__BASE}.title`),
            ...options
        });
        this.options = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep($3d6ecff41ce30a75$var$DefaultOptions), options);
        this.#createModalContent();
    }
    //--------------------------------------------------------------------
    // # Section: Overridden
    //--------------------------------------------------------------------
    getName() {
        return super.getName();
    }
    //--------------------------------------------------------------------
    // # Section: User Interface
    //--------------------------------------------------------------------
    #createModalContent() {
        const i18n = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get(`${$3d6ecff41ce30a75$var$I18N__BASE}.form`);
        const featureProjectionOptions = [];
        const dataProjectionOptions = [];
        const projections = (0, $3d63321abab47ecf$export$38112acb54e12e1).getProjections();
        projections.forEach((projection)=>{
            featureProjectionOptions.push({
                text: `${projection.name} (${projection.code})`,
                value: projection.code
            });
            dataProjectionOptions.push({
                text: `${projection.name} (${projection.code})`,
                value: projection.code
            });
        });
        const projection = (0, $1e8c0ef90ed82280$export$a33e119b2316dcb7).getConfig().projection;
        const [featureProjectionWrapper, featureProjectionSelect] = (0, $8b36a4c9059be7ba$export$af1822d79ba4bb67)({
            idPrefix: $3d6ecff41ce30a75$var$ID__PREFIX,
            idPostfix: '-feature-projection',
            text: i18n.featureProjection,
            options: featureProjectionOptions,
            value: projection.default
        });
        const [dataProjectionWrapper, dataProjectionSelect] = (0, $8b36a4c9059be7ba$export$af1822d79ba4bb67)({
            idPrefix: $3d6ecff41ce30a75$var$ID__PREFIX,
            idPostfix: '-data-projection',
            text: i18n.dataProjection,
            options: dataProjectionOptions,
            value: projection.wgs84
        });
        const buttonsWrapper = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'div',
            class: 'oltb-d-flex oltb-justify-content-between oltb-mt-15'
        });
        const importButton = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'button',
            text: i18n.import,
            class: 'oltb-dialog__btn oltb-btn oltb-btn--green-mid',
            attributes: {
                'type': 'button'
            },
            listeners: {
                'click': ()=>{
                    this.#onImport({
                        featureProjection: featureProjectionSelect.value.trim(),
                        dataProjection: dataProjectionSelect.value.trim()
                    });
                }
            }
        });
        const cancelButton = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'button',
            text: i18n.cancel,
            class: `oltb-dialog__btn oltb-btn ${(0, $c63f096e37f334a4$export$5a63ccfbe4d87ef0)() ? 'oltb-btn--gray-mid' : 'oltb-btn--gray-dark'}`,
            attributes: {
                'type': 'button'
            },
            listeners: {
                'click': this.#onCancel.bind(this)
            }
        });
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(buttonsWrapper, [
            cancelButton,
            importButton
        ]);
        const modalContent = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'div',
            class: 'oltb-modal__content'
        });
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(modalContent, [
            featureProjectionWrapper,
            dataProjectionWrapper,
            buttonsWrapper
        ]);
        this.#buttons = [
            cancelButton,
            importButton
        ];
        this.show(modalContent);
    }
    //--------------------------------------------------------------------
    // # Section: Events
    //--------------------------------------------------------------------
    #onImport(result) {
        this.close();
        this.options.onImport && this.options.onImport(result);
    }
    #onCancel() {
        this.close();
        this.options.onCancel && this.options.onCancel();
    }
    //--------------------------------------------------------------------
    // # Section: Public API
    //--------------------------------------------------------------------
    getButtons() {
        return this.#buttons;
    }
}





const $c7e42ac37e45f65c$var$FILENAME = 'import-vector-layer-tool.js';
const $c7e42ac37e45f65c$var$CLASS__TOOL_BUTTON = 'oltb-tool-button';
const $c7e42ac37e45f65c$var$I18N__BASE = 'tools.importVectorLayerTool';
const $c7e42ac37e45f65c$var$DefaultOptions = Object.freeze({
    onInitiated: undefined,
    onClicked: undefined,
    onImported: undefined,
    onError: undefined
});
/**
 * About:
 * Import Vector layers
 * 
 * Description:
 * Vector layers such as geojson can be imported and then create a Feature layer with its specified projections.
 */ class $c7e42ac37e45f65c$export$9854746561ce0e81 extends (0, $10d08d54da4ecbc4$export$cf198134d112da63) {
    constructor(options = {}){
        super({
            filename: $c7e42ac37e45f65c$var$FILENAME
        });
        const icon = (0, $dcff5ab966a6537f$export$a297fe855adfd36c)({
            path: (0, $35649bc6579784f8$export$3fddabec91763a6e).folderOpen.stroked,
            class: `${$c7e42ac37e45f65c$var$CLASS__TOOL_BUTTON}__icon`
        });
        const i18n = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get($c7e42ac37e45f65c$var$I18N__BASE);
        const button = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'button',
            html: icon,
            class: $c7e42ac37e45f65c$var$CLASS__TOOL_BUTTON,
            attributes: {
                'type': 'button',
                'data-tippy-content': `${i18n.title} (${(0, $a256deadcc62504f$export$4384767a59dc851d).importVectorLayerTool})`,
                'data-tippy-content-post': `(${(0, $a256deadcc62504f$export$4384767a59dc851d).importVectorLayerTool})`,
                'data-oltb-i18n': `${$c7e42ac37e45f65c$var$I18N__BASE}.title`
            },
            listeners: {
                'click': this.onClickTool.bind(this)
            }
        });
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(this.element, [
            button
        ]);
        this.button = button;
        this.fileReader = undefined;
        this.importLayerModal = undefined;
        this.options = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep($c7e42ac37e45f65c$var$DefaultOptions), options);
        this.inputDialog = this.#createUIInputDialog();
        this.attachGlobalListeners();
        // Note: 
        // @Consumer callback
        if (this.options.onInitiated) this.options.onInitiated();
    }
    attachGlobalListeners() {
        this.onWindowKeyUpBind = this.#onWindowKeyUp.bind(this);
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.keyUp, this.onWindowKeyUpBind);
    }
    detachGlobalListeners() {
        window.removeEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.keyUp, this.onWindowKeyUpBind);
    }
    //--------------------------------------------------------------------
    // # Section: Overridden
    //--------------------------------------------------------------------
    getName() {
        return super.getName();
    }
    onClickTool(event) {
        super.onClickTool(event);
        this.momentaryActivation();
        // Note: 
        // @Consumer callback
        if (this.options.onClicked) this.options.onClicked();
    }
    //--------------------------------------------------------------------
    // # Section: Tool Control
    //--------------------------------------------------------------------
    momentaryActivation() {
        if (this.importLayerModal) return;
        this.inputDialog.click();
    }
    //--------------------------------------------------------------------
    // # Section: Browser Events
    //--------------------------------------------------------------------
    #onWindowKeyUp(event) {
        if ((0, $fbd95439548fdf50$export$ad7bf7af8762113)(event, (0, $a256deadcc62504f$export$4384767a59dc851d).importVectorLayerTool)) this.onClickTool(event);
    }
    //--------------------------------------------------------------------
    // # Section: User Interface
    //--------------------------------------------------------------------
    #createUIInputDialog() {
        return (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'input',
            attributes: {
                'type': 'file',
                'accept': '.geojson, .kml'
            },
            listeners: {
                'change': this.#onInputChange.bind(this)
            }
        });
    }
    //--------------------------------------------------------------------
    // # Section: Map/UI Callbacks
    //--------------------------------------------------------------------
    #onInputChange(event) {
        const fileDialog = event.target;
        this.fileReader = new FileReader();
        this.fileReader.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).browser.load, this.#onParseLayer.bind(this, fileDialog));
        this.fileReader.readAsText(fileDialog.files[0]);
    }
    #onParseLayer(fileDialog) {
        if (this.importLayerModal) return;
        const file = fileDialog.files[0].name;
        this.askToImportLayer(file);
    }
    #onImportLayer(file, result) {
        this.doImportLayer(file, result);
    }
    //--------------------------------------------------------------------
    // # Section: Ask User
    //--------------------------------------------------------------------
    askToImportLayer(file) {
        if (this.importLayerModal) return;
        this.importLayerModal = new (0, $3d6ecff41ce30a75$export$22cffae5d5ca5853)({
            onImport: (result)=>{
                this.#onImportLayer(file, result);
            },
            onClose: ()=>{
                this.importLayerModal = undefined;
            }
        });
    }
    //--------------------------------------------------------------------
    // # Section: Tool DoActions
    //--------------------------------------------------------------------
    doAddFeaturesToMap(features, filename) {
        const layerWrapper = (0, $e75fe1c51a3d360c$export$eff87c52915dd7fe).addFeatureLayer({
            name: filename
        });
        layerWrapper.getLayer().getSource().addFeatures(features);
    }
    doImportLayer(file, result) {
        (0, $b9b5c0363f244088$export$49b118289be48034).logDebug($c7e42ac37e45f65c$var$FILENAME, 'doImportLayer', {
            file: file,
            featureProjection: result.featureProjection,
            dataProjection: result.dataProjection
        });
        try {
            const filename = file.split('.')[0];
            const fileExtension = file.split('.').pop().toLowerCase();
            const format = Object.keys((0, $33d6a58e88aba98a$export$6f7aa03db31f8f57)).find((key)=>{
                return key.toLowerCase() === fileExtension;
            });
            // Note: 
            // This should not happen since the format is set in the dialog using select element
            if (!format) {
                (0, $b9b5c0363f244088$export$49b118289be48034).logError($c7e42ac37e45f65c$var$FILENAME, 'doImportLayer', {
                    title: 'Error',
                    message: `The layer format is not supported (${format})`
                });
                (0, $9051f0e072bf4341$export$8d8dc7d5f743331b).error({
                    i18nKey: `${$c7e42ac37e45f65c$var$I18N__BASE}.toasts.errors.unsupportedFormat`
                });
                return;
            }
            const features = (0, $33d6a58e88aba98a$export$570785d7398311f5)(format).readFeatures(this.fileReader.result, {
                featureProjection: result.featureProjection,
                dataProjection: result.dataProjection
            });
            this.doAddFeaturesToMap(features, filename);
            // Note: 
            // @Consumer callback
            if (this.options.onImported) this.options.onImported(features);
        } catch (error) {
            (0, $b9b5c0363f244088$export$49b118289be48034).logError($c7e42ac37e45f65c$var$FILENAME, 'doImportLayer', {
                message: 'Failed to import vector layer',
                error: error
            });
            (0, $9051f0e072bf4341$export$8d8dc7d5f743331b).error({
                i18nKey: `${$c7e42ac37e45f65c$var$I18N__BASE}.toasts.errors.importFailed`
            });
            // Note: 
            // @Consumer callback
            if (this.options.onError) this.options.onError(file, error);
        }
    }
}



var $f1q41 = parcelRequire("f1q41");













var $f1q41 = parcelRequire("f1q41");





const $99e2bc539ad51c75$var$FILENAME = 'coordinate-model.js';
const $99e2bc539ad51c75$var$ID__PREFIX = 'oltb-coordinates-modal';
const $99e2bc539ad51c75$var$I18N__BASE = 'modalExtensions.coordinateModal';
// Note:
// Only specify the unique options to this class
// Things to override on the BaseModal is passed directly
const $99e2bc539ad51c75$var$DefaultOptions = Object.freeze({
    onNavigate: undefined,
    onCancel: undefined
});
/**
 * About:
 * Manager that handles navigation to entered coordinates
 */ class $99e2bc539ad51c75$export$433c63ba085b163f extends (0, $b12cc913018885a9$export$a703eb468fcf7e69) {
    #buttons = [];
    constructor(options = {}){
        super({
            filename: $99e2bc539ad51c75$var$FILENAME,
            title: (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get(`${$99e2bc539ad51c75$var$I18N__BASE}.title`),
            ...options
        });
        this.options = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep($99e2bc539ad51c75$var$DefaultOptions), options);
        this.#createModalContent();
    }
    //--------------------------------------------------------------------
    // # Section: Overridden
    //--------------------------------------------------------------------
    getName() {
        return super.getName();
    }
    //--------------------------------------------------------------------
    // # Section: User Interface
    //--------------------------------------------------------------------
    #createModalContent() {
        const i18n = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get(`${$99e2bc539ad51c75$var$I18N__BASE}.form`);
        const [latWrapper, latInput] = (0, $b40309f6a4fce6ca$export$b9bff34c3ca2042f)({
            idPrefix: $99e2bc539ad51c75$var$ID__PREFIX,
            idPostfix: '-lat',
            text: i18n.latitude,
            placeholder: '51.5072'
        });
        const [lonWrapper, lonInput] = (0, $b40309f6a4fce6ca$export$b9bff34c3ca2042f)({
            idPrefix: $99e2bc539ad51c75$var$ID__PREFIX,
            idPostfix: '-lon',
            text: i18n.longitude,
            placeholder: '0.1276'
        });
        const buttonsWrapper = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'div',
            class: 'oltb-d-flex oltb-justify-content-between oltb-mt-15'
        });
        const navigateButton = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'button',
            text: i18n.navigateTo,
            class: 'oltb-dialog__btn oltb-btn oltb-btn--green-mid',
            attributes: {
                'type': 'button'
            },
            listeners: {
                'click': ()=>{
                    this.#onNavigate([
                        lonInput.value.trim(),
                        latInput.value.trim()
                    ]);
                }
            }
        });
        const cancelButton = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'button',
            text: i18n.cancel,
            class: `oltb-dialog__btn oltb-btn ${(0, $c63f096e37f334a4$export$5a63ccfbe4d87ef0)() ? 'oltb-btn--gray-mid' : 'oltb-btn--gray-dark'}`,
            attributes: {
                'type': 'button'
            },
            listeners: {
                'click': this.#onCancel.bind(this)
            }
        });
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(buttonsWrapper, [
            cancelButton,
            navigateButton
        ]);
        const modalContent = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'div',
            class: 'oltb-modal__content'
        });
        const coordinatesLabel = (0, $e1b36be5f031477b$export$cb0933279c36a66b).createElement({
            element: 'label',
            text: i18n.description,
            class: 'oltb-label oltb-mt-1'
        });
        (0, $e1b36be5f031477b$export$cb0933279c36a66b).appendChildren(modalContent, [
            latWrapper,
            lonWrapper,
            coordinatesLabel,
            buttonsWrapper
        ]);
        this.#buttons = [
            cancelButton,
            navigateButton
        ];
        this.show(modalContent);
    }
    //--------------------------------------------------------------------
    // # Section: Events
    //--------------------------------------------------------------------
    #onNavigate(result) {
        this.close();
        this.options.onNavigate && this.options.onNavigate(result);
    }
    #onCancel() {
        this.close();
        this.options.onCancel && this.options.onCancel();
    }
    //--------------------------------------------------------------------
    // # Section: Public API
    //--------------------------------------------------------------------
    getButtons() {
        return this.#buttons;
    }
}









const $7acb78f28ff27600$var$FILENAME = 'hidden-map-navigation-tool.js';
const $7acb78f28ff27600$var$CLASS__FUNC_BUTTON = 'oltb-func-btn';
const $7acb78f28ff27600$var$ID__PREFIX_INFO_WINDOW = 'oltb-info-window-marker';
const $7acb78f28ff27600$var$I18N__BASE = 'tools.hiddenMapNavigationTool';
const $7acb78f28ff27600$var$I18N__BASE_COMMON = 'commons';
const $7acb78f28ff27600$var$DefaultOptions = Object.freeze({
    focusZoom: 2
});
const $7acb78f28ff27600$var$DefaultLocation = (0, $1e8c0ef90ed82280$export$a33e119b2316dcb7).getConfig().location.default;
const $7acb78f28ff27600$var$LocalStorageNodeName = (0, $52e25f2a10ab5b5c$export$ada36e8a1c3bc83a).mapData;
const $7acb78f28ff27600$var$LocalStorageDefaults = Object.freeze({
    lon: $7acb78f28ff27600$var$DefaultLocation.lon,
    lat: $7acb78f28ff27600$var$DefaultLocation.lat,
    zoom: $7acb78f28ff27600$var$DefaultLocation.zoom,
    rotation: $7acb78f28ff27600$var$DefaultLocation.rotation
});
// Note:
// This model does not follow the model of a Marker. 
// This is to make it easier for the user and not have a deep object in the url
const $7acb78f28ff27600$var$DefaultProjection = (0, $1e8c0ef90ed82280$export$a33e119b2316dcb7).getConfig().projection;
const $7acb78f28ff27600$var$DefaultUrlMarker = Object.freeze({
    lon: 18.0685,
    lat: 59.3293,
    title: 'Marker',
    description: '',
    icon: 'geoMarker.filled',
    iconFill: '#FFFFFFFF',
    iconStroke: '#FFFFFFFF',
    markerFill: '#0166A5FF',
    markerStroke: '#0166A566',
    layerName: 'URL Marker',
    label: 'Marker',
    labelFill: '#FFFFFFFF',
    labelStroke: '#3B4352CC',
    labelStrokeWidth: 8,
    labelFont: '14px Calibri',
    labelUseEllipsisAfter: 20,
    projection: $7acb78f28ff27600$var$DefaultProjection.wgs84,
    zoom: 8
});
/**
 * About:
 * Extended navigation shortcuts
 * 
 * Description:
 * Features to simplify navigation, centering and focusing the Map.
 */ class $7acb78f28ff27600$export$d109f2b348d123ef extends (0, $10d08d54da4ecbc4$export$cf198134d112da63) {
    constructor(options = {}){
        super({
            filename: $7acb78f28ff27600$var$FILENAME
        });
        this.options = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep($7acb78f28ff27600$var$DefaultOptions), options);
        this.coordinatesModal = undefined;
        this.localStorage = (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).getAndMergeStateObject($7acb78f28ff27600$var$LocalStorageNodeName, $7acb78f28ff27600$var$LocalStorageDefaults);
        this.copyIcon = (0, $dcff5ab966a6537f$export$a297fe855adfd36c)({
            path: (0, $35649bc6579784f8$export$3fddabec91763a6e).copy.stroked
        });
        this.coordinatesIcon = (0, $dcff5ab966a6537f$export$a297fe855adfd36c)({
            path: (0, $35649bc6579784f8$export$3fddabec91763a6e).crosshair.stroked
        });
        this.moveCenterIcon = (0, $dcff5ab966a6537f$export$a297fe855adfd36c)({
            path: (0, $35649bc6579784f8$export$3fddabec91763a6e).arrowsMove.stroked
        });
        this.focusHereIcon = (0, $dcff5ab966a6537f$export$a297fe855adfd36c)({
            path: (0, $35649bc6579784f8$export$3fddabec91763a6e).aspectRatio.stroked
        });
        this.#initContextMenuItems();
        this.attachGlobalListeners();
    }
    attachGlobalListeners() {
        this.onOLTBReadyBind = this.#onOLTBReady.bind(this);
        window.addEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.ready, this.onOLTBReadyBind);
    }
    detachGlobalListeners() {
        window.removeEventListener((0, $a9807b370eed025c$export$ada873a34909da65).custom.ready, this.onOLTBReadyBind);
    }
    //--------------------------------------------------------------------
    // # Section: Overridden
    //--------------------------------------------------------------------
    getName() {
        return super.getName();
    }
    //--------------------------------------------------------------------
    // # Section: Init Helpers
    //--------------------------------------------------------------------
    #initContextMenuItems() {
        (0, $062067ac9882af21$export$b6aef0d24cd6ce8c).addItem({
            icon: this.copyIcon,
            i18nKey: `${$7acb78f28ff27600$var$I18N__BASE}.contextItems.copyCoordinates`,
            fn: this.#onContextMenuCopyCoordinates.bind(this)
        });
        (0, $062067ac9882af21$export$b6aef0d24cd6ce8c).addItem({});
        (0, $062067ac9882af21$export$b6aef0d24cd6ce8c).addItem({
            icon: this.coordinatesIcon,
            i18nKey: `${$7acb78f28ff27600$var$I18N__BASE}.contextItems.navigateToCoordinates`,
            fn: this.#onContextMenuCenterAtCoordinates.bind(this)
        });
        (0, $062067ac9882af21$export$b6aef0d24cd6ce8c).addItem({
            icon: this.moveCenterIcon,
            i18nKey: `${$7acb78f28ff27600$var$I18N__BASE}.contextItems.centerMap`,
            fn: this.#onContextMenuCenterMap.bind(this)
        });
        (0, $062067ac9882af21$export$b6aef0d24cd6ce8c).addItem({
            icon: this.focusHereIcon,
            i18nKey: `${$7acb78f28ff27600$var$I18N__BASE}.contextItems.focusMap`,
            fn: this.#onContextMenuFocusHere.bind(this)
        });
        (0, $062067ac9882af21$export$b6aef0d24cd6ce8c).addItem({});
    }
    //--------------------------------------------------------------------
    // # Section: ContextMenu Callbacks
    //--------------------------------------------------------------------
    #onContextMenuCopyCoordinates(map, coordinates, target) {
        this.doCopyCoordinatesAsync(coordinates);
    }
    #onContextMenuCenterAtCoordinates(map, coordinates, target) {
        this.doShowCoordinatesModal(map);
    }
    #onContextMenuCenterMap(map, coordinates, target) {
        (0, $eb687437705d7055$export$cc43ef3ca2ae36e8)({
            map: map,
            coordinates: coordinates,
            zoom: map.getView().getZoom()
        });
    }
    #onContextMenuFocusHere(map, coordinates, target) {
        (0, $eb687437705d7055$export$cc43ef3ca2ae36e8)({
            map: map,
            coordinates: coordinates,
            zoom: this.options.focusZoom
        });
    }
    //--------------------------------------------------------------------
    // # Section: Browser Events
    //--------------------------------------------------------------------
    #onOLTBReady(event) {
        const map = this.getMap();
        if (!map) return;
        // Bind to global map events
        map.on((0, $a9807b370eed025c$export$ada873a34909da65).openLayers.moveEnd, this.#onMoveEnd.bind(this));
        this.doDetectUrlMarker();
    }
    //--------------------------------------------------------------------
    // # Section: Conversions/Validation
    //--------------------------------------------------------------------
    #validateProjection(projection) {
        projection = projection.toUpperCase();
        if (!projection.startsWith('EPSG:')) projection = `EPSG:${projection}`;
        return projection;
    }
    #validateHexColor(color) {
        if (color.startsWith('#')) return color;
        return `#${color}`;
    }
    #hasProjection(projection) {
        const hasProjection = (0, $3d63321abab47ecf$export$38112acb54e12e1).hasProjection(projection);
        if (!hasProjection) {
            (0, $b9b5c0363f244088$export$49b118289be48034).logError($7acb78f28ff27600$var$FILENAME, 'hasProjection', {
                message: 'Missing projection definition',
                projection: projection
            });
            (0, $9051f0e072bf4341$export$8d8dc7d5f743331b).error({
                i18nKey: `${$7acb78f28ff27600$var$I18N__BASE}.toasts.errors.missingProjection`
            });
        }
        return hasProjection;
    }
    //--------------------------------------------------------------------
    // # Section: Map/UI Callbacks
    //--------------------------------------------------------------------
    #onCreateUrlMarker(markerString) {
        const map = this.getMap();
        if (!map) return;
        this.doParseUrlMarker(markerString);
    }
    #onMoveEnd(event) {
        const map = this.getMap();
        if (!map) return;
        this.setLastPosition(map);
    }
    //--------------------------------------------------------------------
    // # Section: Getters and Setters
    //--------------------------------------------------------------------
    setLastPosition(map) {
        const view = map.getView();
        const center = (0, $9c4744460e43e41b$export$3fb495868742d370)(view.getCenter());
        this.localStorage.lon = center[0];
        this.localStorage.lat = center[1];
        this.localStorage.zoom = view.getZoom();
        this.localStorage.rotation = view.getRotation();
        (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).setStateObject($7acb78f28ff27600$var$LocalStorageNodeName, this.localStorage);
    }
    //--------------------------------------------------------------------
    // # Section: Tool DoActions
    //--------------------------------------------------------------------
    async doCopyCoordinatesAsync(coordinates) {
        const prettyCoordinates = (0, $1bd0a226f9a16141$export$c883fd238161f841)(coordinates);
        try {
            await (0, $9f66900afbcbe054$export$2cdf1b96a9f86d16).copyAsync(prettyCoordinates);
            (0, $9051f0e072bf4341$export$8d8dc7d5f743331b).info({
                i18nKey: `${$7acb78f28ff27600$var$I18N__BASE}.toasts.infos.coordinatesCopied`,
                autoremove: true
            });
        } catch (error) {
            (0, $b9b5c0363f244088$export$49b118289be48034).logError($7acb78f28ff27600$var$FILENAME, 'doCopyCoordinatesAsync', {
                message: 'Failed to copy coordinates',
                error: error
            });
            (0, $9051f0e072bf4341$export$8d8dc7d5f743331b).error({
                i18nKey: `${$7acb78f28ff27600$var$I18N__BASE}.toasts.errors.coordinatesCopy`
            });
        }
    }
    doDetectUrlMarker() {
        const markerKey = (0, $1e8c0ef90ed82280$export$a33e119b2316dcb7).getConfig().urlParameter.marker;
        const marker = (0, $af35fd2ff1608131$export$fb10f6d9eb34a490).getParameter(markerKey, false);
        if (marker) this.#onCreateUrlMarker(marker);
    }
    doParseUrlMarker(markerString) {
        const map = this.getMap();
        if (!map) return;
        try {
            const markerParsed = JSON.parse(markerString);
            const markerData = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep($7acb78f28ff27600$var$DefaultUrlMarker), markerParsed);
            (0, $b9b5c0363f244088$export$49b118289be48034).logDebug($7acb78f28ff27600$var$FILENAME, 'doParseUrlMarker', markerData);
            const coordinates = [
                Number(markerData.lon),
                Number(markerData.lat)
            ];
            const marker = this.doAddIconMarker(markerData, coordinates);
            this.doFocusMarker(map, marker, coordinates, (0, $1e8c0ef90ed82280$export$a33e119b2316dcb7).getConfig().marker.focusZoom);
        } catch (error) {
            (0, $b9b5c0363f244088$export$49b118289be48034).logError($7acb78f28ff27600$var$FILENAME, 'doParseUrlMarker', {
                message: 'Failed to parse URL Marker',
                error: error
            });
            (0, $9051f0e072bf4341$export$8d8dc7d5f743331b).error({
                i18nKey: `${$7acb78f28ff27600$var$I18N__BASE}.toasts.errors.parseUrlMarker`
            });
        }
    }
    doFocusMarker(map, marker, coordinates, zoom) {
        (0, $eb687437705d7055$export$cc43ef3ca2ae36e8)({
            map: map,
            coordinates: coordinates,
            zoom: zoom,
            onDone: (result)=>{
                (0, $09399be6683278f4$export$ffc0bcd424265bb8).tryPulseAnimation(marker);
                (0, $09399be6683278f4$export$ffc0bcd424265bb8).showOverlay(marker, (0, $9c4744460e43e41b$export$b15d9668511529b9)(coordinates));
            }
        });
    }
    doAddMarkerToMap(marker, layerName) {
        const layerWrapper = (0, $e75fe1c51a3d360c$export$eff87c52915dd7fe).addFeatureLayer({
            name: layerName
        });
        layerWrapper.getLayer().getSource().addFeature(marker);
    }
    doAddIconMarker(markerData, coordinates) {
        // Note:
        // Colors given in URL can't contain hashtag unless encoded as %23
        // Easier to prepend with hashtag after URL data has been fetched and parsed
        markerData.markerFill = this.#validateHexColor(markerData.markerFill);
        markerData.markerStroke = this.#validateHexColor(markerData.markerStroke);
        markerData.projection = this.#validateProjection(markerData.projection);
        if (!this.#hasProjection(markerData.projection)) return;
        const transformedCoordinates = (0, $9c4744460e43e41b$export$51186ad6e864892a)(coordinates, markerData.projection, (0, $1e8c0ef90ed82280$export$a33e119b2316dcb7).getConfig().projection.wgs84);
        const i18n = (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad).get(`${$7acb78f28ff27600$var$I18N__BASE_COMMON}.titles`);
        const prettyCoordinates = (0, $1bd0a226f9a16141$export$c883fd238161f841)(transformedCoordinates);
        const infoWindow = {
            title: markerData.title,
            content: `
                <p>${markerData.description}</p>
            `,
            footer: `
                <span class="oltb-info-window__coordinates">${prettyCoordinates}</span>
                <div class="oltb-info-window__buttons-wrapper">
                    <button class="${$7acb78f28ff27600$var$CLASS__FUNC_BUTTON} ${$7acb78f28ff27600$var$CLASS__FUNC_BUTTON}--delete oltb-tippy" data-oltb-i18n="${$7acb78f28ff27600$var$I18N__BASE_COMMON}.titles.delete" title="${i18n.delete}" id="${$7acb78f28ff27600$var$ID__PREFIX_INFO_WINDOW}-remove"></button>
                    <button class="${$7acb78f28ff27600$var$CLASS__FUNC_BUTTON} ${$7acb78f28ff27600$var$CLASS__FUNC_BUTTON}--crosshair oltb-tippy" data-oltb-i18n="${$7acb78f28ff27600$var$I18N__BASE_COMMON}.titles.copyCoordinates" title="${i18n.copyCoordinates}" id="${$7acb78f28ff27600$var$ID__PREFIX_INFO_WINDOW}-copy-coordinates" data-oltb-coordinates="${prettyCoordinates}"></button>
                    <button class="${$7acb78f28ff27600$var$CLASS__FUNC_BUTTON} ${$7acb78f28ff27600$var$CLASS__FUNC_BUTTON}--copy oltb-tippy" data-oltb-i18n="${$7acb78f28ff27600$var$I18N__BASE_COMMON}.titles.copyText" title="${i18n.copyText}" id="${$7acb78f28ff27600$var$ID__PREFIX_INFO_WINDOW}-copy-text" data-oltb-copy="${markerData.title}, ${markerData.description}"></button>
                    <button class="${$7acb78f28ff27600$var$CLASS__FUNC_BUTTON} ${$7acb78f28ff27600$var$CLASS__FUNC_BUTTON}--layer oltb-tippy" data-oltb-i18n="${$7acb78f28ff27600$var$I18N__BASE_COMMON}.titles.showLayer" title="${i18n.showLayer}" id="${$7acb78f28ff27600$var$ID__PREFIX_INFO_WINDOW}-show-layer"></button>
                </div>
            `
        };
        const marker = (0, $45f5d1a81c4ed6cb$export$73e78dff44a347ad).generateIconMarker({
            lon: transformedCoordinates[0],
            lat: transformedCoordinates[1],
            title: markerData.title,
            description: markerData.description,
            infoWindow: infoWindow,
            marker: {
                fill: markerData.markerFill,
                stroke: markerData.markerStroke
            },
            icon: {
                key: markerData.icon,
                fill: markerData.iconFill,
                stroke: markerData.iconStroke
            },
            label: {
                text: markerData.label,
                font: markerData.labelFont,
                fill: markerData.labelFill,
                stroke: markerData.labelStroke,
                strokeWidth: markerData.labelStrokeWidth
            }
        });
        this.doAddMarkerToMap(marker, markerData.layerName);
        return marker;
    }
    doShowCoordinatesModal(map) {
        if (this.coordinatesModal) return;
        this.coordinatesModal = new (0, $99e2bc539ad51c75$export$433c63ba085b163f)({
            onNavigate: (coordinates)=>{
                (0, $eb687437705d7055$export$cc43ef3ca2ae36e8)({
                    map: map,
                    coordinates: coordinates,
                    zoom: map.getView().getZoom()
                });
            },
            onClose: ()=>{
                this.coordinatesModal = undefined;
            }
        });
    }
}


// Note: 
// The init order is important
(0, $67f02e726366aa31$export$34222ee0ce4be4c7).initAsync([
    {
        manager: (0, $b9b5c0363f244088$export$49b118289be48034)
    },
    {
        manager: (0, $96903e3f16465932$export$cc74486daaaef499)
    },
    {
        manager: (0, $2577fba4fdbf4b69$export$29bb23d12246c816)
    },
    {
        manager: (0, $b8ef36c3e7ea3a5d$export$8117257dfd8bd5f2)
    },
    {
        manager: (0, $45f5d1a81c4ed6cb$export$73e78dff44a347ad)
    },
    {
        manager: (0, $c40ede3e491a5acd$export$4d5c8163a511d38a),
        options: {
            ignoredKeys: []
        }
    },
    {
        manager: (0, $8f42450ebdd44f5e$export$8e7188a60a5bbe16)
    },
    {
        manager: (0, $1e8c0ef90ed82280$export$a33e119b2316dcb7)
    },
    {
        manager: (0, $aa968a2b9f70852c$export$79f1f2f8f7dbb8ad)
    },
    {
        manager: (0, $3d63321abab47ecf$export$38112acb54e12e1)
    },
    {
        manager: (0, $e75fe1c51a3d360c$export$eff87c52915dd7fe)
    },
    {
        manager: (0, $f886df948c341d69$export$40ee9a3f4944191d)
    },
    {
        manager: (0, $31c79cd05d39fa2c$export$93efd44b9c955db5)
    },
    {
        manager: (0, $5289d96a2eaac637$export$3cf29e47efa41626)
    },
    {
        manager: (0, $af35fd2ff1608131$export$fb10f6d9eb34a490)
    },
    {
        manager: (0, $3110b1ed727d9f35$export$df4a79c26d3b48ff)
    },
    {
        manager: (0, $5547bbb6fff7ebf1$export$3016a1f47b675883)
    },
    {
        manager: (0, $9829e24a28f9d958$export$786f0b7d4117ba87)
    },
    {
        manager: (0, $09399be6683278f4$export$ffc0bcd424265bb8)
    },
    {
        manager: (0, $6600835a70a26b10$export$a2c2de1efa8671eb)
    },
    {
        manager: (0, $206be50bf50f716a$export$53fa2d26c9df363b)
    },
    {
        manager: (0, $676c8372f9654b59$export$ac3128716fe7727f)
    }
]).then(()=>{
    $163e2284b131a289$var$initMapAndToolbar();
});
const $163e2284b131a289$var$initMapAndToolbar = ()=>{
    const defaultLocation = (0, $1e8c0ef90ed82280$export$a33e119b2316dcb7).getConfig().location.default;
    const localStorageNodeName = (0, $52e25f2a10ab5b5c$export$ada36e8a1c3bc83a).mapData;
    const localStorageDefaults = Object.freeze({
        lon: defaultLocation.lon,
        lat: defaultLocation.lat,
        zoom: defaultLocation.zoom,
        rotation: defaultLocation.rotation
    });
    const localStorage = (0, $c40ede3e491a5acd$export$4d5c8163a511d38a).getAndMergeStateObject(localStorageNodeName, localStorageDefaults);
    const defaultProjection = (0, $1e8c0ef90ed82280$export$a33e119b2316dcb7).getConfig().projection.default;
    const map = new (0, $41aa29ae0c4b607a$export$2e2bcd8739ae039)({
        interactions: (0, $e3fbd36d629ecc04$export$ebe90cb607ad99e)({
            mouseWheelZoom: false,
            altShiftDragRotate: false,
            dragPan: false,
            keyboard: false
        }).extend([
            new (0, $aaa378764710d71e$export$2e2bcd8739ae039)({
                condition: function(event) {
                    return (0, $edf87b50170125f7$export$f3100d8d6292d638)(event) || (0, $5547bbb6fff7ebf1$export$3016a1f47b675883).getSetting((0, $65522956a1f1a049$export$c72f6eaae7b9adff).mouseWheelZoom);
                }
            }),
            new (0, $197c7092261b2aa0$export$2e2bcd8739ae039)({
                condition: function(event) {
                    return (0, $edf87b50170125f7$export$4e5f01653f9f1f82)(event) && (0, $5547bbb6fff7ebf1$export$3016a1f47b675883).getSetting((0, $65522956a1f1a049$export$c72f6eaae7b9adff).altShiftDragRotate);
                }
            }),
            new (0, $c11585da26a016db$export$2e2bcd8739ae039)({
                condition: function(event) {
                    return ((0, $edf87b50170125f7$export$f3100d8d6292d638)(event) || (0, $5547bbb6fff7ebf1$export$3016a1f47b675883).getSetting((0, $65522956a1f1a049$export$c72f6eaae7b9adff).dragPan)) && !(0, $edf87b50170125f7$export$4e5f01653f9f1f82)(event) && !(0, $edf87b50170125f7$export$5d31fe68a477cfbb)(event);
                }
            }),
            new (0, $2237fabfa170eefc$export$2e2bcd8739ae039)({
                condition: function(event) {
                    return (0, $5547bbb6fff7ebf1$export$3016a1f47b675883).getSetting((0, $65522956a1f1a049$export$c72f6eaae7b9adff).keyboardZoom) && (0, $edf87b50170125f7$export$e5570ca80cd8fd54)(event);
                }
            }),
            new (0, $178bb1517d626802$export$2e2bcd8739ae039)({
                condition: function(event) {
                    return (0, $5547bbb6fff7ebf1$export$3016a1f47b675883).getSetting((0, $65522956a1f1a049$export$c72f6eaae7b9adff).keyboardPan) && (0, $edf87b50170125f7$export$e5570ca80cd8fd54)(event);
                }
            })
        ]),
        controls: (0, $af7495b2f822d5e9$export$ebe90cb607ad99e)({
            zoom: false,
            rotate: false
        }).extend([
            new (0, $52634d1816cb8c89$export$4602f3257ee20a0f)({
                onAdded: function(marker) {
                    console.log('HiddenMarkerTool: Marker added', marker);
                },
                onRemoved: function(marker) {
                    console.log('HiddenMarkerTool: Marker removed', marker);
                },
                onEdited: function(before, after) {
                    console.log('HiddenMarkerTool: Marker edited', before, after);
                }
            }),
            new (0, $7acb78f28ff27600$export$d109f2b348d123ef)({
                focusZoom: 10
            }),
            new (0, $d8c7e32a69d15871$export$6e06cb1e6abfcb87)({
                lon: 18.1201,
                lat: 35.3518,
                zoom: 3,
                onInitiated: function() {
                    console.log('HomeTool: Initiated');
                },
                onClicked: function() {
                    console.log('HomeTool: Clicked');
                },
                onBrowserStateCleared: function() {
                    console.log('HomeTool: State cleared');
                },
                onNavigatedHome: function(result) {
                    console.log('HomeTool: Navigated home', result);
                }
            }),
            new (0, $2321400a3a921fc4$export$99c93d665eb844f0)({
                onInitiated: function() {
                    console.log('ZoomInTool: Initiated');
                },
                onClicked: function() {
                    console.log('ZoomInTool: Clicked');
                },
                onZoomed: function(result) {
                    console.log('ZoomInTool: Zoomed in', result);
                }
            }),
            new (0, $6f3bdb1dde171a4c$export$22efc6033f101985)({
                onInitiated: function() {
                    console.log('ZoomOutTool: Initiated');
                },
                onClicked: function() {
                    console.log('ZoomOutTool: Clicked');
                },
                onZoomed: function(result) {
                    console.log('ZoomOutTool: Zoomed out', result);
                }
            }),
            new (0, $80358e12c7bd59d1$export$f58d84789496517c)({
                onInitiated: function() {
                    console.log('ZoomboxTool: Initiated');
                },
                onClicked: function() {
                    console.log('ZoomboxTool: Clicked');
                },
                onBrowserStateCleared: function() {
                    console.log('ZoomboxTool: State cleared');
                },
                onStart: function(event) {
                    console.log('ZoomboxTool: Start', event);
                },
                onEnd: function(event) {
                    console.log('ZoomboxTool: End', event);
                },
                onDrag: function(event) {
                    console.log('ZoomboxTool: Drag', event);
                },
                onCancel: function(event) {
                    console.log('ZoomboxTool: Cancel', event);
                },
                onError: function(event) {
                    console.log('ZoomboxTool: Error', event);
                }
            }),
            new (0, $4de09c416369dd54$export$760fd550653b494c)({
                onInitiated: function() {
                    console.log('FullscreenTool: Initiated');
                },
                onClicked: function() {
                    console.log('FullscreenTool: Clicked');
                },
                onEnter: function(event) {
                    console.log('FullscreenTool: Enter fullscreen', event);
                },
                onLeave: function(event) {
                    console.log('FullscreenTool: Leave fullscreen', event);
                }
            }),
            new (0, $b75b4a9c88d279cf$export$b88f5ca7e6588e92)({
                filename: 'map-image-export',
                appendTime: true,
                onInitiated: function() {
                    console.log('ExportPngTool: Initiated');
                },
                onClicked: function() {
                    console.log('ExportPngTool: Clicked');
                },
                onExported: function(filename, content) {
                    console.log('ExportPngTool: PNG exported', filename, content);
                },
                onError: function(error) {
                    console.log('ExportPngTool: Error', error);
                }
            }),
            new (0, $4612de54ed55adf8$export$ccea04be742b1ba4)({
                onInitiated: function() {
                    console.log('DrawTool: Initiated');
                },
                onClicked: function() {
                    console.log('DrawTool: Clicked');
                },
                onBrowserStateCleared: function() {
                    console.log('DrawTool: State cleared');
                },
                onStart: function(event) {
                    console.log('DrawTool: Start');
                },
                onEnd: function(event) {
                    console.log('DrawTool: End', event.feature);
                },
                onAbort: function(event) {
                    console.log('DrawTool: Abort');
                },
                onError: function(event) {
                    console.log('DrawTool: Error');
                },
                onIntersected: function(event, intersectedFeatures) {
                    console.log('DrawTool: Intersected', event.feature);
                    console.log('DrawTool: Intersected features', intersectedFeatures);
                },
                onSnapped: function(event) {
                    console.log('DrawTool: Snapped');
                },
                onUnSnapped: function(event) {
                    console.log('DrawTool: UnSnapped');
                }
            }),
            new (0, $6097679d5ffd37cd$export$9ddc54d50debd217)({
                onInitiated: function() {
                    console.log('MeasureTool: Initiated');
                },
                onClicked: function() {
                    console.log('MeasureTool: Clicked');
                },
                onBrowserStateCleared: function() {
                    console.log('MeasureTool: State cleared');
                },
                onStart: function(event) {
                    console.log('MeasureTool: Start');
                },
                onEnd: function(event) {
                    console.log('MeasureTool: End', event.feature);
                },
                onAbort: function(event) {
                    console.log('MeasureTool: Abort');
                },
                onError: function(event) {
                    console.log('MeasureTool: Error');
                }
            }),
            new (0, $58f704a3861e5d5d$export$f634386f0fc361c4)({
                hitTolerance: 5,
                onInitiated: function() {
                    console.log('EditTool: Initiated');
                },
                onClicked: function() {
                    console.log('EditTool: Clicked');
                },
                onBrowserStateCleared: function() {
                    console.log('EditTool: Sstate cleared');
                },
                onStyleChange: function(event, style) {
                    console.log('EditTool: Style changed');
                },
                onCutFeatures: function(features) {
                    console.log('EditTool: Cut features', features);
                },
                onCopyFeatures: function(features) {
                    console.log('EditTool: Copied features', features);
                },
                onPasteFeatures: function(features, layerWrapper) {
                    console.log('EditTool: Pasted features', features);
                },
                onShapeOperation: function(type, a, b, result) {
                    console.log('EditTool: Shape operation', type);
                },
                onSelectAdd: function(event) {
                    console.log('EditTool: Selected feature');
                },
                onSelectRemove: function(event) {
                    console.log('EditTool: Deselected feature');
                },
                onModifyStart: function(event) {
                    console.log('EditTool: Modify start');
                },
                onModifyEnd: function(event) {
                    console.log('EditTool: Modify end');
                },
                onTranslateStart: function(event) {
                    console.log('EditTool: Translate start');
                },
                onTranslateEnd: function(event) {
                    console.log('EditTool: Translate end');
                },
                onRemovedFeatures: function(features) {
                    console.log('EditTool: Removed features', features);
                },
                onError: function(event) {
                    console.log('EditTool: Error');
                },
                onSnapped: function(event) {
                    console.log('EditTool: Snapped');
                },
                onUnSnapped: function(event) {
                    console.log('EditTool: UnSnapped');
                }
            }),
            new (0, $f5908b407f28646c$export$3b3d473fba97a2cb)({
                onStart: function(event) {
                    console.log('ScissorsTool: Start');
                },
                onEnd: function(event) {
                    console.log('ScissorsTool: End', event.feature);
                },
                onAbort: function(event) {
                    console.log('ScissorsTool: Abort');
                },
                onError: function(event) {
                    console.log('ScissorsTool: Error');
                },
                onSnapped: function(event) {
                    console.log('ScissorsTool: Snapped');
                },
                onUnSnapped: function(event) {
                    console.log('ScissorsTool: UnSnapped');
                }
            }),
            new (0, $8e6511d79a653738$export$decc95b1d1db7cc5)({
                markerLayerVisibleOnLoad: true,
                markerLabelUseEllipsisAfter: 20,
                markerLabelUseUpperCase: false,
                bookmarks: [
                    {
                        id: '6812cc22-f490-46b7-a9f3-42eb9ea58ac2',
                        name: 'Custom Bookmark',
                        zoom: 5,
                        coordinates: [
                            57.123,
                            16.456
                        ]
                    }
                ],
                onInitiated: function() {
                    console.log('BookmarkTool: Initiated');
                },
                onClicked: function() {
                    console.log('BookmarkTool: Clicked');
                },
                onBrowserStateCleared: function() {
                    console.log('BookmarkTool: State cleared');
                },
                onAdded: function(bookmark) {
                    console.log('BookmarkTool: Added', bookmark);
                },
                onRemoved: function(bookmark) {
                    console.log('BookmarkTool: Removed', bookmark);
                },
                onRenamed: function(bookmark) {
                    console.log('BookmarkTool: Renamed', bookmark);
                },
                onZoomedTo: function(bookmark) {
                    console.log('BookmarkTool: Zoomed to', bookmark);
                },
                onCleared: function() {
                    console.log('BookmarkTool: Cleared');
                },
                onDragged: function(item, list) {
                    console.log('BookmarkTool: Dragged', item, list);
                }
            }),
            new (0, $8c356da77b85a9b0$export$5184c141f545a20)({
                onInitiated: function() {
                    console.log('LayerTool: Initiated');
                },
                onClicked: function() {
                    console.log('LayerTool: Clicked');
                },
                onBrowserStateCleared: function() {
                    console.log('LayerTool: State cleared');
                },
                onMapLayerAdded: function(layerWrapper) {
                    console.log('LayerTool: Map layer added', layerWrapper);
                },
                onMapLayerRemoved: function(layerWrapper) {
                    console.log('LayerTool: Map layer removed', layerWrapper);
                },
                onMapLayerRenamed: function(layerWrapper) {
                    console.log('LayerTool: Map layer renamed', layerWrapper);
                },
                onMapLayerVisibilityChanged: function(layerWrapper) {
                    console.log('LayerTool: Map layer visibility change', layerWrapper);
                },
                onMapLayerDragged (item, list) {
                    console.log('LayerTool: Map layer dragged', item, list);
                },
                onFeatureLayerAdded: function(layerWrapper) {
                    console.log('LayerTool: Feature layer added', layerWrapper);
                },
                onFeatureLayerRemoved: function(layerWrapper) {
                    console.log('LayerTool: Feature layer removed', layerWrapper);
                },
                onFeatureLayerRenamed: function(layerWrapper) {
                    console.log('LayerTool: Feature layer renamed', layerWrapper);
                },
                onFeatureLayerVisibilityChanged: function(layerWrapper) {
                    console.log('LayerTool: Feature layer visibility change', layerWrapper);
                },
                onFeatureLayerDownloaded: function(layerWrapper, filename, content) {
                    console.log('LayerTool: Feature layer downloaded', layerWrapper, filename, content);
                },
                onFeatureLayerDragged (item, list) {
                    console.log('LayerTool: Feature layer dragged', item, list);
                }
            }),
            new (0, $fd2b4deaeb353245$export$9228e7c177fdff68)({
                onInitiated: function() {
                    console.log('SplitViewTool: Initiated');
                },
                onClicked: function() {
                    console.log('SplitViewTool: Clicked');
                },
                onBrowserStateCleared: function() {
                    console.log('SplitViewTool: State cleared');
                }
            }),
            new (0, $928bfa8cf54ec183$export$f99b096e17f85829)({
                onInitiated: function() {
                    console.log('OverviewTool: Initiated');
                },
                onClicked: function() {
                    console.log('OverviewTool: Clicked');
                },
                onBrowserStateCleared: function() {
                    console.log('OverviewTool: State cleared');
                }
            }),
            new (0, $c681c904fb3b4803$export$470a47c7d25f2673)({
                color: '#3B4352E6',
                dashed: true,
                width: 2,
                showLabels: true,
                wrapX: true,
                onInitiated: function() {
                    console.log('GraticuleTool: Initiated');
                },
                onClicked: function() {
                    console.log('GraticuleTool: Clicked');
                },
                onBrowserStateCleared: function() {
                    console.log('GraticuleTool: State cleared');
                }
            }),
            new (0, $4c53a8ab81ec152a$export$ea8566250e234470)({
                onInitiated: function() {
                    console.log('MagnifyTool: Initiated');
                },
                onClicked: function() {
                    console.log('MagnifyTool: Clicked');
                },
                onBrowserStateCleared: function() {
                    console.log('MagnifyTool: State cleared');
                }
            }),
            new (0, $46d01ba1c938131e$export$230d38141a067e83)({
                onInitiated: function() {
                    console.log('ResetNorthTool: Initiated');
                },
                onClicked: function() {
                    console.log('ResetNorthTool: Clicked');
                },
                onReset: function(result) {
                    console.log('ResetNorthTool: North reset', result);
                }
            }),
            new (0, $2191e019b62f26fa$export$2576ed38d7a1302e)({
                onInitiated: function() {
                    console.log('CoordinatesTool: Initiated');
                },
                onClicked: function() {
                    console.log('CoordinatesTool: Clicked');
                },
                onBrowserStateCleared: function() {
                    console.log('CoordinatesTool: State cleared');
                },
                onMapClicked: function(coordinates) {
                    console.log('CoordinatesTool: Map clicked at', coordinates);
                }
            }),
            new (0, $7dd4fce02670c9f4$export$4904c93a070eae15)({
                enableHighAccuracy: true,
                timeout: 10000,
                description: 'This is the location that the browser was able to find. It might not be your actual location.',
                markerLabelUseEllipsisAfter: 20,
                markerLabelUseUpperCase: false,
                onInitiated: function() {
                    console.log('MyLocationTool: Initiated');
                },
                onClicked: function() {
                    console.log('MyLocationTool: Clicked');
                },
                onLocationFound: function(location) {
                    console.log('MyLocationTool: Location found', location);
                },
                onError: function(error) {
                    console.log('MyLocationTool: Error', error);
                }
            }),
            new (0, $c7e42ac37e45f65c$export$9854746561ce0e81)({
                onInitiated: function() {
                    console.log('ImportVectorLayerTool: Initiated');
                },
                onClicked: function() {
                    console.log('ImportVectorLayerTool: Clicked');
                },
                onImported: function(features) {
                    console.log('ImportVectorLayerTool: Imported', features);
                },
                onError: function(filename, error) {
                    console.log('ImportVectorLayerTool: Error', filename, error);
                }
            }),
            new (0, $947f84f7bf1b0e06$export$8df575533410ebb8)({
                units: 'metric',
                onInitiated: function() {
                    console.log('ScaleLineTool: Initiated');
                },
                onClicked: function() {
                    console.log('ScaleLineTool: Clicked');
                },
                onBrowserStateCleared: function() {
                    console.log('ScaleLineTool: State cleared');
                }
            }),
            new (0, $6641dd59bdf059c4$export$fbf3f3c99f167d31)({
                onInitiated: function() {
                    console.log('RefreshTool: Initiated');
                },
                onClicked: function() {
                    console.log('RefreshTool: Clicked');
                }
            }),
            new (0, $d9f58fc8021bc237$export$9825cbaf8781ca03)({
                onInitiated: function() {
                    console.log('ThemeTool: Initiated');
                },
                onClicked: function() {
                    console.log('ThemeTool: Clicked');
                },
                onBrowserStateCleared: function() {
                    console.log('ThemeTool: State cleared');
                },
                onChanged: function(theme) {
                    console.log('ThemeTool: Changed to', theme);
                }
            }),
            new (0, $4d95197552cbc5f9$export$609ef3da15019a40)({
                onInitiated: function() {
                    console.log('DirectionTool: Initiated');
                },
                onClicked: function() {
                    console.log('DirectionTool: Clicked');
                },
                onBrowserStateCleared: function() {
                    console.log('DirectionTool: State cleared');
                },
                onChanged: function(direction) {
                    console.log('DirectionTool: Changed to', direction);
                }
            }),
            new (0, $16d88fca5cfe660f$export$1a5db0ee78d96ac4)({
                onInitiated: function() {
                    console.log('ToolboxTool: Initiated');
                },
                onClicked: function() {
                    console.log('ToolboxTool: Clicked');
                },
                onBrowserStateCleared: function() {
                    console.log('ToolboxTool: State cleared');
                },
                onChanged: function(state) {
                    console.log('ToolboxTool: Changed to', state);
                }
            }),
            new (0, $82e635ddc0e2b45d$export$1135e9e24c4d5ed9)({
                title: 'Hey!',
                content: '<p>This is a <strong>modal window</strong>, here you can place some text about your application or links to external resources.</p>',
                onInitiated: function() {
                    console.log('InfoTool: Initiated');
                },
                onClicked: function() {
                    console.log('InfoTool: Clicked');
                }
            }),
            new (0, $7e9db0c7a37b0431$export$1ba0bc57075465bf)({
                url: 'https://github.com/qulle/oltb',
                target: '_blank',
                onInitiated: function() {
                    console.log('HelpTool: Initiated');
                },
                onClicked: function() {
                    console.log('HelpTool: Clicked');
                }
            }),
            new (0, $0fafd5258faf4813$export$c4a0621dfea561e1)({
                onInitiated: function() {
                    console.log('SettingsTool: Initiated');
                },
                onClicked: function() {
                    console.log('SettingsTool: Clicked');
                },
                onBrowserStateCleared: function() {
                    console.log('SettingsTool: State cleared');
                }
            }),
            new (0, $f485bed103ff05f7$export$b1c96e73ae2e8b82)({
                onInitiated: function() {
                    console.log('TranslationTool: Initiated');
                },
                onClicked: function() {
                    console.log('TranslationTool: Clicked');
                }
            }),
            new (0, $325075bf9e711270$export$3bfb3488296c969e)({
                onlyWhenGetParameter: false,
                onInitiated: function() {
                    console.log('DebugInfoTool: Initiated');
                },
                onClicked: function() {
                    console.log('DebugInfoTool: Clicked');
                }
            }),
            new (0, $69f2a1d756f96602$export$c24ab6799594c540)(),
            new (0, $062067ac9882af21$export$b6aef0d24cd6ce8c)()
        ]),
        target: (0, $8f42450ebdd44f5e$export$8e7188a60a5bbe16).getMapElement(),
        view: new (0, $70364d0195659942$export$2e2bcd8739ae039)({
            projection: (0, $9c4744460e43e41b$export$3988ae62b71be9a3)(defaultProjection),
            center: (0, $9c4744460e43e41b$export$b15d9668511529b9)([
                Number(localStorage.lon),
                Number(localStorage.lat)
            ], defaultProjection),
            zoom: localStorage.zoom,
            rotation: localStorage.rotation
        })
    });
    (0, $67f02e726366aa31$export$34222ee0ce4be4c7).setMap(map);
    (0, $67f02e726366aa31$export$34222ee0ce4be4c7).ready();
};


//# sourceMappingURL=dev.0ece6a59.js.map
